webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var _campaignStatusDispla, _postStatusDisplayExt, _postStatusDisplayInt, _create, _update, _delete, _view, _assignClient, _confirmUser, _userRolesDetails;

var FACEBOOK_APP_ID = 981252249000009 || 585647078748086;

var PERMISSION_SCOPE = __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).PERMISSION_SCOPE || 'public_profile,email,instagram_basic,pages_show_list,instagram_manage_insights,pages_read_engagement';
var INSTAGRAM_AUTHORIZE_URL = "https://app.getkobe.com/api/v1/instagrams/authorize" || 'http://localhost:8081/api/v1/instagrams/authorize';
var INSTAGRAM_BASIC_AUTHORIZE_URL = __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).INSTAGRAM_BASIC_AUTHORIZE_URL || 'http://localhost:8081/api/v1/instagrams/authorize';
var INSTAGRAM_APP_AUTHORIZE_URL = __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).INSTAGRAM_APP_AUTHORIZE_URL || 'https://api.instagram.com/oauth/authorize';
var INSTAGRAM_LOGIN_REDIRECT_URL = __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).INSTAGRAM_LOGIN_REDIRECT_URL || 'https://app.getkobe.com/instagrams/handleAuth';
var INSTAGRAM_CLIENT_ID = __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).INSTAGRAM_CLIENT_ID || 498096319805223;
var kobeLogoDataURL = __webpack_require__(103).logo;
var SUBMIT_CONTENT_GUIDE_EMAIL_TEMPLATE_ID = 'd-049ee2e8a44c417c8c1e04ea46416a88';
var CLIENT_FEEDBACK_FORM_URL = '/client/feedback-form';
var BRAND_SHEET_FORM_URL = '/client/brand-fact-sheet';
var RATE_CARD_FORM_URL = '/influencers/rate-card-form';
var JOIN_COMMUNITY_FORM_URL = '/influencers/join-community-form';
var PROFILE_TALLY_FORM_URL = '/creators/travel';
var SIGNING_IN_FORM_URL = '/influencers/signing-form';
var CREATER_CONCEPT_FORM_URL = '/creator/concept-form';
var gDriveConfig = {
  DEVELOPER_KEY: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).GDRIVE_DEVELOPER_KEY || 'AIzaSyBd1jDuvZ-ZvdxhuJ2VUMFPDmxfCAkhdhs',
  CLIENT_ID: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).GDRIVE_CLIENT_ID || '360808666245-rjo80hp2og0r2ev32mhjgb2ltd2uomff.apps.googleusercontent.com',
  SCOPE: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).GDRIVE_SCOPE || 'https://www.googleapis.com/auth/drive.readonly'
};
var cldConfig = {
  CLOUD_NAME: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).CLOUDINARY_SERVICE_CLOUD || 'kobeglobal',
  UPLOAD_PRESET: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).UPLOAD_PRESET || 'ml_default',
  API_KEY: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).API_KEY || '382334513349313'
};
var sendGridTemplateIds = {
  co_reject_influencer_for_campaign: 'd-a6a4eeae7e48417a920949fcdb36befe',
  co_approve_influencer_for_campaign: 'd-8be341275fe746e599e6bffb89ffe4ee'
};
var gSigninConfig = {
  CLIENT_ID: __webpack_require__.i({"NODE_ENV":"production","SERVER_HOSTNAME":"app.getkobe.com","SERVER_PORT":"443","FACEBOOK_APP_ID":981252249000009,"INSTAGRAM_AUTHORIZE_URL":"https://app.getkobe.com/api/v1/instagrams/authorize"}).GDRIVE_CLIENT_ID || '360808666245-rjo80hp2og0r2ev32mhjgb2ltd2uomff.apps.googleusercontent.com'
};
var userRoles = {
  SUPER_ADMIN_HIGH: 0,
  SUPER_ADMIN_LOW: 1,
  COMPANY_ADMIN_HIGH: 2,
  COMPANY_ADMIN_LOW: 3,
  AD_STRATEGIST: 4,
  INFLUENCER: 5,
  CLIENT: 6,
  FINANCE: 7,
  ACCOUNT_MANAGER: 8,
  MARKETING: 9
};

var regexPattern = {
  email: /^([\w\D.-]+@([\w\D-]+)\.+\w{1,}$)/,
  password: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,}$/,
  lowers: /(.*[a-z].*)/,
  uppers: /(.*[A-Z].*)/,
  numbers: /(.*[0-9].*)/,
  symbols: /(?=.*[^\w\d\s:])/,
  instagram: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/p\/([A-Za-z0-9-_]+)/g,
  instagram_reel: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/reel\/([A-Za-z0-9-_]+)/g,
  instagram_post: /\/p\/([^\/]+)[\/|?]/,
  TIKTOK_POST: /\/video\/([^\/]+[0-9])/,
  YOUTUBE_POST: /v=([^&#]{5,})/,
  instagram_profile: /(?:https?:\/\/)?(?:www\.)?instagram\.com\/([a-zA-Z0-9_]+)/,
  tiktok_profile: /@[\w]+/,
  instagram_tv: /\/tv\/([^\/]+)[\/|?]/,
  search_value: /{{2}[a-zA-Z0-9\s_]+}{2}/g,
  date_format: /^\d{2}\/\d{2}\/\d{4}$/
};

var campaignStatus = {
  DRAFT: 0,
  PENDING_CLIENT_APPROVAL: 1,
  PAIRING_BRIEF: 2,
  PAIRING_INFLUENCER: 3,
  RATE_CARD: 4,
  ONGOING: 5,
  REVIEW: 7,
  COMPLETE: 6
};

var pairingStatus = {
  NEW: 0,
  ELIMINATION_PENDING: 1,
  APPROVED: 2,
  INVITED: 3,
  INTERESTED: 4,
  NOT_INTERESTED: 5,
  ACCEPTED: 6,
  NOT_ACCEPTED: 7,
  INQUIRY: 8
};

var freeAccessRoutes = ['Login', 'ClientLogin', 'InstagramLogin', 'ForgotPassword', 'ResetPassword', 'PrivateRegister', 'Reports'];

var postStatus = {
  AD_STRATEGIST_PENDING: 0,
  CLIENT_PENDING: 1,
  APPROVE: 2,
  LIVE: 3,
  COMPLETE: 4,
  ARCHIVE: 5
};

var accountDeleteStatus = {
  PENDING: 0,
  DELETED: 1
};

var dashboardTypes = {
  activation: 1,
  brief: 2,
  pairing: 3,
  drafts: 4,
  reporting: 5
};

var campaignStatusDisplay = (_campaignStatusDispla = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.DRAFT, {
  display: 'Draft',
  url: 'draft',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.PENDING_CLIENT_APPROVAL, {
  display: 'Pending approval',
  url: 'pending_approval',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.PAIRING_BRIEF, {
  display: 'Pairing Brief',
  url: 'pairing_brief',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.PAIRING_INFLUENCER, {
  display: 'Pairing influencer',
  url: 'pairing_influencer',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.RATE_CARD, {
  display: 'Rate Card',
  url: 'rate_card',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.ONGOING, {
  display: 'On-going',
  url: 'on_going',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.REVIEW, {
  display: 'Review',
  url: 'review',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.COMPLETE, {
  display: 'Completed',
  url: 'completed',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), _campaignStatusDispla);

var postStatusDisplayExternal = (_postStatusDisplayExt = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayExt, postStatus.AD_STRATEGIST_PENDING, {
  display: 'Submitted Posts',
  url: 'pending-kobe',
  permissions: [userRoles.INFLUENCER]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayExt, postStatus.CLIENT_PENDING, {
  display: 'Pending Posts',
  url: 'pending-client',
  permissions: [userRoles.INFLUENCER]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayExt, postStatus.APPROVE, {
  display: 'Approved Posts',
  url: 'approved',
  permissions: [userRoles.INFLUENCER]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayExt, postStatus.LIVE, {
  display: 'Published Posts',
  url: 'published',
  permissions: [userRoles.INFLUENCER]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayExt, postStatus.COMPLETE, {
  display: 'Completed Posts',
  url: 'completed',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayExt, postStatus.ARCHIVE, {
  display: 'Archived Posts',
  url: 'internal/archive',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
}), _postStatusDisplayExt);
var postStatusDisplayInternal = (_postStatusDisplayInt = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayInt, postStatus.AD_STRATEGIST_PENDING, {
  display: 'Submitted Posts',
  url: 'internal/pending-kobe',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayInt, postStatus.CLIENT_PENDING, {
  display: 'Pending Posts',
  url: 'internal/pending-client',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayInt, postStatus.APPROVE, {
  display: 'Approved Posts',
  url: 'internal/approved',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayInt, postStatus.LIVE, {
  display: 'Published Posts',
  url: 'internal/published',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayInt, postStatus.COMPLETE, {
  display: 'Completed Posts',
  url: 'internal/completed',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayInt, postStatus.ARCHIVE, {
  display: 'Archived Posts',
  url: 'internal/archive',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
}), _postStatusDisplayInt);

var userGenders = {
  MALE: 0,
  FEMALE: 1,
  NON_BINARY: 2
};

var userGenderDisplay = [{
  value: userGenders.MALE,
  text: 'Male'
}, {
  value: userGenders.FEMALE,
  text: 'Female'
}, {
  value: userGenders.NON_BINARY,
  text: 'Genderqueer/Non-Binary'
}];

var singleNavMenu = [{
  name: 'Dashboard',
  link: '/',
  icon: 'mdi-view-dashboard',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.CLIENT, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
}, {
  name: 'CC Dashboard',
  link: '/co/dashboard',
  icon: 'mdi-chart-tree',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH]
}, {
  name: 'AM Dashboard',
  link: '/am/dashboard',
  icon: 'mdi-chart-timeline',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH]
}, {
  name: 'Users',
  link: '/users',
  icon: 'mdi-account-group',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
}, {
  name: 'All companies',
  link: '/companies',
  icon: 'mdi-office-building',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW]
}, {
  name: 'Reports',
  icon: 'mdi-file-document',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
  subMenus: [{
    name: 'All Campaigns Report',
    link: '/campaigns/all',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'All Posts',
    link: '/posts/internal/all-posts',
    icon: 'mdi-file-chart',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'AOK Report',
    link: '/aok-report',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Status Report',
    link: '/posts/co-creating/status-report',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Draft Submissions Report',
    link: '/posts/draft-submissions-report',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Campaign COGS',
    link: '/campaigns/campaign-cogs',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Campaign Timeline Summary',
    link: '/campaigns/timeline/summary',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Stats Analysis',
    link: '/campaigns/statistics/analysis',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }]
}, {
  name: 'Search',
  icon: 'mdi-account-search',
  permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
  subMenus: [{
    name: 'Creators Search',
    link: '/creators/search',
    icon: 'mdi-account-search',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Creator Discovery',
    link: '/influencers/discovery',
    icon: 'mdi-account-search',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Content Search',
    link: '/content/search',
    icon: 'mdi-account-search',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'All Influencers',
    link: '/all-influencers',
    icon: 'mdi-account-group-outline',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.MARKETING]
  }, {
    name: 'Social Data',
    link: '/influencers/social-data',
    icon: 'mdi-at',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }]
}, {
  name: 'Profile',
  link: '/profile',
  icon: 'fa-user',
  permissions: [userRoles.INFLUENCER]
}, {
  name: 'Submit Draft Post',
  link: '/v2/submit-draft-post',
  icon: 'mdi-tooltip-edit',
  permissions: [userRoles.INFLUENCER]
}, {
  name: 'Submit Payout',
  link: '/submit-post-payout-creator',
  icon: 'mdi-account-cash',
  permissions: [userRoles.INFLUENCER]
}, {
  name: 'Content Storyboard',
  link: '/content-storyboard-list',
  icon: 'mdi-tooltip-edit',
  permissions: [userRoles.INFLUENCER]
}, {
  name: 'Campaigns',
  link: '/clients/campaigns',
  icon: 'mdi-account-group',
  permissions: [userRoles.CLIENT]
}, {
  name: 'Content Storyboard',
  link: '/content-storyboard',
  icon: 'mdi-file-document',
  permissions: [userRoles.CLIENT]
}, {
  name: 'Posts',
  link: '/clients/posts',
  icon: 'mdi-file-document',
  permissions: [userRoles.CLIENT]
}, {
  name: 'Campaign Reports',
  link: '/clients/campaigns-reports',
  icon: 'mdi-file-chart-outline',
  permissions: [userRoles.CLIENT]
}];

var groupNavMenu = [{
  name: 'Activating',
  icon: 'mdi-routes',
  subMenus: [{
    name: 'Clients',
    link: '/clients',
    icon: 'mdi-domain',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Draft Campaigns',
    link: '/campaigns/' + campaignStatusDisplay[campaignStatus.DRAFT]['url'],
    icon: 'mdi-file-document-edit',
    permissions: campaignStatusDisplay[campaignStatus.DRAFT]['permissions']
  }, {
    name: 'Pending Campaigns',
    link: '/campaigns/' + campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['url'],
    icon: 'mdi-file-clock',
    permissions: campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['permissions']
  }, {
    name: 'Brand Fact Sheet',
    link: '/client/brand-fact-sheet',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
  }, {
    name: 'Campaign Timeline',
    link: '/campaigns/timeline',
    icon: 'mdi-chart-timeline',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
  }]
}, {
  name: 'Pairing',
  icon: 'mdi-account-multiple-check',
  subMenus: [{
    name: 'Pairing Campaigns',
    link: '/campaigns/' + campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['url'],
    icon: 'mdi-account-switch',
    permissions: campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['permissions']
  }, {
    name: 'Invoices & Brief Confirmation',
    link: '/influencers/invoices-brief-confirmation',
    icon: 'mdi-account-multiple-check',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.FINANCE, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
  }, {
    name: 'Content Storyboard',
    link: '/content-storyboard',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.CLIENT]
  }, {
    name: 'IMS Influencers',
    link: '/influencers',
    icon: 'mdi-account-multiple',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Invite to IMS',
    link: '/users/create-link',
    icon: 'mdi-account-plus',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Ratecard Forms',
    link: '/influencers/rate-cards',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.MARKETING]
  }, {
    name: 'Creator Community Forms',
    link: '/influencers/join-community',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.MARKETING]
  }]
}, {
  name: 'Co-Creating',
  icon: 'mdi-sync',
  subMenus: [{
    name: 'Ongoing Campaigns',
    link: '/campaigns/' + campaignStatusDisplay[campaignStatus.ONGOING]['url'],
    icon: 'mdi-file-check',
    permissions: campaignStatusDisplay[campaignStatus.ONGOING]['permissions']
  }, {
    name: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['display'],
    link: '/posts/' + postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['url'],
    icon: 'mdi-file-clock-outline',
    permissions: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
  }, {
    name: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['display'],
    link: '/posts/' + postStatusDisplayInternal[postStatus.CLIENT_PENDING]['url'],
    icon: 'mdi-file-sync',
    permissions: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['permissions']
  }, {
    name: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['display'],
    link: '/posts/' + postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['url'],
    icon: 'mdi-file-clock-outline',
    permissions: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
  }, {
    name: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['display'],
    link: '/posts/' + postStatusDisplayExternal[postStatus.CLIENT_PENDING]['url'],
    icon: 'mdi-file-sync',
    permissions: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['permissions']
  }]
}, {
  name: 'Review',
  icon: 'mdi-eye-check-outline',
  subMenus: [{
    name: 'Review Campaigns',
    link: '/campaigns/' + campaignStatusDisplay[campaignStatus.REVIEW]['url'],
    icon: 'mdi-file-check',
    permissions: campaignStatusDisplay[campaignStatus.REVIEW]['permissions']
  }, {
    name: 'Creator Stats & Rating',
    link: '/campaignPayoutsInternal',
    icon: 'mdi-account-cash',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Campaign Reports Internal',
    link: '/campaign-report-internal',
    icon: 'mdi-file-chart',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Upcoming Review Meetings',
    link: '/campaigns/upcoming-review-meetings',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Stats Collection Calendar',
    link: '/stats-collection-calendar',
    icon: 'mdi-calendar-check',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.CLIENT, userRoles.FINANCE]
  }]
}, {
  name: 'Complete',
  icon: 'mdi-check',
  subMenus: [{
    name: postStatusDisplayExternal[postStatus.APPROVE]['display'],
    link: '/posts/' + postStatusDisplayExternal[postStatus.APPROVE]['url'],
    icon: 'mdi-file-document-box-check',
    permissions: postStatusDisplayExternal[postStatus.APPROVE]['permissions']
  }, {
    name: postStatusDisplayInternal[postStatus.APPROVE]['display'],
    link: '/posts/' + postStatusDisplayInternal[postStatus.APPROVE]['url'],
    icon: 'mdi-file-document-box-check',
    permissions: postStatusDisplayInternal[postStatus.APPROVE]['permissions']
  }, {
    name: postStatusDisplayInternal[postStatus.LIVE]['display'],
    link: '/posts/' + postStatusDisplayInternal[postStatus.LIVE]['url'],
    icon: 'mdi-file-link',
    permissions: postStatusDisplayInternal[postStatus.LIVE]['permissions']
  }, {
    name: postStatusDisplayExternal[postStatus.LIVE]['display'],
    link: '/posts/' + postStatusDisplayExternal[postStatus.LIVE]['url'],
    icon: 'mdi-file-link',
    permissions: postStatusDisplayExternal[postStatus.LIVE]['permissions']
  }, {
    name: 'Campaign Reports',
    link: '/campaigns/reports',
    icon: 'mdi-file-chart-outline',
    permissions: [userRoles.CLIENT]
  }, {
    name: 'Client Feedbacks',
    link: '/client/feedback-form',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
  }, {
    name: postStatusDisplayInternal[postStatus.COMPLETE]['display'],
    link: '/posts/' + postStatusDisplayInternal[postStatus.COMPLETE]['url'],
    icon: 'mdi-zip-box',
    permissions: postStatusDisplayInternal[postStatus.COMPLETE]['permissions']
  }, {
    name: 'Finished Campaigns',
    link: '/campaigns/' + campaignStatusDisplay[campaignStatus.COMPLETE]['url'],
    icon: 'mdi-zip-box-outline',
    permissions: campaignStatusDisplay[campaignStatus.COMPLETE]['permissions']
  }]
}, {
  name: 'Financial',
  icon: 'mdi-finance',
  subMenus: [{
    name: 'Payment Consolidation',
    link: '/finance/payment-consolidation',
    icon: 'mdi-cash-usd',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Payment Status',
    link: '/finance/payment-consolidation/status',
    icon: 'mdi-cash-usd',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'COGS Estimation',
    link: '/finance/cogs-estimation',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
  }, {
    name: 'Profit Summary',
    link: '/finance/profit-summary',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE]
  }, {
    name: 'Masterlist',
    link: '/finance/masterlist',
    icon: 'mdi-file-document',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }]
}, {
  name: 'Services',
  icon: 'mdi-hammer-screwdriver',
  subMenus: [{
    name: 'Content Analysis',
    link: '/content-analysis',
    icon: 'mdi-layers-search',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Influencer Lists',
    link: '/services/influencer-lists',
    icon: 'mdi-cloud-search',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }]
}, {
  name: 'Archived',
  icon: 'mdi-archive',
  subMenus: [{
    name: 'Archived Campaigns',
    link: '/campaigns/archive',
    icon: 'mdi-archive',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: postStatusDisplayInternal[postStatus.ARCHIVE]['display'],
    link: '/posts/' + postStatusDisplayInternal[postStatus.ARCHIVE]['url'],
    icon: 'mdi-archive',
    permissions: postStatusDisplayInternal[postStatus.ARCHIVE]['permissions']
  }, {
    name: 'Archived Payment Cons..',
    link: '/finance/payment-consolidation/archive',
    icon: 'mdi-archive',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }, {
    name: 'Archived Client Feedback..',
    link: '/client/feedback-form/archive/lists',
    icon: 'mdi-archive',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  }]
}];

var userPermissions = {
  user: {
    create: (_create = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.SUPER_ADMIN_HIGH, [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.SUPER_ADMIN_LOW, [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.COMPANY_ADMIN_HIGH, [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.COMPANY_ADMIN_LOW, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.ACCOUNT_MANAGER, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.AD_STRATEGIST, [userRoles.AD_STRATEGIST, userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_create, userRoles.FINANCE, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), _create),
    update: (_update = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_update, userRoles.SUPER_ADMIN_HIGH, [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_update, userRoles.SUPER_ADMIN_LOW, [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_update, userRoles.COMPANY_ADMIN_HIGH, [userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_update, userRoles.COMPANY_ADMIN_LOW, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_update, userRoles.ACCOUNT_MANAGER, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_update, userRoles.FINANCE, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), _update),
    delete: (_delete = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_delete, userRoles.SUPER_ADMIN_HIGH, [userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_delete, userRoles.SUPER_ADMIN_LOW, [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_delete, userRoles.COMPANY_ADMIN_HIGH, [userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_delete, userRoles.COMPANY_ADMIN_LOW, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_delete, userRoles.ACCOUNT_MANAGER, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_delete, userRoles.FINANCE, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), _delete),
    view: (_view = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_view, userRoles.SUPER_ADMIN_HIGH, [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_view, userRoles.SUPER_ADMIN_LOW, [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE, userRoles.MARKETING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_view, userRoles.COMPANY_ADMIN_HIGH, [userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_view, userRoles.COMPANY_ADMIN_LOW, [userRoles.AD_STRATEGIST, userRoles.FINANCE]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_view, userRoles.ACCOUNT_MANAGER, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_view, userRoles.FINANCE, [userRoles.FINANCE, userRoles.CLIENT, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.COMPANY_ADMIN_LOW]), _view),
    assignClient: (_assignClient = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_assignClient, userRoles.SUPER_ADMIN_HIGH, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_assignClient, userRoles.SUPER_ADMIN_LOW, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_assignClient, userRoles.COMPANY_ADMIN_HIGH, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_assignClient, userRoles.COMPANY_ADMIN_LOW, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_assignClient, userRoles.FINANCE, [userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_assignClient, userRoles.ACCOUNT_MANAGER, [userRoles.AD_STRATEGIST]), _assignClient),
    confirmUser: (_confirmUser = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_confirmUser, userRoles.SUPER_ADMIN_HIGH, [userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_confirmUser, userRoles.SUPER_ADMIN_LOW, [userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_confirmUser, userRoles.ACCOUNT_MANAGER, [userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_confirmUser, userRoles.FINANCE, [userRoles.INFLUENCER]), _confirmUser)
  },
  client: {
    create: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    view: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    edit: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    delete: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW],
    updateUser: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
  },
  influencer: {
    create: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER],
    view: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    edit: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW],
    delete: [],
    assignCompany: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW]
  },
  campaign: {
    create: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    view: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER, userRoles.FINANCE],
    viewByClient: [userRoles.CLIENT],
    edit: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    settings: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    activate: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH],
      campaignStatus: [campaignStatus.PENDING_CLIENT_APPROVAL, campaignStatus.PAIRING_INFLUENCER, campaignStatus.COMPLETE]
    },
    directClient: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH],
      campaignStatus: [campaignStatus.DRAFT]
    },
    delete: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      campaignStatus: [campaignStatus.DRAFT]
    },
    draftSubmit: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      campaignStatus: [campaignStatus.DRAFT]
    },
    pairingBrief: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH],
      campaignStatus: [campaignStatus.PAIRING_BRIEF]
    },
    releaseToAdmin: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST],
      campaignStatus: [campaignStatus.PENDING_CLIENT_APPROVAL]
    },
    clientApprove: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.CLIENT],
      campaignStatus: [campaignStatus.PENDING_CLIENT_APPROVAL]
    },
    startCampaign: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    reviewCampaign: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      campaignStatus: [campaignStatus.ONGOING]
    },
    closeCampaign: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      campaignStatus: [campaignStatus.REVIEW]
    },
    viewBrandFactSheet: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      campaignStatus: [campaignStatus.DRAFT]
    },
    viewPayout: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    },
    viewPairing: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER, campaignStatus.ONGOING, campaignStatus.REVIEW, campaignStatus.PENDING_CLIENT_APPROVAL]
    },
    eliminating: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.CLIENT],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    influencerAccept: {
      userRoles: [userRoles.INFLUENCER],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    influencerReject: {
      userRoles: [userRoles.INFLUENCER],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER]
    },
    viewPost: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH],
      campaignStatus: [campaignStatus.PAIRING_INFLUENCER, campaignStatus.ONGOING]
    },
    viewInfluencers: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.CLIENT, userRoles.FINANCE],
      campaignStatus: [campaignStatus.ONGOING, campaignStatus.COMPLETE]
    },
    clientFeedback: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE],
    editPayout: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
  },
  post: {
    create: [userRoles.INFLUENCER],
    view: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.CLIENT, userRoles.INFLUENCER, userRoles.FINANCE],
    edit: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.INFLUENCER],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING, postStatus.APPROVE]
    },
    editLiveDate: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING, postStatus.APPROVE]
    },
    delete: [],
    assignCampaign: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    mapInfluencer: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING]
    },
    csApprove: {
      userRoles: [userRoles.AD_STRATEGIST],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    saleApprove: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    directRelease: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST],
      postStatus: [postStatus.AD_STRATEGIST_PENDING]
    },
    clientReview: {
      userRoles: [userRoles.CLIENT],
      postStatus: [postStatus.CLIENT_PENDING]
    },
    clientApproveDate: {
      userRoles: [userRoles.CLIENT],
      postStatus: [postStatus.APPROVE]
    },
    submitPostPayout: {
      userRoles: [userRoles.INFLUENCER],
      postStatus: [postStatus.APPROVE, postStatus.LIVE]
    },
    enterPostURL: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      postStatus: [postStatus.APPROVE]
    },
    markAsMetadataTagged: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW],
      postStatus: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING, postStatus.APPROVE, postStatus.LIVE]
    },
    markAsComplete: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
      postStatus: [postStatus.LIVE]
    },
    markAsAbuseResolved: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST],
      postStatus: [postStatus.CLIENT_PENDING]
    },
    releaseAbuseResolved: {
      userRoles: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER],
      postStatus: [postStatus.CLIENT_PENDING]
    },
    changePostStatus: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.FINANCE],
    influencerResubmit: [userRoles.INFLUENCER],
    clientApprove: [userRoles.CLIENT, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER],
    influencerLive: [userRoles.INFLUENCER]
  },
  dashboard: {
    servicesHealth: [userRoles.SUPER_ADMIN_HIGH],
    xero: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    kobeOverview: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    postsSummary: [userRoles.INFLUENCER],
    campaignSummary: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE],
    influencerTasks: [userRoles.INFLUENCER],
    csTasks: [userRoles.AD_STRATEGIST],
    saleTasks: [userRoles.COMPANY_ADMIN_LOW],
    clientTasks: [userRoles.CLIENT],
    audienceInsightPreview: [userRoles.INFLUENCER]
  },
  financial: {
    create: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    import: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    actions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE]
  }
};

var userRolesDetails = (_userRolesDetails = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.SUPER_ADMIN_HIGH, {
  display: 'Super Admin',
  url: 'super_admins',
  icon: 'user-secret'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.SUPER_ADMIN_LOW, {
  display: 'Admin',
  url: 'admins',
  icon: 'user-secret'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.COMPANY_ADMIN_HIGH, {
  display: 'Account Admin',
  url: 'company_super_admins',
  icon: 'user-md'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.COMPANY_ADMIN_LOW, {
  display: 'Sales',
  url: 'sales',
  icon: 'user-md'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.AD_STRATEGIST, {
  display: 'Content Curator (CC)',
  url: 'ad_strategists',
  icon: 'user'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.ACCOUNT_MANAGER, {
  display: 'Account Manager (AM)',
  url: 'account_manager',
  icon: 'user'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.INFLUENCER, {
  display: 'Influencer',
  url: 'influencers',
  icon: 'male'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.CLIENT, {
  display: 'Client',
  url: 'clients',
  icon: 'male'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.FINANCE, {
  display: 'Finance',
  url: 'finances',
  icon: 'female'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_userRolesDetails, userRoles.MARKETING, {
  display: 'Marketing',
  url: 'marketing',
  icon: 'male'
}), _userRolesDetails);

var socialMediaPlatforms = [{
  icon: '/static/img/f_logo_RGB-Blue_72.png',
  label: 'Facebook',
  placeholder: 'https://www.facebook.com/yourAccount',
  value: ''
}, {
  icon: '/static/img/youtube_social_icon_white.png',
  label: 'Youtube',
  placeholder: 'https://www.youtube.com/channel/abcedfghijklmn',
  value: ''
}, {
  icon: '/static/img/tiktok.svg',
  label: 'Tiktok',
  placeholder: 'ID: 1234567890',
  value: ''
}, {
  icon: '/static/img/x-logo.svg',
  label: 'X (Twitter)',
  placeholder: '@yourxhandle',
  value: ''
}, {
  icon: '/static/img/Tumblr_Logos_2018.03.06_Android Icon Blue.png',
  label: 'Tumblr',
  placeholder: 'https://yourAccount.tumblr.com/',
  value: ''
}, {
  icon: '/static/img/www_blog.png',
  label: 'Blog',
  placeholder: 'https://yourWebsite.com/',
  value: ''
}];

var apiServiceBaseURL = {
  campaign: '/api/v1/campaigns',
  pairing: '/api/v1/pairings',
  pairingOpen: '/api/v1/pairings-open',
  payment: '/api/v1/payments',
  post: '/api/v1/posts',
  influencer: '/api/v1/influencers'
};

var currencies = ['SGD', 'USD', 'MYR', 'IDR', 'VND', 'PHP', 'THB', 'AUD', 'NZD', 'JPY'];

var currencySymbols = [{
  'title': 'SGD',
  'symbol': 'S$'
}, {
  'title': 'USD',
  'symbol': 'US$'
}, {
  'title': 'MYR',
  'symbol': 'RM'
}, {
  'title': 'IDR',
  'symbol': 'Rp'
}, {
  'title': 'VND',
  'symbol': '₫'
}, {
  'title': 'PHP',
  'symbol': '₱'
}, {
  'title': 'THB',
  'symbol': '฿'
}, {
  'title': 'AUD',
  'symbol': 'AU$'
}, {
  'title': 'NZD',
  'symbol': 'NZ$'
}, {
  'title': 'JPY',
  'symbol': '¥'
}];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  FACEBOOK_APP_ID: FACEBOOK_APP_ID,
  PERMISSION_SCOPE: PERMISSION_SCOPE,
  INSTAGRAM_AUTHORIZE_URL: INSTAGRAM_AUTHORIZE_URL,
  INSTAGRAM_BASIC_AUTHORIZE_URL: INSTAGRAM_BASIC_AUTHORIZE_URL,
  INSTAGRAM_APP_AUTHORIZE_URL: INSTAGRAM_APP_AUTHORIZE_URL,
  INSTAGRAM_CLIENT_ID: INSTAGRAM_CLIENT_ID,
  INSTAGRAM_LOGIN_REDIRECT_URL: INSTAGRAM_LOGIN_REDIRECT_URL,
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  userRoles: userRoles,
  userRolesDetails: userRolesDetails,
  userPermissions: userPermissions,
  campaignStatus: campaignStatus,
  campaignStatusDisplay: campaignStatusDisplay,
  postStatus: postStatus,
  accountDeleteStatus: accountDeleteStatus,
  postStatusDisplayExternal: postStatusDisplayExternal,
  postStatusDisplayInternal: postStatusDisplayInternal,
  singleNavMenu: singleNavMenu,
  groupNavMenu: groupNavMenu,
  userGenders: userGenders,
  regexPattern: regexPattern,
  userGenderDisplay: userGenderDisplay,
  freeAccessRoutes: freeAccessRoutes,
  socialMediaPlatforms: socialMediaPlatforms,
  kobeLogoDataURL: kobeLogoDataURL,
  pairingStatus: pairingStatus,
  SUBMIT_CONTENT_GUIDE_EMAIL_TEMPLATE_ID: SUBMIT_CONTENT_GUIDE_EMAIL_TEMPLATE_ID,
  CLIENT_FEEDBACK_FORM_URL: CLIENT_FEEDBACK_FORM_URL,
  BRAND_SHEET_FORM_URL: BRAND_SHEET_FORM_URL,
  RATE_CARD_FORM_URL: RATE_CARD_FORM_URL,
  JOIN_COMMUNITY_FORM_URL: JOIN_COMMUNITY_FORM_URL,
  PROFILE_TALLY_FORM_URL: PROFILE_TALLY_FORM_URL,
  SIGNING_IN_FORM_URL: SIGNING_IN_FORM_URL,
  CREATER_CONCEPT_FORM_URL: CREATER_CONCEPT_FORM_URL,
  gDriveConfig: gDriveConfig,
  gSigninConfig: gSigninConfig,
  cldConfig: cldConfig,
  sendGridTemplateIds: sendGridTemplateIds,
  apiServiceBaseURL: apiServiceBaseURL,
  dashboardTypes: dashboardTypes,
  currencies: currencies,
  currencySymbols: currencySymbols
}));

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export groupBySum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);












var moment = __webpack_require__(1);
var XLSX = __webpack_require__(747);

var sheet_to_json = __webpack_require__(747).utils.sheet_to_json;



var groupBySum = function groupBySum(items, groupByProp, sumProp) {
  var groups = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map___default.a();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item[groupByProp] && item[sumProp]) {
        var groupBy = item[groupByProp];
        if (groups.has(groupBy)) {
          var currentValue = groups.get(groupBy);
          groups.set(groupBy, currentValue + item[sumProp]);
        } else {
          groups.set(groupBy, item[sumProp]);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var sums = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(groups), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _sums$push;

      var _ref = _step2.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      sums.push((_sums$push = {}, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default()(_sums$push, groupByProp, key), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default()(_sums$push, sumProp, value), _sums$push));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return sums;
};

var TYPE = {
  OBJECT: 'object',
  PRIMITIVE: 'primitive'
};

var func = {
  removeElementFromArray: function removeElementFromArray(arr, val, type, fieldName) {
    var index = arr.findIndex(function (e) {
      return type === TYPE.OBJECT ? e[fieldName] === val : e === val;
    });
    if (index === -1) {
      return;
    }
    arr.splice(index, 1);
  },
  removePairingElementFromArray: function removePairingElementFromArray(arr, val, type, fieldName, platform) {
    var index = arr.findIndex(function (e) {
      return type === TYPE.OBJECT ? e[fieldName] === val && e.platform === platform : e[fieldName] === val && e.platform === platform;
    });
    if (index === -1) {
      return;
    }
    arr.splice(index, 1);
  },
  pushElementToArray: function pushElementToArray(arr, element, fieldName, type) {
    if (!arr) return false;
    var index = arr.findIndex(function (e) {
      return type === TYPE.OBJECT ? e[fieldName] === element[fieldName] : e === element;
    });
    if (index !== -1) {
      arr[index] = element;
    } else {
      arr.push(element);
    }
  },
  pushPairingElementToArray: function pushPairingElementToArray(arr, element, fieldName, type, platform) {
    if (!arr) return false;
    var index = arr.findIndex(function (e) {
      return type === TYPE.OBJECT ? e[fieldName] === element[fieldName] && e.platform === platform : e === element;
    });
    if (index !== -1) {
      arr[index] = element;
    } else {
      arr.push(element);
    }
  },
  makeid: function makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  dataURLtoFile: function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {
      type: mime
    });
  },
  extractHashTagsFromString: function extractHashTagsFromString(str) {
    var regex = /#[a-z0-9A-Z]+/gm;
    var m = void 0;
    var hashTags = [];
    while ((m = regex.exec(str)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      m.forEach(function (match) {
        hashTags.push(match);
      });
    }
    return hashTags;
  },
  clean: function clean(obj) {
    var returnObj = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()(obj);
    for (var propName in returnObj) {
      if (returnObj[propName] === null || returnObj[propName] === undefined) {
        delete returnObj[propName];
      } else {
        if (returnObj[propName] && returnObj[propName] !== undefined && typeof returnObj[propName] === 'string') returnObj[propName] = returnObj[propName].trim();
      }
    }
    return returnObj;
  },
  getDate: function getDate() {
    var date = new Date();
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  },
  formatNumber: function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  },
  formatCurrency: function formatCurrency(number) {
    if (number !== '' && number !== undefined && number !== 0 && number !== '0' && number !== null) {
      return 'SGD ' + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return number;
    }
  },

  changeDateFormat: function changeDateFormat(date) {
    return moment(date).format('DD-MM-YYYY');
  },
  formatCustomDate: function formatCustomDate(date, format) {
    return moment(date).format(format);
  },
  extractShortCode: function extractShortCode(url) {
    var matches;
    if ((matches = url.match(/\/p\/([^\/]+)[\/|?]/)) !== null) {
      return matches[1];
    };
    return null;
  },
  keyify: function keyify(obj) {
    var _this = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!obj) return [];
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(obj).reduce(function (res, el) {
      if (Array.isArray(obj[el])) {
        return res;
      } else if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj[el]) === 'object' && obj[el] !== null) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(res), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(_this.keyify(obj[el], prefix + el + '.')));
      } else {
        return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(res), [prefix + el]);
      }
    }, []);
  },

  constructImageURL: function constructImageURL(imageName) {
    return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
  },
  constructWebImageURL: function constructWebImageURL(path) {
    var protocol = window.location.protocol;
    var host = window.location.host;
    return protocol + '//' + host + path;
  },
  cutStringAfterLast: function cutStringAfterLast(value, cutter) {
    return value.substring(value.lastIndexOf(cutter) + 1);
  },
  objectToQueryString: function objectToQueryString() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var searchParams = new URLSearchParams(object);
    return searchParams.toString();
  },
  getInstagramAuthURL: function getInstagramAuthURL() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = arguments[1];

    var protocol = window.location.protocol;
    var host = window.location.host;

    var searchParams = new URLSearchParams();
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(query).forEach(function (key) {
      return searchParams.append(key, query[key]);
    });
    return protocol + '//' + host + path + '?' + searchParams.toString();
  },
  getQuarterRange: function getQuarterRange(quarter) {
    switch (quarter) {
      case 1:
        return {
          from: moment().set('month', 0).startOf('month'),
          to: moment().set('month', 2).endOf('month')
        };
      case 2:
        return {
          from: moment().set('month', 3).startOf('month'),
          to: moment().set('month', 5).endOf('month')
        };
      case 3:
        return {
          from: moment().set('month', 6).startOf('month'),
          to: moment().set('month', 8).endOf('month')
        };
      case 4:
        return {
          from: moment().set('month', 9).startOf('month'),
          to: moment().set('month', 11).endOf('month')
        };
    }
  },
  copyToClipboard: function copyToClipboard(elementid) {
    var copyText = document.querySelector(elementid);
    copyText.setAttribute('type', 'text');
    copyText.select();

    try {
      document.execCommand('copy');
      copyText.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();

      return true;
    } catch (err) {
      return false;
    }
  },
  parserToJson: function parserToJson(filePath) {
    var workbook = XLSX.read(filePath, {
      type: 'buffer',
      sheetStubs: true,
      cellDates: true
    });
    var sheetNameList = workbook.SheetNames;
    var json = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_get_iterator___default()(sheetNameList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var y = _step3.value;

        var worksheet = workbook.Sheets[y];
        var data = sheet_to_json(worksheet, { blankrows: false, raw: false });
        json.push(data);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return json;
  },
  numToAlphabet: function numToAlphabet(num) {
    return (num + 9).toString(36).toUpperCase();
  },
  refreshJSON: function refreshJSON(json) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(json || []));
  },
  formatDate: function formatDate(date) {
    if (!date) return null;

    var _date$split = date.split('-'),
        _date$split2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
        year = _date$split2[0],
        month = _date$split2[1],
        day = _date$split2[2];

    var formattedDate = day + '/' + month + '/' + year;
    if (formattedDate.includes('undefined')) {
      return date;
    }
    return formattedDate;
  },
  parseDate: function parseDate(date) {
    if (!date) return null;

    var _date$split3 = date.split('/'),
        _date$split4 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
        day = _date$split4[0],
        month = _date$split4[1],
        year = _date$split4[2];

    return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
  },
  parseMonth: function parseMonth(date) {
    if (!date) return null;

    var _date$split5 = date.split('/'),
        _date$split6 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_slicedToArray___default()(_date$split5, 3),
        day = _date$split6[0],
        month = _date$split6[1],
        year = _date$split6[2];

    return year + '-' + month.padStart(2, '0');
  },
  escapeSpecialChars: function escapeSpecialChars(value) {
    return value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
  },
  escapeCldSpecialChars: function escapeCldSpecialChars(value) {
    return value.replace(/[?&#\/%<>]/gi, '');
  },
  espaceHandleSign: function espaceHandleSign(value) {
    if (!value) return value;
    return value.replace('@', '').toLowerCase();
  },
  espaceHandleSignNoLower: function espaceHandleSignNoLower(value) {
    if (!value) return value;
    return value.replace('@', '');
  },
  regexMatchIg: function regexMatchIg(value, regex) {
    if (!value) return value;
    if (value.match(regex)) {
      var searchTerm = regex.exec(value);
      if (searchTerm.length > 1) {
        return searchTerm[1];
      }
    }
    return value;
  },
  regexMatch: function regexMatch(value, regex) {
    if (!value) return value;
    if (value.match(regex)) {
      var searchTerm = regex.exec(value);
      return searchTerm[0];
    }
    return value;
  },
  extractTikTokHandle: function extractTikTokHandle(value) {
    if (value.includes('@')) {
      value = value.substring(value.indexOf('@') + 1);
    }
    return value;
  },
  toDataURL: function toDataURL(url) {
    return fetch(url).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () {
          return resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    });
  },
  getCredibilityColor: function getCredibilityColor(credibility) {
    if (credibility >= 0 && credibility < 30) {
      return '#f44336';
    } else if (credibility >= 30 && credibility < 50) {
      return '#f9a825';
    } else {
      return '#4caf50';
    }
  },
  weekOfMonth: function weekOfMonth() {
    var d = new Date();
    var date = d.getDate();
    var day = d.getDay();
    var weekNum = Math.ceil((date - 1 - day) / 7);
    return weekNum + 1;
  },
  weekDurations: function weekDurations(startDate) {
    startDate = moment(startDate, 'YYYY-MM');
    var todayDate = moment();
    var diff = todayDate.diff(startDate, 'week');
    return diff;
  },
  monthDurations: function monthDurations(startDate, endDate) {
    if (!startDate || !endDate) return '';
    var formattedStartDate = moment(startDate).format('YYYY-MM');
    var formattedEndDate = moment(endDate).format('YYYY-MM');
    return moment(formattedEndDate).diff(formattedStartDate, 'months', true) + 1;
  },
  dayDurations: function dayDurations(startDate, endDate) {
    if (!startDate || !endDate) return '';
    var formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    var formattedEndDate = moment(endDate).format('YYYY-MM-DD');
    if (formattedStartDate === formattedEndDate) return 1;
    return moment(formattedEndDate).diff(formattedStartDate, 'days', true);
  },
  totalWeeksOfMonth: function totalWeeksOfMonth() {
    return Math.round(moment().daysInMonth() / 7);
  },
  formatMonth: function formatMonth(date) {
    return moment(date).format('MMM YYYY');
  },
  getRandomColor: function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  },
  getFixedClr: function getFixedClr() {
    var fixedDarkColors = ["#1A1A2E", "#162447", "#0F3460", "#53354A", "#BB86FC", "#1F1F2E", "#5a5757", "#4B0082", "#2B2D42", "#D9BF77"];
    for (var i = fixedDarkColors.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref3 = [fixedDarkColors[j], fixedDarkColors[i]];
      fixedDarkColors[i] = _ref3[0];
      fixedDarkColors[j] = _ref3[1];
    }
    return fixedDarkColors[0];
  },
  downloadFile: function downloadFile(name, url) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                fetch(url).then(function (resp) {
                  return resp.blob();
                }).then(function (blob) {
                  var url = window.URL.createObjectURL(blob);
                  var a = document.createElement('a');
                  a.style.display = 'none';
                  a.href = url;

                  a.download = name;
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(url);
                  resolve(true);
                }).catch(function () {
                  return reject('file download error!');
                });
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  downloadURI: function downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  checkURLExist: function checkURLExist(URL) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                fetch(URL).then(function (resp) {
                  resolve(resp.status === 200 || false);
                }).catch(function () {
                  return resolve(false);
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  escapeFirstChar: function escapeFirstChar(str, char) {
    if (!str || typeof str !== 'string') return str;
    if (str.charAt(0) === char) {
      return str.substring(1);
    }
    return str;
  },
  isDateFormatValid: function isDateFormatValid(givenDate) {
    var regex = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].regexPattern.date_format;
    if (givenDate.match(regex)) return true;
    return false;
  },
  getDaysDiff: function getDaysDiff(dateVal) {
    if (!dateVal || !__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.isDateFormatValid(dateVal)) return '';
    var dayDurations = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.dayDurations(moment(), __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.parseDate(dateVal));
    return dayDurations > 0 ? '+' + dayDurations : dayDurations;
  },
  getLatestDate: function getLatestDate(firstDate, lastDate, format) {
    if (!firstDate && !lastDate) {
      return '';
    } else if (firstDate && !lastDate) {
      return moment(firstDate).format(format);
    } else if (lastDate && !firstDate) {
      return moment(lastDate).format(format);
    }
    firstDate = moment(firstDate).format('YYYY-MM-DD');
    lastDate = moment(lastDate).format('YYYY-MM-DD');
    return firstDate > lastDate ? moment(firstDate).format(format) : moment(lastDate).format(format);
  },
  reduceDays: function reduceDays(dateVal, reduceCount, format) {
    if (!dateVal) return '';
    return moment(dateVal).subtract(reduceCount, 'day').format(format);
  },
  addDays: function addDays(dateVal, reduceCount, format) {
    if (!dateVal) return '';
    return moment(dateVal).add(reduceCount, 'day').format(format);
  },
  getMonthNo: function getMonthNo(month) {
    var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var matchMonthIdx = shortMonths.indexOf(month);
    if (matchMonthIdx !== -1) {
      if (matchMonthIdx < 9) {
        return '0' + (matchMonthIdx + 1);
      } else {
        return '' + (matchMonthIdx + 1);
      }
    }
  },
  getFileNameFromURL: function getFileNameFromURL(url) {
    var parts = url.split('/');
    var parsedURL = parts[parts.length - 1];
    return parsedURL;
  },
  generatePassword: function generatePassword() {
    var upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    var numbers = '0123456789';
    var allCharacters = upperCaseLetters + lowerCaseLetters + numbers;
    var password = '';
    for (var i = 0; i < 8; i++) {
      password += allCharacters.charAt(Math.floor(Math.random() * allCharacters.length));
    }
    return password;
  },
  currencySym: function currencySym(name) {
    var currencies = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].currencySymbols;
    var matchCurrency = currencies.find(function (c) {
      return c.title === name;
    });
    if (matchCurrency) {
      return matchCurrency.symbol;
    }
    return '$';
  },
  convertCurrency: function convertCurrency(currency, amt, currencyRates) {
    var rate = currencyRates[currency];
    amt = Number(amt / rate).toFixed(2);
    return amt;
  },
  convertOtherCurrency: function convertOtherCurrency(currency, amt, currencyRates) {
    var rate = currencyRates[currency];
    amt = Number(amt * rate).toFixed(2);
    return amt;
  },
  generateUniqueId: function generateUniqueId() {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < 26; i++) {
      var randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  func: func,
  TYPE: TYPE
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);











var FileSaver = __webpack_require__(119);

/* harmony default export */ __webpack_exports__["a"] = ({
  extractReportPost: function extractReportPost(url, platform) {
    var _this = this;

    var operation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'insights';
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/social-data/reports/posts/' + operation, true, { url: url, platform: platform });

            case 2:
              response = _context.sent;

              if (!(!response.data || response.data.success !== true)) {
                _context.next = 5;
                break;
              }

              throw new Error('Post extraction returned no usable data.');

            case 5:
              return _context.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  paginate: function paginate(options) {
    var searchParams = new URLSearchParams();
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(options).forEach(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (value === '' || value === null || value === undefined) return;
      searchParams.set(key, String(value));
    });
    var params = searchParams.toString();
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = params ? '/api/v1/campaigns?' + params : '/api/v1/campaigns';
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  paginateRateCard: function paginateRateCard(options) {
    var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
      return key + '=' + options[key];
    }).join('&');
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/pairings?' + params;
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateRateCard: function updateRateCard(pairingIDs, initialRateCards, campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/pairings/updateratecard', true, { pairingIDs: pairingIDs, initialRateCards: initialRateCards, campaignID: campaignID }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  approveRateCard: function approveRateCard(rowID, editRateCard) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/pairings/approveratecard', true, { rowID: rowID, editRateCard: editRateCard }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  rejectRateCard: function rejectRateCard(rowID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/pairings/rejectratecard', true, { rowID: rowID }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllReportRecognized: function getAllReportRecognized() {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/reports/recognized?limit=999', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getMonthlyCampaignsReport: function getMonthlyCampaignsReport(_ref3) {
    var from = _ref3.from,
        to = _ref3.to;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/reports/monthly?from=' + from + '&to=' + to, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCampaigns: function getAllCampaigns(campaignStatus, force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cacheCampaignList = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.cache.campaignList;

      if (cacheCampaignList[campaignStatus] && cacheCampaignList[campaignStatus]['data'] && force === false) {
        resolve(cacheCampaignList[campaignStatus]);
      } else {
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns?limit=999&status=' + campaignStatus, true).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('SET_CAMPAIGNS', {
            campaignStatus: campaignStatus,
            data: response.data
          });

          resolve(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.cache.campaignList[campaignStatus]);
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  },
  getPayoutCampaignPicker: function getPayoutCampaignPicker() {
    var _this2 = this;

    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var campaignStatus, cacheCampaignList, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              campaignStatus = 'payout-picker';
              cacheCampaignList = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.cache.campaignList;

              if (!(cacheCampaignList[campaignStatus] && cacheCampaignList[campaignStatus].data && !force)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt('return', cacheCampaignList[campaignStatus].data);

            case 4:
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/payout-picker', true);

            case 6:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 9;
                break;
              }

              throw new Error('Error');

            case 9:

              __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('SET_CAMPAIGNS', {
                campaignStatus: campaignStatus,
                data: response.data
              });
              return _context2.abrupt('return', response.data);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  downloadCampaignDetailsReport: function downloadCampaignDetailsReport(campaignIDs, exportType) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/detail/download-report', 'POST', { campaignIDs: campaignIDs, exportType: exportType }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        if (exportType === 'csv') {
          var blob = new Blob([response.data], {
            type: 'utf-8'
          });
          FileSaver.saveAs(blob, response.headers.filename);
        } else if (exportType === 'excel') {
          var _blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(_blob, response.headers.filename);
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadAllCampaignsReport: function downloadAllCampaignsReport(campaigns, exportType) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/all/download-report', 'POST', { campaigns: campaigns, exportType: exportType }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        if (exportType === 'csv') {
          var blob = new Blob([response.data], {
            type: 'utf-8'
          });
          FileSaver.saveAs(blob, response.headers.filename);
        } else if (exportType === 'excel') {
          var _blob2 = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(_blob2, response.headers.filename);
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadSystemPerformanceReport: function downloadSystemPerformanceReport(exportType) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/performance/download-report', 'POST', { exportType: exportType }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        if (exportType === 'csv') {
          var blob = new Blob([response.data], {
            type: 'utf-8'
          });
          FileSaver.saveAs(blob, response.headers.filename);
        } else if (exportType === 'excel') {
          var _blob3 = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(_blob3, response.headers.filename);
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadMasterListsReport: function downloadMasterListsReport(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/master-lists/all/download-report', 'POST', data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'Masterlists Report (' + __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_10_moment___default()(), 'DD MMM YYYY') + ').xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadClientFeedback: function downloadClientFeedback(forms) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/client-feedback/download', 'POST', forms).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'Client_Feedback_Forms_' + __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('X') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getUnfinishedCampaigns: function getUnfinishedCampaigns() {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/all/unfinished?limit=999', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCampaignsNoStatus: function getAllCampaignsNoStatus() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/all?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaign: function getCampaign(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + campaignID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getReportGroups: function getReportGroups(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var queryParams = campaignID ? '?campaignID=' + campaignID : '';

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/reports/groups' + queryParams, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  addReportGroup: function addReportGroup(reportGroup) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/groups/add', true, reportGroup).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteReportGroup: function deleteReportGroup(groupID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/campaigns/reports/groups/' + groupID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignsByClientID: function getCampaignsByClientID(clientID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/by/client/' + clientID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  addPostToCampaign: function addPostToCampaign(body) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/', true, body).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateCampaignActivationStatus: function updateCampaignActivationStatus(campaignID, status) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/activate', true, { status: status }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateCampaignDirectRelease: function updateCampaignDirectRelease(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/direct-release', true, { status: status }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createCampaign: function createCampaign(campaign) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns', true, campaign).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editCampaign: function editCampaign(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID, true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createCampaignByAllocate: function createCampaignByAllocate(campaign) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/create/by/allocate', true, campaign).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateCampaignSummary: function updateCampaignSummary(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/summary/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateSegment: function updateSegment(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/segment/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createLineUp: function createLineUp(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/' + campaignID + '/create/lineup', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateLineUp: function updateLineUp(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/update/lineup', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updatePostAnalysisStatus: function updatePostAnalysisStatus(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/postAnalysisStatus/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateStoryAnalysisStatus: function updateStoryAnalysisStatus(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/storyAnalysisStatus/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateTikTokAnalysisStatus: function updateTikTokAnalysisStatus(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/tikTokAnalysisStatus/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateYoutubeAnalysisStatus: function updateYoutubeAnalysisStatus(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/youtubeAnalysisStatus/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updatePairingDisplayStatus: function updatePairingDisplayStatus(campaignID, formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/pairingDisplayStatus/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteCampaign: function deleteCampaign(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/campaigns/' + campaignID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteBulkCampaigns: function deleteBulkCampaigns(campaignIds) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/bulk-delete/campaigns', true, {
        ids: campaignIds
      }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  approveCampaign: function approveCampaign(campaignID, currentStatus) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/status/' + currentStatus, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeStatus: function changeStatus(campaignID, updateStatus) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/changeStatus/' + updateStatus, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changeBulkStatus: function changeBulkStatus(campaignIds, updateStatus) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/changeBulkStatus/' + updateStatus, true, {
        ids: campaignIds
      }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerID: function getInfluencerID(userID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/influencerid/' + userID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPairings: function getPairings(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + campaignID + '/pairings', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  invitePairings: function invitePairings(pairingIDs) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/pairings/status', true, { pairingIDs: pairingIDs }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPendingRateCard: function getPendingRateCard(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/pairings/pendingratecard', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  requestRateCardApproval: function requestRateCardApproval(pairingIDs, editRateCards, initialRateCards, campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/pairings/ratecard', true, { pairingIDs: pairingIDs, editRateCards: editRateCards, initialRateCards: initialRateCards, campaignID: campaignID }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRateCard: function getRateCard(campaignID, influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/pairings/ratecard/campaignID/' + campaignID + '/influencerID/' + influencerID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  acceptInvite: function acceptInvite(pairingID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/pairings/status', true, { pairingID: pairingID }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  rejectInvite: function rejectInvite(pairingID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/pairings/status', true, { pairingID: pairingID }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPosts: function getPosts(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + campaignID + '/posts', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPostsForClient: function getPostsForClient(clientID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/posts-client?clientID=' + clientID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createPost: function createPost(campaignID, form) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/' + campaignID + '/posts', true, form).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editPost: function editPost(campaignID, postID, form) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/posts/' + postID, true, form).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updatePost: function updatePost(campaignID, postID, instagramURL) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/posts/' + postID, true, { instagramURL: instagramURL }).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  approvePost: function approvePost(postID, currentStatus) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/status/' + currentStatus, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  rejectPost: function rejectPost(postID, currentStatus) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/posts/' + postID + '/status/' + currentStatus, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createComment: function createComment(campaignID, newComment) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/' + campaignID + '/comments', true, newComment).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getComments: function getComments(campaignID, conditions) {
    var urlCondition = '?';
    for (var key in conditions) {
      urlCondition += key + '=' + conditions[key] + '&';
    }
    urlCondition = urlCondition.slice(0, -1);

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + campaignID + '/comments' + urlCondition, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getUnreadComments: function getUnreadComments(campaignID) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + campaignID + '/comments/unread', true);

            case 3:
              response = _context3.sent;

              if (!(response.status !== 200)) {
                _context3.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context3.abrupt('return', response.data);

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3['catch'](0);
              throw _context3.t0;

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 9]]);
    }))();
  },
  markCommentAsRead: function markCommentAsRead(commentsId) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              commentsId = commentsId.join(',');
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/comments/mark-as-read?commentIds=' + commentsId, true);

            case 4:
              response = _context4.sent;

              if (!(response.status !== 200)) {
                _context4.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context4.abrupt('return', response.data);

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);
              throw _context4.t0;

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 10]]);
    }))();
  },
  assignCsToCampaign: function assignCsToCampaign(campaignID, cs) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/assign/cs', true, cs);

            case 3:
              response = _context5.sent;

              if (!(response.status !== 200)) {
                _context5.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context5.abrupt('return', response.data);

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5['catch'](0);
              throw _context5.t0;

            case 12:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 9]]);
    }))();
  },
  resetPasscode: function resetPasscode(campaignID, passcode) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/reset/passcode', true, { passcode: passcode });

            case 3:
              response = _context6.sent;

              if (!(response.status !== 200)) {
                _context6.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context6.abrupt('return', response.data);

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6['catch'](0);
              throw _context6.t0;

            case 12:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 9]]);
    }))();
  },
  loginCampaignReport: function loginCampaignReport(campaignID, passcode) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns-html-report/' + campaignID + '/login', false, { passcode: passcode }).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  sendCampaignPDF: function sendCampaignPDF(campaignID, pdfDoc) {
    var data = {
      attachment: pdfDoc
    };
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/' + campaignID + '/pdf', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getPostsFromPaymentsByCampaignId: function getPostsFromPaymentsByCampaignId(campaignID) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', 'api/v1/payments/posts/' + campaignID, true);

            case 3:
              response = _context8.sent;

              if (!(response.status !== 200)) {
                _context8.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context8.abrupt('return', response.data);

            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8['catch'](0);
              throw _context8.t0;

            case 12:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 9]]);
    }))();
  },
  generateCampaignReportPDF: function generateCampaignReportPDF(campaignID, name, force) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var response, blob;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/' + campaignID + '/report?force=' + force + '&fmt=pdf', 'GET');

            case 3:
              response = _context9.sent;
              blob = new Blob([response.data], {
                type: 'application/pdf'
              });

              FileSaver.saveAs(blob, name + '-report.pdf');
              _context9.next = 11;
              break;

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9['catch'](0);
              throw _context9.t0;

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 8]]);
    }))();
  },
  generateCampaignReportExcel: function generateCampaignReportExcel(campaignID, name, force) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var response, blob;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/' + campaignID + '/report?force=' + force + '&fmt=xlsx', 'GET');

            case 3:
              response = _context10.sent;
              blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });

              FileSaver.saveAs(blob, name + '-report.xlsx');

              if (!(response.status !== 200)) {
                _context10.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context10.abrupt('return', response.data);

            case 11:
              _context10.prev = 11;
              _context10.t0 = _context10['catch'](0);
              throw _context10.t0;

            case 14:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 11]]);
    }))();
  },
  generateCampaignReportExcelonPosts: function generateCampaignReportExcelonPosts(campaignID, name, force) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var response, blob;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].download('/api/v1/campaigns/' + campaignID + '/report?force=' + force + '&fmt=xlsx_posts', 'GET');

            case 3:
              response = _context11.sent;
              blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });

              FileSaver.saveAs(blob, name + '-report.xlsx');

              if (!(response.status !== 200)) {
                _context11.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context11.abrupt('return', response.data);

            case 11:
              _context11.prev = 11;
              _context11.t0 = _context11['catch'](0);
              throw _context11.t0;

            case 14:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 11]]);
    }))();
  },
  generateCampaignReport: function generateCampaignReport(campaignID, page, force, fmt, reportID) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + campaignID + '/report?page=' + page + '&force=' + force + '&fmt=' + fmt + '&reportID=' + reportID, true);

            case 3:
              response = _context12.sent;

              if (!(response.status !== 200)) {
                _context12.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context12.abrupt('return', response.data);

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12['catch'](0);
              throw _context12.t0;

            case 12:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 9]]);
    }))();
  },
  getReportsByCampaignIDs: function getReportsByCampaignIDs(campaignIDs) {
    var _this13 = this;

    var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/by/campaignIDs', true, { campaignIDs: campaignIDs, refresh: refresh }).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }

                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  getReportsForCalendar: function getReportsForCalendar(query) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/for/calendar', true, query).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }

                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  getPaymentConsolidateReport: function getPaymentConsolidateReport() {
    var _this15 = this;

    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var params, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context15.prev = 1;
              _context15.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/payment/consolidate/report?' + params, true);

            case 4:
              response = _context15.sent;

              if (!(response.status !== 200)) {
                _context15.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context15.abrupt('return', response.data);

            case 10:
              _context15.prev = 10;
              _context15.t0 = _context15['catch'](1);
              throw _context15.t0;

            case 13:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15, [[1, 10]]);
    }))();
  },
  exportBankReport: function exportBankReport(data, type) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var payload, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              payload = {
                data: data,
                type: type
              };
              _context16.prev = 1;
              _context16.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].downloadPATCH('/api/v1/campaigns/payment/consolidate/report/bank-export', 'PATCH', payload);

            case 4:
              response = _context16.sent;

              if (!(response.status !== 200)) {
                _context16.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context16.abrupt('return', response.data);

            case 10:
              _context16.prev = 10;
              _context16.t0 = _context16['catch'](1);
              throw _context16.t0;

            case 13:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16, [[1, 10]]);
    }))();
  },
  exportCampaignCogs: function exportCampaignCogs(data) {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var payload, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              payload = {
                data: data
              };
              _context17.prev = 1;
              _context17.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].downloadPATCH('/api/v1/campaigns/cogs/export', 'PATCH', payload);

            case 4:
              response = _context17.sent;

              if (!(response.status !== 200)) {
                _context17.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context17.abrupt('return', response.data);

            case 10:
              _context17.prev = 10;
              _context17.t0 = _context17['catch'](1);
              throw _context17.t0;

            case 13:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17, [[1, 10]]);
    }))();
  },
  generateCampaignHTMLReport: function generateCampaignHTMLReport(campaignID, passcode, page, force, fmt) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns-html-report/' + campaignID + '/report?page=' + page + '&force=' + force + '&passcode=' + passcode + '&fmt=' + fmt, true);

            case 3:
              response = _context18.sent;

              if (!(response.status !== 200)) {
                _context18.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context18.abrupt('return', response.data);

            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18['catch'](0);
              throw _context18.t0;

            case 12:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18, [[0, 9]]);
    }))();
  },
  removeUrlFromCampaignReport: function removeUrlFromCampaignReport(campaignID, url) {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var regex, m, shortcode, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              regex = /^(?:https?:\/\/)?(?:www\.)?(?:instagram\.com\/p\/)([\d\w\-_]+)(?:\/)?(\?.*)?$/gm;
              m = void 0;
              shortcode = '';

              while ((m = regex.exec(url)) !== null) {
                if (m.index === regex.lastIndex) {
                  regex.lastIndex++;
                }
                shortcode = m[1];
              }
              _context19.prev = 4;
              _context19.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/campaigns/' + campaignID + '/report/' + shortcode, true);

            case 7:
              response = _context19.sent;

              if (!(response.status !== 200)) {
                _context19.next = 10;
                break;
              }

              throw new Error('Error');

            case 10:
              return _context19.abrupt('return', response.data);

            case 13:
              _context19.prev = 13;
              _context19.t0 = _context19['catch'](4);
              throw _context19.t0;

            case 16:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19, [[4, 13]]);
    }))();
  },
  updateCampaignSetting: function updateCampaignSetting(campaignID, setting) {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/settings/' + campaignID, true, setting);

            case 3:
              response = _context20.sent;

              if (!(response.status !== 200)) {
                _context20.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context20.abrupt('return', response.data);

            case 9:
              _context20.prev = 9;
              _context20.t0 = _context20['catch'](0);
              throw _context20.t0;

            case 12:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20, [[0, 9]]);
    }))();
  },
  fetchSuggestedInfluencers: function fetchSuggestedInfluencers(size, page, campaignName, contents) {
    var _this21 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee21() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              data = {
                name: campaignName,
                texts: contents
              };
              _context21.prev = 1;
              _context21.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/analyze?size=' + size + '&page=' + page, true, data);

            case 4:
              response = _context21.sent;

              if (!(response.status !== 200)) {
                _context21.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context21.abrupt('return', response.data);

            case 10:
              _context21.prev = 10;
              _context21.t0 = _context21['catch'](1);
              throw _context21.t0;

            case 13:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21, [[1, 10]]);
    }))();
  },
  getFinanceCampaigns: function getFinanceCampaigns() {
    var _this22 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/finance/revenue', true);

            case 3:
              response = _context22.sent;

              if (!(response.status !== 200)) {
                _context22.next = 6;
                break;
              }

              throw new Error('error');

            case 6:
              return _context22.abrupt('return', response.data);

            case 9:
              _context22.prev = 9;
              _context22.t0 = _context22['catch'](0);
              throw _context22.t0;

            case 12:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22, [[0, 9]]);
    }))();
  },
  deleteContentFromReport: function deleteContentFromReport(contentID) {
    var _this23 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee23() {
      var params, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
                return key + '=' + options[key];
              }).join('&');
              _context23.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/' + contentID + '/delete?' + params, true);

            case 4:
              response = _context23.sent;

              if (!(response.status !== 200)) {
                _context23.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context23.abrupt('return', response.data);

            case 10:
              _context23.prev = 10;
              _context23.t0 = _context23['catch'](0);
              throw _context23.t0;

            case 13:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this23, [[0, 10]]);
    }))();
  },
  updatePostInsights: function updatePostInsights(reportID, data) {
    var _this24 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee24() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              _context24.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/' + reportID, true, data);

            case 3:
              response = _context24.sent;

              if (!(response.status !== 200)) {
                _context24.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context24.abrupt('return', response.data);

            case 9:
              _context24.prev = 9;
              _context24.t0 = _context24['catch'](0);
              throw _context24.t0;

            case 12:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this24, [[0, 9]]);
    }))();
  },
  addStoryInsights: function addStoryInsights(campaignID, postID, pairingID, igHandle, country, platform, storyInsights, url, liveDate, postType, typeName) {
    var _this25 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee25() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              data = {
                campaignID: campaignID,
                postID: postID || '',
                pairingID: pairingID,
                username: igHandle.trim(),
                platform: platform,
                media_url: url,
                live_date: liveDate,
                insights: storyInsights,
                postType: postType,
                typeName: typeName,
                country: country
              };
              _context25.prev = 1;
              _context25.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually', true, data);

            case 4:
              response = _context25.sent;

              if (!(response.status !== 200)) {
                _context25.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context25.abrupt('return', response.data);

            case 10:
              _context25.prev = 10;
              _context25.t0 = _context25['catch'](1);
              throw _context25.t0;

            case 13:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this25, [[1, 10]]);
    }))();
  },
  addFbInsights: function addFbInsights(campaignID, postID, pairingID, igHandle, country, platform, fbInsights, url, liveDate, postType, typeName) {
    var _this26 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee26() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              data = {
                campaignID: campaignID,
                postID: postID || '',
                pairingID: pairingID,
                username: igHandle.trim(),
                platform: platform,
                media_url: url,
                live_date: liveDate,
                insights: fbInsights,
                postType: postType,
                typeName: typeName,
                country: country
              };
              _context26.prev = 1;
              _context26.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/fbData', true, data);

            case 4:
              response = _context26.sent;

              if (!(response.status !== 200)) {
                _context26.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context26.abrupt('return', response.data);

            case 10:
              _context26.prev = 10;
              _context26.t0 = _context26['catch'](1);
              throw _context26.t0;

            case 13:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this26, [[1, 10]]);
    }))();
  },
  addXHSInsights: function addXHSInsights(campaignID, postID, pairingID, igHandle, country, platform, xhsID, xhsLink, xhsFollowers, xhsInsights, medias, liveDate, postType, typeName) {
    var _this27 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee27() {
      var data, formData, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              data = {
                campaignID: campaignID,
                postID: postID || '',
                pairingID: pairingID,
                username: igHandle.trim(),
                platform: platform,
                xhsID: xhsID,
                xhsLink: xhsLink,
                xhsFollowers: xhsFollowers,
                live_date: liveDate,
                insights: xhsInsights,
                postType: postType,
                typeName: typeName,
                country: country
              };
              _context27.prev = 1;
              formData = new FormData();

              formData.append('report', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
              if (medias) formData.append('medias', medias);
              _context27.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/xhsData', true, formData);

            case 7:
              response = _context27.sent;

              if (!(response.status !== 200)) {
                _context27.next = 10;
                break;
              }

              throw new Error('Error');

            case 10:
              return _context27.abrupt('return', response.data);

            case 13:
              _context27.prev = 13;
              _context27.t0 = _context27['catch'](1);
              throw _context27.t0;

            case 16:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this27, [[1, 13]]);
    }))();
  },
  addLemonInsights: function addLemonInsights(campaignID, postID, pairingID, igHandle, country, platform, lemonID, lemonLink, lemonFollowers, lemonInsights, medias, liveDate, postType, typeName) {
    var _this28 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee28() {
      var data, formData, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              data = {
                campaignID: campaignID,
                postID: postID || '',
                pairingID: pairingID,
                username: igHandle.trim(),
                platform: platform,
                lemonID: lemonID,
                lemonLink: lemonLink,
                lemonFollowers: lemonFollowers,
                live_date: liveDate,
                insights: lemonInsights,
                postType: postType,
                typeName: typeName,
                country: country
              };
              _context28.prev = 1;
              formData = new FormData();

              formData.append('report', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
              formData.append('medias', medias);
              _context28.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/lemonData', true, formData);

            case 7:
              response = _context28.sent;

              if (!(response.status !== 200)) {
                _context28.next = 10;
                break;
              }

              throw new Error('Error');

            case 10:
              return _context28.abrupt('return', response.data);

            case 13:
              _context28.prev = 13;
              _context28.t0 = _context28['catch'](1);
              throw _context28.t0;

            case 16:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this28, [[1, 13]]);
    }))();
  },
  addPostInsights: function addPostInsights(campaignID, postID, pairingID, igHandle, country, platform, postInsights, inputtedInsights, url, imageUrl, liveDate, postType, typeName) {
    var _this29 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee29() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              data = {
                campaignID: campaignID,
                postID: postID,
                pairingID: pairingID,
                username: igHandle.trim(),
                platform: platform,
                postURL: url,
                postImageURL: imageUrl,
                live_date: liveDate,
                insights: postInsights,
                inputtedInsights: inputtedInsights,
                postType: postType,
                typeName: typeName,
                country: country
              };
              _context29.prev = 1;
              _context29.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/postData', true, data);

            case 4:
              response = _context29.sent;

              if (!(response.status !== 200)) {
                _context29.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context29.abrupt('return', response.data);

            case 10:
              _context29.prev = 10;
              _context29.t0 = _context29['catch'](1);
              throw _context29.t0;

            case 13:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this29, [[1, 10]]);
    }))();
  },
  addTikTokInsights: function addTikTokInsights(campaignID, pairingID, tikTokHandle, country, platform, tikTokInsights, inputtedInsights, url, liveDate, postType, postID) {
    var _this30 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee30() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              data = {
                campaignID: campaignID,
                pairingID: pairingID,
                username: tikTokHandle.trim(),
                platform: platform,
                postURL: url,
                insights: tikTokInsights,
                inputtedInsights: inputtedInsights,
                live_date: liveDate,
                postType: postType,
                postID: postID,
                country: country
              };
              _context30.prev = 1;
              _context30.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/tikTokData', true, data);

            case 4:
              response = _context30.sent;

              if (!(response.status !== 200)) {
                _context30.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context30.abrupt('return', response.data);

            case 10:
              _context30.prev = 10;
              _context30.t0 = _context30['catch'](1);
              throw _context30.t0;

            case 13:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this30, [[1, 10]]);
    }))();
  },
  addYoutubePostInsights: function addYoutubePostInsights(campaignID, postID, pairingID, youtubeHandle, country, platform, youtubeInsights, inputtedInsights, url, liveDate, postType, typeName) {
    var _this31 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee31() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              data = {
                campaignID: campaignID,
                postID: postID,
                pairingID: pairingID,
                username: youtubeHandle.trim(),
                country: country,
                platform: platform,
                insights: youtubeInsights,
                inputtedInsights: inputtedInsights,
                postURL: url,
                live_date: liveDate,
                postType: postType,
                typeName: typeName
              };
              _context31.prev = 1;
              _context31.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/youtubeData', true, data);

            case 4:
              response = _context31.sent;

              if (!(response.status !== 200)) {
                _context31.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context31.abrupt('return', response.data);

            case 10:
              _context31.prev = 10;
              _context31.t0 = _context31['catch'](1);
              throw _context31.t0;

            case 13:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this31, [[1, 10]]);
    }))();
  },
  addMultipleContents: function addMultipleContents(campaignID, pairingID, igHandle, country, platform, medias, postType, typeName, liveDate, postID) {
    var _this32 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee32() {
      var data, formData, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              data = {
                campaignID: campaignID,
                pairingID: pairingID,
                username: igHandle.trim(),
                platform: platform,
                postType: postType,
                typeName: typeName,
                postID: postID,
                live_date: liveDate,
                country: country
              };
              formData = new FormData();

              formData.append('report', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
              formData.append('medias', medias);
              _context32.prev = 4;
              _context32.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/multipleContents', true, formData);

            case 7:
              response = _context32.sent;

              if (!(response.status !== 200)) {
                _context32.next = 10;
                break;
              }

              throw new Error('Error');

            case 10:
              return _context32.abrupt('return', response.data);

            case 13:
              _context32.prev = 13;
              _context32.t0 = _context32['catch'](4);
              throw _context32.t0;

            case 16:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this32, [[4, 13]]);
    }))();
  },
  addOtherInsights: function addOtherInsights(campaignID, pairingID, otherHandle, country, platform, otherInsights, url, medias, liveDate, postType, typeName, postID) {
    var _this33 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee33() {
      var data, formData, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              data = {
                campaignID: campaignID,
                pairingID: pairingID,
                username: otherHandle.trim(),
                postURL: url,
                insights: otherInsights,
                live_date: liveDate,
                postType: postType,
                typeName: typeName,
                postID: postID,
                country: country,
                platform: platform
              };
              _context33.prev = 1;
              formData = new FormData();

              formData.append('report', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
              formData.append('medias', medias);
              _context33.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/reports/manually/otherData', true, formData);

            case 7:
              response = _context33.sent;

              if (!(response.status !== 200)) {
                _context33.next = 10;
                break;
              }

              throw new Error('Error');

            case 10:
              return _context33.abrupt('return', response.data);

            case 13:
              _context33.prev = 13;
              _context33.t0 = _context33['catch'](1);
              throw _context33.t0;

            case 16:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this33, [[1, 13]]);
    }))();
  },
  updateLineUpIndex: function updateLineUpIndex(data) {
    var _this34 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee34() {
      var campaignID, reportID, requestObj, response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              campaignID = data.campaignID || null;
              reportID = data.reportID || null;
              requestObj = {
                lineUpIndex: data.lineUpIndex
              };

              if (data.groupID) {
                requestObj.groupID = data.groupID;
                requestObj.posts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.posts);
              }
              _context34.prev = 4;
              _context34.next = 7;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + campaignID + '/' + reportID + '/lineup', true, requestObj);

            case 7:
              response = _context34.sent;

              if (!(response.status !== 200)) {
                _context34.next = 10;
                break;
              }

              throw new Error('Error');

            case 10:
              return _context34.abrupt('return', response.data);

            case 13:
              _context34.prev = 13;
              _context34.t0 = _context34['catch'](4);
              throw _context34.t0;

            case 16:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this34, [[4, 13]]);
    }))();
  },
  updateCampaignBenchmark: function updateCampaignBenchmark(campaignID, formData) {
    var _this35 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee35() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              return _context35.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/' + campaignID + '/benchmark/update', true, formData).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this35);
    }))();
  },
  getAllCampaignVerticals: function getAllCampaignVerticals(force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/verticals', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].commit('SET_CAMPAIGNVERTICALS', response.data.campaignVerticals);
        resolve(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].state.cache.campaignVerticalList);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCountries: function getAllCountries(force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/countries', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data.countries);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllBrandSheets: function getAllBrandSheets(force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/brand-fact-sheets/lists', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getFeedbackAccess: function getFeedbackAccess(campaignID) {
    var _this36 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee36() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/' + encodeURIComponent(campaignID) + '/feedback-access', true);

            case 2:
              response = _context36.sent;
              return _context36.abrupt('return', response.data);

            case 4:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this36);
    }))();
  },
  changeFeedbackAccess: function changeFeedbackAccess(campaignID, accepting) {
    var _this37 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee37() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/' + encodeURIComponent(campaignID) + '/feedback-access', true, { accepting: accepting });

            case 2:
              response = _context37.sent;
              return _context37.abrupt('return', response.data);

            case 4:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, _this37);
    }))();
  },
  getCampaignDetailForFeedback: function getCampaignDetailForFeedback(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns-open/' + encodeURIComponent(campaignID), true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(reject);
    });
  },
  getCampaignDetailForFeedbackInvitation: function getCampaignDetailForFeedbackInvitation(campaignID, token) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns-open/feedback/' + encodeURIComponent(campaignID), false, null, { 'x-feedback-token': token }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignDetailForStats: function getCampaignDetailForStats(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns-open/' + campaignID + '?purpose=stats', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignInfoForBrandSheet: function getCampaignInfoForBrandSheet(campaignID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns-open/' + campaignID + '/brand-sheet', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCampaignsForFeedback: function getAllCampaignsForFeedback(campaignStatus, force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns?limit=999', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignsInfluencerReport: function getCampaignsInfluencerReport(options) {
    var query = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.objectToQueryString(options);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/influencer/reports?' + query, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getClientFeedbacks: function getClientFeedbacks(options) {
    var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
      return key + '=' + options[key];
    }).join('&');
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/campaigns/client-feedback?' + params;
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createClientFeedback: function createClientFeedback(feedback) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns-open/client-feedback', true, feedback).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createBrandSheet: function createBrandSheet(brandSheet) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns-open/brand-fact-sheet', true, brandSheet).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateReportsByIds: function updateReportsByIds(data) {
    var _this38 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee38() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _context38.prev = 0;
              _context38.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/update-by/ids', true, data);

            case 3:
              response = _context38.sent;

              if (!(response.status !== 200)) {
                _context38.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context38.abrupt('return', response.data);

            case 9:
              _context38.prev = 9;
              _context38.t0 = _context38['catch'](0);
              throw _context38.t0;

            case 12:
            case 'end':
              return _context38.stop();
          }
        }
      }, _callee38, _this38, [[0, 9]]);
    }))();
  },
  updateCampaignByIds: function updateCampaignByIds(data) {
    var _this39 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee39() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.prev = 0;
              _context39.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/update-by/ids', true, data);

            case 3:
              response = _context39.sent;

              if (!(response.status !== 200)) {
                _context39.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context39.abrupt('return', response.data);

            case 9:
              _context39.prev = 9;
              _context39.t0 = _context39['catch'](0);
              throw _context39.t0;

            case 12:
            case 'end':
              return _context39.stop();
          }
        }
      }, _callee39, _this39, [[0, 9]]);
    }))();
  },
  saveEditedReportData: function saveEditedReportData(data) {
    var _this40 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee40() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.prev = 0;
              _context40.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/edited-data', true, data);

            case 3:
              response = _context40.sent;

              if (!(response.status !== 200)) {
                _context40.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context40.abrupt('return', response.data);

            case 9:
              _context40.prev = 9;
              _context40.t0 = _context40['catch'](0);
              throw _context40.t0;

            case 12:
            case 'end':
              return _context40.stop();
          }
        }
      }, _callee40, _this40, [[0, 9]]);
    }))();
  },
  savePaymentConsolidatedData: function savePaymentConsolidatedData(data) {
    var _this41 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee41() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.prev = 0;
              _context41.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/payment/consolidated-data', true, data);

            case 3:
              response = _context41.sent;

              if (!(response.status !== 200)) {
                _context41.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context41.abrupt('return', response.data);

            case 9:
              _context41.prev = 9;
              _context41.t0 = _context41['catch'](0);
              throw _context41.t0;

            case 12:
            case 'end':
              return _context41.stop();
          }
        }
      }, _callee41, _this41, [[0, 9]]);
    }))();
  },
  savePaymentConsolidatedPayout: function savePaymentConsolidatedPayout(data) {
    var _this42 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee42() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              _context42.prev = 0;
              _context42.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/payment/consolidate/payout', true, data);

            case 3:
              response = _context42.sent;

              if (!(response.status !== 200)) {
                _context42.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context42.abrupt('return', response.data);

            case 9:
              _context42.prev = 9;
              _context42.t0 = _context42['catch'](0);
              throw _context42.t0;

            case 12:
            case 'end':
              return _context42.stop();
          }
        }
      }, _callee42, _this42, [[0, 9]]);
    }))();
  },
  savePaymentConsolidatedInvoice: function savePaymentConsolidatedInvoice(data) {
    var _this43 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee43() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              _context43.prev = 0;
              _context43.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/report-invoice/create', true, data);

            case 3:
              response = _context43.sent;

              if (!(response.status !== 200)) {
                _context43.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context43.abrupt('return', response.data);

            case 9:
              _context43.prev = 9;
              _context43.t0 = _context43['catch'](0);
              throw _context43.t0;

            case 12:
            case 'end':
              return _context43.stop();
          }
        }
      }, _callee43, _this43, [[0, 9]]);
    }))();
  },
  saveReportPartialAmount: function saveReportPartialAmount(campaignID, data) {
    var _this44 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee44() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              _context44.prev = 0;
              _context44.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/' + campaignID + '/partial/amount', true, data);

            case 3:
              response = _context44.sent;

              if (!(response.status !== 200)) {
                _context44.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context44.abrupt('return', response.data);

            case 9:
              _context44.prev = 9;
              _context44.t0 = _context44['catch'](0);
              throw _context44.t0;

            case 12:
            case 'end':
              return _context44.stop();
          }
        }
      }, _callee44, _this44, [[0, 9]]);
    }))();
  },
  saveReportActualAmount: function saveReportActualAmount(reportID, data) {
    var _this45 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee45() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              _context45.prev = 0;
              _context45.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/' + reportID + '/actual/amount', true, data);

            case 3:
              response = _context45.sent;

              if (!(response.status !== 200)) {
                _context45.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context45.abrupt('return', response.data);

            case 9:
              _context45.prev = 9;
              _context45.t0 = _context45['catch'](0);
              throw _context45.t0;

            case 12:
            case 'end':
              return _context45.stop();
          }
        }
      }, _callee45, _this45, [[0, 9]]);
    }))();
  },
  getDealCampaignCount: function getDealCampaignCount(dealCode) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/deal-code/count/' + dealCode, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  checkUserInCampaignReport: function checkUserInCampaignReport(options) {
    var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
      return key + '=' + options[key];
    }).join('&');
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/campaigns/reports/check/owner?' + params;
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveReportNote: function saveReportNote(data) {
    var _this46 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee46() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              _context46.prev = 0;
              _context46.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/internal-note', true, data);

            case 3:
              response = _context46.sent;

              if (!(response.status !== 200)) {
                _context46.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context46.abrupt('return', response.data);

            case 9:
              _context46.prev = 9;
              _context46.t0 = _context46['catch'](0);
              throw _context46.t0;

            case 12:
            case 'end':
              return _context46.stop();
          }
        }
      }, _callee46, _this46, [[0, 9]]);
    }))();
  },
  saveReportNoteRead: function saveReportNoteRead(data) {
    var _this47 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee47() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              _context47.prev = 0;
              _context47.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/reports/read/internal-note', true, data);

            case 3:
              response = _context47.sent;

              if (!(response.status !== 200)) {
                _context47.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context47.abrupt('return', response.data);

            case 9:
              _context47.prev = 9;
              _context47.t0 = _context47['catch'](0);
              throw _context47.t0;

            case 12:
            case 'end':
              return _context47.stop();
          }
        }
      }, _callee47, _this47, [[0, 9]]);
    }))();
  },
  uploadEditorImage: function uploadEditorImage(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/editor/image/upload', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  uploadImage: function uploadImage(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns-open/image/upload', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  sendBFSEmail: function sendBFSEmail(formData) {
    var _this48 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee48() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              return _context48.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns-open/brand-fact-sheet/email', true, formData).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context48.stop();
          }
        }
      }, _callee48, _this48);
    }))();
  },
  getRptDeliverablesByHandle: function getRptDeliverablesByHandle(options) {
    var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
      return key + '=' + options[key];
    }).join('&');
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/reports/deliverables/byhandle?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteCldFile: function deleteCldFile(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/delete/cloudinary', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveAOKReport: function saveAOKReport(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/update/aok-report', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getUploadedInvoiceLists: function getUploadedInvoiceLists(force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/report-invoice/find', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateReportInvoice: function updateReportInvoice(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/report-invoice/update', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCldSignature: function getCldSignature(payload) {
    var _this49 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee49() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              _context49.prev = 0;
              _context49.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/campaigns/get/cloudinary/signature', true, { options: payload });

            case 3:
              response = _context49.sent;

              if (!(response.status !== 200)) {
                _context49.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context49.abrupt('return', response.data);

            case 9:
              _context49.prev = 9;
              _context49.t0 = _context49['catch'](0);
              throw _context49.t0;

            case 12:
            case 'end':
              return _context49.stop();
          }
        }
      }, _callee49, _this49, [[0, 9]]);
    }))();
  },
  bulkDeleteInvoices: function bulkDeleteInvoices(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('patch', '/api/v1/campaigns/report-invoice/bulk-delete', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteS3Object: function deleteS3Object(objectID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/campaigns/delete/s3/object/' + objectID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getStatsData: function getStatsData(handle) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', '/api/v1/campaigns/stats/data?handle=' + handle, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  storeStatsData: function storeStatsData(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('POST', '/api/v1/campaigns/store/stats/data', data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  uploadAIStatsData: function uploadAIStatsData(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('POST', '/api/v1/campaigns/upload/ai-stats/data', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignAISummary: function getCampaignAISummary(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('POST', '/api/v1/campaigns/context/ai-summary', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getHTMLReportAISummary: function getHTMLReportAISummary(campaignID, passcode, data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('POST', '/api/v1/campaigns-html-report/' + campaignID + '/ai-summary?passcode=' + encodeURIComponent(passcode), false, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignNotableComments: function getCampaignNotableComments(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('POST', '/api/v1/campaigns/context/ai-notable-comments', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(36);





/* harmony default export */ __webpack_exports__["a"] = ({
  paginate: function paginate(page, perPage) {
    var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var role = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/users?page=' + page + '&per_page=' + perPage + '&keyword=' + keyword + '&role=' + role, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllUsers: function getAllUsers() {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/users?limit=999', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllUsersByRole: function getAllUsersByRole(role) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              url = '/api/v1/users?limit=999&role=' + role;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', false);

            case 7:
              return _context.abrupt('return', response.data);

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);
              throw _context.t0;

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 10]]);
    }))();
  },
  getUsersByRole: function getUsersByRole(role) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              url = '/api/v1/users/by/role/' + role;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt('return', false);

            case 7:
              return _context2.abrupt('return', response.data);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 10]]);
    }))();
  },
  getAllUsersByRoleSource: function getAllUsersByRoleSource(role, source) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              url = '/api/v1/users?limit=999&role=' + role + '&source=' + source;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context3.sent;

              if (!(response.status !== 200)) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt('return', false);

            case 7:
              return _context3.abrupt('return', response.data);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);
              throw _context3.t0;

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 10]]);
    }))();
  },
  findByRole: function findByRole(clientID) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              url = '/api/v1/users/find/adstrategist/' + clientID;
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context4.sent;

              if (!(response.status !== 200)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt('return', false);

            case 7:
              return _context4.abrupt('return', response.data);

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);
              throw _context4.t0;

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 10]]);
    }))();
  },
  createPrivateLink: function createPrivateLink(body) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              url = '/api/v1/users/register-link';
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, body);

            case 4:
              response = _context5.sent;

              if (!(response.status !== 200)) {
                _context5.next = 7;
                break;
              }

              return _context5.abrupt('return', false);

            case 7:
              return _context5.abrupt('return', response.data);

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5['catch'](0);
              throw _context5.t0;

            case 13:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 10]]);
    }))();
  },
  getLinkedInProfile: function getLinkedInProfile(handle) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var query, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              query = encodeURIComponent(handle);
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/social-data/audience/influencer/linkedin/profile?handle=' + query + '&refresh=false', true);

            case 3:
              response = _context6.sent;
              return _context6.abrupt('return', response.data);

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getPublicProfile: function getPublicProfile(platform, handle) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var query, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              query = encodeURIComponent(handle);
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/social-data/audience/influencer/' + platform + '/profile?handle=' + query + '&refresh=false', true);

            case 3:
              response = _context7.sent;
              return _context7.abrupt('return', response.data);

            case 5:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  createCommunityOnboardLink: function createCommunityOnboardLink(body) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              url = '/api/v1/users/community/register-link';
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, body);

            case 4:
              response = _context8.sent;

              if (!(response.status !== 200)) {
                _context8.next = 7;
                break;
              }

              return _context8.abrupt('return', false);

            case 7:
              return _context8.abrupt('return', response.data);

            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8['catch'](0);
              throw _context8.t0;

            case 13:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 10]]);
    }))();
  },
  deletePrivateLink: function deletePrivateLink(linkID) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('delete', '/api/v1/users/register-link/' + linkID, true).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }

                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getNewUsers: function getNewUsers() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              url = '/api/v1/users?isApproved=0';
              _context10.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context10.sent;

              if (!(response.status !== 200)) {
                _context10.next = 7;
                break;
              }

              return _context10.abrupt('return', false);

            case 7:
              return _context10.abrupt('return', response.data);

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10['catch'](0);
              throw _context10.t0;

            case 13:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 10]]);
    }))();
  },
  approveOrReject: function approveOrReject(action, userId) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              url = '/api/v1/users/approve-reject/' + userId;
              _context11.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, {
                action: action
              });

            case 4:
              response = _context11.sent;

              if (!(response.status !== 200)) {
                _context11.next = 7;
                break;
              }

              return _context11.abrupt('return', false);

            case 7:
              return _context11.abrupt('return', response.data);

            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11['catch'](0);
              throw _context11.t0;

            case 13:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 10]]);
    }))();
  },
  getUser: function getUser(userID) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/users/' + userID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getUserWordcloud: function getUserWordcloud() {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/influencers/wordcloud', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createUser: function createUser(user) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/users', true, user).then(function (response) {
        if (!response) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editUser: function editUser(user) {
    var userID = user.id;
    delete user.id;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/users/' + userID, true, user).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  changePassword: function changePassword(user) {
    var userID = user.id;
    delete user.id;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/users/change-password/' + userID, true, user).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        console.log('error', error);
        reject(error);
      });
    });
  },
  resetInfPassword: function resetInfPassword(user) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/users/influencer/reset-password', true, user).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        console.log(response.status);
        resolve(response.data);
      }).catch(function (error) {
        console.log('error', error);
        reject(error);
      });
    });
  },
  editProfile: function editProfile(formData) {
    var user = void 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(formData.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var pair = _step.value;

        if (pair[0] === 'editProfile') {
          user = JSON.parse(pair[1]);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/users/' + user.id + '/influencers', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editInfluencerFromAdmin: function editInfluencerFromAdmin(formData) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/users/update/influencers/byAdmin', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteUser: function deleteUser(userID) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('delete', '/api/v1/users/' + userID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  validateTokenResetPassword: function validateTokenResetPassword(email, token) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/users/reset-password/validate/token/' + email + '/' + token, true);

            case 3:
              resp = _context12.sent;
              return _context12.abrupt('return', resp);

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12['catch'](0);
              throw _context12.t0;

            case 10:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 7]]);
    }))();
  },
  validatRegisterToken: function validatRegisterToken(token) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/users/validate/register-token', false, {
                token: token
              });

            case 3:
              resp = _context13.sent;
              return _context13.abrupt('return', resp);

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13['catch'](0);
              throw _context13.t0;

            case 10:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 7]]);
    }))();
  },
  resetPassword: function resetPassword(data) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/users/reset-password', true, data);

            case 3:
              resp = _context14.sent;
              return _context14.abrupt('return', resp);

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14['catch'](0);
              throw _context14.t0;

            case 10:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14, [[0, 7]]);
    }))();
  },
  sendEmailResetPassword: function sendEmailResetPassword(email, recaptchaToken) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/users/forgot-password', false, {
                email: email,
                recaptchaToken: recaptchaToken
              });

            case 3:
              resp = _context15.sent;
              return _context15.abrupt('return', resp);

            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15['catch'](0);
              throw _context15.t0;

            case 10:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15, [[0, 7]]);
    }))();
  },
  getPendingTokenRegistrations: function getPendingTokenRegistrations() {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              url = '/api/v1/users/pending-token';
              _context16.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context16.sent;

              if (!(response.status !== 200)) {
                _context16.next = 7;
                break;
              }

              return _context16.abrupt('return', false);

            case 7:
              return _context16.abrupt('return', response.data);

            case 10:
              _context16.prev = 10;
              _context16.t0 = _context16['catch'](0);
              throw _context16.t0;

            case 13:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16, [[0, 10]]);
    }))();
  },
  getUserByInfluencer: function getUserByInfluencer(param) {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              url = '/api/v1/users/by/influencer';
              _context17.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, param);

            case 4:
              response = _context17.sent;

              if (!(response.status !== 200)) {
                _context17.next = 7;
                break;
              }

              return _context17.abrupt('return', false);

            case 7:
              return _context17.abrupt('return', response.data);

            case 10:
              _context17.prev = 10;
              _context17.t0 = _context17['catch'](0);
              throw _context17.t0;

            case 13:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17, [[0, 10]]);
    }))();
  },
  deleteS3Object: function deleteS3Object(key) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              url = '/api/v1/users/s3/delete';
              _context18.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('delete', url, true, { objectKey: key });

            case 4:
              response = _context18.sent;

              if (!(response.status !== 200)) {
                _context18.next = 7;
                break;
              }

              return _context18.abrupt('return', false);

            case 7:
              return _context18.abrupt('return', response.data);

            case 10:
              _context18.prev = 10;
              _context18.t0 = _context18['catch'](0);
              throw _context18.t0;

            case 13:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18, [[0, 10]]);
    }))();
  },
  checkClientUser: function checkClientUser(param) {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              url = '/api/v1/users/check/client-email';
              _context19.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, param);

            case 4:
              response = _context19.sent;

              if (!(response.status !== 200)) {
                _context19.next = 7;
                break;
              }

              return _context19.abrupt('return', false);

            case 7:
              return _context19.abrupt('return', response.data);

            case 10:
              _context19.prev = 10;
              _context19.t0 = _context19['catch'](0);
              throw _context19.t0;

            case 13:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19, [[0, 10]]);
    }))();
  },
  updateClientUserCampaigns: function updateClientUserCampaigns(body) {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              url = '/api/v1/users/clients/update/campaigns';
              _context20.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, body);

            case 4:
              response = _context20.sent;

              if (!(response.status !== 200)) {
                _context20.next = 7;
                break;
              }

              return _context20.abrupt('return', false);

            case 7:
              return _context20.abrupt('return', response.data);

            case 10:
              _context20.prev = 10;
              _context20.t0 = _context20['catch'](0);
              throw _context20.t0;

            case 13:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20, [[0, 10]]);
    }))();
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_sumBy__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_sum__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_reportPlatform__ = __webpack_require__(79);




















/* harmony default export */ __webpack_exports__["a"] = ({
  fixAnglesData: function fixAnglesData(angles) {
    var _this = this;

    angles = angles.map(function (angle) {
      var cpAngle = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, angle);

      if (cpAngle.required_action || cpAngle.required_action === '') {
        cpAngle.formats = [];
        var format = _this.getAngleFormat();
        format.required_action = cpAngle.required_action;
        format.image_angle = cpAngle.image_angle;
        format.content_angle = cpAngle.content_angle;
        var sampleImages = angle.sample_images ? angle.sample_images : [];
        if (cpAngle.sample_image) {
          sampleImages.push({ type: 'image', url: cpAngle.sample_image });
        }
        format.sample_images = sampleImages;
        delete cpAngle.required_action;
        delete cpAngle.image_angle;
        delete cpAngle.content_angle;
        delete cpAngle.sample_images;
        delete cpAngle.sample_image;
        cpAngle.formats.push(format);
      }

      if (cpAngle.formats) {
        cpAngle.formats = cpAngle.formats.map(function (formatOne) {
          if (formatOne.sample_images) {
            formatOne.sample_images = formatOne.sample_images.map(function (sampleImage) {
              if (!sampleImage.type) {
                if (_this.checkIfImage(sampleImage)) {
                  sampleImage = { type: 'image', url: sampleImage };
                } else {
                  sampleImage = { type: 'link', url: sampleImage };
                }
              }
              return sampleImage;
            });
          }
          return formatOne;
        });
      }
      return cpAngle;
    });
    return angles;
  },
  getAngleFormat: function getAngleFormat() {
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, {
      required_action: '',
      image_angle: '',
      content_angle: '',
      sample_images: ''
    });
  },
  getDefaultAngle: function getDefaultAngle() {
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, {
      option_name: '',
      context: '',
      formats: [this.getAngleFormat()]
    });
  },
  checkIfImage: function checkIfImage(url) {
    var images = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG'];
    var isImage = false;
    images.map(function (img) {
      if (url.endsWith(img)) {
        isImage = true;
      }
    });
    return isImage;
  },
  getDefaultSegments: function getDefaultSegments() {
    return __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userSegmentDisplay.map(function (u) {
      return u.value;
    });
  },

  getYoutubePost: function getYoutubePost(shortCode) {
    return 'https://www.youtube.com/embed/' + shortCode;
  },
  getTikTokPost: function getTikTokPost(shortCode) {
    return 'https://www.tiktok.com/embed/' + shortCode;
  },
  getDeliverableNames: function getDeliverableNames() {
    return [{ name: 'IGP', title: 'IG Post' }, { name: 'IGC', title: 'IG Carousel' }, { name: 'IGS', title: 'IG Story' }, { name: 'IGR', title: 'IG Reel' }, { name: 'TTP', title: 'TikTok Post' }, { name: 'YTP', title: 'Youtube Post' }, { name: 'XHS', title: 'XHS Post' }, { name: 'Lemon8', title: 'Lemon8 Post' }, { name: 'FBP', title: 'Facebook Post' }, { name: 'LIP', title: 'LinkedIn Post' }, { name: 'XTP', title: 'X (Twitter) Post' }, { name: 'Others', title: 'Others' }];
  },
  getDeliverableTitle: function getDeliverableTitle(postType) {
    if (postType === 'IGP') {
      return 'IG Post';
    } else if (postType === 'IGC') {
      return 'IG Carousel';
    } else if (postType === 'IGR') {
      return 'IG Reel';
    } else if (postType === 'IGS') {
      return 'IG Story';
    } else if (postType === 'TTP') {
      return 'TikTok Post';
    } else if (postType === 'YTP') {
      return 'Youtube Post';
    } else if (postType === 'XHS') {
      return 'XHS Post';
    } else if (postType === 'FBP') {
      return 'Facebook Post';
    } else if (postType === 'LIP') {
      return 'LinkedIn Post';
    } else if (postType === 'XTP') {
      return 'X (Twitter) Post';
    } else if (postType === 'others') {
      return 'Others';
    }
    return '';
  },
  getDeliverableDetails: function getDeliverableDetails(details) {
    var deliverables = [];
    if (details) {
      if (details.no_of_tiktok_posts) {
        deliverables.push(details.no_of_tiktok_posts + ' X TTP');
      }
      if (details.no_of_fb_posts) {
        deliverables.push(details.no_of_fb_posts + ' X FBP');
      }
      if (details.no_of_xhs_posts) {
        deliverables.push(details.no_of_xhs_posts + ' X XHS');
      }
      if (details.no_of_posts) {
        deliverables.push(details.no_of_posts + ' X IGP');
      }
      if (details.no_of_carousels) {
        deliverables.push(details.no_of_carousels + ' X IGC');
      }
      if (details.no_of_stories) {
        deliverables.push(details.no_of_stories + ' X IGS');
      }
      if (details.no_of_video) {
        deliverables.push(details.no_of_video + ' X IGV');
      }
      if (details.no_of_reels) {
        deliverables.push(details.no_of_reels + ' X IGR');
      }
      if (details.no_of_li_posts) {
        deliverables.push(details.no_of_li_posts + ' X LIP');
      }
      if (details.no_of_x_posts) {
        deliverables.push(details.no_of_x_posts + ' X X (Twitter) Post');
      }
      if (details.youtube) {
        deliverables.push(details.youtube + ' X YTP');
      }
      if (details.loading_whitelisting) {
        deliverables.push(details.loading_whitelisting + ' X Loading/Whitelisting');
      }
      if (details.exclusivity) {
        deliverables.push(details.exclusivity + ' X Exclusivity');
      }
      if (details.physical_attendance) {
        deliverables.push(details.physical_attendance + 'hrs X Physical Attendance');
      }
      if (details.online_attendance) {
        deliverables.push(details.online_attendance + 'hrs X Online Attendance');
      }
      if (details.custom) {
        details.custom.map(function (custom) {
          deliverables.push(custom.value + ' X ' + custom.label);
        });
      }
      return deliverables.join(', ');
    }
    return 'N/A';
  },
  getTotalDeliverables: function getTotalDeliverables(details) {
    var totalDeliverables = 0;
    if (details.custom) {
      totalDeliverables = __WEBPACK_IMPORTED_MODULE_14_lodash_sumBy___default()(details.custom, function (c) {
        return parseFloat(c.value);
      });
      delete details.custom;
    }
    totalDeliverables += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(details).length > 0 ? __WEBPACK_IMPORTED_MODULE_15_lodash_sum___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(details)) : 0;
    return totalDeliverables;
  },
  isAOKCampaign: function isAOKCampaign(type) {
    if (type === 'AOK' || type === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignType.AOK || type === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignType.Uncut) {
      return true;
    }
    return false;
  },
  isOtherCampaign: function isOtherCampaign(type) {
    if (type !== __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignType.AOK && type !== __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignType.Uncut) {
      return true;
    }
    return false;
  },
  generateBlocks: function generateBlocks(item) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var blocks, ObjectiveArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, goal, deliverableArray, contentAngles, i, j, format, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, mandatory, s, sampleImage;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              blocks = [];
              ObjectiveArray = [];

              if (!item.campaign_brief_details.goal) {
                _context.next = 22;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 6;

              for (_iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(item.campaign_brief_details.goal); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                goal = _step.value;

                ObjectiveArray.push(goal);
              }
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 14:
              _context.prev = 14;
              _context.prev = 15;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 17:
              _context.prev = 17;

              if (!_didIteratorError) {
                _context.next = 20;
                break;
              }

              throw _iteratorError;

            case 20:
              return _context.finish(17);

            case 21:
              return _context.finish(14);

            case 22:
              blocks.push({
                'type': 'title',
                'data': {
                  'text': '<b>Client:</b> ' + item.CampaignName
                }
              }, {
                'type': 'title',
                'data': {
                  'text': '<b>Objectives</b>'
                }
              }, {
                'type': 'list',
                'data': {
                  'style': 'unordered',
                  'items': ObjectiveArray
                }
              }, {
                'type': 'title',
                'data': {
                  'text': '<b>Unique Advantage</b>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + item.campaign_brief_details.uniqueAdvantage
                }
              }, {
                'type': 'title',
                'data': {
                  'text': '<b>Common Objections</b>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + item.campaign_brief_details.commonObjective
                }
              });

              if (item.deliverables) {
                deliverableArray = [];

                if (item.deliverables.no_of_tiktok_posts > 0) {
                  deliverableArray.push(item.deliverables.no_of_tiktok_posts + ' x TikTok Post');
                } else if (item.deliverables.no_of_posts > 0) {
                  deliverableArray.push(item.deliverables.no_of_posts + ' x IG Carousel Post');
                } else if (item.deliverables.no_of_stories > 0) {
                  deliverableArray.push(item.deliverables.no_of_stories + ' x IG Story with swipe up link');
                } else if (item.deliverables.no_of_reels > 0) {
                  deliverableArray.push(item.deliverables.no_of_reels + ' x IG Reel Post');
                } else {
                  deliverableArray.push(item.deliverables.no_of_video + ' x IG Video');
                }

                blocks.push({
                  'type': 'title',
                  'data': {
                    'text': '<b>Deliverables</b>'
                  }
                }, {
                  'type': 'list',
                  'data': {
                    'style': 'unordered',
                    'items': deliverableArray
                  }
                });
              }
              contentAngles = _this2.fixAnglesData(item.campaign_brief_details.angles);
              i = 0;

            case 26:
              if (!(i < contentAngles.length)) {
                _context.next = 60;
                break;
              }

              blocks.push({
                'type': 'title',
                'data': {
                  'text': '<b>Concept ' + (i + 1) + ': ' + contentAngles[i].option_name + '</b>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '<u>Campaign Context:</u>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + contentAngles[i].context
                }
              });
              j = 0;

            case 29:
              if (!(j < contentAngles[i].formats.length)) {
                _context.next = 57;
                break;
              }

              format = contentAngles[i].formats[j];

              blocks.push({
                'type': 'paragraph',
                'data': {
                  'text': '<u>Required action:</u>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + format.required_action
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '<u>Image/Video Pointers:</u>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + format.image_angle
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '<u>Content Pointers:</u>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + format.content_angle
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '<u>Remarks:</u>'
                }
              }, {
                'type': 'paragraph',
                'data': {
                  'text': '' + format.remark
                }
              });
              blocks.push({
                'type': 'paragraph',
                'data': {
                  'text': '<u>Mandatory Hashtags and Mentions:</u>'
                }
              });

              if (!(format.mandatory && format.mandatory.length > 0)) {
                _context.next = 53;
                break;
              }

              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 37;

              for (_iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(format.mandatory); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                mandatory = _step2.value;

                blocks.push({
                  'type': 'paragraph',
                  'data': {
                    'text': '' + mandatory
                  }
                });
              }
              _context.next = 45;
              break;

            case 41:
              _context.prev = 41;
              _context.t1 = _context['catch'](37);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 45:
              _context.prev = 45;
              _context.prev = 46;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 48:
              _context.prev = 48;

              if (!_didIteratorError2) {
                _context.next = 51;
                break;
              }

              throw _iteratorError2;

            case 51:
              return _context.finish(48);

            case 52:
              return _context.finish(45);

            case 53:
              if (format.sample_images.length > 0) {
                blocks.push({
                  'type': 'title',
                  'data': {
                    'text': '<b>Image/Video Inspiration</b>'
                  }
                });

                for (s = 0; s < format.sample_images.length; s++) {
                  sampleImage = format.sample_images[s];

                  if (sampleImage.type === 'image') {
                    blocks.push({
                      'type': 'image',
                      'data': {
                        'url': 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + sampleImage.url,
                        'triggerRemoved': true
                      }
                    });
                  } else {
                    blocks.push({
                      'type': 'paragraph',
                      'data': {
                        'text': sampleImage.url
                      }
                    });
                  }
                }
              }

            case 54:
              j++;
              _context.next = 29;
              break;

            case 57:
              i++;
              _context.next = 26;
              break;

            case 60:
              return _context.abrupt('return', blocks);

            case 61:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[6, 10, 14, 22], [15,, 17, 21], [37, 41, 45, 53], [46,, 48, 52]]);
    }))();
  },
  calculateTotalPlayTime: function calculateTotalPlayTime(posts) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var totalSeconds = 0;
    posts.map(function (post) {
      var time = post.plays;
      if (!time) {
        return false;
      }
      var hours = time.match(/(.+?(?=h))/);
      var minutes = time.match(/(?::)(.*)(?=m)/);
      var seconds = time.match(/(?:m:)(.*)(?=s)/);
      if (hours && minutes && seconds) {
        totalSeconds += hours[1] ? parseFloat(hours[1]) * 3600 : 0;
        totalSeconds += minutes[1] ? parseFloat(minutes[1].replace(':', '')) * 60 : 0;
        totalSeconds += seconds[1] ? parseFloat(seconds[1].replace('m:', '')) : 0;
      }
    });
    if (totalSeconds > 0) {
      if (count) {
        totalSeconds = parseInt(totalSeconds / parseInt(count));
      }
      var hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      return hours + 'h:' + minutes + 'm:' + seconds + 's';
    }
    return '-';
  },
  calculateTotalReelWatchTime: function calculateTotalReelWatchTime(posts) {
    var totalSeconds = 0;
    posts.map(function (post) {
      var time = post.plays;
      if (!time) {
        return false;
      }
      var days = time.match(/(.+?(?=d))/);
      var hours = time.match(/(?::)(.*)(?=h)/);
      var minutes = time.match(/(?::)(.*)(?=m)/);
      var seconds = time.match(/(?:m:)(.*)(?=s)/);
      if (hours && minutes && seconds) {
        totalSeconds += days && days[1] ? parseFloat(days[1]) * 86400 : 0;
        totalSeconds += hours[1] ? parseFloat(hours[1].replace(':', '')) * 3600 : 0;
        totalSeconds += minutes[1] ? parseFloat(minutes[1].replace(':', '')) * 60 : 0;
        totalSeconds += seconds[1] ? parseFloat(seconds[1].replace('m:', '')) : 0;
      }
    });
    if (totalSeconds > 0) {
      var hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      return hours + 'h:' + minutes + 'm:' + seconds + 's';
    }
    return '-';
  },
  formatTikTokPlayTime: function formatTikTokPlayTime(totalPlayTime) {
    return totalPlayTime.hour + 'h:' + totalPlayTime.minute + 'm:' + totalPlayTime.second + 's';
  },
  formatReelPlayTime: function formatReelPlayTime(totalPlayTime) {
    return totalPlayTime.day + 'd:' + totalPlayTime.hour + 'h:' + totalPlayTime.minute + 'm:' + totalPlayTime.second + 's';
  },
  parseTikTokPlayTime: function parseTikTokPlayTime(time) {
    var hours = time.match(/(.+?(?=h))/);
    var minutes = time.match(/(?::)(.*)(?=m)/);
    var seconds = time.match(/(?:m:)(.*)(?=s)/);
    var totalPlayTime = {
      hour: hours && hours[1] ? parseFloat(hours[1]) : 0,
      minute: minutes && minutes[1] ? parseFloat(minutes[1].replace(':', '')) : 0,
      second: seconds && seconds[1] ? parseFloat(seconds[1]) : 0
    };
    return totalPlayTime;
  },
  parseSecondsToHms: function parseSecondsToHms(totalSeconds) {
    totalSeconds = Number(totalSeconds);
    if (isNaN(totalSeconds) || totalSeconds < 0) {
      totalSeconds = 0;
    }
    totalSeconds = Math.floor(totalSeconds);

    var hour = Math.floor(totalSeconds / 3600);
    var minute = Math.floor(totalSeconds % 3600 / 60);
    var second = totalSeconds % 60;

    return {
      hour: hour,
      minute: minute,
      second: second
    };
  },
  parseReelPlayTime: function parseReelPlayTime(time) {
    var days = time.match(/(.+?(?=d))/);
    var hours = time.match(/(?::)(.*)(?=h)/);
    var minutes = time.match(/(?::)(.*)(?=m)/);
    var seconds = time.match(/(?:m:)(.*)(?=s)/);
    var totalPlayTime = {
      day: days && days[1] ? parseFloat(days[1]) : 0,
      hour: hours && hours[1] ? parseFloat(hours[1].replace(':', '')) : 0,
      minute: minutes && minutes[1] ? parseFloat(minutes[1].replace(':', '')) : 0,
      second: seconds && seconds[1] ? parseFloat(seconds[1]) : 0
    };
    return totalPlayTime;
  },
  showTikTokPlayTime: function showTikTokPlayTime(strTime) {
    var time = this.parseTikTokPlayTime(strTime);
    if (time.hour === 0) {
      strTime = strTime.replace('0h:', '');
    }
    if (time.minute === 0) {
      strTime = strTime.replace('0m:', '');
    }
    return strTime;
  },
  parseReelPlayTimeHrs: function parseReelPlayTimeHrs(time) {
    var hours = time.match(/(.+?(?=h))/);
    var minutes = time.match(/(?::)(.*)(?=m)/);
    var seconds = time.match(/(?:m:)(.*)(?=s)/);
    var totalPlayTime = {
      hour: hours && hours[1] ? parseFloat(hours[1].replace(':', '')) : 0,
      minute: minutes && minutes[1] ? parseFloat(minutes[1].replace(':', '')) : 0,
      second: seconds && seconds[1] ? parseFloat(seconds[1]) : 0
    };
    return totalPlayTime;
  },
  showReelPlayTime: function showReelPlayTime(strTime) {
    var time = this.parseReelPlayTimeHrs(strTime);
    strTime = strTime.replace('0d:', '');
    if (time.hour === 0) {
      strTime = strTime.replace('0h:', '');
    }
    if (time.minute === 0) {
      strTime = strTime.replace('0m:', '');
    }
    return strTime;
  },
  formatWatchTime: function formatWatchTime(watch) {
    watch = watch.toString();
    if (watch.includes('s')) {
      return parseFloat(watch.replace('s', ''));
    }
    return watch;
  },
  parseWatchTime: function parseWatchTime(watch) {
    watch = watch.toString();
    if (!watch.includes('s')) {
      return watch + 's';
    }
    return watch;
  },
  invokeReportOwnerCheck: function invokeReportOwnerCheck(context, payload) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(resolve) {
                  var response;
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].checkUserInCampaignReport(payload);

                        case 2:
                          response = _context2.sent;

                          if (!response.exists) {
                            context.$swal({
                              text: 'Influencer\'s content is empty in Campaign Report',
                              type: 'warning',
                              confirmButtonText: 'Continue'
                            }).then(function (result) {
                              if (result.value) {
                                resolve(false);
                              }
                            });
                          } else {
                            resolve(true);
                          }

                        case 4:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));

                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  checkPairingPayoutConfirm: function checkPairingPayoutConfirm(context, payload) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(resolve) {
                  var handle, platform, pairingID, campaign, pairedInfluencers, validated, match;
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          handle = payload.handle, platform = payload.platform, pairingID = payload.pairingID, campaign = payload.campaign, pairedInfluencers = payload.pairedInfluencers;
                          validated = true;
                          match = pairedInfluencers.find(function (p) {
                            if (pairingID) {
                              return p.pairingID === pairingID;
                            }
                            if (!platform) {
                              return p.instagramHandle === handle;
                            } else {
                              return p.instagramHandle === handle && p.platform === platform;
                            }
                          });

                          if (!match || match.payoutStatus !== __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].payoutStatus.CONFIRMED) validated = false;
                          if (!validated) {
                            context.$swal({
                              html: 'Please confirm payout for <b>' + campaign.name + '</b> - <b>@' + handle + '</b> ',
                              type: 'warning',
                              confirmButtonText: 'Continue',
                              showCancelButton: true,
                              cancelButtonText: 'Cancel'
                            }).then(function (result) {
                              if (result.value) {
                                resolve(false);
                              }
                            });
                          } else {
                            resolve(true);
                          }

                        case 5:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, this);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  customMediaConfig: function customMediaConfig(post) {
    var campaignType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (post.customMedia) return post.customMedia;
    var response = {
      type: null,
      publicID: null,
      videoID: null,
      URL: '',
      width: 'auto',
      height: 'auto',
      trans: {}
    };
    if (post.isMultipleContents || post.type === 'story' || post.isXHS || post.isLemon) {
      if (post.public_id) {
        if (post.internalView && post.thumbnail_url.includes('c_fill,h_320,w_320')) {
          response.type = 'v-img';
          response.URL = post.thumbnail_url;
        } else {
          response.type = post.media_type === 'image' ? 'cld-image' : 'cld-video';
          response.URL = post.embed_url;
          response.publicID = post.public_id;
          if (response.type === 'cld-image') {
            response.trans = {
              aspectRatio: '5:9',
              loading: 'lazy'
            };
            if (post.internalView) {
              response.width = '100%';
            } else {
              response.width = 320;
              response.height = 320;
            }
          }
          if (response.type === 'cld-video') {
            response.className = post.internalView ? '' : 'report-video';
            response.videoID = Math.floor(Math.random() * 1000);
          }
        }
      } else {
        response.URL = post.embed_url;
        response.width = '100%';
        response.height = '100%';
        if (campaignType && this.isAOKCampaign(campaignType)) {
          response.type = 'driveCustomView';
        } else {
          response.className = 'media-iframe list';
          response.type = 'gdrive';
        }
        if (post.internalView) {
          response.download = false;
        } else {
          response.download = true;
        }
        if (post.media_type) {
          if (post.media_type === 'video') {
            if (!post.htmlReport) {
              response.height = '300px';
            } else {
              response.width = '300px';
            }
            response.type = 'video';
          }
          if (post.media_type === 'image') {
            response.width = '300px';
            if (!post.htmlReport) {
              response.height = '300px';
            }
            response.type = 'v-img';
          }
        }
      }
    }
    post.customMedia = response;
    return post.customMedia;
  },
  customPostMediaConfig: function customPostMediaConfig(post) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var response = {
      type: null,
      publicID: null,
      videoID: null,
      URL: '',
      width: 'auto',
      height: 'auto',
      trans: {},
      detailView: false
    };

    if (post.publicID) {
      response.type = post.type === 'image' ? 'cld-image' : 'cld-video';
      response.URL = post.file || post.url;
      response.publicID = post.publicID;
      if (response.type === 'cld-image') {
        response.trans = {
          aspectRatio: '5:9',
          loading: 'lazy',
          fetchFormat: 'png'
        };
        response.width = '100%';
        if (options.trans) {
          response.trans = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, response.trans, options.trans);
        }
      }
      if (response.type === 'cld-video') {
        response.className = 'post-video';
        response.videoID = Math.floor(Math.random() * 1000);
        if (options.videoDownload) {
          response.download = true;
        }
        if (options.videoPreview) {
          response.preview = true;
        }
      }
    } else {
      if (post.preview) {
        response.file = post.file;
        response.preview = post.preview;
        if (post.file) {
          response.fileName = post.file.name;
        }
      }
      if (post.url && post.url.includes('s3-ap-southeast-1')) {
        response.URL = post.url;
        if (response.URL) {
          var n = response.URL.lastIndexOf('/');
          var result = response.URL.substring(n + 1);
          response.fileName = result;
        }
        if (post.isvideo) {
          response.isVideo = true;
        } else {
          response.isImage = true;
        }
      }
      if (options.videoDownload) {
        response.download = true;
      }
      if (options.videoPreview) {
        response.preview = true;
      }
    }
    if (options.overlay) response.overlay = true;
    if (options.overlayType) response.overlayType = options.overlayType;
    if (options.postView) response.postView = true;
    if (options.creatorView) response.creatorView = true;
    return response;
  },
  getReportDeliverables: function getReportDeliverables(posts) {
    var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';

    var deliverables = { IGP: 0, IGC: 0, IGS: 0, IGV: 0, IGR: 0, TTP: 0 };
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var post = _step3.value;

        if (deliverables[post.type] || deliverables[post.type] === 0) {
          deliverables[post.type] += 1;
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    if (fmt === 'object') return deliverables;
    var results = [];
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(deliverables)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var key = _step4.value;

        if (deliverables[key] > 0) {
          results.push(deliverables[key] + ' X ' + key);
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return results.join(', ');
  },
  getPostOutreachTotal: function getPostOutreachTotal(posts) {
    var outReach = 0;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var post = _step5.value;

        outReach += post.currentInsight && post.currentInsight.outreach ? post.currentInsight.outreach : 0;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return outReach;
  },
  getCampaignDurationMonths: function getCampaignDurationMonths(item) {
    if (!item.startDate || !item.endDate) return '';
    var formattedStartDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()(item.startDate).format('YYYY-MM');
    var formattedEndDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()(item.endDate).format('YYYY-MM');
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()(formattedEndDate).diff(formattedStartDate, 'months', true) + 1;
  },
  getMarkupCOGS: function getMarkupCOGS(ioNumber, client) {
    var _this5 = this;

    if (!ioNumber || !client) return false;
    var matchDeal = null;
    if (client.account) {
      if (client.account.deals) {
        matchDeal = client.account ? client.account.deals.find(function (deal) {
          return '' + _this5.cutIO(deal.IO) === _this5.cutIO(ioNumber);
        }) : false;
      }
    }
    if (matchDeal && matchDeal.markupCOGS) return matchDeal.cogsAmount;
    return false;
  },
  cutIO: function cutIO(IO) {
    var re = new RegExp('IO-', 'g');
    return IO.replace(re, '');
  },
  getMandatoryHashtagMentions: function getMandatoryHashtagMentions(campaign) {
    if (!campaign.angles) return '';
    var contentAngles = this.fixAnglesData(campaign.angles);
    var hasTagSet = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
    for (var i = 0; i < contentAngles.length; i++) {
      for (var j = 0; j < contentAngles[i].formats.length; j++) {
        var format = contentAngles[i].formats[j];
        if (format.mandatory && format.mandatory.length > 0) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(format.mandatory), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var mandatory = _step6.value;

              hasTagSet.add(mandatory);
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      }
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(hasTagSet).join(' ');
  },
  formatCountry: function formatCountry(countries, givenCountries) {
    var selectedCountries = [];
    if (typeof givenCountries === 'string') {
      givenCountries = [givenCountries];
    }
    if (!Array.isArray(countries) && !Array.isArray(givenCountries)) return selectedCountries;
    if (givenCountries) {
      countries.map(function (item) {
        givenCountries.map(function (country) {
          if (item.code === country) {
            selectedCountries.push(item);
          }
        });
      });
    }
    return selectedCountries;
  },
  getProductName: function getProductName(itemName) {
    if (itemName === 'aok') {
      return 'AOK/Uncut';
    }
    return itemName;
  },
  getStageName: function getStageName(status) {
    if (status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus.DRAFT || status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL) {
      return __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStage.ACTIVATING;
    } else if (status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus.PAIRING_BRIEF || status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER || status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus.RATE_CARD) {
      return __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStage.PAIRING;
    } else if (status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus.ONGOING) {
      return __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStage.COCREATING;
    } else {
      return __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStage.COMPLETE;
    }
  },
  getOrderedColumns: function getOrderedColumns(columnDefs, currentStatus, defaultStatus) {
    var currentOrder = [];
    var currentKeys = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

    if (currentStatus && __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(currentStatus).length > 0) {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(currentStatus).forEach(function (key) {
        var colDef = columnDefs.find(function (c) {
          return c.name === key;
        });
        if (colDef) {
          currentOrder.push({
            title: colDef.label,
            key: key,
            value: currentStatus[key]
          });
          currentKeys.add(key);
        }
      });
    }

    columnDefs.forEach(function (colDef) {
      if (!currentKeys.has(colDef.name)) {
        currentOrder.push({
          title: colDef.label,
          key: colDef.name,

          value: defaultStatus.hasOwnProperty(colDef.name) ? defaultStatus[colDef.name] : false
        });
        currentKeys.add(colDef.name);
      }
    });
    return currentOrder;
  },
  calculatePostData: function calculatePostData(post, index) {
    var platform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_reportPlatform__["a" /* getReportPlatform */])(post);
    var isLinkedIn = platform === 'linkedin';
    var isTwitter = platform === 'twitter';
    var postData = {};
    postData.campaign = post.campaign || {};
    postData.id = post.id;
    postData.key = index;
    postData.lineUpIndex = post.lineUpIndex;
    postData.profileUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_reportPlatform__["b" /* getReportProfileUrl */])(post, platform || (post.isTikTok ? 'tiktok' : 'instagram'));
    if (post.isCalculated) {
      return post;
    }
    if (!isLinkedIn && !isTwitter && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isFacebook && !post.isOthers) {
      if (post.post_details) {
        if (post.post_details.owner) {
          postData.name = post.post_details.owner.username;
          postData.engagement_rate_sd = post.post_details.owner.engagement_rate_sd || null;
        }
        postData.url = post.post_details.link;
      }
      postData.title = 'IG Post';
      postData.impressions = 0;
      if (post.currentInsight) {
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
      }
      postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
      postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
      postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
      if (post.postType === 'IGR') {
        postData.type = 'reel';
        postData.title = 'IG Reel';
      } else {
        postData.type = 'post/carousel';
        postData.title = 'IG Post';
      }
      postData.postType = postData.postType || postData.type;

      if (post.inputtedInsights) {
        postData.saved = post.inputtedInsights.saved;
        postData.shares = post.inputtedInsights.shares;
        postData.views = post.inputtedInsights.views || 0;
        postData.reach = post.inputtedInsights.reach || 0;
        postData.impressions = post.inputtedInsights.impressions || 0;
      } else {
        postData.saved = post.graphInsight ? post.graphInsight.saved : 0;
        postData.shares = 0;
        postData.views = 0;
      }
      postData.new_engagement_rate = Number(((postData.likes + postData.comments + postData.saved + postData.shares) / postData.outreach * 100).toFixed(2));
      postData.new_engagement_rate_view = Number((postData.views / postData.outreach * 100).toFixed(2));
      postData.engagement_rate_reach = Number(((postData.likes + postData.comments + postData.saved + postData.shares) / postData.reach * 100).toFixed(2));
      postData.interactions = (postData.likes || 0) + (postData.comments || 0) + (postData.saved || 0) + (postData.shares || 0);
    } else if (post.isStory && post.insights) {
      postData.name = post.owner.username;
      postData.outreach = post.owner.followers || post.owner.followers_sd;
      postData.title = 'IG Story';
      postData.url = post.media_url || 'https://app.getkobe.com/static/img/kobe_white.png';
      postData.engagement = Number(post.insights.engagement) || 0;
      postData.impressions = Number(post.insights.impressions) || 0;
      postData.reach = Number(post.insights.reach) || 0;
      postData.replies = Number(post.insights.replies) || 0;
      postData.exits = Number(post.insights.exits) || 0;
      postData.taps_back = Number(post.insights.taps_back) || 0;
      postData.taps_forward = Number(post.insights.taps_forward) || 0;
      postData.shares = Number(post.insights.shares) || 0;
      postData.sticker_taps = Number(post.insights.sticker_taps) || 0;
      postData.link_clicks = Number(post.insights.link_clicks) || 0;
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
      postData.type = 'story';
      postData.postType = postData.postType || postData.type;
      postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1;
      postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps;
      postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
      postData.public_id = post.public_id || null;
    } else if (post.isTikTok) {
      postData.name = post.owner.username;
      postData.title = 'TikTok Post';
      if (post.post_details) {
        postData.url = post.post_details.link;
        postData.shortCode = post.post_details.shortcode;
      }
      postData.impressions = 0;
      postData.engagement = post.currentInsight.engagement || 0;
      postData.reach = 0;
      postData.likes = post.currentInsight.like_count || 0;
      postData.comments = post.currentInsight.comment_count || 0;
      postData.shares = post.currentInsight.shares || 0;
      postData.views = post.currentInsight.views || 0;
      postData.outreach = post.currentInsight.outreach || 0;
      postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
      postData.engagement_rate_sd = post.owner.engagement_rate_sd || null;
      postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
      postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
      postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      postData.type = 'tiktok';
      postData.postType = postData.postType || postData.type;

      if (post.inputtedInsights) {
        postData.saved = post.inputtedInsights.saved;
        if (postData.shares === 0) {
          postData.shares = post.inputtedInsights.shares;
        }
        if (postData.views === 0) {
          postData.views = post.inputtedInsights.views || 0;
        }
        postData.reach = post.inputtedInsights.reach || 0;
        postData.impressions = post.inputtedInsights.impressions || 0;
        postData.plays = post.inputtedInsights.plays || 0;
        postData.watches = post.inputtedInsights.watches ? __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].parseWatchTime(post.inputtedInsights.watches) : 0;
        postData.watchedFullVideo = post.inputtedInsights.watchedFullVideo || 0;
      } else {
        postData.saved = post.graphInsight ? post.graphInsight.saved : 0;
        postData.shares = 0;
        postData.views = 0;
        postData.reach = 0;
        postData.impressions = 0;
        postData.plays = 0;
        postData.watches = 0;
      }
      postData.new_engagement_rate = (((postData.likes || 0) + (postData.comments || 0) + (postData.shares || 0)) / (postData.outreach || 0) * 100).toFixed(2);
      postData.interactions = Number((postData.likes || 0) + (postData.comments || 0) + (postData.saved || 0) + (postData.shares || 0));
      postData.interaction_rate_plays = 0;
      postData.eng_rate_total_viewers = 0;
      if (post.views) {
        postData.interaction_rate_plays = (((postData.likes || 0) + (postData.comments || 0) + (postData.shares || 0)) / Number(postData.views) * 100).toFixed(2);
        postData.eng_rate_total_viewers = (((postData.likes || 0) + (postData.comments || 0) + (postData.saved || 0) + (postData.shares || 0)) / Number(postData.reach) * 100).toFixed(2);
      }
      postData.new_engagement_rate_view = Number((postData.views / postData.outreach * 100).toFixed(2));
    } else if (post.isYoutube) {
      postData.name = post.owner.username;
      postData.title = 'Youtube Post';
      if (post.post_details) {
        postData.url = post.post_details.link;
        postData.shortCode = post.post_details.shortcode;
      }
      postData.type = 'youtube';
      postData.postType = postData.postType || postData.type;
      postData.impressions = 0;
      postData.engagement = post.currentInsight.engagement || 0;
      postData.reach = 0;
      postData.likes = post.currentInsight.like_count || 0;
      postData.comments = post.currentInsight.comment_count || 0;
      postData.views = post.currentInsight.views || 0;
      postData.outreach = post.currentInsight.outreach || 0;
      postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
      postData.engagement_rate_sd = post.owner.engagement_rate_sd || null;
      postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
      postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
      postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      postData.new_engagement_rate = (((postData.likes || 0) + (postData.comments || 0)) / (postData.outreach || 0) * 100).toFixed(2);
    } else if (post.isFacebook && post.insights) {
      postData.name = post.owner.username;
      postData.outreach = post.owner.followers || post.owner.followers_sd;
      postData.title = 'Facebook';
      postData.url = post.media_url || 'https://app.getkobe.com/static/img/kobe_white.png';
      postData.outreach = Number(post.insights.outreach) || 0;
      postData.like_count = Number(post.insights.like_count) || 0;
      postData.comment_count = Number(post.insights.comment_count) || 0;
      postData.views = Number(post.insights.views) || 0;
      postData.shares = Number(post.insights.shares) || 0;
      postData.bookmarks = Number(post.insights.bookmarks) || 0;
      postData.interactions = (postData.like_count || 0) + (postData.comment_count || 0) + (postData.bookmarks || 0) + (postData.shares || 0);
      postData.type = 'facebook';
    } else if (post.isXHS && post.insights) {
      postData.name = post.owner.username;
      postData.outreach = post.owner.followers || post.owner.followers_sd;
      postData.title = 'XHS';
      postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
      postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
      postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
      postData.xhsLink = post.xhsLink || '';
      postData.outreach = Number(post.insights.outreach) || 0;
      postData.like_count = Number(post.insights.like_count) || 0;
      postData.comment_count = Number(post.insights.comment_count) || 0;
      postData.views = Number(post.insights.views) || 0;
      postData.shares = Number(post.insights.shares) || 0;
      postData.bookmarks = Number(post.insights.bookmarks) || 0;
      postData.type = 'xhs';
      postData.isXHS = true;
      postData.interactions = (postData.like_count || 0) + (postData.comment_count || 0) + (postData.bookmarks || 0) + (postData.shares || 0);
    } else if ((isLinkedIn || isTwitter || post.isOthers) && post.insights) {
      var latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
      var insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights;
      var insights = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});
      postData.name = post.owner.username;
      postData.outreach = Number(insights.outreach) || Number(post.owner.followers || post.owner.followers_sd) || 0;
      postData.title = isLinkedIn ? 'LinkedIn Post' : isTwitter ? 'X (Twitter) Post' : 'Other Post';
      postData.url = post.post_details ? post.post_details.link : '';
      postData.like_count = Number(insights.like_count) || 0;
      postData.comment_count = Number(insights.comment_count) || 0;
      postData.impressions = Number(insights.impressions != null ? insights.impressions : isTwitter ? insights.views : 0) || 0;
      postData.views = isTwitter ? postData.impressions : Number(insights.views) || 0;
      postData.reach = Number(insights.reach != null ? insights.reach : isLinkedIn ? insights.outreach : 0) || 0;
      postData.shares = Number(insights.shares) || 0;
      postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0;
      postData.saved = postData.bookmarks;
      postData.interactions = postData.like_count + postData.comment_count + postData.bookmarks + postData.shares;
      postData.type = isLinkedIn ? 'linkedin' : isTwitter ? 'twitter' : 'others';
      postData.postType = postData.postType || (isLinkedIn ? 'LIP' : isTwitter ? 'XTP' : 'Others');
    } else if (post.isMultipleContents) {
      postData.name = post.owner.username;
      postData.outreach = post.owner.followers || post.owner.followers_sd;
      postData.title = 'IG Story';
      postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
      postData.type = 'gdrive';
      postData.postType = postData.postType || 'story';
      postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
      postData.public_id = post.public_id || null;
      postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
      if (post.insights) {
        postData.engagement = Number(post.insights.engagement) || 0;
        postData.impressions = Number(post.insights.impressions) || 0;
        postData.reach = Number(post.insights.reach) || 0;
        postData.replies = Number(post.insights.replies) || 0;
        postData.exits = Number(post.insights.exits) || 0;
        postData.taps_back = Number(post.insights.taps_back) || 0;
        postData.taps_forward = Number(post.insights.taps_forward) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.sticker_taps = Number(post.insights.sticker_taps) || 0;
        postData.link_clicks = Number(post.insights.link_clicks) || 0;
        postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1;
        postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps;
      }
    }
    postData.live_date = post.live_date ? __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.formatDate(post.live_date) : '-';
    postData.isCalculated = true;
    return postData;
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialCodes_json__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialCodes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__dialCodes_json__);



var _pairingStatusDisplay, _payoutStatusDisplay, _campaignStatusDispla, _postStatusDisplay, _clientPaymentStatusD, _approve, _pairingSendStatusDis, _dashboardStatusDispl, _approval, _activation;





var userGenders = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userGenders;
var campaignStatus = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatus;

var pairingStatus = {
  NEW: 0,
  ELIMINATION_PENDING: 1,
  APPROVED: 2,
  INVITED: 3,
  INTERESTED: 4,
  NOT_INTERESTED: 5,
  ACCEPTED: 6,
  NOT_ACCEPTED: 7,
  INQUIRY: 8
};

var eliminationStatus = {
  NEW: 0,
  PENDING: 3,
  SELECTED: 1,
  ELIMINATED: 2
};

var pairingStatusDisplay = (_pairingStatusDisplay = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.NEW, 'New'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.ELIMINATION_PENDING, 'In Elimination'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.APPROVED, 'Approved'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.INVITED, 'Invited'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.INTERESTED, 'Interested'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.NOT_INTERESTED, 'Not Interested'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.ACCEPTED, 'Accepted'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.NOT_ACCEPTED, 'Not Accepted'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingStatusDisplay, pairingStatus.INQUIRY, 'Inquiry'), _pairingStatusDisplay);

var payoutStatus = {
  PENDING: 0,
  INCOMPLETE: 1,
  SUBMITTED: 3,
  CONFIRMED: 2
};

var payoutStatusDisplay = (_payoutStatusDisplay = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payoutStatusDisplay, payoutStatus.PENDING, 'Pending Payout'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payoutStatusDisplay, payoutStatus.INCOMPLETE, 'Incomplete Payout'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payoutStatusDisplay, payoutStatus.SUBMITTED, 'Payout Submitted'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payoutStatusDisplay, payoutStatus.CONFIRMED, 'Payout Confirmed'), _payoutStatusDisplay);

var campaignStatusDisplayForClients = (_campaignStatusDispla = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.DRAFT, 'Draft'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.PENDING_CLIENT_APPROVAL, 'Pending'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.PAIRING_BRIEF, 'Approved'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.PAIRING_INFLUENCER, 'Pairing Influencers'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.RATE_CARD, 'On Going'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.ONGOING, 'On Going'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.REVIEW, 'Review'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_campaignStatusDispla, campaignStatus.COMPLETE, 'Completed'), _campaignStatusDispla);

var postStatus = {
  DRAFT: 0,
  AD_STRATEGIST_PENDING: 1,
  AD_STRATEGIST_REJECT: 2,
  CLIENT_PENDING: 3,
  CLIENT_REJECT: 4,
  CLIENT_APPROVE: 5,
  LIVE: 6
};

var paymentStatus = {
  NEW: 0,
  PAID: 1,
  UNPAID: 2,
  PROCESSING: 3,
  ERROR: 4,
  PARTIAL: 5,
  APPROVAL_FINANCE: 6,
  APPROVAL_LEAD: 7,
  RELEASED_FINANCE: 8
};

var paymentConsExportTypes = {
  CO: 1,
  FINANCE: 2
};

var paymentConsSectionIDs = {
  IMPORTED: 'imported',
  BATCH_ONE: 'b1',
  BATCH_TWO: 'b2',
  APPROVAL_FINANCE: 'approvalFinance',
  APPROVAL_LEAD: 'approvalLead',
  WIP_FINANCE: 'partial',
  PAID: 'completed'
};

var postStatusDisplay = (_postStatusDisplay = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplay, postStatus.DRAFT, 'Draft'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplay, postStatus.AD_STRATEGIST_PENDING, 'Pending AS approval'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplay, postStatus.CLIENT_PENDING, 'Pending client approval'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplay, postStatus.CLIENT_APPROVE, 'Client approved'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplay, postStatus.LIVE, 'Post is live'), _postStatusDisplay);

var imsStatuses = {
  NEW: {
    text: 'Please confirm payout',
    value: 0
  },
  SUBMITTED: {
    text: 'Submitted',
    value: 1
  },
  NOT_SUBMITTED: {
    text: 'Not Submitted',
    value: 2
  }
};

var clientPaymentStatus = {
  UNPAID: 0,
  PENDING: 1,
  PAID: 2
};

var tableActions = [{
  name: 'Change Status',
  action: 'changeStatus',
  icon: 'arrow-left-right'
}, {
  name: 'Delete',
  action: 'deleteCampaign',
  icon: 'delete'
}, {
  name: 'Archive',
  action: 'archiveCampaign',
  icon: 'archive'
}];

var clientPaymentStatusDisplay = (_clientPaymentStatusD = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_clientPaymentStatusD, clientPaymentStatus.UNPAID, 'Unpaid'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_clientPaymentStatusD, clientPaymentStatus.PENDING, 'Pending'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_clientPaymentStatusD, clientPaymentStatus.PAID, 'Paid'), _clientPaymentStatusD);

var userGenderDisplay = [{
  value: userGenders.NON_BINARY,
  text: 'No preference'
}, {
  value: userGenders.MALE,
  text: 'Male'
}, {
  value: userGenders.FEMALE,
  text: 'Female'
}];

var targetAudience = {
  AGE: {
    GROUP_A: '13-17',
    GROUP_B: '18-24',
    GROUP_C: '25-34',
    GROUP_D: '35-44',
    GROUP_E: '45-64'
  },
  GENDER: {
    FEMALE: 'Female',
    MALE: 'Male',
    NO_PREFERENCE: '-'
  },
  LOCATION: {
    SINGAPORE: 'SG',
    THAILAND: 'TH',
    INDONESIA: 'ID',
    PHILIPPINES: 'PH',
    VIETNAM: 'VN',
    MALAYSIA: 'MY',
    HONGKONG: 'HK',
    NO_PREFERENCE: ''
  }
};

var targetAudienceDisplay = {
  AGE: [{
    value: targetAudience.AGE.GROUP_A,
    text: '13 - 17'
  }, {
    value: targetAudience.AGE.GROUP_B,
    text: '18 - 24'
  }, {
    value: targetAudience.AGE.GROUP_C,
    text: '25 - 34'
  }, {
    value: targetAudience.AGE.GROUP_D,
    text: '35 - 44'
  }, {
    value: targetAudience.AGE.GROUP_E,
    text: '45 - 64'
  }],
  GENDER: [{
    value: targetAudience.GENDER.FEMALE,
    text: 'Female'
  }, {
    value: targetAudience.GENDER.MALE,
    text: 'Male'
  }, {
    value: targetAudience.GENDER.NO_PREFERENCE,
    text: 'No Preference'
  }],
  LOCATION: [{
    value: targetAudience.LOCATION.SINGAPORE,
    text: 'Singapore'
  }, {
    value: targetAudience.LOCATION.THAILAND,
    text: 'Thailand'
  }, {
    value: targetAudience.LOCATION.INDONESIA,
    text: 'Indonesia'
  }, {
    value: targetAudience.LOCATION.PHILIPPINES,
    text: 'Philippines'
  }, {
    value: targetAudience.LOCATION.VIETNAM,
    text: 'Vietnam'
  }, {
    value: targetAudience.LOCATION.MALAYSIA,
    text: 'Malaysia'
  }, {
    value: targetAudience.LOCATION.HONGKONG,
    text: 'Hong Kong'
  }],
  PLATFORM: [{
    value: 'Instagram',
    text: 'Instagram'
  }, {
    value: 'Tiktok',
    text: 'Tiktok'
  }, {
    value: 'Youtube',
    text: 'Youtube'
  }, {
    value: 'LinkedIn',
    text: 'LinkedIn'
  }, {
    value: 'Twitter',
    text: 'X (Twitter)'
  }, {
    value: 'Blog',
    text: 'Blog'
  }, {
    value: 'Discord',
    text: 'Discord'
  }, {
    value: 'Twitch',
    text: 'Twitch'
  }, {
    value: 'Others',
    text: 'Others'
  }]
};

var userSegment = {
  BRAND_FIT: 'Brand Fit',
  CONTENT_FIT: 'Content Fit',
  ENGAGEMENT_FIT: 'Engagement Fit'
};

var userSegmentDisplay = [{
  value: userSegment.BRAND_FIT,
  text: 'Brand Fit'
}, {
  value: userSegment.CONTENT_FIT,
  text: 'Content Fit'
}, {
  value: userSegment.ENGAGEMENT_FIT,
  text: 'Engagement Fit'
}];

var actionRequired = {
  TIME: {
    LESS_1_HOUR: 0,
    MORE_1_HOUR: 1
  },
  ACTION: {
    RECEIVE: 0,
    COLLECT: 1,
    VISIT_WEB: 2,
    VISIT_INTERACT: 3,
    IN_DEPTH: 4
  },
  RECEIVE: {
    NA: 0,
    PRODUCT: 1,
    EXPERIENCE: 2
  },
  VALUE: {
    NA: 0,
    LESS_50: 1,
    MORE_50: 2
  }
};

var actionRequiredDisplay = {
  TIME: [{
    value: actionRequired.TIME.LESS_1_HOUR,
    text: '< 1 hour'
  }, {
    value: actionRequired.TIME.MORE_1_HOUR,
    text: '> 1 hour'
  }],
  ACTION: [{
    value: actionRequired.ACTION.RECEIVE,
    text: 'Receive Something'
  }, {
    value: actionRequired.ACTION.COLLECT,
    text: 'Collect Something'
  }, {
    value: actionRequired.ACTION.VISIT_WEB,
    text: 'Visit website/app/share past photo/stories/phone call'
  }, {
    value: actionRequired.ACTION.VISIT_INTERACT,
    text: 'Visit + Minimal Interaction'
  }, {
    value: actionRequired.ACTION.IN_DEPTH,
    text: 'In-depth Experience'
  }],
  RECEIVE: [{
    value: actionRequired.RECEIVE.NA,
    text: 'N/A'
  }, {
    value: actionRequired.RECEIVE.PRODUCT,
    text: 'Product'
  }, {
    value: actionRequired.RECEIVE.EXPERIENCE,
    text: 'Experience'
  }],
  VALUE: [{
    value: actionRequired.VALUE.NA,
    text: 'N/A'
  }, {
    value: actionRequired.VALUE.LESS_50,
    text: '< $50'
  }, {
    value: actionRequired.VALUE.MORE_50,
    text: '> $50'
  }]
};

var campaignActivationStatus = {
  ACTIVATED: 1,
  DEACTIVATED: 0
};

var campaignStatusFlow = {
  approve: (_approve = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approve, campaignStatus.DRAFT, [campaignStatus.PENDING_CLIENT_APPROVAL]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approve, campaignStatus.PENDING_CLIENT_APPROVAL, [campaignStatus.PAIRING_BRIEF]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approve, campaignStatus.PAIRING_BRIEF, [campaignStatus.PAIRING_INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approve, campaignStatus.PAIRING_INFLUENCER, [campaignStatus.ONGOING]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approve, campaignStatus.ONGOING, [campaignStatus.COMPLETE]), _approve)
};

var queryType = {
  EQUAL: 1,
  LIKE: 2
};

var campaignModelSectionType = {
  CAMPAIGN_SUMMARY: 1,
  CONTENT_ANGLE: 2,
  INFLUENCER_SELECTION: 3,
  BUDGET_ALLOCATION: 4,
  VIDEO_BRIEF: 5,
  EVENT_BRIEF: 6
};

var pairingBriefModelSectionType = {
  CAMPAIGN_SUMMARY: 1,
  CAMPAIGN_DETAILS: 2
};

var campaignType = {
  NO_PREFERENCE: 'No Preference',
  STORY_TELL: 'Storytell',
  AMPLIFY: 'Amplify',

  AOK: 'AOK/Uncut',
  Others: 'Others',
  LoadingFees: 'Loading Fees'
};

var campaignTypeDisplay = [{
  value: campaignType.STORY_TELL,
  text: 'Storytell'
}, {
  value: campaignType.AMPLIFY,
  text: 'Amplify'
}, {
  value: campaignType.AOK,
  text: 'AOK/Uncut'
}, {
  value: campaignType.Others,
  text: 'Others'
}, {
  value: campaignType.LoadingFees,
  text: 'Loading Fees'
}];

var bfsTypes = {
  STORY_TELL: 'Storytell',
  AOK: 'KOBE Uncut',
  UGC: 'UGC',
  KOBE_LITE: 'KOBE Lite'
};

var campaignStage = {
  ALL: 'All',
  ACTIVATING: 'Activating',
  PAIRING: 'Pairing',
  COCREATING: 'Co-Creating',
  REVIEW: 'Review',
  COMPLETE: 'Complete'
};

var campaignStageDisplay = [{
  value: campaignType.ALL,
  text: 'All'
}, {
  value: campaignType.ACTIVATING,
  text: 'Activating'
}, {
  value: campaignType.PAIRING,
  text: 'Pairing'
}, {
  value: campaignType.COCREATING,
  text: 'Co-Creating'
}, {
  value: campaignType.REVIEW,
  text: 'Review'
}, {
  value: campaignType.COMPLETE,
  text: 'Complete'
}];

var pairingSendStatus = {
  DRAFT: 0,
  SENT: 1,
  SIGNED: 3
};

var pairingSendStatusDisplay = (_pairingSendStatusDis = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingSendStatusDis, pairingSendStatus.DRAFT, 'Draft'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingSendStatusDis, pairingSendStatus.SENT, 'Sent'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_pairingSendStatusDis, pairingSendStatus.SIGNED, 'Signed'), _pairingSendStatusDis);

var dashboardStatuses = {
  pendingAM: 1,
  pendingCC: 2,
  pendingCCShortList: 3,
  pendingAMRelease: 4,
  pendingAdmin: 5,
  pendingClient: 6
};

var dashboardStatusDisplay = (_dashboardStatusDispl = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dashboardStatusDispl, dashboardStatuses.pendingAM, 'Pending AM\'s set up'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dashboardStatusDispl, dashboardStatuses.pendingCC, 'Pending CC\'s approval'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dashboardStatusDispl, dashboardStatuses.pendingCCShortList, 'Pending CC\'s shortlist'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dashboardStatusDispl, dashboardStatuses.pendingAMRelease, 'Pending AM\'s release to client'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dashboardStatusDispl, dashboardStatuses.pendingAdmin, 'Pending admin\'s approval'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dashboardStatusDispl, dashboardStatuses.pendingClient, 'Pending client\'s approval'), _dashboardStatusDispl);

var campaignConfirmation = {
  approval: (_approval = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, campaignStatus.DRAFT, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, campaign will be pending client appoval',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'The campaign is now pending client approval'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, campaignStatus.PENDING_CLIENT_APPROVAL, {
    confirmation: {
      title: 'Terms and Conditions',
      html: '<div style=\'text-align:left;margin-top:20px;height: 350px;overflow:auto;\'><p>Terms and Conditions (Extract)<br/>\n               Full Terms and Conditions: <a target=\'_blank\' href=\'http://www.getkobe.com/advertiser-tnc/\'>www.getkobe.com/advertiser-tnc</a></p>\n               <p>\n               These terms and conditions (the \u201CTerms and Conditions\u201D) are incorporated into the\n               agreement entered into between Kobe Global Technologies Pte Ltd (UEN:\n               201608755R) (\u201CKOBE\u201D) and the Client through the e-Quote.\n               The Quote and these Terms and Conditions will be collectively referred to as the\n               \u201CAgreement\u201D.\n               </p>\n               <h4>Services and Deliverables</h4>\n               <p>\n               1.1 KOBE will furnish to the Client the Campaign Brief and Content Creator Line Up\n               described in the Quote, for the purposes of the Campaign. Guaranteed Deliverables\n               presented in this quote refers to the total Deliverables for the entire Campaign.\n               </p>\n               <p>\n               1.2 KOBE will use reasonable endeavors to furnish the Campaign Brief and Content\n               Creator Line Up in accordance with the specifications in the Quote, as well as in\n               accordance with any feedback and any reasonable additional instructions (whether\n               written or verbal) given to KOBE by the Client or by an authorized representative of\n               the Client.\n               </p>\n               <p>\n               1.3 Client reserves the right to request for refund for unmet Deliverables if\n               Guaranteed Deliverables stated in Quote is not achieved.\n               </p>\n               <h4>Amendments and Alterations</h4>\n               <p>\n               1.4 If Client decides to select Content Creators out of KOBE\u2019s AI technology system,\n               the Guaranteed Deliverables will no longer be guaranteed.\n               </p>\n               <p>\n               1.5 Once the Campaign Brief and Content Creator Line Up have been furnished in\n               the manner set out at clause 1.2 above, the Client must, not later than <b><u>three days</u></b>\n               from the date of delivery (the \u201CResponse Period\u201D), provide KOBE with confirmation\n               on KOBE Influencer Management System (\u201CIMS\u201D) as to whether the Client has\n               approved or disapproved the Campaign Brief and Content Creator Line Up. In the\n               event that the Client fails to give such notice within the Response Period, the Client\n               will be deemed to have approved the Campaign Brief and Content Creator Line Up.\n               In the event that the Client gives notice of disapproval on the IMS, the Client must\n               state with specificity the details of any reasonable alteration or amendments that the\n               Client reasonably requires.\n               </p>\n               <p>\n               1.6 If the Campaign Brief and Content Creator Line Up have been produced in the\n               manner set out at clause 1.2 above, Content Creator will only do <b><u>1 shoot</u></b> and has\n               full creative rights to the final execution of the post. KOBE will provide no more than\n               <b><u>two rounds</u></b> of alterations or amendments, at no further increase in Fee, provided\n               that such changes do not involve a material change in the specifications.\n               </p>\n               <p>\n               1.7 To avoid doubt, the following alterations and amendments will be deemed to\n               involve a material change for the purposes of clause 1.6 above:<br/>\n               a. eliminating more than <b><u>20%</u></b> of Content Creator Line Up;<br/>\n               b. any change in the <b><u>content format</u></b> of the Deliverables;<br/>\n               c. <b><u>re-shooting</u></b> the content in whole\n               </p>\n               <p>\n               1.8 Should the Client reasonably require any further rounds of alterations or\n               amendments beyond the two provided for in clause 1.6 above, or any alterations or\n               amendments involving a material change in the specifications, KOBE has the right to\n               charge a fee for each round of alterations or amendments. The quantum of such a\n               fee is to be determined by KOBE, entirely at KOBE\u2019s discretion.\n               Any reshoots are chargeable at 100% of the Fees.\n               </p>\n               <p>\n               1.9 For the purposes of clauses 1.5 and 1.7 above, each consolidated request for\n               alterations or amendments (e.g. 1 st instruction of edit on IMS for Campaign Brief and\n               Report Abuse in Content Creator Draft Vetting Stage) is regarded as a request for\n               one round of alterations and amendments. Each additional request (e.g. additional\n               comment after 1 st instruction of edit on IMS for Campaign Brief or Report Abuse in\n               Content Creator Draft Vetting Stage) is regarded as a request for an additional round\n               of alterations and amendments.\n               </p>\n               <h4>Posting of Content on Social Media Platforms</h4>\n               <p>\n               1.10 KOBE Content Creator will post the content on the date mutually agreed on by\n               the Parties in this Agreement. Should the Client, after the date of this Agreement,\n               request to change the launch date, KOBE will have the right to charge an additional\n               fee for each request. The quantum of such a fee is to be determined by KOBE,\n               entirely at KOBE\u2019s discretion.<br/>\n               Reshoots are chargeable at 100% of the fees.\n               </p>\n               <p>\n               1.11 Copyright of the content created (artistic, literary, musical or dramatic) belongs\n               to the Content Creator.\n               </p>\n               <p>\n               1.12 Client shall be allowed to share and/or re-post the content(s) on its official social\n               media platform(s) provided:<br/>\n               a. the content(s) is shared/re-posted (as the case may be) on the same platform it\n               was originally posted on with acknowledgement and credit to Content Creator;<br/>\n               b. the content(s) is shared/re-posted (as the case may be) in its entirety with no\n               adaptation to the photo, video or caption;<br/>\n               c. the content(s) is not shared/re-posted for purposes other than to publicise the\n               Campaign;<br/>\n               d. the Client shall remove the shared or re-posted content(s) if instructed by the\n               Company; and<br/>\n               e. the Client does not boost the content(s) via media ads.\n               </p>\n               1.13 The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. \n               The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.<br/>\n               </div>',
      confirmText: 'AGREE AND CONTINUE',
      cancelText: 'Cancel',
      type: 'info',
      input: 'checkbox'
    },
    confirm: {
      title: 'Approved',
      text: 'You have successfully approved this campaign brief.'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, campaignStatus.PAIRING_BRIEF, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, pairing brief will be confirmed',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Done',
      text: 'You have submitted the pairing brief'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, campaignStatus.PAIRING_INFLUENCER, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the campaign will officially start',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Done',
      text: 'The campaign is live now'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, campaignStatus.ONGOING, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the campaign will be closed immediately',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'warning'
    },
    confirm: {
      title: 'Done',
      text: 'The campaign has stopped'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, campaignStatus.REVIEW, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the campaign will be closed immediately',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'warning'
    },
    confirm: {
      title: 'Done',
      text: 'The campaign has stopped'
    }
  }), _approval),
  activation: (_activation = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_activation, campaignActivationStatus.ACTIVATED, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the campaign will be activated',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'warning'
    },
    confirm: {
      title: 'Done',
      text: 'The campaign has been activated'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_activation, campaignActivationStatus.DEACTIVATED, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the campaign will be deactivated',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'warning'
    },
    confirm: {
      title: 'Done',
      text: 'The campaign has been deactivated'
    }
  }), _activation),
  termsAndCondition: {
    title: 'Terms & Conditions',
    html: '\n      <ol class="text-left body-1">\n        <li>Parties hereby agree that the guaranteed deliverables will no longer be a deliverable should the client decide to select influencers out of Kobe\'s AI technology system.</li>\n        <li>Post will not include any direct sales (eg product code promotion) or client link in bio unless otherwise agreed.</li>\n        <li>Content creator will only do 1 shoot based on brief approved by client and has full creative rights to the final execution of the post. Drafts will be sent to clients for the purpose of fact-checking. Stylistic changes are not allowed. Clients will be entitled to one revision.</li>\n      </ol>',
    confirmButtonText: 'Agree',
    cancelButtonText: 'Disagree'
  },
  pairingTermsAndCondition: {
    title: 'Terms & Conditions',
    html: '\n      <ol class="text-left body-1">\n        <li>You will be able to eliminate 20% of this list</li>\n        <li>Please avoid any subjective biasness during this process</li>\n        <li>Influencers have been screened and paired according to your brief requirements and their social data</li>\n        <li>Influencers are not confirmed, they will be invited after you have given your approval</li>\n        <li>Influencers will then decide if they would like to accept/reject this campaign</li>\n        <li>In situations where there are high rejection rates from influencer, a new list will be added</li>\n        <li>Please provide reason for elimination to facilitate our pairing process, if any</li>\n      </ol>',
    confirmButtonText: 'Agree',
    cancelButtonText: 'Disagree'
  },
  influencerContractTermsAndCondition: {
    title: 'Terms and Conditions',
    html: '\n      <ol>\n        <li>I have read and accepted the terms of use.</li>\n        <li>I have read and understood supporting campaign details that accompany this brief.</li>\n        <li>I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.</li>\n        <li>I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.</li>\n        <li>I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.</li>\n        <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>\n        <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline.</li>\n        <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.</li>\n        <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>\n        <li>The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.</li>\n      </ol>',
    confirmButtonText: 'Accept',
    cancelButtonText: 'Decline'
  },
  confirmPayout: {
    title: 'Confirm!',
    html: '<p style="font-weight:600">Are you sure you want to confirm payout?</p>\n    <p style="font-weight:600">After payout is confirmed the status will be changed to Sent and payment status will be changed to Processing.</p>',
    htmlAOK: '<p style="font-weight:600">Are you sure you want to confirm payout?</p>\n    <p style="font-weight:600">After payout is confirmed the status will be changed to Sent and payment status will be changed to Processing.</p>',
    confirmButtonText: 'Confirm'
  },
  cancelPayout: {
    title: 'Cancel!',
    html: '<p style="font-weight:600">Are you sure you want to cancel payout?</p>\n    <p style="font-weight:600">Please provide reason for this cancellation, admin will be notified of this request</p>\n    <textarea class="form-control" style="color: black;font-size: 16px;font-weight: 500;" id="cancel-payout-reason" rows="3"></textarea>',
    confirmButtonText: 'Confirm'
  }
};

var pairingBriefConfirmation = {
  approval: {
    confirmation: {
      title: 'Are you sure?',
      text: 'By pressing agree, you agree to participate in the campaign and acknowledge that you have read and agree with the terms and conditions stated in http://getkobe.com/influencer-terms-use-agreement/  ',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'You have agreed with our terms and conditions and agree to participate in the campaign. The campaign can now be viewed under the "Ongoing Campaigns" tab'
    }
  },
  rejection: {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, your participation in the campaign will be rejected',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'We are sad to see you reject the campaign',
      text: 'Hope you will participate in our campaigns in the future'
    }
  }
};

var rateCardConfirmation = {
  approval: {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the requested rate card will be applied',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'The requested rate card has been approved'
    }
  },
  rejection: {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the requested rate card will be rejected',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'The requested rate card has been rejected'
    }
  }
};

var paymentConsConfirmation = {
  unregisteredPrompt: function unregisteredPrompt(username) {
    return {
      title: '',
      html: 'The Influencer <b>' + username + '</b> don\'t have an account on IMS. Please invite the influencer to register on IMS.\n      For any further assistants, contact here (<a href=\'https://kobe-r021324.slack.com/archives/C01CKH1LYAK\' target=\'_blank\'>https://kobe-r021324.slack.com/archives/C01CKH1LYAK</a>).',
      confirmButtonText: 'OK'
    };
  }
};

var campaignModelSections = [{
  type: campaignModelSectionType.CAMPAIGN_SUMMARY,
  unreadComments: [],
  title: 'Campaign Summary',
  content: [{
    name: 'name',
    label: 'Campaign name',
    type: 'select',
    placeholder: 'Enter campaign name',
    value: [],
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign name is required'
    }]
  }, {
    name: 'goal',
    label: 'Objective',
    type: 'combobox',
    placeholder: 'Enter campaign objective',
    items: ['Brand Awareness', 'Branding', 'Positioning', 'Conversation', 'Brand Loyalty'],
    validations: []
  }, {
    name: 'uniqueAdvantage',
    label: 'Unique Advantage',
    type: 'textarea',
    placeholder: 'Enter unique advantage',
    validations: []
  }, {
    name: 'commonObjective',
    label: 'Common Objections',
    type: 'textarea',
    placeholder: 'Enter common objections',
    validations: []
  }, {
    name: 'campaignType',
    label: 'Campaign Type',
    type: 'select',
    value: campaignTypeDisplay,
    defaultValue: campaignType.NO_PREFERENCE,
    placeholder: 'Campaign Type',
    validations: []
  }, {
    name: 'targetAge',
    label: 'Target Audience - Age',
    type: 'combobox',
    items: targetAudienceDisplay.AGE,
    defaultValue: targetAudience.AGE.GROUP_C,
    placeholder: 'Target Audience Age Group',
    validations: []
  }, {
    name: 'targetGender',
    label: 'Target Audience - Gender',
    type: 'select',
    value: targetAudienceDisplay.GENDER,
    defaultValue: targetAudience.GENDER.NO_PREFERENCE,
    placeholder: 'No preference',
    validations: []
  }, {
    name: 'targetLocation',
    label: 'Target Audience - Location',
    type: 'combobox',
    value: targetAudienceDisplay.LOCATION,
    defaultValue: targetAudience.LOCATION.NO_PREFERENCE,
    placeholder: 'Country',
    validations: []
  }, {
    name: 'platform',
    label: 'Platform',
    type: 'combobox',
    items: targetAudienceDisplay.PLATFORM,
    defaultValue: '',
    placeholder: 'No preference',
    validations: []
  }, {
    name: 'dont',
    label: 'Dont\'s',
    type: 'text',
    placeholder: '',
    validations: []
  }, {
    name: 'campaignBackground',
    label: 'Campaign background',
    type: 'textarea',
    placeholder: '',
    validations: []
  }, {
    name: 'vertical',
    label: 'Campaign Vertical',
    type: 'text',
    placeholder: 'Enter Campaign Vertical',
    validations: []
  }, {
    name: 'kic',
    label: 'Kobe Influencer Canvas',
    type: 'upload',
    placeholder: '',
    validations: []
  }, {
    name: 'callToActionLinks',
    label: 'Call-To-Action Links',
    type: 'textarea',
    placeholder: '(i.e UTM, Promo Codes)',
    validations: []
  }, {
    name: 'mechanics',
    label: 'Mechanics',
    type: 'textarea',
    placeholder: '',
    validations: []
  }]
}, {
  type: campaignModelSectionType.CONTENT_ANGLE,
  unreadComments: [],
  title: 'Concept',
  content: [{
    name: 'angles',
    label: 'Concept',
    type: 'multiple_options',
    template: [{
      name: 'option_name',
      label: 'Option Name',
      type: 'text',
      placeholder: 'Name Your option',
      validations: []
    }, {
      name: 'context',
      label: 'Campaign Context',
      type: 'textarea',
      placeholder: 'Enter angle required action',
      validations: []
    }, {
      name: 'formats',
      label: 'Add More Format',
      type: 'multiple_options',
      template: [[{
        name: 'required_action',
        label: 'Required action',
        type: 'textarea',
        placeholder: 'Enter angle required action',
        validations: []
      }, {
        name: 'sample_images',
        label: 'Image inspiration',
        type: 'upload',
        validations: []
      }, {
        name: 'image_angle',
        label: 'Image/Video Pointers',
        type: 'textarea',
        placeholder: 'Enter image/video pointers',
        validations: []
      }, {
        name: 'remark',
        label: 'Remarks',
        type: 'textarea',
        placeholder: 'Remarks',
        validations: []
      }, {
        name: 'content_angle',
        label: 'Content Pointers',
        type: 'textarea',
        placeholder: 'Enter content pointers',
        validations: []
      }, {
        name: 'mandatory',
        label: 'Mandatory Hashtags and Mentions',
        type: 'combobox',
        items: [],
        defaultValue: '',
        placeholder: 'Enter Mandatory Hashtags and Mentions',
        validations: []
      }]]
    }],
    validations: []
  }, {
    name: 'actionRequired_time',
    label: 'Action required - Time',
    type: 'select',
    value: actionRequiredDisplay.TIME,
    defaultValue: actionRequired.TIME.LESS_1_HOUR,
    placeholder: 'No preference',
    validations: []
  }, {
    name: 'actionRequired_action',
    label: 'Action required - Action',
    type: 'select',
    value: actionRequiredDisplay.ACTION,
    defaultValue: actionRequired.ACTION.RECEIVE,
    placeholder: 'No preference',
    validations: []
  }, {
    name: 'actionRequired_receive',
    label: 'Action required - Receive',
    type: 'select',
    value: actionRequiredDisplay.RECEIVE,
    defaultValue: actionRequired.RECEIVE.NA,
    placeholder: 'No preference',
    validations: []
  }, {
    name: 'actionRequired_value',
    label: 'Action required - Value',
    type: 'select',
    value: actionRequiredDisplay.VALUE,
    defaultValue: actionRequired.VALUE.NA,
    placeholder: 'No preference',
    validations: []
  }]
}, {
  type: campaignModelSectionType.INFLUENCER_SELECTION,
  unreadComments: [],
  title: 'Creator Profiling',
  content: [{
    name: 'influencer_min_age',
    label: 'Creator Age From',
    type: 'text',
    placeholder: "Enter influencer's minimum age",
    validations: [{
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Minimum influencer must be a number'
    }]
  }, {
    name: 'influencer_max_age',
    label: 'Creator Age To',
    type: 'text',
    placeholder: "Enter influencer's maximum age",
    validations: [{
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Maximum influencer must be a number'
    }]
  }, {
    name: 'influencer_ideal',
    label: 'I would like',
    type: 'combobox',
    items: [],
    placeholder: 'Enter desired attributes',
    validations: []
  }, {
    name: 'influencer_unwanted',
    label: "I don't want",
    type: 'combobox',
    items: [],
    placeholder: 'Enter undesirable attributes',
    validations: []
  }, {
    name: 'gender',
    label: 'Creator Gender',
    type: 'select',
    value: userGenderDisplay,
    defaultValue: userGenders.BOTH,
    placeholder: 'No preference',
    validations: []
  }, {
    name: 'segment',
    label: 'Creator Segmentation Preference',
    type: 'chips',
    value: userSegmentDisplay,
    placeholder: 'No preference',
    validations: []
  }]
}, {
  type: campaignModelSectionType.VIDEO_BRIEF,
  unreadComments: [],
  title: 'Video Brief',
  content: [{
    name: 'content_creator',
    label: 'Content Creator(s)',
    type: 'text',
    placeholder: 'Enter Content Creator',
    validations: []
  }, {
    name: 'video_live_date',
    label: 'Video Live Date',
    type: 'date',
    placeholder: 'Enter Video Live Date',
    validations: []
  }, {
    name: 'end_video_link',
    label: 'Links To Include at End of Video',
    type: 'textarea',
    placeholder: 'Company website or landing page',
    validations: []
  }, {
    name: 'video_objective',
    label: 'Video Objective',
    type: 'textarea',
    placeholder: 'E.g. highlight USP of product',
    validations: []
  }, {
    name: 'branded_mentions',
    label: 'Branded Mentions',
    type: 'textarea',
    placeholder: 'Spelling & pronunciation of Brand/Product Name to be used',
    validations: []
  }, {
    name: 'video_storyboard',
    label: 'Video Storyboard',
    type: 'textarea',
    placeholder: 'Brief storyline of video',
    validations: []
  }, {
    name: 'preferred_video',
    label: 'Preferred video background/location/setting',
    type: 'textarea',
    placeholder: '...',
    validations: []
  }, {
    name: 'others',
    label: 'Others',
    type: 'textarea',
    placeholder: 'Video Dimension, Sound and Light requirements',
    validations: []
  }, {
    name: 'tags',
    label: 'Hashtags, Location Check-in (0r) Tag Requirements',
    type: 'combobox',
    items: [],
    placeholder: '(up to 3)',
    validations: []
  }, {
    name: 'suggested_video_length',
    label: 'Suggested Video Length',
    type: 'text',
    placeholder: 'Recommended all instagram posts to be below 45s',
    validations: []
  }, {
    name: 'dos',
    label: 'Dos',
    type: 'combobox',
    items: [],
    placeholder: 'e.g. clothing of bloggers/talents',
    validations: []
  }, {
    name: 'donts',
    label: 'Dont\'s',
    type: 'combobox',
    items: [],
    placeholder: 'e.g. clothing of bloggers/talents',
    validations: []
  }]
}, {
  type: campaignModelSectionType.BUDGET_ALLOCATION,
  unreadComments: [],
  title: 'Budget Allocation',
  content: [{
    name: 'ioNumbers',
    label: 'IO Number',
    type: 'select',
    defaultValue: '',
    value: '',
    placeholder: 'IO Number',
    validations: []
  }, {
    name: 'budget',
    label: 'Campaign budget',
    type: 'slider',
    placeholder: 'Enter campaign budget',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign budget is required'
    }, {
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Campaign budget must be a number'
    }],
    showToClient: {
      name: 'showBudgetToClient',
      defaultValue: true,
      showText: 'Campaign budget is Visible for Clients',
      hideText: 'Campaign budget is Hidden for Clients'
    }
  }, {
    name: 'outreach',
    label: 'Campaign outreach',
    type: 'slider',
    placeholder: 'Enter campaign outreach',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign outreach is required'
    }, {
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Campaign outreach must be a number'
    }]
  }, {
    name: 'engagement',
    label: 'Campaign engagement',
    type: 'slider',
    placeholder: 'Enter campaign engagement',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign engagement is required'
    }, {
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Campaign engagement must be a number'
    }]
  }, {
    name: 'min_content',
    label: 'Minimum content',
    type: 'text',
    placeholder: 'Enter campaign minimum content',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Minimum content is required'
    }, {
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Minimum content must be a number'
    }]
  }, {
    name: 'max_content',
    label: 'Maximum content',
    type: 'text',
    placeholder: 'Enter campaign maxinimum content',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Maximum content is required'
    }, {
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'Maximum content must be a number'
    }]
  }, {
    name: 'kpi_onboarded',
    label: 'KPI Onboarded',
    type: 'text',
    placeholder: 'Enter KPI Onboarded',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'KPI Onboarded is required'
    }, {
      name: 'numeric',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
      message: 'KPI Onboarded must be a number'
    }]
  }, {
    name: 'startDate',
    label: 'Start Month',
    type: 'date',
    placeholder: 'Enter campaign start month',
    validations: []
  }, {
    name: 'endDate',
    label: 'End Month',
    type: 'date',
    placeholder: 'Enter campaign end month',
    validations: []
  }, {
    name: 'revenueCalculation',
    label: 'Revenue Calculations',
    type: 'radio',
    defaultValue: 'content',
    placeholder: '',
    validations: []
  }]
}, {
  type: campaignModelSectionType.EVENT_BRIEF,
  unreadComments: [],
  title: 'Event Brief',
  content: [{
    name: 'eventAttendees',
    label: 'Event Attendees',
    type: 'multiple_options',
    template: [{
      name: 'attendeeName',
      label: 'Attendee Name',
      type: 'text',
      placeholder: '',
      validations: []
    }, {
      name: 'attendeeDesignation',
      label: 'Designation',
      type: 'text',
      placeholder: '',
      validations: []
    }, {
      name: 'attendeeRole',
      label: 'Role',
      type: 'text',
      placeholder: '',
      validations: []
    }, {
      name: 'attendeeContactNumber',
      label: 'Contact Number',
      type: 'text',
      placeholder: '',
      validations: []
    }],
    validations: []
  }, {
    name: 'eventRunDown',
    label: 'Event Run Down',
    type: 'template',
    template: [{
      name: 'isFoodProvided',
      label: 'Will food and drinks be provided during the event?',
      type: 'radioButton',
      validations: []
    }, {
      name: 'isRequireDietary',
      label: 'Do you require the influencer to specify their dietary requirements?',
      type: 'radioButton',
      validations: []
    }, {
      name: 'isGuided',
      label: 'Is this a guided event?',
      type: 'radioButton',
      validations: []
    }, {
      name: 'eventDate',
      label: 'Event Date',
      type: 'date',
      validations: []
    }, {
      name: 'eventStartTime',
      label: 'Start Time',
      type: 'text',
      validations: []
    }, {
      name: 'eventEndTime',
      label: 'End Time',
      type: 'text',
      validations: []
    }, {
      name: 'eventSchedule',
      label: 'Schedule (if any)',
      type: 'textarea',
      validations: []
    }],
    validations: []
  }, {
    name: 'additionalGifts',
    label: 'Additional Gifts',
    type: 'template',
    template: [{
      name: 'isIncludeGifts',
      label: 'Will there be any gifts prepared for the influencers?',
      type: 'radioButton',
      validations: []
    }, {
      name: 'giftForPaidInfluencers',
      label: 'Gift for Paid Influencers',
      type: 'textarea',
      placeholder: 'Customized PR kit for influencer',
      validations: []
    }, {
      name: 'giftForUnpaidInfluencers',
      label: 'Gift for Unpaid Influencers',
      type: 'textarea',
      placeholder: 'PR Kit for unpaid influencers',
      validations: []
    }],
    validations: []
  }, {
    name: 'specialInstructions',
    label: 'Special Instructions (If Any)',
    type: 'textarea',
    placeholder: '\n        - Kobe to run through program notes and conduct guided tour\n        - PR Kit must be featured in IG story at least once',
    validations: []
  }]
}];

var pairingBriefModelSections = [{
  type: pairingBriefModelSectionType.CAMPAIGN_SUMMARY,
  unreadComments: [],
  title: 'Pairing Brief Summary (Initial email to influencer)',
  content: [{
    name: 'pairing_brief_client',
    label: 'Client',
    type: 'textarea',
    placeholder: '(Briefly provide the industry and what the client does) Example: A leading beauty brand that is trending amongst millennials',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Client details are required'
    }]
  }, {
    name: 'pairing_brief_product',
    label: 'Product',
    type: 'textarea',
    placeholder: '(Insert main USP) Example: Latest lipstick that lasts more than 48 hours',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign goal is required'
    }]
  }, {
    name: 'pairing_brief_background',
    label: 'Background',
    type: 'textarea',
    placeholder: 'Briefly describes why the client does what its doing and why the specific product is being focused for this campaign. Example: A home name in the beauty industry, our client has expertise in understanding the different needs and demands of women and is determined to make every woman feel confident of themselves. Their new product, a long lasting lipstick range, helps to strengthen every woman’s confidence by allowing them to go from work to play without worrying on their looks!',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign outreach is required'
    }]
  }, {
    name: 'pairing_brief_objective',
    label: 'Objective',
    type: 'textarea',
    placeholder: 'Share the main points and objectives the client wishes to achieve out of this campaign. Example:  To reach out and be top of mind amongst the millennials when it comes to beauty products',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Campaign engagement is required'
    }]
  }, {
    name: 'pairing_brief_actions',
    label: 'Actions',
    type: 'textarea',
    placeholder: 'Briefly describe what the influencer has to do and touch on overarching messaging of content. Example: Head down to Kobe HQ to collect the product. Experience the product in your normal routine. Share your thoughts on the experience of the product and the impact on your daily activities',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Actions is required'
    }]
  }, {
    name: 'pairing_brief_deadline',
    label: 'Deadline',
    type: 'textarea',
    placeholder: 'Provide exact date for submission if possible, or in the case of product delivery and it’s unforeseeable on the delivery date, provide 3-4 days for influencer to submit their drafts ***Always provide 2359 hours so that the influencer will be able to submit within the deadline date. Example: 30th September 2018, 2359 hours OR Within 4 days of receiving the product, 2359 hours',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Date is required'
    }]
  }, {
    name: 'pairing_brief_deliverables',
    label: 'Deliverables',
    type: 'textarea',
    placeholder: 'Provide exactly what the influencer has to do in terms of the posting or IG story. Example: 1 X IG multi photo posting (minimally 2 images and one of the image to include product in it)',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Deliverables is required'
    }]
  }]
}, {
  type: pairingBriefModelSectionType.CAMPAIGN_DETAILS,
  unreadComments: [],
  title: 'Pairing Brief Details (Influencer has accepted)',
  content: [{
    name: 'pairing_brief_client_name',
    label: 'Client Name',
    type: 'text',
    placeholder: 'Enter client name',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Client name is required'
    }]
  }, {
    name: 'pairing_brief_client_background',
    label: 'Client Background',
    type: 'textarea',
    placeholder: 'Describe your client background',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Client background is required'
    }]
  }, {
    name: 'pairing_brief_required_actions',
    label: 'Required Actions',
    type: 'textarea',
    placeholder: 'Actions required',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Actions is required'
    }]
  }, {
    name: 'pairing_brief_image_angle',
    label: 'Image Angle',
    type: 'textarea',
    placeholder: 'Enter image angle'
  }, {
    name: 'pairing_brief_content_angle',
    label: 'Content Angle',
    type: 'textarea',
    placeholder: 'Enter content angle'
  }, {
    name: 'pairing_brief_draft_deadline',
    label: 'Draft Deadline',
    type: 'textarea',
    placeholder: 'Deadline required',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Deadline is required'
    }]
  }, {
    name: 'pairing_brief_hashtags',
    label: 'Hashtags to be used',
    type: 'textarea',
    placeholder: 'Hashtags required',
    validations: [{
      name: 'required',
      value: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      message: 'Hashtags are required'
    }]
  }]
}];

var brandSheetFormSections = {
  sectionOne: {
    title: 'SECTION ONE: MARKETING ASSESSMENT',
    subtitle: 'CLIENT CONTACT DETAILS',
    name: 'sectionOne',
    required: true,
    fields: [{
      label: 'First name',
      name: 'firstName',
      type: 'textbox',
      required: true,
      class: 'xs12 md6 pr-5'
    }, {
      label: 'Last name',
      name: 'lastName',
      type: 'textbox',
      required: true
    }, {
      label: 'Job Title',
      name: 'jobTitle',
      type: 'textbox',
      required: true,
      class: 'xs12 md12'
    }, {
      label: 'Organisation',
      name: 'organization',
      type: 'textbox',
      required: true,
      class: 'xs12 md12'
    }, {
      label: 'Mobile No',
      name: 'mobileCountry',
      type: 'select',
      class: 'xs12 md4',
      required: true,
      defaultOptions: __WEBPACK_IMPORTED_MODULE_4__dialCodes_json___default.a.map(function (d) {
        return d.cn;
      })
    }, {
      label: '',
      name: 'mobilePhone',
      type: 'textbox',
      class: 'xs12 md8'
    }, {
      label: 'Email',
      name: 'email',
      type: 'textbox',
      class: 'xs12 md6 pr-5',
      required: true
    }, {
      label: 'KOBE POC',
      name: 'kobePoc',
      type: 'textbox',
      class: 'xs12 md6',
      required: true
    }, {
      label: 'Company Background',
      name: 'companyBackground',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Background of the Brand (Limit to 100 words)',
      required: true
    }, {
      label: 'Competitive Background',
      name: 'competitiveBackground',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'List some of your competitors',
      required: true
    }]
  },
  sectionTwo: {
    title: 'SECTION TWO: ADVERTISER OBJECTIVES',
    name: 'sectionTwo',
    required: true,
    fields: [{
      label: 'Project Title',
      name: 'projectTitle',
      type: 'textbox',
      hint: 'ProductName/CampaignName-CampaignPeriod(QxYY)-Markets (SG,MY,TH,ID,PH,VN)<br>\n        E.g. CocaColaVanilaLaunch-Q223-SGMY<br>',
      class: 'xs12 md12'
    }, {
      label: 'Product Details',
      name: 'productDetails',
      type: 'textarea',
      hint: 'What is the featured product/service?<br>\n        Distribution channels<br>\n        How has this product been marketed to your audiences?',
      class: 'xs12 md12'
    }, {
      label: 'Campaign Objectives',
      name: 'campaignObjective',
      type: 'textarea',
      hint: '1. What are you trying to achieve?<br>\n        2. Describe how the project\'s success will be measured',
      class: 'xs12 md12'
    }, {
      label: 'Key Message',
      name: 'keyMessage',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'What do you want the audience to remember from this campaign?'
    }, {
      label: 'Key Barriers',
      name: 'keyBarriers',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'What are your marketing challenges?'
    }, {
      label: 'Campaign Timeframe',
      name: 'campaignTimeframe',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'State preferred start date',
      placeholder: 'Eg. Jan 2022'
    }, {
      label: 'Campaign Duration',
      name: 'campaignDuration',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'How long will this campaign run for?',
      placeholder: 'Eg. 1 month, 3 months, etc.'
    }, {
      label: 'Campaign Budget',
      name: 'campaignBudget',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'Please choose the currency for budget.',
      placeholder: '',
      numberText: true,
      required: true
    }]
  },
  sectionThree: {
    title: 'SECTION THREE: AUDIENCE AND CREATORS PROFILING',
    name: 'sectionThree',
    required: true,
    fields: [{
      label: 'Age',
      name: 'age',
      type: 'checkbox',
      class: 'xs12 md12',
      hint: 'What is your target audience’s age? - Select up to 2',
      detailFields: [{
        label: 'Teenagers (13-17)',
        value: 'teenagers'
      }, {
        label: 'Young Adults (18 - 24)',
        value: 'youngAdults'
      }, {
        label: 'Executives (25-34)',
        value: 'executives'
      }, {
        label: 'Others (35+)',
        value: 'others'
      }]
    }, {
      label: 'Gender',
      name: 'gender',
      type: 'select',
      class: 'xs12 md12',
      hint: 'What is your target audience\'s gender?',
      placeholder: 'Male / Female / Both',
      defaultOptions: userGenderDisplay
    }, {
      label: 'Key Insights',
      name: 'keyInsights',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Industry or audience insights that may be helpful for us to understand your audience more'
    }, {
      label: 'I Would Like',
      name: 'wouldLike',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Enter as many keywords that describe your ideal audience'
    }, {
      label: 'I Don\'t Want',
      name: 'dontWant',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Help us EXCLUDE audience with these keywords'
    }, {
      label: 'Hashtags, Location Check-in, or Tag Requirements',
      name: 'hashTags',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'List up to 3'
    }, {
      label: 'Creators Look-alikes',
      name: 'lookAlike',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Creators you have worked with in the past / Creators you are currently working with'
    }, {
      label: 'Additional Information (if any)',
      name: 'additionalInfo',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Any reference links or additional information you would like us to know'
    }, {
      label: 'Attach Marketing Collaterals (if any)',
      name: 'marketingCollaterals',
      type: 'file',
      class: 'xs12 md12'
    }]
  }
};
var brandSheetAOKFormSections = {
  sectionOne: {
    title: 'KOBE Uncut GUIDELINES',
    subtitle: 'KOBE Uncut PROCESS',
    name: 'sectionOne',
    required: true,
    fields: [{
      label: 'Brand (& Agency)',
      name: 'brandAgency',
      type: 'textbox',
      class: 'xs12 md12',

      required: true
    }, {
      label: 'Email',
      name: 'email',
      type: 'textbox',
      class: 'xs12 md12',
      required: true
    }, {
      label: 'Campaign Name',
      name: 'campaignName',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'Original Dry Shampoo',
      required: true
    }, {
      label: 'Campaign Period',
      name: 'campaignPeriod',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'June 2020 - July 2020',
      required: true
    }, {
      label: 'Campaign Duration',
      name: 'campaignDuration',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'Eg. 3 Months or 6 Months',
      required: true
    }, {
      label: 'Brand Information',
      name: 'brandInformation',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Background of the Brand (Limit to 100 words)',
      placeholder: 'UK\'s No 1 Dry Shampoo with a classic fragrance',
      required: true
    }, {
      label: 'Key Message',
      name: 'keyMessage',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '1. Key message of how your product/service stands out to consumers<br>2. USPs: The Unique Selling Points of your product/service',
      placeholder: 'Educating consumers on a great alternative to shampooing your hair with Batiste Dry Shampoo. No time to wash your hair? Batiste Dry Shampoo is an innovative formula that boosts the body and helps eliminate oily roots, giving dull lifeless hair an instant makeover without water. A quick spray revitalizes hair leaving it looking and feeling clean, no drama.  It\'s not magic, it\'s science! Dry shampoo is a waterless formula that absorbs dirt and oil from the scalp giving your hair that just washed feeling. Or as we like to call it, the reason you can hit snooze in the morning.',
      required: true
    }, {
      label: 'Product/Service Information',
      name: 'productInformation',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Details of product/service<br>\n        Specific copy of Brand name<br>\n        Link to website (if any)',
      placeholder: 'Place of Origin: United Kingdom Ingredients: Butane, Isobutane, Propane, Oryza Sativa (Rice) Starch, Alcohol Denat., Parfum (Fragrance), Limonene, Linalool, Geraniol, Benzyl Benzoate, Distearyldimonium Chloride, Centrimonium Chloride. https://www.batistehair.com/',
      required: true
    }, {
      label: 'USPs',
      name: 'USP',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'The Unique Selling Points of your product/service',
      placeholder: '1. Waterless Formula   2. Fuss-Free Quick Spray',
      required: true
    }, {
      label: 'Pricing',
      name: 'pricing',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'How much is this product/service priced?',
      placeholder: '$8.99',
      required: true
    }, {
      label: 'Direction for use',
      name: 'directionUse',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '(If any)',
      placeholder: 'Shake well. Hold can 30cm from dry hair, section and spray onto roots. Go lightly at first, adding more as and when you need it. Give your roots a massage to add some volume and get rid of any excess oil. Brush through to remove excess residue and style as usual. Et Voila! Ready for whatever, with gorgeous refreshed hair.'
    }, {
      label: 'Logistic Arrangement',
      name: 'LogisticArrangement',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Product/Service Each Creator will receive:<br>\n        Date of Logistics:<br>\n        Logistics Preference: (client/KOBE)<br>\n        Quantity of Product:',
      placeholder: ''
    }, {
      label: 'Hashtag or Mentions (up to 3 Hashtags)',
      name: 'hashTags',
      type: 'textarea',
      class: 'xs12 md12',
      placeholder: ''
    }, {
      label: 'Attach Marketing Collaterals (if any)',
      name: 'marketingCollaterals',
      type: 'file',
      class: 'xs12 md12'
    }]
  }
};

var brandSheetKobeLiteFormSections = {
  sectionOne: {
    title: 'KOBE Lite GUIDELINES',
    subtitle: 'AOK PROCESS',
    name: 'sectionOne',
    required: true,
    fields: [{
      label: 'Brand (& Agency)',
      name: 'brandAgency',
      type: 'textbox',
      class: 'xs12 md12',

      required: true
    }, {
      label: 'Email',
      name: 'email',
      type: 'textbox',
      class: 'xs12 md12',
      required: true
    }, {
      label: 'Campaign Name',
      name: 'campaignName',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'Original Dry Shampoo',
      required: true
    }, {
      label: 'Campaign Period',
      name: 'campaignPeriod',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'June 2020 - July 2020',
      required: true
    }, {
      label: 'Campaign Duration',
      name: 'campaignDuration',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'Eg. 6 Months',
      required: true
    }, {
      label: 'Brand Information',
      name: 'brandInformation',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Background of the Brand (Limit to 100 words)',
      placeholder: 'UK\'s No 1 Dry Shampoo with a classic fragrance',
      required: true
    }, {
      label: 'Key Message',
      name: 'keyMessage',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '1. Key message of how your product/service stands out to consumers<br>2. USPs: The Unique Selling Points of your product/service',
      placeholder: 'Educating consumers on a great alternative to shampooing your hair with Batiste Dry Shampoo. No time to wash your hair? Batiste Dry Shampoo is an innovative formula that boosts the body and helps eliminate oily roots, giving dull lifeless hair an instant makeover without water. A quick spray revitalizes hair leaving it looking and feeling clean, no drama.  It\'s not magic, it\'s science! Dry shampoo is a waterless formula that absorbs dirt and oil from the scalp giving your hair that just washed feeling. Or as we like to call it, the reason you can hit snooze in the morning.',
      required: true
    }, {
      label: 'Product/Service Information',
      name: 'productInformation',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Details of product/service<br>\n        Specific copy of Brand name<br>\n        Link to website (if any)',
      placeholder: 'Place of Origin: United Kingdom Ingredients: Butane, Isobutane, Propane, Oryza Sativa (Rice) Starch, Alcohol Denat., Parfum (Fragrance), Limonene, Linalool, Geraniol, Benzyl Benzoate, Distearyldimonium Chloride, Centrimonium Chloride. https://www.batistehair.com/',
      required: true
    }, {
      label: 'USPs',
      name: 'USP',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'The Unique Selling Points of your product/service',
      placeholder: '1. Waterless Formula   2. Fuss-Free Quick Spray',
      required: true
    }, {
      label: 'Pricing',
      name: 'pricing',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'How much is this product/service priced?',
      placeholder: '$8.99',
      required: true
    }, {
      label: 'Direction for use',
      name: 'directionUse',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '(If any)',
      placeholder: 'Shake well. Hold can 30cm from dry hair, section and spray onto roots. Go lightly at first, adding more as and when you need it. Give your roots a massage to add some volume and get rid of any excess oil. Brush through to remove excess residue and style as usual. Et Voila! Ready for whatever, with gorgeous refreshed hair.'
    }, {
      label: 'Logistic Arrangement',
      name: 'LogisticArrangement',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Product/Service Each Creator will receive:<br>\n        Date of Logistics:<br>\n        Logistics Preference: (client/KOBE)<br>\n        Quantity of Product:',
      placeholder: ''
    }, {
      label: 'Hashtag or Mentions (up to 3 Hashtags)',
      name: 'hashTags',
      type: 'textarea',
      class: 'xs12 md12',
      placeholder: ''
    }, {
      label: 'Attach Marketing Collaterals (if any)',
      name: 'marketingCollaterals',
      type: 'file',
      class: 'xs12 md12'
    }]
  }
};

var brandSheetUGCFormSections = {
  sectionOne: {
    title: 'AOK GUIDELINES',
    subtitle: 'AOK PROCESS',
    name: 'sectionOne',
    required: true,
    fields: [{
      label: 'Brand (& Agency)',
      name: 'brandAgency',
      type: 'textbox',
      class: 'xs12 md12',

      required: true
    }, {
      label: 'Email',
      name: 'email',
      type: 'textbox',
      class: 'xs12 md12',
      required: true
    }, {
      label: 'Campaign Name',
      name: 'campaignName',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'Original Dry Shampoo',
      required: true
    }, {
      label: 'Start Date',
      name: 'startDate',
      type: 'textbox',
      class: 'xs12 md12',
      placeholder: 'dd/mm/yyyy',
      required: true
    }, {
      label: 'Brand Information',
      name: 'brandInformation',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Background of the Brand (Limit to 100 words)',
      placeholder: 'UK\'s No 1 Dry Shampoo with a classic fragrance',
      required: true
    }, {
      label: 'Key Message',
      name: 'keyMessage',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '1. Key message of how your product/service stands out to consumers<br>2. USPs: The Unique Selling Points of your product/service',
      placeholder: 'Educating consumers on a great alternative to shampooing your hair with Batiste Dry Shampoo. No time to wash your hair? Batiste Dry Shampoo is an innovative formula that boosts the body and helps eliminate oily roots, giving dull lifeless hair an instant makeover without water. A quick spray revitalizes hair leaving it looking and feeling clean, no drama.  It\'s not magic, it\'s science! Dry shampoo is a waterless formula that absorbs dirt and oil from the scalp giving your hair that just washed feeling. Or as we like to call it, the reason you can hit snooze in the morning.',
      required: true
    }, {
      label: 'Product/Service Information',
      name: 'productInformation',
      type: 'textarea',
      class: 'xs12 md12',
      hint: 'Details of product/service<br>\n        Specific copy of Brand name<br>\n        Link to website (if any)',
      placeholder: 'Place of Origin: United Kingdom Ingredients: Butane, Isobutane, Propane, Oryza Sativa (Rice) Starch, Alcohol Denat., Parfum (Fragrance), Limonene, Linalool, Geraniol, Benzyl Benzoate, Distearyldimonium Chloride, Centrimonium Chloride. https://www.batistehair.com/',
      required: true
    }, {
      label: 'How will you be providing your product or service experience ',
      name: 'productExperienceType',
      type: 'radio',
      class: 'xs12 md12',
      placeholder: '\n        Deliver directly,\n        Pick Up Point,\n        Reimbursement Basis'
    }, {
      label: 'Pricing',
      name: 'pricing',
      type: 'textbox',
      class: 'xs12 md12',
      hint: 'How much is this product/service priced?',
      placeholder: '$8.99',
      required: true
    }, {
      label: 'What will you like the creator to do to experience your product or service?',
      name: 'experiencesForCreators',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '',
      placeholder: 'Head down to Jurong Point, spin the lucky draw and enjoy sure-win of $50 grabvouchers.\n        Collect hair serum worth $25 from Joo Chiat.\n        Visit CCK190 Wanton Mee to purchase wanton noodles from $4.'
    }, {
      label: 'Exact Location and Transport Directions',
      name: 'locationAndDirections',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '',
      placeholder: 'Blk 89 Circuit Rd, #01-110, Singapore 370089\n        Nearest MRT: Macpherson MRT, public parking available within 2 mins walk.'
    }, {
      label: 'Visiting Dates & Hour range',
      name: 'visitingRange',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '',
      placeholder: 'Between 15 Oct to 15 Dec, 9am to 2pm\n        Monday - Friday only'
    }, {
      label: 'Direction for use',
      name: 'directionUse',
      type: 'textarea',
      class: 'xs12 md12',
      hint: '(If any)',
      placeholder: 'Shake well. Hold can 30cm from dry hair, section and spray onto roots. Go lightly at first, adding more as and when you need it. Give your roots a massage to add some volume and get rid of any excess oil. Brush through to remove excess residue and style as usual. Et Voila! Ready for whatever, with gorgeous refreshed hair.'
    }, {
      label: 'Hashtag or Mentions (up to 3 Hashtags)',
      name: 'hashTags',
      type: 'textarea',
      class: 'xs12 md12',
      placeholder: ''
    }, {
      label: 'Sample Video Content for UGC creator\u2019s reference:',
      name: 'sampleVideoContent',
      type: 'custom',
      class: 'xs12 md12',
      placeholder: 'Sample video url'
    }, {
      label: 'Attach Marketing Collaterals (if any)',
      name: 'marketingCollaterals',
      type: 'custom',
      class: 'xs12 md12'
    }]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  campaignStatusFlow: campaignStatusFlow,
  pairingStatus: pairingStatus,
  eliminationStatus: eliminationStatus,
  pairingStatusDisplay: pairingStatusDisplay,
  payoutStatus: payoutStatus,
  payoutStatusDisplay: payoutStatusDisplay,
  campaignStatusDisplayForClients: campaignStatusDisplayForClients,
  postStatus: postStatus,
  postStatusDisplay: postStatusDisplay,
  clientPaymentStatus: clientPaymentStatus,
  clientPaymentStatusDisplay: clientPaymentStatusDisplay,
  queryType: queryType,
  campaignActivationStatus: campaignActivationStatus,
  campaignModelSections: campaignModelSections,
  campaignModelSectionType: campaignModelSectionType,
  pairingBriefModelSections: pairingBriefModelSections,
  pairingBriefModelSectionType: pairingBriefModelSectionType,
  campaignConfirmation: campaignConfirmation,
  pairingBriefConfirmation: pairingBriefConfirmation,
  rateCardConfirmation: rateCardConfirmation,
  userSegmentDisplay: userSegmentDisplay,
  targetAudienceDisplay: targetAudienceDisplay,
  campaignType: campaignType,
  campaignTypeDisplay: campaignTypeDisplay,
  campaignStage: campaignStage,
  campaignStageDisplay: campaignStageDisplay,
  pairingSendStatus: pairingSendStatus,
  pairingSendStatusDisplay: pairingSendStatusDisplay,
  brandSheetFormSections: brandSheetFormSections,
  brandSheetAOKFormSections: brandSheetAOKFormSections,
  brandSheetKobeLiteFormSections: brandSheetKobeLiteFormSections,
  brandSheetUGCFormSections: brandSheetUGCFormSections,
  userGenderDisplay: userGenderDisplay,
  paymentStatus: paymentStatus,
  imsStatuses: imsStatuses,
  tableActions: tableActions,
  paymentConsConfirmation: paymentConsConfirmation,
  paymentConsExportTypes: paymentConsExportTypes,
  paymentConsSectionIDs: paymentConsSectionIDs,
  dashboardStatuses: dashboardStatuses,
  dashboardStatusDisplay: dashboardStatusDisplay,
  bfsTypes: bfsTypes
}));

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);







var FileSaver = __webpack_require__(119);

/* harmony default export */ __webpack_exports__["a"] = ({
  createPairingForCampaign: function createPairingForCampaign(campaignID, influencerList) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {
                campaignID: campaignID,
                influencers: influencerList
              };
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/campaigns/', true, data);

            case 4:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context.abrupt('return', response.data);

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](1);
              throw _context.t0;

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 10]]);
    }))();
  },
  getPairedInfluencersByCampaign: function getPairedInfluencersByCampaign(campaignID) {
    var _this2 = this;

    var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/influencers?campaign=' + campaignID + '&refresh=' + refresh, true);

            case 3:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context2.abrupt('return', response.data);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 9]]);
    }))();
  },
  getAccuredCogs: function getAccuredCogs() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/accured/cogs', true);

            case 3:
              response = _context3.sent;

              if (!(response.status !== 200)) {
                _context3.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context3.abrupt('return', response.data);

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3['catch'](0);
              throw _context3.t0;

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 9]]);
    }))();
  },
  getPairedCreators: function getPairedCreators() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/paired/creators', true);

            case 3:
              response = _context4.sent;

              if (!(response.status !== 200)) {
                _context4.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context4.abrupt('return', response.data);

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4['catch'](0);
              throw _context4.t0;

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 9]]);
    }))();
  },
  getPairedInfluencersByCampaignIDs: function getPairedInfluencersByCampaignIDs(campaignIDs) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/by/campaign-ids', true, { campaignIDs: campaignIDs }).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }

                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getCampaignPaymentStatusSummary: function getCampaignPaymentStatusSummary(campaignIDs) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/campaign-payment-status-summary', true, { campaignIDs: campaignIDs }).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  return reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getSignedInvoices: function getSignedInvoices(pairingID) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/' + pairingID + '/signed-invoices', true);

            case 3:
              response = _context7.sent;

              if (!(response.status !== 200)) {
                _context7.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context7.abrupt('return', response.data.signedInvoices || []);

            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7['catch'](0);
              throw _context7.t0;

            case 12:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 9]]);
    }))();
  },
  getPairingsByHandle: function getPairingsByHandle(handle) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/by/handle', true, {
                  handle: handle
                }).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }

                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getPairingsByInfluencerID: function getPairingsByInfluencerID(influencerID) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/by/influencerID', true, {
                  influencerID: influencerID
                }).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }

                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  updatePairingDetails: function updatePairingDetails(pairingID, data) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + pairingID + '/pair-details', true, data);

            case 3:
              response = _context10.sent;

              if (!(response.status !== 200)) {
                _context10.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context10.abrupt('return', response.data);

            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10['catch'](0);
              throw _context10.t0;

            case 12:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 9]]);
    }))();
  },
  submitEliminatedInfluencers: function submitEliminatedInfluencers(eliminationData) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/eliminate/influencer', true, eliminationData);

            case 3:
              response = _context11.sent;

              if (!(response.status !== 200)) {
                _context11.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context11.abrupt('return', response.data);

            case 9:
              _context11.prev = 9;
              _context11.t0 = _context11['catch'](0);
              throw _context11.t0;

            case 12:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 9]]);
    }))();
  },
  crawlInfluencerDetails: function crawlInfluencerDetails(body) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var campaignID, userHandle, platform, platformName, options, remarks, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              campaignID = body.campaignID, userHandle = body.userHandle, platform = body.platform, platformName = body.platformName, options = body.options, remarks = body.remarks;
              _context12.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/influencer/detail?campaign=' + campaignID + '&platform=' + platform + '&userHandle=' + userHandle + '&platformName=' + platformName + '&options=' + options + '&remarks=' + remarks, true);

            case 4:
              response = _context12.sent;

              if (!(response.status !== 200)) {
                _context12.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context12.abrupt('return', response.data);

            case 10:
              _context12.prev = 10;
              _context12.t0 = _context12['catch'](0);
              throw _context12.t0;

            case 13:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 10]]);
    }))();
  },
  fetchInfluencerForList: function fetchInfluencerForList(body) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var userHandle, platform, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              userHandle = body.userHandle, platform = body.platform;
              _context13.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/fetch/influencer/for-list?platform=' + platform + '&userHandle=' + userHandle, true);

            case 4:
              response = _context13.sent;

              if (!(response.status !== 200)) {
                _context13.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context13.abrupt('return', response.data);

            case 10:
              _context13.prev = 10;
              _context13.t0 = _context13['catch'](0);
              throw _context13.t0;

            case 13:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 10]]);
    }))();
  },
  refreshInfluencerDetails: function refreshInfluencerDetails(body) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var campaignID, ighandle, platform, pairingID, _body$isChange, isChange, response;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              campaignID = body.campaignID, ighandle = body.ighandle, platform = body.platform, pairingID = body.pairingID, _body$isChange = body.isChange, isChange = _body$isChange === undefined ? false : _body$isChange;
              _context14.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings/influencer/' + encodeURIComponent(ighandle) + '/detail/' + pairingID + '?campaign=' + encodeURIComponent(campaignID) + '&platform=' + encodeURIComponent(platform) + '&isChange=' + isChange, true);

            case 4:
              response = _context14.sent;

              if (!(response.status !== 200)) {
                _context14.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context14.abrupt('return', response.data);

            case 10:
              _context14.prev = 10;
              _context14.t0 = _context14['catch'](0);
              throw _context14.t0;

            case 13:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14, [[0, 10]]);
    }))();
  },
  removePairing: function removePairing(pairingID) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('delete', '/api/v1/pairings/' + pairingID, true);

            case 3:
              response = _context15.sent;

              if (!(response.status !== 200)) {
                _context15.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context15.abrupt('return', response.data);

            case 9:
              _context15.prev = 9;
              _context15.t0 = _context15['catch'](0);
              throw _context15.t0;

            case 12:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15, [[0, 9]]);
    }))();
  },
  updatePayoutAmount: function updatePayoutAmount(data) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var pairingID, payoutAmount, currency, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              pairingID = data.pairingID, payoutAmount = data.payoutAmount, currency = data.currency;
              _context16.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + pairingID + '/influencers/payout-amount', true, {
                payoutAmount: payoutAmount,
                currency: currency
              });

            case 4:
              response = _context16.sent;

              if (!(response.status !== 200)) {
                _context16.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context16.abrupt('return', true);

            case 10:
              _context16.prev = 10;
              _context16.t0 = _context16['catch'](0);
              throw _context16.t0;

            case 13:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16, [[0, 10]]);
    }))();
  },
  sendListInfluencersToAM: function sendListInfluencersToAM(campaignID) {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + campaignID + '/send-list-am', true);

            case 3:
              response = _context17.sent;

              if (!(response.status !== 200)) {
                _context17.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context17.abrupt('return', response.data);

            case 9:
              _context17.prev = 9;
              _context17.t0 = _context17['catch'](0);
              throw _context17.t0;

            case 12:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17, [[0, 9]]);
    }))();
  },
  sendListInfluencersToClient: function sendListInfluencersToClient(campaignID) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + campaignID + '/send-list-client', true);

            case 3:
              response = _context18.sent;

              if (!(response.status !== 200)) {
                _context18.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context18.abrupt('return', response.data);

            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18['catch'](0);
              throw _context18.t0;

            case 12:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18, [[0, 9]]);
    }))();
  },
  sendCOGSExceedReminder: function sendCOGSExceedReminder(campaignID) {
    var _this19 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + campaignID + '/send-cogs-exceed-reminder', true);

            case 3:
              response = _context19.sent;

              if (!(response.status !== 200)) {
                _context19.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context19.abrupt('return', response.data);

            case 9:
              _context19.prev = 9;
              _context19.t0 = _context19['catch'](0);
              throw _context19.t0;

            case 12:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19, [[0, 9]]);
    }))();
  },
  doSelect: function doSelect(pairingID) {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + pairingID + '/select', true);

            case 3:
              response = _context20.sent;

              if (!(response.status !== 200)) {
                _context20.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context20.abrupt('return', response.data);

            case 9:
              _context20.prev = 9;
              _context20.t0 = _context20['catch'](0);
              throw _context20.t0;

            case 12:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20, [[0, 9]]);
    }))();
  },
  doEliminate: function doEliminate(pairingID, reason) {
    var _this21 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee21() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              _context21.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + pairingID + '/eliminate', true, {
                reasonOfElimination: reason
              });

            case 3:
              response = _context21.sent;

              if (!(response.status !== 200)) {
                _context21.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context21.abrupt('return', response.data);

            case 9:
              _context21.prev = 9;
              _context21.t0 = _context21['catch'](0);
              throw _context21.t0;

            case 12:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21, [[0, 9]]);
    }))();
  },
  getInfluencerFromAI: function getInfluencerFromAI(campaignID, force) {
    var _this22 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var matchParams, url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              matchParams = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.aiMatchParams;
              url = '/api/v1/pairings/campaign/' + campaignID + '/from-AI?force=' + force + '&size=' + matchParams.size + '&minFollowers=' + matchParams.minFollowers + '&postDate=' + matchParams.postDate;
              _context22.prev = 2;
              _context22.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true);

            case 5:
              response = _context22.sent;

              if (!(response.status !== 200)) {
                _context22.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context22.abrupt('return', response.data);

            case 11:
              _context22.prev = 11;
              _context22.t0 = _context22['catch'](2);
              throw _context22.t0;

            case 14:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22, [[2, 11]]);
    }))();
  },
  updatePairingStatus: function updatePairingStatus(data) {
    var _this23 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee23() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _context23.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + data.pairingID + '/pair-details', true, data);

            case 3:
              response = _context23.sent;

              if (!(response.status !== 200)) {
                _context23.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context23.abrupt('return', response.data);

            case 9:
              _context23.prev = 9;
              _context23.t0 = _context23['catch'](0);
              throw _context23.t0;

            case 12:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this23, [[0, 9]]);
    }))();
  },
  updatePairingStatusOnly: function updatePairingStatusOnly(pairingId, data) {
    var _this24 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee24() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              _context24.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + pairingId + '/update-status', true, data);

            case 3:
              response = _context24.sent;

              if (!(response.status !== 200)) {
                _context24.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context24.abrupt('return', response.data);

            case 9:
              _context24.prev = 9;
              _context24.t0 = _context24['catch'](0);
              throw _context24.t0;

            case 12:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this24, [[0, 9]]);
    }))();
  },
  saveEditedPairingData: function saveEditedPairingData(data) {
    var _this25 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee25() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              _context25.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/edited-data', true, data);

            case 3:
              response = _context25.sent;

              if (!(response.status !== 200)) {
                _context25.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context25.abrupt('return', response.data);

            case 9:
              _context25.prev = 9;
              _context25.t0 = _context25['catch'](0);
              throw _context25.t0;

            case 12:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this25, [[0, 9]]);
    }))();
  },
  saveInfListData: function saveInfListData(data) {
    var _this26 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee26() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/inf-lists', true, data);

            case 3:
              response = _context26.sent;

              if (!(response.status !== 200)) {
                _context26.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context26.abrupt('return', response.data);

            case 9:
              _context26.prev = 9;
              _context26.t0 = _context26['catch'](0);
              throw _context26.t0;

            case 12:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this26, [[0, 9]]);
    }))();
  },
  saveEditedCampaignInvite: function saveEditedCampaignInvite(data) {
    var _this27 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee27() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;
              _context27.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/edited-invite-data', true, data);

            case 3:
              response = _context27.sent;

              if (!(response.status !== 200)) {
                _context27.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context27.abrupt('return', response.data);

            case 9:
              _context27.prev = 9;
              _context27.t0 = _context27['catch'](0);
              throw _context27.t0;

            case 12:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this27, [[0, 9]]);
    }))();
  },
  updatePairings: function updatePairings(formData) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('PATCH', '/api/v1/pairings/update/data', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  confirmAdminPayout: function confirmAdminPayout(data) {
    var _this28 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee28() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;
              _context28.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/confirm/admin-payout', true, data);

            case 3:
              response = _context28.sent;

              if (!(response.status !== 200)) {
                _context28.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context28.abrupt('return', response.data);

            case 9:
              _context28.prev = 9;
              _context28.t0 = _context28['catch'](0);
              throw _context28.t0;

            case 12:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this28, [[0, 9]]);
    }))();
  },
  confirmAdminPayoutOnly: function confirmAdminPayoutOnly(pairingID) {
    var _this29 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee29() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.prev = 0;
              _context29.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/confirm/admin-payout/' + pairingID, true);

            case 3:
              response = _context29.sent;

              if (!(response.status !== 200)) {
                _context29.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context29.abrupt('return', response.data);

            case 9:
              _context29.prev = 9;
              _context29.t0 = _context29['catch'](0);
              throw _context29.t0;

            case 12:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this29, [[0, 9]]);
    }))();
  },
  cancelAdminPayout: function cancelAdminPayout(pairingID) {
    var _this30 = this;

    var reasons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee30() {
      var data, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.prev = 0;
              data = {};

              if (reasons) {
                data.reasons = reasons;
              }
              _context30.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/cancel/admin-payout/' + pairingID, true, data);

            case 5:
              response = _context30.sent;

              if (!(response.status !== 200)) {
                _context30.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context30.abrupt('return', response.data);

            case 11:
              _context30.prev = 11;
              _context30.t0 = _context30['catch'](0);
              throw _context30.t0;

            case 14:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this30, [[0, 11]]);
    }))();
  },
  uploadPayoutInvoice: function uploadPayoutInvoice(data) {
    var _this31 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee31() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.prev = 0;
              _context31.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/upload/payout-invoice', true, data);

            case 3:
              response = _context31.sent;

              if (!(response.status !== 200)) {
                _context31.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context31.abrupt('return', response.data);

            case 9:
              _context31.prev = 9;
              _context31.t0 = _context31['catch'](0);
              throw _context31.t0;

            case 12:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this31, [[0, 9]]);
    }))();
  },
  updatePayoutHistory: function updatePayoutHistory(data) {
    var _this32 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee32() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;
              _context32.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/update/payout-history', true, data);

            case 3:
              response = _context32.sent;

              if (!(response.status !== 200)) {
                _context32.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context32.abrupt('return', response.data);

            case 9:
              _context32.prev = 9;
              _context32.t0 = _context32['catch'](0);
              throw _context32.t0;

            case 12:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this32, [[0, 9]]);
    }))();
  },
  saveClientNote: function saveClientNote(data) {
    var _this33 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee33() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;
              _context33.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/save/client-note', true, data);

            case 3:
              response = _context33.sent;

              if (!(response.status !== 200)) {
                _context33.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context33.abrupt('return', response.data);

            case 9:
              _context33.prev = 9;
              _context33.t0 = _context33['catch'](0);
              throw _context33.t0;

            case 12:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this33, [[0, 9]]);
    }))();
  },
  saveClientNoteRead: function saveClientNoteRead(data) {
    var _this34 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee34() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.prev = 0;
              _context34.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/read/client-note', true, data);

            case 3:
              response = _context34.sent;

              if (!(response.status !== 200)) {
                _context34.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context34.abrupt('return', response.data);

            case 9:
              _context34.prev = 9;
              _context34.t0 = _context34['catch'](0);
              throw _context34.t0;

            case 12:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this34, [[0, 9]]);
    }))();
  },
  updateClientNote: function updateClientNote(data) {
    var _this35 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee35() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.prev = 0;
              _context35.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/update/client-note', true, data);

            case 3:
              response = _context35.sent;

              if (!(response.status !== 200)) {
                _context35.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context35.abrupt('return', response.data);

            case 9:
              _context35.prev = 9;
              _context35.t0 = _context35['catch'](0);
              throw _context35.t0;

            case 12:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this35, [[0, 9]]);
    }))();
  },
  inviteInfluencerToCampaign: function inviteInfluencerToCampaign(pairingID, inviteData) {
    var _this36 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee36() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.prev = 0;
              url = '/api/v1/pairings/' + pairingID + '/send-invite';
              _context36.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, {
                inviteData: inviteData
              });

            case 4:
              response = _context36.sent;

              if (!(response.status !== 200)) {
                _context36.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context36.abrupt('return', response.data);

            case 10:
              _context36.prev = 10;
              _context36.t0 = _context36['catch'](0);
              throw _context36.t0;

            case 13:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this36, [[0, 10]]);
    }))();
  },
  getInvitation: function getInvitation(campaignID, influencerID, instagramID, instagramHandle) {
    var _this37 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee37() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?influencer=' + influencerID;
              _context37.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context37.sent;

              if (!(response.status !== 200)) {
                _context37.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context37.abrupt('return', response.data);

            case 10:
              _context37.prev = 10;
              _context37.t0 = _context37['catch'](0);
              throw _context37.t0;

            case 13:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, _this37, [[0, 10]]);
    }))();
  },
  getInvitationbyIGHandle: function getInvitationbyIGHandle(campaignID, instagramHandle) {
    var _this38 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee38() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _context38.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?igHandle=' + instagramHandle + '&platform=instagram';
              _context38.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context38.sent;

              if (!(response.status !== 200)) {
                _context38.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context38.abrupt('return', response.data);

            case 10:
              _context38.prev = 10;
              _context38.t0 = _context38['catch'](0);
              throw _context38.t0;

            case 13:
            case 'end':
              return _context38.stop();
          }
        }
      }, _callee38, _this38, [[0, 10]]);
    }))();
  },
  getInvitationTikTok: function getInvitationTikTok(campaignID, handle) {
    var _this39 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee39() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?tiktokHandle=' + handle + '&platform=tiktok';
              _context39.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context39.sent;

              if (!(response.status !== 200)) {
                _context39.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context39.abrupt('return', response.data);

            case 10:
              _context39.prev = 10;
              _context39.t0 = _context39['catch'](0);
              throw _context39.t0;

            case 13:
            case 'end':
              return _context39.stop();
          }
        }
      }, _callee39, _this39, [[0, 10]]);
    }))();
  },
  getInvitationYoutube: function getInvitationYoutube(campaignID, handle) {
    var _this40 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee40() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?youtubeHandle=' + handle + '&platform=youtube';
              _context40.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context40.sent;

              if (!(response.status !== 200)) {
                _context40.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context40.abrupt('return', response.data);

            case 10:
              _context40.prev = 10;
              _context40.t0 = _context40['catch'](0);
              throw _context40.t0;

            case 13:
            case 'end':
              return _context40.stop();
          }
        }
      }, _callee40, _this40, [[0, 10]]);
    }))();
  },
  getInvitationFacebook: function getInvitationFacebook(campaignID, handle) {
    var _this41 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee41() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?fbHandle=' + handle + '&platform=facebook';
              _context41.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context41.sent;

              if (!(response.status !== 200)) {
                _context41.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context41.abrupt('return', response.data);

            case 10:
              _context41.prev = 10;
              _context41.t0 = _context41['catch'](0);
              throw _context41.t0;

            case 13:
            case 'end':
              return _context41.stop();
          }
        }
      }, _callee41, _this41, [[0, 10]]);
    }))();
  },
  getInvitationXHS: function getInvitationXHS(campaignID, handle) {
    var _this42 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee42() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              _context42.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?xhsHandle=' + handle + '&platform=xhs';
              _context42.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context42.sent;

              if (!(response.status !== 200)) {
                _context42.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context42.abrupt('return', response.data);

            case 10:
              _context42.prev = 10;
              _context42.t0 = _context42['catch'](0);
              throw _context42.t0;

            case 13:
            case 'end':
              return _context42.stop();
          }
        }
      }, _callee42, _this42, [[0, 10]]);
    }))();
  },
  getInvitationOthers: function getInvitationOthers(campaignID, handle) {
    var _this43 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee43() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              _context43.prev = 0;
              url = '/api/v1/pairings/campaign/' + campaignID + '/invitation?otherHandle=' + handle + '&platform=others';
              _context43.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context43.sent;

              if (!(response.status !== 200)) {
                _context43.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context43.abrupt('return', response.data);

            case 10:
              _context43.prev = 10;
              _context43.t0 = _context43['catch'](0);
              throw _context43.t0;

            case 13:
            case 'end':
              return _context43.stop();
          }
        }
      }, _callee43, _this43, [[0, 10]]);
    }))();
  },
  getInvitedCampaigns: function getInvitedCampaigns(influencerID, status) {
    var _this44 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee44() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              _context44.prev = 0;
              url = '/api/v1/pairings/campaigns/invited?influencerID=' + influencerID + '&status=' + status;
              _context44.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context44.sent;

              if (!(response.status !== 200)) {
                _context44.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context44.abrupt('return', response.data);

            case 10:
              _context44.prev = 10;
              _context44.t0 = _context44['catch'](0);
              throw _context44.t0;

            case 13:
            case 'end':
              return _context44.stop();
          }
        }
      }, _callee44, _this44, [[0, 10]]);
    }))();
  },
  doAction: function doAction(pairingID, action) {
    var _this45 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee45() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              _context45.prev = 0;
              url = '/api/v1/pairings/' + pairingID + '/action/' + action;
              _context45.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true);

            case 4:
              response = _context45.sent;

              if (!(response.status !== 200)) {
                _context45.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context45.abrupt('return', response.data);

            case 10:
              _context45.prev = 10;
              _context45.t0 = _context45['catch'](0);
              throw _context45.t0;

            case 13:
            case 'end':
              return _context45.stop();
          }
        }
      }, _callee45, _this45, [[0, 10]]);
    }))();
  },
  getPairedAmount: function getPairedAmount(campaignID, influencerID) {
    var _this46 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee46() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              _context46.prev = 0;
              url = '/api/v1/pairings/' + campaignID + '/payout?influencerID=' + influencerID;
              _context46.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context46.sent;

              if (!(response.status !== 200)) {
                _context46.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context46.abrupt('return', response.data);

            case 10:
              _context46.prev = 10;
              _context46.t0 = _context46['catch'](0);
              throw _context46.t0;

            case 13:
            case 'end':
              return _context46.stop();
          }
        }
      }, _callee46, _this46, [[0, 10]]);
    }))();
  },
  sendClientAcceptedInfluencerListEmailNotify: function sendClientAcceptedInfluencerListEmailNotify(params) {
    var _this47 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee47() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              _context47.prev = 0;
              url = '/api/v1/posts/client/accepted-influencer-list/notify';
              _context47.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, params);

            case 4:
              response = _context47.sent;

              if (!(response.status !== 200)) {
                _context47.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context47.abrupt('return', response.data);

            case 10:
              _context47.prev = 10;
              _context47.t0 = _context47['catch'](0);
              throw _context47.t0;

            case 13:
            case 'end':
              return _context47.stop();
          }
        }
      }, _callee47, _this47, [[0, 10]]);
    }))();
  },
  postQuestions: function postQuestions(params) {
    var _this48 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee48() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              _context48.prev = 0;
              url = '/api/v1/pairings/inquiry';
              _context48.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, params);

            case 4:
              response = _context48.sent;

              if (!(response.status !== 200 && response.status !== 201)) {
                _context48.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context48.abrupt('return', response.data);

            case 10:
              _context48.prev = 10;
              _context48.t0 = _context48['catch'](0);
              throw _context48.t0;

            case 13:
            case 'end':
              return _context48.stop();
          }
        }
      }, _callee48, _this48, [[0, 10]]);
    }))();
  },
  getQuestions: function getQuestions(campaignID, influencerID) {
    var _this49 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee49() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              _context49.prev = 0;
              url = '/api/v1/pairings/inquiry/' + campaignID + '/' + influencerID;
              _context49.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context49.sent;

              if (!(response.status !== 200)) {
                _context49.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context49.abrupt('return', response.data);

            case 10:
              _context49.prev = 10;
              _context49.t0 = _context49['catch'](0);
              throw _context49.t0;

            case 13:
            case 'end':
              return _context49.stop();
          }
        }
      }, _callee49, _this49, [[0, 10]]);
    }))();
  },
  putComment: function putComment(params) {
    var _this50 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee50() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              _context50.prev = 0;
              url = '/api/v1/pairings/inquiry';
              _context50.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, params);

            case 4:
              response = _context50.sent;

              if (!(response.status !== 200 && response.status !== 201)) {
                _context50.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context50.abrupt('return', response.data);

            case 10:
              _context50.prev = 10;
              _context50.t0 = _context50['catch'](0);
              throw _context50.t0;

            case 13:
            case 'end':
              return _context50.stop();
          }
        }
      }, _callee50, _this50, [[0, 10]]);
    }))();
  },
  triggerEmailToCO: function triggerEmailToCO(params) {
    var _this51 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee51() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee51$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              _context51.prev = 0;
              url = '/api/v1/posts/influencer/questions';
              _context51.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, params);

            case 4:
              response = _context51.sent;

              if (!(response.status !== 200)) {
                _context51.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context51.abrupt('return', response.data);

            case 10:
              _context51.prev = 10;
              _context51.t0 = _context51['catch'](0);
              throw _context51.t0;

            case 13:
            case 'end':
              return _context51.stop();
          }
        }
      }, _callee51, _this51, [[0, 10]]);
    }))();
  },
  triggerEmailToInfluencer: function triggerEmailToInfluencer(params) {
    var _this52 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee52() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee52$(_context52) {
        while (1) {
          switch (_context52.prev = _context52.next) {
            case 0:
              _context52.prev = 0;
              url = '/api/v1/posts/co/reply/questions';
              _context52.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, params);

            case 4:
              response = _context52.sent;

              if (!(response.status !== 200)) {
                _context52.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context52.abrupt('return', response.data);

            case 10:
              _context52.prev = 10;
              _context52.t0 = _context52['catch'](0);
              throw _context52.t0;

            case 13:
            case 'end':
              return _context52.stop();
          }
        }
      }, _callee52, _this52, [[0, 10]]);
    }))();
  },
  doReject: function doReject(pairingID, reason) {
    var _this53 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee53() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee53$(_context53) {
        while (1) {
          switch (_context53.prev = _context53.next) {
            case 0:
              _context53.prev = 0;
              url = '/api/v1/pairings/' + pairingID + '/reject_reason';
              _context53.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, reason);

            case 4:
              response = _context53.sent;

              if (!(response.status !== 200)) {
                _context53.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context53.abrupt('return', response.data);

            case 10:
              _context53.prev = 10;
              _context53.t0 = _context53['catch'](0);
              throw _context53.t0;

            case 13:
            case 'end':
              return _context53.stop();
          }
        }
      }, _callee53, _this53, [[0, 10]]);
    }))();
  },
  getAllPairedInfluencer: function getAllPairedInfluencer(userID, page, limit) {
    var _this54 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee54() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee54$(_context54) {
        while (1) {
          switch (_context54.prev = _context54.next) {
            case 0:
              _context54.prev = 0;
              url = '/api/v1/pairings/get/all/paired/influencer?userID=' + userID + '&page=' + page + '&limit=' + limit;
              _context54.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context54.sent;

              if (!(response.status !== 200)) {
                _context54.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context54.abrupt('return', response.data);

            case 10:
              _context54.prev = 10;
              _context54.t0 = _context54['catch'](0);
              throw _context54.t0;

            case 13:
            case 'end':
              return _context54.stop();
          }
        }
      }, _callee54, _this54, [[0, 10]]);
    }))();
  },
  getAllPairings: function getAllPairings() {
    var _this55 = this;

    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee55() {
      var params, url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee55$(_context55) {
        while (1) {
          switch (_context55.prev = _context55.next) {
            case 0:
              _context55.prev = 0;
              params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              url = '/api/v1/pairings/all/data?' + params;
              _context55.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 5:
              response = _context55.sent;

              if (!(response.status !== 200)) {
                _context55.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context55.abrupt('return', response.data);

            case 11:
              _context55.prev = 11;
              _context55.t0 = _context55['catch'](0);
              throw _context55.t0;

            case 14:
            case 'end':
              return _context55.stop();
          }
        }
      }, _callee55, _this55, [[0, 11]]);
    }))();
  },
  getAllPayoutSubmittedPairings: function getAllPayoutSubmittedPairings() {
    var _this56 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee56() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee56$(_context56) {
        while (1) {
          switch (_context56.prev = _context56.next) {
            case 0:
              _context56.prev = 0;
              url = '/api/v1/pairings/get/all/payout-submitted';
              _context56.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context56.sent;

              if (!(response.status !== 200)) {
                _context56.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context56.abrupt('return', response.data);

            case 10:
              _context56.prev = 10;
              _context56.t0 = _context56['catch'](0);
              throw _context56.t0;

            case 13:
            case 'end':
              return _context56.stop();
          }
        }
      }, _callee56, _this56, [[0, 10]]);
    }))();
  },
  getPairedInfluencer: function getPairedInfluencer(pairedID) {
    var _this57 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee57() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee57$(_context57) {
        while (1) {
          switch (_context57.prev = _context57.next) {
            case 0:
              _context57.prev = 0;
              url = '/api/v1/pairings/get/paired/influencer?pairedID=' + pairedID;
              _context57.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context57.sent;

              if (!(response.status !== 200)) {
                _context57.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context57.abrupt('return', response.data);

            case 10:
              _context57.prev = 10;
              _context57.t0 = _context57['catch'](0);
              throw _context57.t0;

            case 13:
            case 'end':
              return _context57.stop();
          }
        }
      }, _callee57, _this57, [[0, 10]]);
    }))();
  },
  getPairedInfluencerOpen: function getPairedInfluencerOpen(pairedID) {
    var _this58 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee58() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee58$(_context58) {
        while (1) {
          switch (_context58.prev = _context58.next) {
            case 0:
              _context58.prev = 0;
              url = '/api/v1/pairings-open/get/paired/influencer?pairedID=' + pairedID;
              _context58.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context58.sent;

              if (!(response.status !== 200)) {
                _context58.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context58.abrupt('return', response.data);

            case 10:
              _context58.prev = 10;
              _context58.t0 = _context58['catch'](0);
              throw _context58.t0;

            case 13:
            case 'end':
              return _context58.stop();
          }
        }
      }, _callee58, _this58, [[0, 10]]);
    }))();
  },
  getPairedInfluencerStoryBoardOpen: function getPairedInfluencerStoryBoardOpen(pairedID) {
    var _this59 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee59() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee59$(_context59) {
        while (1) {
          switch (_context59.prev = _context59.next) {
            case 0:
              _context59.prev = 0;
              url = '/api/v1/pairings-open/get/paired/influencer?pairedID=' + pairedID + '&storyboard=true';
              _context59.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true);

            case 4:
              response = _context59.sent;

              if (!(response.status !== 200)) {
                _context59.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context59.abrupt('return', response.data);

            case 10:
              _context59.prev = 10;
              _context59.t0 = _context59['catch'](0);
              throw _context59.t0;

            case 13:
            case 'end':
              return _context59.stop();
          }
        }
      }, _callee59, _this59, [[0, 10]]);
    }))();
  },
  updatePayoutById: function updatePayoutById(params) {
    var _this60 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee60() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee60$(_context60) {
        while (1) {
          switch (_context60.prev = _context60.next) {
            case 0:
              _context60.prev = 0;
              url = '/api/v1/pairings/paired/influencer/payout';
              _context60.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, params);

            case 4:
              response = _context60.sent;

              if (!(response.status !== 200)) {
                _context60.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context60.abrupt('return', response.data);

            case 10:
              _context60.prev = 10;
              _context60.t0 = _context60['catch'](0);

              console.log(_context60.t0);
              throw _context60.t0;

            case 14:
            case 'end':
              return _context60.stop();
          }
        }
      }, _callee60, _this60, [[0, 10]]);
    }))();
  },
  updateStatusEmail: function updateStatusEmail(params) {
    var _this61 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee61() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee61$(_context61) {
        while (1) {
          switch (_context61.prev = _context61.next) {
            case 0:
              _context61.prev = 0;
              url = '/api/v1/pairings/status/update/email';
              _context61.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, params);

            case 4:
              response = _context61.sent;

              if (!(response.status !== 200)) {
                _context61.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context61.abrupt('return', response.data);

            case 10:
              _context61.prev = 10;
              _context61.t0 = _context61['catch'](0);

              console.log(_context61.t0);
              throw _context61.t0;

            case 14:
            case 'end':
              return _context61.stop();
          }
        }
      }, _callee61, _this61, [[0, 10]]);
    }))();
  },
  updatePairingBriefDetails: function updatePairingBriefDetails(data) {
    var _this62 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee62() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee62$(_context62) {
        while (1) {
          switch (_context62.prev = _context62.next) {
            case 0:
              _context62.prev = 0;
              _context62.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + data.pairingID + '/brief-details', true, data);

            case 3:
              response = _context62.sent;

              if (!(response.status !== 200)) {
                _context62.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context62.abrupt('return', response.data);

            case 9:
              _context62.prev = 9;
              _context62.t0 = _context62['catch'](0);
              throw _context62.t0;

            case 12:
            case 'end':
              return _context62.stop();
          }
        }
      }, _callee62, _this62, [[0, 9]]);
    }))();
  },
  addContracts: function addContracts(data) {
    var _this63 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee63() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee63$(_context63) {
        while (1) {
          switch (_context63.prev = _context63.next) {
            case 0:
              _context63.prev = 0;
              _context63.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + data.pairingID + '/contract', true, data);

            case 3:
              response = _context63.sent;

              if (!(response.status !== 200)) {
                _context63.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context63.abrupt('return', response.data);

            case 9:
              _context63.prev = 9;
              _context63.t0 = _context63['catch'](0);
              throw _context63.t0;

            case 12:
            case 'end':
              return _context63.stop();
          }
        }
      }, _callee63, _this63, [[0, 9]]);
    }))();
  },
  sendInfluencerStatusUpdateEmailToCO: function sendInfluencerStatusUpdateEmailToCO(params) {
    var _this64 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee64() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee64$(_context64) {
        while (1) {
          switch (_context64.prev = _context64.next) {
            case 0:
              _context64.prev = 0;
              url = '/api/v1/pairings/influencer/status/update/email';
              _context64.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, params);

            case 4:
              response = _context64.sent;

              if (!(response.status !== 200)) {
                _context64.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context64.abrupt('return', response.data);

            case 10:
              _context64.prev = 10;
              _context64.t0 = _context64['catch'](0);

              console.log(_context64.t0);
              throw _context64.t0;

            case 14:
            case 'end':
              return _context64.stop();
          }
        }
      }, _callee64, _this64, [[0, 10]]);
    }))();
  },
  sendContractToInfluencer: function sendContractToInfluencer(formData) {
    var _this65 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee65() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee65$(_context65) {
        while (1) {
          switch (_context65.prev = _context65.next) {
            case 0:
              _context65.prev = 0;
              url = '/api/v1/pairings/influencer/contract/email';
              _context65.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, formData);

            case 4:
              response = _context65.sent;

              if (!(response.status !== 200)) {
                _context65.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context65.abrupt('return', response.data);

            case 10:
              _context65.prev = 10;
              _context65.t0 = _context65['catch'](0);

              console.log(_context65.t0);
              throw _context65.t0;

            case 14:
            case 'end':
              return _context65.stop();
          }
        }
      }, _callee65, _this65, [[0, 10]]);
    }))();
  },
  updateSubmissionAndLiveDates: function updateSubmissionAndLiveDates(formData) {
    var _this66 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee66() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee66$(_context66) {
        while (1) {
          switch (_context66.prev = _context66.next) {
            case 0:
              _context66.prev = 0;
              url = '/api/v1/pairings/submission/update';
              _context66.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, formData);

            case 4:
              response = _context66.sent;

              if (!(response.status !== 200)) {
                _context66.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context66.abrupt('return', {
                data: response.data,
                status: response.status
              });

            case 10:
              _context66.prev = 10;
              _context66.t0 = _context66['catch'](0);

              console.log(_context66.t0);
              throw _context66.t0;

            case 14:
            case 'end':
              return _context66.stop();
          }
        }
      }, _callee66, _this66, [[0, 10]]);
    }))();
  },
  updateSubmissionDate: function updateSubmissionDate(formData) {
    var _this67 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee67() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee67$(_context67) {
        while (1) {
          switch (_context67.prev = _context67.next) {
            case 0:
              _context67.prev = 0;
              url = '/api/v1/pairings-open/update/submission-date';
              _context67.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, formData);

            case 4:
              response = _context67.sent;

              if (!(response.status !== 200)) {
                _context67.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context67.abrupt('return', {
                data: response.data,
                status: response.status
              });

            case 10:
              _context67.prev = 10;
              _context67.t0 = _context67['catch'](0);

              console.log(_context67.t0);
              throw _context67.t0;

            case 14:
            case 'end':
              return _context67.stop();
          }
        }
      }, _callee67, _this67, [[0, 10]]);
    }))();
  },
  updateContractAgreement: function updateContractAgreement(data) {
    var _this68 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee68() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee68$(_context68) {
        while (1) {
          switch (_context68.prev = _context68.next) {
            case 0:
              _context68.prev = 0;
              _context68.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + data.pairingID + '/contract/agreement', true, data);

            case 3:
              response = _context68.sent;

              if (!(response.status !== 200)) {
                _context68.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context68.abrupt('return', response.data);

            case 9:
              _context68.prev = 9;
              _context68.t0 = _context68['catch'](0);
              throw _context68.t0;

            case 12:
            case 'end':
              return _context68.stop();
          }
        }
      }, _callee68, _this68, [[0, 9]]);
    }))();
  },
  sendFollowUpEmail: function sendFollowUpEmail(data) {
    var _this69 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee69() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee69$(_context69) {
        while (1) {
          switch (_context69.prev = _context69.next) {
            case 0:
              _context69.prev = 0;
              _context69.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/followup/email', true, data);

            case 3:
              response = _context69.sent;

              if (!(response.status !== 200)) {
                _context69.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context69.abrupt('return', response.data);

            case 9:
              _context69.prev = 9;
              _context69.t0 = _context69['catch'](0);
              throw _context69.t0;

            case 12:
            case 'end':
              return _context69.stop();
          }
        }
      }, _callee69, _this69, [[0, 9]]);
    }))();
  },
  updateLineUpIndex: function updateLineUpIndex(data) {
    var _this70 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee70() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee70$(_context70) {
        while (1) {
          switch (_context70.prev = _context70.next) {
            case 0:
              _context70.prev = 0;
              _context70.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/' + data.pairingID + '/lineup', true, data);

            case 3:
              response = _context70.sent;

              if (!(response.status !== 200)) {
                _context70.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context70.abrupt('return', response.data);

            case 9:
              _context70.prev = 9;
              _context70.t0 = _context70['catch'](0);
              throw _context70.t0;

            case 12:
            case 'end':
              return _context70.stop();
          }
        }
      }, _callee70, _this70, [[0, 9]]);
    }))();
  },
  updateGSTamount: function updateGSTamount(params) {
    var _this71 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee71() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee71$(_context71) {
        while (1) {
          switch (_context71.prev = _context71.next) {
            case 0:
              _context71.prev = 0;
              url = '/api/v1/pairings/GST/update';
              _context71.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', url, true, params);

            case 4:
              response = _context71.sent;

              if (!(response.status !== 200)) {
                _context71.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context71.abrupt('return', {
                data: response.data,
                status: response.status
              });

            case 10:
              _context71.prev = 10;
              _context71.t0 = _context71['catch'](0);

              console.log(_context71.t0);
              throw _context71.t0;

            case 14:
            case 'end':
              return _context71.stop();
          }
        }
      }, _callee71, _this71, [[0, 10]]);
    }))();
  },
  sendSubmissionGuide: function sendSubmissionGuide(param) {
    var _this72 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee72() {
      var url, data, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee72$(_context72) {
        while (1) {
          switch (_context72.prev = _context72.next) {
            case 0:
              _context72.prev = 0;
              url = '/api/v1/pairings/sendgrid/dynamic/email';
              data = param;
              _context72.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, data);

            case 5:
              response = _context72.sent;

              if (!(response.status !== 200)) {
                _context72.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context72.abrupt('return', response.data);

            case 11:
              _context72.prev = 11;
              _context72.t0 = _context72['catch'](0);

              console.log(_context72.t0);
              throw _context72.t0;

            case 15:
            case 'end':
              return _context72.stop();
          }
        }
      }, _callee72, _this72, [[0, 11]]);
    }))();
  },
  sendEmailSubmittedPost: function sendEmailSubmittedPost(param) {
    var _this73 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee73() {
      var url, data, response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee73$(_context73) {
        while (1) {
          switch (_context73.prev = _context73.next) {
            case 0:
              _context73.prev = 0;
              url = '/api/v1/pairings/sendgrid/dynamic/email';
              data = param;
              _context73.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, data);

            case 5:
              response = _context73.sent;

              if (!(response.status !== 200)) {
                _context73.next = 8;
                break;
              }

              throw new Error('Error');

            case 8:
              return _context73.abrupt('return', response.data);

            case 11:
              _context73.prev = 11;
              _context73.t0 = _context73['catch'](0);

              console.log(_context73.t0);
              throw _context73.t0;

            case 15:
            case 'end':
              return _context73.stop();
          }
        }
      }, _callee73, _this73, [[0, 11]]);
    }))();
  },
  getPostUnsubmittedPairingInfluencers: function getPostUnsubmittedPairingInfluencers(param) {
    var _this74 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee74() {
      var data, resp;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee74$(_context74) {
        while (1) {
          switch (_context74.prev = _context74.next) {
            case 0:
              _context74.prev = 0;
              data = param;
              _context74.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('POST', '/api/v1/pairings/unsubmitted/influencers', true, data);

            case 4:
              resp = _context74.sent;

              if (!(resp.status === 200)) {
                _context74.next = 7;
                break;
              }

              return _context74.abrupt('return', resp.data);

            case 7:
              throw new Error('Something went wrong');

            case 10:
              _context74.prev = 10;
              _context74.t0 = _context74['catch'](0);
              throw _context74.t0;

            case 13:
            case 'end':
              return _context74.stop();
          }
        }
      }, _callee74, _this74, [[0, 10]]);
    }))();
  },
  downloadCampaignPairingsReport: function downloadCampaignPairingsReport(campaignIDs, exportType) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var _this75 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download('/api/v1/pairings/all/download-report', 'POST', { campaignIDs: campaignIDs, exportType: exportType }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee75(response) {
          var blob, _blob;

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee75$(_context75) {
            while (1) {
              switch (_context75.prev = _context75.next) {
                case 0:
                  if (!(response.status !== 200)) {
                    _context75.next = 3;
                    break;
                  }

                  reject(response);
                  return _context75.abrupt('return');

                case 3:
                  if (exportType === 'csv') {
                    blob = new Blob([response.data], {
                      type: 'utf-8'
                    });

                    FileSaver.saveAs(blob, response.headers.filename);
                  } else if (exportType === 'excel') {
                    _blob = new Blob([response.data], {
                      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    FileSaver.saveAs(_blob, response.headers.filename);
                  }
                  resolve(response.data);

                case 5:
                case 'end':
                  return _context75.stop();
              }
            }
          }, _callee75, _this75);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  refreshPairingInfFromIMS: function refreshPairingInfFromIMS(campaignID) {
    var _this76 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee76() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee76$(_context76) {
        while (1) {
          switch (_context76.prev = _context76.next) {
            case 0:
              _context76.prev = 0;
              _context76.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/refresh/influencers/from-ims', true, {
                campaignID: campaignID
              });

            case 3:
              response = _context76.sent;

              if (!(response.status !== 200)) {
                _context76.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context76.abrupt('return', response.data);

            case 9:
              _context76.prev = 9;
              _context76.t0 = _context76['catch'](0);
              throw _context76.t0;

            case 12:
            case 'end':
              return _context76.stop();
          }
        }
      }, _callee76, _this76, [[0, 9]]);
    }))();
  },
  createConceptForm: function createConceptForm(feedback) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings-open/content-scripts', true, feedback).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  approveConceptForm: function approveConceptForm(formData) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings-open/content-scripts/approve', true, formData).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getContentScriptByPairingID: function getContentScriptByPairingID(pairingID) {
    var _this77 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee77() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee77$(_context77) {
        while (1) {
          switch (_context77.prev = _context77.next) {
            case 0:
              _context77.prev = 0;
              _context77.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings-open/content-scripts/bypairing/' + pairingID, true);

            case 3:
              response = _context77.sent;

              if (!(response.status !== 200)) {
                _context77.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context77.abrupt('return', response.data);

            case 9:
              _context77.prev = 9;
              _context77.t0 = _context77['catch'](0);
              throw _context77.t0;

            case 12:
            case 'end':
              return _context77.stop();
          }
        }
      }, _callee77, _this77, [[0, 9]]);
    }))();
  },
  getContentScriptVersions: function getContentScriptVersions(id) {
    var _this78 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee78() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee78$(_context78) {
        while (1) {
          switch (_context78.prev = _context78.next) {
            case 0:
              _context78.prev = 0;
              _context78.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings-open/content-scripts/' + id + '/versions', true);

            case 3:
              response = _context78.sent;

              if (!(response.status !== 200)) {
                _context78.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context78.abrupt('return', response.data);

            case 9:
              _context78.prev = 9;
              _context78.t0 = _context78['catch'](0);
              throw _context78.t0;

            case 12:
            case 'end':
              return _context78.stop();
          }
        }
      }, _callee78, _this78, [[0, 9]]);
    }))();
  },
  getContentScriptByinfID: function getContentScriptByinfID(infID) {
    var _this79 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee79() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee79$(_context79) {
        while (1) {
          switch (_context79.prev = _context79.next) {
            case 0:
              _context79.prev = 0;
              _context79.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings-open/content-scripts/byinf/' + infID, true);

            case 3:
              response = _context79.sent;

              if (!(response.status !== 200)) {
                _context79.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context79.abrupt('return', response.data);

            case 9:
              _context79.prev = 9;
              _context79.t0 = _context79['catch'](0);
              throw _context79.t0;

            case 12:
            case 'end':
              return _context79.stop();
          }
        }
      }, _callee79, _this79, [[0, 9]]);
    }))();
  },
  setMainVer: function setMainVer(id) {
    var _this80 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee80() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee80$(_context80) {
        while (1) {
          switch (_context80.prev = _context80.next) {
            case 0:
              _context80.prev = 0;
              _context80.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/pairings-open/content-scripts/set-main-ver/' + id, true);

            case 3:
              response = _context80.sent;

              if (!(response.status !== 200)) {
                _context80.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context80.abrupt('return', response.data);

            case 9:
              _context80.prev = 9;
              _context80.t0 = _context80['catch'](0);
              throw _context80.t0;

            case 12:
            case 'end':
              return _context80.stop();
          }
        }
      }, _callee80, _this80, [[0, 9]]);
    }))();
  },
  createComment: function createComment(newComment) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/pairings/content-scripts/comments', true, newComment).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadCreatorConceptRpt: function downloadCreatorConceptRpt(filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download('/api/v1/pairings/paired/creator-concepts', 'POST', filters).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'creators_concepts_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('X') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  sendContentFlowEmail: function sendContentFlowEmail(formData) {
    var _this81 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee81() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee81$(_context81) {
        while (1) {
          switch (_context81.prev = _context81.next) {
            case 0:
              return _context81.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/pairings/content-flow/email', true, formData).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context81.stop();
          }
        }
      }, _callee81, _this81);
    }))();
  }
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);







var FileSaver = __webpack_require__(119);
/* harmony default export */ __webpack_exports__["a"] = ({
  paginate: function paginate(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/search', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  localAllAudienceData: function localAllAudienceData(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/all/local/audience', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  searchAudDataKeyword: function searchAudDataKeyword(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/aud/search/keyword', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  searchKeyword: function searchKeyword(payload, sort, descending, limit, page) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/search/keyword?limit=' + limit + '&page=' + page + '&sortBy=' + sort + '&descending=' + descending, true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllInfluencers: function getAllInfluencers(force) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cacheInfluencerList = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.cache.influencerList;

      if (cacheInfluencerList.data !== null && force === false) {
        resolve(cacheInfluencerList);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers?limit=999', true).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_INFLUENCERS', response.data);

          resolve(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.cache.influencerList);
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  },
  fetchLocalAudienceReport: function fetchLocalAudienceReport(influencerId, instagramID, instagramHandle) {
    var _this = this;

    var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'instagram';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/local/report?instagramID=' + instagramID + '&instagramHandle=' + instagramHandle + '&id=' + influencerId + '&platform=' + platform, true);

            case 3:
              report = _context.sent;
              return _context.abrupt('return', report);

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);
              throw _context.t0;

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  fetchLocalAudienceReportByAudID: function fetchLocalAudienceReportByAudID(audID, handle) {
    var _this2 = this;

    var platform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'instagram';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/local/report?audienceID=' + audID + '&instagramHandle=' + handle + '&platform=' + platform, true);

            case 3:
              report = _context2.sent;
              return _context2.abrupt('return', report);

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  },
  downloadAudienceReport: function downloadAudienceReport(reportId, username) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response, blob;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/social-data/audience/reports/download/' + reportId);

            case 3:
              response = _context3.sent;
              blob = new Blob([response.data], {
                type: 'application/pdf'
              });

              FileSaver.saveAs(blob, username + '.pdf');
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](0);
              throw _context3.t0;

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  downloadAudienceReportByInstagramHandle: function downloadAudienceReportByInstagramHandle(username, platform) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response, blob;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/social-data/audience/reports/pdf/download?handle=' + username + '&platform=' + platform);

            case 3:
              response = _context4.sent;
              blob = new Blob([response.data], {
                type: 'application/pdf'
              });

              FileSaver.saveAs(blob, username + '_' + platform + '.pdf');
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](0);
              throw _context4.t0;

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  fetchLookalikeUsers: function fetchLookalikeUsers(keyword) {
    var _this5 = this;

    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'instagram';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/dict/users?keyword=' + keyword + '&platform=' + platform, true);

            case 3:
              report = _context5.sent;
              return _context5.abrupt('return', report);

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);
              throw _context5.t0;

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  getUserPosts: function getUserPosts(instagramID, instagramHandle, keyword) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/posts?instagramID=' + instagramID + '&instagramHandle=' + instagramHandle + '&keyword=' + keyword, true);

            case 3:
              report = _context6.sent;

              if (!(report.status === 200)) {
                _context6.next = 6;
                break;
              }

              return _context6.abrupt('return', report.data);

            case 6:
              throw new Error('Server Error');

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6['catch'](0);
              throw _context6.t0;

            case 12:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 9]]);
    }))();
  },
  refreshAudienceReport: function refreshAudienceReport(reportId) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/reports/' + reportId, true);

            case 3:
              report = _context7.sent;
              return _context7.abrupt('return', report);

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7['catch'](0);
              throw _context7.t0;

            case 10:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 7]]);
    }))();
  },
  exportAllInfluencers: function exportAllInfluencers() {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/influencers/export').then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  exportInfluencersByFilter: function exportInfluencersByFilter(influencers) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', '/api/v1/influencers/export/by/filter', true, influencers).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  exportNonIMSInfluencersByFilter: function exportNonIMSInfluencersByFilter(influencers) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/influencers/non-ims/export/by/filter', 'POST', influencers).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'influencers_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('X') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  exportAllCampaignPayouts: function exportAllCampaignPayouts() {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/payments/campaignPayout?fmt=xlsx').then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCampaignPayouts: function getAllCampaignPayouts(filters) {
    var query = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.objectToQueryString(filters);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/payments/campaignPayout?' + query, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCountries: function getCountries() {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/countries', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencer: function getInfluencer(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/' + influencerID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerCompany: function getInfluencerCompany(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/' + influencerID + '/companies', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createInfluencer: function createInfluencer(influencer) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers', true, influencer).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createCampaignPayout: function createCampaignPayout(influencerID, campaignPayout) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/' + influencerID + '/campaignPayouts', true, campaignPayout).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editCampaignPayout: function editCampaignPayout(id, updateData) {
    var payoutID = id;
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/payments/campaignPayout/' + payoutID, true, updateData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editInfluencer: function editInfluencer(influencer) {
    var influencerID = influencer.id;
    delete influencer.id;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/influencers/' + influencerID, true, influencer).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteInfluencer: function deleteInfluencer(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('delete', '/api/v1/influencers/' + influencerID + '/delete', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  assignCompany: function assignCompany(influencerID, companyID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/' + influencerID + '/companies', true, {
        companyID: companyID
      }).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  unassignCompany: function unassignCompany(influencerID, companyID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('delete', '/api/v1/influencers/' + influencerID + '/companies/' + companyID, true).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  searchInfluencers: function searchInfluencers() {
    var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers?keyword=' + keyword, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getWordcloud: function getWordcloud(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/wordcloud/' + influencerID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  validateInfluencer: function validateInfluencer(igHandle) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var url, resp, data, user, influencer;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              url = 'https://instagram.com/' + igHandle + '/?__a=1';
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', url);

            case 4:
              resp = _context8.sent;
              data = resp.data;
              user = data.graphql.user;
              influencer = {
                instagramHandle: user.username,
                instagramID: user.id,
                picture: user.profile_pic_url_hd
              };
              return _context8.abrupt('return', {
                success: true,
                influencer: influencer
              });

            case 11:
              _context8.prev = 11;
              _context8.t0 = _context8['catch'](0);
              return _context8.abrupt('return', {
                success: false
              });

            case 14:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 11]]);
    }))();
  },
  getInfluencerDeleteRequests: function getInfluencerDeleteRequests() {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/accountDeleteRequest', true).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  accountDeleteRequest: function accountDeleteRequest(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/accountDeleteRequest', true, payload).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  cancelDeleteRequest: function cancelDeleteRequest(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('delete', '/api/v1/influencers/accountDeleteRequest/' + influencerID, true).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }
        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  accountDeleteStatus: function accountDeleteStatus(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/accountDeleteRequest/' + influencerID, true).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  confirmAccountDeleteRequest: function confirmAccountDeleteRequest(id) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/accountDeleteRequest/confirmDelete/' + id, true).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }
        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  importInfluencers: function importInfluencers(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/influencers/import/byhandles', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  importRateCard: function importRateCard(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/influencers/import/rate-card', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBanks: function getBanks(code) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/banks/' + code, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllRateCards: function getAllRateCards(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/rate-card?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveRateCard: function saveRateCard(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/influencers-open/rate-card', true, formData).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveCreatorCommunity: function saveCreatorCommunity(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/influencers-open/creator-community', true, formData).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCreatorCommunities: function getAllCreatorCommunities(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/creator-community?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadRateCardRpt: function downloadRateCardRpt(influencers) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/influencers/rate-card/download', 'POST', influencers).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'Ratecard_Forms_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('X') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadCreatorCommunityRpt: function downloadCreatorCommunityRpt(influencers) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/influencers/creator-community/download', 'POST', influencers).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'CreatorCommunity_Forms_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('X') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateCreatorCommunityById: function updateCreatorCommunityById(data) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/influencers/creator-community/' + data.id, true, data).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          resolve(response.data);
          return;
        }
        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveMutliplePlatforms: function saveMutliplePlatforms(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/save/multiple-platforms', true, formData).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  discountPlatforms: function discountPlatforms(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/disconnect/multiple-platforms', true, formData).then(function (response) {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data);
          return;
        }

        reject(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAudienceData: function getAudienceData(handle) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/influencer/profile?handle=' + handle, true).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getTikTokAudienceData: function getTikTokAudienceData(handle) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/influencer/tikTok/profile?handle=' + handle, true).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  getYoutubeAudienceData: function getYoutubeAudienceData(handle) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/influencer/youtube/profile?handle=' + handle, true).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(response.data);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  searchTopicKeyword: function searchTopicKeyword() {
    var _this12 = this;

    var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/dict/topic-tags?keyword=' + keyword, true);

            case 3:
              report = _context12.sent;
              return _context12.abrupt('return', report);

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12['catch'](0);
              throw _context12.t0;

            case 10:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 7]]);
    }))();
  },
  searchRelevantKeyword: function searchRelevantKeyword() {
    var _this13 = this;

    var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/dict/relevant-tags?keyword=' + keyword, true);

            case 3:
              report = _context13.sent;
              return _context13.abrupt('return', report);

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13['catch'](0);
              throw _context13.t0;

            case 10:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 7]]);
    }))();
  },
  getPublicProfile: function getPublicProfile(platform, handle) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/social-data/profiles/public', true, { platform: platform, handle: handle });

            case 2:
              response = _context14.sent;
              return _context14.abrupt('return', response.data);

            case 4:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  getInfluencerByIgHandle: function getInfluencerByIgHandle(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/handle?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByTikTokHandle: function getInfluencerByTikTokHandle(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/tiktokhandle?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByYoutubeHandle: function getInfluencerByYoutubeHandle(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/youtubehandle?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByXHSHandle: function getInfluencerByXHSHandle(params) {
    var query = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.objectToQueryString(params);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/xhsHandle?' + query, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByFbHandle: function getInfluencerByFbHandle(params) {
    var query = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.objectToQueryString(params);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/fbHandle?' + query, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByLinkedInHandle: function getInfluencerByLinkedInHandle(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/linkedinHandle?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByTwitterHandle: function getInfluencerByTwitterHandle(params) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/by/twitterHandle?' + params, true).then(function (response) {
        if (response.status !== 200) return reject(response);
        resolve(response.data);
      }).catch(reject);
    });
  },
  getInfluencerByIds: function getInfluencerByIds(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/brief-info', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerByHandles: function getInfluencerByHandles(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/brief-info/byhandles', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveMergingInf: function saveMergingInf(formData) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/save/merge-inf', true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateInfPlatform: function updateInfPlatform(formData) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/update/platform', true, formData).then(function (response) {
                  if (response.status !== 200) {
                    reject(response);
                    return;
                  }
                  resolve(true);
                }).catch(function (error) {
                  reject(error);
                });
              }));

            case 1:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  downloadSearchCreatorRpt: function downloadSearchCreatorRpt(filters) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/influencers/imported/creators', 'POST', filters).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'Creators_Search_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('X') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadAudDataKeyword: function downloadAudDataKeyword(filters, limit) {
    filters.export = true;
    filters.limit = limit;
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download('/api/v1/influencers/aud/search/keyword', 'POST', filters).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'Creator_Discovery_' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD-MM-YYYY') + '.xlsx');
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  checkFollowers: function checkFollowers(creatorCommunityId) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/creator-community/check/follower/' + creatorCommunityId, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_sessionExpiry__ = __webpack_require__(323);







function handleAuthenticatedRequestError(error) {
  if (error.response && error.response.status === 401) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sessionExpiry__["b" /* expireSession */])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);
  }
  throw error;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  request: function request(method, uri, isPrivateLink) {
    var _this = this;

    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (method) {
                _context.next = 4;
                break;
              }

              console.error('API function call requires method argument');
              return _context.abrupt('return');

            case 4:
              if (uri) {
                _context.next = 7;
                break;
              }

              console.error('API function call requires uri argument');
              return _context.abrupt('return');

            case 7:

              if (isPrivateLink) {
                headers.Authorization = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.token;
              }

              url = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].serverURI + uri;
              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                method: method,
                url: url,
                headers: headers,
                data: data
              });

            case 11:
              resp = _context.sent;
              return _context.abrupt('return', resp);

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);
              if (isPrivateLink && _context.t0.response && _context.t0.response.status === 401) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_sessionExpiry__["b" /* expireSession */])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);
              }
              throw _context.t0;

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 15]]);
    }))();
  },
  download: function download(url) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
    var data = arguments[2];

    return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
      method: method,
      url: url,
      responseType: 'arraybuffer',
      headers: {
        Authorization: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.token
      },
      data: data
    }).catch(handleAuthenticatedRequestError);
  },
  downloadPATCH: function downloadPATCH(url) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PATCH';
    var data = arguments[2];

    return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
      method: method,
      url: url,
      responseType: 'arraybuffer',
      headers: {
        Authorization: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.token
      },
      data: data
    }).catch(handleAuthenticatedRequestError);
  }
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(36);








var PostAPI = function () {
  function PostAPI() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, PostAPI);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PostAPI, [{
    key: 'submitPost',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(post) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/posts', true, post);

              case 3:
                resp = _context.sent;

                if (!(resp.status === 201)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', {
                  success: true,
                  data: resp.data
                });

              case 6:
                return _context.abrupt('return', {
                  success: false
                });

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', {
                  success: false,
                  message: _context.t0
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function submitPost(_x) {
        return _ref.apply(this, arguments);
      }

      return submitPost;
    }()
  }, {
    key: 'getGroupedPosts',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(queries) {
        var queriesParams, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                queriesParams = new URLSearchParams(queries).toString();
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/posts/grouped?' + queriesParams, true);

              case 4:
                resp = _context2.sent;

                if (!(resp.status === 200)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', resp.data);

              case 7:
                throw new Error('Something went wrong');

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function getGroupedPosts(_x2) {
        return _ref2.apply(this, arguments);
      }

      return getGroupedPosts;
    }()
  }, {
    key: 'getPost',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(queries) {
        var queriesParams, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                queriesParams = new URLSearchParams(queries).toString();
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/posts?' + queriesParams, true);

              case 4:
                resp = _context3.sent;

                if (!(resp.status === 200)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return', resp.data);

              case 7:
                throw new Error('Something went wrong');

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 10]]);
      }));

      function getPost(_x3) {
        return _ref3.apply(this, arguments);
      }

      return getPost;
    }()
  }, {
    key: 'getLastSevenDaysPosts',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(queries) {
        var queriesParams, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                queriesParams = new URLSearchParams(queries).toString();
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/posts/last-seven-days/calendar?' + queriesParams, true);

              case 4:
                resp = _context4.sent;

                if (!(resp.status === 200)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', resp.data);

              case 7:
                throw new Error('Something went wrong');

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0;

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function getLastSevenDaysPosts(_x4) {
        return _ref4.apply(this, arguments);
      }

      return getLastSevenDaysPosts;
    }()
  }, {
    key: 'editPost',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(postId, post) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/posts/' + postId, true, post);

              case 3:
                resp = _context5.sent;

                if (!(resp.status === 200)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0;

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function editPost(_x5, _x6) {
        return _ref5.apply(this, arguments);
      }

      return editPost;
    }()
  }, {
    key: 'publishPost',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(postId, url) {
        var payoutSubmitted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/posts/' + postId + '/live', true, {
                  url: url,
                  payoutSubmitted: payoutSubmitted
                });

              case 3:
                resp = _context6.sent;

                if (!(resp.status === 200)) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0;

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 9]]);
      }));

      function publishPost(_x7, _x8) {
        return _ref6.apply(this, arguments);
      }

      return publishPost;
    }()
  }, {
    key: 'updatePostForPayout',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(postId, data) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/posts/' + postId + '/payout', true, {
                  data: data
                });

              case 3:
                resp = _context7.sent;

                if (!(resp.status === 200)) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](0);
                throw _context7.t0;

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9]]);
      }));

      function updatePostForPayout(_x10, _x11) {
        return _ref7.apply(this, arguments);
      }

      return updatePostForPayout;
    }()
  }, {
    key: 'completePost',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(postId) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/posts/' + postId + '/complete', true);

              case 3:
                resp = _context8.sent;

                if (!(resp.status === 200)) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);
                throw _context8.t0;

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 9]]);
      }));

      function completePost(_x12) {
        return _ref8.apply(this, arguments);
      }

      return completePost;
    }()
  }, {
    key: 'updateUrlPost',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(postId, url) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/posts/' + postId + '/post-url', true, {
                  url: url
                });

              case 3:
                resp = _context9.sent;

                if (!(resp.status === 200)) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](0);
                throw _context9.t0;

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));

      function updateUrlPost(_x13, _x14) {
        return _ref9.apply(this, arguments);
      }

      return updateUrlPost;
    }()
  }, {
    key: 'deletePost',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(postId) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('DELETE', '/api/v1/posts/' + postId, true);

              case 3:
                resp = _context10.sent;

                if (!(resp.status === 200)) {
                  _context10.next = 6;
                  break;
                }

                return _context10.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10['catch'](0);
                throw _context10.t0;

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 9]]);
      }));

      function deletePost(_x15) {
        return _ref10.apply(this, arguments);
      }

      return deletePost;
    }()
  }, {
    key: 'approvePost',
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/cs/accept/draft', true, {
                  ids: postID
                });

              case 3:
                resp = _context11.sent;

                if (!(resp.status === 200)) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in approvingPost');

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11['catch'](0);
                throw _context11.t0;

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 9]]);
      }));

      function approvePost(_x16) {
        return _ref11.apply(this, arguments);
      }

      return approvePost;
    }()
  }, {
    key: 'abuseResolvePost',
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/cs/abuse/resolved', true, {
                  ids: postID
                });

              case 3:
                resp = _context12.sent;

                if (!(resp.status === 200)) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in abuse resolving post');

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12['catch'](0);
                throw _context12.t0;

              case 12:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 9]]);
      }));

      function abuseResolvePost(_x17) {
        return _ref12.apply(this, arguments);
      }

      return abuseResolvePost;
    }()
  }, {
    key: 'releaseAbuseResolvePost',
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/release/abuse/resolved', true, {
                  ids: postID
                });

              case 3:
                resp = _context13.sent;

                if (!(resp.status === 200)) {
                  _context13.next = 6;
                  break;
                }

                return _context13.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in releasing post');

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13['catch'](0);
                throw _context13.t0;

              case 12:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));

      function releaseAbuseResolvePost(_x18) {
        return _ref13.apply(this, arguments);
      }

      return releaseAbuseResolvePost;
    }()
  }, {
    key: 'releasePost',
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/release/draft', true, {
                  ids: postID
                });

              case 3:
                resp = _context14.sent;

                if (!(resp.status === 200)) {
                  _context14.next = 6;
                  break;
                }

                return _context14.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in releasing Post');

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14['catch'](0);
                throw _context14.t0;

              case 12:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 9]]);
      }));

      function releasePost(_x19) {
        return _ref14.apply(this, arguments);
      }

      return releasePost;
    }()
  }, {
    key: 'clientApprovePost',
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15(body) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/client/accepted', true, {
                  data: body
                });

              case 3:
                resp = _context15.sent;

                if (!(resp.status === 200)) {
                  _context15.next = 6;
                  break;
                }

                return _context15.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in approvingPost');

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15['catch'](0);
                throw _context15.t0;

              case 12:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 9]]);
      }));

      function clientApprovePost(_x20) {
        return _ref15.apply(this, arguments);
      }

      return clientApprovePost;
    }()
  }, {
    key: 'clientReportPost',
    value: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16(postID, body) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/client/report', true, body);

              case 3:
                resp = _context16.sent;

                if (!(resp.status === 200)) {
                  _context16.next = 6;
                  break;
                }

                return _context16.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in approvingPost');

              case 9:
                _context16.prev = 9;
                _context16.t0 = _context16['catch'](0);
                throw _context16.t0;

              case 12:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 9]]);
      }));

      function clientReportPost(_x21, _x22) {
        return _ref16.apply(this, arguments);
      }

      return clientReportPost;
    }()
  }, {
    key: 'bulkDeletePosts',
    value: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/bulk-delete/posts', true, {
                  ids: postID
                });

              case 3:
                resp = _context17.sent;

                if (!(resp.status === 200)) {
                  _context17.next = 6;
                  break;
                }

                return _context17.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in deleting Posts');

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17['catch'](0);
                throw _context17.t0;

              case 12:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 9]]);
      }));

      function bulkDeletePosts(_x23) {
        return _ref17.apply(this, arguments);
      }

      return bulkDeletePosts;
    }()
  }, {
    key: 'getPostById',
    value: function () {
      var _ref18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee18(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', '/api/v1/posts/' + postID, true);

              case 3:
                resp = _context18.sent;

                if (!(resp.status === 200)) {
                  _context18.next = 6;
                  break;
                }

                return _context18.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in getting post');

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18['catch'](0);
                throw _context18.t0;

              case 12:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 9]]);
      }));

      function getPostById(_x24) {
        return _ref18.apply(this, arguments);
      }

      return getPostById;
    }()
  }, {
    key: 'getPostsByCampaign',
    value: function () {
      var _ref19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee19(campaignID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', '/api/v1/posts/' + campaignID + '/all', true);

              case 3:
                resp = _context19.sent;

                if (!(resp.status === 200)) {
                  _context19.next = 6;
                  break;
                }

                return _context19.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in getting post');

              case 9:
                _context19.prev = 9;
                _context19.t0 = _context19['catch'](0);
                throw _context19.t0;

              case 12:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 9]]);
      }));

      function getPostsByCampaign(_x25) {
        return _ref19.apply(this, arguments);
      }

      return getPostsByCampaign;
    }()
  }, {
    key: 'getPostsByInfluencers',
    value: function () {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee20(influencers) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                _context20.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', '/api/v1/posts/by/influencers', true, { influencers: influencers });

              case 3:
                resp = _context20.sent;

                if (!(resp.status === 200)) {
                  _context20.next = 6;
                  break;
                }

                return _context20.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in getting Posts');

              case 9:
                _context20.prev = 9;
                _context20.t0 = _context20['catch'](0);
                throw _context20.t0;

              case 12:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 9]]);
      }));

      function getPostsByInfluencers(_x26) {
        return _ref20.apply(this, arguments);
      }

      return getPostsByInfluencers;
    }()
  }, {
    key: 'csComment',
    value: function () {
      var _ref21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee21(postID, comment) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/cs/comment', true, {
                  comment: comment
                });

              case 3:
                resp = _context21.sent;

                if (!(resp.status === 200)) {
                  _context21.next = 6;
                  break;
                }

                return _context21.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context21.prev = 9;
                _context21.t0 = _context21['catch'](0);
                throw _context21.t0;

              case 12:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 9]]);
      }));

      function csComment(_x27, _x28) {
        return _ref21.apply(this, arguments);
      }

      return csComment;
    }()
  }, {
    key: 'clientComment',
    value: function () {
      var _ref22 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee22(postID, comment) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/client/comment', true, {
                  comment: comment
                });

              case 3:
                resp = _context22.sent;

                if (!(resp.status === 200)) {
                  _context22.next = 6;
                  break;
                }

                return _context22.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context22.prev = 9;
                _context22.t0 = _context22['catch'](0);
                throw _context22.t0;

              case 12:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 9]]);
      }));

      function clientComment(_x29, _x30) {
        return _ref22.apply(this, arguments);
      }

      return clientComment;
    }()
  }, {
    key: 'csAssignCampaign',
    value: function () {
      var _ref23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee23(postID, campaignID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                _context23.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/cs/assign/campaign', true, {
                  campaignID: campaignID
                });

              case 3:
                resp = _context23.sent;

                if (!(resp.status === 200)) {
                  _context23.next = 6;
                  break;
                }

                return _context23.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong');

              case 9:
                _context23.prev = 9;
                _context23.t0 = _context23['catch'](0);
                throw _context23.t0;

              case 12:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 9]]);
      }));

      function csAssignCampaign(_x31, _x32) {
        return _ref23.apply(this, arguments);
      }

      return csAssignCampaign;
    }()
  }, {
    key: 'setAsMainPost',
    value: function () {
      var _ref24 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee24(postID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                _context24.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/set-main/' + postID, true);

              case 3:
                resp = _context24.sent;

                if (!(resp.status === 200)) {
                  _context24.next = 6;
                  break;
                }

                return _context24.abrupt('return', resp);

              case 6:
                throw new Error('Something went wrong in setting as primary post');

              case 9:
                _context24.prev = 9;
                _context24.t0 = _context24['catch'](0);
                throw _context24.t0;

              case 12:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this, [[0, 9]]);
      }));

      function setAsMainPost(_x33) {
        return _ref24.apply(this, arguments);
      }

      return setAsMainPost;
    }()
  }, {
    key: 'mapInfluencerToPost',
    value: function () {
      var _ref25 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee25(postID, mapInfluencerObj) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.prev = 0;
                _context25.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/mapInfluencer', true, {
                  mapInfluencerObj: mapInfluencerObj
                });

              case 3:
                resp = _context25.sent;

                if (!(resp.status === 200)) {
                  _context25.next = 6;
                  break;
                }

                return _context25.abrupt('return', resp.data);

              case 6:
                throw new Error('Something went wrong in mapping Influencer');

              case 9:
                _context25.prev = 9;
                _context25.t0 = _context25['catch'](0);
                throw _context25.t0;

              case 12:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this, [[0, 9]]);
      }));

      function mapInfluencerToPost(_x34, _x35) {
        return _ref25.apply(this, arguments);
      }

      return mapInfluencerToPost;
    }()
  }, {
    key: 'changeStatus',
    value: function changeStatus(postID, updateStatus) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/' + postID + '/changeStatus/' + updateStatus, true).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'changeBulkStatus',
    value: function changeBulkStatus(postIds, updateStatus) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/changeBulkStatus/' + updateStatus, true, {
          ids: postIds
        }).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'getS3Object',
    value: function () {
      var _ref26 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee26(param) {
        var url, data, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                url = '/api/v1/posts/s3/getObject';
                data = {
                  filename: param
                };
                _context26.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', url, true, data);

              case 5:
                response = _context26.sent;

                if (!(response.status !== 200)) {
                  _context26.next = 8;
                  break;
                }

                throw new Error('Error');

              case 8:
                return _context26.abrupt('return', response.data);

              case 11:
                _context26.prev = 11;
                _context26.t0 = _context26['catch'](0);

                console.log(_context26.t0);
                throw _context26.t0;

              case 15:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this, [[0, 11]]);
      }));

      function getS3Object(_x36) {
        return _ref26.apply(this, arguments);
      }

      return getS3Object;
    }()
  }, {
    key: 'sendSubmissionGuide',
    value: function () {
      var _ref27 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee27(param) {
        var url, data, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;
                url = '/api/v1/posts/sendgrid/dynamic/email';
                data = param;
                _context27.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', url, true, data);

              case 5:
                response = _context27.sent;

                if (!(response.status !== 200)) {
                  _context27.next = 8;
                  break;
                }

                throw new Error('Error');

              case 8:
                return _context27.abrupt('return', response.data);

              case 11:
                _context27.prev = 11;
                _context27.t0 = _context27['catch'](0);

                console.log(_context27.t0);
                throw _context27.t0;

              case 15:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this, [[0, 11]]);
      }));

      function sendSubmissionGuide(_x37) {
        return _ref27.apply(this, arguments);
      }

      return sendSubmissionGuide;
    }()
  }, {
    key: 'getStatusReportData',
    value: function () {
      var _ref28 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee28(options) {
        var params;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
                  return key + '=' + options[key];
                }).join('&');
                return _context28.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var url = '/api/v1/posts/co-creating/status-report?' + params;
                  __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', url, true).then(function (response) {
                    if (response.status !== 200) {
                      reject(response);
                      return;
                    }

                    resolve(response.data);
                  }).catch(function (error) {
                    reject(error);
                  });
                }));

              case 2:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getStatusReportData(_x38) {
        return _ref28.apply(this, arguments);
      }

      return getStatusReportData;
    }()
  }, {
    key: 'updatePostByIds',
    value: function () {
      var _ref29 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee29(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;
                _context29.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/update-by/ids', true, data);

              case 3:
                response = _context29.sent;

                if (!(response.status !== 200)) {
                  _context29.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context29.abrupt('return', response.data);

              case 9:
                _context29.prev = 9;
                _context29.t0 = _context29['catch'](0);
                throw _context29.t0;

              case 12:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this, [[0, 9]]);
      }));

      function updatePostByIds(_x39) {
        return _ref29.apply(this, arguments);
      }

      return updatePostByIds;
    }()
  }, {
    key: 'updatePostViewUser',
    value: function () {
      var _ref30 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee30(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                _context30.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/update/view', true, data);

              case 3:
                response = _context30.sent;

                if (!(response.status !== 200)) {
                  _context30.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context30.abrupt('return', response.data);

              case 9:
                _context30.prev = 9;
                _context30.t0 = _context30['catch'](0);
                throw _context30.t0;

              case 12:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this, [[0, 9]]);
      }));

      function updatePostViewUser(_x40) {
        return _ref30.apply(this, arguments);
      }

      return updatePostViewUser;
    }()
  }, {
    key: 'updatePostOwner',
    value: function () {
      var _ref31 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee31(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                _context31.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('patch', '/api/v1/posts/update/owner', true, data);

              case 3:
                response = _context31.sent;

                if (!(response.status !== 200)) {
                  _context31.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context31.abrupt('return', response.data);

              case 9:
                _context31.prev = 9;
                _context31.t0 = _context31['catch'](0);
                throw _context31.t0;

              case 12:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this, [[0, 9]]);
      }));

      function updatePostOwner(_x41) {
        return _ref31.apply(this, arguments);
      }

      return updatePostOwner;
    }()
  }, {
    key: 'sendProposeDateClientEmail',
    value: function () {
      var _ref32 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee32(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                _context32.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', '/api/v1/posts/send/propose-date', true, data);

              case 3:
                response = _context32.sent;

                if (!(response.status !== 200)) {
                  _context32.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context32.abrupt('return', response.data);

              case 9:
                _context32.prev = 9;
                _context32.t0 = _context32['catch'](0);
                throw _context32.t0;

              case 12:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this, [[0, 9]]);
      }));

      function sendProposeDateClientEmail(_x42) {
        return _ref32.apply(this, arguments);
      }

      return sendProposeDateClientEmail;
    }()
  }, {
    key: 'sendReviseDateEmail',
    value: function () {
      var _ref33 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee33(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                _context33.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', '/api/v1/posts/send/revise-date', true, data);

              case 3:
                response = _context33.sent;

                if (!(response.status !== 200)) {
                  _context33.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context33.abrupt('return', response.data);

              case 9:
                _context33.prev = 9;
                _context33.t0 = _context33['catch'](0);
                throw _context33.t0;

              case 12:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, this, [[0, 9]]);
      }));

      function sendReviseDateEmail(_x43) {
        return _ref33.apply(this, arguments);
      }

      return sendReviseDateEmail;
    }()
  }, {
    key: 'sendProposeDateAcceptedToClient',
    value: function () {
      var _ref34 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee34(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.prev = 0;
                _context34.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', '/api/v1/posts/send/propose-date/accepted', true, data);

              case 3:
                response = _context34.sent;

                if (!(response.status !== 200)) {
                  _context34.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context34.abrupt('return', response.data);

              case 9:
                _context34.prev = 9;
                _context34.t0 = _context34['catch'](0);
                throw _context34.t0;

              case 12:
              case 'end':
                return _context34.stop();
            }
          }
        }, _callee34, this, [[0, 9]]);
      }));

      function sendProposeDateAcceptedToClient(_x44) {
        return _ref34.apply(this, arguments);
      }

      return sendProposeDateAcceptedToClient;
    }()
  }, {
    key: 'sendConfirmLiveDateEmailCO',
    value: function () {
      var _ref35 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee35(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.prev = 0;
                _context35.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', '/api/v1/posts/send/live-date/confirmation', true, data);

              case 3:
                response = _context35.sent;

                if (!(response.status !== 200)) {
                  _context35.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context35.abrupt('return', response.data);

              case 9:
                _context35.prev = 9;
                _context35.t0 = _context35['catch'](0);
                throw _context35.t0;

              case 12:
              case 'end':
                return _context35.stop();
            }
          }
        }, _callee35, this, [[0, 9]]);
      }));

      function sendConfirmLiveDateEmailCO(_x45) {
        return _ref35.apply(this, arguments);
      }

      return sendConfirmLiveDateEmailCO;
    }()
  }, {
    key: 'sendClientAcceptPost',
    value: function () {
      var _ref36 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee36(data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.prev = 0;
                _context36.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('post', '/api/v1/posts/send/client-accepted/post', true, data);

              case 3:
                response = _context36.sent;

                if (!(response.status !== 200)) {
                  _context36.next = 6;
                  break;
                }

                throw new Error('Error');

              case 6:
                return _context36.abrupt('return', response.data);

              case 9:
                _context36.prev = 9;
                _context36.t0 = _context36['catch'](0);
                throw _context36.t0;

              case 12:
              case 'end':
                return _context36.stop();
            }
          }
        }, _callee36, this, [[0, 9]]);
      }));

      function sendClientAcceptPost(_x46) {
        return _ref36.apply(this, arguments);
      }

      return sendClientAcceptPost;
    }()
  }]);

  return PostAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PostAPI());

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(78);







/* harmony default export */ __webpack_exports__["a"] = ({
  paginate: function paginate(page, perPage) {
    var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients?page=' + page + '&per_page=' + perPage + '&keyword=' + keyword, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllClients: function getAllClients(force) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cacheClientList = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.cache.clientList;

      if (cacheClientList.data !== null && force === false) {
        resolve(cacheClientList);
      } else {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients/all', true).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('SET_CLIENTS', response.data);

          resolve(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.cache.clientList);
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  },
  getAllClientDealNatures: function getAllClientDealNatures(force) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients/deal/natures', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getClientGroups: function getClientGroups() {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients/groups', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getClient: function getClient(clientID) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients/' + clientID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getClientUser: function getClientUser(clientID) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients/' + clientID + '/users', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createClient: function createClient(client) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/clients', true, client).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  addClientGroup: function addClientGroup(clientGroup) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/clients/groups/add', true, clientGroup).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editClient: function editClient(client, clientId) {

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/clients/' + clientId, true, client).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateClientUser: function updateClientUser(client) {
    var clientID = client.userClient.clientID;


    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/clients/' + clientID + '/users', true, client).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateClient: function updateClient(data) {
    var clientID = data.clientID,
        clientInfoFormData = data.clientInfoFormData;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/clients/' + clientID, true, clientInfoFormData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateClientLogo: function updateClientLogo(data) {
    var clientID = data.clientID,
        body = data.body;


    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/clients/' + clientID + '/logo', true, body).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteClient: function deleteClient(clientID) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('delete', '/api/v1/clients/' + clientID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteClientGroup: function deleteClientGroup(groupID) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('delete', '/api/v1/clients/groups/' + groupID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCampaignsForClient: function getCampaignsForClient(options) {
    var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(options).map(function (key) {
      return key + '=' + options[key];
    }).join('$');
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/campaigns?' + params;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getClientAccountSummary: function getClientAccountSummary(clientID) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', '/api/v1/clients/summary/' + clientID, true);

            case 3:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 6;
                break;
              }

              throw new Error('Error');

            case 6:
              return _context.abrupt('return', response.data);

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);
              throw _context.t0;

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  },
  getClientsByAssignedID: function getClientsByAssignedID(data) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', '/api/v1/clients/count/by/assigned-id', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  clientVendorCreationFormAcceptedEmail: function clientVendorCreationFormAcceptedEmail(data) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              url = '/api/v1/posts/client/vendor-creation-form/notify';
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', url, true, data);

            case 4:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 7;
                break;
              }

              throw new Error('Error');

            case 7:
              return _context2.abrupt('return', response.data);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 10]]);
    }))();
  },
  sendDeleteReq: function sendDeleteReq(data, clientId) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('patch', '/api/v1/clients/' + clientId + '/send-delete-req', true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.status);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1968),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = [{"name":"Singapore","code":"SG"},{"name":"Malaysia","code":"MY"},{"name":"Indonesia","code":"ID"},{"name":"Vietnam","code":"VN"},{"name":"Thailand","code":"TH"},{"name":"Philippines","code":"PH"},{"name":"China","code":"CN"},{"name":"Laos","code":"LA"},{"name":"Cambodia","code":"KH"},{"name":"Brunei Darussalam","code":"BN"},{"name":"India","code":"IN"},{"name":"United States","code":"US"},{"name":"Australia","code":"AU"},{"name":"Canada","code":"CA"},{"name":"New Zealand","code":"NZ"},{"name":"Japan","code":"JP"},{"name":"Korea, Republic of","code":"KR"},{"name":"Hong Kong","code":"HK"},{"name":"Taiwan, Province of China","code":"TW"},{"name":"United Arab Emirates","code":"AE"},{"name":"United Kingdom","code":"GB"},{"name":"Afghanistan","code":"AF"},{"name":"land Islands","code":"AX"},{"name":"Albania","code":"AL"},{"name":"Algeria","code":"DZ"},{"name":"American Samoa","code":"AS"},{"name":"AndorrA","code":"AD"},{"name":"Angola","code":"AO"},{"name":"Anguilla","code":"AI"},{"name":"Antarctica","code":"AQ"},{"name":"Antigua and Barbuda","code":"AG"},{"name":"Argentina","code":"AR"},{"name":"Armenia","code":"AM"},{"name":"Aruba","code":"AW"},{"name":"Austria","code":"AT"},{"name":"Azerbaijan","code":"AZ"},{"name":"Bahamas","code":"BS"},{"name":"Bahrain","code":"BH"},{"name":"Bangladesh","code":"BD"},{"name":"Barbados","code":"BB"},{"name":"Belarus","code":"BY"},{"name":"Belgium","code":"BE"},{"name":"Belize","code":"BZ"},{"name":"Benin","code":"BJ"},{"name":"Bermuda","code":"BM"},{"name":"Bhutan","code":"BT"},{"name":"Bolivia","code":"BO"},{"name":"Bosnia and Herzegovina","code":"BA"},{"name":"Botswana","code":"BW"},{"name":"Bouvet Island","code":"BV"},{"name":"Brazil","code":"BR"},{"name":"British Indian Ocean Territory","code":"IO"},{"name":"Bulgaria","code":"BG"},{"name":"Burkina Faso","code":"BF"},{"name":"Burundi","code":"BI"},{"name":"Cameroon","code":"CM"},{"name":"Cape Verde","code":"CV"},{"name":"Cayman Islands","code":"KY"},{"name":"Central African Republic","code":"CF"},{"name":"Chad","code":"TD"},{"name":"Chile","code":"CL"},{"name":"Christmas Island","code":"CX"},{"name":"Cocos (Keeling) Islands","code":"CC"},{"name":"Colombia","code":"CO"},{"name":"Comoros","code":"KM"},{"name":"Congo","code":"CG"},{"name":"Congo, The Democratic Republic of the","code":"CD"},{"name":"Cook Islands","code":"CK"},{"name":"Costa Rica","code":"CR"},{"name":"Cote D\"Ivoire","code":"CI"},{"name":"Croatia","code":"HR"},{"name":"Cuba","code":"CU"},{"name":"Cyprus","code":"CY"},{"name":"Czech Republic","code":"CZ"},{"name":"Denmark","code":"DK"},{"name":"Djibouti","code":"DJ"},{"name":"Dominica","code":"DM"},{"name":"Dominican Republic","code":"DO"},{"name":"Ecuador","code":"EC"},{"name":"Egypt","code":"EG"},{"name":"El Salvador","code":"SV"},{"name":"Equatorial Guinea","code":"GQ"},{"name":"Eritrea","code":"ER"},{"name":"Estonia","code":"EE"},{"name":"Ethiopia","code":"ET"},{"name":"Falkland Islands (Malvinas)","code":"FK"},{"name":"Faroe Islands","code":"FO"},{"name":"Fiji","code":"FJ"},{"name":"Finland","code":"FI"},{"name":"France","code":"FR"},{"name":"French Guiana","code":"GF"},{"name":"French Polynesia","code":"PF"},{"name":"French Southern Territories","code":"TF"},{"name":"Gabon","code":"GA"},{"name":"Gambia","code":"GM"},{"name":"Georgia","code":"GE"},{"name":"Germany","code":"DE"},{"name":"Ghana","code":"GH"},{"name":"Gibraltar","code":"GI"},{"name":"Greece","code":"GR"},{"name":"Greenland","code":"GL"},{"name":"Grenada","code":"GD"},{"name":"Guadeloupe","code":"GP"},{"name":"Guam","code":"GU"},{"name":"Guatemala","code":"GT"},{"name":"Guernsey","code":"GG"},{"name":"Guinea","code":"GN"},{"name":"Guinea-Bissau","code":"GW"},{"name":"Guyana","code":"GY"},{"name":"Haiti","code":"HT"},{"name":"Heard Island and Mcdonald Islands","code":"HM"},{"name":"Holy See (Vatican City State)","code":"VA"},{"name":"Honduras","code":"HN"},{"name":"Hungary","code":"HU"},{"name":"Iceland","code":"IS"},{"name":"Iran, Islamic Republic Of","code":"IR"},{"name":"Iraq","code":"IQ"},{"name":"Ireland","code":"IE"},{"name":"Isle of Man","code":"IM"},{"name":"Israel","code":"IL"},{"name":"Italy","code":"IT"},{"name":"Jamaica","code":"JM"},{"name":"Jersey","code":"JE"},{"name":"Jordan","code":"JO"},{"name":"Kazakhstan","code":"KZ"},{"name":"Kenya","code":"KE"},{"name":"Kiribati","code":"KI"},{"name":"Korea, Democratic People\"S Republic of","code":"KP"},{"name":"Kuwait","code":"KW"},{"name":"Kyrgyzstan","code":"KG"},{"name":"Latvia","code":"LV"},{"name":"Lebanon","code":"LB"},{"name":"Lesotho","code":"LS"},{"name":"Liberia","code":"LR"},{"name":"Libyan Arab Jamahiriya","code":"LY"},{"name":"Liechtenstein","code":"LI"},{"name":"Lithuania","code":"LT"},{"name":"Luxembourg","code":"LU"},{"name":"Macao","code":"MO"},{"name":"Macedonia, The Former Yugoslav Republic of","code":"MK"},{"name":"Madagascar","code":"MG"},{"name":"Malawi","code":"MW"},{"name":"Maldives","code":"MV"},{"name":"Mali","code":"ML"},{"name":"Malta","code":"MT"},{"name":"Marshall Islands","code":"MH"},{"name":"Martinique","code":"MQ"},{"name":"Mauritania","code":"MR"},{"name":"Mauritius","code":"MU"},{"name":"Mayotte","code":"YT"},{"name":"Mexico","code":"MX"},{"name":"Micronesia, Federated States of","code":"FM"},{"name":"Moldova, Republic of","code":"MD"},{"name":"Monaco","code":"MC"},{"name":"Mongolia","code":"MN"},{"name":"Montenegro","code":"ME"},{"name":"Montserrat","code":"MS"},{"name":"Morocco","code":"MA"},{"name":"Mozambique","code":"MZ"},{"name":"Myanmar","code":"MM"},{"name":"Namibia","code":"NA"},{"name":"Nauru","code":"NR"},{"name":"Nepal","code":"NP"},{"name":"Netherlands","code":"NL"},{"name":"Netherlands Antilles","code":"AN"},{"name":"New Caledonia","code":"NC"},{"name":"Nicaragua","code":"NI"},{"name":"Niger","code":"NE"},{"name":"Nigeria","code":"NG"},{"name":"Niue","code":"NU"},{"name":"Norfolk Island","code":"NF"},{"name":"Northern Mariana Islands","code":"MP"},{"name":"Norway","code":"NO"},{"name":"Oman","code":"OM"},{"name":"Pakistan","code":"PK"},{"name":"Palau","code":"PW"},{"name":"Palestinian Territory, Occupied","code":"PS"},{"name":"Panama","code":"PA"},{"name":"Papua New Guinea","code":"PG"},{"name":"Paraguay","code":"PY"},{"name":"Peru","code":"PE"},{"name":"Pitcairn","code":"PN"},{"name":"Poland","code":"PL"},{"name":"Portugal","code":"PT"},{"name":"Puerto Rico","code":"PR"},{"name":"Qatar","code":"QA"},{"name":"Reunion","code":"RE"},{"name":"Romania","code":"RO"},{"name":"Russian Federation","code":"RU"},{"name":"RWANDA","code":"RW"},{"name":"Saint Helena","code":"SH"},{"name":"Saint Kitts and Nevis","code":"KN"},{"name":"Saint Lucia","code":"LC"},{"name":"Saint Pierre and Miquelon","code":"PM"},{"name":"Saint Vincent and the Grenadines","code":"VC"},{"name":"Samoa","code":"WS"},{"name":"San Marino","code":"SM"},{"name":"Sao Tome and Principe","code":"ST"},{"name":"Saudi Arabia","code":"SA"},{"name":"Senegal","code":"SN"},{"name":"Serbia","code":"RS"},{"name":"Seychelles","code":"SC"},{"name":"Sierra Leone","code":"SL"},{"name":"Slovakia","code":"SK"},{"name":"Slovenia","code":"SI"},{"name":"Solomon Islands","code":"SB"},{"name":"Somalia","code":"SO"},{"name":"South Africa","code":"ZA"},{"name":"South Georgia and the South Sandwich Islands","code":"GS"},{"name":"Spain","code":"ES"},{"name":"Sri Lanka","code":"LK"},{"name":"Sudan","code":"SD"},{"name":"Suriname","code":"SR"},{"name":"Svalbard and Jan Mayen","code":"SJ"},{"name":"Swaziland","code":"SZ"},{"name":"Sweden","code":"SE"},{"name":"Switzerland","code":"CH"},{"name":"Syrian Arab Republic","code":"SY"},{"name":"Tajikistan","code":"TJ"},{"name":"Tanzania, United Republic of","code":"TZ"},{"name":"Timor-Leste","code":"TL"},{"name":"Togo","code":"TG"},{"name":"Tokelau","code":"TK"},{"name":"Tonga","code":"TO"},{"name":"Trinidad and Tobago","code":"TT"},{"name":"Tunisia","code":"TN"},{"name":"Turkey","code":"TR"},{"name":"Turkmenistan","code":"TM"},{"name":"Turks and Caicos Islands","code":"TC"},{"name":"Tuvalu","code":"TV"},{"name":"Uganda","code":"UG"},{"name":"Ukraine","code":"UA"},{"name":"United States Minor Outlying Islands","code":"UM"},{"name":"Uruguay","code":"UY"},{"name":"Uzbekistan","code":"UZ"},{"name":"Vanuatu","code":"VU"},{"name":"Venezuela","code":"VE"},{"name":"Virgin Islands, British","code":"VG"},{"name":"Virgin Islands, U.S.","code":"VI"},{"name":"Wallis and Futuna","code":"WF"},{"name":"Western Sahara","code":"EH"},{"name":"Yemen","code":"YE"},{"name":"Zambia","code":"ZM"},{"name":"Zimbabwe","code":"ZW"}]

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1483)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(2234),
  /* scopeId */
  "data-v-8f9557e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1438)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(2174),
  /* scopeId */
  "data-v-6adc0f7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);



var _postStatusDisplayFor, _postStatusDisplayFor2, _postStatusDisplayFor3, _approval;



var postStatus = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatus;

var postStatusDisplayForInfluencer = (_postStatusDisplayFor = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor, postStatus.AD_STRATEGIST_PENDING, 'Submitted for Review'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor, postStatus.CLIENT_PENDING, 'Under Review'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor, postStatus.APPROVE, 'Your Post is Approved'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor, postStatus.LIVE, 'Your Post is published'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor, postStatus.COMPLETE, 'Completed Post'), _postStatusDisplayFor);

var postStatusDisplayForClient = (_postStatusDisplayFor2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor2, postStatus.CLIENT_PENDING, 'Pending'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor2, postStatus.APPROVE, 'Approved'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor2, postStatus.LIVE, 'Published'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor2, postStatus.COMPLETE, 'Completed'), _postStatusDisplayFor2);

var postStatusDisplayForCS = (_postStatusDisplayFor3 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor3, postStatus.AD_STRATEGIST_PENDING, 'Pending Your Approval'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor3, postStatus.CLIENT_PENDING, 'Pending Client Approval'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor3, postStatus.APPROVE, 'Approved By Client'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor3, postStatus.LIVE, 'Post is published'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_postStatusDisplayFor3, postStatus.COMPLETE, 'Completed Post'), _postStatusDisplayFor3);

var submissionReviewNotes = {
  beforeStart: 'Do note that by approving the draft, it would be deemed that you have considered the style of influencers during the vetting process and agreeable to the Influencer\'s style of image capture and caption writing.',
  thankyou: 'You will be receiving a copy of the ratings that you have provided in your email inbox.\n  Kobe will proceed with sharing the information to the influencers for their next course of actions and keep you updated again',
  internalApproveWarning: 'Do note that you are approving the draft on behalf of the Client. Make sure these drafts are under the correct campaign. Ratings and comments will not be included.'
};

var nonApprovalReasons = ['Non-Compliance to brief', 'Inaccuracy of factual information', 'Clarity of product with image', 'Language considerations', 'Clarity of Image', 'Inaccurate hashtags and mentions'];

var menuActions = [{
  name: 'View',
  action: 'view',
  icon: 'pageview',
  color: 'default'
}, {
  name: 'Edit',
  action: 'edit',
  icon: 'edit'
}, {
  name: 'Edit Live Date',
  action: 'editLiveDate',
  icon: 'edit'
}, {
  name: 'Assign Campaign',
  action: 'assignCampaign',
  icon: 'library_add'
}, {
  name: 'Map Influencer',
  action: 'mapInfluencer',
  icon: 'people_alt'
}, {
  name: 'Approve draft',
  action: 'csApprove',
  icon: 'check'
}, {
  name: 'Release draft',
  action: 'saleApprove',
  icon: 'check'
}, {
  name: 'Direct Release draft',
  action: 'directRelease',
  icon: 'check'
}, {
  name: 'Review Post',
  action: 'clientReview',
  icon: 'rate_review'
}, {
  name: 'Approve Date',
  action: 'clientApproveDate',
  icon: 'check'
}, {
  name: 'Add to Campaign Report',
  action: 'enterPostURL',
  icon: 'publish'
}, {
  name: 'Submit Payout',
  action: 'submitPostPayout',
  icon: 'assignment_turned_in'
}, {
  name: 'Mark as Metadata Tagged',
  action: 'markAsMetadataTagged',
  icon: 'check'
}, {
  name: 'Mark as Complete',
  action: 'markAsComplete',
  icon: 'done_all'
}, {
  name: 'Mark as Abuse Resolved',
  action: 'markAsAbuseResolved',
  icon: 'done_all'
}, {
  name: 'Release to Client',
  action: 'releaseAbuseResolved',
  icon: 'check'
}, {
  name: 'Change Status',
  action: 'changePostStatus',
  icon: 'mdi-pencil-outline'
}];

var tableActions = [{
  name: 'Assign Campaign',
  action: 'assignCampaign',
  icon: 'library_add'
}, {
  name: 'Map Influencer',
  action: 'mapInfluencer',
  icon: 'people_alt'
}, {
  name: 'Approve draft',
  action: 'csApprove',
  icon: 'check'
}, {
  name: 'Accept draft',
  action: 'clientApprove',
  icon: 'check'
}, {
  name: 'Direct Release draft',
  action: 'directRelease',
  icon: 'check'
}, {
  name: 'Release draft',
  action: 'saleApprove',
  icon: 'check'
}, {
  name: 'Change Status',
  action: 'changeStatus',
  icon: 'check'
}, {
  name: 'Delete Post',
  action: 'deletePost',
  icon: 'check'
}, {
  name: 'Archive',
  action: 'archivePost',
  icon: 'archive'
}, {
  name: 'Mark as Metadata Tagged',
  action: 'markAsMetadataTagged',
  icon: 'check'
}, {
  name: 'Mark as Abuse Resolved',
  action: 'markAsAbuseResolved',
  icon: 'check'
}, {
  name: 'Release Abuse Resolved',
  action: 'releaseAbuseResolved',
  icon: 'check'
}, {
  name: 'Restore',
  action: 'restore',
  icon: 'restore'
}];

var postConfirmation = {
  approval: (_approval = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, postStatus.AD_STRATEGIST_PENDING, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the post will be sent to client for approval',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'The post is now pending client approval'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, postStatus.CLIENT_PENDING, {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the post will be confirmed and cannot make changes.',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Approved',
      text: 'You have successfully approved this post.'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, postStatus.APPROVE, {
    confirmation: {
      title: 'Enter the post URL',
      text: 'Please double check the correct url of this post',
      placeholder: 'Paste the post URL here',
      type: 'url'
    },
    confirm: {
      title: 'Done',
      text: 'The post.'
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_approval, postStatus.LIVE, {
    confirmation: {
      title: 'Are you sure to mark as complete?',
      text: 'Upon confirmation, the post will be archived to Completed Posts section.',
      confirmText: 'Yes',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Done',
      text: 'The post is archived'
    }
  }), _approval)
};

var postFilterStatuses = [{
  text: 'All',
  value: '',
  permissions: [postStatus.AD_STRATEGIST_PENDING, postStatus.CLIENT_PENDING, postStatus.APPROVE, postStatus.LIVE, postStatus.COMPLETE]
}, {
  text: 'Campaign not assigned',
  value: 1,
  permissions: [postStatus.AD_STRATEGIST_PENDING]
}, {
  text: 'Pending to release',
  value: 2,
  permissions: [postStatus.AD_STRATEGIST_PENDING]
}, {
  text: 'Pending to release',
  value: 13,
  permissions: [postStatus.CLIENT_PENDING]
}, {
  text: 'Work in progress by CC',
  value: 3,
  permissions: [postStatus.AD_STRATEGIST_PENDING]
}, {
  text: 'Abuse Reported',
  value: 4,
  permissions: [postStatus.CLIENT_PENDING]
}, {
  text: 'New',
  value: 5,
  permissions: [postStatus.CLIENT_PENDING]
}, {
  text: 'Today Live Date',
  value: 9,
  permissions: []
}, {
  text: 'Today',
  value: 14,
  permissions: [postStatus.APPROVE]
}, {
  text: 'This Month',
  value: 15,
  permissions: [postStatus.APPROVE]
}, {
  text: 'Overdue Live Date',
  value: 10,
  permissions: [postStatus.APPROVE]
}, {
  text: 'Today Payout Due Date',
  value: 11,
  permissions: []
}, {
  text: 'Overdue Payout Due Date',
  value: 12,
  permissions: []
}, {
  text: 'Post URL Added',
  value: 8,
  permissions: [postStatus.APPROVE, postStatus.LIVE, postStatus.COMPLETE]
}];

var postFilterStatus = {
  CAMPAIGN_NOT_ASSIGNED: 1,
  PENDING_RELEASE: 2,
  WIP_CO: 3,
  ABUSE_REPORTED: 4,
  NEW: 5,
  TODAY: 6,
  OVERDUE: 7,
  POSTURL_ADDED: 8,

  TODAY_LIVE: 9,
  OVERDUE_LIVE: 10,
  TODAY_PAYOUTDUE: 11,
  OVERDUE_PAYOUT: 12,
  ABUSE_PENDING_RELEASE: 13
};

var clientPostFilterStatuses = [{
  text: 'Pending',
  value: postStatus.CLIENT_PENDING
}, {
  text: 'Approved',
  value: postStatus.APPROVE
}, {
  text: 'Published',
  value: postStatus.LIVE
}, {
  text: 'Completed',
  value: postStatus.COMPLETE
}];

var postTypeDeliverables = [{ type: 'story', shortName: 'IGS', value: 0 }, { type: 'post', shortName: 'IGP', value: 0 }, { type: 'carousel', shortName: 'IGC', value: 0 }, { type: 'video', shortName: 'IGV', value: 0 }, { type: 'reel', shortName: 'IGR', value: 0 }, { type: 'tiktok', shortName: 'TTP', value: 0 }, { type: 'linkedin', shortName: 'LIP', value: 0 }, { type: 'twitter', shortName: 'XTP', value: 0 }];

var submissionStates = [{
  text: 'All',
  value: ''
}, {
  text: 'FULL',
  value: 1
}, {
  text: 'PARTIAL',
  value: 2
}, {
  text: 'EMPTY',
  value: 3
}];

var submissionState = {
  ALL: '',
  FULL: 1,
  PARTIAL: 2,
  EMPTY: 3
};

var postTypes = [{ type: 'story', typeName: 'IG Story', icon: 'mdi-instagram', iconColor: '#E1306C' }, { type: 'post', typeName: 'IG Post', icon: 'mdi-instagram', iconColor: '#E1306C' }, { type: 'carousel', typeName: 'IG Carousel', icon: 'mdi-instagram', iconColor: '#E1306C' }, { type: 'reel', typeName: 'IG Reel', icon: 'mdi-instagram', iconColor: '#E1306C' }, { type: 'tiktok', typeName: 'TikTok', imgIcon: '/static/img/tiktok-32.png' }, { type: 'youtube', typeName: 'YouTube', icon: 'mdi-youtube', iconColor: '#FF0000' }, { type: 'facebook', typeName: 'Facebook', icon: 'mdi-facebook', iconColor: '#1877F2' }, { type: 'linkedin', typeName: 'LinkedIn Post', icon: 'mdi-linkedin', iconColor: '#0A66C2' }, { type: 'twitter', typeName: 'X (Twitter) Post', imgIcon: '/static/img/x-logo.svg' }, { type: 'others', typeName: 'Others', icon: 'mdi-help-circle', iconColor: '#616161' }];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  postStatusDisplayForInfluencer: postStatusDisplayForInfluencer,
  postStatusDisplayForClient: postStatusDisplayForClient,
  postStatusDisplayForCS: postStatusDisplayForCS,
  submissionReviewNotes: submissionReviewNotes,
  nonApprovalReasons: nonApprovalReasons,
  menuActions: menuActions,
  tableActions: tableActions,
  postConfirmation: postConfirmation,
  postFilterStatuses: postFilterStatuses,
  postFilterStatus: postFilterStatus,
  clientPostFilterStatuses: clientPostFilterStatuses,
  submissionStates: submissionStates,
  submissionState: submissionState,
  postTypeDeliverables: postTypeDeliverables,
  postTypes: postTypes
}));

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(2079),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pairing__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__campaign_index__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__campaign_timeline__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__post__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__client__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__influencer__ = __webpack_require__(825);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    pairing: __WEBPACK_IMPORTED_MODULE_5__pairing__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_6__payment__["a" /* default */],
    campaign: __WEBPACK_IMPORTED_MODULE_7__campaign_index__["a" /* default */],
    campaignTimeline: __WEBPACK_IMPORTED_MODULE_8__campaign_timeline__["a" /* default */],
    post: __WEBPACK_IMPORTED_MODULE_9__post__["a" /* default */],
    client: __WEBPACK_IMPORTED_MODULE_10__client__["a" /* default */],
    influencer: __WEBPACK_IMPORTED_MODULE_11__influencer__["a" /* default */]
  }
}));

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getReportPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLinkedInReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isTwitterReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getReportProfileUrl; });
var PLATFORM_BY_POST_TYPE = {
  LIP: 'linkedin',
  XTP: 'twitter',
  IGP: 'instagram',
  IGR: 'instagram',
  IGC: 'instagram',
  IGS: 'instagram',
  TTP: 'tiktok',
  YTP: 'youtube',
  FBP: 'facebook',
  XHS: 'xiaohongshu',
  Lemon8: 'lemon8'
};

var getReportPlatform = function getReportPlatform(report) {
  var contentPlatform = PLATFORM_BY_POST_TYPE[report && report.postType];
  if (contentPlatform) return contentPlatform;
  if (report && (report.isStory || report.isMultipleContents)) return 'instagram';
  if (report && report.isTikTok) return 'tiktok';
  if (report && report.isYoutube) return 'youtube';
  if (report && report.isFacebook) return 'facebook';
  var platform = String(report && report.platform || '').trim().toLowerCase();
  if (platform === 'x') return 'twitter';
  return platform || PLATFORM_BY_POST_TYPE[report && report.postType] || '';
};

var isLinkedInReport = function isLinkedInReport(report) {
  return getReportPlatform(report) === 'linkedin';
};
var isTwitterReport = function isTwitterReport(report) {
  return getReportPlatform(report) === 'twitter';
};

var PROFILE_URL_PREFIXES = {
  instagram: 'https://www.instagram.com/',
  tiktok: 'https://www.tiktok.com/@',
  twitter: 'https://x.com/',
  x: 'https://x.com/',
  facebook: 'https://www.facebook.com/',
  youtube: 'https://www.youtube.com/@',
  xiaohongshu: 'https://www.xiaohongshu.com/user/profile/'
};

var getReportProfileUrl = function getReportProfileUrl(report) {
  var fallbackPlatform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!report) return '#';
  var owner = report.owner || (report.post_details || {}).owner || {};
  var profile = report.influencer_details || {};
  var explicitUrl = report.profileUrl || report.profile_url || owner.profileUrl || owner.profile_url || owner.profileURL || report.linkedinURL || report.linkedinUrl || report.linkedin_profile_url || '';
  if (/^https?:\/\//i.test(explicitUrl)) return explicitUrl;

  var platform = String(report.profilePlatform || report.profile_platform || owner.platform || profile.platform || fallbackPlatform || '').trim().toLowerCase();
  var rawHandle = String(report.profileHandle || report.profile_handle || profile.instagramHandle || owner.username || report.linkedinHandle || report.handle || report.name || report.instagram || '').trim();
  if (!rawHandle) return '#';

  if (platform === 'linkedin') {
    var profileMatch = rawHandle.match(/(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i);
    var profileHandle = (profileMatch ? profileMatch[1] : rawHandle).replace(/^@+/, '').replace(/^\/+|\/+$/g, '');
    return profileHandle ? 'https://www.linkedin.com/in/' + encodeURIComponent(profileHandle) : '#';
  }

  var handle = rawHandle.replace(/^@+/, '').replace(/^\/+|\/+$/g, '');
  return handle && PROFILE_URL_PREFIXES[platform] ? PROFILE_URL_PREFIXES[platform] + encodeURIComponent(handle) : '#';
};

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1431)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(2164),
  /* scopeId */
  "data-v-66f2c538",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);









var FileSaver = __webpack_require__(119);

var PaymentAPI = function () {
  function PaymentAPI() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, PaymentAPI);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PaymentAPI, [{
    key: 'getAllPayouts',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(filters) {
        var query, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                query = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.objectToQueryString(filters);
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/payments/outcome/all/data?' + query, true);

              case 4:
                resp = _context.sent;

                if (!(resp.status === 200)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', resp.data);

              case 7:
                return _context.abrupt('return', {
                  success: false
                });

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', {
                  success: false,
                  message: _context.t0
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function getAllPayouts(_x) {
        return _ref.apply(this, arguments);
      }

      return getAllPayouts;
    }()
  }, {
    key: 'getPayouts',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var query, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                query = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.objectToQueryString(filter);
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/payments/outcome?' + query, true);

              case 4:
                resp = _context2.sent;

                if (!(resp.status === 200)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', resp.data);

              case 7:
                return _context2.abrupt('return', {
                  success: false
                });

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', {
                  success: false,
                  message: _context2.t0
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function getPayouts() {
        return _ref2.apply(this, arguments);
      }

      return getPayouts;
    }()
  }, {
    key: 'getSummary',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(filter) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/payments/outcome/summary', true);

              case 3:
                resp = _context3.sent;

                if (!(resp.status === 200)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return', resp.data);

              case 6:
                return _context3.abrupt('return', {
                  success: false
                });

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);
                return _context3.abrupt('return', {
                  success: false,
                  message: _context3.t0
                });

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function getSummary(_x3) {
        return _ref3.apply(this, arguments);
      }

      return getSummary;
    }()
  }, {
    key: 'createPayout',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(payout) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/outcome', true, payout);

              case 3:
                resp = _context4.sent;

                if (!(resp.status === 201)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return', resp.data);

              case 6:
                return _context4.abrupt('return', {
                  success: false
                });

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);
                return _context4.abrupt('return', {
                  success: false,
                  message: _context4.t0
                });

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 9]]);
      }));

      function createPayout(_x4) {
        return _ref4.apply(this, arguments);
      }

      return createPayout;
    }()
  }, {
    key: 'getPaymentRecords',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var query, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                query = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.objectToQueryString(filter);
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/payments/income?' + query, true);

              case 4:
                resp = _context5.sent;

                if (!(resp.status === 200)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt('return', resp.data);

              case 7:
                return _context5.abrupt('return', {
                  success: false
                });

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);
                return _context5.abrupt('return', {
                  success: false,
                  message: _context5.t0
                });

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 10]]);
      }));

      function getPaymentRecords() {
        return _ref5.apply(this, arguments);
      }

      return getPaymentRecords;
    }()
  }, {
    key: 'deletePaymentRecords',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('DELETE', '/api/v1/payments/income/' + id, true);

              case 3:
                resp = _context6.sent;

                if (!(resp.status === 200)) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt('return', resp.data);

              case 6:
                return _context6.abrupt('return', {
                  success: false
                });

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);
                return _context6.abrupt('return', {
                  success: false,
                  message: _context6.t0
                });

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 9]]);
      }));

      function deletePaymentRecords(_x6) {
        return _ref6.apply(this, arguments);
      }

      return deletePaymentRecords;
    }()
  }, {
    key: 'importPaymentRecords',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(formdata) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/income/import', true, formdata);

              case 3:
                resp = _context7.sent;

                if (!(resp.status === 200)) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt('return', resp.data);

              case 6:
                return _context7.abrupt('return', {
                  success: false
                });

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](0);
                return _context7.abrupt('return', {
                  success: false,
                  message: _context7.t0
                });

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9]]);
      }));

      function importPaymentRecords(_x7) {
        return _ref7.apply(this, arguments);
      }

      return importPaymentRecords;
    }()
  }, {
    key: 'importPaymoutRecords',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(formdata) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/outcome/import', true, formdata);

              case 3:
                resp = _context8.sent;

                if (!(resp.status === 200)) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt('return', resp.data);

              case 6:
                return _context8.abrupt('return', {
                  success: false
                });

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);
                return _context8.abrupt('return', {
                  success: false,
                  message: _context8.t0
                });

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 9]]);
      }));

      function importPaymoutRecords(_x8) {
        return _ref8.apply(this, arguments);
      }

      return importPaymoutRecords;
    }()
  }, {
    key: 'deletePayoutRecords',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(id) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('DELETE', '/api/v1/payments/outcome/' + id, true);

              case 3:
                resp = _context9.sent;

                if (!(resp.status === 200)) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt('return', resp.data);

              case 6:
                return _context9.abrupt('return', {
                  success: false
                });

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](0);
                return _context9.abrupt('return', {
                  success: false,
                  message: _context9.t0
                });

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));

      function deletePayoutRecords(_x9) {
        return _ref9.apply(this, arguments);
      }

      return deletePayoutRecords;
    }()
  }, {
    key: 'getPaymentOrReceiptSummary',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(filter) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', '/api/v1/payments/income/summary', true);

              case 3:
                resp = _context10.sent;

                if (!(resp.status === 200)) {
                  _context10.next = 6;
                  break;
                }

                return _context10.abrupt('return', resp.data);

              case 6:
                return _context10.abrupt('return', {
                  success: false
                });

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10['catch'](0);
                return _context10.abrupt('return', {
                  success: false,
                  message: _context10.t0
                });

              case 12:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 9]]);
      }));

      function getPaymentOrReceiptSummary(_x10) {
        return _ref10.apply(this, arguments);
      }

      return getPaymentOrReceiptSummary;
    }()
  }, {
    key: 'createPaymentOrReceipt',
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11(payout) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/income', true, payout);

              case 3:
                resp = _context11.sent;

                if (!(resp.status === 201)) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt('return', resp.data);

              case 6:
                return _context11.abrupt('return', {
                  success: false
                });

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11['catch'](0);
                return _context11.abrupt('return', {
                  success: false,
                  message: _context11.t0
                });

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 9]]);
      }));

      function createPaymentOrReceipt(_x11) {
        return _ref11.apply(this, arguments);
      }

      return createPaymentOrReceipt;
    }()
  }, {
    key: 'updatePaymentOrReceipt',
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12(id, payout) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/payments/income/' + id, true, payout);

              case 3:
                resp = _context12.sent;

                if (!(resp.status === 200)) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt('return', resp.data);

              case 6:
                return _context12.abrupt('return', {
                  success: false
                });

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12['catch'](0);
                return _context12.abrupt('return', {
                  success: false,
                  message: _context12.t0
                });

              case 12:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 9]]);
      }));

      function updatePaymentOrReceipt(_x12, _x13) {
        return _ref12.apply(this, arguments);
      }

      return updatePaymentOrReceipt;
    }()
  }, {
    key: 'deletePreProcessingPayment',
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13(id) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/pre-processing-payments/delete-by/id', true, { data: [{ id: id }] });

              case 3:
                resp = _context13.sent;

                if (!(resp.status === 200)) {
                  _context13.next = 6;
                  break;
                }

                return _context13.abrupt('return', resp.data);

              case 6:
                return _context13.abrupt('return', {
                  success: false
                });

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13['catch'](0);
                return _context13.abrupt('return', {
                  success: false,
                  message: _context13.t0
                });

              case 12:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));

      function deletePreProcessingPayment(_x14) {
        return _ref13.apply(this, arguments);
      }

      return deletePreProcessingPayment;
    }()
  }, {
    key: 'updatePreProcessingPayment',
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14(data) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/pre-processing-payments/update-by/id', true, { data: data });

              case 3:
                resp = _context14.sent;

                if (!(resp.status === 200)) {
                  _context14.next = 6;
                  break;
                }

                return _context14.abrupt('return', resp.data);

              case 6:
                return _context14.abrupt('return', {
                  success: false
                });

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14['catch'](0);
                return _context14.abrupt('return', {
                  success: false,
                  message: _context14.t0
                });

              case 12:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 9]]);
      }));

      function updatePreProcessingPayment(_x15) {
        return _ref14.apply(this, arguments);
      }

      return updatePreProcessingPayment;
    }()
  }, {
    key: 'rebalancePreProcessingPayout',
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15(data) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/pre-processing-payments/rebalance-by-owner', true, data);

              case 3:
                resp = _context15.sent;

                if (!(resp.status === 200)) {
                  _context15.next = 6;
                  break;
                }

                return _context15.abrupt('return', resp.data);

              case 6:
                return _context15.abrupt('return', {
                  success: false
                });

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15['catch'](0);
                return _context15.abrupt('return', {
                  success: false,
                  message: _context15.t0
                });

              case 12:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 9]]);
      }));

      function rebalancePreProcessingPayout(_x16) {
        return _ref15.apply(this, arguments);
      }

      return rebalancePreProcessingPayout;
    }()
  }, {
    key: 'deleteProcessingPayment',
    value: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16(id) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/finance-payments/delete-by/id', true, { data: [{ id: id }] });

              case 3:
                resp = _context16.sent;

                if (!(resp.status === 200)) {
                  _context16.next = 6;
                  break;
                }

                return _context16.abrupt('return', resp.data);

              case 6:
                return _context16.abrupt('return', {
                  success: false
                });

              case 9:
                _context16.prev = 9;
                _context16.t0 = _context16['catch'](0);
                return _context16.abrupt('return', {
                  success: false,
                  message: _context16.t0
                });

              case 12:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 9]]);
      }));

      function deleteProcessingPayment(_x17) {
        return _ref16.apply(this, arguments);
      }

      return deleteProcessingPayment;
    }()
  }, {
    key: 'updateProcessingPayment',
    value: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17(data) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/finance-payments/update-by/id', true, { data: data });

              case 3:
                resp = _context17.sent;

                if (!(resp.status === 200)) {
                  _context17.next = 6;
                  break;
                }

                return _context17.abrupt('return', resp.data);

              case 6:
                return _context17.abrupt('return', {
                  success: false
                });

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17['catch'](0);
                return _context17.abrupt('return', {
                  success: false,
                  message: _context17.t0
                });

              case 12:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 9]]);
      }));

      function updateProcessingPayment(_x18) {
        return _ref17.apply(this, arguments);
      }

      return updateProcessingPayment;
    }()
  }, {
    key: 'deleteImportedPayment',
    value: function () {
      var _ref18 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee18(id) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/imported-payments/delete-by/id', true, { data: [{ id: id }] });

              case 3:
                resp = _context18.sent;

                if (!(resp.status === 200)) {
                  _context18.next = 6;
                  break;
                }

                return _context18.abrupt('return', resp.data);

              case 6:
                return _context18.abrupt('return', {
                  success: false
                });

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18['catch'](0);
                return _context18.abrupt('return', {
                  success: false,
                  message: _context18.t0
                });

              case 12:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 9]]);
      }));

      function deleteImportedPayment(_x19) {
        return _ref18.apply(this, arguments);
      }

      return deleteImportedPayment;
    }()
  }, {
    key: 'updateImportedPayment',
    value: function () {
      var _ref19 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee19(data) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/imported-payments/update-by/id', true, { data: data });

              case 3:
                resp = _context19.sent;

                if (!(resp.status === 200)) {
                  _context19.next = 6;
                  break;
                }

                return _context19.abrupt('return', resp.data);

              case 6:
                return _context19.abrupt('return', {
                  success: false
                });

              case 9:
                _context19.prev = 9;
                _context19.t0 = _context19['catch'](0);
                return _context19.abrupt('return', {
                  success: false,
                  message: _context19.t0
                });

              case 12:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 9]]);
      }));

      function updateImportedPayment(_x20) {
        return _ref19.apply(this, arguments);
      }

      return updateImportedPayment;
    }()
  }, {
    key: 'uploadPaymentInvoices',
    value: function () {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee20(type, id, files) {
        var formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, resp;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                formData = new FormData();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context20.prev = 5;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('invoices', file);
                }
                _context20.next = 13;
                break;

              case 9:
                _context20.prev = 9;
                _context20.t0 = _context20['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context20.t0;

              case 13:
                _context20.prev = 13;
                _context20.prev = 14;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 16:
                _context20.prev = 16;

                if (!_didIteratorError) {
                  _context20.next = 19;
                  break;
                }

                throw _iteratorError;

              case 19:
                return _context20.finish(16);

              case 20:
                return _context20.finish(13);

              case 21:
                _context20.next = 23;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', '/api/v1/payments/payment-invoices/' + type + '/' + id, true, formData);

              case 23:
                resp = _context20.sent;

                if (!(resp.status === 200)) {
                  _context20.next = 26;
                  break;
                }

                return _context20.abrupt('return', resp.data && resp.data.data ? resp.data.data : resp.data);

              case 26:
                return _context20.abrupt('return', {
                  success: false
                });

              case 29:
                _context20.prev = 29;
                _context20.t1 = _context20['catch'](0);
                return _context20.abrupt('return', {
                  success: false,
                  message: _context20.t1
                });

              case 32:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 29], [5, 9, 13, 21], [14,, 16, 20]]);
      }));

      function uploadPaymentInvoices(_x21, _x22, _x23) {
        return _ref20.apply(this, arguments);
      }

      return uploadPaymentInvoices;
    }()
  }, {
    key: 'deletePaymentInvoice',
    value: function () {
      var _ref21 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee21(type, id, invoiceID) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('DELETE', '/api/v1/payments/payment-invoices/' + type + '/' + id + '/' + invoiceID, true);

              case 3:
                resp = _context21.sent;

                if (!(resp.status === 200)) {
                  _context21.next = 6;
                  break;
                }

                return _context21.abrupt('return', resp.data && resp.data.data ? resp.data.data : resp.data);

              case 6:
                return _context21.abrupt('return', {
                  success: false
                });

              case 9:
                _context21.prev = 9;
                _context21.t0 = _context21['catch'](0);
                return _context21.abrupt('return', {
                  success: false,
                  message: _context21.t0
                });

              case 12:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 9]]);
      }));

      function deletePaymentInvoice(_x24, _x25, _x26) {
        return _ref21.apply(this, arguments);
      }

      return deletePaymentInvoice;
    }()
  }, {
    key: 'updatePayout',
    value: function () {
      var _ref22 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee22(id, payout) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/payments/outcome/' + id, true, payout);

              case 3:
                resp = _context22.sent;

                if (!(resp.status === 200)) {
                  _context22.next = 6;
                  break;
                }

                return _context22.abrupt('return', resp.data);

              case 6:
                return _context22.abrupt('return', {
                  success: false
                });

              case 9:
                _context22.prev = 9;
                _context22.t0 = _context22['catch'](0);
                return _context22.abrupt('return', {
                  success: false,
                  message: _context22.t0
                });

              case 12:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 9]]);
      }));

      function updatePayout(_x27, _x28) {
        return _ref22.apply(this, arguments);
      }

      return updatePayout;
    }()
  }, {
    key: 'updatePayoutStatus',
    value: function () {
      var _ref23 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee23(id, status) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                _context23.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('PATCH', '/api/v1/payments/outcome/' + id + '/status', true, status);

              case 3:
                resp = _context23.sent;

                if (!(resp.status === 200)) {
                  _context23.next = 6;
                  break;
                }

                return _context23.abrupt('return', resp.data);

              case 6:
                return _context23.abrupt('return', {
                  success: false
                });

              case 9:
                _context23.prev = 9;
                _context23.t0 = _context23['catch'](0);
                return _context23.abrupt('return', {
                  success: false,
                  message: _context23.t0
                });

              case 12:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 9]]);
      }));

      function updatePayoutStatus(_x29, _x30) {
        return _ref23.apply(this, arguments);
      }

      return updatePayoutStatus;
    }()
  }, {
    key: 'downloadCogsEstimateRpt',
    value: function downloadCogsEstimateRpt(filters) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].download('/api/v1/payments/download/cogs-estimation-report', 'POST', { filters: filters }).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }
          var blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(blob, 'COGS Estimation Report (' + __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(), 'DD MMM YYYY') + ').xlsx');
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'downloadProfitSummaryRpt',
    value: function downloadProfitSummaryRpt(campaigns) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].download('/api/v1/payments/download/profit-summary-report', 'POST', { campaigns: campaigns }).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }
          var blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(blob, 'Profit Summary Report (' + __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_8_moment___default()(), 'DD MMM YYYY') + ').xlsx');
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }]);

  return PaymentAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PaymentAPI());

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getCategories: function getCategories() {
    var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

    if (lang === 'en') {
      return ['Food / F&B / Restaurants', 'Humour / Role playing / skits', 'Couple', 'Health & Fitness / Sports', 'Beauty & Personal Care', 'Tech', 'Home', 'Music/Dance/Sing', 'Travel / Places to visit', 'Gaming', 'Fashion', 'Finance', 'Family & Parenting', 'Entrepreneurship / business owner', 'Education / Lifehacks', 'Shopping & Ecommerce', 'Luxury'];
    } else if (lang === 'th') {
      return ['อาหาร/อาหารและเครื่องดื่ม/ร้านอาหาร', 'การเล่นบทบาท', 'คู่รัก', 'สุขภาพและฟิตเนส/ กีฬา', 'ความงามและการดูแลส่วนบุคคล', 'เทคโนโลยีและไลฟ์สไตล์', 'บ้าน', 'ดนตรี', 'การเดินทาง/สถานที่ท่องเที่ยว', 'การเล่นเกม', 'แฟชั่น', 'การเงิน', 'การเลี้ยงดู', 'ผู้ประกอบการ/เจ้าของธุรกิจ', 'เคล็ดลับชีวิต/การศึกษา', 'ช้อปปิ้งและอีคอมเมิร์ซ', 'สินค้าฟุ่มเฟือย/ไลฟ์สไตล์'];
    } else if (lang === 'vn') {
      return ['Thực phẩm/F&B/Nhà hàng', 'Hài hước/Nhập vai/Tiểu phẩm', 'Cặp đôi', 'Sức khỏe & Thể hình/Thể thao', 'Chăm sóc sắc đẹp & cá nhân', 'Công nghệ & Phong cách sống', 'Gia đình', 'Âm nhạc', 'Du lịch/ Địa điểm thăm quan', 'Gaming', 'Thời trang', 'Tài chính', 'Làm bố mẹ', 'Kinh doanh/ chủ doanh nghiệp', 'Lifehacks/ Giáo dục', 'Mua sắm và E- Commerce', 'Hàng hoá xa xỉ/ Lifestyle'];
    } else if (lang === 'id') {
      return ['Makanan/F&B/Restoran', 'Humor/Role Playing/Sandiwara', 'Pasangan', 'Kesehatan & Kebugaran/Olahraga', 'Kecantikan & Perawatan Pribadi', 'Teknologi & Gaya Hidup', 'Rumah', 'Musik', 'Travel/Tempat untuk Dikunjungi', 'Gaming', 'Fashion', 'Keuangan', 'Parenting', 'Kewirausahaan/pemilik usaha', 'Lifehack/Pendidikan', 'Shopping & Ecommerce', 'Barang Mewah/Gaya Hidup'];
    } else if (lang === 'cn') {
      return ['食品/餐饮/餐厅', '幽默/角色扮演/小品', '情侣', '健康与健身/体育', '美容与个人护理', '科技与生活方式', '家居', '音乐', '旅行/旅游景点', '电子游戏', '时尚', '金融', '家长类', '创业/企业家', '生活技巧/教育', '购物与电子商务', '奢侈品/生活方式'];
    } else if (lang === 'jp') {
      return ['食品/F&B/レストラン', 'ユーモア/ロールプレイング/スキット', 'カップル', '健康とフィットネス/スポーツ', '美容とパーソナルケア', 'テクノロジー', 'ホーム', '音楽/ダンス/シング', '旅行/訪問地', 'ゲーミング', 'ファッション', '金融', 'ファミリー&パレンティング', '起業家/事業主', '教育/ライフハック', 'ショッピング&Eコマース', 'ラグジュアリー'];
    }
  }
});

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(2185),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(2098),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__);















/* harmony default export */ __webpack_exports__["a"] = ({
  getPdfInBase64: function getPdfInBase64(campaign) {
    var campaignModelSections = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignModelSections;
    var copyrightText = 'All Rights Reserved. © Kobe Global Technologies Pte Ltd';
    var showBudget = false;
    var doc = {};
    doc = {
      content: [{
        image: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].kobeLogoDataURL,
        width: 50,
        style: 'logo'
      }],
      styles: {
        header: {
          fontSize: 20,
          bold: true
        },
        sectionTitle: {
          bold: true,
          fontSize: 18,
          marginTop: 20,
          padding: 5
        },
        options: {
          fontSize: 14,
          marginLeft: 15,
          marginTop: 15
        },
        logo: {
          alignment: 'right'
        },
        attributesTitle: {
          marginLeft: 15,
          marginBottom: 5
        },
        attributes: {
          marginLeft: 15,
          marginBottom: 5
        },
        exportTime: {
          fontSize: 9,
          alignment: 'center',
          color: '#A9A9A9'
        },
        copyright: {
          fontSize: 12,
          color: '#808080',
          marginTop: 20
        },
        image: {
          marginBottom: 15,
          maxWidth: 200
        }
      }
    };
    var sectionsColumns = { columns: [] };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(campaignModelSections), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (item.type === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignModelSectionType.BILLING_DETAILS) {
          if (showBudget) {
            doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
          }
        } else {
          doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
        }
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(item.content), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var field = _step2.value;

            if (field.name === 'gender') {
              var genderText = getDisplayValueFromSelect(field.value, campaign[field.name]);
              sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
              sectionsColumns.columns.push({ text: genderText + '\n\n', style: 'attributes' });
            } else if (field.name === 'budget') {
              if (showBudget) {
                sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
                sectionsColumns.columns.push({ text: campaign[field.name] + '\n\n', style: 'attributes' });
              }
            } else if (field.name === 'actionRequired_time' || field.name === 'actionRequired_action' || field.name === 'actionRequired_receive' || field.name === 'actionRequired_value') {} else if (field.name === 'angles') {
              var count = 0;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(campaign[field.name]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var experiences = _step3.value;

                  var optionTitle = field.label + ' ' + ++count;
                  doc.content.push({ text: optionTitle + '\n\n', style: 'options' });
                  var optionColumns = {
                    columns: []
                  };

                  var _loop = function _loop(exp) {
                    var experiencesTemplate = field.template;
                    var imageList = {
                      color: 'blue',
                      ul: []
                    };
                    if (exp === 'sample_images') {
                      optionColumns.columns.push({ text: 'Image/Video Inspirations' + '\n\n', style: 'attributesTitle' });
                      var _iteratorNormalCompletion4 = true;
                      var _didIteratorError4 = false;
                      var _iteratorError4 = undefined;

                      try {
                        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(experiences[exp]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                          var image = _step4.value;

                          var url = constructImageURL(image);
                          toDataURL(url).then(function (dataURL) {
                            imageList.ul.push({ image: dataURL, width: 200, style: 'image' });
                          });
                        }
                      } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                          }
                        } finally {
                          if (_didIteratorError4) {
                            throw _iteratorError4;
                          }
                        }
                      }

                      optionColumns.columns.push(imageList);
                      doc.content.push(optionColumns);
                      optionColumns = { columns: [] };
                    } else {
                      var otherExperiences = experiencesTemplate.filter(function (expTmp2) {
                        return expTmp2.name === exp;
                      });
                      var _iteratorNormalCompletion5 = true;
                      var _didIteratorError5 = false;
                      var _iteratorError5 = undefined;

                      try {
                        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(otherExperiences), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                          var otherExp = _step5.value;

                          optionColumns.columns.push({ text: otherExp.label, style: 'attributesTitle' });
                          optionColumns.columns.push({ text: experiences[exp] + '\n\n', style: 'attributes' });
                        }
                      } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                          }
                        } finally {
                          if (_didIteratorError5) {
                            throw _iteratorError5;
                          }
                        }
                      }

                      doc.content.push(optionColumns);
                      optionColumns = { columns: [] };
                    }
                  };

                  for (var exp in experiences) {
                    _loop(exp);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            } else {
              sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
              sectionsColumns.columns.push({ text: campaign[field.name] + '\n\n', style: 'attributes' });
            }
            doc.content.push(sectionsColumns);
            sectionsColumns = { columns: [] };
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    doc.content.push({ text: 'Generated at: ' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('MMMM Do YYYY, h:mm:ss a'), style: 'exportTime' });
    doc.content.push({ text: copyrightText, alignment: 'center', style: 'copyright' });

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["createPdf"](doc);

      pdfDocGenerator.getBase64(function (data) {
        if (data !== null) {
          resolve(data);
        } else {
          reject('Can not convert');
        }
      });
    });

    function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(function (option) {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    }

    function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    }

    function toDataURL(url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var reader = new FileReader();
          reader.onloadend = function () {
            return resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
    }
  },
  generatePDF: function generatePDF(pdfObject) {
    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
          var pdfDocGenerator, contractFile;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["fonts"] = {
                    Arial: {
                      normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                      bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                      italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
                    }
                  };
                  pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["createPdf"](pdfObject);
                  _context.next = 4;
                  return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
                    pdfDocGenerator.getDataUrl(function (dataUrl) {
                      var response = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.dataURLtoFile(dataUrl, 'bfs.pdf');
                      resolve(response);
                    });
                  });

                case 4:
                  contractFile = _context.sent;

                  if (contractFile) {
                    resolve(contractFile);
                  } else {
                    reject('Can not convert');
                  }

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        })), 1000);
      } catch (error) {
        reject(error);
        console.log(error);
      }
    });
  },
  generateBasePDF: function generateBasePDF(pdfObject) {
    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var pdfDocGenerator;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["fonts"] = {
                    Arial: {
                      normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                      bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                      italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
                    }
                  };
                  pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["createPdf"](pdfObject);

                  pdfDocGenerator.getBase64(function (data) {
                    if (data !== null) {
                      resolve(data);
                    } else {
                      reject('Can not convert');
                    }
                  });

                case 3:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        })), 1000);
      } catch (error) {
        reject(error);
        console.log(error);
      }
    });
  },
  downloadPDF: function downloadPDF(pdfObject, fileName) {
    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["fonts"] = {
            Arial: {
              normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
              bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
            }
          };
          var pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["createPdf"](pdfObject);
          pdfDocGenerator.download(fileName + '.pdf');
        }, 1000);
      } catch (error) {
        reject(error);
        console.log(error);
      }
    });
  },
  convertPDFLayout: function convertPDFLayout(campaignModelSections, campaignData, showBudget, copyrightText) {
    var campaignModelSectionType = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignModelSectionType;
    var doc = {};
    doc = {
      footer: function footer(currentPage, pageCount) {
        return {
          margin: 10,
          columns: [{
            fontSize: 9,
            text: [{
              text: '--------------------------------------------------------------------------' + '\n',
              margin: [0, 20]
            }, {
              text: currentPage.toString() + ' of ' + pageCount
            }],
            alignment: 'center'
          }]
        };
      },
      content: [{
        image: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].kobeLogoDataURL,
        width: 60,
        style: 'logo'
      }],
      styles: {
        header: {
          fontSize: 20,
          bold: true
        },
        footer: {
          alignment: 'center'
        },
        sectionTitle: {
          alignment: 'center',
          bold: true,
          fontSize: 18,
          marginTop: 20,

          marginBottom: 7,
          padding: 5
        },
        options: {
          alignment: 'left',
          bold: true,
          fontSize: 15,
          marginLeft: 13
        },
        logo: {
          alignment: 'center',
          marginBottom: 0
        },
        attributesTitle: {
          fontSize: 13,
          bold: true,

          marginBottom: 4
        },
        attributes: {
          marginBottom: 7,
          fontSize: 11
        },
        SmallBottomAttributes: {
          marginBottom: 3,
          fontSize: 11
        },
        customTitle: {
          marginLeft: 13
        },
        exportTime: {
          fontSize: 9,
          alignment: 'center',
          color: '#A9A9A9'
        },
        copyright: {
          fontSize: 12,
          color: '#808080',
          marginTop: 20
        },
        image: {
          marginBottom: 15,
          maxWidth: 200
        },
        canvasImage: {
          alignment: 'left'
        },
        kicLabel: {
          marginTop: 20,
          alignment: 'center'
        },
        top1: {
          marginTop: 0
        },
        sampleImage: {
          marginBottom: 10
        },
        spacingBottom: {
          marginBottom: 10
        }
      },
      defaultStyle: {
        font: 'Arial'
      }
    };

    var sectionsColumns = { columns: [] };
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(campaignModelSections), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var item = _step6.value;

        if (item.type === campaignModelSectionType.BILLING_DETAILS) {
          if (showBudget) {
            doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
          }
        } else {
          if (item.type === campaignModelSectionType.CONTENT_ANGLE || item.type === campaignModelSectionType.INFLUENCER_SELECTION) {
            doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle', pageBreak: 'before' });
          } else {
            doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
          }
        }

        var _loop2 = function _loop2(field) {
          if (field.name === 'gender') {
            var genderText = getDisplayValueFromSelect(field.value, campaignData[field.name]);
            if (genderText !== '-') {
              var attributeLists = {
                type: 'none',
                ul: []
              };
              attributeLists.ul.push({ text: field.label, style: 'attributesTitle' });
              attributeLists.ul.push({ text: genderText + '\n\n', style: 'attributes' });
              sectionsColumns.columns.push(attributeLists);
            }
          } else if (field.name === 'budget') {
            if (showBudget && campaignData[field.name]) {
              var _attributeLists = {
                type: 'none',
                ul: []
              };
              _attributeLists.ul.push({ text: field.label, style: 'attributesTitle' });
              _attributeLists.ul.push({ text: campaignData[field.name] + '\n\n', style: 'attributes' });
              sectionsColumns.columns.push(_attributeLists);
            }
          } else if (field.name === 'actionRequired_time' || field.name === 'actionRequired_action' || field.name === 'actionRequired_receive' || field.name === 'actionRequired_value') {} else if (field.name === 'angles') {
            var count = 0;
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
              for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(campaignData[field.name]), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var experiences = _step8.value;

                var optionColumns = {
                  columns: []
                };

                var _loop3 = function _loop3(exp) {
                  if (exp === 'option_name') {
                    var optionTitle = field.label + ' ' + ++count;
                    doc.content.push({ text: optionTitle + ': ' + experiences[exp] + '\n\n', style: 'options' });

                    if (experiences['context']) {
                      var _attributeLists2 = {
                        type: 'none',
                        ul: []
                      };
                      _attributeLists2.ul.push({ text: 'Campaign Context', style: 'attributesTitle' });
                      _attributeLists2.ul.push({ text: experiences['context'] + '\n\n\n', style: 'attributes' });
                      doc.content.push(_attributeLists2);
                    }
                  }
                  var experiencesTemplate = field.template;

                  var otherExperiences = experiencesTemplate.filter(function (expTmp2) {
                    return expTmp2.name === exp;
                  });
                  var _iteratorNormalCompletion9 = true;
                  var _didIteratorError9 = false;
                  var _iteratorError9 = undefined;

                  try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(otherExperiences), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                      var otherExp = _step9.value;

                      if (otherExp.name === 'formats') {
                        for (var formatIndex in experiences[exp]) {
                          var isAnyFormatFieldAdded = false;
                          optionColumns = { columns: [] };

                          var _loop4 = function _loop4(exp2) {
                            var experiencesTemplate2 = otherExp.template[0];
                            var otherExperiences2 = experiencesTemplate2.filter(function (expTmp2) {
                              return expTmp2.name === exp2;
                            });
                            var _iteratorNormalCompletion10 = true;
                            var _didIteratorError10 = false;
                            var _iteratorError10 = undefined;

                            try {
                              for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(otherExperiences2), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                var otherExp2 = _step10.value;

                                if (otherExp2.name === 'sample_images' && experiences[exp][formatIndex][exp2].length > 0) {
                                  (function () {
                                    isAnyFormatFieldAdded = true;

                                    optionColumns = { columns: [] };
                                    optionColumns.columns.push({ text: 'Image/video Inspirations', style: ['attributesTitle', 'customTitle'] });
                                    doc.content.push(optionColumns);
                                    optionColumns = { columns: [] };
                                    var attributeLists = {
                                      type: 'none',
                                      ul: []
                                    };
                                    var _iteratorNormalCompletion11 = true;
                                    var _didIteratorError11 = false;
                                    var _iteratorError11 = undefined;

                                    try {
                                      for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(experiences[exp][formatIndex][exp2]), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                        var image = _step11.value;

                                        if (image.type === 'image' && checkIfImage(image.url)) {
                                          var url = constructImageURL(image.url);
                                          toDataURL(url).then(function (dataURL) {
                                            attributeLists.ul.push({ image: dataURL, width: 200, style: ['sampleImage'] });
                                          });
                                        } else {
                                          attributeLists.ul.push({ text: image.url, style: 'sampleImage', link: image.url });
                                        }
                                      }
                                    } catch (err) {
                                      _didIteratorError11 = true;
                                      _iteratorError11 = err;
                                    } finally {
                                      try {
                                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                          _iterator11.return();
                                        }
                                      } finally {
                                        if (_didIteratorError11) {
                                          throw _iteratorError11;
                                        }
                                      }
                                    }

                                    optionColumns.columns.push(attributeLists);
                                    doc.content.push(optionColumns);
                                    optionColumns = { columns: [] };
                                    optionColumns.columns.push({ text: '', style: ['spacingBottom'] });
                                    doc.content.push(optionColumns);
                                    optionColumns = { columns: [] };
                                  })();
                                } else {
                                  if (typeof experiences[exp][formatIndex][exp2] === 'string' && experiences[exp][formatIndex][exp2] && experiences[exp][formatIndex][exp2] !== '-' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(experiences[exp][formatIndex][exp2]) !== Array || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(experiences[exp][formatIndex][exp2]) === Array && experiences[exp][formatIndex][exp2].length > 0 || otherExp2.name === 'mandatory' && experiences[exp][formatIndex][exp2].length > 0) {
                                    isAnyFormatFieldAdded = true;
                                    var _attributeLists3 = {
                                      type: 'none',
                                      ul: []
                                    };
                                    _attributeLists3.ul.push({ text: otherExp2.label, style: 'attributesTitle' });
                                    if (otherExp2.name === 'mandatory') {
                                      _attributeLists3.ul.push({ text: experiences[exp][formatIndex][exp2].join(', '), style: 'SmallBottomAttributes' });
                                    } else if (otherExp2.name === 'content_angle') {
                                      _attributeLists3.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'SmallBottomAttributes' });
                                    } else {
                                      _attributeLists3.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'attributes' });
                                    }
                                    optionColumns.columns.push(_attributeLists3);
                                    doc.content.push(optionColumns);
                                  }
                                }
                                doc.content.push(optionColumns);
                                if (optionColumns.columns.length > 1) {
                                  optionColumns = { columns: [] };
                                }
                              }
                            } catch (err) {
                              _didIteratorError10 = true;
                              _iteratorError10 = err;
                            } finally {
                              try {
                                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                  _iterator10.return();
                                }
                              } finally {
                                if (_didIteratorError10) {
                                  throw _iteratorError10;
                                }
                              }
                            }
                          };

                          for (var exp2 in experiences[exp][formatIndex]) {
                            _loop4(exp2);
                          }
                          if (isAnyFormatFieldAdded) {
                            doc.content.push({ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510 - 10, y2: 10, lineWidth: 0.01, lineColor: '#e1e1e1' }] });
                            doc.content.push({ text: '\n' });
                          }
                        }
                      } else {
                        if (exp !== 'option_name' && exp !== 'context') {
                          if (experiences[exp] && experiences[exp] !== '-' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(experiences[exp]) !== Array || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(experiences[exp]) === Array && experiences[exp].length > 0) {
                            var _attributeLists4 = {
                              type: 'none',
                              ul: []
                            };
                            _attributeLists4.ul.push({ text: otherExp.label, style: 'attributesTitle' });
                            _attributeLists4.ul.push({ text: experiences[exp] + '\n\n', style: 'attributes' });

                            optionColumns.columns.push(_attributeLists4);
                          }
                        }
                      }
                      doc.content.push(optionColumns);
                      optionColumns = { columns: [] };
                    }
                  } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                      }
                    } finally {
                      if (_didIteratorError9) {
                        throw _iteratorError9;
                      }
                    }
                  }
                };

                for (var exp in experiences) {
                  _loop3(exp);
                }
              }
            } catch (err) {
              _didIteratorError8 = true;
              _iteratorError8 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }
              } finally {
                if (_didIteratorError8) {
                  throw _iteratorError8;
                }
              }
            }
          } else if (field.name === 'kic') {
            if (campaignData[field.name] !== '' && typeof campaignData[field.name] === 'string') {
              sectionsColumns = { columns: [] };
              var _attributeLists5 = {
                type: 'none',
                ul: []
              };
              var url = constructImageURL(campaignData[field.name]);
              toDataURL(url).then(function (dataURL) {
                _attributeLists5.ul.push({ text: field.label, style: 'attributesTitle' });
                _attributeLists5.ul.push({ image: dataURL, width: 300, style: 'canvasImage', link: url });
              });
              sectionsColumns.columns.push(_attributeLists5);
            }
          } else if (field.name === 'vertical') {} else {
            if (field.name === 'campaignType' || field.name === 'dont' || field.name === 'visualMust' || field.name === 'copyMust' || field.name === 'ioNumbers') {} else if (field.name === 'campaignBackground') {
              var _attributeLists6 = {
                type: 'none',
                ul: []
              };
              _attributeLists6.ul.push({ text: field.label, style: 'attributesTitle' });
              _attributeLists6.ul.push({ text: campaignData[field.name] + '\n\n', style: 'attributes' });
              sectionsColumns.columns.push(_attributeLists6);
            } else {
              var addAttribute = true;
              if (field.name === 'engagement') {
                if (campaignData[field.name] <= 0) {
                  addAttribute = false;
                }
              } else if (field.name === 'revenueCalculation') {
                addAttribute = false;
              } else if (field.name === 'segment') {
                if (!campaignData[field.name]) {
                  campaignData['segment'] = '-';
                }
              } else if (field.name === 'targetLocation') {
                if (Array.isArray(campaignData[field.name])) {
                  campaignData['targetLocation'] = getCountryDisplayValueFromSelect(field.value, campaignData[field.name]);
                }
              }
              if (addAttribute && campaignData[field.name] && campaignData[field.name] !== '-' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(campaignData[field.name]) !== 'object' || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(campaignData[field.name]) === 'object' && campaignData[field.name].length > 0) {
                var _attributeLists7 = {
                  type: 'none',
                  ul: []
                };
                _attributeLists7.ul.push({ text: field.label, style: 'attributesTitle' });
                if (field.name === 'name' && typeof campaignData.campaignCode !== 'undefined') {
                  _attributeLists7.ul.push({ text: campaignData[field.name] + ' (' + campaignData.campaignCode + ')\n\n', style: 'attributes' });
                } else {
                  _attributeLists7.ul.push({ text: campaignData[field.name] + '\n\n', style: 'attributes' });
                }
                sectionsColumns.columns.push(_attributeLists7);
              }
            }
          }

          doc.content.push(sectionsColumns);
          if (sectionsColumns.columns.length > 1) {
            sectionsColumns = { columns: [] };
          }
        };

        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var field = _step7.value;

            _loop2(field);
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        sectionsColumns = { columns: [] };
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    doc.content.push({ text: copyrightText, alignment: 'center', style: 'copyright' });
    doc.content.push({ text: 'Generated at: ' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('MMMM Do YYYY, h:mm:ss a'), style: 'exportTime' });

    function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(function (option) {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    }

    function getCountryDisplayValueFromSelect(selectList, value) {
      var countryLists = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_9__static_sources_countries___default.a);
      if (typeof value === 'string') return value;
      var selectedOption = countryLists.filter(function (option) {
        return value.includes(option.code);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.name;
      }).join(', ') : '-';
    }

    function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    }
    function toDataURL(url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var reader = new FileReader();
          reader.onloadend = function () {
            return resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
    }
    function checkIfImage(url) {
      var images = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG'];
      var isImage = false;
      images.map(function (img) {
        if (url.endsWith(img)) {
          isImage = true;
        }
      });
      return isImage;
    }
    return doc;
  },
  generateBFS: function generateBFS(brandSheet) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var doc, bfsTypes;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              doc = __WEBPACK_IMPORTED_MODULE_8__campaignPDF__["a" /* default */].BFSConfig();
              bfsTypes = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].bfsTypes;

              if (!(brandSheet.type === bfsTypes.STORY_TELL)) {
                _context3.next = 6;
                break;
              }

              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_8__campaignPDF__["a" /* default */].generateStoryTell(doc.content, brandSheet);

            case 5:
              doc.content = _context3.sent;

            case 6:
              if (!(brandSheet.type === 'AOK' || brandSheet.type === bfsTypes.AOK)) {
                _context3.next = 10;
                break;
              }

              _context3.next = 9;
              return __WEBPACK_IMPORTED_MODULE_8__campaignPDF__["a" /* default */].generateAOK(doc.content, brandSheet);

            case 9:
              doc.content = _context3.sent;

            case 10:
              if (!(brandSheet.type === bfsTypes.KOBE_LITE)) {
                _context3.next = 14;
                break;
              }

              _context3.next = 13;
              return __WEBPACK_IMPORTED_MODULE_8__campaignPDF__["a" /* default */].generateKobeLite(doc.content, brandSheet);

            case 13:
              doc.content = _context3.sent;

            case 14:
              if (!(brandSheet.type === bfsTypes.UGC)) {
                _context3.next = 18;
                break;
              }

              _context3.next = 17;
              return __WEBPACK_IMPORTED_MODULE_8__campaignPDF__["a" /* default */].generateUGC(doc.content, brandSheet);

            case 17:
              doc.content = _context3.sent;

            case 18:
              return _context3.abrupt('return', doc);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }))();
  },
  generateAOK: function generateAOK(content, brandSheet) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var url, dataURL, brandSheetSections, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, section, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, attachFile, _dataURL;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.constructWebImageURL('/static/img/brand_sheet/aok_bg.png');
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.toDataURL(url);

            case 3:
              dataURL = _context4.sent;

              content.push({
                text: 'KOBE Uncut - BRAND FACT SHEET',
                style: 'sectionTitle'
              }, {
                text: 'KOBE Uncut GUIDELINES',
                style: 'singleTitle'
              }, {
                text: 'KOBE Uncut PROCESS',
                style: 'header'
              }, {
                image: dataURL,
                style: 'image',
                width: 500
              }, {
                text: 'LEAD TIME',
                style: 'header'
              }, {
                text: '14 days upon receiving this brand fact sheet and logistics from the client.',
                style: 'lastparagraph'
              }, {
                text: 'TIME/DATE OF PUBLISH',
                style: 'header'
              }, {
                text: 'Creators are free to post at any preferred time and day during the campaign period.',
                style: 'lastparagraph'
              }, {
                text: 'SELECTION CRITERIA',
                style: 'header'
              }, {
                text: 'Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)',
                style: 'subheader'
              }, {
                text: 'For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.',
                style: 'lastparagraph'
              }, {
                text: 'CREATORS CONTENT',
                style: 'header'
              }, {
                text: 'All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.',
                style: 'lastparagraph'
              }, {
                text: 'CAMPAIGN INFORMATION SHARING',
                style: 'header'
              }, {
                text: 'KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.',
                style: 'lastparagraph'
              }, {
                text: 'LOGISTICS ARRANGEMENT',
                style: 'header'
              }, {
                text: 'It is recommended for our clients to make your own logistics arrangements.',
                style: 'subheader'
              }, {
                text: 'For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.',
                style: 'subheader'
              }, {
                text: 'Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.',
                style: 'subheader'
              }, {
                text: 'There will be a 5 working day turnaround for all logistics arrangements.',
                style: 'subheader'
              }, {
                text: 'KOBE will not be responsible for any damaged or lost parcels.',
                style: 'lastparagraph'
              }, {
                text: 'ADDITIONAL ENGAGEMENT',
                style: 'header'
              }, {
                text: 'Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:',
                style: 'subheader'
              }, {
                ul: ['Contest giveaway on social media', 'Photoshoot for client', 'Video appearance in client’s own production', 'Usage of photos/videos from creators as Ads online or offline', 'Promo Code Shoutout', 'Link in Bio/Swipe Up'],
                style: 'lastparagraph'
              });
              brandSheetSections = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].brandSheetAOKFormSections;
              _iteratorNormalCompletion12 = true;
              _didIteratorError12 = false;
              _iteratorError12 = undefined;
              _context4.prev = 9;
              _iterator12 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheetSections.sectionOne.fields);

            case 11:
              if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                _context4.next = 55;
                break;
              }

              section = _step12.value;

              if (section.type === 'textbox' || section.type === 'textarea') {
                content.push({
                  text: section.label,
                  style: 'header'
                }, {
                  text: brandSheet[section.name],
                  style: 'lastparagraph'
                });
              }

              if (!(section.type === 'file')) {
                _context4.next = 52;
                break;
              }

              content.push({
                text: section.label,
                style: 'header'
              });

              if (!(brandSheet[section.name].length > 0)) {
                _context4.next = 51;
                break;
              }

              _iteratorNormalCompletion13 = true;
              _didIteratorError13 = false;
              _iteratorError13 = undefined;
              _context4.prev = 20;
              _iterator13 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet[section.name]);

            case 22:
              if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                _context4.next = 35;
                break;
              }

              attachFile = _step13.value;

              if (!(attachFile.type === 'image/jpeg' || attachFile.type === 'image/png')) {
                _context4.next = 31;
                break;
              }

              _context4.next = 27;
              return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.toDataURL(attachFile.url);

            case 27:
              _dataURL = _context4.sent;

              content.push({
                image: _dataURL,
                width: 200,
                style: 'image'
              });
              _context4.next = 32;
              break;

            case 31:
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              });

            case 32:
              _iteratorNormalCompletion13 = true;
              _context4.next = 22;
              break;

            case 35:
              _context4.next = 41;
              break;

            case 37:
              _context4.prev = 37;
              _context4.t0 = _context4['catch'](20);
              _didIteratorError13 = true;
              _iteratorError13 = _context4.t0;

            case 41:
              _context4.prev = 41;
              _context4.prev = 42;

              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }

            case 44:
              _context4.prev = 44;

              if (!_didIteratorError13) {
                _context4.next = 47;
                break;
              }

              throw _iteratorError13;

            case 47:
              return _context4.finish(44);

            case 48:
              return _context4.finish(41);

            case 49:
              _context4.next = 52;
              break;

            case 51:
              content.push({
                text: '-',
                style: 'lastparagraph'
              });

            case 52:
              _iteratorNormalCompletion12 = true;
              _context4.next = 11;
              break;

            case 55:
              _context4.next = 61;
              break;

            case 57:
              _context4.prev = 57;
              _context4.t1 = _context4['catch'](9);
              _didIteratorError12 = true;
              _iteratorError12 = _context4.t1;

            case 61:
              _context4.prev = 61;
              _context4.prev = 62;

              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }

            case 64:
              _context4.prev = 64;

              if (!_didIteratorError12) {
                _context4.next = 67;
                break;
              }

              throw _iteratorError12;

            case 67:
              return _context4.finish(64);

            case 68:
              return _context4.finish(61);

            case 69:
              return _context4.abrupt('return', content);

            case 70:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2, [[9, 57, 61, 69], [20, 37, 41, 49], [42,, 44, 48], [62,, 64, 68]]);
    }))();
  },
  generateKobeLite: function generateKobeLite(content, brandSheet) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var brandSheetSections, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, section, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, attachFile, dataURL;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              content.push({
                text: 'KOBE Lite - BRAND FACT SHEET',
                style: 'sectionTitle'
              }, {
                text: 'KOBE Lite GUIDELINES',
                style: 'singleTitle'
              }, {
                text: 'LEAD TIME',
                style: 'header'
              }, {
                text: '14 days upon receiving this brand fact sheet and logistics from the client.',
                style: 'lastparagraph'
              }, {
                text: 'TIME/DATE OF PUBLISH',
                style: 'header'
              }, {
                text: 'Creators are free to post at any preferred time and day during the campaign period.',
                style: 'lastparagraph'
              }, {
                text: 'CREATORS CONTENT',
                style: 'header'
              }, {
                text: 'All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.',
                style: 'lastparagraph'
              }, {
                text: 'CAMPAIGN INFORMATION SHARING',
                style: 'header'
              }, {
                text: 'By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.',
                style: 'lastparagraph'
              });
              brandSheetSections = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].brandSheetAOKFormSections;
              _iteratorNormalCompletion14 = true;
              _didIteratorError14 = false;
              _iteratorError14 = undefined;
              _context5.prev = 5;
              _iterator14 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheetSections.sectionOne.fields);

            case 7:
              if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                _context5.next = 51;
                break;
              }

              section = _step14.value;

              if (section.type === 'textbox' || section.type === 'textarea') {
                content.push({
                  text: section.label,
                  style: 'header'
                }, {
                  text: brandSheet[section.name],
                  style: 'lastparagraph'
                });
              }

              if (!(section.type === 'file')) {
                _context5.next = 48;
                break;
              }

              content.push({
                text: section.label,
                style: 'header'
              });

              if (!(brandSheet[section.name].length > 0)) {
                _context5.next = 47;
                break;
              }

              _iteratorNormalCompletion15 = true;
              _didIteratorError15 = false;
              _iteratorError15 = undefined;
              _context5.prev = 16;
              _iterator15 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet[section.name]);

            case 18:
              if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                _context5.next = 31;
                break;
              }

              attachFile = _step15.value;

              if (!(attachFile.type === 'image/jpeg' || attachFile.type === 'image/png')) {
                _context5.next = 27;
                break;
              }

              _context5.next = 23;
              return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.toDataURL(attachFile.url);

            case 23:
              dataURL = _context5.sent;

              content.push({
                image: dataURL,
                width: 200,
                style: 'image'
              });
              _context5.next = 28;
              break;

            case 27:
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              });

            case 28:
              _iteratorNormalCompletion15 = true;
              _context5.next = 18;
              break;

            case 31:
              _context5.next = 37;
              break;

            case 33:
              _context5.prev = 33;
              _context5.t0 = _context5['catch'](16);
              _didIteratorError15 = true;
              _iteratorError15 = _context5.t0;

            case 37:
              _context5.prev = 37;
              _context5.prev = 38;

              if (!_iteratorNormalCompletion15 && _iterator15.return) {
                _iterator15.return();
              }

            case 40:
              _context5.prev = 40;

              if (!_didIteratorError15) {
                _context5.next = 43;
                break;
              }

              throw _iteratorError15;

            case 43:
              return _context5.finish(40);

            case 44:
              return _context5.finish(37);

            case 45:
              _context5.next = 48;
              break;

            case 47:
              content.push({
                text: '-',
                style: 'lastparagraph'
              });

            case 48:
              _iteratorNormalCompletion14 = true;
              _context5.next = 7;
              break;

            case 51:
              _context5.next = 57;
              break;

            case 53:
              _context5.prev = 53;
              _context5.t1 = _context5['catch'](5);
              _didIteratorError14 = true;
              _iteratorError14 = _context5.t1;

            case 57:
              _context5.prev = 57;
              _context5.prev = 58;

              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }

            case 60:
              _context5.prev = 60;

              if (!_didIteratorError14) {
                _context5.next = 63;
                break;
              }

              throw _iteratorError14;

            case 63:
              return _context5.finish(60);

            case 64:
              return _context5.finish(57);

            case 65:
              return _context5.abrupt('return', content);

            case 66:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this3, [[5, 53, 57, 65], [16, 33, 37, 45], [38,, 40, 44], [58,, 60, 64]]);
    }))();
  },
  generateUGC: function generateUGC(content, brandSheet) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var url, dataURL, brandSheetSections, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, section, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, ct, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, attachFile, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, _ct, _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, _attachFile;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              url = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.constructWebImageURL('/static/img/brand_sheet/ugc_process.png');
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.toDataURL(url);

            case 3:
              dataURL = _context6.sent;

              content.push({
                text: 'UGC (User-Generated-Content) Videos Application Form',
                style: 'sectionTitle'
              }, {
                text: 'I am aware that kobe’s full service of S$15k and up, includes: ',
                style: 'subheader'
              }, {
                ul: ['Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.', 'Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.', 'Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.', 'Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.', 'Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.', 'Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.'],
                style: 'lastparagraph'
              }, {
                text: 'Lead time: 4 weeks',
                style: 'subheader'
              }, {
                text: 'To proceed with UGC videos application, please complete the following.',
                style: 'subheader'
              }, {
                text: brandSheet.ugcVideo || '',
                style: 'lastparagraph'
              }, {
                text: 'Includes:',
                style: 'subheader'
              }, {
                ul: ['Utilization and exposure to a nano-reviewer base of 10,000 individuals with follower counts up to 3,000.', 'Guidance and assistance in the creation of email invitations for reviewer outreach and engagement.', 'Immediate notifications when content is posted, with seamless collection of content assets for future use.', 'Direct access to reviewer contact information for the purpose of building relationships and facilitating additional collaborations.'],
                style: 'lastparagraph'
              }, {
                image: dataURL,
                style: 'image',
                width: 500
              }, {
                text: 'TIME/DATE OF PUBLISH',
                style: 'header'
              }, {
                text: 'Creators are free to post at any preferred time and day during the campaign period.',
                style: 'lastparagraph'
              }, {
                text: 'INFLUENCER SELECTION',
                style: 'header'
              }, {
                text: 'Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.',
                style: 'lastparagraph'
              }, {
                text: 'CREATORS CONTENT',
                style: 'header'
              }, {
                text: 'All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.',
                style: 'lastparagraph'
              }, {
                text: 'INFORMATION SHARING',
                style: 'header'
              }, {
                text: 'KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.',
                style: 'lastparagraph'
              }, {
                text: 'LOGISTICS ARRANGEMENT',
                style: 'header'
              }, {
                text: 'For products',
                style: 'subheader'
              }, {
                ul: ['Client to send products to creators directly for free', 'Client to arrange a pick-up point for creators to collect the products directly', 'Creator can make the purchase of product with attached receipt for 100% reimbursement from client'],
                style: 'lastparagraph'
              }, {
                text: 'For experience',
                style: 'subheader'
              }, {
                ul: ['Creator attend the experience directly and client to verify', 'Creator can make the purchase of experience with attached receipt for 100% reimbursement from client'],
                style: 'lastparagraph'
              }, {
                text: 'UGC VIDEOS TRACKING',
                style: 'header'
              }, {
                text: 'You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.',
                style: 'lastparagraph'
              }, {
                text: 'POST CAMPAIGN',
                style: 'header'
              }, {
                text: 'You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.',
                style: 'lastparagraph'
              });
              brandSheetSections = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].brandSheetAOKFormSections;
              _iteratorNormalCompletion16 = true;
              _didIteratorError16 = false;
              _iteratorError16 = undefined;
              _context6.prev = 9;
              _iterator16 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheetSections.sectionOne.fields);

            case 11:
              if (_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done) {
                _context6.next = 104;
                break;
              }

              section = _step16.value;

              if (section.type === 'textbox' || section.type === 'textarea' || section.type === 'radio') {
                content.push({
                  text: section.label,
                  style: 'header'
                }, {
                  text: brandSheet[section.name],
                  style: 'lastparagraph'
                });
              }

              if (!(section.type === 'custom')) {
                _context6.next = 101;
                break;
              }

              content.push({
                text: section.label,
                style: 'header'
              });

              if (!(section.name === 'sampleVideoContent')) {
                _context6.next = 59;
                break;
              }

              if (typeof brandSheet.sampleVideoContent === 'string') {
                content.push({
                  text: brandSheet.sampleVideoContent,
                  style: 'lastparagraph'
                });
              }

              if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(brandSheet.sampleVideoContent) === 'object')) {
                _context6.next = 39;
                break;
              }

              if (!brandSheet.sampleVideoContent.length) {
                _context6.next = 39;
                break;
              }

              _iteratorNormalCompletion17 = true;
              _didIteratorError17 = false;
              _iteratorError17 = undefined;
              _context6.prev = 23;

              for (_iterator17 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet.sampleVideoContent); !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                ct = _step17.value;

                content.push({
                  text: ct.link,
                  link: ct.link,
                  color: 'blue',
                  style: 'lastparagraph'
                });
              }
              _context6.next = 31;
              break;

            case 27:
              _context6.prev = 27;
              _context6.t0 = _context6['catch'](23);
              _didIteratorError17 = true;
              _iteratorError17 = _context6.t0;

            case 31:
              _context6.prev = 31;
              _context6.prev = 32;

              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }

            case 34:
              _context6.prev = 34;

              if (!_didIteratorError17) {
                _context6.next = 37;
                break;
              }

              throw _iteratorError17;

            case 37:
              return _context6.finish(34);

            case 38:
              return _context6.finish(31);

            case 39:
              if (!brandSheet.sampleVideoContentFiles.length) {
                _context6.next = 59;
                break;
              }

              _iteratorNormalCompletion18 = true;
              _didIteratorError18 = false;
              _iteratorError18 = undefined;
              _context6.prev = 43;

              for (_iterator18 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet.sampleVideoContentFiles); !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                attachFile = _step18.value;

                content.push({
                  text: 'Click to view',
                  link: attachFile.url,
                  color: 'blue',
                  style: 'lastparagraph'
                });
              }
              _context6.next = 51;
              break;

            case 47:
              _context6.prev = 47;
              _context6.t1 = _context6['catch'](43);
              _didIteratorError18 = true;
              _iteratorError18 = _context6.t1;

            case 51:
              _context6.prev = 51;
              _context6.prev = 52;

              if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
              }

            case 54:
              _context6.prev = 54;

              if (!_didIteratorError18) {
                _context6.next = 57;
                break;
              }

              throw _iteratorError18;

            case 57:
              return _context6.finish(54);

            case 58:
              return _context6.finish(51);

            case 59:
              if (!(section.name === 'marketingCollaterals')) {
                _context6.next = 101;
                break;
              }

              if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(brandSheet.marketingURL) === 'object')) {
                _context6.next = 81;
                break;
              }

              if (!brandSheet.marketingURL.length) {
                _context6.next = 81;
                break;
              }

              _iteratorNormalCompletion19 = true;
              _didIteratorError19 = false;
              _iteratorError19 = undefined;
              _context6.prev = 65;

              for (_iterator19 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet.marketingURL); !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                _ct = _step19.value;

                content.push({
                  text: _ct.link,
                  link: _ct.link,
                  color: 'blue',
                  style: 'lastparagraph'
                });
              }
              _context6.next = 73;
              break;

            case 69:
              _context6.prev = 69;
              _context6.t2 = _context6['catch'](65);
              _didIteratorError19 = true;
              _iteratorError19 = _context6.t2;

            case 73:
              _context6.prev = 73;
              _context6.prev = 74;

              if (!_iteratorNormalCompletion19 && _iterator19.return) {
                _iterator19.return();
              }

            case 76:
              _context6.prev = 76;

              if (!_didIteratorError19) {
                _context6.next = 79;
                break;
              }

              throw _iteratorError19;

            case 79:
              return _context6.finish(76);

            case 80:
              return _context6.finish(73);

            case 81:
              if (!brandSheet.marketingCollaterals.length) {
                _context6.next = 101;
                break;
              }

              _iteratorNormalCompletion20 = true;
              _didIteratorError20 = false;
              _iteratorError20 = undefined;
              _context6.prev = 85;

              for (_iterator20 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet.marketingCollaterals); !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                _attachFile = _step20.value;

                content.push({
                  text: 'Click to view',
                  link: _attachFile.url,
                  color: 'blue',
                  style: 'lastparagraph'
                });
              }
              _context6.next = 93;
              break;

            case 89:
              _context6.prev = 89;
              _context6.t3 = _context6['catch'](85);
              _didIteratorError20 = true;
              _iteratorError20 = _context6.t3;

            case 93:
              _context6.prev = 93;
              _context6.prev = 94;

              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }

            case 96:
              _context6.prev = 96;

              if (!_didIteratorError20) {
                _context6.next = 99;
                break;
              }

              throw _iteratorError20;

            case 99:
              return _context6.finish(96);

            case 100:
              return _context6.finish(93);

            case 101:
              _iteratorNormalCompletion16 = true;
              _context6.next = 11;
              break;

            case 104:
              _context6.next = 110;
              break;

            case 106:
              _context6.prev = 106;
              _context6.t4 = _context6['catch'](9);
              _didIteratorError16 = true;
              _iteratorError16 = _context6.t4;

            case 110:
              _context6.prev = 110;
              _context6.prev = 111;

              if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
              }

            case 113:
              _context6.prev = 113;

              if (!_didIteratorError16) {
                _context6.next = 116;
                break;
              }

              throw _iteratorError16;

            case 116:
              return _context6.finish(113);

            case 117:
              return _context6.finish(110);

            case 118:
              return _context6.abrupt('return', content);

            case 119:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this4, [[9, 106, 110, 118], [23, 27, 31, 39], [32,, 34, 38], [43, 47, 51, 59], [52,, 54, 58], [65, 69, 73, 81], [74,, 76, 80], [85, 89, 93, 101], [94,, 96, 100], [111,, 113, 117]]);
    }))();
  },
  generateStoryTell: function generateStoryTell(content, brandSheet) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var userGenders, url, dataURL, brandSheetSections, sectionOne, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, section, sectionTwo, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, _section, sectionThree, _loop5, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, _section2;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              userGenders = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userGenderDisplay;
              url = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.constructWebImageURL('/static/img/brand_sheet/storytell_bg.jpg');
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.toDataURL(url);

            case 4:
              dataURL = _context8.sent;

              content.push({
                text: 'STORYTELL - BRAND FACT SHEET',
                style: 'sectionTitle'
              }, {
                image: dataURL,
                style: 'image',
                width: 500
              });
              brandSheetSections = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].brandSheetFormSections;
              sectionOne = brandSheetSections.sectionOne;

              content.push({
                text: sectionOne.title,
                style: 'singleTitle'
              }, {
                text: sectionOne.subtitle,
                style: 'singleTitle'
              });
              _iteratorNormalCompletion21 = true;
              _didIteratorError21 = false;
              _iteratorError21 = undefined;
              _context8.prev = 12;
              for (_iterator21 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sectionOne.fields); !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                section = _step21.value;

                if (section.type === 'textbox' || section.type === 'textarea') {
                  if (section.name === 'mobilePhone') {
                    content.push({
                      text: 'Mobile No',
                      style: 'header'
                    }, {
                      text: brandSheet[section.name],
                      style: 'lastparagraph'
                    });
                  } else {
                    content.push({
                      text: section.label,
                      style: 'header'
                    }, {
                      text: brandSheet[section.name],
                      style: 'lastparagraph'
                    });
                  }
                }
              }
              _context8.next = 20;
              break;

            case 16:
              _context8.prev = 16;
              _context8.t0 = _context8['catch'](12);
              _didIteratorError21 = true;
              _iteratorError21 = _context8.t0;

            case 20:
              _context8.prev = 20;
              _context8.prev = 21;

              if (!_iteratorNormalCompletion21 && _iterator21.return) {
                _iterator21.return();
              }

            case 23:
              _context8.prev = 23;

              if (!_didIteratorError21) {
                _context8.next = 26;
                break;
              }

              throw _iteratorError21;

            case 26:
              return _context8.finish(23);

            case 27:
              return _context8.finish(20);

            case 28:
              sectionTwo = brandSheetSections.sectionTwo;

              content.push({
                text: sectionTwo.title,
                style: 'middleHeader'
              });
              _iteratorNormalCompletion22 = true;
              _didIteratorError22 = false;
              _iteratorError22 = undefined;
              _context8.prev = 33;
              for (_iterator22 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sectionTwo.fields); !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                _section = _step22.value;

                if (_section.type === 'textbox' || _section.type === 'textarea') {
                  if (_section.name === 'campaignBudget') {
                    content.push({
                      text: _section.label,
                      style: 'header'
                    }, {
                      text: brandSheet.budgetCurrency ? brandSheet.budgetCurrency + ' ' + brandSheet.campaignBudget : brandSheet.campaignBudget,
                      style: 'lastparagraph'
                    });
                  } else {
                    content.push({
                      text: _section.label,
                      style: 'header'
                    }, {
                      text: brandSheet[_section.name],
                      style: 'lastparagraph'
                    });
                  }
                }
              }
              _context8.next = 41;
              break;

            case 37:
              _context8.prev = 37;
              _context8.t1 = _context8['catch'](33);
              _didIteratorError22 = true;
              _iteratorError22 = _context8.t1;

            case 41:
              _context8.prev = 41;
              _context8.prev = 42;

              if (!_iteratorNormalCompletion22 && _iterator22.return) {
                _iterator22.return();
              }

            case 44:
              _context8.prev = 44;

              if (!_didIteratorError22) {
                _context8.next = 47;
                break;
              }

              throw _iteratorError22;

            case 47:
              return _context8.finish(44);

            case 48:
              return _context8.finish(41);

            case 49:
              sectionThree = brandSheetSections.sectionThree;

              content.push({
                text: sectionThree.title,
                style: 'middleHeader'
              });
              _loop5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop5(_section2) {
                var gender, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, attachFile, _dataURL2;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop5$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        content.push({
                          text: _section2.label,
                          style: 'header'
                        });
                        if (_section2.type === 'textbox' || _section2.type === 'textarea') {
                          if (_section2.name === 'keyInsights' || _section2.name === 'wouldLike' || _section2.name === 'dontWant' || _section2.name === 'lookAlike') {
                            content.push({
                              text: brandSheet[_section2.name].join('\n'),
                              style: 'lastparagraph'
                            });
                          } else {
                            content.push({
                              text: brandSheet[_section2.name],
                              style: 'lastparagraph'
                            });
                          }
                        }
                        if (_section2.type === 'checkbox') {
                          content.push({
                            text: brandSheet[_section2.name].join(', '),
                            style: 'lastparagraph'
                          });
                        }
                        if (_section2.type === 'select') {
                          if (_section2.name === 'gender') {
                            gender = userGenders.find(function (gender) {
                              return gender.value === brandSheet[_section2.name];
                            });

                            content.push({
                              text: gender.text,
                              style: 'lastparagraph'
                            });
                          }
                        }

                        if (!(_section2.type === 'file')) {
                          _context7.next = 41;
                          break;
                        }

                        if (!(brandSheet[_section2.name].length > 0)) {
                          _context7.next = 40;
                          break;
                        }

                        _iteratorNormalCompletion24 = true;
                        _didIteratorError24 = false;
                        _iteratorError24 = undefined;
                        _context7.prev = 9;
                        _iterator24 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(brandSheet[_section2.name]);

                      case 11:
                        if (_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done) {
                          _context7.next = 24;
                          break;
                        }

                        attachFile = _step24.value;

                        if (!(attachFile.type === 'image/jpeg' || attachFile.type === 'image/png')) {
                          _context7.next = 20;
                          break;
                        }

                        _context7.next = 16;
                        return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.toDataURL(attachFile.url);

                      case 16:
                        _dataURL2 = _context7.sent;

                        content.push({
                          image: _dataURL2,
                          width: 200,
                          style: 'image'
                        });
                        _context7.next = 21;
                        break;

                      case 20:
                        content.push({
                          text: 'Click to view',
                          link: attachFile.url,
                          color: 'blue',
                          style: 'lastparagraph'
                        });

                      case 21:
                        _iteratorNormalCompletion24 = true;
                        _context7.next = 11;
                        break;

                      case 24:
                        _context7.next = 30;
                        break;

                      case 26:
                        _context7.prev = 26;
                        _context7.t0 = _context7['catch'](9);
                        _didIteratorError24 = true;
                        _iteratorError24 = _context7.t0;

                      case 30:
                        _context7.prev = 30;
                        _context7.prev = 31;

                        if (!_iteratorNormalCompletion24 && _iterator24.return) {
                          _iterator24.return();
                        }

                      case 33:
                        _context7.prev = 33;

                        if (!_didIteratorError24) {
                          _context7.next = 36;
                          break;
                        }

                        throw _iteratorError24;

                      case 36:
                        return _context7.finish(33);

                      case 37:
                        return _context7.finish(30);

                      case 38:
                        _context7.next = 41;
                        break;

                      case 40:
                        content.push({
                          text: '-',
                          style: 'lastparagraph'
                        });

                      case 41:
                      case 'end':
                        return _context7.stop();
                    }
                  }
                }, _loop5, _this5, [[9, 26, 30, 38], [31,, 33, 37]]);
              });
              _iteratorNormalCompletion23 = true;
              _didIteratorError23 = false;
              _iteratorError23 = undefined;
              _context8.prev = 55;
              _iterator23 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sectionThree.fields);

            case 57:
              if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                _context8.next = 63;
                break;
              }

              _section2 = _step23.value;
              return _context8.delegateYield(_loop5(_section2), 't2', 60);

            case 60:
              _iteratorNormalCompletion23 = true;
              _context8.next = 57;
              break;

            case 63:
              _context8.next = 69;
              break;

            case 65:
              _context8.prev = 65;
              _context8.t3 = _context8['catch'](55);
              _didIteratorError23 = true;
              _iteratorError23 = _context8.t3;

            case 69:
              _context8.prev = 69;
              _context8.prev = 70;

              if (!_iteratorNormalCompletion23 && _iterator23.return) {
                _iterator23.return();
              }

            case 72:
              _context8.prev = 72;

              if (!_didIteratorError23) {
                _context8.next = 75;
                break;
              }

              throw _iteratorError23;

            case 75:
              return _context8.finish(72);

            case 76:
              return _context8.finish(69);

            case 77:
              return _context8.abrupt('return', content);

            case 78:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee7, _this5, [[12, 16, 20, 28], [21,, 23, 27], [33, 37, 41, 49], [42,, 44, 48], [55, 65, 69, 77], [70,, 72, 76]]);
    }))();
  },
  BFSConfig: function BFSConfig() {
    return {
      footer: function footer(currentPage, pageCount) {
        return {
          margin: 10,
          columns: [{
            fontSize: 9,
            text: [{
              text: '--------------------------------------------------------------------------' + '\n',
              margin: [0, 20]
            }, {
              text: currentPage.toString() + ' of ' + pageCount
            }],
            alignment: 'center'
          }]
        };
      },
      content: [{
        image: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].kobeLogoDataURL,
        width: 60,
        style: 'logo',
        alignment: 'left'
      }],
      styles: {
        sectionTitle: {
          alignment: 'center',
          bold: true,
          fontSize: 20,
          marginTop: 20,

          marginBottom: 20,
          padding: 5
        },
        singleTitle: {
          fontSize: 13,
          marginBottom: 15,
          bold: true
        },
        image: {
          marginBottom: 15
        },
        header: {
          fontSize: 12,
          bold: true,
          marginBottom: 2
        },
        middleHeader: {
          fontSize: 13,
          bold: true,
          marginTop: 5,
          marginBottom: 3
        },
        subheader: {
          fontSize: 12,
          marginBottom: 10
        },
        lastparagraph: {
          fontSize: 12,
          marginBottom: 15
        },
        footer: {
          alignment: 'center'
        }
      },
      defaultStyle: {
        font: 'Arial'
      }
    };
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(78);




/* harmony default export */ __webpack_exports__["a"] = ({
  paginate: function paginate(page, perPage) {
    var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/companies?page=' + page + '&per_page=' + perPage + '&keyword=' + keyword, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllCompanies: function getAllCompanies(force) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cacheCompanyList = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.cache.companyList;

      if (cacheCompanyList.data !== null && force === false) {
        resolve(cacheCompanyList);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/companies/all', true).then(function (response) {
          if (response.status !== 200) {
            reject(response);
            return;
          }

          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('SET_COMPANIES', response.data);

          resolve(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.cache.companyList);
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  },
  getCompany: function getCompany(companyID) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/companies/' + companyID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createCompany: function createCompany(company) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/api/v1/companies', true, company).then(function (response) {
        if (response.status !== 201) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  editCompany: function editCompany(company) {
    var companyID = company.id;
    delete company.id;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('put', '/api/v1/companies/' + companyID, true, company).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteCompany: function deleteCompany(companyID) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('delete', '/api/v1/companies/' + companyID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 103 */
/***/ (function(module, exports) {

var logo = 'data:image/png;base64,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';

module.exports = {
  logo: logo
};

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1491)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(2253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(36);





/* harmony default export */ __webpack_exports__["a"] = ({
  getLogin: function getLogin() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var headers;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              headers = {
                'Access-Control-Allow-Origin': '*'
              };
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', 'api/v1/payments/xero/connections', true, null, headers));

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);
              throw _context.t0;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },
  handleCallback: function handleCallback(_ref) {
    var _this2 = this;

    var _ref$code = _ref.code,
        code = _ref$code === undefined ? null : _ref$code;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (code) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return');

            case 3:
              return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/payments/xero/connect/token?code=' + code, true));

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 6]]);
    }))();
  },
  getTenant: function getTenant() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/payments/xero/tenant', true));

            case 4:
              _context3.prev = 4;
              _context3.t0 = _context3['catch'](0);
              throw _context3.t0;

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 4]]);
    }))();
  },
  syncResoures: function syncResoures(resource) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/payments/xero/resource/' + resource, true));

            case 4:
              _context4.prev = 4;
              _context4.t0 = _context4['catch'](0);
              throw _context4.t0;

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 4]]);
    }))();
  },
  getXeroContacts: function getXeroContacts() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/payments/xero/contacts', true));

            case 4:
              _context5.prev = 4;
              _context5.t0 = _context5['catch'](0);
              throw _context5.t0;

            case 7:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 4]]);
    }))();
  },
  updateXeroContact: function updateXeroContact(id, data) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('patch', '/api/v1/payments/xero/contacts/update/' + id, true, data).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Kobe Logo Blue.d9e463d.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1413)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1015),
  /* template */
  __webpack_require__(2138),
  /* scopeId */
  "data-v-588762fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1355)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1094),
  /* template */
  __webpack_require__(2042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var clientPaymentModes = [{
  name: 'GIRO',
  value: 0
}, {
  name: 'Cheque',
  value: 1
}];

var feedbackFormSections = {
  account_manager: {
    title: 'Account Manager'
  },
  content_curator: {
    title: 'Content & Community Curator'
  },
  client_name: {
    title: 'Client Name'
  },
  campaign_name: {
    title: 'Campaign Name',
    required: true
  },
  good_ratings: {
    headers: [{
      text: '',
      width: '75%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Very Poor',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Poor',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Average',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Good',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Very Good',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }],
    fields: [{
      title: 'How would you rate your overall experience with Kobe?',
      name: 'overall_experience',
      class: 'background-soft-grey',
      required: true,
      selected: true
    }],
    values: ['Very Poor', 'Poor', 'Average', 'Good', 'Very Good']
  },
  satisfy_ratings: {
    headers: [{
      text: '',
      width: '75%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Very Unsatisfied',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Unsatisfied',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Satisfied',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }, {
      text: 'Very Satisfied',
      width: '5%',
      class: 'no-border',
      align: 'center'
    }],
    fields: [{
      title: 'Selection of Influencers',
      name: 'influencers_selection',
      class: 'background-soft-grey',
      required: true,
      selected: true
    }, {
      title: 'Responsiveness of Account Managers',
      name: 'am_responsiveness',
      class: '',
      required: true,
      selected: false
    }, {
      title: 'Recommendation/Insight by Account Managers',
      name: 'am_recommendation',
      class: 'background-soft-grey',
      required: true,
      selected: true
    }, {
      title: 'Content Quality of the campaign',
      name: 'content_quality',
      class: '',
      required: true,
      selected: false
    }, {
      title: 'Adhering to Campaign Timeline',
      name: 'campaign_timeline',
      class: 'background-soft-grey',
      required: true,
      selected: true
    }],
    values: ['Very Unsatisfied', 'Unsatisfied', 'Satisfied', 'Very Satisfied']
  },

  likely_recommend: {
    headers: [{
      text: '',
      width: '75%',
      class: 'no-border',
      align: 'center'
    }],
    fields: [{
      title: 'How likely is it that you would recommend Kobe to friends or colleagues?',
      name: 'likely_recommend',
      caption: '(1 - Least Likely, 10 - Most Likely)',
      class: 'background-soft-grey',
      required: true,
      selected: true
    }]
  },
  what_did_well: {
    title: 'What did Kobe do well?',
    name: 'what_did_well',
    required: true
  },
  what_can_improve: {
    title: 'What can Kobe improve on?',
    name: 'what_can_improve',
    required: true
  },

  account_manager_status: {
    rate_title: 'Please rate from 1 to 4:',
    rate_desc: '1: dissatisfactory, 2: less than satisfactory, 3: satisfactory, 4: beyond satisfactory',
    title: 'My Account Manager,',
    name: 'account_manager_status',
    required: true,
    fields: [{
      label: 'Dependable',
      name: 'dependable',
      caption: '(He/she understands my needs and i can rely on her for campaign, timeline workflow management)'
    }, {
      label: 'Initiative',
      name: 'initiative',
      caption: 'he/she has demonstrates pro-activeness and dedication in the campaign'
    }, {
      label: 'Knowledgeable',
      name: 'knowledgeable',
      caption: 'he/she offers relevant perspectives and insights on influencer/social media'
    }]
  },
  inf_line_up: {
    fields: [{
      label: 'Creator line up',
      caption: 'Alignment to my campaign brief and objective:',
      name: 'inf_line_up',
      required: true,
      type: 'radio'
    }],
    values: ['little alignment', 'little to moderate alignment', 'moderate to strong alignment', 'strong alignment']
  },
  inf_content_created: {
    fields: [{
      label: 'Creator content created',
      caption: 'Alignment to my campaign brief and objective:',
      name: 'inf_content_created',
      required: true,
      type: 'radio'
    }],
    values: ['does not adhere to campaign brief', 'some adherence to campaign brief, some do not', 'adheres to campaign brief', 'beyond adherence to brief, delivers personality and creativity from content creator']
  },
  sea_countries: {
    title: 'SEA countries that your brand currently / have plans to market in:',
    name: 'sea_countries',
    required: true,
    fields: [{
      label: 'Singapore',
      value: 'Singapore',
      type: 'checkbox'
    }, {
      label: 'Malaysia',
      value: 'Malaysia',
      type: 'checkbox'
    }, {
      label: 'Indonesia',
      value: 'Indonesia',
      type: 'checkbox'
    }, {
      label: 'The Philippines',
      value: 'The Philippines',
      type: 'checkbox'
    }, {
      label: 'Thailand',
      value: 'Thailand',
      type: 'checkbox'
    }, {
      label: 'Vietnam',
      value: 'Vietnam',
      type: 'checkbox'
    }, {
      label: 'Others please specify:',
      value: 'other',
      type: 'textfield'
    }]
  },
  platforms: {
    title: 'Social media platforms that your brand currently / have plans to market on:',
    name: 'platforms',
    required: true,
    fields: [{
      label: 'Instagram',
      value: 'Instagram',
      type: 'checkbox'
    }, {
      label: 'Tiktok',
      value: 'Tiktok',
      type: 'checkbox'
    }, {
      label: 'Youtube',
      value: 'Youtube',
      type: 'checkbox'
    }, {
      label: 'Xiaohongshu',
      value: 'Xiaohongshu',
      type: 'checkbox'
    }, {
      label: 'Others please state:',
      value: 'other',
      type: 'textfield'
    }]
  },
  likely_consider_again: {
    headers: [{
      text: '',
      width: '75%',
      class: 'no-border',
      align: 'center'
    }],
    fields: [{
      title: 'When looking for Influencer Marketing, how likely are you to consider Kobe again?',
      name: 'likely_consider_again',
      caption: '(1 - Least Likely, 10 - Most Likely)',
      class: 'background-soft-grey',
      required: true,
      selected: true
    }]
  },
  kobe_connect: {
    title: 'Can you connect Kobe with others who might benefit from what we do?',
    fields: [{
      label: '1',
      name: 'connect_1',
      placeholder: 'Can be email address or contact number',
      type: 'textfield'
    }, {
      label: '2',
      name: 'connect_2',
      placeholder: '',
      type: 'textfield'
    }, {
      label: '3',
      name: 'connect_3',
      placeholder: '',
      type: 'textfield'
    }]
  },
  buyagain_decision: {
    title: 'Which of the following would influence your decision the most if you were to buy from Kobe again?',
    name: 'buyagain_decisions',
    required: true,
    fields: [{
      label: 'Relevant Targeting',
      value: 'relevant_targeting',
      type: 'checkbox'
    }, {
      label: 'Competitive Pricing',
      value: 'competitive_pricing',
      type: 'checkbox'
    }, {
      label: 'Quality of Content',
      value: 'quality_of_content',
      type: 'checkbox'
    }, {
      label: 'Quality of Influencers',
      value: 'quality_of_influencers',
      type: 'checkbox'
    }, {
      label: 'Service',
      value: 'service',
      type: 'checkbox'
    }, {
      label: 'Results',
      value: 'results',
      type: 'checkbox'
    }, {
      label: 'Hassle-Free Process',
      value: 'hassle_free',
      type: 'checkbox'
    }, {
      label: 'Other',
      value: 'other',
      type: 'textfield'
    }]
  },
  marketing_challenges: {
    title: 'What other marketing challenges would you like to solve?',
    name: 'marketing_challenges',
    required: true,
    fields: [{
      label: 'Brand Awareness',
      value: 'brand_awareness',
      type: 'checkbox'
    }, {
      label: 'Marketing Budget',
      value: 'marketing_budget',
      type: 'checkbox'
    }, {
      label: 'Lead Generation',
      value: 'lead_generation',
      type: 'checkbox'
    }, {
      label: 'Training Marketing Team',
      value: 'training_marketing_team',
      type: 'checkbox'
    }, {
      label: 'Social Media Content Marketing',
      value: 'social_media_marketing',
      type: 'checkbox'
    }, {
      label: 'Ideas for Marketing Campaigns',
      value: 'marketing_campaigns_ideas',
      type: 'checkbox'
    }, {
      label: 'Keeping up with Digital Marketing Trend',
      value: 'digital_marketing_trend',
      type: 'checkbox'
    }, {
      label: 'Identifying Customers/Target Audience',
      value: 'target_audience',
      type: 'checkbox'
    }, {
      label: 'Optimising Marketing Platforms (Website, Google, Instagram, Facebook etc)',
      value: 'optimising_marketing_platforms',
      type: 'checkbox'
    }, {
      label: 'Copywriting',
      value: 'copywriting',
      type: 'checkbox'
    }, {
      label: 'Proving ROI for Marketing Activities',
      value: 'marketing_activites',
      type: 'checkbox'
    }, {
      label: 'Other',
      value: 'other',
      type: 'textfield'
    }]
  },
  kobe_questions: {
    fields: [{
      label: 'Assuming it is appropriate, would you like for our marketing team to submit this campaign as an award entry?',
      name: 'testimonial_kobe',
      caption: 'Marketing will be in touch for next steps and testimonial.',
      required: true,
      type: 'radio'
    }],
    values: ['Yes', 'No']
  },
  refer_info: {
    title: 'Refer someone who will find Kobe services useful:',
    fields: [{
      label: 'Name',
      name: 'referName',
      type: 'textfield',
      class: 'pr-md-4',
      required: true
    }, {
      label: 'Company',
      name: 'referCompany',
      type: 'textfield',
      class: 'pr-md-4',
      required: true
    }, {
      label: 'Contact (number or email for Kobe to contact)',
      name: 'referContact',
      type: 'textfield',
      class: 'pr-md-4',
      required: true
    }]
  },
  contact_info: {
    fields: [{
      label: 'Name',
      name: 'name',
      type: 'textfield',
      class: 'pr-md-4',
      required: true
    }, {
      label: 'Email',
      name: 'email',
      type: 'textfield',
      required: true
    }, {
      label: 'Company',
      name: 'company',
      type: 'textfield',
      class: 'pr-md-4',
      required: true
    }, {
      label: 'Designation',
      name: 'designation',
      type: 'textfield',
      required: true
    }]
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  clientPaymentModes: clientPaymentModes,
  feedbackFormSections: feedbackFormSections
}));

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = ({
  analyse: function analyse(shortCode) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('post', '/api/v1/content-analysis', true, {
                short_code: shortCode
              });

            case 2:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  oembed: function oembed(shortcode) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/content-analysis/helper/oembed?short_code=' + shortcode, true);

            case 2:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context2.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  oembedOpen: function oembedOpen(shortcode) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/content-analysis-open/helper/oembed?short_code=' + shortcode, true);

            case 2:
              response = _context3.sent;

              if (!(response.status !== 200)) {
                _context3.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context3.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getHistories: function getHistories() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/content-analysis/history', true);

            case 2:
              response = _context4.sent;

              if (!(response.status !== 200)) {
                _context4.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context4.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(url) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  post: function post(url, formData) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', url, true, formData).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1539)
__webpack_require__(1537)
__webpack_require__(1538)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1178),
  /* template */
  __webpack_require__(2311),
  /* scopeId */
  "data-v-ecd5cc08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = platformDisplayName;
function platformDisplayName(platform) {
  if (typeof platform !== 'string') return platform;
  return platform.trim().toLowerCase() === 'twitter' ? 'X (Twitter)' : platform;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var BlocksToHtml = function () {
    function BlocksToHtml(data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BlocksToHtml);

        this.data = data;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(BlocksToHtml, [{
        key: 'generate',
        value: function generate() {
            var oldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var html = '';

            for (var i = 0; i < this.data.length; i++) {
                if (this.data[i].type === 'header') {
                    html += '<p></p>';
                    html += '<h' + this.data[i].data.level + '>' + unescape(this.data[i].data.text) + '</h' + this.data[i].data.level + '>';
                }

                if (this.data[i].type === 'title') {
                    html += '<p></p>';
                    html += '<p>' + this.data[i].data.text + '</p>';
                }

                if (this.data[i].type === 'paragraph') {
                    if (oldData) {
                        html += '<p></p>';
                    }
                    html += '<p>' + this.data[i].data.text + '</p>';
                }

                if (this.data[i].type === 'list') {
                    if (this.data[i].data.style === 'unordered') {
                        html += '<ul>';
                        for (var j = 0; j < this.data[i].data.items.length; j++) {
                            html += '<li>' + this.data[i].data.items[j] + '</li>';
                        }
                        html += '</ul>';
                    } else {
                        html += '<ol>';
                        for (var _j = 0; _j < this.data[i].data.items.length; _j++) {
                            html += '<li>' + this.data[i].data.items[_j] + '</li>';
                        }
                        html += '</ol>';
                    }
                }

                if (this.data[i].type === 'image') {
                    html += '<img style="margin-bottom:15px;" width="350" src="' + this.data[i].data.url + '">';
                }

                if (this.data[i].type === 'delimiter') {
                    html += '<p></p>';
                    html += '<hr/>';
                }
            }
            return html;
        }
    }]);

    return BlocksToHtml;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlocksToHtml);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



var formConfig = {
  title: 'Social Media Rate Card',
  sections: [{
    title: 'Instagram Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'Instagram Handle',
      name: 'instagramHandle',
      placeholder: '@handle',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Your IG Following Count',
      name: 'igFollowerCount',
      placeholder: '123000',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12',
      labelClass: 'follower-label'
    }, {
      label: 'IG Story',
      name: 'igStory',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats'
    }, {
      label: 'IG Post',
      name: 'igPost',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats'
    }, {
      label: 'IG Carousel',
      name: 'igCarousel',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats'
    }, {
      label: 'IG Reel',
      name: 'igReel',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats'
    }, {
      label: 'Remarks (Instagram)',
      name: 'igRemarks',
      type: 'textarea',
      placeholder: '(e.g. Bundle Rate)',
      class: 'col-xs-12 col-md-12 pb-0'
    }]
  }, {
    title: 'TikTok Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'TikTok Handle',
      name: 'tiktokHandle',
      placeholder: '@handle',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Your TikTok Following Count',
      name: 'tiktokFollowerCount',
      placeholder: '456700',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Tiktok',
      name: 'tiktok',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats'
    }, {
      label: 'Remarks (TikTok)',
      name: 'tiktokRemarks',
      type: 'textarea',
      placeholder: '(e.g. Bundle Rate)',
      class: 'col-xs-12 col-md-12'
    }]
  }, {
    title: 'LinkedIn Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'LinkedIn Handle',
      name: 'linkedinHandle',
      placeholder: '@handle or LinkedIn profile URL',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Followers (Connections)',
      name: 'linkedinFollowerCount',
      placeholder: '123000',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'LinkedIn Post',
      name: 'linkedin',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats'
    }]
  }, {
    title: 'X (Twitter) Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'X (Twitter) Handle',
      name: 'twitterHandle',
      placeholder: '@handle or x.com/handle',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'X (Twitter) Followers',
      name: 'twitterFollowerCount',
      placeholder: '123000',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'X (Twitter) Post',
      name: 'twitter',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats'
    }]
  }, {
    title: 'Facebook Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'Facebook Handle',
      name: 'facebookHandle',
      placeholder: '@handle or Facebook profile URL',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Facebook Followers',
      name: 'facebookFollowerCount',
      placeholder: '123000',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Facebook Post',
      name: 'facebook',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats'
    }]
  }, {
    title: 'YouTube Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'YouTube Handle',
      name: 'youtubeHandle',
      placeholder: '@handle or YouTube channel URL',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'YouTube Followers',
      name: 'youtubeFollowerCount',
      placeholder: '123000',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'YouTube Post',
      name: 'youtube',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats'
    }]
  }, {
    title: 'Twitch Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'Twitch Handle',
      name: 'twitchHandle',
      placeholder: '@handle or Twitch channel URL',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Twitch Followers',
      name: 'twitchFollowerCount',
      placeholder: '123000',
      type: 'normalNumber',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Twitch Post',
      name: 'twitch',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats'
    }]
  }, {
    title: 'Other Platforms Section',
    class: 'col-xs-12 col-md-12',
    fields: [{
      label: 'Add more platforms',
      type: 'multiple',
      name: 'platforms',
      class: 'col-xs-12 col-md-12',
      labelClass: 'more-platform-label',
      options: [{
        label: 'Platform',
        type: 'select',
        name: 'platform',
        divClass: 'platform-select',
        class: 'col-xs-12 col-md-4 platform-select pt-0',
        style: 'font-size: 12px;min-width: 100px;max-width: 120px;',
        options: [{
          label: 'Others',
          value: 'others'
        }]
      }, {
        label: 'URL',
        placeholder: 'URL',
        type: 'textarea',
        name: 'url',
        class: 'col-xs-12 col-md-4 pt-0'
      }, {
        label: 'Rate',
        placeholder: 'Rate',
        type: 'number',
        name: 'rate',
        prefix: 'SGD $',
        class: 'px-1 multiple-rate',
        style: 'width:100%;position:absolute;margin-top:95px'
      }, {
        type: 'delete',
        style: 'max-width:30px'
      }],
      child: {
        label: 'Others',
        placeholder: 'If others, please specify',
        type: 'textbox',
        name: 'otherPlatform',
        parentName: 'platform',
        class: 'col-xs-12 col-md-4'
      }
    }]
  }, {
    title: 'Common Fees',
    class: 'col-xs-12 col-md-12',
    fields: [{
      label: 'Event Attendance Fee',
      name: 'eventAppearance',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-6 d-flex flex-row pb-4',
      labelClass: 'label-stats'
    }, {
      label: 'Loading Fee',
      name: 'loadingFee',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-6 d-flex flex-row pb-4',
      labelClass: 'label-stats'
    }]
  }, {
    title: 'Global Section',
    class: 'col-xs-12 col-md-12',
    fields: [{
      label: 'Media Kit',
      name: 'uploadMediaKit',
      type: 'file',
      class: 'col-xs-12 col-md-12',
      style: 'max-width:800px'
    }]
  }]
};

var tableHeaders = [{
  text: 'Name',
  value: 'name',
  sortable: false
}, {
  text: 'Email',
  value: 'email',
  sortable: false
}, {
  text: 'Date of Birth',
  value: 'dateOfBirth',
  sortable: false
}, {
  text: 'Ethnicity',
  value: 'ethnicity',
  sortable: false
}, {
  text: 'Country',
  value: 'country',
  sortable: false
}, {
  text: 'City',
  value: 'city',
  sortable: false
}, {
  text: 'Gender',
  value: 'gender',
  sortable: false
}, {
  text: 'Contact Number',
  value: 'contactNo',
  sortable: false
}, {
  text: 'Instagram Handle',
  value: 'instagramHandle',
  sortable: false
}, {
  text: 'Instagram Followers',
  value: 'igFollowerCount',
  sortable: false
}, {
  text: 'TikTok Handle',
  value: 'tiktokHandle',
  sortable: false
}, {
  text: 'TikTok Followers',
  value: 'tiktokFollowerCount',
  sortable: false
}, {
  text: 'Youtube',
  value: 'youtube',
  sortable: false
}, {
  text: 'YouTube Followers',
  value: 'youtubeFollowerCount',
  sortable: false
}, {
  text: 'YouTube Post',
  value: 'youtubeRate',
  sortable: false
}, {
  text: 'Facebook',
  value: 'facebook',
  sortable: false
}, {
  text: 'Facebook Followers',
  value: 'facebookFollowerCount',
  sortable: false
}, {
  text: 'Facebook Post',
  value: 'facebookRate',
  sortable: false
}, {
  text: 'LinkedIn',
  value: 'linkedin',
  sortable: false
}, {
  text: 'Followers (Connections)',
  value: 'linkedinFollowerCount',
  sortable: false
}, {
  text: 'LinkedIn Post',
  value: 'linkedinRate',
  sortable: false
}, {
  text: 'X (Twitter)',
  value: 'twitter',
  sortable: false
}, {
  text: 'X (Twitter) Followers',
  value: 'twitterFollowerCount',
  sortable: false
}, {
  text: 'X (Twitter) Post',
  value: 'twitterRate',
  sortable: false
}, {
  text: 'Twitch',
  value: 'twitch',
  sortable: false
}, {
  text: 'Twitch Followers',
  value: 'twitchFollowerCount',
  sortable: false
}, {
  text: 'Twitch Post',
  value: 'twitchRate',
  sortable: false
}, {
  text: 'IG Story',
  value: 'igStory',
  sortable: false
}, {
  text: 'IG Post',
  value: 'igPost',
  sortable: false
}, {
  text: 'IG Carousel',
  value: 'igCarousel',
  sortable: false
}, {
  text: 'IG Reel',
  value: 'igReel',
  sortable: false
}, {
  text: 'IG Remarks',
  value: 'igRemarks',
  sortable: false
}, {
  text: 'TikTok',
  value: 'tiktok',
  sortable: false
}, {
  text: 'TikTok Remarks',
  value: 'tiktokRemarks',
  sortable: false
}, {
  text: 'Event Attendance',
  value: 'eventAppearance',
  sortable: false
}, {
  text: 'Loading Fee',
  value: 'loadingFee',
  sortable: false
}, {
  text: 'Media Kit',
  value: 'uploadMediaKit',
  sortable: false
}, {
  text: 'Preferred campaigns/genre',
  value: 'preferredCampaigns',
  sortable: false
}, {
  text: 'Genre/Keywords',
  value: 'labelDisplays',
  sortable: false
}, {
  text: 'Labels Edit',
  value: 'labels',
  sortable: false
}, {
  text: 'Profile short description',
  value: 'aboutYou',
  sortable: false
}, {
  text: 'Load Content Aggreement',
  value: 'loadContent',
  sortable: false
}, {
  text: 'Gifting Collaborations',
  value: 'giftBrand',
  sortable: false
}, {
  text: 'Engagement',
  value: 'engagement',
  sortable: false
}, {
  text: 'Views',
  value: 'views',
  sortable: false
}, {
  text: 'CC Remarks',
  value: 'ccRemarks',
  sortable: false
}, {
  text: 'Updated On',
  value: 'updatedAt',
  sortable: false
}, {
  text: 'Actions',
  value: 'action',
  sortable: false
}];

var getRanges = function getRanges(from, to) {
  var range = {};
  if (from) {
    range.from = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(from));
  }
  if (to) {
    range.to = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(to));
  }
  return range;
};
var followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
var followerOptions = getRanges(followersCount, followersCount);

var rateCardLabels = ['Comedy/Roleplaying/Skit', 'Music/Dance/Sing', 'Lifestyle', 'Travel/Places to visit', 'Food', 'Beauty & Personal Care', 'Fashion', 'Couple', 'Health & Fitness/Sports', 'Tech', 'Gaming', 'Finance', 'Family & Parenting', 'Entrepreneur/Business Owner', 'Education / Lifehacks', 'Home & Living', 'Luxury'];

var currencyOptions = ['SGD', 'USD', 'IDR', 'PHP', 'THB', 'MYR', 'VND'];

var rateCardTermsAndCondition = {
  title: {
    en: 'Terms and Conditions',
    th: 'ข้อกำหนดและเงื่อนไข',
    vn: 'Các điều khoản và điều kiện',
    id: 'Syarat dan Ketentuan',
    cn: '条款与条件'
  },
  html: {
    en: '\n    <ol>\n      <li>I have read and accepted the terms of use (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>I warrant that I am not currently embroiled in any controversies or legal disputes that may negatively impact my reputation or the reputation of Kobe or its Clients. I further agree to conduct myself in a manner consistent with the values of professionalism, integrity, and decency. Kobe reserves the right to terminate any Campaign Agreement with Content Creators found to be in violation of this clause, and such termination may result in forfeiture of any compensation or benefits under the agreement.</li>\n      <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specifed in the Campaign Agreement.</li>\n      <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>\n      <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>\n      <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and understand if this is not met, or the client has any complaints about my performance, I may forfeit my rate or be deducted a penalty by the client.</li>\n      <li>If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.</li>\n    </ol>',
    th: '\n    <ol>\n      <li>\u0E09\u0E31\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E48\u0E32\u0E19\u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27 (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>\u0E09\u0E31\u0E19\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E1E\u0E31\u0E27\u0E1E\u0E31\u0E19\u0E01\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E02\u0E31\u0E14\u0E41\u0E22\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E1E\u0E34\u0E1E\u0E32\u0E17\u0E17\u0E32\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E40\u0E2A\u0E35\u0E22\u0E15\u0E48\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07 Kobe \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E09\u0E31\u0E19\u0E22\u0E31\u0E07\u0E15\u0E01\u0E25\u0E07\u0E17\u0E35\u0E48\u0E08\u0E30\u0E1B\u0E23\u0E30\u0E1E\u0E24\u0E15\u0E34\u0E15\u0E19\u0E43\u0E19\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E14\u0E04\u0E25\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E19\u0E34\u0E22\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E21\u0E37\u0E2D\u0E2D\u0E32\u0E0A\u0E35\u0E1E \u0E04\u0E27\u0E32\u0E21\u0E0B\u0E37\u0E48\u0E2D\u0E2A\u0E31\u0E15\u0E22\u0E4C \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 Kobe \u0E02\u0E2D\u0E2A\u0E07\u0E27\u0E19\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E43\u0E14 \u0E46 \u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E1E\u0E1A\u0E27\u0E48\u0E32\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E22\u0E38\u0E15\u0E34\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E2D\u0E32\u0E08\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E43\u0E2B\u0E49\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E34\u0E1A\u0E04\u0E48\u0E32\u0E15\u0E2D\u0E1A\u0E41\u0E17\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E43\u0E14 \u0E46 \u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07</li>\n      <li>\u0E09\u0E31\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 Kobe \u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E41\u0E25\u0E30\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E41\u0E1A\u0E1A\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E1C\u0E48\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E27\u0E25\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E01 (6) \u0E40\u0E14\u0E37\u0E2D\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E19\u0E32\u0E19\u0E01\u0E27\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E44\u0E27\u0E49\u0E43\u0E19 \u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E01\u0E32\u0E23\u0E23\u0E13\u0E23\u0E07\u0E04\u0E4C</li>\n      <li>\u0E09\u0E31\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E09\u0E31\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49 \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E42\u0E14\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32 \u0E40\u0E0A\u0E48\u0E19 \u0E20\u0E32\u0E1E\u0E16\u0E48\u0E32\u0E22\u0E41\u0E25\u0E30\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D (\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 IP) \u0E04\u0E38\u0E13\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E02\u0E2D\u0E07 \u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E22\u0E31\u0E01\u0E22\u0E2D\u0E01\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E43\u0E14\u0E46</li>\n      <li>\u0E09\u0E31\u0E19\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E01\u0E32\u0E23\u0E08\u0E48\u0E32\u0E22\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E41\u0E25\u0E30\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E1A\u0E19 https://app.getkobe.com/ \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E07\u0E32\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19 \u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E20\u0E32\u0E22\u0E43\u0E19 45 \u0E27\u0E31\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E2A\u0E48\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E1A\u0E19\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E32\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E01\u0E23\u0E13\u0E35\u0E43\u0E14\u0E08\u0E30\u0E16\u0E36\u0E07\u0E01\u0E48\u0E2D\u0E19</li>\n      <li>\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E09\u0E31\u0E19\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1A\u0E23\u0E35\u0E1F\u0E41\u0E25\u0E49\u0E27 \u0E09\u0E31\u0E19\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E20\u0E32\u0E22\u0E43\u0E19\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E41\u0E25\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E41\u0E19\u0E27\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E08\u0E32\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E09\u0E31\u0E19\u0E08\u0E30\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E19\u0E31\u0E49\u0E19\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E15\u0E32\u0E21\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14 \u0E41\u0E25\u0E30\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E27\u0E48\u0E32\u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E19\u0E31\u0E49\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E23\u0E49\u0E2D\u0E07\u0E40\u0E23\u0E35\u0E22\u0E19\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E1C\u0E25\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19 \u0E09\u0E31\u0E19\u0E2D\u0E32\u0E08\u0E40\u0E2A\u0E35\u0E22\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E16\u0E39\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E2B\u0E31\u0E01\u0E04\u0E48\u0E32\u0E1B\u0E23\u0E31\u0E1A</li>\n      <li>\u0E2B\u0E32\u0E01\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E16\u0E39\u0E01\u0E23\u0E27\u0E21\u0E44\u0E27\u0E49\u0E43\u0E19\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D \u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E23\u0E27\u0E21\u0E44\u0E27\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E32\u0E22\u0E15\u0E48\u0E2D</li>\n    </ol>',
    vn: '\n    <ol>\n      <li>T\xF4i \u0111\xE3 \u0111\u1ECDc v\xE0 ch\u1EA5p nh\u1EADn c\xE1c \u0111i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>T\xF4i \u0111\u1EA3m b\u1EA3o r\u1EB1ng hi\u1EC7n t\u1EA1i t\xF4i kh\xF4ng b\u1ECB l\xF4i k\xE9o v\xE0o b\u1EA5t k\u1EF3 tranh c\xE3i ho\u1EB7c tranh ch\u1EA5p ph\xE1p l\xFD n\xE0o c\xF3 th\u1EC3 \u1EA3nh h\u01B0\u1EDFng ti\xEAu c\u1EF1c \u0111\u1EBFn danh ti\u1EBFng c\u1EE7a t\xF4i ho\u1EB7c danh ti\u1EBFng c\u1EE7a Kobe ho\u1EB7c Kh\xE1ch h\xE0ng c\u1EE7a Kobe. T\xF4i c\u0169ng \u0111\u1ED3ng \xFD h\xE0nh x\u1EED theo c\xE1ch ph\xF9 h\u1EE3p v\u1EDBi c\xE1c gi\xE1 tr\u1ECB v\u1EC1 t\xEDnh chuy\xEAn nghi\u1EC7p, t\xEDnh ch\xEDnh tr\u1EF1c v\xE0 l\u1EC5 \u0111\u1ED9. Kobe c\xF3 quy\u1EC1n ch\u1EA5m d\u1EE9t b\u1EA5t k\u1EF3 Th\u1ECFa thu\u1EADn Chi\u1EBFn d\u1ECBch n\xE0o v\u1EDBi Ng\u01B0\u1EDDi t\u1EA1o n\u1ED9i dung b\u1ECB ph\xE1t hi\u1EC7n vi ph\u1EA1m \u0111i\u1EC1u kho\u1EA3n n\xE0y v\xE0 vi\u1EC7c ch\u1EA5m d\u1EE9t \u0111\xF3 c\xF3 th\u1EC3 d\u1EABn \u0111\u1EBFn vi\u1EC7c m\u1EA5t m\u1ECDi kho\u1EA3n b\u1ED3i th\u01B0\u1EDDng ho\u1EB7c l\u1EE3i \xEDch theo th\u1ECFa thu\u1EADn.</li>\n      <li>T\xF4i \u0111\u1ED3ng \xFD r\u1EB1ng m\u1ECDi n\u1ED9i dung \u0111\u01B0\u1EE3c g\u1EEDi t\u1EDBi Kobe theo Th\u1ECFa thu\u1EADn Chi\u1EBFn d\u1ECBch v\xE0 \u0111\u01B0\u1EE3c Kh\xE1ch h\xE0ng ch\u1EA5p nh\u1EADn s\u1EBD v\u1EABn c\xF3 th\u1EC3 truy c\u1EADp c\xF4ng khai th\xF4ng qua (c\xE1c) t\xE0i kho\u1EA3n m\u1EA1ng x\xE3 h\u1ED9i c\u1EE7a b\u1EA1n trong t\u1ED1i thi\u1EC3u s\xE1u (6) th\xE1ng ho\u1EB7c th\u1EDDi h\u1EA1n l\xE2u h\u01A1n nh\u01B0 \u0111\u01B0\u1EE3c quy \u0111\u1ECBnh trong Th\u1ECFa thu\u1EADn Chi\u1EBFn d\u1ECBch.</li>\n      <li>T\xF4i s\u1EDF h\u1EEFu t\u1EA5t c\u1EA3 n\u1ED9i dung v\xE0 th\xF4ng tin t\xF4i t\u1EA1o, ngo\xE0i ra, n\u1ED9i dung \u0111\u01B0\u1EE3c b\u1EA3o v\u1EC7 b\u1EDFi quy\u1EC1n s\u1EDF h\u1EEFu tr\xED tu\u1EC7, nh\u01B0 \u1EA3nh v\xE0 video (n\u1ED9i dung IP), B\u1EA1n tuy\xEAn b\u1ED1 v\xE0 \u0111\u1EA3m b\u1EA3o r\u1EB1ng n\u1ED9i dung \u0111\xF3 s\u1EBD l\xE0 t\xE1c ph\u1EA9m g\u1ED1c c\u1EE7a b\u1EA1n v\xE0 n\u1ED9i dung \u0111\xF3 s\u1EBD kh\xF4ng vi ph\u1EA1m ho\u1EB7c chi\u1EBFm d\u1EE5ng quy\u1EC1n s\u1EDF h\u1EEFu tr\xED tu\u1EC7 c\u1EE7a b\u1EA5t k\u1EF3 b\xEAn th\u1EE9 ba n\xE0o.</li>\n      <li>T\xF4i s\u1EBD g\u1EEDi kho\u1EA3n thanh to\xE1n c\u1EE7a m\xECnh v\xE0 t\u1EA5t c\u1EA3 s\u1ED1 li\u1EC7u th\u1ED1ng k\xEA v\u1EC1 b\xE0i \u0111\u0103ng tr\xEAn https://app.getkobe.com/ sau khi c\xF4ng vi\u1EC7c ho\xE0n th\xE0nh \u0111\u1EC3 thanh to\xE1n \u0111\u01B0\u1EE3c x\u1EED l\xFD. Kho\u1EA3n thanh to\xE1n s\u1EBD \u0111\u01B0\u1EE3c nh\u1EADn trong v\xF2ng 45 ng\xE0y sau khi g\u1EEDi kho\u1EA3n thanh to\xE1n tr\xEAn n\u1EC1n t\u1EA3ng v\xE0/ho\u1EB7c x\xE1c nh\u1EADn thanh to\xE1n t\u1EEB kh\xE1ch h\xE0ng, t\xF9y theo th\u1EDDi \u0111i\u1EC3m n\xE0o \u0111\u1EBFn tr\u01B0\u1EDBc.</li>\n      <li>Sau khi nh\u1EADn \u0111\u01B0\u1EE3c x\xE1c nh\u1EADn v\u1EC1 b\u1EA3n t\xF3m t\u1EAFt, t\xF4i s\u1EBD g\u1EEDi t\u1EA5t c\u1EA3 c\xE1c b\u1EA3n nh\xE1p m\u1ED9t c\xE1ch k\u1ECBp th\u1EDDi v\xE0 theo h\u01B0\u1EDBng d\u1EABn \u0111\u01B0\u1EE3c y\xEAu c\u1EA7u t\u1EEB kh\xE1ch h\xE0ng. T\xF4i s\u1EBD \u0111\u1EA3m b\u1EA3o b\xE0i \u0111\u0103ng \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB \u0111\xFAng h\u1EA1n v\xE0 hi\u1EC3u r\u1EB1ng n\u1EBFu \u0111i\u1EC1u n\xE0y kh\xF4ng \u0111\u01B0\u1EE3c \u0111\xE1p \u1EE9ng ho\u1EB7c kh\xE1ch h\xE0ng c\xF3 b\u1EA5t k\u1EF3 khi\u1EBFu n\u1EA1i n\xE0o v\u1EC1 hi\u1EC7u su\u1EA5t c\u1EE7a t\xF4i, t\xF4i c\xF3 th\u1EC3 b\u1ECB m\u1EA5t m\u1EE9c gi\xE1 c\u1EE7a m\xECnh ho\u1EB7c b\u1ECB kh\xE1ch h\xE0ng kh\u1EA5u tr\u1EEB m\u1ED9t h\xECnh ph\u1EA1t.</li>\n      <li>N\u1EBFu s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c \u0111\u01B0a v\xE0o chi\u1EBFn d\u1ECBch th\xEC kh\xF4ng n\xEAn \u0111\u01B0a ch\xFAng v\xE0o m\u1EE5c \u0111\xEDch b\xE1n ho\u1EB7c b\xE1n l\u1EA1i.</li>\n    </ol>',
    id: '\n    <ol>\n      <li>Saya telah membaca dan menerima ketentuan penggunaan (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>Saya menjamin bahwa saat ini saya tidak terlibat dalam kontroversi atau perselisihan hukum apa pun yang dapat berdampak negatif terhadap reputasi saya atau reputasi Kobe atau Kliennya. Saya selanjutnya setuju untuk berperilaku sesuai dengan nilai-nilai profesionalisme, integritas, dan kesopanan. Kobe berhak mengakhiri Perjanjian Campaign apa pun dengan Pembuat Konten yang ditemukan melanggar klausul ini, dan penghentian tersebut dapat mengakibatkan hilangnya kompensasi atau manfaat apa pun berdasarkan perjanjian.</li>\n      <li>Saya setuju bahwa konten apa pun yang dikirimkan ke Kobe berdasarkan Perjanjian Campaign dan diterima oleh Klien akan tetap dapat diakses publik melalui akun media sosial Anda selama minimal enam (6) bulan, atau jangka waktu lebih lama sebagaimana ditentukan dalam Perjanjian Kampanye.</li>\n      <li>Saya memiliki seluruh konten dan informasi yang saya buat, selain itu, konten yang dilindungi oleh hak kekayaan intelektual, seperti foto dan video (konten IP), Anda dengan ini menyatakan dan menjamin bahwa konten tersebut merupakan karya asli Anda dan bahwa konten tersebut tidak akan melanggar atau menyalahgunakan hak kekayaan intelektual pihak ketiga mana pun.</li>\n      <li>Saya akan mengirimkan pembayaran saya dan semua statistik postingan di https://app.getkobe.com/ setelah pekerjaan selesai agar pembayaran dapat diproses. Pembayaran akan diterima dalam waktu 45 hari setelah penyerahan pembayaran pada platform dan/atau izin pembayaran dari klien, mana yang lebih dulu.</li>\n      <li>Setelah saya menerima konfirmasi brief, saya akan menyerahkan semua draft tepat waktu dan sesuai dengan pedoman yang diminta dari klien. Saya akan memastikan postingan tersebut ditayangkan pada tanggal tenggat waktu dan memahami jika hal ini tidak dipenuhi, atau klien memiliki keluhan tentang kinerja saya, saya dapat kehilangan tarif saya atau dikenakan penalti oleh klien.</li>\n      <li>Jika produk disertakan dalam campaign, produk tersebut tidak boleh disertakan untuk tujuan dijual atau dijual kembali.</li>\n    </ol>',
    cn: '\n    <ol>\n      <li>\u6211\u5DF2\u9605\u8BFB\u5E76\u63A5\u53D7\u4E86\u4F7F\u7528\u6761\u6B3E\uFF08https://www.getkobe.com/infuencer-terms-use-agreement/\uFF09</li>\n      <li>\u6211\u4FDD\u8BC1\u6211\u76EE\u524D\u6CA1\u6709\u53C2\u4E0E\u53EF\u80FD\u4F1A\u5BF9\u6211\u7684\u58F0\u8A89\u6216Kobe\u53CA\u5176\u5BA2\u6237\u7684\u58F0\u8A89\u9020\u6210\u8D1F\u9762\u5F71\u54CD\u7684\u4EFB\u4F55\u4E89\u8BAE\u6216\u6CD5\u5F8B\u7EA0\u7EB7\u3002\u6211\u8FDB\u4E00\u6B65\u540C\u610F\u4EE5\u4E13\u4E1A\u3001\u8BDA\u4FE1\u548C\u5F97\u4F53\u7684\u65B9\u5F0F\u884C\u4E8B\u3002Kobe\u4FDD\u7559\u7EC8\u6B62\u4EFB\u4F55\u53D1\u73B0\u8FDD\u53CD\u672C\u6761\u6B3E\u7684\u5185\u5BB9\u521B\u4F5C\u8005\u7684\u6D3B\u52A8\u534F\u8BAE\u7684\u6743\u5229\uFF0C\u6B64\u7C7B\u7EC8\u6B62\u53EF\u80FD\u5BFC\u81F4\u534F\u8BAE\u4E0B\u7684\u4EFB\u4F55\u8865\u507F\u6216\u798F\u5229\u7684\u6CA1\u6536\u3002</li>\n      <li>\u6211\u540C\u610F\u6839\u636E\u6D3B\u52A8\u534F\u8BAE\u5411Kobe\u63D0\u4EA4\u5E76\u88AB\u5BA2\u6237\u63A5\u53D7\u7684\u4EFB\u4F55\u5185\u5BB9\u90FD\u5C06\u901A\u8FC7\u60A8\u7684\u793E\u4EA4\u5A92\u4F53\u8D26\u6237\u4FDD\u6301\u516C\u5F00\u53EF\u8BBF\u95EE\uFF0C\u6700\u77ED\u4FDD\u7559\u671F\u4E3A\u516D\uFF086\uFF09\u4E2A\u6708\uFF0C\u6216\u8005\u5728\u6D3B\u52A8\u534F\u8BAE\u4E2D\u6307\u5B9A\u7684\u66F4\u957F\u671F\u9650\u5185\u3002</li>\n      <li>\u6211\u62E5\u6709\u6211\u6240\u521B\u5EFA\u7684\u6240\u6709\u5185\u5BB9\u548C\u4FE1\u606F\uFF0C\u6B64\u5916\uFF0C\u6DB5\u76D6\u77E5\u8BC6\u4EA7\u6743\u7684\u5185\u5BB9\uFF0C\u5982\u7167\u7247\u548C\u89C6\u9891\uFF08IP\u5185\u5BB9\uFF09\uFF0C\u60A8\u5728\u6B64\u58F0\u660E\u5E76\u4FDD\u8BC1\u8BE5\u5185\u5BB9\u5C06\u662F\u60A8\u7684\u539F\u521B\u4F5C\u54C1\uFF0C\u5E76\u4E14\u8BE5\u5185\u5BB9\u4E0D\u4F1A\u4FB5\u72AF\u6216\u632A\u7528\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u77E5\u8BC6\u4EA7\u6743</li>\n      <li>\u4E00\u65E6\u5DE5\u4F5C\u5B8C\u6210\uFF0C\u6211\u5C06\u5728https://app.getkobe.com/\u63D0\u4EA4\u6211\u7684\u652F\u4ED8\u548C\u6240\u6709\u53D1\u5E03\u7EDF\u8BA1\u6570\u636E\uFF0C\u4EE5\u4FBF\u8FDB\u884C\u652F\u4ED8\u5904\u7406\u3002\u652F\u4ED8\u5C06\u5728\u5E73\u53F0\u4E0A\u63D0\u4EA4\u652F\u4ED8\u540E\u768445\u5929\u5185\u6536\u5230\uFF0C\u5E76/\u6216\u5728\u5BA2\u6237\u652F\u4ED8\u6E05\u7B97\u4E4B\u540E\u6536\u5230\uFF0C\u4EE5\u8F83\u65E9\u8005\u4E3A\u51C6\u3002</li>\n      <li>\u4E00\u65E6\u6211\u6536\u5230\u7B80\u62A5\u7684\u786E\u8BA4\uFF0C\u6211\u5C06\u6309\u7167\u5BA2\u6237\u8981\u6C42\u7684\u6307\u5357\u53CA\u65F6\u63D0\u4EA4\u6240\u6709\u8349\u7A3F\u3002\u6211\u5C06\u786E\u4FDD\u5E16\u5B50\u5728\u622A\u6B62\u65E5\u671F\u4E4B\u524D\u4E0A\u7EBF\uFF0C\u5E76\u4E14\u4E86\u89E3\u5982\u679C\u672A\u80FD\u8FBE\u5230\u8FD9\u4E00\u8981\u6C42\uFF0C\u6216\u8005\u5BA2\u6237\u5BF9\u6211\u7684\u8868\u73B0\u6709\u4EFB\u4F55\u6295\u8BC9\uFF0C\u6211\u53EF\u80FD\u4F1A\u653E\u5F03\u6211\u7684\u8D39\u7528\u6216\u88AB\u5BA2\u6237\u6263\u7F5A\u3002</li>\n      <li>\u5982\u679C\u4EA7\u54C1\u88AB\u7EB3\u5165\u6D3B\u52A8\u4E2D\uFF0C\u5219\u4E0D\u5F97\u5C06\u5176\u7528\u4E8E\u9500\u552E\u6216\u8F6C\u552E\u3002</li>\n    </ol>'
  },
  confirmButtonText: 'Accept',
  cancelButtonText: 'Decline'
};
var langs = {
  en: {
    name: 'Name',
    email: 'Email',
    dateOfBirth: 'Date of Birth',
    ethnicity: 'Ethnicity',
    country: 'Country',
    occupation: 'Occupation',
    city: 'City',
    gender: 'Gender',
    ContactNo: 'Contact Number',
    instagramHandle: 'Instagram Handle (Leave blank if not applicable)',
    igFollowerCount: 'Instagram Followers (Enter numbers only)',
    igAvgViews: 'Average Instagram Views ',
    tiktokHandle: 'TikTok Handle (Leave blank if not applicable)',
    tiktokFollowerCount: 'TikTok Followers (Enter numbers only)',
    linkedinHandle: 'LinkedIn Handle (Leave blank if not applicable)',
    linkedinFollowerCount: 'Followers (Connections) - Enter numbers only',
    linkedin: 'LinkedIn Post',
    twitterHandle: 'X (Twitter) Handle (Leave blank if not applicable)',
    twitterFollowerCount: 'X (Twitter) Followers (Enter numbers only)',
    twitter: 'X (Twitter) Post',
    facebookHandle: 'Facebook Handle (Leave blank if not applicable)',
    facebookFollowerCount: 'Facebook Followers (Enter numbers only)',
    facebook: 'Facebook Post',
    youtubeHandle: 'YouTube Handle (Leave blank if not applicable)',
    youtubeFollowerCount: 'YouTube Followers (Enter numbers only)',
    youtube: 'YouTube Post',
    twitchHandle: 'Twitch Handle (Leave blank if not applicable)',
    twitchFollowerCount: 'Twitch Followers (Enter numbers only)',
    twitch: 'Twitch Post',
    tiktokAvgViews: 'Average TikTok Views',
    igIndicateCost: 'Please indicate your cost for Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'IG Remarks',
    tiktokRemarks: 'TikTok Remarks',
    tiktokIndicateCost: 'Please indicate your cost for TikTok',
    tiktok: 'TikTok',
    platforms: 'Add Other Social Media Platforms',
    eventAppearance: 'Event Attendance',
    loadingFee: 'Loading Fee',
    uploadMediaKit: 'Upload Your Media Kit here',
    loadContent: 'The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?',
    yes: 'Yes',
    no: 'No, please provide reason ',
    giftBrand: 'Would you like to be part of our PR or gifting collaborations with brands?',
    yesIAm: 'Yes, I am',
    noPaidCampaign: 'No, I only do paid campaigns ',
    preferredCampaigns: 'Preferred type of campaigns/genre (please tick relevant)',
    bestRepresent: 'A short description of your profile that best represents you',
    enterIgTikTok: 'Please enter at least one social media handle'
  },
  th: {
    name: 'ชื่อจริง นามสกุล',
    email: 'อีเมลล์',
    dateOfBirth: 'วันเ ดือน ปีเกิด',
    ethnicity: 'เชื้อชาติ',
    country: 'ประเทศ',
    occupation: 'อาชีพ',
    city: 'เมือง',
    gender: 'เพศ',
    ContactNo: 'เบอร์ติดต่อ',
    instagramHandle: 'ชื่อ ไอจี หรือ ลิ้งไอจี (กรุณาเว้นว่างหากไม่เกี่ยวข้อง)',
    igFollowerCount: 'ผู้ติดตามในไอจี (กรุณาใส่เฉพาะตัวเลขเท่านั้น)',
    igAvgViews: 'ค่าเฉลี่ยเปอร์เซ็นจำนวนคนดูใน IG',
    tiktokHandle: 'ชื่อหรือลิ้งTiktok (กรุณาเว้นว่างหากไม่เกี่ยวข้อง)',
    tiktokFollowerCount: 'จำนวนผู้ติดตามในTiktok (กรุณาใส่เฉพาะตัวเลขเท่านั้น)',
    tiktokAvgViews: 'ค่าเฉลี่ยเปอร์เซ็นจำนวนคนดูใน Tiktok',
    igIndicateCost: 'กรุณาเขียนเรทการโพสต์ในช่องทาง IG',
    igStory: 'เรทการโพสต์ ไอจี สตอรี่ ',
    igPost: 'เรทการโพสต์ ไอจี รูป',
    igCarousel: '4-5 รูปต่อ 1 โพสต์',
    igReel: 'เรทการโพสต์ ไอจี reels',
    igRemarks: 'กรุณาแจ้งเงื่อนไขเพิ่มเติม',
    tiktokRemarks: 'กรุณาแจ้งเงื่อนไขเพิ่มเติม',
    tiktokIndicateCost: 'กรุณาเขียนเรทการโพสต์ในช่องทาง Tiktok',
    tiktok: '1 Tiktok โพสต์',
    platforms: 'ช่องทางโซเชี่ลมีเดียอื่นๆ',
    eventAppearance: 'ค่าธรรมเนียมการเดินทาง',
    loadingFee: 'ค่าธรรมเนียมการโหลด',
    uploadMediaKit: 'อัพโหลดคลิปในนี้ค่ะ',
    loadContent: 'ทางลูกค้าอยากที่จะใช้วิดีโอ Content ได้ไหมคะ',
    yes: 'ได้',
    no: 'ไม่ได้ ( เหตุผล )',
    giftBrand: 'คุณอยากที่จะมีส่วนร่วมในการโฆษณา หรือ collab กับแบรนด์ ไหมคะ',
    yesIAm: 'ได้ค่ะ',
    noPaidCampaign: 'ไม่ (รับงานเฉพาะที่จ่ายเงินเท่านั้น)',
    preferredCampaigns: 'ประเภทแคมเปญ/ประเภทที่ต้องการ (โปรดทำเครื่องหมายที่เกี่ยวข้อง)',
    bestRepresent: 'คำอธิบายสั้น ๆ เกี่ยวกับโปรไฟล์ของคุณที่เป็นตัวแทนของคุณได้ดีที่สุด',
    enterIgTikTok: 'กรุณากรอก Instagram หรือ Tiktok Handle'
  },
  vn: {
    name: 'Họ Tên',
    email: 'Email',
    dateOfBirth: 'Ngày sinh',
    ethnicity: 'Dân tộc',
    country: 'Quốc tịch',
    occupation: 'Nghề nghiệp',
    city: 'Thành phố',
    gender: 'Giới tính',
    ContactNo: 'Số điện thoại liên hệ',
    instagramHandle: 'Tên Instagram (Để trống nếu không áp dụng)',
    igFollowerCount: 'Số lượng Follower trên Instagram (Chỉ nhập số)',
    igAvgViews: 'Lượt View trung bình trên Instagram',
    tiktokHandle: 'Tên Tiktok (Để trống nếu không áp dụng)',
    tiktokFollowerCount: 'Số lượng Follower trên Tiktok (Chỉ nhập số)',
    tiktokAvgViews: 'Lượt View trung bình trên Tiktok',
    igIndicateCost: 'Mức giá mong muốn cho các nội dung trên Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'Lưu ý/Ghi chú',
    tiktokRemarks: 'Lưu ý/Ghi chú',
    tiktokIndicateCost: 'Mức giá mong muốn cho các nội dung trên Tiktok',
    tiktok: 'Tiktok',
    platforms: 'Các nền tảng mạng xã hội khác',
    eventAppearance: 'Phí tham dự Event',
    loadingFee: 'Phí đăng tải nội dung (chi phí để boost content)',
    uploadMediaKit: 'Tải lên Chi tiết báo giá của bạn tại đây',
    loadContent: 'Khách hàng có thể muốn đăng tải nội dung của bạn lên các mạng xã hội trong thời gian không quá 30 ngày, bạn có đồng ý với sự sắp xếp này không?',
    yes: 'Đồng ý',
    no: 'Không đồng ý (Lý do)',
    giftBrand: 'Bạn có muốn tham gia chương trình PR hoặc hợp tác tặng quà của chúng tôi với các thương hiệu không?h',
    yesIAm: 'Đồng ý',
    noPaidCampaign: 'Không, mình chỉ tham gia các chiến dịch trả phí',
    preferredCampaigns: ' Loại chiến dịch/thể loại ưa thích (vui lòng đánh dấu vào ô phù hợp)',
    bestRepresent: 'Một mô tả ngắn gọn về hồ sơ của bạn giúp hình dung bạn tốt nhất',
    enterIgTikTok: 'Vui lòng nhập Nick Instagram hoặc Tiktok'
  },
  id: {
    name: 'Nama',
    email: 'Email',
    dateOfBirth: 'Tanggal Lahir',
    ethnicity: 'Etnis',
    country: 'Negara',
    occupation: 'Pekerjaan',
    city: 'Kota',
    gender: 'Gender',
    ContactNo: 'Nomor Kontak',
    instagramHandle: 'Instagram (Biarkan kosong jika tidak berlaku)',
    igFollowerCount: 'Jumlah Pengikut Instagram (Masukkan hanya angka)',
    igAvgViews: 'Rerata Views Instagram',
    tiktokHandle: 'TikTok (Biarkan kosong jika tidak berlaku)',
    tiktokFollowerCount: 'Jumlah Pengikut TikTok (Masukkan hanya angka)',
    tiktokAvgViews: 'Rerata Views TikTok',
    igIndicateCost: 'Biaya untuk Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'Keterangan',
    tiktokRemarks: 'Keterangan',
    tiktokIndicateCost: 'Biaya untuk Tiktok',
    tiktok: 'TikTok',
    platforms: 'Tambahkan Platform Media Sosial Lainnya',
    eventAppearance: 'Biaya Peserta Acara',
    loadingFee: 'Biaya Pemuatan',
    uploadMediaKit: 'Unggah Peralatan Media Anda Disini',
    loadContent: 'Klien mungkin ingin memuat konten Anda di media sosial untuk jangka waktu tidak lebih dari 30 hari, apakah Anda menyetujuinya?',
    yes: 'Ya',
    no: 'Tidak, tolong jelaskan alasan',
    giftBrand: 'Apakah Anda ingin menjadi bagian dari PR kami atau memberikan kolaborasi dengan brand?',
    yesIAm: 'Ya',
    noPaidCampaign: 'Tidak, saya hanya melakukan campaign berbayar',
    preferredCampaigns: 'Jenis campaign/genre pilihan (harap centang yang relevan)',
    bestRepresent: 'Deskripsi singkat tentang profil Anda yang paling mewakili Anda',
    enterIgTikTok: 'Silakan masukkan Instagram atau Tiktok*'
  },
  cn: {
    name: '姓名',
    email: '电子邮件',
    dateOfBirth: '出生日期',
    ethnicity: '种族',
    country: '国家',
    occupation: '职业',
    city: '城市',
    gender: '性别',
    ContactNo: '联系电话',
    instagramHandle: 'Instagram用户名 (若不适用，请留空)',
    igFollowerCount: '您的Instagram粉丝数量 (只输入数字)',
    igAvgViews: '平均Instagram观看次数',
    tiktokHandle: 'TikTok用户名 (若不适用，请留空)',
    tiktokFollowerCount: '您的TikTok粉丝数量 (只输入数字)',
    tiktokAvgViews: '平均TikTok观看次数',
    igIndicateCost: '请注明您的Instagram价格',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'IG Remarks',
    tiktokRemarks: 'TikTok Remarks',
    tiktokIndicateCost: '请注明您的Tiktok价格',
    tiktok: 'TikTok',
    platforms: '添加其他社交媒体平台',
    eventAppearance: '活动参与费',
    loadingFee: '加载费用',
    uploadMediaKit: '在此上传您的媒体宣传册',
    loadContent: '客户可能希望将您的内容加载到社交媒体上，但不超过30天，请问您是否同意此安排？',
    yes: '好',
    no: '否，请提供原因',
    giftBrand: '你想参与我们与品牌的公关或赠品合作吗？',
    yesIAm: '是的，我愿意',
    noPaidCampaign: '不，我只做付费活动',
    preferredCampaigns: '首选的活动/类型（请勾选相关项',
    bestRepresent: '请简要描述您的资料，以最能代表您的方式。',
    enterIgTikTok: '请填写Instagram或Tiktok用户名'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  formConfig: formConfig,
  tableHeaders: tableHeaders,
  followerOptions: followerOptions,
  rateCardTermsAndCondition: rateCardTermsAndCondition,
  langs: langs,
  rateCardLabels: rateCardLabels,
  currencyOptions: currencyOptions
}));

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = ({
  createCampaignPayout: function createCampaignPayout(campaignPayout) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/api/v1/payments-open/campaignPayout/', true, campaignPayout).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1373)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(2071),
  /* scopeId */
  "data-v-3346f83a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(306);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var tableHeaders = [{
  text: 'Actions',
  value: 'action',
  align: 'start'
}, {
  text: 'Quote Acceptance Date',
  value: 'formattedAcceptanceDate',
  align: 'start'
}, {
  text: 'Sales',
  value: 'salePersonName',
  align: 'start'
}, {
  text: 'Billing Name',
  value: 'billingContactName',
  align: 'start'
}, {
  text: 'Quote No.',
  value: 'quoteNo',
  align: 'start'
}, {
  text: 'Quote Amt (excl. GST)',
  value: 'quoteAmt',
  align: 'start'
}, {
  text: 'Invoice Sent',
  value: 'invoiceSent',
  align: 'start'
}, {
  text: 'Invoice Created on Xero',
  value: 'invoiceCreated',
  align: 'start'
}, {
  text: 'Yet to Invoice',
  value: 'invoicePending',
  align: 'start'
}, {
  text: 'Vertical',
  value: 'verticals',
  align: 'start'
}, {
  text: 'Type of Clients',
  value: 'clientType',
  align: 'start'
}, {
  text: 'Line of Services',
  value: 'lineOfServices',
  align: 'start'
}, {
  text: 'Campaign Name',
  value: 'campaigns',
  align: 'start'
}, {
  text: 'Indicate Cost (For Markup)',
  value: 'indicateCost',
  align: 'start'
}, {
  text: 'AM',
  value: 'AM',
  align: 'start'
}, {
  text: 'CC',
  value: 'CC',
  align: 'start'
}, {
  text: 'Start',
  value: 'startMonth',
  align: 'start'
}, {
  text: 'End',
  value: 'endMonth',
  align: 'start'
}, {
  text: 'Mth',
  value: 'totalMonth',
  align: 'start'
}, {
  text: 'Prior ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY'),
  value: 'priorYear',
  align: 'start'
}, {
  text: 'Jan-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Jan',
  align: 'start'
}, {
  text: 'Feb-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Feb',
  align: 'start'
}, {
  text: 'Mar-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Mar',
  align: 'start'
}, {
  text: 'Apr-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Apr',
  align: 'start'
}, {
  text: 'May-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'May',
  align: 'start'
}, {
  text: 'Jun-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Jun',
  align: 'start'
}, {
  text: 'Jul-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Jul',
  align: 'start'
}, {
  text: 'Aug-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Aug',
  align: 'start'
}, {
  text: 'Sep-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Sep',
  align: 'start'
}, {
  text: 'Oct-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Oct',
  align: 'start'
}, {
  text: 'Nov-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Nov',
  align: 'start'
}, {
  text: 'Dec-' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YY'),
  value: 'Dec',
  align: 'start'
}, {
  text: 'For Year ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'years').format('YYYY'),
  value: 'nextYear',
  align: 'start'
}, {
  text: 'Revenue yet to recognise',
  value: 'revenueYetRecognise',
  align: 'start'
}, {
  text: 'Unallocated Revenues',
  value: 'unrecognisedRevenues',
  align: 'start'
}, {
  text: 'Accrued Revenue',
  value: 'accruedRevenue',
  align: 'start'
}, {
  text: 'Deferred Revenue',
  value: 'deferredRevenue',
  align: 'start'
}];
var financeCols = ['ccDate', 'sales', 'billingName', 'quoteNo', 'quoteAmt'];
var quoteStatuses = {
  PENDING: 0,
  ACCEPT: 1,
  REJECT: 2
};
var defaultTotalValues = {
  quoteAmt: 0,
  invoiceSent: 0,
  invoiceCreated: 0,
  invoicePending: 0,
  priorYear: 0,
  Jan: 0,
  Feb: 0,
  Mar: 0,
  Apr: 0,
  May: 0,
  Jun: 0,
  Jul: 0,
  Aug: 0,
  Sep: 0,
  Oct: 0,
  Nov: 0,
  Dec: 0,
  nextYear: 0,
  revenueYetRecognise: 0,
  unrecognisedRevenues: 0,
  accruedRevenue: 0,
  deferredRevenue: 0
};
var dynamicMonthLists = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/* harmony default export */ __webpack_exports__["a"] = ({
  tableHeaders: tableHeaders,
  financeCols: financeCols,
  quoteStatuses: quoteStatuses,
  defaultTotalValues: defaultTotalValues,
  dynamicMonthLists: dynamicMonthLists
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var timelineTypes = {
  ACTIVATING: 1,
  LINEUP: 2,
  COCREATING: 3,
  COMPLETE: 4,
  EMPTY: 0
};

var timelineTypeLists = [{
  title: 'Activating',
  value: timelineTypes.ACTIVATING
}, {
  title: 'Pairing',
  value: timelineTypes.LINEUP
}, {
  title: 'Co-Creating',
  value: timelineTypes.COCREATING
}, {
  title: 'Complete',
  value: timelineTypes.COMPLETE
}];

var tableHeaders = [{
  text: 'Date (DD/MM/YYYY)',
  value: 'timelineDate'
}, {
  text: 'Action',
  value: 'action'
}, {
  text: 'Action by',
  value: 'actionBy'
}, {
  text: '',
  value: 'controlAction'
}];

var summaryTableHeaders = [{
  text: 'Campaign Name',
  value: 'name',
  align: 'center'
}, {
  text: 'AM',
  value: 'AM',
  align: 'center'
}, {
  text: 'CC',
  value: 'CC',
  align: 'center'
}, {
  text: 'Activating',
  value: 'activating',
  align: 'center'
}, {
  text: 'Pairing',
  value: 'pairing',
  align: 'center'
}, {
  text: 'Cocreating',
  value: 'cocreating',
  align: 'center'
}, {
  text: 'Complete',
  value: 'complete',
  align: 'center'
}, {
  text: 'Total Duration',
  value: 'totalDuration',
  align: 'center'
}, {
  text: 'Actions',
  value: 'actions',
  align: 'center'
}];

var defaultTableItems = [{
  timelineDate: '',
  startDate: '',
  endDate: '',
  actionType: timelineTypeLists[0],
  actionTitle: 'Activating',
  actionDesc: '-',
  actionBy: 'Kobe'
}, {
  timelineDate: '',
  startDate: '',
  endDate: '',
  actionType: timelineTypeLists[1],
  actionTitle: 'Pairing',
  actionDesc: '-',
  actionBy: 'Kobe, Client, Creator'
}, {
  timelineDate: '',
  startDate: '',
  endDate: '',
  actionType: timelineTypeLists[2],
  actionTitle: 'Co-Creating',
  actionDesc: '-',
  actionBy: 'Kobe, Client, Creator'
}, {
  timelineDate: '',
  startDate: '',
  endDate: '',
  actionType: timelineTypeLists[3],
  actionTitle: 'Complete',
  actionDesc: '-',
  actionBy: 'Kobe'
}];

var defaultSummaries = {
  activating: {
    title: 'Activating',
    projected: 'invalid',
    actual: 'invalid',
    actualTasks: [{
      title: 'Brief created',
      type: 'a',
      value: 'invalid'
    }, {
      title: 'Brief accepted',
      type: 'b',
      value: 'invalid'
    }]
  },
  pairing: {
    title: 'Pairing',
    projected: 'invalid',
    actual: 'invalid',
    actualTasks: [{
      title: 'Brief Accepted',
      type: 'a',
      value: 'invalid'
    }, {
      title: 'First payout confirmed',
      type: 'b',
      value: 'invalid'
    }, {
      title: 'All payouts confirmed',
      type: 'c',
      value: 'invalid'
    }]
  },
  cocreating: {
    title: 'Co-creating',
    projected: 'invalid',
    actual: 'invalid',
    actualTasks: [{
      title: 'All payouts confirmed',
      type: 'a',
      value: 'invalid'
    }, {
      title: 'First Submitted on IMS',
      type: 'b',
      value: 'invalid'
    }, {
      title: 'Earliest liveDate in Report',
      type: 'c',
      value: 'invalid'
    }, {
      title: 'Latest liveDate in Report',
      type: 'd',
      value: 'invalid'
    }]
  },
  complete: {
    title: 'Complete',
    projected: '',
    actual: 'invalid',
    actualTasks: [{
      title: 'Latest liveDate',
      type: 'a',
      value: 'invalid'
    }, {
      title: 'Review Meeting',
      type: 'b',
      value: 'invalid'
    }]
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  tableHeaders: tableHeaders,
  summaryTableHeaders: summaryTableHeaders,
  defaultTableItems: defaultTableItems,
  timelineTypes: timelineTypes,
  timelineTypeLists: timelineTypeLists,
  defaultSummaries: defaultSummaries
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCampaignsNoStatus: function getAllCampaignsNoStatus() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/campaigns/all?limit=999', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfluencerAvgRating: function getInfluencerAvgRating(filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/payments/influencerAvgRating?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getClientAvgRatings: function getClientAvgRatings(filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/campaigns/clientAvgRatings?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getTotalReportAbuse: function getTotalReportAbuse(filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/posts/reportAbuseTotal?' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



var formConfig = {
  title: 'Join Our Creator Community',
  sections: [{
    title: 'Instagram Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'Instagram Handle',
      name: 'instagramHandle',
      placeholder: 'handle',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'IG Story',
      name: 'igStory',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats',
      required: true
    }, {
      label: 'IG Post',
      name: 'igPost',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats',
      required: true
    }, {
      label: 'IG Carousel',
      name: 'igCarousel',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats',
      required: true
    }, {
      label: 'IG Reel',
      name: 'igReel',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats',
      required: true
    }, {
      label: 'Event Attendance Fee',
      name: 'eventAppearance',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-5',
      labelClass: 'label-stats',
      required: true
    }, {
      label: 'Loading Fee',
      name: 'loadingFee',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
      labelClass: 'label-stats',
      required: true
    }]
  }, {
    title: 'TikTok Section',
    class: 'col-xs-12 col-md-6',
    fields: [{
      label: 'TikTok Handle',
      name: 'tiktokHandle',
      placeholder: 'handle',
      type: 'textbox',
      class: 'col-xs-12 col-md-12'
    }, {
      label: 'Tiktok',
      name: 'tiktok',
      type: 'number',
      prefix: 'SGD $',
      class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
      labelClass: 'label-stats',
      required: true
    }, {
      label: 'Add more platforms',
      type: 'multiple',
      name: 'platforms',
      class: 'col-xs-12 col-md-12',
      labelClass: 'more-platform-label',
      options: [{
        label: 'Platform',
        type: 'select',
        name: 'platform',
        divClass: 'platform-select',
        class: 'col-xs-12 col-md-4 platform-select pt-0',
        style: 'font-size: 12px;min-width: 100px;max-width: 120px;',
        options: [{
          label: 'Facebook',
          value: 'facebook'
        }, {
          label: 'Twitch',
          value: 'twitch'
        }, {
          label: 'Youtube',
          value: 'youtube'
        }, {
          label: 'Others',
          value: 'others'
        }]
      }, {
        label: 'URL',
        placeholder: 'URL',
        type: 'textarea',
        name: 'url',
        class: 'col-xs-12 col-md-4 pt-0'
      }, {
        label: 'Rate',
        placeholder: 'Rate',
        type: 'number',
        name: 'rate',
        prefix: 'SGD $',
        class: 'px-1 multiple-rate',
        style: 'width:100%;position:absolute;margin-top:95px'
      }, {
        type: 'delete',
        style: 'max-width:30px'
      }],
      child: {
        label: 'Others',
        placeholder: 'If others, please specify',
        type: 'textbox',
        name: 'otherPlatform',
        parentName: 'platform',
        class: 'col-xs-12 col-md-4'
      }
    }]
  }, {
    title: 'Global Section',
    class: 'col-xs-12 col-md-12',
    fields: [{
      label: 'Media Kit',
      name: 'uploadMediaKit',
      type: 'file',
      class: 'col-xs-12 col-md-12',
      style: 'max-width:800px'
    }]
  }]
};

var tableHeaders = [{
  text: 'Name',
  value: 'name',
  sortable: false
}, {
  text: 'Email',
  value: 'email',
  sortable: false
}, {
  text: 'Date of Birth',
  value: 'dateOfBirth',
  sortable: false
}, {
  text: 'Ethnicity',
  value: 'ethnicity',
  sortable: false
}, {
  text: 'Country',
  value: 'country',
  sortable: false
}, {
  text: 'Gender',
  value: 'gender',
  sortable: false
}, {
  text: 'Contact Number',
  value: 'contactNo',
  sortable: false
}, {
  text: 'Instagram Handle',
  value: 'instagramHandle',
  sortable: false
}, {
  text: 'Instagram Followers',
  value: 'igFollowerCount',
  sortable: false
}, {
  text: 'TikTok Handle',
  value: 'tiktokHandle',
  sortable: false
}, {
  text: 'TikTok Followers',
  value: 'tiktokFollowerCount',
  sortable: false
}, {
  text: 'CC',
  value: 'cc',
  sortable: false
}, {
  text: 'Youtube',
  value: 'youtube',
  sortable: false
}, {
  text: 'Facebook',
  value: 'facebook',
  sortable: false
}, {
  text: 'Twitch',
  value: 'twitch',
  sortable: false
}, {
  text: 'IG Story',
  value: 'igStory',
  sortable: false
}, {
  text: 'IG Post',
  value: 'igPost',
  sortable: false
}, {
  text: 'IG Carousel',
  value: 'igCarousel',
  sortable: false
}, {
  text: 'IG Reel',
  value: 'igReel',
  sortable: false
}, {
  text: 'TikTok',
  value: 'tiktok',
  sortable: false
}, {
  text: 'Event Attendance',
  value: 'eventAppearance',
  sortable: false
}, {
  text: 'Loading Fee',
  value: 'loadingFee',
  sortable: false
}, {
  text: 'Media Kit',
  value: 'uploadMediaKit',
  sortable: false
}, {
  text: 'Preferred campaigns/genre',
  value: 'preferredCampaigns',
  sortable: false
}, {
  text: 'Profile short description',
  value: 'aboutYou',
  sortable: false
}, {
  text: 'Gifting Collaborations',
  value: 'giftBrand',
  sortable: false
}, {
  text: 'Status',
  value: 'status',
  sortable: false
}, {
  text: 'Updated On',
  value: 'updatedAt',
  sortable: false
}, {
  text: 'Actions',
  value: 'action',
  sortable: false
}];

var getRanges = function getRanges(from, to) {
  var range = {};
  if (from) {
    range.from = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(from));
  }
  if (to) {
    range.to = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(to));
  }
  return range;
};
var followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
var followerOptions = getRanges(followersCount, followersCount);

var rateCardLabels = ['Comedy/Roleplaying/Skit', 'Music/Dance/Sing', 'Lifestyle', 'Travel/Places to visit', 'Food', 'Beauty & Personal Care', 'Fashion', 'Couple', 'Health & Fitness/Sports', 'Tech', 'Gaming', 'Finance', 'Family & Parenting', 'Entrepreneur/Business Owner', 'Education / Lifehacks', 'Home & Living', 'Luxury'];

var currencyOptions = ['SGD', 'USD', 'IDR', 'PHP', 'THB', 'MYR', 'VND', 'JPY'];

var targetCountries = ['Singapore', 'Malaysia', 'Philippines', 'Indonesia', 'Thailand', 'Vietnam', 'Japan', 'China'];

var rateCardTermsAndCondition = {
  title: {
    en: 'Terms and Conditions',
    th: 'ข้อกำหนดและเงื่อนไข',
    vn: 'Các điều khoản và điều kiện',
    id: 'Syarat dan Ketentuan',
    cn: '条款与条件'
  },
  html: {
    en: '\n    <ol>\n      <li>I have read and accepted the terms of use (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>I warrant that I am not currently embroiled in any controversies or legal disputes that may negatively impact my reputation or the reputation of Kobe or its Clients. I further agree to conduct myself in a manner consistent with the values of professionalism, integrity, and decency. Kobe reserves the right to terminate any Campaign Agreement with Content Creators found to be in violation of this clause, and such termination may result in forfeiture of any compensation or benefits under the agreement.</li>\n      <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specifed in the Campaign Agreement.</li>\n      <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>\n      <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>\n      <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and understand if this is not met, or the client has any complaints about my performance, I may forfeit my rate or be deducted a penalty by the client.</li>\n      <li>If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.</li>\n    </ol>',
    th: '\n    <ol>\n      <li>\u0E09\u0E31\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E48\u0E32\u0E19\u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27 (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>\u0E09\u0E31\u0E19\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E09\u0E31\u0E19\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E1E\u0E31\u0E27\u0E1E\u0E31\u0E19\u0E01\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E02\u0E31\u0E14\u0E41\u0E22\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E1E\u0E34\u0E1E\u0E32\u0E17\u0E17\u0E32\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E40\u0E2A\u0E35\u0E22\u0E15\u0E48\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07 Kobe \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E09\u0E31\u0E19\u0E22\u0E31\u0E07\u0E15\u0E01\u0E25\u0E07\u0E17\u0E35\u0E48\u0E08\u0E30\u0E1B\u0E23\u0E30\u0E1E\u0E24\u0E15\u0E34\u0E15\u0E19\u0E43\u0E19\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E14\u0E04\u0E25\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E04\u0E48\u0E32\u0E19\u0E34\u0E22\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E21\u0E37\u0E2D\u0E2D\u0E32\u0E0A\u0E35\u0E1E \u0E04\u0E27\u0E32\u0E21\u0E0B\u0E37\u0E48\u0E2D\u0E2A\u0E31\u0E15\u0E22\u0E4C \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 Kobe \u0E02\u0E2D\u0E2A\u0E07\u0E27\u0E19\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E43\u0E14 \u0E46 \u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E1E\u0E1A\u0E27\u0E48\u0E32\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E22\u0E38\u0E15\u0E34\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E2D\u0E32\u0E08\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E43\u0E2B\u0E49\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E34\u0E1A\u0E04\u0E48\u0E32\u0E15\u0E2D\u0E1A\u0E41\u0E17\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E43\u0E14 \u0E46 \u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07</li>\n      <li>\u0E09\u0E31\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E14 \u0E46 \u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07 Kobe \u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E41\u0E25\u0E30\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E41\u0E1A\u0E1A\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30\u0E1C\u0E48\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E27\u0E25\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E01 (6) \u0E40\u0E14\u0E37\u0E2D\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E19\u0E32\u0E19\u0E01\u0E27\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E44\u0E27\u0E49\u0E43\u0E19 \u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E01\u0E32\u0E23\u0E23\u0E13\u0E23\u0E07\u0E04\u0E4C</li>\n      <li>\u0E09\u0E31\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E09\u0E31\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49 \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E42\u0E14\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32 \u0E40\u0E0A\u0E48\u0E19 \u0E20\u0E32\u0E1E\u0E16\u0E48\u0E32\u0E22\u0E41\u0E25\u0E30\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D (\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 IP) \u0E04\u0E38\u0E13\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E02\u0E2D\u0E07 \u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E22\u0E31\u0E01\u0E22\u0E2D\u0E01\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E43\u0E14\u0E46</li>\n      <li>\u0E09\u0E31\u0E19\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E01\u0E32\u0E23\u0E08\u0E48\u0E32\u0E22\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19\u0E41\u0E25\u0E30\u0E2A\u0E16\u0E34\u0E15\u0E34\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E1A\u0E19 https://app.getkobe.com/ \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E07\u0E32\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19 \u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E20\u0E32\u0E22\u0E43\u0E19 45 \u0E27\u0E31\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E2A\u0E48\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E1A\u0E19\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E32\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E01\u0E23\u0E13\u0E35\u0E43\u0E14\u0E08\u0E30\u0E16\u0E36\u0E07\u0E01\u0E48\u0E2D\u0E19</li>\n      <li>\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E09\u0E31\u0E19\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E1A\u0E23\u0E35\u0E1F\u0E41\u0E25\u0E49\u0E27 \u0E09\u0E31\u0E19\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E20\u0E32\u0E22\u0E43\u0E19\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E41\u0E25\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E41\u0E19\u0E27\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E08\u0E32\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E09\u0E31\u0E19\u0E08\u0E30\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E19\u0E31\u0E49\u0E19\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E15\u0E32\u0E21\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14 \u0E41\u0E25\u0E30\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E27\u0E48\u0E32\u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E19\u0E31\u0E49\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E23\u0E49\u0E2D\u0E07\u0E40\u0E23\u0E35\u0E22\u0E19\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E1C\u0E25\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E09\u0E31\u0E19 \u0E09\u0E31\u0E19\u0E2D\u0E32\u0E08\u0E40\u0E2A\u0E35\u0E22\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E16\u0E39\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E2B\u0E31\u0E01\u0E04\u0E48\u0E32\u0E1B\u0E23\u0E31\u0E1A</li>\n      <li>\u0E2B\u0E32\u0E01\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E16\u0E39\u0E01\u0E23\u0E27\u0E21\u0E44\u0E27\u0E49\u0E43\u0E19\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D \u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E23\u0E27\u0E21\u0E44\u0E27\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E32\u0E22\u0E15\u0E48\u0E2D</li>\n    </ol>',
    vn: '\n    <ol>\n      <li>T\xF4i \u0111\xE3 \u0111\u1ECDc v\xE0 ch\u1EA5p nh\u1EADn c\xE1c \u0111i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>T\xF4i \u0111\u1EA3m b\u1EA3o r\u1EB1ng hi\u1EC7n t\u1EA1i t\xF4i kh\xF4ng b\u1ECB l\xF4i k\xE9o v\xE0o b\u1EA5t k\u1EF3 tranh c\xE3i ho\u1EB7c tranh ch\u1EA5p ph\xE1p l\xFD n\xE0o c\xF3 th\u1EC3 \u1EA3nh h\u01B0\u1EDFng ti\xEAu c\u1EF1c \u0111\u1EBFn danh ti\u1EBFng c\u1EE7a t\xF4i ho\u1EB7c danh ti\u1EBFng c\u1EE7a Kobe ho\u1EB7c Kh\xE1ch h\xE0ng c\u1EE7a Kobe. T\xF4i c\u0169ng \u0111\u1ED3ng \xFD h\xE0nh x\u1EED theo c\xE1ch ph\xF9 h\u1EE3p v\u1EDBi c\xE1c gi\xE1 tr\u1ECB v\u1EC1 t\xEDnh chuy\xEAn nghi\u1EC7p, t\xEDnh ch\xEDnh tr\u1EF1c v\xE0 l\u1EC5 \u0111\u1ED9. Kobe c\xF3 quy\u1EC1n ch\u1EA5m d\u1EE9t b\u1EA5t k\u1EF3 Th\u1ECFa thu\u1EADn Chi\u1EBFn d\u1ECBch n\xE0o v\u1EDBi Ng\u01B0\u1EDDi t\u1EA1o n\u1ED9i dung b\u1ECB ph\xE1t hi\u1EC7n vi ph\u1EA1m \u0111i\u1EC1u kho\u1EA3n n\xE0y v\xE0 vi\u1EC7c ch\u1EA5m d\u1EE9t \u0111\xF3 c\xF3 th\u1EC3 d\u1EABn \u0111\u1EBFn vi\u1EC7c m\u1EA5t m\u1ECDi kho\u1EA3n b\u1ED3i th\u01B0\u1EDDng ho\u1EB7c l\u1EE3i \xEDch theo th\u1ECFa thu\u1EADn.</li>\n      <li>T\xF4i \u0111\u1ED3ng \xFD r\u1EB1ng m\u1ECDi n\u1ED9i dung \u0111\u01B0\u1EE3c g\u1EEDi t\u1EDBi Kobe theo Th\u1ECFa thu\u1EADn Chi\u1EBFn d\u1ECBch v\xE0 \u0111\u01B0\u1EE3c Kh\xE1ch h\xE0ng ch\u1EA5p nh\u1EADn s\u1EBD v\u1EABn c\xF3 th\u1EC3 truy c\u1EADp c\xF4ng khai th\xF4ng qua (c\xE1c) t\xE0i kho\u1EA3n m\u1EA1ng x\xE3 h\u1ED9i c\u1EE7a b\u1EA1n trong t\u1ED1i thi\u1EC3u s\xE1u (6) th\xE1ng ho\u1EB7c th\u1EDDi h\u1EA1n l\xE2u h\u01A1n nh\u01B0 \u0111\u01B0\u1EE3c quy \u0111\u1ECBnh trong Th\u1ECFa thu\u1EADn Chi\u1EBFn d\u1ECBch.</li>\n      <li>T\xF4i s\u1EDF h\u1EEFu t\u1EA5t c\u1EA3 n\u1ED9i dung v\xE0 th\xF4ng tin t\xF4i t\u1EA1o, ngo\xE0i ra, n\u1ED9i dung \u0111\u01B0\u1EE3c b\u1EA3o v\u1EC7 b\u1EDFi quy\u1EC1n s\u1EDF h\u1EEFu tr\xED tu\u1EC7, nh\u01B0 \u1EA3nh v\xE0 video (n\u1ED9i dung IP), B\u1EA1n tuy\xEAn b\u1ED1 v\xE0 \u0111\u1EA3m b\u1EA3o r\u1EB1ng n\u1ED9i dung \u0111\xF3 s\u1EBD l\xE0 t\xE1c ph\u1EA9m g\u1ED1c c\u1EE7a b\u1EA1n v\xE0 n\u1ED9i dung \u0111\xF3 s\u1EBD kh\xF4ng vi ph\u1EA1m ho\u1EB7c chi\u1EBFm d\u1EE5ng quy\u1EC1n s\u1EDF h\u1EEFu tr\xED tu\u1EC7 c\u1EE7a b\u1EA5t k\u1EF3 b\xEAn th\u1EE9 ba n\xE0o.</li>\n      <li>T\xF4i s\u1EBD g\u1EEDi kho\u1EA3n thanh to\xE1n c\u1EE7a m\xECnh v\xE0 t\u1EA5t c\u1EA3 s\u1ED1 li\u1EC7u th\u1ED1ng k\xEA v\u1EC1 b\xE0i \u0111\u0103ng tr\xEAn https://app.getkobe.com/ sau khi c\xF4ng vi\u1EC7c ho\xE0n th\xE0nh \u0111\u1EC3 thanh to\xE1n \u0111\u01B0\u1EE3c x\u1EED l\xFD. Kho\u1EA3n thanh to\xE1n s\u1EBD \u0111\u01B0\u1EE3c nh\u1EADn trong v\xF2ng 45 ng\xE0y sau khi g\u1EEDi kho\u1EA3n thanh to\xE1n tr\xEAn n\u1EC1n t\u1EA3ng v\xE0/ho\u1EB7c x\xE1c nh\u1EADn thanh to\xE1n t\u1EEB kh\xE1ch h\xE0ng, t\xF9y theo th\u1EDDi \u0111i\u1EC3m n\xE0o \u0111\u1EBFn tr\u01B0\u1EDBc.</li>\n      <li>Sau khi nh\u1EADn \u0111\u01B0\u1EE3c x\xE1c nh\u1EADn v\u1EC1 b\u1EA3n t\xF3m t\u1EAFt, t\xF4i s\u1EBD g\u1EEDi t\u1EA5t c\u1EA3 c\xE1c b\u1EA3n nh\xE1p m\u1ED9t c\xE1ch k\u1ECBp th\u1EDDi v\xE0 theo h\u01B0\u1EDBng d\u1EABn \u0111\u01B0\u1EE3c y\xEAu c\u1EA7u t\u1EEB kh\xE1ch h\xE0ng. T\xF4i s\u1EBD \u0111\u1EA3m b\u1EA3o b\xE0i \u0111\u0103ng \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB \u0111\xFAng h\u1EA1n v\xE0 hi\u1EC3u r\u1EB1ng n\u1EBFu \u0111i\u1EC1u n\xE0y kh\xF4ng \u0111\u01B0\u1EE3c \u0111\xE1p \u1EE9ng ho\u1EB7c kh\xE1ch h\xE0ng c\xF3 b\u1EA5t k\u1EF3 khi\u1EBFu n\u1EA1i n\xE0o v\u1EC1 hi\u1EC7u su\u1EA5t c\u1EE7a t\xF4i, t\xF4i c\xF3 th\u1EC3 b\u1ECB m\u1EA5t m\u1EE9c gi\xE1 c\u1EE7a m\xECnh ho\u1EB7c b\u1ECB kh\xE1ch h\xE0ng kh\u1EA5u tr\u1EEB m\u1ED9t h\xECnh ph\u1EA1t.</li>\n      <li>N\u1EBFu s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c \u0111\u01B0a v\xE0o chi\u1EBFn d\u1ECBch th\xEC kh\xF4ng n\xEAn \u0111\u01B0a ch\xFAng v\xE0o m\u1EE5c \u0111\xEDch b\xE1n ho\u1EB7c b\xE1n l\u1EA1i.</li>\n    </ol>',
    id: '\n    <ol>\n      <li>Saya telah membaca dan menerima ketentuan penggunaan (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>\n      <li>Saya menjamin bahwa saat ini saya tidak terlibat dalam kontroversi atau perselisihan hukum apa pun yang dapat berdampak negatif terhadap reputasi saya atau reputasi Kobe atau Kliennya. Saya selanjutnya setuju untuk berperilaku sesuai dengan nilai-nilai profesionalisme, integritas, dan kesopanan. Kobe berhak mengakhiri Perjanjian Campaign apa pun dengan Pembuat Konten yang ditemukan melanggar klausul ini, dan penghentian tersebut dapat mengakibatkan hilangnya kompensasi atau manfaat apa pun berdasarkan perjanjian.</li>\n      <li>Saya setuju bahwa konten apa pun yang dikirimkan ke Kobe berdasarkan Perjanjian Campaign dan diterima oleh Klien akan tetap dapat diakses publik melalui akun media sosial Anda selama minimal enam (6) bulan, atau jangka waktu lebih lama sebagaimana ditentukan dalam Perjanjian Kampanye.</li>\n      <li>Saya memiliki seluruh konten dan informasi yang saya buat, selain itu, konten yang dilindungi oleh hak kekayaan intelektual, seperti foto dan video (konten IP), Anda dengan ini menyatakan dan menjamin bahwa konten tersebut merupakan karya asli Anda dan bahwa konten tersebut tidak akan melanggar atau menyalahgunakan hak kekayaan intelektual pihak ketiga mana pun.</li>\n      <li>Saya akan mengirimkan pembayaran saya dan semua statistik postingan di https://app.getkobe.com/ setelah pekerjaan selesai agar pembayaran dapat diproses. Pembayaran akan diterima dalam waktu 45 hari setelah penyerahan pembayaran pada platform dan/atau izin pembayaran dari klien, mana yang lebih dulu.</li>\n      <li>Setelah saya menerima konfirmasi brief, saya akan menyerahkan semua draft tepat waktu dan sesuai dengan pedoman yang diminta dari klien. Saya akan memastikan postingan tersebut ditayangkan pada tanggal tenggat waktu dan memahami jika hal ini tidak dipenuhi, atau klien memiliki keluhan tentang kinerja saya, saya dapat kehilangan tarif saya atau dikenakan penalti oleh klien.</li>\n      <li>Jika produk disertakan dalam campaign, produk tersebut tidak boleh disertakan untuk tujuan dijual atau dijual kembali.</li>\n    </ol>',
    cn: '\n    <ol>\n      <li>\u6211\u5DF2\u9605\u8BFB\u5E76\u63A5\u53D7\u4E86\u4F7F\u7528\u6761\u6B3E\uFF08https://www.getkobe.com/infuencer-terms-use-agreement/\uFF09</li>\n      <li>\u6211\u4FDD\u8BC1\u6211\u76EE\u524D\u6CA1\u6709\u53C2\u4E0E\u53EF\u80FD\u4F1A\u5BF9\u6211\u7684\u58F0\u8A89\u6216Kobe\u53CA\u5176\u5BA2\u6237\u7684\u58F0\u8A89\u9020\u6210\u8D1F\u9762\u5F71\u54CD\u7684\u4EFB\u4F55\u4E89\u8BAE\u6216\u6CD5\u5F8B\u7EA0\u7EB7\u3002\u6211\u8FDB\u4E00\u6B65\u540C\u610F\u4EE5\u4E13\u4E1A\u3001\u8BDA\u4FE1\u548C\u5F97\u4F53\u7684\u65B9\u5F0F\u884C\u4E8B\u3002Kobe\u4FDD\u7559\u7EC8\u6B62\u4EFB\u4F55\u53D1\u73B0\u8FDD\u53CD\u672C\u6761\u6B3E\u7684\u5185\u5BB9\u521B\u4F5C\u8005\u7684\u6D3B\u52A8\u534F\u8BAE\u7684\u6743\u5229\uFF0C\u6B64\u7C7B\u7EC8\u6B62\u53EF\u80FD\u5BFC\u81F4\u534F\u8BAE\u4E0B\u7684\u4EFB\u4F55\u8865\u507F\u6216\u798F\u5229\u7684\u6CA1\u6536\u3002</li>\n      <li>\u6211\u540C\u610F\u6839\u636E\u6D3B\u52A8\u534F\u8BAE\u5411Kobe\u63D0\u4EA4\u5E76\u88AB\u5BA2\u6237\u63A5\u53D7\u7684\u4EFB\u4F55\u5185\u5BB9\u90FD\u5C06\u901A\u8FC7\u60A8\u7684\u793E\u4EA4\u5A92\u4F53\u8D26\u6237\u4FDD\u6301\u516C\u5F00\u53EF\u8BBF\u95EE\uFF0C\u6700\u77ED\u4FDD\u7559\u671F\u4E3A\u516D\uFF086\uFF09\u4E2A\u6708\uFF0C\u6216\u8005\u5728\u6D3B\u52A8\u534F\u8BAE\u4E2D\u6307\u5B9A\u7684\u66F4\u957F\u671F\u9650\u5185\u3002</li>\n      <li>\u6211\u62E5\u6709\u6211\u6240\u521B\u5EFA\u7684\u6240\u6709\u5185\u5BB9\u548C\u4FE1\u606F\uFF0C\u6B64\u5916\uFF0C\u6DB5\u76D6\u77E5\u8BC6\u4EA7\u6743\u7684\u5185\u5BB9\uFF0C\u5982\u7167\u7247\u548C\u89C6\u9891\uFF08IP\u5185\u5BB9\uFF09\uFF0C\u60A8\u5728\u6B64\u58F0\u660E\u5E76\u4FDD\u8BC1\u8BE5\u5185\u5BB9\u5C06\u662F\u60A8\u7684\u539F\u521B\u4F5C\u54C1\uFF0C\u5E76\u4E14\u8BE5\u5185\u5BB9\u4E0D\u4F1A\u4FB5\u72AF\u6216\u632A\u7528\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u77E5\u8BC6\u4EA7\u6743</li>\n      <li>\u4E00\u65E6\u5DE5\u4F5C\u5B8C\u6210\uFF0C\u6211\u5C06\u5728https://app.getkobe.com/\u63D0\u4EA4\u6211\u7684\u652F\u4ED8\u548C\u6240\u6709\u53D1\u5E03\u7EDF\u8BA1\u6570\u636E\uFF0C\u4EE5\u4FBF\u8FDB\u884C\u652F\u4ED8\u5904\u7406\u3002\u652F\u4ED8\u5C06\u5728\u5E73\u53F0\u4E0A\u63D0\u4EA4\u652F\u4ED8\u540E\u768445\u5929\u5185\u6536\u5230\uFF0C\u5E76/\u6216\u5728\u5BA2\u6237\u652F\u4ED8\u6E05\u7B97\u4E4B\u540E\u6536\u5230\uFF0C\u4EE5\u8F83\u65E9\u8005\u4E3A\u51C6\u3002</li>\n      <li>\u4E00\u65E6\u6211\u6536\u5230\u7B80\u62A5\u7684\u786E\u8BA4\uFF0C\u6211\u5C06\u6309\u7167\u5BA2\u6237\u8981\u6C42\u7684\u6307\u5357\u53CA\u65F6\u63D0\u4EA4\u6240\u6709\u8349\u7A3F\u3002\u6211\u5C06\u786E\u4FDD\u5E16\u5B50\u5728\u622A\u6B62\u65E5\u671F\u4E4B\u524D\u4E0A\u7EBF\uFF0C\u5E76\u4E14\u4E86\u89E3\u5982\u679C\u672A\u80FD\u8FBE\u5230\u8FD9\u4E00\u8981\u6C42\uFF0C\u6216\u8005\u5BA2\u6237\u5BF9\u6211\u7684\u8868\u73B0\u6709\u4EFB\u4F55\u6295\u8BC9\uFF0C\u6211\u53EF\u80FD\u4F1A\u653E\u5F03\u6211\u7684\u8D39\u7528\u6216\u88AB\u5BA2\u6237\u6263\u7F5A\u3002</li>\n      <li>\u5982\u679C\u4EA7\u54C1\u88AB\u7EB3\u5165\u6D3B\u52A8\u4E2D\uFF0C\u5219\u4E0D\u5F97\u5C06\u5176\u7528\u4E8E\u9500\u552E\u6216\u8F6C\u552E\u3002</li>\n    </ol>'
  },
  confirmButtonText: 'Accept',
  cancelButtonText: 'Decline'
};
var langs = {
  en: {
    name: 'Name',
    email: 'Email',
    dateOfBirth: 'Date of Birth',
    ethnicity: 'Ethnicity',
    country: 'Country',
    occupation: 'Occupation',
    city: 'City',
    gender: 'Gender',
    ContactNo: 'Contact Number',
    instagramHandle: 'Instagram Handle (Leave blank if not applicable)',
    igFollowerCount: 'Instagram Followers (Enter numbers only)',
    igAvgViews: 'Average Instagram Views ',
    tiktokHandle: 'TikTok Handle (Leave blank if not applicable)',
    tiktokFollowerCount: 'TikTok Followers (Enter numbers only)',
    tiktokAvgViews: 'Average TikTok Views',
    igIndicateCost: 'Please indicate your cost for Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'IG Remarks',
    tiktokRemarks: 'TikTok Remarks',
    tiktokIndicateCost: 'Please indicate your cost for TikTok',
    tiktok: 'TikTok',
    platforms: 'Add Other Social Media Platforms',
    eventAppearance: 'Event Attendance',
    loadingFee: 'Loading Fee',
    uploadMediaKit: 'Upload Your Media Kit here',
    loadContent: 'The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?',
    yes: 'Yes',
    no: 'No, please provide reason ',
    giftBrand: 'Would you like to be part of our PR or gifting collaborations with brands?',
    yesIAm: 'Yes, I am',
    noPaidCampaign: 'No, I only do paid campaigns ',
    preferredCampaigns: 'Preferred type of campaigns/genre (please tick relevant)',
    bestRepresent: 'A short description of your profile that best represents you',
    enterIgTikTok: 'Please enter Instagram or Tiktok Handle'
  },
  th: {
    name: 'ชื่อจริง นามสกุล',
    email: 'อีเมลล์',
    dateOfBirth: 'วันเ ดือน ปีเกิด',
    ethnicity: 'เชื้อชาติ',
    country: 'ประเทศ',
    occupation: 'อาชีพ',
    city: 'เมือง',
    gender: 'เพศ',
    ContactNo: 'เบอร์ติดต่อ',
    instagramHandle: 'ชื่อ ไอจี หรือ ลิ้งไอจี (กรุณาเว้นว่างหากไม่เกี่ยวข้อง)',
    igFollowerCount: 'ผู้ติดตามในไอจี (กรุณาใส่เฉพาะตัวเลขเท่านั้น)',
    igAvgViews: 'ค่าเฉลี่ยเปอร์เซ็นจำนวนคนดูใน IG',
    tiktokHandle: 'ชื่อหรือลิ้งTiktok (กรุณาเว้นว่างหากไม่เกี่ยวข้อง)',
    tiktokFollowerCount: 'จำนวนผู้ติดตามในTiktok (กรุณาใส่เฉพาะตัวเลขเท่านั้น)',
    tiktokAvgViews: 'ค่าเฉลี่ยเปอร์เซ็นจำนวนคนดูใน Tiktok',
    igIndicateCost: 'กรุณาเขียนเรทการโพสต์ในช่องทาง IG',
    igStory: 'เรทการโพสต์ ไอจี สตอรี่ ',
    igPost: 'เรทการโพสต์ ไอจี รูป',
    igCarousel: '4-5 รูปต่อ 1 โพสต์',
    igReel: 'เรทการโพสต์ ไอจี reels',
    igRemarks: 'กรุณาแจ้งเงื่อนไขเพิ่มเติม',
    tiktokRemarks: 'กรุณาแจ้งเงื่อนไขเพิ่มเติม',
    tiktokIndicateCost: 'กรุณาเขียนเรทการโพสต์ในช่องทาง Tiktok',
    tiktok: '1 Tiktok โพสต์',
    platforms: 'ช่องทางโซเชี่ลมีเดียอื่นๆ',
    eventAppearance: 'ค่าธรรมเนียมการเดินทาง',
    loadingFee: 'ค่าธรรมเนียมการโหลด',
    uploadMediaKit: 'อัพโหลดคลิปในนี้ค่ะ',
    loadContent: 'ทางลูกค้าอยากที่จะใช้วิดีโอ Content ได้ไหมคะ',
    yes: 'ได้',
    no: 'ไม่ได้ ( เหตุผล )',
    giftBrand: 'คุณอยากที่จะมีส่วนร่วมในการโฆษณา หรือ collab กับแบรนด์ ไหมคะ',
    yesIAm: 'ได้ค่ะ',
    noPaidCampaign: 'ไม่ (รับงานเฉพาะที่จ่ายเงินเท่านั้น)',
    preferredCampaigns: 'ประเภทแคมเปญ/ประเภทที่ต้องการ (โปรดทำเครื่องหมายที่เกี่ยวข้อง)',
    bestRepresent: 'คำอธิบายสั้น ๆ เกี่ยวกับโปรไฟล์ของคุณที่เป็นตัวแทนของคุณได้ดีที่สุด',
    enterIgTikTok: 'กรุณากรอก Instagram หรือ Tiktok Handle'
  },
  vn: {
    name: 'Họ Tên',
    email: 'Email',
    dateOfBirth: 'Ngày sinh',
    ethnicity: 'Dân tộc',
    country: 'Quốc tịch',
    occupation: 'Nghề nghiệp',
    city: 'Thành phố',
    gender: 'Giới tính',
    ContactNo: 'Số điện thoại liên hệ',
    instagramHandle: 'Tên Instagram (Để trống nếu không áp dụng)',
    igFollowerCount: 'Số lượng Follower trên Instagram (Chỉ nhập số)',
    igAvgViews: 'Lượt View trung bình trên Instagram',
    tiktokHandle: 'Tên Tiktok (Để trống nếu không áp dụng)',
    tiktokFollowerCount: 'Số lượng Follower trên Tiktok (Chỉ nhập số)',
    tiktokAvgViews: 'Lượt View trung bình trên Tiktok',
    igIndicateCost: 'Mức giá mong muốn cho các nội dung trên Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'Lưu ý/Ghi chú',
    tiktokRemarks: 'Lưu ý/Ghi chú',
    tiktokIndicateCost: 'Mức giá mong muốn cho các nội dung trên Tiktok',
    tiktok: 'Tiktok',
    platforms: 'Các nền tảng mạng xã hội khác',
    eventAppearance: 'Phí tham dự Event',
    loadingFee: 'Phí đăng tải nội dung (chi phí để boost content)',
    uploadMediaKit: 'Tải lên Chi tiết báo giá của bạn tại đây',
    loadContent: 'Khách hàng có thể muốn đăng tải nội dung của bạn lên các mạng xã hội trong thời gian không quá 30 ngày, bạn có đồng ý với sự sắp xếp này không?',
    yes: 'Đồng ý',
    no: 'Không đồng ý (Lý do)',
    giftBrand: 'Bạn có muốn tham gia chương trình PR hoặc hợp tác tặng quà của chúng tôi với các thương hiệu không?h',
    yesIAm: 'Đồng ý',
    noPaidCampaign: 'Không, mình chỉ tham gia các chiến dịch trả phí',
    preferredCampaigns: ' Loại chiến dịch/thể loại ưa thích (vui lòng đánh dấu vào ô phù hợp)',
    bestRepresent: 'Một mô tả ngắn gọn về hồ sơ của bạn giúp hình dung bạn tốt nhất',
    enterIgTikTok: 'Vui lòng nhập Nick Instagram hoặc Tiktok'
  },
  id: {
    name: 'Nama',
    email: 'Email',
    dateOfBirth: 'Tanggal Lahir',
    ethnicity: 'Etnis',
    country: 'Negara',
    occupation: 'Pekerjaan',
    city: 'Kota',
    gender: 'Gender',
    ContactNo: 'Nomor Kontak',
    instagramHandle: 'Instagram (Biarkan kosong jika tidak berlaku)',
    igFollowerCount: 'Jumlah Pengikut Instagram (Masukkan hanya angka)',
    igAvgViews: 'Rerata Views Instagram',
    tiktokHandle: 'TikTok (Biarkan kosong jika tidak berlaku)',
    tiktokFollowerCount: 'Jumlah Pengikut TikTok (Masukkan hanya angka)',
    tiktokAvgViews: 'Rerata Views TikTok',
    igIndicateCost: 'Biaya untuk Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'Keterangan',
    tiktokRemarks: 'Keterangan',
    tiktokIndicateCost: 'Biaya untuk Tiktok',
    tiktok: 'TikTok',
    platforms: 'Tambahkan Platform Media Sosial Lainnya',
    eventAppearance: 'Biaya Peserta Acara',
    loadingFee: 'Biaya Pemuatan',
    uploadMediaKit: 'Unggah Peralatan Media Anda Disini',
    loadContent: 'Klien mungkin ingin memuat konten Anda di media sosial untuk jangka waktu tidak lebih dari 30 hari, apakah Anda menyetujuinya?',
    yes: 'Ya',
    no: 'Tidak, tolong jelaskan alasan',
    giftBrand: 'Apakah Anda ingin menjadi bagian dari PR kami atau memberikan kolaborasi dengan brand?',
    yesIAm: 'Ya',
    noPaidCampaign: 'Tidak, saya hanya melakukan campaign berbayar',
    preferredCampaigns: 'Jenis campaign/genre pilihan (harap centang yang relevan)',
    bestRepresent: 'Deskripsi singkat tentang profil Anda yang paling mewakili Anda',
    enterIgTikTok: 'Silakan masukkan Instagram atau Tiktok*'
  },
  cn: {
    name: '姓名',
    email: '电子邮件',
    dateOfBirth: '出生日期',
    ethnicity: '种族',
    country: '国家',
    occupation: '职业',
    city: '城市',
    gender: '性别',
    ContactNo: '联系电话',
    instagramHandle: 'Instagram用户名 (若不适用，请留空)',
    igFollowerCount: '您的Instagram粉丝数量 (只输入数字)',
    igAvgViews: '平均Instagram观看次数',
    tiktokHandle: 'TikTok用户名 (若不适用，请留空)',
    tiktokFollowerCount: '您的TikTok粉丝数量 (只输入数字)',
    tiktokAvgViews: '平均TikTok观看次数',
    igIndicateCost: '请注明您的Instagram价格',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'IG Remarks',
    tiktokRemarks: 'TikTok Remarks',
    tiktokIndicateCost: '请注明您的Tiktok价格',
    tiktok: 'TikTok',
    platforms: '添加其他社交媒体平台',
    eventAppearance: '活动参与费',
    loadingFee: '加载费用',
    uploadMediaKit: '在此上传您的媒体宣传册',
    loadContent: '客户可能希望将您的内容加载到社交媒体上，但不超过30天，请问您是否同意此安排？',
    yes: '好',
    no: '否，请提供原因',
    giftBrand: '你想参与我们与品牌的公关或赠品合作吗？',
    yesIAm: '是的，我愿意',
    noPaidCampaign: '不，我只做付费活动',
    preferredCampaigns: '首选的活动/类型（请勾选相关项',
    bestRepresent: '请简要描述您的资料，以最能代表您的方式。',
    enterIgTikTok: '请填写Instagram或Tiktok用户名'
  },
  jp: {
    name: '名前',
    email: 'メールアドレス',
    dateOfBirth: '生年月日',
    ethnicity: '民族',
    country: '国',
    occupation: '職業',
    city: '都市',
    gender: '性別',
    ContactNo: '連絡先番号',
    instagramHandle: 'Instagramハンドル（該当しない場合は空白のままにしてください）',
    igFollowerCount: 'Instagramフォロワー数（数字のみを入力してください）',
    igAvgViews: 'Instagramの平均ビュー数',
    tiktokHandle: 'TikTokハンドル（該当しない場合は空白のままにしてください）',
    tiktokFollowerCount: 'TikTokフォロワー数（数字のみを入力してください）',
    tiktokAvgViews: 'TikTokの平均ビュー数',
    igIndicateCost: 'Instagramのコストを指定してください',
    igStory: 'IGストーリー',
    igPost: 'IG投稿',
    igCarousel: 'IGカルーセル',
    igReel: 'IGリール',
    igRemarks: 'IG備考',
    tiktokRemarks: 'TikTok備考',
    tiktokIndicateCost: 'TikTokのコストを指定してください',
    tiktok: 'TikTok',
    platforms: 'その他のソーシャルメディアプラットフォーム',
    eventAppearance: 'イベント出演料',
    loadingFee: 'ローディング料金',
    uploadMediaKit: 'メディアキットをアップロードしてください',
    loadContent: 'クライアントがあなたのコンテンツをソーシャルメディアに30日以内の期間で投稿する可能性があります。この取り決めに同意しますか？',
    yes: 'はい',
    no: 'いいえ（理由をお知らせください）',
    giftBrand: 'ブランドのPRやギフティングコラボレーションに参加してみませんか？',
    yesIAm: 'はい、参加します',
    noPaidCampaign: 'いいえ、有料キャンペーンのみ',
    preferredCampaigns: '希望するキャンペーンのタイプ/ジャンル（関連するものをチェックしてください）',
    bestRepresent: 'あなたのプロフィールを最もよく説明する短い説明',
    enterIgTikTok: 'InstagramまたはTikTokハンドルを入力してください'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  formConfig: formConfig,
  tableHeaders: tableHeaders,
  followerOptions: followerOptions,
  rateCardTermsAndCondition: rateCardTermsAndCondition,
  langs: langs,
  rateCardLabels: rateCardLabels,
  currencyOptions: currencyOptions,
  targetCountries: targetCountries
}));

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  INSTAGRAM_GRAPH_API_HANDLE_AUTH: '/api/v1/instagrams/graph/api/handleAuth',
  INSTAGRAM_GRAPH_API_HANDLE_FB_LOGIN: 'api/v1/instagrams/graph/api/facebook-login',
  INSTAGRAM_GRAPH_API_HANDLE_SELECTION: '/api/v1/instagrams/graph/api/select',
  INSTAGRAM_GRAPH_API_CHECK_SESSION_AVAILBLE: '/api/v1/instagrams/graph/api/{fbId}/availble-session',
  INSTAGRAM_BASIC_DISPLAY_VERIFY: '/api/v1/instagrams/graph/api/basic-instagram-auth'
});

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(2251),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1547)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(2318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(2236),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1409)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(2128),
  /* scopeId */
  "data-v-53cfd877",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1484)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(2240),
  /* scopeId */
  "data-v-964f257e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1523)
__webpack_require__(1522)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(2289),
  /* scopeId */
  "data-v-c9d0b358",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1314)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1155),
  /* template */
  __webpack_require__(1989),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1156),
  /* template */
  __webpack_require__(2096),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1159),
  /* template */
  __webpack_require__(2084),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1524)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1164),
  /* template */
  __webpack_require__(2290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1166),
  /* template */
  __webpack_require__(2281),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1176),
  /* template */
  __webpack_require__(2206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1385)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1183),
  /* template */
  __webpack_require__(2090),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initFbSdk;
/* harmony export (immutable) */ __webpack_exports__["b"] = getFbSdk;
/* harmony export (immutable) */ __webpack_exports__["c"] = fbLogin;
/* unused harmony export getFbLoginStatus */
/* unused harmony export fbLogout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);




function initFbSdk(options) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.fbAsyncInit = function () {
      var defaults = {
        cookie: true,
        xfbml: false
      };
      options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaults, options);
      window.FB.init(options);
      resolve();
    };

    (function (d, s, id) {
      var fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      var js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v15.0&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  });
}

function getFbSdk(options) {
  var _this = this;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!window.FB) {
                _context.next = 4;
                break;
              }

              resolve(window.FB);
              _context.next = 7;
              break;

            case 4:
              _context.next = 6;
              return initFbSdk(options);

            case 6:
              resolve(window.FB);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}

function fbLogin(options) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.FB.login(function (response) {
      return resolve(response);
    }, options);
  });
}

function getFbLoginStatus() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.FB.getLoginStatus(function (response) {
      return resolve(response);
    });
  });
}

function fbLogout() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.FB.logout(function (response) {
      return resolve(response);
    });
  });
}

/***/ }),
/* 221 */,
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html_to_pdfmake__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html_to_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html_to_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Post_postApi__ = __webpack_require__(42);









var path = __webpack_require__(668);



var HTMLToPDF = function () {
    function HTMLToPDF(data) {
        var font = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Roboto';

        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, HTMLToPDF);

        this.data = data;
        this.font = font;
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(HTMLToPDF, [{
        key: '_pdfMake',
        value: function _pdfMake() {
            var dd = {
                header: {
                    margin: [0, 10, 20, 40],
                    text: 'Date: ' + __WEBPACK_IMPORTED_MODULE_7_moment___default()(Date.now()).format('DD/MM/YYYY'),
                    alignment: 'right',
                    style: 'smallText'
                },
                footer: {
                    margin: [0, 10, 0, 10],
                    text: 'www.getkobe.com',
                    alignment: 'center',
                    style: 'smallText'
                },
                content: [{
                    image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAYAAADnRuK4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAKXlJREFUeNrtnXecXWWd/9/f59w2NcnMpJCQBNITSCgBRJBii+CKgr2L6676W9ddy1oWXdeVdd3VXRFcVywIFkAQERCQHlJI771MMjOZlum93HPPeZ7fH885d27GJBAywwzj+bxeyeTezD33eZ7zOd/n2x+IECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIvzFQIbjouauWX/+RTceHum5RhgGqKG+YECe8cDrgfOBQuY6bPjXmSM91wjDgCEnEFaqXQH8DPgt8H1zwL/s4m+eIYmCUkrKykZ6zhGGELFhuKYDLAJmAHGEuU3dZsEXr668HVhuDPUjPekIQ4fhkEAOcAYhOQXV0msuP9Kmb8lLyLccYcZIT/qVhLlr1nF1wrGC4ZBAcawOlFXQ23qM6uhjkhKuB54Ejoz0xIcbg0lj7pqFAdQYMyaGg0ApYELuGw3dmu5+gwiGYbL8RiEEmALMBHygSubGmmIFpaY4T2htbh7p8Q0JhmMLSwGl4QtjoKnT0J8BgR6gcaQn/QphEvBvwK+BXxv4z4at7jyvR4sDlI0RY2I4JFAxYFdHIONDQ6fB9Q0I7UDTSE/6FcJZwLXAmQj0uWb6Hasz+QXj1GMGngIaRnqAQ4EhlUDBvj8VqwMB0OcZGjo1vgax0qdjpCc93AjWYSJQGL7XkyF/71H9nriS7wPvxBobr3oMxxY2AygIX/S50NRt0AaDlT5dIz3pVwhnAkkABDr6DPUdWiFMAGYREei4cLAEyi5ce6+hsdMAaOAo0DvSk34FEAfmAonwjYpmTU2bRgk+0AJ4Iz3IocBQEygfu/db3cpAbbvmaIdGCRmgljGycCdCsH1NBhYTSBnPh521Pm09BiV0AfuxD9SrHkNNoInAHAJTXRsob9J09BmU0AeUj/SEXyEsAuaHLzr7DZurfDwfgBpgT3Nkxh+L4Mk7G7v3A5D2YE+dJm1lTj0wtrxox0cCeA1WCoHA/kbNjho/9INtD9ZiTGAoJZAC5gElAAi09RkONPjh/x8Cjo6VJ+94CB6iSVgCJcFK4S1VPs3dBhG6gReA7pEe61BhKAmUBywkxwKradPUtGpE0MAe/jIssHlY/QcEutKGrUd8XCuFq4BNjBH9B4aWQCXAgtxr7qnXtPUaxD5xu4HMSE94mBEHXosNYYBAZath31EfrBtjF3BkLEnhISFQILqnY/0bAPRlYEeNT7998o4CBwEz0hMeLgRrUAJcTmC+GwO7an1q2w0I/cAWoH2kxzqUGCoJpLBie0r4qr5Ts7vOx1jKlAPVY+nJOwEWAksAG/hzDVuqfLr6DUpoArYyxtwYQ0WgAqzozuo/e+o1lc0a7La1DRjr7IkDV2JdGSBwpNWw5YiPthrPfmDvWHuITptAgeieCSwFQKA/A5sqfav/CK1Y0Z0e6ckOF3Kch9ntS2vYUOlzqMlHKTLAWsZgJsJQSCABLsGSCICGLs3Wap+MD2LN950jPdFXAEuAc8IXrb2Gp3Zn6Elng8grGYNGxFAQqAibRJ/dvipbNIca/TDus4ExZnkcBwXAG7A+IBDYfMRnU2XWebgGu42POZwWgQLRPRu4ILxWRsOWIz4t3QZlHWfrGfvb1wLgTVg9iB4XntzjhS6MduAxoG0sPkSnK4EEuJBw+xJo7jY8v9/HtQ7oWqzvY8ya71jSLCOMfSnY3+iz7pCHb5Xn7VgJNGach7k4XQKNAy4LfgKwq85nb50fep/XAJVj8cmDYxLorsWm8uL58EK5z5EWjbK+n2eAqrG6Bi+bQMHinQmcRxB9z2hYX+HT0ZcV3c9g86DHKgRreZ0TvjrapVl10KPXBREqgecBd6QHOlw43ZzohdgIPIjNfd5Y4eFpUEI5Vny/pO3r1VZPH4x3AvBWcqpQdtVmI+8aWAfsGqvSB06PQCngUsL8Z4HddT4HGzXY/X4jUPNiizeIODGsReNSpvpGenFeAi7AOlAFbPjm+f1eaEB0YpPnx3QO+MsiUHDTZ2DNd4WA68HmKp+WHoNAK9Zx1nOCzw4ew1TgXGwzhrOBCjrNL4vGl9WmYlaEjaanOJhDPvBmwvwngao2zZpDPtqAEvZiJdCYxulIoMuw5isALT06m7YQU1Ri4z7HbF+DyFOIzdx7I9aHsgCYiJA00PnCfq9ofL78vqvf7I2pUalHnR2M23qegTXlHhXNGiV4wHNA3Wgi/nDg5RKoCLiKnLKVg42affU+yu79m8mxPHKII1hn28XAddgWMDYJP6hXPdppWF/pF/98Vfof+lxzQ0zxA+BORpcvyQGuxj4AWffFM3s9el2DEqqBZ0fZmIcFp0yggAxnYV33x1hfTV1Z5+FaoHcQcSZjCXM91nKZGn4+TLxaWe7z2w0Z1ld4tPWYfCy5zsUmq42KmxHMqRS4htD7LrCj1mdnrQYrdddj/V9jHi9XAp2PJREALT2GNeU+GWt9HQE2rfvnwnD7SmJ1pb/FEmhi9ioCvoEDDZrfbszwhy0Zats1QL8StgK/x3pxR1sm4xKsAzUbPH6h3KexUyNCB3b7ahnr2xe8PAKNA15HjvW1s9ZnT/1A3Ke121TOnu4IvWY68F7gb7CpnlmJA1DXaXhit8c961x21/m4PkYJFcA9wN3YPKLRlj+TwnqeJ4Vv1LZr1h7ycH2IKQ5g857HpOd5ME6JQIH4noU13xXYyotVB7NxnzZf81zL/xXH6TXvBj6KzZEpzl4k2K5Wlfv8doPLqoM+nTbhqlUJz2L1nZXkWHCj5UnOqTy5Ilw7A+yo1RxszCrPq4CK0TLm4capSiCFVYBnha9qWjTrK2zqRlyx/2tvTfaOj8m/oHkfMC37yaDRwq56q+c8vjNDfYcBSCthE/BL7HZVB6OHNIMg2IqLeeEbfRlYXe6FtW+twHLg1eDDGhKcKoEKsdtXNnVjR63mUKMmP45+10XxxKevSn4Vw1JyypuNgSNtmoe3edy/yeVgg8bT+Eo4CPyOge3Kh1FLHrA5z28g9DyLTV1Ze8jDGBBhNyOQtjGSXvyXTKBgkNOwCrSEyuP2ap+iFPztlUn50CWJ8wriOJgBXaepx7B8v8fvNmVYd9ijz8aIGpXwOLZ3zjpy6uVHK3mC+c/HJs8JWANgVblHlQ2cuti4V9MrNYdBxEkFf3ozPu7mm2ey9F+qhn0MpyqBFpBTedrRZyhMwjffnuLNC+OSHycW9iAL84J+sdpleeDeF+gRYS1Wz3mKIE96tJJmEMKc57PAzrGpy7B8n0d/htD3s5xXIHA6iDjjseGUa7Cukn0xh3su/HrlgYm3TqSpOc1wGrGnQqA41nS1zkMD41LCxy9LMCFfUGLfQ6Cx2/Dw9gx3rnY50KgxhowSdmIlzkPYAjsDrxrygPX9vJ6crXlbtc+OGh/Ipq7sHu5B5JAnDysNP4JNJ5mMdXC6ns/FD/z9jFtdz6wtmZjX1do0wgQKBl2GTZyPh++nYpCKBTa5sSJ9W43PHatdntzl0W4VyxYRHgJ+ik2uz5rlrxby5GReLgRAoDdQnoOS5Xas57l9OOeUQ55pwIeAj2PbyOT2GkqI4i19PvPHFaj7W7v8H5WVldUO17hORQItyi7gYAj0e/D0Xo/bnk2zvdpHG7SySuWPgQcJWroN5USGqs/gSxzTYsLejwL17ZpNlbbjhmN9P+sY5PsZSuU251qLgC9hu5wVh+Oxv2R/xBycskKZnYrxDzFHPOC/GKa8rJdKoDxszu/UP18RaO8z/GZDhp+vdKlu04jQK8IfgVuxaR0eDB15BhEniZWKx+v+OjgXKXepNdAP6LKyshcbWwE2dSMF1qrcXa8pH/D9rCaI/b1YT+jw/0+FSMFnFNaF8K9YSzAezqah2+B6hqnFCifcEAxoTYEI1wH3MUzb64sSKMd5mI08596Olh7DT1a63LHaDX0hjcBdwP9hdR1gyMkjWDJfgbUKx3P8lnEnI1AftuRoJbD74nMmZTbsakDkWB4G8z8DG5NTAK4PGyqs70eENgMrt9xU2D+jpDj8jkKsp/pMrG5SjC3paQAqgGpz16xeAB0D58MnJlPw/U4w129h44gKge60YfkBj111mmvOiTFtnP1214P9RzXdaYMSirDB79NC7oORS/6XIoFC5+GCY94N2rf8ZJXLz1a5oTe5EvhvrF+nHYZNz1kMfBlYpg0lGEuel5q5L8FfInSL7Rryg42H/Afa7jj7RHVb88mxvpq7bcMorQFhfyLGzhkT1QR85mANjUuw2/0U7M1LYCVeD7bQYC3wB4T1f9yU6S8pLqW1s+VkN+1ibMvgLHmOdhl+utJlU5XHjZclOOcMx7JbYGedz5O7M7g+YWJb5+ks9smk6kshUCE2deOYcERvBu5am+GO1VnyVAA3Yw9Y6YOhJ09JSRlYaXAT8C4gVlogFOcJjoJQeJyok7kJ/tIG+jKG5i5TmPG5xFF86+0XxEnE1SPmvlk98r5jJEIcu31le1/vrvcpb9QY8M8qVRVPf77gDfi8BbgIK3HyAIUKBjPA7PEYpgWO1rdqzS8mFcsvWzq21kv8fPBajzfsecDXsA5chUBth+F7T6bZesTns29M8LbFcRKB/D3crPnBM2l21fq5oZWXfTJAQJ4Y9mFwjKGOnALJ2Ev48FysnyGLjIZHtmf42UqXjl6DEuqwitp9DBN5AFpbM5SVxa/EBjNjS2c6/M0VCc4qUzhKELEezFDCHDsZex+NETSGzl7DH7ZmeHBLhr4Mc4qS/EdbpykrSMld5q5ZXXLj4dyOG+cTmO+uD2sO2byf1811zOfelHxtSb5ci2FAMRMbI6xt1VS1aFq6DRkfJuQLS2c6TCwQB5iL8NWMYcmliy66E8PK0rKydMuxOVQlwN9jMx9VqG/+fHWag40+X7omybKFMRJBaURtu+EHz6Z5Zo+HNlnXwp2cYkOrQRKnBHgH8B7AE4ebx5WUbUwou54vJoFiWN9HtmzZCKw77POj5WkaOjXKmrA/An4D9A4Hccyds8AB+Wi1MmbcRUBxcZ5w4+UJ3n1hHGwSW0ewUJqAKye5pCBIWZE4O2p06dYjfl5TlzmrN22+iCdH6OORnM9PJydxrLFb09hp+H9XJXnvxfHY7FI1R3IOcGjrM2yt9lm+z2NDhU9Nm6HXNWhDuiBJ+p+WJdXHLk0UOIIoYdzkYvX+siJ1XmGh+m9HuBfoN4/PgUbtAG/DZjPYbmfAxiqfrn74+l+luOQsx+7dAvWdhluf6+fBzRlbUi7sAP4d2PEyiZPAqgofB94NTPY0mbvXZxpjwlINKwT2xV7kYmdiPZypcAGPtGl+/HyavfXZuqffYM8G6xkW8oSTUiQ2fXvqgk//qu/cw03aGZ8vzJqoAHx8VgRjqD4OgXKJNCCXYkhnP+Nbus3nRHhLd78h4zETw/WkeA7rvhWs8pz1vseV8OkrE8yd5JAXJ+s87XYN6yp87tuY4YVyj6Yug6/pxxoS2w1sbO2hsqRAlgKfJYgnTsgXKc5jUUxxkzYchn9aQd2DEGMe8AnCXovYhg3Txguff1OCaeNU9rur2w23PJPm/k0Ze6SEsAercC8H9Eu5LznkSWD13VDqLARiWmBNhRf/+ar0hw28X1kL+99PJoEU1nV/XnYCBp4/4PNCedb7+jxW+gzp8QXHifEswueauRPVtedNdy4sb9Q4ChwrupuB24EHeOl6NPjwpv/pGZ+f4KgEN8fXBgwLEEoCAqWw+o8NHhuYXChMLnKyFDUCh5o1d6/P8IetGWraNBjSIuxyFI9gk8v2KKF9/mSlrz8vnsIM+Iu0Ad9W8c4AXgO3rSB+ZhzD27A6VRYxgYWTHfsUBOTZ16i57dk0D2/zSFvy7MMq3I8D3snIM2idHWyqyvVYiXMekAqT/l4o9/ivJ9LsP6qTyj6GGTj5FjYe6/vJKo9dacOK/V5oHjZgnYQHhkryHEeEzscqy+/AMN8RyUs42bULqyI7sKaxOVUnXeASMOGN1JZ+hVglGGzUfQmDCzADmnrG6kO3Peeyttyj3wMlVCHcD9yLtfDS4fXXfaUwjmEOOeGQ7n5DS48BQQFF4IJhKnb7yg9/L0T4T9/YFjq3PJPm+f0eno8RYTt22/oj4J7ovgxaZ8VAde37sRZkYe6W/Nguj5+usLsO1qf3KIG+ezICTcLu/dnIekWLZnu1H157HdaBdlqZd8cxEcdjxeYyrBhdRJh0HzwNgy8B+KebvmAVbMA+VE6O/2v28X4/o+HxXRm++2SafUc1YvOaVgE/wErmYxLiguvNwyrEifBLq9s19e3ZDvbtK744DWzI6NxwXG29Bk/DhDyr7LX1Gp7d53H7Cpd99T4GPBFWAP8BrAD8l0CeOFbqXQm8D5skOC68170Z2Frtc+8Glyd22YTBQN99GPhPYF+4WCf6knHk1LxrAxsqfI7avN++YKAdpyp9TuBTSAWTuQjrsLw8uHmJkK1N3YbnD3rsqdPWXM+aW0PeuCH36kvIkcAhfOCpfYFIb9Bh9/n7sOTZE45pUFVKQXCjzs9ex9g+kq22g32fgYrXLk3FcM25BM4/14dfrXPZUuUzb7IyrgflTVo2VdrPidAh9qbeglWYj9F5jrPeKSyRl2H126XkpCd7GvbWax7aluGP2zNUNmu0wVPCLmzS330Efa6bm5tPuoUVkqM897g2PSPYZ2uwIQqfF8FJnFAJrIJ4PrZE5tJgYqUE+UYA7f2GVQd9HticYUNFNi1ksJ112iTK7hIm67kpxDrw8nJ/zwBrK3y++0SaA5Y8fcCvsG6M6lzi5MxfBTfsQ+RsS41dhpUH/NDhV681B+JCEmv1xsBuIc/s9XjhoE88xmFj2OhrFomQUEItdjv5HdZByXFKqUIUY62qvwrGsoCcqhJjoKHL8Mj2DPdvyrC71sf1MEpRI8Ij2EyKbQRbcvg9JyJQeHBuabhqjkBBQkJRv02Eg8cNPp2YME4w4FLscQhXBH/OweoadizKTqalx7C9xuehrRme3uPR1G0AepUdQsGL2emnwBvrNhJsSopkCRR6lSX3t/cc1XzvyTS7a31ESGMdp/+JPcLgeOQR7MPxVXK62PrGBp83V2WLETb1Z8wRtHGw5BUEuvoNzd0GpdBa85in+XbcYVywnh1YIyITfvdxSsWnYCX727DS/UzCjAqxE63v0Kw+5POHLRnWHPLpThsEWpTiaazUeYEgqWjwjvNnBAoGUIzdG7NPX34cbrggzu46n/JGXe8beipuLgIp5jhwsIpiAdZzPCdYvPlYx+TsYGID3x/oN0eaNavKrR9lY6VHY6dBG1xlTdNHsAHFZcYg2uR++mVDgSWPsqqyDsb/WsLGEcE3tPYa7ljtsv6wB9bL+wTw3cHkGVQPdxHwDcIeksG7O2t9frPWDTu4NgJ/7OvSXfiksKXhGlCJGOTFBWNIK8XOjm7dtGCa0whQmBSWLYpx0zVJCpIS3DYcbOnUvIC4VwUPwmRy9FljbBHnynKPh7Zk2Fjp095rQOgKctTvxkq37MF4x1NXTiSB5mDNV8Dui2kNl57tcMv78mjtMVeeP019AaENq5X3YD3QcWze0GSsEj4FG0MKY0J5x9xuseZzd9pwuEWzptzn8V0ZdtdqOvsNQIcSdonwFDbhvhz4jgim10W608G1YpjCcaWk4qfMoySBnhdzhIQjYPCxUvIN5FTeamD5AY/HdlhHnbIWz3eB/SfQOWLY8u+vBddywjlXtWl+tNy1Bokl4mNYxdtgSGPbAn4QQ/HkIsW7LozR3K29pi7TY+6eYLBWW+4DkAzWO0y5fQ3WEJk6eM3TnlXcVx30eHK3lYCtPQagWwlbgPuBp7GB5hfNUT8egcK0ganhF+9r0Px2o8uV82JcOsthwWR1vsCiwJ+hAxL5wWcTAZEUofk7oPCCsblDbb2GI62anbU+6w77bKv2qW/X9Hv4QFPwFDyIVdZrGEgVPayETFuPTj6xK8P0CeJ09JvCjE9+Kn5KkiiFtYjOB5gyThhfkCXQLHIqb8Osg99vztjtxD44P8FWoGblYA55JgE3AJ/BbtHZdaho1fzP02ke35GxpzgK67DukCZoAyZobLrvU8ANKQfnxtcmOGeqk9KaZV6P6YxJtuNHIdb4WIJ94Gdj1YGBrIlAJWjtNeyu81m+3+P5/TaW1+sagFYlbAP+gPUdVb0U4pyMQMVY0ZcCu62sPuRx5xqXx3Z67gcuiW+/cl5s0uRimTmlSJGKDwQx/wzGlvJ0pg2tPYajHYaqFs3BRp99R20+TUOnpi+DL9AqQrkS1mPdA+uxiuFgVed54GBGc+59GzLsqPYn1naYzxYkpY5jt7KT5QcprJR5rTFML0gKb1wYozRfwNAf3IipuVfaXuOzpcoP1YZVwKPFKfEP/XsROXHmFFbxvhF4OwzExzTWLP7hcy5PBZHyINzwHWwjitwR1gHfx27/lxUmRF4/LxY3hg+KVYLD2FY+A5L9GF3NntNqIwcbK31WHLChlaMdGk/jiVClLHmfZiDgesrZoscQKKdtyznhgLrShnWHffozcKRVV3//qfTXNlZ4+YV58tEpxep1k4tVyYQCiRUkIBmDWKDl9rmGxi5DVbOmqk3T0GFo6TZ09BnT65pMRtMv0KAUhwNpsxmb9FTLSYoKy8rKdgjc5ij+pbPfTH/hkD/eEd4DGP/UtGoFkJ+A6y+I8Y7z4sQUYKgC9mKfxIWAuD6sOujTavtedxjDgy0tzfVNAxInidXt3ok11eeRYxS4nt3+bn3WZVOFDXSKfVC+jZU0Wb9NEMQ12G3sG9gt8AogLooEhonkloeHhAke1o5+Q3WbZt9RzaYqn61HPCqaDJ39xhjodoS9Sng6IM4urL71svPTjyeBFpHT86a61bCr1joPRdjY47LhgTUNnVCyZkKJvCYZk6tijpynhOmOUChC3EDM16iMZ8ho/CAm1GagTqBaCRVBCfAh7PbUwaBqhhNNRsCdXqruPn+GU9Lbb2460qqLe13EGOTFI6iE8yCm7Lb15kUx3n1hgilFAoZWrBh/EKg1hr/LGJbta9DFKw/YUIFS7E7FWG/um51Pnwn1jtdjTeOF5Lg+tLFHXT60NcNv1rlUt9ozM0T4E1bybOY4saqARD42lnXU9fnrxm7zbk+bmXkJIRGzc/A1pDP2WNHy4EyybTV2e2rpNvRnjO9rOkSoCXS2Z7EWVTU5zSpOJ5IwmEB5DGT4YYA99bbrRuA8XJuK022KSszZk5ymez5V+OiV3+l8WvlMxCrKpUCBBGmmAhjBdRRtWG2+EWgTSJsTeLBfbDIZ4OBRv/eFrxXe3dBmzmrv0R/ucynUxmCMnDSCGpJHxJBwhEnFwpQiRdwBDO0MVMf2MlUt7zrsH9hd73/o2X3+X589Uc2bOl5kZonyP/+m5DvoN2GW4oJg7lkl2TdQ1655bp91Q2yssvVwQdrLfVid5+BJH5QBSbRnXZX/zUe2ZjbUd+rPKMVFeXHJU4KkPejss5K+rl3T1WeMb+gTqEPYL7DLUezESvYKbGJZdmmGIgQ14D8b2L5+CrwFwNXwrcf6+ekKFwOVwMeAleEXv+G8SRxo1LieVdTCGJVhQIM+WWeE05nAzbfO5euT/TPx+AiG67Amd5gbnZNgcQLYZdQY0hgOY6XOfUC93HgY88BsOps14z7dnvcfH8h/8wdeE//Xgricn58QtyCJj9U/BtbP2DLnqlbNygPWwtlWnW042iXCC9hU3yc5xWzNld+YyZXfanRI5M8vzONqR8kisaQtNnbOnqPoCgi6M/hThT3ct3+o1vx4GEyg12MTkGYitnvG39/Tx4oDHkHjg09wgpa1YaL7ye7cUA7e/MrmCJEmiWIqVunNh2we4EkTE1HoyiadV9tu/EVnqF0TUlKDsnzPjau9/aLJPPxoicOz6ct9l49Ut+lr+z2mxWP2Sp5vz0Q91KzZWOGx7rBPVYumL2OPOQ9M4z8Af8Ju1y9P30iUkogLE/JRGZ8EQlKElLKr4GOler8BV44j3V+Jsp4YAw4nEChv9DlsT9zxsTGe5hMN5JWu8ZKPBhmDijRWPFe82Gd6XcPhZs2BBs2Nv+wriyk+pYSpV82PVf7+B8Vy2cfa2d+gj6n6WFPps/72Xn/xTGfluoPejjtWu5ubu83fGZitDXmuh3T1G1p7ND0unjF0K2vhbMC2OV6LNQyyN/VlrZXbQsmEMnyNVop+rGTpgBMlPL0y9ySXQEXkmu/adt1q6tKIdWNvY5Sd+X4qEfhBpUBFyRif0oYvzSxT8c+9ObkwfcD/xfuXJe//+l19XtJ6bbI6+etv6aGvo5nnbprRfs/Kvl86+c7mZEwtdRQzBIqVoJSiTwltIhzCPmyV5HRoHYqbebRh9BVi5hJoOjlnfXb0GbZVa/pdUIpaTqHn82hDQJ4wYepcbLLUJwTGjcsT1ld6r39mrzfu7nXu1ESMHqzE7QOOGMP2L12baP23r8xDLjhAoqC0z/XMxumT2NzVT8xolA8YjTH2cz5DrKiOZtgmSQMHhmTP+qxp0+yt88Nc9D2M0JEFL7f6NBxr8PnwPIt/NHChMRQQJHXtqrFHM2g43/dZZMAYe76pFqHZUfxx1QH/JxTKXvOrWVo+epgzJpfR1oM24IYLdLIxjGXEcn4uIUg1MAb2HtXUtBmUjThvZATO+ny55En/uem3GPi6gUuLU8IZ44RU3DaEaOs1VLdq4g5qzkSVyksIWlvFuL7DFLqe+eT4lCze9VD61nOvTj5mfjMrIx8+veS1sYSQQCXYRY6DvQGbKn160gYRWrBe0RfN/RkGOFipWMaxFVaDLazc125Xl65q++nZ3eNnxZj4/rYY8BZjWDp1guJL1yS5fLajk450i6LnoW2ZvO88lh43qUjk5utTLJrq9Lqe6WjsNty+wk0+vCUzobpVX93SZSZx0OvACYKeEYABAk3HRuBt35tuw/ZqPzTJ9xM4vUYAU7EJ4ks5OYHIeb/vykWxOw08hNDgW5/hXAPxOZMUC89w6HU5eqTLf6Kx29Q9t9d7XdozVyQccQqTQrdr9hw8qh82QkYJ85Tw3uYuU9jaYxbgm/di2Mgp1lmNZYQEmklO19G9R30qmjVi83Q3MXIta/ME5sRjLHZExNO2QC+EwSa6xZ2BLLCEAzdcEJ9WFJeLqfNv7u70j44b5ySVwM4an3+8t5c+l/zaNn2x62GUMA1BeRoe2Jxh7SFvxp56/TZt8JUwTiDpa4PrGWUMC8UWEEYEChASqAMbaijRBrWhwqcj6LrKCJ442Ouayhkl6qaPvy7x1bPK1Fs6eo3zxC7PrD7oKd/Y4O27lia4bI4tdTEGkxcXLp7pTI0Jl6OZlMnoo2GUobvf0J8xKGR8Ki7jkzFIezZh3ddwsEFT1WImJWPBw2Rs8nyOwAvbyEUIEBJoHcKXu/rNDVtr9fXrDnllvj0w5CCvQNetE6E4Je7eiukvcG/Hd/DNHl9TWN6kL3mhnAvEoK6aH+OfliWZMUFagOUIzYR1qoZ9KA7l5TkCaGPgorMc3ndxIltHnvHhyd0Z/rTLIxGDD7wmbt62JNbdlzHJmCOJimbNbze4GGPCDmyS7f8YARggUA/l/uM/q/Q2P7zDqz7U6H9ICdOweSr1I2WOHm1shvqJpment6ZgvrPluh/2nLuj1l+c8ZFzpjp85uokM8ZLGs09xvBdo+kQEFEYBJedXjq/QCWBFgPG18gls5z0nIlqtYJyo6CmXc96ao93BZBaMMXh3OnOes8zezOaGT9b5S72NWcXJETG54nNXTaRAp2LGASR34dn84VvjW/4ohz5nwklzqOO4kKs9BnRYwZk6l4+e80Z5qc/dPMLkvIRY7hocrHIp69O8JqzHY3wLA7/e/uzbk1poTB/kmLJmUH15l8lkV/0usALSvjg9mp/4ld+128SMdo3VvpVStD9HkWej9/RZ/jdZlfu20TRI9u8VmNMoqPPLOlxkUvOdpg/WYH1xI8qb/xI41hxHCuhqFCRcI7NMhxJh1jgC0oCnzSGb6TiUvbJqxJ86qoEyRiHqlr0l97yw97nfddku44V5Yl77QVxfvSlYibe0AzWDfAVgU/4mgmBx9gLVkBhq4bFsemfvq/xgZgIasEUh3++Nsk158a8mPC/GL4mNx6OSBTghPt56MQbBeQRbO7ybQLzXzc3xhXzYlS3aiqaddWGCm9T2iMTpJp6QK0Ifywtc9Zv+0yen0wopt7UiS9MvnCG88lx+fIPfS6lvjYSNAdHgnYsvWlDfkKIxyAVF+ZOUly3JM7FMx2TiLERw2eBDaP5KM5XGicsLBxFbvhzgC9rw/xzpjqUFgk/fj5Nc5fBGGaIMEPEZiNiex34iRjXvPNc5zan1HkUh6Y0YDQNP/5swW39LbqzpkV/Pu5wxuxS1Rx3EE+LumejO+7p3V7qxssS+o0LY92OoqcgISYvTg+wGcPtWJdGhByc7qG7w4ZA+kwCPqMNr5s2Xnjn0hhP7fZo7TacN93h3GmOqLArme0ZKGsPebGmLnO+A9/1+szMmMMtrc3NHTOnlHHBFzp7SgukOhkjM71Etf3Xu1J3nzfD2VHRqN37N2U+f7hJX3r5XG3efZEcSChuB2qDTMXD2A4kp9zAYaxj1BIIW5ryfmN4X16c5IcvTXDFnBgPbMyQiAnvuTjOhy9NeEabI8bQLUpo7tbOV35npta1exO6+02Z0eb9OPJk4biytT32KM6y9j7zKQyzzi7DKymQ6xApv+5/ex6tazcfUQKeMY4xlKA48MiWzKq2XsOmKp+Ht3v0ZQxlZWV4PrS3jRoJPaIYzQQqApY5DhOuXRznY5claOrSruujHCE2LiUUJ6kC+RwOB4kJW6p08e5a/2tKeIfvg9jqhSm+RgHF2jDeUVRfMNNp+cRVyYnxmCwob/QvjDmyW4k5A7JKYaqxw0z84B29E/MSogaNy21v150bvnOWf/F78pE5e0Z6nUYUo5lA3cD915wTn/KPb0xeOLlYuvcdNc83dJrzRZgeNMzsxLDPN5Qr33DdbT3jUwnpzLEMlBGceIyLgL8VoUwgv88l88Aml99txK9q0ZfXtunFIiwyxhakd7km/9t/Sn8k5sj7sAHmbAzOQMfZ05xfa8NqZl/o2kyXv1yMZgKlxxdw7803JLumF6svAHse3uY92tlvvlOcCpp3KIEk5oy/68AYyEuIBkxuQnBQK7YE+KAS8sNKk111ADhKbB+eECLQ1U9hRbN+syPki+RYqgZiCvPei+KLzztD3cuv1vyS4MCYv1SMWgI1NzeTSpRlZiyJP0aVv5U86fz1WneyEjxPG6paNbvr/NQDmzKztEYFfqtSYIoQBFhFcAQ83zy3ZJrzoyvnxv66MCWlErSmA5v7VN2ueXq3R3uvwRgoLZC2157t3FuckoWLzlBvVjJQdVKUElm2KLY0pRiHYS0RgUYvauqaoa7YxVBJt7ECQDjseiz5zVpXHt3uzaxu1d9DsqUrKWOYnYzBnMmKmIMWjc5PyuHnvljw34L0S855X0HdGodbdGxXrb+4rddMBEMyhvvPb03+KePzoLKJdNlGWyrwG2HYSdAP6C8Zo5pAAPLBAbO5rKysGfiFo5jV3muWtHT7+SKcF89Rc/MSts792nPjOEI7hubmpmbic0sbOZT5HoZicnOLBHbV+EXVLeZWgWXBwd2CQeIxVuOzF2sRDm5n1c1pdoAfCxj1BBoE7Xn6iTcsTvQtneF8szAplyohFrLBEThjvHDRzBhTiqQLwyOE57dXZMDQxXFie++8pStVWhqrdxSmKCmhb0mwIY3GkZ70aMarikDNzc1MnFjm3fe9ohUc9r9sMrxDbP+hARlk2dSPYRP2cLtWAPmIlWTm/uC0nPceI9kyns+v37AwVrpsYWxZTGEwZOTGw5jfzwL/2N+PMIBXFYEAmpqaoXm8x0RZKzVmG3JsiTH2ABQPu8X8WXr9CYjgt7d5z/3wg0Vdk/IlI9b7fBBA3hUR52R41SZH6TtnnbgvUe4EX2roIVGK2VmmWJ8pReMB7XLj4Sj350XwqpNAIdTHh1gyuC2wcZzGDG3X/QgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChAgRIkSIECFChDGD/w9DDvP8MytnVAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0xMi0xOVQxMDo1MzozNSswMDowMETEO1YAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMTItMTlUMTA6NTM6MzUrMDA6MDA1mYPqAAAARnRFWHRzb2Z0d2FyZQBJbWFnZU1hZ2ljayA2LjcuOC05IDIwMTQtMDUtMTIgUTE2IGh0dHA6Ly93d3cuaW1hZ2VtYWdpY2sub3Jn3IbtAAAAABh0RVh0VGh1bWI6OkRvY3VtZW50OjpQYWdlcwAxp/+7LwAAABh0RVh0VGh1bWI6OkltYWdlOjpoZWlnaHQAMTkyDwByhQAAABd0RVh0VGh1bWI6OkltYWdlOjpXaWR0aAAxOTLTrCEIAAAAGXRFWHRUaHVtYjo6TWltZXR5cGUAaW1hZ2UvcG5nP7JWTgAAABd0RVh0VGh1bWI6Ok1UaW1lADE1NzY3NTI4MTVKGZywAAAAD3RFWHRUaHVtYjo6U2l6ZQAwQkKUoj7sAAAAVnRFWHRUaHVtYjo6VVJJAGZpbGU6Ly8vbW50bG9nL2Zhdmljb25zLzIwMTktMTItMTkvNDQ1YmIwZTY3NTBmYTgwNDc2ODA1YzllZWJkYjE5MGYuaWNvLnBuZ+9aL2wAAAAASUVORK5CYII=',
                    width: 80,
                    height: 80,
                    alignment: 'center'
                }],
                styles: {
                    header_1: {
                        fontSize: 36,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_2: {
                        fontSize: 30,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_3: {
                        fontSize: 24,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_4: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_5: {
                        fontSize: 14,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_6: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'white',
                        fillColor: '#3F3FFF'
                    },
                    boldText: {
                        fontSize: 12,
                        bold: true
                    },
                    underlineText: {
                        decoration: 'underline'
                    },
                    smallText: {
                        fontSize: 9
                    },
                    'ql-indent-1': {
                        margin: [10, 0, 0, 0]
                    }
                },
                defaultStyle: {
                    font: this.font
                },
                pageMargins: [40, 60, 40, 60]
            };
            return dd;
        }
    }, {
        key: 'generate',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _pdfMake$content;

                var pdfMake, briefPDFData;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                pdfMake = this._pdfMake();
                                briefPDFData = __WEBPACK_IMPORTED_MODULE_8_html_to_pdfmake___default()(this.data);

                                (_pdfMake$content = pdfMake.content).push.apply(_pdfMake$content, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(briefPDFData));
                                _context.next = 5;
                                return this._fixPDFContent(pdfMake.content);

                            case 5:
                                pdfMake.content = _context.sent;
                                return _context.abrupt('return', pdfMake);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function generate() {
                return _ref.apply(this, arguments);
            }

            return generate;
        }()
    }, {
        key: '_fixPDFContent',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(pdfMakeContent) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, index, content, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref5, _ref6, stackOneIndex, stackOne, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref7, _ref8, stackTwoIndex, stackTwo, stackImage, _stackImage, _stackImage2;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context2.prev = 3;
                                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pdfMakeContent.entries());

                            case 5:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context2.next = 99;
                                    break;
                                }

                                _ref3 = _step.value;
                                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                                index = _ref4[0];
                                content = _ref4[1];

                                if (content.text !== undefined) {
                                    if (content.text.length === 1) {
                                        if (content.text[0].nodeName === 'BR') {
                                            content.margin = [0, 0, 0, 0];
                                            content._margin = [0, 0, 0, 0];
                                        }
                                    }
                                }

                                if (!(content.stack !== undefined && content.stack.length > 0)) {
                                    _context2.next = 87;
                                    break;
                                }

                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context2.prev = 15;
                                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(content.stack.entries());

                            case 17:
                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                    _context2.next = 73;
                                    break;
                                }

                                _ref5 = _step2.value;
                                _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                                stackOneIndex = _ref6[0];
                                stackOne = _ref6[1];

                                if (!stackOne.stack) {
                                    _context2.next = 61;
                                    break;
                                }

                                _iteratorNormalCompletion3 = true;
                                _didIteratorError3 = false;
                                _iteratorError3 = undefined;
                                _context2.prev = 26;
                                _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(stackOne.stack.entries());

                            case 28:
                                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                                    _context2.next = 45;
                                    break;
                                }

                                _ref7 = _step3.value;
                                _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);
                                stackTwoIndex = _ref8[0];
                                stackTwo = _ref8[1];

                                if (!(stackTwo.nodeName === 'IMG')) {
                                    _context2.next = 42;
                                    break;
                                }

                                _context2.next = 36;
                                return this._getBase64FromURL(stackTwo.image);

                            case 36:
                                stackImage = _context2.sent;

                                if (stackImage) {
                                    _context2.next = 40;
                                    break;
                                }

                                content.stack.splice(stackIndex, 1);
                                return _context2.abrupt('continue', 42);

                            case 40:
                                stackTwo.image = stackImage || '';
                                stackTwo.width = 350;

                            case 42:
                                _iteratorNormalCompletion3 = true;
                                _context2.next = 28;
                                break;

                            case 45:
                                _context2.next = 51;
                                break;

                            case 47:
                                _context2.prev = 47;
                                _context2.t0 = _context2['catch'](26);
                                _didIteratorError3 = true;
                                _iteratorError3 = _context2.t0;

                            case 51:
                                _context2.prev = 51;
                                _context2.prev = 52;

                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }

                            case 54:
                                _context2.prev = 54;

                                if (!_didIteratorError3) {
                                    _context2.next = 57;
                                    break;
                                }

                                throw _iteratorError3;

                            case 57:
                                return _context2.finish(54);

                            case 58:
                                return _context2.finish(51);

                            case 59:
                                _context2.next = 70;
                                break;

                            case 61:
                                if (!(stackOne.nodeName === 'IMG')) {
                                    _context2.next = 70;
                                    break;
                                }

                                _context2.next = 64;
                                return this._getBase64FromURL(stackOne.image);

                            case 64:
                                _stackImage = _context2.sent;

                                if (_stackImage) {
                                    _context2.next = 68;
                                    break;
                                }

                                content.stack.splice(stackIndex, 1);
                                return _context2.abrupt('continue', 70);

                            case 68:
                                stackOne.image = _stackImage || '';
                                stackOne.width = 350;

                            case 70:
                                _iteratorNormalCompletion2 = true;
                                _context2.next = 17;
                                break;

                            case 73:
                                _context2.next = 79;
                                break;

                            case 75:
                                _context2.prev = 75;
                                _context2.t1 = _context2['catch'](15);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context2.t1;

                            case 79:
                                _context2.prev = 79;
                                _context2.prev = 80;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 82:
                                _context2.prev = 82;

                                if (!_didIteratorError2) {
                                    _context2.next = 85;
                                    break;
                                }

                                throw _iteratorError2;

                            case 85:
                                return _context2.finish(82);

                            case 86:
                                return _context2.finish(79);

                            case 87:
                                if (!(content.nodeName === 'IMG')) {
                                    _context2.next = 96;
                                    break;
                                }

                                _context2.next = 90;
                                return this._getBase64FromURL(content.image);

                            case 90:
                                _stackImage2 = _context2.sent;

                                if (_stackImage2) {
                                    _context2.next = 94;
                                    break;
                                }

                                pdfMakeContent.splice(index, 1);
                                return _context2.abrupt('continue', 96);

                            case 94:
                                content.image = _stackImage2 || '';
                                content.width = 350;

                            case 96:
                                _iteratorNormalCompletion = true;
                                _context2.next = 5;
                                break;

                            case 99:
                                _context2.next = 105;
                                break;

                            case 101:
                                _context2.prev = 101;
                                _context2.t2 = _context2['catch'](3);
                                _didIteratorError = true;
                                _iteratorError = _context2.t2;

                            case 105:
                                _context2.prev = 105;
                                _context2.prev = 106;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 108:
                                _context2.prev = 108;

                                if (!_didIteratorError) {
                                    _context2.next = 111;
                                    break;
                                }

                                throw _iteratorError;

                            case 111:
                                return _context2.finish(108);

                            case 112:
                                return _context2.finish(105);

                            case 113:
                                return _context2.abrupt('return', pdfMakeContent);

                            case 114:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[3, 101, 105, 113], [15, 75, 79, 87], [26, 47, 51, 59], [52,, 54, 58], [80,, 82, 86], [106,, 108, 112]]);
            }));

            function _fixPDFContent(_x2) {
                return _ref2.apply(this, arguments);
            }

            return _fixPDFContent;
        }()
    }, {
        key: '_getBase64FromURL',
        value: function () {
            var _ref9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(url) {
                var filename, object, image, base64Image;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                filename = path.basename(url);
                                _context3.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_9__views_Post_postApi__["a" /* default */].getS3Object(filename);

                            case 4:
                                object = _context3.sent;
                                image = new Buffer.from(object.Body).toString('base64');
                                base64Image = "data:" + object.ContentType + ";base64," + image;
                                return _context3.abrupt('return', base64Image);

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](0);

                                console.log(_context3.t0);

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 10]]);
            }));

            function _getBase64FromURL(_x3) {
                return _ref9.apply(this, arguments);
            }

            return _getBase64FromURL;
        }()
    }]);

    return HTMLToPDF;
}();

/* harmony default export */ __webpack_exports__["a"] = (HTMLToPDF);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(121).Buffer))

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTotalInfluencers: function getTotalInfluencers() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/influencers/total', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data.totalInfluencers);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getTotalClients: function getTotalClients() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/clients', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data.totalClients);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getTotalCompanies: function getTotalCompanies() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/companies', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data.totalCompanies);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getTotalCampaigns: function getTotalCampaigns() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/campaigns', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data.totalCampaigns);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAMCODashboardTotal: function getAMCODashboardTotal() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/campaigns/amco-dashboard-total', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCampaignsNoStatus: function getAllCampaignsNoStatus() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/campaigns/all?limit=999', true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getSpeedData: function getSpeedData(type, filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/campaigns/speed/' + type + '/duration?limit=999&' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(36);





/* harmony default export */ __webpack_exports__["a"] = ({
  handleInstagramAuthCallback: function handleInstagramAuthCallback(code) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/instagrams/handleAuth', false, { code: code }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  handleInstagramIntegrateCallback: function handleInstagramIntegrateCallback(code, userID, facebookId) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/instagrams/graph/api/basic-instagram-auth/callback-handler?facebookId=' + facebookId + '&userId=' + userID, true, { code: code }).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getLivePostMetrics: function getLivePostMetrics(url) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', 'api/v1/instagrams/media/post', true, url);

            case 2:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getInstagramProfileMetrics: function getInstagramProfileMetrics(igHandles) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/instagrams/helper/influencer/profile?handles=' + igHandles, true);

            case 2:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context2.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchRecentPosts: function fetchRecentPosts(igHandle, after, before) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = '/api/v1/instagrams/graph/api/' + igHandle + '/media';

              if (after) {
                url += '?after=' + after;
              }
              if (before) {
                url += '?before=' + before;
              }
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', url, true);

            case 5:
              response = _context3.sent;

              if (!(response.status !== 200)) {
                _context3.next = 8;
                break;
              }

              throw new Error('External Error');

            case 8:
              return _context3.abrupt('return', response.data);

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  searchByHashtag: function searchByHashtag(_ref) {
    var _this4 = this;

    var hashtag = _ref.hashtag,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'recent_media' : _ref$type;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/instagrams/graph/api/hashtag?q=' + hashtag + '&type=' + type, true);

            case 2:
              response = _context4.sent;

              if (!(response.status !== 200)) {
                _context4.next = 5;
                break;
              }

              throw new Error('External Error');

            case 5:
              return _context4.abrupt('return', response.data);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generatePDF */
/* unused harmony export contentConfig */
/* unused harmony export getTextBlocks */
/* unused harmony export formatTextBlocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html_to_pdfmake__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html_to_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html_to_pdfmake__);








var generatePDF = function generatePDF(creatorConceptData) {
  var document = __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].contentConfig();
  var content = document.content;
  content.push({
    text: 'Content Storyboard Flow',
    style: 'header'
  }, {
    text: 'Campaign Name: ' + creatorConceptData.campaignName,
    style: 'subheader'
  }, {
    text: 'Creator Handle: ' + creatorConceptData.creatorHandle,
    style: 'subheader'
  }, {
    text: 'Draft Submission Date: ' + creatorConceptData.submissionDate,
    style: 'subheader'
  }, {
    text: 'Deliverable Details: ' + creatorConceptData.deliverableLists,
    style: 'subheader'
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(creatorConceptData.deliverables), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var deliItem = _step.value;

      content.push({
        text: deliItem.title,
        style: 'middleHeader'
      });
      if (deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn') {
        if (deliItem.type === 'igReel') {
          content.push({
            text: 'Concept: ' + deliItem.concept,
            style: 'subheader'
          });
          content.push({
            text: 'Reason for concept: ' + deliItem.reasonConcept,
            style: 'subheader'
          });
          content.push({
            text: 'Music choice: ' + deliItem.musicChoice,
            style: 'subheader'
          });
        }
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(deliItem.boxes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var boxItem = _step2.value;

            var imageLinks = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(boxItem.images), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var imgItem = _step3.value;

                if (imgItem.refLinkType === 'link') {
                  imageLinks.push(imgItem.link);
                } else {
                  imageLinks.push(imgItem.imgUrl);
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            content.push({
              table: {
                widths: [160, 160, 160],
                body: [[{ text: 'Descriptions of scenes/ footage', style: 'tableHeader' }, { text: 'Include text overlays / voiceover script in each scene', style: 'tableHeader' }, { text: 'Reference links/images', style: 'tableHeader' }], [{
                  text: __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(boxItem.scenesInfo),
                  margin: [0, 5],
                  fontSize: 12,
                  style: 'tableTxt'
                }, {
                  text: __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(boxItem.briefText),
                  margin: [0, 5]
                }, { text: imageLinks.join(','), margin: [0, 5] }], [{
                  text: __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(boxItem.bodyInfo),
                  margin: [0, 5]
                }, {
                  text: __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(boxItem.briefPointer),
                  margin: [0, 5]
                }, {
                  text: '',
                  margin: [0, 5]
                }], [{
                  text: __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(boxItem.callToAction),
                  margin: [0, 5],
                  colSpan: 3
                }, {
                  text: '',
                  margin: [0, 5]
                }, {
                  text: '',
                  margin: [0, 5]
                }]]
              }
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      if (deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn') {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(deliItem.boxes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _boxItem = _step4.value;

            var _imageLinks = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_boxItem.images), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _imgItem = _step5.value;

                if (_imgItem.refLinkType === 'link') {
                  _imageLinks.push(_imgItem.link);
                } else {
                  _imageLinks.push(_imgItem.imgUrl);
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }

            var carouselItems = [[{ text: 'IMAGE', style: 'tableHeader' }, { text: 'Description of image/gif', style: 'tableHeader' }, { text: 'Text on image (if any)', style: 'tableHeader' }, { text: 'Reference image', style: 'tableHeader' }]];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(_boxItem.images)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _ref = _step6.value;

                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                var imgRowIndex = _ref2[0];
                var imgRow = _ref2[1];

                carouselItems.push([{
                  text: imgRowIndex + 1,
                  margin: [0, 5]
                }, {
                  text: imgRow.imgDescription ? __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(imgRow.imgDescription) : '',
                  margin: [0, 5]
                }, {
                  text: imgRow.textImage ? __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].formatTextBlocks(imgRow.textImage) : '',
                  margin: [0, 5]
                }, { text: _imageLinks.join(','), margin: [0, 5] }]);
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }

            content.push({
              table: {
                widths: [120, 120, 120, 120],
                body: carouselItems
              },
              layout: 'lightHorizontalLines'
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return document;
};

var contentConfig = function contentConfig() {
  return {
    footer: function footer(currentPage, pageCount) {
      return {
        margin: 10,
        columns: [{
          fontSize: 9,
          text: [{
            text: '--------------------------------------------------------------------------' + '\n',
            margin: [0, 20]
          }, {
            text: currentPage.toString() + ' of ' + pageCount
          }],
          alignment: 'center'
        }]
      };
    },
    content: [{
      image: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].kobeLogoDataURL,
      width: 60,
      style: 'logo',
      alignment: 'left'
    }],
    styles: {
      sectionTitle: {
        alignment: 'center',
        bold: true,
        fontSize: 20,
        marginTop: 0,

        marginBottom: 0,
        padding: 5
      },
      singleTitle: {
        fontSize: 13,
        marginBottom: 15,
        bold: true
      },
      image: {
        marginBottom: 15
      },
      header: {
        fontSize: 15,
        bold: true,
        marginBottom: 10,
        alignment: 'center'
      },
      middleHeader: {
        fontSize: 13,
        bold: true,
        marginTop: 5,
        marginBottom: 3
      },
      subheader: {
        fontSize: 12,
        marginBottom: 10
      },
      lastparagraph: {
        fontSize: 12,
        marginBottom: 15
      },
      footer: {
        alignment: 'center'
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: 'black'
      },
      tableTxt: {
        fontSize: 11
      },
      'html-h4': {
        fontSize: 11
      },
      tableTxtHighlight: {
        color: 'yellow'
      }
    },
    defaultStyle: {
      font: 'Arial'
    }
  };
};

var getTextBlocks = function getTextBlocks(text) {
  if (text !== undefined && text !== null) {
    var textP = text.replace(/\n/g, '<p>');

    textP = textP.split(/(<span[^>]*>.*?<\/span>|<p>|<\/p>|<[^>]+>)/).filter(Boolean);
    return textP;
  }
  return [];
};

var formatTextBlocks = function formatTextBlocks(text) {
  var fmtTxts = __WEBPACK_IMPORTED_MODULE_4__ContentPDFGenerator__["a" /* default */].getTextBlocks(text);
  var fmtTextRun = fmtTxts.map(function (part) {
    if (part.startsWith("<span")) {
      return {
        text: __WEBPACK_IMPORTED_MODULE_5_html_to_pdfmake___default()(part.replace(/<.*?>/g, '')),
        margin: [0, 5],
        fontSize: 9,
        style: 'tableTxtHighlight'
      };
    } else if (part.startsWith("<p>")) {
      return '';
    } else if (part.startsWith("</p>")) {
      return '';
    } else {
      return {
        text: __WEBPACK_IMPORTED_MODULE_5_html_to_pdfmake___default()(part),
        margin: [0, 5],
        fontSize: 9
      };
    }
  });
  fmtTextRun = fmtTextRun.filter(function (s) {
    return s !== '';
  });
  return fmtTextRun;
};
/* harmony default export */ __webpack_exports__["a"] = ({
  generatePDF: generatePDF,
  contentConfig: contentConfig,
  getTextBlocks: getTextBlocks,
  formatTextBlocks: formatTextBlocks
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    openEditItem: function openEditItem(item, itemName, dataSourceName) {
      item[itemName + 'Edit'] = true;
      item.editData = true;
      this.showEditActions = true;
      this[dataSourceName] = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].func.refreshJSON(this[dataSourceName]);
    },
    resetEditFields: function resetEditFields(records, fields) {
      this.showEditActions = false;
      records = records.map(function (record) {
        fields.map(function (fieldName) {
          record[fieldName + 'Edit'] = false;
        });
        record.editData = false;
        return record;
      });
      return records;
    }
  }
});

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(2189),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1358)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(2046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1369)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(2066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1500)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(2267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1499)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1019),
  /* template */
  __webpack_require__(2264),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1020),
  /* template */
  __webpack_require__(2083),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1023),
  /* template */
  __webpack_require__(2186),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1494)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1032),
  /* template */
  __webpack_require__(2258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1466)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1044),
  /* template */
  __webpack_require__(2208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1525)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1047),
  /* template */
  __webpack_require__(2291),
  /* scopeId */
  "data-v-d05a4ca6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1421)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1103),
  /* template */
  __webpack_require__(2146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1520)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1135),
  /* template */
  __webpack_require__(2287),
  /* scopeId */
  "data-v-c735a3c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1498)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1160),
  /* template */
  __webpack_require__(2263),
  /* scopeId */
  "data-v-adf2529e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTokenExpiration */
/* unused harmony export isTokenExpired */
/* harmony export (immutable) */ __webpack_exports__["b"] = expireSession;
/* harmony export (immutable) */ __webpack_exports__["a"] = watchSessionExpiry;
var MAX_TIMER_DELAY = 2147483647;

var expiryTimer = null;
var endingSession = false;

function getTokenExpiration(token) {
  if (!token || typeof token !== 'string') {
    return null;
  }

  var jwt = token.replace(/^Bearer\s+/i, '');
  var parts = jwt.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    var payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    var remainder = payload.length % 4;
    if (remainder) {
      payload += new Array(5 - remainder).join('=');
    }

    var decoded = JSON.parse(atob(payload));
    return typeof decoded.exp === 'number' && isFinite(decoded.exp) ? decoded.exp * 1000 : null;
  } catch (error) {
    return null;
  }
}

function isTokenExpired(token) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

  var expiresAt = getTokenExpiration(token);
  return expiresAt !== null && expiresAt <= now;
}

function expireSession(store) {
  if (endingSession || !store.state.token) {
    return;
  }

  endingSession = true;
  store.dispatch('LOG_OUT');
  window.location.replace('/login?redirect=session_ended');
}

function scheduleExpiryCheck(store) {
  if (expiryTimer) {
    window.clearTimeout(expiryTimer);
    expiryTimer = null;
  }

  var expiresAt = getTokenExpiration(store.state.token);
  if (expiresAt === null) {
    return;
  }

  var remaining = expiresAt - Date.now();
  if (remaining <= 0) {
    expireSession(store);
    return;
  }

  expiryTimer = window.setTimeout(function () {
    return scheduleExpiryCheck(store);
  }, Math.min(remaining, MAX_TIMER_DELAY));
}

function watchSessionExpiry(store) {
  var unsubscribe = store.subscribe(function (mutation) {
    if (mutation.type === 'SET_TOKEN' || mutation.type === 'REMOVE_TOKEN') {
      endingSession = false;
      scheduleExpiryCheck(store);
    }
  });

  var checkAfterInactivity = function checkAfterInactivity() {
    return scheduleExpiryCheck(store);
  };
  var checkWhenVisible = function checkWhenVisible() {
    if (!document.hidden) {
      scheduleExpiryCheck(store);
    }
  };

  window.addEventListener('focus', checkAfterInactivity);
  document.addEventListener('visibilitychange', checkWhenVisible);
  scheduleExpiryCheck(store);

  return function () {
    unsubscribe();
    window.removeEventListener('focus', checkAfterInactivity);
    document.removeEventListener('visibilitychange', checkWhenVisible);
    if (expiryTimer) {
      window.clearTimeout(expiryTimer);
      expiryTimer = null;
    }
  };
}

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(306);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Bar */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildAnalysisContext;
/* unused harmony export reportContentTypes */
/* unused harmony export buildTableAnalysisContext */
/* harmony export (immutable) */ __webpack_exports__["b"] = buildReportHtml;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_finite__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reportData__ = __webpack_require__(805);













var TIERS = [{ label: 'Tier 1 (250k and up)', from: 250000, to: null }, { label: 'Tier 2 (100k to 250k)', from: 100000, to: 250000 }, { label: 'Tier 3 (50k to 100k)', from: 50000, to: 100000 }, { label: 'Tier 4 (25k to 50k)', from: 25000, to: 50000 }, { label: 'Tier 5 (10k to 25k)', from: 10000, to: 25000 }, { label: 'Tier 6 (10k and below)', from: null, to: 10000 }];
var tierOf = function tierOf(v) {
  var num = numeric(v);
  return (TIERS.find(function (t) {
    if (t.from !== null && t.to !== null) return num > t.from && num <= t.to;
    if (t.from !== null) return num > t.from;
    if (t.to !== null) return num <= t.to;
    return false;
  }) || {}).label || '—';
};

function numeric(v) {
  if (v === null || v === undefined || v === '') return 0;
  if (typeof v === 'number') return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_finite___default()(v) ? v : 0;
  var x = Number(String(v).replace(/[,%s]/g, '').trim());
  return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_finite___default()(x) ? x : 0;
}
var esc = function esc(s) {
  return String(s === null || s === undefined ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
};
var has = function has(v) {
  return v !== null && v !== undefined && v !== '';
};
var compact = function compact(n) {
  var v = numeric(n);
  if (Math.abs(v) >= 1e6) return (v / 1e6).toFixed(v % 1e6 === 0 ? 0 : 1) + 'm';
  if (Math.abs(v) >= 1e3) return Math.round(v / 1e3) + 'k';
  return String(Math.round(v));
};
var ratio = function ratio(a, b) {
  return numeric(b) > 0 ? numeric(a) / numeric(b) * 100 : null;
};
var numCell = function numCell(v) {
  return has(v) && numeric(v) !== 0 ? compact(v) : has(v) ? '0' : '—';
};
var pctCell = function pctCell(v) {
  return has(v) ? numeric(v).toFixed(2) + '%' : '—';
};

var handleOf = function handleOf(p) {
  return p.name || p.instagram || p.influencer || 'unknown';
};
var cleanHandle = function cleanHandle(h) {
  return String(h || '').trim().replace(/^@/, '');
};
var profileUrl = function profileUrl(p) {
  var savedUrl = String(p.profileUrl || '').trim();
  if (/^https?:\/\//i.test(savedUrl)) return savedUrl;

  var handle = cleanHandle(p.profileHandle);
  if (!handle || handle === 'unknown') return null;
  var encodedHandle = encodeURIComponent(handle);
  switch (String(p.profilePlatform || '').toLowerCase()) {
    case 'tiktok':
      return 'https://tiktok.com/@' + encodedHandle;
    case 'youtube':
      return 'https://youtube.com/' + encodedHandle;
    case 'facebook':
      return 'https://facebook.com/' + encodedHandle;
    case 'linkedin':
      return 'https://www.linkedin.com/in/' + encodedHandle;
    case 'twitter':
      return 'https://x.com/' + encodedHandle;
    case 'xhs':
    case 'xiaohongshu':
      return 'https://xiaohongshu.com/user/profile/' + encodedHandle;
    case 'lemon':
    case 'lemon8':
      return 'https://lemon8-app.com/' + encodedHandle;
    case 'instagram':
      return 'https://instagram.com/' + encodedHandle;
    default:
      return null;
  }
};
var creatorLink = function creatorLink(p) {
  var handle = handleOf(p);
  var url = profileUrl(p);
  var label = '@' + esc(handle);
  return url ? '<a class="handle" href="' + esc(url) + '" target="_blank" rel="noopener">' + label + '</a>' : '<span class="handle">' + label + '</span>';
};
var linkCell = function linkCell(p) {
  return p.url ? '<a class="handle" href="' + esc(p.url) + '" target="_blank" rel="noopener">View \u2197</a>' : '—';
};

var TYPE_META = {
  'post/carousel': { status: 'postAnalysisStatus', enable: 'enablePostAnalysis' },
  reel: { status: 'reelAnalysisStatus', enable: 'enableReelAnalysis' },
  story: { status: 'storyAnalysisStatus', enable: null },
  gdrive: { status: 'storyAnalysisStatus', enable: null },
  tiktok: { status: 'tikTokAnalysisStatus', enable: 'enableTikTokAnalysis' },
  youtube: { status: 'youtubeAnalysisStatus', enable: 'enableYoutubeAnalysis' },
  facebook: { status: 'fbAnalysisStatus', enable: 'enableFbAnalysis' },
  linkedin: { status: 'linkedInAnalysisStatus', enable: 'enableLinkedInAnalysis' },
  twitter: { status: 'twitterAnalysisStatus', enable: 'enableTwitterAnalysis' },
  xhs: { status: 'xhsAnalysisStatus', enable: 'enableXHSAnalysis' },
  lemon: { status: 'lemonAnalysisStatus', enable: 'enableLemonAnalysis' }
};

var INFO_ICON = '<svg class="th-info" viewBox="0 0 16 16" width="11" height="11" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.4"/><rect x="7.25" y="6.6" width="1.5" height="4.6" rx="0.5" fill="currentColor"/><circle cx="8" cy="4.4" r="1" fill="currentColor"/></svg>';

var N = function N(field) {
  return { get: function get(p) {
      return numCell(p[field]);
    }, num: true };
};
var P = function P(field) {
  return { get: function get(p) {
      return pctCell(p[field]);
    }, num: true };
};
var COLUMN_DEFS = {
  liveDate: { label: 'Live Date', get: function get(p) {
      return esc(p.live_date || '—');
    }, tip: 'Date the content went live' },
  url: { label: 'Post URL', get: linkCell, tip: 'Link to the published content' },
  outreach: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Audience Size', tip: 'The number of followers the creator has at the time the post was made' }, N('outreach')),
  showReach: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Accounts Reached', tip: 'The total number of unique users who viewed the content' }, N('reach')),
  showImpressions: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Impressions', tip: "The total number of times the content is displayed on a user's feed" }, N('impressions')),
  likes: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Likes', tip: 'The number of times users have tapped the “like” button on a post' }, N('likes')),
  showStoryLikes: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Story Likes', tip: 'Likes on the story' }, N('story_likes')),
  comments: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Comments', tip: 'The number of written responses to a post' }, N('comments')),
  shares: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Shares', tip: 'The number of times users have reposted / shared a post' }, N('shares')),
  showShares: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Shares', tip: 'The number of times users have reposted / shared a post' }, N('shares')),
  showBookmarks: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Bookmarks', tip: 'The number of times users have saved a post to their “Saved” folder' }, N('saved')),
  showReplies: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Replies', tip: 'Replies to the story' }, N('replies')),
  showLinkClicks: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Link Clicks', tip: 'Number of taps on links in the story' }, N('link_clicks')),
  showStickerTaps: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Sticker Taps', tip: 'Number of taps on stickers in the story' }, N('sticker_taps')),
  showInteractions: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Interactions', tip: 'The sum of likes, comments, saves and shares' }, N('interactions')),
  showViews: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Plays', tip: 'The number of times the video was played' }, N('views')),
  showPlays: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Play Time', tip: 'Total play time' }, N('plays')),
  showWatches: { label: 'Avg Watch Time', tip: 'Average watch time per view', get: function get(p) {
      return has(p.watches) ? esc(p.watches) : '—';
    }, num: true },
  showEngagement: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'ER by Audience', tip: 'Engagement ÷ audience size' }, P('new_engagement_rate')),
  showNewEngagementRate: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'ER by Audience', tip: 'Engagement ÷ audience size' }, P('new_engagement_rate')),
  showEngagementView: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Play Rate', tip: 'Plays ÷ audience size' }, P('new_engagement_rate_view')),
  showInteractionPlays: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'ER by Plays', tip: 'Engagement ÷ plays' }, P('interaction_rate_plays')),
  showEngRateReach: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'ER by Reach', tip: 'Engagement ÷ accounts reached' }, P('engagement_rate_reach')),
  showEngRateTotalViewers: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'ER by Reach', tip: 'Engagement ÷ accounts reached' }, P('eng_rate_total_viewers')),
  showAvgEngagement: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg ER', tip: 'The creator’s average engagement rate' }, P('engagement_rate')),
  showMediaEngagement: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Median ER', tip: 'The creator’s median engagement rate' }, P('median_engagement_rate')),
  showAvgLikes: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Likes', tip: 'The creator’s average likes' }, N('avg_likes')),
  avgLikes: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Likes', tip: 'The creator’s average likes' }, N('avg_likes')),
  showAvgComments: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Comments', tip: 'The creator’s average comments' }, N('avg_comments')),
  avgComments: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Comments', tip: 'The creator’s average comments' }, N('avg_comments')),
  showAvgViews: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Views', tip: 'The creator’s average views' }, N('avg_views')),
  avgViews: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Views', tip: 'The creator’s average views' }, N('avg_views')),
  showAvgReelsPlays: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Reels Plays', tip: 'The creator’s average reels plays' }, N('avg_reels_plays')),
  avgShares: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Shares', tip: 'The creator’s average shares' }, N('avg_shares')),
  avgSaves: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({ label: 'Avg Saves', tip: 'The creator’s average saves' }, N('avg_saves'))
};
var DEFAULT_COLS = {
  'post/carousel': ['liveDate', 'url', 'outreach', 'showReach', 'likes', 'comments', 'showShares', 'showBookmarks', 'showEngagement'],
  reel: ['liveDate', 'url', 'outreach', 'showViews', 'likes', 'comments', 'showShares', 'showBookmarks', 'showInteractionPlays'],
  story: ['liveDate', 'outreach', 'showReach', 'showImpressions', 'showLinkClicks', 'showReplies', 'showShares', 'showInteractions'],
  gdrive: ['liveDate', 'outreach', 'showLinkClicks', 'showReplies', 'showShares', 'showInteractions'],
  tiktok: ['liveDate', 'url', 'outreach', 'showPlays', 'likes', 'comments', 'shares', 'showBookmarks', 'showInteractionPlays'],
  youtube: ['liveDate', 'url', 'outreach', 'showViews', 'likes', 'comments', 'showEngagement'],
  facebook: ['liveDate', 'url', 'outreach', 'likes', 'comments', 'showShares'],
  linkedin: ['liveDate', 'url', 'outreach', 'showImpressions', 'likes', 'comments', 'showShares', 'showBookmarks'],
  twitter: ['liveDate', 'url', 'outreach', 'likes', 'comments', 'showShares', 'showBookmarks', 'showViews'],
  xhs: ['liveDate', 'url', 'outreach', 'showViews', 'likes', 'comments', 'showShares'],
  lemon: ['liveDate', 'url', 'outreach', 'showViews', 'likes', 'comments', 'showShares']
};
function columnKeysFor(type, campaign) {
  var meta = TYPE_META[type] || TYPE_META['post/carousel'];
  var status = campaign[meta.status];
  if (status && (typeof status === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(status)) === 'object') {
    var keys = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(status).filter(function (k) {
      return status[k] && COLUMN_DEFS[k];
    });
    if (keys.length) return keys;
  }
  return DEFAULT_COLS[type] || DEFAULT_COLS['post/carousel'];
}
var typeEnabled = function typeEnabled(type, campaign) {
  var enable = (TYPE_META[type] || {}).enable;
  if (!enable) return true;
  var settings = campaign.settings || {};
  return settings[enable] !== false;
};

function computeAchieved(posts) {
  var outreach = 0;
  var engagement = 0;
  var impressions = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var p = _step.value;

      outreach += numeric(p.outreach);
      var t = p.type;
      if (t === 'story' || t === 'gdrive') {
        engagement += numeric(p.shares) + numeric(p.replies) + numeric(p.link_clicks) + numeric(p.sticker_taps);
        impressions += numeric(p.impressions);
      } else if (t === 'youtube') {
        engagement += numeric(p.likes) + numeric(p.comments);
        impressions += numeric(p.impressions);
      } else if (t === 'reel' || t === 'tiktok') {
        engagement += numeric(p.likes) + numeric(p.comments) + numeric(p.saved) + numeric(p.shares);
        impressions += numeric(p.impressions) + numeric(p.views);
      } else if (t === 'xhs' || t === 'lemon' || t === 'facebook' || t === 'others') {
        engagement += numeric(p.like_count) + numeric(p.comment_count) + numeric(p.bookmarks) + numeric(p.shares);
        impressions += numeric(p.impressions);
      } else {
        engagement += numeric(p.likes) + numeric(p.comments) + numeric(p.saved) + numeric(p.shares);
        impressions += numeric(p.impressions);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return { outreach: outreach, engagement: engagement, outreachImpressions: outreach + impressions };
}

function kpiRow(posts, campaign, totalContents, formats) {
  var achieved = computeAchieved(posts);
  var status = campaign.performanceAnalysisStatus || {};
  var show = function show(key) {
    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return status[key] === undefined ? def : !!status[key];
  };
  var kpis = [];
  if (show('contents')) kpis.push({ label: 'Contents', value: String(totalContents), sub: formats + ' formats' });
  if (show('outreachImpressions')) kpis.push({ label: 'Audience Size + Impressions', value: compact(achieved.outreachImpressions), sub: 'achieved' });
  if (show('outreach')) kpis.push({ label: 'Audience Size', value: compact(achieved.outreach), sub: 'achieved' });
  if (show('interactions')) kpis.push({ label: 'Interactions', value: compact(achieved.engagement), sub: 'achieved' });
  if (!kpis.length) return '';
  return '<div class="kpi-grid" style="grid-template-columns:repeat(' + kpis.length + ',1fr);">' + kpis.map(function (k) {
    return '<div class="kpi"><div class="kpi-label">' + esc(k.label) + '</div><div class="kpi-value">' + k.value + '</div><div class="kpi-sub">' + esc(k.sub) + '</div></div>';
  }).join('') + '</div>';
}

var AI_TABLE_KEY = {
  'post/carousel': 'post',
  reel: 'reel',
  story: 'story',
  gdrive: 'story',
  tiktok: 'tiktok',
  youtube: 'youtube',
  facebook: 'facebook',
  twitter: 'twitter',
  xhs: 'xhs',
  lemon: 'lemon',
  others: 'others'
};

function summaryTables(groups, campaign) {
  var i = 0;
  return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(groups.entries())).filter(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
        type = _ref2[0];

    return typeEnabled(type, campaign);
  }).map(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        type = _ref4[0],
        entry = _ref4[1];

    var cols = columnKeysFor(type, campaign).map(function (k) {
      return COLUMN_DEFS[k];
    });
    var head = '<th><span class="th-main">Creator</span><span class="th-sub">Handle \xB7 Tier</span></th>' + cols.map(function (c) {
      return '<th class="' + (c.num ? 'num-th' : '') + '" title="' + esc(c.tip || c.label) + '">' + esc(c.label) + INFO_ICON + '</th>';
    }).join('');
    var body = entry.posts.map(function (p) {
      var creator = '<td>' + creatorLink(p) + '<div class="th-sub">' + esc(tierOf(p.outreach)) + '</div></td>';
      return '<tr>' + creator + cols.map(function (c) {
        return '<td class="' + (c.num ? 'num' : '') + '">' + c.get(p) + '</td>';
      }).join('') + '</tr>';
    }).join('');
    i += 1;

    var tableAi = (campaign.AITableSummaries || {})[AI_TABLE_KEY[type] || type];
    return '\n  <section>\n    <div class="section-label">' + String(i).padStart(2, '0') + ' \xB7 ' + esc(entry.label) + ' Summary</div>\n    <h2>' + esc(entry.label) + ' <span class="accent">performance.</span></h2>\n    ' + (tableAi ? '<p class="table-ai">' + esc(tableAi) + '</p>' : '') + '\n    <div class="table-wrap">\n      <table><thead><tr>' + head + '</tr></thead><tbody>' + body + '</tbody></table>\n    </div>\n  </section>';
  }).join('');
}

function aggregateCreators(posts) {
  var by = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var p = _step2.value;

      var key = p.influencerID || handleOf(p);
      if (!by.has(key)) by.set(key, { handle: handleOf(p), contents: 0, outreach: 0, plays: 0, interactions: 0, reach: 0, saved: 0, shares: 0 });
      var c = by.get(key);
      c.contents += 1;
      c.outreach = Math.max(c.outreach, numeric(p.outreach));
      c.plays += numeric(p.views);
      c.interactions += numeric(p.interactions);
      c.reach += numeric(p.reach);
      c.saved += numeric(p.saved);
      c.shares += numeric(p.shares);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(by.values())).map(function (c) {
    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, c, {
      erReach: ratio(c.interactions, c.reach) !== null ? ratio(c.interactions, c.reach) : ratio(c.interactions, c.outreach),
      saveRate: c.plays > 0 ? ratio(c.saved, c.plays) : null,
      shareRate: c.plays > 0 ? ratio(c.shares, c.plays) : null
    });
  }).sort(function (a, b) {
    return (b.erReach || 0) - (a.erReach || 0);
  });
}

function aiSection(text) {
  if (!text || !String(text).trim()) return '';
  var lines = String(text).trim().split(/\r?\n/).map(function (l) {
    return l.trim();
  }).filter(Boolean);
  var lead = '';
  var rec = '';
  var bullets = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(lines), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var l = _step3.value;

      if (/^recommendation\s*:/i.test(l)) rec = l.replace(/^recommendation\s*:\s*/i, '');else if (/^[•\-*]\s+/.test(l)) bullets.push(l.replace(/^[•\-*]\s+/, ''));else if (!lead) lead = l;else bullets.push(l);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return '\n  <section class="ai-analysis">\n    <div class="section-label">AI Analysis</div>\n    <h2>What the <span class="accent">numbers say.</span></h2>\n    ' + (lead ? '<p class="ai-lead">' + esc(lead) + '</p>' : '') + '\n    ' + (bullets.length ? '<ul class="ai-bullets">' + bullets.map(function (b) {
    return '<li>' + esc(b) + '</li>';
  }).join('') + '</ul>' : '') + '\n    ' + (rec ? '<div class="ai-rec"><span>Recommendation</span>' + esc(rec) + '</div>' : '') + '\n  </section>';
}

function buildAnalysisContext(data) {
  var campaign = data.campaign_details || data.campaign || {};
  var summary = data.summary || {};
  var posts = orderPosts(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__reportData__["a" /* default */])(data.posts));
  var g = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var p = _step4.value;

      var t = p.title || p.type;
      if (!g.has(t)) g.set(t, { contents: 0, er: [], views: [], likes: [], comments: [], saves: [] });
      var x = g.get(t);
      x.contents += 1;
      if (p.new_engagement_rate) x.er.push(numeric(p.new_engagement_rate));
      x.views.push(numeric(p.views));
      x.likes.push(numeric(p.likes));
      x.comments.push(numeric(p.comments));
      x.saves.push(numeric(p.saved));
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  var avg = function avg(a) {
    return a.length ? Math.round(a.reduce(function (s, v) {
      return s + v;
    }, 0) / a.length * 100) / 100 : 0;
  };
  var byType = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(g.entries())).map(function (_ref5) {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
        type = _ref6[0],
        x = _ref6[1];

    return {
      type: type,
      contents: x.contents,
      avgEngagementRatePct: avg(x.er),
      avgPlays: Math.round(avg(x.views)),
      avgLikes: Math.round(avg(x.likes)),
      avgComments: Math.round(avg(x.comments)),
      avgSaves: Math.round(avg(x.saves))
    };
  });
  var creators = aggregateCreators(posts).map(function (c) {
    return {
      handle: c.handle,
      tier: tierOf(c.outreach),
      contents: c.contents,
      outreach: c.outreach,
      erByReachPct: c.erReach === null ? null : Math.round(c.erReach * 100) / 100,
      saveRatePct: c.saveRate === null ? null : Math.round(c.saveRate * 100) / 100
    };
  });
  return {
    campaign: campaign.name || 'Campaign',
    client: (data.client || {}).name || null,
    period: campaign.campaignPeriod || campaign.targetLocation || null,
    totalContents: posts.length,
    kpis: {
      totalOutreach: numeric(summary.outreach),
      totalEngagement: numeric(summary.engagement),
      campaignEngagementRatePct: numeric(summary.engagement_rate)
    },
    byType: byType,
    topCreators: creators.slice(0, 5),
    weakestCreators: creators.slice(-3).reverse()
  };
}

function reportContentTypes(data) {
  var posts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__reportData__["a" /* default */])(data.posts);
  var seen = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var p = _step5.value;

      var t = p.type || 'post/carousel';
      if (!seen.has(t)) seen.set(t, { type: t, label: p.title || t, contents: 0 });
      seen.get(t).contents += 1;
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(seen.values()));
}

function buildTableAnalysisContext(data, type) {
  var campaign = data.campaign_details || data.campaign || {};
  var rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__reportData__["a" /* default */])(data.posts).filter(function (p) {
    return (p.type || 'post/carousel') === type;
  }).map(function (p) {
    return Object.fromEntries(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()({
      creator: handleOf(p),
      liveDate: p.live_date,
      audienceSize: numeric(p.outreach),
      reach: numeric(p.reach) || undefined,
      impressions: numeric(p.impressions) || undefined,
      plays: numeric(p.views) || undefined,
      likes: p.likes !== undefined ? numeric(p.likes) : undefined,
      comments: p.comments !== undefined ? numeric(p.comments) : undefined,
      shares: numeric(p.shares) || undefined,
      saves: numeric(p.saved) || undefined,
      replies: numeric(p.replies) || undefined,
      linkClicks: numeric(p.link_clicks) || undefined,
      engagementRatePct: p.new_engagement_rate !== undefined ? numeric(p.new_engagement_rate) : undefined
    }).filter(function (_ref7) {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
          v = _ref8[1];

      return v !== undefined;
    }));
  });
  return {
    campaign: campaign.name || 'Campaign',
    contentType: type,
    contents: rows.length,
    rows: rows.slice(0, 60)
  };
}

function embedMarkup(p) {
  var url = p.url || '';
  var t = p.type;
  if (t === 'twitter' || /(?:x\.com|twitter\.com)\/.+\/status\//.test(url)) {
    var postId = (url.match(/\/status(?:es)?\/(\d+)/) || [])[1] || '';
    if (postId) return '<iframe class="social-embed twitter-embed" loading="lazy" src="https://platform.twitter.com/embed/Tweet.html?id=' + postId + '&theme=dark" title="X (Twitter) post" frameborder="0" scrolling="no"></iframe>';
  }
  if (t === 'facebook' || /(?:facebook\.com|fb\.watch)\//.test(url)) {
    var facebookUrl = encodeURIComponent(url);
    return '<iframe class="social-embed facebook-embed" loading="lazy" src="https://www.facebook.com/plugins/post.php?href=' + facebookUrl + '&show_text=true&width=500" title="Facebook post" width="500" height="560" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>';
  }
  if (t === 'linkedin' || /linkedin\.com\/(?:feed\/update|posts)\//.test(url)) {
    var decodedUrl = url;
    try {
      decodedUrl = decodeURIComponent(url);
    } catch (error) {
      decodedUrl = url;
    }
    var urnMatch = decodedUrl.match(/urn:li:(activity|share|ugcPost):(\d+)/i);
    var publicPostMatch = decodedUrl.match(/\/posts\/[^?#]*-(activity|share|ugcPost)-(\d+)(?:-[^/?#]+)?\/?(?:[?#]|$)/i);
    var postIdentifier = urnMatch || publicPostMatch;
    if (postIdentifier) {
      var urnType = postIdentifier[1].toLowerCase() === 'ugcpost' ? 'ugcPost' : postIdentifier[1].toLowerCase();
      return '<iframe class="social-embed linkedin-embed" loading="lazy" src="https://www.linkedin.com/embed/feed/update/urn:li:' + urnType + ':' + postIdentifier[2] + '" title="LinkedIn post" frameborder="0" allowfullscreen="true"></iframe>';
    }
    return '<a class="embed-fallback" href="' + esc(url) + '" target="_blank" rel="noopener"><span>LinkedIn post</span><b>View on LinkedIn \u2197</b></a>';
  }
  if (t === 'tiktok' || /tiktok\.com/.test(url)) {
    var vid = (url.match(/video\/(\d+)/) || [])[1] || '';
    return '<blockquote class="tiktok-embed" cite="' + esc(url) + '" data-video-id="' + vid + '" style="max-width:100%;min-width:280px;margin:0;"><section></section></blockquote>';
  }
  if (t === 'youtube' || /youtube|youtu\.be/.test(url)) {
    var _vid = (url.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([\w-]{11})/) || [])[1] || '';
    if (_vid) return '<div class="embed-yt"><iframe loading="lazy" src="https://www.youtube.com/embed/' + _vid + '" allowfullscreen></iframe></div>';
  }
  if ((t === 'post/carousel' || t === 'reel') && /instagram\.com/.test(url)) {
    return '<blockquote class="instagram-media" data-instgrm-permalink="' + esc(url) + '" data-instgrm-version="14" style="max-width:100%;min-width:260px;margin:0;"></blockquote>';
  }

  var link = p.xhsLink || p.lemonLink || p.postLink || '';
  if (url && /^https?:\/\//.test(url)) {
    var media = p.media_type === 'video' ? '<video class="content-media" src="' + esc(url) + '" controls playsinline preload="metadata"></video>' : '<img class="content-media" src="' + esc(url) + '" alt="' + esc(handleOf(p)) + '" loading="lazy" />';
    return link ? '<a href="' + esc(link) + '" target="_blank" rel="noopener">' + media + '</a>' : media;
  }
  return '<div class="content-media placeholder">' + esc(p.title || 'Content') + '</div>';
}
var STAT_ROWS = [['Audience', function (p) {
  return compact(p.outreach);
}], ['Reach', function (p) {
  return has(p.reach) && numeric(p.reach) ? compact(p.reach) : '—';
}], ['Plays', function (p) {
  return has(p.views) && numeric(p.views) ? compact(p.views) : '—';
}], ['Likes', function (p) {
  return numCell(p.likes != null ? p.likes : p.story_likes);
}], ['Comments', function (p) {
  return numCell(p.comments);
}], ['Shares', function (p) {
  return numCell(p.shares);
}], ['Saves', function (p) {
  return numCell(p.saved);
}], ['ER', function (p) {
  return pctCell(p.new_engagement_rate != null ? p.new_engagement_rate : p.engagement_rate);
}]];
function contentCard(p) {
  var stats = STAT_ROWS.map(function (_ref9) {
    var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
        label = _ref10[0],
        get = _ref10[1];

    return '<div class="cs-row"><span>' + esc(label) + '</span><b>' + get(p) + '</b></div>';
  }).join('');
  return '\n      <div class="content-card" data-type="' + esc(p.type) + '" data-handle="' + esc(String(handleOf(p)).toLowerCase()) + '">\n        <div class="content-embed">' + embedMarkup(p) + '</div>\n        <div class="content-meta">\n          ' + creatorLink(p) + '\n          <span class="content-type-tag">' + esc(p.title || p.type) + '</span>\n        </div>\n        <button class="stats-toggle" type="button">Show stats \u25BE</button>\n        <div class="content-stats" hidden>' + stats + '</div>\n      </div>';
}
function contentSection(posts, groups) {
  var cards = posts.filter(function (p) {
    return p.url;
  }).map(contentCard);
  if (!cards.length) return '';
  var chips = '<button class="filter-chip active" data-type="all" type="button">All (' + posts.filter(function (p) {
    return p.url;
  }).length + ')</button>' + [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(groups.entries())).map(function (_ref11) {
    var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
        type = _ref12[0],
        entry = _ref12[1];

    var count = entry.posts.filter(function (p) {
      return p.url;
    }).length;
    return count ? '<button class="filter-chip" data-type="' + esc(type) + '" type="button">' + esc(entry.label) + ' (' + count + ')</button>' : '';
  }).join('');
  return '\n  <section>\n    <div class="section-label">Embedded Content</div>\n    <h2>The content, <span class="accent">in the feed.</span></h2>\n    <p class="section-lede">Filter by format, search a creator handle, and click any post to reveal its stats.</p>\n    <div class="filter-bar">' + chips + '\n      <input id="handleSearch" class="handle-search" type="search" placeholder="Search by handle\u2026" autocomplete="off" />\n    </div>\n    <div class="content-carousel">' + cards.join('') + '</div>\n    <div class="no-content-match" id="noContentMatch" hidden>No content matches that handle.</div>\n  </section>';
}

var EXTRA_CSS = '\n  .table-wrap { overflow-x:auto; }\n  table td.num, table th.num-th { text-align:right; white-space:nowrap; }\n  .th-info { margin-left:5px; color:var(--text-muted); vertical-align:middle; cursor:help; }\n  th[title]:hover .th-info { color:var(--green); }\n  .content-media[controls] { background:#000; }\n  .ai-lead { font-size:20px; color:var(--text); max-width:840px; margin-bottom:24px; line-height:1.5; }\n  .ai-bullets { list-style:none; max-width:840px; margin-bottom:24px; }\n  .ai-bullets li { position:relative; padding-left:24px; margin-bottom:12px; color:var(--text-dim); line-height:1.55; }\n  .ai-bullets li::before { content:\'\u25B8\'; position:absolute; left:0; color:var(--green); }\n  .ai-rec { border-left:2px solid var(--green); padding:14px 20px; background:var(--bg-card); max-width:840px; color:var(--text); line-height:1.5; }\n  .ai-rec span { display:block; font-family:\'JetBrains Mono\',monospace; font-size:10px; text-transform:uppercase; letter-spacing:1.5px; color:var(--green); margin-bottom:6px; }\n  .table-ai { max-width:840px; margin-bottom:24px; color:var(--text-dim); line-height:1.6; border-left:2px solid var(--green); padding:10px 16px; background:var(--bg-card); }\n  .handle-search { margin-left:auto; min-width:220px; background:var(--bg-card); border:1px solid var(--border); color:var(--text); font-family:\'JetBrains Mono\',monospace; font-size:12px; padding:8px 14px; outline:none; }\n  .handle-search:focus { border-color:var(--green); }\n  .handle-search::placeholder { color:var(--text-muted); }\n  .no-content-match { padding:32px 0; color:var(--text-muted); font-family:\'JetBrains Mono\',monospace; font-size:12px; text-transform:uppercase; letter-spacing:1px; }\n  .handle { color: var(--green); font-family:\'JetBrains Mono\',monospace; text-decoration:none; }\n  .filter-bar { display:flex; flex-wrap:wrap; gap:10px; margin-bottom:28px; }\n  .filter-chip { background:var(--bg-card); border:1px solid var(--border); color:var(--text-dim); font-family:\'JetBrains Mono\',monospace; font-size:11px; text-transform:uppercase; letter-spacing:1px; padding:8px 16px; cursor:pointer; transition:all .15s; }\n  .filter-chip:hover { border-color:var(--green); color:var(--text); }\n  .filter-chip.active { background:var(--green); border-color:var(--green); color:#0A0A0A; font-weight:700; }\n  .content-carousel { display:flex; gap:20px; overflow-x:auto; padding-bottom:20px; scroll-snap-type:x mandatory; }\n  .content-card { flex:0 0 330px; scroll-snap-align:start; background:var(--bg-card); border:1px solid var(--border); display:flex; flex-direction:column; }\n  .content-card:hover { border-color:var(--border-strong); }\n  .content-embed { min-height:120px; background:var(--bg-elev); display:flex; justify-content:center; align-items:flex-start; overflow:hidden; }\n  .content-media { width:100%; height:auto; display:block; max-height:520px; object-fit:cover; }\n  .content-media.placeholder { min-height:280px; display:flex; align-items:center; justify-content:center; color:var(--text-muted); font-family:\'Rubik\',sans-serif; font-weight:700; }\n  .embed-yt { position:relative; width:100%; padding-bottom:120%; height:0; }\n  .embed-yt iframe { position:absolute; inset:0; width:100%; height:100%; }\n  .social-embed { display:block; width:100%; border:0; background:transparent; }\n  .twitter-embed { height:550px; background:#000; }\n  .facebook-embed { height:560px; background:#fff; }\n  .linkedin-embed { min-height:480px; background:#fff; }\n  .embed-fallback { width:100%; min-height:220px; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px; padding:24px; background:#fff; color:#0A66C2; text-decoration:none; font-family:\'Rubik\',sans-serif; text-align:center; }\n  .embed-fallback span { color:#566070; font-size:13px; }\n  .embed-fallback b { font-size:14px; }\n  .content-meta { display:flex; justify-content:space-between; align-items:center; gap:8px; padding:14px 16px 0; }\n  .content-type-tag { font-family:\'JetBrains Mono\',monospace; font-size:10px; text-transform:uppercase; color:var(--text-muted); }\n  .stats-toggle { margin:12px 16px; background:transparent; border:1px solid var(--border-strong); color:var(--green); font-family:\'JetBrains Mono\',monospace; font-size:11px; text-transform:uppercase; letter-spacing:1px; padding:8px; cursor:pointer; }\n  .stats-toggle:hover { background:var(--green); color:#0A0A0A; }\n  .content-stats { border-top:1px solid var(--border); padding:4px 16px 16px; }\n  .content-stats[hidden] { display:none; }\n  .cs-row { display:flex; justify-content:space-between; padding:7px 0; border-bottom:1px solid var(--border); font-size:13px; }\n  .cs-row span { color:var(--text-dim); font-family:\'JetBrains Mono\',monospace; font-size:11px; text-transform:uppercase; }\n  .cs-row b { color:var(--text); font-family:\'Rubik\',sans-serif; }\n  .instagram-media, .tiktok-embed { margin:0 !important; }\n';

var CAROUSEL_JS = '\n<script>\n(function(){\n  function ready(fn){ if(document.readyState!==\'loading\'){fn();}else{document.addEventListener(\'DOMContentLoaded\',fn);} }\n  ready(function(){\n    var activeType = \'all\';\n    var searchTerm = \'\';\n    function applyContentFilters(){\n      var anyVisible = false;\n      document.querySelectorAll(\'.content-card\').forEach(function(card){\n        var typeOk = (activeType===\'all\' || card.getAttribute(\'data-type\')===activeType);\n        var handleOk = !searchTerm || (card.getAttribute(\'data-handle\')||\'\').indexOf(searchTerm) !== -1;\n        var show = typeOk && handleOk;\n        card.style.display = show ? \'\' : \'none\';\n        if (show) anyVisible = true;\n      });\n      var empty = document.getElementById(\'noContentMatch\');\n      if (empty) { if (anyVisible) empty.setAttribute(\'hidden\',\'\'); else empty.removeAttribute(\'hidden\'); }\n    }\n    document.querySelectorAll(\'.filter-chip\').forEach(function(chip){\n      chip.addEventListener(\'click\', function(){\n        activeType = chip.getAttribute(\'data-type\');\n        document.querySelectorAll(\'.filter-chip\').forEach(function(c){ c.classList.toggle(\'active\', c===chip); });\n        applyContentFilters();\n      });\n    });\n    var search = document.getElementById(\'handleSearch\');\n    if (search) {\n      search.addEventListener(\'input\', function(){\n        searchTerm = String(search.value||\'\').trim().toLowerCase().replace(/^@/,\'\');\n        applyContentFilters();\n      });\n    }\n    document.querySelectorAll(\'.stats-toggle\').forEach(function(btn){\n      btn.addEventListener(\'click\', function(){\n        var panel = btn.nextElementSibling;\n        if(!panel) return;\n        var hidden = panel.hasAttribute(\'hidden\');\n        if(hidden){ panel.removeAttribute(\'hidden\'); btn.textContent=\'Hide stats \u25B4\'; }\n        else { panel.setAttribute(\'hidden\',\'\'); btn.textContent=\'Show stats \u25BE\'; }\n      });\n    });\n  });\n})();\n</script>';

var orderPosts = function orderPosts(posts) {
  return posts.map(function (p, idx) {
    return { p: p, idx: idx };
  }).sort(function (a, b) {
    var ai = has(a.p.lineUpIndex) ? numeric(a.p.lineUpIndex) : a.idx;
    var bi = has(b.p.lineUpIndex) ? numeric(b.p.lineUpIndex) : b.idx;
    return ai - bi;
  }).map(function (x) {
    return x.p;
  });
};

function buildReportHtml(data) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var campaign = data.campaign_details || data.campaign || {};
  var summary = data.summary || {};
  var client = data.client || campaign.client || {};

  var posts = orderPosts(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__reportData__["a" /* default */])(data.posts));

  var groups = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var p = _step6.value;

      var type = p.type || 'post/carousel';
      if (!groups.has(type)) groups.set(type, { label: p.title || type, posts: [] });
      groups.get(type).posts.push(p);
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  var totalContents = posts.length;
  var period = campaign.campaignPeriod || campaign.targetLocation || '';
  var title = (campaign.name || 'Campaign') + ' \xB7 Kob\u0113 Report';

  return '<!DOCTYPE html>\n<html lang="en"><head>\n<meta charset="UTF-8" /><meta name="viewport" content="width=device-width, initial-scale=1.0" />\n<meta name="robots" content="noindex, nofollow" />\n<title>' + esc(title) + '</title>\n<link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>\n<link href="https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700;800;900&family=Open+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;700&display=swap" rel="stylesheet">\n<style>' + __WEBPACK_IMPORTED_MODULE_9__style__["a" /* default */] + EXTRA_CSS + '</style>\n</head><body>\n<header class="topbar">\n  <div class="logo">' + esc(client.name || 'Kobē') + ' \xB7 Campaign Report</div>\n  <div class="topbar-meta"><span>' + esc(period) + '</span><span class="badge">Kob\u0113</span></div>\n</header>\n<div class="container">\n  <div class="hero">\n    <div class="section-label">Influencer Campaign Report</div>\n    <h1>' + esc(campaign.name || 'Campaign') + '<br><span class="accent">performance review.</span></h1>\n    <p class="subtitle">' + totalContents + ' pieces of content across ' + groups.size + ' format' + (groups.size === 1 ? '' : 's') + '. ' + compact(summary.outreach) + ' total outreach. Summary tables and live content below.</p>\n  </div>\n  ' + kpiRow(posts, campaign, totalContents, groups.size) + '\n  ' + aiSection(opts.aiAnalysis) + '\n  ' + summaryTables(groups, campaign) + '\n  ' + contentSection(posts, groups) + '\n</div>\n<footer><div class="footer-logo">' + esc(title) + '</div><div class="footer-tag">All rights reserved. Copyright \xA9 2016-2026 Kobe Global Technologies Pte Ltd.</div></footer>\n<script async src="//www.instagram.com/embed.js"></script>\n<script async src="https://www.tiktok.com/embed.js"></script>\n' + CAROUSEL_JS + '\n</body></html>';
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tableHeaders = [{
  text: 'Campaign Name',
  value: 'name'
}, {
  text: 'AM',
  value: 'AM'
}, {
  text: 'CC',
  value: 'CC'
}, {
  text: 'Date of Review',
  value: 'reviewMeetingDate'
}, {
  text: 'Stats and Sentiment Due Date',
  value: 'sentimentDueDate'
}, {
  text: 'Completed by CC',
  value: 'ccDeckReadyDate'
}, {
  text: 'Completed by AM',
  value: 'amDeckReadyDate'
}, {
  text: 'Alignment Sync',
  value: 'overallAlignmentDate'
}, {
  text: 'Approved by Admin',
  value: 'approvedByAdmin'
}, {
  text: 'Feedback Form',
  value: 'feedback'
}];

var reviewMeetingChecklists = {
  completedByCC: {
    html: '\n      <ol class="text-left body-1">\n        <li>Analysis of influencer sentiments and feedback</li>\n        <li>Analysis of audience sentiments</li>\n        <li>Lineup quality and rationale</li>\n        <li>Draft Quality</li>\n        <li>Timeline Management</li>\n        <li>Numbers for this campaign vs other paid campaigns</li>\n        <li>Other scenarios that should be addressed</li>\n      </ol>\n    '
  },
  completedByAM: {
    html: '\n      <ol class="text-left body-1">\n        <li>Overall content strategy alignment</li>\n        <li>Overall creator strategy alignment</li>\n        <li>Numbers for this campaign vs Other campaigns</li>\n        <li>Content Format Analysis</li>\n        <li>Timeline Management</li>\n        <li>Client Management</li>\n        <li>Any crisis</li>\n        <li>Clear Next steps Prescribed </li>\n      </ol>\n    '
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  tableHeaders: tableHeaders,
  reviewMeetingChecklists: reviewMeetingChecklists
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);



var dd = {
	header: {
		margin: [0, 10, 20, 40],
		text: 'Date: ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now()).format('DD/MM/YYYY'),
		alignment: 'right',
		style: 'smallText'
	},
	footer: {
		margin: [0, 10, 0, 10],
		text: 'www.getkobe.com',
		alignment: 'center',
		style: 'smallText'
	},
	content: [{
		image: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].kobeLogoDataURL,
		width: 160,
		alignment: 'center'
	}, { alignment: 'justify',
		margin: [0, 20, 0, 0],
		columns: [[{ text: 'Kobe Global Technologies Pte Ltd.' }, { text: 'GST Registration no. 201608755R' }, { text: '51 Goldhill Plaza' }, { text: '#14-01' }, { text: 'Singapore 308900' }, { text: 'finance@getkobe.com' }], []]

	}, {
		margin: [0, 20, 0, 0],
		table: {
			widths: ['100%'],
			body: [[{ text: 'Content Creator Details', style: 'tableHeader', alignment: 'left' }], [{ text: 'Instagram Handle: @XXX', border: [true, true, true, true] }]]
		}
	}, {
		margin: [0, 20, 0, 0],
		table: {
			widths: ['100%'],

			body: [[{ text: 'Company Rep Details', style: 'tableHeader', alignment: 'left' }], [{ text: 'Kobe Global Technologies Pte Ltd.', bold: true, border: [true, true, true, false] }], [{ text: '(+65) 6255 5662', border: [true, false, true, false] }], [{ text: 'finance@getkobe.com', border: [true, false, true, true] }]]
		}
	}, {
		margin: [0, 20, 0, 0],
		table: {
			widths: ['100%'],
			body: [[{ text: 'Campaign Details', style: 'tableHeader', alignment: 'left' }], [{ text: 'Campaign Name-QuarterYear-COUNTRY', bold: true, border: [true, true, true, false] }], [{ text: 'Campaign Ref: XXX', border: [true, false, true, true] }]]
		}
	}, {
		margin: [0, 20, 0, 0],
		table: {
			headerRows: 1,
			widths: ['70%', '10%', '20%'],
			body: [[{ text: 'DESCRIPTION', style: 'tableHeader', alignment: 'center' }, { text: 'QTY', style: 'tableHeader', alignment: 'center' }, { text: 'AMOUNT', style: 'tableHeader', alignment: 'center' }], [{ text: 'Agreed Deliverables eg. IG REELS / TikTok Video / Youtube Shorts' }, { text: 'XX', alignment: 'center' }, { text: 'SGD XXX', alignment: 'center' }]]
		}
	}, { margin: [0, 40, 0, 0],
		text: 'Terms and Conditions',
		fontSize: 18
	}, {
		margin: [0, 10, 0, 0],
		fontSize: 10,
		ol: ['I have read and accepted the terms of use (https://www.getkobe.com/influencer-terms-use-agreement/)', 'I have read and understood supporting campaign details that accompany this brief.', 'I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.', 'I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.', 'I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.', 'Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance, I may forfeit my rate or be deducted a penalty by the client.', 'I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.', 'I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.', 'I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.', 'If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.', 'The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.']
	}],
	styles: {
		header: {
			fontSize: 18,
			bold: true,
			margin: [0, 0, 0, 10]
		},
		subheader: {
			fontSize: 16,
			bold: true,
			margin: [0, 10, 0, 5]
		},
		tableExample: {
			margin: [0, 5, 0, 15]
		},
		tableHeader: {
			bold: true,
			fontSize: 13,
			color: 'white',
			fillColor: '#3F3FFF'
		},
		smallText: {
			fontSize: 9
		}
	},
	defaultStyle: {
		font: 'Arial'
	}

};

/* harmony default export */ __webpack_exports__["a"] = (dd);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);




/* harmony default export */ __webpack_exports__["a"] = ({
  getOverviewReportData: function getOverviewReportData(filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/campaigns/spend/overview-report?limit=999&' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCOGSPerCampaign: function getCOGSPerCampaign(filters) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
        return key + '=' + filters[key];
      }).join('&');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', '/api/v1/campaigns/spend/cogsPerCampaign?limit=999&' + params, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var getRanges = function getRanges(from, to) {
  var range = {};
  if (from) {
    range.from = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(from));
  }
  if (to) {
    range.to = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(to));
  }
  return range;
};
var engCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
var engOptions = getRanges(engCount, engCount);

var followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
var followerOptions = getRanges(followersCount, followersCount);

var engRatePercentageCount = [];
for (var i = 0; i < 20; i++) {
  engRatePercentageCount.push('>= ' + i + '.0 %');
}
var engRatePercentageOptions = getRanges(engRatePercentageCount, false);
var percentOptions = ['≥1%', '≥5%', '≥10%', '≥15%', '≥20%', '≥25%', '≥30%', '≥35%', '≥40%', '≥45%', '≥50%', '≥55%', '≥60%', '≥65%', '≥70%', '≥75%', '≥80%', '≥85%', '≥90%', '≥95%'];
var searchSettings = {
  relevantKeywords: 0,
  distance: 0,
  frequency: 0,
  influencerGeos: ['Singapore'],
  audGeos: ['Singapore'],
  audGeoPercent: '≥5%',
  infGender: 'KNOWN',
  audGender: '',
  audGenderPercent: '',
  followers: { from: '1K', to: '' },
  engagements: { from: '', to: '' },
  engagementRate: { from: '' },
  bio: '',
  keywords: '',
  mentions: [],
  hashtags: []
};

var localTableHeaders = [{
  value: 'handle',
  text: 'Handle'
}, {
  value: 'fullName',
  text: 'Full Name'
}, {
  value: 'tags',
  text: 'Tags',
  sortable: false
}, {
  value: 'totalFollowers',
  text: 'Followers'
}, {
  value: 'engagementRate',
  text: 'Engagement Rate',
  width: '60px'
}, {
  text: 'Avg Likes',
  value: 'avgLikes'
}, {
  text: 'Avg Views',
  value: 'avgViews'
}, {
  text: 'Avg Cmt.',
  value: 'avgComments'
}, {
  text: 'Avg Reel Plays',
  value: 'avgReelPlays'
}, {
  value: 'action',
  text: 'Actions',
  sortable: false
}];

var iqDataTableHeaders = [{
  value: 'handle',
  text: 'Handle'
}, {
  value: 'fullName',
  text: 'Full Name'
}, {
  value: 'totalFollowers',
  text: 'Followers'
}, {
  value: 'engagementRate',
  text: 'Engagement Rate',
  width: '60px'
}, {
  value: 'engagements',
  text: 'Engagements',
  width: '60px'
}];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  followerOptions: followerOptions,
  engOptions: engOptions,
  engRatePercentageOptions: engRatePercentageOptions,
  percentOptions: percentOptions,
  searchSettings: searchSettings,
  localTableHeaders: localTableHeaders,
  iqDataTableHeaders: iqDataTableHeaders
}));

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateDocument */
/* unused harmony export formatDate */
/* unused harmony export getTextBlocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_docx__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_docx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_docx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);







var generateDocument = function generateDocument(creatorConceptData) {
  var spaceHund = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: ''
    })],
    spacing: {
      after: 0 }
  });

  var pageTitle = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    alignment: 'center',
    spacing: {
      after: 200 },
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: "Content Storyboard Flow",
      font: "Calibri",
      size: 30,
      bold: true
    })]
  });

  var campaignName = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: 'Campaign Name: ',
      bold: true,
      size: 25,
      font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: creatorConceptData.campaignName,
      bold: true,
      size: 25,
      font: "Calibri" })],
    spacing: {
      after: 100 }
  });

  var handle = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: 'Creator Handle: ',
      bold: true,
      size: 25,
      font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: creatorConceptData.creatorHandle,
      bold: true,
      size: 25,
      font: "Calibri" })],
    spacing: {
      after: 100 }
  });

  var submissionDate = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: 'Draft Submission Date: ',
      bold: true,
      size: 25,
      font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: creatorConceptData.submissionDate,
      bold: true,
      size: 25,
      font: "Calibri" })],
    spacing: {
      after: 200 }
  });
  var deliDetails = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: 'Deliverable Details: ',
      bold: true,
      size: 25,
      font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: creatorConceptData.submissionDate,
      bold: true,
      size: 25,
      font: "Calibri" })],
    spacing: {
      after: 200 }
  });
  var children = [pageTitle, campaignName, handle, submissionDate, deliDetails];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(creatorConceptData.deliverables), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var deliItem = _step.value;

      var concept = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
        children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
          text: 'Concept: ',
          bold: true,
          size: 25,
          font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
          text: deliItem.concept || '-',
          bold: true,
          size: 25,
          font: "Calibri" })],
        spacing: {
          after: 100 }
      });
      var reasonConcept = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
        children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
          text: 'Reason for concept: ',
          bold: true,
          size: 25,
          font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
          text: deliItem.reasonConcept || '-',
          bold: true,
          size: 25,
          font: "Calibri" })],
        spacing: {
          after: 100 }
      });
      var musicChoice = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
        children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
          text: 'Music choice: ',
          bold: true,
          size: 25,
          font: "Calibri" }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
          text: deliItem.musicChoice || '-',
          bold: true,
          size: 25,
          font: "Calibri" })],
        spacing: {
          after: 100 }
      });
      children.push(concept);
      children.push(reasonConcept);
      children.push(musicChoice);

      var deliTableTitle = new __WEBPACK_IMPORTED_MODULE_3_docx__["Table"]({
        rows: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
          children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
            children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
              children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: deliItem.title,
                bold: true,
                size: 27,
                font: "Calibri" })],
              spacing: {
                before: 100,
                after: 100
              },
              indent: {
                left: 100,
                top: 240 },
              alignment: 'left' })],
            shading: {
              fill: 'F4F4F4' },
            width: {
              size: 10000,
              type: __WEBPACK_IMPORTED_MODULE_3_docx__["WidthType"].DXA
            },
            borders: {
              top: { style: undefined },
              bottom: { style: undefined },
              left: { style: undefined },
              right: { style: undefined }
            }
          })],
          width: {
            size: 10000,
            type: __WEBPACK_IMPORTED_MODULE_3_docx__["WidthType"].DXA
          }
        })]
      });
      children.push(deliTableTitle);
      children.push(spaceHund);
      if (deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn') {
        var _loop = function _loop(boxItem) {
          var imageLinks = [];
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(boxItem.images), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var imgItem = _step3.value;

              if (imgItem.refLinkType === 'link') {
                imageLinks.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: imgItem.link,
                  size: 20,
                  font: "Calibri"
                }));
              } else {
                imageLinks.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: imgItem.imgUrl,
                  size: 20,
                  font: "Calibri"
                }));
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          var sceneInfoTxts = __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__["a" /* default */].getTextBlocks(boxItem.scenesInfo);
          var scenceInfoTextRun = sceneInfoTxts.map(function (part) {
            if (part.startsWith("<span")) {
              return new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part.replace(/<.*?>/g, ''),
                color: "FFFF00",
                bold: false,
                font: "Calibri" });
            } else if (part.startsWith("<p>")) {} else if (part.startsWith("</p>")) {
              return new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]('');
            } else {
              return new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part,
                bold: false,
                font: "Calibri" });
            }
          });
          var briefTxts = __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__["a" /* default */].getTextBlocks(boxItem.briefText);
          var briefTextRun = briefTxts.map(function (part) {
            if (part.startsWith("<span")) {
              return new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part.replace(/<.*?>/g, ''),
                color: "FFFF00",
                bold: false,
                font: "Calibri" });
            } else if (part.startsWith("<p>")) {} else if (part.startsWith("</p>")) {
              return new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]('');
            } else {
              return new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part,
                bold: false,
                font: "Calibri" });
            }
          });
          var bodyInfoTxts = __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__["a" /* default */].getTextBlocks(boxItem.bodyInfo);
          var bodyInfoPara = [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
            children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
              text: 'BODY',
              bold: true,
              size: 22,
              font: "Calibri" })],
            spacing: {
              before: 50,
              after: 100
            },
            indent: {
              left: 50,
              right: 50 },
            alignment: 'left' })];
          bodyInfoTxts.map(function (part) {
            if (part.startsWith("<span")) {
              var bodyInfoParaLength = bodyInfoPara.length;
              bodyInfoPara[bodyInfoParaLength - 1].root.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part.replace(/<.*?>/g, ''),
                color: "FFFF00",
                bold: false,
                font: "Calibri" }));
            } else if (part.startsWith("<p>")) {
              bodyInfoPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: part.replace(/<.*?>/g, ''),
                  size: 20,
                  font: "Calibri" })],
                spacing: {
                  before: 50,
                  after: 100
                },
                indent: {
                  left: 50,
                  right: 50 },
                alignment: 'left' }));
            } else if (part.startsWith("</p>")) {
              bodyInfoPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"](''));
            } else {
              bodyInfoPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: part.replace(/<.*?>/g, ''),
                  size: 20,
                  font: "Calibri" })],
                spacing: {
                  before: 50,
                  after: 100
                },
                indent: {
                  left: 50,
                  right: 50 },
                alignment: 'left' }));
            }
          });
          var briefPointerTxts = __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__["a" /* default */].getTextBlocks(boxItem.briefPointer);
          var briefPointerPara = [];
          briefPointerTxts.map(function (part) {
            if (part.startsWith("<span")) {
              var briefPointerParaLength = briefPointerPara.length;
              briefPointerPara[briefPointerParaLength - 1].root.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part.replace(/<.*?>/g, ''),
                color: "FFFF00",
                bold: false,
                font: "Calibri" }));
            } else if (part.startsWith("<p>")) {
              briefPointerPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: part.replace(/<.*?>/g, ''),
                  size: 20,
                  font: "Calibri" })],
                spacing: {
                  before: 50,
                  after: 100
                },
                indent: {
                  left: 50,
                  right: 50 },
                alignment: 'left' }));
            } else if (part.startsWith("</p>")) {
              briefPointerPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"](''));
            } else {
              briefPointerPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: part.replace(/<.*?>/g, ''),
                  size: 20,
                  font: "Calibri" })],
                spacing: {
                  before: 50,
                  after: 100
                },
                indent: {
                  left: 50,
                  right: 50 },
                alignment: 'left' }));
            }
          });
          var callToActionTxts = __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__["a" /* default */].getTextBlocks(boxItem.callToAction);
          var callToActionPara = [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
            children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
              text: 'CTA (input your final CTA scene, not caption)',
              size: 22,
              bold: true,
              font: "Calibri" })],
            spacing: { after: 200 } })];
          callToActionTxts.map(function (part) {
            if (part.startsWith("<span")) {
              var callToActionParaLength = callToActionPara.length;
              callToActionPara[callToActionParaLength - 1].root.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                text: part.replace(/<.*?>/g, ''),
                color: "FFFF00",
                bold: false,
                font: "Calibri" }));
            } else if (part.startsWith("<p>")) {
              callToActionPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: part.replace(/<.*?>/g, ''),
                  size: 20,
                  font: "Calibri" })],
                spacing: {
                  before: 50,
                  after: 100
                },
                indent: {
                  left: 50,
                  right: 50 },
                alignment: 'left' }));
            } else if (part.startsWith("</p>")) {
              callToActionPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"](''));
            } else {
              callToActionPara.push(new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                  text: part.replace(/<.*?>/g, ''),
                  size: 20,
                  font: "Calibri" })],
                spacing: {
                  before: 50,
                  after: 100
                },
                indent: {
                  left: 50,
                  right: 50 },
                alignment: 'left' }));
            }
          });
          var table = new __WEBPACK_IMPORTED_MODULE_3_docx__["Table"]({
            width: {
              size: '100%',
              type: 'pct'
            },
            rows: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
              children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'Descriptions of scenes/ footage',
                    size: 22,
                    font: "Calibri" })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'Include text overlays / voiceover script in each scene	',
                    size: 22,
                    font: "Calibri" })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'Reference links/images',
                    size: 22,
                    font: "Calibri" })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              })]
            }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
              children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'INTROs: (can be hook/ theme/ title of your video)',
                    bold: true,
                    size: 22,
                    font: "Calibri" })],
                  spacing: {
                    before: 50,
                    after: 100
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' }), new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: scenceInfoTextRun,
                  spacing: {
                    before: 50,
                    after: 100
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: briefTextRun,
                  spacing: {
                    before: 50,
                    after: 100
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: imageLinks
                })]
              })]
            }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
              children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: bodyInfoPara
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: briefPointerPara
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]('')]
              })]
            }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
              children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                columnSpan: 3,
                children: callToActionPara
              })]
            })]
          });
          children.push(table);
          children.push(spaceHund);
          children.push(spaceHund);
          children.push(spaceHund);
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(deliItem.boxes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var boxItem = _step2.value;

            _loop(boxItem);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      if (deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn') {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(deliItem.boxes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _boxItem = _step4.value;

            var carouselTableRow = [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
              children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'IMAGE',
                    bold: true,
                    size: 22,
                    font: "Calibri"
                  })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'Description of image/gif	',
                    bold: true,
                    size: 22,
                    font: "Calibri"
                  })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'Text on image (if any)	',
                    bold: true,
                    size: 22,
                    font: "Calibri"
                  })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                    text: 'Reference links/images',
                    size: 22,
                    font: "Calibri"
                  })],
                  spacing: {
                    before: 50,
                    after: 50
                  },
                  indent: {
                    left: 50,
                    right: 50 },
                  alignment: 'left' })]
              })]
            })];
            var idx = 0;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_boxItem.images), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var imgRow = _step5.value;

                var tableRowChild = [new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                      text: idx + 1,
                      bold: true,
                      size: 22,
                      font: "Calibri"
                    })],
                    spacing: {
                      before: 50,
                      after: 100
                    },
                    indent: {
                      left: 50,
                      right: 50 },
                    alignment: 'left' })]
                }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                      text: imgRow.imgDescription,
                      size: 20,
                      font: "Calibri"
                    })],
                    spacing: {
                      before: 50,
                      after: 100
                    },
                    indent: {
                      left: 50,
                      right: 50 },
                    alignment: 'left' })]
                }), new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                  children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                      text: imgRow.textImage,
                      size: 20,
                      font: "Calibri"
                    })],
                    spacing: {
                      before: 50,
                      after: 100
                    },
                    indent: {
                      left: 50,
                      right: 50 },
                    alignment: 'left' })]
                })];
                if (imgRow.refLinkType === 'link') {
                  var refLinkType = new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                      children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                        text: imgRow.link,
                        size: 20,
                        font: "Calibri"
                      })],
                      spacing: {
                        before: 50,
                        after: 100
                      },
                      indent: {
                        left: 50,
                        right: 50 },
                      alignment: 'left' })]
                  });
                  tableRowChild.push(refLinkType);
                } else {
                  var _refLinkType = new __WEBPACK_IMPORTED_MODULE_3_docx__["TableCell"]({
                    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
                      children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
                        text: imgRow.imgUrl,
                        size: 20,
                        font: "Calibri"
                      })],
                      spacing: {
                        before: 50,
                        after: 100
                      },
                      indent: {
                        left: 50,
                        right: 50 },
                      alignment: 'left' })]
                  });
                  tableRowChild.push(_refLinkType);
                }

                var tableRow = new __WEBPACK_IMPORTED_MODULE_3_docx__["TableRow"]({
                  children: tableRowChild
                });

                carouselTableRow.push(tableRow);
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }

            var carouselTable = new __WEBPACK_IMPORTED_MODULE_3_docx__["Table"]({
              width: {
                size: '100%',
                type: 'pct'
              },
              rows: carouselTableRow
            });
            children.push(carouselTable);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        children.push(spaceHund);
        children.push(spaceHund);
        children.push(spaceHund);
        children.push(spaceHund);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var verPara = new __WEBPACK_IMPORTED_MODULE_3_docx__["Paragraph"]({
    children: [new __WEBPACK_IMPORTED_MODULE_3_docx__["TextRun"]({
      text: creatorConceptData.versionNo + ', ' + __WEBPACK_IMPORTED_MODULE_2__ContentWordGenerator__["a" /* default */].formatDate(creatorConceptData.createdAt),
      bold: false,
      size: 18 })],
    alignment: "left" });

  children.push(verPara);

  var doc = new __WEBPACK_IMPORTED_MODULE_3_docx__["Document"]({
    sections: [{
      properties: {},
      children: children
    }]
  });

  __WEBPACK_IMPORTED_MODULE_3_docx__["Packer"].toBlob(doc).then(function (blob) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_file_saver__["saveAs"])(blob, '@' + creatorConceptData.creatorHandle + ' ' + creatorConceptData.campaignName + '.docx');
    console.log('Document created successfully');
  });
  return true;
};

var formatDate = function formatDate(date) {
  return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('DD-MM-YYYY, HH:mm');
};

var getTextBlocks = function getTextBlocks(text) {
  if (text !== undefined && text !== null) {
    var textP = text.replace(/\n/g, '<p>');

    textP = textP.split(/(<span[^>]*>.*?<\/span>|<p>|<\/p>|<[^>]+>)/).filter(Boolean);
    return textP;
  }
  return [];
};

/* harmony default export */ __webpack_exports__["a"] = ({
  generateDocument: generateDocument,
  formatDate: formatDate,
  getTextBlocks: getTextBlocks
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMissingPostMedia;

function isMissingPostMedia(media) {
  var imageChanges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!media) return true;
  if (media.publicID) return false;
  if (typeof media.url !== 'string' || !media.url.trim()) return true;

  if (/^(?:data|blob):/i.test(media.url) && imageChanges.some(function (change) {
    return change.element && change.url === media.url;
  })) {
    return false;
  }
  if (/^data:/i.test(media.url)) {
    return !/^data:image\/(?:png|jpeg|gif|webp|bmp|avif);base64,[A-Za-z0-9+/]+={0,2}$/i.test(media.url);
  }
  if (/^blob:/i.test(media.url)) {
    return true;
  }
  return false;
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentMode: 'view'
    };
  },

  computed: {
    viewMode: function viewMode() {
      return this.currentMode === 'view';
    },
    editMode: function editMode() {
      return this.currentMode === 'edit';
    }
  },
  methods: {
    changeMode: function changeMode(mode) {
      this.currentMode = mode;
    }
  }
});

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Kobe Logo Green.b4768d4.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1488)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(2247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(2313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1398)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(2110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1343)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(2026),
  /* scopeId */
  "data-v-1e41c3b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1363)
__webpack_require__(1364)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(2054),
  /* scopeId */
  "data-v-2b389176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1371)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(2069),
  /* scopeId */
  "data-v-33187b78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1475)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(2223),
  /* scopeId */
  "data-v-7ec9308a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(2123),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1383)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(2087),
  /* scopeId */
  "data-v-3d22c403",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1319)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1997),
  /* scopeId */
  "data-v-0c9f17ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1300)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1970),
  /* scopeId */
  "data-v-028c6335",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1435)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(2170),
  /* scopeId */
  "data-v-6938b295",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1307)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1978),
  /* scopeId */
  "data-v-05776351",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1430)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(2163),
  /* scopeId */
  "data-v-66123d62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1549)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(2321),
  /* scopeId */
  "data-v-f50ff834",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(2041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(2213),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(2204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(2252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(2058),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1303)
__webpack_require__(1304)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(937),
  /* template */
  __webpack_require__(1974),
  /* scopeId */
  "data-v-0329f234",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1486)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(2245),
  /* scopeId */
  "data-v-9a3f765e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1325)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(2004),
  /* scopeId */
  "data-v-0f657784",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(2227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(2050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1540)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(970),
  /* template */
  __webpack_require__(2312),
  /* scopeId */
  "data-v-ed26fafa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(1973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(2013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1471)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(992),
  /* template */
  __webpack_require__(2214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(996),
  /* template */
  __webpack_require__(2260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1316)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(999),
  /* template */
  __webpack_require__(1992),
  /* scopeId */
  "data-v-0974dec0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1410)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1003),
  /* template */
  __webpack_require__(2129),
  /* scopeId */
  "data-v-53f355c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1012),
  /* template */
  __webpack_require__(2259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1342)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1014),
  /* template */
  __webpack_require__(2023),
  /* scopeId */
  "data-v-1d201134",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1548)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1016),
  /* template */
  __webpack_require__(2319),
  /* scopeId */
  "data-v-f4845f2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1512)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1018),
  /* template */
  __webpack_require__(2277),
  /* scopeId */
  "data-v-b88236de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1043),
  /* template */
  __webpack_require__(2067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1449)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1046),
  /* template */
  __webpack_require__(2192),
  /* scopeId */
  "data-v-72c433ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1428)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1048),
  /* template */
  __webpack_require__(2161),
  /* scopeId */
  "data-v-644b04e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1381)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1049),
  /* template */
  __webpack_require__(2085),
  /* scopeId */
  "data-v-3c6910ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1051),
  /* template */
  __webpack_require__(2130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1365)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1052),
  /* template */
  __webpack_require__(2056),
  /* scopeId */
  "data-v-2b617e22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1448)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1053),
  /* template */
  __webpack_require__(2190),
  /* scopeId */
  "data-v-7175e11a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1470)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1055),
  /* template */
  __webpack_require__(2212),
  /* scopeId */
  "data-v-7ac01187",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1058),
  /* template */
  __webpack_require__(2152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1351)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(2036),
  /* scopeId */
  "data-v-21e8a53e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1311)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(1983),
  /* scopeId */
  "data-v-06fda34d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1352)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1064),
  /* template */
  __webpack_require__(2038),
  /* scopeId */
  "data-v-23769df8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1340)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1065),
  /* template */
  __webpack_require__(2019),
  /* scopeId */
  "data-v-1b1fd3ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1508)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1066),
  /* template */
  __webpack_require__(2274),
  /* scopeId */
  "data-v-b6bab890",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1084),
  /* template */
  __webpack_require__(2235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1087),
  /* template */
  __webpack_require__(2237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1535)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(2309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1437)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1102),
  /* template */
  __webpack_require__(2173),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1376)
__webpack_require__(1377)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1106),
  /* template */
  __webpack_require__(2075),
  /* scopeId */
  "data-v-3556129a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1348)
__webpack_require__(1349)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1121),
  /* template */
  __webpack_require__(2033),
  /* scopeId */
  "data-v-1f7fd534",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1122),
  /* template */
  __webpack_require__(2220),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1529)
__webpack_require__(1530)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1124),
  /* template */
  __webpack_require__(2299),
  /* scopeId */
  "data-v-d85d83a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1518)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1130),
  /* template */
  __webpack_require__(2285),
  /* scopeId */
  "data-v-c3fbeb66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1481)
__webpack_require__(1482)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1145),
  /* template */
  __webpack_require__(2232),
  /* scopeId */
  "data-v-89dd22b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1389)
__webpack_require__(1390)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1149),
  /* template */
  __webpack_require__(2097),
  /* scopeId */
  "data-v-42f8008e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1152),
  /* template */
  __webpack_require__(2099),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1168),
  /* template */
  __webpack_require__(2118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1171),
  /* template */
  __webpack_require__(2233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, exports) {

module.exports = {"Speed":{"COMPLETION":{"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"Jessica","data":[5,15,14,7,20,22,25,8,12,10,21,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16,22,8,13,15,22,25,26,20],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21,21,21,21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"Jessica","data":[5,15,14,7],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"Jessica","data":[10,15,14,7,25,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,18,23,22,24],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]}},"REVENUE":{"WEEKLY":{"labels":["Week1","Week2","Week3","week4"],"datasets":[{"label":"Jessica","data":[15200,14000,18000,12000],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[25000,15000,17500,20000],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Team","data":[23200,29000,19300,21400],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"Jessica","data":[5,15,14,7,20,22,25,8,12,10,21,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16,22,8,13,15,22,25,26,20],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21,21,21,21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"Jessica","data":[5,15,14,7],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"Jessica","data":[10,15,14,7,25,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,18,23,22,24],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]}}},"Spend":{"RENEWAL":{"WEEKLY":{"labels":["Week1","Week2","Week3","week4"],"datasets":[{"label":"Jessica","data":[15200,14000,18000,12000],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[25000,15000,17500,20000],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"}]},"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"Jessica","data":[5,15,14,7,20,22,25,8,12,10,21,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16,22,8,13,15,22,25,26,20],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"Jessica","data":[5,15,14,7],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"Jessica","data":[10,15,14,7,25,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Jiayi","data":[12,9,18,23,22,24],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"}]}},"AVERAGE_AMOUNT":{"WEEKLY":{"labels":["Week1","Week2","Week3","week4"],"datasets":[{"label":"Jessica","data":[15200,14000,18000,12000],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0","fill":false},{"label":"Jiayi","data":[25000,15000,17500,20000],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1","fill":false},{"label":"Team","data":[23200,29000,19300,21400],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2","fill":false}]},"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"Jessica","data":[5,15,14,7,20,22,25,8,12,10,21,20],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16,22,8,13,15,22,25,26,20],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Team","data":[21,21,21,21,21,21,21,21,21,21,21,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"Jessica","data":[5,15,14,7],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Jiayi","data":[12,9,10,16],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Team","data":[21,21,21,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"Jessica","data":[10,15,14,7,25,20],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Jiayi","data":[12,9,18,23,22,24],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Team","data":[21,21,21,21,21,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]}}}}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = [{"cc":"AF","cn":"Afghanistan","dc":"+93"},{"cc":"AL","cn":"Albania","dc":"+355"},{"cc":"DZ","cn":"Algeria","dc":"+213"},{"cc":"AS","cn":"American Samoa","dc":"+1"},{"cc":"AD","cn":"Andorra","dc":"+376"},{"cc":"AO","cn":"Angola","dc":"+244"},{"cc":"AI","cn":"Anguilla","dc":"+1"},{"cc":"AG","cn":"Antigua","dc":"+1"},{"cc":"AR","cn":"Argentina","dc":"+54"},{"cc":"AM","cn":"Armenia","dc":"+374"},{"cc":"AW","cn":"Aruba","dc":"+297"},{"cc":"AU","cn":"Australia","dc":"+61"},{"cc":"AI","cn":"Austria","dc":"+43"},{"cc":"AZ","cn":"Azerbaijan","dc":"+994"},{"cc":"BH","cn":"Bahrain","dc":"+973"},{"cc":"BD","cn":"Bangladesh","dc":"+880"},{"cc":"BB","cn":"Barbados","dc":"+1"},{"cc":"BY","cn":"Belarus","dc":"+375"},{"cc":"BE","cn":"Belgium","dc":"+32"},{"cc":"BZ","cn":"Belize","dc":"+501"},{"cc":"BJ","cn":"Benin","dc":"+229"},{"cc":"BM","cn":"Bermuda","dc":"+1"},{"cc":"BT","cn":"Bhutan","dc":"+975"},{"cc":"BO","cn":"Bolivia","dc":"+591"},{"cc":"BA","cn":"Bosnia and Herzegovina","dc":"+387"},{"cc":"BW","cn":"Botswana","dc":"+267"},{"cc":"BR","cn":"Brazil","dc":"+55"},{"cc":"IO","cn":"British Indian Ocean Territory","dc":"+246"},{"cc":"VG","cn":"British Virgin Islands","dc":"+1"},{"cc":"BN","cn":"Brunei","dc":"+673"},{"cc":"BG","cn":"Bulgaria","dc":"+359"},{"cc":"BF","cn":"Burkina Faso","dc":"+226"},{"cc":"MM","cn":"Myanmar","dc":"+95"},{"cc":"BI","cn":"Burundi","dc":"+257"},{"cc":"KH","cn":"Cambodia","dc":"+855"},{"cc":"CM","cn":"Cameroon","dc":"+237"},{"cc":"CA","cn":"Canada","dc":"+1"},{"cc":"CV","cn":"Cape Verde","dc":"+238"},{"cc":"KY","cn":"Cayman Islands","dc":"+1"},{"cc":"CF","cn":"Central African Republic","dc":"+236"},{"cc":"ID","cn":"Chad","dc":"+235"},{"cc":"CL","cn":"Chile","dc":"+56"},{"cc":"CN","cn":"China","dc":"+86"},{"cc":"CO","cn":"Colombia","dc":"+57"},{"cc":"KM","cn":"Comoros","dc":"+269"},{"cc":"CK","cn":"Cook Islands","dc":"+682"},{"cc":"CR","cn":"Costa Rica","dc":"+506"},{"cc":"CI","cn":"Côte dIvoire","dc":"+225"},{"cc":"HR","cn":"Croatia","dc":"+385"},{"cc":"CU","cn":"Cuba","dc":"+53"},{"cc":"CY","cn":"Cyprus","dc":"+357"},{"cc":"CZ","cn":"Czech Republic","dc":"+420"},{"cc":"CD","cn":"Democratic Republic of Congo","dc":"+243"},{"cc":"DK","cn":"Denmark","dc":"+45"},{"cc":"DJ","cn":"Djibouti","dc":"+253"},{"cc":"DM","cn":"Dominica","dc":"+1"},{"cc":"DO","cn":"Dominican Republic","dc":"+1"},{"cc":"EC","cn":"Ecuador","dc":"+593"},{"cc":"EG","cn":"Egypt","dc":"+20"},{"cc":"SV","cn":"El Salvador","dc":"+503"},{"cc":"GQ","cn":"Equatorial Guinea","dc":"+240"},{"cc":"ER","cn":"Eritrea","dc":"+291"},{"cc":"EE","cn":"Estonia","dc":"+372"},{"cc":"ET","cn":"Ethiopia","dc":"+251"},{"cc":"FK","cn":"Falkland Islands","dc":"+500"},{"cc":"FO","cn":"Faroe Islands","dc":"+298"},{"cc":"FM","cn":"Federated States of Micronesia","dc":"+691"},{"cc":"FJ","cn":"Fiji","dc":"+679"},{"cc":"FI","cn":"Finland","dc":"+358"},{"cc":"FR","cn":"France","dc":"+33"},{"cc":"GF","cn":"French Guiana","dc":"+594"},{"cc":"PF","cn":"French Polynesia","dc":"+689"},{"cc":"GA","cn":"Gabon","dc":"+241"},{"cc":"GE","cn":"Georgia","dc":"+995"},{"cc":"DE","cn":"Germany","dc":"+49"},{"cc":"GH","cn":"Ghana","dc":"+233"},{"cc":"GI","cn":"Gibraltar","dc":"+350"},{"cc":"GR","cn":"Greece","dc":"+30"},{"cc":"GL","cn":"Greenland","dc":"+299"},{"cc":"GD","cn":"Grenada","dc":"+1"},{"cc":"GP","cn":"Guadeloupe","dc":"+590"},{"cc":"GU","cn":"Guam","dc":"+1"},{"cc":"GT","cn":"Guatemala","dc":"+502"},{"cc":"GN","cn":"Guinea","dc":"+224"},{"cc":"GW","cn":"Guinea-Bissau","dc":"+245"},{"cc":"GY","cn":"Guyana","dc":"+592"},{"cc":"HT","cn":"Haiti","dc":"+509"},{"cc":"HN","cn":"Honduras","dc":"+504"},{"cc":"HK","cn":"Hong Kong","dc":"+852"},{"cc":"HU","cn":"Hungary","dc":"+36"},{"cc":"IS","cn":"Iceland","dc":"+354"},{"cc":"IN","cn":"India","dc":"+91"},{"cc":"ID","cn":"Indonesia","dc":"+62"},{"cc":"IR","cn":"Iran","dc":"+98"},{"cc":"IQ","cn":"Iraq","dc":"+964"},{"cc":"IE","cn":"Ireland","dc":"+353"},{"cc":"IL","cn":"Israel","dc":"+972"},{"cc":"IT","cn":"Italy","dc":"+39"},{"cc":"JM","cn":"Jamaica","dc":"+1"},{"cc":"JP","cn":"Japan","dc":"+81"},{"cc":"JO","cn":"Jordan","dc":"+962"},{"cc":"KZ","cn":"Kazakhstan","dc":"+7"},{"cc":"KE","cn":"Kenya","dc":"+254"},{"cc":"KI","cn":"Kiribati","dc":"+686"},{"cc":"XK","cn":"Kosovo","dc":"+383"},{"cc":"KW","cn":"Kuwait","dc":"+965"},{"cc":"KG","cn":"Kyrgyzstan","dc":"+996"},{"cc":"LA","cn":"Laos","dc":"+856"},{"cc":"LV","cn":"Latvia","dc":"+371"},{"cc":"LB","cn":"Lebanon","dc":"+961"},{"cc":"LS","cn":"Lesotho","dc":"+266"},{"cc":"LR","cn":"Liberia","dc":"+231"},{"cc":"LY","cn":"Libya","dc":"+218"},{"cc":"LI","cn":"Liechtenstein","dc":"+423"},{"cc":"LT","cn":"Lithuania","dc":"+370"},{"cc":"LU","cn":"Luxembourg","dc":"+352"},{"cc":"MO","cn":"Macau","dc":"+853"},{"cc":"MK","cn":"Macedonia","dc":"+389"},{"cc":"MG","cn":"Madagascar","dc":"+261"},{"cc":"MW","cn":"Malawi","dc":"+265"},{"cc":"MY","cn":"Malaysia","dc":"+60"},{"cc":"MV","cn":"Maldives","dc":"+960"},{"cc":"ML","cn":"Mali","dc":"+223"},{"cc":"MT","cn":"Malta","dc":"+356"},{"cc":"MH","cn":"Marshall Islands","dc":"+692"},{"cc":"MQ","cn":"Martinique","dc":"+596"},{"cc":"MR","cn":"Mauritania","dc":"+222"},{"cc":"MU","cn":"Mauritius","dc":"+230"},{"cc":"YT","cn":"Mayotte","dc":"+262"},{"cc":"MX","cn":"Mexico","dc":"+52"},{"cc":"MD","cn":"Moldova","dc":"+373"},{"cc":"MC","cn":"Monaco","dc":"+377"},{"cc":"MN","cn":"Mongolia","dc":"+976"},{"cc":"ME","cn":"Montenegro","dc":"+382"},{"cc":"MS","cn":"Montserrat","dc":"+1"},{"cc":"MA","cn":"Morocco","dc":"+212"},{"cc":"MZ","cn":"Mozambique","dc":"+258"},{"cc":"NA","cn":"Namibia","dc":"+264"},{"cc":"NR","cn":"Nauru","dc":"+674"},{"cc":"NP","cn":"Nepal","dc":"+977"},{"cc":"NL","cn":"Netherlands","dc":"+31"},{"cc":"AN","cn":"Netherlands Antilles","dc":"+599"},{"cc":"NC","cn":"New Caledonia","dc":"+687"},{"cc":"NZ","cn":"New Zealand","dc":"+64"},{"cc":"NI","cn":"Nicaragua","dc":"+505"},{"cc":"NE","cn":"Niger","dc":"+227"},{"cc":"NG","cn":"Nigeria","dc":"+234"},{"cc":"NU","cn":"Niue","dc":"+683"},{"cc":"NF","cn":"Norfolk Island","dc":"+672"},{"cc":"KP","cn":"North Korea","dc":"+850"},{"cc":"MP","cn":"Northern Mariana Islands","dc":"+1"},{"cc":"NO","cn":"Norway","dc":"+47"},{"cc":"OM","cn":"Oman","dc":"+968"},{"cc":"PK","cn":"Pakistan","dc":"+92"},{"cc":"PW","cn":"Palau","dc":"+680"},{"cc":"PS","cn":"Palestine","dc":"+970"},{"cc":"PA","cn":"Panama","dc":"+507"},{"cc":"PG","cn":"Papua New Guinea","dc":"+675"},{"cc":"PY","cn":"Paraguay","dc":"+595"},{"cc":"PE","cn":"Peru","dc":"+51"},{"cc":"PH","cn":"Philippines","dc":"+63"},{"cc":"PL","cn":"Poland","dc":"+48"},{"cc":"PT","cn":"Portugal","dc":"+351"},{"cc":"PR","cn":"Puerto Rico","dc":"+1"},{"cc":"QA","cn":"Qatar","dc":"+974"},{"cc":"CG","cn":"Republic of the Congo","dc":"+242"},{"cc":"RE","cn":"Réunion","dc":"+262"},{"cc":"RO","cn":"Romania","dc":"+40"},{"cc":"RU","cn":"Russia","dc":"+7"},{"cc":"RW","cn":"Rwanda","dc":"+250"},{"cc":"BL","cn":"Saint Barthélemy","dc":"+590"},{"cc":"SH","cn":"Saint Helena","dc":"+290"},{"cc":"KN","cn":"Saint Kitts and Nevis","dc":"+1"},{"cc":"MF","cn":"Saint Martin","dc":"+590"},{"cc":"PM","cn":"Saint Pierre and Miquelon","dc":"+508"},{"cc":"VC","cn":"Saint Vincent and the Grenadines","dc":"+1"},{"cc":"WS","cn":"Samoa","dc":"+685"},{"cc":"SM","cn":"San Marino","dc":"+378"},{"cc":"ST","cn":"São Tomé and Príncipe","dc":"+239"},{"cc":"SA","cn":"Saudi Arabia","dc":"+966"},{"cc":"SN","cn":"Senegal","dc":"+221"},{"cc":"RS","cn":"Serbia","dc":"+381"},{"cc":"SC","cn":"Seychelles","dc":"+248"},{"cc":"SL","cn":"Sierra Leone","dc":"+232"},{"cc":"SG","cn":"Singapore","dc":"+65"},{"cc":"SK","cn":"Slovakia","dc":"+421"},{"cc":"SI","cn":"Slovenia","dc":"+386"},{"cc":"SB","cn":"Solomon Islands","dc":"+677"},{"cc":"SO","cn":"Somalia","dc":"+252"},{"cc":"ZA","cn":"South Africa","dc":"+27"},{"cc":"KR","cn":"South Korea","dc":"+82"},{"cc":"ES","cn":"Spain","dc":"+34"},{"cc":"LK","cn":"Sri Lanka","dc":"+94"},{"cc":"LC","cn":"St. Lucia","dc":"+1"},{"cc":"SD","cn":"Sudan","dc":"+249"},{"cc":"SR","cn":"Suriname","dc":"+597"},{"cc":"SZ","cn":"Swaziland","dc":"+268"},{"cc":"SE","cn":"Sweden","dc":"+46"},{"cc":"CH","cn":"Switzerland","dc":"+41"},{"cc":"SY","cn":"Syria","dc":"+963"},{"cc":"TW","cn":"Taiwan","dc":"+886"},{"cc":"TJ","cn":"Tajikistan","dc":"+992"},{"cc":"TZ","cn":"Tanzania","dc":"+255"},{"cc":"TH","cn":"Thailand","dc":"+66"},{"cc":"BS","cn":"The Bahamas","dc":"+1"},{"cc":"GM","cn":"The Gambia","dc":"+220"},{"cc":"TL","cn":"Timor-Leste","dc":"+670"},{"cc":"TG","cn":"Togo","dc":"+228"},{"cc":"TK","cn":"Tokelau","dc":"+690"},{"cc":"TO","cn":"Tonga","dc":"+676"},{"cc":"TT","cn":"Trinidad and Tobago","dc":"+1"},{"cc":"TN","cn":"Tunisia","dc":"+216"},{"cc":"TR","cn":"Turkey","dc":"+90"},{"cc":"TM","cn":"Turkmenistan","dc":"+993"},{"cc":"TC","cn":"Turks and Caicos Islands","dc":"+1"},{"cc":"TV","cn":"Tuvalu","dc":"+688"},{"cc":"UG","cn":"Uganda","dc":"+256"},{"cc":"UA","cn":"Ukraine","dc":"+380"},{"cc":"AE","cn":"United Arab Emirates","dc":"+971"},{"cc":"GB","cn":"United Kingdom","dc":"+44"},{"cc":"US","cn":"United States","dc":"+1"},{"cc":"UY","cn":"Uruguay","dc":"+598"},{"cc":"VI","cn":"US Virgin Islands","dc":"+1"},{"cc":"UZ","cn":"Uzbekistan","dc":"+998"},{"cc":"VU","cn":"Vanuatu","dc":"+678"},{"cc":"VA","cn":"Vatican City","dc":"+39"},{"cc":"VE","cn":"Venezuela","dc":"+58"},{"cc":"VN","cn":"Vietnam","dc":"+84"},{"cc":"WF","cn":"Wallis and Futuna","dc":"+681"},{"cc":"YE","cn":"Yemen","dc":"+967"},{"cc":"ZM","cn":"Zambia","dc":"+260"},{"cc":"ZW","cn":"Zimbabwe","dc":"+263"}]

/***/ }),
/* 750 */
/***/ (function(module, exports) {

/**
 * The list of bank account and swift codes
 *
 *
 */
/* eslint-disable */

module.exports = [
    {
        "code": "KASITHBK",
        "bank": "Kasikorn Bank"
    },
    {
        "code": "SICOTHBK",
        "bank": "SIAM COMERCIAL BANK"
    },
    {
        "code": "NISPIDJA",
        "bank": "OCBC NISP"
    },
    {
        "code": "MBBEMYKL",
        "bank": "Maybank"
    },
    {
        "code": "CENAIDJA",
        "bank": "Bank Central Asia"
    },
    {
        "code": "HASEHKHH",
        "bank": "Hang Seng Bank"
    },
    {
        "code": "BKCHHKHH",
        "bank": "Bank of China (Hong Kong) Limited"
    },
    {
        "code": "HSBCHKHHHKH",
        "bank": "HSBC The Hong Kong and Shanghai Banking Corporation"
    },
    {
        "code": "CENAIDJA",
        "bank": "Bank Central Asia (BCA)"
    },
    {
        "code": "MBBEMYKLXXX",
        "bank": "Maybank"
    },
    {
        "code": "CIBBMYKLXXX",
        "bank": "CIMB"
    },
    {
        "code": "PBBEMYKL",
        "bank": "Public Bank"
    },
    {
        "code": "RHBBMYKLXXX",
        "bank": "RHB Bank"
    },
    {
        "code": "CTBBMYKL",
        "bank": "CIMB Islamic BANK BERHAD"
    },
    {
        "code": "OCBCMYKLXXX",
        "bank": "OCBC BANK"
    },
    {
        "code": "MBBEMYKL",
        "bank": "Maybank Berhad"
    },
    {
        "code": "HLBBMYKLXXX",
        "bank": "Hong Leong Bank"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB Berhad"
    },
    {
        "code": "VTCBVNVX",
        "bank": "Techcombank"
    },
    {
        "code": "KASITHBK",
        "bank": "Kasikorn bank"
    },
    {
        "code": "KRTHTHBK",
        "bank": "Krungthai Bank"
    },
    {
        "code": "PBBEMYKLXXX",
        "bank": "PUBLIC BANK BERHAD"
    },
    {
        "code": "BRINIDJA",
        "bank": "Bank Rakyat Indonesia (BRI)"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB"
    },
    {
        "code": "BKKBTHBK",
        "bank": "Bangkok Bank"
    },
    {
        "code": "BFTVVNVX",
        "bank": "Vietcombank"
    },
    {
        "code": "WPACAU2S",
        "bank": "Westpac Business"
    },
    {
        "code": "RHBBMYKLXXX",
        "bank": "RHB BANK BERHAD"
    },
    {
        "code": "ARBKMYKLXXX",
        "bank": "AMBANK (M) BERHAD"
    },
    {
        "code": "UBPHPHMMXXX",
        "bank": "Union Bank of the Philippines"
    },
    {
        "code": "BOPIPHMMXXX",
        "bank": "BANK OF THE PHILIPPINE ISLANDS"
    },
    {
        "code": "MBBEMYKLPEN",
        "bank": "Maybank"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB Bank Malaysia"
    },
    {
        "code": "OCBCMYKL",
        "bank": "OCBC BANK"
    },
    {
        "code": "PBBEMYKL",
        "bank": "PUBLIC BANK BERHAD"
    },
    {
        "code": "MBBEMYKLSAC",
        "bank": "Maybank"
    },
    {
        "code": "KASITHBKXXX",
        "bank": "Kasikorn bank"
    },
    {
        "code": "KRTHTHBKXXX",
        "bank": "Krung Thai Bank\r\n\r\n"
    },
    {
        "code": "CIBBMYKLXXX",
        "bank": "CIMB Bank Malaysia"
    },
    {
        "code": "BOPIPHMMXXX",
        "bank": "Bank of the Philippine Islands - Savings"
    },
    {
        "code": "BNORPHMMXXX",
        "bank": "BDO UNIBANK, INC."
    },
    {
        "code": "PNBMPHMMXXX",
        "bank": "PHILIPPINE NATIONAL BANK"
    },
    {
        "code": "CENAIDJA",
        "bank": "BANK Central Asia Cab Graha Paramita"
    },
    {
        "code": "CENAIDJA",
        "bank": "BANK CENTRAL ASIA\r\n"
    },
    {
        "code": "BMRIIDJA",
        "bank": "BANK MANDIRI (PERSERO), PT\r\n"
    },
    {
        "code": "RHBBMYKL",
        "bank": "RHB Bank"
    },
    {
        "code": "SICOTHBK",
        "bank": "Siam Commercial Bank Public Company Limited"
    },
    {
        "code": "KASITHBKXXX",
        "bank": "KASIKORNBANK PUBLIC COMPANY LIMITED"
    },
    {
        "code": "CITIVNVX",
        "bank": "CITIBANK N.A.\r\n"
    },
    {
        "code": "BKKBTHBK",
        "bank": "BANGKOK BANK PUBLIC COMPANY LIMITED\r\n"
    },
    {
        "code": "TMBKTHBKXXX",
        "bank": "THANACHART BANK PUBLIC COMPANY LIMITED\r\n"
    },
    {
        "code": "MBBEMYKL",
        "bank": "MALAYAN BANKING BERHAD (MAYBANK)\r\n"
    },
    {
        "code": "MBBEMYKL",
        "bank": "MALAYAN BANKING BERHAD"
    },
    {
        "code": "HBMBMYKL",
        "bank": "HSBC"
    },
    {
        "code": "SICOTHBK",
        "bank": "SIAM COMMERCIAL BANK PCL., THE\r\n"
    },
    {
        "code": "SICOTHBK",
        "bank": "Siam Commercial Bank"
    },
    {
        "code": "KASITHBK",
        "bank": "Kasikorn Bank"
    },
    {
        "code": "CIBBMYKLXXX",
        "bank": "CIMB Bank Berhad"
    },
    {
        "code": "BOPIPHMM",
        "bank": "BANK OF THE PHILIPPINE ISLANDS"
    },
    {
        "code": "CIBBMYKL",
        "bank": "CIMB Bank Berhad"
    },
    {
        "code": "ORSIPHM1",
        "bank": "BANCO DE ORO"
    },
    {
        "code": "KASITHBK",
        "bank": "KASIKORNBANK PUBLIC COMPANY LIMITED"
    },
    {
        "code": "SICOTHBKXXX",
        "bank": "siam commercial bank"
    },
    {
        "code": "TMBKTHBK",
        "bank": "TMBThanachart Bank Public Company Limited"
    },
    {
        "code": "SCBLMYKXXXX",
        "bank": "STANDARD CHARTERED BANK"
    },
    {
        "code": "SICOTHBK",
        "bank": "Siam Commercial Bank Public Company Limited"
    },
    {
        "code": "PHBMMYKL",
        "bank": "AFFIN BANK BERHAD"
    },
    {
        "code": "ICBVVNVX946\r\n",
        "bank": "VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE (FORMERLY VIETNAM BANK FOR INDUSTRY AND TRADE)"
    },
    {
        "code": "BNORPHMMXXX",
        "bank": "BANCO DE ORO UNIBANK"
    },
    {
        "code": "MBBEMYKLXXX",
        "bank": "Maybank"
    },
    {
        "code": "MSCBVNVX004",
        "bank": "MILITARY COMMERCIAL JOINT STOCK BANK"
    },
    {
        "code": "KASITHBK",
        "bank": "Kasikorn Bank\r\n"
    },
    {
        "code": "BOPIPHMMXXX",
        "bank": "UNION BANK OF THE PHILIPPINES"
    },
    {
        "code": "BNORPHMM",
        "bank": "BDO UNIBANK, INC."
    },
    {
        "code": "MBBEMYKLIPH",
        "bank": "MALAYAN BANKING BERHAD (MAYBANK)"
    },
    {
        "code": "MBBEMYKL",
        "bank": "MALAYAN BANKING BERHAD (MAYBANK)"
    },
    {
        "code": "SACLVNVX",
        "bank": "SAIGON COMMERCIAL BANK"
    },
    {
        "code": "CENAIDJAXXX",
        "bank": "Bank Central Asia"
    }
]

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = {"Afghanistan":["Herat","Kabul","Kandahar","Molah","Rana","Shar","Sharif","Wazir Akbar Khan"],"Albania":["Elbasan","Petran","Pogradec","Shkoder","Tirana","Ura Vajgurore"],"Algeria":["Algiers","Annaba","Azazga","Batna City","Blida","Bordj","Bordj Bou Arreridj","Bougara","Cheraga","Chlef","Constantine","Djelfa","Draria","El Tarf","Hussein Dey","Illizi","Jijel","Kouba","Laghouat","Oran","Ouargla","Oued Smar","Relizane","Rouiba","Saida","Souk Ahras","Tamanghasset","Tiaret","Tissemsilt","Tizi","Tizi Ouzou","Tlemcen"],"Andorra":["Andorra la Vella","Canillo","Encamp","Engordany","Escaldes-Engordany","La Massana","Llorts","Ordino","Santa Coloma","Sispony","Soldeu"],"Angola":["Ambriz","Benguela","Cabinda","Cacole","Camabatela","Cazeta","Huambo","Kuito","Lobito","Luanda","Lubango","Lucapa","Lumeje","Malanje","Menongue","Muxaluando","Namibe","Ondjiva","Piri","Saurimo","Talatona"],"Antigua and Barbuda":["All Saints","Cassada Gardens","Codrington","Old Road","Parham","Woods"],"Argentina":["28 de Noviembre","Abasto","Acassuso","Acebal","Acevedo","Adelia Maria","Agua de Oro","Albardon","Albarellos","Alberdi","Alberti","Aldo Bonzi","Alejandro Korn","Alicia","Allen","Almafuerte","Almagro","Almirante Brown","Alta Gracia","Alta Italia","Alvarez","Alvear","Anatuya","Angelica","Antonio Carboni","Apostoles","Arequito","Armstrong","Arrecifes","Arroyito","Arroyito","Arroyito Challaco","Arroyo Seco","Arteaga","Asamblea","Ascension","Avellaneda","Avellaneda","Ayacucho","Azara","Azul","Balcarce","Balnearia","Banda del Rio Sali","Bandera","Banfield","Baradero","Bariloche","Barrio Fisherton","Batan","Beccar","Belen de Escobar","Belgrano","Belgrano","Bell Ville","Bella Vista","Bella Vista","Benavidez","Berazategui","Berisso","Bernal","Bernardo Larroude","Bernasconi","Bigand","Bombal","Bordenave","Bosch","Bosques","Boulogne","Bovril","Bragado","Brandsen","Brinkmann","Buenos Aires","Burzaco","Bustinza","Caballito","Calderon","Caleta Olivia","Caleufu","Camilo Aldao","Campana","Canada de Gomez","Canada del Ucle","Canada Rosquin","Canals","Canning","Canuelas","Capilla del Monte","Capilla del Senor","Capitan Bermudez","Carhue","Carlos Casares","Carlos Pellegrini","Carlos Tejedor","Caseros","Casilda","Castelar","Castelli","Castillo","Catriel","Catrilo","Cavanagh","Centenario","Ceres","Cervantes","Chacabuco","Chacarita","Chajari","Charata","Chateaubriand","Chilecito","Chivilcoy","Choele Choel","Chorroarin","Cinco Saltos","Cipolletti","City Bell","Ciudad General Belgrano","Ciudadela","Claypole","Clorinda","Colon","Colon","Colonia Baron","Colonia Caroya","Colonia San Miguel Arcangel","Comodoro Rivadavia","Concepcion","Concepcion","Concordia","Constituyentes","Coronel Dorrego","Coronel Martinez de Hoz","Coronel Pringles","Corral de Bustos","Corralitos","Corrientes","Cosquin","Coy Aike","Cramer","Crespo","Cruz del Eje","Curuzu Cuatia","Cutral-Co","Darregueira","De Mayo","Del Campillo","Del Viso","Despenaderos","Devoto","Diaz","Diego de Alvear","Doblas","Dock Sud","Dolores","Don Bosco","Don Torcuato","Drabble","Eduardo Castex","El Calafate","El Dorado","El Hoyo","El Palomar","El Palomar","El Talar","El Trebol","Eldorado","Embalse","Empalme Lobos","Ensenada","Esperanza","Esquel","Esteban Echeverria","Ezeiza","Ezpeleta","Famailla","Fatima","Federal","Fernandez","Firmat","Florencio Varela","Florentino Ameghino","Flores","Floresta","Florida","Formosa","Francisco Alvarez","Franck","Fray Luis A. Beltran","Freyre","Frias","Funes","Gaiman","Galvez","Garin","Garupa","General Acha","General Alvear","General Cabrera","General Deheza","General Guido","General Juan Madariaga","General Lagos","General Las Heras","General Lavalle","General Mansilla","General Martin Miguel de Guemes","General Pacheco","General Paz","General Pico","General Roca","General Roca","General Rodriguez","General San Martin","General San Martin","General Viamonte","General Villegas","Germania","Glew","Gobernador Crespo","Gobernador Galvez","Godoy","Godoy Cruz","Gonzalez Catan","Gonzalez Moreno","Goya","Granadero Baigorria","Grand Bourg","Gualeguay","Guatrache","Guernica","Henderson","Hernando","Hersilia","Hilario","Hilario Ascasubi","Hipatia","Hipolito Yrigoyen","Huanchillas","Huanguelen","Huinca Renanco","Humahuaca","Hurlingham","Ibarlucea","Ibicuy","Independencia","Ingeniero Beaugey","Ingeniero Luiggi","Ingeniero Maschwitz","Intendente Alvear","Isidro Casanova","Ituzaingo","James Craik","Jauregui","Jeppener","Jesus Maria","Jose Leon Suarez","Jose Marmol","Juan Pujol","Justiniano Posse","La Banda","La Boca","La Calera","La Cumbre","La Falda","La Leonesa","La Lucila","La Madrid","La Pampa","La Para","La Paz","La Paz","La Plata","La Punta","La Rioja","La Tablada","La Union","La Violeta","Laborde","Laboulaye","Laferrere","Laguna Alsina","Lanus","Larroque","Las Catitas","Las Flores","Las Flores","Las Heras","Las Perdices","Las Rosas","Las Talitas","Las Varillas","Lavalle","Leandro N. Alem","Leones","Libertad","Lima","Liniers","Llavallol","Lobos","Lomas de Zamora","Lomas del Mirador","Longchamps","Los Antiguos","Los Cardales","Los Molinos","Los Polvorines","Luis Guillon","Lujan de Cuyo","Luque","Luzuriaga","Lynch","Macachin","Magdalena","Magdalena","Maggiolo","Maipu","Maipu","Manantial","Manfredi","Manuel J. Cobo","Maquinista Savio","Mar de Ajo","Mar del Plata","Mar del Tuyu","Marcos Juarez","Marcos Paz","Margarita","Maria Ignacia","Maria Juana","Mariano Acosta","Mariano J. Haedo","Mariano Moreno","Martinez","Matheu","Mayor Buratovich","Melincue","Mendiolaza","Mendoza","Mercedes","Mercedes","Merlo","Merlo","Minacar","Miramar","Miramar","Monje","Monte Hermoso","Monteros","Montserrat","Moreno","Moron","Morteros","Muniz","Munro","Navarro","Navarro","Necochea","Nogoya","Nordelta","Nunez","Obera","Oliva","Oliveros","Olivos","Oncativo","Open Door","Ordonez","Palermo","Palmira","Palpala","Partido de Jose C. Paz","Pasco","Paso del Rey","Paternal","Pavon","Pedernales","Pedro Luro","Pellegrini","Perez","Pergamino","Perico","Perito Moreno","Piamonte","Pico de Salamanca","Pico Truncado","Pigue","Pilar","Pilar","Pilar","Pinamar","Piquete Cabado","Platanos","Plaza Huincul","Plottier","Pontevedra","Portena","Posadas","Pozo del Molle","Presidente Derqui","Puan","Pueblo San Jose","Puerto Madryn","Puerto Rico","Pueyrredon","Punta Alta","Quilmes","Rada Tilly","Rafael Calzada","Rafael Castillo","Rafael Obligado","Rafaela","Ramallo","Ramos Mejia","Ranchos","Rancul","Ranelagh","Rawson","Rawson","Realico","Recoleta","Reconquista","Remedios de Escalada","Resistencia","Retiro","Rio Ceballos","Rio Colorado","Rio Grande","Rio Piedras","Rio Segundo","Rio Tercero","Rivadavia","Rivadavia","Rivadavia","Rocamora","Rodriguez Pena","Rojas","Roldan","Roque Perez","Rosario","Rosas","Rufino","Sacanta","Saenz Pena","Saladillo","Saladillo","Salguero","Salsipuedes","Salta","Salto","Salto Grande","Sampacho","San Andres","San Andres de Giles","San Antonio de Areco","San Antonio de Arredondo","San Antonio de Obligado","San Antonio de Padua","San Antonio Oeste","San Benito","San Bernardo","San Carlos de Bolivar","San Cayetano","San Clemente","San Cristobal","San Fernando","San Fernando del Valle de Catamarca","San Francisco","San Francisco de Santa Fe","San Francisco Solano","San Genaro","San Gregorio","San Guillermo","San Isidro","San Isidro","San Isidro de Lules","San Javier","San Jeronimo Norte","San Jorge","San Jose","San Jose de la Esquina","San Juan","San Justo","San Lorenzo","San Luis","San Manuel","San Martin","San Martin de las Escobas","San Miguel","San Miguel","San Miguel","San Miguel del Monte","San Nicolas","San Pedro","San Pedro","San Rafael","San Salvador","San Salvador","San Salvador de Jujuy","San Telmo","San Vicente","Sanchez","Santa Clara de Saguier","Santa Elena","Santa Fe","Santa Lucia","Santa Lucia","Santa Rita","Santa Rosa","Santa Teresita","Santiago del Estero","Santo Tome","Santos Lugares","Sarandi","Sarmiento","Sarmiento","Segui","Sierra de la Ventana","Sierra de los Padres","Sinsacate","Suipacha","Sunchales","Tablada","Tacuari","Tafi Viejo","Tandil","Tapalque","Tapiales","Temperley","Teodelina","Thames","Tigre","Tio Pujio","Todd","Tornquist","Tortuguitas","Tostado","Totoras","Trelew","Trenque Lauquen","Tres Arroyos","Trevelin","Tristan Suarez","Tunuyan","Tupungato","Turdera","Ucacha","Uriburu","Ushuaia","Valle Hermoso","Vedia","Veinticinco de Mayo","Veinticinco de Mayo","Venado Tuerto","Vera","Veronica","Viale","Viamonte","Vicente Lopez","Victoria","Victoria","Vicuna Mackenna","Viedma","Villa Aberastain","Villa Adelina","Villa Allende","Villa Alsina","Villa Amelia","Villa Angela","Villa Ballester","Villa Bosch","Villa Canas","Villa Carlos Paz","Villa Constitucion","Villa de Maria","Villa de Mayo","Villa del Parque","Villa Dolores","Villa Dominico","Villa Elisa","Villa General Belgrano","Villa Gesell","Villa Giardino","Villa Huidobro","Villa Insuperable","Villa La Angostura","Villa Las Rosas","Villa Lugano","Villa Luzuriaga","Villa Madero","Villa Maria Grande","Villa Media Agua","Villa Mercedes","Villa Mercedes","Villa Nueva","Villa Nueva","Villa Ocampo","Villa Paranacito","Villa Regina","Villa Robles","Villa Rosa","Villa Trinidad","Villa Urquiza","Villaguay","Vuelta de Obligado","Warnes","Wheelwright","Wilde","Winifreda","Yerba Buena","Zenon Pereyra"],"Armenia":["Abovyan","Agarak","Apaga","Aparan","Arabkir","Ashtarak","Erebuni Fortress","Hrazdan","Ijevan","Jermuk","Kapan","Tsaghkadzor","Vanadzor","Yerevan"],"Aruba":["Noord","Oranjestad","Palm Beach","Paradera","Ponton","Sabaneta","San Barbola","Santa Cruz","Sero Blanco","Sint Nicolaas","Tanki Lender"],"Australia":["Abbotsford","Abbotsford","Abbotsham","Aberdeen","Aberfoyle","Aberglasslyn","Abermain","Acacia Ridge","Adamstown","Adelaide","Adelong","Advancetown","Agnes Banks","Agnes Water","Airlie Beach","Aitkenvale","Albany","Albany Creek","Albert Park","Alberton","Alberton","Albion","Albion Park","Albury","Aldgate","Aldinga","Aldinga Beach","Alexandra","Alexandra","Alexandria","Alfredton","Alice Springs","Allambee","Allansford","Allanson","Allora","Alma","Alphington","Alpine","Alstonville","Alton Downs","Altona","Amamoor","Amaroo","Angaston","Anglesea","Anna Bay","Annandale","Apollo Bay","Applecross","Applethorpe","Ararat","Arcadia","Argents Hill","Armadale","Armadale","Armidale","Armstrong Creek","Arno Bay","Arrawarra","Artarmon","Ascot","Ascot Vale","Ashburton","Ashfield","Ashgrove","Ashton","Aspendale","Aspley","Asquith","Atherton","Attadale","Auburn","Augusta","Austinmer","Austins Ferry","Australind","Avalon","Avenue","Avoca Beach","Avondale","Axedale","Aylmerton","Ayr","Babinda","Bacchus Marsh","Bagdad","Bahrs Scrub","Bairnsdale","Baker","Balaclava","Balaklava","Bald Hills","Balgowlah","Balgownie","Balhannah","Ballan","Ballarat","Ballina","Balmain","Balmoral","Balnarring","Balwyn","Balwyn North","Bangalow","Bangor","Banksmeadow","Bankstown","Bannockburn","Barcoo","Barellan","Bargara","Bargo","Baringhup","Barkstead","Barnsley","Barry","Barwon Downs","Barwon Heads","Barwon Heads","Basin View","Bass Hill","Bassendean","Batchelor","Bateau Bay","Batesford","Bathurst","Batlow","Baulkham Hills","Baxter","Bayles","Baynton","Bayswater","Beachmere","Beacon","Beaconsfield","Beaconsfield Upper","Beaudesert","Beaumaris","Beaumont","Beaumont","Beauty Point","Bedford Park","Bedfordale","Beeac","Beechwood","Beechworth","Beenak","Beenleigh","Beerwah","Bega","Belair","Belconnen","Belgian Gardens","Belgrave","Belgrave Heights","Bell","Bellambi","Bellara","Bellbird","Bellbrae","Bellerive","Bellevue Hill","Belmont","Belmont","Belmont","Belrose","Benalla","Benambra","Bendigo","Benowa","Bensville","Bentleigh","Bentleigh East","Bentley","Bentley","Beresfield","Berkeley","Berkeley Vale","Berowra","Berridale","Berrima","Berry","Berwick","Bethania Junction","Beveridge","Beverley","Beverley","Bexley","Bicheno","Bicton","Big Pats Creek","Bilinga","Biloela","Bilpin","Binda","Binnaway","Birdwood","Birkdale","Birkenhead","Black Hill","Black Rock","Blackburn","Blackbutt","Blackheath","Blackmans Bay","Blacktown","Blackwall","Blackwarry","Blackwater","Blackwood","Blackwood","Blair Athol","Blair Athol","Blakehurst","Blaxland","Blayney","Bli Bli","Boambee","Boat Harbour","Bobin","Boddington","Bogangar","Bohle Plains","Bolton","Bolwarra","Bomaderry","Bombala","Bonbeach","Bondi","Boneo","Bongaree","Bonnells Bay","Bonnet Bay","Bonython","Booker Bay","Bool Lagoon","Boolarra","Boonah","Boondall","Booral","Bordertown","Boronia","Botany","Boulder","Bourke","Bowen","Bowenfels","Bowral","Bowraville","Box Hill","Box Hill South","Boyup Brook","Bradbury","Braddon","Braeside","Braidwood","Brandon","Brandy Hill","Branxton","Brewarrina","Briar Hill","Bridgetown","Bridgewater","Bridgewater","Brighton","Brighton","Brighton","Brighton East","Brighton-Le-Sands","Bringelly","Brisbane","Broadbeach","Broadford","Broadmeadows","Broadwater","Broadwater","Broke","Broken Hill","Bronte","Brookdale","Brookfield","Brookfield","Brooklyn","Brookvale","Broome","Brown Hill","Browns Plains","Bruce","Brunswick","Buchan","Buckland","Buderim","Budgewoi","Bulahdelah","Bulga","Bulimba","Bulla","Bulleen","Bulli","Bullsbrook","Bullyard","Buln Buln","Bunbury","Bundaberg","Bundalong","Bundamba","Bundanoon","Bundeena","Bundook","Bundoora","Bungendore","Bungonia","Buninyong","Burekup","Burleigh Heads","Burnett Heads","Burnie","Burnley","Burnside","Burpengary","Burradoo","Burraneer","Burrum","Burrum Heads","Burwood","Burwood","Bushland Beach","Busselton","Butchers Ridge","Buxton","Byford","Byron Bay","Caboolture","Cairns","Calen","Calingiri","Callala Bay","Callington","Caloundra","Caltowie","Camberwell","Cambewarra","Cambridge","Camden","Camden Haven","Cammeray","Campbell","Campbellfield","Campbelltown","Campbelltown","Campbelltown","Camperdown","Camperdown","Canadian","Canberra","Cannington","Cannonvale","Canterbury","Canterbury","Canungra","Capalaba","Caragabal","Caravonica","Carbrook","Cardiff","Cardigan","Cardinia","Cardup","Caringbah","Carlingford","Carlsruhe","Carlton","Carlton North","Carlton South","Carnarvon","Carnegie","Caroline Springs","Carrick","Carrington","Carrum","Carrum Downs","Casino","Casterton","Castle Hill","Castlecrag","Castlemaine","Caulfield","Caulfield North","Caulfield South","Caversham","Cawarral","Cawongla","Cedar Grove","Ceduna","Central Coast","Cessnock","Charlestown","Chatswood","Chatsworth Island","Chelsea","Cheltenham","Chinchilla","Chippendale","Chipping Norton","Christies","Chullora","Churchill","City of Parramatta","City of West Torrens","Clare","Clare","Claremont","Claremont","Clarence Town","Clareville","Clarinda","Clarkefield","Clayton North","Cleveland","Clifton","Clifton Hill","Clifton Springs","Clontarf","Clontarf","Closeburn","Clovelly","Clunes","Clyde","Clyde","Clyde North","Cobbitty","Coburg","Cockatoo","Cockburn","Coffs Harbour","Colac","Coleambally","Coledale","Coleraine","Collaroy","Collie","Collingwood","Collinsvale","Colo","Colo Vale","Como","Concord","Condamine","Condobolin","Coniston","Connells Point","Coober Pedy","Cooee","Coogee","Coogee","Cook","Cooktown","Coolah","Coolamon","Coolangatta","Cooloolabin","Coolum","Coolum Beach","Coolup","Cooma","Coomera","Coonawarra","Coondoo","Cooranbong","Cooroy","Coorparoo","Cootamundra","Copacabana","Copmanhurst","Corinda","Corinthia","Corio","Corlette","Coromandel Valley","Corrimal","Cotham","Cottesloe","Coutts Crossing","Cowan","Cowes","Cowra","Crafers","Craigieburn","Cranbourne","Crawford","Cremorne","Cremorne","Crescent Head","Creswick","Crib Point","Cringila","Cronulla","Crookwell","Crossley","Crows Nest","Crows Nest","Croydon","Croydon","Croydon North","Crystal Creek","Cudlee Creek","Cummins","Cundletown","Curl Curl","Currumbin","Cygnet","Daceyville","Daisy Hill","Dakabin","Dalby","Dalkeith","Dandenong","Dapto","Dardanup","Darkan","Darley","Darling","Darling Point","Darlinghurst","Darlington","Darlington","Darra","Darwin","Davidson","Davistown","Dawson","Dayboro","Daylesford","Deagon","Deakin","Deception Bay","Deepdene","Deer Park","Deloraine","Denham","Denman","Dereel","Derrimut","Derwent","Devonport","Diamond Creek","Diggers Rest","Dilston","Dimboola","Dimbulah","Dingley","Dirranbandi","Dodges Ferry","Dolans Bay","Don","Doncaster","Doncaster East","Donnybrook","Donvale","Doonside","Doreen","Dorrigo","Doubtful Creek","Douglas","Douglas Park","Dover Heights","Drayton","Dromana","Drouin","Drouin South","Drouin West","Drummond Cove","Drummoyne","Drysdale","Dubbo","Dumbalk","Dumbleyung","Dundas","Dundowran","Dungog","Dunkeld","Dunmore","Dunolly","Dunsborough","Dural","Eagle Farm","Eagle Heights","Eagleby","Eaglehawk","Eaglemont","Earlwood","East Fremantle","East Gosford","East Maitland","East Malvern","Eastwood","Eaton","Ebbw Vale","Ebenezer","Echuca","Echunga","Eden","Eden Park","Edge Hill","Edgecliff","Edith","Edithvale","Edmonton","Edwardstown","Eight Mile Plains","Elderslie","Elizabeth","Ellalong","Ellangowan","Ellendale","Ellerslie","Elsternwick","Elsternwick","Eltham","Eltham North","Elwood","Emerald","Emerald","Empire Bay","Emu Park","Emu Plains","Emu Vale","Encounter Bay","Endeavour","Endeavour Hills","Enfield","Engadine","Enmore","Enoggera","Epping","Epping","Erina","Erskine","Eschol","Esk","Esperance","Essendon","Ettalong Beach","Eudlo","Eudunda","Eumundi","Euroa","Evandale","Everton","Exeter","Exmouth","Failford","Fairfield","Fairfield","Fairview","Fairy Meadow","Fassifern","Faulconbridge","Fawkner","Fern Tree","Fern Tree Gully","Ferndale","Ferntree Gully","Fernvale","Ferny Creek","Figtree","Findon","Fingal","Fingal Bay","Fitzroy","Flemington","Flinders","Flinders","Flynn","Footscray","Forbes","Forest","Forest Hill","Forestville","Forrest","Forrest","Forsayth","Forster","Foster","Franklin","Frankston","Freeling","Freemans Reach","Fremantle","Freshwater","Fulham","Fullerton","Fyshwick","Galston","Garfield","Gatton","Gawler","Gayndah","Gaythorne","Geelong","Geelong West","Gellibrand","George Town","Gepps Cross","Geraldton","Gerringong","Gheerulla","Gilberton","Gilmore","Gilston","Gin Gin","Girraween","Gisborne","Gladesville","Gladstone","Glass House Mountains","Glebe","Glen Huntly","Glen Huon","Glen Innes","Glen Iris","Glen Osmond","Glen Waverley","Glenbrook","Glenburn","Glenelg","Glenfield","Glengarry","Glenhaven","Glenorchy","Glenorchy","Glenore Grove","Glenorie","Glenreagh","Glenroy","Glenvale","Glossodia","Gloucester","Golconda","Gold Coast","Golden Grove","Goodna","Goodwood","Goolwa","Goomeri","Goonellabah","Goornong","Gooseberry Hill","Gordon","Gordon","Gordonvale","Gore Hill","Gorokan","Gosford","Gosforth","Gosnells","Goulburn","Gould","Gowrie","Gracemere","Grafton","Grandchester","Grange","Grant","Grantham","Granville","Grassmere","Gravesend","Green Hill","Green Point","Greenbank","Greendale","Greensborough","Greenvale","Greenwich","Gregadoo","Grenfell","Greta","Griffith","Grove","Grovedale","Guildford","Guildford","Gundaroo","Gunnedah","Gymea","Gymea Bay","Gympie","Haberfield","Hackham","Haddon","Hadspen","Hagley","Hahndorf","Hall","Hallam","Hallett","Halls Gap","Hamilton","Hamilton","Hamilton","Hamilton","Hammond","Hampton","Hampton Park","Happy Valley","Harrington","Harristown","Harvey","Hastings","Hastings Point","Hat Head","Hawker","Hawkesbury Heights","Hawksburn","Hawthorn","Hawthorne","Haymarket","Hazelbrook","Hazelwood","Healesville","Heathcote","Heathcote","Heathcote Junction","Heatherton","Heathmont","Heddon Greta","Heidelberg","Helensburgh","Helensvale","Hendon","Hepburn Springs","Hervey Bay","Hexham","Highbury","Highett","Highfields","Hill Top","Hillcrest","Hindmarsh","Hobart","Hoddles Creek","Hollow Tree","Holroyd","Holsworthy","Homebush","Homebush","Hope Island","Hope Valley","Hopetoun","Hoppers Crossing","Hornsby","Horsham","Hove","Howard","Howard Springs","Howden","Howe","Howlong","Hughesdale","Hunter","Hunters Hill","Huntly","Huonville","Hurstbridge","Hurstville","Hurstville Grove","Hyland Park","Illawarra","Illawong","Iluka","Indented Head","Ingham","Ingle Farm","Ingleburn","Inglewood","Innisfail","Inverell","Inverloch","Invermay","Ipswich","Isabella","Ivanhoe","Ivanhoe East","Ives","Jacobs Well","Jannali","Jarrahdale","Jensen","Jilliby","Jimboomba","Jindabyne","Jindivick","Judbury","Junee","Kadina","Kalgoorlie","Kallista","Kalorama","Kambalda","Kangaroo Flat","Kangaroo Point","Kanwal","Kapunda","Karalee","Karana Downs","Kardella","Kardella South","Kareela","Karnup","Karoonda","Karratha","Katherine","Katoomba","Kawungan","Keilor","Keiraville","Keith","Kellyville","Kelmscott","Kelso","Kelvin Grove","Kempsey","Kempton","Kendall","Kenilworth","Kenmore","Kennington","Kensington","Kensington","Kensington and Norwood","Kenthurst","Kenwick","Kerang","Kerry","Keswick","Kettering","Kew","Kew","Kew East","Keysborough","Keysbrook","Kiama","Kilcoy","Kilcunda","Killara","Killarney","Killarney","Killcare","Killingworth","Kilmore","Kilsyth","Kincumber","Kindred","Kingaroy","Kinglake","Kings Cross","Kings Park","Kingscliff","Kingsthorpe","Kingston","Kingston","Kingston","Kingston","Kingswood","Kinross","Kirrawee","Kirribilli","Kirwan","Koah","Kobble","Koetong","Kogarah","Kojonup","Koo-Wee-Rup","Koolewong","Koorawatha","Koornalla","Kootingal","Kooyong","Koroit","Korumburra","Kotara","Kununurra","Kuranda","Kurnell","Kurrajong Heights","Kurri Kurri","Kyabram","Kyneton","Kyogle","Laang","Laguna","Laidley","Lake Cathie","Lake Heights","Lake Illawarra","Lake Munmorah","Lakemba","Lakes Entrance","Lalor","Lambton","Lamington","Lancefield","Lancelin","Landsborough","Lane Cove","Lang Lang","Langhorne Creek","Langley","Langwarrin","Lara","Largs North","Latrobe","Lauderdale","Launceston","Laverton","Laverton","Lavington","Lawgi","Lawnton","Lawson","Lebrina","Leeton","Legana","Leichhardt","Lemon Tree Passage","Lennox Head","Leongatha","Leopold","Lethbridge","Leumeah","Leura","Lewiston","Lidcombe","Lilli Pilli","Lilydale","Limestone","Linden","Lindenow","Lindfield","Lindisfarne","Lisarow","Lismore","Lithgow","Little Bay","Little Hampton","Little River","Liverpool","Loch","Lockhart","Lockridge","Loftus","Logan","Logan City","Logan Village","Loganholme","Loganlea","Long Jetty","Long Plains","Long Point","Longford","Longreach","Longueville","Longwarry","Lovely Banks","Lowanna","Lower Chittering","Lower Plenty","Lowood","Loxton","Luddenham","Ludlow","Lugarno","Lulworth","Lutana","Lyndhurst","Lyndoch","Lyneham","Lyons","Lysterfield","Macarthur","Macedon","Mackay","Macksville","Maclean","Macleod","Macquarie Park","Maddington","Maffra","Magill","Maidenwell","Maitland","Malabar","Maleny","Mallala","Mallanganee","Malmsbury","Malvern","Mandalong","Mandurah","Mangalore","Mangerton","Manildra","Manjimup","Manly","Manly","Mannering Park","Manning","Manning Point","Mannum","Mansfield","Mapleton","Mareeba","Margaret River","Margate","Margate","Marian","Maribyrnong","Marino","Marion","Marlee","Marmor","Marong","Maroochydore","Maroota","Maroubra","Marrickville","Marsden","Marsden Park","Marshalltown","Martins Creek","Marulan","Maryborough","Maryborough","Maryland","Marysville","Mascot","Maslin Beach","Matcham","Matraville","Maudsland","Maybole","Mayfield","Maylands","McCrae","McGraths Hill","McKinnon","McLachlan","McLaren Flat","McLaren Vale","Meadows","Medlow Bath","Medowie","Melbourne","Melrose","Melton","Melton South","Melville","Menai","Menangle","Mentone","Meredith","Merewether","Meringandan","Merlynston","Mernda","Merredin","Merriwa","Merrylands","Middlemount","Middleton","Middleton","Midway Point","Mildura","Mile End","Miles","Milton","Miners Rest","Minlaton","Minmi","Minto","Miranda","Mirani","Mirboo","Mirboo North","Mirrabooka","Mission Beach","Mitcham","Mitcham","Mitchell","Mitchelton","Mitiamo","Mittagong","Moama","Moana","Modbury","Moggill","Mona Vale","Monash","Monbulk","Mont Albert North","Monteagle","Monterey","Montmorency","Montrose","Montville","Mooloolaba","Mooloolah Valley","Moonah","Moonee Ponds","Mooney Mooney","Moorabbin","Mooralla","Moore","Moore Park","Moorooduc","Mooroolbark","Mooroopna","Mooroopna","Moranbah","Morang","Morayfield","Mordialloc","Moree","Moriac","Morisset","Mornington","Morphett Vale","Mortdale","Mortlake","Moruya","Morwell","Mosman","Mosman Park","Moss Vale","Mossman","Mount Barker","Mount Colah","Mount Cotton","Mount Dandenong","Mount Direction","Mount Druitt","Mount Egerton","Mount Eliza","Mount Evelyn","Mount Gambier","Mount Gravatt","Mount Helen","Mount Helena","Mount Isa","Mount Julian","Mount Keira","Mount Larcom","Mount Lofty","Mount Macedon","Mount Martha","Mount Molloy","Mount Morgan","Mount Ousley","Mount Perry","Mount Pleasant","Mount Saint Thomas","Mount Waverley","Mount White","Mourilyan","Muchea","Mudgee","Mudgeeraba","Mudjimba","Mulgoa","Mulgrave","Mullewa","Mullumbimby","Mundaring","Mundijong","Murray Bridge","Murrumba","Murrumbateman","Murrumbeena","Murrurundi","Murtoa","Murwillumbah","Muswellbrook","Mylor","Myrrhee","Myrtleford","Nagambie","Nairne","Nambour","Nambucca Heads","Nana Glen","Nanango","Nannup","Napoleons","Nar Nar Goon","Narangba","Narara","Narellan","Narooma","Narrabeen","Narrabri","Narrandera","Narrawong","Narre Warren","Narre Warren North","Narrogin","Narromine","Neath","Nebo","Nedlands","Neerim South","Nelson Bay","Nerang","Nerrigundah","Nerrina","Neutral Bay","New Farm","New Lambton","New Town","Newcastle","Newmarket","Newnham","Newport","Newport","Newry","Newstead","Newstead","Newstead","Newtown","Newtown","Nhill","Nindaroo","Ningi","Nirranda","Noarlunga","Noble Park","Noosa","Noosaville","Norah","Nords Wharf","Norlane","Norman Park","Normanhurst","Normanton","Normanville","North Beach","North Fitzroy","North Mackay","North Melbourne","North Tamborine","North Turramurra","Northam","Northcote","Northgate","Northmead","Norton Summit","Norwood","Notting Hill","Nowra","Nullawarre","Nunawading","Nuriootpa","Nyora","Oak Park","Oakdale","Oakey","Oakhurst","Oaklands","Oakleigh","Oakleigh South","Oatlands","Oatley","Oberon","Obi Obi","Ocean Shores","Officer","Old Bar","Old Beach","Olinda","Oman-Ama","One Tree Hill","Orange","Orchard Hills","Orford","Orient Point","Ormeau","Ormiston","Ormond","Orroroo","Osborne","Ourimbah","Oxenford","Oxley","Oxley","Oyster Bay","Paddington","Padstow","Pakenham","Pallarenda","Palm Beach","Palm Cove","Palm Island","Palmer","Palmwoods","Pambula","Paradise","Paramatta","Parap","Park Ridge","Parkdale","Parkerville","Parkes","Parkhurst","Parkville","Parkwood","Pearce","Pearcedale","Pechey","Pelican","Pendle Hills","Penfield","Penguin","Pennant Hills","Penrith","Penshurst","Perenjori","Perth","Perth","Peterborough","Petrie","Phillip","Pialba","Piawaning","Picnic Bay","Picton","Piggabeen","Pimpama","Pine Mountain","Pinery","Pinjarra","Pinkenba","Pioneer","Pipers Brook","Pitt Town","Pittsworth","Plympton","Point Clare","Point Cook","Point Lonsdale","Point Lookout","Point Pass","Point Vernon","Pokolbin","Pomona","Pontville","Poowong","Port Adelaide","Port Augusta","Port Douglas","Port Fairy","Port Hacking","Port Hedland","Port Kembla","Port Lincoln","Port MacDonnell","Port Macquarie","Port Melbourne","Port Noarlunga","Port Pirie","Port Sorell","Portarlington","Portland","Portsea","Potts Point","Prahran","Preston","Proserpine","Prospect","Purnim","Pymble","Pyrmont","Quakers Hill","Queanbeyan","Queenscliff","Queensferry","Queenstown","Railton","Ramsgate","Randwick","Rathmines","Ravenswood","Raworth","Raymond Terrace","Red Hill","Redan","Redbank","Redcliffe","Redfern","Redhead","Redland Bay","Redlynch","Reedy Creek","Regents Park","Research","Reservoir","Retreat","Revesby","Reynella","Rhodes","Riana","Richmond","Richmond","Riddell","Ridgley","Ringwood","Ringwood East","Ringwood North","Ripley","Risdon","River Heads","Riverside","Riverstone","Riverton","Riverview","Riverwood","Robertson","Robertstown","Robinvale","Rochedale","Rochester","Rockbank","Rockdale","Rockhampton","Rockingham","Rocklea","Rodborough","Rokeby","Roleystone","Roma","Romsey","Rooty Hill","Rosanna","Rose Bay","Rosebery","Rosebery","Rosebud","Rosehill","Roseville","Rosewood","Roseworthy","Ross","Ross Creek","Ross River","Rowville","Royal Park","Rozelle","Rudall","Rushworth","Rutherford","Rydalmere","Ryde","Rye","Rylstone","Safety Bay","Saint Albans","Saint Andrews","Saint George","Saint Georges Basin","Saint Helena","Saint Ives","Saint James","Saint Leonards","Saint Lucia","Saint Marys","Saint Peters","Saints","Salamander Bay","Sale","Salisbury","Salt Ash","Samford","San Remo","Sanctuary Point","Sandford","Sandgate","Sandgate","Sandringham","Sandstone Point","Sandy Bay","Sandy Hollow","Sans Souci","Sapphire","Sarina","Sarina Beach","Sassafras","Scarborough","Scarborough","Scarness","Scarsdale","Schofields","Scone","Scoresby","Scottsdale","Seacliff","Seacombe","Seaford","Seaford","Seaforth","Seaton","Seaview","Sebastopol","Selbourne","Selby","Sellicks Beach","Sellicks Hill","Semaphore","Serpentine","Seven Hills","Seven Mile Beach","Seville","Seville East","Seymour","Sheffield","Shellharbour","Shenton Park","Sherbrook","Shoal Point","Shorncliffe","Silvan","Silverdale","Silverwater","Singleton","Sippy Downs","Slacks Creek","Smithfield","Smithfield","Smithton","Smythes Creek","Smythesdale","Snowtown","Somersby","Somerset","Somerset","Somerton","Somerville","Sorrento","South Melbourne","South Perth","South West Rocks","South Yarra","Southbank","Southern Brook","Southport","Spearwood","Spencer","Spotswood","Spreyton","Spring Field","Spring Hill","Spring Hill","Springfield","Springvale","Springvale South","Springwood","St Helens","St Kilda","Stanhope","Stanley","Stanmore","Stannum","Stanthorpe","Stapylton","Stawell","Stieglitz","Stirling","Stirling","Stockton","Stockyard Creek","Stoneville","Stradbroke","Stratford","Stratford","Strathalbyn","Strathfield","Strathfieldsaye","Strathmore","Strathpine","Streaky Bay","Stroud","Stuart Park","Sturt","Subiaco","Success","Suffolk Park","Sulphur Creek","Summerholm","Summertown","Sunbury","Sunnybank","Sunnyside","Sunshine","Surfers Paradise","Surrey Hills","Sutherland","Swan Hill","Swan View","Swansea","Swansea","Sydenham","Sydney","Sylvania","Sylvania Waters","Tahmoor","Tallangatta","Tallarook","Tallebudgera","Talmalmo","Tambo Upper","Tamborine","Tammin","Tamworth","Tannum Sands","Tanunda","Taree","Taren Point","Tarlee","Tarneit","Taroona","Tarragindi","Tarrawanna","Tarro","Tarzali","Tatura","Tawonga","Teesdale","Telegraph Point","Temora","Tempe","Templestowe","Templestowe Lower","Tenambit","Tennyson","Tenterfield","Teralba","Terrigal","Terry Hills","Tewantin","Thagoona","Thargomindah","The Basin","The Entrance","The Oaks","The Patch","The Rocks","Thebarton","Thirlmere","Thirroul","Thomastown","Thompson","Thornbury","Thornlands","Thornleigh","Thornton","Thuringowa","Thursday Island","Tiaro","Tieri","Tinamba","Tincurrin","Tingoora","Tolga","Tom Price","Tomago","Tongala","Toogoolawah","Toogoom","Toolangi","Toolern Vale","Toongabbie","Toora","Tooradin","Toorak","Toorbul","Tooronga","Toowong","Toowoomba","Torbanlea","Toronto","Torquay","Torquay","Tottenham","Toukley","Townsville","Towradgi","Trafalgar","Traralgon","Traralgon South","Trentham","Trinity Beach","Truganina","Trunkey","Tuggerah","Tuggeranong","Tugun","Tullamarine","Tully","Tumut","Tuncurry","Tunnack","Turners Beach","Turramurra","Tweed Heads","Two Rocks","Two Wells","Tyabb","Tyalgum","Tynong","Uki","Ulladulla","Ulmarra","Ultimo","Ulverstone","Umina","Unanderra","Underwood","Unley","Upper Brookfield","Upper Burringbar","Upper Caboolture","Upper Coomera","Upwey","Uraidla","Urangan","Valla Beach","Valley Heights","Vaucluse","Venus Bay","Verdun","Vermont","Victor Harbor","Victoria Park","Victoria Point","Villawood","Vineyard","Virginia","Virginia","Waaia","Wacol","Wagga Wagga","Wahgunyah","Wahroonga","Waikerie","Waitara","Walgett","Walhalla","Wallacia","Wallan","Wallaroo","Wallington","Walliston","Wallsend","Walmer","Wamberal","Wamuran","Wanbi","Wandin North","Wandoan","Wangaratta","Wangi Wangi","Wanneroo","Wantirna","Wantirna South","Waratah","Warburton","Warnbro","Warnervale","Warragul","Warrandyte","Warrane","Warrawong","Warren","Warren Shire","Warrigal","Warrimoo","Warrnambool","Warwick","Waterford","Waterloo","Waterloo","Waterloo","Waterloo Corner","Watsonia","Wattle Grove","Wattle Grove","Waubra","Wauchope","Waurn Ponds","Waverley","Waverton","Wayville","Wedderburn","Wedderburn","Weetah","Weethalle","Wellard","Wellington","Wellington Point","Welshpool","Wembley","Wendouree","Wentworth","Wentworth Falls","Wentworthville","Werribee","Werribee South","West Burleigh","West End","West Hoxton","West Pymble","West Wyalong","Westbrook","Westfield","Westmead","Weston","Weston Creek","Wheelers Hill","White Rock","Whitfield","Whittlesea","Whyalla","Wickham","Wickham","Wilberforce","Willaston","Willaura","Williams","Williamstown","Williamstown","Willow Grove","Willow Vale","Willunga","Wilmot","Wilson","Wilton","Wiluna","Wimbledon","Winchelsea","Windang","Windaroo","Windellama","Windermere Park","Windsor","Windsor","Windsor","Windsor","Windsor Downs","Wingham","Winkleigh","Wodonga","Wollar","Wollert","Wollongbar","Wollongong","Womboota","Won Wron","Wondai","Wonga Park","Wongan Hills","Wonthaggi","Woodburn","Woodend","Woodford","Woodford","Woodgate","Woodleigh","Woodridge","Woodside","Woodstock","Woodvale","Woodville","Woolamai","Woolgoolga","Woolloomooloo","Woolooware","Wooloweyah","Woolwich","Woombah","Woombye","Woonona","Woori Yallock","Woorim","Wooroolin","Worongary","Woronora","Woy Woy","Wulkuraka","Wyalkatchem","Wyalong","Wyee","Wyndham","Wynnum","Wynyard","Wyong","Wyongah","Wyreema","Yaamba","Yackandandah","Yallingup","Yallourn","Yallourn North","Yamba","Yanchep","Yandina","Yangan","Yankalilla","Yapeen","Yaroomba","Yarpturk","Yarra Glen","Yarra Junction","Yarragon","Yarram","Yarraman","Yarrambat","Yarraville","Yarrawarrah","Yass","Yatala","Yea","Yellow Rock","Yenda","Yeoval","Yeppoon","Yerrinbool","Yinnar","Yolla","York","Yorkeys Knob","Young","Yowie Bay","Zeehan"],"Austria":["Absam","Absdorf","Abtenau","Abtsdorf","Ach","Achenkirch","Achensee","Admont","Adnet","Afritz","Aggsbach","Aichbach","Aichdorf","Aifersdorf","Aigen","Aigen im Muehlkreis","Ainet","Aistersheim","Alberndorf in der Riedmark","Alberschwende","Aldrans","Alkoven","Alland","Allhartsberg","Alpbach","Altach","Altenberg","Altenberg bei Linz","Altenburg","Altendorf","Altendorf","Altenhof am Hausruck","Altenmarkt an der Triesting","Altenmarkt im Pongau","Altheim","Althofen","Altlengbach","Altlichtenwarth","Altmunster","Altwaidhofen","Am See","Amaliendorf","Ampass","Ampfelwang","Amstetten","Andorf","Anger","Anif","Annenheim","Ansfelden","Anthering","Apfelberg","Arbesthal","Ardagger Markt","Ardning","Arnoldstein","Arriach","Asberg","Aschach an der Donau","Aschau","Aspang Markt","Asparn","Asperhofen","Asten","Attersee","Attnang-Puchheim","Atzbach","Au","Auersthal","Aufhausen","Augsdorf","Aurolzmunster","Axams","Bach","Bad Blumau","Bad Deutsch-Altenburg","Bad Erlach","Bad Fischau","Bad Gams","Bad Gastein","Bad Gleichenberg","Bad Goisern","Bad Hall","Bad Hofgastein","Bad Ischl","Bad Kreuzen","Bad Pirawarth","Bad Radkersburg","Bad Schallerbach","Bad Tatzmannsdorf","Bad Voslau","Baden bei Wien","Baernbach","Baldramsdorf","Bartholomaberg","Barwies","Bauer","Baumgarten im Burgenland","Baumgartenberg","Baumkirchen","Berg","Bergau","Bergheim","Berndorf","Bernhardsthal","Bernstein","Berwang","Bezau","Biberbach","Biberwier","Bichlbach","Biedermann","Biedermannsdorf","Birgitz","Bisamberg","Bizau","Bleiberg ob Villach","Bleiburg","Blindenmarkt","Bludenz","Bludesch","Blumau","Bockfliess","Bodensdorf","Boheimkirchen","Bosendurnbach","Bramberg am Wildkogel","Brandberg","Braunau am Inn","Bregenz","Breitenbrunn","Breitenfurt bei Wien","Breitenwang","Brixen im Thale","Bruck am Ziller","Bruck an der Grossglocknerstrasse","Bruck an der Leitha","Bruck an der Mur","Bruckl","Bruckneudorf","Bruendl","Bruggen","Brunn am Gebirge","Buch","Buch bei Jenbach","Buchkirchen","Burgkirchen","Burgschleinitz","Burmoos","Dalaas","Dechantskirchen","Dellach","Desselbrunn","Deutsch Goritz","Deutsch-Wagram","Deutschfeistritz","Deutschkreutz","Deutschlandsberg","Diepoltsham","Dietach","Dietersdorf am Gnasbach","Dobersberg","Dobersdorf","Doblbach","Dobldorf","Doebriach","Donnerskirchen","Doren","Dorf","Dorfgastein","Dorfla","Dornbirn","Drassburg","Drassmarkt","Dross","Durnstein","Ebbs","Eben im Pongau","Ebenau","Ebendorf","Ebenfurth","Ebensee","Ebenthal","Ebergassing","Eberndorf","Eberschwang","Ebersdorf","Eberstein","Ebreichsdorf","Eckartsau","Edelschrott","Edelstal","Edlitz","Edt bei Lambach","Eferding","Egg","Egg am Faaker See","Eggenburg","Eggendorf","Eggendorf","Eggendorf im Thale","Eggersdorf bei Graz","Ehrenhausen","Ehrwald","Eibiswald","Eichgraben","Eisbach","Eisenberg","Eisenerz","Eisenstadt","Eisentratten","Eisgarn","Elixhausen","Ellmau","Elsbethen","Emberg","Emmersdorf an der Donau","Engelhartszell","Engersdorf","Engerwitzdorf","Enns","Ennsdorf","Enzenkirchen","Enzenreith","Enzersdorf an der Fischa","Enzersfeld","Enzesfeld","Erlauf","Ernst","Ernstbrunn","Ernsthofen","Erpersdorf","Erpfendorf","Esternberg","Eugendorf","Faak am See","Falkenburg","Fehring","Feistritz","Feistritz an der Drau","Feld am See","Feldbach","Feldkirch","Feldkirchen an der Donau","Feldkirchen bei Graz","Feldkirchen bei Mattighofen","Feldkirchen in Karnten","Felixdorf","Ferndorf","Fernitz","Feuchten","Feuersbrunn","Fieberbrunn","Filzmoos","Finkenberg","Finsing","Fischamend Dorf","Fischbach","Fischerndorf","Fiss","Flachau","Fladnitz im Raabtal","Flattach","Fliess","Flinsdorf","Foederlach","Fohnsdorf","Forst","Frankenburg","Frankenmarkt","Frattingsdorf","Frauenkirchen","Freienstein","Freilassing","Freinberg","Freistadt","Friedburg","Friesach","Frohnleiten","Fuernitz","Fuerstenfeld","Fugen","Fulpmes","Furthof","Fusch an der Glocknerstrasse","Fuschl am See","Fussach","Gaaden","Gaal","Gablitz","Gaflenz","Gailitz","Gaisberg","Gallbrunn","Gallneukirchen","Gallspach","Gallzein","Galtur","Gaming","Gampern","Gansbach","Ganserndorf","Gargellen","Gars am Kamp","Garsten","Gaschurn","Gaspoltshofen","Gasthof","Gattendorf","Gaweinstal","Geinberg","Geras","Gerasdorf am Steinfelde","Gerasdorf bei Wien","Gerersdorf","Gerlos","Getzersdorf","Gfohl","Giesshubl","Glan","Glaubendorf","Gleisdorf","Glinzendorf","Gloggnitz","Gmund","Gmunden","Gnadenwald","Gnas","Gobelsburg","Goedersdorf","Goesselsdorf","Gofis","Going","Goldegg","Gollersdorf","Golling an der Salzach","Gols","Gortipohl","Gosau","Gosdorf","Gosing","Gostling an der Ybbs","Gotzendorf","Gotzendorf an der Leitha","Gotzens","Gotzis","Grabelsdorf","Graen","Grafenbach","Grafendorf","Grafendorf bei Hartberg","Grafendorf bei Stainz","Grafenschlag","Grafenstein","Grafenweg","Grafenworth","Gramastetten","Gramatneusiedl","Grambach","Gratkorn","Gratwein","Graz","Grein","Gresten","Gries","Gries am Brenner","Grieselstein","Grieskirchen","Griffen","Grimmenstein","Grobming","Grodig","Gross","Gross-Enzersdorf","Gross-Schweinbarth","Gross-Siegharts","Grossarl","Grossebersdorf","Grossklein","Grosspesendorf","Grossraming","Grossrussbach","Grossweikersdorf","Grunbach am Schneeberg","Gruner Baum","Gschnitz","Guessing","Gugging","Guglwald","Gumpoldskirchen","Gunselsdorf","Gunskirchen","Guntersdorf","Guntramsdorf","Gurten","Gurtis","Gutau","Gutenstein","Guttaring","Haag","Haag","Haag am Hausruck","Hadersdorf am Kamp","Hadersfeld","Hadres","Hagenberg im Muhlkreis","Haibach ob der Donau","Haid","Haidershofen","Haiming","Haimingerberg","Hainburg an der Donau","Hainfeld","Halbturn","Haldensee","Hall","Hall in Tirol","Hallein","Haller","Hallstatt","Harbach","Hard","Hart","Hartberg","Hartkirchen","Haslau an der Donau","Hatting","Hatzendorf","Haus","Hausbrunn","Hausleiten","Hausmannstatten","Hautzendorf","Heidenreichstein","Heiligenkreuz am Waasen","Heimschuh","Heissberg","Heissingfelding","Heiterwang","Hellmonsodt","Henndorf am Wallersee","Hennersdorf","Hermagor","Hernstein","Herrnbaumgarten","Herzogenburg","Herzogsdorf","Himberg","Himmelreich","Hinterbruehl","Hinterburg","Hinterglemm","Hintersdorf","Hinterstoder","Hinterthiersee","Hintertux","Hinterwaldberg","Hipping","Hirm","Hirschegg","Hirtenberg","Hochburg","Hochgurgl","Hochleithen","Hochneukirchen","Hochsoelden","Hochst","Hoehe","Hof am Leithaberge","Hof bei Salzburg","Hofen","Hofkirchen im Traunkreis","Hoflein","Hofstatten an der Raab","Hofstetten","Hohenau","Hohenberg","Hohenburg","Hoheneich","Hohenems","Hohentauern","Hohenwarth","Hohenzell","Hohnhart","Hollabrunn","Hollenthon","Hollersbach im Pinzgau","Holzhausen","Hopfgarten im Brixental","Horbranz","Horersdorf","Horn","Hornstein","Horsching","Huetten","Huttschlag","Igls","Im Brand","Imst","Innerkrems","Innermanzing","Innsbruck","Inzersdorf im Kremstal","Inzing","Ischgl","Isper","Jagenbach","Jagerberg","Japons","Jeging","Jenbach","Jennersdorf","Jerzens","Jochberg","Jois","Judenau","Judenburg","Judendorf","Jungholz","Kainach bei Voitsberg","Kaindorf","Kalsdorf bei Graz","Kaltenbrunn","Kaltenleutgeben","Kanzelhoehe","Kapelln","Kapfenberg","Kapfing","Kappern","Kappl","Kaprun","Karl","Karlstetten","Karteis","Katsdorf","Katzelsdorf","Kaumberg","Kefermarkt","Kematen in Tirol","Kennelbach","Keutschach am See","Kienberg","Kierling","Kilb","Kindberg","Kirchbach in Steiermark","Kirchberg am Wagram","Kirchberg in Tirol","Kirchbichl","Kirchdorf an der Krems","Kirchdorf in Tirol","Kirchham","Kirchschlag","Kirchschlag bei Linz","Kittsee","Klagenfurt","Klam","Klaus","Klein-Harras","Kleinbergl","Kleinkirchheim","Kleinstubing","Klingfurth","Klosterle","Klostermarienberg","Klosterneuburg","Knappenberg","Knittelfeld","Kobenz","Kobersdorf","Koblach","Koestenberg","Koetschach","Koflach","Kollmitzberg","Konigstetten","Konigswiesen","Kopfing im Innkreis","Koppl","Korneuburg","Kossen","Kottingbrunn","Kottmannsdorf","Kraig","Kramsach","Krems","Kremsbruecke","Kremsdorf","Kremsmunster","Krenglbach","Kreuz","Krieglach","Krispl","Kritzendorf","Kroatisch Minihof","Krottendorf bei Ligist","Krumbach","Krumbach Markt","Krumegg","Krumpendorf","Kuchl","Kuehnsdorf","Kuehtai","Kufstein","Kumberg","Kundl","Laa an der Thaya","Laab im Walde","Laaben","Laakirchen","Labach","Lambrechten","Lamprechtshausen","Landeck","Landegg","Landskron","Lanersbach","Langeck im Burgenland","Langenlois","Langenrohr","Langenstein","Langenzersdorf","Lannach","Lanzenkirchen","Lassee","Lassnitzhohe","Latschach","Launsdorf","Lauterach","Lavamund","Lavant","Laxenburg","Lebring","Lech","Lechaschau","Leibnitz, Styria","Leisach","Leiten","Leitring","Lembach im Muhlkreis","Lend","Lendorf","Lenzing","Leoben","Leobendorf","Leobersdorf","Leogang","Leonding","Leonfelden","Leopoldsdorf","Lermoos","Leutasch","Leutschach","Lichtenau","Lichtenberg","Lichtenegg","Lichtenworth","Liebenfels","Lieboch","Lienz","Liesfeld","Liezen","Ligist","Lilienfeld","Lindenberg","Linz","Litschau","Lobenstein","Lochau","Lochen","Lofer","Lohnsburg","Loimersdorf","Loipersbach","Loosdorf","Loretto","Ludesch","Luftenberg an der Donau","Lungotz","Lustenau","Lutzmannsburg","Mader","Madseit","Maglern","Maiersdorf","Maildorf","Mairhof","Maissau","Mallnitz","Mandling","Mank","Mannersdorf am Leithagebirge","Mannersdorf an der Rabnitz","Mannsworth","Marbach","Marchegg","Marchtrenk","Margarethen am Moos","Maria Alm am Steinernen Meer","Maria Buch","Maria Elend","Maria Ellend","Maria Enzersdorf","Maria Lankowitz","Maria Lanzendorf","Maria Saal","Maria Schmolln","Maria Taferl","Maria Worth","Maria-Anzbach","Mariazell","Markgrafneusiedl","Markt Allhau","Markt Neuhodis","Markt Piesting","Marktl","Marz","Mathon","Matrei am Brenner","Matrei in Osttirol","Mattersburg","Mattsee","Mauerbach","Mauerkirchen","Maurach","Mauterndorf","Mauthausen","Mayrhofen","Meggenhofen","Mehrnbach","Meiningen","Meisten","Melk","Mellach","Mettmach","Michelbach Markt","Micheldorf in Oberoesterreich","Mieming","Miesenbach","Miesenbach","Millstatt","Mistelbach","Mittelberg","Mitterdorf im Muerztal","Mitterkirchen im Machland","Mitterndorf an der Fischa","Mittersill","Moellbruecke","Mollersdorf","Molln","Mollram","Monchhof","Mondsee","Moos","Moosburg","Moosdorf","Mooskirchen","Mosern","Motz","Muckendorf an der Donau","Muerzhofen","Muerzsteg","Muerzzuschlag","Muhlbach am Manhartsberg","Munchendorf","Muntlix","Munzbach","Munzkirchen","Murau","Murfeld","Mutters","Naarn im Machlande","Nassereith","Natternbach","Nauders","Neckenmarkt","Neidling","Nenzing","Nesselwangle","Nestelbach bei Graz","Neudau","Neudorf bei Landsee","Neudorf bei Staatz","Neudorfl","Neufeld an der Leitha","Neuhofen","Neuhofen an der Krems","Neuhofen an der Ybbs","Neukirchen","Neukirchen am Walde","Neukirchen an der Enknach","Neukirchen an der Vockla","Neulengbach","Neumarkt am Wallersee","Neumarkt an der Ybbs","Neumarkt im Hausruckkreis","Neumarkt im Muhlkreis","Neumarkt in Steiermark","Neunkirchen","Neusiedl am See","Neusiedl bei Guessing","Neustift","Neutal","Neuzeug","Nickelsdorf","Niederachen","Niederalm","Niederdorf","Niederkreuzstetten","Niederland","Niederleis","Niederndorf","Niederneukirchen","Niederwaldkirchen","Niederwolz","Nochling","Nussdorf","Nussdorf am Haunsberg","Nuziders","Obdach","Ober-Grafendorf","Oberaich","Oberaichwald","Oberalm","Oberau","Obergruenburg","Obergurgl","Oberhausen","Oberhofen im Inntal","Oberkappel","Oberkirchbach","Oberkohlstaetten","Obernberg","Obernberg am Brenner","Oberndorf an der Melk","Oberndorf bei Salzburg","Oberneukirchen","Oberort","Oberperfuss","Oberpullendorf","Oberrohrbach","Oberschutzen","Obersdorf","Obersiebenbrunn","Obertauern","Obertrum am See","Obervellach","Oberwaltersdorf","Oberwart","Oberweis","Oberwolbling","Obritzberg","Obsteig","Oed","Oehling","Oepping","Oetz","OEtztal-Bahnhof","Offenhausen","Oftering","Oggau","Ohlsdorf","Ollern","Opponitz","Ort im Innkreis","Orth an der Donau","Oslip","Ossiach","Ostermiething","Ottendorf bei Gleisdorf","Ottenheim","Ottensheim","Pabneukirchen","Pachfurth","Paldau","Panzendorf","Parndorf","Parschlug","Pasching","Passail","Passthurn","Patsch","Pattergassen","Payerbach","Peggau","Perchtoldsdorf","Perg","Pernegg an der Mur","Pernitz","Pertisau","Perwang am Grabensee","Petersdorf","Petronell-Carnuntum","Pettenbach","Pettnau","Pettneu","Petzenkirchen","Peuerbach","Pfaffstatten","Pfons","Pfunds","Piberbach","Pichl","Pichl bei Wels","Pichling bei Stainz","Piesendorf","Pillberg","Pillichsdorf","Pinggau","Pinkafeld","Pinsdorf","Piringsdorf","Pirka","Pischeldorf","Pischelsdorf am Engelbach","Pischelsdorf in Steiermark","Pitten","Plangeross","Plankenau","Plescherken","Pochlarn","Poelten","Poertschach am Woerthersee","Poetting","Poggstall","Polfing","Pottelsdorf","Pottenbrunn","Pottendorf","Pottenstein","Pottsching","Potzneusiedl","Poysbrunn","Poysdorf","Prabach","Pram","Preding","Pregarten","Pressbaum","Prinzersdorf","Puch","Puch bei Hallein","Puchberg am Schneeberg","Puchenau","Pucking","Purbach","Purbach am Neusiedlersee","Purgg","Purgstall","Purgstall","Purkersdorf","Pyhra","Raab","Raaba","Raabs an der Thaya","Radfeld","Radstadt","Ramsau im Zillertal","Randegg","Rangersdorf","Rankweil","Rannersdorf","Rappoltenkirchen","Rauchenwarth","Rauris","Redlham","Regau","Regelsbrunn","Reichenau an der Rax","Reichenau im Muhlkreis","Reichendorf","Reichraming","Reifnitz","Reisenberg","Reitdorf","Reith","Reith bei Seefeld","Reith im Alpbachtal","Rekawinkel","Reutte","Ried im Innkreis","Ried im Traunkreis","Ried im Zillertal","Ried in der Riedmark","Riedenthal","Rieding","Riedlingsdorf","Riefensberg","Riegersburg","Riezlern","Ringelsdorf","Rinn","Rohrau","Rohrbach am Kulm","Rohrbach am Steinfelde","Rohrbach in Oberosterreich","Rohrmoos","Roppen","Rosegg","Rosenau am Hengstpass","Rosenbach","Rosental","Rosental","Rotenbach","Rothis","Rotholz","Rottenbach","Rottenmann","Rubring","Ruden","Rudersdorf","Rum","Rutzenmoos","Saalbach","Saalfelden am Steinernen Meer","Sachendorf","Sachsenburg","Saint Anton","Salzburg","Sankt Agatha","Sankt Andra am Zicksee","Sankt Andrae","Sankt Florian","Sankt Gallenkirch","Sankt Georgen am Ybbsfelde","Sankt Georgen im Attergau","Sankt Johann im Pongau","Sankt Kanzian","Sankt Kathrein am Hauenstein","Sankt Lorenzen","Sankt Lorenzen im Muerztal","Sankt Margarethen im Burgenland","Sankt Marienkirchen am Hausruck","Sankt Martin am Techelsberg","Sankt Martin am Ybbsfelde","Sankt Michael im Burgenland","Sankt Michael in Obersteiermark","Sankt Oswald","Sankt Pankraz","Sankt Peter","Sankt Polten","Sankt Ruprecht an der Raab","Sankt Stefan im Rosental","Sankt Ulrich bei Steyr","Sankt Valentin","Sankt Veit an der Glan","Sankt Veit im Pongau","Sankt Wolfgang","Sankt Wolfgang","Sarleinsbach","Satteins","Sauerbrunn","Sausenstein","Schachendorf","Schalchen","Schardenberg","Scharding","Scharnstein","Scharten","Schattendorf","Scheffau am Wilden Kaiser","Scheifling","Schiefling am See","Schladming","Schleinbach","Schlierbach","Schlins","Schlitters","Schmirn","Schneeberg","Schoenau","Schoenberg im Stubaital","Schoerfling","Schonbuhel an der Donau","Schongrabern","Schonkirchen","Schoppernau","Schrems","Schruns","Schutzen am Gebirge","Schwadorf","Schwaigs","Schwanberg","Schwanenstadt","Schwarzach","Schwarzach im Pongau","Schwarzau am Steinfelde","Schwarzau im Gebirge","Schwarzenau","Schwarzenberg am Boehmerwald","Schwaz","Schwechat","Schweiggers","Schwendau","Schwertberg","Schwoich","Sebersdorf","Seckau","Seeboden","Seefeld in Tirol","Seeham","Seekirchen am Wallersee","Seewalchen","Seiersberg","Seitenstetten Markt","Semmering","Semriach","Serfaus","Sernau","Sibratsgfall","Siebenhirten","Siebenhirten","Siegendorf im Burgenland","Sieghartskirchen","Sierndorf","Sierning","Siezenheim","Sillian","Silz","Sinabelkirchen","Sinnersdorf","Sipbachzell","Sirnitz","Sistrans","Sitzenberg","Solden","Soll","Sollenau","Sommerein","Sooss","Spielberg bei Knittelfeld","Spillern","Spital am Pyhrn","Spittal an der Drau","Spitz","Spratzern","Staatz","Stadelbach","Stadl-Paura","Stadtschlaining","Stainz","Stainz bei Straden","Stams","Stans","Stattegg","Statzendorf","Steg","Stegersbach","Stein an der Donau","Stein an der Enns","Stein im Jauntal","Steinabruckl","Steinach am Brenner","Steinakirchen am Forst","Steinberg bei Ligist","Steindorf am Ossiacher See","Steinerberg","Steinerkirchen an der Traun","Steinfeld","Steinhaus","Steinhaus am Semmering","Stettenhof","Steyr","Steyregg","Stiegl","Stockerau","Stoob","Straden","Strass","Strassen","Strassengel","Strasshof an der Nordbahn","Strasswalchen","Strau","Strobl","Stubach","Stubenberg","Studenzen","Stuhlfelden","Stuhlsdorf","Stumm","Stummerberg","Sulz","Sulz im Wienerwald","Sulzau","Sulzberg","Tadten","Tal","Tamsweg","Tannheim","Tarrenz","Tattendorf","Taufkirchen an der Pram","Taufkirchen an der Trattnach","Tauplitz","Taxenbach","Telfes im Stubai","Telfs","Ternberg","Ternitz","Teufenbach","Thal","Thalgau","Thalheim bei Wels","Thalling","Thaur","Thaya","Theresienfeld","Thoerl","Thuringen","Tiefenbach","Tiefgraben","Tieschen","Tirol","Tobaj","Toeschling","Toesenssteinach","Traboch","Traisen","Traiskirchen","Traismauer","Trasdorf","Traun","Traunkirchen","Traunstein","Trausdorf an der Wulka","Trautmannsdorf an der Leitha","Tribuswinkel","Trieben","Tristach","Troepolach","Trofaiach","Trumau","Tschagguns","Tschoeran","Tulln","Tullnerbach-Lawies","Tumeltsham","Turnitz","Turrach","Tweng","Uderns","Ulmerfeld","Ulrichsberg","Ulrichskirchen","Ungenach","Unterberg","Untergrub","Unterjoch","Unterlamm","Unterparschenbrunn","Unterpremstatten","Unterpullendorf","Unterpurkla","Unterradlberg","Unterrohr","Unterrohr","Untersiebenbrunn","Unterwaltersdorf","Unterweitersdorf","Unzmarkt","Uttendorf","Utzenaich","Veitsch","Velden am Woerthersee","Vent","Vienna","Vigaun","Viktorsberg","Viktring","Villach","Virgen","Vitis","Vocklabruck","Vocklamarkt","Voelkermarkt","Voitsberg","Volders","Vols","Vorau","Vorchdorf","Vorderlanersbach","Vordernberg","Vosendorf","Wagna","Wagrain","Waidhofen an der Thaya","Waidhofen an der Ybbs","Waidmannsfeld","Waidring","Waizenkirchen","Walbersdorf","Walchsee","Wald am Arlberg","Waldenstein","Walding","Waldkirchen am Wesen","Waldzell","Wallern an der Trattnach","Wallern im Burgenland","Wallsee","Wals","Waltersdorf an der March","Waltersdorf in Oststeiermark","Wampersdorf","Wang","Wangle","Wartberg","Wartberg an der Krems","Warth","Warth","Wattens","Watzelsdorf","Watzendorf","Waxenberg","Weibern","Weiden am See","Weigelsdorf","Weikendorf","Weikersdorf am Steinfelde","Weilbach","Weiler","Weinburg am Sassbach","Weissbriach","Weissenbach am Lech","Weissenkirchen in der Wachau","Weisskirchen an der Traun","Weisskirchen in Steiermark","Weiten","Weitersfeld","Weitra","Weiz","Wels","Weng bei Admont","Weng im Innkreis","Wenns","Weppersdorf","Werfen","Werfenweng","Werndorf","Wernstein am Inn","Westendorf","Wettmannstatten","Wiener Neudorf","Wiener Neustadt","Wienerherberg","Wies","Wieselburg","Wiesing","Wiesmath","Wieting","Wildon","Wilfleinsdorf","Wilhelmsburg","Wilhering","Wimpassing an der Leitha","Wimpassing im Schwarzatale","Winden am See","Windischgarsten","Winkl","Winzendorf","Woelfnitz","Wolfau","Wolfpassing","Wolfsberg","Wolfsgraben","Wolfurt","Wolkersdorf im Weinviertel","Wollersdorf","Wordern","Worgl","Wulkaprodersdorf","Wundschuh","Wurflach","Wurmbrand","Ybbs an der Donau","Ybbsitz","Zams","Zeillern","Zeiselmauer","Zell am Moos","Zell am See","Zell am Ziller","Zell an der Ybbs","Zellerndorf","Zeltweg","Zemendorf","Zettling","Ziersdorf","Zillingdorf","Zillingtal","Zipf","Zirl","Zistersdorf","Zobing","Zuers","Zurndorf","Zwentendorf","Zwettl Stadt","Zwolfaxing"],"Azerbaijan":["Baku","Nakhchivan","Quba","Qusar","Sulutapa","Sumqayit","Xirdalan","Zurges"],"Bahamas":["Andros Town","Dunmore Town","Freeport","Marsh Harbour","Nassau","Palmetto Point","Spanish Wells"],"Bahrain":["Al Budayyi`","Al Hadd","Al Hamalah","Al Janabiyah","Al Markh","Al Muharraq","Bani Jamrah","Barbar","Jurdab","Madinat `Isa","Madinat Hamad","Manama","Oil City","Sanabis","Sanad","Sitrah","Tubli"],"Bangladesh":["Agrabad","Bangla","Barisal","Bazar","Chittagong","Comilla","Delta","Dhaka","Hossain","Jessore","Kabi","Kazipur","Mymensingh","Narayanganj","Rajshahi","Tejgaon","Uttara"],"Barbados":["Atlantic Shores","Bagatelle","Bloomsbury","Bridgetown","Bruce Vale","Cave Hill","Clapham","Hastings","Holetown","Husbands","Jackmans","Oistins","Pine Housing Estate","Porters","Rendezvous","Rockley","The Garden","Wanstead","Warners","Warrens","White Hill","Wildey","Worthing"],"Belarus":["Baranovichi","Borisov","Brest","Dzyarzhynsk","Horki","Hrodna","Lahoysk","Lida","Lyakhovichi","Lyaskavichy","Mazyr","Minsk","Mogilev","Navapolatsk","Orsha","Pinsk","Polatsk","Radoshkovichi","Shklow","Vitebsk","Zaslawye","Zhodzina"],"Belgium":["Aalbeke","Aalst","Aalter","Aarschot","Aarsele","Aartrijke","Aartselaar","Achel","Adegem","Adinkerke","Afsnee","Agimont","Alken","Alleur","Alsemberg","Alveringem","Amay","Ampsin","Andenne","Anderlecht","Anderlues","Andrimont","Angleur","Ans","Anseroeul","Anthisnes","Antwerp","Anzegem","Appels","Appelterre-Eichem","Arbrefontaine","Ardooie","Arendonk","Argenteau","Arlon","Arquennes","Arsimont","As","Asse","Assebroek","Assenede","Assent","Assesse","Astene","Astenet","Ath","Attenhoven","Attre","Aubange","Aubel","Auderghem","Auvelais","Avekapelle","Avelgem","Averbode","Awans","Awirs","Aywaille","Baal","Baarle-Hertog","Baasrode","Baelen","Baisy-Thy","Balen","Banneux","Barchon","Barry","Basecles","Bassenge","Bassevelde","Bastogne","Battice","Baudour","Bavegem","Bavikhove","Bazel","Beaufays","Beauvechain","Beernem","Beerse","Beersel","Beervelde","Beerzel","Beez","Begijnendijk","Beigem","Bekkevoort","Belgrade","Belle Fontaine","Bellem","Beloeil","Belsele","Berchem","Berchem","Berendrecht","Beringen","Berlaar","Berlare","Bernissart","Bertem","Bertrix","Betekom","Bevel","Beveren","Beveren","Beverlo","Beyne-Heusay","Bierbeek","Biercee","Bierges","Bierset","Bilstain","Bilzen","Binche","Bissegem","Blaasveld","Blanden","Blankenberge","Blegny","Bocholt","Boechout","Boezinge","Boncelles","Bonheiden","Bonlez","Booischot","Boom","Boorsem","Boortmeerbeek","Borchtlombeek","Borgerhout","Borgloon","Bornem","Borsbeek","Borsbeke","Bouge","Bouillon","Boussu","Bousval","Boutersem","Bouwel","Bovekerke","Bovesse","Braine-le-Chateau","Braine-le-Comte","Braives","Brasmenil","Brasschaat","Brecht","Bredene","Bree","Bressoux","Broechem","Brugelette","Bruges","Brussegem","Brussels","Budingen","Buggenhout","Buizingen","Bunsbeek","Burcht","Burdinne","Burst","Butgenbach","Buvrinnes","Carnieres","Casteau","Celles","Cerexhe-Heuseux","Chapelle-lez-Herlaimont","Charleroi","Charneux","Chastre","Chatelet","Chatelineau","Chaudfontaine","Chaumont-Gistoux","Chaussee-Notre-Dame-Louvignies","Chenee","Chercq","Chevron","Chievres","Chimay","Chiny","Ciney","Ciplet","Clavier","Colfontaine","Comblain-au-Pont","Comines","Coret","Corroy-le-Grand","Couillet","Cour-sur-Heure","Courcelles","Court-Saint-Etienne","Couthuin","Couvin","Crisnee","Cuesmes","Dadizele","Dalhem","Damme","Dampremy","Dave","De Haan","De Klinge","De Panne","De Pinte","Deerlijk","Deftinge","Deinze","Denderbelle","Denderhoutem","Denderleeuw","Dendermonde","Dentergem","Dessel","Desselgem","Destelbergen","Deurle","Deurne","Diegem","Diepenbeek","Diest","Diksmuide","Dilbeek","Dilsen","Dinant","Dison","Donceel","Dongelberg","Dorinne","Dottignies","Dour","Dranouter","Drogenbos","Drongen","Dudzele","Duffel","Duisburg","Dworp","Ecaussinnes-Lalaing","Edegem","Eeklo","Eernegem","Eghezee","Eigenbilzen","Eke","Ekeren","Eksaarde","Eksel","Elen","Elewijt","Elingen","Ellezelles","Ellignies-Sainte-Anne","Elverdinge","Elversele","Emblem","Embourg","Emptinne","Enghien","Engis","Ensival","Eppegem","Erbaut","Erembodegem","Erezee","Erondegem","Erpe","Erpent","Erps-Kwerps","Erquelinnes","Ertvelde","Esneux","Essen","Essene","Estaimpuis","Estinnes-au-Val","Etalle","Etikhove","Etterbeek","Eupen","Everbeek","Everberg","Evere","Evergem","Faimes","Falisolle","Fallais","Farciennes","Fayt-lez-Manage","Feluy","Ferrieres","Fexhe-le-Haut-Clocher","Fexhe-Slins","Filot","Flawinne","Flemalle-Grande","Flemalle-Haute","Flenu","Fleron","Fleurus","Flobecq","Floreffe","Florennes","Florenville","Fontaine","Fontaine-Valmont","Forchies-la-Marche","Forest","Forrieres","Fosse des Loups","Frameries","Franiere","Frasnes-lez-Buissenal","Freylange","Gages","Galmaarden","Ganshoren","Gavere","Geel","Geer","Geetbets","Gellik","Gelrode","Geluwe","Gembloux","Genk","Gentbrugge","Gentinnes","Genval","Geraardsbergen","Gerpinnes","Gesves","Ghent","Ghislenghien","Ghlin","Gierle","Gijzegem","Gilly","Gingelom","Gistel","Gits","Glabbeek","Glimes","Gobard","Godarville","Goe","Gooik","Goor","Gosselies","Gourdinne","Goutroux","Gouy-lez-Pieton","Grand","Grand-Leez","Grand-Rechain","Grand-Reng","Grembergen","Grez-Doiceau","Grimbergen","Grimminge","Grivegnee","Grobbendonk","Groot-Bijgaarden","Gruitrode","Gullegem","Haacht","Haaltert","Haasdonk","Haasrode","Haccourt","Haine-Saint-Paul","Halen","Hallaar","Halle","Ham","Ham","Ham-sur-Heure","Ham-sur-Sambre","Hamme","Hamme-Mille","Hamoir","Hamont","Hampteau","Haneffe","Hannut","Hansbeke","Harelbeke","Haren","Hasselt","Haut-Ittre","Hautrage","Havay","Havre","Hechtel","Heers","Heestert","Heffen","Heindonk","Heist","Heist-op-den-Berg","Hekelgem","Helchteren","Hemiksem","Henri-Chapelle","Hensies","Heppen","Herdersem","Herent","Herentals","Herenthout","Herinnes","Herk-de-Stad","Herlaimont","Hermalle-sous-Argenteau","Hermee","Herne","Herseaux","Herselt","Herstal","Herve","Herzele","Heule","Heure-le-Romain","Heusden","Heusden","Heusy","Hever","Heverlee","Hingene","Hoboken","Hodeige","Hoegaarden","Hoeilaart","Hoeleden","Hoeselt","Hoevenen","Hofstade","Hofstade","Hognoul","Hollain","Holland","Hollogne","Holsbeek","Hombeek","Hooglede","Hoogstraten","Horion-Hozemont","Hornu","Hotton","Houdeng-Goegnies","Houffalize","Housse","Houtain-le-Val","Houtaing","Houthalen","Houthem","Houthulst","Houtvenne","Hove","Huizingen","Huldenberg","Hulshout","Humbeek","Humbeek","Huy","Hyon","Ichtegem","Iddergem","Idegem","Impe","Incourt","Ingelmunster","Ingooigem","Isnes","Itegem","Itterbeek","Ittre","Ixelles-Elsene","Izegem","Izel","Jabbeke","Jambes","Jamioulx","Jauche","Jemappes","Jemelle","Jemeppe-sur-Meuse","Jemeppe-sur-Sambre","Jette","Jodoigne","Jumet","Jupille-sur-Meuse","Juprelle","Jurbise","Kachtem","Kain","Kalken","Kalmthout","Kampenhout","Kanegem","Kapelle-op-den-Bos","Kapellen","Kaprijke","Kasterlee","Kaulille","Keerbergen","Kemzeke","Kerkhove","Kerksken","Kermt","Kersbeek-Miskom","Kessel","Kessel-Lo","Kettenis","Kinrooi","Klein-Gelmen","Klemskerke","Knesselare","Knokke","Knokke-Heist","Koekelare","Koersel","Koksijde","Koningshooikt","Kontich","Korbeek-Dijle","Korbeek-Lo","Kortemark","Kortenaken","Kortenberg","Kortessem","Kortrijk","Kortrijk-Dutsel","Kozen","Kraainem","Kruibeke","Kruishoutem","Kuringen","Kuurne","Kwaadmechelen","La Calamine","La Hestre","La Hulpe","Laarne","Labuissiere","Laken","Lambermont","Lambermont","Lanaken","Landegem","Landelies","Landen","Langdorp","Langemark","Lanklaar","Latinne","Lauwe","Le Tilleul","Lebbeke","Lede","Ledeberg","Ledegem","Leefdaal","Leerbeek","Leernes","Leest","Leffinge","Leisele","Lembeek","Lendelede","Lennik","Leopoldsburg","Lessines","Letterhoutem","Leuven","Leuze","Leval-Trahegnies","Libramont","Lichtaart","Lichtervelde","Liedekerke","Lier","Ligny","Lille","Lillois-Witterzee","Limal","Limbourg","Limelette","Lincent","Linden","Linkebeek","Lint","Lippelo","Lisogne","Lissewege","Lives-sur-Meuse","Lixhe","Lobbes","Lochristi","Lodelinsart","Loenhout","Loker","Lokeren","Lommel","Loncin","Londerzeel","Lontzen","Loppem","Lot","Lotenhulle","Loupoigne","Louvain-la-Neuve","Louveigne","Lovendegem","Loverval","Lubbeek","Lummen","Luttre","Maaseik","Maasmechelen","Machelen","Magnee","Maisieres","Maldegem","Malderen","Malmedy","Malonne","Manage","Manhay","Marais","Marche-en-Famenne","Marche-lez-Ecaussinnes","Marchienne-au-Pont","Marchin","Marcinelle","Mariakerke","Mariekerke","Mariembourg","Marke","Markegem","Massemen","Maurage","Mechelen","Meensel-Kiezegem","Meerbeke","Meerhout","Meerlaar","Meerle","Meersel","Meeuwen","Meigem","Meise","Meldert","Melen","Melkwezer","Melle","Melsbroek","Melsele","Membach","Menen","Merchtem","Mere","Merelbeke","Merendree","Merksem","Merksplas","Mespelare","Messancy","Mettet","Meulebeke","Middelburg","Middelkerke","Minderhout","Modave","Moen","Moerbeke","Moerzeke","Moha","Mol","Molenbeek","Molenbeek-Saint-Jean","Molenstede","Momalle","Monceau-sur-Sambre","Mons","Mont-Saint-Guibert","Mont-Sainte-Aldegonde","Mont-sur-Marchienne","Montegnee","Montignies-lez-Lens","Montignies-sur-Sambre","Montzen","Moorsel","Moorslede","Morialme","Morkhoven","Morlanwelz-Mariemont","Mortsel","Mouscron","Muizen","Muizen","Munsterbilzen","Naast","Nalinnes","Nameche","Namur","Nandrin","Natoye","Nazareth","Neder-Over-Heembeek","Nederbrakel","Nederhasselt","Neerharen","Neerijse","Neerlinter","Neerpelt","Nethen","Neuville-en-Condroz","Nevele","Niel","Nieuwenhove","Nieuwerkerken","Nieuwerkerken","Nieuwpoort","Nieuwpoort","Nieuwrode","Nijlen","Nil Saint-Vincent","Nimy","Ninove","Nivelles","Nodebais","Nokere","Nossegem","Nouvelles","Nukerke","Obaix","Obourg","Oedelem","Oelegem","Oeselgem","Ohain","Ohey","Okegem","Olen","Olne","Onze-Lieve-Vrouw-Waver","Ooigem","Oordegem","Oostakker","Oosteeklo","Oostende","Oosterzele","Oostham","Oostkamp","Oostmalle","Oostrozebeke","Oostvleteren","Opbrakel","Opglabbeek","Opgrimbie","Ophain","Opitter","Opoeteren","Oppem","Oppuurs","Opwijk","Orbais","Orp-le-Grand","Ostend","Otegem","Othee","Ottignies","Oud-Heverlee","Oud-Turnhout","Oudegem","Oudenaarde","Oudenburg","Ougree","Oupeye","Outer","Outrijve","Overheide","Overijse","Overmere","Overpelt","Paal","Pamel","Parike","Park","Passendale","Peer","Pellenberg","Pepinster","Peronnes","Pervijze","Perwez","Petegem","Peutie","Pipaix","Pittem","Plainevaux","Plancenoit","Ploegsteert","Poederlee","Poelkapelle","Pollare","Pont-a-Celles","Pont-de-Loup","Poperinge","Poppel","Post","Presles","Profondeville","Pulderbos","Pulle","Putte","Puurs","Quaregnon","Quenast","Quevaucamps","Quievrain","Ramet","Ramsdonk","Ramsel","Ramskapelle","Rance","Ransart","Ranst","Ravels","Rebaix","Recht","Reet","Rekem","Rekkem","Relegem","Remersdaal","Remicourt","Reninge","Renlies","Ressaix","Ressegem","Retie","Retinne","Rhisnes","Richelle","Riemst","Rijkevorsel","Rijmenam","Rillaar","Rixensart","Rochefort","Rocourt","Rode","Roeselare","Roeulx","Romsee","Ronse","Rosieres","Rosmeer","Rotselaar","Roux","Ruddervoorde","Ruien","Ruisbroek","Ruisbroek","Ruiselede","Rumbeke","Rummen","Rumst","Sablon","Saint-Georges-sur-Meuse","Saint-Ghislain","Saint-Gilles","Saint-Jean-Geest","Saint-Josse-ten-Noode","Saint-Leger","Saint-Mard","Saint-Nicolas","Saint-Remy","Saint-Sauveur","Saint-Servais","Saint-Symphorien","Sainte-Ode","Saintes","Saive","Sankt Vith","Sart Melin","Sart-Dames-Avelines","Sart-en-Fagne","Sart-lez-Spa","Schaarbeek","Schaffen","Schalkhoven","Scheldewindeke","Schelle","Schellebelle","Schendelbeke","Schepdaal","Scherpenheuvel","Schilde","Schoonaarde","Schorisse","Schoten","Schriek","Schulen","Sclayn","Seilles","Seneffe","Seraing","Serskamp","Sijsele","Sinaai","Sint-Agatha-Berchem","Sint-Agatha-Rode","Sint-Amands","Sint-Amandsberg","Sint-Andries","Sint-Baafs-Vijve","Sint-Denijs-Westrem","Sint-Genesius-Rode","Sint-Gillis-bij-Dendermonde","Sint-Gillis-Waas","Sint-Katelijne-Waver","Sint-Kornelis-Horebeke","Sint-Lambrechts-Herk","Sint-Laureins","Sint-Lievens-Houtem","Sint-Maria-Latem","Sint-Martens-Latem","Sint-Michiels","Sint-Niklaas","Sint-Pauwels","Sint-Pieters op de Dijk","Sint-Pieters-Leeuw","Sint-Stevens-Woluwe","Sint-Truiden","Sirault","Sleidinge","Soignies","Sombreffe","Soumagne","Souvret","Spa","Sprimont","Stabroek","Staden","Stavelot","Steendorp","Steenokkerzeel","Stekene","Stembert","Stene","Ster","Sterrebeek","Stevoort","Stokkem","Stoumont","Stree","Strepy-Bracquegnies","Strombeek-Bever","Tamines","Temse","Teralfene","Terhagen","Ternat","Tertre","Tervuren","Tessenderlo","Testelt","Theux","Thimeon","Thimister","Thisnes","Thuin","Thulin","Thy-le-Chateau","Thynes","Tiegem","Tielt","Tielt","Tienen","Tildonk","Tilff","Tilleur","Tisselt","Toernich","Tohogne","Tongeren","Tongerlo","Tongre-Notre-Dame","Torhout","Tournai","Transinne","Trazegnies","Tremelo","Trooz","Tubize","Turnhout","Uccle","Ulbeek","Ursel","Vance","Varsenare","Vaux","Vaux-sous-Chevremont","Vedrin","Veerle","Velaine-sur-Sambre","Velaines","Veldegem","Velm","Veltem-Beisem","Verlaine","Verrebroek","Verviers","Veurne","Viane","Vichte","Vielsalm","Viesville","Villers-la-Ville","Villers-le-Bouillet","Villers-sur-Semois","Vilvoorde","Vinderhoute","Virton","Vise","Vivegnis","Vladslo","Vlekkem","Vlezenbeek","Vliermaal","Vliermaalroot","Vlierzele","Vlissegem","Vollezele","Voormezele","Voroux-Goreux","Vorselaar","Vosselaar","Vossem","Vottem","Vremde","Waarloos","Waarschoot","Waasmunster","Wachtebeke","Wagnelee","Wakken","Waleffe Saint-Georges","Walhain","Walhorn","Wanfercee-Baulet","Wangenies","Wanne","Wanze","Warchin","Waregem","Waremme","Warneton","Warquignies","Warsage","Wasmes","Waterloo","Watermael-Boitsfort","Watervliet","Waudrez","Wavre","Ways","Wechelderzande","Weelde","Welkenraedt","Welle","Wellen","Wemmel","Wenduine","Wepion","Werchter","Werken","Wervik","Wespelaar","Westende","Westerlo","Westmalle","Westouter","Wetteren","Wevelgem","Wezemaal","Wezembeek-Oppem","Wichelen","Wiekevorst","Wielsbeke","Wierde","Wieze","Wijgmaal","Wijnegem","Willebroek","Wilrijk","Wilsele","Wingene","Winksele","Woesten","Wolfsdonk","Wolkrange","Woluwe-Saint-Lambert","Woluwe-Saint-Pierre - Sint-Pieters-Woluwe","Wolvertem","Wommelgem","Wondelgem","Wortegem","Wuustwezel","Xhendremael","Xhoris","Ypres","Yvoir","Zaffelare","Zandbergen","Zandhoven","Zarren","Zaventem","Zedelgem","Zeebrugge","Zele","Zellik","Zelzate","Zemst","Zeveneken","Zichem","Zingem","Zoersel","Zolder","Zomergem","Zonhoven","Zonnebeke","Zottegem","Zoutleeuw","Zuienkerke","Zulte","Zutendaal","Zwartenbroek","Zwevegem","Zwevezele","Zwijnaarde","Zwijndrecht"],"Belize":["Belize City","Belmopan","Benque Viejo del Carmen","Freetown Sibun","Ladyville","San Ignacio","San Pedro Town"],"Bolivia":["Anillo","Aroma","Bermejo","Caracasa","Cobija","Cochabamba","Cotoca","Cruz","Guayaramerin","La Paz","Oruro","Riberalta","Santa Cruz","Santa Cruz","Sucre","Tarija","Trinidad"],"Bosnia and Herzegovina":["Banja","Banja Luka","Bijeljina","Bosanska Dubica","Bosanska Krupa","Brcko","Breza","Bugojno","Cazin","Core","Doboj","Donja Mahala","Gracanica","Ilidza","Jajce","Jelah","Kiseljak","Livno","Ljubuski","Lopare","Lukavac","Modrica","Mostar","Novi Travnik","Odzak","Prijedor","Sanski Most","Sarajevo","Siroki Brijeg","Srpska","Stup","Tesanj","Travnik","Tuzla","Visoko","Vitez","Vogosca","Zenica","Zepce","Zivinice"],"Botswana":["Francistown","Gaborone","Orapa","Serowe","Village"],"Brazil":["Abadiania","Abaetetuba","Abelardo Luz","Abidos","Abrantes","Abreu","Abreu e Lima","Acarau","Acopiara","Acorizal","Acu","Acucena","Adamantina","Adustina","Afogados da Ingazeira","Afonso Claudio","Agrestina","Agua Boa","Agua Clara","Aguai","Aguanil","Aguas Claras","Aguas da Prata","Aguas de Chapeco","Aguas de Lindoia","Aguas de Sao Pedro","Aguas Lindas","Agudo","Agudos","Agulha","Alagoa Grande","Alagoa Nova","Alagoinha","Alagoinhas","Alambari","Aldeia","Alegre","Alegres","Alegrete","Alem Paraiba","Alfenas","Alfredo Chaves","Almeirim","Almirante Tamandare","Aloandia","Alta Floresta","Altamira","Altaneira","Alterosa","Altinho","Altinopolis","Alto","Alto Alegre","Alto do Rodrigues","Alto Paraiso de Goias","Alto Piquiri","Alto Santo","Altos","Alvares Machado","Alvorada","Alvorada do Sul","Amambai","Amaraji","Amarante","Amarante do Maranhao","Amazonas","America de Cima","America Dourada","Americana","Americo Brasiliense","Amparo","Anadia","Anajas","Ananindeua","Anchieta","Andarai","Andradas","Andradina","Andre","Andre da Rocha","Angatuba","Angical do Piaui","Angicos","Angra dos Reis","Anhembi","Anhumas","Antas","Antonina","Antonio Carlos","Antonio Carlos","Antonio Prado","Aparecida","Aparecida do Rio Negro","Aperibe","Apiai","Apiuna","Apodi","Apora","Apucarana","Apuiares","Aquidaba","Aquidauana","Aquiraz","Aracai","Aracaju","Aracariguama","Aracas","Aracati","Aracatuba","Araci","Aracoiaba da Serra","Aracruz","Aracuai","Aragarcas","Araguari","Arandu","Arapiraca","Arapongas","Arapoti","Arapua","Araquari","Ararangua","Araraquara","Araras","Ararica","Araripina","Araruama","Araruna","Araujos","Arceburgo","Arcos","Arcoverde","Areado","Areal","Arealva","Areia Branca","Areial","Aricanduva","Ariquemes","Armacao de Buzios","Armazem","Aroeiras","Arraial","Arraial do Cabo","Arroio do Meio","Arroio do Silva","Arroio do Tigre","Arroio dos Ratos","Arroio Grande","Artur Nogueira","Ascurra","Assis","Assis Chateaubriand","Atibaia","Auriflama","Avanhandava","Avare","Azurita","Bady Bassitt","Baia da Traicao","Baiao","Bairro da Velha Central","Baixo Guandu","Balsa Nova","Balsamo","Balsas","Bambui","Banabuiu","Bananal","Bandeirantes","Bangu","Barao de Cocais","Barao de Cotegipe","Barao de Grajau","Barauna","Barbacena","Barbalha","Barbosa","Barcarena","Barra","Barra","Barra Bonita","Barra da Tijuca","Barra de Sao Miguel","Barra do Bugres","Barra do Corda","Barra do Jacare","Barra do Ribeiro","Barra Mansa","Barra Velha","Barracao","Barras","Barreiras","Barretos","Barrinha","Barro","Barrocas","Barueri","Batatais","Batista","Baturite","Bauru","Bayeux","Bebedouro","Beberibe","Bela Vista","Bela Vista","Bela Vista","Bela Vista de Goias","Bela Vista do Paraiso","Belem","Belem","Belem do Brejo do Cruz","Belford Roxo","Belo Horizonte","Belo Horizonte","Belo Jardim","Benedito Novo","Benevides","Bento","Berilo","Bernardo","Bertioga","Betania","Betim","Bezerros","Bicas","Biguacu","Birigui","Biritiba Mirim","Biritinga","Bituruna","Blumenau","Boa Esperanca","Boa Esperanca","Boa Ventura","Boa Vista","Boa Vista","Boa Vista","Boa Vista","Boa Vista","Boa Vista","Boa Vista do Burica","Bocaiuva","Bocaiuva do Sul","Boituva","Bom Conselho","Bom Despacho","Bom Jardim","Bom Jardim de Minas","Bom Jesus","Bom Jesus","Bom Jesus","Bom Jesus da Lapa","Bom Jesus do Amparo","Bom Jesus do Itabapoana","Bom Jesus dos Perdoes","Bom Principio","Bom Retiro do Sul","Bombinhas","Bonfim","Bonito","Bonito","Bonito","Bonito","Boqueirao","Boquim","Borda da Mata","Borrazopolis","Botafogo","Botafogo","Botucatu","Botupora","Botuvera","Braco do Norte","Braganca","Braganca Paulista","Branco","Bras","Brasa","Brasil","Brasilandia","Brasopolis","Brejetuba","Brejinho de Nazare","Brejo da Madre de Deus","Brejo Santo","Breves","Brochier","Brodosqui","Brotas","Brumadinho","Brumado","Brusque","Bueno Brandao","Buique","Buritama","Buriti","Buriti","Buritizeiro","Butia","Buzios","Caapora","Caarapo","Cabedelo","Cabo de Santo Agostinho","Cabo Frio","Cabralia","Cabralia Paulista","Cabreuva","Cabrobo","Cacapava","Cacapava do Sul","Cacequi","Caceres","Cachoeira","Cachoeira do Sul","Cachoeira Grande","Cachoeira Paulista","Cachoeiras","Cachoeiras de Macacu","Cachoeirinha","Cachoeiro de Itapemirim","Cacimba de Dentro","Cacique Doble","Cacoal","Caete","Caetite","Cafarnaum","Cafelandia","Caiana","Caiaponia","Caibate","Caico","Caieiras","Caiua","Cajamar","Cajati","Cajazeiras","Cajobi","Cajuru","Calcado","Calcoene","Caldas","Caldas Novas","California","Camacari","Camamu","Camanducaia","Camaqua","Camaragibe","Cambe","Camboriu","Cambui","Cambuquira","Cameta","Campestre","Campina","Campina Grande","Campina Grande do Sul","Campinas","Campinas do Sul","Campinorte","Campo","Campo Alegre","Campo Alegre","Campo Bom","Campo Ere","Campo Formoso","Campo Grande","Campo Grande","Campo Largo","Campo Magro","Campo Maior","Campo Mourao","Campo Novo","Campo Verde","Campos","Campos","Campos do Jordao","Campos dos Goytacazes","Campos Gerais","Campos Novos","Campos Sales","Canarana","Canas","Canavieiras","Candeal","Candeias","Candeias","Candelaria","Candido Mota","Candoi","Canela","Canelinha","Cangucu","Canhotinho","Caninde","Caninde de Sao Francisco","Canoas","Canoinhas","Cansancao","Cantagalo","Cantanhede","Capanema","Capao Alto","Capao Bonito","Capao da Canoa","Capao do Leao","Caparao","Capela","Capela","Capela do Alto","Capelinha","Capetinga","Capinopolis","Capistrano","Capitao Poco","Capivari","Caputira","Caraa","Caraguatatuba","Carambei","Carangola","Carapebus","Carapicuiba","Caratinga","Caraubas","Carazinho","Cardeal da Silva","Cardoso","Cariacica","Carinhanha","Caripi","Carius","Carlos Barbosa","Carmo da Mata","Carmo do Cajuru","Carmo do Rio Claro","Carmopolis","Carmopolis de Minas","Carnaiba","Carolina","Carpina","Caruaru","Casa Nova","Casca","Cascavel","Casimiro de Abreu","Cassia","Cassilandia","Cassino","Castanhal","Castelo","Castro","Cataguases","Catalao","Catanduva","Catanduvas","Catarina","Catende","Catu","Caucaia","Caxambu","Caxambu","Caxias","Caxias do Sul","Ceara Mirim","Cedral","Cedro do Abaete","Ceilandia","Centenario do Sul","Central","Ceres","Cerqueira Cesar","Cerquilho","Cerro Azul","Cerro Branco","Cerro Grande","Cerro Largo","Cesario Lange","Ceu Azul","Cha Grande","Chapada","Chapadao","Chapadao","Chapadinha","Charqueada","Charqueadas","Chaval","Chavantes","Chopinzinho","Cianorte","Cicero Dantas","Cidade","Cidade","Cidade de Deus","Cidade Nova","Cipotanea","Claro dos Pocoes","Claudio","Clementina","Clevelandia","Coari","Cocal","Cocalinho","Cocos","Coelho","Colatina","Colina","Colinas","Colinas","Colombo","Colorado","Comodoro","Conceicao","Conceicao","Conceicao da Barra","Conceicao das Alagoas","Conceicao de Macabu","Conceicao do Araguaia","Conceicao do Coite","Conceicao do Mato Dentro","Conchal","Conchas","Concordia","Condado","Conde","Conde","Congonhas","Conselheiro Lafaiete","Contagem","Contenda","Convento da Penha","Cordeiro","Cordeiropolis","Cordilheira","Coreau","Coremas","Corguinho","Cornelio Procopio","Coroados","Coroas","Coroata","Coromandel","Coronel","Coronel Fabriciano","Correia Pinto","Correntina","Cortes","Corumba de Goias","Coruripe","Cosmopolis","Cosmorama","Cotia","Crateus","Crato","Cravinhos","Cristais","Cristalina","Cristiano Otoni","Cruz","Cruz Alta","Cruz das Almas","Cruzeiro","Cruzeiro da Fortaleza","Cruzeiro do Oeste","Cruzeiro do Sul","Cruzeiro do Sul","Cruzilia","Cubatao","Cuite","Cunha Pora","Cupira","Curimata","Curitiba","Curitibanos","Currais Novos","Cururupu","Curvelo","Delfinopolis","Descalvado","Descanso","Diadema","Diamantina","Diamantino","Dias","Dionisio Cerqueira","Divinopolis","Dix-sept Rosado","Dobrada","Dois Corregos","Dois Irmaos","Dois Vizinhos","Dom Feliciano","Dom Pedrito","Dom Silverio","Domingos Martins","Dores do Indaia","Dourado","Dourados","Doutor Camargo","Doutor Mauricio Cardoso","Dracena","Duartina","Duas Barras","Dumont","Duque de Caxias","Eldorado","Elias Fausto","Elisiario","Eloi Mendes","Embu","Embu Guacu","Encantado","Encruzilhada do Sul","Engenheiro Beltrao","Engenheiro Schmidt","Entre Rios","Entre Rios de Minas","Erechim","Erval Grande","Erval Velho","Ervalia","Escada","Esmeraldas","Espera Feliz","Esperanca","Esperanca","Esperantina","Espinosa","Espirito Santo","Espirito Santo do Pinhal","Espumoso","Estancia","Estancia Nova","Estancia Velha","Esteio","Estiva","Estreito","Estrela","Eugenio","Eugenopolis","Eusebio","Extrema","Extremoz","Exu","Farroupilha","Fartura","Fatima","Faxinal","Faxinal do Soturno","Faxinal dos Guedes","Fazenda Rio Grande","Feira de Santana","Feira Nova","Feliz","Fenix","Fernando Prestes","Fernandopolis","Ferraz de Vasconcelos","Flexeiras","Florania","Flores","Flores da Cunha","Floresta Azul","Floriano","Florinia","Formiga","Formosa","Forquilha","Forquilha","Forquilhinha","Fortaleza","Fortaleza","Fortaleza","Fortuna","Foz do Jordao","Fragoso","Franca","Francisco Beltrao","Francisco Morato","Francisco Sa","Franco da Rocha","Frederico Westphalen","Frei Paulo","Freitas","Fronteira","Frutal","Fundao","Gameleira","Gandu","Garanhuns","Garca","Gardenia Azul","Garibaldi","Garimpo Novo","Garopaba","Garuva","Gaspar","Gaviao Peixoto","General Carneiro","General Salgado","Getulio Vargas","Girau do Ponciano","Gloria","Gloria do Goita","Glorinha","Goiana","Goianapolis","Goianesia","Goianinha","Goianira","Goias","Gomes","Goncalves","Governador Valadares","Graca Aranha","Grajau","Gramado","Granito","Granja","Grao Mogol","Groairas","Guacui","Guai","Guaianases","Guaicara","Guaira","Guaira","Guajeru","Guamare","Guanambi","Guanhaes","Guapiacu","Guapimirim","Guapo","Guapore","Guara","Guara","Guarabira","Guaraci","Guaraciaba","Guaragi","Guaramirim","Guaranesia","Guarani dOeste","Guaranta","Guarapari","Guarapuava","Guararapes","Guararapes","Guararema","Guaratingueta","Guaratuba","Guarei","Guariba","Guaruja","Guarulhos","Guaxupe","Gurjao","Gurupi","Heliodora","Heliopolis","Horizontina","Iacanga","Iacu","Ibaiti","Ibate","Ibatiba","Ibiaca","Ibicoara","Ibipeba","Ibipora","Ibirama","Ibirarema","Ibirataia","Ibirite","Ibiruba","Ibitinga","Ibiuna","Icapui","Icara","Icarai","Icem","Ico","Icoraci","Igaracu do Tiete","Igarapava","Igarape","Igarassu","Igarata","Igreja Nova","Igrejinha","Iguaba Grande","Iguai","Iguape","Iguaracu","Iguatu","Ijui","Ilha Solteira","Ilhabela","Ilhota","Imbituba","Imbituva","Imperatriz","Imperatriz","Indaial","Indaiatuba","Indianopolis","Inga","Inhacora","Inhangapi","Inhauma","Inhumas","Inocencia","Inubia Paulista","Ipaba","Ipameri","Ipatinga","Ipaucu","Ipero","Ipeuna","Ipiau","Ipira","Ipiranga","Ipojuca","Ipora","Ipu","Ipua","Ipubi","Ipumirim","Iracema","Iracemapolis","Iraceminha","Irai","Iranduba","Irati","Irece","Iretama","Irupi","Itabaiana","Itabaiana","Itabaianinha","Itabapoana","Itaberaba","Itabira","Itabirinha de Mantena","Itabirito","Itaborai","Itabuna","Itacare","Itaete","Itagi","Itagiba","Itaguacu","Itaguai","Itaguatins","Itaipava","Itaipu","Itaitinga","Itaituba","Itajobi","Itajuba","Itajuipe","Italva","Itamaraca","Itamarati","Itambaraca","Itambe","Itamogi","Itamonte","Itanhaem","Itanhandu","Itanhomi","Itaocara","Itapaci","Itapagipe","Itaparica","Itape","Itapecerica","Itapecerica da Serra","Itapecuru Mirim","Itapejara","Itapema","Itaperuna","Itapetinga","Itapetininga","Itapeva","Itapevi","Itapicuru","Itapipoca","Itapira","Itapiranga","Itapissuma","Itapixuna","Itapo","Itapolis","Itaporanga","Itapua","Itapuranga","Itaquaquecetuba","Itaqui","Itarantim","Itarare","Itatiaia","Itatiba","Itatinga","Itatira","Itau de Minas","Itauna","Itinga da Serra","Itirapina","Itiuba","Itobi","Itororo","Itu","Itubera","Ituiutaba","Itumbiara","Ituporanga","Iturama","Ituverava","Iuna","Ivaipora","Ivoti","Jaboatao dos Guararapes","Jabora","Jaborandi","Jaboticabal","Jaboticatubas","Jacarau","Jacarepagua","Jacarezinho","Jaci","Jaciara","Jacobina","Jacuizinho","Jacupiranga","Jacutinga","Jaguapita","Jaguaquara","Jaguarao","Jaguaras","Jaguariaiva","Jaguaribe","Jaguaripe","Jaguariuna","Jaguaruana","Jaguaruna","Jaiba","Jales","Jampruca","Janauba","Jandaia do Sul","Jandira","Japaratinga","Japeri","Japira","Jardim Alegre","Jardim de Piranhas","Jardinopolis","Jarinu","Jaru","Jatai","Jataizinho","Jequitinhonha","Jerico","Jeronimo Monteiro","Jesuania","Jetiba","Ji Parana","Jiquirica","Joacaba","Joanopolis","Joao Camara","Joao Lisboa","Joao Monlevade","Joao Neiva","Joao Pinheiro","Joaquim","Joaquim Tavora","Joinville","Jose Boiteux","Jose Bonifacio","Jose de Freitas","Juatuba","Juazeiro","Juazeiro do Norte","Jucara","Jucurutu","Juiz de Fora","Julio de Castilhos","Julio Mesquita","Jumirim","Jundiai do Sul","Junqueiro","Junqueiropolis","Juquia","Juquitiba","Juripiranga","Juru","Juruaia","Juruena","Juruti","Jussara","Jussari","Ladario","Lagarto","Lages","Lagoa","Lagoa da Canoa","Lagoa da Prata","Lagoa do Carro","Lagoa dos Gatos","Lagoa Salgada","Lagoa Santa","Lagoa Seca","Lagoa Vermelha","Laguna","Laguna Carapa","Lajeado","Lajinha","Lambari","Lambari","Lapa","Lapa","Laranjal Paulista","Laranjeiras","Laranjeiras do Sul","Lauro","Lavinia","Lavras","Lavras da Mangabeira","Lavras do Sul","Lavrinhas","Lebon Regis","Leme","Lencois","Lencois Paulista","Leopoldina","Liberdade","Lima Campos","Limeira","Limoeiro","Limoeiro do Norte","Linhares","Lins","Loanda","Londrina","Lontra","Lorena","Louveira","Lucena","Luis Antonio","Luis Antonio","Luis Correia","Lumiar","Luminarias","Luz","Luzerna","Luziania","Macaiba","Macaparana","Macatuba","Macau","Macaubas","Macedonia","Machadinho","Machado","Machados","Macuco","Madre de Deus","Mafra","Mage","Mairi","Mairinque","Malacacheta","Mamanguape","Mambore","Mamonas","Manacapuru","Manaus","Mandaguacu","Mandaguari","Mandirituba","Manga","Mangabeira","Mangaratiba","Mangueirinha","Manhuacu","Manhumirim","Mantena","Mantenopolis","Mar de Espanha","Maracaju","Maracana","Maracana","Maracanau","Maragogipe","Maraial","Maranguape","Marataizes","Marau","Maravilha","Marcelino Ramos","Marcelino Vieira","Marco","Marcolandia","Marechal Candido Rondon","Marechal Deodoro","Maria da Fe","Marialva","Mariana","Marica","Marilandia","Mariluz","Marituba","Marques","Martinopolis","Maruim","Marumbi","Marzagao","Massape","Massaranduba","Matao","Matelandia","Mateus Leme","Matina","Matinhos","Matipo","Mato Grosso","Matozinhos","Matutina","Maua","Maxaranguape","Medeiros Neto","Medianeira","Meier","Mendes","Mendes Pimentel","Mendonca","Mesquita","Messias","Miguel Pereira","Miguelopolis","Milagres","Minas","Mineiros","Mineiros do Tiete","Miracatu","Miracema","Miracema do Tocantins","Miraima","Miranda","Miranda","Mirandopolis","Mirassol","Mirim Doce","Mirinzal","Missao Velha","Mococa","Moema","Mogeiro","Mogi das Cruzes","Mogi Mirim","Mogi-Gaucu","Mongagua","Monte Alegre","Monte Alegre","Monte Alto","Monte Aprazivel","Monte Azul","Monte Azul Paulista","Monte Belo","Monte Carmelo","Monte Dourado","Monte Mor","Monte Santo","Monte Siao","Monteiro","Monteiro Lobato","Montenegro","Montes Altos","Montes Claros","Montividiu","Morada Nova","Moreno","Morretes","Morrinhos","Morrinhos","Morro Agudo","Morro da Fumaca","Morro de Sao Paulo","Morro do Chapeu","Morro Reuter","Morungaba","Mossoro","Mostardas","Mucuri","Muliterno","Munhoz","Muniz Ferreira","Muniz Freire","Muqui","Muritiba","Mutum","Mutum","Muzambinho","Nanuque","Nao Me Toque","Narandiba","Natal","Natercia","Navegantes","Navirai","Nazare","Nazare da Mata","Nazare Paulista","Neopolis","Neropolis","Nilo Pecanha","Nilopolis","Niquelandia","Niteroi","Niteroi","Nobres","Norte","Nossa Senhora","Nossa Senhora da Gloria","Nossa Senhora Das Gracas","Nossa Senhora do Socorro","Nova","Nova","Nova Alianca","Nova Araca","Nova Aurora","Nova Bassano","Nova Brescia","Nova Canaa","Nova Cruz","Nova Esperanca","Nova Esperanca","Nova Friburgo","Nova Independencia","Nova Itarana","Nova Lima","Nova Londrina","Nova Odessa","Nova Palma","Nova Petropolis","Nova Ponte","Nova Prata","Nova Resende","Nova Serrana","Nova Timboteua","Nova Trento","Nova Venecia","Novo Hamburgo","Novo Horizonte","Novo Mundo","Novo Oriente","Novo Recreio","Nucleo Bandeirante","Nunes Freire","Nuporanga","Ocara","Oeiras","Olimpia","Olinda","Oliveira","Oratorios","Orlandia","Orleans","Orobo","Osasco","Osorio","Otacilio Costa","Ouricangas","Ouricuri","Ourinhos","Ouro Branco","Ouro Fino","Ouro Preto","Ouro Preto do Oeste","Ouro Verde","Ouvidor","Pacaembu","Pacatuba","Pachecos","Padre","Paicandu","Palestina","Palestina","Palhoca","Palma","Palmares","Palmares do Sul","Palmas","Palmas","Palmeira","Palmeira","Palmeira das Missoes","Palmeira dos Indios","Palmeiras de Goias","Palmelo","Palmital","Palmital","Palmitinho","Palmitos","Palotina","Panambi","Pancas","Panorama","Pao de Acucar","Papagaios","Para de Minas","Paracambi","Paracuru","Paragominas","Paraguacu","Paraguacu Paulista","Parai","Paraiba do Sul","Paraibano","Paraibuna","Paraipaba","Paraiso","Paraiso","Paraiso do Tocantins","Paraisopolis","Paraitinga","Parana","Parana","Parana","Paranaiba","Paranapanema","Paranavai","Paranoa","Paraopeba","Parapeuna","Paraty","Parelhas","Pariquera Acu","Parnaiba","Parnamirim","Parnamirim","Parobe","Passo Fundo","Passos","Pastos Bons","Pato Branco","Patos","Patos de Minas","Patrocinio","Patrocinio Paulista","Pau Brasil","Pau dos Ferros","Pauini","Pauliceia","Paulinia","Paulista","Paulista","Paulo Afonso","Paulo Jacinto","Paulo Lopes","Paverama","Peabiru","Pecem","Pederneiras","Pedra Bonita","Pedra Grande","Pedranopolis","Pedreira","Pedreira","Pedro Afonso","Pedro Avelino","Pedro de Toledo","Pedro Leopoldo","Pelotas","Pena","Penapolis","Pendencias","Penedo","Penha","Perdigao","Perdoes","Pereira Barreto","Pereiro","Peruibe","Pesqueira","Petrolina","Piabeta","Picada","Picos","Picui","Piedade","Piedade do Rio Grande","Piedade dos Gerais","Pien","Pilao Arcado","Pilar do Sul","Pimenta","Pimenta Bueno","Pindamonhangaba","Pindobacu","Pindoretama","Pinhais","Pinhalao","Pinhalzinho","Pinheiral","Pinhoes","Piquet Carneiro","Piracaia","Piracanjuba","Piracema","Piracicaba","Pirai","Pirai do Sul","Piraju","Pirajuba","Pirajui","Pirangi","Pirapora do Bom Jesus","Pirapozinho","Piraquara","Pirassununga","Piratininga","Piritiba","Pitanga","Pitangueiras","Pitangueiras","Pitangui","Piuma","Planalto","Planalto","Platina","Poa","Poco Branco","Poco das Antas","Poco Verde","Pojuca","Pombal","Pomerode","Pompeia","Pompeu","Pongai","Ponta Grossa","Ponta Pora","Pontal","Pontal do Parana","Pontalina","Ponte de Itabapoana","Ponte Nova","Ponte Serrada","Pontes e Lacerda","Porangatu","Porecatu","Portao","Porteira do Pinhal","Porto","Porto Alegre","Porto Amazonas","Porto Belo","Porto Esperidiao","Porto Feliz","Porto Ferreira","Porto Grande","Porto Nacional","Porto Real","Porto Sao Jose Velho","Porto Seguro","Porto Uniao","Porto Velho","Porto Velho","Posse","Posto Fiscal Rolim de Moura","Pote","Potirendaba","Pouso Alegre","Pradopolis","Praia Grande","Prata","Pratania","Pratapolis","Presidente Bernardes","Presidente Dutra","Presidente Epitacio","Presidente Getulio","Presidente Kennedy","Presidente Medici","Presidente Olegario","Presidente Prudente","Presidente Venceslau","Primavera","Primeiro de Maio","Progresso","Progresso","Promissao","Propria","Prudentopolis","Putinga","Puxinana","Quarai","Quata","Quatigua","Quatis","Quatro Barras","Quatro Pontes","Quebrangulo","Queimadas","Queimados","Querencia","Querencia do Norte","Quilombo","Quipapa","Quirinopolis","Quissama","Quitandinha","Quixada","Quixeramobim","Quixere","Rafard","Rancharia","Rancho Queimado","Raposa (1)","Raposos","Raul Soares","Realeza","Reboucas","Recanto","Recife","Redencao","Redencao","Reduto","Registro","Remigio","Renascenca","Repartimento","Resende","Resende Costa","Restinga","Restinga Seca","Riachao do Jacuipe","Riacho das Almas","Riacho Fundo","Riacho Fundo","Rialma","Ribas do Rio Pardo","Ribeira do Pombal","Ribeirao","Ribeirao Bonito","Ribeirao Corrente","Ribeirao do Pinhal","Ribeirao Pires","Rio Acima","Rio Azul","Rio Bananal","Rio Bonito","Rio Bonito","Rio Branco","Rio Branco","Rio Branco do Sul","Rio Brilhante","Rio Casca","Rio Claro","Rio Claro","Rio das Ostras","Rio das Pedras","Rio de Janeiro","Rio do Pires","Rio do Sul","Rio dos Cedros","Rio Formoso","Rio Grande","Rio Grande da Serra","Rio Largo","Rio Manso","Rio Negrinho","Rio Negro","Rio Novo","Rio Novo do Sul","Rio Paranaiba","Rio Pardo","Rio Pardo de Minas","Rio Piracicaba","Rio Tinto","Rio Verde de Mato Grosso","Roca Sales","Rodeio Bonito","Rodeiro","Rodrigues","Rolandia","Rolante","Ronda Alta","Rondon","Rosalia","Rosario","Rosario do Sul","Roseira","Rubiataba","Rubim","Russas","Sabara","Sabaudia","Sabinopolis","Sacramento","Sales","Sales Oliveira","Salesopolis","Salgado","Salgueiro","Salinas da Margarida","Salto","Salto","Salto de Pirapora","Salto Grande","Salvador","Salvador","Salvador","Samambaia","Sampaio Correia","Sananduva","Sangao","Sanharo","Santa","Santa Adelia","Santa Barbara","Santa Barbara do Sul","Santa Branca","Santa Cruz","Santa Cruz Cabralia","Santa Cruz da Baixa Verde","Santa Cruz do Capibaribe","Santa Cruz do Rio Pardo","Santa Cruz do Sul","Santa Fe","Santa Fe do Sul","Santa Gertrudes","Santa Helena","Santa Helena","Santa Ines","Santa Isabel","Santa Isabel do Ivai","Santa Isabel do Para","Santa Leopoldina","Santa Lucia","Santa Luzia","Santa Luzia","Santa Luzia","Santa Luzia","Santa Maria","Santa Maria","Santa Maria da Vitoria","Santa Maria de Itabira","Santa Rita","Santa Rita do Passa Quatro","Santa Rita do Sapucai","Santa Rosa","Santa Teresa","Santa Teresa","Santa Teresinha","Santa Terezinha","Santana","Santana da Vargem","Santana de Parnaiba","Santana do Cariri","Santana do Ipanema","Santana do Livramento","Santana do Matos","Santana do Paraiso","Santarem Novo","Santiago","Santo","Santo Aleixo","Santo Amaro","Santo Amaro","Santo Amaro da Imperatriz","Santo Anastacio","Santo Antonio","Santo Antonio da Patrulha","Santo Antonio da Platina","Santo Antonio de Jesus","Santo Antonio de Lisboa","Santo Antonio de Padua","Santo Antonio de Posse","Santo Antonio do Amparo","Santo Antonio do Caiua","Santo Antonio do Grama","Santo Antonio do Jardim","Santo Antonio do Leverger","Santo Antonio do Monte","Santo Antonio do Pinhal","Santo Antonio do Retiro","Santo Estevao","Santo Expedito","Santo Inacio","Santos","Santos Dumont","Sao Bento","Sao Bento","Sao Bento do Sapucai","Sao Bernardo","Sao Caetano","Sao Caetano do Sul","Sao Carlos","Sao Cristovao","Sao Domingos","Sao Domingos","Sao Domingos","Sao Domingos","Sao Domingos","Sao Felipe","Sao Felix","Sao Fidelis","Sao Francisco","Sao Francisco","Sao Francisco de Paula","Sao Francisco do Conde","Sao Francisco do Sul","Sao Gabriel","Sao Gabriel","Sao Gabriel","Sao Gabriel da Cachoeira","Sao Geraldo do Araguaia","Sao Goncalo","Sao Goncalo do Amarante","Sao Goncalo do Para","Sao Goncalo do Sapucai","Sao Goncalo dos Campos","Sao Gotardo","Sao Jeronimo","Sao Joao","Sao Joao Batista","Sao Joao da Barra","Sao Joao da Boa Vista","Sao Joao de Meriti","Sao Joao de Pirabas","Sao Joao do Paraiso","Sao Joao Evangelista","Sao Joao Nepomuceno","Sao Joaquim","Sao Joaquim da Barra","Sao Joaquim de Bicas","Sao Joaquim do Monte","Sao Jose","Sao Jose","Sao Jose","Sao Jose da Barra","Sao Jose da Laje","Sao Jose de Mipibu","Sao Jose de Piranhas","Sao Jose de Ribamar","Sao Jose do Calcado","Sao Jose do Cedro","Sao Jose do Egito","Sao Jose do Goiabal","Sao Jose do Inhacora","Sao Jose do Ouro","Sao Jose do Rio Pardo","Sao Jose do Rio Preto","Sao Lourenco da Mata","Sao Lourenco da Serra","Sao Lourenco do Sul","Sao Lourenco dOeste","Sao Luis","Sao Luis de Montes Belos","Sao Luis do Paraitinga","Sao Luiz Gonzaga","Sao Manoel","Sao Manuel","Sao Marcos","Sao Miguel","Sao Miguel","Sao Miguel Arcanjo","Sao Miguel do Araguaia","Sao Miguel do Iguacu","Sao Miguel dos Campos","Sao Paulo","Sao Paulo","Sao Paulo do Potengi","Sao Pedro","Sao Pedro da Aldeia","Sao Pedro do Ivai","Sao Pedro do Sul","Sao Pedro dos Ferros","Sao Roque","Sao Roque","Sao Salvador","Sao Sebastiao","Sao Sebastiao","Sao Sebastiao","Sao Sebastiao","Sao Sebastiao","Sao Sebastiao da Amoreira","Sao Sebastiao da Grama","Sao Sebastiao do Cai","Sao Sebastiao do Maranhao","Sao Sebastiao do Paraiso","Sao Sepe","Sao Simao","Sao Tome","Sao Vicente","Sao Vicente","Sao Vicente de Paula","Sape","Sapeacu","Sapiranga","Sapucaia","Sapucaia","Sapucaia do Sul","Saquarema","Sarandi","Sarandi","Sarapui","Sardoa","Sarzedo","Satuba","Saudades","Schroeder","Seabra","Seara","Sebastianopolis do Sul","Seberi","Sede Nova","Sem Peixe","Senador Canedo","Senhor do Bonfim","Serafina","Seropedica","Serra","Serra","Serra","Serra","Serra Azul","Serra Negra","Serra Preta","Serra Talhada","Serrana","Serrania","Serrinha","Serro","Sertania","Sertanopolis","Sertao","Sertaozinho","Sete Lagoas","Sidrolandia","Silva Jardim","Silveiras","Simao Dias","Simao Pereira","Simoes","Simplicio Mendes","Siqueira Campos","Sitio Figueira","Sitio Novo","Sobradinho","Sobral","Socorro","Soledade","Sombrio","Sorocaba","Sorriso","Sousa","Stio Ouro Fino","Sulina","Sumare","Suzano","Tabatinga","Tabira","Taboao da Serra","Tabuleiro do Norte","Taguatinga","Taguatinga","Taiacu","Taiobeiras","Taiuva","Tamandare","Tambau","Tamboril","Tamoios","Tanabi","Tangua","Tanque Novo","Tapejara","Tapira","Tapirai","Taquara","Taquaral","Taquarana","Taquari","Taquaritinga","Tarumirim","Tatuamunha","Taua","Taubate","Teixeira","Teixeira","Telemaco Borba","Tenente Ananias","Tenorio","Teodoro Sampaio","Terenos","Teresina","Teresopolis","Terra Boa","Terra Nova","Terra Nova","Terra Rica","Terra Roxa","Terra Roxa","Teutonia","Tiangua","Tibagi","Tibau","Tiete","Tijuca","Tijucas","Timbauba","Timbe","Timbo","Timon","Timoteo","Tiradentes","Tobias Barreto","Tocantins","Toledo","Tomar do Geru","Tome Acu","Toritama","Torres","Touros","Tramandai","Tremembe","Tres Barras","Tres Cachoeiras","Tres Coroas","Tres Marias","Tres Passos","Tres Pontas","Tres Rios","Trindade","Trindade","Triunfo","Tubarao","Tucum","Tucunduva","Tucurui","Tuiuti","Tumiritinga","Tupa","Tupaciguara","Tupanatinga","Tupancireta","Tuparendi","Tupi Paulista","Turmalina","Turvo","Turvo","Uaua","Uba","Ubaira","Ubaitaba","Ubarana","Ubata","Ubatuba","Uberaba","Uberlandia","Uchoa","Uibai","Uirauna","Umbauba","Umbuzeiro","Umirim","Umuarama","Unai","Uniao da Vitoria","Urai","Urania","Urubici","Uruburetama","Urucania","Urucuca","Uruguaiana","Urupes","Urussanga","Vacaria","Valenca","Valente","Valentim Gentil","Valerio","Valinhos","Valparaiso","Vargem Alta","Vargem Grande do Sul","Vargem Grande Paulista","Varginha","Varjota","Varzea","Varzea Paulista","Varzelandia","Vassouras","Velha","Venancio Aires","Venda Nova","Vera Cruz","Vera Cruz","Vera Cruz","Vera Cruz","Veranopolis","Vespasiano","Vespasiano Correa","Viana","Vicencia","Vicente","Vicosa","Vicosa","Vicosa do Ceara","Videira","Vila Maria","Vila Muriqui","Vila Rica","Vila Velha","Vilar dos Teles","Vilhena","Vinhedo","Virgem da Lapa","Virginia","Virginopolis","Virmond","Visconde do Rio Branco","Vista Alegre do Alto","Vitoria de Santo Antao","Vitorino Freire","Volta Grande","Volta Redonda","Votorantim","Votuporanga","Wenceslau Braz","Witmarsum","Xanxere","Xavantina","Xaxim"],"Brunei":["Bandar Seri Begawan","Bangar","Kampong Jerudong","Kuala Balai","Kuala Belait","Panaga","Seria","Tutong"],"Bulgaria":["Akhtopol","Aksakovo","Aleksandriya","Alfatar","Anton","Antonovo","Ardino","Asenovgrad","Aytos","Babovo","Baltchik","Banite","Bankya","Bansko","Barutin","Batak","Belene","Belogradchik","Beloslav","Belovo","Berkovitsa","Bistritsa","Blagoevgrad","Boboshevo","Bobovdol","Borovan","Borovo","Botevgrad","Bratsigovo","Bregare","Bukovo","Bukovo","Burgas","Byala","Byala","Byala Slatina","Chakalarovo","Chernolik","Chernomorets","Cherven","Cherven Bryag","Chiprovtsi","Chirpan","Choba","Debelets","Devin","Dimitrovgrad","Dobrich","Dolna Banya","Dolna Mitropoliya","Dolna Oryakhovitsa","Dospat","Dragash Voyvoda","Draginovo","Dragizhevo","Dryanovo","Dulgopol","Dulovo","Dupnitsa","Elena","Elin Pelin","Elkhovo","Etropole","Gabrovo","Ganchovo","General-Toshevo","Glogovo","Godech","Gorna Oryakhovitsa","Gotse Delchev","Gulubovo","Gurkovo","Gurmazovo","Haskovo","Ikhtiman","Iskrets","Isperikh","Isperikhovo","Ivaylovgrad","Kableshkovo","Kamenovo","Kardzhali","Karlovo","Karnobat","Kavarna","Kazanlak","Kazashka Reka","Kharmanli","Khisarya","Knezha","Konush","Koprivets","Koprivlen","Kostenets","Kostievo","Kostinbrod","Kovachite","Kozloduy","Kran","Krichim","Krivodol","Krumovgrad","Krupnik","Kula","Kyustendil","Lom","Lovech","Lozno","Lukovit","Lyaskovets","Lyulyakovo","Madan","Malo Konare","Marikostinovo","Markovo","Mesta","Mezdra","Mikrevo","Moderno Predgradie","Momchilgrad","Montana","Moravka","Muglizh","Nesebar","Nikopol","Nova Zagora","Novi Iskur","Novi Pazar","Obzor","Omurtag","Orizovo","Orlovets","Oryakhovets","Oryakhovitsa","Ovoshtnik","Panagyurishte","Pavel Banya","Pavlikeni","Pazardzhik","Pchelishte","Pernik","Peshtera","Petrich","Pleven","Plovdiv","Poleto","Polski Trumbesh","Pomorie","Popovo","Pravets","Prespa","Provadiya","Radnevo","Raduil","Rakitovo","Rakovski","Ravda","Razgrad","Razlog","Rila","Rodopi","Rousse","Rozino","Rudozem","Ruen","Samokov","Samovodene","Samuil","Sandanski","Sandrovo","Septemvri","Sevlievo","Shabla","Shivachevo","Shumen","Silistra","Simeonovgrad","Simitli","Skravena","Slatina","Sliven","Slivnitsa","Smolyan","Smyadovo","Sofia","Sofronievo","Sokolets","Sopot","Sozopol","Sredets","Stamboliyski","Stara Zagora","Strazhitsa","Strelcha","Suedinenie","Svilengrad","Svishtov","Svoge","Targovishte","Tervel","Tochilari","Topoli","Topolovo","Troyan","Trustenik","Tryavna","Tutrakan","Varna","Veliko","Veliko Tarnovo","Velingrad","Vetren","Vidin","Vievo","Vlado Trichkov","Vrachesh","Vratsa","Yakoruda","Yambol","Zavet","Zlatitrap","Zlatograd"],"Cambodia":["Moung Roessei","Phnom Penh","Phumi Boeng (1)","Phumi Chhuk","Phumi Preah Haoh","Phumi Prei","Phumi Prek Mrinh","Phumi Siem Reab","Phumi Thmei","Phumi Thnal","Phumi Vott Phnum","Sihanoukville","Tuol Kok","Vott Kampong Svay"],"Cameroon":["Bafia","Bafoussam","Bamenda","Buea","Douala","Kribi","Kumba","Ringo","Tibati"],"Canada":["100 Mile House","Abbey","Abbotsford","Acadia Valley","Acme","Acton","Acton Vale","Agassiz","Agincourt","Ailsa Craig","Airdrie","Ajax","Aklavik","Alameda","Albanel","Alberton","Aldergrove","Alert Bay","Alexander","Alexandria","Alfred","Allan","Allardville","Allenford","Alliston","Alma","Alma","Almonte","Alton","Altona","Alvinston","Amherst","Amherstburg","Amos","Amqui","Ancaster","Andrew","Ange-Gardien","Angliers","Angus","Annapolis Royal","Antigonish","Apohaqui","Apple Hill","Apsley","Arborfield","Arborg","Arcadia","Arcola","Arctic Bay","Ardmore","Ardrossan","Arelee","Arichat","Arkona","Armagh","Armstrong","Arnprior","Arthabaska","Arthur","Arundel","Arva","Arviat","Asbestos","Ascot Corner","Ashcroft","Ashmont","Ashville","Assiniboia","Aston-Jonction","Athabasca","Athens","Atikameg","Atikokan","Atlin","Attawapiskat","Atwood","Audet","Aurora","Austin","Authier","Avonmore","Aylesford","Aylmer","Aylmer","Aylsham","Ayr","Ayton","Baddeck","Baden","Baie Verte","Baie-Comeau","Baie-Des-Sables","Baie-du-Febvre","Baie-Saint-Paul","Baie-Sainte-Catherine","Bala","Balcarres","Baldonnel","Baldur","Baltimore","Bamfield","Bancroft","Banff","Barkerville","Barnaby River","Barons","Barraute","Barrhead","Barrie","Barriere","Barrington","Barrington Passage","Bashaw","Bassano","Bath","Bathurst","Batiscan","Battleford","Bay Bulls","Bay de Verde","Bay Roberts","Bayfield","Beachburg","Beaconsfield","Beamsville","Bear River","Bearn","Bearskin Lake","Beauceville","Beauharnois","Beaumont","Beauport","Beaupre","Beausejour","Beauval","Beaux-Rivages--Lac-des-Ecorces--Val-Barrette","Beaver Bank","Beaver Crossing","Beaverlodge","Beaverton","Becancour","Bedford","Bedford","Beeton","Begin","Beiseker","Bell Island","Bella Bella","Belle River","Belleville","Bellevue","Bellevue","Beloeil","Belwood","Bentley","Berry Mills","Berthier-Sur-Mer","Berthierville","Berwick","Berwyn","Bethune","Betsiamites","Bic","Biencourt","Bienfait","Big River","Big Valley","Biggar","Binscarth","Birch Hills","Birchy Bay","Birtle","Black Creek","Black Diamond","Blackfalds","Blackie","Blacks Harbour","Blackville","Blaine Lake","Blainville","Blairmore","Blandford","Blenheim","Blind River","Bloomfield","Blue River","Bluewater","Bobcaygeon","Bois-des-Filion","Boisbriand","Boischatel","Boissevain","Bolton","Bonaventure","Bonne Bay","Bonnyville","Bonsecours","Bonshaw","Borden","Borden-Carleton","Boswell","Boucherville","Bouctouche","Bourget","Bow Island","Bowden","Bowmanville","Bowser","Boyle","Bracebridge","Brackendale","Bradford","Bramalea","Brampton","Brandon","Brantford","Brechin","Bredenbury","Brentwood Bay","Breslau","Breton","Bridge Lake","Bridgetown","Bridgewater","Brigham","Brighton","Brigus","Britt","Broadview","Brochet","Brockville","Brome","Bromhead","Bromont","Brookfield","Brooklyn","Brooks","Brossard","Brossard","Bruno","Bryson","Buckhorn","Buckingham","Buffalo Narrows","Burgeo","Burgessville","Burin","Burlington","Burnaby","Burns Lake","Burnside","Cabano","Cabri","Cache Creek","Calder","Caledon","Caledon","Caledonia","Caledonia","Calgary","Calixa-Lavallee","Callander","Calmar","Cambridge","Cambridge","Cambridge Bay","Camlachie","Campbell River","Campbellford","Campbellton","Campbellville","Camrose","Canal Flats","Candiac","Canfield","Canim Lake","Canmore","Canning","Cannington","Canoe Narrows","Canora","Canso","Canterbury","Canwood","Canyon","Cap-aux-Meules","Cap-Chat","Cap-Saint-Ignace","Cap-Sante","Cape Dorset","Caraquet","Carberry","Carbonear","Cardigan","Cardinal","Cardston","Carignan","Carleton Place","Carleton-sur-Mer","Carlisle","Carlyle","Carmacks","Carman","Carmel","Carnduff","Caroline","Caronport","Carp","Carrot River","Carrying Place","Carseland","Carstairs","Carters Cove","Cartier","Cartwright","Casimir","Casselman","Castle Bay","Castlegar","Cat Lake","Causapscal","Cavendish","Cayley","Cayuga","Cedar Valley","Central Bedeque","Centreville","Ceylon","Chalk River","Chambly","Champlain","Chandler","Chapais","Chapel Arm","Chapleau","Charlemagne","Charlesbourg","Charlie Lake","Charlottetown","Charny","Chase","Chateau-Richer","Chateauguay","Chatham","Chatsworth","Cheapside","Chelmsford","Chelsea","Chemainus","Cheneville","Cherry Grove","Chertsey","Chesley","Chester","Chestermere","Chesterville","Cheticamp","Chibougamau","Chicoutimi","Chicoutimi","Chilliwack","Chipman","Church Point","Churchill","Churchill","Churchville","Chute-aux-Outardes","Circonscription electorale de Jacques-Cartier","Clair","Clairmont","Claremont","Clarence","Clarence-Rockland","Clarenville","Clarenville-Shoal Harbour","Claresholm","Clarke City","Clarkson","Clearwater","Clementsvale","Clermont","Cleveland","Clifford","Clinton","Clinton","Clive","Clyde River","Coal Harbour","Coaldale","Coaticook","Cobble Hill","Cobden","Coboconk","Cobourg","Coburg","Cochrane","Cochrane","Colborne","Cold Lake","Coldstream","Coldwater","Coleman","Coleman","Coleraine","Coleville","Colinet","Colliers","Collingwood","Colonsay","Colville Lake","Comber","Comox","Compton","Conception Bay South","Concord","Conestogo","Coniston","Conquest","Consort","Contrecoeur","Cookshire-Eaton","Copper Cliff","Coquitlam","Corbyville","Corner Brook","Cornwall","Cornwall","Cornwallis","Cote-Saint-Luc","Cottam","Courtenay","Courtland","Courtright","Coutts","Cow Head","Cowansville","Cowichan Bay","Cowley","Crabtree","Craik","Cranberry","Cranberry Portage","Cranbrook","Crapaud","Creemore","Creston","Crofton","Cromer","Cross Lake","Crossfield","Cudworth","Cumberland","Cumberland","Cumberland Bay","Cumberland House","Cupar","Cut Knife","Czar","Dalhousie","Dalmeny","Danville","Dartmouth","Dashwood","Dauphin","Daveluyville","Davidson","Dawson City","Dawson Creek","Dawson Settlement","Daysland","Debden","Debert","DeBolt","Deep River","Deer Lake","Deer Lake","Delaware","Delaware West","Delburne","Delhi","Deline","Delisle","Delson","Delta","Denfield","Denman Island","Deroche","Desbiens","Deschaillons-sur-Saint-Laurent","Deschambault","Deseronto","Deux-Montagnes","Devon","Didsbury","Dieppe","Digby","Digby","Dinsmore","Disraeli","Dixville","Doaktown","Dog Creek","Dolbeau-Mistassini","Dollard-Des Ormeaux","Domain","Dominion City","Domremy","Don Mills","Donnacona","Donnelly","Dorchester","Dorion-Gardens","Dorset","Dorval","Dover","Downsview","Drayton","Drayton Valley","Dresden","Drumbo","Drumheller","Drummondville","Dryden","Dublin","Duchess","Duck Lake","Dudswell","Dufresne","Dugald","Duhamel","Duncan","Dundalk","Dundas","Dundurn","Dunham","Dunnville","Dunsford","Dupuy","Durham","Eaglesham","Earlton","East Angus","East Broughton","East Chezzetcook","East Coulee","East Margaree","Eastern Passage","Eastman","Eastport","Eatonville","Echo Bay","Eckville","Economy","Edam","Eden","Edgerton","Edgewood","Edmonton","Edmundston","Edson","Eganville","Elbow","Elgin","Elgin","Elk Point","Elliot Lake","Elliston","Elma","Elmira","Elmsdale","Elmvale","Elora","Elrose","Embrun","Emerald","Emerald Junction","Emo","Empress","Emsdale","Enderby","Enfield","Englehart","Enterprise","Entwistle","Eriksdale","Erin","Espanola","Esprit-Saint","Essex","Esterhazy","Estevan","Eston","Etobicoke","Eureka","Everett","Exeter","Fabreville","Fairmont Hot Springs","Fairview, Alberta","Farnham","Fenelon Falls","Fergus","Ferintosh","Ferme-Neuve","Fermeuse","Fermont","Fernie","Field","Field","Fillmore","Finch","Flat River","Flesherton","Flin Flon","Florenceville-Bristol","Foam Lake","Fogo","Fonthill","Foremost","Forest","Forestburg","Forestville","Fort Albany","Fort Erie","Fort Frances","Fort Good Hope","Fort Hope","Fort Kent","Fort Macleod","Fort McMurray","Fort McPherson","Fort Nelson","Fort Saskatchewan","Fort Severn","Fort Simpson","Fort Smith","Fort St. James","Fort St. John","Fort Vermilion","Fort-Coulonge","Fortierville","Fortune","Fox Creek","Foxtrap","Foymount","Francis","Frankford","Fraser Lake","Fredericton","Fredericton Junction","Frelighsburg","Frobisher","Fruitvale","Gabriola","Gadsby","Galahad","Gambo","Gananoque","Gander","Gander Bay","Ganges","Garden River","Garibaldi","Garibaldi Highlands","Garnish","Garrick","Garson","Gatineau","Gem","Georgetown","Geraldton","Gibsons","Gilbert Plains","Gillam","Gimli","Girouxville","Glace Bay","Gladstone","Glaslyn","Gleichen","Glen Robertson","Glencoe","Glendon","Glentworth","Glenwood","Glenwood","Gloucester","Glovertown","Goderich","Gogama","Gold Bridge","Golden","Golden Lake","Gore","Gore Bay","Granby","Grand Bend","Grand Falls","Grand Falls-Windsor","Grand Forks","Grand Rapids","Grand Valley","Grand-Remous","Grand-Saint-Esprit","Grande Cache","Grande Prairie","Grande-Anse","Grande-Riviere","Grandora","Granton","Granum","Granville Ferry","Grasmere","Gravelbourg","Gravenhurst","Gray Creek","Great Village","Greater Sudbury","Greely","Greenfield Park","Greenspond","Greenwood","Greenwood","Grenfell","Grenville","Gretna","Grimsby","Grimshaw","Grindrod","Griswold","Gronlid","Grono Road","Guelph","Guigues","Gull Lake","Guysborough","Hafford","Hagensborg","Hagersville","Haileybury","Halfmoon Bay","Haliburton","Halifax","Halifax","Ham-Nord","Hamilton","Hamiota","Hampden","Hampton","Hampton","Hanley","Hanna","Hanover","Hantsport","Happy Valley-Goose Bay","Harbour Grace","Harbour Main","Hardisty","Hare Bay","Harriston","Harrow","Hartland","Hartley Bay","Hartney","Harvey","Hastings","Havelock","Havre Boucher","Havre-Aubert","Havre-Saint-Pierre","Hawkesbury","Hawkestone Beach","Hay Lakes","Hay River","Hazelton","Head of Jeddore","Hearst","Hebertville","Hebron","Hemmingford","Henryville","Hensall","Herbert","Heron Bay","Hespeler","High Level","High Prairie","High River","Hillsburgh","Hinton","Hobbema","Holden","Holman","Holyrood","Honeymoon Bay","Hope","Hornepayne","Houston","Howick","Howley","Hubbards","Hudson","Hudson Bay","Hull","Humboldt","Hunter River","Huntingdon","Huntsville","Huron East","Hythe","Ignace","Ilderton","Ile-a-la-Crosse","Indian Head","Ingersoll","Ingleside","Inglewood","Inglis","Ingonish","Innisfail","Innisfil","Inukjuak","Inuvik","Invermere","Inverness","Inwood","Iona","Iqaluit","Irma","Iroquois","Iroquois Falls","Irricana","Islington","Italy Cross","Ituna","Ivujivik","Jacksons","Jasper","Jenner","Jerseyville","Joliette","Jonquiere","Jordan","Jordan Falls","Kagawong","Kamloops","Kamouraska","Kamsack","Kanata","Kangiqsujuaq","Kangirsuk","Kapuskasing","Kars","Kaslo","Kazabazua","Kedgwick","Keene","Keewatin","Kelowna","Kelvington","Kemptville","Kenora","Kensington","Kent Bridge","Kentville","Kerrobert","Kerwood","Keswick","Keswick Beach","Kettleby","Killarney","Kilworthy","Kimberley","Kimmirut","Kincardine","Kindersley","King City","Kingsey Falls","Kingston","Kingston","Kingsville","Kingsville","Kinistino","Kinuso","Kippen","Kirkland","Kirkland Lake","Kirkton","Kisbey","Kispiox","Kitchener","Kitchener","Kitimat","Kitscoty","Kitwanga","Klemtu","Knowlton","Kohler","Komoka","Kugaaruk","Kugluktuk","Kuujjuaq","Kuujjuarapik","La Baie","La Conception","La Corey","La Durantaye","La Guadeloupe","La Loche","La Malbaie","La Morandiere","La Patrie","La Pocatiere","La Prairie","La Presentation","La Ronge","La Salle","La Sarre","La Tabatiere","La Tuque","La Visitation","Labelle","Labrador City","Lac du Bonnet","Lac La Biche","Lac-aux-Sables","Lac-Drolet","Lac-Megantic","Lachenaie","Lachine","Lachute","Lacolle","Lacombe","Ladysmith","Ladysmith","Lafleche","LaHave","Lake Cowichan","Lake Lenore","Lake Louise","Lakeburn","Lakefield","Lambton","Lamont","Lampman","Lanark","Lancaster","Lancaster Park","Landrienne","Lang","Langdon","Langenburg","Langham","Langley","Lanigan","Lanoraie","Lantzville","Lasalle","Lashburn","Laurentia Beach","Laurier-Station","Laval","Lavaltrie","Laverlochere","Lavillette","Lawrencetown","Leader","Leamington","Leduc","Lefroy","Legal","Lemberg","Leonard","Lery","Les Cedres","Les Coteaux","Les Escoumins","Les Mechins","Leslieville","Lethbridge","Lethbridge","Levack","Levis","Lewisporte","Lillooet","Limoges","Lindsay","Lipton","Listowel","Little Current","Little Narrows","Lively","Liverpool","Lloydminster","Logan Lake","London","Londonderry","Long Sault","Longueuil","Lorraine","Lotbiniere","Lougheed","Louisbourg","Louiseville","Lourdes","Lower Island Cove","Lucan","Lucknow","Lucky Lake","Lumby","Lumsden","Lumsden","Lunenburg","Luseland","Luskville","Lyn","Lyster","Lytton","Maberly","Mabou","Macamic","MacGregor","Mackenzie","Macklin","MacTier","Madoc","Magog","Magrath","Mahone Bay","Maidstone","Maidstone","Malagawatch","Malakwa","Malartic","Mallaig","Malton","Mandeville","Manitou","Manitouwadge","Maniwaki","Mankota","Mannville","Manor","Manotick Station","Manseau","Mansonville","Maple","Maple Creek","Maple Ridge","Mar","Marathon","Marbleton","Marchand","Margaree Valley","Margaretsville","Maria","Marieville","Markdale","Markham","Markstay","Marmora","Martinville","Marwayne","Maryfield","Marystown","Marysville","Mascouche","Maskinonge","Masset","Massey","Masson-Angers","Massueville","Matagami","Matane","Matheson","Maxville","Mayne","McBride","McCreary","McGregor","McLennan","McMasterville","Meadow Lake","Meaford","Medicine Hat","Melbourne Ridge","Melfort","Melita","Melocheville","Melville","Memphremagog","Memramcook","Mercier","Merlin","Merrickville","Merritt","Merville","Messines","Metabetchouan-Lac-a-la-Croix","Meteghan","Meteghan River","Metis-sur-Mer","Miami","Midale","Middle Arm","Middle Musquodoboit","Middleton","Midhurst","Midland","Milden","Mildmay","Milford","Milford Station","Milk River","Mill Village","Millarville","Millbrook","Millet","Millville","Milton","Milton","Milverton","Minden","Minnedosa","Minto","Mira Gut","Mirabel","Miramichi","Miscouche","Mission","Mississauga","Mistatim","Mitchell","Moberly Lake","Mobile","Moffat","Moncton","Mont-Joli","Mont-Laurier","Mont-Royal","Mont-Saint-Gregoire","Mont-Saint-Hilaire","Mont-Saint-Michel","Mont-Tremblant","Montague","Montebello","Montmagny","Montmartre","Montreal","Montreal East","Moonbeam","Mooretown","Moose Creek","Moose Jaw","Moose Lake","Moosehorn","Moosomin","Moosonee","Moraviantown","Morden","Morell","Morewood","Morinville","Morrin","Morris","Morrisburg","Mortlach","Mount Brydges","Mount Elgin","Mount Forest","Mount Pearl","Mount Stewart","Mount Uniacke","Mountain View","Muirkirk","Mulgrave","Mundare","Munson","Munster","Murdochville","Murray Harbour","Murray River","Musquodoboit Harbour","Myrnam","Nackawic","Naicam","Nakina","Nakusp","Nampa","Namur","Nanaimo","Nanoose Bay","Nantes","Nanton","Napanee","Napanee","Napierville","Nauwigewauk","Neepawa","Neguac","Neilburg","Nelson","Nepean","Neudorf","Neuville","New Aiyansh","New Carlisle","New Denver","New Dundee","New Glasgow","New Hamburg","New Harbour","New Liskeard","New Ross","New Waterford","New Westminster","New-Richmond","New-Wes-Valley","Newburgh","Newcastle Creek","Newcastle Village","Newdale","Newmarket","Newport","Newton","Newtown","Niagara","Niagara Falls","Niagara-on-the-Lake","Nicolet","Nipawin","Nipigon","Nisku","Niverville","Nobleford","Nobleton","Nokomis","Nominingue","Norfolk County","Norman Wells","Normandin","Norquay","North Battleford","North Bay","North Delta","North Hatley","North Lunenburg","North Perth","North Portal","North Russell","North Rustico","North Saanich","North Star","North Sydney","North Vancouver","North York","Norval","Norway House","Norwich","Norwood","Notre-Dame-de-Lourdes","Notre-Dame-du-Bon-Conseil","Notre-Dame-du-Mont-Carmel","Notre-Dame-du-Nord","Notre-Dame-du-Portage","Nouvelle","Noyan","Oak Lake","Oak Point","Oakville","Obedjiwan","Odessa","Ogoki","Ohsweken","Oil Springs","Oka","Okanagan Centre","Okotoks","Old Perlican","Oldcastle","Olds","Oliver","Omemee","Omerville","Onanole","Onion Lake","Onoway","Orangeville","Orillia","Orleans","Ormstown","Oromocto","Orono","Orton","Oshawa","Osoyoos","Ottawa","Otter Lake","Otterburn Park","Otterburne","Outlook","Owen Sound","Oxbow","Oxdrift","Oxford","Oxford House","Oyama","Pain Court","Paisley","Pakenham","Palmarolle","Palmerston","Papineauville","Paradise Cove","Paradise Valley","Parham","Paris","Parisville","Parkhill","Parksville","Parry Sound","Parson","Pasadena","Pascal","Paspebiac","Pass Lake","Paulatuk","Peace River","Peachland","Pefferlaw","Pelly","Pemberton","Pembroke","Penetanguishene","Penhold","Pennfield","Penobsquis","Penticton","Penzance","Perth","Perth","Perth-Andover","Petawawa","Peterborough","Petherton","Petit-de-Grat","Petitcodiac","Petite-Riviere-Saint-Francois","Petrolia","Pickering","Picton","Pictou","Pierreville","Pierson","Pikangikum","Pilot Butte","Pilot Mound","Pinantan Lake","Pinawa","Pincher Creek","Pincourt","Pine Falls","Piney","Pitt Meadows","Placentia","Plamondon","Plantagenet Station","Plaster Rock","Plessisville","Plum Coulee","Plumas","Plympton","Point Edward","Pointe-a-la-Croix","Pointe-aux-Trembles","Pointe-Calumet","Pointe-Claire","Pointe-Fortune","Pointe-Lebel","Pointe-Verte","Ponoka","Pont-Rouge","Pont-Viau","Pontypool","Poplar Hill","Port Alberni","Port Alice","Port au Choix","Port au Port","Port Burwell","Port Clements","Port Colborne","Port Coquitlam","Port Credit","Port Dover","Port Edward","Port Elgin","Port Elgin","Port Hardy","Port Hawkesbury","Port Hope","Port Lorne","Port McNeill","Port McNicoll","Port Medway","Port Moody","Port Morien","Port Perry","Port Renfrew","Port Royal","Port Saunders","Port Stanley","Port-Cartier","Port-Daniel","Portage","Portage la Prairie","Portage-du-Fort","Porters Lake","Portneuf","Portugal Cove","Potter","Pouce Coupe","Pouch Cove","Powassan","Powell River","Preeceville","Prescott","Price","Priceville","Prince","Prince Albert","Prince George","Prince Rupert","Princeton","Princeville","Pritchard","Prospect","Provost","Pugwash","Pukatawagan","Puslinch","Puvirnituq","Pynns","Qualicum Beach","Quaqtaq","Quathiaski Cove","Quebec","Queen Charlotte","Quesnel","Quill Lake","Quispamsis","Quyon","Racine","Radisson","Radville","Rainbow Lake","Raleigh","Ramea","Rankin Inlet","Rapid City","Rawdon","Raymond","Raymore","Red Deer","Red Lake","Red Rock","Redcliff","Redvers","Redwater","Regina","Rencontre East","Renfrew","Renous","Repentigny","Revelstoke","Rexdale","Rhein","Richibucto","Richmond","Richmond","Richmond","Richmond Hill","Ridgetown","Ridgeway","Rigaud","Rimbey","Rimouski","Ripley","Ripon","Ripples","River Hebert","River John","Rivers","Riverside-Albert","Riverton","Riverview","Riviere-Beaudette","Riviere-Bleue","Riviere-Ouelle","Riviere-Rouge","Riviere-Saint-Paul","Roberts Creek","Roberval","Roblin","Roblin","Rocanville","Rockland","Rockville","Rockwood","Rocky Mountain House","Roddickton","Rogersville","Roland","Rosalind","Rosedale","Rosemary","Rosemere","Roseneath","Rosetown","Rossburn","Rossland","Rossport","Rosthern","Rothesay","Rougemont","Rouleau","Rouyn-Noranda","Roxboro","Roxton Falls","Roxton Pond","Rumsey","Russell","Rycroft","Saanichton","Sable River","Sabrevois","Sackville","Saguenay","Saint Andrews","Saint Etienne-De-Lauzon","Saint John","Saint Romuald","Saint-Adalbert","Saint-Adelphe","Saint-Agapit","Saint-Aime-du-Lac-des-Iles","Saint-Alban","Saint-Alexis-des-Monts","Saint-Ambroise","Saint-Anaclet-de-Lessard","Saint-Andre","Saint-Andre-Avellin","Saint-Anicet","Saint-Anselme","Saint-Antoine-de-Tilly","Saint-Antoine-sur-Richelieu","Saint-Antonin","Saint-Apollinaire","Saint-Arsene","Saint-Aubert","Saint-Augustin","Saint-Augustin-de-Desmaures","Saint-Barnabe-Sud","Saint-Barthelemy","Saint-Basile","Saint-Basile-le-Grand","Saint-Benjamin","Saint-Bruno","Saint-Bruno-de-Montarville","Saint-Camille","Saint-Camille","Saint-Casimir","Saint-Cesaire","Saint-Charles-de-Bellechasse","Saint-Charles-sur-Richelieu","Saint-Clement","Saint-Colomban","Saint-Come","Saint-Come--Liniere","Saint-Cyprien","Saint-Cyrille-de-Wendover","Saint-Damase","Saint-Denis","Saint-Denis","Saint-Dominique","Saint-Donat","Saint-Elie","Saint-Elzear","Saint-Etienne-des-Gres","Saint-Eusebe","Saint-Eustache","Saint-Fabien","Saint-Fabien-de-Panet","Saint-Faustin--Lac-Carre","Saint-Felicien","Saint-Felix-de-Kingsey","Saint-Felix-de-Valois","Saint-Ferdinand","Saint-Ferreol-les-Neiges","Saint-Flavien","Saint-Francois-du-Lac","Saint-Frederic","Saint-Gabriel","Saint-Gabriel-de-Valcartier","Saint-Gedeon","Saint-Georges","Saint-Georges-de-Windsor","Saint-Germain-de-Grantham","Saint-Gilles","Saint-Godefroi","Saint-Guillaume","Saint-Henri","Saint-Hilaire","Saint-Honore-de-Temiscouata","Saint-Hubert-de-Riviere-du-Loup","Saint-Hugues","Saint-Hyacinthe","Saint-Irenee","Saint-Isidore","Saint-Jacques","Saint-Jean-de-Dieu","Saint-Jean-de-Matha","Saint-Jean-Port-Joli","Saint-Jean-sur-Richelieu","Saint-Jerome","Saint-Joachim","Saint-Joachim-de-Shefford","Saint-Joseph-de-Beauce","Saint-Jude","Saint-Lambert","Saint-Lambert","Saint-Lazare-de-Bellechasse","Saint-Leon-de-Standon","Saint-Leonard","Saint-Liboire","Saint-Lin","Saint-Lin-Laurentides","Saint-Louis de Kent","Saint-Louis-de-Gonzague","Saint-Luc","Saint-Ludger","Saint-Malachie","Saint-Marc-de-Figuery","Saint-Marc-des-Carrieres","Saint-Marc-sur-Richelieu","Saint-Mathieu","Saint-Maurice","Saint-Michel","Saint-Michel-de-Bellechasse","Saint-Michel-des-Saints","Saint-Nazaire","Saint-Odilon-de-Cranbourne","Saint-Pacome","Saint-Pamphile","Saint-Pascal","Saint-Paul","Saint-Paul","Saint-Paul-de-la-Croix","Saint-Paulin","Saint-Philemon","Saint-Philippe","Saint-Philippe-de-Neri","Saint-Pie","Saint-Pierre","Saint-Pierre-de-Broughton","Saint-Pierre-les-Becquets","Saint-Placide","Saint-Polycarpe","Saint-Prosper","Saint-Quentin","Saint-Raphael","Saint-Raymond","Saint-Remi","Saint-Roch","Saint-Roch-de-Richelieu","Saint-Roch-des-Aulnaies","Saint-Sauveur","Saint-Sebastien","Saint-Severe","Saint-Simon-de-Rimouski","Saint-Stanislas","Saint-Stanislas-de-Kostka","Saint-Sylvere","Saint-Sylvestre","Saint-Telesphore","Saint-Thomas","Saint-Tite","Saint-Ubalde","Saint-Ulric","Saint-Urbain","Saint-Urbain-Premier","Saint-Vallier","Saint-Venant-de-Paquette","Saint-Victor","Saint-Wenceslas","Saint-Zacharie","Saint-Zenon","Saint-Zotique","Sainte-Adele","Sainte-Agathe-des-Monts","Sainte-Angele-de-Premont","Sainte-Anne-de-Beaupre","Sainte-Anne-de-Bellevue","Sainte-Anne-de-la-Perade","Sainte-Anne-des-Monts","Sainte-Anne-du-Lac","Sainte-Brigitte-des-Saults","Sainte-Catherine","Sainte-Cecile-de-Masham","Sainte-Cecile-de-Whitton","Sainte-Claire","Sainte-Clotilde-de-Horton","Sainte-Croix","Sainte-Famille","Sainte-Foy","Sainte-Gertrude","Sainte-Helene-de-Bagot","Sainte-Helene-de-Breakeyville","Sainte-Julie","Sainte-Julienne","Sainte-Justine","Sainte-Marcelline-de-Kildare","Sainte-Marguerite","Sainte-Marie","Sainte-Marthe","Sainte-Marthe-sur-le-Lac","Sainte-Martine","Sainte-Melanie","Sainte-Monique","Sainte-Perpetue","Sainte-Thecle","Sainte-Therese","Salaberry-de-Valleyfield","Salisbury","Salmo","Salmon Arm","Salmon River","Sandy Bay","Sandy Lake","Sanikiluaq","Sardis","Sarnia","Saskatoon","Saulnierville","Sault Ste. Marie","Savona","Sawyerville","Sayabec","Sayward","Scarborough","Schefferville","Schomberg","Schreiber","Scotland","Scotsburn","Scotstown","Scott","Scoudouc","Seaforth","Searchmont","Sechelt","Seldom-Little Seldom","Selkirk","Senneterre","Senneville","Sept-Iles","Seton Portage","Severn Bridge","Sexsmith","Shamattawa","Shanklin","Shannon","Shannonville","Sharbot Lake","Shaunavon","Shawinigan","Shawinigan-Sud","Shawnigan Lake","Shawville","Shediac","Sheho","Shelburne","Shelburne","Shellbrook","Sherbrooke","Sherbrooke","Sherrington","Sherwood Park","Shigawake","Shoal Lake","Shubenacadie","Sicamous","Sidney","Sillery","Silton","Simcoe","Sioux Lookout","Skidegate","Slave Lake","Slocan","Smithers","Smiths Falls","Smithville","Smoky Lake","Smooth Rock Falls","Snow Lake","Sointula","Sombra","Sooke","Sorel","Sorel-Tracy","Sorrento","Souris","Souris","South Augusta","South Gower","South Indian Lake","South Lancaster","South Mountain","South Porcupine","South River","South Slocan","Southend Reindeer","Southey","Spanish","Sparta","Spencerville","Sperling","Spillimacheen","Spirit River","Spiritwood","Spring Hill","Springdale","Springfield","Springhill","Spruce Grove","Spy Hill","Squamish","St-Hubert","St-Lazare","St-Timothee","St. Albert","St. Andrews","St. Anthony","St. Brieux","St. Catharines","St. Jacobs","St. Louis","St. Marys","St. Paul","St. Peters Bay","St. Stephen","St. Thomas","St. Walburg","Stanbridge East","Standard","Stanley Bridge, Hope River, Bayview, Cavendish and North Rustico","Star City","Stayner","Steinbach","Stella","Stellarton","Stephenville","Stephenville Crossing","Stettler","Stevensville","Stewiacke","Stirling","Stirling","Stittsville","Stoneham","Stonewall","Stoney Creek","Stony Mountain","Stony Plain","Stouffville","Stoughton","Strasbourg","Stratford","Stratford","Strathmore","Strathroy","Streetsville","Sturgeon Falls","Sturgis","Summerland","Summerside","Sunderland","Sundridge","Surrey","Sussex","Sutton","Sutton","Swan River","Swastika","Swift Current","Sydenham","Sydney","Sydney","Sydney Mines","Sylvan Lake","Taber","Tadoussac","Tahsis","Takla Landing","Tappen","Taschereau","Tasiujaq","Tatamagouche","Tavistock","Taylor","Tecumseh","Tecumseh","Teeswater","Temiscaming","Tennion","Terrace","Terrace Bay","Terre Noire","Terrebonne","Teulon","Thamesford","Thamesville","The Pas","Thedford","Theodore","Theresa","Thetford-Mines","Thompson","Thorhild","Thornbury","Thorndale","Thornhill","Thorold","Three Hills","Three Mile Plains","Thunder Bay","Thurso","Tilbury","Tilley","Tillsonburg","Timberlea","Timmins","Tisdale","Tlell","Tofield","Tofino","Tompkins","Tompkins","Torbay","Toronto","Torrington","Tottenham","Tracadie","Trail","Treherne","Trenton","Trenton","Tring-Jonction","Trochu","Trois Pistoles","Trout Creek","Trout River","Troy","Truro","Tsawwassen","Tuktoyaktuk","Tumbler Ridge","Turner Valley","Turtleford","Tusket","Tweed","Twillingate","Two Hills","Tyndall","Ucluelet","Union Bay","Unionville","Unity","Upper Island Cove","Upton","Utterson","Uxbridge","Val-Brillant","Val-David","Val-des-Monts","Val-Morin","Valcourt","Valemount","Vallee-Jonction","Valley","Valleyview","Van Anda","Vancouver","Vanderhoof","Vankleek Hill","Varennes","Vaudreuil-Dorion","Vaughan","Vauxhall","Vegreville","Vercheres","Verdun","Vermilion","Verner","Vernon","Vernon Bridge","Victoria","Victoria","Victoria Cove","Victoria Harbour","Victoriaville","Vieux-Saint-Laurent","Viking","Villa Marie","Ville-Marie","Vineland Station","Virden","Viscount","Vonda","Vulcan","Wabana","Wabigoon","Wabush","Wadena","Wainfleet","Wainwright","Wakaw","Wakefield","Waldeck","Waldheim","Walkerton","Wallace","Wallaceburg","Warkworth","Warman","Warner","Warsaw","Warwick","Wasaga Beach","Washago","Waterdown","Waterford","Waterloo","Waterloo","Waterville","Watford","Watrous","Watson","Watson Lake","Waubaushene","Wawa","Waweig","Wawota","Weedon","Weir","Weldon","Welland","Wellesley","Wellington","Wellington","Wembley","Wemindji","West Bay","West Chezzetcook","West Hill","West Lake","West Osgoode","Westbank","Western Bay","Westlock","Westmount","Weston","Westport","Westree","Westville","Wetaskiwin","Weyburn","Wheatley","Whistler Village","Whitby","White City","White Fox","White River","White Rock","Whitecourt","Whitehorse","Whitemouth","Whites Lake","Whitney","Whycocomagh","Wiarton","Wickham","Wilcox","Wildwood","Wilkie","Williams Lake","Williamsburg","Willingdon","Willow Bunch","Willowdale","Willowvale","Winchester","Windermere","Windham Centre","Windsor","Windsor","Windsor","Winfield","Winfield","Wingham","Winkler","Winnipeg","Winnipegosis","Wiseton","Wishart","Witless Bay","Wittenburg","Wolfville","Wolseley","Wood Mountain","Woodbridge","Woodlands","Woodridge","Woodstock","Woodstock","Worsley","Wrentham","Wright-Gracefield-Northfield","Wymark","Wynyard","Wyoming","Yahk","Yamachiche","Yamaska","Yarker","Yarmouth","Yellow Grass","Yellowknife","York","Yorkton","Youbou","Young","Youngstown"],"Cayman Islands":["Bodden Town","Coral Gables","George Town","Newlands","Savannah","Spot Bay","West Bay"],"Chile":["Algarrobo","Angol","Antofagasta","Apoquindo","Arauco","Arica","Buin","Bulnes","Calama","Caldera","Castro","Catemu","Centro","Cerrillos de Tamaya","Chicureo Abajo","Chiguayante","Chillan","Chillan Viejo","Chimbarongo","Chonchi","Chuquicamata","Coihaique","Colina","Collipulli","Concon","Constitucion","Coquimbo","Coronel","Cunco","Curacavi","Dalcahue","El Arco","El Bosque","El Monte","El Quisco","El Salto","El Salvador","El Valle","Fresia","Galvarino","Graneros","Hanga Roa","Iquique","La Calera","La Cisterna","La Granja","La Laja","La Ligua","La Reina","La Serena","La Union","Lampa","Las Condes","Lautaro","Llanquihue","Lo Barnechea","Lolol","Los Andes","Los Angeles","Machali","Macul","Maipu","Maquina Atacama","Maule","Mejillones","Melipilla","Miraflores","Molina","Monte Aguila","Nacimiento","Nogales","Nunoa","Olmue","Osorno","Ovalle","Paillaco","Penablanca","Penaflor","Port Montt","Providencia","Puchuncavi","Pucon","Puente Alto","Puerto Aisen","Puerto Natales","Puerto Varas","Punta Arenas","Puren","Purranque","Quellon","Quemchi","Quilicura","Quillota","Rancagua","Recoleta","Renaca","Renca","Rengo","Rinconada","Rio Bueno","San Antonio","San Bernardo","San Carlos","San Felipe","San Fernando","San Javier","San Martin","San Pedro","Santa Barbara","Santiago","Talagante","Talca","Talcahuano","Tarapaca","Temuco","Tome","Valdivia","Vallenar","Villa Alemana","Villarrica","Vitacura"],"China":["Aishang","Aizhou","Aksu","Anbang","Anbu","Ancheng","Anda","Andong","Angu","Anguo","Anhu","Anji","Anjiang","Ankang","Anke","Anqing","Anqiu","Anshan","Anshun","Ansu","Anxi","Anyang","Anying","Anzhou","Anzi","Aojiang","Aoma","Bagong","Baicheng","Baidu","Baihua","Baile","Bailicun","Baipo","Baise City","Baisha","Baishan","Baishi","Baitang","Baixiang","Baixin","Baiyashi","Baiyi","Baiyin","Baiyu","Baiyun","Baizhang","Baliqiao","Bamao","Bangke","Bangtou","Bantou","Banxi","Banyou","Baocheng","Baodi","Baodian","Baoding","Baojiang","Baoluo","Baoqing","Baoshan","Baotao","Baotian","Baotou","Baotou","Baoxing","Baoyu","Base","Baying","Bazhou","Baziqiang","Beichan","Beidou","Beihai","Beijie","Beijing","Beilin","Beilun","Beishan","Beixi","Beixiao","Beiying","Beiyuan","Beiyuan","Bengbu","Benxi","Bianzhuang","Bibo","Bijie","Binhe","Binjiang","Binzhou","Biyang","Bobai","Bohai","Boji","Bole","Bole","Boli","Boshan","Boxing","Bozhou","Buxin","Caijing","Caishen","Caiyuan","Caiyuan","Cangnan","Cangshang","Cangzhou","Caopu","Caoxi","Caozhai","Cengang","Cenyang","Cezi","Chadianzi","Chaicun","Chaigoubu","Chamdo","Changchao","Changchun","Changde","Changfeng","Changhe","Changjian","Changjiang","Changle","Changle","Changning","Changping","Changqing","Changsha","Changshan","Changsheng","Changsheng","Changshu City","Changting","Changtu","Changxiacun","Changxin","Changzheng","Changzhi","Changzhong","Changzhou","Chaohu","Chaoyang","Chaoyang","Chaozhou","Chen Xian","Chendu","Chengbei","Chengdong","Chengdong","Chengdu","Chengfeng","Chengguan","Chenghua","Chengjian","Chengmai","Chengnan","Chengqiao","Chenguang","Chengxi","Chengxian Chengguanzhen","Chengxiang","Chengxiang","Chengyang","Chengzhong","Chenyang","Chenzhou","Chifeng","Chiping","Chizhou","Chongqing","Chongwen","Chongxian","Choucheng","Chuansha","Chum","Chunhua","Chunjiang","Chuxiong","Chuzhou","Cicheng","Cili","Citai","Cixi","Cuibei","Cuiyuan","Cuizhu","Cuntou","Dabaizhuang","Dabao","Dabu","Dachen","Dachuan","Dagang","Dahai","Dahuaishu","Daidong","Daishan","Daixi","Daizhong","Daji","Dajie","Daju","Dali","Dalian","Dampu","Dancheng","Dandong","Danfeng","Dangshan","Dangyang","Danjiang","Danjiangkou","Danyang","Danzao","Danzhou","Daojiang","Daotou","Daoxu","Daqiao","Daqing","Daqing","Daqiuzhuang","Dasha","Dashiqiao","Dashun","Datang","Datong","Dawa","Dawang","Dawukou","Daxie","Daxing","Daxing","Dayan","Dayang","Daye","Dayun","Dazhong","Dazhou","Dazu","Defeng","Dehui","Dengbu","Dengzhou","Deqing","Deyang","Deyuan","Deyue","Dezhou","Diankou","Dianzhong","Dianzi","Digang","Dingcheng","Dinghai","Dingqiao","Dingtao","Dingxi","Dingzha","Dingzhou","Dipu","Dongchang","Dongcheng","Dongcheng","Dongcun","Dongdu","Dongfang","Dongfeng","Dongguan","Donghai","Donghe","Donghong","Donghuxu","Dongjiaying","Dongli","Donglin","Dongliu","Dongning","Dongshen","Dongsheng","Dongshi","Dongtou","Dongxi","Dongxiao","Dongxin","Dongxing","Dongyang","Dongying","Doujiang","Doumen","Dujiacun","Dungdo","Duoba","Dushu","Duwei","Duyun","Edong","Ejia","Enshi","Erqi","Eshan","Ezhou","Fangqiao","Fangshan","Fangxian Chengguanzhen","Fangzhuang","Fangzi","Fanjing","Fanzhong","Feihong","Feilong","Feixian","Feiyun","Feiyun","Fendou","Fendou","Fengcheng","Fengcheng","Fenggang","Fengjiang","Fenglin","Fengling","Fengming","Fengnan","Fengqi","Fengqiao","Fengqing","Fengshan","Fengshang","Fengshun","Fengtai","Fengting","Fengxian","Fengxiang","Fengzhou","Fenshang","Fenyang","Foshan","Fotang","Fuchun","Fuchunjiang","Fudao","Fuding","Fugu","Fuhao","Fuling","Fumin","Fuqiang","Furong","Fusheng","Fushun","Futian","Fuxin","Fuyang","Fuyang","Fuzhou","Fuzhou","Gaiwei","Gaiyu","Gamlung","Gangcun","Ganjiang","Gannan","Ganyao","Ganzhou","Gaobeidian","Gaobu","Gaocheng","Gaoji","Gaoping","Gaoqiao","Gaotang","Gaoting","Gaoxin","Gaozhao","Gaozhou","Gejiu","Gongchang","Gongjiang","Gongjiao","Gongli","Gongyi","Gongyuan","Goushan","Gouzhuang","Guali","Guancheng","Guangchang","Guangdong","Guangming","Guangtai","Guangtong","Guangxi","Guangyuan","Guangzhou","Guanli","Guanqiao","Guantian","Gucheng","Gucheng","Guigang","Guigang","Guili","Guilin","Guixi","Guiyang","Guiyuan","Guizhoumanzuxiang","Gujiang","Gujiao","Guli","Gunan","Guodian","Guohe","Guoji","Guoshang","Guozhen","Gushan","Gushi","Guxiang","Guyong","Guyuan","Gyari","Haibei","Haicheng","Haidian","Haifu","Haihong","Haijing","Haikou","Hailar","Hailin","Hainan","Haitang","Haixing","Haiyang","Haiyu","Haizhou","Handan","Hangbu","Hangong","Hangu","Hangzhou","Hanjiang","Hanshan","Hanshang","Hanting","Hanzhong","Haocheng","Haozhuang","Harbin","Hebei","Hebei","Hebi","Hecheng","Hechi","Hechi","Hechun","Hecun","Hedong","Hefei","Hegang","Heibei","Heihe","Hejiang","Hejin","Hekou","Heliang","Hengdian","Henghe","Hengjie","Hengshui","Hengyang","Hengzhou","Heping","Heshun","Hetao","Hetian","Hexi","Hexun","Heyi","Heyuan","Heyuan","Heze","Hezhou","Hezhu","Hezuo","Hohhot","Hongchang","Honglin","Hongling","Hongpan","Hongqiao","Hongshan","Hongshun","Hongtang","Hongwei","Hongxi","Hongyan","Hongyangshu","Hongyuan","Hongyun","Houxiangcheng","Houzhai","Huabei","Huacheng","Huadian","Huadong","Huafeng","Huagong","Huagongchang","Huaibei","Huaihe","Huaihua","Huainan","Huairou","Huajiashan","Huajie","Huali","Hualin","Hualong","Huamei","Huanan","Huangbao","Huangdao","Huangdu","Huanggang","Huanghou","Huanghu","Huanghua","Huangjia","Huangjue","Huangshan","Huangshi","Huangshi","Huangxuan","Huangyan","Huangyuan Chengguanzhen","Huangze","Huangzhai","Huangzhou","Huanzhen","Huaqiang","Huaqiao","Huashan","Huatan","Huating","Huawei","Huaxia","Huaxin","Huaxing","Huayang","Huaying","Huayuan","Huayue","Huayuji","Huazhong","Huazhou","Huge","Huicheng","Huigang","Huilongba","Huimin","Huimin","Huixin","Huiyang","Huizhou","Hulan","Huling","Hulu","Huludao","Huoshan","Huozhou","Hupi","Huquan","Hushan","Huzhen","Huzhou","Jiadi","Jiading","Jiafu","Jiahao","Jiahe Chengguanzhen","Jiahu","Jialing","Jiamusi","Jianci","Jiangbei","Jiangchuanlu","Jiangdong","Jiangguantun","Jiangjia","Jiangjin Qu","Jiangkou","Jiangmen","Jiangnan","Jiangnan","Jiangshan","Jiangtian","Jiangwan","Jiangwang","Jiangyan","Jiangyin","Jiangyou","Jianning","Jianxing","Jianyang","Jianyuan","Jianzhong","Jiaojiang","Jiaokou","Jiaotong","Jiaotou","Jiaowei","Jiaoyu","Jiaoyuan","Jiaoyun","Jiaozhou","Jiaozuo","Jiaqin","Jiaxin","Jiaxing","Jiaying","Jiayuan","Jiayue","Jiazhuang","Jicheng","Jiedong","Jiefang","Jiehe","Jielong","Jielong","Jielong","Jieshou","Jiexi","Jiexiu","Jieyang","Jifeng","Jiguang","Jilin City","Jimo","Jin Jiang","Jinan","Jinbi","Jincheng","Jinchuan","Jinci","Jinda","Jinde","Jindi","Jindian","Jinding","Jindou","Jindu","Jingbei","Jingcheng","Jingdezhen","Jingdong","Jingdu","Jingfeng","Jinghai","Jinghe","Jinghong","Jinghu","Jinghua","Jingjiang","Jinglian","Jinglong","Jingmen","Jingning Chengguanzhen","Jingshan","Jingtian","Jinguang","Jingxi","Jingyuan","Jingzhong","Jingzhou","Jinhai","Jinhe","Jinhong","Jinhu","Jinhua","Jining","Jinjiang","Jinli","Jinling","Jinlong","Jinlu","Jinlun","Jinma","Jinmao","Jinmen","Jinming","Jinnan","Jinpan","Jinpu","Jinqiao","Jinqingzhen","Jinsha","Jinshadi","Jinshan","Jinshi","Jintan","Jintian","Jinwo","Jinxiangzhen","Jinxing","Jinyang","Jinyi","Jinyin","Jinying","Jinyuan","Jinyun","Jinzao","Jinzhong","Jinzhou","Jishou","Jishu","Jiuba","Jiuguan","Jiuzong","Jixi","Jiya","Jiyang","Jiyang","Jizhou","Jondag","Juchuan","Juhua","Julong","Jundu","Junlin","Junping","Junpu","Kaifeng","Kaihua","Kaili","Kaiyuan","Kaiyun","Kandun","Kang Xian","Kangcun","Kangda","Karamay","Kashgar","Kecheng","Keqiao","Keshan","Korla","Kouqian","Kouquan","Kuangyan","Kuicheng","Kuiju","Kuishan","Kumul","Kunlun","Kunming","Kunshan","Kunshan","Kunyang","Kuytun","Laibin","Laiwu","Laiyi","Lake","Langfang","Langli","Langzhong","Lanhai","Lanjiang","Lanping","Lantang","Lanxi","Lanzhou","Laohekou","Laonian","Lecheng","Ledong","Lengshuijiang","Leshan","Lhasa","Lianghu","Liangping","Liangzhu","Lianhua","Lianjiang","Liannan","Lianping","Lianshan","Lianshi","Lianshui","Lianyuan","Lianyungang","Liaocheng","Liaoyang","Liaoyang","Liaoyuan","Libang","Licheng","Licheng","Lida","Lidong","Lidu","Lihou","Lijiang","Lijing","Linbei","Lincang","Lincheng","Lincheng","Lindian","Linfen","Lingang","Lingcheng","Lingcheng","Lingdong","Linghu","Lingnga","Lingshi","Lingshui","Lingxi","Lingzhi","Linhai","Linjiang","Linjiang","Linkou","Linnan","Linping","Linqi","Linqing","Linqu","Lintong","Linxia Chengguanzhen","Linyi","Linze","Linzhou","Lishang","Lishu","Lishui","Liu`an","Liucheng","Liudao","Liudong","Liuhe","Liuheng","Liujian","Liujiang","Liulin","Liushi","Liuzhou","Liwu","Liyuan","Lize","Longchuan","Longdong","Longfeng","Longgang","Longgong","Longhu","Longhua","Longhua","Longjian","Longjiang","Longjin","Longlin","Longmao","Longmen","Longnan","Longquan","Longshan","Longtai","Longteng","Longxiang","Longxin","Longxing","Longxun","Longyan","Longzhou","Loufan","Lucheng","Lugouqiao","Luhua","Lujiazhi","Lung","Luobu","Luocheng","Luofang","Luohe","Luohu","Luohu","Luoling","Luomen","Luorong","Luoxi","Luoyang","Luoyang","Luoyang","Luoyuan","Luozhuang","Luqiao","Luqiao","Luquan","Lushang","Luwan","Luzhou","Luzhou","Macao","Maji","Majin","Maoba","Maodian","Maodun","Maoming","Maotai","Mapai","Mawei","Mayao","Mayu","Meicheng","Meijiang","Meilian","Meilin","Meishan","Meixi","Meiyu","Meiyuan","Meizhou","Meizhou","Mengshan","Mengyin","Mengzhou","Mengzi","Mianyang","Miaogao","Mingde","Mingdu","Mingjia","Mingjing","Mingshui","Mingxi","Mingxing","Mingzhou","Mingzhou","Mingzhu","Minhang","Minjiang","Minjie","Minzhu","Minzu","Mishan","Miyun","Moushan","Mudanjiang","Muling","Nagqu","Name","Nanchang","Nanchong","Nanda","Nandu","Nanfang","Nanguo","Nangxian","Nanhai","Nanhan","Nanhe","Nanhu","Nanjiang","Nanjin","Nanjing","Nankai","Nanlong","Nanma","Nanmen","Nanning","Nanning","Nanping","Nanshan","Nantang","Nantong","Nanxi","Nanxianglong","Nanxun","Nanyang","Nanying","Nanyuan","Nanzhao","Nanzhuang","Napo","Naxi Yaozuxiang","Neijiang","Nenjiang","Niaojiang","Ningbo","Ningde","Ninghai","Ninghe","Ningyi","Niulanshan","Niunaichang","Nongkeng","Nyingchi County","Oucheng","Oujiang","Panjin Shi","Panxi","Panzhihua","Pengcheng","Penglai","Pengshan","Pengyu","Pingchuan","Pingdingshan","Pinghu","Pinghu","Pingliang","Pinglu","Pingwang","Pingxiang","Pingyang","Pingyao County","Pingyi","Pingyin","Pingyuan","Pizhou","Potang","Pucheng","Pudong","Puning","Puning","Puqing","Putian","Putian","Putuo","Putuoshan","Puyang","Puyang","Puyuan","Qiandao","Qiandaohu","Qianhai","Qianjiang","Qianjin","Qianling","Qianqing","Qianshan","Qiantan","Qiantang","Qianyu","Qiaodou","Qiaolian","Qiaoting","Qiaoxia","Qiaoyuan","Qiaozhen","Qidu","Qijiashan","Qike","Qingdao","Qingfeng Chengguanzhen","Qinggang","Qinghai","Qinghu","Qingma","Qingnian","Qingquan","Qingshan","Qingshuiwan","Qingtian","Qingtian","Qingtong","Qingxin","Qingyang","Qingyang","Qingyuan","Qingyuan","Qingzhen","Qingzhou","Qinhuangdao","Qinjiang","Qinzhou","Qionghai","Qiongshan","Qiqihar","Qitai","Quanzhou","Quanzhou","Qujiang","Qujing","Qushan","Quzhou","Renhe","Renhou","Renmin","Renqiu","Renrong","Rizhao","Rongjiang","Rongjiang","Rongjin","Rongle","Rongshan","Rongsheng","Rongxian","Rongxing","Ruicheng","Ruifeng","Ruihu","Ruili","Ruiting","Ruixing","Ruiying","Rujia","Sailing","Sandu","Sanguan","Sanhe","Sanjiang","Sanjiangkou","Sanjiaocheng","Sanjiu","Sanlian","Sanmao","Sanmen","Sanmenxia","Sanming","Sanpailou","Santai","Santiaolou","Sanya","Sanyi","Sanyou","Sanyuanpu","Sanzhang","Shamen","Shancheng","Shancheng","Shangbao","Shangbu","Shangbu","Shangdong","Shangfang","Shanghai","Shanghu","Shangjiang","Shangluo","Shangma","Shangnan","Shangqiu","Shangrao","Shangsha","Shangsi","Shangtang","Shangwang","Shangwu","Shangxi","Shangye","Shangying","Shangzhang","Shangzhi","Shangzhou","Shanhe","Shanhu","Shanrui","Shanshui","Shantou","Shantou","Shanwei","Shanzhuang","Shaoguan","Shaoguang","Shaowu","Shaoxing","Shashan","Shashi","Shecheng","Shejiazhuang","Shekou","Shengdu","Shengfang","Shengli","Shengping","Shengshan","Shenjiamen","Shenlong","Shennan","Shensha","Shenwan","Shenyan","Shenyang","Shenzhen","Shenzhou","Shibei","Shifan","Shifang","Shihezi","Shiji","Shijiazhuang","Shijiazhuang","Shijing","Shijingxiang","Shiling","Shilou","Shima","Shinian","Shipu","Shiqi","Shiqiaopu","Shishi","Shishi","Shixia","Shiyan","Shizheng","Shizhong","Shizhu","Shouchang","Shouchun","Shouguang","Shouyang","Shuangcheng","Shuangcheng","Shuanglin","Shuanglong","Shuangqiao","Shuangshipu","Shuangtang","Shuangxi","Shuangyashan","Shuguang","Shuhong","Shuigang","Shuiku","Shuitian","Shuitou","Shuiwu","Shule","Shuliang","Shunde","Shunshui","Shuozhou","Shuyi","Sichuan","Side","Siduxu","Sijiqing","Sili","Simao","Simcun","Simen","Siting","Siyang","Sizhou","Songling","Songyang","Songyuan","Suihua","Suining","Suixi","Suji","Sundun","Sungang","Suqian","Suqian","Suxi","Suzhou","Suzhou","Suzhuang","Taicang","Taihe","Taikang","Tailai","Taili","Taimen","Taiping","Taiping","Taipingyan","Taishan","Taishan","Taixing","Taiyuan","Taizhou","Tancheng","Tancheng","Tang Xian","Tangbian","Tangchang","Tangcheng","Tangdukou","Tangtou","Tangxi","Tangxia","Tangyuan","Tanshi","Taocheng","Taohua","Taoshan","Taoshan","Taoxi","Taoyuan","Taozhuang","Tara","Tashi","Taxi","Tengjiao","Tengzhou","Tianbao","Tianchang","Tianchang","Tiancheng","Tianchi","Tiandong","Tianfu","Tiangang","Tianhai","Tianhong","Tianjin","Tianle","Tianli","Tianma","Tianning","Tianshan","Tianshi","Tianshui","Tiantai Chengguanzhen","Tianyang","Tianyi","Tianyuan","Tianzhen","Tianzhu","Tieli","Tieling","Tieshan","Tingpang","Tongbai","Tongchuan","Tongcun","Tongji","Tongliao","Tongling","Tonglu","Tongmin","Tongren","Tongwang","Tongxiang","Tongyu","Tongyuan","Tumu","Turpan Diqu","Wanbao","Wangfu","Wangluo","Wangshang","Wangsu","Wanjia","Wanning","Wanquan","Wansong","Wanxi","Weibo","Weidun","Weifang","Weihai","Weinan","Weitang","Weitang","Weiyang","Wenchang","Wenhou","Wenlan","Wenlin","Wenling","Wenquan","Wenshan","Wenshang","Wenxi","Wenxing","Wenzhou","Wuhai","Wuhai","Wuhan","Wuhou","Wuhu","Wuling","Wuning","Wushan","Wutai","Wutong","Wuwei","Wuxi","Wuxia","Wuxing","Wuyang","Wuyi","Wuyishan","Wuzhen","Wuzhishan","Wuzhong","Wuzhou","Xiabancheng","Xiadianmiao","Xiakou","Xiamen","Xianchang","Xiandu","Xiangcheng","Xiangfan","Xiangfeng","Xiangjiang","Xiangnan","Xiangru","Xiangshan","Xiangsheng","Xiangsi","Xiangtan","Xiangtong","Xiangxi","Xiangyi","Xiangyuan","Xianjiang","Xianlin","Xianning","Xianqiao","Xianren","Xianrenqiao","Xiantao","Xianyang","Xianyou","Xiaogan","Xiaogang","Xiaoheshan","Xiaojiahe","Xiaojiang","Xiaomi","Xiaoqu","Xiaoshan","Xiaoshun","Xiaosi","Xiaoxi","Xiaozheng","Xiapu","Xiasha","Xiashi","Xiatangyunxiang","Xiayuan","Xiazhi","Xiazhuang","Xibei","Xibu","Xichang","Xichong","Xidian","Xiedian","Xieqiao","Xiezhou","Xigu","Xiguan","Xihu","Xijiao","Xijiao","Xijing","Xikou","Xiling","Ximeng","Xinao","Xincao","Xinchang","Xinchen","Xincheng","Xindi","Xindu","Xingang","Xingchang","Xingchen","Xingcheng","Xingfeng","Xingguang","Xinghua","Xingqiao","Xingtai","Xinguang","Xingwang","Xingxian","Xingxiangcun","Xingxing","Xingye","Xingyi","Xingyuan","Xinhua","Xinhua","Xinhuang","Xinhui","Xining","Xinjian","Xinjiang","Xinmin","Xinning","Xinqiao","Xinrong","Xinsha","Xinshijie","Xintai","Xintangbian","Xintian","Xinxiang","Xinxing","Xinyang","Xinyi","Xinyou","Xinzha","Xinzheng","Xinzhou","Xiping","Xiqu","Xishan","Xitang","Xiushan","Xiushui","Xiuying","Xiuyu","Xixi","Xiyang","Xiyue","Xizhang","Xizhou","Xuancheng","Xuanwu","Xuanzhou","Xuchang","Xucheng","Xucun","Xuefeng","Xuexi","Xuexiao","Xuezhuang","Xuhui","Xunxian","Xunyi Chengguanzhen","Xushan","Xuzhou","Yahao","Yajin","Yalan","Yalongwan","Yanchang","Yancheng","Yancheng","Yandang","Yandao","Yangce","Yangcun","Yangda","Yangfen","Yanggu","Yangjiang","Yangling","Yanglou","Yangmiao","Yangpu","Yangqitan","Yangqu","Yangquan","Yangshan","Yanguan","Yangxunqiao","Yangzhong","Yangzhou","Yangzhou","Yanhai","Yanji","Yanjiang","Yanjiao","Yanjiao","Yanjing","Yanming","Yanshi","Yanta","Yanta","Yantai","Yantan","Yaocheng","Yaofeng","Yaohua","Yaoluoping","Yaozhuang","Yayu","Yibin","Yichang","Yicheng","Yicheng","Yichun","Yidong","Yifeng","Yifu","Yijin","Yijing","Yili","Yinchuan","Yindian","Yinfang","Yingcai","Yingchuan","Yingdu","Yinggen","Yingjia","Yingjie","Yingqian","Yingtai","Yinhai","Yining","Yinjiang","Yinliang","Yinshan","Yintian","Yinxin","Yinzhou","Yiqiao","Yisa","Yishan","Yishui","Yitian","Yiting","Yiwu","Yiwu","Yiyang","Yizheng","Yizhong","Yizhou","Yongchuan","Yongjia","Yongjiawan","Yongjin","Yongjiu","Yongkang","Yongning","Yongqiang","Yongxing","Yongzhou","Youchegang","Youjia","Youjiang","Youshi","Youyi","Yuanchang","Yuanheng","Yuanli","Yuanling","Yuanping","Yuanpu","Yuanqu","Yuantong","Yuanyang","Yucai","Yucheng","Yucheng","Yuchi","Yuecheng","Yuehu","Yuehua","Yuele","Yueliangwan","Yueqing","Yuetai","Yuhai","Yuhan","Yuhang","Yuhong","Yuhuan","Yuhuayuan","Yuhui","Yujing","Yulin","Yulong","Yuncheng","Yunfeng","Yunfu","Yungang","Yungcun","Yunling","Yunnan","Yunting","Yunyang","Yuting","Yutou","Yuxi","Yuxi","Yuxiang","Yuyao","Yuyuan","Yuzhen","Yuzhong Chengguanzhen","Yuzi","Zaoyang","Zaozhuang","Zhancheng","Zhanghe","Zhanghou","Zhangjiagang","Zhangjiagang","Zhangjiajie","Zhangjiakou","Zhangjiang","Zhangqi","Zhangqiu","Zhangshan","Zhangshu","Zhangye","Zhangzhai","Zhangzhou","Zhangzhuang","Zhanjiang","Zhanmao","Zhaobaoshan","Zhaodong","Zhaoqing","Zhaotong","Zhaoyu","Zhaozhou","Zhapu","Zhedong","Zhengda","Zhengdi","Zhengding","Zhenghai","Zhengjiang","Zhengyuan","Zhengzhou","Zhenhua","Zhenjiang","Zhenxi","Zhenxing","Zhenzhou","Zhenzhuquan","Zheshang","Zhicheng","Zhijiang","Zhili","Zhima","Zhixing","Zhiye","Zhiyuan","Zhizhong","Zhongdian","Zhongfang","Zhongfu","Zhonggongmiao","Zhongji","Zhongjian","Zhonglin","Zhongnan","Zhongqiao","Zhongshan","Zhongshan","Zhongtang","Zhongtian","Zhongtu","Zhongwei","Zhongxiang","Zhongxiang","Zhongxin","Zhongxing","Zhongyang","Zhongyicun","Zhongyin","Zhongyuan","Zhongzhou","Zhongzhou","Zhoukou","Zhoushan","Zhoushan","Zhouwangmiao","Zhouxiang","Zhuhai","Zhuji","Zhujiajian","Zhujiajiao","Zhulin","Zhumadian","Zhuozhou","Zhuxi Chengguanzhen","Zhuxiang","Zhuyuan","Zibo","Zicheng","Zigong","Zijin","Ziyang","Ziyu","Zongxoi","Zoucheng","Zunyi","Zuxi"],"Colombia":["Acacias","Acevedo","Aguachica","Antioquia","Arauca","Armenia","Atlantico","Barrancabermeja","Barranquilla","Bello","Bermudez","Boyaca","Bucaramanga","Buenaventura","Buga","Cajica","Calamar","Caldas","Candelaria","Cartagena","Cartago","Cauca","Chia","Chiquinquira","Chocho","Columbia","Corozal","Cota","Cumaribo","Cundinamarca","Dosquebradas","Duitama","El Colegio","Engativa","Envigado","Espinal","Florencia","Floridablanca","Fonseca","Fundacion","Fusagasuga","Galapa","Ginebra","Giron","Guarne","Ibague","Inirida","Ipiales","Itagui","La Ceja","La Estrella","La Mesa","La Union","Los Patios","Madrid","Magdalena","Manizales","Miami","Mitu","Montenegro","Mosquera","Municipio de Copacabana","Neiva","Obando","Palmira","Pamplona","Pasto","Pereira","Piedecuesta","Pitalito","Planadas","Popayan","Puerta Roja","Puerto Tejada","Purificacion","Riohacha","Rionegro","Risaralda","Sabana de Torres","Sabaneta","Sachica","San Clemente","San Diego","San Gil","San Martin","Santa Marta","Santa Rosa de Cabal","Santa Rosa del Sur","Santiago de Cali","Silvania","Sincelejo","Soacha","Sogamoso","Soledad","Sopo","Tarapaca","Tauramena","Tenjo","Tocancipa","Tunja","Turbaco","Ubaque","Urumita","Valledupar","Velez","Villa del Rosario","Villamaria","Villavicencio","Yopal","Yotoco","Yumbo"],"Congo":["Banana","Goma","Kinshasa","Likasi","Lubumbashi"],"Costa Rica":["Alajuela","Alajuelita","Alfaro","Aserri","Atenas","Barva","Cartago","Colon","Corazon de Jesus","Coronado","Coyol","Curridabat","Desamparados","Escazu","Esparza","Filadelfia","Grecia","Guachipelin","Guacima","Guadalupe","Guapiles","Heredia","Isla de Tibas","Jaco","La Garita","Liberia","Llorente","Llorente","Mercedes","Mexico","Miramar","Moravia","Palmares","Paraiso","Pavas","Perez","Poas","Puerto Jimenez","Puntarenas","Quepos","Quesada","Sabanilla","San Diego","San Francisco","San Francisco","San Isidro","San Joaquin","San Jose de la Montana","San Josecito","San Juan","San Marcos","San Pablo","San Pedro","San Rafael","San Rafael","San Ramon","Santa Ana","Santa Cecilia","Santa Cruz","Santo Domingo","Sarchi","Siquirres","Tres Rios","Turrialba","Turrucares","Zapote","Zarcero"],"Croatia":["Antunovac","Baska","Baska Voda","Bedekovcina","Bestovje","Betina","Bibinje","Bizovac","Bjelovar","Bracevci","Brdovec","Bregana","Brela","Brsadin","Buje","Cabuna","Cavtat","Cepin","Cestica","Core","Crikvenica","Dalj","Darda","Delnice","Desinic","Donja Pusca","Donja Zelina","Donji Kraljevec","Dubrovnik","Dugo Selo","Fazana","Fuzine","Galgovo","Glina","Gornja Lomnica","Gornji Kriz","Gornji Stupnik","Hreljin","Icici","Ivanec","Ivanic-Grad","Karlovac","Karojba","Kastel Gomilica","Kastel Luksic","Kastel Sucurac","Koprivnica","Kostrena","Kraljevec na Sutli","Krapina","Kriz","Krk","Krsan","Kutjevo","Labin","Lapad","Lekenik","Lepoglava","Lovran","Lukavec","Lupoglav","Lupoglav","Makarska","Matulji","Medulin","Mlini","Mursko Sredisce","Nedelisce","Nova Gradiska","Novi Marof","Novi Vinodolski","Novo Cice","Nustar","Okrug Gornji","Opatija","Orahovica","Orebic","Orle","Oroslavje","Osijek","Pakrac","Pazin","Petrcane","Petrinja","Piskorevci","Podastrana","Podgajci Posavski","Popovaca","Postira","Pregrada","Prelog","Primosten","Privlaka","Pula","Rab","Rakitje","Rijeka","Rijeka","Rovinj","Samobor","Sapjane","Senkovec","Sesvete","Sesvetski Kraljevec","Sice","Silas","Simuni","Sinj","Sisak","Slatina","Slavonski Brod","Sokolovac","Solin","Split","Splitska","Strmec","Strmec Samoborski","Sveti Ivan Zelina","Tar","Torcec","Trogir","Tuzno","Umag","Varazdinske Toplice","Vardarac","Velika Gorica","Vetovo","Vinica","Vinkovci","Virje","Virovitica","Viskovci","Vojnic","Vrata","Vratisinec","Vrbnik","Vrbovec","Vukovar","Zabok","Zadar","Zagreb","Zapresic","Zlatar"],"Cuba":["Bayamo","Cienfuegos","Habana","Havana","La Habana","Las Tunas","Matanzas","Santiago de Cuba","Varadero","Villa"],"Cyprus":["Agia Anna","Aradippou","Ayia Marina","Chlorakas","Deryneia","Famagusta","Geroskipou","Kato Lakatamia","Kato Polemidia","Kiti","Kyrenia","Larnaca","Laxia","Limassol","Livadia","Morfou","Mouttagiaka","Nicosia","Paphos","Paralimni","Parekklisha","Prodromi","Sotira","Strovolos","Tera"],"Czech Republic":["Adamov","Albrechtice","Arnoltice","As","Babice","Banov","Baska","Batelov","Bavory","Bechyne","Bela pod Bezdezem","Belotin","Benatky nad Jizerou","Benesov","Benesovice","Bernartice","Bernartice nad Odrou","Beroun","Bezdekov","Bilina","Bilina","Bilovice","Bilovice nad Svitavou","Bitovany","Blansko","Blatna","Blizevedly","Blovice","Blucina","Bludov","Bludovice","Bochov","Bohumin","Bohunovice","Bojanov","Bojkovice","Bolatice","Bolebor","Bor","Boretice","Borohradek","Borotin","Borovany","Borsice","Bosin","Boskovice","Bradlec","Brandys nad Labem-Stara Boleslav","Branky","Branov","Bratrikov","Brezi","Brezno","Brezolupy","Brezova","Brno","Brod","Brodce","Brodek","Broumov","Brtnice","Bruntal","Brusperk","Bucovice","Budyne nad Ohri","Bukovec","Bustehrad","Bylnice","Bystrice","Bystrice","Bystrice","Bystrice nad Pernstejnem","Bystrice pod Hostynem","Cakovice","Caslav","Cebin","Cechtice","Cejc","Cejkovice","Celadna","Celakovice","Cepi","Cercany","Cerekvice nad Loucnou","Cerhenice","Cerna Hora","Cerna za Bory","Cerncice","Cernosice","Cernotin","Cervene Pecky","Cerveny Kostelec","Ceska","Ceska Skalice","Ceska Trebova","Ceska Ves","Ceske Mezirici","Cesky Brod","Cesky Dub","Cestice","Cheb","Cheznovice","Chlumcany","Chlumec","Chlumec nad Cidlinou","Chlupice","Chocen","Chocerady","Chodov","Chodov","Chodova Plana","Chomutov","Chotebor","Chotesov","Chotetov","Chotoviny","Choustnik","Choustnikovo Hradiste","Chrast","Chrast","Chrastna","Chribska","Chroustovice","Chrudim","Chvalec","Chyne","Cista","Citoliby","Citov","Citov","Ckyne","Ctidruzice","Cvikov","Dalovice","Damnice","Darkovicky","Davle","Deblin","Dehylov","Dejvice","Desna","Detmarovice","Dily","Divisov","Dlouha Trebova","Dlouhe","Dobra","Dobra Voda","Dobrany","Dobre","Dobrichovice","Dobris","Dobriv","Dobronin","Dobroslavice","Dobruska","Doksy","Dolany","Dolni Becva","Dolni Benesov","Dolni Berkovice","Dolni Bojanovice","Dolni Brezany","Dolni Dunajovice","Dolni Jircany","Dolni Kounice","Dolni Nemci","Dolni Poustevna","Dolni Radechova","Dolni Sucha","Dolni Sytova","Dolni Terlicko","Dolni Zandov","Domasov","Domazelice","Domazlice","Doubravnik","Doubravy","Doudleby nad Orlici","Drahotuse","Drisy","Drnovice","Drzkov","Drzovice","Dubec","Dubenec","Dubi","Dubicko","Dubnany","Dubne","Duchcov","Dukovany","Dusejov","Dvorce","Dvur Kralove nad Labem","Dymokury","Ejpovice","Filipova","Francova Lhota","Frantiskovy Lazne","Frenstat pod Radhostem","Frydek-Mistek","Frydlant","Frydlant nad Ostravici","Frystak","Fulnek","Golcuv Jenikov","Grucovice","Habartov","Haj ve Slezsku","Haje","Hajnice","Halenkov","Hamr","Harrachov","Havrice","Hermanuv Mestec","Hlasna Treban","Hlinsko","Hlubocepy","Hlubocky","Hluboka nad Vltavou","Hlucin","Hodice","Hodslavice","Holasice","Holesov","Holice","Holoubkov","Holubice","Holysov","Horesedly","Horice","Horin","Horni Becva","Horni Benesov","Horni Bojanovice","Horni Briza","Horni Lutyne","Horni Nemci","Horni Pocernice","Horni Podluzi","Horni Redice","Horni Slavkov","Horomerice","Horousanky","Horovice","Horsovsky Tyn","Hospozin","Hosteradice","Hostice","Hostin","Hostinne","Hostivice","Hostomice","Hostomice","Hovezi","Hovorany","Hovorcovice","Hrabetice","Hradcovice","Hradec","Hradec nad Moravici","Hradek","Hradek nad Nisou","Hradiste","Hradiste","Hranice","Hranice","Hrdejovice","Hronov","Hrusovany nad Jevisovkou","Hrusovany u Brna","Hudlice","Hukvaldy","Hulin","Humpolec","Hustopece","Hvozd","Hysly","Ivancice","Ivanovice na Hane","Jablonec nad Nisou","Jablonne nad Orlici","Jablonne v Podjestedi","Jablunka","Jablunkov","Jalubi","Janovice","Janovice nad Uhlavou","Jaromer","Jaroslav","Jaroslavice","Jedovnice","Jenec","Jesenice","Jesenik","Jevicko","Jevisovice","Jezov","Jihlava","Jilemnice","Jilove u Prahy","Jilovec","Jiloviste","Jince","Jindrichuv Hradec","Jinocany","Jirice","Jirickov","Jirkov","Jirny","Jistebnik","Kacerov","Kacice","Kadan","Kamenice","Kamenice","Kamenicky Senov","Kamenne Zehrovice","Kamenny Privoz","Kamyk","Kaplice","Karlin","Karlovy Vary","Karvina","Kaznejov","Kbely","Kdyne","Kladno","Klasterec nad Ohri","Klatovy","Klecany","Klicany","Klimkovice","Klobouky","Knezmost","Kochovice","Koci","Kolodeje","Komarice","Komorni Lhotka","Konice","Kopidlno","Koprivnice","Korycany","Kosmonosy","Kostelec na Hane","Kostelec nad Cernymi Lesy","Kostelec nad Labem","Kostelec nad Orlici","Kostelni Hlavno","Kostice","Kotencice","Kourim","Kouty","Kozmice","Kralice na Hane","Kraliky","Kralovice","Kralupy nad Vltavou","Kraluv Dvur","Kraslice","Krasna Hora nad Vltavou","Krasna Lipa","Kratonohy","Kravare","Krchleby","Krenovice","Krepenice","Kresice","Kretin","Krhova","Krivoklat","Krizanov","Krmelin","Krnov","Krnsko","Krouna","Krtiny","Krumvir","Krupka","Ktis","Kuncice","Kuncina","Kunovice","Kunratice","Kunstat","Kurim","Kvetnice","Kyjov","Kyjov","Kylesovice","Lachov","Ladvi","Lampertice","Lanskroun","Lanzhot","Lasenice","Lazne Bohdanec","Lazne Libverda","Ledec nad Sazavou","Lednice","Leskovec","Lesonice","Letohrad","Letovice","Lety","Lhota","Lhota","Lhota","Lhota pod Libcany","Lhotka","Liban","Libcany","Liberec","Libesice","Libeznice","Libice nad Cidlinou","Libis","Libocany","Libochovicky","Libos","Lichkov","Lichnov (o. Novy Jicin)","Line","Lipence","Lipnik nad Becvou","Lipova","Lisov","Litava","Liten","Litovel","Litvinov","Lodenice","Loket","Lomnice","Lomnice nad Luznici","Lomnice nad Popelkou","Loucany","Loucen","Loukov","Lounovice pod Blanikem","Louny","Lovosice","Lubenec","Luby","Luhacovice","Luka","Lukov","Lustenice","Lutin","Luze","Luzna","Lysa nad Labem","Lysice","Mala Skala","Malcice","Malenice","Malenovice","Malesov","Maly Ujezd","Marianska","Markvartovice","Marov u Upice","Mcely","Mechenice","Menany","Merklin","Merklin","Mesice","Mestec","Mesto Touskov","Mezibori","Mezilesi","Michle","Mikulov","Mikulovice","Milevsko","Milikov","Milin","Milonice","Milotice","Milovice","Mimon","Miroslav","Mirosov","Mirosovice","Mlada Vozice","Mlade Buky","Mladkov","Mlazovice","Mnichovice","Mnisek pod Brdy","Modrice","Mohelnice","Mokra Horakov","Mokrany","Moran","Moravicany","Moravska Nova Ves","Moravska Trebova","Moravske Budejovice","Moravsky Beroun","Moravsky Krumlov","Moravsky Pisek","Moravsky Zizkov","Most","Mostek","Mosty u Jablunkova","Mratin","Mrlinek","Msec","Mseno","Mukarov","Mutenice","Nachod","Naklo","Napajedla","Nasavrky","Navsi u Jablunkova","Nechanice","Nedakonice","Nedomice","Nedvedice","Nehvizdy","Nejdek","Nelahozeves","Nenkovice","Nepomysl","Neratovice","Nesovice","Nezamyslice","Nezvestice","Nikolcice","Nivnice","Nova Cerekev","Nova Lhota","Nova Paka","Nova Vcelnice","Nova Ves","Nove Dvory","Nove Mesto na Morave","Nove Mesto nad Metuji","Nove Straseci","Nove Veseli","Novosedly","Novy Bor","Novy Bydzov","Novy Hrozenkov","Novy Jicin","Novy Knin","Novy Oldrichov","Nucice","Nupaky","Nydek","Nymburk","Nyrany","Nyrsko","Obrany","Obristvi","Ochoz","Odolena Voda","Odry","Ohrobec","Okrisky","Olomouc","Olomucany","Olovi","Olsany","Ondrejov","Oparany","Opatovice nad Labem","Opava","Opocno","Orlova","Osecna","Osek","Osik","Oslavany","Ostopovice","Ostrava","Ostromer","Ostrov","Ostrov u Macochy","Ostrozska Lhota","Ostrozska Nova Ves","Otnice","Otrokovice","Pacov","Palkovice","Pardubice","Pariz","Pavlice","Pchery","Pecin","Pecky","Pelhrimov","Perstejn","Petrovice","Petrovice u Karvine","Petrvald","Pilsen","Pisecna","Pisecna","Pistovice","Plana","Planany","Plouznice","Pocatky","Pocenice","Podborany","Podebrady","Podivin","Polepy","Polesovice","Police nad Metuji","Policka","Polna","Poricany","Poritsch","Postoloprty","Postrelmov","Potstejn","Prachatice","Prackovice nad Labem","Prague","Prazmo","Preckov","Predklasteri","Predmerice nad Jizerou","Predmerice nad Labem","Predmesti","Prelouc","Prepere","Prerov nad Labem","Prestice","Prezletice","Pribor","Pribyslav","Prikazy","Primda","Prlov","Prosetin","Protivin","Provodov","Pruhonice","Prusanky","Psary","Pustejov","Pysely","Radim","Radnice","Radostice","Radostin","Radun","Raj","Rajec-Jestrebi","Rajecko","Rakovnik","Rapotice","Rapotin","Raspenava","Rataje","Ratibor","Ratiskovice","Rebesovice","Repy","Ricany","Ricany","Rikovice","Ritka","Rokycany","Rokytnice","Rokytnice nad Jizerou","Ronov nad Doubravou","Rosice","Rosice","Roudnice nad Labem","Roudnicek","Rousinov","Rovensko pod Troskami","Rovina","Rovna","Rozdrojovice","Rozmital pod Tremsinem","Roznov pod Radhostem","Rozsochatec","Roztoky","Rtyne","Ruda nad Moravou","Rudikov","Rudna","Rudolfov","Rudoltice","Rybna","Rychnov","Rychnov nad Kneznou","Rychvald","Rymarov","Sadska","Sanov","Sany","Satov","Seberov","Sebrov","Sedlcany","Sedlec","Sedliste","Seibersdorf","Semily","Senec","Senice na Hane","Senohraby","Senov","Sestajovice","Sezemice","Sibrina","Silherovice","Siluvky","Sivice","Skalice","Skalsko","Skripov","Skuhrov nad Belou","Skutec","Slany","Slapanice","Slapy","Slavicin","Slavkov u Brna","Slavonice","Sloup","Sluknov","Slusovice","Smirice","Smrzovka","Snedovice","Snezne","Sobeslav","Sobotka","Sokolov","Spalene Porici","Spytihnev","Stalkov","Stankov","Stara Paka","Stara Voda","Stare Mesto","Stare Mesto","Stare Sedliste","Starec","Starovice","Starovicky","Stary Bydzov","Statenice","Stenovice","Stepanov","Sterboholy","Sternberk","Steti","Stezery","Stitina","Stity","Stochov","Stod","Stoky","Strachotice","Strachotin","Strakonice","Strancice","Strasice","Straz nad Nisou","Straz pod Ralskem","Strazek","Straznice","Strelice","Stribrec","Stribrna Skalice","Stribro","Stritez nad Ludinou","Strunkovice nad Blanici","Studenka","Sucha Loz","Sudkov","Sumice","Sumperk","Susice","Svatava","Svaty Jan nad Malsi","Svetla nad Sazavou","Sviadnov","Svihov","Svitavka","Svitavy","Svojek","Svojkov","Syrovice","Tachlovice","Tachov","Tehov","Telc","Telnice","Temice","Teplice","Tesetice","Tetin","Tisice","Tisnov","Tlumacov","Tman","Tosovice","Trebechovice pod Orebem","Trebestovice","Trebon","Tremesna","Tremosna","Trhovy Stepanov","Trinec","Trmice","Troja","Trstenice","Trutnov","Tucapy","Tuchlovice","Tuchomerice","Tupesy","Turnov","Tursko","Tvarozna","Tvrdonice","Tynec nad Sazavou","Tyniste nad Orlici","Uhersky Brod","Uhersky Ostroh","Uhonice","Uhrice","Ujezd","Ujezd","Ujezd nad Lesy","Unetice","Unicov","Usti nad Orlici","Ustin","Uvaly","Uzice","Vacenovice","Valasske Klobouky","Valasske Mezirici","Valtice","Vamberk","Varnsdorf","Vcelna","Velehrad","Velesin","Velesovice","Velka Bites","Velka Bystrice","Velka Dobra","Velka Jesenice","Velka Polom","Velke Albrechtice","Velke Brezno","Velke Heraltice","Velke Hydcice","Velke Losiny","Velke Mezirici","Velke Opatovice","Velke Popovice","Velke Prilepy","Velke Svatonovice","Velky","Velky Borek","Velky Osek","Veltrusy","Velvary","Vendryne","Vernovice","Veseli nad Luznici","Veseli nad Moravou","Veverska Bityska","Veverske Kninice","Vidce","Vimperk","Vinarice","Vinicne Sumice","Visnove","Vitkov","Vizovice","Vlachovice","Vladislav","Vlasim","Vlastislav","Vlcovice","Vochov","Vodnany","Vojkovice","Volyne","Votice","Vracov","Vrane nad Vltavou","Vratimov","Vratkov","Vrbice","Vrbno pod Pradedem","Vrchlabi","Vresina","Vsechovice","Vsechovice","Vselibice","Vsenory","Vsestary","Vsetaty","Vsetin","Vtelno","Vyprachtice","Vysker","Vysoka","Vysoka nad Labem","Vysoke Myto","Vysoke Veseli","Zabcice","Zabreh","Zadni Treban","Zajeci","Zamberk","Zampach","Zandov","Zasova","Zatcany","Zborovice","Zbuch","Zbysov","Zdanice","Zdeslav","Zdiby","Zdice","Zdirec","Zdounky","Zehun","Zelenec","Zelenka","Zelesice","Zeletava","Zeleznice","Zelezny Brod","Zeliv","Zeravice","Zidlochovice","Zilina","Zipotin","Zizkov","Zlata","Zlate Hory","Zlicin","Zliv","Znojmo","Zubri","Zulova","Zvole"],"Denmark":["Aabenraa","Aabybro","Aalborg","Aarhus","Aars","Abyhoj","Agedrup","Agerbaek","Agerskov","Akirkeby","Albaek","Albertslund","Ale","Alestrup","Aller","Allerod","Allingabro","Allinge","Almind","Alsgarde","Alslev","Alslev","Anholt","Ans","Ansager","Arden","Arre","Arslev","Arslev","Arup","Asa","Askeby","Asnaes","Asperup","Assens","Astrup","Augustenborg","Auning","Avlum","Baekke","Baekmarksbro","Baelum","Bagsvaerd","Balle","Ballerup","Bandholm","Baring","Barrit","Beder","Bedsted","Bevtoft","Billund","Bjaert","Bjaeverskov","Bjerringbro","Blavand","Blokhus","Blommenslyst","Boeslunde","Bogense","Bogo By","Bolderslev","Bording Stationsby","Borkop","Borre","Borum","Borup","Bovlingbjerg","Bovrup","Brabrand","Braedstrup","Bramming","Brande","Branderup","Bredballe","Bredebro","Bredsten","Brejning","Brenderup","Broager","Brobyvaerk","Brondby Strand","Bronshoj","Brorup","Brovst","Bruunshab","Bryrup","Bylderup-Bov","Charlottenlund","Christiansfeld","Copenhagen","Dalmose","Dannemare","Daugard","Dianalund","Dong","Dronninglund","Dronningmolle","Dybvad","Ebberup","Ebeltoft","Ega","Egernsund","Egtved","Ejby","Ejby","Ejstrup","Elsinore","Engesvang","Errindlev","Erslev","Esbjerg","Eskebjerg","Eskilstrup","Espergaerde","Faaborg","Fakse","Farevejle","Farum","Farup","Farvang","Fensmark","Ferritslev","Ferslev","Fjenneslev","Fjerritslev","Flauenskjold","Flemming","Follenslev","Fovling","Fredensborg","Fredericia","Frederiksberg","Frederiksberg","Frederiksdal","Frederikshavn","Frederikssund","Frorup","Frostrup","Fuglebjerg","Gadbjerg","Gadstrup","Galten","Gammel Svebolle","Gandrup","Ganlose","Gedved","Gelsted","Gentofte","Gesten","Gilleleje","Gislev","Gislinge","Gistrup","Give","Gjerlev","Gjern","Gjol","Gladsaxe","Glamsbjerg","Glejbjerg","Glesborg","Glostrup","Glumso","Glyngore","Gording","Gorlose","Graested","Gram","Gredstedbro","Greve","Greve Strand","Grevinge","Grindsted","Gudbjerg","Gudhjem","Gudme","Guldborg","Haderslev","Haderup","Hadsten","Hadsund","Hals","Hammel","Hammershoj","Hampen","Hanstholm","Harboore","Harby","Harlev","Harlev","Harndrup","Harpelunde","Hasle","Haslev","Hasselager","Havdrup","Havndal","Hedehusene","Hedensted","Hejls","Hejnsvig","Hellebaek","Hellerup","Helsinge","Hemmet","Henne","Henne Strand","Herfolge","Herlev","Herlufmagle","Herning","Hesselager","Himmelev","Hinnerup","Hirtshals","Hjallerup","Hjerm","Hjortshoj","Hobro","Hodsager","Hojbjerg","Hojby","Hoje Tastrup","Hojslev","Holbaek","Holeby","Holme","Holme-Olstrup","Holstebro","Holsted","Holte","Hoptrup","Horbelev","Hornbaek","Horning","Hornslet","Hornsyld","Horsens","Horslunde","Horve","Hosterkob","Hou","Hovedgard","Humble","Humlebaek","Hundested","Hundslund","Hurup","Hvide Sande","Hvidovre","Hyllinge","Idestrup","Ikast","Janderup","Jelling","Jerslev","Jerslev","Jerup","Jordrup","Jorlunde","Juelsminde","Jyderup","Jyllinge","Jystrup","Kaldred","Kalundborg","Kalvehave","Karise","Karlslunde","Karlstrup","Karrebaeksminde","Karup","Kastrup","Kastrup","Kejlstrup","Kerteminde","Kettinge","Kibaek","Kirke Eskilstrup","Kirke Hvalso","Kirke Saby","Kirke-Hyllinge","Kjargaard","Kjellerup","Klampenborg","Klarup","Klemensker","Klippinge","Klokkerholm","Klovborg","Knebel","Kokkedal","Koldby","Kolding","Kolind","Kolsen","Kongens Lyngby","Kongerslev","Krusa","Kvaerndrup","Kvistgard","Kvols","Laeso","Lambjerg","Langa","Langeskov","Lasby","Laurbjerg","Ledoje","Lejre","Lem","Lemming","Lemvig","Lille Skensved","Liseleje","Logstrup","Lokken","Losning","Lundby Stationsby","Lunderskov","Lyngby","Lynge","Lystrup","Malling","Malov","Mariager","Maribo","Marslet","Marslev","Marstal","Martofte","Melby","Mern","Middelfart","Millinge","Moldrup","Morke","Morkov","Morud","Munke Bjergby","Munkebo","Naerum","Naesby","Naestved","Nakskov","Nexo","Nibe","Nim","Nimtofte","Niva","No","Nodebo","Norager","Nordborg","Nordby","Nordenskov","Norre Aby","Norre Asmindrup","Norre Bindslev","Norre Nebel","Norre Snede","Norreballe","Norresundby","Nyborg","Nygard","Nykobing Falster","Nykobing Mors","Nykobing Sjaelland","Nysted","Odder","Oddesund Syd","Odense","Odsted","Oksbol","Olsted","Olstykke","Omme","Orbaek","Ornhoj","Orsted","Orum","Osby","Ostbirk","Oster Assels","Ostermarie","Ostervra","Otterup","Oure","Padborg","Pandrup","Ramlose","Randbol","Randers","Ranum","Rebaek","Refsvindinge","Regstrup","Ribe","Ringe","Ringsted","Risskov","Rodding","Rodkaersbro","Rodvig","Ronde","Roskilde","Roslev","Rude","Ruds-Vedby","Rungsted","Ry","Rynkeby","Ryomgard","Ryslinge","Sabro","Saeby","Salten","Saltum","Sandager","Sanderum","Sandved","Sherrebek","Silkeborg","Sindal","Sjolund","Skaelskor","Skaering","Skagen","Skals","Skamby","Skanderborg","Skarup","Skibby","Skive","Skjern","Skodsborg","Skodstrup","Skovlunde","Slagelse","Slangerup","Slet","Snedsted","Snekkersten","Snertinge","Soborg","Soby","Soesmarke","Solbjerg","Sollested","Solrod","Sommersted","Sonder Omme","Sonder Stenderup","Sonderso","Soro","Sorring","Sorvad","Spentrup","Spjald","Spottrup","Stakroge","Stege","Stenderup","Stenlille","Stenlose","Stenstrup","Stensved","Stoholm","Stokkemarke","Store Fuglede","Store Heddinge","Store Merlose","Storvorde","Stouby","Stovring","Strandby","Strib","Stroby","Struer","Suldrup","Sulsted","Sundby","Sunds","Svaneke","Svanninge","Svendborg","Svenstrup","Svinninge","Taastrup","Tagerup","Tappernoje","Tarbaek","Tarm","Tars","Tejn","Terndrup","Them","Thisted","Thorso","Tikob","Tilst","Tim","Tinglev","Tistrup","Tisvildeleje","Tjaereborg","Tjebberup","Toftlund","Tollose","Tommerup","Toreby","Tornby","Torrig","Torring","Torring","Tranbjerg","Tranebjerg","Tranekaer","Trelde","Trige","TRUE","Trustrup","Tullebolle","Tune","Tureby","Tylstrup","Ugerlose","Uldum","Ulfborg","Ullerslev","Ulstrup","Vadum","Vaeggerlose","Vaerlose","Vamdrup","Vandel","Vantinge","Varde","Vasby","Vebbestrup","Vedbaek","Vederso","Veflinge","Vejby","Vejen","Vejle","Vejstrup","Vekso","Vemb","Vemmelev","Verninge","Vestbjerg","Vester Hassing","Vester-Skerninge","Vesterborg","Vestervig","Viborg","Viby","Viby","Vig","Vildbjerg","Vils","Vinderup","Vinkel","Vipperod","Virring","Virum","Vissenbjerg","Viuf","Vivild","Vodskov","Vojens","Vorbasse","Vordingborg","Vra"],"Dominican Republic":["Arenazo","Bavaro","Boca Chica","Cabarete","Cotui","Dominica","Guaricano","Hato Mayor del Rey","Jimani","La Romana","Los Alcarrizos","Los Prados","Moca","Pedernales","Puerto Plata","Punta Cana","Sabaneta","San Cristobal","San Fernando de Monte Cristi","San Jose de Ocoa","Santa Cruz de Barahona","Santiago de los Caballeros","Santo Domingo"],"Ecuador":["Ambato","Atacames","Atuntaqui","Bahia de Caraquez","Banos","Calderon","Cayambe","Cuenca","Daule","El Carmen","El Naranjal","Esmeraldas","Florida","General Leonidas Plaza Gutierrez","Guabo","Gualaceo","Guamote","Guayaquil","Guayas","Guayllabamba","Hacienda Bolivia","Hacienda Duran","Hacienda Ibarra","Hacienda Santa Catalina","Huaquillas","Ibarra","Jipijapa","La Esperanza","La Libertad","La Troncal","Latacunga","Loja","Loreto","Macara","Macas","Machachi","Machala","Manta","Milagro","Montecristi","Nabon","Olmedo","Otavalo","Paccha","Pasaje","Pelileo","Pichincha","Playas","Portoviejo","Puerto Francisco de Orellana","Puyo","Quevedo","Quito","Riobamba","Salinas","Samborondon","San Miguel","San Rafael","Santa Cruz","Santa Elena","Santo Domingo de los Colorados","Sucre","Tababela","Tarapoa","Tena","Vinces","Zamora","Zaruma","Zumba"],"Egypt":["Abu Hammad","Al Mahallah al Kubra","Al Mansurah","Al Marj","Alexandria","Almazah","Ar Rawdah","Assiut","Az Zamalik","Badr","Banha","Bani Suwayf","Cairo","Damietta","Faraskur","Flaminj","Giza","Heliopolis","Helwan","Hurghada","Ismailia","Kafr ash Shaykh","Luxor","Madinat an Nasr","Madinat as Sadis min Uktubar","Minya","Nasr","New Cairo","Port Said","Rafah","Ramsis","Sadat","Shirbin","Shubra","Sohag","Suez","Tanta","Toukh","Zagazig"],"El Salvador":["Ahuachapan","Antiguo Cuscatlan","Apaneca","Apopa","Ayutuxtepeque","Botoncillal El Botoncillo","Coatepeque","Colon","Colonia Escalon","Cuscatancingo","Delgado","Gigante","Guazapa","Ilopango","La Libertad","Lourdes","Mejicanos","Nuevo Cuscatlan","Ozatlan","San Jose Villanueva","San Marcos","San Miguel","San Salvador","Santa Ana","Santa Tecla","Santiago Texacuangos","Sonsonate","Soyapango","Usulutan","Zaragoza"],"Estonia":["Aasmae","Aaviku","Aespa","Ahtma","Alliku","Ambla","Antsla","Ardu","Avinurme","Elva","Emmaste","Haabneeme","Haage","Haapsalu","Halinga","Harju","Harku","Kaarma","Kadrina","Kehra","Keila","Kiili","Kohila","Kohtla","Kose","Kulna","Kuressaare","Kuusalu","Laagri","Lagedi","Lahtse","Lepna","Loksa","Loo","Lubja","Maardu","Muraste","Narva","Otepaeae","Paide","Paikuse","Paldiski","Palivere","Peetri","Puhja","Rakke","Rakvere","Rapla","Saku","Saue","Sindi","Somerpalu","Syare","Tabasalu","Tabivere","Tallinn","Tamsalu","Tapa","Tartu","Toila","Vaida","Valga","Vara","Venevere","Viimsi","Viljandi","Voka"],"Faroe Islands":["Argir","Glyvrar","Hvalba","Innan Glyvur","Leirvik","Saltangara","Signabour","Strendur"],"Finland":["Aapajoki","Aavasaksa","Aitoo","Akaa","Alastaro","Alaveteli","Alavieska","Alavus","Alvettula","Angelniemi","Anjala","Anttila","Askola","Aura","Bergoe","Box","Broby","Degerby","Eno","Erajarvi","Espoo","Eura","Eurajoki","Evijaervi","Evitskog","Fiskars","Forsby","Forssa","Gammelby","Haapavesi","Haeme","Haermae","Haijaa","Halikko","Halkia","Halli","Halsua","Hamina","Hammaslahti","Hanko","Harjavalta","Harviala","Hattula","Hauho","Haukipudas","Haukkala","Hausjaervi","Heimari","Heinola","Helsingby","Helsinki","Hervanta","Hiltulanlahti","Himanka","Hinthaara","Hirvensalmi","Hirvihaara","Hoegsara","Hoeytiae","Hollola","Hollola","Huittinen","Humppila","Huuvari","Hyvinkaeae","Ihode","Ii","Iisalmi","Iittala","Ilkka","Ilmajoki","Ilmarinen","Ilveskylae","Imatra","Inkeroinen","Isojoki","Itaekylae","Ivalo","Jaervelae","Jakobstad","Janakkala","Joensuu","Jokela","Jokikunta","Jokimaa","Jokioinen","Jormua","Joroinen","Jorvas","Joutseno","Jurva","Juuka","Juupajoki","Jyskae","Kaakamo","Kaarina","Kaemmenniemi","Kaerrby","Kaipiainen","Kaipola","Kaivanto","Kajaani","Kalajoki","Kalanti","Kangasala","Kangasniemi","Kankaanpaeae","Kannonkoski","Kannus","Kantomaanpaeae","Kantti","Kantvik","Karhula","Karinkanta","Karjaa","Karjalohja","Karkkila","Karkku","Karstula","Karttula","Karunki","Karvia","Kaskinen","Kauhajoki","Kauhakorpi","Kauhava","Kauniainen","Kausala","Kaustinen","Kauttua","Kauvatsa","Kello","Kellokoski","Kemi","Keminmaa","Kempele","Kerava","Kerkkoo","Keuruu","Kihnioe","Kiiminki","Kiistala","Kiljava","Kimito","Kinnula","Kirjala","Kirkkonummi","Kisko","Kitee","Kiuruvesi","Kivijaervi","Klaukkala","Kokkola","Kokkola","Kolari","Kolinkylae","Koljonvirta","Kontiolahti","Kontiomaeki","Kopsa","Koria","Kormu","Korplax","Korppoo","Korsholm","Koskenkorva","Koskioinen","Kotka","Kouvola","Kronoby","Kruusila","Kuhmalahti","Kuhmo","Kuivakangas","Kuivaniemi","Kulho","Kuni","Kuohu","Kuopio","Kuortane","Kurikka","Kuusamo","Kuusankoski","Kuusisto","Kvevlax","Kylmaekoski","Kyroeskoski","Kyynaeroe","Laeyliaeinen","Lahela","Lahti","Laihia","Laikko","Laitikkala","Laitila","Lammi","Lampinsaari","Lapinlahti","Lappajaervi","Lappeenranta","Lapua","Larsmo","Latovainio","Laukaa","Laukkoski","Launonen","Lautiosaari","Lehmo","Lehtimaeki","Lemi","Lepaa","Lepplax","Levanto","Lieksa","Lielax","Lieto","Lievestuore","Liljendal","Liminka","Linna","Linnavuori","Liperi","Littoinen","Lohja","Lohtaja","Loimaa","Loppi","Louhi","Loviisa","Lumijoki","Luohua","Luoma-aho","Maenttae","Maentyharju","Majvik","Mankila","Mantila","Martensby","Marttila","Masala","Masku","Mattila","Mehtaekylae","Merimasku","Metsaekansa","Mieto","Mikkeli","Mouhijaervi","Muhos","Multia","Munsala","Muonio","Muurame","Muurla","Myllykoski","Mynaemaeki","Naantali","Naervijoki","Nahkela","Nakkila","Narva","Nastola","Neuvoton","Niinijoki","Niittylahti","Nivala","Nokia","Noormarkku","Nousiainen","Nukari","Nummela","Nummenkylae","Nummenkylae","Nummi","Nunnanlahti","Nuppulinna","Nurmes","Nurmo","Nuutajaervi","Nykarleby","OEvermalax","Oitti","Oja","Okskoski","Orimattila","Orivesi","Otalampi","Oulainen","Oulu","Oulunsalo","Outokumpu","Paalijaervi","Paattinen","Padasjoki","Paelkaene","Paimio","Paippinen","Palojoki","Palokka","Pankakoski","Pargas","Parkano","Parkkuu","Pattijoki","Peipohja","Pellinki","Pello","Peraelae","Peraseinajoki","Pernioe","Pertteli","Perttula","Pihtipudas","Piispanristi","Pilkanmaa","Pirkkala","Pjelax","Pockar","Poeytyae","Pohjola","Poikelus","Poitsila","Pori","Porlammi","Pornainen","Porvoo","Pukkila","Punkaharju","Punkalaidun","Puolanka","Purmo","Purola","Pusula","Puumala","Pyhaejoki","Pyhaentae","Pyhamaa","Raahe","Raisio","Rantasalmi","Raseborg","Rauma","Rautalampi","Rautjaervi","Rautjaervi","Ravijoki","Revonlahti","Riihikoski","Riistavesi","Ristiina","Roeykkae","Roismala","Rovaniemi","Ruokolahti","Ruovesi","Rusko","Ruto","Ruutana","Ryttylae","Saaksmaki","Saarijaervi","Saekylae","Saeviae","Sahalahti","Sajaniemi","Salo","Saloinen","Salomaa","Sammaljoki","Sappee","Saukkola","Saunalahti","Sauvo","Savitaipale","Savonlinna","Saynatsalo","Seinaejoki","Sievi","Siikainen","Siivikkala","Simoniemi","Simpele","Sipoo","Siuntio","Siuro","Skinnarby","Skuru","Soederkulla","Soeoermarkku","Solberg","Somerniemi","Somero","Sotkamo","Sotkuma","Suhmura","Sundby","Sundom","Suolahti","Suomusjaervi","Suomussalmi","Suonenjoki","Svarta","Sykaeraeinen","Taavetti","Taipalsaari","Tammela","Tampella","Tampere","Tarttila","Tarvasjoki","Tenala","Terjaerv","Tervajoki","Tervakoski","Tervalampi","Teuva","Tikkakoski","Toelby","Toholampi","Toijala","Toivala","Tolkis","Tornio","Tortinmaeki","Tottijarvi","Tuomikylae","Turenki","Turku","Tuulos","Tuuri","Tuusula","Tyrnaevae","Uimaharju","Ulvila","Utsjoki","Utti","Uurainen","Uusikaupunki","Vaajakoski","Vaasa","Vaeaeksy","Vaesterskog","Vahto","Vakkola","Valkama","Valkeakoski","Valkeala","Valkola","Vammala","Vanhalinna","Vantaa","Varkaus","Vasarainen","Vaskio","Vaulammi","Vehniae","Veikkola","Venetheitto","Vesanka","Veteli","Viantie","Vihtavuori","Vihti","Viiala","Viitasaari","Viljakkala","Vilppula","Vimpeli","Virrat","Vuokatti","Ylaemylly","Ylihaermae","Ylitornio","Ylivieska","Ypaejae"],"France":["Aast","Abancourt","Abbans-Dessus","Abbaretz","Abbecourt","Abbeville","Abbeville-les-Conflans","Abeilhan","Abere","Abergement-Saint-Jean","Abilly","Ablain-Saint-Nazaire","Ablaincourt-Pressoir","Ablainzevelle","Ablis","Ablon-sur-Seine","Abondance","Abondant","Abreschviller","Abrest","Abscon","Abzac","Abzac","Achatel","Achenheim","Acheres","Acheville","Achicourt","Achiet-le-Grand","Achiet-le-Petit","Acigne","Acq","Acquigny","Acy-en-Multien","Adam-les-Vercel","Adamswiller","Adelans-et-le-Val-de-Bithaine","Adissan","Adriers","Afa","Agay","Agde","Agen","Agneaux","Agnetz","Agnin","Agnos","Agny","Aguilcourt","Ahaxe-Alciette-Bascassan","Ahuille","Ahun","Ahuy","Aiffres","Aigaliers","Aiglemont","Aignan","Aigne","Aigny","Aigonnay","Aigre","Aigrefeuille","Aigrefeuille-sur-Maine","Aigremont","Aigremont","Aiguebelette-le-Lac","Aiguebelle","Aigueblanche","Aiguefonde","Aigueperse","Aigueperse","Aigues-Mortes","Aigues-Vives","Aigues-Vives","Aiguillon","Ailette","Aillas","Aillevillers-et-Lyaumont","Aillon-le-Vieux","Ailly-le-Haut-Clocher","Ailly-sur-Noye","Ailly-sur-Somme","Aimargues","Aime","Ainay-le-Chateau","Aincourt","Ainhoa","Airaines","Aire-sur-la-Lys","Airel","Airvault","Aiserey","Aissey","Aiton","Aix-en-Ergny","Aix-en-Issart","Aix-en-Othe","Aix-en-Provence","Aix-les-Bains","Aix-Noulette","Aixe-sur-Vienne","Aizenay","Ajaccio","Alairac","Alata","Alban","Albas","Albefeuille-Lagarde","Albens","Albert","Albertville","Albi","Albias","Albigny-sur-Saone","Albiosc","Alboussiere","Albussac","Alby-sur-Cheran","Alenya","Alfortville","Algolsheim","Algrange","Alignan-du-Vent","Alissas","Alix","Alixan","Alizay","Allain","Allaire","Allan","Allassac","Allauch","Allegre","Alleins","Allemans-du-Dropt","Allennes-les-Marais","Alleriot","Allery","Allevard","Alliancelles","Allier","Allieres","Allinges","Allogny","Allondrelle-la-Malmaison","Allonne","Allonne","Allonnes","Allonnes","Allonville","Allonzier-la-Caille","Allos","Allouagne","Alloue","Allouis","Allouville-Bellefosse","Alluy","Alluyes","Ally","Alos-Sibas-Abense","Alteckendorf","Altkirch","Altorf","Altviller","Alvimare","Alzonne","Amagney","Amailloux","Amancey","Amancy","Amange","Amanlis","Amanvillers","Amathay-Vesigneux","Amaye-sur-Orne","Ambazac","Amberac","Amberieux","Amberieux-en-Dombes","Ambert","Ambes","Ambierle","Ambleny","Ambleteuse","Amboise","Ambon","Ambonnay","Ambres","Ambrieres","Ambronay","Ambrus","Ambutrix","Amelecourt","Amelie-les-Bains-Palalda","Amen","Ames","Amfreville","Amfreville-la-Mi-Voie","Amfreville-sous-les-Monts","Amiens","Amigny","Amigny-Rouy","Amillis","Amilly","Ammerschwihr","Ammerzwiller","Amneville","Amou","Amplepuis","Amponville","Ampuis","Ampus","Amure","Anais","Ance","Anceaumeville","Ancemont","Ancenis","Ancerville","Anche","Anchenoncourt-et-Chazel","Ancinnes","Ancizan","Ancone","Ancy","Ancy-le-Franc","Ancy-sur-Moselle","Andance","Andancette","Andard","Ande","Andechy","Andel","Andelot-Morval","Andernos-les-Bains","Andeville","Andigne","Andilly","Andilly","Andilly","Andoins","Andolsheim","Andon","Andonville","Andouille","Andouille-Neuville","Andres","Andrest","Andresy","Andreze","Andrezieux-Boutheon","Anduze","Anet","Anetz","Ange","Angeac-Champagne","Angeac-Charente","Angely","Angers","Angerville-la-Martel","Angervilliers","Angevillers","Angicourt","Angiens","Anglade","Anglefort","Angles","Anglet","Angliers","Anglure","Angoulins","Angoume","Angoville-sur-Ay","Angres","Anguerny","Angy","Anhaux","Anhiers","Aniane","Aniche","Anizy-le-Chateau","Anjou","Anjoutey","Anlhiac","Annay","Annay-sur-Serein","Annebault","Annecy","Annecy-le-Vieux","Annemasse","Annepont","Annequin","Annesse-et-Beaulieu","Annet-sur-Marne","Anneville-Ambourville","Anneyron","Annezay","Annezin","Annoeullin","Annois","Annonay","Annot","Annouville-Vilmesnil","Anor","Anould","Ansac-sur-Vienne","Ansauvillers","Anse","Ansouis","Antagnac","Anteuil","Anthe","Antheuil-Portes","Anthon","Anthy-sur-Leman","Antibes","Antignac","Antignac","Antigny","Antilly","Antilly","Antogny le Tillac","Antony","Antrain","Anzat-le-Luguet","Anzin","Anzin-Saint-Aubin","Anzy-le-Duc","Aoste","Aougny","Aouste-sur-Sye","Apach","Apcher","Apcher","Appenwihr","Appeville","Appeville-Annebault","Appietto","Appoigny","Apprieu","Apremont","Apremont","Apt","Araches-la-Frasse","Aragon","Aramits","Aramon","Arancou","Arbent","Arberats-Sillegue","Arbin","Arbois","Arbonne","Arboucave","Arbus","Arbusigny","Arc-et-Senans","Arc-sur-Tille","Arcachon","Arcay","Arcens","Arces","Archamps","Arche","Arches","Archettes","Archiac","Archingeay","Arcine","Arcis-sur-Aube","Arcon","Arcon","Arcueil","Arcy-Sainte-Restitue","Ardenay-sur-Merize","Ardentes","Ardes","Ardiege","Ardillieres","Ardoix","Ardon","Ardres","Areines","Arengosse","Arenthon","Ares","Aressy","Arette","Argancy","Argelers","Argeles-Gazost","Argeliers","Argelliers","Argences","Argens","Argent-sur-Sauldre","Argentan","Argentat","Argenteuil","Argentiere","Argentine","Argenton-les-Vallees","Argenton-sur-Creuse","Argentre","Argentre-du-Plessis","Argeville","Argol","Argueil","Arinthod","Arlanc","Arlay","Arlebosc","Arles","Arles","Arleux","Arleux-en-Gohelle","Armaucourt","Armbouts-Cappel","Armenonville-les-Gatineaux","Armes","Armoy","Arnac-Pompadour","Arnage","Arnas","Arnay-le-Duc","Arnieres-sur-Iton","Arnouville","Arnouville-les-Mantes","Aron","Arpaillargues-et-Aureillac","Arpajon","Arpajon-sur-Cere","Arpenans","Arpheuilles-Saint-Priest","Arques","Arques-la-Bataille","Arquettes-en-Val","Arrabloy","Arradon","Arras","Arraute-Charritte","Arreau","Arrenes","Arrigas","Arrigny","Arrou","Ars","Ars-en-Re","Ars-Laquenexy","Ars-sur-Formans","Ars-sur-Moselle","Arsac","Arsac-en-Velay","Arsague","Artannes-sur-Indre","Artas","Artenay","Arthaz-Pont-Notre-Dame","Arthes","Arthez-de-Bearn","Arthon","Arthon-en-Retz","Artigat","Artigueloutan","Artiguelouve","Artigues","Artigues-pres-Bordeaux","Artix","Artolsheim","Arudy","Arvert","Arveyres","Arvillard","Arville","Arvillers","Arx","Arzacq-Arraziguet","Arzal","Arzano","Arzon","Asasp-Arros","Ascain","Ascheres-le-Marche","Ascoux","Ascq","Aslonnes","Asnans-Beauvoisin","Asnieres","Asnieres-sur-Oise","Asnieres-sur-Seine","Aspach-le-Bas","Aspach-le-Haut","Asperes","Aspet","Aspremont","Asque","Assas","Assat","Assay","Assevent","Assier","Assignan","Asson","Astaffort","Astille","Astis","Athee","Athesans-Etroitefontaine","Athies","Athies-sous-Laon","Athis-Mons","Attenschwiller","Attiches","Attichy","Attignat-Oncin","Attigny","Atton","Atur","Aubagne","Aubais","Aubas","Aubenas","Auberchicourt","Aubergenville","Auberives-sur-Vareze","Aubers","Auberville-la-Campagne","Auberville-la-Renault","Aubervilliers","Aubevoye","Aubiac","Aubie-et-Espessas","Aubiere","Aubiet","Aubignan","Aubigne","Aubigne-Racan","Aubigney","Aubigny","Aubigny-au-Bac","Aubigny-en-Artois","Aubigny-en-Laonnois","Aubigny-en-Plaine","Aubin","Aubin","Aubin-Saint-Vaast","Aubinges","Aubord","Auboue","Aubrac","Aubrives","Aubry-du-Hainaut","Aubusson","Auby","Aucamville","Auch","Auchel","Auchy-les-Hesdin","Auchy-les-Mines","Auchy-lez-Orchies","Audelange","Audenge","Audes","Audierne","Audignies","Audincourt","Audincthun","Audruicq","Audun-le-Roman","Audun-le-Tiche","Auffargis","Auffay","Auffreville-Brasseuil","Auga","Augignac","Augny","Aulhat-Saint-Privat","Aulnat","Aulnay","Aulnay-sous-Bois","Aulnay-sur-Marne","Aulnay-sur-Mauldre","Aulnoye-Aymeries","Ault","Aumagne","Aumale","Aumenancourt","Aumetz","Aumont","Aumont-Aubrac","Aumont-en-Halatte","Aumontzey","Aumur","Aunay-les-Bois","Aunay-sous-Auneau","Aunay-sur-Odon","Auneau","Auneuil","Aups","Auray","Aurec-sur-Loire","Aureil","Aureilhan","Aureilhan","Auriac","Auriac","Auriac-sur-Vendinelle","Auribeau-sur-Siagne","Aurignac","Aurillac","Auriol","Aurons","Aussevielle","Aussillon","Aussonce","Aussonne","Autechaux","Auterive","Auterive","Auteuil","Auteuil","Autevielle-Saint-Martin-Bideren","Authevernes","Authie","Authie","Authon","Authou","Authouillet","Autoreille","Autrans","Autreche","Autremencourt","Autreville","Autry-le-Chatel","Autun","Auvergny","Auvers","Auvers-Saint-Georges","Auvers-sur-Oise","Auvillar","Auvillars","Auvillers-les-Forges","Auvilliers-en-Gatinais","Auxais","Auxances","Auxange","Auxerre","Auxey-Duresses","Auxi-le-Chateau","Auxon","Auxon-Dessous","Auxon-Dessus","Auxonne","Auxy","Auzances","Auzeville-Tolosane","Auzielle","Auzon","Auzouer-en-Touraine","Availles-Limouzine","Avallon","Avancon","Avanne-Aveney","Avanton","Avaray","Aveize","Aveizieux","Avelin","Aveluy","Avenay","Avensan","Aventignan","Averdoingt","Averdon","Averton","Avesnelles","Avesnes-en-Bray","Avesnes-le-Comte","Avesnes-le-Sec","Avesnes-les-Aubert","Avesnes-sur-Helpe","Aveze","Aveze","Aviernoz","Avignon","Avignonet-Lauragais","Avion","Aviron","Avize","Avoine","Avon","Avon-la-Peze","Avord","Avot","Avrainville","Avranches","Avremesnil","Avressieux","Avril","Avrille","Ax-les-Thermes","Aydat","Ayencourt","Ayette","Ayguemorte-les-Graves","Ayguesvives","Aymeries","Aynac","Ayrens","Ayse","Aytre","Azas","Azay-le-Brule","Azay-le-Rideau","Azay-sur-Cher","Azay-sur-Indre","Aze","Aze","Azerables","Azerailles","Azet","Azille","Azur","Azy-sur-Marne","Babeau-Bouldoux","Baccarat","Bach","Bachant","Bachy","Bacilly","Baconnes","Bacqueville","Bacqueville-en-Caux","Baden","Badevel","Bagard","Bagas","Bage-la-Ville","Bages","Bagnac-sur-Cele","Bagneaux","Bagneaux-sur-Loing","Bagneux","Bagnolet","Bagnols","Bagnols","Bagnols-en-Foret","Bagnols-sur-Ceze","Baguer-Morvan","Baguer-Pican","Baho","Baignes-Sainte-Radegonde","Baigneux-les-Juifs","Baillargues","Bailleau-le-Pin","Baillet-en-France","Bailleul","Bailleul-le-Soc","Bailleul-Sir-Berthoult","Bailleul-sur-Therain","Bailly","Bailly","Bailly-Carrois","Bailly-le-Franc","Bailly-Romainvilliers","Bain-de-Bretagne","Bains","Bains-les-Bains","Bains-sur-Oust","Bainville-sur-Madon","Baisieux","Baixas","Bajus","Balagny-sur-Therain","Balan","Balanod","Balaruc-le-Vieux","Balaruc-les-Bains","Balaze","Balbigny","Baldenheim","Baldersheim","Balgau","Ballainvilliers","Ballaison","Ballan-Mire","Ballancourt-sur-Essonne","Balleroy","Ballon","Ballon","Balma","Balschwiller","Balzac","Ban-de-Laveline","Banassac","Bandol AOC","Bangor","Banize","Bannalec","Banne","Bannes","Bannieres","Banon","Bantigny","Bantzenheim","Banville","Banvou","Banyuls de la Marenda","Banyuls-dels-Aspres","Bapaume","Bar-le-Duc","Bar-sur-Aube","Bar-sur-Seine","Baraqueville","Barastre","Barbaira","Barbaste","Barbatre","Barbazan-Debat","Barbechat","Barbentane","Barberaz","Barbery","Barbeville","Barbezieux-Saint-Hilaire","Barbieres","Barbizon","Barby","Barc","Barcelonnette","Bardos","Barembach","Barentin","Barenton-Bugny","Barfleur","Barges","Barinque","Barisey-au-Plain","Barisey-la-Cote","Barjac","Barjols","Barjon","Barjouville","Barlin","Barneville-Carteret","Baron","Baron","Baronville","Barr","Barraux","Barreme","Barro","Barrou","Bartenheim","Barzy-en-Thierache","Bas-en-Basset","Bascons","Bassan","Basse-Goulaine","Basse-Ham","Basse-Rentgen","Basse-sur-le-Rupt","Bassemberg","Bassens","Bassens","Bassigney","Bassillac","Bassoles-Aulers","Bassou","Bassu","Bassussarry","Bastennes","Bastia","Batilly","Batilly-en-Gatinais","Battenheim","Battrans","Batz-sur-Mer","Batzendorf","Baud","Baudemont","Baudreix","Baulay","Baule","Baulne","Baulon","Baume-les-Dames","Baume-les-Messieurs","Baune","Baupte","Baurech","Bauvin","Bavans","Bavay","Bavent","Bavilliers","Bavincourt","Baye","Bayet","Bayeux","Bayon","Bayonne","Bazailles","Bazancourt","Bazarnes","Bazas","Bazeilles","Bazemont","Bazens","Bazet","Bazian","Bazicourt","Baziege","Bazien","Bazincourt-sur-Epte","Bazoches","Bazoches-les-Gallerandes","Bazoches-sur-Guyonne","Bazoches-sur-Hoene","Bazoches-sur-le-Betz","Bazoges-en-Paillers","Bazoilles-sur-Meuse","Bazoncourt","Bazouges-la-Perouse","Bazouges-sous-Hede","Bazouges-sur-le-Loir","Bazuel","Beaucaire","Beaucamps-le-Vieux","Beaucamps-Ligny","Beauce","Beauchamp","Beauchamps","Beauchamps","Beauchamps-sur-Huillard","Beauchastel","Beauchene","Beaucourt","Beaucouze","Beaucroissant","Beaudricourt","Beaufort","Beaufort","Beaufort","Beaufort-en-Vallee","Beaufou","Beaugency","Beaujeu","Beaulieu-sous-Parthenay","Beaulieu-sur-Dordogne","Beaulieu-sur-Loire","Beaulieu-sur-Mer","Beaumetz-les-Loges","Beaumont","Beaumont","Beaumont","Beaumont-de-Lomagne","Beaumont-de-Pertuis","Beaumont-du-Gatinais","Beaumont-du-Perigord","Beaumont-en-Veron","Beaumont-Hague","Beaumont-le-Roger","Beaumont-les-Autels","Beaumont-les-Nonains","Beaumont-les-Valence","Beaumont-Pied-de-Boeuf","Beaumont-sur-Oise","Beaumont-sur-Sarthe","Beaune","Beaune-la-Rolande","Beaupont","Beaupreau","Beaupuy","Beauquesne","Beaurains","Beaurainville","Beauregard-Baret","Beauregard-Vendon","Beaurepaire","Beaurepaire","Beaurepaire","Beaurevoir","Beaurieux","Beausemblant","Beausoleil","Beaussault","Beautheil","Beautiran","Beautor","Beautot","Beauvais","Beauvais-sur-Matha","Beauval","Beauvallon","Beauvene","Beauvernois","Beauvezer","Beauville","Beauvoir","Beauvoir","Beauvoir-de-Marc","Beauvoir-sur-Mer","Beauvoir-sur-Niort","Beauvoisin","Beauvoisin","Beauvoisin","Beauzac","Beauzelle","Bechy","Becon-les-Granits","Bedarrides","Bedee","Bedous","Beganne","Begard","Begles","Beguey","Behren-les-Forbach","Beignon","Beine-Nauroy","Beinheim","Beire-le-Chatel","Bel Air","Belarga","Belaye","Belbeuf","Belcodene","Belfort","Belfort-du-Quercy","Belgentier","Belgodere","Belhade","Beliet","Beligneux","Bellac","Bellaing","Bellancourt","Belle-Isle-en-Terre","Belleau","Bellebrune","Bellechaume","Bellefond","Bellefontaine","Bellefosse","Bellegarde","Bellegarde-du-Razes","Bellegarde-en-Diois","Bellegarde-Sainte-Marie","Bellegarde-sur-Valserine","Bellemagny","Bellenaves","Bellencombre","Belleneuve","Bellengreville","Bellentre","Belleray","Bellerive-sur-Allier","Bellesserre","Belleu","Bellevaux","Bellevesvre","Belleville","Belleville","Belleville-en-Caux","Belleville-sur-Loire","Belleville-sur-Mer","Belleville-sur-Meuse","Belleville-sur-Vie","Bellevue-la-Montagne","Belley","Bellignat","Belloy-en-France","Belmont","Belmont","Belmont-sur-Rance","Belmontet","Belpech","Belrupt-en-Verdunois","Belveze","Belz","Benamenil","Bene","Benerville-sur-Mer","Benesse-Maremne","Benestroff","Benfeld","Benifontaine","Benney","Bennwihr","Benon","Benouville","Beon","Berat","Bercenay-en-Othe","Berck","Berck-Plage","Berdoues","Berenx","Berg-sur-Moselle","Bergerac","Bergheim","Bergholtz","Bergonne","Bergues","Berjou","Berlaimont","Berles-au-Bois","Bermeries","Bermicourt","Bernadets","Bernard","Bernaville","Bernay","Bernay-Saint-Martin","Berne","Bernes-sur-Oise","Berneuil-sur-Aisne","Berneval-le-Grand","Bernex","Bernieres-le-Patry","Bernieres-sur-Mer","Bernin","Bernis","Bernos-Beaulac","Berriac","Berric","Berry-Bouy","Bersaillin","Bersee","Berson","Berthecourt","Berthelange","Berthen","Bertholene","Bertin","Bertincourt","Bertrange","Bertrimoutier","Bertry","Berville-en-Roumois","Berville-la-Campagne","Berville-sur-Seine","Berviller-en-Moselle","Berzeme","Berzet","Besayes","Besne","Bessais-le-Fromental","Bessan","Bessancourt","Bessay","Besse","Besse","Besse-sur-Braye","Besse-sur-Issole","Besseges","Bessenay","Bessens","Bessey-les-Citeaux","Bessieres","Bessines","Bessines-sur-Gartempe","Besson","Bessoncourt","Bessonies","Betaille","Bethancourt-en-Valois","Bethencourt-sur-Mer","Betheniville","Betheny","Bethisy-Saint-Pierre","Bethoncourt","Betschdorf","Bettancourt-la-Ferree","Bettignies","Betting","Betton","Bettviller","Bettwiller","Betz","Beugin","Beugneux","Beure","Beurlay","Beuste","Beutal","Beuvillers","Beuvrages","Beuvraignes","Beuvron-en-Auge","Beuvry-la-Foret","Beuzec-Cap-Sizun","Beuzeville","Bevenais","Beychac-et-Caillau","Beynes","Beynost","Beyrede-Jumet","Beyrie-en-Bearn","Beyssenac","Bezac","Bezannes","Bezons","Bezouce","Bezu-Saint-Eloi","Biache-Saint-Vaast","Biard","Biarritz","Biars-sur-Cere","Biaudos","Bichancourt","Bicqueley","Bidache","Bidarray","Bidart","Bief-du-Fourg","Bielle","Bienville","Bienvillers-au-Bois","Biermont","Bierne","Bierry-les-Belles-Fontaines","Biesheim","Biesles","Bietlenheim","Bieville-Beuville","Bievres","Biganos","Bignac","Bignan","Bignoux","Biguglia","Bihorel","Bilieu","Billere","Billey","Billiers","Billom","Billy","Billy","Billy-Berclau","Billy-Montigny","Billy-sous-les-Cotes","Billy-sur-Ourcq","Bindernheim","Binges","Binic","Bining","Bionville-sur-Nied","Biot","Biot","Bioule","Birac-sur-Trec","Biriatou","Birieux","Biscarrosse","Bischheim","Bischoffsheim","Bischwihr","Bischwiller","Bisel","Bitche","Biviers","Biville-sur-Mer","Bizanos","Blacourt","Blacqueville","Blacy","Blaesheim","Blagnac","Blagny","Blaignan","Blain","Blainville","Blainville-sur-Mer","Blainville-sur-Orne","Blaise","Blaise-sous-Arzillieres","Blaison-Gohier","Blamont","Blamont","Blan","Blancafort","Blanchefosse-et-Bay","Blangy-sur-Bresle","Blanot","Blanquefort","Blanzat","Blanzay-sur-Boutonne","Blanzy","Blanzy-la-Salonnaise","Blaringhem","Blaudeix","Blausasc","Blauzac","Blavozy","Blaye","Blaye-les-Mines","Bleigny-le-Carreau","Blendecques","Blenod-les-Pont-a-Mousson","Blenod-les-Toul","Blerancourdelle","Blere","Bleriot-Plage","Blesle","Bletterans","Bleury","Bligny-les-Beaune","Blincourt","Blingel","Blodelsheim","Blois","Blomard","Blondefontaine","Blonville-sur-Mer","Blotzheim","Blou","Bloye","Blyes","Bobigny","Bocquegney","Boe","Boege","Boeil-Bezing","Boen-sur-Lignon","Boersch","Boeschepe","Boeseghem","Boesenbiesen","Bohain-en-Vermandois","Bohal","Boigneville","Boigny","Boigny-sur-Bionne","Bois","Bois-Anzeray","Bois-Arnault","Bois-Colombes","Bois-de-Cene","Bois-de-Gand","Bois-de-la-Pierre","Bois-Grenier","Bois-Guillaume","Bois-Jerome-Saint-Ouen","Bois-le-Roi","Bois-le-Roi","Boisbergues","Boiscommun","Boisemont","Boisemont","Boisjean","Boisleux-au-Mont","Boismont","Boismorand","Boisse-Penchot","Boisseron","Boisset-et-Gaujac","Boisseuil","Boissey-le-Chatel","Boissezon","Boissieres","Boissise-la-Bertrand","Boissise-le-Roi","Boissy-Fresnoy","Boissy-le-Bois","Boissy-le-Chatel","Boissy-le-Girard","Boissy-Maugis","Boissy-Mauvoisin","Boissy-sous-Saint-Yon","Boisville-la-Saint-Pere","Boisyvon","Bolandoz","Bolbec","Bollene","Bolleville","Bollezeele","Bollwiller","Bolsenheim","Bommes","Bompas","Bompas","Bon-Encontre","Bonchamp-les-Laval","Boncourt-le-Bois","Boncourt-sur-Meuse","Bondeville","Bondigoux","Bondoufle","Bondues","Bondy","Bongheat","Bonifacio","Bonlier","Bonnard","Bonnat","Bonnebosq","Bonnee","Bonnegarde","Bonneguete","Bonneil","Bonnelles","Bonnemain","Bonnes","Bonnet","Bonnet","Bonnet","Bonnetable","Bonnetage","Bonnetan","Bonneuil-en-France","Bonneuil-en-Valois","Bonneuil-les-Eaux","Bonneuil-sur-Marne","Bonneval","Bonnevaux-le-Prieure","Bonnevent-Velloreille","Bonneville","Bonneville","Bonneville-Aptot","Bonneville-la-Louvet","Bonnieres-sur-Seine","Bonnieux","Bonny-sur-Loire","Bonrepos","Bonrepos-Riquet","Bons-en-Chablais","Bonsecours","Bonson","Bonzac","Boos","Boos","Boqueho","Bor-et-Bar","Boran-sur-Oise","Bord","Bord","Bordeaux","Borderes","Borderes-et-Lamensans","Bordes","Bords","Borgo","Bormes-les-Mimosas","Bornay","Bornel","Bosc Renoult","Bosc-Guerard-Saint-Adrien","Bosc-le-Hard","Bosc-Mesnil","Bosgouet","Bosguerard-de-Marcouville","Bosjean","Bosmont-sur-Serre","Bosrobert","Bossancourt","Bossay-sur-Claise","Bossendorf","Bossey","Botsorhel","Bouafles","Bouan","Bouaye","Boubers-sur-Canche","Boubiers","Bouc-Bel-Air","Boucau","Bouchain","Bouchemaine","Boucheporn","Bouchet","Boucoiran-et-Nozieres","Bouee","Bouer","Bouere","Bouex","Bouffemont","Bouffere","Bougarber","Bouge-Chambalud","Bougival","Bougnon","Bougue","Bouguenais","Bougy","Bouhet","Bouillargues","Bouilly","Bouilly","Bouilly-en-Gatinais","Bouin","Boujan-sur-Libron","Boulages","Boulancourt","Boulange","Boulay-les-Barres","Boulay-Moselle","Boulazac","Bouleurs","Bouliac","Boulieu-les-Annonay","Bouligney","Bouligny","Boullay-les-Troux","Boulleret","Boulleville","Bouloc","Boulogne-Billancourt","Boulogne-la-Grasse","Boulogne-sur-Gesse","Boulogne-sur-Mer","Bouloire","Boult-sur-Suippe","Boulzicourt","Bouniagues","Bouquet","Bouquetot","Bouray-sur-Juine","Bourbon-Lancy","Bourbonne-les-Bains","Bourbourg","Bourbriac","Bourcefranc-le-Chapus","Bourdenay","Bourdon","Bouresse","Bourg","Bourg-Achard","Bourg-Argental","Bourg-Blanc","Bourg-de-Thizy","Bourg-en-Bresse","Bourg-la-Reine","Bourg-le-Comte","Bourg-le-Roi","Bourg-les-Valence","Bourg-Saint-Andeol","Bourg-Saint-Maurice","Bourg-Sainte-Marie","Bourg-sous-Chatelet","Bourganeuf","Bourgbarre","Bourges","Bourget","Bourghelles","Bourgneuf","Bourgneuf","Bourgneuf-en-Retz","Bourgogne","Bourgogne","Bourgoin","Bourguebus","Bourgueil","Bourguignon-sous-Coucy","Bourlon","Bourneville","Bournezeau","Bourogne","Bourran","Bourron-Marlotte","Bours","Bours","Boursault","Bourseville","Boursieres","Bourth","Boury-en-Vexin","Bousbach","Bousbecque","Bousies","Boussac","Boussac","Boussay","Boussenac","Boussens","Boussieres","Boussois","Boussy-Saint-Antoine","Boust","Boutancourt","Boutiers-Saint-Trojan","Boutigny-Prouais","Boutigny-sur-Essonne","Bouvaincourt-sur-Bresle","Bouvante","Bouvelinghem","Bouvesse-Quirieu","Bouvigny-Boyeffles","Bouville","Bouvincourt-en-Vermandois","Bouvron","Bouxieres-aux-Chenes","Bouxieres-aux-Dames","Bouxwiller","Bouzel","Bouzigues","Bouzincourt","Bouzonville","Bouzonville-en-Beauce","Bouzy","Bouzy-la-Foret","Boves","Boyer","Boynes","Boz","Bozel","Bozouls","Brachy","Bracieux","Brain-sur-Allonnes","Brain-sur-Vilaine","Braine","Brains","Bram","Bramans","Branches","Brancourt-en-Laonnois","Brandivy","Brando","Brandonnet","Branges","Branne","Branoux-les-Taillades","Bransles","Braquis","Bras","Brasles","Brasparts","Brassac","Brassac-les-Mines","Brassempouy","Braucourt","Braud-et-Saint-Louis","Brax","Brax","Bray","Bray-Dunes","Bray-en-Val","Bray-et-Lu","Bray-Saint-Christophe","Bray-sur-Seine","Bray-sur-Somme","Braye-sous-Faye","Brazey-en-Plaine","Breal-sous-Montfort","Brebieres","Brece","Brecey","Brech","Breconchaux","Bree","Bregy","Brehal","Brehand","Breil-sur-Roya","Breitenbach-Haut-Rhin","Breles","Bremenil","Bremontier-Merval","Brenouille","Brens","Bresles","Bresse-sur-Grosne","Bressolles","Bressolles","Bressols","Bresson","Bressuire","Brest","Bretagne","Breteil","Breteniere","Bretenoux","Breteuil","Breteuil","Bretignolles","Bretignolles-sur-Mer","Bretigny","Bretigny","Bretteville-sur-Laize","Bretteville-sur-Odon","Breuil","Breuil","Breuil-le-Sec","Breuil-le-Vert","Breuil-Magne","Breuillet","Breuillet","Breuilpont","Breuschwickersheim","Breuvannes-en-Bassigny","Breux-sur-Avre","Breval","Breviandes","Brexent-Enocq","Breze","Brezins","Brezolles","Brianconnet","Briare","Briarres-sur-Essonne","Briatexte","Bricon","Bricquebec","Bricqueville-la-Blouette","Bricqueville-sur-Mer","Bricy","Brides-les-Bains","Bridore","Brie","Brie","Brie-Comte-Robert","Brie-et-Angonnes","Briec","Brienne-la-Vieille","Briennon","Brienon-sur-Armancon","Brieres-les-Scelles","Brieuil-sur-Chize","Brieulles-sur-Meuse","Briey","Brignac-la-Plaine","Brignais","Brigne","Brignoles","Brignon","Brignoud","Brigueuil","Briis-sous-Forges","Brimeux","Brin-sur-Seille","Brinay","Brindas","Bringolo","Brinon-sur-Beuvron","Briollay","Brion","Brion","Brionne","Briord","Brioude","Brioux-sur-Boutonne","Briouze","Briscous","Brison-Saint-Innocent","Brissac","Brissac-Quince","Brissy-Hamegicourt","Brive","Brive-la-Gaillarde","Brives-Charensac","Brives-sur-Charente","Brix","Brochon","Broglie","Brognon","Broin","Brombos","Bron","Broons","Brossac","Brosville","Brou","Brou-sur-Chantereine","Brouay","Brouckerque","Brouderdorff","Broue","Brouennes","Brouilla","Brouqueyran","Brousse","Brousse","Brousseval","Brouviller","Bru","Bruch","Brue-Auriac","Bruebach","Bruges","Brugheas","Brugny-Vaudancourt","Bruguieres","Bruille-Saint-Amand","Bruley","Brullioles","Brulon","Brumath","Brunoy","Brunstatt","Brussey","Brussieu","Brusvily","Brux","Bruyeres-et-Montberault","Bruyeres-le-Chatel","Bruyeres-sur-Oise","Bruz","Bry-sur-Marne","Bu","Buanes","Bubry","Buc","Buceels","Bucey-les-Gy","Bucheres","Buchy","Bucquoy","Bucy-le-Long","Bucy-les-Cerny","Budos","Bueil","Buellas","Buffard","Bugeat","Bugnicourt","Buhl","Buigny-les-Gamaches","Buire-le-Sec","Buironfosse","Buis-les-Baronnies","Bulat-Pestivien","Bulgneville","Bulhon","Bulles","Bully","Bully-les-Mines","Buno-Bonnevaux","Bunzac","Burbure","Bures-sur-Yvette","Burie","Burlats","Burnhaupt-le-Haut","Buros","Bury","Busigny","Busloup","Busque","Bussac-Foret","Bussang","Bussiere-Galant","Bussiere-Poitevine","Bussieres-les-Belmont","Bussunarits-Sarrasquette","Bussus-Bussuel","Bussy-le-Chateau","Bussy-le-Grand","Bussy-les-Daours","Bussy-Lettree","Bussy-Saint-Georges","Busy","Buthiers","Butry-sur-Oise","Buxerolles","Buxeuil","Buxieres-les-Mines","Buxy","Buzan","Buzancais","Buzet-sur-Baise","Buzet-sur-Tarn","Buzy","Cabanac","Cabanac-et-Villagrains","Cabannes","Cabara","Cabariot","Cabasse","Cabestany","Cabourg","Cabries","Cabris","Cachan","Cadalen","Cadaujac","Caden","Cadenet","Cadillac","Cadillac-en-Fronsadais","Cadolive","Cadours","Caen","Caestre","Cagnac-les-Mines","Cagnes-sur-Mer","Cagnicourt","Cagny","Cagny","Cahagnes","Cahors","Cahuzac","Cahuzac","Cahuzac-sur-Vere","Caille","Caillouel-Crepigny","Cailloux-sur-Fontaines","Cairanne","Cairon","Caissargues","Cajarc","Calais","Calas","Calavante","Calcatoggio","Calenzana","Callac","Callac","Callas","Calleville","Callian","Calmels-et-le-Viala","Calmont","Calonne-Ricouart","Calonne-sur-la-Lys","Caluire-et-Cuire","Calvi","Calvisson","Camaret-sur-Aigues","Camaret-sur-Mer","Camarsac","Cambes","Cambieure","Camblain-Chatelain","Camblanes-et-Meynac","Cambo-les-Bains","Cambounet-sur-le-Sor","Cambrai","Cambrin","Cambronne-les-Ribecourt","Came","Cameyrac","Camiac-et-Saint-Denis","Camiers","Camlez","Camoel","Camon","Camon","Camors","Campagnan","Campagne","Campagne","Campagne-les-Hesdin","Campagne-les-Wardrecques","Campagnolles","Campeaux","Campeneac","Campet-et-Lamolere","Camphin-en-Carembault","Camphin-en-Pevele","Campigneulles-les-Petites","Campremy","Camprond","Camps-la-Source","Campuac","Campugnan","Canaples","Cancale","Cancon","Cande","Cande-sur-Beuvron","Candillargues","Candresse","Canejan","Canet-de-Salars","Canet-Plage","Cangey","Canisy","Canlers","Canly","Cannes","Cannes-Ecluse","Cannet","Canohes","Canouville","Canteleu","Cantin","Cany-Barville","Capbreton","Capdenac-Gare","Capelle","Capelle-Fermont","Capendu","Capens","Capestang","Capinghem","Capoulet-et-Junac","Cappel","Cappelle-Brouck","Cappelle-en-Pevele","Cappelle-la-Grande","Captieux","Capvern","Caragoudes","Caraman","Carantec","Carantilly","Carbon-Blanc","Carbonne","Carcans","Carcassonne","Carces","Carcopino","Cardaillac","Cardesse","Cardonville","Cardroc","Carency","Carentan","Carentoir","Carhaix-Plouguer","Carignan","Carling","Carlipa","Carlucet","Carlus","Carmaux","Carnac","Carneville","Carnieres","Carnin","Carnon-Plage","Carnoules","Carolles","Caromb","Carpentras","Carpiquet","Carquefou","Carqueiranne","Carresse-Cassaber","Carrieres-sous-Poissy","Carrieres-sur-Seine","Carros","Carrouges","Carry-le-Rouet","Carsac-Aillac","Carspach","Cartelegue","Cartignies","Carville-la-Folletiere","Carvin","Casanova","Cases-de-Pene","Cassagne","Cassagnes","Cassagnes-Begonhes","Cassagnoles","Cassel","Casseneuil","Cassis","Casson","Cast","Castagnede","Castanet-le-Haut","Castanet-Tolosan","Casteide-Cami","Castelginest","Casteljaloux","Castellane","Castellar","Castellare-di-Mercurio","Castello-di-Rostino","Castelmoron-sur-Lot","Castelnau-de-Brassac","Castelnau-de-Levis","Castelnau-de-Montmiral","Castelnau-Durban","Castelnau-le-Lez","Castelnau-Montratier","Castelnau-sur-Gupie","Castelnau-Valence","Castelnaud-de-Gratecambe","Castelnaudary","Castels","Castelsagrat","Castelsarrasin","Castera-Loubix","Castet","Castetner","Castets-en-Dorthe","Castiglione","Castillon-Debats","Castillon-du-Gard","Castillon-la-Bataille","Castillon-Massas","Castillonnes","Castilly","Castres","Castres-Gironde","Castries","Catenay","Catenoy","Cattenom","Catus","Caucalieres","Caudan","Caudebec-en-Caux","Caudecoste","Caudrot","Caudry","Cauge","Caullery","Caulnes","Caumont","Caumont","Caumont-sur-Durance","Caumont-sur-Garonne","Cauneille","Caunes-Minervois","Caurel","Cauroir","Cauroy-les-Hermonville","Caussade-Riviere","Causse-de-la-Selle","Cauvigny","Cauville-sur-Mer","Caux","Caux-et-Sauzens","Cauzac","Cavaillon","Cavalaire-sur-Mer","Cavan","Caveirac","Cavignac","Cavillargues","Cavillon","Cayeux-sur-Mer","Caylus","Cayrac","Cazals-des-Bayles","Cazaux","Cazaux-Layrisse","Cazavet","Cazeres","Cazes-Mondenard","Cazevieille","Cazilhac","Cazouls-les-Beziers","Ceauce","Ceaux","Cebazat","Ceignes","Ceintrey","Celle-Levescault","Celles-en-Bassigny","Celles-sur-Belle","Celles-sur-Durolle","Cellettes","Cellieu","Celon","Cenac","Cendras","Cenon","Cenon-sur-Vienne","Centres","Cepet","Cepie","Cepoy","Cerans-Foulletourte","Cercier","Cercoux","Cerdon","Cere","Cerelles","Cereste","Ceret","Cergy","Cerilly","Cerise","Cerisiers","Cerisy-la-Foret","Cerisy-la-Salle","Cerizay","Cernay","Cernay-la-Ville","Cerneux","Cerny","Cerons","Cers","Certines","Cervens","Cervera de la Marenda","Cervieres","Cervione","Cesar","Cesarches","Cescau","Cesny-aux-Vignes","Cesny-Bois-Halbout","Cessales","Cessenon-sur-Orb","Cesseras","Cessey","Cessieu","Cesson","Cesson","Cessy","Cestas","Ceton","Ceyrat","Ceyreste","Ceyssat","Ceyzeriat","Cezay","Chaban","Chabanais","Chabestan","Chabeuil","Chablis","Chabons","Chabottes","Chabrillan","Chabris","Chacenay","Chadeleuf","Chadrac","Chadron","Chaffois","Chagey","Chagny","Chaignay","Chail","Chaillac","Chaillac-sur-Vienne","Chaille-les-Marais","Chailles","Chaillevette","Chailloue","Chailly-en-Biere","Chailly-en-Gatinais","Chainaz-les-Frasses","Chaingy","Chaix","Chalais","Chalamont","Chalampe","Chalandry-Elaire","Chaleins","Chalencon","Chalette-sur-Loing","Chalette-sur-Voire","Chaleze","Chalezeule","Chaligny","Chalindrey","Challain-la-Potherie","Challans","Challes-les-Eaux","Challet","Challex","Chalmaison","Chalo-Saint-Mars","Chalon","Chalonnes-sur-Loire","Chalons-en-Champagne","Chalonvillars","Chalou-Moulineux","Chamagne","Chamagnieu","Chambalud","Chamberet","Chambilly","Chamblac","Chamblanc","Chambles","Chamblet","Chambley-Bussieres","Chambly","Chamboeuf","Chambon","Chambon-sur-Lac","Chambon-sur-Voueize","Chambonas","Chambord","Chamboret","Chamborigaud","Chambors","Chambost-Longessaigne","Chamboulive","Chambourcy","Chambourg-sur-Indre","Chambrecy","Chambretaud","Chambry","Chamelet","Chameyrat","Chamigny","Chamonix","Chamouilley","Chamoux","Chamoux-sur-Gelon","Champ","Champ-le-Duc","Champ-sur-Drac","Champagnac","Champagnac-le-Vieux","Champagnat","Champagne","Champagne","Champagne-les-Marais","Champagne-Mouton","Champagne-sur-Oise","Champagne-sur-Seine","Champagney","Champagnole","Champanges","Champcenest","Champcerie","Champcevinel","Champcueil","Champdieu","Champdotre","Champdray","Champeaux","Champeaux","Champeix","Champenay","Champenoux","Champeon","Champey-sur-Moselle","Champforgeuil","Champfromier","Champhol","Champien","Champier","Champigne","Champigneulles","Champigny","Champigny-sur-Marne","Champlan","Champlemy","Champlitte","Champniers","Champoly","Champoulet","Champs","Champs-sur-Marne","Champs-sur-Tarentaine-Marchal","Champs-sur-Yonne","Champsac","Champtercier","Champtoce-sur-Loire","Champtoceaux","Champvans","Chanas","Chanceaux-sur-Choisille","Chancelade","Chancenay","Change","Changis-sur-Marne","Chaniers","Chanonat","Chanoz-Chatenay","Chanteau","Chantecorps","Chanteheux","Chanteloup","Chanteloup-en-Brie","Chanteloup-les-Bois","Chanteloup-les-Vignes","Chantemerle-sur-la-Soie","Chantepie","Chanteuges","Chantilly","Chantome","Chantonnay","Chantraine","Chantrans","Chanveaux","Chaon","Chapareillan","Chapdes-Beaufort","Chapeiry","Chapelle-Vallon","Chapelle-Voland","Chaponnay","Chaponost","Chaptelat","Chaptuzat","Charancieu","Charantonnay","Charavines","Charbonnieres-les-Bains","Charbonnieres-les-Varennes","Charbuy","Charentay","Charenton-le-Pont","Charge","Chargey-les-Gray","Chargey-les-Port","Charleval","Charleval","Charleville","Charlieu","Charly","Charly-sur-Marne","Charmant","Charmes","Charmes","Charmes-sur-Rhone","Charmont-en-Beauce","Charmont-sous-Barbuise","Charnas","Charnay","Charnay","Charnay-les-Macon","Charnecles","Charny","Charolles","Charonville","Charost","Charquemont","Charrecey","Charron","Charroux","Charsonville","Charteves","Chartres","Chartres-de-Bretagne","Chartrettes","Charvieu-Chavagneux","Charvonnex","Chas","Chasnais","Chasne-sur-Illet","Chaspinhac","Chassagnes","Chassagny","Chasse-sur-Rhone","Chasselay","Chassemy","Chassenard","Chasseneuil","Chasseneuil-du-Poitou","Chasseneuil-sur-Bonnieure","Chassey-le-Camp","Chassiers","Chassieu","Chataincourt","Chateau","Chateau-Arnoux-Saint-Auban","Chateau-Chervix","Chateau-Chinon(Ville)","Chateau-du-Loir","Chateau-Gontier","Chateau-Landon","Chateau-Porcien","Chateau-Renault","Chateau-Salins","Chateau-sur-Epte","Chateaubleau","Chateaubourg","Chateaubriand","Chateaubriant","Chateaudouble","Chateaufort","Chateaugay","Chateaugiron","Chateaumeillant","Chateauneuf","Chateauneuf-de-Bordette","Chateauneuf-de-Gadagne","Chateauneuf-de-Galaure","Chateauneuf-du-Faou","Chateauneuf-du-Rhone","Chateauneuf-en-Thymerais","Chateauneuf-Grasse","Chateauneuf-la-Foret","Chateauneuf-le-Rouge","Chateauneuf-les-Martigues","Chateauneuf-sur-Charente","Chateauneuf-sur-Loire","Chateauneuf-sur-Sarthe","Chateaurenard","Chateauvillain","Chatel","Chatel-de-Neuvre","Chatel-Guyon","Chatel-Saint-Germain","Chatel-sur-Moselle","Chatelaillon-Plage","Chatelaines","Chatelais","Chatelaudren","Chateldon","Chatelet","Chatelus","Chatelus-le-Marcheix","Chatenay-sur-Seine","Chatenet","Chatenois","Chatenois","Chatenois-les-Forges","Chatenoy","Chatenoy-le-Royal","Chatignonville","Chatillon","Chatillon-Coligny","Chatillon-la-Palud","Chatillon-le-Duc","Chatillon-le-Roi","Chatillon-les-Sons","Chatillon-sur-Chalaronne","Chatillon-sur-Cher","Chatillon-sur-Indre","Chatillon-sur-Loire","Chatillon-sur-Saone","Chatillon-sur-Seiche","Chatillon-sur-Thouet","Chatonnay","Chatonrupt-Sommermont","Chatou","Chatres","Chatres-sur-Cher","Chatte","Chatuzange-le-Goubet","Chauche","Chaudefonds-sur-Layon","Chaudefontaine","Chaudon","Chaudron-en-Mauges","Chauffailles","Chauffry","Chaufour-les-Bonnieres","Chaufour-Notre-Dame","Chaulnes","Chaumes","Chaumes-en-Brie","Chaumont","Chaumont","Chaumont-en-Vexin","Chaumontel","Chaumousey","Chauny","Chauray","Chauriat","Chaussin","Chaussoy-Epagny","Chaussy","Chauve","Chauvigny","Chauvincourt-Provemont","Chauvry","Chaux","Chavagne","Chavagnes-en-Paillers","Chavagnes-les-Redoux","Chavaignes","Chavanay","Chavannes-sur-Reyssouze","Chavanod","Chavanoz","Chavaroux","Chavenay","Chavigny","Chaville","Chazelles","Chazelles-sur-Lyon","Checy","Chedigny","Chef-Boutonne","Cheffes","Chehery","Chelan","Chelles","Chemaze","Chemere","Chemere-le-Roi","Chemery","Chemery-les-Deux","Chemille-Melay","Chemilly-sur-Serein","Cheminot","Chemy","Chenailler-Mascheix","Chenaud","Chenay-le-Chatel","Chenerailles","Chenevelles","Chenex","Chenimenil","Chennevieres-sur-Marne","Chenonceaux","Chenou","Chenove","Chens-sur-Leman","Cheny","Chepoix","Cheptainville","Chepy","Cherac","Cherbourg-Octeville","Chereng","Cheret","Cherier","Cherisey","Cherisy","Cheron","Cheroy","Cherre","Cherreau","Cherves-Chatelars","Cherves-Richemont","Chervettes","Cherveux","Chesley","Chessy","Chessy","Chessy-les-Pres","Cheux","Chevaigne","Cheval-Blanc","Chevalet-le-Haut","Chevanceaux","Chevannes","Chevannes","Cheverny","Chevigny","Chevigny-Saint-Sauveur","Chevillon","Chevillon","Chevillon-sur-Huillard","Chevilly","Chevilly-Larue","Chevincourt","Chevire-le-Rouge","Chevrainvilliers","Chevremont","Chevreuse","Chevrier","Chevrieres","Chevrieres","Chevrotaine","Chevru","Chevry","Chevry-Cossigny","Chevry-en-Sereine","Cheyssieu","Chezery-Forens","Chezy","Chezy-sur-Marne","Chiche","Chichery","Chierry","Chieulles","Chignin","Chigny-les-Roses","Chigy","Chilhac","Chille","Chilly","Chilly-Mazarin","Chimilin","Chinon","Chire-en-Montreuil","Chirens","Chiry-Ourscamp","Chissay-en-Touraine","Chisseaux","Chissey-en-Morvan","Chitenay","Chivres-en-Laonnois","Chize","Chocques","Choisel","Choisey","Choisy","Choisy-au-Bac","Choisy-en-Brie","Choisy-le-Roi","Cholet","Chomerac","Chorges","Chourgnac","Chouy","Choye","Chozeau","Chuelles","Chuzelles","Ciboure","Ciel","Cierrey","Cieurac","Cieux","Cinq-Mars-la-Pile","Cinqueux","Cintegabelle","Cintheaux","Cintre","Cires-les-Mello","Cirey","Cirey-sur-Vezouze","Ciron","Ciry-le-Noble","Cissac-Medoc","Cisse","Cistrieres","Citerne","Citry","Civaux","Civens","Civrac-de-Blaye","Civrac-en-Medoc","Civray","Civray","Civray-de-Touraine","Civrieux","Civry-en-Montagne","Cize","Cizely","Claira","Clairac","Clairfontaine","Clairmarais","Clairoix","Clairvaux-dAveyron","Clairvaux-les-Lacs","Claix","Claix","Clamart","Clamecy","Clamecy","Claouey","Clapiers","Clarac","Claracq","Clarafond","Clarensac","Clarques","Clary","Classun","Clasville","Clavel","Clavette","Claviers","Claville","Claye-Souilly","Cleder","Cleguer","Cleguerec","Clelles","Clement","Clemery","Clemont","Clenay","Cleon","Clerieux","Clermont","Clermont","Clermont","Clermont","Clermont-Ferrand","Clerval","Clery-Saint-Andre","Clesse","Clety","Clevilliers","Clichy","Clichy-sous-Bois","Clinchamps-sur-Orne","Cliron","Clisson","Clohars-Carnoet","Clohars-Fouesnant","Clouange","Clouzeau","Cloyes-sur-le-Loir","Cluny","Cluses","Coaraze","Coarraze","Cobrieux","Cocheren","Cocumont","Codognan","Codolet","Coesmes","Coeuvres-et-Valsery","Coex","Cogles","Cogna","Cognac","Cognin","Cogolin","Coignet","Coignieres","Coimeres","Coincy","Coirac","Coise-Saint-Jean-Pied-Gauthier","Coivrel","Colayrac-Saint-Cirq","Colembert","Coligny","Collandres-Quincarnon","Collegien","Colleret","Colleville","Colleville-Montgomery","Collias","Collioure","Collobrieres","Collonges-les-Premieres","Collonges-sous-Saleve","Collorgues","Colmar","Colmars","Cologne","Colomars","Colombe","Colombelles","Colombes","Colombier","Colombier","Colombier-Fontaine","Colombier-le-Cardinal","Colombier-le-Vieux","Colombier-Saugnieu","Colombieres-sur-Orb","Colombiers","Colomby-sur-Thaon","Colomiers","Colomieu","Colondannes","Colonzelle","Colpo","Coltainville","Combas","Comblanchien","Combloux","Combon","Combourg","Combrand","Combree","Combrit","Combronde","Combs-la-Ville","Comines","Commelle-Vernay","Commenchon","Commensacq","Commentry","Commeny","Commequiers","Commer","Commercy","Commes","Commissey","Communay","Compans","Compertrix","Compolibat","Compreignac","Comps","Concarneau","Conceze","Conches-en-Ouche","Conches-sur-Gondoire","Conchy-les-Pots","Condac","Condat","Condat-sur-Vienne","Conde-en-Brie","Conde-Northen","Conde-Sainte-Libiaire","Conde-sur-Iton","Conde-sur-Marne","Conde-sur-Noireau","Conde-sur-Sarthe","Conde-sur-Suippe","Conde-sur-Vesgre","Conde-sur-Vire","Condecourt","Condeon","Condette","Condezaygues","Condillac","Condom","Condrieu","Conflans-en-Jarnisy","Conflans-Sainte-Honorine","Conflans-sur-Loing","Conflans-sur-Seine","Confolens","Congenies","Conliege","Connantray-Vaurefroy","Conne-de-Labarde","Connerre","Conquereuil","Conques-sur-Orbiel","Cons-Sainte-Colombe","Contamine-sur-Arve","Contes","Contigne","Contoire","Contre","Contres","Contrexeville","Contrisson","Contz-les-Bains","Copponex","Coquelles","Corancez","Coray","Corbara","Corbarieu","Corbas","Corbehem","Corbeil-Cerf","Corbeil-Essonnes","Corbeilles","Corbelin","Corbeny","Corbere-Aberes","Corbere-les-Cabanes","Corbie","Corbieres","Corbieres","Corbigny","Corbonod","Corbreuse","Corcelles-les-Citeaux","Corcelles-les-Monts","Corcieux","Corconne","Corcy","Cordelle","Cordemais","Cordes-sur-Ciel","Cordes-Tolosannes","Cordon","Corenc","Corgnac-sur-lIsle","Corgoloin","Corignac","Corlay","Cormainville","Corme-Ecluse","Corme-Royal","Cormeilles","Cormeilles-en-Parisis","Cormeilles-en-Vexin","Cormelles-le-Royal","Cormeray","Cormery","Cormes","Cormicy","Cormolain","Cormontreuil","Cormoranche-sur-Saone","Cornac","Cornas","Corne","Cornebarrieu","Corneilla-de-Conflent","Corneilla-del-Vercol","Corneilla-la-Riviere","Cornier","Cornille","Cornillon-Confoux","Cornillon-en-Trieves","Cornimont","Cornus","Corny-sur-Moselle","Coron","Corpe","Corps-Nuds","Correze","Corroy","Cors","Corsept","Corseul","Corte","Corveissiat","Corze","Cosges","Cosmes","Cosne-Cours-sur-Loire","Cosqueville","Cosse-le-Vivien","Cossesseville","Costaros","Cotdoussan","Cotignac","Cottenchy","Cottevrard","Cottun","Couargues","Coublevie","Coubon","Coubron","Couches","Couchey","Coucy-le-Chateau-Auffrique","Couddes","Coudehard","Coudekerque-Branche","Coudes","Coudoux","Coudray","Coudray-au-Perche","Coudray-Rabut","Coudroy","Coudun","Coueron","Couesmes-Vauce","Coufouleux","Couhe","Couilly-Pont-aux-Dames","Couiza","Coulaines","Coulandon","Coulans-sur-Gee","Coulaures","Coullons","Coulogne","Couloisy","Coulombiers","Coulombiers","Coulomby","Coulommes","Coulommiers","Coulommiers-la-Tour","Coulon","Coulonces","Coulonges","Coulonges-Thouarsais","Coulounieix-Chamiers","Coulouvray-Boisbenatre","Coulvain","Coulx","Coume","Coupelle-Vieille","Coupesarte","Coupeville","Coupigny","Coupru","Coupvray","Cour-Cheverny","Cour-et-Buis","Cour-sur-Loire","Courances","Courbeveille","Courbevoie","Courcais","Courcay","Courcelles","Courcelles","Courcelles-Chaussy","Courcelles-en-Bassee","Courcelles-Epayelles","Courcelles-les-Gisors","Courcelles-les-Lens","Courcelles-sur-Nied","Courcelles-sur-Seine","Courcelles-sur-Viosne","Courcemont","Courcerac","Courchaton","Courchelettes","Courchevel","Courcon","Courcouronnes","Courcy","Courcy","Courcy-aux-Loges","Courdemanche","Courdemanche","Courdimanche-sur-Essonne","Courgis","Courlans","Courlaoux","Courlay","Courmelles","Courmemin","Cournon","Cournon-dAuvergne","Cournonsec","Cournonterral","Courpalay","Courpiere","Courquetaine","Cours","Cours-de-Monsegur","Cours-la-Ville","Cours-les-Bains","Cours-les-Barres","Coursac","Coursan","Courseulles-sur-Mer","Courson","Courson-les-Carrieres","Courson-Monteloup","Courtelevant","Courtenay","Courtenay","Courtenot","Courteranges","Courthezon","Courtisols","Courtomer","Courtonne-la-Meurdrac","Courtry","Courville-sur-Eure","Courzieu","Cousance","Cousances-les-Forges","Cousolre","Coussay-les-Bois","Coutances","Coutarnoux","Couterne","Couternon","Couteuges","Coutevroult","Coutiches","Coutras","Couvains","Couville","Couvron-et-Aumencourt","Coux","Couy","Couze-et-Saint-Front","Couzeix","Couzon","Coye-la-Foret","Coyriere","Cozes","Crach","Craincourt","Cramant","Cran-Gevrier","Crancey","Crancot","Cransac","Cranves-Sales","Craon","Craonne","Craponne","Cras-sur-Reyssouze","Cravanche","Cravans","Cravant","Cravant-les-Coteaux","Cravent","Crayssac","Crazannes","Creances","Creches-sur-Saone","Crecy-sur-Serre","Credin","Cregy-les-Meaux","Crehange","Crehen","Creil","Creissan","Creissels","Cremeaux","Cremieu","Crepey","Cresancey","Crespieres","Crespin","Crespin","Cressat","Cresse","Cresserons","Crest","Creully","Creusot","Creutzwald","Creuzier-le-Neuf","Creuzier-le-Vieux","Crevant-Laveine","Crevechamps","Crevecoeur-le-Grand","Crevin","Crezancy","Criel-sur-Mer","Crillon-le-Brave","Crimolois","Crisenoy","Crisolles","Crissey","Crissey","Crochte","Crocq","Croisette","Croisilles","Croisilles","Croisilles","Croissanville","Croissy-Beaubourg","Croissy-sur-Celle","Croissy-sur-Seine","Croix","Croix","Croix-Chapeau","Croix-de-Vie","Croix-Mare","Croixanvec","Crolles","Cros-de-Ronesque","Crosne","Crottet","Crouay","Croutelle","Crouttes","Crouy-sur-Cosson","Crouy-sur-Ourcq","Croze","Crozes-Hermitage","Crozon","Cruas","Cruet","Crugny","Cruscades","Cruseilles","Crusnes","Cruzilles-les-Mepillat","Cruzy","Cublac","Cubry-les-Soing","Cubzac-les-Ponts","Cucq","Cucuron","Cuers","Cuffies","Cuffy","Cugand","Cuges-les-Pins","Cugnaux","Cuigy-en-Bray","Cuinchy","Cuincy","Cuinzier","Cuise-la-Motte","Cuiseaux","Cuisery","Culhat","Culmont","Culoz","Cumieres","Cunfin","Cunlhat","Cuon","Cuperly","Cuqueron","Curchy","Curdin","Curel","Curgies","Curtafond","Curzay-sur-Vonne","Cussay","Cusset","Cussey-les-Forges","Cussy-les-Forges","Custines","Cusy","Cuttoli-Corticchiato","Cuvergnon","Cuverville","Cuvilly","Cuvry","Cuxac-Cabardes","Cuy","Cuy-Saint-Fiacre","Cuzieu","Cysoing","Dabo","Dachstein","Dadonville","Dagneux","Dainville","Dalhunden","Dallet","Dalmas","Damazan","Dambach-la-Ville","Dambenois","Dame-Marie","Damelevieres","Damerey","Damery","Damgan","Damiatte","Damigny","Dammarie-les-Lys","Dammarie-sur-Saulx","Dammartin-en-Goele","Dammartin-en-Serve","Damparis","Dampierre","Dampierre-au-Temple","Dampierre-en-Burly","Dampierre-en-Crot","Dampierre-les-Bois","Dampierre-les-Conflans","Dampierre-sur-Blevy","Dampierre-sur-Boutonne","Dampmart","Damprichard","Dampsmesnil","Dampvalley-les-Colombe","Damville","Damvix","Dancevoir","Dangeau","Dangeul","Danjoutin","Danne-et-Quatre-Vents","Dannemoine","Daoulas","Dardilly","Dareize","Dargnies","Dargoire","Darmont","Darnetal","Darney","Darnieulles","Darvoy","Dasle","Daubensand","Daubeuf-la-Campagne","Dauendorf","Daumeray","Daux","Dauzat-sur-Vodable","Davenescourt","Davezieux","Dax","Deauville","Decazeville","Dechy","Decines-Charpieu","Decize","Delettes","Delle","Delme","Demouville","Demuin","Denain","Denat","Denee","Denevre","Denice","Denier","Dennebroeucq","Denneville","Denney","Denting","Dercy","Dernancourt","Derval","Desaignes","Desertines","Desvres","Detrier","Dettwiller","Deuil-la-Barre","Deulemont","Devecey","Devillac","Deville-les-Rouen","Devrouze","Deyme","Deyvillers","Dezize-les-Maranges","Dhuisy","Diarville","Didenheim","Die","Diebling","Dieffenbach-au-Val","Diemeringen","Diemoz","Dienville","Dieppe","Dieppe-sous-Douaumont","Dierre","Dietwiller","Dieue-sur-Meuse","Dieulefit","Dieulouard","Dieupentale","Dieuze","Dieval","Diffembach-les-Hellimer","Diges","Digne-les-Bains","Digoin","Dijon","Dimbsthal","Dimechaux","Dinan","Dinard","Dinge","Dingsheim","Dingy-en-Vuache","Dingy-Saint-Clair","Dinoze","Dionay","Dissay","Disse-sous-Ballon","Distre","Distroff","Dive","Dives-sur-Mer","Divion","Divonne-les-Bains","Dixmont","Dizy","Doazit","Docelles","Doeuil-sur-le-Mignon","Dogneville","Doingt","Doissin","Doix","Dol-de-Bretagne","Dole","Dollon","Dolo","Dolomieu","Domagne","Domaize","Domalain","Domancy","Domart-sur-la-Luce","Domats","Dombasle-sur-Meurthe","Domene","Domerat","Domessargues","Domessin","Domevre-sur-Durbion","Domezain-Berraute","Domfront","Domgermain","Domjevin","Dommartin","Dommartin","Dommartin-les-Remiremont","Dommartin-les-Toul","Domont","Dompierre-les-Ormes","Dompierre-sur-Besbre","Dompierre-sur-Mer","Dompierre-sur-Veyle","Dompierre-sur-Yon","Donchery","Doncourt-les-Conflans","Donges","Donjeux","Donnemarie-Dontilly","Donnery","Donneville","Donnezac","Dontrien","Donville-les-Bains","Donzacq","Donzere","Donzy","Donzy-le-Pertuis","Dordives","Dorlisheim","Dormans","Dormelles","Dornes","Dornot","Dortan","Dorval","Douai","Douarnenez","Doubs","Douchy","Douchy-les-Mines","Doudeville","Doue-la-Fontaine","Douilly","Doulezon","Doullens","Doumy","Dounoux","Dourdain","Dourdan","Dourges","Dourgne","Doussard","Douvaine","Douville","Douvres","Douvres-la-Delivrande","Douvrin","Doux","Douy-la-Ramee","Douzy","Doville","Doyet","Dozule","Drace","Drachenbronn-Birlenbach","Dracy-le-Fort","Draguignan","Draillant","Drain","Drancy","Drap","Draveil","Dreffeac","Dremil-Lafage","Dreslincourt","Dreuil-les-Amiens","Dreux","Dreville","Drocourt","Drom","Droupt-Saint-Basle","Drouville","Druillat","Drulingen","Drusenheim","Druye","Druyes-les-Belles-Fontaines","Dry","Ducey","Duclair","Duerne","Dugny","Dugny-sur-Meuse","Duingt","Duisans","Dullin","Dun-le-Poelier","Dun-sur-Auron","Duneau","Dunes","Duniere","Dunkirk","Duppigheim","Durance","Duranus","Durban-Corbieres","Durcet","Durette","Durfort","Durlinsdorf","Durmenach","Durrenbach","Durrenentzen","Durstel","Durtal","Durtol","Dury","Duttlenheim","Eance","Eaubonne","Eaucourt-sur-Somme","Eaunes","Eaux-Bonnes","Eaux-Puiseaux","Eauze","Ebersviller","Eblange","Ecaillon","Ecalles-Alix","Ecaquelon","Ecardenville-la-Campagne","Ecardenville-sur-Eure","Ecault","Eccles","Echalas","Echarcon","Echauffour","Echavanne","Echemire","Echenans","Echenevex","Echenon","Echenoz-la-Meline","Echevannes","Echevis","Echillais","Echinghen","Echire","Eckbolsheim","Eckwersheim","Eclaron-Braucourt-Sainte-Liviere","Ecleux","Ecluzelles","Ecoche","Ecole","Ecole-Valentin","Ecommoy","Ecorcei","Ecos","Ecouen","Ecouflant","Ecourt-Saint-Quentin","Ecouviez","Ecoyeux","Ecques","Ecquevilly","Ecretteville-les-Baons","Ecrosnes","Ecrouves","Ectot-les-Baons","Ecueil","Ecueille","Ecuelles","Ecuille","Ecuires","Ecuisses","Ecully","Ecury-sur-Coole","Edern","Effiat","Effry","Egletons","Egligny","Egly","Egreville","Eguilles","Eichhoffen","Einville-au-Jard","el Volo","Elbeuf","Eletot","Eleu-dit-Leauwette","Elincourt","Elincourt-Sainte-Marguerite","Elliant","Ellon","Elna","Elnes","Eloise","Eloyes","els Banys de la Presta","Elven","Emance","Embrun","Embry","Emerainville","Emieville","Emmerin","Enchenberg","Enencourt-le-Sec","Enghien-les-Bains","Engins","Englefontaine","Englos","Ennery","Ennery","Ennevelin","Ennezat","Ennordres","Enquin-les-Mines","Ensisheim","Ensues-la-Redonne","Entraigues-sur-la-Sorgue","Entrains-sur-Nohain","Entrammes","Entrange","Entraygues-sur-Truyere","Entre-deux-Guiers","Entrecasteaux","Entremont-le-Vieux","Entressen","Entzheim","Enveig","Envermeu","Epagne-Epagnette","Epagny","Epaignes","Epegard","Epenancourt","Epenede","Epercieux-Saint-Paul","Eperlecques","Epernon","Epertully","Epervans","Epfig","Epiais-Rhus","Epieds-en-Beauce","Epierre","Epinac","Epinay","Epinay-sous-Senart","Epineuil-le-Fleuriel","Epinouze","Epinoy","Episy","Epoisses","Epone","Epouville","Eppe-Sauvage","Eppeville","Epping","Epuisay","Equeurdreville-Hainneville","Equihen-Plage","Er","Eragny","Erbray","Erbree","Erce-en-Lamee","Erce-pres-Liffre","Erceville","Ercheu","Erdeven","Ergersheim","Ergny","Ergue-Gaberic","Erize-Saint-Dizier","Ermenonville","Ermont","Ernee","Ernemont-sur-Buchy","Ernestviller","Ernolsheim-Bruche","Erome","Eroudeville","Erquinghem-Lys","Erquinvillers","Erquy","Erre","Errouville","Erstein","Ervauville","Esbarres","Esbly","Escalquens","Escames","Escassefort","Escaudain","Escaudoeuvres","Escautpont","Escazeaux","Eschau","Eschbach-au-Val","Eschentzwiller","Esches","Esclainvillers","Escolives-Sainte-Camille","Escombres-et-le-Chesnois","Escondeaux","Escorneboeuf","Escou","Escout","Escoutoux","Escurolles","Esery","Eslettes","Esmery-Hallon","Esnandes","Esnouveaux","Espagnac","Espalais","Espalion","Espaly-Saint-Marcel","Esparron-de-Verdon","Espedaillac","Espelette","Espeluche","Espezel","Espiet","Espinasses","Espira-de-Conflent","Espirat","Espondeilhan","Esquay-Notre-Dame","Esquay-sur-Seulles","Esquelbecq","Esquerchin","Esquerdes","Esquibien","Esquieze-Sere","Essegney","Essert","Essertaux","Esserts-Saleve","Essey","Essey-les-Nancy","Essia","Essigny-le-Grand","Esson","Essoyes","Estadens","Estagel","Estaing","Estaires","Esternay","Estevelles","Estillac","Estivareilles","Estouches","Estouteville-Ecalles","Estouy","Estrablin","Estree-Blanche","Estrees","Estrees-les-Crecy","Estrees-Saint-Denis","Estrees-sur-Noye","Esvres","Etable","Etables","Etables-sur-Mer","Etaimpuis","Etaing","Etainhus","Etalondes","Etampes-sur-Marne","Etang-sur-Arroux","Etaules","Etauliers","Etaux","Etaves-et-Bocquiaux","Eteimbes","Etel","Etelfay","Etercy","Eternoz","Eterville","Etevaux","Eth","Etigny","Etiolles","Etival","Etival-Clairefontaine","Etival-les-le-Mans","Etoges","Etoile-sur-Rhone","Etourvy","Etouvans","Etouvy","Etrechy","Etrechy","Etreillers","Etrelles","Etrembieres","Etrepagny","Etrepilly","Etreux","Etrez","Etriac","Etriche","Etricourt-Manancourt","Etroeungt","Etroussat","Ettendorf","Etting","Etupes","Etuz","Etzling","Eu","Eulmont","Euville","Evans","Evenos","Everly","Eveux","Evin-Malmaison","Evran","Evrecy","Evron","Excenevex","Excideuil","Exideuil","Exincourt","Exireuil","Exoudun","Eybens","Eybouleuf","Eygalieres","Eyguieres","Eygurande-et-Gardedeuil","Eyjeaux","Eyliac","Eymet","Eymoutiers","Eyragues","Eyrans","Eysines","Eyzin-Pinet","Ezanville","Eze","Ezy-sur-Eure","Fabregues","Fabrezan","Faches","Faches-Thumesnil","Fagnieres","Faimbe","Fains-Veel","Falaise","Falaise","Falck","Falicon","Fallerans","Falleron","Falletans","Famars","Fameck","Fampoux","Fanjeaux","Faramans","Farbus","Farebersviller","Fareins","Faremoutiers","Farges-les-Chalon","Fargues","Fargues","Fargues-Saint-Hilaire","Farincourt","Fatouville-Grestain","Fauch","Faucigny","Faucogney-et-la-Mer","Faucompierre","Faulquemont","Faulx","Faumont","Fauquembergues","Fauville-en-Caux","Favars","Faverges","Faverges-de-la-Tour","Faverolles-la-Campagne","Faverolles-sur-Cher","Favieres","Favieres","Fay-aux-Loges","Fay-de-Bretagne","Fay-les-Nemours","Fayence","Fayet-le-Chateau","Fayl-Billot","Fays-la-Chapelle","Fayssac","Feas","Fechain","Fegersheim","Fegreac","Feigeres","Feignies","Feillens","Fein","Feissons-sur-Isere","Feldkirch","Felines","Felines","Felix","Fellering","Felletin","Fenain","Fenay","Fendeille","Fenetrange","Feneu","Feneyrols","Fenioux","Fenouillet","Fenouillet","Fere-Champenoise","Fere-en-Tardenois","Ferel","Ferfay","Fericy","Ferin","Fermanville","Ferney-Voltaire","Ferolles-Attilly","Ferques","Ferrals-les-Corbieres","Ferreol","Ferrette","Ferreux-Quincey","Ferriere-la-Grande","Ferriere-la-Petite","Ferriere-Larcon","Ferrieres","Ferrieres","Ferrieres-en-Brie","Ferrieres-en-Gatinais","Ferrieres-Haut-Clocher","Ferrieres-les-Scey","Ferrieres-sur-Ariege","Fesches-le-Chatel","Fesques","Fessenheim","Festieux","Festubert","Feternes","Feucherolles","Feuges","Feuguerolles-sur-Seulles","Feuilla","Feuquieres","Feuquieres-en-Vimeu","Feurs","Feves","Fey","Feytiat","Feyzin","Fiefs","Fiennes","Fierville-Bray","Fierville-les-Mines","Figanieres","Figeac","Fignieres","Filain","Fille","Fillievres","Fillinges","Filstroff","Finhan","Firmi","Firminy","Fislis","Fismes","Fitilieu","Fitz-James","Flagnac","Flamanville","Flamarens","Flancourt-Catelon","Flangebouche","Flaucourt","Flaux","Flavacourt","Flavigny","Flavigny-sur-Moselle","Flavin","Flavy-le-Martel","Flaxlanden","Flayosc","Fleac","Flechin","Flee","Flers","Flers-en-Escrebieux","Flers-sur-Noye","Fletrange","Fletre","Fleurance","Fleurbaix","Fleure","Fleurey-sur-Ouche","Fleurie","Fleuriel","Fleury","Fleury-en-Biere","Fleury-les-Aubrais","Fleury-Merogis","Fleury-sur-Andelle","Fleury-sur-Orne","Fleville-devant-Nancy","Flevy","Flines-les-Mortagne","Flines-lez-Raches","Flins-sur-Seine","Flixecourt","Floing","Floirac","Florac","Florange","Florensac","Florent-en-Argonne","Florentin","Florentin","Floyon","Flumet","Foameix-Ornel","Foecy","Foissiat","Foix","Folelli","Folembray","Folgensbourg","Follainville-Dennemont","Folles","Folleville","Folschviller","Fonbeauzard","Foncine-le-Haut","Fondettes","Fons","Fons","Fonsorbes","Font-Romeu-Odeillo-Via","Fontain","Fontaine","Fontaine","Fontaine-au-Bois","Fontaine-Bonneleau","Fontaine-en-Dormois","Fontaine-Etoupefour","Fontaine-Guerin","Fontaine-Heudebourg","Fontaine-la-Mallet","Fontaine-le-Comte","Fontaine-le-Dun","Fontaine-le-Pin","Fontaine-les-Bassets","Fontaine-les-Dijon","Fontaine-les-Gres","Fontaine-les-Luxeuil","Fontaine-Milon","Fontaine-Notre-Dame","Fontaine-Notre-Dame","Fontaine-Simon","Fontaine-sous-Jouy","Fontaine-sous-Preaux","Fontaine-sur-Somme","Fontaine-Uterte","Fontainebleau","Fontaines","Fontaines","Fontaines-Saint-Martin","Fontaines-sur-Saone","Fontanes","Fontanil-Cornillon","Fontannes","Fontcouverte","Fontenai-les-Louvets","Fontenay","Fontenay-aux-Roses","Fontenay-en-Parisis","Fontenay-le-Comte","Fontenay-le-Fleury","Fontenay-le-Vicomte","Fontenay-sous-Bois","Fontenay-sur-Loing","Fontenay-sur-Vegre","Fontenay-Tresigny","Fontenelle-en-Brie","Fontenilles","Fontenoy","Fontenoy-la-Joute","Fontenoy-le-Chateau","Fontes","Fontjoncouse","Fontpedrosa","Fontrabiouse","Fontvannes","Fontvieille","Forbach","Forcalqueiret","Forcalquier","Force","Forest-sur-Marque","Foret-la-Folie","Forfry","Forges","Forges-les-Bains","Forges-les-Eaux","Forleans","Formerie","Fors","Fort-Mahon-Plage","Fort-Mardyck","Fortschwihr","Fos-sur-Mer","Fosse","Fossemanant","Fosses","Fosses-et-Baleyssac","Fouchy","Fouday","Fouencamps","Fouesnant","Foug","Fougax-et-Barrineuf","Fougere","Fougeres","Fougeres","Fougeres-sur-Bievre","Fougerolles","Fouillard","Fouilleuse","Foulangues","Foulayronnes","Foulcrey","Fouquebrune","Fouquieres-les-Lens","Four","Fouras","Fourchambault","Fourches","Fourdrinoy","Fourg","Fourmies","Fournes-en-Weppes","Fournier","Fournival","Fournols","Fouronnes","Fourques","Fourques-sur-Garonne","Fourqueux","Fours-Saint-Laurent","Foussemagne","Fragnes","Fraisans","Fraisses","Fraize","Fralignes","Frambouhans","Framerville-Rainecourt","Francaltroff","Francardo","Francheleins","Francheville","Francieres","Franclens","Francois","Franconville","Francourville","Frangy","Franois","Franqueville","Franvillers","Franxault","Frauenberg","Frebuans","Frechede","Frechencourt","Frechou","Fredille","Fregimont","Fregouville","Freistroff","Frejairolles","Freland","Frelinghien","Fremainville","Fremifontaine","Fremonville","Frencq","Frenes","Freneuse","Frepillon","Fresnay-en-Retz","Fresnay-le-Gilmert","Fresnay-sur-Sarthe","Fresne","Fresne-Cauverville","Fresne-la-Mere","Fresne-Saint-Mames","Fresneaux-Montchevreuil","Fresnes","Fresnes-au-Mont","Fresnes-en-Woevre","Fresnes-les-Montauban","Fresnes-sur-Escaut","Fresnes-sur-Marne","Fresnicourt-le-Dolmen","Fresnoy-la-Riviere","Fresnoy-le-Grand","Frespech","Fressac","Fressain","Fresse","Fresse-sur-Moselle","Fressenneville","Fressies","Fressines","Frethun","Fretigney-et-Velloreille","Fretin","Frevent","Frevillers","Frevin-Capelle","Friauville","Frieres-Faillouel","Friesen","Friville-Escarbotin","Frocourt","Froges","Froidestrees","Froidfond","Froissy","Fromelles","Fromont","Fromonville","Froncles","Fronsac","Frontenac","Frontenas","Frontenay-Rohan-Rohan","Frontenay-sur-Dive","Frontenex","Frontignan","Frontignan-Saves","Fronton","Frontonas","Frossay","Frouard","Frouzins","Frozes","Frucourt","Frugeres-les-Mines","Fruges","Fuisse","Fultot","Fumay","Fumel","Furchhausen","Furiani","Fussy","Fuveau","Fye","Gaas","Gabaston","Gabat","Gace","Gagnac-sur-Garonne","Gagnieres","Gagny","Gahard","Gailhan","Gaillac","Gaillac-Toulza","Gaillan-en-Medoc","Gaillard","Gaillefontaine","Gaillon","Galametz","Galapian","Galargues","Galfingue","Galgon","Galie","Gallardon","Gallician","Galluis","Gamaches","Gamarde-les-Bains","Gambais","Gambsheim","Gan","Ganac","Gandrange","Ganges","Gannat","Gap","Garancieres-en-Drouais","Garanou","Garat","Garche","Garches","Garchizy","Gardanne","Gardonne","Garencieres","Garennes-sur-Eure","Gareoult","Gargenville","Garlan","Garlin","Garons","Garrevaques","Garrigues","Garris","Garrosse","Gas","Gasny","Gassin","Gasville-Oiseme","Gatelles","Gatey","Gattieres","Gauchy","Gauciel","Gauriac","Gauriaguet","Gauville-la-Campagne","Gavarnie","Gavray","Gaye","Geanges","Geaune","Geay","Gee","Geispolsheim","Gelannes","Gelles","Gelos","Geloux","Gemeaux","Gemenos","Gemil","Gemozac","Genac","Genas","Genay","Gencay","Gendrey","Gene","Genebrieres","Genech","Genelard","Generac","Generargues","Genet","Geneuille","Geney","Genille","Genis","Genissac","Genissiat","Genissieux","Genlis","Gennes","Gennes-sur-Seiche","Gennetines","Gennevilliers","Gensac","Gensac-la-Pallue","Gente","Gentilly","Georges","Geovreisset","Ger","Ger","Gerard","Gerbaix","Gerbecourt-et-Haplemont","Gerbeviller","Gergy","Gerland","Germaine","Germainville","Germenay","Germigny-sur-Loire","Germond-Rouvre","Gerstheim","Gervais","Gervans","Gerzat","Gesnes-le-Gandelin","Geste","Gestel","Gesvres","Getigne","Geudertheim","Geveze","Gevrey-Chambertin","Gevrieux","Gex","Geyssans","Gezaincourt","Gezoncourt","Ghisonaccia","Ghyvelde","Giat","Giberville","Gidy","Gien","Gieres","Gievres","Gif-sur-Yvette","Gigean","Gignac","Gignac","Gignac-la-Nerthe","Gigny-sur-Saone","Gilette","Gilles","Gilley","Gilly-les-Citeaux","Gilly-sur-Isere","Gimbrett","Gimeux","Gimont","Ginasservis","Ginestas","Ginestet","Girancourt","Giraumont","Girolles","Giromagny","Giron","Gironcourt-sur-Vraine","Gironde-sur-Dropt","Giroussens","Gisors","Givenchy-en-Gohelle","Givet","Givors","Givraines","Givrand","Givrauval","Givron","Givry","Glanon","Glatigny","Gleize","Glenic","Glomel","Glos-sur-Risle","Goderville","Godewaersvelde","Goersdorf","Goes","Goetzenbruck","Goeulzin","Goin","Goincourt","Golbey","Golfe-Juan","Gombergean","Gomelange","Gomene","Gomer","Gometz-la-Ville","Gometz-le-Chatel","Gommegnies","Gommerville","Gommerville","Goncelin","Gondecourt","Gondeville","Gondrecourt-le-Chateau","Gondreville","Gonesse","Gonfaron","Gonfreville-Caillot","Gonfreville-lOrcher","Gonnehem","Gonneville-la-Mallet","Gonneville-sur-Mer","Gontier","Gorbio","Gorcy","Gordes","Gorges","Gornac","Gorre","Gorron","Gorze","Gosnay","Gosselming","Gottenhouse","Gouaix","Gouaux","Goudelin","Goudourville","Gouesnach","Gouesnou","Gouezec","Gouillons","Gouise","Goulet","Goult","Goupillieres","Goupillieres","Gourdan-Polignan","Gourdon","Gourge","Gourhel","Gourin","Gourlizon","Gournay-en-Bray","Gournay-sur-Marne","Gourvillette","Goury","Goussainville","Goussainville","Gousse","Goutrens","Gouts","Gouttieres","Gouvernes","Gouves","Gouvieux","Gouville-sur-Mer","Goux-les-Dambelin","Goux-les-Usiers","Gouy-en-Artois","Gouy-en-Ternois","Gouy-Saint-Andre","Gouy-sous-Bellonne","Gouze","Gouzeaucourt","Goven","Goxwiller","Goyrans","Grabels","Gracay","Graces","Gradignan","Gragnague","Graincourt-les-Havrincourt","Grainville","Grainville-la-Teinturiere","Grainville-sur-Odon","Graissessac","Gramat","Grammond","Grand","Grand Champ","Grand-Auverne","Grand-Charmont","Grand-Fort-Philippe","Grand-Fougeray","Grand-Laviers","Grand-Rozoy","Grandchamp","Grandchamps-des-Fontaines","Grande-Synthe","Grandfontaine","Grandfontaine-Fournets","Grandfresnoy","Grandpre","Grandris","Grandsaigne","Grandvaux","Grandvillars","Grandville-Gaudreville","Grandvillers","Grandvilliers","Grane","Granges","Granges-le-Bourg","Granges-sur-Vologne","Grangues","Grans","Granville","Grasse","Grassendorf","Gratentour","Gratot","Graulhet","Grauves","Gravelines","Graveron-Semerville","Graveson","Gravigny","Gray","Grazac","Grazay","Greasque","Gremecey","Gremevillers","Gremonville","Grenade","Grenay","Greneville-en-Beauce","Grenoble","Grentheville","Grentzingen","Greolieres","Greoux-les-Bains","Grepiac","Gresse-en-Vercors","Gresswiller","Gressy","Gresy-sur-Aix","Gresy-sur-Isere","Gretz-Armainvilliers","Grez-en-Bouere","Grez-sur-Loing","Grezieu-la-Varenne","Grezillac","Grezolles","Gries","Griesbach-au-Val","Griesheim-pres-Molsheim","Grignan","Grignols","Grigny","Grigny","Grillon","Grilly","Grimaud","Gripport","Griselles","Griselles","Grisolles","Grisy-Suisnes","Grisy-sur-Seine","Grivillers","Groffliers","Groissiat","Groisy","Groix","Gron","Gros-Rederching","Grosbliederstroff","Grosbreuil","Groslay","Grosrouvre","Grosseto-Prugna","Grossoeuvre","Grozon","Gruchet-le-Valasse","Gruey-les-Surance","Gruffy","Grugies","Gruissan","Grun-Bordas","Grundviller","Gruson","Grussenheim","Guebwiller","Guecelard","Guegon","Guemar","Guemene-Penfao","Guemene-sur-Scorff","Guenange","Guengat","Guenin","Guenrouet","Guer","Guerande","Guerard","Guercheville","Gueret","Guerigny","Guerlesquin","Guernes","Guerting","Guerville","Guerville","Guesnain","Guessling-Hemering","Guethary","Gueugnon","Gueures","Gueux","Guewenheim","Guiche","Guichen","Guiclan","Guidel","Guignen","Guignes","Guigneville","Guignicourt","Guignicourt-sur-Vence","Guiler-sur-Goyen","Guilers","Guilherand-Granges","Guillestre","Guilliers","Guilly","Guilvinec","Guines","Guingamp","Guipavas","Guipel","Guipronvel","Guipry","Guiscard","Guise","Guiseniers","Guitalens","Guivry","Gujan-Mestras","Gumbrechtshoffen","Gundershoffen","Gundolsheim","Guntzviller","Guny","Gurs","Guyancourt","Gy-en-Sologne","Habas","Habere-Lullin","Habsheim","Hadol","Hagenbach","Hagenthal-le-Haut","Hagetmau","Hageville","Hagondange","Haguenau","Haillicourt","Haironville","Haisnes","Hallencourt","Hallennes-lez-Haubourdin","Hallering","Hallines","Halloy-les-Pernois","Halluin","Ham","Ham-en-Artois","Ham-sous-Varsberg","Ham-sur-Meuse","Hamars","Hambach","Hambers","Hamel","Hammeville","Han-sur-Nied","Hanches","Hangenbieten","Hangest-en-Santerre","Hannogne-Saint-Martin","Hantay","Hanvec","Happonvilliers","Haramont","Haraucourt","Haraucourt","Harbonnieres","Harcanville","Harcigny","Harcourt","Hardelot-Plage","Hardencourt","Hardifort","Hardinvast","Harfleur","Hargicourt","Hargnies","Harnes","Haroue","Harprich","Harreberg","Harreville-les-Chanteurs","Harskirchen","Hartmannswiller","Hary","Hasnon","Hasparren","Haspres","Hastingues","Hatten","Hattenville","Hattstatt","Haubourdin","Hauconcourt","Haucourt-Moulaine","Haudiomont","Haudivillers","Haulchin","Haussignemont","Haussimont","Haussy","Haut-Clocher","Haute-Goulaine","Haute-Isle","Haute-Rivoire","Haute-Vigneulles","Hautecloque","Hautefage-la-Tour","Hautefort","Hauteluce","Hauterive","Hauterive","Hauterives","Hauteville-les-Dijon","Hauteville-Lompnes","Hauteville-sur-Mer","Hautmont","Hautot-sur-Mer","Hautvillers","Hautvillers-Ouville","Haveluy","Haverskerque","Havrincourt","Hayange","Haybes","Hazebrouck","Hebecourt","Hebecrevon","Hebuterne","Hede-Bazouges","Hegenheim","Heidwiller","Heiligenberg","Heillecourt","Heilly","Heimersdorf","Heimsbrunn","Heiteren","Helesmes","Helette","Helfaut","Hellemmes-Lille","Hellimer","Hem","Hemevillers","Heming","Hemonstoir","Henansal","Hendaye","Henin-Beaumont","Henin-sur-Cojeul","Hennebont","Henon","Henonville","Henouville","Henrichemont","Henridorff","Henvic","Herbeys","Herbignac","Herblay","Herchies","Herepian","Heres","Hergnies","Heric","Hericourt","Hericy","Herimoncourt","Herin","Herisson","Herlies","Hermanville-sur-Mer","Hermelange","Hermeray","Hermes","Hermies","Hermillon","Herny","Herouvillette","Herrlisheim-pres-Colmar","Herserange","Hersin-Coupigny","Hery-sur-Alby","Herzeele","Hesdin","Hesingue","Hestrus","Hettange-Grande","Heuchin","Heudebouville","Heudicourt","Heudicourt-sous-les-Cotes","Heudreville-sur-Eure","Heugas","Heuqueville","Heurtevent","Heutregiville","Heyrieux","Higueres-Souye","Hilbesheim","Hillion","Hindlingen","Hinges","Hipsheim","Hirel","Hirsingue","Hirson","Hochfelden","Hochstatt","Hocquigny","Hodenc-en-Bray","Hodeng-Hodenger","Hoenheim","Hoerdt","Hohfrankenheim","Hohwiller","Holnon","Holtzheim","Holtzwihr","Holving","Hombleux","Homblieres","Hombourg","Hombourg-Budange","Hombourg-Haut","Homecourt","Homps","Hon-Hergies","Hondeghem","Hondouville","Hondschoote","Honfleur","Honnecourt-sur-Escaut","Hopital-Camfrout","Horbourg-Wihr","Hordain","Horgues","Hornaing","Hossegor","Houchin","Houdain-lez-Bavay","Houdan","Houdelmont","Houdemont","Houeilles","Houilles","Houlbec-Cocherel","Houlette","Houlgate","Houlle","Houplin-Ancoisne","Houplines","Houppeville","Hourtin","Houry","Houssen","Housseville","Houville-la-Branche","Houx","Hoymille","Hubersent","Huberville","Huchenneville","Hucqueliers","Hudimesnil","Huelgoat","Huest","Huez","Hugier","Huiron","Huisseau-sur-Cosson","Huisseau-sur-Mauves","Hulluch","Hultehouse","Hundling","Hundsbach","Huningue","Hunspach","Huppy","Hure","Huriel","Hurigny","Husseren-les-Chateaux","Husseren-Wesserling","Hussigny-Godbrange","Huttenheim","Hyemondans","Idrac-Respailles","Idron","Iffendic","Ifs","Igney","Igny","Igon","Igoville","Illange","Ille-sur-Tet","Illfurth","Illhaeusern","Illiat","Illiers-Combray","Illifaut","Illkirch-Graffenstaden","Illois","Illzach","Imling","Imphy","Incheville","Inchy","Indre","Ingersheim","Ingolsheim","Ingrandes","Ingre","Inguiniel","Ingwiller","Innenheim","Inxent","Ippling","Irai","Irancy","Irigny","Irissarry","Irodouer","Irouleguy","Irreville","Is-sur-Tille","Isbergues","Isches","Isigny-le-Buat","Isigny-sur-Mer","Isle","Isle-et-Bardais","Isles-les-Villenoy","Isneauville","Isola","Ispoure","Isques","Issancourt-et-Rumel","Issenhausen","Issenheim","Issoire","Issou","Issoudun","Issus","Issy-les-Moulineaux","Istres","Itancourt","Iteuil","Ittenheim","Itteville","Itxassou","Iville","Ivoy-le-Pre","Ivry-la-Bataille","Ivry-le-Temple","Ivry-sur-Seine","Iwuy","Izeaux","Izernore","Izeron","Izier","Izon","Izotges","Jabreilles-les-Bordes","Jacob-Bellecombette","Jacou","Jainvillotte","Jallais","Jallans","Jallerange","Jalognes","Jalogny","Jalons","Jambles","Jametz","Jandun","Janneyrias","Janville","Janville","Janville-sur-Juine","Janvilliers","Janvry","Janze","Jarcieu","Jard-sur-Mer","Jardin","Jardres","Jargeau","Jarmenil","Jarnac-Champagne","Jarnages","Jarny","Jarrie","Jarrier","Jars","Jarville-la-Malgrange","Jarze","Jassans-Riottier","Jasseron","Jaucourt","Jaujac","Jaunay-Clan","Jaure","Jausiers","Jaux","Javene","Javrezac","Jayat","Jazeneuil","Jeandelaincourt","Jeanmenil","Jebsheim","Jegun","Jenlain","Jesonville","Jettingen","Jeu-les-Bois","Jeufosse","Jeumont","Jeune","Jeurre","Jeux-les-Bard","Jeuxey","Jezainville","Job","Jobourg","Joch","Joeuf","Joigny","Joigny-sur-Meuse","Joinville","Joinville-le-Pont","Jolimetz","Jolivet","Jonage","Jonchery-sur-Vesle","Joncourt","Jonquerets-de-Livet","Jonquerettes","Jonquieres","Jonquieres","Jonquieres","Jons","Jonvelle","Jonvilliers","Jonzac","Jonzier-Epagny","Jonzieux","Josnes","Josse","Josselin","Jossigny","Jouarre","Jouars-Pontchartrain","Jouaville","Joudreville","Joue-sur-Erdre","Jougne","Jouhet","Jouques","Journans","Journiac","Journy","Joux","Jouy-en-Josas","Jouy-le-Chatel","Jouy-le-Moutier","Jouy-le-Potier","Jouy-sous-Thelle","Jouy-sur-Eure","Jouy-sur-Morin","Juan-les-Pins","Jugeals-Nazareth","Jugon-les-Lacs","Juigne-sur-Loire","Juigne-sur-Sarthe","Juillac","Juillan","Juilles","Juilly","Juilly","Jujurieux","Julienas","Julienne","Jully-sur-Sarce","Jumeauville","Jumelles","Jumelles","Jumilhac-le-Grand","Junay","Jungholtz","Juniville","Jupilles","Jurancon","Jury","Jussey","Jussy","Jussy","Juvaincourt","Juvignac","Juvigny","Juvigny","Juvigny-en-Perthois","Juville","Juvisy-sur-Orge","Juziers","Kaltenhouse","Kappelen","Katzenthal","Kaysersberg","Kedange-sur-Canner","Kembs","Kerbach","Kerfot","Kerfourn","Kergloff","Kerien","Kerity","Kerlaz","Kerlouan","Kernascleden","Kerpert","Kervignac","Kesseldorf","Kienheim","Kientzheim","Killem","Kilstett","Kingersheim","Kintzheim","Knutange","Koenigsmacker","Koeur-la-Petite","Krafft","Krautergersheim","Kriegsheim","Kruth","Kunheim","Kuntzig","Kurtzenhouse","Kutzenhausen","La Baconniere","La Barben","La Barre-de-Monts","La Barre-en-Ouche","La Barthe","La Bassee","La Bastide","La Bastide","La Bastide","La Bathie","La Batie","La Baule-Escoublac","La Baume-de-Transit","La Baussaine","La Bazoche-Gouet","La Bazoge","La Begue","La Bernerie-en-Retz","La Berthenoux","La Bigne","La Biolle","La Bohalle","La Boissiere-des-Landes","La Bosse","La Bosse-de-Bretagne","La Bouexiere","La Bouilladisse","La Bourboule","La Bourgonce","La Boussac","La Bresse","La Bretonne","La Bridoire","La Brigue","La Brillanne","La Broque","La Brosse","La Bruffiere","La Brulatte","La Buisse","La Buissiere","La Bussiere","La Calmette","La Calotterie","La Canourgue","La Capelle","La Caunette","La Cavalerie","La Celle","La Celle","La Celle","La Celle-Saint-Cloud","La Celle-sous-Montmirail","La Celle-sur-Seine","La Cerlangue","La Chaise","La Chaise","La Chaise-Baudouin","La Chaize-le-Vicomte","La Chapelaude","La Chapelle","La Chapelle-aux-Bois","La Chapelle-aux-Lys","La Chapelle-Baton","La Chapelle-Blanche","La Chapelle-de-Brain","La Chapelle-de-Guinchay","La Chapelle-en-Vercors","La Chapelle-Gaudin","La Chapelle-Gauthier","La Chapelle-Heulin","La Chapelle-Laurent","La Chapelle-Montligeon","La Chapelle-Orthemale","La Chapelle-Saint-Luc","La Chapelle-sur-Chezy","La Chapelle-Yvon","La Charme","La Charmee","La Chartre-sur-le-Loir","La Chataigneraie","La Chatre","La Chatre-Langlin","La Chaumusse","La Chaussaire","La Chaussee","La Chaux-du-Dombief","La Cheneviere","La Chevallerais","La Chevroliere","La Ciotat","La Clayette","La Clisse","La Clotte","La Clusaz","La Cluse-et-Mijoux","La Colle-sur-Loup","La Combelle","La Copechagniere","La Coquille","La Cornuaille","La Cote","La Cote","La Couarde-sur-Mer","La Coucourde","La Coudre","La Coulonche","La Courneuve","La Couronne","La Couronne","La Couture-Boussey","La Crau","La Croix-Valmer","La Cropte","La Dagueniere","La Defense","La Destrousse","La Dominelais","La Fare-en-Champsaur","La Farlede","La Faute-sur-Mer","La Faye","La Fere","La Ferriere","La Ferriere-Bochard","La Ferte","La Ferte-Alais","La Ferte-Mace","La Ferte-Milon","La Ferte-Saint-Cyr","La Ferte-Saint-Samson","La Ferte-sous-Jouarre","La Feuillade","La Feuillie","La Feuillie","La Flachere","La Fleche","La Flocelliere","La Flotte","La Force","La Forest-Landerneau","La Foret","La Foret","La Foret-Fouesnant","La Forie","La Fouillade","La Fouillouse","La Foux","La Foye-Monjault","La Frasse","La Frenaye","La Fresnais","La Frette","La Frette","La Frette-sur-Seine","La Gacilly","La Gaillarde","La Gaillarde","La Garde","La Garde","La Garenne","La Garenne-Colombes","La Garnache","La Gaubretiere","La Gaude","La Gavotte","La Glacerie","La Gorgue","La Gouesniere","La Grand-Croix","La Grande-Motte","La Grandville","La Grave","La Graverie","La Gree-Saint-Laurent","La Greve-sur-Mignon","La Grigonnais","La Groise","La Guerche","La Guerche-de-Bretagne","La Gueroulde","La Guierche","La Guyonniere","La Haie","La Halle","La Hallotiere","La Haye","La Haye-Saint-Sylvestre","La Houblonniere","La Houssaye-en-Brie","La Houssoye","La Jaille-Yvon","La Jarne","La Jarrie","La Jubaudiere","La Jumelliere","La Laigne","La Lande","La Lande","La Landec","La Laupie","La Lechere","La Limouziniere","La Liviniere","La Londe","La Londe-les-Maures","La Loubiere","La Loupe","La Lucerne-dOutremer","La Machine","La Madeleine","La Madeleine","La Madeleine-sur-Loing","La Magdelaine-sur-Tarn","La Mailleraye-sur-Seine","La Malhoure","La Marche","La Marolle-en-Sologne","La Martiniere","La Maxe","La Meauffe","La Meaugon","La Meignanne","La Meilleraie-Tillay","La Meilleraye-de-Bretagne","La Membrolle-sur-Choisille","La Membrolle-sur-Longuenee","La Menitre","La Meziere","La Milesse","La Montagne","La Montagne","La Montagne","La Mothe-Saint-Heray","La Motte","La Motte-Chalancon","La Motte-du-Caire","La Motte-Fouquet","La Motte-Saint-Jean","La Motte-Saint-Martin","La Motte-Servolex","La Mulatiere","La Muraz","La Mure","La Napoule","La Nerthe","La Neuveville-devant-Lepanges","La Neuville-du-Bosc","La Noe","La Norville","La Palud","La Paute","La Penne-sur-Huveaune","La Perche","La Place","La Plagne","La Plaine","La Plaine","La Plaine-Saint-Denis","La Planche","La Plane","La Pointe","La Poiteviniere","La Pommeraye","La Porcherie","La Porte","La Possonniere","La Poste","La Poterie","La Poterie-Mathieu","La Poueze","La Puye","La Queue-en-Brie","La Queue-les-Yvelines","La Ravoire","La Remuee","La Renaudiere","La Reole","La Reorthe","La Ricamarie","La Richardais","La Riche","La Riviere","La Riviere","La Riviere","La Riviere","La Riviere-de-Corps","La Rixouse","La Roche","La Roche","La Roche","La Roche","La Roche-Blanche","La Roche-des-Arnauds","La Roche-sur-le-Buis","La Roche-sur-Yon","La Rochefoucauld","La Rochegiron","La Rochelle","La Rochenard","La Rochette","La Rochette","La Rochette-sur-Crest","La Romagne","La Ronde","La Roque-Baignard","La Roquebrussanne","La Roquette-sur-Siagne","La Rouine","La Rouquette","La Rouviere","La Salette-Fallavaux","La Salle-de-Vihiers","La Salvetat-Lauragais","La Salvetat-Saint-Gilles","La Salvetat-sur-Agout","La Saulce","La Sauve","La Sauvetat-de-Saveres","La Seauve-sur-Semene","La Seguiniere","La Selle-en-Hermoy","La Selve","La Sentinelle","La Seyne-sur-Mer","La Sone","La Souche","La Souterraine","La Suze-sur-Sarthe","La Tagniere","La Taillee","La Talaudiere","La Tardiere","La Terrasse","La Tessoualle","La Teste-de-Buch","La Tour","La Tour","La Tour-dAuvergne","La Tour-de-Scay","La Tour-du-Crieu","La Tour-Saint-Gelin","La Tour-sur-Orb","La Tourette","La Tranche-sur-Mer","La Treille","La Tremblade","La Trimouille","La Trinite","La Trinite-de-Reville","La Tronche","La Tuiliere","La Turballe","La Turbie","La Vacherie","La Valette-du-Var","La Vallee de Dormelles","La Varenne","La Varenne","La Vaupaliere","La Verpilliere","La Verrie","La Verriere","La Vespiere","La Veze","La Ville","La Ville aux Chiens","La Ville-aux-Bois","La Villedieu","La Villedieu-les-Quenoche","La Villeneuve","La Villetelle","La Voulte-sur-Rhone","La Vraie-Croix","La Walck","La Wantzenau","Laas","Labaroche","Labarthe-sur-Leze","Labastide-Beauvoir","Labastide-Cezeracq","Labastide-dArmagnac","Labastide-de-Virac","Labastide-Gabausse","Labastide-Rouairoux","Labastide-Saint-Pierre","Labastidette","Labatut","Labege","Labenne","Labessiere-Candeil","Labeuvriere","Lablachere","Labouheyre","Labouquerie","Labourse","Labretonie","Labruguiere","Labruyere","Labry","Labuissiere","Lacabarede","Lacadee","Lacanau","Lacapelle-Cabanac","Lacapelle-Marival","Lacapelle-Viescamp","Lacaune","Lacaussade","Lachapelle","Lachapelle-sous-Chaux","Lachapelle-sous-Rougemont","Lachaux","Lacour","Lacq","Lacroix-Falgarde","Lacroix-Saint-Ouen","Lacroix-sur-Meuse","Lacrost","Lacs","Ladoix-Serrigny","Ladon","Laduz","Lafare","Lafeuillade-en-Vezie","Lafitole","Lafox","Lagardelle-sur-Leze","Lagardere","Lagarrigue","Lagnes","Lagnieu","Lagny-le-Sec","Lagor","Lagord","Lagrave","Laguenne","Laguiole","Lagupie","Lahitte-Toupiere","Lahonce","Lahontan","Lahosse","Lahourcade","Laifour","Laigne","Laigne-en-Belin","Laignelet","Laignes","Laigneville","LAiguillon-sur-Mer","Laille","Lailly-en-Val","Lainsecq","Laissac","Laissaud","Laissey","Laiz","Laize","Lalanne-Arque","Lalbenque","Laleu","Lalinde","Lallaing","Lalonquette","Laloubere","Lamagdelaine","Lamagistere","Lamaire","Lamalou-les-Bains","Lamanon","Lamarche","Lamarche-sur-Saone","Lamastre","Lamativie","Lamaziere-Basse","Lamballe","Lambersart","Lambert","Lambesc","Lambres-lez-Douai","Lamnay","Lamorlaye","Lamorville","Lamothe-Landerron","Lamothe-Montravel","Lamotte-Beuvron","Lampaul-Guimiliau","Lampaul-Plouarzel","Lampertheim","Lampertsloch","Lancey","Lancie","Lancieux","Lancon-Provence","Lancrans","Landas","Landebia","Landeda","Landelles","Landelles-et-Coupigny","Landemont","Landepereuse","Landerneau","Landeronde","Landes","Landevant","Landevieille","Landivisiau","Landogne","Landos","Landrecies","Landres","Landrethun-le-Nord","Landrethun-les-Ardres","Landrevarzec","Landry","Landser","Landujan","Landunvez","Lanester","Laneuvelotte","Laneuveville-aux-Bois","Laneuveville-devant-Bayon","Laneuveville-devant-Nancy","Langan","Langeac","Langeais","Langensoultzbach","Langlade","Langoat","Langoelan","Langoiran","Langolen","Langon","Langon","Langonnet","Langourla","Langres","Langrune-sur-Mer","Langueux","Languidic","Lanhelin","Laning","Lanleff","Lanmerin","Lanmeur","Lanne","Lanne-en-Baretous","Lannebert","Lannemezan","Lannilis","Lannion","Lannoy","Lannoy-Cuillere","Lanobre","Lanouee","Lanrelas","Lanrodec","Lans","Lans-en-Vercors","Lansac","Lansargues","Lanta","Lantenne-Vertiere","Lanthenans","Lantignie","Lantilly","Lanton","Lantriac","Lanvallay","Lanvaudan","Lanveoc","Lanvollon","Lanzac","Laon","Lapalisse","Lapalme","Lapalud","Laparrouquial","Lapenche","Laperriere-sur-Saone","Lapeyrouse-Fossat","Lapeyrouse-Mornay","Lapoutroie","Lapouyade","Lapte","Lapugnoy","Laquenexy","Laqueuille","Laragne-Monteglin","LArbresle","Larcay","Larchant","Larche","Lardy","Largeasse","Largillay-Marsonnay","Lariviere-Arnoncourt","Larmor-Baden","Larmor-Plage","Laroche-Saint-Cydroine","Laroin","Laroque-de-Fa","Larrazet","Larressore","Larriviere-Saint-Savin","Laruns","Larzicourt","Lasalle","Lasbordes","Lassay-les-Chateaux","Lassay-sur-Croisne","Lasseran","Lasserre","Lasseube","Lassigny","Lasson","Lassy","Lastic","Lathuile","Latille","Latour","Latour-Bas-Elne","Latresne","Latronquiere","Lattainville","Lattes","Lattre-Saint-Quentin","Laudun-lArdoise","Laugnac","Launaguet","Launay","Laurabuc","Laure","Laurede","Laurenan","Laurens","Laurent","Lauret","Lauris","Laussonne","Lautenbach","Lauterbourg","Lautrec","Lauzerte","Lauzerville","Lauzun","Laval","Laval-sur-Doulon","Laval-sur-Vologne","Lavannes","Lavans-les-Saint-Claude","Lavans-Vuillafans","Lavardac","Lavardens","Lavardin","Lavardin","Lavau","Lavaur","Lavaur","Lavaurette","Lavelanet","Laventie","Lavergne","Lavernose-Lacasse","Laversine","Laversines","Laverune","Lavit","Lavours","Lavoute-Chilhac","Laxou","Laye","Layrac","Layrisse","Le Baizil","Le Ban-Saint-Martin","Le Bar-sur-Loup","Le Barboux","Le Barcares","Le Bardon","Le Barp","Le Beausset","Le Bernard","Le Bessat","Le Bez","Le Bignon","Le Blanc","Le Blanc-Mesnil","Le Bleymard","Le Bocasse","Le Bois","Le Bois-Plage-en-Re","Le Bonhomme","Le Bono","Le Bosc","Le Bosc-Roger-en-Roumois","Le Bouchage","Le Boulay-Morin","Le Boupere","Le Bourg","Le Bourget","Le Bourget","Le Bourgneuf-la-Foret","Le Bouscat","Le Bousquet","Le Breil","Le Breuil","Le Breuil","Le Breuil","Le Breuil","Le Breuil-sur-Couze","Le Broc","Le Broc","Le Brugeron","Le Buisson-de-Cadouin","Le Cailar","Le Cannet","Le Castellet","Le Castera","Le Cateau-Cambresis","Le Caylar","Le Cellier","Le Cendre","Le Cergne","Le Chambon","Le Chambon","Le Chambon","Le Champ-pres-Froges","Le Champ-Saint-Pere","Le Chateau","Le Chateau Gaillard","Le Chatel","Le Chatelard","Le Chatelet-en-Brie","Le Chatelet-sur-Retourne","Le Chaylard","Le Chesnay","Le Chesne","Le Cheylas","Le Collet-de-Deze","Le Comte","Le Conquet","Le Coteau","Le Coudray","Le Coudray-Baillet","Le Coudray-Montceaux","Le Cres","Le Crest","Le Creusot","Le Croisic","Le Crotoy","Le Deluge","Le Deschaux","Le Dezert","Le Donjon","Le Dorat","Le Doulieu","Le Falgoux","Le Faou","Le Faouet","Le Fayet","Le Fenouiller","Le Ferre","Le Fidelaire","Le Fief-Sauvin","Le Foeil","Le Folgoet","Le Fossat","Le Fousseret","Le Fraysse","Le Fresne-Camilly","Le Fuilet","Le Garric","Le Gavre","Le Gond","Le Grand Village","Le Grand-Bornand","Le Grand-Pressigny","Le Grand-Quevilly","Le Gratteris","Le Grau-du-Roi","Le Gua","Le Guerno","Le Guildo","Le Haillan","Le Havre","Le Herie-la-Vieville","Le Hohwald","Le Houlme","Le Kremlin-Bicetre","Le Landin","Le Landreau","Le Lardin-Saint-Lazare","Le Lavandou","Le Lez","Le Longeron","Le Loroux","Le Loroux-Bottereau","Le Louroux-Beconnais","Le Luart","Le Luc","Le Lude","Le Manoir","Le Mans","Le Marillais","Le Martinet","Le Mas","Le May-sur-Evre","Le Mayet","Le Mazeau","Le Mee-sur-Seine","Le Meix-Saint-Epoing","Le Mele-sur-Sarthe","Le Menil","Le Meriot","Le Merlerault","Le Mesnil-Amelot","Le Mesnil-en-Thelle","Le Mesnil-en-Vallee","Le Mesnil-Esnard","Le Mesnil-Fuguet","Le Mesnil-le-Roi","Le Mesnil-Ozenne","Le Mesnil-Vigot","Le Mesnil-Villeman","Le Meux","Le Molard","Le Molay","Le Monastier-Pin-Mories","Le Monastier-sur-Gazeille","Le Mont-Dore","Le Monteil","Le Montel","Le Muy","Le Neubourg","Le Noyer","Le Palais","Le Pallet","Le Parc","Le Parcq","Le Passage","Le Passage","Le Pecq","Le Pellerin","Le Perray-en-Yvelines","Le Perreux-sur-Marne","Le Perrier","Le Petit-Quevilly","Le Pian-sur-Garonne","Le Pin","Le Pin","Le Pin","Le Pin","Le Pin-la-Garenne","Le Pizou","Le Plan-de-la-Tour","Le Planois","Le Plessier-sur-Bulles","Le Plessis","Le Plessis-Belleville","Le Plessis-Bouchard","Le Plessis-Grammoire","Le Plessis-Hebert","Le Plessis-Pate","Le Plessis-Robinson","Le Plessis-Trevise","Le Poet","Le Poet-Laval","Le Poinconnet","Le Poire-sur-Velluire","Le Pont","Le Pont","Le Pont-de-Claix","Le Pontet","Le Porge","Le Port","Le Port","Le Port-Marly","Le Portel","Le Pouget","Le Pouliguen","Le Pout","Le Pouzin","Le Pradet","Le Pre-Saint-Gervais","Le Puy","Le Puy-en-Velay","Le Puy-Sainte-Reparade","Le Quesnel","Le Quesnoy","Le Raincy","Le Relecq-Kerhuon","Le Renouard","Le Revest-les-Eaux","Le Rheu","Le Roncenay-Authenay","Le Rouget","Le Rouret","Le Rove","Le Sacq","Le Sap","Le Segur","Le Soler","Le Sourn","Le Syndicat","Le Taillan-Medoc","Le Tallud","Le Teich","Le Teil","Le Teilleul","Le Temple-de-Bretagne","Le Theil","Le Theil-de-Bretagne","Le Thieulin","Le Thillay","Le Thillot","Le Tholonet","Le Tholy","Le Thor","Le Thou","Le Thoureil","Le Thuit-Signol","Le Thuit-Simer","Le Tignet","Le Torquesne","Le Touquet-Paris-Plage","Le Tourne","Le Tourneur","Le Touvet","Le Trait","Le Treport","Le Trevoux","Le Tronchet","Le Tronquay","Le Val","Le Val-dAjol","Le Vaudioux","Le Vaudreuil","Le Vaumain","Le Verger","Le Vernet","Le Vernet","Le Versoud","Le Vesinet","Le Vieux","Le Vieux Bourg","Le Vieux Bourg","Le Vigan","Le Vigean","Le Vigeant","Le Vigen","Le Vivier-sur-Mer","Le Voide","Lealvillers","Leaz","Lecelles","Lechatelet","Lechelle","Lecousse","Lectoure","Ledenon","Lederzeele","Leers","Leffincourt","Leffrinckoucke","Leforest","Lege","Lege-Cap-Ferret","Leguevin","Lehon","Leigneux","Leintrey","Lelling","Lemainville","Lembach","Lemberg","Leme","Lemmes","Lempdes","Lempdes-sur-Allagnon","Lemps","Lencloitre","Lennon","Lenoncourt","Lens","Lens-Lestang","Lent","Lentigny","Lentilly","Lentiol","Leojac","Leon","Leouville","Lepin-le-Lac","Lepuix","Lepuy","Lere","Lery","Les Abrets","Les Ageux","Les Alleuds","Les Allies","Les Allues","Les Ancizes-Comps","Les Andelys","Les Angles","Les Arcs","Les Ardillats","Les Artigues-de-Lussac","Les Assions","Les Aubiers","Les Avanchers-Valmorel","Les Avenieres","Les Bains","Les Baux de Provence","Les Baux-de-Breteuil","Les Billanges","Les Bordes","Les Bordes","Les Bordes-sur-Lez","Les Breviaires","Les Brouzils","Les Cabanes","Les Cabannes","Les Cars","Les Champs","Les Chapelles","Les Charmontois","Les Cheres","Les Clayes-sous-Bois","Les Clouzeaux","Les Combes","Les Deux-Fays","Les Echelles","Les Ecrennes","Les Eglisottes-et-Chalaures","Les Eparres","Les Epesses","Les Essards","Les Essards-Taignevaux","Les Essarts","Les Essarts","Les Essarts","Les Etangs","Les Eyzies-de-Tayac-Sireuil","Les Fins","Les Fontaines","Les Fonts","Les Forges","Les Forges","Les Fourgs","Les Gets","Les Gours","Les Grands-Chezeaux","Les Granges","Les Granges","Les Gras","Les Halles","Les Hays","Les Herbiers","Les Hogues","Les Hopitaux-Vieux","Les Hotelleries","Les Houches","Les Jumeaux","Les Landes","Les Landes-Genusson","Les Laumes","Les Lilas","Les Loges","Les Loges","Les Loges-en-Josas","Les Lucs-sur-Boulogne","Les Mages","Les Marches","Les Martres","Les Mathes","Les Maures","Les Mees","Les Mesneux","Les Mesnuls","Les Milles","Les Moitiers-en-Bauptois","Les Molieres","Les Montils","Les Mureaux","Les Nouillers","Les Ollieres-sur-Eyrieux","Les Olmes","Les Ormes","Les Ormes","Les Ormes-sur-Voulzie","Les Palais","Les Pavillons-sous-Bois","Les Peintures","Les Pennes-Mirabeau","Les Petites Loges","Les Pieux","Les Pineaux","Les Pins","Les Pins","Les Pins","Les Places","Les Rives","Les Rivieres-Henruel","Les Roches","Les Rosiers","Les Rosiers-sur-Loire","Les Rousses","Les Sables","Les Sauvages","Les Sorinieres","Les Taillades","Les Thilliers-en-Vexin","Les Touches","Les Vallees","Les Vans","Les Varennes","Les Vigneaux","Les Villedieu","Lescar","Lescheraines","Lescherolles","Lesches","Lesconil","Lescout","Lescure","Lesdain","Lesigny","Lesneven","Lespesses","Lespielle","Lespignan","Lespinasse","Lesquin","Lessay","Lesse","Lessy","Lestelle-Betharram","Lestiou","Lestrem","Letanne","Letricourt","Leuc","Leucate","Leudeville","Leugny","Leuilly-sous-Coucy","Leuville-sur-Orge","Leuvrigny","Levainville","Leval","Leval","Levallois-Perret","Levens","Levernois","Leves","Levet","Levie","Levier","Levignacq","Levis","Levroux","Lewarde","Lexy","Leyme","Leyr","Leyrieu","Leysse","Lezan","Lezardrieux","Lezat-sur-Leze","Lezay","Lezennes","Lezignan-Corbieres","Lezigne","Lezigneux","Lezoux","Lheraule","Lherm","Lhommaize","Lhuis","Liancourt","Liancourt-Saint-Pierre","Liart","Libercourt","Libourne","Licques","Liepvre","Lieramont","Liergues","Liernais","Lieu-Saint-Amand","Lieuran-les-Beziers","Lieurey","Lieuron","Lieusaint","Lieuvillers","Liffol-le-Grand","Liffre","Ligescourt","Lignan-sur-Orb","Ligne","Ligne","Lignerolles","Lignerolles","Lignieres-Chatelain","Lignieres-la-Carelle","Lignol","Ligny-en-Barrois","Ligny-en-Cambresis","Ligny-le-Chatel","Ligny-le-Ribault","Ligsdorf","Ligueil","Liguge","Lihons","Lihus","Lille","Lillebonne","Lillers","Limas","Limay","Limeil-Brevannes","Limeray","Limersheim","Limerzel","Limesy","Limetz-Villez","Limoges","Limoges-Fourches","Limogne-en-Quercy","Limonest","Limony","Limours","Limoux","Linars","Linas","Lincel","Lingolsheim","Lingreville","Linselles","Linxe","Liocourt","Lion-en-Sullias","Lion-sur-Mer","Liouc","Lipsheim","Lire","Lisieux","Lisle","LIsle-dEspagnac","LIsle-sur-le-Doubs","Lisle-sur-Tarn","Lisors","Lisses","Lissieu","Lissy","Lit-et-Mixe","Livarot","Liverdun","Liverdy-en-Brie","Livernon","Livet-et-Gavet","Livet-sur-Authou","Livinhac-le-Haut","Livre-sur-Changeon","Livron","Livron-sur-Drome","Livry-Gargan","Livry-sur-Seine","Lixhausen","Lixheim","Lizac","Lizy-sur-Ourcq","Llupia","Loche","Loche-sur-Indrois","Locmaria-Grand-Champ","Locmaria-Plouzane","Locmariaquer","Locmine","Locmiquelic","Locoal-Mendon","Locon","Locquemeau","Locquirec","Loctudy","Loge-Fougereuse","Logelbach","Logelheim","Lognes","Logonna-Daoulas","Logonna-Quimerch","Logrian-Florian","Lohr","Loire","Loire-les-Marais","Loire-sur-Rhone","Loiron","Loisin","Loison-sous-Lens","Loisy","Loisy-sur-Marne","Loix","Lokmaria","Lombers","Lombez","Lombron","Lomme","Lommerange","Lompret","Londigny","Londinieres","Longages","Longchamp","Longchamp-sous-Chatenois","Longeault","Longecourt-en-Plaine","Longes","Longessaigne","Longevelle-sur-Doubs","Longeves","Longeville-en-Barrois","Longeville-les-Metz","Longeville-les-Saint-Avold","Longeville-sur-Mer","Longfosse","Longjumeau","Longlaville","Longnes","Longpont-sur-Orge","Longpre-les-Corps-Saints","Longue-Jumelles","Longueau","Longueil-Annel","Longueil-Sainte-Marie","Longuenesse","Longueville","Longueville-sur-Scie","Longuyon","Longvic","Longwy","Lons","Lons-le-Saunier","Loon-Plage","Loos","Loos-en-Gohelle","Loperhet","Lorcieres","Lorette","Lorey","Lorgies","Lorgues","Lorient","Lorignac","Loriol-du-Comtat","Loriol-sur-Drome","Lorlanges","Lormaison","Lormaye","Lormont","Lorquin","Lorrez-le-Bocage-Preaux","Lorris","Lorry-Mardigny","Los Masos","Losne","Louailles","Louannec","Louargat","Louatre","Loubaresse","Loubes-Bernac","Loubeyrat","Loubieng","Loubigne","Loubille","Loudeac","Loudes","Loudrefing","Loudun","Loue","Louer","Lougres","Louhans","Loupershouse","Loupes","Loupiac-de-la-Reole","Loupian","Louplande","Lourches","Lourdes","Lourenties","Loures-Barousse","Louresse-Rochemenier","Lourmarin","Lourties-Monbrun","Loury","Louveciennes","Louvemont","Louverne","Louvie-Juzon","Louviers","Louvigne-de-Bais","Louvignies-Quesnoy","Louvigny","Louvigny","Louvigny","Louvil","Louvrechy","Louvres","Louvroil","Louzouer","Louzy","Lovagny","Loyat","Loyes","Loyettes","Lozanne","Lozinghem","Lozon","Luant","Lubersac","Luc","Luc-sur-Mer","Luc-sur-Orbieu","Lucciana","Luce","Luce","Luceau","Lucenay","Lucey","Luchy","Lucon","Lucq-de-Bearn","Lucy-sur-Cure","Ludon-Medoc","Ludres","Luemschwiller","Lugny-Champagne","Lugny-les-Charolles","Lugrin","Luisant","Luitre","Lullin","Lully","Lumbin","Lumbres","Lumeau","Lumio","Lunel","Lunel-Viel","Luneray","Lupe","Luppy","Lupstein","Luquet","Lurais","Luray","Lurcy","Lurcy-Levis","Lure","Lury-sur-Arnon","Lus-la-Croix-Haute","Lusanger","Lusignan","Lusignan-Grand","Lusigny","Lusigny-sur-Barse","Lussac","Lussac-les-Chateaux","Lussac-les-Eglises","Lussant","Lussas","Lussat","Luttange","Lutter","Lutterbach","Lutz-en-Dunois","Lux","Lux","Luxe","Luxeuil-les-Bains","Luxey","Luynes","Luynes","Luz-Saint-Sauveur","Luzarches","Luze","Luzille","Luzinay","Luzy","Lyaud","Lynde","Lyon","Mably","Macau","Mache","Machecoul","Machemont","Macheren","Machezal","Maclas","Macot-la-Plagne","Madirac","Madre","Madriat","Mael-Carhaix","Maennolsheim","Maffliers","Magagnosc","Magalas","Magenta","Magescq","Magland","Magnan","Magnanville","Magne","Magneux-Haute-Rive","Magnieres","Magny","Magny-Cours","Magny-en-Vexin","Magny-le-Desert","Magny-le-Hongre","Magny-les-Hameaux","Magny-les-Villers","Magny-sur-Tille","Magrie","Magstatt-le-Haut","Maiche","Maidieres","Maigne","Maignelay-Montigny","Maillane","Maille","Maillebois","Mailly-Champagne","Mailly-la-Ville","Mailly-le-Camp","Mailly-Maillet","Mailly-Raineval","Maincy","Maing","Maintenon","Mainvilliers","Mainxe","Mairieux","Mairy-sur-Marne","Maisdon-sur-Sevre","Maisnil","Maisnil-les-Ruitz","Maison-Ponthieu","Maisons-Alfort","Maisons-Laffitte","Maisonsgoutte","Maisontiers","Maisse","Maizeroy","Maizieres-les-Metz","Malabry","Malafretaz","Malain","Malakoff","Malancourt-la-Montagne","Malange","Malansac","Malataverne","Malaucene","Malaumont","Malaunay","Malause","Malaussanne","Malay-le-Grand","Malegoude","Malemort-du-Comtat","Malemort-sur-Correze","Malesherbes","Malestroit","Maleville","Malguenac","Malicorne","Malicorne-sur-Sarthe","Malijai","Malincourt","Malintrat","Malissard","Malleloy","Mallemoisson","Mallemort","Malling","Malmerspach","Malmont","Malpas","Malras","Malrevers","Malves-en-Minervois","Malville","Malzeville","Mamers","Mametz","Mamey","Mamirolle","Manchecourt","Mancieulles","Mandagout","Mandelieu-la-Napoule","Mandeure","Mandres-la-Cote","Mandres-les-Roses","Manduel","Mane","Maneglise","Mangiennes","Mangonville","Manicamp","Maninghen-Henne","Manneville-es-Plains","Mannevillette","Manom","Manoncourt-sur-Seille","Manonviller","Manosque","Manot","Mansigne","Mansle","Manspach","Mantes-la-Jolie","Mantes-la-Ville","Manthelan","Mantoche","Mantry","Manzat","Manziat","Marange-Silvange","Marange-Zondrange","Marans","Maraussan","Marbache","Marc","Marcamps","Marcay","Marce-sur-Esves","Marcelcave","Marcellaz-Albanais","Marchainville","Marchaux","Marche-Allouarde","Marcheprime","Marchesieux","Marcheville","Marchiennes","Marciac","Marcigny","Marcilhac-sur-Cele","Marcillac","Marcillac-la-Croisille","Marcillat-en-Combraille","Marcilloles","Marcilly-en-Bassigny","Marcilly-en-Beauce","Marcilly-en-Villette","Marcilly-sur-Eure","Marcilly-sur-Seine","Marcilly-sur-Tille","Marcilly-sur-Vienne","Marck","Marckolsheim","Marcoing","Marcollin","Marconnelle","Marcoussis","Marcouville","Marcoux","Marcq","Marcq-en-Baroeul","Marcq-en-Ostrevent","Mardeuil","Mardie","Mardyck","Mareau-aux-Bois","Mareau-aux-Pres","Mareil-en-France","Mareil-Marly","Mareil-sur-Loir","Mareil-sur-Mauldre","Marenla","Marennes","Marennes","Marest","Marestaing","Mareuil","Mareuil","Mareuil-Caubert","Mareuil-en-Brie","Mareuil-le-Port","Mareuil-les-Meaux","Mareuil-sur-Cher","Mareuil-sur-Lay-Dissais","Mareuil-sur-Ourcq","Margaux","Margencel","Margency","Margerie-Chantagret","Margny","Margny-les-Compiegne","Margon","Marguerittes","Margut","Marie","Marienthal","Marignac","Marignac-Lasclares","Marignane","Marigne","Marignier","Marigny","Marigny","Marigny-Brizay","Marigny-Chemereau","Marigny-en-Orxois","Marigny-le-Chatel","Marigny-les-Usages","Marigny-Marmande","Marin","Marines","Maringes","Maringues","Marle","Marlenheim","Marles-en-Brie","Marles-les-Mines","Marliens","Marlioz","Marlotte","Marly","Marly","Marly-la-Ville","Marly-le-Roi","Marmagne","Marmande","Marmanhac","Marmoutier","Marnand","Marnaz","Marnes","Marnes-la-Coquette","Maroeuil","Marolles","Marolles-en-Brie","Marolles-en-Hurepoix","Marols","Maromme","Maron","Maron","Marpent","Marquay","Marquefave","Marqueglise","Marques","Marquillies","Marquion","Marquise","Marquixanes","Mars","Mars","Mars-sur-Allier","Marsac","Marsac-en-Livradois","Marsac-sur-lIsle","Marsainvilliers","Marsais","Marsais-Sainte-Radegonde","Marsaneix","Marsangy","Marsannay-le-Bois","Marsanne","Marsat","Marsaz","Marseillan","Marseille","Marseille-en-Beauvaisis","Marseilles-les-Aubigny","Marsillargues","Marsilly","Marsilly","Marssac-sur-Tarn","Martainville-Epreville","Martel","Marthod","Martiel","Martignas-sur-Jalle","Martigne-Briand","Martigne-Ferchaud","Martigny","Martigues","Martillac","Martin-Eglise","Martinet","Martinvast","Martot","Martres-Tolosane","Marval","Marvejols","Marville-les-Bois","Marzan","Marzy","Mas-Grenier","Mas-Saintes-Puelles","Masevaux","Maslacq","Maslives","Masnieres","Masny","Masparraute","Massat","Masserac","Masseret","Massiac","Massieu","Massieux","Massingy-les-Semur","Massugas","Massy","Mastaing","Matha","Mathay","Mathenay","Mathieu","Mathieu","Matignon","Matigny","Matour","Mattaincourt","Mattexey","Matzenheim","Maubeuge","Maubourguet","Mauchamps","Maucor","Mauguio","Maule","Mauleon-Licharre","Maulevrier","Mauperthuis","Mauprevoir","Mauran","Maure","Maure-de-Bretagne","Maurecourt","Maureilhan","Maureillas-las-Illas","Mauremont","Maurens","Maurepas","Mauressargues","Maureville","Mauriac","Maurois","Mauron","Maurrin","Maurs","Maussane-les-Alpilles","Mauves","Mauves-sur-Huisne","Mauves-sur-Loire","Mauvezin-de-Prat","Maux","Mauzac","Mauze-sur-le-Mignon","Mauzens-et-Miremont","Maxent","Maxeville","Maxilly-sur-Saone","May-en-Multien","May-sur-Orne","Mayenne","Mayet","Maysel","Mazamet","Mazan","Mazange","Maze","Mazeray","Mazeres-de-Neste","Mazeres-sur-Salat","Mazerolles","Mazerolles-le-Salin","Mazet-Saint-Voy","Mazeuil","Mazieres-en-Gatine","Mazieres-en-Mauges","Mazingarbe","Mazion","Meaudre","Meaulte","Meaux","Meauzac","Medan","Medis","Medreac","Mees","Megrit","Meharicourt","Mehun-sur-Yevre","Meigneux","Meilhac","Meilhan","Meilhan","Meilhan-sur-Garonne","Meillant","Meillerie","Meillon","Meillonnas","Meisenthal","Mejannes-le-Clap","Mejannes-les-Ales","Melay","Melay","Melesse","Melgven","Mellac","Melle","Mellecey","Melleran","Melleray","Mellionnec","Mello","Melrand","Melsheim","Melun","Membrey","Menat","Mende","Mendionde","Meneac","Menerbes","Menesplet","Menestreau-en-Villette","Menetou-Salon","Menetreol-sur-Sauldre","Menetrol","Menil-Erreux","Menil-Hermei","Menil-la-Horgne","Menil-sur-Belvitte","Menilles","Mennecy","Mennevret","Mens","Mensignac","Menthon-Saint-Bernard","Menton","Menucourt","Menville","Meounes-les-Montrieux","Mer","Mercenac","Merckeghem","Mercues","Mercurol","Mercy-le-Bas","Merdrignac","Mere","Mereau","Merenvielle","Mereville","Merey-sous-Montrond","Mergey","Mericourt","Meriel","Merignac","Merignas","Merignat","Merignies","Merigny","Merindol","Merlas","Merlebach","Merlevenez","Merlimont","Merlines","Mernel","Meroux","Merry-la-Vallee","Merry-sur-Yonne","Mers-les-Bains","Mertzen","Mertzwiller","Meru","Mervans","Merville","Merville","Merville-Franceville-Plage","Merxheim","Mery","Mery-es-Bois","Mery-sur-Oise","Mery-sur-Seine","Mesanger","Mesangueville","Meschers-sur-Gironde","Mescoules","Mesland","Meslay","Meslay-du-Maine","Meslay-le-Vidame","Meslin","Mesnil-Raoul","Mesnil-Saint-Georges","Mesnil-Saint-Nicaise","Mesnil-Sellieres","Mesnil-sous-Vienne","Mesplede","Messac","Messanges","Messei","Messein","Messia-sur-Sorne","Messigny-et-Vantoux","Messimy","Messon","Messy","Metabief","Meteren","Mettray","Metz","Metz-Tessy","Metzeral","Metzeresche","Metzervisse","Meucon","Meudon","Meulan-en-Yvelines","Meung-sur-Loire","Meurchin","Meursault","Meuse","Meusnes","Meuzac","Mevoisins","Meximieux","Mexy","Meyenheim","Meylan","Meymac","Meynes","Meyrargues","Meyras","Meyreuil","Meyssac","Meythet","Meyzieu","Meze","Mezel","Mezel","Mezeres","Mezeriat","Mezidon-Canon","Mezieres-en-Drouais","Mezieres-lez-Clery","Mezieres-sous-Lavardin","Mezieres-sur-Couesnon","Mezieres-sur-Seine","Mezzavia","Michelbach-le-Bas","Mielan","Miellin","Mietesheim","Mieussy","Migennes","Miglos","Mignaloux-Beauvoir","Migne-Auxances","Mignieres","Migron","Milhaud","Milizac","Millac","Millas","Millau","Millencourt","Millery","Millery","Milly","Milly-la-Foret","Milly-Lamartine","Milly-sur-Therain","Milon-la-Chapelle","Mimbaste","Mimet","Mimizan","Mine de Bert","Mingot","Miniac-Morvan","Miniac-sous-Becherel","Minihy-Treguier","Minversheim","Minzier","Mionnay","Mions","Mios","Mirabel-aux-Baronnies","Miradoux","Miramas","Mirambeau","Miramont-de-Guyenne","Miramont-Sensacq","Mirande","Mirebeau","Mirebeau-sur-Beze","Mirecourt","Miremont","Mirepeix","Mirepoix","Mirepoix-sur-Tarn","Mireval-Lauragais","Miribel","Miserey","Miserey-Salines","Mison","Misse","Missillac","Missiriac","Misson","Missy-sur-Aisne","Mitry-Mory","Mittelbronn","Mittelhausbergen","Mittelwihr","Mitterand","Mittersheim","Modane","Moelan-sur-Mer","Moens","Moernach","Moeslains","Mogneville","Mogues","Mohon","Moineville","Moinville-la-Jeulin","Moirans","Moirans-en-Montagne","Moire","Moisdon-la-Riviere","Moislains","Moissac","Moissat","Moisselles","Moissieu-sur-Dolon","Moissy-Cramayel","Moisville","Molac","Molandier","Molesme","Moliens","Molieres-sur-Ceze","Moliets-et-Maa","Molinet","Molineuf","Molleges","Molliens-au-Bois","Mollkirch","Moloy","Molsheim","Moltifao","Momas","Mombrier","Momeres","Mommenheim","Momy","Monbahus","Monbalen","Monbrun","Moncale","Monce-en-Belin","Monceau-le-Neuf-et-Faucouzy","Monceau-le-Waast","Monceau-Saint-Waast","Monceaux","Moncel-sur-Seille","Moncetz-Longevas","Moncheaux-les-Frevent","Monchecourt","Monchy-Breton","Monchy-Humieres","Monchy-Saint-Eloi","Monclar-de-Quercy","Moncontour","Moncoutant","Mondelange","Mondescourt","Mondetour","Mondeville","Mondeville","Mondon","Mondonville","Mondragon","Mondrainville","Mondrepuis","Monein","Monestier-de-Clermont","Monesties","Monetay-sur-Loire","Moneteau","Monferran-Plaves","Monferran-Saves","Monflanquin","Monistrol-sur-Loire","Monnaie","Monnetier-Mornex","Monneville","Monnieres","Monpazier","Mons","Mons","Mons","Mons","Mons-en-Baroeul","Mons-en-Montois","Mons-en-Pevele","Monsac","Monsegur","Monsempron-Libos","Monsireigne","Monsteroux-Milieu","Mont","Mont","Mont","Mont-Bonvillers","Mont-Cauvaire","Mont-de-Marsan","Mont-Notre-Dame","Mont-pres-Chambord","Mont-Saint-Aignan","Mont-Saint-Martin","Mont-Saint-Martin","Mont-Saint-Pere","Mont-Saxonnex","Mont-sur-Meurthe","Mont-sur-Monnet","Montabard","Montady","Montagnac","Montagnat","Montagne","Montagney","Montagnieu","Montagnole","Montagny-en-Vexin","Montagny-les-Lanches","Montagny-les-Seurre","Montagny-Sainte-Felicite","Montagny-sur-Grosne","Montagrier","Montagut","Montaigu","Montaigu","Montaigu","Montaigu-de-Quercy","Montaigut-sur-Save","Montainville","Montalet-le-Bois","Montalieu-Vercieu","Montamise","Montanay","Montardon","Montargis","Montarlot-les-Rioz","Montarnaud","Montastruc-de-Salies","Montastruc-la-Conseillere","Montataire","Montauban","Montauban-de-Bretagne","Montaud","Montaudin","Montaulieu","Montaure","Montauroux","Montaut","Montaut","Montayral","Montbard","Montbartier","Montbazin","Montbazon","Montbel","Montbellet","Montberon","Montbert","Montbeton","Montbeugny","Montbizot","Montblanc","Montboillon","Montbonnot-Saint-Martin","Montboucher-sur-Jabron","Montbouton","Montbrison","Montbron","Montbronn","Montbrun-Bocage","Montcaret","Montcarra","Montceau","Montceau-les-Mines","Montceaux","Montceaux-les-Meaux","Montcel","Montcenis","Montcey","Montchamp","Montchanin","Montchaude","Montclar","Montcornet","Montcourt-Fromonville","Montcoy","Montcuq","Montcy-Notre-Dame","Montdidier","Montdoumerc","Montdragon","Monteaux","Montebourg","Montech","Montecheroux","Monteglin","Monteils","Montel-de-Gelat","Montelier","Montemboeuf","Montendre","Montenescourt","Montenois","Montenoison","Monterblanc","Montereau-Fault-Yonne","Monterfil","Montescot","Montesquieu","Montesquieu-des-Alberes","Montesquieu-Volvestre","Montessaux","Montesson","Montestruc-sur-Gers","Montestrucq","Monteux","Montevrain","Monteynard","Montfarville","Montfaucon","Montfaucon","Montfaucon","Montfaucon-en-Velay","Montfaucon-Montigne","Montfavet","Montfermeil","Montfermy","Montferrand-du-Perigord","Montferrand-le-Chateau","Montferrat","Montferrier-sur-Lez","Montfleur","Montfort","Montfort-en-Chalosse","Montfort-sur-Meu","Montfrin","Montfroc","Montfuron","Montgaillard","Montgaroult","Montgermont","Montgeron","Montgesty","Montgirod","Montgiscard","Montgivray","Montherme","Monthieux","Monthodon","Monthou-sur-Bievre","Monthou-sur-Cher","Monthureux-sur-Saone","Monthyon","Monticello","Montier-en-Der","Montierchaume","Montiers","Montignac-de-Lauzun","Montignac-le-Coq","Montigne-le-Brillant","Montigne-les-Rairies","Montigny","Montigny","Montigny-en-Cambresis","Montigny-en-Gohelle","Montigny-le-Bretonneux","Montigny-le-Chartif","Montigny-Lengrain","Montigny-les-Cormeilles","Montigny-sur-Loing","Montilly","Montilly-sur-Noireau","Montiron","Montivilliers","Montjavoult","Montjean-sur-Loire","Montlhery","Montliard","Montlieu-la-Garde","Montlignon","Montlivault","Montlouis","Montlouis-sur-Loire","Montluel","Montmacq","Montmagny","Montmalin","Montmarault","Montmartin","Montmartin-en-Graignes","Montmartin-sur-Mer","Montmelian","Montmerle-sur-Saone","Montmeyran","Montmirail","Montmiral","Montmirat","Montmoreau-Saint-Cybard","Montmorency","Montmorency-Beaufort","Montmorillon","Montmorot","Montoir-de-Bretagne","Montoire-sur-le-Loir","Montois-la-Montagne","Montoison","Montolivet","Montournais","Montpellier","Montpeyroux","Montpeyroux","Montpezat","Montpezat-de-Quercy","Montpezat-sous-Bauzon","Montpincon","Montpinier","Montpitol","Montpon-Menesterol","Montpothier","Montrabe","Montreal","Montreal","Montreal-la-Cluse","Montredon-des-Corbieres","Montredon-Labessonnie","Montrejeau","Montrelais","Montrem","Montrequienne","Montresor","Montret","Montreuil","Montreuil","Montreuil-aux-Lions","Montreuil-Bonnin","Montreuil-en-Caux","Montreuil-sous-Perouse","Montreuil-sur-Blaise","Montreuil-sur-Breche","Montreuil-sur-Lozon","Montreuil-sur-Mer","Montreux-Jeune","Montrevel","Montrevel-en-Bresse","Montrichard","Montricoux","Montrodat","Montrond","Montrond","Montrond-les-Bains","Montrouge","Montrouveau","Montry","Monts","Monts-en-Bessin","Monts-sur-Guesnes","Montsalvy","Montsauche-les-Settons","Montsegur-sur-Lauzon","Montseveroux","Montsoreau","Montsoult","Montussan","Montvalen","Montvalent","Montvendre","Montverdun","Montville","Moon-sur-Elle","Moosch","Moragne","Morainvilliers","Morance","Morancez","Morangis","Morangis","Morbecque","Morbier","Morcenx","Mordelles","Moreac","Moree","Morelmaison","Morestel","Moret-sur-Loing","Moreuil","Morez","Morgny","Morgny-la-Pommeraye","Morhange","Morienval","Morieres-les-Avignon","Morieux","Morigny-Champigny","Morisel","Moriville","Morlaas","Morlaix","Mormant","Mornac","Mornac-sur-Seudre","Mornant","Mornay","Mornay-sur-Allier","Moroges","Morogues","Morre","Morsain","Morsang-sur-Orge","Morsbach","Morsbronn-les-Bains","Morschwiller-le-Bas","Mortagne","Mortagne-au-Perche","Mortagne-du-Nord","Mortagne-sur-Sevre","Mortain","Mortcerf","Morteau","Morteaux-Couliboeuf","Mortefontaine","Mortefontaine-en-Thelle","Mortree","Mortzwiller","Morvillers-Saint-Saturnin","Morvilliers","Morzine","Moslins","Mosnac","Mosson","Motteville","Mouans-Sartoux","Mouaze","Mouchin","Mouflers","Mougins","Mougon","Mouguerre","Mouilleron-en-Pareds","Mouilleron-le-Captif","Mouledous","Moules","Mouliets-et-Villemartin","Moulin","Moulin-Mage","Moulin-Neuf","Moulin-sous-Touvent","Moulineaux","Moulines","Moulinet","Moulinet","Moulins","Moulins-Engilbert","Moulins-les-Metz","Moulins-sur-Cephons","Moulins-sur-Yevre","Moulle","Moult","Moumour","Mourenx","Moureze","Mouries","Mourioux-Vieilleville","Mourmelon-le-Grand","Mourmelon-le-Petit","Mouroux","Mours","Mours-Saint-Eusebe","Moussan","Mousseaux-Neuville","Moussey","Mousson","Moussoulens","Moussy","Moussy-le-Neuf","Moussy-le-Vieux","Mousteru","Moustier-en-Fagne","Mouthe","Mouthier-en-Bresse","Mouthiers-sur-Boeme","Moutiers","Moutiers","Moutiers-les-Mauxfaits","Moutiers-sur-le-Lay","Mouvaux","Mouxy","Mouy","Mouzeil","Mouzieys-Teulet","Mouzillon","Mouzon","Moyaux","Moyencourt","Moyenmoutier","Moyenneville","Moyenneville","Moyeuvre-Grande","Moyon","Moyrazes","Moyvillers","Mozac","Muespach-le-Haut","Muides-sur-Loire","Muidorge","Muirancourt","Muizon","Mulcent","Mulcey","Mulhouse","Mulsanne","Munchhouse","Mundolsheim","Munster","Munster","Mur-de-Bretagne","Mur-de-Sologne","Murat","Mures","Muret","Murianette","Muro","Murol","Muron","Murs-Erigne","Murviel-les-Beziers","Murviel-les-Montpellier","Mus","Mussidan","Mussig","Mutzig","Muzillac","Nadillac","Nages-et-Solorgues","Nailloux","Naintre","Naizin","Najac","Nalliers","Nancy","Nandy","Nangis","Nans-les-Pins","Nanterre","Nantes","Nanteuil-en-Vallee","Nanteuil-le-Haudouin","Nanteuil-les-Meaux","Nantiat","Nantoin","Nanton","Nantua","Naours","Narbonne","Narbonne-Plage","Nargis","Narrosse","Nattages","Naucelle","Naujan-et-Postiac","Naux","Navailles-Angos","Navarrenx","Naves","Nay","Nayemont-les-Fosses","Nazelles-Negron","Neauphle-le-Chateau","Neauphlette","Nebian","Nebouzat","Nedonchel","Neewiller-pres-Lauterbourg","Neffes","Neffies","Nefiach","Negrepelisse","Negron","Nehou","Nemours","Neoules","Nercillac","Nere","Neris-les-Bains","Neron","Neronde-sur-Dore","Ners","Nersac","Nerville-la-Foret","Nery","Nesle","Nesles","Nesles-la-Montagne","Nesles-la-Vallee","Nesmy","Nessa","Neuf Eglise","Neuf-Brisach","Neufchateau","Neufchatel-en-Bray","Neufchef","Neufgrange","Neuflize","Neufmanil","Neufmesnil","Neufmoutiers-en-Brie","Neufvy-sur-Aronde","Neuil","Neuille","Neuilly","Neuilly-en-Thelle","Neuilly-le-Bisson","Neuilly-le-Real","Neuilly-les-Dijon","Neuilly-Plaisance","Neuilly-Saint-Front","Neuilly-sous-Clermont","Neuilly-sur-Marne","Neuilly-sur-Seine","Neulliac","Neung-sur-Beuvron","Neure","Neussargues-Moissac","Neuve-Maison","Neuvecelle","Neuves-Maisons","Neuvic","Neuvic-Entier","Neuvicq-le-Chateau","Neuville","Neuville","Neuville-aux-Bois","Neuville-Bosc","Neuville-de-Poitou","Neuville-en-Ferrain","Neuville-Ferrieres","Neuville-les-Dames","Neuville-les-Dieppe","Neuville-Saint-Remy","Neuville-Saint-Vaast","Neuville-sur-Ain","Neuville-sur-Brenne","Neuville-sur-Escaut","Neuville-sur-Oise","Neuville-sur-Saone","Neuville-sur-Sarthe","Neuville-sur-Seine","Neuviller-sur-Moselle","Neuvireuil","Neuvy","Neuvy","Neuvy-Bouin","Neuvy-en-Beauce","Neuvy-en-Sullias","Neuvy-le-Roi","Neuvy-Saint-Sepulchre","Nevers","Nevez","Nevian","Neville","Nexon","Neydens","Nibas","Nibelle","Nice","Nicole","Nicorps","Niderhoff","Niderviller","Niederbronn-les-Bains","Niederbruck","Niederentzen","Niederhaslach","Niederhausbergen","Niedermodern","Niederschaeffolsheim","Nieppe","Niergnies","Nieuil","Nieul-le-Virouil","Nieul-les-Saintes","Nieul-sur-Mer","Nievroz","Niffer","Niherne","Nilvange","Niort","Nissan-lez-Enserune","Nitting","Nivillac","Nivolas-Vermelle","Nizas","Noailhac","Noaillac","Noaillan","Noailles","Noailles","Noe","Noeux-les-Auxi","Noeux-les-Mines","Nogent","Nogent-le-Phaye","Nogent-le-Roi","Nogent-le-Rotrou","Nogent-sur-Eure","Nogent-sur-Marne","Nogent-sur-Oise","Nogent-sur-Seine","Nogent-sur-Vernisson","Nohanent","Nohic","Noidans-le-Ferroux","Noidans-les-Vesoul","Noilhan","Nointel","Nointot","Noiron","Noiron-sous-Gevrey","Noirterre","Noiseau","Noisiel","Noisseville","Noisy-le-Grand","Noisy-le-Roi","Noisy-le-Sec","Noisy-Rudignon","Noisy-sur-Ecole","Noisy-sur-Oise","Nolay","Nomain","Nomeny","Nomexy","Nommay","Nonancourt","Nonette","Nonneville","Nontron","Nonville","Nonvilliers-Grandhoux","Noordpeene","Nordausques","Nordhouse","Norges-la-Ville","Normanville","Normier","Norrent-Fontes","Norrey-en-Auge","Norroy-le-Sec","Norroy-le-Veneur","Norroy-les-Pont-a-Mousson","Nort-sur-Erdre","Nostang","Nothalten","Notre-Dame-de-Boisset","Notre-Dame-de-Bondeville","Notre-Dame-de-Cenilly","Notre-Dame-de-Commiers","Notre-Dame-de-Gravenchon","Notre-Dame-de-la-Rouviere","Notre-Dame-de-Livaye","Notre-Dame-de-Livoye","Notre-Dame-de-Mesage","Notre-Dame-de-Riez","Notre-Dame-de-Sanilhac","Notre-Dame-des-Landes","Notre-Dame-du-Pre","Nouaille-Maupertuis","Nouainville","Nouan-le-Fuzelier","Noueilles","Nouilly","Nousseviller-les-Bitche","Nousseviller-Saint-Nabor","Nouvelle-Eglise","Nouvion-le-Comte","Nouvion-le-Vineux","Nouvion-sur-Meuse","Nouvoitou","Nouzonville","Novalaise","Noveant-sur-Moselle","Noves","Novillard","Novillars","Novion-Porcien","Noyal-Muzillac","Noyal-Pontivy","Noyal-sur-Vilaine","Noyant-de-Touraine","Noyant-la-Gravoyere","Noyant-la-Plaine","Noyarey","Noyelles-Godault","Noyelles-sous-Lens","Noyelles-sur-Escaut","Noyen-sur-Sarthe","Noyers","Noyers","Noyers-Bocage","Noyers-sur-Cher","Noyon","Nozay","Nozay","Nuaille","Nuaille-sur-Boutonne","Nueil-sur-Layon","Nuelles","Nuits-Saint-Georges","Nyoiseau","Nyons","Obenheim","Oberbronn","Oberentzen","Oberhaslach","Oberhausbergen","Oberhergheim","Oberhoffen-sur-Moder","Oberlauterbach","Obermodern-Zutzendorf","Obermorschwihr","Obermorschwiller","Obernai","Obersaasheim","Oberschaeffolsheim","Objat","Oblinghem","Obtree","Ochey","Octeville","Octeville-sur-Mer","Oderen","Odomez","Odos","Oelleville","OEting","Oeyreluy","Offekerque","Offemont","Offendorf","Offoy","Offranville","Ogenne-Camptort","Oger","Ogeu-les-Bains","Ogeviller","Ogy","Oignies","Oingt","Oinville-sur-Montcient","Oiron","Oiselay-et-Grachaux","Oisemont","Oisly","Oisseau","Oissel","Oisy","Oisy-le-Verger","Oizon","Olargues","Olby","Olemps","Oletta","Olivet","Ollainville","Olle","Ollezy","Ollieres","Olliergues","Ollioules","Olloix","Olmet","Olonne-sur-Mer","Olonzac","Oloron-Sainte-Marie","Olwisheim","Omessa","Omonville-la-Rogue","Ondes","Ondres","Ondreville-sur-Essonne","Onet-le-Chateau","Onnaing","Onnion","Ons-en-Bray","Onzain","Opio","Oppede","Optevoz","Oradour","Oradour-Fanais","Oradour-sur-Glane","Oraison","Orangis","Orban","Orbec","Orbeil","Orbey","Orcet","Orchaise","Orchamps-Vennes","Orches","Orchies","Orcier","Orcines","Ordan-Larroque","Ordiarp","Oregue","Oresmaux","Orgelet","Orgeres","Orgerus","Orgeval","Orgon","Orgueil","Orignolles","Origny-en-Thierache","Origny-le-Sec","Origny-Sainte-Benoite","Oriol-en-Royans","Orion","Orleat","Orlienas","Orlu","Orly","Ormersviller","Ormes","Ormes-et-Ville","Ormesson-sur-Marne","Ormoy","Ormoy","Ormoy-Villers","Ornacieux","Ornans","Ornex","Orny","Orphin","Orrouer","Orrouy","Orry-la-Ville","Orsan","Orsanco","Orsonville","Orthez","Ortoncourt","Orval","Orval","Orvault","Orvaux","Orveau-Bellesauve","Orvillers-Sorel","Osne-le-Val","Osny","Ossages","Osse","Osses","Ossun","Ostheim","Ostricourt","Ostwald","Ota","Othis","Ottange","Ottmarsheim","Ottonville","Ottrott","Ouanne","Ouarville","Ouchamps","Oucques","Oudon","Ouerre","Ouezy","Ouffieres","Ougney","Ouhans","Ouilly-le-Tesson","Ouilly-le-Vicomte","Ouistreham","Oulchy-le-Chateau","Oullins","Oupia","Ourches","Ouroux","Ouroux-sur-Saone","Oursbelille","Ousse","Ousson-sur-Loire","Outarville","Outille","Outines","Outreau","Ouveillan","Ouville","Ouville","Ouzilly","Ouzouer-le-Marche","Ouzouer-sur-Loire","Ouzouer-sur-Trezee","Ovanches","Ovillers-la-Boisselle","Oye-Plage","Oyeu","Oyonnax","Oytier-Saint-Oblas","Ozan","Ozoir-la-Ferriere","Ozolles","Ozouer-le-Voulgis","Pabu","Pace","Pact","Pacy-sur-Eure","Pageas","Pagny-la-Ville","Pagny-sur-Meuse","Pagny-sur-Moselle","Paillart","Paillencourt","Paillet","Paimboeuf","Paimpol","Paimpont","Painblanc","Pair-et-Grandrupt","Paix","Paizay-le-Chapt","Paizay-le-Sec","Paizay-le-Tort","Palaiseau","Palaja","Palalda","Palaminy","Palau-del-Vidre","Palavas-les-Flots","Paleyrac","Palinges","Palleau","Palluau","Palluau-sur-Indre","Pallud","Pamfou","Pamiers","Pamproux","Panassac","Panazol","Panissieres","Pannece","Pannes","Panossas","Pantin","Panzoult","Paradou","Paray-le-Monial","Paray-sous-Briailles","Paray-Vieille-Poste","Paraza","Parcay-Meslay","Parce-sur-Sarthe","Parcieux","Pareds","Parempuyre","Parent","Parentis-en-Born","Pargny-Filain","Pargny-la-Dhuys","Pargny-les-Bois","Pargny-sur-Saulx","Parigne","Parigne-sur-Braye","Parigny","Paris","Paris 17 Batignolles-Monceau","Parisot","Parly","Parmain","Parnans","Parnay","Parne-sur-Roc","Paron","Parsac","Parthenay","Parthenay-de-Bretagne","Parzac","Pas-en-Artois","Paslieres","Pasly","Pasques","Passel","Passy","Patay","Pau","Pauilhac","Pauillac Haut","Paul","Paulhac","Paulhaguet","Paulhan","Paulx","Pavie","Pavilly","Payrac","Payrin-Augmontel","Payroux","Payzac","Payzac","Peaugres","Peaule","Pebrac","Pechabou","Pechbonnieu","Pecquencourt","Pecqueuse","Pegomas","Peillac","Peille","Peillon","Peillonnex","Peipin","Peisey-Nancroix","Pelissanne","Pellegrue","Pellevoisin","Pellouailles-les-Vignes","Pelousey","Peltre","Pelussin","Penchard","Pencran","Pende","Penestin","Penguily","Penmarch","Pennautier","Penne-dAgenais","Pennedepie","Penol","Penta-di-Casinca","Penvenan","Pepieux","Peray","Percy","Pere","Perenchies","Peret","Peri","Periers","Perignac","Perignat-les-Sarlieve","Perigne","Perigneux","Perigny","Perigny","Perillos","Pern","Pernay","Pernes","Pernes-les-Boulogne","Pernes-les-Fontaines","Perols","Perols","Peron","Peronnas","Peronne","Peronne","Peronne-en-Melantois","Perouse","Peroy-les-Gombries","Perpezac-le-Noir","Perpignan","Perrecy-les-Forges","Perreux","Perreux","Perrex","Perrier","Perriers-sur-Andelle","Perrignier","Perrigny","Perrigny-les-Dijon","Perrogney-les-Fontaines","Perros-Guirec","Perrou","Perruel","Pers","Pers-Jussy","Persan","Persquen","Perthes-les-Brienne","Pertheville-Ners","Pertuis","Pessac","Pessac-sur-Dordogne","Pessan","Pessans","Pessat-Villeneuve","Petit Chaumont","Petit-Couronne","Petit-Landau","Petit-Mars","Petit-Palais-et-Cornemps","Petite-Foret","Petite-Rosselle","Petiville","Petreto-Bicchisano","Peumerit","Pexonne","Pey","Peymeinade","Peynier","Peypin","Peyrat-le-Chateau","Peyrehorade","Peyriac-de-Mer","Peyriac-Minervois","Peyrignac","Peyrilhac","Peyrilles","Peyrins","Peyrissas","Peyrolles-en-Provence","Peyruis","Peyrus","Peyrusse-Massas","Pezenas","Pezens","Pezilla-la-Riviere","Pezou","Pfaffenheim","Pfaffenhoffen","Pfastatt","Pfettisheim","Pfulgriesheim","Phaffans","Phalempin","Phalsbourg","Pia","Piazza","Piblange","Pibrac","Picauville","Picquigny","Piegros-la-Clastre","Piegut-Pluviers","Piennes","Pierre","Pierre-Benite","Pierre-de-Bresse","Pierre-la-Treiche","Pierre-Levee","Pierrefeu-du-Var","Pierrefitte-Nestalas","Pierrefitte-sur-Seine","Pierrefonds","Pierrefort","Pierregot","Pierrelatte","Pierrelaye","Pierremande","Pierrepont-sur-Avre","Pierrerue","Pierres","Pierrevert","Pierrevillers","Pierric","Pierry","Pietralba","Pieusse","Pignan","Pignans","Pignols","Pihem","Pimbo","Pimprez","Pin","Pinet","Pineuilh","Piney","Pinon","Pinsaguel","Piolenc","Pionsat","Pipriac","Piquecos","Pire-sur-Seiche","Pirey","Pirou","Piscop","Piseux","Pissos","Pissotte","Pissy-Poville","Pithiviers","Pitres","Pizay","Plabennec","Place","Plailly","Plaimpied-Givaudins","Plaine-de-Walsch","Plaine-Haute","Plaintel","Plaisance","Plaisance-du-Touch","Plaisir","Plan-de-Cuques","Planay","Plancher-Bas","Planches","Planguenoual","Planzolles","Plappeville","Plassay","Plateau","Plaudren","Plauzat","Pleboulle","Plechatel","Pledran","Plehedel","Plelan-le-Grand","Plelan-le-Petit","Plelauff","Plelo","Plemet","Plenee-Jugon","Pleneuf-Val-Andre","Plerguer","Plerin","Plerneuf","Plescop","Plesidy","Plesnois","Plessala","Plesse","Plessis-Barbuise","Plessis-de-Roye","Plestan","Plestin-les-Greves","Pleucadeuc","Pleudihen-sur-Rance","Pleugriffet","Pleugueneuc","Pleumartin","Pleumeleuc","Pleumeur-Bodou","Pleure","Pleurs","Pleurtuit","Pleuven","Pleyben","Pleyber-Christ","Plobannalec-Lesconil","Plobsheim","Ploemel","Ploemeur","Ploerdut","Ploeren","Ploermel","Ploeuc-sur-Lie","Ploeven","Plogonnec","Plomb","Plombieres-les-Bains","Plombieres-les-Dijon","Plomelin","Plomeur","Plonevez-du-Faou","Plorec-sur-Arguenon","Plottes","Plouagat","Plouaret","Plouarzel","Plouasne","Plouay","Ploubalay","Ploubazlanec","Ploubezre","Ploudalmezeau","Ploudaniel","Plouec-du-Trieux","Plouedern","Plouer-sur-Rance","Plouescat","Plouezec","Ploufragan","Plougar","Plougasnou","Plougastel-Daoulas","Plougonvelin","Plougonven","Plougoulm","Plougoumelen","Plougourvest","Plougrescant","Plouguerneau","Plouguin","Plouha","Plouharnel","Plouigneau","Ploumagoar","Ploumilliau","Ploumoguer","Plouneour-Menez","Plouneour-Trez","Plounerin","Plounevez-Lochrist","Plounevezel","Plourin","Plourivo","Plouvain","Plouvara","Plouvien","Plouvorn","Plouzane","Plozevet","Pludual","Pluduno","Pluguffan","Pluherlin","Plumaugat","Plumeliau","Plumelin","Plumergat","Plumoison","Pluneret","Plurien","Plusquellec","Plussulien","Pluvault","Pluvigner","Pluzunet","Poce-sur-Cisse","Podensac","Poeuilly","Poey-de-Lescar","Poggio-dOletta","Pogny","Poigny-la-Foret","Poilly-lez-Gien","Poilly-sur-Tholon","Poinsenot","Pointis-Inard","Poisat","Poiseul-les-Saulx","Poisieux","Poisson","Poissons","Poissy","Poisy","Poitiers","Poix","Poix-de-Picardie","Poix-du-Nord","Poligny","Poligny","Pollestres","Polliat","Pomacle","Pomarez","Pomerols","Pomeys","Pommard","Pommeret","Pommerit-Jaudy","Pommerit-le-Vicomte","Pommeuse","Pommevic","Pommiers","Pommiers-la-Placette","Pompadour","Pompaire","Pompertuzat","Pompey","Pompidou","Pompignan","Pomponne","Pomport","Poncey-les-Athee","Ponchon","Poncin","Poncins","Pons","Pons","Pont","Pont-a-Marcq","Pont-a-Vendin","Pont-Audemer","Pont-Aven","Pont-de-Barret","Pont-de-Beauvoisin","Pont-de-Briques","Pont-de-Buis-les-Quimerch","Pont-de-Cheruy","Pont-de-Labeaume","Pont-de-Larn","Pont-de-Metz","Pont-de-Roide","Pont-de-Salars","Pont-de-Vaux","Pont-de-Veyle","Pont-du-Casse","Pont-du-Chateau","Pont-en-Royans","Pont-Eveque","Pont-Hebert","Pont-Noyelles","Pont-Remy","Pont-Saint-Esprit","Pont-Saint-Mard","Pont-Saint-Martin","Pont-Saint-Pierre","Pont-Saint-Vincent","Pont-Sainte-Marie","Pont-Sainte-Maxence","Pont-Salomon","Pont-Scorff","Pont-sur-Sambre","Pont-sur-Seine","Pont-sur-Yonne","Pontacq","Pontailler-sur-Saone","Pontarlier","Pontarme","Pontaubault","Pontault-Combault","Pontaumur","Pontaut","Pontavert","Pontcarre","Pontcharra","Pontcharra-sur-Turdine","Pontchateau","Pontcirq","Ponte-Leccia","Ponteilla","Pontenx-les-Forges","Pontgibaud","Pontgouin","Ponthevrard","Ponthierry","Pontigne","Pontigny","Pontivy","Pontlevoy","Pontoise","Pontorson","Pontours","Pontpoint","Pontruet","Ponts","Pontvallain","Popian","Porcelette","Porcheres","Porcheresse","Porcheville","Porcieu-Amblagnieu","Pordic","Pornic","Pornichet","Port-Brillet","Port-Cros","Port-de-Bouc","Port-des-Barques","Port-en-Bessin-Huppain","Port-Joinville","Port-la-Nouvelle","Port-Launay","Port-Louis","Port-Mort","Port-Saint-Louis-du-Rhone","Port-Saint-Pere","Port-Sainte-Foy-et-Ponchapt","Port-Sainte-Marie","Port-sur-Saone","Portbail","Portel-des-Corbieres","Portes-les-Valence","Portet-sur-Garonne","Portets","Porticcio","Portieux","Portiragnes","Porto","Porto-Vecchio","Portrieux","Ports","Portvendres","Poses","Potigny","Pouan-les-Vallees","Pouance","Pouffonds","Pougny","Pougues-les-Eaux","Pougy","Pouille","Pouille","Pouillenay","Pouilley-Francais","Pouilley-les-Vignes","Pouillon","Pouilloux","Pouilly","Pouilly","Pouilly-en-Auxois","Pouilly-le-Monial","Pouilly-les-Nonains","Pouilly-sous-Charlieu","Pouilly-sur-Loire","Pouilly-sur-Serre","Pouilly-sur-Vingeanne","Poulainville","Poulan-Pouzols","Pouldergat","Pouldreuzic","Poule-les-Echarmeaux","Pouligney-Lusans","Poullan-sur-Mer","Poullaouen","Poulx","Pournoy-la-Grasse","Pourrain","Pourrieres","Pouru-Saint-Remy","Poussan","Pouxeux","Pouydesseaux","Pouzauges","Pouzay","Pouzilhac","Pouzolles","Pouzols-Minervois","Poville","Pradelles","Prades","Prades-le-Lez","Pradieres","Prahecq","Pralognan-la-Vanoise","Pranzac","Prasville","Prat","Prats-de-Carlux","Pray","Prayssac","Prayssas","Praz","Praz-sur-Arly","Pre-en-Pail","Preaux","Precey","Prechac","Prechac","Precieux","Precigne","Precorbin","Precy-sous-Thil","Precy-sur-Marne","Precy-sur-Oise","Precy-sur-Vrin","Prefailles","Prefontaines","Preguillac","Preignac","Preignan","Premanon","Premery","Premian","Premontre","Preseau","Presles-en-Brie","Presles-et-Thierny","Pressagny-le-Val","Pressignac-Vicq","Pressigny","Pressigny-les-Pins","Pretot-Vicquemare","Preuschdorf","Prevessin-Moens","Prey","Prigonrieux","Primarette","Primat","Prin-Deyrancon","Princay","Pringy","Pringy","Prinquiau","Prisse","Privas","Prix","Prix-les-Mezieres","Proissans","Prompsat","Pronville","Propriano","Prouais","Prouilly","Prouvy","Prouzel","Provencheres-sur-Fave","Provencheres-sur-Meuse","Proveysieux","Proville","Provin","Provins","Proyart","Prudhomat","Prunay-Cassereau","Prunay-le-Gillon","Prunay-sur-Essonne","Prunelli-di-Fiumorbo","Prunieres","Pruniers","Pruzilly","Publier","Puceul","Puchevillers","Puget-sur-Argens","Puget-Ville","Pugey","Pugieu","Pugnac","Pugny-Chatenod","Puicheric","Puihardy","Puilacher","Puilboreau","Puimichel","Puiseaux","Puiseux-en-France","Puiseux-le-Hauberger","Puisieulx","Puisieux","Puissalicon","Puisseguin","Puisserguier","Pujaudran","Pujaut","Pujo-le-Plan","Pujols","Puligny-Montrachet","Pulligny","Pulnoy","Pulversheim","Pusignan","Pussay","Puteaux","Putot-en-Bessin","Puttelange-les-Thionville","Puy-Guillaume","Puy-Saint-Andre","Puy-Saint-Martin","Puybegon","Puybrun","Puycelsi","Puycornet","Puygouzon","Puygros","Puylaurens","Puyloubier","Puymiclan","Puyravault","Puyravault","Puyreaux","Puyricard","Quaedypre","Quarouble","Quarre-les-Tombes","Quatremare","Queaux","Quebriac","Quedillac","Queige","Quelaines-Saint-Gault","Quelneuc","Quenoche","Querenaing","Quernes","Querqueville","Querrien","Querrieu","Quers","Quesnoy-sur-Deule","Quessoy","Questembert","Quetigny","Quettehou","Quettreville-sur-Sienne","Quevauvillers","Queven","Quevert","Quevillon","Queyrac","Queyrieres","Quezac","Quiberon","Quiberville","Quibou","Quiers","Quievrechain","Quievrecourt","Quievy","Quillan","Quillebeuf-sur-Seine","Quilly","Quilly","Quily","Quimper","Quincampoix","Quincie-en-Beaujolais","Quincieu","Quincy","Quincy-sous-Senart","Quincy-Voisins","Quineville","Quingey","Quinsac","Quint-Fonsegrives","Quintenic","Quintin","Quissac","Rabastens-de-Bigorre","Rabat-les-Trois-Seigneurs","Rablay-sur-Layon","Rabou","Raches","Racquinghem","Racrange","Radinghem","Radinghem-en-Weppes","Radon","Radonvilliers","Raedersheim","Raffetot","Rahon","Rai","Raids","Raimbeaucourt","Rainfreville","Rainneville","Rainville","Rainvillers","Raismes","Raizeux","Ramatuelle","Rambert","Rambervillers","Rambouillet","Rammersmatt","Ramonchamp","Ramonville-Saint-Agne","Rance","Rancogne","Randan","Randan","Randens","Ranes","Rang","Rang-du-Fliers","Rans","Ranspach","Rantigny","Ranville","Raon-aux-Bois","Raon-sur-Plaine","Rarecourt","Ratieres","Ratte","Raucourt-et-Flaba","Rauville-la-Place","Rauwiller","Rauzan","Ravenel","Ravieres","Ray-sur-Saone","Rayssac","Razac-sur-lIsle","Real","Realmont","Realville","Reaumont","Reaumur","Rebais","Rebenacq","Rebrechien","Rebreuve-sur-Canche","Rebreuviette","Recey-sur-Ource","Rechesy","Rechicourt-le-Chateau","Recloses","Recologne","Recologne-les-Rioz","Recques-sur-Course","Recquignies","Redene","Redessan","Reding","Redon","Reffuveille","Regniowez","Reguiny","Reguisheim","Regusse","Rehainviller","Rehon","Reichshoffen","Reichstett","Reignac-sur-Indre","Reignier-Esery","Reillanne","Reilly","Reims","Reims-la-Brulee","Reiners","Reiningue","Reipertswiller","Reitwiller","Relanges","Remaucourt","Remecourt","Remelfang","Remelfing","Remenoville","Remerangles","Remereville","Remering-les-Puttelange","Remigny","Remilly","Reminiac","Remiremont","Remoulins","Remungol","Remuzat","Remy","Renage","Renaison","Renault","Renaze","Rene","Renescure","Rennes","Renneville","Repaix","Reparsac","Replonges","Requeil","Requista","Ressons-le-Long","Ressons-sur-Matz","Restinclieres","Rethel","Rethondes","Retiers","Retonfey","Retournac","Retschwiller","Rettel","Rety","Reuil-en-Brie","Reuil-sur-Breche","Reuilly","Reuilly","Reuilly-Sauvigny","Reumont","Reuves","Revel","Revel-Tourdan","Reventin-Vaugris","Revest-des-Brousses","Reviers","Revigny","Revigny-sur-Ornain","Reville","Revin","Reynies","Reyrieux","Reyssouze","Rezonville","Rhinau","Riaille","Rians","Rians","Riantec","Ribaute-les-Tavernes","Ribecourt-Dreslincourt","Ribemont","Ribemont-sur-Ancre","Riberac","Ribiers","Ricarville","Richardmenil","Richebourg","Richebourg","Richelieu","Richeling","Richemont","Richemont","Richwiller","Ricquebourg","Riec-sur-Belon","Riedisheim","Riedseltz","Riencourt-les-Bapaume","Rieulay","Rieumes","Rieupeyroux","Rieux","Rieux","Rieux","Rieux-de-Pelleport","Rieux-en-Cambresis","Rieux-Minervois","Riez","Rignac","Rignieux-le-Franc","Rilhac-Rancon","Rillieux-la-Pape","Rimbaud","Rimogne","Ringendorf","Rinxent","Riocaud","Riom","Riom-es-Montagnes","Rion-des-Landes","Rions","Riorges","Riotord","Rioz","Ris-Orangis","Rittershoffen","Rivarennes","Rive-de-Gier","Rivecourt","Rivedoux-Plage","Rivery","Rivesaltes","Riviere","Rivieres","Rivieres","Riville","Rixheim","Roaillan","Roanne","Roannes-Saint-Mary","Robert","Robion","Rocbaron","Roche","Roche","Roche-la-Moliere","Roche-le-Peyroux","Roche-lez-Beaupre","Rochechouart","Rochecorbon","Rochefort","Rochefort-du-Gard","Rochefort-en-Terre","Rochefort-sur-Loire","Rochefort-sur-Nenon","Rochegude","Rochemaure","Rocher","Roches","Roches-les-Blamont","Roches-Premarie-Andille","Roches-sur-Marne","Rocheserviere","Rochesson","Rochetoirin","Rochetrejoux","Rochy-Conde","Rocquemont","Rocquencourt","Rocroi","Rodelinghem","Roderen","Rodern","Rodez","Roeschwoog","Roeulx","Roeux","Roeze-sur-Sarthe","Roffey","Roffiac","Rogerville","Rognac","Rognaix","Rognes","Rognonas","Rohan","Rohan","Rohr","Rohrbach-les-Bitche","Roiffieux","Roisel","Roissy-en-Brie","Roissy-en-France","Rolampont","Rollancourt","Rolleville","Rollot","Romagnat","Romagne","Romagne","Romagne","Romagnieu","Romain","Romain-sur-Meuse","Romaine","Romainville","Romaneche-Thorins","Romange","Romans","Rombas","Romegoux","Romeny-sur-Marne","Romeries","Romille","Romilly-sur-Andelle","Romilly-sur-Seine","Romorantin-Lanthenay","Rompon","Roncey","Ronchin","Roncq","Ronnet","Ronno","Ronsenac","Ronthon","Roost-Warendin","Roppe","Roppenheim","Roppentzwiller","Roquebilliere","Roquebrune","Roquebrune-Cap-Martin","Roquebrune-sur-Argens","Roquecor","Roquecourbe","Roquefort","Roquefort","Roquefort-de-Sault","Roquefort-des-Corbieres","Roquefort-la-Bedoule","Roquefort-sur-Garonne","Roquefort-sur-Soulzon","Roquelaure-Saint-Aubin","Roquemaure","Roques","Roqueseriere","Roquesteron","Roquetoire","Roquettes","Roquevaire","Rosay","Rosay-sur-Lieure","Roscoff","Rosel","Rosenwiller","Rosheim","Rosieres","Rosieres-aux-Salines","Rosieres-en-Haye","Rosieres-en-Santerre","Rosieres-pres-Troyes","Rosieres-sur-Mance","Rosny-sous-Bois","Rosny-sur-Seine","Rosoy-en-Multien","Rospez","Rosporden","Rosselange","Rossfeld","Rosteig","Rostrenen","Rosult","Rothau","Rotherens","Rots","Rott","Rouans","Roubaix","Roubia","Roubion","Roucy","Rouen","Rouffach","Rouffiac-Tolosan","Rouffignac","Rouffignac-Saint-Cernin-de-Reilhac","Rouge-Perriers","Rougegoutte","Rougemont","Rougiers","Rouillac","Rouille","Rouillon","Rouilly-Sacey","Roujan","Roulans","Roullens","Roullet-Saint-Estephe","Roumare","Roumazieres","Roumegoux","Roumoules","Rountzenheim","Rouperroux","Rousies","Roussay","Rousseloy","Rousset","Roussillon","Roussillon","Rousson","Roussy","Roussy-le-Village","Routot","Rouville","Rouvillers","Rouvre","Rouvres-la-Chetive","Rouvroy","Rouvroy","Rouvroy-sur-Audry","Rouvroy-sur-Marne","Rouxmesnil-Bouteilles","Rouy-le-Grand","Rouziers-de-Touraine","Roville-aux-Chenes","Royan","Royas","Royat","Roybon","Roye","Roye","Roye-sur-Matz","Rozay-en-Brie","Rozerieulles","Rozier-en-Donzy","Rozieres-en-Beauce","Rozoy-Bellevalle","Rozoy-sur-Serre","Ruaudin","Rubelles","Rubempre","Ruch","Rucqueville","Rue","Rueil-Malmaison","Ruelisheim","Ruelle","Ruelle-sur-Touvre","Ruesnes","Ruffec","Ruffey-les-Beaune","Ruffey-les-Echirey","Ruffey-sur-Seille","Ruffiac","Rugles","Ruille-Froid-Fonds","Ruille-le-Gravelais","Ruitz","Rully","Rully","Rumaucourt","Rumegies","Rumersheim-le-Haut","Rumigny","Rumilly","Rumilly-en-Cambresis","Rungis","Ruoms","Rupt","Rupt-sur-Moselle","Rurange-les-Thionville","Russ","Ruy","Ry","Saacy-sur-Marne","Saales","Sabatier","Sable-sur-Sarthe","Sablonceaux","Sablons","Sabres","Sacey","Sachin","Saclas","Saclay","Sacquenville","Sacy","Sadirac","Saessolsheim","Saffre","Sagy","Sahurs","Saignes","Sail-sous-Couzan","Saillans","Sailly-en-Ostrevent","Sailly-Flibeaucourt","Sailly-Labourse","Sailly-le-Sec","Sailly-lez-Cambrai","Sailly-sur-la-Lys","Sain-Bel","Sainghin-en-Melantois","Sainghin-en-Weppes","Sainneville","Sainpuits","Sains-du-Nord","Sains-en-Amienois","Sains-en-Gohelle","Saint Nicolas Les Arras","Saint-Abit","Saint-Adrien","Saint-Affrique","Saint-Agathon","Saint-Agnant","Saint-Agoulin","Saint-Agreve","Saint-Aignan-des-Noyers","Saint-Aignan-sur-Roe","Saint-Aigulin","Saint-Albain","Saint-Alban-de-Roche","Saint-Alban-du-Rhone","Saint-Alban-Leysse","Saint-Alexandre","Saint-Amancet","Saint-Amand-de-Belves","Saint-Amand-de-Coly","Saint-Amand-en-Puisaye","Saint-Amand-les-Eaux","Saint-Amand-Magnazeix","Saint-Amand-Montrond","Saint-Amand-sur-Fion","Saint-Amans-Soult","Saint-Amans-Valtoret","Saint-Amant-de-Boixe","Saint-Amant-Tallende","Saint-Amarin","Saint-Ambroix","Saint-Amour","Saint-Andeol-de-Vals","Saint-Andeux","Saint-Andiol","Saint-Andre","Saint-Andre-de-Chalencon","Saint-Andre-de-Corcy","Saint-Andre-de-Messei","Saint-Andre-de-Roquelongue","Saint-Andre-de-Rosans","Saint-Andre-de-Sangonis","Saint-Andre-des-Eaux","Saint-Andre-en-Vivarais","Saint-Andre-Farivillers","Saint-Andre-le-Gaz","Saint-Andre-le-Puy","Saint-Andre-les-Alpes","Saint-Andre-les-Vergers","Saint-Andre-lez-Lille","Saint-Andre-sur-Orne","Saint-Andre-Treize-Voies","Saint-Androny","Saint-Angeau","Saint-Angel","Saint-Antoine-Cumond","Saint-Antoine-du-Rocher","Saint-Antoine-la-Foret","Saint-Antonin-sur-Bayon","Saint-Apollinaire","Saint-Appolinard","Saint-Aquilin-de-Pacy","Saint-Armel","Saint-Arnoult","Saint-Arnoult","Saint-Arnoult-des-Bois","Saint-Arnoult-en-Yvelines","Saint-Astier","Saint-Auban","Saint-Aubert","Saint-Aubin","Saint-Aubin-de-Baubigne","Saint-Aubin-de-Lanquais","Saint-Aubin-de-Medoc","Saint-Aubin-des-Chateaux","Saint-Aubin-du-Cormier","Saint-Aubin-du-Plain","Saint-Aubin-en-Bray","Saint-Aubin-en-Charollais","Saint-Aubin-les-Elbeuf","Saint-Aubin-les-Forges","Saint-Aubin-sous-Erquery","Saint-Aubin-sur-Gaillon","Saint-Aubin-sur-Mer","Saint-Aubin-sur-Scie","Saint-Augustin","Saint-Augustin","Saint-Augustin","Saint-Aunes","Saint-Avaugourd-des-Landes","Saint-Ave","Saint-Avertin","Saint-Avit","Saint-Avit-les-Guespieres","Saint-Avold","Saint-Avre","Saint-Ay","Saint-Aygulf","Saint-Baldoph","Saint-Bardoux","Saint-Barnabe","Saint-Barnabe","Saint-Barthelemy-de-Bussiere","Saint-Barthelemy-de-Vals","Saint-Barthelemy-Lestra","Saint-Baudille-de-la-Tour","Saint-Bauzille-de-Montmel","Saint-Bauzille-de-Putois","Saint-Beat","Saint-Benezet","Saint-Benin-dAzy","Saint-Benoit","Saint-Benoit-des-Ondes","Saint-Benoit-sur-Loire","Saint-Berain-sur-Dheune","Saint-Bernard","Saint-Beron","Saint-Berthevin","Saint-Bihy","Saint-Blaise-la-Roche","Saint-Bohaire","Saint-Boil","Saint-Boingt","Saint-Bonnet-de-Mure","Saint-Bonnet-le-Chateau","Saint-Bonnet-le-Troncy","Saint-Bonnet-les-Allier","Saint-Branchs","Saint-Brandan","Saint-Bres","Saint-Brevin-les-Pins","Saint-Briac-sur-Mer","Saint-Brice","Saint-Brice-de-Landelles","Saint-Brice-sous-Foret","Saint-Brieuc","Saint-Bris-le-Vineux","Saint-Brisson-sur-Loire","Saint-Calais","Saint-Cannat","Saint-Caprais-de-Bordeaux","Saint-Carne","Saint-Carreuc","Saint-Cassin","Saint-Cast-le-Guildo","Saint-Cere","Saint-Cergues","Saint-Cesaire","Saint-Cezaire-sur-Siagne","Saint-Cezert","Saint-Chamassy","Saint-Chamond","Saint-Chaptes","Saint-Chartres","Saint-Chef","Saint-Cheron-du-Chemin","Saint-Chinian","Saint-Christo-en-Jarez","Saint-Christol","Saint-Christol","Saint-Christol-les-Ales","Saint-Christophe-de-Valains","Saint-Christophe-du-Bois","Saint-Christophe-du-Ligneron","Saint-Christophe-en-Boucherie","Saint-Christophe-en-Brionnais","Saint-Christophe-sur-Avre","Saint-Christophe-sur-Guiers","Saint-Christophe-sur-le-Nais","Saint-Christophe-sur-Roc","Saint-Ciers-sur-Gironde","Saint-Cirgues","Saint-Clair","Saint-Clair-de-la-Tour","Saint-Clair-du-Rhone","Saint-Clair-sur-Galaure","Saint-Clar-de-Riviere","Saint-Claud","Saint-Claude","Saint-Claude-de-Diray","Saint-Clement","Saint-Clement","Saint-Clement","Saint-Clement-de-la-Place","Saint-Clement-des-Levees","Saint-Clet","Saint-Cloud","Saint-Colomban","Saint-Congard","Saint-Contest","Saint-Corneille","Saint-Cornier-des-Landes","Saint-Coulitz","Saint-Coulomb","Saint-Creac","Saint-Crepin-Ibouvillers","Saint-Crespin-sur-Moine","Saint-Cyprien","Saint-Cyprien","Saint-Cyprien-Plage","Saint-Cyr-du-Gault","Saint-Cyr-en-Pail","Saint-Cyr-en-Val","Saint-Cyr-la-Campagne","Saint-Cyr-le-Chatoux","Saint-Cyr-les-Champagnes","Saint-Cyr-sur-le-Rhone","Saint-Cyr-sur-Loire","Saint-Cyr-sur-Menthon","Saint-Cyr-sur-Mer","Saint-Cyr-sur-Morin","Saint-Denis","Saint-Denis-dAnjou","Saint-Denis-de-Cabanne","Saint-Denis-de-Palin","Saint-Denis-de-Pile","Saint-Denis-de-Vaux","Saint-Denis-des-Murs","Saint-Denis-en-Bugey","Saint-Denis-en-Val","Saint-Denis-le-Gast","Saint-Denis-le-Thiboult","Saint-Denis-les-Rebais","Saint-Denis-sur-Coise","Saint-Denis-sur-Sarthon","Saint-Derrien","Saint-Desir","Saint-Desirat","Saint-Desire","Saint-Dezery","Saint-Didier-de-Formans","Saint-Didier-de-la-Tour","Saint-Didier-en-Donjon","Saint-Didier-en-Velay","Saint-Didier-sous-Riverie","Saint-Didier-sur-Chalaronne","Saint-Didier-sur-Rochefort","Saint-Die-des-Vosges","Saint-Dionisy","Saint-Disdier","Saint-Divy","Saint-Dizier","Saint-Dizier-en-Diois","Saint-Dolay","Saint-Domet","Saint-Domineuc","Saint-Donan","Saint-Doulchard","Saint-Drezery","Saint-Ebremond-de-Bonfosse","Saint-Elier","Saint-Eliph","Saint-Elix-Seglan","Saint-Eloi","Saint-Eloi","Saint-Eloy-de-Gy","Saint-Eloy-la-Glaciere","Saint-Eloy-les-Mines","Saint-Emilion","Saint-Erblon","Saint-Erme-Outre-et-Ramecourt","Saint-Esteve","Saint-Esteve-Janson","Saint-Etienne","Saint-Etienne-au-Mont","Saint-Etienne-au-Temple","Saint-Etienne-de-Baigorry","Saint-Etienne-de-Brillouet","Saint-Etienne-de-Crossey","Saint-Etienne-de-Cuines","Saint-Etienne-de-Fontbellon","Saint-Etienne-de-Montluc","Saint-Etienne-de-Saint-Geoirs","Saint-Etienne-de-Tinee","Saint-Etienne-de-Tulmont","Saint-Etienne-de-Valoux","Saint-Etienne-des-Oullieres","Saint-Etienne-du-Bois","Saint-Etienne-du-Gres","Saint-Etienne-du-Valdonnez","Saint-Etienne-du-Vauvray","Saint-Etienne-en-Cogles","Saint-Etienne-la-Varenne","Saint-Etienne-le-Molard","Saint-Etienne-les-Orgues","Saint-Etienne-sous-Bailleul","Saint-Etienne-sur-Chalaronne","Saint-Etienne-sur-Suippe","Saint-Eulien","Saint-Eustache-la-Foret","Saint-Evarzec","Saint-Faust","Saint-Felicien","Saint-Felix-de-Rieutord","Saint-Felix-de-Villadeix","Saint-Fiacre","Saint-Fiacre-sur-Maine","Saint-Firmin","Saint-Firmin-des-Pres","Saint-Florent","Saint-Florent-le-Vieil","Saint-Florent-sur-Auzonnet","Saint-Florent-sur-Cher","Saint-Florentin","Saint-Floret","Saint-Floris","Saint-Flour","Saint-Flovier","Saint-Folquin","Saint-Fons","Saint-Forgeux","Saint-Fort","Saint-Fregant","Saint-Fromond","Saint-Front","Saint-Front","Saint-Fulgent","Saint-Fuscien","Saint-Galmier","Saint-Gatien-des-Bois","Saint-Gaudens","Saint-Gaultier","Saint-Gein","Saint-Gelais","Saint-Gely-du-Fesc","Saint-Gence","Saint-Generoux","Saint-Genes-du-Retz","Saint-Genest-Lerpt","Saint-Genest-Malifaux","Saint-Gengoux-de-Scisse","Saint-Genies-Bellevue","Saint-Genies-de-Comolas","Saint-Genies-de-Malgoires","Saint-Genies-des-Mourgues","Saint-Genis-Laval","Saint-Genis-les-Ollieres","Saint-Genis-Pouilly","Saint-Genix-sur-Guiers","Saint-Genou","Saint-Geoire-en-Valdaine","Saint-Geoirs","Saint-Georges-de-Baroille","Saint-Georges-de-Didonne","Saint-Georges-de-Luzencon","Saint-Georges-de-Montaigu","Saint-Georges-de-Pointindoux","Saint-Georges-de-Poisieux","Saint-Georges-de-Reneins","Saint-Georges-des-Coteaux","Saint-Georges-du-Bois","Saint-Georges-du-Rosay","Saint-Georges-du-Vievre","Saint-Georges-Haute-Ville","Saint-Georges-le-Flechard","Saint-Georges-les-Baillargeaux","Saint-Georges-Montcocq","Saint-Georges-sur-Allier","Saint-Georges-sur-Arnon","Saint-Georges-sur-Baulche","Saint-Georges-sur-Cher","Saint-Georges-sur-Eure","Saint-Georges-sur-Fontaine","Saint-Georges-sur-Loire","Saint-Georges-sur-Renon","Saint-Gerand","Saint-Gerand-de-Vaux","Saint-Gereon","Saint-Germain","Saint-Germain-de-Joux","Saint-Germain-de-la-Grange","Saint-Germain-de-Princay","Saint-Germain-de-Tournebut","Saint-Germain-des-Fosses","Saint-Germain-des-Pres","Saint-Germain-du-Corbeis","Saint-Germain-du-Plain","Saint-Germain-du-Puch","Saint-Germain-du-Puy","Saint-Germain-en-Laye","Saint-Germain-la-Blanche-Herbe","Saint-Germain-la-Ville","Saint-Germain-Langot","Saint-Germain-Laprade","Saint-Germain-Laxis","Saint-Germain-Lembron","Saint-Germain-les-Arpajon","Saint-Germain-les-Belles","Saint-Germain-les-Corbeil","Saint-Germain-les-Paroisses","Saint-Germain-les-Vergnes","Saint-Germain-Nuelles","Saint-Germain-sous-Doue","Saint-Germain-sur-Avre","Saint-Germain-sur-Moine","Saint-Germain-sur-Morin","Saint-Germain-sur-Rhone","Saint-Germain-Village","Saint-Germainmont","Saint-Germer-de-Fly","Saint-Gervais-en-Belin","Saint-Gervais-la-Foret","Saint-Gervais-les-Bains","Saint-Gervais-sous-Meymont","Saint-Gervais-sur-Roubion","Saint-Gervazy","Saint-Geyrac","Saint-Gildas-des-Bois","Saint-Gilles","Saint-Gilles-des-Marais","Saint-Gilles-les-Bois","Saint-Gingolph","Saint-Girons","Saint-Goazec","Saint-Gobain","Saint-Gondon","Saint-Gondran","Saint-Gonnery","Saint-Gratien","Saint-Gratien","Saint-Grave","Saint-Gregoire","Saint-Gregoire","Saint-Guilhem-le-Desert","Saint-Guinoux","Saint-Heand","Saint-Helen","Saint-Herblain","Saint-Herve","Saint-Hilaire-Cusson-la-Valmitte","Saint-Hilaire-de-Brethmas","Saint-Hilaire-de-Chaleons","Saint-Hilaire-de-Court","Saint-Hilaire-de-la-Cote","Saint-Hilaire-de-Loulay","Saint-Hilaire-de-Riez","Saint-Hilaire-de-Talmont","Saint-Hilaire-de-Voust","Saint-Hilaire-du-Harcouet","Saint-Hilaire-le-Vouhis","Saint-Hilaire-les-Andresis","Saint-Hilaire-les-Courbes","Saint-Hilaire-lez-Cambrai","Saint-Hilaire-Peyroux","Saint-Hilaire-Saint-Mesmin","Saint-Hilarion","Saint-Hilliers","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte-de-Montaigu","Saint-Hippolyte-du-Fort","Saint-Honore-les-Bains","Saint-Hostien","Saint-Igneuc","Saint-Illide","Saint-Imoges","Saint-Ismier","Saint-Jacques-de-la-Lande","Saint-Jean-aux-Amognes","Saint-Jean-Bonnefonds","Saint-Jean-Brevelay","Saint-Jean-de-Boiseau","Saint-Jean-de-Bournay","Saint-Jean-de-Braye","Saint-Jean-de-Chevelu","Saint-Jean-de-Cornies","Saint-Jean-de-Gonville","Saint-Jean-de-la-Ruelle","Saint-Jean-de-Laur","Saint-Jean-de-Lier","Saint-Jean-de-Liversay","Saint-Jean-de-Losne","Saint-Jean-de-Luz","Saint-Jean-de-Marcel","Saint-Jean-de-Marsacq","Saint-Jean-de-Maurienne","Saint-Jean-de-Moirans","Saint-Jean-de-Monts","Saint-Jean-de-Muzols","Saint-Jean-de-Sauves","Saint-Jean-de-Serres","Saint-Jean-de-Sixt","Saint-Jean-de-Soudain","Saint-Jean-de-Vedas","Saint-Jean-des-Baisants","Saint-Jean-des-Champs","Saint-Jean-des-Mauvrets","Saint-Jean-des-Ollieres","Saint-Jean-des-Vignes","Saint-Jean-du-Bruel","Saint-Jean-du-Cardonnay","Saint-Jean-du-Falga","Saint-Jean-en-Royans","Saint-Jean-Kerdaniel","Saint-Jean-Kourtzerode","Saint-Jean-la-Poterie","Saint-Jean-Lasseille","Saint-Jean-le-Blanc","Saint-Jean-le-Blanc","Saint-Jean-le-Centenier","Saint-Jean-le-Thomas","Saint-Jean-les-Deux-Jumeaux","Saint-Jean-Ligoure","Saint-Jean-Pied-de-Port","Saint-Jean-Rohrbach","Saint-Jean-Saint-Germain","Saint-Jean-sur-Erve","Saint-Jean-sur-Vilaine","Saint-Jean-Trolimon","Saint-Jeannet","Saint-Jeoire","Saint-Jeoire-Prieure","Saint-Jeures","Saint-Joachim","Saint-Jorioz","Saint-Jory","Saint-Joseph-de-Riviere","Saint-Jouan-des-Guerets","Saint-Jouvent","Saint-Judoce","Saint-Julien","Saint-Julien-de-Cassagnas","Saint-Julien-de-Chedon","Saint-Julien-de-Concelles","Saint-Julien-de-Coppel","Saint-Julien-de-Lampon","Saint-Julien-de-Vouvantes","Saint-Julien-des-Landes","Saint-Julien-du-Puy","Saint-Julien-du-Sault","Saint-Julien-en-Born","Saint-Julien-en-Champsaur","Saint-Julien-en-Genevois","Saint-Julien-le-Roux","Saint-Julien-le-Vendomois","Saint-Julien-les-Metz","Saint-Julien-les-Villas","Saint-Julien-sur-Bibost","Saint-Julien-sur-Sarthe","Saint-Junien","Saint-Just-Chaleyssin","Saint-Just-de-Claix","Saint-Just-en-Bas","Saint-Just-en-Chaussee","Saint-Just-en-Chevalet","Saint-Just-le-Martel","Saint-Just-Malmont","Saint-Just-pres-Brioude","Saint-Lactencin","Saint-Lager","Saint-Lager-Bressac","Saint-Lambert-du-Lattay","Saint-Lambert-la-Potherie","Saint-Lambert-sur-Dive","Saint-Lanne","Saint-Lary-Boujean","Saint-Lary-Soulan","Saint-Launeuc","Saint-Laurent-Blangy","Saint-Laurent-Bretagne","Saint-Laurent-de-la-Plaine","Saint-Laurent-de-la-Pree","Saint-Laurent-de-la-Salanque","Saint-Laurent-de-Levezou","Saint-Laurent-de-Mure","Saint-Laurent-de-Neste","Saint-Laurent-des-Autels","Saint-Laurent-des-Combes","Saint-Laurent-du-Bois","Saint-Laurent-du-Mottay","Saint-Laurent-du-Pont","Saint-Laurent-du-Var","Saint-Laurent-en-Beaumont","Saint-Laurent-en-Gatines","Saint-Laurent-la-Roche","Saint-Laurent-Rochefort","Saint-Laurent-sur-Gorre","Saint-Laurent-sur-Sevre","Saint-Laurs","Saint-Leger-aux-Bois","Saint-Leger-de-Rotes","Saint-Leger-des-Vignes","Saint-Leger-du-Bourg-Denis","Saint-Leger-en-Bray","Saint-Leger-les-Domart","Saint-Leger-sous-Brienne","Saint-Leger-sous-Cholet","Saint-Leger-sur-Dheune","Saint-Leonard","Saint-Leonard-de-Noblat","Saint-Leu-la-Foret","Saint-Lezin","Saint-Lieux-les-Lavaur","Saint-Lormel","Saint-Loubes","Saint-Louis","Saint-Louis-de-Montferrand","Saint-Loup","Saint-Loup-Cammas","Saint-Loup-Hors","Saint-Lubin-des-Joncherets","Saint-Lumier-en-Champagne","Saint-Lumine-de-Clisson","Saint-Luperce","Saint-Lupicin","Saint-Lye","Saint-Lye-la-Foret","Saint-Lyphard","Saint-Lys","Saint-Macaire","Saint-Macaire-du-Bois","Saint-Macaire-en-Mauges","Saint-Magne-de-Castillon","Saint-Maigner","Saint-Maigrin","Saint-Maime","Saint-Maixant","Saint-Malo-de-Guersac","Saint-Malo-de-la-Lande","Saint-Malo-de-Phily","Saint-Malo-du-Bois","Saint-Malo-en-Donziois","Saint-Mamert-du-Gard","Saint-Mamet-la-Salvetat","Saint-Mammes","Saint-Mande","Saint-Mandrier-sur-Mer","Saint-Marc-Jaumegarde","Saint-Marceau","Saint-Marcel-Bel-Accueil","Saint-Marcel-les-Valence","Saint-Marcel-sur-Aude","Saint-Marcellin","Saint-Marcellin-en-Forez","Saint-Mard","Saint-Mard-de-Vaux","Saint-Mariens","Saint-Mars-de-Coutais","Saint-Mars-de-Locquenay","Saint-Mars-du-Desert","Saint-Mars-la-Jaille","Saint-Martial","Saint-Martial-de-Vitaterne","Saint-Martin-au-Laert","Saint-Martin-Belle-Roche","Saint-Martin-Bellevue","Saint-Martin-Boulogne","Saint-Martin-Choquel","Saint-Martin-de-Belleville","Saint-Martin-de-Bernegoue","Saint-Martin-de-Blagny","Saint-Martin-de-Crau","Saint-Martin-de-Fontenay","Saint-Martin-de-la-Brasque","Saint-Martin-de-Lenne","Saint-Martin-de-Londres","Saint-Martin-de-Nigelles","Saint-Martin-de-Re","Saint-Martin-de-Riberac","Saint-Martin-de-Seignanx","Saint-Martin-de-Valamas","Saint-Martin-de-Valgalgues","Saint-Martin-des-Bois","Saint-Martin-des-Champs","Saint-Martin-des-Champs","Saint-Martin-des-Noyers","Saint-Martin-des-Olmes","Saint-Martin-du-Bois","Saint-Martin-du-Bois","Saint-Martin-du-Bosc","Saint-Martin-du-Manoir","Saint-Martin-du-Mont","Saint-Martin-du-Puy","Saint-Martin-du-Tertre","Saint-Martin-du-Tilleul","Saint-Martin-du-Var","Saint-Martin-en-Biere","Saint-Martin-en-Bresse","Saint-Martin-en-Campagne","Saint-Martin-en-Gatinois","Saint-Martin-en-Haut","Saint-Martin-la-Campagne","Saint-Martin-la-Plaine","Saint-Martin-Lacaussade","Saint-Martin-Lalande","Saint-Martin-le-Beau","Saint-Martin-le-Noeud","Saint-Martin-le-Pin","Saint-Martin-le-Vieil","Saint-Martin-le-Vinoux","Saint-Martin-les-Melle","Saint-Martin-Longueau","Saint-Martin-Osmonville","Saint-Martin-Sainte-Catherine","Saint-Martin-sur-Arve","Saint-Martin-sur-le-Pre","Saint-Martin-sur-Nohain","Saint-Martin-sur-Ocre","Saint-Martin-Terressus","Saint-Martin-Valmeroux","Saint-Mary","Saint-Mathieu-de-Treviers","Saint-Mathurin","Saint-Maudan","Saint-Maulvis","Saint-Maurice","Saint-Maurice-de-Cazevieille","Saint-Maurice-de-Gourdans","Saint-Maurice-de-Lignon","Saint-Maurice-de-Remens","Saint-Maurice-la-Clouere","Saint-Maurice-la-Souterraine","Saint-Maurice-les-Brousses","Saint-Maurice-Montcouronne","Saint-Maurice-sur-Aveyron","Saint-Maurice-sur-Dargoire","Saint-Maurice-sur-Eygues","Saint-Maurice-sur-Fessard","Saint-Maurice-sur-Moselle","Saint-Max","Saint-Maxent","Saint-Maximin","Saint-Maximin","Saint-Maximin","Saint-Maximin-la-Sainte-Baume","Saint-Maxire","Saint-Meard-de-Gurcon","Saint-Medard-de-Guizieres","Saint-Medard-en-Forez","Saint-Meen-le-Grand","Saint-Melaine-sur-Aubance","Saint-Meloir-des-Ondes","Saint-Meme-les-Carrieres","Saint-Memmie","Saint-Michel","Saint-Michel","Saint-Michel-Chef-Chef","Saint-Michel-de-Chabrillanoux","Saint-Michel-de-Maurienne","Saint-Michel-de-Rieufret","Saint-Michel-de-Volangis","Saint-Michel-des-Andaines","Saint-Michel-le-Cloucq","Saint-Michel-lObservatoire","Saint-Michel-Mont-Mercure","Saint-Michel-sous-Bois","Saint-Michel-sur-Meurthe","Saint-Michel-sur-Orge","Saint-Michel-sur-Savasse","Saint-Michel-sur-Ternoise","Saint-Michel-Treve","Saint-Mihiel","Saint-Mitre-les-Remparts","Saint-Morillon","Saint-Nabord","Saint-Nauphary","Saint-Nazaire","Saint-Nazaire","Saint-Nazaire-de-Valentane","Saint-Nectaire","Saint-Nicolas-de-Bliquetuit","Saint-Nicolas-de-la-Grave","Saint-Nicolas-de-Port","Saint-Nicolas-de-Redon","Saint-Nicolas-du-Pelem","Saint-Nolff","Saint-Nom-la-Breteche","Saint-Offenge-Dessous","Saint-Offenge-Dessus","Saint-Omer","Saint-Omer-en-Chaussee","Saint-Orens-de-Gameville","Saint-Orens-Pouy-Petit","Saint-Ouen","Saint-Ouen","Saint-Ouen-de-Thouberville","Saint-Ouen-des-Besaces","Saint-Ouen-des-Toits","Saint-Ouen-du-Breuil","Saint-Ouen-du-Mesnil-Oger","Saint-Ouen-du-Tilleul","Saint-Ouen-en-Brie","Saint-Ouen-les-Parey","Saint-Ouen-sur-Iton","Saint-Ouen-sur-Morin","Saint-Oulph","Saint-Ours","Saint-Pabu","Saint-Pair-du-Mont","Saint-Pair-sur-Mer","Saint-Pal-de-Mons","Saint-Palais","Saint-Pancre","Saint-Pandelon","Saint-Pantaleon-de-Larche","Saint-Papoul","Saint-Pardoux-du-Breuil","Saint-Pargoire","Saint-Parize-le-Chatel","Saint-Parres-aux-Tertres","Saint-Parres-les-Vaudes","Saint-Paterne","Saint-Paterne-Racan","Saint-Pathus","Saint-Patrice-de-Claids","Saint-Paul","Saint-Paul","Saint-Paul-de-Jarrat","Saint-Paul-de-Varces","Saint-Paul-de-Vence","Saint-Paul-de-Vezelin","Saint-Paul-du-Vernay","Saint-Paul-en-Chablais","Saint-Paul-en-Cornillon","Saint-Paul-en-Foret","Saint-Paul-en-Jarez","Saint-Paul-en-Pareds","Saint-Paul-les-Dax","Saint-Paul-les-Durance","Saint-Paul-les-Romans","Saint-Paul-Trois-Chateaux","Saint-Paulet-de-Caisson","Saint-Pee-sur-Nivelle","Saint-Pellerin","Saint-Peray","Saint-Perdon","Saint-Pere","Saint-Pere-en-Retz","Saint-Pern","Saint-Philbert-de-Bouaine","Saint-Philbert-de-Grand-Lieu","Saint-Philbert-du-Pont-Charrault","Saint-Philibert","Saint-Piat","Saint-Pierre-Bois","Saint-Pierre-Brouck","Saint-Pierre-dAllevard","Saint-Pierre-de-Boeuf","Saint-Pierre-de-Bressieux","Saint-Pierre-de-Chandieu","Saint-Pierre-de-Jards","Saint-Pierre-de-Lages","Saint-Pierre-de-Maille","Saint-Pierre-de-Mons","Saint-Pierre-de-Plesguen","Saint-Pierre-de-Trivisy","Saint-Pierre-de-Varengeville","Saint-Pierre-de-Varennes","Saint-Pierre-des-Corps","Saint-Pierre-des-Echaubrognes","Saint-Pierre-des-Fleurs","Saint-Pierre-du-Chemin","Saint-Pierre-du-Mont","Saint-Pierre-du-Palais","Saint-Pierre-du-Perray","Saint-Pierre-du-Regard","Saint-Pierre-du-Vauvray","Saint-Pierre-en-Port","Saint-Pierre-en-Val","Saint-Pierre-la-Bourlhonne","Saint-Pierre-la-Cour","Saint-Pierre-la-Garenne","Saint-Pierre-la-Palud","Saint-Pierre-Lavis","Saint-Pierre-le-Chastel","Saint-Pierre-le-Moutier","Saint-Pierre-le-Vieux","Saint-Pierre-le-Vieux","Saint-Pierre-les-Elbeuf","Saint-Pierre-Montlimart","Saint-Pierre-sur-Dives","Saint-Pierre-Tarentaine","Saint-Pierreville","Saint-Pol-sur-Mer","Saint-Pol-sur-Ternoise","Saint-Pompont","Saint-Pont","Saint-Porchaire","Saint-Porquier","Saint-Pouange","Saint-Pourcain-sur-Sioule","Saint-Prest","Saint-Priest-des-Champs","Saint-Priest-en-Jarez","Saint-Priest-la-Roche","Saint-Priest-la-Vetre","Saint-Priest-Taurion","Saint-Prim","Saint-Privat","Saint-Privat","Saint-Privat-de-Vallongue","Saint-Privat-la-Montagne","Saint-Prix","Saint-Projet","Saint-Prouant","Saint-Pryve-Saint-Mesmin","Saint-Python","Saint-Quay-Perros","Saint-Quay-Portrieux","Saint-Quentin","Saint-Quentin-de-Baron","Saint-Quentin-du-Dropt","Saint-Quentin-en-Mauges","Saint-Quentin-Fallavier","Saint-Quentin-la-Poterie","Saint-Quentin-le-Verger","Saint-Quentin-les-Chardonnets","Saint-Quentin-sur-Indrois","Saint-Quentin-sur-le-Homme","Saint-Rambert-en-Bugey","Saint-Regle","Saint-Remeze","Saint-Remimont","Saint-Remy","Saint-Remy","Saint-Remy","Saint-Remy-du-Nord","Saint-Remy-en-Mauges","Saint-Remy-en-Rollat","Saint-Remy-la-Vanne","Saint-Remy-la-Varenne","Saint-Remy-les-Chevreuse","Saint-Remy-sur-Avre","Saint-Remy-sur-Durolle","Saint-Renan","Saint-Reverien","Saint-Riquier","Saint-Rirand","Saint-Robert","Saint-Roch","Saint-Rogatien","Saint-Romain-de-Colbosc","Saint-Romain-de-Lerps","Saint-Romain-en-Gal","Saint-Romain-en-Gier","Saint-Romain-la-Motte","Saint-Romain-la-Virvee","Saint-Romain-Lachalm","Saint-Romain-le-Preux","Saint-Romain-le-Puy","Saint-Romain-les-Atheux","Saint-Rome-de-Tarn","Saint-Saens","Saint-Saire","Saint-Samson-sur-Rance","Saint-Sandoux","Saint-Sardos","Saint-Saturnin-du-Limet","Saint-Saturnin-les-Apt","Saint-Saturnin-les-Avignon","Saint-Saturnin-sur-Loire","Saint-Saulge","Saint-Saulve","Saint-Sauvant","Saint-Sauveur-dAunis","Saint-Sauveur-de-Montagut","Saint-Sauveur-Gouvernet","Saint-Sauveur-la-Sagne","Saint-Sauveur-le-Vicomte","Saint-Sauveur-Lendelin","Saint-Savin","Saint-Savin","Saint-Savin","Saint-Savinien","Saint-Saviol","Saint-Savournin","Saint-Sebastien","Saint-Sebastien","Saint-Sebastien-de-Morsent","Saint-Secondin","Saint-Segal","Saint-Seglin","Saint-Seine-sur-Vingeanne","Saint-Selve","Saint-Senoch","Saint-Senoux","Saint-Series","Saint-Sernin","Saint-Sernin-du-Bois","Saint-Servant","Saint-Seurin-de-Cadourne","Saint-Seurin-de-Cursac","Saint-Seurin-de-Prats","Saint-Sever","Saint-Sever-Calvados","Saint-Siffret","Saint-Sigismond","Saint-Simeon-de-Bressieux","Saint-Simon","Saint-Simon-de-Pellouaille","Saint-Sixt","Saint-Sixte","Saint-Sorlin-en-Valloire","Saint-Souplet","Saint-Soupplets","Saint-Suliac","Saint-Sulpice-de-Faleyrens","Saint-Sulpice-de-Royan","Saint-Sulpice-et-Cameyrac","Saint-Sulpice-la-Foret","Saint-Sulpice-le-Vieux","Saint-Sulpice-les-Feuilles","Saint-Sulpice-sur-Leze","Saint-Sulpice-sur-Risle","Saint-Sylvain","Saint-Sylvestre-sur-Lot","Saint-Symphorien-de-Lay","Saint-Symphorien-dOzon","Saint-Symphorien-sur-Coise","Saint-Symphorien-sur-Saone","Saint-Theodorit","Saint-Thibaud-de-Couz","Saint-Thibault","Saint-Thibault-des-Vignes","Saint-Thibery","Saint-Thierry","Saint-Thurial","Saint-Trivier-de-Courtes","Saint-Trivier-sur-Moignans","Saint-Trojan-les-Bains","Saint-Tropez","Saint-Tugdual","Saint-Urbain","Saint-Urbain","Saint-Urbain-Maconcourt","Saint-Usage","Saint-Uze","Saint-Vaast-du-Val","Saint-Vaast-en-Auge","Saint-Vaast-la-Hougue","Saint-Vaast-les-Mello","Saint-Valery-en-Caux","Saint-Valery-sur-Somme","Saint-Vallier","Saint-Vallier","Saint-Vallier-de-Thiey","Saint-Varent","Saint-Vaury","Saint-Venant","Saint-Verand","Saint-Viance","Saint-Viatre","Saint-Viaud","Saint-Victor-de-Cessieu","Saint-Victor-la-Coste","Saint-Victor-sur-Arlanc","Saint-Victor-sur-Loire","Saint-Victor-sur-Rhins","Saint-Victoret","Saint-Victurnien","Saint-Vigor","Saint-Vincent-de-Connezac","Saint-Vincent-de-Durfort","Saint-Vincent-de-Paul","Saint-Vincent-de-Tyrosse","Saint-Vincent-des-Landes","Saint-Vincent-sur-Graon","Saint-Vit","Saint-Vital","Saint-Vite","Saint-Vivien","Saint-Vivien-de-Medoc","Saint-Vrain","Saint-Vulbas","Saint-Witz","Saint-Xandre","Saint-Ybars","Saint-Yorre","Saint-Yrieix-la-Perche","Saint-Yrieix-sur-Charente","Saint-Yvi","Saint-Yzan-de-Soudiac","Saint-Zacharie","Sainte-Adresse","Sainte-Anastasie-sur-Issole","Sainte-Anne-Saint-Priest","Sainte-Anne-sur-Vilaine","Sainte-Austreberthe","Sainte-Bazeille","Sainte-Blandine","Sainte-Catherine","Sainte-Catherine","Sainte-Cecile","Sainte-Cecile","Sainte-Colombe-de-Duras","Sainte-Colombe-sur-Gand","Sainte-Colombe-sur-Guette","Sainte-Consorce","Sainte-Croix","Sainte-Croix-aux-Mines","Sainte-Croix-en-Jarez","Sainte-Croix-en-Plaine","Sainte-Croix-Grand-Tonne","Sainte-Croix-Hague","Sainte-Croix-Volvestre","Sainte-Eanne","Sainte-Enimie","Sainte-Eulalie-en-Born","Sainte-Eusoye","Sainte-Fauste","Sainte-Fereole","Sainte-Flaive-des-Loups","Sainte-Florence","Sainte-Florine","Sainte-Fortunade","Sainte-Foy-de-Longas","Sainte-Foy-de-Peyrolieres","Sainte-Foy-la-Grande","Sainte-Foy-les-Lyon","Sainte-Gemme-la-Plaine","Sainte-Gemme-Martaillac","Sainte-Genevieve","Sainte-Genevieve","Sainte-Helene","Sainte-Hermine","Sainte-Honorine-du-Fay","Sainte-Livrade-sur-Lot","Sainte-Luce-sur-Loire","Sainte-Lucie de Porto-Vecchio","Sainte-Lucie-de-Tallano","Sainte-Marguerite","Sainte-Marguerite-des-Loges","Sainte-Marie","Sainte-Marie-aux-Chenes","Sainte-Marie-aux-Mines","Sainte-Marie-Cappel","Sainte-Marie-de-Chignac","Sainte-Marie-de-Cuines","Sainte-Marie-de-Re","Sainte-Marie-du-Mont","Sainte-Marie-Kerque","Sainte-Marie-Laumont","Sainte-Maure-de-Touraine","Sainte-Maxime","Sainte-Menehould","Sainte-Mere-Eglise","Sainte-Neomaye","Sainte-Opportune-du-Bosc","Sainte-Ouenne","Sainte-Pazanne","Sainte-Preuve","Sainte-Radegonde","Sainte-Reine-de-Bretagne","Sainte-Sabine-sur-Longeve","Sainte-Savine","Sainte-Seve","Sainte-Sigolene","Sainte-Solange","Sainte-Soulle","Sainte-Suzanne","Sainte-Terre","Sainte-Tulle","Sainte-Valiere","Sainte-Verge","Saintes","Saintes-Maries-de-la-Mer","Saintry-sur-Seine","Saints","Saints-Geosmes","Sainville","Saissac","Saisseval","Saivres","Saix","Salagnon","Salaise-sur-Sanne","Salans","Salbert","Salbris","Saleich","Saleilles","Salernes","Salers","Sales","Saleux","Salies-de-Bearn","Salies-du-Salat","Saligny","Saligny-le-Vif","Saligny-sur-Roudon","Salin-de-Giraud","Salindres","Salins","Salins-les-Bains","Salins-les-Thermes","Sallanches","Sallaumines","Salleboeuf","Sallertaine","Salles-de-Barbezieux","Salles-la-Source","Salles-Mongiscard","Salles-sur-Mer","Salome","Salon-de-Provence","Salouel","Salses-le-Chateau","Salvagnac","Salviac","Salvizinet","Salzuit","Samadet","Samatan","Samazan","Sambin","Sameon","Samer","Samognat","Samois-sur-Seine","Samoreau","Sampigny-les-Maranges","Samson","San-Giuliano","San-Nicolao","Sanary-sur-Mer","Sancerre","Sanchey","Sancourt","Sand","Sandillon","Sandouville","Sandrans","Sangatte","Sanguinet","Sannerville","Sannois","Sansais","Sant Andreu de Sureda","Sant Genis de Fontanes","Sant Joan de Pladecorts","Santa-Maria-Poggio","Santeny","Santes","Santeuil","Santranges","Sanvignes-les-Mines","Sanxay","Saone","Sapogne-et-Feucheres","Sapogne-sur-Marche","Saramon","Saran","Sarcelles","Sarcey","Sarcicourt","Sardan","Sardieu","Sardon","Sare","Sarge-sur-Braye","Sarliac-sur-lIsle","Sarralbe","Sarraltroff","Sarrant","Sarras","Sarrazac","Sarre","Sarre-Union","Sarrebourg","Sarreguemines","Sarrey","Sarrians","Sarrola-Carcopino","Sarry","Sars-Poteries","Sartrouville","Sarzeau","Sassay","Sassenage","Sassenay","Sassey-sur-Meuse","Sathonay-Camp","Sathonay-Village","Satillieu","Satolas-et-Bonce","Saubens","Saubion","Saubrigues","Saubusse","Saucats","Saudoy","Saugon","Saugues","Saujon","Saulces-Monclin","Saulcy-sur-Meurthe","Saules","Saulge","Saulieu","Saulnes","Saulnieres","Saulnot","Saulny","Saulon-la-Chapelle","Saulon-la-Rue","Sault","Sault-Brenaz","Sault-les-Rethel","Sault-Saint-Remy","Saultain","Saulx-les-Chartreux","Saulx-Marchais","Saulxures","Saulxures-les-Nancy","Saulxures-sur-Moselotte","Saulzoir","Saumane-de-Vaucluse","Saumeray","Saumur","Saurat","Sauret-Besserve","Sausheim","Saussan","Saussay-la-Campagne","Saussemesnil","Saussenac","Sausset-les-Pins","Saussey","Saussines","Sautel","Sauteyrargues","Sautron","Sauvage","Sauvagney","Sauvagnon","Sauvat","Sauve","Sauverny","Sauvessanges","Sauveterre","Sauveterre-de-Bearn","Sauveterre-de-Comminges","Sauveterre-de-Guyenne","Sauveterre-la-Lemance","Sauvian","Sauvigney-les-Pesmes","Sauvigny-les-Bois","Sauxillanges","Sauze","Sauze-Vaussais","Sauzelles","Sauzet","Sauzet","Sauzon","Savasse","Savenay","Savennieres","Saverdun","Saverne","Savieres","Savignac-les-Eglises","Savignac-sur-Leyze","Savigne","Savigne-sous-le-Lude","Savigneux","Savigny","Savigny-en-Revermont","Savigny-en-Septaine","Savigny-le-Sec","Savigny-le-Temple","Savigny-les-Beaune","Savigny-sur-Braye","Savigny-sur-Clairis","Savigny-sur-Orge","Savoie","Savonnieres","Savouges","Savoyeux","Savy","Savy-Berlette","Sayat","Scaer","Sceaux","Sceaux-du-Gatinais","Sceaux-sur-Huisne","Scharrachbergheim-Irmstett","Scherwiller","Schillersdorf","Schiltigheim","Schirmeck","Schirrhein","Schmittviller","Schnersheim","Schoeneck","Schopperten","Schorbach","Schweighouse-Thann","Schwenheim","Scientrier","Sciez","Scionzier","Scorbe-Clairvaux","Scrignac","Scy-Chazelles","Sebazac-Concoures","Sebecourt","Sebourg","Secheval","Seclin","Secondigny","Sedan","Sedzere","Sees","Seez","Segalas","Segny","Segonzac","Segonzat","Segre","Segrie","Segry","Seichamps","Seiches-sur-le-Loir","Seignalens","Seignelay","Seignosse","Seilh","Seilhac","Seine-Port","Seingbouse","Seissan","Selle","Selles","Selles-Saint-Denis","Selles-sur-Cher","Selles-sur-Nahon","Sellieres","Selommes","Seloncourt","Selongey","Seltz","Semalens","Semblancay","Semeac","Semeacq-Blachon","Semecourt","Semoine","Semoutiers-Montsaon","Semoy","Sempigny","Semur-en-Brionnais","Senan","Senas","Sendets","Sene","Senlecques","Senlis","Sennece-les-Macon","Sennecey-le-Grand","Sennely","Senneville-sur-Fecamp","Senonches","Senones","Senonges","Senozan","Sens","Sens-de-Bretagne","Sentheim","Senuc","Sepmeries","Seppois-le-Bas","Seppois-le-Haut","Sept-Forges","Sept-Saulx","Septeme","Septemes-les-Vallons","Septeuil","Septfonds","Septvaux","Sequedin","Seraincourt","Serans","Seraucourt-le-Grand","Serbannes","Serdinya","Sereilhac","Serein","Seremange-Erzange","Serent","Serezin-de-la-Tour","Serezin-du-Rhone","Sergeac","Sergy","Serifontaine","Serignan","Serignan-du-Comtat","Serigne","Sermaises","Sermamagny","Sermerieu","Sermoise","Sermoyer","Sernhac","Serocourt","Seronville","Serques","Serquigny","Serre-les-Sapins","Serres","Serres-Castet","Serres-Gaston","Serres-Morlaas","Serres-Sainte-Marie","Serres-sur-Arget","Serrieres","Serrieres-de-Briord","Serrieres-en-Chautagne","Serris","Serrouville","Sers","Servais","Servance","Servant","Servas","Servaville-Salmonville","Servian","Servon","Servon-sur-Vilaine","Sery","Sery-les-Mezieres","Sessenheim","Seugy","Seuil","Seuillet","Seurre","Sevelinges","Severac","Severac-le-Chateau","Seveux","Sevran","Sevres-Anxaumont","Sevrey","Sevrier","Sewen","Sexey-aux-Forges","Seyches","Seyne-les-Alpes","Seynod","Seyre","Seyssel","Seysses","Seyssinet","Seyssinet-Pariset","Seyssins","Seyssuel","Sezanne","Sibiril","Siccieu-Saint-Julien-et-Carisieu","Siegen","Sierck-les-Bains","Sierentz","Sierville","Sigean","Sigloy","Signes","Signy","Signy-le-Petit","Signy-Signets","Sigogne","Sigoules","Sigournais","Sigy-en-Bray","Silfiac","Sillans","Sille-le-Guillaume","Sillery","Sillingy","Silly-la-Poterie","Silly-le-Long","Silly-sur-Nied","Silly-Tillard","Simandre","Simandres","Simiane-Collongue","Simorre","Sin-le-Noble","Sinard","Sinceny","Sion-les-Mines","Siran","Sireuil","Siros","Sisco","Sissonne","Sissy","Sisteron","Sivry-Courtry","Sivry-sur-Meuse","Six-Fours-les-Plages","Sizun","Smarves","Sochaux","Soignolles-en-Brie","Soing-Cubry-Charentenay","Soissons","Soissons-sur-Nacey","Soisy-sous-Montmorency","Soisy-sur-Ecole","Soisy-sur-Seine","Soize","Solaize","Solaro","Solers","Solesmes","Solesmes","Soleymieux","Solferino","Solgne","Soliers","Solignac","Solignac-sous-Roche","Solignac-sur-Loire","Soligny-la-Trappe","Sollies-Pont","Sollies-Toucas","Sollies-Ville","Sologny","Somain","Sombacour","Sombernon","Somloire","Sommaing","Somme","Sommecaise","Sommedieue","Sommelonne","Sommerance","Sommervieu","Sommerviller","Sommieres","Sommieres-du-Clain","Sonchamp","Sondernach","Songeons","Sonnay","Sonnaz","Sonzay","Soorts-Hossegor","Sorbey","Sorbiers","Sorcy-Saint-Martin","Sore","Sorede","Sorel-en-Vimeu","Sorel-Moussel","Soreze","Sorges","Sorgues","Sorigny","Sormonne","Sornay","Sorquainville","Sorrus","Sort-en-Chalosse","Sospel","Sottevast","Sotteville","Sotteville-sur-Mer","Souastre","Soubise","Soublecause","Souchez","Soucht","Soucieu-en-Jarrest","Soucy","Soudan","Soues","Souesmes","Souffelweyersheim","Soufflenheim","Sougy","Sougy-sur-Loire","Souilhanels","Souillac","Soulac-sur-Mer","Soulaincourt","Soulaines-Dhuys","Soulaines-sur-Aubance","Soulaire-et-Bourg","Soulanges","Soulangis","Soulge-sur-Ouette","Soulieres","Souligne-sous-Ballon","Soulitre","Soullans","Soultz-Haut-Rhin","Soultz-sous-Forets","Soultzeren","Soultzmatt","Soulvache","Soumeras","Soumoulou","Souppes-sur-Loing","Souprosse","Souraide","Sourcieux-les-Mines","Sourdeval","Sourdon","Sourdun","Sourribes","Sours","Souspierre","Soustons","Souvans","Souvigne","Souvigne-sur-Sarthe","Souvigny","Souvigny-en-Sologne","Souzay-Champigny","Souzy","Souzy-la-Briche","Soyaux","Soyers","Soyons","Spay","Spechbach-le-Bas","Spechbach-le-Haut","Speracedes","Spezet","Spicheren","Spincourt","Sponville","Spycker","Squiffiec","St Chamas","St Laurent des Arbres","St-Malo","Staffelfelden","Stains","Steenbecque","Steenvoorde","Steenwerck","Steige","Steinbach","Steinbourg","Stella-Plage","Stenay","Still","Stiring-Wendel","Stosswihr","Strasbourg","Strazeele","Strueth","Succieu","Suce-sur-Erdre","Sucy-en-Brie","Suhescun","Suin","Suippes","Sully-la-Chapelle","Sully-sur-Loire","Sulniac","Sundhoffen","Supt","Surat","Surba","Suresnes","Surgeres","Surgy","Surin","Surques","Surtainville","Surville","Surville","Survilliers","Sury-en-Vaux","Sury-le-Comtal","Surzur","Sus","Sussargues","Suzanne","Suze-la-Rousse","Tabanac","Tacoignieres","Taden","Taglio-Isolaccio","Tagnon","Taillades","Taillebourg","Taillis","Tailly","Taintrux","Taissy","Taize-Aizie","Tajan","Talange","Talant","Talence","Talensac","Tallard","Tallende","Taller","Talloires","Tallud-Sainte-Gemme","Talon","Taluyers","Tamnay-en-Bazois","Tancrou","Taninges","Tanneron","Taradeau","Tarare","Tarascon","Tarascon-sur-Ariege","Tarbes","Tarcenay","Tarentaise","Targassonne","Targon","Tarnes","Tarnos","Tartaras","Tartas","Tartigny","Tassille","Tassin-la-Demi-Lune","Tatinghem","Taule","Taulignan","Taupont","Tauriac","Tauriac-de-Camares","Tautavel","Tauxieres-Mutry","Tauxigny","Tavaux","Tavel","Tavera","Tavernes","Taverny","Tavers","Tavey","Tayrac","Tecou","Teillet-Argenty","Teissieres-de-Cornet","Telgruc-sur-Mer","Teloche","Templemars","Templeuve","Tence","Tende","Tendon","Terce","Tercis-les-Bains","Terdeghem","Tergnier","Ternand","Ternay","Ternay","Terrasson-Lavilledieu","Terraube","Terrebasse","Terssac","Terves","Terville","Tessy-sur-Vire","Teteghem","Teuillac","Teurtheville-Hague","Teyjat","Teyran","Thaims","Thaire","Thal-Drulingen","Thann","Thaon","Thaon-les-Vosges","Thauron","Theding","Thegra","Theil-sur-Vanne","Theillay","Theix","Theize","Thelus","Themericourt","Thenay","Thenelles","Thenezay","Thenissey","Thennelieres","Thennes","Thenon","Theoule-sur-Mer","Therdonne","Therouanne","Theuville","Theuville-aux-Maillots","Theys","Thezan-les-Beziers","Theze","Theziers","Thezy-Glimont","Thiais","Thiant","Thiberville","Thiefosse","Thiergeville","Thiers","Thiers-sur-Theve","Thierville","Thierville-sur-Meuse","Thietreville","Thieuloy-Saint-Antoine","Thieville","Thil","Thil","Thilay","Thilouze","Thimert-Gatelles","Thimory","Thin-le-Moutier","Thionville","Thise","Thivars","Thivencelle","Thiverval-Grignon","Thiviers","Thizy-les-Bourgs","Thodure","Thoirette","Thoiry","Thoiry","Thoissey","Thomery","Thones","Thonnance-les-Joinville","Thonon-les-Bains","Thoraise","Thorens-Glieres","Thorigny","Thorigny-sur-Marne","Thou","Thouare-sur-Loire","Thouars","Thourotte","Thoux","Thuir","Thuit-Hebert","Thulay","Thumeries","Thun-Saint-Amand","Thurageau","Thure","Thuret","Thurins","Thury-Harcourt","Thusy","Thyez","Tierce","Tiercelet","Tigery","Tignes","Tignieu-Jameyzieu","Tigy","Til-Chatel","Tillay-le-Peneux","Tille","Tillenay","Tillieres","Tillieres-sur-Avre","Tilloy-et-Bellay","Tilloy-lez-Cambrai","Tilloy-lez-Marchiennes","Tilly-sur-Meuse","Tilques","Tinchebray","Tincques","Tincry","Tinqueux","Tinteniac","Tiranges","Tirepied","Tivernon","Tocqueville","Tocqueville","Tocqueville-en-Caux","Tollevast","Tombeboeuf","Tomblaine","Tonnay-Boutonne","Tonnay-Charente","Tonneins","Tonnerre","Tonnoy","Torce-en-Vallee","Torcieu","Torcy","Torcy","Torcy-le-Grand","Torderes","Torfou","Torigni-sur-Vire","Torpes","Torreilles","Torsac","Torvilliers","Torxe","Tosse","Tossiat","Totes","Touchay","Toucy","Toudon","Toufflers","Toul","Toulaud","Toulenne","Toulon","Toulon-sur-Arroux","Toulouges","Toulouse","Toulouzette","Toulx-Sainte-Croix","Touques","Touquin","Tour-en-Sologne","Tourbes","Tourcoing","Tourgeville","Tourlaville","Tourly","Tournan-en-Brie","Tournay-sur-Odon","Tournecoupe","Tournedos-Bois-Hubert","Tournefeuille","Tournehem-sur-la-Hem","Tournieres","Tournoisis","Tournon-Saint-Martin","Tournus","Tourouvre","Tourrette-Levens","Tourrettes-sur-Loup","Tourriers","Tours","Tours-en-Savoie","Tours-sur-Marne","Tours-sur-Meymont","Tourtrol","Tourves","Tourville-en-Auge","Tourville-la-Campagne","Tourville-la-Chapelle","Tourville-la-Riviere","Tourville-les-Ifs","Tourville-sur-Odon","Tourville-sur-Sienne","Toury","Toussaint","Toussieu","Toussieux","Toussus-le-Noble","Toutlemonde","Touville","Touvois","Touvre","Touzac","Tracy-le-Mont","Tracy-le-Val","Tracy-sur-Loire","Traenheim","Trainel","Trainou","Tramole","Tramoyes","Trange","Trans-en-Provence","Trappes","Traubach-le-Bas","Trausse","Travecy","Treauville","Trebes","Trebeurden","Trebry","Treclun","Tredarzec","Treduder","Treffendel","Treffieux","Trefflean","Treffort","Treffrin","Treflez","Tregarantec","Tregastel","Treglamus","Tregourez","Treguidel","Tregunc","Treignac","Treillieres","Treize-Septiers","Trelaze","Trelevern","Trelissac","Trelivan","Trelly","Trelon","Tremblay","Tremblay","Tremel","Trementines","Tremery","Tremeven","Tremilly","Tremons","Tremont-sur-Saulx","Tremuson","Treon","Trepied","Trept","Tresilley","Tresques","Tressan","Tressange","Tresserve","Tresses","Trets","Treuzy-Levelay","Treve","Treveneuc","Treveray","Treverien","Treves","Trevien","Trevignin","Trevoux","Trezioux","Triaize","Tricot","Trie-Chateau","Trie-sur-Baise","Triel-sur-Seine","Trieux","Trigavou","Trignac","Trigueres","Trilbardou","Trilport","Triors","Trith-Saint-Leger","Trizac","Trizay","Troarn","Troche","Trogues","Troissereux","Troissy","Troisvilles","Tronville-en-Barrois","Trosly-Breuil","Trouhans","Trouillas","Trouley-Labarthe","Troussencourt","Troussey","Trouville","Trouville-la-Haule","Trouville-sur-Mer","Trouy","Troyes","Troyon","Truchtersheim","Trumilly","Truyes","Tubersent","Tuchan","Tucquegnieux","Tuffe","Tulle","Tullins","Tupigny","Turckheim","Turquant","Tursac","Tuzaguet","Uberach","Uchacq-et-Parentis","Uchaud","Uchaux","Uckange","Ueberstrass","Ugine","Ugny-sur-Meuse","Uhrwiller","Ully-Saint-Georges","Umpeau","Undurein","Ungersheim","Unieux","Ur","Urbeis","Urcay","Urcel","Urcuit","Urdos","Uriage-les-Bains","Urmatt","Urou-et-Crennes","Urrugne","Urt","Uruffe","Urval","Urville-Nacqueville","Ury","Urzy","Us","Ussac","Usseau","Ussel","Usson-du-Poitou","Ussy","Ustaritz","Utelle","Uvernet-Fours","Uxegney","Uxem","Uzein","Uzerche","Uzos","Vaas","Vacheresse","Vacognes-Neuilly","Vacon","Vacquieres","Vacquiers","Vadenay","Vadencourt","Vagney","Vahl-les-Benestroff","Vailhauques","Vaillant","Vailly","Vailly","Vailly-sur-Aisne","Vailly-sur-Sauldre","Vaire","Vaire-sous-Corbie","Vaires-sur-Marne","Vaison-la-Romaine","Vaissac","Vaivre-et-Montoille","Val-de-Fier","Val-de-la-Haye","Val-et-Chatillon","Valaire","Valay","Valberg","Valbonne","Valcourt","Valdahon","Valdampierre","Valdoie","Valdurenque","Valencay","Valence","Valence","Valence-sur-Baise","Valenciennes","Valencin","Valencogne","Valensole","Valentigney","Valenton","Valescourt","Valff","Valflaunes","Valines","Vallangoujard","Vallans","Vallant-Saint-Georges","Vallauris","Valle-di-Mezzana","Vallegue","Valleiry","Valleraugue","Valleres","Vallerois-Lorioz","Valleroy-le-Sec","Vallesvilles","Vallet","Vallier","Valliguieres","Valliquerville","Vallon-en-Sully","Vallouise","Valmestroff","Valmondois","Valmont","Valmont","Valmy","Valognes","Valpuiseaux","Valras-Plage","Valreas","Valros","Vals-les-Bains","Vals-pres-le-Puy","Vanclans","Vandieres","Vandoeuvre-les-Nancy","Vandoncourt","Vandre","Vandrimare","Vandy","Vannes","Vanosc","Vantoux","Vanves","Vanville","Vanzac","Varades","Varages","Varaignes","Varaize","Varanges","Varangeville","Varaville","Varces-Allieres-et-Risset","Varen","Varennes","Varennes","Varennes-en-Argonne","Varennes-Jarcy","Varennes-le-Grand","Varennes-les-Macon","Varennes-sous-Dun","Varennes-sur-Allier","Varennes-sur-Loire","Varennes-sur-Seine","Varennes-Vauzelles","Varesnes","Varetz","Varilhes","Varinfroy","Varois-et-Chaignot","Varrains","Varreddes","Vars","Vars","Varsberg","Varzay","Varzy","Vasles","Vassel","Vasselay","Vassy","Vasteville","Vatan","Vathimenil","Vatimesnil","Vauban","Vaubecourt","Vauchamps","Vauchelles","Vauchelles-les-Domart","Vauchelles-les-Quesnoy","Vauchonvilliers","Vaucouleurs","Vaucresson","Vaudebarrier","Vaudemange","Vaudesson","Vaudeville","Vaudoy-en-Brie","Vaudreching","Vaudrey","Vaugneray","Vaugrigneuse","Vauhallan","Vaujours","Vaulry","Vault-de-Lugny","Vaulx-en-Velin","Vaulx-Milieu","Vaumas","Vaumoise","Vaumort","Vaureal","Vaureilles","Vauvert","Vauville","Vauvillers","Vaux-en-Bugey","Vaux-la-Petite","Vaux-le-Penil","Vaux-les-Pres","Vaux-les-Saint-Claude","Vaux-sur-Aure","Vaux-sur-Blaise","Vaux-sur-Eure","Vaux-sur-Mer","Vaux-sur-Poligny","Vaux-sur-Seine","Vauxbuin","Vauxtin","Vaxoncourt","Vay","Vayrac","Vayres","Veauche","Veaugues","Vecoux","Vecquemont","Vecqueville","Vedene","Veho","Veigne","Veigy-Foncenex","Velaine-en-Haye","Velaines","Velars-sur-Ouche","Velaux","Velines","Velle-le-Chatel","Velleches","Velleminfroy","Velleron","Velotte-et-Tatignecourt","Velye","Velzic","Vemars","Venables","Venansault","Venant","Venarey-les-Laumes","Venasque","Vence","Vendargues","Vendat","Vendays-Montalivet","Vendegies-sur-Ecaillon","Vendemian","Vendenheim","Vendeuil-Caply","Vendeuvre-du-Poitou","Vendeville","Vendin-le-Vieil","Vendin-les-Bethune","Vendome","Vendrennes","Vendres","Venejan","Venelles","Venerand","Venerque","Venette","Veneux-les-Sablons","Venizel","Venizy","Vennecy","Venon","Venoy","Ventabren","Ventes-Saint-Remy","Venteuil","Venthon","Ventiseri","Ver-sur-Launette","Verac","Verargues","Verberie","Verchaix","Verchamp","Verchin","Verdelais","Verderonne","Verdon","Verdun","Verdun-en-Lauragais","Verdun-sur-Garonne","Verdun-sur-le-Doubs","Veretz","Verfeil","Vergeze","Vergongheon","Vergt","Veria","Verigny","Verines","Verjux","Verlinghem","Vermand","Vermelles","Vermenton","Vern-sur-Seiche","Vernaison","Verne","Verne","Vernegues","Verneil-le-Chetif","Vernet-les-Bains","Verneugheol","Verneuil","Verneuil-en-Bourbonnais","Verneuil-en-Halatte","Verneuil-sous-Coucy","Verneuil-sur-Avre","Verneuil-sur-Seine","Verneuil-sur-Vienne","Vernierfontaine","Vernines","Verniolle","Vernioz","Vernon","Vernon","Vernosc-les-Annonay","Vernou-sur-Brenne","Vernouillet","Vernouillet","Vernoux-en-Vivarais","Verny","Veron","Verpillieres","Verquieres","Verquigneul","Verquin","Verrey-sous-Salmaise","Verrieres","Verrieres","Verrieres-le-Buisson","Vers","Vers-en-Montagne","Vers-Pont-du-Gard","Vers-sur-Selles","Versailles","Versailleux","Versigny","Verson","Versonnex","Vert","Vert-en-Drouais","Vert-le-Grand","Vert-le-Petit","Vert-Saint-Denis","Vertaizon","Verthemex","Vertolaye","Verton","Vertou","Vertrieu","Vertus","Vervezelle","Vervins","Very","Verze","Verzeille","Verzenay","Vescovato","Vesigneul-sur-Coole","Vesly","Vesoul","Vestric-et-Candiac","Vetheuil","Vetraz-Monthoux","Veuil","Veurey-Voroize","Veynes","Veyrac","Veyras","Veyre-Monton","Veyrier-du-Lac","Veyrignac","Vezac","Vezelise","Vezenobres","Vezezoux","Vezin-le-Coquet","Vezins","Viabon","Vialas","Vianne","Viarmes","Vias","Vibersviller","Vibraye","Vic-en-Bigorre","Vic-Fezensac","Vic-la-Gardiole","Vic-le-Comte","Vic-le-Fesq","Vic-sur-Aisne","Vic-sur-Cere","Vic-sur-Seille","Vichy","Vico","Vicq","Vidauban","Videix","Vieille-Brioude","Vieille-Eglise","Vieille-Eglise-en-Yvelines","Vieillevigne","Vieillevigne","Vieilley","Vielle-Saint-Girons","Vielle-Tursan","Viellespeze","Vielmur-sur-Agout","Viels-Maisons","Vienne","Vienville","Vierville","Vierzon","Viesly","Viessoix","Vieux","Vieux","Vieux Conde","Vieux-Berquin","Vieux-Boucau-les-Bains","Vieux-Charmont","Vieux-Conde","Vieux-Ferrette","Vieux-Fume","Vieux-Manoir","Vieux-Moulin","Vieux-Rouen-sur-Bresle","Vieux-Thann","Vif","Vigeois","Vignacourt","Vignes","Vignes","Vigneulles","Vigneulles-les-Hattonchatel","Vigneux-de-Bretagne","Vigneux-sur-Seine","Vignoc","Vignolles","Vignols","Vignonet","Vignot","Vigny","Vigny","Vigny","Vigoulet-Auzil","Vigouroux","Vigueron","Vigy","Vihiers","Vilallonga dels Monts","Villabe","Villabon","Villacourt","Village-Neuf","Villaines-la-Juhel","Villaines-les-Rochers","Villaines-sous-Bois","Villaines-sous-Luce","Villaines-sous-Malicorne","Villamblard","Villamee","Villard","Villard-Bonnot","Villard-de-Lans","Villard-Saint-Christophe","Villard-sur-Doron","Villards","Villargondran","Villaries","Villarlurin","Villars","Villars-Brandis","Villars-Colmars","Villars-en-Pons","Villars-et-Villenotte","Villars-les-Dombes","Villars-sur-Var","Villarzel-Cabardes","Villasavary","Villaz","Ville","Ville","Ville-du-Pont","Ville-en-Tardenois","Ville-la-Grand","Ville-sous-Anjou","Ville-sur-Cousances","Ville-sur-Jarnioux","Ville-sur-Lumes","Ville-sur-Tourbe","Villebarou","Villebernier","Villeblevin","Villebois-Lavalette","Villebon-sur-Yvette","Villebret","Villebrumier","Villecerf","Villeconin","Villecresnes","Villecroze","Villedieu","Villedieu","Villedieu-les-Poeles","Villedomer","Villedoux","Villefagnan","Villefontaine","Villefranche-de-Lauragais","Villefranche-de-Rouergue","Villefranche-du-Queyran","Villefranche-le-Chateau","Villefranche-sur-Cher","Villefranche-sur-Mer","Villefranque","Villegailhenc","Villegats","Villegouge","Villejesus","Villejoubert","Villejuif","Villejust","Villelaure","Villelongue-de-la-Salanque","Villemandeur","Villemarechal","Villembray","Villemeux-sur-Eure","Villemoirieu","Villemoisson-sur-Orge","Villemolaque","Villemomble","Villemort","Villemotier","Villemoustaussou","Villemoyenne","Villemur","Villemur-sur-Tarn","Villemurlin","Villenauxe-la-Grande","Villenave","Villeneuve","Villeneuve","Villeneuve les beziers","Villeneuve-au-Chemin","Villeneuve-de-Berg","Villeneuve-de-Duras","Villeneuve-de-la-Raho","Villeneuve-de-Marc","Villeneuve-de-Marsan","Villeneuve-des-Escaldes","Villeneuve-Frouville","Villeneuve-la-Garenne","Villeneuve-la-Guyard","Villeneuve-la-Riviere","Villeneuve-le-Comte","Villeneuve-le-Roi","Villeneuve-Lecussan","Villeneuve-les-Avignon","Villeneuve-les-Bouloc","Villeneuve-les-Genets","Villeneuve-les-Maguelone","Villeneuve-les-Sablons","Villeneuve-Loubet","Villeneuve-Minervois","Villeneuve-Saint-Georges","Villeneuve-Saint-Germain","Villeneuve-sur-Allier","Villeneuve-sur-Fere","Villeneuve-sur-Lot","Villeneuve-sur-Yonne","Villeneuve-Tolosane","Villennes-sur-Seine","Villenouvelle","Villenoy","Villeny","Villeparisis","Villeperdue","Villepinte","Villepinte","Villepreux","Villequier-Aumont","Villerable","Villerest","Villermain","Villeron","Villers","Villers","Villers-Allerand","Villers-au-Bois","Villers-au-Tertre","Villers-aux-Vents","Villers-Bocage","Villers-Bocage","Villers-Bretonneux","Villers-Canivet","Villers-Farlay","Villers-Helon","Villers-la-Montagne","Villers-le-Lac","Villers-le-Sec","Villers-les-Nancy","Villers-les-Ormes","Villers-les-Pots","Villers-les-Roye","Villers-Outreaux","Villers-Plouich","Villers-Pol","Villers-Saint-Frambourg","Villers-Saint-Genest","Villers-Saint-Paul","Villers-Saint-Sepulcre","Villers-Semeuse","Villers-Sire-Nicole","Villers-sous-Preny","Villers-sous-Saint-Leu","Villers-sur-Fere","Villers-sur-le-Mont","Villers-sur-Mer","Villers-sur-Meuse","Villers-sur-Port","Villers-sur-Saulnot","Villersexel","Villerupt","Villerville","Villes-sur-Auzon","Villesequelande","Villesiscle","Villetaneuse","Villetelle","Villeton","Villetrun","Villette","Villettes","Villeurbanne","Villevallier","Villevaude","Villeve","Villeveque","Villeveyrac","Villevieux","Villevillon","Villevocance","Villexavier","Villey-Saint-Etienne","Villey-sur-Tille","Villez-sous-Bailleul","Villie-Morgon","Villiers-Adam","Villiers-au-Bouin","Villiers-Couture","Villiers-en-Desoeuvre","Villiers-en-Plaine","Villiers-le-Bacle","Villiers-le-Bel","Villiers-le-Mahieu","Villiers-Saint-Georges","Villiers-sous-Grez","Villiers-sur-Chize","Villiers-sur-Marne","Villiers-sur-Morin","Villiers-sur-Orge","Villiers-sur-Seine","Villiers-sur-Tholon","Villieu-Loyes-Mollon","Villing","Villons-les-Buissons","Villorceau","Villotte-sur-Aire","Villy-Bocage","Villy-le-Bouveret","Villy-le-Pelloux","Vimines","Vimory","Vimoutiers","Vimy","Vinassan","Vinay","Vinca","Vincelles","Vincelles","Vincennes","Vincent","Vincey","Vincly","Vindelle","Vineuil","Vineuil","Vineuil-Saint-Firmin","Vinneuf","Vinon-sur-Verdon","Vinzelles","Vinzier","Viodos-Abense-de-Bas","Violaines","Violay","Viomenil","Vion","Vion","Viplaix","Vire","Vire","Virelade","Vireux-Molhain","Vireux-Wallerand","Virey-le-Grand","Viriat","Virieu-le-Grand","Virignin","Viriville","Viroflay","Virville","Viry","Viry","Viry-Noureuil","Vitrac","Vitrac-Saint-Vincent","Vitreux","Vitrimont","Vitrolles","Vitry-aux-Loges","Vitry-en-Artois","Vitry-en-Perthois","Vitry-la-Ville","Vitry-sur-Orne","Vitry-sur-Seine","Vitteaux","Vittel","Vittersbourg","Viuz-en-Sallaz","Viven","Vivier","Vivier-au-Court","Vivieres","Viviers","Viviers-du-Lac","Viviers-les-Montagnes","Viviez","Vivonne","Vivy","Vix","Vizille","Vocance","Voglans","Voillecomte","Voiron","Voisin","Voisins-le-Bretonneux","Voissant","Vollore-Ville","Volmerange-les-Boulay","Volmerange-les-Mines","Volonne","Volvic","Volx","Vonnas","Voreppe","Vorey","Vorges","Vouel","Vouhe","Vouille","Vouille-les-Marais","Vouillers","Voujeaucourt","Voulangis","Voultegon","Voulton","Voulx","Vouneuil-sous-Biard","Vouneuil-sur-Vienne","Vourey","Vourles","Voutezac","Voutre","Vouvant","Vouvray","Vouzan","Vouzeron","Vouziers","Vouzon","Vouzy","Voves","Vraiville","Vraux","Vred","Vriange","Vrigne-aux-Bois","Vrigny","Vritz","Vue","Vulaines-sur-Seine","Vulbens","Wahagnies","Wahlenheim","Wail","Wailly","Wailly-Beaucamp","Waldhouse","Waldighofen","Waldweistroff","Waldwisse","Walheim","Wallers","Walscheid","Wambaix","Wambercourt","Wambrechies","Wandignies-Hamage","Wangen","Wangenbourg-Engenthal","Wanquetin","Warcq","Warendin","Wargnies-le-Petit","Warhem","Warlaing","Warlus","Warluzel","Warmeriville","Warnecourt","Wasnes-au-Bac","Wasquehal","Wasselonne","Wassy","Watten","Wattignies","Wattrelos","Wattwiller","Wavignies","Waville","Wavrechain-sous-Denain","Wavrechain-sous-Faulx","Wavrin","Waziers","Weislingen","Weitbruch","Wentzwiller","Werentzhouse","Wervicq-Sud","Westbecourt","Westhoffen","Westhouse","Weyersheim","Wickerschwihr","Widensolen","Wierre-Effroy","Wignehies","Wihr-au-Val","Wildersbach","Willems","Willencourt","Willer-sur-Thur","Willerwald","Willgottheim","Wimereux","Wimille","Wingen-sur-Moder","Wingersheim","Wingles","Winnezeele","Wintersbourg","Wintzenbach","Wintzenheim","Wintzfelden","Wirwignes","Wissant","Wissembourg","Wissignicourt","Wissous","Witry-les-Reims","Wittelsheim","Wittenheim","Witternheim","Wittersdorf","Wittersheim","Wittes","Wittisheim","Wiwersheim","Wizernes","Woerth","Woincourt","Woippy","Wolfgantzen","Wolfisheim","Wolschheim","Wolxheim","Wormhout","Woustviller","Wuenheim","Xaintray","Xanton-Chassenon","Xertigny","Xures","Yaucourt-Bussus","Ychoux","Ydes","Yebleron","Yebles","Yenne","Yermenonville","Yerres","Yerville","Yevre-la-Ville","Yffiniac","Ygos-Saint-Saturnin","Ygrande","Ymare","Youx","Yport","Ypreville-Biville","Yronde-et-Buron","Yssac-la-Tourette","Yssandon","Yssingeaux","Ytrac","Yversay","Yves","Yvetot","Yvette","Yvias","Yvoire","Yvrac","Yvrac-et-Malleyrand","Yzernay","Yzeure","Yzeures-sur-Creuse","Yzosse","Zellwiller","Zillisheim","Zimmersheim","Zimming","Zinswiller","Zittersheim","Zouafques","Zutzendorf"],"French Polynesia":["Arue","Faaa","Mahina","Paeau","Papeete","Pirae","Punaauia"],"Gabon":["Gamba","Libreville","Mamagnia","Moanda","Port-Gentil"],"Georgia":["Gogolesubani","Kutaisi","Lentekhi","Qazbegi","Samtredia","Sukhumi","Tbilisi","Zemo-Avchala","Zugdidi"],"Germany":["Aach","Aach","Aachen","Aalen","Abbensen","Abberode","Abenberg","Abensberg","Abstatt","Abtsbessingen","Abtsgmuend","Abtswind","Abtweiler","Achern","Achim","Achstetten","Adelebsen","Adelheidsdorf","Adelmannsfelden","Adelschlag","Adelsdorf","Adelsdorf","Adelsheim","Adelshofen","Adelsried","Adenau","Adenbuettel","Adendorf","Adlkofen","Adlum","Adorf","Aerzen","Affalterbach","Affaltern","Affing","Affinghausen","Aftholderberg","Aglasterhausen","Ahaus","Ahausen","Ahlen","Ahlhorn","Aholfing","Aholming","Ahorn","Ahrbruck","Ahrensboek","Ahrensbok","Ahrensburg","Ahrensfelde","Ahrenshagen","Ahrensmoor","Ahstedt","Aicha vorm Wald","Aichach","Aichelberg","Aichhalden","Aichstetten","Aichtal","Aichwald","Aidenbach","Aidlingen","Aindling","Aindorf","Ainring","Aislingen","Aitrach","Aitrang","Aken","Albaching","Albbruck","Albeck","Albersdorf","Albershausen","Albersweiler","Albertshausen","Albig","Albisheim","Albrechts","Albstadt","Aldekerk","Aldenhoven","Aldersbach","Aldingen","Alesheim","Aletshausen","Alexander","Alfdorf","Alfeld","Alfeld","Alfhausen","Alfstedt","Alfter","Algermissen","Alheim","Allee","Allendorf","Allendorf","Allensbach","Allersberg","Allershausen","Alleshausen","Alling","Allmannshofen","Allmendingen","Allmersbach im Tal","Allstedt","Almstedt","Alpen","Alpenrod","Alperstedt","Alpirsbach","Alsbach","Alsbach-Hahnlein","Alsdorf","Alsdorf","Alsfeld","Alsheim","Alt Buchhorst","Alt Bukow","Alt Golm","Alt Ruppin","Alt Schwerin","Altbach","Altbelgern","Altdobern","Altdorf","Altdorf","Altdorf","Alteglofsheim","Alten","Altena","Altenahr","Altenau","Altenbeken","Altenberg","Altenberge","Altenburg","Altendiez","Altenglan","Altengottern","Altengronau","Altenhasslau","Altenholz","Altenkirchen","Altenkirchen","Altenkirchen","Altenkrempe","Altenkunstadt","Altenmarkt","Altenmedingen","Altenmunster","Altenriet","Altenstadt","Altenstadt","Altenstadt","Altenstadt","Altensteig","Altenthann","Altentreptow","Alterhofen","Altersbach","Altfraunhofen","Althegnenberg","Altheim","Altheim","Althengstett","Althutte","Altingen","Altkirchen","Altlandsberg","Altleiningen","Altlussheim","Altmannstein","Altoetting","Altomunster","Altrip","Altshausen","Altstadt","Altstadt","Alttechau","Altusried","Altwittenbek","Alveslohe","Alzenau in Unterfranken","Alzey","Am Mellensee","Am See","Amberg","Amelinghausen","Amerang","Ammern","Ammerndorf","Amoneburg","Amorbach","Ampermoching","Ampfing","Amstetten","Amtzell","Andechs","Anderlingen","Andernach","Andreasberg","Anger","Angermunde","Angern","Anker","Ankershagen","Anklam","Ankum","Annaberg-Buchholz","Annaburg","Annerod","Annweiler am Trifels","Anrath","Anrochte","Ansbach","Antdorf","Anzing","Anzing","Apen","Apenburg","Apensen","Apfeldorf","Apfelstadt","Apolda","Appel","Appen","Appenweier","Arberg","Arenrath","Arensdorf","Arenshausen","Aresing","Arft","Argenthal","Arlaching","Arlewatt","Armsheim","Armstorf","Arnbach","Arnbruck","Arnsberg","Arnschwang","Arnsdorf","Arnsdorf","Arnstadt","Arnstein","Arnstorf","Arrach","Artern","Artlenburg","Arzbach","Arzbach","Arzberg","Asbach","Asbach","Asbach","Asbach-Baumenheim","Ascha","Aschaffenburg","Aschau","Aschau","Ascheberg","Ascheberg","Ascheffel","Aschendorf","Aschersleben","Aschheim","Asendorf","Aspach","Aspach","Asperg","Aspisheim","Assel","Assenheim","Asslar","Assling","Astfeld","Atteln","Attendorn","Attenkirchen","Attenweiler","Atting","Atzendorf","Au","Au am Rhein","Au in der Hallertau","Aub","Aue","Auen","Auenstein","Auerbach","Auerbach","Auerbach","Aufhausen","Auggen","Augsburg","Augustdorf","Augustfehn","Augustusburg","Aukrug","Aulendorf","Aull","Auma","Aumuhle","Aurach","Aurachtal","Aurich","Autenzell","Auw","Axstedt","Aying","Ayl","Baar-Ebenhausen","Baasdorf","Baasem","Babenhausen","Babenhausen","Babensham","Babow","Bach","Bach","Bach an der Donau","Bacharach","Bachhagel","Bachingen an der Brenz","Backnang","Bad Abbach","Bad Aibling","Bad Alexandersbad","Bad Arolsen","Bad Bellingen","Bad Bentheim","Bad Bergzabern","Bad Berka","Bad Berleburg","Bad Berneck im Fichtelgebirge","Bad Bevensen","Bad Bibra","Bad Blankenburg","Bad Bocklet","Bad Boll","Bad Bramstedt","Bad Breisig","Bad Buchau","Bad Camberg","Bad Ditzenbach","Bad Doberan","Bad Driburg","Bad Duben","Bad Duerkheim","Bad Durrenberg","Bad Durrheim","Bad Eilsen","Bad Elster","Bad Ems","Bad Endbach","Bad Endorf","Bad Essen","Bad Fallingbostel","Bad Feilnbach","Bad Frankenhausen","Bad Freienwalde","Bad Fussing","Bad Gandersheim","Bad Godesberg","Bad Gogging","Bad Gottleuba","Bad Griesbach","Bad Grund","Bad Harzburg","Bad Heilbrunn","Bad Herrenalb","Bad Hersfeld","Bad Hindelang","Bad Homburg","Bad Honnef","Bad Honningen","Bad Iburg","Bad Karlshafen","Bad Kissingen","Bad Kleinen","Bad Klosterlausnitz","Bad Kohlgrub","Bad Konig","Bad Konigshofen im Grabfeld","Bad Kosen","Bad Kostritz","Bad Kreuznach","Bad Krozingen","Bad Laasphe","Bad Laer","Bad Langensalza","Bad Lauchstadt","Bad Lausick","Bad Lauterberg im Harz","Bad Liebenstein","Bad Liebenwerda","Bad Liebenzell","Bad Lippspringe","Bad Lobenstein","Bad Marienberg","Bad Mergentheim","Bad Munder am Deister","Bad Munster am Stein-Ebernburg","Bad Munstereifel","Bad Muskau","Bad Nauheim","Bad Nenndorf","Bad Neuenahr-Ahrweiler","Bad Neustadt an der Saale","Bad Oeynhausen","Bad Oldesloe","Bad Orb","Bad Peterstal-Griesbach","Bad Pyrmont","Bad Rappenau","Bad Reichenhall","Bad Rippoldsau-Schapbach","Bad Rothenfelde","Bad Saarow","Bad Sachsa","Bad Sackingen","Bad Salzdetfurth","Bad Salzschlirf","Bad Salzuflen","Bad Salzungen","Bad Sassendorf","Bad Schachen","Bad Schandau","Bad Schmiedeberg","Bad Schussenried","Bad Schwalbach","Bad Schwartau","Bad Segeberg","Bad Soden am Taunus","Bad Soden-Salmunster","Bad Sooden-Allendorf","Bad Staffelstein","Bad Steben","Bad Sulza","Bad Teinach-Zavelstein","Bad Tennstedt","Bad Toelz","Bad Uberkingen","Bad Urach","Bad Vilbel","Bad Waldsee","Bad Wiessee","Bad Wildbad im Schwarzwald","Bad Wildungen","Bad Wilsnack","Bad Wimpfen","Bad Windsheim","Bad Worishofen","Bad Wurzach","Bad Zwischenahn","Badbergen","Baddeckenstedt","Badem","Baden-Baden","Badenhausen","Badenweiler","Badow","Badra","Baesweiler","Bahlingen","Bahratal","Bahrdorf","Bahrenfleth","Baienfurt","Baierbrunn","Baiern","Baiersbronn","Baiersdorf","Baindt","Bakum","Baldham","Balgheim","Balingen","Ballendorf","Ballenstedt","Ballersbach","Ballrechten","Ballstadt","Baltmannsweiler","Baltringen","Baltrum","Balve","Bamberg","Bamlach","Bammental","Bank","Bankewitz","Bann","Bannberscheid","Bannemin","Bannewitz","Banteln","Banzkow","Barbelroth","Barbing","Barby","Barchfeld","Bardenberg","Bardowick","Barendorf","Barenstein","Barenthal","Bargenstedt","Bargfeld-Stegen","Barghorst","Bargstedt","Bargteheide","Bargum","Barkelsby","Barkenholm","Barkow","Barleben","Barmstedt","Barnau","Barnstorf","Barntrup","Barsbuettel","Barsinghausen","Barssel","Barstadt","Barth","Bartholoma","Bartow","Barum","Baruth","Barwedel","Basel","Bassenheim","Bassum","Bastheim","Bastorf","Battenberg","Battenberg","Batzhausen","Baudenbach","Baumholder","Baunach","Baunatal","Bausendorf","Bautzen","Bawinkel","Bayenthal","Bayerbach","Bayerisch Eisenstein","Bayerisch Gmain","Bayern","Bayersoien","Bayreuth","Bayrischzell","Beaumarais","Bebra","Becheln","Becherbach","Bechhofen","Bechtolsheim","Beckdorf","Beckedorf","Beckeln","Beckingen","Beckstedt","Beckum","Bedburdyck","Bedburg","Bederkesa","Beedenbostel","Beelen","Beelitz","Beerfelden","Beeskow","Beesten","Beetzendorf","Beetzsee","Behrendorf","Behrenhoff","Behringen","Beierfeld","Beiersdorf","Beierstedt","Beilngries","Beilrode","Beilstein","Beim Kronsberg","Beimerstetten","Beindersheim","Beinerstadt","Bekond","Belecke","Belgern","Belgershain","Bell","Bell","Bellamont","Bellenberg","Bellenberg","Bellershausen","Bellheim","Belm","Beltheim","Belum","Belzig","Bemerode","Bempflingen","Bendeleben","Bendestorf","Bendfeld","Bendorf","Benediktbeuern","Benneckenstein","Benningen","Benningen am Neckar","Bennungen","Bensberg","Benshausen","Bensheim","Bentfeld","Bentwisch","Benz","Benzingerode","Beratzhausen","Berching","Berchtesgaden","Berg","Berg","Berg","Berg","Berga","Berga","Bergbau","Berge","Bergen","Bergen","Bergen","Bergen auf Ruegen","Bergfelde","Berggiesshubel","Berghaupten","Berghausen","Bergheim","Berghulen","Bergisch Gladbach","Bergkamen","Bergkirchen","Berglern","Berglicht","Bergneustadt","Bergrheinfeld","Bergtheim","Bergweiler","Berka","Berkenthin","Berkheim","Berlin","Berlin","Berlingerode","Bermatingen","Bermbach","Bermersheim","Bermuthshain","Bernau","Bernau am Chiemsee","Bernau bei Berlin","Bernburg","Berne","Berngau","Bernhardswald","Bernkastel-Kues","Bernried","Bernsbach","Bernsdorf","Bernsdorf","Bernstadt","Bernstadt","Bernterode","Berod bei Wallmerod","Bersenbruck","Berumbur","Berzdorf","Bescheid","Besigheim","Besitz","Bestensee","Bestwig","Betheln","Bettingen","Betzdorf","Betzendorf","Betzenstein","Betzigau","Beucha","Beuern","Beuren","Beuren","Bevern","Beverstedt","Beverungen","Bexbach","Bexhovede","Biberach an der Riss","Biberbach","Biblis","Biburg","Bichl","Bickenbach","Biebelsheim","Bieber","Biebesheim","Biedenkopf","Biederitz","Bielefeld","Bienenbuttel","Bienstadt","Biere","Bierlingen","Biesenthal","Biesingen","Biessenhofen","Bietigheim","Bietigheim-Bissingen","Bietingen","Bilk","Billerbeck","Billigheim","Billigheim-Ingenheim","Billings","Billingshausen","Bimohlen","Binau","Bindlach","Bingen","Bingen am Rhein","Binsfeld","Binzen","Bippen","Birenbach","Birkenau","Birkenfeld","Birkenfeld","Birkenfeld","Birkenheide","Birkenhof","Birkenlohe","Birkenwerder","Birkheim","Birlenbach","Birlinghoven","Birnbach","Birnbach","Birstein","Bischberg","Bischheim","Bischoffen","Bischofferode","Bischofsgrun","Bischofsheim","Bischofsheim an der Rhon","Bischofsmais","Bischofswerda","Bischofswiesen","Bischweier","Bisingen","Bismark","Bismark","Bispingen","Bissendorf","Bissingen","Bissingen an der Teck","Bistensee","Bitburg","Bitterfeld-Wolfen","Bitz","Blaibach","Blaichach","Blankenburg","Blankenfelde","Blankenhagen","Blankenhain","Blankenhain","Blankenheim","Blankenloch","Blankenrath","Blankensee","Blankenstein","Blatzheim","Blaubeuren Abbey","Blechhammer","Bleckede","Bleckenrode","Bleialf","Bleicherode","Blender","Bliesdorf","Blieskastel","Bliesmengen-Bolchen","Blievenstorf","Blitzenreute","Blomberg","Blomberg","Blomesche Wildnis","Blumberg","Blume","Blumenthal","Bobbau","Bobenheim am Berg","Bobenheim-Roxheim","Bobingen","Bobrach","Bocholt","Bochum","Bocka","Bockau","Bockelwitz","Bockenau","Bockenem","Bockenheim","Bockhorn","Bockhorn","Bockhorst","Boddenstedt","Boddin","Bodelshausen","Boden","Bodenfelde","Bodenheim","Bodenkirchen","Bodenmais","Bodensee","Bodenteich","Bodenwerder","Bodenwohr","Bodman-Ludwigshafen","Bodolz","Boel","Boffzen","Bofingen","Bogen","Bogenhausen","Bohl-Iggelheim","Bohlen","Bohmenkirch","Bohmstedt","Bohmte","Bohringen","Boich","Boizenburg","Boklund","Bolanden","Boldebuck","Boldela","Bollendorf","Bollingstedt","Bollschweil","Bollstein","Bolsterlang","Bomlitz","Bondorf","Bonebuttel","Bonefeld","Bonen","Bonn","Bonndorf im Schwarzwald","Bonnigheim","Bonningstedt","Bonstetten","Boos","Boos","Boostedt","Bopfingen","Boppard","Bordelum","Bordesholm","Borgdorf-Seedorf","Borgentreich","Borger","Borgholzhausen","Borgsdorf","Borgstedt","Borgsum","Borken","Borken","Borkheide","Borkum","Borkwalde","Born","Borna","Borne","Bornheim","Bornheim","Bornhoved","Bornich","Bornitz","Bornsen","Bornstein","Borsdorf","Borsfleth","Borstel","Borstel-Hohenraden","Bortlingen","Bosau","Bosel","Bosingen","Bosleben-Wullersleben","Botersen","Bothkamp","Bottrop","Botzingen","Bous","Bovenden","Boxberg","Brachbach","Brackel","Brackenheim","Brake (Unterweser)","Brakel","Bramsche","Bramstedt","Brand","Brand-Erbisdorf","Brande-Hornerkirchen","Brandenburg","Brandis","Brandl","Brandshagen","Brannenburg","Braubach","Braunfels","Braunlage","Braunlingen","Braunsbach","Braunsbedra","Braunschweig","Brauweiler","Brebel","Breckerfeld","Breddenberg","Breddorf","Bredenbek","Bredeney","Bredstedt","Breesen","Breest","Bregenstedt","Breidenbach","Breiholz","Breisach","Breit","Breitbrunn am Chiemsee","Breitenau","Breitenbach","Breitenbach","Breitenbach","Breitenbach am Herzberg","Breitenberg","Breitenbrunn","Breitenbrunn","Breitenburg","Breitenfelde","Breitengussbach","Breitenworbis","Breitnau","Breitscheid","Breitscheid","Breitscheid","Breitscheidt","Breitungen","Brekendorf","Bremen","Bremerhaven","Bremervorde","Brennberg","Brensbach","Brenz","Bretten","Bretthausen","Bretzfeld","Breuna","Brey","Brickeln","Brieselang","Brieske","Brieskow-Finkenheerd","Brietlingen","Brilon","Britz","Brockum","Brodersby","Broderstorf","Brodhagen","Broeckel","Brokdorf","Brokstedt","Brome","Bromskirchen","Brotterode","Bruch","Bruchhausen","Bruchhausen-Vilsen","Bruchkobel","Bruchmuhlbach-Miesau","Bruchsal","Bruchweiler","Bruck","Bruck in der Oberpfalz","Bruckberg","Brucken","Bruckmuhl","Brucktal","Bruel","Bruggen","Bruggen","Bruhl","Bruhl","Brunn","Brunnthal","Brunsbuttel","Brunstorf","Brusewitz","Brussow","Bubenheim","Bubenreuth","Bubesheim","Buborn","Buch","Buch","Buch","Buch am Buchrain","Buch am Erlbach","Bucha","Bucha","Buchbach","Buchbach","Buchberg","Buchel","Buchen","Buchen","Buchenbach","Buchenbach","Buchenberg","Buchfart","Buchholz","Buchholz","Buchholz in der Nordheide","Buchlberg","Buchloe","Buchwaldchen","Buchwalde","Buckeburg","Buckenhof","Buckow","Buden","Budenheim","Budingen","Bueddenstedt","Buedelsdorf","Buende","Buggingen","Buhl","Buhlen","Buhler","Buhlerhohe","Buhlertal","Buhlertann","Buhlerzell","Bulkau","Bullay","Bulow","Bulowerburg","Bunde","Bundenthal","Bunsoh","Burbach","Burbach","Buren","Burg","Burg","Burg auf Fehmarn","Burg bei Magdeburg","Burg Stargard","Burg-Grambke","Burgau","Burgberg","Burgbernheim","Burgbrohl","Burgdorf, Hanover","Burgebrach","Burgen","Burgerhof","Burghaslach","Burghaun","Burghausen","Burgheim","Burgkirchen an der Alz","Burgkunstadt","Burglauer","Burglengenfeld","Burgoberbach","Burgrieden","Burgschwalbach","Burgsinn","Burgsponheim","Burgstadt","Burgstadt","Burgstall","Burgstetten","Burgthann","Burgwedel","Burgwindheim","Burk","Burkardroth","Burkau","Burkhardtsdorf","Burladingen","Burscheid","Burstadt","Burtenbach","Burweg","Buschbell","Buschhausen","Busdorf","Busenberg","Butjadingen","Buttelborn","Buttelstedt","Buttenheim","Buttenwiesen","Butthard","Buttstedt","Butzbach","Butzow","Buxheim","Buxtehude","Cadenberge","Cadolzburg","Calau","Calbe","Calberlah","Calden","Callbach","Callenberg","Calvorde","Calw","Cambs","Camin","Cannewitz","Cappel","Cappeln","Caputh","Carlow","Carlsberg","Carmzow","Carolinensiel","Castrop-Rauxel","Catterfeld","Celle","Cham","Chamerau","Chemnitz","Chieming","Chiemsee","Chostlarn","Clausen","Claussnitz","Clausthal","Clausthal-Zellerfeld","Cleebronn","Cloppenburg","Coburg","Cochem","Coesfeld","Colbe","Colbitz","Colditz","Colmnitz","Colnrade","Cologne","Contwig","Coppenbrugge","Coppengrave","Cornberg","Coswig","Coswig","Cottbus","Crailsheim","Cramonshagen","Cranz","Cremlingen","Creussen","Creuzburg","Crimmitschau","Crinitz","Crivitz","Crossen","Crostau","Crottendorf","Cunewalde","Cuxhaven","Daaden","Dabel","Dabelow","Dabendorf","Dabergotz","Dachau","Dachwig","Dackscheid","Dagersheim","Dahlem","Dahlen","Dahlenburg","Dahlenwarsleben","Dahlewitz","Dahme","Dahme","Dahn","Dahnsdorf","Dallgow-Doeberitz","Dalum","Dambeck","Damlos","Damme","Damp","Danischenhagen","Dankenfeld","Dankmarshausen","Danndorf","Dannenberg","Dannstadt-Schauernheim","Dardesheim","Darmstadt","Darstein","Dasing","Dassel","Dassendorf","Dassow","Datteln","Dattenberg","Dauborn","Dauchingen","Daun","Dausenau","Deckenpfronn","Dedeleben","Dedelstorf","Dederstedt","Degerloch","Deggendorf","Deggenhausen","Deggingen","Deidesheim","Deilingen","Deining","Deiningen","Deinste","Deisenhofen","Deisslingen","Deizisau","Delbruck","Delingsdorf","Delitzsch","Dellfeld","Delligsen","Dellmensingen","Delmenhorst","Delve","Demitz-Thumitz","Demmin","Denkendorf","Denkendorf","Denkingen","Denklingen","Densborn","Dentlein am Forst","Denzlingen","Derben","Derenburg","Dermbach","Dernau","Dernbach","Derschen","Dersum","Dessau","Dessow","Destedt","Detern","Detmold","Dettelbach","Dettenhausen","Dettighofen","Dettingen an der Erms","Dettingen an der Iller","Dettingen unter Teck","Dettmannsdorf","Deutsch","Deutsch Evern","Deutsches Haus","Deutz","Deutzen","Dexheim","Diana","Dibbersen","Diebach","Dieblich","Dieburg","Diedersdorf","Diedorf","Diedorf","Diefflen","Diekholzen","Dielheim","Dielingen","Dienheim","Dienstweiler","Diepenau","Diepersdorf","Diepholz","Dierdorf","Dierkow","Dieskau","Diessen am Ammersee","Dietenheim","Dietenhofen","Dietersburg","Dietersheim","Dietfurt","Dietingen","Dietlingen","Dietmannsried","Dietramszell","Dietrichingen","Dietzenbach","Diez","Dillenburg","Dillingen","Dillingen an der Donau","Dingelstadt","Dingelstedt","Dingolfing","Dingolshausen","Dingstede","Dinkelscherben","Dinklage","Dinslaken","Dintesheim","Dipbach","Dippach","Dipperz","Dippoldiswalde","Dirlewang","Dirmingen","Dirmstein","Dischingen","Dissen","Ditfurt","Dittelbrunn","Dittelsdorf","Dittelsheim-Hessloch","Dittenheim","Dittweiler","Ditzingen","Dobel","Dobeln","Doberlug-Kirchhain","Doberschau","Doberschutz","Dobitschen","Dobler","Dobra","Dockingen","Dogern","Dohlau","Dohle","Dohna","Dohren","Dolgesheim","Dollern","Dollnstein","Dombuhl","Domitz","Dommitzsch","Domsdorf","Domsuhl","Donaueschingen","Donaustauf","Donndorf","Donnersdorf","Donsieders","Donzdorf","Dorentrup","Dorf","Dorf Doberitz","Dorfen","Dorfles","Dorfprozelten","Dormagen","Dormettingen","Dornburg","Dorndorf","Dornhan","Dornheim","Dornstadt","Dornstetten","Dornum","Dorpen","Dorpstedt","Dorstadt","Dorsten","Dorth","Dortmund","Dorum","Dorverden","Dorzbach","Dossenheim","Dotlingen","Dotternhausen","Drachselsried","Drage","Dransfeld","Dranske","Drebach","Drebkau","Dreetz","Dreieich","Dreikirchen","Dreis","Dreisbach","Drelsdorf","Drensteinfurt","Dresden","Drestedt","Dreveskirchen","Driedorf","Driftsethe","Drochtersen","Drolshagen","Droyssig","Drubeck","Duchelsdorf","Ducherow","Duchroth","Dudenhofen","Duderode","Duderstadt","Duggendorf","Duingen","Duisburg","Dulmen","Dummerstorf","Dungenheim","Dunningen","Dunnwald","Dunzweiler","Durach","Durbach","Durbheim","Durchhausen","Durlangen","Durmentingen","Durmersheim","Durnau","Durrbrunn","Dusseldorf","Dusslingen","Ebeleben","Ebelsbach","Ebendorf","Ebensfeld","Ebenweiler","Eberbach","Eberdingen","Eberhardzell","Ebermannsdorf","Ebermannstadt","Ebern","Ebernhahn","Ebersbach","Ebersbach an der Fils","Ebersberg","Ebersdorf","Ebershausen","Eberstadt","Eberstadt","Eberswalde","Ebertsheim","Ebhausen","Ebnat","Ebrach","Ebringen","Ebstorf","Eching","Echterdingen","Echzell","Eckartsberg","Eckartsberga","Eckernforde","Eckersdorf","Eckfeld","Ecklingerode","Eddelak","Edelsfeld","Edemissen","Eden","Edenkoben","Ederheim","Edesheim","Edewecht","Edingen-Neckarhausen","Edling","Effelder","Effeltrich","Efringen-Kirchen","Egeln","Egelsbach","Egenhausen","Egenhausen","Egenhofen","Egesheim","Egestorf","Egg an der Gunz","Eggebek","Eggenfelden","Eggenstein-Leopoldshafen","Eggenthal","Eggersdorf","Eggersdorf","Eggesin","Eggingen","Egglham","Eggolsheim","Eggstatt","Eging","Egling","Egloffstein","Egmating","Ehekirchen","Ehingen","Ehingen","Ehingen","Ehlscheid","Ehndorf","Ehningen","Ehrenberg","Ehrenburg","Ehrenfeld","Ehrenfriedersdorf","Ehringshausen","Eibau","Eibelshausen","Eibelstadt","Eibenstock","Eibsee","Eich","Eichelgarten","Eichen","Eichen","Eichenau","Eichenbarleben","Eichenberg","Eichenbuhl","Eichendorf","Eichenzell","Eicherloh","Eichstaett","Eichstedt","Eichstetten","Eichtersheim","Eichwalde","Eicklingen","Eigeltingen","Eilenburg","Eilenburg, Berg","Eilsleben","Eime","Eimeldingen","Eimsheim","Einbeck","Einhaus","Einhausen","Einhausen","Einsbach","Einselthum","Eiselfing","Eisenach","Eisenbach","Eisenbach","Eisenbach","Eisenberg","Eisenberg","Eisenberg","Eisfeld","Eisingen","Eisingen","Eislingen","Eitelborn","Eitensheim","Eiterfeld","Eitorf","Eitting","Elbe","Elbingerode","Eldena","Eldingen","Elend","Elfershausen","Elgersburg","Elisabeth-Sophien-Koog","Elkenroth","Ellefeld","Ellenberg","Ellerau","Ellerbek","Ellerdorf","Ellerhoop","Ellerstadt","Ellgau","Ellhofen","Ellingen","Ellrich","Ellwangen","Ellzee","Elm","Elmenhorst","Elmlohe","Elmpt","Elmshorn","Elmstein","Elsdorf","Elsdorf-Westermuhlen","Elsendorf","Elsenfeld","Elsfleth","Elster","Elsterberg","Elsterwerda","Elstorf","Elstra","Elterlein","Eltmann","Eltville","Elxleben","Elz","Elzach","Elze","Embsen","Emden","Emerkingen","Emlichheim","Emmelshausen","Emmendorf","Emmerich","Emmering","Emmering","Emmerzhausen","Emmingen-Liptingen","Empfertshausen","Empfingen","Emsburen","Emsdetten","Emskirchen","Emstal","Emstek","Emtinghausen","Emtmannsberg","Endingen","Engden","Engelsberg","Engelsbrand","Engelsburg","Engelshof","Engelskirchen","Engelstadt","Engelthal","Engen","Enger","Eningen unter Achalm","Enkenbach-Alsenborn","Enkirch","Ennepetal","Ennigerloh","Ensdorf","Ensdorf","Ensen","Entringen","Epfenbach","Epfendorf","Eppelborn","Eppelheim","Eppelsheim","Eppenbrunn","Eppendorf","Eppenrod","Eppertshausen","Eppingen","Eppishausen","Eppstein","Erbach","Erbach im Odenwald","Erbendorf","Erbes-Budesheim","Erda","Erdeborn","Erding","Erdmannhausen","Erdweg","Eresing","Erfde","Erfelden","Erftstadt","Erfurt","Ergersheim","Ergolding","Ergoldsbach","Erika","Ering","Eriskirch","Erkelenz","Erkheim","Erkner","Erkrath","Erlabrunn","Erlach","Erlangen","Erlau","Erlbach","Erlenbach","Erlenbach am Main","Erlenbach bei Marktheidenfeld","Erlenmoos","Erlensee","Erligheim","Ermershausen","Ermke","Erndtebruck","Ernsgaden","Ernst","Ernsthof","Ernstroda","Ernstthal","Erolzheim","Erpel","Erpolzheim","Ersingen","Ertingen","Erwitte","Erzenhausen","Erzhausen","Erzingen","Eschach","Eschau","Eschbach","Eschborn","Escheburg","Eschede","Eschelbronn","Eschenbach","Eschenbach","Eschenbach","Eschenlohe","Eschershausen","Eschfeld","Eschlkam","Eschwege","Eschweiler","Esens","Esgrus","Eslarn","Eslohe","Espelkamp","Espelkamp-Mittwald","Espenau","Espenhain","Essel","Esselborn","Essen","Essen","Essenbach","Essenheim","Essingen","Esslingen am Neckar","Estenfeld","Esterwegen","Esthal","Estorf","Etschberg","Etteln","Ettenheim","Ettenstatt","Ettersburg","Etterschlag","Ettleben","Ettlingen","Ettringen","Etzelwang","Etzenricht","Euerbach","Euerdorf","Eurasburg","Euskirchen","Eussenheim","Eutin","Eutingen","Everode","Eversmeer","Everswinkel","Evessen","Ewersbach","Eydelstedt","Eyendorf","Eystrup","Fachbach","Fahrdorf","Fahrenbach","Fahrenbach","Fahrendorf","Fahrenkrug","Fahrenzhausen","Fahrland","Faid","Falkenberg","Falkenberg","Falkendorf","Falkenfels","Falkensee","Falkenstein","Fallersleben","Falls","Fambach","Farchant","Fargau-Pratjau","Farnroda","Farnstadt","Fassberg","Fatschenbrunn","Faulbach","Fehl-Ritzhausen","Fehmarn","Fehrbellin","Feilbingert","Feilitzsch","Feldafing","Feldberg","Feldberg-Ort","Felde","Feldkirchen","Feldkirchen","Feldkirchen-Westerham","Feldrennach","Fell","Fellbach","Felm","Felsberg","Ferchesar","Fernthal","Festenburg","Feucht","Feuchtwangen","Feusdorf","Fichtelberg","Fichtenberg","Fichtenberg","Fichtenwalde","Filderstadt","Filsen","Filsum","Filzen","Fincken","Finkenbach","Finnentrop","Finningen","Finowfurt","Finsing","Finsterwalde","Fintel","Firrel","Fischach","Fischbach","Fischbach","Fischbachau","Fischen","Fischerbach","Fischerhude","Fischingen","Flachslanden","Flacht","Flammersfeld","Flechtingen","Fleckeby","Flecken Zechlin","Flein","Fleisbach","Flensburg","Flieden","Flinsbach","Flintbek","Flintsbach","Floha","Flomborn","Flonheim","Florsheim","Florstadt","Floss","Flothe","Flurstedt","Fockbek","Fohren","Fohren-Linden","Forbach","Forchheim","Forchtenberg","Forheim","Forst","Forst","Forst","Forstern","Forsthaus","Forstinning","Frammersbach","Frankenau","Frankenberg","Frankenberg","Frankenheim","Frankenstein","Frankenthal","Frankenwinheim","Frankfurt (Oder)","Frankfurt am Main","Frankisch-Crumbach","Frankweiler","Franzenheim","Frasdorf","Frauenau","Frauendorf","Frauenstein","Fraunberg","Fraureuth","Frechen","Freckenfeld","Freckenhorst","Fredelsloh","Freden","Fredersdorf","Freiberg","Freiberg am Neckar","Freiburg","Freiburg","Freihung","Freilassing","Freimersheim","Freinsheim","Freirachdorf","Freisbach","Freisen","Freising","Freital","Freiwalde","Fremdingen","Frensdorf","Freren","Fresenburg","Freudenberg","Freudenberg","Freudenberg","Freudenberg","Freudenburg","Freudenstadt","Freudental","Freudenweiler","Freund","Freyburg","Freystadt","Freyung","Frickenhausen","Frickingen","Fridingen an der Donau","Fridolfing","Friedberg","Friedberg","Friedeburg","Friedelsheim","Friedensau","Friedensdorf","Friedenweiler","Friedersdorf","Friedewald","Friedland","Friedland","Friedrichroda","Friedrichsdorf","Friedrichshafen","Friedrichsholm","Friedrichskoog","Friedrichsort","Friedrichstadt","Friedrichsthal","Friedrichswerth","Frielendorf","Friemar","Friesack","Friesenhagen","Friesenheim","Friesenheim","Friesenried","Friesoythe","Friolzheim","Frittlingen","Fritzlar","Frohburg","Frommern","Frondenberg","Fronhausen","Fronhofen","Frontenhausen","Frose","Fuchshain","Fuchsstadt","Fulda","Fuldabruck","Fuldatal","Funfeichen","Funfstetten","Furholzen","Furstenau","Furstenberg","Furstenberg","Fursteneck","Furstenstein","Furstenwald","Furstenwalde","Furstenzell","Furth","Furth im Wald","Furthen","Furtwangen im Schwarzwald","Fusternberg","Gablenz","Gablingen","Gachenbach","Gadebusch","Gadegast","Gagern","Gaggenau","Gahlkow","Gaiberg","Gaienhofen","Gaildorf","Gailingen","Gaimersheim","Gaishofen","Gaissach","Galenbeck","Gammellund","Gammelsdorf","Gammelshausen","Gammertingen","Ganderkesee","Gangelt","Gangkofen","Gangloff","Garbek","Garbsen","Garching an der Alz","Garching bei Munchen","Gardelegen","Garden","Garlstorf","Garmisch-Partenkirchen","Garrel","Gars","Gartow","Gartringen","Garz","Garz","Gatersleben","Gattendorf","Gau-Algesheim","Gau-Bickelheim","Gau-Bischofsheim","Gau-Odernheim","Gaukonigshofen","Gauting","Gebenbach","Gebesee","Gebhardshain","Gechingen","Gedern","Geeste","Geesthacht","Gefell","Gefrees","Gehaus","Gehlenbeck","Gehofen","Gehrde","Gehrden","Gehrweiler","Geiersthal","Geilenkirchen","Geinsheim","Geinsheim","Geiselbach","Geiselhoring","Geiselwind","Geisenfeld","Geisenhain","Geisenhausen","Geisenheim","Geisfeld","Geisig","Geising","Geisingen","Geisling","Geislingen","Geislingen an der Steige","Geithain","Gelbensande","Geldern","Geldersheim","Gelenau","Gelnhausen","Gelsenkirchen","Geltendorf","Gelting","Gemmingen","Gemmrigheim","Gemunden","Gemunden an der Wohra","Genderkingen","Gendorf","Gengenbach","Genkingen","Gensingen","Genthin","Georgensgmund","Georgenthal","Georgsdorf","Georgsmarienhutte","Gera","Geraberg","Gerabronn","Gerach","Geratskirchen","Gerau","Gerbershausen","Gerbrunn","Gerbstedt","Gerdau","Geretsried","Gerhardshofen","Gerichshain","Geringswalde","Gerlachsheim","Gerlfangen","Gerlingen","Germering","Germersheim","Gernrode","Gernrode","Gernsbach","Gernsheim","Gerolfingen","Gerolsbach","Gerolsheim","Gerolstein","Gerolzhofen","Gersdorf","Gersfeld","Gershasen","Gersheim","Gerstetten","Gersthofen","Gerstungen","Gerwisch","Gerzen","Gescher","Geschwenda","Geseke","Gessertshausen","Gestungshausen","Getelo","Gettorf","Gevelsberg","Gevensleben","Geversdorf","Geyer","Giebelstadt","Gieboldehausen","Gielde","Gieleroth","Giengen an der Brenz","Gierstadt","Giesen","Giesenkirchen","Giessen","Gifhorn","Giggenhausen","Gilching","Gillenfeld","Gillersdorf","Gilserberg","Gimbsheim","Gingen an der Fils","Gingst","Ginsheim-Gustavsburg","Girod","Gittelde","Gladbach","Gladbeck","Gladenbach","Glan-Munchweiler","Glandorf","Glasewitz","Glashagen","Glashutte","Glashutten","Glashutten","Glattbach","Glatten","Glauburg","Glauchau","Gleichen","Gleiritsch","Gleissenberg","Gleisweiler","Gleschendorf","Glien","Glienicke","Glinde","Glindenberg","Glonn","Gluckstadt","Gmain bei Weidach","Gmund am Tegernsee","Gnadau","Gnarrenburg","Gnaschwitz","Gnoien","Gnotzheim","Gnutz","Goch","Gochsheim","Goda","Goggingen","Gohrde","Gohren","Goldbach","Goldberg","Goldelund","Goldenstedt","Goldewin","Goldkronach","Gollheim","Gollhofen","Golm","Golmbach","Golssen","Golzow","Gomadingen","Gomaringen","Gommern","Gommersheim","Gondelsheim","Gondenbrett","Gonnheim","Gorenzen","Goritz","Gorkwitz","Gornsdorf","Gorschendorf","Gorwihl","Goseck","Gosheim","Goslar","Gossel","Gossen","Gossersweiler-Stein","Gossnitz","Gossweinstein","Gotha","Gotteszell","Gottfrieding","Gottmadingen","Graach","Grabau","Graben","Graben-Neudorf","Grabenstatt","Grabenstetten","Grabow","Grafelfing","Grafenau","Grafenberg","Grafengehaig","Grafenhainichen","Grafenhausen","Grafenrheinfeld","Grafenroda","Grafenthal","Grafenwohr","Grafhorst","Grafing bei Munchen","Grafrath","Grafschaft","Grainau","Graitschen","Grambin","Grambow","Grammow","Gramzow","Gransee","Grasberg","Grasbrunn","Grassau","Gravenbruch","Graveneck","Gravenwiesbach","Grebbin","Grebenau","Grebenhain","Grebenstein","Greding","Green","Grefrath","Greifenberg","Greifenstein","Greifswald","Greiling","Greiz","Gremersdorf","Gremsdorf","Grenzach-Wyhlen","Grenzau","Greppin","Grethem","Grethen","Grettstadt","Greussen","Greussenheim","Greven","Grevenbroich","Grevesmuhlen","Gribow","Gries","Griesheim","Griesingen","Griesstatt","Grimma","Grimmen","Grobenzell","Grobzig","Groditz","Groditz","Groeningen","Groitzsch","Grolsheim","Grombach","Gromitz","Gronau","Gronau","Gronau","Gronenbach","Gronwohld","Gross Bengerstorf","Gross Gronau","Gross Kiesow","Gross Koris","Gross Kreutz","Gross Kummerfeld","Gross Lindow","Gross Miltzow","Gross Oesingen","Gross Rheide","Gross Santersleben","Gross Twulpstedt","Gross Wittensee","Gross-Bieberau","Gross-Gerau","Gross-Rohrheim","Gross-Umstadt","Gross-Zimmern","Grossaitingen","Grossalmerode","Grossbardorf","Grossbeeren","Grossbettlingen","Grossbottwar","Grossbreitenbach","Grosselfingen","Grossenaspe","Grossengottern","Grossenhain","Grossenkneten","Grossenluder","Grossensee","Grossenseebach","Grossenwiehe","Grosserlach","Grosshabersdorf","Grosshansdorf","Grossharthau","Grossheide","Grossheirath","Grossheubach","Grosskarolinenfeld","Grosskorbetha","Grosskrotzenburg","Grosskugel","Grosslittgen","Grosslobichau","Grossmaischeid","Grossmehring","Grossmonra","Grossostheim","Grossposna","Grossraschen","Grossrinderfeld","Grossrohrsdorf","Grossrosseln","Grossruckerswalde","Grossschirma","Grossschonau","Grosssolt","Grosswallstadt","Grosswechsungen","Grove","Gruibingen","Gruna","Grunberg","Grundau","Grundhof","Grunenberg","Grunenplan","Grunenthal","Grunhainichen","Grunheide","Grunhof","Grunkraut","Grunstadt","Grunwald","Gschwend","Guben","Guckheim","Gudensberg","Guenzburg","Guestrow","Guglingen","Gulzow","Gulzow","Gulzowshof","Gummersbach","Gundelfingen","Gundelfingen","Gundelsheim","Gundelsheim","Gundernhausen","Gundersheim","Gundremmingen","Gunningen","Guntersblum","Guntersleben","Gunthersleben","Gunzenhausen","Gurtweil","Gustavel","Gusten","Gusterath","Gutach (Schwarzwaldbahn)","Gutach im Breisgau","Gutenacker","Gutenberg","Gutenstetten","Gutenzell-Hurbel","Gutmadingen","Gutow","Gutzkow","Guxhagen","Gyhum","Haag","Haag an der Amper","Haan","Haar","Haarbach","Haaren","Habach","Habenhausen","Habersdorf","Hachenburg","Hackenheim","Hadamar","Hademstorf","Haenigsen","Hafenlohr","Haffkrug","Hage","Hagelstadt","Hagen","Hagen","Hagenbach","Hagenburg","Hagenow","Hagnau","Hahn","Hahnbach","Hahnenbach","Hahnheim","Hahnstatten","Haibach","Haide","Haidhof","Haidmuhle","Haiger","Haigerloch","Haimhausen","Haiming","Haina","Hainewalde","Hainichen","Hainsfarth","Haiterbach","Halbe","Halberg","Halberstadt","Halblech","Halbs","Haldensleben I","Haldenwang","Halfing","Hallbergmoos","Halle","Halle","Halle","Halle Neustadt","Hallenberg","Hallerndorf","Hallnberg","Hallschlag","Hallstadt","Halsbach","Halsbrucke","Halsenbach","Halstenbek","Haltern","Halver","Halvesbostel","Hamb","Hamberge","Hambergen","Hambrucken","Hambuhren","Hamburg","Hamdorf","Hamelin","Hamm","Hammah","Hammelburg","Hammersbach","Hamminkeln","Hamwarde","Hanau","Handeloh","Handewitt","Hanerau-Hademarschen","Hanhofen","Hankensbuttel","Hannover","Hanover","Hanstedt","Happurg","Harburg","Hard","Hardegsen","Hardenberg","Hardheim","Hardt","Haren","Hargesheim","Harlachen","Harmsdorf","Harmstorf","Harpstedt","Harra","Harrislee","Harschbach","Harsefeld","Harsewinkel","Harsleben","Harste","Harsum","Hartenfels","Hartenholm","Hartenstein","Hartenstein","Hartha","Harthausen","Hartheim","Hartmannsdorf","Hartmannsdorf","Harxheim","Harzgerode","Hasbergen","Haschbach an der Glan","Hasel","Haselbach","Haseldorf","Haselunne","Hasenmoor","Haslach im Kinzigtal","Hasloch","Hasloh","Hassel","Hassel","Hasselbach","Hasselberg","Hasselfelde","Hassfurt","Hassloch","Hassmersheim","Haste","Hastenrath","Haswede","Hatten","Hattenhofen","Hattenhofen","Hattersheim","Hattert","Hattingen","Hattorf","Hattstedt","Hatzenbuhl","Hatzfeld","Haus","Hausach","Hausen","Hausen","Hausen","Hausen am Tann","Hausen ob Verena","Hausen uber Aar","Hauser","Hausern","Hausham","Hausten","Hauteroda","Hauzenberg","Havelberg","Haverkamp","Havixbeck","Hawangen","Hayingen","Hebertsfelden","Hebertshausen","Hechingen","Hechthausen","Hecklingen","Heddesheim","Heede","Heeg","Heek","Heeslingen","Hefersweiler","Hegge","Hehlen","Heide","Heide","Heideck","Heidehof","Heidekamp","Heidelberg","Heiden","Heidenau","Heidenau","Heidenburg","Heidenheim","Heidesheim","Heigenbrucken","Heikendorf","Heilbad Heiligenstadt","Heilbronn","Heiligengrabe","Heiligenhafen","Heiligenhagen","Heiligenhaus","Heiligenroth","Heiligenstadt","Heiligenstedtenerkamp","Heiligenthal","Heiligkreuzsteinach","Heilingen","Heilsbronn","Heimbach","Heimbach","Heimbuchenthal","Heimenkirch","Heimertingen","Heimerzheim","Heimsheim","Heimstetten","Heinade","Heinbockel","Heinersreuth","Heiningen","Heiningen","Heinkenborstel","Heinrichsthal","Heinsberg","Heinsdorf","Heinz","Heinzenberg","Heinzenhausen","Heisede","Heist","Heitersheim","Helbra","Heldrungen","Helfant","Helferskirchen","Hellenhahn-Schellenberg","Hellenthal","Hellstein","Hellweg","Helmbrechts","Helmenzen","Helmern","Helmershausen","Helmstadt","Helmste","Helmstedt","Helpsen","Helsa","Heltersberg","Helvesiek","Hemau","Hemdingen","Hemelingen","Hemer","Hemhofen","Hemmelzen","Hemmersdorf","Hemmingen","Hemmingen","Hemmingstedt","Hemmoor","Hemsbach","Hemsbunde","Hemslingen","Henfenfeld","Hengersberg","Hennef","Hennickendorf","Hennigsdorf","Hennstedt","Hennweiler","Henstedt-Ulzburg","Hepberg","Heppdiel","Heppenheim an der Bergstrasse","Hepstedt","Herbertingen","Herbolzheim","Herborn","Herborn","Herbrechtingen","Herbsleben","Herbstein","Herdecke","Herdorf","Herdwangen-Schonach","Herfatz","Herford","Herforst","Hergenfeld","Hergisdorf","Hergolding","Hergolshausen","Heringen","Heringen","Heringsdorf","Heringsdorf","Herleshausen","Hermannsburg","Hermaringen","Hermersberg","Hermeskeil","Hermsdorf","Herne","Heroldsbach","Heroldsberg","Herren Steinfeld","Herren-Sulzbach","Herrenberg","Herresbach","Herrieden","Herringen","Herrischried","Herrnburg","Herrnhut","Herrsching am Ammersee","Herrstein","Hersbruck","Herschbach","Herschberg","Herscheid","Herschweiler-Pettersheim","Herten","Herxheim","Herzberg","Herzberg am Harz","Herzebrock","Herzfeld","Herzlake","Herzogenaurach","Herzogenrath","Herzogsweiler","Hesedorf","Hesel","Hespe","Hessdorf","Hesselbach","Hessen","Hessheim","Hessigheim","Hessisch Lichtenau","Hessisch Oldendorf","Hetschburg","Hettenleidelheim","Hettenrodt","Hettstadt","Hettstedt","Hetzenhausen","Hetzerath","Hetzlinshofen","Hetzwege","Heubach","Heubach","Heuchelheim","Heuchlingen","Heudeber","Heudorf","Heuerssen","Heusenstamm","Heustreu","Heusweiler","Heuweiler","Heyerode","Hiddenhausen","Hiddensee","Hilbersdorf","Hilchenbach","Hildburghausen","Hildebrandshausen","Hilden","Hilders","Hildesheim","Hildrizhausen","Hilgermissen","Hilgert","Hilgertshausen-Tandern","Hille","Hillersleben","Hillesheim","Hillscheid","Hilpoltstein","Hilscheid","Hilter","Hiltpoltstein","Hiltrup","Hilwartshausen","Hilzingen","Himbergen","Himmelkron","Himmelpforten","Himmelstadt","Hinrichshagen","Hinte","Hinterhermsdorf","Hinterm Horn","Hinterschmiding","Hinterzarten","Hirrlingen","Hirschaid","Hirschau","Hirschberg","Hirschfelde","Hirschhorn","Hirschhorn","Hirschstein","Hirstein","Hirzenhain","Hirzlei","Hittbergen","Hitzacker","Hitzhofen","Hobbersdorf","Hobeck","Hochberg","Hochborn","Hochdonn","Hochdorf","Hochdorf","Hochdorf-Assenheim","Hochenschwand","Hochheim am Main","Hochkirch","Hochscheid","Hochspeyer","Hochst im Odenwald","Hochstadt","Hochstadt an der Aisch","Hochstadten","Hochstenbach","Hochstetten-Dhaun","Hochstrasse","Hochwang","Hockendorf","Hockenheim","Hodenhagen","Hof","Hof","Hof","Hofbieber","Hofen","Hofen an der Enz","Hofer","Hofgarten","Hofgeismar","Hofheim","Hofheim am Taunus","Hofkirchen","Hofstetten","Hohberg","Hohe","Hoheinod","Hohen","Hohen","Hohen Neuendorf","Hohen Schwarfs","Hohen Wangelin","Hohenaspe","Hohenau","Hohenberg","Hohenberg","Hohenbergham","Hohenbocka","Hohenbrunn","Hohendodeleben","Hoheneggelsen","Hohenerxleben","Hohenfelde","Hohenfelde","Hohenfels","Hohenfinow","Hohenfurch","Hohenhameln","Hohenhaus","Hohenhorn","Hohenkammer","Hohenkirchen-Siegertsbrunn","Hohenleimbach","Hohenleipisch","Hohenleuben","Hohenlimburg","Hohenlinden","Hohenlockstedt","Hohenmolsen","Hohenollen","Hohenpeissenberg","Hohenroda","Hohenroth","Hohenschaftlarn","Hohenstein","Hohenstein","Hohenstein-Ernstthal","Hohentengen am Hochrhein","Hohenthann","Hohenwart","Hohenwarthe","Hohenwestedt","Hohn","Hohn","Hohndorf","Hohne","Hohnhorst","Hohnstein","Hohnstorf","Hohr-Grenzhausen","Hoisdorf","Hoitlingen","Holdorf","Holle","Hollenbach","Hollenstedt","Holler","Hollern","Hollfeld","Hollingstedt","Hollstadt","Holm","Holte","Holthausen","Holtinghausen","Holtland","Holtsee","Holzbach","Holzengel","Holzgerlingen","Holzgunz","Holzhausen","Holzhausen an der Haide","Holzheim","Holzheim","Holzkirchen","Holzmaden","Holzminden","Holzweissig","Holzwickede","Homberg","Homberg","Homburg","Honebach","Hoogstede","Hopferau","Hopfingen","Hoppegarten","Hoppegarten","Hoppstadten-Weiersbach","Hopsten","Horath","Horb am Neckar","Horbach","Horbruch","Hordt","Horgau","Horgertshausen","Horhausen","Hormersdorf","Horn-Bad Meinberg","Hornbach","Hornberg","Hornburg","Horneburg","Horperath","Horressen","Horrweiler","Horselgau","Horst","Horst","Horst","Horstdorf","Horstedt","Horstel","Horstmar","Hosbach","Hosenfeld","Hoslwang","Hosskirch","Host","Hotensleben","Hovelhof","Hoya","Hoyerswerda","Hoym","Huckelhoven","Huckeswagen","Hude","Huellhorst","Huffelsheim","Huffenhardt","Hufingen","Hugelsheim","Huglfing","Huhnerhof","Huje","Hulben","Humptrup","Hunderdorf","Hundhaupten","Hundisburg","Hundsangen","Hundsdorf","Hunfeld","Hungen","Hungenroth","Hunxe","Hunzel","Hurlach","Hurtgenwald","Husby","Husum","Husum","Hutschenhausen","Huttblek","Huttenberg","Hutthurm","Huttisheim","Huttlingen","Ibach","Ibbenbueren","Ichenhausen","Ichtershausen","Icker","Icking","Idar-Oberstein","Idenheim","Idstein","Iffeldorf","Iffezheim","Igel","Igensdorf","Igersheim","Iggensbach","Iggingen","Ihlow","Ihringen","Ihrlerstein","Ilbesheim","Ilfeld","Illerrieden","Illertissen","Illingen","Illingen","Illschwang","Ilmenau","Ilmmunster","Ilsede","Ilsenburg","Ilsfeld","Ilshofen","Ilvesheim","Im Loh","Immendingen","Immenhausen","Immenreuth","Immenstaad am Bodensee","Immenstadt im Allgau","Imsbach","In der Meer","Inchenhofen","Inden","Ingelfingen","Ingelheim am Rhein","Ingersleben","Ingoldingen","Ingolstadt","Innernzell","Inning am Ammersee","Inning am Holz","Insel","Insheim","Insingen","Insul","Inzell","Inzigkofen","Inzlingen","Inzmuhlen","Iphofen","Ippesheim","Ipsheim","Irlbach","Irmenach","Irrel","Irschenberg","Irsee","Irxleben","Isen","Isenburg","Isenburg","Isenbuttel","Iserlohn","Ismaning","Isny im Allgau","Ispringen","Isselburg","Isseroda","Isserstedt","Issigau","Issum","Istein","Ittersbach","Ittlingen","Itzehoe","Itzstedt","Ivenack","Jacobsdorf","Jaderberg","Jagel","Jagerhof","Jagsthausen","Jagstzell","Jahnsdorf","Jahnshof","Jameln","Jarmen","Jebenhausen","Jeddeloh Eins","Jelmstorf","Jembke","Jemgum","Jena","Jengen","Jerichow","Jersbek","Jersleben","Jesberg","Jesendorf","Jessen","Jessnitz","Jestadt","Jesteburg","Jestetten","Jettenbach","Jettingen-Scheppach","Jetzendorf","Jevenstedt","Jever","Jheringsfehn","Joachimsthal","Jockgrim","Joehlingen","Johannesberg","Johanngeorgenstadt","Johstadt","Jork","Jorl","Jubek","Juchen","Jugenheim","Juist","Julbach","Julich","Juliusburg","Jungingen","Junkerath","Juterbog","Kaaks","Kaarst","Kadelburg","Kaden","Kagsdorf","Kahl am Main","Kahla","Kaisersbach","Kaisersesch","Kaiserslautern","Kaisheim","Kakenstorf","Kalbach","Kaldenkirchen","Kalefeld","Kalenborn-Scheuern","Kalkar","Kalkreuth","Kall","Kallmunz","Kallstadt","Kaltenengers","Kaltenkirchen","Kaltennordheim","Kaltenwestheim","Kamen","Kamenz","Kammerforst","Kammerforst","Kammerstein","Kamp-Bornhofen","Kamp-Lintfort","Kampen","Kamsdorf","Kandel","Kandern","Kanzlei","Kapellen-Drusweiler","Kapellenberg","Kappel-Grafenhausen","Kappeln","Kappelrodeck","Kapsweyer","Karbach","Karben","Karin","Karl","Karlsbad","Karlsdorf-Neuthard","Karlsfeld","Karlshagen","Karlshausen","Karlshuld","Karlskron","Karlsruhe","Karlstadt am Main","Karlstein","Karlum","Karsbach","Karsdorf","Karstadt","Karweiler","Kasbach-Ohlenberg","Kasdorf","Kasel-Golzig","Kasendorf","Kasseedorf","Kassel","Kassow","Kastel","Kastellaun","Kastl","Kastorf","Katlenburg-Lindau","Katzenelnbogen","Katzenmoos","Katzenstein","Katzow","Katzwang","Katzwinkel","Kaub","Kaufbeuren","Kaufering","Kaufungen","Kaulsdorf","Kayhude","Kayna","Kefenrod","Kefferhausen","Kehl","Keidelheim","Keitum","Kelberg","Kelbra","Kelheim","Kelkheim (Taunus)","Kell","Kellenhusen","Keller","Kellinghusen","Kelsterbach","Kemberg","Kemerting","Kemmern","Kemnath","Kempen","Kempenich","Kempfeld","Kempten (Allgaeu)","Kendenich","Kenn","Kennenburg","Kenzingen","Kerlingen","Kerpen","Kervenheim","Kerzenheim","Kesselbach","Kesselsdorf","Kestert","Ketsch","Kettenkamp","Kettershausen","Kettig","Ketzin","Kevelaer","Kiedrich","Kiefersfelden","Kiel","Kienberg","Kierspe","Kieselbach","Kieselbronn","Kiez","Kindelbruck","Kinding","Kindsbach","Kinheim","Kinsau","Kipfenberg","Kippenheim","Kirberg","Kirburg","Kirchardt","Kirchberg","Kirchberg","Kirchberg","Kirchberg","Kirchdorf","Kirchdorf","Kirchdorf am Inn","Kirchdorf im Wald","Kirchehrenbach","Kirchen","Kirchendemenreuth","Kirchenlamitz","Kirchentellinsfurt","Kirchenthumbach","Kirchgellersen","Kirchhain","Kirchham","Kirchhasel","Kirchhaslach","Kirchheilingen","Kirchheim","Kirchheim","Kirchheim am Ries","Kirchheim an der Weinstrasse","Kirchheim unter Teck","Kirchheimbolanden","Kirchhellen","Kirchhundem","Kirchlauter","Kirchlengern","Kirchlinteln","Kirchreit","Kirchroth","Kirchsahr","Kirchseelte","Kirchseeon","Kirchtimke","Kirchweg","Kirchweidach","Kirchweyhe","Kirchworbis","Kirchzarten","Kirchzell","Kirkel","Kirn","Kirrweiler","Kirschau","Kirschfurt","Kirschhofen","Kirspenich","Kirtorf","Kisdorf","Kisselbach","Kissenbruck","Kissing","Kisslegg","Kist","Kitzingen","Kitzscher","Kladen","Klais","Klanxbull","Klaus","Klausdorf","Klausen","Klausheide","Klein Ammensleben","Klein Berssen","Klein Kedingshagen","Klein Lichtenhagen","Klein Meckelsen","Klein Nordende","Klein Offenseth-Sparrieshoop","Klein Rogahn","Klein Ronnau","Klein Wesenberg","Klein Wittensee","Klein-Gerau","Klein-Schlamin","Klein-Winternheim","Klein-Zimmern","Kleinbeeren","Kleinblittersdorf","Kleinbundenbach","Kleinfahner","Kleinfurra","Kleinheubach","Kleinkahl","Kleinmachnow","Kleinmaischeid","Kleinostheim","Kleinrinderfeld","Kleinschwabhausen","Kleinsendelbach","Kleinsteinhausen","Kleinwallstadt","Kleinwolmsdorf","Klettwitz","Kleve","Klinge","Klingenberg","Klingenberg am Main","Klingenmunster","Klingenthal","Klink","Klipphausen","Kloster","Klosterhauser","Klosterlechfeld","Klostermansfeld","Klostersee","Klotten","Klotze","Kluis","Klutz","Knesebeck","Knetzgau","Knittelsheim","Knittlingen","Knobelsdorf","Knoringen","Kobern-Gondorf","Koblenz","Kochel","Kodersdorf","Koditz","Kodnitz","Kofering","Kohlberg","Kohra","Kohren-Sahlis","Kolbermoor","Kolbingen","Kolitzheim","Kolkwitz","Kolleda","Kollerbach","Kollmar","Kolln-Reisiek","Kollnburg","Kolpien","Komp","Kongen","Konigheim","Konigs Wusterhausen","Konigsbach-Stein","Konigsberg in Bayern","Konigsbronn","Konigsbruck","Konigsbrunn","Konigsbrunn","Konigsdorf","Konigsdorf","Konigsee","Konigseggwald","Konigsfeld","Konigsfeld im Schwarzwald","Konigsheim","Konigslutter am Elm","Konigstein","Konigstein","Konigstein im Taunus","Konigswartha","Konigswinter","Konken","Konnern","Konradsreuth","Konstanz","Konz","Konzell","Korb","Korbach","Korchow","Kordel","Korle","Korntal","Kornwestheim","Korperich","Korschenbroich","Kosching","Kossa","Kothel","Kottenheim","Kotterichen","Kottgeisering","Kottweiler-Schwanden","Kotzting","Koxhausen","Kraft","Kraftisried","Kraiburg am Inn","Krailling","Krakow am See","Kramerhof","Kranenburg","Kranichfeld","Kranzberg","Krauchenwies","Kraupa","Krauschwitz","Krauschwitz","Krautheim","Krautheim","Krefeld","Kreiensen","Kreischa","Kremmen","Krempe","Kremperheide","Kressbronn am Bodensee","Krettnach","Kretzschau","Kreuz","Kreuzau","Kreuztal","Kreuzwertheim","Krickenbach","Kriebitzsch","Kriebstein","Kriftel","Kritzmow","Kritzow","Krolpa","Krombach","Kronach","Kronau","Kronberg","Kronshagen","Kropelin","Kropp","Kroppelshagen-Fahrendorf","Kroppenstedt","Kroslin","Krostitz","Krov","Kruden","Kruft","Krugsdorf","Krugzell","Krumbach","Krumhermersdorf","Krummensee","Krummesse","Krumpa","Krumstedt","Krun","Kubschutz","Kuchen","Kuddeworde","Kuenzelsau","Kueps Oberfranken","Kuhardt","Kuhbach","Kuhn","Kuhndorf","Kuhstedt","Kukels","Kulmbach","Kulsheim","Kulz","Kumhausen","Kummerfeld","Kummersbruck","Kunreuth","Kunzell","Kunzing","Kupferberg","Kupferzell","Kuppenheim","Kurnach","Kurnbach","Kurort Hartha","Kurort Steinbach-Hallenberg","Kurten","Kurtscheid","Kusel","Kusterdingen","Kutenholz","Kutzenhausen","Kyritz","Laaber","Laage","Laasdorf","Laatzen","Labejum","Labenz","Laboe","Lachen","Lachendorf","Ladbergen","Ladenburg","Laer","Lage","Lage","Lagerdorf","Lagesbuttel","Lahden","Lahm","Lahnstein","Lahr","Lahr","Lahrbach","Laichingen","Lain","Lalendorf","Lam","Lambertsberg","Lambrecht","Lambsheim","Lamerdingen","Lampertheim","Lampertswalde","Lamspringe","Lamstedt","Landau","Landau an der Isar","Landensberg","Landesbergen","Landrecht","Landsberg","Landsberg am Lech","Landscheid","Landscheide","Landshut","Landstuhl","Langballig","Langebruck","Langeln","Langelsheim","Langen","Langen","Langenargen","Langenau","Langenbach","Langenbach","Langenbach","Langenberg","Langenbernsdorf","Langendorf","Langendorf","Langenenslingen","Langenfeld","Langenfeld","Langenhagen","Langenhorn","Langenlonsheim","Langenmosen","Langenneufnach","Langenpreising","Langenselbold","Langensendelbach","Langenweddingen","Langenwetzendorf","Langenwolmsdorf","Langenzenn","Langeoog","Langerringen","Langerwehe","Langewiesen","Langfurth","Langgons","Langlingen","Langquaid","Langstedt","Langsur","Langwasser","Langwedel","Langweid","Langweiler","Langwieden","Langwitz","Lappersdorf","Lasbek","Lassan","Lassentin","Lastrup","Lathen","Laubach","Lauben","Laubenheim","Laubusch","Laucha","Lauchhammer","Lauchheim","Lauchringen","Lauda-Konigshofen","Laudenbach","Laudert","Lauenau","Lauenbruck","Lauenburg","Lauenhagen","Lauf","Lauf an der Pegnitz","Laufach","Laufen","Laufenburg","Lauffen am Neckar","Laugna","Lauingen","Laumersheim","Laupheim","Laurenburg","Lauscha","Lauschied","Lausitz","Laussnitz","Lauta","Lauta","Lautenbach","Lautenthal","Lauter","Lauterach","Lauterbach","Lauterbach/Schwarzwald","Lauterburg","Lauterecken","Lauterhofen","Lautern","Lautersheim","Lautertal","Lautertal","Lautrach","Lautzenhausen","Lawalde","Lebach","Lebrade","Lebus","Lebusa","Lechbruck","Leck","Lederhose","Leegebruch","Leeheim","Leer","Leer","Leezdorf","Leezen","Leezen","Legau","Legden","Lehen","Lehesten","Lehmen","Lehmke","Lehndorf","Lehrberg","Lehre","Lehrensteinsfeld","Lehrte","Leibelbach","Leibertingen","Leiblfing","Leichlingen","Leidersbach","Leiferde","Leimbach","Leimbach","Leimen","Leimen","Leimersheim","Leinach","Leinburg","Leinefelde","Leinfelden-Echterdingen","Leingarten","Leinsweiler","Leipheim","Leipzig","Leisnig","Leitershofen","Leitzkau","Leiwen","Leizen","Lemberg","Lembruch","Lemforde","Lemgo","Lemwerder","Lengdorf","Lengede","Lengenfeld","Lengenfeld","Lengerich","Lengerich","Lenggries","Lengthal","Lennestadt","Lensahn","Lentfohrden","Lenting","Lenzkirch","Leonberg","Leonberg","Leopoldshagen","Leopoldshohe","Lerbach","Lessien","Lettenreuth","Leubsdorf","Leubsdorf","Leukersdorf","Leun","Leuna","Leutenbach","Leutenbach","Leutenberg","Leutershausen","Leuthen","Leutkirch im Allgau","Leverkusen","Lich","Lichte","Lichtenau","Lichtenau","Lichtenau","Lichtenau","Lichtenau","Lichtenberg","Lichtenberg","Lichtenbroich","Lichtenfels","Lichtenstein","Lichtenstein","Lichtentanne","Lichtenwald","Liebenau","Liebenau","Liebenburg","Liebenscheid","Liebenstein","Liebenwalde","Lieberose","Liederbach","Lienen","Liepgarten","Lieser","Lieskau","Lietzen","Lilienthal","Limbach","Limbach","Limbach-Oberfrohna","Limburg an der Lahn","Limburgerhof","Lindau","Linde","Linden","Linden","Linden","Linden","Linden","Linden","Lindenau","Lindenberg im Allgau","Lindenfels","Lindenthal","Lindern","Lindewitt","Lindhorst","Lindhorst","Lindigshof","Lindlar","Lindwedel","Lingen","Lingenfeld","Lingerhahn","Linkenbach","Linkenheim-Hochstetten","Linnich","Linow","Linsburg","Lintig","Linz am Rhein","Lippe","Lipporn","Lippstadt","Lissendorf","Listerfehrda","Litzendorf","Lobau","Loch","Lochau","Lochgau","Lochhausen","Lochum","Loddin","Loderburg","Loffenau","Loffingen","Lohberg","Lohe-Rickelshof","Loheide","Lohfelden","Lohmar","Lohnberg","Lohne","Lohne","Lohnsfeld","Lohr a. Main","Lohra","Lohsa","Loiching","Loitz","Lollar","Lollbach","Lommatzsch","Longkamp","Longuich","Loningen","Lonnerstadt","Lonnig","Lonsee","Lonsingen","Loose","Lorch","Lorsch","Lorscheid","Lorup","Losheim","Losheim","Lossburg","Lossnitz","Lostau","Lotte","Lottstetten","Lotzbeuren","Lowenstein","Loxstedt","Lubbecke","Lubbenau","Lubesse","Lubmin","Lubstorf","Lubtheen","Lubz","Luchem","Lucka","Luckau","Luckenbach","Luckenwalde","Ludersdorf","Ludersfeld","Ludinghausen","Ludwigsburg","Ludwigsfelde","Ludwigshafen","Ludwigshafen am Rhein","Ludwigshohe","Ludwigslust","Ludwigsstadt","Luebben","Luechow","Luerdissen","Luft","Luftkurort Arendsee","Lugau","Lugde","Luhden","Luhe-Wildenau","Lunne","Lunzenau","Lupburg","Lurschau","Lutau","Lutjenburg","Lutjensee","Lutter am Barenberge","Luttgenrode","Luttum","Lutz","Lutzelbach","Lutzen","Lutzerath","Lutzingen","Lychen","Lynow","Maasholm","Machern","Machtolsheim","Macken","Mackenbach","Magdala","Magdeburg","Magstadt","Mahlberg","Mahlow","Mahndorf","Maierhofen","Maikammer","Mailing","Mainaschaff","Mainbernheim","Mainburg","Mainhardt","Mainleus","Mainstockheim","Maintal","Mainz","Maisach","Maitenbeth","Malberg","Malborn","Malchin","Malchow","Malente","Malgersdorf","Mallersdorf-Pfaffenberg","Mallin","Malsburg","Malsch","Malsch","Malschwitz","Malsfeld","Malterdingen","Mammendorf","Mamming","Manching","Mandel","Mandern","Mannebach","Mannheim","Mannichswalde","Mansfeld","Mantel","Marbach am Neckar","Marburg","March","Margarethen","Margertshausen","Margetshochheim","Mariaposching","Marienberg","Marienburg","Marienfeld","Marienhafe","Marienhagen","Marienhausen","Marienheide","Marienrachdorf","Marienstein","Mariental","Maring-Noviand","Mark","Markdorf","Markersbach","Markgroningen","Markkleeberg","Marklkofen","Marklohe","Markneukirchen","Markranstadt","Marksuhl","Markt","Markt","Markt Einersheim","Markt Erlbach","Markt Indersdorf","Markt Rettenbach","Markt Schwaben","Markt Wald","Marktbreit","Marktgraitz","Marktheidenfeld","Marktl","Marktleugast","Marktleuthen","Marktoberdorf","Marktredwitz","Marktrodach","Marktschellenberg","Marktschorgast","Marl","Marlow","Marne","Marnheim","Marpingen","Marquartstein","Marsberg","Marschacht","Marschall","Marsdorf","Martensrade","Martfeld","Martinsried","Marwitz","Marxen","Marxgrun","Marxheim","Marzling","Maschen","Maselheim","Massbach","Massenbachhausen","Massenhausen","Massenheim","Massing","Mastershausen","Mastholte","Mattstedt","Mauer","Mauer","Mauerstetten","Maulbronn","Maulburg","Mauth","Maxdorf","Maxhutte-Haidhof","Maximilian","Mayen","Mechelgrun","Mechelroda","Mechenried","Mechernich","Meckenbach","Meckenbeuren","Meckenheim","Meckenheim","Meckesheim","Mecklenburg","Medard","Medebach","Medelby","Medow","Meeder","Meerane","Meerbeck","Meerbusch","Meersburg","Meesiger","Megesheim","Mehlbach","Mehlingen","Mehlmeisel","Mehmels","Mehr","Mehring","Mehring","Meine","Meinersen","Meinerzhagen","Meiningen","Meinsdorf","Meisenheim","Meissen","Meissenheim","Meitingen","Melbeck","Melchow","Meldorf","Melle","Mellenbach-Glasbach","Mellingen","Mellrichstadt","Melsbach","Melsdorf","Melsungen","Memmelsdorf","Memmingen","Memmingerberg","Menden","Mendig","Mengen","Mengerschied","Mengersgereuth-Hammern","Mengerskirchen","Mengkofen","Menslage","Meppen","Merching","Merchweiler","Merdingen","Merenberg","Mering","Merkelbach","Merkendorf","Merkers","Merklingen","Merschwitz","Merseburg","Mersheim","Mertendorf","Mertingen","Mertloch","Merxheim","Merzalben","Merzen","Merzenich","Merzhausen","Merzig","Meschede","Messel","Messkirch","Messstetten","Metelen","Metjendorf","Metten","Mettenheim","Metterich","Mettingen","Mettlach","Mettmann","Metzingen","Metzlos-Gehag","Meudt","Meuro","Meuselwitz","Meyn","Michelau","Michelbach an der Bilz","Michelfeld","Michelstadt","Michendorf","Mickhausen","Midlum","Miehlen","Mielenhausen","Mielkendorf","Miellen","Miesbach","Mieste","Mietingen","Mihla","Milbertshofen","Mildenau","Mildstedt","Milow","Miltenberg","Milzau","Mindelheim","Mindelstetten","Minden","Minfeld","Minsen","Mintraching","Mirow","Missen-Wilhams","Mistelbach","Mistelgau","Mittbach","Mittegrossefehn","Mittelbach","Mittelberg","Mittelbiberach","Mitteleschenbach","Mittelherwigsdorf","Mittelneufnach","Mittelnkirchen","Mittelrot","Mittelsaida","Mittelstenweiler","Mittelstetten","Mittelstreu","Mittenaar","Mittenwald","Mittenwalde","Mitterfelden","Mitterfels","Mitterstetten","Mitterteich","Mittweida","Mitwitz","Mixdorf","Mochau","Mochenwangen","Mockern","Mockmuhl","Mockrehna","Moers","Mogendorf","Mogglingen","Moglingen","Mohlsdorf","Mohnesee","Mohren","Mohrendorf","Mohrkirch","Moisburg","Molbergen","Molfsee","Mollenhagen","Molln","Molschow","Molsheim","Mombris","Momlingen","Mommenheim","Monchberg","Monchsdeggingen","Monchsroth","Monchweiler","Monheim","Monheim am Rhein","Monkeberg","Monreal","Monschau","Monsheim","Monsheim","Montabaur","Monzelfeld","Monzingen","Moor","Moorenweis","Moos","Moos","Moosach","Moosburg","Moosinning","Moosthenning","Morbach","Morenhoven","Morfelden-Walldorf","Moringen","Moritz","Moritzburg","Morlenbach","Morsbach","Morscheid","Morschheim","Morschied","Morsfeld","Morshausen","Morsleben","Morslingen","Mosbach","Moschenfeld","Moser","Mossingen","Mottgers","Mottingen","Motzingen","Moyland","Much","Mucheln","Mudau","Muden","Mudersbach","Mudershausen","Muehldorf","Muehlheim am Main","Mugeln","Muggendorf","Muggensturm","Muhl Rosin","Muhlacker","Muhlau","Muhle","Muhlen","Muhlhausen","Muhlhausen","Muhlhausen","Muhlhausen-Ehingen","Muhlheim an der Donau","Muhltal","Muhltroff","Muhr am See","Mulda","Muldenhammer","Muldenstein","Mulfingen","Mulheim-Karlich","Mullrose","Mulsen","Mulsum","Munchaurach","Munchberg","Muncheberg","Munchenbernsdorf","Munchhausen","Munchhausen","Munchsmunster","Munchsteinach","Munchweiler am Klingbach","Munchweiler an der Alsenz","Munderkingen","Mundersbach","Munich","Munich","Munnerstadt","Munsing","Munsingen","Munster","Munster","Munster","Munster-Sarmsheim","Munsterdorf","Munstermaifeld","Munzenberg","Munzingen","Murchin","Murg","Murlenbach","Murnau am Staffelsee","Murr","Murrhardt","Muschenbach","Mutlangen","Mutterschied","Mutterstadt","Mutzenich","Mutzschen","Mylau","Nabburg","Nachrodt-Wiblingwerde","Nachterstedt","Nachtsheim","Nackenheim","Nagel","Nagold","Nahe","Nahrendorf","Naila","Nakensdorf","Nalbach","Namborn","Nandlstadt","Nanzweiler","Nassau","Nassenfels","Nastatten","Nattenheim","Nattheim","Nauen","Nauendorf","Nauheim","Naumburg","Naumburg","Naunheim","Naunhof","Nauort","Naurath","Nebra","Nebringen","Neckarbischofsheim","Neckargemund","Neckargerach","Neckarrems","Neckarsteinach","Neckarsulm","Neckartailfingen","Neckartenzlingen","Neckarweihingen","Neckarwestheim","Neckarzimmern","Neehausen","Neenstetten","Neermoor","Neetze","Negast","Nehren","Neidenfels","Neidenstein","Neidlingen","Neitersen","Nellingen","Nennhausen","Nennig","Nennslingen","Nentershausen","Nerchau","Neresheim","Neroth","Nersingen","Nesselwang","Netphen","Nettersheim","Nettetal","Netze","Netzschkau","Neu Darchau","Neu Duvenstedt","Neu Isenburg","Neu Kaliss","Neu Sanitz","Neu Vitense","Neu Wulmstorf","Neu Zauche","Neu-Anspach","Neu-Ulm","Neubeckum","Neuberg","Neuberg","Neubeuern","Neubiberg","Neuborger","Neubrandenburg","Neubrunn","Neubukow","Neubulach","Neuburg","Neuburg","Neuburg an der Donau","Neudietendorf","Neudorf","Neudrossenfeld","Neuenbrook","Neuenburg am Rhein","Neuendettelsau","Neuendorf","Neuendorf","Neuendorf","Neuengors","Neuenhagen","Neuenhaus","Neuenkirchen","Neuenkirchen","Neuenkirchen","Neuenkirchen","Neuenkirchen","Neuenkirchen","Neuenmarkt","Neuenrade","Neuenstadt am Kocher","Neuenstein","Neuental","Neuerburg","Neufahrn bei Freising","Neufarn","Neuffen","Neufra","Neufrach","Neufraunhofen","Neugersdorf","Neuhardenberg","Neuhaus","Neuhaus","Neuhaus am Inn","Neuhaus am Rennweg","Neuhaus-Schierschnitz","Neuhausel","Neuhausen","Neuhausen","Neuhausen","Neuhausen auf den Fildern","Neuhausen ob Eck","Neuhemsbach","Neuhof","Neuhof","Neuhof","Neuhofen","Neuhutten","Neuhutten","Neukamperfehn","Neukeferloh","Neukieritzsch","Neukirch","Neukirch/Lausitz","Neukirchen","Neukirchen","Neukirchen","Neukirchen am Teisenberg","Neukirchen-Vluyn","Neukloster","Neuleiningen","Neulussheim","Neumagen-Dhron","Neumark","Neumarkt in der Oberpfalz","Neumarkt-Sankt Veit","Neunburg vorm Wald","Neundorf","Neundorf","Neunheilingen","Neunkirchen","Neunkirchen","Neunkirchen","Neunkirchen","Neunkirchen","Neunkirchen am Sand","Neuotting","Neupetershain","Neupotz","Neuravensburg","Neureichenau","Neuried","Neuried","Neuruppin","Neusalza-Spremberg","Neusass","Neuschonau","Neusitz","Neusorg","Neuss","Neustadt","Neustadt","Neustadt","Neustadt (Orla)","Neustadt am Rubenberge","Neustadt an der Aisch","Neustadt an der Orla","Neustadt an der Waldnaab","Neustadt bei Coburg","Neustadt in Holstein","Neustadt in Sachsen","Neustadt-Glewe","Neustadt/Westerwald","Neustrelitz","Neutraubling","Neutrebbin","Neutz-Lettewitz","Neuweiler","Neuwerk","Neuwied","Neuwittenbek","Neuzelle","Neverin","Neversdorf","Newel","Nickenich","Nidda","Nidderau","Nideggen","Niebull","Niedenstein","Nieder Ohmen","Nieder-Beerbach","Nieder-Olm","Niederaichbach","Niederalben","Niederalsen","Niederalteich","Niederau","Niederau","Niederaula","Niederbrechen","Niederbreitbach","Niederburg","Niederding","Niederdorf","Niederdorf","Niederdorfelden","Niederdorla","Niedereisenhausen","Niedereschach","Niederfell","Niederfischbach","Niederfrohna","Niederheimbach","Niederkassel","Niederkirchen","Niederkirchen bei Deidesheim","Niederkruchten","Niederlangen","Niederlindhart","Niedermurach","Niedernberg","Niederndodeleben","Niederneisen","Niederneuching","Niedernhall","Niedernhausen","Niedernwohren","Niederorschel","Niederpollnitz","Niederquembach","Niederrieden","Niedersachswerfen","Niederschonenfeld","Niederselters","Niederspier","Niederstadtfeld","Niederstaufenbach","Niederstetten","Niederstotzingen","Niederviehbach","Niederwambach","Niederweidbach","Niederwerrn","Niederwiesa","Niederwinkling","Niederwuerschnitz","Niederzeuzheim","Niederzier","Niederzissen","Niefern-Oschelbronn","Nieheim","Niemberg","Niemegk","Nienborstel","Nienburg","Nienburg/Saale","Niendorf","Niendorf","Nienhagen","Nienhagen","Nienstadt","Niepars","Nierstein","Niesgrau","Niesky","Nieste","Nindorf","Nittel","Nittenau","Nittendorf","Nitz","Nobitz","Noda","Nohfelden","Nohra","Nonnenhorn","Nonnweiler","Norddeich","Norden","Nordendorf","Nordenham","Norderney","Norderstapel","Norderstedt","Nordhalben","Nordhastedt","Nordhausen","Nordheim","Nordhofen","Nordholz","Nordholz","Nordhorn","Nordkirchen","Nordrach","Nordstemmen","Nordwalde","Norheim","Norken","Norsingen","Norten-Hardenberg","Northeim","Nortmoor","Nortorf","Nortrup","Norvenich","Nossen","Nottuln","Notzingen","Nubbel","Nudlingen","Nufringen","Numbrecht","Nunchritz","Nuremberg","Nurtingen","Nusplingen","Nussdorf am Inn","Nusse","Nussloch","Ober-Erlenbach","Ober-Hilbersheim","Ober-Morlen","Ober-Olm","Ober-Ramstadt","Ober-Roden","Oberammergau","Oberasbach","Oberau","Oberaudorf","Oberaula","Oberberg","Oberbillig","Oberbodnitz","Oberboihingen","Oberderdingen","Oberdiebach","Oberding","Oberdischingen","Oberdolling","Oberdorla","Oberelbert","Oberelsbach","Oberfell","Obergebra","Obergriesbach","Obergunzburg","Obergurig","Oberhaching","Oberhaid","Oberharmersbach","Oberhausen","Oberhausen","Oberhausen","Oberhausen-Rheinhausen","Oberhermsdorf","Oberhof","Oberhof","Oberhonnefeld-Gierend","Oberhundem","Oberickelsheim","Oberirsen","Oberkail","Oberkammlach","Oberkirch","Oberkirchen","Oberkochen","Oberkotzau","Oberlahr","Oberlaindern","Oberleichtersbach","Oberlungwitz","Obermarchtal","Obermeilingen","Obermeitingen","Obermichelbach","Obermohr","Obermoschel","Obernbreit","Obernburg am Main","Oberndorf","Oberndorf","Oberndorf","Oberndorf","Oberndorf","Oberneukirchen","Oberneuses","Obernfeld","Obernheim-Kirchenarnbach","Obernkirchen","Obernzell","Obernzenn","Oberopfingen","Oberornau","Oberotterbach","Oberottmarshausen","Oberpframmern","Oberpierscheid","Oberpleichfeld","Oberpleis","Oberporing","Oberporlitz","Oberraden","Oberreichenbach","Oberreichenbach","Oberreichenbach","Oberried","Oberrieden","Oberriexingen","Oberrod","Oberrot","Oberschefflenz","Oberscheinfeld","Oberschleissheim","Oberschneiding","Oberschona","Oberschweinbach","Oberseifersdorf","Obersontheim","Oberstadion","Oberstadtfeld","Oberstaufen","Oberstdorf","Oberstenfeld","Oberstreu","Obersuhl","Obertaufkirchen","Oberteuringen","Oberthal","Oberthulba","Obertraubling","Obertrubach","Obertshausen","Oberursel","Oberviechtach","Oberweimar","Oberweis","Oberweissbach","Oberwesel","Oberwiesenthal","Oberwinter","Oberwolfach","Oberzissen","Obing","Obrigheim","Obrigheim","Obristfeld","Ochsenfurt","Ochsenhausen","Ochtendung","Ochtmersleben","Ochtrup","Ockenfels","Odelzhausen","Odendorf","Odenheim","Odenthal","Oderberg","Odernheim","Oebisfelde","Oechsen","Oederan","Oedheim","Oelde","Oelerse","Oelixdorf","Oelsberg","Oelsen","Oelsnitz","Oelsnitz","Oelzschau","Oer-Erkenschwick","Oerlenbach","Oerlinghausen","Oersdorf","Oesterdeichstrich","Oestrich-Winkel","Oettersdorf","Oettingen in Bayern","Oeversee","Offenau","Offenbach","Offenbach an der Queich","Offenbach-Hundheim","Offenberg","Offenburg","Offenhausen","Offingen","Offstein","Ofterdingen","Oftersheim","Oggelshausen","Ohlsbach","Ohlsdorf","Ohlstadt","Ohmden","Ohningen","Ohorn","Ohrdruf","Ohren","Ohrensen","Ohringen","Olbernhau","Olbersdorf","Olbersleben","Olbronn-Durrn","Olching","Oldenburg","Oldenburg","Oldenburg in Holstein","Oldendorf","Oldendorf","Oldendorf","Oldenswort","Oldersum","Olderup","Oldisleben","Olfen","Olpe","Olsberg","Olsbrucken","Olzheim","Opfenbach","Opfingen","Oppach","Oppenau","Oppendorf","Oppenheim","Oppenweiler","Oppurg","Oranienbaum","Oranienburg","Orbis","Oring","Ornbau","Orsingen-Nenzingen","Ortenberg","Ortenberg","Ortenburg","Ortrand","Osann-Monzel","Osburg","Osch","Oschatz","Oschersleben","Oschingen","Osdorf","Osede","Osingen","Osloss","Ostbevern","Ostelsheim","Osten","Ostenfeld","Osterberg","Osterbrock","Osterburg","Osterburken","Ostercappeln","Osterfeld","Osterhausen","Osterhofen","Osterholz-Scharmbeck","Osternienburg","Osterode","Osterode am Harz","Osterrade","Osterronfeld","Osterspai","Osterstedt","Osterwald","Osterwieck","Ostfildern","Ostheim","Osthofen","Ostrach","Ostramondra","Ostrhauderfehn","Ostringen","Ostritz","Ostseebad Ahrenshoop","Ostseebad Baabe","Ostseebad Binz","Ostseebad Boltenhagen","Ostseebad Dierhagen","Ostseebad Gohren","Ostseebad Kuhlungsborn","Ostseebad Nienhagen","Ostseebad Prerow","Ostseebad Sellin","Ostseebad Zinnowitz","Oststeinbek","Othenstorf","Otigheim","Otisheim","Ottenbach","Ottendorf-Okrilla","Ottenhofen","Ottenhofen","Ottensoos","Otter","Otterbach","Otterbach","Otterberg","Otterfing","Otterloh","Otterndorf","Ottersberg","Ottersheim","Otterstadt","Ottersweier","Otterwisch","Ottobeuren","Ottobrunn","Ottrau","Ottweiler","Otze","Otzing","Ovelgoenne","Ovelgonne","Overath","Owen","Owingen","Owschlag","Oy-Mittelberg","Oyten","Padelugge","Padenstedt","Paderborn","Pahl","Painten","Palling","Panschwitz-Kuckau","Pansdorf","Pantelitz","Papenburg","Papendorf","Pappenheim","Paradies","Parchim","Parey","Parkstein","Parkstetten","Parnsberg","Parsau","Parsdorf","Partenheim","Partenstein","Parum","Pasewalk","Passau","Passow","Pastetten","Pattensen","Patzig","Paulinenaue","Paunzhausen","Pausa","Pauscha","Pechbrunn","Peckelsheim","Peetsch","Pegau","Pegnitz","Peine","Peissenberg","Peiting","Peitz","Pellingen","Pellworm","Pelm","Pemfling","Penig","Pentenried","Pentling","Penzberg","Penzing","Perach","Perkam","Perl","Perleberg","Perlesreut","Pesch","Pessenburgheim","Pesterwitz","Petersaurach","Petersberg","Petersberg","Petersberg","Petersdorf","Petersdorf","Petershagen","Petershagen","Petershausen","Petriroda","Petting","Pettstadt","Pewsum","Pfaffen-Schwabenheim","Pfaffenhausen","Pfaffenhausen","Pfaffenhofen","Pfaffenhofen an der Ilm","Pfaffenhofen an der Roth","Pfaffenweiler","Pfaffing","Pfaffroda","Pfalzfeld","Pfalzgrafenweiler","Pfarrkirchen","Pfarrweisach","Pfatter","Pfedelbach","Pfeffelbach","Pfeffenhausen","Pflummern","Pforring","Pforzen","Pforzheim","Pfreimd","Pfronten","Pfullendorf","Pfullingen","Pfungstadt","Philippsburg","Philippsthal","Pickliessem","Piding","Piesport","Pilsach","Pilsting","Pinneberg","Pinnow","Pinnow","Pirk","Pirmasens","Pirna","Pittenhart","Pixel","Plaidt","Plan","Planegg","Plankstadt","Plate","Platkow","Platten","Plattenburg","Plattling","Plau am See","Plaue","Plauen","Plech","Pleckhausen","Pleidelsheim","Plein","Pleinfeld","Pleiskirchen","Pleisweiler-Oberhofen","Pleizenhausen","Plessa","Plettenberg","Pleystein","Pliening","Pliezhausen","Plochingen","Plodda","Ploen","Plossberg","Pluderhausen","Pluwig","Pockau","Pocking","Podeldorf","Poggensee","Pohl","Pohl","Pohnstorf","Poing","Point","Polch","Politz","Pollenfeld","Pollhagen","Polling","Pommelsbrunn","Pommerby","Pomster","Poppenhausen","Poppenhausen","Poppenlauer","Poppenricht","Pornbach","Porta Westfalica","Posing","Possendorf","Possendorf","Possenheim","Possneck","Postbauer-Heng","Postmunster","Potsdam","Pottenstein","Pottmes","Pouch","Poxdorf","Pracht","Prackenbach","Prangendorf","Prebberede","Prebitz","Preetz","Preith","Premnitz","Prenzlau","Pressath","Pressen","Pressig","Prestewitz","Pretzfeld","Preussisch Oldendorf","Prichsenstadt","Prien am Chiemsee","Priesendorf","Priestewitz","Prietitz","Prisdorf","Prittriching","Pritzwalk","Probsteierhagen","Prohn","Proseken","Protzen","Pruchten","Prum","Prumzurlay","Prutting","Puchersreuth","Puchheim","Puderbach","Pulheim","Pullach im Isartal","Pullenreuth","Pullhausen","Puls","Pulsnitz","Purgen","Puschendorf","Putbus","Putlitz","Puttlingen","Putzbrunn","Pyrbaum","Quaal","Quakenbruck","Quarnbek","Quarnstedt","Quedlinburg","Queidersbach","Querfurt","Querum","Quickborn","Quierschied","Quitzow","Raben","Rabenau","Rabenholz","Rabenkirchen-Fauluck","Rabke","Rachelsbach","Rackith","Rackwitz","Radbruch","Radeberg","Radebeul","Radeburg","Radefeld","Radegast","Radevormwald","Radibor","Radolfzell","Raesfeld","Raguhn","Rahden","Raibach","Rain","Raisdorf","Raisting","Ralingen","Rambin","Ramerberg","Rammelsbach","Rammenau","Rammingen","Ramsau","Ramsen","Ramsla","Ramsloh","Ramstein-Miesenbach","Ramsthal","Randersacker","Rangendingen","Rangsdorf","Ranis","Ransbach-Baumbach","Ranstadt","Ransweiler","Rantum","Rantzau","Rappenau","Raschau","Rasdorf","Rasselstein","Rastatt","Rastdorf","Rastede","Rastenberg","Rastow","Ratekau","Rath","Rathenow","Ratingen","Rattelsdorf","Rattenberg","Rattenkirchen","Ratzeburg","Raubach","Raubling","Rauda","Rauen","Rauenberg","Rauenstein","Raunheim","Rauschenberg","Rausdorf","Rausdorf","Ravensburg","Ravenstein","Rechberg","Rechberg","Rechberghausen","Rechenberg-Bienenmuhle","Rechtenbach","Rechtenfleth","Rechtenstein","Rechtmehring","Rechtsupweg","Recke","Recklinghausen","Reddelich","Redefin","Redekin","Rednitzhembach","Redwitz an der Rodach","Rees","Regen","Regensburg","Regenstauf","Regis-Breitingen","Regnitzlosau","Rehau","Rehburg-Loccum","Rehden","Reher","Rehfelde","Rehhorst","Rehling","Rehlingen-Siersburg","Rehna","Reich","Reichardtswerben","Reichartshausen","Reichelsheim","Reichelsheim","Reichenbach","Reichenbach","Reichenbach im Tale","Reichenbach-Steegen","Reichenbach/Vogtland","Reichenschwand","Reichersbeuern","Reichertshausen","Reichertshausen","Reichertshofen","Reilingen","Reimlingen","Reimsbach","Reinbek","Reinfeld","Reinhartshausen","Reinheim","Reinsberg","Reinsdorf","Reinstadt","Reipoltskirchen","Reisbach","Reischach","Reiskirchen","Reit im Winkl","Reithofen","Reitmehring","Reitsch","Rellingen","Remagen","Remels","Remlingen","Remmesweiler","Remptendorf","Remscheid","Renchen","Rendsburg","Rengsdorf","Rennerod","Rennersdorf","Rennertshofen","Renningen","Renquishausen","Rentrisch","Rentweinsdorf","Reppenstedt","Retgendorf","Rethwisch","Rettenberg","Rettersen","Rettert","Rettigheim","Rettin","Retzstadt","Reute","Reuth","Reutlingen","Reutlingendorf","Rhade","Rhadereistedt","Rhaunen","Rheda-Wiedenbruck","Rhede","Rhede","Rheden","Rhein","Rhein","Rheinau","Rheinau","Rheinbach","Rheinberg","Rheinbollen","Rheinbreitbach","Rheinbrohl","Rheine","Rheinfelden","Rheinsberg","Rheinzabern","Rheurdt","Rhinow","Rhumspringe","Ribbeck","Ribbesbuttel","Ribnitz","Ribnitz-Damgarten","Richen","Rickenbach","Rickert","Riding","Riedbach","Riedbach","Riede","Rieden","Rieden","Rieden","Rieden","Riedenberg","Riedenburg","Riedenheim","Rieder","Riederich","Riedering","Riedhausen","Riedlingen","Riedmoos","Riegel","Riegelsberg","Riegsee","Rielasingen-Worblingen","Riemerling","Rieneck","Riepsdorf","Riesa","Rieseby","Rieste","Rietberg","Rietheim","Riethnordhausen","Rietschen","Rimbach","Rimbach","Rimhorn","Rimpar","Rimschweiler","Rimsting","Rinchnach","Ringenwalde","Ringsberg","Ringsheim","Rinteln","Rinzenberg","Riol","Ritschenhausen","Ritterhude","Rittersdorf","Robel","Rochlitz","Rockenberg","Rockenhausen","Rodach","Rodalben","Roden","Rodenbach","Rodenbach","Rodenberg","Rodental","Rodersheim-Gronau","Rodewisch","Rodgau","Rodheim","Roding","Rodinghausen","Roehrnbach","Roes","Roetgen","Roetz","Rofingen","Roggenburg","Roggentin","Rogling","Rohr","Rohr","Rohrbach","Rohrbach","Rohrbach","Rohrdorf","Rohrdorf","Rohrenfels","Rohrmoos","Rohrsdorf","Roigheim","Roklum","Rollbach","Rollshausen","Romhild","Rommerskirchen","Romrod","Romsthal","Rondeshagen","Ronneburg","Ronnenberg","Ronsberg","Rorichum","Rosbach vor der Hohe","Roschbach","Rosdorf","Rosdorf","Roseburg","Rosenburg","Rosendahl","Rosendahl","Rosenfeld","Rosengarten","Rosengarten","Rosengarten","Rosenheim","Rosenkopf","Rosenthal","Rositz","Roslau","Rosrath","Rossau","Rossdorf","Rosshaupten","Rosslau","Rosstal","Rosswein","Rostock","Rot am See","Rotenburg","Rotenburg an der Fulda","Rotenhain","Roth","Rotha","Rothenbach","Rothenbach an der Pegnitz","Rothenbuch","Rothenburg","Rothenburg","Rothenfels","Rothenstein","Rothhausen","Rothlein","Rothof","Rott am Inn","Rottach","Rottach-Egern","Rottenacker","Rottenbach","Rottenbuch","Rottenburg","Rottenburg an der Laaber","Rottendorf","Rottenstuben","Rotterode","Rotthalmunster","Rottingen","Rottleberode","Rottweil","Rovershagen","Roxel","Rubke","Ruchheim","Ruchsen","Ruckeroth","Ruckersdorf","Ruckersdorf","Ruckholz","Rudelzhausen","Ruderatshofen","Rudersberg","Rudersdorf","Rudersdorf","Ruderting","Rudesheim","Rudesheim am Rhein","Rudolstadt","Rugendorf","Rugheim","Rugland","Ruhen","Ruhla","Ruhland","Ruhpolding","Ruhstorf","Ruit","Rullstorf","Rulzheim","Rumeltshausen","Rummer","Rummingen","Rumohr","Runding","Runkel","Runthe","Ruppach-Goldhausen","Ruppertsberg","Ruppertshofen","Ruppertsweiler","Ruppichteroth","Ruschberg","Ruscheid","Ruspel","Rust","Rutesheim","Ruthen","Ruthnick","Rutsweiler an der Lauter","Saal","Saal","Saaldorf","Saalfeld","Saalstadt","Saara","Saarburg","Saarlouis","Saarwellingen","Sachsen","Sachsenhagen","Sachsenheim","Sachsenkam","Sack","Saerbeck","Saffig","Sagard","Sailauf","Saint Egidien","Saint Michaelisdonn","Salach","Salching","Saldenburg","Salem","Salgen","Salm","Salmtal","Salz","Salzbergen","Salzburg","Salzgitter","Salzgitter-Bad","Salzhausen","Salzhemmendorf","Salzkotten","Salzstetten","Salzwedel","Salzweg","Samerberg","Samern","Samswegen","Samtens","Sand","Sandberg","Sandbostel","Sande","Sandersdorf","Sandersleben","Sandesneben","Sandhausen","Sandkrug","Sangerhausen","Sankt Andreasberg","Sankt Augustin","Sankt Englmar","Sankt Georgen im Schwarzwald","Sankt Ingbert","Sankt Katharinen","Sankt Leon-Rot","Sankt Peter-Ording","Sankt Wendel","Sankt Wolfgang","Sanssouci","Sargenroth","Sarkwitz","Sarlhusen","Sarstedt","Sasbach","Sasbach","Sasbachwalden","Sassenberg","Sassenburg","Sassnitz","Satjendorf","Satrup","Satteldorf","Sattelstadt","Satzvey","Sauensiek","Sauerlach","Sauldorf","Saulgau","Schaafheim","Schaalby","Schacht-Audorf","Schackendorf","Schacksdorf","Schadeleben","Schafflund","Schafstedt","Schalkau","Schalksmuhle","Schallstadt","Schammelsdorf","Scharbeutz","Scharnebeck","Scharnhorst","Scharrel","Schauenstein","Schauerberg","Schaulings","Schaumburg","Schechen","Schechingen","Scheden","Scheer","Scheessel","Scheidegg","Scheinfeld","Schelklingen","Schellerten","Schellhorn","Schellweiler","Schenefeld","Schenefeld","Schenefeld","Schenkenhorst","Schenkenzell","Schenklengsfeld","Scherenbostel","Schermbeck","Schermen","Scherstetten","Schesslitz","Scheuerfeld","Scheuerhalden","Scheuring","Scheyern","Schieder-Schwalenberg","Schierling","Schiffdorf","Schifferstadt","Schiffweiler","Schildau","Schildow","Schillingsfurst","Schillingshof","Schiltach","Schiltberg","Schindhard","Schiphorst","Schirgiswalde","Schirmitz","Schirnding","Schkeuditz","Schkolen","Schkopau","Schladen","Schlaitdorf","Schlammersdorf","Schlangen","Schlangenbad","Schlanstedt","Schlat","Schleching","Schlegel","Schlehdorf","Schleid","Schleid","Schleiden","Schleife","Schleiz","Schlema","Schlepzig","Schleswig","Schlettau","Schleusingen","Schlieben","Schliengen","Schlier","Schlierbach","Schliersee","Schlitz","Schloss","Schloss Holte-Stukenbrock","Schlossberg","Schlotfeld","Schlotheim","Schluchsee","Schluchtern","Schlusselfeld","Schmalenberg","Schmalensee","Schmalkalden","Schmallenberg","Schmelz","Schmerz","Schmidgaden","Schmidmuhlen","Schmidt","Schmidthachenbach","Schmiechen","Schmiechen","Schmiedefeld am Rennsteig","Schmilau","Schmitten","Schmittweiler","Schmolln","Schnabelwaid","Schnackenburg","Schnaitsee","Schnaittach","Schnaittenbach","Schneckenhausen","Schnee","Schneeberg","Schneeberg","Schnega","Schneizlreuth","Schnellbach","Schnelldorf","Schnellmannshausen","Schneppenbach","Schneverdingen","Schney","Schnurpflingen","Schoeffengrund","Schoenberg","Schoenheide","Schollbrunn","Schollene","Schollkrippen","Schollnach","Schomberg","Schomberg","Schonach im Schwarzwald","Schonaich","Schonau","Schonau","Schonau im Schwarzwald","Schonberg","Schonberg","Schonberg","Schonberg","Schonborn","Schonbrunn","Schondorf am Ammersee","Schondra","Schonebeck","Schoneberg","Schoneck","Schonecken","Schonefeld","Schoneiche","Schonenberg","Schonenberg-Kubelberg","Schonewalde","Schoneworde","Schonfeld","Schonfliess","Schongau","Schongeising","Schoningen","Schonkirchen","Schonsee","Schonstett","Schonthal","Schonungen","Schonwald","Schonwald im Schwarzwald","Schonwalde","Schonwalde","Schopfheim","Schopfloch","Schopfloch","Schoppenstedt","Schoppingen","Schopsdorf","Schorndorf","Schornsheim","Schortens","Schossin","Schotten","Schramberg","Schriesheim","Schrobenhausen","Schrozberg","Schuby","Schuld","Schulendorf","Schulldorf","Schuller","Schulzendorf","Schuttertal","Schutterwald","Schuttorf","Schutz","Schutzbach","Schutzenhof","Schwaan","Schwabach","Schwaben","Schwabenheim","Schwabhausen","Schwabhausen","Schwabmunchen","Schwabniederhofen","Schwabstedt","Schwaibach","Schwaig","Schwaig","Schwaigern","Schwaikheim","Schwalbach","Schwalbach am Taunus","Schwalingen","Schwallungen","Schwalmstadt","Schwalmtal","Schwalmtal","Schwandorf in Bayern","Schwanebeck","Schwaneberg","Schwanewede","Schwanfeld","Schwangau","Schwansee","Schwarme","Schwarmstedt","Schwarz","Schwarzach","Schwarzach","Schwarzbach","Schwarzenbach","Schwarzenbach am Wald","Schwarzenbach an der Saale","Schwarzenbek","Schwarzenberg","Schwarzenborn","Schwarzenbruck","Schwarzenfeld","Schwarzhausen","Schwarzheide","Schwarzholz","Schwarzwald","Schwebheim","Schwedelbach","Schwedt (Oder)","Schwegenheim","Schweiburg","Schweich","Schweigen-Rechtenbach","Schweinfurt","Schweitenkirchen","Schweizerhof","Schwelm","Schwendi","Schwenningen","Schwerin","Schweringen","Schwerstedt","Schwerte","Schwesing","Schwetzingen","Schwieberdingen","Schwienau","Schwifting","Schwindegg","Schwirzheim","Schwollen","Schworstadt","Sebnitz","Seck","Seckach","Seebach","Seebad Ahlbeck","Seebad Bansin","Seebad Heringsdorf","Seebergen","Seebruck","Seeburg","Seeburg","Seedorf","Seefeld","Seefeld","Seefeld","Seeg","Seega","Seehaus","Seehausen","Seeheilbad Graal-Muritz","Seeheim-Jugenheim","Seehof","Seehof","Seeland","Seelbach","Seelitz","Seelow","Seelscheid","Seelze","Seeon-Seebruck","Seesbach","Seesen","Seeshaupt","Seester","Seevetal","Seffern","Sefferweich","Sehlde","Sehlem","Sehlen","Sehma","Sehnde","Seifhennersdorf","Selb","Selbach","Selbitz","Selent","Seligenstadt","Seligenstadt","Seligenthal","Sellerich","Sellin","Selm","Selmsdorf","Selsingen","Selters","Selters","Selzen","Sembach","Senden","Senden","Sendenhorst","Senftenberg","Sengenthal","Sennfeld","Sensweiler","Senzig","Sereetz","Serrig","Sersheim","Sesslach","Seth","Seubersdorf","Seukendorf","Sexau","Sibbesse","Sickte","Siebenbaumen","Siedenbrunzow","Siedenburg","Siegburg","Siegelsbach","Siegen","Siegenburg","Siegsdorf","Sielenbach","Sierksdorf","Siershahn","Siesbach","Sievershutten","Sieverstedt","Sigmaringen","Sigmaringendorf","Sigmarszell","Silling","Simbach","Simbach am Inn","Simmelsdorf","Simmerath","Simmern","Simmersfeld","Simmertal","Simonsberg","Sindelfingen","Sindorf","Sindringen","Singen","Singenbach","Singhofen","Sinn","Sinsheim","Sinzheim","Sinzig","Sinzing","Sippersfeld","Sipplingen","Sittensen","Sochtenau","Soemmerda","Soest","Sogel","Sohland","Sohlde","Sohren","Solden","Solingen","Solkwitz","Soller","Sollerup","Sollstedt","Solms","Soltau","Soltendieck","Somborn","Sommerland","Sommerloch","Sondershausen","Sondheim","Sonneberg","Sonnefeld","Sonnschied","Sonsbeck","Sontheim","Sontheim an der Brenz","Sonthofen","Sontra","Sorth","Sorup","Sosa","Sotterhausen","Sottrum","Soyen","Spaichingen","Spalt","Spangdahlem","Spangenberg","Spardorf","Spatzenhausen","Spay","Spechtsbrunn","Spechtshausen","Speicher","Speichersdorf","Speinshart","Spelle","Spenge","Spessart","Spetzerfehn","Speyer","Spiegelau","Spiegelberg","Spiegelsberge","Spielberg","Spiesen-Elversberg","Spitzkunnersdorf","Splietsdorf","Sponheim","Spora","Spornitz","Spraitbach","Spree","Spreenhagen","Spremberg","Spremberg","Sprendlingen","Sprengel","Springe","Springstille","Sprockhovel","Stabelow","Stade","Stadecken-Elsheim","Stadelhofen","Stadt","Stadt Wehlen","Stadtallendorf","Stadtbergen","Stadthagen","Stadtilm","Stadtkyll","Stadtlauringen","Stadtlohn","Stadtoldendorf","Stadtprozelten","Stadtroda","Stadtsteinach","Stahl","Stahlhofen","Stahnsdorf","Staig","Stammbach","Stammheim","Stamsried","Stangerode","Stapelburg","Stapelfeld","Starnberg","Stassfurt","Stauchitz","Staudt","Staufen im Breisgau","Staufenberg","Stegaurach","Stegen","Steglitz Bezirk","Steigra","Steimbke","Steimel","Stein","Stein an der Traun","Stein-Neukirch","Steinach","Steinach","Steinau an der Strasse","Steinbach am Taunus","Steinburg","Steineberg","Steinegg","Steinen","Steinen","Steinenbronn","Steineroth","Steinfeld","Steinfeld","Steinfurt","Steingaden","Steinhagen","Steinhagen","Steinhausen","Steinheim","Steinheim am Albuch","Steinheim am der Murr","Steinhoring","Steinhorst","Steinigtwolmsdorf","Steinlah","Steinmauern","Steintoch","Steinweiler","Steinweiler","Steinwenden","Steinwiesen","Steisslingen","Stelle","Stellshagen","Stelzenberg","Stendal","Stepfershausen","Stephanskirchen","Sterbfritz","Sternberg","Sternberg","Sternenfels","Sterup","Sterzhausen","Stetten","Stetten","Stettfeld","Steuden","Steudnitz","Steyerberg","Stiege","Stimpfach","Stinstedt","Stockach","Stockelsdorf","Stockhausen","Stockhausen-Illfurth","Stockheim","Stockheim","Stockse","Stocksee","Stockstadt am Main","Stockstadt am Rhein","Stoetze","Stolberg","Stolk","Stollberg","Stolpen","Stolzenau","Stolzenhagen","Storkow","Stornstein","Stotten","Stotternheim","Stottwang","Straelen","Strahlungen","Stralsund","Strande","Strassberg","Strasskirchen","Strasslach-Dingharting","Straubing","Straupitz","Strausberg","Straussfurt","Streich","Streithausen","Strickscheid","Strohkirchen","Strohn","Stromberg","Stromberg","Strucklingen","Strullendorf","Struxdorf","Stubenberg","Stuhlingen","Stuhr","Stukenbrock","Stulln","Stuttgart","Stutzengrun","Stutzerbach","Styrum","Suckow","Suddendorf","Suderau","Suderbrarup","Suderburg","Suderholz","Suderlugum","Suderstapel","Sudheide","Sudlohn","Sugenheim","Suhl","Suhlendorf","Sulfeld","Sulingen","Sulz am Neckar","Sulzbach","Sulzbach","Sulzbach","Sulzbach am Main","Sulzbach-Rosenberg","Sulzberg","Sulzemoos","Sulzfeld","Sulzfeld","Sulzgries","Sulzheim","Sulzheim","Sulzthal","Sunching","Sundern","Sundhausen","Supplingen","Surheim","Susel","Sussen","Syke","Syrau","Taarstedt","Tabarz","Tacherting","Taching am See","Tailfingen","Talheim","Talkau","Tamm","Tangendorf","Tangerhutte","Tangermunde","Tangstedt","Tangstedt","Tann","Tann","Tanna","Tannesberg","Tannhausen","Tantow","Tapfheim","Tappenbeck","Tarbek","Tarmow","Tarmstedt","Tarp","Tating","Tauberbischofsheim","Tauberfeld","Tauberrettersheim","Taucha","Tauche","Taufkirchen","Taufkirchen","Taunusstein","Taura","Tawern","Tecklenburg","Tegernheim","Tegernsee","Teichwolframsdorf","Teisendorf","Teising","Teisnach","Teistungenburg","Telgte","Tellingstedt","Teltow","Temmels","Templin","Tengen","Teningen","Tennenbronn","Terborg","Teschow","Tespe","Tessin","Tetenbull","Tetenhusen","Teterow","Tettau","Tettau","Tettenwang","Tettnang Castle","Teublitz","Teuchern","Teugn","Teuschnitz","Teutschenthal","Thaden","Thale","Thaleischweiler-Froschen","Thalfang","Thalhausen","Thalheim","Thalheim","Thallichtenberg","Thallwitz","Thalmassing","Thalmassing","Thalwenden","Thannberg","Thannhausen","Tharandt","Thedinghausen","Theilenhofen","Theilheim","Theissen","Theley","Themar","Thermalbad Wiesenbad","Thiendorf","Thierhaupten","Thierstein","Tholey","Thoma","Thomasburg","Thomm","Thuine","Thulba","Thum","Thungen","Thungersheim","Thur","Thurkow","Thurnau","Thyrnau","Thyrow","Tiddische","Tiefenbach","Tiefenbach","Tiefenbronn","Tiefenort","Tiefenthal","Tieplitz","Tieringen","Tilleda","Timmaspe","Timmendorf","Timmendorf Beach","Timmenrode","Tinnum","Tirschenreuth","Titisee-Neustadt","Titting","Tittling","Tittmoning","Titz","Tobertitz","Todenbuttel","Todendorf","Todesfelde","Todtenried","Todtenweis","Todtmoos","Todtnau","Todtnauberg","Toging am Inn","Tomerdingen","Tonbach","Tonisvorst","Tonndorf","Tonning","Topen","Toppenstedt","Torgau","Torgelow","Tornesch","Tostedt","Traben-Trarbach","Trabitz","Traisen","Traitsching","Trappenkamp","Trassem","Traubing","Traunreut","Traunstein","Traunwalchen","Trautskirchen","Trebbin","Treben","Trebendorf","Trebsen","Trebur","Treffelhausen","Treffelstein","Treia","Treis-Karden","Tremsbuttel","Trendelburg","Trent","Treuchtlingen","Treudelberg","Treuen","Treuenbrietzen","Triberg im Schwarzwald","Trier","Trierweiler","Triftern","Trimbs","Trippstadt","Triptis","Trittau","Trochtelfingen","Trogen","Troisdorf","Trollenhagen","Trossingen","Trostau","Trostberg an der Alz","Truchtlaching","Trulben","Trunkelsberg","Trusetal","Tschernitz","Tuerkenfeld","Tulau","Tuningen","Tuntenhausen","Turkheim","Tussenhausen","Tuszshing","Tutow","Tuttlingen","Tutzing","Tutzpatz","Twielenfleth","Twist","Twiste","Twistringen","Ubach-Palenberg","Uberfeld","Uberherrn","Uberlingen","Ubersee","Ubstadt-Weiher","Uchte","Uchtelhausen","Uckendorf","Udenheim","Uder","Uebigau","Ueckermunde","Uedem","Uehlfeld","Uelitz","Uelsen","Uelvesbull","Uelzen","Uersfeld","Uess","Ueterlande","Uetersen","Uettingen","Uetze","Uffenheim","Uffing","Uhingen","Uhldingen-Muhlhofen","Uhler","Uhlingen-Birkendorf","Ulbersdorf","Ulm","Ulmen","Ulmet","Ulrichstein","Ulsnis","Umkirch","Ummendorf","Umpfenbach","Unkel","Unlingen","Unna","Unnau","Unterammergau","Unterbaldingen","Unterdiessen","Unterdietfurt","Untereglfing","Untereisesheim","Unterensingen","Untereuerheim","Unterfoehring","Untergimpern","Untergriesbach","Untergruppenbach","Unterhaching","Unterhausen","Unterkirnach","Unterliezheim","Unterluss","Untermeitingen","Untermunkheim","Unterneukirchen","Unterpleichfeld","Unterreichenbach","Unterreit","Unterroth","Unterschleichach","Unterschleissheim","Unterschneidheim","Untersiemau","Untersteinach","Unterthingau","Unteruhldingen","Unterwellenborn","Unterwossen","Untrasried","Upgant-Schott","Urbach","Urbach","Urbar","Urexweiler","Urmitz","Ursensollen","Urspringen","Urweiler","Urzig","Usedom","Usingen","Uslar","Ustersbach","Uttenreuth","Uttenweiler","Utting","Utzenfeld","Uxheim","Vacha","Vachendorf","Vahlbruch","Vahldorf","Vaihingen an der Enz","Vallendar","Valley","Varel","Vastorf","Vaterstetten","Vechelde","Vechta","Veckenstedt","Vegesack","Vehlow","Veilsdorf","Veitsbronn","Veitshochheim","Velbert","Velburg","Velden","Veldenz","Velen","Vellahn","Vellberg","Vellmar","Velpke","Velten","Veltheim","Veltheim","Vendersheim","Venne","Verchen","Verden an der Aller","Veringendorf","Veringenstadt","Verl","Versmold","Vesser","Vestenberg","Vestenbergsgreuth","Vetschau","Vettelschoss","Vettweiss","Viecheln","Viechtach","Vielbach","Vienenburg","Vier","Vierden","Viereth-Trunstadt","Vierhofen","Vierkirchen","Viernau","Viernheim","Viersen","Vieselbach","Vietgest","Villenbach","Villingen","Villingen-Schwenningen","Villingendorf","Villmar","Vilsbiburg","Vilseck","Vilsheim","Vilshofen","Vilshoven","Visbek","Visselhovede","Vitte","Vlotho","Vluyn","Voerde","Vogelsdorf","Vogelsen","Vogt","Vogtareuth","Vogtsburg","Vohburg an der Donau","Vohenstrauss","Vohl","Vohrenbach","Vohringen","Vohringen","Volkach","Volkenschwand","Volkenshagen","Volkersweiler","Volkertshausen","Volklingen","Volkmarsen","Vollersode","Vollersroda","Vollkofen","Vollrathsruhe","Voltlage","Volxheim","Vorbach","Vorbach","Vorden","Vordorf","Vorland","Vorra","Vorstetten","Vorwerk","Voslapp","Vreden","Waakirchen","Waal","Wabern","Wachau","Wachenheim an der Weinstrasse","Wachenroth","Wachsenburg","Wachtberg","Wachtendonk","Wachtersbach","Wachtum","Wacken","Wackernheim","Wackerow","Wackersdorf","Wadelsdorf","Wadern","Wadersloh","Wadgassen","Waffenbrunn","Wagenfeld","Wagenhoff","Wagersrott","Waghausel","Waging am See","Wahlstedt","Wahnwegen","Wahrenholz","Waiblingen","Waibstadt","Waidhaus","Wain","Waischenfeld","Wakendorf","Walchum","Wald","Wald","Wald-Michelbach","Waldalgesheim","Waldaschaff","Waldau","Waldbockelheim","Waldbreitbach","Waldbrol","Waldbrunn","Waldburg","Waldbuttelbrunn","Waldeck","Waldems","Waldenbuch","Waldenburg","Waldenburg","Walderbach","Waldershof","Waldesch","Waldfeucht","Waldfischbach-Burgalben","Waldhambach","Waldheim","Waldkappel","Waldkirch","Waldkirchen","Waldkraiburg","Waldlaubersheim","Waldmohr","Waldmunchen","Waldorf","Waldsassen","Waldschlosschen","Waldsee","Waldshut","Waldshut-Tiengen","Waldsieversdorf","Waldstetten","Walhausen","Walheim","Walkenried","Wall","Walldorf","Walldorf","Walldurn","Walle","Wallendorf","Wallenfels","Wallenhorst","Wallerfangen","Wallersdorf","Wallerstein","Wallertheim","Walleshausen","Wallhausen","Wallhausen","Wallhausen","Wallmerod","Walluf","Walpertshofen","Walpertskirchen","Walsdorf","Walshausen","Walsleben","Walsrode","Waltenhofen","Waltersdorf","Waltershausen","Walting","Waltrop","Wandlitz","Wanfried","Wang","Wangen","Wangen","Wangen im Allgau","Wangerooge","Wankendorf","Wanna","Wanne-Eickel","Wannweil","Wansleben","Wanzleben","Warberg","Warburg","Wardenburg","Wardow","Waren","Warendorf","Warin","Warmensteinach","Warmsen","Warnau","Warngau","Warnow","Warrenzin","Warstein","Wartenberg","Wartenberg-Rohrbach","Warthausen","Warza","Wasbek","Wasbuttel","Waschenbach","Waschenbeuren","Wasenweiler","Wassenach","Wassenberg","Wasser","Wasser","Wasserburg am Inn","Wasserleben","Wasserliesch","Wasserlosen","Wassermungenau","Wassersleben","Wassertrudingen","Wasungen","Wathlingen","Wattenbek","Wattenheim","Wattmannshagen","Watzenborn","Waxweiler","Wechingen","Wechmar","Wechselburg","Weddel","Weddelbrook","Weddingstedt","Wedel","Wedringen","Weede","Weener","Weenzen","Wees","Weeze","Wefensleben","Weferlingen","Wegberg","Wegeleben","Wegscheid","Wehingen","Wehlheiden","Wehnrath","Wehr","Wehrbleck","Wehrheim","Weiberg","Weibern","Weibersbrunn","Weichering","Weichs","Weida","Weiden","Weiden","Weiden","Weiden","Weidenbach","Weidenberg","Weidenhahn","Weidenhof","Weidenthal","Weidhausen","Weiding","Weigendorf","Weihenzell","Weiherhammer","Weihmichl","Weikersheim","Weil","Weil am Rhein","Weil der Stadt","Weil im Schonbuch","Weilar","Weilbach","Weilbach","Weilburg","Weiler","Weiler-Simmerberg","Weilerbach","Weilersbach","Weilerswist","Weilheim","Weilheim","Weilheim an der Teck","Weilmunster","Weiltingen","Weimar","Weimar","Weinahr","Weinbach","Weinbohla","Weingarten","Weingarten","Weinheim","Weinsberg","Weinsfeld","Weinsheim","Weinstadt-Endersbach","Weischlitz","Weisel","Weisen","Weisenbach","Weisendorf","Weisenheim am Berg","Weisenheim am Sand","Weiskirchen","Weismain","Weissach","Weissandt-Golzau","Weissbach","Weissdorf","Weissen","Weissenborn","Weissenbrunn","Weissenburg","Weissenfeld","Weissenfels","Weissenhorn","Weissenohe","Weissensee","Weissenstadt","Weissenthurm","Weisswasser","Weisweil","Weitefeld","Weitenhagen","Weitersborn","Weitersburg","Weiterstadt","Weitersweiler","Weitnau","Weitramsdorf","Weitzschen","Weixerau","Welbsleben","Welden","Welden","Welgesheim","Welkenbach","Welle","Wellheim","Welschbillig","Welshofen","Welsleben","Welterod","Welver","Welzheim","Welzow","Wemding","Wenddorf","Wendeburg","Wendelstein","Wenden","Wendhausen","Wendisch Evern","Wendisch Rietz","Wendlingen am Neckar","Wendtorf","Wengelsdorf","Wennigsen","Wentorf","Wentorf bei Hamburg","Wenzenbach","Wenzendorf","Wenzingen","Wenzlow","Werben","Werda","Werdau","Werder","Werdohl","Werl","Werlaburgdorf","Werlau","Werlte","Wermelskirchen","Wermsdorf","Wernau","Wernberg-Koblitz","Werne","Werneck","Wernersberg","Werneuchen","Wernigerode","Werningshausen","Wernrode","Werpeloh","Werste","Wertach","Wertheim am Main","Werther","Wertingen","Wesel","Weselberg","Wesenberg","Wesendorf","Wesselburen","Wesseling","Wesseln","Wessiszell","Wessling","Wessobrunn Abbey","Weste","Westendorf","Westensee","Wester-Ohrstedt","Westerburg","Westerdeichstrich","Westeregeln","Westergellersen","Westerheim","Westerheim","Westerholt","Westerhorn","Westerkappeln","Westerland","Westerronfeld","Westerstede","Westerstetten","Westfeld","Westhausen","Westhausen","Westheim","Westheim","Westhofen","Westkirchen","Westrhauderfehn","Wetschen","Wettelsheim","Wettenberg","Wetter","Wetter (Ruhr)","Wetterzeube","Wettin","Wettringen","Wettstetten","Wetzlar","Weyarn","Weyerbusch","Weyhausen","Weyhe","Wichte","Wickede","Wicklesgreuth","Wiebelsheim","Wiedemar","Wiederau","Wiedergeltingen","Wiefelstede","Wiehe","Wiehl","Wiek","Wielenbach","Wienhausen","Wienrode","Wiernsheim","Wiesau","Wiesbach","Wiesbach","Wiesbaden","Wieseck","Wieselbach","Wiesenbach","Wiesenbach","Wiesenburg","Wiesenfeld","Wiesenfelden","Wiesensteig","Wiesent","Wiesentheid","Wieske","Wiesloch","Wiesmoor","Wiesthal","Wietmarschen","Wietze","Wietzen","Wietzendorf","Wiggensbach","Wilburgstetten","Wildau","Wildberg","Wildbergerhutte","Wildenberg","Wildenfels","Wildeshausen","Wildpoldsried","Wilferdingen","Wilgartswiesen","Wilhelm","Wilhelmsburg","Wilhelmsdorf","Wilhelmsdorf","Wilhelmsdorf","Wilhelmsfeld","Wilhelmshaven","Wilhelmsheim","Wilhelmsthal","Wilhelmsthal","Wilhermsdorf","Wilkau-Hasslau","Willebadessen","Willensen","Willich","Willingen","Willmars","Willmenrod","Willmersdorf","Willroth","Willstatt","Wilnsdorf","Wilsdruff","Wilstedt","Wilster","Wilsum","Wilthen","Wiltingen","Wimmelburg","Wimsheim","Wincheringen","Windach","Windberg","Windeby","Windehausen","Winden","Winden","Windesheim","Windhagen","Windischeschenbach","Windischleuba","Windorf","Windsbach","Wingst","Winhoring","Winkelhaid","Winkelhaid","Winkwitz","Winnen","Winnenden","Winnigstedt","Winningen","Winnweiler","Winsen","Winsen","Winsen","Winterbach","Winterbach","Winterberg","Winterhausen","Winterlingen","Winterrieden","Wintersdorf","Wintrich","Winzeln","Winzer","Wipfeld","Wippershain","Wirdum","Wirges","Wirsberg","Wisch","Wischhafen","Wismar","Wisper","Wissen","Wistedt","Wittdun","Wittekindshof","Wittelshofen","Witten","Wittenbeck","Wittenberg","Wittenberg","Wittenberge","Wittenborn","Wittenburg","Wittenforden","Wittgendorf","Wittgensdorf","Wittgert","Wittichenau","Wittighausen","Wittingen","Wittislingen","Wittlich","Wittmund","Wittnau","Wittorf","Wittstock","Witzenhausen","Witzhave","Witzin","Witzwort","Woffleben","Wohlsborn","Wohltorf","Wohnbach","Wohnrod","Wohra","Wohrden","Woldegk","Woldert","Wolfach","Wolfegg","Wolfen","Wolferlingen","Wolferode","Wolfersdorf","Wolfersheim","Wolfgang","Wolfhagen","Wolfis","Wolfmannshausen","Wolframs-Eschenbach","Wolfratshausen","Wolfsburg","Wolfschlugen","Wolfsegg","Wolfsheim","Wolgast","Wolkenstein","Wollbrandshausen","Wollstein","Wolmirstedt","Wolnzach","Wolpertshausen","Wolpertswende","Wolpinghausen","Wolsdorf","Wolsendorf","Wolsfeld","Woltersdorf","Woltersdorf","Woltersdorf","Woltershausen","Woltingerode","Womrath","Wonfurt","Wonsees","Worbis","Worfelden","Worms","Wormstedt","Worpswede","Worrstadt","Worth","Worth am Main","Worth am Rhein","Worthsee","Wotersen","Wredenhagen","Wremen","Wrestedt","Wriedel","Wriezen","Wrist","Wrixum","Wuelfrath","Wulfen","Wulfen","Wulften","Wumbach","Wundersleben","Wunnenberg","Wunsiedel","Wunstorf","Wuppertal","Wurmannsquick","Wurmberg","Wurmlingen","Wurmsham","Wurselen","Wurzbach","Wurzburg","Wurzen","Wustenriet","Wustenrot","Wusterhausen","Wusterhusen","Wustermark","Wusterwitz","Wustheuterode","Wustweiler","Wutoschingen","Wyhl","Wyk auf Fohr","Xanten","Zaberfeld","Zahna","Zainingen","Zaisenhausen","Zaisertshofen","Zapel","Zapfendorf","Zarpen","Zarrendorf","Zarrentin","Zaulsdorf","Zechlin Dorf","Zehdenick","Zeil","Zeiskam","Zeithain","Zeitlofs","Zeitz","Zell","Zell","Zell","Zell am Harmersbach","Zell am Main","Zell im Wiesental","Zell unter Aichelberg","Zella-Mehlis","Zellingen","Zeltingen-Rachtig","Zemmer","Zempin","Zeppernick","Zerben","Zerbst","Zerf","Zernien","Zerre","Zerrenthin","Zetel","Zeulenroda","Zeuthen","Zeven","Ziegendorf","Zielitz","Ziemetshausen","Zierenberg","Ziesar","Ziesendorf","Ziltendorf","Zimmern","Zimmern","Zimmern ob Rottweil","Zingst","Zipplingen","Zirkow","Zirndorf","Zittau","Zolling","Zollstock","Zorbig","Zorge","Zorneding","Zornheim","Zoschingen","Zossen","Zottelstedt","Zschopau","Zschorlau","Zschornewitz","Zschortau","Zuchering","Zuffenhausen","Zuhlsdorf","Zulpich","Zusamaltheim","Zusmarshausen","Zussow","Zuzenhausen","Zweiflingen","Zwenkau","Zwesten","Zwickau","Zwiefalten","Zwiesel","Zwingenberg","Zwingenberg","Zwonitz"],"Ghana":["Accra","Bawku","Berekum","Bolgatanga","Cape Coast","Home","Koforidua","Kumasi","Legon","Mampong","Navrongo","Sunyani","Takoradi","Tema","Wa","Winneba"],"Greece":["Aegina","Agioi Anargyroi","Agios Nikolaos","Agrinio","Aigaleo","Aigio","Alexandreia","Alexandroupoli","Aliartos","Alimos","Amaliada","Anavyssos","Andravida","Ano Liosia","Archaia Nemea","Argos","Argostoli","Argyroupoli","Arta","Aspropyrgos","Athens","Attica","Ayios Stefanos","Chalcis","Chania","Chania","Chios","Cholargos","Corfu","Corinth","Dafni","Dionysos","Drama","Ekali","Elassona","Elefsina","Elliniko","Eretria","Farsala","Filippiada","Filothei","Florina","Galatsi","Giannitsa","Glyfada","Gonnoi","Goumenissa","Heraklion","Hydra","Ialysos","Ierapetra","Igoumenitsa","Ioannina","Kaisariani","Kalamaria","Kalamata","Kalamos","Kallithea","Kalymnos","Kamatero","Karditsa","Kassiopi","Kastoria","Katerini","Kavala","Keratea","Keratsini","Kifissia","Kilkis","Komotini","Koropi","Kos","Kouvaras","Kozani","Kranidi","Kryonerion","Kymi","Lamia","Larisa","Lefkada","Lefkimmi","Leontario","Litochoro","Lixouri","Loutraki","Lykovrysi","Magoula","Makrygialos","Mandra","Marathon","Markopoulo Mesogaias","Megalochari","Megara","Melissia","Mesagros","Messolonghi","Metaxades","Moires","Mytilene","Nafpaktos","Nafplion","Naousa","Naxos","Nea Alikarnassos","Nea Filadelfeia","Nea Ionia","Nea Kios","Nea Makri","Nea Peramos","Nea Smyrni","Nikaia","Orestiada","Ormylia","Oropos","Paiania","Pallini","Paloukia","Panorama","Parga","Patmos","Pefki","Pella","Perama","Peristeri","Peristeri","Pikermi","Piraeus","Platy","Polichni","Porto Rafti","Preveza","Psychiko","Ptolemaida","Pylaia","Pyrgos","Rafina","Rethymno","Rhodes","Rio","Salamina","Samothraki","Serres","Servia","Sindos","Skala","Skala Oropou","Skiathos","Sparta","Spata","Symi","Tavros","Thebes","Thermi","Thessaloniki","Tinos","Trikala","Tripoli","Vari","Varkiza","Vergina","Veroia","Volos","Voula","Vouliagmeni","Xanthi","Xylokastro","Zakynthos"],"Greenland":["Aasiaat","Ilulissat","Kapisillit","Maniitsoq","Narsaq","Narsarsuaq","Nuuk","Nuussuaq","Paamiut","Qaqortoq","Qasigiannguit","Qeqertarsuaq","Qeqertat","Sisimiut","Tasiilaq","Upernavik","Uummannaq Kommune"],"Guadeloupe":["Anse-Bertrand","Baie Mahault","Baie-Mahault","Baillif","Basse-Terre","Capesterre-Belle-Eau","Capesterre-de-Marie-Galante","Deshaies","Gourbeyre","Goyave","Grand-Bourg","Lamentin","Le Gosier","Le Moule","Les Abymes","Petit-Bourg","Petit-Canal","Pointe-Noire","Port-Louis","Saint-Claude","Saint-Francois","Saint-Louis","Sainte-Anne","Sainte-Rose","Terre-de-Bas","Terre-de-Haut","Trois-Rivieres","Village"],"Guam":["Barrigada Village","Dededo Village","Inarajan Village","Santa Rita","Tamuning-Tumon-Harmon Village","Yigo Village"],"Guatemala":["Antigua Guatemala","Cambote","Catarina","Central","Chimaltenango","Chiquimula","Ciudad Vieja","Coban","El Limon","El Naranjo","El Salvador","Escuintla","Esquipulas","Flores","Guatemala City","Huehuetenango","Jocotenango","La Reforma","La Reforma","Mazatenango","Melchor de Mencos","Mixco","Palin","Panajachel","Petapa","Puerto Barrios","Quesada","Quetzaltenango","Retalhuleu","San Antonio Miramar","San Jose Pinula","San Juan","San Marcos","San Pedro Sacatepequez","Santa Catarina Pinula","Santa Cruz La Laguna","Santa Cruz Naranjo","Santa Lucia Cotzumalguapa","Santa Rosa","Solola","Villa Nueva","Vista Hermosa","Zacapa"],"Guinea":["Conakry","Dabola","Kalia","Kankan","Lola","Mamou","Port Kamsar","Sangaredi"],"Haiti":["Carrefour","Delmar","Duverger","Jacmel","Masseau","Moise","Petionville","Port-au-Prince","Prince","Turgeau"],"Hashemite Kingdom of Jordan":["Amman","Ar Ramtha","Farah","Irbid","Madaba","Sahab","Salt"],"Honduras":["Choloma","Comayagua","Comayaguela","Coxen Hole","El Barro","El Paraiso","El Progreso","La Ceiba","La Hacienda","Morazan","Nacaome","Pinalejo","Piraera","Puerto Lempira","San Antonio de Flores","San Pedro Sula","Santa Barbara","Sula","Tegucigalpa"],"Hong Kong":["Aberdeen","Causeway Bay","Central District","Cha Kwo Ling","Chai Wan Kok","Chek Chue","Cheung Kong","Cheung Sha Wan","Chuen Lung","Chung Hau","Fa Yuen","Fanling","Fo Tan","Happy Valley","Ho Man Tin","Hong Kong","Hung Hom","Kat O Sheung Wai","Kennedy Town","Kowloon","Kowloon Tong","Kwai Chung","Kwun Hang","Lai Chi Wo","Lam Tei","Lam Tin","Lin Fa Tei","Lo So Shing","Ma On Shan Tsuen","Ma Wan","Ma Yau Tong","Mau Ping","Mid Levels","Mong Kok","Nam A","Ngau Chi Wan","Ngau Tau Kok","North Point","Pak Ngan Heung","Peng Chau","Ping Yeung","Quarry Bay","Repulse Bay","Sai Keng","San Tsuen","San Tung Chung Hang","Sha Po Kong","Sha Tau Kok","Sha Tin Wai","Sham Shui Po","Sham Tseng","Shatin","Shau Kei Wan","Shek Kip Mei","Shek Tong Tsui","Sheung Shui","Sheung Tsuen","Shuen Wan","Tai Chau To","Tai Hang","Tai Kok Tsui","Tai Lin Pai","Tai Po","Tai Tan","Tai Wai","Tai Wan To","Tin Shui Wai","Tin Wan Resettlement Estate","Ting Kau","To Kwa Wan","Tseung Kwan O","Tsimshatsui","Tsing Lung Tau","Tsz Wan Shan","Tuen Mun San Hui","Wan Tsai","Wo Che","Wong Chuk Hang","Wong Tai Sin","Yau Ma Tei","Ying Pun","Yuen Long San Hui"],"Hungary":["Abaujszanto","Abda","Abony","Acs","Acsa","Adacs","Adony","Agard","Ajak","Ajka","Alap","Albertirsa","Almasfuzito","Almaskamaras","Almosd","Alsogalla","Alsonemedi","Alsopahok","Alsoszentivan","Alsotold","Alsozsolca","Aparhant","Apatfalva","Apc","Apostag","Arnot","Asotthalom","Aszalo","Aszar","Aszod","Atkar","Attala","Babolna","Bacsalmas","Badacsonytomaj","Badacsonytordemic","Bag","Bagyogszovat","Baja","Bajna","Bakonybel","Bakonycsernye","Bakonyszentlaszlo","Bakonyszombathely","Balassagyarmat","Balaton","Balatonalmadi","Balatonboglar","Balatonfokajar","Balatonfured","Balatonfuzfo","Balatonkenese","Balatonlelle","Balatonszabadi","Balatonszarszo","Balkany","Balloszog","Balmazujvaros","Banhorvati","Baracs","Baracska","Barand","Barcs","Bataszek","Batonyterenye","Bazsi","Becsehely","Bekasmegyer","Bekesszentandras","Belapatfalva","Beled","Beloiannisz","Benye","Berekfurdo","Berettyoujfalu","Berhida","Berkesd","Besnyo","Biatorbagy","Bicske","Biharkeresztes","Bikal","Bocs","Bodajk","Bodaszolo","Bodrogkisfalud","Bogyiszlo","Bohonye","Bokod","Boldog","Boldva","Boly","Boncodfolde","Bonyhad","Borcs","Borsodszirak","Budajeno","Budakalasz","Budakeszi","Budaors","Budapest","Bugac","Bugyi","Buk","Bukkaranyos","Buzsak","Cegled","Cegledbercel","Celldomolk","Center","Cered","Ciko","Cirak","Csabacsud","Csajag","Csakvar","Csanadpalota","Csanytelek","Csecse","Csemo","Csepa","Cserenfa","Cserepfalu","Cserszegtomaj","Csobad","Csobanka","Csoeroeg","Csogle","Csolyospalos","Csomad","Csomor","Csongrad","Csopak","Csorna","Csorvas","Csovar","Dabas","Dad","Danszentmiklos","Dany","Debrecen","Decs","Dedestapolcsany","Deg","Delegyhaza","Demjen","Derecske","Deszk","Devavanya","Devecser","Diosd","Dobrokoz","Domaszek","Dombovar","Dombrad","Domoszlo","Domsod","Donat","Dorog","Doroghaza","Dudar","Dunabogdany","Dunafoldvar","Dunaharaszti","Dunakeszi","Dunaszeg","Dunaszentgyorgy","Dunavarsany","Dunavecse","Dusnok","Ebes","Ecs","Ecser","Edeleny","Eger","Egerszolat","Egyek","Egyhazasdengeleg","Egyhazashetye","Emod","Encs","Eperjeske","Ercsi","Erdokertes","Esztergom","Farmos","Fegyvernek","Fehergyarmat","Felsopakony","Felsoszentivan","Felsotarkany","Felsozsolca","Fertod","Fertoszentmiklos","Fot","Fuzesabony","Fuzesgyarmat","Galambok","Galgamacsa","Garab","Gardony","Gasztony","Gavavencsello","Gelse","Gemzse","Gencsapati","Gerjen","God","Golle","Gonyu","Gorbehaza","Gorgeteg","Gyal","Gyar","Gyenesdias","Gyomaendrod","Gyomro","Gyongyos","Gyongyossolymos","Gyongyostarjan","Gyorkony","Gyorladamer","Gyorsag","Gyorujbarat","Gyorzamoly","Gyula","Gyulahaza","Hajduboszormeny","Hajdudorog","Hajduhadhaz","Hajdunanas","Hajdusamson","Hajduszoboszlo","Hajmasker","Halaszi","Halasztelek","Halimba","Harkany","Harta","Hatvan","Hegyeshalom","Hegyfalu","Hegyhatmaroc","Hegyhatszentmarton","Hehalom","Helvecia","Herceghalom","Hercegkut","Hercegszanto","Hered","Herend","Hernad","Hernadkak","Hernadnemeti","Heves","Hevesaranyos","Hevizgyoerk","Hidas","Hodmezovasarhely","Homrogd","Hont","Hort","Hosszuheteny","Ibrany","Ikreny","Inancs","Inarcs","Iregszemcse","Isaszeg","Ivancsa","Izmeny","Janoshalma","Janoshida","Janossomorja","Jaszapati","Jaszbereny","Jaszfelsoszentgyorgy","Jaszfenyszaru","Jaszkiser","Jaszladany","Juta","Kacsota","Kadarkut","Kajaszo","Kallo","Kalocsa","Kaloz","Kapolnasnyek","Kaposmero","Kapuvar","Karancskeszi","Karancslapujto","Karancssag","Karcag","Kartal","Kazincbarcika","Kecel","Kemecse","Kemence","Kerecsend","Kerekegyhaza","Kerekharaszt","Kerepes","Kesznyeten","Keszthely","Keszu","Ketegyhaza","Kevermes","Kincsesbanya","Kisar","Kisber","Kisdorog","Kisgyor","Kiskinizs","Kiskoros","Kiskunfelegyhaza","Kiskunhalas","Kiskunlachaza","Kislang","Kismanyok","Kismaros","Kisnemedi","Kispest","Kistapolca","Kistarcsa","Kistelek","Kistokaj","Kistormas","Kisujszallas","Kisvarda","Kisvaszar","Klarafalva","Koka","Kolontar","Komlo","Komlod","Kompolt","Kony","Kophaza","Kormend","Kornye","Korosladany","Koszarhegy","Koszeg","Kotaj","Kotelek","Kubekhaza","Kulcs","Kulsobarand","Kunagota","Kunbaja","Kunhegyes","Kunszentmarton","Kunszentmiklos","Kunsziget","Kurd","Kurityan","Labatlan","Labod","Ladbesenyo","Lajoskomarom","Lajosmizse","Lazi","Leanyfalu","Lebeny","Lenti","Letenye","Levelek","Lovas","Lovaszi","Madocsa","Maglod","Magy","Magyaregres","Magyarhertelend","Magyarnandor","Majoshaza","Makad","Makkoshotyka","Maklar","Mako","Malyi","Mandok","Many","Marcali","Mariapocs","Markaz","Marokpapi","Martely","Martfu","Martonvasar","Mateszalka","Matraballa","Matraszolos","Mecseknadasd","Medgyesegyhaza","Melykut","Mende","Mernye","Mesztegnyo","Mezobereny","Mezofalva","Mezohegyes","Mezokovesd","Mezonyarad","Mezoszilas","Mezotur","Mindszent","Misefa","Miskolc","Mogyorod","Monor","Monorierdo","Mor","Morahalom","Mosonszentmiklos","Mosonszolnok","Mucsony","Nagyatad","Nagybarca","Nagyberki","Nagycenk","Nagycserkesz","Nagydobsza","Nagyhalasz","Nagyhegyes","Nagyigmand","Nagykallo","Nagykanizsa","Nagykapornak","Nagykata","Nagykereki","Nagykeresztur","Nagykoros","Nagykoru","Nagykovacsi","Nagykozar","Nagymagocs","Nagymanyok","Nagynyarad","Nagypali","Nagysap","Nagyszekeres","Nagyszenas","Nagyszokoly","Nagytarcsa","Nagytotfalu","Nagyvazsony","Nagyvenyim","Naszaly","Nemesbod","Nemesbuek","Nemesvid","Nemesvita","Nemetker","Neszmely","Nezsa","Nogradsap","Nogradsipek","Nyekladhaza","Nyergesujfalu","Nyiradony","Nyirbator","Nyiregyhaza","Nyirmartonfalva","Nyirtass","Nyul","Ocsa","Ocseny","Ocsod","Ofeherto","Onga","Orbottyan","Oroshaza","Oroszlany","Ostoros","Otteveny","Ozd","Paka","Pakod","Pakozd","Paks","Palotabozsok","Papa","Part","Paszto","Patroha","Patvarc","Paty","Pazmand","Pecel","Pecol","Pellerd","Per","Perbal","Perenye","Peteri","Petfuerdo","Petofibanya","Petohaza","Pilis","Piliscsaba","Pilismarot","Pilisszanto","Pilisszentivan","Pilisszentkereszt","Pilisvorosvar","Polgar","Polgardi","Pomaz","Posfa","Puspokladany","Pusztaszabolcs","Pusztaszemes","Pusztavacs","Pusztavam","Pusztazamor","Rabapatona","Rabapaty","Racalmas","Rackeresztur","Rackeve","Rad","Rajka","Rakoczifalva","Rakocziujfalu","Repcelak","Repceszemere","Retsag","Revfueloep","Rimoc","Roszke","Rudabanya","Sajokapolna","Sajokeresztur","Sajooeroes","Sajopalfala","Sajoszentpeter","Sajovamos","Salfold","Salgotarjan","Sandorfalva","Sarbogard","Sarisap","Sarkad","Sarmellek","Sarosd","Sarospatak","Sarpentele","Sarpilis","Sarszentagota","Sarszentlorinc","Sarszentmihaly","Sarvar","Sasd","Saska","Se","Selyeb","Senyo","Seregelyes","Siklos","Simontornya","Sirok","Solt","Soltszentimre","Solymar","Somogysard","Somogyudvarhely","Sopron","Sopronkovesd","Sored","Soskut","Suelysap","Sukoro","Sumeg","Szabadbattyan","Szabadszallas","Szabadszentkiraly","Szabolcs","Szabolcsveresmart","Szajk","Szajol","Szalaszend","Szany","Szar","Szarvas","Szazhalombatta","Szecseny","Szecsenyfelfalu","Szeged","Szeghalom","Szegvar","Szemely","Szendehely","Szentendre","Szentes","Szentgotthard","Szentistvan","Szentkatalin","Szentkiralyszabadja","Szentlorinc","Szentmartonkata","Szepetnek","Szeremle","Szerencs","Szigetcsep","Szigethalom","Szigetszentmarton","Szigetszentmiklos","Szigetvar","Szigliget","Szikszo","Szilsarkany","Szirmabesenyo","Szod","Szodliget","Szogliget","Szokolya","Szolnok","Szombathely","Szomod","Szomor","Szuhakallo","Tab","Tabajd","Taborfalva","Taksony","Taktaszada","Tamasi","Tapiobicske","Tapiogyorgye","Tapiosag","Tapioszecso","Tapioszele","Taplanszentkereszt","Tapolca","Tar","Tarcal","Tarjan","Tarnok","Tarpa","Tass","Taszar","Tat","Tata","Teglas","Telekes","Telep","Telki","Tepe","Terem","Tet","Tetetlen","Tevel","Tinnye","Tiszaadony","Tiszabo","Tiszacsege","Tiszafoldvar","Tiszafured","Tiszalok","Tiszaluc","Tiszapalkonya","Tiszaszalka","Tiszaujvaros","Tiszavalk","Tiszavasvari","Toekoel","Toeroekbalint","Tokodaltaro","Tolna","Tomorkeny","Tompa","Tordas","Torokszentmiklos","Torony","Toszeg","Totkomlos","Totszerdahely","Tura","Turkeve","Ujfeherto","Ujkenez","Ujkigyos","Ujlengyel","Ujszasz","Ujszentmargita","Ujszilvas","Ujudvar","Ullo","Uraiujfalu","Uri","Urom","Vacduka","Vacratot","Vacszentlaszlo","Vadna","Vaja","Vajszlo","Valko","Valkonya","Vamospercs","Vamosszabadi","Varalja","Varbalog","Varbo","Vardomb","Varosfoeld","Varpalota","Vasarosdombo","Vasvar","Vecses","Vegegyhaza","Velence","Vep","Veresegyhaz","Veroce","Verseg","Vertessomlo","Vertesszolos","Vertestolna","Vezseny","Visznek","Vitnyed","Vizslas","Zagyvaszanto","Zahony","Zalaegerszeg","Zalakomar","Zalalovo","Zalaszentgrot","Zamoly","Zebecke","Zebegeny","Zichyujfalu","Zirc","Zsambek","Zsambok","Zsombo"],"Iceland":["Akranes","Akureyri","Borgarnes","Dalvik","Grindavik","Hella","Holmavik","Husavik","Hvammstangi","Hveragerdi","Hvolsvollur","Kopavogur","Reykjavik","Selfoss","Skagastrond","Stokkseyri","Vestmannaeyjar","Vogar"],"India":["Abdul","Adilabad","Adwani","Agartala","Agra","Ahmedabad","Ahmednagar","Aizawl","Ajabpur","Ajmer","Akividu","Akola","Alanallur","Alangulam","Alappuzha","Aldona","Alibag","Aligarh","Alipur","Alipur","Allahabad","Almora","Aluva","Alwar","Amal","Amalapuram","Ambad","Ambah","Ambala","Ambarnath","Ambejogai","Ambikapur","Ambur","Amer","Amet","Amravati","Amreli","Amritsar","Anand","Anantapur","Anantnag","Anantpur","Anchal","Andheri","Andra","Angadipuram","Angul","Ankleshwar","Annamalainagar","Antapur","Arakkonam","Arani","Aranmula","Arch","Ariyalur","Arora","Arpora","Arunachal","Arvi","Asansol","Assagao","Attingal","Attur","Aundh","Aurangabad","Aurangabad","Avanigadda","Azamgarh","Baddi","Badlapur","Bagalkot","Bagh","Bagpat","Bahadurgarh","Baharampur","Baidyabati","Bala","Balaghat","Balana","Balanagar","Balangir","Balasore","Bali","Bali","Ballabgarh","Balu","Balurghat","Bambolim","Banda","Bandra","Banga","Bangalore","Bangaon","Bank","Banka","Bankura","Banswara","Bapatla","Barakpur","Baramati","Barddhaman","Bardoli","Bareilly","Bargarh","Barmer","Barnala","Baroda","Barpali","Barpeta","Basirhat","Basti","Basu","Batala","Bawan","Bawana","Beawar","Begusarai","Behala","Bela","Belapur","Belgaum","Belgharia","Bellare","Bellary","Bemetara","Berasia","Betalbatim","Betim","Betul","Bhadath","Bhadohi","Bhadravati","Bhagalpur","Bhagwan","Bhandari","Bhandup","Bharatpur","Bharuch","Bhatapara","Bhatinda","Bhatkal","Bhavnagar","Bhawan","Bhilai","Bhilwara","Bhimavaram","Bhiwandi","Bhiwani","Bhoj","Bhongir","Bhopal","Bhubaneswar","Bhuj","Bhusawal","Bichpuri","Bidar","Bihar Sharif","Bijapur","Bikaner","Bilaspur","Bilaspur","Bilimora","Binavas","Binnaguri","Bishnupur","Bobbili","Bodhan","Bodinayakkanur","Boisar","Bokaro","Bolpur","Botad","Brahmapur","Budaun","Budbud","Budha","Bulandshahr","Bundi","Calangute","Candolim","Canning","Caranzalem","Chakan","Chakra","Chalisgaon","Chamba","Champa","Chand","Chandan","Chandannagar","Chandauli","Chandausi","Chandigarh","Chandrapur","Changanacheri","Channapatna","Charan","Charu","Chen","Chengannur","Chennai","Chetan","Cheyyar","Chhabra","Chhachhrauli","Chhota Udepur","Chicalim","Chidambaram","Chikodi","Chinchvad","Chintamani","Chiplun","Chirala","Chitra","Chitradurga","Chittoor","Chittur","Choolai","Chopda","Chopra","Churachandpur","Coimbatore","Colaba","Connaught Place","Coonoor","Cuddalore","Cumbum","Cuncolim","Curchorem","Cuttack","Dadri","Dahanu","Dahod","Dam Dam","Daman","Damoh","Dang","Dangi","Darbhanga","Darjeeling","Darsi","Dasna","Dasua","Davangere","Dehradun","Delhi","Deolali","Deoria","Devgarh","Devipattinam","Dewas","Dhaka","Dhamtari","Dhanbad","Dhansura","Dhar","Dharamsala","Dharapuram","Dharavi","Dhariwal","Dharmapuri","Dharwad","Dhenkanal","Dhone","Dhrol","Dhubri","Dhule","Dhuri","Dibrugarh","Dicholi","Dimapur","Dinanagar","Dindigul","Dindori","Dipas","Dogadda","Dona Paula","Dumka","Durg","Durgapur","Dwarahat","Dwarka","Edavanna","Ekkattuthangal","Ellora Caves","Eluru","Eral","Ernakulam","Erode","Etawah","Faizabad","Farakka","Faridabad","Faridkot","Fatehabad","Fatehgarh","Fatehpur","Firozabad","Firozpur","Fort","Gadag","Gampalagudem","Gandhidham","Gandhigram","Gandhinagar","Ganga","Ganganagar","Gangapur","Gangrar","Gangtok","Gannavaram","Ganpat","Gargoti","Garhshankar","Gaya","Ghana","Ghatal","Ghatkopar","Ghaziabad","Goa","Gobichettipalayam","Godhra","Gohana","Golaghat","Gold","Gonda","Gorakhpur","Goregaon","Goshaingaon","Gudivada","Gudur","Guindy","Gujrat","Gulbarga","Guna","Guntur","Gurdaspur","Gurgaon","Guruvayur","Guwahati","Gwalior","Habra","Hadadi","Haldia","Haldwani","Hamirpur","Hamirpur","Hansi","Hapur","Hari","Haridwar","Haripad","Haripur","Haryana","Hassan","Haveri","Hazaribagh","Himatnagar","Hinganghat","Hingoli","Hira","Hiriyur","Hisar","Honavar","Hong","Hoshangabad","Hoshiarpur","Hosur","Howrah","Hubli","Hugli","Hyderabad","Ichalkaranji","Idukki","Igatpuri","Iglas","Imphal","Indore","Indraprast","Irinjalakuda","Itanagar","Jabalpur","Jadabpur","Jagdalpur","Jagraon","Jaipur","Jaisalmer","Jajpur","Jalalabad","Jalalpur","Jalandhar","Jalesar","Jalgaon Jamod","Jalna","Jalpaiguri","Jamal","Jammu","Jamnagar","Jamshedpur","Janjgir","Jaspur","Jatani","Jaunpur","Jayanti","Jaynagar","Jaypur","Jha Jha","Jhajjar","Jhalawar","Jhansi","Jhargram","Jharsuguda","Jhunjhunun","Jind","Jodhpur","Jorhat","Junagadh","Kadapa","Kagal","Kailaras","Kaimganj","Kaithal","Kakdwip","Kakinada","Kaladi","Kalam","Kalamboli","Kalan","Kalinga","Kalka","Kalkaji Devi","Kalol","Kalpakkam","Kalpetta","Kalra","Kalyan","Kalyani","Kamalpur","Kamalpura","Kamat","Kanakpura","Kanchipuram","Kanchrapara","Kandi","Kangayam","Kangra","Kanhangad","Kanigiri","Kaniyambadi","Kankauli","Kanniyakumari","Kannur","Kanpur","Kapurthala Town","Karad","Karaikal","Karaikudi","Karamadai","Karamsad","Karanja","Karari","Kargil","Karimganj","Karimnagar","Karjat","Karnal","Karsiyang","Karur","Karwar","Kasal","Kasaragod","Kasganj","Kashipur","Kasia","Kataria","Kathua","Katni","Katoya","Katra","Kaul","Kavali","Kavaratti","Kayamkulam","Keshod","Khajuraho Group of Monuments","Khalapur","Khambhat","Khammam","Khan","Khanna","Kharagpur","Kharar","Khargone","Khatauli","Kheda","Khergam","Kheri","Khinwara","Khopoli","Khurda","Khurja","Kishangarh","Koch Bihar","Kochi","Kodaikanal","Kodungallur","Kohima","Kokrajhar","Kolar","Kolayat","Kolhapur","Kolkata","Kollam","Kollegal","Koni","Koni","Konnagar","Koothanallur","Koppal","Koraput","Korba","Kosamba","Kot Isa Khan","Kota","Kotian","Kottagudem","Kottakkal","Kottarakara","Kottayam","Kovilpatti","Kovvur","Kozhikode","Krishnagiri","Kulti","Kumar","Kumbakonam","Kumhari","Kundan","Kunwar","Kuppam","Kurali","Kurnool","Kushalnagar","Kuzhithurai","Ladwa","Lakhimpur","Lala","Lalgudi","Lamba Harisingh","Lanka","Latur","Liluah","Lohaghat","Lucknow","Ludhiana","Machhiwara","Machilipatnam","Madanapalle","Madgaon","Madhoganj","Madikeri","Madurai","Madurantakam","Mahabalipuram","Mahad","Mahajan","Mahal","Maharaj","Mahatma","Mahesana","Mahesh","Mahim","Mahulia","Malappuram","Maldah","Malpur","Manali","Mancherial","Mandal","Mandapeta","Mandi","Mandla","Mandsaur","Mandvi","Mandya","Mangalagiri","Mangalore","Mangaon","Manipala","Manipur","Manjeri","Manna","Mannargudi","Manor","Mansa","Manu","Markal","Markapur","Marmagao","Maru","Mashobra","Matar","Mathan","Mathura","Mattanur","Mavelikara","Mawana","Mayapur","Medak","Medarametla","Medchal","Medinipur","Meerut","Mehra","Mettur","Mhow","Mill","Miraj","Mirza Murad","Mirzapur","Mithapur","Modasa","Moga","Mohala","Mohali","Mohan","Moradabad","Morena","Morinda","Morvi","Motihari","Mount Abu","Muddanuru","Mukerian","Muktsar","Multi","Mumbai","Mundgod","Mundra","Munger","Murshidabad","Mussoorie","Muzaffarnagar","Muzaffarpur","Mylapore","Mysore","Nabadwip","Nabha","Nadgaon","Nadia","Nadiad","Nagal","Nagapattinam","Nagar","Nagara","Nagari","Nagaur","Nagercoil","Nagpur","Nagwa","Naini","Nalagarh","Nalbari","Nalgonda","Namakkal","Namrup","Nanda","Nanded","Nandi","Nandigama","Nandurbar","Nandyal","Naraina","Narasaraopet","Narayangaon","Narela","Narnaul","Narsapur","Nashik","Nathdwara","Navelim","Navsari","Nayagarh","Nazira","Nehra","Nellore","Neral","Neri","New Delhi","Neyveli","Nila","Nilambur","Nilokheri","Nizamabad","Noida","Nongpoh","Nongstoin","North Lakhimpur","Nurpur","Nuzvid","Odhan","Omalur","Ongole","Ooty","Orai","Osmanabad","Ottappalam","Pachmarhi","Padrauna","Pahalgam","Pakala","Pala","Palakkad","Palampur","Palani","Palayam","Palghar","Pali","Palladam","Paloncha","Palus","Palwal","Panchal","Panchgani","Pandharpur","Panipat","Panjim","Panruti","Pantnagar","Panvel","Paonta Sahib","Parappanangadi","Paravur","Parbhani","Parel","Parra","Patan","Patancheru","Patel","Patelguda","Pathanamthitta","Pathankot","Patiala","Patna","Pattambi","Pattukkottai","Pauri","Payyanur","Peddapuram","Pehowa","Perambalur","Peranampattu","Perundurai","Petlad","Phagwara","Phaphamau","Piduguralla","Pilani","Pileru","Pilkhuwa","Pimpri","Pitampura","Pithapuram","Pithoragarh","Pochampalli","Pollachi","Ponda","Ponnani","Ponneri","Porbandar","Port Blair","Potti","Powai","Proddatur","Puducherry","Pudukkottai","Puliyur","Punalur","Pune","Puras","Puri","Purnea","Puruliya","Pusa","Pushkar","Puttur","Puttur","Quepem","Raichur","Raigarh","Raipur","Raipur","Rajahmundry","Rajapalaiyam","Rajapur","Rajkot","Rajpur","Rajpura","Raju","Rama","Ramanagaram","Ramanathapuram","Ramapuram","Ramavaram","Ramgarh","Ramnagar","Rampur","Rana","Ranaghat","Ranchi","Rander","Raniganj","Ranippettai","Ranjan","Ratlam","Ratnagiri","Raurkela","Rawal","Raxaul","Rayagada","Rewa","Rewari","Ring","Rishikesh","Rohtak","Roorkee","Roshan","Rudrapur","Rupnagar","Rupnarayanpur","Sachin","Sagar","Sagar","Saha","Saharanpur","Sahibabad","Sakri","Sakri","Salem","Saligao","Salt Lake City","Samastipur","Sambalpur","Sanand","Sandur","Sangam","Sangamner","Sangli","Sangola","Sangrur","Sanquelim","Saranga","Sarangi","Sarwar","Satara","Satna","Sattur","Sawi","Secunderabad","Sehore","Sendhwa","Serampore","Shadnagar","Shahabad","Shahapur","Shahdara","Shahdol","Shahjahanpur","Shahkot","Shamsabad","Shanti Grama","Shillong","Shimla","Shimoga","Shirgaon","Shiv","Sholavandan","Shoranur","Shrigonda","Shyamnagar","Sibsagar","Sidhi","Sidhpur","Sikar","Sikka","Silchar","Siliguri","Silvassa","Singarayakonda","Singtam","Sinnar","Sion","Sirhind","Sirkazhi","Sirohi","Sirsa","Sirsi","Siruguppa","Siruseri","Sirwani","Sitapur","Siuri","Sivaganga","Sivakasi","Sodhi","Sojat","Solan","Solapur","Solim","Somnath","Soni","Sonipat","Sopara","Srikakulam","Srikalahasti","Srinagar","Sriperumbudur","Srirangam","Srivilliputhur","Sukma","Sultan","Sultanpur","Sultans Battery","Suman","Sunam","Sundargarh","Surana","Suratgarh","Surendranagar","Suriapet","Tadepallegudem","Tala","Talcher","Talegaon Dabhade","Talwandi Sabo","Tambaram","Tanda","Tanuku","Tarn Taran","Teri","Tezpur","Thalassery","Thane","Thanjavur","Thasra","Thenali","Thenkasi","Thirumangalam","Thiruthani","Thiruvananthapuram","Thiruvarur","Thoothukudi","Thrissur","Tikamgarh","Tindivanam","Tinsukia","Tiptur","Tiruchchendur","Tiruchi","Tirumala","Tirumala - Tirupati","Tirunelveli","Tiruppur","Tirur","Tiruvalla","Tiruvallur","Tiruvannamalai","Tohana","Tonk","Trimbak","Tuljapur","Turaiyur","Udaigiri","Udaipur","Udupi","Ujjain","Ulhasnagar","Ulubari","Umred","Unnao","Uppal","Uttarkashi","Vadamadurai","Vadner","Vadodara","Vaikam","Vainguinim","Valsad","Vandalur","Vandavasi","Vaniyambadi","Vapi","Varanasi","Vasai","Vasco","Vashi","Vazhakulam","Vellore","Verna","Vidisha","Vijapur","Vijayawada","Vikarabad","Vikasnagar","Villupuram","Vinukonda","Virar","Visakhapatnam","Visnagar","Vizianagaram","Wai","Warangal","Wardha","Wellington","Yadgir","Yamunanagar","Yanam","Yavatmal","Yeola","Yercaud"],"Indonesia":["Jakarta","Surabaya","Bandung","Medan","Bekasi","Semarang","Tangerang","Depok","Palembang","Makassar"],"Iran":["`Aliabad","`Aliabad-e Aq Hesar","`Oryan","Abadan","Abol","Ahvaz","Amlash","Amol","Arak","Ardabil","Ardakan","Arnan","Arsanjan","Asadabad","Ashan","Ashna","Ashtian","Astara","Azad","Azadi","Azaran","Babol","Badr","Baft","Baghin","Baharan","Bakhtiari","Bakhtiaruyeh","Baladeh","Banak","Band","Bandar-e Khamir","Bandar-e Mahshahr","Barbun","Bardsir","Baseri Hadi","Bastak","Behbahan","Behdasht","Behjan","Behshahr","Bidak","Birizg","Birjand","Bonab","Borran-e Bala","Bostan","Bukan","Chabahar","Chah Deraz","Chapar","Dadeh","Damavand","Damghan","Darmian","Dezful","Dorud","Emam","Esfarayen","Eslamshahr","Estahban","Evin","Falavarjan","Fardis","Farsi","Fasa","Fordu","Garmsar","Gazan-e Bala","Gerash","Germi","Gharbi","Gilan-e Gharb","Gilas","Golestan","Golpayegan","Golriz","Gorgan","Gostar","Hadishahr","Hamadan","Hasanabad-e Qadamgah","Hashtgerd","Hashtpar","Hirad","Homa","Hormozabad","Hush","Idah","Ilam","Iranshahr","Isfahan","Jadir","Jahan","Jahan Nama","Jahrom","Jiroft","Julfa","Kabir","Kaman","Karaj","Karimkhan","Kashan","Kelarabad","Kerman","Kermanshah","Khalkhal","Khameneh","Khash","Khomeyn","Khomeyni Shahr","Khong","Khorasan","Khowrasgan","Khowrshid","Khvajeh","Khvoy","Kian","Kish","Kord Kandi","Kordestan-e `Olya","Kordovan-e Sofla","Lahijan","Lamerd","Mahabad","Mahallat","Mahestan","Malayer","Malek Talesh","Malekan","Mamasani","Manjil","Maragheh","Marand","Mashhad","Mehin","Mehregan","Meshgin Shahr","Meybod","Miandoab","Mianej","Mobarakeh","Moghan","Mohr","Nahavand","Najafabad","Naji","Nasir","Negar","Nehbandan","Neka","Neyriz","Neyshabur","Novin","Onar","Parpis","Parsian","Pasargad","Payam","Peshgoman","Peyk","Piruz","Post","Qasr od Dasht","Qazvin","Qeshm","Quchan","Rabor","Rafsanjan","Rasak","Rasht","Ravand","Ravansar","Ravar","Rayen","Razan","Razaviyeh","Razi","Rigan","Sabz","Sabzevar","Sahand","Salmas","Saman","Samen","Sanandaj","Saravan","Sari","Saveh","Semirom","Semnan","Sena","Servan","Shadman","Shahid","Shahid Chamran","Shahid Madani","Shahr","Shahrak","Shahrak-e Direh","Shahrak-e Milad","Shahrak-e Pars","Shahreza","Shahriar","Shahrud","Sharif","Shazand","Shiraz","Shirvan","Siahkal","Sirjan","Sistan-e `Olya","Soltanabad","Tabriz","Taha","Takestan","Tiran","Tonekabon","Torkan","Urmia","Vaj","Valilu","Vandar","Varamin","Wahna","Yasuj","Yazd","Zabol","Zahedan","Zahra","Zangiabad","Zanjan","Zarand"],"Iraq":["Al `Amarah","Al Hillah","Baghdad","Bahr","Basere","Basra","Erbil","Haji Hasan","Hayat","Karkh","Kirkuk","Manawi","Mosul","Najaf","Sulaymaniyah","Tikrit"],"Ireland":["Abbeyfeale","Abbeyleix","Ardee","Arklow","Artane","Ashbourne","Athboy","Athenry","Athlone","Athy","Bagenalstown","Bailieborough","Balbriggan","Baldoyle","Balgriffin","Ballina","Ballinadee","Ballinasloe","Ballincollig","Ballineen","Ballinrobe","Ballintober","Ballivor","Ballon","Ballsbridge","Ballybrack","Ballybrit","Ballycullen","Ballyfermot","Ballygarvan","Ballyhooly","Ballymahon","Ballymote","Ballymount","Ballymun","Ballyphilip","Ballyragget","Ballyroe","Ballyvaghan","Bandon","Bantry","Berrings","Bettystown","Birr","Blackrock","Blanchardstown","Blessington","Bodyke","Boherbue","Bray","Broadford","Buncrana","Bundoran","Cabinteely","Cabra","Caher","Cahersiveen","Callan","Carbury","Carlow","Carnew","Carraroe","Carrick","Carrick on Shannon","Carrick-on-Suir","Carrickmacross","Carrickmines","Carrigaline","Carrigtohill","Cashel","Castlebar","Castleblayney","Castlebridge","Castleknock","Castlemaine","Castlerea","Cavan","Celbridge","Clane","Clarecastle","Claregalway","Claremorris","Clogherhead","Clonakilty","Clondalkin","Clonee","Clones","Clonmel","Clonsilla","Clontarf","Coachford","Cobh","Coolock","Cork","County Galway","County Wexford","Courtown","Crookhaven","Cross","Crosshaven","Crumlin","Crusheen","Dalkey","Delgany","Donabate","Donegal","Donnybrook","Doolin","Doughiska","Douglas","Drogheda","Droichead Nua","Dublin","Duleek","Dunboyne","Dundalk","Dundrum","Dundrum","Dungarvan","Dunlavin","Dunleer","Dunshaughlin","Edenderry","Enfield","Ennis","Enniscorthy","Enniskerry","Feakle","Ferbane","Fermoy","Finglas","Firhouse","Foxford","Foxrock","Foynes","Galway","Garristown","Geevagh","Glanmire","Glasnevin","Glen","Glenealy","Glengarriff","Glenties","Gorey","Gort","Grange","Greystones","Headford","Hospital","Inchicore","Irishtown","Island","Jamestown","Kanturk","Kells","Kenmare","Kilbride Cross Roads","Kilcock","Kilcoole","Kilcullen","Kildalkey","Kildare","Kilfinane","Kilkenny","Killala","Killaloe","Killarney","Killiney","Killinick","Killorglin","Killurin","Killybegs","Killygordon","Kilmainham","Kilmichael","Kilmore","Kilrush","Kiltamagh","Kingscourt","Kingswood","Kinsale","Kinvarra","Leamlara","Leixlip","Leopardstown","Letterkenny","Limerick","Lisselton","Listowel","Longford","Longwood","Loughrea","Louth","Lucan","Lusk","Macroom","Malahide","Mallow","Manorhamilton","Marino","Maynooth","Mayo","Midleton","Milltown","Mitchelstown","Monaghan","Monasterevin","Monkstown","Mornington","Mount Merrion","Mountrath","Moycullen","Mullinavat","Mullingar","Naas","Naul","Navan","Nenagh","New Ross","Newcastle West","Newmarket","Newport","Oranmore","Oughterard","Oysterhaven","Passage West","Patrickswell","Portarlington","Porterstown","Portmarnock","Portumna","Prosperous","Raheny","Rathcoole","Rathfarnham","Rathgar","Rathmines","Rathmolyon","Rathowen","Ratoath","Ringaskiddy","River","Roscommon","Roscrea","Rush","Saggart","Saint Mullins","Sallins","Sallynoggin","Sandyford","Sandymount","Santry","Seafield","Shankill","Shannon","Shrule","Sixmilebridge","Skerries","Skibbereen","Slieve","Sligo","Spiddal","Stepaside","Stillorgan","Stradbally","Straffan","Summerhill","Sutton","Swinford","Swords","Tallaght","Templeogue","Terenure","Thomastown","Thurles","Tipperary","Tralee","Trim","Tuam","Tullamore","Tullow","Tyrrellspass","Virginia","Walkinstown","Waterford","Westport","Wexford","Wicklow","Williamstown","Windy Arbour","Youghal"],"Isle of Man":["Ballasalla","Castletown","Crosby","Dalby","Douglas","Foxdale","Laxey","Onchan","Peel","Port Erin","Port Saint Mary","Ramsey","Saint Johns"],"Israel":["`Alma","`Amir","`Arugot","`Aseret","`En Ayyala","`En HaShelosha","`Evron","Acre","Afiqim","Ahituv","Allonim","Ashdod","Ashqelon","Azor","Bahan","Baraq","Bareqet","Bat Hadar","Bat Hefer","Bat Yam","Beersheba","Ben Shemen-Kefar Hano`ar","Bene Ziyyon","Bet Alfa","Bet Dagan","Bet Oren","Bet Shemesh","Binyamina","Biriyya","Dabburiya","Dimona","Eilat","Elyakhin","Elyaqim","Emunim","Et Taiyiba","Even Yehuda","Gan Hayyim","Gan Yavne","Ganne Tiqwa","Gedera","Gibbeton","Gimzo","Ginnosar","Giv`at Hayyim","Hadar `Am","Hadar Ramatayim","Hadera","Hadid","Haifa","HaKarmel","Haluz","Hazav","Hazor Ashdod","Hazor HaGelilit","Herut","Herzliya","Hever","Hod HaSharon","Holon","Hurfeish","Jaffa","Jerusalem","Kadima","Karkur","Kefar Daniyyel","Kefar Netter","Kefar Witqin","Kefar Yona","Kfar Saba","Liman","Lod","maalot Tarshiha","Magen","Maghar","Mazkeret Batya","Mazliah","Mazor","Mesillat Ziyyon","Migdal","Mikhmoret","Misgav Regional Council","Mizpe Netofa","Modiin","Moran","Naham","Nahariya","Nazareth","Nazerat `Illit","Nesher","Ness Ziona","Netanya","Netivot","Newe Efrayim","Newe Yamin","Nir Zevi","Nirim","Nordiyya","Ofaqim","Or `Aqiva","Or Yehuda","Pardes Hanna Karkur","Pardesiyya","Pasuta","Petah Tikwah","Qiryat Ata","Qiryat Bialik","Qiryat Gat","Qiryat Hayyim","Qiryat Motzkin","Qiryat Ono","Qiryat Tiv`on","Qiryat Yam","Ramat Aviv","Ramat Dawid","Ramat Ef`al","Ramat Gan","Ramat HaSharon","Ramat Poleg","Ramat Yishay","Ramla","Ramot Naftali","Rehovot","Rinnatya","Rishon LeZion","Rishpon","Safed","Sarid","Savyon","Sde Boker","Sde Warburg","Sderot","Sedot Yam","Shamir","Shave Ziyyon","Shefayim","Shelomi","Shetulim","Shoval","Talme Menashe","Tel Aviv","Tel Mond","Tiberias","Timrat","Tirat Karmel","Tirat Yehuda","Urim","Yaqum","Yavne","Yehud","Zoran"],"Italy":["Abano Terme","Abbadia Lariana","Abbadia San Salvatore","Abbasanta","Abbiategrasso","Abetone","Acate","Acerno","Acerra","Aci Castello","Aci Catena","Acireale","Acquafredda","Acquafredda Inferiore","Acquapendente","Acquappesa","Acquaro","Acquasparta","Acquaviva","Acquaviva delle Fonti","Acquaviva Picena","Acqui Terme","Acri","Adelfia","Adrano","Adria","Adro","Affi","Afragola","Africo Nuovo","Agazzano","Agerola","Agira","Agliana","Agliano","Aglientu","Agna","Agnadello","Agnone","Agordo","Agrano","Agrate Brianza","Agrigento","Agro","Agropoli","Agugliano","Agugliaro","Ai Palazzi","Aiello","Aiello del Sabato","Ailano","Ailoche","Airasca","Airola","Airole","Airuno","Ala","Ala di Stura","Alanno","Alassio","Alatri","Alba","Albanella","Albano di Lucania","Albano Laziale","Albano Vercellese","Albaredo","Albareto","Albenga","Albergo","Alberobello","Alberoni","Albettone","Albiate","Albignasego","Albina","Albinea","Albino","Albissola Marina","Albizzate","Albuzzano","Alcamo","Alcara li Fusi","Aldeno","Ales","Alessandria","Alessandria della Rocca","Alessano","Alezio","Alfonsine","Alghero","Algund","Alice Castello","Alife","Alimena","Alleghe","Allerona","Alliste","Allumiere","Almenno San Bartolomeo","Almese","Alpette","Alpignano","Altamura","Altare","Altavilla","Altavilla Irpina","Altavilla Milicia","Altavilla Silentina","Altavilla Vicentina","Altedo","Altessano","Altidona","Altino","Altofonte","Altomonte","Altopascio","Alviano","Alvignanello","Alvignano","Alvito","Alzano Lombardo","Amalfi","Amandola","Amantea","Amaro","Amato","Ambra","Ambrogio","Ameglia","Amelia","Ameno","Amorosi","Ampezzo","Anacapri","Anagni","Ancarano","Ancona","Andezeno","Andorno Micca","Andrano","Andria","Anfo","Angera","Anghiari","Angolo Terme","Angri","Anguillara","Anguillara Veneta","Anna","Annicco","Annone Veneto","Antea","Antella","Anterselva di Mezzo","Antico di Maiolo","Antignano","Antonimina","Antrodoco","Anzano del Parco","Anzio","Aosta","Apice","Apiro","Appiano Gentile","Appiano sulla strada del vino","Appignano","Appignano del Tronto","Apricena","Aprilia","Aquileia","Aquilonia","Aquino","Arabba","Aradeo","Aragona","Arborea","Arborio","Arbus","Arcade","Arce","Arcene","Arcevia","Arcidosso","Arco","Arcola","Arcole","Arconate","Arcore","Arcugnano","Ardea","Ardesio","Arenzano","Arese","Arezzo","Argelato","Argenta","Ariano Ferrarese","Ariano Irpino","Ariano nel Polesine","Ariccia","Arielli","Arienzo","Arignano","Arizzano","Arluno","Armeno","Armento","Arnesano","Arona","Arosio","Arpaia","Arpino","Arqua Polesine","Arquata Scrivia","Arre","Arrone","Arsago Seprio","Arsita","Arta Terme","Artena","Artogne","Arzachena","Arzano","Arzene","Arzignano","Asciano","Ascoli Piceno","Ascoli Satriano","Asiago","Asola","Asolo","Assemini","Assisi","Asso","Assoro","Asti","Atella","Atena Lucana","Atessa","Atina","Atri","Atripalda","Attigliano","Attimis","Atzara","Augusta","Auletta","Aulla","Aurelia","Auronzo di Cadore","Avella","Avellino","Aversa","Avezzano","Aviano","Avigliana","Avigliano","Avigliano Umbro","Avio","Avola","Azeglio","Azzano","Azzano Decimo","Azzano San Paolo","Azzate","Bacoli","Badia","Badia","Badia Calavena","Badia Polesine","Badolato","Bagheria","Baglio Rizzo","Bagnacavallo","Bagnara","Bagnara Calabra","Bagnara di Romagna","Bagnasco","Bagni","Bagni di Lucca","Bagno a Ripoli","Bagno di Romagna","Bagnoli del Trigno","Bagnoli di Sopra","Bagnoli Irpino","Bagnolo","Bagnolo Cremasco","Bagnolo in Piano","Bagnolo Mella","Bagnolo Piemonte","Bagnolo San Vito","Baia","Baiano","Baiso","Balangero","Baldissero Torinese","Balestrate-Foce","Ballabio","Baluello","Balvano","Balzola","Baragiano","Baranzate","Baratte","Barbarano Vicentino","Barbarasco","Barberino di Mugello","Barbiano","Bardolino","Bardonecchia","Bareggio","Barga","Bargagli","Barge","Bari","Bari Sardo","Baricella","Barile","Barisciano","Barlassina","Barletta","Barni","Baronissi","Barra","Barrafranca","Barrali","Baruchella","Barumini","Barzana","Basaldella","Baschi","Basciano","Baselice","Basiliano","Basilicanova","Bassano Bresciano","Bassano del Grappa","Bassano in Teverina","Bassano Romano","Bastia umbra","Bastiglia","Battaglia Terme","Battipaglia","Baunei","Baveno","Bazzano","Bedollo","Begliano","Beinasco","Beinette","Belfiore","Belforte","Belgioioso","Bella","Bellagio","Bellano","Bellante","Bellaria-Igea Marina","Bellariva","Bellinzago Novarese","Bellocchi","Bellona","Belluno","Belmonte Mezzagno","Belmonte Piceno","Belpasso","Belsito","Belvedere","Belvedere di Spinello","Belvedere Marittimo","Belvedere Ostrense","Benestare","Benetutti","Benevello","Benevento","Benna","Bentivoglio","Berbenno di Valtellina","Berceto","Bergamo","Berlingo","Bernalda","Bernate Ticino","Bertinoro","Bertonico","Berzo Demo","Besana in Brianza","Besano","Besnate","Besozzo","Bettola","Bettolle","Bettona","Beura-Cardezza","Bevilacqua","Biancade","Biancano","Biancavilla","Bianco","Bianconese","Biandronno","Bianzone","Biassono","Bibbiano","Bibbiena","Bibbona","Bibione","Biella","Bienno","Bientina","Binanuova","Binasco","Bisaccia","Bisacquino","Bisceglie","Bitetto","Bitonto","Bitritto","Bitti","Bivongi","Blera","Boara","Bobbio","Boccheggiano","Bocchignano","Boffalora sopra Ticino","Bogliasco","Bojano","Bolano","Bollate","Bollengo","Bologna","Bolzano","Bolzano","Bolzano Vicentino","Bompietro","Bomporto","Bonarcado","Bonassola","Bonavicina","Bondeno","Bonea","Bonorva","Bordighera","Boretto","Borgaro Torinese","Borgetto","Borghetto","Borghetto di Vara","Borghetto Santo Spirito","Borgia","Borgo","Borgo","Borgo a Mozzano","Borgo di Terzo","Borgo Priolo","Borgo Sabotino-Foce Verde","Borgo San Dalmazzo","Borgo San Giacomo","Borgo San Lorenzo","Borgo Ticino","Borgo Tossignano","Borgo Val di Taro","Borgo Vercelli","Borgomanero","Borgone","Borgonovo","Borgonovo Val Tidone","Borgoricco","Borgorose","Borgosatollo","Borgosesia","Bornasco","Borno","Borrello","Borzonasca","Bosa","Boschetto","Bosco","Bosco","Bosco Chiesanuova","Bosconero","Boscoreale","Boscotrecase","Bosisio Parini","Bossolasco","Bottanuco","Bova Marina","Bovalino","Bovegno","Boves","Bovezzo","Boville Ernica","Bovino","Bovisio-Masciago","Bovolenta","Bovolone","Bozzolo","Bra","Braccagni","Bracciano","Bracigliano","Brancaleone","Brandizzo","Braone","Brebbia","Breda di Piave","Breganze","Breguzzo","Brembate","Brembilla","Brendola","Brenner","Breno","Brescello","Brescia","Bressana Bottarone","Bressanvido","Bresso","Briatico","Bricherasio","Briga Novarese","Brignano","Brindisi","Brissago-Valtravaglia","Brivio","Brixen","Brolo","Broni","Bronte","Bronzolo","Brossasco","Brosso","Brugherio","Brugine","Brugnera","Bruino","Brunate","Bruneck","Brunella","Bruno","Brusciano","Brusnengo","Bubbio","Bucchianico","Bucciano","Buccino","Bucine","Budrio","Buggiano","Buia","Buonabitacolo","Burano","Buriasco","Burolo","Buronzo","Busalla","Busca","Buscate","Buscoldo","Busseto","Bussi sul Tirino","Bussolengo","Bussoleno","Busto Arsizio","Busto Garolfo","Butera","Buti","Buttapietra","Buttigliera Alta","Buttrio","Cabras","Caccamo","Caccuri","Cadelbosco di Sopra","Cadeo","Cadoneghe","Caerano di San Marco","Caggiano","Cagli","Cagliari","Cagliari","Cagnano Varano","Caianello","Caiatia","Cairate","Cairo Montenotte","Caivano","Calalzo di Cadore","Calamandrana","Calangianus","Calascibetta","Calatabiano","Calatafimi","Calcara","Calcata","Calci","Calcinaia","Calcinate","Calcinato","Calcinelli","Calcio","Caldaro sulla Strada del Vino","Caldarola","Calderara di Reno","Caldogno","Caldonazzo","Calendasco","Calenzano","Calice al Cornoviglio","Calimera","Calitri","Calizzano","Calliano","Calolziocorte","Caltagirone","Caltanissetta","Caltavuturo","Caluso","Calvanico","Calvatone","Calvenzano","Calvisano","Calvizzano","Camaiore","Cambiago","Cambiano","Camburzano","Camerano","Camerata Picena","Cameri","Cameriano","Camerino","Camerlona","Caminetto","Camino","Camino","Camisa","Camisano","Camisano Vicentino","Camogli","Campagna","Campagnano di Roma","Campagnola","Campagnola Emilia","Camparada","Campegine","Campertogno","Campi","Campi Bisenzio","Campi Salentina","Campiglia Marittima","Campiglio","Campione","Campli","Campo","Campo Ligure","Campo San Martino","Campo Tizzoro","Campobasso","Campobello di Licata","Campobello di Mazara","Campodarsego","Campodenno","Campodimele","Campodipietra","Campodoro","Campofelice di Roccella","Campofilone","Campoformido","Campofranco","Campogalliano","Campoleone","Campoli Appennino","Campolieto","Campolongo Maggiore","Campomarino","Campomorone","Camponogara","Campora","Camporeale","Camporosso","Camposampiero","Camposano","Canale","Canaro","Canazei","Cancello","Cancello ed Arnone","Candelo","Candia Canavese","Candia Lomellina","Candiana","Candiolo","Canegrate","Canelli","Canicattini Bagni","Canino","Canistro","Cannara","Cannella","Cannero Riviera","Canneto Pavese","Cannobio","Canonica","Canosa di Puglia","Canosa Sannita","Canossa","Cantagallo","Cantalice","Cantalupo in Sabina","Cantalupo Ligure","Cantarana","Cantu","Canzo","Caorle","Caorso","Capaccio","Capaci","Capalbio","Capannelle","Capannoli","Capannori","Capena","Capergnanica","Capistrano","Capistrello","Capitignano","Capo Rizzuto","Capodimonte","Capodrise","Capoliveri","Capoterra","Cappella Maggiore","Cappelle sul Tavo","Capralba","Capranica","Caprese Michelangelo","Capri","Capriate San Gervasio","Caprie","Caprino Bergamasco","Caprino Veronese","Capriolo","Capriva del Friuli","Capua","Capurso","Caraglio","Carapelle","Carasco","Carate Brianza","Caravaggio","Caravate","Caravino","Caravonica","Carbonara al Ticino","Carbonara di Bari","Carbonara di Po","Carbonera","Carbonia","Carcare","Carcereri","Carceri","Cardano","Cardito","Carema","Carenno","Carentino","Caresana","Cariati","Carignano","Carini","Carinola","Carlazzo","Carlentini","Carlino","Carloforte","Carmagnola","Carmiano","Carmignano","Carmignano di Brenta","Carnago","Carnate","Carobbio","Carolei","Caronia","Carosino","Carovigno","Carpaneto Piacentino","Carpegna","Carpenedolo","Carpeneto","Carpi","Carpiano","Carpignano Sesia","Carpinello","Carpineti","Carpineto Romano","Carrara","Carsoli","Cartoceto","Cartura","Carugate","Carvico","Casa Bartolacelli-Stella","Casa Gherardi","Casa Pace","Casa Paradiso","Casa Zola","Casacalenda","Casacanditella","Casaccia II","Casaglia","Casal di Principe","Casal Velino","Casalbordino","Casalborgone","Casalbuttano ed Uniti","Casale","Casale Corte Cerro","Casale di Mezzani","Casale di Scodosia","Casale Monferrato","Casale sul Sile","Casalecchio di Reno","Casaleggio Novara","Casaletto Spartano","Casalgrande","Casalgrasso","Casali","Casalmaggiore","Casalmaiocco","Casalmorano","Casalnuovo di Napoli","Casaloldo","Casalpusterlengo","Casalromano","Casalserugo","Casaluce","Casalvecchio Siculo","Casalvieri","Casalvolone","Casalzuigno","Casamarciano","Casamassima","Casandrino","Casanova","Casapulla","Casarano","Casaratta","Casargo","Casarile","Casarsa della Delizia","Casate Raffa","Casateia","Casatenovo","Casavecchia","Casazza","Cascia","Casciana Terme","Cascina","Cascine Maggio","Case","Case Catania","Case Franchini","Casei Gerola","Caselette","Caselle","Caselle","Caselle Lurani","Caselle Torinese","Caserta","Casier","Casignana","Casina","Casinalbo","Casnigo","Casola di Napoli","Casoli","Casorate Primo","Casorate Sempione","Casorezzo","Casoria","Casperia","Caspoggio","Cassacco","Cassano","Cassano delle Murge","Cassano Spinola","Cassine Superiore","Cassino","Cassolnovo","Castagnaro","Castagneto Carducci","Castagneto Po","Castagnole","Castano Primo","Casteggio","Castegnato","Castel","Castel Bolognese","Castel Colonna","Castel del Piano","Castel di Casio","Castel di Judica","Castel Focognano","Castel Frentano","Castel Gabbiano","Castel Gandolfo","Castel Giorgio","Castel Goffredo","Castel Guelfo di Bologna","Castel Madama","Castel Maggiore","Castel Mella","Castel San Giovanni","Castel San Lorenzo","Castel San Pietro Romano","Castel San Pietro Terme","Castel Viscardo","Castel Volturno","Castelbellino","Castelbuono","Castelcucco","Casteldaccia","Castelfidardo","Castelfiorentino","Castelfranci","Castelfranco di Sopra","Castelfranco di Sotto","Castelfranco Emilia","Castelfranco Veneto","Castelgomberto","Castelgrande","Castellabate","Castellalto","Castellammare del Golfo","Castellammare di Stabia","Castellamonte","Castellana Grotte","Castellana Sicula","Castellaneta","Castellanza","Castellar Guidobono","Castellarano","Castellaro","Castellazzo Bormida","Castellengo","Castelleone","Castelletto","Castelletto","Castelletto sopra Ticino","Castelli","Castelli Calepio","Castellina in Chianti","Castellina Marittima","Castelliri","Castello","Castello","Castello","Castello","Castello","Castello","Castello","Castello","Castello","Castello di Annone","Castello di Godego","Castello di Serravalle","Castellucchio","Castelluccio Inferiore","Castelmassa","Castelnovo di Sotto","Castelnuovo","Castelnuovo","Castelnuovo","Castelnuovo","Castelnuovo","Castelnuovo Berardenga","Castelnuovo dei Sabbioni","Castelnuovo della Daunia","Castelnuovo di Garfagnana","Castelnuovo di Porto","Castelnuovo di Val di Cecina","Castelnuovo di Verona","Castelnuovo Don Bosco","Castelnuovo Magra","Castelnuovo Nigra","Castelnuovo Rangone","Castelnuovo Scrivia","Castelpagano","Castelplanio","Castelpoto","Castelraimondo","Castelseprio","Casteltermini","Castelvecchio","Castelvecchio Pascoli","Castelvenere","Castelverde","Castelvetrano","Castelvetro di Modena","Castenaso","Castenedolo","Castiadas","Castiglion Fibocchi","Castiglion Fiorentino","Castiglione","Castiglione","Castiglione","Castiglione Chiavarese","Castiglione Cosentino","Castiglione dei Pepoli","Castiglione del Lago","Castiglione della Pescaia","Castiglione delle Stiviere","Castiglione di Cervia","Castiglione di Garfagnana","Castiglione di Sicilia","Castiglione Messer Raimondo","Castiglione Olona","Castignano","Castilenti","Castione della Presolana","Castions di Strada","Casto","Castorano","Castri di Lecce","Castrignano del Capo","Castro dei Volsci","Castrocaro Terme","Castrofilippo","Castrolibero","Castronno","Castroreale","Castrovillari","Catania","Catanzaro","Catenanuova","Catignano","Cattolica","Cattolica Eraclea","Caulonia","Cava Manara","Cavacurta","Cavagnolo","Cavaion Veronese","Cavalese","Cavallermaggiore","Cavallino","Cavallino","Cavallirio","Cavareno","Cavaria con Premezzo","Cavarzere","Cave","Cavenago di Brianza","Cavezzo","Cavour","Cavriago","Cavriana","Cavriglia","Cazzago San Martino","Ceccano","Cecchini","Cecina","Cedessano","Cedrasco","Ceggia","Ceglie Messapica","Celano","Celenza Valfortore","Celico","Cellamare","Celle Ligure","Cellino Attanasio","Cellino San Marco","Cellio","Cellole","Cembra","Cenaia","Cencenighe Agordino","Cene","Cengio","Centallo","Cento","Centola","Centrale","Centuripe","Cepagatti","Ceppaloni","Ceprano","Cerano","Cerasolo","Cercepiccola","Cercola","Cerea","Ceregnano","Ceres","Ceresara","Cerete","Ceriale","Ceriano Laghetto","Cerignola","Cermenate","Cernobbio","Cernusco sul Naviglio","Cerredolo","Cerreto Guidi","Cerreto Laziale","Cerreto Sannita","Cerrione","Cerro Maggiore","Certaldo","Certosa","Certosa di Pavia","Cervaro","Cerveno","Cervere","Cerveteri","Cervia","Cervignano del Friuli","Cervino","Cervo","Cesa","Cesana Torinese","Cesano Maderno","Cesara","Cese","Cesena","Cesenatico","Cesiomaggiore","Ceto","Cetraro","Ceva","Chambave","Champdepraz","Charvensod","Cherasco","Chiampo","Chianciano Terme","Chiara","Chiaramonte Gulfi","Chiarano","Chiaravalle","Chiaravalle Centrale","Chiari","Chiavari","Chiavazza","Chiavenna","Chieri","Chiesina Uzzanese","Chieti","Chioggia","Chiomonte","Chions","Chitignano","Chiusanico","Chiusano di San Domenico","Chiusavecchia","Chiusi","Chiusi della Verna","Chivasso","Cicagna","Cicciano","Ciciliano","Cicognolo","Cigliano","Cignone","Cilavegna","Cimadolmo","Cimego","Ciminna","Cimitile","Cinecitta","Cingoli","Cinisello Balsamo","Cinisi","Cinquefrondi","Cintano","Cinto Caomaggiore","Circello","Cirimido","Cisano Bergamasco","Cisano sul Neva","Ciserano","Cislago","Cisliano","Cison di Valmarino","Cisterna di Latina","Cisternino","Cittadella","Cittaducale","Cittanova","Cittiglio","Civezzano","Cividale del Friuli","Cividate Camuno","Civita Castellana","Civitanova Alta","Civitanova Marche","Civitavecchia","Civitella del Tronto","Civitella di Romagna","Civitella in Val di Chiana","Civitella Marittima","Civitella Roveto","Civitella San Paolo","Cizzago-Comezzano","Cles","Clusone","Coccaglio","Cocconato","Cocquio-Trevisago","Codaruina","Codevigo","Codigoro","Codogno","Codroipo","Codrongianos","Coggiola","Cogne","Cogoleto","Cogorno","Cola","Colbordolo","Colere","Colico","Collalto","Collazzone","Colle","Colle","Colle Umberto","Collecchio","Collecorvino","Colledara","Colledimezzo","Colleferro","Collefontana-Fontana Liri Inferiore","Collegno","Collelungo","Collepasso","Collesano","Colli del Tronto","Colliano","Collinas","Colloredo di Prato","Colmurano","Cologna","Cologna Veneta","Cologne","Cologno al Serio","Cologno Monzese","Colombaro","Colonna","Colonnella","Colorno","Coltura","Comacchio","Comano","Comazzo","Comerio","Comiso","Como","Compiano","Comun Nuovo","Cona","Conco","Concordia Sagittaria","Concordia sulla Secchia","Concorezzo","Condofuri","Condove","Conegliano","Confienza","Conselice","Conselve","Contigliano","Contrada","Controguerra","Contursi Terme","Conversano","Copertino","Copiano","Copparo","Coppe","Coppito","Corato","Corbetta","Corbola","Corchiano","Corciano","Cordenons","Cordignano","Cordovado","Corea Castelluccia San Paolo","Coredo","Corfinio","Cori","Coriano","Corigliano Calabro","Corinaldo","Corio","Corleone","Corleto Perticara","Cormons","Cornaiano","Cornaredo","Cornedo Vicentino","Corno","Corno di Rosazzo","Corno Giovine","Cornuda","Corona","Correggio","Correzzola","Corridonia","Corropoli","Corsano","Corsico","Cortandone","Corte","Corte Franca","Cortemaggiore","Cortenova","Corteolona","Corti","Cortina","Cortona","Corvara","Corzano","Coseano","Cosenza","Cossato","Costa","Costa","Costa di Rovigo","Costa Volpino","Costabissara","Costarainera","Costermano","Cotignola","Cotronei","Courmayeur","Covo","Cozzo","Creazzo","Crema","Cremolino","Cremona","Crescentino","Crespano del Grappa","Crespellano","Crespiatica","Crespina","Crespino","Cressa","Crevacuore","Crevalcore","Crispiano","Croce","Crocetta del Montello","Crodo","Cropani","Crosia","Crotone","Cuceglio","Cuggiono","Cuglieri","Cugnoli","Cumiana","Cumignano sul Naviglio","Cuneo","Cunico","Cupello","Cupra Marittima","Cupramontana","Curcuris","Curinga","Curno","Curtarolo","Cusano Milanino","Cusano Mutri","Cusino","Custonaci","Cutrofiano","Dairago","Dalmine","Darfo","Davoli","Decima","Decollatura","Deggiano","Dego","Deiva Marina","Delia","Delianuova","Dello","Demonte","Deruta","Dervio","Desenzano del Garda","Desio","Deutschnofen","Diamante","Diano Marina","Diano San Pietro","Dicomano","Diecimo","Dignano","Dimaro","Dipignano","Dogliani","Dolceacqua","Dolianova","Dolo","Domanico","Domaso","Domegliara","Domodossola","Domusnovas","Dongo","Doria","Dorno","Dosolo","Dossobuono","Dosson","Dovadola","Dozza","Dozza","Drapia","Dro","Dronero","Druento","Druogno","Dubino","Dueville","Dugenta","Duino-Aurisina","Eboli","Edolo","Elmas","Empoli","Endine Gaiano","Enemonzo-Quinis","Enna","Envie","Eraclea","Erba","Erchie","Ercolano","Erice","Erve","Escalaplano","Escolca","Esine","Esino Lario","Esperia","Este","Etroubles","Fabbri","Fabbrica","Fabbrico","Fabriano","Fabrica di Roma","Faedis","Faenza","Fagagna","Faggiano","Fagnano Olona","Faiano","Falciano","Falconara","Falconara Albanese","Falconara Marittima","Falcone","Falerna","Falerone","Falze-Signoressa","Fanano","Fanna","Fano","Fantina","Fara Filiorum Petri","Fara in Sabina","Fara Novarese","Farnese","Farra di Soligo","Fasano","Fastello","Fauglia","Favara","Favaro Veneto","Favria","Feldthurns","Felegara","Feletto","Feletto Umberto","Felino","Felitto","Feltre","Fenile","Ferentino","Fermignano","Fermo","Ferno","Feroleto della Chiesa","Ferrandina","Ferrara","Ferrara","Ferrari","Ferrazzano","Ferrero","Ferriere","Fiano","Fiano Romano","Ficarazzi","Ficarolo","Ficarra","Ficulle","Fidenza","Field","Fiera","Fiesole","Fiesso Umbertiano","Figino","Figline Valdarno","Filadelfia","Filettino","Filetto","Filiano","Filighera","Filo","Filottrano","Finale Emilia","Finale Ligure","Fino Mornasco","Fiorano Modenese","Fiore","Fisciano","Fiuggi","Fiume Veneto","Fiumefreddo di Sicilia","Fiumicello","Fiumicino","Flaibano","Flero","Florence","Floridia","Fluminimaggiore","Flussio","Foggia","Foglianise","Fogliano Redipuglia","Foglizzo","Foiano della Chiana","Foiano di Val Fortore","Folgaria","Folignano","Foligno","Follina","Follonica","Fombio","Fondi","Fonni","Fontana","Fontana Liri","Fontanafredda","Fontanarosa","Fontanelice","Fontanella","Fontanella","Fontanellato","Fontanelle","Fontanelle","Fontaniva","Fontevivo","Fonzaso","Forano","Forenza","Foresto","Forino","Forio","Forlimpopoli","Formello","Formia","Formicola","Formigine","Fornace di Miramare","Fornaci","Fornaci di Barga","Forno","Forno Alpi Graie","Forno Canavese","Fornovo di Taro","Forte dei Marmi","Fortunago","Fosco","Fosdinovo","Fossa","Fossacesia","Fossalta di Piave","Fossalta di Portogruaro","Fossano","Fossato di Vico","Fossombrone","Frabosa Sottana","Fragagnano","Francavilla al Mare","Francavilla di Sicilia","Francavilla Fontana","Francavilla in Sinni","Francenigo","Francofonte","Francolise","Frascaro","Frascati","Frascineto","Frassineto Po","Frasso Telesino","Frattamaggiore","Frattaminore","Frattocchie","Fregene","Frigento","Frisa","Front","Frontone","Frosinone","Frugarolo","Fucecchio","Fumane","Fumone","Furci Siculo","Furore","Fuscaldo","Fusignano","Futani","Gabbiano","Gabbro","Gabicce Mare","Gadoni","Gaeta","Gaggi","Gaggiano","Gaggio Montano","Gagliano del Capo","Gaiarine","Gaiole in Chianti","Gais","Galatina","Galatone","Galbiate","Galdo","Galeata","Gallarate","Gallese","Galliate","Gallicano","Gallicano nel Lazio","Galliera","Galliera Veneta","Gallignano","Gallio","Gallipoli","Gallo","Gambara","Gambellara","Gambettola","Gandino","Gangi","Garbagnate Milanese","Garda","Gardone Riviera","Gardone Val Trompia","Garessio","Gargnano","Garibaldi","Garlasco","Garlate","Garlenda","Garrufo","Gassino Torinese","Gattatico","Gatteo","Gatteo a Mare","Gattinara","Gavardo","Gavi","Gavinana","Gavirate","Gavoi","Gazoldo degli Ippoliti","Gazzada Schianno","Gazzaniga","Gazzo","Gazzo Veronese","Gazzola","Gazzuolo","Gela","Gemona","Genazzano","Genivolta","Genoa","Genzano di Roma","Gera Lario","Gerano","Gerenzago","Gergei","Germagnano","Gessate","Gessopalena","Gesualdo","Ghedi","Ghemme","Ghiffa","Ghilarza","Ghisalba","Giano Vetusto","Giardinello","Giardinetto Vecchio","Giardini","Giardini-Naxos","Giarratana","Giarre","Giaveno","Giavera del Montello","Gibellina","Giffoni Valle Piana","Gignese","Gimigliano","Ginosa","Gioia","Gioia del Colle","Gioia Tauro","Gioiosa Ionica","Gioiosa Marea","Giove","Giove","Giovinazzo","Girifalco","Gissi","Giugliano in Campania","Giuliana","Giuliano","Giuliano Teatino","Giulianova","Giungano","Giussago","Giussano","Godiasco","Godo","Goito","Golasecca","Golfo Aranci","Gonars","Gonnesa","Gonnosfanadiga","Gonnostramatza","Gonzaga","Gordona","Gorgo al Monticano","Gorgonzola","Gorizia","Gorla Maggiore","Gorle","Gorno","Gossolengo","Gottolengo","Gozzano","Gradara","Grado","Gradoli","Graglia","Gragnano","Gragnano Trebbiense","Grammichele","Grandate","Granitola Torretta","Grantorto","Grassano","Gravedona","Gravellona Toce","Gravina in Puglia","Grazzanise","Grazzano Badoglio","Greci","Gressoney-Saint-Jean","Greve in Chianti","Grezzana","Grignasco","Grigno","Grimaldi","Grisignano di Zocco","Gropello Cairoli","Grosio","Grosseto","Grotta","Grottaferrata","Grottaglie","Grottaminarda","Grottammare","Grottazzolina","Grotte","Grotte di Castro","Grottolella","Gruaro","Grugliasco","Grumello Cremonese","Grumello del Monte","Grumento Nova","Grumo Appula","Grumo Nevano","Grumolo delle Abbadesse","Guagnano","Gualdo Cattaneo","Gualdo Tadino","Gualtieri","Guamaggiore","Guarda Veneta","Guardamiglio","Guardavalle","Guardia Piemontese","Guardia Sanframondi","Guardiagrele","Guardialfiera","Guarrato","Guasila","Guastalla","Gubbio","Guidizzolo","Guido","Guidonia","Guiglia","Gurro","Guspini","Gussago","Gusti","Iesi","Iglesias","Il Ciocco","Illasi","Imola","Imperia","Impruneta","Induno Olona","Innichen","Inverigo","Inveruno","Inzago","Ischia","Ischia di Castro","Ischitella","Iseo","Isernia","Isili","Isola","Isola del Cantone","Isola del Giglio","Isola del Gran Sasso","Isola del Liri","Isola della Scala","Isola delle Femmine","Isola Dovarese","Isola Vicentina","Isorella","Ispica","Ispra","Issime","Istrana","Itala","Itri","Ittiri","Ivrea","Izano","Jesolo","Jolanda di Savoia","Klausen","La Gala","La Loggia","La Maddalena","La Morra","La Salle","La Salute di Livenza","La Spezia","La Valle Agordina","La Via","La Villa","Labico","Lacchiarella","Lacco Ameno","Ladispoli","Lago","Lago","Lago","Lagosanto","Laigueglia","Lainate","Laino Borgo","Laives","Lajatico","Lajen","Lake Bolsena","Lallio","Lama Mocogno","Lammari","Lamon","Lampedusa","Lamporecchio","Lana","Lancenigo","Lancenigo-Villorba","Lanciano","Landriano","Langhirano","Lanusei","Lanuvio","Lanzo Torinese","Lapio","Lappato","Larciano","Larderello","Lardirago","Lari","Lariano","Larino","Lasino","Lastra","Lastra a Signa","Laterina","Laterza","Latiano","Latina","Latisana","Latronico","Laureana di Borrello","Lauria","Lauro","Lavagna","Lavello","Lavena Ponte Tresa","Laveno-Mombello","Lavis","Lazise","Lazzaro","Le Castella","Lecce","Lecco","Leffe","Legnago","Legnano","Legnaro","Lendinara","Lenna","Lenno","Leno","Lenola","Lentate sul Seveso","Lentiai","Lentini","Leonessa","Leonforte","Leporano","Lercara Friddi","Lerici","Lerma","Lesa","Lesegno","Lesina","Lessona","Lestizza","Lettomanoppello","Lettopalena","Levane","Levanto","Levata","Leverano","Levico Terme","Lezzeno","Librizzi","Licata","Licciana Nardi","Lido","Lido","Lido di Camaiore","Lido di Ostia","Lierna","Lignano Sabbiadoro","Limana","Limatola","Limbiate","Limena","Limite","Limiti di Greccio","Limone Piemonte","Lingotto","Lioni","Lipari","Liscate","Lissone","Liveri","Livigno","Livinallongo del Col di Lana","Livorno","Livorno Ferraris","Lizzanello","Lizzano","Lizzola","Loano","Localita della Chiesa","Locate di Triulzi","Locati","Locorotondo","Locri","Lodi","Lodi Vecchio","Lograto","Loiano","Lomagna","Lomazzo","Lombardore","Lomello","Lonate Ceppino","Lonate Pozzolo","Lonato","Longare","Longarone","Longiano","Longobardi","Lonigo","Loreggia","Loreo","Loreto","Loreto Aprutino","Loria","Loro Ciuffenna","Loro Piceno","Lovere","Lozzo Atestino","Lozzo di Cadore","Luca","Lucca","Lucera","Luciana","Luciano","Lucino","Lucito","Luco dei Marsi","Lucugnano","Lugagnano","Lugnano","Lugnano in Teverina","Lugo","Luino","Lunamatrona","Lungavilla","Lungro","Lurago Marinone","Lurate Caccivio","Lustra","Lutago","Luzzano","Luzzi","Maccagno","Maccarese","Macello","Macerata","Macerata Campania","Macomer","Maddalena di Cazzano","Maddaloni","Maderno","Madignano","Madonna","Madonna di Campiglio","Maerne","Mafalda","Magenta","Maggio","Magione","Magliano","Magliano","Magliano Alpi","Magliano di Tenna","Magliano in Toscana","Magliano Sabina","Maglie","Magnago","Magno","Magreta","Maierato","Maiolati Spontini","Mairano","Malalbergo","Malcesine","Malcontenta","Maletto","Malgrate","Malnate","Malo","Malonno","Mals","Maltignano","Mammola","Mandas","Mandello del Lario","Manduria","Manerbio","Manfredonia","Maniago","Manocalzati","Manoppello","Manta","Mantova","Mantovana","Manzano","Manziana","Manzoni","Mapello","Maranello","Marano di Napoli","Marano Ticino","Marano Vicentino","Maratea","Marcallo con Casone","Marcaria","Marcellina","Marche","Marciana Marina","Marcianise","Marco","Marcon","Mareno di Piave","Mareo","Maresca","Margarita","Marghera","Margherita di Savoia","Mariae","Mariano","Mariano Comense","Mariglianella","Marigliano","Marignano","Marina","Marina di Andora","Marina di Campo","Marina di Carrara","Marina di Castagneto Carducci","Marina di Cerveteri","Marina di Ginosa","Marina di Gioiosa Ionica","Marina di Ragusa","Marineo","Marini","Marino","Marlia","Marmirolo","Marnate","Marola","Marone","Marostica","Marotta","Marrubiu","Marsala","Marsciano","Marsico Nuovo","Marta","Martano","Martellago","Martignacco","Martignano","Martina Franca","Martinengo","Martiniana Po","Martinsicuro","Martirano","Maruggio","Marzabotto","Marzano","Marzano di Nola","Mas","Masainas","Mascali","Mascalucia","Maser","Masera","Maserada sul Piave","Masi Torello","Maslianico","Mason","Massa","Massa","Massa","Massa","Massa e Cozzile","Massa Fiscaglia","Massa Lombarda","Massa Marittima","Massa Martana","Massafra","Massarosa","Masserano","Massignano","Masullas","Matelica","Matera","Mathi","Matino","Mauro","Mazara del Vallo","Mazzano Romano","Mazzarino","Mazzo di Valtellina","Meana Sardo","Meano","Meda","Mede","Medea","Medesano","Medicina","Medolago","Medole","Medolla","Meduna di Livenza","Mel","Melara","Meldola","Melegnano","Melendugno","Melfi","Melicucco","Melilli","Melissano","Melito di Porto Salvo","Melizzano","Melzo","Menaggio","Mendicino","Menfi","Mentana","Meolo","Meran","Merano","Merate","Mercatino Conca","Mercato","Mercato San Severino","Mercato Saraceno","Mercenasco","Mercogliano","Mereto di Tomba","Mergo","Mergozzo","Mesagne","Mesola","Mesoraca","Messina","Mestre","Mestrino","Meta","Metaponto","Mezzanego","Mezzano","Mezzocorona","Mezzolara","Mezzolombardo","Mezzomerico","Miglianico","Migliarino","Migliarino","Migliaro","Miglionico","Mignanego","Mignano Monte Lungo","Milan","Milanesi","Milano","Milano Marittima","Milazzo","Milena","Militello in Val di Catania","Militello Rosmarino","Millesimo","Milo","Mineo","Minerbe","Minerbio","Minervino di Lecce","Minervino Murge","Minori","Minturno","Mira","Mirabella","Mirabella Eclano","Mirabella Imbaccari","Mirabello","Mirabello Monferrato","Miradolo Terme","Mirandola","Mirano","Miravalle","Misano Adriatico","Misilmeri","Misinto","Missaglia","Misterbianco","Mistretta","Modena","Modica","Modigliana","Modugno","Moena","Moglia","Mogliano","Mogliano Veneto","Mogoro","Moiano","Moimacco","Moio della Civitella","Mojo Alcantara","Mola di Bari","Molazzana","Molfetta","Molinari","Molinella","Molino","Molise","Moliterno","Mombercelli","Momo","Monaco","Monasterace","Monastero","Monasterolo del Castello","Monastir","Moncalieri","Moncalvo","Mondavio","Mondolfo","Mondragone","Moneglia","Monfalcone","Monforte San Giorgio","Monghidoro","Mongrando","Moniga del Garda","Monopoli","Monreale","Monsampietro Morico","Monsampolo del Tronto","Monsano","Monselice","Monserrato","Monsummano Terme","Montafia","Montagnana","Montalbano","Montalbano Jonico","Montalcino","Montaldo","Montale","Montalenghe","Montalto delle Marche","Montalto di Castro","Montalto Dora","Montalto Uffugo","Montanara","Montanaro","Montanaso Lombardo","Montappone","Monte","Monte","Monte Castello di Vibio","Monte Compatri","Monte di Malo","Monte di Procida","Monte Giberto","Monte Porzio Catone","Monte Roberto","Monte San Giovanni Campano","Monte San Giusto","Monte San Pietro","Monte San Savino","Monte San Vito","Monte Urano","Monte Vidon Corrado","Montebello","Montebello Vicentino","Montebelluna","Montecalvoli","Montecarlo","Montecarotto","Montecassiano","Montecastrilli","Montecatini Terme","Montecchia di Crosara","Montecchio","Montecchio","Montecchio","Montecchio Emilia","Montecchio Maggiore","Montechiarugolo","Montecorice","Montecorvino Rovella","Montecosaro","Montefalcione","Montefano","Montefiascone","Montefiore Conca","Montefiorino","Monteforte Irpino","Montefortino","Montefranco","Montefredane","Montegaldella","Montegiorgio","Montegranaro","Montegrotto Terme","Monteiasi","Montelabbate","Montelanico","Montelepre","Montelparo","Montelupo Fiorentino","Montemaggiore al Metauro","Montemarano","Montemarciano","Montemassi","Montemiletto","Montemurlo","Montemurro","Montenero di Bisaccia","Montenerodomo","Monteodorisio","Montepaone","Montepiano","Monteprandone","Montepulciano","Montepulciano Stazione","Monterchi","Montereale","Montereale Valcellina","Monterenzio","Monteriggioni","Monteroduni","Monteroni di Lecce","Monterosi","Monterosso al Mare","Monterosso Calabro","Monterotondo","Monterubbiano","Montesano Salentino","Montesano sulla Marcellana","Montesarchio","Montescaglioso","Montescudo","Montese","Montesilvano Colle","Montespertoli","Montevago","Montevarchi","Monteveglio","Monteverde","Monteviale","Monticelli","Monticelli","Monticello","Monticello Conte Otto","Montichiari","Monticiano","Montignoso","Montodine","Montoggio","Montorio al Vomano","Montoro","Montorso Vicentino","Monza","Monzambano","Monzuno","Mora","Morano Calabro","Morbegno","Morciano di Leuca","Morciano di Romagna","Morcone","Mordano","Moretta","Morgano","Morgex","Mori","Moricone","Morlupo","Mornago","Morolo","Morozzo","Morrone","Morrovalle","Mortara","Mortegliano","Morter","Moscufo","Moso","Mossa","Motta di Livenza","Motta San Giovanni","Motta San Guglielmo","Motta Visconti","Mottafollone","Mottalciata","Mottola","Mozzagrogna","Mozzanica","Mozzate","Mozzecane","Muggia","Mugnano","Mugnano del Cardinale","Mulazzano","Murano","Muravera","Murlo","Muro Leccese","Muro Lucano","Muros","Musei","Musile di Piave","Mussomeli","Nanto","Naples","Narbolia","Narcao","Narni","Narni Scalo","Naro","Naturns","Natz-Schabs","Navacchio","Nave","Nave","Nazzano","Negrar","Neirone","Neive","Nembro","Nepi","Nereto","Nervesa della Battaglia","Nerviano","Nettuno","Neumarkt","Neviano","Neviano degli Arduini","Nichelino","Nicola","Nicolosi","Nicosia","Nicotera","Niederdorf","Nimis","Niscemi","Nizza di Sicilia","Nizza Monferrato","Noale","Nocciano","Nocelleto","Nocera Inferiore","Nocera Superiore","Nocera Terinese","Noceto","Noci","Nociglia","Nogara","Nogaredo al Torre","Nogarole Rocca","Noicattaro","Nola","Noli","Nonantola","None","Norcia","Norma","Notaresco","Noto","Nova Milanese","Nova Siri","Novafeltria","Novalesa","Novara","Novate Mezzola","Novate Milanese","Nove","Novellara","Novello","Noventa di Piave","Noventa Vicentina","Novi di Modena","Novi Ligure","Novi Velia","Novoli","Numana","Nuoro","Nurachi","Nurallao","Nuraminis","Nurri","Nusco","Nuvolento","Occhieppo Inferiore","Occhieppo Superiore","Occhiobello","Ocre","Oderzo","Offagna","Offanengo","Offida","Offlaga","Oggiono","Oglianico","Olbia","Oleggio","Olevano Romano","Olevano sul Tusciano","Olgiate Comasco","Olgiate Molgora","Olgiate Olona","Olginate","Oliena","Oliva","Oliveri","Oliveto","Oliveto Citra","Oliveto Lario","Olivetta","Olmedo","Omegna","Omignano","Opera","Oppeano","Oppido Lucano","Orani","Oratino","Orbassano","Orbetello","Orciano di Pesaro","Orgiano","Orgosolo","Oria","Origgio","Orio al Serio","Orio Litta","Oriolo Romano","Oristano","Ormea","Ormelle","Ornago","Ornavasso","Orosei","Orotelli","Orsenigo","Orsogna","Orta Nova","Orta San Giulio","Orte","Ortelle","Ortona","Ortonovo","Ortovero","Orvieto","Orzinuovi","Orzivecchi","Osiglia","Osimo","Osnago","Osoppo","Ospedaletti","Ospedaletto","Ospedaletto Euganeo","Ospedaletto-Expopisa","Ospitaletto","Ossago Lodigiano","Ossi","Ossona","Ostiano","Ostiglia","Ostigliano","Ostra","Ostra Vetere","Ostuni","Otranto","Otricoli","Ottaviano","Ottiglio","Oulx","Ovada","Ovaro","Ozegna","Ozieri","Ozzano Monferrato","Ozzero","Pace","Paceco","Pacentro","Pachino","Paciano","Paderno","Paderno Dugnano","Paderno Franciacorta","Paderno Ponchielli","Padua","Padula","Paesana","Paese","Pagani","Paganica","Pagazzano","Paglieta","Pago Veiano","Palagianello","Palagiano","Palagonia","Palaia","Palau","Palazzina","Palazzo","Palazzo","Palazzo Canavese","Palazzolo","Palazzolo Acreide","Palazzolo dello Stella","Palermo","Palestrina","Paliano","Palizzi Marina","Palladio","Pallanza-Intra-Suna","Pallanzeno","Pallerone","Palma Campania","Palma di Montechiaro","Palmanova","Palmariggi","Palmas Arborea","Palmi","Palo del Colle","Palombara Sabina","Palosco","Paluzza","Panaro","Pancalieri","Pandino","Panicale","Pannarano","Pantano","Pantigliate","Panzano","Paola","Parabiago","Parabita","Paratico","Parghelia","Parigi","Parma","Parre","Partanna","Partinico","Paruzzaro","Pasian di Prato","Passarella","Passetto","Passignano sul Trasimeno","Passirano","Passo","Passo Corese","Passo di Treia","Pastene","Pastrengo","Pasturo","Paterno","Paternopoli","Patrica","Patti","Pauli Arbarei","Paulilatino","Paullo","Pavia","Pavia di Udine","Pavona","Pavone Canavese","Pavullo nel Frignano","Peccioli","Pecetto","Pedara","Pedaso","Pedavena","Pedemonte","Pederobba","Peglio","Pegognaga","Pelago","Pellegrini","Pellegrino","Pellegrino Parmense","Pellestrina","Pellezzano","Pennabilli","Penne","Perdasdefogu","Perdaxius","Perdifumo","Perfugas","Pergine Valsugana","Pergola","Perignano","Perinaldo","Pernumia","Pero","Pero","Perosa Argentina","Pertengo","Perteole","Pertosa","Perugia","Pesaro","Pescantina","Pescara","Pescarolo ed Uniti","Peschici","Peschiera Borromeo","Peschiera del Garda","Pescia","Pescina","Pescocostanzo","Pessinetto","Pessione","Petacciato","Petilia Policastro","Petriano","Petritoli","Petrosino","Petruro","Pettinengo","Pettoranello del Molise","Pettorazza Grimani","Peveragno","Pezzana","Pezze di Greco","Piacenza","Piadena","Piaggine","Pian Camuno","Pian-Fossal","Piana","Piana degli Albanesi","Piancastagnaio","Piancogno","Piandimeleto","Piane Crati","Pianella","Pianella","Pianello Val Tidone","Pianezza","Pianezze","Piangipane","Pianiga","Piano","Piano","Piano di Coreglia-Ghivizzano","Piano di Sorrento","Piano-Vetrale","Pianoro","Piasco","Piateda","Piavon","Piazza","Piazza al Serchio","Piazza Armerina","Piazza Brembana","Piazza Roma","Piazzola sul Brenta","Picerno","Pico","Piedimonte Etneo","Piedimonte Matese","Piedimonte San Germano","Piegaro","Piemonte","Pieris","Pietra","Pietra Ligure","Pietrabbondante","Pietracuta","Pietrapaola","Pietraperzia","Pietrasanta","Pieve","Pieve","Pieve Albignola","Pieve del Cairo","Pieve di Cadore","Pieve di Cento","Pieve di Soligo","Pieve Fosciana","Pieve Ligure","Pieve San Giacomo","Pieve Vecchia","Pievebovigliana","Pievepelago","Piglio","Pignataro Interamna","Pignataro Maggiore","Pignola","Pignone","Pilcante","Pimonte","Pinarella","Pinerolo","Pineta","Pineto","Pinzano al Tagliamento","Pinzolo","Piobbico","Piobesi Torinese","Pioltello","Piombino","Piombino Dese","Pioraco","Piossasco","Piove di Sacco","Piovene Rocchette","Piraino","Pirri","Pisa","Pisciotta","Pisogne","Pisticci","Pistoia","Pistrino","Pitigliano","Piumazzo","Pizzighettone","Pizzo","Plan da Tieja","Ploaghe","Pocenia","Podenzana","Podenzano","Pofi","Poggiardo","Poggibonsi","Poggio","Poggio a Caiano","Poggio Berni","Poggio di Roio","Poggio Mirteto","Poggio Moiano","Poggio Nativo","Poggio Renatico","Poggio Rusco","Poggio San Lorenzo","Poggiomarino","Pogliano","Pogliano Milanese","Pogno","Poiana Maggiore","Poirino","Polesella","Polesine Parmense","Poli","Policoro","Polignano a Mare","Polinago","Polistena","Polla","Pollein","Pollenza","Pollica","Pollina","Polverara","Polverigi","Pomarance","Pombia","Pomezia","Pompei","Pompiano","Pomponesco","Poncarale","Ponsacco","Ponso","Pont","Pont-Canavese","Pont-Saint-Martin","Pontassieve","Ponte","Ponte","Ponte","Ponte a Evola","Ponte a Moriano","Ponte Basso","Ponte Buggianese","Ponte di Barbarano","Ponte di Piave","Ponte Galeria-La Pisana","Ponte Lambro","Ponte nelle Alpi","Ponte Nossa","Ponte San Giovanni","Ponte San Nicolo","Ponte San Pietro","Pontecagnano","Pontecchio","Pontecchio Polesine","Pontecorvo","Pontecurone","Pontedassio","Pontedera","Pontelongo","Pontenure","Pontestura","Pontevico","Ponti","Ponticelli","Pontida","Pontinia","Pontremoli","Ponza","Ponzano","Ponzano Veneto","Ponzone","Popoli","Poppi","Porano","Porcari","Porcia","Pordenone","Porlezza","Porpetto","Porretta Terme","Porta","Portici","Portico di Caserta","Porto","Porto","Porto Azzurro","Porto Empedocle","Porto Ercole","Porto Garibaldi","Porto Potenza Picena","Porto Recanati","Porto San Giorgio","Porto Tolle","Porto Torres","Porto Viro","Portoferraio","Portofino","Portogruaro","Portomaggiore","Portoscuso","Portovenere","Positano","Posta Fibreno","Posta Vecchia","Postiglione","Postioma","Potenza","Potenza Picena","Povegliano","Povegliano Veronese","Poviglio","Pozza di Fassa","Pozza-San Marco","Pozzallo","Pozzilli","Pozzo","Pozzo di Gotto","Pozzolengo","Pozzoleone","Pozzolo","Pozzolo Formigaro","Pozzonovo","Pozzuoli","Pozzuolo del Friuli","Prad am Stilfser Joch","Pradamano","Praia a Mare","Praiano","Pralormo","Pralungo","Pramaggiore","Prarolo","Prata","Prata Camportaccio","Prata di Pordenone","Prata Sannita","Prato","Prato Sesia","Pratola Peligna","Pratola Serra","Pratovecchio","Pravisdomini","Pray","Predazzo","Predore","Predosa","Preganziol","Premana","Premariacco","Premosello-Chiovenda","Presicce","Pressana","Pretoro","Prevalle","Prezza","Priolo Gargallo","Priverno","Prizzi","Procida","Provesano","Province of Messina","Puglianello","Pugliano","Puianello","Pula","Pulsano","Punta Marina","Putignano","Quadri","Quagliuzzo","Qualiano","Qualso","Quaregna","Quargnento","Quarona","Quarrata","Quart","Quarto","Quarto Inferiore","Quartucciu","Quattordio","Quattro Castella","Quero","Quiliano","Quindici","Quinto di Treviso","Quinto Vercellese","Quinto Vicentino","Quistello","Racale","Racalmuto","Racconigi","Radda in Chianti","Raffadali","Ragogna","Ragusa","Raiano","Raldon","Ramacca","Ramiseto","Ramon","Ramponio","Rancio Valcuvia","Randazzo","Ranieri","Rapagnano","Rapallo","Rapolla","Rassina","Ratschings","Ravanusa","Ravarino","Ravello","Ravenna","Ravi","Recale","Recanati","Recco","Recoaro Terme","Regalbuto","Reggello","Reggio Calabria","Reggiolo","Regina","Regina Margherita","Remanzacco","Renazzo","Rende","Reno","Resana","Rescaldina","Resia","Revello","Revere","Revigliasco","Revine","Rezzato","Rho","Riale","Riano","Ribera","Ribolla","Ricadi","Riccia","Riccione","Riccovolto","Riese Pio X","Riesi","Rieti","Rignano Flaminio","Rignano Garganico","Rimini","Rino","Rio Marina","Rio Saliceto","Riola Sardo","Riolo Terme","Riomaggiore","Rionero in Vulture","Ripa","Ripa Teatina","Ripa-Pozzi-Querceta-Ponterosso","Ripafratta-Farneta","Ripalta Cremasca","Riparbella","Ripatransone","Ripe","Ripe San Ginesio","Ripi","Ripoli","Riposto","Riva","Riva","Riva del Garda","Riva Ligure","Riva presso Chieri","Rivalba","Rivalta","Rivalta di Torino","Rivanazzano","Rivara","Rivarolo del Re ed Uniti","Rivarolo Ligure","Rivarolo Mantovano","Rivello","Rivergaro","Riviera","Rivignano","Rivodutri","Rivoli","Rizzi","Rizziconi","Roasio","Robassomero","Robbiate","Robbio","Robecchetto con Induno","Robecco sul Naviglio","Rocca","Rocca Canavese","Rocca di Papa","Rocca Massima","Rocca Priora","Rocca San Casciano","Roccabernarda","Roccabianca","Roccadaspide","Roccafranca","Roccalumera","Roccamonfina","Roccapiemonte","Roccarainola","Roccaromana","Roccasecca","Roccastrada","Roccavione","Roccavivara","Roccavivi","Roccella","Roccella Ionica","Rocchetta di Vara","Rocco","Rodano","Rodeneck-Rodengo","Rodi Garganico","Rodigo","Roggiano Gravina","Rogliano","Rognano","Roiano","Rolo","Romagnano Sesia","Romana","Romanengo","Romano Canavese","Romano di Lombardia","Rome","Romentino","Rometta","Roncade","Roncadelle","Roncalceci","Roncegno","Ronchi","Ronchi dei Legionari","Ronchis","Ronciglione","Ronco","Ronco Scrivia","Ronco-Chiesa","Roncoferraro","Roncone","Rondissone","Rosa","Rosate","Rosciano","Rose","Roseto Capo Spulico","Roseto degli Abruzzi","Roseto Valfortore","Rosignano Marittimo","Rosignano Solvay-Castiglioncello","Rosolina","Rosolini","Rossano","Rossano Veneto","Rossi","Rossiglione","Rota Greca","Rotella","Rotello","Rotondi","Rottofreno","Rovagnate","Rovato","Rovellasca","Rovello Porro","Roverbella","Rovere","Roveredo","Roveredo in Piano","Rovereto","Rovetta","Roviano","Rovigo","Rovito","Rozzano","Rubano","Rubbiano","Rubiana","Rubiera","Ruda","Rudiano","Ruffano","Rufina","Ruoti","Russi","Russo","Rutigliano","Ruviano","Ruvo di Puglia","Sabatino","Sabaudia","Sabbio Chiese","Sabbioneta","Sacco","Saccolongo","Sacile","Sacrofano","Sagrado","Saint-Pierre","Saint-Vincent","Sala Baganza","Sala Bolognese","Sala Consilina","Salara","Salassa","Sale","Sale Marasino","Salemi","Salento","Salerno","Saletto","Salice Salentino","Saliceto","Saline","Salmour","Salorno","Salsomaggiore Terme","Saltocchio","Saludecio","Saluggia","Saluzzo","Salvaterra","Salve","Salvirola","Salzano","Samarate","Samassi","Sambruson","Sambuceto","Sammichele di Bari","Samone","San Bartolomeo","San Bassano","San Benedetto dei Marsi","San Benedetto del Tronto","San Benedetto Po","San Benedetto Val di Sambro","San Benigno Canavese","San Bernardino","San Biagio","San Biagio di Callalta","San Bonifacio","San Carlo","San Carlo","San Casciano dei Bagni","San Casciano in Val di Pesa","San Cassiano","San Cataldo","San Cesareo","San Cesario di Lecce","San Cesario sul Panaro","San Chirico Raparo","San Cipirello","San Cipriano Picentino","San Colombano al Lambro","San Costanzo","San Daniele del Friuli","San Demetrio Corone","San Dona","San Donaci","San Donato","San Donato","San Donato di Lecce","San Donato Milanese","San Dorligo della Valle","San Fedele","San Felice Circeo","San Felice sul Panaro","San Ferdinando","San Ferdinando di Puglia","San Fili","San Filippo","San Filippo","San Fior","San Fiorano","San Francesco","San Francesco","San Francesco al Campo","San Fratello","San Gavino Monreale","San Gemini","San Genesio ed Uniti","San Gennaro Vesuviano","San Germano Vercellese","San Giacomo","San Giacomo degli Schiavoni","San Gillio","San Gimignano","San Ginesio","San Giorgio","San Giorgio","San Giorgio","San Giorgio","San Giorgio a Cremano","San Giorgio a Liri","San Giorgio Canavese","San Giorgio del Sannio","San Giorgio della Richinvelda","San Giorgio di Lomellina","San Giorgio di Nogaro","San Giorgio di Piano","San Giorgio in Bosco","San Giorgio Ionico","San Giorgio la Molara","San Giorgio Piacentino","San Giovanni","San Giovanni","San Giovanni","San Giovanni","San Giovanni a Piro","San Giovanni al Natisone","San Giovanni Bianco","San Giovanni Gemini","San Giovanni in Croce","San Giovanni in Fiore","San Giovanni in Marignano","San Giovanni in Persiceto","San Giovanni la Punta","San Giovanni Lupatoto","San Giovanni Rotondo","San Giovanni Suergiu","San Giovanni Valdarno","San Giuliano Milanese","San Giuliano Terme","San Giuseppe","San Giuseppe Jato","San Giuseppe Vesuviano","San Giustino","San Giusto Canavese","San Gregorio","San Gregorio","San Gregorio da Sassola","San Gregorio di Catania","San Lazzaro degli Armeni","San Lazzaro di Savena","San Leo","San Lorenzello","San Lorenzo","San Lorenzo","San Lorenzo","San Lorenzo al Mare","San Lorenzo del Vallo","San Lorenzo in Campo","San Lorenzo Isontino","San Luca","San Lucido","San Mango","San Mango Piemonte","San Marcello","San Marcello Pistoiese","San Marco","San Marco","San Marco Argentano","San Marco dei Cavoti","San Marco Evangelista","San Marco in Lamis","San Mariano","San Martino","San Martino","San Martino","San Martino","San Martino","San Martino al Tagliamento","San Martino Buon Albergo","San Martino Canavese","San Martino di Lupari","San Martino in Pensilis","San Martino in Rio","San Martino in Strada","San Martino Sannita","San Martino Siccomario","San Marzano di San Giuseppe","San Marzano sul Sarno","San Maurizio","San Maurizio Canavese","San Mauro","San Mauro Pascoli","San Mauro Torinese","San Michele al Tagliamento","San Michele Prazzo","San Michele Salentino","San Miniato","San Miniato Basso","San Nazario","San Niccolo","San Nicola","San Nicola","San Nicola Arcella","San Nicolo","San Pancrazio Salentino","San Paolo","San Pellegrino Terme","San Piero a Sieve","San Piero in Bagno","San Piero Patti","San Pietro","San Pietro","San Pietro","San Pietro","San Pietro","San Pietro a Maida","San Pietro di Cadore","San Pietro di Feletto","San Pietro in Casale","San Pietro in Gu","San Pietro in Lama","San Pietro Mosezzo","San Pietro Vernotico","San Pietro Viminario","San Polo","San Polo","San Polo di Piave","San Prisco","San Prospero","San Quirino","San Raineri","San Rocco","San Rufo","San Salvatore","San Salvatore","San Salvatore Monferrato","San Salvatore Telesino","San Salvo","San Sebastiano al Vesuvio","San Secondo","San Secondo Parmense","San Severino","San Severino Marche","San Severo","San Sisto","San Sossio Baronia","San Sosti","San Sperate","San Tammaro","San Teodoro","San Valentino Torio","San Venanzio","San Venanzo","San Vendemiano","San Vero Milis","San Vincenzo","San Vito","San Vito al Tagliamento","San Vito Chietino","San Vito dei Normanni","San Vito di Cadore","San Vito Lo Capo","San Vito Romano","San Vittore","San Zaccaria","San Zeno","San Zenone al Lambro","San Zenone al Po","San Zenone degli Ezzelini","Sand in Taufers","Sandigliano","Sandon","Sandrigo","Sangano","Sanguinetto","Sanluri","Sannicandro di Bari","Sannicandro Garganico","Sannicola","Sanremo","Sansepolcro","Sant Angelo","Santa Barbara","Santa Caterina dello Ionio","Santa Caterina Villarmosa","Santa Cristina","Santa Croce","Santa Croce Camerina","Santa Elisabetta","Santa Eufemia Lamezia","Santa Fiora","Santa Flavia","Santa Giuletta","Santa Giusta","Santa Giustina","Santa Giustina in Colle","Santa Lucia","Santa Lucia","Santa Lucia di Piave","Santa Margherita di Belice","Santa Margherita Ligure","Santa Maria","Santa Maria","Santa Maria","Santa Maria","Santa Maria","Santa Maria a Monte","Santa Maria a Vico","Santa Maria Capua Vetere","Santa Maria Codifiume","Santa Maria degli Angeli","Santa Maria di Licodia","Santa Maria di Sala","Santa Maria Imbaro","Santa Maria Nuova","Santa Marinella","Santa Ninfa","Santa Severa","Santa Sofia","Santa Teresa di Riva","Santa Teresa Gallura","Santa Venerina","Santa Vittoria di Libiola","Santa Vittoria in Matenano","Santadi","Santarcangelo di Romagna","Santeramo in Colle","Santi","Santi Cosma e Damiano","Santo Pietro","Santo Spirito","Santo Stefano","Santo Stefano al Mare","Santo Stefano Belbo","Santo Stefano di Briga","Santo Stefano di Cadore","Santo Stefano di Magra","Santo Stefano di Rogliano","Santo Stefano Quisquina","Santo Stefano Ticino","Santo Stino di Livenza","Santorso","Santu Lussurgiu","Saponara","Sapri","Sarcedo","Sarezzo","Sarmede","Sarnano","Sarnico","Sarno","Sarnthein","Saronno","Sarroch","Sarsina","Sarteano","Sartirana Lomellina","Sarzana","Sassa","Sassari","Sassello","Sassetta","Sassinoro","Sasso","Sasso Marconi","Sassoferrato","Sassuolo","Saturnia","Sava","Saviano","Savigliano","Savignano sul Panaro","Savignano sul Rubicone","Savio","Savona","Scafa","Scafati","Scala","Scaldasole","Scalea","Scalenghe","Scaletta Zanclea","Scandiano","Scandicci","Scanno","Scansano","Scanzano","Scanzano Jonico","Scarlino","Scarmagno","Scarperia","Scauri","Scerni","Schiavon","Schio","Schlanders","Sciacca","Scicli","Scilla","Scoppito","Scordia","Scorrano","Scuola","Seano","Seborga","Secondigliano","Sedegliano","Sedico","Sedilo","Sedriano","Segariu","Seglia San Bernardo","Segni","Segrate","Selargius","Selci","Selegas","Sella","Selva","Selvazzano Dentro","Selvino","Seminara","Senago","Senerchia","Seniga","Senigallia","Senise","Sennori","Seravezza","Seregno","Sergnano","Seriate","Serino","Serle","Sermide","Sermoneta","Sernaglia della Battaglia","Serra","Serra Pedace","Serra San Bruno","Serra San Quirico","Serracapriola","Serradifalco","Serraglio","Serramanna","Serramazzoni","Serramezzana","Serrano","Serrara Fontana","Serravalle Pistoiese","Serravalle Scrivia","Serravalle Sesia","Serre","Serrenti","Sersale","Servigliano","Sessa Aurunca","Sesto al Reghena","Sesto Calende","Sesto Fiorentino","Sesto San Giovanni","Sestri Levante","Sestriere","Sestu","Settimo","Settimo San Pietro","Settimo Torinese","Settimo Vittone","Seveso","Sexten","Sezze","Sgonico","Sgurgola","Siamaggiore","Siamanna","Siano","Siapiccia","Sibari","Sicignano degli Alburni","Siculiana","Siderno","Siena","Sigillo","Signa","Silanus","Silea","Siliqua","Sillavengo","Silvi","Silvi Paese","Simaxis","Simone","Sinalunga","Sindia","Siniscola","Sinnai","Sinopoli","Sirignano","Sirmione","Siziano","Sizzano","Soave","Soave","Soci","Sogliano Cavour","Solagna","Solarino","Solaro","Solarolo","Solarolo","Solato","Solbiate Arno","Solbiate Olona","Solda","Soldano","Soleminis","Solesino","Soleto","Soliera","Solignano Nuovo","Solofra","Solopaca","Solto Collina","Somma Lombardo","Somma Vesuviana","Sommacampagna","Sommariva del Bosco","Sommariva Perno","Sommatino","Sona","Soncino","Sondalo","Sondrio","Sonnino","Sora","Soragna","Sorbolo","Sordevolo","Soresina","Sorgono","Sori","Soriano nel Cimino","Sorisole","Sorrento","Sorso","Sortino","Sospiro","Sospirolo","Sossano","Sotto Castello","Sotto il Monte Giovanni XXIII","Sottomarina","Soverato Marina","Sovere","Soveria Mannelli","Sovicille","Spadafora","Sparanise","Sparone","Specchia","Spello","Sperlonga","Sperone","Spezzano Albanese","Spezzano della Sila","Spigno Saturnia","Spilamberto","Spilimbergo","Spin","Spina","Spinazzola","Spinea","Spineda","Spinete","Spineto","Spinetoli","Spinetta Marengo","Spirano","Spoleto","Spoltore","Spotorno","Spresiano","Squillace","Squinzano","Staffolo","Stagno","Stanghella","Staranzano","Statte","Stazione Castelguelfo","Stazione Ponte Rio","Stazzano","Stefania","Stella Cilento","Sterzing","Stezzano","Stia","Stienta","Stigliano","Stimigliano","Stornarella","Storo","Stra","Strada San Zeno","Stradella","Strambino","Stresa","Stretti","Strevi","Striano","Strigno","Strona","Stroncone","Strongoli","Stroppiana","Sturno","Suardi","Subbiano","Subiaco","Sulmona","Sulzano","Sumirago","Suno","Supino","Surbo","Susa","Susegana","Sutri","Sutrio","Suzzara","Syracuse","Taggia","Tagliacozzo","Taglio di Po","Taibon Agordino","Taino","Taio","Talsano","Taormina","Taranta Peligna","Tarantasca","Taranto","Tarcento","Tarquinia","Tarvisio","Tarzo","Tassullo","Taurano","Taurianova","Tavagnacco","Tavarnelle Val di Pesa","Tavarnuzze","Taverna","Tavernola Bergamasca","Taviano","Tavullia","Teggiano","Teglio","Teglio Veneto","Telese","Telgate","Tempio Pausania","Tenno","Teolo","Teramo","Terenten","Terenzo","Terlan","Terlizzi","Termeno","Termini Imerese","Termoli","Ternate","Terni","Terracina","Terralba","Terranova da Sibari","Terranuova Bracciolini","Terrarossa","Terrasini","Terricciola","Terruggia","Tertenia","Terzigno","Terzo","Terzorio","Tessera","Tezze sul Brenta","Thiene","Thiesi","Ticengo","Tina","Tione di Trento","Tirano","Tiriolo","Tirrenia","Tito","Tivoli","Toblach","Todi","Toffia","Toirano","Tolentino","Tolfa","Tollegno","Tolmezzo","Tolve","Tomba","Tombolo","Tonezza del Cimone","Torano Castello","Torchiarolo","Torella dei Lombardi","Torgiano","Torgnon","Toritto","Tornaco","Tornareccio","Toro","Torrazza","Torre","Torre","Torre a Mare","Torre Annunziata","Torre Boldone","Torre del Greco","Torre del Lago Puccini","Torre di Ruggiero","Torre Orsaia","Torre Pellice","Torre San Patrizio","Torre Santa Susanna","Torrebelvicino","Torrecuso","Torreglia","Torregrotta","Torrenova","Torretta","Torrevecchia Teatina","Torri","Torri del Benaco","Torri di Quartesolo","Torri in Sabina","Torriana","Torrice","Torricella","Torricella","Torrile","Torrita di Siena","Torrita Tiberina","Tortona","Tortora","Tortoreto","Torviscosa","Toscolano-Maderno","Tossicia","Trabia","Tradate","Tramonti","Tramutola","Trana","Trani","Transacqua","Traona","Trapani","Trappeto","Trasacco","Tratalias","Travagliato","Travedona Monate","Traversetolo","Travo","Trebaseleghe","Trebisacce","Trecastagni","Trecate","Trecenta","Tredozio","Treglio","Tregnago","Treia","Trento","Trentola-Ducenta","Trepuzzi","Trequanda","Tres","Trescore Balneario","Trescore Cremasco","Tresenda","Trevenzuolo","Trevi","Trevico","Treviglio","Trevignano","Trevignano Romano","Treviso","Trezzano Rosa","Trezzano sul Naviglio","Tribiano","Tricarico","Tricase","Tricesimo","Trichiana","Trieste","Triggianello","Triggiano","Trigolo","Trinitapoli","Trino","Trissino","Triuggio","Trivento","Trivero","Trivignano","Trivignano Udinese","Trofarello","Troia","Troina","Tromello","Tronzano Vercellese","Tropea","Trovo","Truccazzano","Tufino","Tuglie","Tuili","Tuoro sul Trasimeno","Turbigo","Turi","Turin","Turriaco","Tursi","Tusa","Tuscania","Udine","Ugento","Uggiate Trevano","Umbertide","Urbania","Urbino","Urbisaglia","Urgnano","Ururi","Uscio","Usellus","Usini","Usmate Velate","Ussana","Uta","Uzzano","Vacri","Vadena","Vado","Vado Ligure","Vaglia","Vaglio Basilicata","Vahrn","Vaiano","Vaiano Cremasco","Vailate","Vairano Patenora","Vajont","Valdagno","Valdengo","Valdieri","Valdobbiadene","Valduggia","Valeggio sul Mincio","Valentano","Valentina","Valenza","Valenzano","Valfabbrica","Valfenera","Valganna","Valguarnera Caropepe","Vallata","Valle","Valle","Valle","Valle Agricola","Valle di Cadore","Valle Lomellina","Valle Mosso","Vallecrosia","Vallefiorita","Vallerano","Valli del Pasubio","Vallo","Vallo della Lucania","Vallombrosa","Valmadrera","Valmontone","Valperga","Valverde","Vanzaghello","Vanzago","Varallo Pombia","Varallo Sesia","Varano","Varapodio","Varazze","Varedo","Varese","Varese Ligure","Varzo","Vas","Vasanello","Vascon","Vasto","Vattaro","Vecchiano-Nodica","Vedano Olona","Vedelago","Veglie","Velletri","Vellezzo Bellini","Vena di Maida","Venafro","Venaria Reale","Venarotta","Venaus","Venegono Inferiore","Venegono Superiore","Venetico","Veneto","Venice","Venosa","Ventimiglia","Ventimiglia di Sicilia","Venturina","Verbicaro","Vercelli","Vercurago","Verdellino","Verdello","Vergano-Villa","Vergato","Vergiate","Vermezzo","Vernate","Vernio","Vernole","Verolanuova","Verolavecchia","Verolengo","Veroli","Verona","Veronella","Verrone","Vertova","Verucchio","Verzuolo","Vescovana","Vescovato","Vespolate","Vestone","Vetralla","Vezzano Ligure","Vezzano sul Crostolo","Viadana","Viagrande","Viano","Viareggio","Vibo Valentia","Vicarello","Vicari","Vicchio","Vicenza","Vico Equense","Vicoforte","Vicolungo","Vicopisano","Vicovaro","Vidardo","Vidiciatico","Vidigulfo","Vieste","Vietri sul Mare","Vigarano Mainarda","Vigarano Pieve","Vigasio","Vigevano","Vigliano Biellese","Vignacastrisi","Vignale Monferrato","Vignanello","Vignate","Vignola","Vigo di Cadore","Vigo di Fassa","Vigo Rendena","Vigodarzere","Vigolo Vattaro","Vigolzone","Vigone","Vigonovo","Vigonza","Viguzzolo","Villa","Villa","Villa Bartolomea","Villa Basilica","Villa Castelli","Villa Cortese","Villa del Conte","Villa di Serio","Villa di Tirano","Villa Estense","Villa Faraldi","Villa Guardia","Villa Lagarina","Villa Literno","Villa Marina","Villa Minozzo","Villa Morelli","Villa Ottone","Villa San Giovanni","Villa San Pietro","Villa San Sebastiano","Villa Santa Lucia","Villa Verucchio","Villa Vicentina","Villabate","Villacidro","Villadose","Villafranca di Forli","Villafranca di Verona","Villafranca in Lunigiana","Villafranca Piemonte","Villafranca Tirrena","Villafrati","Villaggio","Villaggio Montegrappa","Villagrazia","Villalago","Villamagna","Villamar","Villamassargia","Villanova","Villanova","Villanova","Villanova del Ghebbo-Valdentro","Villanova Monferrato","Villanovafranca","Villanterio","Villanuova sul Clisi","Villapiana","Villaputzu","Villar","Villaricca","Villarosa","Villasalto","Villasanta","Villasmundo","Villasor","Villaspeciosa","Villastellone","Villastrada","Villaurbana","Villaverla","Villavesco","Ville","Villetta","Villetta","Vimercate","Vimodrone","Vinci","Viola","Virgilio","Viscone","Viserba","Visinale","Vistrorio","Viterbo","Vitigliano","Vitorchiano","Vittoria","Vittorio Veneto","Vittuone","Vitulano","Vitulazio","Vivaro","Vizzini","Vo","Vobarno","Voghenza","Voghera","Vogogna","Volano","Volla","Volpago del Montello","Volpedo","Volpiano","Volta Mantovana","Voltago","Volterra","Volturara Irpina","Volturino","Volvera","Welsberg-Taisten","Welschnofen","Zafferana Etnea","Zagarolo","Zambana","Zambrone","Zandobbio","Zanetti","Zangarona","Zanica","Zelarino","Zelo","Zelo Buon Persico","Zeme","Zerbo","Zerfaliu","Zermeghedo","Zero Branco","Zevio","Zibido San Giacomo","Zimella","Zimone","Zinasco","Zoagli","Zocca","Zogno","Zola Predosa","Zoldo Alto","Zollino","Zoppola","Zumaglia"],"Jamaica":["Black River","Browns Town","Gordon Town","Gregory Park","Kingston","Mandeville","May Pen","Moneague","Montego Bay","Negril","Ocho Rios","Old Harbour","Port Maria","Portland Cottage","Portmore","Runaway Bay","Spanish Town"],"Japan":["Abashiri","Abiko","Abira","Aboshiku-okinohama","Agano","Agena","Ageo","Aikawa","Aioi","Aisai","Aitsu","Aizu-Wakamatsu","Akao","Akasaka","Akasaka","Akasaki","Akashi","Akashi","Akeno","Aki","Akiruno-shi","Akishima","Akita","Ama-higashimachi","Amagasaki","Ami","Anabuki","Anan","Anesaki","Anjo","Annaka","Aoicho","Aomori","Arai","Arakawa","Ariake","Arida","Arita","Asahi","Asahi","Asahikawa","Asahimachi","Asaka","Ashihara","Ashikaga","Ashiya","Aso","Atami","Atsugi","Awara","Ayase","Azuchi","Azumino","Bakurocho","Bakurocho","Bandaicho","Bando","Beppu","Bibai","Budo","Chatan","Chiba","Chichibu","Chigasaki","Chiji","Chikusei","Chino","Chiran","Chiryu","Chita","Chitose","Choshi","Chuo","Daido","Daigo","Daimon","Daisen","Daitocho","Date","Ebetsu","Ebina","Ebisu","Echizen","Echizen","Edagawa","Edogawa-ku","Ena","Eniwa-shi","Esashi","Fuchu-machi","Fuchucho","Fuefuki-shi","Fuji","Fujieda","Fujiidera","Fujimi","Fujimino","Fujinomiya","Fujioka","Fujisato","Fujisawa","Fujita","Fukai","Fukayacho","Fukiage-fujimi","Fukuchi","Fukuchiyama","Fukuda","Fukui","Fukui-shi","Fukuoka","Fukuroi","Fukushima-shi","Fukuyama","Fumoto","Funabashi","Fushiki-minatomachi","Fushimi","Fussa","Futoo","Futtsu","Gamagori","Gannosu","Geinocho-mukumoto","Gifu","Ginowan","Ginza","Gobo","Godo","Gojo","Gosen","Goshogawara","Gotanda","Gotanda","Gotemba","Gotsucho","Goya","Gujo","Gundo","Gushikawa","Gyoda","Habikino","Hachiman-cho","Hachimantai","Hachimori","Hachinohe","Hadano","Haebaru","Hagi","Hagi","Haibara-akanedai","Haijima","Hakata","Hakodate","Hakone","Hakozaki","Hakui","Hama","Hamada","Hamamatsu","Hamana","Hamura","Hanabatacho","Hanamaki","Hanawadamachi","Handa","Hannan","Hanno","Hanyu","Harigaya","Hashima","Hashimoto","Hashimoto","Hasuda","Hatogaya-honcho","Hatoyama","Hatsukaichi","Hayama","Hayashi","Hayashima","Hayashino","Heiwajima","Hekinan","Hidaka","Hidakacho-ebara","Higashi-iwashiro","Higashi-takadama","Higashiasahimachi","Higashiboridori","Higashicho","Higashiiya-takano","Higashiiya-wakabayashi","Higashikawa","Higashimurayama-shi","Higashine","Higashiomi-shi","Higashiosaka","Higashiura","Higashiyama","Higashiyamato","Hiji","Hikari","Hikawa","Hiki","Hikone","Himeji","Himi","Hinata","Hino","Hino","Hinode","Hirakata","Hirakawa","Hiranuma","Hiratsuka","Hirokawa","Hirosaki","Hiroshima","Hita","Hitachi","Hitoyoshi","Hiyoshi","Hodogayacho","Hofu","Hojo","Hokota","Hokuto-shi","Hommachi","Honcho","Honcho","Honden","Hongo","Honjo","Honjo","Honjocho","Horinouchi","Horyuji","Hosobara","Hotei","Hyogo","Ibara","Ibaraki","Ichi","Ichibanhoridoricho","Ichihara","Ichikawa","Ichimura","Ichinogo","Ichinomiya","Ichinomiya","Ichinomiyacho","Ichinomotocho","Ichinoseki","Ida","Iida","Iiyama","Iizuka","Iju","Ikaruga","Ikeda","Ikedacho-itano","Ikejiri","Ikoma","Ikuno","Imabari-shi","Imabuku","Imagami","Imaicho","Imari","Imizucho","Ina","Inabe","Inage","Inagi-shi","Inami","Inami","Inashiki","Inazawa","Innoshima Hara-cho","Ino","Inuyama","Inzai","Iruma","Isahaya","Isawa","Ise","Isehara","Isesaki","Ishida","Ishigaki","Ishige","Ishii","Ishikari","Ishikawa","Ishikawa","Ishiki","Ishinomaki","Ishioka","Isomura","Isoya","Isumi","Itabashi","Itako","Itami","Itoi","Itoigawa","Itoman","Iwade","Iwaki","Iwakiri","Iwakuni","Iwakura","Iwamizawa","Iwanai","Iwanuma","Iwata","Iwatsuki","Izu","Izumi","Izumiotsu","Izumo","Izunokuni","Jissen","Joetsu","Jogo","Joshi","Joso","Jumonji","Kabe","Kadoma","Kaga","Kagawa","Kagoshima","Kagoya","Kahoku","Kahoku","Kaigandori","Kainan","Kaisei","Kaita","Kaizu","Kaizuka","Kakamigahara","Kakegawa","Kakogawa","Kakuda","Kamagaya-shi","Kamaishi","Kamakura","Kameda-honcho","Kameoka","Kameoka","Kameyama","Kami-kawakami","Kami-nagarekawacho","Kamibun","Kamigori","Kamikawa","Kamikita-kita","Kamimura","Kaminokawa","Kaminoyama","Kamirenjaku","Kamisu","Kamitosa","Kamo","Kamo","Kamogatacho-kamogata","Kamoi","Kanada","Kanagawa","Kanaya","Kanayama","Kanazawa","Kanda","Kanegasaki","Kani","Kanie","Kano","Kanomata","Kanuma","Kanzaki","Kanzaki","Karatsu","Kariya","Kariya","Kasai","Kasai","Kasama","Kasamatsucho","Kasaoka","Kaseda-shirakame","Kashiba","Kashihara","Kashima","Kashima-shi","Kashiwa","Kashiwagimachi","Kashiwara","Kashiwazaki","Kasuga","Kasugai","Kasukabe","Kasumicho","Kasumicho","Kasumigaseki","Kasumigaura","Kataoka","Katori-shi","Katsumada","Katsura","Katsuura","Katsuyama","Katta","Kawagoe","Kawaguchi","Kawahara","Kawanishi","Kawasaki","Kayano","Kazo","Kazuka","Kazuno","Kesennuma","Keta","Kichijoji-honcho","Kii-nagashimaku-nagashima","Kikuchi","Kikugawa","Kikyo","Kimitsu","Kinokawa","Kinoshita","Kiryu","Kisarazu","Kishiwada","Kita","Kita-sannomaru","Kitagata","Kitahiroshima","Kitaibaraki","Kitakami","Kitakata","Kitakyushu","Kitami","Kitamoto","Kitanagoya","Kitaozuma","Kitsuki","Kitsuregawa","Kiyama","Kiyokawa","Kiyose","Kiyosu","Kobe","Kobe","Kochi-shi","Kochino","Kocho","Kodaira","Kodamacho-kodamaminami","Kofu","Koga","Koga","Koganei","Kojima","Koka","Kokawa","Kokubu-matsuki","Kokubunji","Kokufu","Kokura","Kokuryo","Komaba","Komae-shi","Komagane","Komagawa","Komagome","Komaki","Komatsu","Komatsu","Komatsubara","Komatsushimacho","Komono","Komoro","Konan","Konancho-fukawa","Konosu","Koori","Koriyama","Koriyama","Koryocho-itazu","Kosai","Kose","Koshigaya","Koto","Kotohira","Kotoku","Koyama","Koyasan","Koyo","Koza","Kubo","Kudamatsu","Kugayama","Kukichuo","Kumagaya","Kumamoto","Kumano","Kunitachi","Kurami","Kurashiki","Kurayoshi","Kure","Kure","Kurihara","Kurihashi","Kurobeshin","Kurogi","Kuroishi","Kuroiwa","Kurume","Kusai","Kusatsu","Kuse","Kushimoto","Kushiro","Kusunoki","Kutchan","Kuwana-shi","Kyodo","Kyoritsu","Kyoto","Kyowa","Machi","Machi","Machi","Machi","Machida","Machiya","Maebaru","Maebashi","Maibara","Maizuru","Maki","Makinohara","Makuhari","Marugame","Marunouchi","Maruyama","Masaki","Mashiko","Masuda","Matsubara","Matsudo","Matsue-shi","Matsukawamachi","Matsumoto","Matsusaka","Matsuto","Matsuyama","Matsuyama","Matsuyama","Meguro","Meiji","Mibu","Midori","Miemachi","Mihama","Mihama","Mihara","Mihara","Miki","Mima","Mimasaka","Minabe","Minamata","Minami","Minami","Minamiaoyama","Minamiashigara","Minamiuonuma","Minato","Minato","Minatogawa","Minatomachi","Minatomachi","Mine","Mineyama","Mino","Mino","Minobu","Minokamo","Minoshima","Minowa","Misakicho","Misakimachi-konami","Misato","Misawa","Mishima","Mitai","Mitake","Mito-shi","Mitsucho-iwami","Mitsui","Mitsukaido","Mitsuke","Mitsushimacho-osaki","Miura","Miwa","Miyagi","Miyako","Miyakojima","Miyakonojo","Miyama","Miyata","Miyazaki-shi","Miyazu","Miyoshi","Miyoshi","Mizugama","Mizuko","Mizunami","Mizusawa","Mizushima-nishichidoricho","Mobara","Mochida","Moji","Mombetsu","Momoishi","Monzenmachi-igisu","Mooka","Mori","Moriguchi","Morioka","Moriya","Moriyama","Morodomitsu","Morohongo","Morowa","Motegi","Motomiya","Muikamachi","Muko","Murai","Murakami","Murata","Murayama","Muroran","Muroto-misakicho","Musa","Musashimurayama","Musashino","Mutsu","Mutsumi","Nabari","Nada","Naebocho","Nagahama","Nagano-shi","Naganohara","Nagao","Nagaoka","Nagaoka","Nagareyama","Nagasaki","Nagase","Nagashima","Nagato","Nagawado","Nago","Nagoya-shi","Naha","Naitobokujo","Naka","Nakada","Nakagawa","Nakagomi","Nakagusuku","Nakahai","Nakahata","Nakaichi","Nakama","Nakamura","Nakanishi","Nakano","Nakano","Nakano-kami","Nakanoshima","Nakanoshima","Nakatsu","Nakatsugawa","Nakayama","Nakazawa","Nakijin","Namerikawa","Nanae","Nanao","Nanto","Nara","Nara","Narashino-shi","Narita","Narutocho-mitsuishi","Nasa","Nasukarasuyama","Natori-shi","Natsumi","Nayoro","Nemuro","Nerima-ku","Neyagawa","Nichinan","Nihommatsu","Niigata","Niihama","Niimi","Niitsu","Niiza","Nikaho","Ninohe","Ninomiya","Nirasaki","Nishi","Nishi-Tokyo-shi","Nishihara","Nishikawa","Nishikicho","Nishiko","Nishimachi","Nishime","Nishinomiya","Nishio","Nishiwaki","Nishiyama","Nisshin","Nita","Nobeoka","Nobitome","Noboribetsu","Noda","Nodani","Nogata","Noguchi","Nomimachi","Nomura","None-mura","Nonoichi","Nose","Noshiro","Numazu","Nyuzen","Oarai","Obama","Obanazawa","Obari","Obayashi","Obihiro","Obu","Obuse","Ochiai","Ochiai","Ochikawa","Odaira","Odawara","Odori","Ogaki","Ogawa","Ogi","Ogori-shimogo","Oguni","Ogura","Ohara","Oiso","Oiwake","Oizu","Ojiya","Okawa","Okawachi","Okaya","Okayama","Okazaki","Okegawa","Okinawa","Okubo","Okuchi","Okuma","Okuura","Omachi","Omaezaki","Omagari","Ome","Omihachiman","Omiya","Omiya-ku","Omori","Omura","Omuta","Onna","Ono","Onoda","Onogawa","Onojo","Onomichi","Onuma","Osaka","Osaka","Osaki","Osawa","Oshima","Oshu","Ota","Otake","Otani","Otaru","Otawara","Otemachi","Otsukacho","Otsuki","Otsuku-kibi","owariasahi","Oyabe","Oyama","Oyama","Oyama","Oyamato","Ozu","Raiba","Rankoshi-cho","Rifu","Ritto","Roppongi","Ryugasaki","Ryuo","Sabae","Sado","Saga-shi","Sagae","Sagamihara-shi","Saidaiji-naka","Saijo","Saikai","Saiki","Saitama","Sakado","Sakae","Sakai","Sakaidecho","Sakaiminato","Sakata","Saku","Sakura","Sakura","Sakuracho","Sakurai","Sakurajima-koikecho","Sakurakabu","Sandacho","Sango","Sanjo","Sanmu","Sanno","Sannohe","Sano","Sanuki","Sapporo","Sarugakucho","Sasaguri","Sasayama","Sasebo","Satocho-sato","Satte","Sawara","Sayama","Sayama","Sayo","Seiro","Sekicho-furumaya","Senboku","Sendai","Sendai","Senju","Sennan","Senriyama","Senzoku","Seta","Setagaya-ku","Seto","Settsu","Shiba-Kaigandori","Shibadaimon","Shibata","Shibaura","Shibukawa","Shichibancho","Shijonawate","Shikamaku-miya","Shiki","Shima","Shimabara","Shimada","Shimizukoji","Shimizumachi","Shimo-iino","Shimoda","Shimogo","Shimomeguro","Shimonoseki","Shimotoda","Shimotsucho-kominami","Shimotsuke","Shin","Shin-shigai","Shinagawa","Shingu","Shingu","Shinjo","Shinjuku","Shinkawa","Shinmachi","Shinshiro","Shinshuku","Shinsuka","Shiobaru","Shiogama","Shiojiri","Shioya","Shirakawa-machi","Shiraoka","Shirayamamachi","Shiretoko","Shiroi","Shiroishi","Shiroishi","Shirokane","Shisui","Shitama","Shizukuishi","Shizunai-misono","Shizuoka","Shobara","Shobusawa","Shoinmachi-koji","Shonaicho","Showa","Shuchi","Sodegaura","Sogabe-minamijo","Soja","Soka","Sone","Sonobe","Subashiri","Suda","Suginomecho","Sugito","Sugiyama","Suigetsu","Suijo","Suita","Sukagawa","Sukumo","Sumidacho","Sumiyocho-kawauchi","Sumiyoshi","Sumiyoshi","Sumoto","Susaki","Susami","Susono","Suwa","Suzaka","Suzuka","Tachibana","Tadotsu","Taga","Taga","Tagajo-shi","Tagawa","Tahara","Taiji","Taiki","Tainoura","Tajimi","Tajiri","Takahama","Takahashi","Takaishi","Takaiwa","Takajo","Takajomachi","Takamatsu","Takamori","Takanawa","Takaoka","Takara","Takarazuka","Takasagocho-takasemachi","Takasaki","Takase","Takashima","Takashima","Takasu","Takata","Takatsuki","Takayama","Takedamachi","Takemiya","Takeo","Taketoyo","Takicho-oda","Takikawa","Takinogawa","Tama","Tamachi","Tamagawa","Tamana","Tamano","Tamashima","Tamatsukuri","Tamura","Tanabe","Tanaka","Taniyama-chuo","Tanushimarumachi-sugawara","Tashima","Tashiro","Tatebayashi","Tateyama","Tatsumi","Tatsuno","Tatsunocho-tominaga","Tawaramoto","Teine-ku","Temma","Tendo","Tennojicho-kita","Tenri","Toba","Tobata","Tobe","Tobo","Tochigi","Togane","Toge","Togitsu","Tokai","Tokamachi","Toki","Tokiwa","Tokiwamachi-tokiwa","Tokoname","Tokorozawa","Tokushima","Tokuyama","Tokyo","Tomakomai","Tomioka","Tomisato","Tomiya","Tomo","Tomobe","Tonami","Tondabayashi","Tone","Tono","Toranomon","Toride","Toshima Mura","Tosu","Totsukacho","Tottori-shi","Towada","Toyama-shi","Toyo","Toyoake","Toyoda","Toyohashi","Toyohira-ku","Toyokawa","Toyonaka","Toyonomachi-toyono","Toyooka","Toyota","Toyota","Tsu","Tsubame","Tsubata","Tsuchiara","Tsuchiura","Tsudanuma","Tsuhako","Tsukawaki","Tsukayama","Tsukuba","Tsukubamirai","Tsukumiura","Tsuru","Tsuruga","Tsurugashima","Tsurumi","Tsuruoka","Tsushima","Tsuyama","Ube","Uchimaru","Ueda, Nagano","Ueki","Ueno","Ueno-ebisumachi","Uenohara","Uji","Ujiie","Uki","Umeda","Uonuma","Uozu","Urasoe","Urayama","Urayasu","Ureshino","Uruma","Usa","Ushiku","Usuki","Utazu","Utsunomiya","Uwajima","Uwayama","Wadayama","Wajima","Wakamatsucho","Wakasa","Wakayama","Wakicho","Wakimachi","Wakkanai","Wako","Warabi-shi","Waseda","Watari","Yabase","Yabasehoncho","Yabu","Yabuki","Yachimata","Yachiyo","Yaese","Yahagi","Yahata","Yaita","Yaizu","Yakage","Yakuin-Horibata","Yakumo","Yamada","Yamadayu","Yamaga","Yamagata-shi","Yamaguchi","Yamakita","Yamanashi","Yamanashi","Yamano","Yamashitacho","Yamato-Takada","Yamatomachi","Yamatomachi-mitsuai","Yamauchi","Yamawaki","Yamazaki","Yamazakicho-nakabirose","Yanagawa","Yanagi","Yanai","Yano","Yanocho-futatsugi","Yao","Yashima","Yashio-shi","Yasu-shi","Yasuda","Yasugicho","Yatsushiro","Yawata","Yodogawa","Yoichi","Yokaichiba","Yokkaichi","Yokogawa","Yokohama","Yokoo","Yokosuka","Yokotemachi","Yomitan Son","Yomogita","Yonago","Yoneyamacho-nishino","Yonezawa","Yorii","Yorishimacho","Yoshida","Yoshida-kasugacho","Yoshii","Yoshikawa","Yoshimi","Yoshino","Yotsukaido","Youkaichi","Yubari","Yufutsu","Yugawara","Yuge","Yuki","Yukuhashi","Yunoshima","Yurihonjo","Yutaka","Yuzawa","Zama","Zushi"],"Kazakhstan":["Aksay","Aksoran","Almaty","Aqtas","Aqtau","Astana","Atyrau","Baikonur","Dostyk","Dzhezkazgan","Ekibastuz","Esil","Karagandy","Karagandy","Kazakh","Kentau","Koktem","Kostanay","Kyzyl","Kyzylorda","Lomonosovka","Oral","Pavlodar","Petropavl","Qaraghandy","Qaskeleng","Ridder","Rudnyy","Semey","Serebryansk","Shymkent","Sonaly","Stepnogorsk","Taldyk","Taldykorgan","Talghar","Taraz","Temirtau","Turkestan","Uritskiy","Ust-Kamenogorsk","Vostok","Zyryanovsk"],"Kenya":["Bondo","Chuka","Eldoret","Kabete","Kaiboi","Karatina","Kiambu","Kikuyu","Kisii","Kisumu","Kitale","Kitui","Machakos","Maseno","Mbita","Mombasa","Nairobi","Nakuru","Sawa Sawa","Siaya","Thika","Turbo","Wote"],"Kosovo":["Dunavo","Ferizaj","Mitrovica","Pristina","Prizren"],"Kuwait":["Abraq Khaytan","Ad Dasmah","Ad Dawhah","Al Ahmadi","Al Farwaniyah","Al Shamiya","Ar Rawdah","As Salimiyah","Ash Shu`aybah","Ash Shuwaykh","Bayan","Hawalli","Janub as Surrah","Kayfan","Kuwait City","Salwa"],"Laos":["Vientiane","Luang Prabang","Pakse","Savannakhet","Vang Vieng","Thakhek","Xieng Khouang","Phonsavan","Luang Namtha","Oudomxay","Sekong"],"Latvia":["Adazi","Agenskalns","Aizkraukle","Aizpute","Baldone","Balvi","Bauska","Brankas","Carnikava","Centrs","Daugavpils","Dobele","Durbe","Gulbene","Ilguciems","Izvalta","Jaunolaine","Jelgava","Kandava","Kolka","Lapmezciems","Liepa","Ludza","Madona","Malpils","Malta","Marupe","Mazsalaca","Ogre","Olaine","Ozolnieki","Pilsrundale","Priedkalne","Pure","Riga","Salaspils","Saldus","Sigulda","Smiltene","Stalgene","Talsi","Tukums","Valka","Valmiera","Varsava","Ventspils","Zasa","Zilupe"],"Lebanon":["Aaley","Adma","Ashrafiye","Baabda","Baalbek","Beirut","Broummana","Bsalim","Chekka","Dbaiye","Dik el Mehdi","Halba","Hboub","Sarba","Sidon","Tripoli","Yanar","Zgharta"],"Libya":["Benghazi","Misratah","Sabha","Tripoli","Zliten"],"Liechtenstein":["Balzers","Bendern","Eschen","Gamprin","Mauren","Nendeln","Planken","Ruggell","Schaan","Schaanwald","Schellenberg","Triesen","Triesenberg","Vaduz"],"Luxembourg":["Ahn","Alzingen","Bascharage","Beaufort","Beckerich","Beggen","Beidweiler","Belvaux","Berchem","Bereldange","Bergem","Bertrange","Bettembourg","Betzdorf","Bigonville","Bissen","Bivange","Bofferdange","Bonnevoie","Bourglinster","Bridel","Burmerange","Canach","Cap","Capellen","Colmar","Contern","Crauthem","Dalheim","Differdange","Dippach","Dudelange","Echternach","Ehnen","Ernster","Erpeldange-lez-Bous","Esch-sur-Alzette","Esch-sur-Sure","Ettelbruck","Foetz","Frisange","Godbrange","Goetzingen","Gonderange","Gosseldange","Gostingen","Grevenknapp","Grevenmacher","Grosbous","Hagen","Hautcharage","Heffingen","Heisdorf-sur-Alzette","Helmdange","Helmsange","Hersberg","Hesperange","Hobscheid","Hollerich","Holzem","Huncherange","Hunsdorf","Itzig","Junglinster","Kayl","Kehlen","Kleinbettingen","Koetschette","Lamadelaine","Larochette","Leudelange","Limpertsberg","Lintgen","Lorentzweiler","Luxembourg","Luxembourg-Kirchberg","Mamer","Medernach","Merl","Mersch","Mertert","Mondercange","Mondorf-les-Bains","Moutfort","Niedercorn","Noerdange","Nospelt","Oberanven","Oetrange","Olm","Pontpierre","Remerschen","Remich","Rodange","Roeser","Roodt-sur-Syre","Rumelange","Sandweiler","Sanem","Schieren","Schifflange","Schoos","Schouweiler","Schuttrange","Soleuvre","Steinfort","Steinsel","Strassen","Syren","Tetange","Tuntange","Uebersyren","Walferdange","Wasserbillig","Wolpert","Wormeldange"],"Macedonia":["Berovo","Bitola","Bogdanci","Cair","Debar","Delcevo","Demir Hisar","Gevgelija","Gostivar","Ilinden","Kadino","Kavadarci","Kicevo","Kumanovo","Labunista","Lisice","Makedonska Kamenica","Negotino","Novo Selo","Ohrid","Prilep","Pripor","Probistip","Radovis","Shtip","Skopje","Struga","Strumica","Tetovo","Veles"],"Madagascar":["Ambanja","Antananarivo","Antsirabe","Antsiranana","Fianarantsoa","Toamasina","Toliara"],"Malaysia":["Kuala Lumpur","George Town","Ipoh","Shah Alam","Petaling Jaya","Johor Bahru","Malacca City","Kota Kinabalu","Alor Setar","Kuala Terengganu","Seremban","Kuching","Miri"],"Malta":["Attard","Balzan","Bingemma","Birgu","Birkirkara","Bugibba","Cospicua","Dingli","Fgura","Floriana","Fontana","Ghajnsielem","Gharb","Ghasri","Ghaxaq","Gudja","Gzira","Hal Gharghur","Hamrun","Haz-Zebbug","Il-Madliena","Il-Pergla","Imsida","Imtarfa","Iz-Zebbiegh","Kirkop","L-Iklin","L-Iskorvit","Lija","Luqa","Manikata","Marsa","Marsalforn","Marsaskala","Marsaxlokk","Mdina","Mellieha","Mosta","Mqabba","Munxar","Nadur","Naxxar","Paola","Pembroke","Qormi","Qrendi","Rabat","Safi","Saint John","Saint Lawrence","Saint Lucia","Saint Venera","San Pawl il-Bahar","Sannat","Senglea","Siggiewi","Sliema","Swieqi","Tarxien","Valletta","Victoria","Xaghra","Xewkija","Zabbar","Zejtun","Zurrieq"],"Martinique":["Case-Pilote","Ducos","Fort-de-France","Le Carbet","Le Diamant","Le Francois","Le Gros-Morne","Le Lamentin","Le Morne-Rouge","Le Robert","Les Trois-Ilets","Riviere-Salee","Saint-Esprit","Saint-Joseph","Sainte-Anne","Sainte-Luce","Sainte-Marie","Schoelcher"],"Mauritius":["Beau Bassin","Chemin Grenier","Ebene CyberCity","Floreal","Goodlands","Le Reduit","Port Louis","Port Mathurin","Quatre Bornes","Rose Hill","Saint Jean","Tamarin","Vacoas"],"Mayotte":["Bandaboa","Chiconi","Combani","Dzaoudzi","Dzoumonye","Koungou","Mamoudzou","Ouangani","Pamandzi","Sada","Tsingoni","Tsoundzou 1"],"Mexico":["Abasolo","Acambaro","Acambay","Acapulco","Acatic","Acatlan de Perez Figueroa","Acatzingo de Hidalgo","Acolman","Actopan","Acuna","Adolfo Lopez Mateos","Adolfo Ruiz Cortines","Agua Amarga","Agua Azul","Agua Dulce","Agua Prieta","Aguascalientes","Ahome","Ahualulco de Mercado","Ajijic","Alamo","Alamos","Aldama","Allende","Almada","Almoloya","Altamira","Altotonga","Alvaro Obregon Borough","Amado Nervo","Ameca","Amecameca de Juarez","Anahuac","Anahuac","Angamacutiro de la Union","Apan","Apaseo el Alto","Apaseo el Grande","Apatzingan","Apaxco de Ocampo","Apizaco","Apodaca","Arandas","Arcelia","Arizpe","Arriaga","Asuncion Ixtaltepec","Asuncion Nochixtlan","Atequiza","Atizapan","Atlacholoaya","Atlacomulco","Atlatlahucan","Atlixco","Atlzayanca","Atotonilco el Alto","Atoyac de Alvarez","Autlan de Navarro","Autopista Puebla Orizaba 185 (La Condusa)","Axochiapan","Azcapotzalco","Azteca","Badiraguato","Bahia de Kino","Baja California","Balancan de Dominguez","Bamoa","Banderas del Aguila","Banderilla","Barra de Navidad","Barranca de Santa Clara","Barrio de Mexico","Benito Juarez","Benito Juarez","Benito Juarez","Benito Juarez (Santa Elena)","Berriozabal","Boca del Rio","Brisas Barra de Suchiate","Bucerias","Cabo San Lucas","Cabos","Cadereyta","Cadereyta de Montes","Cadereyta Jimenez","Cajeme","Cajititlan","Camargo","Campeche","Campestre Tarimbaro","Cananea","Canatlan","Candelaria","Cardenas","Cardonal","Catemaco","Cazones de Herrera","Celaya","Centro","Centro","Cerritos","Chalco de Diaz Covarrubias","Chapala","Chetumal","Chiapa de Corzo","Chiapas","Chiautempan","Chiautla","Chicago","Chiconcuac","Chignahuapan","Chihuahua","Chihuahua","Chihuahua","Chilpancingo","Cholula","Ciudad Ayala","Ciudad Constitucion","Ciudad de Huajuapam de Leon","Ciudad de Villa de Alvarez","Ciudad del Carmen","Ciudad Hidalgo","Ciudad Lopez Mateos","Ciudad Madero","Ciudad Mendoza","Ciudad Nezahualcoyotl","Ciudad Sabinas","Ciudad Sahagun","Ciudad Valles","Ciudad Victoria","Coacalco","Coahuila","Coatepec","Coatzacoalcos","Coatzintla","Cocoyoc","Cocula","Colima","Colimas","Colon","Colonia","Colonia Benito Juarez","Colonia Cuauhtemoc","Colonia de Venado","Colonia Emiliano Zapata (Ejido Santiago Temoaya)","Colonia Guerrero (Los Guajes)","Colonia Hidalgo","Colonia la Presa (Ejido de Chapultepec)","Colonia Lopez Nelio (Las Palmas)","Colonia Madero (Madero)","Colonia Mexico","Colonia Miguel Aleman Valdez","Colonia Veracruz","Comalcalco","Compostela","Corregidora","Cortazar","Cosamaloapan de Carpio","Cosoleacaque","Coyoacan","Coyuca de Catalan","Cuajimalpa","Cuarta Brigada","Cuauhtemoc","Cuauhtemoc","Cuauhtemoc","Cuautepec","Cuautepec de Hinojosa","Cuautitlan","Cuautla","Cuautlancingo","Cuernavaca","Cuitlahuac","Cunduacan","Cutzamala de Pinzon","Cuyoaco","Dolores Hidalgo Cuna de la Independencia Nacional","Durango","Ecatepec de Morelos","Ejido de Otumba (Loma Bonita)","Ejido Distrito Federal","Ejido Santa Maria Tianguistenco (Ejido el Rosario)","El Alto Culiacan","El Carmen","El Colli","El Fuerte de Montes Claros","El Grullo","El Leon","El Mirador","El Ocotito","El Parque","El Potrero","El Rio","El Sabinal (San Pedro)","El Salto","El Salto","El Sauz","El Tecuan","El Torreon","Emiliano Zapata","Emiliano Zapata","Empalme","Ensenada","Epazoyucan","Erongaricuaro","Escobedo","Escobedo","Escondida de lo Verde","Escuinapa de Hidalgo","Escuintla","Estado de Mexico","Estados Unidos","Ex-Hacienda Pantitlan","Ezequiel Montes","Florida","Fortin de las Flores","Fraccionamiento Iberica Calimaya","Francisco Castellanos","Francisco I. Madero","Fresnillo","Frontera","Garcia","Garza Garcia","General Escobedo","General Teran","Gomez Palacio","Graciano Sanchez","Granjas","Guadalajara","Guadalajara","Guadalupe","Guadalupe","Guadalupe","Guadalupe","Guadalupe Victoria","Guadalupito","Guamuchil","Guanajuato","Guasave","Guaymas","Gueramaro","Gustavo A. Madero Borough","Gutierrez Zamora","Hermosillo","Heroica Alvarado","Heroica Caborca","Heroica Coscomatepec de Bravo","Heroica Matamoros","Heroica Zitacuaro","Huandacareo","Huanimaro","Huatabampo","Huauchinango","Huehuetoca","Huejotzingo","Huejucar","Huichapan","Huimanguillo","Huimilpan","Huixquilucan","Huixtla","Hunucma","Iglesia Vieja","Ignacio Allende","Iguala de la Independencia","Insurgentes","Irapuato","Isla Holbox","Isla Mujeres","Ixmiquilpan","Ixtapa","Ixtapa","Ixtapa-Zihuatanejo","Ixtapaluca","Ixtapan de la Sal","Ixtlahuaca de Villada","Ixtlahuacan del Rio","Ixtlan del Rio","Izamal","Iztacalco","Iztapalapa","Izucar de Matamoros","Jacobo","Jacona de Plancarte","Jala","Jalapa","Jalisco","Jalostotitlan","Jalpa","Jaltipan de Morelos","Jalupa","Jaumave","Jerez de Garcia Salinas","Jesus Carranza","Jesus del Monte","Jesus Maria","Jesus Maria","Jilotepec","Jimenez","Jimenez","Jiquilpan de Juarez","Jiquipilco","Jiutepec","Jocotepec","Jocotitlan","Jojutla","Jonacatepec de Leandro Valle","Jose Cardel","Juan","Juarez","Juarez","Juarez","Juarez","Kanasin","Kilometro 32 Texcoco Lecheria","La Barca","La Canada","La Ciudad","La Cruz","La Florida","La Habana","La Herradura","La Isla","La Joya","La Moncada","La Paletena","La Paz","La Piedad","La Pista de Tizayuca","La Reforma","La Tapachula","La Union","La Victoria","Lagos de Moreno","Laredo","Las Americas","Las Cabanas (Colinas de los Angeles)","Las Canoras (Altiva)","Las Choapas","Las Delicias","Las Delicias","Leon","Lerdo","Lerma","Leyva Solano","Libramiento Leon-Salamanca","Libres","Linares","Loma de los Cavazos (Maria de la Luz)","Loreto","Loreto","Los Garzas","Los Mochis","Los Reyes","Los Reyes","Los Reyes de Salgado","Los Sabinos","Luvianos","Macuspana","Madero","Magdalena de Kino","Magdalena Petlacalco","Magiscatzin","Malinalco","Manuel Avila Camacho","Manzanillo","Mariano Matamoros","Marquelia","Martinez de la Torre","Mazatecochco","Mazatepec","Mazatlan","Medellin de Bravo","Melchor","Melchor Muzquiz","Mendoza","Mexicali","Mexico City","Mextepec","Mier","Miguel Aleman","Miguel Hidalgo","Mina Mexico","Mineral","Mineral de la Reforma","Mineral del Chico","Mineral del Monte","Mixquiahuala de Juarez","Moctezuma","Monclova","Monclova","Monte Leon","Montemorelos","Monterrey","Monterrey","Morelia","Morelos","Morelos","Morelos","Moroleon","Motozintla de Mendoza","Muna","Nacozari Viejo","Naucalpan","Navojoa","Navolato","Netzahualcoyotl","Nextlalpan","Nicolas Romero","Nogales","Noxtepec de Zaragoza (El Aguacate)","Nueva Italia de Ruiz","Nuevo Casas Grandes","Nuevo Coahuila","Nuevo Ideal","Nuevo Laredo","Nuevo Leon","Oaxaca","Oaxtepec","Ocotlan","Ocoyoacac","Ocozocoautla de Espinosa","Ojinaga","Ojo de Agua","Ojuelos de Jalisco","Orizaba","Oxkutzkab","Pabellon","Pabellon de Arteaga","Pachuca","Pachuca de Soto","Panotla","Pantanal","Paraiso","Paraje Nuevo","Parral","Paseos de Tecamac","Paso Real","Pastor Ortiz","Patzcuaro","Pedregal de Jerico","Pedro Escobedo","Pedro Meoqui","Pericos","Perote","Pesqueria","Petaquillas","Petatlan","Pichucalco","Piedras Negras","Piedras Negras","Playa del Carmen","Polanco","Poncitlan","Poza Rica Chacas","Poza Rica de Hidalgo","Primero de Mayo","Progreso","Prolongacion Avenida Mexico Norte","Puebla","Pueblo Hidalgo","Pueblo Juarez (La Magdalena)","Pueblo Viejo","Pueblo Yaqui","Puente de Ixtla","Puente Grande","Puerto Escondido","Puerto Mexico","Puerto Morelos","Puerto Vallarta","Purisima de Bustos","Purisima del Zapote","Puruandiro","Queseria","Quintana Roo","Quintana Roo","Quiroga","Ramos Arizpe","Rancho Xalnene","Rayon","Rayon","Reforma (Madrigal 2da. Seccion)","Refractarios Guadalajara","Reyes de Vallarta","Reynosa","Rincon de Tamayo","Rio Blanco","Rio Bravo","Roma","Rosarito","Sahuayo de Morelos","Salamanca","Salina Cruz","Salinas de Hidalgo","Saltillo","Salvatierra","San Agustin","San Agustin (Salvador Alvarado)","San Agustin Altamirano","San Agustin Tlaxiaca","San Andres Cholula","San Andres Tuxtla","San Angel Inn","San Antonio","San Antonio la Isla","San Antonio Virreyes","San Bernardo","San Cristobal","San Cristobal","San Felipe","San Felipe Torres Mochas [Ganaderia]","San Fernando","San Fernando","San Francisco","San Francisco","San Francisco Javier","San Gabriel","San Jeronimo de Juarez","San Jose del Valle","San Jose Iturbide","San Juan","San Juan","San Juan Bautista Tuxtla","San Juan de Aragon","San Juan del Rio","San Luis","San Luis","San Luis de la Paz","San Luis Soyatlan","San Martin de Camargo","San Martin Duraznos","San Martin Hidalgo","San Martin Notario","San Martin Texmelucan de Labastida","San Mateo","San Mateo Atenco","San Mateo Mexicaltzingo","San Miguel","San Miguel","San Miguel Balderas","San Miguel de Allende","San Miguel de Atotonilco","San Miguel de Cozumel","San Miguel de Papasquiaro","San Miguel el Alto","San Miguel el Alto (El Puerto)","San Miguel Zinacantepec","San Nicolas","San Nicolas","San Nicolas","San Nicolas Totolapan","San Pablo Hidalgo","San Patricio","San Pedro","San Pedro","San Pedro","San Pedro Cholula","San Pedro de Las Colonias","San Pedro de Nolasco","San Pedro Piedra Gorda","San Pedro Pochutla","San Rafael","San Salvador Atenco","San Salvador Huixcolotla","San Salvador Tzompantepec","San Sebastian el Grande","San Sebastian Tutla","San Sebastian Xhala","San Simon de Guerrero","San Vicente","San Vicente Chicoloapan","Santa Anita","Santa Apolonia","Santa Catalina","Santa Catarina","Santa Catarina Juquila","Santa Fe","Santa Isabel Tlanepantla","Santa Lucia","Santa Maria Chimalhuacan","Santiago","Santiago de Queretaro","Santiago Ixcuintla","Santiago Tianguistenco","Satelite","Seccion Primera Santiago Tetla","Selene","Sierra Madre","Silao","Sinaloa de Leyva","Sombrerete","Sonora","Soto la Marina","Suchiapa","Tabasco","Tablon Grande (Bombas de Apaxco)","Tacambaro de Codallos","Tacotalpa","Tala","Tamaulipas","Tamazula de Gordiano","Tampico","Tampico Alto","Tangancicuaro de Arista","Tapachula","Tapalpa","Taxco","Teapa","Tecalitlan","Tecamachalco","Tecate","Tecax","Tecoman","Tecuala","Tejupilco de Hidalgo","Tekoh","Teloloapan","Temascalcingo","Temascaltepec de Gonzalez","Temixco","Tenamaxtlan","Tenancingo de Degollado","Tenosique de Pino Suarez","Teoloyucan","Teotihuacan de Arista","Tepalcatepec","Tepeaca","Tepeapulco","Tepeji de Ocampo","Tepetlacolco","Tepetlapa","Tepic","Tepotzotlan","Tepoztlan","Tequila","Tequisistlan","Tequisquiapan","Tequixquiac","Texcoco","Tezonapa","Tezontepec","Tezontepec de Aldama","Tezoyuca","Tezoyuca","Tierra Blanca","Tierra Colorada","Tijuana","Tilzapotla","Tirindaro","Tizapan el Alto","Tlacolula de Matamoros","Tlacotalpan","Tlahuac","Tlahuelilpan","Tlajomulco de Zuniga","Tlalmanalco de Velazquez","Tlalnepantla","Tlalnepantla","Tlalpan","Tlaltizapan","Tlanalapa","Tlapa de Comonfort","Tlapacoyan","Tlaquepaque","Tlaquiltenango","Tlatlauquitepec","Tlatlaya","Tlaxcala","Tlaxcalancingo","Tocatlan","Tocumbo","Todos Santos","Tolcayuca","Toluca","Tonala","Tonala","Tonatico","Topolobampo","Tula de Allende","Tulancingo","Tultepec","Tultitlan","Tulum","Tuxpan","Tuxpan","Tuxpan de Rodriguez Cano","Tuxtla","Uman","Union de Tula","Ures","Uriangato","Ursulo Galvan","Uruapan","Valladolid","Valle de Bravo","Valle de Santiago","Valle Hermoso","Valles","Venustiano Carranza","Venustiano Carranza","Veracruz","Vicente Guerrero","Vicente Guerrero","Victoria","Victoria","Villa Cuauhtemoc Otzolotepec","Villa de Almoloya de Juarez","Villa de Costa Rica","Villa Garcia","Villa Hidalgo","Villa Nanchital","Villadiego","Villagran","Villahermosa","Visitacion","Vistahermosa de Negrete","Xalapa","Xalisco","Xochimilco","Xochimilco","Xochitepec","Xonacatlan","Yanga","Yautepec","Yecapixtla","Yucatan","Yurecuaro","Yuriria","Zacapoaxtla","Zacapu","Zacatecas","Zacatelco","Zacatepec","Zacatlan","Zacualpan","Zacualpan","Zacualtipan","Zamora","Zapopan","Zapotitlan de Vadillo","Zapotlan de Juarez","Zapotlanejo","Zapotlanejo","Zaragoza","Zinapecuaro","Zitlala","Zongolica","Zumpango"],"Mongolia":["Altai","Arvayheer","Baruun-Urt","Bayangol","Bayanhongor","Cecerleg","Chihertey","Choyr","Dalandzadgad","Darhan","Han-Uul","Javhlant","Khovd","Mandalgovi","Ovoot","Saynshand","Toyrim","Ulaan-Uul","Ulan Bator","Uliastay","Undurkhaan"],"Montenegro":["Budva","Crna Gora","Herceg Novi","Igalo","Kotor","Niksic","Pljevlja","Podgorica","Stari Bar","Ulcinj"],"Morocco":["Afourer","Agadir","Ait Melloul","Al Hoceima","Assa","Benguerir","Beni Mellal","Berrechid","Casablanca","Deroua","El Gara","El Hajeb","El Jadida","Erfoud","Fes","Fkih Ben Salah","Kenitra","Khemisset","Khouribga","Ksar el Kebir","Larache","Mansour","Marrakesh","Mehediyah","Meknes","Mohammedia","Nador","Ouazzane","Oued Zem","Oujda","Oulad Teima","Rabat","Safi","Sefrou","Settat","Sidi Bennour","Sidi Slimane","Skhirat","Tahala","Tan-Tan","Tangier","Tarfaya","Taza","Temara","Tiflet","Tiznit","Touissite"],"Mozambique":["Beira","Maputo","Matola","Mozambique","Nampula","Pemba","Quelimane","Tete"],"Myanmar":["Nay Pyi Taw","Yangon","Mandalay","Taunggyi","Sittwe","Mawlamyine","Pathein","Hpa-An","Myitkyina","Loikaw","Magway","Sagaing","Hakha","Dawei","Bago","Kengtung"],"Namibia":["Etunda","Grootfontein","Katima Mulilo","Keetmanshoop","Mpapuka","Olympia","Ondangwa","Ongwediva","Oranjemund","Oshakati","Otjiwarongo","Outapi","Swakopmund","Tsumeb","Walvis Bay","Windhoek"],"Nepal":["Bharatpur","Jawlakhel","Kathmandu","Lumbini","Palpa","Patan"],"Netherlands":["Aagtekerke","Aalburg","Aalden","Aalsmeer","Aalsmeerderbrug","Aalst","Aalten","Aardenburg","Abbekerk","Abbenes","Abcoude","Achterberg","Achterveld","Achthuizen","Achtmaal","Aduard","Aerdenhout","Aerdt","Afferden","Akersloot","Akkrum","Albergen","Alblasserdam","Alde Leie","Alem","Alkmaar","Almelo","Almere","Almere Haven","Almkerk","Alphen","Alphen aan den Rijn","Ameide","America","Amerongen","Amersfoort","Ammerstol","Ammerzoden","Amstelhoek","Amstelveen","Amstenrade","Amsterdam","Anderen","Andijk","Ane","Angeren","Anjum","Ankeveen","Anloo","Anna Paulowna","Annen","Apeldoorn","Appelscha","Appeltern","Appingedam","Arcen","Arkel","Arnemuiden","Arnhem","Asperen","Assen","Assendelft","Asten","Augustinusga","Avenhorn","Axel","Baambrugge","Baarland","Baarle-Nassau","Baarlo","Baarn","Baars","Babberich","Badhoevedorp","Baexem","Bakel","Baken","Bakhuizen","Balgoij","Balk","Ballum","Banholt","Barchem","Barendrecht","Barneveld","Batenburg","Bathmen","Bavel","Bedum","Beegden","Beek","Beek","Beek","Beekbergen","Beerta","Beerzerveld","Beesd","Beesel","Beets","Beetsterzwaag","Beilen","Beinsdorp","Belfeld","Bellingwolde","Bemelen","Bemmel","Beneden-Leeuwen","Bennebroek","Bennekom","Benningbroek","Benthuizen","Berg","Berg en Dal","Bergambacht","Bergeijk","Bergen","Bergen","Bergen op Zoom","Bergentheim","Bergharen","Berghem","Bergschenhoek","Beringe","Berkenwoude","Berkhout","Berlicum","Best","Beugen","Beuningen","Beusichem","Beverwijk","Biddinghuizen","Bierum","Biervliet","Biest","Bilthoven","Bitgum","Bladel","Blaricum","Bleiswijk","Blerick","Bleskensgraaf","Blitterswijck","Bloemendaal","Blokker","Blokzijl","Bocholtz","Bodegraven","Boeicop","Boekel","Boelenslaan","Boerakker","Boesingheliede","Bolsward","Borculo","Borger","Born","Borne","Borsele","Bosch en Duin","Boskoop","Bosschenhoofd","Bourtange","Boven-Hardinxveld","Boven-Leeuwen","Bovenkarspel","Bovensmilde","Boxmeer","Boxtel","Brakel","Breda","Bredevoort","Breezand","Breskens","Breugel","Breukelen","Breukeleveen","Brielle","Briltil","Britsum","Broek in Waterland","Broek op Langedijk","Broekhin","Broekhuizen","Brouwershaven","Bruchem","Brucht","Bruinisse","Brummen","Brunssum","Buchten","Budel","Budel-Dorplein","Budel-Schoot","Buinerveen","Buitenkaag","Buitenpost","Bunde","Bunnik","Bunschoten","Buren","Buren","Burgerveen","Burgum","Burgwerd","Burum","Bussum","Buurse","Cadier en Keer","Cadzand","Callantsoog","Capelle aan den IJssel","Castricum","Centrum","Chaam","Clinge","Coevorden","Colijnsplaat","Colmschate","Craailo","Cromvoirt","Cruquius","Cuijk","Culemborg","Daarle","Dalen","Dalfsen","Damwald","De Bilt","De Blesse","De Cocksdorp","De Falom","De Glind","De Goorn","De Hoef","De Horst","De Klomp","De Koog","De Kwakel","De Lier","De Lutte","De Meern","De Moer","De Punt","De Rijp","De Steeg","De Waal","De Westereen","De Wijk","De Wilp","De Zilk","Dedemsvaart","Deest","Delden","Delden","Delfgauw","Delft","Delfzijl","Den Bommel","Den Burg","Den Deijl","Den Dolder","Den Dungen","Den Helder","Den Hoorn","Den Hout","Den Ilp","Den Oever","Denekamp","Deurne","Deventer","Didam","Diemen","Diepenheim","Diepenveen","Dieren","Diessen","Dieteren","Diever","Dijk","Dinteloord","Dinxperlo","Dirkshorn","Dirksland","Dodewaard","Doenrade","Doesburg","Doetinchem","Dokkum","Domburg","Dongen","Doorn","Doornenburg","Doornspijk","Doorwerth","Dordrecht","Dorp","Dorst","Drachten","Drempt","Dreumel","Driebergen","Driebruggen","Driehuis","Driel","Driemond","Drogeham","Dronryp","Dronten","Drunen","Druten","Duin","Duiven","Duivendrecht","Dwingeloo","Earnewald","Echt","Echten","Echtenerbrug","Eckart","Edam","Ede","Ederveen","Eede","Eefde","Eelde-Paterswolde","Eelderwolde","Eemnes","Eenrum","Eerbeek","Eersel","Eethen","Eext","Eexterzandvoort","Egchel","Egmond aan Zee","Egmond-Binnen","Eibergen","Eijsden","Eindhoven","Einighausen","Elburg","Ell","Ellecom","Elsendorp","Elsloo","Elst","Elst","Emmeloord","Emmen","Emmer-Compascuum","Emst","Engelen","Enkhuizen","Ens","Enschede","Enschot","Enspijk","Enter","Enumatil","Epe","Epen","Epse","Erica","Erichem","Erm","Ermelo","Erp","Escharen","Espel","Etten","Everdingen","Ewijk","Exloo","Eygelshoven","Eys","Ezinge","Farmsum","Feanwalden","Ferwert","Fijnaart","Finsterwolde","Fleringen","Fluitenberg","Flushing","Foxhol","Franeker","Frederiksoord","Gaanderen","Galder","Gameren","Gapinge","Garderen","Garmerwolde","Garsthuizen","Garyp","Gasselte","Gasselternijveen","Geertruidenberg","Geervliet","Gees","Geesteren","Geesteren","Geldermalsen","Geldrop","Geleen","Gelselaar","Gemeente Rotterdam","Gemert","Gemonde","Genderen","Gendringen","Gendt","Genemuiden","Gennep","Giesbeek","Giessenburg","Giessendam","Gieten","Gieterveen","Giethoorn","Gilze","Glimmen","Goes","Goirle","Goor","Gorinchem","Gorredijk","Gorssel","Gouda","Gouderak","Goudswaard","Goutum","Gramsbergen","Grashoek","Grathem","Grave","Greup","Grijpskerk","Groeningen","Groenlo","Groenveld","Groesbeek","Groessen","Groet","Groningen","Gronsveld","Groot-Agelo","Groot-Ammers","Grootebroek","Grootegast","Grou","Grubbenvorst","Gulpen","Guttecoven","Gytsjerk","Haaften","Haaksbergen","Haalderen","Haamstede","Haaren","Haarle","Haarlem","Haarlemmerliede","Haelen","Halfweg","Halle","Hallum","Halsteren","Hank","Hantum","Hantumhuizen","Hapert","Haps","Hardenberg","Harderwijk","Haren","Haren","Harich","Harkema","Harkstede","Harlingen","Harmelen","Hartwerd","Hasselt","Hattem","Haule","Haulerwijk","Hauwert","Havelte","Hazerswoude-Dorp","Hazerswoude-Rijndijk","Hedel","Hedel","Heeg","Heelsum","Heemskerk","Heemstede","Heenvliet","Heerde","Heerenveen","Heerhugowaard","Heerjansdam","Heerle","Heerlen","Heesch","Heeswijk","Heeswijk-Dinther","Heeten","Heeze","Heijen","Heijningen","Heikant","Heilig Landstichting","Heiloo","Heinenoord","Heino","Hekelingen","Helden","Helenaveen","Hellendoorn","Hellevoetsluis","Hellouw","Helmond","Helvoirt","Hem","Hemelum","Hendrik-Ido-Ambacht","Hengelo","Hengelo","Hengevelde","Hennaard","Hensbroek","Herbaijum","Herkenbosch","Herkingen","Hernen","Herpen","Herten","Herveld","Herwijnen","Heteren","Heukelum","Heusden","Heveadorp","Heythuysen","Hierden","Hijken","Hillegom","Hilvarenbeek","Hilversum","Hindeloopen","Hippolytushoef","Hoedekenskerke","Hoek","Hoek van Holland","Hoenderloo","Hoensbroek","Hoevelaken","Hoge Donk","Hollandsche Rading","Hollandscheveld","Hollum","Holten","Holthees","Holthone","Holtum","Holwierde","Homoet","Honselersdijk","Hoofddorp","Hoofdplaat","Hoogblokland","Hooge Zwaluwe","Hoogeloon","Hoogerheide","Hoogersmilde","Hoogeveen","Hoogezand","Hooghalen","Hoogkarspel","Hoogkerk","Hoogland","Hooglanderveen","Hoogmade","Hoogvliet","Hoogwoud","Hoorn","Hoorn","Hoornaar","Horn","Horst","Hout","Houtakker","Houten","Huijbergen","Huis ter Heide","Huissen","Huizen","Hulsberg","Hulshorst","Hulst","Hummelo","Hurdegaryp","IJhorst","IJlst","IJmuiden","IJsselmuiden","IJsselstein","IJzendijke","IJzendoorn","Ilpendam","Ingelum","Ingen","Ittervoort","Jabeek","Jisp","Joppe","Joure","Jubbega","Julianadorp","Jutrijp","Kaag","Kaatsheuvel","Kalenberg","Kamerik","Kampen","Kamperland","Kantens","Kapelle","Kats","Katwijk","Katwijk aan Zee","Katwoude","Keijenborg","Kekerdom","Keldonk","Kerk-Avezaath","Kerkdriel","Kerkenveld","Kerkrade","Kessel","Kesteren","Kimswerd","Kinderdijk","Klaaswaal","Klazienaveen","Klimmen","Kloetinge","Kloosterhaar","Klundert","Kockengen","Koedijk","Koekange","Koewacht","Kolham","Kolhorn","Kollum","Kommerzijl","Koog aan de Zaan","Kootstertille","Kootwijkerbroek","Kortenhoef","Kortgene","Koudekerk aan den Rijn","Koudekerke","Koudum","Kraggenburg","Krimpen aan de Lek","Krimpen aan den IJssel","Krommenie","Kropswolde","Kruiningen","Kruisland","Kudelstaart","Kuitaart","Kwintsheul","Laag-Soeren","Lage Mierde","Lage Zwaluwe","Landsmeer","Langedijk","Langezwaag","Laren","Lathum","Leek","Leerdam","Leersum","Leeuwarden","Legemeer","Leiden","Leiderdorp","Leidschendam","Leimuiden","Lekkerkerk","Lelystad","Lemele","Lemelerveld","Lemiers","Lemmer","Lent","Lettele","Leusden","Leuth","Lewenborg","Lexmond","Lichtenvoorde","Liempde","Lienden","Lienden","Lies","Lieshout","Liessel","Lievelde","Lijnden","Limbricht","Limmel","Limmen","Linne","Linschoten","Lippenhuizen","Lisse","Lithoijen","Lobith","Lochem","Loenen","Loon op Zand","Loosdrecht","Loozen","Lopik","Loppersum","Losser","Lottum","Lunteren","Lutjebroek","Lutjewinkel","Lutten","Luyksgestel","Maarheeze","Maarn","Maarssen","Maarssenbroek","Maartensdijk","Maasbommel","Maasbracht","Maasbree","Maasdam","Maasdijk","Maashees","Maaskantje","Maasland","Maassluis","Maastricht","Made","Makkum","Malden","Manderveen","Margraten","Marienberg","Markelo","Marknesse","Marrum","Marum","Mastenbroek","Maurik","Mechelen","Medemblik","Meeden","Meer","Meerkerk","Meerlo","Meerssen","Meeuwen","Megchelen","Meijel","Melick","Meppel","Merkelbeek","Merselo","Middelbeers","Middelburg","Middelharnis","Middenbeemster","Middenmeer","Midlum","Mierlo","Mijdrecht","Mijnsheerenland","Mildam","Milheeze","Mill","Millingen","Millingen aan de Rijn","Milsbeek","Moerdijk","Moergestel","Moerkapelle","Molenaarsgraaf","Molenhoek","Molenhoek","Molenschot","Monnickendam","Monster","Montfoort","Montfort","Mook","Mookhoek","Moordrecht","Mortel","Muiden","Muiderberg","Munstergeleen","Muntendam","Mussel","Naaldwijk","Naarden","Nederasselt","Nederhemert","Nederhorst den Berg","Nederweert","Neede","Neer","Neer-Andel","Nes","Netterden","Nibbixwoud","Nieuw-Amsterdam","Nieuw-Balinge","Nieuw-Beijerland","Nieuw-Bergen","Nieuw-Buinen","Nieuw-Dordrecht","Nieuw-Lekkerland","Nieuw-Namen","Nieuw-Schoonebeek","Nieuw-Vennep","Nieuw-Vossemeer","Nieuwdorp","Nieuwe Pekela","Nieuwe Wetering","Nieuwe-Niedorp","Nieuwe-Tonge","Nieuwegein","Nieuwehorne","Nieuwendijk","Nieuwer-Ter-Aa","Nieuwerbrug","Nieuwerkerk aan den IJssel","Nieuweschoot","Nieuwkoop","Nieuwkuijk","Nieuwlande","Nieuwleusen","Nieuwolda","Nieuwpoort","Nieuwstadt","Nieuwveen","Nigtevecht","Nijbroek","Nijhuizum","Nijkerk","Nijkerkerveen","Nijland","Nijmegen","Nijnsel","Nijverdal","Nistelrode","Noardburgum","Noorbeek","Noord-Scharwoude","Noord-Sleen","Noordbroek","Noordeloos","Noorden","Noordgouwe","Noordhorn","Noordlaren","Noordscheschut","Noordwelle","Noordwijk aan Zee","Noordwijk-Binnen","Noordwijkerhout","Noordwolde","Nootdorp","Norg","Nuenen","Nuis","Nuland","Numansdorp","Nunhem","Nunspeet","Nuth","Obbicht","Obdam","Ochten","Odijk","Oeffelt","Oegstgeest","Oene","Oijen","Oirsbeek","Oirschot","Oisterwijk","Oldeberkoop","Oldebroek","Oldeholtpade","Oldehove","Oldekerk","Oldemarkt","Oldenzaal","Olst","Ommen","Onnen","Ooij","Ooltgensplaat","Oost-Souburg","Oostburg","Oostendam","Oosterbeek","Oosterbierum","Oosterend","Oosterhesselen","Oosterhout","Oosterland","Oosternijkerk","Oosterwolde","Oosterwolde","Oosterzee","Oosthuizen","Oostkapelle","Oostvoorne","Oostwold","Oostwoud","Oostzaan","Ootmarsum","Op den Bosch","Opeinde","Ophemert","Opheusden","Opmeer","Oranje","Oranjewoud","Ospel","Oss","Ossendrecht","Oterleek","Otterlo","Ottersum","Oud-Ade","Oud-Alblas","Oud-Beijerland","Oud-Gastel","Oud-Zuilen","Ouddorp","Oude Pekela","Oude Wetering","Oude-Tonge","Oudega","Oudehaske","Oudehorne","Oudelande","Oudemirdum","Oudemolen","Oudenbosch","Oudendijk","Ouderkerk aan de Amstel","Oudeschild","Oudesluis","Oudewater","Oudkarspel","Oudorp","Oudwoude","Overasselt","Overberg","Overdinkel","Overloon","Overveen","Ovezande","Palemig","Pannerden","Panningen","Papekop","Papendrecht","Partij","Paterswolde","Peize","Pernis","Petten","Philippine","Piershil","Pieterburen","Pieterzijl","Pijnacker","Pingjum","Plasmolen","Poeldijk","Poortugaal","Poortvliet","Posterholt","Princenhof","Prinsenbeek","Puiflijk","Purmerend","Purmerland","Puth","Putte","Putten","Puttershoek","Raalte","Raamsdonksveer","Randwijk","Ravenstein","Ravenswoud","Reeuwijk","Rekken","Renesse","Renkum","Renswoude","Ressen","Retranchement","Reusel","Reuver","Rheden","Rhenen","Rhenoy","Rhoon","Ridderkerk","Riethoven","Rietveld","Rijckholt","Rijen","Rijkevoort","Rijnsburg","Rijpwetering","Rijsbergen","Rijsenhout","Rijssen","Rijswijk","Rijswijk","Rilland","Rinsumageast","Rips","Rivierenwijk","Rixtel","Rockanje","Roden","Rodenrijs","Roelofarendsveen","Roermond","Roggel","Rolde","Roodeschool","Roosendaal","Roosteren","Rooth","Rosmalen","Rossum","Rossum","Rotterdam","Rottum","Rottum","Rozenburg","Rozenburg","Rozendaal","Rucphen","Ruinen","Ruinerwold","Rutten","Ruurlo","s-Heerenberg","Saasveld","Sambeek","Santpoort-Noord","Sappemeer","Sas van Gent","Sassenheim","Schagen","Schagerbrug","Schaijk","Schalkhaar","Scharmer","Scheemda","Schellinkhout","Schermerhorn","Scherpenisse","Scherpenzeel","Schiedam","Schiermonnikoog","Schijndel","Schildwolde","Schimmert","Schin op Geul","Schinnen","Schinveld","Schipborg","Schipluiden","Schoondijke","Schoonebeek","Schoonhoven","Schoorl","Schore","Sellingen","Serooskerke","Sevenum","Sibculo","Siddeburen","Siebengewald","Silvolde","Simpelveld","Sint Agatha","Sint Annaland","Sint Annaparochie","Sint Anthonis","Sint Hubert","Sint Jansteen","Sint Joost","Sint Maarten","Sint Maartensdijk","Sint Nicolaasga","Sint Odilienberg","Sint Pancras","Sint Philipsland","Sint Willebrord","Sint-Michielsgestel","Sint-Oedenrode","Sintjohannesga","Sittard","Slagharen","Sleen","Sleeuwijk","Slenaken","Sliedrecht","Slijk-Ewijk","Slochteren","Slootdorp","Sloterdijk","Sluis","Sluiskil","Smilde","Sneek","Soerendonk","Soest","Soesterberg","Someren","Sommelsdijk","Son en Breugel","Spaarndam","Spakenburg","Spanbroek","Spaubeek","Spierdijk","Spijk","Spijkenisse","Sprang","Sprundel","Stadskanaal","Stampersgat","Staphorst","Stationsbuurt","Stedum","Steenbergen","Steensel","Steenwijk","Steggerda","Steijl","Stein","Stellendam","Sterksel","Stevensbeek","Stevensweert","Stiens","Stolwijk","Stompetoren","Stompwijk","Stoutenburg","Strijen","Strijensas","Stroe","Stuifzand","Sumar","Surhuisterveen","Surhuizum","Susteren","Suwald","Swalmen","Sweikhuizen","Swifterbant","Taarlo","Tegelen","Ten Boer","Ten Post","Ter Aar","Ter Apel","Ter Apelkanaal","Terblijt","Terborg","Terheijden","Terneuzen","Terschuur","Teteringen","The Hague","Tholen","Tiel","Tienhoven","Tienraij","Tijnje","Tilburg","Tilligte","Tinte","Tjerkwerd","Tolbert","Toldijk","Tolkamer","Tricht","Tubbergen","Tuitjenhorn","Tull","Tweede Exloermond","Tweede Valthermond","Twello","Twijzelerheide","Twisk","Tynaarlo","Tytsjerk","Tzummarum","Uddel","Uden","Udenhout","Ugchelen","Uitdam","Uitgeest","Uithoorn","Uithuizen","Uithuizermeeden","Uitwellingerga","Ulestraten","Ulft","Ulicoten","Ulrum","Ulvenhout","Ureterp","Urk","Urmond","Ursem","Utrecht","Vaals","Vaassen","Valburg","Valkenburg","Valkenburg","Valkenswaard","Valthe","Valthermond","Varik","Varsseveld","Vasse","Veen","Veendam","Veenendaal","Veenhuizen","Veenoord","Veghel","Velddriel","Velden","Veldhoven","Velp","Velsen","Velsen-Noord","Ven-Zelderheide","Venhorst","Venhuizen","Venlo","Venray","Vianen","Vierhouten","Vierlingsbeek","Vierpolders","Vijfhuizen","Vilt","Vinkeveen","Vlaardingen","Vlagtwedde","Vledder","Vleuten","Vlieland","Vlijmen","Vlodrop","Voerendaal","Vogelenzang","Vogelwaarde","Volendam","Volkel","Voorburg","Voorhout","Voorschoten","Voorst","Voorthuizen","Vorden","Vorstenbosch","Vortum-Mullem","Vragender","Vreeland","Vries","Vriezenveen","Vroomshoop","Vrouwenpolder","Vught","Vuren","Waalre","Waalwijk","Waardenburg","Waarder","Waarland","Waddinxveen","Wagenberg","Wagenborgen","Wageningen","Walterswald","Wamel","Wanroij","Wanssum","Wapenveld","Warder","Warffum","Warmenhuizen","Warmond","Warnsveld","Waspik","Wassenaar","Wateringen","Waterland","Weerselo","Weert","Weesp","Wehl","Weidum","Well","Wellerlooi","Wemeldinge","Werkendam","Werkhoven","Wervershoof","Wessem","West-Knollendam","West-Terschelling","Westbeemster","Westbroek","Westdorpe","Westerbork","Westerhaar-Vriezenveensewijk","Westerhoven","Westervoort","Westerwijtwerd","Westkapelle","Westmaas","Westzaan","Weurt","Wezep","Wierden","Wieringerwaard","Wieringerwerf","Wierum","Wijchen","Wijckel","Wijdenes","Wijdewormer","Wijhe","Wijk aan Zee","Wijk bij Duurstede","Wijlre","Wijnaldum","Wijnandsrade","Wijngaarden","Wijster","Wildervank","Willemstad","Wilnis","Wilp","Winkel","Winschoten","Winssen","Winsum","Wintelre","Winterswijk","Wissenkerke","Witharen","Wittem","Witteveen","Woensdrecht","Woerden","Woerdense Verlaat","Wognum","Wolfheze","Wolphaartsdijk","Woltersum","Wolvega","Wommels","Wons","Workum","Wormer","Wormerveer","Woubrugge","Woudenberg","Woudrichem","Woudsend","Wouwsche Plantage","Yde","Yerseke","Ysbrechtum","Zaamslag","Zaandam","Zaandijk","Zaanstad","Zalk","Zaltbommel","Zandeweer","Zandvoort","Zeddam","Zeeland","Zeerijp","Zeewolde","Zeist","Zelhem","Zetten","Zevenaar","Zevenbergen","Zevenbergschen Hoek","Zevenhoven","Zevenhuizen","Zierikzee","Zieuwent","Zijderveld","Zoetermeer","Zoeterwoude","Zonnemaire","Zorgvlied","Zoutelande","Zoutkamp","Zuid-Beijerland","Zuid-Scharwoude","Zuidbroek","Zuidermeer","Zuiderpark","Zuidhorn","Zuidland","Zuidlaren","Zuidoostbeemster","Zuidwolde","Zuidzande","Zuilichem","Zundert","Zutphen","Zwaag","Zwaagdijk-Oost","Zwaanshoek","Zwanenburg","Zwartebroek","Zwartemeer","Zwartewaal","Zwartsluis","Zwijndrecht","Zwinderen","Zwolle"],"New Caledonia":["Dumbea","Mont-Dore","Noumea","Nouville","Paita"],"New Zealand":["Ahaura","Albany","Amberley","Ashhurst","Auckland","Avondale","Awanui","Balclutha","Balfour","Beachlands","Belmont","Bethlehem","Blackburn","Bombay","Brightwater","Browns Bay","Bulls","Campbells Bay","Cashmere Hills","Cave","Cheviot","Christchurch","Clarks","Clevedon","Clinton","Clive","Clyde","Coalgate","Coatesville","Collingwood","Colville","Coromandel","Darfield","Dargaville","Douglas","Doyleston","Drury","Dunedin","Duvauchelle","East Tamaki","Eastbourne","Edendale","Eltham","Fairlie","Favona","Foxton","Foxton Beach","Franz Josef","Gisborne","Glen Eden","Glenbrook","Greenhithe","Greerton","Greymouth","Haast","Halswell","Hamilton","Hastings","Havelock North","Hawarden","Hawera","Herne Bay","Hikuai","Hokitika","Howick","Hunterville","Invercargill","Johnsonville","Kaeo","Kaiata","Kaikoura","Kaitangata","Kaiwaka","Kaiwharawhara","Kamo","Karamea","Katikati","Kawakawa","Kawerau","Kawhia","Kerikeri","Khandallah","Kimbolton","Kirwee","Kohukohu","Kumeu","Kurow","Lake Tekapo","Leamington","Leeston","Levels","Levin","Lincoln","Linwood","Longburn","Lower Hutt","Lumsden","Mangaroa","Mangawhai Heads","Mangere","Mangonui","Manukau","Manukau","Manunui","Marua","Masterton","Matakana","Maungatapere","Maungaturoto","Menzies Ferry","Methven","Milton","Mission Bay","Moerewa","Mosgiel","Mossburn","Mount Maunganui","Murupara","Myross Bush","Napier City","Nelson","New Plymouth","Ngaio","Ngatea","North Shore","Northcote Point","Northland","Oakura","Oamaru","Oban","Ohaupo","Ohura","Okaiawa","Okaihau","Okato","Onga Onga","Opaheke","Opotiki","Opunake","Orakei","Oratia","Orewa","Otaki","Otaki Beach","Otane","Otautau","Otematata","Otorohanga","Oturehua","Outram","Owaka","Oxford","Paekakariki","Paeroa","Paihia","Pakuranga","Palmerston North","Panmure","Papakura","Papamoa","Paradise","Paraparaumu","Paraparaumu Beach","Paremata","Parnell","Penrose","Petone","Piopio","Pirongia","Pleasant Point","Pokeno","Ponsonby","Porangahau","Porirua","Port Chalmers","Portland","Puhoi","Pukeatua","Punakaiki","Queenstown","Raglan","Rakaia","Rakaia Gorge","Ranfurly","Red Beach","Renwick","Reporoa","Riverhead","Riversdale","Riverton","Rolleston","Rotherham","Rotorua","Ruawai","Russell","Saint Heliers","Sawyers Bay","Sefton","Silverdale","Springs Junction","Stanmore Bay","Swanson","Tahoraiti","Takaka","Takanini","Takapau","Takapuna","Tamahere","Taradale","Tasman","Taupiri","Taupo","Tauranga","Te Anau","Te Atatu","Te Kauwhata","Te Roti","Templeton","Thames","Timaru","Tinwald","Tirau","Titirangi North","Tokomaru","Tokoroa","Torbay","Tuakau","Tuatapere","Turangi","Upper Moutere","Urenui","Waiau","Waiau Pa","Waihi","Waihi Beach","Waikanae","Waikari","Waikawa","Waikuku","Waikuku Beach","Waimana","Waimauku","Wainuiomata","Waiouru","Waipara","Waipawa","Waipu","Wairoa","Wairoa","Waitakere City","Waitangi","Waitara","Waitati","Waitoa","Waiuku","Wakefield","Walton","Wanaka","Wanganui","Warkworth","Waverley","Wellington","Wellsford","Wendon Valley","West Melton","Weston","Westport","Weymouth","Whakatane","Whangamata","Whangaparaoa","Whangarei","Whitianga","Winchester","Windermere","Winton","Woodend","Woolston","Wyndham","Yaldhurst"],"Nicaragua":["Bluefields","Chinandega","El Panama","Esteli","Granada","Jinotega","Los Arados","Managua","Masaya","Matagalpa","Ocotal","Rivas","San Juan del Sur"],"Nigeria":["Aba","Abakaliki","Abeokuta","Abraka","Abraka","Abuja","Ado-Ekiti","Adodo","Aganga","Agege","Agidingbi","Ajegunle","Ajuwon","Akure","Alimosho","Anambra","Apapa","Ayobo","Benin City","Birnin Kebbi","Bonny","Burutu","Bwari","Calabar","Chafe","Damaturu","Egbeda","Ekpoma","Enugu","Forum","Funtua","Ibadan","Ido","Ifako","Igando","Igueben","Ikeja","Ikorodu","Ikotun","Ile-Ife","Ilesa","Ilorin","Ipaja","Iseri-Oke","Isolo","Jalingo","Jos","Kaduna","Kano","Kebbi","Lagos","Lekki","Lokoja","Magodo","Makurdi","Maryland","Minna","Mogho","Mowe","Mushin","Nsukka","Obafemi","Obudu","Odau","Ojo","Ojota","Ondo","Onigbongbo","Orile Oshodi","Oshodi","Osogbo","Ota","Owerri","Oworonsoki","Port Harcourt","Shomolu","Suleja","Suru-Lere","Tara","Ughelli","Ungwan Madaki","Uyo","Warri","Warri","Yaba","Yola","Zaria"],"Norway":["Abelvaer","Adalsbruk","Adland","Agotnes","Agskardet","Aker","Akkarfjord","Akrehamn","Al","Alen","Algard","Almas","Alta","Alvdal","Amli","Amli","Amot","Amot","Ana-Sira","Andalsnes","Andenes","Angvika","Ankenes","Annstad","Ardal","Ardalstangen","Arendal","Arland","Arneberg","Arnes","Aros","As","Asen","Aseral","Asgardstrand","Ask","Ask","Asker","Askim","Aukra","Auli","Aurdal","Aure","Aursmoen","Austbo","Austbygdi","Austevoll","Austmarka","Baerums verk","Bagn","Balestrand","Ballangen","Ballstad","Bangsund","Barkaker","Barstadvik","Batnfjordsora","Batsto","Beisfjord","Beitostolen","Bekkjarvik","Berge","Berge","Bergen","Berger","Berkak","Birkeland","Birtavarre","Bjaland","Bjerka","Bjerkvik","Bjoneroa","Bjordal","Bjorke","Bjorkelangen","Bjornevatn","Blaker","Blakset","Bleikvasslia","Bo","Bo","Bo","Bomlo","Bones","Borge","Borgen","Borhaug","Borkenes","Borregard","Bostad","Bovagen","Boverfjorden","Brandbu","Brandval","Brattholmen","Brattvag","Brekke","Brekstad","Brennasen","Brevik","Bronnoysund","Bru","Bruflat","Brumunddal","Brusand","Bruvik","Bryne","Bud","Burfjord","Buskerud","Buvika","Byglandsfjord","Bygstad","Bykle","Byrknes Nordre","Cavkkus","Dal","Dale","Dalen","Davik","Deknepollen","Digermulen","Dilling","Dimmelsvik","Dirdal","Disena","Dokka","Dolemo","Dovre","Drag","Drammen","Drangedal","Drobak","Dverberg","Dyrvika","Ebru","Egersund","Eggedal","Eggkleiva","Eide","Eide","Eidfjord","Eidsa","Eidsberg","Eidsdal","Eidsfoss","Eidsnes","Eidsvag","Eidsvag","Eidsvoll","Eidsvoll verk","Eikanger","Eikelandsosen","Eiken","Eina","Eivindvik","Elverum","Enebakkneset","Enga","Engalsvik","Erdal","Erfjord","Ervik","Espeland","Etne","Evanger","Evenskjer","Evje","Eydehavn","Faberg","Faervik","Fagernes","Fagerstrand","Fall","Fardal","Farsund","Fauske","Feda","Fedje","Feiring","Felle","Fenstad","Fetsund","Fevik","Figgjo","Finnoy","Finnsnes","Finsand","Fiska","Fiskum","Fister","Fitjar","Fjellstrand","Fla","Flam","Flateby","Flekke","Flekkefjord","Flemma","Flesberg","Flesnes","Floro","Florvag","Foldereid","Folderoy","Folkestad","Follafoss","Follebu","Follese","Fonnes","Forde","Forde","Fornebu","Fosnavag","Fossdalen","Fosser","Fotlandsvag","Fredrikstad","Frekhaug","Fresvik","Frogner","Froland","From","Furnes","Fyrde","Fyresdal","Gan","Gardermoen","Gargan","Garnes","Gasbakken","Gaupen","Geilo","Geithus","Gjerdrum","Gjerstad","Gjolme","Glesvaer","Glomfjord","Godoy","Godvik","Gol","Gran","Gransherad","Granvin","Gratangen","Gravdal","Greaker","Grendi","Gressvik","Grimstad","Groa","Grong","Grua","Gullaug","Gvarv","Haddal","Haegeland","Haerland","Hagan","Hagavik","Hakadal","Halden","Hallingby","Halsa","Haltdalen","Hamar","Hamarvik","Hammerfest","Hansnes","Haram","Hareid","Harstad","Haslum","Hasvik","Hatlestranda","Hauge","Haugesund","Haukeland","Havik","Havik","Hebnes","Hedal","Heggedal","Heggenes","Hegra","Heimdal","Helgeland","Helgeroa","Hell","Hellandsjoen","Helleland","Hellesylt","Hellvik","Hemnes","Hemnesberget","Hemnskjela","Hemsedal","Henningsvaer","Herand","Heroysund","Herre","Hersaeter","Hestvika","Hetlevik","Hildre","Hitra","Hjellestad","Hjelmas","Hjelset","Hjorungavag","Hof","Hokkasen","Hokksund","Hol","Hole","Holen","Holmefjord","Holmen","Holmenkollen","Holmestrand","Holsen","Holter","Hommelvik","Hommersak","Honefoss","Hordvik","Hornnes","Horte","Horten","Hov","Hovag","Hovden","Hovet","Hovik verk","Hovin","Hoyanger","Hundven","Hunndalen","Husoy","Hustad","Hvalstad","Hvam","Hvitsten","Hvittingfoss","Hyggen","Hylkje","Hyllestad","Ikornnes","Indre Arna","Indre Billefjord","Indre Klubben","Indre Ulvsvag","Indreby","Innbygda","Inndyr","Innvik","Isdalsto","Ise","Ivgobahta","Jakobselv","Jar","Jaren","Jessheim","Jevnaker","Jomna","Jorpeland","Kabelvag","Kaldfarnes","Kalvag","Kamben","Karasjok","Karlshus","Karlshus","Kaupanger","Kautokeino","Kirkenaer","Kirkenes","Kjeller","Kjellmyra","Kjerstad","Kjollefjord","Kjopsvik","Kleive","Klepp","Kleppe","Kleppesto","Kleppstad","Klofta","Klokkarvik","Knapper","Knappstad","Knarrevik","Knarrlaget","Kolbjornsvik","Kolbotn","Kolbu","Kolltveit","Kolnes","Kolsas","Kolvereid","Kongsberg","Kongshamn","Kongsvika","Kongsvinger","Konsmo","Konsvikosen","Kopervik","Koppang","Korgen","Kornsjo","Korsvegen","Kragero","Krakeroy","Krakstad","Kristiansand","Kristiansund","Kroderen","Krokstadelva","Kval","Kvalsund","Kvam","Kvammen","Kvanne","Kvelde","Kvinesdal","Kvinlog","Kvisvik","Kviteseid","Kyrkjebo","Kyrksaeterora","Lakselv","Laksevag","Laksvatn","Lalm","Land","Langangen","Langesund","Langevag","Langfjordbotn","Langhus","Larkollen","Larvik","Laukvik","Lauvsnes","Lauvstad","Leikang","Leines","Leira","Leirfjord","Leirsund","Leirvik","Leknes","Lena","Lensvik","Lenvik","Lepsoy","Levanger","Lidaladdi","Lier","Lillehammer","Lillesand","Lindas","Loddefjord","Lodingen","Loen","Lofthus","Loken","Lokken Verk","Lom","Lonevag","Longva","Lorenfallet","Loten","Lovund","Lundamo","Lunde","Lunner","Lyngdal","Lyngseidet","Lyngstad","Lysaker","Lysoysundet","Magnor","Malm","Maloy","Malvik","Mandal","Manger","Manndalen","Marheim","Masfjorden","Mathopen","Maura","Mehamn","Meisingset","Melbu","Meldal","Melhus","Melsomvik","Meraker","Mestervik","Midsund","Miland","Minnesund","Mirza Rafi Sauda","Misje","Misvaer","Mjolkeraen","Mjondalen","Mo","Mo i Rana","Modalen","Moelv","Moen","Moen","Moi","Molde","Moldjord","Morgedal","Mosby","Mosjoen","Moss","Movik","Myking","Myre","Myre","Mysen","Na","Naerbo","Naersnes","Namsos","Namsskogan","Narvik","Naustdal","Nedenes","Nedre Frei","Nesbru","Nesbyen","Nesgrenda","Nesna","Nesoddtangen","Nesttun","Neverdal","Nevlunghamn","Nodeland","Nordby Bruk","Nordfjordeid","Nordkisa","Nordland","Nordstrono","Noresund","Norheimsund","Notodden","Nybergsund","Nyborg","Nydalen","Nygardsjoen","Nyhus","Nykirke","Odda","Odnes","Oksfjord","Oksvoll","Olden","Olderdalen","Olen","Oltedal","Oma","Onarheim","Oppdal","Oppegard","Opphaug","Oresvika","Orje","Orkanger","Ornes","Orre","Os","Os","Oslo","Otta","Otteroy","Ottestad","Oveland","Ovre Ardal","Ovrebo","Oyeren","Oystese","Porsgrunn","Prestfoss","Raholt","Rakkestad","Ramberg","Ramfjordbotn","Ramnes","Rana","Ranasfoss","Randaberg","Ranheim","Raudeberg","Raudsand","Raufoss","Rauland","Re","Re","Reine","Reinsvoll","Reipa","Reistad","Reitan","Rena","Rennebu","Rindal","Ringebu","Ringsaker","Ringstad","Risoyhamn","Rjukan","Roa","Rodberg","Rodoy","Rognan","Rogne","Rokland","Roldal","Rollag","Rolvsoy","Romedal","Rong","Roros","Rorvik","Rosendal","Rossland","Rost","Rovde","Roverud","Royken","Royneberg","Rubbestadneset","Rud","Rygge","Rykene","Rypefjord","Saebo","Saebovik","Saetre","Saevareid","Saeveland","Sagvag","Salhus","Salsbruket","Salsnes","Saltnes","Samuelsberg","Sand","Sand","Sandane","Sande","Sande","Sandefjord","Sandeid","Sander","Sandnes","Sandnes","Sandnessjoen","Sandshamn","Sandstad","Sandtorg","Sandvika","Sandvoll","Sannidal","Sarpsborg","Saupstad","Selasvatn","Selje","Seljord","Sellebakk","Selva","Selvaer","Sem","Setermoen","Siggerud","Siljan","Silsand","Singsas","Sira","Sirevag","Sistranda","Sjovegan","Skabu","Skage","Skanevik","Skarer","Skarnes","Skatoy","Skaun","Skedsmokorset","Skeie","Ski","Skien","Skjeberg","Skjerstad","Skjervoy","Skjold","Skjoldastraumen","Skjolden","Skodje","Skogn","Skogn","Skoppum","Skotbu","Skotterud","Skreia","Skudeneshavn","Skulsfjord","Skutvika","Slastad","Slattum","Slemdal","Slemmestad","Sletta","Snaase","Snillfjord","Sogn","Sokna","Sokndal","Soknedal","Sola","Solbergelva","Solvorn","Sommaroy","Somna","Son","Sondeled","Sor-Fron","Sorbo","Soreidgrenda","Sorli","Sortland","Sorum","Sorumsand","Sorvaer","Sorvagen","Sorvik","Spangereid","Sparbu","Sperrebotn","Spillum","Spydeberg","Stabbestad","Stabekk","Stamnes","Stamsund","Stange","Stathelle","Staubo","Stavanger","Stavern","Stavern","Steigen","Steinberg","Steinkjer","Steinsdalen","Sto","Stokke","Stokmarknes","Stol","Storas","Stordal","Storebo","Storforshei","Storslett","Storsteinnes","Stranda","Straume","Straumen","Strommen","Stronstad","Strusshamn","Stryn","Suldalsosen","Sulisjielmma","Sund","Sundal","Sunde","Sunndalsora","Surnadalsora","Svarstad","Svartskog","Sveio","Svelgen","Svelvik","Svene","Svortland","Sylling","Syvik","Tafjord","Talvik","Tananger","Tanem","Tangen","Tau","Tennevoll","Tennfjord","Tertnes","Tiller","Tingvoll","Tistedal","Tjeldsto","Tjelta","Tjong","Tjorvag","Tjotta","Tofte","Tolga","Tomasjorda","Tomter","Tonstad","Tornes","Torod","Torp","Torpo","Tovik","Trana","Tranby","Trengereid","Tretten","Treungen","Trofors","Trollfjorden","Tromsdalen","Trondheim","Trones","Turoy","Tvedestrand","Tveit","Tynset","Tyristrand","Tysnes","Tysse","Tyssedal","Uggdal","Ulefoss","Ulstein","Ulsteinvik","Ulvagen","Ulvik","Undeim","Uskedalen","Utsira","Utskarpen","Uvdal","Vadheim","Vage","Vagland","Vaksdal","Vale","Valen","Valer","Valer","Valestrand","Valestrandfossen","Valldal","Valle","Valle","Valsoyfjord","Vangsvika","Vannvag","Vanse","Varangerbotn","Varhaug","Vassenden","Vatne","Vedavagen","Vegarshei","Veggli","Venabygd","Vennesla","Verdal","Vestby","Vestfossen","Vestnes","Vestra Mosterhamn","Vestre Gausdal","Vevang","Vevelstad","Vigrestad","Vikebygd","Vikedal","Vikersund","Vikesa","Vikran","Vingelen","Vinje","Vinstra","Voksa","Volda","Vollen","Vormedal","Vormsund","Voss","Vossestrand","Vraliosen","Ytre Alvik"],"Oman":["Al Sohar","Muscat","Nizwa","Ruwi","Saham","Salalah","Samad"],"Pakistan":["Abbottabad","Attock","Batgram","Bhimbar","Burewala","Cantt","Chakwal","Clifton","Daska","Daud Khel","Dera Ghazi Khan","Faisalabad","Fazal","Gilgit","Goth Abad Magsi","Gujar Khan","Gujranwala","Gujrat","Gulberg","Gulshan-e-Iqbal","Habib Baihk","Haripur","Havelian","Hyderabad","Islamabad","Jhang City","Jhang Sadr","Jhelum","Jhumra","Kabirwala","Karachi","Kasur","Khan","Khanewal","Khanpur","Kohat","Lahore","Mandi","Mandi Bahauddin","Mansehra","Mardan","Mian Channu","Mianwali","Miran Shah","Multan","Muzaffarabad","Nangar","Nankana Sahib","Narowal","New Mirpur","Nowshera","Okara","Peshawar","Pindi","Plot","Quetta","Rawalpindi","Rawlakot","Saddar","Sahiwal","Sarai Sidhu","Sargodha","Sarwar","Sheikhupura","Sialkot","Sukkur","Toba Tek Singh","Usman","Wazirabad","Ziauddin"],"Palestine":["Al Mawasi","Bethlehem","Gaza","Hebron","Jenin","Jericho","Nablus","Ramallah"],"Panama":["Aguadulce","Albrook","Ancon","Arosemena","Arraijan","Balboa","Bella Vista","Bocas del Toro","Boquete","Bugaba","Calidonia","Campo Alegre","Cerro Viento","Chigore","Chiriqui","Cocle","Corozal","Cristobal","Curundame","Curundu","David","El Arado","El Cangrejo","El Lago","Elena","Entre Rios","Finca Blanco Numero Uno","Fuerte Amador","Guadalupe","Jimenez","Juan Diaz","Juan Diaz","Juan Franco","Kuba","La Chorrera","La Exposicion","La Loma","Las Mercedes","Las Sabanas","Las Tablas","Llano Tugri","Los Angeles","Muerto","Mulatupo","Paitilla","Panama City","Parque Lefevre","Peru","Playa Blanca","Plaza","Portobelo","Pueblo Nuevo","Quebrada de Camilo","Rio Abajo","Sabalo","Sacramento","San Cristobal","San Felipe","San Francisco","San Miguelito","Santa Ana","Santa Catalina","Santa Clara","Santa Isabel","Santiago","Santo Domingo","Tocumen","Torre","Torres Bluff","Veraguas","Victoria","Vista Alegre","Vista Hermosa"],"Papua New Guinea":["Aitape","Arawa","Daru","Goroka","Kavieng","Kerema","Kikori","Kimbe","Kiunga","Kokopo","Kundiawa","Kupano","Lae","Lorengau","Madang","Mendi","Mount Hagen","Namatanai","Nambaga","Paivara","Pongani","Popondetta","Port Moresby","Vanimo","Wabag","Waigani","Wewak"],"Paraguay":["Ayolas","Boqueron","Chore","Ciudad del Este","Colonia Mariano Roque Alonso","Coronel Oviedo","Fernando de la Mora","Fuerte Olimpo","Hernandarias","Hohenau","Independencia","La Paz","Limpio","Loma Plata","Luque","Nemby","Presidente Franco","Salto del Guaira","San Alberto","San Juan Bautista","San Lorenzo","Santa Rita","Santa Rosa","Villa Elisa","Villa Hayes","Villarrica","Yataity"],"Peru":["Abancay","Arequipa","Ate","Ayacucho","Bagua","Barranca","Barranco","Bellavista","Bolivar","Cajamarca","Callao","Calle","Caras","Cerro de Pasco","Chachapoyas","Chiclayo","Chimbote","Chincha","Cusco","Cuzco","El Agustino","Hacienda La Palma","Huacho","Huancavelica","Huancayo","Huaral","Huaraz","Huaytara","Ica","Ilo","Imperial","Iquitos","Jaen","Jesus Maria","Jose Olaya","Juliaca","Junin","La Molina","La Perla","La Punta","Lambayeque","Lima","Lince","Loreto","Lurigancho","Machu Picchu","Maldonado","Minas de Marcona","Miraflores","Moquegua","Moyobamba","Pasco","Paucarpata","Pimentel","Pisco","Piura","Progreso","Pucallpa","Puerto Inca","Puerto Maldonado","Puno","Rimac","Rimac","Rioja","San Borja","San Isidro","San Isidro","San Juan Bautista","San Martin","San Martin","San Miguel","Santa","Santiago","Santiago De Surco","Sullana","Surco","Surquillo","Tacna","Talara","Tarapoto","Tingo Maria","Trujillo","Tumbes","Ventanilla","Victoria"],"Philippines":["Manila","Quezon City","Caloocan","Davao City","Cebu City","Zamboanga City","Taguig","Antipolo","Pasig","Cagayan de Oro","Paranaque","Makati","Bacolod","General Santos","Dasmarinas","Muntinlupa","Pasay","Angeles","Iloilo City","Valenzuela"],"Poland":["Adama","Alwernia","Andrespol","Andrychow","Anin","Annopol","Arkadia","Babienica","Babimost","Baborow","Baboszewo","Balice","Balice","Banino","Baniocha","Baran","Baranow","Baranowko","Barciany","Barcice","Barcin","Barczewo","Barglowka","Barlinek","Bartoszyce","Baruchowo","Barwice","Bazanowka","Beblo","Bedkow","Bejsce","Belk","Belsk Duzy","Belsznica","Bestwina","Bestwinka","Biala","Bialobrzegi","Bialy Dunajec","Bibice","Biecz","Biedrusko","Bielany","Bielany Wroclawskie","Bielawa","Bielawa","Bielawy","Bielcza","Bieliny","Bielkowo","Bielsk","Bielsk Podlaski","Bielsko-Biala","Bierun","Bierun Nowy","Bierutow","Biesiekierz","Biezanow-Prokocim","Bircza","Biskupice","Biskupice","Biskupice Oloboczne","Biskupiec","Biskupin","Bisztynek","Blachownia","Blazowa","Bledzew","Blizne","Blizyn","Bobrowniki","Bobrza","Bochnia","Bochotnica","Bochowo","Bodzentyn","Bogatynia","Bogdaszowice","Bogumilowice","Bogunice","Boguslaw","Bohdan","Bojadla","Bojano","Bojanowo","Bojszow","Bojszowy","Bolechowice","Boleslaw","Bolewice","Bolkow","Bolszewo","Borek Strzelinski","Borki","Borkowice","Borkowo","Borne Sulinowo","Borowa","Borowe","Borowiec","Bory","Borzecin","Borzykowo","Bralin","Bramki","Braniewo","Braszewice","Bratkowice","Brenna","Brochocin","Brodnica","Brok","Brudzice","Brudzowice","Brynica","Brzeg","Brzeg Dolny","Brzesko","Brzeszcze","Brzezinka","Brzeziny","Brzeznica","Brzeznica","Brzostek","Brzostowka","Brzoza Krolewska","Brzozow","Brzyska Wola","Buczkowice","Budziska","Budzyn","Buk","Bukowice","Bukowiec Opoczynski","Bukowina Tatrzanska","Bukowno","Bukowsko","Burzenin","Bychawa","Byczyna","Bydgoszcz","Bydlin","Byslaw","Bystra","Bystrzyca Klodzka","Bytom","Cekcyn","Cekow","Chalupki","Charzykowy","Checiny","Chelm","Chelmek","Chelmsko Slaskie","Chmielnik","Chmielnik","Chmielow","Chocianow","Chociwel","Choczewo","Chocznia","Chojna","Chojnice","Choroszcz","Chorzele","Chorzelow","Choszczno","Chotel","Chotomow","Chrzan","Chrzastowka","Chrzesne","Chrzowice","Chwaszczyno","Chybie","Chylice","Chyliczki","Cianowice Duze","Ciasna","Ciechocin","Ciechocinek","Cierpice","Cieszkow","Cieszyn","Ciezkowice","Cigacice","Cisiec","Cmielow","Cmolas","Cwiklice","Cybinka","Czaniec","Czaplinek","Czapury","Czarna","Czarne","Czarnkow","Czarnozyly","Czarny Bor","Czarny Dunajec","Czarny Las","Czarze","Czastary","Czechowice-Dziedzice","Czekanow","Czeladz","Czempin","Czernica","Czernica","Czernichow","Czerniewice","Czersk","Czersk","Czerwiensk","Czerwionka-Leszczyny","Czerwonak","Czluchow","Czosnow","Czudec","Czyzyny","Dabki","Dabrowa","Dabrowa Bialostocka","Dabrowa Biskupia","Dabrowa Chelminska","Dabrowa Chotomowska","Dabrowka Wielka","Dabrowno","Dabrowskie","Daleszyce","Damnica","Dankowice","Dargoslaw","Darnowo","Debe Wielkie","Debica","Debina","Deblin","Debno","Debno","Debowiec","Debrzno Wies","Deszczno","Dlugopole-Zdroj","Dobiesz","Dobieszowice","Dobra","Dobra","Dobre Miasto","Dobrodzien","Dobromierz","Dobron","Dobroszyce","Dobroszyce","Dobrzany","Dobrzen Wielki","Dobrzyca","Dolaszewo","Dolice","Domaniewice","Domaradz","Domaslaw","Dopiewiec","Drawno","Drawsko Pomorskie","Drewnica","Drezdenko","Drohiczyn","Drozdowo","Druzbice","Drzewica","Duczki","Dukla","Dulcza Wielka","Dunaj","Duszniki-Zdroj","Dygowo","Dylewo","Dynow","Dywity","Dzialoszyn","Dziechciniec","Dziegielow","Dziekanow Lesny","Dzielna","Dzierzazno","Dzierzgon","Dzierzoniow","Dziewin","Dzikowiec","Dziwnow","Dzwierzuty","Elblag","Elzbieta","Fabianki","Falkow","Falkowo","Frank","Frombork","Frydrychowice","Frysztak","Gadka Stara","Garbow","Garby","Garki","Garwolin","Gaszowice","Gaworzyce","Gdow","Gdynia","Giby","Gieraltowice","Gieraltowice","Gizalki","Gizyce","Gliwice","Glogow Malopolski","Glogowek","Gloskow","Glowienka","Glowna","Glowno","Glubczyce","Glucholazy","Gluchow","Gluszyca","Gmina Babiak","Gmina Bobrowo","Gmina Chmielno","Gmina Ciechanowiec","Gmina Gnojno","Gmina Kiszkowo","Gmina Kolno","Gmina Konarzyny","Gmina Lipno","Gmina Ludwin","Gmina Lutomiersk","Gmina Morawica","Gmina Moszczenica","Gmina Opole Lubelskie","Gmina Przywidz","Gmina Sadowie","Gmina Sierakowice","Gmina Strzelin","Gmina Szubin","Gmina Widawa","Gmina Wyszki","Gmina Zakliczyn","Gniew","Gniewino","Gniewkowo","Gniezno","Gnuszyn","Godziszewo","Gogolin","Golanice","Golasowice","Golczewo","Goleszow","Golkowice","Golotczyzna","Golub-Dobrzyn","Gomunice","Gora","Gora","Gora Kalwaria","Gora Pulawska","Gora Siewierska","Gorazdze","Gorki Wielkie","Gorlice","Gorno","Gorz","Gorzkow","Gorzkowice","Gorzow","Gorzow Slaski","Gorzyce","Gorzyce","Gorzyce","Gorzyczki","Gostyn","Gostynin","Goszczyn","Gowarzewo","Gowino","Gozdnica","Gozdowo","Grabiec","Grabki Duze","Grabow nad Prosna","Grabowka","Gracze","Grajewo","Grebocice","Grebocin","Grodki","Grodkow","Grodzisk","Grodzisk Mazowiecki","Grodzisk Wielkopolski","Grodzisko Dolne","Grojec","Gromiec","Gronowo Elblaskie","Gruczno","Grunwald","Grupa","Gruszczyn","Grybow","Gryfice","Gryfino","Gryfow Slaski","Grzebien","Grzegorz","Grzmiaca","Grzmucin","Gubin","Gzin","Haczow","Harasiuki","Hecznarowice","Henrykow","Hornowek","Hucisko Jawornickie","Humniska","Huta Dabrowa","Huta Dlutowska","Huta Stara","Ilowa","Ilowo","Ilza","Imielin","Iwaniska","Iwanowice","Iwiczna","Iwierzyce","Iwla","Iwonicz-Zdroj","Izabela","Izabelin","Jablonica","Jablonka","Jablonna","Janin","Jankowice","Janow","Janow Lubelski","Jarkowice","Jarocin","Jaroszow","Jaroszowiec","Jasienica","Jasienica Dolna","Jasieniec","Jaslo","Jastkow","Jastrowie","Jastrzebie","Jastrzebie","Jawiszowice","Jawor","Jaworzno","Jaworzyna Slaska","Jedlicze","Jedlnia-Letnisko","Jelesnia","Jemielnica","Jerzmanowice","Jeziora Wielkie","Jeziorany","Jezowe","Jordanow","Jozefatow","Jozefoslaw","Jozefow","Juchnowiec Koscielny","Jugow","Juszkowo","Jutrosin","Kaczkowo","Kaczor","Kalety","Kalisz","Kalwaria Zebrzydowska","Kamien","Kamien","Kamien Krajenski","Kamien Pomorski","Kamien Slaski","Kamienica Polska","Kamieniec","Kamienna Gora","Kamionki","Kampinos","Kanczuga","Karchowice","Karczew","Kargowa","Karlikowo","Karlino","Karnice","Karniowice","Karpacz","Karpiska","Karsko","Kartuzy","Kasinka","Katarzyna","Katowice","Katy","Katy","Katy Wroclawskie","Kazimierz Biskupi","Kazimierz Dolny","Kazimierza Wielka","Kazmierz","Kcynia","Keblowo","Keblowo","Kedzierzyn","Kedzierzyn-Kozle","Kety","Kicin","Kielce","Kielcz","Kielczow","Kielno","Kielpin","Kijewo Krolewskie","Klaj","Klecko","Klecza Dolna","Kleczany","Klenica","Kleszczewo","Kleszczow","Klikawa","Klikuszowa","Klimontow","Kliniska","Klobuck","Klodawa","Klomnice","Kluczbork","Klucze","Knurow","Knyszyn","Kobiernice","Kobierzyce","Kobior","Kobylanka","Kobylka","Kobylnica","Kochcice","Kocierzew Poludniowy","Kocmyrzow","Kojszowka","Kokoszkowy","Kolbudy","Kolbuszowa","Koleczkowo","Kolno","Kolodziejewo","Kolonia Zawada","Kolonowskie","Koluszki","Komorniki","Komorow","Komorsk","Konarzewo","Konarzyce","Konczyce Male","Koniakow","Koniecpol","Konin","Koniusza","Konopiska","Konradowka","Konstancin-Jeziorna","Konstantyn","Konstantynow","Konstantynow Lodzki","Kopki","Korczyna","Korfantow","Kornik","Koronowo","Korsze","Korytow","Korzenna","Kosakowo","Koscielisko","Koscierzyna","Kosina","Kostrzyn","Kostrzyn nad Odra","Koszalin","Koszecin","Koszyce","Koszyce","Koteze","Kotlin","Kowal","Kowalew","Kowalewo","Kowalewo Pomorskie","Kowalkow","Kowalowa","Kowary","Kowiesy","Kozieglowy","Kozieglowy","Kozienice","Kozmin Wielkopolski","Kozminek","Kozuchow","Kozy","Kozy","Krakow","Krapkowice","Krasiejow","Krasne","Krasnik","Krasnystaw","Krasocin","Kraszew","Krepa Kaszubska","Krokowa","Kroscienko Wyzne","Krosno","Krosno Odrzanskie","Krosnowice","Krotoszyn","Kruszyn","Kruszyna","Krynica","Krynica-Zdroj","Krypno","Krzepice","Krzeszow","Krzeszowice","Krzyki-Partynice","Krzyszkowice","Krzywcza","Krzywin","Krzyz Wielkopolski","Krzyzanowice","Ksiazenice","Ksieginice","Kukow","Kuligow","Kunice","Kunow","Kurdwanow","Kurek","Kurylowka","Kurzetnik","Kusnierz","Kutno","Kuznia","Kuznica Czarnkowska","Kuzniki","Kwaczala","Kwidzyn","Kwilcz","Labiszyn","Labowa","Labunie","Lachowice","Lack","Lacko","Ladek","Lajsk","Laka","Lancut","Lany","Lask","Laska","Laskarzew","Latowicz","Laziska","Laziska Gorne","Leba","Lebork","Leczna","Ledziny","Legionowo","Legnica","Legowo","Lekawica","Lelow","Lesko","Lesna","Lesnica","Leszkowice","Leszno","Leszno","Lewin Brzeski","Lezajsk","Libiaz","Lidzbark","Ligota","Limanowa","Liniewo","Linowko","Lipinki Luzyckie","Lipiny","Lipnica Murowana","Lipnica Wielka","Lipnik","Lipno","Lipowa","Lipsko","Lipusz","Lisewo","Liskow","Liszki","Liw","Lobez","Lobzenica","Lochow","Lochowo","Lodygowice","Lomianki","Lomianki Dolne","Lomnica","Lotyn","Lowicz","Lubaczow","Luban","Lubanie","Lubartow","Lubaszowa","Lubawa","Lubawka","Lubenia","Lubichowo","Lubicz","Lubien","Lubin","Lublewo","Lublin","Lubliniec","Lubnice","Lubochnia","Lubomia","Lubomierz","Lubon","Luborzyca","Lubraniec","Lubsko","Lubsza","Lubycza Krolewska","Lukow","Lulin","Lusowko","Lutynia","Luzino","Lysomice","Mackowice","Magnuszew","Majdan Krolewski","Majewo","Makow","Makow Mazowiecki","Makow Podhalanski","Makowiec","Maksymilianowo","Malbork","Malczyce","Malogoszcz","Manowo","Marcinowice","Marek","Margonin","Maria","Marki","Marklowice","Marta","Mary","MaryLka","Maslice","Maslow","Maszewo","Mazancowice","Mechelinki","Medyka","Medynia Glogowska","Melno","Meszna","Mialy","Miasteczko Slaskie","Miastko","Michalowice","Miechow","Mieczewo","Miedzna","Miedzyborow","Miedzyborz","Miedzybrodzie Zywieckie","Miedzylesie","Miedzyzdroje","Miejska Gorka","Mielec","Mielno","Mieroszow","Mierzecice","Mierzeszyn","Mikolajki","Mikoszewo","Mikstat","Milanow","Milcza","Milejow","Milicz","Milkowice","Milobadz","Miloradz","Milowka","Minoga","Mirkow","Miroslaw","Miroslawiec","Mirsk","Miszkowice","Mniow","Modlnica","Modlniczka","Modrze","Mogilany","Mogilno","Mokrsko","Morawica","Moryn","Mosina","Mosty","Moszczanka","Mragowo","Mrocza","Mrowino","Mscice","Msciwojow","Mszana","Mszana Dolna","Mucharz","Murowana Goslina","Muszyna","Myslachowice","Myslenice","Mysliborz","Myszkow","Myszyniec","Nacpolsk","Nadarzyn","Naklo","Naleczow","Namyslow","Naprawa","Narew","Narzym","Nasielsk","Nawodna","Nebrowo Wielkie","Nidzica","Nieborowice","Niechanowo","Niedomice","Niedrzwica Duza","Niegoslawice","Nielisz","Niemcz","Niemcza","Niemodlin","Nienadowka","Niepolomice","Niewierz","Nisko","Niwica","Nowa","Nowa Biala","Nowa Deba","Nowa Huta","Nowa Ruda","Nowa Slupia","Nowa Sol","Nowa Wies Elcka","Nowe Chechlo","Nowe Lignowy","Nowe Miasto Lubawskie","Nowe Miasto nad Pilica","Nowe Miasto nad Warta","Nowe Skalmierzyce","Nowo-Aleksandrowo","Nowogard","Nowogrodziec","Nowy Dwor","Nowy Dwor Gdanski","Nowy Dwor Mazowiecki","Nowy Korczyn","Nowy Staw","Nowy Swietow","Nowy Targ","Nowy Tomysl","Nowy Wisnicz","Nysa","Oblaczkowo","Oborniki","Obrzycko","Obsza","Odolanow","Odolin","Odrzykon","Ogrody","Ogrodzieniec","Ojrzen","Oksywie","Olawa","Olecko","Olejnica","Olesnica","Olesno","Oleszno","Olimpia","Olkusz","Olszany","Olszowice","Olsztyn","Olsztynek","Olszyna","Oltarzew","Opalenica","Opatow","Opatowek","Opoczno","Opole","Orchowo","Orneta","Ornontowice","Orzel","Orzesze","Orzysz","Osieck","Osieczna","Osiek","Osiek","Osiek Jasielski","Osielsko","Osno","Osno Lubuskie","Ostaszewo","Ostrog","Ostroszowice","Ostrow","Ostrow Lubelski","Ostrow Mazowiecka","Ostrowek","Ostrowite","Ostrowy","Ostrzeszow","Otoki","Otomin","Otrebusy","Otwock","Otyn","Owinska","Ozarow Mazowiecki","Ozimek","Ozorkow","Pabianice","Pacanow","Pajeczno","Paledzie","Paliszewo","Paniowki","Papowo","Parczew","Pastuchow","Paulina","Pawlowice","Pawlowice","Pcim","Peczniew","Pedziwiatry","Pegow","Pelplin","Pepowo","Pewel Mala","Piaseczno","Piasek","Piaski","Piaski","Piastow","Piechowice","Piekary","Piekary Slaskie","Piekielnik","Piekoszow","Pielgrzymka","Pielice","Piensk","Pierwoszyno","Pieszkow","Pieszyce","Pietrowice Wielkie","Pietrzykowice","Pila","Pila","Pila Koscielecka","Pilawa","Pilawa","Pilawa Gorna","Pilchowice","Pilica","Pinczow","Pionki","Pisarzowice","Pisz","Plesna","Pleszew","Plewiska","Plochocin","Pniewy","Pniewy","Pobiedna","Pobiedziska","Poczesna","Podegrodzie","Podgorne","Podgorze","Podlasie","Podleze","Pogodki","Pogorzela","Pogwizdow","Pokrzywnica","Polajewo","Polanka Wielka","Polczyn-Zdroj","Police","Polkowice","Polomia","Polskie","Pomiechowek","Pomorskie","Popow","Popowice","Poraj","Poreba","Poswietne","Poznan","Prabuty","Prabuty","Praca","Praszka","Prawiedniki","Prochowice","Prokocim","Prosna","Proszowice","Pruchna","Prudnik","Prusice","Pruszcz Gdanski","Pruszcz Pomorski","Przasnysz","Przechlewo","Przeclaw","Przeclaw","Przemet","Przemysl","Przemysl","Przemyslaw","Przeworsk","Przezmierowo","Przygodzice","Przylep","Przyrow","Przysiek","Przystajn","Przyszowice","Pszczew","Pszczyna","Pszow","Puck","Pustkow","Puszczew","Puszczykowo","Pyrzyce","Pyskowice","Pysznica","Rabien","Rabka-Zdroj","Raciaz","Raciazek","Racula","Raczka","Raczki","Radgoszcz","Radlin","Radlow","Radom","Radomin","Radomsko","Radomysl Wielki","Radoslaw","Radostowice","Radoszyce","Radymno","Radzanow","Radzanowo","Radziechowy","Radziejowice","Radzionkow","Radzymin","Radzyn Podlaski","Rajszew","Rakow","Rakowiec","Rakszawa","Ranizow","Raszowa","Raszowka","Raszyn","Rawa Mazowiecka","Rawicz","Rebkow","Rebowo","Reczno","Reda","Regimin","Rejowiec","Reszel","Rewa","Rewal","Roczyny","Rogalinek","Rogow","Rogow","Rogowo","Rogoznik","Rogozno","Rokietnica","Rokitki","Rokitnica","Ropczyce","Rosnowko","Rostarzewo","Rozanka","Rozgarty","Rozprza","Roztoka","Ruda","Rudka","Rudna Mala","Rudnik nad Sanem","Rudy","Rudzica","Rudziniec","Rumia","Rumianek","Rusiec","Rybna","Rybnik","Rybno","Rychwal","Rydzyna","Ryglice","Ryki","Ryman","Rymanow","Ryn","Rypin","Rzasnia","Rzeczyce","Rzemien","Rzepin","Rzeszotary","Rzewnie","Rzgow Pierwszy","Rzuchowa","Sadlinki","Sadlno","Sady","Samin","Sandomierz","Sanniki","Sanok","Santok","Sarbinowo","Scinawa Mala","Scinawa Nyska","Sedziszow","Sedziszow Malopolski","Sepolno Krajenskie","Serock","Serock","Serwis","Sianow","Sidra","Sidzina","Siechnice","Siedlce","Siedlec","Siekierczyn","Siemiatycze","Siemirowice","Siemkowice","Sieniawa","Sieniawa Zarska","Sieniawka","Siennica","Siennica Nadolna","Sieradz","Sieroszowice","Sierpc","Siewierz","Siwek","Skala","Skarszewy","Skarzysko-Kamienna","Skawina","Skierdy","Skierniewice","Skoczow","Skomlin","Skopanie","Skorcz","Skorzec","Skorzewo","Skrbensko","Skrzetusz","Skrzyszow","Skwierzyna","Slawkow","Slawno B","Slawoszyno","Slemien","Slomniki","Slone","Slupca","Slupno","Smardzew","Smardzowice","Smigiel","Smolec","Smolnica","Smolnik","Sobienie Jeziory","Sobotka","Sobotka","Sobowidz","Sochaczew","Sochocin","Soczewka","Sokolow Malopolski","Sokolowsko","Solec Kujawski","Sompolno","Sopot","Sosnie","Sosnowiec","Sroda Wielkopolska","Stadla","Stalowa Wola","Staniatki","Staniszow","Stankowo","Stanowice","Stara","Stara Kamienica","Stara Lubianka","Starachowice","Stare Babice","Stare Bogaczowice","Stare Czarnowo","Stare Juchy","Stare Kurowo","Stare Miasto","Stary Broniszew","Stary Garbow","Stary Sacz","Stary Zamosc","Staszow","Staw","Stawiany","Stawiguda","Stegna","Steszew","Stoczek","Stolno","Stopnica","Straszyn","Strawczyn","Strazow","Stronie Slaskie","Stroze","Strumien","Strykow","Stryszawa","Stryszow","Strzalkowo","Strzebielino","Strzebin","Strzegom","Strzelce Krajenskie","Strzelce Opolskie","Strzeleczki","Strzelno","Strzeszow","Strzyze","Strzyzow","Strzyzow","Studzieniec","Subkowy","Sucha Beskidzka","Suchedniow","Suchowola","Suchy Dab","Suchy Las","Sulechow","Sulejow","Sulejowek","Sulistrowice","Sulmierzyce","Sulmierzyce","Sulmin","Suloszowa","Supienie","Susiec","Susz","Suszec","Suwaki","Swarorzyn","Swarzedz","Swarzewo","Swiatki","Swidnica","Swidnik","Swidwin","Swiebodzice","Swiebodzin","Swiecie nad Osa","Swiekatowo","Swierk","Swierklany","Swieta Katarzyna","Swietno","Swietoniowa","Swiniary","Swoboda","Sycewice","Sycow","Syrynia","Szadek","Szadlowice","Szczaniec","Szczawno","Szczawno-Zdroj","Szczecin","Szczecinek","Szczejkowice","Szczepanow","Szczercow","Szczucin","Szczuczyn","Szczurowa","Szczyrk","Szczytniki","Szczytno","Szebnie","Szemud","Szepietowo","Szewce","Szlachta","Szostka","Szowsko","Szprotawa","Szreniawa","Sztum","Sztutowo","Szyce","Szydlowiec","Szydlowo","Szyldak","Szymanow","Szypliszki","Tanowo","Tarchaly Wielkie","Tarczyn","Targanice","Tarnobrzeg","Tarnogrod","Tarnow Opolski","Tarnowiec","Tarnowo Podgorne","Tarnowskie Gory","Tczew","Tecza","Tegoborze","Tenczyn","Teofilow","Teresin","Terespol","Tluczan","Tolkmicko","Tomaszow","Tomaszow","Tomaszow Lubelski","Tomaszowice","Topola Mala","Torzym","Toszek","Towarzystwo","Trabki","Trawniki","Trojanow","Trzciana","Trzcianka","Trzciel","Trzcinsko","Trzebinia","Trzebnica","Trzebownisko","Trzebunia","Trzemesnia","Trzemeszno","Trzemeszno Lubuskie","Trzesniow","Trzeszczyn","Trzyciaz","Trzydnik Duzy","Tuchola","Tuchow","Tuczno","Tulce","Turbia","Turek","Turobin","Turowiec","Tuszyn","Twardawa","Twardogora","Tworog","Tychy","Tyczyn","Tyczyn","Tykocin","Tylicz","Tylmanowa","Tymbark","Tymowa","Tyszowce","Uciechow","Ujazd","Ujscie","Ulez","Unieszewo","Ustanow","Ustka","Ustron","Ustrzyki Dolne","Wabrzezno","Wachock","Wadowice","Wadowice Gorne","Waganiec","Wagrowiec","Walcz","Walim","Wambierzyce","Wapielsk","Warka","Warsaw","Warzachewka Polska","Warzno","Warzymice","Wasilkow","Wasniow","Wawel","Wawolnica","Wegierska Gorka","Wegliniec","Weglowice","Wegrzce Wielkie","Wejherowo","Wiazow","Wicko","Wieckowice","Wielbark","Wielen Zaobrzanski","Wielgie","Wielichowo","Wieliczka","Wieliszew","Wielki Klincz","Wieloglowy","Wielopole Skrzynskie","Wielowies","Wieruszow","Wierzchowisko","Wieszowa","Wijewo","Wilczeta","Wilczyce","Wilczyn","Wilga","Wilkanowo","Wilkow","Wilkowice","Wilkowisko","Winnica","Winsko","Wiorek","Wisla","Wisla Wielka","Wisniew","Wisniowa","Wisznice","Witaszyce","Witkowo","Witnica","Wlodawa","Wlodzimierz","Wloszczowa","Wojciech","Wojkowice","Wojkowice Koscielne","Wola Baranowska","Wola Filipowska","Wola Kopcowa","Wola Krzysztoporska","Wola Radlowska","Wola Rasztowska","Wola Rebkowska","Wola Zaradzynska","Wolborz","Wolbrom","Wolin","Wolka","Wolow","Wolsztyn","Wozniki","Wreczyca Wielka","Wronki","Wrzesnia","Wrzosowa","Wrzosowka","Wschowa","Wylatowo","Wymiarki","Wyrzysk","Wysogotowo","Wysoka","Wysoka Strzyzowska","Wysokie Mazowieckie","Wystep","Wyszogrod","Zabia Wola","Zabierzow Bochenski","Zablocie","Zabno","Zabor","Zabrowo","Zabrze","Zabrzeg","Zaczernie","Zagnansk","Zagorow","Zagorzyce","Zagosciniec","Zagrodno","Zakopane","Zalakowo","Zalasewo","Zalesie","Zaleszany","Zalewo","Zalubice Nowe","Zalubice Stare","Zaluski","Zaniemysl","Zaparcin","Zarow","Zarowka","Zarszyn","Zary","Zator","Zawada","Zawada","Zawady","Zawadzkie","Zawidow","Zawiercie","Zawoja","Zawonia","Zbaszyn","Zbaszynek","Zbiczno","Zblewo","Zbroslawice","Zdunska Wola","Zduny","Zduny","Zdzieszowice","Zebowice","Zebrzydowice","Zegrze Pomorskie","Zelazkow","Zelow","Zembrzyce","Zerkow","Zernica","Zerniki","Zgierz","Zglobice","Zglobien","Zgorsko","Zgorzala","Zgorzelec","Ziebice","Zielona","Zielone","Zielonka","Zielonki","Zielonki-Wies","Zlocieniec","Zloczew","Zlotow","Zloty Stok","Zmigrod","Znin","Zofia","Zorawia","Zorawina","Zosin","Zrecin","Zukowo","Zurawica","Zwolen","Zyrakow"],"Portugal":["Abobada","Abrantes","Acores","Aguada de Cima","Agualva","Agucadoura","Aguiar da Beira Municipality","Alandroal","Albergaria-a-Velha","Albufeira","Alcabideche","Alcacer do Sal","Alcains","Alcanede","Alcanena","Alcobaca","Alcochete","Alcoentre","Aldeia de Paio Pires","Aldeia do Meio","Aldeia dos Fernandes","Alenquer","Alfarelos","Alfena","Alfornelos","Alfragide","Alges","Algoz","Algueirao","Alhandra","Alhos Vedros","Aljezur","Aljustrel","Almada","Almancil","Almargem","Almeirim","Almodovar","Alpiarca","Alportel","Alqueidao da Serra","Alter do Chao","Altura","Alvaiazere","Alvarinhos","Alvelos","Alverca","Amadora","Amarante","Amares","Amiaes de Cima","Amor","Amora","Amoreira","Amorim","Anadia","Anta","Apulia","Arazede","Arco da Calheta","Arcos de Valdevez","Arcozelo","Arganil","Argoncilhe","Armacao de Pera","Arouca","Arraiolos","Arrifana","Arronches","Arruda dos Vinhos","Arvore","Assumar","Atalaia","Atouguia da Baleia","Avanca","Aveiras de Cima","Aveiro","Avelar","Avidos","Avintes","Azoia","Azueira","Azurem","Baguim","Baguim do Monte","Baleia","Baltar","Barcarena","Barcelos","Barreiro","Barrosas","Basto","Batalha","Beira","Beja","Belas","Belmonte","Bemfica","Benafim","Benavente","Benedita","Bicesse","Bico","Boavista","Bobadela","Boliqueime","Bombarral","Borba","Boticas","Bouca","Braga","Braganca","Brito","Bucelas","Buraca","Cabanelas","Cabeceiras de Basto","Cabeco de Vide","Cabecudos","Cabrela","Cacela","Cacem","Cacilhas","Cadaval","Caldas","Caldas da Rainha","Caldas das Taipas","Caldas de Sao Jorge","Caldas de Vizela","Calvao","Calvaria de Cima","Camarate","Caminha","Campanario","Campia","Campinho","Campo","Campo Maior","Canecas","Canedo","Canedo","Canelas","Canhas","Canical","Canico","Canidelo","Cano","Cantanhede","Caparica","Caramulo","Carapinheira","Carcavelos","Carnaxide","Carrazedo","Carregado","Carrico","Cartaxo","Carvalhal","Carvalho","Carvalhosa","Carvoeiro","Casal","Casal da Areia","Cascais","Castanheira do Ribatejo","Castelejo","Castelo","Castelo Branco","Castelo de Paiva","Castro Daire","Castro Marim","Castro Verde Municipality","Catraia de Sao Paio","Cavaleiros","Cavaloes","Caxias","Ceira","Celorico de Basto","Cercal","Cernache","Cesar","Chao de Couce","Charneca","Chaves","Cidade","Cinfaes","Coimbra","Coimbra","Colares","Colmeias","Condeixa-a-Nova","Constance","Constancia","Corroios","Cortegaca","Costa de Caparica","Costa de Lavos","Covilha","Creixomil","Cruz Quebrada","Cuba","Cucujaes","Dalvares","Damaia","Darque","Dois Portos","Dona Maria","Dossaos","Eixo","Elvas","Encarnacao","Entroncamento","Entroncamento","Ericeira","Ermidas","Escapaes","Escoural","Esmoriz","Espinho","Esposende","Estarreja","Estoi","Estombar","Estoril","Estremoz","Evora","Fafe","Famoes","Fanzeres","Fao","Faro","Feira","Felgueiras","Felgueiras","Felgueiras","Ferradosa","Ferreira","Ferreira do Alentejo","Ferrel","Ferro","Fiaes","Figueira da Foz Municipality","Figueira de Lorvao","Figueiro dos Vinhos","Fogueteiro","Folgados","Forte","Foz do Sousa","Fradelos","Freamunde","Frielas","Funchal","Fundao","Gafanha da Nazare","Galiza","Gandara dos Olivais","Gandra","Garruchas","Gemunde","Godim","Golega","Gondomar","Gouveia","Graca","Gradil","Grandola","Granja","Granja do Ulmeiro","Grijo","Guarda","Guardizela","Guia","Guimaraes","Gulpilhares","Igreja Nova","Igreja Nova","Ilhavo","Infesta","Joane","Jovim","Juncal","Lagarinhos","Lago","Lagoa","Lagoa","Lagoa","Lagoas","Lagos","Lajes","Lamego","Landim","Lavos","Lavra","Lavradio","Leca da Palmeira","Leca do Bailio","Leiria","Linda a Velha","Linhaceira","Linho","Lisbon","Lordelo","Loule","Lourel de Baixo","Loures","Lourical","Lourosa","Lousa","Lousada","Lousado","Macas de Caminho","Maceda","Macedo de Cavaleiros","Maceira","Machico","Macieira da Lixa","Madeira","Mafra","Maia","Malveira","Malveira da Serra","Mamouros","Mangualde","Manique de Baixo","Manique do Intendente","Marco","Marco de Canaveses","Margaride","Marinha","Marinha Grande","Marinhais","Marteleira","Martinganca","Massama","Massarelos","Matosinhos Municipality","Mealhada","Mem Martins","Mesao Frio","Mesao Frio","Mexilhoeira Grande","Milharado","Milhazes","Minde","Mira","Mira","Miranda do Corvo","Miranda do Douro","Mirandela","Mocarria","Modivas","Moita","Moncao","Monchique","Monforte","Monsanto","Monsaraz","Montalvo","Monte Estoril","Montelavar","Montemor-o-Novo","Montemor-o-Velho","Montes","Montes","Montijo","Moreira de Conegos","Mortagua","Moscavide","Moura","Moura","Moure","Mourisca do Vouga","Mozelos","Muro","Murtede","Murteira","Nadadouro","Negrelos","Neiva","Nelas","Nespereira","Nine","Nisa","Nogueira","Nogueira da Regedoura","Nogueira do Cravo","Obidos","Obidos","Odemira","Odivelas","Oeiras","Oia","Olhao","Olhos de Agua","Olivais","Olivais","Olival","Oliveira","Oliveira do Bairro","Oliveira do Douro","Oliveira do Hospital","Ortiga","Ota","Ourem","Ourique","Outeiro","Ovar","Paco de Arcos","Paderne","Palhaca","Palhais","Palmeira","Palmela","Parada de Gonta","Parada do Bispo","Paraiso","Parchal","Pardilho","Parede","Paredes","Paredes","Paredes da Beira","Paredes de Coura","Pataias","Paul","Pechao","Pedreiras","Pedroso","Pedroucos","Pegoes Velhos","Penacova","Penafiel","Penedono","Penela","Penha Garcia","Peniche","Penteado","Pereira","Pero Pinheiro","Pevidem","Piedade","Pinhal","Pinhal Novo","Pinheiro","Pinheiro da Bemposta","Pinheiro de Azere","Poceirao","Poco Barreto","Poiares","Polima","Pombal","Ponta","Ponta Delgada","Ponta do Sol","Ponte","Ponte da Barca","Ponte de Lima","Ponte de Sor","Ponte de Vagos","Pontevel","Pontinha","Portalegre","Portel","Portela","Portimao","Porto","Porto","Porto","Porto","Porto Alto","Porto da Cruz","Porto de Mos","Porto Moniz","Porto Salvo","Povoa","Povoa","Povoa da Galega","Povoa de Lanhoso","Povoa de Santa Iria","Povoa de Santo Adriao","Povoa do Forno","Prado","Pragal","Praia da Vitoria","Praia de Mira","Praia do Almoxarife","Praia do Carvoeiro","Praia do Ribatejo","Prazins","Prime","Proenca-a-Nova","Quarteira","Quejas","Queluz","Queluz de Baixo","Quinchaes","Quinta","Quinta","Quinta do Anjo","Ramada","Ramo","Rana","Real","Rebordosa","Recarei","Redondo","Regueira de Pontes","Reguengo Grande","Reguengos de Monsaraz","Riachos","Riba de Ave","Ribeira Brava","Ribeira Grande","Ribeirao","Rinchoa","Rio de Moinhos","Rio de Mouro","Rio Maior","Rio Tinto","Romariz","Ronfe","Roque","Roriz","Runa","Sabugal","Sacavem","Salreu","Salto","Salvaterra de Magos","Samil","Samora Correia","Samouco","Sandim","Sanfins do Douro","Sangalhos","Sanguedo","Santa Barbara de Nexe","Santa Catarina","Santa Catarina da Serra","Santa Clara-a-Velha","Santa Comba Dao","Santa Cruz","Santa Iria da Azoia","Santa Marta","Santa Marta de Penaguiao","Santana","Santiago","Santiago","Santiago da Guarda","Santiago de Riba-Ul","Santiago do Cacem","Santo Andre","Santo Antao do Tojal","Santo Antonio","Santo Antonio da Charneca","Santo Tirso","Sao Bras","Sao Bras de Alportel","Sao Domingos de Rana","Sao Felix da Marinha","Sao Francisco","Sao Joao","Sao Joao da Madeira","Sao Joao da Talha","Sao Joao das Lampas","Sao Joao de Ver","Sao Joao do Campo","Sao Joao dos Montes","Sao Juliao do Tojal","Sao Mamede de Infesta","Sao Marcos","Sao Pedro da Cadeira","Sao Pedro do Estoril","Sao Romao do Coronado","Sao Roque","Sao Vicente da Beira","Sao Vicente de Lafoes","Sardoal","Sarilhos Grandes","Satao","Seia","Seixal","Seixal","Sendim","Senhora da Hora","Seroa","Serpa","Serpins","Serta","Sesimbra","Sete Rios","Sever do Vouga","Silva","Silvares","Silveira","Silves","Sines Municipality","Sintra","Soalheira","Sobrado","Sobrado de Paiva","Sobral de Monte Agraco","Sobralinho","Sobreda","Sobreiro","Sobrosa","Soito","Soure Municipality","Souto da Carpalhosa","Souzel","Sul","Tabuaco","Talaide","Tamel","Tarouca","Taveiro","Tavira Municipality","Teixoso","Telhado","Tercena","Terena","Tires","Tocha","Tomar","Tondela","Torre da Marinha","Torre de Moncorvo","Torres Novas","Torres Vedras","Touguinha","Tourais","Trafaria","Trancoso","Trancoso de Baixo","Travanca","Treixedo","Trofa","Tunes","Turcifal","Vagos","Valado de Frades","Valbom","Vale","Vale","Vale","Vale da Pinta","Vale de Acor","Vale de Cambra","Valega","Valenca","Valongo","Valverde","Varzea do Douro","Venda do Pinheiro","Vendas Novas","Vermelha","Vermoil","Vialonga","Viana do Alentejo","Viana do Castelo","Vidago","Vidigueira","Vieira de Leiria","Vieira do Minho","Vila Alva","Vila Boa de Quires","Vila Cha","Vila Cha de Ourique","Vila de Porto Santo","Vila do Bispo","Vila do Conde","Vila Franca de Xira","Vila Franca do Rosario","Vila Nogueira de Azeitao","Vila Nova","Vila Nova","Vila Nova","Vila Nova","Vila Nova da Barquinha","Vila Nova de Cerveira","Vila Nova de Famalicao","Vila Nova de Gaia","Vila Nova de Paiva","Vila Praia de Ancora","Vila Real","Vila Verde","Vilar de Perdizes","Vilar do Paraiso","Vilar do Pinheiro","Vilar Formoso","Vilarinho das Paranheiras","Vilarinho de Arcos","Vilarinho do Bairro","Vilela","Vimieiro","Vinhais","Viseu","Vizela","Vizela","Zambujal","Zibreira"],"Puerto Rico":["Adjuntas","Aguada","Aguadilla","Aguas Buenas","Aibonito","Anasco","Arecibo","Arroyo","Bajadero","Barceloneta","Barranquitas","Boqueron","Cabo Rojo","Caguas","Camuy","Canovanas","Carolina","Catano","Cayey","Ceiba","Ciales","Cidra","Coamo","Corozal","Coto Laurel","Culebra","Dorado","Ensenada","Fajardo","Florida","Garrochales","Guanica","Guayama","Guayanilla","Guaynabo","Gurabo","Hatillo","Hormigueros","Humacao","Isabela","Jayuya","Juana Diaz","Juncos","Lajas","Lares","Las Piedras","Loiza","Luquillo","Manati","Maricao","Maunabo","Mayaguez","Mercedita","Moca","Morovis","Naguabo","Naranjito","Orocovis","Palmer","Patillas","Penuelas","Ponce","Punta Santiago","Quebradillas","Residencial Puerto Real","Rincon","Rio Grande","Sabana Grande","Sabana Seca","Saint Just","Salinas","San Antonio","San German","San Juan","San Lorenzo","San Sebastian","Santa Isabel","Toa Alta","Toa Baja","Trujillo Alto","Utuado","Vega Alta","Vega Baja","Vieques","Villalba","Yabucoa","Yauco"],"Republic of Korea":["Andong","Ansan-si","Anseong","Anyang-si","Asan","Bucheon-si","Busan","Changwon","Cheonan","Cheongju-si","Chilgok","Chuncheon","Chungju","Chungnim","Daegu","Daejeon","Deokjin","Duchon","Gangneung","Gimhae","Gongju","Gumi","Gunnae","Gwangju","Gwangmyeong","Gyeongju","Gyeongsan-si","Hadong","Haesan","Haeundae","Hanam","Hansol","Hyangyang","Hyoja-dong","Icheon-si","Iksan","Ilsan-dong","Incheon","Janghowon","Jecheon","Jeju-si","Jeonju","Jinju","Ka-ri","Kimso","Kisa","Koyang-dong","Kwanghui-dong","Mapo-dong","Miryang","Moppo","Nae-ri","Naju","Namhyang-dong","Namyang","Namyangju","Nonsan","Okpo-dong","Osan","Paju","Pohang","Pon-dong","Pyong-gol","Samjung-ni","Samsung","Sangdo-dong","Sasang","Se-ri","Seocho","Seong-dong","Seongnam-si","Seosan City","Seoul","Songam","Songang","Songjeong","Songnim","Suncheon","Suwon-si","Taebuk","Tang-ni","Tongan","Uiwang","Ulchin","Ulsan","Unpo","Wonju","Wonmi-gu","Yangsan","Yeoju","Yeosu","Yongin","Yongsan-dong"],"Republic of Lithuania":["Alytus","Anciskiai","Antakalnis","Garliava","Ignalina","Jonava","Jurbarkas","Juskonys","Kaunas","Kretinga","Mastaiciai","Palanga","Panevezys","Sakiai","Salcininkai","Trakai","Ukmerge","Uzliedziai","Venta","Vievis","Vilniaus Apskritis","Vilnius","Visaginas"],"Republic of Moldova":["Anenii Noi","Briceni","Cahul","Calarasi","Ciorescu","Cojusna","Comrat","Drochia","Durlesti","Ialoveni","Magdacesti","Nisporeni","Orhei","Soroca","Straseni","Tighina","Tiraspol","Voinescu","Vulcanesti"],"Romania":["Adjud","Afumati","Agnita","Aiud","Alba","Alba Iulia","Albesti-Paleologu","Alesd","Alexandria","Alunu","Apahida","Apata","Arad","Avrig","Baba Novac","Baia Mare","Baia Sprie","Baicoi","Baile Olanesti","Baiut","Balomiru de Camp","Balotesti","Banesti","Baraolt","Barbuletu","Bascov","Becicherecu Mic","Berceni","Berzasca","Bethausen","Bic","Bilciuresti","Birda","Blaj","Bobolia","Bocsa","Bogdanita","Bolintin Deal","Borca","Borsa","Bozieni","Bragadiru","Branistea","Brazii de Sus","Breaza","Bucecea","Bucharest","Bucsani","Bucu","Bucurestii Noi","Buftea","Buhusi","Bujor","Bumbesti-Jiu","Busteni","Buzias","Calafat","Calan","Calarasi","Calinesti","Campeni","Campia","Campia Turzii","Campina","Campulung Moldovenesc","Campulung Muscel","Cara","Caracal","Caransebes","Carbunesti","Carei","Catcau","Catunele","Cernisoara","Cetatea de Balta","Cetatuia","Chiajna","Chiselet","Chisineu-Cris","Chisoda","Chitila","Cisnadie","Ciumani","Cluj-Napoca","Cobadin","Codlea","Cojasca","Comana","Comanesti","Corabia","Corbeanca","Corbita","Corlateni","Cosbuc","Costesti","Cotnari","Covasna","Craiova","Crangasi","Crasna","Cris","Cristian","Cristuru Secuiesc","Cugir","Curtici","Cuza Voda","Daia Romana","Decebal","Dej","Deta","Deva","Dimitrie Cantemir","Ditrau","Doamna","Dobroesti","Domnesti","Dor Marunt","Dorohoi","Dragotesti","Dridu","Dudestii Vechi","Dumbravita","Eforie","Fabrica","Faget","Fagetu","Falcau","Falticeni","Fetesti","Filias","Filiasi","Filipestii de Padure","Floresti","Floresti","Floresti","Fogarasch","Fundulea","Gaesti","Garla-Mare","Gataia","Geoagiu","Gheorgheni","Gherea","Gherla","Giarmata","Gilau","Giroc","Giulesti","Giurgiu","Glina","Gramesti","Grojdibodu","Gura Humorului","Hangulesti","Harsova","Hateg","Horia","Huedin","Humulesti","Hunedoara","Husi","Iadara","Iernut","Ion Ghica","Iorga","Izvoru Crisului","Jibou","Jilava","Lacu","Lacu Sinaia","Lancram","Lazuri","Lehliu-Gara","Lenauheim","Livezi","Ludesti","Lugoj","Lunguletu","Macin","Madaras","Magura","Magurele","Magurele","Mandruloc","Mangalia","Manta","Marasheshty","Marasti","Marginea","Masloc","Matasari","Matei","Medgidia","Miercurea Sibiului","Miercurea-Ciuc","Mihai Bravu","Mihail Kogalniceanu","Mioveni","Mircea","Mizil","Moara Vlasiei","Mocira","Mogosoaia","Moinesti","Moisei","Moldova Noua","Moreni","Moroda","Motru","Murfatlar","Musenita","Nana","Nasaud","Navodari","Negresti","Negru Voda","Nenciulesti","Nicolae Balcescu","Nucsoara","Obreja","Ocna Mures","Ocnita","Odobesti","Odorheiu Secuiesc","Oltenita","Oradea","Oravita","Orsova","Otelu Rosu","Otopeni","Padureni","Panciu","Panduri","Pantelimon","Pascani","Patarlagele","Pecica","Petresti","Petresti","Plopeni","Podu Dambovitei","Poiana Ilvei","Popesti","Popesti-Leordeni","Potlogi","Prejmer","Prim Decembrie","Prod","Pucheni","Rabagani","Racari","Racoasa","Racovita","Radauti","Radovanu","Ramnicu Sarat","Reghin","Roata de Jos","Rohia","Roman","Rosia","Rosiori de Vede","Sacele","Salatrucel","Salcea","Salcioara","Salonta","Sancraieni","Sangeorge","Sangeorz-Bai","Santimbru","Satu Mare","Saveni","Schela","Sebes","Seini","Sfantu Gheorghe","Sfantu Gheorghe","Sfantu-Gheorghe","Sibiu","Siculeni","Sighisoara","Simeria","Slatina","Slobozia","Soimus","Somcuta Mare","Sovata","Spiru Haret","Stalpeni","Stanilesti","Stefanesti","Stefanestii de Jos","Stroesti","Suceava","Susenii Bargaului","Sutesti","Talisoara","Tandarei","Targu Gangulesti","Targu Neamt","Tartasesti","Tatarani","Tatarusi","Tecuci","Teiu","Teius","Telega","Tibeni","Tileagd","Timus","Tina","Tipari","Titesti","Titu","Tomesti","Topoloveni","Traian","Trestiana","Tulcea","Tulnici","Tunari","Turda","Turnu Magurele","Turnu Ruieni","Tuzla","Uioara de Jos","Ungheni","Unirea","Unirea","Urlati","Urziceni","Utvin","Vacaresti","Valcea","Valea Lupului","Valea Seaca","Valenii de Munte","Vama","Vaslui","Vatra Dornei","Vedea","Vetresti-Herastrau","Victoria","Videle","Vidin","Vidra","Viseu de Jos","Viseu de Sus","Voinesti","Voiteg","Voluntari","Voronet","Zetea","Zimnicea"],"Russia":["Abakan","Abinsk","Achinsk","Adygeysk","Agapovka","Agidel","Akhtubinsk","Aksay","Aksenovo","Alapayevsk","Aldan","Aleksandrov","Aleksandrovka","Alekseyevka","Alekseyevka","Aleksin","Aleksino","Aleysk","Alikovo","Altay","Altayskoye","Amur","Amursk","Anapa","Angarsk","Anuchino","Anzhero-Sudzhensk","Apatity","Apazovo","Aprelevka","Aramil","Ariadnoye","Arkhangelsk","Arkhara","Armavir","Aro","Artem","Arti","Arzamas","Asbest","Asha","Ashchibutak","Asino","Astrakhan","Atkarsk","Atlas","Avangard","Avri","Avtozavodskiy Rayon","Aykino","Azov","Bagan","Baksan","Balabanovo","Balakovo","Balashikha","Balashov","Baltiysk","Barabash","Baranchinskiy","Barda","Barnaul","Barnaul","Bashkortostan","Bataysk","Baykal","Baza","Begunitsy","Belaya Kalitva","Belebey","Belgorod","Belgorod","Belogorka","Belogorsk","Belorechensk","Beloretsk","Belovo","Belyy","Berdsk","Berezayka","Berezniki","Berezovka","Beryozovsky","Betlitsa","Beya","Bezhetsk","Bibayevo","Bilibino","Birobidzhan","Birsk","Birzha","Biysk","Blagovar","Blagoveshchensk","Bogdanovich","Bogdashino","Bogoroditsk","Bogorodsk","Bogorodskoye","Boguchany","Boksitogorsk","Bologoye","Bor","Borisoglebsk","Borkovka","Borodino","Borodynovka","Borovichi","Borovskiy","Borzya","Bovykiny","Bras","Bratsk","Brod","Bronnitsy","Bryansk","Bugry","Bulgakov","Buyantsevo","Buzuluk","Chapayevsk","Chaplygin","Chastyye","Chaykovskiy","Cheboksary","Chekhov","Chelbasskaya","Chelyabinsk","Chemashur","Cheremkhovo","Cherepanovo","Cherepovets","Cherkessk","Cherkizovo","Chernigovka","Chernogolovka","Chernogorsk","Chernushka","Chernushka","Chernyakhovsk","Chesnokovka","Chik","China","Chita","Chiverevo","Chkalov","Chudovo","Chyorny Yar","Dagomys","Dalmatovo","Damkhurts","Danilov","Dedenevo","Dedovsk","Denisovo","Derbent","Desnogorsk","Detchino","Dimitrovgrad","Dinskaya","Divnogorsk","Divo","Dmitriyevka","Dmitrov","Dobryanka","Dolgoprudnyy","Domodedovo","Donetsk","Donskoy","Drezna","Druzhba","Dubenka","Dubna","Dubovka","Dubovka","Dubrovka","Dudinka","Dyurtyuli","Dzerzhinsk","Dzerzhinskiy","Elektrogorsk","Elektrostal","Elektrougli","Elista","Enkheluk","Fatezh","Fialka","Filatovskoye","Filial","Frolovo","Frunzenskiy","Fryazino","Furmanov","Gagarin","Gagino","Gatchina","Gaurilov","Gelendzhik","Georgiyevsk","Georgiyevskoye","Glazov","Glazunovka","Glebychevo","Gogolya","Golitsyno","Golovchino","Gorbatov","Gorin","Gorno-Altaysk","Gornozavodsk","Gorodna","Granit","Grozny","Gryazovets","Gubakha","Gubkin","Gubkin","Gubkinskiy","Gudermes","Gukovo","Gusev","Gusinoozyorsk","Gvardeysk","Ibresi","Ibrya","Iglino","Igra","Ilim","Ilovlya","Ilya","Insar","Inta","Irbit","Irkutsk","Isheyevka","Ishim","Ishimbay","Ishimskiy","Ishkulovo","Ishley","Iskitim","Istra","Ivangorod","Ivanovo","Izberbash","Izhevsk","Izmaylovo","Kabanovo","Kabardino","Kachkanar","Kadrovik","Kalashnikovo","Kalinina","Kaliningrad","Kalininskaya","Kalino","Kaltan","Kaluga","Kamchatka","Kamenka","Kamennogorsk","Kamennomostskiy","Kamenolomni","Kamensk","Kamensk-Shakhtinskiy","Kamyshin","Kamyshovka","Kanash","Kanavka","Kandalaksha","Kanevskaya","Kansk","Karabash","Karabulak","Karachev","Karin Perevoz","Karla Marksa","Kartaly","Kashira","Kasimov","Kasli","Kastornoye","Katav-Ivanovsk","Kavkaz","Kemerovo","Khabarovsk","Khabarskoye","Khangash-Yurt","Khanty-Mansiysk","Kharp","Khasavyurt","Khimki","Kholmistyy","Kholmsk","Khrenovoye","Kichmengskiy Gorodok","Kimovsk","Kimry","Kineshma","Kingisepp","Kirgiz-Miyaki","Kirilly","Kirishi","Kirov","Kirova","Kirovgrad","Kirovo-Chepetsk","Kirovsk","Kirovsk","Kirovskaya","Kirsanov","Kiryabinskoye","Kirzhach","Kislovodsk","Kizlyar","Kizner","Klimovsk","Klin","Klintsy","Klyuchi","Klyuchi-Bulak","Kochkurovo","Kodinsk","Kola","Kolomino","Kolomna","Kolpashevo","Kolpino","Komarov","Komintern","Komsomolsk-on-Amur","Konakovo","Kondopoga","Konosha","Kopeysk","Koptyuga","Korkino","Korolev","Korsakov","Koryazhma","Kosteniki","Kostomuksha","Kostroma","Kotlas","Kovdor","Kovrov","Kraskovo","Krasnoarmeysk","Krasnoarmeyskaya","Krasnoarmeyskoye","Krasnodar","Krasnodarskiy","Krasnogorsk","Krasnogorskiy","Krasnogvardeyskiy","Krasnokamensk","Krasnokamensk","Krasnokamsk","Krasnoobsk","Krasnoufimsk","Krasnoyarsk","Krasnoye-na-Volge","Krasnoznamensk","Krasnoznamensk","Krasnyy Kut","Krasnyy Sulin","Krasnyy Yar","Kristall","Kromy","Kronshtadt","Kropotkin","Krugloye","Krymsk","Kstovo","Kubinka","Kugesi","Kulikov","Kumertau","Kungur","Kupavna","Kurchatov","Kurgan","Kurgan","Kurgan","Kurganinsk","Kursk","Kurtamysh","Kusa","Kusakovka","Kushnarenkovo","Kushva","Kuybyshev","Kuznetsk","Kuznetskiy Rayon","Kuzovatovo","Kvatchi","Kyshtym","Kyzyl","Labinsk","Labytnangi","Lada","Lakinsk","Lampovo","Lazo","Lebedev","Lenina","Leningradskaya","Leningradskiy","Leninogorsk","Leninsk-Kuznetsky","Leninskiy","Leninskoye","Lenkino","Lermontov","Lesnoy","Lesnoy","Lesnoy","Lesnoy Gorodok","Lesodacha","Lesosibirsk","Lesozavodsk","Likino-Dulevo","Linda","Linevo","Liniya","Lipetsk","Lipetsk","Lisikha","Liski","Livny","Lobnya","Lodeynoye Pole","Lomonosov","Losino-Petrovskiy","Luchegorsk","Lukhovitsy","Luzino","Lyantor","Lytkarino","Lyubertsy","Magadan","Magdagachi","Magnitnyy","Magnitogorsk","Makhachkala","Maksimovka","Malaya Vishera","Malino","Maloyaroslavets","Malysheva","Mamontovka","Mamontovo","Manturovo","Mariinskiy Posad","Markovo","Marks","Maslyanino","Mayakovskogo","Maykop","Maykor","Mednogorsk","Medvedevo","Medvenka","Mega","Megion","Melenki","Meleuz","Metallostroy","Metallurg","Mezhdurechensk","Mga","Miass","Miasskoye","Michurinsk","Mikhaylovskoye","Millerovo","Mineralnye Vody","Minusinsk","Mira","Moldavanskoye","Monchegorsk","Monino","Morozov","Morozovo","Morozovsk","Morshansk","Moscow","Moskovskaya","Moskovskiy","Mostovskoy","Mozdok","Mozhaysk","Mozhga","Mtsensk","Muravlenko","Murmansk","Murmashi","Murom","Myski","Mytishchi","Naberezhnyye Chelny","Nadezhdinka","Nadvoitsy","Nadym","Nakhabino","Nakhodka","Naro-Fominsk","Nartkala","Naryan-Mar","Nauka","Naumkino","Nazarovo","Nazran","Neftekamsk","Neftekumsk","Nefteyugansk","Nelazskoye","Nelidovo","Neman","Neryungri","Neva","Nevinnomyssk","Nevskiy","Neya","Nikel","Nikolayevsk","Nikolayevsk-on-Amur","Nikulin","Nizhegorodskaya","Nizhnekamsk","Nizhneudinsk","Nizhnevartovsk","Nizhneyashkino","Nizhniy Novgorod","Nizhniy Odes","Nizhniy Tagil","Noginsk","Noginskaya","Nova","Novator","Novaya Igirma","Novaya Silava","Novoaltaysk","Novobelokatay","Novocheboksarsk","Novocherkassk","Novodmitriyevka","Novodvinsk","Novokorsunskaya","Novokruchininskiy","Novokuybyshevsk","Novokuznetsk","Novomichurinsk","Novomoskovsk","Novorossiysk","Novoselovo","Novosemeykino","Novoshakhtinsk","Novoshakhtinskiy","Novosibirsk","Novosokolovogorskiy","Novotroitsk","Novovarshavka","Novovoronezh","Novoye Devyatkino","Novozavedennoye","Novozolotovskaya","Novozybkov","Novy Urengoy","Novyy","Noyabrsk","Nyagan","Nytva","Obninsk","Obyedineniye","Ocher","Odintsovo","Odintsovo","Ogarev","Okha","Okhansk","Okulovka","Olenegorsk","Olimpiyskiy","Omchak","Omsk","Orekhovo-Zuyevo","Orenburg","Orlovskiy","Orshanka","Orsk","Oshib","Osnova","Ostankino","Ostrov","Otradnoye","Otradnyy","Ovchinnikov","Panayevsk","Pangody","Parapino","Parfino","Pargolovo","Parkovyy","Partizansk","Patrushi","Pavlovo","Pavlovsk","Pavlovskaya","Pavlovskaya Sloboda","Pavlovskiy Posad","Pechora","Pechory","Penza","Perepravnaya","Perm","Perovka","Persianovka","Pervo","Pervomayskaya","Pervouralsk","Peschanka","Pestovo","Petergof","Petropavlovka","Petropavlovsk-Kamchatsky","Petrozavodsk","Pikalyovo","Pioner","Piter","Pitkyaranta","Pivovar","Plavsk","Pleloye","Podgortsy","Podolsk","Podstepki","Pokrov","Polevskoy","Polyarnyy","Poronaysk","Posad","Poselok","Poselok","Postnikova","Potok","Povarovo","Povedniki","Poztykeres","Pregradnaya","Priozersk","Prirechensk","Progress","Prokhladnyy","Protvino","Pryazha","Pskov","Pskovskoye","Pugachev","Pulkovo","Purovsk","Pushchino","Pushchino","Pushchino","Pushkin","Pushkina","Pushkino","Putilkovo","Pyatigorsk","Pychas","Pyshma","Radist","Raduga","Rakita","Ramenskoye","Rassvet","Ratmirovo","Raychikhinsk","Redkino","Reftinskiy","Reutov","Revda","Revda","Rezh","Rikasikha","Rodionovka","Rodionovo-Nesvetayskaya","Rodniki","Romanovka","Rosa","Roshchino","Roshchino","Rossiyskiy","Rostov","Rostov-on-Don","Rostovskaya","Rovnoye","Rozhdestvenka","Rubin","Rubtsovsk","Russa","Ruza","Ruzayevka","Ryasnoye","Ryazan","Rybinsk","Rybnoye","Rzhev","Safonovo","Saint Petersburg","Salavat","Salekhard","Salym","Samara","Samara","Samara","Samsonovka","Saransk","Sarapul","Saratov","Sarov","Sartykov","Sary","Satis","Satka","Sayanogorsk","Sayansk","Sebezh","Segezha","Selo","Selyatino","Semibratovo","Semyonov","Serafimovskiy","Serdobsk","Sergeyevka","Sergiyev Posad","Sergiyevskoye","Serov","Serpukhov","Sertolovo","Seryshevo","Sestroretsk","Severo","Severo-Zapad","Severodvinsk","Severomorsk","Seversk","Severskaya","Sevsk","Shadrinsk","Shakhty","Shalinskoye","Shalushka","Sharapova Okhota","Sharnutovskiy","Shatura","Shaturtorf","Shchekino","Shchelkovo","Shebalino","Shebekino","Sheksna","Shelekhov","Sheregesh","Shoshma","Shumerlya","Sibay","Sistema","Skala","Skat","Skovorodino","Slantsy","Slavgorod","Slavyanka","Slavyansk-na-Kubani","Sloboda","Slyudyanka","Smolensk","Smolenskaya","Snegiri","Snezhinsk","Snezhinskiy","Snezhnogorsk","Sobinka","Sochi","Sodyshka","Sofrino","Sofrino","Sokol","Sokolovo","Soldatskoye","Solikamsk","Solnechnogorsk","Sorochinsk","Sortavala","Sosnogorsk","Sosnovo","Sosnovoborsk","Sosnovyy Bor","Sosny","Sovetsk","Sovetskiy","Spas-Demensk","Spassk","Sputnik","Sredneuralsk","Srostki","Staraya Kupavna","Staraya Russa","Starobachaty","Starodub","Staronizhestebliyevskaya","Staropesterevo","Starovelichkovskaya","Start","Stary Oskol","Stavropol","Sterlitamak","Strezhevoy","Stroiteley","Studenets","Stupino","Sukhanovo","Surgut","Surkhakhi","Sursk","Sverdlova","Sverdlovskaya","Sverdlovskiy","Svetlaya","Svetlogorsk","Svetlograd","Svetlyy","Svetlyy","Svetogorsk","Sviblovo","Svirsk","Svobodnaya","Svobodnyy","Syamzha","Syktyvkar","Taganrog","Tagil","Taksimo","Taldom","Tambov","Tapkhar","Tarko-Sale","Tarusa","Tatlybayevo","Taushkasy","Tayga","Tayshet","Tazovskiy","Techa","Temryuk","Teykovo","Tikhoretsk","Tikhvin","Tim","Timiryazev","Tochka","Tolstoy","Tolyatti","Tomilino","Tomsk","Topki","Torzhok","Tosno","Trekhgornyy","Troitsk","Troitsk","Troitsko-Pechorsk","Trubchevsk","Tsna","Tsudakhar","Tuapse","Tuchkovo","Tula","Tulun","Turinsk","Tuymazy","Tver","Tynda","Tyrma","Tyrnyauz","Tyumen","Uchaly","Udomlya","Ufa","Ufa","Uglegorsk","Uglich","Ugra","Ugresha","Ukhta","Uktuz","Ulan-Ude","Ulyanovsk","Unecha","Ural","Uray","Urengoy","Urgal","Urus-Martan","Uryupinsk","Urzhum","Usinsk","Usinskoye","Uspenskoye","Ussuriysk","Uvarovo","Uyar","Uzlovaya","Vagay","Valday","Valentin","Vanino","Varvarovka","Vega","Velikiy Ustyug","Velikiye Luki","Veliky Novgorod","Verkhnekazymskiy","Verkhniy Ufaley","Verkhnyaya Pyshma","Verkhnyaya Salda","Veshki","Vichuga","Vidnoye","Vikhorevka","Vinsady","Vitebskaya","Vladikavkaz","Vladimir","Vladivostok","Vladykino","Vnukovo","Volga","Volga","Volga","Volgodonsk","Volgograd","Volgorechensk","Volkhonshchino","Volkhov","Volna","Volochek","Volodarskiy","Vologda","Volovo","Volzhsk","Volzhskiy","Volzhskiy","Vorkuta","Voronezh","Voronezhskiy","Vorovskogo","Voskresensk","Voskresenskoye","Voskresenskoye","Vostochnaya","Vostochnyy","Votkinsk","Vsevolozhsk","Vurnary","Vyatka","Vyatskiye Polyany","Vyazemskiy","Vyazniki","Vyborg","Vyksa","Vysokogornyy","Vysokovsk","Vytegra","Yakhroma","Yakovlevo","Yakutsk","Yalta","Yalutorovsk","Yanaul","Yaratovo","Yaroslavl","Yashkino","Yaya","Yekaterinburg","Yekaterinoslavka","Yekaterinovka","Yelabuga","Yelanskiy","Yelets","Yelizovo","Yermolkino","Yessentuki","Yeysk","Yoshkar-Ola","Yugorsk","Yugra","Yurga","Yuzhno-Sakhalinsk","Zainsk","Zaokskiy","Zaozersk","Zaprudnya","Zaraysk","Zarechenskiy","Zarechnyy","Zarinsk","Zavodoukovsk","Zavodouspenskoye","Zelenodolsk","Zelenogorsk","Zelenogorsk","Zelenograd","Zelenogradsk","Zernograd","Zeya","Zheleznodorozhnyy","Zheleznogorsk","Zheleznogorsk","Zheleznogorsk-Ilimskiy","Zheleznovodsk","Zhigulevsk","Zhirnovsk","Zhukovskiy","Zhukovskogo","Zhuravna","Zima","Zlatoust","Zolotarevka","Zori","Zubovo","Zvenigorod","Zvenigovo","Zvezda"],"Saint Lucia":["Anse La Raye","Castries","Choiseul","Dauphin","Gros Islet","Vieux Fort"],"San Marino":["Acquaviva","Falciano","Fiorentino","San Marino","Serravalle"],"Saudi Arabia":["Abha","Abqaiq","Al Bahah","Al Faruq","Al Hufuf","Al Qatif","Al Yamamah","At Tuwal","Buraidah","Dammam","Dhahran","Hayil","Jazirah","Jazirah","Jeddah","Jizan","Jubail","Khamis Mushait","Khobar","Khulays","Linah","Madinat Yanbu` as Sina`iyah","Mecca","Medina","Mina","Najran","Rabigh","Rahimah","Rahman","Ramdah","Ras Tanura","Riyadh","Sabya","Safwa","Sakaka","Sambah","Sayhat","Tabuk","Yanbu` al Bahr"],"Senegal":["Boussinki","Camberene","Dakar","Dodji","Guediawaye","Kaolack","Kedougou","Louga","Madina Kokoun","Saint-Louis","Sama","Tanaf"],"Serbia":["Ada","Aleksinac","Apatin","Arilje","Avala","Backa Topola","Backi Jarak","Backi Petrovac","Backo Gradiste","Banatsko Novo Selo","Barajevo","Basaid","Batajnica","Becej","Belgrade","Bocar","Bor","Cantavir","Coka","Cukarica","Cuprija","Debeljaca","Despotovac","Dolovo","Drenovac","Futog","Glozan","Golubinci","Gornji Milanovac","Grocka","Ingija","Izvor","Jagodina","Kacarevo","Kanjiza","Kovin","Kragujevac","Kraljevo","Leskovac","Loznica","Melenci","Nikinci","Nova Pazova","Novi Banovci","Novi Becej","Novi Belgrade","Novi Pazar","Novi Sad","Odzaci","Palic","Paracin","Petrovac","Petrovaradin","Pirot","Popovac","Priboj","Prokuplje","Ratkovo","Ruma","Rumenka","Savski Venac","Selo Mladenovac","Senta","Sibac","Simanovci","Sirig","Smederevo","Sombor","Srbobran","Sremcica","Sremska Kamenica","Sremska Mitrovica","Sremski Karlovci","Stara Pazova","Stari Banovci","Subotica","Surcin","Svilajnac","Svrljig","Temerin","Titel","Tornjos","Ugrinovci","Umcari","Umka","Vajska","Valjevo","Veternik","Vrbas","Zajecar","Zemun Polje","Zlatibor","Zrenjanin"],"Singapore":["Ang Mo Kio","Bedok","Bishan","Boon Lay","Bukit Batok","Bukit Merah","Bukit Panjang","Bukit Timah","Central Area","Changi","Choa Chu Kang","Clementi","Downtown Core","Geylang","Hougang","Jurong East","Jurong West","Kallang","Lim Chu Kang","Mandai","Marine Parade","Newton","Novena","Orchard","Outram","Pasir Ris","Paya Lebar","Punggol","Queenstown","River Valley","Rochor","Seletar","Sembawang","Sengkang","Serangoon","Southern Islands","Sungei Kadut","Tampines","Tanglin","Toa Payoh","Tuas","Western Islands","Western Water Catchment","Woodlands","Yishun"],"Slovakia":["Bahon","Baka","Banovce nad Bebravou","Bardejov","Bela","Beladice","Bernolakovo","Besenov","Blatnica","Bobrov","Bohdanovce","Boleraz","Borovce","Branc","Bratislava","Brezno","Brezova pod Bradlom","Bystricka","Cecejovce","Cechynce","Cerova","Cerveny Hradok","Cerveny Kamen","Chlebnice","Chorvatsky Grob","Chtelnica","Cifer","Detva","Diakovce","Diviaky nad Nitricou","Dlha nad Oravou","Dlhe Klcovo","Dlhe nad Cirochou","Dolna Marikova","Dolna Streda","Dolne Oresany","Dolne Vestenice","Dolny Hricov","Dolny Stal","Druzstevna pri Hornade","Eliasovce","Fintice","Galanta","Gbely","Gelnica","Giraltovce","Golianovo","Handlova","Hencovce","Hlinik","Hlinik nad Hronom","Hlohovec","Holic","Holice","Horna Lehota","Horna Stubna","Horne Oresany","Horne Saliby","Horny Smokovec","Hradiste","Hrinova","Hrochot,Slovakia","Hruby Sur","Ilava","Istebne","Ivanka pri Dunaji","Jablonove","Jacovce","Jasenica","Jaslovske Bohunice","Jelenec","Jelka","Kajal","Kanianka","Klatova Nova Ves","Klokoc","Klokocov","Kolarovo","Komjatice","Kopcany","Kosicka Nova Ves","Kremnica","Krizovany nad Dudvahom","Krompachy","Krupina","Krusovce","Kukova","Kvetoslavov","Kysucky Lieskovec","Ladce","Lednicke Rovne","Lehota","Lemesany","Levice","Likavka","Liptovske Revuce","Liptovsky Hradok","Lozorno","Lubina","Ludanice","Lukacovce","Madunice","Malacky","Maly Lapas","Marianka","Martin","Mesto","Michalovce","Miloslavov","Mojmirovce","Moldava nad Bodvou","Moravany nad Vahom","Mutne","Myjava","Nana","Nededza","Nitra","Nitrianske Rudno","Nitrianske Sucany","Nizna","Nizna Kamenica","Nova Bana","Novaky","Nove Sady","Novy Salas","Nyrovce","Okoc","Olesna","Opatovce nad Nitrou","Opoj","Oravske Vesele","Pastuchov","Pata","Pernek","Pezinok","Plave Vozokany","Plavecke Podhradie","Pliesovce","Pobedim","Podbrezova","Podolie","Polomka","Poprad","Potvorice","Praha","Prakovce","Praznovce","Prievidza","Proc","Reca","Rosina","Rovinka","Ruzindol","Sabinov","Samorin","Sarisske Bohdanovce","Secovce","Secovska Polianka","Selice","Selpice","Sena","Senec","Senica","Sipkove","Skalica","Sladkovicovo","Slovenska Ves","Slovensky Grob","Smizany","Snina","Sobrance","Solosnica","Spacince","Spissky Hrusov","Spissky Stiavnik","Spissky Stvrtok","Stara Lesna","Stara Tura","Stary Smokovec","Staskov","Stefanov","Stropkov","Studienka","Stupava","Sucany","Sucha nad Parnou","Svaty Kriz","Svaty Peter","Svit","Svodin","Tajov","Terchova","Tesedikovo","Tlmace","Tomasov","Torysky","Trnava","Trnovec nad Vahom","Trstena","Turany","Tvrdosin","Tvrdosovce","Udavske","Urmince","Vahovce","Varhanovce","Varin","Vecelkov","Velcice","Velicna","Velky Meder","Vinne","Vitanova","Vlckovce","Vlkanova","Vojcice","Vrable","Vrutky","Vysne Raslavice","Vysny Orlik","Zakamenne","Zavod","Zbince","Zelenec","Zeliezovce","Ziar nad Hronom","Zikava","Zlate","Zuberec","Zvolen"],"Slovenia":["Ankaran","Begunje na Gorenjskem","Beltinci","Besnica","Bevke","Bistrica pri Rusah","Bled","Bohinjska Bela","Borovnica","Breginj","Brestanica","Breznica","Cemsenik","Cerklje ob Krki","Cerknica","Cersak","Cirkovce","Crensovci","Dekani","Dob","Dobravlje","Dobrova","Dobrunje","Dol pri Ljubljani","Dolenjske Toplice","Dornava","Dravograd","Globoko","Gmajnica","Gorenja Vas","Gorisnica","Gornja Radgona","Grize","Grosuplje","Horjul","Hotedrsica","Hrastnik","Hrusica","Idrija","Ig","Ilirska Bistrica","Izola","Jesenice","Kamnik","Kidricevo","Knezak","Kobarid","Kojsko","Komenda","Koper","Krajna","Kranj","Kranjska Gora","Lenart v Slov. Goricah","Lendava","Lesce","Limbus","Litija","Ljubecna","Ljubljana","Log pri Brezovici","Logatec","Lokev","Lovrenc na Dravskem Polju","Lovrenc na Pohorju","Maribor","Markovci","Medvode","Menges","Mezica","Miklavz na Dravskem Polju","Miren","Mirna","Mojstrana","Moravce","Mozirje","Murska Sobota","Naklo","Notranje Gorice","Nova Cerkev","Nova Gorica","Novo Mesto","Pernica","Pesnica pri Mariboru","Petrovce","Piran","Pobegi","Podbocje","Polhov Gradec","Poljcane","Polzela","Postojna","Prebold","Preserje","Prestranek","Prevalje","Ptuj","Puconci","Radlje ob Dravi","Radomlje","Radovljica","Rakek","Ravne","Ravne na Koroskem","Rocinj","Secovlje","Selnica ob Dravi","Sempeter pri Gorici","Sencur","Sentjanz","Sentvid pri Sticni","Sevnica","Skofljica","Slovenj Gradec","Slovenska Bistrica","Slovenske Konjice","Smarje","Smarje pri Jelsah","Smarje-Sap","Smartno ob Paki","Smlednik","Sostanj","Spodnje Hoce","Spodnji Brnik","Spodnji Duplek","Spodnji Ivanjci","Sredisce ob Dravi","Stahovica","Stara Cerkev","Stari Trg pri Lozu","Starse","Tisina","Tolmin","Trbovlje","Trzic","Trzin","Velenje","Velika Loka","Verzej","Videm","Vipava","Vodice","Vojnik","Vrhnika","Zagorje ob Savi","Zelezniki","Zgornja Polskava","Zgornje Gorje","Zgornje Hoce","Zgornje Skofije","Zidani Most","Ziri"],"South Africa":["Alberton","Alice","Alrode","Amanzimtoti","Ashton","Atlantis","Balfour","Bathurst","Beaufort West","Bedfordview","Belhar","Bellville","Benoni","Bergvliet","Bethal","Bethlehem","Bloemfontein","Boksburg","Bothasig","Botshabelo","Braamfontein","Brackenfell","Brakpan","Bredasdorp","Brits","Bronkhorstspruit","Brooklyn","Bryanston","Buffalo","Butterworth","Cape Town","Capital Park","Carletonville","Carolina","Centurion","City of Cape Town","Clanwilliam","Claremont","Coega","Coligny","Constantia","Craighall","Cullinan","De Aar","Delmas","Deneysville","Despatch","Doornfontein","Dube Location","Duiwelskloof","Dullstroom","Dundee","Durban","Durbanville","East London","Edenburg","Edenvale","Eersterivier","Elandsfontein","Elarduspark","Eloff","Elsburg","Elsenburg","Emerald Hill","Emnambithi-Ladysmith","Empangeni","Erasmia","Ermelo","Eshowe","Evander","Faure","Florida Glen","Fochville","Fordsburg","Fort Cox","Franschhoek","Gansbaai","Ganspan","George","Germiston","Gezina","Gillitts","Gingindlovu","Glen Austin","Goodwood","Graaff Reinet","Grabouw","Grahamstown","Greytown","Groblersdal","Haenertsburg","Harrismith","Hartbeespoort","Hartenbos","Hartswater","Hatfield","Hawston","Hazyview","Heidelberg","Hekpoort","Henley on Klip","Hennenman","Hermanus","Hillcrest","Hilton","Himeville","Hluhluwe","Hoedspruit","Hogsback","Houghton Estate","Hout Bay","Howick","Humansdorp","Hyde Park","Irene","Isando","Ixopo","Johannesburg","Kalkbaai","Katlehong","Kempton Park","Kimberley","Kingsborough","Kingsley","Kingsmead","Kinross","Kleinmond","Klerksdorp","Kloof","Knysna","Kokstad","Kraaifontein","Kranskop","Kriel","Kroonstad","Krugersdorp","Kuils River","KwaDukuza","La Lucia","La Motte","Ladybrand","Lansdowne","Laudium","Lephalale","Lichtenburg","Lombardy East","London","Louis Trichardt","Lutzville","Lydenburg","Lyndhurst","Lynnwood","Lyttelton","Machadodorp","Mafikeng","Maidstone","Majuba","Malmesbury","Malvern","Maraisburg","Margate","Marshalltown","Meadowridge","Medunsa","Melkbosstrand","Merrivale","Messina","Meyerton","Middelburg","Middelburg","Midrand","Milnerton","Mmabatho","Mobeni","Modderfontein","Mokopane","Montagu","Monument Park","Mooi River","Mookgophong","Moorreesburg","Morningside Manor","Mossel Bay","Mount Edgecombe","Mthatha","Muizenberg","Napier","Nelspruit","New Germany","Newcastle","Newlands","Nigel","Northcliff","Odendaalsrus","Ogies","Olifantsfontein","Onderstepoort","Onverwacht","Oranjeville","Oranjezicht","Ottosdal","Oudtshoorn","Overport","Paarl","Panorama","Parktown","Parkview","Parow","Peninsula","Phalaborwa","Philadelphia","Philipstown","Phoenix","Phokeng","Pietermaritzburg","Pinelands","Pinetown","Plettenberg Bay","Plumstead","Polokwane","Pongola","Port Alfred","Port Elizabeth","Port Shepstone","Potchefstroom","Pretoria","Prieska","Primrose","Pringle Bay","Queensburgh","Queenstown","Queenswood","Randburg","Randfontein","Rawsonville","Rhodes","Richards Bay","Richmond","Riebeek-Kasteel","Rivonia","Roggebaai","Roodepoort","Rooigrond","Rooihuiskraal","Rosebank","Rosettenville","Rosslyn","Rustenburg","Sabie","Saint Helena Bay","Saint James","Saldanha","Salt Rock","Sandown","Sandton","Sasolburg","Schweizer-Reneke","Scottburgh","Sebokeng","Secunda","Sedgefield","Senekal","Shelly Beach","Silverton","Sinoville","Somerset West","Soshanguve","Soweto","Springs","Standerton","Stanford","Stellenbosch","Stilfontein","Strand","Sun Valley","Swartkops","Temba","Tembisa","Thabazimbi","The Rest","Thohoyandou","Three Anchor Bay","Three Rivers","Tokai","Tongaat","Tzaneen","Uitenhage","Umbogintwini","Umdloti","Umhlanga","Umkomaas","Umtentweni","Upington","Vaalbank","Vaalpark","Vanderbijlpark","Vereeniging","Verulam","Villiersdorp","Virginia","Vosloorus","Vrededorp","Vredenburg","Vryheid","Walkerville","Walmer Heights","Warner Beach","Wartburg","Waverley","Waverley","Welgelegen","Welgemoed","Welkom","Welkom","Wellington","Weltevreden","Weltevreedenpark","Westonaria","Westville","White River","Wilderness","Winterton","Witbank","Witpoortjie","Wonderboom","Worcester","Wynberg","Zeerust"],"Spain":["A Cidade","A Estrada","A Pobra do Caraminal","Abadino","Abanilla","Abanto","Abaran","Abegondo","Abrera","Acala del Rio","Aceuchal","Adeje","Ador","Adra","Adrall","Aduna","Agaete","Agoncillo","Agost","Agramunt","Agreda","Aguadulce","Aguilafuente","Aguilar","Aguilar de Campoo","Aguilar del Rio Alhama","Agullana","Agullent","Ahigal","Aielo de Malferit","Aiguafreda","Aizarnazabal","Aizoain","Ajalvir","Ajo","Ajofrin","Alaejos","Alagon","Alameda","Alanis","Alava","Alba de Tormes","Albacete","Albaida","Albal","Albalat dels Sorells","Albalat dels Tarongers","Albalate de Cinca","Albarreal de Tajo","Albatera","Albelda de Iregua","Albendin","Alberic","Alberite","Albolote","Alboraya","Albox","Albuixech","Albujon","Alburquerque","Alcala de Xivert","Alcala del Obispo","Alcala la Real","Alcanadre","Alcanar","Alcantara","Alcantarilla","Alcarras","Alcazar de San Juan","Alcobendas","Alcoletge","Alcorisa","Alcossebre","Alcover","Alcoy","Aldaia","Aldealsenor","Aldeamayor de San Martin","Aldeanueva","Aldeanueva de Ebro","Aldeaseca de Armuna","Aldeatejada","Alegria","Alella","Alfafar","Alfajarin","Alfambra","Alfara de Algimia","Alfara del Patriarca","Alfaro","Alfarrasi","Alfondeguilla","Alforja","Algadefe","Algaida","Algar","Algarrobo","Algeciras","Algemesi","Algete","Algezares","Alginet","Algodonales","Algorta","Alguazas","Alhama de Aragon","Alhama de Granada","Alhama de Murcia","Alhambra","Alhaurin de la Torre","Alhaurin el Grande","Alhendin","Alicante","Aliseda","Aljaraque","Allariz","Almagro","Almansa","Almargen","Almassera","Almassora","Almazan","Almazcara","Almenar","Almenara","Almendralejo","Almensilla","Almodovar del Campo","Almodovar del Rio","Almonacid de Zorita","Almonte","Almoradi","Almoster","Almudebar","Almuna","Alonsotegi","Alora","Alosno","Alovera","Alozaina","Alpedrete","Alpicat","Alquerias","Alta","Altafulla","Altea","Altet","Altura","Alumbres","Alza","Alzira","Amavida","Amer","Ames","Ametlla","Amorebieta","Amposta","Ampuero","Amurrio","Anchuelo","Andeiro","Andoain","Andorra","Andosilla","Andujar","Anglesola","Anguciana","Anoeta","Anora","Anorbe","Antas","Antequera","Antigua","Aracena","Arafo","Arama","Aranda de Duero","Aranguren","Aranjuez","Aravaca","Arbizu","Arbo","Arboleas","Arca","Arcade","Arce","Archena","Archidona","Arcicollar","Arcos de la Frontera","Arenas de San Pedro","Arenys de Mar","Arenys de Munt","Ares","Arevalo","Argamasilla de Alba","Argamasilla de Calatrava","Arganda","Argelaguer","Argentona","Arges","Argonos","Arico","Arino","Arjona","Armilla","Armunia","Arnedillo","Arnedo","Arnuero","Aroche","Arona","Arrecife","Arriate","Arrigorriaga","Arroyal","Arroyo","Arroyo de la Luz","Arroyo de la Miel","Arroyo del Ojanco","Arroyomolinos","Arrubal","Artajo","Artajona","Artana","Arteixo","Artenara","Artes","Artesa de Segre","Arucas","Arzua","As Pontes de Garcia Rodriguez","Aspe","Asteasu","Astigarraga","Astorga","Astrabudua","Astrain","Astudillo","Atarfe","Atarrabia","Ataun","Ateca","Autol","Avia","Avinyonet del Penedes","Axpe","Ayamonte","Ayegui","Azagra","Azkoitia","Aznalcazar","Aznalcollar","Azpeitia","Azuaga","Azuqueca de Henares","Babilafuente","Badajoz","Badalona","Baena","Baeza","Baga","Bailen","Baina","Bajamar","Balaguer","Balazote","Balenya","Balerma","Balsareny","Balsicas","Banugues","Bara","Barakaldo","Baranain","Barbarroja","Barbastro","Barbate","Barcarrota","Barcelona","Barcena de Cicero","Bargas","Barranda","Barros","Bas","Basauri","Batres","Baza","Beas","Beas de Segura","Becerril de la Sierra","Bedmar","Begijar","Begis","Begues","Begur","Bejar","Belgida","Belicena","Bellpuig","Bellvei","Bellver de Cerdanya","Bellvis","Belvis de Jarama","Belvis de la Jara","Bembibre","Benacazon","Benagalbon","Benahadux","Benahavis","Benamargosa","Benameji","Benatae","Benavarri / Benabarre","Benavente","Benavides","Benejuzar","Beniajan","Beniarbeig","Beniarjo","Beniarres","Benicassim","Benicolet","Benidoleig","Benidorm","Beniel","Benifairo de les Valls","Benifato","Beniganim","Benijofar","Benimodo","Beniparrell","Benisano","Benissa","Benisuera","Benitachell","Beranga","Berango","Berantevilla","Berastegui","Berga","Bergondo","Berguenda","Beriain","Berja","Bermeo","Bernuy","Berriatua","Berriobeiti","Berriozar","Berriz","Berrobi","Berron","Bescano","Betanzos","Betelu","Betera","Beznar","Biar","Bicorp","Bigastro","Bigues i Riells","Bilbao","Binefar","Bitem","Blanca","Blancos","Blanes","Boadilla del Monte","Bocairent","Boceguillas","Boecillo","Bogajo","Boimorto","Boiro","Bolanos de Calatrava","Bollullos de la Mitacion","Bollullos par del Condado","Boltana","Bolvir","Bonares","Borben","Bordils","Borja","Bormujos","Bornos","Borox","Borriol","Botarell","Botorrita","Brafim","Brazatortas","Brea de Aragon","Breda","Brenes","Brihuega","Brion","Briviesca","Broto","Brunete","Buenache de Alarcon","Bueu","Bujaraloz","Bullas","Burela de Cabo","Burgos","Burguillos","Burguillos del Cerro","Burjassot","Burlata","Burriana","Busot","Bustarviejo","Busturi-Axpe","Cabana","Cabanaquinta","Cabanas","Cabanas de la Sagra","Cabanes","Cabanillas del Campo","Cabeza del Buey","Cabezarrubias del Puerto","Cabezo de Torres","Cabezon de la Sal","Caborana","Cabra","Cabrera de Almanza","Cabrerizos","Cabrils","Cacheiras","Cadiar","Cadiz","Cadreita","Caion","Cajar","Cala","Cala del Moral","Cala Millor","Cala Ratjada","Calaf","Calafell","Calahonda","Calahorra","Calamonte","Calasparra","Calatayud","Calatorao","Caldelas","Calders","Caldes de Malavella","Calella","Calig","Callosa de Segura","Calo","Calonge","Calpe","Camarassa","Camarenilla","Camargo","Camarinas","Camarma de Esteruelas","Camas","Cambados","Cambre","Cambrils","Camos","Campanario","Campillo","Campillos","Campina","Campins","Campo","Campo de Criptana","Campo Real","Campohermoso","Camponaraya","Campos","Camprodon","Campuzano","Can Picafort","Canal","Canals","Canar","Candas","Candelaria","Candeleda","Caneja","Canet de Mar","Canete de las Torres","Cangas de Onis","Cangas del Narcea","Cangas do Morrazo","Canillas de Albaida","Canovelles","Cantillana","Cantimpalos","Capdepera","Capela","Capella","Capellades","Capileira","Capmany","Capsec","Carabana","Caravaca","Carbajal de la Legua","Carbajosa de la Sagrada","Carballo","Carcabuey","Carcar","Carcastillo","Cardedeu","Cardenal","Cardenosa","Cardona","Carinena","Carlet","Carmona","Carpesa","Carpio","Carral","Carranque","Carrascal de Barregas","Carrion de los Cespedes","Carrion de los Condes","Carrizo de la Ribera","Cartagena","Cartama","Cartaya","Cartelle","Casabermeja","Casar de Caceres","Casares","Casarrubios del Monte","Casas del Castanar","Casas del Monte","Casas Viejas","Caserio El Campello","Casetas","Casillas de Coria","Casillas del Angel","Casla","Caso","Caspe","Castalla","Castandiello","Castejon","Castejon del Puente","Castell de Ferro","Castellar de la Frontera","Castellar de Santiago","Castellar del Valles","Castellbell i el Vilar","Castellbisbal","Castelldefels","Castellet","Castello","Castellvell del Camp","Castellvi de Rosanes","Castelseras","Castilblanco de los Arroyos","Castilleja de Guzman","Castilleja de la Cuesta","Castillo de Locubin","Castillo del Romeral","Castrillon","Castro","Castro Urdiales","Castrogonzalo","Castropol","Castuera","Catadau","Catarroja","Cati","Catoira","Catral","Catral","Caudete","Cazalegas","Cazorla","Cea","Cebolla","Cebreros","Cecenas","Cedillo del Condado","Celanova","Celeiro","Celeiros","Celra","Cenes de la Vega","Cenicero","Cenicientos","Central","Cerceda","Cercedilla","Cerdeda","Cerro Muriano","Cervello","Cervera","Cervera del Rio Alhama","Cervo","Cetina","Ceuta","Ceuti","Chantada","Chapela","Chauchina","Checa","Chelva","Cheste","Chiclana de la Frontera","Chiclana de Segura","Chilches","Chiloeches","Chinchilla de Monte Aragon","Chipiona","Chiva","Chozas de Canales","Chucena","Churra","Churriana","Churriana de la Vega","Cicero","Cidones","Ciempozuelos","Cieza","Cifuentes","Cigales","Cijuela","Cilleros","Ciriza","Cisterniga","Cistierna","Ciudad Real","Ciudad Rodrigo","Ciutadella","Cizur Menor","Cobatillas","Cobena","Cobisa","Coca","Cocentaina","Cogollos","Coin","Coiros","Colera","Coles","Colinas de Trasmonte","Colindres","Collado","Collado Mediano","Collado Villalba","Collbato","Colmenar de Oreja","Colmenar del Arroyo","Colmenar Viejo","Colmenarejo","Colonia de San Pedro","Comares","Comillas","Competa","Compostela","Conil de la Frontera","Consell","Constanti","Constantina","Consuegra","Corbera","Corbera de Llobregat","Corchuela","Cordova","Corella","Corgo","Coria","Coristanco","Corme-Porto","Cornellana","Corral de Almaguer","Corralejo","Corrales","Corrales","Cortegana","Cortes de la Frontera","Cortiguera","Corvera","Corvera","Coslada","Costa","Costur","Couso de Salas","Covaleda","Cox","Creixell","Crevillent","Cruce de Arinaga","Cruces","Cruilles","Cruz","Cuadros","Cuarte de Huerva","Cubas","Cubas","Cubelles","Cubillos del Sil","Cudillero","Cuellar","Cuenca","Cueto","Cuevas de San Marcos","Cuevas de Vinroma","Cuevas del Almanzora","Cullera","Culleredo","Cunit","Cuntis","Curro","Curtis","Daganzo de Arriba","Daimiel","Dalias","Daroca","Daya Vieja","Deba","Denia","Derio","Deustu","Diezma","Dilar","Dodro","Dolores","Domingo Perez","Don Benito","Dos Hermanas","Dosbarrios","Dosrius","Duenas","Dumbria","Durango","Durcal","Echarri-Aranaz","Egues-Uharte","Eibar","Ejea de los Caballeros","El Abrigo","El Alamo","El Alamo","El Arahal","El Astillero","El Ballestero","El Barco de Avila","El Burgo de Ebro","El Burgo de Osma","el Camp de Mirra","el Campello","El Casar","el Catllar","El Coronil","El Corrillo","El Cuervo","El Ejido","El Escorial","El Escorial","El Espinar","El Garrobo","El Grado","El Grao","El Hoyo de Pinares","el Masnou","El Medano","El Molar","El Moral","el Morche","el Morell","El Palmar","El Palmar de Troya","El Papiol","El Pedernoso","El Perello","el Poal","El Pozo de los Frailes","el Prat de Llobregat","El Provencio","El Puerto","El Raal","El Real de la Jara","El Saler","El Sauzal","El Sotillo","El Tablero","El Torno","El Toro","El Vellon","El Vendrell","El Viso de San Juan","El Viso del Alcor","Elburgo","Elche","Elda","Elechas","Elexalde","Elgoibar","Elgorriaga","Elizondo","Elorrio","els Hostalets de Pierola","Els Monjos","els Pallaresos","Eltzaburu","Encinas Reales","Encinasola","Eneriz","Enguera","Entrambasaguas","Entrevias","Epila","Erandio","Ermua","Errenteria","Escalona","Escalonilla","Escatron","Escurial","Esparreguera","Espartinas","Espejo","Espera","Espiel","Espinardo","Espirdo","Esplugues de Llobregat","Esplus","Espolla","Esquivias","Esteiro","Estella-Lizarra","Estellencs","Estepa","Estepona","Estrada","Ezcaray","Fabero","Falces","Falset","Fasnia","Faura","Felanitx","Fene","Ferreira","Ferreries","Ferrol","Figaro","Figueras","Finestrat","Firgas","Fitero","Flix","Formentera de Segura","Fornells de la Selva","Fortia","Fortuna","Forua","Foz","Fraga","Frailes","Fregenal de la Sierra","Fresno de la Vega","Frigiliana","Friol","Fruiz","Fuengirola","Fuenlabrada","Fuenmayor","Fuensalida","Fuensanta","Fuensanta de Martos","Fuente del Maestre","Fuente el Fresno","Fuente el Saz","Fuente Vaqueros","Fuente-Alamo","Fuentealbilla","Fuentelapena","Fuenterrabia","Fuentes","Fuentes de Andalucia","Fuentes de Ebro","Fuentes de Jiloca","Fuentes de Leon","Fuentes de Valdepero","Gaceta","Galapagar","Galapagos","Galaroza","Galdakao","Galdames Beitia","Galera","Galizano","Gallarta","Gallur","Galvez","Gamiz","Gamonal","Gandesa","Gandia","Garachico","Garcia","Garciaz","Gargallo","Garraf","Garrigas","Garriguella","Garrovillas","Garrucha","Gata","Gata de Gorgos","Gaucin","Gautegiz Arteaga","Gava","Gelida","Gelsa","Gelves","Genoves","Gerena","Gernika-Lumo","Getafe","Getaria","Gilet","Gines","Girona","Gironella","Gizaburuaga","Godella","Godelleta","Gojar","Golmayo","Golmes","Gondomar","Gordon","Gorriti","Gozon de Ucieza","Grado","Granada","Granadilla de Abona","Granja de Rocamora","Granollers","Graus","Grazalema","Grijota","Grinon","Grisen","Grove, O","Guadalajara","Guadalcazar","Guadalix de la Sierra","Guadalupe","Guadalupe","Guadamur","Guadarrama","Guadiana del Caudillo","Guadiaro","Guadix","Guamasa","Guardamar del Segura","Guardo","Guarena","Guarnizo","Guejar-Sierra","Guenes","Guevejar","Guijuelo","Guillena","Guimar","Guitiriz","Gurb","Guzman","Haro","Hellin","Henares","Herencia","Hernani","Hernansancho","Hernialde","Herrera","Herrera","Herrera de Pisuerga","Herrera del Duque","Higuera la Real","Hijar","Hinojedo","Hinojos","Hinojosa del Duque","Hinojosa del Valle","Hondon de las Nieves","Hondon de los Frailes","Hontanares de Eresma","Hontoria del Pinar","Horcajo de las Torres","Horche","Hornachos","Hornachuelos","Horta de Sant Joan","Hortichuela","Hospital","Hostalric","Hoya-Gonzalo","Hoyo de Manzanares","Huarte-Araquil","Huecas","Huelma","Huelva","Huelves","Huercal de Almeria","Huercal Overa","Huercanos","Huertas","Huerto","Huesca","Huete","Huetor Santillan","Huetor Vega","Huetor-Tajar","Huevar","Humanes","Humanes de Madrid","Hurchillo","Ibarra","Ibarruri","Ibi","Ibiza","Ibros","Icod de los Vinos","Idiazabal","Igualada","Igualeja","Igueste","Illa","Illana","Illas","Illescas","Illora","Illueca","Inca","Incio","Infantes","Ingenio","Iniesta","Ipazter","Irun","Irura","Isla Becoa","Isla Cristina","Isora","Itza","Iznajar","Iznate","Jabaga","Jabali Nuevo","Jaca","Jacarilla","Jaraiz de la Vera","Javea","Jerez de la Frontera","Jerez de los Caballeros","Jerte","Jesus","Jijona","Jimena de la Frontera","Joanetes","Jodar","Jorba","Jumilla","Juneda","La Abadilla","La Adrada","La Alameda de la Sagra","La Alberca","La Algaba","La Aljorra","La Almunia de Dona Godina","La Antilla","La Arena","La Arena","La Baneza","la Baronia de Rialb","La Batlloria","La Bisbal","la Bisbal del Penedes","La Cabrera","La Calzada","La Calzada de Calatrava","La Calzada de Oropesa","La Campana","La Canada","La Canada de San Urbano","La Canalosa","La Canonja","La Caridad","La Carlota","La Carolina","La Cavada","La Codosera","La Espina","la Febro","La Felguera","La Figuera","La Flecha","La Floresta Pearson","La Florida","La Fresneda","La Frontera","La Fuente de San Esteban","La Galera","La Garganta","la Garriga","La Gineta","La Granada","la Granadella","La Granja","La Granja de San Vicente","La Guancha","La Guardia","La Guardia de Jaen","La Herradura","La Higuerita","La Lantejuela","La Llacuna","La Llagosta","La Llosa","La Luisiana","La Mamola","La Mancha Blanca","La Matanza de Acentejo","La Mojonera","La Muela","La Nora","la Nou de Bergueda","la Nucia","La Oliva","La Orden","La Orotava","La Palma del Condado","La Paz","La Pedraja de Portillo","La Pedrera","La Penilla","La Perdoma","La Plana","La Playa de Arguineguin","La Pobla de Claramunt","La Pobla de Lillet","la Pobla de Mafumet","la Pobla de Montornes","La Pola de Gordon","La Puebla de Almoradiel","La Puebla de Arganzon","La Puebla de Cazalla","La Puebla de Hijar","La Puebla de los Infantes","La Puebla de Montalban","La Puebla del Rio","La Pueblanueva","La Puerta de Segura","La Rambla","La Rambla","La Rapita","La Raya","La Red de Valdetuejar","La Riba","la Riera de Gaia","La Rinconada","La Robla","La Roca del Valles","La Roda","La Roda de Andalucia","La Seca","La Secuita","La Selva","La Serna","La Solana","La Torre","La Torre","La Torre","La Torre","la Vall","la Vall del Bac","La Vera","La Victoria","La Victoria de Acentejo","La Vinuela","La Virgen del Camino","La Virgen del Pilar","La Yedra","Labajos","Lagartera","Lago","Laguardia","Laguna de Duero","Lajares","Lalin","Lama","Lamadrid","Lanaja","Landa","Landa","Langa","Langa de Duero","Langreo","Lanjaron","Lantadilla","Laracha","Lardero","Laredo","Las Cabezas de San Juan","Las Galletas","Las Hortichuelas","Las Islas","Las Matas","Las Navas de la Concepcion","Las Navas del Marques","Las Palmas de Gran Canaria","Las Rozas de Madrid","Las Torres de Cotillas","Las Vegas","Las Ventanas","Las Ventas de Retamosa","Lasarte","Laudio-Llodio","Lazagurria","Lebrija","Ledana","Ledrada","Legasa","Legazpia","Legorreta","Lekeitio","Lepe","Lerin","Lerma","les Borges del Camp","Les Fonts","Lezama","Lezo","Liano","Librilla","Liencres","Lijar","Lillo","Limones","Limpias","Linares","Linyola","Lires","Llafranc","Llagostera","Llanera","Llanes","Llano","Lledo","Lleida","Llerena","Llers","Llinars del Valles","Lliria","Llofriu","Lloret de Mar","Llosa de Ranes","Lobios","Lodosa","Loeches","Loja","Lomo de Arico","Lopera","Lorca","Loriguilla","Lorqui","Los Alcazares","Los Angeles","Los Barrios","Los Barrios","Los Corrales","Los Corrales de Buelna","Los Cristianos","Los Dolores","Los Gallardos","Los Garres","Los Hueros","Los Llanos de Aridane","Los Marines","Los Molinos","Los Montes","Los Narejos","Los Navalmorales","Los Navalucillos","Los Palacios","Los Palacios y Villafranca","Los Rios","Los Rosales","Los Santos de la Humosa","Los Silos","Los Villares","Los Yebenes","Losar de la Vera","Lousame","Luanco","Luarca","Lucena","Lucena del Cid","Lucena del Puerto","Luceni","Lucillos","Lugo","Lugones","Luou","Luyando","Luzaide","Luzmela","Macael","Macanet de la Selva","Maceira","Madrid","Madridanos","Madridejos","Madrigal de la Vera","Madrigalejo","Madrigueras","Madronera","Magan","Mahon","Mairena del Alcor","Mairena del Aljarafe","Majadahonda","Malagon","Malgrat de Mar","Maliano","Mallen","Malpartida de Caceres","Malpartida de Plasencia","Malpica","Malpica","Manacor","Mancha Real","Manilva","Manises","Manlleu","Manresa","Manuel","Manzanares","Manzanares el Real","Maracena","Marbella","Marchamalo","Marchena","Marcilla","Margarida","Maria de Huerva","Maria de la Salut","Marin","Mariola","Marmolejo","Martin","Martinet","Martorell","Martos","Marugan","Marzagan","Masdenverge","Maside","Masllorenc","Maspalomas","Masquefa","Massamagrell","Mata","Matadepera","Mataelpino","Mataluenga","Matamorosa","Matapozuelos","Mayor","Mazagon","Meano","Mecina Fondales","Meco","Medina de Pomar","Medina del Campo","Medina-Sidonia","Medinya","Medio","Mediona","Medrano","Meira","Meis","Mejorada","Mejorada del Campo","Meliana","Melilla","Membrilla","Mendaro","Mengibar","Mentrida","Mequinensa / Mequinenza","Mercadal","Mestanza","Mezalocha","Miajadas","Mieres","Miguel Esteban","Miguelturra","Mijas","Milagro","Millares","Minas de Riotinto","Ministerio","Mino","Miono","Mira","Mirador","Miraflores de la Sierra","Miramar","Miranda de Arga","Miranda de Ebro","Miranda del Castanar","Mislata","Moana","Mocejon","Mogente","Moguer","Moia","Moja","Mojacar Pueblo","Mojados","Molina de Aragon","Molina de Segura","Molinos de Duero","Molins de Rei","Mollina","Mollo","Mombeltran","Monachil","Moncada","Moncofar","Monda","Mondariz","Mondonedo","Mondujar","Monesterio","Monforte de Lemos","Monforte del Cid","Monistrol de Calders","Monserrat","Mont","Montagut","Montalban de Cordoba","Montcada i Reixac","Monte","Monteagudo","Montealegre del Castillo","Montearagon","Montefrio","Montehermoso","Montejicar","Montellano","Montemayor de Pililla","Monterroso","Monterrubio de la Serena","Montesa","Montesquiu","Montfulla","Montgat","Montijo","Montilla","Montillana","Montmajor","Montroy","Montseny","Monzalbarba","Monzon","Mora","Mora de Rubielos","Moraleja de Enmedio","Moralzarzal","Morata de Jalon","Morata de Tajuna","Moratalla","Moreda","Morella","Moriscos","Morro del Jable","Mortera","Moscas del Paramo","Mosqueruela","Mostoles","Mota del Marques","Motilla del Palancar","Motril","Moya","Muchamiel","Mugardos","Mula","Mungia","Mura","Murcia","Muriedas","Muro","Muro","Muro del Alcoy","Muros","Muros de Nalon","Museros","Mutiloa","Mutilva Baja","Mutriku","Nalda","Nambroca","Nanclares de la Oca","Naquera","Nava de la Asuncion","Navacerrada","Navaconcejo","Navahermosa","Navalcan","Navalcarnero","Navalmoral de la Mata","Navalperal de Pinares","Navamorcuende","Navarcles","Navaridas","Navarres","Navarrete","Navas de Riofrio","Navas del Rey","Navata","Navatejera","Navezuelas","Navia","Neda","Neda","Negreira","Nembro","Nerja","Nerva","Nestares","Nigran","Nijar","Nino Perdido","Nivar","Noain","Noja","Nora","Norena","Novallas","Novelda","Noves","Nubledo","Nueva","Nuevo Baztan","Nuez de Ebro","Nules","Numancia de la Sagra","O Barco de Valdeorras","O Carballino","O Grove","O Mazo","Oasis (La Marina)","Obanos","Ocana","Odena","Odon","Ogijares","Ojen","Olaberria","Olazagutia","Oleiros","Oleiros","Olesa de Bonesvalls","Olesa de Montserrat","Oliana","Olias del Rey","Olite","Oliva","Oliva de Merida","Oliva de Plasencia","Olivares","Olivella","Olivenza","Olmedo","Olocau","Olot","Olula de Castro","Olula del Rio","Olvega","Olvera","Onda","Ondara","Ondarroa","Onil","Ontigola","Ontinena","Ontinyent","Ontur","Orce","Orcoyen","Ordes","Ordis","Orellana la Vieja","Oria","Orial","Orihuela","Orio","Oroso","Orpesa/Oropesa del Mar","Ortiguero","Oruna","Orusco","Osuna","Otero","Otura","Ouces","Ourense","Ourense","Outes","Oviedo","Oyon","Oza de los Rios","Padilla del Ducado","Padul","Paiporta","Pajara","Palafolls","Palafrugell","Palau","Palencia","Palma de Mallorca","Palma del Rio","Palmeira","Palmera","Palmones","Palol","Palomares del Rio","Palos de la Frontera","Pals","Pamplona","Panillo","Panticosa","Pantoja","Para","Paracuellos","Paracuellos de Jarama","Parada","Paradas","Paradela","Parbayon","Parcent","Paredes de Nava","Parla","Parres","Pasai San Pedro","Pasaia","Pastrana","Paterna","Paterna del Campo","Pau","Pauels","Pedrajas","Pedrajas de San Esteban","Pedralba","Pedreguer","Pedrezuela","Pedro","Pedro Abad","Pedro Munoz","Pedrola","Pedrosillo de Alba","Pedrosillo el Ralo","Pego","Pelayos de la Presa","Peligros","Penafiel","Penaflor","Penagos","Penarroya-Pueblonuevo","Perafita","Perafort","Peralejo","Perales del Alfambra","Perales del Puerto","Peratallada","Perdiguera","Pereiro de Aguiar","Periedo","Perillo","Pescador","Pescueza","Petrel","Petres","Pezuela de las Torres","Piedra","Piedrabuena","Piera","Pilar de la Horadada","Pilas","Pina de Ebro","Pinar","Pineda de Mar","Pinos del Valle","Pinos Puente","Pinoso","Pinseque","Pinto","Pioz","Placencia","Plan","Planes","Plasencia","Plasenzuela","Playa","Playa Blanca","Plegamans","Plentzia","Poblete","Poboa de San Xulian","Poboleda","Pola de Laviana","Pola de Lena","Pola de Siero","Polan","Polinya","Polop","Pomar","Pomar de Cinca","Ponferrada","Pont de Molins","Pontejos","Pontevedra","Pontos","Ponts","Poris de Abona","Porrino","Port de Sagunt","Portillo","Portillo de Toledo","Porto","Porto Cristo","Portocolom","Portonovo","Portugalete","Portus","Posadas","Posadas","Pozo de Guadalajara","Pozo de la Serna","Pozoamargo","Pozoblanco","Pozuelo del Rey","Pradejon","Prado del Rey","Pravia","Premia de Mar","Priego","Priego de Cordoba","Pruna","Pruvia","Pucol","Puebla de Alfinden","Puebla de Don Fadrique","Puebla de la Calzada","Puebla del Maestre","Puente Viesgo","Puente-Genil","Puentelarra","Puentenansa","Puerto","Puerto","Puerto de Gandia","Puerto de la Cruz","Puerto del Carmen","Puerto del Rosario","Puerto Lumbreras","Puerto Real","Puertollano","Pueyo","Pueyo de Santa Cruz","Puig","Puigpelat","Pulgar","Pulianas","Purchil","Quart de Poblet","Quel","Quer","Querol","Quijorna","Quincoces de Yuso","Quintana de la Serena","Quintana de Raneros","Quintanar de la Orden","Quintanar del Rey","Quintes","Rafal","Rafelbunyol","Rafelcofer","Rafelguaraf","Rairiz de Veiga","Rajadell","Ramales de la Victoria","Rasines","Real","Real de Gandia","Rebolledo","Rebordanes","Recas","Redes","Redondela","Redovan","Reinosa","Rendar","Renedo","Renedo","Reocin","Requena","Reus","Revellinos","Reyes","Rianxo","Riaza","Riba","Ribadavia","Ribadeo","Ribadesella","Ribarroja","Ribeira","Ribera del Fresno","Ribes de Freser","Ricla","Riells i Viabrea","Rielves","Rincon","Rincon de la Victoria","Rincon de Soto","Rioja","Riola","Rios","Ripoll","Ripollet","Riudellots de la Selva","Riudoms","Riumors","Rivabellosa","Roales","Robleda-Cervantes","Robledillo de Gata","Robledillo de la Vera","Robledo de Chavela","Rocafort","Roda de Bara","Rodonya","Rojales","Roldan","Ron","Ronda","Roquetas de Mar","Rosell","Roses","Rota","Rubielos de Mora","Ruente","Rupit","Rus","Rute","Saamasas","Sabadell","Sabero","Sabinanigo","Sabiote","Sabucedo","Sada","Sagra","Sagunto","Salamanca","Salas de los Infantes","Salceda","Salcedo","Saldana","Salinas","Salinas","Sallent","Salobral","Salobre","Salou","Salt","Salteras","Salvatierra","Salvatierra de los Barros","Salvatierra de Mino","San Adrian","San Agustin de Guadalix","San Andres del Rabanedo","San Anton","San Antonio","San Blas","San Clemente","San Cristobal","San Cristobal de Entrevinas","San Esteban del Valle","San Felices","San Feliz de Torio","San Fernando","San Fernando","San Fernando de Henares","San Ildefonso","San Isidro","San Isidro","San Javier","San Jorge","San Juan","San Juan","San Juan de Alicante","San Juan de Aznalfarache","San Juan de Moro","San Juan del Puerto","San Julian de Muskiz","San Luis de Sabinillas","San Martin","San Martin de la Vega","San Martin de Unx","San Martin de Valdeiglesias","San Martino","San Miguel","San Miguel","San Miguel de las Duenas","San Nicolas","San Nicolas del Puerto","San Pedro","San Pedro","San Pedro","San Pedro","San Pedro del Pinatar","San Rafael","San Roman","San Roque","San Sebastian","San Sebastian de los Ballesteros","San Vicent del Raspeig","San Vicente","San Vicente de Alcantara","San Vicente de Leon","Sancibrian","Sancti Spiritus","Sangonera la Verde","Sanlucar la Mayor","Sant Andreu de la Barca","Sant Andreu de Llavaneres","Sant Bartomeu del Grau","Sant Carles de la Rapita","Sant Feliu de Llobregat","Sant Joan de les Abadesses","Sant Joan de Vilatorrada","Sant Joan les Fonts","Sant Jordi","Sant Josep de sa Talaia","Sant Just Desvern","Sant Marti de Malda","Sant Pere de Ribes","Sant Pere de Riudebitlles","Sant Pere, Santa Caterina i La Ribera","Sant Vicenc de Castellet","Santa Barbara","Santa Brigida","Santa Coloma de Farners","Santa Coloma de Gramenet","Santa Coloma de Queralt","Santa Cristina","Santa Cristina de Aro","Santa Cruz","Santa Cruz de Bezana","Santa Cruz de La Palma","Santa Cruz de la Zarza","Santa Cruz de Mudela","Santa Cruz de Tenerife","Santa Eulalia","Santa Eulalia","Santa Eulalia Bajera","Santa Fe","Santa Fe de Mondujar","Santa Lucia","Santa Lucia","Santa Margarida","Santa Maria","Santa Maria","Santa Maria de Palautordera","Santa Maria del Cami","Santa Maria del Campo","Santa Maria del Paramo","Santa Marina del Rey","Santa Marta de Ortigueira","Santa Marta de Tormes","Santa Olalla","Santa Oliva","Santa Pau","Santa Perpetua de Mogoda","Santa Pola","Santa Uxia de Ribeira","Santalla","Santander","Santiago","Santiago de Cartes","Santiago de Compostela","Santiago de la Ribera","Santiago Pena","Santiponce","Santisteban del Puerto","Santiurde de Toranzo","Santo Angel","Santo Domingo","Santo Domingo de la Calzada","Santomera","Santona","Santovenia de Pisuerga","Santpedor","Santurtzi","Sarandones","Sardina","Sarinena","Saron","Sarria","Sarria","Sarria de Ter","Sarroca de Lleida","Sax","Sayalonga","Sedavi","Segorbe","Segovia","Segovia","Segura","Segura","Segura de la Sierra","Selaya","Selva","Senija","Seoane","Sepulveda","Serena","Serra","Serracines","Serranillos del Valle","Serrateix","ses Salines","Sesena","Sesena Nuevo","Sestao","Seva","Sevares","Sevilla La Nueva","Seville","Sierra","Sierra de Fuentes","Sierra de Luna","Siete Iglesias de Trabancos","Sigueiro","Siguenza","Silla","Silleda","Sils","Simancas","Sitges","Sixto","Sobarzo","Sobradiel","Sobremazas","Socuellamos","Sodupe","Sojuela","Solares","Sollana","Soller","Solsona","Somahoz","Somo","Son Curt","Son Servera","Soneja","Sopela","Sorbas","Soria","Sotillo de la Adrada","Soto","Soto de Cerrato","Soto de la Marina","Sotogrande","Sotopalacios","Sotrondio","Suances","Subirats","Sudanell","Sueca","Sufli","Tabernas","Taboada","Tacoronte","Tafalla","Tahiche","Talamanca de Jarama","Talarn","Talavera de la Reina","Tamames","Tamaraceite","Taradell","Tarancon","Tarazona","Tarazona de la Mancha","Tarifa","Tarragona","Tarrega","Teba","Tegueste","Teguise","Tejina","Telde","Tenteniguada","Teo","Termino","Teror","Terradillos","Terrassa","Terrassa","Terrer","Teruel","Teulada","Tiagua","Tiana","Tias","Tigaiga","Tijarafe","Tijola","Tineo","Titulcia","Tobarra","Toledo","Tolosa","Tomares","Tombrio de Arriba","Tomelloso","Tomino","Tona","Tora de Riubregos","Toral de los Vados","Tordera","Tordesillas","Tordillos","Toreno","Torija","Tormantos","Toro","Torralba de Calatrava","Torralba de Oropesa","Torre del Campo","Torre del Mar","Torre-Pacheco","Torreaguera","Torreblascopedro","Torrecaballeros","Torrecilla de Alcaniz","Torredembarra","Torredonjimeno","Torrefarrera","Torrefeta","Torrejon de la Calzada","Torrejon del Rey","Torrelaguna","Torrelavega","Torrelles de Llobregat","Torrelletas","Torrelodones","Torremenga","Torremocha del Campo","Torremolinos","Torrent","Torrent","Torrenueva","Torreperogil","Torres","Torres de Berrellen","Torres de la Alameda","Torres de Segre","Torresandino","Torrevieja","Torrijos","Torroella de Fluvia","Torroella de Montgri","Torrox","Tortella","Tortola de Henares","Tortosa","Totana","Touro","Tous","Trabada","Traiguera","Traslavina","Trasona","Trazo","Trebujena","Tremp","Trespaderne","Trevino","Triana","Trillo","Trives","Trobajo del Camino","Trujillanos","Trujillo","Tudela","Tudela de Duero","Tuineje","Turia","Turis","Ubrique","Uceda","Ugena","Ugijar","Ujo","Ullastrell","Umbrete","Urda","Urdiain","Urduna","Urnieta","Urroz","Urtuella","Usansolo","Useras","Usurbil","Utebo","Utiel","Utrera","Vaciamadrid","Val de Santo Domingo","Valcabado","Valdeavero","Valdeaveruelo","Valdecabras","Valdecilla","Valdemaqueda","Valdemorillo","Valdemoro","Valdepenas","Valdepenas de la Sierra","Valdepolo","Valderrey","Valderrobres","Valderrubio","Valdesogo de Abajo","Valdetorres","Valdetorres de Jarama","Valdezufre","Valdilecha","Valencia","Valencia","Valencia de Don Juan","Valencina de la Concepcion","Vall de Almonacid","Vallada","Valladolid","Valladolises","Valldoreix","Valle","Valle de Oro","Valles","Valleseco","Vallgorguina","Vallirana","Vallmoll","Valls","Valmojado","Valpalmas","Valsequillo de Gran Canaria","Valverde","Valverde","Valverde del Camino","Valverde del Fresno","Valverde del Majano","Vedra","Vejer de la Frontera","Velez de Benaudalla","Velez-Rubio","Velilla","Velilla de San Antonio","Venta","Venta de Banos","Ventallo","Venturada","Vera","Verdu","Vergel","Verges","Verin","Viana","Viator","Vic","Vicar","Vicolozano","Vigo","Vila","Vila-real","Vila-seca","Vilabertran","Vilacolum","Viladecans","Viladrau","Vilafant","Vilagarcia de Arousa","Vilajuiga","Vilamalla","Vilamaniscle","Vilanova","Vilanova de Arousa","Vilaplana","Vilasantar","Vilassar de Mar","Vilatenim","Vilavella","Vilches","Villa","Villa de Don Fadrique","Villa del Prado","Villa del Rio","Villabalter","Villabanez","Villablino","Villabona","Villacanas","Villacarriedo","Villacarrillo","Villacastin","Villacondide","Villaconejos","Villacuende","Villafranca","Villafranca","Villafranca de Cordoba","Villafranca de los Barros","Villafranca de los Caballeros","Villafranca del Campo","Villafranqueza","Villahermosa","Villajoyosa","Villalar de los Comuneros","Villalba de los Alcores","Villalbilla","Villalonga","Villalpardo","Villaluenga","Villamalea","Villamanrique","Villamanrique de la Condesa","Villamanta","Villamartin","Villamayor","Villamayor","Villamayor","Villamayor de Santiago","Villamediana de Iregua","Villamiel de Toledo","Villamuriel de Cerrato","Villanubla","Villanueva","Villanueva de Azoague","Villanueva de Castellon","Villanueva de Cordoba","Villanueva de Gallego","Villanueva de Gomez","Villanueva de la Canada","Villanueva de la Jara","Villanueva de la Reina","Villanueva de la Serena","Villanueva de la Torre","Villanueva de Perales","Villanueva de Villaescusa","Villanueva del Ariscal","Villanueva del Arzobispo","Villanueva del Fresno","Villanueva del Pardillo","Villanueva del Rio","Villanueva del Rosario","Villaquilambre","Villar","Villar de Gallimazo","Villar de Olalla","Villar del Arzobispo","Villaralbo","Villarcayo","Villarejo","Villares de la Reina","Villares del Saz","Villaricos","Villarluengo","Villarquemado","Villarreal de Alava","Villarrobledo","Villarrubia","Villarrubia de los Ojos","Villarrubia de Santiago","Villarta de San Juan","Villasana de Mena","Villaseca de la Sagra","Villasequilla de Yepes","Villasevil","Villatuerta","Villaverde de los Cestos","Villaverde del Rio","Villaviad","Villaviciosa","Villaviciosa","Villaviciosa de Odon","Villena","Vinaixa","Vinales","Vinalesa","Vinaros","Vitigudino","Vitoria-Gasteiz","Viveda","Viveiro","Vivero","Xunqueira de Espadanedo","Yaiza","Yebes","Yecla","Yeles","Yepes","Yuncler","Yuncos","Yunquera de Henares","Zafra","Zahara de los Atunes","Zahinos","Zalamea la Real","Zamora","Zamudio","Zaragoza","Zaramillo","Zaratamo","Zaratan","Zarautz","Zarzalejo","Zarzuela","Ziga","Zorraquin","Zuazo de Vitoria","Zubia","Zubiri","Zuera","Zumaia","Zumarraga"],"Sri Lanka":["Badulla","Battaramulla South","Biyagama","Boralesgamuwa South","Colombo","Dehiwala","Dehiwala-Mount Lavinia","Eppawala","Gampaha","Gangodawila North","Hekitta","Homagama","Kaduwela","Kandana","Kandy","Katubedda","Katunayaka","Kelaniya","Kohuwala","Maharagama","Makola South","Matale","Moratuwa","Nattandiya Town","Negombo","Nugegoda","Orugodawatta","Padukka","Pannipitiya","Peradeniya","Piliyandala","Ragama","Rajagiriya","Sri Jayewardenepura Kotte","Talapathpitiya","Wattala","Wellampitiya"],"Sudan":["Kassala","Khartoum","Nyala","Shendi","Thabit","Umm Durman"],"Suriname":["Botopasi","Brownsweg","Friendship","Groningen","Moengo","Nieuw Amsterdam","Onverwacht","Paramaribo","Totness"],"Swaziland":["Kwaluseni","Lobamba","Manzini","Mbabane","Piggs Peak"],"Sweden":["Aby","AElmhult","AElvdalen","AElvkarleby","AElvsbyn","Agnesberg","Agunnaryd","Akarp","Akers Styckebruk","Akersberga","Alafors","Alandsbro","Aled","Alem","Alfta","Alingsas","Allerum","Almeboda","Almunge","Alno","Alsen","Alsterbro","Alstermo","Alta","Altersbruk","Alunda","Alunda","Alvangen","Alvesta","Alvsjo","Amal","Ambjornarp","Amotfors","Anderslov","Anderstorp","Anderstorp","Aneby","Ange","Angered","Ankarsrum","Ankarsvik","Annelov","Annerstad","Ansvar","Aplared","Arboga","Arbra","Arholma","Arjaeng","Arjeplog","Arkelstorp","Arla","Arloev","Arnasvall","Arsunda","Arvidsjaur","Arvika","Aryd","As","Asa","Asarna","Asarum","Asbro","Aseda","Asele","Asenhoga","Asensbruk","Ashammar","Askersund","Askim","Askloster","Asmundtorp","Aspas","Aspered","Aspero","Astorp","Atorp","Atran","Atvidaberg","Avesta","Axvall","Backa","Backaryd","Backe","Backefors","Balinge","Ballingslov","Balsta","Bankeryd","Bara","Barkarby","Barseback","Barsebackshamn","Bastad","Beddinge Lage","Bengtsfors","Berga","Bergeforsen","Bergkvara","Bergshamra","Bergsjoe","Bergvik","Bettna","Billdal","Billeberga","Billesholm","Billinge","Billingsfors","Bjarnum","Bjarred","Bjartra","Bjasta","Bjorbo","Bjoringe","Bjorkhaga","Bjorklinge","Bjorkoby","Bjorkvik","Bjorna","Bjorneborg","Bjornlunda","Bjuraker","Bjurholm","Bjursas","Bjuv","Blackstad","Blasmark","Blattnicksele","Blentarp","Bockara","Bodafors","Boden","Bofors","Bohus","Boliden","Bollebygd","Bollnas","Bollstabruk","Bor","Borensberg","Borghamn","Borgholm","Borgstena","Borrby","Botsmark","Bottnaryd","Boxholm","Braas","Braecke","Brakne-Hoby","Bralanda","Bramhult","Branno","Brastad","Bredared","Bredaryd","Bro","Broby","Brokind","Bromma","Bromoella","Brosarp","Brottby","Brunflo","Brunnby","Bua","Bullmark","Bunkeflostrand","Burea","Burtraesk","Bygdea","Bygdsiljum","Byske","Byske","Charlottenberg","Dala-Floda","Dala-Jarna","Dalaro","Dalby","Dals Langed","Dals Rostock","Dalsjofors","Dalstorp","Danderyd","Degeberga","Degerfors","Deje","Delsbo","Dikanaes","Dingle","Dio","Djura","Djuras","Djurhamn","Djursholm","Domsjo","Donso","Dorotea","Dosjebro","Drottningholm","Duved","Dyltabruk","Ed","Edsbro","Edsbyn","Edsele","Edshultshall","Edsvalla","Ekeby","Ekenassjon","Ekshaerad","Eksjoe","Eldsberga","Elloes","Emmaboda","Enanger","Enebyberg","Eneryda","Enkoping","Enskede-Arsta-Vantoer","Enviken","Erikslund","Eriksmala","Eskilstuna","Eslov","Faergelanda","Faerjestaden","Fagelfors","Fageras","Fagerberg","Fagered","Fagerhult","Fagersanna","Fagersta","Fagervik","Falkenberg","Fallfors","Falun","Farbo","Farila","Farlov","Farna","Farnas","Faro","Fellingsbro","Fengersfors","Figeholm","Filipstad","Finja","Finnerodja","Finspang","Fiskeby","Fjaeras station","Fjalkinge","Fjardhundra","Fjugesta","Flen","Fleninge","Flisby","Floby","Floda","Flyinge","Follinge","Follinge","Fors","Forsa","Forsbacka","Forsby","Forserum","Forshaga","Forsheda","Forslov","Frandefors","Fransta","Fredriksberg","Frillesas","Fristad","Fritsla","Froso","Frovi","Frufallan","Furulund","Furuvik","Gabo","Gagnef","Gallo","Gallstad","Gamla stan","Gamleby","Gammelstad","Ganghester","Gards Kopinge","Gargnas","Garpenberg","Garphyttan","Garsas","Garsnas","Gemla","Genarp","Genevad","Getinge","Gidea","Gimo","Gislaved","Glanshammar","Glimakra","Glommen","Glommerstrask","Glostorp","Glumslov","Gnarp","Gnesta","Gnosjoe","Goetene","Gota","Gothenburg","Grabo","Graddo","Graestorp","Grangarde","Grangesberg","Grasmyr","Graso","Grebbestad","Grillby","Grimeton","Grimsas","Grimslov","Grimstorp","Grisslehamn","Grondal","Gronskara","Grums","Grundsund","Grycksbo","Gryt","Grythyttan","Gualov","Guldsmedshyttan","Gullbrandstorp","Gullspang","Gunnebo","Gunnilse","Gusselby","Gustafs","Gustavsberg","Gusum","Gyttorp","Hackas","Hacksvik","Haegersten","Haellefors","Haerryda","Haesselby","Hagfors","Hagglund","Hajom","Hakkas","Haknas","Haljarp","Hallabro","Halland","Hallarod","Hallberg","Halleforsnas","Hallekis","Hallestad","Hallestad","Hallevadsholm","Hallingsjo","Hallsberg","Hallsta","Hallstahammar","Hallstavik","Halmstad","Halso","Halta","Hamburgsund","Hammar","Hammaro","Hammarstrand","Hammenhog","Hammerdal","Hamneda","Hamrangefjarden","Hanaskog","Handen","Haparanda","Harads","Harbo","Harby","Harestad","Harmanger","Harplinge","Harslov","Hasselby","Hasselfors","Hasslarp","Hasslo","Hastveda","Havdhem","Hebo","Hedared","Hede","Hedekas","Hedemora","Hedesunda","Helgum","Helsingborg","Hemmingsmark","Hemse","Henan","Herrangen","Herrljunga","Hestra","Hillared","Hillerstorp","Hindas","Hjaerup","Hjalteby","Hjarnarp","Hjartum","Hjo","Hoegsby","Hoeoer","Hoerby","Hoernefors","Hofors","Hoganas","Hogsaters","Hogsjo","Hok","Hokerum","Hollviken","Holmen","Holmsjo","Holmsund","Holmsveden","Holo","Holsbybrunn","Holsljunga","Hono","Horn","Horndal","Horred","Hortlax","Hova","Hovas","Hoviksnas","Hovmantorp","Huarod","Huddinge","Hudiksvall","Hultafors","Hultsfred","Hunnebostrand","Hunnestad","Huskvarna","Husum","Hyllinge","Hyltebruk","Hyssna","Iggesund","Immeln","Indal","Ingarp","Ingelstad","Ingmarso","Insjon","Jaemjoe","Jaervsoe","Jamshog","Jarbo","Jarlasa","Jarna","Jarpen","Jarved","Joern","Johanneshov","Johannishus","Jokkmokk","Jonaker","Jonsered","Jordbro","Jorlanda","Jude","Junosuando","Kaevlinge","Kage","Kagerod","Kalix","Kallby","Kallered","Kallinge","Kallo","Kalmar","Kareby","Karesuando","Karl Gustav","Karlsborg","Karlshamn","Karlskoga","Karlskrona","Karlstad","Karna","Karra","Katrineholm","Kattarp","Katthammarsvik","Kattilstorp","Kil","Kilafors","Killeberg","Kimstad","Kinna","Kinnared","Kinnarp","Kiruna","Kisa","Kista","Kivik","Kladesholmen","Klagerup","Klagshamn","Klagstorp","Klassbol","Klavrestrom","Klintehamn","Klippan","Klovedal","Knared","Knislinge","Knivsta","Knivsta","Knutby","Kode","Kolback","Kolmarden","Kolsva","Konga","Koping","Kopingebro","Kopmanholmen","Kopparberg","Koppom","Korpilombolo","Korsberga","Korskrogen","Koskullskulle","Kosta","Kramfors","Kristdala","Kristianstad","Kristineberg","Kristinehamn","Krokom","Krylbo","Kulla","Kullavik","Kulltorp","Kumla","Kungsaengen","Kungsbacka","Kungsgarden","Kungshamn","Kungsoer","Kvanum","Kvibille","Kvicksund","Kvidinge","Kvissleby","Kyrkobyn","Lagan","Laholm","Lammhult","Landeryd","Landfjarden","Landsbro","Landskrona","Landvetter","Langas","Langasjo","Langhem","Langsele","Langshyttan","Langviksmon","Lanna","Lannavaara","Larbro","Larv","Lavsjo","Laxa","Lekeryd","Leksand","Lenhovda","Lerberget","Lerdala","Lerum","Lessebo","Liden","Lidhult","Lidingoe","Lidkoping","Likenas","Lilla Edet","Lillpite","Lima","Limhamn","Limmared","Lindas","Lindesberg","Lindome","Linghem","Linneryd","Listerby","Lit","Ljugarn","Ljung","Ljungaverk","Ljungby","Ljungbyhed","Ljungbyholm","Ljungsarp","Ljungsbro","Ljungskile","Ljusdal","Ljusfallshammar","Ljusne","Ljustero","Ljustorp","Loberod","Loddekopinge","Loderup","Lodose","Lomma","Lonashult","Lonsboda","Los","Lotorp","Lottorp","Lovanger","Lovestad","Lovikka","Ludvigsborg","Ludvika","Lugnvik","Lund","Lycke","Lyckeby","Lycksele","Lysekil","Lysvik","Mala","Maleras","Malilla","Malma","Malma","Malmback","Malmberget","Malmkoping","Malmo","Malsryd","Malung","Mankarbo","Mansarp","Mantorp","Marback","Mardaklev","Mariannelund","Mariefred","Marieholm","Marieholm","Mariestad","Markaryd","Marma","Marsta","Marstrand","Matfors","Mellansel","Mellbystrand","Mellerud","Mjallom","Mjolby","Mockfjard","Moelle","Moelndal","Moensteras","Moerbylanga","Moheda","Moholm","Moliden","Molkom","Molltorp","Molnbo","Molnlycke","Mora","Morarp","Morgongava","Morlunda","Morrum","Morsil","Morup","Motala","Mullhyttan","Mullsjoe","Munka-Ljungby","Munkedal","Munkfors","Musko","Myggenas","Myresjo","Nacka","Nalden","Nashulta","Nassjo","Nasum","Nasviken","Nattraby","Navekvarn","Navlinge","Nissafors","Njurundabommen","Njutanger","Nodinge","Nodinge-Nol","Nora","Norberg","Nordingra","Nordmaling","Norrahammar","Norrala","Norrfjarden","Norrhult","Norrsundet","Norrtalje","Norsborg","Norsholm","Norsjoe","Nossebro","Nybro","Nygard","Nyhammar","Nyhamnslage","Nykil","Nykroppa","Nykvarn","Nyland","Nyland","Nynas","Nynashamn","Nysater","Nyvang","Obbola","Ockelbo","Odakra","Odeborg","Odensbacken","OEckeroe","OEdeshoeg","OErkelljunga","OEsterbymo","OEstervala","OEsthammar","OEverkalix","OEvertornea","Ojebyn","Ojersjo","Olofstorp","Olofstroem","Olsfors","Onnestad","Orby","Orbyhus","Oregrund","Ormaryd","Orno","Ornskoldsvik","Orrefors","Orsa","Orsundsbro","Orviken","Osby","Oskarshamn","Oskarstrom","Osmo","Ostansjo","Osterbybruk","Osterbybruk","Osterhaninge","Osterskar","Ostra","Ostra Frolunda","Ostra Hindalebyn","Ostra Karup","Ostra Ryd","Otterbacken","Ovanaker","Overhornas","Overkovland","Overlida","Overum","Oviken","Oxaback","Oxelosund","Oxie","Paarp","Pajala","Palange","Palsboda","Partille","Paskallavik","Perstorp","Pilgrimstad","Pixbo","Raa","Raettvik","Ramdala","Ramnas","Ramsele","Ramsjo","Ramvik","Ranea","Rangedala","Ransater","Ransta","Ravlanda","Reftele","Rejmyre","Rekarne","Rengsjo","Reso","Restad","Riddarhyttan","Rimbo","Rimforsa","Ring","Ringarum","Rinkaby","Roback","Robertsfors","Rockneby","Rodeby","Roke","Rolfstorp","Romakloster","Romelanda","Ronnang","Ronneby","Ronninge","Roro","Rorvik","Rosersberg","Rosson","Rostanga","Rosvik","Rotebro","Rottne","Ruda","Rundvik","Ryd","Rydaholm","Rydboholm","Rydeback","Rydobruk","Rydsgard","Ryssby","Saeffle","Saeter","Saevar","Saevast","Saevsjoe","Sagmyra","Sala","Saltsjo-Duvnas","Saltsjobaden","Sand","Sandared","Sandarne","Sandby","Sandhem","Sandhult","Sandviken","Sankt Olof","Saro","Satila","Savedalen","Savsjostrom","Saxtorp","Segersta","Seglora","Segmon","Sennan","Sexdrega","Sibbhult","Sidensjo","Sifferbo","Sigtuna","Siljansnas","Simlangsdalen","Simrishamn","Sjalevad","Sjoebo","Sjomarken","Sjotofta","Sjovik","Sjuntorp","Ska","Skaerhamn","Skaerholmen","Skallinge","Skane","Skanes Fagerhult","Skanninge","Skanor med Falsterbo","Skara","Skaraborg","Skarblacka","Skarplinge","Skarpnaeck","Skattkarr","Skee","Skelleftehamn","Skene","Skepplanda","Skillingaryd","Skillinge","Skinnskatteberg","Skivarp","Skogas","Skoghall","Skogstorp","Skoldinge","Skollersta","Skondal","Skruv","Skultuna","Skummeslovsstrand","Skurup","Skyllberg","Skyttorp","Slite","Sloinge","Slottsbron","Slutarp","Smalandsstenar","Smedjebacken","Smedstorp","Smoegen","Soderakra","Soderala","Soderby","Soderfors","Sodergard","Soderhamn","Sodra Sandby","Sodra Sunderbyn","Sodra Vi","Soederbaerke","Soederkoeping","Sollebrunn","Solleftea","Sollentuna","Solna","Sommen","Soraker","Sorberge","Sorombacken","Sorsele","Sosdala","Sovde","Spanga","Sparsor","Spekerod","Staffanstorp","Stallarholmen","Stalldalen","Stanga","Stehag","Stenhamra","Stenkullen","Stensele","Stenstorp","Stenungsund","Stigen","Stigtomta","Stjarnhov","Stoby","Stockaryd","Stockholm","Stocksund","Stode","Stollet","Stora","Stora Hoga","Stora Mellosa","Stora Skedvi","Stora Vika","Storebro","Storfors","Storlien","Storuman","Storvik","Storvreta","Stra","Strangnas","Stratjara","Stravalla","Stroemstad","Stroemsund","Stromsbruk","Stromsholm","Stromsnasbruk","Strovelstorp","Stugun","Sturefors","Sturko","Styrso","Sundborn","Sundbyberg","Sundsbruk","Sundsvall","Sunnansjo","Sunne","Sunnemo","Surahammar","Surte","Svaloev","Svaneholm","Svaneholm","Svanesund","Svangsta","Svardsjo","Svarta","Svartinge","Svartsjo","Svedala","Sveg","Svenljunga","Svensbyn","Svenshogen","Svenstavik","Taberg","Taby","Taenndalen","Taernaby","Taftea","Tagarp","Talje","Taljo","Tallasen","Tallberg","Tanumshede","Tarnsjo","Tavelsjo","Teckomatorp","Tegeltorp","Tenhult","Tibro","Tidaholm","Tidan","Tierp","Timmele","Timmernabben","Timmersdala","Timra","Tingsryd","Tingstade","Tjornarp","Toecksfors","Toere","Toereboda","Tolg","Tollarp","Tollered","Tomelilla","Torekov","Tormestorp","Torpshammar","Torsaker","Torsas","Torsby","Torshalla","Torslanda","Torup","Tranas","Tranemo","Trangsund","Transtrand","Traryd","Traslovslage","Traslovslage","Travad","Trehorningsjo","Trekanten","Trelleborg","Trollhattan","Trosa","Tullinge","Tumba","Tun","Tungelsta","Tvaaker","Tvaralund","Tving","Tygelsjo","Tyreso Strand","Tyringe","Tystberga","Ucklum","Uddebo","Uddeholm","Uddevalla","Ugglarp","Ullared","Ulricehamn","Ulrika","Undersaker","Unnaryd","Uppharad","Upplands Vasby","Uppsala","Urshult","Ursviken","Utansjo","Uttran","Vackelsang","Vaddo","Vaderstad","Vadstena","Vaeja","Vaellingby","Vaennaes","Vaermdoe","Vaggeryd","Vagnharad","Valadalen","Valberg","Valbo","Valdemarsvik","Valla","Vallakra","Vallda","Vallentuna","Vallsta","Valskog","Vanersborg","Vankiva","Vannasby","Vansbro","Vara","Varberg","Varby","Varekil","Vargarda","Vargon","Varing","Varmland","Varnamo","Varnhem","Varobacka","Varsas","Varsta","Vartofta","Vase","Vassmolosa","Vasterfarnebo","Vasterljung","Vastervik","Vastra Amtervik","Vastra Frolunda","Vastra Karup","Vastra Ramlosa","Vastra Torup","Vato","Vattholma","Vaxholm","Vaxjo","Vaxtorp","Veberod","Veddige","Vedum","Vega","Vegby","Veinge","Vejbystrand","Vellinge","Vendelso","Vessigebro","Vetlanda","Vidsel","Vikarbyn","Viken","Vikingstad","Vikmanshyttan","Viksjofors","Vilhelmina","Villan","Vimmerby","Vinberg","Vindeln","Vingaker","Vinninga","Vinslov","Vintrie","Vintrosa","Virsbo Bruk","Virserum","Visby","Viskafors","Vislanda","Vissefjarda","Vitaby","Vittaryd","Vittaryd","Vittsjo","Vollsjo","Vrena","Vreta Kloster","Vretstorp","Yngsjo","Ystad","Ytterby","Zinkgruvan"],"Switzerland":["Aadorf","Aarau","Aarberg","Aarburg","Abtwil","Adelboden","Adligenswil","Adliswil","Aesch","Aesch","Aeschau","Aeschlen ob Gunten","Aettenschwil","Aeugst am Albis","Affoltern am Albis","Agno","Agra","Aigle","Airolo","Alberswil","Albligen","Alchenstorf","Allaman","Allschwil","Alpnach","Alt-Bachs","Altdorf","Altendorf","Altenrhein","Alterswil","Altishofen","Altnau","Altstatten","Amden","Amriswil","Amsoldingen","Andermatt","Andwil","Anieres","Appenzell","Apples","Apro","Arbaz","Arbedo","Arbon","Arcegno","Ardon","Arisdorf","Aristau","Arlesheim","Arni","Arogno","Arosa","Arth","Arzier","Arzo","Ascona","Assens","Attalens","Attinghausen","Attiswil","Au","Au","Aubonne","Auenstein","Augst","Ausser-Dinhard","Autigny","Auvernier","Auw","Avenches","Avry","Ayent","Ayer","Baar","Bach","Bachenbulach","Bad Ragaz","Bad Zurzach","Baden","Balerna","Balgach","Ballwil","Balsthal","Balterswil","Banco","Bangerten","Bannwil","Barbereche","Baretswil","Bariswil","Basadingen","Basel","Basse-Nendaz","Bassecourt","Bassersdorf","Batterkinden","Baulmes","Bauma","Bavois","Bazenheid","Beckenried","Begnins","Beinwil","Belfaux","Bellerive","Bellevue","Bellinzona","Bellmund","Belmont-sur-Lausanne","Belp","Benken","Berg","Berikon","Beringen","Berlikon","Bern","Bern / Liebefeld","Berneck","Bernex","Beromuenster","Bettingen","Bettlach","Beuson","Bevaix","Bevilard","Bex","Biasca","Biberist","Biel-Benken","Biel/Bienne","Biere","Bigenthal","Bigorio","Bilten","Binningen","Bioggio","Birmensdorf","Birmenstorf","Birr","Birsfelden","Bissegg","Bissone","Bitsch","Blonay","Blumenstein","Bogis-Bossey","Boll","Bolligen","Bonaduz","Bonigen","Bonnefontaine","Bonstetten","Borex","Bosingen","Bottens","Bottenwil","Bottighofen","Bottmingen","Boudry","Bouveret","Bramois","Breitenbach","Bremgarten","Brenzikofen","Brienz","Brig","Brislach","Brissago","Bristen","Brittnau","Broc","Bronschhofen","Brugg","Brunnen","Brusino Arsizio","Brutten","Bruttisellen","Bubendorf","Bubikon","Buch","Buchberg","Buchrain","Buchs","Buchs","Buchs / Buchs (Dorf)","Buetschwil","Buix","Bulach","Bulle","Buochs","Buonas","Burchen","Buren an der Aare","Buren nid dem Bach","Burgdorf","Burglen","Burglen","Bursins","Busserach","Bussigny","Busswil","Buttes","Buttisholz","Butzberg","Buus","Cadempino","Cadenazzo","Cadro","Camorino","Campfer","Canobbio","Capolago","Carouge","Cartigny","Caslano","Castione","Cazis","Celerina","Celigny","Cernier","Chalais","Cham","Chambesy","Chamoson","Champagne","Champex","Champsec","Chancy","Chapelle","Chardonne","Charmey","Charrat-les-Chenes","Chatel-Saint-Denis","Chatelaine","Chavannes","Chavannes de Bogis","Chavannes-les-Forts","Chavornay","Cheiry","Chene-Bougeries","Chene-Bourg","Chene-Paquier","Cheseaux-sur-Lausanne","Chesieres","Chexbres","Cheyres","Chez-le-Bart","Chiasso","Chippis","Chur","Claro","Coeuve","Cointrin","Collombey","Colombier","Colombier","Concise","Confignon","Conthey","Contone","Coppet","Coppet","Corcelles","Corcelles","Cordast","Corgemont","Corminboeuf","Cornaux","Corsier","Cortaillod","Cossonay","Cottens","Courfaivre","Courgenay","Courrendlin","Courroux","Court","Courtedoux","Courtelary","Courtemaiche","Courtepin","Courtetelle","Courtion","Couvet","Crassier","Cremines","Cressier","Cressier","Crissier","Cudrefin","Cugnasco","Cugy","Cully","Dachsen","Daettlikon","Dagmersellen","Daillens","Dallenwil","Daniken","Dardagny","Dattwil","Davos","Davos Dorf","Davos Platz","Degersheim","Deitingen","Densbueren","Derendingen","Diegten","Dielsdorf","Diepoldsau","Diessbach","Diessenhofen","Dietikon","Doettingen","Domat","Dombresson","Domdidier","Dompierre","Dornach","Dottikon","Dozwil","Dubendorf","Durnten","Durrenasch","Ebikon","Ebnat-Kappel","Ecublens","Ecuvillens","Effretikon","Egerkingen","Egg","Eggenwil","Eggersriet","Eggiwil","Eglisau","Egliswil","Egnach","Eich","Eichberg","Eiken","Einigen","Einsiedeln","Elgg","Ellikon an der Thur","Elsau-Raeterschen","Embrach","Emmen","Emmenbruecke","Emmetten","Endingen","Engelberg","Ennenda","Enney","Entlebuch","Epalinges","Epautheyres","Ependes","Erde","Erlach","Erlen","Erlenbach","Ermatingen","Erschwil","Ersigen","Erstfeld","Eschenbach","Eschenbach","Eschlikon","Escholzmatt","Essertines-sur-Rolle","Estavayer-le-Lac","Ettingen","Euthal","Evilard","Evionnaz","Eysins","Fahrwangen","Fallanden","Faoug","Fehraltorf","Felben","Feldbach","Feldbrunnen","Feldmeilen","Felsberg","Felsenau","Ferden","Ferenbalm","Feuerthalen","Feusisberg","Finhaut","Fischenthal","Fischingen","Flaach","Flamatt","Flawil","Fleurier","Flims","Fluehli","Flueli","Flums","Flurlingen","Fontainemelon","Forel","Founex","Fraubrunnen","Frauenfeld","Freidorf","Freienbach","Frenkendorf","Fribourg","Frick","Froideville","Frutigen","Fulenbach","Full","Fullinsdorf","Fully","Furstenaubruck","Gachlingen","Gais","Gampel","Gampelen","Gandria","Ganterschwil","Gebenstorf","Gelfingen","Gelterkinden","Genestrerio","Geneva","Gerlafingen","Gerlikon","Gersau","Gerzensee","Gettnau","Geuensee","Gimel","Gingins","Gipf-Oberfrick","Giswil","Giubiasco","Givrins","Gland","Glaris","Glarus","Glattburg","Glattfelden","Glion","Glis","Gnosca","Goldach","Goldau","Goldiwil","Gommiswald","Gonten","Gontenschwil","Gordevio","Gordola","Goslikon","Gossau","Gossau","Gottlieben","Grabs","Graenichen","Grancy","Grandcour","Grandson","Grandval","Grandvillard","Granges","Granges-pres-Sion","Gravesano","Greifensee","Grellingen","Grenchen","Greppen","Grimentz","Grimisuat","Grindelwald","Grolley","Grone","Grono","Grossandelfingen","Grosswangen","Grueningen","Grund","Gryon","Gstaad","Gumligen","Gummenen","Gunten","Gunzgen","Guttingen","Gwatt","Habkern","Habsburg","Hagenbuch","Hagendorf","Hagglingen","Hagneck","Haldenstein","Hasle","Hauptwil","Hausen","Hausen am Albis / Hausen (Dorf)","Hauterive","Hauteville","Heerbrugg","Heiden","Heimberg","Heimiswil","Heitenried","Hellbuehl","Hemmental","Henau","Hendschiken","Henggart","Herbetswil","Herdern","Hergiswil","Hergiswil","Herisau","Hermance","Hermetschwil-Staffeln","Herrliberg","Herzogenbuchsee","Hettlingen","Hildisrieden","Hilterfingen","Himmelried","Hindelbank","Hinterkappelen","Hinwil","Hirzel-Kirche","Hittnau","Hitzkirch","Hochdorf","Hochwald","Hoerstetten","Hofstetten","Hofstetten","Holderbank","Holderbank","Holstein","Hombrechtikon","Horgen","Horn","Hornussen","Horw","Hundwil","Hunenberg","Hunibach","Huntwangen","Hunzenschwil","Huttwil","Ibach","Igis","Ilanz","Illnau","Immensee","Ingenbohl","Ins","Interlaken","Inwil","Iragna","Iseo","Iserables","Islikon","Ittenthal","Jegenstorf","Jenaz","Jona","Jonen","Jonschwil","Jussy","Kaiseraugst","Kaiserstuhl","Kaisten","Kallnach","Kaltbrunn","Kappel","Kappel","Kastanienbaum","Kefikon","Kehrsatz","Kempttal","Kernenried","Kerns","Kerzers","Kiesen","Kilchberg","Killwangen","Kirchberg","Kirchberg","Kirchdorf","Kleinlutzel","Klingnau","Klosters Platz","Klosters Serneus","Kloten","Koblenz","Kollbrunn","Kolliken","Konolfingen","Koppigen","Kradolf","Krauchthal","Kreuzlingen","Kriegstetten","Kriens","Kronbuhl","Kuesnacht","Kulm","La Chaux","La Chaux-de-Fonds","La Chiesaz","La Neuveville","La Plaine","La Roche","La Sarraz","La Tour-de-Peilz","Laax","Lachen","Lamboing","Landquart","Langenbruck","Langenthal","Langnau","Langnau","Langnau am Albis","Lauenen","Lauerz","Laufelfingen","Laufen","Laufenburg","Laupen","Lausanne","Lausen","Le Brassus","Le Bry","Le Cret","Le Grand-Saconnex","Le Landeron","Le Locle","Le Mont-sur-Lausanne","Le Noirmont","Le Sentier","Le Vaud","Leibstadt","Lengnau","Lenk","Lenz","Lenzburg","Lenzerheide","Les Acacias","Les Breuleux","Les Diablerets","Les Geneveys-sur-Coffrane","Les Genevez","Les Hauts-Geneveys","Les Pommerats","Les Verrieres","Leukerbad","Leutwil","Leysin","Lichtensteig","Liddes","Liebistorf","Lienz","Liestal","Ligerz","Lignieres","Lindau","Littau","Locarno","Loco","Lodrino","Lohn","Lommis","Losone","Lostorf","Lotzwil","Lucens","Lucerne","Lugano","Lungern","Lurtigen","Lutisburg","Lutry","Luvis","Lyss","Lyssach","Maerstetten-Dorf","Magadino","Magden","Maggia","Maisprach","Malleray","Malters","Mannedorf","Manno","Marin","Maroggia","Marsens","Martigny-Croix","Martigny-Ville","Maschwanden","Massagno","Matt","Matzendorf","Matzingen","Mauensee","Maur","Meggen","Meierskappel","Meilen","Meinier","Meinisberg","Meiringen","Meisterschwanden","Melano","Melchnau","Melide","Mellingen","Mels","Mendrisio","Menziken","Menzingen","Merenschwand","Merishausen","Messen","Mettendorf","Mettlen","Mettmenstetten","Mettmenstetten","Meyrin","Miecourt","Minusio","Mohlin","Mollis","Monchaltorf","Montagnola","Montana","Montet","Monthey","Montreux","Moosleerau","Morbio Inferiore","Morcote","Morges","Morgins","Morigen","Moriken","Morschach","Morschwil","Mosnang","Motiers","Moudon","Moutier","Muerren","Muhen","Muhlau","Muhleberg","Mullheim","Mumliswil","Mumpf","Munchenbuchsee","Munchenstein","Munchwilen","Munsingen","Munster","Muolen","Muotathal","Murgenthal","Muri","Muri bei Bern","Murten","Muttenz","Nafels","Nanikon","Naters","Nax","Neftenbach","Nesslau","Netstal","Neu-Rheinau","Neuchatel","Neuenhof","Neuenkirch","Neuhausen","Neuheim","Neukirch","Neunkirch","Neyruz","Nidau","Niederbipp","Niederbuchsiten","Niederburen","Niedererlinsbach","Niedergosgen","Niederhallwil","Niederhelfenschwil","Niederlenz","Niederrohrdorf","Niederscherli","Niederurnen","Niederuzwil","Niederweningen","Nohl","Noreaz","Nottwil","Novaggio","Novazzano","Nunningen","Nurensdorf","Nussbaumen","Nussbaumen","Nyon","Ober Urdorf","Oberbalm","Oberbipp","Oberbuchsiten","Oberburg","Oberdiessbach","Oberdorf","Oberdorf","Oberegg","Oberembrach","Oberengstringen","Oberentfelden","Obergerlafingen","Oberglatt","Obergosgen","Oberhelfenschwil","Oberhofen","Oberhofen bei Etzgen","Oberkirch","Oberlunkhofen","Oberonz","Oberrieden","Oberriet","Obersaxen","Oberschlatt","Oberstocken","Oberuzwil","Obervaz","Oberwangen","Oberweningen","Oberwil","Oberwil","Obfelden","Oensingen","Oetwil / Oetwil an der Limmat","Oetwil am See","Oftringen","Olten","Onex","Onnens","Opfikon","Orbe","Ormalingen","Oron-la-ville","Orpund","Orsonnens","Orvin","Ossingen","Ostermundigen","Otelfingen","Othmarsingen","Ottenbach","Ouchy","Ovronnaz","Palezieux","Pampigny","Paudex","Payerne","Perlen","Perroy","Pery","Peseux","Pfaeffikon","Pfaeffikon","Pfaffnau","Pfeffikon","Pfeffingen","Pfungen","Pfyn","Pieterlen","Plaffeien","Plan-les-Ouates","Porrentruy","Porsel","Portalban- Dessous","Prangins","Pratteln","Pregassona","Preles","Preverenges","Prilly","Puidoux","Pully","Pura","Quartino","Rafz","Ramsen","Rances","Raperswilen","Rapperswil","Rapperswil","Raron","Rebstein","Rechthalten","Reconvilier","Regensdorf","Rehetobel","Reichenburg","Reiden","Reigoldswil","Reinach","Reinach","Rekingen","Renens","Rhazuns","Rheineck","Rheinfelden","Riaz","Richenthal","Richigen","Richterswil","Ricken","Rickenbach","Rickenbach","Riddes","Ried","Riedholz","Rifferswil","Riggisberg","Rikon / Rikon (Dorfkern)","Ringgenberg","Riva San Vitale","Roche","Roemerswil","Roggwil","Roggwil","Rohr","Rohrbach","Rolle","Romainmotier","Romanel","Romanshorn","Romont","Rondchatel","Root","Rorbas","Rorschach","Roschenz","Rossens","Rothenbach","Rothenthurm","Rothrist","Rotkreuz","Roveredo","Rubigen","Rudlingen","Rudolfstetten","Rue","Rueggisberg","Rueti","Rueyres","Rufi","Rumlang","Rupperswil","Ruschlikon","Russikon","Russin","Ruswil","Ruthi","Saanen","Saanenmoser","Saas-Fee","Saas-Grund","Sachseln","Safenwil","Saignelegier","Saint-Aubin","Saint-Aubin-Sauges","Saint-Blaise","Saint-Cergue","Saint-Imier","Saint-Leonard","Saint-Livres","Saint-Maurice","Saint-Prex","Saint-Sulpice","Saint-Sulpice","Sainte-Croix","Salmsach","Samstagern","Sankt Gallenkappel","Sankt Margrethen","Sargans","Sariswil","Sarmenstorf","Sarn","Sarnen","Satigny","Sattel","Saviese","Savigny","Savognin","Saxon","Schachen","Schaffhausen","Schafisheim","Schanis","Schattdorf","Schenkon","Schiers","Schindellegi","Schinznach Bad","Schinznach Dorf","Schlatt","Schleitheim","Schlieren","Schmerikon","Schmitten","Schmitten","Schnottwil","Schoetz","Schoftland","Schonbuhl","Schonenberg","Schonenbuch","Schonenwerd","Schongau","Schonholzerswilen","Schonried","Schubelbach","Schuepfheim","Schupfen","Schwarzenberg","Schwarzenburg","Schwellbrunn","Schwyz","Scuol","Seedorf","Seedorf","Seegraben","Seelisberg","Seengen","Seewis im Pratigau","Seftigen","Seltisberg","Selzach","Sembrancher","Sementina","Sempach","Semsales","Sennwald","Seon","Sessa","Seuzach Dorf","Sevelen","Sezegnin","Siebnen","Sierre","Siglistorf","Sigriswil","Sils-Segl Maria","Sins","Sion","Sirnach","Siselen","Sissach","Siviriez","Solothurn","Sonceboz","Sonvico","Sonvilier","Sorengo","Sottens","Soyhieres","Speicher","Spiez","Spreitenbach","St. Gallen","Stabio","Stadel","Stafa","Stallikon","Stans","Stansstad","Staufen","Steckborn","Steffisburg","Steg","Stein","Stein","Stein am Rhein","Steinen","Steinhausen","Stettfurt","Stettlen","Stoos","Strengelbach","Subingen","Suhr","Sulgen","Sulz","Sumiswald","Sursee","Tafers","Tagerwilen","Tamins","Tanay","Tann","Tasch","Tauffelen","Tavannes","Tegerfelden","Tenero","Termen","Territet","Tesserete","Teufen AR","Teufenthal","Thalheim","Thalheim","Thalwil","Thayngen","Therwil","Thielle","Thierachern","Thierrens","Thonex","Thorishaus","Thun","Thundorf","Thusis","Toffen","Tramelan","Trasadingen","Travers","Treyvaux","Triengen","Trimbach","Trimmis","Trogen","Troistorrents","Trubbach","Trubschachen","Trun","Tschuggen","Tuggen","Turbenthal","Turgi","Twann","Udligenswil","Ueberstorf","Uerikon","Uerkheim","Uetendorf","Uetikon","Ufhusen","Uhwiesen","Uitikon","Ulrichen","Unter-Teufen","Unterageri","Unterehrendingen","Unterengstringen","Untererlinsbach","Unteriberg","Unterkulm","Unterlunkhofen","Unterseen","Untersiggenthal","Untervaz","Ursenbach","Urtenen","Uster","Utzenstorf","Uznach","Uzwil","Vacallo","Vallorbe","Vandoeuvres","Vauderens","Vaulruz","Veltheim","Verbier","Vercorin","Vernayaz","Vernier","Verscio","Versoix","Vesenaz","Vessy","Vetroz","Vevey","Vex","Veyrier","Veytaux","Vicques","Viganello","Villa","Villars","Villars-sur-Glane","Villars-sur-Ollon","Villaz-Saint-Pierre","Villeneuve","Villeret","Villigen","Villmergen","Villnachern","Vilters","Vinzel","Vionnaz","Visp","Vitznau","Volketswil","Vordemwald","Vouvry","Vuadens","Vuiteboeuf","Vullierens","Wabern","Wadenswil","Wagenhausen","Wahlen","Walchwil","Wald","Waldenburg","Waldhaus","Waldkirch","Waldstatt","Walkringen","Wallisellen","Waltenschwil","Walzenhausen","Wangen","Wangen","Wangen an der Aare","Wangi","Wangs","Wasen","Wattwil","Wauwil","Weesen","Wegenstetten","Weggis","Weinfelden","Weiningen","Weiningen","Weissbad","Weisslingen","Welschenrohr","Wengen","Werthenstein","Wettingen","Wetzikon","Wichtrach","Wiedlisbach","Wiesendangen","Wigoltingen","Wikon","Wil","Wil","Wila","Wildegg","Wilderswil","Wileroltigen","Willisau","Wimmis","Windisch","Winkel","Winterberg","Winterthur","Wittenbach","Wittnau","Wohlen","Wolfenschiessen","Wolfgang","Wolfhalden","Wolfwil","Wolhusen","Wollerau","Worb","Worben","Worblaufen","Wuppenau","Wurenlingen","Wurenlos","Wynau","Yens","Yverdon-les-Bains","Yvonand","Yvorne","Zaziwil","Zeglingen","Zeihen","Zell","Zell","Zermatt","Ziegelbrucke","Zihlschlacht","Zizers","Zofingen","Zollbruck","Zollikofen","Zollikon","Zuchwil","Zuckenriet","Zufikon","Zug","Zullwil","Zumikon","Zunzgen","Zurich","Zuzgen","Zuzwil","Zwingen"],"Taiwan":["Budai","Caogang","Chang-hua","Checheng","Chiayi","Dahu","Douliu","Erlin","Fanlu","Fengshan","Gangshan","Gaozhongyicun","Hemei","Hengchun","Hsinchu","Hualian","Jincheng","Kao-sung","Kaohsiung City","Keelung","Linkou","Lugang","Ma-kung","Maru","Matsu","Meilun","Miaoli","Nanhua","Nankan","Nantou","Neihu","Pingtung","Pozi","Puli","Shalun","Shetou","Shoufeng","Shuilin","Shuiliu","Shuishang","Shulin","Shuyi","Suqin","Taichang","Taichung","Tainan","Taipei","Taipingding","Taitung","Taoyuan","Toucheng","Tuchang","Wan-hua","Wangtongwen","Wanluan","Wutai","Xinji","Xinzhuang","Yangmei","Yanping","Yilan","Yuli","Yunlin County","Zhubei","Zhunan","Zhuqi"],"Tanzania":["Arusha","Bukoba","Dar es Salaam","Dodoma","Morogoro","Mwanza","Njombe","Raha","Tanga","Zanzibar"],"Thailand":["Bangkok (also known as Krung Thep Maha Nakhon)","Chiang Mai","Phuket City","Pattaya","Nonthaburi","Hat Yai","Udon Thani","Nakhon Ratchasima (Korat)","Chiang Rai","Khon Kaen"],"Trinidad and Tobago":["Arima","Arouca","Barataria","California","Carapichaima","Carenage","Caroni","Chaguanas","Claxton Bay","Couva","Cumuto","Cunupia","Curepe","Debe","Diego Martin","El Dorado","Freeport","Fyzabad","Gasparillo","Golden Lane","Laventille","Lopinot","Marabella","Maraval","Moriah","Morvant","Penal","Petit Valley","Phoenix Park","Piarco","Port of Spain","Princes Town","Rio Claro","Roxborough","Saint Augustine","Saint Clair","Saint James","Saint Joseph","San Fernando","San Juan","Sangre Grande","Santa Cruz","Scarborough","Siparia","Tunapuna","Valsayn","Victoria","Ward of Tacarigua","Woodbrook"],"Tunisia":["Ariana","Beja","Gafsa","Hammamet","Le Bardo","Manouba","Monastir","Rades","Sfax","Sidi Bouzid","Sousse","Tunis"],"Turkey":["Abdullah","Acibadem","Ada","Adana","Adnan Menderes","Afyonkarahisar","Akhisar","Aksaray","Alanya","Alpaslan","Amasra","Amasya","Andac","Ankara","Antakya","Antalya","Ardahan","Artvin","Atakoy","Ataturk","Atlas","Ayazaga","Aydin","Aydogan","Aydogdu","Babaeski","Balcova","Banaz","Bandirma","Bartin","Basari","Baskent","Baskil","Batman","Bayburt","Bayrampasa","Belek","Bergama","Besiktas","Beykent","Beykoz","Beysehir","Biga","Bilecik","Bilgi","Bingol","Birbir","Bitam","Bitlis","Bodrum","Bogazici","Bolu","Bor","Bornova","Bozuyuk","Buca","Bucak","Bueyuekcekmece","Bugdayli","Bulut","Burdur","Burgaz","Burhaniye","Bursa","Calkaya","Camliyayla","Cekme","Celal","Cermik","Ceyhan","Cine","Cukurova","Dalaman","Darica","Dayanikli","Demetevleri","Deniz","Denizli","Doga","Dogankoy","Dogu","Dogus","Dokuz","Dortyol","Doruklu","Dumlupinar","Duran","Duzce","Edebey","Edirne","Edremit","Elbistan","Elek","Erbaa","Ercis","Erciyes","Erenkoy","Erzin","Erzincan","Erzurum","Esenkent","Esentepe","Esenyurt","Eser","Eskisehir","Etimesgut","Fatih","Ferizli","Fethiye","Findikli","Gazi","Gaziantep","Gebze","Gediz","Gelibolu","Gemlik","Germencik","Geulzuk","Giresun","Girne","Golmarmara","Gonen","Gunbuldu","Guzelyurt","Hakkari","Halic","Harbiye","Harran","Hendek","Hurriyet","Ibrahim","Ikitelli","Iskilip","Isparta","Istanbul","Izmir","Kadikoey","Kadikoy","Kadir","Kadirli","Kagithane","Karabuk","Karaca","Karakoy","Karaman","Karamursel","Karatekin","Kars","Kartal","Kastamonu","Kayseri","Kecioeren","Kemal","Kibriskoy","Kilis","Kirikkale","Kisir","Kocakoy","Kocatepe","Konak","Konya","Korfez","Kozan","Kucukcekmece","Kumluca","Kusadasi","Kuzey","Magnesia ad Sipylum","Mahmutkoy","Malatya","Maltepe","Manavgat","Mardin","Marmaris","Maslak","Mehmet Akif Ersoy","Meliksah","Meric","Mersin","Merzifon","Mezitli","Milas","Mugla","Muradiye","Muratpasa","Mustafa","Mustafa Kemal","Mustafakemalpasa","Nazilli","Niksar","Niluefer","Nizip","Ordu","Orhangazi","Orta","Osmaneli","Osmangazi","Osmaniye","Ostim","Pamukkale","Patnos","Pendik","Piri","Rize","Sabanci","Safranbolu","Saglik","Sahinbey","Salihli","Samsun","Sanayi","Sanliurfa","Sariyer","Seferihisar","Sehitkamil","Selcuk","Serdivan","Serik","Seydisehir","Seyhan","Siirt","Sile","Silifke","Siliviri","Sinankoy","Sincan","Sinop","Sirnak","Sisli","Sisman","Sivas","Soeke","Suleyman","Sultanpinar","Sungurlu","Susurluk","Taksim","Tarsus","Tasdelen","Tatvan","Tesvikiye","Tire","Tokat Province","Toprak","Torbali","Toros","Trabzon","Trakya","Tunceli","Turgut","Turgutlu","Uchisar","UEskuedar","Ugur","Ulker","Uludag","Ulus","Umraniye","Unieh","Urgub","Urla","Uzun Keupru","Van","Yagcilar","Yakakoy","Yalova","Yaman","Yasarkoy","Yeditepe","Yeni","Yenibosna","Yildiz","Yozgat","Yuregir","Zekeriya","Zeytinburnu","Zonguldak"],"U.S. Virgin Islands":["Charlotte Amalie","Christiansted","Frederiksted","Kingshill","St John Island"],"Ukraine":["Aleksandriya","Aleksandrovka","Alekseyevo-Druzhkovka","Alupka","Alushta","Babin","Barashivka","Baryshivka","Belaya","Berdychiv","Berehove","Bila Hora","Bila Tserkva","Bolekhiv","Borodyanka","Bortnychi","Boryslav","Boryspil","Boryspil Raion","Boyarka","Bozhenka","Brody","Brovary","Bryanka","Bucha","Buchach","Bukova","Bushtyno","Cherkasy","Chernev","Chernihiv","Chernivtsi","Chervona Hirka","Chervonohrad","Chop","Darakhov","Davydov","Desna","Dimitrov","Dmitrovichi","Dnipropetrovsk","Donetsk","Drohobych","Druzhkovka","Dubno","Dzhankoy","Energodar","Fastiv","Feodosiya","Fontanka","Frunze","German","Goncharov","Gorlovka","Grebenyuk","Haysyn","Hlukhiv","Horlivka","Horodenka","Hoshiv","Illintsi","Irpin","Ivankov","Ivanov","Izmail","Kakhovka","Kalush","Kalynivka","Kalynivka","Kaniv","Kerch","Kharkiv","Kherson","Khust","Khyzha","Kiev","Kirovohrad","Kirovsk","Knyazhychi","Kolomyia","Komsomolsk","Konotop","Korosten","Korostyshiv","Kovel","Kozyatyn","Kramatorsk","Krasnodon","Krasnohrad","Kremenchuk","Kremenets","Kreminna","Kryvyy Rih","Kuna","Kurakhovo","Kurylivka","Kuznetsovsk","Kvasyliv","Kyseliv","Kyyiv","Lanovka","Lenina","Letychiv","Lisichansk","Lityn","Lohvynove","Lubny","Lugansk","Luganskoye","Luhansk","Lutsk","Lutugino","Lviv","Makariv","Makiyivka","Maksim","Mala Tokmachka","Malyn","Mariupol","Markova","Mega","Melitopol","Merefa","Monastyryshche","Mukacheve","Mykolayiv","Mykolayiv","Mylove","Nadezhda","Netishyn","Nizhyn","Nosivka","Novi Sanzhary","Novomoskovsk","Novyy Buh","Obukhov","Odesa","Oleh","Oreanda","Osnova","Osypenko","Pavlograd","Pavlohrad","Petranka","Petrenky","Pobeda","Podol","Poltava","Poplavy","Pyrohiv","Rayhorodka","Rivne","Rivne","Rodinskoye","Romaniv","Romny","Rovenki","Rubizhne","Saky","Selidovo","Semen","Sencha","Serhiyi","Sevastopol","Shepetivka","Shevchenka","Shevchenko","Shostka","Shpola","Simferopol","Slavuta","Sloviansk","Slynkivshchyna","Smila","Sokol","Sokoliv","Soroka","Soroki","Sorotskoye","Spas","Stakhanov","Stanislav","Stat","Stryi","Sudak","Sumy","Svalyava","Svessa","Teplodar","Teremky","Ternopil","Ternovka","Tkachenka","Tokmak","Toporov","Torez","Trypillia","Tsvetkov","Tsyurupinsk","Turka","Tyachiv","Ugledar","Ukrayinka","Uzhhorod","Vasylkiv","Vinnytsya","Volkov","Volnovakha","Voronovo","Vorovskiy","Voznesenka","Vyshhorod","Vyshneve","Yalta","Yasinovataya","Yenakiyeve","Zabolotiv","Zaporizhia","Zaporozhe","Zastava","Zavod","Zdolbuniv","Zhashkiv","Zhdanovka","Zhmerynka","Zhytomyr","Zlazne","Zmiyiv","Zolochiv","Zolotonosha"],"United Arab Emirates":["Abu Dhabi","Al Ain","Al Khan","Ar Ruways","As Satwah","Dayrah","Dubai","Fujairah","Ras al-Khaimah","Sharjah"],"United Kingdom":["Abberton","Abbots Langley","Aberaeron","Aberchirder","Abercynon","Aberdare","Aberdeen","Aberfeldy","Aberford","Aberfoyle","Abergavenny","Abergele","Abergwynfi","Abergynolwyn","Aberkenfig","Aberlour","Abersychan","Abertillery","Aberystwyth","Abingdon","Aboyne","Accrington","Acton","Addington","Addington","Addlestone","Adlingfleet","Aghalee","Aintree","Airdrie","Akeley","Albrighton","Alcester","Aldeburgh","Alderholt","Alderley Edge","Aldermaston","Aldershot","Aldridge","Alexandria","Alfold","Alford","Alford","Alfreton","Alloa","Alness","Alnwick","Alresford","Alrewas","Alsager","Alston","Altham","Alton","Alton","Altrincham","Alva","Alvechurch","Alveston","Ambleside","Amersham","Amesbury","Amlwch","Ammanford","Ampthill","Andover","Angmering","Anlaby","Annalong","Annan","Annesley","Anniesland","Anstey","Anstey","Anstruther","Antrim","Appleby","Appleford","Appleton","Appley Bridge","Arbroath","Ardingly","Ardmillan","Ardrossan","Arlesey","Arley","Armadale","Armagh","Armitage","Arnold","Arrochar","Arthog","Arundel","Ascot","Ash","Ash Vale","Ashbourne","Ashburton","Ashby de la Launde","Ashby de la Zouch","Ashdon","Ashen","Ashfield","Ashford","Ashford","Ashington","Ashington","Ashley","Ashmore","Ashtead","Ashton in Makerfield","Ashton-under-Lyne","Ashwell","Askam in Furness","Askern","Askham","Astley","Aston","Aston Clinton","Atherstone","Atherton","Attleborough","Attleborough","Atworth","Auchinleck","Auchterarder","Auchtermuchty","Augher","Aughnacloy","Aultbea","Aveley","Aviemore","Avoch","Avonmouth","Axbridge","Axminster","Aycliffe","Aylesbury","Aylesford","Aylsham","Ayr","Babraham","Back","Bacton","Bacup","Bagillt","Bagshot","Baildon","Bainton","Bakewell","Bala","Baldock","Balerno","Balham","Ball","Ballingry","Balloch","Ballybogy","Ballycastle","Ballyclare","Ballymena","Ballymoney","Ballynahinch","Bampton","Banbridge","Banbury","Banchory","Banff","Bangor","Bangor","Bangor-is-y-coed","Banham","Banstead","Barbaraville","Bargoed","Barking","Barkway","Barley","Barmouth","Barmston","Barnard Castle","Barnes","Barnet","Barnham","Barnoldswick","Barnsley","Barnstaple","Barnwell","Barrow","Barrow in Furness","Barrow upon Humber","Barrow upon Soar","Barrowford","Barry","Barton in Fabis","Barton on Sea","Barton under Needwood","Barton upon Humber","Barton-le-Clay","Barwell","Basildon","Basingstoke","Baslow","Bath","Bathgate","Batley","Battle","Bawtry","Bayble","Bayford","Beach","Beaconsfield","Beal","Bealings","Beaminster","Beaufort","Beaulieu","Beauly","Beaumaris","Beaumont","Beaworthy","Bebington","Beccles","Beckenham","Beckingham","Beckley","Beckton","Bedale","Bedford","Bedlington","Bedminster","Bedworth","Beer","Beeston","Beith","Bekesbourne","Belbroughton","Belcoo","Belfast","Belleek","Bellshill","Belmont","Belper","Belvedere","Bembridge","Ben Rhydding","Benburb","Benenden","Benllech","Benson","Bentley","Berkeley","Berkhamstead","Bermondsey","Berwick","Berwick-Upon-Tweed","Besthorpe","Betchworth","Bettws","Betws","Beverley","Bewdley","Bexhill","Bexleyheath","Bicester","Bickenhill","Bickleigh","Biddenden","Biddenham","Biddulph","Bideford","Bidford-on-Avon","Bidston","Bierton","Biggar","Biggin Hill","Biggleswade","Bignor","Bildeston","Billericay","Billesley","Billingham","Billingshurst","Bilsthorpe","Bilston","Binfield","Bingham","Bingley","Binsted","Birchanger","Birchington","Birdbrook","Birkenhead","Birmingham","Birnam","Birstall","Birtley","Birtley","Bishop Auckland","Bishop Burton","Bishopbriggs","Bishops Cleeve","Bishops Waltham","Bishopstoke","Bishopstrow","Bishopton","Bisley","Blackburn","Blackford","Blackford","Blackheath","Blackpool","Blackwater","Blackwater","Blackwood","Blackwood","Blaenau-Ffestiniog","Blaenavon","Blaenwaun","Blaina","Blairgowrie","Blakeney","Blakeney","Blandford Forum","Blaydon","Bledlow","Bletchingley","Bletchley","Blewbury","Blidworth","Bloomsbury","Bloxwich","Blunham","Bluntisham","Blyth","Bodelwyddan","Bodmin","Bognor Regis","Boldon Colliery","Bollington","Bolney","Bolsover","Bolton","Bonar Bridge","Bonnybridge","Bonnyrigg","Bookham","Bootle","Bordesley","Boreham","Borehamwood","Borough Green","Boroughbridge","Bosbury","Boscastle","Boston","Boston Spa","Botesdale","Bothwell","Botley","Bottesford","Bourne","Bourne End","Bournemouth","Bournville","Bourton on the Water","Bovey Tracey","Bow","Bowdon","Bowes","Bowness-on-Windermere","Box","Boxley","Bozeat","Brackley","Bracknell","Bradfield St George","Bradford","Bradford-on-Avon","Bradwell on Sea","Braintree","Bramford","Bramhall","Bramley","Brampton","Brandesburton","Brandon","Brandon","Brandon","Bransford","Bransgore","Brasted","Braunstone","Braunton","Brayton","Brechin","Brecon","Bredbury","Brede","Brenchley","Brentford","Brentwood","Brewood","Bridge","Bridgemary","Bridgend","Bridgham","Bridgnorth","Bridgwater","Bridlington","Bridport","Brierfield","Brierley Hill","Brigg","Brighouse","Brightlingsea","Brighton","Brigstock","Brimpton","Brimscombe","Bristol","Briton Ferry","Brixham","Brixton Hill","Brixworth","Broad Blunsdon","Broadstairs","Broadstone","Broadwas","Broadway","Brockenhurst","Brockley Green","Brockworth","Bromborough","Bromham","Brompton","Bromsgrove","Bromyard","Brook","Brook","Brooke","Brookland","Broom","Broseley","Brough","Broughton","Broughton","Broughton","Broughton","Broughton","Broughton","Broughton","Broughty Ferry","Brownhills","Broxbourne","Broxburn","Bruton","Buckden","Buckfastleigh","Buckhurst Hill","Buckie","Buckingham","Buckland","Buckley","Bucknell","Bude","Budleigh Salterton","Bugbrooke","Builth Wells","Bulford","Bulkington","Bulwell","Bungay","Buntingford","Burbage","Burbage","Burford","Burgess Hill","Burgh le Marsh","Burghclere","Burley","Burnham","Burnham on Crouch","Burnham-on-Sea","Burnley","Burnopfield","Burntisland","Burntwood","Burry Port","Burscough","Burslem","Burstwick","Burton","Burton","Burton Pidsea","Burton-on-Trent","Burwash","Burwell","Bury","Bury","Bury St Edmunds","Burythorpe","Bushey","Butterton","Buxted","Buxton","Byfield","Byfleet","Cadbury","Caddington","Caernarfon","Caerphilly","Caersws","Caister-on-Sea","Caistor","Caldicot","Callander","Callington","Calne","Calstock","Calverton","Cam","Camberley","Camberwell","Camborne","Cambridge","Cambuslang","Cambusnethan","Camelford","Campbeltown","Canewdon","Cannock","Canterbury","Capel","Capenhurst","Carbrooke","Cardiff","Cardigan","Cardonald","Cardross","Carlisle","Carlton","Carlton","Carlton le Moorland","Carluke","Carmarthen","Carnforth","Carnmoney","Carnoustie","Carrbridge","Carrickfergus","Carrowdore","Carshalton","Carterton","Castle Cary","Castle Donington","Castle Douglas","Castlederg","Castleford","Castlereagh","Castleton","Castlewellan","Caston","Caterham","Catford","Catherington","Catterick","Caversham","Cawston","Caxton","Caythorpe","Chacombe","Chaddesden","Chadwell","Chalfont Saint Peter","Chalgrove","Chandlers Ford","Chapel en le Frith","Chapeltown","Chard","Charfield","Charing Cross","Charlestown","Charlton on Otmoor","Charlwood","Charmouth","Chartham","Chasetown","Chatham","Chatteris","Cheadle","Cheadle","Cheadle Hulme","Cheam","Checkley","Cheddar","Chellaston","Chelmsford","Chelsfield","Cheltenham","Chepstow","Chertsey","Chesham","Cheshunt","Chessington","Chester","Chester-le-Street","Chesterfield","Chestfield","Chichester","Chigwell","Chilbolton","Chilcompton","Childwall","Chilton","Chilton","Chilton Trinity","Chilwell","Chingford","Chinley","Chinnor","Chippenham","Chipping Campden","Chipping Norton","Chipping Ongar","Chipping Sodbury","Chipstead","Chislehurst","Chiswick","Choppington","Chorley","Christchurch","Christleton","Chryston","Chulmleigh","Church","Church Gresley","Church Leigh","Church Stretton","Churchill","Cinderford","Cirencester","City of London","City of Westminster","Clackmannan","Clacton-on-Sea","Clapham","Clapham","Clapham","Clarbeston Road","Clare","Clare","Claverdon","Clavering","Claygate","Clayton West","Cleator","Cleator Moor","Cleckheaton","Clevedon","Cleveleys","Cliffe","Clifton","Clifton","Clifton","Clifton Hampden","Clipstone","Clitheroe","Clovenfords","Clun","Clunderwen","Clutton","Clydach","Clydebank","Coalbrookdale","Coalisland","Coalville","Coatbridge","Cobham","Cobham","Cockerham","Cockermouth","Codsall","Coed-Talon","Cogenhoe","Coggeshall","Colchester","Coleford","Coleraine","Colnbrook","Colne","Colne","Colwyn Bay","Colyford","Colyton","Comber","Compton","Compton Dundon","Comrie","Congleton","Conisbrough","Connahs Quay","Conon Bridge","Consett","Conway","Cookham","Cooksbridge","Cookstown","Coppenhall","Coppull","Corbridge","Corby","Corfe Castle","Corfe Mullen","Corpach","Corringham","Corsham","Corwen","Coseley","Cosham","Cotgrave","Cottenham","Cottered","Cottingham","Coulsdon","Countess Wear","Coupar Angus","Covent Garden","Coventry","Cowbridge","Cowden","Cowdenbeath","Cowley","Cradley","Craigavon","Cramlington","Cranbrook","Cranfield","Cranford","Cranleigh","Crathorne","Craven Arms","Crawley","Crayford","Crediton","Crewe","Crewkerne","Criccieth","Crick","Crickhowell","Cricklade","Cricklewood","Crieff","Crofton","Cromer","Cromwell","Crook","Crookham","Crosby","Cross","Cross in Hand","Cross Keys","Crossgar","Crossgates","Crosshouse","Croston","Croughton","Crowborough","Crowland","Crowthorne","Croxley Green","Croydon","Crumlin","Crymych","Cublington","Cuckfield","Cuffley","Cullen","Cullompton","Cumbernauld","Cumnock","Cupar","Curdridge","Currie","Cwmbran","Cynwyd","Dagenham","Dalbeattie","Dalkeith","Dalry","Dalton in Furness","Daresbury","Darfield","Darlaston","Darlington","Dartford","Dartmouth","Darvel","Darwen","Datchet","Daventry","Dawley","Dawlish","Deal","Dean","Deighton","Denbigh","Denby","Denham","Denny","Denton","Deptford","Derby","Dereham","Derwen","Desborough","Devizes","Dewsbury","Didcot","Diddington","Dinas Powys","Dingestow","Dingwall","Dinnington","Diss","Doagh","Dolgelly","Dollar","Dollis Hill","Dolwyddelan","Donaghadee","Doncaster","Donnington","Dorchester","Dorking","Dorney","Dornoch","Dorridge","Douglas","Doune","Dover","Dovercourt","Downend","Downham Market","Downpatrick","Draperstown","Draycott","Draycott in the Moors","Drayton","Drayton Bassett","Drayton Saint Leonard","Driffield","Drighlington","Droitwich","Dromara","Dromore","Dronfield","Droxford","Droylsden","Drumahoe","Drumchapel","Drybrook","Drymen","Duddington","Dudley","Duffield","Duffus","Dukinfield","Dulverton","Dulwich","Dumbarton","Dumbleton","Dumfries","Dunbar","Dunblane","Dunchurch","Dundee","Dundonald","Dunfermline","Dungannon","Dungiven","Dunkeld","Dunkeswell","Dunmurry","Dunning","Dunoon","Duns","Dunstable","Durham","Durrington","Dursley","Duxford","Dyce","Dymock","Dyserth","Eagle","Eaglesfield","Eaglesham","Earley","Earlham","Earls Colne","Earls Court","Earlston","Earnley","Easington","Easingwold","East Barnet","East Bergholt","East Boldon","East Budleigh","East Challow","East Cowes","East Down","East Dulwich","East Grinstead","East Hagbourne","East Ham","East Hanningfield","East Harling","East Hoathly","East Horsley","East Keal","East Kilbride","East Leake","East Linton","East Malling","East Molesey","East Peckham","East Preston","East Retford","East Stour","East Tilbury","Eastbourne","Eastchurch","Eastcote","Eastham","Eastington","Eastleigh","Easton","Eastwood","Ebbw Vale","Eccles","Eccleshall","Edenbridge","Edenfield","Edgbaston","Edgefield","Edgware","Edinburgh","Edmonton","Edwalton","Edwinstowe","Effingham","Egerton","Egham","Egremont","Egton","Elderslie","Elgin","Elland","Ellesmere","Ellesmere Port","Ellington","Ellon","Elloughton","Elmley Lovett","Elstead","Elstree","Elsworth","Eltham","Ely","Ely","Empingham","Emsworth","Enfield","Englefield Green","Enniskillen","Enstone","Epping","Epping Green","Epsom","Erdington","Erith","Esher","Essendon","Etchingham","Eton","Eversholt","Evesham","Ewelme","Ewhurst","Exeter","Exminster","Exmouth","Eye","Eyemouth","Eynsham","Failsworth","Fairford","Fairlight","Fakenham","Falkirk","Falkland","Falmouth","Fangfoss","Fareham","Faringdon","Farmborough","Farnborough","Farndon","Farnham","Farnham Royal","Farningham","Farnworth","Fauldhouse","Faulkland","Faversham","Felbridge","Felixstowe","Felsted","Feltham","Ferndale","Ferryhill","Ferryside","Filey","Fillongley","Finchampstead","Finchley","Finedon","Fintry","Fishburn","Fishguard","Fitzwilliam","Fivemiletown","Fladbury","Fleet","Fleetwood","Flint","Flitwick","Flordon","Fochabers","Folkestone","Ford","Fordingbridge","Forest Row","Forfar","Formby","Forres","Fort William","Four Marks","Fowey","Fownhope","Framlingham","Frant","Fraserburgh","Freckleton","Frensham","Freshwater","Fressingfield","Friern Barnet","Frimley","Fringford","Frinton-on-Sea","Friskney","Frithville","Frizington","Frodsham","Froggatt","Frome","Fulham","Fulmer","Gaerwen","Gainsborough","Galashiels","Galston","Gamlingay","Gargrave","Gargunnock","Garrison","Garstang","Garston","Garth","Gateshead","Gatwick","Gaydon","Gayton Thorpe","Gelligaer","Gifford","Giggleswick","Gillingham","Gillingham","Gipping","Girton","Girvan","Glasdrumman","Glasgow","Glastonbury","Glenboig","Glenrothes","Glenshee","Glentham","Glossop","Gloucester","Gnosall","Godalming","Godmanchester","Godmersham","Godstone","Golborne","Gomersal","Goodmayes","Goodwick","Goole","Goostrey","Gordon","Gorebridge","Goring","Goring","Gorleston-on-Sea","Gorseinon","Gorslas","Gorton","Gosberton","Gosfield","Gosforth","Gosport","Goudhurst","Gourock","Granby","Grange","Grangemouth","Grantham","Grantown on Spey","Grasmere","Grateley","Graveley","Gravesend","Grays","Great Amwell","Great Baddow","Great Barton","Great Billing","Great Chesterford","Great Dunmow","Great Fransham","Great Gidding","Great Glemham","Great Gransden","Great Milton","Great Missenden","Great Ryburgh","Great Staughton","Great Torrington","Great Waldingfield","Great Yarmouth","Greenfield","Greenford","Greenhead","Greenhithe","Greenisland","Greenock","Greensted","Greenwich","Grendon","Grendon Underwood","Gresford","Gretna","Gretna Green","Gretton","Grimsargh","Grimsby","Groombridge","Grove","Guildford","Guisborough","Guiseley","Gullane","Gunnislake","Guthrie","Hackbridge","Hackney","Haddenham","Haddington","Hadleigh","Hadleigh","Hadlow","Hadlow Down","Hagley","Hailsham","Halesowen","Halesworth","Halewood","Halifax","Halstead","Halstead","Halton","Haltwhistle","Halwell","Hamble","Hambleden","Hambleton","Hamilton","Hammersmith","Hampton","Hampton","Hampton Lucy","Handcross","Handforth","Handsworth","Hanley","Hanwell","Hanworth","Hapton","Harby","Hardham","Harefield","Harlaxton","Harlech","Harlesden","Harleston","Harlow","Harold Wood","Harpenden","Harrogate","Harrold","Harrow","Harrow on the Hill","Harrow Weald","Hartfield","Hartford","Hartlepool","Hartley","Hartpury","Hartwell","Harwell","Harwich","Harworth","Haslemere","Haslingden","Hassocks","Hastings","Hatch","Hatfield","Hatherleigh","Hathersage","Hatton","Havant","Haverfordwest","Haverhill","Havering atte Bower","Hawarden","Hawes","Hawick","Hawkhurst","Hawkwell","Hawley","Haydock","Haydon Bridge","Hayes","Hayes","Hayle","Haywards Heath","Hazel Grove","Hazelwood","Headcorn","Headington","Headley","Heanor","Heath","Heathfield","Heathrow","Hebburn","Hebden Bridge","Heckington","Heckmondwike","Hedgerley","Hednesford","Hedon","Helens Bay","Helensburgh","Hellesdon","Helmsley","Helston","Hemel Hempstead","Hemingstone","Hemswell","Hemsworth","Hendon","Henfield","Hengoed","Henham","Henley","Henley-on-Thames","Henlow","Hennock","Henstridge","Hereford","Heriot","Hermitage","Herne Bay","Herriard","Hersham","Herstmonceux","Hertford","Hessle","Heston","Heswall","Hever","Hexham","Heybridge","Heysham","Heythrop","Heywood","High Bentham","High Blantyre","High Halden","High Legh","High Peak","High Peak Junction","High Wycombe","Higham Ferrers","Higham on the Hill","Highbridge","Highbury","Highcliffe","Higher Bebington","Hightown","Highway","Highworth","Hilborough","Hilderstone","Hill","Hillingdon","Hillsborough","Hillside","Hilton","Hinckley","Hindhead","Hindley","Hindon","Hingham","Hinton St George","Histon","Hitcham","Hitchin","Hockley","Hoddesdon","Holbeach","Holborn","Holmes Chapel","Holmewood","Holmfirth","Holsworthy","Holt","Holt","Holyhead","Holywell","Holywell","Holywood","Honingham","Honiton","Hook","Hooke","Hopwood","Horam","Horbling","Horbury","Horley","Horley","Horncastle","Hornchurch","Horndean","Horndon on the Hill","Hornsea","Hornsey","Horrabridge","Horsham","Horsmonden","Horsted Keynes","Horton Kirby","Horwich","Hotham","Houghton on the Hill","Houghton Regis","Houghton-le-Spring","Houston","Hove","Howden","Hoylake","Hucknall Torkard","Hucknall under Huthwaite","Huddersfield","Huish","Hull","Humberston","Humbie","Hungerford","Hunstanton","Huntingdon","Huntly","Huntspill","Hursley","Hurstbourne Tarrant","Hurstpierpoint","Hurworth","Huyton","Hyde","Hythe","Ibstock","Ickenham","Ifield","Ilchester","Ilford","Ilfracombe","Ilkeston","Ilkley","Ilminster","Immingham","Inchinnan","Ingatestone","Innerleithen","Insch","Inveraray","Invergordon","Inverkeilor","Inverkeithing","Inverkip","Inverness","Inverness-shire","Inverurie","Ipswich","Irlam","Irthlingborough","Irvine","Isham","Isleham","Isleworth","Islington","Islip","Itchen","Itchen Abbas","Iver","Ivybridge","Iwerne Courtney","Jarrow","Jedburgh","Johnstone","Jordanstown","Juniper Green","Kedington","Keele","Keighley","Keith","Kelbrook","Kelly","Kelmarsh","Kelsall","Kelso","Kelty","Kelvedon","Kempston","Kendal","Kenilworth","Kenley","Kennington","Kennoway","Kensington","Kent","Keresley","Keston","Keswick","Ketley","Kettering","Keynsham","Kibworth Harcourt","Kidderminster","Kidlington","Kidsgrove","Kidwelly","Kilbarchan","Kilbirnie","Kilbride","Kilbride","Kilkeel","Killamarsh","Killin","Kilmacolm","Kilmarnock","Kilsyth","Kilwinning","Kimberley","Kimbolton","Kingham","Kinghorn","Kinglassie","Kings Langley","Kings Lynn","Kings Norton","Kings Sutton","Kingsbridge","Kingskerswell","Kingsland","Kingsteignton","Kingston","Kingston","Kingston Seymour","Kingswinford","Kingswood","Kingswood","Kingussie","Kinloch Rannoch","Kinmel","Kinnerley","Kinross","Kirby Cross","Kirk Ella","Kirkby","Kirkby in Ashfield","Kirkby Stephen","Kirkcaldy","Kirkconnel","Kirkcudbright","Kirkham","Kirkintilloch","Kirkliston","Kirkwall","Kirriemuir","Kirtlington","Kirton in Lindsey","Knaresborough","Knebworth","Kneeton","Knighton","Knottingley","Knowsley","Knutsford","Kyle of Lochalsh","Laindon","Lakenheath","Lambeth","Lambourn","Lampeter","Lanark","Lancaster","Lancing","Landrake","Langho","Langley","Langport","Langstone","Lapworth","Larbert","Largs","Larkhall","Larne","Lauder","Laugharne","Launceston","Laurencekirk","Lavant","Lavendon","Lawrencetown","Laxfield","Laxton","Leatherhead","Lechlade","Leconfield","Ledbury","Lee","Lee-on-the-Solent","Leeds","Leeds","Leek","Leek Wootton","Leicester","Leigh","Leigh","Leigh-on-Sea","Leighton Buzzard","Leiston","Leitholm","Lenham","Leominster","Lerwick","Lesmahagow","Letchworth","Leuchars","Leven","Levenshulme","Lewes","Lewisham","Leyburn","Leyland","Leysdown-on-Sea","Leyton","Lichfield","Lidlington","Lifton","Limavady","Limekilns","Lincoln","Lindal in Furness","Lindfield","Lingfield","Linlithgow","Linthwaite","Linton","Linton","Linton upon Ouse","Liphook","Lisburn","Liskeard","Lisnaskea","Liss","Litherland","Little Barningham","Little Canfield","Little Eaton","Little Gaddesden","Little Hulton","Little Kimble","Little Lever","Little Milton","Little Paxton","Littleborough","Littlebury","Littlehampton","Littleport","Liverpool","Liversedge","Livingston","Llanbedr","Llanddulas","Llandeilo","Llandovery","Llandrillo","Llandrindod Wells","Llandudno","Llandudno Junction","Llanelli","Llanfair-Dyffryn-Clwyd","Llanfairfechan","Llanfyllin","Llanfyrnach","Llangattock","Llangefni","Llangennech","Llangollen","Llanharan","Llanidloes","Llanishen","Llanon","Llanrwst","Llansantffraid-ym-Mechain","Llantrisant","Llantrisant","Llantwit Fardre","Llantwit Major","Llanwrda","Llanwrtyd Wells","Llanymynech","Llwyngwril","Llwynypia","Loanhead","Lochgelly","Lochgilphead","Lochmaddy","Lochwinnoch","Lockerbie","Loddington","London","London Borough of Bromley","London Borough of Hounslow","London Borough of Wandsworth","Londonderry","Long Buckby","Long Ditton","Long Eaton","Long Melford","Long Stratton","Longdown","Longfield","Longhope","Longniddry","Longport","Longridge","Longstanton","Longton","Looe","Loppington","Lossiemouth","Lostwithiel","Loudwater","Loughborough","Loughor","Loughton","Louth","Low Ham","Lowdham","Lower Beeding","Lower Brailes","Lower Darwen","Lowestoft","Lowton","Lubenham","Ludlow","Lupton","Lurgan","Lustleigh","Luton","Lutterworth","Lydbury North","Lydney","Lyme Regis","Lyminge","Lymington","Lymm","Lympsham","Lyndhurst","Lyng","Lytchett Minster","Lytham","Mablethorpe","Macclesfield","Macduff","Machynlleth","Maerdy","Maesteg","Maghera","Magherafelt","Magheralin","Maghull","Maida Vale","Maiden Newton","Maidenhead","Maidstone","Malden","Maldon","Mallaig","Malmesbury","Malpas","Malton","Malvern","Manchester","Manningtree","Manor","Mansfield","Mansfield Woodhouse","Manton","March","Marcham","Marden","Margate","Marhamchurch","Mark","Market Deeping","Market Drayton","Market Harborough","Market Rasen","Market Weighton","Markfield","Marlborough","Marlow","Marnhull","Marple","Marr","Marsham","Marske","Martin","Martley","Martock","Maryhill","Maryport","Masham","Matching","Matlock","Mattishall","Mauchline","Maulden","Maybole","Mayfair","Mayfield","Mayfield","Meanwood","Measham","Medmenham","Medstead","Meesden","Meggies","Meifod","Melbourne","Meldreth","Melksham","Mells","Melrose","Melton","Melton Constable","Melton Mowbray","Menai Bridge","Mendlesham","Menheniot","Menston","Meopham","Mere","Merthyr Mawr","Merthyr Tydfil","Merton","Metheringham","Methil","Mexborough","Mickleton","Mickleton","Mid Calder","Middlesbrough","Middleton","Middleton","Middleton","Middleton One Row","Middlewich","Midford","Midgham","Midhurst","Midsomer Norton","Mildenhall","Milford","Milford Haven","Milford on Sea","Mill Hill","Millbrook","Millbrook","Millom","Milltimber","Milnathort","Milnthorpe","Milton","Milton","Milton","Milton Keynes","Milton on Stour","Minchinhampton","Minehead","Minster","Minster Lovell","Minsterley","Mirfield","Mitcham","Mitcheldean","Mobberley","Mochdre","Moira","Mold","Molesey","Molesey","Mollington","Moneymore","Monifieth","Monkswood","Monkton","Monmouth","Montgomery","Montrose","Monyash","Moorsholm","Moorside","Morden","More","Morecambe","Moreton","Moreton in Marsh","Morley","Morpeth","Morriston","Moseley","Moss","Mossley","Moston","Motherwell","Moulton","Moulton St Michael","Moulton St Michael","Mount Bures","Mount Hamilton","Mountain Ash","Mountsorrel","Much Hadham","Much Hoole","Much Wenlock","Muir of Ord","Mundesley","Murton","Musselburgh","Myddle","Mytholmroyd","Myton on Swale","Nafferton","Nailsea","Nairn","Nantwich","Nantyglo","Napton on the Hill","Narberth","Naseby","Nash","Nassington","Neasden","Neath","Needingworth","Neilston","Nelson","Nelson","Neston","Nettlebed","Nettleton","New Barnet","New Buckenham","New Cross","New Ferry","New Mills","New Milton","New Quay","New Romney","New Southgate","New Tredegar","Newark on Trent","Newbiggin-by-the-Sea","Newbold","Newbridge","Newbridge","Newburgh","Newbury","Newcastle","Newcastle","Newcastle Emlyn","Newcastle upon Tyne","Newcastle-under-Lyme","Newent","Newhall","Newham","Newham","Newhaven","Newick","Newlands","Newmarket","Newport","Newport","Newport","Newport","Newport","Newport Pagnell","Newport-On-Tay","Newquay","Newry","Newton Abbot","Newton Aycliffe","Newton on Trent","Newton Stewart","Newton-le-Willows","Newtonmore","Newtown","Newtownabbey","Newtownards","Norbury","Nordelph","Norham","Normandy","Normanton","North Berwick","North Elmsall","North Ferriby","North Hykeham","North Kilworth","North Leigh","North Moreton","North Newton","North Petherton","North Shields","North Somercotes","North Tawton","North Walsham","North Waltham","North Weald","Northallerton","Northampton","Northenden","Northfield","Northfleet","Northleach","Northolt","Northop","Northrepps","Northwich","Northwood","Norton","Norton","Norton","Norton Lindsey","Norwich","Norwood","Nottingham","Nuffield","Nuneaton","Nutfield","Nutley","Oadby","Oakamoor","Oakford","Oakham","Oakhill","Oakley","Oare","Oban","Odiham","Offord Cluny","Okehampton","Old Basing","Old Buckenham","Old Colwyn","Old Malton","Old Windsor","Oldbury","Oldbury","Oldham","Oldmeldrum","Olney","Omagh","Ormesby","Ormiston","Ormskirk","Orpington","Ossett","Oswaldtwistle","Oswestry","Otford","Otley","Otley","Otterburn","Ottershaw","Ottery St Mary","Oulton","Oundle","Overton","Oving","Ovingdean","Owslebury","Oxenhope","Oxford","Oxshott","Oxted","Padbury","Paddock Wood","Padiham","Padstow","Paignton","Painswick","Paisley","Palmers Green","Pampisford","Papworth Everard","Par","Parbold","Partington","Partridge Green","Paston","Patchway","Pathhead","Patrington","Paul","Peebles","Pelsall","Pembroke","Pembroke Dock","Pembury","Penarth","Pencader","Pencaitland","Pencarreg","Pencoed","Pendlebury","Penicuik","Penkridge","Penn","Pennington","Penrice","Penrith","Penryn","Penshurst","Pentraeth","Penwortham","Penzance","Perivale","Perranporth","Pershore","Perth","Peterborough","Peterculter","Peterhead","Peterlee","Petersfield","Petworth","Pevensey","Pewsey","Pickering","Piddington","Pilham","Pilton","Pinner","Pinxton","Pitlochry","Pitsford","Pittenweem","Plaistow","Plaitford","Pleshey","Plockton","Plumstead","Plymouth","Plymstock","Pocklington","Polegate","Polmont","Polperro","Ponders End","Pontardawe","Pontefract","Ponteland","Pontesbury","Pontycymer","Pontypool","Pontypridd","Poole","Poplar","Porlock","Port Erroll","Port Glasgow","Port Sunlight","Port Talbot","Portadown","Portaferry","Portchester","Portglenone","Porth","Porthcawl","Porthleven","Portishead","Portlethen","Portmadoc","Portree","Portrush","Portslade-by-Sea","Portsmouth","Portstewart","Postling","Potters Bar","Potterspury","Potton","Poulton le Fylde","Powfoot","Powick","Poynton","Prees","Preesall","Prescot","Prestatyn","Presteigne","Preston","Prestonpans","Prestwich","Prestwick","Princes Risborough","Princethorpe","Privett","Prudhoe","Puckeridge","Pudsey","Pulborough village hall","Pulloxhill","Purfleet","Purleigh","Purley","Pwllheli","Pyle","Quedgeley","Queenborough","Queensferry","Quinton","Radcliffe","Radcliffe on Trent","Radlett","Radnage","Radstock","Rainford","Rainham","Rainham","Rainhill","Rainworth","Ramsbottom","Ramsbury","Ramsey","Ramsey Saint Marys","Ramsgate","Randalstown","Ratcliffe on Soar","Rathfriland","Ravenstone","Rawmarsh","Rawreth","Rawtenstall","Rayleigh","Rayne","Raynes Park","Reading","Redbourn","Redcar","Reddish","Redditch","Redhill","Redhill","Redland","Redruth","Reed","Reepham","Reigate","Renfrew","Renton","Repton","Reydon","Rhayader","Rhondda","Rhoose","Rhos-on-Sea","Rhyl","Richmond","Richmond","Rickmansworth","Ridingmill","Rimington","Ringmer","Ringwood","Ripe","Ripley","Ripley","Ripon","Ripponden","Risca","Risley","River","Rivington","Roade","Roath","Robertsbridge","Rochdale","Roche","Rochester","Rochford","Rock","Rock Ferry","Roehampton","Roffey","Rogerstone","Rogiet","Romford","Romsey","Ross on Wye","Rosslea","Rosyth","Rothbury","Rotherfield","Rotherham","Rothesay","Rothwell","Rothwell","Rottingdean","Rowde","Rowhedge","Rowlands Castle","Rowlands Gill","Rowley Regis","Roxwell","Royal Leamington Spa","Royal Tunbridge Wells","Royal Wootton Bassett","Roydon","Royston","Royston","Ruabon","Ruddington","Rugby","Rugeley","Ruislip","Runcorn","Rushden","Rushden","Rustington","Rutherglen","Ruthin","Ryde","Rye","Ryton","Sacriston","Saffron Walden","Saint Agnes","Saint Annes on the Sea","Saint Bees","Saint Brides Major","Saint Clears","Saint Columb Major","Saint Erme","Saint Ives","Saint Leonards-on-Sea","Saint Neots","Sale","Salford","Salfords","Salisbury","Saltash","Saltburn-by-the-Sea","Saltcoats","Salthouse","Sandbach","Sanderstead","Sandhurst","Sandiacre","Sandown","Sandwell","Sandwich","Sandy","Sandycroft","Sanquhar","Sarratt","Saundersfoot","Sawbridgeworth","Sawley","Saxmundham","Saxtead","Scalby","Scapa","Scarborough","Scunthorpe","Seacroft","Seaford","Seaham","Seale","Seascale","Seaton","Seaton","Seaview","Sedbergh","Sedgeberrow","Sedgefield","Sedgley","Seend","Seghill","Selborne","Selby","Selkirk","Selsey","Selston","Send","Settle","Seven Kings","Sevenoaks","Shadoxhurst","Shaftesbury","Shalford","Shalford","Shanklin","Shardlow","Shaw","Shawbury","Sheering","Sheerness","Sheffield","Shefford","Sheldon","Shelford","Shenfield","Shepperton","Shepshed","Shepton Mallet","Sherborne","Sherfield upon Loddon","Sheringham","Shifnal","Shildon","Shilton","Shinfield","Shipley","Shipston on Stour","Shirebrook","Shirehampton","Shireoaks","Shoeburyness","Shoreham-by-Sea","Shotley Gate","Shotton","Shotts","Shrewsbury","Shrivenham","Sidcot","Sidcup","Sidlesham","Sidmouth","Sileby","Silloth","Silsden","Silsoe","Silverdale","Silverstone","Sittingbourne","Skegness","Skelmersdale","Skelmorlie","Skelton","Skilgate","Skipton","Slapton","Slawitt","Sleaford","Slinfold","Slough","Smalley","Smarden","Smethwick","Snaresbrook","Snettisham","Snodland","Soham","Solihull","Somerset","Somersham","Somerton","Sompting","Sonning","South Benfleet","South Brent","South Brewham","South Carlton","South Cave","South Cerney","South Elmsall","South Hayling","South Hetton","South Killingholme","South Milford","South Molton","South Normanton","South Ockendon","South Petherton","South Shields","Southall","Southam","Southampton","Southbourne","Southend-on-Sea","Southgate","Southgate","Southminster","Southport","Southsea","Southwark","Southwater","Southwell","Southwick","Southwold","Sowerby Bridge","Spalding","Sparsholt","Speke","Speldhurst","Spennymoor","Spetisbury","Spilsby","Spittal","Spondon","Spratton","Sprowston","Square","St Albans","St Andrews","St Asaph","St Austell","St Helens","St Ives","St. Dogmaels","Stafford","Staindrop","Staines","Stalham","Stallingborough","Stalybridge","Stamford","Stanbridge","Standlake","Stanford","Stanford","Stanford","Stanground","Stanhope","Stanley","Stanmore","Stanstead","Stansted","Stanton","Stanton","Stanton Fitzwarren","Stanwell","Staple","Staplehurst","Star","Staverton","Stawell","Steeple Claydon","Steeton","Stepps","Stevenage","Stevenston","Steventon","Stewarton","Steyning","Stiffkey","Stifford","Stillington","Stirling","Stisted","Stock","Stockbridge","Stockcross","Stockport","Stocksbridge","Stocksfield","Stockton","Stockton-on-Tees","Stoke","Stoke by Nayland","Stoke Climsland","Stoke Newington","Stoke Poges","Stoke Prior","Stoke upon Tern","Stoke-on-Trent","Stokesley","Stone","Stone","Stone Allerton","Stonehaven","Stonehouse","Stoneleigh","Stonesfield","Stony Stratford","Stornoway","Storrington","Stotfold","Stourbridge","Stourport On Severn","Stow","Stow","Stow on the Wold","Stowe","Stowmarket","Strabane","Stranmillis","Stranraer","Stratfield Mortimer","Stratford","Stratford-upon-Avon","Strathaven","Strathmiglo","Strathyre","Streatham","Streatley","Stretford","Stretton on Fosse","Stromness","Strood","Stroud","Stuartfield","Studham","Studley","Studley","Sturmer","Sturminster Newton","Stutton","Sudbury","Sully","Sunbury-on-Thames","Sunderland","Sundon Park","Sunningdale","Sunninghill","Surbiton","Surrey","Sutton","Sutton Bridge","Sutton Coldfield","Sutton Courtenay","Sutton in Ashfield","Sutton on Hull","Sutton on the Hill","Sutton on Trent","Swadlincote","Swaffham","Swalwell","Swanage","Swanland","Swanscombe","Swansea","Swavesey","Swaythling","Swindon","Swindon Village","Swinton","Swynnerton","Symington","Syston","Tackley","Tadcaster","Tadley","Tadmarton","Tadworth","Tain","Takeley","Talgarth","Talsarnau","Talybont","Tamworth","Tandragee","Tansley","Taplow","Tarbert","Tarleton","Tarporley","Tatsfield","Tattershall","Taunton","Tavistock","Taynuilt","Tayport","Teddington","Teddington","Teignmouth","Telford","Temple","Templecombe","Templepatrick","Tempo","Tenbury Wells","Tenby","Tendring","Tenterden","Tetbury","Tetsworth","Tewin","Tewkesbury","Teynham","Thakeham","Thame","Thames Ditton","Thatcham","The Hyde","Theale","Theale","Thetford","Theydon Bois","Thirsk","Thornaby","Thornaby","Thornbury","Thornton","Thornton","Thornton Heath","Thornton-in-Craven","Thorpe St Peter","Thorrington","Thrapston","Three Legged Cross","Threlkeld","Thurleigh","Thurso","Thurston","Ticehurst","Ticknall","Tideswell","Tilbury","Tile Hill","Tilehurst","Tillicoultry","Tillingham","Timperley","Tipton","Tiptree","Tisbury","Tiverton","Toddington","Todmorden","Tollard Royal","Tollerton","Tonbridge","Tongham","Tonypandy","Tonyrefail","Torpoint","Torquay","Totnes","Tottenham","Totteridge","Totternhoe","Totton","Towcester","Tranent","Tredegar","Trefonen","Treforest","Tregarth","Trehafod","Treharris","Treherbert","Trent","Treorchy","Treuddyn","Trimdon","Tring","Troon","Trowbridge","Truro","Trusthorpe","Tunstall","Turnberry","Turriff","Turvey","Tweedmouth","Twickenham","Twyford","Twyford","Tyldesley","Tynemouth","Tywardreath","Uckfield","Uddingston","Ufford","Ulceby","Ulcombe","Ullesthorpe","Ulverston","Unstone","Uphall","Upminster","Upper Beeding","Upper Slaughter","Uppingham","Upton","Upton","Upton","Upton upon Severn","Upwell","Urchfont","Urmston","Ushaw Moor","Usk","Uttoxeter","Uxbridge","Uxbridge","Valley","Ventnor","Verwood","Victoria","Voe","Waddesdon","Wadebridge","Wadhurst","Wakefield","Waldringfield","Wales","Walford","Walgrave","Walkden","Walker","Wallasey","Wallingford","Wallington","Wallsend","Walmer","Walsall","Waltham","Waltham","Waltham Abbey","Waltham Cross","Walthamstow","Walton on Thames","Walton on the Hill","Walton on the Hill","Walton-on-the-Naze","Wanstead","Wantage","Warden","Ware","Wareham","Warfield","Wargrave","Waringstown","Warlingham","Warmington","Warminster","Warrenpoint","Warrington","Warton","Warwick","Washington","Watchet","Watchfield","Water Orton","Waterbeach","Waterlooville","Watford","Wath upon Dearne","Watlington","Wattisfield","Watton","Weald","Wealdstone","Weare","Weaverham","Wedmore","Wednesbury","Wednesfield","Weedon","Weedon Bec","Well","Welling","Wellingborough","Wellington","Wellington","Wells","Welshpool","Welwyn","Welwyn Garden City","Wem","Wembley","Wemyss Bay","Wendover","Wentworth","Weobley","West Ashby","West Bromwich","West Byfleet","West Calder","West Clandon","West Cowes","West Drayton","West Drayton","West Grinstead","West Horsley","West Kilbride","West Kirby","West Langdon","West Linton","West Malling","West Mersea","West Raynham","West Row","West Rudham","West Wickham","West Wickham","West Wittering","Westbury","Westbury-sub-Mendip","Westcott","Westerham","Westfield","Westgate","Westgate on Sea","Westhay","Westhoughton","Westleigh","Westleton","Weston","Weston","Weston in Gordano","Weston under Lizard","Weston-super-Mare","Wetherby","Wethersfield","Weybridge","Weymouth","Whaley Bridge","Whalley","Wheathampstead","Wheatley","Wheaton Aston","Whetstone","Whickham","Whimple","Whisby","Whitbourne","Whitburn","Whitby","Whitchurch","Whitchurch","Whitchurch","Whitchurch","Whitefield","Whitehaven","Whitehouse","Whiteparish","Whitland","Whitley Bay","Whitnash","Whitstable","Whittlebury","Whittlesey","Whittlesford","Whitton","Whitwell","Whitwick","Whyteleafe","Wick","Wick","Wick","Wick","Wicken","Wickersley","Wickford","Wickham","Wickham Bishops","Wickham Market","Widdrington","Widmerpool","Widnes","Wigan","Wigston","Wigton","Wilburton","Wilden","Willaston","Willenhall","Willesden","Willingale Doe","Willingham","Willington","Willington","Willington Quay","Wilmington","Wilmslow","Wilnecote","Wilshamstead","Wimbledon","Wimborne Minster","Wincanton","Winchester","Windermere","Windlesham","Windsor","Windsor","Wing","Wingate","Winkleigh","Winlaton","Winnersh","Winnington","Winsford","Winslow","Winterborne Kingston","Winterbourne Dauntsey","Winton","Wirksworth","Wisbech","Wishaw","Witham","Withernsea","Withernwick","Withington","Witley","Witney","Wix","Woburn Sands","Woking","Wokingham","Wold Newton","Woldingham","Wolstanton","Wolverhampton","Wolverley","Wombourne","Wombwell","Wooburn","Woodbridge","Woodford","Woodford Green","Woodhall Spa","Woodham Ferrers","Woodhouse","Woodhouse","Woodley","Woodmancote","Woodsetts","Woodstock","Woolacombe","Woolwich","Woore","Wootton","Wootton","Wootton","Wootton","Worcester","Worcester Park","Workington","Worksop","Worle","Worminghall","Worsley","Worth","Worthing","Wotton Underwood","Wotton-under-Edge","Wragby","Wrangaton","Wrangle","Wrawby","Wraysbury","Wrea Green","Wrexham","Wrington","Writtle","Wroughton","Wroxall","Wyke","Wymeswold","Wymondham","Wythenshawe","Wyton","Wyverstone","Yarm","Yate","Yatton","Yeadon","Yelverton","Yeovil","York","Yoxford","Ystalyfera","Ystrad Mynach","Ystradgynlais","Zeals"],"United States":["Abbeville","Abbeville","Abbeville","Abbeville","Abbeville","Abbotsford","Abbott","Abbottstown","Abercrombie","Aberdeen","Aberdeen","Aberdeen","Aberdeen","Aberdeen","Aberdeen","Aberdeen","Aberdeen Proving Ground","Abernathy","Abilene","Abilene","Abingdon","Abingdon","Abingdon","Abington","Abington Township","Abiquiu","Abita Springs","Abrams","Absarokee","Absecon","Acampo","Access","Accident","Accokeek","Accomac","Accord","Accoville","Achille","Achilles","Ackerly","Ackerman","Ackley","Acme","Acme","Acton","Acton","Acushnet","Acworth","Acworth","Ada","Ada","Ada","Ada","Adah","Adair","Adair","Adairsville","Adairville","Adak","Adams","Adams","Adams","Adams","Adams","Adams","Adams","Adams","Adams Center","Adams Run","Adamstown","Adamstown","Adamsville","Adamsville","Addieville","Addis","Addison","Addison","Addison","Addison","Addison","Addison","Addison","Addyston","Adel","Adel","Adelanto","Adell","Adena","Adger","Adin","Adkins","Admire","Adolphus","Adona","Adrian","Adrian","Adrian","Adrian","Adrian","Adrian","Advance","Advance","Afton","Afton","Afton","Afton","Afton","Afton","Afton","Agar","Agate","Agawam","Agency","Agoura Hills","Agra","Agra","Aguanga","Aguila","Ahoskie","Ahwahnee","Aiken","Ailey","Ainsworth","Ainsworth","Air Force Academy","Airville","Airway Heights","Aitkin","Ajo","Akaska","Akeley","Akhiok","Akiachak","Akiak","Akron","Akron","Akron","Akron","Akron","Akron","Akron","Akutan","Alabaster","Alachua","Alakanuk","Alamance","Alameda","Alamo","Alamo","Alamo","Alamo","Alamo","Alamo","Alamogordo","Alamosa","Alanson","Alapaha","Alba","Alba","Alba","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albany","Albemarle","Albers","Albert City","Albert Lea","Alberton","Albertson","Albertson","Albertville","Albertville","Albia","Albin","Albion","Albion","Albion","Albion","Albion","Albion","Albion","Albion","Albion","Albion","Albion","Alborn","Albright","Albrightsville","Albuquerque","Alburg","Alburnett","Alburtis","Alcalde","Alcester","Alcoa","Alcolu","Alda","Alden","Alden","Alden","Alden","Alden","Alderpoint","Alderson","Aldie","Aldrich","Aledo","Aledo","Alex","Alexander","Alexander","Alexander","Alexander","Alexander","Alexander City","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria","Alexandria Bay","Alexis","Alexis","Alford","Alfred","Alfred","Alfred","Alfred Station","Alger","Algodones","Algoma","Algona","Algonac","Algonquin","Alhambra","Alhambra","Alice","Aliceville","Aline","Aliquippa","Aliso Viejo","Alkol","Allamuchy","Allardt","Allegan","Allegany","Allen","Allen","Allen","Allen","Allen","Allen Park","Allendale","Allendale","Allendale","Allenhurst","Allenport","Allenspark","Allenton","Allenton","Allenton","Allentown","Allentown","Allenwood","Allenwood","Allerton","Alliance","Alliance","Allison","Allison","Allison Park","Allons","Alloway","Allston","Allyn","Alma","Alma","Alma","Alma","Alma","Alma","Alma","Alma","Alma","Alma Center","Almena","Almena","Almira","Almo","Almond","Almond","Almont","Alna","Alpaugh","Alpena","Alpena","Alpha","Alpha","Alpha","Alpha","Alpha","Alpharetta","Alpine","Alpine","Alpine","Alpine","Alpine","Alpine","Alpine","Alplaus","Alsea","Alsey","Alsip","Alstead","Alta","Alta Vista","Altadena","Altamont","Altamont","Altamont","Altamont","Altamont","Altamonte Springs","Altaville","Altavista","Altenburg","Altha","Altmar","Alto","Alto","Alto","Alto","Alton","Alton","Alton","Alton","Alton","Alton","Alton Bay","Altona","Altoona","Altoona","Altoona","Altoona","Altoona","Altoona","Altura","Alturas","Alturas","Altus","Alum Bank","Alum Creek","Alva","Alva","Alvada","Alvarado","Alvaton","Alverda","Alverton","Alvin","Alvin","Alviso","Alvo","Alvord","Alvord","Alvordton","Ama","Amagansett","Amana","Amanda","Amargosa Valley","Amarillo","Amawalk","Amazonia","Amberg","Ambler","Ambler","Amboy","Amboy","Amboy","Ambridge","Ambrose","Amelia","Amelia","Amelia Court House","Amenia","Amenia","America","American Canyon","American Falls","American Fork","Americus","Americus","Amery","Ames","Ames","Amesbury","Amesville","Amherst","Amherst","Amherst","Amherst","Amherst","Amherst","Amherst","Amherst","Amherst Junction","Amherstdale","Amidon","Amissville","Amite","Amity","Amity","Amity","Amity","Amityville","Ammon","Amo","Amoret","Amory","Amsterdam","Amsterdam","Amsterdam","Amston","Anacoco","Anaconda","Anacortes","Anadarko","Anaheim","Anahola","Anahuac","Anamosa","Anchor Point","Anchorage","Ancona","Andale","Andalusia","Andalusia","Anderson","Anderson","Anderson","Anderson","Anderson","Andersonville","Andersonville","Andes","Andover","Andover","Andover","Andover","Andover","Andover","Andover","Andover","Andover","Andover","Andreas","Andrew","Andrews","Andrews","Andrews","Andrews","Andrews Air Force Base","Angel Fire","Angelica","Angie","Angier","Angle Inlet","Angleton","Angola","Angola","Angoon","Angora","Anguilla","Angwin","Animas","Anita","Aniwa","Ankeny","Anmoore","Ann Arbor","Anna","Anna","Anna","Annabella","Annandale","Annandale","Annandale","Annandale-on-Hudson","Annapolis","Annawan","Anniston","Annona","Annville","Annville","Anoka","Anselmo","Ansley","Anson","Anson","Ansonia","Ansted","Antelope","Antelope","Anthem","Anthon","Anthony","Anthony","Anthony","Anthony","Antigo","Antioch","Antioch","Antioch","Antioch","Antlers","Antrim","Antwerp","Anza","Apache","Apache Junction","Apalachicola","Apalachin","Apex","Apison","Aplington","Apollo","Apollo Beach","Apopka","Appalachia","Apple Creek","Apple River","Apple Valley","Applegate","Applegate","Appleton","Appleton","Appleton","Appleton City","Appling","Appomattox","Aptos","Aquasco","Aquashicola","Aquebogue","Aquilla","Arab","Arabi","Arabi","Aragon","Aransas Pass","Arapaho","Arapahoe","Arapahoe","Arapahoe","Ararat","Ararat","Arbela","Arbon","Arbovale","Arbuckle","Arbyrd","Arcade","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcadia","Arcanum","Arcata","Archbald","Archbold","Archer","Archer City","Archie","Arco","Arco","Arcola","Arcola","Arden","Ardmore","Ardmore","Ardmore","Ardmore","Ardsley","Aredale","Arena","Arenas Valley","Arendtsville","Arenzville","Argenta","Argillite","Argonia","Argonne","Argos","Argusville","Argyle","Argyle","Argyle","Argyle","Argyle","Ariel","Arimo","Arispe","Ariton","Arivaca","Arizona City","Arkadelphia","Arkansas City","Arkansas City","Arkdale","Arkoma","Arkville","Arlee","Arley","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington","Arlington Heights","Arma","Armada","Armagh","Armington","Armona","Armonk","Armour","Armstrong","Armstrong","Armuchee","Arnaudville","Arnegard","Arnett","Arnett","Arnold","Arnold","Arnold","Arnold","Arnoldsburg","Arnoldsville","Aroma Park","Aromas","Aroostook Band of Micmac Trust Land","Arp","Arpin","Arriba","Arrington","Arrington","Arrowsmith","Arroyo Grande","Arroyo Hondo","Arroyo Seco","Artesia","Artesia","Artesian","Arthur","Arthur","Arthur City","Arvada","Arvada","Arverne","Arvin","Arvonia","Ary","Asbury","Asbury","Asbury Park","Ascutney","Ash","Ash Flat","Ash Fork","Ash Grove","Ash Hill","Ashaway","Ashburn","Ashburn","Ashburnham","Ashby","Ashby","Ashcamp","Ashdown","Asheboro","Asherton","Asheville","Ashfield","Ashford","Ashford","Ashkum","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland","Ashland City","Ashley","Ashley","Ashley","Ashley","Ashley","Ashmore","Ashtabula","Ashton","Ashton","Ashton","Ashton","Ashville","Ashville","Ashville","Askov","Asotin","Aspen","Aspermont","Aspers","Assaria","Assonet","Assumption","Astatula","Aston Arms","Astor","Astoria","Astoria","Astoria","Atalissa","Atascadero","Atascosa","Atchison","Atco","Atglen","Athelstane","Athena","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Athens","Atherton","Athol","Athol","Athol","Atkins","Atkins","Atkins","Atkinson","Atkinson","Atkinson","Atlanta","Atlanta","Atlanta","Atlanta","Atlanta","Atlanta","Atlanta","Atlantic","Atlantic","Atlantic","Atlantic Beach","Atlantic Beach","Atlantic Beach","Atlantic City","Atlantic Highlands","Atlantic Mine","Atlasburg","Atmore","Atoka","Atoka","Atqasuk","Attalla","Attapulgus","Attica","Attica","Attica","Attica","Attica","Attleboro","Attleboro Falls","Atwater","Atwater","Atwater","Atwood","Atwood","Atwood","Au Gres","Au Sable Forks","Au Train","Auberry","Aubrey","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn","Auburn Hills","Auburndale","Auburndale","Auburndale","Audubon","Audubon","Audubon","Augusta","Augusta","Augusta","Augusta","Augusta","Augusta","Augusta","Augusta","Augusta","Augusta","Aulander","Ault","Aumsville","Aurelia","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Aurora","Austell","Austerlitz","Austin","Austin","Austin","Austin","Austin","Austin","Austinburg","Austinville","Autaugaville","Autryville","Auxier","Auxvasse","Ava","Ava","Ava","Ava","Avalon","Avalon","Avalon","Avalon","Avella","Avenal","Avenel","Aventura","Averill Park","Avery","Avery","Avila Beach","Avilla","Avinger","Aviston","Avoca","Avoca","Avoca","Avoca","Avon","Avon","Avon","Avon","Avon","Avon","Avon","Avon","Avon","Avon Lake","Avon Park","Avon-by-the-Sea","Avondale","Avondale","Avondale","Avondale Estates","Avonmore","Awendaw","Axis","Axtell","Axtell","Axtell","Axtell","Axton","Ayden","Ayer","Aylett","Aynor","Azalea","Azle","Aztec","Azusa","Babb","Babbitt","Babcock","Babson Park","Babson Park","Babylon","Backus","Bacliff","Bad Axe","Baden","Badger","Badger","Badin","Bagdad","Bagdad","Bagdad","Baggs","Bagley","Bagley","Bagwell","Bahama","Bailey","Bailey","Bailey","Bailey Island","Baileys Harbor","Baileyton","Baileyville","Bainbridge","Bainbridge","Bainbridge","Bainbridge","Bainbridge","Bainbridge Island","Bainville","Baird","Bairdford","Baisden","Baker","Baker","Baker","Baker","Baker","Baker City","Bakersfield","Bakersfield","Bakersfield","Bakersville","Bakewell","Bala-Cynwyd","Balaton","Bald Knob","Baldwin","Baldwin","Baldwin","Baldwin","Baldwin","Baldwin","Baldwin","Baldwin","Baldwin City","Baldwin Park","Baldwin Place","Baldwinsville","Baldwinville","Baldwyn","Ball","Ball Ground","Ballantine","Ballico","Ballinger","Ballston Lake","Ballston Spa","Ballwin","Bally","Balsam Lake","Baltic","Baltic","Baltic","Baltimore","Baltimore","Bamberg","Bancroft","Bancroft","Bancroft","Bancroft","Bandera","Bandon","Bangor","Bangor","Bangor","Bangor","Bangs","Banks","Banks","Banks","Bankston","Banner","Banner Elk","Banning","Bannister","Banquete","Bantam","Bapchule","Baptistown","Bar Harbor","Baraboo","Baraga","Barbeau","Barberton","Barboursville","Barboursville","Barbourville","Barclay","Bardstown","Bardwell","Bardwell","Bargersville","Baring","Baring","Bark River","Barkhamsted","Barling","Barlow","Barnard","Barnard","Barnardsville","Barnegat","Barnes","Barnes City","Barnesville","Barnesville","Barnesville","Barnesville","Barnet","Barneveld","Barney","Barnhart","Barnsdall","Barnstable","Barnstead","Barnum","Barnwell","Baroda","Barre","Barre","Barren Springs","Barrett","Barrington","Barrington","Barrington","Barrington","Barron","Barronett","Barrow","Barry","Barry","Barryton","Barryville","Barstow","Bart Township","Bartelso","Bartlesville","Bartlett","Bartlett","Bartlett","Bartley","Barto","Barton","Barton","Barton","Bartonsville","Bartow","Bartow","Bartow","Basalt","Basalt","Bascom","Basehor","Basile","Basin","Basin","Basking Ridge","Bassett","Bassett","Bassfield","Bastrop","Bastrop","Basye","Batavia","Batavia","Batavia","Batavia","Batchelor","Batchtown","Bates City","Batesburg","Batesville","Batesville","Batesville","Bath","Bath","Bath","Bath","Bath","Bath","Bath","Bath","Bath","Bathgate","Baton Rouge","Batson","Battle Creek","Battle Creek","Battle Creek","Battle Ground","Battle Ground","Battle Lake","Battle Mountain","Battleboro","Baudette","Bausman","Bauxite","Baxley","Baxter","Baxter","Baxter","Baxter","Baxter Springs","Bay City","Bay City","Bay City","Bay City","Bay Minette","Bay Port","Bay Saint Louis","Bay Shore","Bay Springs","Bay Village","Bayard","Bayard","Bayboro","Bayfield","Bayfield","Bayonne","Bayport","Bayport","Bayside","Bayside","Baytown","Bayview","Bayville","Bayville","Bazine","Beach","Beach City","Beach Haven","Beach Lake","Beachwood","Beachwood","Beacon","Beacon","Beacon Falls","Bealeton","Beaman","Bean Station","Beans Purchase","Bear","Bear Creek","Bear Creek","Bear Creek","Bear Lake","Bear Lake","Bear River City","Bearden","Beardstown","Bearsville","Beasley","Beatrice","Beattie","Beatty","Beattyville","Beaufort","Beaufort","Beaufort","Beaumont","Beaumont","Beaumont","Beaumont","Beauty","Beaver","Beaver","Beaver","Beaver","Beaver","Beaver","Beaver Bay","Beaver Creek","Beaver Creek","Beaver Crossing","Beaver Dam","Beaver Dam","Beaver Falls","Beaver Meadows","Beaver Springs","Beaverdam","Beaverton","Beaverton","Beavertown","Bechtelsville","Beckemeyer","Becker","Becket","Beckley","Beckville","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford","Bedford Hills","Bedford Park","Bedias","Bedminster","Bee Branch","Bee Spring","Beebe","Beech Bluff","Beech Bottom","Beech Creek","Beech Grove","Beech Island","Beecher","Beecher City","Beechgrove","Beechmont","Beeville","Beggs","Bel Air","Bel Alton","Belcamp","Belchertown","Belcourt","Belden","Beldenville","Belding","Belen","Belfair","Belfast","Belfast","Belfield","Belford","Belfry","Belfry","Belgium","Belgrade","Belgrade","Belgrade","Belgrade","Belhaven","Belington","Belknap","Bell","Bell","Bell Buckle","Bell City","Bell Island Hot Springs","Bella Vista","Bella Vista","Bellaire","Bellaire","Bellaire","Bellbrook","Belle","Belle","Belle Center","Belle Chasse","Belle Fourche","Belle Glade","Belle Haven","Belle Mead","Belle Plaine","Belle Plaine","Belle Plaine","Belle Rose","Belle Valley","Belle Vernon","Belleair Beach","Bellefontaine","Bellefontaine","Bellefonte","Bellemont","Bellerose","Belleview","Belleville","Belleville","Belleville","Belleville","Belleville","Belleville","Belleville","Belleville","Bellevue","Bellevue","Bellevue","Bellevue","Bellevue","Bellevue","Bellevue","Bellevue","Bellflower","Bellflower","Bellflower","Bellingham","Bellingham","Bellingham","Bellmawr","Bellmore","Bellows Falls","Bellport","Bells","Bells","Bellville","Bellville","Bellvue","Bellwood","Bellwood","Bellwood","Belmar","Belmond","Belmont","Belmont","Belmont","Belmont","Belmont","Belmont","Belmont","Belmont","Belmont","Belmont","Beloit","Beloit","Beloit","Belpre","Belt","Belton","Belton","Belton","Beltrami","Beltsville","Belvidere","Belvidere","Belvidere","Belvidere Center","Belview","Belvue","Belzoni","Bement","Bemidji","Bemus Point","Ben Lomond","Ben Wheeler","Bena","Benavides","Bend","Bendersville","Benedict","Benedict","Benham","Benicia","Benkelman","Benld","Bennet","Bennett","Bennett","Bennettsville","Bennington","Bennington","Bennington","Bennington","Bennington","Benoit","Bensalem","Bensenville","Benson","Benson","Benson","Benson","Bent","Bent Mountain","Bentleyville","Benton","Benton","Benton","Benton","Benton","Benton","Benton","Benton","Benton City","Benton Harbor","Benton Ridge","Bentonia","Bentonville","Bentonville","Benwood","Benzonia","Berea","Berea","Berea","Beresford","Bergen","Bergenfield","Berger","Bergheim","Berkeley","Berkeley","Berkeley Heights","Berkeley Springs","Berkley","Berkley","Berkshire","Berkshire","Berlin","Berlin","Berlin","Berlin","Berlin","Berlin","Berlin","Berlin","Berlin","Berlin Center","Berlin Heights","Bern","Bernalillo","Bernard","Bernard","Bernardston","Bernardsville","Berne","Berne","Bernice","Bernie","Bernville","Berrien Center","Berrien Springs","Berry","Berry","Berry Creek","Berrysburg","Berryton","Berryville","Berryville","Bertha","Berthoud","Bertram","Bertrand","Berwick","Berwick","Berwick","Berwind","Berwyn","Berwyn","Beryl","Bessemer","Bessemer","Bessemer","Bessemer City","Bethalto","Bethania","Bethany","Bethany","Bethany","Bethany","Bethany","Bethany Beach","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel","Bethel Island","Bethel Park","Bethel Springs","Bethesda","Bethesda","Bethlehem","Bethlehem","Bethlehem","Bethlehem","Bethlehem","Bethpage","Bethpage","Bethune","Betsy Layne","Bettendorf","Beulah","Beulah","Beulah","Beulah","Beulaville","Beverly","Beverly","Beverly","Beverly","Beverly Hills","Beverly Hills","Bevington","Bickmore","Bicknell","Bicknell","Biddeford","Bidwell","Bieber","Big Bay","Big Bear","Big Bear Lake","Big Bend","Big Cabin","Big Cove Tannery","Big Creek","Big Creek","Big Creek","Big Falls","Big Flats","Big Horn","Big Lake","Big Lake","Big Lake","Big Pine","Big Pine Key","Big Piney","Big Pool","Big Rapids","Big Rock","Big Rock","Big Sandy","Big Sandy","Big Sandy","Big Sky","Big Spring","Big Springs","Big Stone City","Big Stone Gap","Big Sur","Big Timber","Big Wells","Bigbend","Bigelow","Bigelow","Bigfoot","Bigfork","Bigfork","Biggs","Biggsville","Biglerville","Bill","Billerica","Billings","Billings","Biloxi","Bim","Binford","Bingen","Binger","Bingham Lake","Binghamton","Biola","Bippus","Birch River","Birch Run","Birch Tree","Birchleaf","Birchwood","Birchwood","Bird City","Bird in Hand","Bird Island","Birdsboro","Birdseye","Birdsnest","Birmingham","Birmingham","Birmingham","Birmingham","Birnamwood","Bisbee","Biscoe","Bishop","Bishop","Bishop","Bishopville","Bishopville","Bismarck","Bismarck","Bismarck","Bismarck","Bison","Bitely","Bivalve","Bivins","Biwabik","Bixby","Bixby","Blachly","Black Canyon City","Black Creek","Black Creek","Black Diamond","Black Eagle","Black Earth","Black Hawk","Black Mountain","Black River","Black River","Black River Falls","Black Rock","Blackduck","Blackfoot","Blackhawk","Blacklick","Blacksburg","Blacksburg","Blackshear","Blackstock","Blackstone","Blackstone","Blackstone","Blacksville","Blackville","Blackwater","Blackwell","Blackwell","Blackwood","Bladenboro","Bladensburg","Blain","Blaine","Blaine","Blair","Blair","Blair","Blairs","Blairs Mills","Blairsburg","Blairstown","Blairstown","Blairsville","Blairsville","Blakely","Blakesburg","Blakeslee","Blanch","Blanchard","Blanchard","Blanchard","Blanchard","Blanchardville","Blanchester","Blanco","Bland","Bland","Blandburg","Blandford","Blanding","Blandinsville","Blandon","Blauvelt","Bledsoe","Blencoe","Blenheim","Blenker","Blessing","Bliss","Bliss","Blissfield","Block Island","Blockton","Blodgett","Blodgett Mills","Bloomburg","Bloomdale","Bloomer","Bloomery","Bloomfield","Bloomfield","Bloomfield","Bloomfield","Bloomfield","Bloomfield","Bloomfield","Bloomfield","Bloomfield","Bloomfield Hills","Blooming Glen","Blooming Grove","Blooming Prairie","Bloomingburg","Bloomingburg","Bloomingdale","Bloomingdale","Bloomingdale","Bloomingdale","Bloomingdale","Bloomingdale","Bloomingdale","Bloomington","Bloomington","Bloomington","Bloomington","Bloomington","Bloomington Springs","Bloomsburg","Bloomsbury","Bloomsdale","Bloomville","Blossburg","Blossom","Blossvale","Blountstown","Blountsville","Blountville","Blowing Rock","Blue","Blue Ball","Blue Bell","Blue Creek","Blue Earth","Blue Eye","Blue Grass","Blue Hill","Blue Hill","Blue Island","Blue Jay","Blue Lake","Blue Mound","Blue Mounds","Blue Mountain","Blue Mountain Lake","Blue Point","Blue Rapids","Blue Ridge","Blue Ridge","Blue Ridge","Blue Ridge Summit","Blue River","Blue River","Blue Springs","Blue Springs","Blue Springs","Bluebell","Bluefield","Bluefield","Bluejacket","Bluemont","Bluewater","Bluff","Bluff City","Bluff City","Bluff Dale","Bluffs","Bluffton","Bluffton","Bluffton","Bluford","Blum","Bly","Blythe","Blythe","Blytheville","Blythewood","Boalsburg","Boardman","Boardman","Boaz","Boaz","Bob White","Bobtown","Boca Grande","Boca Raton","Bode","Bodega Bay","Bodfish","Boelus","Boerne","Bogalusa","Bogard","Bogart","Bogata","Boggstown","Bogota","Bogue Chitto","Bohannon","Bohemia","Boiceville","Boiling Springs","Boiling Springs","Boiling Springs","Boise","Boise City","Boissevain","Bokchito","Bokeelia","Bolckow","Boligee","Bolinas","Boling","Bolingbroke","Bolingbrook","Bolivar","Bolivar","Bolivar","Bolivar","Bolivar","Bolivia","Bolt","Bolton","Bolton","Bolton","Bolton Landing","Bomont","Bon Aqua","Bonaire","Bonaparte","Bondsville","Bonduel","Bondurant","Bondville","Bone Gap","Bonfield","Bonham","Bonifay","Bonita","Bonita","Bonita Springs","Bonlee","Bonne Terre","Bonneau","Bonner Springs","Bonnerdale","Bonners Ferry","Bonney Lake","Bonnie","Bonnieville","Bonnots Mill","Bonnyman","Bono","Bonsall","Boody","Booker","Boomer","Boomer","Boone","Boone","Boones Mill","Booneville","Booneville","Booneville","Boonsboro","Boonton","Boonville","Boonville","Boonville","Boonville","Boothbay","Boothbay Harbor","Borden","Bordentown","Borger","Boring","Boron","Borrego Springs","Boscobel","Bosque Farms","Bossier City","Bostic","Boston","Boston","Boston","Boston","Bostwick","Boswell","Boswell","Bosworth","Bothell","Botkins","Bottineau","Boulder","Boulder","Boulder City","Boulder Creek","Boulder Town","Boulevard","Bound Brook","Bountiful","Bourbon","Bourbon","Bourbonnais","Bourg","Boutte","Bovard","Bovey","Bovina","Bovina Center","Bow","Bow Center","Bowdoin Center","Bowdoinham","Bowdon","Bowerston","Bowersville","Bowie","Bowie","Bowie","Bowler","Bowling Green","Bowling Green","Bowling Green","Bowling Green","Bowling Green","Bowling Green","Bowlus","Bowman","Bowman","Bowman","Bowmanstown","Bowmansville","Box Elder","Box Elder","Box Springs","Boxford","Boxholm","Boyce","Boyce","Boyceville","Boyd","Boyd","Boyd","Boyd","Boyden","Boyds","Boydton","Boyers","Boyertown","Boyle","Boylston","Boyne City","Boyne Falls","Boynton","Boynton Beach","Bozeman","Braceville","Bracey","Brackenridge","Brackettville","Brackney","Braddock","Bradenton","Bradenton Beach","Bradenville","Bradford","Bradford","Bradford","Bradford","Bradford","Bradford","Bradford","Bradford","Bradford","Bradley","Bradley","Bradley","Bradley","Bradley","Bradley Beach","Bradley Junction","Bradner","Bradshaw","Brady","Brady","Brady","Bradyville","Bragg City","Braham","Braidwood","Brainerd","Braintree","Braithwaite","Braman","Bramwell","Branch","Branch Township","Branchland","Branchville","Brandamore","Brandenburg","Brandon","Brandon","Brandon","Brandon","Brandon","Brandon","Brandt","Brandy Station","Brandywine","Brandywine","Branford","Branford","Branson","Branson","Brant","Brant Lake","Brantingham","Braselton","Brashear","Brashear","Brasher Falls","Brasstown","Brattleboro","Brave","Brawley","Braxton","Brayton","Brazil","Brazoria","Brea","Breaux Bridge","Breckenridge","Breckenridge","Breckenridge","Breckenridge","Breckenridge","Brecksville","Breda","Breese","Breezewood","Breezy Point","Breinigsville","Bremen","Bremen","Bremen","Bremen","Bremen","Bremen","Bremerton","Bremo Bluff","Brenham","Brent","Brentwood","Brentwood","Brentwood","Brentwood","Bretton Woods","Brevard","Brewer","Brewerton","Brewster","Brewster","Brewster","Brewster","Brewster","Brewster","Brewton","Brian Head","Briarcliff Manor","Bricelyn","Briceville","Brick Township","Bridge City","Bridgehampton","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridgeport","Bridger","Bridgeton","Bridgeton","Bridgeview","Bridgeville","Bridgeville","Bridgewater","Bridgewater","Bridgewater","Bridgewater","Bridgewater","Bridgewater","Bridgewater","Bridgewater","Bridgewater Corners","Bridgman","Bridgton","Brielle","Brier Hill","Brierfield","Brigantine","Briggs","Briggsdale","Brigham City","Brighton","Brighton","Brighton","Brighton","Brighton","Brighton","Brighton","Brightwaters","Brightwood","Brightwood","Brilliant","Brilliant","Brillion","Brimfield","Brimfield","Brimley","Bringhurst","Brinkley","Brisbane","Briscoe","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristol","Bristolville","Bristow","Bristow","Bristow","Britt","Brittany","Britton","Britton","Broad Brook","Broad Run","Broadalbin","Broaddus","Broadlands","Broadus","Broadview","Broadview Heights","Broadway","Broadway","Broadway","Brockport","Brockport","Brockton","Brockway","Brocton","Brodhead","Brodhead","Brodheadsville","Brodnax","Brogue","Brohard","Broken Arrow","Broken Bow","Broken Bow","Bronaugh","Bronson","Bronson","Bronson","Bronson","Bronston","Bronte","Bronwood","Bronxville","Brook","Brook Park","Brook Park","Brookdale","Brookeland","Brooker","Brookeville","Brookfield","Brookfield","Brookfield","Brookfield","Brookfield","Brookfield","Brookfield","Brookfield","Brookhaven","Brookhaven","Brookhaven","Brookings","Brookings","Brookland","Brooklandville","Brooklet","Brooklin","Brookline","Brookline","Brookline","Brooklyn","Brooklyn","Brooklyn","Brooklyn","Brooklyn","Brooklyn","Brooklyn","Brooklyn","Brookport","Brooks","Brooks","Brooks","Brooks","Brooks","Brookshire","Brookston","Brookston","Brookston","Brooksville","Brooksville","Brooksville","Brooksville","Brookton","Brooktondale","Brookville","Brookville","Brookville","Brookville","Brookwood","Broomall","Broomfield","Brooten","Broseley","Broughton","Broussard","Browder","Brown City","Brownell","Brownfield","Brownfield","Browning","Browning","Browns Mills","Browns Summit","Browns Valley","Browns Valley","Brownsboro","Brownsboro","Brownsburg","Brownsdale","Brownstown","Brownstown","Brownstown","Brownsville","Brownsville","Brownsville","Brownsville","Brownsville","Brownsville","Brownsville","Brownsville","Brownsville","Brownsville","Browntown","Brownville","Brownville","Brownwood","Broxton","Bruce","Bruce","Bruceton","Bruceton Mills","Bruceville","Bruin","Brule","Brule","Brundidge","Bruner","Bruni","Bruning","Bruno","Brunsville","Brunswick","Brunswick","Brunswick","Brunswick","Brunswick","Brunswick","Brunswick","Brush","Brush Prairie","Brushton","Brusly","Brussels","Bryan","Bryan","Bryans Road","Bryant","Bryant","Bryant","Bryant","Bryant","Bryant Pond","Bryantville","Bryce Canyon","Bryce Canyon City","Bryceville","Bryn Athyn","Bryn Mawr","Bryson","Bryson City","Buchanan","Buchanan","Buchanan","Buchanan","Buchanan","Buchanan Dam","Buckatunna","Buckeye","Buckeystown","Buckfield","Buckhannon","Buckhead","Buckholts","Buckingham","Buckingham","Buckingham Township","Buckland","Buckland","Buckley","Buckley","Bucklin","Bucklin","Buckner","Buckner","Buckner","Bucksport","Bucyrus","Bucyrus","Bud","Buda","Buda","Budd Lake","Bude","Buellton","Buena","Buena Park","Buena Vista","Buena Vista","Buena Vista","Buena Vista","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo","Buffalo Center","Buffalo Gap","Buffalo Grove","Buffalo Lake","Buffalo Valley","Buford","Buhl","Buhler","Buies Creek","Bulan","Bulger","Bull Shoals","Bullard","Bullhead","Bullhead City","Bullock","Bulls Gap","Bullville","Bulpitt","Bulverde","Bumpass","Bumpus Mills","Buna","Bunceton","Bunch","Buncombe","Bunker Hill","Bunker Hill","Bunker Hill","Bunkie","Bunn","Bunnell","Bunnlevel","Bunola","Buras","Burbank","Burbank","Burbank","Burbank","Burbank","Burden","Burdett","Burdett","Burdick","Bureau","Burgaw","Burgess","Burgettstown","Burgin","Burkburnett","Burke","Burke","Burkesville","Burket","Burkeville","Burkeville","Burleson","Burley","Burley","Burlingame","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington","Burlington Flats","Burlington Junction","Burlison","Burnet","Burnettsville","Burney","Burneyville","Burnham","Burnham","Burns","Burns","Burns","Burns","Burns Flat","Burnside","Burnside","Burnsville","Burnsville","Burnsville","Burnsville","Burnt Hills","Burr","Burr Hill","Burrton","Burt","Burt","Burt","Burton","Burton","Burton","Burton","Burton","Burtonsville","Burtrum","Burwell","Busby","Bush","Bushkill","Bushland","Bushnell","Bushnell","Bushton","Buskirk","Busy","Butler","Butler","Butler","Butler","Butler","Butler","Butler","Butler","Butler","Butler","Butler","Butlerville","Butner","Butte","Butte","Butte","Butte des Morts","Butterfield","Butternut","Buttonwillow","Buxton","Buxton","Buxton","Buzzards Bay","Byers","Byers","Byesville","Byfield","Byhalia","Bylas","Bynum","Byram","Byrdstown","Byron","Byron","Byron","Byron","Byron","Byron","Byron","Byron","Byron Center","Cabazon","Cabery","Cabin Creek","Cabin John","Cable","Cable","Cabool","Cabot","Cabot","Cabot","Cache","Cactus","Caddo","Caddo Gap","Caddo Mills","Cade","Cades","Cadet","Cadillac","Cadiz","Cadiz","Cadott","Cadyville","Cainsville","Cairnbrook","Cairo","Cairo","Cairo","Cairo","Cairo","Cairo","Calabasas","Calabash","Calais","Calamus","Calder","Caldwell","Caldwell","Caldwell","Caldwell","Caldwell","Caledonia","Caledonia","Caledonia","Caledonia","Caledonia","Caledonia","Caledonia","Calera","Calera","Calexico","Calhan","Calhoun","Calhoun","Calhoun","Calhoun","Calhoun","Calhoun City","Calhoun Falls","Calico Rock","Caliente","Caliente","Califon","California","California","California","California","California City","Calimesa","Calipatria","Calistoga","Callahan","Callao","Callao","Callaway","Callaway","Callicoon","Calmar","Calpella","Calpine","Calumet","Calumet","Calumet","Calumet City","Calvert","Calvert","Calvert City","Calverton","Calypso","Camanche","Camano","Camarillo","Camas","Cambria","Cambria","Cambria Heights","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge","Cambridge City","Cambridge Springs","Cambridgeport","Camby","Camden","Camden","Camden","Camden","Camden","Camden","Camden","Camden","Camden","Camden","Camden","Camden","Camden Point","Camdenton","Cameron","Cameron","Cameron","Cameron","Cameron","Cameron","Cameron","Cameron","Cameron","Cameron","Cameron Mills","Camilla","Camillus","Camino","Camp Creek","Camp Dennison","Camp Douglas","Camp H M Smith","Camp Hill","Camp Meeker","Camp Point","Camp Verde","Camp Wood","Campbell","Campbell","Campbell","Campbell","Campbell","Campbell","Campbell","Campbell Hall","Campbell Hill","Campbellsburg","Campbellsburg","Campbellsport","Campbellsville","Campbelltown","Campo","Campobello","Campti","Campton","Campton Upper Village","Campus","Cana","Canaan","Canaan","Canaan","Canaan","Canaan","Canada","Canadensis","Canadian","Canadian","Canajoharie","Canal Fulton","Canal Point","Canal Winchester","Canalou","Canandaigua","Canastota","Canby","Canby","Candia","Candler","Cando","Candor","Candor","Canehill","Caney","Caney","Caneyville","Canfield","Canisteo","Canmer","Cannel City","Cannelton","Cannon","Cannon Falls","Cannonville","Canoga Park","Canon","Canon City","Canonsburg","Canterbury","Canterbury","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Canton","Cantonment","Cantrall","Canute","Canutillo","Canvas","Canyon","Canyon","Canyon","Canyon City","Canyon Country","Canyon Lake","Canyonville","Capac","Cape Canaveral","Cape Charles","Cape Coral","Cape Elizabeth","Cape Fair","Cape Girardeau","Cape May","Cape May Court House","Cape May Point","Cape Neddick","Cape Porpoise","Cape Vincent","Capeville","Capistrano Beach","Capitan","Capitola","Capon Bridge","Capron","Capron","Captain Cook","Captiva","Caputa","Caraway","Carbon","Carbon Hill","Carbon Hill","Carbonado","Carbondale","Carbondale","Carbondale","Carbondale","Cardale","Cardington","Carefree","Carencro","Carey","Careywood","Caribou","Carl Junction","Carle Place","Carleton","Carlin","Carlinville","Carlisle","Carlisle","Carlisle","Carlisle","Carlisle","Carlisle","Carlisle","Carlock","Carlos","Carlotta","Carlsbad","Carlsbad","Carlsborg","Carlstadt","Carlton","Carlton","Carlton","Carlton","Carlyle","Carman","Carmel","Carmel","Carmel","Carmel","Carmel Valley","Carmen","Carmi","Carmichael","Carmichaels","Carmine","Carnation","Carnegie","Carnegie","Carnesville","Carney","Carney","Caro","Caroga Lake","Carol Stream","Carolina","Carolina","Carolina Beach","Carp Lake","Carpentersville","Carpinteria","Carr","Carrabelle","Carrboro","Carrie","Carrier","Carrier Mills","Carriere","Carrington","Carrizo Springs","Carrizozo","Carroll","Carroll","Carroll","Carrollton","Carrollton","Carrollton","Carrollton","Carrollton","Carrollton","Carrollton","Carrollton","Carrollton","Carrollton","Carrolltown","Carrsville","Carson","Carson","Carson","Carson","Carson","Carson City","Carson City","Carsonville","Carter Lake","Carteret","Cartersville","Carterville","Carterville","Carthage","Carthage","Carthage","Carthage","Carthage","Carthage","Carthage","Carthage","Cartwright","Caruthers","Caruthersville","Carver","Carver","Cary","Cary","Caryville","Caryville","Casa Grande","Casanova","Casar","Cascade","Cascade","Cascade","Cascade","Cascade","Cascade Locks","Cascilla","Casco","Casco","Casco","Caseville","Casey","Casey","Caseyville","Cashiers","Cashion","Cashion","Cashmere","Cashton","Cashtown","Casnovia","Casper","Caspian","Cass City","Cass Lake","Cassadaga","Cassatt","Cassel","Casselberry","Casselton","Cassoday","Cassopolis","Casstown","Cassville","Cassville","Castaic","Castalia","Castalian Springs","Castile","Castine","Castle Dale","Castle Hayne","Castle Point","Castle Rock","Castle Rock","Castleberry","Castleton","Castleton-on-Hudson","Castlewood","Castlewood","Castor","Castorland","Castro Valley","Castroville","Castroville","Cat Spring","Cataldo","Catasauqua","Cataula","Cataumet","Catawba","Catawba","Catawissa","Catawissa","Catharpin","Cathedral City","Catherine","Catheys Valley","Cathlamet","Catlett","Catlettsburg","Catlin","Cato","Catonsville","Catoosa","Catron","Catskill","Cattaraugus","Caulfield","Cavalier","Cave City","Cave City","Cave Creek","Cave Creek","Cave Junction","Cave Spring","Cave Springs","Cave-in-Rock","Cavendish","Cavour","Cawood","Cayce","Cayucos","Cayuga","Cayuta","Cazadero","Cazenovia","Cazenovia","Cecil","Cecil","Cecil","Cecil","Cecilia","Cecilia","Cecilton","Cedar","Cedar","Cedar Bluff","Cedar Bluff","Cedar Bluffs","Cedar Brook","Cedar City","Cedar Creek","Cedar Crest","Cedar Falls","Cedar Glen","Cedar Grove","Cedar Grove","Cedar Grove","Cedar Grove","Cedar Hill","Cedar Hill","Cedar Hill","Cedar Key","Cedar Knolls","Cedar Lake","Cedar Lake","Cedar Park","Cedar Point","Cedar Point","Cedar Rapids","Cedar Ridge","Cedar Springs","Cedar Vale","Cedar Valley","Cedarburg","Cedaredge","Cedarhurst","Cedartown","Cedarville","Cedarville","Cedarville","Celeste","Celina","Celina","Celina","Celoron","Cement","Cement City","Centenary","Center","Center","Center","Center","Center Barnstead","Center City","Center Conway","Center Cross","Center Harbor","Center Hill","Center Junction","Center Line","Center Moriches","Center Ossipee","Center Point","Center Point","Center Point","Center Point","Center Point","Center Ridge","Center Rutland","Center Sandwich","Center Tuftonboro","Center Valley","Centerbrook","Centerburg","Centereach","Centerfield","Centerport","Centerton","Centertown","Centertown","Centerview","Centerville","Centerville","Centerville","Centerville","Centerville","Centerville","Centerville","Centerville","Centerville","Centerville","Centrahoma","Central","Central","Central Bridge","Central City","Central City","Central City","Central City","Central City","Central Falls","Central Islip","Central Lake","Central Point","Central Square","Central Valley","Central Village","Centralia","Centralia","Centralia","Centralia","Centre","Centre Hall","Centreville","Centreville","Centreville","Centreville","Centreville","Centuria","Century","Ceres","Ceres","Ceresco","Ceresco","Cerrillos","Cerritos","Cerro","Cerro Gordo","Cerro Gordo","Cerulean","Chadbourn","Chadds Ford","Chadron","Chadwick","Chaffee","Chaffee","Chagrin Falls","Chalfont","Challis","Chalmette","Chama","Chamberino","Chamberlain","Chambers","Chambersburg","Chambersburg","Champaign","Champion","Champion","Champlain","Champlin","Chana","Chancellor","Chancellor","Chandler","Chandler","Chandler","Chandler","Chandler","Chandlersville","Chandlerville","Chanhassen","Channahon","Channelview","Channing","Chantilly","Chanute","Chaparral","Chapel Hill","Chapel Hill","Chapin","Chaplin","Chaplin","Chapman","Chapman","Chapmansboro","Chapmanville","Chappaqua","Chappell Hill","Chardon","Charenton","Chariton","Charlemont","Charleroi","Charles City","Charles City","Charles Town","Charleston","Charleston","Charleston","Charleston","Charleston","Charleston","Charleston","Charleston","Charlestown","Charlestown","Charlestown","Charlestown","Charlevoix","Charlotte","Charlotte","Charlotte","Charlotte","Charlotte","Charlotte","Charlotte","Charlotte Court House","Charlotte Hall","Charlottesville","Charlotteville","Charlton","Charter Oak","Charter Township of Clinton","Chartley","Chase","Chase City","Chaseburg","Chaseley","Chaska","Chassell","Chataignier","Chatfield","Chatham","Chatham","Chatham","Chatham","Chatham","Chatham","Chatom","Chatsworth","Chatsworth","Chatsworth","Chattahoochee","Chattanooga","Chattaroy","Chattaroy","Chaumont","Chauncey","Chautauqua","Chauvin","Chavies","Chazy","Chebanse","Chebeague Island","Cheboygan","Checotah","Chefornak","Chehalis","Chelan","Chelan Falls","Chelmsford","Chelsea","Chelsea","Chelsea","Chelsea","Chelsea","Chelsea","Cheltenham","Cheltenham","Chemung","Chenango Forks","Cheney","Cheney","Cheneyville","Chenoa","Chepachet","Cheraw","Cheriton","Cherokee","Cherokee","Cherokee","Cherokee","Cherokee","Cherokee Village","Cherry Hill","Cherry Log","Cherry Point Marine Base Mobile Home Park","Cherry Tree","Cherry Valley","Cherry Valley","Cherry Valley","Cherryfield","Cherryvale","Cherryville","Chesaning","Chesapeake","Chesapeake","Chesapeake Beach","Chesapeake City","Cheshire","Cheshire","Cheshire","Chesnee","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester","Chester Heights","Chester Springs","Chesterfield","Chesterfield","Chesterfield","Chesterfield","Chesterfield","Chesterhill","Chesterland","Chesterton","Chestertown","Chestertown","Chestnut","Chestnut Hill","Chestnut Mountain","Chestnut Ridge","Cheswick","Chetek","Chetopa","Chevak","Chevy Chase","Chewelah","Cheyenne","Cheyenne","Cheyenne Wells","Cheyney","Chicago","Chicago Heights","Chicago Ridge","Chichester","Chickamauga","Chickasha","Chicken","Chico","Chico","Chicopee","Chicora","Chiefland","Childersburg","Childress","Childs","Chilhowee","Chilhowie","Chili","Chillicothe","Chillicothe","Chillicothe","Chillicothe","Chilo","Chilton","Chilton","Chimacum","China Grove","China Springs","Chinchilla","Chincoteague Island","Chinese Camp","Chinle","Chino","Chino Hills","Chino Valley","Chinook","Chipley","Chippewa Falls","Chippewa Lake","Chireno","Chisago City","Chisholm","Chittenango","Chittenden","Chloride","Chocorua","Chocowinity","Choctaw","Choctaw","Chokio","Choteau","Choudrant","Chouteau","Chowchilla","Chrisman","Christchurch","Christiana","Christiana","Christiansburg","Christine","Christmas","Christmas Valley","Christopher","Christoval","Chualar","Chuckey","Chugiak","Chugwater","Chula","Chula","Chula Vista","Chunchula","Chunky","Church Hill","Church Hill","Church Point","Church Rock","Churchton","Churchville","Churchville","Churchville","Churdan","Churubusco","Cibola","Cibolo","Cicero","Cicero","Cicero","Cimarron","Cimarron","Cimarron","Cincinnati","Cincinnatus","Cinebar","Circle","Circle Pines","Circleville","Circleville","Circleville","Cisco","Cisco","Cisco","Cisne","Cissna Park","Citra","Citronelle","Citrus Heights","City of Angels","City of Industry","City of Picher (historical)","City of Saint Marys","City of Saint Peters","Clackamas","Claflin","Claire City","Clairton","Clam Lake","Clancy","Clanton","Clara City","Clare","Clare","Claremont","Claremont","Claremont","Claremont","Claremont","Claremont","Claremore","Clarence","Clarence","Clarence","Clarence","Clarendon","Clarendon","Clarendon Hills","Claridge","Clarinda","Clarington","Clarion","Clarion","Clarissa","Clark","Clark","Clark","Clark","Clark Fork","Clark Mills","Clarkesville","Clarkfield","Clarkia","Clarklake","Clarkrange","Clarks","Clarks","Clarks Grove","Clarks Hill","Clarks Hill","Clarks Summit","Clarksboro","Clarksburg","Clarksburg","Clarksburg","Clarksburg","Clarksburg","Clarksburg","Clarksdale","Clarksdale","Clarkson","Clarkson","Clarkston","Clarkston","Clarkston","Clarkston","Clarkston","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarksville","Clarkton","Claryville","Clatonia","Clatskanie","Claude","Claudville","Claverack","Clawson","Clawson","Claxton","Clay","Clay","Clay Center","Clay Center","Clay City","Clay City","Clay City","Claymont","Claypool","Claypool","Claysburg","Claysville","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Clayton","Cle Elum","Clear Brook","Clear Fork","Clear Lake","Clear Lake","Clear Lake","Clear Lake","Clear Spring","Clearbrook","Clearfield","Clearfield","Clearfield","Clearfield","Clearlake","Clearlake Oaks","Clearmont","Clearmont","Clearville","Clearwater","Clearwater","Clearwater","Clearwater","Clearwater Beach","Cleburne","Cleghorn","Clementon","Clements","Clemmons","Clemons","Clemson","Clendenin","Clermont","Clermont","Clermont","Clermont","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Cleveland","Clever","Cleves","Clewiston","Clifford","Clifford","Cliffside Park","Cliffwood","Clifton","Clifton","Clifton","Clifton","Clifton","Clifton","Clifton","Clifton","Clifton Forge","Clifton Heights","Clifton Park","Clifton Springs","Climax","Climax","Climax","Climax","Climax","Climax Springs","Clinchco","Clint","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton","Clinton Corners","Clintondale","Clintonville","Clintonville","Clintwood","Clio","Clio","Clio","Clive","Clontarf","Clopton","Cloquet","Closplint","Closter","Cloud","Cloudcroft","Clover","Clover","Cloverdale","Cloverdale","Cloverdale","Cloverdale","Cloverdale","Cloverport","Clovis","Clovis","Clute","Clyde","Clyde","Clyde","Clyde","Clyde","Clyde","Clyde Park","Clyman","Clymer","Clymer","Clyo","Coachella","Coahoma","Coal Center","Coal City","Coal City","Coal City","Coal Hill","Coal Mountain","Coal Township","Coal Valley","Coaldale","Coalfield","Coalgate","Coalinga","Coalmont","Coalport","Coalville","Coarsegold","Coatesville","Coatesville","Coats","Coatsburg","Cobalt","Cobb","Cobb","Cobbs Creek","Cobden","Cobleskill","Coburn","Cochecton","Cochise","Cochiti Lake","Cochiti Pueblo","Cochran","Cochrane","Cochranton","Cochranville","Cockeysville","Cocoa","Cocoa Beach","Cocolamus","Coden","Cody","Cody","Coeburn","Coeymans","Coeymans Hollow","Coffee Springs","Coffeen","Coffeeville","Coffey","Coffeyville","Coffman Cove","Coggon","Cogswell","Cohasset","Cohasset","Cohocton","Cohoes","Cohutta","Coin","Coinjock","Cokato","Cokeburg","Coker","Cokeville","Colbert","Colbert","Colbert","Colby","Colby","Colchester","Colchester","Colchester","Colcord","Cold Brook","Cold Spring","Cold Spring","Cold Spring Harbor","Cold Springs","Colden","Coldspring","Coldwater","Coldwater","Coldwater","Coldwater","Cole Camp","Colebrook","Coleman","Coleman","Coleman","Coleman","Colerain","Coleraine","Coleridge","Colesburg","Coleville","Colfax","Colfax","Colfax","Colfax","Colfax","Colfax","Colfax","Colfax","Colfax","Colgate","College Corner","College Grove","College Park","College Place","College Point","College Station","Collegedale","Collegeport","Collegeville","Collegeville","Colleyville","Colliers","Collierville","Collingswood","Collins","Collins","Collins","Collins","Collins","Collins","Collinston","Collinston","Collinsville","Collinsville","Collinsville","Collinsville","Collinsville","Collinsville","Collinsville","Collinsville","Collinwood","Collison","Colman","Colmar","Colmesneil","Colo","Cologne","Coloma","Coloma","Coloma","Colon","Colona","Colonia","Colonial Beach","Colonial Heights","Colony","Colora","Colorado City","Colorado City","Colorado City","Colorado Springs","Colquitt","Colstrip","Colt","Colton","Colton","Colton","Colton","Colts Neck","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia","Columbia City","Columbia City","Columbia Cross Roads","Columbia Falls","Columbia Station","Columbiana","Columbiana","Columbiaville","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus","Columbus Grove","Columbus Junction","Colusa","Colver","Colville","Colwich","Comanche","Comanche","Combined Locks","Combs","Combs","Comer","Comfort","Comfrey","Commack","Commerce","Commerce","Commerce","Commerce","Commerce City","Commercial Point","Commiskey","Como","Comptche","Compton","Compton","Comstock","Comstock","Comstock","Comstock Park","Conception Junction","Concho","Concord","Concord","Concord","Concord","Concord","Concord","Concord","Concord","Concord","Concordia","Concordia","Concordville","Concrete","Condon","Conestoga","Conesus","Conesville","Confluence","Conger","Congers","Congerville","Congress","Conifer","Conklin","Conklin","Conley","Conneaut","Conneaut Lake","Conneautville","Connell","Connellsville","Connelly Springs","Connersville","Conover","Conover","Conowingo","Conrad","Conrad","Conrath","Conroe","Conroy","Conshohocken","Constableville","Constantia","Constantine","Contact","Content","Continental","Contoocook","Convent","Converse","Converse","Converse","Convoy","Conway","Conway","Conway","Conway","Conway","Conway","Conway","Conway","Conway Springs","Conyers","Conyngham","Cook","Cook","Cookeville","Cookstown","Cooksville","Coolidge","Coolidge","Coolin","Coolville","Coon Rapids","Coon Valley","Cooper","Cooper Landing","Coopers Plains","Coopersburg","Cooperstown","Cooperstown","Cooperstown","Coopersville","Coos Bay","Copake","Copake Falls","Copalis Beach","Copan","Cope","Copeland","Copenhagen","Copeville","Copiague","Coplay","Coppell","Copper Center","Copper Harbor","Copperas Cove","Copperhill","Copperopolis","Coquille","Coral","Coral Gables","Coralville","Coram","Coraopolis","Corbett","Corbin","Corcoran","Cordele","Cordell","Cordesville","Cordova","Cordova","Cordova","Cordova","Cordova","Cordova","Corfu","Corinna","Corinne","Corinth","Corinth","Corinth","Corn","Cornelia","Cornelius","Cornelius","Cornell","Cornell","Cornersville","Corning","Corning","Corning","Corning","Corning","Corning","Cornish","Cornish","Cornish Flat","Cornville","Cornwall","Cornwall Bridge","Cornwall-on-Hudson","Cornwallville","Corolla","Corona","Corona","Corona","Corona","Corona del Mar","Coronado","Corpus Christi","Corrales","Correctionville","Corrigan","Corry","Corryton","Corsica","Corsica","Corsicana","Cortaro","Corte Madera","Cortez","Cortland","Cortland","Cortland","Cortland","Corunna","Corunna","Corvallis","Corvallis","Corwith","Cory","Cory","Corydon","Corydon","Corydon","Cos Cob","Cosby","Coshocton","Cosmopolis","Cosmos","Costa Mesa","Cotati","Cottage Grove","Cottage Grove","Cottage Grove","Cottage Hills","Cottageville","Cottageville","Cottekill","Cotton","Cotton Valley","Cottondale","Cottondale","Cottonport","Cottontown","Cottonwood","Cottonwood","Cottonwood","Cottonwood","Cottonwood","Cotuit","Cotulla","Coudersport","Coulee City","Coulee Dam","Coulterville","Coulterville","Counce","Council","Council","Council Bluffs","Council Grove","Council Hill","Country Club Hills","Coupeville","Coupland","Courtland","Courtland","Courtland","Courtland","Coushatta","Cove","Cove","Covelo","Coventry","Coventry","Covert","Covina","Covington","Covington","Covington","Covington","Covington","Covington","Covington","Covington","Covington","Cowan","Cowansville","Coward","Cowden","Cowen","Coweta","Cowiche","Cowlesville","Cowley","Cowpens","Coxs Creek","Coxsackie","Coyle","Coyote","Coyote","Cozad","Crab Orchard","Crab Orchard","Crab Orchard","Crabtree","Craftsbury","Craig","Craig","Craig","Craig","Craigmont","Craigsville","Craigsville","Craigville","Cramerton","Cranberry Township","Cranbury","Crandall","Crandall","Crandall","Crandon","Crane","Crane","Crane","Crane Hill","Crane Lake","Cranesville","Cranfills Gap","Cranford","Cranks","Cranston","Craryville","Crawford","Crawford","Crawford","Crawford","Crawford","Crawford","Crawfordsville","Crawfordsville","Crawfordville","Crawfordville","Crawley","Creal Springs","Cream Ridge","Creede","Creedmoor","Creekside","Creighton","Creighton","Creola","Creola","Creole","Cresbard","Crescent","Crescent","Crescent","Crescent City","Crescent City","Crescent Hills","Crescent Mills","Crescent Valley","Cresco","Cresco","Cresskill","Cresson","Cresson","Crest Hill","Crested Butte","Crestline","Crestline","Creston","Creston","Creston","Creston","Crestone","Crestview","Crestwood","Creswell","Crete","Crete","Creve Coeur","Crewe","Crimora","Cripple Creek","Crisfield","Crittenden","Critz","Crivitz","Crocker","Crockett","Crockett","Crofton","Crofton","Crofton","Croghan","Crompond","Cromwell","Cromwell","Cromwell","Crooks","Crookston","Crookston","Crooksville","Cropseyville","Crosby","Crosby","Crosby","Crosbyton","Cross","Cross City","Cross Junction","Cross Lake","Cross Plains","Cross Plains","Cross Plains","Cross Plains","Cross River","Crossett","Crossville","Crossville","Crossville","Crosswicks","Croswell","Crothersville","Croton","Croton Falls","Croton-on-Hudson","Crow Agency","Crowder","Crowell","Crowheart","Crowley","Crowley","Crown City","Crown Point","Crown Point","Crownpoint","Crownsville","Crows Landing","Croydon","Crozet","Crucible","Cruger","Crum","Crum Lynne","Crump","Crumpler","Crystal","Crystal City","Crystal City","Crystal Falls","Crystal Lake","Crystal River","Crystal Springs","Crystal Springs","Cub Run","Cuba","Cuba","Cuba","Cuba","Cuba","Cuba City","Cudahy","Cuddebackville","Cuddy Hill","Cuero","Culbertson","Culbertson","Culdesac","Cullen","Cullen","Culleoka","Cullman","Culloden","Culloden","Cullom","Cullowhee","Culpeper","Culver","Culver","Culver City","Cumberland","Cumberland","Cumberland","Cumberland","Cumberland","Cumberland","Cumberland","Cumberland Center","Cumberland City","Cumberland Foreside","Cumberland Furnace","Cumberland Gap","Cumby","Cumming","Cumming","Cummings","Cummington","Cunningham","Cunningham","Cupertino","Currie","Currituck","Curryville","Curtice","Curtis","Curtis","Curtis Bay","Curtiss","Curwensville","Cushing","Cushing","Cushing","Cusick","Cusseta","Cusseta","Custar","Custer","Custer","Custer","Custer","Custer","Custer City","Cut Bank","Cut Off","Cutchogue","Cuthbert","Cutler","Cutler","Cuttingsville","Cuyahoga Falls","Cyclone","Cygnet","Cylinder","Cynthiana","Cynthiana","Cypress","Cypress","Cypress","Cypress Inn","Cyril","Dacoma","Dacono","Dacula","Dade City","Dadeville","Daggett","Dagsboro","Dahlgren","Dahlgren","Dahlonega","Daingerfield","Daisetta","Daisytown","Dakota","Dakota","Dakota City","Dakota City","Dale","Dale","Dale","Dale","Daleville","Daleville","Daleville","Dalhart","Dallas","Dallas","Dallas","Dallas","Dallas","Dallas","Dallas","Dallas","Dallas Center","Dallas City","Dallastown","Dalmatia","Dalton","Dalton","Dalton","Dalton","Dalton","Dalton","Dalton","Dalton City","Daly City","Dalzell","Dalzell","Damariscotta","Damascus","Damascus","Damascus","Damascus","Damascus","Damon","Dana","Dana","Dana","Dana Point","Danbury","Danbury","Danbury","Danbury","Danbury","Danby","Dandridge","Dane","Danese","Danforth","Danforth","Dania Beach","Daniels","Danielson","Danielsville","Danielsville","Dannemora","Dansville","Dansville","Dante","Danube","Danvers","Danvers","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Danville","Daphne","Darby","Darby","Dardanelle","Darden","Darien","Darien","Darien","Darien","Darlington","Darlington","Darlington","Darlington","Darlington","Darmstadt","Darrington","Darrouzett","Darrow","Darwin","Dassel","Dateland","Datil","Dauphin","Dauphin Island","Davenport","Davenport","Davenport","Davenport","David City","Davidson","Davidsonville","Davis","Davis","Davis","Davis","Davis City","Davis Junction","Davisboro","Davisburg","Davison","Daviston","Davisville","Davisville","Davy","Dawes","Dawn","Dawson","Dawson","Dawson","Dawson","Dawson","Dawson Springs","Dawsonville","Days Creek","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Dayton","Daytona Beach","Dayville","Dazey","De Beque","De Borgia","De Forest","De Graff","De Kalb","De Kalb","De Kalb","De Kalb Junction","De Leon","De Leon Springs","De Queen","De Smet","De Soto","De Soto","De Soto","De Soto","De Soto","De Valls Bluff","De Witt","De Witt","De Witt","Deadwood","Deal","Deal Island","Deale","Deansboro","Deanville","Dearborn","Dearborn","Dearborn Heights","Dearing","Death Valley Junction","Deatsville","Deaver","DeBary","Debord","Decatur","Decatur","Decatur","Decatur","Decatur","Decatur","Decatur","Decatur","Decatur","Decatur","Decaturville","Decherd","Decker","Deckerville","Declo","Decorah","Dedham","Deep River","Deep River","Deep Run","Deep Water","Deepwater","Deer","Deer Island","Deer Isle","Deer Lodge","Deer Lodge","Deer Park","Deer Park","Deer Park","Deer Park","Deer River","Deer Trail","Deerfield","Deerfield","Deerfield","Deerfield","Deerfield","Deerfield","Deerfield","Deerfield Beach","Deering","Deerwood","Defiance","Defiance","Defiance","Defiance","Deford","DeFuniak Springs","DeKalb","Del Mar","Del Norte","Del Rey","Del Rio","Del Rio","Del Valle","Delafield","DeLand","Delano","Delano","Delano","Delano","Delanson","Delaplaine","Delavan","Delavan","Delavan","Delaware","Delaware City","Delbarton","Delcambre","Delco","Delevan","Delhi","Delhi","Delhi","Delhi","Delight","Dell","Dell Rapids","Delmar","Delmar","Delmar","Delmar","Delmont","Delmont","Deloit","Delphi","Delphos","Delphos","Delray","Delray Beach","Delta","Delta","Delta","Delta","Delta","Deltana","Deltaville","Delton","Deltona","Dema","Demarest","Deming","Deming","Demopolis","Demorest","DeMossville","DeMotte","Denair","Dendron","Denham Springs","Denison","Denison","Denison","Denmark","Denmark","Denmark","Denmark","Denmark","Dennis","Dennis","Dennis Port","Dennison","Dennison","Dennison","Denniston","Dennysville","Dent","Denton","Denton","Denton","Denton","Denton","Denton","Denton","Denver","Denver","Denver","Denver","Denver","Denver","Denver City","Denville","Depauw","Depere","Depew","Depew","Depoe Bay","Deposit","Depue","Deputy","DeQuincy","Derby","Derby","Derby","Derby","Derby Center","Derby Line","DeRidder","Derma","Dermott","Derry","Derry","DeRuyter","Derwood","Des Allemands","Des Arc","Des Arc","Des Moines","Des Moines","Des Plaines","Descanso","Desert Hot Springs","Deshler","Deshler","DeSoto","Destin","Destrehan","Detroit","Detroit","Detroit Lakes","Devens","Deville","Devils Lake","Devine","Devon","Dewar","Dewey","Dewey","Dewey","DeWitt","DeWitt","DeWitt","Dewy Rose","Dexter","Dexter","Dexter","Dexter","Dexter","Dexter","Dexter","Dexter","Dexter","Dexter City","Diablo","Diagonal","Diamond","Diamond","Diamond Bar","Diamond Point","Diamond Springs","Diamondhead","Diamondville","Diana","Diana","Diboll","Dickerson","Dickeyville","Dickinson","Dickinson","Dickinson Center","Dickson","Dickson City","Dierks","Dieterich","Dietrich","Diggs","Dighton","Dighton","Dill City","Dillard","Dillard","Diller","Dilley","Dillingham","Dillon","Dillon","Dillon","Dillon Beach","Dillonvale","Dillsboro","Dillsboro","Dillsburg","Dillwyn","Dime Box","Dimmitt","Dimock","Dimondale","Dingess","Dingmans Ferry","Dinuba","Dinwiddie","Discovery Bay","Disputanta","Distant","District Heights","Dittmer","Divernon","Divide","Divide","Dividing Creek","Dix","Dixfield","Dixie","Dixie","Dixie","Dixmont","Dixon","Dixon","Dixon","Dixon","Dixon","Dixon","Dixon","Dixon Springs","Dixons Mills","Dixonville","Dobbs Ferry","Dobson","Docena","Dodd City","Doddridge","Dodge","Dodge","Dodge Center","Dodge City","Dodgeville","Dodgewood","Doerun","Dolan Springs","Doland","Dolgeville","Dollar Bay","Dolliver","Dolomite","Dolores","Dolphin","Dolton","Donald","Donalds","Donaldson","Donaldsonville","Donalsonville","Donegal","Dongola","Donie","Doniphan","Doniphan","Donna","Donnellson","Donnelly","Donnelsville","Donner","Donora","Donovan","Doon","Dora","Dorchester","Dorchester","Dorchester","Dorena","Dornsife","Dorothy","Dorr","Dorrance","Dorris","Dorset","Dorsey","Dos Palos","Doss","Doswell","Dothan","Double Springs","Dougherty","Douglas","Douglas","Douglas","Douglas","Douglas","Douglas","Douglas","Douglas City","Douglass","Douglass","Douglassville","Douglassville","Douglasville","Dousman","Dover","Dover","Dover","Dover","Dover","Dover","Dover","Dover","Dover","Dover","Dover","Dover Plains","Dover-Foxcroft","Dow","Dowagiac","Dowell","Dowelltown","Dowling","Downers Grove","Downey","Downey","Downieville","Downingtown","Downs","Downs","Downsville","Downsville","Downsville","Dows","Doyle","Doyle","Doylestown","Doylestown","Doyline","Dozier","Dracut","Dragoon","Drain","Drakes Branch","Drakesboro","Draper","Draper","Drasco","Dravosburg","Drayden","Dresden","Dresden","Dresher","Dresser","Drewryville","Drexel","Drexel","Drexel Hill","Drift","Drifting","Driftwood","Driftwood","Driggs","Dripping Springs","Driscoll","Drummond","Drummond","Drummond","Drummond","Drummonds","Drumore","Drumright","Drums","Dry Branch","Dry Creek","Dry Fork","Dry Prong","Dry Ridge","Dry Run","Drybranch","Dryden","Dryden","Dryden","Dryden","Dryfork","Du Bois","Du Quoin","Duanesburg","Duarte","Dubach","Dublin","Dublin","Dublin","Dublin","Dublin","Dublin","Dublin","Dublin","Dublin","DuBois","Dubois","Dubois","Dubois","Dubuque","Duchesne","Duck","Duck Creek Village","Duck Hill","Ducktown","Dudley","Dudley","Dudley","Dudley","Due West","Duff","Duffield","Dufur","Dugger","Dugway","Duke","Duke Center","Dukedom","Dulac","Dulce","Dulles","Duluth","Duluth","Dulzura","Dumas","Dumas","Dumfries","Dumont","Dumont","Dunbar","Dunbar","Dunbar","Dunbar","Dunbarton Center","Duncan","Duncan","Duncan","Duncannon","Duncans Mills","Duncansville","Duncanville","Duncanville","Duncombe","Dundalk","Dundas","Dundas","Dundee","Dundee","Dundee","Dundee","Dundee","Dundee","Dunedin","Dunellen","Dungannon","Dunkerton","Dunkirk","Dunkirk","Dunkirk","Dunlap","Dunlap","Dunlap","Dunlap","Dunlow","Dunmor","Dunmore","Dunn","Dunn Loring","Dunnell","Dunnellon","Dunnsville","Dunnville","Dunseith","Dunsmuir","Dunstable","Duplessis","Dupo","DuPont","Dupont","Dupuyer","Duquesne","Durand","Durand","Durand","Durango","Durango","Durant","Durant","Durant","Durbin","Durham","Durham","Durham","Durham","Durham","Durhamville","Duryea","Dushore","Duson","Dustin","Dutch Flat","Dutch Harbor","Dutch John","Dutton","Dutton","Duvall","Duxbury","Dwale","Dwight","Dwight","Dwight","Dyer","Dyer","Dyersburg","Dyersville","Dysart","Dysart","Eads","Eads","Eagar","Eagle","Eagle","Eagle","Eagle","Eagle","Eagle Bend","Eagle Bridge","Eagle Butte","Eagle Creek","Eagle Grove","Eagle Lake","Eagle Lake","Eagle Lake","Eagle Mountain","Eagle Nest","Eagle Pass","Eagle Point","Eagle River","Eagle River","Eagle Rock","Eagle Springs","Eagleville","Eagleville","Eagleville","Earl Park","Earle","Earleville","Earlham","Earlimart","Earling","Earlsboro","Earlton","Earlville","Earlville","Earlville","Early","Early","Earlysville","Earth","Earth City","Easley","East Alton","East Amherst","East Andover","East Aurora","East Bank","East Barre","East Bend","East Berkshire","East Berlin","East Berlin","East Bernard","East Berne","East Bernstadt","East Blue Hill","East Boothbay","East Brady","East Branch","East Bridgewater","East Brookfield","East Brunswick","East Burke","East Butler","East Calais","East Canaan","East Candia","East Carbon City","East Carondelet","East Chatham","East Chicago","East China Township","East Claridon","East Corinth","East Dennis","East Dover","East Dublin","East Dubuque","East Durham","East Earl","East Elmhurst","East Fairfield","East Fairview","East Falmouth","East Flat Rock","East Freedom","East Freetown","East Galesburg","East Granby","East Grand Forks","East Greenbush","East Greenville","East Greenwich","East Haddam","East Hampstead","East Hampton","East Hampton","East Hanover","East Hardwick","East Hartford","East Hartland","East Haven","East Helena","East Irvine","East Islip","East Jordan","East Kingston","East Lake","East Lansing","East Leroy","East Liberty","East Liverpool","East Longmeadow","East Lynn","East Lynn","East Machias","East Marion","East McKeesport","East Meadow","East Meredith","East Middlebury","East Millinocket","East Millsboro","East Moline","East Montpelier","East Moriches","East New Market","East Northport","East Norwich","East Orange","East Orleans","East Otis","East Palatka","East Palestine","East Peoria","East Petersburg","East Pharsalia","East Pittsburgh","East Point","East Prairie","East Prospect","East Providence","East Quogue","East Randolph","East Rochester","East Rockaway","East Rutherford","East Saint Louis","East Sandwich","East Setauket","East Sparta","East Stone Gap","East Stoneham","East Stroudsburg","East Syracuse","East Taunton","East Tawas","East Thetford","East Troy","East Wakefield","East Walpole","East Wareham","East Waterboro","East Wenatchee","East Weymouth","East Windsor Hill","Eastaboga","Eastanollee","Eastchester","Eastern","Eastford","Eastham","Easthampton","Eastlake","Eastlake","Eastland","Eastman","Easton","Easton","Easton","Easton","Easton","Easton","Easton","Easton","Eastover","Eastpoint","Eastpointe","Eastport","Eastport","Eastsound","Eastview","Eastville","Eaton","Eaton","Eaton","Eaton","Eaton Rapids","Eatonton","Eatontown","Eatonville","Eau Claire","Eau Claire","Eau Galle","Ebensburg","Echo","Echo","Eckert","Eckerty","Eclectic","Economy","Ecorse","Ecru","Ector","Edcouch","Eddington","Eddy","Eddyville","Eddyville","Eddyville","Edelstein","Eden","Eden","Eden","Eden","Eden","Eden","Eden","Eden","Eden Prairie","Eden Valley","Edenton","Edgar","Edgar","Edgard","Edgartown","Edgecomb","Edgefield","Edgeley","Edgemont","Edgemont","Edgemoor","Edgerton","Edgerton","Edgerton","Edgerton","Edgerton","Edgewater","Edgewater","Edgewater","Edgewood","Edgewood","Edgewood","Edgewood","Edgewood","Edina","Edinboro","Edinburg","Edinburg","Edinburg","Edinburg","Edinburg","Edinburgh","Edison","Edison","Edison","Edison","Edisto Island","Edmeston","Edmond","Edmonds","Edmonton","Edmore","Edmore","Edna","Edna","Edneyville","Edon","Edson","Edwall","Edwards","Edwards","Edwards","Edwards","Edwards","Edwards Air Force Base","Edwardsburg","Edwardsport","Edwardsville","Effie","Effingham","Effingham","Effingham","Effingham","Effort","Efland","Egan","Egan","Egg Harbor","Egg Harbor","Egg Harbor City","Eglin","Eglon","Egypt","Ehrenberg","Eielson Air Force Base","Eight Mile","Eighty Four","Ekalaka","Ekron","El Cajon","El Campo","El Centro","El Cerrito","El Dorado","El Dorado","El Dorado","El Dorado Hills","El Dorado Springs","El Granada","El Macero","El Mirage","El Monte","El Paso","El Paso","El Paso","El Prado","El Reno","El Segundo","El Sobrante","Elba","Elba","Elba","Elberon","Elbert","Elbert","Elberta","Elberta","Elberton","Elbow Lake","Elbridge","Elburn","Elcho","Elco","Elderton","Eldon","Eldon","Eldora","Eldorado","Eldorado","Eldorado","Eldred","Eldred","Eldred","Eldridge","Eldridge","Eleanor","Electra","Elephant Butte","Eleva","Elfrida","Elgin","Elgin","Elgin","Elgin","Elgin","Elgin","Elgin","Elgin","Elgin","Elgin","Eliot","Elizabeth","Elizabeth","Elizabeth","Elizabeth","Elizabeth","Elizabeth","Elizabeth City","Elizabethton","Elizabethtown","Elizabethtown","Elizabethtown","Elizabethtown","Elizabethtown","Elizabethtown","Elizabethville","Elizaville","Elk","Elk City","Elk Falls","Elk Garden","Elk Grove","Elk Grove Village","Elk Horn","Elk Horn","Elk Mills","Elk Mound","Elk Park","Elk Point","Elk Rapids","Elk River","Elk River","Elkader","Elkfork","Elkhart","Elkhart","Elkhart","Elkhart","Elkhart","Elkhart Lake","Elkhorn","Elkhorn","Elkhorn","Elkhorn City","Elkin","Elkins","Elkins","Elkins Park","Elkland","Elkland","Elkmont","Elko","Elko","Elko","Elkridge","Elkton","Elkton","Elkton","Elkton","Elkton","Elkton","Elkton","Elkview","Elkville","Elkwood","Ellabell","Ellaville","Ellenboro","Ellenburg Center","Ellenburg Depot","Ellendale","Ellendale","Ellendale","Ellendale","Ellensburg","Ellenton","Ellenville","Ellenwood","Ellerbe","Ellerslie","Ellettsville","Ellicott City","Ellicottville","Ellijay","Ellington","Ellington","Ellinwood","Elliott","Elliottsburg","Ellis","Ellis Grove","Elliston","Ellisville","Elloree","Ellsinore","Ellsworth","Ellsworth","Ellsworth","Ellsworth","Ellsworth","Ellsworth","Ellsworth","Ellsworth","Ellwood City","Elm City","Elm Creek","Elm Grove","Elm Grove","Elma","Elma","Elma","Elmdale","Elmendorf","Elmer","Elmer","Elmer City","Elmhurst","Elmhurst","Elmhurst","Elmira","Elmira","Elmira","Elmira","Elmo","Elmont","Elmora","Elmore","Elmore","Elmore","Elmore City","Elmsford","Elmwood","Elmwood","Elmwood","Elmwood","Elmwood Park","Elmwood Park","Elnora","Elon","Elora","Eloy","Elroy","Elsa","Elsah","Elsberry","Elsie","Elsie","Elsinore","Elton","Eltopia","Elvaston","Elverson","Elverta","Elwell","Elwood","Elwood","Elwood","Elwood","Ely","Ely","Ely","Elyria","Elysburg","Elysian","Elysian Fields","Embarrass","Embudo","Emden","Emerado","Emerald Isle","Emerson","Emerson","Emerson","Emerson","Emerson","Emerson","Emery","Emery","Emeryville","Emigrant","Emily","Eminence","Eminence","Emlenton","Emmaus","Emmet","Emmetsburg","Emmett","Emmett","Emmitsburg","Emmons","Emory","Emory","Empire","Empire","Empire","Empire","Empire","Empire","Emporia","Emporia","Emporium","Encampment","Encinitas","Encino","Endeavor","Enderlin","Endicott","Endicott","Endicott","Energy","Enfield","Enfield","Enfield","Enfield","Engelhard","England","Englewood","Englewood","Englewood","Englewood","Englewood","Englewood Cliffs","Englishtown","Enid","Enigma","Enka","Ennice","Ennis","Ennis","Enola","Enola","Enon","Enoree","Enosburg Falls","Enterprise","Enterprise","Enterprise","Enterprise","Enterprise","Entiat","Enumclaw","Eolia","Eolia","Epes","Ephraim","Ephraim","Ephrata","Ephrata","Epping","Epping","Epps","Epsom","Epworth","Epworth","Equality","Equality","Equinunk","Erath","Erbacon","Erhard","Erick","Erie","Erie","Erie","Erie","Erie","Erieville","Erin","Erin","Erlanger","Eros","Errol","Erskine","Erving","Ervings Location","Erwin","Erwin","Erwinna","Erwinville","Esbon","Escalante","Escalon","Escanaba","Escondido","Esko","Eskridge","Esmond","Esmond","Esmont","Espanola","Esparto","Esperance","Essex","Essex","Essex","Essex","Essex","Essex Fells","Essex Junction","Essexville","Essie","Essington","Estacada","Estancia","Estell Manor","Estelline","Estero","Estes Park","Estherville","Estherwood","Estill","Estill Springs","Estillfork","Ethel","Ethel","Ethel","Ethelsville","Ethridge","Etna","Etna","Etna","Etna","Etna","Etna","Etna Green","Etoile","Eton","Etowah","Etta","Ettrick","Eubank","Eucha","Euclid","Euclid","Eudora","Eudora","Eufaula","Eufaula","Eugene","Eugene","Euless","Eunice","Eunice","Eupora","Eureka","Eureka","Eureka","Eureka","Eureka","Eureka","Eureka","Eureka","Eureka Springs","Eustace","Eustis","Eustis","Eutaw","Eutawville","Eva","Evangeline","Evans","Evans","Evans","Evans","Evans","Evans City","Evans Mills","Evansdale","Evanston","Evanston","Evanston","Evansville","Evansville","Evansville","Evansville","Evansville","Evansville","Evant","Evart","Evarts","Eveleth","Evensville","Everest","Everett","Everett","Everett","Everetts","Everglades City","Evergreen","Evergreen","Evergreen","Evergreen","Evergreen Park","Everly","Everson","Everson","Everton","Everton","Evington","Ewan","Ewen","Ewing","Ewing","Ewing","Ewing","Ewing","Excel","Excello","Excelsior","Excelsior Springs","Exeland","Exeter","Exeter","Exeter","Exeter","Exeter","Exira","Exline","Exmore","Experiment","Export","Exton","Eyota","Ezel","Fabens","Faber","Fabius","Fackler","Factoryville","Fair Bluff","Fair Grove","Fair Haven","Fair Haven","Fair Haven","Fair Lawn","Fair Oaks","Fair Oaks","Fair Play","Fair Play","Fairacres","Fairbank","Fairbanks","Fairbanks North Star Borough","Fairborn","Fairburn","Fairburn","Fairbury","Fairbury","Fairchance","Fairchild","Fairchild Air Force Base","Fairdale","Fairdale","Fairdealing","Fairfax","Fairfax","Fairfax","Fairfax","Fairfax","Fairfax","Fairfax","Fairfax","Fairfax Station","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield","Fairfield Bay","Fairgrove","Fairhaven","Fairhope","Fairhope","Fairland","Fairland","Fairlee","Fairless Hills","Fairmont","Fairmont","Fairmont","Fairmont","Fairmont","Fairmont City","Fairmount","Fairmount","Fairmount","Fairmount","Fairplay","Fairplay","Fairport","Fairton","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview","Fairview Heights","Fairview Village","Faith","Faith","Falcon","Falconer","Falfurrias","Falkland","Falkner","Falkville","Fall Branch","Fall City","Fall Creek","Fall Creek","Fall River","Fall River","Fall River Mills","Fallbrook","Falling Rock","Falling Waters","Fallon","Falls","Falls Church","Falls City","Falls City","Falls Creek","Falls Mills","Falls of Rough","Falls Village","Fallsburg","Fallston","Falmouth","Falmouth","Falmouth","Fancy Farm","Fannettsburg","Fanwood","Far Hills","Far Rockaway","Farber","Fargo","Faribault","Farina","Farley","Farlington","Farmdale","Farmer City","Farmersburg","Farmersville","Farmersville","Farmersville","Farmersville","Farmerville","Farmingdale","Farmingdale","Farmingdale","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington","Farmington Hills","Farmingville","Farmland","Farmville","Farmville","Farnham","Farnhamville","Farragut","Farragut","Farrell","Farson","Farwell","Farwell","Farwell","Farwell","Faulkner","Faulkton","Fawn Grove","Fawnskin","Faxon","Fayette","Fayette","Fayette","Fayette","Fayette","Fayette City","Fayetteville","Fayetteville","Fayetteville","Fayetteville","Fayetteville","Fayetteville","Fayetteville","Fayetteville","Fayetteville","Fayville","Feasterville-Trevose","Federal Way","Federalsburg","Feeding Hills","Felda","Felicity","Fellsmere","Felton","Felton","Felton","Felton","Fenelton","Fennimore","Fennville","Fenton","Fenton","Fenton","Fenton","Fentress","Fenwick","Fenwick","Fenwick Island","Ferdinand","Fergus Falls","Ferguson","Ferguson","Fernandina Beach","Ferndale","Ferndale","Ferndale","Ferndale","Fernley","Fernwood","Ferriday","Ferris","Ferrisburgh","Ferron","Ferrum","Ferrysburg","Fertile","Fessenden","Festus","Feura Bush","Fiddletown","Fidelity","Fieldale","Fielding","Fieldon","Fife Lake","Fifty Lakes","Filer","Filley","Fillmore","Fillmore","Fillmore","Fillmore","Fincastle","Finchville","Findlay","Findlay","Finger","Fingerville","Finksburg","Finlayson","Finley","Finleyville","Firebaugh","Firestone","Firth","Firth","Fischer","Fish Camp","Fish Creek","Fish Haven","Fishel","Fisher","Fisher","Fisher","Fishers","Fishers Island","Fishersville","Fisherville","Fishkill","Fishtail","Fisk","Fiskdale","Fitchburg","Fitzgerald","Fitzhugh","Fitzpatrick","Fitzwilliam","Five Points","Five Points","Flag Pond","Flagler","Flagler Beach","Flagstaff","Flanagan","Flanders","Flandreau","Flasher","Flat Lick","Flat Rock","Flat Rock","Flat Rock","Flat Rock","Flat Rock","Flatgap","Flatwoods","Flatwoods","Flatwoods","Flaxton","Flaxville","Fleetwood","Fleetwood","Fleischmanns","Fleming","Fleming","Fleming","Flemingsburg","Flemington","Flemington","Flemington","Flensburg","Fletcher","Fletcher","Flint","Flint","Flinton","Flintstone","Flintstone","Flintville","Flippin","Flomaton","Floodwood","Flora","Flora","Flora Vista","Florahome","Floral City","Floral Park","Florala","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Florence","Floresville","Florham Park","Florida","Florien","Florissant","Florissant","Flossmoor","Flourtown","Flovilla","Flower Mound","Floweree","Flowery Branch","Flowood","Floyd","Floyd","Floydada","Floyds Knobs","Fluker","Flushing","Flushing","Flushing","Fly Creek","Fogelsville","Folcroft","Foley","Foley","Foley","Folkston","Follansbee","Follett","Folly Beach","Folsom","Folsom","Folsom","Folsom","Fombell","Fond du Lac","Fonda","Fonda","Fontana","Fontana","Fontanelle","Foothill Ranch","Forbes","Forbes Road","Ford","Ford","Ford City","Fordland","Fordoche","Fords","Fordsville","Fordville","Fordyce","Foreman","Forest","Forest","Forest","Forest","Forest City","Forest City","Forest City","Forest City","Forest Falls","Forest Grove","Forest Hill","Forest Hill","Forest Hills","Forest Home","Forest Junction","Forest Knolls","Forest Lake","Forest Park","Forest Park","Forest River","Forestdale","Foresthill","Foreston","Forestport","Forestville","Forestville","Forestville","Forgan","Foristell","Fork Union","Forked River","Forkland","Forks","Forksville","Forman","Formoso","Forney","Forrest","Forrest City","Forreston","Forreston","Forsyth","Forsyth","Forsyth","Forsyth","Fort Ann","Fort Apache","Fort Ashby","Fort Atkinson","Fort Atkinson","Fort Belvoir","Fort Benning","Fort Benton","Fort Blackmore","Fort Bragg","Fort Bragg","Fort Branch","Fort Bridger","Fort Calhoun","Fort Campbell North","Fort Cobb","Fort Collins","Fort Davis","Fort Defiance","Fort Defiance","Fort Deposit","Fort Dodge","Fort Drum","Fort Duchesne","Fort Edward","Fort Fairfield","Fort Gaines","Fort Garland","Fort Gay","Fort George Meade","Fort Gibson","Fort Gratiot Township","Fort Greely","Fort Hall","Fort Irwin","Fort Jennings","Fort Jones","Fort Kent","Fort Knox","Fort Lauderdale","Fort Lee","Fort Lee","Fort Leonard Wood","Fort Loramie","Fort Loudon","Fort Lupton","Fort Madison","Fort McCoy","Fort McDowell","Fort Meade","Fort Mill","Fort Mitchell","Fort Mitchell","Fort Montgomery","Fort Morgan","Fort Myers","Fort Myers Beach","Fort Oglethorpe","Fort Payne","Fort Pierre","Fort Plain","Fort Polk","Fort Ransom","Fort Recovery","Fort Richardson","Fort Riley-Camp Whiteside","Fort Ripley","Fort Rucker","Fort Scott","Fort Sill Indian School Reservation (historical)","Fort Smith","Fort Stewart","Fort Stockton","Fort Sumner","Fort Thomas","Fort Thompson","Fort Totten","Fort Valley","Fort Walton Beach","Fort Washakie","Fort Washington","Fort Wayne","Fort White","Fort Worth","Fort Yates","Fortine","Fortson","Fortuna","Fortuna","Fortville","Foss","Fossil","Fosston","Foster","Foster","Foster","Foster","Foster","Foster City","Foster City","Fosters","Fostoria","Fostoria","Fouke","Fountain","Fountain","Fountain","Fountain","Fountain City","Fountain City","Fountain Green","Fountain Hills","Fountain Inn","Fountain Run","Fountain Valley","Fountaintown","Fountainville","Four Oaks","Fowler","Fowler","Fowler","Fowler","Fowler","Fowler","Fowlerville","Fox Island","Fox Lake","Fox Lake","Fox River Grove","Foxborough","Foxburg","Foxhome","Foxworth","Frackville","Framingham","Francestown","Francesville","Francisco","Franconia","Frankenmuth","Frankewing","Frankford","Frankford","Frankford","Frankfort","Frankfort","Frankfort","Frankfort","Frankfort","Frankfort","Frankfort","Frankfort","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin","Franklin Grove","Franklin Lakes","Franklin Park","Franklin Park","Franklin Springs","Franklin Square","Franklinton","Franklinton","Franklinville","Franklinville","Franklinville","Frankston","Franksville","Frankton","Franktown","Frannie","Fraser","Fraser","Frazee","Frazer","Frazeysburg","Frazier Park","Fraziers Bottom","Fred","Frederic","Frederica","Frederick","Frederick","Frederick","Frederick","Frederick","Fredericksburg","Fredericksburg","Fredericksburg","Fredericksburg","Fredericktown","Fredericktown","Fredericktown","Fredonia","Fredonia","Fredonia","Fredonia","Fredonia","Fredonia","Free Soil","Free Union","Freeburg","Freeburg","Freeburg","Freeburn","Freedom","Freedom","Freedom","Freedom","Freedom","Freehold","Freehold Borough","Freeland","Freeland","Freeland","Freeland","Freeman","Freeman","Freeport","Freeport","Freeport","Freeport","Freeport","Freeport","Freeport","Freeport","Freeport","Freer","Freetown","Freeville","Fremont","Fremont","Fremont","Fremont","Fremont","Fremont","Fremont","Fremont","French Camp","French Camp","French Lick","French Settlement","French Village","Frenchburg","Frenchtown","Frenchtown","Frenchville","Fresh Meadows","Fresno","Fresno","Fresno","Frewsburg","Friant","Friars Point","Friday Harbor","Friedens","Friend","Friendly","Friendship","Friendship","Friendsville","Friendsville","Friendsville","Friendswood","Fries","Friona","Frisco","Frisco","Frisco City","Fritch","Frohna","Froid","Front Royal","Frontenac","Frost","Frostburg","Frostproof","Fruita","Fruitdale","Fruitland","Fruitland","Fruitland","Fruitland","Fruitland Park","Fruitport","Fruitvale","Fryburg","Fryeburg","Ft. Pierce","Ft. Washington","Fulda","Fullerton","Fullerton","Fullerton","Fulshear","Fulton","Fulton","Fulton","Fulton","Fulton","Fulton","Fulton","Fulton","Fulton","Fulton","Fultondale","Fultonham","Fultonville","Fults","Funkstown","Fuquay-Varina","Furlong","Fyffe","Gable","Gackle","Gadsden","Gadsden","Gadsden","Gadsden","Gaffney","Gagetown","Gail","Gaines","Gaines","Gainesboro","Gainestown","Gainesville","Gainesville","Gainesville","Gainesville","Gainesville","Gainesville","Gaithersburg","Galatia","Galax","Galena","Galena","Galena","Galena","Galena","Galena","Galena Park","Gales Ferry","Galesburg","Galesburg","Galesburg","Galesville","Galesville","Galien","Galion","Galivants Ferry","Gallatin","Gallatin","Gallatin Gateway","Galliano","Gallion","Gallipolis","Gallipolis Ferry","Gallitzin","Galloway","Gallup","Galt","Galt","Galva","Galva","Galva","Galveston","Galveston","Galway","Gambier","Gambrills","Ganado","Ganado","Gans","Gansevoort","Gap","Gap Mills","Garards Fort","Garber","Garberville","Garciasville","Garden City","Garden City","Garden City","Garden City","Garden City","Garden City","Garden City","Garden City","Garden City","Garden Grove","Garden Grove","Garden Plain","Garden Prairie","Garden Valley","Garden Valley","Gardena","Gardendale","Gardendale","Gardiner","Gardiner","Gardiner","Gardner","Gardner","Gardner","Gardner","Gardners","Gardnerville","Garfield","Garfield","Garfield","Garfield","Garfield","Garland","Garland","Garland","Garland","Garnavillo","Garner","Garner","Garner","Garnerville","Garnet Valley","Garnett","Garrard","Garretson","Garrett","Garrett","Garrett","Garrettsville","Garrison","Garrison","Garrison","Garrison","Garrison","Garryowen","Garvin","Garwin","Garwood","Gary","Gary","Gary","Gary","Gary","Garysburg","Garyville","Gas","Gas City","Gasport","Gasquet","Gassaway","Gassville","Gaston","Gaston","Gaston","Gaston","Gastonia","Gastonville","Gate City","Gates","Gates","Gates Mills","Gatesville","Gateway","Gatlinburg","Gatzke","Gauley Bridge","Gause","Gautier","Gay","Gay","Gaylesville","Gaylord","Gaylord","Gaylordsville","Gays Creek","Gays Mills","Gazelle","Geary","Geff","Geigertown","Geismar","Genesee","Genesee","Genesee","Geneseo","Geneseo","Geneseo","Geneva","Geneva","Geneva","Geneva","Geneva","Geneva","Geneva","Geneva","Genoa","Genoa","Genoa","Genoa","Genoa","Genoa","Genoa","Genoa","Genoa City","Gentry","Gentry","Gentryville","George","George West","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgetown","Georgiana","Gerald","Geraldine","Geraldine","Gerber","Gering","Gerlach","German Valley","Germansville","Germanton","Germantown","Germantown","Germantown","Germantown","Germantown","Germantown","Germantown","Geronimo","Gerrardstown","Gerry","Gervais","Gettysburg","Gettysburg","Getzville","Geuda Springs","Geyser","Geyserville","Gheens","Ghent","Ghent","Ghent","Ghent","Gibbon","Gibbon","Gibbsboro","Gibbstown","Gibsland","Gibson","Gibson","Gibson","Gibson City","Gibsonburg","Gibsonia","Gibsonton","Gibsonville","Giddings","Gideon","Gifford","Gifford","Gig Harbor","Gila","Gila Bend","Gilbert","Gilbert","Gilbert","Gilbert","Gilbert","Gilbert","Gilbertown","Gilberts","Gilbertsville","Gilbertsville","Gilbertsville","Gilbertville","Gilbertville","Gilboa","Gilby","Gilcrest","Gilford","Gill","Gill","Gillespie","Gillett","Gillett","Gillett Grove","Gillette","Gillette","Gillham","Gillsville","Gilman","Gilman","Gilman","Gilman","Gilman City","Gilmanton","Gilmanton","Gilmanton Ironworks","Gilmer","Gilmore City","Gilroy","Gilson","Gilsum","Giltner","Girard","Girard","Girard","Girard","Girardville","Girdwood","Girvin","Gladbrook","Glade Spring","Glade Valley","Gladehill","Gladewater","Gladstone","Gladstone","Gladstone","Gladstone","Gladwin","Gladwyne","Gladys","Glasco","Glasco","Glasford","Glasgow","Glasgow","Glasgow","Glasgow","Glassboro","Glassport","Glastonbury","Gleason","Gleason","Glen Allan","Glen Allen","Glen Arbor","Glen Arm","Glen Burnie","Glen Campbell","Glen Carbon","Glen Cove","Glen Daniel","Glen Easton","Glen Elder","Glen Ellen","Glen Ellyn","Glen Flora","Glen Fork","Glen Gardner","Glen Head","Glen Hope","Glen Lyon","Glen Mills","Glen Oaks","Glen Ridge","Glen Rock","Glen Rock","Glen Rose","Glen Saint Mary","Glen Spey","Glen Ullin","Glenallen","Glenbeulah","Glenbrook","Glenburn","Glencoe","Glencoe","Glencoe","Glencoe","Glencoe","Glendale","Glendale","Glendale","Glendale","Glendale","Glendale","Glendale","Glendale","Glendale Heights","Glendive","Glendo","Glendora","Glendora","Glenelg","Glenfield","Glenford","Glengary","Glenham","Glenmont","Glenmont","Glenmoore","Glenmora","Glenn","Glenn Dale","Glenns Ferry","Glennville","Glennville","Glenolden","Glenpool","Glenrock","Glens","Glens Falls","Glens Fork","Glenshaw","Glenside","Glenview","Glenvil","Glenville","Glenville","Glenville","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood","Glenwood City","Glenwood Landing","Glenwood Springs","Glidden","Glidden","Glidden","Globe","Glorieta","Gloster","Gloster","Gloucester","Gloucester","Gloucester City","Gloucester Point","Glouster","Glover","Gloversville","Glyndon","Gobles","Goddard","Godfrey","Godley","Godwin","Goehner","Goessel","Goff","Goffstown","Golconda","Gold Bar","Gold Beach","Gold Canyon","Gold Hill","Gold Hill","Golden","Golden","Golden","Golden","Golden City","Golden Eagle","Golden Meadow","Golden Valley","Golden Valley","Goldendale","Goldenrod","Goldens Bridge","Goldfield","Goldonna","Goldsboro","Goldsboro","Goldsmith","Goldston","Goldthwaite","Goldvein","Goleta","Goliad","Goltry","Gonvick","Gonzales","Gonzales","Gonzales","Goochland","Good Hope","Good Hope","Good Thunder","Goode","Goodells","Goodfield","Goodhue","Gooding","Goodland","Goodland","Goodland","Goodland","Goodlettsville","Goodman","Goodnews Bay","Goodrich","Goodrich","Goodridge","Goodview","Goodwater","Goodwell","Goodyear","Goose Creek","Gordo","Gordon","Gordon","Gordon","Gordon","Gordon","Gordonsville","Gordonsville","Gordonville","Gordonville","Gore","Gore","Gore Springs","Goreville","Gorham","Gorham","Gorin","Gorman","Goshen","Goshen","Goshen","Goshen","Goshen","Goshen","Goshen","Goshen","Goshen","Goshen","Goshen","Gosport","Gotha","Gotham","Gothenburg","Gould","Gouldsboro","Gouldsboro","Gouverneur","Gowanda","Gowen","Gower","Gowrie","Grabill","Grace","Grace City","Gracemont","Graceville","Graceville","Grady","Grady","Gradyville","Graettinger","Graford","Grafton","Grafton","Grafton","Grafton","Grafton","Grafton","Grafton","Grafton","Graham","Graham","Graham","Graham","Grain Valley","Grambling","Gramercy","Grammer","Grampian","Granada","Granada Hills","Granbury","Granby","Granby","Granby","Granby","Grand Bay","Grand Blanc","Grand Cane","Grand Canyon","Grand Coulee","Grand Forks","Grand Haven","Grand Island","Grand Island","Grand Island","Grand Isle","Grand Isle","Grand Junction","Grand Junction","Grand Junction","Grand Junction","Grand Lake","Grand Ledge","Grand Marais","Grand Marsh","Grand Meadow","Grand Mound","Grand Portage","Grand Prairie","Grand Rapids","Grand Rapids","Grand Rapids","Grand Ridge","Grand River","Grand River","Grand Rivers","Grand Ronde","Grand Saline","Grand Terrace","Grand Tower","Grand View","Grand View","Grandfalls","Grandfield","Grandin","Grandview","Grandview","Grandview","Grandview","Grandville","Grandy","Granger","Granger","Granger","Granger","Grangeville","Granite","Granite Bay","Granite City","Granite Falls","Granite Falls","Granite Falls","Granite Quarry","Graniteville","Graniteville","Grant","Grant","Grant","Grant","Grant","Grant City","Grant Park","Grantham","Granton","Grants","Grants Pass","Grantsboro","Grantsburg","Grantsville","Grantsville","Grantsville","Grantville","Grantville","Granville","Granville","Granville","Granville","Granville","Granville","Granville","Granville Summit","Grapeland","Grapeview","Grapevine","Grapevine","Grasonville","Grass Lake","Grass Valley","Grass Valley","Grassflat","Grassy Creek","Grassy Meadows","Gratiot","Gratis","Graton","Gratz","Gravel Switch","Gravelly","Gravette","Gravity","Gravois Mills","Grawn","Gray","Gray","Gray","Gray","Gray","Gray Court","Gray Summit","Grayland","Grayling","Grayslake","Grayson","Grayson","Grayson","Graysville","Graysville","Graysville","Graytown","Grayville","Great Barrington","Great Bend","Great Bend","Great Cacapon","Great Falls","Great Falls","Great Falls","Great Lakes","Great Meadows","Great Mills","Great Neck","Great River","Greater Capitol Heights","Greeley","Greeley","Greeley","Greeley","Greeley","Greeleyville","Green","Green","Green Bank","Green Bay","Green Castle","Green City","Green Cove Springs","Green Forest","Green Isle","Green Lake","Green Lane","Green Mountain","Green Mountain Falls","Green Pond","Green River","Green River","Green Sea","Green Springs","Green Valley","Green Valley","Green Village","Greenacres","Greenback","Greenbackville","Greenbank","Greenbelt","Greenbrae","Greenbrier","Greenbrier","Greenbush","Greenbush","Greenbush","Greenbush","Greencastle","Greencastle","Greendale","Greene","Greene","Greene","Greene","Greeneville","Greenfield","Greenfield","Greenfield","Greenfield","Greenfield","Greenfield","Greenfield","Greenfield","Greenfield","Greenland","Greenland","Greenlawn","Greenleaf","Greenleaf","Greenock","Greenport","Greens Farms","Greensboro","Greensboro","Greensboro","Greensboro","Greensboro","Greensburg","Greensburg","Greensburg","Greensburg","Greensburg","Greentop","Greentown","Greentown","Greenup","Greenup","Greenvale","Greenview","Greenview","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenville","Greenway Downs","Greenwell Springs","Greenwich","Greenwich","Greenwich","Greenwich","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood","Greenwood Lake","Greenwood Springs","Greenwood Village","Greer","Gregory","Gregory","Gregory","Grelton","Grenada","Grenloch","Grenville","Gresham","Gresham","Gresham","Grethel","Gretna","Gretna","Gretna","Gretna","Grey Eagle","Greybull","Greycliff","Gridley","Gridley","Griffin","Griffith","Griffithsville","Griffithville","Grifton","Griggsville","Grimes","Grimesland","Grimsley","Grindstone","Grinnell","Grinnell","Griswold","Groesbeck","Groom","Grosse Ile","Grosse Pointe","Grosse Tete","Grosvenor Dale","Groton","Groton","Groton","Groton","Groton","Grottoes","Grouse Creek","Grove","Grove City","Grove City","Grove Hill","Grove Oak","Groveland","Groveland","Groveland","Groveland","Groveport","Grover","Grover","Grover","Grover Beach","Grover Hill","Grovertown","Groves","Groveton","Groveton","Grovetown","Gruetli-Laager","Grundy","Grundy Center","Gruver","Grygla","Guadalupe","Gualala","Guatay","Guerneville","Guernsey","Gueydan","Guffey","Guide Rock","Guilderland","Guilford","Guilford","Guilford","Guilford","Guin","Guinda","Gulf Breeze","Gulf Shores","Gulfport","Gully","Gum Spring","Gunlock","Gunlock","Gunnison","Gunnison","Gunnison","Gunpowder","Gunter","Guntersville","Guntown","Gurley","Gurley","Gurnee","Gustine","Gustine","Guston","Guthrie","Guthrie","Guthrie Center","Guttenberg","Guy","Guy","Guymon","Guys","Guys Mills","Guysville","Guyton","Gwinn","Gwinner","Gwynedd","Gwynedd Valley","Gwynn Oak","Gypsum","Gypsum","Gypsy","Hacienda Heights","Hackberry","Hackensack","Hackensack","Hackett","Hackettstown","Haddam","Haddam","Haddock","Haddon Heights","Haddonfield","Hadley","Hadley","Hadley","Hadlyme","Hagan","Hager City","Hagerhill","Hagerman","Hagerman","Hagerstown","Hagerstown","Hahira","Hahnville","Haigler","Hailey","Haines","Haines","Haines City","Hainesport","Hakalau","Halbur","Hale","Hale","Haledon","Hales Corners","Halethorpe","Haleyville","Half Moon Bay","Halfway","Halfway","Halifax","Halifax","Halifax","Halifax","Hall","Hallam","Hallandale","Hallett","Hallettsville","Halliday","Hallie","Hallieford","Hallock","Hallowell","Halls","Hallstead","Hallsville","Hallsville","Halltown","Hallwood","Halma","Halsey","Halstad","Halstead","Haltom City","Hambleton","Hamburg","Hamburg","Hamburg","Hamburg","Hamburg","Hamburg","Hamburg","Hamburg","Hamden","Hamden","Hamel","Hamel","Hamer","Hamer","Hamersville","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamilton","Hamler","Hamlet","Hamlet","Hamlin","Hamlin","Hamlin","Hamlin","Hamlin","Hammon","Hammond","Hammond","Hammond","Hammond","Hammond","Hammondsport","Hammonton","Hampden","Hampden","Hampden","Hampden Sydney","Hampshire","Hampstead","Hampstead","Hampstead","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton","Hampton Bays","Hampton Falls","Hamptonville","Hamtramck","Hana","Hanalei","Hanapepe","Hanceville","Hancock","Hancock","Hancock","Hancock","Hancock","Hancock","Hancock","Hancock","Hancock","Hancocks Bridge","Hanford","Hankamer","Hankinson","Hanksville","Hanley Falls","Hanlontown","Hanna","Hanna","Hanna City","Hannacroix","Hannah","Hannibal","Hannibal","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover","Hanover Park","Hanoverton","Hanska","Hanson","Hanson","Hansville","Happy","Happy","Happy Camp","Happy Jack","Happy Valley","Harbeson","Harbor Beach","Harbor City","Harbor Springs","Harborcreek","Harborside","Harborton","Hardeeville","Hardin","Hardin","Hardin","Hardin","Hardin","Hardinsburg","Hardinsburg","Hardtner","Hardwick","Hardwick","Hardwick","Hardy","Hardy","Hardy","Hardy","Hardyville","Hardyville","Harford","Harker Heights","Harlan","Harlan","Harlan","Harlem","Harlem","Harleton","Harleysville","Harlingen","Harlowton","Harmans","Harmon","Harmonsburg","Harmony","Harmony","Harmony","Harmony","Harned","Harold","Harper","Harper","Harper","Harper","Harper Woods","Harpers Ferry","Harpers Ferry","Harpersville","Harpster","Harpswell","Harpursville","Harrah","Harrah","Harrells","Harriet","Harrietta","Harriman","Harriman","Harrington","Harrington","Harrington","Harrington Park","Harris","Harrisburg","Harrisburg","Harrisburg","Harrisburg","Harrisburg","Harrisburg","Harrison","Harrison","Harrison","Harrison","Harrison","Harrison","Harrison","Harrison","Harrison","Harrison","Harrison City","Harrison Valley","Harrisonburg","Harrisonburg","Harrisonville","Harrisville","Harrisville","Harrisville","Harrisville","Harrisville","Harrisville","Harrisville","Harrod","Harrodsburg","Harrogate","Harrold","Harshaw","Hart","Hart","Hartfield","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford","Hartford City","Hartington","Hartland","Hartland","Hartland","Hartland","Hartland","Hartley","Hartley","Hartline","Hartly","Hartman","Harts","Hartsburg","Hartsdale","Hartsel","Hartselle","Hartsfield","Hartshorne","Hartstown","Hartsville","Hartsville","Hartsville","Hartville","Hartville","Hartville","Hartwell","Hartwick","Hartwood","Harvard","Harvard","Harvard","Harvest","Harvey","Harvey","Harvey","Harvey","Harveys Lake","Harveyville","Harviell","Harwich","Harwich Port","Harwick","Harwinton","Harwood","Harwood","Harwood Heights","Hasbrouck Heights","Haskell","Haskell","Haskell","Haskins","Haslet","Haslett","Hastings","Hastings","Hastings","Hastings","Hastings","Hastings","Hastings","Hastings-on-Hudson","Hasty","Hat Creek","Hatboro","Hatch","Hatfield","Hatfield","Hatfield","Hatfield","Hathaway Pines","Hathorne","Hatley","Hattiesburg","Hattieville","Haubstadt","Haughton","Hauppauge","Havana","Havana","Havana","Havana","Havelock","Havelock","Haven","Havensville","Haverford","Haverhill","Haverstraw","Havertown","Haviland","Haviland","Havre","Havre de Grace","Haw River","Hawaiian Gardens","Hawaiian Ocean View","Hawarden","Hawesville","Hawkeye","Hawkins","Hawkinsville","Hawley","Hawley","Hawley","Haworth","Haworth","Hawthorn","Hawthorne","Hawthorne","Hawthorne","Hawthorne","Hawthorne","Haxtun","Hay","Hay Springs","Hayden","Hayden","Hayden","Haydenville","Hayes","Hayesville","Hayfield","Hayfork","Haymarket","Haynesville","Haynesville","Hayneville","Hays","Hays","Hays","Haysi","Haysville","Hayti","Hayti","Hayward","Hayward","Hazard","Hazel","Hazel","Hazel Crest","Hazel Green","Hazel Green","Hazel Green","Hazel Park","Hazelhurst","Hazelton","Hazelton","Hazelwood","Hazen","Hazen","Hazlehurst","Hazlehurst","Hazlet","Hazleton","Hazleton","Hazleton","Head of Westport","Headland","Healdsburg","Healdton","Healy","Hearne","Heath","Heath","Heath Springs","Heathsville","Heavener","Hebbronville","Heber","Heber","Heber","Heber Springs","Hebron","Hebron","Hebron","Hebron","Hebron","Hebron","Hebron","Hebron","Hebron","Hebron","Hector","Hedgesville","Hedrick","Heflin","Hegins","Heidelberg","Heidrick","Heiskell","Helen","Helen","Helena","Helena","Helena","Helena","Helena","Helena","Helendale","Helenwood","Helix","Hellertown","Helmetta","Helotes","Helper","Helvetia","Hematite","Hemet","Hemingford","Hemingway","Hemlock","Hemlock","Hemphill","Hempstead","Hempstead","Henagar","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Henderson","Hendersonville","Hendersonville","Hendricks","Hendrix","Henefer","Hennepin","Hennessey","Henniker","Henning","Henning","Henrico","Henrietta","Henrietta","Henrietta","Henry","Henry","Henry","Henryetta","Henryville","Henryville","Hensley","Hensley","Hephzibah","Hepler","Heppner","Hepzibah","Herald","Herculaneum","Hercules","Hereford","Hereford","Hereford","Herington","Herkimer","Herlong","Herman","Hermann","Hermansville","Hermanville","Herminie","Hermiston","Hermitage","Hermitage","Hermitage","Hermon","Hermosa","Hermosa Beach","Hernando","Hernando","Herndon","Herndon","Hernshaw","Herod","Heron","Heron Lake","Herrick","Herrick","Herriman","Herrin","Hershey","Hershey","Hertford","Hesperia","Hesperia","Hesperus","Hessmer","Hesston","Hesston","Hettick","Hettinger","Heuvelton","Hewett","Hewitt","Hewitt","Hewitt","Hewitt","Hewlett","Heyburn","Heyworth","Hialeah","Hiawassee","Hiawatha","Hiawatha","Hibbing","Hibbs","Hickman","Hickman","Hickman","Hickman","Hickory","Hickory","Hickory","Hickory","Hickory Corners","Hickory Flat","Hickory Hills","Hickory Valley","Hicksville","Hicksville","Hico","Hico","Hidalgo","Hidalgo","Hidden Valley Lake","Hiddenite","Higden","Higdon","Higganum","Higgins","Higginsville","High Bridge","High Falls","High Island","High Point","High Ridge","High Springs","High View","Highland","Highland","Highland","Highland","Highland","Highland","Highland","Highland","Highland Falls","Highland Home","Highland Lakes","Highland Mills","Highland Park","Highland Park","Highland Park","Highland Springs","Highlands","Highlands","Highlands","Highlandville","Highmore","Highspire","Hightstown","Highwood","Highwood","Highwood","Higley","Hiko","Hilbert","Hildale","Hildebran","Hildreth","Hilham","Hill","Hill City","Hill City","Hill City","Hillburn","Hilliard","Hilliard","Hillister","Hillman","Hills","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsboro","Hillsborough","Hillsborough","Hillsborough","Hillsdale","Hillsdale","Hillsdale","Hillsdale","Hillsdale","Hillside","Hillside","Hillsville","Hilltop","Hillview","Hilmar","Hilo","Hilton","Hilton Head Island","Himrod","Hinckley","Hinckley","Hinckley","Hinckley","Hindman","Hindsboro","Hindsville","Hines","Hines","Hinesburg","Hinesville","Hingham","Hingham","Hinkley","Hinsdale","Hinsdale","Hinsdale","Hinton","Hinton","Hinton","Hinton","Hiram","Hiram","Hiram","Hitchcock","Hitterdal","Hiwasse","Hixson","Hixton","Ho-Ho-Kus","Hoagland","Hobart","Hobart","Hobart","Hobbs","Hobbsville","Hobe Sound","Hoboken","Hoboken","Hobson","Hobson","Hockessin","Hockley","Hodge","Hodgen","Hodgenville","Hodges","Hoffman","Hoffman","Hoffman Estates","Hogansburg","Hogansville","Hohenwald","Hoisington","Hokah","Holabird","Holbrook","Holbrook","Holbrook","Holbrook","Holcomb","Holcomb","Holcomb","Holcombe","Holden","Holden","Holden","Holden","Holden","Holden","Holdenville","Holderness","Holdingford","Holdrege","Holgate","Holiday","Holland","Holland","Holland","Holland","Holland","Holland","Holland","Holland Patent","Hollandale","Hollandale","Holley","Holliday","Holliday","Hollidaysburg","Hollis","Hollis","Hollis","Hollis Center","Hollister","Hollister","Holliston","Holloman Air Force Base","Hollow Rock","Holloway","Hollsopple","Holly","Holly","Holly Grove","Holly Hill","Holly Pond","Holly Ridge","Holly Springs","Holly Springs","Holly Springs","Hollywood","Hollywood","Hollywood","Hollywood","Holmdel","Holmen","Holmes","Holmes","Holmesville","Holstein","Holt","Holt","Holt","Holton","Holton","Holton","Holts Summit","Holtsville","Holtville","Holtwood","Holualoa","Holy Cross","Holyoke","Holyoke","Holyrood","Home","Home","Homedale","Homeland","Homer","Homer","Homer","Homer","Homer","Homer","Homer City","Homer Glen","Homerville","Homerville","Homestead","Homestead","Homestead","Homestead","Hometown","Homewood","Homewood","Homeworth","Hominy","Homosassa","Honaker","Honaunau","Hondo","Hondo","Honea Path","Honeoye","Honeoye Falls","Honesdale","Honey Brook","Honey Creek","Honey Grove","Honeydew","Honeyville","Honolulu","Honor","Hood River","Hoodsport","Hooker","Hooks","Hooksett","Hookstown","Hooper","Hooper","Hooper Bay","Hoopeston","Hoople","Hoosick","Hoosick Falls","Hooversville","Hop Bottom","Hopatcong","Hope","Hope","Hope","Hope","Hope","Hope","Hope","Hope Hull","Hope Mills","Hope Valley","Hopedale","Hopedale","Hopedale","Hopewell","Hopewell","Hopewell","Hopewell Junction","Hopkins","Hopkins","Hopkins","Hopkins","Hopkinsville","Hopkinton","Hopkinton","Hopkinton","Hopland","Hopwood","Hoquiam","Horatio","Horicon","Horn Lake","Hornbeak","Hornbeck","Hornell","Horner","Hornick","Horntown","Horse Branch","Horse Cave","Horse Shoe","Horseheads","Horseshoe Bay","Horseshoe Bend","Horseshoe Bend","Horsham","Hortense","Horton","Horton","Horton","Hortonville","Hoschton","Hosford","Hoskins","Hoskinston","Hosmer","Hospers","Hosston","Hostetter","Hot Springs","Hot Springs","Hot Springs","Hot Springs National Park","Hot Springs Village","Hotchkiss","Houghton","Houghton","Houghton","Houghton Lake","Houlka","Houlton","Houlton","Houma","House Springs","Houston","Houston","Houston","Houston","Houston","Houston","Houston","Houston","Houston","Houtzdale","Hoven","Hovland","Howard","Howard","Howard","Howard","Howard","Howard Beach","Howard City","Howard Lake","Howardsville","Howe","Howe","Howe","Howell","Howell","Howes Cave","Howie In The Hills","Howland","Hoxie","Hoxie","Hoyleton","Hoyt","Hoyt Lakes","Huachuca City","Hubbard","Hubbard","Hubbard","Hubbard","Hubbard","Hubbard Lake","Hubbardston","Hubbardsville","Hubbell","Hubert","Hubertus","Huddleston","Huddy","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson","Hudson Falls","Hudsonville","Huffman","Huger","Hughes","Hughes Springs","Hugheston","Hughesville","Hughesville","Hughesville","Hughson","Hugo","Hugo","Hugo","Hugoton","Hulbert","Hulett","Hull","Hull","Hull","Hull","Hull","Humansville","Humarock","Humbird","Humble","Humboldt","Humboldt","Humboldt","Humboldt","Humboldt","Hume","Humeston","Hummelstown","Humphrey","Humphrey","Hundred","Hungerford","Hunker","Hunlock Creek","Hunt","Hunt","Hunt Valley","Hunter","Huntersville","Huntertown","Huntingburg","Huntingdon","Huntingdon","Huntingdon Valley","Huntington","Huntington","Huntington","Huntington","Huntington","Huntington","Huntington","Huntington","Huntington Beach","Huntington Mills","Huntington Park","Huntington Station","Huntington Woods","Huntingtown","Huntland","Huntley","Huntsburg","Huntsville","Huntsville","Huntsville","Huntsville","Huntsville","Huntsville","Huntsville","Hurdland","Hurdle Mills","Hurley","Hurley","Hurleyville","Hurlock","Huron","Huron","Huron","Huron","Hurricane","Hurricane","Hurst","Hurst","Hurt","Hurtsboro","Huson","Hustisford","Hustler","Hustontown","Hustonville","Husum","Hutchins","Hutchinson","Hutchinson","Huttig","Hutto","Huttonsville","Huxley","Hyampom","Hyannis","Hyannis","Hyattsville","Hyde","Hyde Park","Hyde Park","Hyde Park","Hyde Park","Hyden","Hydes","Hydesville","Hydeville","Hydro","Hygiene","Hymera","Hyndman","Hyrum","Hysham","Iaeger","Iberia","Ickesburg","Ida","Ida","Ida Grove","Idabel","Idaho Falls","Idaho Springs","Idalia","Idalou","Idaville","Ider","Idledale","Idyllwild","Ignacio","Igo","Ijamsville","Iliff","Ilion","Imlay City","Imler","Immaculata","Immokalee","Imogene","Imperial","Imperial","Imperial","Imperial","Imperial","Imperial Beach","Ina","Inchelium","Incline Village","Independence","Independence","Independence","Independence","Independence","Independence","Independence","Independence","Independence","Independence","Independence","India","Indialantic","Indian Head","Indian Head","Indian Hills","Indian Lake","Indian Mound","Indian Orchard","Indian River","Indian Rocks Beach","Indian Trail","Indian Wells","Indiana","Indianapolis","Indianola","Indianola","Indianola","Indianola","Indianola","Indianola","Indiantown","Indio","Industry","Industry","Industry","Inez","Inez","Ingalls","Ingleside","Ingleside","Inglewood","Inglis","Ingomar","Ingraham","Ingram","Inkom","Inkster","Inland","Inman","Inman","Inman","Inola","Institute","Institute","Intercession City","Intercourse","Interlachen","Interlaken","Interlochen","International Falls","Inver Grove Heights","Inverness","Inverness","Inverness","Inverness","Inwood","Inwood","Inwood","Inyokern","Iola","Iola","Iola","Ione","Ione","Ionia","Ionia","Ionia","Iota","Iowa","Iowa City","Iowa Falls","Iowa Park","Ipswich","Ipswich","Iraan","Irasburg","Iredell","Ireland","Irene","Ireton","Irma","Irmo","Iron City","Iron Junction","Iron Mountain","Iron Ridge","Iron River","Iron River","Iron Station","Irons","Ironton","Ironton","Ironton","Ironwood","Iroquois","Iroquois","Irrigon","Irvine","Irvine","Irving","Irving","Irving","Irvington","Irvington","Irvington","Irvington","Irvington","Irvington","Irwin","Irwin","Irwinton","Isabel","Isabel","Isabella","Isanti","Iselin","Ishpeming","Islamorada","Island","Island Falls","Island Heights","Island Lake","Island Park","Islandia","Islandton","Isle","Isle of Palms","Isle of Wight","Islesboro","Islesford","Isleta","Isleton","Islip","Islip Terrace","Ismay","Issaquah","Italia","Italy","Itasca","Ithaca","Ithaca","Ithaca","Itmann","Itta Bena","Iuka","Iuka","Iva","Ivanhoe","Ivanhoe","Ivanhoe","Ivanhoe","Ivel","Ivins","Ivor","Ivoryton","Ivydale","Ixonia","Jack","Jackpot","Jacks Creek","Jacksboro","Jacksboro","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson","Jackson Center","Jackson Heights","Jackson Township","Jacksonboro","Jacksonburg","Jacksons Gap","Jacksonville","Jacksonville","Jacksonville","Jacksonville","Jacksonville","Jacksonville","Jacksonville","Jacksonville","Jacksonville","Jacksonville Beach","Jacobs Creek","Jacobsburg","Jacobson","Jacumba Hot Springs","Jaffrey","Jal","Jamaica","Jamaica","Jamaica Plain","Jameson","Jamesport","Jamesport","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamestown","Jamesville","Jamison","Jamul","Jane Lew","Janesville","Janesville","Janesville","Janesville","Jaroso","Jarreau","Jarrell","Jarrettsville","Jarvisburg","Jasonville","Jasper","Jasper","Jasper","Jasper","Jasper","Jasper","Jasper","Jasper","Jasper","Jasper","Jasper","Jay","Jay","Jay","Jay","Jayess","Jayton","Jean","Jeanerette","Jeannette","Jeddo","Jeff","Jeffers","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson","Jefferson City","Jefferson City","Jefferson City","Jefferson Valley","Jeffersonton","Jeffersonville","Jeffersonville","Jeffersonville","Jeffersonville","Jeffersonville","Jeffrey","Jekyll Island","Jellico","Jemez Pueblo","Jemez Springs","Jemison","Jena","Jenison","Jenkins","Jenkinsburg","Jenkinsville","Jenkintown","Jenks","Jenner","Jennerstown","Jennings","Jennings","Jensen Beach","Jeremiah","Jericho","Jericho","Jerico Springs","Jermyn","Jerome","Jerome","Jersey","Jersey City","Jersey Shore","Jerseyville","Jerusalem","Jessup","Jessup","Jesup","Jesup","Jet","Jetersville","Jetmore","Jewell","Jewell","Jewell","Jewett","Jewett","Jewett","Jewett City","Jim Falls","Jim Thorpe","Joanna","Joaquin","Jobstown","Joelton","Joes","Johannesburg","John Day","Johns Island","Johnson","Johnson","Johnson","Johnson","Johnson City","Johnson City","Johnson City","Johnson Creek","Johnsonburg","Johnsonville","Johnsonville","Johnston","Johnston","Johnston","Johnston City","Johnstown","Johnstown","Johnstown","Johnstown","Johnstown","Joice","Joiner","Joliet","Joliet","Jolon","Jones","Jones","Jonesboro","Jonesboro","Jonesboro","Jonesboro","Jonesboro","Jonesboro","Jonesborough","Jonesburg","Jonesport","Jonestown","Jonestown","Jonesville","Jonesville","Jonesville","Jonesville","Jonesville","Jonesville","Joplin","Joplin","Joppa","Joppa","Joppa","Jordan","Jordan","Jordan","Jordan Valley","Joseph","Joseph","Josephine","Josephine","Joshua","Joshua Tree","Jourdanton","Joy","Jud","Juda","Judith Gap","Judsonia","Julesburg","Juliaetta","Julian","Julian","Julian","Julian","Juliette","Jumping Branch","Junction","Junction","Junction City","Junction City","Junction City","Junction City","Junction City","June Lake","Juneau","Juneau","Juniata","Junior","Juno Beach","Jupiter","Justice","Justice","Justin","Kadoka","Kahoka","Kahuku","Kahului","Kailua","Kailua","Kaiser","Kake","Kaktovik","Kalaheo","Kalama","Kalamazoo","Kaleva","Kalida","Kalispell","Kalkaska","Kalona","Kalskag","Kamas","Kamiah","Kampsville","Kanab","Kanawha","Kandiyohi","Kane","Kaneville","Kankakee","Kannapolis","Kanopolis","Kansas","Kansas","Kansas City","Kansas City","Kansasville","Kapaau","Kaplan","Kapolei","Karlstad","Karnack","Karnak","Karnes City","Karns City","Karthaus","Karval","Kasota","Kasson","Kathleen","Katonah","Katy","Kaufman","Kaukauna","Kaumakani","Kaunakakai","Kauneonga Lake","Kaw City","Kaweah","Kawkawlin","Kaycee","Kayenta","Kaysville","Kealakekua","Keams Canyon","Keansburg","Kearney","Kearney","Kearneysville","Kearny","Kearny","Keasbey","Keatchie","Keauhou","Keavy","Kechi","Keedysville","Keego Harbor","Keene","Keene","Keene","Keene","Keene Valley","Keenesburg","Keeseville","Keewatin","Keezletown","Kegley","Keithville","Keizer","Kekaha","Kelayres","Kelford","Keller","Keller","Kellerton","Kelley","Kelliher","Kellogg","Kellogg","Kelly","Kellyton","Kellyville","Kelseyville","Kelso","Kelso","Kelso","Kemah","Kemmerer","Kemp","Kempner","Kempton","Kempton","Kempton","Kenai","Kenansville","Kenbridge","Kendalia","Kendall","Kendall Park","Kendallville","Kendrick","Kenduskeag","Kenedy","Kenesaw","Kenilworth","Kenilworth","Kenly","Kenmare","Kenmore","Kenna","Kennan","Kennard","Kennard","Kennebec","Kennebunk","Kennebunkport","Kennedale","Kennedy","Kennedy","Kennedy","Kennedyville","Kenner","Kennerdell","Kennesaw","Kennett","Kennett Square","Kennewick","Kenney","Kenney","Keno","Kenosha","Kenova","Kensett","Kensington","Kensington","Kensington","Kensington","Kent","Kent","Kent","Kent","Kent","Kent","Kent City","Kentfield","Kentland","Kenton","Kenton","Kents Hill","Kents Store","Kentwood","Kenvil","Kenyon","Keokuk","Keosauqua","Keota","Keota","Kerby","Kerens","Kerhonkson","Kerkhoven","Kerman","Kermit","Kermit","Kernersville","Kernville","Kerrick","Kerrville","Kersey","Kersey","Kershaw","Keshena","Keswick","Keswick","Ketchikan","Ketchum","Ketchum","Ketchum","Kettle Falls","Kettle Island","Kettleman City","Keuka Park","Kevil","Kevin","Kew Gardens","Kewadin","Kewanee","Kewanna","Kewaskum","Kewaunee","Key Biscayne","Key Largo","Key West","Keyes","Keyes","Keymar","Keyport","Keyport","Keyser","Keystone","Keystone","Keystone","Keystone Heights","Keysville","Keytesville","Kiamesha Lake","Kiana","Kiefer","Kiel","Kieler","Kiester","Kihei","Kila","Kilauea","Kilbourne","Kilbourne","Kilgore","Kilgore","Kilkenny","Kilkenny Township","Kill Devil Hills","Killbuck","Killdeer","Killeen","Killen","Killington","Killingworth","Kilmarnock","Kilmichael","Kiln","Kimball","Kimball","Kimball","Kimball","Kimballton","Kimberling City","Kimberly","Kimberly","Kimberly","Kimberly","Kimberton","Kimbolton","Kimmell","Kimper","Kincaid","Kincaid","Kincaid","Kinde","Kinder","Kinderhook","Kinderhook","Kindred","King","King","King and Queen Court House","King City","King City","King Cove","King George","King of Prussia","King Salmon","King William","Kingdom City","Kingfield","Kingfisher","Kingman","Kingman","Kings Bay Base","Kings Beach","Kings Mills","Kings Mountain","Kings Park","Kingsburg","Kingsbury","Kingsbury","Kingsford","Kingsland","Kingsland","Kingsley","Kingsley","Kingsley","Kingsport","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston","Kingston Springs","Kingstree","Kingsville","Kingsville","Kingsville","Kingsville","Kingwood","Kinmundy","Kinnear","Kinsley","Kinsman","Kinston","Kinston","Kinta","Kintnersville","Kintyre","Kinzers","Kiowa","Kiowa","Kiowa","Kipling","Kipnuk","Kirby","Kirbyville","Kirbyville","Kirk","Kirkland","Kirkland","Kirkland","Kirklin","Kirksey","Kirksville","Kirkville","Kirkville","Kirkwood","Kirkwood","Kirkwood","Kirkwood","Kiron","Kirtland","Kirwin","Kismet","Kissee Mills","Kissimmee","Kite","Kite","Kittanning","Kittery","Kittery Point","Kitts Hill","Kitty Hawk","Klamath","Klamath Falls","Klamath River","Klawock","Klemme","Knapp","Knife River","Knightdale","Knights Landing","Knightsen","Knightstown","Knightsville","Knippa","Knob Lick","Knob Noster","Knott","Knox","Knox","Knox City","Knox Dale","Knoxville","Knoxville","Knoxville","Knoxville","Knoxville","Knoxville","Kodak","Kodiak","Kohler","Kokomo","Kokomo","Koloa","Konawa","Kongiganak","Kooskia","Koppel","Kopperl","Kosciusko","Kotlik","Kountze","Kouts","Koyuk","Krakow","Kramer","Krebs","Kremmling","Krum","Kula","Kulm","Kulpmont","Kuna","Kunkletown","Kure Beach","Kurtistown","Kuttawa","Kutztown","Kwethluk","Kykotsmovi Village","Kyle","Kyle","Kyles Ford","La Barge","La Belle","La Belle","La Blanca","La Canada Flintridge","La Center","La Center","La Conner","La Crescent","La Crescenta","La Crosse","La Crosse","La Crosse","La Crosse","La Crosse","La Crosse","La Cygne","La Farge","La Fayette","La Feria","La Fontaine","La Fox","La Grande","La Grange","La Grange","La Grange","La Grange","La Grange","La Grange","La Grange Park","La Habra","La Harpe","La Harpe","La Honda","La Jara","La Jolla","La Joya","La Junta","La Luz","La Marque","La Mesa","La Mesa","La Mirada","La Moille","La Motte","La Palma","La Pine","La Plata","La Plata","La Pointe","La Porte","La Porte","La Porte City","La Prairie","La Pryor","La Puente","La Quinta","La Rue","La Sal","La Salle","La Salle","La Valle","La Vergne","La Verne","La Vernia","La Veta","La Vista","Labadie","Labadieville","LaBelle","LaBolt","Lac du Flambeau","Lacey","Laceys Spring","Laceyville","Lachine","Lackawaxen","Lackey","Lacombe","Lacon","Lacona","Lacona","Laconia","Laconia","Ladd","Laddonia","Ladera Ranch","Ladoga","Ladonia","Ladora","Ladson","Lady Lake","Ladysmith","Lafayette","Lafayette","Lafayette","Lafayette","Lafayette","Lafayette","Lafayette","LaFayette","Lafayette","LaFayette","Lafayette","Lafayette","Lafayette","Lafferty","Lafitte","LaFollette","Lagrange","Lagrange","Lagrangeville","Lagro","Laguna","Laguna Beach","Laguna Hills","Laguna Niguel","Laguna Woods","Lagunitas","Lahaina","Lahaska","Laingsburg","Lake","Lake","Lake","Lake Alfred","Lake Andes","Lake Ann","Lake Ariel","Lake Arrowhead","Lake Arthur","Lake Arthur","Lake Benton","Lake Bluff","Lake Bronson","Lake Buena Vista","Lake Butler","Lake Charles","Lake City","Lake City","Lake City","Lake City","Lake City","Lake City","Lake City","Lake City","Lake City","Lake Cormorant","Lake Crystal","Lake Dallas","Lake Delton","Lake Elmo","Lake Elsinore","Lake Forest","Lake Forest","Lake Geneva","Lake George","Lake Grove","Lake Hamilton","Lake Harmony","Lake Havasu City","Lake Helen","Lake Hiawatha","Lake Hopatcong","Lake Hughes","Lake in the Hills","Lake Isabella","Lake Jackson","Lake Junaluska","Lake Katrine","Lake Lillian","Lake Linden","Lake Lure","Lake Luzerne","Lake Lynn","Lake Mary","Lake Mills","Lake Mills","Lake Monroe","Lake Nebagamon","Lake Norden","Lake Odessa","Lake Orion","Lake Oswego","Lake Ozark","Lake Panasoffkee","Lake Park","Lake Park","Lake Park","Lake Peekskill","Lake Placid","Lake Placid","Lake Pleasant","Lake Preston","Lake Providence","Lake Saint Louis","Lake Shasta","Lake Station","Lake Stevens","Lake Tomahawk","Lake Toxaway","Lake View","Lake View","Lake Villa","Lake Village","Lake Village","Lake Waccamaw","Lake Wales","Lake Wilson","Lake Winola","Lake Worth","Lake Zurich","Lakebay","Lakefield","Lakehead","Lakehurst","Lakeland","Lakeland","Lakeland","Lakemont","Lakemore","Lakeport","Lakeside","Lakeside","Lakeside","Lakeside","Lakeside","Lakeside","Lakeside","Laketown","Lakeview","Lakeview","Lakeview","Lakeview","Lakeview","Lakeville","Lakeville","Lakeville","Lakeville","Lakeville","Lakeville","Lakeville","Lakewood","Lakewood","Lakewood","Lakewood","Lakewood","Lakewood","Lakewood","Lakewood","Lakin","Lakota","Lakota","Lamar","Lamar","Lamar","Lamar","Lamar","Lamar","Lambert","Lamberton","Lambertville","Lambertville","Lambsburg","Lame Deer","Lamesa","Lamoni","Lamont","Lamont","Lamont","LaMoure","Lampasas","Lamy","Lanai","Lanark","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancaster","Lancing","Landenberg","Lander","Landing","Landis","Landisburg","Landisville","Landisville","Landrum","Lanesboro","Lanesville","Lanett","Laneville","Lanexa","Langdon","Langeloth","Langford","Langhorne","Langley","Langley","Langley","Langston","Langsville","Lanham","Lanoka Harbor","Lansdale","Lansdowne","Lanse","Lansford","Lansford","Lansing","Lansing","Lansing","Lansing","Lansing","Lansing","Lansing","Lantry","Laona","Laotto","Lapeer","Lapel","Lapine","Laplace","Laporte","Laporte","Lapwai","Laquey","Laramie","Larchmont","Larchwood","Laredo","Largo","Larimore","Larkspur","Larkspur","Larned","Larose","Las Animas","Las Cruces","Las Vegas","Las Vegas","LaSalle","Lascassas","Latexo","Latham","Latham","Latham","Lathrop","Lathrop","Latimer","Laton","Latonia","Latrobe","Latta","Lattimer","Lattimore","Lauderdale","Laughlin","Laughlintown","Laura","Laurel","Laurel","Laurel","Laurel","Laurel","Laurel","Laurel","Laurel","Laurel Hill","Laurel Hill","Laurel Springs","Laurelton","Laurelville","Laurens","Laurens","Laurens","Laurinburg","Laurys Station","Lavaca","Lavalette","Lavallette","Laveen","LaVerkin","Laverne","Lavon","Lavonia","Lawler","Lawn","Lawndale","Lawndale","Lawnside","Lawrence","Lawrence","Lawrence","Lawrence","Lawrence","Lawrenceburg","Lawrenceburg","Lawrenceburg","Lawrenceville","Lawrenceville","Lawrenceville","Lawrenceville","Lawson","Lawton","Lawton","Lawton","Lawton","Layton","Laytonville","Le Center","Le Grand","Le Mars","Le Raysville","Le Roy","Le Roy","Le Roy","Le Roy","Le Sueur","Lead","Lead Hill","Leadville","Leadwood","Leaf River","League City","Leakesville","Leakey","Leander","Leary","Leavenworth","Leavenworth","Leavenworth","Leavittsburg","Leawood","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon","Lebanon Junction","Lebec","Lebo","Leburn","Lecanto","LeClaire","Lecompte","Lecompton","Ledbetter","Ledbetter","Lederach","Ledgewood","Ledyard","Ledyard Center","Lee","Lee","Lee","Lee","Lee Center","Leechburg","Leedey","Leeds","Leeds","Leeds","Leeds","Leeds","Leeds","Leeper","Leesburg","Leesburg","Leesburg","Leesburg","Leesburg","Leesburg","Leesburg","Leesburg","Leesport","Leesville","Leesville","Leeton","Leetonia","Leetsdale","Lefor","Lefors","Lehi","Lehigh","Lehigh Acres","Lehighton","Lehman","Lehr","Leicester","Leicester","Leicester","Leigh","Leighton","Leighton","Leipsic","Leitchfield","Leland","Leland","Leland","Leland","Leland","Lemasters","Lemmon","Lemon Grove","Lemont","Lemont","Lemont Furnace","Lemoore","Lemoyne","Lemoyne","Lempster","Lena","Lena","Lena","Lena","Lenapah","Lenexa","Lengby","Lenhartsville","Lenni","Lennon","Lennox","Lenoir","Lenoir City","Lenora","Lenore","Lenore","Lenox","Lenox","Lenox","Leo","Leola","Leola","Leoma","Leominster","Leon","Leon","Leon","Leon","Leona","Leonard","Leonard","Leonard","Leonard","Leonardo","Leonardsville","Leonardtown","Leonardville","Leonia","Leonidas","Leonore","Leonville","Leopold","Leopold","Leopolis","Leoti","Lepanto","Lerna","LeRoy","LeRoy","Leroy","Lesage","Leslie","Leslie","Leslie","Leslie","Lester","Lester","Lester Prairie","Lesterville","Letart","Letohatchee","Letts","Levan","Levant","Levelland","Levelock","Levels","Leverett","Levering","Levittown","Levittown","Lewellen","Lewes","Lewis","Lewis","Lewis","Lewis Center","Lewis Run","Lewisberry","Lewisburg","Lewisburg","Lewisburg","Lewisburg","Lewisburg","Lewisport","Lewiston","Lewiston","Lewiston","Lewiston","Lewiston","Lewiston","Lewiston","Lewiston Woodville","Lewistown","Lewistown","Lewistown","Lewistown","Lewisville","Lewisville","Lewisville","Lexa","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington","Lexington Park","Libby","Liberal","Liberal","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty","Liberty Center","Liberty Corner","Liberty Hill","Liberty Lake","Libertytown","Libertyville","Lick Creek","Licking","Lidgerwood","Liebenthal","Lignum","Ligonier","Ligonier","Lihue","Likely","Lilburn","Lilesville","Lillian","Lillington","Lilliwaup","Lilly","Lily Dale","Lima","Lima","Lime Ridge","Lime Springs","Limerick","Limestone","Limestone","Limestone","Limington","Limon","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln","Lincoln City","Lincoln Park","Lincoln Park","Lincolndale","Lincolnshire","Lincolnton","Lincolnton","Lincolnville","Lincolnville","Lincolnville Center","Lincolnwood","Lincroft","Lindale","Lindale","Linden","Linden","Linden","Linden","Linden","Linden","Linden","Linden","Linden","Linden","Linden","Lindenhurst","Lindley","Lindon","Lindsay","Lindsay","Lindsay","Lindsay","Lindsborg","Lindside","Lindstrom","Linesville","Lineville","Lineville","Linkwood","Linn","Linn","Linn Creek","Linneus","Linthicum Heights","Linton","Linton","Linville","Linville","Linwood","Linwood","Linwood","Linwood","Linwood","Linwood","Lipan","Lisbon","Lisbon","Lisbon","Lisbon","Lisbon","Lisbon","Lisbon","Lisbon Falls","Liscomb","Lisle","Lisle","Lismore","Listie","Litchfield","Litchfield","Litchfield","Litchfield","Litchfield","Litchfield","Litchfield","Litchfield Park","Litchfield Plains","Lithia","Lithia Springs","Lithonia","Lithopolis","Lititz","Little America","Little Chute","Little Compton","Little Elm","Little Falls","Little Falls","Little Falls","Little Ferry","Little Hocking","Little Meadows","Little Mountain","Little Neck","Little River","Little River","Little River-Academy","Little Rock","Little Rock","Little Rock","Little Rock","Little Rock Air Force Base","Little Silver","Little Suamico","Little Valley","Littlefield","Littlefield","Littlefork","Littlerock","Littlestown","Littleton","Littleton","Littleton","Littleton","Littleton","Live Oak","Live Oak","Livermore","Livermore","Livermore","Livermore","Livermore Falls","Liverpool","Liverpool","Livingston","Livingston","Livingston","Livingston","Livingston","Livingston","Livingston","Livingston","Livingston","Livingston Manor","Livonia","Livonia","Livonia","Lizella","Lizton","Llano","Llano","Loa","Loachapoka","Loami","Lobelville","Local","Loch Sheldrake","Lock Haven","Lockbourne","Locke","Lockeford","Lockesburg","Lockhart","Lockney","Lockport","Lockport","Lockport","Lockwood","Lockwood","Loco","Locust","Locust Fork","Locust Gap","Locust Grove","Locust Grove","Locust Valley","Loda","Lodge","Lodge Grass","Lodi","Lodi","Lodi","Lodi","Lodi","Log Lane Village","Logan","Logan","Logan","Logan","Logan","Logan","Logan","Logandale","Logansport","Logansport","Loganton","Loganville","Loganville","Lohman","Lohn","Lolita","Lolo","Loma","Loma Linda","Lomax","Lombard","Lomira","Lomita","Lompoc","Lonaconing","London","London","London","London Mills","Londonderry","Londonderry","Londonderry","Lone Grove","Lone Jack","Lone Oak","Lone Pine","Lone Rock","Lone Rock","Lone Tree","Lone Wolf","Lonedell","Long Beach","Long Beach","Long Beach","Long Beach","Long Branch","Long Branch","Long Grove","Long Island","Long Island City","Long Lake","Long Lake","Long Lane","Long Pine","Long Pond","Long Prairie","Long Valley","Longboat Key","Longbranch","Longdale","Longmeadow","Longmont","Longport","Longs","Longton","Longview","Longview","Longville","Longwood","Lonoke","Lonsdale","Loogootee","Lookout","Lookout Mountain","Lookout Mountain","Loomis","Loomis","Loon Lake","Loop","Loose Creek","Lopez","Lorain","Loraine","Loranger","Lordsburg","Lore City","Lorena","Lorenzo","Loretto","Loretto","Loretto","Loretto","Lorimor","Loris","Lorman","Lorraine","Lorraine","Lorton","Los Alamitos","Los Alamos","Los Alamos","Los Altos","Los Altos Hills","Los Angeles","Los Banos","Los Fresnos","Los Gatos","Los Lunas","Los Molinos","Los Olivos","Los Osos","Losantville","Lost City","Lost Creek","Lost Creek","Lost Nation","Lost Springs","Lostant","Lostine","Lothian","Lott","Lottie","Lottsburg","Lotus","Loudon","Loudon","Loudonville","Louin","Louisa","Louisa","Louisburg","Louisburg","Louise","Louisiana","Louisville","Louisville","Louisville","Louisville","Louisville","Louisville","Louisville","Louisville","Louisville","Loup City","Lovejoy","Lovelady","Loveland","Loveland","Lovell","Lovell","Lovelock","Lovely","Loves Park","Lovettsville","Loveville","Lovilia","Loving","Lovingston","Lovington","Lovington","Low and Burbanks Grant","Low Moor","Lowber","Lowden","Lowell","Lowell","Lowell","Lowell","Lowell","Lowell","Lowell","Lowell","Lowell","Lowellville","Lower Brule","Lower Lake","Lower Salem","Lowgap","Lowman","Lowmansville","Lowndes","Lowndesboro","Lowry","Lowry City","Lowville","Loxahatchee Groves","Loxley","Loyal","Loyalhanna","Loyall","Loysville","Lu Verne","Lubbock","Lubec","Lucama","Lucan","Lucas","Lucas","Lucas","Lucasville","Lucedale","Lucerne","Lucerne","Lucerne Valley","Lucinda","Luck","Luckey","Ludington","Ludlow","Ludlow","Ludlow","Ludlow","Ludlow","Ludlow","Ludlow","Ludlow Falls","Ludowici","Lueders","Lufkin","Lugoff","Lula","Luling","Luling","Lumberport","Lumberton","Lumberton","Lumberton","Lumberton","Lumberville","Lummi Island","Lumpkin","Luna Pier","Lund","Lunenburg","Lupton City","Luray","Luray","Luray","Lusby","Lusk","Lutcher","Luther","Luthersburg","Luthersville","Lutherville-Timonium","Lutsen","Luttrell","Lutz","Luverne","Luverne","Luxemburg","Luxor","Luxora","Luzerne","Lydia","Lyerly","Lykens","Lyle","Lyle","Lyles","Lyman","Lyman","Lyman","Lyman","Lyme","Lynbrook","Lynch","Lynch","Lynch Station","Lynchburg","Lynchburg","Lynchburg","Lynchburg","Lynco","Lynd","Lyndeborough","Lynden","Lyndhurst","Lyndhurst","Lyndon","Lyndon","Lyndon Center","Lyndon Station","Lyndonville","Lyndonville","Lynn","Lynn","Lynn","Lynn","Lynn Center","Lynn Haven","Lynnfield","Lynnville","Lynnville","Lynnville","Lynnwood","Lynwood","Lyon","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lyons","Lytle","Lytle Creek","Mabank","Mabel","Mabelvale","Maben","Mableton","Mabton","Macclenny","Macclesfield","Macdoel","Macedon","Macedonia","Macfarlan","Machesney Park","Machias","Machias","Machiasport","Mackay","Mackinac Island","Mackinaw","Mackinaw City","Macksburg","Macomb","Macomb","Macomb","Macomb","Macon","Macon","Macon","Macon","Macungie","Mad River","Madawaska","Madbury","Maddock","Madelia","Madera","Madera","Madill","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison","Madison Heights","Madison Heights","Madison Lake","Madisonville","Madisonville","Madisonville","Madisonville","Madras","Madrid","Madrid","Magalia","Magazine","Magdalena","Magee","Maggie Valley","Magna","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia","Magnolia Springs","Mahaffey","Mahanoy City","Mahaska","Mahnomen","Mahomet","Mahopac","Mahwah","Maiden","Maiden Rock","Maidens","Maidsville","Mainesburg","Maineville","Maitland","Maize","Makanda","Makawao","Makinen","Malabar","Malad City","Malaga","Malaga","Malakoff","Malcom","Malden","Malden","Malden","Malibu","Malin","Malinta","Mallory","Malmo","Malone","Malone","Malone","Malott","Malta","Malta","Malta","Malta","Malvern","Malvern","Malvern","Malvern","Malverne","Mamaroneck","Mammoth","Mammoth Lakes","Mamou","Man","Manahawkin","Manasquan","Manassas","Manassas Park","Manawa","Mancelona","Manchaca","Manchaug","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester","Manchester Center","Manchester Township","Manchester-by-the-Sea","Mancos","Mandan","Mandaree","Manderson","Manderson","Mandeville","Mangum","Manhasset","Manhattan","Manhattan","Manhattan","Manhattan Beach","Manheim","Manila","Manila","Manistee","Manistique","Manito","Manitou","Manitou Springs","Manitowoc","Mankato","Mankato","Manlius","Manlius","Manly","Mannford","Manning","Manning","Manning","Mannington","Manns Choice","Mannsville","Manokotak","Manomet","Manor","Manor","Manorville","Manorville","Manquin","Mansfield","Mansfield","Mansfield","Mansfield","Mansfield","Mansfield","Mansfield","Mansfield","Mansfield Center","Mansfield Depot","Manson","Manson","Mansura","Mantachie","Manteca","Mantee","Manteno","Manteo","Manti","Mantoloking","Manton","Mantorville","Mantua","Mantua","Mantua","Manvel","Manvel","Manville","Manville","Many","Many Farms","Manzanita","Manzanola","Maple City","Maple Falls","Maple Grove","Maple Heights","Maple Hill","Maple Lake","Maple Park","Maple Plain","Maple Rapids","Maple Shade","Maple Valley","Maplesville","Mapleton","Mapleton","Mapleton","Mapleton","Mapleton","Mapleville","Maplewood","Mappsville","Maquoketa","Marana","Marathon","Marathon","Marathon","Marathon","Marble","Marble Falls","Marble Hill","Marble Rock","Marblehead","Marblehill","Marblemount","Marbury","Marbury","Marceline","Marcell","Marcellus","Marcellus","March Air Force Base","Marco Island","Marcus","Marcus Hook","Marcy","Mardela Springs","Marengo","Marengo","Marengo","Marengo","Marengo","Marenisco","Marfa","Margaret","Margaretville","Margate City","Maria Stein","Marianna","Marianna","Marianna","Maribel","Maricopa","Marienthal","Marienville","Marietta","Marietta","Marietta","Marietta","Marietta","Marietta","Marietta","Marietta","Marietta","Marina","Marina del Rey","Marine","Marine City","Marine on Saint Croix","Marinette","Maringouin","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion","Marion Center","Marion Heights","Marion Junction","Marionville","Marionville","Mariposa","Marissa","Mark Center","Marked Tree","Markesan","Markham","Markham","Markham","Markle","Markleeville","Markleville","Markleysburg","Marks","Marksville","Marlboro","Marlboro","Marlboro","Marlborough","Marlborough","Marlborough","Marlette","Marlin","Marlinton","Marlow","Marlton","Marmora","Marne","Maroa","Marquand","Marquette","Marquette","Marquette","Marquez","Marrero","Marriottsville","Mars","Mars Hill","Mars Hill","Marseilles","Marshall","Marshall","Marshall","Marshall","Marshall","Marshall","Marshall","Marshall","Marshall","Marshall","Marshall","Marshalls Creek","Marshalltown","Marshallville","Marshallville","Marshfield","Marshfield","Marshfield","Marshfield","Marshfield Hills","Marshville","Marsing","Marsteller","Marstons Mills","Mart","Martell","Martelle","Martha","Marthasville","Marthaville","Martin","Martin","Martin","Martin","Martin","Martin","Martindale","Martindale","Martinez","Martins Creek","Martins Ferry","Martinsburg","Martinsburg","Martinsdale","Martinsville","Martinsville","Martinsville","Martinsville","Martinsville","Martinsville","Martville","Mary Esther","Marydel","Marydel","Maryknoll","Maryland","Maryland Heights","Marylhurst","Maryneal","Marysvale","Marysville","Marysville","Marysville","Marysville","Marysville","Marysville","Marysville","Maryville","Maryville","Maryville","Mascot","Mascotte","Mascoutah","Mashantucket","Mashpee","Maskell","Mason","Mason","Mason","Mason","Mason","Mason","Mason","Mason City","Mason City","Masontown","Masontown","Masonville","Masonville","Maspeth","Mass City","Massapequa","Massapequa Park","Massena","Massena","Massey","Massillon","Mastic","Mastic Beach","Masury","Matamoras","Matawan","Matewan","Matfield Green","Mather Field","Mathews","Mathias","Mathis","Mathiston","Matinicus","Matoaka","Mattapan","Mattapoisett","Mattaponi","Mattawa","Mattawamkeag","Mattawan","Mattawana","Matteson","Matthews","Matthews","Matthews","Mattituck","Mattoon","Mauckport","Maud","Maud","Mauk","Mauldin","Maumee","Maumelle","Maunaloa","Maupin","Maurepas","Maurertown","Maurice","Maurice","Mauriceville","Maury","Maury City","Mauston","Max","Max Meadows","Maxatawny","Maxbass","Maxton","Maxwell","Maxwell","Maxwell","Maxwell","May","May Creek","Maybee","Maybrook","Mayer","Mayer","Mayesville","Mayetta","Mayfield","Mayfield","Mayfield","Mayfield","Mayflower","Maylene","Maynard","Maynard","Maynard","Maynardville","Mayo","Mayo","Mayo","Mayodan","Maypearl","Mayport","Mays Landing","Maysel","Maysville","Maysville","Maysville","Maysville","Maysville","Mayville","Mayville","Mayville","Mayville","Maywood","Maywood","Maywood","Maywood","Mazeppa","Mazomanie","Mazon","McAdoo","McAlester","McAlister","McAlisterville","McAllen","McAlpin","McArthur","McArthur","McBain","McBee","McCall","McCalla","McCamey","McCammon","McCaysville","McCleary","McClellan Park Census Designated Place","McClelland","McClellandtown","McClellanville","McCloud","McClure","McClure","McClusky","McColl","McComb","McComb","McConnells","McConnellsburg","McConnelsville","McCook","McCool","McCool Junction","McCordsville","McCormick","McCoy","McCune","McCurtain","McCutchenville","McDaniels","McDavid","McDermitt","McDermott","McDonald","McDonald","McDonald","McDonough","McDonough","McDowell","McElhattan","McEwen","McFall","McFarland","McFarland","McGaheysville","McGehee","McGraw","McGregor","McGregor","McGregor","McHenry","McHenry","McHenry","McHenry","McIntosh","McKean Township","McKee","McKees Rocks","McKeesport","McKenna","McKenzie","McKinleyville","McKinney","McLain","McLaughlin","McLean","McLean","McLean","McLeansboro","McLeansville","McLoud","McMechen","McMillan","McMinnville","McMinnville","McNabb","McNary","McNeal","McPherson","McQueeney","McRae","McSherrystown","McVeytown","McVille","Meacham","Mead","Mead","Mead","Meade","Meadow","Meadow","Meadow Bridge","Meadow Grove","Meadow Lands","Meadow Valley","Meadow Vista","Meadowlands","Meadows of Dan","Meadowview","Meadview","Meadville","Meadville","Meadville","Meally","Meansville","Mears","Mebane","Mecca","Mechanic Falls","Mechanicsburg","Mechanicsburg","Mechanicsburg","Mechanicsville","Mechanicsville","Mechanicsville","Mechanicsville","Mechanicville","Mecosta","Medanales","Medaryville","Medfield","Medford","Medford","Medford","Medford","Medford","Medford","Medford","Media","Mediapolis","Medical Lake","Medicine Lake","Medicine Lodge","Medicine Park","Medina","Medina","Medina","Medina","Medina","Medina","Medinah","Medon","Medora","Medora","Medora","Medway","Medway","Medway","Meeker","Meeker","Meeteetse","Meherrin","Mehoopany","Mekoryuk","Melba","Melbourne","Melbourne","Melbourne","Melbourne","Melbourne Beach","Melcher-Dallas","Melcroft","Melfa","Melissa","Mellen","Mellenville","Melrose","Melrose","Melrose","Melrose","Melrose","Melrose","Melrose Park","Melstone","Melville","Melville","Melvin","Melvin","Melvin","Melvindale","Memphis","Memphis","Memphis","Memphis","Memphis","Memphis","Mena","Menahga","Menan","Menard","Menasha","Mendenhall","Mendham","Mendocino","Mendon","Mendon","Mendon","Mendon","Mendon","Mendon","Mendota","Mendota","Menifee","Menlo","Menlo","Menlo","Menlo Park","Menno","Meno","Menominee","Menominee","Menomonee Falls","Mentone","Mentone","Mentor","Mentor","Mequon","Mer Rouge","Meraux","Merced","Mercedes","Mercer","Mercer","Mercer","Mercer Island","Mercersburg","Merchantville","Meredith","Mereta","Meriden","Meriden","Meriden","Meriden","Meridian","Meridian","Meridian","Meridian","Meridianville","Merino","Merion","Merit","Merkel","Merlin","Mermentau","Merna","Merrick","Merrifield","Merrifield","Merrill","Merrill","Merrill","Merrillan","Merrillville","Merrimac","Merrimac","Merrimack","Merriman","Merritt","Merritt Island","Merry Hill","Merry Point","Merryville","Merton","Mertzon","Mertztown","Mesa","Mesa","Mescalero","Meshoppen","Mesick","Mesilla","Mesilla Park","Mesquite","Mesquite","Metairie","Metaline Falls","Metamora","Metamora","Metamora","Metcalf","Methow","Methuen","Metlakatla","Metropolis","Metropolitan","Metter","Metuchen","Metz","Mexia","Mexico","Mexico","Mexico","Meyersdale","Mi-Wuk Village","Miami","Miami","Miami","Miami","Miami Beach","Miamisburg","Miamitown","Miamiville","Micanopy","Michie","Michigan Center","Michigan City","Michigantown","Mickleton","Mico","Micro","Middle Bass","Middle Granville","Middle Grove","Middle Haddam","Middle Island","Middle Point","Middle River","Middle River","Middle Village","Middleboro","Middlebourne","Middleburg","Middleburg","Middleburg","Middleburg","Middleburgh","Middlebury","Middlebury","Middlebury","Middlefield","Middlefield","Middleport","Middleport","Middleport","Middlesboro","Middlesex","Middlesex","Middlesex","Middleton","Middleton","Middleton","Middleton","Middleton","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown","Middletown Springs","Middleville","Midfield","Midkiff","Midland","Midland","Midland","Midland","Midland","Midland","Midland","Midland City","Midland Park","Midlothian","Midlothian","Midlothian","Midvale","Midvale","Midvale","Midville","Midway","Midway","Midway","Midway","Midway","Midway","Midway","Midway","Midway City","Midway Park","Midwest","Mifflin","Mifflinburg","Mifflintown","Mifflinville","Mikado","Milaca","Milam","Milan","Milan","Milan","Milan","Milan","Milan","Milan","Milan","Milan","Milan","Milan","Milano","Milbank","Milburn","Miles","Miles","Miles City","Milesburg","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford","Milford Center","Mililani Town","Mill City","Mill Creek","Mill Creek","Mill Hall","Mill Neck","Mill River","Mill Shoals","Mill Spring","Mill Valley","Milladore","Millboro","Millbrae","Millbrook","Millbrook","Millburn","Millbury","Millbury","Milldale","Milledgeville","Milledgeville","Millen","Miller","Miller","Miller Place","Millers Creek","Millersburg","Millersburg","Millersburg","Millersport","Millerstown","Millersview","Millersville","Millersville","Millerton","Millerton","Millfield","Millheim","Millican","Milligan","Milliken","Millington","Millington","Millington","Millington","Millington","Millinocket","Millis","Millmont","Millport","Millry","Mills","Mills River","Millsap","Millsboro","Millsboro","Millstadt","Millstone","Milltown","Milltown","Milltown","Millville","Millville","Millville","Millville","Millville","Millville","Millwood","Millwood","Millwood","Millwood","Millwood","Milmay","Milner","Milnesville","Milnor","Milo","Milo","Milpitas","Milroy","Milroy","Milroy","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton","Milton Mills","Milton-Freewater","Miltona","Miltonvale","Milwaukee","Milwaukie","Mimbres","Mims","Minburn","Minco","Minden","Minden","Minden","Minden","Minden City","Mine Hill","Mineola","Mineola","Mineral","Mineral","Mineral Bluff","Mineral City","Mineral Point","Mineral Ridge","Mineral Springs","Mineral Wells","Mineral Wells","Minersville","Minersville","Minerva","Minford","Mingo Junction","Minier","Minneapolis","Minneapolis","Minneola","Minneota","Minnesota Lake","Minnetonka","Minnewaukan","Minnie","Minoa","Minocqua","Minonk","Minooka","Minot","Minot","Minotola","Minster","Minto","Minturn","Mio","Mira Loma","Miramar","Miramar Beach","Miranda","Mishawaka","Mishicot","Mission","Mission","Mission","Mission Hill","Mission Hills","Mission Hills","Mission Viejo","Missoula","Missouri City","Missouri Valley","Mitchell","Mitchell","Mitchell","Mitchell","Mitchellville","Mize","Moab","Moapa","Moatsville","Moberly","Mobile","Mobridge","Moccasin","Mocksville","Modale","Modena","Modena","Modesto","Modoc","Modoc","Modoc","Mogadore","Mohave Valley","Mohawk","Mohawk","Mohawk","Mohegan Lake","Mohnton","Mohrsville","Mojave","Mokelumne Hill","Mokena","Molalla","Molena","Moline","Moline","Moline","Molino","Mollusk","Molt","Momence","Mona","Monaca","Monahans","Moncks Corner","Moncure","Mondamin","Mondovi","Monee","Monessen","Moneta","Monett","Monette","Monkton","Monmouth","Monmouth","Monmouth","Monmouth Beach","Monmouth Junction","Monon","Monona","Monongahela","Monponsett","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe","Monroe Center","Monroe City","Monroe City","Monroe Township","Monroeton","Monroeville","Monroeville","Monroeville","Monroeville","Monroeville","Monrovia","Monrovia","Monrovia","Monsey","Monson","Monson","Mont Belvieu","Mont Clare","Mont Vernon","Montague","Montague","Montague","Montague","Montandon","Montara","Montauk","Montclair","Montclair","Montclair","Monte Rio","Monte Vista","Monteagle","Montebello","Montegut","Montello","Monterey","Monterey","Monterey","Monterey","Monterey","Monterey County","Monterey Park","Monterville","Montesano","Montevallo","Montevideo","Monteview","Montezuma","Montezuma","Montezuma","Montezuma","Montezuma","Montezuma","Montfort","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery","Montgomery Center","Montgomery City","Montgomery Creek","Montgomery Village","Montgomeryville","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Monticello","Montour","Montour Falls","Montoursville","Montpelier","Montpelier","Montpelier","Montpelier","Montpelier","Montpelier","Montreal","Montreat","Montrose","Montrose","Montrose","Montrose","Montrose","Montrose","Montrose","Montrose","Montrose","Montrose","Montross","Montvale","Montvale","Montverde","Montville","Monument","Monument Beach","Moodus","Moody","Moody","Moody","Mooers","Mooers Forks","Moon","Moonachie","Moorcroft","Moore","Moore","Moore","Moore Haven","Moorefield","Mooreland","Mooreland","Moores Hill","Mooresboro","Mooresburg","Moorestown Township","Mooresville","Mooresville","Mooresville","Mooreton","Mooreville","Moorhead","Moorhead","Mooringsport","Moorland","Moorpark","Moose","Moose Lake","Moosic","Moosup","Mora","Mora","Moraga","Moran","Moran","Moravia","Moravia","Moravian Falls","Moreauville","Morehead","Morehead City","Moreland","Morenci","Morenci","Moreno Valley","Moretown","Morgan","Morgan","Morgan","Morgan","Morgan","Morgan City","Morgan Hill","Morganfield","Morganton","Morganton","Morgantown","Morgantown","Morgantown","Morgantown","Morganville","Morganville","Moriah","Moriarty","Moriches","Morley","Morning Sun","Morning View","Moro","Moro","Moro","Morocco","Morongo Valley","Moroni","Morral","Morrice","Morrill","Morrill","Morrill","Morrilton","Morris","Morris","Morris","Morris","Morris","Morris","Morris Chapel","Morris Plains","Morrisdale","Morrison","Morrison","Morrison","Morrison","Morrisonville","Morrisonville","Morriston","Morristown","Morristown","Morristown","Morristown","Morristown","Morristown","Morristown","Morrisville","Morrisville","Morrisville","Morrisville","Morrisville","Morro Bay","Morrow","Morrow","Morrow","Morse","Morse","Morse Bluff","Morton","Morton","Morton","Morton","Morton","Morton","Morton Grove","Mortons Gap","Morven","Mosca","Moscow","Moscow","Moscow","Moscow","Moscow","Moscow","Moscow","Moscow","Moscow Mills","Moseley","Moses Lake","Mosheim","Mosier","Mosinee","Moss","Moss Beach","Moss Landing","Moss Point","Mossyrock","Motley","Mott","Moulton","Moulton","Moulton","Moultonborough","Moultrie","Mound","Mound Bayou","Mound City","Mound City","Moundridge","Mounds","Mounds","Moundsville","Moundville","Mount Airy","Mount Airy","Mount Airy","Mount Angel","Mount Arlington","Mount Auburn","Mount Ayr","Mount Berry","Mount Bethel","Mount Blanchard","Mount Calvary","Mount Carbon","Mount Carmel","Mount Carmel","Mount Carmel","Mount Carroll","Mount Clemens","Mount Cory","Mount Crawford","Mount Croghan","Mount Eaton","Mount Eden","Mount Enterprise","Mount Ephraim","Mount Erie","Mount Gay","Mount Gilead","Mount Gilead","Mount Gretna","Mount Hermon","Mount Hermon","Mount Holly","Mount Holly","Mount Holly","Mount Holly","Mount Holly Springs","Mount Hope","Mount Hope","Mount Hope","Mount Hope","Mount Horeb","Mount Ida","Mount Jackson","Mount Jewett","Mount Joy","Mount Juliet","Mount Kisco","Mount Laurel","Mount Lookout","Mount Morris","Mount Morris","Mount Morris","Mount Nebo","Mount Olive","Mount Olive","Mount Olive","Mount Olive","Mount Olivet","Mount Orab","Mount Pleasant","Mount Pleasant","Mount Pleasant","Mount Pleasant","Mount Pleasant","Mount Pleasant","Mount Pleasant Mills","Mount Pocono","Mount Prospect","Mount Pulaski","Mount Rainier","Mount Royal","Mount Saint Joseph","Mount Savage","Mount Shasta","Mount Sidney","Mount Sinai","Mount Sterling","Mount Sterling","Mount Sterling","Mount Sterling","Mount Storm","Mount Tremper","Mount Ulla","Mount Union","Mount Union","Mount Upton","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Vernon","Mount Victoria","Mount Victory","Mount Vision","Mount Washington","Mount Wilson","Mount Wolf","Mount Zion","Mount Zion","Mountain","Mountain City","Mountain City","Mountain Grove","Mountain Home","Mountain Home","Mountain Home","Mountain Home","Mountain Iron","Mountain Lake","Mountain Lakes","Mountain Pine","Mountain Ranch","Mountain Top","Mountain View","Mountain View","Mountain View","Mountain View","Mountain View","Mountain View","Mountain Village","Mountainair","Mountainburg","Mountainside","Mountainville","Mountlake Terrace","Mountville","Mousie","Mouth of Wilson","Mouthcard","Moville","Moweaqua","Moxee City","Moyie Springs","Moyock","Mt Pleasant","Mt. Dora","Mt. Morris","Mt. Pleasant","Mt. Vernon","Muenster","Muir","Muir","Mukilteo","Mukwonago","Mulberry","Mulberry","Mulberry","Mulberry","Mulberry Grove","Muldoon","Muldraugh","Muldrow","Muleshoe","Mulga","Mulino","Mulkeytown","Mullan","Mullen","Mullica Hill","Mulliken","Mullin","Mullins","Mullinville","Mulvane","Muncie","Muncy","Munday","Mundelein","Munford","Munford","Munfordville","Munger","Munich","Munising","Munith","Munnsville","Munroe Falls","Munster","Murchison","Murdock","Murdock","Murfreesboro","Murfreesboro","Murfreesboro","Murphy","Murphy","Murphys","Murphysboro","Murray","Murray","Murray","Murrayville","Murrells Inlet","Murrieta","Murrysville","Muscatine","Muscle Shoals","Muscoda","Muse","Musella","Muskego","Muskegon","Muskogee","Mustang","Mutual","Myakka City","Myerstown","Myersville","Mylo","Myrtle","Myrtle Beach","Myrtle Creek","Myrtle Point","Mystic","Mystic","Myton","N. Lawrence","Nabb","Nabesna","Naco","Nacogdoches","Nacoochee","Nageezi","Nags Head","Nahant","Nahunta","Naknek","Nampa","Nancy","Nanjemoy","Nanticoke","Nantucket","Nanty Glo","Nanuet","Naoma","Napa","Napavine","Naper","Naperville","Napier","Naples","Naples","Naples","Naples","Naples","Napoleon","Napoleon","Napoleonville","Nappanee","Nara Visa","Narberth","Narka","Narragansett","Narrows","Narrowsburg","Narvon","Naselle","Nash","Nash","Nashoba","Nashotah","Nashport","Nashua","Nashua","Nashua","Nashville","Nashville","Nashville","Nashville","Nashville","Nashville","Nashville","Nashville","Nashwauk","Nassau","Nassawadox","Natalbany","Natalia","Natchez","Natchitoches","Natick","National City","National Park","Natrona Heights","Natural Bridge","Natural Bridge","Natural Bridge Station","Naturita","Naubinway","Naugatuck","Nauvoo","Nauvoo","Navajo","Navarre","Navarre","Navasota","Naylor","Naylor","Nazan Village","Nazareth","Nazareth","Neah Bay","Nebo","Nebo","Nebraska City","Necedah","Neche","Nederland","Nederland","Nedrow","Needham","Needham","Needham Heights","Needles","Needmore","Needville","Neely","Neelyville","Neenah","Neeses","Neffs","Negaunee","Negley","Nehalem","Neillsville","Nekoosa","Neligh","Nellis","Nellysford","Nelson","Nelson","Nelsonville","Nemacolin","Nemaha","Nemo","Nenana","Neodesha","Neoga","Neola","Neosho","Neosho","Neosho Falls","Neosho Rapids","Neotsu","Nephi","Neponset","Neptune Beach","Neptune City","Nerstrand","Nesbit","Nesconset","Nescopeck","Neshanic Station","Neshkoro","Nesquehoning","Ness City","Nester","Netawaka","Netcong","Nettleton","Nevada","Nevada","Nevada","Nevada City","Neversink","Nevis","New Albany","New Albany","New Albany","New Albany","New Albin","New Alexandria","New Almaden","New Athens","New Auburn","New Baden","New Baltimore","New Bavaria","New Bedford","New Berlin","New Berlin","New Berlin","New Berlin","New Berlinville","New Bern","New Bethlehem","New Blaine","New Bloomfield","New Boston","New Boston","New Boston","New Boston","New Braintree","New Braunfels","New Bremen","New Brighton","New Britain","New Brockton","New Brunswick","New Buffalo","New Burnside","New Cambria","New Cambria","New Canaan","New Caney","New Canton","New Carlisle","New Carlisle","New Castle","New Castle","New Castle","New Castle","New Castle","New Castle","New Castle","New Church","New City","New Columbia","New Concord","New Concord","New Creek","New Cumberland","New Cumberland","New Cuyama","New Deal","New Derry","New Douglas","New Durham","New Eagle","New Effington","New Egypt","New England","New Enterprise","New Era","New Fairfield","New Florence","New Florence","New Franken","New Franklin","New Freedom","New Galilee","New Germany","New Glarus","New Gloucester","New Goshen","New Hampton","New Hampton","New Hampton","New Hampton","New Harbor","New Harmony","New Harmony","New Hartford","New Hartford","New Haven","New Haven","New Haven","New Haven","New Haven","New Haven","New Haven","New Hebron","New Hill","New Holland","New Holland","New Holstein","New Hope","New Hudson","New Hyde Park","New Iberia","New Ipswich","New Johnsonville","New Kensington","New Kent","New Knoxville","New Laguna","New Lebanon","New Lebanon","New Lenox","New Lexington","New Liberty","New Lisbon","New Lisbon","New Llano","New London","New London","New London","New London","New London","New London","New London","New London","New London","New London","New Lothrop","New Madrid","New Market","New Market","New Market","New Market","New Market","New Market","New Marshfield","New Martinsville","New Meadows","New Memphis","New Middletown","New Milford","New Milford","New Milford","New Orleans","New Oxford","New Palestine","New Paltz","New Paris","New Paris","New Paris","New Park","New Philadelphia","New Philadelphia","New Plymouth","New Plymouth","New Point","New Port Richey","New Portland","New Prague","New Preston","New Providence","New Providence","New Providence","New Raymer","New Richland","New Richmond","New Richmond","New Richmond","New Riegel","New Ringgold","New River","New Roads","New Rochelle","New Rockford","New Ross","New Salem","New Salem","New Salem","New Salisbury","New Sharon","New Sharon","New Smyrna Beach","New Springfield","New Stanton","New Straitsville","New Stuyahok","New Tazewell","New Town","New Tripoli","New Troy","New Ulm","New Ulm","New Underwood","New Vernon","New Vienna","New Vienna","New Vineyard","New Virginia","New Washington","New Waterford","New Waverly","New Weston","New Wilmington","New Windsor","New Windsor","New Windsor","New Woodstock","New York","New York Mills","New York Mills","Newalla","Newark","Newark","Newark","Newark","Newark","Newark","Newark","Newark","Newark Valley","Newaygo","Newberg","Newbern","Newberry","Newberry","Newberry","Newberry","Newberry Springs","Newborn","Newburg","Newburg","Newburg","Newburgh","Newburgh","Newbury","Newbury","Newbury Center","Newbury Old Town","Newbury Park","Newburyport","Newcastle","Newcastle","Newcastle","Newcastle","Newcastle","Newcastle","Newcomb","Newcomerstown","Newell","Newell","Newell","Newell","Newellton","Newfane","Newfane","Newfield","Newfield","Newfields","Newfolden","Newfoundland","Newfoundland","Newhall","Newhall","Newhope","Newington","Newington","Newington","Newkirk","Newland","Newman","Newman","Newman Grove","Newman Lake","Newmanstown","Newmarket","Newnan","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport","Newport Beach","Newport Center","Newport Coast","Newport News","Newry","Newsoms","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton","Newton Center","Newton Falls","Newton Grove","Newton Highlands","Newton Lower Falls","Newton Upper Falls","Newtonsville","Newtonville","Newtown","Newtown","Newtown","Newtown","Newtown Square","Newville","Newville","Nezperce","Niagara","Niagara Falls","Niangua","Niantic","Niantic","Nicasio","Niceville","Nicholasville","Nicholls","Nichols","Nichols","Nicholson","Nicholson","Nicholville","Nickelsville","Nickerson","Nickerson","Nicktown","Nicollet","Nicoma Park","Nielsville","Nikiski","Niland","Niles","Niles","Niles","Nilwood","Nine Mile Falls","Ninety Six","Nineveh","Nineveh","Ninilchik","Ninnekah","Ninole","Niobe","Niobrara","Niota","Niota","Nipomo","Nisswa","Nitro","Niwot","Nixa","Nixon","Nixon","Noatak","Noble","Noble","Nobleboro","Noblesville","Nocona","Noel","Nogal","Nogales","Nokesville","Nokomis","Nokomis","Nolanville","Nolensville","Nome","Nondalton","Nooksack","Noonan","Noorvik","Nora Springs","Norborne","Norco","Norco","Norcross","Nordland","Norfolk","Norfolk","Norfolk","Norfolk","Norlina","Norma","Normal","Normal","Normalville","Norman","Norman","Norman","Norman Park","Normandy","Normandy Beach","Normangee","Normantown","Norridgewock","Norris","Norris","Norris City","Norristown","North","North Adams","North Adams","North Amherst","North Andover","North Anson","North Apollo","North Arlington","North Attleboro","North Augusta","North Aurora","North Babylon","North Baltimore","North Bangor","North Beach","North Bend","North Bend","North Bend","North Bend","North Bend","North Bennington","North Bergen","North Berwick","North Billerica","North Bloomfield","North Bonneville","North Branch","North Branch","North Branch","North Branford","North Bridgton","North Brookfield","North Brookfield","North Brunswick","North Carrollton","North Carver","North Charleston","North Chatham","North Chelmsford","North Chicago","North Chili","North Clarendon","North Collins","North Conway","North Creek","North Dartmouth","North Dighton","North East","North East","North Eastham","North Easton","North English","North Fairfield","North Falmouth","North Falmouth","North Fork","North Fort Myers","North Franklin","North Freedom","North Garden","North Grafton","North Granby","North Greece","North Grosvenor Dale","North Hampton","North Hatfield","North Haven","North Haven","North Haverhill","North Henderson","North Hero","North Highlands","North Hills","North Hollywood","North Jackson","North Judson","North Kingstown","North Kingsville","North Las Vegas","North Lemmon","North Lewisburg","North Liberty","North Liberty","North Lima","North Little Rock","North Loup","North Manchester","North Matewan","North Miami Beach","North Monmouth","North Myrtle Beach","North Newton","North Olmsted","North Oxford","North Palm Beach","North Pembroke","North Plains","North Platte","North Point","North Pole","North Pomfret","North Port","North Powder","North Prairie","North Providence","North Reading","North Richland Hills","North Ridgeville","North Rose","North Royalton","North Salem","North Salem","North Salem","North Salt Lake","North San Juan","North Sandwich","North Scituate","North Sioux City","North Smithfield","North Springfield","North Stonington","North Sutton","North Tazewell","North Tonawanda","North Troy","North Truro","North Vernon","North Versailles","North Wales","North Walpole","North Waterboro","North Webster","North Weymouth","North Wilkesboro","North Windham","North Woodstock","North Zulch","Northampton","Northampton","Northboro","Northborough","Northbridge","Northbrook","Northeast Harbor","Northern Cambria","Northfield","Northfield","Northfield","Northfield","Northfield","Northfield","Northfield Falls","Northford","Northfork","Northome","Northport","Northport","Northport","Northridge","Northumberland","Northvale","Northville","Northville","Northway","Northwood","Northwood","Northwood","Northwood","Norton","Norton","Norton","Nortonville","Nortonville","Norwalk","Norwalk","Norwalk","Norwalk","Norwalk","Norway","Norway","Norway","Norway","Norwell","Norwich","Norwich","Norwich","Norwich","Norwich","Norwood","Norwood","Norwood","Norwood","Norwood","Norwood","Norwood","Norwood Young America","Notasulga","Notre Dame","Nottingham","Nottingham","Nottingham","Nova","Novato","Novelty","Novelty","Novi","Novinger","Nowata","Noxapater","Noxen","Noxon","Nucla","Nuevo","NuMine","Nunda","Nunica","Nunn","Nunnelly","Nuremberg","Nutley","Nutrioso","Nyack","Nye","Nyssa","Oacoma","Oak Bluffs","Oak Brook","Oak City","Oak City","Oak Creek","Oak Creek","Oak Forest","Oak Grove","Oak Grove","Oak Grove","Oak Harbor","Oak Harbor","Oak Hill","Oak Hill","Oak Hill","Oak Hill","Oak Hill","Oak Island","Oak Lawn","Oak Park","Oak Park","Oak Park","Oak Park","Oak Ridge","Oak Ridge","Oak Ridge","Oak Ridge","Oak Run","Oak View","Oakboro","Oakdale","Oakdale","Oakdale","Oakdale","Oakdale","Oakdale","Oakdale","Oakes","Oakesdale","Oakfield","Oakfield","Oakfield","Oakfield","Oakfield","Oakham","Oakhurst","Oakhurst","Oakhurst","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland","Oakland City","Oakland Estates Mobile Home Park","Oakland Gardens","Oakley","Oakley","Oakley","Oakley","Oakley","Oaklyn","Oakman","Oakmont","Oaks","Oakton","Oakvale","Oakville","Oakville","Oakville","Oakwood","Oakwood","Oakwood","Oakwood","Oakwood","Oakwood","Oberlin","Oberlin","Oberlin","Obion","Oblong","Ocala","Ocate","Occidental","Occoquan","Ocean City","Ocean City","Ocean Gate","Ocean Grove","Ocean Isle Beach","Ocean Park","Ocean Park","Ocean Shores","Ocean Springs","Ocean View","Ocean View","Oceana","Oceano","Oceanport","Oceanside","Oceanside","Oceanville","Ochelata","Ocheyedan","Ochlocknee","Ocilla","Ocklawaha","Ocoee","Ocoee","Oconomowoc","Oconto","Oconto Falls","Ocotillo","Odanah","Odebolt","Odell","Odell","Odem","Oden","Odenton","Odenville","Odessa","Odessa","Odessa","Odessa","Odessa","Odessa","Odessa","Odin","Odin","Odon","Odum","Oelrichs","Oelwein","Ogallah","Ogallala","Ogden","Ogden","Ogden","Ogdensburg","Ogdensburg","Ogdensburg","Ogema","Ogema","Ogilvie","Oglesby","Oglethorpe","Ogunquit","Ohatchee","Ohio","Ohio City","Ohiopyle","Oil City","Oil City","Oil Springs","Oilton","Oilton","Ojai","Ojo Caliente","Okahumpka","Okanogan","Okarche","Okatie","Okay","Okeana","Okeechobee","Okeene","Okemah","Okemos","Oketo","Oklahoma City","Oklaunion","Oklee","Okmulgee","Okoboji","Okolona","Okolona","Oktaha","Ola","Olalla","Olancha","Olanta","Olanta","Olathe","Olathe","Olaton","Old Bethpage","Old Bridge","Old Chatham","Old Fields","Old Forge","Old Forge","Old Fort","Old Greenwich","Old Hickory","Old Kotzebue","Old Lyme","Old Ocean","Old Orchard Beach","Old Pekin","Old Saybrook","Old Town","Old Town","Old Westbury","Oldfort","Oldsmar","Oldtown","Oldtown","Oldwick","Olean","Oley","Olin","Olive Branch","Olive Branch","Olive Hill","Olivebridge","Oliveburg","Olivehurst","Oliver Springs","Olivet","Olivette","Olivia","Olla","Ollie","Olmito","Olmsted","Olmsted Falls","Olmstedville","Olney","Olney","Olney","Olney Springs","Olpe","Olsburg","Olton","Olympia","Olympia Fields","Olyphant","Omaha","Omaha","Omaha","Omaha","Omak","Omega","Omega","Omena","Omro","Ona","Ona","Onaga","Onalaska","Onalaska","Onalaska","Onamia","Onancock","Onarga","Onawa","Onaway","Oneco","Oneco","Oneida","Oneida","Oneida","Oneida","Onekama","Oneonta","Oneonta","Onia","Onley","Onondaga","Onset","Onslow","Onsted","Ontario","Ontario","Ontario","Ontario","Ontonagon","Onyx","Oologah","Ooltewah","Oostburg","Opa-locka","Opdyke","Opelika","Opelousas","Opheim","Ophiem","Opolis","Opp","Oquawka","Oracle","Oradell","Oran","Oran","Orange","Orange","Orange","Orange","Orange","Orange","Orange","Orange Beach","Orange City","Orange City","Orange Cove","Orange Grove","Orange Park","Orange Springs","Orangeburg","Orangeburg","Orangevale","Orangeville","Orangeville","Orangeville","Orchard","Orchard","Orchard","Orchard Hill","Orchard Park","Ord","Orderville","Ordway","Ore City","Oreana","Orefield","Oregon","Oregon","Oregon","Oregon","Oregon City","Oregon House","Oregonia","Oreland","Orem","Orford","Orfordville","Orient","Orient","Orient","Orient","Oriental","Orinda","Orion","Oriska","Oriskany","Oriskany Falls","Orland","Orland","Orland","Orland Park","Orlando","Orlando","Orlando","Orleans","Orleans","Orleans","Orleans","Orleans","Orlinda","Orma","Ormond Beach","Orofino","Orondo","Orono","Oronoco","Oronogo","Orosi","Oroville","Oroville","Orrington","Orrs Island","Orrstown","Orrtanna","Orrville","Orrville","Orting","Ortonville","Orwell","Orwell","Orwigsburg","Osage","Osage","Osage","Osage Beach","Osage City","Osakis","Osawatomie","Osborn","Osborne","Osburn","Osceola","Osceola","Osceola","Osceola","Osceola","Osceola","Osceola","Osceola Mills","Osco","Oscoda","Osgood","Oshkosh","Oshkosh","Oshtemo","Oskaloosa","Oskaloosa","Oslo","Osmond","Osprey","Osseo","Osseo","Ossian","Ossian","Ossineke","Ossining","Ossipee","Osteen","Osterville","Ostrander","Ostrander","Oswego","Oswego","Oswego","Osyka","Otego","Othello","Otho","Otis","Otis","Otis","Otis Orchards","Otisco","Otisville","Otisville","Otoe","Otsego","Ottawa","Ottawa","Ottawa","Otter","Otter Lake","Otterbein","Ottertail","Otto","Ottosen","Ottoville","Ottsville","Ottumwa","Otway","Ouray","Outing","Outlook","Overbrook","Overbrook","Overgaard","Overland Park","Overpeck","Overton","Overton","Ovid","Ovid","Ovid","Oviedo","Owaneco","Owasso","Owatonna","Owego","Owen","Owens Cross Roads","Owensboro","Owensburg","Owensville","Owensville","Owensville","Owenton","Owings","Owings Mills","Owingsville","Owosso","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford","Oxford Junction","Oxnard","Oxon Hill","Oyster Bay","Ozan","Ozark","Ozark","Ozark","Ozark","Ozawkie","Ozona","Ozone","Ozone Park","Pablo","Pacific","Pacific","Pacific City","Pacific Grove","Pacific Junction","Pacific Palisades","Pacifica","Packwood","Packwood","Pacoima","Pacolet","Paden","Paden City","Paducah","Paducah","Paeonian Springs","Page","Page","Pageland","Pageton","Pagosa Springs","Pahala","Pahoa","Pahokee","Pahrump","Paia","Paige","Painesdale","Painesville","Paint Lick","Paint Rock","Painted Post","Painter","Paintsville","Pala","Palacios","Palatine","Palatka","Palermo","Palermo","Palermo","Palestine","Palestine","Palestine","Palisade","Palisade","Palisade","Palisades","Palisades Park","Pall Mall","Palm","Palm Bay","Palm Beach","Palm Beach Gardens","Palm City","Palm Coast","Palm Desert","Palm Harbor","Palm Springs","Palmdale","Palmer","Palmer","Palmer","Palmer","Palmer","Palmer","Palmer","Palmer","Palmer Lake","Palmerdale","Palmersville","Palmerton","Palmetto","Palmetto","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palmyra","Palo","Palo Alto","Palo Cedro","Palo Verde","Paloma","Palos Heights","Palos Hills","Palos Park","Palos Verdes Peninsula","Palouse","Pampa","Pamplico","Pamplin","Pana","Panaca","Panacea","Panama","Panama","Panama","Panama","Panama City","Panama City Beach","Pandora","Pangburn","Panguitch","Panhandle","Panola","Panora","Panorama City","Pansey","Pantego","Paola","Paoli","Paoli","Paoli","Paoli","Paonia","Papillion","Parachute","Paradis","Paradise","Paradise","Paradise","Paradise","Paradise","Paradise Valley","Paradise Valley","Paradox","Paragon","Paragould","Paramount","Paramus","Pardeeville","Paris","Paris","Paris","Paris","Paris","Paris","Paris","Paris","Paris","Parish","Park","Park","Park City","Park City","Park Falls","Park Forest","Park Hill","Park Hills","Park Rapids","Park Ridge","Park Ridge","Park River","Parker","Parker","Parker","Parker","Parker","Parker","Parker City","Parker Ford","Parkers Lake","Parkers Prairie","Parkersburg","Parkersburg","Parkersburg","Parkesburg","Parkman","Parksley","Parkston","Parkton","Parkton","Parkville","Parlier","Parlin","Parma","Parma","Parma","Parnell","Parowan","Parrish","Parrish","Parrottsville","Parshall","Parsippany","Parsons","Parsons","Parsons","Parsonsburg","Parsonsfield","Partlow","Partridge","Partridge","Pasadena","Pasadena","Pasadena","Pascagoula","Pasco","Pascoag","Paso Robles","Pass Christian","Passaic","Passumpsic","Pataskala","Patchogue","Paterson","Patoka","Patoka","Paton","Patrick","Patrick Springs","Patriot","Patten","Patterson","Patterson","Patterson","Patterson","Patterson","Pattersonville","Pattison","Pattison","Patton","Patton","Patton","Pattonsburg","Pattonville","Paul","Paul Smiths","Paulden","Paulding","Paulina","Pauline","Paullina","Pauls Valley","Paulsboro","Pauma Valley","Pavilion","Pavillion","Pavo","Paw Paw","Paw Paw","Paw Paw","Pawcatuck","Pawhuska","Pawlet","Pawleys Island","Pawling","Pawnee","Pawnee","Pawnee City","Pawtucket","Paxico","Paxinos","Paxton","Paxton","Paxton","Paxton","Payette","Payne","Paynesville","Payneville","Payson","Payson","Payson","Pea Ridge","Peabody","Peabody","Peace Dale","Peach Bottom","Peach Creek","Peach Orchard","Peach Springs","Peachland","Peachtree City","Peak","Peaks Island","Peapack","Pearblossom","Pearce","Pearcy","Pearisburg","Pearl","Pearl City","Pearl City, Manana","Pearl River","Pearl River","Pearland","Pearlington","Pearsall","Pearson","Pearson","Pease","Pebble Beach","Pecatonica","Peck","Peck","Peck","Pecks Mill","Peckville","Peconic","Pecos","Pecos","Peculiar","Pedricktown","Pedro Bay","Peebles","Peekskill","Peel","Peetz","Peever","Peggs","Pegram","Pekin","Pelahatchie","Pelham","Pelham","Pelham","Pelham","Pelham","Pelham","Pelican","Pelican Lake","Pelican Rapids","Pelion","Pelkie","Pell City","Pella","Pellston","Pelzer","Pemberton","Pemberville","Pembina","Pembine","Pembroke","Pembroke","Pembroke","Pembroke","Pembroke","Pembroke","Pembroke Pines","Pen Argyl","Penasco","Pender","Pendergrass","Pendleton","Pendleton","Pendleton","Pendleton","Penelope","Penfield","Penfield","Pengilly","Penhook","Peninsula","Penitas","Penn","Penn Laird","Penn Run","Penn Valley","Penn Yan","Pennellville","Penney Farms","Penngrove","Pennington","Pennington","Pennington Gap","Pennock","Penns Grove","Penns Park","Pennsauken Township","Pennsboro","Pennsburg","Pennsville Township","Pennsylvania Furnace","Pennville","Penokee","Penrose","Penrose","Penryn","Pensacola","Pentress","Pentwater","Peoria","Peoria","Peoria Heights","Peosta","Peotone","Pepperell","Pequannock","Pequea","Pequot Lakes","Peralta","Percy","Perdido","Perham","Peridot","Perkasie","Perkins","Perkinston","Perkinsville","Perkiomenville","Perley","Perrineville","Perrinton","Perris","Perronville","Perry","Perry","Perry","Perry","Perry","Perry","Perry","Perry","Perry","Perry","Perry","Perry Hall","Perry Point","Perryman","Perryopolis","Perrysburg","Perryton","Perryville","Perryville","Perryville","Perryville","Pershing","Persia","Perth Amboy","Peru","Peru","Peru","Peru","Peru","Pescadero","Peshastin","Peshtigo","Pesotum","Petal","Petaluma","Peterborough","Peterman","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersburg","Petersham","Peterson","Peterstown","Petoskey","Petroleum","Petrolia","Petrolia","Petros","Pettigrew","Pevely","Pewamo","Pewaukee","Pewee Valley","Peyton","Pfafftown","Pflugerville","Pharr","Phelan","Phelps","Phelps","Phenix","Phenix City","Phil Campbell","Philadelphia","Philadelphia","Philadelphia","Philadelphia","Philadelphia","Philip","Philipp","Philippi","Philipsburg","Philipsburg","Phillips","Phillips","Phillips","Phillipsburg","Phillipsburg","Phillipsburg","Philo","Philo","Philo","Philomath","Philpot","Phippsburg","Phoenicia","Phoenix","Phoenix","Phoenix","Phoenix","Phoenixville","Piasa","Picabo","Picayune","Pickens","Pickens","Pickerington","Pickett","Pickstown","Pickton","Pico Rivera","Picture Rocks","Piedmont","Piedmont","Piedmont","Piedmont","Piedmont","Piedmont","Pierce","Pierce","Pierce","Pierce City","Pierceton","Piercy","Piermont","Pierpont","Pierpont","Pierre","Pierre Part","Pierron","Pierson","Pierson","Pierson","Pierz","Piffard","Pigeon","Pigeon Forge","Piggott","Pike Road","Pikesville","Piketon","Pikeville","Pikeville","Pikeville","Pillager","Pilot","Pilot Grove","Pilot Hill","Pilot Knob","Pilot Mound","Pilot Mountain","Pilot Point","Pilot Rock","Pilot Station","Pima","Pima County","Pimento","Pinckney","Pinckneyville","Pinconning","Pine","Pine Beach","Pine Bluff","Pine Bluffs","Pine Brook","Pine Bush","Pine City","Pine City","Pine Forge","Pine Grove","Pine Grove","Pine Grove","Pine Grove Mills","Pine Hill","Pine Hill","Pine Island","Pine Island","Pine Knot","Pine Lake","Pine Mountain","Pine Mountain Club","Pine Plains","Pine Ridge","Pine River","Pine Top","Pine Valley","Pine Valley","Pinebluff","Pinecrest","Pinedale","Pinedale","Pinehill","Pinehurst","Pinehurst","Pinehurst","Pinellas Park","Pineola","Pinesdale","Pinetop-Lakeside","Pinetops","Pinetown","Pineville","Pineville","Pineville","Pineville","Pineville","Pineville","Pinewood","Piney Creek","Piney Flats","Piney View","Piney Woods","Pingree","Pink Hill","Pinnacle","Pinola","Pinole","Pinon","Pinon Hills","Pinson","Pinson","Pioche","Pioneer","Pioneer","Pioneer","Pioneertown","Pipe Creek","Piper City","Pipersville","Pipestone","Piqua","Piqua","Pirtleville","Piscataway","Piseco","Pisgah","Pisgah","Pisgah Forest","Pismo Beach","Pitcairn","Pitcher","Pitkin","Pitman","Pitman","Pittsboro","Pittsboro","Pittsboro","Pittsburg","Pittsburg","Pittsburg","Pittsburg","Pittsburgh","Pittsfield","Pittsfield","Pittsfield","Pittsfield","Pittsfield","Pittsfield","Pittsford","Pittsford","Pittsford","Pittston","Pittstown","Pittsview","Pittsville","Pittsville","Pixley","Placedo","Placentia","Placerville","Placida","Placitas","Plain","Plain City","Plain Dealing","Plainfield","Plainfield","Plainfield","Plainfield","Plainfield","Plainfield","Plainfield","Plainfield","Plainfield","Plains","Plains","Plains","Plains","Plainsboro","Plainview","Plainview","Plainview","Plainview","Plainview","Plainville","Plainville","Plainville","Plainville","Plainville","Plainville","Plainwell","Plaistow","Planada","Plankinton","Plano","Plano","Plant City","Plantation","Plantersville","Plantersville","Plantsville","Plaquemine","Plato","Platte","Platte City","Plattekill","Plattenville","Platteville","Platteville","Plattsburg","Plattsburgh","Plattsmouth","Playa del Rey","Plaza","Pleasant City","Pleasant Dale","Pleasant Garden","Pleasant Grove","Pleasant Grove","Pleasant Grove","Pleasant Hill","Pleasant Hill","Pleasant Hill","Pleasant Hill","Pleasant Hill","Pleasant Hill","Pleasant Hill","Pleasant Hope","Pleasant Lake","Pleasant Lake","Pleasant Mount","Pleasant Plain","Pleasant Plains","Pleasant Prairie","Pleasant Ridge","Pleasant Shade","Pleasant Unity","Pleasant Valley","Pleasant View","Pleasant View","Pleasanton","Pleasanton","Pleasanton","Pleasantville","Pleasantville","Pleasantville","Pleasantville","Pleasantville","Pleasureville","Plentywood","Plover","Plum Branch","Plum City","Plumerville","Plummer","Plummer","Plummers Landing","Plumsteadville","Plumville","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth","Plymouth Meeting","Plympton","Poca","Pocahontas","Pocahontas","Pocahontas","Pocasset","Pocatello","Pocola","Pocomoke City","Pocono Pines","Pocono Summit","Poestenkill","Point","Point Arena","Point Comfort","Point Harbor","Point Hope","Point Lay","Point Lookout","Point of Rocks","Point of Rocks","Point Pleasant","Point Pleasant","Point Pleasant Beach","Point Reyes Station","Point Roberts","Pointblank","Polacca","Poland","Poland","Poland","Polk","Polk","Polk City","Polk City","Polkton","Polkville","Pollard","Pollock","Pollock","Pollock","Pollock Pines","Pollocksville","Pollok","Polo","Polo","Polson","Pomaria","Pomerene","Pomeroy","Pomeroy","Pomeroy","Pomfret","Pomfret","Pomfret Center","Pomona","Pomona","Pomona","Pomona","Pomona","Pomona Park","Pompano Beach","Pompey","Pompton Lakes","Pompton Plains","Ponca","Ponca","Ponca City","Ponce de Leon","Ponchatoula","Pond Creek","Ponder","Ponderay","Ponemah","Poneto","Ponsford","Ponte Vedra","Ponte Vedra Beach","Pontiac","Pontiac","Pontotoc","Pooler","Poolesville","Poolville","Pope","Pope Valley","Poplar","Poplar Bluff","Poplar Branch","Poplar Grove","Poplar Grove","Poplarville","Poquoson","Porcupine","Port Allegany","Port Allen","Port Angeles","Port Aransas","Port Arthur","Port Austin","Port Barre","Port Bolivar","Port Byron","Port Byron","Port Carbon","Port Charlotte","Port Chester","Port Clinton","Port Crane","Port Deposit","Port Edwards","Port Elizabeth","Port Gibson","Port Hadlock","Port Henry","Port Hope","Port Hueneme","Port Huron","Port Isabel","Port Jefferson","Port Jefferson Station","Port Jervis","Port Lavaca","Port Leyden","Port Ludlow","Port Mansfield","Port Matilda","Port Monmouth","Port Murray","Port Neches","Port Norris","Port Orange","Port Orchard","Port Orford","Port Penn","Port Reading","Port Republic","Port Republic","Port Republic","Port Richey","Port Royal","Port Royal","Port Royal","Port Saint Joe","Port Saint Lucie","Port Salerno","Port Sanilac","Port Tobacco","Port Townsend","Port Trevorton","Port Washington","Port Washington","Port Washington","Portage","Portage","Portage","Portage","Portage","Portageville","Portal","Portal","Portales","Porter","Porter","Porter","Porter Corners","Portersville","Porterville","Portland","Portland","Portland","Portland","Portland","Portland","Portland","Portland","Portland","Portland","Portola","Portola Valley","Portsmouth","Portsmouth","Portsmouth","Portsmouth","Portsmouth","Portville","Porum","Posen","Posen","Poseyville","Post","Post Falls","Post Mills","Poston","Postville","Poteau","Poteet","Poth","Potlatch","Potomac","Potomac","Potomac","Potosi","Potosi","Potsdam","Potter","Potter Valley","Pottersville","Pottersville","Potterville","Potts Camp","Pottsboro","Pottstown","Pottsville","Pottsville","Potwin","Poughkeepsie","Poughquag","Poulan","Poulsbo","Poultney","Pound","Pound","Pound Ridge","Pounding Mill","Poway","Powder Springs","Powder Springs","Powderly","Powell","Powell","Powell","Powell","Powell Butte","Powellsville","Powellton","Powers","Powers Lake","Powhatan","Powhatan","Powhatan Point","Pownal","Poyen","Poynette","Poynor","Poyntelle","Prague","Prague","Prairie","Prairie City","Prairie City","Prairie du Chien","Prairie du Rocher","Prairie du Sac","Prairie Farm","Prairie Grove","Prairie View","Prairie View","Prairie Village","Prairieton","Prairieville","Prather","Pratt","Pratt","Pratts","Prattsburgh","Prattsville","Prattville","Preble","Preemption","Premier","Prentiss","Prescott","Prescott","Prescott","Prescott","Prescott","Prescott","Prescott","Prescott Valley","Presho","Presidio","Presque Isle","Presque Isle","Presto","Preston","Preston","Preston","Preston","Preston","Preston","Preston City","Preston Hollow","Prestonsburg","Prewitt","Price","Prichard","Pride","Priest River","Primghar","Primm Springs","Primus","Prince Frederick","Prince George","Princess Anne","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton","Princeton Junction","Princeville","Princeville","Princewick","Prineville","Prinsburg","Printer","Prior Lake","Pritchett","Procious","Proctor","Proctor","Proctor","Proctor","Proctor","Proctorville","Progreso","Prompton","Prophetstown","Prospect","Prospect","Prospect","Prospect","Prospect","Prospect","Prospect","Prospect Harbor","Prospect Heights","Prospect Park","Prosper","Prosperity","Prosperity","Prosser","Protection","Protivin","Providence","Providence","Providence","Providence","Providence Forge","Provincetown","Provo","Prudenville","Prudhoe Bay","Pryor","Pueblo","Puerto Rico","Pukalani","Pukwana","Pulaski","Pulaski","Pulaski","Pulaski","Pulaski","Pulaski","Pullman","Pullman","Pullman","Pungoteague","Punta Gorda","Punxsutawney","Purcell","Purcellville","Purchase","Purdin","Purdon","Purdy","Purdys","Purgitsville","Purlear","Purling","Purvis","Puryear","Put-in-Bay","Putnam","Putnam","Putnam Station","Putnam Valley","Putney","Puyallup","Pylesville","Quail","Quakake","Quaker City","Quaker Hill","Quakertown","Quakertown","Quality","Quanah","Quantico","Quantico","Quapaw","Quarryville","Quartzsite","Quasqueton","Quebeck","Quechee","Queen Anne","Queen City","Queen City","Queen Creek","Queens Village","Queensbury","Queenstown","Quemado","Questa","Quilcene","Quimby","Quincy","Quincy","Quincy","Quincy","Quincy","Quincy","Quincy","Quincy","Quincy","Quinebaug","Quinlan","Quinnesec","Quinter","Quinton","Quinton","Quinton","Quinwood","Quitman","Quitman","Quitman","Quitman","Quitman","Qulin","Quogue","Raccoon","Raceland","Racine","Racine","Racine","Racine","Radcliff","Radcliffe","Radford","Radisson","Radnor","Raeford","Ragland","Rahway","Rainbow","Rainbow City","Rainelle","Rainier","Rainier","Rainsville","Raleigh","Raleigh","Raleigh","Ralls","Ralph","Ralston","Ramah","Ramah","Ramer","Ramey","Ramona","Ramona","Ramona","Ramseur","Ramsey","Ramsey","Ramsey","Ranburne","Ranchita","Rancho Cordova","Rancho Cucamonga","Rancho Mirage","Rancho Palos Verdes","Rancho Santa Fe","Rancho Santa Margarita","Ranchos de Taos","Rancocas","Randall","Randallstown","Randle","Randleman","Randlett","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph","Randolph Center","Randolph Township","Random Lake","Rangely","Ranger","Ranger","Ranger","Rankin","Rankin","Ransom","Ransom","Ransom","Ransom Canyon","Ransomville","Ranson","Rantoul","Rantoul","Raphine","Rapid City","Rapid City","Rapid River","Rapidan","Raquette Lake","Raritan","Rathdrum","Ratliff City","Raton","Rattan","Ravalli","Raven","Ravena","Ravencliff","Ravenden","Ravenel","Ravenna","Ravenna","Ravenna","Ravenna","Ravenna","Ravensdale","Ravenswood","Ravenwood","Ravia","Rawlings","Rawlings","Rawlins","Rawson","Ray","Ray","Ray Center","Ray City","Rayland","Raymond","Raymond","Raymond","Raymond","Raymond","Raymond","Raymond","Raymond","Raymondville","Raymondville","Raymore","Rayne","Raynham","Rayville","Rayville","Raywick","Readfield","Reading","Reading","Reading","Reading","Reading","Readlyn","Readsboro","Readyville","Reamstown","Reardan","Rebecca","Rebersburg","Rector","Rector","Red Bank","Red Banks","Red Bay","Red Bluff","Red Boiling Springs","Red Bud","Red Cloud","Red Creek","Red Hill","Red Hook","Red House","Red Jacket","Red Lake Falls","Red Level","Red Lion","Red Lodge","Red Oak","Red Oak","Red Oak","Red River","Red Rock","Red Rock","Red Springs","Red Wing","Redan","Redby","Reddick","Reddick","Redding","Redding","Redding Ridge","Redfield","Redfield","Redfield","Redfield","Redfield","Redford","Redford","Redfox","Redkey","Redlands","Redmon","Redmond","Redmond","Redmond","Redondo Beach","Redwater","Redway","Redwood","Redwood","Redwood","Redwood City","Redwood Estates","Redwood Falls","Redwood Valley","Reed City","Reed Point","Reedley","Reeds","Reeds Spring","Reedsburg","Reedsport","Reedsville","Reedsville","Reedsville","Reedville","Reedy","Reelsville","Reese","Reeseville","Reevesville","Reform","Refugio","Regent","Register","Rego Park","Rehoboth","Rehoboth Beach","Reidsville","Reidsville","Reidville","Reinbeck","Reinholds","Reisterstown","Reklaw","Reliance","Rembert","Rembrandt","Remer","Remington","Remlap","Remote","Remsen","Remsen","Remsenburg","Remus","Renfrew","Renner","Reno","Reno","Renovo","Rensselaer","Rensselaer","Rensselaer Falls","Renton","Rentz","Renville","Renwick","Repton","Republic","Republic","Republic","Republic","Republic","Resaca","Reseda","Reserve","Reserve","Reston","Revere","Revere","Revillo","Rex","Rex","Rexburg","Rexford","Rexmont","Rexville","Reydell","Reydon","Reynolds","Reynolds","Reynolds","Reynoldsburg","Reynoldsville","Rhame","Rheems","Rhine","Rhinebeck","Rhineland","Rhinelander","Rhoadesville","Rhodelia","Rhodell","Rhodes","Rhodesdale","Rhodhiss","Rhome","Rialto","Rib Lake","Ribera","Rice","Rice","Rice Lake","Rices Landing","Riceville","Riceville","Rich Creek","Rich Hill","Rich Square","Richards","Richardson","Richardton","Richboro","Richburg","Richeyville","Richfield","Richfield","Richfield","Richfield","Richfield","Richfield","Richfield Springs","Richford","Richford","Richgrove","Richland","Richland","Richland","Richland","Richland","Richland","Richland","Richland","Richland","Richland","Richland Center","Richlands","Richlands","Richlandtown","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond","Richmond Hill","Richmond Hill","Richton","Richton Park","Richvale","Richview","Richwood","Richwood","Rickman","Rickreall","Riddle","Riddleton","Riderwood","Ridge","Ridge","Ridge Farm","Ridge Spring","Ridgecrest","Ridgecrest","Ridgedale","Ridgefield","Ridgefield","Ridgefield","Ridgefield Park","Ridgeland","Ridgeland","Ridgeland","Ridgeley","Ridgely","Ridgely","Ridgeview","Ridgeville","Ridgeville","Ridgeway","Ridgeway","Ridgeway","Ridgeway","Ridgeway","Ridgewood","Ridgway","Ridgway","Ridgway","Ridley Park","Ridott","Riegelsville","Riegelwood","Rienzi","Riesel","Rifle","Riga","Rigby","Riggins","Riley","Rillton","Rimersburg","Rimforest","Rimrock","Rinard","Rincon","Rindge","Riner","Rineyville","Ringgold","Ringgold","Ringgold","Ringgold","Ringle","Ringling","Ringoes","Ringsted","Ringtown","Ringwood","Ringwood","Ringwood","Rio","Rio","Rio","Rio Dell","Rio Grande","Rio Grande","Rio Grande City","Rio Hondo","Rio Linda","Rio Nido","Rio Rancho","Rio Rico","Rio Verde","Rio Vista","Rio Vista","Ripley","Ripley","Ripley","Ripley","Ripley","Ripon","Ripon","Rippey","Ripplemead","Ripton","Rising City","Rising Fawn","Rising Star","Rising Sun","Rising Sun","Risingsun","Rison","Rittman","Ritzville","Riva","River Edge","River Falls","River Forest","River Grove","River Pines","River Rouge","Riverbank","Riverdale","Riverdale","Riverdale","Riverdale","Riverdale","Riverdale","Riverdale","Riverdale Hills","Riverhead","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside","Riverside County","Riverton","Riverton","Riverton","Riverton","Riverton","Riverton","Riverton","Riverton","Riverview","Riverview","Rives","Rives Junction","Rivesville","Riviera","Rixeyville","Roach","Roachdale","Roan Mountain","Roann","Roanoke","Roanoke","Roanoke","Roanoke","Roanoke","Roanoke Rapids","Roaring Branch","Roaring River","Roaring Spring","Robards","Robbins","Robbins","Robbins","Robbinsville","Robersonville","Robert","Robert Lee","Roberta","Roberts","Roberts","Robertsdale","Robertsdale","Robertson","Robertsville","Robesonia","Robins","Robinson","Robinson","Robinson Creek","Robinsonville","Robstown","Roby","Roca","Rochdale","Rochelle","Rochelle","Rochelle","Rochelle Park","Rochester","Rochester","Rochester","Rochester","Rochester","Rochester","Rochester","Rochester","Rochester","Rochester","Rochester","Rociada","Rock","Rock","Rock Creek","Rock Falls","Rock Hall","Rock Hill","Rock Hill","Rock Island","Rock Island","Rock Port","Rock Rapids","Rock River","Rock Spring","Rock Springs","Rock Springs","Rock Tavern","Rock Valley","Rock View","Rockaway","Rockaway Beach","Rockaway Beach","Rockaway Park","Rockbridge","Rockdale","Rockfield","Rockford","Rockford","Rockford","Rockford","Rockford","Rockford","Rockford","Rockholds","Rockhouse","Rockingham","Rockland","Rockland","Rockland","Rockland","Rockland","Rockledge","Rocklin","Rockmart","Rockport","Rockport","Rockport","Rockport","Rockport","Rockport","Rockport","Rocksprings","Rockton","Rockton","Rockvale","Rockvale","Rockville","Rockville","Rockville","Rockville","Rockville","Rockville","Rockville Centre","Rockwall","Rockwell","Rockwell","Rockwell City","Rockwood","Rockwood","Rockwood","Rockwood","Rocky","Rocky Face","Rocky Ford","Rocky Gap","Rocky Hill","Rocky Mount","Rocky Mount","Rocky Point","Rocky Point","Rocky River","Rodanthe","Rodeo","Rodeo","Roderfield","Rodman","Rodney","Roebling","Roebuck","Rogers","Rogers","Rogers","Rogers","Rogers City","Rogersville","Rogersville","Rogersville","Roggen","Rogue River","Rohnert Park","Rohrersville","Roland","Roland","Roland","Rolesville","Rolfe","Roll","Rolla","Rolla","Rolla","Rolling Fork","Rolling Meadows","Rolling Prairie","Rollingbay","Rollingstone","Rollinsford","Roma","Rome","Rome","Rome","Rome","Rome City","Romeo","Romeoville","Romney","Romney","Romulus","Romulus","Ronald","Ronan","Ronceverte","Ronda","Ronkonkoma","Ronks","Roodhouse","Roosevelt","Roosevelt","Roosevelt","Roosevelt","Rootstown","Roper","Ropesville","Rosalia","Rosalia","Rosamond","Rosburg","Roscoe","Roscoe","Roscoe","Roscommon","Rose Bud","Rose City","Rose Creek","Rose Hill","Rose Hill","Rose Hill","Rose Hill","Roseau","Roseboro","Rosebud","Rosebud","Rosebud","Rosebud","Roseburg","Rosebush","Rosedale","Rosedale","Rosedale","Rosedale","Rosedale","Rosedale","Roseland","Roseland","Roseland","Roseland","Roselle","Roselle","Roselle Park","Rosemary Beach","Rosemead","Rosemont","Rosemont","Rosemount","Rosenberg","Rosendale","Rosendale","Rosenhayn","Rosepine","Roseville","Roseville","Roseville","Roseville","Roseville","Rosewood","Rosharon","Rosholt","Rosiclare","Rosine","Roslindale","Roslyn","Roslyn","Roslyn","Roslyn Heights","Rosman","Ross","Rosser","Rossford","Rossiter","Rossville","Rossville","Rossville","Rossville","Roswell","Roswell","Rotan","Rothbury","Rothsay","Rothschild","Rotonda","Rotterdam Junction","Rougemont","Rough and Ready","Roulette","Round Hill","Round Lake","Round Lake","Round Mountain","Round Mountain","Round Mountain","Round O","Round Rock","Round Top","Roundhill","Roundup","Rouses Point","Rousseau","Rowan","Rowe","Rowena","Rowesville","Rowland","Rowland","Rowland Heights","Rowlesburg","Rowlett","Rowley","Rowley","Roxana","Roxboro","Roxbury","Roxbury","Roxbury","Roxie","Roy","Roy","Roy","Roy","Roy-Winifred Junction","Royal","Royal","Royal","Royal Center","Royal City","Royal Oak","Royal Palm Beach","Royalton","Royalton","Royersford","Royse City","Royston","Rozet","Rubicon","Ruby","Ruby","Ruckersville","Rudd","Rudolph","Rudyard","Ruffin","Ruffin","Ruffs Dale","Rugby","Ruidoso","Ruidoso Downs","Rule","Ruleville","Rulo","Rumford","Rumford","Rumney","Rumsey","Rumson","Runge","Runnells","Runnemede","Running Springs","Rupert","Rupert","Rural Hall","Rural Retreat","Rural Ridge","Rural Valley","Rush","Rush","Rush Center","Rush City","Rush Hill","Rush Valley","Rushford","Rushford","Rushmore","Rushville","Rushville","Rushville","Rushville","Rushville","Rushville","Rusk","Ruskin","Russell","Russell","Russell","Russell","Russell","Russell","Russell","Russell Springs","Russells Point","Russellton","Russellville","Russellville","Russellville","Russellville","Russellville","Russellville","Russellville","Russia","Russian Mission","Russiaville","Rustburg","Ruston","Ruth","Ruther Glen","Rutherford","Rutherford","Rutherford","Rutherfordton","Ruthton","Ruthven","Rutland","Rutland","Rutland","Rutland","Rutland","Rutledge","Rutledge","Rutledge","Ryan","Rydal","Ryde","Rye","Rye","Rye","Rye","Sabattus","Sabetha","Sabillasville","Sabin","Sabina","Sabinal","Sabot","Sabula","Sac City","Sacaton","Sachse","Sackets Harbor","Saco","Sacramento","Sacramento","Sacred Heart","Saddle Brook","Saddle River","Sadieville","Sadler","Saegertown","Safety Harbor","Safford","Sag Harbor","Sagamore","Sagamore Beach","Sagaponack","Saginaw","Saginaw","Sagle","Saguache","Sahuarita","Sailor Springs","Saint Agatha","Saint Albans","Saint Albans","Saint Albans","Saint Albans","Saint Albans","Saint Amant","Saint Ann","Saint Anne","Saint Ansgar","Saint Anthony","Saint Anthony","Saint Anthony","Saint Bonaventure","Saint Boniface","Saint Bonifacius","Saint Catharine","Saint Charles","Saint Charles","Saint Charles","Saint Charles","Saint Charles","Saint Clair","Saint Clair","Saint Clair","Saint Clair","Saint Clair Shores","Saint Clairsville","Saint Cloud","Saint Cloud","Saint Cloud","Saint Croix Falls","Saint David","Saint David","Saint Edward","Saint Elizabeth","Saint Elmo","Saint Francis","Saint Francis","Saint Francis","Saint Francis","Saint Francisville","Saint Francisville","Saint Gabriel","Saint George","Saint George","Saint George","Saint George","Saint Germain","Saint Hedwig","Saint Helen","Saint Helena","Saint Helens","Saint Henry","Saint Hilaire","Saint Ignace","Saint Ignatius","Saint Jacob","Saint James","Saint James","Saint James","Saint James","Saint James","Saint James City","Saint Joe","Saint Joe","Saint John","Saint John","Saint John","Saint John","Saint Johns","Saint Johns","Saint Johnsbury","Saint Johnsville","Saint Joseph","Saint Joseph","Saint Joseph","Saint Joseph","Saint Leo","Saint Leonard","Saint Libory","Saint Libory","Saint Louis","Saint Louis Park","Saint Louisville","Saint Marie","Saint Maries","Saint Marks","Saint Martin","Saint Martinville","Saint Mary","Saint Marys","Saint Marys","Saint Marys","Saint Marys","Saint Marys","Saint Matthews","Saint Matthews","Saint Meinrad","Saint Michael","Saint Michael","Saint Michael","Saint Michaels","Saint Michaels","Saint Nazianz","Saint Onge","Saint Paris","Saint Paul","Saint Paul","Saint Paul","Saint Paul","Saint Paul","Saint Paul","Saint Paul Park","Saint Pauls","Saint Peter","Saint Peter","Saint Peters","Saint Petersburg","Saint Regis","Saint Regis Falls","Saint Robert","Saint Simons Island","Saint Stephen","Saint Stephens","Saint Thomas","Saint Thomas","Sainte Marie","Salado","Salamanca","Sale City","Sale Creek","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salem","Salemburg","Salesville","Salida","Salida","Salina","Salina","Salina","Salinas","Saline","Saline","Salineville","Salisbury","Salisbury","Salisbury","Salisbury","Salisbury","Salisbury","Salisbury","Salisbury","Salisbury Mills","Salix","Salix","Salkum","Sallis","Sallisaw","Salmon","Salome","Salt Lake City","Salt Lick","Salt Point","Salt Rock","Salters","Saltillo","Saltillo","Saltillo","Salton City","Saltsburg","Saltville","Saluda","Saluda","Saluda","Salvisa","Salyer","Salyersville","Sammamish","Samoa","Samson","San Andreas","San Angelo","San Anselmo","San Antonio","San Antonio","San Antonio","San Augustine","San Benito","San Bernardino","San Bernardino County","San Bruno","San Carlos","San Carlos","San Clemente","San Cristobal","San Diego","San Diego","San Dimas","San Elizario","San Felipe","San Fernando","San Fidel","San Francisco","San Gabriel","San Geronimo","San Gregorio","San Jacinto","San Joaquin","San Jon","San Jose","San Jose","San Jose","San Juan","San Juan Bautista","San Juan Capistrano","San Leandro","San Lorenzo","San Luis","San Luis","San Luis Obispo","San Luis Rey Heights","San Manuel","San Marcos","San Marcos","San Marino","San Martin","San Mateo","San Mateo","San Miguel","San Pablo","San Pedro","San Pierre","San Rafael","San Rafael","San Ramon","San Saba","San Simeon","San Simon","San Ysidro","Sanborn","Sanborn","Sanborn","Sanbornton","Sanbornville","Sand Coulee","Sand Creek","Sand Creek","Sand Fork","Sand Lake","Sand Lake","Sand Point","Sand Springs","Sandborn","Sanders","Sanders","Sanderson","Sanderson","Sandersville","Sandia","Sandia Park","Sandoval","Sandoval County","Sandown","Sandpoint","Sandston","Sandstone","Sandusky","Sandusky","Sandwich","Sandwich","Sandy","Sandy","Sandy City","Sandy Creek","Sandy Hook","Sandy Hook","Sandy Hook","Sandy Lake","Sandy Ridge","Sandy Ridge","Sandy Spring","Sandyville","Sanford","Sanford","Sanford","Sanford","Sanger","Sanger","Sangerville","Sanibel","Santa Ana","Santa Ana Heights","Santa Anna","Santa Barbara","Santa Clara","Santa Clara","Santa Clara","Santa Clarita","Santa Claus","Santa Cruz","Santa Cruz","Santa Fe","Santa Fe","Santa Fe","Santa Fe Springs","Santa Margarita","Santa Maria","Santa Monica","Santa Paula","Santa Rosa","Santa Rosa","Santa Rosa Beach","Santa Teresa","Santa Ynez","Santa Ysabel","Santaquin","Santee","Santee","Santo","Sapphire","Sapulpa","Sarah","Sarah Ann","Sarahsville","Saraland","Saranac","Saranac Lake","Sarasota","Saratoga","Saratoga","Saratoga","Saratoga Springs","Saratoga Springs","Sarcoxie","Sardinia","Sardis","Sardis","Sardis","Sardis","Sarepta","Sargent","Sarita","Sarona","Saronville","Sartell","Sarver","Sasakwa","Satanta","Satartia","Satellite Beach","Satsop","Satsuma","Satsuma","Saucier","Saugatuck","Saugerties","Saugus","Sauk Centre","Sauk City","Sauk Rapids","Saukville","Saulsbury","Saulsville","Sault Ste. Marie","Saunderstown","Saunemin","Sauquoit","Sausalito","Savage","Savage","Savage","Savanna","Savanna","Savannah","Savannah","Savannah","Savannah","Savonburg","Savoy","Savoy","Savoy","Sawyer","Sawyer","Sawyer","Sawyer","Saxon","Saxonburg","Saxton","Saxtons River","Saybrook","Saylorsburg","Sayre","Sayre","Sayreville","Sayville","Scales Mound","Scammon Bay","Scandia","Scandia","Scandinavia","Scappoose","Scarborough","Scarbro","Scarsdale","Scarville","Scenery Hill","Schaefferstown","Schaghticoke","Schaller","Schaumburg","Schellsburg","Schenectady","Schenevus","Schenley","Schererville","Schertz","Schiller Park","Schlater","Schleswig","Schnecksville","Schneider","Schodack Landing","Schoenchen","Schofield","Schoharie","Schoolcraft","Schroon Lake","Schulenburg","Schulter","Schurz","Schuyler","Schuyler","Schuylerville","Schuylkill Haven","Schwenksville","Science Hill","Scio","Scio","Sciota","Sciota","Scipio","Scipio Center","Scituate","Scobey","Scotch Plains","Scotia","Scotland","Scotland","Scotland","Scotland Neck","Scotrun","Scott","Scott","Scott","Scott Air Force Base","Scott City","Scott City","Scott Depot","Scottdale","Scottdale","Scottown","Scotts","Scotts Hill","Scotts Mills","Scotts Valley","Scottsbluff","Scottsboro","Scottsburg","Scottsburg","Scottsburg","Scottsdale","Scottsville","Scottsville","Scottsville","Scottville","Scranton","Scranton","Scranton","Scranton","Scranton","Scranton","Scribner","Scroggins","Scurry","Sea Cliff","Sea Girt","Sea Island","Sea Isle City","Sea Ranch","Seabeck","Seabrook","Seabrook","Seabrook","Seadrift","Seaford","Seaford","Seaford","Seagoville","Seagraves","Seagrove","Seahurst","Seal","Seal Beach","Seal Cove","Seal Rock","Seale","Sealevel","Sealy","Seaman","Searcy","Searsboro","Searsmont","Seaside","Seaside","Seaside Heights","Seaside Park","Seaton","Seatonville","Seattle","Sebastian","Sebastian","Sebastopol","Sebec","Sebeka","Sebewaing","Sebree","Sebring","Sebring","Secaucus","Second Mesa","Secor","Section","Sedalia","Sedalia","Sedalia","Sedan","Sedgwick","Sedgwick","Sedona","Sedro-Woolley","Seekonk","Seeley","Seeley Lake","Seffner","Seguin","Seiling","Selah","Selawik","Selby","Selbyville","Selden","Selden","Seligman","Selinsgrove","Selkirk","Sellersburg","Sellersville","Sells","Selma","Selma","Selma","Selma","Selma","Selmer","Seminary","Seminole","Seminole","Seminole","Semmes","Senath","Senatobia","Seneca","Seneca","Seneca","Seneca","Seneca","Seneca Falls","Senecaville","Senoia","Sentinel Butte","Sequim","Sequoia","Serafina","Serena","Sergeant Bluff","Sergeantsville","Sesser","Seth","Seven Mile","Seven Springs","Seven Valleys","Severance","Severn","Severna Park","Severy","Sevierville","Seville","Seville","Sewanee","Seward","Seward","Seward","Sewaren","Sewell","Sewickley","Seymour","Seymour","Seymour","Seymour","Seymour","Seymour","Seymour","Shabbona","Shacklefords","Shade Gap","Shady Cove","Shady Dale","Shady Point","Shady Side","Shady Spring","Shady Valley","Shadyside","Shafer","Shafter","Shaftsbury","Shakopee","Shalimar","Shallotte","Shallowater","Shamokin","Shamokin Dam","Shamrock","Shandaken","Shandon","Shanks","Shanksville","Shannon","Shannon","Shannon","Shannon City","Shapleigh","Sharon","Sharon","Sharon","Sharon","Sharon","Sharon","Sharon","Sharon","Sharon","Sharon Center","Sharon Hill","Sharon Springs","Sharon Springs","Sharpsburg","Sharpsburg","Sharpsburg","Sharpsville","Sharpsville","Sharptown","Shartlesville","Shasta","Shattuck","Shavertown","Shaw","Shaw Island","Shawano","Shawboro","Shawnee","Shawnee","Shawnee","Shawnee on Delaware","Shawneetown","Shawsville","Sheboygan","Sheboygan Falls","Shedd","Sheep Springs","Sheffield","Sheffield","Sheffield","Sheffield","Sheffield","Sheffield","Sheffield Lake","Shelbiana","Shelburn","Shelburne","Shelburne Falls","Shelby","Shelby","Shelby","Shelby","Shelby","Shelby","Shelby","Shelbyville","Shelbyville","Shelbyville","Shelbyville","Shelbyville","Shelbyville","Sheldahl","Sheldon","Sheldon","Sheldon","Sheldon","Sheldon","Sheldon Springs","Shell","Shell Knob","Shell Lake","Shell Rock","Shelley","Shellman","Shellsburg","Shelly","Shelocta","Shelter Island","Shelter Island Heights","Shelton","Shelton","Shelton","Shenandoah","Shenandoah","Shenandoah","Shenandoah Junction","Shepherd","Shepherd","Shepherd","Shepherdstown","Shepherdsville","Sherborn","Sherburn","Sherburne","Sheridan","Sheridan","Sheridan","Sheridan","Sheridan","Sheridan","Sheridan","Sheridan","Sheridan","Sherman","Sherman","Sherman","Sherman","Sherman Oaks","Shermans Dale","Sherrard","Sherrill","Sherrill","Sherrill","Sherrills Ford","Sherrodsville","Sherwood","Sherwood","Sherwood","Sherwood","Sherwood","Shevlin","Sheyenne","Shickley","Shickshinny","Shidler","Shiloh","Shiloh","Shiloh","Shiner","Shingle Springs","Shinglehouse","Shingleton","Shingletown","Shinnston","Shiocton","Shipman","Shipman","Shippensburg","Shippenville","Shippingport","Shiprock","Shipshewana","Shirley","Shirley","Shirley","Shirley","Shirley","Shirley Mills","Shirleysburg","Shoals","Shobonier","Shoemakersville","Shohola","Shokan","Shongaloo","Shoreham","Shoreham","Shorewood","Short Hills","Shoshone","Shoshoni","Show Low","Shreve","Shreveport","Shrewsbury","Shrewsbury","Shrewsbury","Shrub Oak","Shubuta","Shumway","Shungnak","Shutesbury","Sibley","Sibley","Sibley","Sibley","Sicily Island","Sicklerville","Side Lake","Sidell","Sidman","Sidney","Sidney","Sidney","Sidney","Sidney","Sidney","Sidney","Sidney Center","Sidon","Siemens","Sierra Madre","Sierra Vista","Signal Hill","Signal Mountain","Sigourney","Sikes","Sikeston","Silas","Siler City","Silex","Siloam","Siloam Springs","Silsbee","Silt","Silva","Silvana","Silver Bay","Silver Bay","Silver City","Silver City","Silver Creek","Silver Creek","Silver Creek","Silver Grove","Silver Lake","Silver Lake","Silver Lake","Silver Lake","Silver Spring","Silver Springs","Silver Springs","Silver Springs","Silverado","Silverdale","Silverdale","Silverhill","Silverstreet","Silverthorne","Silverton","Silverton","Silvis","Simi Valley","Simla","Simmesport","Simms","Simms","Simon","Simonton","Simpson","Simpson","Simpsonville","Simpsonville","Simpsonville","Sims","Sims","Simsboro","Simsbury","Sinclair","Sinclairville","Sinks Grove","Sinton","Sioux Center","Sioux City","Sioux Falls","Sioux Rapids","Sipesville","Sipsey","Siren","Sisseton","Sister Bay","Sisters","Sistersville","Sitka","Sitka","Six Lakes","Six Mile","Skaguay","Skamokawa","Skandia","Skaneateles","Skaneateles Falls","Skanee","Skellytown","Skiatook","Skidmore","Skidmore","Skillman","Skippack","Skokie","Skowhegan","Skyforest","Skykomish","Skyland","Slagle","Slanesville","Slate Hill","Slater","Slater","Slatersville","Slatington","Slaton","Slaty Fork","Slaughter","Slaughters","Slayton","Sleepy Eye","Slidell","Sligo","Slinger","Slingerlands","Slippery Rock","Sloan","Sloansville","Sloatsburg","Slocomb","Sloughhouse","Slovan","Smackover","Smarr","Smartt","Smethport","Smilax","Smiley","Smith Center","Smith River","Smithers","Smithfield","Smithfield","Smithfield","Smithfield","Smithfield","Smithfield","Smithfield","Smithland","Smiths","Smiths Creek","Smiths Grove","Smithsburg","Smithshire","Smithton","Smithton","Smithton","Smithtown","Smithville","Smithville","Smithville","Smithville","Smithville","Smithville","Smithville","Smithville","Smithville Flats","Smoaks","Smock","Smoke Run","Smoketown","Smyer","Smyrna","Smyrna","Smyrna","Smyrna","Smyrna","Smyrna Mills","Sneads","Sneads Ferry","Sneedville","Snelling","Snellville","Snohomish","Snoqualmie","Snover","Snow Camp","Snow Hill","Snow Hill","Snow Shoe","Snowflake","Snowmass","Snowmass Village","Snyder","Snyder","Snyder","Soap Lake","Sobieski","Social Circle","Society Hill","Socorro","Sod","Soda Springs","Soda Springs","Soddy-Daisy","Sodus","Solana Beach","Soldier","Soldier","Soldiers Grove","Soldotna","Solebury","Soledad","Solen","Solomons","Solon","Solon","Solon Springs","Solsberry","Solvang","Solway","Somerdale","Somers","Somers","Somers","Somers","Somers Point","Somerset","Somerset","Somerset","Somerset","Somerset","Somerset","Somerset","Somerset","Somerset","Somerset Center","Somersworth","Somerton","Somerville","Somerville","Somerville","Somerville","Somerville","Somerville","Somis","Somonauk","Sonoita","Sonoma","Sonora","Sonora","Sonora","Sopchoppy","Soper","Soperton","Sophia","Sophia","Soquel","Sorento","Sorrento","Sorrento","Soso","Soudan","Souderton","Soulsbyville","Sound Beach","Sour Lake","South Amboy","South Barre","South Bay","South Beach","South Beloit","South Bend","South Bend","South Bend","South Berwick","South Boardman","South Boston","South Bound Brook","South Bristol","South Burlington","South Cairo","South Canaan","South Casco","South Charleston","South China","South Dartmouth","South Deerfield","South Dennis","South Easton","South Egremont","South El Monte","South Elgin","South English","South Fallsburg","South Fork","South Fork","South Freeport","South Fulton","South Gate","South Gibson","South Glastonbury","South Glens Falls","South Hackensack","South Hadley","South Hamilton","South Harwich","South Haven","South Haven","South Haven","South Hero","South Hill","South Holland","South Houston","South Hutchinson","South Jamesport","South Jordan","South Kent","South Lake Tahoe","South Lancaster","South Lebanon","South Londonderry","South Lyon","South Mills","South Milwaukee","South New Berlin","South Newfane","South Orange","South Otselic","South Ozone Park","South Padre Island","South Paris","South Park Township","South Pasadena","South Pekin","South Pittsburg","South Plainfield","South Plymouth","South Point","South Pomfret","South Portland","South Prairie","South Range","South River","South Rockwood","South Roxana","South Royalton","South Ryegate","South Saint Paul","South Salem","South Salem","South Sanford","South Seaville","South Shore","South Sioux City","South Solon","South Sterling","South Strafford","South Tamworth","South Vienna","South Wales","South Wayne","South Webster","South Wellfleet","South West City","South Weymouth","South Whitley","South Williamson","South Willington","South Wilmington","South Windsor","South Woodstock","South Woodstock","South Yarmouth","Southampton","Southampton","Southampton","Southaven","Southborough","Southbridge","Southbury","Southern Pines","Southfield","Southfields","Southgate","Southington","Southington","Southlake","Southmayd","Southold","Southport","Southport","Southport","Southside","Southview","Southwest Harbor","Southwick","Spain","Spalding","Spanaway","Spanish Fork","Spanish Fort","Spanishburg","Sparkill","Sparkman","Sparks","Sparks","Sparks","Sparks","Sparland","Sparrow Bush","Sparrows Point","Sparta","Sparta","Sparta","Sparta","Sparta","Sparta","Sparta","Sparta","Sparta","Spartanburg","Spartansburg","Spavinaw","Spearfish","Spearman","Spearsville","Spearville","Speculator","Spencer","Spencer","Spencer","Spencer","Spencer","Spencer","Spencer","Spencer","Spencer","Spencer","Spencer","Spencerport","Spencertown","Spencerville","Spencerville","Spencerville","Sperry","Sperry","Sperryville","Spiceland","Spicer","Spicewood","Spickard","Spindale","Spinnerstown","Spirit Lake","Spirit Lake","Spiro","Spivey","Splendora","Spofford","Spokane","Spooner","Spotswood","Spotsylvania","Spout Spring","Spraggs","Sprakers","Spreckels","Spring","Spring Arbor","Spring Branch","Spring Church","Spring City","Spring City","Spring City","Spring Creek","Spring Creek","Spring Glen","Spring Green","Spring Grove","Spring Grove","Spring Grove","Spring Grove","Spring Hill","Spring Hill","Spring Hill","Spring Hope","Spring House","Spring Lake","Spring Lake","Spring Lake","Spring Lake Park","Spring Mills","Spring Park","Spring Run","Spring Valley","Spring Valley","Spring Valley","Spring Valley","Spring Valley","Spring Valley","Springboro","Springboro","Springdale","Springdale","Springdale","Springdale","Springer","Springerville","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield","Springfield Gardens","Springfield Township","Springfield Township","Springhill","Springport","Springport","Springtown","Springtown","Springvale","Springview","Springville","Springville","Springville","Springville","Springville","Springville","Springville","Springville","Springwater","Spruce","Spruce Pine","Spruce Pine","Spurlockville","Squaw Lake","Squaw Valley","Squires","St Louis","St. Augustine","St. Charles","St. Genevieve","St. Helena","St. Joseph","St. Rose","Staatsburg","Stacy","Stacyville","Stacyville","Stafford","Stafford","Stafford","Stafford Springs","Staffordsville","Stahlstown","Staley","Stamford","Stamford","Stamford","Stamford","Stamford","Stanardsville","Stanberry","Stanchfield","Standard","Standish","Standish","Stanfield","Stanfield","Stanfield","Stanford","Stanford","Stanford","Stanford","Stanfordville","Stanhope","Stanhope","Stanley","Stanley","Stanley","Stanley","Stanley","Stanton","Stanton","Stanton","Stanton","Stanton","Stanton","Stanton","Stanton","Stantonsburg","Stanville","Stanwood","Stanwood","Staples","Staples","Stapleton","Stapleton","Stapleton","Star","Star","Star City","Star City","Star Lake","Star Prairie","Starbuck","Starford","Stark","Stark City","Starke","Starksboro","Starkville","Starkweather","Starr","Startex","State Center","State College","State Line","State Line","State Road","State University","Stateline","Staten Island","Statenville","Statesboro","Statesville","Statham","Staunton","Staunton","Stayton","Steamboat Rock","Steamboat Springs","Steamburg","Stearns","Stebbins","Stedman","Steedman","Steele","Steele","Steele","Steele City","Steeleville","Steelville","Steen","Steens","Steep Falls","Steger","Steilacoom","Steinauer","Steinhatchee","Stella","Stella","Stem","Stephen","Stephens","Stephens City","Stephenson","Stephenson","Stephensport","Stephentown","Stephenville","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling","Sterling Forest","Sterling Heights","Sterlington","Sterrett","Stetson","Stetsonville","Steuben","Steubenville","Stevens","Stevens Point","Stevenson","Stevenson","Stevenson","Stevenson Ranch","Stevensville","Stevensville","Stevensville","Stevinson","Steward","Stewardson","Stewart","Stewart","Stewart","Stewartstown","Stewartsville","Stewartsville","Stewartville","Stickney","Stigler","Stilesville","Still Pond","Stillman Valley","Stillmore","Stillwater","Stillwater","Stillwater","Stillwater","Stilwell","Stilwell","Stinesville","Stinnett","Stinson Beach","Stirling","Stites","Stittville","Stockbridge","Stockbridge","Stockdale","Stockertown","Stockholm","Stockport","Stockton","Stockton","Stockton","Stockton","Stockton","Stockton","Stockton","Stockton","Stockton","Stockton","Stockton Springs","Stoddard","Stoddard","Stokesdale","Stollings","Stone","Stone Creek","Stone Harbor","Stone Lake","Stone Mountain","Stone Park","Stone Ridge","Stoneboro","Stonefort","Stoneham","Stoneville","Stoneville","Stonewall","Stonewall","Stonewall","Stonewall","Stonington","Stonington","Stony Brook","Stony Creek","Stony Creek","Stony Point","Stony Point","Stonyford","Storden","Storm Lake","Stormville","Storrs","Story","Story","Story City","Stotts City","Stoughton","Stoughton","Stout","Stoutland","Stover","Stow","Stow","Stowe","Stoystown","Strafford","Strafford","Strafford","Strasburg","Strasburg","Strasburg","Strasburg","Strasburg","Strasburg","Stratford","Stratford","Stratford","Stratford","Stratford","Stratford","Stratford","Stratford","Stratford","Stratford","Stratham","Strathmore","Strattanville","Stratton","Stratton","Straughn","Strawberry","Strawberry Plains","Strawberry Point","Strawn","Strawn","Streamwood","Streator","Street","Streeter","Streetman","Streetsboro","Stringer","Stromsburg","Strong","Strong","Stronghurst","Strongstown","Strongsville","Stroud","Stroudsburg","Strum","Strunk","Struthers","Stryker","Stuart","Stuart","Stuart","Stuart","Stuart","Stuarts Draft","Studio City","Stump Creek","Sturbridge","Sturgeon","Sturgeon","Sturgeon Bay","Sturgeon Lake","Sturgis","Sturgis","Sturgis","Sturgis","Sturtevant","Stuttgart","Stuyvesant","Suamico","Sublette","Sublette","Sublimity","Succasunna","Suches","Sudan","Sudbury","Sudlersville","Suffern","Suffield","Suffolk","Sugar City","Sugar Grove","Sugar Grove","Sugar Grove","Sugar Grove","Sugar Grove","Sugar Grove","Sugar Hill","Sugar Land","Sugar Loaf","Sugar Run","Sugar Tree","Sugar Valley","Sugarcreek","Sugarloaf","Sugarloaf Township","Sugartown","Suisun","Suitland","Sula","Sulligent","Sullivan","Sullivan","Sullivan","Sullivan","Sullivan","Sullivan","Sullivan","Sully","Sulphur","Sulphur","Sulphur Bluff","Sulphur Springs","Sulphur Springs","Sulphur Springs","Sultan","Sumas","Sumerduck","Sumiton","Summer Shade","Summerdale","Summerdale","Summerfield","Summerfield","Summerfield","Summerfield","Summerfield","Summerfield","Summerhill","Summerland","Summerland Key","Summers","Summersville","Summersville","Summerton","Summertown","Summerville","Summerville","Summerville","Summerville","Summit","Summit","Summit","Summit","Summit Hill","Summit Lake","Summit Station","Summitville","Sumner","Sumner","Sumner","Sumner","Sumner","Sumner","Sumner","Sumner","Sumrall","Sumter","Sun","Sun City","Sun City","Sun City","Sun City Center","Sun City West","Sun Prairie","Sun River","Sun Valley","Sun Valley","Sun Valley","Sunapee","Sunbright","Sunburg","Sunburst","Sunbury","Sunbury","Suncook","Sundance","Sunderland","Sunderland","Sundown","Sunflower","Sunland","Sunman","Sunnyside","Sunnyside","Sunnyside","Sunnyvale","Sunnyvale","Sunol","Sunray","Sunrise","Sunrise Beach","Sunset","Sunset","Sunset","Sunset Beach","Sunset Beach","Sunshine","Superior","Superior","Superior","Superior","Supply","Suquamish","Surgoinsville","Suring","Surprise","Surrency","Surry","Surry","Susanville","Susquehanna","Sussex","Sussex","Sutersville","Sutherland","Sutherland","Sutherland","Sutherland Springs","Sutherlin","Sutter","Sutter","Sutter Creek","Sutton","Sutton","Sutton","Sutton","Suttons Bay","Suwanee","Suwannee","Swainsboro","Swaledale","Swampscott","Swan","Swannanoa","Swans Island","Swansboro","Swansea","Swansea","Swanton","Swanton","Swanton","Swanville","Swanzey","Swarthmore","Swartswood","Swartz","Swartz Creek","Swayzee","Swedesboro","Sweeny","Sweet","Sweet Home","Sweet Springs","Sweet Valley","Sweet Water","Sweetser","Sweetwater","Sweetwater","Swiftwater","Swink","Swisher","Swisshome","Switz City","Switzer","Swoope","Sybertsville","Sycamore","Sycamore","Sycamore","Sycamore","Sycamore","Sykeston","Sykesville","Sykesville","Sylacauga","Sylmar","Sylva","Sylvan Beach","Sylvan Grove","Sylvania","Sylvania","Sylvania","Sylvester","Sylvester","Symsonia","Syosset","Syracuse","Syracuse","Syracuse","Syracuse","Syracuse","Syracuse","Taberg","Tabernash","Table Grove","Tabor","Tabor","Tabor City","Tacoma","Taft","Taft","Taft","Tafton","Taftville","Tahlequah","Tahoe City","Tahoe Valley","Tahoe Vista","Tahoka","Taholah","Tahoma","Tahuya","Takoma Park","Talala","Talbott","Talbotton","Talco","Talcott","Talent","Talihina","Talkeetna","Talking Rock","Tall Timbers","Talladega","Tallahassee","Tallapoosa","Tallassee","Tallmadge","Tallulah","Talmo","Talmoon","Taloga","Tama","Tamaqua","Tamassee","Tamms","Tampa","Tampico","Tamworth","Taneytown","Taneyville","Tangent","Tangerine","Tangier","Tangipahoa","Tanner","Tannersville","Tannersville","Taos","Taos Ski Valley","Tappahannock","Tappan","Tappen","Tar Heel","Tarawa Terrace I","Tarboro","Tarentum","Tariffville","Tarkio","Tarpon Springs","Tarrs","Tarrytown","Tarzana","Tasley","Tatamy","Tate","Tatum","Tatum","Taunton","Taunton","Tavares","Tavernier","Tawas City","Taylor","Taylor","Taylor","Taylor","Taylor","Taylor","Taylor","Taylor","Taylor","Taylor Springs","Taylors","Taylors Falls","Taylorsville","Taylorsville","Taylorsville","Taylorsville","Taylorsville","Taylorsville","Taylorville","Tazewell","Tazewell","Tea","Teachey","Teague","Teaneck","Teasdale","Tebbetts","Tecumseh","Tecumseh","Tecumseh","Tecumseh","Teec Nos Pos","Tehachapi","Tehama","Tekamah","Tekoa","Tekonsha","Telephone","Telford","Telford","Tell City","Teller","Tellico Plains","Telluride","Telogia","Temecula","Tempe","Temperance","Temple","Temple","Temple","Temple","Temple","Temple City","Temple Hills","Templeton","Templeton","Templeton","Templeton","Ten Mile","Ten Sleep","Tenafly","Tenaha","Tenants Harbor","Tenino","Tennent","Tennessee","Tennessee Colony","Tennessee Ridge","Tennille","Tensed","Tenstrike","Terlingua","Terlton","Terra Alta","Terra Bella","Terrace Park","Terre Haute","Terre Hill","Terrebonne","Terrell","Terrell","Terreton","Terril","Terry","Terry","Terryville","Tescott","Tesuque","Teterboro","Teton","Teton Village","Tetonia","Teutopolis","Tewksbury","Texarkana","Texarkana","Texas City","Texhoma","Texico","Texline","Thackerville","Thatcher","Thaxton","Thayer","Thayer","Thayne","The Bronx","The Colony","The Dalles","The Plains","The Plains","The Rock","The Villages","Thelma","Thendara","Theodore","Theresa","Thermal","Thermopolis","Thetford Center","Thibodaux","Thief River Falls","Thiells","Thiensville","Thomas","Thomas","Thomasboro","Thomaston","Thomaston","Thomaston","Thomaston","Thomasville","Thomasville","Thomasville","Thomasville","Thompson","Thompson","Thompson","Thompson","Thompson","Thompson Falls","Thompsontown","Thompsonville","Thompsonville","Thomson","Thomson","Thonotosassa","Thoreau","Thorn Hill","Thornburg","Thorndale","Thorndike","Thorne Bay","Thornton","Thornton","Thornton","Thornton","Thornton","Thornton","Thorntown","Thornville","Thornwood","Thorofare","Thorp","Thousand Oaks","Thousand Palms","Thrall","Three Bridges","Three Forks","Three Lakes","Three Mile Bay","Three Oaks","Three Rivers","Three Rivers","Three Rivers","Three Rivers","Three Springs","Throckmorton","Thurmond","Thurmont","Thurston","Thurston","Tiburon","Tickfaw","Ticonderoga","Tidioute","Tierra Amarilla","Tieton","Tiffin","Tiffin","Tifton","Tigard","Tiger","Tigerton","Tigerville","Tignall","Tijeras","Tilden","Tilden","Tilden","Tilghman","Tiline","Tillamook","Tillar","Tilleda","Tillson","Tilton","Tilton","Tiltonsville","Timber Lake","Timberlake","Timberon","Timberville","Timbo","Timewell","Timmonsville","Timpson","Tingley","Tinley Park","Tioga","Tioga","Tioga","Tiona","Tionesta","Tipp City","Tipton","Tipton","Tipton","Tipton","Tipton","Tipton","Tiptonville","Tire Hill","Tiro","Tishomingo","Tishomingo","Tiskilwa","Titonka","Titus","Titusville","Titusville","Titusville","Tiverton","Tivoli","Tivoli","Toano","Tobaccoville","Tobyhanna","Toccoa","Toccoa Falls","Todd","Toddville","Tofte","Togiak","Toivola","Tok","Toksook Bay","Tolar","Toledo","Toledo","Toledo","Toledo","Toledo","Tolland","Tollesboro","Tolleson","Tollhouse","Tolna","Tolono","Toluca","Tom Bean","Tomah","Tomahawk","Tomahawk","Tomball","Tombstone","Tomkins Cove","Tompkinsville","Toms Brook","Toms River","Tonasket","Tonawanda","Tonawanda","Toney","Tonganoxie","Tonica","Tonkawa","Tonopah","Tontitown","Tonto Basin","Tony","Tooele","Toomsboro","Toomsuba","Toone","Topanga","Topeka","Topeka","Topock","Toppenish","Topping","Topsfield","Topsham","Topton","Topton","Tornado","Tornillo","Toronto","Toronto","Toronto","Torrance","Torrance","Torreon","Torrey","Torrington","Torrington","Totowa","Totz","Tougaloo","Toughkenamon","Toulon","Toutle","Tovey","Towaco","Towanda","Towanda","Towanda","Tower","Tower City","Tower City","Tower Hill","Town Creek","Town of Boxborough","Town of Bozrah","Town of East Lyme","Town of Mount Desert","Towner","Townsend","Townsend","Townsend","Townsend","Townsend","Townshend","Townville","Townville","Towson","Toxey","Trabuco Canyon","Tracy","Tracy","Tracy City","Tracys Landing","Tracyton","Trade","Traer","Trafalgar","Trafford","Trafford","Trail","Trail","Transfer","Traphill","Trappe","Travelers Rest","Traverse City","Treadwell","Trego","Treichlers","Trementina","Tremont","Tremont","Tremont","Tremonton","Trempealeau","Trenary","Trent","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Trenton","Tres Pinos","Tresckow","Trevett","Trevor","Trevorton","Trexlertown","Treynor","Trezevant","Triadelphia","Triangle","Tribes Hill","Tribune","Trimble","Trimont","Trinidad","Trinidad","Trinidad","Trinity","Trinity","Trinity","Trion","Tripoli","Tripp","Triumph","Trivoli","Trona","Tropic","Trosper","Troup","Troupsburg","Trout Creek","Trout Creek","Trout Creek","Trout Run","Troutdale","Troutman","Troutville","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Troy","Truchas","Truckee","Trufant","Truman","Trumann","Trumansburg","Trumbauersville","Trumbull","Trumbull","Truro","Truro","Trussville","Truth or Consequences","Truxton","Tryon","Tryon","Tryon","Tsaile","Tualatin","Tuba City","Tubac","Tuckahoe","Tuckahoe","Tuckasegee","Tucker","Tucker","Tuckerman","Tuckerton","Tucson","Tucumcari","Tujunga","Tulare","Tulare County","Tularosa","Tulelake","Tulia","Tullahoma","Tully","Tulsa","Tumacacori","Tumtum","Tumwater","Tunas","Tunbridge","Tunica","Tunkhannock","Tunnel Hill","Tunnelton","Tuntutuliak","Tuolumne","Tupelo","Tupelo","Tupelo","Tupper Lake","Turbeville","Turbotville","Turin","Turkey","Turkey Creek","Turlock","Turner","Turner","Turner","Turner","Turners Falls","Turners Station","Turnerville","Turpin","Turtle Creek","Turtle Creek","Turtle Lake","Tuscaloosa","Tuscarawas","Tuscola","Tuscola","Tuscumbia","Tuscumbia","Tuskegee","Tustin","Tustin","Tutor Key","Tuttle","Tutwiler","Tuxedo Park","Twain Harte","Twelve Mile","Twentynine Palms","Twin Bridges","Twin City","Twin Falls","Twin Lake","Twin Lakes","Twin Peaks","Twin Valley","Twining","Twinsburg","Twisp","Two Buttes","Two Harbors","Two Rivers","Two Rivers","Tyaskin","Tybee Island","Tybo","Tygh Valley","Tyler","Tyler","Tyler","Tylertown","Tyndall","Tyner","Tyngsboro","Tyringham","Tyrone","Tyrone","Tyrone","Tyronza","Ubly","Udall","Uhrichsville","Ukiah","Uledi","Ulen","Ullin","Ulm","Ulster","Ulster Park","Ulysses","Ulysses","Ulysses","Umatilla","Umatilla","Umpire","Unadilla","Unadilla","Unadilla","Unalakleet","Unalaska","Uncasville","Underhill","Underwood","Underwood","Underwood","Underwood","Underwood","Unicoi","Union","Union","Union","Union","Union","Union","Union","Union","Union","Union","Union","Union","Union","Union Bridge","Union City","Union City","Union City","Union City","Union City","Union City","Union City","Union City","Union City","Union Dale","Union Grove","Union Grove","Union Hall","Union Hill","Union Lake","Union Mills","Union Mills","Union Point","Union Springs","Union Springs","Union Star","Union Township","Uniondale","Uniondale","Uniontown","Uniontown","Uniontown","Uniontown","Unionville","Unionville","Unionville","Unionville","Unionville","Unionville","Unionville","Unionville","Unity","Unity","Universal City","Universal City","University","University","University Park","University Park","University Place","Unorganized Territory of Camp Lejeune","Upatoi","Upland","Upland","Upper Abbot","Upper Black Eddy","Upper Darby","Upper Falls","Upper Jay","Upper Marlboro","Upper Saddle River","Upper Sandusky","Upperco","Upperville","Upsala","Upton","Upton","Upton","Upton","Urbana","Urbana","Urbana","Urbana","Urbana","Urbandale","Urbanna","Uriah","Urich","Ursa","Ute","Utica","Utica","Utica","Utica","Utica","Utica","Utica","Utica","Utica","Utopia","Uvalda","Uvalde","Uxbridge","Vacaville","Vacherie","Vader","Vail","Vail","Vails Gate","Valatie","Valders","Valdese","Valdez","Valdosta","Vale","Vale","Valencia","Valencia","Valentine","Valentines","Valera","Valhalla","Valhermoso Springs","Valier","Valier","Valle","Vallecito","Vallejo","Valles Mines","Valley","Valley","Valley","Valley","Valley Bend","Valley Center","Valley Center","Valley City","Valley City","Valley Cottage","Valley Falls","Valley Falls","Valley Farms","Valley Forge","Valley Green","Valley Head","Valley Head","Valley Mills","Valley Park","Valley Springs","Valley Springs","Valley Springs","Valley Stream","Valley View","Valley View","Valley Village","Valleyford","Valliant","Vallonia","Valmeyer","Valparaiso","Valparaiso","Valparaiso","Valrico","Van","Van","Van Alstyne","Van Buren","Van Buren","Van Buren","Van Dyne","Van Etten","Van Horn","Van Horne","Van Lear","Van Meter","Van Nuys","Van Vleck","Van Vleet","Van Wert","Van Wert","Van Wyck","Vance","Vanceburg","Vancleave","Vancouver","Vandalia","Vandalia","Vandalia","Vandalia","Vanderbilt","Vanderbilt","Vandergrift","Vandiver","Vanleer","Vanlue","Vansant","Vanzant","Vardaman","Varna","Varnville","Vashon","Vass","Vassalboro","Vassar","Vassar","Vaughan","Vaughn","Vauxhall","Veblen","Veedersburg","Vega","Velarde","Velva","Vendor","Venedocia","Veneta","Venetia","Venice","Venice","Ventnor City","Ventress","Ventura","Ventura","Venus","Venus","Veradale","Verbank","Verdi","Verdigre","Verdon","Verdugo City","Verdunville","Vergas","Vergennes","Vergennes","Vermilion","Vermillion","Vermillion","Vermillion","Vermont","Vermontville","Vernal","Verndale","Vernon","Vernon","Vernon","Vernon","Vernon","Vernon","Vernon","Vernon","Vernon","Vernon Center","Vernon Hill","Vernon Hills","Vernonia","Vero Beach","Verona","Verona","Verona","Verona","Verona","Verona","Verona","Verona","Verplanck","Versailles","Versailles","Versailles","Versailles","Versailles","Versailles","Vershire","Vesper","Vesta","Vestaburg","Vestaburg","Vestal","Vesuvius","Vevay","Veyo","Vian","Viborg","Viburnum","Vicco","Vici","Vicksburg","Vicksburg","Victor","Victor","Victor","Victor","Victoria","Victoria","Victoria","Victorville","Vida","Vida","Vidalia","Vidalia","Vidor","Vienna","Vienna","Vienna","Vienna","Vienna","Vienna","Vilas","Vilas","Villa Grove","Villa Park","Villa Park","Villa Rica","Villa Ridge","Villa Ridge","Village","Village Mills","Villanova","Villanueva","Villard","Villas","Ville Platte","Villisca","Vilonia","Vina","Vina","Vinalhaven","Vincennes","Vincent","Vincent","Vincentown","Vine Grove","Vineland","Vinemont","Vineyard Haven","Vining","Vinita","Vinton","Vinton","Vinton","Vinton","Vintondale","Viola","Viola","Viola","Viola","Viola","Viola","Violet","Violet Hill","Viper","Virden","Virgie","Virgilina","Virgin","Virginia","Virginia","Virginia Beach","Viroqua","Visalia","Vista","Vivian","Volborg","Volcano","Volga","Volga","Volga","Voluntown","Von Ormy","Vona","Vonore","Voorhees Township","Voorheesville","Vulcan","Waban","Wabash","Wabasha","Wabasso","Waccabuc","Wachapreague","Waco","Waco","Waco","Waco","Waconia","Waddell","Waddy","Wade","Wadena","Wadesboro","Wadesville","Wading River","Wadley","Wadmalaw Island","Wadsworth","Wadsworth","Waelder","Wagener","Wagner","Wagoner","Wahiawa","Wahkon","Wahoo","Wahpeton","Waialua","Waikoloa","Wailuku","Waimanalo","Wainscott","Wainwright","Wainwright","Waipahu","Waite Park","Waitsburg","Waitsfield","Wakarusa","Wake","Wake Forest","WaKeeney","Wakefield","Wakefield","Wakefield","Wakefield","Wakefield","Wakefield","Wakefield","Wakeman","Wakita","Wakonda","Walbridge","Walcott","Walden","Waldo","Waldo","Waldo","Waldo","Waldoboro","Waldorf","Waldorf","Waldport","Waldron","Waldron","Waldron","Waldwick","Wales","Wales","Waleska","Walford","Walhalla","Walhalla","Walhalla","Walhonding","Walker","Walker","Walker","Walker","Walker Valley","Walkersville","Walkersville","Walkerton","Walkertown","Walkerville","Wall","Wall Lake","Walla Walla","Wallace","Wallace","Wallace","Wallace","Wallace","Wallace","Wallace","Wallaceton","Walland","Wallback","Wallburg","Walled Lake","Waller","Wallingford","Wallingford","Wallingford","Wallingford","Wallingford","Wallington","Wallins Creek","Wallis","Wallkill","Wallowa","Walls","Wallsburg","Walnut","Walnut","Walnut","Walnut","Walnut","Walnut Bottom","Walnut Cove","Walnut Creek","Walnut Grove","Walnut Grove","Walnut Grove","Walnut Grove","Walnut Ridge","Walnut Shade","Walnut Springs","Walnutport","Walpole","Walpole","Walpole","Walsenburg","Walsh","Walshville","Walstonburg","Walterboro","Walters","Waltham","Walthill","Walton","Walton","Walton","Walton","Walton","Walton","Waltonville","Walworth","Walworth","Wamego","Wampsville","Wampum","Wamsutter","Wana","Wanakena","Wanamingo","Wanaque","Wanatah","Wanchese","Waneta","Wanette","Wannaska","Wantagh","Wapakoneta","Wapato","Wapella","Wapello","Wappapello","Wappingers Falls","Wapwallopen","War","Warba","Ward","Ward","Warden","Wardensville","Ware","Ware Neck","Ware Shoals","Wareham","Waretown","Warfordsburg","Warm Springs","Warm Springs","Warminster","Warne","Warner","Warner","Warner Robins","Warner Springs","Warners","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren","Warren Center","Warren Township","Warrendale","Warrens","Warrensburg","Warrensburg","Warrensburg","Warrensville","Warrenton","Warrenton","Warrenton","Warrenton","Warrenton","Warrenville","Warrenville","Warrington","Warrior","Warriors Mark","Warroad","Warsaw","Warsaw","Warsaw","Warsaw","Warsaw","Warsaw","Warsaw","Warsaw","Warsaw","Wartburg","Wartrace","Warwick","Warwick","Warwick","Warwick","Warwick","Wasco","Waseca","Washburn","Washburn","Washburn","Washburn","Washburn","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington","Washington Boro","Washington Court House","Washington Crossing","Washington Grove","Washington Township","Washingtonville","Washingtonville","Washougal","Wasilla","Waskom","Wassaic","Watauga","Watchung","Water Mill","Water Valley","Waterboro","Waterbury","Waterbury","Waterbury Center","Waterford","Waterford","Waterford","Waterford","Waterford","Waterford","Waterford","Waterford","Waterford","Waterford","Waterford Flat","Waterford Works","Waterloo","Waterloo","Waterloo","Waterloo","Waterloo","Waterloo","Waterloo","Waterman","Waterport","Waterproof","Waters","Watersmeet","Watertown","Watertown","Watertown","Watertown","Watertown","Watertown","Watertown","Waterville","Waterville","Waterville","Waterville","Waterville","Waterville","Waterville Valley","Watervliet","Watervliet","Watford City","Wathena","Watkins","Watkins Glen","Watkinsville","Watonga","Watseka","Watson","Watson","Watsontown","Watsonville","Watts","Wattsburg","Wattsville","Waubun","Wauchula","Waucoma","Wauconda","Waukee","Waukegan","Waukesha","Waukomis","Waukon","Waunakee","Wauneta","Waupaca","Waupun","Wauregan","Waurika","Wausa","Wausau","Wauseon","Wautoma","Waveland","Waveland","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly","Waverly Hall","Wawaka","Waxahachie","Waxhaw","Waycross","Wayland","Wayland","Wayland","Wayland","Wayland","Waymart","Wayne","Wayne","Wayne","Wayne","Wayne","Wayne","Wayne","Wayne","Wayne","Wayne City","Waynesboro","Waynesboro","Waynesboro","Waynesboro","Waynesboro","Waynesburg","Waynesburg","Waynesburg","Waynesfield","Waynesville","Waynesville","Waynesville","Waynesville","Waynetown","Waynoka","Wayzata","Weare","Weatherford","Weatherford","Weatherly","Weatogue","Weaubleau","Weaver","Weaverville","Weaverville","Webb","Webb","Webb City","Webbers Falls","Webberville","Weber City","Webster","Webster","Webster","Webster","Webster","Webster","Webster","Webster","Webster","Webster City","Webster Springs","Wedowee","Weed","Weedsport","Weedville","Weehawken","Weeksbury","Weems","Weeping Water","Weidman","Weimar","Weimar","Weiner","Weippe","Weir","Weir","Weirsdale","Weirton","Weiser","Welaka","Welch","Welch","Welch","Welches","Welcome","Welcome","Welcome","Weldon","Weldon","Weldon","Weleetka","Wellborn","Wellborn","Wellesley","Wellesley Hills","Wellfleet","Wellford","Wellington","Wellington","Wellington","Wellington","Wellington","Wellington","Wellington","Wellington","Wellington","Wellman","Wellman","Wellpinit","Wells","Wells","Wells","Wells","Wells","Wells","Wellsboro","Wellsburg","Wellsburg","Wellsley","Wellston","Wellston","Wellston","Wellsville","Wellsville","Wellsville","Wellsville","Wellsville","Wellsville","Wellton","Welsh","Wenatchee","Wendel","Wendell","Wendell","Wendell","Wendell","Wenden","Wendover","Wenham","Wenona","Wenonah","Wentworth","Wentworth","Wentzville","Wernersville","Weskan","Weslaco","Wesley","Wesley Chapel","Wessington","Wessington Springs","Wesson","West","West","West Alexander","West Alexandria","West Alton","West Babylon","West Baldwin","West Barnstable","West Bend","West Bend","West Berlin","West Blocton","West Bloomfield","West Boylston","West Branch","West Branch","West Briar","West Bridgewater","West Brookfield","West Burke","West Burlington","West Chatham","West Chazy","West Chester","West Chester","West Chester","West Chesterfield","West Chicago","West Columbia","West Columbia","West Concord","West Corinth","West Cornwall","West Cornwall","West Covina","West Coxsackie","West Creek","West Danville","West Decatur","West Dennis","West Des Moines","West Dover","West Dummerston","West Dundee","West Durham","West Edmeston","West End","West Enfield","West Falls","West Falmouth","West Fargo","West Farmington","West Finley","West Fork","West Frankfort","West Friendship","West Glover","West Granby","West Green","West Greenwich","West Groton","West Grove","West Hamlin","West Harrison","West Hartford","West Hartland","West Harwich","West Haven","West Haverstraw","West Helena","West Hempstead","West Henrietta","West Hills","West Hollywood","West Islip","West Jefferson","West Jefferson","West Jordan","West Kingston","West Lafayette","West Lafayette","West Lebanon","West Lebanon","West Leyden","West Liberty","West Liberty","West Liberty","West Linn","West Long Branch","West Louisville","West Manchester","West Mansfield","West McLean","West Memphis","West Middlesex","West Middleton","West Mifflin","West Milford","West Milton","West Mineral","West Minot","West Monroe","West Monroe","West New York","West Newbury","West Newbury","West Newton","West Newton","West Newton","West Nyack","West Olive","West Orange","West Paducah","West Palm Beach","West Paris","West Park","West Pawlet","West Pittsburg","West Plains","West Point","West Point","West Point","West Point","West Point","West Point","West Point","West Point","West Point","West Point","West Portsmouth","West Richland","West River","West Rockport","West Roxbury","West Rutland","West Sacramento","West Salem","West Salem","West Salem","West Sand Lake","West Sayville","West Shokan","West Simsbury","West Springfield","West Springfield","West Stockbridge","West Stockholm","West Suffield","West Sunbury","West Swanzey","West Terre Haute","West Tisbury","West Topsham","West Townsend","West Union","West Union","West Union","West Union","West Union","West Unity","West Valley","West Van Lear","West Wardsboro","West Wareham","West Warwick","West Wendover","West Winfield","West Yarmouth","West Yellowstone","Westboro","Westboro","Westborough","Westbrook","Westbrook","Westbrook","Westbrookville","Westbury","Westby","Westby","Westchester","Westcliffe","Westerlo","Westerly","Western Grove","Western Springs","Westernport","Westernville","Westerville","Westfield","Westfield","Westfield","Westfield","Westfield","Westfield","Westfield","Westfield","Westfield","Westfield","Westfield Center","Westford","Westford","Westford","Westgate","Westhampton","Westhampton Beach","Westhope","Westlake","Westlake","Westlake Village","Westland","Westland","Westley","Westminster","Westminster","Westminster","Westminster","Westminster","Westminster","Westmont","Westmoreland","Westmoreland","Westmoreland","Westmoreland","Westmoreland City","Weston","Weston","Weston","Weston","Weston","Weston","Weston","Weston","Westover","Westphalia","Westphalia","Westphalia","Westpoint","Westport","Westport","Westport","Westport","Westport","Westport","Westside","Westtown","Westtown","Westview","Westville","Westville","Westville","Westville","Westville","Westville","Westwego","Westwood","Westwood","Westwood","Wethersfield","Wetmore","Wetumka","Wetumpka","Wewahitchka","Wewoka","Wexford","Weyauwega","Weyerhaeuser","Weyers Cave","Weymouth","Whaleyville","Wharncliffe","Wharton","Wharton","Wharton","Wharton","What Cheer","Whately","Whatley","Wheat Ridge","Wheatfield","Wheatland","Wheatland","Wheatland","Wheatland","Wheatland","Wheatland","Wheatland","Wheatland","Wheaton","Wheaton","Wheeler","Wheeler","Wheeler","Wheeler","Wheelersburg","Wheeling","Wheeling","Wheeling","Wheelwright","Whigham","Whippany","Whipple","Whitakers","White","White","White Bear Lake","White Bird","White Bluff","White Castle","White City","White City","White Cloud","White Cloud","White Deer","White Hall","White Hall","White Hall","White Haven","White Heath","White House","White Lake","White Lake","White Lake","White Marsh","White Mountain Lake","White Oak","White Oak","White Oak","White Pigeon","White Pine","White Plains","White Plains","White Plains","White Plains","White Post","White River Junction","White Salmon","White Sands","White Springs","White Stone","White Sulphur Springs","White Sulphur Springs","White Swan","White Water","Whiteface","Whitefield","Whitefield","Whitefield","Whitefish","Whiteford","Whitehall","Whitehall","Whitehall","Whitehall","Whitehall Township","Whitehouse","Whitehouse","Whitehouse","Whitehouse Station","Whiteland","Whiteman Air Force Base","Whiteriver","Whites Creek","Whitesboro","Whitesboro","Whitesburg","Whitesburg","Whitesburg","Whiteside","Whitestone","Whitestown","Whitesville","Whitesville","Whitesville","Whitethorn","Whiteville","Whitewater","Whitewater","Whitewater","Whitewright","Whiting","Whiting","Whiting","Whiting","Whiting","Whitingham","Whitinsville","Whitley City","Whitman","Whitman","Whitman","Whitmire","Whitmore","Whitmore Lake","Whitney","Whitney Point","Whitsett","Whittemore","Whittemore","Whittier","Whittier","Whittington","Whitwell","Wibaux","Wichita","Wichita Falls","Wickenburg","Wickes","Wickliffe","Wickliffe","Wiconisco","Widener","Wiergate","Wiggins","Wiggins","Wilber","Wilberforce","Wilbraham","Wilbur","Wilburton","Wilburton","Wilcox","Wilcox","Wild Rose","Wilder","Wilder","Wilderville","Wildomar","Wildorado","Wildwood","Wildwood","Wildwood","Wildwood","Wiley","Wilkes Barre","Wilkesboro","Wilkinson","Willacoochee","Willamina","Willapa","Willard","Willard","Willard","Willard","Willcox","Willet","Williams","Williams","Williams","Williams","Williams","Williams Bay","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsburg","Williamsfield","Williamson","Williamson","Williamson","Williamsport","Williamsport","Williamsport","Williamsport","Williamsport","Williamsport","Williamston","Williamston","Williamston","Williamstown","Williamstown","Williamstown","Williamstown","Williamstown","Williamstown","Williamstown","Williamstown","Williamsville","Williamsville","Williamsville","Willimantic","Willingboro","Willis","Willis","Willis","Willis Wharf","Willisburg","Williston","Williston","Williston","Williston","Williston","Williston","Williston Park","Willisville","Willits","Willmar","Willoughby","Willow Creek","Willow Grove","Willow Hill","Willow Lake","Willow River","Willow Springs","Willow Springs","Willow Springs","Willow Street","Willowbrook","Willows","Wills Point","Willsboro","Willseyville","Willshire","Wilmar","Wilmer","Wilmer","Wilmerding","Wilmette","Wilmington","Wilmington","Wilmington","Wilmington","Wilmington","Wilmington","Wilmington","Wilmont","Wilmore","Wilmore","Wilmot","Wilmot","Wilmot","Wilsall","Wilsey","Wilseyville","Wilson","Wilson","Wilson","Wilson","Wilson","Wilson","Wilson","Wilson","Wilson","Wilsonville","Wilsonville","Wilton","Wilton","Wilton","Wilton","Wilton","Wilton","Wilton","Wilton Manors","Wimauma","Wimberley","Wimbledon","Winamac","Winchendon","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester","Winchester Center","Wind Gap","Wind Ridge","Windber","Winder","Windermere","Windfall","Windham","Windham","Windham","Windham","Windham Center","Windom","Windom","Window Rock","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor","Windsor Heights","Windsor Locks","Windsor Mill","Windthorst","Winesburg","Winfield","Winfield","Winfield","Winfield","Winfield","Winfield","Winfield","Winfield","Wing","Wing","Wingate","Wingate","Wingdale","Winger","Wingina","Wingo","Winifrede","Wink","Winlock","Winnebago","Winnebago","Winnebago","Winneconne","Winnemucca","Winner","Winnetka","Winnetka","Winnett","Winnfield","Winnie","Winnsboro","Winnsboro","Winnsboro","Winona","Winona","Winona","Winona","Winona Lake","Winooski","Winside","Winslow","Winslow","Winslow","Winslow","Winslow Township","Winsted","Winsted","Winston","Winston","Winston","Winston","Winston-Salem","Winter","Winter Garden","Winter Harbor","Winter Haven","Winter Park","Winter Park","Winter Springs","Winterhaven","Winterport","Winters","Winters","Winterset","Winterthur","Winterville","Winterville","Winthrop","Winthrop","Winthrop","Winthrop","Winthrop","Winthrop","Winthrop","Winthrop Harbor","Winton","Winton","Wiota","Wirtz","Wiscasset","Wisconsin Dells","Wisconsin Rapids","Wisdom","Wise","Wishek","Wisner","Wisner","Wister","Withams","Withee","Witt","Witten","Wittenberg","Wittensville","Wittmann","Wixom","Woburn","Woden","Wofford Heights","Wolbach","Wolcott","Wolcott","Wolcott","Wolcott","Wolcottville","Wolf Point","Wolfe City","Wolfeboro","Wolfeboro Falls","Wolfforth","Wolford","Wolverton","Womelsdorf","Wonder Lake","Wonewoc","Wood Dale","Wood Lake","Wood River","Wood River","Wood River Junction","Wood-Ridge","Woodacre","Woodberry Forest","Woodbine","Woodbine","Woodbine","Woodbine","Woodbine","Woodbine","Woodbourne","Woodbridge","Woodbridge","Woodbridge","Woodbridge","Woodburn","Woodburn","Woodburn","Woodburn","Woodbury","Woodbury","Woodbury","Woodbury","Woodbury","Woodbury Heights","Woodcliff Lake","Woodford","Woodgate","Woodhaven","Woodhull","Woodhull","Woodinville","Woodlake","Woodlake","Woodland","Woodland","Woodland","Woodland","Woodland","Woodland","Woodland","Woodland Hills","Woodland Mills","Woodland Park","Woodlawn","Woodlawn","Woodlawn","Woodlawn","Woodleaf","Woodlyn","Woodmere","Woodridge","Woodridge","Woodruff","Woodruff","Woodruff","Woodruff","Woods Cross","Woods Hole","Woodsboro","Woodsboro","Woodsfield","Woodside","Woodside","Woodson","Woodstock","Woodstock","Woodstock","Woodstock","Woodstock","Woodstock","Woodstock","Woodstock","Woodstock","Woodstown","Woodsville","Woodville","Woodville","Woodville","Woodville","Woodville","Woodward","Woodward","Woodward","Woodway","Woodworth","Woodworth","Woolstock","Woolwich","Woonsocket","Woonsocket","Wooster","Wooton","Worcester","Worcester","Worcester","Worden","Worden","Worland","Worley","Worth","Wortham","Worthing","Worthington","Worthington","Worthington","Worthington","Worthington","Worthington","Worthington Center","Worthington Springs","Worthville","Worton","Wray","Wray","Wrens","Wrenshall","Wrentham","Wright","Wright","Wright City","Wright City","Wrightstown","Wrightstown","Wrightsville","Wrightsville","Wrightsville Beach","Wrightwood","Wurtsboro","Wyaconda","Wyalusing","Wyandanch","Wyandotte","Wyandotte","Wyanet","Wyckoff","Wyco","Wye Mills","Wykoff","Wylie","Wylliesburg","Wymore","Wynantskill","Wyncote","Wyndmere","Wynne","Wynnewood","Wynnewood","Wynona","Wynot","Wyocena","Wyoming","Wyoming","Wyoming","Wyoming","Wyoming","Wyoming","Wyoming","Wyoming","Wyoming","Wysox","Wytheville","Xenia","Xenia","Yachats","Yacolt","Yadkinville","Yakima","Yalaha","Yale","Yale","Yale","Yale","Yamhill","Yampa","Yanceyville","Yankeetown","Yankton","Yantis","Yaphank","Yarmouth","Yarmouth","Yarmouth Port","Yates Center","Yates City","Yatesboro","Yatesville","Yazoo City","Yeaddiss","Yellow Spring","Yellow Springs","Yellville","Yelm","Yemassee","Yerington","Yermo","Yoakum","Yoder","Yoder","Yolyn","Yoncalla","Yonkers","Yorba Linda","York","York","York","York","York","York Beach","York Corner","York Harbor","York Haven","York Springs","Yorkshire","Yorktown","Yorktown","Yorktown","Yorktown Heights","Yorkville","Yorkville","Yorkville","Yosemite Valley","Young","Young America","Young Harris","Youngstown","Youngstown","Youngstown","Youngstown","Youngsville","Youngsville","Youngsville","Youngtown","Youngwood","Yountville","Ypsilanti","Ypsilanti","Yreka","Yuba City","Yucaipa","Yucca","Yucca Valley","Yukon","Yukon","Yulan","Yulee","Yuma","Yuma","Yuma","Yutan","Zachary","Zaleski","Zalma","Zanesfield","Zanesville","Zanesville","Zapata","Zarephath","Zavalla","Zearing","Zebulon","Zebulon","Zeeland","Zeeland","Zeigler","Zelienople","Zellwood","Zenda","Zephyr","Zephyr Cove","Zephyrhills","Zieglersville","Zillah","Zimmerman","Zion","Zion Grove","Zionhill","Zionsville","Zionsville","Zionville","Zirconia","Zolfo Springs","Zortman","Zullinger","Zumbrota","Zuni","Zurich","Zwingle"],"Uruguay":["Barra de Carrasco","Canelones","Colonia del Sacramento","Durazno","Florida","La Floresta","La Paz","Las Piedras","Maldonado","Mercedes","Montevideo","Punta del Este","Salto","San Carlos","Toledo","Union"],"Venezuela":["Acarigua","Anaco","Araure","Bachaquero","Barcelona","Barinas","Barquisimeto","Bejuma","Bolivar","Cabimas","Cabudare","Cagua","Caja de Agua","Calabozo","Campo de Carabobo","Caraballeda","Caracas","Caripe","Carrizal","Catia La Mar","Charallave","Chivacoa","Ciudad Guayana","Ciudad Ojeda","Ciudad Piar","Colonia Tovar","Coro","Cua","Curazaito","El Chorro","El Recreo","El Roque","El Rosal","El Tigre","El Vigia","Guachara","Guanare","Guarenas","Guatire","Guayana","Gueiria","La Castellana","La Cruz","La Guaira","La Urbina","La Verdad","La Victoria","La Villa del Rosario","Londres","Los Chorros","Los Teques","Macuto","Maiquetia","Maracaibo","Maracay","Maria","Mariguitar","Matanzas","Miranda","Monte Cristo","Naguanagua","Ocumare","Pampatar","Porlamar","Puerto Cabello","Puerto La Cruz","Puerto Ordaz and San Felix","Punto Fijo","Sabaneta","San Antonio","San Antonio de Los Altos","San Diego","San Felipe","San Felix","San Francisco","San Joaquin","San Jose de Guanipa","Santa Cruz del Zulia","Santa Fe","Santa Teresa","Solano","Tariba","Torre","Trujillo","Tucupita","Turmero","Valencia","Valera","Valle","Vargas"],"Vietnam":["Ho Chi Minh City","Hanoi","Da Nang","Hai Phong","Can Tho","Bien Hoa","Hue","Nha Trang","Vinh","Qui Nhon"],"Zambia":["Kalomo","Kitwe","Livingstone","Lusaka","Macha","Mumbwa","Ndola","Siavonga","Solwezi"],"Zimbabwe":["Bulawayo","Chinhoyi","Greendale","Gwanda","Harare","Kwekwe","Mufakose","Mutare","Victoria Falls"]}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = [{"cc":"AF","cn":"Afghanistan","dc":"+93"},{"cc":"AL","cn":"Albania","dc":"+355"},{"cc":"DZ","cn":"Algeria","dc":"+213"},{"cc":"AS","cn":"American Samoa","dc":"+1"},{"cc":"AD","cn":"Andorra","dc":"+376"},{"cc":"AO","cn":"Angola","dc":"+244"},{"cc":"AI","cn":"Anguilla","dc":"+1"},{"cc":"AG","cn":"Antigua","dc":"+1"},{"cc":"AR","cn":"Argentina","dc":"+54"},{"cc":"AM","cn":"Armenia","dc":"+374"},{"cc":"AW","cn":"Aruba","dc":"+297"},{"cc":"AU","cn":"Australia","dc":"+61"},{"cc":"AI","cn":"Austria","dc":"+43"},{"cc":"AZ","cn":"Azerbaijan","dc":"+994"},{"cc":"BH","cn":"Bahrain","dc":"+973"},{"cc":"BD","cn":"Bangladesh","dc":"+880"},{"cc":"BB","cn":"Barbados","dc":"+1"},{"cc":"BY","cn":"Belarus","dc":"+375"},{"cc":"BE","cn":"Belgium","dc":"+32"},{"cc":"BZ","cn":"Belize","dc":"+501"},{"cc":"BJ","cn":"Benin","dc":"+229"},{"cc":"BM","cn":"Bermuda","dc":"+1"},{"cc":"BT","cn":"Bhutan","dc":"+975"},{"cc":"BO","cn":"Bolivia","dc":"+591"},{"cc":"BA","cn":"Bosnia and Herzegovina","dc":"+387"},{"cc":"BW","cn":"Botswana","dc":"+267"},{"cc":"BR","cn":"Brazil","dc":"+55"},{"cc":"IO","cn":"British Indian Ocean Territory","dc":"+246"},{"cc":"VG","cn":"British Virgin Islands","dc":"+1"},{"cc":"BN","cn":"Brunei","dc":"+673"},{"cc":"BG","cn":"Bulgaria","dc":"+359"},{"cc":"BF","cn":"Burkina Faso","dc":"+226"},{"cc":"MM","cn":"Myanmar","dc":"+95"},{"cc":"BI","cn":"Burundi","dc":"+257"},{"cc":"KH","cn":"Cambodia","dc":"+855"},{"cc":"CM","cn":"Cameroon","dc":"+237"},{"cc":"CA","cn":"Canada","dc":"+1"},{"cc":"CV","cn":"Cape Verde","dc":"+238"},{"cc":"KY","cn":"Cayman Islands","dc":"+1"},{"cc":"CF","cn":"Central African Republic","dc":"+236"},{"cc":"ID","cn":"Chad","dc":"+235"},{"cc":"CL","cn":"Chile","dc":"+56"},{"cc":"CN","cn":"China","dc":"+86"},{"cc":"CO","cn":"Colombia","dc":"+57"},{"cc":"KM","cn":"Comoros","dc":"+269"},{"cc":"CK","cn":"Cook Islands","dc":"+682"},{"cc":"CR","cn":"Costa Rica","dc":"+506"},{"cc":"CI","cn":"Côte dIvoire","dc":"+225"},{"cc":"HR","cn":"Croatia","dc":"+385"},{"cc":"CU","cn":"Cuba","dc":"+53"},{"cc":"CY","cn":"Cyprus","dc":"+357"},{"cc":"CZ","cn":"Czech Republic","dc":"+420"},{"cc":"CD","cn":"Democratic Republic of Congo","dc":"+243"},{"cc":"DK","cn":"Denmark","dc":"+45"},{"cc":"DJ","cn":"Djibouti","dc":"+253"},{"cc":"DM","cn":"Dominica","dc":"+1"},{"cc":"DO","cn":"Dominican Republic","dc":"+1"},{"cc":"EC","cn":"Ecuador","dc":"+593"},{"cc":"EG","cn":"Egypt","dc":"+20"},{"cc":"SV","cn":"El Salvador","dc":"+503"},{"cc":"GQ","cn":"Equatorial Guinea","dc":"+240"},{"cc":"ER","cn":"Eritrea","dc":"+291"},{"cc":"EE","cn":"Estonia","dc":"+372"},{"cc":"ET","cn":"Ethiopia","dc":"+251"},{"cc":"FK","cn":"Falkland Islands","dc":"+500"},{"cc":"FO","cn":"Faroe Islands","dc":"+298"},{"cc":"FM","cn":"Federated States of Micronesia","dc":"+691"},{"cc":"FJ","cn":"Fiji","dc":"+679"},{"cc":"FI","cn":"Finland","dc":"+358"},{"cc":"FR","cn":"France","dc":"+33"},{"cc":"GF","cn":"French Guiana","dc":"+594"},{"cc":"PF","cn":"French Polynesia","dc":"+689"},{"cc":"GA","cn":"Gabon","dc":"+241"},{"cc":"GE","cn":"Georgia","dc":"+995"},{"cc":"DE","cn":"Germany","dc":"+49"},{"cc":"GH","cn":"Ghana","dc":"+233"},{"cc":"GI","cn":"Gibraltar","dc":"+350"},{"cc":"GR","cn":"Greece","dc":"+30"},{"cc":"GL","cn":"Greenland","dc":"+299"},{"cc":"GD","cn":"Grenada","dc":"+1"},{"cc":"GP","cn":"Guadeloupe","dc":"+590"},{"cc":"GU","cn":"Guam","dc":"+1"},{"cc":"GT","cn":"Guatemala","dc":"+502"},{"cc":"GN","cn":"Guinea","dc":"+224"},{"cc":"GW","cn":"Guinea-Bissau","dc":"+245"},{"cc":"GY","cn":"Guyana","dc":"+592"},{"cc":"HT","cn":"Haiti","dc":"+509"},{"cc":"HN","cn":"Honduras","dc":"+504"},{"cc":"HK","cn":"Hong Kong","dc":"+852"},{"cc":"HU","cn":"Hungary","dc":"+36"},{"cc":"IS","cn":"Iceland","dc":"+354"},{"cc":"IN","cn":"India","dc":"+91"},{"cc":"ID","cn":"Indonesia","dc":"+62"},{"cc":"IR","cn":"Iran","dc":"+98"},{"cc":"IQ","cn":"Iraq","dc":"+964"},{"cc":"IE","cn":"Ireland","dc":"+353"},{"cc":"IL","cn":"Israel","dc":"+972"},{"cc":"IT","cn":"Italy","dc":"+39"},{"cc":"JM","cn":"Jamaica","dc":"+1"},{"cc":"JP","cn":"Japan","dc":"+81"},{"cc":"JO","cn":"Jordan","dc":"+962"},{"cc":"KZ","cn":"Kazakhstan","dc":"+7"},{"cc":"KE","cn":"Kenya","dc":"+254"},{"cc":"KI","cn":"Kiribati","dc":"+686"},{"cc":"XK","cn":"Kosovo","dc":"+383"},{"cc":"KW","cn":"Kuwait","dc":"+965"},{"cc":"KG","cn":"Kyrgyzstan","dc":"+996"},{"cc":"LA","cn":"Laos","dc":"+856"},{"cc":"LV","cn":"Latvia","dc":"+371"},{"cc":"LB","cn":"Lebanon","dc":"+961"},{"cc":"LS","cn":"Lesotho","dc":"+266"},{"cc":"LR","cn":"Liberia","dc":"+231"},{"cc":"LY","cn":"Libya","dc":"+218"},{"cc":"LI","cn":"Liechtenstein","dc":"+423"},{"cc":"LT","cn":"Lithuania","dc":"+370"},{"cc":"LU","cn":"Luxembourg","dc":"+352"},{"cc":"MO","cn":"Macau","dc":"+853"},{"cc":"MK","cn":"Macedonia","dc":"+389"},{"cc":"MG","cn":"Madagascar","dc":"+261"},{"cc":"MW","cn":"Malawi","dc":"+265"},{"cc":"MY","cn":"Malaysia","dc":"+60"},{"cc":"MV","cn":"Maldives","dc":"+960"},{"cc":"ML","cn":"Mali","dc":"+223"},{"cc":"MT","cn":"Malta","dc":"+356"},{"cc":"MH","cn":"Marshall Islands","dc":"+692"},{"cc":"MQ","cn":"Martinique","dc":"+596"},{"cc":"MR","cn":"Mauritania","dc":"+222"},{"cc":"MU","cn":"Mauritius","dc":"+230"},{"cc":"YT","cn":"Mayotte","dc":"+262"},{"cc":"MX","cn":"Mexico","dc":"+52"},{"cc":"MD","cn":"Moldova","dc":"+373"},{"cc":"MC","cn":"Monaco","dc":"+377"},{"cc":"MN","cn":"Mongolia","dc":"+976"},{"cc":"ME","cn":"Montenegro","dc":"+382"},{"cc":"MS","cn":"Montserrat","dc":"+1"},{"cc":"MA","cn":"Morocco","dc":"+212"},{"cc":"MZ","cn":"Mozambique","dc":"+258"},{"cc":"NA","cn":"Namibia","dc":"+264"},{"cc":"NR","cn":"Nauru","dc":"+674"},{"cc":"NP","cn":"Nepal","dc":"+977"},{"cc":"NL","cn":"Netherlands","dc":"+31"},{"cc":"AN","cn":"Netherlands Antilles","dc":"+599"},{"cc":"NC","cn":"New Caledonia","dc":"+687"},{"cc":"NZ","cn":"New Zealand","dc":"+64"},{"cc":"NI","cn":"Nicaragua","dc":"+505"},{"cc":"NE","cn":"Niger","dc":"+227"},{"cc":"NG","cn":"Nigeria","dc":"+234"},{"cc":"NU","cn":"Niue","dc":"+683"},{"cc":"NF","cn":"Norfolk Island","dc":"+672"},{"cc":"KP","cn":"North Korea","dc":"+850"},{"cc":"MP","cn":"Northern Mariana Islands","dc":"+1"},{"cc":"NO","cn":"Norway","dc":"+47"},{"cc":"OM","cn":"Oman","dc":"+968"},{"cc":"PK","cn":"Pakistan","dc":"+92"},{"cc":"PW","cn":"Palau","dc":"+680"},{"cc":"PS","cn":"Palestine","dc":"+970"},{"cc":"PA","cn":"Panama","dc":"+507"},{"cc":"PG","cn":"Papua New Guinea","dc":"+675"},{"cc":"PY","cn":"Paraguay","dc":"+595"},{"cc":"PE","cn":"Peru","dc":"+51"},{"cc":"PH","cn":"Philippines","dc":"+63"},{"cc":"PL","cn":"Poland","dc":"+48"},{"cc":"PT","cn":"Portugal","dc":"+351"},{"cc":"PR","cn":"Puerto Rico","dc":"+1"},{"cc":"QA","cn":"Qatar","dc":"+974"},{"cc":"CG","cn":"Republic of the Congo","dc":"+242"},{"cc":"RE","cn":"Réunion","dc":"+262"},{"cc":"RO","cn":"Romania","dc":"+40"},{"cc":"RU","cn":"Russia","dc":"+7"},{"cc":"RW","cn":"Rwanda","dc":"+250"},{"cc":"BL","cn":"Saint Barthélemy","dc":"+590"},{"cc":"SH","cn":"Saint Helena","dc":"+290"},{"cc":"KN","cn":"Saint Kitts and Nevis","dc":"+1"},{"cc":"MF","cn":"Saint Martin","dc":"+590"},{"cc":"PM","cn":"Saint Pierre and Miquelon","dc":"+508"},{"cc":"VC","cn":"Saint Vincent and the Grenadines","dc":"+1"},{"cc":"WS","cn":"Samoa","dc":"+685"},{"cc":"SM","cn":"San Marino","dc":"+378"},{"cc":"ST","cn":"São Tomé and Príncipe","dc":"+239"},{"cc":"SA","cn":"Saudi Arabia","dc":"+966"},{"cc":"SN","cn":"Senegal","dc":"+221"},{"cc":"RS","cn":"Serbia","dc":"+381"},{"cc":"SC","cn":"Seychelles","dc":"+248"},{"cc":"SL","cn":"Sierra Leone","dc":"+232"},{"cc":"SG","cn":"Singapore","dc":"+65"},{"cc":"SK","cn":"Slovakia","dc":"+421"},{"cc":"SI","cn":"Slovenia","dc":"+386"},{"cc":"SB","cn":"Solomon Islands","dc":"+677"},{"cc":"SO","cn":"Somalia","dc":"+252"},{"cc":"ZA","cn":"South Africa","dc":"+27"},{"cc":"KR","cn":"South Korea","dc":"+82"},{"cc":"ES","cn":"Spain","dc":"+34"},{"cc":"LK","cn":"Sri Lanka","dc":"+94"},{"cc":"LC","cn":"St. Lucia","dc":"+1"},{"cc":"SD","cn":"Sudan","dc":"+249"},{"cc":"SR","cn":"Suriname","dc":"+597"},{"cc":"SZ","cn":"Swaziland","dc":"+268"},{"cc":"SE","cn":"Sweden","dc":"+46"},{"cc":"CH","cn":"Switzerland","dc":"+41"},{"cc":"SY","cn":"Syria","dc":"+963"},{"cc":"TW","cn":"Taiwan","dc":"+886"},{"cc":"TJ","cn":"Tajikistan","dc":"+992"},{"cc":"TZ","cn":"Tanzania","dc":"+255"},{"cc":"TH","cn":"Thailand","dc":"+66"},{"cc":"BS","cn":"The Bahamas","dc":"+1"},{"cc":"GM","cn":"The Gambia","dc":"+220"},{"cc":"TL","cn":"Timor-Leste","dc":"+670"},{"cc":"TG","cn":"Togo","dc":"+228"},{"cc":"TK","cn":"Tokelau","dc":"+690"},{"cc":"TO","cn":"Tonga","dc":"+676"},{"cc":"TT","cn":"Trinidad and Tobago","dc":"+1"},{"cc":"TN","cn":"Tunisia","dc":"+216"},{"cc":"TR","cn":"Turkey","dc":"+90"},{"cc":"TM","cn":"Turkmenistan","dc":"+993"},{"cc":"TC","cn":"Turks and Caicos Islands","dc":"+1"},{"cc":"TV","cn":"Tuvalu","dc":"+688"},{"cc":"UG","cn":"Uganda","dc":"+256"},{"cc":"UA","cn":"Ukraine","dc":"+380"},{"cc":"AE","cn":"United Arab Emirates","dc":"+971"},{"cc":"GB","cn":"United Kingdom","dc":"+44"},{"cc":"US","cn":"United States","dc":"+1"},{"cc":"UY","cn":"Uruguay","dc":"+598"},{"cc":"VI","cn":"US Virgin Islands","dc":"+1"},{"cc":"UZ","cn":"Uzbekistan","dc":"+998"},{"cc":"VU","cn":"Vanuatu","dc":"+678"},{"cc":"VA","cn":"Vatican City","dc":"+39"},{"cc":"VE","cn":"Venezuela","dc":"+58"},{"cc":"VN","cn":"Vietnam","dc":"+84"},{"cc":"WF","cn":"Wallis and Futuna","dc":"+681"},{"cc":"YE","cn":"Yemen","dc":"+967"},{"cc":"ZM","cn":"Zambia","dc":"+260"},{"cc":"ZW","cn":"Zimbabwe","dc":"+263"}]

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = [
  {
    "bank": "DBS BANK LTD.",
    "code": "DBSSSGSGXXX"
  },
  {
    "bank": "POSB",
    "code": "DBSSSGSGXXX"
  },
  {
    "bank": "OCBC",
    "code": "OCBCSGSGXXX"
  },
  {
    "bank": "UNITED OVERSEAS BANK LIMITED",
    "code": "UOVBSGSGXXX"
  },
  {
    "bank": "ANEXT BANK",
    "code": "ANTPSGSGXXX"
  }
]


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortableDataTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sortablejs__ = __webpack_require__(302);


var SortableDataTable = {
  bind: function bind(el, binding, vnode) {
    if (!binding.hasOwnProperty('value') || binding.value) {
      var items = vnode.child.items;
      var options = {
        animation: 150,
        onUpdate: function onUpdate(event) {
          vnode.child.$emit('sorted', event, items);
        }
      };
      __WEBPACK_IMPORTED_MODULE_0_sortablejs__["a" /* default */].create(el.getElementsByTagName('tbody')[0], options);
    }
  }
};

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
/* unused harmony export parserQueries */
/* harmony export (immutable) */ __webpack_exports__["e"] = thousandSeprator;
/* harmony export (immutable) */ __webpack_exports__["f"] = currency;
/* harmony export (immutable) */ __webpack_exports__["g"] = abbr;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

function parserQueries(url, query) {
  for (var pro in query) {
    if (query.hasOwnProperty(pro)) {
      url = url + pro + '=' + query[pro] + '&';
    }
  }
  url = url.substring(0, url.length - 1);
  return url;
}

function thousandSeprator(value) {
  if (value !== '' && value !== undefined && value !== 0 && value !== '0' && value !== null) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return value;
  }
}

function currency(number) {
  if (number !== '' && number !== undefined && number !== 0 && number !== '0' && number !== null) {
    return number.toLocaleString('sg-SG', {
      style: 'currency',
      currency: 'SGD',
      minimumFractionDigits: 0
    });
  } else {
    return number;
  }
}

function abbr(num) {
  if (String(num).length < 4) {
    return num;
  } else if (String(num).length >= 4) {
    return Math.floor(num / 1000) + 'K';
  } else {
    return Math.floor(num / 1000000) + 'M';
  }
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DashVuetify_vue__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DashVuetify_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DashVuetify_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientLogin_vue__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ClientLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SelectInstagram_vue__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SelectInstagram_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SelectInstagram_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PrivateRegister_vue__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PrivateRegister_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PrivateRegister_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_vue__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ResetPasswordPage_vue__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ResetPasswordPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ResetPasswordPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_404_vue__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_User__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_User_Profile_vue__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_User_Profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_User_Profile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_User_UnApprovedUser_vue__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_User_UnApprovedUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_User_UnApprovedUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Influencer__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Influencer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_Influencer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Influencer_NonIMSLists_vue__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Influencer_NonIMSLists_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_Influencer_NonIMSLists_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Influencer_SearchKeyword__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Influencer_SearchKeyword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_Influencer_SearchKeyword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Influencer_SearchCreators__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Influencer_SearchCreators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_Influencer_SearchCreators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Pairing_CreatorConcept__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Pairing_CreatorConcept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_Pairing_CreatorConcept__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Campaign_CampaignPayoutList_vue__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Campaign_CampaignPayoutList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_Campaign_CampaignPayoutList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Influencer_CreateCampaignPayout_vue__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Influencer_CreateCampaignPayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_Influencer_CreateCampaignPayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_Instagram_handleAuth_vue__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_Instagram_handleAuth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_Instagram_handleAuth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Instagram_handleIntegrate_vue__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Instagram_handleIntegrate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_Instagram_handleIntegrate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_Company__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_Company___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_Company__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Client__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_Client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Client_CreateFeedbacksForm__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Client_CreateFeedbacksForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_Client_CreateFeedbacksForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_Client_FeedbacksForm_vue__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_Client_FeedbacksForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_Client_FeedbacksForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Pairing_CreatorConceptForm_Form_vue__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_Pairing_CreatorConceptForm_Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_Pairing_CreatorConceptForm_Form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Pairing_CreatorConceptForm_List_vue__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_Pairing_CreatorConceptForm_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_Pairing_CreatorConceptForm_List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Influencer_SigningForm_Form_vue__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_Influencer_SigningForm_Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_Influencer_SigningForm_Form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_Campaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_Campaign_Timeline__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_Campaign_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_Campaign_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Campaign_Timeline_Summary__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_Campaign_Timeline_Summary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_Campaign_Timeline_Summary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_Campaign_StatisticsAnalysis__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_Campaign_StatisticsAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_Campaign_StatisticsAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_Dashboard_vue__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_Campaign_CampaignBrief__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_Campaign_CampaignBrief___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_views_Campaign_CampaignBrief__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_Campaign_CampaignReport__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_Campaign_CampaignReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_views_Campaign_CampaignReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Campaign_CampaignsOverview__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Campaign_CampaignsOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_views_Campaign_CampaignsOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Campaign_AOKReport_index_vue__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Campaign_AOKReport_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_views_Campaign_AOKReport_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_views_Xero_XeroCallBackAuth__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_views_Xero_XeroCallBackAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_views_Xero_XeroCallBackAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_views_Campaign_CampaignReportInternal_vue__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_views_Campaign_CampaignReportInternal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_views_Campaign_CampaignReportInternal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_views_Campaign_InfluencerPosts__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_views_Campaign_InfluencerPosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_views_Campaign_InfluencerPosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_views_InfluencerSocialData__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_views_InfluencerSocialData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_views_InfluencerSocialData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_views_Campaign_CampaignInvite_CampaignInvite__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_views_Campaign_CampaignInvite_CampaignInvite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_views_Campaign_CampaignInvite_CampaignInvite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_views_Campaign_RateCard__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_views_Campaign_RateCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_views_Campaign_RateCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_views_Campaign_CampaignCompleted__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_views_Campaign_CampaignCompleted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_views_Campaign_CampaignCompleted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_views_Campaign_CampaignOngoing__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_views_Campaign_CampaignOngoing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_views_Campaign_CampaignOngoing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_views_ContentAnalysis__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_views_ContentAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_views_ContentAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_InfluencerSearch__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_views_InfluencerSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_views_InfluencerSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Influencer_KeywordSearch__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_views_Influencer_KeywordSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_views_Influencer_KeywordSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_views_Development_Express_Gateway_User__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_views_Development_Express_Gateway_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_views_Development_Express_Gateway_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_views_Development_API_Testing_vue__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_views_Development_API_Testing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_views_Development_API_Testing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_views_Post_CreateDraftPostV2__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_views_Post_CreateDraftPostV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_views_Post_CreateDraftPostV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_views_Post__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_views_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_views_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_views_Post_PostViewClient__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_views_Post_PostViewClient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_views_Post_PostViewClient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_views_Post_PostDetail__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_views_Post_PostDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_views_Post_PostDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_views_Post_SubmissionReview_vue__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_views_Post_SubmissionReview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_views_Post_SubmissionReview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_views_Influencer_SubmitPostPayout__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_views_Influencer_SubmitPostPayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_views_Influencer_SubmitPostPayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_views_Post_CalenderViewPosts_vue__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_views_Post_CalenderViewPosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_views_Post_CalenderViewPosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_views_User_CreatePrivateLink_vue__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_views_User_CreatePrivateLink_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_views_User_CreatePrivateLink_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_views_Finance_MoneyOut_vue__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_views_Finance_MoneyOut_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_views_Finance_MoneyOut_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_views_Finance_MoneyIn_vue__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_views_Finance_MoneyIn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_views_Finance_MoneyIn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_views_Finance_PaymentConsolidation_vue__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_views_Finance_PaymentConsolidation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_views_Finance_PaymentConsolidation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_views_Finance_ArchiveList_vue__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_views_Finance_ArchiveList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_views_Finance_ArchiveList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_views_Campaign_CampaignInvite_CampaignInviteDetail_vue__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_views_Campaign_CampaignInvite_CampaignInviteDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_views_Campaign_CampaignInvite_CampaignInviteDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_views_Campaign_PairingInfluencer_InvoicesBriefConfirmation_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_views_Campaign_PairingInfluencer_InvoicesBriefConfirmation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_views_Campaign_PairingInfluencer_InvoicesBriefConfirmation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_views_Campaign_PairingInfluencer_PaymentConsolidationStatus_vue__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_views_Campaign_PairingInfluencer_PaymentConsolidationStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_views_Campaign_PairingInfluencer_PaymentConsolidationStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_views_Campaign_PairingInfluencer_InfluencerLists_index_vue__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_views_Campaign_PairingInfluencer_InfluencerLists_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_views_Campaign_PairingInfluencer_InfluencerLists_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_reports__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_reports_HtmlReport_vue__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_reports_HtmlReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_reports_HtmlReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_views_CODashboard_index_vue__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_views_CODashboard_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_views_CODashboard_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_views_CODashboard_speed_vue__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_views_CODashboard_speed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_views_CODashboard_speed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_views_CODashboard_quality_vue__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_views_CODashboard_quality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_views_CODashboard_quality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_views_AMDashboard_index_vue__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_views_AMDashboard_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_views_AMDashboard_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_views_AMDashboard_speed_vue__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_views_AMDashboard_speed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_views_AMDashboard_speed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_views_AMDashboard_quality_vue__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_views_AMDashboard_quality_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_views_AMDashboard_quality_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_views_AMDashboard_spendRevenue__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_views_AMDashboard_spendRevenue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_views_AMDashboard_spendRevenue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_views_CODashboard_spendRevenue__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_views_CODashboard_spendRevenue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_views_CODashboard_spendRevenue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_views_Finance_payoutsReport__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_views_Finance_payoutsReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_views_Finance_payoutsReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_views_Post_statusReport__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_views_Post_statusReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_views_Post_statusReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_views_Post_DraftSubmissionReport__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_views_Post_DraftSubmissionReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_views_Post_DraftSubmissionReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_views_Campaign_BrandSheetForm__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_views_Campaign_BrandSheetForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_views_Campaign_BrandSheetForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_views_Campaign_BrandSheetList__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_views_Campaign_BrandSheetList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_views_Campaign_BrandSheetList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_views_Influencer_RateCard_Form__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_views_Influencer_RateCard_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_views_Influencer_RateCard_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_views_Influencer_JoinCommunity_Form__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_views_Influencer_JoinCommunity_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_views_Influencer_JoinCommunity_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_views_Influencer_RateCard_index__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_views_Influencer_RateCard_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_views_Influencer_RateCard_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_views_Influencer_JoinCommunity_index__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_views_Influencer_JoinCommunity_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_views_Influencer_JoinCommunity_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_views_Campaign_ReviewMeeting__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_views_Campaign_ReviewMeeting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_views_Campaign_ReviewMeeting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_views_Campaign_MasterLists__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_views_Campaign_MasterLists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_views_Campaign_MasterLists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_views_Campaign_COGSSummary__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_views_Campaign_COGSSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_views_Campaign_COGSSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_views_Finance_CogsEstimate__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_views_Finance_CogsEstimate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_views_Finance_CogsEstimate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_views_Finance_ProfitSummary__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_views_Finance_ProfitSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_views_Finance_ProfitSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_views_Influencer_ProfileTally_Form__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_views_Influencer_ProfileTally_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_views_Influencer_ProfileTally_Form__);









































































































var userRoles = __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles;
var campaignStatus = __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].campaignStatus;
var campaignStatusDisplay = __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].campaignStatusDisplay;
var postStatus = __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].postStatus;
var postStatusDisplayInternal = __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].postStatusDisplayInternal;
var postStatusDisplayExternal = __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].postStatusDisplayExternal;

var routes = [{
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/client-login',
  name: 'ClientLogin',
  component: __WEBPACK_IMPORTED_MODULE_2__components_ClientLogin_vue___default.a
}, {
  path: '/register',
  name: 'PrivateRegister',
  component: __WEBPACK_IMPORTED_MODULE_4__components_PrivateRegister_vue___default.a
}, {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_vue___default.a
}, {
  path: '/reports/campaign/summary',
  name: 'CampaignSummaryReports',
  component: __WEBPACK_IMPORTED_MODULE_67__components_reports___default.a
}, {
  path: '/reports/campaign/html',
  name: 'CampaignHtmlReport',
  component: __WEBPACK_IMPORTED_MODULE_68__components_reports_HtmlReport_vue___default.a
}, {
  path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].CLIENT_FEEDBACK_FORM_URL + '/:campaignId',
  name: 'CreateClientFeedbackForm',
  component: __WEBPACK_IMPORTED_MODULE_22__components_views_Client_CreateFeedbacksForm___default.a
}, {
  path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].BRAND_SHEET_FORM_URL + '/:campaignId',
  name: 'CreateBrandSheetForm',
  component: __WEBPACK_IMPORTED_MODULE_80__components_views_Campaign_BrandSheetForm___default.a
}, {
  path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].RATE_CARD_FORM_URL,
  name: 'RateCardForm',
  component: __WEBPACK_IMPORTED_MODULE_82__components_views_Influencer_RateCard_Form___default.a
}, {
  path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].JOIN_COMMUNITY_FORM_URL,
  name: 'JoinCommunityForm',
  component: __WEBPACK_IMPORTED_MODULE_83__components_views_Influencer_JoinCommunity_Form___default.a
}, {
  path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].PROFILE_TALLY_FORM_URL,
  name: 'ProfileTallyForm',
  component: __WEBPACK_IMPORTED_MODULE_91__components_views_Influencer_ProfileTally_Form___default.a
}, {
  path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].SIGNING_IN_FORM_URL + '/:pairingID',
  name: 'CreateSigningForm',
  component: __WEBPACK_IMPORTED_MODULE_26__components_views_Influencer_SigningForm_Form_vue___default.a
}, {
  path: '/submit-post-payout',
  name: 'PayoutSubmission',
  component: __WEBPACK_IMPORTED_MODULE_55__components_views_Influencer_SubmitPostPayout___default.a
}, {
  path: '/developer/express-gateway/users',
  name: 'ExpressGatewayUsers',
  component: __WEBPACK_IMPORTED_MODULE_47__components_views_Development_Express_Gateway_User___default.a,
  meta: {
    description: 'Overview of environment',
    requiresAuth: true,
    allow: [userRoles.SUPER_ADMIN_HIGH]
  }
}, {
  path: '/developer/api/testing',
  name: 'APITesting',
  component: __WEBPACK_IMPORTED_MODULE_48__components_views_Development_API_Testing_vue___default.a,
  meta: {
    description: 'Overview of environment',
    requiresAuth: true,
    allow: [userRoles.SUPER_ADMIN_HIGH]
  }
}, {
  path: '/reset_password/:email/:token',
  name: 'ResetPassword',
  component: __WEBPACK_IMPORTED_MODULE_6__components_ResetPasswordPage_vue___default.a
}, {
  path: '/instagrams/handleAuth',
  name: 'InstagramLogin',
  component: __WEBPACK_IMPORTED_MODULE_18__components_views_Instagram_handleAuth_vue___default.a
}, {
  path: '/instagrams/handleIntegrate',
  name: 'InstagramIntegrate',
  component: __WEBPACK_IMPORTED_MODULE_19__components_views_Instagram_handleIntegrate_vue___default.a
}, {
  path: '/xero/handleAuth',
  name: 'XeroHandleCallbackAuth',
  component: __WEBPACK_IMPORTED_MODULE_36__components_views_Xero_XeroCallBackAuth___default.a,
  meta: {
    description: 'Xero Integration',
    requiresAuth: true,
    allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE]
  }
}, {
  path: '/influencers/content-storyboard/:id',
  component: __WEBPACK_IMPORTED_MODULE_24__components_views_Pairing_CreatorConceptForm_Form_vue___default.a,
  name: 'CreatorConceptForm'
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_DashVuetify_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_31__components_views_Dashboard_vue___default.a,
    name: 'Dashboard',
    meta: {
      description: 'Overview of environment',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.CLIENT, userRoles.INFLUENCER, userRoles.FINANCE]
    }
  }, {
    path: 'co/dashboard',
    alias: 'CC Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_69__components_views_CODashboard_index_vue___default.a,
    name: 'co-dashboard',
    meta: {
      description: 'Overview of CC environment',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'co/dashboard/speed',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_70__components_views_CODashboard_speed_vue___default.a,
    name: 'co-speed',
    meta: {
      description: 'Detail fo CC Speed Graph',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'co/dashboard/quality',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_71__components_views_CODashboard_quality_vue___default.a,
    name: 'CO-Quality',
    meta: {
      description: 'Detail for CC Quality Graph',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'co/dashboard/spend/revenue',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_76__components_views_CODashboard_spendRevenue___default.a,
    name: 'co-spend-revenue',
    meta: {
      description: 'Detail for CC Spend Revenue Graph',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'am/dashboard',
    alias: 'AM Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_72__components_views_AMDashboard_index_vue___default.a,
    name: 'am-dashboard',
    meta: {
      description: 'Overview of AM environment',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: 'am/dashboard/speed',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_73__components_views_AMDashboard_speed_vue___default.a,
    name: 'am-speed',
    meta: {
      description: 'Detail fo AM Speed Graph',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: 'am/dashboard/quality',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_74__components_views_AMDashboard_quality_vue___default.a,
    name: 'AM-Quality',
    meta: {
      description: 'Detail for AM Quality Graph',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: 'am/dashboard/spend/revenue',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_75__components_views_AMDashboard_spendRevenue___default.a,
    name: 'am-spend-revenue',
    meta: {
      description: 'Detail for AM Spend Revenue Graph',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: 'campaign-report-internal',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_37__components_views_Campaign_CampaignReportInternal_vue___default.a,
    name: 'Campaign Report Internal',
    meta: {
      description: 'Generate Campaign Report',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'services/influencer-lists',
    component: __WEBPACK_IMPORTED_MODULE_66__components_views_Campaign_PairingInfluencer_InfluencerLists_index_vue___default.a,
    name: 'Influencer Lists',
    meta: {
      description: 'Influencer Lists',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.FINANCE, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: '/facebook/auth',
    name: 'FacebookAuth',
    component: __WEBPACK_IMPORTED_MODULE_3__components_SelectInstagram_vue___default.a
  }, { path: 'users',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_User___default.a,
    name: 'Users',
    meta: {
      description: 'User list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.FINANCE, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'users/un-verified',
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_User_UnApprovedUser_vue___default.a,
    name: 'New Signups',
    meta: {
      description: '',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: 'users/create-link',
    component: __WEBPACK_IMPORTED_MODULE_57__components_views_User_CreatePrivateLink_vue___default.a,
    name: 'Invite an Influencer to IMS',
    meta: {
      description: '',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'content-analysis',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_44__components_views_ContentAnalysis___default.a,
    name: 'Content Analysis',
    meta: {
      description: 'Analyse the Post Content',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'search-influencers',
    component: __WEBPACK_IMPORTED_MODULE_45__components_views_InfluencerSearch___default.a,
    name: 'Influencer Search by NLU/Computer Vision',
    meta: {
      description: 'Influencer Search for Kobe Company only',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_User_Profile_vue___default.a,
    name: 'Profile',
    meta: {
      description: 'Profile',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: 'submit-post-payout-creator',
    component: __WEBPACK_IMPORTED_MODULE_55__components_views_Influencer_SubmitPostPayout___default.a,
    name: 'Payout Submission',
    meta: {
      description: 'Submit payout for this post',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: '/content-storyboard-list',
    component: __WEBPACK_IMPORTED_MODULE_25__components_views_Pairing_CreatorConceptForm_List_vue___default.a,
    name: 'Content Storyboards',
    meta: {
      description: 'Content Storyboard',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: 'submitCampaignPayouts',
    component: __WEBPACK_IMPORTED_MODULE_17__components_views_Influencer_CreateCampaignPayout_vue___default.a,
    name: 'Submit Campaign Payout',
    meta: {
      description: 'Submit new campaign payout',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: 'v2/submit-draft-post',
    component: __WEBPACK_IMPORTED_MODULE_49__components_views_Post_CreateDraftPostV2___default.a,
    name: 'Submit Draft Post',
    meta: {
      description: 'Submit a draft post for the campaign',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: 'influencers',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_Influencer___default.a,
    name: 'IMS Influencers',
    meta: {
      description: 'Influencer list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'all-influencers',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_Influencer_NonIMSLists_vue___default.a,
    name: 'All Influencers',
    meta: {
      description: 'All Influencer list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.MARKETING]
    }
  }, {
    path: 'content/search',
    component: __WEBPACK_IMPORTED_MODULE_13__components_views_Influencer_SearchKeyword___default.a,
    name: 'Content Search',
    meta: {
      description: 'Search Influencers by keywords in posts',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'influencers/discovery',
    component: __WEBPACK_IMPORTED_MODULE_46__components_views_Influencer_KeywordSearch___default.a,
    name: 'Creator Discovery',
    meta: {
      description: 'Search Influencers by Keyword',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'creators/search',
    component: __WEBPACK_IMPORTED_MODULE_14__components_views_Influencer_SearchCreators___default.a,
    name: 'Creators Search',
    meta: {
      description: 'Creators Search',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'content-storyboard',
    component: __WEBPACK_IMPORTED_MODULE_15__components_views_Pairing_CreatorConcept___default.a,
    name: 'Content Storyboard',
    meta: {
      description: 'Content Storyboard',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.CLIENT]
    }
  }, {
    path: 'influencers/social-data',
    component: __WEBPACK_IMPORTED_MODULE_39__components_views_InfluencerSocialData___default.a,
    name: 'Influencer Audience Data',
    meta: {
      description: 'Influencer Audience Data',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'companies',
    component: __WEBPACK_IMPORTED_MODULE_20__components_views_Company___default.a,
    name: 'Companies',
    meta: {
      description: 'Company list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW]
    }
  }, {
    path: 'clients',
    component: __WEBPACK_IMPORTED_MODULE_21__components_views_Client___default.a,
    name: 'Clients',
    meta: {
      description: 'Client list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].CLIENT_FEEDBACK_FORM_URL,
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_Client_FeedbacksForm_vue___default.a,
    name: 'Client Feedbacks',
    meta: {
      description: 'Client Feedbacks',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
    }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].CLIENT_FEEDBACK_FORM_URL + '/archive/lists',
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_Client_FeedbacksForm_vue___default.a,
    name: 'Archived Client Feedbacks',
    meta: {
      description: 'Archived Client Feedbacks',
      requiresAuth: true,
      archive: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'campaignPayoutsInternal',
    component: __WEBPACK_IMPORTED_MODULE_16__components_views_Campaign_CampaignPayoutList_vue___default.a,
    name: 'Creator Stats & Rating',
    meta: {
      description: 'Campaign Payout from Influencers',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'payouts-report',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_77__components_views_Finance_payoutsReport___default.a,
    name: 'Payouts Report',
    meta: {
      description: 'Campaign Payouts Report',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST]
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.DRAFT]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.DRAFT]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.DRAFT,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.DRAFT]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.DRAFT]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.PENDING_CLIENT_APPROVAL,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.PAIRING_BRIEF,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.PAIRING_INFLUENCER,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.RATE_CARD]['url'],
    component: __WEBPACK_IMPORTED_MODULE_41__components_views_Campaign_RateCard___default.a,
    name: campaignStatusDisplay[campaignStatus.RATE_CARD]['display'] + ' Requests',
    meta: {
      campaignStatus: campaignStatus.RATE_CARD,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.RATE_CARD]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.RATE_CARD]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.ONGOING]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.ONGOING]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.ONGOING,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.ONGOING]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.ONGOING]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.REVIEW]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.REVIEW]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.REVIEW,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.REVIEW]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.REVIEW]['permissions']
    }
  }, {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.COMPLETE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: campaignStatusDisplay[campaignStatus.COMPLETE]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.COMPLETE,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.COMPLETE]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.COMPLETE]['permissions']
    }
  }, {
    path: 'campaigns/all',
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: 'All Campaigns Report',
    meta: {
      campaignStatus: -1,
      description: 'Campaigns all',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.MARKETING]
    }
  }, {
    path: 'aok-report',
    component: __WEBPACK_IMPORTED_MODULE_35__components_views_Campaign_AOKReport_index_vue___default.a,
    name: 'AOK Report',
    meta: {
      description: 'AOK Report',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'clients/campaigns',
    component: __WEBPACK_IMPORTED_MODULE_32__components_views_Campaign_CampaignBrief___default.a,
    name: 'Campaigns',
    meta: {
      description: 'Campaigns',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  }, {
    path: 'campaigns/:campaignID/invitation',
    component: __WEBPACK_IMPORTED_MODULE_62__components_views_Campaign_CampaignInvite_CampaignInviteDetail_vue___default.a,
    name: 'Campaign Invitation',
    meta: {
      description: 'Campaign Invitation',
      requiresAuth: true,
      allow: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.INFLUENCER]
    }
  }, {
    path: 'campaigns/influencer-posts',
    component: __WEBPACK_IMPORTED_MODULE_38__components_views_Campaign_InfluencerPosts___default.a,
    name: 'influencer-posts',
    meta: {
      description: 'Influencer Posts',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  }, {
    path: 'clients/campaigns-reports',
    component: __WEBPACK_IMPORTED_MODULE_33__components_views_Campaign_CampaignReport___default.a,
    name: 'Campaign Report',
    meta: {
      description: 'Campaign Reports',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  }, {
    path: 'campaigns/overview',
    component: __WEBPACK_IMPORTED_MODULE_34__components_views_Campaign_CampaignsOverview___default.a,
    name: 'Campaign Overview',
    meta: {
      description: 'Campaign Overview',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'campaigns/:campaignID/invite-influencer',
    component: __WEBPACK_IMPORTED_MODULE_40__components_views_Campaign_CampaignInvite_CampaignInvite___default.a,
    name: 'campaign-invites',
    meta: {
      description: 'Campaign Invites',
      requiresAuth: true,
      allow: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'campaigns/ongoing',
    component: __WEBPACK_IMPORTED_MODULE_43__components_views_Campaign_CampaignOngoing___default.a,
    name: 'ongoing-campaigns',
    meta: {
      description: 'Ongoing Campaigns',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: 'campaigns/influencer-completed',
    component: __WEBPACK_IMPORTED_MODULE_42__components_views_Campaign_CampaignCompleted___default.a,
    name: 'completed-campaigns',
    meta: {
      description: 'Completed Campaigns',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  }, {
    path: 'influencers/invoices-brief-confirmation',
    name: 'Invoices & Brief Confirmation',
    component: __WEBPACK_IMPORTED_MODULE_64__components_views_Campaign_PairingInfluencer_InvoicesBriefConfirmation_vue___default.a,
    meta: {
      description: 'Invoices & Brief Confirmation',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.FINANCE, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
    }
  }, {
    path: 'clients/payments',
    component: __webpack_require__(1844),
    name: 'Client payments',
    meta: {
      description: 'Client Payment',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  }, {
    path: 'payments-from-clients',
    component: __webpack_require__(1837),
    name: 'Payments from Clients',
    meta: {
      description: 'Payments from Clients',
      requiresAuth: true,
      allow: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE]
    }
  }, {
    path: 'posts/' + postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['url'],
    component: __WEBPACK_IMPORTED_MODULE_50__components_views_Post___default.a,
    name: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['display'],
    meta: {
      postStatus: postStatus.AD_STRATEGIST_PENDING,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayExternal[postStatus.CLIENT_PENDING]['url'],
    component: __WEBPACK_IMPORTED_MODULE_50__components_views_Post___default.a,
    name: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['display'],
    meta: {
      postStatus: postStatus.CLIENT_PENDING,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.CLIENT_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayExternal[postStatus.APPROVE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_50__components_views_Post___default.a,
    name: postStatusDisplayExternal[postStatus.APPROVE]['display'],
    meta: {
      postStatus: postStatus.APPROVE,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.APPROVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.APPROVE]['permissions']
    }
  }, {
    path: 'posts/view/:postId',
    component: __WEBPACK_IMPORTED_MODULE_53__components_views_Post_PostDetail___default.a,
    name: 'Post View',
    meta: {
      postStatus: postStatus.APPROVE,
      description: 'Posts View',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.AD_STRATEGIST, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.ACCOUNT_MANAGER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.CLIENT, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.INFLUENCER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: 'posts/' + postStatusDisplayExternal[postStatus.LIVE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_50__components_views_Post___default.a,
    name: postStatusDisplayExternal[postStatus.LIVE]['display'],
    meta: {
      postStatus: postStatus.LIVE,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.LIVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.LIVE]['permissions']
    }
  }, {
    path: 'clients/posts',
    component: __WEBPACK_IMPORTED_MODULE_51__components_views_Post_PostViewClient___default.a,
    name: 'Posts',
    meta: {
      description: 'Posts',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  }, {
    path: 'posts/' + postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['url'],
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.AD_STRATEGIST_PENDING,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayInternal[postStatus.CLIENT_PENDING]['url'],
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.CLIENT_PENDING,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.CLIENT_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayInternal[postStatus.APPROVE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: postStatusDisplayInternal[postStatus.APPROVE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.APPROVE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.APPROVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.APPROVE]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayInternal[postStatus.LIVE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: postStatusDisplayInternal[postStatus.LIVE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.LIVE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.LIVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.LIVE]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayInternal[postStatus.COMPLETE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: postStatusDisplayInternal[postStatus.COMPLETE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.COMPLETE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.COMPLETE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.COMPLETE]['permissions']
    }
  }, {
    path: 'posts/' + postStatusDisplayInternal[postStatus.ARCHIVE]['url'],
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: postStatusDisplayInternal[postStatus.ARCHIVE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.ARCHIVE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.ARCHIVE]['url'],
      archive: true,
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.ARCHIVE]['permissions']
    }
  }, {
    path: 'posts/internal/all-posts',
    component: __WEBPACK_IMPORTED_MODULE_52__components_views_Post_PostViewInternal___default.a,
    name: 'All Posts',
    meta: {
      postStatus: -1,
      description: 'All Posts',
      archive: true,
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
    }
  }, {
    path: 'posts/submission-review',
    component: __WEBPACK_IMPORTED_MODULE_54__components_views_Post_SubmissionReview_vue___default.a,
    name: 'posts-submission-review',
    meta: {
      description: 'Report Abuse or Rate Influencer regarding the post',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.CLIENT]
    }
  }, {
    path: 'stats-collection-calendar',
    component: __WEBPACK_IMPORTED_MODULE_56__components_views_Post_CalenderViewPosts_vue___default.a,
    name: 'Stats Collection Calendar',
    meta: {
      description: 'Stats Collection Calendar',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.AD_STRATEGIST, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.ACCOUNT_MANAGER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.CLIENT, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.INFLUENCER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: 'clients/posts-approved-calender',
    component: __WEBPACK_IMPORTED_MODULE_56__components_views_Post_CalenderViewPosts_vue___default.a,
    name: 'Post Calendar',
    meta: {
      description: 'Approved Posts in calender View',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.CLIENT]
    }
  }, {
    path: 'posts/co-creating/status-report',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_78__components_views_Post_statusReport___default.a,
    name: 'Co-creating Status Report',
    meta: {
      description: 'Co-creating Status Report',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'posts/draft-submissions-report',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_79__components_views_Post_DraftSubmissionReport___default.a,
    name: 'Draft Submissions Report',
    meta: {
      description: 'Draft Submissions Report',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'finance/revenue-recognize',
    component: __WEBPACK_IMPORTED_MODULE_34__components_views_Campaign_CampaignsOverview___default.a,
    name: 'Revenue Recognize',
    meta: {
      description: 'Revenue Recognize',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.ACCOUNT_MANAGER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: 'finance/money-out',
    component: __WEBPACK_IMPORTED_MODULE_58__components_views_Finance_MoneyOut_vue___default.a,
    name: 'Payout Recognize',
    meta: {
      description: 'Revenue Recognize',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.AD_STRATEGIST, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: 'finance/money-in',
    component: __WEBPACK_IMPORTED_MODULE_59__components_views_Finance_MoneyIn_vue___default.a,
    name: 'Payments/Receipts Recognize',
    meta: {
      description: 'Payments/Receipts Recognize',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.ACCOUNT_MANAGER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: 'finance/payment-consolidation',
    component: __WEBPACK_IMPORTED_MODULE_60__components_views_Finance_PaymentConsolidation_vue___default.a,
    name: 'Payment Consolidation',
    meta: {
      description: 'Payment Consolidation',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.AD_STRATEGIST, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.ACCOUNT_MANAGER, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: 'finance/payment-consolidation/status',
    name: 'Payment Consolidation Status',
    component: __WEBPACK_IMPORTED_MODULE_65__components_views_Campaign_PairingInfluencer_PaymentConsolidationStatus_vue___default.a,
    meta: {
      description: 'Payment Consolidation Status',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }, {
    path: 'finance/payment-consolidation/archive',
    component: __WEBPACK_IMPORTED_MODULE_61__components_views_Finance_ArchiveList_vue___default.a,
    name: 'Archived Payment Consolidation',
    meta: {
      description: 'Archived Payment Consolidation',
      requiresAuth: true,
      allow: [__WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.AD_STRATEGIST, __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].userRoles.FINANCE]
    }
  }, {
    path: __WEBPACK_IMPORTED_MODULE_63__config__["a" /* default */].BRAND_SHEET_FORM_URL,
    component: __WEBPACK_IMPORTED_MODULE_81__components_views_Campaign_BrandSheetList___default.a,
    name: 'Brand Fact Sheet',
    meta: {
      description: 'Brand Fact Sheet',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: '/influencers/rate-cards',
    component: __WEBPACK_IMPORTED_MODULE_84__components_views_Influencer_RateCard_index___default.a,
    name: 'Ratecard Forms',
    meta: {
      description: 'Rate Cards',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.MARKETING]
    }
  }, {
    path: '/influencers/join-community',
    component: __WEBPACK_IMPORTED_MODULE_85__components_views_Influencer_JoinCommunity_index___default.a,
    name: 'Creator Community Forms',
    meta: {
      description: 'Join Community',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.MARKETING]
    }
  }, {
    path: '/campaigns/archive',
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_Campaign___default.a,
    name: 'Archived Campaigns',
    meta: {
      campaignStatus: -1,
      archive: true,
      description: 'Archived Campaigns',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: '/campaigns/timeline',
    component: __WEBPACK_IMPORTED_MODULE_28__components_views_Campaign_Timeline___default.a,
    name: 'Campaign Timeline',
    meta: {
      description: 'Campaign Timeline',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: '/campaigns/timeline/summary',
    component: __WEBPACK_IMPORTED_MODULE_29__components_views_Campaign_Timeline_Summary___default.a,
    name: 'Campaign Timeline Summary',
    meta: {
      description: 'Campaign Timeline Summary',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: '/campaigns/statistics/analysis',
    component: __WEBPACK_IMPORTED_MODULE_30__components_views_Campaign_StatisticsAnalysis___default.a,
    name: 'Stats Analysis',
    meta: {
      description: 'Stats Analysis',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
    }
  }, {
    path: '/campaigns/upcoming-review-meetings',
    component: __WEBPACK_IMPORTED_MODULE_86__components_views_Campaign_ReviewMeeting___default.a,
    name: 'Upcoming Review Meetings',
    meta: {
      description: 'Upcoming Review Meetings',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  }, {
    path: '/campaigns/campaign-cogs',
    component: __WEBPACK_IMPORTED_MODULE_88__components_views_Campaign_COGSSummary___default.a,
    name: 'Campaign COGS',
    meta: {
      description: 'Campaign COGS',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
    }
  }, {
    path: '/finance/cogs-estimation',
    component: __WEBPACK_IMPORTED_MODULE_89__components_views_Finance_CogsEstimate___default.a,
    name: 'COGS Estimation',
    meta: {
      description: 'COGS Estimation',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST, userRoles.FINANCE]
    }
  }, {
    path: '/finance/profit-summary',
    component: __WEBPACK_IMPORTED_MODULE_90__components_views_Finance_ProfitSummary___default.a,
    name: 'Profit Summary',
    meta: {
      description: 'Profit Summary',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE]
    }
  }, {
    path: '/finance/masterlist',
    component: __WEBPACK_IMPORTED_MODULE_87__components_views_Campaign_MasterLists___default.a,
    name: 'Masterlist',
    meta: {
      description: 'Masterlist',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_7__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1332)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(2010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.1","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.1","name":"axios","escapedName":"axios","rawSpec":"^0.21.1","saveSpec":null,"fetchSpec":"^0.21.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.1","_where":"/app","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(306);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Post_postApi__ = __webpack_require__(42);







var path = __webpack_require__(668);
var html2PdfMake = __webpack_require__(291);

var BlocksToPDF = function () {
    function BlocksToPDF(data) {
        var font = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Roboto';

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BlocksToPDF);

        this.data = data;
        this.font = font;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BlocksToPDF, [{
        key: '_pdfMake',
        value: function _pdfMake() {
            var dd = {
                header: {
                    margin: [0, 10, 20, 40],
                    text: 'Date: ' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(Date.now()).format('DD/MM/YYYY'),
                    alignment: 'right',
                    style: 'smallText'
                },
                footer: {
                    margin: [0, 10, 0, 10],
                    text: 'www.getkobe.com',
                    alignment: 'center',
                    style: 'smallText'
                },
                content: [{
                    image: 'data:image/png;base64,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',
                    width: 80,
                    height: 80,
                    alignment: 'center'
                }],
                styles: {
                    header_1: {
                        fontSize: 36,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_2: {
                        fontSize: 30,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_3: {
                        fontSize: 24,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_4: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_5: {
                        fontSize: 14,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    header_6: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'white',
                        fillColor: '#3F3FFF'
                    },
                    boldText: {
                        fontSize: 12,
                        bold: true
                    },
                    underlineText: {
                        decoration: 'underline'
                    },
                    smallText: {
                        fontSize: 9
                    }
                },
                defaultStyle: {
                    font: this.font
                },
                pageMargins: [40, 60, 40, 60]
            };
            return dd;
        }
    }, {
        key: '_getBase64FromURL',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
                var filename, object, image, base64Image;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                filename = path.basename(url);
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_5__views_Post_postApi__["a" /* default */].getS3Object(filename);

                            case 3:
                                object = _context.sent;
                                image = new Buffer.from(object.Body).toString('base64');
                                base64Image = "data:" + object.ContentType + ";base64," + image;
                                return _context.abrupt('return', base64Image);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _getBase64FromURL(_x2) {
                return _ref.apply(this, arguments);
            }

            return _getBase64FromURL;
        }()
    }, {
        key: 'generate',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var pdfMake, i, response, headerClass, htmlParagraph, ulArray, j, htmlListUnOrdered, olArray, _j, htmlListOrdered;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                pdfMake = this._pdfMake();
                                i = 0;

                            case 2:
                                if (!(i < this.data.length)) {
                                    _context2.next = 39;
                                    break;
                                }

                                if (!(this.data[i].type === 'image')) {
                                    _context2.next = 14;
                                    break;
                                }

                                _context2.prev = 4;
                                _context2.next = 7;
                                return this._getBase64FromURL(this.data[i].data.url);

                            case 7:
                                response = _context2.sent;

                                pdfMake.content.push({
                                    margin: [10, 10, 10, 10],
                                    image: response,
                                    width: 350
                                });
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](4);

                                console.log(_context2.t0);

                            case 14:
                                if (!(this.data[i].type === 'header')) {
                                    _context2.next = 33;
                                    break;
                                }

                                headerClass = void 0;
                                _context2.t1 = this.data[i].data.level;
                                _context2.next = _context2.t1 === 1 ? 19 : _context2.t1 === 2 ? 21 : _context2.t1 === 3 ? 23 : _context2.t1 === 4 ? 25 : _context2.t1 === 5 ? 27 : _context2.t1 === 6 ? 29 : 31;
                                break;

                            case 19:
                                headerClass = 'header_1';
                                return _context2.abrupt('break', 32);

                            case 21:
                                headerClass = 'header_2';
                                return _context2.abrupt('break', 32);

                            case 23:
                                headerClass = 'header_3';
                                return _context2.abrupt('break', 32);

                            case 25:
                                headerClass = 'header_4';
                                return _context2.abrupt('break', 32);

                            case 27:
                                headerClass = 'header_5';
                                return _context2.abrupt('break', 32);

                            case 29:
                                headerClass = 'header_6';
                                return _context2.abrupt('break', 32);

                            case 31:
                                return _context2.abrupt('break', 32);

                            case 32:
                                pdfMake.content.push({
                                    margin: [0, 5, 0, 0],
                                    text: html2PdfMake(this.data[i].data.text, {}),
                                    style: headerClass
                                });

                            case 33:

                                if (this.data[i].type === 'paragraph') {
                                    htmlParagraph = html2PdfMake(this.data[i].data.text, {});

                                    pdfMake.content.push({
                                        margin: [0, 10, 0, 10],
                                        text: htmlParagraph
                                    });
                                }

                                if (this.data[i].type === 'list') {

                                    if (this.data[i].data.style === 'unordered') {
                                        ulArray = [];

                                        for (j = 0; j < this.data[i].data.items.length; j++) {
                                            htmlListUnOrdered = html2PdfMake(this.data[i].data.items[j], {});

                                            ulArray.push(htmlListUnOrdered);
                                        }

                                        pdfMake.content.push({
                                            margin: [0, 0, 0, 5],
                                            ul: ulArray,
                                            fontSize: 11
                                        });
                                    }

                                    if (this.data[i].data.style === 'ordered') {
                                        olArray = [];

                                        for (_j = 0; _j < this.data[i].data.items.length; _j++) {
                                            htmlListOrdered = html2PdfMake(this.data[i].data.items[_j], {});

                                            olArray.push(htmlListOrdered);
                                        }
                                        pdfMake.content.push({
                                            margin: [0, 0, 0, 5],
                                            ol: olArray,
                                            fontSize: 11
                                        });
                                    }
                                }

                                if (this.data[i].type === 'delimiter') {
                                    pdfMake.content.push({
                                        margin: [0, 30, 0, 0],
                                        svg: '<svg height="10" width="500"><line x1="0" y1="0" x2="100%" y2="0" style="stroke:rgb(192,192,192);stroke-width:0.5" /></svg>',
                                        alignment: 'center'
                                    });
                                }

                            case 36:
                                i++;
                                _context2.next = 2;
                                break;

                            case 39:
                                return _context2.abrupt('return', pdfMake);

                            case 40:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[4, 11]]);
            }));

            function generate() {
                return _ref2.apply(this, arguments);
            }

            return generate;
        }()
    }]);

    return BlocksToPDF;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlocksToPDF);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(121).Buffer))

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jimp__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jimp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);











var inputFile = '';

var RenderImage = function () {
  function RenderImage(_ref) {
    var data = _ref.data,
        api = _ref.api;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, RenderImage);

    this.api = api;
    this.data = {
      url: data.url || '',
      withBorder: data.withBorder !== undefined ? data.withBorder : false,
      withBackground: data.withBackground !== undefined ? data.withBackground : false
    };
    this.wrapper = undefined;
    this.settings = [{
      name: 'withBorder',
      icon: '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.8 10.592v2.043h2.35v2.138H15.8v2.232h-2.25v-2.232h-2.4v-2.138h2.4v-2.28h2.25v.237h1.15-1.15zM1.9 8.455v-3.42c0-1.154.985-2.09 2.2-2.09h4.2v2.137H4.15v3.373H1.9zm0 2.137h2.25v3.325H8.3v2.138H4.1c-1.215 0-2.2-.936-2.2-2.09v-3.373zm15.05-2.137H14.7V5.082h-4.15V2.945h4.2c1.215 0 2.2.936 2.2 2.09v3.42z"/></svg>'
    }, {
      name: 'withBackground',
      icon: '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.043 8.265l3.183-3.183h-2.924L4.75 10.636v2.923l4.15-4.15v2.351l-2.158 2.159H8.9v2.137H4.7c-1.215 0-2.2-.936-2.2-2.09v-8.93c0-1.154.985-2.09 2.2-2.09h10.663l.033-.033.034.034c1.178.04 2.12.96 2.12 2.089v3.23H15.3V5.359l-2.906 2.906h-2.35zM7.951 5.082H4.75v3.201l3.201-3.2zm5.099 7.078v3.04h4.15v-3.04h-4.15zm-1.1-2.137h6.35c.635 0 1.15.489 1.15 1.092v5.13c0 .603-.515 1.092-1.15 1.092h-6.35c-.635 0-1.15-.489-1.15-1.092v-5.13c0-.603.515-1.092 1.15-1.092z"/></svg>'
    }];
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(RenderImage, [{
    key: '_createImage',
    value: function _createImage(url) {
      var image = document.createElement('img');
      image.src = url;
      this.wrapper.innerHTML = '';
      this.wrapper.appendChild(image);
      this._acceptTuneView();
    }
  }, {
    key: '_readImageFileAndRender',
    value: function _readImageFileAndRender(file) {
      var _this = this;

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        _this._createImage(e.target.result);
      };
    }
  }, {
    key: '_resizeImageFile',
    value: function _resizeImageFile(element) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = function (e) {
          var buffer = e.target.result;

          __WEBPACK_IMPORTED_MODULE_8_jimp___default.a.read(buffer, function (err, img) {
            if (err) console.error(111, err);
            img.resize(500, __WEBPACK_IMPORTED_MODULE_8_jimp___default.a.AUTO).quality(100).getBase64(__WEBPACK_IMPORTED_MODULE_8_jimp___default.a.MIME_PNG, function (err, buff) {
              if (err) {
                console.error(222, err);
                reject(err);
              }
              var file = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
              resolve(file);
            });
          });
        };
      });
    }
  }, {
    key: '_saveImageFile',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(file) {
        var form, formData, media, images, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, val, response;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = document.getElementById('form');
                formData = new FormData(form);
                media = [];

                media.push(file);
                images = media;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 8;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(images); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  val = _step.value;

                  formData.append('images', val);
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 16:
                _context.prev = 16;
                _context.prev = 17;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 19:
                _context.prev = 19;

                if (!_didIteratorError) {
                  _context.next = 22;
                  break;
                }

                throw _iteratorError;

              case 22:
                return _context.finish(19);

              case 23:
                return _context.finish(16);

              case 24:
                _context.next = 26;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('post', '/api/v1/posts/s3/upload', true, formData);

              case 26:
                response = _context.sent;

                this._createImage(response.data.file.url);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 12, 16, 24], [17,, 19, 23]]);
      }));

      function _saveImageFile(_x) {
        return _ref2.apply(this, arguments);
      }

      return _saveImageFile;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      this.wrapper = document.createElement('div');
      var form = document.createElement('form');
      form.id = 'form';
      var input = document.createElement('input');
      input.id = 'imgUpload';
      input.accept = 'image/*';
      input.type = 'file';

      this.wrapper.classList.add('brief-image');

      if (this.data && this.data.url) {
        this._createImage(this.data.url);
        return this.wrapper;
      }

      this.wrapper.appendChild(form);
      form.appendChild(input);

      input.addEventListener('change', function () {
        inputFile = input.files[0];

        _this2._resizeImageFile(inputFile).then(function (datafile) {
          _this2._saveImageFile(datafile);
        });
      });

      return this.wrapper;
    }
  }, {
    key: 'save',
    value: function save(blockContent) {
      var image = blockContent.querySelector('img');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.data, {
        url: image.src
      });
    }
  }, {
    key: 'validate',
    value: function validate(savedData) {
      if (!savedData.url.trim()) {
        return false;
      }
      return true;
    }
  }, {
    key: 'renderSettings',
    value: function renderSettings() {
      var _this3 = this;

      var wrapper = document.createElement('div');

      this.settings.forEach(function (tune) {
        var button = document.createElement('div');
        button.classList.add(_this3.api.styles.settingsButton);
        button.classList.toggle(_this3.api.styles.settingsButtonActive, _this3.data[tune.name]);
        button.innerHTML = tune.icon;
        wrapper.appendChild(button);

        button.addEventListener('click', function () {
          console.log('Tune name', tune.name);
          _this3._toggleTune(tune.name);
          button.classList.toggle(_this3.api.styles.settingsButtonActive);
        });
      });

      return wrapper;
    }
  }, {
    key: '_toggleTune',
    value: function _toggleTune(tune) {
      this.data[tune] = !this.data[tune];
      this._acceptTuneView();
    }
  }, {
    key: '_acceptTuneView',
    value: function _acceptTuneView() {
      var _this4 = this;

      this.settings.forEach(function (tune) {
        _this4.wrapper.classList.toggle(tune.name, !!_this4.data[tune.name]);
      });
    }
  }], [{
    key: 'toolbox',
    get: function get() {
      return {
        title: 'Image',
        icon: '<svg width="17" height="15" viewBox="0 0 336 276" xmlns="http://www.w3.org/2000/svg"><path d="M291 150V79c0-19-15-34-34-34H79c-19 0-34 15-34 34v42l67-44 81 72 56-29 42 30zm0 52l-43-30-56 30-81-67-66 39v23c0 19 15 34 34 34h178c17 0 31-13 34-29zM79 0h178c44 0 79 35 79 79v118c0 44-35 79-79 79H79c-44 0-79-35-79-79V79C0 35 35 0 79 0z"/></svg>'
      };
    }
  }]);

  return RenderImage;
}();

/* harmony default export */ __webpack_exports__["a"] = (RenderImage);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizePosts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_reportPlatform__ = __webpack_require__(79);




var n = function n(v) {
  return v === null || v === undefined || v === '' ? 0 : Number(v) || 0;
};
var round2 = function round2(v) {
  return Number((__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(v) ? v : 0).toFixed(2));
};

function formatDate(date) {
  if (!date) return '-';
  var parts = String(date).split('-');
  if (parts.length < 3) return date;
  var out = parts[2] + '/' + parts[1] + '/' + parts[0];
  return out.includes('undefined') ? date : out;
}

function parseWatchTime(watch) {
  if (watch === null || watch === undefined || watch === '') return 0;
  var s = String(watch);
  return s.includes('s') ? s : n(s);
}

function calculatePostData(post, index) {
  if (post.isCalculated) return post;
  var platform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_reportPlatform__["a" /* getReportPlatform */])(post);
  var d = {
    id: post.id,
    campaignID: post.campaignID,
    key: index,
    lineUpIndex: post.lineUpIndex,
    groupID: post.groupID,
    groupName: post.groupName,

    profileUrl: post.profileUrl || post.profile_url || (post.owner || {}).profileUrl || (post.owner || {}).profile_url || (post.owner || {}).profileURL || '',
    profilePlatform: post.profilePlatform || post.profile_platform || (post.influencer_details || {}).platform || post.platform || '',
    profileHandle: post.profileHandle || post.profile_handle || (post.influencer_details || {}).instagramHandle || ''
  };

  if (!['linkedin', 'twitter'].includes(platform) && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isLemon && !post.isFacebook && !post.isOthers) {
    var ci = post.currentInsight || {};
    var pd = post.post_details || {};
    d.name = (pd.owner || {}).username;
    d.url = pd.link;
    d.impressions = 0;
    d.engagement = ci.engagement || 0;
    d.reach = 0;
    d.likes = ci.like_count || 0;
    d.comments = ci.comment_count || 0;
    d.outreach = ci.outreach || 0;
    d.engagement_rate = post.currentInsight ? Number(ci.engagement_rate) : 1;
    d.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
    d.avg_likes = n(post.avg_likes);
    d.avg_comments = n(post.avg_comments);
    d.avg_views = n(post.avg_views);
    d.avg_reels_plays = n(post.avg_reels_plays);
    if (post.postType === 'IGR') {
      d.type = 'reel';d.title = 'IG Reel';
    } else {
      d.type = 'post/carousel';d.title = 'IG Post';
    }
    if (post.inputtedInsights) {
      var ii = post.inputtedInsights;
      d.saved = ii.saved;d.shares = ii.shares;d.views = ii.views || 0;
      d.reach = ii.reach || 0;d.impressions = ii.impressions || 0;
      d.plays = ii.plays || 0;d.watches = ii.watches ? parseWatchTime(ii.watches) : 0;
    } else {
      d.saved = post.graphInsight ? post.graphInsight.saved : 0;d.shares = 0;d.views = 0;
    }
  } else if (post.isStory && post.insights) {
    var ins = post.insights;var ow = post.owner || {};
    d.name = ow.username;
    d.outreach = ow.followers || ow.followers_sd;
    d.title = 'IG Story';
    d.url = post.media_url || '';
    d.engagement = n(ins.engagement);
    d.impressions = n(ins.impressions);
    d.story_likes = n(ins.story_likes);
    d.reach = n(ins.reach);
    d.replies = n(ins.replies);
    d.exits = n(ins.exits);
    d.taps_back = n(ins.taps_back);
    d.taps_forward = n(ins.taps_forward);
    d.shares = n(ins.shares);
    d.sticker_taps = n(ins.sticker_taps);
    d.link_clicks = n(ins.link_clicks);
    d.avg_views = n(post.avg_views);
    d.avg_reels_plays = n(post.avg_reels_plays);
    d.type = 'story';
    d.storyTotalInteractions = d.link_clicks + d.replies + d.shares + d.sticker_taps + d.story_likes;
  } else if (post.isTikTok) {
    var _ci = post.currentInsight || {};var _pd = post.post_details || {};var _ow = post.owner || {};
    d.name = _ow.username;
    d.title = 'TikTok Post';
    d.url = _pd.link;
    d.impressions = 0;
    d.engagement = _ci.engagement || 0;
    d.reach = 0;
    d.likes = _ci.like_count || 0;
    d.comments = _ci.comment_count || 0;
    d.shares = _ci.shares || 0;
    d.views = _ci.views || 0;
    d.outreach = _ci.outreach || 0;
    d.engagement_rate = post.currentInsight ? Number(_ci.engagement_rate) : 1;
    d.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
    d.avg_likes = n(post.avg_likes);d.avg_comments = n(post.avg_comments);
    d.avg_views = n(post.avg_views);d.avg_saves = n(post.avg_saves);d.avg_shares = n(post.avg_shares);
    d.type = 'tiktok';
    if (post.inputtedInsights) {
      var _ii = post.inputtedInsights;
      d.saved = _ii.saved;
      if (d.shares === 0) d.shares = _ii.shares;
      if (d.views === 0) d.views = _ii.views || 0;
      d.reach = _ii.reach || 0;d.impressions = _ii.impressions || 0;
      d.plays = _ii.plays || 0;d.watches = _ii.watches ? parseWatchTime(_ii.watches) : 0;
      d.watchedFullVideo = _ii.watchedFullVideo || 0;d.photo_views = _ii.photo_views || 0;
    } else {
      d.saved = post.graphInsight ? post.graphInsight.saved : 0;
      d.shares = 0;d.views = 0;d.reach = 0;d.impressions = 0;d.plays = 0;d.watches = 0;d.watchedFullVideo = 0;
    }
  } else if (post.isYoutube) {
    var _ci2 = post.currentInsight || {};var _pd2 = post.post_details || {};var _ow2 = post.owner || {};
    d.name = _ow2.username;d.title = 'Youtube Post';d.url = _pd2.link;d.type = 'youtube';
    d.impressions = 0;d.engagement = _ci2.engagement || 0;d.reach = 0;
    d.likes = _ci2.like_count || 0;d.comments = _ci2.comment_count || 0;d.views = _ci2.views || 0;
    d.outreach = _ci2.outreach || 0;
    d.engagement_rate = post.currentInsight ? Number(_ci2.engagement_rate) : 1;
    d.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
    d.avg_likes = n(post.avg_likes);d.avg_comments = n(post.avg_comments);d.avg_views = n(post.avg_views);
  } else if (post.isFacebook && post.insights) {
    var _ins = post.insights;var _ow3 = post.owner || {};
    d.name = _ow3.username;d.title = 'Facebook';d.url = post.media_url || '';
    d.outreach = n(_ins.outreach);d.like_count = n(_ins.like_count);d.comment_count = n(_ins.comment_count);
    d.views = n(_ins.views);d.shares = n(_ins.shares);d.bookmarks = n(_ins.bookmarks);d.type = 'facebook';
    d.likes = d.like_count;d.comments = d.comment_count;d.saved = d.bookmarks;
  } else if (post.isXHS && post.insights) {
    var _ins2 = post.insights;var _ow4 = post.owner || {};
    d.name = _ow4.fullName || _ow4.username;
    d.outreach = _ow4.followers ? Number(_ow4.followers) : _ow4.followers_sd;
    d.title = 'XHS';d.url = post.embed_url || '';d.xhsLink = post.xhsLink || '';
    d.like_count = n(_ins2.like_count);d.comment_count = n(_ins2.comment_count);d.views = n(_ins2.views);
    d.watches = n(_ins2.watches);d.shares = n(_ins2.shares);d.bookmarks = n(_ins2.bookmarks);d.type = 'xhs';
    d.likes = d.like_count;d.comments = d.comment_count;d.saved = d.bookmarks;
  } else if (post.isLemon && post.insights) {
    var _ins3 = post.insights;var _ow5 = post.owner || {};
    d.name = _ow5.fullName || _ow5.username;
    d.outreach = _ow5.followers ? Number(_ow5.followers) : _ow5.followers_sd;
    d.title = 'Lemon8';d.url = post.embed_url || '';d.lemonLink = post.lemonLink || '';
    d.like_count = n(_ins3.like_count);d.comment_count = n(_ins3.comment_count);d.views = n(_ins3.views);
    d.watches = n(_ins3.watches);d.shares = n(_ins3.shares);d.bookmarks = n(_ins3.bookmarks);d.type = 'lemon';
    d.likes = d.like_count;d.comments = d.comment_count;d.saved = d.bookmarks;
  } else if (platform === 'twitter' && post.insights) {
    var latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
    var insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights;
    var _ins4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});var _ow6 = post.owner || {};
    d.name = _ow6.twitterHandle || _ow6.username || _ow6.fullName;
    d.outreach = n(_ins4.outreach || _ow6.followers || _ow6.followers_sd);
    var rawUrl = post.postLink || post.postURL || post.post_details || post.url || post.embed_url || '';
    d.title = 'X (Twitter) Post';
    d.url = typeof rawUrl === 'string' ? rawUrl : rawUrl.link || rawUrl.url || rawUrl.href || '';
    d.like_count = n(_ins4.like_count);d.comment_count = n(_ins4.comment_count);d.impressions = n(_ins4.impressions != null ? _ins4.impressions : _ins4.views);d.views = d.impressions;
    d.shares = n(_ins4.shares);d.bookmarks = n(_ins4.saved || _ins4.bookmarks);d.type = 'twitter';
    d.likes = d.like_count;d.comments = d.comment_count;d.saved = d.bookmarks;
  } else if ((platform === 'linkedin' || post.isOthers) && post.insights) {
    var isLinkedIn = platform === 'linkedin';
    var _latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
    var _insightData = _latestInsight && _latestInsight.data ? _latestInsight.data : post.insights;
    var _ins5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});var _ow7 = post.owner || {};
    var influencer = post.influencer_details || {};
    d.name = _ow7.fullName || _ow7.username;
    d.outreach = n(_ins5.outreach);
    d.title = isLinkedIn ? 'LinkedIn Post' : 'Others';
    d.media_type = post.media_type ? String(post.media_type).toLowerCase() : null;
    d.url = isLinkedIn ? post.postLink || post.postURL || '' : post.embed_url || '';
    d.postLink = post.postLink || post.postURL || '';
    d.like_count = n(_ins5.like_count);d.comment_count = n(_ins5.comment_count);d.views = n(_ins5.views);
    d.impressions = n(_ins5.impressions);d.reach = n(_ins5.reach != null ? _ins5.reach : _ins5.outreach);
    d.watches = n(_ins5.watches);d.shares = n(_ins5.shares);d.bookmarks = n(_ins5.saved || _ins5.bookmarks);d.plays = n(_ins5.plays);
    d.type = isLinkedIn ? 'linkedin' : 'others';
    d.likes = d.like_count;d.comments = d.comment_count;d.saved = d.bookmarks;
    if (isLinkedIn) {
      d.profilePlatform = 'linkedin';
      d.profileUrl = [post.linkedinURL, post.linkedinUrl, post.linkedin_profile_url, _ow7.linkedinURL, _ow7.linkedinUrl, _ow7.linkedin_profile_url, _ow7.profileUrl, _ow7.profile_url, influencer.linkedinURL, influencer.linkedinUrl, influencer.linkedin_profile_url, influencer.profileUrl, influencer.profile_url, d.profileUrl].find(Boolean) || '';
      d.profileHandle = [post.linkedinHandle, post.linkedin_handle, _ow7.linkedinHandle, _ow7.handle, _ow7.username, influencer.linkedinHandle, influencer.handle, d.profileHandle, d.name].find(Boolean) || '';
    }
  } else if (post.isMultipleContents) {
    var _ow8 = post.owner || {};
    d.name = _ow8.username;
    d.outreach = _ow8.followers || _ow8.followers_sd;
    d.title = 'IG Story';
    d.url = post.embed_url || '';
    d.type = 'gdrive';
    d.media_type = post.media_type ? String(post.media_type).toLowerCase() : null;
    d.public_id = post.public_id || null;
    d.avg_views = n(post.avg_views);
    d.avg_reels_plays = n(post.avg_reels_plays);
    if (post.insights) {
      var _ins6 = post.insights;
      d.engagement = n(_ins6.engagement);
      d.impressions = n(_ins6.impressions);
      d.reach = n(_ins6.reach);
      d.replies = n(_ins6.replies);
      d.exits = n(_ins6.exits);
      d.taps_back = n(_ins6.taps_back);
      d.taps_forward = n(_ins6.taps_forward);
      d.shares = n(_ins6.shares);
      d.sticker_taps = n(_ins6.sticker_taps);
      d.link_clicks = n(_ins6.link_clicks);
      d.storyTotalInteractions = d.link_clicks + d.replies + d.shares + d.sticker_taps;
    }
  }

  d.live_date = post.live_date ? formatDate(post.live_date) : '-';
  d.liveDate = d.live_date;
  d.isCalculated = true;
  return d;
}

function applyDerived(p) {
  var likes = n(p.likes);var comments = n(p.comments);var saved = n(p.saved);var shares = n(p.shares);
  var outreach = n(p.outreach);var views = n(p.views);var reach = n(p.reach);
  if (p.type === 'story' || p.type === 'gdrive') {
    p.interactions = n(p.shares) + n(p.replies) + n(p.link_clicks) + n(p.sticker_taps) + n(p.story_likes);
    p.new_engagement_rate = outreach ? round2(p.interactions / outreach * 100) : 0;
  } else if (p.type === 'tiktok') {
    p.interactions = likes + comments + saved + shares;
    p.new_engagement_rate = outreach ? round2((likes + comments + shares) / outreach * 100) : 0;
    p.interaction_rate_plays = views ? round2((likes + comments + shares) / views * 100) : 0;
    p.eng_rate_total_viewers = views && reach ? round2((likes + comments + saved + shares) / reach * 100) : 0;
    p.new_engagement_rate_view = outreach ? round2(views / outreach * 100) : 0;
  } else if (p.type === 'youtube') {
    p.interactions = likes + comments;
    p.new_engagement_rate = outreach ? round2((likes + comments) / outreach * 100) : 0;
    p.new_engagement_rate_view = outreach ? round2(views / outreach * 100) : 0;
  } else if (p.type === 'facebook' || p.type === 'xhs' || p.type === 'lemon' || p.type === 'twitter') {
    p.interactions = n(p.like_count) + n(p.comment_count) + n(p.bookmarks) + shares;
  } else {
    p.interactions = likes + comments + saved + shares;
    p.new_engagement_rate = outreach ? round2((likes + comments + saved + shares) / outreach * 100) : 0;
    p.new_engagement_rate_view = outreach ? round2(views / outreach * 100) : 0;
    p.interaction_rate_plays = views ? round2((likes + comments + saved + shares) / views * 100) : 0;
    p.engagement_rate_reach = reach ? round2((likes + comments + saved + shares) / reach * 100) : 0;
  }
  return p;
}

function normalizePosts(rawPosts) {
  var out = [];
  (Array.isArray(rawPosts) ? rawPosts : []).forEach(function (post, index) {
    if (post && post.reportGroup && Array.isArray(post.reports)) {
      post.reports.forEach(function (gp) {
        return out.push(applyDerived(calculatePostData(gp, index)));
      });
    } else if (post) {
      out.push(applyDerived(calculatePostData(post, index)));
    }
  });
  return out;
}

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("  :root {\n    --bg: #0A0A0A;\n    --bg-elev: #131313;\n    --bg-card: #1A1A1A;\n    --border: #232323;\n    --border-strong: #333;\n    --green: #A3FF12;\n    --green-dim: #8FB800;\n    --blue: #3D3DFF;\n    --text: #FAFAFA;\n    --text-dim: #9A9A9A;\n    --text-muted: #5A5A5A;\n    --red: #FF3D3D;\n    --orange: #FF9500;\n    --amber: #FFB800;\n  }\n  * { box-sizing: border-box; margin: 0; padding: 0; }\n  html { scroll-behavior: smooth; }\n  body {\n    background: var(--bg);\n    color: var(--text);\n    font-family: 'Open Sans', -apple-system, sans-serif;\n    font-weight: 400;\n    line-height: 1.5;\n    overflow-x: hidden;\n  }\n  a { color: var(--green); text-decoration: none; }\n  a:hover { text-decoration: underline; }\n\n  /* HEADER */\n  .topbar {\n    border-bottom: 1px solid var(--border);\n    padding: 18px 32px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    background: rgba(10,10,10,0.92);\n    backdrop-filter: blur(12px);\n    z-index: 100;\n  }\n  .logo {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 22px;\n    letter-spacing: 0.5px;\n    color: var(--green);\n    text-transform: uppercase;\n  }\n  .topbar-meta { display: flex; gap: 24px; align-items: center; font-size: 12px; color: var(--text-dim); font-family: 'JetBrains Mono', monospace; }\n  .topbar-meta .badge { padding: 4px 10px; border: 1px solid var(--green); color: var(--green); border-radius: 2px; }\n\n  /* LAYOUT */\n  .container { max-width: 1400px; margin: 0 auto; padding: 0 32px; }\n  section { padding: 80px 0; border-bottom: 1px solid var(--border); }\n  .section-label {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    color: var(--green);\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    margin-bottom: 12px;\n  }\n\n  /* HERO */\n  .hero { padding: 100px 0 80px; border-bottom: 1px solid var(--border); position: relative; overflow: hidden; }\n  .hero::before {\n    content: '';\n    position: absolute;\n    top: -200px;\n    right: -100px;\n    width: 600px;\n    height: 600px;\n    background: radial-gradient(circle, rgba(163,255,18,0.08), transparent 70%);\n    pointer-events: none;\n  }\n  .hero h1 {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: clamp(48px, 8vw, 120px);\n    line-height: 0.92;\n    text-transform: uppercase;\n    letter-spacing: -1.5px;\n    margin-bottom: 28px;\n  }\n  .hero h1 .accent { color: var(--green); font-style: italic; }\n  .hero p.subtitle {\n    font-size: 18px;\n    color: var(--text-dim);\n    max-width: 720px;\n    margin-bottom: 60px;\n    line-height: 1.5;\n  }\n\n  /* KPI ROW */\n  .kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0;\n    border-top: 1px solid var(--border);\n    border-bottom: 1px solid var(--border);\n  }\n  .kpi {\n    padding: 32px 28px;\n    border-right: 1px solid var(--border);\n    position: relative;\n  }\n  .kpi:last-child { border-right: none; }\n  .kpi-label {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 10px;\n    color: var(--text-dim);\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    margin-bottom: 8px;\n  }\n  .kpi-value {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 60px;\n    line-height: 1;\n    color: var(--green);\n    margin-bottom: 4px;\n  }\n  .kpi-sub {\n    font-size: 13px;\n    color: var(--text-dim);\n  }\n\n  /* SECTION HEADINGS */\n  h2 {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: clamp(34px, 5vw, 60px);\n    line-height: 1;\n    text-transform: uppercase;\n    letter-spacing: -0.5px;\n    margin-bottom: 16px;\n  }\n  h2 .accent { color: var(--green); }\n  .section-lede {\n    font-size: 17px;\n    color: var(--text-dim);\n    max-width: 760px;\n    margin-bottom: 48px;\n    line-height: 1.55;\n  }\n\n  /* PILLAR CARDS */\n  .pillar-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    margin-bottom: 40px;\n  }\n  .pillar-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 28px;\n    position: relative;\n    transition: border-color 0.2s;\n  }\n  .pillar-card:hover { border-color: var(--green); }\n  .pillar-card .pillar-name {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 19px;\n    text-transform: uppercase;\n    margin-bottom: 6px;\n    line-height: 1.1;\n  }\n  .pillar-card .pillar-tag {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 10px;\n    color: var(--green);\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  .pillar-stats { display: grid; grid-template-columns: 1fr 1fr; gap: 16px 12px; }\n  .pillar-stat-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--text-muted); text-transform: uppercase; }\n  .pillar-stat-value { font-family: 'Rubik', sans-serif; font-weight: 900; font-size: 26px; line-height: 1; }\n\n  /* CHARTS */\n  .chart-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n  .chart-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 28px;\n  }\n  .chart-card h3 {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 20px;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n  }\n  .chart-card .chart-sub {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    color: var(--text-dim);\n    margin-bottom: 24px;\n  }\n  .chart-wrap { position: relative; height: 320px; }\n  .chart-wrap-tall { position: relative; height: 420px; }\n\n  /* TABLE */\n  .table-wrap { overflow-x: auto; background: var(--bg-card); border: 1px solid var(--border); }\n  table { width: 100%; border-collapse: collapse; font-family: 'Open Sans', sans-serif; font-size: 13px; }\n  thead { background: #0A0A0A; }\n  th {\n    text-align: left;\n    padding: 16px 14px;\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    color: var(--text-dim);\n    border-bottom: 1px solid var(--border-strong);\n    cursor: pointer;\n    user-select: none;\n    white-space: nowrap;\n  }\n  th:hover { color: var(--green); }\n  th .sort-ind { opacity: 0.4; margin-left: 4px; }\n  th.sorted .sort-ind { opacity: 1; color: var(--green); }\n  th.num-th { text-align: right; }\n  th .th-main { display: block; }\n  th .th-sub {\n    display: block;\n    font-family: 'Open Sans', sans-serif;\n    font-size: 10px;\n    color: var(--text-muted);\n    text-transform: none;\n    letter-spacing: 0;\n    margin-top: 4px;\n    font-weight: 400;\n    line-height: 1.3;\n  }\n  th.num-th .th-sub { text-align: right; }\n  td {\n    padding: 16px 14px;\n    border-bottom: 1px solid var(--border);\n    vertical-align: middle;\n  }\n  tr:hover td { background: rgba(163,255,18,0.03); }\n  tr.expanded td { background: rgba(163,255,18,0.05); }\n  td.handle { font-weight: 700; }\n  td.handle .creator-pillar {\n    display: block;\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 9px;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    margin-top: 4px;\n    font-weight: 400;\n  }\n  td.num { font-family: 'JetBrains Mono', monospace; text-align: right; }\n  .tier-badge {\n    display: inline-block;\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 9px;\n    padding: 3px 8px;\n    border: 1px solid var(--border-strong);\n    color: var(--text-dim);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-left: 8px;\n  }\n  .sent-bar {\n    display: flex;\n    height: 8px;\n    width: 100px;\n    background: var(--border);\n    overflow: hidden;\n  }\n  .sent-bar .pos { background: var(--green); }\n  .sent-bar .neu { background: #555; }\n  .sent-bar .neg { background: var(--red); }\n  .gap-cell { color: var(--text-muted); font-style: italic; font-family: 'JetBrains Mono', monospace; font-size: 11px; }\n\n  /* expandable comment rows */\n  tr.detail-row td {\n    padding: 0;\n    background: #0A0A0A;\n    border-bottom: 1px solid var(--border);\n  }\n  .detail-inner { padding: 24px 32px; max-height: 520px; overflow-y: auto; }\n  .detail-inner::-webkit-scrollbar { width: 6px; }\n  .detail-inner::-webkit-scrollbar-thumb { background: var(--border-strong); }\n\n  /* METRIC STRIP inside detail row */\n  .metric-strip {\n    display: grid;\n    grid-template-columns: repeat(8, 1fr);\n    gap: 0;\n    padding: 4px 0 20px;\n    margin-bottom: 18px;\n    border-bottom: 1px dashed var(--border-strong);\n  }\n  .metric-cell {\n    border-left: 1px solid var(--border);\n    padding: 4px 12px;\n  }\n  .metric-cell:first-child { border-left: none; padding-left: 0; }\n  .metric-cell .m-label {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 9px;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 8px;\n  }\n  .metric-cell .m-value {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 22px;\n    line-height: 1;\n    color: var(--green);\n  }\n  .metric-cell .m-sub {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 9px;\n    color: var(--text-muted);\n    margin-top: 6px;\n    letter-spacing: 0.5px;\n  }\n  @media (max-width: 900px) {\n    .metric-strip { grid-template-columns: repeat(2, 1fr); gap: 12px 0; }\n    .metric-cell { border-left: none; padding: 0 12px; }\n  }\n\n  .comment-line {\n    display: flex;\n    gap: 14px;\n    padding: 10px 0;\n    border-bottom: 1px dashed var(--border);\n    font-size: 13px;\n  }\n  .comment-line:last-child { border-bottom: none; }\n  .comment-meta { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--text-muted); min-width: 90px; }\n  .comment-text { flex: 1; color: var(--text); }\n  .comment-tags { display: flex; gap: 6px; font-family: 'JetBrains Mono', monospace; font-size: 9px; text-transform: uppercase; flex-shrink: 0; }\n  .tag-POS { background: rgba(163,255,18,0.15); color: var(--green); padding: 2px 6px; }\n  .tag-NEU { background: rgba(255,255,255,0.05); color: var(--text-dim); padding: 2px 6px; }\n  .tag-NEG { background: rgba(255,61,61,0.15); color: var(--red); padding: 2px 6px; }\n  .tag-theme { background: rgba(61,61,255,0.15); color: #8888FF; padding: 2px 6px; }\n\n  /* PILLAR FILTER */\n  .pillar-filter {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 32px;\n  }\n  .pillar-btn {\n    background: transparent;\n    border: 1px solid var(--border-strong);\n    color: var(--text-dim);\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    padding: 10px 16px;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  .pillar-btn:hover { border-color: var(--green); color: var(--text); }\n  .pillar-btn.active { background: var(--green); color: #000; border-color: var(--green); font-weight: 700; }\n\n  /* DEEP DIVE */\n  .deepdive-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-color: var(--green);\n    padding: 36px;\n    max-width: 980px;\n    margin: 0 auto;\n  }\n  .verdict-label {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    margin-bottom: 10px;\n    color: var(--green);\n  }\n  .deepdive-handle {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 42px;\n    line-height: 1;\n    margin-bottom: 8px;\n  }\n  .deepdive-meta {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    color: var(--text-dim);\n    margin-bottom: 18px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  .deepdive-numbers {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n    margin: 24px 0;\n  }\n  .deepdive-num { border: 1px solid var(--border); padding: 14px; }\n  .deepdive-num-value { font-family: 'Rubik', sans-serif; font-weight: 900; font-size: 28px; line-height: 1; color: var(--green); }\n  .deepdive-num-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--text-dim); text-transform: uppercase; margin-top: 6px; }\n  .takeaway { font-size: 15px; color: var(--text-dim); margin-top: 18px; line-height: 1.6; }\n  .quote-list { display: flex; flex-direction: column; gap: 10px; max-height: 380px; overflow-y: auto; padding-right: 8px; margin-top: 18px; }\n  .quote-list::-webkit-scrollbar { width: 6px; }\n  .quote-list::-webkit-scrollbar-thumb { background: var(--border-strong); }\n  .quote {\n    padding: 14px 16px;\n    border-left: 2px solid var(--green);\n    background: rgba(163,255,18,0.04);\n    font-size: 14px;\n  }\n  .quote.neg { border-left-color: var(--red); background: rgba(255,61,61,0.04); }\n  .quote.neu { border-left-color: var(--text-muted); background: rgba(255,255,255,0.02); }\n  .quote-author { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--text-dim); margin-top: 6px; }\n\n  /* PILLAR EFFICIENCY CARDS */\n  .efficiency-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    margin-top: 32px;\n  }\n  .eff-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 24px;\n  }\n  .eff-card.winner { border-color: var(--green); }\n  .eff-card.below { border-color: var(--red); }\n  .eff-card.par { border-color: var(--orange); }\n  .eff-card .eff-name {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    color: var(--text-dim);\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 8px;\n    line-height: 1.3;\n    min-height: 28px;\n  }\n  .eff-card .eff-headline {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 44px;\n    line-height: 1;\n    margin-bottom: 4px;\n  }\n  .eff-card.winner .eff-headline { color: var(--green); }\n  .eff-card.par .eff-headline { color: var(--orange); }\n  .eff-card.below .eff-headline { color: var(--red); }\n  .eff-card .eff-sub { font-size: 13px; color: var(--text-dim); margin-top: 8px; }\n  .eff-card .eff-detail { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 12px; font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--text-dim); }\n  .eff-card .eff-detail span strong { color: var(--text); font-weight: 700; }\n\n  /* COMPOSITION LAYOUT */\n  .composition-layout {\n    display: grid;\n    grid-template-columns: 1.5fr 1fr;\n    gap: 16px;\n    margin-top: 16px;\n  }\n  .pillar-callout-stack { display: flex; flex-direction: column; gap: 12px; }\n  .pillar-callout {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-left: 4px solid var(--green);\n    padding: 20px 24px;\n  }\n  .pillar-callout.bad { border-left-color: var(--red); }\n  .pillar-callout.mid { border-left-color: var(--orange); }\n  .pillar-callout .pc-name {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    color: var(--green);\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    margin-bottom: 8px;\n  }\n  .pillar-callout.bad .pc-name { color: var(--red); }\n  .pillar-callout.mid .pc-name { color: var(--orange); }\n  .pillar-callout .pc-headline {\n    font-family: 'Rubik', sans-serif; font-weight: 900;\n    font-size: 48px;\n    line-height: 1;\n    margin-bottom: 4px;\n  }\n  .pillar-callout .pc-stat {\n    font-size: 14px;\n    color: var(--text);\n    margin-bottom: 6px;\n  }\n  .pillar-callout .pc-read {\n    font-size: 13px;\n    color: var(--text-dim);\n    line-height: 1.45;\n  }\n\n  /* CUSTOM LEGEND */\n  .custom-legend {\n    display: flex;\n    gap: 22px;\n    justify-content: center;\n    margin: 24px 0 0;\n    flex-wrap: wrap;\n  }\n  .legend-item {\n    cursor: help;\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--text);\n  }\n  .legend-dot { width: 12px; height: 12px; display: inline-block; border-radius: 2px; }\n\n  /* HARD TRUTH CALLOUT */\n  .truth-block {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-left: 4px solid var(--red);\n    padding: 28px 32px;\n    margin-top: 40px;\n  }\n  .truth-label {\n    font-family: 'JetBrains Mono', monospace;\n    font-size: 11px;\n    color: var(--red);\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    margin-bottom: 12px;\n  }\n  .truth-block p {\n    font-size: 15px;\n    color: var(--text);\n    line-height: 1.6;\n    margin-bottom: 8px;\n  }\n  .truth-block p:last-child { margin-bottom: 0; color: var(--text-dim); }\n\n  /* FOOTER */\n  footer { padding: 60px 32px; text-align: center; color: var(--text-muted); font-size: 12px; font-family: 'JetBrains Mono', monospace; border-top: 1px solid var(--border); }\n  footer .footer-logo { font-family: 'Rubik', sans-serif; font-weight: 900; font-size: 28px; color: var(--green); margin-bottom: 12px; text-transform: uppercase; }\n  footer .footer-tag { color: var(--text-dim); margin-bottom: 8px; }\n\n  /* RESPONSIVE */\n  @media (max-width: 900px) {\n    .kpi-grid { grid-template-columns: repeat(2, 1fr); }\n    .kpi:nth-child(2) { border-right: none; }\n    .pillar-grid { grid-template-columns: 1fr; }\n    .chart-grid { grid-template-columns: 1fr; }\n    .composition-layout { grid-template-columns: 1fr; }\n    .efficiency-grid { grid-template-columns: 1fr; }\n    .deepdive-numbers { grid-template-columns: 1fr 1fr; }\n    .container { padding: 0 20px; }\n    .topbar { padding: 14px 20px; }\n  }\n");

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var reportTableHeader = [{
  text: 'IO Number',
  value: 'ioNumbers'
}, {
  text: 'Campaign Name',
  value: 'name'
}, {
  text: 'Start Month',
  value: 'startDate'
}, {
  text: 'End Month',
  value: 'endDate'
}, {
  text: 'KPI Onboarded',
  value: 'onboardKPI'
}, {
  text: 'Target KPI Onboarded as at today',
  value: 'todayOnboardKPI'
}, {
  text: 'Actual Onboarded',
  value: 'actualOnboarded'
}, {
  text: 'Current Progress',
  value: 'currentProgress'
}, {
  text: 'Total Achieved',
  value: 'totalAchieved'
}, {
  text: 'KPI Converages',
  value: 'coverageKPI'
}, {
  text: 'Actual Coverages',
  value: 'coverageActual'
}, {
  text: 'Number of Reviewers',
  value: 'numberOfReviewers'
}, {
  text: '% Achieved',
  value: 'achieved'
}, {
  text: 'In Charge',
  value: 'inCharge'
}, {
  text: 'Actions',
  value: 'action',
  sortable: false
}];

var influencerHeaders = [{
  text: 'Influencer',
  value: 'handle'
}, {
  text: 'Followers',
  value: 'followers'
}, {
  text: 'Status',
  value: 'status'
}, {
  text: 'Completed Form',
  value: 'completedForm'
}, {
  text: 'Review in IMS',
  value: 'imsReview'
}, {
  text: 'Deliverables',
  value: 'deliverables'
}, {
  text: 'Number of Reviews',
  value: 'numberOfReviews'
}];

var defaultCalHeaders = [{
  text: 'POC',
  value: 'poc'
}, {
  text: 'Brand factSheet',
  value: 'bfs'
}, {
  text: 'Campaign',
  value: 'name'
}];

var overallTotals = {
  influencers: {
    title: 'Number of Influencers',
    value: 0
  },
  reviewers: {
    title: 'Number of Reviews',
    value: 0
  },
  followers: {
    title: 'Total Follower Count',
    value: 0
  }
};
var postedTotals = {
  reviewOutreach: {
    title: 'Total Review Outreach',
    value: 0
  },
  totalFollower: {
    title: 'Total Follower Count',
    value: 0
  },
  tiktokContents: {
    title: 'Number of Tiktok Content',
    value: 0
  },
  tiktokOutreach: {
    title: 'Tiktok Outreach',
    value: 0
  },
  instagramContent: {
    title: 'Number of Instagram Content',
    value: 0
  },
  instagramOutreach: {
    title: 'Instagram Outreach',
    value: 0
  }
};

var postedDeliverables = {
  IGS: {
    title: 'IGS',
    value: 0
  },
  IGV: {
    title: 'IGV',
    value: 0
  },
  IGR: {
    title: 'IGR',
    value: 0
  },
  IGC: {
    title: 'IGC',
    value: 0
  },
  IGP: {
    title: 'IGP',
    value: 0
  },
  TTP: {
    title: 'TTP',
    value: 0
  }
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  reportTableHeader: reportTableHeader,
  influencerHeaders: influencerHeaders,
  defaultCalHeaders: defaultCalHeaders,
  overallTotals: overallTotals,
  postedTotals: postedTotals,
  postedDeliverables: postedDeliverables
}));

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tableHeaders = [{
  text: 'IO Number',
  value: 'ioNumbers'
}, {
  text: 'Billing Name as per Xero',
  value: 'billingName'
}, {
  text: 'Campaign Name',
  value: 'campaignName'
}, {
  text: 'Campaign Type',
  value: 'campaignType'
}, {
  text: 'Budget',
  value: 'budget'
}, {
  text: 'Capped COGS',
  value: 'cappedCOGS'
}, {
  text: 'Total COGS',
  value: 'cogsTotal'
}, {
  text: 'COGS (INF) - Inclusive GST',
  value: 'cogsInf'
}, {
  text: 'COGS (INF) - Exclusive GST',
  value: 'cogsNoGST'
}, {
  text: 'COGS (others)',
  value: 'cogsOthers'
}, {
  text: 'COGS %',
  value: 'cogsInfPercentage'
}, {
  text: 'COGS Excess',
  value: 'cogsExcess'
}, {
  text: 'Completed Amount',
  value: 'completedAmt'
}, {
  text: 'Pending Amount',
  value: 'pendingAmt'
}, {
  text: 'AM',
  value: 'AM'
}, {
  text: 'CC',
  value: 'CC'
}, {
  text: 'Stage',
  value: 'stage'
}, {
  text: 'First Post Date',
  value: 'firstPostDate'
}, {
  text: 'Last Post Date',
  value: 'lastPostDate'
}, {
  text: 'Start Month',
  value: 'startMonth'
}, {
  text: 'End Month',
  value: 'endMonth'
}, {
  text: 'Action',
  value: 'action'
}];

var dummyData = [{
  name: 'ongoing',
  title: 'Ongoing',
  panel: [0],
  data: []
}, {
  name: '24Q1',
  title: 'QUARTER 1',
  panel: [0],
  data: []
}, {
  name: '24Q2',
  title: 'QUARTER 2',
  panel: [0],
  data: []
}, {
  name: '24Q3',
  title: 'QUARTER 3',
  panel: [0],
  data: []
}, {
  name: '24Q4',
  title: 'QUARTER 4',
  panel: [0],
  data: []
}, {
  name: 'completed',
  title: 'Completed',
  panel: [0],
  data: []
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  tableHeaders: tableHeaders,
  dummyData: dummyData
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = ({
  createEmailTemplate: function createEmailTemplate(template) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/email/template';
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', url, true, template).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  saveEmailTemplate: function saveEmailTemplate(templateId, template) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/email/template/' + templateId;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('put', url, true, template).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAllEmailTemplates: function getAllEmailTemplates() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var url = '/api/v1/email/template';
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', url, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var postAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Post URL',
  value: 'url',
  legendText: 'Post URL'
}, {
  text: 'Outreach',
  value: 'outreach',
  legendText: 'The number of followers the creator has at the time where the post was made '
}, {
  text: 'Accounts Reached',
  value: 'reach',
  legendText: 'The total number of unique users who viewed the content'
}, {
  text: 'Impressions',
  value: 'impressions',
  legendText: 'The total number of times the content is displayed on an user\'s feed'
}, {
  text: 'Likes',
  value: 'likes',
  legendText: 'The number of times users have tapped the “like” button on a post.'
}, {
  text: 'Shares',
  value: 'shares',
  legendText: 'The number of times users have reposted / shared a post.'
}, {
  text: 'Comments',
  value: 'comments',
  legendText: 'The number of written responses to a post.'
}, {
  text: 'Saves',
  value: 'saved',
  legendText: 'The number of times users have saved a post to their “Saved” folder.'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}, {
  text: 'Views',
  value: 'views',
  legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
}, {
  text: 'Engagement Rate by Outreach',
  value: 'new_engagement_rate',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by the outreach numbers'
}, {
  text: 'Play Rate (by Outreach)',
  value: 'new_engagement_rate_view',
  legendText: 'The total number of views divided by the outreach numbers'
}, {
  text: 'Engagement Rate by Reach',
  value: 'engagement_rate_reach',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by reach'
}, {
  text: 'Avg. Engagement Rate',
  value: 'engagement_rate_sd',
  legendText: 'The average sum of engagement rate on the last 30 posts'
}, {
  text: 'Median Engagement Rate',
  value: 'median_engagement_rate',
  legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
}, {
  text: 'Average Likes',
  value: 'avg_likes',
  legendText: 'Average likes over the last 30 posts'
}, {
  text: 'Average Comments',
  value: 'avg_comments',
  legendText: 'Average comments over the last 30 posts'
}, {
  text: 'Average Views',
  value: 'avg_views',
  legendText: 'Average views over the last 30 posts'
}];
var storyAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Outreach',
  value: 'outreach',
  legendText: 'The number of followers the creator has at the time where the post was made '
}, {
  text: 'Accounts Reached',
  value: 'reach',
  legendText: 'The total number of unique users who viewed the content'
}, {
  text: 'Impressions',
  value: 'impressions',
  legendText: 'The total number of times the content is displayed on an user\'s feed'
}, {
  text: 'Replies',
  value: 'replies',
  legendText: 'The number of replies to a story.'
}, {
  text: 'Shares',
  value: 'shares',
  legendText: 'The number of times users have reposted / shared a story.'
}, {
  text: 'Links Click',
  value: 'link_clicks',
  legendText: 'The number of times users have tapped the link attached on a story.'
}, {
  text: 'Sticker Taps',
  value: 'sticker_taps',
  legendText: 'The number of times users have tapped the hashtags and mentions attached on a story.'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}, {
  text: 'Average Views',
  value: 'avg_views',
  legendText: 'Average views over the last 30 posts'
}, {
  text: 'Average Reels Plays',
  value: 'avg_reels_plays',
  legendText: 'Average plays over the last 30 posts'
}];
var reelAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Post URL',
  value: 'url',
  legendText: 'Post URL'
}, {
  text: 'Outreach',
  value: 'outreach',
  legendText: 'The number of followers the creator has at the time where the post was made '
}, {
  text: 'Accounts Reached',
  value: 'reach',
  legendText: 'The total number of unique users who viewed the content'
}, {
  text: 'Impressions',
  value: 'impressions',
  legendText: 'The total number of times the content is displayed on an user\'s feed'
}, {
  text: 'Likes',
  value: 'likes',
  legendText: 'The number of times users have tapped the “like” button on a post.'
}, {
  text: 'Shares',
  value: 'shares',
  legendText: 'The number of times users have reposted / shared a post.'
}, {
  text: 'Comments',
  value: 'comments',
  legendText: 'The number of written responses to a post.'
}, {
  text: 'Saves',
  value: 'saved',
  legendText: 'The number of times users have saved a post to their “Saved” folder.'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}, {
  text: 'Plays',
  value: 'views',
  legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
}, {
  text: 'Watch Time',
  value: 'plays',
  legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
}, {
  text: 'Average Watch Time',
  value: 'watches',
  legendText: 'How many seconds your video is viewed for'
}, {
  text: 'Engagement Rate by Outreach',
  value: 'new_engagement_rate',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by outreach'
}, {
  text: 'Play Rate (by Outreach)',
  value: 'new_engagement_rate_view',
  legendText: 'The total number of views divided by the outreach'
}, {
  text: 'Engagement Rate by Plays',
  value: 'interaction_rate_plays',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by Plays'
}, {
  text: 'Engagement Rate by Reach',
  value: 'engagement_rate_reach',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by reach'
}, {
  text: 'Avg. Engagement Rate',
  value: 'engagement_rate_sd',
  legendText: 'The average sum of engagement rate on the last 30 posts'
}, {
  text: 'Median Engagement Rate',
  value: 'median_engagement_rate',
  legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
}, {
  text: 'Average Likes',
  value: 'avg_likes',
  legendText: 'Average likes over the last 30 posts'
}, {
  text: 'Average Comments',
  value: 'avg_comments',
  legendText: 'Average comments over the last 30 posts'
}, {
  text: 'Average Views',
  value: 'avg_views',
  legendText: 'Average views over the last 30 posts'
}, {
  text: 'Average Reels Plays',
  value: 'avg_reels_plays',
  legendText: 'Average plays over the last 30 posts'
}];

var tiktokAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Post URL',
  value: 'url',
  legendText: 'Post URL'
}, {
  text: 'Outreach',
  value: 'outreach',
  legendText: 'The number of followers the creator has at the time where the post was made'
}, {
  text: 'Total Play Time',
  value: 'plays',
  legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
}, {
  text: 'Average Watch Time',
  value: 'watches',
  legendText: 'How many seconds your video is viewed for'
}, {
  text: 'Likes',
  value: 'likes',
  legendText: 'The number of times users have tapped the “like” button on a post.'
}, {
  text: 'Comments',
  value: 'comments',
  legendText: 'The number of written responses to a post.'
}, {
  text: 'Shares',
  value: 'shares',
  legendText: 'The number of times users have reposted / shared a post.'
}, {
  text: 'Favourites',
  value: 'saved',
  legendText: 'The number of times users have saved a post to their “Saved” folder.'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}, {
  text: 'Plays',
  value: 'views',
  legendText: 'The number of times users have viewed a post, including every looped view.'
}, {
  text: 'Total Viewers',
  value: 'reach',
  legendText: 'The total number of unique users who viewed the content'
}, {
  text: 'Impressions',
  value: 'impressions',
  legendText: 'Total number of times content have been shown to users'
}, {
  text: 'Average Views',
  value: 'avg_views',
  legendText: 'Average views over the last 30 posts'
}, {
  text: 'Average Likes',
  value: 'avg_likes',
  legendText: 'Average likes over the last 30 posts'
}, {
  text: 'Average Comments',
  value: 'avg_comments',
  legendText: 'Average comments over the last 30 posts'
}, {
  text: 'Average Saves',
  value: 'avg_saves',
  legendText: 'The average sum of saves on the last 30 posts'
}, {
  text: 'Average Shares',
  value: 'avg_shares',
  legendText: 'The average sum of shares on the last 30 posts'
}, {
  text: 'Engagement Rate by Outreach',
  value: 'new_engagement_rate',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by outreach'
}, {
  text: 'Play Rate (by Outreach)',
  value: 'new_engagement_rate_view',
  legendText: 'The total number of plays divided by the outreach'
}, {
  text: 'Engagement Rate by Plays',
  value: 'interaction_rate_plays',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by Plays'
}, {
  text: 'Engagement Rate by Total Viewers',
  value: 'eng_rate_total_viewers',
  legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by total viewers (reach)'
}, {
  text: 'Average Engagement Rate',
  value: 'engagement_rate_sd',
  legendText: 'The average sum of engagement rate on the last 30 posts'
}, {
  text: 'Median Engagement Rate',
  value: 'median_engagement_rate',
  legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
}, {
  text: 'Watched Full Video',
  value: 'watchedFullVideo',
  legendText: 'Watched Full Video'
}];

var youtubeAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Post URL',
  value: 'url',
  legendText: 'Post URL'
}, {
  text: 'Outreach',
  value: 'outreach'
}, {
  text: 'Total Views',
  value: 'views',
  legendText: 'Number of views'
}, {
  text: 'Likes',
  value: 'likes',
  legendText: 'Number of likes'
}, {
  text: 'Comments',
  value: 'comments',
  legendText: 'Number of comments'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}, {
  text: 'Average Views',
  value: 'avg_views',
  legendText: 'Average views over the last 30 posts'
}, {
  text: 'Average Likes',
  value: 'avg_likes',
  legendText: 'Average likes over the last 30 posts'
}, {
  text: 'Average Comments',
  value: 'avg_comments',
  legendText: 'Average comments over the last 30 posts'
}, {
  text: 'Engagement Rate by Interactions',
  value: 'new_engagement_rate',
  legendText: 'The total number of interactions divided by the subscriber numbers'
}, {
  text: 'Engagement Rate by Views',
  value: 'new_engagement_rate_view',
  legendText: 'The total number of views divided by the subscriber numbers'
}, {
  text: 'Average Engagement Rate',
  value: 'engagement_rate_sd',
  legendText: 'Average engagement for all advertorials and organic content'
}, {
  text: 'Median Engagement Rate',
  value: 'median_engagement_rate',
  legendText: 'Distribution by engagement rate for influencers having followers in the similar range/tier'
}];

var xhsAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Outreach',
  value: 'outreach',
  legendText: 'The number of followers the creator has at the time where the post was made '
}, {
  text: 'Likes',
  value: 'like_count',
  legendText: 'The total number of likes'
}, {
  text: 'Comments',
  value: 'comment_count',
  legendText: 'The number of comments.'
}, {
  text: 'Views',
  value: 'views',
  legendText: 'The number of views.'
}, {
  text: 'Shares',
  value: 'shares',
  legendText: 'The number of times users have reposted / shared a story.'
}, {
  text: 'Bookmarks',
  value: 'bookmarks',
  legendText: 'The number of bookmarks.'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}];
var fbAnalysisTableHeaders = [{
  text: 'Campaign',
  value: 'contents'
}, {
  text: 'Live Date',
  value: 'live_date',
  legendText: 'Live Date'
}, {
  text: 'Outreach',
  value: 'outreach',
  legendText: 'The number of followers the creator has at the time where the post was made '
}, {
  text: 'Likes',
  value: 'like_count',
  legendText: 'The total number of likes'
}, {
  text: 'Comments',
  value: 'comment_count',
  legendText: 'The number of comments.'
}, {
  text: 'Views',
  value: 'views',
  legendText: 'The number of views.'
}, {
  text: 'Shares',
  value: 'shares',
  legendText: 'The number of times users have reposted / shared a story.'
}, {
  text: 'Bookmarks',
  value: 'bookmarks',
  legendText: 'The number of bookmarks.'
}, {
  text: 'Interactions',
  value: 'interactions',
  legendText: 'The sum of likes, comments, saves, shares'
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  postAnalysisTableHeaders: postAnalysisTableHeaders,
  storyAnalysisTableHeaders: storyAnalysisTableHeaders,
  reelAnalysisTableHeaders: reelAnalysisTableHeaders,
  tiktokAnalysisTableHeaders: tiktokAnalysisTableHeaders,
  youtubeAnalysisTableHeaders: youtubeAnalysisTableHeaders,
  xhsAnalysisTableHeaders: xhsAnalysisTableHeaders,
  fbAnalysisTableHeaders: fbAnalysisTableHeaders
});

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = ({
  checkExistdUser: function checkExistdUser(email) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('post', '/api/v1/users/gateway/existed', true, {
                email: email
              });

            case 3:
              resp = _context.sent;

              if (!(resp.status !== 200)) {
                _context.next = 6;
                break;
              }

              throw resp;

            case 6:
              return _context.abrupt('return', resp.data);

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);
              throw _context.t0;

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  },
  createUserGateWay: function createUserGateWay(email) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('post', '/api/v1/users/gateway', true, {
                email: email
              });

            case 3:
              resp = _context2.sent;

              if (!(resp.status !== 201)) {
                _context2.next = 6;
                break;
              }

              throw resp;

            case 6:
              return _context2.abrupt('return', resp.data);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 9]]);
    }))();
  }
});

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tableHeaders = [{
  text: 'Estimate Live Month',
  value: 'estimatedLiveDate',
  align: 'start'
}, {
  text: 'Live Date',
  value: 'liveDate',
  align: 'start'
}, {
  text: 'Submission Date',
  value: 'submissionDate',
  align: 'start'
}, {
  text: 'IG/TikTok Handle',
  value: 'handle',
  align: 'start'
}, {
  text: 'Country',
  value: 'country',
  align: 'start'
}, {
  text: 'Bank Name',
  value: 'bankName',
  align: 'start'
}, {
  text: 'SWIFT Code',
  value: 'swiftCode',
  align: 'start'
}, {
  text: 'Bank A/C No.',
  value: 'bankAccount',
  align: 'start'
}, {
  text: 'Payee Name',
  value: 'username',
  align: 'start'
}, {
  text: 'Influencer Email',
  value: 'email',
  align: 'start'
}, {
  text: 'Type',
  value: 'estimationType',
  align: 'start'
}, {
  text: 'Amount',
  value: 'amount',
  align: 'center'
}, {
  text: 'GST',
  value: 'GSTAmount',
  align: 'center'
}, {
  text: 'Total (excluding GST)',
  value: 'GSTExcludedAmt',
  align: 'start'
}, {
  text: 'Campaign Name',
  value: 'campaignName',
  align: 'start'
}, {
  text: 'Client Name',
  value: 'clientName',
  align: 'start'
}, {
  text: 'Campaign IO Number',
  value: 'IONumber',
  align: 'start'
}, {
  text: 'CC',
  value: 'CC',
  align: 'start'
}, {
  text: 'Duplicate',
  value: 'duplicate',
  align: 'start'
}, {
  text: 'Remarks',
  value: 'remarks',
  align: 'start'
}, {
  text: 'Attachments',
  value: 'invoices',
  align: 'center'
}, {
  text: 'Action',
  value: 'action',
  align: 'center'
}];
var countries = ['Singapore', 'Indonesia', 'Philippines', 'Thailand', 'Malaysia', 'Vietnam'];
/* harmony default export */ __webpack_exports__["a"] = ({
  tableHeaders: tableHeaders,
  countries: countries
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var types = [{
  text: 'All',
  value: ''
}, {
  text: 'Direct',
  value: 'direct'
}, {
  text: 'Agency',
  value: 'agency'
}];
var platformLists = [{
  text: 'All',
  value: ''
}, {
  text: 'Instagram',
  value: 'instagram'
}, {
  text: 'TikTok',
  value: 'tiktok'
}, {
  text: 'Youtube',
  value: 'youtube'
}, {
  text: 'LinkedIn',
  value: 'linkedin'
}, {
  text: 'X (Twitter)',
  value: 'twitter'
}, {
  text: 'Xiaohongshu',
  value: 'xiaohongshu'
}];

var influencerTiers = [{
  text: 'Tier 1: >1m',
  value: 0
}, {
  text: 'Tier 2: 500K-1m',
  value: 1
}, {
  text: 'Tier 3: 100K - 500K',
  value: 2
}, {
  text: 'Tier 4: 50K - 100K',
  value: 3
}, {
  text: 'Tier 5: 15K - 50K',
  value: 4
}, {
  text: 'Tier 6: <15K',
  value: 5
}];

var defaultCols = ['instagram', 'tiktok', 'linkedin', 'twitter', 'instagramFollowers', 'tiktokFollowers', 'linkedinFollowers', 'twitterFollowers', 'email', 'country', 'pastCampaigns', 'shortDescription', 'ccRemarks', 'rateCard'];

var tableHeaders = [{
  text: 'Name',
  value: 'name',
  align: 'start',
  sortable: false
}, {
  text: 'Instagram',
  value: 'instagram',
  align: 'start',
  sortable: false
}, {
  text: 'TikTok',
  value: 'tiktok',
  align: 'start',
  sortable: false
}, {
  text: 'Youtube',
  value: 'youtube',
  align: 'start',
  sortable: false
}, {
  text: 'LinkedIn',
  value: 'linkedin',
  align: 'start',
  sortable: false
}, {
  text: 'X (Twitter)',
  value: 'twitter',
  align: 'start',
  sortable: false
}, {
  text: 'Xiaohongshu',
  value: 'xiaohongshu',
  align: 'start',
  sortable: false
}, {
  text: 'Instagram Followers',
  value: 'instagramFollowers',
  align: 'start',
  sortable: false
}, {
  text: 'TikTok Followers',
  value: 'tiktokFollowers',
  align: 'start',
  sortable: false
}, {
  text: 'Youtube Followers',
  value: 'youtubeFollowers',
  align: 'start',
  sortable: false
}, {
  text: 'Followers (Connections)',
  value: 'linkedinFollowers',
  align: 'start',
  sortable: false
}, {
  text: 'X (Twitter) Followers',
  value: 'twitterFollowers',
  align: 'start',
  sortable: false
}, {
  text: 'XHS Followers',
  value: 'xhsFollowers',
  align: 'start',
  sortable: false
}, {
  text: 'Email',
  value: 'email',
  align: 'start',
  sortable: false
}, {
  text: 'Gender',
  value: 'gender',
  align: 'start',
  sortable: false
}, {
  text: 'Country',
  value: 'country',
  align: 'start',
  sortable: false
}, {
  text: 'Mailing Address',
  value: 'mailingAddress',
  align: 'start',
  sortable: false
}, {
  text: 'Postal Code',
  value: 'postalCode',
  align: 'start',
  sortable: false
}, {
  text: 'Date of Birth',
  value: 'dateOfBirth',
  align: 'start',
  sortable: false
}, {
  text: 'Age Group',
  value: 'ageGroup',
  align: 'start',
  sortable: false
}, {
  text: 'Past Campaigns',
  value: 'pastCampaigns',
  align: 'start',
  sortable: false
}, {
  text: 'Short Description',
  value: 'shortDescription',
  align: 'start',
  sortable: false
}, {
  text: 'CC Remarks',
  value: 'ccRemarks',
  align: 'start',
  sortable: false
}, {
  text: 'Stats Analysis',
  value: 'statsAnalysis',
  align: 'start',
  sortable: false
}, {
  text: 'Genre',
  value: 'genre',
  align: 'start',
  sortable: false
}, {
  text: 'Main Category',
  value: 'mainCategory',
  align: 'start',
  sortable: false
}, {
  text: 'Sub Category',
  value: 'subCategory',
  align: 'start',
  sortable: false
}, {
  text: 'Tags',
  value: 'tags',
  align: 'center',
  sortable: false
}, {
  text: 'Travel Form',
  value: 'travelForm',
  align: 'center',
  sortable: false
}, {
  text: 'Rate Card',
  value: 'rateCard',
  align: 'center',
  sortable: false
}, {
  text: 'IMS Profile',
  value: 'IMS',
  align: 'center',
  sortable: false
}, {
  text: 'Audience',
  value: 'Audience',
  align: 'center',
  sortable: false
}, {
  text: 'Actions',
  value: 'actions',
  align: 'start'
}];

var customSlots = {
  instagram: 'instagram',
  tiktok: 'tiktok',
  youtube: 'youtube',
  linkedin: 'linkedin',
  twitter: 'twitter',
  followers: 'followers'
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  platformLists: platformLists,
  influencerTiers: influencerTiers,
  tableHeaders: tableHeaders,
  defaultCols: defaultCols,
  types: types,
  customSlots: customSlots
}));

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var getRanges = function getRanges(from, to) {
  var range = {};
  if (from) {
    range.from = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(from));
  }
  if (to) {
    range.to = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(to));
  }
  return range;
};
var genderOptions = [{ text: 'All', value: '' }, { text: 'Male', value: 'MALE' }, { text: 'Female', value: 'FEMALE' }];
var followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
var followerOptions = getRanges(followersCount, followersCount);

var ageFromCount = ['13', '18', '25', '35', '45', '65'];
var ageToCount = ['17', '24', '34', '44', '64', '65+'];
var ageOptions = getRanges(ageFromCount, ageToCount);

var creatorAgeOptions = ['13-17', '18-24', '25-34', '35-44', '45-64', '65+'];
var creatorAgePercentOptions = ['≥1%', '≥5%', '≥10%', '≥15%', '≥20%', '≥25%', '≥30%', '≥35%', '≥40%', '≥45%', '≥50%', '≥55%', '≥60%', '≥65%', '≥70%', '≥75%', '≥80%', '≥85%', '≥90%', '≥95%'];

var limitOptions = [100, 300, 500, 1000, 2000, 5000, 10000, 'All'];

var paidPstPerformanceCount = ['1', '10', '20', '30', '40', '50', '60', '80', '100'];
var paidPstPerformanceOptions = getRanges(paidPstPerformanceCount, paidPstPerformanceCount);

var engRatePercentageCount = ['5.0', '10.0', '15.0', '20.0'];
var engRatePercentageOptions = getRanges(false, engRatePercentageCount);
var imsOptions = [{ text: 'All Influencers', value: 0 }, { text: 'IMS Only', value: 1 }, { text: 'Not in IMS', value: 2 }];
var imsInfluencerStatus = {
  All: 0,
  IMS: 1,
  NON_IMS: 2
};
var searchFilters = function searchFilters() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
    gender: '',
    followers: { from: '', to: '' },
    isIMS: imsInfluencerStatus.All,
    infInterest: [],
    audienceInterest: [],
    campaign: '',
    campaignType: '',
    engagements: { from: '', to: '' },
    engagementRate: { to: '' },
    ageGroup: '',
    ageGroupPercent: '',
    secAgeGroup: '',
    secAgeGroupPercent: '',
    limit: 100,

    paidPstPerformance: { from: '', to: '' }
  });
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  ageOptions: ageOptions,
  creatorAgeOptions: creatorAgeOptions,
  creatorAgePercentOptions: creatorAgePercentOptions,
  limitOptions: limitOptions,
  genderOptions: genderOptions,
  followerOptions: followerOptions,
  engRatePercentageOptions: engRatePercentageOptions,
  paidPstPerformanceOptions: paidPstPerformanceOptions,
  imsOptions: imsOptions,
  imsInfluencerStatus: imsInfluencerStatus,
  searchFilters: searchFilters
}));

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(36);





/* harmony default export */ __webpack_exports__["a"] = ({
  paginate: function paginate(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/search', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  searchKeyword: function searchKeyword(payload) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('post', '/api/v1/influencers/search/keyword', true, payload).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  fetchLocalAudienceReport: function fetchLocalAudienceReport(instagramID, instagramHandle) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/local/report?instagramID=' + instagramID + '&instagramHandle=' + instagramHandle, true);

            case 3:
              report = _context.sent;
              return _context.abrupt('return', report);

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);
              throw _context.t0;

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  getUserPosts: function getUserPosts(instagramID, instagramHandle, keyword) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/posts?instagramID=' + instagramID + '&instagramHandle=' + instagramHandle + '&keyword=' + keyword, true);

            case 3:
              report = _context2.sent;

              if (!(report.status === 200)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', report.data);

            case 6:
              throw new Error('Server Error');

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](0);
              throw _context2.t0;

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 9]]);
    }))();
  },
  refreshAudienceReport: function refreshAudienceReport(reportId) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var report;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/social-data/audience/reports/' + reportId, true);

            case 3:
              report = _context3.sent;
              return _context3.abrupt('return', report);

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);
              throw _context3.t0;

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  getWordcloud: function getWordcloud(influencerID) {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', '/api/v1/influencers/wordcloud/' + influencerID, true).then(function (response) {
        if (response.status !== 200) {
          reject(response);
          return;
        }

        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var headers = [{
  text: 'Creator',
  align: 'center',
  sortable: true,
  value: 'userHandle',
  class: 'creator-handle-column',
  cellClass: 'creator-handle-column'
}, {
  text: 'Campaign',
  align: 'center',
  sortable: true,
  value: 'campaignName'
}, {
  text: 'Content Storyboard Status',
  align: 'center',
  sortable: true,
  value: 'conceptStatus'
}, {
  text: 'Content Storyboard',
  align: 'center',
  sortable: true,
  value: 'contentScripts'
}, {
  text: 'Pending Item Submission Date',
  align: 'center',
  sortable: true,
  value: 'shootDate'
}, {
  text: 'Deliverables',
  align: 'center',
  sortable: true,
  value: 'deliverableDetails'
}, {
  text: 'Content Feature/pillar',
  align: 'center',
  sortable: true,
  value: 'contentFeature'
}, {
  text: 'Remark',
  align: 'center',
  sortable: true,
  value: 'kobeRemark'
}, {
  text: 'Action',
  align: 'center',
  sortable: true,
  value: 'action'
}];

var conceptStatuses = [{
  text: 'Pending creator concept submission',
  value: 1,
  color: '#e8eaed'
}, {
  text: 'Concept submitted, pending client approval',
  value: 2,
  color: '#ffcfc9'
}, {
  text: 'Concept pending revision',
  value: 3,
  color: '#ffc8aa'
}, {
  text: 'Concept revised, pending client approval',
  value: 4,
  color: '#ffe5a0'
}, {
  text: 'Concept approved, proceed to brief influencers to shoot',
  value: 5,
  color: '#d4edbc'
}, {
  text: 'Draft submitted on IMS',
  value: 6,
  color: '#bfe1f6'
}, {
  text: 'Draft pending revisions',
  value: 7,
  color: '#c6dbe1'
}, {
  text: 'Draft revised, pending final approval',
  value: 8,
  color: '#e6cff2'
}, {
  text: 'Draft approved',
  value: 9,
  color: '#11734b'
}];

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  headers: headers,
  conceptStatuses: conceptStatuses
}));

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);


var templateContents = "<p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Name:&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Handle:</span><span\n      style=\"font-size:15px;color:#000000;\"><br></span><span style=\"font-size:15px;color:#000000;\">Platform:</span><span\n      style=\"font-size:15px;color:#000000;\"><br></span><span style=\"font-size:15px;color:#000000;\">Campaign:</span></p>\n  <p style=\"line-height:1.38\"><br></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#ff0000;\">Submission Date:</span></p>\n  <p style=\"line-height:1.38\"><br></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">IG Reel/ TT</span></p>\n  <p style=\"line-height:1.38\"><br></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Concept:&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Reason for concept:&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Music choice if any:&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><br></p>\n  <div style=\"margin-left:0pt\">\n    <table>\n      <tbody>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Descriptions of scenes/ footage</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Include text overlays / voiceover\n                script in each scene</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Reference links/images&nbsp;</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">INTRO: (can be hook/ theme/ title of\n                your video)&nbsp;</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">What will make your audience want to\n                watch this content?&nbsp;</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">Scene 1:</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Text:&nbsp;</span></p>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">VO:&nbsp;</span></p><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Relate 2-3 pointers of brief into your\n                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p><br>\n          </td>\n          <td rowspan=\"3\">\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">BODY</span></p>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Showcase how you plan to execute every\n                scene and how you\u2019ll feature the product/service that relates to the campaign brief.</span></p>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">*Not every scene needs to have the\n                product/ USPs</span></p><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 2:</span></p><br><br><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 3:</span></p><br><br><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 4:</span></p><br><br><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 5:</span></p><br><br><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 6:</span></p><br><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 7:</span></p><br>\n          </td>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Text:&nbsp;</span></p>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">VO:&nbsp;</span></p><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Relate 2-3 pointers of brief into your\n                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p><br>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">CTA - Call To Action&nbsp;</span></p>\n            <br><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Scene 8:</span></p><br>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <p style=\"line-height:1.38\"><span style=\"font-size:16px;color:#000000;\"><br></span><span\n      style=\"font-size:15px;color:#000000;\">IG Story</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Any Story functions used?&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Polling/ AMA/ Quiz/ Link</span></p>\n  <p style=\"line-height:1.38\"><br></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Music choice if any:&nbsp;</span></p>\n  <div style=\"margin-left:0pt\">\n    <table>\n      <tbody>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Descriptions of scenes</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Include text overlays / voiceover\n                script in each scene</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Reference links/images&nbsp;</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">INTRO: (can be hook/ theme/ title of\n                your video)&nbsp;</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">What will make your audience not skip\n                your story?&nbsp;</span></p><br><br>\n          </td>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Text:&nbsp;</span></p>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">VO:&nbsp;</span></p><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Relate 2-3 pointers of brief into your\n                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p>\n          </td>\n          <td rowspan=\"3\">\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Text:&nbsp;</span></p>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">VO:&nbsp;</span></p><br>\n            <p style=\"line-height:1.38\"><span style=\"font-size:9px;color:#999999;\">Relate 2-3 pointers of brief into your\n                concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">CTA - Call To Action&nbsp;</span></p>\n            <br><br><br>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">Let us know your text display of your\n                link sticker that\u2019ll entice your audience to click&nbsp; (if required):</span><span\n                style=\"font-size:9px;color:#999999;\"><br><br></span></p>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">IG Carousel</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">&nbsp;</span></p>\n  <div style=\"margin-left:0pt\">\n    <table>\n      <tbody>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">IMAGE</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Description of image/gif</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Text on image (if any)</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">Reference image</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">1</span></p>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#999999;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">2</span></p><br>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">3</span></p>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n          <td>\n            <div><br></div>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">Caption:&nbsp;</span></p>\n  <p style=\"line-height:1.38\"><span style=\"font-size:15px;color:#000000;\">(Include mandatory hashtags and mentions needed\n      for campaign)</span></p>\n  <div style=\"margin-left:-49.5pt\">\n    <table>\n      <tbody>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">1st pic&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">2nd Pic&nbsp;&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">3rd Pic</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">4th pic&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#000000;\">5th pic&nbsp; or more</span></p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Description of image/gif:&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Description of image/gif:&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Description of image/gif:&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Description of image/gif:&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Description of image/gif:&nbsp;</span>\n            </p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Text on image (if any):&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Text on image (if any):&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Text on image (if any):&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Text on image (if any):&nbsp;</span>\n            </p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#999999;\">Text on image (if any):&nbsp;</span>\n            </p>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#0000ff;\">Reference image:</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#0000ff;\">Reference image:</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#0000ff;\">Reference image:</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#0000ff;\">Reference image:</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n          <td>\n            <p style=\"line-height:1.2\"><span style=\"font-size:15px;color:#0000ff;\">Reference image:</span></p><br>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">Share a content piece that best\n                describes your content script</span></p>\n            <p style=\"line-height:1.2\"><span style=\"font-size:9px;color:#0000ff;\">(can be existing link/ image/ GIF/ self\n                demo)&nbsp;&nbsp;</span></p>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>";

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
  templateContents: templateContents
}));

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getPendingImageChanges;
/* harmony export (immutable) */ __webpack_exports__["c"] = serializeViewImages;
/* harmony export (immutable) */ __webpack_exports__["a"] = getEditPostErrorMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

function getPendingImageChanges(imageChanges) {
  return imageChanges.filter(function (change) {
    return change.element;
  });
}

function serializeViewImages(viewImages, imageChanges) {
  var pendingChanges = getPendingImageChanges(imageChanges);

  return viewImages.map(function (image) {
    var uploadIndex = pendingChanges.findIndex(function (change) {
      return change.url === image.url;
    });
    if (uploadIndex === -1) return image;

    var serializedImage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, image, {
      pendingUpload: true,
      uploadIndex: uploadIndex
    });
    delete serializedImage.url;
    delete serializedImage.isNew;
    return serializedImage;
  });
}

function getEditPostErrorMessage(error) {
  var responseData = error && error.response && error.response.data;
  if (responseData && responseData.message) {
    return responseData.message;
  }
  if (typeof responseData === 'string') return responseData;
  return error && error.message ? error.message : 'Unable to save changes';
}

/***/ }),
/* 819 */
/***/ (function(module, exports) {



module.exports = [{
    "code": "KASITHBK",
    "bank": "Kasikorn Bank"
}, {
    "code": "SICOTHBK",
    "bank": "SIAM COMERCIAL BANK"
}, {
    "code": "NISPIDJA",
    "bank": "OCBC NISP"
}, {
    "code": "MBBEMYKL",
    "bank": "Maybank"
}, {
    "code": "CENAIDJA",
    "bank": "Bank Central Asia"
}, {
    "code": "HASEHKHH",
    "bank": "Hang Seng Bank"
}, {
    "code": "BKCHHKHH",
    "bank": "Bank of China (Hong Kong) Limited"
}, {
    "code": "HSBCHKHHHKH",
    "bank": "HSBC The Hong Kong and Shanghai Banking Corporation"
}, {
    "code": "CENAIDJA",
    "bank": "Bank Central Asia (BCA)"
}, {
    "code": "MBBEMYKLXXX",
    "bank": "Maybank"
}, {
    "code": "CIBBMYKLXXX",
    "bank": "CIMB"
}, {
    "code": "PBBEMYKL",
    "bank": "Public Bank"
}, {
    "code": "RHBBMYKLXXX",
    "bank": "RHB Bank"
}, {
    "code": "CTBBMYKL",
    "bank": "CIMB Islamic BANK BERHAD"
}, {
    "code": "OCBCMYKLXXX",
    "bank": "OCBC BANK"
}, {
    "code": "MBBEMYKL",
    "bank": "Maybank Berhad"
}, {
    "code": "HLBBMYKLXXX",
    "bank": "Hong Leong Bank"
}, {
    "code": "CIBBMYKL",
    "bank": "CIMB Berhad"
}, {
    "code": "VTCBVNVX",
    "bank": "Techcombank"
}, {
    "code": "KASITHBK",
    "bank": "Kasikorn bank"
}, {
    "code": "KRTHTHBK",
    "bank": "Krungthai Bank"
}, {
    "code": "PBBEMYKLXXX",
    "bank": "PUBLIC BANK BERHAD"
}, {
    "code": "BRINIDJA",
    "bank": "Bank Rakyat Indonesia (BRI)"
}, {
    "code": "CIBBMYKL",
    "bank": "CIMB"
}, {
    "code": "BKKBTHBK",
    "bank": "Bangkok Bank"
}, {
    "code": "BFTVVNVX",
    "bank": "Vietcombank"
}, {
    "code": "WPACAU2S",
    "bank": "Westpac Business"
}, {
    "code": "RHBBMYKLXXX",
    "bank": "RHB BANK BERHAD"
}, {
    "code": "ARBKMYKLXXX",
    "bank": "AMBANK (M) BERHAD"
}, {
    "code": "UBPHPHMMXXX",
    "bank": "Union Bank of the Philippines"
}, {
    "code": "BOPIPHMMXXX",
    "bank": "BANK OF THE PHILIPPINE ISLANDS"
}, {
    "code": "MBBEMYKLPEN",
    "bank": "Maybank"
}, {
    "code": "CIBBMYKL",
    "bank": "CIMB Bank Malaysia"
}, {
    "code": "OCBCMYKL",
    "bank": "OCBC BANK"
}, {
    "code": "PBBEMYKL",
    "bank": "PUBLIC BANK BERHAD"
}, {
    "code": "MBBEMYKLSAC",
    "bank": "Maybank"
}, {
    "code": "KASITHBKXXX",
    "bank": "Kasikorn bank"
}, {
    "code": "KRTHTHBKXXX",
    "bank": "Krung Thai Bank\r\n\r\n"
}, {
    "code": "CIBBMYKLXXX",
    "bank": "CIMB Bank Malaysia"
}, {
    "code": "BOPIPHMMXXX",
    "bank": "Bank of the Philippine Islands - Savings"
}, {
    "code": "BNORPHMMXXX",
    "bank": "BDO UNIBANK, INC."
}, {
    "code": "PNBMPHMMXXX",
    "bank": "PHILIPPINE NATIONAL BANK"
}, {
    "code": "CENAIDJA",
    "bank": "BANK Central Asia Cab Graha Paramita"
}, {
    "code": "CENAIDJA",
    "bank": "BANK CENTRAL ASIA\r\n"
}, {
    "code": "BMRIIDJA",
    "bank": "BANK MANDIRI (PERSERO), PT\r\n"
}, {
    "code": "RHBBMYKL",
    "bank": "RHB Bank"
}, {
    "code": "SICOTHBK",
    "bank": "Siam Commercial Bank Public Company Limited"
}, {
    "code": "KASITHBKXXX",
    "bank": "KASIKORNBANK PUBLIC COMPANY LIMITED"
}, {
    "code": "CITIVNVX",
    "bank": "CITIBANK N.A.\r\n"
}, {
    "code": "BKKBTHBK",
    "bank": "BANGKOK BANK PUBLIC COMPANY LIMITED\r\n"
}, {
    "code": "TMBKTHBKXXX",
    "bank": "THANACHART BANK PUBLIC COMPANY LIMITED\r\n"
}, {
    "code": "MBBEMYKL",
    "bank": "MALAYAN BANKING BERHAD (MAYBANK)\r\n"
}, {
    "code": "MBBEMYKL",
    "bank": "MALAYAN BANKING BERHAD"
}, {
    "code": "HBMBMYKL",
    "bank": "HSBC"
}, {
    "code": "SICOTHBK",
    "bank": "SIAM COMMERCIAL BANK PCL., THE\r\n"
}, {
    "code": "SICOTHBK",
    "bank": "Siam Commercial Bank"
}, {
    "code": "KASITHBK",
    "bank": "Kasikorn Bank"
}, {
    "code": "CIBBMYKLXXX",
    "bank": "CIMB Bank Berhad"
}, {
    "code": "BOPIPHMM",
    "bank": "BANK OF THE PHILIPPINE ISLANDS"
}, {
    "code": "CIBBMYKL",
    "bank": "CIMB Bank Berhad"
}, {
    "code": "ORSIPHM1",
    "bank": "BANCO DE ORO"
}, {
    "code": "KASITHBK",
    "bank": "KASIKORNBANK PUBLIC COMPANY LIMITED"
}, {
    "code": "SICOTHBKXXX",
    "bank": "siam commercial bank"
}, {
    "code": "TMBKTHBK",
    "bank": "TMBThanachart Bank Public Company Limited"
}, {
    "code": "SCBLMYKXXXX",
    "bank": "STANDARD CHARTERED BANK"
}, {
    "code": "SICOTHBK",
    "bank": "Siam Commercial Bank Public Company Limited"
}, {
    "code": "PHBMMYKL",
    "bank": "AFFIN BANK BERHAD"
}, {
    "code": "ICBVVNVX946\r\n",
    "bank": "VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE (FORMERLY VIETNAM BANK FOR INDUSTRY AND TRADE)"
}, {
    "code": "BNORPHMMXXX",
    "bank": "BANCO DE ORO UNIBANK"
}, {
    "code": "MBBEMYKLXXX",
    "bank": "Maybank"
}, {
    "code": "MSCBVNVX004",
    "bank": "MILITARY COMMERCIAL JOINT STOCK BANK"
}, {
    "code": "KASITHBK",
    "bank": "Kasikorn Bank\r\n"
}, {
    "code": "BOPIPHMMXXX",
    "bank": "UNION BANK OF THE PHILIPPINES"
}, {
    "code": "BNORPHMM",
    "bank": "BDO UNIBANK, INC."
}, {
    "code": "MBBEMYKLIPH",
    "bank": "MALAYAN BANKING BERHAD (MAYBANK)"
}, {
    "code": "MBBEMYKL",
    "bank": "MALAYAN BANKING BERHAD (MAYBANK)"
}, {
    "code": "SACLVNVX",
    "bank": "SAIGON COMMERCIAL BANK"
}, {
    "code": "CENAIDJAXXX",
    "bank": "Bank Central Asia"
}];

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_read_more__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__routes__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_sessionExpiry__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_the_mask__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_fb_sdk__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_tabs_component__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_tabs_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_tabs_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_sweetalert2__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__filters__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_platformDisplay__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__directives__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_App_vue__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_tabs_component_docs_resources_tabs_component_css__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_tabs_component_docs_resources_tabs_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_tabs_component_docs_resources_tabs_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_dist_vuetify_css__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_json_excel__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__static_css_custom_css__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__static_css_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__static_css_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__static_css_b_pagination_css__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__static_css_b_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__static_css_b_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_wysiwyg__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_cloudinary_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_cloudinary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_cloudinary_vue__);




























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('tabs', __WEBPACK_IMPORTED_MODULE_16_vue_tabs_component__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('tab', __WEBPACK_IMPORTED_MODULE_16_vue_tabs_component__["Tab"]);



















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_27_vue_json_excel__["a" /* default */]);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_vue_wysiwyg___default.a, {
  maxHeight: '500px'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_19__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_19__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_19__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_19__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('thousandSeprator', __WEBPACK_IMPORTED_MODULE_19__filters__["e" /* thousandSeprator */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('currency', __WEBPACK_IMPORTED_MODULE_19__filters__["f" /* currency */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('abbr', __WEBPACK_IMPORTED_MODULE_19__filters__["g" /* abbr */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('platformDisplayName', __WEBPACK_IMPORTED_MODULE_20__utils_platformDisplay__["a" /* platformDisplayName */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('sortable-data-table', __WEBPACK_IMPORTED_MODULE_21__directives__["a" /* SortableDataTable */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_read_more__["a" /* default */]);

var vuetify = new __WEBPACK_IMPORTED_MODULE_5_vuetify___default.a({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#A3FF12',
        secondary: '#3F3FFF',
        accent: '#1A1A1A',
        info: '#3F3FFF',
        success: '#15803D',
        warning: '#F4B740',
        error: '#D83A2E',
        anchor: '#3F3FFF',
        surface: '#F4F4F4',
        ink: '#1A1A1A',
        facebook: '#1778F2',
        instagram: '#F77737'
      }
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (vuetify);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_10__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || {
      x: 0,
      y: 0
    };
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-135074880-1', 'UA-135074880-2'],
  router: router
});


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_cloudinary_vue___default.a, {
  configuration: {
    cloudName: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].cldConfig.CLOUD_NAME,
    secure: true }
});

var fbOptions = {
  appId: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].FACEBOOK_APP_ID,
  version: 'v15.0'
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__plugins_fb_sdk__["a" /* initFbSdk */])(fbOptions).then(function () {
  console.log('facebook sdk is ready for use');
});

var ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.warnHandler = function (msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

router.beforeEach(function (to, from, next) {
  var isLoggedIn = false;
  if (router.app.$store.state.token && router.app.$store.state.token !== 'null' && router.app.$store.state.user) {
    isLoggedIn = true;
  }

  if (to.name === 'CampaignSummaryReports' || to.name === 'CampaignHtmlReport') {
    return next();
  }
  if (to.name === 'InstagramIntegrate') {
    if (isLoggedIn) {
      return next();
    } else {
      return next({
        name: 'Login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  }

  if (to.name === 'CreateClientFeedbackForm' || to.name === 'CreateBrandSheetForm' || to.name === 'RateCardForm' || to.name === 'JoinCommunityForm' || to.name === 'CreateSigningForm' || to.name === 'ProfileTallyForm' || to.name === 'CreatorConceptForm' || to.name === 'PayoutSubmission') {
    return next();
  }

  if (__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].freeAccessRoutes.includes(to.name)) {
    if (isLoggedIn) {
      next('/');
    } else {
      next();
    }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && !isLoggedIn) {
    next({
      name: 'Login',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    var userRole = Number(router.app.$store.state.user.role);
    var hasPermission = false;
    if (isLoggedIn) {
      hasPermission = to.matched.some(function (record) {
        return record.meta.allow && record.meta.allow.includes(userRole);
      });
    }

    if (hasPermission === false) {
      if (userRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        next({
          name: 'Profile'
        });
      } else if (userRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT) {
        next({
          name: 'Campaigns'
        });
      } else if (userRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.MARKETING) {
        next({
          name: 'All Influencers'
        });
      } else {
        next({
          path: '/'
        });
      }
    } else {
      next();
    }
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_sessionExpiry__["a" /* watchSessionExpiry */])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('SET_GLOBAL_CONFIG', __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#root',
  router: router,
  vuetify: vuetify,
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_22__components_App_vue___default.a);
  }
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LOG_OUT: function LOG_OUT(_ref) {
    var commit = _ref.commit;

    commit('REMOVE_USER');
    commit('REMOVE_TOKEN');

    commit('CLEAR_CACHE');

    if (window.localStorage) {
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('globalConfig');
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_apiService__ = __webpack_require__(128);






var campaignServiceBaseURL = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].apiServiceBaseURL.campaign;
var state = {
  campaigns: [],
  campaignsCount: 0,
  countries: [],
  campaignVerticals: [],
  campaignDetail: {},
  reports: [],
  bfsLists: [],
  invoiceLists: [],
  updatedReport: false,
  campaignUpdated: false,
  feedbackFormUpdated: false,
  invoiceDeleteSuccess: false,
  consolidateReports: [],
  archiveReports: [],
  cldSignature: '',

  campaignCogs: [],
  savedCampaignCogs: false,

  masterLists: [],
  masterListSummary: [],
  savedMasterList: false,
  masterListErr: '',

  dashboardCampaigns: [],
  dashboardActivations: [],
  dashboardBriefings: [],
  dashboardPairings: [],
  dashboardDrafts: [],
  dashboardReportings: [],
  savedDashboardStatus: false,
  emailSent: false
};

var actions = {
  getCampaigns: function getCampaigns(_ref) {
    var _this = this;

    var commit = _ref.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var filters, campaigns;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              filters = payload.filters || {};
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus(filters);

            case 4:
              campaigns = _context.sent;

              if (filters && campaigns) {
                if (filters.statuses && filters.statuses.length > 0) {
                  campaigns = campaigns.filter(function (campaign) {
                    return filters.statuses.includes(Number(campaign.status));
                  });
                }
                if (filters.types) {
                  campaigns = campaigns.filter(function (campaign) {
                    return filters.types.includes(campaign.campaignType);
                  });
                }
                if (filters.type) {
                  campaigns = campaigns.filter(function (campaign) {
                    return campaign.campaignType === filters.type;
                  });
                }
                if (filters.payoutStatus) {
                  campaigns = campaigns.filter(function (campaign) {
                    return campaign.payoutStatus === filters.payoutStatus;
                  });
                }
                if (filters.clientID) {
                  campaigns = campaigns.filter(function (campaign) {
                    return campaign.clientID === filters.clientID;
                  });
                }
              }
              commit('SET_CAMPAIGNS', campaigns);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', '');

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  },
  paginateCampaigns: function paginateCampaigns(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var filters, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              filters = payload.filters || {};
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].paginate(filters);

            case 4:
              response = _context2.sent;

              commit('SET_CAMPAIGNS', response.campaigns || []);
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  },
  getCampaignDetail: function getCampaignDetail(_ref3, id) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('UNSET_CAMPAIGN_DETAIL');
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getCampaign(id);

            case 4:
              response = _context3.sent;

              commit('SET_CAMPAIGN_DETAIL', response);
              _context3.next = 12;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              return _context3.abrupt('return', '');

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 8]]);
    }))();
  },
  getCampaignsCountByStatus: function getCampaignsCountByStatus(_ref4, payload) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              commit('SET_DATA', {
                name: 'campaignsCount',
                data: 0
              });
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/count/bystatus?status=' + payload.status + '&archive=' + payload.archive));

            case 4:
              response = _context4.sent;

              if (response && response.count) {
                commit('SET_DATA', {
                  name: 'campaignsCount',
                  data: response.count
                });
              }
              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              return _context4.abrupt('return', '');

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  },
  getCampaignVerticals: function getCampaignVerticals(_ref5) {
    var _this5 = this;

    var commit = _ref5.commit;
    var filterIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var resp, verticals;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getAllCampaignVerticals(false);

            case 3:
              resp = _context5.sent;

              if (resp) {
                verticals = resp.data;

                if (filterIds.length > 0) {
                  verticals = verticals.filter(function (v) {
                    return filterIds.includes(v.id);
                  });
                }
                commit('SET_CAMPAIGN_VERTICALS', verticals);
              }
              _context5.next = 11;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.error(_context5.t0);
              return _context5.abrupt('return', '');

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  getCountries: function getCountries(_ref6) {
    var _this6 = this;

    var commit = _ref6.commit;
    var filterIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var resp, countries;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getAllCountries(false);

            case 3:
              resp = _context6.sent;

              if (resp) {
                countries = resp;

                if (filterIds.length > 0) {
                  countries = countries.filter(function (v) {
                    return filterIds.includes(v.id);
                  });
                }
                commit('SET_Countries', countries);
              }
              _context6.next = 11;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6['catch'](0);

              console.error(_context6.t0);
              return _context6.abrupt('return', '');

            case 11:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 7]]);
    }))();
  },
  getReportsByCampaignIDs: function getReportsByCampaignIDs(_ref7) {
    var _this7 = this;

    var commit = _ref7.commit;
    var campaignIDs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getReportsByCampaignIDs(campaignIDs);

            case 3:
              resp = _context7.sent;

              if (resp) {
                commit('SET_REPORTS', resp);
              }
              _context7.next = 11;
              break;

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7['catch'](0);

              console.error(_context7.t0);
              return _context7.abrupt('return', '');

            case 11:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 7]]);
    }))();
  },
  getReportsByCampaignIDRefresh: function getReportsByCampaignIDRefresh(_ref8, payload) {
    var _this8 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getReportsByCampaignIDs(payload.campaignIDs, payload.refresh || false);

            case 3:
              resp = _context8.sent;

              if (resp) {
                commit('SET_REPORTS', resp);
              }
              _context8.next = 11;
              break;

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8['catch'](0);

              console.error(_context8.t0);
              return _context8.abrupt('return', '');

            case 11:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 7]]);
    }))();
  },
  getCampaignsByAssignedID: function getCampaignsByAssignedID(_ref9, formData) {
    var _this9 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;

              commit('SET_DATA', {
                name: 'campaignsCount',
                data: 0
              });
              _context9.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/count/by/assigned-id', formData);

            case 4:
              resp = _context9.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'campaignsCount',
                  data: resp.count
                });
              }
              _context9.next = 12;
              break;

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9['catch'](0);

              console.error(_context9.t0);
              return _context9.abrupt('return', '');

            case 12:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 8]]);
    }))();
  },
  getReportsByHandle: function getReportsByHandle(_ref10, handle) {
    var _this10 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;

              commit('SET_DATA', {
                name: 'reports',
                data: []
              });
              filters = {
                handle: handle
              };
              params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context10.next = 6;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/reports/data/byhandle?' + params));

            case 6:
              response = _context10.sent;

              if (response) {
                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'reports',
                    data: response
                  });
                }
              }
              _context10.next = 14;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10['catch'](0);

              console.error(_context10.t0);
              return _context10.abrupt('return', '');

            case 14:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 10]]);
    }))();
  },
  updateReportsByIds: function updateReportsByIds(_ref11, data) {
    var _this11 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;

              commit('UNSET_UPDATED');
              _context11.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].updateReportsByIds(data);

            case 4:
              commit('SET_UPDATED');
              _context11.next = 11;
              break;

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11['catch'](0);

              console.error(_context11.t0);
              return _context11.abrupt('return', '');

            case 11:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 7]]);
    }))();
  },
  updateReportHandle: function updateReportHandle(_ref12, data) {
    var _this12 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;

              commit('SET_DATA', {
                name: 'updatedReport',
                data: false
              });
              _context12.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/reports/update/handle', data);

            case 4:
              commit('SET_DATA', {
                name: 'updatedReport',
                data: true
              });
              _context12.next = 11;
              break;

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12['catch'](0);

              console.error(_context12.t0);
              return _context12.abrupt('return', '');

            case 11:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 7]]);
    }))();
  },
  updateCampaignByIds: function updateCampaignByIds(_ref13, data) {
    var _this13 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;

              commit('UNSET_CAMPAIGN_UPDATED');
              _context13.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].updateCampaignByIds(data);

            case 4:
              commit('SET_CAMPAIGN_UPDATED');
              _context13.next = 11;
              break;

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13['catch'](0);

              console.error(_context13.t0);
              return _context13.abrupt('return', '');

            case 11:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 7]]);
    }))();
  },
  updateFeedbackFormByIds: function updateFeedbackFormByIds(_ref14, data) {
    var _this14 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;

              commit('SET_DATA', {
                name: 'feedbackFormUpdated',
                data: false
              });
              _context14.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/client-feedback/update-by/ids', data);

            case 4:
              commit('SET_DATA', {
                name: 'feedbackFormUpdated',
                data: true
              });
              _context14.next = 11;
              break;

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14['catch'](0);

              console.error(_context14.t0);
              return _context14.abrupt('return', '');

            case 11:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14, [[0, 7]]);
    }))();
  },
  getBFSLists: function getBFSLists(_ref15) {
    var _this15 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var brandFactSheets;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getAllBrandSheets();

            case 3:
              brandFactSheets = _context15.sent;

              commit('SET_BFS', brandFactSheets.data);
              _context15.next = 11;
              break;

            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15['catch'](0);

              console.error(_context15.t0);
              return _context15.abrupt('return', '');

            case 11:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15, [[0, 7]]);
    }))();
  },
  getUploadedInvoiceLists: function getUploadedInvoiceLists(_ref16) {
    var _this16 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getUploadedInvoiceLists();

            case 3:
              response = _context16.sent;

              commit('SET_UPLOADED_INVOICE', response.invoices);
              _context16.next = 11;
              break;

            case 7:
              _context16.prev = 7;
              _context16.t0 = _context16['catch'](0);

              console.error(_context16.t0);
              return _context16.abrupt('return', '');

            case 11:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16, [[0, 7]]);
    }))();
  },
  getPaymentConsolidateReport: function getPaymentConsolidateReport(_ref17) {
    var _this17 = this;

    var commit = _ref17.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var response, filters;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getPaymentConsolidateReport(payload.filters || {});

            case 3:
              response = _context17.sent;

              if (response) {
                filters = payload.filters;

                if (filters && filters.archive) {
                  commit('UNSET_ARCHIVE_REPORT');
                  commit('SET_ARCHIVE_REPORT', response.reports);
                } else {
                  commit('UNSET_CONSOLIDATE_REPORT');
                  commit('SET_CONSOLIDATE_REPORT', response.reports);
                }
              }
              _context17.next = 11;
              break;

            case 7:
              _context17.prev = 7;
              _context17.t0 = _context17['catch'](0);

              console.error(_context17.t0);
              return _context17.abrupt('return', '');

            case 11:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17, [[0, 7]]);
    }))();
  },
  deleteReport: function deleteReport(_ref18, payload) {
    var _this18 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var params;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;

              commit('UNSET_UPDATED');
              params = payload.params || {};
              _context18.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].deleteContentFromReport(payload.id, params);

            case 5:
              commit('SET_UPDATED');
              _context18.next = 12;
              break;

            case 8:
              _context18.prev = 8;
              _context18.t0 = _context18['catch'](0);

              console.error(_context18.t0);
              return _context18.abrupt('return', '');

            case 12:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18, [[0, 8]]);
    }))();
  },
  getCldSignature: function getCldSignature(_ref19, payload) {
    var _this19 = this;

    var commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].getCldSignature(payload.filters || {});

            case 3:
              response = _context19.sent;

              commit('SET_CLD_SIGNATURE', response);
              _context19.next = 11;
              break;

            case 7:
              _context19.prev = 7;
              _context19.t0 = _context19['catch'](0);

              console.error(_context19.t0);
              return _context19.abrupt('return', '');

            case 11:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19, [[0, 7]]);
    }))();
  },
  deleteCldFile: function deleteCldFile(_ref20, payload) {
    var _this20 = this;

    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].deleteCldFile(payload);

            case 3:
              _context20.next = 9;
              break;

            case 5:
              _context20.prev = 5;
              _context20.t0 = _context20['catch'](0);

              console.error(_context20.t0);
              return _context20.abrupt('return', '');

            case 9:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20, [[0, 5]]);
    }))();
  },
  deleteInvoiceByIds: function deleteInvoiceByIds(_ref21, payload) {
    var _this21 = this;

    var commit = _ref21.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;

              commit('UnsetInvoiceDeleteSuccess');
              _context21.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__components_views_Campaign_campaignAPIs__["a" /* default */].bulkDeleteInvoices(payload);

            case 4:
              commit('SetInvoiceDeleteSuccess');
              _context21.next = 11;
              break;

            case 7:
              _context21.prev = 7;
              _context21.t0 = _context21['catch'](0);

              console.error(_context21.t0);
              return _context21.abrupt('return', '');

            case 11:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21, [[0, 7]]);
    }))();
  },
  saveCampaignMasterLists: function saveCampaignMasterLists(_ref22, formData) {
    var _this22 = this;

    var commit = _ref22.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;

              commit('SET_DATA', {
                name: 'savedMasterList',
                data: false
              });
              commit('SET_DATA', {
                name: 'masterListErr',
                data: ''
              });
              _context22.next = 5;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/master-lists/create', formData);

            case 5:
              resp = _context22.sent;

              if (resp.success === false) {
                commit('SET_DATA', {
                  name: 'masterListErr',
                  data: resp.message
                });
              } else {
                commit('SET_DATA', {
                  name: 'savedMasterList',
                  data: true
                });
              }
              _context22.next = 14;
              break;

            case 9:
              _context22.prev = 9;
              _context22.t0 = _context22['catch'](0);

              if (_context22.t0.response.data) {
                commit('SET_DATA', {
                  name: 'masterListErr',
                  data: _context22.t0.response.data
                });
              }
              console.error(_context22.t0);
              return _context22.abrupt('return', '');

            case 14:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22, [[0, 9]]);
    }))();
  },
  updateMasterlistActiveYear: function updateMasterlistActiveYear(_ref23, formData) {
    var _this23 = this;

    var commit = _ref23.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;

              commit('SET_DATA', {
                name: 'savedMasterList',
                data: false
              });
              _context23.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/master-lists/update/active-year', formData);

            case 4:
              commit('SET_DATA', {
                name: 'savedMasterList',
                data: true
              });
              _context23.next = 11;
              break;

            case 7:
              _context23.prev = 7;
              _context23.t0 = _context23['catch'](0);

              console.error(_context23.t0);
              return _context23.abrupt('return', '');

            case 11:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this23, [[0, 7]]);
    }))();
  },
  getCampaignMasterLists: function getCampaignMasterLists(_ref24) {
    var _this24 = this;

    var commit = _ref24.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;

              commit('SET_DATA', {
                name: 'masterLists',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context24.next = 6;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/master-lists?' + params));

            case 6:
              response = _context24.sent;

              if (response) {
                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'masterLists',
                    data: response
                  });
                }
              }
              _context24.next = 14;
              break;

            case 10:
              _context24.prev = 10;
              _context24.t0 = _context24['catch'](0);

              console.error(_context24.t0);
              return _context24.abrupt('return', '');

            case 14:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this24, [[0, 10]]);
    }))();
  },
  getCampaignMasterListsIONumbers: function getCampaignMasterListsIONumbers(_ref25) {
    var _this25 = this;

    var commit = _ref25.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;

              commit('SET_DATA', {
                name: 'masterLists',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context25.next = 6;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/master-lists/find-IO?' + params));

            case 6:
              response = _context25.sent;

              if (response) {
                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'masterLists',
                    data: response
                  });
                }
              }
              _context25.next = 14;
              break;

            case 10:
              _context25.prev = 10;
              _context25.t0 = _context25['catch'](0);

              console.error(_context25.t0);
              return _context25.abrupt('return', '');

            case 14:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this25, [[0, 10]]);
    }))();
  },
  linkMasterlist: function linkMasterlist(_ref26, data) {
    var _this26 = this;

    var commit = _ref26.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;

              commit('SET_DATA', {
                name: 'savedMasterList',
                data: false
              });
              _context26.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/master-lists/link/deal', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedMasterList',
                data: true
              });
              _context26.next = 11;
              break;

            case 7:
              _context26.prev = 7;
              _context26.t0 = _context26['catch'](0);

              console.error(_context26.t0);
              return _context26.abrupt('return', '');

            case 11:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this26, [[0, 7]]);
    }))();
  },
  getMasterListSummary: function getMasterListSummary(_ref27) {
    var _this27 = this;

    var commit = _ref27.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;

              commit('SET_DATA', {
                name: 'masterListSummary',
                data: null
              });
              _context27.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/master-lists/summary', payload);

            case 4:
              resp = _context27.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'masterListSummary',
                  data: resp
                });
              }
              _context27.next = 12;
              break;

            case 8:
              _context27.prev = 8;
              _context27.t0 = _context27['catch'](0);

              console.error(_context27.t0);
              return _context27.abrupt('return', '');

            case 12:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this27, [[0, 8]]);
    }))();
  },
  changeMasterListLock: function changeMasterListLock(_ref28) {
    var _this28 = this;

    var commit = _ref28.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;

              commit('SET_DATA', {
                name: 'savedMasterList',
                data: false
              });
              _context28.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/master-lists/change/lock', payload);

            case 4:
              resp = _context28.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'savedMasterList',
                  data: true
                });
              }
              _context28.next = 12;
              break;

            case 8:
              _context28.prev = 8;
              _context28.t0 = _context28['catch'](0);

              console.error(_context28.t0);
              return _context28.abrupt('return', '');

            case 12:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this28, [[0, 8]]);
    }))();
  },
  refreshMasterList: function refreshMasterList(_ref29) {
    var _this29 = this;

    var commit = _ref29.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.prev = 0;

              commit('SET_DATA', {
                name: 'savedMasterList',
                data: false
              });
              _context29.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/master-lists/refresh', payload);

            case 4:
              resp = _context29.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'savedMasterList',
                  data: true
                });
              }
              _context29.next = 12;
              break;

            case 8:
              _context29.prev = 8;
              _context29.t0 = _context29['catch'](0);

              console.error(_context29.t0);
              return _context29.abrupt('return', '');

            case 12:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this29, [[0, 8]]);
    }))();
  },
  getDashboardReviewMeetings: function getDashboardReviewMeetings(_ref30) {
    var _this30 = this;

    var commit = _ref30.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardCampaigns',
                data: false
              });
              _context30.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/reviewmeetings', payload);

            case 4:
              resp = _context30.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardCampaigns',
                  data: resp.campaigns
                });
              }
              _context30.next = 12;
              break;

            case 8:
              _context30.prev = 8;
              _context30.t0 = _context30['catch'](0);

              console.error(_context30.t0);
              return _context30.abrupt('return', '');

            case 12:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this30, [[0, 8]]);
    }))();
  },
  getDashboardRevDate: function getDashboardRevDate(_ref31) {
    var _this31 = this;

    var commit = _ref31.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardCampaigns',
                data: false
              });
              _context31.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/review-dates', payload);

            case 4:
              resp = _context31.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardCampaigns',
                  data: resp.campaigns
                });
              }
              _context31.next = 12;
              break;

            case 8:
              _context31.prev = 8;
              _context31.t0 = _context31['catch'](0);

              console.error(_context31.t0);
              return _context31.abrupt('return', '');

            case 12:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this31, [[0, 8]]);
    }))();
  },
  getDashboardActivation: function getDashboardActivation(_ref32) {
    var _this32 = this;

    var commit = _ref32.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee32() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardActivations',
                data: false
              });
              _context32.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/activation', payload);

            case 4:
              resp = _context32.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardActivations',
                  data: resp.campaigns
                });
              }
              _context32.next = 12;
              break;

            case 8:
              _context32.prev = 8;
              _context32.t0 = _context32['catch'](0);

              console.error(_context32.t0);
              return _context32.abrupt('return', '');

            case 12:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this32, [[0, 8]]);
    }))();
  },
  getDashboardCampaigns: function getDashboardCampaigns(_ref33) {
    var _this33 = this;

    var commit = _ref33.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee33() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardBriefings',
                data: false
              });
              _context33.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/campaigns', payload);

            case 4:
              resp = _context33.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardBriefings',
                  data: resp.campaigns
                });
              }
              _context33.next = 12;
              break;

            case 8:
              _context33.prev = 8;
              _context33.t0 = _context33['catch'](0);

              console.error(_context33.t0);
              return _context33.abrupt('return', '');

            case 12:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this33, [[0, 8]]);
    }))();
  },
  getDashboardPairings: function getDashboardPairings(_ref34) {
    var _this34 = this;

    var commit = _ref34.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee34() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardPairings',
                data: false
              });
              _context34.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/pairings', payload);

            case 4:
              resp = _context34.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardPairings',
                  data: resp.campaigns
                });
              }
              _context34.next = 12;
              break;

            case 8:
              _context34.prev = 8;
              _context34.t0 = _context34['catch'](0);

              console.error(_context34.t0);
              return _context34.abrupt('return', '');

            case 12:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this34, [[0, 8]]);
    }))();
  },
  getDashboardDrafts: function getDashboardDrafts(_ref35) {
    var _this35 = this;

    var commit = _ref35.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee35() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardDrafts',
                data: false
              });
              _context35.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/drafts', payload);

            case 4:
              resp = _context35.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardDrafts',
                  data: resp.campaigns
                });
              }
              _context35.next = 12;
              break;

            case 8:
              _context35.prev = 8;
              _context35.t0 = _context35['catch'](0);

              console.error(_context35.t0);
              return _context35.abrupt('return', '');

            case 12:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this35, [[0, 8]]);
    }))();
  },
  getDashboardReporting: function getDashboardReporting(_ref36) {
    var _this36 = this;

    var commit = _ref36.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee36() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.prev = 0;

              commit('SET_DATA', {
                name: 'dashboardReportings',
                data: false
              });
              _context36.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/reporting', payload);

            case 4:
              resp = _context36.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'dashboardReportings',
                  data: resp.campaigns
                });
              }
              _context36.next = 12;
              break;

            case 8:
              _context36.prev = 8;
              _context36.t0 = _context36['catch'](0);

              console.error(_context36.t0);
              return _context36.abrupt('return', '');

            case 12:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this36, [[0, 8]]);
    }))();
  },
  saveDashboardStatus: function saveDashboardStatus(_ref37) {
    var _this37 = this;

    var commit = _ref37.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee37() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _context37.prev = 0;

              commit('SET_DATA', {
                name: 'savedDashboardStatus',
                data: false
              });
              _context37.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/dashboard/status/update', payload);

            case 4:
              resp = _context37.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'savedDashboardStatus',
                  data: resp.campaigns
                });
              }
              _context37.next = 12;
              break;

            case 8:
              _context37.prev = 8;
              _context37.t0 = _context37['catch'](0);

              console.error(_context37.t0);
              return _context37.abrupt('return', '');

            case 12:
            case 'end':
              return _context37.stop();
          }
        }
      }, _callee37, _this37, [[0, 8]]);
    }))();
  },
  sendCampaignReleaseEmailToAdmin: function sendCampaignReleaseEmailToAdmin(_ref38) {
    var _this38 = this;

    var commit = _ref38.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee38() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _context38.prev = 0;

              commit('SET_DATA', {
                name: 'emailSent',
                data: false
              });
              _context38.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/release/email-admin', payload);

            case 4:
              resp = _context38.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'emailSent',
                  data: true
                });
              }
              _context38.next = 12;
              break;

            case 8:
              _context38.prev = 8;
              _context38.t0 = _context38['catch'](0);

              console.error(_context38.t0);
              return _context38.abrupt('return', '');

            case 12:
            case 'end':
              return _context38.stop();
          }
        }
      }, _callee38, _this38, [[0, 8]]);
    }))();
  },
  getCampaignCogs: function getCampaignCogs(_ref39) {
    var _this39 = this;

    var commit = _ref39.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee39() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.prev = 0;

              commit('SET_DATA', {
                name: 'campaignCogs',
                data: null
              });
              _context39.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/get/campaign-cogs', payload);

            case 4:
              resp = _context39.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'campaignCogs',
                  data: resp
                });
              }
              _context39.next = 12;
              break;

            case 8:
              _context39.prev = 8;
              _context39.t0 = _context39['catch'](0);

              console.error(_context39.t0);
              return _context39.abrupt('return', '');

            case 12:
            case 'end':
              return _context39.stop();
          }
        }
      }, _callee39, _this39, [[0, 8]]);
    }))();
  },
  updateCampaignCogs: function updateCampaignCogs(_ref40) {
    var _this40 = this;

    var commit = _ref40.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee40() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              _context40.prev = 0;

              commit('SET_DATA', {
                name: 'savedCampaignCogs',
                data: false
              });
              _context40.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/update/campaign-cogs/collection', payload);

            case 4:
              resp = _context40.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'savedCampaignCogs',
                  data: true
                });
              }
              _context40.next = 12;
              break;

            case 8:
              _context40.prev = 8;
              _context40.t0 = _context40['catch'](0);

              console.error(_context40.t0);
              return _context40.abrupt('return', '');

            case 12:
            case 'end':
              return _context40.stop();
          }
        }
      }, _callee40, _this40, [[0, 8]]);
    }))();
  },
  updateCampaignCogsByCampaignID: function updateCampaignCogsByCampaignID(_ref41, payload) {
    var _this41 = this;

    var commit = _ref41.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee41() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              _context41.prev = 0;

              commit('SET_DATA', {
                name: 'savedCampaignCogs',
                data: false
              });
              _context41.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/update/campaign-cogs/by/campaignID', payload);

            case 4:
              resp = _context41.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'savedCampaignCogs',
                  data: true
                });
              }
              _context41.next = 12;
              break;

            case 8:
              _context41.prev = 8;
              _context41.t0 = _context41['catch'](0);

              console.error(_context41.t0);
              return _context41.abrupt('return', '');

            case 12:
            case 'end':
              return _context41.stop();
          }
        }
      }, _callee41, _this41, [[0, 8]]);
    }))();
  }
};

var getters = {
  campaigns: function campaigns(state) {
    return state.campaigns;
  },
  campaignVerticals: function campaignVerticals(state) {
    return state.campaignVerticals;
  }
};

var mutations = {
  SET_CAMPAIGNS: function SET_CAMPAIGNS(state, data) {
    state.campaigns = data;
  },
  SET_CAMPAIGN_VERTICALS: function SET_CAMPAIGN_VERTICALS(state, data) {
    state.campaignVerticals = data;
  },
  SET_CAMPAIGN_DETAIL: function SET_CAMPAIGN_DETAIL(state, data) {
    state.campaignDetail = data;
  },
  UNSET_CAMPAIGN_DETAIL: function UNSET_CAMPAIGN_DETAIL(state) {
    state.campaignDetail = {};
  },
  SET_REPORTS: function SET_REPORTS(state, data) {
    state.reports = data;
  },
  SET_BFS: function SET_BFS(state, data) {
    state.bfsLists = data;
  },
  SET_UPLOADED_INVOICE: function SET_UPLOADED_INVOICE(state, data) {
    state.invoiceLists = data;
  },
  SET_UPDATED: function SET_UPDATED(state) {
    state.updatedReport = true;
  },
  UNSET_UPDATED: function UNSET_UPDATED(state) {
    state.updatedReport = false;
  },
  SET_CAMPAIGN_UPDATED: function SET_CAMPAIGN_UPDATED(state) {
    state.campaignUpdated = true;
  },
  UNSET_CAMPAIGN_UPDATED: function UNSET_CAMPAIGN_UPDATED(state) {
    state.campaignUpdated = false;
  },
  SET_CONSOLIDATE_REPORT: function SET_CONSOLIDATE_REPORT(state, data) {
    state.consolidateReports = data;
  },
  UNSET_CONSOLIDATE_REPORT: function UNSET_CONSOLIDATE_REPORT(state) {
    state.consolidateReports = [];
  },
  SET_ARCHIVE_REPORT: function SET_ARCHIVE_REPORT(state, data) {
    state.archiveReports = data;
  },
  UNSET_ARCHIVE_REPORT: function UNSET_ARCHIVE_REPORT(state) {
    state.archiveReports = [];
  },
  SET_CLD_SIGNATURE: function SET_CLD_SIGNATURE(state, data) {
    state.cldSignature = data;
  },
  SetInvoiceDeleteSuccess: function SetInvoiceDeleteSuccess(state) {
    state.invoiceDeleteSuccess = true;
  },
  UnsetInvoiceDeleteSuccess: function UnsetInvoiceDeleteSuccess(state) {
    state.invoiceDeleteSuccess = false;
  },
  SET_Countries: function SET_Countries(state, data) {
    state.countries = data;
  },
  SET_DATA: function SET_DATA(state, _ref42) {
    var name = _ref42.name,
        data = _ref42.data;

    state[name] = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_Campaign_Timeline_config__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_apiService__ = __webpack_require__(128);







var _this10 = this;







var campaignServiceBaseURL = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].apiServiceBaseURL.campaign;
var state = {
  timelines: [],
  savedTimeline: false,
  timelineDetail: {},
  timelineSummary: [],
  actualDays: null,
  timelineStages: {
    activating: 'activating',
    pairing: 'pairing',
    cocreating: 'cocreating',
    complete: 'complete'
  },

  reviewMeetings: [],
  savedReviewMeeting: false,
  reviewMeetingDetail: {}
};

var actions = {
  getCampaignTimeline: function getCampaignTimeline(_ref, id) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response, timelineDetail, campaign, timelines;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit('SET_DATA', {
                name: 'timelineDetail',
                data: {}
              });
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/timeline?campaignID=' + id));

            case 4:
              response = _context.sent;
              timelineDetail = {};

              if (Array.isArray(response) && response.length) {
                campaign = response.find(function (item) {
                  return String(item.id) === String(id);
                }) || response[0];
                timelines = campaign && Array.isArray(campaign.timelines) ? campaign.timelines : [];

                timelineDetail = timelines.find(function (item) {
                  return String(item.campaignID) === String(id);
                }) || timelines[0] || {};
              }
              commit('SET_DATA', {
                name: 'timelineDetail',
                data: timelineDetail
              });
              return _context.abrupt('return', timelineDetail);

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', null);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 11]]);
    }))();
  },
  getCampaignTimelineLists: function getCampaignTimelineLists(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit('SET_DATA', {
                name: 'timelines',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/timeline?' + params));

            case 6:
              response = _context2.sent;

              if (Array.isArray(response) && response.length) {
                commit('SET_DATA', {
                  name: 'timelines',
                  data: response
                });
              }
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 10]]);
    }))();
  },
  getCampaignTimelineSummary: function getCampaignTimelineSummary(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('SET_DATA', {
                name: 'timelineSummary',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/timeline/summary?' + params));

            case 6:
              response = _context3.sent;

              if (Array.isArray(response) && response.length) {
                commit('SET_DATA', {
                  name: 'timelineSummary',
                  data: response
                });
              }
              _context3.next = 14;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              return _context3.abrupt('return', '');

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 10]]);
    }))();
  },
  getActualDays: function getActualDays(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              commit('SET_DATA', {
                name: 'actualDays',
                data: null
              });

              if (!(!payload.campaignID || !payload.type)) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt('return', false);

            case 4:
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/timeline/actual-days/' + payload.campaignID + '/' + payload.type));

            case 6:
              response = _context4.sent;

              if (response) {
                commit('SET_DATA', {
                  name: 'actualDays',
                  data: response
                });
              }
              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              return _context4.abrupt('return', '');

            case 14:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 10]]);
    }))();
  },
  saveTimeline: function saveTimeline(_ref5, formData) {
    var _this5 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              commit('SET_DATA', {
                name: 'savedTimeline',
                data: false
              });
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/timeline/create', formData);

            case 4:
              commit('SET_DATA', {
                name: 'savedTimeline',
                data: true
              });
              _context5.next = 11;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.error(_context5.t0);
              return _context5.abrupt('return', '');

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  getReviewMeetingLists: function getReviewMeetingLists(_ref6) {
    var _this6 = this;

    var commit = _ref6.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              commit('SET_DATA', {
                name: 'reviewMeetings',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context6.next = 6;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/review-meeting?' + params));

            case 6:
              response = _context6.sent;

              if (Array.isArray(response) && response.length) {
                commit('SET_DATA', {
                  name: 'reviewMeetings',
                  data: response
                });
              }
              _context6.next = 14;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6['catch'](0);

              console.error(_context6.t0);
              return _context6.abrupt('return', '');

            case 14:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 10]]);
    }))();
  },
  getReviewMeeting: function getReviewMeeting(_ref7, id) {
    var _this7 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              commit('SET_DATA', {
                name: 'reviewMeetingDetail',
                data: {}
              });
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].get(campaignServiceBaseURL + ('/review-meeting?campaignID=' + id));

            case 4:
              response = _context7.sent;

              if (Array.isArray(response) && response.length) {
                commit('SET_DATA', {
                  name: 'reviewMeetingDetail',
                  data: response[0].reviewmeetings.length ? response[0].reviewmeetings[0] : {}
                });
              }
              _context7.next = 12;
              break;

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7['catch'](0);

              console.error(_context7.t0);
              return _context7.abrupt('return', '');

            case 12:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  },
  saveReviewMeeting: function saveReviewMeeting(_ref8, formData) {
    var _this8 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;

              commit('SET_DATA', {
                name: 'savedReviewMeeting',
                data: false
              });
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/review-meeting/create', formData);

            case 4:
              commit('SET_DATA', {
                name: 'savedReviewMeeting',
                data: true
              });
              _context8.next = 11;
              break;

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8['catch'](0);

              console.error(_context8.t0);
              return _context8.abrupt('return', '');

            case 11:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 7]]);
    }))();
  },
  saveReviewDeck: function saveReviewDeck(_ref9, payload) {
    var _this9 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;

              commit('SET_DATA', {
                name: 'savedReviewDeck',
                data: false
              });
              _context9.next = 4;
              return __WEBPACK_IMPORTED_MODULE_10__services_apiService__["a" /* default */].post(campaignServiceBaseURL + '/review-meeting/update/review-deck', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedReviewDeck',
                data: true
              });
              _context9.next = 11;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9['catch'](0);

              console.error(_context9.t0);
              return _context9.abrupt('return', '');

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 7]]);
    }))();
  }
};

var getters = {
  getActivatingDays: function getActivatingDays(state, getters) {
    return function (campaignVal) {
      var results = {
        briefing: {
          days: null,
          startDate: null,
          endDate: null
        }
      };
      var campaignActivity = campaignVal.activity || {};
      var createdAt = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(campaignVal.createdAt, 'YYYY-MM-DD');
      var clientAcceptedAt = campaignActivity.clientApproveAt ? __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(campaignActivity.clientApproveAt, 'YYYY-MM-DD') : null;
      if (createdAt && clientAcceptedAt) {
        results.briefing.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(createdAt, clientAcceptedAt);
      }
      if (createdAt) results.briefing.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(createdAt, 'DD/MM/YYYY');
      if (clientAcceptedAt) results.briefing.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(clientAcceptedAt, 'DD/MM/YYYY');
      return results;
    };
  },

  getPairingDays: function getPairingDays(state) {
    return function (campaignVal) {
      var results = {
        firstPayoutConfirmed: {
          days: null,
          startDate: null,
          endDate: null
        },
        allPayoutConfirmed: {
          days: null,
          startDate: null,
          endDate: null
        }
      };
      var campaignActivity = campaignVal.activity || {};
      var clientAcceptedAt = campaignActivity.clientApproveAt ? __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(campaignActivity.clientApproveAt, 'YYYY-MM-DD') : null;
      if (clientAcceptedAt) results.firstPayoutConfirmed.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(clientAcceptedAt, 'DD/MM/YYYY');
      if (state.timelineDetail.payoutConfirmHistory && state.timelineDetail.payoutConfirmHistory.length) {
        var confirmedHistories = state.timelineDetail.payoutConfirmHistory;
        var firstPayoutConfirmedDate = confirmedHistories[0].created_at;
        var lastPayoutConfirmedDate = confirmedHistories[confirmedHistories.length - 1].created_at;
        if (clientAcceptedAt && firstPayoutConfirmedDate) {
          results.firstPayoutConfirmed.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(clientAcceptedAt, firstPayoutConfirmedDate);
        }
        if (firstPayoutConfirmedDate) {
          results.firstPayoutConfirmed.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(lastPayoutConfirmedDate, 'DD/MM/YYYY');
          results.allPayoutConfirmed.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(firstPayoutConfirmedDate, 'DD/MM/YYYY');
        }
        if (firstPayoutConfirmedDate && lastPayoutConfirmedDate) {
          results.allPayoutConfirmed.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(firstPayoutConfirmedDate, lastPayoutConfirmedDate);
        }
        if (lastPayoutConfirmedDate) {
          results.allPayoutConfirmed.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(lastPayoutConfirmedDate, 'DD/MM/YYYY');
        }
      }
      return results;
    };
  },

  getCocreatingDays: function getCocreatingDays(state) {
    return function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10(posts, reports) {
        var results, lastPayoutConfirmedDate, firstContentSubmittedDate, firstRptLiveDate, lastRptLiveDate, confirmedHistories, createdDates, liveDates;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                results = {
                  firstContentSubmitted: {
                    days: null,
                    startDate: null,
                    endDate: null
                  },
                  firstReportLive: {
                    days: null,
                    startDate: null,
                    endDate: null
                  },
                  lastReportLive: {
                    days: null,
                    startDate: null,
                    endDate: null
                  }
                };
                lastPayoutConfirmedDate = null;
                firstContentSubmittedDate = null;
                firstRptLiveDate = null;
                lastRptLiveDate = null;

                if (state.timelineDetail.payoutConfirmHistory && state.timelineDetail.payoutConfirmHistory.length) {
                  confirmedHistories = state.timelineDetail.payoutConfirmHistory;

                  lastPayoutConfirmedDate = confirmedHistories[confirmedHistories.length - 1].created_at;
                }
                createdDates = posts.map(function (p) {
                  if (p.createdAt) {
                    return { 'date': __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(p.createdAt, 'YYYY-MM-DD') };
                  } else return '';
                }).filter(function (p) {
                  return p;
                });

                if (createdDates.length) {
                  createdDates = __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy___default()(createdDates, ['date'], ['asc']);
                  firstContentSubmittedDate = createdDates[0].date;
                }
                if (lastPayoutConfirmedDate && firstContentSubmittedDate) {
                  results.firstContentSubmitted.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(lastPayoutConfirmedDate, firstContentSubmittedDate);
                }
                if (lastPayoutConfirmedDate) results.firstContentSubmitted.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(lastPayoutConfirmedDate, 'DD/MM/YYYY');
                if (firstContentSubmittedDate) {
                  results.firstContentSubmitted.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(firstContentSubmittedDate, 'DD/MM/YYYY');
                  results.firstReportLive.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(firstContentSubmittedDate, 'DD/MM/YYYY');
                }
                liveDates = reports.map(function (rpt) {
                  if (rpt.live_date) {
                    return { 'date': __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(rpt.live_date, 'YYYY-MM-DD') };
                  } else return '';
                }).filter(function (rpt) {
                  return rpt;
                });

                if (liveDates.length) {
                  liveDates = __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy___default()(liveDates, ['date'], ['asc']);
                  firstRptLiveDate = liveDates[0].date;
                  lastRptLiveDate = liveDates[liveDates.length - 1].date;
                }
                if (firstContentSubmittedDate && firstRptLiveDate) {
                  results.firstReportLive.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(firstContentSubmittedDate, firstRptLiveDate);
                }
                if (firstRptLiveDate) {
                  results.firstReportLive.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(firstRptLiveDate, 'DD/MM/YYYY');
                  results.lastReportLive.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(firstRptLiveDate, 'DD/MM/YYYY');
                }
                if (firstRptLiveDate && lastRptLiveDate) {
                  results.lastReportLive.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(firstRptLiveDate, lastRptLiveDate);
                }
                if (lastRptLiveDate) {
                  results.lastReportLive.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(lastRptLiveDate, 'DD/MM/YYYY');
                }
                return _context10.abrupt('return', results);

              case 18:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }));

      return function (_x5, _x6) {
        return _ref10.apply(this, arguments);
      };
    }();
  },

  getCompleteDays: function getCompleteDays(state) {
    return function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11(reports) {
        var result, lastRptLiveDate, reviewMeetingDate, liveDates;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                result = {
                  reviewDate: {
                    days: null,
                    startDate: null,
                    endDate: null
                  }
                };
                lastRptLiveDate = null;
                reviewMeetingDate = null;
                liveDates = reports.map(function (rpt) {
                  if (rpt.live_date) {
                    return { 'date': __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(rpt.live_date, 'YYYY-MM-DD') };
                  } else return '';
                }).filter(function (rpt) {
                  return rpt;
                });

                if (liveDates.length) {
                  liveDates = __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy___default()(liveDates, ['date'], ['asc']);
                  lastRptLiveDate = liveDates[liveDates.length - 1].date;
                }
                if (state.reviewMeetingDetail.reviewMeetingDate) {
                  reviewMeetingDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.parseDate(state.reviewMeetingDetail.reviewMeetingDate);
                }
                if (lastRptLiveDate && reviewMeetingDate) {
                  result.reviewDate.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(lastRptLiveDate, reviewMeetingDate);
                }
                if (lastRptLiveDate) result.reviewDate.startDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(lastRptLiveDate, 'DD/MM/YYYY');
                if (reviewMeetingDate) result.reviewDate.endDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(reviewMeetingDate, 'DD/MM/YYYY');
                return _context11.abrupt('return', result);

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this10);
      }));

      return function (_x7) {
        return _ref11.apply(this, arguments);
      };
    }();
  },

  getStageDays: function getStageDays(state) {
    return function (filteredItems) {
      var stageDays = __WEBPACK_IMPORTED_MODULE_7__components_views_Campaign_Timeline_config__["a" /* default */].timelineTypeLists.map(function (t) {
        var dates = [];
        var filteredItemTypes = filteredItems.filter(function (f) {
          return f.actionType === t.value;
        });
        filteredItemTypes.map(function (t) {
          if (t.startDate) dates.push({ 'date': __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.parseDate(t.startDate) });
          if (t.endDate) dates.push({ 'date': __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.parseDate(t.endDate) });
        });
        if (dates.length) {
          dates = __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy___default()(dates, ['date'], ['asc']);
          t.days = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.dayDurations(dates[0].date, dates[dates.length - 1].date);
        }
        return t;
      });
      return stageDays;
    };
  },

  getActivatingActualDays: function getActivatingActualDays(state) {
    return function (summary, dateRets) {
      var activatingDaysDisplay = {
        briefingDays: dateRets.days,
        briefingStartDate: dateRets.briefing.startDate,
        briefingEndDate: dateRets.briefing.endDate
      };
      summary.actual = activatingDaysDisplay.briefingDays ? activatingDaysDisplay.briefingDays + ' days' : 'invalid';
      summary.actualTasks[0].value = activatingDaysDisplay.briefingStartDate ? '' + activatingDaysDisplay.briefingStartDate : 'invalid';
      summary.actualTasks[1].value = activatingDaysDisplay.briefingEndDate ? '' + activatingDaysDisplay.briefingEndDate : 'invalid';
      return summary;
    };
  },

  getPairingActualDays: function getPairingActualDays(state) {
    return function (summary, dateRets) {
      summary.actual = dateRets.days ? dateRets.days + ' days' : 'invalid';
      var idx = 0;
      var pairingDaysDisplay = {
        firstPayoutConfirmedStartDate: dateRets.firstPayoutConfirmed.startDate,
        allPayoutConfirmedStartDate: dateRets.allPayoutConfirmed.startDate,
        allPayoutConfirmedEndDate: dateRets.allPayoutConfirmed.endDate };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(pairingDaysDisplay)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref12 = _step.value;

          var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref12, 2);

          var key = _ref13[0];
          var value = _ref13[1];

          summary.actualTasks[idx].value = value || value === 0 ? '' + value : 'invalid';
          idx += 1;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return summary;
    };
  },

  getCocreatingActualDays: function getCocreatingActualDays(state) {
    return function (summary, dateRets) {
      summary.actual = dateRets.days ? dateRets.days + ' days' : 'invalid';
      var idx = 0;
      var cocreatingDaysDisplay = {
        firstContentSubmittedStartDate: dateRets.firstContentSubmitted.startDate,

        firstReportLiveStartDate: dateRets.firstReportLive.startDate,

        lastReportLiveStartDate: dateRets.lastReportLive.startDate,
        lastReportLiveEndDate: dateRets.lastReportLive.endDate
      };
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(cocreatingDaysDisplay)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref14 = _step2.value;

          var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref14, 2);

          var key = _ref15[0];
          var value = _ref15[1];

          summary.actualTasks[idx].value = value || value === 0 ? '' + value : 'invalid';
          idx += 1;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return summary;
    };
  },

  getCompleteActualDays: function getCompleteActualDays(state) {
    return function (summary, dateRets) {
      summary.actual = dateRets.days ? dateRets.days + ' days' : 'invalid';
      var idx = 0;
      var completeDaysDisplay = {
        reviewDateStartDate: dateRets.reviewDate.startDate,
        reviewDateEndDate: dateRets.reviewDate.endDate
      };
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(completeDaysDisplay)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref16 = _step3.value;

          var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref16, 2);

          var key = _ref17[0];
          var value = _ref17[1];

          summary.actualTasks[idx].value = value || value === 0 ? '' + value : 'invalid';
          idx += 1;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return summary;
    };
  },

  getProjectedDaysByStage: function getProjectedDaysByStage(state) {
    return function (stageVal) {
      if (state.timelineDetail.numberOfDaysPerStage) {
        var matchStage = state.timelineDetail.numberOfDaysPerStage.filter(function (s) {
          return s.value === stageVal;
        });
        if (matchStage.length) return matchStage[0].days;
      }
      return null;
    };
  },

  getReviewDates: function getReviewDates(state) {
    return function (reviewDate, reports) {
      var result = {
        reviewMeetingDate: '',
        overallAlignmentDate: '',
        amDeckReadyDate: '',
        ccDeckReadyDate: '',
        statsReadyByLivePostsDate: '',
        statsReadyByReviewMeetingDate: ''
      };
      if (!reviewDate) return result;
      result.reviewMeetingDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(reviewDate, 'DD/MM/YYYY');
      result.overallAlignmentDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.reduceDays(reviewDate, 2, 'DD/MM/YYYY');
      result.amDeckReadyDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.reduceDays(reviewDate, 3, 'DD/MM/YYYY');
      result.ccDeckReadyDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.reduceDays(reviewDate, 5, 'DD/MM/YYYY');
      result.statsReadyByReviewMeetingDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.reduceDays(reviewDate, 7, 'DD/MM/YYYY');

      var lastRptLiveDate = null;

      var liveDates = reports.map(function (rpt) {
        if (rpt.live_date) {
          return { 'date': __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(rpt.live_date, 'YYYY-MM-DD') };
        } else return '';
      }).filter(function (rpt) {
        return rpt;
      });
      if (liveDates.length) {
        liveDates = __WEBPACK_IMPORTED_MODULE_9_lodash_orderBy___default()(liveDates, ['date'], ['asc']);
        lastRptLiveDate = liveDates[liveDates.length - 1].date;
      }
      if (lastRptLiveDate) {
        result.statsReadyByLivePostsDate = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.addDays(lastRptLiveDate, 5, 'DD/MM/YYYY');
      }
      return result;
    };
  }
};

var mutations = {
  SET_DATA: function SET_DATA(state, _ref18) {
    var name = _ref18.name,
        data = _ref18.data;

    state[name] = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_Client_clientAPIs__ = __webpack_require__(46);



var state = {
  clients: [],
  dealNatures: []
};

var actions = {
  getClients: function getClients(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__components_views_Client_clientAPIs__["a" /* default */].getAllClients();

            case 3:
              resp = _context.sent;

              commit('SET_CLIENTS', resp.data);
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', '');

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  getDealNatures: function getDealNatures(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var filterIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var resp, dealNatures;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__components_views_Client_clientAPIs__["a" /* default */].getAllClientDealNatures(false);

            case 3:
              resp = _context2.sent;

              if (resp && resp.data.success) {
                dealNatures = resp.data.dealNatures || [];

                if (filterIds.length > 0) {
                  dealNatures = dealNatures.filter(function (v) {
                    return filterIds.includes(v.id);
                  });
                }
                commit('SET_DealNatures', dealNatures);
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  }
};

var getters = {};

var mutations = {
  SET_CLIENTS: function SET_CLIENTS(state, data) {
    state.clients = data;
  },
  SET_DealNatures: function SET_DealNatures(state, data) {
    state.dealNatures = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_apiService__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);








var infServiceBaseURL = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].apiServiceBaseURL.influencer;
var state = {
  influencers: [],
  igInf: {},
  tiktokInf: {},
  youtubeInf: {},
  xhsInf: {},
  fbInf: {},
  linkedinInf: {},
  twitterInf: {},
  infDetail: {},
  savedInfMerge: false,

  rateCards: [],
  savedRateCard: false,

  creatorCommunities: [],
  savedCreatorCommunity: false,
  savedPlatforms: false,
  savedPlatformsNotFoundErr: false,

  importedCreators: [],
  importedCreatorGenres: [],
  importedCreatorCols: [],
  importedCreatorDtl: null,
  savedImportedCreator: null,

  socialDataExist: false,
  socialDataSuccess: false,
  socialDataErrMsg: '',
  deletedAud: false,

  allTags: [],
  assignedTags: [],
  allAssignedTags: [],
  customTag: [],
  updatedTag: false
};

var actions = {
  update: function update(_ref, payload) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].editInfluencer(payload);

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', '');

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },
  getRateCardLists: function getRateCardLists(_ref2, payload) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var params, filters, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getAllRateCards(params);

            case 5:
              data = _context2.sent;

              data = data.map(function (i) {
                i.updatedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(i.updatedAt).format('YYYY-MM-DD HH:mm:ss');
                return i;
              });
              data = __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy___default()(data, ['updatedAt'], ['desc']);
              commit('SET_RATE_CARD', data);
              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 11]]);
    }))();
  },
  deleteRateCard: function deleteRateCard(_ref3, payload) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('SET_DATA', {
                name: 'savedRateCard',
                data: false
              });
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/rate-card/delete', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedRateCard',
                data: true
              });
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              return _context3.abrupt('return', '');

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  getCreatorCommunityLists: function getCreatorCommunityLists(_ref4, payload) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var params, filters, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getAllCreatorCommunities(params);

            case 5:
              data = _context4.sent;

              data = data.map(function (i) {
                i.updatedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(i.updatedAt).format('YYYY-MM-DD HH:mm:ss');
                return i;
              });
              data = __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy___default()(data, ['updatedAt'], ['desc']);
              commit('SET_CREATOR_COMMUNITY', data);
              _context4.next = 15;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              return _context4.abrupt('return', '');

            case 15:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 11]]);
    }))();
  },
  deleteCreatorCommunity: function deleteCreatorCommunity(_ref5, payload) {
    var _this5 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              commit('SET_DATA', {
                name: 'savedCreatorCommunity',
                data: false
              });
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/creator-community/delete', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedCreatorCommunity',
                data: true
              });
              _context5.next = 11;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.error(_context5.t0);
              return _context5.abrupt('return', '');

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  saveRateCard: function saveRateCard(_ref6, data) {
    var _this6 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              commit('UNSET_SAVE_RATECARD');
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].saveRateCard(data);

            case 4:
              commit('SET_SAVE_RATECARD');
              _context6.next = 11;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6['catch'](0);

              console.error(_context6.t0);
              return _context6.abrupt('return', '');

            case 11:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 7]]);
    }))();
  },
  saveCreatorCommunity: function saveCreatorCommunity(_ref7, data) {
    var _this7 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              commit('UNSET_SAVE_CREATORCOMMUNITY');
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].saveCreatorCommunity(data);

            case 4:
              commit('SET_SAVE_CREATORCOMMUNITY');
              _context7.next = 11;
              break;

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7['catch'](0);

              console.error(_context7.t0);
              return _context7.abrupt('return', '');

            case 11:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 7]]);
    }))();
  },
  createMultiplePlatforms: function createMultiplePlatforms(_ref8, payload) {
    var _this8 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;

              commit('UnsetSavedPlatforms');
              commit('SET_DATA', {
                name: 'savedPlatformsNotFoundErr',
                data: false
              });
              _context8.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].saveMutliplePlatforms(payload.data);

            case 5:
              commit('SetSavedPlatforms');
              _context8.next = 13;
              break;

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8['catch'](0);

              console.error(_context8.t0);
              if (_context8.t0.response.status === 404) {
                commit('SET_DATA', {
                  name: 'savedPlatformsNotFoundErr',
                  data: true
                });
              }
              return _context8.abrupt('return', '');

            case 13:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 8]]);
    }))();
  },
  discountPlatforms: function discountPlatforms(_ref9, payload) {
    var _this9 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;

              commit('UnsetSavedPlatforms');
              _context9.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].discountPlatforms(payload.data);

            case 4:
              commit('SetSavedPlatforms');
              _context9.next = 11;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9['catch'](0);

              console.error(_context9.t0);
              return _context9.abrupt('return', '');

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 7]]);
    }))();
  },
  rejectPlatform: function rejectPlatform(_ref10, payload) {
    var _this10 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;

              commit('SET_DATA', {
                name: 'savedPlatforms',
                data: false
              });
              _context10.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/reject/platform', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedPlatforms',
                data: true
              });
              _context10.next = 11;
              break;

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10['catch'](0);

              console.error(_context10.t0);
              return _context10.abrupt('return', '');

            case 11:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 7]]);
    }))();
  },
  getAudienceData: function getAudienceData(_ref11, payload) {
    var _this11 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;

              commit('SET_SocialDataErrMsg', '');
              commit('SET_SocialDataSuccess', false);
              commit('SET_SocialDataExist', false);
              filters = [];

              if (payload) {
                filters = payload.filters;
              }
              _context11.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].importInfluencers(filters);

            case 8:
              resp = _context11.sent;

              if (!(resp.failedInfluencers && resp.failedInfluencers.length)) {
                _context11.next = 12;
                break;
              }

              commit('SET_SocialDataErrMsg', resp.failedInfluencers[0].error ? resp.failedInfluencers[0].error.error.message : 'Cannot fetch audience data');
              return _context11.abrupt('return');

            case 12:
              if (!(filters.handleItems && resp.influencers && resp.influencers.length)) {
                _context11.next = 16;
                break;
              }

              if (!resp.influencers.find(function (inf) {
                return inf.handle === filters.handleItems[0].handle && inf.exist;
              })) {
                _context11.next = 16;
                break;
              }

              commit('SET_SocialDataExist', true);
              return _context11.abrupt('return');

            case 16:
              commit('SET_SocialDataSuccess', true);
              _context11.next = 23;
              break;

            case 19:
              _context11.prev = 19;
              _context11.t0 = _context11['catch'](0);

              console.error(_context11.t0);
              return _context11.abrupt('return', '');

            case 23:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 19]]);
    }))();
  },
  getInfluencerByIgHandle: function getInfluencerByIgHandle(_ref12, payload) {
    var _this12 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              commit('SET_IgInf', {});
              commit('SET_CompareInfEmpty');
              _context12.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByIgHandle(params);

            case 7:
              resp = _context12.sent;

              if (resp) {
                commit('SET_IgInf', resp);
              }
              _context12.next = 15;
              break;

            case 11:
              _context12.prev = 11;
              _context12.t0 = _context12['catch'](0);

              console.error(_context12.t0);
              return _context12.abrupt('return', '');

            case 15:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 11]]);
    }))();
  },
  getInfluencerByTikTokHandle: function getInfluencerByTikTokHandle(_ref13, payload) {
    var _this13 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              commit('SET_TikTokInf', {});
              commit('SET_CompareInfEmpty');
              _context13.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByTikTokHandle(params);

            case 7:
              resp = _context13.sent;

              if (resp) {
                commit('SET_TikTokInf', resp);
              }
              _context13.next = 15;
              break;

            case 11:
              _context13.prev = 11;
              _context13.t0 = _context13['catch'](0);

              console.error(_context13.t0);
              return _context13.abrupt('return', '');

            case 15:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 11]]);
    }))();
  },
  getInfluencerByYoutubeHandle: function getInfluencerByYoutubeHandle(_ref14, payload) {
    var _this14 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              commit('SET_YoutubeInf', {});
              commit('SET_CompareInfEmpty');
              _context14.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByYoutubeHandle(params);

            case 7:
              resp = _context14.sent;

              if (resp) {
                commit('SET_YoutubeInf', resp);
              }
              _context14.next = 15;
              break;

            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14['catch'](0);

              console.error(_context14.t0);
              return _context14.abrupt('return', '');

            case 15:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14, [[0, 11]]);
    }))();
  },
  getInfluencerByXHSHandle: function getInfluencerByXHSHandle(_ref15, payload) {
    var _this15 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              commit('SET_DATA', {
                name: 'xhsInf',
                data: {}
              });
              commit('SET_CompareInfEmpty');
              _context15.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByXHSHandle(params);

            case 7:
              resp = _context15.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'xhsInf',
                  data: resp
                });
              }
              _context15.next = 15;
              break;

            case 11:
              _context15.prev = 11;
              _context15.t0 = _context15['catch'](0);

              console.error(_context15.t0);
              return _context15.abrupt('return', '');

            case 15:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15, [[0, 11]]);
    }))();
  },
  getInfluencerByFbHandle: function getInfluencerByFbHandle(_ref16, payload) {
    var _this16 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              commit('SET_DATA', {
                name: 'fbInf',
                data: {}
              });
              commit('SET_CompareInfEmpty');
              _context16.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByFbHandle(params);

            case 7:
              resp = _context16.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'fbInf',
                  data: resp
                });
              }
              _context16.next = 15;
              break;

            case 11:
              _context16.prev = 11;
              _context16.t0 = _context16['catch'](0);

              console.error(_context16.t0);
              return _context16.abrupt('return', '');

            case 15:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16, [[0, 11]]);
    }))();
  },
  getInfluencerByLinkedInHandle: function getInfluencerByLinkedInHandle(_ref17, payload) {
    var _this17 = this;

    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + encodeURIComponent(filters[key]);
                }).join('&');
              }
              commit('SET_DATA', {
                name: 'linkedinInf',
                data: {}
              });
              commit('SET_CompareInfEmpty');
              _context17.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByLinkedInHandle(params);

            case 7:
              resp = _context17.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'linkedinInf',
                  data: resp
                });
              }
              _context17.next = 15;
              break;

            case 11:
              _context17.prev = 11;
              _context17.t0 = _context17['catch'](0);

              console.error(_context17.t0);
              return _context17.abrupt('return', '');

            case 15:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17, [[0, 11]]);
    }))();
  },
  getInfluencerByTwitterHandle: function getInfluencerByTwitterHandle(_ref18, payload) {
    var _this18 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
      var filters, params, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              filters = payload ? payload.filters : {};
              params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + encodeURIComponent(filters[key]);
              }).join('&');

              commit('SET_DATA', { name: 'twitterInf', data: {} });
              commit('SET_CompareInfEmpty');
              _context18.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByTwitterHandle(params);

            case 7:
              resp = _context18.sent;

              if (resp) commit('SET_DATA', { name: 'twitterInf', data: resp });
              _context18.next = 14;
              break;

            case 11:
              _context18.prev = 11;
              _context18.t0 = _context18['catch'](0);

              console.error(_context18.t0);

            case 14:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this18, [[0, 11]]);
    }))();
  },
  getInfluencerBriefInfoByIds: function getInfluencerBriefInfoByIds(_ref19, payload) {
    var _this19 = this;

    var commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              filters = {};

              if (payload) {
                filters = payload.filters;
              }
              commit('SET_Infs', []);
              _context19.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByIds(filters);

            case 6:
              resp = _context19.sent;

              if (resp) {
                commit('SET_Infs', resp);
              }
              _context19.next = 14;
              break;

            case 10:
              _context19.prev = 10;
              _context19.t0 = _context19['catch'](0);

              console.error(_context19.t0);
              return _context19.abrupt('return', '');

            case 14:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this19, [[0, 10]]);
    }))();
  },
  getInfluencerDetail: function getInfluencerDetail(_ref20, payload) {
    var _this20 = this;

    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
      var id, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              id = payload.id || '';

              if (payload) {
                _context20.next = 4;
                break;
              }

              return _context20.abrupt('return', false);

            case 4:
              commit('SET_InfDetail', {});
              _context20.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].getInfluencer(id);

            case 7:
              resp = _context20.sent;

              if (resp) {
                commit('SET_InfDetail', resp);
              }
              _context20.next = 15;
              break;

            case 11:
              _context20.prev = 11;
              _context20.t0 = _context20['catch'](0);

              console.error(_context20.t0);
              return _context20.abrupt('return', '');

            case 15:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this20, [[0, 11]]);
    }))();
  },
  mergeInf: function mergeInf(_ref21, payload) {
    var _this21 = this;

    var commit = _ref21.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;

              commit('SET_SavedInfMerge', false);
              _context21.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Influencer_influencerAPIs__["a" /* default */].saveMergingInf(payload.formData);

            case 4:
              commit('SET_SavedInfMerge', true);
              _context21.next = 11;
              break;

            case 7:
              _context21.prev = 7;
              _context21.t0 = _context21['catch'](0);

              console.error(_context21.t0);
              return _context21.abrupt('return', '');

            case 11:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this21, [[0, 7]]);
    }))();
  },
  getImportedCreators: function getImportedCreators(_ref22, payload) {
    var _this22 = this;

    var commit = _ref22.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;

              commit('SET_DATA', {
                name: 'importedCreators',
                data: []
              });
              _context22.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/imported/creators', payload);

            case 4:
              resp = _context22.sent;

              commit('SET_DATA', {
                name: 'importedCreators',
                data: resp
              });
              _context22.next = 12;
              break;

            case 8:
              _context22.prev = 8;
              _context22.t0 = _context22['catch'](0);

              console.error(_context22.t0);
              return _context22.abrupt('return', '');

            case 12:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this22, [[0, 8]]);
    }))();
  },
  updateImportedCreatorByIds: function updateImportedCreatorByIds(_ref23, payload) {
    var _this23 = this;

    var commit = _ref23.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;

              commit('SET_DATA', {
                name: 'savedImportedCreator',
                data: false
              });
              _context23.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/imported/creators/update-by/ids', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedImportedCreator',
                data: true
              });
              _context23.next = 11;
              break;

            case 7:
              _context23.prev = 7;
              _context23.t0 = _context23['catch'](0);

              console.error(_context23.t0);
              return _context23.abrupt('return', '');

            case 11:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this23, [[0, 7]]);
    }))();
  },
  deleteAud: function deleteAud(_ref24, payload) {
    var _this24 = this;

    var commit = _ref24.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;

              commit('SET_DATA', {
                name: 'deletedAud',
                data: false
              });
              _context24.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/delete/audience', payload);

            case 4:
              commit('SET_DATA', {
                name: 'deletedAud',
                data: true
              });
              _context24.next = 11;
              break;

            case 7:
              _context24.prev = 7;
              _context24.t0 = _context24['catch'](0);

              console.error(_context24.t0);
              return _context24.abrupt('return', '');

            case 11:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this24, [[0, 7]]);
    }))();
  },
  deleteImportedCreator: function deleteImportedCreator(_ref25, payload) {
    var _this25 = this;

    var commit = _ref25.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;

              commit('SET_DATA', {
                name: 'importedCreators',
                data: false
              });
              _context25.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/imported/creators/delete', payload);

            case 4:
              commit('SET_DATA', {
                name: 'importedCreators',
                data: true
              });
              _context25.next = 11;
              break;

            case 7:
              _context25.prev = 7;
              _context25.t0 = _context25['catch'](0);

              console.error(_context25.t0);
              return _context25.abrupt('return', '');

            case 11:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this25, [[0, 7]]);
    }))();
  },
  fetchIQDataImportedCreator: function fetchIQDataImportedCreator(_ref26, payload) {
    var _this26 = this;

    var commit = _ref26.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;

              commit('SET_DATA', {
                name: 'importedCreatorDtl',
                data: null
              });
              _context26.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/imported/creators/fetch/IQData', payload);

            case 4:
              resp = _context26.sent;

              if (resp) {
                if (!resp.id) {
                  commit('SET_DATA', {
                    name: 'socialDataErrMsg',
                    data: resp.socialDataErr
                  });
                } else {
                  commit('SET_DATA', {
                    name: 'importedCreatorDtl',
                    data: resp
                  });
                }
              }
              _context26.next = 12;
              break;

            case 8:
              _context26.prev = 8;
              _context26.t0 = _context26['catch'](0);

              console.error(_context26.t0);
              return _context26.abrupt('return', '');

            case 12:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this26, [[0, 8]]);
    }))();
  },
  getImportedCreatorGenres: function getImportedCreatorGenres(_ref27, payload) {
    var _this27 = this;

    var commit = _ref27.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;

              commit('SET_DATA', {
                name: 'importedCreatorGenres',
                data: []
              });
              _context27.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(infServiceBaseURL + '/imported/creators/genres', payload);

            case 4:
              resp = _context27.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'importedCreatorGenres',
                  data: resp
                });
              }
              _context27.next = 12;
              break;

            case 8:
              _context27.prev = 8;
              _context27.t0 = _context27['catch'](0);

              console.error(_context27.t0);
              return _context27.abrupt('return', '');

            case 12:
            case 'end':
              return _context27.stop();
          }
        }
      }, _callee27, _this27, [[0, 8]]);
    }))();
  },
  getImportedCreatorsCols: function getImportedCreatorsCols(_ref28, payload) {
    var _this28 = this;

    var commit = _ref28.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;

              commit('SET_DATA', {
                name: 'importedCreatorCols',
                data: []
              });
              _context28.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(infServiceBaseURL + '/imported/creators/cols', payload);

            case 4:
              resp = _context28.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'importedCreatorCols',
                  data: resp
                });
              }
              _context28.next = 12;
              break;

            case 8:
              _context28.prev = 8;
              _context28.t0 = _context28['catch'](0);

              console.error(_context28.t0);
              return _context28.abrupt('return', '');

            case 12:
            case 'end':
              return _context28.stop();
          }
        }
      }, _callee28, _this28, [[0, 8]]);
    }))();
  },
  getAllTags: function getAllTags(_ref29) {
    var _this29 = this;

    var commit = _ref29.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.prev = 0;

              commit('SET_DATA', {
                name: 'allTags',
                data: []
              });
              _context29.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(infServiceBaseURL + '/custom-tags/find');

            case 4:
              resp = _context29.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'allTags',
                  data: resp
                });
              }
              _context29.next = 12;
              break;

            case 8:
              _context29.prev = 8;
              _context29.t0 = _context29['catch'](0);

              console.error(_context29.t0);
              return _context29.abrupt('return', '');

            case 12:
            case 'end':
              return _context29.stop();
          }
        }
      }, _callee29, _this29, [[0, 8]]);
    }))();
  },
  getAllAssignedTags: function getAllAssignedTags(_ref30) {
    var _this30 = this;

    var commit = _ref30.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.prev = 0;

              commit('SET_DATA', {
                name: 'allAssignedTags',
                data: []
              });
              _context30.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(infServiceBaseURL + '/assigned-tags/all/find');

            case 4:
              resp = _context30.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'allAssignedTags',
                  data: resp
                });
              }
              _context30.next = 12;
              break;

            case 8:
              _context30.prev = 8;
              _context30.t0 = _context30['catch'](0);

              console.error(_context30.t0);
              return _context30.abrupt('return', '');

            case 12:
            case 'end':
              return _context30.stop();
          }
        }
      }, _callee30, _this30, [[0, 8]]);
    }))();
  },
  getCustomTags: function getCustomTags(_ref31, payload) {
    var _this31 = this;

    var commit = _ref31.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31() {
      var params, filters, resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.prev = 0;

              commit('SET_DATA', {
                name: 'customTag',
                data: []
              });
              params = '';

              if (payload) {
                filters = payload.filters;

                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                  return key + '=' + filters[key];
                }).join('&');
              }
              _context31.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(infServiceBaseURL + '/custom-tags/findOne?' + params);

            case 6:
              resp = _context31.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'customTag',
                  data: resp
                });
              }
              _context31.next = 14;
              break;

            case 10:
              _context31.prev = 10;
              _context31.t0 = _context31['catch'](0);

              console.error(_context31.t0);
              return _context31.abrupt('return', '');

            case 14:
            case 'end':
              return _context31.stop();
          }
        }
      }, _callee31, _this31, [[0, 10]]);
    }))();
  },
  updateTag: function updateTag(_ref32, payload) {
    var _this32 = this;

    var commit = _ref32.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee32() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;

              commit('SET_DATA', {
                name: 'updatedTag',
                data: false
              });
              _context32.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/custom-tags/create', payload);

            case 4:
              commit('SET_DATA', {
                name: 'updatedTag',
                data: true
              });
              _context32.next = 11;
              break;

            case 7:
              _context32.prev = 7;
              _context32.t0 = _context32['catch'](0);

              console.error(_context32.t0);
              return _context32.abrupt('return', '');

            case 11:
            case 'end':
              return _context32.stop();
          }
        }
      }, _callee32, _this32, [[0, 7]]);
    }))();
  },
  deleteTag: function deleteTag(_ref33, payload) {
    var _this33 = this;

    var commit = _ref33.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee33() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;

              commit('SET_DATA', {
                name: 'updatedTag',
                data: false
              });
              _context33.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/custom-tags/delete', payload);

            case 4:
              commit('SET_DATA', {
                name: 'updatedTag',
                data: true
              });
              _context33.next = 11;
              break;

            case 7:
              _context33.prev = 7;
              _context33.t0 = _context33['catch'](0);

              console.error(_context33.t0);
              return _context33.abrupt('return', '');

            case 11:
            case 'end':
              return _context33.stop();
          }
        }
      }, _callee33, _this33, [[0, 7]]);
    }))();
  },
  getAssignedTags: function getAssignedTags(_ref34, payload) {
    var _this34 = this;

    var commit = _ref34.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee34() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.prev = 0;

              commit('SET_DATA', {
                name: 'assignedTags',
                data: []
              });
              _context34.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/assigned-tags/find', payload);

            case 4:
              resp = _context34.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'assignedTags',
                  data: resp
                });
              }
              _context34.next = 12;
              break;

            case 8:
              _context34.prev = 8;
              _context34.t0 = _context34['catch'](0);

              console.error(_context34.t0);
              return _context34.abrupt('return', '');

            case 12:
            case 'end':
              return _context34.stop();
          }
        }
      }, _callee34, _this34, [[0, 8]]);
    }))();
  },
  updateRateCardByIds: function updateRateCardByIds(_ref35, payload) {
    var _this35 = this;

    var commit = _ref35.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee35() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.prev = 0;

              commit('SET_DATA', {
                name: 'savedRateCard',
                data: false
              });
              _context35.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/rate-card/update-by/ids', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedRateCard',
                data: true
              });
              _context35.next = 11;
              break;

            case 7:
              _context35.prev = 7;
              _context35.t0 = _context35['catch'](0);

              console.error(_context35.t0);
              return _context35.abrupt('return', '');

            case 11:
            case 'end':
              return _context35.stop();
          }
        }
      }, _callee35, _this35, [[0, 7]]);
    }))();
  },
  updateCreatorCommunityByIds: function updateCreatorCommunityByIds(_ref36, payload) {
    var _this36 = this;

    var commit = _ref36.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee36() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              _context36.prev = 0;

              commit('SET_DATA', {
                name: 'savedCreatorCommunity',
                data: false
              });
              _context36.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(infServiceBaseURL + '/creator-community/update-by/ids', payload);

            case 4:
              commit('SET_DATA', {
                name: 'savedCreatorCommunity',
                data: true
              });
              _context36.next = 11;
              break;

            case 7:
              _context36.prev = 7;
              _context36.t0 = _context36['catch'](0);

              console.error(_context36.t0);
              return _context36.abrupt('return', '');

            case 11:
            case 'end':
              return _context36.stop();
          }
        }
      }, _callee36, _this36, [[0, 7]]);
    }))();
  }
};

var getters = {};

var mutations = {
  SET_SAVE_RATECARD: function SET_SAVE_RATECARD(state) {
    state.savedRateCard = true;
  },
  UNSET_SAVE_RATECARD: function UNSET_SAVE_RATECARD(state) {
    state.savedRateCard = false;
  },
  SET_RATE_CARD: function SET_RATE_CARD(state, data) {
    state.rateCards = data;
  },
  SET_SAVE_CREATORCOMMUNITY: function SET_SAVE_CREATORCOMMUNITY(state) {
    state.savedCreatorCommunity = true;
  },
  UNSET_SAVE_CREATORCOMMUNITY: function UNSET_SAVE_CREATORCOMMUNITY(state) {
    state.savedCreatorCommunity = false;
  },
  SET_CREATOR_COMMUNITY: function SET_CREATOR_COMMUNITY(state, data) {
    state.creatorCommunities = data;
  },
  UnsetSavedPlatforms: function UnsetSavedPlatforms(state) {
    state.savedPlatforms = false;
  },
  SetSavedPlatforms: function SetSavedPlatforms(state) {
    state.savedPlatforms = true;
  },
  SET_SocialDataSuccess: function SET_SocialDataSuccess(state, status) {
    state.socialDataSuccess = status;
  },
  SET_SocialDataExist: function SET_SocialDataExist(state, status) {
    state.socialDataExist = status;
  },
  SET_SocialDataErrMsg: function SET_SocialDataErrMsg(state, message) {
    state.socialDataErrMsg = message;
  },
  SET_IgInf: function SET_IgInf(state, data) {
    state.igInf = data;
  },
  SET_TikTokInf: function SET_TikTokInf(state, data) {
    state.tiktokInf = data;
  },
  SET_YoutubeInf: function SET_YoutubeInf(state, data) {
    state.youtubeInf = data;
  },
  SET_Infs: function SET_Infs(state, data) {
    state.influencers = data;
  },
  SET_InfDetail: function SET_InfDetail(state, data) {
    state.infDetail = data;
  },
  SET_SavedInfMerge: function SET_SavedInfMerge(state, status) {
    state.savedInfMerge = status;
  },
  SET_CompareInfEmpty: function SET_CompareInfEmpty(state) {
    state.igInf = {};
    state.tiktokInf = {};
    state.youtubeInf = {};
    state.xhsInf = {};
    state.fbInf = {};
    state.linkedinInf = {};
    state.twitterInf = {};
  },
  SET_DATA: function SET_DATA(state, _ref37) {
    var name = _ref37.name,
        data = _ref37.data;

    state[name] = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_MATCH_PARAMS: function SET_MATCH_PARAMS(state, params) {
    state.aiMatchParams.size = params.size ? params.size : 200;
    state.aiMatchParams.minFollowers = params.minFollowers ? params.minFollowers : 500;
    state.aiMatchParams.postDate = params.postDate ? params.postDate : '';
  },
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_FACEBOOK_DATA: function SET_FACEBOOK_DATA(state, facebook) {
    state.facebook = facebook;
  },
  SET_AVATAR: function SET_AVATAR(state, profilePicture) {
    state.user.profilePicture = profilePicture;
    var user = JSON.parse(localStorage.getItem('user'));
    if (user !== undefined) {
      user.profilePicture = profilePicture;
      localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
    }
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_GLOBAL_CONFIG: function SET_GLOBAL_CONFIG(state, config) {
    state.globalConfig = config;
  },
  REMOVE_GLOBAL_CONFIG: function REMOVE_GLOBAL_CONFIG(state, config) {
    state.globalConfig = null;
  },
  REMOVE_USER: function REMOVE_USER(state) {
    state.user = null;
  },
  REMOVE_FACEBOOK_DATA: function REMOVE_FACEBOOK_DATA(state) {
    state.facebook = null;
  },
  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
    state.token = null;
  },
  SET_COMPANIES: function SET_COMPANIES(state, companyList) {
    state.cache.companyList = {
      data: companyList,
      lastUpdate: Date.now()
    };
  },
  SET_CLIENTS: function SET_CLIENTS(state, clientList) {
    state.cache.clientList = {
      data: clientList,
      lastUpdate: Date.now()
    };
  },
  SET_CAMPAIGNS: function SET_CAMPAIGNS(state, campaignData) {
    state.cache.campaignList[campaignData.campaignStatus] = {
      data: campaignData.data,
      lastUpdate: Date.now()
    };
  },
  SET_CAMPAIGNVERTICALS: function SET_CAMPAIGNVERTICALS(state, campaignVerticalList) {
    state.cache.campaignVerticalList = {
      data: campaignVerticalList,
      lastUpdate: Date.now()
    };
  },
  SET_INFLUENCERS: function SET_INFLUENCERS(state, influencerList) {
    state.cache.influencerList = {
      data: influencerList,
      lastUpdate: Date.now()
    };
  },
  CLEAR_CACHE: function CLEAR_CACHE(state) {
    state.cache = {
      companyList: {
        data: null,
        lastUpdate: null
      },
      clientList: {
        data: null,
        lastUpdate: null
      },
      campaignList: {},
      influencerList: {
        data: null,
        lastUpdate: null
      }
    };
  },
  SET_NOTIFICATIONS: function SET_NOTIFICATIONS(state, notificationData) {
    state.userInfo.notifications = notificationData;
  },
  SET_USER_PLATFORMS: function SET_USER_PLATFORMS(state, infInfo) {
    state.userPlatforms = [];
    state.showActivePlatform = null;
    state.activePlatform = null;
    if (infInfo.instagram && infInfo.instagram.instagramHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.instagram.instagramHandle,
        platform: 'instagram',
        icon: 'mdi-instagram'
      });
    }
    if (infInfo.facebook && infInfo.facebook.handle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.facebook.handle,
        platform: 'facebook',
        icon: 'mdi-facebook'
      });
    }
    if (infInfo.tiktok && infInfo.tiktok.tiktokHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.tiktok.tiktokHandle,
        platform: 'tiktok',
        imgIcon: '/static/img/tiktok-32.png'
      });
    }
    if (infInfo.youtube && (infInfo.youtube.youtubeHandle || infInfo.youtube.youtubeCustomName)) {
      state.userPlatforms.push({
        handle: '@' + (infInfo.youtube.youtubeHandle || infInfo.youtube.youtubeCustomName),
        platform: 'youtube',
        icon: 'mdi-youtube'
      });
    }
    if (infInfo.xiaohongshu && (infInfo.xiaohongshu.xhsFullname || infInfo.xiaohongshu.xhsHandle)) {
      state.userPlatforms.push({
        handle: '@' + (infInfo.xiaohongshu.xhsFullname || infInfo.xiaohongshu.xhsHandle),
        platform: 'xiaohongshu',
        icon: ''
      });
    }
    if (infInfo.linkedin && infInfo.linkedin.linkedinHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.linkedin.linkedinHandle,
        platform: 'linkedin',
        icon: 'mdi-linkedin'
      });
    }
    if (infInfo.twitter && infInfo.twitter.twitterHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.twitter.twitterHandle,
        platform: 'twitter',
        imgIcon: '/static/img/x-logo.svg'
      });
    }
    var requestedActivePlatform = String(infInfo.activePlatform || '').toLowerCase() === 'x' ? 'twitter' : String(infInfo.activePlatform || '').toLowerCase();
    state.showActivePlatform = state.userPlatforms.find(function (p) {
      return p.platform === requestedActivePlatform;
    }) || state.userPlatforms[0] || null;
    if (state.showActivePlatform) state.activePlatform = state.showActivePlatform.platform;
  },
  REMOVE_ACTIVE_PLATFORM: function REMOVE_ACTIVE_PLATFORM(state) {
    state.showActivePlatform = null;
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_apiService__ = __webpack_require__(128);





var pairingServiceBaseURL = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].apiServiceBaseURL.pairing;
var pairingServiceOpenBaseURL = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].apiServiceBaseURL.pairingOpen;
var state = {
  pairings: [],
  pairingDetails: {},
  unsubmittedInfluencers: [],
  status: {
    NEW: {
      text: 'New',
      value: 0
    },
    ELIMINATION_PENDING: {
      text: 'In Elimination',
      value: 1
    },
    APPROVED: {
      text: 'Approved',
      value: 2
    },
    INVITED: {
      text: 'Invited',
      value: 3
    },
    INTERESTED: {
      text: 'Interested',
      value: 4
    },
    NOT_INTERESTED: {
      text: 'Not Interested',
      value: 5
    },
    ACCEPTED: {
      text: 'Accepted',
      value: 6
    },
    NOT_ACCEPTED: {
      text: 'Not Accepted',
      value: 7
    },
    INQUIRY: {
      text: 'Inquiry',
      value: 8
    }
  },
  savedCOGSApproval: false,
  requestedPayoutEdit: false,
  saved: false,
  infLists: []
};

var actions = {
  getPairings: function getPairings(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Pairing_pairingAPIs__["a" /* default */].getAllPairings();

            case 3:
              response = _context.sent;

              if (response) {
                commit('SET_PAIRINGS', response);
              }
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', '');

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  getPostUnsubmittedPairingInfluencers: function getPostUnsubmittedPairingInfluencers(_ref2, filter) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Pairing_pairingAPIs__["a" /* default */].getPostUnsubmittedPairingInfluencers(filter);

            case 3:
              response = _context2.sent;

              if (response) {
                commit('SET_UNSUBMITTED_INFLUENCERS', response);
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  },
  saveAmountApproval: function saveAmountApproval(_ref3, data) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('SET_DATA', {
                name: 'savedAmountApproval',
                data: false
              });
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/update/approval-amount', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedAmountApproval',
                data: true
              });
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              return _context3.abrupt('return', '');

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  saveCOGSApproval: function saveCOGSApproval(_ref4, data) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              commit('SET_DATA', {
                name: 'savedCOGSApproval',
                data: false
              });
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/request/cogs/approval-amount', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedCOGSApproval',
                data: true
              });
              _context4.next = 11;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              return _context4.abrupt('return', '');

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  },
  updatePayoutActivity: function updatePayoutActivity(_ref5, data) {
    var _this5 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              commit('SET_DATA', {
                name: 'savedPayoutActivity',
                data: false
              });
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/update/payout-activity', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedPayoutActivity',
                data: true
              });
              _context5.next = 11;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.error(_context5.t0);
              return _context5.abrupt('return', '');

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  requestPayoutEdit: function requestPayoutEdit(_ref6, data) {
    var _this6 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              commit('SET_DATA', {
                name: 'requestedPayoutEdit',
                data: false
              });
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/request/payout/edit', data);

            case 4:
              commit('SET_DATA', {
                name: 'requestedPayoutEdit',
                data: true
              });
              _context6.next = 11;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6['catch'](0);

              console.error(_context6.t0);
              return _context6.abrupt('return', '');

            case 11:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 7]]);
    }))();
  },
  getPairingDetails: function getPairingDetails(_ref7, id) {
    var _this7 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              commit('SET_DATA', {
                name: 'pairingDetails',
                data: {}
              });
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(pairingServiceOpenBaseURL + '/' + id);

            case 4:
              response = _context7.sent;

              if (response) {
                commit('SET_DATA', {
                  name: 'pairingDetails',
                  data: response
                });
              }
              _context7.next = 12;
              break;

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7['catch'](0);

              console.error(_context7.t0);
              return _context7.abrupt('return', '');

            case 12:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 8]]);
    }))();
  },
  getPairingDetailsForStats: function getPairingDetailsForStats(_ref8, id) {
    var _this8 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;

              commit('SET_DATA', {
                name: 'pairingDetails',
                data: {}
              });
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(pairingServiceOpenBaseURL + '/' + id + '?stats=true');

            case 4:
              response = _context8.sent;

              if (response) {
                commit('SET_DATA', {
                  name: 'pairingDetails',
                  data: response
                });
              }
              _context8.next = 12;
              break;

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8['catch'](0);

              console.error(_context8.t0);
              return _context8.abrupt('return', '');

            case 12:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 8]]);
    }))();
  },
  getPairingsByHandle: function getPairingsByHandle(_ref9) {
    var _this9 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Pairing_pairingAPIs__["a" /* default */].getAllPairings();

            case 3:
              response = _context9.sent;

              if (response) {
                commit('SET_PAIRINGS', response);
              }
              _context9.next = 11;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9['catch'](0);

              console.error(_context9.t0);
              return _context9.abrupt('return', '');

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 7]]);
    }))();
  },
  getPairingAcceptedInfs: function getPairingAcceptedInfs(_ref10, data) {
    var _this10 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;

              commit('SET_DATA', {
                name: 'pairings',
                data: []
              });
              _context10.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/paired/accepted-influencer', data);

            case 4:
              resp = _context10.sent;

              commit('SET_DATA', {
                name: 'pairings',
                data: resp
              });
              _context10.next = 12;
              break;

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10['catch'](0);

              console.error(_context10.t0);
              return _context10.abrupt('return', '');

            case 12:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 8]]);
    }))();
  },
  saveSignInForm: function saveSignInForm(_ref11, data) {
    var _this11 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;

              commit('SET_DATA', {
                name: 'saved',
                data: false
              });
              _context11.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceOpenBaseURL + '/save/signin-form', data);

            case 4:
              commit('SET_DATA', {
                name: 'saved',
                data: true
              });
              _context11.next = 11;
              break;

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11['catch'](0);

              console.error(_context11.t0);
              return _context11.abrupt('return', '');

            case 11:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 7]]);
    }))();
  },
  cancelPairingStatus: function cancelPairingStatus(_ref12, data) {
    var _this12 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;

              commit('SET_DATA', {
                name: 'saved',
                data: false
              });
              _context12.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/cancel/pairing/status', data);

            case 4:
              commit('SET_DATA', {
                name: 'saved',
                data: true
              });
              _context12.next = 11;
              break;

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12['catch'](0);

              console.error(_context12.t0);
              return _context12.abrupt('return', '');

            case 11:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 7]]);
    }))();
  },
  getCreatorConceptPairing: function getCreatorConceptPairing(_ref13, data) {
    var _this13 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;

              commit('SET_DATA', {
                name: 'pairings',
                data: []
              });
              _context13.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/paired/creator-concepts', data);

            case 4:
              resp = _context13.sent;

              commit('SET_DATA', {
                name: 'pairings',
                data: resp
              });
              _context13.next = 12;
              break;

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13['catch'](0);

              console.error(_context13.t0);
              return _context13.abrupt('return', '');

            case 12:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 8]]);
    }))();
  },
  savePairingBillingInfo: function savePairingBillingInfo(_ref14, data) {
    var _this14 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;

              commit('SET_DATA', {
                name: 'saved',
                data: false
              });
              _context14.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/paired/billing-info', data);

            case 4:
              commit('SET_DATA', {
                name: 'saved',
                data: true
              });
              _context14.next = 11;
              break;

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14['catch'](0);

              console.error(_context14.t0);
              return _context14.abrupt('return', '');

            case 11:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14, [[0, 7]]);
    }))();
  },
  getInfLists: function getInfLists(_ref15) {
    var _this15 = this;

    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;

              commit('SET_DATA', {
                name: 'infLists',
                data: []
              });
              _context15.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].get(pairingServiceBaseURL + '/inf-lists');

            case 4:
              response = _context15.sent;

              if (response) {
                commit('SET_DATA', {
                  name: 'infLists',
                  data: response
                });
              }
              _context15.next = 12;
              break;

            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15['catch'](0);

              console.error(_context15.t0);
              return _context15.abrupt('return', '');

            case 12:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15, [[0, 8]]);
    }))();
  },
  deleteInfListData: function deleteInfListData(_ref16, payload) {
    var _this16 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;

              commit('SET_DATA', {
                name: 'saved',
                data: false
              });
              _context16.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/delete/inf-lists', payload);

            case 4:
              commit('SET_DATA', {
                name: 'saved',
                data: true
              });
              _context16.next = 11;
              break;

            case 7:
              _context16.prev = 7;
              _context16.t0 = _context16['catch'](0);

              console.error(_context16.t0);
              return _context16.abrupt('return', '');

            case 11:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16, [[0, 7]]);
    }))();
  },
  deleteInfDetailData: function deleteInfDetailData(_ref17, payload) {
    var _this17 = this;

    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;

              commit('SET_DATA', {
                name: 'saved',
                data: false
              });
              _context17.next = 4;
              return __WEBPACK_IMPORTED_MODULE_4__services_apiService__["a" /* default */].post(pairingServiceBaseURL + '/delete/inf-detail-data', payload);

            case 4:
              commit('SET_DATA', {
                name: 'saved',
                data: true
              });
              _context17.next = 11;
              break;

            case 7:
              _context17.prev = 7;
              _context17.t0 = _context17['catch'](0);

              console.error(_context17.t0);
              return _context17.abrupt('return', '');

            case 11:
            case 'end':
              return _context17.stop();
          }
        }
      }, _callee17, _this17, [[0, 7]]);
    }))();
  }
};

var getters = {
  status: function status(state) {
    return state.status;
  }
};

var mutations = {
  updateStatus: function updateStatus(state, value) {
    state.status = value;
  },
  SET_PAIRINGS: function SET_PAIRINGS(state, data) {
    state.pairings = data;
  },
  SET_UNSUBMITTED_INFLUENCERS: function SET_UNSUBMITTED_INFLUENCERS(state, data) {
    state.unsubmittedInfluencers = data;
  },
  SET_DATA: function SET_DATA(state, _ref18) {
    var name = _ref18.name,
        data = _ref18.data;

    state[name] = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_apiService__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_find__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);














var paymentServiceBaseURL = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].apiServiceBaseURL.payment;
var userRoles = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles;
var bankAccounts = __webpack_require__(819);
var paymentStatus = __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus;
var sectionIDs = __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentConsSectionIDs;
var getPaymentPlatform = function getPaymentPlatform(infDetails) {
  return String(infDetails && (infDetails.platform || infDetails.activePlatform) || '').toLowerCase();
};



var state = {
  status: {
    PAID: {
      text: 'Paid',
      value: 1,
      order: 7,
      color: '#2f7d46',
      permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
      allowedStatusChange: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PARTIAL, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.APPROVAL_LEAD]
    },

    PROCESSING: {
      text: 'Pre-processing',
      value: 3,
      order: 2,
      color: '#b77900',
      permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE],
      allowedStatusChange: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PARTIAL]
    },

    PARTIAL: {
      text: 'WIP by Finance',
      value: 5,
      order: 6,
      color: '#3f3fff',
      permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
      allowedStatusChange: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.APPROVAL_FINANCE]
    },
    APPROVAL_FINANCE: {
      text: 'Approval by Finance',
      value: 6,
      order: 3,
      color: '#3f3fff',
      permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.FINANCE],
      allowedStatusChange: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PROCESSING, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PARTIAL]
    }
  },
  paymentUpdateFields: [{
    name: 'PVNumber',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    status: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PARTIAL]
  }, {
    name: 'bankReference',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    status: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PAID]
  }, {
    name: 'paymentDate',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    status: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PAID]
  }, {
    name: 'submissionDate',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST],
    status: []
  }, {
    name: 'batch',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    status: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PAID]
  }, {
    name: 'paymentStatus',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE, userRoles.AD_STRATEGIST],
    status: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PROCESSING, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PAID, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.UNPAID, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.ERROR, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PARTIAL, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.APPROVAL_FINANCE, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.APPROVAL_LEAD, __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.RELEASED_FINANCE]
  }, {
    name: 'actualAmount',
    permissions: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE],
    status: [__WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PAID]
  }],
  bankSwiftCodes: bankAccounts,
  exportTypes: __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentConsExportTypes,
  tableEditFields: [{
    name: 'bankReference',
    batchNo: [sectionIDs.WIP_FINANCE, sectionIDs.PAID]
  }, {
    name: 'paymentDate',
    batchNo: [sectionIDs.WIP_FINANCE, sectionIDs.PAID]
  }, {
    name: 'PVNumber',
    batchNo: [sectionIDs.APPROVAL_FINANCE]
  }],
  filtersStates: [{
    name: 'liveDate',
    batchNo: [sectionIDs.IMPORTED, sectionIDs.BATCH_ONE, sectionIDs.BATCH_TWO, sectionIDs.APPROVAL_FINANCE, sectionIDs.APPROVAL_LEAD, sectionIDs.WIP_FINANCE]
  }, {
    name: 'dueDate',
    batchNo: [sectionIDs.IMPORTED, sectionIDs.BATCH_ONE, sectionIDs.BATCH_TWO, sectionIDs.APPROVAL_FINANCE, sectionIDs.APPROVAL_LEAD, sectionIDs.WIP_FINANCE]
  }, {
    name: 'paymentDate',
    batchNo: [sectionIDs.PAID]
  }],
  sectionsByRoles: {
    CC: [sectionIDs.IMPORTED, sectionIDs.BATCH_ONE, sectionIDs.BATCH_TWO],
    FINANCE: [sectionIDs.BATCH_ONE, sectionIDs.BATCH_TWO, sectionIDs.APPROVAL_FINANCE, sectionIDs.APPROVAL_LEAD, sectionIDs.WIP_FINANCE, sectionIDs.PAID]
  },
  financePayments: [],
  preProcessingPayments: [],
  importedPayments: [],
  completedPayments: [],
  savedCompletedPayments: false,
  savedFinancePayments: false,
  saved: false,
  creatorCogsEstimate: [],
  profitSummary: []
};

var getters = {
  status: function status(state) {
    return state.status;
  },
  paymentStatusOptions: function paymentStatusOptions(state) {
    var data = [];
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(state.status).forEach(function (item) {
      data.push({
        status: item[1].value,
        display: item[1].text,
        order: item[1].order,
        permissions: item[1].permissions,
        allowedStatusChange: item[1].allowedStatusChange
      });
    });
    data = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], data).sort(function (a, b) {
      return a.order - b.order;
    });
    return data;
  },
  allowedStatuses: function allowedStatuses(state, getters, rootState, rootGetters) {
    var userRole = Number(rootState.user.role);
    var filtered = getters.paymentStatusOptions.filter(function (option) {
      return option.permissions.includes(userRole);
    });
    return filtered;
  },
  allowedStatusesForPayoutCreate: function allowedStatusesForPayoutCreate(state, getters, rootState, rootGetters) {
    var userRole = Number(rootState.user.role);
    var filtered = getters.paymentStatusOptions;
    if (userRole !== userRoles.SUPER_ADMIN_HIGH) {
      filtered = getters.paymentStatusOptions.filter(function (option) {
        return option.status === __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].paymentStatus.PROCESSING;
      });
    }
    return filtered;
  },
  allowTableFieldEdit: function allowTableFieldEdit(state, getters, rootState, rootGetters) {
    return function (fieldName, batchNo) {
      if (batchNo === sectionIDs.PAID || getters.currentUserRole === userRoles.ACCOUNT_MANAGER) return false;
      var matchField = state.tableEditFields.find(function (field) {
        return field.name === fieldName;
      });
      if (!matchField) return true;
      if (matchField.batchNo.includes(batchNo)) return true;
      return false;
    };
  },
  allowFilters: function allowFilters(state) {
    return function (fieldName, batchNo) {
      var matchField = state.filtersStates.find(function (field) {
        return field.name === fieldName;
      });
      if (!matchField) return true;
      if (matchField.batchNo.includes(batchNo)) return true;
      return false;
    };
  },
  allowedActions: function allowedActions(state, getters, rootState, rootGetters) {
    return function (actionName) {
      var userRole = Number(rootState.user.role);
      if (userRole === userRoles.AD_STRATEGIST) {
        if (state.sectionsByRoles.CC.includes(actionName)) {
          return true;
        }
      } else if (userRole === userRoles.FINANCE) {
        if (state.sectionsByRoles.FINANCE.includes(actionName)) {
          return true;
        }
      } else if (userRole === userRoles.ACCOUNT_MANAGER) {
        return false;
      } else {
        return true;
      }
      return false;
    };
  },
  getPaymentStatus: function getPaymentStatus(state) {
    return function (statusVal) {
      var statusText = '-';
      __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(state.status).forEach(function (item) {
        if (statusVal === item[1].value) {
          statusText = item[1].text;
        }
      });
      return statusText;
    };
  },
  getPaymentStatusObj: function getPaymentStatusObj(state) {
    return function (statusVal) {
      var statusObj = {};
      __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(state.status).forEach(function (item) {
        if (statusVal === item[1].value) {
          statusObj = item[1];
        }
      });
      return statusObj;
    };
  },
  getPaymentConsolidationStatusValue: function getPaymentConsolidationStatusValue(state) {
    return function (payment) {
      return Number(payment ? payment.payment_status || payment.paymentStatus || payment.status : null);
    };
  },
  getPaymentConsolidationRecordHandles: function getPaymentConsolidationRecordHandles(state) {
    return function (payment) {
      if (!payment) return [];
      var handles = [];
      if (payment.influencer_details) {
        handles.push(payment.influencer_details.handle);
        handles.push(payment.influencer_details.instagramHandle);
        handles.push(payment.influencer_details.linkedinHandle);
        handles.push(payment.influencer_details.userHandle);
        handles.push(payment.influencer_details.username);
        handles.push(payment.influencer_details.fullName);
      }
      handles.push(payment.instagram);
      handles.push(payment.handle);
      handles.push(payment.username);
      handles.push(payment.fullName);
      return [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(handles.filter(Boolean).map(function (handle) {
        return String(handle).trim().toLowerCase();
      }))));
    };
  },
  getPaymentConsolidationRecordInfluencerID: function getPaymentConsolidationRecordInfluencerID(state) {
    return function (payment) {
      if (!payment) return '';
      if (payment.influencer_details && payment.influencer_details.influencerID) {
        return payment.influencer_details.influencerID;
      }
      return payment.influencerID || '';
    };
  },

  isPaymentConsolidationRecordMatch: function isPaymentConsolidationRecordMatch(state, getters) {
    return function (payment, campaignID, handle, influencerID, pairingID) {
      if (!payment || !payment.campaign || !payment.influencer_details) return false;
      var paymentCampaignID = payment.campaign.id || payment.campaignID;
      if (paymentCampaignID !== campaignID) return false;
      if (pairingID && payment.pairingID && payment.pairingID === pairingID) return true;
      var paymentInfluencerID = getters.getPaymentConsolidationRecordInfluencerID(payment);
      if (influencerID && paymentInfluencerID && paymentInfluencerID === influencerID) return true;
      var normalizedHandle = handle ? String(handle).trim().toLowerCase() : '';
      var paymentHandles = getters.getPaymentConsolidationRecordHandles(payment);
      return paymentHandles.includes(normalizedHandle);
    };
  },
  isPaymentConsolidationCommittedRecord: function isPaymentConsolidationCommittedRecord(state, getters) {
    return function (payment) {
      var statusValue = getters.getPaymentConsolidationStatusValue(payment);
      if (statusValue === paymentStatus.PROCESSING) return !!(payment && payment.imported);
      return statusValue === paymentStatus.PARTIAL || statusValue === paymentStatus.APPROVAL_FINANCE || statusValue === paymentStatus.PAID;
    };
  },
  getPaymentConsolidationRecordAmount: function getPaymentConsolidationRecordAmount(state) {
    return function (payment) {
      if (payment && payment.transaction_details) {
        return Number(payment.transaction_details.amount || 0);
      }
      return Number(payment && payment.amount ? payment.amount : 0);
    };
  },
  getPaymentConsolidationCommittedAmount: function getPaymentConsolidationCommittedAmount(state, getters) {
    return function (payments, campaignID, handle, influencerID, pairingID) {
      return payments.filter(function (payment) {
        return getters.isPaymentConsolidationRecordMatch(payment, campaignID, handle, influencerID, pairingID) && getters.isPaymentConsolidationCommittedRecord(payment);
      }).map(function (payment) {
        return getters.getPaymentConsolidationRecordAmount(payment);
      }).reduce(function (total, amount) {
        return total + amount;
      }, 0);
    };
  },
  getPaymentConsolidationBalanceAmount: function getPaymentConsolidationBalanceAmount(state, getters) {
    return function (pairedAmount, payments, campaignID, handle, influencerID, pairingID) {
      if (pairedAmount === undefined || pairedAmount === null || pairedAmount === '') return null;
      var committedAmount = getters.getPaymentConsolidationCommittedAmount(payments, campaignID, handle, influencerID, pairingID);
      var remainingAmount = Number(pairedAmount || 0) - Number(committedAmount || 0);
      return Math.max(remainingAmount, 0).toFixed(2);
    };
  },
  getPaymentConsolidationStatusDisplay: function getPaymentConsolidationStatusDisplay(state, getters) {
    return function (payments, campaignID, handle, influencerID, pairingID) {
      return payments.filter(function (payment) {
        return getters.isPaymentConsolidationRecordMatch(payment, campaignID, handle, influencerID, pairingID);
      }).map(function (payment) {
        var amount = getters.getPaymentConsolidationRecordAmount(payment);
        var statusValue = getters.getPaymentConsolidationStatusValue(payment);
        if (statusValue === paymentStatus.PROCESSING && !(payment && payment.imported)) {
          var pairedAmount = payment && payment.transaction_details ? Number(payment.transaction_details.pairedAmount) : Number(payment && payment.pairedAmount);
          if (isNaN(pairedAmount)) pairedAmount = amount;
          var committedAmount = getters.getPaymentConsolidationCommittedAmount(payments, campaignID, handle, influencerID, pairingID);
          amount = Math.max(Number(pairedAmount || 0) - Number(committedAmount || 0), 0);
        }
        var currency = payment.currency || 'SGD';
        var ret = {
          currency: currency,
          payConsAmt: amount.toFixed(2),
          statusDisplay: getters.getPaymentStatusObj(getters.getPaymentConsolidationStatusValue(payment))
        };
        if (payment.imported) {
          ret.imported = true;
        }
        if (currency !== 'SGD') {
          ret.sgdAmt = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.convertCurrency(currency, amount, state.currencyRates);
        }
        return ret;
      }).filter(function (payment) {
        return payment.payConsAmt;
      });
    };
  },
  currentUserID: function currentUserID(state, getters, rootState, rootGetters) {
    return rootState.user.id;
  },
  currentUserRole: function currentUserRole(state, getters, rootState, rootGetters) {
    return Number(rootState.user.role);
  },
  formatPosts: function formatPosts(state, getters, rootState, rootGetters) {
    return function (posts, sections, users) {
      var filters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      posts = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], posts).sort(function (a, b) {
        return a.lineUpIndex - b.lineUpIndex;
      });
      if (filters.POC) {
        posts = posts.filter(function (p) {
          if (!p.POC || p.POC && __WEBPACK_IMPORTED_MODULE_13_lodash_find___default()(p.POC, { id: getters.currentUserID })) return true;
          return false;
        });
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var element = _step.value;

          if (!element.PVNumber && element.VDNumber) {
            element.PVNumber = element.VDNumber;
          }

          if ((element.status === paymentStatus.PAID || element.status === paymentStatus.APPROVAL_FINANCE || element.status === paymentStatus.PARTIAL) && element.CC) {
            element.assignedTo = element.CC.map(function (p) {
              return p.id;
            });
          }
          if (element.assignedTo) {
            element.POCDisplay = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(element.POC);
            element.POCDisplay = element.assignedTo.map(function (p) {
              var user = users.find(function (u) {
                return u.id === p;
              });
              var resp = {
                id: p
              };
              if (user) {
                resp.name = user.name;
              }
              return resp;
            });
            element.CC = element.POCDisplay.filter(function (p) {
              return p.name;
            });
            element.POCDisplay = element.CC.map(function (p) {
              return p.name;
            }).join(', ');
          }
          element.paymentDate = getters.formatDate(element.paymentDate);
          element = getters.setDefaultEditFields(element);
          var sectionRets = getters.setBatchSectionsData(element, sections);
          element = sectionRets.element;
          sections = sectionRets.sections;

          element.liveDate = getters.formatDate(element.liveDate);
          element.overdue = getters.checkOverDue(element.dueDate);
          element.early = getters.checkEarly(element.dueDate);
          element.dueDate = getters.formatDate(element.dueDate);

          if (element.partialAmount.length > 0 || element.importedAmount) {
            element.paidAmount = getters.getPaidAmount(element);
            element.amount = getters.getRemainAmount(element);
          }
          if (element.currency) {
            if (element.currency !== 'SGD') {
              element.sgdAmt = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.convertCurrency(element.currency, element.amount, state.currencyRates);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      sections.batchOne = getters.getSortedLiveDates(sections.batchOne);
      sections.batchTwo = getters.getSortedLiveDates(sections.batchTwo);
      return {
        posts: posts,
        sections: sections
      };
    };
  },
  formatPreProcessingPayments: function formatPreProcessingPayments(state, getters, rootState, rootGetters) {
    return function (users, invoiceLists) {
      var formattedPayments = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.preProcessingPayments), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;

          var infDetails = element.influencer_details;
          var deliverables = element.deliverables;
          var campaign = element.campaign;
          var transDetails = element.transaction_details;
          var invoices = element.invoices;

          element.instagram = infDetails.handle || '';
          element.platformHandlesObj = element.platformHandlesObj;
          var paymentPlatform = getPaymentPlatform(infDetails);
          element.platform = paymentPlatform;
          if (paymentPlatform === 'tiktok') {
            element.isTikTok = true;
          } else if (paymentPlatform === 'youtube') {
            element.isYoutube = true;
          } else if (paymentPlatform === 'xiaohongshu') {
            element.isXHS = true;
          } else if (paymentPlatform === 'facebook') {
            element.isFacebook = true;
          }
          element.swiftCode = infDetails.swiftCode || '';
          element.bankName = infDetails.bankName || '';
          element.bankAccount = infDetails.bankAccount || '';
          element.username = infDetails.username || '';
          element.country = infDetails.country || '';
          element.fullName = infDetails.fullName || '';
          element.email = infDetails.email || '';
          if (infDetails.xhsID) {
            element.xhsID = infDetails.xhsID || '';
          }

          element.agreedDeliverables = deliverables.agreed;
          element.deliverables = deliverables.produced;

          element.clientName = campaign.clientName || '';
          element.campaignID = campaign.id || '';
          element.campaignName = campaign.name || '';
          element.IONumber = campaign.IONumber || '';

          element.PVNumber = transDetails.PVNumber || '';
          element.bankReference = transDetails.bankReference || '';
          element.GSTPercent = transDetails.GSTPercent || null;
          element.specialPayment = transDetails.specialPayment || '';
          element.currency = transDetails.currency || 'SGD';
          element.pairedAmount = transDetails.pairedAmount || '';
          element.amount = transDetails.amount || '';
          element.remainAmount = transDetails.remainAmount || '';
          element.actualAmount = transDetails.actualAmount || '';
          element.partialAmount = [];
          element.paymentDate = transDetails.paymentDate || '';
          element.paymentSubmissionDate = transDetails.submissionDate || '';
          element.payment_status = element.status;
          element.paymentStatus = element.status;

          element.invoice = invoices.internalInvoice;
          element.uploadInvoice = getters.getReportInvoices(element, invoiceLists);
          element.paymentInvoices = invoices.uploadInvoice || [];
          if (element.CC) {
            element.POCDisplay = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(element.POC);
            element.POCDisplay = element.CC.map(function (p) {
              var userID = null;
              if (p.id) {
                userID = p.id;
              } else {
                userID = p;
              }
              var user = users.find(function (u) {
                return u.id === userID;
              });
              var resp = {
                id: userID
              };
              if (user) {
                resp.name = user.name;
              }
              return resp;
            });
            element.POCDisplay = element.POCDisplay.map(function (p) {
              return p.name;
            }).join(', ');
          }

          formattedPayments.push(element);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return formattedPayments;
    };
  },
  getReportInvoices: function getReportInvoices(state, getters, rootState, rootGetters) {
    return function (report) {
      var reportInvoices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var matchInvoices = [];
      var datas = reportInvoices.filter(function (inv) {
        return inv.handle === report.instagram;
      });
      if (datas && datas.length) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(datas), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var data = _step3.value;

            if (data.invoice) {
              if (typeof data.invoice === 'string') {
                matchInvoices.push({
                  id: data.id,
                  url: data.invoice,
                  timestamp: data.createdAt
                });
              } else {
                matchInvoices.push(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, data.invoice, {
                  id: data.id,
                  timestamp: data.invoice.timestamp || data.createdAt
                }));
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return matchInvoices;
    };
  },
  formatImportedPayments: function formatImportedPayments(state, getters, rootState, rootGetters) {
    return function (users, invoiceLists) {
      var formattedPayments = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.importedPayments), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var element = _step4.value;

          var infDetails = element.influencer_details;
          var deliverables = element.deliverables;
          var campaign = element.campaign;
          var transDetails = element.transaction_details;
          var invoices = element.invoices;

          element.instagram = infDetails.handle || '';
          element.platformHandlesObj = element.platformHandlesObj;
          var paymentPlatform = getPaymentPlatform(infDetails);
          element.platform = paymentPlatform;
          if (paymentPlatform === 'tiktok') {
            element.isTikTok = true;
          } else if (paymentPlatform === 'youtube') {
            element.isYoutube = true;
          } else if (paymentPlatform === 'xiaohongshu') {
            element.isXHS = true;
          } else if (paymentPlatform === 'facebook') {
            element.isFacebook = true;
          }
          element.swiftCode = infDetails.swiftCode || '';
          element.bankName = infDetails.bankName || '';
          element.bankAccount = infDetails.bankAccount || '';
          element.username = infDetails.username || '';
          element.country = infDetails.country || '';
          element.fullName = infDetails.fullName || '';
          element.email = infDetails.email || '';
          if (infDetails.xhsID) {
            element.xhsID = infDetails.xhsID || '';
          }

          element.agreedDeliverables = deliverables.agreed;
          element.deliverables = deliverables.produced;

          element.clientName = campaign.clientName || '';
          element.campaignID = campaign.id || '';
          element.campaignName = campaign.name || '';
          element.IONumber = campaign.IONumber || '';

          element.PVNumber = transDetails.PVNumber || '';
          element.bankReference = transDetails.bankReference || '';
          element.GSTPercent = transDetails.GSTPercent || null;
          element.specialPayment = transDetails.specialPayment || '';
          element.currency = transDetails.currency || 'SGD';
          element.pairedAmount = transDetails.pairedAmount || '';
          element.amount = transDetails.amount || '';
          element.remainAmount = transDetails.remainAmount || '';
          element.actualAmount = transDetails.actualAmount || '';
          element.partialAmount = [];
          element.paymentDate = transDetails.paymentDate || '';
          element.paymentSubmissionDate = transDetails.submissionDate || '';
          element.payment_status = element.status;
          element.paymentStatus = element.status;

          element.invoice = invoices.internalInvoice;

          element.uploadInvoice = getters.getReportInvoices(element, invoiceLists);
          element.paymentInvoices = invoices.uploadInvoice || [];

          if (element.CC) {
            element.POCDisplay = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(element.POC);
            element.POCDisplay = element.CC.map(function (p) {
              var userID = null;
              if (p.id) {
                userID = p.id;
              } else {
                userID = p;
              }
              var user = users.find(function (u) {
                return u.id === userID;
              });
              var resp = {
                id: userID
              };
              if (user) {
                resp.name = user.name;
              }
              return resp;
            });
            element.POCDisplay = element.POCDisplay.map(function (p) {
              return p.name;
            }).join(', ');
          }

          formattedPayments.push(element);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return formattedPayments;
    };
  },
  formatFinancePayments: function formatFinancePayments(state, getters, rootState, rootGetters) {
    return function (users, invoiceLists) {
      var formattedPayments = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.financePayments), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var element = _step5.value;

          var infDetails = element.influencer_details;
          var deliverables = element.deliverables;
          var campaign = element.campaign;
          var transDetails = element.transaction_details;
          var invoices = element.invoices;

          element.instagram = infDetails.handle || '';
          element.platformHandlesObj = element.platformHandlesObj;
          var paymentPlatform = getPaymentPlatform(infDetails);
          element.platform = paymentPlatform;
          if (paymentPlatform === 'tiktok') {
            element.isTikTok = true;
          } else if (paymentPlatform === 'youtube') {
            element.isYoutube = true;
          } else if (paymentPlatform === 'xiaohongshu') {
            element.isXHS = true;
          } else if (paymentPlatform === 'facebook') {
            element.isFacebook = true;
          }
          element.swiftCode = infDetails.swiftCode || '';
          element.bankName = infDetails.bankName || '';
          element.bankAccount = infDetails.bankAccount || '';
          element.username = infDetails.username || '';
          element.country = infDetails.country || '';
          element.fullName = infDetails.fullName || '';
          element.email = infDetails.email || '';
          if (infDetails.xhsID) {
            element.xhsID = infDetails.xhsID || '';
          }

          element.agreedDeliverables = deliverables.agreed;
          element.deliverables = deliverables.produced;

          element.clientName = campaign.clientName || '';
          element.campaignID = campaign.id || '';
          element.campaignName = campaign.name || '';
          element.IONumber = campaign.IONumber || '';

          element.PVNumber = transDetails.PVNumber || '';
          element.bankReference = transDetails.bankReference || '';
          element.GSTPercent = transDetails.GSTPercent || null;
          element.specialPayment = transDetails.specialPayment || '';
          element.currency = transDetails.currency || 'SGD';
          element.pairedAmount = transDetails.pairedAmount || '';
          element.amount = transDetails.amount || '';
          element.remainAmount = transDetails.remainAmount || '';
          element.actualAmount = transDetails.actualAmount || '';
          element.partialAmount = [];
          element.paymentDate = transDetails.paymentDate || '';
          element.paymentSubmissionDate = transDetails.submissionDate || '';
          element.payment_status = element.status;
          element.paymentStatus = element.status;

          element.invoice = invoices.internalInvoice;
          element.uploadInvoice = getters.getReportInvoices(element, invoiceLists);
          element.paymentInvoices = invoices.uploadInvoice || [];
          if (element.CC) {
            element.POCDisplay = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(element.POC);
            element.POCDisplay = element.CC.map(function (p) {
              var userID = null;
              if (p.id) {
                userID = p.id;
              } else {
                userID = p;
              }
              var user = users.find(function (u) {
                return u.id === userID;
              });
              var resp = {
                id: userID
              };
              if (user) {
                resp.name = user.name;
              }
              return resp;
            });
            element.POCDisplay = element.POCDisplay.map(function (p) {
              return p.name;
            }).join(', ');
          }

          formattedPayments.push(element);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return formattedPayments;
    };
  },
  formatCompletedPayments: function formatCompletedPayments(state, getters, rootState, rootGetters) {
    return function (users, invoiceLists) {
      var formattedPayments = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.completedPayments), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var element = _step6.value;

          var infDetails = element.influencer_details;
          var deliverables = element.deliverables;
          var campaign = element.campaign;
          var transDetails = element.transaction_details;
          var invoices = element.invoices;

          element.instagram = infDetails.handle || '';
          element.platformHandlesObj = element.platformHandlesObj;
          var paymentPlatform = getPaymentPlatform(infDetails);
          element.platform = paymentPlatform;
          if (paymentPlatform === 'tiktok') {
            element.isTikTok = true;
          } else if (paymentPlatform === 'youtube') {
            element.isYoutube = true;
          } else if (paymentPlatform === 'xiaohongshu') {
            element.isXHS = true;
          } else if (paymentPlatform === 'facebook') {
            element.isFacebook = true;
          }
          element.swiftCode = infDetails.swiftCode || '';
          element.bankName = infDetails.bankName || '';
          element.bankAccount = infDetails.bankAccount || '';
          element.username = infDetails.username || '';
          element.country = infDetails.country || '';
          element.fullName = infDetails.fullName || '';
          element.email = infDetails.email || '';
          if (infDetails.xhsID) {
            element.xhsID = infDetails.xhsID || '';
          }

          element.agreedDeliverables = deliverables.agreed;
          element.deliverables = deliverables.produced;

          element.clientName = campaign.clientName || '';
          element.campaignID = campaign.id || '';
          element.campaignName = campaign.name || '';
          element.IONumber = campaign.IONumber || '';

          element.PVNumber = transDetails.PVNumber || '';
          element.bankReference = transDetails.bankReference || '';
          element.GSTPercent = transDetails.GSTPercent || null;
          element.specialPayment = transDetails.specialPayment || '';
          element.currency = transDetails.currency || 'SGD';
          element.pairedAmount = transDetails.pairedAmount || '';
          element.amount = transDetails.amount || '';
          element.remainAmount = transDetails.remainAmount || '';
          element.actualAmount = transDetails.actualAmount || '';
          element.partialAmount = [];
          element.paymentDate = transDetails.paymentDate || '';
          element.paymentSubmissionDate = transDetails.submissionDate || '';
          element.payment_status = element.status;
          element.paymentStatus = element.status;

          element.invoice = invoices.internalInvoice;
          element.uploadInvoice = getters.getReportInvoices(element, invoiceLists);
          element.paymentInvoices = invoices.uploadInvoice || [];
          if (element.CC) {
            element.POCDisplay = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(element.POC);
            element.POCDisplay = element.CC.map(function (p) {
              var userID = null;
              if (p.id) {
                userID = p.id;
              } else {
                userID = p;
              }
              var user = users.find(function (u) {
                return u.id === userID;
              });
              var resp = {
                id: userID
              };
              if (user) {
                resp.name = user.name;
              }
              return resp;
            });
            element.POCDisplay = element.POCDisplay.map(function (p) {
              return p.name;
            }).join(', ');
          }

          formattedPayments.push(element);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return formattedPayments;
    };
  },
  setBatchTableSections: function setBatchTableSections(state, getters, rootState, rootGetters) {
    return function (batches, headers, sections) {
      for (var i = 1; i <= 7; i++) {
        batches.push(getters.getBatchTableData(i, headers, sections));
      }
    };
  },
  getBatchTableData: function getBatchTableData(state, getters, rootState, rootGetters) {
    return function (id, headers, sections) {
      var _getters$getBatchSect = getters.getBatchSectionsData(id, sections),
          name = _getters$getBatchSect.name,
          batchNo = _getters$getBatchSect.batchNo,
          data = _getters$getBatchSect.data,
          status = _getters$getBatchSect.status,
          exportType = _getters$getBatchSect.exportType;

      var selectedPayments = [];

      var customHeaders = [];
      if (batchNo !== sectionIDs.WIP_FINANCE && batchNo !== sectionIDs.PAID) {
        customHeaders = headers.filter(function (h) {
          return h.value !== 'paymentDate' && h.value !== 'paymentSubmissionDate' && h.value !== 'bankReference';
        });
      } else {
        customHeaders = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], headers);
      }

      if (batchNo !== sectionIDs.PAID) {
        customHeaders = customHeaders.filter(function (h) {
          return h.value !== 'batch';
        });
      }

      if (batchNo !== sectionIDs.APPROVAL_LEAD && batchNo !== sectionIDs.WIP_FINANCE && batchNo !== sectionIDs.PAID) {
        customHeaders = customHeaders.filter(function (h) {
          return h.value !== 'PVNumber';
        });
      }

      if (batchNo === sectionIDs.WIP_FINANCE) {
        customHeaders = customHeaders.filter(function (h) {
          return h.value !== 'bankReference' && h.value !== 'paymentDate';
        });
      }

      if (getters.currentUserRole === userRoles.ACCOUNT_MANAGER) {
        customHeaders = customHeaders.filter(function (h) {
          return h.value !== 'action';
        });
      }
      return {
        id: id,
        name: name,
        batchNo: batchNo,
        headers: customHeaders,
        displayData: data,
        data: data,
        disableSaveEdit: true,
        panel: [0],
        selectedPayments: selectedPayments,
        filter: getters.searchParams(),
        status: status,
        totalAmount: 0,
        exportType: exportType
      };
    };
  },
  setBatchSectionsData: function setBatchSectionsData(state, getters, rootState, rootGetters) {
    return function (element, sections) {
      var status = element.payment_status;

      if (status === paymentStatus.PAID) {
        element.batchNo = sectionIDs.PAID;
        sections.completed.push(element);
      } else if (status === paymentStatus.PARTIAL) {
        element.batchNo = sectionIDs.WIP_FINANCE;
        sections.partiallyPaid.push(element);
      } else if (status === paymentStatus.PROCESSING) {
        if (element.imported) {
          element.batchNo = sectionIDs.IMPORTED;
          sections.imported.push(element);
        } else {
          element.batchNo = element.liveDate ? getters.checkBatch(element.liveDate) : 'b1';
          if (element.batchNo === sectionIDs.BATCH_ONE) {
            sections.batchOne.push(element);
          }
          if (element.batchNo === sectionIDs.BATCH_TWO) {
            sections.batchTwo.push(element);
          }
        }
      } else if (status === paymentStatus.APPROVAL_FINANCE) {
        element.batchNo = sectionIDs.APPROVAL_FINANCE;
        sections.approvalFinance.push(element);
      }

      return {
        element: element,
        sections: sections
      };
    };
  },
  getBatchSectionsData: function getBatchSectionsData(state, getters, rootState, rootGetters) {
    return function (id, sections) {
      var batchInfo = {
        name: '',
        batchNo: '',
        data: [],
        status: '',
        exportType: ''
      };
      if (id === 1) {
        batchInfo.name = 'Imported';
        batchInfo.batchNo = sectionIDs.IMPORTED;
        batchInfo.data = sections.imported;
        batchInfo.status = paymentStatus.PROCESSING;
        batchInfo.exportType = state.exportTypes.CO;
      } else if (id === 2) {
        batchInfo.name = 'Batch 1';
        batchInfo.batchNo = sectionIDs.BATCH_ONE;
        batchInfo.data = sections.batchOne;
        batchInfo.status = paymentStatus.PROCESSING;
        batchInfo.exportType = state.exportTypes.CO;
      } else if (id === 3) {
        batchInfo.name = 'Batch 2';
        batchInfo.batchNo = sectionIDs.BATCH_TWO;
        batchInfo.data = sections.batchTwo;
        batchInfo.status = paymentStatus.PROCESSING;
        batchInfo.exportType = state.exportTypes.CO;
      } else if (id === 4) {
        batchInfo.name = 'Approval by Finance';
        batchInfo.batchNo = sectionIDs.APPROVAL_FINANCE;
        batchInfo.data = sections.approvalFinance;
        batchInfo.status = paymentStatus.APPROVAL_FINANCE;
        batchInfo.exportType = state.exportTypes.CO;
      } else if (id === 6) {
        batchInfo.name = 'WIP by Finance';
        batchInfo.batchNo = sectionIDs.WIP_FINANCE;
        batchInfo.data = sections.partiallyPaid;
        batchInfo.status = paymentStatus.PARTIAL;
        batchInfo.exportType = state.exportTypes.FINANCE;
      } else if (id === 7) {
        batchInfo.name = 'Paid';
        batchInfo.batchNo = sectionIDs.PAID;
        batchInfo.data = sections.completed;
        batchInfo.status = paymentStatus.PAID;
        batchInfo.exportType = state.exportTypes.FINANCE;
      }
      return batchInfo;
    };
  },
  checkBatch: function checkBatch(state) {
    return function (date) {
      if (!date) return null;
      var day = __WEBPACK_IMPORTED_MODULE_15_moment___default()(date).format('D');
      if (day <= 15) {
        return sectionIDs.BATCH_ONE;
      }
      if (day > 15) {
        return sectionIDs.BATCH_TWO;
      }
      return null;
    };
  },
  searchParams: function searchParams(state) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, {
        search: '',
        workingSearch: '',
        searchliveDateMonth: '',
        searchDueDateMonth: '',
        searchPaymentDateMonth: '',
        selectedMonth: '',
        liveDatePicker: false,
        dueDatePicker: false,
        paymentStatus: paymentStatus.NEW,
        imported: false,
        country: 'All Country',
        cc: ''
      });
    };
  },
  setDefaultEditFields: function setDefaultEditFields(state) {
    return function (obj) {
      obj.swiftCodeEdit = false;
      obj.bankAccountEdit = false;
      obj.usernameEdit = false;
      obj.paymentDateEdit = false;
      obj.bankReferenceEdit = false;
      obj.paymentStatusEdit = false;
      obj.PVNumberEdit = false;
      obj.emailEdit = false;
      obj.bankNameEdit = false;
      obj.countryEdit = false;
      obj.editReport = false;
      return obj;
    };
  },
  getPaidAmount: function getPaidAmount(state) {
    return function (item) {
      if (item.partialAmount === undefined && item.importedAmount === undefined) {
        return '';
      }
      var totalAmount = 0;
      if (item.partialAmount.length > 0) {
        var partials = item.partialAmount;
        var amounts = partials.map(function (p) {
          return p.amount;
        });
        totalAmount += amounts.reduce(function (a, b) {
          return Number(a) + Number(b);
        });
      }
      if (item.importedAmount) {
        totalAmount += item.importedAmount;
      }
      return totalAmount.toFixed(2);
    };
  },
  getSortedLiveDates: function getSortedLiveDates(state, getters) {
    return function (items) {
      items = items.map(function (item) {
        item.formattedLiveDate = '';
        if (item.liveDate) {
          item.formattedLiveDate = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.parseDate(item.liveDate);
        }
        return item;
      });
      items = __WEBPACK_IMPORTED_MODULE_14_lodash_orderBy___default()(items, ['formattedLiveDate'], ['asc']);
      return items;
    };
  },
  getRemainAmount: function getRemainAmount(state, getters) {
    return function (item) {
      var paidAmounts = getters.getPaidAmount(item);
      return (Number(item.amount) - paidAmounts).toFixed(2);
    };
  },
  checkOverDue: function checkOverDue(state) {
    return function (date) {
      if (!date) return false;
      var today = __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD');
      return date < today;
    };
  },
  checkEarly: function checkEarly(state) {
    return function (date) {
      if (!date) return false;
      var today = __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD');
      var oneMonthDate = __WEBPACK_IMPORTED_MODULE_15_moment___default()().add(30, 'days').format('YYYY-MM-DD');
      return date > today && date < oneMonthDate;
    };
  },
  formatDate: function formatDate(state) {
    return function (date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      var formattedDate = day + '/' + month + '/' + year;
      if (formattedDate.includes('undefined')) {
        return date;
      }
      return formattedDate;
    };
  }
};

var actions = {
  getPreProcessingPayments: function getPreProcessingPayments(_ref) {
    var _this = this;

    var commit = _ref.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit('SET_DATA', {
                name: 'preProcessingPayments',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + ('/pre-processing-payments/find?' + params));

            case 6:
              response = _context.sent;

              if (response.data) {
                response = response.data;
                response = response.sort(function (a, b) {
                  var dateA = new Date(a.dueDate);
                  var dateB = new Date(b.dueDate);
                  return dateB - dateA;
                });

                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'preProcessingPayments',
                    data: response
                  });
                }
              }
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', '');

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 10]]);
    }))();
  },
  getImportedPayments: function getImportedPayments(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit('SET_DATA', {
                name: 'importedPayments',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + ('/imported-payments/find?' + params));

            case 6:
              response = _context2.sent;

              if (response.data) {
                response = response.data;
                response = response.sort(function (a, b) {
                  var dateA = new Date(a.dueDate);
                  var dateB = new Date(b.dueDate);
                  return dateB - dateA;
                });

                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'importedPayments',
                    data: response
                  });
                }
              }
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 10]]);
    }))();
  },
  getFinancePayments: function getFinancePayments(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('SET_DATA', {
                name: 'financePayments',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + ('/finance-payments/find?' + params));

            case 6:
              response = _context3.sent;

              if (response.data) {
                response = response.data;
                response = response.sort(function (a, b) {
                  var dateA = new Date(a.dueDate);
                  var dateB = new Date(b.dueDate);
                  return dateB - dateA;
                });

                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'financePayments',
                    data: response
                  });
                }
              }
              _context3.next = 14;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              return _context3.abrupt('return', '');

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 10]]);
    }))();
  },
  getCompletedPayments: function getCompletedPayments(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              commit('SET_DATA', {
                name: 'completedPayments',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + ('/completed-payments/find?' + params));

            case 6:
              response = _context4.sent;

              if (response.data) {
                response = response.data;
                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'completedPayments',
                    data: response
                  });
                }
              }
              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              return _context4.abrupt('return', '');

            case 14:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 10]]);
    }))();
  },
  saveCompletedPayments: function saveCompletedPayments(_ref5, data) {
    var _this5 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              commit('SET_DATA', {
                name: 'savedCompletedPayments',
                data: false
              });
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].post(paymentServiceBaseURL + '/completed-payments/create', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedCompletedPayments',
                data: true
              });
              _context5.next = 11;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](0);

              console.error(_context5.t0);
              return _context5.abrupt('return', '');

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 7]]);
    }))();
  },
  saveFinancePayments: function saveFinancePayments(_ref6, data) {
    var _this6 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              commit('SET_DATA', {
                name: 'savedFinancePayments',
                data: false
              });
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].post(paymentServiceBaseURL + '/finance-payments/create', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedFinancePayments',
                data: true
              });
              _context6.next = 11;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6['catch'](0);

              console.error(_context6.t0);
              return _context6.abrupt('return', '');

            case 11:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 7]]);
    }))();
  },
  savePreProcessingPayments: function savePreProcessingPayments(_ref7, data) {
    var _this7 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              commit('SET_DATA', {
                name: 'savedPreProcessingPayments',
                data: false
              });
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].post(paymentServiceBaseURL + '/pre-processing-payments/create', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedPreProcessingPayments',
                data: true
              });
              _context7.next = 11;
              break;

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7['catch'](0);

              console.error(_context7.t0);
              return _context7.abrupt('return', '');

            case 11:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 7]]);
    }))();
  },
  saveImportedPayments: function saveImportedPayments(_ref8, data) {
    var _this8 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;

              commit('SET_DATA', {
                name: 'saveImportedPayments',
                data: false
              });
              _context8.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].post(paymentServiceBaseURL + '/imported-payments/create', data);

            case 4:
              commit('SET_DATA', {
                name: 'saveImportedPayments',
                data: true
              });
              _context8.next = 11;
              break;

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8['catch'](0);

              console.error(_context8.t0);
              return _context8.abrupt('return', '');

            case 11:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 7]]);
    }))();
  },
  updateCompletedPaymentsByReportID: function updateCompletedPaymentsByReportID(_ref9, data) {
    var _this9 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;

              commit('SET_DATA', {
                name: 'savedCompletedPayments',
                data: false
              });
              _context9.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].post(paymentServiceBaseURL + '/completed-payments/update-by/reportID', data);

            case 4:
              commit('SET_DATA', {
                name: 'savedCompletedPayments',
                data: true
              });
              _context9.next = 11;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9['catch'](0);

              console.error(_context9.t0);
              return _context9.abrupt('return', '');

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 7]]);
    }))();
  },
  getCreatorCogsEstimate: function getCreatorCogsEstimate(_ref10) {
    var _this10 = this;

    var commit = _ref10.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;

              commit('SET_DATA', {
                name: 'creatorCogsEstimate',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context10.next = 6;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + ('/creator-cogs-estimate/find?' + params));

            case 6:
              response = _context10.sent;

              if (response.data) {
                response = response.data;
                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'creatorCogsEstimate',
                    data: response
                  });
                }
              }
              _context10.next = 14;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10['catch'](0);

              console.error(_context10.t0);
              return _context10.abrupt('return', '');

            case 14:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 10]]);
    }))();
  },
  createCogsEstimate: function createCogsEstimate(_ref11, data) {
    var _this11 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;

              commit('SET_DATA', {
                name: 'saved',
                data: false
              });
              _context11.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].post(paymentServiceBaseURL + '/creator-cogs-estimate/create', data);

            case 4:
              commit('SET_DATA', {
                name: 'saved',
                data: true
              });
              _context11.next = 11;
              break;

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11['catch'](0);

              console.error(_context11.t0);
              return _context11.abrupt('return', '');

            case 11:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[0, 7]]);
    }))();
  },
  getProfitSummary: function getProfitSummary(_ref12) {
    var _this12 = this;

    var commit = _ref12.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var filters, params, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;

              commit('SET_DATA', {
                name: 'profitSummary',
                data: []
              });
              filters = payload.filters || {};
              params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
                return key + '=' + filters[key];
              }).join('&');
              _context12.next = 6;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + ('/profit-summary/find?' + params));

            case 6:
              response = _context12.sent;

              if (response.data) {
                response = response.data;
                if (Array.isArray(response) && response.length) {
                  commit('SET_DATA', {
                    name: 'profitSummary',
                    data: response
                  });
                }
              }
              _context12.next = 14;
              break;

            case 10:
              _context12.prev = 10;
              _context12.t0 = _context12['catch'](0);

              console.error(_context12.t0);
              return _context12.abrupt('return', '');

            case 14:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12, [[0, 10]]);
    }))();
  },
  getCurrencyRates: function getCurrencyRates(_ref13) {
    var _this13 = this;

    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;

              commit('SET_DATA', {
                name: 'currencyRates',
                data: null
              });
              _context13.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__services_apiService__["a" /* default */].get(paymentServiceBaseURL + '/get/currency-rates');

            case 4:
              resp = _context13.sent;

              if (resp) {
                commit('SET_DATA', {
                  name: 'currencyRates',
                  data: resp.data
                });
              }
              _context13.next = 12;
              break;

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13['catch'](0);

              console.error(_context13.t0);
              return _context13.abrupt('return', '');

            case 12:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13, [[0, 8]]);
    }))();
  }
};

var mutations = {
  SET_DATA: function SET_DATA(state, _ref14) {
    var name = _ref14.name,
        data = _ref14.data;

    state[name] = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Post_postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);







var postServiceBaseURL = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].apiServiceBaseURL.post;
var state = {
  strPostDeliverables: '',
  totalDeliverables: 0,
  updated: false
};

var actions = {
  updatePostByIds: function updatePostByIds(_ref, data) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit('UNSET_POST_UPDATED');
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].updatePostByIds(data);

            case 4:
              commit('SET_POST_UPDATED');
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              return _context.abrupt('return', '');

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  updatePostViewUser: function updatePostViewUser(_ref2, payload) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].updatePostViewUser(payload);

            case 3:
              _context2.next = 9;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              return _context2.abrupt('return', '');

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 5]]);
    }))();
  },
  updatePostOwner: function updatePostOwner(_ref3, payload) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              commit('UNSET_POST_UPDATED');
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].updatePostOwner(payload);

            case 4:
              commit('SET_POST_UPDATED');
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](0);

              console.error(_context3.t0);
              return _context3.abrupt('return', '');

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },

  setPostDeliverables: function setPostDeliverables(_ref4, posts) {
    var commit = _ref4.commit;

    var deliverableTypes = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.refreshJSON(__WEBPACK_IMPORTED_MODULE_5__components_views_Post_postConfig__["a" /* default */].postTypeDeliverables);
    deliverableTypes.push({
      type: 'Unknown',
      shortName: 'Unknown',
      value: 0
    });
    posts.map(function (post) {
      var index = deliverableTypes.findIndex(function (d) {
        return d.type === post.type;
      });
      if (post.type === 'post/carousel') {
        index = deliverableTypes.findIndex(function (d) {
          return d.type === 'carousel';
        });
      }
      if (index !== -1) {
        deliverableTypes[index].value += 1;
      } else {
        deliverableTypes[deliverableTypes.length - 1].value += 1;
      }
    });
    commit('SET_DELIVERABLE_STR', deliverableTypes);
    commit('SET_TOTAL_DELIVERABLES', deliverableTypes);
  },
  sendProposeDateClientEmail: function sendProposeDateClientEmail(_ref5, payload) {
    var _this4 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].sendProposeDateClientEmail(payload);

            case 3:
              _context4.next = 9;
              break;

            case 5:
              _context4.prev = 5;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              return _context4.abrupt('return', '');

            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 5]]);
    }))();
  },
  sendReviseDateEmail: function sendReviseDateEmail(_ref6, payload) {
    var _this5 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].sendReviseDateEmail(payload);

            case 3:
              _context5.next = 9;
              break;

            case 5:
              _context5.prev = 5;
              _context5.t0 = _context5['catch'](0);

              console.error(_context5.t0);
              return _context5.abrupt('return', '');

            case 9:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[0, 5]]);
    }))();
  },
  sendProposeDateAcceptedToClient: function sendProposeDateAcceptedToClient(_ref7, payload) {
    var _this6 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].sendProposeDateAcceptedToClient(payload);

            case 3:
              _context6.next = 9;
              break;

            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6['catch'](0);

              console.error(_context6.t0);
              return _context6.abrupt('return', '');

            case 9:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[0, 5]]);
    }))();
  },
  sendConfirmLiveDateEmailCO: function sendConfirmLiveDateEmailCO(_ref8, payload) {
    var _this7 = this;

    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].sendConfirmLiveDateEmailCO(payload);

            case 3:
              _context7.next = 9;
              break;

            case 5:
              _context7.prev = 5;
              _context7.t0 = _context7['catch'](0);

              console.error(_context7.t0);
              return _context7.abrupt('return', '');

            case 9:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[0, 5]]);
    }))();
  },
  sendClientAcceptPost: function sendClientAcceptPost(_ref9, payload) {
    var _this8 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__components_views_Post_postApi__["a" /* default */].sendClientAcceptPost(payload);

            case 3:
              _context8.next = 9;
              break;

            case 5:
              _context8.prev = 5;
              _context8.t0 = _context8['catch'](0);

              console.error(_context8.t0);
              return _context8.abrupt('return', '');

            case 9:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[0, 5]]);
    }))();
  },
  saveLiveDate: function saveLiveDate(_ref10, payload) {
    var _this9 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;

              commit('SET_DATA', {
                name: 'updated',
                data: false
              });
              _context9.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post(postServiceBaseURL + '/update/live-date', payload);

            case 4:
              commit('SET_DATA', {
                name: 'updated',
                data: true
              });
              _context9.next = 11;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9['catch'](0);

              console.error(_context9.t0);
              return _context9.abrupt('return', '');

            case 11:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[0, 7]]);
    }))();
  },
  updatePostTypes: function updatePostTypes(_ref11, data) {
    var _this10 = this;

    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;

              commit('SET_DATA', {
                name: 'updated',
                data: false
              });
              _context10.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].post(postServiceBaseURL + '/update/post-type', data);

            case 4:
              commit('SET_DATA', {
                name: 'updated',
                data: true
              });
              _context10.next = 11;
              break;

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10['catch'](0);

              console.error(_context10.t0);
              return _context10.abrupt('return', '');

            case 11:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[0, 7]]);
    }))();
  }
};

var getters = {};

var mutations = {
  SET_DELIVERABLE_STR: function SET_DELIVERABLE_STR(state, data) {
    var results = [];
    data.map(function (d) {
      if (d.value > 0) {
        results.push(d.value + ' X ' + d.shortName);
      }
    });
    state.strPostDeliverables = results.join(', ');
  },
  SET_TOTAL_DELIVERABLES: function SET_TOTAL_DELIVERABLES(state, data) {
    state.totalDeliverables = data.map(function (im) {
      return parseInt(im.value);
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  },
  SET_POST_UPDATED: function SET_POST_UPDATED(state) {
    state.updated = true;
  },
  UNSET_POST_UPDATED: function UNSET_POST_UPDATED(state) {
    state.updated = false;
  },
  SET_DATA: function SET_DATA(state, _ref12) {
    var name = _ref12.name,
        data = _ref12.data;

    state[name] = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  userPlatforms: [],
  showActivePlatform: null,
  activePlatform: null,
  token: null,
  globalConfig: null,
  cache: {
    companyList: {
      data: null,
      lastUpdate: null
    },
    clientList: {
      data: null,
      lastUpdate: null
    },
    campaignList: {},
    campaignVerticalList: {
      data: null,
      lastUpdate: null
    },
    influencerList: {
      data: null,
      lastUpdate: null
    },
    rateCardList: {
      data: null,
      lastUpdate: null
    }
  },
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  },
  aiMatchParams: {
    size: 1000,
    minFollowers: 500,
    postDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'years').format('YYYY-MM-DD') }
});

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSubmissionID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

function createSubmissionID() {
  var crypto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.crypto;

  if (crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();

  var bytes = new Uint8Array(16);
  if (crypto && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (var i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = bytes[6] & 15 | 64;
  bytes[8] = bytes[8] & 63 | 128;
  var hex = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(bytes, function (byte) {
    return ('0' + byte.toString(16)).slice(-2);
  });
  return hex.slice(0, 4).join('') + '-' + hex.slice(4, 6).join('') + '-' + hex.slice(6, 8).join('') + '-' + hex.slice(8, 10).join('') + '-' + hex.slice(10).join('');
}

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getV3Origin */
/* harmony export (immutable) */ __webpack_exports__["a"] = getV3Url;

var renamedPaths = {
  '/client-login': '/login',
  '/all-influencers': '/creators/search',
  '/influencers/social-data': '/influencers/audience-data',
  '/posts/published': '/posts/approved',
  '/posts/internal/published': '/posts/internal/approved'
};

function getV3Origin(location) {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    return location.protocol + '//' + location.hostname + ':3000';
  }
  return location.hostname === 'uat.app.getkobe.com' ? 'https://v3-uat.app.getkobe.com' : 'https://v3-app.getkobe.com';
}

function getV3Url(route, location) {
  var path = route.path || '/';
  var normalizedPath = path.replace(/\/$/, '').toLowerCase() || '/';
  var targetPath = renamedPaths[normalizedPath] || path;
  if (/^\/(?:co|am)\/dashboard(?:\/|$)/i.test(path)) {
    targetPath = '/dashboard';
  }
  var fullPath = route.fullPath || path;
  var suffix = fullPath.slice(path.length);

  if (normalizedPath === '/all-influencers') {
    var hashIndex = suffix.indexOf('#');
    var query = hashIndex < 0 ? suffix : suffix.slice(0, hashIndex);
    var hash = hashIndex < 0 ? '' : suffix.slice(hashIndex);
    var params = new URLSearchParams(query);
    params.set('view', 'audience');
    return getV3Origin(location) + targetPath + '?' + params.toString() + hash;
  }
  return getV3Origin(location) + targetPath + suffix;
}

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		moreStr: {
			type: String,
			default: 'read more'
		},
		lessStr: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			required: true
		},
		link: {
			type: String,
			default: '#'
		},
		maxChars: {
			type: Number,
			default: 100
		}
	},

	data: function data() {
		return {
			isReadMore: false
		};
	},


	computed: {
		formattedString: function formattedString() {
			var val_container = this.text;

			if (!this.isReadMore && this.text.length > this.maxChars) {
				val_container = val_container.substring(0, this.maxChars) + '...';
			}

			return val_container;
		}
	},

	methods: {
		triggerReadMore: function triggerReadMore(e, b) {
			if (this.link == '#') {
				e.preventDefault();
			}
			if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b;
		}
	}
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound',
  data: function data() {
    return {
      logoPrimary: __webpack_require__(122)
    };
  }
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_LegacySunsetBanner_vue__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_LegacySunsetBanner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_LegacySunsetBanner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_APIs__ = __webpack_require__(173);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  components: { LegacySunsetBanner: __WEBPACK_IMPORTED_MODULE_0__core_LegacySunsetBanner_vue___default.a },
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push({ name: 'Login' });
    },
    checkLoginStatus: function checkLoginStatus(fbId) {
      var _this = this;

      var url = __WEBPACK_IMPORTED_MODULE_2__config_APIs__["a" /* default */].INSTAGRAM_GRAPH_API_CHECK_SESSION_AVAILBLE.replace('{fbId}', fbId);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', url, false).then(function (response) {
        if (response.status === 200) {
          var data = response.data;
          _this.handleLoginStatus(data);
        } else {
          _this.handleLoginStatusUnreachable();
        }
      }).catch(function () {
        return _this.handleLoginStatusUnreachable();
      });
    },
    handleLoginStatus: function handleLoginStatus(data) {
      var _this2 = this;

      if (!data.success) {
        this.$swal({
          title: 'Session expired',
          text: 'Your session has expired. Please do login again!',
          type: 'warning'
        }).then(function () {
          _this2.logout();
        });
      }
    },
    handleLoginStatusUnreachable: function handleLoginStatusUnreachable() {
      var _this3 = this;

      this.$swal({
        title: 'Error',
        text: 'There are something wrong. Please do login again!',
        type: 'error'
      }).then(function () {
        _this3.logout();
      });
    }
  },
  created: function created() {
    var user = this.$store.state.user;
    if (user && user.facebookId) {
      this.checkLoginStatus(user.facebookId);
    }
    if (user && !user.id) {
      this.logout();
    }
  }
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar_cropper__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar_cropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_avatar_cropper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { AvatarCropper: __WEBPACK_IMPORTED_MODULE_0_vue_avatar_cropper___default.a, Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a },
  name: 'ChangeAvatarModal',
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      isLoading: false,
      labels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      formData: {
        userID: this.$store.state.user.id
      },
      uploadHeaders: {
        authorization: this.$store.state.token
      }
    };
  },

  watch: {},

  computed: {
    currentAvatar: function currentAvatar() {
      return this.$store.state.user.profilePicture || '/static/img/avatar/user.png';
    },
    uploadUrl: function uploadUrl() {
      return '/api/v1/users/upload/avatar';
    }
  },

  methods: {
    closeModal: function closeModal() {
      this.$emit('input');
    },
    handleUploading: function handleUploading(form, xhr) {
      console.log('uploading...');
      this.isLoading = true;
    },
    handleUploaded: function handleUploaded(response) {
      this.isLoading = false;
      if (response.status === 'finished') {
        this.$emit('changeAvatar', response.extra.Location);
      }
    },
    handleCompleted: function handleCompleted(response, form, xhr) {
      console.log('upload completed.');
      this.isLoading = false;
    },
    handlerError: function handlerError(message, type, xhr) {
      console.log('Oops! Something went wrong...');
      this.isLoading = false;
    }
  }
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientLogin',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a
  },
  data: function data(router) {
    return {
      year: new Date().getFullYear(),
      section: 'Login',
      loading: false,
      logoPrimary: __webpack_require__(122),
      email: '',
      password: '',
      response: ''
    };
  },

  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  methods: {
    checkCreds: function checkCreds() {
      var _this = this;

      var email = this.email,
          password = this.password;


      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/api/v1/users/login', false, { email: email, password: password }).then(function (response) {
        _this.toggleLoading();

        var userData = response.data;
        var jwtToken = userData.jwtToken;

        delete userData.jwtToken;

        var token = 'Bearer ' + jwtToken;

        _this.$store.commit('SET_USER', userData);
        _this.$store.commit('SET_TOKEN', token);

        if (window.localStorage) {
          window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          window.localStorage.setItem('token', token);
        }

        _this.$router.push(_this.$route.query.redirect ? _this.$route.query.redirect : '/');
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');

        _this.$swal({
          title: 'Error',
          text: error.response.data.err || 'Please enter your Username & Password correctly! (or) Contact us for help',
          type: 'error'
        });

        _this.response = error;
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  },
  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  }
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_Drawer__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_FooterDense__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_FooterDense___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_FooterDense__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_Toolbar__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__core_Toolbar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashVuetify',
  components: {
    CoreFooter: __WEBPACK_IMPORTED_MODULE_3__core_FooterDense___default.a,
    CoreDrawer: __WEBPACK_IMPORTED_MODULE_2__core_Drawer___default.a,
    CoreToolbar: __WEBPACK_IMPORTED_MODULE_4__core_Toolbar___default.a
  },
  data: function data() {
    return {
      drawer: false
    };
  },
  watch: {
    '$route': function $route(to, from) {
      this.drawer = false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo', 'user']), {
    containerView: function containerView() {
      var excludeNames = ['Payment Consolidation', 'All Influencers', 'IMS Influencers', 'AOK Report', 'Archived Payment Consolidation', 'All Campaigns Report', 'Upcoming Review Meetings', 'Campaign Timeline', 'Client Feedbacks', 'Archived Client Feedbacks', 'Payout Submission', 'Campaign Report Internal', 'Campaign COGS', 'Creator Stats & Rating', 'Posts', 'Campaign Report', 'Campaign Timeline Summary', 'COGS Estimation', 'Profit Summary', 'Masterlist', 'Invoices & Brief Confirmation', 'Creators Search', 'Stats Analysis', 'Clients', 'am-dashboard', 'co-dashboard', 'Keyword Search', 'Ratecard Forms', 'Creator Concept', 'Content Search'];
      if (excludeNames.includes(this.$route.name)) {
        return false;
      }
      return true;
    }
  }),
  methods: {
    openDrawer: function openDrawer() {
      if (this.drawer) this.drawer = false;
      this.toggleDrawer();
    },
    toggleDrawer: function toggleDrawer() {
      this.drawer = !this.drawer;
    }
  }
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators_common__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__ = __webpack_require__(2328);










var validEmail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators_common__["regex"])('validEmail', __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].regexPattern.email);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ForgotPassword',
  components: { 'vue-recaptcha': __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      logoPrimary: __webpack_require__(122),
      email: null,
      fail: false,
      sent: false,
      errorMessage: '',
      token: ''
    };
  },

  methods: {
    validateCaptcha: function validateCaptcha() {
      this.sendEmailResetPassword(this.token);
    },
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.$refs.recaptcha.reset();
      this.sendEmailResetPassword(recaptchaToken);
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    sendEmailResetPassword: function sendEmailResetPassword(recaptchaToken) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__views_User_userAPIs__["a" /* default */].sendEmailResetPassword(this.email, recaptchaToken).then(function (resp) {
        _this.sent = true;
        _this.errorMessage = '';
        _this.fail = false;
      }).catch(function (error) {
        console.log(error.response.data.message);
        _this.errorMessage = error.response.data.message || 'Something went wrong!';
        _this.fail = true;
      });
    },
    recaptcha: function recaptcha() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$recaptchaLoaded();

              case 2:
                _context.next = 4;
                return _this2.$recaptcha('login');

              case 4:
                _this2.token = _context.sent;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },

  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      validEmail: validEmail
    }
  },

  created: function created() {
    this.fail = this.$route.query.redirect;
    this.recaptcha();
  }
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_common__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_fb_sdk__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_APIs__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay_dist_vue_loading_css__);


















var validPassword = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators_common__["regex"])('validPassword', __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].regexPattern.password);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  mixins: [__WEBPACK_IMPORTED_MODULE_6_vuelidate__["validationMixin"]],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay___default.a
  },
  data: function data(router) {
    return {
      year: new Date().getFullYear(),
      section: 'Login',
      loading: false,
      email: '',
      password: '',
      response: '',
      locations: [],
      currentTab: 'login-tab',
      registerUser: {
        firstName: '',
        lastName: '',
        email: '',
        location: '',
        password: '',
        igHandle: '',
        role: 5,
        activated: 0 },
      showUpdateDialog: false,
      gSigninConfig: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].gSigninConfig,
      tiktokAuthCode: null,
      logoPrimary: __webpack_require__(122)
    };
  },

  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"] },
    registerUser: {
      firstName: { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"] },
      email: { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["email"] },
      password: { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"], validPassword: validPassword },
      igHandle: { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"] }
    }
  },
  methods: {
    doTikTokLogin: function doTikTokLogin() {
      this.toggleLoading();
      var loginParams = {
        client_key: 'aw11ehp6bojb6gk3',
        scope: 'user.info.basic',
        response_type: 'code',
        redirect_uri: 'https://uat.app.getkobe.com/login',
        state: Math.random().toString(36).substring(2)
      };
      var query = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.objectToQueryString(loginParams);
      window.location.href = 'https://www.tiktok.com/v2/auth/authorize?' + query;
    },
    checkTikTokLogin: function checkTikTokLogin() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tiktokRespCode, reqParams, query;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.$route.query.code) {
                  tiktokRespCode = _this.$route.query.code;
                  reqParams = {
                    client_key: 'aw11ehp6bojb6gk3',
                    client_secret: 'UFPaPIOnnMvy2Ool9Acvf8nfvqmvphEh',
                    code: tiktokRespCode,
                    grant_type: 'authorization_code'
                  };
                  query = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.objectToQueryString(reqParams);

                  fetch('https://open-api.tiktok.com/oauth/access_token/?' + query, { method: 'post' }).then(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                      var resp, fullName, data, response, responseData, userData, jwtToken, token;
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              console.log(res.json());
                              resp = res.json();
                              fullName = resp.display_name;

                              fullName = fullName.split(' ');
                              data = {
                                firstName: fullName[0],
                                lastName: fullName.length > 0 ? fullName[1] : '',
                                username: resp.username,
                                imageUrl: resp.avatar_url
                              };
                              _context.next = 7;
                              return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', '/api/v1/users/tiktok/login/create', false, data);

                            case 7:
                              response = _context.sent;

                              if (response.status === 200) {
                                responseData = response.data;
                                userData = responseData ? responseData.user : {};
                                jwtToken = responseData.jwtToken;

                                delete userData.jwtToken;
                                token = 'Bearer ' + jwtToken;

                                _this.$store.commit('SET_TOKEN', token);
                                _this.$store.commit('SET_USER', userData);

                                if (window.localStorage) {
                                  window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(userData));
                                  window.localStorage.setItem('token', token);
                                }
                                _this.$router.push({ name: 'Profile' });
                              } else {
                                console.log('Error', response);
                              }

                            case 9:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    onSignIn: function onSignIn(user) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, response, responseData, userData, jwtToken, token;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = { credential: user.credential };
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', '/api/v1/users/google/basic-display', false, data);

              case 3:
                response = _context3.sent;

                if (!(response.status === 200)) {
                  _context3.next = 19;
                  break;
                }

                responseData = response.data;
                userData = responseData ? responseData.user : {};

                if (!(userData.role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER && !userData.influencerID)) {
                  _context3.next = 10;
                  break;
                }

                _this2.$router.push({ name: 'RateCardForm',
                  query: {
                    name: userData.firstName + ' ' + userData.lastName,
                    email: userData.email
                  }
                });
                return _context3.abrupt('return');

              case 10:
                jwtToken = responseData.jwtToken;

                delete userData.jwtToken;
                token = 'Bearer ' + jwtToken;

                _this2.$store.commit('SET_TOKEN', token);
                _this2.$store.commit('SET_USER', userData);

                if (window.localStorage) {
                  window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(userData));
                  window.localStorage.setItem('token', token);
                }
                _this2.$router.push({ name: 'Profile' });
                _context3.next = 20;
                break;

              case 19:
                console.log('Error', response);

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    signOut: function signOut() {
      if (window.gapi.auth2) {
        var auth2 = window.gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
          console.log('User signed out');
        });
      }
    },
    initGoogleAuth: function initGoogleAuth() {
      var gClientId = this.gSigninConfig.CLIENT_ID;
      window.google.accounts.id.initialize({
        client_id: gClientId,
        callback: this.onSignIn,
        auto_select: true
      });
      window.google.accounts.id.renderButton(this.$refs.googleLoginBtn, {
        text: 'Sign in with',
        size: 'large',
        width: '260',
        theme: 'outline',
        logo_alignment: 'left' });
    },
    instagramLogin: function instagramLogin() {
      this.toggleLoading();

      var reqObj = {
        client_id: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].INSTAGRAM_CLIENT_ID,
        redirect_uri: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].INSTAGRAM_LOGIN_REDIRECT_URL,
        scope: 'instagram_business_basic',
        response_type: 'code'
      };
      reqObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(reqObj).map(function (key) {
        return key + '=' + reqObj[key];
      }).join('&');
      window.location.href = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].INSTAGRAM_APP_AUTHORIZE_URL + '?' + reqObj;
    },
    doFacebookLogin: function doFacebookLogin() {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__plugins_fb_sdk__["c" /* fbLogin */])({ scope: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].PERMISSION_SCOPE }).then(function (response) {
        if (response.status === 'connected') {
          _this3.handlFacebookLogin(response.authResponse);
        }
      });
    },
    handlFacebookLogin: function handlFacebookLogin(data) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var isFbSignedUp, url, response, responseData, _data2, userData, jwtToken, token, headers, user;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.toggleLoading();
                isFbSignedUp = false;
                url = __WEBPACK_IMPORTED_MODULE_10__config_APIs__["a" /* default */].INSTAGRAM_GRAPH_API_CHECK_SESSION_AVAILBLE.replace('{fbId}', data.userID);

                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('get', url, false).then(function (response) {
                  if (response.status === 200) {
                    var _data = response.data;
                    isFbSignedUp = _data.success;
                  }
                }).catch(function (err) {
                  return console.log('Error', err);
                });
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', __WEBPACK_IMPORTED_MODULE_10__config_APIs__["a" /* default */].INSTAGRAM_GRAPH_API_HANDLE_FB_LOGIN, false, data);

              case 6:
                response = _context4.sent;

                if (!(response.status === 200)) {
                  _context4.next = 25;
                  break;
                }

                responseData = response.data;

                if (!responseData.shouldRedirect) {
                  _context4.next = 14;
                  break;
                }

                _data2 = responseData.data;

                _this4.$store.commit('SET_FACEBOOK_DATA', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_data2));
                _this4.$router.push({ name: 'FacebookAuth' });
                return _context4.abrupt('return');

              case 14:
                userData = responseData ? responseData.userData : {};
                jwtToken = responseData.jwtToken;

                delete userData.jwtToken;
                token = 'Bearer ' + jwtToken;

                _this4.$store.commit('SET_TOKEN', token);
                _this4.$store.commit('SET_USER', userData);

                if (window.localStorage) {
                  window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(userData));
                  window.localStorage.setItem('token', token);
                }

                if (!isFbSignedUp) {
                  headers = {
                    'Authorization': token
                  };
                  user = {
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    igHandle: '#'
                  };

                  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', '/api/v1/posts/influencer/notify', false, user, headers);
                }
                _this4.$router.push({ name: 'Profile' });
                _context4.next = 26;
                break;

              case 25:
                console.log('Error', response);

              case 26:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    saveInstagramData: function saveInstagramData(data) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', __WEBPACK_IMPORTED_MODULE_10__config_APIs__["a" /* default */].INSTAGRAM_GRAPH_API_HANDLE_AUTH, false, data).then(function (response) {
        if (response.status === 200) {
          var responseData = response.data;
          if (responseData.shouldRedirect) {
            var _data3 = responseData.data;
            _this5.$store.commit('SET_FACEBOOK_DATA', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_data3));
            _this5.$router.push({ name: 'FacebookAuth' });
            return;
          }
          var userData = responseData ? responseData.userData : {};
          var jwtToken = responseData.jwtToken;

          delete userData.jwtToken;

          var token = 'Bearer ' + jwtToken;
          _this5.$store.commit('SET_USER', userData);
          _this5.$store.commit('SET_TOKEN', token);

          if (window.localStorage) {
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(userData));
            window.localStorage.setItem('token', token);
          }
          _this5.$router.push(_this5.$route.query.redirect ? _this5.$route.query.redirect : { name: 'Profile' });
        }
      }).catch(function (error) {
        _this5.$swal({
          title: 'Error',
          text: error.response.data || 'Unexpected error! Please contact us for help',
          type: 'error'
        });
      });
    },
    getLocations: function getLocations() {
      this.locations = __WEBPACK_IMPORTED_MODULE_11__static_sources_countries___default.a.map(function (element) {
        return element.name;
      });
    },
    checkCreds: function checkCreds() {
      var _this6 = this;

      var email = this.email;
      var password = this.password;
      if (email) {
        email = email.toLowerCase();
      }
      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', '/api/v1/users/login', false, { email: email, password: password }).then(function (response) {
        _this6.toggleLoading();

        var userData = response.data;
        var jwtToken = userData.jwtToken;

        delete userData.jwtToken;

        var token = 'Bearer ' + jwtToken;

        _this6.$store.commit('SET_USER', userData);
        _this6.$store.commit('SET_TOKEN', token);

        if (window.localStorage) {
          window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(userData));
          window.localStorage.setItem('token', token);
        }

        if (userData.role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST) {
          _this6.$router.push({ name: 'co-dashboard' });
        } else if (userData.role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
          _this6.$router.push({ name: 'am-dashboard' });
        } else {
          _this6.$router.push(_this6.$route.query.redirect ? _this6.$route.query.redirect : '/Profile');
        }
      }).catch(function (error) {
        _this6.$store.commit('TOGGLE_LOADING');

        _this6.$swal({
          title: 'Error',
          text: error.response.data.err || 'Please enter your Username & Password correctly! (or) Contact us for help',
          type: 'error'
        });

        _this6.response = error;
        _this6.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    registerInfluencer: function registerInfluencer() {
      var _this7 = this;

      this.toggleLoading();
      var user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.registerUser);

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('post', '/api/v1/users/register', false, user).then(function (response) {
        _this7.toggleLoading();

        _this7.$swal({
          title: 'Success',
          text: 'Your account is registered!, Please check your email and click on activation link to activate the account',
          type: 'success'
        });
      }).catch(function (error) {
        _this7.toggleLoading();
        console.log('Error: ' + error);

        _this7.$swal({
          title: 'Sorry',
          text: error.response.data.message || 'Something went wrong! Please try again! (or) Contact Us for Help',
          type: 'error'
        });
      });
    },
    showRegisterTab: function showRegisterTab() {
      this.currentTab = 'signup-tab';
    },
    decodeJwtResponseFromGoogleAPI: function decodeJwtResponseFromGoogleAPI(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    },
    changeTab: function changeTab() {
      var _this8 = this;

      setTimeout(function () {
        window.google.accounts.id.renderButton(_this8.$refs.googleSignUpBtn, {
          text: 'signup_with',
          size: 'large',
          width: '280',
          theme: 'outline',
          logo_alignment: 'left' });
      }, 1000);
    },
    removeSpaces: function removeSpaces() {
      this.$v.email.$touch();
      this.email = this.email.replace(/\s/g, '');
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    var status = this.$route.query.redirect;
    this.$nextTick(function () {
      if (status === 'activated') {
        this.$swal({
          title: 'Success',
          text: 'Activation Success! You may login now.',
          type: 'success'
        });
      } else if (status === 'failed') {
        this.$swal({
          title: 'Failed',
          text: 'Activation Failed! Please contact our Support or Try Again',
          type: 'error'
        });
      } else if (status === 'alreadyConfirmed') {
        this.$swal({
          title: 'Error',
          text: 'Your Account is already activated',
          type: 'error'
        });
      } else if (status === 'noUser') {
        this.$swal({
          title: 'Error',
          text: 'No User account found, please contact Support',
          type: 'error'
        });
      } else if (status === 'session_ended') {
        this.$swal({
          title: 'Warning',
          text: 'Your session has ended. Please login again',
          type: 'warning'
        });
      }
    });
    this.getLocations();

    setTimeout(function () {
      _this9.initGoogleAuth();
    }, 1000);
    if (this.$route.query.code) {
      this.checkTikTokLogin();
    }
  },
  computed: {
    currentDomain: function currentDomain() {
      if (location.hostname === 'localhost') {
        return location.protocol + '//' + location.hostname + ':' + location.port;
      }
      return location.protocol + '//' + location.hostname;
    },
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.registerUser.firstName.$dirty) return errors;
      !this.$v.registerUser.firstName.required && errors.push('FirstName is required');
      return errors;
    },
    registerEmailErrors: function registerEmailErrors() {
      var errors = [];
      if (!this.$v.registerUser.email.$dirty) return errors;
      !this.$v.registerUser.email.email && errors.push('Must be valid e-mail');
      !this.$v.registerUser.email.required && errors.push('E-mail is required');
      return errors;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    registerPasswordErrors: function registerPasswordErrors() {
      var errors = [];
      if (!this.$v.registerUser.password.$dirty) return errors;
      !this.$v.registerUser.password.required && errors.push('Password is required');
      !this.$v.registerUser.password.validPassword && errors.push('Password must contain number, uppercase, lowercase, special symbols and more than 8 characters.');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    },
    igHandleErrors: function igHandleErrors() {
      var errors = [];
      if (!this.$v.registerUser.igHandle.$dirty) return errors;
      !this.$v.registerUser.igHandle.required && errors.push('Instagram account name is required');
      return errors;
    }
  }
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PrivateRegister',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vuelidate__["validationMixin"]],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      registerUser: {
        firstName: '',
        lastName: '',
        email: '',
        location: '',
        password: '',
        igHandle: '',
        tiktokHandle: '',
        youtubeHandle: '',
        platform: '',
        role: 5,
        activated: 0 },
      logoPrimary: __webpack_require__(122),
      disableIgHandle: false,
      disableTikTokHandle: false,
      disableYoutubeHandle: false,
      locations: [],
      loading: false
    };
  },

  validations: {
    registerUser: {
      firstName: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] },
      email: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["email"] },
      password: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] },

      platform: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] }
    }
  },
  methods: {
    getLocations: function getLocations() {
      this.locations = __WEBPACK_IMPORTED_MODULE_4__static_sources_countries___default.a.map(function (element) {
        return element.name;
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
    },
    registerInfluencer: function registerInfluencer() {
      var _this = this;

      if (!this.registerUser.igHandle && !this.registerUser.tiktokHandle && !this.registerUser.youtubeHandle) {
        this.$swal({
          title: 'Invalid',
          text: 'Please enter Instagram, TikTok or Youtube Handle',
          type: 'warning'
        });
        return;
      }
      this.toggleLoading();
      var user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.registerUser);

      var headers = {
        'K-Token': this.$route.query.token
      };
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('post', '/api/v1/users/register', false, user, headers).then(function (response) {
        _this.toggleLoading();

        _this.$swal({
          title: 'Success',
          text: 'Your account is registered! You will be redirected to login page.',
          type: 'success'
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('post', '/api/v1/posts/influencer/notify', false, user, headers);
          window.location = '/';
        });
      }).catch(function (error) {
        _this.toggleLoading();
        console.log('Error: ' + error);

        _this.$swal({
          title: 'Sorry',
          text: error.response.data.message || 'Something went wrong! Please try again! (or) Contact Us for Help',
          type: 'error'
        });
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    var token = this.$route.query.token;


    __WEBPACK_IMPORTED_MODULE_1__views_User_userAPIs__["a" /* default */].validatRegisterToken(token).then(function (resp) {
      _this2.registerUser.email = resp.data.email.trim();
      _this2.registerUser.igHandle = resp.data.igHandle.trim();
      _this2.registerUser.tiktokHandle = resp.data.tiktokHandle.trim();
      _this2.registerUser.youtubeHandle = resp.data.youtubeHandle.trim();
      _this2.registerUser.platform = _this2.registerUser.igHandle ? 'instagram' : resp.data.platform.trim();
      if (_this2.registerUser.igHandle) _this2.disableIgHandle = true;
      if (_this2.registerUser.tiktokHandle) _this2.disableTikTokHandle = true;
      if (_this2.registerUser.youtubeHandle) _this2.disableYoutubeHandle = true;
    }).catch(function () {
      _this2.$swal({
        title: 'Sorry',
        text: 'Your link is expired',
        type: 'error'
      }).then(function () {
        window.location = '/';
      });
    });
  },
  mounted: function mounted() {
    this.getLocations();
  },

  computed: {
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.registerUser.firstName.$dirty) return errors;
      !this.$v.registerUser.firstName.required && errors.push('FirstName is required');
      return errors;
    },
    registerEmailErrors: function registerEmailErrors() {
      var errors = [];
      if (!this.$v.registerUser.email.$dirty) return errors;
      !this.$v.registerUser.email.email && errors.push('Must be valid e-mail');
      !this.$v.registerUser.email.required && errors.push('E-mail is required');
      return errors;
    },
    registerPasswordErrors: function registerPasswordErrors() {
      var errors = [];
      if (!this.$v.registerUser.password.$dirty) return errors;
      !this.$v.registerUser.password.required && errors.push('Password is required');
      return errors;
    },
    igHandleErrors: function igHandleErrors() {
      var errors = [];
      if (!this.$v.registerUser.igHandle.$dirty) return errors;
      !this.$v.registerUser.igHandle.required && errors.push('Instagram account name is required');
      return errors;
    },
    showAccountName: function showAccountName() {
      if (this.registerUser.platform === 'tiktok') {
        return 'TikTok Account Name';
      }
      return 'Instagram Account Name';
    }
  }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);







var validPassword = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__["regex"])('validPassword', __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].regexPattern.password);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ForgotPassword',
  data: function data() {
    return {
      logoPrimary: __webpack_require__(122),
      email: null,
      fail: false,
      user: {}
    };
  },

  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      var data = {
        email: this.$route.params.email,
        token: this.$route.params.token,
        password: this.user.password
      };
      __WEBPACK_IMPORTED_MODULE_0__views_User_userAPIs__["a" /* default */].resetPassword(data).then(function () {
        _this.$swal({
          title: 'Success',
          text: 'Your password has been changed. Redirect to login page!',
          type: 'success'
        }).then(function () {
          window.location = '/login';
        });
      }).catch(function (error) {
        _this.$swal({
          title: 'Error',
          text: error.response.data.message,
          type: 'error'
        });
        console.error(error);
      });
    }
  },

  validations: {
    user: {
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        validPassword: validPassword
      },
      repeatPassword: {
        sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password')
      }
    }
  },

  beforeCreate: function beforeCreate() {
    var token = this.$route.params.token;
    var email = this.$route.params.email;
    if (!token || !email) {
      window.location = '/forgot-password?redirect=fail';
    }
  },
  created: function created() {
    this.fail = this.$route.query.redirect;
  }
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_APIs__ = __webpack_require__(173);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectInstagram',
  data: function data() {
    return {
      facebookData: null,
      facebookId: null,
      selected: null
    };
  },

  methods: {
    selectInstagram: function selectInstagram(item) {
      this.selected = item.id;
    },
    next: function next() {
      var _this = this;

      var body = {
        facebookId: this.facebookId,
        instagram: this.selected
      };
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', __WEBPACK_IMPORTED_MODULE_2__config_APIs__["a" /* default */].INSTAGRAM_GRAPH_API_HANDLE_SELECTION, false, body).then(function (response) {
        var responseData = response.data;
        var userData = responseData ? responseData.userData : {};
        var jwtToken = responseData.jwtToken;

        delete userData.jwtToken;

        var token = 'Bearer ' + jwtToken;

        _this.$store.commit('SET_USER', userData);
        _this.$store.commit('SET_TOKEN', token);

        if (window.localStorage) {
          window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          window.localStorage.setItem('token', token);
        }

        _this.$router.push(_this.$route.query.redirect ? _this.$route.query.redirect : { name: 'Profile' });
      }).catch(function () {
        _this.$swal({
          title: 'Error',
          text: 'Could not connect to this instagram account. Please select another. If you still face this issue, do not hesitate contact us at ',
          type: 'error'
        });
      });
    }
  },
  created: function created() {
    var data = this.$store.state.facebook ? JSON.parse(this.$store.state.facebook) : {};
    this.facebookData = data.pages || [];
    this.selected = this.facebookData.length > 0 ? this.facebookData[0].id : null;
    this.facebookId = data.facebookId;
  }
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bar-Chart',
  props: ['name', 'chartData', 'options'],
  data: function data() {
    return {
      toggle_filter: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.loadCharts();
    }, 1000);
  },

  watch: {
    chartData: function chartData() {
      this.loadCharts();
    }
  },
  methods: {
    loadCharts: function loadCharts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.chartData;

              case 2:
                data = _context.sent;

                _this2.renderChart(data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    renderChart: function renderChart(chartData) {
      var ctx = document.getElementById(this.name);

      var config = {
        type: 'bar',
        data: chartData,
        options: this.options
      };
      if (window.barChart !== undefined) {
        window.barChart.destroy();
      }

      window.barChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
    }
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pie',
  props: ['name', 'title', 'labels', 'backgroundColors', 'options', 'items', 'width', 'height'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.renderChart();
  },

  methods: {
    renderChart: function renderChart() {
      var ctx = document.getElementById(this.name);
      var config = {
        type: 'pie',
        data: {
          'labels': this.labels,
          'datasets': [{
            'data': this.items,
            'backgroundColor': this.backgroundColors
          }]
        },
        options: this.options
      };

      if (window['pie_' + this.name] !== undefined) {
        window['pie_' + this.name].destroy();
      }
      window['pie_' + this.name] = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
    }
  }
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DrawerNavList__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DrawerNavList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DrawerNavList__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CoreDrawer',
  components: { NavList: __WEBPACK_IMPORTED_MODULE_2__DrawerNavList___default.a },
  props: ['drawer'],
  data: function data() {
    return {
      mini: true,
      logoPrimary: __webpack_require__(680)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['user', 'globalConfig']), {
    singleMenuList: function singleMenuList() {
      var _this = this;

      var singleMenus = this.globalConfig.singleNavMenu.map(function (smenu) {
        if (smenu.subMenus) {
          smenu.subMenus = smenu.subMenus.filter(function (subMenu) {
            return subMenu.permissions.includes(_this.user.role);
          });
        }
        return smenu;
      });

      return singleMenus.filter(function (smenu) {
        return smenu.permissions.includes(_this.user.role);
      });
    },
    groupMenuList: function groupMenuList() {
      var groupNavMenuConfig = this.globalConfig.groupNavMenu;
      var userRole = this.user.role;
      var result = [];
      groupNavMenuConfig.forEach(function (groupItem) {
        var newSubMenus = [];
        groupItem.subMenus.forEach(function (subMenuItem) {
          if (subMenuItem.permissions.includes(userRole)) {
            newSubMenus.push(subMenuItem);
          }
        });
        if (newSubMenus.length > 0) {
          var newGroupItem = {};
          newGroupItem.name = groupItem.name;
          newGroupItem.icon = groupItem.icon;
          newGroupItem.subMenus = newSubMenus;
          result.push(newGroupItem);
        }
      });
      return result;
    }
  })
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrawerMenu',
  props: {
    singleMenus: Array,
    groupMenus: Array
  },
  computed: {
    isNotClientRole: function isNotClientRole() {
      return Number(this.$store.state.user.role) !== __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.CLIENT;
    }
  },
  methods: {
    isMenuRouteActive: function isMenuRouteActive(menu) {
      var _this = this;

      var currentPath = this.$route.path;
      return Array.isArray(menu.subMenus) && menu.subMenus.some(function (subMenu) {
        return _this.isRoutePathMatch(currentPath, subMenu.link);
      });
    },
    isRoutePathMatch: function isRoutePathMatch(currentPath, menuPath) {
      if (!menuPath) {
        return false;
      }
      return currentPath === menuPath || currentPath.startsWith(menuPath + '/');
    }
  }
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CoreFooter',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_v3Migration__ = __webpack_require__(832);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LegacySunsetBanner',
  computed: {
    v3Url: function v3Url() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_v3Migration__["a" /* getV3Url */])(this.$route, window.location);
    }
  },
  mounted: function mounted() {
    this.$nextTick(this.updateHeight);
    window.addEventListener('resize', this.updateHeight);
    if (window.ResizeObserver) {
      this.resizeObserver = new window.ResizeObserver(this.updateHeight);
      this.resizeObserver.observe(this.$el);
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },

  methods: {
    updateHeight: function updateHeight() {
      this.$el.parentElement.style.setProperty('--legacy-banner-height', this.$el.offsetHeight + 'px');
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loading',
  props: {
    dialog: {
      type: Boolean
    },
    text: {
      type: String,
      default: 'Please stand by'
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangeAvatarModal__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChangeAvatarModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ChangeAvatarModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_User_ChangePasswordModal__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_User_ChangePasswordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_User_ChangePasswordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_User_userAPIs__ = __webpack_require__(19);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CoreToolbar',
  props: ['drawer'],
  components: {
    ChangeAvatarModal: __WEBPACK_IMPORTED_MODULE_8__ChangeAvatarModal___default.a,
    ChangePasswordModal: __WEBPACK_IMPORTED_MODULE_9__views_User_ChangePasswordModal___default.a
  },
  data: function data() {
    return {
      changeAvatarDialog: false,
      passwordModalDialog: false,
      profileMenu: false,
      changePasswordModalId: 'changePasswordModalId',
      logoPrimary: __webpack_require__(122)
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.getUserProfile();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    routerName: function routerName() {
      if (this.$route.name === 'co-dashboard') {
        return 'CC Dashboard';
      } else if (this.$route.name === 'am-dashboard') {
        return 'AM Dashboard';
      } else if (this.$route.name === 'co-speed') {
        return 'Speed';
      } else if (this.$route.name === 'am-speed') {
        return 'Speed';
      } else if (this.$route.name === 'am-spend-revenue') {
        return 'Revenue';
      } else if (this.$route.name === 'co-spend-revenue') {
        return 'Revenue';
      } else if (this.$route.name === 'am-spend-campaign-report') {
        return 'Campaign Report';
      } else if (this.$route.name === 'co-spend-campaign-report') {
        return 'Campaign Report';
      } else {
        return this.$route.name;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['userInfo', 'user', 'userPlatforms', 'showActivePlatform']), {
    activeUser: function activeUser() {
      return {
        displayName: this.user.firstName + ' ' + this.user.lastName,
        avatar: this.user.profilePicture ? this.user.profilePicture : '/static/img/avatar/user.png',
        email: this.user.email,
        createdAt: __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.user.createdAt).format('MMM D, YYYY'),
        role: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userRolesDetails'][this.user.role]['display']
      };
    },

    changePasswordModalIdDisplay: function changePasswordModalIdDisplay() {
      return '#' + this.changePasswordModalId;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    facebookId: function facebookId() {
      return this.$store.state.user.facebookId;
    }
  }),
  mounted: function mounted() {
    this.getUserProfile();
  },

  methods: {
    updateNewPassword: function updateNewPassword() {
      this.passwordModalDialog = true;
    },
    changeProfilePicture: function changeProfilePicture() {
      this.changeAvatarDialog = true;
    },
    uploadAvatar: function uploadAvatar(path) {
      this.$store.commit('SET_AVATAR', path);
      this.changeAvatarDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your avatar is updated.',
        type: 'success'
      });
    },
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    passwordChanged: function passwordChanged() {
      var _this = this;

      this.passwordModalDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your password has been changed. Please login again!',
        type: 'success'
      }).then(function () {
        _this.logout();
      });
    },
    logout: function logout() {
      this.$store.dispatch('LOG_OUT');
      this.$store.commit('REMOVE_ACTIVE_PLATFORM');

      this.$router.push({ name: 'Login' });
    },
    changePlatform: function changePlatform(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('influencer/update', {
                  id: _this2.user.influencerID,
                  activePlatform: data.platform
                });

              case 2:
                user = JSON.parse(window.localStorage.getItem('user'));

                user.activePlatform = data.platform;
                window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(user));
                window.location.reload();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this3.currentUserRole !== __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.INFLUENCER)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                __WEBPACK_IMPORTED_MODULE_10__views_User_userAPIs__["a" /* default */].getUser(_this3.currentUserID).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                    var influencer, resolvedPlatform, storedPlatform, hasPlatform;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            influencer = response.influencer;

                            if (influencer) {
                              _context2.next = 3;
                              break;
                            }

                            return _context2.abrupt('return');

                          case 3:

                            _this3.$store.commit('SET_USER_PLATFORMS', influencer);
                            resolvedPlatform = _this3.$store.state.activePlatform;
                            storedPlatform = String(influencer.activePlatform || '').toLowerCase() === 'x' ? 'twitter' : String(influencer.activePlatform || '').toLowerCase();

                            if (!(resolvedPlatform && resolvedPlatform !== storedPlatform)) {
                              _context2.next = 9;
                              break;
                            }

                            _context2.next = 9;
                            return _this3.$store.dispatch('influencer/update', {
                              id: influencer.id,
                              activePlatform: resolvedPlatform
                            });

                          case 9:
                            hasPlatform = influencer.instagram || influencer.tiktok || influencer.youtube || influencer.xiaohongshu || influencer.facebook || influencer.linkedin || influencer.twitter || influencer.reqIgHandle || influencer.reqTikTokHandle || influencer.reqYoutubeHandle || influencer.reqLinkedinHandle;

                            if (!hasPlatform) {
                              _this3.$router.push({ path: '/profile' });
                            }

                          case 11:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    connectInstagram: function connectInstagram() {
      var reqObj = {
        client_id: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].INSTAGRAM_CLIENT_ID,
        redirect_uri: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].INSTAGRAM_LOGIN_REDIRECT_URL,
        scope: 'instagram_business_basic',
        response_type: 'code'
      };
      reqObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(reqObj).map(function (key) {
        return key + '=' + reqObj[key];
      }).join('&');
      window.location.href = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].INSTAGRAM_APP_AUTHORIZE_URL + '?' + reqObj;
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorjs_editorjs__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editorjs_editorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__editorjs_editorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorjs_header__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorjs_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__editorjs_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editorjs_list__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editorjs_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__editorjs_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugin_renderImage__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editorjs_underline__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editorjs_underline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__editorjs_underline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editorjs_delimiter__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editorjs_delimiter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__editorjs_delimiter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__editor_generator_blocksToPDF__ = __webpack_require__(803);


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editorjs_vue',
  props: ['content', 'pairingID', 'userID', 'saveStatus', 'reportName'],
  data: function data() {
    return {
      editorData: {},
      loader: null,
      loading: false,
      snackbar: false,
      snackbarTimeout: 2000,
      snackbarText: ''
    };
  },

  watch: {
    content: {
      handler: function handler(val, oval) {
        editor.render({
          blocks: val.blocks
        });
      },
      deep: true
    },
    loader: function loader() {
      var l = this.loader;
      this[l] = !this[l];

      this.loader = null;
    },
    saveStatus: function saveStatus() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.save();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var token = localStorage.getItem('token');
    window.editor = new __WEBPACK_IMPORTED_MODULE_4__editorjs_editorjs___default.a({
      holder: 'editorjs',
      tools: {
        header: {
          class: __WEBPACK_IMPORTED_MODULE_5__editorjs_header___default.a,
          config: {
            placeholder: 'Enter a header'
          }
        },
        image: __WEBPACK_IMPORTED_MODULE_7__plugin_renderImage__["a" /* default */],
        list: {
          class: __WEBPACK_IMPORTED_MODULE_6__editorjs_list___default.a,
          inlineToolbar: true
        },
        underline: __WEBPACK_IMPORTED_MODULE_8__editorjs_underline___default.a,
        delimiter: __WEBPACK_IMPORTED_MODULE_9__editorjs_delimiter___default.a
      },
      data: this.content,
      inlineToolbar: true,
      onChange: function onChange(blk) {
        var previousBlocksCount = _this2.content.blocks.length;
        var currentBlocksCount = blk.blocks.getBlocksCount();

        if (previousBlocksCount !== currentBlocksCount) _this2.$emit('contentChangeTrue');else _this2.$emit('contentChangeFalse');
      }
    });
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake_js__["fonts"] = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      };
    }, 1000);
  },

  methods: {
    deleteImages: function deleteImages(url) {
      var filename = url.substring(url.lastIndexOf('/') + 1);

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('delete', '/api/v1/posts/s3/delete', true, { image: filename });
    },
    checkDeletedImages: function checkDeletedImages(currentBlocks) {
      var blocksArray = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content.blocks));


      for (var i = 0; i < blocksArray.length; i++) {
        if (blocksArray[i].type === 'image') {

          if (currentBlocks[i] === undefined || currentBlocks[i] === null) {
            this.deleteImages(blocksArray[i].data.url);
          }
        }
      }
    },
    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.editor.save().then(function (res) {
                  var data = {
                    pairingID: _this3.pairingID,
                    userID: _this3.userID,
                    content: res.blocks
                  };

                  _this3.checkDeletedImages(data.content);
                  __WEBPACK_IMPORTED_MODULE_10__components_views_Pairing_pairingAPIs__["a" /* default */].updatePairingBriefDetails(data).then(function () {
                    _this3.content.blocks = res.blocks;
                    _this3.$emit('contentChangeFalse');
                    _this3.$emit('reloadDataTable');
                    _this3.$emit('forceSaveOnCloseFalse');
                  });
                  _this3.snackbarText = 'Successfully, Saved!';
                  _this3.snackbar = true;
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    download: function download() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var blocksToPdf, pdfData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loader = 'loading';
                blocksToPdf = new __WEBPACK_IMPORTED_MODULE_12__editor_generator_blocksToPDF__["a" /* default */](_this4.content.blocks, 'Arial');
                _context3.next = 4;
                return blocksToPdf.generate();

              case 4:
                pdfData = _context3.sent;

                __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake_js__["createPdf"](pdfData).download(_this4.reportName + 'brief.pdf');
                _this4.loading = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    cancelClick: function cancelClick() {
      this.$emit('closeModal');
    }
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_suneditor_dist_css_suneditor_min_css__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_suneditor_dist_css_suneditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_suneditor_dist_css_suneditor_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_suneditor__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_suneditor_src_plugins__ = __webpack_require__(1683);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SunEditor',
  props: {
    value: {
      type: String,
      default: undefined
    },
    content: {
      type: String,
      default: ''
    },
    editorOpened: Boolean,
    width: [String, Number],
    height: [String, Number],
    source: String,
    placeholder: {
      type: String,
      default: ''
    },
    buttonList: {
      type: Array,
      default: null
    }

  },
  data: function data() {
    return {
      editorData: {},
      loader: null,
      loading: false,
      editor: null,
      lastEditorContent: null
    };
  },

  watch: {
    value: {
      handler: function handler(val) {
        this.syncEditorContent(val);
      }
    },
    content: {
      handler: function handler(val) {
        if (this.value === undefined) this.syncEditorContent(val);
      }
    }
  },
  mounted: function mounted() {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake_js__["fonts"] = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      };
    }, 1000);
    this.editor = __WEBPACK_IMPORTED_MODULE_4_suneditor__["a" /* default */].create(this.$refs.editorElement, {
      plugins: __WEBPACK_IMPORTED_MODULE_5_suneditor_src_plugins__["a" /* default */],
      width: this.width || 930,
      height: this.height || 500,
      placeholder: this.placeholder,
      buttonList: this.buttonList || [['undo', 'redo'], ['font', 'fontSize', 'formatBlock'], ['paragraphStyle', 'blockquote'], ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'], ['fontColor', 'hiliteColor', 'textStyle'], ['removeFormat'], '/', ['outdent', 'indent'], ['align', 'horizontalRule', 'list', 'lineHeight'], ['table', 'link'], ['fullScreen', 'showBlocks', 'codeView']]
    });
    this.editor.setDefaultStyle('font-family: Arial');
    var vm = this;
    var initialContent = this.value !== undefined ? this.value : this.content;
    this.lastEditorContent = initialContent || '';
    this.editor.setContents(this.lastEditorContent);
    this.editor.onChange = function (contents, core) {
      vm.lastEditorContent = contents;
      vm.$emit('input', contents);
      vm.$emit('contentChanged', contents);
    };
    this.editor.onImageUploadBefore = function (files, info, core, uploadHandler) {
      var file = files[0];
      vm.$emit('loadingDialogOpen');
      var formData = new FormData();
      formData.append("image", file);
      __WEBPACK_IMPORTED_MODULE_1__views_Campaign_campaignAPIs__["a" /* default */].uploadEditorImage(formData).then(function (response) {
        vm.$emit('loadingDialogClose');
        if (response) {
          var url = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].func.constructImageURL(response.url);
          vm.editor.insertHTML('<img src="' + url + '">', true, true);
        }
      }).catch(function (error) {
        vm.$emit('loadingDialogClose');

        console.log('error', error);
        vm.$swal({
          text: error,
          type: 'error'
        });
      });
      return false;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },

  methods: {
    syncEditorContent: function syncEditorContent(value) {
      if (!this.editor) return;

      var nextContent = value || '';
      if (nextContent === this.lastEditorContent) return;

      if (this.editor.getContents() !== nextContent) {
        this.editor.setContents(nextContent);
      }
      this.lastEditorContent = nextContent;
    }
  }
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake_js__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Vue2Editor',
  props: ['content', 'editorOpened'],
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* VueEditor */]
  },
  data: function data() {
    return {
      editorData: {},
      loader: null,
      loading: false,
      editorSettings: {
        modules: {
          toolbar: {
            container: [[{ 'size': ['small', false, 'large'] }], ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image']]
          }
        }
      }
    };
  },

  watch: {
    content: {
      handler: function handler(val, oval) {
        if (this.editorOpened) {
          this.$emit('changeEditorOpened');
          return;
        }
        this.$emit('contentChanged', val);
      },
      deep: true
    }
  },
  mounted: function mounted() {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake_js__["fonts"] = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      };
    }, 1000);
  },

  methods: {
    handleImageAdded: function handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var _this = this;

      console.log('image added');
      this.$emit('loadingDialogOpen');
      var formData = new FormData();
      formData.append("image", file);
      __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignAPIs__["a" /* default */].uploadEditorImage(formData).then(function (response) {
        _this.$emit('loadingDialogClose');
        if (response) {
          var url = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].func.constructImageURL(response.url);
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        }
      }).catch(function (error) {
        _this.$emit('loadingDialogClose');

        console.log('error', error);
        _this.$swal({
          text: error,
          type: 'error'
        });
      });
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scoped_custom_ImageSwiper__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scoped_custom_ImageSwiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scoped_custom_ImageSwiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kobe_buildReportHtml__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_campaign_summary',
  components: {
    ImageSwiper: __WEBPACK_IMPORTED_MODULE_6__scoped_custom_ImageSwiper___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a
  },

  props: ['campaign', 'isInternalView', 'respData'],
  data: function data() {
    return {
      panel: [0],
      oldData: {},
      startCal: false,
      endCal: false,
      MONTH_FORMAT: 'MMM YYYY',
      files: [],
      uploadSubmitting: false,

      editCampaignSummary: false,
      editAIAnalysis: false,
      aiCommentsLoading: false,
      generatingSummary: false,
      aiHeaders: [{ text: 'Comment', value: 'comment', sortable: false, width: '40%' }, { text: 'Relevancy', value: 'relevance', sortable: true, width: '15%' }, { text: 'Reason', value: 'reason', sortable: false, width: '35%' }, { text: 'HTML Report', value: 'checkbox', sortable: false, width: '10%' }]
    };
  },

  computed: {
    startDate: function startDate() {
      return this.campaign.startDate ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.campaign.startDate).format(this.MONTH_FORMAT) : '-';
    },
    endDate: function endDate() {
      return this.campaign.endDate ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.campaign.endDate).format(this.MONTH_FORMAT) : '-';
    },
    enableUpload: function enableUpload() {
      return this.files.length > 0;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  created: function created() {
    this.setOldData();
  },

  methods: {
    safeClone: function safeClone(value) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (value === undefined || value === null || value === 'undefined') return fallback;
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(value));
    },
    rollbackLineup: function rollbackLineup(lineUp) {
      lineUp = lineUp.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.cutStringAfterLast(l, '/');
      });
      return lineUp;
    },
    saveEdit: function saveEdit() {
      var _this = this;

      var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        angles: this.campaign.angles,
        startDate: this.campaign.startDate,
        endDate: this.campaign.endDate,
        optionalRemarks: this.campaign.optionalRemarks,

        AISummary: this.campaign.AISummary
      });
      var formData = new FormData();
      formData.append('data', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(data));
      if (this.files.length > 0) {
        formData.append('isImage', true);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var val = _step.value;

            formData.append('images', val);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.uploadSubmitting = true;

      __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__["a" /* default */].updateCampaignSummary(this.campaign.id, formData).then(function (response) {
        _this.editCampaignSummary = false;
        _this.editAIAnalysis = false;

        if (_this.files.length > 0) {
          _this.campaign.lineUp = response.lineUp;
          _this.files = [];
        }
        _this.setOldData();
        _this.uploadSubmitting = false;
      }).catch(function (error) {
        console.log('error', error);
        _this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    deleteImage: function deleteImage(deleteIndex) {
      var _this2 = this;

      this.campaign.lineUp.splice(deleteIndex, 1);
      var lineUpData = this.rollbackLineup(this.campaign.lineUp);
      var formData = new FormData();
      formData.append('images', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(lineUpData));

      __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__["a" /* default */].updateLineUp(this.campaign.id, formData).then(function (response) {
        console.log('successfully deleted!');
      }).catch(function (error) {
        console.log('error', error);
        _this2.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    setOldData: function setOldData() {
      var campaign = this.campaign || {};

      this.oldData.angles = this.safeClone(campaign.angles, []);
      this.oldData.startDate = this.safeClone(campaign.startDate, '');
      this.oldData.endDate = this.safeClone(campaign.endDate, '');
      this.oldData.optionalRemarks = this.safeClone(campaign.optionalRemarks, '');

      this.oldData.AISummary = this.safeClone(campaign.AISummary, '');
    },
    cancelEdit: function cancelEdit(section) {
      if (section === 'summary') {
        this.editCampaignSummary = false;
        this.campaign.angles = this.safeClone(this.oldData.angles, []);
        this.campaign.startDate = this.safeClone(this.oldData.startDate, '');
        this.campaign.endDate = this.safeClone(this.oldData.endDate, '');
        this.campaign.optionalRemarks = this.safeClone(this.oldData.optionalRemarks, '');
      } else if (section === 'ai') {
        this.editAIAnalysis = false;

        this.campaign.AISummary = this.safeClone(this.oldData.AISummary, '');
      }
    },
    handleDragDropUpdate: function handleDragDropUpdate(segment) {
      var _this3 = this;

      var formData = new FormData();
      formData.append('segment', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(segment));
      __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__["a" /* default */].updateSegment(this.campaign.id, formData).then(function (response) {
        console.log('successfully updated!');
      }).catch(function (error) {
        console.log('error', error);
        _this3.$swal({
          text: error,
          type: 'error'
        });
      });
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    generateAISummary: function generateAISummary() {
      var _this4 = this;

      var autoSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var context = '';
      if (this.campaign.angles && this.campaign.angles.length > 0) {
        context = this.campaign.angles.map(function (angle) {
          return angle.context;
        }).filter(function (c) {
          return c && c.trim() !== '';
        }).join('\n\n---\n\n');
      }

      var performance = null;
      try {
        var raw = this.respData && (this.respData.data || this.respData);
        if (raw && raw.posts) {
          performance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__kobe_buildReportHtml__["a" /* buildAnalysisContext */])(raw);
        }
      } catch (e) {
        console.warn('performance context unavailable', e && e.message);
      }

      if (!context && !performance) {
        this.$swal({
          text: 'Campaign Context (or report data) is required to generate AI Analysis.',
          type: 'warning'
        });
        return;
      }

      var combined = performance ? __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({ campaignBrief: context || undefined, performance: performance }) : context;
      var data = { campaignContext: combined };

      this.generatingSummary = true;
      if (autoSave) this.uploadSubmitting = true;
      this.$emit('loading-status', true);

      __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__["a" /* default */].getCampaignAISummary(data).then(function (response) {
        _this4.$set(_this4.campaign, 'AISummary', response.analysis);
        if (autoSave) {
          _this4.saveEdit();
        } else {
          _this4.uploadSubmitting = false;
        }
        _this4.$emit('loading-status', false);
      }).catch(function (error) {
        _this4.uploadSubmitting = false;
        _this4.$emit('loading-status', false);
        console.error('AI Summary generation error:', error);
        _this4.$swal({
          text: 'Failed to generate AI Analysis.',
          type: 'error'
        });
      }).finally(function () {
        _this4.generatingSummary = false;
      });
    },
    renderRemark: function renderRemark(remark) {
      if (remark !== undefined && remark !== null) {
        return remark.replace(/\n/g, '<br>');
      }
      return '-';
    },
    fetchAINotableComments: function fetchAINotableComments() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload, response, errorMessage;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this5.campaign || !_this5.campaign.id)) {
                  _context.next = 3;
                  break;
                }

                _this5.$swal({ title: 'Error', text: 'Campaign ID is missing.', type: 'error' });
                return _context.abrupt('return');

              case 3:
                payload = {
                  campaignID: _this5.campaign.id
                };


                _this5.aiCommentsLoading = true;

                _this5.$emit('loading-status', true);

                _context.prev = 6;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__["a" /* default */].getCampaignNotableComments(payload);

              case 9:
                response = _context.sent;

                _this5.$emit('saved');

                _this5.$swal({
                  title: 'AI Analysis Complete',
                  text: response.message || 'Notable comments successfully analyzed and saved.',
                  type: 'success'
                });

                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](6);

                console.error('AI Notable Comments generation error:', _context.t0);
                errorMessage = _context.t0.response && _context.t0.response.data && _context.t0.response.data.error ? _context.t0.response.data.error : _context.t0.message || 'Failed to retrieve AI analysis.';

                _this5.$swal({
                  text: errorMessage,
                  type: 'error'
                });

              case 19:
                _context.prev = 19;

                _this5.aiCommentsLoading = false;
                _this5.$emit('loading-status', false);
                return _context.finish(19);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[6, 14, 19, 23]]);
      }))();
    },
    updateNotableCheckFromTable: function updateNotableCheckFromTable(comment, isChecked) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                comment.checked = isChecked;data = [{
                  id: _this6.campaign.id,
                  commentAnalysisResult: _this6.campaign.commentAnalysisResult
                }];
                _context2.prev = 2;
                _context2.next = 5;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 5:
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                comment.checked = !isChecked;
                console.error('Error updating notable comment status:', _context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[2, 7]]);
      }))();
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_reportPlatform__ = __webpack_require__(79);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_story_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView', 'summaryType'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_9__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      storyLegends: [],
      selectedGroup: null,
      colSettingsDialog: false,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      headers: [{ text: 'Influencer', align: 'start', sortable: false, value: 'name' }, { text: 'Live Date', value: 'live_date', legendText: 'Live Date' }, { text: 'Post URL', value: 'url', legendText: 'Link to the published post' }, { text: 'Audience Size', value: 'outreach', legendText: 'The number of followers the creator has at the time where the post was made ' }, { text: 'Likes', value: 'like_count', legendText: 'The total number of likes' }, { text: 'Comments', value: 'comment_count', legendText: 'The number of comments.' }, { text: 'Views', value: 'views', legendText: 'The number of views.' }, { text: 'Impressions', value: 'impressions', legendText: 'The number of times the post was shown.' }, { text: 'Members reached', value: 'reach', legendText: 'The number of unique LinkedIn members who saw the post.' }, { text: 'Video views', value: 'video_views', legendText: 'The number of times the LinkedIn video was viewed.' }, { text: 'Profile viewers from this post', value: 'profile_viewers', legendText: 'The number of profile views generated by the post.' }, { text: 'Shares', value: 'shares', legendText: 'The number of times users have reposted / shared a story.' }, { text: 'Bookmarks', value: 'bookmarks', legendText: 'The number of bookmarks.' }, { text: 'Interactions', value: 'interactions', legendText: 'The sum of likes, comments, saves, shares' }],
      showHideFields: [{ name: 'liveDate', label: 'Live Date', value: 'live_date' }, { name: 'url', label: 'Post URL', value: 'url' }, { name: 'showLikes', label: 'Likes', value: 'like_count' }, { name: 'showComments', label: 'Comments', value: 'comment_count' }, { name: 'showViews', label: 'Views', value: 'views' }, { name: 'showImpressions', label: 'Impressions', value: 'impressions' }, { name: 'showReach', label: 'Members reached', value: 'reach' }, { name: 'showVideoViews', label: 'Video views', value: 'video_views' }, { name: 'showProfileViewers', label: 'Profile viewers from this post', value: 'profile_viewers' }, { name: 'showShares', label: 'Shares', value: 'shares' }, { name: 'showBookmarks', label: 'Bookmarks', value: 'bookmarks' }, { name: 'showInteractions', label: 'Interactions', value: 'interactions' }],
      storyRightSection: [{ title: 'Live Date', description: 'Live Date' }, { title: 'Audience Size', description: 'Audience size (followers at post time)' }, { title: 'Shares', description: 'Number of times story was shared' }, { title: 'Replies', description: 'Number of replies to photo or video in your stories' }, { title: 'Links Click', description: 'Number of people who swipe up on a story to follow a link' }, { title: 'Sticker Taps', description: 'Number of times users interacted with the stickers/handle' }, { title: 'Reach', description: 'Number of unique user that seen your content' }, { title: 'Impressions', description: 'Total number of times content have been shown to users' }, { title: 'Average Views', description: 'Average views over the last 30 posts' }, { title: 'Average Reels Plays', description: 'Average plays over the last 30 posts' }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isLinkedIn: function isLinkedIn() {
      return this.summaryType === 'linkedin';
    },
    isTwitter: function isTwitter() {
      return this.summaryType === 'twitter';
    },
    sectionTitle: function sectionTitle() {
      return this.isLinkedIn ? 'LinkedIn Analysis Summary' : this.isTwitter ? 'X (Twitter) Analysis Summary' : 'Facebook Analysis Summary';
    },
    sectionId: function sectionId() {
      return this.isLinkedIn ? 'linkedin-analysis-summary' : this.isTwitter ? 'twitter-analysis-summary' : 'fb-analysis-summary';
    },
    analysisStatus: function analysisStatus() {
      if (this.isLinkedIn) return this.campaign.linkedInAnalysisStatus || this.defaultCols || {};
      if (this.isTwitter) return this.campaign.twitterAnalysisStatus || this.defaultCols || {};
      return this.campaign.fbAnalysisStatus || this.defaultCols || {};
    },
    availableShowHideFields: function availableShowHideFields() {
      if (this.isLinkedIn) {
        var labels = {
          showLikes: 'Reactions',
          showShares: 'Reposts',
          showBookmarks: 'Saves'
        };
        return this.showHideFields.filter(function (field) {
          return ['liveDate', 'url', 'showImpressions', 'showReach', 'showVideoViews', 'showProfileViewers', 'showLikes', 'showComments', 'showShares', 'showBookmarks'].includes(field.name);
        }).map(function (field) {
          return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, field, { label: labels[field.name] || field.label });
        });
      }
      if (this.isTwitter) {
        var _labels = {
          showComments: 'Replies',
          showShares: 'Reposts'
        };
        return this.showHideFields.filter(function (field) {
          return ['liveDate', 'url', 'showImpressions', 'showComments', 'showLikes', 'showShares', 'showBookmarks'].includes(field.name);
        }).map(function (field) {
          return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, field, { label: _labels[field.name] || field.label });
        });
      }
      return this.showHideFields;
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredPosts: function filteredPosts() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.analysisStatus;
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.availableShowHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.value === field.value;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      if (this.isTwitter) {
        return finalHeaders.map(function (header) {
          if (header.value === 'comment_count') return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, header, { text: 'Replies' });
          if (header.value === 'shares') return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, header, { text: 'Reposts' });
          return header;
        });
      }
      if (this.isLinkedIn) {
        return finalHeaders.map(function (header) {
          if (header.value === 'like_count') return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, header, { text: 'Reactions' });
          if (header.value === 'shares') return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, header, { text: 'Reposts' });
          if (header.value === 'bookmarks') return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, header, { text: 'Saves' });
          return header;
        });
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredPosts.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalLikes: function totalLikes() {
      var likeCount = 0;
      this.filteredPosts.map(function (item) {
        likeCount += item.like_count ? Number(item.like_count) : 0;
      });
      return likeCount;
    },
    totalComments: function totalComments() {
      var commentCount = 0;
      this.filteredPosts.map(function (item) {
        commentCount += item.comment_count ? Number(item.comment_count) : 0;
      });
      return commentCount;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredPosts.map(function (item) {
        views += item.views ? Number(item.views) : 0;
      });
      return views;
    },
    totalImpressions: function totalImpressions() {
      return this.filteredPosts.reduce(function (total, item) {
        return total + Number(item.impressions || 0);
      }, 0);
    },
    totalReach: function totalReach() {
      return this.filteredPosts.reduce(function (total, item) {
        return total + Number(item.reach || 0);
      }, 0);
    },
    totalVideoViews: function totalVideoViews() {
      return this.filteredPosts.reduce(function (total, item) {
        return total + Number(item.video_views || 0);
      }, 0);
    },
    totalProfileViewers: function totalProfileViewers() {
      return this.filteredPosts.reduce(function (total, item) {
        return total + Number(item.profile_viewers || 0);
      }, 0);
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredPosts.map(function (item) {
        shares += item.shares ? Number(item.shares) : 0;
      });
      return shares;
    },
    totalBookmarks: function totalBookmarks() {
      var bookmarks = 0;
      this.filteredPosts.map(function (item) {
        bookmarks += item.bookmarks ? Number(item.bookmarks) : 0;
      });
      return bookmarks;
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredPosts.map(function (item) {
        interactions += item.interactions ? Number(item.interactions) : 0;
      });
      return interactions;
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    updateLegend: function updateLegend() {
      var _this3 = this;

      var filteredLegend = this.storyRightSection.filter(function (s) {
        var fbAnalysisStatus = _this3.analysisStatus;
        if (!fbAnalysisStatus.showShares && s.title === 'Shares') return false;
        if (!fbAnalysisStatus.showReplies && s.title === 'Replies') return false;
        if (!fbAnalysisStatus.showLinkClicks && s.title === 'Links Click') return false;
        if (!fbAnalysisStatus.showStickerTaps && s.title === 'Sticker Taps') return false;
        if (!fbAnalysisStatus.showReach && s.title === 'Reach') return false;
        if (!fbAnalysisStatus.showImpressions && s.title === 'Impressions') return false;
        if (!fbAnalysisStatus.liveDate && s.title === 'Live Date') return false;
        if (!fbAnalysisStatus.showAvgViews && s.title === 'Average Views') return false;
        if (!fbAnalysisStatus.showAvgReelsPlays && s.title === 'Average Reels Plays') return false;
        return true;
      });
      this.storyLegends = filteredLegend;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  campaignAPIs.updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    updateFbAnalysisStatus: function updateFbAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var statusField;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                statusField = _this5.isLinkedIn ? 'linkedInAnalysisStatus' : _this5.isTwitter ? 'twitterAnalysisStatus' : 'fbAnalysisStatus';
                _context2.next = 3;
                return _this5.updateColumnsStatus(items, statusField, 'colSettingsDialog');

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializeFbAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializeFbAnalysisTableCols: function initializeFbAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.availableShowHideFields, this.analysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this6.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context3.prev = 3;
                _context3.next = 6;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this6.campaign[campaignDataProp] = newStatusObject;
                _this6[dialogProp] = false;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.error('Error updating campaign settings:', _context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 10]]);
      }))();
    },
    downloadSummary: function downloadSummary() {
      var _this7 = this;

      var element = document.getElementById(this.sectionId);
      __WEBPACK_IMPORTED_MODULE_8_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = _this7.sectionId + '.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    },
    profileUrl: function profileUrl(item) {
      var fallbackPlatform = this.isLinkedIn ? 'linkedin' : this.isTwitter ? 'twitter' : 'facebook';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_reportPlatform__["b" /* getReportProfileUrl */])(item, fallbackPlatform);
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kobe_buildReportHtml__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportLoginModal__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReportLoginModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ReportLoginModal__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignHtmlReport',
  components: { ReportLoginModal: __WEBPACK_IMPORTED_MODULE_5__ReportLoginModal___default.a },
  data: function data() {
    return {
      loading: true,
      error: '',
      html: '',
      showLogin: false,
      campaignID: ''
    };
  },
  created: function created() {
    this.campaignID = this.$route.query.id || '';
    if (!this.campaignID) {
      this.error = 'Missing campaign id (use ?id=<campaignID>).';
      this.loading = false;
      return;
    }

    var fromUrl = this.$route.query.passcode || '';
    var stored = fromUrl || this.storedPasscode(this.campaignID);
    if (stored) {
      if (fromUrl) this.savePasscode(this.campaignID, fromUrl);
      this.fetchReport(stored);
    } else {
      this.showLogin = true;
      this.loading = false;
    }
  },

  methods: {
    storedPasscode: function storedPasscode(campaignID) {
      try {
        var raw = window.localStorage.getItem('reportauth') || 'null';
        var map = raw !== 'null' ? JSON.parse(raw) : {};
        return map && map[campaignID] ? map[campaignID] : '';
      } catch (e) {
        return '';
      }
    },
    savePasscode: function savePasscode(campaignID, passcode) {
      try {
        var raw = window.localStorage.getItem('reportauth') || 'null';
        var map = raw !== 'null' ? JSON.parse(raw) : {};
        map[campaignID] = passcode;
        window.localStorage.setItem('reportauth', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(map));
      } catch (e) {}
    },
    onLoggedIn: function onLoggedIn(passcode) {
      this.showLogin = false;
      this.savePasscode(this.campaignID, passcode);
      this.fetchReport(passcode);
    },
    fetchReport: function fetchReport(passcode) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var body, data, saved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.error = '';
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__views_Campaign_campaignAPIs__["a" /* default */].generateCampaignHTMLReport(_this.campaignID, passcode, null, false, 'json');

              case 5:
                body = _context.sent;
                data = body && body.success ? body.data : body && body.data ? body.data : body;

                if (!data || !data.summary) {
                  _this.error = 'No report data for this campaign yet.';
                } else {
                  saved = (data.campaign_details || {}).AISummary;

                  if (saved && String(saved).trim()) {
                    _this.html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__kobe_buildReportHtml__["b" /* default */])(data, { aiAnalysis: saved });
                  } else {
                    _this.html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__kobe_buildReportHtml__["b" /* default */])(data);
                    _this.loadAiAnalysis(data, passcode);
                  }
                }
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](2);

                _this.showLogin = true;

                console.error('CampaignHtmlReport', _context.t0);

              case 14:
                _context.prev = 14;

                _this.loading = false;
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 10, 14, 17]]);
      }))();
    },
    loadAiAnalysis: function loadAiAnalysis(data, passcode) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var context, resp, analysis;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                context = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__kobe_buildReportHtml__["a" /* buildAnalysisContext */])(data);
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__views_Campaign_campaignAPIs__["a" /* default */].getHTMLReportAISummary(_this2.campaignID, passcode, { campaignContext: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(context) });

              case 4:
                resp = _context2.sent;
                analysis = resp && resp.analysis;

                if (analysis) {
                  _this2.html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__kobe_buildReportHtml__["b" /* default */])(data, { aiAnalysis: analysis });
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.warn('AI analysis unavailable', _context2.t0 && _context2.t0.message);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    }
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);





var embedScriptPromise = void 0;

function loadInstagramScript() {
  if (window.instgrm && window.instgrm.Embeds) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
  if (embedScriptPromise) return embedScriptPromise;
  embedScriptPromise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var script = document.querySelector('script[src="https://www.instagram.com/embed.js"], script[src="//www.instagram.com/embed.js"]');
    var existing = Boolean(script);
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
    }
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    if (!existing) document.head.appendChild(script);
  }).catch(function (error) {
    embedScriptPromise = null;
    throw error;
  });
  return embedScriptPromise;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  props: { url: { type: String, default: '' } },
  computed: {
    permalink: function permalink() {
      var match = this.url.trim().match(/^https?:\/\/(?:www\.)?instagram\.com\/(p|reel|reels|tv)\/([\w-]+)/i);
      if (!match) return '';
      var type = match[1].toLowerCase() === 'reels' ? 'reel' : match[1].toLowerCase();
      return 'https://www.instagram.com/' + type + '/' + match[2] + '/';
    }
  },
  mounted: function mounted() {
    this.processEmbed();
  },

  watch: {
    permalink: function permalink() {
      this.processEmbed();
    }
  },
  methods: {
    processEmbed: function processEmbed() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.permalink) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return loadInstagramScript();

              case 5:
                _context.next = 7;
                return _this.$nextTick();

              case 7:
                if (!_this._isDestroyed && window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](2);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 10]]);
      }))();
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'legend-section',
  props: ['leftTitle', 'rightTitle', 'leftSections', 'rightSections', 'showleftSideIcon'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'legend-icon',
  props: ['header', 'iconColor', 'rootClass'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Campaign_campaignAPIs__ = __webpack_require__(16);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_story_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_9__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      storyLegends: [],
      colSettingsDialog: false,
      selectedGroup: null,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      headers: [{
        text: 'Influencer',
        align: 'start',
        sortable: false,
        value: 'name'
      }, {
        text: 'Live Date',
        value: 'live_date',
        legendText: 'Live Date'
      }, {
        text: 'Audience Size',
        value: 'outreach',
        legendText: 'The number of followers the creator has at the time where the post was made '
      }, {
        text: 'Views',
        value: 'views',
        legendText: 'The number of views.'
      }, {
        text: 'Average Watch Time',
        value: 'watches',
        legendText: 'How many seconds your video is viewed for'
      }, {
        text: 'Likes',
        value: 'like_count',
        legendText: 'The total number of likes'
      }, {
        text: 'Saves',
        value: 'bookmarks',
        legendText: 'The number of saves.'
      }, {
        text: 'Comments',
        value: 'comment_count',
        legendText: 'The number of comments.'
      }, {
        text: 'Shares',
        value: 'shares',
        legendText: 'The number of times users have reposted / shared a story.'
      }, {
        text: 'Interactions',
        value: 'interactions',
        legendText: 'The sum of likes, comments, saves, shares'
      }],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'showViews', label: 'Views' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showLikes', label: 'Likes' }, { name: 'showBookmarks', label: 'Saves' }, { name: 'showComments', label: 'Comments' }, { name: 'showShares', label: 'Shares' }, { name: 'showInteractions', label: 'Interactions' }],

      storyRightSection: [{
        title: 'Live Date',
        description: 'Live Date'
      }, {
        title: 'Audience Size',
        description: 'Audience size (followers at post time)'
      }, {
        title: 'Shares',
        description: 'Number of times story was shared'
      }, {
        title: 'Replies',
        description: 'Number of replies to photo or video in your stories'
      }, {
        title: 'Links Click',
        description: 'Number of people who swipe up on a story to follow a link'
      }, {
        title: 'Sticker Taps',
        description: 'Number of times users interacted with the stickers/handle'
      }, {
        title: 'Reach',
        description: 'Number of unique user that seen your content'
      }, {
        title: 'Impressions',
        description: 'Total number of times content have been shown to users'
      }, {
        title: 'Average Views',
        description: 'Average views over the last 30 posts'
      }, {
        title: 'Average Reels Plays',
        description: 'Average plays over the last 30 posts'
      }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredItems: function filteredItems() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.lemonAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.showHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.text === field.label;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredItems.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalLikes: function totalLikes() {
      var likeCount = 0;
      this.filteredItems.map(function (item) {
        likeCount += item.like_count ? Number(item.like_count) : 0;
      });
      return likeCount;
    },
    totalComments: function totalComments() {
      var commentCount = 0;
      this.filteredItems.map(function (item) {
        commentCount += item.comment_count ? Number(item.comment_count) : 0;
      });
      return commentCount;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredItems.map(function (item) {
        views += item.views ? Number(item.views) : 0;
      });
      return views;
    },
    totalWatches: function totalWatches() {
      var watches = 0;
      this.filteredItems.map(function (item) {
        watches += item.watches ? Number(item.watches) : 0;
      });
      return watches;
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredItems.map(function (item) {
        shares += item.shares ? Number(item.shares) : 0;
      });
      return shares;
    },
    totalBookmarks: function totalBookmarks() {
      var bookmarks = 0;
      this.filteredItems.map(function (item) {
        bookmarks += item.bookmarks ? Number(item.bookmarks) : 0;
      });
      return bookmarks;
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredItems.map(function (item) {
        interactions += item.interactions ? Number(item.interactions) : 0;
      });
      return interactions;
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_14__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateLegend: function updateLegend() {
      var _this4 = this;

      var filteredLegend = this.storyRightSection.filter(function (s) {
        var lemonAnalysisStatus = _this4.campaign.lemonAnalysisStatus;
        if (!lemonAnalysisStatus.showShares && s.title === 'Shares') {
          return false;
        }
        if (!lemonAnalysisStatus.showReplies && s.title === 'Replies') {
          return false;
        }
        if (!lemonAnalysisStatus.showLinkClicks && s.title === 'Links Click') {
          return false;
        }
        if (!lemonAnalysisStatus.showStickerTaps && s.title === 'Sticker Taps') {
          return false;
        }
        if (!lemonAnalysisStatus.showReach && s.title === 'Reach') {
          return false;
        }
        if (!lemonAnalysisStatus.showImpressions && s.title === 'Impressions') {
          return false;
        }
        if (!lemonAnalysisStatus.liveDate && s.title === 'Live Date') {
          return false;
        }
        if (!lemonAnalysisStatus.showAvgViews && s.title === 'Average Views') {
          return false;
        }
        if (!lemonAnalysisStatus.showAvgReelsPlays && s.title === 'Average Reels Plays') {
          return false;
        }
        return true;
      });
      this.storyLegends = filteredLegend;
    },
    updatelemonAnalysisStatus: function updatelemonAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.updateColumnsStatus(items, 'lemonAnalysisStatus', 'colSettingsDialog');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializeLemonAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializeLemonAnalysisTableCols: function initializeLemonAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.showHideFields, this.campaign.lemonAnalysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this6.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context3.prev = 3;
                _context3.next = 6;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this6.campaign[campaignDataProp] = newStatusObject;
                _this6[dialogProp] = false;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.error('Error updating campaign settings:', _context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 10]]);
      }))();
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('lemon-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_8_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'lemon-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    }
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(6);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_post_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_10__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      postLegends: [],
      selectedGroup: null,
      colSettingsDialog: false,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'outreach', label: 'Audience Size' }, { name: 'showReach', label: 'Accounts Reached' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'likes', label: 'Likes' }, { name: 'showShares', label: 'Shares' }, { name: 'comments', label: 'Comments' }, { name: 'showBookmarks', label: 'Bookmarks' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showEngagement', label: 'Engagement Rate by Audience Size' }, { name: 'showEngRateReach', label: 'Engagement Rate by Reach' }, { name: 'showAvgEngagement', label: 'Avg. Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }, { name: 'showAvgLikes', label: 'Average Likes' }, { name: 'showAvgComments', label: 'Average Comments' }, { name: 'showAvgViews', label: 'Average Views' }],
      headers: [{
        text: 'Influencer',
        align: 'start',
        sortable: false,
        value: 'name'
      }, {
        text: 'Live Date',
        value: 'live_date',
        legendText: 'Live Date'
      }, {
        text: 'Post URL',
        value: 'url',
        legendText: 'Post URL'
      }, {
        text: 'Audience Size',
        value: 'outreach',
        legendText: 'The number of followers the creator has at the time where the post was made '
      }, {
        text: 'Accounts Reached',
        value: 'reach',
        legendText: 'The total number of unique users who viewed the content'
      }, {
        text: 'Impressions',
        value: 'impressions',
        legendText: 'The total number of times the content is displayed on an user\'s feed'
      }, {
        text: 'Likes',
        value: 'likes',
        legendText: 'The number of times users have tapped the “like” button on a post.'
      }, {
        text: 'Shares',
        value: 'shares',
        legendText: 'The number of times users have reposted / shared a post.'
      }, {
        text: 'Comments',
        value: 'comments',
        legendText: 'The number of written responses to a post.'
      }, {
        text: 'Bookmarks',
        value: 'saved',
        legendText: 'The number of times users have saved a post to their “Saved” folder.'
      }, {
        text: 'Interactions',
        value: 'interactions',
        legendText: 'The sum of likes, comments, saves, shares'
      }, {
        text: 'Engagement Rate by Audience Size',
        value: 'new_engagement_rate',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by the audience size numbers'
      }, {
        text: 'Engagement Rate by Reach',
        value: 'engagement_rate_reach',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by reach'
      }, {
        text: 'Avg. Engagement Rate',
        value: 'engagement_rate_sd',
        legendText: 'The average sum of engagement rate on the last 30 posts'
      }, {
        text: 'Median Engagement Rate',
        value: 'median_engagement_rate',
        legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
      }, {
        text: 'Average Likes',
        value: 'avg_likes',
        legendText: 'Average likes over the last 30 posts'
      }, {
        text: 'Average Comments',
        value: 'avg_comments',
        legendText: 'Average comments over the last 30 posts'
      }, {
        text: 'Average Views',
        value: 'avg_views',
        legendText: 'Average views over the last 30 posts'
      }],
      postRightSection: [{
        title: 'Live Date',
        description: 'Live Date'
      }, {
        title: 'Post URL',
        description: 'Post URL'
      }, {
        title: 'Likes',
        description: 'Number of likes'
      }, {
        title: 'Comments',
        description: 'Number of comments'
      }, {
        title: 'Bookmarks',
        description: 'Number of bookmarks'
      }, {
        title: 'Shares',
        description: 'Number of shares'
      }, {
        title: 'Engagement Rate',
        description: 'Followers divided by total interactions for this campaign'
      }, {
        title: 'Views',
        description: 'Number of views'
      }, {
        title: 'Reach',
        description: 'Number of unique user that seen your content'
      }, {
        title: 'Impressions',
        description: 'Total number of times content have been shown to users'
      }, {
        title: 'Average Engagement Rate',
        description: 'Average engagement for all advertorials and organic content'
      }, {
        title: 'Median Engagement Rate',
        description: 'Engagement Rate within same tier comparison'
      }, {
        title: 'Average Likes',
        description: 'Average likes over the last 30 posts'
      }, {
        title: 'Average Comments',
        description: 'Average comments over the last 30 posts'
      }, {
        title: 'Average Views',
        description: 'Average views over the last 30 posts'
      }, {
        title: 'Average Reels Plays',
        description: 'Average plays over the last 30 posts'
      }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredPosts: function filteredPosts() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.postAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.showHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.text === field.label;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredPosts.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalEngagement: function totalEngagement() {
      var engagement = 0;
      this.filteredPosts.map(function (item) {
        engagement += item.engagement ? item.engagement : 0;
      });
      return engagement;
    },
    totalLikes: function totalLikes() {
      var likes = 0;
      this.filteredPosts.map(function (item) {
        likes += item.likes ? item.likes : 0;
      });
      return likes;
    },
    totalComments: function totalComments() {
      var comments = 0;
      this.filteredPosts.map(function (item) {
        comments += item.comments ? item.comments : 0;
      });
      return comments;
    },
    totalSaved: function totalSaved() {
      var saved = 0;
      this.filteredPosts.map(function (item) {
        saved += item.saved ? item.saved : 0;
      });
      return saved;
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredPosts.map(function (item) {
        shares += item.shares ? item.shares : 0;
      });
      return shares;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredPosts.map(function (item) {
        views += item.views ? item.views : 0;
      });
      return views.toFixed(2);
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredPosts.map(function (item) {
        interactions += item.interactions ? item.interactions : 0;
      });
      return interactions;
    },
    totalReach: function totalReach() {
      var reach = 0;
      this.filteredPosts.map(function (item) {
        reach += item.reach ? Number(item.reach) : 0;
      });
      return reach;
    },
    totalImpressions: function totalImpressions() {
      var impressions = 0;
      this.filteredPosts.map(function (item) {
        impressions += item.impressions ? item.impressions : 0;
      });
      return impressions;
    },
    totalEngagementRate: function totalEngagementRate() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.new_engagement_rate ? item.new_engagement_rate : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalEngagementRateView: function totalEngagementRateView() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalEngagementRateReach: function totalEngagementRateReach() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.engagement_rate_reach ? item.engagement_rate_reach : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    profileUrl: function profileUrl(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_reportPlatform__["b" /* getReportProfileUrl */])(item, 'instagram');
    },

    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLegend: function updateLegend() {
      var _this3 = this;

      var filteredLegend = this.postRightSection.filter(function (element) {
        var postAnalysisStatus = _this3.campaign.postAnalysisStatus;
        if (!postAnalysisStatus.showEngagement && element.title === 'Engagement Rate') {
          return false;
        }
        if (!postAnalysisStatus.showAvgEngagement && element.title === 'Average Engagement Rate') {
          return false;
        }
        if (!postAnalysisStatus.showMediaEngagement && element.title === 'Median Engagement Rate') {
          return false;
        }
        if (!postAnalysisStatus.showAvgLikes && element.title === 'Average Likes') {
          return false;
        }
        if (!postAnalysisStatus.showAvgComments && element.title === 'Average Comments') {
          return false;
        }
        if (!postAnalysisStatus.showAvgViews && element.title === 'Average Views') {
          return false;
        }
        if (!postAnalysisStatus.likes && element.title === 'Likes') {
          return false;
        }
        if (!postAnalysisStatus.comments && element.title === 'Comments') {
          return false;
        }
        if (!postAnalysisStatus.showBookmarks && element.title === 'Bookmarks') {
          return false;
        }
        if (!postAnalysisStatus.showShares && element.title === 'Shares') {
          return false;
        }
        if (!postAnalysisStatus.showViews && element.title === 'Views') {
          return false;
        }
        if (!postAnalysisStatus.showReach && element.title === 'Reach') {
          return false;
        }
        if (!postAnalysisStatus.showImpressions && element.title === 'Impressions') {
          return false;
        }
        if (!postAnalysisStatus.liveDate && element.title === 'Live Date') {
          return false;
        }
        if (!postAnalysisStatus.url && element.title === 'Live Date') {
          return false;
        }
        return true;
      });
      this.postLegends = filteredLegend;
    },
    updatePostAnalysisStatus: function updatePostAnalysisStatus(items) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.updateColumnsStatus(items, 'postAnalysisStatus', 'colSettingsDialog');

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializePostAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializePostAnalysisTableCols: function initializePostAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_13__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.showHideFields, this.campaign.postAnalysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });

                data = [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this5.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context2.prev = 3;
                _context2.next = 6;
                return _this5.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this5.campaign[campaignDataProp] = newStatusObject;
                _this5[dialogProp] = false;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](3);

                console.error('Error updating campaign settings:', _context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[3, 10]]);
      }))();
    },
    showPlayTime: function showPlayTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_13__views_Campaign_campaignHelper__["a" /* default */].showTikTokPlayTime(time);
      }
      return '';
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('post-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_9_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'post-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    },
    updateLineUp: function updateLineUp() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this6.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignAPIs__ = __webpack_require__(16);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_post_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_10__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      postLegends: [],
      selectedGroup: null,
      colSettingsDialog: false,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'outreach', label: 'Audience Size' }, { name: 'showReach', label: 'Accounts Reached' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'likes', label: 'Likes' }, { name: 'showShares', label: 'Shares' }, { name: 'comments', label: 'Comments' }, { name: 'showBookmarks', label: 'Bookmarks' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showViews', label: 'Plays' }, { name: 'showPlays', label: 'Watch Time' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showEngagement', label: 'Engagement Rate by Audience Size' }, { name: 'showEngagementView', label: 'Play Rate (by Audience Size)' }, { name: 'showInteractionPlays', label: 'Engagement Rate by Plays' }, { name: 'showEngRateReach', label: 'Engagement Rate by Reach' }, { name: 'showAvgEngagement', label: 'Avg. Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }, { name: 'showAvgLikes', label: 'Average Likes' }, { name: 'showAvgComments', label: 'Average Comments' }, { name: 'showAvgViews', label: 'Average Views' }, { name: 'showAvgReelsPlays', label: 'Average Reels Plays' }],
      headers: [{
        text: 'Influencer',
        align: 'start',
        sortable: false,
        value: 'name'
      }, {
        text: 'Live Date',
        value: 'live_date',
        legendText: 'Live Date'
      }, {
        text: 'Post URL',
        value: 'url',
        legendText: 'Post URL'
      }, {
        text: 'Audience Size',
        value: 'outreach',
        legendText: 'The number of followers the creator has at the time where the post was made '
      }, {
        text: 'Accounts Reached',
        value: 'reach',
        legendText: 'The total number of unique users who viewed the content'
      }, {
        text: 'Impressions',
        value: 'impressions',
        legendText: 'The total number of times the content is displayed on an user\'s feed'
      }, {
        text: 'Likes',
        value: 'likes',
        legendText: 'The number of times users have tapped the “like” button on a post.'
      }, {
        text: 'Shares',
        value: 'shares',
        legendText: 'The number of times users have reposted / shared a post.'
      }, {
        text: 'Comments',
        value: 'comments',
        legendText: 'The number of written responses to a post.'
      }, {
        text: 'Bookmarks',
        value: 'saved',
        legendText: 'The number of times users have saved a post to their “Saved” folder.'
      }, {
        text: 'Interactions',
        value: 'interactions',
        legendText: 'The sum of likes, comments, saves, shares'
      }, {
        text: 'Plays',
        value: 'views',
        legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
      }, {
        text: 'Watch Time',
        value: 'plays',
        legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
      }, {
        text: 'Average Watch Time',
        value: 'watches',
        legendText: 'How many seconds your video is viewed for'
      }, {
        text: 'Engagement Rate by Audience Size',
        value: 'new_engagement_rate',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by audience size'
      }, {
        text: 'Play Rate (by Audience Size)',
        value: 'new_engagement_rate_view',
        legendText: 'The total number of views divided by the audience size'
      }, {
        text: 'Engagement Rate by Plays',
        value: 'interaction_rate_plays',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by Plays'
      }, {
        text: 'Engagement Rate by Reach',
        value: 'engagement_rate_reach',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by reach'
      }, {
        text: 'Avg. Engagement Rate',
        value: 'engagement_rate_sd',
        legendText: 'The average sum of engagement rate on the last 30 posts'
      }, {
        text: 'Median Engagement Rate',
        value: 'median_engagement_rate',
        legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
      }, {
        text: 'Average Likes',
        value: 'avg_likes',
        legendText: 'Average likes over the last 30 posts'
      }, {
        text: 'Average Comments',
        value: 'avg_comments',
        legendText: 'Average comments over the last 30 posts'
      }, {
        text: 'Average Views',
        value: 'avg_views',
        legendText: 'Average views over the last 30 posts'
      }, {
        text: 'Average Reels Plays',
        value: 'avg_reels_plays',
        legendText: 'Average plays over the last 30 posts'
      }],
      postRightSection: [{
        title: 'Live Date',
        description: 'Live Date'
      }, {
        title: 'Post URL',
        description: 'Post URL'
      }, {
        title: 'Likes',
        description: 'Number of likes'
      }, {
        title: 'Comments',
        description: 'Number of comments'
      }, {
        title: 'Bookmarks',
        description: 'Number of bookmarks'
      }, {
        title: 'Shares',
        description: 'Number of shares'
      }, {
        title: 'Engagement Rate by Interactions',
        description: 'Followers divided by total interactions for this campaign'
      }, {
        title: 'Views',
        description: 'Number of views'
      }, {
        title: 'Reach',
        description: 'Number of unique user that seen your content'
      }, {
        title: 'Impressions',
        description: 'Total number of times content have been shown to users'
      }, {
        title: 'Total Play Time',
        description: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
      }, {
        title: 'Average Watch Time',
        description: 'How many seconds your video is viewed for.'
      }, {
        title: 'Average Engagement Rate',
        description: 'Average engagement for all advertorials and organic content'
      }, {
        title: 'Median Engagement Rate',
        description: 'Engagement Rate within same tier comparison'
      }, {
        title: 'Average Likes',
        description: 'Average likes over the last 30 posts'
      }, {
        title: 'Average Comments',
        description: 'Average comments over the last 30 posts'
      }, {
        title: 'Average Views',
        description: 'Average views over the last 30 posts'
      }, {
        title: 'Average Reels Plays',
        description: 'Average plays over the last 30 posts'
      }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredPosts: function filteredPosts() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.reelAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.showHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.text === field.label;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredPosts.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalEngagement: function totalEngagement() {
      var engagement = 0;
      this.filteredPosts.map(function (item) {
        engagement += item.engagement ? item.engagement : 0;
      });
      return engagement;
    },
    totalLikes: function totalLikes() {
      var likes = 0;
      this.filteredPosts.map(function (item) {
        likes += item.likes ? item.likes : 0;
      });
      return likes;
    },
    totalComments: function totalComments() {
      var comments = 0;
      this.filteredPosts.map(function (item) {
        comments += item.comments ? item.comments : 0;
      });
      return comments;
    },
    totalSaved: function totalSaved() {
      var saved = 0;
      this.filteredPosts.map(function (item) {
        saved += item.saved ? item.saved : 0;
      });
      return saved;
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredPosts.map(function (item) {
        shares += item.shares ? item.shares : 0;
      });
      return shares;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredPosts.map(function (item) {
        views += item.views ? item.views : 0;
      });
      return views.toFixed(2);
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredPosts.map(function (item) {
        interactions += item.interactions ? item.interactions : 0;
      });
      return interactions;
    },
    totalReach: function totalReach() {
      var reach = 0;
      this.filteredPosts.map(function (item) {
        reach += item.reach ? Number(item.reach) : 0;
      });
      return reach;
    },
    totalImpressions: function totalImpressions() {
      var impressions = 0;
      this.filteredPosts.map(function (item) {
        impressions += item.impressions ? item.impressions : 0;
      });
      return impressions;
    },
    totalPlayTime: function totalPlayTime() {
      return __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__["a" /* default */].calculateTotalReelWatchTime(this.filteredPosts);
    },
    totalWatches: function totalWatches() {
      var watches = 0;
      this.filteredPosts.map(function (item) {
        watches += item.watches ? Number(item.watches) : 0;
      });
      return watches.toFixed(2);
    },
    totalEngagementRate: function totalEngagementRate() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.new_engagement_rate ? item.new_engagement_rate : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalInteractionRatePlays: function totalInteractionRatePlays() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.interaction_rate_plays ? parseFloat(item.interaction_rate_plays) : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalEngagementRateReach: function totalEngagementRateReach() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.engagement_rate_reach ? parseFloat(item.engagement_rate_reach) : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalEngagementRateView: function totalEngagementRateView() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    profileUrl: function profileUrl(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_reportPlatform__["b" /* getReportProfileUrl */])(item, 'instagram');
    },

    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateLegend: function updateLegend() {
      var _this4 = this;

      var filteredLegend = this.postRightSection.filter(function (element) {
        var s = _this4.campaign.reelAnalysisStatus;
        if (!s.showEngagement && element.title === 'Engagement Rate by Interactions') return false;
        if (!s.showAvgEngagement && element.title === 'Average Engagement Rate') return false;
        if (!s.showMediaEngagement && element.title === 'Median Engagement Rate') return false;
        if (!s.showAvgLikes && element.title === 'Average Likes') return false;
        if (!s.showAvgComments && element.title === 'Average Comments') return false;
        if (!s.showAvgViews && element.title === 'Average Views') return false;
        if (!s.showAvgReelsPlays && element.title === 'Average Reels Plays') return false;
        if (!s.likes && element.title === 'Likes') return false;
        if (!s.comments && element.title === 'Comments') return false;
        if (!s.showBookmarks && element.title === 'Bookmarks') return false;
        if (!s.showShares && element.title === 'Shares') return false;
        if (!s.showViews && element.title === 'Views') return false;
        if (!s.showReach && element.title === 'Reach') return false;
        if (!s.showImpressions && element.title === 'Impressions') return false;
        if (!s.showPlays && element.title === 'Total Play Time') return false;
        if (!s.showWatches && element.title === 'Average Watch Time') return false;
        if (!s.showInteractions && element.title === 'Interactions') return false;
        if (!s.liveDate && element.title === 'Live Date') return false;
        if (!s.url && element.title === 'Post URL') return false;
        return true;
      });
      this.postLegends = filteredLegend;
    },
    updatePostAnalysisStatus: function updatePostAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.updateColumnsStatus(items, 'reelAnalysisStatus', 'colSettingsDialog');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializeReelAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializeReelAnalysisTableCols: function initializeReelAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.showHideFields, this.campaign.reelAnalysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this6.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context3.prev = 3;
                _context3.next = 6;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this6.campaign[campaignDataProp] = newStatusObject;
                _this6[dialogProp] = false;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.error('Error updating campaign settings:', _context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 10]]);
      }))();
    },
    showPlayTime: function showPlayTime(time) {
      if (time) {
        return __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__["a" /* default */].showReelPlayTime(time);
      }
      return '';
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('reel-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_9_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'reel-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    }
  }
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aos__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aos_dist_aos_css__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aos_dist_aos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aos_dist_aos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PostSummary__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PostSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PostSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReelSummary__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ReelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StorySummary__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StorySummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__StorySummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TiktokSummary__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TiktokSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__TiktokSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__YoutubeSummary__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__YoutubeSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__YoutubeSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FbSummary__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FbSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__FbSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__XHSSummary__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__XHSSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__XHSSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LemonSummary__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LemonSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__LemonSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Campaign_TableAiAnalysisModal__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Campaign_TableAiAnalysisModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Campaign_TableAiAnalysisModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Campaign_campaignAPIs__ = __webpack_require__(16);





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportForSummary',
  components: {
    PostSummary: __WEBPACK_IMPORTED_MODULE_6__PostSummary___default.a,
    ReelSummary: __WEBPACK_IMPORTED_MODULE_7__ReelSummary___default.a,
    StorySummary: __WEBPACK_IMPORTED_MODULE_8__StorySummary___default.a,
    TiktokSummary: __WEBPACK_IMPORTED_MODULE_9__TiktokSummary___default.a,
    YoutubeSummary: __WEBPACK_IMPORTED_MODULE_10__YoutubeSummary___default.a,
    FbSummary: __WEBPACK_IMPORTED_MODULE_11__FbSummary___default.a,
    XhsSummary: __WEBPACK_IMPORTED_MODULE_12__XHSSummary___default.a,
    LemonSummary: __WEBPACK_IMPORTED_MODULE_13__LemonSummary___default.a,
    TableAiAnalysisModal: __WEBPACK_IMPORTED_MODULE_14__views_Campaign_TableAiAnalysisModal___default.a
  },
  props: {
    respData: {
      type: Object,
      required: true
    },
    campaignID: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      reportData: { campaign: null },

      aiDialog: false,
      aiTypeKey: '',
      aiLabel: '',
      aiPosts: [],
      postsAnalysisData: [],
      reelAnalysisData: [],
      storyAnalysisData: [],
      tikTokAnalysisData: [],
      youtubeAnalysisData: [],
      xhsAnalysisData: [],
      lemonAnalysisData: [],
      fbAnalysisData: [],
      linkedInAnalysisData: [],
      twitterAnalysisData: [],
      defaultPostsAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showEngagement: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false
      },
      defaultReelAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: true,
        showPlays: false,
        showWatches: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultStoryAnalysisStatus: {
        liveDate: false,
        outreach: true,
        showReach: false,
        showImpressions: true,
        showStoryLikes: true,
        showReplies: true,
        showShares: true,
        showLinkClicks: true,
        showStickerTaps: true,
        showInteractions: false,
        showNewEngagementRate: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultTikTokAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showPlays: true,
        showWatches: true,
        likes: true,
        comments: true,
        shares: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: false,
        showReach: false,
        showImpressions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        avgSaves: false,
        avgShares: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateTotalViewers: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showWatchedFullVideo: false
      },
      defaultYoutubeAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showViews: true,
        likes: true,
        comments: true,
        showInteractions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        showEngagement: true,
        showEngagementView: false,
        showAvgEngagement: false,
        showMediaEngagement: false
      },
      defaultPerformanceAnalysisStatus: {
        totalContents: true,
        totalOutreach: true,
        contents: true,
        outreach: true,
        interactions: true,
        outreachImpressions: true,
        postEngRate: false,
        reelEngRate: false,
        tiktokEngRate: false,
        youtubeEngRate: false,
        postEngRateView: false,
        reelEngRateView: false,
        tiktokEngRateView: false,
        youtubeEngRateView: false,
        industryBenchmark: false
      },
      defaultXHSAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultLemonAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultFbAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showLikes: true,
        showComments: true,
        showViews: true,
        showShares: true,
        showBookmarks: false,
        showInteractions: false
      },
      defaultLinkedInAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showReach: true,
        showVideoViews: true,
        showProfileViewers: true,
        showLikes: true,
        showComments: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      defaultTwitterAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showComments: true,
        showLikes: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      }
    };
  },

  watch: {
    campaignID: {
      handler: 'processReportData',
      immediate: true,
      deep: true
    }
  },
  methods: {
    openAi: function openAi(typeKey, label, posts) {
      this.aiTypeKey = typeKey;
      this.aiLabel = label;
      this.aiPosts = posts || [];
      this.aiDialog = true;
    },
    resetReportData: function resetReportData() {
      this.reportData = { campaign: null };
      this.postsAnalysisData = [];
      this.reelAnalysisData = [];
      this.storyAnalysisData = [];
      this.tikTokAnalysisData = [];
      this.youtubeAnalysisData = [];
      this.xhsAnalysisData = [];
      this.lemonAnalysisData = [];
      this.fbAnalysisData = [];
      this.linkedInAnalysisData = [];
      this.twitterAnalysisData = [];
    },
    processReportData: function processReportData() {
      var _this = this;

      var reportData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.respData;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, newData, campaign, settings, posts;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('loading-status', true);
                _context.prev = 1;

                if (!(reportData && reportData.campaign_details)) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = { success: true, data: reportData };
                _context.next = 9;
                break;

              case 6:
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_18__views_Campaign_campaignAPIs__["a" /* default */].generateCampaignReport(_this.campaignID, null, false);

              case 8:
                _context.t0 = _context.sent;

              case 9:
                response = _context.t0;

                if (!(!response || !response.success || !response.data || !response.data.campaign_details)) {
                  _context.next = 13;
                  break;
                }

                _this.resetReportData();
                return _context.abrupt('return');

              case 13:
                newData = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response.data));

                newData.summary = newData.summary || {};
                newData.client = newData.client || {};
                newData.posts = Array.isArray(newData.posts) ? newData.posts.filter(Boolean) : [];
                campaign = {};

                campaign.id = newData.campaign_details.id;
                campaign.name = newData.campaign_details.name;
                campaign.campaignType = newData.campaign_details.campaignType;
                campaign.objectives = newData.campaign_details.goal;
                campaign.deliverables = ['Total ' + newData.summary.contents + ' contents'];
                campaign.angles = newData.campaign_details.angles ? __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignHelper__["a" /* default */].fixAnglesData(newData.campaign_details.angles) : [];
                campaign.segment = newData.campaign_details.segment || __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignHelper__["a" /* default */].getDefaultSegments();
                campaign.lineUp = newData.campaign_details.lineUp || [];
                settings = newData.campaign_details.settings || {};

                campaign.enablePostAnalysis = settings.enablePostAnalysis !== false;
                campaign.enableReelAnalysis = settings.enableReelAnalysis !== false;
                campaign.enableTikTokAnalysis = settings.enableTikTokAnalysis !== false;
                campaign.enableYoutubeAnalysis = settings.enableYoutubeAnalysis !== false;
                campaign.enableFbAnalysis = settings.enableFbAnalysis !== false;
                campaign.enableLinkedInAnalysis = settings.enableLinkedInAnalysis !== false;
                campaign.enableTwitterAnalysis = settings.enableTwitterAnalysis !== false;
                campaign.enableXHSAnalysis = settings.enableXHSAnalysis !== false;
                campaign.enableLemonAnalysis = settings.enableLemonAnalysis !== false;
                campaign.enableOverallSection = newData.campaign_details.settings ? newData.campaign_details.settings.enableOverallSection : false;
                campaign.postAnalysisStatus = newData.campaign_details.postAnalysisStatus || _this.defaultPostsAnalysisStatus;
                campaign.reelAnalysisStatus = newData.campaign_details.reelAnalysisStatus || _this.defaultReelAnalysisStatus;
                campaign.storyAnalysisStatus = newData.campaign_details.storyAnalysisStatus || _this.defaultStoryAnalysisStatus;
                campaign.tikTokAnalysisStatus = newData.campaign_details.tikTokAnalysisStatus || _this.defaultTikTokAnalysisStatus;
                campaign.youtubeAnalysisStatus = newData.campaign_details.youtubeAnalysisStatus || _this.defaultYoutubeAnalysisStatus;
                campaign.performanceAnalysisStatus = newData.campaign_details.performanceAnalysisStatus || _this.defaultPerformanceAnalysisStatus;
                campaign.fbAnalysisStatus = newData.campaign_details.fbAnalysisStatus || _this.defaultFbAnalysisStatus;
                campaign.linkedInAnalysisStatus = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.defaultLinkedInAnalysisStatus, newData.campaign_details.linkedInAnalysisStatus || {});
                campaign.twitterAnalysisStatus = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.defaultTwitterAnalysisStatus, newData.campaign_details.twitterAnalysisStatus || {});
                campaign.xhsAnalysisStatus = newData.campaign_details.xhsAnalysisStatus || _this.defaultXHSAnalysisStatus;
                campaign.lemonAnalysisStatus = newData.campaign_details.lemonAnalysisStatus || _this.defaultLemonAnalysisStatus;
                campaign.startDate = newData.campaign_details.startDate || '';
                campaign.endDate = newData.campaign_details.endDate || '';
                campaign.optionalRemarks = newData.campaign_details.optionalRemarks || '';

                campaign.AITableSummaries = newData.campaign_details.AITableSummaries || {};
                campaign.kpi = {
                  post: newData.campaign_details.kpi && newData.campaign_details.kpi.post ? newData.campaign_details.kpi.post : {},
                  story: newData.campaign_details.kpi && newData.campaign_details.kpi.story ? newData.campaign_details.kpi.story : {},
                  reel: newData.campaign_details.kpi && newData.campaign_details.kpi.reel ? newData.campaign_details.kpi.reel : {},
                  tiktok: newData.campaign_details.kpi && newData.campaign_details.kpi.tiktok ? newData.campaign_details.kpi.tiktok : {},
                  youtube: newData.campaign_details.kpi && newData.campaign_details.kpi.youtube ? newData.campaign_details.kpi.youtube : {}
                };
                campaign.summary = newData.summary;
                campaign.client = {
                  name: newData.client.name,
                  logo: newData.client.logo
                };
                posts = newData.posts.map(function (post, index) {
                  if (post.reportGroup) {
                    var reports = Array.isArray(post.reports) ? post.reports : [];
                    post.reports = reports.map(function (p) {
                      return _this.calculatePostData(p, index);
                    });
                  } else {
                    post = _this.calculatePostData(post, index);
                  }
                  return post;
                });

                posts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], posts).sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.reportData.campaign = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, campaign);

                _this.postsAnalysisData = posts.filter(function (post) {
                  return post.type !== 'story' && post.type !== 'tiktok' && post.type !== 'youtube' && post.type !== 'xhs' && post.type !== 'lemon' && post.type !== 'facebook' && post.type !== 'linkedin' && post.type !== 'twitter' && post.type !== 'gdrive' && post.type !== 'reel';
                });
                _this.postsAnalysisData.map(function (post) {
                  post.new_engagement_rate = Number(((post.likes + post.comments + post.saved + post.shares) / post.outreach * 100).toFixed(2));
                  post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                  post.engagement_rate_reach = Number(((post.likes + post.comments + post.saved + post.shares) / post.reach * 100).toFixed(2));
                  post.interactions = (post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0);
                });
                _this.postsAnalysisData = _this.postsAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.reelAnalysisData = posts.filter(function (post) {
                  return post.type === 'reel';
                });
                _this.reelAnalysisData.map(function (post) {
                  post.interactions = Number(post.likes + post.comments + post.saved + post.shares);
                  post.new_engagement_rate = Number(((post.likes + post.comments + post.saved + post.shares) / post.outreach * 100).toFixed(2));
                  post.interaction_rate_plays = 0;
                  if (post.views) {
                    post.interaction_rate_plays = Number(((post.likes + post.comments + post.saved + post.shares) / Number(post.views) * 100).toFixed(2));
                  }
                  post.engagement_rate_reach = Number(((post.likes + post.comments + post.saved + post.shares) / Number(post.reach) * 100).toFixed(2));
                  post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                });
                _this.reelAnalysisData = _this.reelAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.tikTokAnalysisData = posts.filter(function (post) {
                  return post.type === 'tiktok';
                });
                _this.tikTokAnalysisData.map(function (post) {
                  post.new_engagement_rate = (((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / (post.outreach || 0) * 100).toFixed(2);
                  post.interactions = Number((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0));
                  post.interaction_rate_plays = 0;
                  post.eng_rate_total_viewers = 0;
                  if (post.views) {
                    post.interaction_rate_plays = (((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / Number(post.views) * 100).toFixed(2);
                    post.eng_rate_total_viewers = (((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0)) / Number(post.reach) * 100).toFixed(2);
                  }
                  post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                });
                _this.tikTokAnalysisData = _this.tikTokAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.youtubeAnalysisData = posts.filter(function (post) {
                  return post.type === 'youtube';
                });
                _this.youtubeAnalysisData.map(function (post) {
                  post.new_engagement_rate = (((post.likes || 0) + (post.comments || 0)) / (post.outreach || 0) * 100).toFixed(2);
                  post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                  post.interactions = Number((post.likes || 0) + (post.comments || 0));
                });
                _this.youtubeAnalysisData = _this.youtubeAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.storyAnalysisData = posts.filter(function (post) {
                  return post.type === 'story' || post.type === 'gdrive';
                });
                _this.storyAnalysisData.map(function (post) {
                  post.interactions = (post.shares || 0) + (post.replies || 0) + (post.link_clicks || 0) + (post.sticker_taps || 0) + (post.story_likes || 0);
                  post.new_engagement_rate = ((post.interactions || 0) / (post.outreach || 0) * 100).toFixed(2);
                });
                _this.storyAnalysisData = _this.storyAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.fbAnalysisData = posts.filter(function (post) {
                  return post.type === 'facebook';
                });
                _this.fbAnalysisData.map(function (post) {
                  post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                });

                _this.linkedInAnalysisData = posts.filter(function (post) {
                  return post.type === 'linkedin';
                });
                _this.linkedInAnalysisData.map(function (post) {
                  post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.shares || 0);
                });
                _this.linkedInAnalysisData = _this.linkedInAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.twitterAnalysisData = posts.filter(function (post) {
                  return post.type === 'twitter';
                });
                _this.twitterAnalysisData.forEach(function (post) {
                  post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                });
                _this.twitterAnalysisData = _this.twitterAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.xhsAnalysisData = posts.filter(function (post) {
                  return post.type === 'xhs';
                });
                _this.xhsAnalysisData.map(function (post) {
                  post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                });
                _this.xhsAnalysisData = _this.xhsAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });

                _this.lemonAnalysisData = posts.filter(function (post) {
                  return post.type === 'lemon';
                });
                _this.lemonAnalysisData.map(function (post) {
                  post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                });
                _this.lemonAnalysisData = _this.lemonAnalysisData.sort(function (a, b) {
                  return a.lineUpIndex - b.lineUpIndex;
                });
                __WEBPACK_IMPORTED_MODULE_4_aos___default.a.init();
                window.onscroll = function () {
                  setTimeout(function () {
                    var favBtn = document.getElementById('goTop');
                    if (favBtn) {
                      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 800) {
                        favBtn.style.display = 'block';
                      } else {
                        favBtn.style.display = 'none';
                      }
                    }
                  }, 500);
                };
                _context.next = 95;
                break;

              case 91:
                _context.prev = 91;
                _context.t1 = _context['catch'](1);

                _this.resetReportData();
                console.error(_context.t1);

              case 95:
                _context.prev = 95;

                _this.$emit('loading-status', false);
                return _context.finish(95);

              case 98:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 91, 95, 98]]);
      }))();
    },
    calculatePostData: function calculatePostData(post, index) {
      var platform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_reportPlatform__["a" /* getReportPlatform */])(post);
      var postData = {};
      postData.id = post.id;
      postData.campaignID = post.campaignID;
      postData.key = index;
      postData.lineUpIndex = post.lineUpIndex;
      postData.groupID = post.groupID;
      postData.groupName = post.groupName;
      var profileOwner = post.owner || (post.post_details || {}).owner || {};
      postData.profileUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_reportPlatform__["b" /* getReportProfileUrl */])(post, platform || (post.isTikTok ? 'tiktok' : 'instagram'));
      postData.profilePlatform = post.profilePlatform || post.profile_platform || profileOwner.platform || (post.influencer_details || {}).platform || '';
      postData.profileHandle = post.profileHandle || post.profile_handle || (post.influencer_details || {}).instagramHandle || profileOwner.username || '';
      if (post.isCalculated) {
        return post;
      }
      if (!['linkedin', 'twitter'].includes(platform) && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isLemon && !post.isFacebook && !post.isOthers) {
        postData.name = post.post_details.owner.username;
        postData.url = post.post_details.link;
        postData.impressions = 0;
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
        postData.engagement_rate_sd = post.post_details.owner.engagement_rate_sd || null;
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
        if (post.postType === 'IGR') {
          postData.type = 'reel';
          postData.title = 'IG Reel';
        } else {
          postData.type = 'post/carousel';
          postData.title = 'IG Post';
        }

        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved;
          postData.shares = post.inputtedInsights.shares;
          postData.views = post.inputtedInsights.views || 0;
          postData.reach = post.inputtedInsights.reach || 0;
          postData.impressions = post.inputtedInsights.impressions || 0;
          postData.plays = post.inputtedInsights.plays || 0;
          postData.watches = post.inputtedInsights.watches ? __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignHelper__["a" /* default */].parseWatchTime(post.inputtedInsights.watches) : 0;
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0;
          postData.shares = 0;
          postData.views = 0;
        }
      } else if (post.isStory && post.insights) {
        postData.name = post.owner.username;
        postData.outreach = post.owner.followers || post.owner.followers_sd;
        postData.title = 'IG Story';
        postData.url = post.media_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.engagement = Number(post.insights.engagement) || 0;
        postData.impressions = Number(post.insights.impressions) || 0;
        postData.story_likes = Number(post.insights.story_likes) || 0;
        postData.reach = Number(post.insights.reach) || 0;
        postData.replies = Number(post.insights.replies) || 0;
        postData.exits = Number(post.insights.exits) || 0;
        postData.taps_back = Number(post.insights.taps_back) || 0;
        postData.taps_forward = Number(post.insights.taps_forward) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.sticker_taps = Number(post.insights.sticker_taps) || 0;
        postData.link_clicks = Number(post.insights.link_clicks) || 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
        postData.type = 'story';
        postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1;
        postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps + postData.story_likes;
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.public_id = post.public_id || null;
      } else if (post.isTikTok) {
        postData.name = post.owner.username;
        postData.title = 'TikTok Post';
        postData.url = post.post_details.link;
        postData.shortCode = post.post_details.shortcode;
        postData.impressions = 0;
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.shares = post.currentInsight.shares || 0;
        postData.views = post.currentInsight.views || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null;
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_saves = post.avg_saves ? Number(post.avg_saves) : 0;
        postData.avg_shares = post.avg_shares ? Number(post.avg_shares) : 0;
        postData.type = 'tiktok';

        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved;
          if (postData.shares === 0) {
            postData.shares = post.inputtedInsights.shares;
          }
          if (postData.views === 0) {
            postData.views = post.inputtedInsights.views || 0;
          }
          postData.reach = post.inputtedInsights.reach || 0;
          postData.impressions = post.inputtedInsights.impressions || 0;
          postData.plays = post.inputtedInsights.plays || 0;
          postData.watches = post.inputtedInsights.watches ? __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignHelper__["a" /* default */].parseWatchTime(post.inputtedInsights.watches) : 0;
          postData.watchedFullVideo = post.inputtedInsights.watchedFullVideo || 0;
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0;
          postData.shares = 0;
          postData.views = 0;
          postData.reach = 0;
          postData.impressions = 0;
          postData.plays = 0;
          postData.watches = 0;
          postData.watchedFullVideo = 0;
        }
      } else if (post.isYoutube) {
        postData.name = post.owner.username;
        postData.title = 'Youtube Post';
        postData.url = post.post_details.link;
        postData.shortCode = post.post_details.shortcode;
        postData.type = 'youtube';
        postData.impressions = 0;
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.views = post.currentInsight.views || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null;
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      } else if (post.isFacebook && post.insights) {
        postData.name = post.owner.username;
        postData.outreach = post.owner.followers || post.owner.followers_sd;
        postData.title = 'Facebook';
        postData.url = post.media_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.outreach = Number(post.insights.outreach) || 0;
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.bookmarks) || 0;
        postData.type = 'facebook';
      } else if (post.isXHS && post.insights) {
        postData.name = post.owner.fullName || post.owner.username;
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd;
        postData.title = 'XHS';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.xhsLink = post.xhsLink || '';
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.watches = Number(post.insights.watches) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.bookmarks) || 0;
        postData.type = 'xhs';
        postData.isXHS = true;
      } else if (post.isLemon && post.insights) {
        postData.name = post.owner.fullName || post.owner.username;
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd;
        postData.title = 'Lemon8';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.lemonLink = post.lemonLink || '';
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.watches = Number(post.insights.watches) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.bookmarks) || 0;
        postData.type = 'lemon';
        postData.isLemon = true;
      } else if (platform === 'twitter' && post.insights) {
        var rawUrl = post.postLink || post.postURL || post.post_details || '';
        var latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
        var insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights;
        var insights = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});
        postData.name = post.owner.username || post.owner.fullName;
        postData.title = 'X (Twitter)';
        postData.url = typeof rawUrl === 'string' ? rawUrl : rawUrl.link || rawUrl.url || rawUrl.href || '';
        postData.outreach = Number(post.owner.followers || insights.outreach) || 0;
        postData.like_count = Number(insights.like_count) || 0;
        postData.comment_count = Number(insights.comment_count) || 0;
        postData.impressions = Number(insights.impressions != null ? insights.impressions : insights.views) || 0;
        postData.views = postData.impressions;
        postData.shares = Number(insights.shares) || 0;
        postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0;
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks;
        postData.type = 'twitter';
      } else if (platform === 'linkedin' && post.insights) {
        var _rawUrl = post.postLink || post.postURL || post.post_details || '';
        var _latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
        var _insightData = _latestInsight && _latestInsight.data ? _latestInsight.data : post.insights;
        var _insights = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});
        postData.name = post.owner.username || post.owner.fullName;
        postData.title = 'LinkedIn';
        postData.url = typeof _rawUrl === 'string' ? _rawUrl : _rawUrl.link || _rawUrl.url || _rawUrl.href || '';
        postData.like_count = Number(_insights.like_count) || 0;
        postData.comment_count = Number(_insights.comment_count) || 0;
        postData.impressions = Number(_insights.impressions) || 0;
        postData.reach = Number(_insights.reach != null ? _insights.reach : _insights.outreach) || 0;
        postData.video_views = Number(_insights.video_views) || 0;
        postData.profile_viewers = Number(_insights.profile_viewers) || 0;
        postData.shares = Number(_insights.shares) || 0;
        postData.bookmarks = Number(_insights.saved || _insights.bookmarks) || 0;
        postData.saved = postData.bookmarks;
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks;
        postData.type = 'linkedin';
      } else if (post.isOthers && post.insights) {
        postData.name = post.owner.fullName || post.owner.username;
        postData.outreach = Number(post.insights.outreach) || 0;
        postData.title = 'Others';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.postLink = post.postLink || '';
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.watches = Number(post.insights.watches) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.saved) || 0;
        postData.plays = Number(post.insights.plays) || 0;
        postData.type = 'others';
        postData.isOthers = true;
      } else if (post.isMultipleContents) {
        postData.name = post.owner.username;
        postData.outreach = post.owner.followers || post.owner.followers_sd;
        postData.title = 'IG Story';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.type = 'gdrive';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.public_id = post.public_id || null;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
        if (post.insights) {
          postData.engagement = Number(post.insights.engagement) || 0;
          postData.impressions = Number(post.insights.impressions) || 0;
          postData.reach = Number(post.insights.reach) || 0;
          postData.replies = Number(post.insights.replies) || 0;
          postData.story_likes = Number(post.insights.story_likes) || 0;
          postData.exits = Number(post.insights.exits) || 0;
          postData.taps_back = Number(post.insights.taps_back) || 0;
          postData.taps_forward = Number(post.insights.taps_forward) || 0;
          postData.shares = Number(post.insights.shares) || 0;
          postData.sticker_taps = Number(post.insights.sticker_taps) || 0;
          postData.link_clicks = Number(post.insights.link_clicks) || 0;
          postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1;
          postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps;
        }
      }
      postData.live_date = post.live_date ? __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.formatDate(post.live_date) : '-';
      postData.isCalculated = true;
      return postData;
    },
    refreshReportInf: function refreshReportInf() {
      var _this2 = this;

      var reportID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$emit('loading-status', true);
      __WEBPACK_IMPORTED_MODULE_18__views_Campaign_campaignAPIs__["a" /* default */].generateCampaignReport(this.campaignID, null, true, 'json', reportID).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (response && response.success) {
                    _this2.processReportData(response.data);
                  }
                  _this2.$emit('loading-status', false);

                case 2:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this2.$emit('loading-status', false);
        console.error(error);
      });
    }
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignAPIs__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportLoginModal',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  props: {
    value: Boolean,
    campaignID: String
  },
  validations: {
    passcode: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      show1: false,
      passcode: '',
      submitting: false,
      invalid: false,
      errText: ''
    };
  },

  computed: {
    passcodeErrors: function passcodeErrors() {
      var errors = [];
      if (!this.$v.passcode.$dirty) return errors;
      !this.$v.passcode.required && errors.push('passcode is required');
      return errors;
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      var passcode = this.passcode;
      this.submitting = true;
      return __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignAPIs__["a" /* default */].loginCampaignReport(this.campaignID, passcode).then(function (response) {
        _this.submitting = false;
        if (response.success) {
          _this.$emit('loggedIn', passcode);
          return;
        }

        _this.invalid = true;
        _this.errText = response.message || 'Incorrect passcode. Please try again.';
      }).catch(function (error) {
        _this.submitting = false;
        _this.invalid = true;
        _this.errText = error.response && error.response.data && error.response.data.message || 'Unable to verify the passcode. Please try again.';
        console.error(error);
      });
    },
    close: function close() {
      this.$emit('input');
    },
    removeSpaces: function removeSpaces() {
      this.$v.passcode.$touch();
      this.passcode = this.passcode.replace(/\s/g, '');
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignAPIs__ = __webpack_require__(16);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_story_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_10__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      storyLegends: [],
      selectedGroup: null,
      colSettingsDialog: false,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      headers: [{
        text: 'Influencer',
        align: 'start',
        sortable: false,
        value: 'name'
      }, {
        text: 'Live Date',
        value: 'live_date',
        legendText: 'Live Date'
      }, {
        text: 'Audience Size',
        value: 'outreach',
        legendText: 'The number of followers the creator has at the time where the post was made '
      }, {
        text: 'Accounts Reached',
        value: 'reach',
        legendText: 'The total number of unique users who viewed the content'
      }, {
        text: 'Impressions',
        value: 'impressions',
        legendText: 'The total number of times the content is displayed on an user\'s feed'
      }, {
        text: 'Story Likes',
        value: 'story_likes',
        legendText: 'The number of likes on the story.'
      }, {
        text: 'Replies',
        value: 'replies',
        legendText: 'The number of replies to a story.'
      }, {
        text: 'Shares',
        value: 'shares',
        legendText: 'The number of times users have reposted / shared a story.'
      }, {
        text: 'Links Click',
        value: 'link_clicks',
        legendText: 'The number of times users have tapped the link attached on a story.'
      }, {
        text: 'Sticker Taps',
        value: 'sticker_taps',
        legendText: 'The number of times users have tapped the hashtags and mentions attached on a story.'
      }, {
        text: 'Interactions',
        value: 'interactions',
        legendText: 'The sum of likes, comments, saves, shares'
      }, {
        text: 'Engagement Rate by Audience Size',
        value: 'new_engagement_rate',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by the audience size numbers'
      }, {
        text: 'Average Views',
        value: 'avg_views',
        legendText: 'Average views over the last 30 posts'
      }, {
        text: 'Average Reels Plays',
        value: 'avg_reels_plays',
        legendText: 'Average plays over the last 30 posts'
      }],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'outreach', label: 'Audience Size' }, { name: 'showReach', label: 'Reach' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'showStoryLikes', label: 'Story Likes' }, { name: 'showReplies', label: 'Replies' }, { name: 'showShares', label: 'Shares' }, { name: 'showLinkClicks', label: 'Links Click' }, { name: 'showStickerTaps', label: 'Sticker Taps' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showNewEngagementRate', label: 'Engagement Rate by Audience Size' }, { name: 'showAvgViews', label: 'Average Views' }, { name: 'showAvgReelsPlays', label: 'Average Reels Plays' }],
      storyRightSection: [{
        title: 'Live Date',
        description: 'Live Date'
      }, {
        title: 'Audience Size',
        description: 'Audience size (followers at post time)'
      }, {
        title: 'Shares',
        description: 'Number of times story was shared'
      }, {
        title: 'Replies',
        description: 'Number of replies to photo or video in your stories'
      }, {
        title: 'Story Likes',
        description: 'Number of likes on the story.'
      }, {
        title: 'Links Click',
        description: 'Number of people who swipe up on a story to follow a link'
      }, {
        title: 'Sticker Taps',
        description: 'Number of times users interacted with the stickers/handle'
      }, {
        title: 'Reach',
        description: 'Number of unique user that seen your content'
      }, {
        title: 'Impressions',
        description: 'Total number of times content have been shown to users'
      }, {
        title: 'Engagement Rate by Audience Size',
        description: 'The total number of interactions (users who liked, shares, links click or sticker taps the post) divided by the audience size numbers'
      }, {
        title: 'Average Views',
        description: 'Average views over the last 30 posts'
      }, {
        title: 'Average Reels Plays',
        description: 'Average plays over the last 30 posts'
      }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredItems: function filteredItems() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.storyAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.showHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.text === field.label;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      return finalHeaders;
    },
    totalStoryLikes: function totalStoryLikes() {
      var likes = 0;
      this.filteredItems.map(function (item) {
        likes += item.story_likes ? Number(item.story_likes) : 0;
      });
      return likes;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredItems.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalReplies: function totalReplies() {
      var replies = 0;
      this.filteredItems.map(function (item) {
        replies += item.replies ? Number(item.replies) : 0;
      });
      return replies;
    },
    totalLinkClicks: function totalLinkClicks() {
      var linkClicks = 0;
      this.filteredItems.map(function (item) {
        linkClicks += item.link_clicks ? Number(item.link_clicks) : 0;
      });
      return linkClicks;
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredItems.map(function (item) {
        shares += item.shares ? Number(item.shares) : 0;
      });
      return shares;
    },
    totalStickerTaps: function totalStickerTaps() {
      var stickerTaps = 0;
      this.filteredItems.map(function (item) {
        stickerTaps += item.sticker_taps ? Number(item.sticker_taps) : 0;
      });
      return stickerTaps;
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredItems.map(function (item) {
        interactions += item.interactions ? Number(item.interactions) : 0;
      });
      return interactions;
    },
    totalNewEngagementRate: function totalNewEngagementRate() {
      var newEngagementRate = 0;
      this.filteredItems.map(function (item) {
        newEngagementRate += item.new_engagement_rate ? Number(item.new_engagement_rate) : 0;
      });
      return newEngagementRate;
    },
    totalReach: function totalReach() {
      var reach = 0;
      this.filteredItems.map(function (item) {
        reach += item.reach ? Number(item.reach) : 0;
      });
      return reach;
    },
    totalImpressions: function totalImpressions() {
      var impressions = 0;
      this.filteredItems.map(function (item) {
        impressions += item.impressions ? Number(item.impressions) : 0;
      });
      return impressions;
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    profileUrl: function profileUrl(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_reportPlatform__["b" /* getReportProfileUrl */])(item, 'instagram');
    },

    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateLegend: function updateLegend() {
      var _this4 = this;

      var filteredLegend = this.storyRightSection.filter(function (s) {
        var st = _this4.campaign.storyAnalysisStatus;
        if (!st.showShares && s.title === 'Shares') return false;
        if (!st.showReplies && s.title === 'Replies') return false;
        if (!st.showLinkClicks && s.title === 'Links Click') return false;
        if (!st.showStickerTaps && s.title === 'Sticker Taps') return false;
        if (!st.showReach && s.title === 'Reach') return false;
        if (!st.showImpressions && s.title === 'Impressions') return false;
        if (!st.liveDate && s.title === 'Live Date') return false;
        if (!st.showNewEngagementRate && s.title === 'Engagement Rate by Audience Size') return false;
        if (!st.showAvgViews && s.title === 'Average Views') return false;
        if (!st.showAvgReelsPlays && s.title === 'Average Reels Plays') return false;
        return true;
      });
      this.storyLegends = filteredLegend;
    },
    updateStoryAnalysisStatus: function updateStoryAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.updateColumnsStatus(items, 'storyAnalysisStatus', 'colSettingsDialog');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializeStoryAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializeStoryAnalysisTableCols: function initializeStoryAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_13__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.showHideFields, this.campaign.storyAnalysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this6.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context3.prev = 3;
                _context3.next = 6;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this6.campaign[campaignDataProp] = newStatusObject;
                _this6[dialogProp] = false;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.error('Error updating campaign settings:', _context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 10]]);
      }))();
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('story-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_9_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'story-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    }
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_reportPlatform__ = __webpack_require__(79);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_tiktok_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_9__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      tikTokLegends: [],
      colSettingsDialog: false,
      selectedGroup: null,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      headers: [{
        text: 'Influencer',
        align: 'start',
        sortable: false,
        value: 'name'
      }, {
        text: 'Live Date',
        value: 'live_date',
        legendText: 'Live Date'
      }, {
        text: 'Post URL',
        value: 'url',
        legendText: 'Post URL'
      }, {
        text: 'Audience Size',
        value: 'outreach',
        legendText: 'The number of followers the creator has at the time where the post was made'
      }, {
        text: 'Total Play Time',
        value: 'plays',
        legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
      }, {
        text: 'Average Watch Time',
        value: 'watches',
        legendText: 'How many seconds your video is viewed for'
      }, {
        text: 'Likes',
        value: 'likes',
        legendText: 'The number of times users have tapped the “like” button on a post.'
      }, {
        text: 'Comments',
        value: 'comments',
        legendText: 'The number of written responses to a post.'
      }, {
        text: 'Shares',
        value: 'shares',
        legendText: 'The number of times users have reposted / shared a post.'
      }, {
        text: 'Bookmarks',
        value: 'saved',
        legendText: 'The number of times users have saved a post to their “Saved” folder.'
      }, {
        text: 'Interactions',
        value: 'interactions',
        legendText: 'The sum of likes, comments, saves, shares'
      }, {
        text: 'Plays',
        value: 'views',
        legendText: 'The number of times users have viewed a post, including every looped view.'
      }, {
        text: 'Accounts Reached',
        value: 'reach',
        legendText: 'The total number of unique users who viewed the content'
      }, {
        text: 'Impressions',
        value: 'impressions',
        legendText: 'Total number of times content have been shown to users'
      }, {
        text: 'Average Views',
        value: 'avg_views',
        legendText: 'Average views over the last 30 posts'
      }, {
        text: 'Average Likes',
        value: 'avg_likes',
        legendText: 'Average likes over the last 30 posts'
      }, {
        text: 'Average Comments',
        value: 'avg_comments',
        legendText: 'Average comments over the last 30 posts'
      }, {
        text: 'Average Saves',
        value: 'avg_saves',
        legendText: 'The average sum of saves on the last 30 posts'
      }, {
        text: 'Average Shares',
        value: 'avg_shares',
        legendText: 'The average sum of shares on the last 30 posts'
      }, {
        text: 'Engagement Rate by Audience Size',
        value: 'new_engagement_rate',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by audience size'
      }, {
        text: 'Play Rate (by Audience Size)',
        value: 'new_engagement_rate_view',
        legendText: 'The total number of plays divided by the audience size'
      }, {
        text: 'Engagement Rate by Plays',
        value: 'interaction_rate_plays',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by Plays'
      }, {
        text: 'Engagement Rate by Accounts Reached',
        value: 'eng_rate_total_viewers',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by accounts reached'
      }, {
        text: 'Average Engagement Rate',
        value: 'engagement_rate_sd',
        legendText: 'The average sum of engagement rate on the last 30 posts'
      }, {
        text: 'Median Engagement Rate',
        value: 'median_engagement_rate',
        legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
      }, {
        text: 'Watched Full Video',
        value: 'watchedFullVideo',
        legendText: 'Watched Full Video'
      }, {
        text: 'Photo Views',
        value: 'photo_views',
        legendText: 'Photo Views'
      }],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'outreach', label: 'Audience Size' }, { name: 'showPlays', label: 'Total Play Time' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'likes', label: 'Likes' }, { name: 'comments', label: 'Comments' }, { name: 'shares', label: 'Shares' }, { name: 'showBookmarks', label: 'Bookmarks' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showViews', label: 'Plays' }, { name: 'showReach', label: 'Accounts Reached' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'avgViews', label: 'Average Views' }, { name: 'avgLikes', label: 'Average Likes' }, { name: 'avgComments', label: 'Average Comments' }, { name: 'avgSaves', label: 'Average Saves' }, { name: 'avgShares', label: 'Average Shares' }, { name: 'showEngagement', label: 'Engagement Rate by Audience Size' }, { name: 'showEngagementView', label: 'Play Rate (by Audience Size)' }, { name: 'showInteractionPlays', label: 'Engagement Rate by Plays' }, { name: 'showEngRateTotalViewers', label: 'Engagement Rate by Accounts Reached' }, { name: 'showAvgEngagement', label: 'Average Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }, { name: 'showWatchedFullVideo', label: 'Watched Full Video' }, { name: 'showPhotoViews', label: 'Photo Views' }],
      rightSection: [{
        title: 'Likes',
        description: 'Number of likes'
      }, {
        title: 'Comments',
        description: 'Number of comments'
      }, {
        title: 'Bookmarks',
        description: 'Number of bookmarks'
      }, {
        title: 'Shares',
        description: 'Number of shares'
      }, {
        title: 'Total Views',
        description: 'Number of plays'
      }, {
        title: 'Reach',
        description: 'Number of unique user that seen your content'
      }, {
        title: 'Impressions',
        description: 'Total number of times content have been shown to users'
      }, {
        title: 'Total Play Time',
        description: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
      }, {
        title: 'Average Watch Time',
        description: 'How many seconds your video is viewed for.'
      }, {
        title: 'Average Views',
        description: 'Average views over the last 30 posts'
      }, {
        title: 'Average Likes',
        description: 'Average likes over the last 30 posts'
      }, {
        title: 'Average Comments',
        description: 'Average comments over the last 30 posts'
      }, {
        title: 'Live Date',
        description: 'Live Date'
      }, {
        title: 'Post URL',
        description: 'Post URL'
      }, {
        title: 'Engagement Rate by Interactions',
        description: 'Followers divided by total interactions for this campaign'
      }, {
        title: 'Average Engagement Rate',
        description: 'Average engagement for all advertorials and organic content'
      }, {
        title: 'Median Engagement Rate',
        description: 'Distrubution by engagement rate for influencers having followers in the similar range/tier'
      }],
      items: [],
      posts: this.posts
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredItems: function filteredItems() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (item) {
        if (item.groupID === _this.selectedGroup) return true;
        if (Array.isArray(item.reports)) {
          return item.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.tikTokAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.showHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.text === field.label;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredItems.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredItems.map(function (item) {
        views += item.views ? Number(item.views) : 0;
      });
      return views.toFixed(2);
    },
    totalBookmarks: function totalBookmarks() {
      var bookmarks = 0;
      this.filteredItems.map(function (item) {
        bookmarks += item.saved ? Number(item.saved) : 0;
      });
      return bookmarks;
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredItems.map(function (item) {
        interactions += item.interactions ? Number(item.interactions) : 0;
      });
      return interactions;
    },
    totalLikes: function totalLikes() {
      var likes = 0;
      this.filteredItems.map(function (item) {
        likes += item.likes ? Number(item.likes) : 0;
      });
      return likes;
    },
    totalComments: function totalComments() {
      var comments = 0;
      this.filteredItems.map(function (item) {
        comments += item.comments ? Number(item.comments) : 0;
      });
      return comments;
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredItems.map(function (item) {
        shares += item.shares ? Number(item.shares) : 0;
      });
      return shares;
    },
    totalReach: function totalReach() {
      var reach = 0;
      this.filteredItems.map(function (item) {
        reach += item.reach ? Number(item.reach) : 0;
      });
      return reach;
    },
    totalImpressions: function totalImpressions() {
      var impressions = 0;
      this.filteredItems.map(function (item) {
        impressions += item.impressions ? Number(item.impressions) : 0;
      });
      return impressions;
    },
    totalPlays: function totalPlays() {
      var plays = 0;
      this.filteredItems.map(function (item) {
        plays += item.plays ? Number(item.plays) : 0;
      });
      return plays.toFixed(2);
    },
    totalWatches: function totalWatches() {
      var watches = 0;
      this.filteredItems.map(function (item) {
        watches += item.watches ? Number(item.watches) : 0;
      });
      return watches.toFixed(2);
    },
    totalEngagementRate: function totalEngagementRate() {
      var totalEng = 0;
      this.filteredItems.map(function (item) {
        totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
      });
      return this.filteredItems.length ? (totalEng / this.filteredItems.length).toFixed(2) : 0;
    },
    totalInteractionRatePlays: function totalInteractionRatePlays() {
      var totalEng = 0;
      this.filteredItems.map(function (item) {
        totalEng += item.interaction_rate_plays ? parseFloat(item.interaction_rate_plays) : 0;
      });
      return this.filteredItems.length ? (totalEng / this.filteredItems.length).toFixed(2) : 0;
    },
    totalEngRateTotalViewers: function totalEngRateTotalViewers() {
      var totalEng = 0;
      this.filteredItems.map(function (item) {
        totalEng += item.eng_rate_total_viewers ? parseFloat(item.eng_rate_total_viewers) : 0;
      });
      return this.filteredItems.length ? (totalEng / this.filteredItems.length).toFixed(2) : 0;
    },
    totalEngagementRateView: function totalEngagementRateView() {
      var totalEng = 0;
      this.filteredItems.map(function (item) {
        totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0;
      });
      return this.filteredItems.length ? (totalEng / this.filteredItems.length).toFixed(2) : 0;
    },
    totalAvgViews: function totalAvgViews() {
      var avgViews = 0;
      this.filteredItems.map(function (item) {
        avgViews += item.avg_views ? item.avg_views : 0;
      });
      return avgViews;
    },
    totalAvgLikes: function totalAvgLikes() {
      var avgLikes = 0;
      this.filteredItems.map(function (item) {
        avgLikes += item.avg_likes ? item.avg_likes : 0;
      });
      return avgLikes;
    },
    totalAvgComments: function totalAvgComments() {
      var avgComments = 0;
      this.filteredItems.map(function (item) {
        avgComments += item.avg_comments ? item.avg_comments : 0;
      });
      return avgComments;
    },
    totalPlayTime: function totalPlayTime() {
      return __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignHelper__["a" /* default */].calculateTotalPlayTime(this.filteredItems);
    },
    totalWatchedFullVideo: function totalWatchedFullVideo() {
      var totalData = 0;
      this.filteredItems.map(function (item) {
        totalData += item.watchedFullVideo ? parseFloat(item.watchedFullVideo) : 0;
      });
      return this.filteredItems.length ? (totalData / this.filteredItems.length).toFixed(2) : 0;
    },
    totalPhotoViews: function totalPhotoViews() {
      var totalData = 0;
      this.filteredItems.map(function (item) {
        totalData += item.photo_views ? Number(item.photo_views) : 0;
      });
      return totalData;
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    profileUrl: function profileUrl(item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_reportPlatform__["b" /* getReportProfileUrl */])(item, 'tiktok');
    },

    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_14__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateLegend: function updateLegend() {
      var _this4 = this;

      var filteredLegend = this.rightSection.filter(function (element) {
        var s = _this4.campaign.tikTokAnalysisStatus;
        if (!s.showEngagement && element.title === 'Engagement Rate by Interactions') return false;
        if (!s.showAvgEngagement && element.title === 'Average Engagement Rate') return false;
        if (!s.showMediaEngagement && element.title === 'Median Engagement Rate') return false;
        if (!s.showViews && element.title === 'Views') return false;
        if (!s.likes && element.title === 'Likes') return false;
        if (!s.comments && element.title === 'Comments') return false;
        if (!s.showBookmarks && element.title === 'Bookmarks') return false;
        if (!s.shares && element.title === 'Shares') return false;
        if (!s.showReach && element.title === 'Reach') return false;
        if (!s.showImpressions && element.title === 'Impressions') return false;
        if (!s.showPlays && element.title === 'Total Play Time') return false;
        if (!s.showWatches && element.title === 'Average Watch Time') return false;
        if (!s.avgViews && element.title === 'Average Views') return false;
        if (!s.avgLikes && element.title === 'Average Likes') return false;
        if (!s.avgComments && element.title === 'Average Comments') return false;
        if (!s.liveDate && element.title === 'Live Date') return false;
        if (!s.url && element.title === 'Post URL') return false;
        return true;
      });
      this.tikTokLegends = filteredLegend;
    },
    updateTikTokAnalysisStatus: function updateTikTokAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.updateColumnsStatus(items, 'tikTokAnalysisStatus', 'colSettingsDialog');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    showTikTokPlayTime: function showTikTokPlayTime(time) {
      return __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignHelper__["a" /* default */].showTikTokPlayTime(time);
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializeTikTokAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializeTikTokAnalysisTableCols: function initializeTikTokAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.showHideFields, this.campaign.tikTokAnalysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this6.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context3.prev = 3;
                _context3.next = 6;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this6.campaign[campaignDataProp] = newStatusObject;
                _this6[dialogProp] = false;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.error('Error updating campaign settings:', _context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 10]]);
      }))();
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('tiktok-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_8_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'tiktok-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    }
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Campaign_campaignAPIs__ = __webpack_require__(16);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_story_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_9__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_10__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      storyLegends: [],
      selectedGroup: null,
      colSettingsDialog: false,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      headers: [{ text: 'Influencer', align: 'start', sortable: false, value: 'name' }, { text: 'Live Date', value: 'live_date', legendText: 'Live Date' }, { text: 'Audience Size', value: 'outreach', legendText: 'The number of followers the creator has at the time where the post was made ' }, { text: 'Views', value: 'views', legendText: 'The number of views.' }, { text: 'Average Watch Time', value: 'watches', legendText: 'How many seconds your video is viewed for' }, { text: 'Likes', value: 'like_count', legendText: 'The total number of likes' }, { text: 'Saves', value: 'bookmarks', legendText: 'The number of saves.' }, { text: 'Comments', value: 'comment_count', legendText: 'The number of comments.' }, { text: 'Shares', value: 'shares', legendText: 'The number of times users have reposted / shared a story.' }, { text: 'Interactions', value: 'interactions', legendText: 'The sum of likes, comments, saves, shares' }],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'showViews', label: 'Views' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showLikes', label: 'Likes' }, { name: 'showBookmarks', label: 'Saves' }, { name: 'showComments', label: 'Comments' }, { name: 'showShares', label: 'Shares' }, { name: 'showInteractions', label: 'Interactions' }],
      storyRightSection: [{ title: 'Live Date', description: 'Live Date' }, { title: 'Audience Size', description: 'Audience size (followers at post time)' }, { title: 'Shares', description: 'Number of times story was shared' }, { title: 'Replies', description: 'Number of replies to photo or video in your stories' }, { title: 'Links Click', description: 'Number of people who swipe up on a story to follow a link' }, { title: 'Sticker Taps', description: 'Number of times users interacted with the stickers/handle' }, { title: 'Reach', description: 'Number of unique user that seen your content' }, { title: 'Impressions', description: 'Total number of times content have been shown to users' }, { title: 'Average Views', description: 'Average views over the last 30 posts' }, { title: 'Average Reels Plays', description: 'Average plays over the last 30 posts' }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredItems: function filteredItems() {
      var _this = this;

      if (!this.selectedGroup) return this.sortedPosts;
      return this.sortedPosts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.xhsAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      var _loop = function _loop(statusKey) {
        if (Object.prototype.hasOwnProperty.call(status, statusKey)) {
          var isVisible = status[statusKey];
          if (isVisible) {
            var field = _this2.showHideFields.find(function (f) {
              return f.name === statusKey;
            });
            if (field) {
              var header = _this2.headers.find(function (h) {
                return h.text === field.label;
              });
              if (header) {
                finalHeaders.push(header);
              }
            } else {
              var _header = _this2.headers.find(function (h) {
                return h.value === statusKey;
              });
              if (_header) {
                finalHeaders.push(_header);
              }
            }
          }
        }
      };

      for (var statusKey in status) {
        _loop(statusKey);
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredItems.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalLikes: function totalLikes() {
      var likeCount = 0;
      this.filteredItems.map(function (item) {
        likeCount += item.like_count ? Number(item.like_count) : 0;
      });
      return likeCount;
    },
    totalComments: function totalComments() {
      var commentCount = 0;
      this.filteredItems.map(function (item) {
        commentCount += item.comment_count ? Number(item.comment_count) : 0;
      });
      return commentCount;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredItems.map(function (item) {
        views += item.views ? Number(item.views) : 0;
      });
      return views;
    },
    totalWatches: function totalWatches() {
      var watches = 0;
      this.filteredItems.map(function (item) {
        watches += item.watches ? Number(item.watches) : 0;
      });
      return watches.toFixed(2);
    },
    totalShares: function totalShares() {
      var shares = 0;
      this.filteredItems.map(function (item) {
        shares += item.shares ? Number(item.shares) : 0;
      });
      return shares;
    },
    totalBookmarks: function totalBookmarks() {
      var bookmarks = 0;
      this.filteredItems.map(function (item) {
        bookmarks += item.bookmarks ? Number(item.bookmarks) : 0;
      });
      return bookmarks;
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredItems.map(function (item) {
        interactions += item.interactions ? Number(item.interactions) : 0;
      });
      return interactions;
    }
  },
  mounted: function mounted() {
    this.updateLegend();
  },

  methods: {
    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_14__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateLegend: function updateLegend() {
      var _this4 = this;

      var filteredLegend = this.storyRightSection.filter(function (s) {
        var xhsAnalysisStatus = _this4.campaign.xhsAnalysisStatus;
        if (!xhsAnalysisStatus.showShares && s.title === 'Shares') return false;
        if (!xhsAnalysisStatus.showReplies && s.title === 'Replies') return false;
        if (!xhsAnalysisStatus.showLinkClicks && s.title === 'Links Click') return false;
        if (!xhsAnalysisStatus.showStickerTaps && s.title === 'Sticker Taps') return false;
        if (!xhsAnalysisStatus.showReach && s.title === 'Reach') return false;
        if (!xhsAnalysisStatus.showImpressions && s.title === 'Impressions') return false;
        if (!xhsAnalysisStatus.liveDate && s.title === 'Live Date') return false;
        if (!xhsAnalysisStatus.showAvgViews && s.title === 'Average Views') return false;
        if (!xhsAnalysisStatus.showAvgReelsPlays && s.title === 'Average Reels Plays') return false;
        return true;
      });
      this.storyLegends = filteredLegend;
    },
    updatexhsAnalysisStatus: function updatexhsAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.updateColumnsStatus(items, 'xhsAnalysisStatus', 'colSettingsDialog');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      this.initializeXhsAnalysisTableCols();
      this.colSettingsDialog = true;
    },
    initializeXhsAnalysisTableCols: function initializeXhsAnalysisTableCols() {
      this.tableColsItems = __WEBPACK_IMPORTED_MODULE_12__views_Campaign_campaignHelper__["a" /* default */].getOrderedColumns(this.showHideFields, this.campaign.xhsAnalysisStatus, this.defaultCols);
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                  id: _this6.campaign.id
                }, campaignDataProp, newStatusObject))];
                _context3.prev = 3;
                _context3.next = 6;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this6.campaign[campaignDataProp] = newStatusObject;
                _this6[dialogProp] = false;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.error('Error updating ' + campaignDataProp + ':', _context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 10]]);
      }))();
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('xhs-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_8_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'xhs-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignAPIs__ = __webpack_require__(16);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_tiktok_summary',
  props: ['posts', 'campaign', 'defaultCols', 'isInternalView'],
  components: {
    LegendSection: __WEBPACK_IMPORTED_MODULE_10__Legend___default.a,
    LegendIcon: __WEBPACK_IMPORTED_MODULE_11__LegendIcon___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default.a
  },
  data: function data() {
    return {
      page: 1,
      sortBy: 'live_date',
      sortDesc: true,
      dataTableKey: 0,
      disableSaveArrange: true,
      lineUpItems: [],
      panel: [0, 1],
      tikTokLegends: [],
      selectedGroup: null,
      colSettingsDialog: false,
      tableColsItems: [],
      editPostOrder: false,
      originalPosts: [],
      showHideFields: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'showViews', label: 'Total Views' }, { name: 'likes', label: 'Likes' }, { name: 'comments', label: 'Comments' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'avgViews', label: 'Average Views' }, { name: 'avgLikes', label: 'Average Likes' }, { name: 'avgComments', label: 'Average Comments' }, { name: 'showEngagement', label: 'Engagement Rate by Interactions' }, { name: 'showEngagementView', label: 'Engagement Rate by Views' }, { name: 'showAvgEngagement', label: 'Average Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }],
      headers: [{ text: 'Influencer', align: 'start', sortable: false, value: 'name' }, { text: 'Live Date', value: 'live_date', legendText: 'Live Date' }, { text: 'Post URL', value: 'url', legendText: 'Post URL' }, { text: 'Audience Size', value: 'outreach' }, { text: 'Total Views', value: 'views', legendText: 'Number of views' }, { text: 'Likes', value: 'likes', legendText: 'Number of likes' }, { text: 'Comments', value: 'comments', legendText: 'Number of comments' }, { text: 'Interactions', value: 'interactions', legendText: 'The sum of likes, comments, saves, shares' }, { text: 'Average Views', value: 'avg_views', legendText: 'Average views over the last 30 posts' }, { text: 'Average Likes', value: 'avg_likes', legendText: 'Average likes over the last 30 posts' }, { text: 'Average Comments', value: 'avg_comments', legendText: 'Average comments over the last 30 posts' }, { text: 'Engagement Rate by Interactions', value: 'new_engagement_rate', legendText: 'The total number of interactions divided by the subscriber numbers' }, { text: 'Engagement Rate by Views', value: 'new_engagement_rate_view', legendText: 'The total number of views divided by the subscriber numbers' }, { text: 'Average Engagement Rate', value: 'engagement_rate_sd', legendText: 'Average engagement for all advertorials and organic content' }, { text: 'Median Engagement Rate', value: 'median_engagement_rate', legendText: 'Distribution by engagement rate for influencers having followers in the similar range/tier' }],
      rightSection: [{ title: 'Likes', description: 'Number of likes' }, { title: 'Comments', description: 'Number of comments' }, { title: 'Average Views', description: 'Average views over the last 30 posts' }, { title: 'Average Likes', description: 'Average likes over the last 30 posts' }, { title: 'Average Comments', description: 'Average comments over the last 30 posts' }, { title: 'Live Date', description: 'Live Date' }, { title: 'Post URL', description: 'Post URL' }, { title: 'Engagement Rate by Interactions', description: 'Followers divided by total interactions for this campaign' }, { title: 'Average Engagement Rate', description: 'Average engagement for all advertorials and organic content' }, { title: 'Median Engagement Rate', description: 'Distrubution by engagement rate for influencers having followers in the similar range/tier' }]
    };
  },

  computed: {
    sortedPosts: function sortedPosts() {
      return this.posts;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    groups: function groups() {
      var groupMap = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a();
      this.sortedPosts.forEach(function (post) {
        if (post.groupID && post.groupName) {
          groupMap.set(post.groupID, post.groupName);
        }
        if (Array.isArray(post.reports)) {
          post.reports.forEach(function (report) {
            if (report.groupID && report.groupName) {
              groupMap.set(report.groupID, report.groupName);
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(groupMap, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            groupID = _ref2[0],
            groupName = _ref2[1];

        return {
          groupID: groupID,
          groupName: groupName
        };
      });
    },
    filteredPosts: function filteredPosts() {
      var _this = this;

      if (!this.selectedGroup) return this.posts;
      return this.posts.filter(function (post) {
        if (post.groupID === _this.selectedGroup) return true;
        if (Array.isArray(post.reports)) {
          return post.reports.some(function (report) {
            return report.groupID === _this.selectedGroup;
          });
        }
        return false;
      });
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var status = this.campaign.youtubeAnalysisStatus || {};
      var finalHeaders = [];

      var nameHeader = this.headers.find(function (h) {
        return h.value === 'name';
      });
      if (nameHeader) {
        finalHeaders.push(nameHeader);
      }

      for (var statusKey in status) {
        if (status[statusKey]) {
          (function () {
            var headerKey = statusKey.replace('show', '').toLowerCase();
            var foundHeader = void 0;

            if (headerKey === 'engagement') {
              foundHeader = _this2.headers.find(function (h) {
                return h.value === 'new_engagement_rate';
              });
            } else if (headerKey === 'engagementview') {
              foundHeader = _this2.headers.find(function (h) {
                return h.value === 'new_engagement_rate_view';
              });
            } else if (headerKey === 'avgengagement') {
              foundHeader = _this2.headers.find(function (h) {
                return h.value === 'engagement_rate_sd';
              });
            } else if (headerKey === 'mediaengagement') {
              foundHeader = _this2.headers.find(function (h) {
                return h.value === 'median_engagement_rate';
              });
            } else if (headerKey === 'livedate') {
              foundHeader = _this2.headers.find(function (h) {
                return h.value === 'live_date';
              });
            } else {
              foundHeader = _this2.headers.find(function (h) {
                return h.value.toLowerCase() === headerKey;
              });
            }

            if (foundHeader) {
              finalHeaders.push(foundHeader);
            }
          })();
        }
      }
      return finalHeaders;
    },
    totalOutreach: function totalOutreach() {
      var outreach = 0;
      this.filteredPosts.map(function (item) {
        outreach += item.outreach ? Number(item.outreach) : 0;
      });
      return outreach;
    },
    totalViews: function totalViews() {
      var views = 0;
      this.filteredPosts.map(function (item) {
        views += item.views ? Number(item.views) : 0;
      });
      return views;
    },
    totalLikes: function totalLikes() {
      var likes = 0;
      this.filteredPosts.map(function (item) {
        likes += item.likes ? Number(item.likes) : 0;
      });
      return likes;
    },
    totalComments: function totalComments() {
      var comments = 0;
      this.filteredPosts.map(function (item) {
        comments += item.comments ? Number(item.comments) : 0;
      });
      return comments;
    },
    totalInteractions: function totalInteractions() {
      var interactions = 0;
      this.filteredPosts.map(function (item) {
        interactions += item.interactions ? Number(item.interactions) : 0;
      });
      return interactions;
    },
    totalEngagementRate: function totalEngagementRate() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalEngagementRateView: function totalEngagementRateView() {
      var totalEng = 0;
      this.filteredPosts.map(function (item) {
        totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0;
      });
      return this.filteredPosts.length ? (totalEng / this.filteredPosts.length).toFixed(2) : 0;
    },
    totalAvgViews: function totalAvgViews() {
      var avgViews = 0;
      this.filteredPosts.map(function (item) {
        avgViews += item.avg_views ? Number(item.avg_views) : 0;
      });
      return avgViews;
    },
    totalAvgLikes: function totalAvgLikes() {
      var avgLikes = 0;
      this.filteredPosts.map(function (item) {
        avgLikes += item.avg_likes ? Number(item.avg_likes) : 0;
      });
      return avgLikes;
    },
    totalAvgComments: function totalAvgComments() {
      var avgComments = 0;
      this.filteredPosts.map(function (item) {
        avgComments += item.avg_comments ? Number(item.avg_comments) : 0;
      });
      return avgComments;
    }
  },
  mounted: function mounted() {},

  methods: {
    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0 || !this.showRequiredActions()) {
        return;
      }

      if (!this.editPostOrder) {
        this.originalPosts = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.posts));
      }

      var itemsPerPage = 15;
      var oldIndex = (this.page - 1) * itemsPerPage + event.oldIndex;
      var newIndex = (this.page - 1) * itemsPerPage + event.newIndex;
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.sortedPosts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = group.reports;
        }
      } else {
        tmpPosts = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], this.sortedPosts);
      }
      var movedItem = tmpPosts.splice(oldIndex, 1)[0];
      tmpPosts.splice(newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.sortedPosts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], tmpPosts);
      this.disableSaveArrange = false;
      this.editPostOrder = true;
    },
    savePostOrder: function savePostOrder() {
      this.updateLineUp();
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    cancelPostOrder: function cancelPostOrder() {
      this.posts = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.originalPosts));
      this.lineUpItems = [];
      this.disableSaveArrange = true;
      this.editPostOrder = false;
      this.originalPosts = [];
    },
    updateLineUp: function updateLineUp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    data.posts = item.reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_15__views_Campaign_campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateYoutubeAnalysisStatus: function updateYoutubeAnalysisStatus(items) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var columns, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                columns = _this4.campaign.youtubeAnalysisStatus || {};

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                data = [__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                  id: _this4.campaign.id,
                  youtubeAnalysisStatus: columns
                })];
                _context2.next = 5;
                return _this4.$store.dispatch('campaign/updateCampaignByIds', data);

              case 5:
                _this4.colSettingsDialog = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    showRequiredActions: function showRequiredActions() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false;
      } else {
        return __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
      }
    },
    openColSettingsModal: function openColSettingsModal() {
      var _this5 = this;

      this.tableColsItems = [];
      var tmpStatuses = {};
      this.showHideFields.map(function (header) {
        tmpStatuses[header.name] = true;
      });
      tmpStatuses = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, tmpStatuses, this.campaign.youtubeAnalysisStatus);

      var _loop = function _loop(key, value) {
        var header = _this5.showHideFields.find(function (item) {
          return item.name === key;
        });
        if (header) {
          _this5.tableColsItems.push({
            title: header.label,
            key: key,
            value: value
          });
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(tmpStatuses)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var key = _ref4[0];
          var value = _ref4[1];

          _loop(key, value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    downloadSummary: function downloadSummary() {
      var element = document.getElementById('youtube-analysis-summary');
      __WEBPACK_IMPORTED_MODULE_9_html2canvas___default()(element).then(function (canvas) {
        var link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'youtube-analysis-summary.png';
        link.click();
      });
    },
    refreshReportInf: function refreshReportInf(id) {
      this.$emit('refreshReportInf', id);
    }
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aos__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_aos_dist_aos_css__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_aos_dist_aos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_aos_dist_aos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__posts__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__posts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__posts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CampaignSummary__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CampaignSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CampaignSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PostSummary__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PostSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__PostSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReelSummary__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ReelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StorySummary__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StorySummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__StorySummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TiktokSummary__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TiktokSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__TiktokSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__YoutubeSummary__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__YoutubeSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__YoutubeSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FbSummary__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FbSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__FbSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__XHSSummary__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__XHSSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__XHSSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LemonSummary__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LemonSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__LemonSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__performance__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__performance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__performance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ReportLoginModal__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ReportLoginModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ReportLoginModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_Kobe_Logo_Green_png__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_Kobe_Logo_Green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_Kobe_Logo_Green_png__);






























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Reports',
  components: {
    ReportLoginModal: __WEBPACK_IMPORTED_MODULE_21__ReportLoginModal___default.a,
    posts: __WEBPACK_IMPORTED_MODULE_9__posts___default.a,
    CampaignSummary: __WEBPACK_IMPORTED_MODULE_10__CampaignSummary___default.a,
    PostSummary: __WEBPACK_IMPORTED_MODULE_11__PostSummary___default.a,
    ReelSummary: __WEBPACK_IMPORTED_MODULE_12__ReelSummary___default.a,
    StorySummary: __WEBPACK_IMPORTED_MODULE_13__StorySummary___default.a,
    TiktokSummary: __WEBPACK_IMPORTED_MODULE_14__TiktokSummary___default.a,
    YoutubeSummary: __WEBPACK_IMPORTED_MODULE_15__YoutubeSummary___default.a,
    FbSummary: __WEBPACK_IMPORTED_MODULE_16__FbSummary___default.a,
    XhsSummary: __WEBPACK_IMPORTED_MODULE_17__XHSSummary___default.a,
    LemonSummary: __WEBPACK_IMPORTED_MODULE_18__LemonSummary___default.a,
    campaignPerformance: __WEBPACK_IMPORTED_MODULE_19__performance___default.a
  },
  data: function data() {
    return {
      campaignID: '',
      passcode: '',
      kobeGreenLogo: __WEBPACK_IMPORTED_MODULE_25__assets_Kobe_Logo_Green_png___default.a,
      loginModalDialog: false,
      reportData: { campaign: null },
      postsAnalysisData: [],
      reelAnalysisData: [],
      storyAnalysisData: [],
      tikTokAnalysisData: [],
      youtubeAnalysisData: [],
      xhsAnalysisData: [],
      lemonAnalysisData: [],
      fbAnalysisData: [],
      linkedInAnalysisData: [],
      twitterAnalysisData: [],
      allPosts: [],
      campaignPosts: [],
      defaultPostsAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showEngagement: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false
      },
      defaultReelAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: true,
        showPlays: false,
        showWatches: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultStoryAnalysisStatus: {
        liveDate: false,
        outreach: true,
        showReach: false,
        showImpressions: true,
        showStoryLikes: true,
        showReplies: true,
        showShares: true,
        showLinkClicks: true,
        showStickerTaps: true,
        showInteractions: false,
        showNewEngagementRate: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultTikTokAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showPlays: true,
        showWatches: true,
        likes: true,
        comments: true,
        shares: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: false,
        showReach: false,
        showImpressions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        avgSaves: false,
        avgShares: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateTotalViewers: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showWatchedFullVideo: false,
        showPhotoViews: false
      },
      defaultYoutubeAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showViews: true,
        likes: true,
        comments: true,
        showInteractions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        showEngagement: true,
        showEngagementView: false,
        showAvgEngagement: false,
        showMediaEngagement: false
      },
      defaultPerformanceAnalysisStatus: {
        totalContents: true,
        totalOutreach: true,
        contents: true,
        outreach: true,
        interactions: true,
        outreachImpressions: true,
        postEngRate: false,
        reelEngRate: false,
        tiktokEngRate: false,
        youtubeEngRate: false,
        postEngRateView: false,
        reelEngRateView: false,
        tiktokEngRateView: false,
        youtubeEngRateView: false,
        industryBenchmark: false
      },
      defaultXHSAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultLemonAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultFbAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showLikes: true,
        showComments: true,
        showViews: true,
        showShares: true,
        showBookmarks: false,
        showInteractions: false
      },
      defaultLinkedInAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showReach: true,
        showVideoViews: true,
        showProfileViewers: true,
        showLikes: true,
        showComments: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      defaultTwitterAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showComments: true,
        showLikes: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      drawer: true,
      items: [{ title: 'Home', icon: 'mdi-home-city' }, { title: 'My Account', icon: 'mdi-account' }, { title: 'Users', icon: 'mdi-account-group-outline' }],
      mini: true,
      infiniteId: +new Date(),
      page: 1
    };
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      if (this.$store.state.token && this.$store.state.token !== 'null' && this.$store.state.user) {
        return true;
      }
      return false;
    },
    formatedCurrentDate: function formatedCurrentDate() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(Date.now()).format('MMM - DD, yyyy');
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_6_aos___default.a.init();
    window.onscroll = function () {
      setTimeout(function () {
        var favBtn = document.getElementById('goTop');

        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 800) {
          favBtn.style.display = 'block';
        } else {
          favBtn.style.display = 'none';
        }
      }, 500);
    };
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.$route.query).length === 0) {
      this.$swal({
        type: 'error',
        title: 'Invalid ID',
        text: 'Please Reload with a valid ID'
      });
    } else {
      this.campaignID = this.$route.query.id;
      if (this.isLoggedIn) {
        this.clearReportAuthLocalStorage();
        this.getCampaignReport();
      } else {
        this.checkPasscodeLoggedIn();
      }
    }
  },

  watch: {
    reportData: function reportData(newData) {
      this.reportData = newData;
    }
  },
  methods: {
    scrollTopFunction: function scrollTopFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getCampaignReport: function getCampaignReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var force, campaignID, response, respData, campaign, settings, _posts, typeOrder, grandOutreach, grandEngagement, totalImpressions;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                force = false;
                campaignID = _this.$route.query.id;

                _this.isLoading = true;
                _context.prev = 3;
                response = void 0;

                if (!_this.isLoggedIn) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_20__views_Campaign_campaignAPIs__["a" /* default */].generateCampaignReport(campaignID, null, force);

              case 8:
                response = _context.sent;
                _context.next = 14;
                break;

              case 11:
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_20__views_Campaign_campaignAPIs__["a" /* default */].generateCampaignHTMLReport(campaignID, _this.passcode, null, force);

              case 13:
                response = _context.sent;

              case 14:
                if (response.success) {
                  respData = response.data;
                  campaign = {};

                  campaign.id = respData.campaign_details.id;
                  campaign.name = respData.campaign_details.name;
                  campaign.campaignType = respData.campaign_details.campaignType;
                  campaign.objectives = respData.campaign_details.goal;
                  campaign.deliverables = ['Total ' + respData.summary.contents + ' contents'];
                  campaign.angles = respData.campaign_details.angles ? __WEBPACK_IMPORTED_MODULE_22__views_Campaign_campaignHelper__["a" /* default */].fixAnglesData(respData.campaign_details.angles) : [];
                  campaign.segment = respData.campaign_details.segment || __WEBPACK_IMPORTED_MODULE_22__views_Campaign_campaignHelper__["a" /* default */].getDefaultSegments();
                  campaign.lineUp = respData.campaign_details.lineUp || [];
                  settings = respData.campaign_details.settings || {};

                  campaign.enablePostAnalysis = settings.enablePostAnalysis !== false;
                  campaign.enableReelAnalysis = settings.enableReelAnalysis !== false;
                  campaign.enableTikTokAnalysis = settings.enableTikTokAnalysis !== false;
                  campaign.enableYoutubeAnalysis = settings.enableYoutubeAnalysis !== false;
                  campaign.enableFbAnalysis = settings.enableFbAnalysis !== false;
                  campaign.enableLinkedInAnalysis = settings.enableLinkedInAnalysis !== false;
                  campaign.enableTwitterAnalysis = settings.enableTwitterAnalysis !== false;
                  campaign.enableXHSAnalysis = settings.enableXHSAnalysis !== false;
                  campaign.enableLemonAnalysis = settings.enableLemonAnalysis !== false;
                  campaign.enableOverallSection = respData.campaign_details.settings ? respData.campaign_details.settings.enableOverallSection : false;
                  campaign.postAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultPostsAnalysisStatus, respData.campaign_details.postAnalysisStatus || {});
                  campaign.reelAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultReelAnalysisStatus, respData.campaign_details.reelAnalysisStatus || {});
                  campaign.storyAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultStoryAnalysisStatus, respData.campaign_details.storyAnalysisStatus || {});
                  campaign.tikTokAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultTikTokAnalysisStatus, respData.campaign_details.tikTokAnalysisStatus || {});
                  campaign.youtubeAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultYoutubeAnalysisStatus, respData.campaign_details.youtubeAnalysisStatus || {});
                  campaign.performanceAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultPerformanceAnalysisStatus, respData.campaign_details.performanceAnalysisStatus || {});
                  campaign.fbAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultFbAnalysisStatus, respData.campaign_details.fbAnalysisStatus || {});
                  campaign.linkedInAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultLinkedInAnalysisStatus, respData.campaign_details.linkedInAnalysisStatus || {});
                  campaign.twitterAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultTwitterAnalysisStatus, respData.campaign_details.twitterAnalysisStatus || {});
                  campaign.xhsAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultXHSAnalysisStatus, respData.campaign_details.xhsAnalysisStatus || {});
                  campaign.lemonAnalysisStatus = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _this.defaultLemonAnalysisStatus, respData.campaign_details.lemonAnalysisStatus || {});
                  campaign.startDate = respData.campaign_details.startDate || '';
                  campaign.endDate = respData.campaign_details.endDate || '';
                  campaign.optionalRemarks = respData.campaign_details.optionalRemarks || '';
                  campaign.kpi = {
                    engagement: Number(respData.campaign_details.engagement),
                    outreach: Number(respData.campaign_details.outreach),
                    minContent: respData.campaign_details.min_content,
                    maxContent: respData.campaign_details.max_content,
                    content: respData.campaign_details.min_content + ' to ' + respData.campaign_details.max_content,
                    benchmarkTitle: respData.campaign_details.benchmark ? respData.campaign_details.benchmark.title : '-',
                    benchmarkValue: respData.campaign_details.benchmark ? respData.campaign_details.benchmark.value : '-'
                  };
                  campaign.summary = respData.summary;
                  campaign.client = {
                    name: respData.client.name,
                    logo: respData.client.logo
                  };
                  _posts = [];

                  respData.posts = respData.posts.map(function (post, index) {
                    if (post.reportGroup) {
                      post.panel = [0];
                      post.reports = post.reports.map(function (groupPost) {
                        groupPost = _this.calculatePostData(groupPost, index);
                        return groupPost;
                      });
                      _posts.push.apply(_posts, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(post.reports));
                    } else {
                      post = _this.calculatePostData(post, index);
                      _posts.push(post);
                    }
                    return post;
                  });

                  typeOrder = ['post/carousel', 'reel', 'story', 'tiktok', 'youtube', 'facebook', 'linkedin', 'twitter', 'xhs', 'lemon', 'gdrive', 'others'];

                  _this.campaignPosts = respData.posts.sort(function (a, b) {
                    var aType = a.reportGroup && a.reports && a.reports.length > 0 ? a.reports[0].type : a.type;
                    var bType = b.reportGroup && b.reports && b.reports.length > 0 ? b.reports[0].type : b.type;

                    var aTypeIndex = typeOrder.indexOf(aType);
                    var bTypeIndex = typeOrder.indexOf(bType);
                    var aOrder = aTypeIndex !== -1 ? aTypeIndex : 999;
                    var bOrder = bTypeIndex !== -1 ? bTypeIndex : 999;

                    if (aOrder !== bOrder) {
                      return aOrder - bOrder;
                    }

                    var aIndex = a.lineUpIndex !== undefined ? a.lineUpIndex : a.reports && a.reports[0] ? a.reports[0].lineUpIndex : 999999;
                    var bIndex = b.lineUpIndex !== undefined ? b.lineUpIndex : b.reports && b.reports[0] ? b.reports[0].lineUpIndex : 999999;
                    return aIndex - bIndex;
                  });

                  _this.reportData.campaign = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, campaign);

                  _this.postsAnalysisData = _posts.filter(function (post) {
                    return post.type !== 'story' && post.type !== 'tiktok' && post.type !== 'youtube' && post.type !== 'xhs' && post.type !== 'lemon' && post.type !== 'facebook' && post.type !== 'linkedin' && post.type !== 'twitter' && post.type !== 'gdrive' && post.type !== 'reel';
                  });
                  _this.postsAnalysisData.map(function (post) {
                    post.new_engagement_rate = Number(((post.likes + post.comments + post.saved + post.shares) / post.outreach * 100).toFixed(2));
                    post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                    post.engagement_rate_reach = Number(((post.likes + post.comments + post.saved + post.shares) / post.reach * 100).toFixed(2));
                    post.interactions = (post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0);
                  });
                  _this.postsAnalysisData = _this.postsAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.reelAnalysisData = _posts.filter(function (post) {
                    return post.type === 'reel';
                  });
                  _this.reelAnalysisData.map(function (post) {
                    post.interactions = Number(post.likes + post.comments + post.saved + post.shares);
                    post.new_engagement_rate = Number(((post.likes + post.comments + post.saved + post.shares) / post.outreach * 100).toFixed(2));
                    post.interaction_rate_plays = 0;
                    if (post.views) {
                      post.interaction_rate_plays = Number(((post.likes + post.comments + post.saved + post.shares) / Number(post.views) * 100).toFixed(2));
                    }
                    post.engagement_rate_reach = Number(((post.likes + post.comments + post.saved + post.shares) / Number(post.reach) * 100).toFixed(2));
                    post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                  });
                  _this.reelAnalysisData = _this.reelAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.tikTokAnalysisData = _posts.filter(function (post) {
                    return post.type === 'tiktok';
                  });
                  _this.tikTokAnalysisData.map(function (post) {
                    post.new_engagement_rate = (((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / (post.outreach || 0) * 100).toFixed(2);
                    post.interactions = Number((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0));
                    post.interaction_rate_plays = 0;
                    post.eng_rate_total_viewers = 0;
                    if (post.views) {
                      post.interaction_rate_plays = (((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / Number(post.views) * 100).toFixed(2);
                      post.eng_rate_total_viewers = (((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0)) / Number(post.reach) * 100).toFixed(2);
                    }
                    post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                  });
                  _this.tikTokAnalysisData = _this.tikTokAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.youtubeAnalysisData = _posts.filter(function (post) {
                    return post.type === 'youtube';
                  });
                  _this.youtubeAnalysisData.map(function (post) {
                    post.new_engagement_rate = (((post.likes || 0) + (post.comments || 0)) / (post.outreach || 0) * 100).toFixed(2);
                    post.new_engagement_rate_view = Number((post.views / post.outreach * 100).toFixed(2));
                    post.interactions = Number((post.likes || 0) + (post.comments || 0));
                  });
                  _this.youtubeAnalysisData = _this.youtubeAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.storyAnalysisData = _posts.filter(function (post) {
                    return post.type === 'story' || post.type === 'gdrive';
                  });
                  _this.storyAnalysisData.map(function (post) {
                    post.interactions = (post.shares || 0) + (post.replies || 0) + (post.link_clicks || 0) + (post.sticker_taps || 0) + (post.story_likes || 0);
                    post.new_engagement_rate = ((post.interactions || 0) / (post.outreach || 0) * 100).toFixed(2);
                  });
                  _this.storyAnalysisData = _this.storyAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.fbAnalysisData = _posts.filter(function (post) {
                    return post.type === 'facebook';
                  });
                  _this.fbAnalysisData.map(function (post) {
                    post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                  });
                  _this.fbAnalysisData = _this.fbAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.linkedInAnalysisData = _posts.filter(function (post) {
                    return post.type === 'linkedin';
                  });
                  _this.linkedInAnalysisData.map(function (post) {
                    post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.shares || 0);
                  });
                  _this.linkedInAnalysisData = _this.linkedInAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.twitterAnalysisData = _posts.filter(function (post) {
                    return post.type === 'twitter';
                  });
                  _this.twitterAnalysisData.forEach(function (post) {
                    post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                  });
                  _this.twitterAnalysisData = _this.twitterAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.xhsAnalysisData = _posts.filter(function (post) {
                    return post.type === 'xhs';
                  });
                  _this.xhsAnalysisData.map(function (post) {
                    post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                  });
                  _this.xhsAnalysisData = _this.xhsAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });

                  _this.lemonAnalysisData = _posts.filter(function (post) {
                    return post.type === 'lemon';
                  });
                  _this.lemonAnalysisData.map(function (post) {
                    post.interactions = (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                  });
                  _this.lemonAnalysisData = _this.lemonAnalysisData.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });
                  grandOutreach = 0;
                  grandEngagement = 0;
                  totalImpressions = 0;

                  _this.postsAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0);
                    totalImpressions += Number(post.impressions || 0);
                  });
                  _this.reelAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0);
                    totalImpressions += Number(post.impressions || 0) + Number(post.views || 0);
                  });
                  _this.tikTokAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0);
                    totalImpressions += Number(post.impressions || 0) + Number(post.views || 0);
                  });
                  _this.youtubeAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.likes || 0) + (post.comments || 0);
                    totalImpressions += Number(post.impressions || 0);
                  });
                  _this.storyAnalysisData.forEach(function (story) {
                    grandOutreach += story.outreach ? Number(story.outreach) : 0;
                    grandEngagement += (story.shares || 0) + (story.replies || 0) + (story.link_clicks || 0) + (story.sticker_taps || 0);
                    totalImpressions += Number(story.impressions || 0);
                  });
                  _this.xhsAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                    totalImpressions += Number(post.impressions || 0);
                  });
                  _this.lemonAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                    totalImpressions += Number(post.impressions || 0);
                  });
                  _this.fbAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                    totalImpressions += Number(post.impressions || 0);
                  });
                  _this.linkedInAnalysisData.forEach(function (post) {
                    grandEngagement += (post.like_count || 0) + (post.comment_count || 0) + (post.shares || 0);
                  });
                  _this.twitterAnalysisData.forEach(function (post) {
                    grandOutreach += post.outreach ? Number(post.outreach) : 0;
                    grandEngagement += (post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0);
                    totalImpressions += Number(post.views || 0);
                  });
                  _this.reportData.campaign.summary.engagement = grandEngagement;
                  _this.reportData.campaign.summary.outreach = grandOutreach;
                  _this.reportData.campaign.summary.outreachImpressions = Number(grandOutreach + totalImpressions);
                  _this.isLoading = false;
                }
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](3);

                _this.isLoading = false;
                console.error(_context.t0);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 17]]);
      }))();
    },
    calculatePostData: function calculatePostData(post, index) {
      var platform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_reportPlatform__["a" /* getReportPlatform */])(post);
      var postData = {};
      postData.id = post.id;
      postData.campaignID = post.campaignID;
      postData.key = index;
      postData.lineUpIndex = post.lineUpIndex;
      postData.groupID = post.groupID;
      postData.groupName = post.groupName;
      var profileOwner = post.owner || (post.post_details || {}).owner || {};
      postData.profileUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_reportPlatform__["b" /* getReportProfileUrl */])(post, platform || (post.isTikTok ? 'tiktok' : 'instagram'));
      postData.profilePlatform = post.profilePlatform || post.profile_platform || profileOwner.platform || (post.influencer_details || {}).platform || '';
      postData.profileHandle = post.profileHandle || post.profile_handle || (post.influencer_details || {}).instagramHandle || profileOwner.username || '';
      if (post.isCalculated) {
        return post;
      }
      if (!['linkedin', 'twitter'].includes(platform) && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isLemon && !post.isFacebook && !post.isOthers) {
        postData.name = post.post_details.owner.username;
        postData.url = post.post_details.link;
        postData.impressions = 0;
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
        postData.engagement_rate_sd = post.post_details.owner.engagement_rate_sd || null;
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
        if (post.postType === 'IGR') {
          postData.type = 'reel';
          postData.title = 'IG Reel';
        } else {
          postData.type = 'post/carousel';
          postData.title = 'IG Post';
        }

        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved;
          postData.shares = post.inputtedInsights.shares;
          postData.views = post.inputtedInsights.views || 0;
          postData.reach = post.inputtedInsights.reach || 0;
          postData.impressions = post.inputtedInsights.impressions || 0;
          postData.plays = post.inputtedInsights.plays || 0;
          postData.watches = post.inputtedInsights.watches ? __WEBPACK_IMPORTED_MODULE_22__views_Campaign_campaignHelper__["a" /* default */].parseWatchTime(post.inputtedInsights.watches) : 0;
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0;
          postData.shares = 0;
          postData.views = 0;
        }
      } else if (post.isStory && post.insights) {
        postData.name = post.owner.username;
        postData.outreach = post.owner.followers || post.owner.followers_sd;
        postData.title = 'IG Story';
        postData.url = post.media_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.engagement = Number(post.insights.engagement) || 0;
        postData.impressions = Number(post.insights.impressions) || 0;
        postData.story_likes = Number(post.insights.story_likes) || 0;
        postData.reach = Number(post.insights.reach) || 0;
        postData.replies = Number(post.insights.replies) || 0;
        postData.exits = Number(post.insights.exits) || 0;
        postData.taps_back = Number(post.insights.taps_back) || 0;
        postData.taps_forward = Number(post.insights.taps_forward) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.sticker_taps = Number(post.insights.sticker_taps) || 0;
        postData.link_clicks = Number(post.insights.link_clicks) || 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
        postData.type = 'story';
        postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1;
        postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps + postData.story_likes;
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.public_id = post.public_id || null;
      } else if (post.isTikTok) {
        postData.name = post.owner.username;
        postData.title = 'TikTok Post';
        postData.url = post.post_details.link;
        postData.shortCode = post.post_details.shortcode;
        postData.impressions = 0;
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.shares = post.currentInsight.shares || 0;
        postData.views = post.currentInsight.views || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null;
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_saves = post.avg_saves ? Number(post.avg_saves) : 0;
        postData.avg_shares = post.avg_shares ? Number(post.avg_shares) : 0;
        postData.type = 'tiktok';

        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved;
          if (postData.shares === 0) {
            postData.shares = post.inputtedInsights.shares;
          }
          if (postData.views === 0) {
            postData.views = post.inputtedInsights.views || 0;
          }
          postData.reach = post.inputtedInsights.reach || 0;
          postData.impressions = post.inputtedInsights.impressions || 0;
          postData.plays = post.inputtedInsights.plays || 0;
          postData.watches = post.inputtedInsights.watches ? __WEBPACK_IMPORTED_MODULE_22__views_Campaign_campaignHelper__["a" /* default */].parseWatchTime(post.inputtedInsights.watches) : 0;
          postData.watchedFullVideo = post.inputtedInsights.watchedFullVideo || 0;
          postData.photo_views = post.inputtedInsights.photo_views || 0;
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0;
          postData.shares = 0;
          postData.views = 0;
          postData.reach = 0;
          postData.impressions = 0;
          postData.plays = 0;
          postData.watches = 0;
          postData.watchedFullVideo = 0;
        }
      } else if (post.isYoutube) {
        postData.name = post.owner.username;
        postData.title = 'Youtube Post';
        postData.url = post.post_details.link;
        postData.shortCode = post.post_details.shortcode;
        postData.type = 'youtube';
        postData.impressions = 0;
        postData.engagement = post.currentInsight.engagement || 0;
        postData.reach = 0;
        postData.likes = post.currentInsight.like_count || 0;
        postData.comments = post.currentInsight.comment_count || 0;
        postData.views = post.currentInsight.views || 0;
        postData.outreach = post.currentInsight.outreach || 0;
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1;
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null;
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0;
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0;
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
      } else if (post.isFacebook && post.insights) {
        postData.name = post.owner.username;
        postData.outreach = post.owner.followers || post.owner.followers_sd;
        postData.title = 'Facebook';
        postData.url = post.media_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.outreach = Number(post.insights.outreach) || 0;
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.bookmarks) || 0;
        postData.type = 'facebook';
      } else if (post.isXHS && post.insights) {
        postData.name = post.owner.fullName || post.owner.username;
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd;
        postData.title = 'XHS';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.xhsLink = post.xhsLink || '';
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.watches = Number(post.insights.watches) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.bookmarks) || 0;
        postData.type = 'xhs';
        postData.isXHS = true;
      } else if (post.isLemon && post.insights) {
        postData.name = post.owner.fullName || post.owner.username;
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd;
        postData.title = 'Lemon8';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.lemonLink = post.lemonLink || '';
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.watches = Number(post.insights.watches) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.bookmarks) || 0;
        postData.type = 'lemon';
        postData.isLemon = true;
      } else if (platform === 'twitter' && post.insights) {
        var rawUrl = post.postLink || post.postURL || post.post_details || '';
        var latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
        var insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights;
        var insights = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});
        postData.name = post.owner.username || post.owner.fullName;
        postData.title = 'X (Twitter)';
        postData.url = typeof rawUrl === 'string' ? rawUrl : rawUrl.link || rawUrl.url || rawUrl.href || '';
        postData.outreach = Number(post.owner.followers || insights.outreach) || 0;
        postData.like_count = Number(insights.like_count) || 0;
        postData.comment_count = Number(insights.comment_count) || 0;
        postData.impressions = Number(insights.impressions != null ? insights.impressions : insights.views) || 0;
        postData.views = postData.impressions;
        postData.shares = Number(insights.shares) || 0;
        postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0;
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks;
        postData.type = 'twitter';
      } else if (platform === 'linkedin' && post.insights) {
        var _rawUrl = post.postLink || post.postURL || post.post_details || '';
        var _latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
        var _insightData = _latestInsight && _latestInsight.data ? _latestInsight.data : post.insights;
        var _insights = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _insightData || {}, post.currentInsight || {}, post.inputtedInsights || {});
        postData.name = post.owner.username || post.owner.fullName;
        postData.linkedinHandle = post.owner.linkedinHandle || post.owner.handle || post.owner.username;
        postData.linkedinURL = post.owner.linkedinURL || post.owner.linkedinUrl || post.owner.profileURL || post.owner.profileUrl || post.owner.profile_url || post.owner.linkedin && (post.owner.linkedin.linkedinURL || post.owner.linkedin.linkedinUrl || post.owner.linkedin.profileUrl || post.owner.linkedin.profile_url);
        postData.title = 'LinkedIn';
        postData.url = typeof _rawUrl === 'string' ? _rawUrl : _rawUrl.link || _rawUrl.url || _rawUrl.href || '';
        postData.like_count = Number(_insights.like_count) || 0;
        postData.comment_count = Number(_insights.comment_count) || 0;
        postData.impressions = Number(_insights.impressions) || 0;
        postData.reach = Number(_insights.reach != null ? _insights.reach : _insights.outreach) || 0;
        postData.video_views = Number(_insights.video_views) || 0;
        postData.profile_viewers = Number(_insights.profile_viewers) || 0;
        postData.shares = Number(_insights.shares) || 0;
        postData.bookmarks = Number(_insights.saved || _insights.bookmarks) || 0;
        postData.saved = postData.bookmarks;
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks;
        postData.type = 'linkedin';
      } else if (post.isOthers && post.insights) {
        postData.name = post.owner.fullName || post.owner.username;
        postData.outreach = Number(post.insights.outreach) || 0;
        postData.title = 'Others';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.embed_url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.postLink = post.postLink || '';
        postData.like_count = Number(post.insights.like_count) || 0;
        postData.comment_count = Number(post.insights.comment_count) || 0;
        postData.views = Number(post.insights.views) || 0;
        postData.watches = Number(post.insights.watches) || 0;
        postData.shares = Number(post.insights.shares) || 0;
        postData.bookmarks = Number(post.insights.saved) || 0;
        postData.plays = Number(post.insights.plays) || 0;
        postData.type = 'others';
        postData.isOthers = true;
      } else if (post.isMultipleContents) {
        postData.name = post.owner.username;
        postData.outreach = post.owner.followers || post.owner.followers_sd;
        postData.title = 'IG Story';
        postData.url = post.embed_url || 'https://app.getkobe.com/static/img/kobe_white.png';
        postData.type = 'gdrive';
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null;
        postData.public_id = post.public_id || null;
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0;
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0;
        if (post.insights) {
          postData.engagement = Number(post.insights.engagement) || 0;
          postData.impressions = Number(post.insights.impressions) || 0;
          postData.reach = Number(post.insights.reach) || 0;
          postData.replies = Number(post.insights.replies) || 0;
          postData.exits = Number(post.insights.exits) || 0;
          postData.taps_back = Number(post.insights.taps_back) || 0;
          postData.taps_forward = Number(post.insights.taps_forward) || 0;
          postData.shares = Number(post.insights.shares) || 0;
          postData.sticker_taps = Number(post.insights.sticker_taps) || 0;
          postData.link_clicks = Number(post.insights.link_clicks) || 0;
          postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1;
          postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps;
        }
      }
      postData.live_date = post.live_date ? __WEBPACK_IMPORTED_MODULE_24__utils__["a" /* default */].func.formatDate(post.live_date) : '-';
      postData.isCalculated = true;
      return postData;
    },
    loggedIn: function loggedIn(passcode) {
      this.loginModalDialog = false;
      this.passcode = passcode;
      this.addPasscodeToLocalStorage(this.passcode);
      this.getCampaignReport();
    },
    addPasscodeToLocalStorage: function addPasscodeToLocalStorage(passcode) {
      var campaignID = this.campaignID;
      var localPasscodeString = window.localStorage.getItem('reportauth') || 'null';
      var localPasscodes = localPasscodeString !== 'null' ? JSON.parse(localPasscodeString) : {};
      localPasscodes[campaignID] = passcode;
      localStorage.setItem('reportauth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localPasscodes));
    },
    removePasscodeFromLocalStorage: function removePasscodeFromLocalStorage(campaignID) {
      var localPasscodeString = window.localStorage.getItem('reportauth') || 'null';
      var localPasscodes = localPasscodeString !== 'null' ? JSON.parse(localPasscodeString) : {};
      delete localPasscodes[campaignID];
      localStorage.setItem('reportauth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localPasscodes));
    },
    checkPasscodeLoggedIn: function checkPasscodeLoggedIn() {
      var _this2 = this;

      this.isLoading = true;
      var campaignID = this.campaignID;
      var localPasscodeString = window.localStorage.getItem('reportauth') || 'null';
      var localPasscodes = localPasscodeString !== 'null' ? JSON.parse(localPasscodeString) : {};
      if (!localPasscodes.hasOwnProperty(campaignID)) {
        this.isLoading = false;
        this.loginModalDialog = true;
        return;
      }
      var passcode = '';
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(localPasscodes).forEach(function (key) {
        if (key === campaignID) {
          passcode = localPasscodes[key];
        }
      });
      __WEBPACK_IMPORTED_MODULE_20__views_Campaign_campaignAPIs__["a" /* default */].loginCampaignReport(campaignID, passcode).then(function (response) {
        if (response.success) {
          _this2.isLoading = false;
          _this2.loggedIn(passcode);
        }
      }).catch(function (error) {
        _this2.isLoading = false;
        _this2.removePasscodeFromLocalStorage(campaignID);
        _this2.loginModalDialog = true;
        _this2.$swal({
          title: 'Error',
          text: error.response && error.response.data && error.response.data.message || 'The saved passcode is no longer valid. Please enter it again.',
          type: 'error'
        });
        console.error(error);
      });
    },
    clearReportAuthLocalStorage: function clearReportAuthLocalStorage() {
      if (window.localStorage.getItem('reportauth')) {
        window.localStorage.removeItem('reportauth');
      }
    }
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rpt_campaign_per',
    components: {
        TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_TableColsShowHideModal___default.a
    },
    props: ['campaignID', 'summary', 'campaign', 'campaignKPI', 'posts', 'reels', 'tikTokPosts', 'youtubePosts'],
    data: function data() {
        return {
            editBenchmark: false,
            colSettingsDialog: false,
            tableColsItems: [],
            showHideFields: [{
                name: 'totalContents',
                label: 'Total Contents'
            }, {
                name: 'totalOutreach',
                label: 'Total Audience Size'
            }, {
                name: 'contents',
                label: 'Contents'
            }, {
                name: 'outreachImpressions',
                label: 'Audience Size Impressions'
            }, {
                name: 'outreach',
                label: 'Audience Size'
            }, {
                name: 'interactions',
                label: 'Interactions'
            }, {
                name: 'postEngRate',
                label: 'Post Engagement Rate by Interactions'
            }, {
                name: 'reelEngRate',
                label: 'Reel Engagement Rate by Interactions'
            }, {
                name: 'tiktokEngRate',
                label: 'TikTok Engagement Rate by Interactions'
            }, {
                name: 'youtubeEngRate',
                label: 'Youtube Engagement Rate by Interactions'
            }, {
                name: 'postEngRateView',
                label: 'Post Engagement Rate by Views'
            }, {
                name: 'reelEngRateView',
                label: 'Reel Engagement Rate by Views'
            }, {
                name: 'tiktokEngRateView',
                label: 'TikTok Engagement Rate by Views'
            }, {
                name: 'youtubeEngRateView',
                label: 'Youtube Engagement Rate by Views'
            }, {
                name: 'industryBenchmark',
                label: 'Industry Benchmark'
            }]
        };
    },

    computed: {
        totalEngagementRate: function totalEngagementRate() {
            var totalEng = 0;
            this.posts.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            var postEng = totalEng > 0 ? (totalEng / this.posts.length).toFixed(2) : 0;

            totalEng = 0;
            this.reels.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            var reelEng = totalEng > 0 ? (totalEng / this.reels.length).toFixed(2) : 0;

            totalEng = 0;
            this.tikTokPosts.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            var tikTokEng = totalEng > 0 ? (totalEng / this.tikTokPosts.length).toFixed(2) : 0;

            totalEng = 0;
            this.youtubePosts.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            var youtubeEng = totalEng > 0 ? (totalEng / this.youtubePosts.length).toFixed(2) : 0;
            return parseFloat(postEng) + parseFloat(reelEng) + parseFloat(tikTokEng) + parseFloat(youtubeEng);
        },
        totalAverageEngagementRate: function totalAverageEngagementRate() {
            var totalAvgEng = 0;
            this.posts.map(function (item) {
                totalAvgEng += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
            });
            this.reels.map(function (item) {
                totalAvgEng += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
            });
            return (totalAvgEng / (this.posts.length + this.reels.length)).toFixed(2);
        },
        postEngRate: function postEngRate() {
            var totalEng = 0;
            this.posts.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            return (totalEng / this.posts.length).toFixed(2);
        },
        reelEngRate: function reelEngRate() {
            var totalEng = 0;
            this.reels.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            return (totalEng / this.reels.length).toFixed(2);
        },
        tiktokEngRate: function tiktokEngRate() {
            var totalEng = 0;
            this.tikTokPosts.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            return (totalEng / this.tikTokPosts.length).toFixed(2);
        },
        youtubeEngRate: function youtubeEngRate() {
            var totalEng = 0;
            this.youtubePosts.map(function (item) {
                totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0;
            });
            return (totalEng / this.youtubePosts.length).toFixed(2);
        },
        postEngRateView: function postEngRateView() {
            var totalEng = 0;
            this.posts.map(function (item) {
                totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0;
            });
            return (totalEng / this.posts.length).toFixed(2);
        },
        reelEngRateView: function reelEngRateView() {
            var totalEng = 0;
            this.reels.map(function (item) {
                totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0;
            });
            return (totalEng / this.reels.length).toFixed(2);
        },
        tiktokEngRateView: function tiktokEngRateView() {
            var totalEng = 0;
            this.tikTokPosts.map(function (item) {
                totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0;
            });
            return (totalEng / this.tikTokPosts.length).toFixed(2);
        },
        youtubeEngRateView: function youtubeEngRateView() {
            var totalEng = 0;
            this.youtubePosts.map(function (item) {
                totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0;
            });
            return (totalEng / this.youtubePosts.length).toFixed(2);
        },

        currentUserRole: function currentUserRole() {
            return Number(this.$store.state.user.role);
        }
    },
    mounted: function mounted() {},

    methods: {
        editBenchmarkAction: function editBenchmarkAction() {
            if (this.showRequiredActions()) {
                this.editBenchmark = true;
            }
        },
        saveBenchmark: function saveBenchmark() {
            var _this = this;

            var benchmark = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                title: this.campaignKPI.benchmarkTitle,
                value: this.campaignKPI.benchmarkValue
            });
            var formData = new FormData();
            formData.append('benchmark', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(benchmark));

            __WEBPACK_IMPORTED_MODULE_7__views_Campaign_campaignAPIs__["a" /* default */].updateCampaignBenchmark(this.campaignID, formData).then(function (response) {
                _this.editBenchmark = false;
            }).catch(function (error) {
                console.log('error', error);
                _this.$swal({
                    text: error,
                    type: 'error'
                });
            });
        },

        showRequiredActions: function showRequiredActions() {
            if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
                return false;
            } else {
                return __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
            }
        },
        updatePerformanceAnalysisStatus: function updatePerformanceAnalysisStatus(items) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                var columns, data;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                columns = _this2.campaign.performanceAnalysisStatus || {};

                                items.map(function (item) {
                                    columns[item.key] = item.value;
                                });
                                data = [__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                                    id: _this2.campaign.id,
                                    performanceAnalysisStatus: columns
                                })];
                                _context.next = 5;
                                return _this2.$store.dispatch('campaign/updateCampaignByIds', data);

                            case 5:
                                _this2.colSettingsDialog = false;

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        displayFields: function displayFields(field) {
            if (this.campaign.performanceAnalysisStatus !== undefined) {
                if (this.campaign.performanceAnalysisStatus[field]) {
                    return true;
                }
            }
            return false;
        },
        openColSettingsModal: function openColSettingsModal() {
            var _this3 = this;

            this.tableColsItems = [];
            var tmpStatuses = {};
            if (this.campaign.performanceAnalysisStatus) {
                tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.campaign.performanceAnalysisStatus);
            } else {
                this.showHideFields.map(function (header) {
                    tmpStatuses[header.name] = true;
                });
            }

            var _loop = function _loop(key, value) {
                var header = _this3.showHideFields.find(function (item) {
                    return item.name === key;
                });
                if (header) {
                    _this3.tableColsItems.push({
                        title: header.label,
                        key: key,
                        value: value
                    });
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(tmpStatuses)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                    var key = _ref2[0];
                    var value = _ref2[1];

                    _loop(key, value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.colSettingsDialog = true;
        }
    }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_ContentAnalysis_contentAnalysisAPI__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scoped_gdrive_GDrivePostView__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scoped_gdrive_GDrivePostView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scoped_gdrive_GDrivePostView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMedia__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scoped_custom_BtnDownload__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scoped_custom_BtnDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__scoped_custom_BtnDownload__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rpt_post',
  components: { GDrivePostView: __WEBPACK_IMPORTED_MODULE_3__scoped_gdrive_GDrivePostView___default.a, CustomMedia: __WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMedia___default.a, BtnDownload: __WEBPACK_IMPORTED_MODULE_5__scoped_custom_BtnDownload___default.a },
  props: ['type', 'post', 'campaign'],
  data: function data() {
    return {
      post_title: '',
      shortCode: null,
      igPost: null,
      tikTokPost: null,
      youtubePost: null,
      postAnalytics: '',
      postData: {},
      campaignHelper: __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__["a" /* default */]
    };
  },

  computed: {
    POST_TITLE: function POST_TITLE() {
      if (this.type === 'story') {
        return 'Instagram Story';
      } else if (this.type === 'post/carousel') {
        return 'Instagram Post/Carousel';
      } else if (this.type === 'tiktok') {
        return 'TikTok';
      }
    },
    POST_URL: function POST_URL() {
      if (this.post.url.includes('drive.google.com')) {
        return this.post.url.substr(0, this.post.url.lastIndexOf('/')) + '/preview';
      }
      return this.post.url;
    },
    MEDIA_URL_TYPE: function MEDIA_URL_TYPE() {
      if (this.type === 'story') {
        var videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4'];
        var images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP'];
        var url = new URL(this.POST_URL);
        var extension = url.pathname.split('.')[4];
        if (videos.includes(extension)) {
          return 'video';
        } else if (images.includes(extension)) {
          return 'image';
        } else if (url.hostname === 'drive.google.com') {
          if (__WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__["a" /* default */].isAOKCampaign(this.campaign.campaignType)) {
            return 'driveView';
          }
          return 'iframe';
        } else if (url.hostname === 'res.cloudinary.com') {
          return 'cld';
        }
      } else {
        return null;
      }
    }
  },
  mounted: function mounted() {
    if (this.type !== 'story' && this.type !== 'gdrive' && this.type !== 'tiktok' && this.type !== 'youtube' && this.type !== 'linkedin' && this.type !== 'twitter') {
      this.getInstagramPost(this.POST_URL);
    } else if (this.type === 'youtube') {
      this.youtubePost = __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__["a" /* default */].getYoutubePost(this.post.shortCode);
    } else {
      this.tikTokPost = __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__["a" /* default */].getTikTokPost(this.post.shortCode);
    }
  },

  watch: {
    post: function post(newPost) {
      this.postData = this.post;
    }
  },
  methods: {
    hasPositiveMetric: function hasPositiveMetric(value) {
      return Number(value) > 0;
    },
    twitterMetric: function twitterMetric(post, metric) {
      var metrics = {
        impressions: post.impressions != null ? post.impressions : post.views,
        replies: post.comment_count,
        likes: post.like_count,
        reposts: post.shares,
        bookmarks: post.saved != null ? post.saved : post.bookmarks
      };
      return Number(metrics[metric]) || 0;
    },
    getLinkedInEmbedUrl: function getLinkedInEmbedUrl(postUrl) {
      if (!postUrl || typeof postUrl !== 'string') return '';
      if (/^https:\/\/www\.linkedin\.com\/embed\/feed\/update\//i.test(postUrl)) return postUrl;
      var decodedUrl = postUrl;
      try {
        decodedUrl = decodeURIComponent(postUrl);
      } catch (error) {
        decodedUrl = postUrl;
      }
      var urnMatch = decodedUrl.match(/urn:li:(activity|share|ugcPost):(\d+)/i);
      var publicPostMatch = decodedUrl.match(/\/posts\/[^?#]*-(activity|share|ugcPost)-(\d+)(?:-[^/?#]+)?\/?(?:[?#]|$)/i);
      var postIdentifier = urnMatch || publicPostMatch;
      if (!postIdentifier) return '';
      var urnType = postIdentifier[1].toLowerCase() === 'ugcpost' ? 'ugcPost' : postIdentifier[1].toLowerCase();
      return 'https://www.linkedin.com/embed/feed/update/urn:li:' + urnType + ':' + postIdentifier[2];
    },
    getTwitterEmbedUrl: function getTwitterEmbedUrl(postUrl) {
      if (!postUrl || typeof postUrl !== 'string') return '';
      var statusMatch = postUrl.match(/(?:x\.com|twitter\.com)\/(?:#!\/)?[^/?#]+\/status(?:es)?\/(\d+)/i);
      return statusMatch ? 'https://platform.twitter.com/embed/Tweet.html?id=' + statusMatch[1] + '&theme=dark' : '';
    },

    getInstagramPost: function getInstagramPost(igUrl) {
      var _this = this;

      var shortCode = '';
      if (igUrl.indexOf('https://www.instagram.com/p/') !== -1) {
        var regex = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].regexPattern.instagram;
        if (igUrl.match(regex)) {
          var searchShortCodes = regex.exec(igUrl);
          shortCode = searchShortCodes[1];
        }
      } else if (igUrl.indexOf('https://www.instagram.com/reel/') !== -1) {
        var _regex = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].regexPattern.instagram_reel;
        if (igUrl.match(_regex)) {
          var _searchShortCodes = _regex.exec(igUrl);
          shortCode = _searchShortCodes[1];
        }
      } else if (igUrl.indexOf('https://www.instagram.com/tv/') !== -1) {
        var _regex2 = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].regexPattern.instagram_tv;
        if (igUrl.match(_regex2)) {
          var _searchShortCodes2 = _regex2.exec(igUrl);
          shortCode = _searchShortCodes2[1];
        }
      }
      if (shortCode.trim().length === 0) {} else {
        __WEBPACK_IMPORTED_MODULE_1__views_ContentAnalysis_contentAnalysisAPI__["a" /* default */].oembedOpen(shortCode).then(function (data) {
          _this.igPost = data.oembed;
          setTimeout(function () {
            window.instgrm.Embeds.process();
          }, 100);
        }).catch(function () {
          _this.igPost = '';
        });
      }
    },
    showTikTokPlayTime: function showTikTokPlayTime(time) {
      return __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__["a" /* default */].showTikTokPlayTime(time);
    },
    getMedia: function getMedia(post) {
      if (post.type === 'gdrive') {
        post.isMultipleContents = true;
        post.embed_url = post.url;
        post.htmlReport = true;
      } else if (post.type === 'story') {
        post.embed_url = post.url;
      } else if (post.type === 'others') {
        post.embed_url = post.url;
      }
      return __WEBPACK_IMPORTED_MODULE_2__views_Campaign_campaignHelper__["a" /* default */].customMediaConfig(post, this.campaign.campaignType);
    },
    getFbPost: function getFbPost(url) {
      return 'https://www.facebook.com/plugins/post.php?href=' + url + '&show_text=true&width=500';
    },
    download: function download(url) {
      if (!url) return;

      var link = document.createElement('a');
      link.href = url;
      link.download = url.substr(url.lastIndexOf('/') + 1);
      link.target = '_blank';
      link.click();
    }
  }
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PostView__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PostView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__PostView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_core_Loading__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_core_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_core_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_Instagram_instagramAPIs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__gdrive_GDriveSelector__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__gdrive_GDriveSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__gdrive_GDriveSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__post_UploadMedia__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__post_UploadMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__post_UploadMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_SocialHandleView__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_SocialHandleView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_SocialHandleView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__UploadStatsModal_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__UploadStatsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__UploadStatsModal_vue__);




























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddPostToCampaign',
  components: {
    PostView: __WEBPACK_IMPORTED_MODULE_10__PostView___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_11__components_core_Loading___default.a,
    GDriveSelector: __WEBPACK_IMPORTED_MODULE_20__gdrive_GDriveSelector___default.a,
    UploadMedia: __WEBPACK_IMPORTED_MODULE_21__post_UploadMedia___default.a,
    SocialHandleView: __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_SocialHandleView___default.a,
    UploadStatsModal: __WEBPACK_IMPORTED_MODULE_25__UploadStatsModal_vue___default.a
  },
  props: {
    campaign: Object,
    value: Boolean,
    selectedPostIds: Object,
    postID: String,
    post: Object,
    campaignPayouts: Object
  },
  data: function data() {
    return {
      cldConfig: __WEBPACK_IMPORTED_MODULE_18__config__["a" /* default */].cldConfig,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_19__components_views_Campaign_config__["a" /* default */].payoutStatus,
      campaignTypes: __WEBPACK_IMPORTED_MODULE_19__components_views_Campaign_config__["a" /* default */].campaignType,
      countries: __WEBPACK_IMPORTED_MODULE_24__static_sources_countries___default.a,
      step: 1,
      showPanel: '',
      recentPostDialog: false,
      loading: false,
      campaignData: null,
      noOfnewPostAdded: 0,
      paging: null,
      seachHashtagType: 0,
      list: [],
      url: null,

      postViewType: 'influencer_search',
      pairedInfluencers: [],
      pairedInfluencersLoading: false,
      xhsInfluencers: [],
      fbInfluencers: [],
      selectedInstagramHandle: null,
      postListTitle: null,
      listPosts: [],
      hashtag: null,

      storyIgHandle: '',
      storyCountry: '',
      storyLiveDate: '',
      storyLiveCal: false,
      postLiveDate: '',
      postLiveCal: false,
      tiktokLiveDate: '',
      tiktokLiveCal: false,
      multipleLiveDate: '',
      multipleLiveCal: false,
      otherLiveDate: '',
      otherLiveCal: false,
      uploadStatsDialog: false,
      campaignPayout: null,
      aiPostType: '',
      storyInsights: {
        impressions: '',
        story_likes: '',
        reach: '',
        replies: '',
        exits: '',
        taps_back: '',
        taps_forward: '',
        shares: '',
        link_clicks: '',
        sticker_taps: ''
      },

      fbHandle: '',
      fbCountry: '',
      fbMediaUrl: '',
      fbLiveDate: '',
      fbLiveCal: false,
      fbInsights: {
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        shares: '',
        bookmarks: ''
      },

      xhsHandle: '',
      xhsCountry: '',
      xhsID: '',
      xhsMediaUrl: [],
      xhsFullname: '',
      xhsLink: '',
      xhsFollowers: '',
      xhsLiveDate: '',
      xhsLiveCal: false,
      xhsInsights: {
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        watches: '',
        shares: '',
        bookmarks: ''
      },

      lemonHandle: '',
      lemonCountry: '',
      lemonID: '',
      lemonMediaUrl: [],
      lemonFullname: '',
      lemonLink: '',
      lemonFollowers: '',
      lemonLiveDate: '',
      lemonLiveCal: false,
      lemonInsights: {
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        watches: '',
        shares: '',
        bookmarks: ''
      },

      postTypes: __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__["a" /* default */].getDeliverableNames(),
      postType: '',
      postIgHandle: '',
      postCountry: '',
      postURL: '',
      postImageURL: '',
      postInsights: {
        engagement_rate: '',
        outreach: '',
        like_count: '',
        comment_count: ''
      },
      inputtedInsights: {
        saved: '',
        shares: '',
        reposts: '',
        views: '',
        reach: '',
        impressions: '',
        watches: '',
        plays: ''
      },
      tikTokHandle: '',
      tiktokCountry: '',
      tikTokPostURL: '',
      tikTokInsights: {
        engagement_rate: '',
        outreach: '',
        like_count: '',
        comment_count: '',
        views: '',
        shares: ''
      },
      tikTokInputtedInsights: {
        outreach: '',
        engagement_rate: '',
        reach: '',
        impressions: '',
        watches: '',
        plays: '',
        watchedFullVideo: '',
        photo_views: ''
      },

      otherHandle: '',
      otherCountry: '',
      otherPostURL: '',
      otherMediaUrl: [],
      otherInsights: {
        engagement_rate: '',
        outreach: '',
        like_count: '',
        comment_count: '',
        impressions: '',
        views: '',
        shares: '',
        reach: '',
        saved: '',
        watches: '',
        plays: '',
        video_views: '',
        profile_viewers: ''
      },
      otherTotalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },

      youtubeHandle: '',
      youtubeCountry: '',
      youtubeURL: '',
      youtubeInsights: {
        outreach: '',
        engagement_rate: '',
        like_count: '',
        comment_count: '',
        views: ''
      },
      youtubeInputtedInsights: {
        impressions: '',
        unique_viewers: '',
        watches: ''
      },
      youtubeLiveDate: '',
      youtubeLiveCal: false,
      multipleIgHandle: '',
      gdriveFiles: [],
      panel: [],
      media: [],
      totalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      reelTotalPlayTime: {
        day: '',
        hour: '',
        minute: '',
        second: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    cldSignature: function cldSignature(state) {
      return state.campaign.cldSignature;
    }
  }), {
    isDone: function isDone() {
      var done = this.list.filter(function (item) {
        return !item.isLoading;
      });
      return done.length === 0;
    },
    postTypeName: function postTypeName() {
      return __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__["a" /* default */].getDeliverableTitle(this.postType);
    },
    otherInfluencers: function otherInfluencers() {
      return this.pairedInfluencers;
    }
  }),
  methods: {
    parsePlayTime: function parsePlayTime(playTime) {
      var timeArray = [];
      var days = 0;
      var hours = 0;
      var minutes = 0;
      var seconds = 0;

      var currentNum = '';
      for (var i = 0; i < playTime.length; i++) {
        var char = playTime[i];

        if (!isNaN(char)) {
          currentNum += char;
        } else {
          if (currentNum) {
            if (char === 'd') {
              days = parseInt(currentNum, 10);
            } else if (char === 'h') {
              hours = parseInt(currentNum, 10);
            } else if (char === 'm') {
              minutes = parseInt(currentNum, 10);
            } else if (char === 's') {
              seconds = parseInt(currentNum, 10);
            }
            currentNum = '';
          }
        }
      }

      timeArray.push(days, hours, minutes, seconds);
      return timeArray;
    },
    showRecentPosts: function showRecentPosts(instagramHandle, page) {
      var _this = this;

      var after = void 0,
          before = void 0;
      if (page === 'prev') {
        before = this.paging ? this.paging.cursors.previous : null;
      }
      if (page === 'next') {
        after = this.paging ? this.paging.cursors.after : null;
      }
      this.fetchRecentPosts(instagramHandle, after, before).then(function (data) {
        _this.recentPostDialog = true;
        _this.listPosts = data.medias;
        _this.paging = data.paging;
        _this.postListTitle = instagramHandle + '\'s Recent Posts';
        _this.postViewType = 'influencer_search';
      }).catch(function () {
        _this.$swal({
          type: 'warning',
          text: 'Some thing wrong. Cannot perform this action'
        });
      });
      this.selectedInstagramHandle = instagramHandle;
    },
    fetchRecentPosts: function fetchRecentPosts(instagramhandle, after, before) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__components_views_Instagram_instagramAPIs__["a" /* default */].fetchRecentPosts(instagramhandle, after, before);

              case 3:
                resp = _context.sent;
                return _context.abrupt('return', resp || {});

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                throw _context.t0;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },
    searchHashTag: function searchHashTag() {
      var _this3 = this;

      var searchType = this.seachHashtagType === 0 ? 'recent_media' : 'top_media';
      this.fetchPostByHashtag(this.hashtag, searchType).then(function (posts) {
        _this3.recentPostDialog = true;
        _this3.listPosts = posts;
        _this3.postViewType = 'hashtag_search';
        _this3.postListTitle = 'Posts published with tag ' + _this3.hashtag;
      }).catch(function (err) {
        console.error(err);
        _this3.$swal({
          type: 'warning',
          text: 'Some thing wrong. Cannot perform this action'
        });
      });
    },
    fetchPostByHashtag: function fetchPostByHashtag(hashtag, type) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__components_views_Instagram_instagramAPIs__["a" /* default */].searchByHashtag({ hashtag: hashtag, type: type });

              case 3:
                resp = _context2.sent;
                return _context2.abrupt('return', resp.data || []);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                throw _context2.t0;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 7]]);
      }))();
    },
    userRecentPostDialog: function userRecentPostDialog() {
      this.recentPostDialog = false;
    },
    close: function close() {
      this.$emit('input');
    },
    add: function add() {
      if (this.url === '' || this.url === null) {
        this.$swal({
          type: 'error',
          title: 'Empty URL',
          text: 'Please Enter the correct URL'
        });
      } else {
        var data = {
          isLoading: true,
          url: this.url,
          shortcode: __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.extractShortCode(this.url)
        };
        this.list.push(data);
        this.url = '';
        this.addPostToCampaign(data.url, this.campaignData.id);
      }
    },
    fetchSelectedInfluencers: function fetchSelectedInfluencers(campaignId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, acceptedPairings, influencers;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_15__components_views_Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignId);

              case 3:
                resp = _context3.sent;
                acceptedPairings = resp.filter(function (pairing) {
                  var pairingStatus = pairing.pairing_details && pairing.pairing_details.status;
                  return Number(pairingStatus) === Number(__WEBPACK_IMPORTED_MODULE_18__config__["a" /* default */].pairingStatus.ACCEPTED);
                });
                influencers = acceptedPairings.map(function (e) {
                  var result = {};
                  if (e.influencer_details) {
                    var infDetails = e.influencer_details;
                    var rawPlatform = String(infDetails.platform || 'instagram').toLowerCase();
                    var platform = rawPlatform === 'x' ? 'twitter' : rawPlatform;
                    var linkedinHandle = infDetails.linkedinHandle || (platform === 'linkedin' ? infDetails.userHandle || infDetails.instagramHandle : '');
                    var twitterHandle = infDetails.twitterHandle || (platform === 'twitter' ? infDetails.userHandle || infDetails.instagramHandle : '');
                    var displayHandle = platform === 'linkedin' ? linkedinHandle : platform === 'twitter' ? twitterHandle : infDetails.instagramHandle;
                    var deliverables = e.deliverables_details || {};
                    result = {
                      pairingID: e.id,
                      fullName: infDetails.fullname || infDetails.fullName,

                      originalInstagramHandle: infDetails.instagramHandle,
                      instagramHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
                      instagramAccountHandle: infDetails.igHandle || (platform === 'instagram' ? infDetails.instagramHandle : ''),
                      tiktokHandle: infDetails.tiktokHandle || (platform === 'tiktok' ? infDetails.userHandle || infDetails.instagramHandle : ''),
                      youtubeAccountHandle: infDetails.youtubeHandle || (platform === 'youtube' ? infDetails.userHandle || infDetails.instagramHandle : ''),
                      facebookAccountHandle: infDetails.facebookHandle || infDetails.fbHandle || (platform === 'facebook' ? infDetails.userHandle || infDetails.instagramHandle : ''),
                      linkedinHandle: linkedinHandle,
                      twitterHandle: twitterHandle,
                      xhsHandle: infDetails.xhsHandle || (platform === 'xiaohongshu' ? infDetails.userHandle || infDetails.instagramHandle || infDetails.fullName : ''),
                      displayHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
                      platform: platform,
                      hasLinkedInDeliverable: platform === 'linkedin' || Number(deliverables.no_of_li_posts || 0) > 0,
                      hasTwitterDeliverable: platform === 'twitter' || Number(deliverables.no_of_x_posts || 0) > 0,
                      xhsID: infDetails.xhsID || '',
                      instagramID: infDetails.instagramID,
                      influencerID: infDetails.influencerID
                    };
                  }
                  if (e.payout_details) {
                    result.payoutStatus = e.payout_details.status;
                  }
                  return result;
                });
                _context3.next = 8;
                return _this5.expandPairedInfluencerHandles(influencers);

              case 8:
                _this5.pairedInfluencers = _context3.sent;
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 11]]);
      }))();
    },
    getInfluencerProfileHandles: function getInfluencerProfileHandles(profile, pairedInfluencer) {
      var nestedHandle = function nestedHandle(key, handleKey) {
        return profile && profile[key] && profile[key][handleKey];
      };
      var accounts = [{ platform: 'instagram', handle: profile.instagramHandle || nestedHandle('instagram', 'instagramHandle') || pairedInfluencer.instagramAccountHandle }, { platform: 'tiktok', handle: profile.tiktokHandle || nestedHandle('tiktok', 'tiktokHandle') || pairedInfluencer.tiktokHandle }, { platform: 'youtube', handle: profile.youtubeHandle || nestedHandle('youtube', 'youtubeHandle') || pairedInfluencer.youtubeAccountHandle }, { platform: 'facebook', handle: profile.facebookHandle || profile.fbHandle || nestedHandle('facebook', 'facebookHandle') || nestedHandle('facebook', 'username') || pairedInfluencer.facebookAccountHandle }, { platform: 'linkedin', handle: profile.linkedinHandle || nestedHandle('linkedin', 'linkedinHandle') || pairedInfluencer.linkedinHandle }, { platform: 'twitter', handle: profile.twitterHandle || nestedHandle('twitter', 'twitterHandle') || pairedInfluencer.twitterHandle }, { platform: 'xiaohongshu', handle: profile.xhsHandle || nestedHandle('xiaohongshu', 'xhsHandle') || pairedInfluencer.xhsHandle }, { platform: 'lemon8', handle: profile.lemon8Handle || profile.lemonHandle }];
      accounts.unshift({
        platform: pairedInfluencer.platform,
        handle: pairedInfluencer.displayHandle || pairedInfluencer.instagramHandle
      });

      var seen = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a();
      return accounts.filter(function (account) {
        if (!account.handle) return false;
        account.handle = String(account.handle).trim().replace(/^@+/, '');
        if (!account.handle) return false;
        var key = account.platform + ':' + account.handle.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    createPairedHandleOption: function createPairedHandleOption(pairedInfluencer, account, profileHandles) {
      var findHandle = function findHandle(platform) {
        var match = profileHandles.find(function (profileHandle) {
          return profileHandle.platform === platform;
        });
        return match ? match.handle : '';
      };
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, pairedInfluencer, {
        platform: account.platform,

        instagramHandle: account.handle,
        displayHandle: account.handle,
        originalInstagramHandle: findHandle('instagram') || pairedInfluencer.originalInstagramHandle,
        linkedinHandle: account.platform === 'linkedin' ? account.handle : findHandle('linkedin'),
        twitterHandle: account.platform === 'twitter' ? account.handle : findHandle('twitter')
      });
    },
    getAccountOptionValue: function getAccountOptionValue(account) {
      if (!account || (typeof account === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(account)) !== 'object') return account;
      var platform = String(account.platform || 'instagram').trim().toLowerCase();
      var handle = String(account.instagramHandle || account.displayHandle || '').trim().replace(/^@+/, '').toLowerCase();
      return (account.pairingID || account.influencerID || '') + ':' + platform + ':' + handle;
    },
    resolveSelectedAccount: function resolveSelectedAccount(value) {
      if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) === 'object') return value;
      var handle = String(value || '').trim().replace(/^@+/, '').toLowerCase();
      var matches = this.pairedInfluencers.filter(function (account) {
        return String(account.instagramHandle || '').trim().replace(/^@+/, '').toLowerCase() === handle;
      });
      if (matches.length > 1) throw new Error('Please select the specific creator account from the list.');
      return matches[0];
    },
    expandPairedInfluencerHandles: function expandPairedInfluencerHandles(influencers) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var expandedGroups, seen;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.pairedInfluencersLoading = true;
                _context5.prev = 1;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(influencers.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4(pairedInfluencer) {
                    var profile, response, profileHandles;
                    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            profile = {};

                            if (!pairedInfluencer.influencerID) {
                              _context4.next = 12;
                              break;
                            }

                            _context4.prev = 2;
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_22__views_Influencer_influencerAPIs__["a" /* default */].getInfluencer(pairedInfluencer.influencerID);

                          case 5:
                            response = _context4.sent;

                            profile = response && response.influencer ? response.influencer : response;
                            _context4.next = 12;
                            break;

                          case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](2);

                            console.error('Unable to load connected accounts for influencer ' + pairedInfluencer.influencerID, _context4.t0);

                          case 12:
                            profileHandles = _this6.getInfluencerProfileHandles(profile || {}, pairedInfluencer);

                            if (profileHandles.length) {
                              _context4.next = 15;
                              break;
                            }

                            return _context4.abrupt('return', [pairedInfluencer]);

                          case 15:
                            return _context4.abrupt('return', profileHandles.map(function (account) {
                              return _this6.createPairedHandleOption(pairedInfluencer, account, profileHandles);
                            }));

                          case 16:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this6, [[2, 9]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 4:
                expandedGroups = _context5.sent;
                seen = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a();
                return _context5.abrupt('return', expandedGroups.reduce(function (options, group) {
                  return options.concat(group);
                }, []).filter(function (option) {
                  var key = (option.pairingID || option.influencerID) + ':' + option.platform + ':' + String(option.displayHandle).toLowerCase();
                  if (seen.has(key)) return false;
                  seen.add(key);
                  return true;
                }));

              case 7:
                _context5.prev = 7;

                _this6.pairedInfluencersLoading = false;
                return _context5.finish(7);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[1,, 7, 10]]);
      }))();
    },
    postSelected: function postSelected(post) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var campaignID, body;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this7.noOfnewPostAdded++;

                if (!(_this7.postViewType === 'hashtag_search')) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return', _this7.addPostToCampaign(post.permalink, _this7.campaign.id));

              case 4:
                _this7.loading = true;
                campaignID = _this7.campaign.id;
                body = {
                  campaignID: campaignID,
                  source: 'graph_api',
                  post: post,
                  postType: _this7.postType
                };
                _context6.next = 9;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addPostToCampaign(body);

              case 9:
                _this7.$emit('done');
                _this7.$swal({
                  type: 'success',
                  text: 'New post is added to this campaign.'
                });
                _context6.next = 17;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6['catch'](0);

                console.error(_context6.t0.message);
                _this7.$swal({
                  type: 'warning',
                  text: 'Fail to add post to this campaign'
                });

              case 17:
                _context6.prev = 17;

                _this7.loading = false;
                return _context6.finish(17);

              case 20:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 13, 17, 20]]);
      }))();
    },
    addPostToCampaign: function addPostToCampaign(url, campaignID) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this8.loading = true;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addPostToCampaign({ url: url, campaignID: campaignID, postId: _this8.postID || '', postType: _this8.postType, typeName: _this8.postTypeName });

              case 4:
                _this8.$emit('done');
                _this8.$swal({
                  type: 'success',
                  text: 'New post is added to this campaign.'
                });

                if (!_this8.postID) {
                  _context7.next = 10;
                  break;
                }

                data = {
                  url: url,
                  lockSubmission: true,
                  dateConfirmed: true
                };
                _context7.next = 10;
                return __WEBPACK_IMPORTED_MODULE_14__components_views_Post_postApi__["a" /* default */].updatePostForPayout(_this8.postID, data);

              case 10:
                _context7.next = 15;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](0);

                console.error(_context7.t0);

              case 15:
                _context7.prev = 15;

                _this8.loading = false;
                return _context7.finish(15);

              case 18:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 12, 15, 18]]);
      }))();
    },
    addStoryInsightsManually: function addStoryInsightsManually() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var selectedHandle, pairingID, platform, selectedAccount, reports;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                selectedHandle = _this9.storyIgHandle;
                pairingID = null;
                platform = 'instagram';

                if (!(_this9.storyIgHandle === '' || _this9.storyIgHandle === null)) {
                  _context8.next = 7;
                  break;
                }

                _this9.$swal({
                  type: 'error',
                  text: 'Instagram username is required'
                });
                return _context8.abrupt('return');

              case 7:
                if (_this9.storyCountry) {
                  _context8.next = 10;
                  break;
                }

                _this9.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context8.abrupt('return');

              case 10:
                if (_this9.storyMediaUrl) {
                  _context8.next = 13;
                  break;
                }

                _this9.$swal({
                  type: 'error',
                  text: 'Story Media URL is required'
                });
                return _context8.abrupt('return');

              case 13:
                if (_this9.storyLiveDate) {
                  _context8.next = 16;
                  break;
                }

                _this9.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context8.abrupt('return');

              case 16:
                selectedAccount = _this9.resolveSelectedAccount(_this9.storyIgHandle);

                if (selectedAccount) {
                  platform = selectedAccount.platform || platform;
                  pairingID = selectedAccount.pairingID || null;
                  selectedHandle = selectedAccount.instagramHandle;
                }
                _context8.next = 20;
                return _this9.invokePayoutCheck(selectedHandle);

              case 20:
                if (_this9.checkLiveDate(_this9.storyLiveDate)) {
                  _context8.next = 22;
                  break;
                }

                return _context8.abrupt('return');

              case 22:
                selectedHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(selectedHandle);
                _this9.loading = true;
                _context8.next = 26;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addStoryInsights(_this9.campaignData.id, _this9.postID || '', pairingID, selectedHandle, _this9.storyCountry, platform, _this9.storyInsights, _this9.storyMediaUrl, _this9.storyLiveDate, _this9.postType, _this9.postTypeName);

              case 26:
                reports = _context8.sent;

                _this9.$emit('addedReport', reports);
                _this9.$swal({
                  type: 'success',
                  text: 'Story Insights are added.'
                });
                _this9.storyMediaUrl = '';
                _this9.storyIgHandle = '';
                _this9.storyInsights = {
                  impressions: '',
                  story_likes: '',
                  reach: '',
                  replies: '',
                  exits: '',
                  taps_back: '',
                  taps_forward: '',
                  shares: '',
                  link_clicks: '',
                  sticker_taps: ''
                };
                _this9.storyCountry = '';
                _this9.close();
                _context8.next = 42;
                break;

              case 36:
                _context8.prev = 36;
                _context8.t0 = _context8['catch'](0);

                console.error(_context8.t0);
                _this9.$swal({
                  type: 'error',
                  text: 'Failed to add story insights'
                });
                _this9.loading = false;
                _this9.close();

              case 42:
                _context8.prev = 42;

                _this9.loading = false;
                return _context8.finish(42);

              case 45:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[0, 36, 42, 45]]);
      }))();
    },
    addPostInsightsManually: function addPostInsightsManually() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var platform, selectedHandle, pairingID, selectedAccount, handle, matches, data, reports;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                platform = 'instagram';
                selectedHandle = _this10.postIgHandle;
                pairingID = null;

                if (!(_this10.postIgHandle === '' || _this10.postIgHandle === null)) {
                  _context9.next = 7;
                  break;
                }

                _this10.$swal({
                  type: 'error',
                  text: 'Instagram username is required'
                });
                return _context9.abrupt('return');

              case 7:
                if (_this10.postCountry) {
                  _context9.next = 10;
                  break;
                }

                _this10.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context9.abrupt('return');

              case 10:
                if (_this10.postURL) {
                  _context9.next = 13;
                  break;
                }

                _this10.$swal({
                  type: 'error',
                  text: 'Post URL is required'
                });
                return _context9.abrupt('return');

              case 13:
                if (_this10.postLiveDate) {
                  _context9.next = 16;
                  break;
                }

                _this10.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context9.abrupt('return');

              case 16:
                selectedAccount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this10.postIgHandle) === 'object' ? _this10.postIgHandle : null;

                if (selectedAccount) {
                  _context9.next = 24;
                  break;
                }

                handle = String(_this10.postIgHandle).trim().replace(/^@+/, '').toLowerCase();
                matches = _this10.pairedInfluencers.filter(function (account) {
                  return String(account.instagramHandle || '').trim().replace(/^@+/, '').toLowerCase() === handle;
                });

                if (!(matches.length > 1)) {
                  _context9.next = 23;
                  break;
                }

                _this10.$swal({ type: 'error', text: 'Please select the specific creator account from the list.' });
                return _context9.abrupt('return');

              case 23:
                selectedAccount = matches[0];

              case 24:
                if (selectedAccount) {
                  platform = selectedAccount.platform || 'instagram';
                  pairingID = selectedAccount.pairingID || null;
                  selectedHandle = selectedAccount.instagramHandle;
                }

                if (!(_this10.postURL === '')) {
                  _context9.next = 28;
                  break;
                }

                _this10.$swal({
                  type: 'error',
                  text: 'PostURL is required'
                });
                return _context9.abrupt('return');

              case 28:
                _context9.next = 30;
                return _this10.invokePayoutCheck(selectedHandle);

              case 30:
                if (_this10.checkLiveDate(_this10.postLiveDate)) {
                  _context9.next = 32;
                  break;
                }

                return _context9.abrupt('return');

              case 32:

                _this10.loading = true;

                if (!_this10.postID) {
                  _context9.next = 37;
                  break;
                }

                data = {
                  url: _this10.postURL,
                  lockSubmission: true,
                  dateConfirmed: true
                };
                _context9.next = 37;
                return __WEBPACK_IMPORTED_MODULE_14__components_views_Post_postApi__["a" /* default */].updatePostForPayout(_this10.postID, data);

              case 37:
                if (_this10.postType === 'IGR') {
                  _this10.inputtedInsights.plays = __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__["a" /* default */].formatTikTokPlayTime(_this10.reelTotalPlayTime);
                }
                selectedHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(selectedHandle);
                _context9.next = 41;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addPostInsights(_this10.campaignData.id, _this10.postID || '', pairingID, selectedHandle, _this10.postCountry, platform, _this10.postInsights, _this10.inputtedInsights, _this10.postURL, _this10.postImageURL, _this10.postLiveDate, _this10.postType, _this10.postTypeName);

              case 41:
                reports = _context9.sent;

                _this10.$emit('addedReport', reports);
                _this10.$swal({
                  type: 'success',
                  text: 'Post Insights are added.'
                });
                _this10.postIgHandle = '';
                _this10.postURL = '';
                _this10.postImageURL = '';
                _this10.postCountry = '';
                _this10.postInsights = {
                  outreach: '',
                  engagement_rate: '',
                  like_count: '',
                  comment_count: ''
                };
                _this10.inputtedInsights = {
                  saved: '',
                  shares: '',
                  reposts: '',
                  views: '',
                  reach: '',
                  impressions: '',
                  watches: '',
                  plays: ''
                };
                _this10.reelTotalPlayTime = {
                  day: '',
                  hour: '',
                  minute: '',
                  second: ''
                };
                _this10.close();
                _context9.next = 60;
                break;

              case 54:
                _context9.prev = 54;
                _context9.t0 = _context9['catch'](0);

                console.error(_context9.t0);
                _this10.$swal({
                  type: 'error',
                  text: _context9.t0
                });
                _this10.loading = false;
                _this10.close();

              case 60:
                _context9.prev = 60;

                _this10.loading = false;
                return _context9.finish(60);

              case 63:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[0, 54, 60, 63]]);
      }))();
    },
    addYoutubeInsightsManually: function addYoutubeInsightsManually() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var platform, pairingID, data, reports;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                platform = 'youtube';
                pairingID = null;

                if (!(_this11.youtubeHandle === '' || _this11.youtubeHandle === null)) {
                  _context10.next = 6;
                  break;
                }

                _this11.$swal({
                  type: 'error',
                  text: 'Youtube username is required'
                });
                return _context10.abrupt('return');

              case 6:
                if (_this11.youtubeCountry) {
                  _context10.next = 9;
                  break;
                }

                _this11.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context10.abrupt('return');

              case 9:
                if (_this11.youtubeURL) {
                  _context10.next = 12;
                  break;
                }

                _this11.$swal({
                  type: 'error',
                  text: 'Youtube Video URL is required'
                });
                return _context10.abrupt('return');

              case 12:
                if (_this11.youtubeLiveDate) {
                  _context10.next = 15;
                  break;
                }

                _this11.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context10.abrupt('return');

              case 15:
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this11.youtubeHandle) === 'object') {
                  platform = _this11.youtubeHandle.platform;
                  if (_this11.youtubeHandle.pairingID) {
                    pairingID = _this11.youtubeHandle.pairingID;
                  }
                  _this11.youtubeHandle = _this11.youtubeHandle.instagramHandle;
                }

                if (_this11.checkLiveDate(_this11.youtubeLiveDate)) {
                  _context10.next = 18;
                  break;
                }

                return _context10.abrupt('return');

              case 18:

                _this11.loading = true;

                if (!_this11.postID) {
                  _context10.next = 23;
                  break;
                }

                data = {
                  url: _this11.postURL,
                  lockSubmission: true,
                  dateConfirmed: true
                };
                _context10.next = 23;
                return __WEBPACK_IMPORTED_MODULE_14__components_views_Post_postApi__["a" /* default */].updatePostForPayout(_this11.postID, data);

              case 23:
                _this11.youtubeHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSignNoLower(_this11.youtubeHandle);
                _context10.next = 26;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addYoutubePostInsights(_this11.campaignData.id, _this11.postID || '', pairingID, _this11.youtubeHandle, _this11.youtubeCountry, platform, _this11.youtubeInsights, _this11.youtubeInputtedInsights, _this11.youtubeURL, _this11.youtubeLiveDate, _this11.postType, _this11.postTypeName);

              case 26:
                reports = _context10.sent;

                _this11.$emit('addedReport', reports);
                _this11.$swal({
                  type: 'success',
                  text: 'Post Insights are added.'
                });
                _this11.youtubeHandle = '';
                _this11.youtubeURL = '';
                _this11.youtubeCountry = '';
                _this11.youtubeInsights = {
                  outreach: '',
                  engagement_rate: '',
                  like_count: '',
                  comment_count: '',
                  views: ''
                };
                _this11.youtubeInputtedInsights = {
                  impressions: '',
                  unique_viewers: '',
                  watches: ''
                };
                _this11.close();
                _context10.next = 43;
                break;

              case 37:
                _context10.prev = 37;
                _context10.t0 = _context10['catch'](0);

                console.error(_context10.t0);
                _this11.$swal({
                  type: 'error',
                  text: _context10.t0
                });
                _this11.loading = false;
                _this11.close();

              case 43:
                _context10.prev = 43;

                _this11.loading = false;
                return _context10.finish(43);

              case 46:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11, [[0, 37, 43, 46]]);
      }))();
    },
    addTikTokInsightsManually: function addTikTokInsightsManually() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var selectedHandle, platform, pairingID, selectedAccount, reports;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                selectedHandle = _this12.tikTokHandle;
                platform = 'tiktok';
                pairingID = null;

                if (!(_this12.tikTokHandle === '' || _this12.tikTokHandle === null)) {
                  _context11.next = 7;
                  break;
                }

                _this12.$swal({
                  type: 'error',
                  text: 'TikTok username is required'
                });
                return _context11.abrupt('return');

              case 7:
                if (_this12.tiktokCountry) {
                  _context11.next = 10;
                  break;
                }

                _this12.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context11.abrupt('return');

              case 10:
                if (_this12.tikTokPostURL) {
                  _context11.next = 13;
                  break;
                }

                _this12.$swal({
                  type: 'error',
                  text: 'TikTok Post URL is required'
                });
                return _context11.abrupt('return');

              case 13:
                if (_this12.tiktokLiveDate) {
                  _context11.next = 16;
                  break;
                }

                _this12.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context11.abrupt('return');

              case 16:
                selectedAccount = _this12.resolveSelectedAccount(_this12.tikTokHandle);

                if (selectedAccount) {
                  platform = selectedAccount.platform || platform;
                  pairingID = selectedAccount.pairingID || null;
                  selectedHandle = selectedAccount.instagramHandle;
                }

                if (!(_this12.tikTokPostURL === '')) {
                  _context11.next = 21;
                  break;
                }

                _this12.$swal({
                  type: 'error',
                  text: 'TikTok PostURL is required'
                });
                return _context11.abrupt('return');

              case 21:
                _context11.next = 23;
                return _this12.invokePayoutCheck(selectedHandle, 'tiktok');

              case 23:
                if (_this12.checkLiveDate(_this12.tiktokLiveDate)) {
                  _context11.next = 25;
                  break;
                }

                return _context11.abrupt('return');

              case 25:
                _this12.loading = true;

                _this12.tikTokInputtedInsights.plays = __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__["a" /* default */].formatTikTokPlayTime(_this12.totalPlayTime);
                selectedHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(selectedHandle);
                _context11.next = 30;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addTikTokInsights(_this12.campaignData.id, pairingID, selectedHandle, _this12.tiktokCountry, platform, _this12.tikTokInsights, _this12.tikTokInputtedInsights, _this12.tikTokPostURL, _this12.tiktokLiveDate, _this12.postType, _this12.postID || '');

              case 30:
                reports = _context11.sent;

                _this12.$emit('addedReport', reports);
                _this12.$swal({
                  type: 'success',
                  text: 'TikTok Insights are added.'
                });
                _this12.tikTokHandle = '';
                _this12.tikTokPostURL = '';
                _this12.tiktokCountry = '';
                _this12.tikTokInsights = {
                  engagement_rate: '',
                  outreach: '',
                  like_count: '',
                  comment_count: '',
                  views: '',
                  shares: ''
                };
                _this12.tikTokInputtedInsights = {
                  outreach: '',
                  engagement_rate: '',
                  reach: '',
                  impressions: '',
                  watches: '',
                  plays: '',
                  watchedFullVideo: '',
                  photo_views: ''
                };
                _this12.close();
                _context11.next = 47;
                break;

              case 41:
                _context11.prev = 41;
                _context11.t0 = _context11['catch'](0);

                console.error(_context11.t0);
                _this12.$swal({
                  type: 'error',
                  text: _context11.t0
                });
                _this12.loading = false;
                _this12.close();

              case 47:
                _context11.prev = 47;

                _this12.loading = false;
                return _context11.finish(47);

              case 50:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12, [[0, 41, 47, 50]]);
      }))();
    },
    addFbInsightsManually: function addFbInsightsManually() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var platform, pairingID, reports;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                platform = 'facebook';
                pairingID = null;

                if (!(_this13.fbHandle === '' || _this13.fbHandle === null)) {
                  _context12.next = 6;
                  break;
                }

                _this13.$swal({
                  type: 'error',
                  text: 'Facebook username is required'
                });
                return _context12.abrupt('return');

              case 6:
                if (_this13.fbCountry) {
                  _context12.next = 11;
                  break;
                }

                _this13.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context12.abrupt('return');

              case 11:
                if (_this13.fbMediaUrl) {
                  _context12.next = 16;
                  break;
                }

                _this13.$swal({
                  type: 'error',
                  text: 'Facebook Media URL is required'
                });
                return _context12.abrupt('return');

              case 16:
                if (!(_this13.fbLiveDate === '')) {
                  _context12.next = 19;
                  break;
                }

                _this13.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context12.abrupt('return');

              case 19:
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this13.fbHandle) === 'object') {
                  platform = _this13.fbHandle.platform;
                  if (_this13.fbHandle.pairingID) {
                    pairingID = _this13.fbHandle.pairingID;
                  }
                  _this13.fbHandle = _this13.fbHandle.instagramHandle;
                }
                _context12.next = 22;
                return _this13.invokePayoutCheck(_this13.fbHandle);

              case 22:
                if (_this13.checkLiveDate(_this13.fbLiveDate)) {
                  _context12.next = 24;
                  break;
                }

                return _context12.abrupt('return');

              case 24:
                _this13.fbHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(_this13.fbHandle);
                _this13.loading = true;
                _context12.next = 28;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addFbInsights(_this13.campaignData.id, _this13.postID || '', pairingID, _this13.fbHandle, _this13.fbCountry, platform, _this13.fbInsights, _this13.fbMediaUrl, _this13.fbLiveDate, _this13.postType, _this13.postTypeName);

              case 28:
                reports = _context12.sent;

                _this13.$emit('addedReport', reports);
                _this13.$swal({
                  type: 'success',
                  text: 'Facebook Insights are added.'
                });
                _this13.fbMediaUrl = '';
                _this13.fbHandle = '';
                _this13.fbCountry = '';
                _this13.fbInsights = {
                  outreach: '',
                  like_count: '',
                  comment_count: ''
                };
                _this13.close();
                _context12.next = 44;
                break;

              case 38:
                _context12.prev = 38;
                _context12.t0 = _context12['catch'](0);

                console.error(_context12.t0);
                _this13.$swal({
                  type: 'error',
                  text: 'Failed to add Facebook insights'
                });
                _this13.loading = false;
                _this13.close();

              case 44:
                _context12.prev = 44;

                _this13.loading = false;
                return _context12.finish(44);

              case 47:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this13, [[0, 38, 44, 47]]);
      }))();
    },
    addXHSInsightsManually: function addXHSInsightsManually() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var platform, pairingID, chkRet, multipleMediaUrls, reports, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, multiMedia;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                platform = 'xiaohongshu';
                pairingID = null;

                if (!(_this14.xhsHandle === '' || _this14.xhsHandle === null)) {
                  _context13.next = 8;
                  break;
                }

                _this14.$swal({
                  type: 'error',
                  text: 'XHS username is required'
                });
                return _context13.abrupt('return');

              case 8:
                if (_this14.xhsCountry) {
                  _context13.next = 13;
                  break;
                }

                _this14.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context13.abrupt('return');

              case 13:
                if (!(_this14.xhsLink === '')) {
                  _context13.next = 18;
                  break;
                }

                _this14.$swal({
                  type: 'error',
                  text: 'XHS Link is required'
                });
                return _context13.abrupt('return');

              case 18:
                if (!(_this14.xhsLiveDate === '')) {
                  _context13.next = 23;
                  break;
                }

                _this14.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context13.abrupt('return');

              case 23:
                if (!(_this14.xhsFollowers === '')) {
                  _context13.next = 26;
                  break;
                }

                _this14.$swal({
                  type: 'error',
                  text: 'XHS followers is required'
                });
                return _context13.abrupt('return');

              case 26:
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this14.xhsHandle) === 'object') {
                  pairingID = _this14.xhsHandle.pairingID;
                  _this14.xhsHandle = _this14.xhsHandle.instagramHandle;
                  _this14.xhsID = _this14.xhsHandle.xhsID;
                }
                _context13.next = 29;
                return _this14.checkXHSInf(_this14.xhsHandle);

              case 29:
                chkRet = _context13.sent;

                if (!chkRet) {} else {
                  if (chkRet.xiaohongshu) {
                    if (!_this14.xhsID) {
                      _this14.xhsID = chkRet.xiaohongshu.xhsID;
                    }
                  }
                }
                _context13.next = 33;
                return _this14.invokePayoutCheck(_this14.xhsHandle);

              case 33:
                if (_this14.checkLiveDate(_this14.xhsLiveDate)) {
                  _context13.next = 35;
                  break;
                }

                return _context13.abrupt('return');

              case 35:
                _this14.loading = true;
                multipleMediaUrls = _this14.media ? _this14.xhsMediaUrl.map(function (m) {
                  return m.file;
                }) : [];
                reports = [];

                _this14.xhsHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSignNoLower(_this14.xhsHandle);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context13.prev = 42;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(multipleMediaUrls);

              case 44:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context13.next = 52;
                  break;
                }

                multiMedia = _step.value;
                _context13.next = 48;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addXHSInsights(_this14.campaignData.id, _this14.postID || '', pairingID, _this14.xhsHandle, _this14.xhsCountry, platform, _this14.xhsID, _this14.xhsLink, _this14.xhsFollowers, _this14.xhsInsights, multiMedia, _this14.xhsLiveDate, _this14.postType, _this14.postTypeName);

              case 48:
                reports = _context13.sent;

              case 49:
                _iteratorNormalCompletion = true;
                _context13.next = 44;
                break;

              case 52:
                _context13.next = 58;
                break;

              case 54:
                _context13.prev = 54;
                _context13.t0 = _context13['catch'](42);
                _didIteratorError = true;
                _iteratorError = _context13.t0;

              case 58:
                _context13.prev = 58;
                _context13.prev = 59;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 61:
                _context13.prev = 61;

                if (!_didIteratorError) {
                  _context13.next = 64;
                  break;
                }

                throw _iteratorError;

              case 64:
                return _context13.finish(61);

              case 65:
                return _context13.finish(58);

              case 66:
                _this14.$emit('addedReport', reports);
                _this14.$swal({
                  type: 'success',
                  text: 'XHS Insights are added.'
                });
                _this14.xhsMediaUrl = '';
                _this14.xhsLink = '';
                _this14.xhsHandle = '';
                _this14.xhsCountry = '';
                _this14.xhsFollowers = '';
                _this14.xhsInsights = {
                  outreach: '',
                  like_count: '',
                  comment_count: '',
                  views: '',
                  watches: '',
                  shares: '',
                  bookmarks: ''
                };
                _this14.close();
                _context13.next = 83;
                break;

              case 77:
                _context13.prev = 77;
                _context13.t1 = _context13['catch'](0);

                console.error(_context13.t1);
                _this14.$swal({
                  type: 'error',
                  text: 'Failed to add XHS insights'
                });
                _this14.loading = false;
                _this14.close();

              case 83:
                _context13.prev = 83;

                _this14.loading = false;
                return _context13.finish(83);

              case 86:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this14, [[0, 77, 83, 86], [42, 54, 58, 66], [59,, 61, 65]]);
      }))();
    },
    addLemonInsightsManually: function addLemonInsightsManually() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var platform, pairingID, multipleMediaUrls, reports, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, multiMedia;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                platform = 'lemon8';
                pairingID = null;

                if (!(_this15.lemonHandle === '' || _this15.lemonHandle === null)) {
                  _context14.next = 8;
                  break;
                }

                _this15.$swal({
                  type: 'error',
                  text: 'Lemon8 username is required'
                });
                return _context14.abrupt('return');

              case 8:
                if (_this15.lemonCountry) {
                  _context14.next = 13;
                  break;
                }

                _this15.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context14.abrupt('return');

              case 13:
                if (!(_this15.lemonLink === '')) {
                  _context14.next = 18;
                  break;
                }

                _this15.$swal({
                  type: 'error',
                  text: 'Lemon Link is required'
                });
                return _context14.abrupt('return');

              case 18:
                if (!(_this15.lemonLiveDate === '')) {
                  _context14.next = 23;
                  break;
                }

                _this15.$swal({
                  type: 'error',
                  text: 'Live Date is required'
                });
                return _context14.abrupt('return');

              case 23:
                if (!(_this15.lemonFollowers === '')) {
                  _context14.next = 28;
                  break;
                }

                _this15.$swal({
                  type: 'error',
                  text: 'Lemon8 followers is required'
                });
                return _context14.abrupt('return');

              case 28:
                if (_this15.lemonMediaUrl.length) {
                  _context14.next = 31;
                  break;
                }

                _this15.$swal({
                  type: 'error',
                  text: 'Media is required'
                });
                return _context14.abrupt('return');

              case 31:
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this15.lemonHandle) === 'object') {
                  _this15.lemonHandle = _this15.lemonHandle.instagramHandle;
                  if (_this15.lemonHandle.pairingID) {
                    pairingID = _this15.lemonHandle.pairingID;
                  }
                  _this15.lemonID = _this15.lemonHandle.lemonID;
                }

                if (_this15.checkLiveDate(_this15.lemonLiveDate)) {
                  _context14.next = 34;
                  break;
                }

                return _context14.abrupt('return');

              case 34:
                _this15.loading = true;
                multipleMediaUrls = _this15.media ? _this15.lemonMediaUrl.map(function (m) {
                  return m.file;
                }) : [];
                reports = [];

                _this15.lemonHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSignNoLower(_this15.lemonHandle);
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context14.prev = 41;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(multipleMediaUrls);

              case 43:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context14.next = 51;
                  break;
                }

                multiMedia = _step2.value;
                _context14.next = 47;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addLemonInsights(_this15.campaignData.id, _this15.postID || '', pairingID, _this15.lemonHandle, _this15.lemonCountry, platform, _this15.lemonID, _this15.lemonLink, _this15.lemonFollowers, _this15.lemonInsights, multiMedia, _this15.lemonLiveDate, _this15.postType, _this15.postTypeName);

              case 47:
                reports = _context14.sent;

              case 48:
                _iteratorNormalCompletion2 = true;
                _context14.next = 43;
                break;

              case 51:
                _context14.next = 57;
                break;

              case 53:
                _context14.prev = 53;
                _context14.t0 = _context14['catch'](41);
                _didIteratorError2 = true;
                _iteratorError2 = _context14.t0;

              case 57:
                _context14.prev = 57;
                _context14.prev = 58;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 60:
                _context14.prev = 60;

                if (!_didIteratorError2) {
                  _context14.next = 63;
                  break;
                }

                throw _iteratorError2;

              case 63:
                return _context14.finish(60);

              case 64:
                return _context14.finish(57);

              case 65:
                _this15.$emit('addedReport', reports);
                _this15.$swal({
                  type: 'success',
                  text: 'Lemon8 Insights are added.'
                });
                _this15.lemonMediaUrl = '';
                _this15.lemonLink = '';
                _this15.lemonHandle = '';
                _this15.lemonCountry = '';
                _this15.lemonFollowers = '';
                _this15.lemonInsights = {
                  outreach: '',
                  like_count: '',
                  comment_count: '',
                  views: '',
                  watches: '',
                  shares: '',
                  bookmarks: ''
                };
                _this15.close();
                _context14.next = 82;
                break;

              case 76:
                _context14.prev = 76;
                _context14.t1 = _context14['catch'](0);

                console.error(_context14.t1);
                _this15.$swal({
                  type: 'error',
                  text: 'Failed to add Lemon8 insights'
                });
                _this15.loading = false;
                _this15.close();

              case 82:
                _context14.prev = 82;

                _this15.loading = false;
                return _context14.finish(82);

              case 85:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this15, [[0, 76, 82, 85], [41, 53, 57, 65], [58,, 60, 64]]);
      }))();
    },
    addOtherInsightsManually: function addOtherInsightsManually() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var platform, pairingID, selectedInfluencer, multipleMediaUrls, reports, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, multiMedia;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                platform = _this16.postType === 'LIP' ? 'linkedin' : _this16.postType === 'XTP' ? 'twitter' : 'others';
                pairingID = null;

                if (!(_this16.otherHandle === '' || _this16.otherHandle === null)) {
                  _context15.next = 6;
                  break;
                }

                _this16.$swal({
                  type: 'error',
                  text: 'username is required'
                });
                return _context15.abrupt('return');

              case 6:
                if (_this16.otherCountry) {
                  _context15.next = 9;
                  break;
                }

                _this16.$swal({
                  type: 'error',
                  text: 'Country is required'
                });
                return _context15.abrupt('return');

              case 9:
                if (!(_this16.otherPostURL === '')) {
                  _context15.next = 12;
                  break;
                }

                _this16.$swal({
                  type: 'error',
                  text: 'PostURL is required'
                });
                return _context15.abrupt('return');

              case 12:
                if (!(_this16.otherMediaUrl === '' && _this16.postType !== 'XTP')) {
                  _context15.next = 15;
                  break;
                }

                _this16.$swal({
                  type: 'error',
                  text: 'Media is required'
                });
                return _context15.abrupt('return');

              case 15:
                selectedInfluencer = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this16.otherHandle) === 'object' ? _this16.otherHandle : _this16.pairedInfluencers.find(function (influencer) {
                  var selectedHandle = _this16.postType === 'LIP' ? influencer.linkedinHandle : _this16.postType === 'XTP' ? influencer.twitterHandle : influencer.instagramHandle;
                  return selectedHandle === _this16.otherHandle;
                });

                if (selectedInfluencer) {
                  _this16.otherHandle = _this16.postType === 'LIP' ? selectedInfluencer.linkedinHandle || selectedInfluencer.instagramHandle : _this16.postType === 'XTP' ? selectedInfluencer.twitterHandle || selectedInfluencer.instagramHandle : selectedInfluencer.instagramHandle;
                  platform = _this16.postType === 'LIP' ? 'linkedin' : _this16.postType === 'XTP' ? 'twitter' : selectedInfluencer.platform;
                  if (selectedInfluencer.pairingID) {
                    pairingID = selectedInfluencer.pairingID;
                  }
                }
                _context15.next = 19;
                return _this16.invokePayoutCheck(_this16.otherHandle, platform, pairingID);

              case 19:
                if (_this16.checkLiveDate(_this16.otherLiveDate)) {
                  _context15.next = 21;
                  break;
                }

                return _context15.abrupt('return');

              case 21:
                _this16.otherHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(_this16.otherHandle);
                _this16.loading = true;
                multipleMediaUrls = _this16.media && _this16.otherMediaUrl.length ? _this16.otherMediaUrl.map(function (m) {
                  return m.file;
                }) : [null];

                if (_this16.postType !== 'LIP' && _this16.postType !== 'XTP' && _this16.otherTotalPlayTime) {
                  _this16.otherInsights.plays = __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__["a" /* default */].formatTikTokPlayTime(_this16.otherTotalPlayTime);
                } else if (_this16.postType === 'LIP' || _this16.postType === 'XTP') {
                  _this16.otherInsights.plays = '';
                  _this16.otherInsights.watches = '';
                  _this16.otherInsights.views = '';
                }
                reports = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context15.prev = 29;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(multipleMediaUrls);

              case 31:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context15.next = 40;
                  break;
                }

                multiMedia = _step3.value;
                _context15.next = 35;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addOtherInsights(_this16.campaignData.id, pairingID, _this16.otherHandle, _this16.otherCountry, platform, _this16.otherInsights, _this16.otherPostURL, multiMedia, _this16.otherLiveDate, _this16.postType, _this16.typeName, _this16.postID || '');

              case 35:
                reports = _context15.sent;

                _this16.$emit('addedReport', reports);

              case 37:
                _iteratorNormalCompletion3 = true;
                _context15.next = 31;
                break;

              case 40:
                _context15.next = 46;
                break;

              case 42:
                _context15.prev = 42;
                _context15.t0 = _context15['catch'](29);
                _didIteratorError3 = true;
                _iteratorError3 = _context15.t0;

              case 46:
                _context15.prev = 46;
                _context15.prev = 47;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 49:
                _context15.prev = 49;

                if (!_didIteratorError3) {
                  _context15.next = 52;
                  break;
                }

                throw _iteratorError3;

              case 52:
                return _context15.finish(49);

              case 53:
                return _context15.finish(46);

              case 54:
                _this16.$swal({
                  type: 'success',
                  text: 'Other Insights are added.'
                });
                _this16.otherHandle = '';
                _this16.otherCountry = '';
                _this16.otherPostURL = '';
                _this16.otherInsights = {
                  engagement_rate: '',
                  outreach: '',
                  like_count: '',
                  comment_count: '',
                  impressions: '',
                  views: '',
                  shares: '',
                  reach: '',
                  saved: '',
                  watches: '',
                  plays: '',
                  video_views: '',
                  profile_viewers: ''
                };
                _this16.close();
                _context15.next = 68;
                break;

              case 62:
                _context15.prev = 62;
                _context15.t1 = _context15['catch'](0);

                console.error(_context15.t1);
                _this16.$swal({
                  type: 'error',
                  text: _context15.t1
                });
                _this16.loading = false;
                _this16.close();

              case 68:
                _context15.prev = 68;

                _this16.loading = false;
                return _context15.finish(68);

              case 71:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this16, [[0, 62, 68, 71], [29, 42, 46, 54], [47,, 49, 53]]);
      }))();
    },
    processMultipleUpload: function processMultipleUpload(error, result) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var INFO, multipleMediaUrls, reports;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this17.loading = true;

                if (!(!error && result && result.event === 'success')) {
                  _context16.next = 10;
                  break;
                }

                INFO = result.info;
                multipleMediaUrls = [{ media_type: INFO.resource_type, public_id: INFO.public_id, embed_url: INFO.secure_url, thumbnail_url: INFO.thumbnail_url }];
                _context16.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addMultipleContents(_this17.campaignData.id, _this17.multipleIgHandle, multipleMediaUrls, _this17.postType, _this17.multipleLiveDate, _this17.postID || '');

              case 7:
                reports = _context16.sent;

                _this17.$emit('addedReport', reports);
                _this17.$swal({
                  type: 'success',
                  text: 'Multiple Contents are added.'
                });

              case 10:
                _this17.loading = false;
                _context16.next = 19;
                break;

              case 13:
                _context16.prev = 13;
                _context16.t0 = _context16['catch'](0);

                console.error(_context16.t0);
                _this17.$swal({
                  type: 'error',
                  text: 'Failed to multiple contents'
                });
                _this17.loading = false;
                _this17.close();

              case 19:
                _context16.prev = 19;

                _this17.loading = false;
                return _context16.finish(19);

              case 22:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this17, [[0, 13, 19, 22]]);
      }))();
    },
    saveMutlipleContents: function saveMutlipleContents() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var platform, pairingID, multipleMediaUrls, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, multiMedia, reports;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                platform = 'instagram';

                _this18.loading = true;
                pairingID = null;

                if (_this18.multipleIgHandle.pairingID) {
                  pairingID = _this18.multipleIgHandle.pairingID;
                  _this18.multipleIgHandle = _this18.multipleIgHandle.instagramHandle;
                }
                _this18.multipleIgHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(_this18.multipleIgHandle);
                multipleMediaUrls = _this18.media ? _this18.media.map(function (m) {
                  return m.file;
                }) : [];
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context17.prev = 10;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(multipleMediaUrls);

              case 12:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context17.next = 21;
                  break;
                }

                multiMedia = _step4.value;
                _context17.next = 16;
                return __WEBPACK_IMPORTED_MODULE_12__components_views_Campaign_campaignAPIs__["a" /* default */].addMultipleContents(_this18.campaignData.id, pairingID, _this18.multipleIgHandle, _this18.multipleCountry, platform, multiMedia, _this18.postType, _this18.postTypeName, _this18.multipleLiveDate, _this18.postID || '');

              case 16:
                reports = _context17.sent;

                _this18.$emit('addedReport', reports);

              case 18:
                _iteratorNormalCompletion4 = true;
                _context17.next = 12;
                break;

              case 21:
                _context17.next = 27;
                break;

              case 23:
                _context17.prev = 23;
                _context17.t0 = _context17['catch'](10);
                _didIteratorError4 = true;
                _iteratorError4 = _context17.t0;

              case 27:
                _context17.prev = 27;
                _context17.prev = 28;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 30:
                _context17.prev = 30;

                if (!_didIteratorError4) {
                  _context17.next = 33;
                  break;
                }

                throw _iteratorError4;

              case 33:
                return _context17.finish(30);

              case 34:
                return _context17.finish(27);

              case 35:
                _this18.$swal({
                  type: 'success',
                  text: 'Multiple Contents are added.'
                });
                _this18.loading = false;
                _context17.next = 45;
                break;

              case 39:
                _context17.prev = 39;
                _context17.t1 = _context17['catch'](0);

                console.error(_context17.t1);
                _this18.$swal({
                  type: 'error',
                  text: 'Failed to multiple contents'
                });
                _this18.loading = false;
                _this18.close();

              case 45:
                _context17.prev = 45;

                _this18.loading = false;
                return _context17.finish(45);

              case 48:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this18, [[0, 39, 45, 48], [10, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    gDrivePicked: function gDrivePicked(data) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                data.map(function (m) {
                  return _this19.gdriveFiles.push(m);
                });

              case 1:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this19);
      }))();
    },
    deletegDriveFile: function deletegDriveFile(index) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee19() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this20.gdriveFiles.splice(index, 1);

              case 1:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this20);
      }))();
    },
    clearEnterPost: function clearEnterPost() {
      this.storyIgHandle = '';
      this.storyMediaUrl = '';
      this.tikTokHandle = '';
      this.tikTokPostURL = '';
      this.postIgHandle = '';
      this.postImageURL = '';
      this.postURL = '';
      this.url = '';
      this.panel = [];
    },
    openCloudinaryWidget: function openCloudinaryWidget(folder) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee21() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return _this21.$store.dispatch('campaign/getCldSignature', {
                  filters: {
                    folder: folder,
                    source: 'uw' }
                });

              case 2:
                _this21.myWidget = window.cloudinary.createUploadWidget({ cloudName: _this21.cldConfig.CLOUD_NAME,
                  uploadPreset: _this21.cldConfig.UPLOAD_PRESET,
                  folder: folder,
                  thumbnailTransformation: [{ width: 320, height: 320, crop: 'fill' }],
                  sources: ['local', 'url', 'google_drive', 'facebook', 'instagram'],
                  api_key: _this21.cldConfig.API_KEY,
                  uploadSignature: _this21.cldSignature.signature,
                  uploadSignatureTimestamp: _this21.cldSignature.timestamp,
                  prepareUploadParams: function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee20(cb, params) {
                      var _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _ref3, _ref4, index, param;

                      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
                        while (1) {
                          switch (_context20.prev = _context20.next) {
                            case 0:
                              params = [].concat(params);
                              _iteratorNormalCompletion5 = true;
                              _didIteratorError5 = false;
                              _iteratorError5 = undefined;
                              _context20.prev = 4;
                              _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(params.entries());

                            case 6:
                              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                                _context20.next = 18;
                                break;
                              }

                              _ref3 = _step5.value;
                              _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                              index = _ref4[0];
                              param = _ref4[1];

                              if (!param.headers) {
                                _context20.next = 14;
                                break;
                              }

                              _context20.next = 14;
                              return _this21.$store.dispatch('campaign/getCldSignature', {
                                filters: {
                                  filename_override: param.filename_override,
                                  folder: param.folder,
                                  headers: param.headers,
                                  source: 'uw',
                                  timestamp: param.timestamp
                                }
                              });

                            case 14:
                              params[index] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                                signature: _this21.cldSignature.signature
                              });

                            case 15:
                              _iteratorNormalCompletion5 = true;
                              _context20.next = 6;
                              break;

                            case 18:
                              _context20.next = 24;
                              break;

                            case 20:
                              _context20.prev = 20;
                              _context20.t0 = _context20['catch'](4);
                              _didIteratorError5 = true;
                              _iteratorError5 = _context20.t0;

                            case 24:
                              _context20.prev = 24;
                              _context20.prev = 25;

                              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                              }

                            case 27:
                              _context20.prev = 27;

                              if (!_didIteratorError5) {
                                _context20.next = 30;
                                break;
                              }

                              throw _iteratorError5;

                            case 30:
                              return _context20.finish(27);

                            case 31:
                              return _context20.finish(24);

                            case 32:
                              cb(params.length === 1 ? params[0] : params);

                            case 33:
                            case 'end':
                              return _context20.stop();
                          }
                        }
                      }, _callee20, _this21, [[4, 20, 24, 32], [25,, 27, 31]]);
                    }));

                    return function prepareUploadParams(_x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()
                }, _this21.processMultipleUpload);
                _this21.myWidget.open();

              case 4:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this21);
      }))();
    },
    openCloudinaryUpload: function openCloudinaryUpload() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var campaignName;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!(_this22.multipleIgHandle === '')) {
                  _context22.next = 3;
                  break;
                }

                _this22.$swal({
                  type: 'error',
                  text: 'Instagram username is required'
                });
                return _context22.abrupt('return');

              case 3:
                _context22.next = 5;
                return _this22.invokePayoutCheck(_this22.multipleIgHandle);

              case 5:
                if (_this22.checkLiveDate(_this22.multipleLiveDate)) {
                  _context22.next = 7;
                  break;
                }

                return _context22.abrupt('return');

              case 7:
                campaignName = _this22.campaignData ? _this22.campaignData.name : 'Unknown Campaign';

                _this22.openCloudinaryWidget(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.escapeCldSpecialChars(campaignName) + '/@' + __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.escapeCldSpecialChars(_this22.multipleIgHandle));

              case 9:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this22);
      }))();
    },
    changeContentType: function changeContentType() {
      if (this.postType === 'IGP' || this.postType === 'IGC' || this.postType === 'IGV' || this.postType === 'IGR') {
        this.showPanel = 'post';
      } else if (this.postType === 'IGS') {
        this.showPanel = 'story';
      } else if (this.postType === 'TTP') {
        this.showPanel = 'tiktok';
      } else if (this.postType === 'YTP') {
        this.showPanel = 'youtube';
      } else if (this.postType === 'Others') {
        this.showPanel = 'Others';
      } else if (this.postType === 'LIP') {
        this.showPanel = 'LinkedIn Post';
      } else if (this.postType === 'XTP') {
        this.showPanel = 'X (Twitter) Post';
      } else if (this.postType === 'XHS') {
        this.showPanel = 'XHS Post';
      } else if (this.postType === 'Lemon8') {
        this.showPanel = 'Lemon Post';
      } else if (this.postType === 'FBP') {
        this.showPanel = 'Facebook Post';
      }
    },
    checkLiveDate: function checkLiveDate(liveDate) {
      if (!liveDate) {
        this.$swal({
          type: 'error',
          title: 'Empty Live Date',
          text: 'Please select live date'
        });
        return false;
      }
      return true;
    },
    invokePayoutCheck: function invokePayoutCheck(handle) {
      var _this23 = this;

      var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var pairingID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                payload = {
                  handle: handle,
                  platform: platform,
                  pairingID: pairingID,
                  campaign: _this23.campaignData,
                  pairedInfluencers: _this23.pairedInfluencers
                };
                _context23.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__components_views_Campaign_campaignHelper__["a" /* default */].checkPairingPayoutConfirm(_this23, payload);

              case 3:
                return _context23.abrupt('return', _context23.sent);

              case 4:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this23);
      }))();
    },
    checkXHSInf: function checkXHSInf(xhsHandle) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var payload, inf;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                payload = {
                  xhsHandle: xhsHandle
                };
                _context24.next = 3;
                return __WEBPACK_IMPORTED_MODULE_22__views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByXHSHandle(payload);

              case 3:
                inf = _context24.sent;

                if (!inf) {
                  _context24.next = 7;
                  break;
                }

                if (!inf.influencerID) {
                  _context24.next = 7;
                  break;
                }

                return _context24.abrupt('return', inf);

              case 7:
                return _context24.abrupt('return', false);

              case 8:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this24);
      }))();
    },
    checkFbInf: function checkFbInf(fbHandle) {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee25() {
        var payload, inf;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                payload = {
                  fbHandle: fbHandle
                };
                _context25.next = 3;
                return __WEBPACK_IMPORTED_MODULE_22__views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByFbHandle(payload);

              case 3:
                inf = _context25.sent;

                if (!inf) {
                  _context25.next = 7;
                  break;
                }

                if (!inf.influencerID) {
                  _context25.next = 7;
                  break;
                }

                return _context25.abrupt('return', inf);

              case 7:
                return _context25.abrupt('return', false);

              case 8:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, _this25);
      }))();
    },
    mediaChanged: function mediaChanged(media) {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee26() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _this26.media = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(media, []);

              case 1:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, _this26);
      }))();
    },
    xhsMediaChanged: function xhsMediaChanged(media) {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee27() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this27.xhsMediaUrl = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(media, []);

              case 1:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, _this27);
      }))();
    },
    lemonMediaChanged: function lemonMediaChanged(media) {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee28() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _this28.lemonMediaUrl = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(media, []);

              case 1:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, _this28);
      }))();
    },
    otherMediaChanged: function otherMediaChanged(media) {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee29() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _this29.otherMediaUrl = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(media, []);

              case 1:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, _this29);
      }))();
    },
    openUploadStatsDialog: function openUploadStatsDialog(handle, postType) {
      var _this30 = this;

      var uploadHandle = '';
      if ((typeof handle === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(handle)) === 'object') {
        uploadHandle = handle.instagramHandle;
      } else {
        uploadHandle = handle;
      }
      this.aiPostType = postType;
      if (this.campaignPayouts) {
        this.campaignPayouts.forEach(function (cPayout) {
          if (cPayout.handle === uploadHandle) {
            _this30.campaignPayout = cPayout;
          }
        });
      }
      this.uploadStatsDialog = true;
    },
    confirmedStats: function confirmedStats(statsData) {
      if (this.showPanel === 'post') {
        if (statsData.new_followers) this.inputtedInsights.reach = Number(statsData.new_followers);
        if (statsData.reached) {
          this.inputtedInsights.reach = statsData.reached;
        }
        if (statsData.likes) this.postInsights.like_count = Number(statsData.likes);
        if (statsData.comments) this.postInsights.comment_count = Number(statsData.comments);
        if (statsData.bookmarks) this.inputtedInsights.saved = Number(statsData.bookmarks);
        if (statsData.shares) this.inputtedInsights.shares = Number(statsData.shares);
      }
      if (this.showPanel === 'tiktok') {
        if (statsData.new_followers) this.tikTokInputtedInsights.reach = Number(statsData.new_followers);
        if (statsData.likes) this.tikTokInsights.like_count = Number(statsData.likes);
        if (statsData.comments) this.tikTokInsights.comment_count = Number(statsData.comments);
        if (statsData.shares) this.tikTokInsights.shares = Number(statsData.shares);
        if (statsData.bookmarks) this.tikTokInputtedInsights.saved = Number(statsData.bookmarks);
        if (statsData.video_views) {
          this.tikTokInsights.views = statsData.video_views;
        }
        if (statsData.total_play_time) {
          var playTimeParsed = this.parsePlayTime(statsData.total_play_time);
          if (playTimeParsed.length > 2) {
            this.totalPlayTime.hour = playTimeParsed[0];
            this.totalPlayTime.minute = playTimeParsed[1];
            this.totalPlayTime.second = playTimeParsed[2];
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.tikTokInputtedInsights.watches = statsData.average_watch_time_seconds;
        }
        if (statsData.watched_full_video_percentage) {
          this.tikTokInputtedInsights.watchedFullVideo = statsData.watched_full_video_percentage;
        }
      }
      if (this.postType === 'IGR') {
        if (statsData.reposts != null) {
          this.inputtedInsights.reposts = Number(statsData.reposts);
        }
        if (statsData.reached) {
          this.inputtedInsights.reach = statsData.reached;
        }
        if (statsData.video_views) {
          this.inputtedInsights.views = statsData.video_views;
        }
        if (statsData.reel_watch_time) {
          var _playTimeParsed = this.parsePlayTime(statsData.reel_watch_time);
          if (_playTimeParsed.length > 2) {
            this.reelTotalPlayTime.day = _playTimeParsed[0];
            this.reelTotalPlayTime.hour = _playTimeParsed[1];
            this.reelTotalPlayTime.minute = _playTimeParsed[2];
            this.reelTotalPlayTime.second = _playTimeParsed[3];
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.inputtedInsights.watches = statsData.average_watch_time_seconds;
        }
      }
      if (this.showPanel === 'story') {
        if (statsData.reached) {
          this.storyInsights.reach = statsData.reached;
        }
        if (statsData.replies) {
          this.storyInsights.replies = statsData.replies;
        }
        if (statsData.shares) {
          this.storyInsights.shares = statsData.shares;
        }
        if (statsData.link_clicks) {
          this.storyInsights.link_clicks = statsData.link_clicks;
        }
        if (statsData.sticker_taps) {
          this.storyInsights.sticker_taps = statsData.sticker_taps;
        }
      }
    }
  },
  watch: {
    campaign: function campaign(value) {
      var _this31 = this;

      this.campaignData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, value);
      console.log(this.campaignData);
      this.list = [];
      this.showPanel = '';
      this.postType = '';

      this.targetCountries = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.countries);
      this.fetchSelectedInfluencers(value.id);
      if (this.campaignData.targetLocation) {
        if (Array.isArray(this.campaignData.targetLocation)) {
          this.targetCountries = this.targetCountries.filter(function (t) {
            return _this31.campaignData.targetLocation.includes(t.code);
          });
        }
      }
    },
    post: function post(newPost) {
      if (!newPost) {
        return false;
      }
      this.clearEnterPost();
      var ighandle = '';
      var isTikTok = false;
      if (newPost.submitedBy) {
        if (newPost.submitedBy.tiktokHandle) {
          ighandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(newPost.submitedBy.tiktokHandle);
          isTikTok = true;
        } else {
          ighandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(newPost.submitedBy.instagramHandle);
        }
      }
      var mediaURL = newPost.images.length > 0 ? newPost.images[0].url : '';
      var postURL = newPost.postURL !== undefined ? newPost.postURL : '';
      if (newPost.postDate !== undefined) {
        this.storyLiveDate = newPost.postDate;
        this.postLiveDate = newPost.postDate;
      }
      if (newPost.type !== undefined) {
        if (newPost.type === 'story') {
          if (isTikTok) {
            this.tikTokHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(ighandle);
            this.tikTokPostURL = mediaURL;
            this.panel = [4];
          } else {
            this.storyIgHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(ighandle);
            this.storyMediaUrl = mediaURL;
            this.panel = [2];
          }
        } else if (newPost.type === 'post/carousel' || newPost.type === 'video' || newPost.type === 'post' || newPost.type === 'carousel' || newPost.type === 'reel' || newPost.type === 'tiktok' || newPost.type === 'youtube' || newPost.type === 'facebook') {
          if (isTikTok) {
            this.tikTokHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(ighandle);
            this.tikTokPostURL = mediaURL;
            this.panel = [4];
          } else {
            this.postIgHandle = __WEBPACK_IMPORTED_MODULE_17__utils__["a" /* default */].func.espaceHandleSign(ighandle);

            this.postImageURL = mediaURL;
            this.postURL = postURL;
            this.url = postURL;
            this.panel = [3];
          }
        }
      }
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditReportHandleModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    report: Object
  },
  validations: {
    updateData: {
      handle: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      platform: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      platforms: ['Instagram', 'TikTok', 'Youtube', 'Xiaohongshu', 'Facebook'],
      platformList: [{
        text: 'Instagram',
        value: 'instagram'
      }, {
        text: 'TikTok',
        value: 'tiktok'
      }, {
        text: 'Youtube',
        value: 'youtube'
      }, {
        text: 'Xiaohongshu',
        value: 'xiaohongshu'
      }, {
        text: 'Facebook',
        value: 'facebook'
      }],
      viewPlatforms: [],
      updateData: {
        handle: '',
        platform: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    updatedReport: function updatedReport(state) {
      return state.campaign.updatedReport;
    }
  })),
  watch: {
    value: function value(newValue) {
      this.updateData = {
        handle: '',
        platform: ''
      };
      this.viewPlatforms = [];
      this.getPlatformDataToView();
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                saveData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  id: _this2.report.id
                }, _this2.updateData));
                _context2.next = 4;
                return _this2.$store.dispatch('campaign/updateReportHandle', {
                  updateData: saveData
                });

              case 4:
                _this2.isLoading = false;
                if (_this2.updatedReport) {
                  _this2.$swal({
                    text: 'Successfully Updated.',
                    type: 'success'
                  });
                  _this2.$emit('saved');
                  _this2.close();
                } else {
                  _this2.$swal({
                    text: 'Error Updating Handle!',
                    type: 'error'
                  });
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPlatformDataToView: function getPlatformDataToView() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var infID, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoading = true;
                infID = null;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__views_Influencer_influencerAPIs__["a" /* default */].getInfluencerByHandles({
                  searchHandles: [_this3.report.instagram]
                });

              case 4:
                resp = _context3.sent;

                if (resp.length) {
                  resp = resp[0];
                  infID = resp.id;
                }
                __WEBPACK_IMPORTED_MODULE_5__views_Influencer_influencerAPIs__["a" /* default */].getInfluencer(infID).then(function (response) {
                  _this3.selectedInfluencerID = infID;
                  _this3.platformList = _this3.platformList.map(function (p) {
                    if (p.value === 'instagram' && response.instagram) {
                      p.handle = response.instagram.instagramHandle;
                    }
                    if (p.value === 'tiktok' && response.tiktok) {
                      p.handle = response.tiktok.tiktokHandle || '';
                    }
                    if (p.value === 'youtube' && response.youtube) {
                      p.handle = response.youtube.youtubeHandle || '';
                    }
                    if (p.value === 'facebook' && response.facebook) {
                      p.handle = response.facebook.handle || '';
                    }
                    if (p.value === 'xiaohongshu' && response.xiaohongshu) {
                      p.handle = response.xiaohongshu.xhsHandle || '';
                    }
                    return p;
                  });
                  _this3.platforms = _this3.platforms.filter(function (p) {
                    var matchPlatform = _this3.platformList.find(function (pl) {
                      if (pl.text === p && pl.handle) {
                        return true;
                      }
                      return false;
                    });
                    if (matchPlatform) return true;
                    return false;
                  });
                  _this3.isLoading = false;
                }).catch(function (error) {
                  _this3.isLoading = false;
                  console.log('error', error);
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    changePlatform: function changePlatform() {
      var _this4 = this;

      this.viewPlatforms = [];
      var matchPlatform = this.platformList.find(function (p) {
        return p.value === _this4.updateData.platform.toLowerCase();
      });
      if (matchPlatform) {
        this.viewPlatforms.push(matchPlatform.handle);
        this.updateData.handle = matchPlatform.handle;
      }
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PairingStatus',
  props: {
    status: Boolean,
    isAgree: Boolean
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    statusINVITED: function statusINVITED() {
      return this.pairingStatus.INVITED.value;
    },
    statusINTERESTED: function statusINTERESTED() {
      return this.pairingStatus.INTERESTED.value;
    },
    statusNOTINTERESTED: function statusNOTINTERESTED() {
      return this.pairingStatus.NOT_INTERESTED.value;
    },
    statusACCEPTED: function statusACCEPTED() {
      return this.pairingStatus.ACCEPTED.value;
    },
    statusNOTACCEPTED: function statusNOTACCEPTED() {
      return this.pairingStatus.NOT_ACCEPTED.value;
    },
    statusINQUIRY: function statusINQUIRY() {
      return this.pairingStatus.INQUIRY.value;
    },
    statusELIMINATION_PENDING: function statusELIMINATION_PENDING() {
      return this.pairingStatus.ELIMINATION_PENDING.value;
    }
  })
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    post: Object,
    isSelected: Boolean
  },
  data: function data() {
    return {
      show: false,
      post: null
    };
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Post__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Post__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    posts: Array,
    title: String,
    selectedPostIds: Object
  },
  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__Post___default.a
  },
  data: function data() {
    return {
      dialog: false
    };
  },

  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandleView__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandleView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandleView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__post_UploadMedia__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__post_UploadMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__post_UploadMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UploadStatsModal_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UploadStatsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__UploadStatsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(6);
























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdateInsights',
  components: {
    SocialHandleView: __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandleView___default.a,
    UploadMedia: __WEBPACK_IMPORTED_MODULE_16__post_UploadMedia___default.a,
    UploadStatsModal: __WEBPACK_IMPORTED_MODULE_17__UploadStatsModal_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default.a
  },
  props: {
    post: Object,
    value: Boolean,
    campaign: Object,
    imagesToView: Object
  },
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_15__static_sources_countries___default.a,
      isStory: false,
      isTikTok: false,
      isYoutube: false,
      isReel: false,
      isLemon: false,
      isOthers: false,
      isLinkedIn: false,
      isTwitter: false,
      storyLiveCal: false,
      postLiveCal: false,
      postData: null,
      tiktokLiveCal: false,
      youtubeLiveCal: false,
      fbLiveCal: false,
      xhsLiveCal: false,
      lemonLiveCal: false,
      uploadStatsDialog: false,
      postInsightReportID: '',
      ighandle: '',
      updateHandle: '',
      updatePlatform: '',
      platform: '',
      country: '',
      postTypes: __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].getDeliverableNames(),
      postType: '',
      mediaUrl: '',
      aiPostType: '',
      postInsightSubmittingData: {
        reportType: 'igPost',
        postURL: '',
        postImageURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0
        },
        inputtedInsights: {
          saved: 0,
          shares: 0,
          reposts: 0,
          views: 0,
          reach: 0,
          impressions: 0,
          unique_viewers: 0,
          watches: 0,
          plays: 0,
          watchedFullVideo: 0
        }
      },
      storyInsightSubmittingData: {
        reportType: 'igStory',
        media_url: '',
        live_date: '',
        insights: {
          impressions: 0,
          story_likes: 0,
          reach: 0,
          replies: 0,
          exits: 0,
          taps_back: 0,
          taps_forward: 0,
          shares: 0,
          link_clicks: 0,
          sticker_taps: 0
        }
      },
      tikTokPostInsightSubmittingData: {
        reportType: 'tikTokPost',
        postURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0
        },
        inputtedInsights: {
          saved: 0,
          shares: 0,
          views: 0,
          reach: 0,
          impressions: 0,
          watches: 0,
          plays: 0,
          watchedFullVideo: 0,
          photo_views: 0
        }
      },
      youtubePostInsightSubmittingData: {
        reportType: 'youtubePost',
        postURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0,
          views: 0
        },
        inputtedInsights: {}
      },
      fbPostInsightSubmittingData: {
        reportType: 'fbPost',
        media_url: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      },
      xhsPostInsightSubmittingData: {
        reportType: 'xhsPost',
        media_url: '',
        xhsLink: '',
        xhsFullname: '',
        xhsFollowers: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          watches: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      },
      lemonPostInsightSubmittingData: {
        reportType: 'lemonPost',
        media_url: '',
        lemonLink: '',
        lemonFullname: '',
        lemonFollowers: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          watches: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      },
      otherInsightSubmittingData: {
        reportType: 'otherPost',
        postURL: '',
        media_url: '',
        live_date: '',
        othersFullname: '',
        othersFollowers: '',
        insights: {
          engagement_rate: '',
          outreach: '',
          like_count: '',
          comment_count: '',
          views: '',
          impressions: '',
          shares: '',
          reach: '',
          saved: '',
          watches: '',
          plays: '',
          video_views: '',
          profile_viewers: ''
        }
      },
      totalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      reelTotalPlayTime: {
        day: '',
        hour: '',
        minute: '',
        second: ''
      },
      otherTotalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      isLoading: false,
      scrapingStatusMessage: '',
      pairedInfluencers: [],
      pairedInfluencersLoading: false,
      platformTypes: ['Instagram', 'TikTok', 'Youtube', 'Facebook', 'LinkedIn', 'X (Twitter)', 'Xiaohongshu', 'Lemon8']
    };
  },

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.storyInsightSubmittingData.live_date);
    },
    computedPostDateFormatted: function computedPostDateFormatted() {
      return this.formatDate(this.postInsightSubmittingData.live_date);
    },
    computedTikTokDateFormatted: function computedTikTokDateFormatted() {
      return this.formatDate(this.postInsightSubmittingData.live_date);
    },
    computedYoutubeDateFormatted: function computedYoutubeDateFormatted() {
      return this.formatDate(this.postInsightSubmittingData.live_date);
    },
    computedXHSDateFormatted: function computedXHSDateFormatted() {
      return this.formatDate(this.xhsPostInsightSubmittingData.live_date);
    },
    computedLemonDateFormatted: function computedLemonDateFormatted() {
      return this.formatDate(this.lemonPostInsightSubmittingData.live_date);
    },
    computedFacebookDateFormatted: function computedFacebookDateFormatted() {
      return this.formatDate(this.fbPostInsightSubmittingData.live_date);
    },
    computedOthersDateFormatted: function computedOthersDateFormatted() {
      return this.formatDate(this.otherInsightSubmittingData.live_date);
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
      this.storyInsightSubmittingData = {
        reportType: 'igStory',
        media_url: '',
        live_date: '',
        insights: {
          impressions: 0,
          story_likes: 0,
          reach: 0,
          replies: 0,
          exits: 0,
          taps_back: 0,
          taps_forward: 0,
          shares: 0,
          link_clicks: 0,
          sticker_taps: 0
        }
      };
      this.postInsightSubmittingData = {
        reportType: 'igPost',
        inputtedInsights: {
          saved: 0,
          shares: 0,
          reposts: 0,
          views: 0,
          reach: 0,
          impressions: 0,
          unique_viewers: 0,
          watches: 0,
          plays: 0,
          watchedFullVideo: 0
        },
        postURL: '',
        postImageURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0
        }
      };
      this.tikTokPostInsightSubmittingData = {
        reportType: 'tikTokPost',
        postURL: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0,
          shares: 0,
          views: 0
        },
        inputtedInsights: {
          saved: 0,
          reach: 0,
          impressions: 0,
          watches: 0,
          plays: 0,
          photo_views: 0
        }
      };
      this.youtubePostInsightSubmittingData = {
        reportType: 'youtubePost',
        postURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0,
          views: 0
        },
        inputtedInsights: {}
      };
      this.fbPostInsightSubmittingData = {
        reportType: 'fbPost',
        media_url: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      };
      this.xhsPostInsightSubmittingData = {
        reportType: 'xhsPost',
        media_url: '',
        xhsLink: '',
        xhsFullname: '',
        xhsFollowers: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          watches: 0,
          views: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      };
    },
    saveInputtedInsights: function saveInputtedInsights(data) {
      var _this = this;

      if (this.postInsightReportID !== '') {
        data.updateAccountOnly = true;
        if (this.updateHandle) {
          if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_typeof___default()(this.updateHandle) === 'object') {
            data.handle = this.updateHandle.displayHandle || this.updateHandle.instagramHandle;
            data.platform = this.updatePlatform === 'X (Twitter)' ? 'twitter' : this.updatePlatform.toLowerCase();
          } else {
            data.handle = this.updateHandle;
            data.platform = this.updatePlatform === 'X (Twitter)' ? 'twitter' : this.updatePlatform.toLowerCase();
          }
        }
        if (this.updateHandle === '' || this.updateHandle === null) {
          this.$swal({
            type: 'error',
            text: 'handle is required'
          });
          return;
        }
        if (!this.country) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          });
          return;
        }
        if (this.isStory) {
          if (!this.storyInsightSubmittingData.media_url && !this.storyInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            });
            return;
          }
          if (!this.storyInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            });
            return;
          }
        }
        if (this.isTikTok || this.isYoutube || this.isPost) {
          if (!this.postInsightSubmittingData.postURL) {
            this.$swal({
              type: 'error',
              text: 'Post URL is required'
            });
            return;
          }
          if (!this.postInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            });
            return;
          }
        }
        if (this.isXHS) {
          if (!this.xhsPostInsightSubmittingData.media_url && !this.xhsPostInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            });
            return;
          }
          if (!this.xhsPostInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            });
            return;
          }
        }
        if (this.isLemon) {
          if (!this.lemonPostInsightSubmittingData.media_url && !this.lemonPostInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            });
            return;
          }
          if (!this.lemonPostInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            });
            return;
          }
        }
        if (this.isLinkedIn || this.isTwitter || this.isOthers) {
          if (!this.isLinkedIn && !this.isTwitter && !this.otherInsightSubmittingData.media_url && !this.otherInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            });
            return;
          }
          if (!this.otherInsightSubmittingData.postURL) {
            this.$swal({
              type: 'error',
              text: 'Post URL is required'
            });
            return;
          }
          if (!this.otherInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            });
            return;
          }
        }
        if (this.isFacebook) {
          if (!this.fbPostInsightSubmittingData.media_url && !this.fbPostInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            });
            return;
          }
          if (!this.fbPostInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            });
            return;
          }
        }

        if (this.isTikTok) {
          data.inputtedInsights.plays = __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].formatTikTokPlayTime(this.totalPlayTime);
        }
        if (this.isReel) {
          data.inputtedInsights.plays = __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].formatReelPlayTime(this.reelTotalPlayTime);
        }
        if (this.isOthers) {
          data.insights.plays = __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].formatTikTokPlayTime(this.otherTotalPlayTime);
        }
        if (this.country) {
          data.country = this.country;
        }
        if (this.mediaUrl) {
          data.mediaUrl = this.mediaUrl;
        }
        __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignAPIs__["a" /* default */].updatePostInsights(this.postInsightReportID, data).then(function (response) {
          _this.$swal({
            title: 'Success',
            text: 'Saved Changes for this post',
            type: 'success'
          }).then(function (result) {
            _this.$emit('done');
            _this.close();
          });
        }).catch(function (error) {
          _this.$swal({
            title: 'Error',
            text: 'Error in saving report',
            type: 'error'
          });
          console.log(error);
          _this.close();
        });
      } else {
        console.log('ReportID empty');
      }
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split = date.split('/'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          day = _date$split2[0],
          month = _date$split2[1],
          year = _date$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          year = _date$split4[0],
          month = _date$split4[1],
          day = _date$split4[2];

      var formattedDate = day + '/' + month + '/' + year;
      if (formattedDate.includes('undefined')) {
        return date;
      }
      return formattedDate;
    },
    clearTotalPlayTime: function clearTotalPlayTime() {
      this.totalPlayTime = {
        hour: '',
        minute: '',
        second: ''
      };
    },
    clearReelTotalPlayTime: function clearReelTotalPlayTime() {
      this.reelTotalPlayTime = {
        day: '',
        hour: '',
        minute: '',
        second: ''
      };
    },
    fetchSelectedInfluencers: function fetchSelectedInfluencers(campaignId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, acceptedPairings, influencers, post, owner, ownerHandle, normalizedOwnerHandle, postPlatform, matchesOwnerHandle, matchesPlatform, selectedInfluencer;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__views_Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignId);

              case 3:
                resp = _context.sent;
                acceptedPairings = resp.filter(function (pairing) {
                  var pairingStatus = pairing.pairing_details && pairing.pairing_details.status;
                  return Number(pairingStatus) === Number(__WEBPACK_IMPORTED_MODULE_20__config__["a" /* default */].pairingStatus.ACCEPTED);
                });
                influencers = acceptedPairings.map(function (e) {
                  var result = {};
                  if (e.influencer_details) {
                    var infDetails = e.influencer_details;
                    var rawInfluencerPlatform = String(infDetails.platform || 'instagram').toLowerCase();
                    var influencerPlatform = rawInfluencerPlatform === 'x' ? 'twitter' : rawInfluencerPlatform;
                    var linkedinHandle = infDetails.linkedinHandle || (influencerPlatform === 'linkedin' ? infDetails.userHandle || infDetails.instagramHandle : '');
                    var twitterHandle = infDetails.twitterHandle || (influencerPlatform === 'twitter' ? infDetails.userHandle || infDetails.instagramHandle : '');
                    var displayHandle = influencerPlatform === 'linkedin' ? linkedinHandle : influencerPlatform === 'twitter' ? twitterHandle : infDetails.instagramHandle;
                    result = {
                      pairingID: e.id,
                      fullName: infDetails.fullname || infDetails.fullName,
                      originalInstagramHandle: infDetails.instagramHandle,
                      instagramHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
                      instagramAccountHandle: infDetails.igHandle || (influencerPlatform === 'instagram' ? infDetails.instagramHandle : ''),
                      tiktokHandle: infDetails.tiktokHandle || (influencerPlatform === 'tiktok' ? infDetails.userHandle || infDetails.instagramHandle : ''),
                      youtubeAccountHandle: infDetails.youtubeHandle || (influencerPlatform === 'youtube' ? infDetails.userHandle || infDetails.instagramHandle : ''),
                      facebookAccountHandle: infDetails.facebookHandle || infDetails.fbHandle || (influencerPlatform === 'facebook' ? infDetails.userHandle || infDetails.instagramHandle : ''),
                      linkedinHandle: linkedinHandle,
                      twitterHandle: twitterHandle,
                      xhsHandle: infDetails.xhsHandle || (influencerPlatform === 'xiaohongshu' ? infDetails.userHandle || infDetails.instagramHandle || infDetails.fullName : ''),
                      displayHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
                      platform: influencerPlatform,
                      xhsID: infDetails.xhsID || '',
                      instagramID: infDetails.instagramID,
                      influencerID: infDetails.influencerID
                    };
                  }
                  if (e.payout_details) {
                    result.payoutStatus = e.payout_details.status;
                  }
                  return result;
                });
                _context.next = 8;
                return _this2.expandPairedInfluencerHandles(influencers);

              case 8:
                _this2.pairedInfluencers = _context.sent;
                post = _this2.postData || {};
                owner = post.post_details && post.post_details.owner || post.owner || {};
                ownerHandle = post.profileHandle || post.profile_handle || owner.username || post.instagram;
                normalizedOwnerHandle = String(ownerHandle || '').replace(/^@+/, '').toLowerCase();
                postPlatform = _this2.getPostAccountPlatform(post);

                matchesOwnerHandle = function matchesOwnerHandle(influencer) {
                  return normalizedOwnerHandle && String(influencer.displayHandle || influencer.instagramHandle || '').replace(/^@+/, '').toLowerCase() === normalizedOwnerHandle;
                };

                matchesPlatform = function matchesPlatform(influencer) {
                  return String(influencer.platform || 'instagram').toLowerCase() === postPlatform;
                };

                selectedInfluencer = _this2.pairedInfluencers.find(function (influencer) {
                  return matchesOwnerHandle(influencer) && matchesPlatform(influencer);
                }) || _this2.pairedInfluencers.find(function (influencer) {
                  return !normalizedOwnerHandle && post.influencerID && influencer.influencerID === post.influencerID && matchesPlatform(influencer);
                });

                if (selectedInfluencer) {
                  _this2.updateHandle = selectedInfluencer;
                  _this2.changePlatform();
                } else if (ownerHandle) {
                  _this2.updateHandle = ownerHandle;
                  _this2.updatePlatform = _this2.getPlatformDisplayName(postPlatform);
                }
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 20]]);
      }))();
    },
    getInfluencerProfileHandles: function getInfluencerProfileHandles(profile, pairedInfluencer) {
      var nestedHandle = function nestedHandle(key, handleKey) {
        return profile && profile[key] && profile[key][handleKey];
      };
      var accounts = [{ platform: 'instagram', handle: profile.instagramHandle || nestedHandle('instagram', 'instagramHandle') || pairedInfluencer.instagramAccountHandle }, { platform: 'tiktok', handle: profile.tiktokHandle || nestedHandle('tiktok', 'tiktokHandle') || pairedInfluencer.tiktokHandle }, { platform: 'youtube', handle: profile.youtubeHandle || nestedHandle('youtube', 'youtubeHandle') || pairedInfluencer.youtubeAccountHandle }, { platform: 'facebook', handle: profile.facebookHandle || profile.fbHandle || nestedHandle('facebook', 'facebookHandle') || nestedHandle('facebook', 'username') || pairedInfluencer.facebookAccountHandle }, { platform: 'linkedin', handle: profile.linkedinHandle || nestedHandle('linkedin', 'linkedinHandle') || pairedInfluencer.linkedinHandle }, { platform: 'twitter', handle: profile.twitterHandle || nestedHandle('twitter', 'twitterHandle') || pairedInfluencer.twitterHandle }, { platform: 'xiaohongshu', handle: profile.xhsHandle || nestedHandle('xiaohongshu', 'xhsHandle') || pairedInfluencer.xhsHandle }, { platform: 'lemon8', handle: profile.lemon8Handle || profile.lemonHandle }];
      accounts.unshift({
        platform: pairedInfluencer.platform,
        handle: pairedInfluencer.displayHandle || pairedInfluencer.instagramHandle
      });

      var seen = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
      return accounts.filter(function (account) {
        if (!account.handle) return false;
        account.handle = String(account.handle).trim().replace(/^@+/, '');
        if (!account.handle) return false;
        var key = account.platform + ':' + account.handle.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    createPairedHandleOption: function createPairedHandleOption(pairedInfluencer, account, profileHandles) {
      var findHandle = function findHandle(platform) {
        var match = profileHandles.find(function (profileHandle) {
          return profileHandle.platform === platform;
        });
        return match ? match.handle : '';
      };
      var accountOwner = pairedInfluencer.pairingID || pairedInfluencer.influencerID || 'unpaired';
      var normalizedPlatform = String(account.platform || 'others').toLowerCase();
      var normalizedHandle = String(account.handle || '').toLowerCase();
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, pairedInfluencer, {
        platform: account.platform,
        instagramHandle: account.handle,
        displayHandle: account.handle,
        accountKey: accountOwner + ':' + normalizedPlatform + ':' + normalizedHandle,
        accountLabel: account.handle + ' (' + this.getPlatformDisplayName(normalizedPlatform) + ')',
        originalInstagramHandle: findHandle('instagram') || pairedInfluencer.originalInstagramHandle,
        linkedinHandle: account.platform === 'linkedin' ? account.handle : findHandle('linkedin'),
        twitterHandle: account.platform === 'twitter' ? account.handle : findHandle('twitter')
      });
    },
    getPlatformDisplayName: function getPlatformDisplayName(platform) {
      var names = {
        instagram: 'Instagram',
        tiktok: 'TikTok',
        youtube: 'YouTube',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        twitter: 'X (Twitter)',
        xiaohongshu: 'Xiaohongshu',
        lemon8: 'Lemon8',
        others: 'Other'
      };
      return names[String(platform || '').toLowerCase()] || platform;
    },
    getPostAccountPlatform: function getPostAccountPlatform(post) {
      var owner = post.post_details && post.post_details.owner || post.owner || {};
      var platform = String(post.profilePlatform || post.profile_platform || owner.platform || post.platform || '').trim().toLowerCase();
      var normalizedPlatform = platform === 'x' ? 'twitter' : platform;
      var accountPlatforms = ['instagram', 'tiktok', 'youtube', 'facebook', 'linkedin', 'twitter', 'xiaohongshu', 'lemon8', 'others'];
      if (accountPlatforms.includes(normalizedPlatform)) return normalizedPlatform;
      if (post.isTikTok) return 'tiktok';
      if (post.isYoutube) return 'youtube';
      if (post.isFacebook) return 'facebook';
      if (post.isXHS) return 'xiaohongshu';
      if (post.isLemon) return 'lemon8';
      var reportPlatform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_reportPlatform__["a" /* getReportPlatform */])(post);
      if (reportPlatform === 'linkedin') return 'linkedin';
      if (reportPlatform === 'twitter') return 'twitter';
      return 'instagram';
    },
    getLatestInsightData: function getLatestInsightData(post) {
      var latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null;
      var insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights || {};
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, insightData, post.currentInsight || {}, post.inputtedInsights || {});
    },
    expandPairedInfluencerHandles: function expandPairedInfluencerHandles(influencers) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var expandedGroups, seen;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.pairedInfluencersLoading = true;
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(influencers.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(pairedInfluencer) {
                    var profile, response, profileHandles;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            profile = {};

                            if (!pairedInfluencer.influencerID) {
                              _context2.next = 12;
                              break;
                            }

                            _context2.prev = 2;
                            _context2.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_13__views_Influencer_influencerAPIs__["a" /* default */].getInfluencer(pairedInfluencer.influencerID);

                          case 5:
                            response = _context2.sent;

                            profile = response && response.influencer ? response.influencer : response;
                            _context2.next = 12;
                            break;

                          case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](2);

                            console.error('Unable to load connected accounts for influencer ' + pairedInfluencer.influencerID, _context2.t0);

                          case 12:
                            profileHandles = _this3.getInfluencerProfileHandles(profile || {}, pairedInfluencer);

                            if (profileHandles.length) {
                              _context2.next = 15;
                              break;
                            }

                            return _context2.abrupt('return', [pairedInfluencer]);

                          case 15:
                            return _context2.abrupt('return', profileHandles.map(function (account) {
                              return _this3.createPairedHandleOption(pairedInfluencer, account, profileHandles);
                            }));

                          case 16:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3, [[2, 9]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 4:
                expandedGroups = _context3.sent;
                seen = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
                return _context3.abrupt('return', expandedGroups.reduce(function (options, group) {
                  return options.concat(group);
                }, []).filter(function (option) {
                  var key = (option.pairingID || option.influencerID) + ':' + option.platform + ':' + String(option.displayHandle).toLowerCase();
                  if (seen.has(key)) return false;
                  seen.add(key);
                  return true;
                }));

              case 7:
                _context3.prev = 7;

                _this3.pairedInfluencersLoading = false;
                return _context3.finish(7);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1,, 7, 10]]);
      }))();
    },
    mediaChanged: function mediaChanged(media) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (Array.isArray(media)) {
                  if (media[0]) {
                    _this4.mediaUrl = media[0].preview.src;
                  }
                }

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    openUploadStatsDialog: function openUploadStatsDialog(postType) {
      this.aiPostType = postType;
      this.uploadStatsDialog = true;
    },
    confirmedStats: function confirmedStats(statsData) {
      if (this.isPost || this.isTikTok) {
        if (statsData.new_followers) this.postInsightSubmittingData.inputtedInsights.reach = Number(statsData.new_followers);
        if (statsData.likes) this.postInsightSubmittingData.postInsights.like_count = Number(statsData.likes);
        if (statsData.comments) this.postInsightSubmittingData.postInsights.comment_count = Number(statsData.comments);
        if (statsData.bookmarks) this.postInsightSubmittingData.inputtedInsights.saved = Number(statsData.bookmarks);
      }
      if (this.isPost) {
        if (statsData.shares) this.postInsightSubmittingData.inputtedInsights.shares = Number(statsData.shares);
      }
      if (this.isTikTok) {
        if (statsData.total_play_time) {
          var playTimeParsed = this.parsePlayTime(statsData.total_play_time);
          if (playTimeParsed.length > 2) {
            this.totalPlayTime.hour = playTimeParsed[0];
            this.totalPlayTime.minute = playTimeParsed[1];
            this.totalPlayTime.second = playTimeParsed[2];
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.postInsightSubmittingData.inputtedInsights.watches = statsData.average_watch_time_seconds;
        }
        if (statsData.shares) this.postInsightSubmittingData.postInsights.shares = Number(statsData.shares);
        if (statsData.video_views) {
          this.postInsightSubmittingData.postInsights.views = statsData.video_views;
        }
        if (statsData.watched_full_video_percentage) {
          this.postInsightSubmittingData.inputtedInsights.watchedFullVideo = statsData.watched_full_video_percentage;
        }
      }
      if (this.isReel) {
        if (statsData.reposts != null) {
          this.postInsightSubmittingData.inputtedInsights.reposts = Number(statsData.reposts);
        }
        if (statsData.reached) {
          this.postInsightSubmittingData.inputtedInsights.reach = statsData.reached;
        }
        if (statsData.video_views) {
          this.postInsightSubmittingData.inputtedInsights.views = statsData.video_views;
        }
        if (statsData.reel_watch_time) {
          var _playTimeParsed = this.parsePlayTime(statsData.reel_watch_time);
          if (_playTimeParsed.length > 2) {
            this.reelTotalPlayTime.day = _playTimeParsed[0];
            this.reelTotalPlayTime.hour = _playTimeParsed[1];
            this.reelTotalPlayTime.minute = _playTimeParsed[2];
            this.reelTotalPlayTime.second = _playTimeParsed[3];
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.postInsightSubmittingData.inputtedInsights.watches = statsData.average_watch_time_seconds;
        }
      }
      if (this.isStory) {
        if (statsData.reached) {
          this.storyInsightSubmittingData.insights.reach = statsData.reached;
        }
        if (statsData.replies) {
          this.storyInsightSubmittingData.insights.replies = statsData.replies;
        }
        if (statsData.shares) {
          this.storyInsightSubmittingData.insights.shares = statsData.shares;
        }
        if (statsData.link_clicks) {
          this.storyInsightSubmittingData.insights.link_clicks = statsData.link_clicks;
        }
        if (statsData.sticker_taps) {
          this.storyInsightSubmittingData.insights.sticker_taps = statsData.sticker_taps;
        }
      }
    },
    parsePlayTime: function parsePlayTime(playTime) {
      var timeArray = [];
      var hours = 0;
      var minutes = 0;
      var seconds = 0;

      var currentNum = '';
      for (var i = 0; i < playTime.length; i++) {
        var char = playTime[i];

        if (!isNaN(char)) {
          currentNum += char;
        } else {
          if (currentNum) {
            if (char === 'h') {
              hours = parseInt(currentNum, 10);
            } else if (char === 'm') {
              minutes = parseInt(currentNum, 10);
            } else if (char === 's') {
              seconds = parseInt(currentNum, 10);
            }
            currentNum = '';
          }
        }
      }

      timeArray.push(hours, minutes, seconds);
      return timeArray;
    },
    changePlatform: function changePlatform() {
      if (this.updateHandle && this.updateHandle.platform) {
        var platform = String(this.updateHandle.platform).toLowerCase();
        if (platform === 'tiktok') {
          this.updatePlatform = 'TikTok';
        } else if (platform === 'linkedin') {
          this.updatePlatform = 'LinkedIn';
        } else if (platform === 'twitter' || platform === 'x') {
          this.updatePlatform = 'X (Twitter)';
        } else if (platform === 'youtube') {
          this.updatePlatform = 'Youtube';
        } else if (platform === 'xiaohongshu') {
          this.updatePlatform = 'Xiaohongshu';
        } else if (platform === 'lemon8') {
          this.updatePlatform = 'Lemon8';
        } else {
          this.updatePlatform = platform.charAt(0).toUpperCase() + platform.slice(1);
        }
      }
    },
    logScrapingStatus: function logScrapingStatus(message) {
      this.scrapingStatusMessage = message;
      console.log('[UpdateInsightsModal][STATUS] ' + message);
    },
    getScrapeTargetLink: function getScrapeTargetLink() {
      if (this.isTikTok || this.isYoutube || this.isPost) {
        return this.postInsightSubmittingData.postURL;
      }
      if (this.isLinkedIn || this.isTwitter || this.isOthers) {
        return this.otherInsightSubmittingData.postURL;
      }
      var post = this.post || {};
      if (this.isXHS) {
        return this.xhsPostInsightSubmittingData.xhsLink || (post.post_details ? post.post_details.link : '');
      }
      if (this.isLemon) {
        return this.lemonPostInsightSubmittingData.lemonLink || (post.post_details ? post.post_details.link : '');
      }
      return (post.post_details ? post.post_details.link : '') || post.link || '';
    },
    scrapComments: function scrapComments(link, postID) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var platform, result, target, _arr, _i, key, value, manualField;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!link || !postID)) {
                  _context5.next = 3;
                  break;
                }

                _this5.$swal({ title: 'Info', text: 'A post link and report ID are required for extraction.', type: 'info' });
                return _context5.abrupt('return', false);

              case 3:
                platform = _this5.isTikTok ? 'tiktok' : _this5.isYoutube ? 'youtube' : _this5.isPost || _this5.isReel ? 'instagram' : null;

                if (platform) {
                  _context5.next = 7;
                  break;
                }

                _this5.$swal({ title: 'Info', text: 'Only Instagram posts/reels, TikTok, and YouTube support public extraction.', type: 'info' });
                return _context5.abrupt('return', false);

              case 7:
                _this5.isLoading = true;
                _context5.prev = 8;
                _context5.next = 11;
                return __WEBPACK_IMPORTED_MODULE_11__views_Campaign_campaignAPIs__["a" /* default */].extractReportPost(link, platform);

              case 11:
                result = _context5.sent;
                target = _this5.postInsightSubmittingData;
                _arr = ['like_count', 'comment_count', 'shares', 'saved', 'views'];
                _i = 0;

              case 15:
                if (!(_i < _arr.length)) {
                  _context5.next = 25;
                  break;
                }

                key = _arr[_i];
                value = result.insights && result.insights[key];

                if (!(typeof value !== 'number' || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_finite___default()(value) || value < 0)) {
                  _context5.next = 20;
                  break;
                }

                return _context5.abrupt('continue', 22);

              case 20:
                manualField = key === 'saved' || key === 'shares' && platform === 'instagram' || key === 'views' && _this5.isReel;

                _this5.$set(manualField ? target.inputtedInsights : target.postInsights, key, value);

              case 22:
                _i++;
                _context5.next = 15;
                break;

              case 25:
                _this5.logScrapingStatus('Public metrics extracted. Review them before saving.');
                return _context5.abrupt('return', true);

              case 29:
                _context5.prev = 29;
                _context5.t0 = _context5['catch'](8);

                _this5.$swal({ title: 'Error', text: _context5.t0.response && _context5.t0.response.data && _context5.t0.response.data.message || _context5.t0.message || 'Failed to extract public metrics.', type: 'error' });
                return _context5.abrupt('return', false);

              case 33:
                _context5.prev = 33;

                _this5.isLoading = false;
                return _context5.finish(33);

              case 36:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[8, 29, 33, 36]]);
      }))();
    }
  },
  mounted: function mounted() {},

  watch: {
    post: function post(newPost) {
      var _this6 = this;

      if (!newPost) {
        this.postData = null;
        this.postInsightReportID = '';
        return;
      }
      this.postData = newPost;
      this.postInsightReportID = newPost.id;
      this.isStory = false;
      this.isTikTok = false;
      this.isYoutube = false;
      this.isReel = false;
      this.isPost = false;
      this.isXHS = false;
      this.isFacebook = false;
      this.isLemon = false;
      this.isOthers = false;
      this.isLinkedIn = false;
      this.isTwitter = false;
      this.updateHandle = '';
      this.updatePlatform = '';
      this.postType = '';
      this.country = '';
      this.mediaUrl = '';
      this.fetchSelectedInfluencers(newPost.campaignID);
      this.clearTotalPlayTime();
      this.clearReelTotalPlayTime();
      this.targetCountries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.countries);
      if (newPost.postType) this.postType = newPost.postType;
      if (newPost.instagram) this.updateHandle = newPost.instagram;
      if (newPost.country) {
        this.country = newPost.country;
      } else {
        this.country = this.targetCountries[0].name;
      }
      if (this.campaign && this.campaign.targetLocation) {
        if (Array.isArray(this.campaign.targetLocation)) {
          this.targetCountries = this.targetCountries.filter(function (t) {
            return _this6.campaign.targetLocation.includes(t.code);
          });
        }
      }
      if (newPost.isStory || newPost.isMultipleContents) {
        this.isStory = true;
        this.platform = 'instagram';
        this.updatePlatform = this.getPlatformDisplayName(this.getPostAccountPlatform(newPost));
        this.ighandle = newPost.owner.username;
        if (newPost.isMultipleContents) {
          this.storyInsightSubmittingData.embed_url = newPost.embed_url;
        } else {
          this.storyInsightSubmittingData.media_url = newPost.media_url;
        }
        this.storyInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        if (newPost.insights) {
          this.storyInsightSubmittingData.insights.impressions = newPost.insights.impressions;
          this.storyInsightSubmittingData.insights.story_likes = newPost.insights.story_likes;
          this.storyInsightSubmittingData.insights.reach = newPost.insights.reach;
          this.storyInsightSubmittingData.insights.replies = newPost.insights.replies;
          this.storyInsightSubmittingData.insights.exits = newPost.insights.exits;
          this.storyInsightSubmittingData.insights.taps_back = newPost.insights.taps_back;
          this.storyInsightSubmittingData.insights.taps_forward = newPost.insights.taps_forward;
          this.storyInsightSubmittingData.insights.shares = newPost.insights.shares || 0;
          this.storyInsightSubmittingData.insights.link_clicks = newPost.insights.link_clicks;
          this.storyInsightSubmittingData.insights.sticker_taps = newPost.insights.sticker_taps;
        }
      } else if (newPost.isTikTok) {
        this.isStory = false;
        this.isTikTok = true;
        this.isYoutube = false;
        this.isLemon = false;
        this.isPost = false;
        this.isOthers = false;
        this.platform = 'tiktok';
        this.updatePlatform = this.getPlatformDisplayName(this.getPostAccountPlatform(newPost));
        this.ighandle = newPost.owner.username;
        this.postInsightSubmittingData.reportType = 'tikTokPost';
        this.postInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        if (newPost.post_details) {
          this.postInsightSubmittingData.postURL = newPost.post_details.link;
        }
        if (newPost.inputtedInsights) {
          this.postInsightSubmittingData.inputtedInsights.saved = newPost.inputtedInsights.saved;
          this.postInsightSubmittingData.postInsights['shares'] = newPost.inputtedInsights.shares || 0;
          this.postInsightSubmittingData.postInsights['views'] = newPost.inputtedInsights.views || 0;
          this.postInsightSubmittingData.inputtedInsights.reach = newPost.inputtedInsights.reach || 0;
          this.postInsightSubmittingData.inputtedInsights.impressions = newPost.inputtedInsights.impressions || 0;
          this.postInsightSubmittingData.inputtedInsights.watchedFullVideo = newPost.inputtedInsights.watchedFullVideo || '';
          this.postInsightSubmittingData.inputtedInsights.photo_views = newPost.inputtedInsights.photo_views || 0;
          this.postInsightSubmittingData.inputtedInsights.watches = newPost.inputtedInsights.watches ? __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].formatWatchTime(newPost.inputtedInsights.watches) : 0;
          this.totalPlayTime = newPost.inputtedInsights.plays ? __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].parseTikTokPlayTime(newPost.inputtedInsights.plays) : this.totalPlayTime;
        }
        if (newPost.currentInsight) {
          this.postInsightSubmittingData.postInsights['engagement_rate'] = newPost.currentInsight.engagement_rate;
          this.postInsightSubmittingData.postInsights['outreach'] = newPost.currentInsight.outreach;
          this.postInsightSubmittingData.postInsights['like_count'] = newPost.currentInsight.like_count;
          this.postInsightSubmittingData.postInsights['comment_count'] = newPost.currentInsight.comment_count;
          if (this.postInsightSubmittingData.postInsights['shares'] === 0) {
            this.postInsightSubmittingData.postInsights['shares'] = newPost.currentInsight.shares || 0;
          }
          if (this.postInsightSubmittingData.postInsights['views'] === 0) {
            this.postInsightSubmittingData.postInsights['views'] = newPost.currentInsight.views || 0;
          }
        }
      } else if (newPost.isYoutube) {
        this.isStory = false;
        this.isTikTok = false;
        this.isYoutube = true;
        this.isLemon = false;
        this.isPost = false;
        this.isOthers = false;
        this.platform = 'youtube';
        this.updatePlatform = 'Youtube';
        this.ighandle = newPost.owner.username;
        this.postInsightSubmittingData.reportType = 'youtubePost';
        this.postInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        if (newPost.post_details) {
          this.postInsightSubmittingData.postURL = newPost.post_details.link;
        }
        if (newPost.inputtedInsights) {
          this.postInsightSubmittingData.inputtedInsights.impressions = newPost.inputtedInsights.impressions || 0;
          this.postInsightSubmittingData.inputtedInsights.unique_viewers = newPost.inputtedInsights.unique_viewers || 0;
          this.postInsightSubmittingData.inputtedInsights.watches = newPost.inputtedInsights.watches || 0;
        }
        if (newPost.currentInsight) {
          this.postInsightSubmittingData.postInsights['engagement_rate'] = newPost.currentInsight.engagement_rate;
          this.postInsightSubmittingData.postInsights['outreach'] = newPost.currentInsight.outreach;
          this.postInsightSubmittingData.postInsights['like_count'] = newPost.currentInsight.like_count;
          this.postInsightSubmittingData.postInsights['comment_count'] = newPost.currentInsight.comment_count;
          this.postInsightSubmittingData.postInsights['views'] = newPost.currentInsight.views || 0;
        }
      } else if (newPost.isFacebook) {
        this.isStory = false;
        this.isTikTok = false;
        this.isYoutube = false;
        this.isXHS = false;
        this.isLemon = false;
        this.isPost = false;
        this.isOthers = false;
        this.isFacebook = true;
        this.platform = 'facebook';
        this.updatePlatform = 'Facebook';
        this.ighandle = newPost.owner.username;
        this.fbPostInsightSubmittingData.reportType = 'facebookPost';
        this.fbPostInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        this.fbPostInsightSubmittingData.media_url = newPost.media_url;
        if (newPost.insights) {
          this.fbPostInsightSubmittingData.insights.outreach = newPost.insights.outreach;
          this.fbPostInsightSubmittingData.insights.like_count = newPost.insights.like_count;
          this.fbPostInsightSubmittingData.insights.comment_count = newPost.insights.comment_count;
          this.fbPostInsightSubmittingData.insights.views = newPost.insights.views;
          this.fbPostInsightSubmittingData.insights.shares = newPost.insights.shares;
          this.fbPostInsightSubmittingData.insights.bookmarks = newPost.insights.bookmarks;
        }
      } else if (newPost.isXHS) {
        this.isStory = false;
        this.isTikTok = false;
        this.isYoutube = false;
        this.isFacebook = false;
        this.isLemon = false;
        this.isPost = false;
        this.isOthers = false;
        this.isXHS = true;
        this.platform = 'xiaohongshu';
        this.updatePlatform = 'Xiaohongshu';
        this.ighandle = newPost.owner.username;
        this.xhsPostInsightSubmittingData.reportType = 'xhsPost';
        this.xhsPostInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        this.xhsPostInsightSubmittingData.embed_url = newPost.embed_url || '';
        this.xhsPostInsightSubmittingData.xhsLink = newPost.xhsLink;
        this.xhsPostInsightSubmittingData.xhsFullname = newPost.owner.fullName;
        this.xhsPostInsightSubmittingData.xhsFollowers = newPost.owner.followers;
        if (newPost.insights) {
          this.xhsPostInsightSubmittingData.insights.outreach = newPost.insights.outreach;
          this.xhsPostInsightSubmittingData.insights.like_count = newPost.insights.like_count;
          this.xhsPostInsightSubmittingData.insights.comment_count = newPost.insights.comment_count;
          this.xhsPostInsightSubmittingData.insights.views = newPost.insights.views;
          this.xhsPostInsightSubmittingData.insights.watches = newPost.insights.watches;
          this.xhsPostInsightSubmittingData.insights.shares = newPost.insights.shares;
          this.xhsPostInsightSubmittingData.insights.bookmarks = newPost.insights.bookmarks;
        }
      } else if (newPost.isLemon) {
        this.isStory = false;
        this.isTikTok = false;
        this.isYoutube = false;
        this.isFacebook = false;
        this.isXHS = false;
        this.isPost = false;
        this.isOthers = false;
        this.isLemon = true;
        this.platform = 'lemon8';
        this.updatePlatform = 'Lemon8';
        this.ighandle = newPost.owner.username;
        this.lemonPostInsightSubmittingData.reportType = 'lemonPost';
        this.lemonPostInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        this.lemonPostInsightSubmittingData.embed_url = newPost.embed_url || '';
        this.lemonPostInsightSubmittingData.lemonLink = newPost.lemonLink;
        this.lemonPostInsightSubmittingData.lemonFullname = newPost.owner.fullName;
        this.lemonPostInsightSubmittingData.lemonFollowers = newPost.owner.followers;
        if (newPost.insights) {
          this.lemonPostInsightSubmittingData.insights.outreach = newPost.insights.outreach;
          this.lemonPostInsightSubmittingData.insights.like_count = newPost.insights.like_count;
          this.lemonPostInsightSubmittingData.insights.comment_count = newPost.insights.comment_count;
          this.lemonPostInsightSubmittingData.insights.views = newPost.insights.views;
          this.lemonPostInsightSubmittingData.insights.watches = newPost.insights.watches;
          this.lemonPostInsightSubmittingData.insights.shares = newPost.insights.shares;
          this.lemonPostInsightSubmittingData.insights.bookmarks = newPost.insights.bookmarks;
        }
      } else if (['linkedin', 'twitter'].includes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_reportPlatform__["a" /* getReportPlatform */])(newPost)) || newPost.isOthers) {
        this.isStory = false;
        this.isTikTok = false;
        this.isYoutube = false;
        this.isFacebook = false;
        this.isXHS = false;
        this.isPost = false;
        this.isLemon = false;
        var reportPlatform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_reportPlatform__["a" /* getReportPlatform */])(newPost);
        this.isLinkedIn = reportPlatform === 'linkedin';
        this.isTwitter = reportPlatform === 'twitter';
        this.isOthers = reportPlatform === 'others' || !this.isLinkedIn && !this.isTwitter;
        this.platform = newPost.platform || 'others';
        this.updatePlatform = this.isLinkedIn ? 'LinkedIn' : this.isTwitter ? 'X (Twitter)' : 'Others';
        this.ighandle = newPost.owner.username;
        this.otherInsightSubmittingData.reportType = 'otherPost';
        this.otherInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        var postUrl = newPost.postLink || newPost.postURL || newPost.post_details || '';
        this.otherInsightSubmittingData.postURL = typeof postUrl === 'string' ? postUrl : postUrl.link || postUrl.url || postUrl.href || '';
        this.otherInsightSubmittingData.embed_url = newPost.embed_url || '';
        this.otherInsightSubmittingData.othersFullname = newPost.owner.fullName;
        this.otherInsightSubmittingData.othersFollowers = newPost.owner.followers;
        var insights = this.getLatestInsightData(newPost);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(insights).length) {
          this.otherInsightSubmittingData.insights.outreach = insights.outreach;
          this.otherInsightSubmittingData.insights.like_count = insights.like_count;
          this.otherInsightSubmittingData.insights.comment_count = insights.comment_count;
          this.otherInsightSubmittingData.insights.views = insights.views;
          this.otherInsightSubmittingData.insights.impressions = insights.impressions != null ? insights.impressions : this.isTwitter ? insights.views : '';
          this.otherInsightSubmittingData.insights.reach = insights.reach != null ? insights.reach : insights.outreach;
          this.otherInsightSubmittingData.insights.watches = insights.watches;
          this.otherInsightSubmittingData.insights.shares = insights.shares;
          this.otherInsightSubmittingData.insights.saved = insights.saved;
          this.otherInsightSubmittingData.insights.plays = insights.plays;
          this.otherInsightSubmittingData.insights.video_views = insights.video_views;
          this.otherInsightSubmittingData.insights.profile_viewers = insights.profile_viewers;
          this.otherInsightSubmittingData.insights.engagement_rate = insights.engagement_rate;
          this.otherTotalPlayTime = insights.plays ? __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].parseTikTokPlayTime(insights.plays) : this.otherTotalPlayTime;
        }
      } else {
        this.isStory = false;
        this.isTikTok = false;
        this.isYoutube = false;
        this.isFacebook = false;
        this.isXHS = false;
        this.isLemon = false;
        this.isOthers = false;
        this.isPost = true;
        this.platform = 'instagram';
        this.updatePlatform = this.getPlatformDisplayName(this.getPostAccountPlatform(newPost));
        this.updateHandle = newPost.profileHandle || newPost.profile_handle || newPost.post_details && newPost.post_details.owner && newPost.post_details.owner.username || newPost.instagram || '';
        this.postInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || '';
        if (newPost.post_details) {
          this.ighandle = newPost.post_details.owner.username;
          this.postInsightSubmittingData.postURL = newPost.post_details.link;
          this.postInsightSubmittingData.postImageURL = newPost.post_details.image || '';
        }
        if (newPost.inputtedInsights) {
          this.postInsightSubmittingData.inputtedInsights.saved = newPost.inputtedInsights.saved;
          this.postInsightSubmittingData.inputtedInsights.shares = newPost.inputtedInsights.shares;
          this.postInsightSubmittingData.inputtedInsights.reposts = newPost.inputtedInsights.reposts || 0;
          this.postInsightSubmittingData.inputtedInsights.views = newPost.inputtedInsights.views || 0;
          this.postInsightSubmittingData.inputtedInsights.reach = newPost.inputtedInsights.reach || 0;
          this.postInsightSubmittingData.inputtedInsights.impressions = newPost.inputtedInsights.impressions || 0;
          this.postInsightSubmittingData.inputtedInsights.watches = newPost.inputtedInsights.watches || 0;
          if (newPost.postType === 'IGR') {
            this.isReel = true;
            this.reelTotalPlayTime = newPost.inputtedInsights.plays ? __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */].parseReelPlayTime(newPost.inputtedInsights.plays) : this.reelTotalPlayTime;
          }
        }
        if (newPost.currentInsight) {
          this.postInsightSubmittingData.postInsights['engagement_rate'] = newPost.currentInsight.engagement_rate;
          this.postInsightSubmittingData.postInsights['outreach'] = newPost.currentInsight.outreach;
          this.postInsightSubmittingData.postInsights['like_count'] = newPost.currentInsight.like_count;
          this.postInsightSubmittingData.postInsights['comment_count'] = newPost.currentInsight.comment_count;
        }
      }
    }
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__post_UploadMediaForStats__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__post_UploadMediaForStats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__post_UploadMediaForStats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniq__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_uniq__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadStatsModal',
  components: {
    UploadMedia: __WEBPACK_IMPORTED_MODULE_5__post_UploadMediaForStats___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    postType: String,
    imagesToView: Object
  },
  data: function data() {
    return {
      media: [],
      uploadMedias: [],
      selectedImages: [],
      mediaUrl: '',
      dataResult: null,
      isLoading: false,
      previewMedia: '',
      imageViewerDialog: false,
      checkedContent: false,
      checkedStory: false,
      checkedPost: false,
      base64Image: '',
      checkbox: {
        content: ''
      },
      activeTab: null
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue === true) {
        this.media = [];
        this.mediaUrl = '';
        this.dataResult = null;
        this.selectedImages = [];
      }
    }
  },
  computed: {
    hasPosts: function hasPosts() {
      if (this.imagesToView) {
        if (this.imagesToView.posts && this.imagesToView.posts.length > 0) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.imagesToView.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var post = _step.value;

              if (post.instagramPostURL !== '' || post.images && post.images.length > 0) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
      return false;
    },
    hasStories: function hasStories() {
      if (this.imagesToView) {
        if (this.imagesToView.stories && this.imagesToView.stories.length > 0) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.imagesToView.stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var post = _step2.value;

              if (post.label !== '' || post.images && post.images.length > 0) {
                return true;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }
      return false;
    },
    hasDeliverablePosts: function hasDeliverablePosts() {
      if (this.imagesToView) {
        if (this.imagesToView.deliverablePosts && this.imagesToView.deliverablePosts.length > 0) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.imagesToView.deliverablePosts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var allPosts = _step3.value;
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(allPosts.posts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var post = _step4.value;

                  if (post.label !== '' || post.images && post.images.length > 0) {
                    return true;
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      }
      return false;
    }
  },
  methods: {
    confirmStats: function confirmStats() {
      this.closeModal();
      this.$emit('statsConfirmed', this.dataResult);
      return;
    },
    closeModal: function closeModal() {
      this.$emit('input');
    },
    mediaChanged: function mediaChanged(media) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.uploadMedias = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], media);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    extractData: function extractData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var vm, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, ret;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                vm = _this2;

                if (!_this2.selectedImages.length) {
                  _context2.next = 23;
                  break;
                }

                vm.selectedImages = __WEBPACK_IMPORTED_MODULE_8_lodash_uniq___default()(vm.selectedImages);
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context2.prev = 7;
                for (_iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this2.selectedImages); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  ret = _step5.value;

                  _this2.uploadMedias.push(ret);
                }
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError5 = true;
                _iteratorError5 = _context2.t0;

              case 15:
                _context2.prev = 15;
                _context2.prev = 16;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 18:
                _context2.prev = 18;

                if (!_didIteratorError5) {
                  _context2.next = 21;
                  break;
                }

                throw _iteratorError5;

              case 21:
                return _context2.finish(18);

              case 22:
                return _context2.finish(15);

              case 23:
                vm.uploadMedias = vm.uploadMedias.filter(function (v) {
                  return v !== '';
                });

                if (vm.uploadMedias.length) {
                  _context2.next = 26;
                  break;
                }

                return _context2.abrupt('return');

              case 26:
                if (!Array.isArray(vm.uploadMedias)) {
                  _context2.next = 33;
                  break;
                }

                vm.uploadMedias = vm.uploadMedias.map(function (m) {
                  if (m.preview) {
                    if (m.preview.src) {
                      m = m.preview.src;
                    }
                  }
                  return m;
                });

                if (!vm.uploadMedias.length) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 31;
                return __WEBPACK_IMPORTED_MODULE_6__views_Campaign_campaignAPIs__["a" /* default */].uploadAIStatsData({
                  medias: vm.uploadMedias
                });

              case 31:
                vm.dataResult = _context2.sent;

                vm.uploadMedias = [];

              case 33:
                vm.isLoading = false;

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 11, 15, 23], [16,, 18, 22]]);
      }))();
    },
    viewMedia: function viewMedia(media) {
      this.imageViewerDialog = true;
      this.activeImage = media;
    },
    toggleImage: function toggleImage(img) {
      if (!this.selectedImages.includes(img)) {
        this.selectedImages = this.selectedImages.filter(function (s) {
          return s !== img;
        });
      } else {
        this.selectedImages.push(img);
      }
    },
    changeContentImage: function changeContentImage(posts) {
      var _this3 = this;

      this.selectedImages = [];
      if (this.checkedContent) {
        this.checkedContent = false;
      } else {
        this.checkbox.story = '';
        this.checkbox.post = '';
        this.checkedContent = true;
      }
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var post = _step6.value;

          var _loop = function _loop(image) {
            if (_this3.checkbox.content) {
              if (!image.isvideo) {
                _this3.selectedImages.push(image.url);
              }
            } else {
              _this3.selectedImages = _this3.selectedImages.filter(function (sImg) {
                return sImg !== image.url;
              });
            }
          };

          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(post.images), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var image = _step7.value;

              _loop(image);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    changeStoryImage: function changeStoryImage(posts) {
      var _this4 = this;

      this.selectedImages = [];
      if (this.checkedStory) {
        this.checkedStory = false;
      } else {
        this.checkbox.post = '';
        this.checkbox.content = '';
        this.checkedStory = true;
      }
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var post = _step8.value;

          var _loop2 = function _loop2(image) {
            if (_this4.checkbox.story) {
              if (!image.isvideo) {
                _this4.selectedImages.push(image.url);
              }
            } else {
              _this4.selectedImages = _this4.selectedImages.filter(function (sImg) {
                return sImg !== image.url;
              });
            }
          };

          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(post.images), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var image = _step9.value;

              _loop2(image);
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    },
    changePostImage: function changePostImage(posts) {
      var _this5 = this;

      this.selectedImages = [];
      if (this.checkedPost) {
        this.checkedPost = false;
      } else {
        this.checkbox.story = '';
        this.checkbox.content = '';
        this.checkedPost = true;
      }
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(posts), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var post = _step10.value;

          var _loop3 = function _loop3(image) {
            if (_this5.checkbox.post) {
              if (!image.isvideo) {
                _this5.selectedImages.push(image.url);
              }
            } else {
              _this5.selectedImages = _this5.selectedImages.filter(function (sImg) {
                return sImg !== image.url;
              });
            }
          };

          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(post.images), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var image = _step11.value;

              _loop3(image);
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    },
    convertImageToBase64: function convertImageToBase64(imageUrl) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, blob, reader, base64Image;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fetch(imageUrl);

              case 3:
                response = _context3.sent;
                _context3.next = 6;
                return response.blob();

              case 6:
                blob = _context3.sent;
                reader = new FileReader();

                reader.readAsDataURL(blob);
                _context3.next = 11;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  reader.onloadend = function () {
                    return resolve(reader.result);
                  };
                  reader.onerror = reject;
                });

              case 11:
                base64Image = _context3.sent;
                return _context3.abrupt('return', base64Image);

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](0);

                console.error('Error converting image to Base64:', _context3.t0);

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 15]]);
      }))();
    },
    getPostType: function getPostType(type) {
      if (type === 'IGS') {
        return 'label';
      } else return 'url';
    },
    filterEmptyPosts: function filterEmptyPosts(posts) {
      posts = posts.filter(function (post) {
        if (post.label || post.images.length > 0) {
          return true;
        }
        return false;
      });
      return posts;
    },
    getLongPostTitle: function getLongPostTitle(title) {
      if (title === 'TTP') {
        return 'TikTok Post';
      } else if (title === 'IGP') {
        return 'IG Post';
      } else if (title === 'IGC') {
        return 'IG Carousel';
      } else if (title === 'IGS') {
        return 'IG Story';
      } else if (title === 'IGV') {
        return 'IG Video';
      } else if (title === 'IGR') {
        return 'IG Reel';
      } else return title;
    },
    getMediaType: function getMediaType(mediaUrl) {
      var videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4'];
      var images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP'];
      var url = new URL(mediaUrl);
      var extension = url.pathname.split('.')[4];
      if (videos.includes(extension)) {
        return 'video';
      } else if (images.includes(extension)) {
        return 'image';
      } else {
        return 'image';
      }
    }
  }
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BtnDownload',
  props: {
    url: String,
    label: String,
    className: String,
    noBlock: Boolean
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    download: function download(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var link;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (url) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                link = document.createElement('a');

                link.href = url;
                link.download = url.substr(url.lastIndexOf('/') + 1);
                link.click();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CustomFileUpload',
  data: function data() {
    return {
      uploadFiles: [],
      deleteObjectKeys: [],
      tmpImages: [],
      tmpFiles: [],
      actualMedias: []
    };
  },

  props: ['refresh', 'multiple', 'title'],
  watch: {
    refresh: function refresh(newRefresh) {
      this.resetUpload();
    }
  },
  computed: {
    checkDisable: function checkDisable() {
      if (!this.multiple) {
        return this.actualMedias.length > 0;
      }
      return false;
    }
  },
  methods: {
    prepareUpload: function prepareUpload(e) {
      var _this = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var mediaType = element.type.split('/')[0];

        if (mediaType === 'image') {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buff = e.target.result;
            var file = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
            _this.actualMedias.push(file);
            _this.tmpImages.push({
              url: buff,
              src: buff,
              name: element.name
            });
            _this.updateMedias();
          };

          e.target.value = '';
        } else {
          _this.tmpFiles.push(element);
          _this.actualMedias.push(element);
          var _reader = new FileReader();
          _reader.readAsArrayBuffer(element);
          e.target.value = '';
          _this.updateMedias();
        }
      });
    },
    deleteImage: function deleteImage(imgIndex) {
      var filename = this.tmpImages[imgIndex].name;
      this.deleteObjectKeys.push(filename);
      this.tmpImages.splice(imgIndex, 1);
      var mediaIndex = this.actualMedias.findIndex(function (item) {
        return item.name === filename;
      });
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1);
      this.updateMedias();
    },
    deleteFile: function deleteFile(fileIndex) {
      var fileName = '';
      if (this.tmpFiles[fileIndex].name) {
        fileName = this.tmpFiles[fileIndex].name;
        this.deleteObjectKeys.push(fileName);
      }
      this.tmpFiles.splice(fileIndex, 1);
      var mediaIndex = this.actualMedias.findIndex(function (item) {
        return item.name === fileName;
      });
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1);
      this.updateMedias();
    },
    updateMedias: function updateMedias() {
      this.$emit('setMedias', this.actualMedias);
    },
    resetUpload: function resetUpload() {
      this.uploadFiles = [];
      this.deleteObjectKeys = [];
      this.tmpImages = [];
      this.tmpFiles = [];
      this.actualMedias = [];
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gdrive_GDrivePostView__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gdrive_GDrivePostView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gdrive_GDrivePostView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BtnDownload__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BtnDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BtnDownload__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CustomMedia',
  components: { GDrivePostView: __WEBPACK_IMPORTED_MODULE_1__gdrive_GDrivePostView___default.a, BtnDownload: __WEBPACK_IMPORTED_MODULE_2__BtnDownload___default.a },
  props: ['type', 'publicID', 'URL', 'width', 'height', 'aspectRatio', 'trans', 'videoID', 'className', 'styles', 'download'],
  data: function data() {
    return {
      cldConfig: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].cldConfig,
      cld: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
    if (this.type === 'cld-video') {
      setTimeout(function () {
        _this.renderCldVideo();
      }, 3000);
    }
  },

  methods: {
    getType: function getType() {
      if (this.URL.includes('drive.google.com')) {
        if (this.type === 'driveCustomView') {
          return 'driveCustomView';
        }
        return 'iframe';
      }
      return this.type;
    },
    renderCldVideo: function renderCldVideo() {
      this.cld.videoPlayer('cld-player-' + this.videoID, {});
    }
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gdrive_GDrivePostView__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gdrive_GDrivePostView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gdrive_GDrivePostView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BtnDownload__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BtnDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BtnDownload__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CustomMediaV2',
  components: { GDrivePostView: __WEBPACK_IMPORTED_MODULE_3__gdrive_GDrivePostView___default.a, BtnDownload: __WEBPACK_IMPORTED_MODULE_4__BtnDownload___default.a },
  props: ['media'],
  data: function data() {
    return {
      cldConfig: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].cldConfig,
      cld: null,
      vplayer: null,
      playCalled: null,
      previewMedia: null
    };
  },

  watch: {
    media: {
      handler: function handler(newValue, oldVal) {
        if (newValue.file) {
          if (newValue.file.type.indexOf('image') !== -1) {
            this.previewMedia = newValue.preview.src;
          } else {
            this.vplayer = document.getElementById(this.mediaFileName);
            var file = newValue.file;
            var blobURL = URL.createObjectURL(file);
            if (blobURL) {
              this.vplayer.src = blobURL;
              document.getElementById(this.mediaFileName).src = blobURL;
            }
            if (newValue.file.type.indexOf('mp4') !== -1) {
              this.vplayer.type = 'video/mp4';
            } else if (newValue.file.type.indexOf('quicktime') !== -1) {
              this.vplayer.type = 'video/quicktime';
            }
            this.vplayer.load();
            this.playCalled = true;
          }
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
    if (this.media.type === 'cld-video') {
      setTimeout(function () {
        _this.renderCldVideo();
      }, 100);
    } else {
      if (this.media.file) {
        if (this.media.file.type.indexOf('image') !== -1) {
          this.previewMedia = this.media.preview.src;
        } else {
          this.vplayer = document.getElementById(this.mediaFileName);
          var file = this.media.file;
          var blobURL = URL.createObjectURL(file);
          if (blobURL) {
            this.vplayer.src = blobURL;
            document.getElementById(this.mediaFileName).src = blobURL;
          }
          if (this.media.file.type.indexOf('mp4') !== -1) {
            this.vplayer.type = 'video/mp4';
          } else if (this.media.file.type.indexOf('quicktime') !== -1) {
            this.vplayer.type = 'video/quicktime';
          }
          this.vplayer.load();
          this.playCalled = true;
        }
      }
    }
  },

  computed: {
    mediaFileName: function mediaFileName() {
      if (this.media.fileName) {
        return 'postVdoMedia' + this.media.fileName;
      }
      return 'postVdoMedia';
    }
  },
  methods: {
    getType: function getType() {
      var _this2 = this;

      if (this.media.URL) {
        if (this.media.URL.includes('drive.google.com')) {
          if (this.media.type === 'driveCustomView') {
            return 'driveCustomView';
          }
          return 'iframe';
        }
        if (this.media.URL.includes('s3-ap-southeast-1')) {
          if (this.media.isVideo) {
            setTimeout(function () {
              if (!_this2.vplayer) {
                _this2.vplayer = document.getElementById(_this2.mediaFileName);
              }
            }, 1000);
            return 's3-video';
          }
          if (this.media.isImage) {
            return 's3-image';
          }
        }
      }
      if (this.media.file) {
        if (this.media.file.type.indexOf('image') !== -1) {
          return 'native-image';
        } else if (this.media.file.type.indexOf('video') !== -1) {
          return 'native-video';
        }
      }
      return this.media.type;
    },
    getOverlayType: function getOverlayType() {
      if (this.media.overlayType) {
        if (this.media.overlayType === 'TikTok') {
          return '/static/img/post/tiktok.png';
        } else if (this.media.overlayType === 'IGStory') {
          return '/static/img/post/ig-story.png';
        } else if (this.media.overlayType === 'IG') {
          return '/static/img/post/ig-cutoff-post.png';
        }
      }
      return '';
    },
    renderCldVideo: function renderCldVideo() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = {};

                if (_this3.media.preview) {
                  options.controls = false;
                }

                _this3.vplayer = _this3.cld.videoPlayer('cld-player-' + _this3.media.videoID, options);
                _this3.vplayer.on('playing', function (event) {
                  _this3.playCalled = true;
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    checkURL: function checkURL(url) {
      if (url.includes('res.cloudinary.com')) {
        return url.replace('http:', 'https:');
      }
      return url;
    },
    videoAction: function videoAction() {
      if (this.playCalled) {
        this.playCalled = null;
        this.vplayer.pause();
      } else {
        this.vplayer.play();
        this.playCalled = true;
      }
    }
  }
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DatePicker',
  props: ['className', 'typeName', 'date', 'status', 'options'],
  data: function data() {
    return {
      dateFormatted: ''
    };
  },

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.options.dateFormat ? this.formatDate(this.date) : this.date;
    }
  },
  watch: {
    date: function date(newValue) {
      this.dateFormatted = this.formatDate(this.date);
      if (newValue || newValue === null) {
        if (newValue === null) newValue = '';
        if (!this.options.confirm) {
          this.$emit('changeDate', newValue);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.options.dateFormat) {
      this.dateFormatted = this.formatDate(this.date);
    }
  },

  methods: {
    formatDate: function formatDate(date) {
      if (!date) return '';
      if (!this.options.dateFormat) return date;
      if (this.options.type === 'month') {
        var _date$split = date.split('-'),
            _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 2),
            year = _date$split2[0],
            month = _date$split2[1];

        return month + '/' + year;
      } else {
        var _date$split3 = date.split('-'),
            _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
            _year = _date$split4[0],
            _month = _date$split4[1],
            day = _date$split4[2];

        return day + '/' + _month + '/' + _year;
      }
    },
    parseDate: function parseDate(date) {
      if (!date) return '';
      if (!this.options.dateFormat) return date;
      if (this.options.type === 'month') {
        var _date$split5 = date.split('/'),
            _date$split6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split5, 2),
            month = _date$split6[0],
            year = _date$split6[1];

        return year + '-' + month.padStart(2, '0');
      } else {
        var _date$split7 = date.split('/'),
            _date$split8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split7, 3),
            day = _date$split8[0],
            _month2 = _date$split8[1],
            _year2 = _date$split8[2];

        return _year2 + '-' + _month2.padStart(2, '0') + '-' + day.padStart(2, '0');
      }
    },
    changeDate: function changeDate(date) {
      this.$emit('changeDate', date);
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DirectFileUpload',
  data: function data() {
    return {
      uploadFiles: [],
      deleteObjectKeys: [],
      tmpImages: [],
      tmpFiles: [],
      actualMedias: []
    };
  },

  props: ['refresh', 'multiple', 'title', 'iconOnly'],
  watch: {
    refresh: function refresh(newRefresh) {
      this.resetUpload();
    }
  },
  computed: {
    checkDisable: function checkDisable() {
      if (!this.multiple) {
        return this.actualMedias.length > 0;
      }
      return false;
    }
  },
  methods: {
    prepareUpload: function prepareUpload(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var uploadedFiles, selectedMedias, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, mediaType, buff, file;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });
                selectedMedias = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(uploadedFiles);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 26;
                  break;
                }

                element = _step.value;
                mediaType = element.type.split('/')[0];

                if (!(mediaType === 'image')) {
                  _context.next = 20;
                  break;
                }

                _context.next = 13;
                return _this.readImage(element);

              case 13:
                buff = _context.sent;
                file = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);

                _this.actualMedias.push(file);
                selectedMedias.push(file);
                _this.tmpImages.push({
                  url: buff,
                  src: buff,
                  name: element.name
                });
                _context.next = 23;
                break;

              case 20:
                _this.tmpFiles.push(element);
                _this.actualMedias.push(element);
                selectedMedias.push(element);

              case 23:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 26:
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 32:
                _context.prev = 32;
                _context.prev = 33;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 35:
                _context.prev = 35;

                if (!_didIteratorError) {
                  _context.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context.finish(35);

              case 39:
                return _context.finish(32);

              case 40:
                e.target.value = '';
                _this.updateMedias(selectedMedias);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 28, 32, 40], [33,, 35, 39]]);
      }))();
    },
    readImage: function readImage(file) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          return resolve(e.target.result);
        };
      });
    },
    deleteImage: function deleteImage(imgIndex) {
      var filename = this.tmpImages[imgIndex].name;
      this.deleteObjectKeys.push(filename);
      this.tmpImages.splice(imgIndex, 1);
      var mediaIndex = this.actualMedias.findIndex(function (item) {
        return item.name === filename;
      });
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1);
      this.updateMedias();
    },
    deleteFile: function deleteFile(fileIndex) {
      var fileName = '';
      if (this.tmpFiles[fileIndex].name) {
        fileName = this.tmpFiles[fileIndex].name;
        this.deleteObjectKeys.push(fileName);
      }
      this.tmpFiles.splice(fileIndex, 1);
      var mediaIndex = this.actualMedias.findIndex(function (item) {
        return item.name === fileName;
      });
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1);
      this.updateMedias();
    },
    updateMedias: function updateMedias(medias) {
      this.$emit('setMedias', medias || this.actualMedias);
    },
    resetUpload: function resetUpload() {
      this.uploadFiles = [];
      this.deleteObjectKeys = [];
      this.tmpImages = [];
      this.tmpFiles = [];
      this.actualMedias = [];
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FilePreview',
  props: ['files']
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FullScreenProgress',
  props: {
    show: Boolean,
    isStatus: Boolean,
    processing: Number,
    complete: Number,
    color: String
  },
  data: function data() {
    return {
      percent: 0
    };
  },

  watch: {
    processing: function processing(value) {
      this.calcPercent(value);
    }
  },
  mounted: function mounted() {
    this.calcPercent(this.processing);
  },
  methods: {
    calcPercent: function calcPercent(value) {
      this.percent = Math.round(value / this.complete * 100, 0);
    }
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_css_swiper_css__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_swiper_css_swiper_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageSwiper',
  components: {
    Swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["Swiper"],
    SwiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["SwiperSlide"]
  },
  props: {
    show: Boolean,
    isShowDelete: Boolean,
    images: Array
  },
  directives: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["directive"]
  },
  data: function data() {
    return {
      autoUpdate: false,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },

  mounted: function mounted() {
    var vm = this;

    setTimeout(function () {
      vm.autoUpdate = true;
    }, 1000);
  },
  methods: {
    constructImageURL: function constructImageURL(imageName) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].func.constructImageURL(imageName);
    }
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KToast',
  props: {
    variant: String,
    header: String,
    content: String
  },
  data: function data() {
    return {
      toastVariant: '',
      toastHeader: '',
      toastContent: ''
    };
  },

  watch: {
    variant: function variant(value) {
      this.toastVariant = value;
    },
    header: function header(value) {
      this.toastHeader = value;
    },
    content: function content(value) {
      this.toastContent = value;
    }
  }
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LinearProgress',
  props: {
    loading: Boolean,
    text: String,
    disablePersistent: Boolean
  }
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialHandle',
  props: ['isTikTok', 'isInstagram', 'isFacebook', 'isLinkedIn', 'isTwitter', 'tiktokHandle', 'instagramHandle', 'facebookHandle', 'linkedinHandle', 'twitterHandle', 'divClassName', 'isYoutube', 'youtubeHandle', 'youtubeURL', 'isXiaohongshu', 'xiaohongshuHandle', 'xiaohongshuFullName', 'isOthers', 'otherHandle'],
  methods: {
    showYoutubeURL: function showYoutubeURL(youtubeURL) {
      if (youtubeURL && youtubeURL.includes('https://www.youtube.com')) {
        return youtubeURL;
      } else {
        return 'https://youtube.com/@' + this.youtubeHandle;
      }
    },
    openLink: function openLink(link) {
      window.open(link, '_blank');
    }
  }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SocialHandle',
  props: ['isTikTok', 'isInstagram', 'isFacebook', 'isLinkedIn', 'isTwitter', 'tiktokHandle', 'instagramHandle', 'facebookHandle', 'linkedinHandle', 'twitterHandle', 'divClassName', 'isYoutube', 'youtubeHandle', 'youtubeURL', 'isXiaohongshu', 'xiaohongshuHandle', 'xiaohongshuFullName', 'isOthers', 'otherHandle'],
  computed: {
    hasExplicitPlatform: function hasExplicitPlatform() {
      return this.isTikTok || this.isInstagram || this.isFacebook || this.isLinkedIn || this.isTwitter || this.isYoutube || this.isXiaohongshu || this.isOthers;
    }
  },
  methods: {
    showYoutubeURL: function showYoutubeURL(youtubeURL) {
      if (youtubeURL && youtubeURL.includes('https://www.youtube.com')) {
        return youtubeURL;
      } else {
        return 'https://youtube.com/@' + this.youtubeHandle;
      }
    },
    openLink: function openLink(link) {
      window.open(link, '_blank');
    }
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sortablejs__ = __webpack_require__(302);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableColsShowHideModal',
  props: {
    value: Boolean,
    title: String,
    items: {
      type: Array,
      required: true
    },

    isSort: {
      type: Boolean,
      default: false }
  },
  data: function data() {
    return {
      localItems: [],
      sortable: null
    };
  },

  watch: {
    items: {
      immediate: true,
      handler: function handler(newItems) {
        this.localItems = newItems ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newItems)) : [];
      }
    },
    value: function value(val) {
      var _this = this;

      if (val && this.isSort) {
        this.$nextTick(function () {
          _this.initSortable();
        });
      } else {
        this.destroySortable();
      }
    },
    isSort: function isSort(val) {
      var _this2 = this;

      if (this.value && val) {
        this.$nextTick(function () {
          _this2.initSortable();
        });
      } else {
        this.destroySortable();
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.value && this.isSort) {
      this.$nextTick(function () {
        _this3.initSortable();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroySortable();
  },

  methods: {
    initSortable: function initSortable() {
      if (this.sortable || !this.$refs.sortableTbody || !this.isSort) return;

      this.sortable = __WEBPACK_IMPORTED_MODULE_1_sortablejs__["a" /* default */].create(this.$refs.sortableTbody, {
        handle: '.sort-handle',
        animation: 150,
        onEnd: this.onSortEnd
      });
    },
    destroySortable: function destroySortable() {
      if (this.sortable) {
        this.sortable.destroy();
        this.sortable = null;
      }
    },
    onSortEnd: function onSortEnd(event) {
      var oldIndex = event.oldIndex,
          newIndex = event.newIndex;

      if (newIndex !== oldIndex) {
        var itemToMove = this.localItems.splice(oldIndex, 1)[0];
        this.localItems.splice(newIndex, 0, itemToMove);
      }
    },
    save: function save() {
      this.$emit('updated', this.localItems);
    }
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GDrivePostView',
  props: ['url', 'darkTheme'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadIcon__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UploadIcon__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GDriveSelector',
  data: function data() {
    return {
      tempAttachments: [],
      attachments: [],
      pickerApiLoaded: false,
      oauthToken: null
    };
  },

  components: {
    UploadIcon: __WEBPACK_IMPORTED_MODULE_3__UploadIcon___default.a
  },
  mounted: function mounted() {
    var gDrive = document.createElement('script');
    gDrive.setAttribute('type', 'text/javascript');
    gDrive.setAttribute('src', 'https://apis.google.com/js/api.js');
    document.head.appendChild(gDrive);
  },

  methods: {
    driveIconClicked: function driveIconClicked() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return window.gapi.load('auth2', function () {
                  window.gapi.auth2.authorize({
                    client_id: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].gDriveConfig.CLIENT_ID,
                    scope: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].gDriveConfig.SCOPE,
                    immediate: false
                  }, _this.handleAuthResult);
                });

              case 2:
                window.gapi.load('picker', function () {
                  _this.pickerApiLoaded = true;
                  _this.createPicker();
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleAuthResult: function handleAuthResult(authResult) {
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token;
        this.createPicker();
      }
    },
    createPicker: function createPicker() {
      if (this.pickerApiLoaded && this.oauthToken) {
        var docsView = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS).setIncludeFolders(true).setSelectFolderEnabled(false);
        var picker = new window.google.picker.PickerBuilder().enableFeature(window.google.picker.Feature.NAV_HIDDEN).enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED).addView(docsView).setOAuthToken(this.oauthToken).setDeveloperKey(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].gDriveConfig.DEVELOPER_KEY).setCallback(this.pickerCallback).build();
        picker.setVisible(true);
      }
    },
    pickerCallback: function pickerCallback(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var docs, attachments, i, attachment;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (data[window.google.picker.Response.ACTION] === window.google.picker.Action.PICKED) {
                  docs = data.docs;
                  attachments = [];

                  for (i = 0; i < docs.length; i++) {
                    attachment = {};

                    attachment._id = docs[i].id;
                    attachment.title = docs[i].name;
                    attachment.name = docs[i].name + '.' + docs[i].mimeType.split('/')[1];
                    attachment.type = 'gDrive';
                    attachment.description = 'Shared with GDrive';
                    attachment.extension = '.' + docs[i].mimeType.substring(docs[i].mimeType.lastIndexOf('.') + 1);
                    if (attachment.extension.includes('image')) {
                      attachment.media_type = 'IMAGE';
                    } else if (attachment.extension.includes('video')) {
                      attachment.media_type = 'VIDEO';
                    } else {
                      attachment.media_type = 'OTHER';
                    }
                    attachment.iconURL = docs[i].iconUrl;
                    attachment.embedURL = docs[i].embedUrl;
                    attachment.size = docs[i].sizeBytes;
                    attachment.thumb = null;
                    attachment.thumb_list = null;
                    attachments.push(attachment);
                  }
                  _this2.tempAttachments = [].concat(attachments);
                  _this2.$emit('picked', _this2.tempAttachments);
                }
                _this2.oauthToken = null;
                _this2.pickerApiLoaded = false;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: {
    getTempAttachments: function getTempAttachments() {
      return this.tempAttachments;
    },
    getAttachments: function getAttachments() {
      return this.attachments;
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadIcon'
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    facebookId: function facebookId() {
      return this.$store.state.user.facebookId;
    },
    userId: function userId() {
      return this.$store.state.user.id;
    }
  },
  name: 'ConnectInstagram',
  methods: {
    connectInstagram: function connectInstagram() {
      var _this = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var reqObj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqObj = {
                  client_id: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].INSTAGRAM_CLIENT_ID,
                  redirect_uri: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].INSTAGRAM_LOGIN_REDIRECT_URL,
                  scope: 'instagram_business_basic',
                  response_type: 'code'
                };

                reqObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(reqObj).map(function (key) {
                  return key + '=' + reqObj[key];
                }).join('&');
                window.location.href = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].INSTAGRAM_APP_AUTHORIZE_URL + '?' + reqObj;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KInfluencerSearchBox',
  props: {
    search: String,
    page: Number,
    limit: Number,
    sortBy: String,
    descending: Number
  }, data: function data() {
    return {
      dialog: false,

      keyword: [],
      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      location: null,
      locations: ['Singapore', 'Thailand', 'Philippin', 'Malaysia', 'Indonesia'],
      pastYear: 3
    };
  },

  computed: {
    searchKeywordPayload: function searchKeywordPayload() {
      return {
        keyword: this.keyword,
        negative_keyword: this.negativeKeyword,
        negative_period: this.negativePeriod,
        opt_in_only: this.optInOnly,
        search_duration: this.searchDuration,
        search_image: false,
        search_nlu: this.searchNlu,
        location: this.location,
        pastYear: this.pastYear
      };
    },
    pastDate: function pastDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(this.pastYear, 'years').format('DD-MM-YYYY');
    }
  },
  watch: {
    search: function search(value) {
      this.searchByKeywords();
    }
  },
  methods: {
    searchByKeywords: function searchByKeywords() {
      var _this = this;

      if (this.keyword.length === 0) {
        this.$swal({
          title: 'Warning',
          text: 'Please enter the keyword',
          type: 'info'
        });
        this.$emit('result', { success: false, nokeyword: true });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__views_Influencer_influencerAPIs__["a" /* default */].searchKeyword(this.searchKeywordPayload, this.sortBy, this.descending, this.limit, this.page).then(function (response) {
          var originalItems = response.influencers;
          var totalItems = response.totalInfluencers;
          var summary = response.summary;
          _this.$emit('result', { success: true, originalItems: originalItems, totalItems: totalItems, summary: summary, keyword: _this.keyword });
        }).catch(function (error) {
          console.log(error);
          _this.$emit('result', { success: false });
        });
      }
    },
    removeKeyword: function removeKeyword(item) {
      var index = this.keyword.indexOf(item);
      if (index !== -1) {
        this.keyword.splice(index, 1);
      }
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostDeliverables',
  props: ['deliverables']
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadMedia__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UploadMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UploadMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostForm',
  data: function data() {
    return {
      caption: null,
      vdoLink: null,
      remark: null,
      media: [],
      type: null,
      hashTags: '',
      callToActionLinks: '',
      rules: {
        length: function length(len) {
          return function (v) {
            return (v || '').length <= len || 'Character Length should not more than ' + len;
          };
        },
        required: function required(v) {
          return !!v || 'This field is required';
        }
      },
      influencerRole: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.INFLUENCER
    };
  },

  components: {
    UploadMedia: __WEBPACK_IMPORTED_MODULE_4__UploadMedia___default.a
  },
  props: {
    post: Object,
    influencer: Object,
    campaign: Object
  },
  watch: {
    caption: function caption(value) {
      this.$emit('text-changed', value);
    },
    vdoLink: function vdoLink(val) {
      this.$emit('vdo-link-changed', val);
    },
    remark: function remark(value) {
      this.$emit('remark-changed', value);
    },
    post: function post(oval, val) {
      this.link = oval.vdoLink;
      this.caption = oval.captionText;
      this.type = oval.type;
      this.media = oval.media;
      this.remark = oval.remark;
    },

    campaign: {
      handler: function handler(newValue) {
        if (newValue) {
          this.loadCampaign();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadCampaign();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    campaignDetail: function campaignDetail(state) {
      return state.campaign.campaignDetail;
    }
  }), {
    accept: function accept() {
      switch (this.post.type) {
        case 'video':
          return 'image/*|video/*';
        case 'image':
          return 'image/*';
        case 'post/carousel':
          return 'image/*|video/*';
        case 'reel':
          return 'image/*|video/*';
      }
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isVideoLink: function isVideoLink() {
      return this.post.type === 'story' || this.post.type === 'video' || this.post.type === 'reel' || this.post.type === 'tiktok' || this.post.type === 'youtube' || this.post.type === 'facebook';
    },
    supportsVideoUpload: function supportsVideoUpload() {
      return this.isVideoLink || (this.accept || '').includes('video/*');
    },
    isRemark: function isRemark() {
      return this.post.type === 'story' && this.currentUserRole !== this.influencerRole;
    },
    captionLabel: function captionLabel() {
      return this.post.type === 'story' ? 'Story Caption' : 'Caption';
    }
  }),
  methods: {
    mediaChanged: function mediaChanged(media) {
      this.$emit('media-changed', media);
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('campaign/getCampaignDetail', _this2.campaign.id);

              case 2:
                _this2.hashTags = __WEBPACK_IMPORTED_MODULE_5__views_Campaign_campaignHelper__["a" /* default */].getMandatoryHashtagMentions(_this2.campaignDetail);
                _this2.callToActionLinks = _this2.campaignDetail.callToActionLinks || '';

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UploadMedia__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UploadMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UploadMedia__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StoryForm',
  data: function data() {
    return {
      media: []
    };
  },

  components: {
    UploadMedia: __WEBPACK_IMPORTED_MODULE_0__UploadMedia___default.a
  },
  props: {
    post: Object
  },
  watch: {
    post: function post(oval, val) {
      this.media = val.media;
    }
  },
  mounted: function mounted() {
    console.log('Media List', this.media);
  },

  methods: {
    mediaChanged: function mediaChanged(media) {
      this.$emit('media-changed', media);
    }
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadMedia',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a,
    btnDownload: __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      previewMedia: '',
      media: [],
      imageDialog: false,
      mediaType: '',
      loadingDialog: false,
      cldConfig: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].cldConfig,
      cld: null,
      cldFolderPath: 'POST SUBMISSIONS',
      campaignHelper: __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */]
    };
  },

  props: {
    accept: String,
    limit: {
      type: Number,
      default: 1
    },
    listMedia: Array,
    influencer: Object,
    campaign: Object,
    multiple: Boolean
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    cldSignature: function cldSignature(state) {
      return state.campaign.cldSignature;
    }
  })),
  watch: {
    media: function media(newValue) {
      this.$emit('change', newValue);
    },
    listMedia: function listMedia(value) {
      this.media = value;
    }
  },
  mounted: function mounted() {
    console.log('File type accept', this.accept);
    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
  },

  methods: {
    prepareUpload: function prepareUpload(e) {
      var _this = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          return _this.$swal('File Type Not Supported, Please select a video or an image');
        }
        if (type === 'video') {
          if (element.size > 104857600) {
            var fileSize = element.size / (1024 * 1024);
            return _this.$swal({
              title: 'File size',
              text: 'Too big, maximum is 100MB. You file size is: ' + fileSize.toFixed(2) + ' MB',
              type: 'warning'
            });
          }
          return _this.processVideo(element);
        } else {
          _this.processImage(element);
        }
      });
    },
    processImage: function processImage(image) {
      var _this2 = this;

      try {
        var reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = function (e) {
          var buffer = e.target.result;
          var file = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.dataURLtoFile(buffer, image.name);
          _this2.media.push({
            file: file,
            preview: {
              thumbnail: buffer,
              src: buffer,
              name: image.name
            }
          });
        };
      } catch (error) {
        console.error(error);
        this.$swal({
          text: 'Error When processing iamge',
          type: 'error'
        });
      }
    },
    processVideo: function processVideo(element) {
      var _this3 = this;

      try {
        var reader = new FileReader();
        this.loadingDialog = true;
        reader.onload = function () {
          var blog = new Blob([reader.result], { type: element.type });
          var url = URL.createObjectURL(blog);
          var video = document.createElement('video');

          var timeupdate = function timeupdate() {
            if (snapImage()) {
              video.removeEventListener('timeupdate', timeupdate);
              video.pause();
            }
          };
          var snapImage = function snapImage() {
            var canvas = document.createElement('canvas');
            canvas.width = video.videoWidth * 0.25;
            canvas.height = video.videoHeight * 0.25;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            var image = canvas.toDataURL();

            _this3.media.push({
              file: element,
              preview: {
                src: url,
                thumbnail: image,
                name: video.name,
                video: true
              }
            });
            return true;
          };
          video.addEventListener('timeupdate', timeupdate);
          video.preload = 'metadata';
          video.src = url;

          video.muted = true;
          video.playsInline = true;
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(function (_) {}).catch(function (error) {
              console.log(error);
              _this3.media.push({
                file: element,
                preview: {
                  src: url,
                  thumbnail: '',
                  name: video.name,
                  video: true
                }
              });
            });
          }
          _this3.loadingDialog = false;
        };
        reader.readAsArrayBuffer(element);
      } catch (error) {
        console.error(error);
        this.$swal({ type: 'error', text: 'Error when processing video' });
      }
    },
    deleteImage: function deleteImage(imgIndex, img) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.media.splice(imgIndex, 1);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    viewMedia: function viewMedia(media) {
      this.imageDialog = true;

      if (media.file.type.indexOf('image') !== -1) {
        this.mediaType = 'image';
        this.previewMedia = media.preview.src;
      } else {
        this.mediaType = 'vdo';
        setTimeout(function () {
          var video = document.getElementById('postVdo');
          var file = media.file;
          var blobURL = URL.createObjectURL(file);
          video.src = blobURL;
          if (media.file.type.indexOf('mp4') !== -1) {
            video.type = 'video/mp4';
          } else if (media.file.type.indexOf('quicktime') !== -1) {
            video.type = 'video/quicktime';
          }
          video.load();
        }, 700);
      }
    },
    modalClickOutSide: function modalClickOutSide() {
      if (this.mediaType === 'vdo') {
        var vdoCtrl = document.getElementById('postVdo');
        vdoCtrl.pause();
        vdoCtrl.currentTime = 0;
        vdoCtrl.src = '';
      }
    }
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadMedia',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a,
    btnDownload: __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      previewMedia: '',
      media: [],
      imageDialog: false,
      mediaType: '',
      loadingDialog: false,
      cldConfig: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].cldConfig,
      cld: null,
      cldFolderPath: 'POST SUBMISSIONS',
      campaignHelper: __WEBPACK_IMPORTED_MODULE_9__components_views_Campaign_campaignHelper__["a" /* default */]
    };
  },

  props: {
    accept: String,
    limit: {
      type: Number,
      default: 1
    },
    listMedia: Array,
    influencer: Object,
    campaign: Object,
    multiple: Boolean
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    cldSignature: function cldSignature(state) {
      return state.campaign.cldSignature;
    }
  })),
  watch: {
    media: function media(newValue) {
      this.$emit('change', newValue);
    },
    listMedia: function listMedia(value) {
      this.media = value;
    }
  },
  mounted: function mounted() {
    console.log('File type accept', this.accept);
    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
  },

  methods: {
    prepareUpload: function prepareUpload(e) {
      var _this = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          return _this.$swal('File Type Not Supported, Please select a video or an image');
        }
        if (type === 'video') {
          if (element.size > 104857600) {
            var fileSize = element.size / (1024 * 1024);
            return _this.$swal({
              title: 'File size',
              text: 'Too big, maximum is 100MB. You file size is: ' + fileSize.toFixed(2) + ' MB',
              type: 'warning'
            });
          }
          return _this.processVideo(element);
        } else {
          _this.processImage(element);
        }
      });
    },
    processImage: function processImage(image) {
      var _this2 = this;

      try {
        var reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = function (e) {
          var buffer = e.target.result;
          var file = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.dataURLtoFile(buffer, image.name);
          _this2.media.push({
            file: file,
            preview: {
              thumbnail: buffer,
              src: buffer,
              name: image.name
            }
          });
        };
      } catch (error) {
        console.error(error);
        this.$swal({
          text: 'Error When processing iamge',
          type: 'error'
        });
      }
    },
    processVideo: function processVideo(element) {
      var _this3 = this;

      try {
        var reader = new FileReader();
        this.loadingDialog = true;
        reader.onload = function () {
          var blog = new Blob([reader.result], { type: element.type });
          var url = URL.createObjectURL(blog);
          var video = document.createElement('video');

          var timeupdate = function timeupdate() {
            if (snapImage()) {
              video.removeEventListener('timeupdate', timeupdate);
              video.pause();
            }
          };
          var snapImage = function snapImage() {
            var canvas = document.createElement('canvas');
            canvas.width = video.videoWidth * 0.25;
            canvas.height = video.videoHeight * 0.25;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            var image = canvas.toDataURL();

            _this3.media.push({
              file: element,
              preview: {
                src: url,
                thumbnail: image,
                name: video.name,
                video: true
              }
            });
            return true;
          };
          video.addEventListener('timeupdate', timeupdate);
          video.preload = 'metadata';
          video.src = url;

          video.muted = true;
          video.playsInline = true;
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(function (_) {}).catch(function (error) {
              console.log(error);
              _this3.media.push({
                file: element,
                preview: {
                  src: url,
                  thumbnail: '',
                  name: video.name,
                  video: true
                }
              });
            });
          }
          _this3.loadingDialog = false;
        };
        reader.readAsArrayBuffer(element);
      } catch (error) {
        console.error(error);
        this.$swal({ type: 'error', text: 'Error when processing video' });
      }
    },
    deleteImage: function deleteImage(imgIndex, img) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.media.splice(imgIndex, 1);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    viewMedia: function viewMedia(media) {
      this.imageDialog = true;

      if (media.file.type.indexOf('image') !== -1) {
        this.mediaType = 'image';
        this.previewMedia = media.preview.src;
      } else {
        this.mediaType = 'vdo';
        setTimeout(function () {
          var video = document.getElementById('postVdo');
          var file = media.file;
          var blobURL = URL.createObjectURL(file);
          video.src = blobURL;
          if (media.file.type.indexOf('mp4') !== -1) {
            video.type = 'video/mp4';
          } else if (media.file.type.indexOf('quicktime') !== -1) {
            video.type = 'video/quicktime';
          }
          video.load();
        }, 700);
      }
    },
    modalClickOutSide: function modalClickOutSide() {
      if (this.mediaType === 'vdo') {
        var vdoCtrl = document.getElementById('postVdo');
        vdoCtrl.pause();
        vdoCtrl.currentTime = 0;
        vdoCtrl.src = '';
      }
    }
  }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StoryForm__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StoryForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StoryForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VideoForm',
  extends: __WEBPACK_IMPORTED_MODULE_0__StoryForm___default.a
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Xero_XeroAPIs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConnectXero',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      tenant: null,
      isLoading: false
    };
  },

  methods: {
    getTenant: function getTenant() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, respData, data, tenant;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__views_Xero_XeroAPIs__["a" /* default */].getTenant();

              case 2:
                resp = _context.sent;
                respData = resp.data;
                data = respData.data;
                tenant = data.tenant;

                _this.tenant = tenant;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    syncXeroResource: function syncXeroResource(resource) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__views_Xero_XeroAPIs__["a" /* default */].syncResoures(resource);

              case 4:
                _this2.isLoading = false;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                _this2.isLoading = false;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    connect: function connect() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, responseData, data, login;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__views_Xero_XeroAPIs__["a" /* default */].getLogin();

              case 2:
                response = _context3.sent;
                responseData = response.data;
                data = responseData.data;
                login = data.login;

                window.location.href = login;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  mounted: function mounted() {
    this.getTenant();
  }
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jimp__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jimp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upload-media',
  props: {
    accept: String,
    listMedia: Array,
    logoURI: String,
    isEdit: Boolean
  },
  data: function data() {
    return {
      media: [],
      previewMedia: '',
      showUpload: false
    };
  },

  watch: {
    media: function media(newValue) {
      this.$emit('change', newValue);
    },
    listMedia: function listMedia(value) {
      this.media = value;
    }
  },
  methods: {
    prepareUpload: function prepareUpload(e) {
      var _this = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          return _this.$swal('File Type Not Supported, Please select a video or an image');
        }

        _this.processImage(element);
      });
    },
    processImage: function processImage(image) {
      var _this2 = this;

      try {
        var reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = function (e) {
          var buffer = e.target.result;
          __WEBPACK_IMPORTED_MODULE_1_jimp___default.a.read(buffer, function (err, img) {
            if (err) console.error(111, err);
            img.resize(500, __WEBPACK_IMPORTED_MODULE_1_jimp___default.a.AUTO).quality(100).getBase64(__WEBPACK_IMPORTED_MODULE_1_jimp___default.a.MIME_PNG, function (err, buff) {
              if (err) console.error(222, err);
              var file = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].func.dataURLtoFile(buff, image.name);
              _this2.media.push({
                file: file,
                preview: {
                  thumbnail: buff,
                  src: buff,
                  name: image.name
                }
              });
            });
          });
        };
      } catch (error) {
        console.error(error);
        this.$swal({
          text: 'Error When processing iamge',
          type: 'error'
        });
      }
    },
    deleteImage: function deleteImage(imgIndex) {
      this.showUpload = false;
      this.media.splice(imgIndex, 1);
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_data_json__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chart_data_json__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bar-Chart',
  props: ['name', 'summaryTitle', 'summary', 'chartData', 'target', 'color'],
  data: function data() {
    return {
      toggle_filter: 0,
      MONTHLY_DATA: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.loadCharts();
    }, 1000);
  },

  methods: {
    loadCharts: function loadCharts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.chartData;

              case 2:
                data = _context.sent;

                if (_this2.name === 'completion') {
                  _this2.renderCompletionChart(data);
                } else if (_this2.name === 'revenue') {
                  _this2.renderRevenueChart(data);
                } else {
                  _this2.renderRenewalChart(data);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    renderCompletionChart: function renderCompletionChart(chartData) {
      var ctx = document.getElementById(this.name);

      var config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.completionChart !== undefined) {
        window.completionChart.destroy();
      }

      window.completionChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
    },
    renderRevenueChart: function renderRevenueChart(chartData) {
      var ctx = document.getElementById(this.name);

      var config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.revenueChart !== undefined) {
        window.revenueChart.destroy();
      }

      window.revenueChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
    },
    renderRenewalChart: function renderRenewalChart(chartData) {
      var ctx = document.getElementById(this.name);

      var config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.renewalChart !== undefined) {
        window.renewalChart.destroy();
      }

      window.renewalChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
    },
    detailCLick: function detailCLick(name) {
      if (name.toLowerCase() === 'completion') this.$router.push({ name: 'am-speed' });else if (name.toLowerCase() === 'renewal') this.$router.push({ name: 'am-spend-campaign-report' });else if (name.toLowerCase() === 'average_amount') this.$router.push({ name: 'am-spend-campaign-report' });else this.$router.push({ name: 'am-spend-revenue' });
    },
    monthlyClick: function monthlyClick(name) {
      if (name.toLowerCase() === 'completion') {
        this.renderCompletionChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.MONTHLY);
        this.calculateCompletionSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.MONTHLY, 12);
      } else if (name.toLowerCase() === 'renuve') {
        this.renderRevenueChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.MONTHLY);
        this.calculateRevenueSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.MONTHLY);
      } else {
        this.renderRenewalChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Spend.RENEWAL.MONTHLY);
        this.calculateRenewalSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Spend.RENEWAL.MONTHLY);
      }
    },
    quartelyClick: function quartelyClick(name) {
      if (name.toLowerCase() === 'completion') {
        this.renderCompletionChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.QUARTELY);
        this.calculateCompletionSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.QUARTELY, 4);
      } else if (name.toLowerCase() === 'revenue') {
        this.renderRevenueChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.QUARTELY);
        this.calculateRevenueSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.QUARTELY);
      } else {
        this.renderRenewalChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Spend.RENEWAL.QUARTELY);
        this.calculateRenewalSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Spend.RENEWAL.QUARTELY);
      }
    },
    yearlyClick: function yearlyClick(name) {
      if (name.toLowerCase() === 'completion') {
        this.renderCompletionChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.YEARLY);
        this.calculateCompletionSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.YEARLY, 6);
      } else if (name.toLowerCase() === 'revenue') {
        this.renderRevenueChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.YEARLY);
        this.calculateRevenueSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Speed.COMPLETION.YEARLY);
      } else {
        this.renderRenewalChart(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Spend.RENEWAL.YEARLY);
        this.calculateRenewalSummary(__WEBPACK_IMPORTED_MODULE_3__chart_data_json___default.a.Spend.RENEWAL.YEARLY);
      }
    },
    calculateCompletionSummary: function calculateCompletionSummary(data, totalCount) {
      var _this3 = this;

      this.summary = [];
      var dataset = data.datasets;
      dataset.map(function (item) {
        var avgValue = item.data.reduce(function (a, b) {
          return a + b;
        }) / totalCount;
        var summaryObj = {
          'text': item.label,
          'value': Math.round(avgValue)
        };
        _this3.summary.push(summaryObj);
      });
    },
    calculateRevenueSummary: function calculateRevenueSummary(data) {
      var _this4 = this;

      this.summary = [];
      var dataset = data.datasets;
      dataset.map(function (item) {
        var summaryObj = {
          'text': item.label,
          'value': item.data.reduce(function (a, b) {
            return a + b;
          })
        };
        _this4.summary.push(summaryObj);
      });
    },
    calculateRenewalSummary: function calculateRenewalSummary(data) {
      var _this5 = this;

      this.summary = [];
      var dataset = data.datasets;
      var total = 0;
      dataset.map(function (item) {
        var summaryObj = {
          'text': item.label,
          'value': item.data.reduce(function (a, b) {
            return a + b;
          })
        };
        total += summaryObj.value;
        _this5.summary.push(summaryObj);
      });

      var totalRenewal = {
        'text': 'Total',
        'value': total
      };
      this.summary.push(totalRenewal);
    }
  }
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DashboardComponents_TotalNumbers__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DashboardComponents_TotalNumbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DashboardComponents_TotalNumbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Bar_vue__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Chart_Bar_vue__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Chart_Bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Chart_Bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_Chart_Line_vue__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_Chart_Line_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__DashboardComponents_Chart_Line_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_CampaignSummary_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_CampaignSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__DashboardComponents_CampaignSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DashboardComponents_QualityRatingHelper__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_SpeedHelper__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DashboardComponents_KobeOverviewHelper__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DashboardComponents_CampaignBriefDataTable_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DashboardComponents_CampaignBriefDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__DashboardComponents_CampaignBriefDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DashboardComponents_DashboardActivationDataTable_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DashboardComponents_DashboardActivationDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__DashboardComponents_DashboardActivationDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DashboardComponents_PairingLineupDataTable_vue__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DashboardComponents_PairingLineupDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__DashboardComponents_PairingLineupDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_DraftsDataTable_vue__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_DraftsDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__DashboardComponents_DraftsDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DashboardComponents_ReportingDataTable_vue__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DashboardComponents_ReportingDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__DashboardComponents_ReportingDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Campaign_ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Campaign_ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Campaign_ViewCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__am_data_json__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__am_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__am_data_json__);








var _components;




























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AM_Dashboard',
  components: (_components = {
    totalNumber: __WEBPACK_IMPORTED_MODULE_9__DashboardComponents_TotalNumbers___default.a,
    ChangePasswordModal: __WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal___default.a,
    CampaignSummary: __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_CampaignSummary_vue___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Bar_vue___default.a,
    SpendBarChart: __WEBPACK_IMPORTED_MODULE_11__Chart_Bar_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_Chart_Line_vue___default.a,
    QualityLineChart: __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_Chart_Line_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'CampaignSummary', __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_CampaignSummary_vue___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'DashboardActivationDataTable', __WEBPACK_IMPORTED_MODULE_18__DashboardComponents_DashboardActivationDataTable_vue___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'CampaignBriefDataTable', __WEBPACK_IMPORTED_MODULE_17__DashboardComponents_CampaignBriefDataTable_vue___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'PairingLineupDataTable', __WEBPACK_IMPORTED_MODULE_19__DashboardComponents_PairingLineupDataTable_vue___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'DraftsDataTable', __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_DraftsDataTable_vue___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'ReportingDataTable', __WEBPACK_IMPORTED_MODULE_21__DashboardComponents_ReportingDataTable_vue___default.a), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_components, 'ViewCampaignModal', __WEBPACK_IMPORTED_MODULE_22__Campaign_ViewCampaignModal___default.a), _components),
  data: function data() {
    return {
      passwordModalDialog: false,
      pwdWarning: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      chartCompletionData: [],
      completionSummary: [],
      chartRevenueData: [],
      revenueSummary: [],
      chartRenewalData: [],
      renewalSummary: [],
      averageAmountChartData: [],
      averageAmountSummary: [],
      totalSummaryData: {},
      campaigns: [],
      AMUsers: [],
      FilterAMUsers: [],
      benchmark: 4,
      benchmarkColor: { r: 255, g: 99, b: 132 },
      yAxes: {
        min: 0,
        max: 5,
        stepSize: 1,
        label: 'Score'
      },
      speedBenchmark: 20,
      speedYAxes: {
        min: 0,
        max: 30,
        stepSize: 5,
        label: 'Days'
      },
      spendRevBenchmark: 100000,
      spendAvgBenchmark: 20000,
      SPEED_TURNAROUND: {
        id: 'campaign_speed_turnaround_chart',
        title: 'Turnaround for Campaign - Filter by',
        labels: [],
        datasets: []
      },
      SPEND_REVENUE: {
        id: 'spend_revenue_chart',
        title: 'Filter by',
        labels: [],
        datasets: [],
        summaryTitle: 'Revenue Summary',
        summary: []
      },
      SPEND_AVG_PER_CAMPAIGN: {
        id: 'spend_avg_per_campaign_chart',
        title: 'Filter by',
        labels: [],
        datasets: [],
        summaryTitle: 'Average Amount Per Campaign',
        summary: []
      },
      CLIENT_SATISFACTION: {
        id: 'client_line_chart',
        title: 'CLIENT Satisfaction - Filter by',
        labels: [],
        datasets: []
      },
      influencerPerMonth: 'Total Influencer on ' + __WEBPACK_IMPORTED_MODULE_26_moment___default()(Date.now()).format('MMMM'),
      campaignActivity: {
        ACTIVATION: 'activation',
        PAIRING: 'pairing',
        CREATING: 'creating',
        COMPLETE: 'complete'
      },
      AM: [],
      CC: [],
      viewCampaignData: null,
      viewCampaignModalDialog: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getUsers();
              _this.pwdWarning = _this.user.pwdWarning;
              _this.chartCompletionData = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Speed.COMPLETION.MONTHLY;
              _this.chartRevenueData = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Speed.REVENUE.MONTHLY;
              _this.chartRenewalData = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Spend.RENEWAL.MONTHLY;
              _this.averageAmountChartData = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Spend.AVERAGE_AMOUNT.MONTHLY;
              _this.calculateCompletionSummary();
              _this.calculateRevenueSummary();

              response = void 0;
              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_14__DashboardComponents_QualityRatingHelper__["a" /* default */].getAllCampaignsNoStatus();

            case 11:
              response = _context.sent;

              if (response) {
                _this.campaigns = response;
              }
              _context.next = 15;
              return __WEBPACK_IMPORTED_MODULE_23__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_25__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

            case 15:
              response = _context.sent;

              if (response) {
                _this.AMUsers = response.users;
                _this.AMUsers = _this.AMUsers.map(function (am) {
                  am.name = am.firstName + ' ' + am.lastName;
                  am.lineColor = _this.randomLineColors();
                  return am;
                });
                _this.filterUsers = _this.AMUsers.slice();
                _this.filterUsers.unshift({ id: '', name: 'All Team' });
              }

              _this.getSpendRevenueData({ monthly: true });
              _this.getSpendAvgPerCampaign({ monthly: true });
              _this.getSpeedDataOverview({ monthly: true });

              _this.calculateRenewalSummary();

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getSpendRevenueData: function getSpendRevenueData(filters) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var queryFilter, response, graphdata;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queryFilter = _this2.getPeriodFilter(filters);
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_24__Campaign_campaignAPIs__["a" /* default */].getAllReportRecognized();

              case 3:
                response = _context2.sent;

                if (response) {
                  queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : '';
                  graphdata = _this2.getSpendRevenueGraphData(response, queryFilter);

                  _this2.SPEND_REVENUE.labels = graphdata.periodLabels;
                  _this2.SPEND_REVENUE.datasets = graphdata.datasets;
                  _this2.SPEND_REVENUE.summary = graphdata.revenueSummary;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getSpendAvgPerCampaign: function getSpendAvgPerCampaign(filters) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var queryFilter, response, graphdata;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                queryFilter = _this3.getPeriodFilter(filters);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_24__Campaign_campaignAPIs__["a" /* default */].getAllReportRecognized();

              case 3:
                response = _context3.sent;

                if (response) {
                  queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : '';
                  queryFilter.avg_per_campaign = true;
                  graphdata = _this3.getSpendRevenueGraphData(response, queryFilter);

                  _this3.SPEND_AVG_PER_CAMPAIGN.labels = graphdata.periodLabels;
                  _this3.SPEND_AVG_PER_CAMPAIGN.datasets = graphdata.datasets;
                  _this3.SPEND_AVG_PER_CAMPAIGN.summary = graphdata.revenueSummary;
                }

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getSpeedDataOverview: function getSpeedDataOverview(filters) {
      var _this4 = this;

      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_SpeedHelper__["a" /* default */].getSpeedData('all', queryFilter).then(function (response) {
        queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : '';
        var graphdata = _this4.getSpeedGraphData(response, queryFilter);
        _this4.SPEED_TURNAROUND.labels = graphdata.periodLabels;
        _this4.SPEED_TURNAROUND.datasets = graphdata.datasets;
      }).catch(function (error) {
        _this4.isLoading = false;
        console.log('error', error);
      });
    },
    getClientAvgRatingsOverview: function getClientAvgRatingsOverview(filters) {
      var _this5 = this;

      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      __WEBPACK_IMPORTED_MODULE_14__DashboardComponents_QualityRatingHelper__["a" /* default */].getClientAvgRatings(queryFilter, true).then(function (response) {
        var clientAvgRatings = response.ratings;
        var avgRates = _this5.calculateClientAvgOverall(clientAvgRatings);
        queryFilter.AMUserId = filters.firstFilterId ? filters.firstFilterId : '';
        var graphdata = _this5.getSatisfactionGraphData(avgRates, queryFilter);
        _this5.CLIENT_SATISFACTION.labels = graphdata.periodLabels;
        _this5.CLIENT_SATISFACTION.datasets = graphdata.datasets;
      }).catch(function (error) {
        _this5.isLoading = false;
        console.log('error', error);
      });
    },
    getSpendRevenueGraphData: function getSpendRevenueGraphData(data, filters) {
      var _this6 = this;

      var allPeriods = [];

      if (filters.monthly || filters.quarterly) {
        data = data.filter(function (d) {
          return d.year === parseInt(__WEBPACK_IMPORTED_MODULE_26_moment___default()().format('YYYY'));
        });
      }
      if (filters.monthly) {
        data = data.map(function (a) {
          a.period = a.month;
          return a;
        });
      } else if (filters.quarterly) {
        data = data.map(function (d) {
          d.period = __WEBPACK_IMPORTED_MODULE_26_moment___default()(d.year + '-' + d.month).quarter();
          return d;
        });
      } else if (filters.yearly) {
        data = data.map(function (d) {
          d.period = d.year;
          return d;
        });
      }
      allPeriods = data.map(function (a) {
        return a.period && a.period;
      });
      var periods = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(allPeriods.sort(function (a, b) {
        return a - b;
      }))));
      if (filters.quarterly) {
        var quarterLabel = this.quarterLabels(periods, data);
        periods = quarterLabel.periods;
        data = quarterLabel.data;
      }
      var datasets = [];
      var team = 0;
      var revenueSummary = [];
      var filterAM = [];
      if (filters.AMUserId !== '') {
        filterAM = this.AMUsers.filter(function (c) {
          return c.id === filters.AMUserId;
        });
      } else {
        filterAM = this.AMUsers;
      }
      filterAM.map(function (am, key) {
        var eachPeriodData = [];
        periods.map(function (p) {
          var AMCampaigns = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
          var eachTotalRate = 0;
          data.map(function (d) {
            if (d.period === p) {
              var hasAMInCampaign = _this6.campaigns.some(function (c) {
                return c.id === d.campaignId && c.assignedTo && c.assignedTo.includes(am.id);
              });
              if (hasAMInCampaign) {
                AMCampaigns.add(d.campaignId);

                if (d.revenueCalculation !== undefined) {
                  if (d.revenueCalculation === 'engagement') {
                    eachTotalRate += d.revenue;
                  } else {
                    eachTotalRate += d.revenueByContents;
                  }
                } else {
                  eachTotalRate += d.revenue;
                }
              }
            }
          });
          eachTotalRate = Math.round(eachTotalRate, 0);

          if (filters.avg_per_campaign) {
            eachTotalRate = eachTotalRate > 0 ? Math.round(eachTotalRate / AMCampaigns.size, 0) : 0;
          }
          eachPeriodData.push(eachTotalRate);
        });
        var dataAttrs = {
          'label': am.name,
          'data': eachPeriodData,
          'stack': 'Stack ' + (key + 1)
        };
        if (filters.avg_per_campaign) {
          dataAttrs.borderColor = am.lineColor;
          dataAttrs.fill = false;
        } else {
          dataAttrs.backgroundColor = am.lineColor;
        }
        datasets.push(dataAttrs);
        var AMTotal = eachPeriodData.reduce(function (a, b) {
          return a + b;
        }, 0);
        team += AMTotal;
        revenueSummary.push(_this6.getSummaryObj(am.name, AMTotal));
      });
      var periodLabels = this.ratingPeriodLabels(filters, periods);
      var bechmarkAttr = {
        'label': 'Benchmark',
        'backgroundColor': 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')',
        'stack': 'Stack ' + 0
      };
      if (filters.avg_per_campaign) {
        bechmarkAttr.borderColor = 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')';
        bechmarkAttr.fill = false;
        bechmarkAttr.data = periods.map(function (p) {
          return _this6.spendAvgBenchmark;
        });
      } else {
        bechmarkAttr.data = periods.map(function (p) {
          return _this6.spendRevBenchmark;
        });
      }
      datasets.unshift(bechmarkAttr);
      var shortFall = this.spendRevBenchmark - team;

      revenueSummary = revenueSummary.sort(function (a, b) {
        return b.data - a.data;
      });

      if (filters.AMUserId === '') {
        revenueSummary.push(this.getSummaryObj('Team', team));
      }
      revenueSummary.push(this.getSummaryObj('Benchmark', this.spendRevBenchmark), this.getSummaryObj('Shortfall', shortFall));

      revenueSummary = revenueSummary.map(function (r) {
        r.data = r.data + ' SGD';return r;
      });
      return { periodLabels: periodLabels, datasets: datasets, revenueSummary: revenueSummary };
    },
    getSpeedGraphData: function getSpeedGraphData(data, filters) {
      var _this7 = this;

      var allPeriods = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.campaignActivity).map(function (key) {
        allPeriods = data[key].map(function (a) {
          return a.period && a.period;
        });
      });
      var periods = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(allPeriods.sort())));
      var datasets = [];
      var filterAM = [];

      if (filters.AMUserId !== '') {
        filterAM = this.AMUsers.filter(function (c) {
          return c.id === filters.AMUserId;
        });
      } else {
        filterAM = this.AMUsers;
      }
      filterAM.map(function (am, key) {
        var eachPeriodData = [];
        periods.map(function (p) {
          var totalDays = 0;
          var eachCOAvgDays = 0;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this7.campaignActivity).map(function (key) {
            var AMCampaigns = data[key].filter(function (a) {
              return a.assignedTo && a.assignedTo.includes(am.id) && a.period === p;
            });
            var days = AMCampaigns.map(function (c) {
              return c.days;
            }).reduce(function (one, two) {
              return one + two;
            }, 0);
            totalDays += days;
          });
          eachCOAvgDays = totalDays > 0 ? Math.round(totalDays / __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this7.campaignActivity).length, 0) : 0;
          eachPeriodData.push(eachCOAvgDays);
        });
        datasets.push({
          'label': am.name,
          'data': eachPeriodData,
          'backgroundColor': am.lineColor,
          'stack': 'Stack ' + (key + 1)
        });
      });
      var benchmarkData = periods.map(function (p) {
        return _this7.speedBenchmark;
      });
      datasets.unshift({
        'label': 'Benchmark',
        'data': benchmarkData,
        'backgroundColor': 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')',
        'stack': 'Stack ' + 0
      });
      var periodLabels = this.ratingPeriodLabels(filters, periods);
      return { periodLabels: periodLabels, datasets: datasets };
    },
    getSatisfactionGraphData: function getSatisfactionGraphData(avgRates, filters) {
      var _this8 = this;

      var periods = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(avgRates.map(function (a) {
        return a._id.period;
      }).sort())));
      var datasets = [];
      var filterAM = [];

      if (filters.AMUserId !== '') {
        filterAM = this.AMUsers.filter(function (c) {
          return c.id === filters.AMUserId;
        });
      } else {
        filterAM = this.AMUsers;
      }
      this.AMUsers.map(function (am, key) {
        var eachPeriodData = [];
        periods.map(function (p) {
          var AMCampaigns = 0;
          var eachTotalRate = 0;
          avgRates.map(function (av) {
            if (av._id.period === p) {
              var hasAMInCampaign = _this8.campaigns.some(function (c) {
                return c.id === av._id.campaignID && c.assignedTo && c.assignedTo.includes(am.id);
              });
              if (hasAMInCampaign) {
                AMCampaigns += 1;
                eachTotalRate += av.avg_overall;
              }
            }
          });
          eachTotalRate = eachTotalRate > 0 && AMCampaigns > 0 ? Math.round(eachTotalRate / AMCampaigns) : 0;
          eachPeriodData.push(eachTotalRate);
        });
        datasets.push({
          'label': am.firstName + ' ' + am.lastName,
          'data': eachPeriodData,
          'borderColor': am.lineColor,
          'fill': false,
          'stack': 'Stack ' + (key + 1)
        });
      });

      var benchmarkData = periods.map(function (p) {
        return _this8.benchmark;
      });
      datasets.unshift({
        'label': 'Benchmark',
        'data': benchmarkData,
        'borderColor': 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')',
        'fill': false,
        'stack': 'Stack ' + 0
      });
      var periodLabels = this.ratingPeriodLabels(filters, periods);
      return { periodLabels: periodLabels, datasets: datasets };
    },
    calculateClientAvgOverall: function calculateClientAvgOverall(clientAvgRatings) {
      var avgValues = ['avg_influencers_selection', 'avg_content_quality_rate', 'avg_campaign_timeline_rate', 'avg_overall_experience_rate', 'avg_draft_post'];
      clientAvgRatings = clientAvgRatings.map(function (v) {
        var totalAvgs = 0;
        avgValues.map(function (akey) {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0;
          totalAvgs += v[akey];
        });
        v.avg_overall = Math.round(totalAvgs / avgValues.length);
        return v;
      });
      return clientAvgRatings;
    },
    ratingPeriodLabels: function ratingPeriodLabels(filters, periods) {
      if (filters.hasOwnProperty('monthly')) {
        return periods.map(function (p) {
          return __WEBPACK_IMPORTED_MODULE_26_moment___default()(p, 'MM').format('MMM');
        });
      }
      return periods;
    },
    quarterLabels: function quarterLabels(periods, data) {
      periods = periods.map(function (p) {
        return 'Q' + p;
      });
      data = data.map(function (d) {
        if (d.period.length) {
          d.period = d.period.map(function (p) {
            return 'Q' + p;
          });
        } else if (d.period) {
          d.period = 'Q' + d.period;
        }
        return d;
      });
      return { periods: periods, data: data };
    },
    randomLineColors: function randomLineColors() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      if (r === this.benchmarkColor.r && g == this.benchmarkColor.g && b == this.benchmarkColor.b) {
        this.randomLineColors();
      }

      return "rgb(" + r + "," + g + "," + b + ")";
    },
    calculateCompletionSummary: function calculateCompletionSummary() {
      var _this9 = this;

      var dataset = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Speed.COMPLETION.MONTHLY.datasets;
      dataset.map(function (item) {
        var avgValue = item.data.reduce(function (a, b) {
          return a + b;
        }) / 12;
        var summaryObj = {
          "text": item.label,
          "value": Math.round(avgValue)
        };
        _this9.completionSummary.push(summaryObj);
      });
    },
    calculateRevenueSummary: function calculateRevenueSummary() {
      var _this10 = this;

      var dataset = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Speed.REVENUE.MONTHLY.datasets;
      dataset.map(function (item) {
        var summaryObj = {
          "text": item.label,
          "value": item.data.reduce(function (a, b) {
            return a + b;
          })
        };
        _this10.revenueSummary.push(summaryObj);
      });
    },
    calculateRenewalSummary: function calculateRenewalSummary() {
      var _this11 = this;

      var dataset = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Spend.RENEWAL.MONTHLY.datasets;
      var total = 0;
      dataset.map(function (item) {
        var summaryObj = {
          'text': item.label,
          'value': item.data.reduce(function (a, b) {
            return a + b;
          })
        };
        total += summaryObj.value;
        _this11.renewalSummary.push(summaryObj);
      });

      var totalRenewal = {
        'text': 'Total',
        'value': total
      };
      this.renewalSummary.push(totalRenewal);
    },
    calculateAverageAmountSummary: function calculateAverageAmountSummary(totalCount) {
      var _this12 = this;

      var dataset = __WEBPACK_IMPORTED_MODULE_27__Chart_chart_data_json___default.a.Spend.AVERAGE_AMOUNT.MONTHLY.datasets;
      dataset.map(function (item) {
        var avgValue = item.data.reduce(function (a, b) {
          return a + b;
        }) / totalCount;
        var summaryObj = {
          "text": item.label,
          "value": Math.round(avgValue)
        };
        _this12.averageAmountSummary.push(summaryObj);
      });
    },
    getPeriodFilter: function getPeriodFilter(filters) {
      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      return queryFilter;
    },
    getSummaryObj: function getSummaryObj(label, data) {
      return { label: label, data: data };
    },
    speedDetail: function speedDetail() {
      this.$router.push({ name: 'am-speed' });
    },
    spendDetail: function spendDetail() {
      this.$router.push({ name: 'AM-Quality' });
    },
    spendRevenueDetail: function spendRevenueDetail() {
      this.$router.push({ name: 'am-spend-revenue' });
    },
    qualityDetail: function qualityDetail() {
      this.$router.push({ name: 'AM-Quality' });
    },
    getUsers: function getUsers() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                response = null;
                _context4.next = 4;
                return _this13.$store.dispatch('client/getClients');

              case 4:
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_23__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_25__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                response = _context4.sent;

                if (response) {
                  _this13.AM = response.users;
                  _this13.AM = _this13.AM.map(function (am) {
                    am.name = am.firstName + ' ' + am.lastName;
                    return am;
                  });
                }
                _this13.AM.unshift({ id: '', name: 'All Team' });
                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_23__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_25__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 11:
                response = _context4.sent;

                if (response) {
                  _this13.CC = response.users;
                  _this13.CC = _this13.CC.map(function (cc) {
                    cc.name = cc.firstName + ' ' + cc.lastName;
                    return cc;
                  });
                  _this13.CC.unshift({ id: '', name: 'All Team' });
                }
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](0);

                console.log('error', _context4.t0);
                return _context4.abrupt('return', false);

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this13, [[0, 15]]);
      }))();
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_24__Campaign_campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this14.viewCampaignData = response;
        _this14.viewCampaignModalDialog = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashboardComponents_QualityRatingHelper__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_InfluencerQualityRating_vue__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_InfluencerQualityRating_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DashboardComponents_InfluencerQualityRating_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_ClientQualityRating_vue__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_ClientQualityRating_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DashboardComponents_ClientQualityRating_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_Chart_Pie_vue__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_Chart_Pie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DashboardComponents_Chart_Pie_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Quality',
  components: {
    InfluencerQualityRating: __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_InfluencerQualityRating_vue___default.a,
    ClientQualityRating: __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_ClientQualityRating_vue___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_Chart_Pie_vue___default.a
  },
  data: function data() {
    return {
      campaigns: [],
      filterCampaigns: [],
      filters: {},
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/am/dashboard'
      }, {
        text: 'Quality',
        disabled: true,
        href: ''
      }],
      AMUsers: [],
      filterUsers: [],
      clientHeaders: [{ value: 'name', text: 'Campaign', sortable: true }, { value: 'vertical', text: 'Vertical', sortable: true }, { value: 'budget', text: 'Budget', sortable: true }, { value: 'avg_influencers_selection', text: 'Average Rating on Selection', sortable: true }, { value: 'avg_draft_post', text: 'Average Rating on Drafts', sortable: true }, { value: 'avg_campaign_timeline_rate', text: 'Average Rating on Timeline', sortable: true }, { value: 'avg_content_quality_rate', text: 'Average on Content Quality', sortable: true }, { value: 'avg_overall_experience_rate', text: 'Average on Overall Experience with KOBE', sortable: true }, { value: 'overall_rate', text: 'Overall Score', sortable: true }],
      CLIENT_RATING: {
        title: 'Client Rating',
        items: []
      },
      clientAvgRatings: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__DashboardComponents_QualityRatingHelper__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
      _this.campaigns = response;
      _this.filterCampaigns = response;
      _this.filterCampaigns.unshift({ id: '', name: 'All Campaigns' });
      _this.getClientAvgRatings();
    }).catch(function (error) {
      _this.isLoading = false;
      console.log('error', error);
    });

    __WEBPACK_IMPORTED_MODULE_3__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (response) {
      _this.AMUsers = response.users;
      _this.filterUsers = response.users.map(function (user) {
        user.name = user.firstName + ' ' + user.lastName;
        return user;
      });
      _this.filterUsers.unshift({ id: '', name: 'All Team' });
    }).catch(function (error) {
      console.log('error', error);
    });
  },

  methods: {
    clientSearch: function clientSearch(filters) {
      this.filters = filters;
      this.getClientAvgRatings();
    },
    getClientAvgRatings: function getClientAvgRatings() {
      var _this2 = this;

      var queryFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { month: this.filters.month ? this.filters.month : '' });
      __WEBPACK_IMPORTED_MODULE_4__DashboardComponents_QualityRatingHelper__["a" /* default */].getClientAvgRatings(queryFilter, true).then(function (response) {
        _this2.clientAvgRatings = response.ratings;
        _this2.CLIENT_RATING.items = [];
        _this2.CLIENT_RATING.items = _this2.calculateClientAvgOverall(_this2.filterAvgRatings(_this2.clientAvgRatings, _this2.filters));
      }).catch(function (error) {
        _this2.isLoading = false;
        console.log('error', error);
      });
    },
    filterAvgRatings: function filterAvgRatings(allAvgRatings, filters) {
      var filteredCampaigns = this.campaigns.filter(function (c) {
        return allAvgRatings.some(function (v) {
          return c.id === (v._id && v._id.campaignID);
        });
      });
      filteredCampaigns.map(function (c) {
        var avgRatings = allAvgRatings.filter(function (avg) {
          return (avg._id && avg._id.campaignID) === c.id;
        });
        if (avgRatings.length) {
          avgRatings.map(function (ar) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(c, ar);
          });
        }
      });

      if (filters.CampaignId && filters.CampaignId !== '') {
        filteredCampaigns = filteredCampaigns.filter(function (c) {
          return c.id === filters.CampaignId;
        });
      }

      if (filters.UserId && filters.UserId !== '') {
        filteredCampaigns = filteredCampaigns.filter(function (c) {
          return c.assignedTo && c.assignedTo.includes(filters.UserId);
        });
      }
      return filteredCampaigns;
    },
    calculateClientAvgOverall: function calculateClientAvgOverall(filteredCampaigns) {
      var avgValues = ['avg_influencers_selection', 'avg_content_quality_rate', 'avg_campaign_timeline_rate', 'avg_overall_experience_rate', 'avg_draft_post'];
      filteredCampaigns = filteredCampaigns.map(function (v) {
        var totalAvgs = 0;
        avgValues.map(function (akey) {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0;
          totalAvgs += v[akey];
        });
        v.overall_rate = Math.round(totalAvgs / avgValues.length);
        return v;
      });
      return filteredCampaigns;
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Speed',
  components: {
    SpeedStages: __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages___default.a
  },
  data: function data() {
    return {
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/am/dashboard'
      }, {
        text: 'Speed',
        disabled: true,
        href: ''
      }],
      filterUser: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = void 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

            case 3:
              response = _context.sent;

              if (response) {
                _this.filterUser = response.users.map(function (user) {
                  user.name = user.firstName + ' ' + user.lastName;
                  return user;
                });
                _this.filterUser.unshift({ id: '', name: 'All Team' });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AM_Spend_Revenue',
  components: {
    SummaryOfAccount: __WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount___default.a
  },
  data: function data() {
    return {
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/am/dashboard'
      }, {
        text: 'Spend Revenue',
        disabled: true,
        href: ''
      }],
      filterUser: []
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = void 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

            case 3:
              response = _context.sent;

              if (response) {
                _this.filterUser = response.users.map(function (user) {
                  user.name = user.firstName + ' ' + user.lastName;
                  return user;
                });
                _this.filterUser.unshift({ id: '', name: 'All Team' });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bar-Chart',
  props: ['chartData', 'name'],
  data: function data() {
    return {
      toggle_filter: 0,
      MONTHLY_DATA: [],
      cogs: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.loadCharts();
    }, 1000);
  },

  methods: {
    loadCharts: function loadCharts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.chartData;

              case 2:
                data = _context.sent;

                if (_this2.name === 'speed') {
                  _this2.renderSpeedChart(data.MONTHLY);
                } else {
                  _this2.renderSpendChart(data.MONTHLY);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    detailClick: function detailClick(name) {
      if (name === 'speed') this.$router.push({ name: 'co-speed' });else this.$router.push({ name: 'co-spend-revenue' });
    },
    monthlyClick: function monthlyClick(name) {
      if (name.toLowerCase() === 'speed') {
        this.renderSpeedChart(this.chartData.MONTHLY);
      } else this.renderSpendChart(this.chartData.MONTHLY);
    },
    quartelyClick: function quartelyClick(name) {
      if (name.toLowerCase() === 'speed') {
        this.renderSpeedChart(this.chartData.QUARTELY);
      } else this.renderSpendChart(this.chartData.QUARTELY);
    },
    yearlyClick: function yearlyClick(name) {
      if (name.toLowerCase() === 'speed') {
        this.renderSpeedChart(this.chartData.YEARLY);
      } else this.renderSpendChart(this.chartData.YEARLY);
    },
    renderSpeedChart: function renderSpeedChart(chartData) {
      var ctx = document.getElementById(this.name);

      var config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.speedChart !== undefined) {
        window.speedChart.destroy();
      }

      window.speedChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
    },
    renderSpendChart: function renderSpendChart(chartData) {
      var ctx = document.getElementById(this.name);

      var config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          tooltips: {
            callbacks: {
              label: function label(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][tooltipItem['datasetIndex']]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            },
            yAxes: [{
              ticks: {
                callback: function callback(value) {
                  return value + '%';
                }
              },
              scaleLabel: {
                display: true,
                labelString: 'Percentage'
              }
            }]
          }
        }
      };
      if (window.spendChart !== undefined) {
        window.spendChart.destroy();
      }

      window.spendChart = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(ctx, config);
    }
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__co_data_json__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__co_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__co_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Chart_chart_data_json__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Chart_chart_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Chart_chart_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DashboardComponents_ContentStrategistTasks_vue__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DashboardComponents_ContentStrategistTasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__DashboardComponents_ContentStrategistTasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_CampaignSummary_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_CampaignSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__DashboardComponents_CampaignSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DashboardComponents_TotalNumbers__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DashboardComponents_TotalNumbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__DashboardComponents_TotalNumbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Chart_Bar_vue__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Chart_Bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Chart_Bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DashboardComponents_Chart_Bar_vue__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DashboardComponents_Chart_Bar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__DashboardComponents_Chart_Bar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DashboardComponents_Chart_Line_vue__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DashboardComponents_Chart_Line_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__DashboardComponents_Chart_Line_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_QualityRatingHelper__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DashboardComponents_SpeedHelper__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DashboardComponents_SpendHelper__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DashboardComponents_KobeOverviewHelper__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DashboardComponents_CampaignBriefDataTable_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DashboardComponents_CampaignBriefDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__DashboardComponents_CampaignBriefDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DashboardComponents_DashboardActivationDataTable_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DashboardComponents_DashboardActivationDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__DashboardComponents_DashboardActivationDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DashboardComponents_PairingLineupDataTable_vue__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DashboardComponents_PairingLineupDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__DashboardComponents_PairingLineupDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__DashboardComponents_DraftsDataTable_vue__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__DashboardComponents_DraftsDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__DashboardComponents_DraftsDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__DashboardComponents_ReportingDataTable_vue__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__DashboardComponents_ReportingDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__DashboardComponents_ReportingDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Campaign_ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Campaign_ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__Campaign_ViewCampaignModal__);

































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CO_Dashboard',
  components: {
    ChangePasswordModal: __WEBPACK_IMPORTED_MODULE_8__User_ChangePasswordModal___default.a,
    ContentStrategistTasks: __WEBPACK_IMPORTED_MODULE_14__DashboardComponents_ContentStrategistTasks_vue___default.a,
    CampaignSummary: __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_CampaignSummary_vue___default.a,
    totalNumber: __WEBPACK_IMPORTED_MODULE_16__DashboardComponents_TotalNumbers___default.a,
    SpendBarChart: __WEBPACK_IMPORTED_MODULE_17__Chart_Bar_vue___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_18__DashboardComponents_Chart_Bar_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_19__DashboardComponents_Chart_Line_vue___default.a,
    DashboardActivationDataTable: __WEBPACK_IMPORTED_MODULE_25__DashboardComponents_DashboardActivationDataTable_vue___default.a,
    CampaignBriefDataTable: __WEBPACK_IMPORTED_MODULE_24__DashboardComponents_CampaignBriefDataTable_vue___default.a,
    PairingLineupDataTable: __WEBPACK_IMPORTED_MODULE_26__DashboardComponents_PairingLineupDataTable_vue___default.a,
    DraftsDataTable: __WEBPACK_IMPORTED_MODULE_27__DashboardComponents_DraftsDataTable_vue___default.a,
    ReportingDataTable: __WEBPACK_IMPORTED_MODULE_28__DashboardComponents_ReportingDataTable_vue___default.a,
    ViewCampaignModal: __WEBPACK_IMPORTED_MODULE_29__Campaign_ViewCampaignModal___default.a
  },
  data: function data() {
    return {
      passwordModalDialog: false,
      pwdWarning: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      totalSummaryData: {},
      speedChartData: __WEBPACK_IMPORTED_MODULE_10__Chart_chart_data_json___default.a.Speed,
      spendChartData: __WEBPACK_IMPORTED_MODULE_10__Chart_chart_data_json___default.a.Spend,
      campaigns: [],
      COUsers: [],
      FilterCOUsers: [],
      benchmark: 4,
      benchmarkColor: { r: 255, g: 99, b: 132 },
      yAxes: {
        min: 0,
        max: 5,
        stepSize: 1,
        label: 'Score'
      },
      speedBenchmark: 20,
      speedYAxes: {
        min: 0,
        max: 30,
        stepSize: 5,
        label: 'Days'
      },
      SPEED_TURNAROUND: {
        id: 'campaign_speed_turnaround_chart',
        title: 'Turnaround for Campaign - Filter by',
        labels: [],
        datasets: []
      },
      spendCogsBenchmark: 50,
      spendCogsYAxes: {
        min: 0,
        max: 100,
        stepSize: 10,
        label: 'Percentage'
      },
      SPEND_COGS: {
        id: 'campaign_spend_cogs_chart',
        title: 'COGS - Filter by',
        labels: [],
        datasets: []
      },
      INFLUENCER_SATISFACTION: {
        id: 'influencer_line_chart',
        title: 'Influencer Satisfaction - Filter by',
        labels: [],
        datasets: []
      },
      CLIENT_SATISFACTION: {
        id: 'client_line_chart',
        title: 'CLIENT Satisfaction - Filter by',
        labels: [],
        datasets: []
      },
      influencerPerMonth: 'Total Influencer on ' + __WEBPACK_IMPORTED_MODULE_6_moment___default()(Date.now()).format('MMMM'),
      campaignActivity: {
        ACTIVATION: 'activation',
        PAIRING: 'pairing',
        CREATING: 'creating',
        COMPLETE: 'complete'
      },
      viewCampaignData: null,
      viewCampaignModalDialog: false,
      AM: [],
      CC: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getUsers();
              _this.pwdWarning = _this.user.pwdWarning;
              response = void 0;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_QualityRatingHelper__["a" /* default */].getAllCampaignsNoStatus();

            case 5:
              response = _context.sent;

              if (response) {
                _this.campaigns = response;
              }
              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 9:
              response = _context.sent;

              if (response) {
                _this.COUsers = response.users;
                _this.COUsers = _this.COUsers.map(function (co) {
                  co.name = co.firstName + ' ' + co.lastName;
                  co.lineColor = _this.randomLineColors();
                  return co;
                });
                _this.filterUsers = _this.COUsers.slice();
                _this.filterUsers.unshift({ id: '', name: 'All Team' });
              }

              _this.getSpeedDataOverview({ monthly: true });
              _this.getInfluencerAvgRatingsOverview({ monthly: true });

              _this.getSpendCOGS({ monthly: true });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getSpeedDataOverview: function getSpeedDataOverview(filters) {
      var _this2 = this;

      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      __WEBPACK_IMPORTED_MODULE_21__DashboardComponents_SpeedHelper__["a" /* default */].getSpeedData('all', queryFilter).then(function (response) {
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : '';
        var graphdata = _this2.getSpeedGraphData(response, queryFilter);
        _this2.SPEED_TURNAROUND.labels = graphdata.periodLabels;
        _this2.SPEED_TURNAROUND.datasets = graphdata.datasets;
      }).catch(function (error) {
        _this2.isLoading = false;
        console.log('error', error);
      });
    },
    getInfluencerAvgRatingsOverview: function getInfluencerAvgRatingsOverview(filters) {
      var _this3 = this;

      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_QualityRatingHelper__["a" /* default */].getInfluencerAvgRating(queryFilter, true).then(function (response) {
        var avgRates = response.data;
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : '';
        var graphdata = _this3.getSatisfactionGraphData(avgRates, queryFilter);
        _this3.INFLUENCER_SATISFACTION.labels = graphdata.periodLabels;
        _this3.INFLUENCER_SATISFACTION.datasets = graphdata.datasets;
      }).catch(function (error) {
        _this3.isLoading = false;
        console.log('error', error);
      });
    },
    getClientAvgRatingsOverview: function getClientAvgRatingsOverview(filters) {
      var _this4 = this;

      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      __WEBPACK_IMPORTED_MODULE_20__DashboardComponents_QualityRatingHelper__["a" /* default */].getClientAvgRatings(filters, true).then(function (response) {
        var clientAvgRatings = response.ratings;
        var avgRates = _this4.calculateClientAvgOverall(clientAvgRatings);
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : '';
        var graphdata = _this4.getSatisfactionGraphData(avgRates, queryFilter);
        _this4.CLIENT_SATISFACTION.labels = graphdata.periodLabels;
        _this4.CLIENT_SATISFACTION.datasets = graphdata.datasets;
      }).catch(function (error) {
        _this4.isLoading = false;
        console.log('error', error);
      });
    },
    getSpendCOGS: function getSpendCOGS(filters) {
      var _this5 = this;

      var queryFilter = this.getPeriodFilter(filters);
      __WEBPACK_IMPORTED_MODULE_22__DashboardComponents_SpendHelper__["a" /* default */].getCOGSPerCampaign(queryFilter).then(function (response) {
        queryFilter.COUserId = filters.firstFilterId ? filters.firstFilterId : '';
        var graphdata = _this5.getSpendGraphData(response, queryFilter);
        _this5.SPEND_COGS.labels = graphdata.periodLabels;
        _this5.SPEND_COGS.datasets = graphdata.datasets;
      }).catch(function (error) {
        _this5.isLoading = false;
        console.log('error', error);
      });
    },
    getSpeedGraphData: function getSpeedGraphData(data, filters) {
      var _this6 = this;

      var allPeriods = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.campaignActivity).map(function (key) {
        allPeriods = data[key].map(function (a) {
          return a.period && a.period;
        });
      });
      var periods = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(allPeriods.sort())));
      var datasets = [];
      var filterCO = [];

      if (filters.COUserId !== '') {
        filterCO = this.COUsers.filter(function (c) {
          return c.id === filters.COUserId;
        });
      } else {
        filterCO = this.COUsers;
      }
      filterCO.map(function (co, key) {
        var eachPeriodData = [];
        periods.map(function (p) {
          var totalDays = 0;
          var eachCOAvgDays = 0;
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this6.campaignActivity).map(function (key) {
            var COCampaigns = data[key].filter(function (a) {
              return a.assignedTo && a.assignedTo.includes(co.id) && a.period === p;
            });
            var days = COCampaigns.map(function (c) {
              return c.days;
            }).reduce(function (one, two) {
              return one + two;
            }, 0);
            totalDays += days;
          });
          eachCOAvgDays = totalDays > 0 ? Math.round(totalDays / __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this6.campaignActivity).length, 0) : 0;
          eachPeriodData.push(eachCOAvgDays);
        });
        datasets.push({
          'label': co.name,
          'data': eachPeriodData,
          'backgroundColor': co.lineColor,
          'stack': 'Stack ' + (key + 1)
        });
      });
      var benchmarkData = periods.map(function (p) {
        return _this6.speedBenchmark;
      });
      datasets.unshift({
        'label': 'Benchmark',
        'data': benchmarkData,
        'backgroundColor': 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')',
        'stack': 'Stack ' + 0
      });
      var periodLabels = this.ratingPeriodLabels(filters, periods);
      return { periodLabels: periodLabels, datasets: datasets };
    },
    getSatisfactionGraphData: function getSatisfactionGraphData(avgRates, filters) {
      var _this7 = this;

      var periods = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(avgRates.map(function (a) {
        return a._id.period;
      }).sort())));
      var datasets = [];
      var filterCO = [];

      if (filters.COUserId !== '') {
        filterCO = this.COUsers.filter(function (c) {
          return c.id === filters.COUserId;
        });
      } else {
        filterCO = this.COUsers;
      }
      filterCO.map(function (co, key) {
        var eachPeriodData = [];
        periods.map(function (p) {
          var COCampaigns = 0;
          var eachTotalRate = 0;
          avgRates.map(function (av) {
            if (av._id.period === p) {
              var hasCOInCampaign = _this7.campaigns.some(function (c) {
                return c.id === av._id.campaignID && c.assignedTo && c.assignedTo.includes(co.id);
              });
              if (hasCOInCampaign) {
                COCampaigns += 1;
                eachTotalRate += av.avg_overall;
              }
            }
          });
          eachTotalRate = eachTotalRate > 0 && COCampaigns > 0 ? Math.round(eachTotalRate / COCampaigns) : 0;
          eachPeriodData.push(eachTotalRate);
        });
        datasets.push({
          'label': co.name,
          'data': eachPeriodData,
          'borderColor': co.lineColor,
          'fill': false,
          'stack': 'Stack ' + (key + 1)
        });
      });

      var benchmarkData = periods.map(function (p) {
        return _this7.benchmark;
      });
      datasets.unshift({
        'label': 'Benchmark',
        'data': benchmarkData,
        'borderColor': 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')',
        'fill': false,
        'stack': 'Stack ' + 0
      });
      var periodLabels = this.ratingPeriodLabels(filters, periods);
      return { periodLabels: periodLabels, datasets: datasets };
    },
    getSpendGraphData: function getSpendGraphData(data, filters) {
      var _this8 = this;

      var periodResult = this.getCogsCampaignPeriod(data, filters);
      data = periodResult.data;
      var periods = periodResult.periods;
      var datasets = [];
      var filterCO = [];

      if (filters.COUserId !== '') {
        filterCO = this.COUsers.filter(function (c) {
          return c.id === filters.COUserId;
        });
      } else {
        filterCO = this.COUsers;
      }
      filterCO.map(function (co, key) {
        var eachPeriodData = [];
        periods.map(function (p) {
          var eachTotalTarget = 0;
          var eachTotalPayout = 0;
          var eachTotalRate = 0;
          data.map(function (c) {
            c.period.map(function (dp) {
              if (dp === p) {
                if (c.assignedTo && c.assignedTo.includes(co.id)) {
                  eachTotalTarget += c.budget;
                  eachTotalPayout += c.payout;
                }
              }
            });
          });
          eachTotalRate = eachTotalPayout > 0 || eachTotalTarget > 0 ? (eachTotalPayout / eachTotalTarget * 100).toFixed(2) : 0;
          eachPeriodData.push(eachTotalRate);
        });
        datasets.push({
          'label': co.name,
          'data': eachPeriodData,
          'backgroundColor': co.lineColor,
          'stack': 'Stack ' + (key + 1)
        });
      });
      var benchmarkData = periods.map(function (p) {
        return _this8.spendCogsBenchmark;
      });
      datasets.unshift({
        'label': 'Benchmark',
        'data': benchmarkData,
        'backgroundColor': 'rgba(' + this.benchmarkColor.r + ', ' + this.benchmarkColor.g + ', ' + this.benchmarkColor.b + ')',
        'stack': 'Stack ' + 0
      });
      var periodLabels = this.ratingPeriodLabels(filters, periods);
      return { periodLabels: periodLabels, datasets: datasets };
    },
    calculateClientAvgOverall: function calculateClientAvgOverall(clientAvgRatings) {
      var avgValues = ['avg_influencers_selection', 'avg_content_quality_rate', 'avg_campaign_timeline_rate', 'avg_overall_experience_rate', 'avg_draft_post'];
      clientAvgRatings = clientAvgRatings.map(function (v) {
        var totalAvgs = 0;
        avgValues.map(function (akey) {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0;
          totalAvgs += v[akey];
        });
        v.avg_overall = Math.round(totalAvgs / avgValues.length);
        return v;
      });
      return clientAvgRatings;
    },
    getCogsCampaignPeriod: function getCogsCampaignPeriod(data, filters) {
      var allPeriods = [];
      var currentYear = parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY'));
      data = data.map(function (a) {
        a.period = [];

        if (a.startDate) {
          var startYear = parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.startDate).format('YYYY'));
          if (filters.monthly && startYear === currentYear) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.startDate).format('M'));
          } else if (filters.quarterly && startYear === currentYear) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.startDate).quarter());
          } else if (filters.yearly) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.startDate).format('YYYY'));
          }
        }

        if (a.endDate) {
          var endYear = parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.endDate).format('YYYY'));
          if (filters.monthly && endYear === currentYear) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.endDate).format('M'));
          } else if (filters.quarterly && endYear === currentYear) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.endDate).quarter());
          } else if (filters.yearly) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.endDate).format('YYYY'));
          }
        }

        if (!a.startDate && !a.endDate) {
          var createdYear = parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.createdAt).format('YYYY'));
          if (filters.monthly && createdYear === currentYear) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.createdAt).format('M'));
          } else if (filters.quarterly && createdYear === currentYear) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.createdAt).quarter());
          } else if (filters.yearly) {
            a.period.push(__WEBPACK_IMPORTED_MODULE_6_moment___default()(a.createdAt).format('YYYY'));
          }
        }
        a.period = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(a.period)));
        return a;
      });
      data = data.filter(function (d) {
        return d.period.length > 0;
      });
      data.map(function (a) {
        if (a.period) {
          a.period.map(function (p) {
            if (p !== 'Invalid date') {
              allPeriods.push(p);
            }
          });
        }
      });
      var periods = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(allPeriods))).sort(function (a, b) {
        return a - b;
      });
      if (filters.quarterly) {
        var quarterLabel = this.quarterLabels(periods, data);
        periods = quarterLabel.periods;
        data = quarterLabel.data;
      }
      return { data: data, periods: periods };
    },
    ratingPeriodLabels: function ratingPeriodLabels(filters, periods) {
      if (filters.hasOwnProperty('monthly')) {
        return periods.map(function (p) {
          return __WEBPACK_IMPORTED_MODULE_6_moment___default()(p, 'MM').format('MMM');
        });
      }
      return periods;
    },
    quarterLabels: function quarterLabels(periods, data) {
      periods = periods.map(function (p) {
        return 'Q' + p;
      });
      data = data.map(function (d) {
        if (d.period.length) {
          d.period = d.period.map(function (p) {
            return 'Q' + p;
          });
        } else if (d.period) {
          d.period = 'Q' + d.period;
        }
        return d;
      });
      return { periods: periods, data: data };
    },
    randomLineColors: function randomLineColors() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      if (r === this.benchmarkColor.r && g == this.benchmarkColor.g && b == this.benchmarkColor.b) {
        this.randomLineColors();
      }

      return "rgb(" + r + "," + g + "," + b + ")";
    },
    getPeriodFilter: function getPeriodFilter(filters) {
      var queryFilter = {};
      if (filters.monthly) {
        queryFilter.monthly = true;
      }
      if (filters.quarterly) {
        queryFilter.quarterly = true;
      }
      if (filters.yearly) {
        queryFilter.yearly = true;
      }
      return queryFilter;
    },
    speedDetail: function speedDetail() {
      this.$router.push({ name: 'co-speed' });
    },
    satisfactionDetail: function satisfactionDetail() {
      this.$router.push({ name: 'CO-Quality' });
    },
    spendRevenueDetail: function spendRevenueDetail() {
      this.$router.push({ name: 'co-spend-revenue' });
    },
    getUsers: function getUsers() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                response = null;
                _context2.next = 4;
                return _this9.$store.dispatch('client/getClients');

              case 4:
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                response = _context2.sent;

                if (response) {
                  _this9.AM = response.users;
                  _this9.AM = _this9.AM.map(function (am) {
                    am.name = am.firstName + ' ' + am.lastName;
                    return am;
                  });
                }
                _this9.AM.unshift({ id: '', name: 'All Team' });
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 11:
                response = _context2.sent;

                if (response) {
                  _this9.CC = response.users;
                  _this9.CC = _this9.CC.map(function (cc) {
                    cc.name = cc.firstName + ' ' + cc.lastName;
                    return cc;
                  });
                  _this9.CC.unshift({ id: '', name: 'All Team' });
                }
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](0);

                console.log('error', _context2.t0);
                return _context2.abrupt('return', false);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this9, [[0, 15]]);
      }))();
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this10.viewCampaignData = response;
        _this10.viewCampaignModalDialog = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_QualityRatingHelper__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DashboardComponents_InfluencerQualityRating_vue__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DashboardComponents_InfluencerQualityRating_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DashboardComponents_InfluencerQualityRating_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_ClientQualityRating_vue__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_ClientQualityRating_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DashboardComponents_ClientQualityRating_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Pie_vue__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Pie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Pie_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Quality',
  components: {
    InfluencerQualityRating: __WEBPACK_IMPORTED_MODULE_7__DashboardComponents_InfluencerQualityRating_vue___default.a,
    ClientQualityRating: __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_ClientQualityRating_vue___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_Chart_Pie_vue___default.a
  },
  data: function data() {
    return {
      campaigns: [],
      filterCampaigns: [],
      filters: {},
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/co/dashboard'
      }, {
        text: 'Quality',
        disabled: true,
        href: ''
      }],
      influencerHeaders: [{ value: 'name', text: 'Campaign', sortable: true }, { value: 'avg_satisfy', text: 'Average Satisfaction with Campaign', sortable: true }, { value: 'avg_advertiser', text: 'Average Experience with Advertiser', sortable: true }, { value: 'avg_kobe', text: 'Average Satisfaction with Kobe', sortable: true }, { value: 'avg_overall', text: 'Overall Rating', sortable: true }],
      INFLUENCER_RATING: {
        title: 'Influencer Rating',
        items: []
      },
      influencerAvgRatings: [],
      COUsers: [],
      filterUsers: [],
      clientHeaders: [{ value: 'name', text: 'Campaign', sortable: true }, { value: 'vertical', text: 'Vertical', sortable: true }, { value: 'budget', text: 'Budget', sortable: true }, { value: 'avg_influencers_selection', text: 'Average Rating on Selection', sortable: true }, { value: 'avg_draft_post', text: 'Average Rating on Drafts', sortable: true }, { value: 'avg_campaign_timeline_rate', text: 'Average Rating on Timeline', sortable: true }, { value: 'avg_content_quality_rate', text: 'Average on Content Quality', sortable: true }, { value: 'avg_overall_experience_rate', text: 'Average on Overall Experience with KOBE', sortable: true }, { value: 'overall_rate', text: 'Overall Score', sortable: true }],
      CLIENT_RATING: {
        title: 'Client Rating',
        items: []
      },
      clientAvgRatings: [],
      REPORT_ABUSE: {
        title: 'Report Abuse in %',
        labels: ['Non-compliance to Brief', 'Language Consideration', 'Clarity of Image', 'Inaccuracy of Factual Information', 'Inaccurate hastags & mentions'],
        backgroundColors: ['rgba(255, 100, 111, 23)', 'rgba(255, 111, 64, 0.8)', 'rgba(255, 168, 111, 0.8)', 'rgba(255, 59, 42, 111)', 'rgba(255, 222, 1, 0.8)'],
        items: []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_QualityRatingHelper__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
      _this.campaigns = response;
      _this.filterCampaigns = response;
      _this.filterCampaigns.unshift({ id: '', name: 'All Campaigns' });
      _this.getInfluencerAvgRatings();
      _this.getClientAvgRatings();
    }).catch(function (error) {
      _this.isLoading = false;
      console.log('error', error);
    });

    __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.AD_STRATEGIST).then(function (response) {
      _this.COUsers = response.users;
      _this.filterUsers = response.users.map(function (user) {
        user.name = user.firstName + ' ' + user.lastName;
        return user;
      });
      _this.filterUsers.unshift({ id: '', name: 'All Team' });
    }).catch(function (error) {
      console.log('error', error);
    });
    this.getReportAbuse();
  },

  methods: {
    influencerSearch: function influencerSearch(filters) {
      this.filters = filters;
      this.getInfluencerAvgRatings();
    },
    clientSearch: function clientSearch(filters) {
      this.filters = filters;
      this.getClientAvgRatings();
    },
    reportAbuseSearch: function reportAbuseSearch(filters) {
      this.filters = filters;
      this.getReportAbuse();
    },
    getInfluencerAvgRatings: function getInfluencerAvgRatings() {
      var _this2 = this;

      var queryFilter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { month: this.filters.month ? this.filters.month : '' });
      __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_QualityRatingHelper__["a" /* default */].getInfluencerAvgRating(queryFilter, true).then(function (response) {
        _this2.influencerAvgRatings = response.data;
        _this2.INFLUENCER_RATING.items = [];
        _this2.INFLUENCER_RATING.items = _this2.filterAvgRatings(_this2.influencerAvgRatings, _this2.filters);
      }).catch(function (error) {
        _this2.isLoading = false;
        console.log('error', error);
      });
    },
    getClientAvgRatings: function getClientAvgRatings() {
      var _this3 = this;

      var queryFilter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { month: this.filters.month ? this.filters.month : '' });
      __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_QualityRatingHelper__["a" /* default */].getClientAvgRatings(queryFilter, true).then(function (response) {
        _this3.clientAvgRatings = response.ratings;
        _this3.CLIENT_RATING.items = [];
        _this3.CLIENT_RATING.items = _this3.calculateClientAvgOverall(_this3.filterAvgRatings(_this3.clientAvgRatings, _this3.filters));
      }).catch(function (error) {
        _this3.isLoading = false;
        console.log('error', error);
      });
    },
    getReportAbuse: function getReportAbuse() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_QualityRatingHelper__["a" /* default */].getTotalReportAbuse(this.filters, true).then(function (response) {
        var totalReportAbuse = response;
        if (!totalReportAbuse) {
          _this4.REPORT_ABUSE.items = [];
          return;
        }
        delete totalReportAbuse._id;
        var sumValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(totalReportAbuse).reduce(function (a, b) {
          return a + b;
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(totalReportAbuse).forEach(function (key) {
          totalReportAbuse[key] = Math.round(totalReportAbuse[key] / sumValues * 100, 2);
        });
        _this4.REPORT_ABUSE.items = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(totalReportAbuse);
      }).catch(function (error) {
        _this4.isLoading = false;
        console.log('error', error);
      });
    },
    filterAvgRatings: function filterAvgRatings(allAvgRatings, filters) {
      var filteredCampaigns = this.campaigns.filter(function (c) {
        return allAvgRatings.some(function (v) {
          return c.id === (v._id && v._id.campaignID);
        });
      });
      filteredCampaigns.map(function (c) {
        var avgRatings = allAvgRatings.filter(function (avg) {
          return (avg._id && avg._id.campaignID) === c.id;
        });
        if (avgRatings.length) {
          avgRatings.map(function (ar) {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(c, ar);
          });
        }
      });

      if (filters.CampaignId && filters.CampaignId !== '') {
        filteredCampaigns = filteredCampaigns.filter(function (c) {
          return c.id === filters.CampaignId;
        });
      }

      if (filters.UserId && filters.UserId !== '') {
        filteredCampaigns = filteredCampaigns.filter(function (c) {
          return c.assignedTo && c.assignedTo.includes(filters.UserId);
        });
      }
      return filteredCampaigns;
    },
    calculateClientAvgOverall: function calculateClientAvgOverall(filteredCampaigns) {
      var avgValues = ['avg_influencers_selection', 'avg_content_quality_rate', 'avg_campaign_timeline_rate', 'avg_overall_experience_rate', 'avg_draft_post'];
      filteredCampaigns = filteredCampaigns.map(function (v) {
        var totalAvgs = 0;
        avgValues.map(function (akey) {
          v[akey] = v[akey] ? Math.round(v[akey]) : 0;
          totalAvgs += v[akey];
        });
        v.overall_rate = Math.round(totalAvgs / avgValues.length);
        return v;
      });
      return filteredCampaigns;
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Speed',
  components: {
    SpeedStages: __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_SpeedStages___default.a
  },
  data: function data() {
    return {
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/co/dashboard'
      }, {
        text: 'Speed',
        disabled: true,
        href: ''
      }],
      filterUser: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = void 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 3:
              response = _context.sent;

              if (response) {
                _this.filterUser = response.users.map(function (user) {
                  user.name = user.firstName + ' ' + user.lastName;
                  return user;
                });
                _this.filterUser.unshift({ id: '', name: 'All Team' });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CO_Spend_Revenue',
  components: {
    SummaryOfAccount: __WEBPACK_IMPORTED_MODULE_3__DashboardComponents_summaryOfAccount___default.a
  },
  data: function data() {
    return {
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/co/dashboard'
      }, {
        text: 'Spend Revenue',
        disabled: true,
        href: ''
      }],
      filterUser: []
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = void 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 3:
              response = _context.sent;

              if (response) {
                _this.filterUser = response.users.map(function (user) {
                  user.name = user.firstName + ' ' + user.lastName;
                  return user;
                });
                _this.filterUser.unshift({ id: '', name: 'All Team' });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CalendarTable',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vue_loading_overlay___default.a
  },
  props: ['headers', 'calendarMonths', 'filteredItems', 'filter', 'loading', 'disableLeftArrow', 'disableRightArrow'],
  data: function data() {
    return {
      disableSave: true,
      isLoading: false,
      dateFilter: {
        startDate: null,
        endDate: null
      }
    };
  },

  watch: {
    dateFilter: {
      handler: function handler(val, oldVal) {
        this.$emit('filterDate', this.dateFilter);
      },
      deep: true
    }
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__ = __webpack_require__(28);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerTable',
  props: ['headers', 'filteredItems', 'filter', 'loading', 'value', 'campaign', 'overall', 'posted', 'postedDeliverables', 'totals'],
  data: function data() {
    return {
      disableSave: true,
      isLoading: false,
      completedFormOptions: [{
        text: 'YES',
        value: 1
      }, {
        text: 'NO',
        value: 0
      }],
      YesNoOptions: [{
        text: 'All',
        value: ''
      }, {
        text: 'YES',
        value: 1
      }, {
        text: 'NO',
        value: 0
      }],
      customFilter: {
        completedForm: '',
        imsReview: ''
      }
    };
  },
  mounted: function mounted() {},

  watch: {
    value: function value(newValue) {
      this.unsetItemEdits();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    getCompletedFormOptions: function getCompletedFormOptions() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.completedFormOptions);
    }
  }),
  methods: {
    saveChanges: function saveChanges() {
      var _this = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this.isLoading = true;
          var formData = _this.buildFormData();

          __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].updatePairings(formData).then(function (response) {
            _this.isLoading = false;

            _this.cancelEdit();

            _this.$swal({
              text: 'Successfully Updated',
              type: 'success'
            });
          }).catch(function (error) {
            _this.isLoading = false;

            console.log('error', error);
            _this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    buildFormData: function buildFormData() {
      var editedItems = this.filteredItems.filter(function (item) {
        return item.editReport;
      });
      var updatePairings = [];
      editedItems.map(function (item) {
        updatePairings.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
          id: item.pairingID,
          completedForm: item.completedForm
        }));
      });
      var formData = new FormData();
      formData.append('pairings', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(updatePairings));
      return formData;
    },
    unsetItemEdits: function unsetItemEdits() {
      var _this2 = this;

      this.filteredItems = this.filteredItems.map(function (item) {
        item = _this2.setDefaultEditFields(item);
        return item;
      });
    },
    setDefaultEditFields: function setDefaultEditFields(item) {
      item.completedFormEdit = false;
      return item;
    },
    cancelEdit: function cancelEdit() {
      this.unsetItemEdits();
      this.disableSave = true;
    },
    openEditItem: function openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true;
      item.editReport = true;
      this.disableSave = false;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
    },
    getStatusText: function getStatusText(status) {
      var statusTxt = '';
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        if (item[1].value === status) {
          statusTxt = item[1].text;
        }
      });
      return statusTxt;
    },
    completedFormText: function completedFormText(status) {
      return status > 0 ? 'YES' : 'NO';
    },
    getFiltered: function getFiltered() {
      this.$emit('filtered', this.customFilter);
    },
    getDataTableFiltered: function getDataTableFiltered(filtered) {
      this.$emit('dataTableFiltered', filtered);
    },
    close: function close() {
      this.$emit('input');
      this.$emit('closed');
    }
  }
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__campaignAPIs__ = __webpack_require__(16);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportTable',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  props: ['headers', 'filteredItems', 'loading', 'refresh'],
  watch: {
    refresh: function refresh(value) {
      if (value) this.unsetItemEdits();
    }
  },
  data: function data() {
    return {
      disableSave: true,
      isLoading: false,
      filter: ''
    };
  },
  mounted: function mounted() {
    this.unsetItemEdits();
  },

  methods: {
    saveChanges: function saveChanges() {
      var _this = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this.isLoading = true;
          var formData = _this.buildFormData();

          __WEBPACK_IMPORTED_MODULE_4__campaignAPIs__["a" /* default */].saveAOKReport(formData).then(function (response) {
            _this.isLoading = false;

            _this.cancelEdit();
            _this.$emit('updated');

            _this.$swal({
              text: 'Report Updated',
              type: 'success'
            });
          }).catch(function (error) {
            _this.isLoading = false;

            console.log('error', error);
            _this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    buildFormData: function buildFormData() {
      var editedItems = this.filteredItems.filter(function (item) {
        return item.editReport;
      });
      var updateCampaignData = [];
      editedItems.map(function (item) {
        updateCampaignData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
          id: item.id,
          startDate: item.startDate,
          endDate: item.endDate,
          max_content: item.coverageKPI,
          kpi_onboarded: item.onboardKPI
        }));
      });
      var formData = new FormData();
      formData.append('campaigns', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updateCampaignData));
      return formData;
    },
    unsetItemEdits: function unsetItemEdits() {
      var _this2 = this;

      this.filteredItems = this.filteredItems.map(function (item) {
        item = _this2.setDefaultEditFields(item);
        return item;
      });
    },
    setDefaultEditFields: function setDefaultEditFields(item) {
      item.startDateEdit = false;
      item.endDateEdit = false;
      item.onboardKPIEdit = false;
      item.coverageKPIEdit = false;
      item.editReport = false;
      return item;
    },
    cancelEdit: function cancelEdit() {
      this.unsetItemEdits();
      this.disableSave = true;
    },
    openEditItem: function openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true;
      item.editReport = true;
      this.disableSave = false;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
    },
    formatMonth: function formatMonth(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('MMM YYYY');
    }
  }
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReportTable_vue__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReportTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ReportTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CalendarTable_vue__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CalendarTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CalendarTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__InfluencerModal_vue__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__InfluencerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__InfluencerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils__ = __webpack_require__(11);






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AOKReport',
  components: {
    ReportTable: __WEBPACK_IMPORTED_MODULE_13__ReportTable_vue___default.a,
    CalendarTable: __WEBPACK_IMPORTED_MODULE_14__CalendarTable_vue___default.a,
    InfluencerModal: __WEBPACK_IMPORTED_MODULE_15__InfluencerModal_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    reports: function reports(state) {
      return state.campaign.reports;
    },
    bfsLists: function bfsLists(state) {
      return state.campaign.bfsLists;
    },
    pairings: function pairings(state) {
      return state.pairing.pairings;
    }
  })),
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].reportTableHeader,
      influencerHeaders: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].influencerHeaders,
      defaultCalHeaders: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].defaultCalHeaders,
      overallTotals: {},
      postedTotals: {},
      deliverableTotals: {},
      filterInfTotals: {
        followers: 0,
        completedForm: 0,
        imsReview: 0,
        numberOfReviews: 0
      },
      tableRefresh: false,
      calendarHeaders: [],
      influencerFilter: '',
      calendarFilter: '',
      filteredItems: [],
      influencers: [],
      filteredInfluencers: [],
      calendarCampaigns: [],
      filteredCalCampaigns: [],
      allMonthLists: [],
      showMonths: [],
      disableLeftArrow: false,
      disableRightArrow: true,
      loading: false,
      infLoading: false,
      CO: [],
      selectedCampaign: {},
      viewInfluencerDialog: false,
      display: 0
    };
  },

  watch: {
    display: function display(value) {
      if (value === 0) {
        this.loadTableView();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _this.init();

            case 3:
              _this.loadTableView();
              _this.loadCalendarView();
              _this.loading = false;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('campaign/getCampaigns');

              case 2:
                _context2.next = 4;
                return _this2.$store.dispatch('pairing/getPairings');

              case 4:
                _context2.next = 6;
                return _this2.getCOLists();

              case 6:
                _this2.filteredItems = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this2.campaigns);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    refreshTableView: function refreshTableView() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.tableRefresh = false;
                _context3.next = 3;
                return _this3.init();

              case 3:
                _this3.loadTableView();
                _this3.tableRefresh = true;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadTableView: function loadTableView() {
      this.updateItems();
    },
    updateItems: function updateItems() {
      var _this4 = this;

      this.filteredItems = this.filteredItems.filter(function (item) {
        return item.campaignType && __WEBPACK_IMPORTED_MODULE_16__campaignHelper__["a" /* default */].isAOKCampaign(item.campaignType);
      });
      this.filteredItems = this.filteredItems.map(function (item) {
        item.inCharge = _this4.CO.filter(function (co) {
          return item.assignedTo && item.assignedTo.includes(co.id);
        }).map(function (co) {
          return co.name;
        }).join(', ');
        item.pairings = _this4.pairings.filter(function (pairing) {
          return pairing.campaignID === item.id && pairing.pairing_details && pairing.pairing_details.status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].pairingStatus.ACCEPTED;
        });
        item.actualOnboarded = item.pairings.length;
        item.coverageKPI = item.max_content || 0;
        item.onboardKPI = item.kpi_onboarded || '';
        var targetOnboardKPI = _this4.calcTdyOnboardKPI(item);
        if (targetOnboardKPI) {
          if (targetOnboardKPI > item.onboardKPI) {
            item.todayOnboardKPI = item.onboardKPI;
          } else item.todayOnboardKPI = targetOnboardKPI;
          if (item.todayOnboardKPI > item.actualOnboarded) item.lowonboardKPI = true;
        }
        if (item.actualOnboarded && item.todayOnboardKPI) {
          item.currentProgress = (item.actualOnboarded / item.todayOnboardKPI * 100).toFixed(2);
        } else item.currentProgress = 0;
        if (item.actualOnboarded && item.onboardKPI) {
          item.totalAchieved = (item.actualOnboarded / item.onboardKPI * 100).toFixed(2);
        } else item.totalAchieved = 0;
        return item;
      });
      this.updateReportItems();
    },
    updateReportItems: function updateReportItems() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var campaignIDs;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                campaignIDs = _this5.filteredItems.map(function (item) {
                  return item.id;
                });
                _context4.next = 3;
                return _this5.$store.dispatch('campaign/getReportsByCampaignIDs', campaignIDs);

              case 3:
                if (_this5.reports.length > 0) {
                  _this5.filteredItems = _this5.filteredItems.map(function (item) {
                    item.campaignReports = _this5.reports.filter(function (report) {
                      return report.campaignID === item.id && !report.imported;
                    });
                    item.coverageActual = item.campaignReports.length || 0;
                    item.numberOfReviewers = _this5.getReviewersCount(item.campaignReports);
                    item.achieved = (item.coverageActual / item.coverageKPI * 100).toFixed(2);
                    return item;
                  });
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    viewInfluencers: function viewInfluencers(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.selectedCampaign = item;
                _this6.influencers = [];
                item.pairings.map(function (pairing) {
                  var inf = {};
                  var infDetails = pairing.influencer_details;
                  inf.pairingID = pairing.id;
                  inf.handle = infDetails.instagramHandle;
                  inf.platform = infDetails.platform || 'instagram';
                  inf.followers = infDetails.followers;
                  inf.pairingStatus = pairing.pairing_details.status;
                  inf.completedForm = pairing.completedForm || 0;
                  var influencerReports = item.campaignReports.filter(function (rpt) {
                    var owner = rpt.owner ? rpt.owner.toLowerCase() : undefined;
                    var handle = inf.handle ? inf.handle.toLowerCase() : undefined;
                    if (rpt.isTikTok) {
                      return inf.platform === 'tiktok' && owner === handle;
                    }
                    return owner === handle;
                  });
                  inf.imsReview = influencerReports.length > 0 ? 1 : 0;
                  inf.deliverables = __WEBPACK_IMPORTED_MODULE_16__campaignHelper__["a" /* default */].getReportDeliverables(influencerReports);
                  inf.deliverablesObj = __WEBPACK_IMPORTED_MODULE_16__campaignHelper__["a" /* default */].getReportDeliverables(influencerReports, 'object');
                  inf.numberOfReviews = influencerReports.length;
                  _this6.influencers.push(inf);
                });
                _this6.calculateInfSummary();
                _this6.filteredInfluencers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this6.influencers);
                _this6.viewInfluencerDialog = true;

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    calculateInfSummary: function calculateInfSummary() {
      var _this7 = this;

      this.overallTotals = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.refreshJSON(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].overallTotals);
      this.overallTotals.influencers.value = this.influencers.length;
      this.overallTotals.reviewers.value = this.influencers.map(function (c) {
        return c.numberOfReviews || 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.overallTotals.followers.value = this.influencers.map(function (c) {
        return c.followers || 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);

      this.postedTotals = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.refreshJSON(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].postedTotals);
      this.postedTotals.reviewOutreach.value = this.influencers.map(function (c) {
        return c.numberOfReviews * c.followers;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.postedTotals.totalFollower.value = this.influencers.filter(function (c) {
        return c.numberOfReviews > 0;
      }).map(function (c) {
        return c.followers || 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.postedTotals.tiktokContents.value = this.influencers.map(function (c) {
        return c.deliverablesObj.TTP;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.postedTotals.tiktokOutreach.value = this.influencers.map(function (c) {
        return c.platform === 'tiktok' ? c.numberOfReviews * c.followers : 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.postedTotals.instagramContent.value = this.influencers.map(function (c) {
        return c.deliverablesObj.IGS + c.deliverablesObj.IGV + c.deliverablesObj.IGR + c.deliverablesObj.IGC + c.deliverablesObj.IGP;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.postedTotals.instagramOutreach.value = this.influencers.map(function (c) {
        return c.platform === 'instagram' ? c.numberOfReviews * c.followers : 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);

      this.deliverableTotals = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.refreshJSON(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].postedDeliverables);
      this.influencers.map(function (inf) {
        var deliverables = inf.deliverablesObj;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(deliverables)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            _this7.deliverableTotals[key].value += deliverables[key];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    loadCalendarView: function loadCalendarView() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var statuses;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                statuses = [__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStatus.ONGOING, __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStatus.PAIRING];
                _context6.next = 3;
                return _this8.$store.dispatch('campaign/getCampaigns', { statuses: statuses });

              case 3:
                _context6.next = 5;
                return _this8.$store.dispatch('campaign/getBFSLists');

              case 5:
                _this8.calendarCampaigns = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this8.campaigns);
                _this8.filteredCalCampaigns = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this8.calendarCampaigns);
                _this8.formatCalCampaigns({ colorChange: true });

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    calcTdyOnboardKPI: function calcTdyOnboardKPI(item) {
      if (!item.startDate || !item.endDate || !item.onboardKPI) return '';
      var durationMonths = __WEBPACK_IMPORTED_MODULE_16__campaignHelper__["a" /* default */].getCampaignDurationMonths(item);
      var totalWeeks = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.totalWeeksOfMonth();
      var weekDurations = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.weekDurations(item.startDate);
      return Math.round(item.onboardKPI / (durationMonths * totalWeeks) * weekDurations);
    },
    formatCalCampaigns: function formatCalCampaigns() {
      var _this9 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var allMonths = [];
      this.filteredCalCampaigns = this.filteredCalCampaigns.map(function (item) {
        item.poc = _this9.CO.filter(function (co) {
          return item.assignedTo && item.assignedTo.includes(co.id);
        }).map(function (co) {
          return co.name;
        }).join(', ');
        item.bfs = _this9.getBFSByCampaign(item);
        item.onboardKPI = item.kpi_onboarded || '';
        item.todayOnboardKPI = _this9.calcTdyOnboardKPI(item);
        if (options.colorChange) item.bgColor = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.getRandomColor();
        var monthlyData = _this9.getCampaignMonthlyData(item);
        if (monthlyData) {
          var _allMonths;

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(monthlyData.months), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var month = _step2.value;

              item[month] = monthlyData.contentPerMonth;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          (_allMonths = allMonths).push.apply(_allMonths, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(monthlyData.months));
        }
        allMonths = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(allMonths)));
        return item;
      });
      this.setCalendarMonthHeaders(allMonths);
    },
    setCalendarMonthHeaders: function setCalendarMonthHeaders(months) {
      this.allMonthLists = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(months));
      this.allMonthLists = this.allMonthLists.filter(function (m) {
        return m || false;
      });
      this.allMonthLists = this.allMonthLists.sort(function (a, b) {
        return new Date(a) - new Date(b);
      });
      var currentYear = __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('YYYY');
      var currentYearMonths = this.allMonthLists.filter(function (m) {
        return m.includes(currentYear);
      });
      var currentYearCount = currentYearMonths.length;
      var lastYearCount = currentYearCount < 12 ? 12 - currentYearCount : 0;
      this.showMonths = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(currentYearMonths));
      if (this.showMonths.length > 0) {
        var firstCurrentYearIndex = this.allMonthLists.indexOf(this.showMonths[0]);
        for (var i = 1; i <= lastYearCount; i++) {
          var monthIndex = firstCurrentYearIndex - i;
          if (this.allMonthLists[monthIndex]) {
            this.showMonths.unshift(this.allMonthLists[monthIndex]);
          }
        }
      }
      this.setShowMonthsHeader(this.showMonths);
    },
    filterMonth: function filterMonth(dateRange) {
      if (!dateRange.startDate || !dateRange.endDate) {
        this.formatCalCampaigns();
        this.resetMonthArrows();
        return false;
      }
      var startDate = dateRange.startDate;
      var endDate = dateRange.endDate;
      var durationMonths = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.monthDurations(startDate, endDate);
      var months = [];
      for (var i = 0; i < durationMonths; i++) {
        var futureMonth = __WEBPACK_IMPORTED_MODULE_18_moment___default()(startDate).add(i, 'M').format('YYYY-MM');
        months.push(futureMonth);
      }
      this.setCalendarMonthHeaders(months);
    },
    changeMonth: function changeMonth(type) {
      if (type === 'next') {
        var lastIndex = this.allMonthLists.indexOf(this.showMonths[this.showMonths.length - 1]);
        var nextMonth = this.allMonthLists[lastIndex + 1];
        if (nextMonth) {
          this.showMonths.shift();
          this.showMonths.push(nextMonth);
          this.disableLeftArrow = false;
        } else this.disableRightArrow = true;
      } else {
        var firstIndex = this.allMonthLists.indexOf(this.showMonths[0]);
        var previousMonth = this.allMonthLists[firstIndex - 1];
        if (previousMonth) {
          this.showMonths.pop();
          this.showMonths.unshift(previousMonth);
          this.disableRightArrow = false;
        } else this.disableLeftArrow = true;
      }
      this.setShowMonthsHeader(this.showMonths);
    },
    setShowMonthsHeader: function setShowMonthsHeader(months) {
      var _this10 = this;

      this.calendarHeaders = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.defaultCalHeaders);
      months.map(function (month) {
        _this10.calendarHeaders.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
          text: __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.formatMonth(month),
          value: month
        }));
      });
    },
    getCampaignMonthlyData: function getCampaignMonthlyData(item) {
      var durationMonths = __WEBPACK_IMPORTED_MODULE_16__campaignHelper__["a" /* default */].getCampaignDurationMonths(item);
      if (!durationMonths) {
        return false;
      }
      var contentPerMonth = Math.round(item.onboardKPI / durationMonths);
      var months = [];
      for (var i = 0; i < durationMonths; i++) {
        var futureMonth = __WEBPACK_IMPORTED_MODULE_18_moment___default()(item.startDate).add(i, 'M').format('YYYY-MM');
        months.push(futureMonth);
      }
      return { months: months, contentPerMonth: contentPerMonth };
    },
    getReviewersCount: function getReviewersCount(reports) {
      var uniqueHandles = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(reports.map(function (rpt) {
        return rpt.owner ? rpt.owner.toLowerCase() : '';
      }))));
      return uniqueHandles.length;
    },
    getCOLists: function getCOLists() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_17__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                response = _context7.sent;

                if (response) {
                  _this11.CO = response.users;
                  _this11.CO = _this11.CO.map(function (co) {
                    co.name = co.firstName + ' ' + co.lastName;
                    return co;
                  });
                }

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    getBFSByCampaign: function getBFSByCampaign(item) {
      var bfsOne = this.bfsLists.find(function (bfs) {
        return bfs.campaignID === item.id;
      });
      if (bfsOne) return bfsOne.id;
      return null;
    },
    filterInfluencerList: function filterInfluencerList(searchData) {
      this.filteredInfluencers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.influencers);
      if (searchData.completedForm || searchData.completedForm === 0) {
        this.filteredInfluencers = this.filteredInfluencers.filter(function (item) {
          return item.completedForm === searchData.completedForm;
        });
      }
      if (searchData.imsReview || searchData.imsReview === 0) {
        this.filteredInfluencers = this.filteredInfluencers.filter(function (item) {
          return item.imsReview === searchData.imsReview;
        });
      }
    },
    infDataTableFiltered: function infDataTableFiltered(filtered) {
      this.filterInfTotals.followers = filtered.map(function (c) {
        return c.followers || 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      this.filterInfTotals.completedForm = filtered.length;
      this.filterInfTotals.imsReview = filtered.length;
      this.filterInfTotals.numberOfReviews = filtered.map(function (c) {
        return c.numberOfReviews || 0;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    },
    resetMonthArrows: function resetMonthArrows() {
      this.disableLeftArrow = false;
      this.disableRightArrow = true;
    },
    closeInfModal: function closeInfModal() {
      this.viewInfluencerDialog = false;
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AllReportsPasscodeModal',
  props: {
    value: Boolean
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      show1: false,
      passcode: '',
      validPasscode: 'k0be23'
    };
  },

  validations: {
    passcode: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    passcodeErrors: function passcodeErrors() {
      var errors = [];
      if (!this.$v.passcode.$dirty) return errors;
      !this.$v.passcode.required && errors.push('PIN is required');
      return errors;
    }
  },
  methods: {
    confirmPasscode: function confirmPasscode() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: 'Invalid PIN',
          text: 'Make sure you filled the passcode correctly.'
        });
        return;
      }

      if (this.passcode === this.validPasscode) {
        this.$emit('success');
        this.closeModal();
      } else {
        this.$swal({
          type: 'error',
          title: 'Invalid PIN',
          text: 'Make sure you filled the PIN correctly.'
        });
      }
      return;
    },
    closeModal: function closeModal() {
      this.$v.$reset();
      this.$emit('input');
      this.passcode = '';
    }
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AmCcInputsModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    campaign: Object,
    source: String
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    }
  },
  methods: {
    proceedBrief: function proceedBrief() {
      this.close();
      this.$emit('proceedBrief', this.campaign);
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Client_AssignTeam__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Client_AssignTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Client_AssignTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    campaign: Object
  },
  components: {
    AssignTeam: __WEBPACK_IMPORTED_MODULE_4__Client_AssignTeam___default.a
  },
  data: function data() {
    return {
      campaignData: null,
      selectedCSList: [],
      selectedAMList: [],
      adStrategist: [],
      accountManagers: [],

      assignUsers: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      dedicatedData: [],
      supportingData: []
    };
  },

  methods: {
    assignCS: function assignCS() {
      var _this = this;

      var assignedToLists = this.selectedDedicatedPersons.map(function (s) {
        return s.id;
      });
      var assignedSupportingTo = this.selectedSupportingPersons.map(function (s) {
        return s.id;
      });
      __WEBPACK_IMPORTED_MODULE_6__campaignAPIs__["a" /* default */].assignCsToCampaign(this.campaignData.id, { assignedTo: assignedToLists, assignedSupportingTo: assignedSupportingTo }).then(function () {
        _this.$emit('updated', true);
        _this.$emit('input');
      }).catch(function (err) {
        return console.error(err);
      });
    },
    fetchCSlist: function fetchCSlist(clientId, assignedTo) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__["a" /* default */].findByRole(clientId).then(function (resp) {
        _this2.adStrategist = resp.users;
        if (assignedTo) {
          resp.users.map(function (item) {
            assignedTo.map(function (id) {
              if (item.id === id) {
                _this2.selectedCSList.push(id);
              }
            });
          });
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    fetchAMlist: function fetchAMlist(assignedTo) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (resp) {
        _this3.accountManagers = resp.users;
        if (assignedTo) {
          resp.users.map(function (item) {
            assignedTo.map(function (id) {
              if (item.id === id) {
                _this3.selectedAMList.push(id);
              }
            });
          });
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    getAssignUsers: function getAssignUsers() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                resp = _context.sent;

                if (resp) _this4.CO = resp.users;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                resp = _context.sent;

                if (resp) _this4.AM = resp.users;
                _this4.assignUsers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this4.CO), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this4.AM)));
                if (_this4.campaignData.assignedTo) {
                  _this4.dedicatedData = _this4.assignUsers.filter(function (a) {
                    return _this4.campaignData.assignedTo.includes(a.id);
                  });
                }
                if (_this4.campaignData.assignedSupportingTo) {
                  _this4.supportingData = _this4.assignUsers.filter(function (a) {
                    return _this4.campaignData.assignedSupportingTo.includes(a.id);
                  });
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    updateSelectedDedicated: function updateSelectedDedicated(newValue) {
      this.selectedDedicatedPersons = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], newValue);
    },
    updateSelectedSupporting: function updateSelectedSupporting(newValue) {
      this.selectedSupportingPersons = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], newValue);
    }
  },
  computed: {
    cs_options: function cs_options() {
      var data = this.adStrategist.map(function (item) {
        return {
          csData: {
            name: item.firstName + ' ' + item.lastName,
            id: item.id
          },
          display: item.firstName
        };
      });
      return data;
    },
    am_options: function am_options() {
      var data = this.accountManagers.map(function (item) {
        return {
          amData: {
            name: item.firstName + ' ' + item.lastName,
            id: item.id
          },
          display: item.firstName
        };
      });
      return data;
    }
  },
  watch: {
    campaign: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(newCampaign) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (newCampaign !== null) {
                  this.campaignData = newCampaign;

                  this.selectedCSList = [];
                  this.fetchCSlist(this.campaignData.clientID, this.campaignData.assignedTo);
                  this.selectedAMList = [];
                  this.fetchAMlist(this.campaignData.assignedTo);
                  this.getAssignUsers();
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function campaign(_x) {
        return _ref.apply(this, arguments);
      }

      return campaign;
    }()
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TotalSubmissionsModal',
  props: ['value', 'monthYearValues'],
  data: function data() {
    return {
      headers: [{
        text: 'Month',
        value: 'month'
      }, {
        text: 'Total',
        value: 'amount'
      }]
    };
  },

  computed: {
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY');
    },
    totalAmount: function totalAmount() {
      var total = 0;
      if (this.monthYearValues) {
        this.monthYearValues.map(function (m) {
          if (m.amount) {
            total += parseInt(m.amount);
          }
        });
      }
      return parseInt(total);
    }
  },
  methods: {
    formatCurrentMonth: function formatCurrentMonth(month) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(month).format('MMM YYYY');
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_logoDataURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jimp__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jimp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dialCodes_json__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dialCodes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__dialCodes_json__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateBrandSheetForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_10_vuelidate__["validationMixin"]],
  validations: function validations() {
    var _this = this;

    var validationRules = {
      brandSheet: {}
    };
    if (this.type === this.campaignTypes.STORY_TELL) {
      var multiplevalidations = ['sectionOne', 'sectionTwo', 'sectionThree'];
      multiplevalidations.map(function (val) {
        _this.brandSheetFormSections[val].fields.forEach(function (field) {
          validationRules['brandSheet'][field.name] = field.required ? { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] } : '';
        });
      });
    } else if (this.type === this.campaignTypes.AOK) {
      var _multiplevalidations = ['sectionOne'];
      _multiplevalidations.map(function (val) {
        _this.brandSheetAOKFormSections[val].fields.forEach(function (field) {
          validationRules['brandSheet'][field.name] = field.required ? { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] } : '';
        });
      });
    } else if (this.type === this.bfsTypes.KOBE_LITE) {
      var _multiplevalidations2 = ['sectionOne'];
      _multiplevalidations2.map(function (val) {
        _this.brandSheetKobeLiteFormSections[val].fields.forEach(function (field) {
          validationRules['brandSheet'][field.name] = field.required ? { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] } : '';
        });
      });
    } else {
      var _multiplevalidations3 = ['sectionOne'];
      _multiplevalidations3.map(function (val) {
        _this.brandSheetAOKFormSections[val].fields.forEach(function (field) {
          validationRules['brandSheet'][field.name] = field.required ? { required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"] } : '';
        });
      });
    }
    return validationRules;
  },
  data: function data() {
    return {
      dialog: true,
      submitting: false,
      valid: true,
      campaignID: '',
      type: '',
      campaignTypes: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignType,
      bfsTypes: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].bfsTypes,
      brandSheetFormSections: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].brandSheetFormSections,
      brandSheetAOKFormSections: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].brandSheetAOKFormSections,
      brandSheetKobeLiteFormSections: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].brandSheetKobeLiteFormSections,
      brandSheetUGCFormSections: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].brandSheetUGCFormSections,
      brandSheetLogo: __WEBPACK_IMPORTED_MODULE_7__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png',
      brandSheet: {
        mobileCountry: 'Singapore',
        age: [],
        gender: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userGenders.NON_BINARY,
        budgetCurrency: 'USD',
        sampleVideoContent: [{
          link: ''
        }],
        marketingURL: [{
          link: ''
        }]
      },
      uploadFiles: [],
      deleteObjectKeys: [],
      images: [],
      decksFiles: [],
      decksMedia: [],
      deleteVideoObjectKeys: [],
      videos: [],
      videoFiles: [],
      videosMedia: [],
      countriesCode: __WEBPACK_IMPORTED_MODULE_15__dialCodes_json___default.a,
      currenyOptions: ['SGD', 'USD', 'IDR', 'PHP', 'THB', 'MYR', 'VND']
    };
  },

  methods: {
    close: function close() {
      this.$router.push({ path: '/client' });
    },
    submitBrandSheet: function submitBrandSheet() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var brandSheet;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$v.$touch();

                if (!_this2.$v.brandSheet.$error) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', false);

              case 3:
                brandSheet = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(_this2.brandSheet, {
                  campaignID: _this2.campaignID,
                  type: _this2.type
                });

                _this2.$swal({
                  title: 'Double Check!',
                  text: 'Make sure you filled all the required information',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function (result) {
                  if (result.value) {
                    _this2.submitting = true;
                    var formData = new FormData();
                    var files = _this2.decksMedia;
                    var vdofiles = _this2.videosMedia;
                    formData.append('brandSheet', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(brandSheet));
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var val = _step.value;

                        formData.append('uploadFile', val);
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(vdofiles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _val = _step2.value;

                        formData.append('uploadFile', _val);
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }

                    __WEBPACK_IMPORTED_MODULE_12__campaignAPIs__["a" /* default */].createBrandSheet(formData).then(function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return _this2.sendBFSEmail(response);

                              case 2:
                                _this2.close();

                                _this2.submitting = false;
                                _this2.deleteObjectKeys = [];
                                _this2.deleteVideoObjectKeys = [];

                                _this2.$swal({
                                  text: 'Brand Fact Sheet Created',
                                  type: 'success'
                                }).then(function (result) {
                                  if (result.value) {
                                    _this2.$router.push({ path: '/' });
                                  }
                                });

                              case 7:
                              case 'end':
                                return _context.stop();
                            }
                          }
                        }, _callee, _this2);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }()).catch(function (error) {
                      _this2.submitting = false;

                      console.log('error', error);
                      _this2.$swal({
                        text: 'Error saving brand fact sheet.',
                        type: 'error'
                      });
                    });
                  }
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    prepareUpload: function prepareUpload(e) {
      var _this3 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var mediaType = element.type.split('/')[0];
        var fileType = element.name.split('.')[1];

        if (mediaType !== 'image' && fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'ppt' && fileType !== 'txt' && fileType !== 'docx') {
          _this3.$swal('File Type Not Supported, Please select a video or an image');
        } else if (mediaType === 'image') {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buffer = e.target.result;
            __WEBPACK_IMPORTED_MODULE_13_jimp___default.a.read(buffer, function (err, img) {
              if (err) console.error(111, err);
              img.resize(500, __WEBPACK_IMPORTED_MODULE_13_jimp___default.a.AUTO).quality(100).getBase64(__WEBPACK_IMPORTED_MODULE_13_jimp___default.a.MIME_PNG, function (err, buff) {
                if (err) console.error(222, err);
                var file = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
                _this3.decksMedia.push(file);
                _this3.images.push({
                  url: buff,
                  src: buff,
                  name: element.name
                });
              });
            });
          };

          e.target.value = '';
        } else {
          _this3.decksFiles.push(element);
          _this3.decksMedia.push(element);
          var _reader = new FileReader();
          _reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteImage: function deleteImage(imgIndex) {
      var imgURl = this.images[imgIndex].url;
      var filename = this.images[imgIndex].url.substring(this.images[imgIndex].url.lastIndexOf('/') + 1);
      this.deleteObjectKeys.push(filename);
      this.images.splice(imgIndex, 1);
      var DecksMediaIndex = this.decksMedia.findIndex(function (item) {
        return item.url === imgURl;
      });
      if (DecksMediaIndex !== -1) this.decksMedia.splice(DecksMediaIndex, 1);
    },
    deleteFile: function deleteFile(fileIndex) {
      var fileURL = '';
      if (this.decksFiles[fileIndex].url) {
        fileURL = this.decksFiles[fileIndex].url;
        var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        this.deleteObjectKeys.push(fileName);
      }
      this.decksFiles.splice(fileIndex, 1);
      var DecksMediaIndex = this.decksMedia.findIndex(function (item) {
        return item.url === fileURL;
      });
      if (DecksMediaIndex !== -1) this.decksMedia.splice(DecksMediaIndex, 1);
    },
    prepareVideoUpload: function prepareVideoUpload(e) {
      var _this4 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var mediaType = element.type.split('/')[0];


        if (mediaType !== 'video') {
          _this4.$swal('File Type Not Supported, Please select a video');
        } else if (mediaType === 'video') {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buff = e.target.result;
            var file = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
            _this4.videosMedia.push(file);
            _this4.videos.push({
              url: buff,
              src: buff,
              name: element.name
            });
          };

          e.target.value = '';
        } else {
          _this4.videoFiles.push(element);
          _this4.videosMedia.push(element);
          var _reader2 = new FileReader();
          _reader2.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteVideo: function deleteVideo(vdoIndex) {
      var imgURl = this.videos[vdoIndex].url;
      var filename = this.videos[vdoIndex].url.substring(this.videos[vdoIndex].url.lastIndexOf('/') + 1);
      this.deleteVideoObjectKeys.push(filename);
      this.videos.splice(vdoIndex, 1);
      var vdoMediaIndex = this.videosMedia.findIndex(function (item) {
        return item.url === imgURl;
      });
      if (vdoMediaIndex !== -1) this.videosMedia.splice(vdoMediaIndex, 1);
    },
    deleteVideoFile: function deleteVideoFile(fileIndex) {
      var fileURL = '';
      if (this.videoFiles[fileIndex].url) {
        fileURL = this.videoFiles[fileIndex].url;
        var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        this.deleteVideoObjectKeys.push(fileName);
      }
      this.videoFiles.splice(fileIndex, 1);
      var DecksMediaIndex = this.videosMedia.findIndex(function (item) {
        return item.url === fileURL;
      });
      if (DecksMediaIndex !== -1) this.videosMedia.splice(DecksMediaIndex, 1);
    },
    changeSelect: function changeSelect(name, value) {
      if (name === 'mobileCountry') {
        var optionOne = this.countriesCode.find(function (o) {
          return o.cn === value;
        });
        if (optionOne) {
          this.brandSheet.mobilePhone = optionOne.dc;
        }
      }
      return true;
    },
    getCampaignInfo: function getCampaignInfo(campaignID) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_12__campaignAPIs__["a" /* default */].getCampaignInfoForBrandSheet(campaignID).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
          var invalidCampaign, errMessage;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  invalidCampaign = false;
                  errMessage = '';

                  if (!response.id) {
                    invalidCampaign = true;
                    errMessage = 'Campaign Not Found!';
                  }

                  if (invalidCampaign) {
                    _this5.$swal({
                      title: 'Error',
                      text: errMessage,
                      type: 'error'
                    }).then(function () {
                      _this5.$router.push({ path: '/' });
                    });
                  }
                  _this5.campaignID = response.id;
                  _this5.type = response.type;

                case 6:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this5);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log('error', error.message);
        _this5.$swal({
          title: 'Error',
          text: error.response.data,
          type: 'error'
        }).then(function () {
          _this5.$router.push({ path: '/' });
        });
      });
    },
    sendBFSEmail: function sendBFSEmail(response) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var doc;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__campaignPDF__["a" /* default */].generateBFS(response);

              case 2:
                doc = _context5.sent;

                __WEBPACK_IMPORTED_MODULE_9__campaignPDF__["a" /* default */].generatePDF(doc).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(pdfData) {
                    var bfsBaseFmt, formData;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_9__campaignPDF__["a" /* default */].generateBasePDF(doc);

                          case 2:
                            bfsBaseFmt = _context4.sent;
                            formData = new FormData();

                            formData.append('id', response.id);
                            formData.append('bfsFileBase', bfsBaseFmt);
                            formData.append('bfsFile', pdfData);
                            _context4.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_12__campaignAPIs__["a" /* default */].sendBFSEmail(formData);

                          case 9:
                            return _context4.abrupt('return', true);

                          case 10:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this6);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log('error in converting PDF', error);
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    addVideoURL: function addVideoURL() {
      this.brandSheet.sampleVideoContent.push({
        link: ''
      });
    },
    addMarketingURL: function addMarketingURL() {
      this.brandSheet.marketingURL.push({
        link: ''
      });
    }
  },
  mounted: function mounted() {
    var campaignID = this.$route.params.campaignId;
    if (campaignID === 'storytell') {
      this.type = this.bfsTypes.STORY_TELL;
    } else if (campaignID === 'uncut') {
      this.type = this.bfsTypes.AOK;
    } else if (campaignID === 'kobe-lite') {
      this.type = this.bfsTypes.KOBE_LITE;
    } else if (campaignID === 'ugcvideos') {
      this.type = this.bfsTypes.UGC;
    } else {
      this.getCampaignInfo(campaignID);
    }
    this.changeSelect('mobileCountry', this.brandSheet.mobileCountry);
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewBrandSheetModal__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewBrandSheetModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ViewBrandSheetModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BrandFactSheet_TotalSubmissionsModal_vue__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BrandFactSheet_TotalSubmissionsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__BrandFactSheet_TotalSubmissionsModal_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Brand Fact Sheet',
  components: {
    ViewBrandSheetModal: __WEBPACK_IMPORTED_MODULE_4__ViewBrandSheetModal___default.a,
    TotalSubmissionsModal: __WEBPACK_IMPORTED_MODULE_13__BrandFactSheet_TotalSubmissionsModal_vue___default.a
  },
  data: function data() {
    return {
      viewBrandSheetData: null,
      viewModalDialog: false,
      totalSubmissionsModalDialog: false,
      allClients: [],
      allClientUsers: [],
      AM: [],
      allCampaigns: [],
      headers: [{
        text: 'Campaign Name',
        value: 'campaignName'
      }, {
        text: 'Campaign Type',
        value: 'type'
      }, {
        text: 'Client Name',
        value: 'clientName'
      }, {
        text: 'Email',
        value: 'email'
      }, {
        text: 'KOBE POC',
        value: 'kobePoc'
      }, {
        text: 'Updated On',
        value: 'updatedAtDisplay'
      }, {
        text: 'Created At',
        value: 'createdAtDisplay'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      items: [],
      lastUpdate: null,
      filter: '',
      campaignTypes: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignType,
      menus: [{ title: 'UGC Form', value: 'ugcvideos' }, { title: 'Storytell', value: 'storytell' }, { title: 'KOBE Uncut', value: 'uncut' }, { title: 'KOBE Lite', value: 'kobe-lite' }],
      brandSheetLink: '',
      brandLinkCopied: false,
      viewID: null,
      monthYearValues: [],
      totalValues: {
        currentMonth: 0,
        currentYear: 0
      }
    };
  },

  computed: {
    currentMonthLabel: function currentMonthLabel() {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('MMM YYYY');
    },
    currentYearLabel: function currentYearLabel() {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY');
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    updateItems: function updateItems(response) {
      var _this = this;

      var data = response.data;
      data = data.map(function (item) {
        var campaign = _this.allCampaigns.find(function (c) {
          return c.id === item.campaignID;
        });
        if (campaign) {
          item.campaignName = campaign.name;
          item.clientName = _this.getClientName(campaign.clientID);
          var accountManager = _this.AM.find(function (a) {
            return campaign.assignedTo.includes(a.id);
          });
          if (accountManager) {
            item.accountManager = accountManager.firstName + ' ' + accountManager.lastName;
          }
        } else {
          if (item.type === _this.campaignTypes.STORY_TELL) {
            item.campaignName = '-';
            item.clientName = item.firstName + ' ' + item.lastName;
          } else if (item.type === _this.campaignTypes.AOK) {
            item.clientName = '-';
            if (item.ugcVideo) {
              item.type = 'UGC';
            }
          }
          item.accountManager = '-';
        }
        item.updatedAtDisplay = _this.formatTime(item.updatedAt);
        item.createdAtDisplay = _this.formatDateTime(item.createdAt);
        item.currentMonthYearVal = __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.createdAt).format('YYYY-MM');
        item.currentYearVal = __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.createdAt).format('YYYY');
        if (item.currentMonthYearVal === __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY-MM')) {
          _this.totalValues.currentMonth += 1;
        }
        if (item.currentYearVal === __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY')) {
          _this.totalValues.currentYear += 1;
        }
        return item;
      });
      this.setMonthYearValues(data);
      this.items = data;
      if (this.viewID) {
        this.viewBFS();
      }
    },
    viewBFS: function viewBFS() {
      var _this2 = this;

      var bfsOne = this.items.find(function (i) {
        return i.id === _this2.viewID;
      });
      this.getBrandSheetDataToView(bfsOne);
      this.viewID = null;
    },
    getAllBrandSheets: function getAllBrandSheets() {
      var _this3 = this;

      this.resetValues();
      __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__["a" /* default */].getAllBrandSheets().then(function (response) {
        _this3.updateItems(response);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getClientName: function getClientName(id) {
      var result = null;
      this.allClients.forEach(function (item) {
        if (item.id === id) {
          result = item.name;
        }
      });
      return result;
    },
    getClientFullName: function getClientFullName(id) {
      var _this4 = this;

      var result = null;
      this.allClientUsers.forEach(function (item) {
        if (item.id === id) {
          var clientName = _this4.getClientName(item.clientID);
          result = item.firstName + ' ' + item.lastName + ' (' + clientName + ')';
        }
      });
      return result;
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).fromNow();
    },
    formatDateTime: function formatDateTime(value) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).format('DD-MM-YYYY HH:mm:ss');
    },
    getBrandSheetDataToView: function getBrandSheetDataToView(viewData) {
      this.viewBrandSheetData = viewData;
      this.viewModalDialog = true;
    },
    copyBrandSheetLink: function copyBrandSheetLink(value) {
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.brandSheetLink = protocol + '//' + host + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].BRAND_SHEET_FORM_URL + '/' + value;
      var vm = this;
      setTimeout(function () {
        vm.brandLinkCopied = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.copyToClipboard('#copy-brand-link');
      }, 100);
      setTimeout(function () {
        vm.brandLinkCopied = false;
      }, 1000);
    },
    downloadBFS: function downloadBFS(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var doc;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__campaignPDF__["a" /* default */].generateBFS(item);

              case 2:
                doc = _context.sent;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__campaignPDF__["a" /* default */].downloadPDF(doc, item.projectTitle || item.campaignName);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    getCurrentMthYearArray: function getCurrentMthYearArray() {
      var respArray = [];
      for (var i = 1; i <= 12; i++) {
        var monthStr = String(i).padStart(2, '0');
        var month = __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY') + '-' + monthStr;
        respArray.push({
          month: month,
          amount: ''
        });
      }
      return respArray;
    },
    setMonthYearValues: function setMonthYearValues(data) {
      this.monthYearValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.getCurrentMthYearArray());

      var _loop = function _loop(mthYearObj) {
        var totalMatches = data.filter(function (d) {
          return mthYearObj.month === d.currentMonthYearVal;
        });
        mthYearObj.amount = totalMatches.length;
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.monthYearValues), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mthYearObj = _step.value;

          _loop(mthYearObj);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    resetValues: function resetValues() {
      this.totalValues = {
        currentMonth: 0,
        currentYear: 0
      };
      this.monthYearValues = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.getCurrentMthYearArray());
    },
    openTotalSubmissionsModal: function openTotalSubmissionsModal() {
      this.totalSubmissionsModalDialog = true;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this6.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this6.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || _this6.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || _this6.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST)) {
                _context2.next = 9;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_8__Client_clientAPIs__["a" /* default */].getAllClients(false).then(function (response) {
                _this6.allClients = response.data;
              }).catch(function (error) {
                console.log('error', error);
              });

              __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.CLIENT).then(function (response) {
                _this6.allClientUsers = response.users;
              }).catch(function (error) {
                console.log('error', error);
              });

              __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (response) {
                _this6.AM = response.users;
              }).catch(function (error) {
                console.log('error', error);
              });
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus();

            case 6:
              _this6.allCampaigns = _context2.sent;

              _this6.getAllBrandSheets();
              if (_this6.$route.query.id) {
                _this6.viewID = _this6.$route.query.id;
              }

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this6);
    }))();
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BriefReleaseChecklistModal',
  props: {
    value: Boolean,
    campaign: Object
  },
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    save: function save() {
      this.close();
      this.$emit('confirmActivate', this.campaign.id);
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActiveYearModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    campaigns: Array
  },
  validations: {
    updateData: {
      activeYear: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      years: ['2026', '2025', '2024', '2023', '2022'],
      updateData: {
        activeYear: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    }
  })),
  watch: {
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(newValue) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.updateData = {
                  activeYear: []
                };

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function value(_x) {
        return _ref.apply(this, arguments);
      }

      return value;
    }()
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, campaign, newUpdateData;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this2.campaigns);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 14;
                  break;
                }

                campaign = _step.value;

                _this2.isLoading = true;
                newUpdateData = [{
                  id: campaign.campaignID,
                  activeYear: _this2.updateData.activeYear
                }];
                _context3.next = 11;
                return _this2.$store.dispatch('campaign/updateCampaignByIds', newUpdateData);

              case 11:
                _iteratorNormalCompletion = true;
                _context3.next = 5;
                break;

              case 14:
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context3.prev = 23;

                if (!_didIteratorError) {
                  _context3.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context3.finish(23);

              case 27:
                return _context3.finish(20);

              case 28:
                _this2.isLoading = false;
                if (_this2.campaignUpdated) {
                  _this2.$swal({
                    text: 'Successfully Updated.',
                    type: 'success'
                  });
                  _this2.$emit('updated');
                  _this2.close();
                } else {
                  _this2.$swal({
                    text: 'Error Updating Active Year!',
                    type: 'error'
                  });
                }

              case 30:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[3, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_DataTableMixin__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PairingInfluencer_PairedInfAdminViewDialog__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PairingInfluencer_PairedInfAdminViewDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__PairingInfluencer_PairedInfAdminViewDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UpdateQuarterModal__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UpdateQuarterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__UpdateQuarterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ProjectedCogsModal__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ProjectedCogsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ProjectedCogsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ActiveYearModal__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ActiveYearModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ActiveYearModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal__);



























var FileSaver = __webpack_require__(119);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CogsSummaryDataTable',
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_DataTableMixin__["a" /* default */]],
  props: ['refresh'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default.a,
    PairedInfAdminViewDialog: __WEBPACK_IMPORTED_MODULE_12__PairingInfluencer_PairedInfAdminViewDialog___default.a,
    UpdateQuarterModal: __WEBPACK_IMPORTED_MODULE_13__UpdateQuarterModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal___default.a,
    ProjectedCogsModal: __WEBPACK_IMPORTED_MODULE_14__ProjectedCogsModal___default.a,
    ActiveYearModal: __WEBPACK_IMPORTED_MODULE_15__ActiveYearModal___default.a
  },
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].tableHeaders,
      dummyData: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].dummyData,
      items: [],
      filter: '',
      filteredItems: [],
      AM: [],
      CC: [],
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      isLoading: false,
      showEditActions: false,
      campaignTypeDisplayFilter: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignTypeDisplay,
      selectedFilter: {
        AM: '',
        CC: '',
        startDate: '',
        endDate: '',
        locked: false,
        text: '',
        activeYear: 2026
      },
      pairedInfAdminViewDialog: false,
      pairedCampaign: null,
      startDate: '',
      endDate: '',
      startDateCal: false,
      endDateCal: false,
      selectedCOGS: [],
      quarterUpdateialog: false,
      tableColsItems: [],
      colSettingsDialog: false,
      colStatuses: {},
      userProfile: {},
      totalSummary: {
        projectedCOGS: 0,
        projectedCogsForMonth: 0,
        avgCOGS: 0,
        revsForMonthYear: []
      },
      summaryItems: [],
      projectedCogsDialog: false,
      activeYearDialog: false,
      editCampaignID: ''
    };
  },

  watch: {
    refresh: function refresh(value) {
      if (value) this.init();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["b" /* mapState */])({
    allClients: function allClients(state) {
      return state.client.clients;
    },
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    campaignCogs: function campaignCogs(state) {
      return state.campaign.campaignCogs;
    },
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isAdmin: function isAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    computedHeaders: function computedHeaders() {
      var _this = this;

      var campaignCogsCols = null;
      var headers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.headers);

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.campaignCogsCols) {
          campaignCogsCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.campaignCogsCols);
        }
      }
      if (campaignCogsCols) {
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, campaignCogsCols);
      } else {
        headers.map(function (header) {
          _this.colStatuses[header.value] = true;
        });
      }
      return headers.filter(function (h) {
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },

    currentMonthYear: function currentMonthYear() {
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('MMM YYYY');
    },
    isNotClient: function isNotClient() {
      return Number(this.$store.state.user.role) !== __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.init();
              _context.next = 3;
              return _this2.getUserProfile();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    init: function init() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;
                _context2.next = 3;
                return _this3.getUsers();

              case 3:
                _context2.next = 5;
                return _this3.getCampaignCogs();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getCampaignCogs: function getCampaignCogs() {
      var _this4 = this;

      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var filters;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.isLoading = true;
                filters = {};

                if (reload) {
                  filters.reload = reload;
                }
                if (_this4.selectedFilter.activeYear) {
                  filters.activeYear = _this4.selectedFilter.activeYear;
                }
                _context3.next = 6;
                return _this4.$store.dispatch('campaign/getCampaignCogs', filters);

              case 6:
                if (_this4.campaignCogs) {
                  _this4.items = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this4.campaignCogs);
                  _this4.searchFilter();
                }
                _this4.isLoading = false;
                _this4.calSummaryBox();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getUsers: function getUsers() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                response = null;
                _context4.next = 4;
                return _this5.$store.dispatch('client/getClients');

              case 4:
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                response = _context4.sent;

                if (response) {
                  _this5.AM = response.users;
                  _this5.AM = _this5.AM.map(function (am) {
                    am.name = am.firstName + ' ' + am.lastName;
                    return am;
                  });
                }
                _this5.AM.unshift({ id: '', name: 'All Team' });
                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 11:
                response = _context4.sent;

                if (response) {
                  _this5.CC = response.users;
                  _this5.CC = _this5.CC.map(function (cc) {
                    cc.name = cc.firstName + ' ' + cc.lastName;
                    return cc;
                  });
                  _this5.CC.unshift({ id: '', name: 'All Team' });
                }
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](0);

                console.log('error', _context4.t0);
                return _context4.abrupt('return', false);

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 15]]);
      }))();
    },
    getClientName: function getClientName(id) {
      var result = null;
      this.allClients.forEach(function (item) {
        if (item.id === id) {
          if (item.group) {
            result = item.group.Name || item.name;
          } else {
            result = item.name;
          }
        }
      });
      return result;
    },
    changeLock: function changeLock(item, status) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var lockTxt;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                lockTxt = status ? 'Lock' : 'Unlock';

                _this6.$swal({
                  title: 'Are you sure to ' + lockTxt + '?',
                  icon: 'warning',
                  confirmButtonText: lockTxt,
                  showCancelButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5(result) {
                    var updateData;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!result.value) {
                              _context5.next = 9;
                              break;
                            }

                            updateData = [{
                              id: item.campaignID,
                              lockedCOGS: status
                            }];
                            _context5.next = 4;
                            return _this6.$store.dispatch('campaign/updateCampaignByIds', updateData);

                          case 4:
                            if (_this6.campaignUpdated) {
                              _context5.next = 7;
                              break;
                            }

                            _this6.$swal({
                              text: 'Error Campaign Update.',
                              type: 'error'
                            });
                            return _context5.abrupt('return');

                          case 7:
                            _this6.$swal({
                              text: 'Successfully Updated.',
                              type: 'success'
                            });
                            item.lockedCOGS = status;

                          case 9:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this6);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    resetFilter: function resetFilter() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var oldYear;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                oldYear = _this7.selectedFilter.activeYear;

                _this7.selectedFilter = {
                  AM: '',
                  CC: '',
                  startDate: '',
                  endDate: '',
                  locked: false,
                  text: '',
                  activeYear: oldYear
                };
                _this7.getCampaignCogs(true);

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    searchFilter: function searchFilter() {
      var _this8 = this;

      this.filteredItems = __WEBPACK_IMPORTED_MODULE_22__utils__["a" /* default */].func.refreshJSON(this.items);
      this.filteredItems = this.filteredItems.map(function (item) {
        if (_this8.selectedFilter.AM) {
          item.data = item.data.filter(function (dItem) {
            var AMs = dItem.AM.map(function (a) {
              return a.id;
            });
            return AMs && AMs.includes(_this8.selectedFilter.AM);
          });
        }
        if (_this8.selectedFilter.CC) {
          item.data = item.data.filter(function (dItem) {
            var CCs = dItem.CC.map(function (a) {
              return a.id;
            });
            return CCs && CCs.includes(_this8.selectedFilter.CC);
          });
        }
        if (_this8.selectedFilter.startDate) {
          item.data = item.data.filter(function (dItem) {
            return _this8.formatYmd(dItem.createdAt) >= _this8.selectedFilter.startDate;
          });
        }
        if (_this8.selectedFilter.endDate) {
          item.data = item.data.filter(function (dItem) {
            return _this8.formatYmd(dItem.createdAt) <= _this8.selectedFilter.endDate;
          });
        }
        if (_this8.selectedFilter.locked) {
          item.data = item.data.filter(function (dItem) {
            return dItem.lockedCOGS;
          });
        }
        if (_this8.selectedFilter.text) {
          item.filter.search = _this8.selectedFilter.text;
        }
        return item;
      });
      this.getTotalSummary();
      this.calSummaryBox();
    },
    showPairedAdminViewDialog: function showPairedAdminViewDialog(campaign) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.pairedCampaign = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                  id: campaign.campaignID
                });
                _this9.pairedInfAdminViewDialog = true;

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    getFiltered: function getFiltered(filtered) {
      var _this10 = this;

      if (!filtered.length) return;
      var qName = filtered[0].yearQuarter;

      var qIdex = this.filteredItems.findIndex(function (f) {
        return f.name === qName;
      });
      if (!this.filteredItems[qIdex]) return;
      this.filteredItems[qIdex].totalValues = {
        budget: 0,
        cappedCOGS: 0,
        cogsTotal: 0,
        cogsInf: 0,
        cogsOthers: 0,
        cogsInfPercentage: 0,
        cogsExcess: 0,
        completedAmt: 0,
        pendingAmt: 0
      };
      if (filtered.length > 0) {
        filtered.map(function (f) {
          _this10.filteredItems[qIdex].totalValues.budget += f.budget ? Number(f.budget) : 0;
          _this10.filteredItems[qIdex].totalValues.cappedCOGS += f.cappedCOGS ? Number(f.cappedCOGS) : 0;
          _this10.filteredItems[qIdex].totalValues.cogsTotal += f.cogsTotal ? Number(f.cogsTotal) : 0;
          _this10.filteredItems[qIdex].totalValues.cogsInf += f.cogsInf ? Number(f.cogsInf) : 0;
          _this10.filteredItems[qIdex].totalValues.cogsOthers += f.cogsOthers ? Number(f.cogsOthers) : 0;
          _this10.filteredItems[qIdex].totalValues.cogsInfPercentage += f.cogsInfPercentage ? Number(f.cogsInfPercentage) : 0;
          _this10.filteredItems[qIdex].totalValues.cogsExcess += f.cogsExcess ? Number(f.cogsExcess) : 0;
          _this10.filteredItems[qIdex].totalValues.completedAmt += f.completedAmt ? Number(f.completedAmt) : 0;
          _this10.filteredItems[qIdex].totalValues.pendingAmt += f.pendingAmt ? Number(f.pendingAmt) : 0;
        });
        this.filteredItems[qIdex].totalValues.budget = this.filteredItems[qIdex].totalValues.budget.toFixed(2);
        this.filteredItems[qIdex].totalValues.cappedCOGS = this.filteredItems[qIdex].totalValues.cappedCOGS.toFixed(2);
        this.filteredItems[qIdex].totalValues.cogsTotal = this.filteredItems[qIdex].totalValues.cogsTotal.toFixed(2);
        this.filteredItems[qIdex].totalValues.cogsInf = this.filteredItems[qIdex].totalValues.cogsInf.toFixed(2);
        this.filteredItems[qIdex].totalValues.cogsOthers = this.filteredItems[qIdex].totalValues.cogsOthers.toFixed(2);
        this.filteredItems[qIdex].totalValues.cogsExcess = this.filteredItems[qIdex].totalValues.cogsExcess.toFixed(2);
        if (this.filteredItems[qIdex].totalValues.cogsInfPercentage > 0) {
          this.filteredItems[qIdex].totalValues.cogsInfPercentage = (this.filteredItems[qIdex].totalValues.cogsInfPercentage / filtered.length).toFixed(2);
        }
      }
    },
    getExcessCOGS: function getExcessCOGS(item) {
      if (Number(item.target) > 0) {
        return Number(item.target) - Number(item.cogs);
      }
      return 0;
    },
    formatDecimal: function formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    formatMonth: function formatMonth(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()(date).format('MMM YYYY');
    },
    formatYmd: function formatYmd(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()(date).format('YYYY-MM-DD');
    },
    getCOGSExcessColor: function getCOGSExcessColor(cogsExcess) {
      if (cogsExcess < 0) {
        return 'cogs-red';
      } else if (cogsExcess > 0) {
        return 'cogs-green';
      } else {
        return '';
      }
    },
    getCOGSExcessSign: function getCOGSExcessSign(cogsExcess) {
      if (cogsExcess < 0) {
        return '- $' + Math.abs(cogsExcess);
      } else if (cogsExcess > 0) {
        return '+ $' + Math.abs(cogsExcess);
      } else {
        return '$' + 0;
      }
    },
    openQuarterUpdateModal: function openQuarterUpdateModal(selectedCOGS) {
      this.selectedCOGS = selectedCOGS;
      this.quarterUpdateialog = true;
    },
    getUsersDisplay: function getUsersDisplay(AM) {
      return AM.map(function (user) {
        return user.firstName;
      }).join(', ');
    },
    reloadManually: function reloadManually(campaignID) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this11.isLoading = true;
                _context9.next = 3;
                return _this11.$store.dispatch('campaign/updateCampaignCogsByCampaignID', [{ campaignID: campaignID }]);

              case 3:
                _this11.getCampaignCogs();

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.headers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var key = _ref3[0];
          var value = _ref3[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                columns = _this12.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this12.userProfile.tableSettings) {
                  tableSettings = _this12.userProfile.tableSettings;
                }
                tableSettings.campaignCogsCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this12.currentUserID,
                  tableSettings: tableSettings
                };
                _context10.next = 8;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this12.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                _this12.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].getUser(_this13.currentUserID);

              case 2:
                resp = _context11.sent;

                if (resp && resp.id) {
                  _this13.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },
    openProjectedCogsDialog: function openProjectedCogsDialog() {
      this.projectedCogsDialog = true;
    },
    getTotalSummary: function getTotalSummary() {
      var _this14 = this;

      this.totalSummary.projectedCogs = 0;
      this.totalSummary.projectedCogsForMonth = 0;
      this.totalSummary.avgCOGS = 0;
      var lockedAmts = 0;
      var lockedCounts = 0;
      var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      var currentMonthYear = __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('MMM') + '' + __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('YYYY');
      var matchMonths = shortMonths.map(function (m) {
        return '' + m + _this14.selectedFilter.activeYear;
      });
      var revsForMonthYear = matchMonths.map(function (m) {
        return {
          month: m,
          amount: 0,
          totalAmt: 0
        };
      });
      var processItems = [];
      this.filteredItems.map(function (fItem) {
        if (fItem.data) {
          fItem.data.map(function (i) {
            processItems.push(i);
          });
        }
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(processItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.monthlyRates) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(item.monthlyRates)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _ref4 = _step5.value;

                var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);

                var key = _ref5[0];
                var value = _ref5[1];

                if (key === currentMonthYear) {
                  this.totalSummary.projectedCogsForMonth += parseFloat(value);
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
          if (item.pendingAmt) {
            this.totalSummary.projectedCogs += Number(item.pendingAmt);
          }
          if (item.lockedCOGS) {
            lockedAmts += Number(item.cogsInfPercentage);
            lockedCounts += 1;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (lockedAmts > 0) {
        this.totalSummary.avgCOGS = (lockedAmts / lockedCounts).toFixed(2);
      }
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(processItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _item = _step3.value;

          if (_item.monthlyRates) {
            var _loop2 = function _loop2(_key, _value) {
              var revMYIdx = revsForMonthYear.findIndex(function (rev) {
                return rev.month === _key;
              });
              if (revMYIdx !== -1) {
                revsForMonthYear[revMYIdx].amount += parseFloat(_value);
              }
            };

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(_item.monthlyRates)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _ref6 = _step6.value;

                var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);

                var _key = _ref7[0];
                var _value = _ref7[1];

                _loop2(_key, _value);
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.filteredItems.map(function (f) {
        var _loop = function _loop(data) {
          var createdMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()(data.createdAt).format('MMMYYYY');
          var revMYIdx = revsForMonthYear.findIndex(function (rev) {
            return rev.month === createdMonth;
          });
          if (revMYIdx !== -1) {
            revsForMonthYear[revMYIdx].totalAmt += parseFloat(data.cogsTotal);
          }
        };

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(f.data), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var data = _step4.value;

            _loop(data);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        _this14.getFiltered(f.data);
      });
      revsForMonthYear = revsForMonthYear.map(function (rm) {
        rm.month = rm.month.replace(_this14.selectedFilter.activeYear.toString(), ' ' + _this14.selectedFilter.activeYear);
        rm.amount = parseFloat(parseFloat(rm.amount, 2).toFixed(2));
        rm.totalAmt = parseFloat(parseFloat(rm.totalAmt, 2).toFixed(2));
        return rm;
      });
      this.totalSummary.revsForMonthYear = revsForMonthYear;
    },
    roundDec: function roundDec(num) {
      if (num) {
        return Number(num).toFixed(2);
      }
      return num;
    },
    exportReport: function exportReport(item) {
      var _this15 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].exportCampaignCogs(item.data).then(function (response) {
        _this15.isLoading = false;
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        FileSaver.saveAs(blob, 'Campaign_Cogs_' + item.title + '_' + __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('X') + '.xlsx');
      }).catch(function (error) {
        _this15.isLoading = false;

        console.log('error', error);
        _this15.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    openActiveYearDialog: function openActiveYearDialog(campaigns) {
      this.editCampaigns = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], campaigns);
      this.activeYearDialog = true;
    },
    calSummaryBox: function calSummaryBox() {
      var _this16 = this;

      var newItems = __WEBPACK_IMPORTED_MODULE_22__utils__["a" /* default */].func.refreshJSON(this.items);
      newItems = newItems.map(function (item) {
        if (_this16.selectedFilter.AM) {
          item.data = item.data.filter(function (dItem) {
            var AMs = dItem.AM.map(function (a) {
              return a.id;
            });
            return AMs && AMs.includes(_this16.selectedFilter.AM);
          });
        }
        if (_this16.selectedFilter.CC) {
          item.data = item.data.filter(function (dItem) {
            var CCs = dItem.CC.map(function (a) {
              return a.id;
            });
            return CCs && CCs.includes(_this16.selectedFilter.CC);
          });
        }
        return item;
      });
      newItems.map(function (item, index) {
        item.totalValues = {
          budget: 0,
          cappedCOGS: 0,
          cogsTotal: 0,
          cogsInf: 0,
          cogsOthers: 0,
          cogsInfPercentage: 0,
          cogsExcess: 0,
          completedAmt: 0,
          pendingAmt: 0
        };
        item.data.map(function (data) {
          item.totalValues.budget += data.budget ? Number(data.budget) : 0;
          item.totalValues.cappedCOGS += data.cappedCOGS ? Number(data.cappedCOGS) : 0;
          item.totalValues.cogsTotal += data.cogsTotal ? Number(data.cogsTotal) : 0;
          item.totalValues.cogsInf += data.cogsInf ? Number(data.cogsInf) : 0;
          item.totalValues.cogsOthers += data.cogsOthers ? Number(data.cogsOthers) : 0;
          item.totalValues.cogsInfPercentage += data.cogsInfPercentage ? Number(data.cogsInfPercentage) : 0;
          item.totalValues.cogsExcess += data.cogsExcess ? Number(data.cogsExcess) : 0;
          item.totalValues.completedAmt += data.completedAmt ? Number(data.completedAmt) : 0;
          item.totalValues.pendingAmt += data.pendingAmt ? Number(data.pendingAmt) : 0;
        });
        item.totalValues.budget = item.totalValues.budget.toFixed(2);
        item.totalValues.cappedCOGS = item.totalValues.cappedCOGS.toFixed(2);
        item.totalValues.cogsTotal = item.totalValues.cogsTotal.toFixed(2);
        item.totalValues.cogsInf = item.totalValues.cogsInf.toFixed(2);
        item.totalValues.cogsOthers = item.totalValues.cogsOthers.toFixed(2);
        item.totalValues.cogsExcess = item.totalValues.cogsExcess.toFixed(2);
        if (item.totalValues.cogsInfPercentage > 0) {
          item.totalValues.cogsInfPercentage = (item.totalValues.cogsInfPercentage / item.data.length).toFixed(2);
        }
        return item;
      });
      this.summaryItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], newItems);
    }
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecognizedRevenueModal',
  props: ['value', 'monthYearValues'],
  data: function data() {
    return {
      AMCC: [],
      selectedFilter: {
        AMCC: ''
      },
      headers: [{
        text: 'Month',
        value: 'month'
      }, {
        text: 'Total Amount',
        value: 'totalAmt'
      }, {
        text: 'Pending Amount',
        value: 'amount'
      }],
      filteredMthYearVals: []
    };
  },

  computed: {
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY');
    },
    totalAmount: function totalAmount() {
      var total = 0;
      if (this.monthYearValues) {
        this.monthYearValues.map(function (m) {
          if (m.amount) {
            total += parseFloat(m.amount);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    totalCogsAmount: function totalCogsAmount() {
      var total = 0;
      if (this.monthYearValues) {
        this.monthYearValues.map(function (m) {
          if (m.totalAmt) {
            total += parseFloat(m.totalAmt);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    campaigns: Object,
    selectedCOGS: Array
  },
  data: function data() {
    return {
      valid: true,
      isLoading: false,
      data: {
        quarter: ''
      },
      quarters: [{
        name: '25Q1',
        title: 'QUARTER 1'
      }, {
        name: '25Q2',
        title: 'QUARTER 2'
      }, {
        name: '25Q3',
        title: 'QUARTER 3'
      }, {
        name: '25Q4',
        title: 'QUARTER 4'
      }, {
        name: 'na',
        title: 'Others'
      }],
      totalValues: {
        entries: 0,
        cogsCapped: 0,
        cogsUsed: 0,
        cogsExcess: 0,
        cogsPercent: 0
      },
      MessageRules: [function (value) {
        return !!value || 'Required.';
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    savedCampaignCogs: function savedCampaignCogs(state) {
      return state.campaign.savedCampaignCogs;
    },
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isAdmin: function isAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isTopUsers: function isTopUsers() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.FINANCE;
    }
  }),
  watch: {
    selectedCOGS: function selectedCOGS(newselectedCOGS) {
      var _this2 = this;

      this.totalValues = {
        entries: 0,
        cogsCapped: 0,
        cogsUsed: 0,
        cogsExcess: 0,
        cogsPercent: 0
      };
      this.totalValues.entries = newselectedCOGS.length;
      var totalPercent = 0;
      newselectedCOGS.map(function (ns) {
        _this2.totalValues.cogsCapped += Number(ns.cappedCOGS);
        _this2.totalValues.cogsUsed += Number(ns.cogsTotal);
        totalPercent += ns.cogsInfPercentage;
      });
      this.totalValues.cogsExcess = this.totalValues.cogsCapped - this.totalValues.cogsUsed;
      this.totalValues.cogsPercent = (totalPercent / newselectedCOGS.length).toFixed(2);
      this.totalValues.cogsCapped = this.totalValues.cogsCapped.toFixed(2);
      this.totalValues.cogsUsed = this.totalValues.cogsUsed.toFixed(2);
      this.totalValues.cogsExcess = this.totalValues.cogsExcess.toFixed(2);
      this.totalValues.cogsPercent = this.totalValues.cogsPercent.toFixed(2);
    }
  },
  methods: {
    save: function save() {
      var _this3 = this;

      if (!this.$refs.quarterForm.validate()) {
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var saveCOGS;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result.value) {
                    _context2.next = 8;
                    break;
                  }

                  _this3.isLoading = true;
                  saveCOGS = [];

                  saveCOGS = _this3.selectedCOGS.map(function (s) {
                    return {
                      id: s.campaignID,
                      yearQuarter: _this3.data.quarter.replace('20', '')
                    };
                  });
                  _context2.next = 6;
                  return _this3.$store.dispatch('campaign/updateCampaignByIds', saveCOGS);

                case 6:
                  _this3.isLoading = false;
                  if (_this3.campaignUpdated) {
                    _this3.$emit('updated');
                    _this3.close();
                    _this3.$swal({
                      text: 'Successfully Saved.',
                      type: 'success'
                    });
                  }

                case 8:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetForm: function resetForm() {
      this.data = {
        quarter: ''
      };
      this.valid = true;
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cogs-summary',
  components: {
    CogsSummaryDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ViewCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPairingInfluencerElimination_vue__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPairingInfluencerElimination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ViewPairingInfluencerElimination_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_reverse__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-brief',
  components: {
    ViewCampaignModal: __WEBPACK_IMPORTED_MODULE_12__ViewCampaignModal___default.a,
    InfluencerElimination: __WEBPACK_IMPORTED_MODULE_13__ViewPairingInfluencerElimination_vue___default.a
  },
  data: function data() {
    return {
      viewModalDialog: false,
      campaingData: null,
      eliminationDialog: false,
      currentPage: 1,
      itemsPerPage: 10,
      totalRows: 0,
      campaigns: [],
      keyword: '',
      fields: [{
        text: 'Campaign Name',
        value: 'name'
      }, {
        text: 'Status',
        value: 'campaignStatusDisplayForClients'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      viewCampaignData: null,
      viewInfluencerDialog: false,
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      }
    };
  },
  mounted: function mounted() {},
  created: function created() {
    this.paginate(1);
  },

  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    }
  },
  methods: {
    startEliminate: function startEliminate(campaignID, status) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = null;

                if (!(status === _this.campaignStatusConfig.COMPLETE)) {
                  _context.next = 5;
                  break;
                }

                result = { value: true };
                _context.next = 8;
                break;

              case 5:
                _context.next = 7;
                return _this.$swal({
                  title: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.title,
                  html: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.html,
                  type: 'info',
                  width: 500,
                  backdrop: 'rgba(0,0,1, 0.9)',
                  showCancelButton: true,
                  confirmButtonText: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.confirmButtonText,
                  cancelButtonText: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.cancelButtonText,
                  allowOutsideClick: false
                });

              case 7:
                result = _context.sent;

              case 8:
                if (!result.value) {
                  _this.eliminationDialog = false;
                } else {
                  __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
                    _this.campaingData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, response);
                    _this.eliminationDialog = true;
                  }).catch(function (error) {
                    console.log('error', error);
                  });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    paginate: function paginate() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].paginate({
        page: page,
        keyword: this.keyword,
        sort: 'updatedAt DESC'
      }).then(function (response) {
        var campaigns = response.campaigns.map(function (item) {
          item.campaignStatusDisplayForClients = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignStatusDisplayForClients[item.status];

          item.clientPaymentStatusDisplay = item.clientPaymentStatus ? __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].clientPaymentStatusDisplay[item.clientPaymentStatus] : __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].clientPaymentStatusDisplay[item.activated];
          item.updatedAtDisplay = _this2.formatTime(item.updatedAt);
          return item;
        });

        _this2.campaigns = campaigns;
        _this2.totalRows = response.totalCampaigns;
        _this2.checkShowURLParam();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this3.viewCampaignData = response;
        _this3.viewModalDialog = true;
      }).catch(function (error) {
        _this3.viewModalDialog = true;

        console.log('error', error);
      });
    },
    approveCampaign: function approveCampaign(campaignID) {
      var _this4 = this;

      var campaignConfirmation = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.approval[this.campaignStatusConfig.PENDING_CLIENT_APPROVAL];

      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        html: campaignConfirmation['confirmation']['html'],
        input: campaignConfirmation['confirmation']['input'],
        inputValue: 0,
        inputPlaceholder: 'I have read and agree to the Terms and Conditions',
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        inputValidator: function inputValidator(result) {
          return !result && 'You need to agree with T&C';
        },
        width: 850,
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].approveCampaign(campaignID, _this4.campaignStatusConfig.PENDING_CLIENT_APPROVAL).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
              __WEBPACK_IMPORTED_MODULE_14__campaignPDF__["a" /* default */].getPdfInBase64(response).then(function (pdfData) {
                _this4.sendEmail(campaignID, pdfData);
              }).catch(function (error) {
                console.log('error in converting PDF', error);
              });
            }).catch(function (error) {
              console.log('error', error);
            });
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this4.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this4.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this4.paginate(1);

          _this4.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignStatusFlow['approve'][_this4.campaignStatusConfig.PENDING_CLIENT_APPROVAL],
            data: null
          });

          _this4.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    buttonShow: function buttonShow(type) {
      var campaignStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var buttonPermission = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */]['userPermissions']['campaign'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(campaignStatus);
      }
      return false;
    },
    getPairedInfluencers: function getPairedInfluencers(campaign) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var campaignResp, pairingResp, items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, inf, invitedItems, notInvitedItems;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].getCampaign(campaign.id);

              case 2:
                campaignResp = _context2.sent;

                if (campaignResp) {
                  _this5.campaignCOEB = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                    id: campaignResp.id,
                    campaignId: campaignResp.id,
                    campaignName: campaignResp.name,
                    campaignType: campaignResp.campaignType,
                    companyID: campaignResp.companyID,
                    clientID: campaignResp.clientID,
                    ioNumbers: campaignResp.ioNumbers,
                    campaignOutreach: campaignResp.outreach,
                    campaignEngagement: campaignResp.engagement,
                    campaignBudget: campaignResp.budget,
                    max_content: campaignResp.max_content,
                    min_content: campaignResp.min_content,
                    outreach: campaignResp.outreach,
                    engagement: campaignResp.engagement,
                    budget: campaignResp.budget
                  });
                }
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaign.id);

              case 6:
                pairingResp = _context2.sent;

                if (!pairingResp) {
                  _context2.next = 35;
                  break;
                }

                items = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 12;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(pairingResp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  inf = _this5.beautifyData(data);

                  if (inf.pairingStatus === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ACCEPTED) {
                    items.push(inf);
                  }
                }
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 20:
                _context2.prev = 20;
                _context2.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context2.prev = 23;

                if (!_didIteratorError) {
                  _context2.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context2.finish(23);

              case 27:
                return _context2.finish(20);

              case 28:
                _this5.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
                _this5.campaignMeasurement(items);
                invitedItems = items.filter(function (e) {
                  return e.pairingStatus !== __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this5.campaignMeasurementInvited(invitedItems);

                notInvitedItems = items.filter(function (e) {
                  return e.pairingStatus === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this5.campaignMeasurementNotInvited(notInvitedItems);
                _this5.viewInfluencerDialog = true;

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[12, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    campaignMeasurement: function campaignMeasurement(items) {
      var _this6 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(function (item) {
        _this6.measurement.total += Number(_this6.calculateContents(item));
        _this6.measurement.outreach += Number(_this6.calculateOutreach(item));
        _this6.measurement.engagement += Number(_this6.calculateEngagement(item));
        _this6.measurement.budget += Number(item.payout || 0);
      });
      var content = this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaignCOEB.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaignCOEB.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.budget * 100).toFixed(2);
    },
    campaignMeasurementInvited: function campaignMeasurementInvited(items) {
      var _this7 = this;

      this.measurement.invitedTotal = 0;
      items.map(function (item) {
        _this7.measurement.invitedTotal += Number(_this7.calculateContents(item));
        _this7.measurement.invitedOutreach += Number(_this7.calculateOutreach(item));
        _this7.measurement.invitedEngagement += Number(_this7.calculateEngagement(item));
        _this7.measurement.invitedBudget += Number(item.payout || 0);
      });
    },
    campaignMeasurementNotInvited: function campaignMeasurementNotInvited(items) {
      var _this8 = this;

      this.measurement.notInvitedTotal = 0;
      items.map(function (item) {
        _this8.measurement.notInvitedTotal += Number(_this8.calculateContents(item));
        _this8.measurement.notInvitedOutreach += Number(_this8.calculateOutreach(item));
        _this8.measurement.notInvitedEngagement += Number(_this8.calculateEngagement(item));
        _this8.measurement.notInvitedBudget += Number(item.payout || 0);
      });
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};
      inf = data.influencer_details;
      inf.influencer_details = __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.refreshJSON(influencerDetails);
      inf.pairing_details = data.pairing_details;
      inf.elimination_details = data.elimination_details;
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.pairingID = data.id;
      inf.id = data.id;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = __WEBPACK_IMPORTED_MODULE_9__campaignHelper__["a" /* default */].getDeliverableDetails(deliverablesDetails);
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? __WEBPACK_IMPORTED_MODULE_17_lodash_reverse___default()(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        if (inf.payoutStatus === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].payoutStatus.SUBMITTED) {
          inf.payoutSubmitted = true;
        }
        if (inf.payoutStatus >= __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].payoutStatus.CONFIRMED) {
          inf.payoutVerified = true;
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details;
      }
      return inf;
    },
    eliminatinStatusColor: function eliminatinStatusColor(id) {
      if (id === 0) {
        return 'primary';
      } else if (id === 1) {
        return '#8BC34A';
      } else {
        return 'red';
      }
    },
    eliminationStatusDisplay: function eliminationStatusDisplay(id) {
      if (id === 0) {
        return 'Pending';
      } else if (id === 1) {
        return 'Selected';
      } else {
        return 'Eliminated';
      }
    },
    sendEmail: function sendEmail(campaignID, pdfData) {
      __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].sendCampaignPDF(campaignID, pdfData).then(function (response) {
        return response;
      }).catch(function (error) {
        console.log('error in sending email with pdf attached', error);
      });
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).fromNow();
    },
    checkShowURLParam: function checkShowURLParam() {
      if (this.$route.query.id) {
        this.getCampaignDataToView(this.$route.query.id);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* mapState */])(['user']), {
    campaignActivationStatusConfig: function campaignActivationStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignActivationStatus;
    },
    campaignStatusConfig: function campaignStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  })
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewPostModal__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewPostModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ViewPostModal__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-ongoing',
  components: {
    ViewPairingBriefDetailedModal: __WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal___default.a,
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_5__ViewPostModal___default.a
  },
  data: function data() {
    return {
      campaignStatus: this.$route.meta.campaignStatus,
      currentPage: 1,
      perPage: 15,
      viewRateCardData: 0,
      influencerID: '',
      totalRows: 0,
      campaigns: [],
      keyword: '',
      fields: [{
        key: 'pairingStatusDisplay',
        label: 'Status'
      }, {
        key: 'name'
      }, {
        key: 'updatedAt'
      }, {
        key: 'actions'
      }],
      viewCampaignData: null,
      viewPostCampaignData: null
    };
  },
  created: function created() {
    this.paginate(1);
    this.userID = this.$store.state.user.id;
    this.influencerID = this.getInfluencerID(this.userID);
  },

  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    }
  },
  methods: {
    paginate: function paginate() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].paginate({
        page: page,
        per_page: this.perPage,
        status: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.COMPLETE + ',' + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.ONGOING,
        pairingStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].pairingStatus.INTERESTED,
        keyword: this.keyword,
        sort: 'updatedAt DESC',
        hasInstagramURL: true
      }).then(function (response) {
        var campaigns = response.campaigns;

        campaigns = campaigns.map(function (item) {
          item.pairingStatusDisplay = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].pairingStatusDisplay[item.status];
          item.updatedAt = _this.formatTime(item.updatedAt);
          return item;
        });

        _this.campaigns = campaigns;
        _this.totalRows = response.totalCampaigns;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this2.viewCampaignData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getInfluencerID: function getInfluencerID(userID) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getInfluencerID(userID).then(function (response) {
        _this3.influencerID = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getRateCardDataToView: function getRateCardDataToView(campaignID, influencerID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getRateCard(campaignID, influencerID).then(function (response) {
        if (response === []) {
          _this4.viewRateCardData = 0;
        } else {
          _this4.viewRateCardData = response[0].approvedRateCard;
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    approveCampaign: function approveCampaign(campaignID) {
      var _this5 = this;

      var campaignConfirmation = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignConfirmation.approval[this.campaignStatus];

      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].approveCampaign(campaignID, _this5.campaignStatus).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this5.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this5.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this5.paginate(1);

          _this5.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatusFlow['approve'][_this5.campaignStatus],
            data: null
          });

          _this5.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    buttonShowPairing: function buttonShowPairing(pairingStatus) {
      return pairingStatus === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].pairingStatus.INVITED;
    },
    rejectCampaign: function rejectCampaign(campaignID) {
      var _this6 = this;

      var campaignConfirmation = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignConfirmation.reject[this.campaignStatus];

      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].rejectCampaign(campaignID, _this6.campaignStatus).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this6.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this6.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this6.paginate(true);

          _this6.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatusFlow['reject'][_this6.campaignStatus],
            data: null
          });

          _this6.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    acceptInvite: function acceptInvite(pairingID) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].acceptInvite(pairingID).then(function (response) {
        _this7.paginate(1);

        _this7.$store.commit('SET_CAMPAIGNS', {
          campaignStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatusFlow['approve'][_this7.campaignStatus],
          data: null
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getPostDataToView: function getPostDataToView(campaignData) {
      this.viewPostCampaignData = campaignData;
    }
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_editor__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__scoped_custom_KToast__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__scoped_custom_KToast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__scoped_custom_KToast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__EmailTemplateAPIs__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_campaign_PairingStatus__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_campaign_PairingStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__scoped_campaign_PairingStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mustache__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuex__ = __webpack_require__(12);























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-invite',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_15_vue2_editor__["a" /* VueEditor */],
    KToast: __WEBPACK_IMPORTED_MODULE_16__scoped_custom_KToast___default.a,
    PairingStatus: __WEBPACK_IMPORTED_MODULE_18__scoped_campaign_PairingStatus___default.a
  },
  data: function data() {
    return {
      dialog: false,
      emailDialog: false,
      campaign: {},
      keywordsMap: new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a(),
      keywords: [],
      client: {},
      selectedInfluencers: [],
      templates: [],
      selectedFromEmail: [],
      fromEmail: [],
      templateHTML: '',

      previewDialog: false,
      previewText: null,

      sendingInvitationDialog: false,
      isSending: false,
      sendings: [],
      selectedTemplate: {
        id: null,
        subject: null,
        name: null,
        templateHTML: null
      },
      inviteUrl: '',
      toast: {
        variant: '',
        content: '',
        header: ''
      },
      fields: [],
      headers: [{
        text: 'Instagram',
        align: 'start',
        sortable: false,
        value: 'instagramHandle'
      }, { text: 'Email', value: 'email' }, { text: 'Payout', value: 'payout' }, { text: 'Deliverables' }, { text: 'Status', value: 'status' }, { text: 'Actions', value: 'actions', sortable: false }],
      influencers: [],
      editedIndex: -1,
      editedItem: {
        email: '',
        no_of_posts: 0,
        no_of_stories: 0,
        no_of_carousels: 0,
        no_of_video: 0,
        no_of_igTv: 0,
        id: null
      },
      defaultItem: {
        email: '',
        no_of_posts: 0,
        no_of_stories: 0,
        no_of_carousels: 0,
        no_of_video: 0,
        no_of_igTv: 0,
        id: null
      },
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      },
      disableSaveEdit: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    statusINVITED: function statusINVITED() {
      return this.pairingStatus.INVITED;
    },

    budget: function budget() {
      return Math.floor(this.campaign.budget * 0.3);
    }
  }),
  watch: {
    'selectedTemplate.templateHTML': function selectedTemplateTemplateHTML(value) {
      this.templateHTML = value;
      this.processKeywords(value);
    },
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  created: function created() {
    var campaignID = this.$route.params.campaignID;
    if (!campaignID) {
      this.$swal({
        type: 'error',
        text: 'Campaign ID is invalid'
      });
    }
    this.getCampaignDetails(campaignID);
    this.getAllEmailTemplates();
    this.getCampaignUsers(campaignID);
    this.inviteUrl = window.location.protocol + '//' + window.location.host + '/campaigns/' + campaignID + '/invitation';
  },

  methods: {
    saveNewTemplate: function saveNewTemplate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, name, data, createdTemplate, message;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(!_this.selectedTemplate || !_this.selectedTemplate.templateHTML || !_this.selectedTemplate.subject)) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Please enter the template content and subject');

              case 3:
                _context.next = 5;
                return _this.$swal({
                  title: 'Enter template name',
                  input: 'text',
                  showCancelButton: true,
                  inputValue: 'Template-' + new Date().getMilliseconds(),
                  confirmButtonText: 'Confirm',

                  target: document.getElementById('sweetAlertContainer'),
                  inputValidator: function inputValidator(value) {
                    if (!value) {
                      return 'Please enter a name';
                    }
                  }
                });

              case 5:
                _ref = _context.sent;
                name = _ref.value;

                if (name) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:
                data = {
                  templateHTML: _this.selectedTemplate.templateHTML,
                  name: name,
                  subject: _this.selectedTemplate.subject
                };
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_17__EmailTemplateAPIs__["a" /* default */].createEmailTemplate(data);

              case 12:
                createdTemplate = _context.sent;

                _this.makeToast({
                  content: 'Template Created',
                  header: 'Success!',
                  variant: 'success'
                });
                _this.templates.push(createdTemplate);
                _this.selectedTemplate = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, createdTemplate);
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](0);
                message = _context.t0 && _context.t0.message ? _context.t0.message : 'Could not create template';

                _this.$swal({
                  type: 'error',
                  text: message
                });

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 18]]);
      }))();
    },
    selectAllInfluencers: function selectAllInfluencers($event) {
      var _this2 = this;

      if (!$event.value) {
        this.selectedInfluencers = [];
        return;
      }
      var influencers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.influencers);
      var qualifiedInfluencers = influencers.filter(function (e) {
        return _this2.isValidPairing(e) && e.pairingStatus < _this2.statusINVITED.value;
      }).map(function (e) {
        return e.id;
      });
      this.selectedInfluencers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], qualifiedInfluencers);
    },
    makeToast: function makeToast(toast) {
      this.toast = toast;
      this.$bvToast.show('kobe-toast');
    },
    processKeywords: function processKeywords(text) {
      var pattern = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].regexPattern.search_value;
      var m = void 0;
      var keywords = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a();

      while ((m = pattern.exec(text)) !== null) {
        if (m.index === pattern.lastIndex) {
          pattern.lastIndex++;
        }

        m.forEach(function (match, groupIndex) {
          if (!keywords.has(match)) {
            keywords.set(match, 1);
          }
        });
      }

      var mergedMap = new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(keywords), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.keywordsMap)));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(mergedMap.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (!keywords.has(key)) {
            mergedMap.delete(key);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.keywords = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(mergedMap.keys());
      this.keywordsMap = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a(), mergedMap);
    },
    mapValue: function mapValue(target, keyword) {
      this.keywordsMap.set(keyword, target);
      var html = this.selectedTemplate.templateHTML || '';

      html = html.replace(keyword, '{{' + target + '}}');

      this.selectedTemplate.templateHTML = html;
    },
    saveTemplateChanges: function saveTemplateChanges(templateId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (templateId) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                data = {
                  templateHTML: _this3.selectedTemplate.templateHTML,
                  name: _this3.selectedTemplate.name,
                  subject: _this3.selectedTemplate.subject
                };
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_17__EmailTemplateAPIs__["a" /* default */].saveEmailTemplate(templateId, data);

              case 6:
                _this3.makeToast({
                  content: 'Template Updated',
                  header: 'Success!',
                  variant: 'success'
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                _this3.$swal({
                  type: 'error',
                  text: 'Could not save the template'
                });

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 9]]);
      }))();
    },
    getAllEmailTemplates: function getAllEmailTemplates() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var templates;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__EmailTemplateAPIs__["a" /* default */].getAllEmailTemplates();

              case 3:
                templates = _context3.sent;

                _this4.templates = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], templates);
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },
    getCampaignUsers: function getCampaignUsers(campaignID) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var adUsersEmail, campaign, assignedTo, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, assigner, user;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                adUsersEmail = [];
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__campaignAPIs__["a" /* default */].getCampaign(campaignID);

              case 4:
                campaign = _context4.sent;
                assignedTo = campaign.assignedTo;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 9;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(assignedTo);

              case 11:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 20;
                  break;
                }

                assigner = _step2.value;
                _context4.next = 15;
                return __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__["a" /* default */].getUser(assigner);

              case 15:
                user = _context4.sent;


                if (user) {
                  adUsersEmail.push(user.email);
                }

              case 17:
                _iteratorNormalCompletion2 = true;
                _context4.next = 11;
                break;

              case 20:
                _context4.next = 26;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4['catch'](9);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 26:
                _context4.prev = 26;
                _context4.prev = 27;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 29:
                _context4.prev = 29;

                if (!_didIteratorError2) {
                  _context4.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context4.finish(29);

              case 33:
                return _context4.finish(26);

              case 34:
                _this5.fromEmail = adUsersEmail;
                _context4.next = 40;
                break;

              case 37:
                _context4.prev = 37;
                _context4.t1 = _context4['catch'](0);

                console.log(_context4.t1);

              case 40:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 37], [9, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    isValidPairing: function isValidPairing(pairing) {
      return true;
    },
    getCampaignDetails: function getCampaignDetails(campaignID) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var campaign;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__campaignAPIs__["a" /* default */].getCampaign(campaignID);

              case 3:
                campaign = _context5.sent;


                _this6.campaign = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                  campaignId: campaign.id,
                  campaignName: campaign.name,
                  companyID: campaign.companyID,
                  clientID: campaign.clientID,
                  campaignOutreach: campaign.outreach,
                  campaignEngagement: campaign.engagement,
                  campaignBudget: campaign.budget,
                  max_content: campaign.max_content,
                  min_content: campaign.min_content,
                  outreach: campaign.outreach,
                  engagement: campaign.engagement,
                  budget: campaign.budget
                });
                _this6.fields = _this6.fields.concat(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.keyify(_this6.campaign));
                _context5.next = 8;
                return _this6.getClientDetails(campaign.clientID);

              case 8:
                _context5.next = 10;
                return _this6.getPairing(campaignID);

              case 10:
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);
                _this6.$swal({
                  type: 'error',
                  text: 'Could not get campaign details'
                });

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 12]]);
      }))();
    },
    getClientDetails: function getClientDetails(clientID) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var client;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__Client_clientAPIs__["a" /* default */].getClient(clientID);

              case 3:
                client = _context6.sent;

                _this7.client = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                  clientId: client.id,
                  clientName: client.name,
                  clientAddress: client.address,
                  companyID: client.companyID,
                  clientEmail: client.email,
                  clientWebsite: client.website,
                  clientPhoneNumber: client.phoneNumber
                });
                _this7.fields = _this7.fields.concat(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.keyify(_this7.client));
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0);
                _this7.$swal({
                  type: 'error',
                  text: 'Could not get client details'
                });

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 8]]);
      }))();
    },
    getPairing: function getPairing(campaignID) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var pairings, items, invitedItems, notInvitedItems;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                if (campaignID) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt('return', _this8.$swal({
                  type: 'warning',
                  text: 'CampaignID cannot be null'
                }));

              case 3:
                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID);

              case 5:
                pairings = _context7.sent;
                items = pairings.map(function (e) {
                  return _this8.beautifyData(e);
                });
                invitedItems = items.filter(function (e) {
                  return e.pairingStatus !== __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });
                notInvitedItems = items.filter(function (e) {
                  return e.pairingStatus === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this8.fields = _this8.fields.concat(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.keyify(items[0]));
                _this8.influencers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], items);
                _this8.campaignCOEB(items);
                _this8.campaignCOEBInvited(invitedItems);
                _this8.campaignCOEBNotInvited(notInvitedItems);
                _context7.next = 20;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);
                _this8.$swal({
                  type: 'error',
                  text: 'Could not get data'
                });

              case 20:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 16]]);
      }))();
    },
    campaignCOEB: function campaignCOEB(items) {
      var _this9 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(function (item) {
        _this9.measurement.total += Number(_this9.calculateContents(item));
        _this9.measurement.outreach += Number(_this9.calculateOutreach(item));
        _this9.measurement.engagement += Number(_this9.calculateEngagement(item));
        _this9.measurement.budget += Number(item.payout || 0);
      });
      var content = this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaign.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaign.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.budget * 100).toFixed(2);
    },
    campaignCOEBInvited: function campaignCOEBInvited(items) {
      var _this10 = this;

      this.measurement.invitedTotal = 0;
      items.map(function (item) {
        _this10.measurement.invitedTotal += Number(_this10.calculateContents(item));
        _this10.measurement.invitedOutreach += Number(_this10.calculateOutreach(item));
        _this10.measurement.invitedEngagement += Number(_this10.calculateEngagement(item));
        _this10.measurement.invitedBudget += Number(item.payout || 0);
      });
    },
    campaignCOEBNotInvited: function campaignCOEBNotInvited(items) {
      var _this11 = this;

      this.measurement.notInvitedTotal = 0;
      items.map(function (item) {
        _this11.measurement.notInvitedTotal += Number(_this11.calculateContents(item));
        _this11.measurement.notInvitedOutreach += Number(_this11.calculateOutreach(item));
        _this11.measurement.notInvitedEngagement += Number(_this11.calculateEngagement(item));
        _this11.measurement.notInvitedBudget += Number(item.payout || 0);
      });
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels);
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var contactDetails = influencerDetails.contact_details || {};
      var deliverablesDetails = data.deliverables_details || {};
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.pairingID = data.id;
      inf.influencerID = influencerDetails.influencerID;
      inf.email = contactDetails.email || null;
      inf.phoneNumber = contactDetails.phoneNumber || null;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.payout = data.payout_details.amount || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.instagramHandle = influencerDetails.instagramHandle;
      inf.platform = influencerDetails.platform || 'instagram';
      inf.id = data.id;
      inf.emailEdit = false;
      inf.editInfluencer = false;
      return inf;
    },
    openEditItem: function openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true;
      item.editInfluencer = true;
      this.influencers = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.refreshJSON(this.influencers);
      this.disableSaveEdit = false;
    },
    editItem: function editItem(item) {
      this.editedIndex = this.influencers.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    saveEditingData: function saveEditingData() {
      var _this12 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this12.isEditing = true;
          var data = _this12.influencers.filter(function (item) {
            return item.editInfluencer && item.editInfluencer === true;
          });
          data = data.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
              id: item.pairingID,
              email: item.email
            });
          });

          __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].saveEditedCampaignInvite(data).then(function (response) {
            _this12.isEditing = false;
            _this12.cancelEdit();

            _this12.$swal({
              text: 'Pairing Updated',
              type: 'success'
            });
          }).catch(function (error) {
            _this12.isEditing = false;

            console.log('error', error);
            _this12.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    cancelEdit: function cancelEdit() {
      this.influencers = this.influencers.map(function (inf) {
        inf.emailEdit = false;
        inf.editInfluencer = false;
        return inf;
      });
      this.disableSaveEdit = true;
    },
    preview: function preview(item, templateHTML) {
      if (!templateHTML) {
        this.$swal({
          type: 'error',
          text: 'Email template could not be empty'
        });
      }
      var client = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.client);
      var campaign = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.campaign);
      item = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(item, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(client, campaign));
      var html = __WEBPACK_IMPORTED_MODULE_19_mustache___default.a.render(templateHTML, item);
      this.previewText = html;
      this.previewDialog = true;
    },
    close: function close() {
      var _this13 = this;

      this.dialog = false;
      setTimeout(function () {
        _this13.editedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this13.defaultItem);
        _this13.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      var _this14 = this;

      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.influencers[this.editedIndex], this.editedItem);
        var updateData = {
          email: this.editedItem.email,
          no_of_posts: this.editedItem.no_of_posts,
          no_of_stories: this.editedItem.no_of_stories,
          no_of_carousels: this.editedItem.no_of_carousels,
          no_of_video: this.editedItem.no_of_video,
          no_of_igTv: this.editedItem.no_of_igTv
        };
        this.updatePairing(this.editedItem.id, updateData).then(function () {
          console.log('updated');
          return _this14.$swal({
            type: 'success',
            text: 'Saved!'
          });
        });
      } else {
        this.influencers.push(this.editedItem);
      }
      this.close();
    },
    updatePairing: function updatePairing(pairId, data) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].updatePairingDetails(pairId, data);

              case 3:
                _context8.next = 9;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);
                _this15.$swal({
                  type: 'error',
                  text: 'Could not save the pairing details'
                });

              case 9:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this15, [[0, 5]]);
      }))();
    },
    sendInvitation: function sendInvitation(pairingId, inviteData, isUpdateStatus) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var influencer, updated;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                influencer = _this16.influencers.find(function (e) {
                  return e.id === pairingId;
                });
                _context9.prev = 1;
                updated = false;

                if (!isUpdateStatus) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].updatePairingStatusOnly(pairingId, inviteData);

              case 6:
                updated = _context9.sent;
                _context9.next = 12;
                break;

              case 9:
                _context9.next = 11;
                return __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].inviteInfluencerToCampaign(pairingId, inviteData);

              case 11:
                updated = _context9.sent;

              case 12:
                influencer.isSuccess = true;
                _this16.sendings.push(influencer);

                if (_this16.sendings.length >= _this16.selectedInfluencers.length) {
                  _this16.isSending = false;
                  _this16.emailDialog = false;
                  _this16.getPairing(_this16.campaign.campaignId);
                }
                return _context9.abrupt('return', updated);

              case 18:
                _context9.prev = 18;
                _context9.t0 = _context9['catch'](1);

                influencer.isSuccess = false;
                _this16.sendings.push(influencer);
                throw _context9.t0;

              case 23:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this16, [[1, 18]]);
      }))();
    },
    sendBulkInvitation: function sendBulkInvitation(selectedInfluencers, templateId) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var inviteData, influencers, li;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (templateId) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return', _this17.$swal({
                  type: 'error',
                  text: 'Please select an email template'
                }));

              case 2:
                if (!(_this17.selectedFromEmail.length === 0)) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt('return', _this17.$swal({
                  type: 'error',
                  text: 'Please select from email'
                }));

              case 4:
                inviteData = {
                  templateId: templateId,
                  fromEmail: _this17.selectedFromEmail,
                  fromEmailName: 'Kobe'
                };
                influencers = _this17.influencers.filter(function (e) {
                  return selectedInfluencers.find(function (id) {
                    return id === e.id;
                  });
                });
                li = '';

                influencers.forEach(function (inf) {
                  li += '<li style=list-style:none !important;>' + ('<a target="_blank" href="https://instagram.com/' + inf.instagramHandle + '">@' + inf.instagramHandle + '</a>') + '</li>';
                });
                _this17.$swal({
                  title: '<strong>Confirmation</strong>',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Confirm',
                  html: 'The following influencers will be invited to this campaign? </br>' + '<ul>' + li + '</ul>'
                }).then(function (result) {
                  if (result.value) {
                    _this17.isSending = true;
                    _this17.sendings = [];
                    _this17.sendingInvitationDialog = true;
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selectedInfluencers), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var pairingId = _step3.value;

                        _this17.sendInvitation(pairingId, inviteData, false);
                      }
                    } catch (err) {
                      _didIteratorError3 = true;
                      _iteratorError3 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                          _iterator3.return();
                        }
                      } finally {
                        if (_didIteratorError3) {
                          throw _iteratorError3;
                        }
                      }
                    }
                  }
                });

              case 9:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this17);
      }))();
    },
    updateInvitedStatus: function updateInvitedStatus(selectedInfluencers) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var influencers, li;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                influencers = _this18.influencers.filter(function (e) {
                  return selectedInfluencers.find(function (id) {
                    return id === e.id;
                  });
                });
                li = '';

                influencers.forEach(function (inf) {
                  li += '<li style=list-style:none !important;>' + ('<a target="_blank" href="https://instagram.com/' + inf.instagramHandle + '">@' + inf.instagramHandle + '</a>') + '</li>';
                });
                _this18.$swal({
                  title: '<strong>Confirmation</strong>',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Confirm',
                  html: 'The following influencers will be invited to this campaign? </br>' + '<ul>' + li + '</ul>'
                }).then(function (result) {
                  if (result.value) {
                    _this18.isSending = true;
                    _this18.sendings = [];
                    _this18.sendingInvitationDialog = true;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                      for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selectedInfluencers), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var pairingId = _step4.value;

                        var data = {
                          pairingStatus: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.INVITED
                        };
                        _this18.sendInvitation(pairingId, data, true);
                      }
                    } catch (err) {
                      _didIteratorError4 = true;
                      _iteratorError4 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                          _iterator4.return();
                        }
                      } finally {
                        if (_didIteratorError4) {
                          throw _iteratorError4;
                        }
                      }
                    }
                  }
                });

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this18);
      }))();
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RejectModal_vue__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RejectModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RejectModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QandA_vue__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QandA_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__QandA_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CampaignInvite_InfluencerContractModal__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CampaignInvite_InfluencerContractModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CampaignInvite_InfluencerContractModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editor_generator_blocksToHtml__ = __webpack_require__(142);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignInviteDetail',
  data: function data() {
    return {
      campaignID: '',
      defaultMsg: 'Could not load invitation',
      pairingID: null,
      brief: {},
      payout: 0,

      status: null,
      deliverables: null,
      question: '',
      loadAllQuestoins: [],
      showRejectModal: false,
      rejectReasons: {},
      QandAComponentKey: 0,
      showUnderLine: false,
      briefDetailsHTML: '',
      showContractModal: false,
      influencerContract: {},
      isAgree: '',
      GST: ''
    };
  },

  components: {
    QandA: __WEBPACK_IMPORTED_MODULE_8__QandA_vue___default.a,
    RejectModal: __WEBPACK_IMPORTED_MODULE_7__RejectModal_vue___default.a,
    InfluencerContractModal: __WEBPACK_IMPORTED_MODULE_10__CampaignInvite_InfluencerContractModal___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    influencerID: function influencerID() {
      return this.$store.state.user.influencerID;
    },
    statusINVITED: function statusINVITED() {
      return this.pairingStatus.INVITED.value;
    },
    statusINTERESTED: function statusINTERESTED() {
      return this.pairingStatus.INTERESTED.value;
    },
    statusNOTINTERESTED: function statusNOTINTERESTED() {
      return this.pairingStatus.NOT_INTERESTED.value;
    },
    statusACCEPTED: function statusACCEPTED() {
      return this.pairingStatus.ACCEPTED.value;
    },
    statusNOTACCEPTED: function statusNOTACCEPTED() {
      return this.pairingStatus.NOT_ACCEPTED.value;
    },
    statusINQUIRY: function statusINQUIRY() {
      return this.pairingStatus.INQUIRY.value;
    },
    influencer: function influencer() {
      return this.$store.state.user.influencerID;
    },
    userID: function userID() {
      return this.$store.state.user.id;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  }),
  created: function created() {
    this.campaignID = this.$route.params.campaignID;
    if (!this.campaignID || !this.influencer) {
      this.$swal({
        type: 'error',
        text: 'Invalid campaign id'
      });
      return;
    }
    this.viewInvitation(this.campaignID, this.influencer);
    this.loadQuestions();
  },

  methods: {
    diplayAgreement: function diplayAgreement() {
      if (this.influencerContract.agreement !== undefined && this.influencerContract.agreement.isAgree !== undefined) {
        this.isAgree = this.influencerContract.agreement.isAgree;
      } else this.isAgree = 0;
    },
    forceRenderQandAComponent: function forceRenderQandAComponent() {
      this.QandAComponentKey += 1;
    },
    constructImage: function constructImage(imageName) {
      return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.constructImageURL(imageName);
    },
    viewInvitation: function viewInvitation(campaign, influencer) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var invitation, blocksTohtml, invitationObject, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].getInvitation(campaign, influencer);

              case 3:
                invitation = _context.sent;

                _this.brief = invitation.brief;
                _this.pairingID = invitation.id;
                _this.payout = invitation.payout;
                _this.amount = invitation.amount;
                _this.deliverables = invitation.deliverables;
                _this.status = invitation.status;
                _this.rejectReasons = invitation.reject_reasons ? invitation.reject_reasons : null;
                _this.GST = invitation.GST;

                if (invitation.brief_details) {
                  blocksTohtml = new __WEBPACK_IMPORTED_MODULE_11__editor_generator_blocksToHtml__["a" /* default */](invitation.brief_details.content);

                  _this.briefDetailsHTML = blocksTohtml.generate();
                  invitationObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, invitation);

                  invitationObject.campaignID = _this.$route.params.campaignID;
                  _this.influencerContract = invitationObject;
                }
                _this.diplayAgreement();
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);
                message = _context.t0 ? _context.t0.message || _this.defaultMsg : _this.defaultMsg;

                _this.$swal({
                  type: 'error',
                  text: message
                });

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16]]);
      }))();
    },
    doReject: function doReject() {
      this.showRejectModal = true;
    },
    closeRejectModal: function closeRejectModal() {
      this.showRejectModal = false;
    },
    doAction: function doAction(action) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var confirmed;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                confirmed = void 0;
                _context2.t0 = action;
                _context2.next = _context2.t0 === 'interested' ? 4 : _context2.t0 === 'not_interested' ? 8 : _context2.t0 === 'inquiry' ? 12 : 16;
                break;

              case 4:
                _context2.next = 6;
                return _this2.confirmationBox();

              case 6:
                confirmed = _context2.sent;
                return _context2.abrupt('break', 17);

              case 8:
                _context2.next = 10;
                return _this2.rejectionBox();

              case 10:
                confirmed = _context2.sent;
                return _context2.abrupt('break', 17);

              case 12:
                _context2.next = 14;
                return _this2.inquiryBox();

              case 14:
                confirmed = _context2.sent;
                return _context2.abrupt('break', 17);

              case 16:
                return _context2.abrupt('break', 17);

              case 17:
                if (confirmed) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt('return');

              case 19:
                _this2.updatStatus(action);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updatStatus: function updatStatus(action) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].doAction(_this3.pairingID, action);

              case 2:
                _context3.t0 = action;
                _context3.next = _context3.t0 === 'interested' ? 5 : _context3.t0 === 'not_interested' ? 7 : _context3.t0 === 'inquiry' ? 9 : 11;
                break;

              case 5:
                _this3.status = _this3.statusINTERESTED;
                return _context3.abrupt('break', 12);

              case 7:
                _this3.status = _this3.statusNOTINTERESTED;
                return _context3.abrupt('break', 12);

              case 9:
                _this3.status = _this3.statusINQUIRY;
                return _context3.abrupt('break', 12);

              case 11:
                return _context3.abrupt('break', 12);

              case 12:

                _this3.viewInvitation(_this3.campaignID, _this3.influencer);
                _this3.influencerStatusUpdateEmailToCo(action);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    influencerStatusUpdateEmailToCo: function influencerStatusUpdateEmailToCo(status) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  campaignID: _this4.$route.params.campaignID,
                  influencer: _this4.$store.state.user.firstName + ' ' + _this4.$store.state.user.lastName,
                  url: window.location.protocol + '//' + window.location.host + '/campaigns/invited-influencer',
                  template: 'influencer_status_update_campaign'
                };

                if (status === 'interested') {
                  params.subject = 'We have a response from ' + params.influencer + ' from ' + _this4.brief.campaignName + ' campaign';
                  params.message = 'has indicated that they are interested in ' + _this4.brief.campaignName + ' campaign. ';
                } else if (status === 'not_interested') {
                  params.subject = 'We have a response from ' + params.influencer + ' from ' + _this4.brief.campaignName + ' campaign';
                  params.message = 'has indicated that they are not interested in ' + _this4.brief.campaignName + ' campaign. Please get in touch accordingly.';
                }

                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].sendInfluencerStatusUpdateEmailToCO(params);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    saveQuestion: function saveQuestion() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var QuestionsData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                QuestionsData = {
                  'campaignID': _this5.$route.params.campaignID,
                  'userID': _this5.userID,
                  'influencerID': _this5.influencer,
                  'question': _this5.question,
                  'answers': []
                };
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].postQuestions(QuestionsData).then(function () {
                  _this5.forceRenderQandAComponent();
                  _this5.loadQuestions();
                  _this5.triggerEamilWithQuestion(_this5.question);
                  _this5.showUnderLine = true;
                });

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    triggerEamilWithQuestion: function triggerEamilWithQuestion(question) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {
                  campaignID: _this6.$route.params.campaignID,
                  influencer: _this6.$store.state.user.firstName + ' ' + _this6.$store.state.user.lastName,
                  url: window.location.protocol + '//' + window.location.host + '/influencers/pairing/' + _this6.pairingID,
                  type: 'question',
                  question: question
                };
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].triggerEmailToCO(params);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    loadQuestions: function loadQuestions() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var campaignID, allQuestions, questionArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, questionObj;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                campaignID = _this7.$route.params.campaignID;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].getQuestions(campaignID, _this7.influencer);

              case 3:
                allQuestions = _context7.sent;
                questionArray = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context7.prev = 8;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(allQuestions); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  questionObj = _step.value;

                  questionArray.push(questionObj);
                }
                _context7.next = 16;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context7.t0;

              case 16:
                _context7.prev = 16;
                _context7.prev = 17;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 19:
                _context7.prev = 19;

                if (!_didIteratorError) {
                  _context7.next = 22;
                  break;
                }

                throw _iteratorError;

              case 22:
                return _context7.finish(19);

              case 23:
                return _context7.finish(16);

              case 24:
                _this7.loadAllQuestoins = questionArray;

              case 25:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[8, 12, 16, 24], [17,, 19, 23]]);
      }))();
    },
    confirmationBox: function confirmationBox() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this8.$swal({
                  title: 'Thank you!',

                  html: '<p style=\'text-align:left;font-weight:400;\'>We have received your indication of interest, let us work on the confirmation with client.</p>\n               <p style=\'text-align:left;font-weight:400;\'>You will be receiving an official campaign brief and invoice upon confirmation here and via email.</p>',
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Ok'
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    rejectionBox: function rejectionBox() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.$swal({
                  title: 'Please confirm',
                  text: 'Are you sure to reject this opportunity?',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, Reject it!'
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    inquiryBox: function inquiryBox() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this10.$swal({
                  title: 'Ask your question',
                  text: 'What do you want to know about this campaign?',
                  input: 'textarea',
                  inputLabel: 'Question',
                  inputPlaceholder: 'Type your question here...',
                  inputAttributes: {
                    'aria-label': 'Type your question here'
                  },
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Ok',
                  inputValidator: function inputValidator(value) {
                    if (!value) {
                      return 'You need to write something!';
                    } else {
                      _this10.question = value;
                      _this10.saveQuestion();
                    }
                  }
                });

              case 2:
                result = _context10.sent;
                return _context10.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    closeInfluencerContractModal: function closeInfluencerContractModal() {
      this.showContractModal = false;
    },
    showAgreement: function showAgreement() {
      this.showContractModal = true;
    },
    didAgree: function didAgree() {
      this.isAgree = true;
      this.showContractModal = false;
    },
    didNotAgree: function didNotAgree() {
      this.isAgree = false;
      this.showContractModal = false;
    },
    formatPayout: function formatPayout(n) {
      if (n.toString().indexOf('-') !== -1) {
        var str = n.toString().split('-');
        return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.formatCurrency(parseFloat(str[0])) + ' - ' + str[1];
      } else {
        return __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.formatCurrency(parseFloat(n));
      }
    }
  }
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editor_generator_HTMLToPDF__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_editor__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'influencer_contract',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_10_vue2_editor__["a" /* VueEditor */]
  },
  props: ['dialogTitle', 'dialog', 'close', 'invoiceContract', 'contract', 'action', 'didAgree', 'didNotAgree', 'showTerms', 'showSendButton', 'showSubmitButton', 'showOptions', 'showDeclineButton', 'showCancelButton', 'isAgreement', 'emailTemplateHTML', 'updateEmailTemplate', 'content', 'briefDetailHTML', 'users', 'selectedUser', 'influencerEmail'],
  data: function data() {
    return {
      valid: true,
      tc: false,
      rowSpanCount: 0,
      showRowSpan: '',
      showDeliverables: false,
      agreement: '',
      alert: false,
      selectedTab: '',
      emailTemplateHTMLUpdated: '',
      downloadloading: false,
      customToolbar: [[{ header: [false, 1, 2, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'], [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }], ['blockquote', 'code-block'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ indent: '-1' }, { indent: '+1' }], [{ color: [] }, { background: [] }], ['link'], ['clean']],
      snackbar: false,
      snackbarTimeout: 2000,
      snackbarText: ''
    };
  },

  watch: {
    alert: function alert() {
      var _this = this;

      if (this.alert) {
        setTimeout(function () {
          _this.alert = false;
        }, 10000);
      }
    },
    emailTemplateHTML: function emailTemplateHTML(nVal) {
      var _this2 = this;

      this.showRowSpan = '';
      this.emailTemplateHTMLUpdated = nVal;
      this.showDeliverables = false;

      setTimeout(function () {
        _this2.showDeliverables = true;
      }, 500);
    }
  },
  computed: {
    logoUrl: function logoUrl() {
      return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].kobeLogoDataURL;
    },
    getRowSpanCount: function getRowSpanCount() {
      this.rowSpanCount = 0;
      if (this.contract.deliverables.no_of_carousels > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_igTv > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_tiktok_posts > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_xhs_posts > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_fb_posts > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_posts > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_stories > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_video > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_reels > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_li_posts > 0) this.rowSpanCount++;
      if (this.contract.deliverables.no_of_x_posts > 0) this.rowSpanCount++;
      if (this.contract.deliverables.youtube > 0) this.rowSpanCount++;
      if (this.contract.deliverables.loading_whitelisting) this.rowSpanCount++;
      if (this.contract.deliverables.exclusivity) this.rowSpanCount++;
      if (this.contract.deliverables.physical_attendance) this.rowSpanCount++;
      if (this.contract.deliverables.online_attendance) this.rowSpanCount++;
      if (this.contract.deliverables.custom) this.rowSpanCount += this.contract.deliverables.custom.length;

      return this.rowSpanCount;
    },
    chkPayoutGST: function chkPayoutGST() {
      var payout = this.contract.payout;

      if (this.contract.payout_details && this.contract.payout_details.boostingFees && Array.isArray(this.contract.payout_details.boostingFees)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.contract.payout_details.boostingFees), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var boostingFee = _step.value;

            payout -= Number(boostingFee.value) || 0;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (this.contract.GST) {
        return Number(payout - this.contract.GSTpercent).toFixed(2);
      } else {
        return Number(payout).toFixed(2);
      }
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    checkShowAmountRowSpan: function checkShowAmountRowSpan(type) {
      if (!this.showRowSpan) {
        this.showRowSpan = type;
        return true;
      } else if (this.showRowSpan === type) return true;
      return false;
    },
    sendClick: function sendClick() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = _this3.getRptOwnerCheckPayload(_this3.contract);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__campaignHelper__["a" /* default */].invokeReportOwnerCheck(_this3, payload);

              case 3:
                if (!(_this3.contract.influencer_details.platform !== undefined || !_this3.contract.influencer_details.contact_details.email)) {
                  _context.next = 9;
                  break;
                }

                if (!(_this3.contract.influencer_details.platform === 'tiktok' || !_this3.contract.influencer_details.contact_details.email)) {
                  _context.next = 9;
                  break;
                }

                if (_this3.influencerEmail) {
                  _context.next = 9;
                  break;
                }

                _this3.snackbarText = 'Please Enter Influencer Email!';
                _this3.snackbar = true;
                return _context.abrupt('return', false);

              case 9:
                _this3.updateEmailTemplate(_this3.emailTemplateHTMLUpdated);
                _this3.action(_this3.influencerEmail);
                _this3.close();

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD/MM/yyyy');
    },
    agreeClick: function agreeClick() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$refs.form.validate();

                if (!_this4.$refs.form.validate()) {
                  _context2.next = 6;
                  break;
                }

                data = {
                  pairingID: _this4.contract.id,
                  agreement: _this4.agreement
                };
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__["a" /* default */].updateContractAgreement(data);

              case 5:
                _this4.didAgree();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    declineClick: function declineClick() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = {
                  pairingID: _this5.contract.id,
                  agreement: false
                };
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__["a" /* default */].updateContractAgreement(data);

              case 3:
                _this5.didNotAgree();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    cancelClick: function cancelClick() {
      if (this.isAgreement) {
        this.alert = true;
      } else {
        this.$refs.form.reset();
        this.close();
      }
    },
    formatPayout: function formatPayout(n) {
      var currency = 'SGD';
      if (this.contract.currency) {
        currency = this.contract.currency;
      }
      currency = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.currencySym(currency);
      if (!n) return n;
      if (n.toString().indexOf('-') !== -1) {
        var str = n.toString().split('-');
        return currency + ' ' + parseFloat(str[0]) + ' - ' + str[1];
      } else {
        return currency + ' ' + parseFloat(n);
      }
    },

    hideRequiredActions: function hideRequiredActions() {
      return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.INFLUENCER !== this.currentUserRole;
    },
    download: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var vm, reportName, htmlToPdf, pdfData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                vm = this;

                this.downloadloading = true;
                reportName = '';

                reportName += this.contract.brief ? this.contract.brief.campaignName + '_' : '';
                reportName += this.contract.influencer_details ? this.contract.influencer_details.userHandle + '_' : '';

                if (!(this.selectedTab === 0)) {
                  _context4.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake_js__["createPdf"](vm.invoiceContract).download(reportName + 'invoice.pdf');

                this.downloadloading = false;
                _context4.next = 17;
                break;

              case 10:
                if (!(this.selectedTab === 1)) {
                  _context4.next = 17;
                  break;
                }

                htmlToPdf = new __WEBPACK_IMPORTED_MODULE_7__editor_generator_HTMLToPDF__["a" /* default */](this.briefDetailHTML, 'Arial');
                _context4.next = 14;
                return htmlToPdf.generate();

              case 14:
                pdfData = _context4.sent;

                __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake_js__["createPdf"](pdfData).download(reportName + 'brief.pdf');

                this.downloadloading = false;

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function download() {
        return _ref.apply(this, arguments);
      }

      return download;
    }(),
    getRptOwnerCheckPayload: function getRptOwnerCheckPayload(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        campaignID: item.CampaignID,
        handle: item.influencer_details ? item.influencer_details.userHandle : null,
        platform: item.influencer_details ? item.influencer_details.platform : null
      });
    },
    formatDesc: function formatDesc(text) {
      return text.replaceAll('\n', '</br>');
    }
  },
  mounted: function mounted() {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake_js__["fonts"] = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      };
    }, 1000);
  }
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pairing_pairingAPIs__ = __webpack_require__(28);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QandA',
  props: ['Questions', 'campaignID', 'influencerID', 'TriggerEmail', 'pairedID'],
  data: function data() {
    return {
      questionUserProfile: {
        usrId: '',
        displayName: '',
        avatar: ''
      },
      answerUserProfile: {
        usrId: '',
        displayName: '',
        avatar: ''
      },
      comment: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['userInfo', 'user']), {
    activeUser: function activeUser() {
      return {
        displayName: this.user.firstName + ' ' + this.user.lastName,
        avatar: this.user.profilePicture ? this.user.profilePicture : '/static/img/avatar/user.png',
        email: this.user.email,
        createdAt: __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.user.createdAt).format('MMM D, YYYY'),
        role: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userRolesDetails'][this.user.role]['display'],
        id: this.user.id
      };
    }
  }),
  mounted: function mounted() {
    this.loadQuestions();
  },

  methods: {
    createdDate: function createdDate(val) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(val).format('MMM DD, yyyy hh:mm');
    },
    loadQuestions: function loadQuestions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var allQuestions, questionArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, questionObj;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__Pairing_pairingAPIs__["a" /* default */].getQuestions(_this.campaignID, _this.influencerID);

              case 2:
                allQuestions = _context.sent;
                questionArray = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(allQuestions); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  questionObj = _step.value;

                  questionArray.push(questionObj);
                }
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 15:
                _context.prev = 15;
                _context.prev = 16;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 18:
                _context.prev = 18;

                if (!_didIteratorError) {
                  _context.next = 21;
                  break;
                }

                throw _iteratorError;

              case 21:
                return _context.finish(18);

              case 22:
                return _context.finish(15);

              case 23:
                _this.Questions = questionArray;
                if (_this.Questions.length > 0) {
                  _this.getUserProfile(_this.Questions[0].userID);
                }

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }))();
    },
    getUserProfile: function getUserProfile(userID) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userProfile;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getUser(userID);

              case 2:
                userProfile = _context2.sent;

                _this2.questionUserProfile.userId = userProfile.id;
                _this2.questionUserProfile.avatar = userProfile.profilePicture ? userProfile.profilePicture : '/static/img/avatar/user.png';
                _this2.questionUserProfile.displayName = userProfile.firstName + ' ' + userProfile.lastName;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAnswerUserProfile: function getAnswerUserProfile(userID) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userProfile;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getUser(userID);

              case 2:
                userProfile = _context3.sent;

                _this3.answerUserProfile.userId = userProfile.id;
                _this3.answerUserProfile.avatar = userProfile.profilePicture ? userProfile.profilePicture : '/static/img/avatar/user.png';
                _this3.answerUserProfile.displayName = userProfile.firstName + ' ' + userProfile.lastName;

                return _context3.abrupt('return', { avatar: _this3.answerUserProfile.avatar, displayName: _this3.answerUserProfile.displayName });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    replyClick: function replyClick(index) {
      var replyDiv = document.getElementById('reply_question_' + index);
      var replyBtn = document.getElementById('reply_question_btn_' + index);
      replyDiv.classList.add('active');
      replyBtn.classList.add('noActive');
    },
    cancelClick: function cancelClick(index) {
      var replyDiv = document.getElementById('reply_question_' + index);
      var replyBtn = document.getElementById('reply_question_btn_' + index);
      replyDiv.classList.remove('active');
      replyBtn.classList.remove('noActive');
      this.comment = '';
    },
    submitClick: function submitClick(index) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var answersArray, commentObj, i, params;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                answersArray = [];
                commentObj = {
                  id: _this4.user.id,
                  profilePicture: _this4.activeUser.avatar,
                  profileName: _this4.activeUser.displayName,
                  comment: _this4.comment,
                  createdAt: Date.now()
                };

                if (_this4.Questions[index].answers.length > 0) {
                  for (i = 0; i < _this4.Questions[index].answers.length; i++) {
                    answersArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(answersArray), [_this4.Questions[index].answers[i]]);
                  }
                  answersArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(answersArray), [commentObj]);
                } else answersArray.push(commentObj);

                params = {
                  id: _this4.Questions[index].id,
                  answers: answersArray
                };
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__Pairing_pairingAPIs__["a" /* default */].putComment(params);

              case 6:
                _this4.loadQuestions();
                if (_this4.TriggerEmail) {
                  _this4.triggerEmail(_this4.Questions[index].question, _this4.comment);
                }
                _this4.cancelClick(index);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    triggerEmail: function triggerEmail(question, reply) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var params, _params;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this5.activeUser.role.toLowerCase() === 'influencer')) {
                  _context5.next = 6;
                  break;
                }

                params = {
                  campaignID: _this5.campaignID,
                  influencer: _this5.activeUser.displayName,
                  url: window.location.protocol + '//' + window.location.host + '/influencers/pairing/' + _this5.pairedID,
                  type: 'reply',
                  question: question,
                  reply: reply
                };
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__Pairing_pairingAPIs__["a" /* default */].triggerEmailToCO(params);

              case 4:
                _context5.next = 9;
                break;

              case 6:
                _params = {
                  influencerId: _this5.influencerID,
                  campaignID: _this5.campaignID,
                  influencer: _this5.activeUser.displayName,
                  url: window.location.protocol + '//' + window.location.host + '/campaigns/' + _this5.campaignID + '/invitation',
                  type: 'reply',
                  question: question,
                  reply: reply
                };
                _context5.next = 9;
                return __WEBPACK_IMPORTED_MODULE_9__Pairing_pairingAPIs__["a" /* default */].triggerEmailToInfluencer(_params);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pairing_pairingAPIs__ = __webpack_require__(28);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Reject_Modal',
  props: ['dialog', 'close', 'pairingID', 'updateStatus'],
  data: function data() {
    return {
      campaign_proposed: '',
      campaign_timeline: '',
      payout_issue: '',
      payout_issue_file: '',
      competitor: '',
      not_associate: '',
      others: '',
      errors: false,
      errorMessage: 'Pick at least one to reject.'
    };
  },

  methods: {
    clearState: function clearState() {
      this.campaign_proposed = '';
      this.campaign_timeline = '';
      this.payout_issue = '';
      this.competitor = '';
      this.not_associate = '';
      this.errors = false;
      this.others = '';
    },
    validForm: function validForm() {
      var valid = true;
      if (this.campaign_proposed === '' && this.campaign_timeline === '' && this.payout_issue === '' && this.competitor === '' && this.not_associate === '' && this.others === '') {
        this.errors = true;
        valid = false;
      }
      return valid;
    },
    cancel: function cancel() {
      this.clearState();
      this.close();
    },
    reject: function reject() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.validForm()) {
                  _context.next = 13;
                  break;
                }

                formData = {};

                if (_this.campaign_proposed) {
                  formData.campaign_proposed = _this.campaign_proposed;
                }

                if (_this.campaign_timeline) {
                  formData.campaign_timeline = _this.campaign_timeline;
                }

                if (_this.payout_issue) {
                  formData.payout_issue = _this.payout_issue;
                }

                if (_this.competitor) {
                  formData.competitor = _this.competitor;
                }

                if (_this.not_associate) {
                  formData.not_associate = _this.not_associate;
                }

                if (_this.others) {
                  formData.others = _this.others;
                }
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_2__Pairing_pairingAPIs__["a" /* default */].doReject(_this.pairingID, { reason: formData });

              case 10:
                _this.updateStatus('not_interested');
                _this.close();
                _this.clearState();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewPostModal__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewPostModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ViewPostModal__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-ongoing',
  components: {
    ViewPairingBriefDetailedModal: __WEBPACK_IMPORTED_MODULE_4__ViewPairingBriefDetailedModal___default.a,
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_5__ViewPostModal___default.a
  },
  data: function data() {
    return {
      campaignStatus: this.$route.meta.campaignStatus,
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      campaigns: [],
      viewRateCardData: 0,
      influencerID: '',
      keyword: '',
      fields: [{
        key: 'pairingStatusDisplay',
        label: 'Status'
      }, {
        key: 'name'
      }, {
        key: 'updatedAt'
      }, {
        key: 'actions'
      }],
      viewCampaignData: null,
      viewPostCampaignData: null
    };
  },
  created: function created() {
    this.paginate(1);
    this.userID = this.$store.state.user.id;
    this.influencerID = this.getInfluencerID(this.userID);
  },

  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    }
  },
  methods: {
    paginate: function paginate() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].paginate({
        page: page,
        per_page: this.perPage,
        status: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER + ',' + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.ONGOING,
        pairingStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].pairingStatus.INTERESTED,
        keyword: this.keyword,
        sort: 'updatedAt DESC',
        hasInstagramURL: false
      }).then(function (response) {
        var campaigns = response.campaigns;

        campaigns = campaigns.map(function (item) {
          item.pairingStatusDisplay = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].pairingStatusDisplay[item.status];
          item.updatedAt = _this.formatTime(item.updatedAt);
          return item;
        });

        _this.campaigns = campaigns;
        _this.totalRows = response.totalCampaigns;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getInfluencerID: function getInfluencerID(userID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getInfluencerID(userID).then(function (response) {
        _this2.influencerID = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getRateCardDataToView: function getRateCardDataToView(campaignID, influencerID) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getRateCard(campaignID, influencerID).then(function (response) {
        if (response === []) {
          _this3.viewRateCardData = 0;
        } else {
          _this3.viewRateCardData = response[0].approvedRateCard;
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this4.viewCampaignData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    approveCampaign: function approveCampaign(campaignID) {
      var _this5 = this;

      var campaignConfirmation = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignConfirmation.approval[this.campaignStatus];

      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].approveCampaign(campaignID, _this5.campaignStatus).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this5.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this5.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this5.paginate(1);

          _this5.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatusFlow['approve'][_this5.campaignStatus],
            data: null
          });

          _this5.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    buttonShowPairing: function buttonShowPairing(pairingStatus) {
      return pairingStatus === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].pairingStatus.INVITED;
    },
    rejectCampaign: function rejectCampaign(campaignID) {
      var _this6 = this;

      var campaignConfirmation = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignConfirmation.reject[this.campaignStatus];

      this.$swal({
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].rejectCampaign(campaignID, _this6.campaignStatus).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this6.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this6.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this6.paginate(true);

          _this6.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatusFlow['reject'][_this6.campaignStatus],
            data: null
          });

          _this6.$swal({
            title: campaignConfirmation['confirm']['title'],
            text: campaignConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    acceptInvite: function acceptInvite(pairingID) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].acceptInvite(pairingID).then(function (response) {
        _this7.paginate(1);

        _this7.$store.commit('SET_CAMPAIGNS', {
          campaignStatus: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].campaignStatusFlow['approve'][_this7.campaignStatus],
          data: null
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getPostDataToView: function getPostDataToView(campaignData) {
      this.viewPostCampaignData = campaignData;
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Finance_paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PayoutVerificationModal_vue__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PayoutVerificationModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__PayoutVerificationModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Finance_PayoutScreenshotsDialog_vue__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Finance_PayoutScreenshotsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Finance_PayoutScreenshotsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReportInternal_ReportPayoutLists__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReportInternal_ReportPayoutLists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ReportInternal_ReportPayoutLists__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignPayoutInternal',
  components: {
    PayoutVerificationModal: __WEBPACK_IMPORTED_MODULE_14__PayoutVerificationModal_vue___default.a,
    PayoutScreenshotsDialog: __WEBPACK_IMPORTED_MODULE_15__Finance_PayoutScreenshotsDialog_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker___default.a,
    ReportPayoutLists: __WEBPACK_IMPORTED_MODULE_16__ReportInternal_ReportPayoutLists___default.a
  },
  data: function data() {
    return {
      headers: [{ value: 'handle', text: 'Handle', sortable: true }, { value: 'campaignName', text: 'Campaign', sortable: true }, { value: 'createdAt', text: 'Submitted date', sortable: true }, { value: 'satisfaction_level_on_kobe', text: 'Satisfication Level on Kobe', sortable: true }, { value: 'satisfaction_level_on_advertiser', text: 'Satisfication Level on Client', sortable: true }, { value: 'promotingProducts', text: 'What do you like most about this product/service you are promoting?', sortable: true }, { value: 'improved', text: 'What are areas of improvement about this product/service that will be valuable feedback for them?', sortable: true }, { value: 'audienceEnjoyment', text: 'What do you think your audience enjoyed about your content?', sortable: true }, { value: 'otherCampaigns', text: 'What other campaigns would you want to work more on with us?', sortable: true }, { value: 'action', text: 'Actions' }],
      items: [],
      filteredItems: [],
      moneyouts: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      refreshPayouts: 1,
      filter: null,
      payoutViewDialog: false,
      payoutViewData: null,
      viewScreenShotsDialog: false,
      imagesToView: [],
      imageViewerDialog: false,
      activeImage: '',
      searchFilters: {},
      campaignFilterLists: [],
      subDateCal: false,
      dueDateCal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    hasPosts: function hasPosts() {
      if (this.imagesToView.posts && this.imagesToView.posts.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.imagesToView.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var post = _step.value;

            if (post.instagramPostURL !== '' || post.images && post.images.length > 0) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return false;
    },
    hasStories: function hasStories() {
      if (this.imagesToView.stories && this.imagesToView.stories.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.imagesToView.stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var post = _step2.value;

            if (post.label !== '' || post.images && post.images.length > 0) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return false;
    },
    hasDeliverablePosts: function hasDeliverablePosts() {
      if (this.imagesToView.deliverablePosts && this.imagesToView.deliverablePosts.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.imagesToView.deliverablePosts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var allPosts = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(allPosts.posts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var post = _step4.value;

                if (post.label !== '' || post.images && post.images.length > 0) {
                  return true;
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return false;
    }
  }),
  methods: {
    viewMedia: function viewMedia(img) {
      this.activeImage = img;
      this.imageViewerDialog = true;
    },
    viewImages: function viewImages(item) {
      this.imagesToView = item;
      this.viewScreenShotsDialog = true;
    },
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */]['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    verifyPayout: function verifyPayout(payout) {
      this.payoutViewData = payout;
      this.payoutViewDialog = true;
    },
    updateItems: function updateItems(newItems) {
      this.items = newItems;
      this.totalRows = this.items.length;
      this.setFilteredItems();
      this.filterbyDates();
    },
    getAllCampaignPayouts: function getAllCampaignPayouts() {
      var _this = this;

      this.getAllMoneyOuts();
      __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].getAllCampaignPayouts(this.searchFilters).then(function (response) {
        var campaignPayouts = response.data;

        var displayItems = campaignPayouts.map(function (element) {
          var moneyOut = _this.moneyouts.find(function (m) {
            return m.payoutID && m.payoutID === element.id;
          });
          var resultData = {
            campaignName: element.campaignName,
            postID: element.postID,
            influencerID: element.influencerID,
            collaboration: element.collaboration || null,
            improved: element.improved || null,
            promotingProducts: element.promotingProducts || null,
            audienceEnjoyment: element.audienceEnjoyment || null,
            otherCampaigns: element.otherCampaigns || null,
            other_social_media_post_url: element.otherSocialMediaPostUrl,
            satisfaction_level_on_campaign: element.satisfactionLevel,
            satisfaction_level_on_kobe: element.kobeSatisfactionLevel,
            satisfaction_level_on_advertiser: element.advertiserSatisfactionLevel || 0,
            createdAt: element.createdAt,
            toMakePaymentAt: __WEBPACK_IMPORTED_MODULE_8_moment___default()(element.createdAt).add(30, 'days').format(),
            payoutAmount: element.payoutAmount || '',

            images: element.images || [],
            posts: element.posts || [],
            stories: element.stories || [],
            deliverablePosts: element.deliverablePosts || [],
            uploadMedias: element.uploadMedias || []
          };
          if (element.tiktok) {
            resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : '';
            resultData.fullName = element.tiktok ? element.tiktok.tiktokFullname : '';
            resultData.tiktok_post_url = element.tiktokPostURL;
            resultData.platform = 'tiktok';
          }
          if (element.instagram) {
            if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(element.instagram) === 'object') {
              resultData.handle = element.instagram ? element.instagram.instagramHandle : '';
              resultData.fullName = element.instagram ? element.instagram.instagramFullname : '';
              resultData.instagram_post_url = element.instagramPostURL;
              resultData.platform = 'instagram';
            }
            if (typeof element.instagram === 'string') {
              resultData.handle = element.instagram;
              resultData.platform = 'instagram';
            }
          }
          if (!resultData.handle) {
            if (element.handle) {
              resultData.handle = element.handle;
              resultData.platform = element.platform || 'instagram';
              resultData.xhsID = element.xhsID || '';
            }
          }
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
            id: element.id,
            campaignID: element.campaignID,
            postID: element.postID
          }, resultData, { moneyOut: moneyOut });
        });

        _this.updateItems(displayItems);
        _this.lastUpdate = response.lastUpdate;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    exportCampaignPayouts: function exportCampaignPayouts() {
      __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].exportAllCampaignPayouts().then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'campaign_payouts_' + __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('X') + '.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        console.log(error);
      });
    },

    calDaysLeft: function calDaysLeft(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()().to(date);
    },
    changeDateFormat: function changeDateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('DD-MM-YYYY');
    },
    getAllMoneyOuts: function getAllMoneyOuts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__Finance_paymentAPIs__["a" /* default */].getAllPayouts();

              case 2:
                resp = _context.sent;

                if (resp.success) {
                  _this2.moneyouts = resp.data.outcomes;
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    disableViewScreenshot: function disableViewScreenshot(item) {
      return !item.images.length > 0 && !item.posts.length > 0 && !item.stories.length > 0 && !item.deliverablePosts.length > 0;
    },
    getCampaigns: function getCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var filter;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filter = {
                  statuses: [__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER, __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignStatus.ONGOING]
                };
                _context2.next = 3;
                return _this3.$store.dispatch('campaign/getCampaigns', filter);

              case 3:
                _this3.campaignFilterLists = [{ id: '', name: 'All Campaigns' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.campaigns));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    filterbyDates: function filterbyDates() {
      var _this4 = this;

      if (this.searchFilters.submissionDate) {
        this.filteredItems = this.items.filter(function (item) {
          return __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === _this4.searchFilters.submissionDate;
        });
      }
      if (this.searchFilters.dueDate) {
        var filterDueDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.searchFilters.dueDate).subtract(30, 'days').format('YYYY-MM-DD');
        this.filteredItems = this.items.filter(function (item) {
          return __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === filterDueDate;
        });
      }
    },
    setSubmissionDateFilter: function setSubmissionDateFilter(value) {
      this.searchFilters.submissionDate = value;
      this.setFilteredItems();
      this.filterbyDates();
    },
    setDueDateFilter: function setDueDateFilter(value) {
      this.searchFilters.dueDate = value;
      this.setFilteredItems();
      this.filterbyDates();
    },
    setFilteredItems: function setFilteredItems() {
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.items);
    },
    reload: function reload() {
      if (this.searchFilters.campaignID) {
        this.refreshPayouts += 1;
      } else {
        this.getAllCampaignPayouts();
        this.resetFilters();
      }
    },
    resetFilters: function resetFilters() {
      this.searchFilters.submissionDate = '';
      this.searchFilters.dueDate = '';
      this.filter = '';
    },
    downloadInvoice: function downloadInvoice(item) {
      console.log(item);
      if (item.uploadMedias.length) {
        var mediaOne = item.uploadMedias[0];
        __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.downloadFile(item.handle, mediaOne.url);
      }
    }
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this5.$route.query.influencerID) {
                _this5.searchFilters.influencerID = _this5.$route.query.influencerID;
              }
              if (_this5.$route.query.campaignID) {
                _this5.searchFilters.campaignID = _this5.$route.query.campaignID;
              }
              if (_this5.$route.query.verified) {
                _this5.searchFilters.verified = _this5.$route.query.verified;
              }
              _this5.getAllCampaignPayouts();
              _this5.getCampaigns();

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a },
  data: function data() {
    return {
      isLoading: false,
      campaignList: [] };
  },
  mounted: function mounted() {
    this.fetchCampaignList();
  },

  methods: {
    fetchCampaignList: function fetchCampaignList() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].getAllCampaigns(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].campaignStatus.ONGOING + ',' + __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].campaignStatus.REVIEW + ',' + __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].campaignStatus.COMPLETE, true).then(function (response) {
        var results = [];
        response.data.campaigns.forEach(function (element) {
          var campaign = {
            name: element.name,
            id: element.id
          };
          results.push(campaign);
        });
        _this.campaignList = results.sort(function (a, b) {
          if (a.name > b.name) {
            return -1;
          }
          if (a.name < b.name) {
            return 1;
          }
          return 0;
        });
        _this.isLoading = false;
      }).catch(function (err) {
        console.log('Error:' + err);
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__charts_LineChart_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scoped_campaign_AddPostToCampaign__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scoped_campaign_AddPostToCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__scoped_campaign_AddPostToCampaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_gdrive_GDrivePostView__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_gdrive_GDrivePostView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__scoped_gdrive_GDrivePostView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_campaign_EditReportHandleModal__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_campaign_EditReportHandleModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__scoped_campaign_EditReportHandleModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ViewCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_campaign_UpdateInsightsModal__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_campaign_UpdateInsightsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__scoped_campaign_UpdateInsightsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ReportGroupModal__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ReportGroupModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ReportGroupModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reports_CampaignSummary__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reports_CampaignSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__reports_CampaignSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__scoped_custom_CustomMedia__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__scoped_custom_CustomMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__scoped_custom_CustomMedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reports_InstagramPostEmbed_vue__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reports_InstagramPostEmbed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__reports_InstagramPostEmbed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ReportInternal_ReportPayoutLists__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ReportInternal_ReportPayoutLists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__ReportInternal_ReportPayoutLists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reports_ReportForSummary_vue__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__reports_ReportForSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__reports_ReportForSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CampaignSettingsModal__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CampaignSettingsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__CampaignSettingsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ReportInternal_ViewPostCommentsModal__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ReportInternal_ViewPostCommentsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__ReportInternal_ViewPostCommentsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_sortablejs__ = __webpack_require__(302);














































/* harmony default export */ __webpack_exports__["default"] = ({
  components: { InstagramPostEmbed: __WEBPACK_IMPORTED_MODULE_33__reports_InstagramPostEmbed_vue___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_14__charts_LineChart_js__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay___default.a, AddPostToCampaign: __WEBPACK_IMPORTED_MODULE_24__scoped_campaign_AddPostToCampaign___default.a, ViewPostCommentsModal: __WEBPACK_IMPORTED_MODULE_41__ReportInternal_ViewPostCommentsModal___default.a, ViewCampaignModal: __WEBPACK_IMPORTED_MODULE_28__ViewCampaignModal___default.a, TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_36__components_scoped_custom_TableColsShowHideModal___default.a, UpdateInsightsModal: __WEBPACK_IMPORTED_MODULE_29__scoped_campaign_UpdateInsightsModal___default.a, ReportGroupModal: __WEBPACK_IMPORTED_MODULE_30__ReportGroupModal___default.a, EditReportHandleModal: __WEBPACK_IMPORTED_MODULE_26__scoped_campaign_EditReportHandleModal___default.a, CampaignSettings: __WEBPACK_IMPORTED_MODULE_37__CampaignSettingsModal___default.a, CampaignSummary: __WEBPACK_IMPORTED_MODULE_31__reports_CampaignSummary___default.a, draggable: __WEBPACK_IMPORTED_MODULE_39_vuedraggable___default.a, GDrivePostView: __WEBPACK_IMPORTED_MODULE_25__scoped_gdrive_GDrivePostView___default.a, CustomMedia: __WEBPACK_IMPORTED_MODULE_32__scoped_custom_CustomMedia___default.a, ReportPayoutLists: __WEBPACK_IMPORTED_MODULE_34__ReportInternal_ReportPayoutLists___default.a, ReportForSummary: __WEBPACK_IMPORTED_MODULE_35__reports_ReportForSummary_vue___default.a },
  data: function data() {
    return {
      postInsightdialog: false,
      campaignSettingsDialog: false,
      updatePostInsightsData: null,
      respData: null,

      reportChartData: {
        labels: [],
        datasets: []
      },
      options: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false
      },

      selectedPostIds: new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default.a(),

      posts: [],
      filteredPosts: [],
      postTypes: __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].getDeliverableNames(),
      postType: '',

      campaignDataView: null,
      campaignData: null,
      viewCampaignData: null,
      viewCampaignModalDialog: false,
      reportHistory: [],
      client: {},
      addPostToCampaign: false,

      summary: {},
      isLoading: false,
      display: '',

      campaignList: [],

      selectedCampaignID: null,

      lineUpItems: [],
      lineUpGroupItems: [],
      campaignPayouts: [],
      campaignPayout: null,
      payoutUploads: [],
      disableSaveArrange: true,
      swtRevenue: 'content',
      revenueSubText: 'by content',
      headers: [{ value: 'instagram', text: 'Handle', sortable: true, class: 'report-handle-column', cellClass: 'report-handle-column' }, { value: 'media_url', text: 'Content Link', sortable: true }, { value: 'typeName', text: 'Content Type', sortable: true }, { value: 'live_date', text: 'Live Date', sortable: true }, { value: 'outreach', text: 'Outreach', sortable: true }, { value: 'due_date', text: 'Due Date', sortable: true }, { value: 'tier', text: 'Tier', sortable: true }, { value: 'engagement', text: 'Engagement', sortable: true }, { value: 'newEngagementRate', text: 'Engagement Rate (by Outreach)', sortable: true }, { value: 'engagementRateSD', text: 'Avg. Engagement Rate', sortable: true }, { value: 'medianEngagement', text: 'Median Engagement Rate', sortable: true }, { value: 'avgLikes', text: 'Average Likes', sortable: true }, { value: 'avgComments', text: 'Average Comments', sortable: true }, { value: 'avgWatchTime', text: 'Average Watch Time', sortable: true }, { value: 'avgViews', text: 'Average Views', sortable: true }, { value: 'plays', text: 'Total Play Time', sortable: true }, { value: 'likes', text: 'Likes', sortable: true }, { value: 'comments', text: 'Comments', sortable: true }, { value: 'bookmarks', text: 'Bookmarks', sortable: true }, { value: 'shares', text: 'Shares', sortable: true }, { value: 'views', text: 'Plays', sortable: true }, { value: 'impressions', text: 'Impressions', sortable: true }, { value: 'reach', text: 'Accounts reached', sortable: true }, { value: 'storyExits', text: 'Story Exits', sortable: true }, { value: 'storyImpressions', text: 'Story Impressions', sortable: true }, { value: 'storyReach', text: 'Story Reach', sortable: true }, { value: 'storyReplies', text: 'Story Replies', sortable: true }, { value: 'storyTapsBack', text: 'Story Taps Back', sortable: true }, { value: 'storyTapsForward', text: 'Story Taps Forward', sortable: true }, { value: 'storyShares', text: 'Story Shares', sortable: true }, { value: 'storyLinkClicks', text: 'Story Link Clicks', sortable: true }, { value: 'storyStickerTaps', text: 'Story Sticker Taps', sortable: true }, { value: 'playRateByOutreach', text: 'Play Rate (by Outreach)', sortable: true }, { value: 'interactionRatePlays', text: 'Engagement Rate by Plays', sortable: true }, { value: 'engRateReach', text: 'Engagement Rate (by Account Reached)', sortable: true }, { value: 'payment_status', text: 'Payment Status', sortable: true }, { value: 'action', text: 'Actions', sortable: false, groupable: false }],
      defaultHideCols: ['tier', 'engagement', 'newEngagementRate', 'engagementRateSD', 'medianEngagement', 'avgLikes', 'avgComments', 'avgWatchTime', 'avgViews', 'plays', 'likes', 'comments', 'bookmarks', 'shares', 'views', 'impressions', 'reach', 'storyExits', 'storyImpressions', 'storyReach', 'storyReplies', 'storyTapsBack', 'storyTapsForward', 'storyShares', 'storyLinkClicks', 'storyStickerTaps', 'playRateByOutreach', 'interactionRatePlays', 'engRateReach'],
      selectedPosts: [],
      liveDates: [],
      imsStatuses: __WEBPACK_IMPORTED_MODULE_18__config__["a" /* default */].imsStatuses,
      totalCounts: {
        contents: 0,
        outreach: 0,
        amount: 0
      },
      reportGroupDialog: false,
      disableSaveEdit: true,
      searchFilter: '',
      campaignHelper: __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */],
      cldConfig: __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].cldConfig,
      cld: null,
      searchMonth: '',
      selectedMonth: '',
      monthPicker: false,
      reviewers: new __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default.a(),
      editReportHandleDialog: false,
      editHandleReport: null,
      tableColsItems: [],
      colStatuses: {},
      colSettingsDialog: false,

      scrapedCommentsDialog: false,
      currentScrapedComments: null,
      currentPostToScrape: null,

      isScrapLoading: false,

      scrapingStatusMessage: '',

      viewCommentsDialog: false,
      selectedPostComments: [] };
  },

  watch: {
    selectedCampaignID: function selectedCampaignID(value) {
      this.getCampaignReport(value, false);
      this.getAllCampaignPayouts();
    },
    display: function display(oldValue, newValue) {
      if (oldValue !== '' && newValue !== '') {
        if (newValue === 1) {
          this.setPostIds();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();
              _this.fetchCampaignList();
              _context.next = 4;
              return _this.getUserProfile();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    isLinkedInReport: function isLinkedInReport(post) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__["c" /* isLinkedInReport */])(post);
    },
    isTwitterReport: function isTwitterReport(post) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__["d" /* isTwitterReport */])(post);
    },
    getAccountProfileUrl: function getAccountProfileUrl(post) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__["b" /* getReportProfileUrl */])(post, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__["a" /* getReportPlatform */])(post) || (post.isTikTok ? 'tiktok' : 'instagram'));
    },
    getLinkedInProfileUrl: function getLinkedInProfileUrl(handle) {
      var value = String(handle || '').trim();
      if (/^https?:\/\/(?:www\.)?linkedin\.com\/in\//i.test(value)) return value;
      var profileMatch = value.match(/(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i);
      var profileHandle = (profileMatch ? profileMatch[1] : value).replace(/^@+/, '').replace(/^\/+|\/+$/g, '');
      return profileHandle ? 'https://www.linkedin.com/in/' + encodeURIComponent(profileHandle) : '#';
    },
    getReportPostUrl: function getReportPostUrl(post) {
      if (!post) return '';
      var rawUrl = post.postLink || post.postURL || post.post_details || '';
      return typeof rawUrl === 'string' ? rawUrl : rawUrl.link || rawUrl.url || rawUrl.href || '';
    },
    getLinkedInEmbedUrl: function getLinkedInEmbedUrl(post) {
      if (!post) return '';
      var postUrl = this.getReportPostUrl(post);
      if (!postUrl) return '';
      if (/^https:\/\/www\.linkedin\.com\/embed\/feed\/update\//i.test(postUrl)) return postUrl;
      var decodedUrl = postUrl;
      try {
        decodedUrl = decodeURIComponent(postUrl);
      } catch (error) {
        decodedUrl = postUrl;
      }
      var urnMatch = decodedUrl.match(/urn:li:(activity|share|ugcPost):(\d+)/i);
      var publicPostMatch = decodedUrl.match(/\/posts\/[^?#]*-(activity|share|ugcPost)-(\d+)(?:-[^/?#]+)?\/?(?:[?#]|$)/i);
      var postIdentifier = urnMatch || publicPostMatch;
      if (!postIdentifier) return '';
      var urnType = postIdentifier[1].toLowerCase() === 'ugcpost' ? 'ugcPost' : postIdentifier[1].toLowerCase();
      return 'https://www.linkedin.com/embed/feed/update/urn:li:' + urnType + ':' + postIdentifier[2];
    },
    getTwitterEmbedUrl: function getTwitterEmbedUrl(post) {
      if (!post) return '';
      var postUrl = this.getReportPostUrl(post);
      var match = String(postUrl).match(/(?:x|twitter)\.com\/[^/?#]+\/status\/(\d+)/i);
      return match ? 'https://platform.twitter.com/embed/Tweet.html?id=' + match[1] + '&theme=dark' : '';
    },
    MEDIA_URL_TYPE: function MEDIA_URL_TYPE(mediaUrl) {
      var videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4'];
      var images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP'];
      if (!mediaUrl) return '';
      if (!mediaUrl.includes('http') || !mediaUrl.includes('.com') || !mediaUrl.includes('www')) return '';
      var url = new URL(mediaUrl);
      var extension = url.pathname.split('.')[4];
      if (videos.includes(extension)) {
        return 'video';
      } else if (images.includes(extension)) {
        return 'image';
      } else if (url.hostname === 'drive.google.com') {
        if (__WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].isAOKCampaign(this.campaignData.campaignType)) {
          return 'driveView';
        }
        return 'iframe';
      } else if (url.hostname === 'res.cloudinary.com') {
        return 'cld';
      }
    },
    updatePostInsightsHandler: function updatePostInsightsHandler(post) {
      var _this2 = this;

      this.updatePostInsightsData = post;
      this.campaignPayout = null;
      if (this.campaignPayouts) {
        this.campaignPayouts.forEach(function (cPayout) {
          if (cPayout.handle === post.instagram || cPayout.influencerID === post.influencerID) {
            _this2.campaignPayout = cPayout;
          }
        });
      }
      this.postInsightdialog = true;
    },
    init: function init() {
      this.summary = {
        outreach: 0,
        engagement: 0,
        revenue: 0,
        contents: 0,
        contents_percentage: 0,
        revenue_percentage: 0,
        outreach_percentage: 0,
        engagement_percentage: 0
      };
      this.postTypes.unshift({ name: '', title: 'All' });
    },
    removeContent: function removeContent(postID) {
      var _this3 = this;

      if (postID) {
        this.$swal({
          title: 'Please Confirm',
          text: 'Do you want to remove it from the report?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, remove it!'
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].deleteContentFromReport(postID).then(function () {
              _this3.$swal({
                title: 'Success',
                text: 'Removed Successfully from report',
                type: 'success'
              });
              _this3.quickReload();
            }).catch(function (err) {
              _this3.$swal({
                title: 'Error',
                text: err,
                type: 'error'
              });
              console.log('error');
            });
          }
        });
      }
    },
    addPost: function addPost() {
      this.addPostToCampaign = true;
      this.campaignDataView = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.campaignData);
    },
    quickReload: function quickReload() {
      this.getCampaignReport(this.selectedCampaignID, false);
    },
    addReportManually: function addReportManually(reports) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _posts;

        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reports = _this4.normalizeReportRows(reports);

                if (reports.length) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', false);

              case 3:
                (_posts = _this4.posts).push.apply(_posts, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(reports));
                _this4.setPostIds();
                _this4.filteredPosts = _this4.posts.map(function (p) {
                  return p;
                });

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    postChanged: function postChanged(isChanged) {
      if (isChanged) {
        this.quickReload();
      }
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
        var campaigns = response;
        campaigns = campaigns.filter(function (c) {
          return c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.ONGOING || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.REVIEW || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.COMPLETE;
        });
        _this5.campaignList = campaigns.map(function (element) {
          return {
            name: element.ioNumbers ? element.ioNumbers + ' - ' + element.name : element.name,
            id: element.id
          };
        });

        if (_this5.$route.query.id) {
          _this5.selectedCampaignID = _this5.$route.query.id;
          _this5.quickReload();
        }
      }).catch(function (err) {
        console.log('Error:' + err);
      });
    },
    generateChart: function generateChart() {
      var labels = [];
      var datasets = [];
      var history = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()(this.reportHistory);
      history.push({ report_date: __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.getDate(), data: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.summary) });
      var engagements = [];
      var outreaches = [];
      var revenues = [];
      history.forEach(function (report) {
        labels.push(report.report_date);
        var data = report.data;
        engagements.push(data.engagement);
        outreaches.push(data.outreach);
        revenues.push(data.revenue);
      });
      var engagementDataset = {
        label: 'Engagement',
        fill: false,
        borderColor: '#64dd17',
        data: engagements
      };
      var outreachDataset = {
        label: 'Outreach',
        fill: false,
        borderColor: '#0094cc',
        data: outreaches
      };
      var revenueDataset = {
        label: 'Revenue',
        fill: false,
        borderColor: '#ff3d00',
        data: revenues
      };
      datasets.push(engagementDataset);
      datasets.push(outreachDataset);
      datasets.push(revenueDataset);

      this.reportChartData.labels = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], labels);
      this.reportChartData.datasets = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], datasets);
    },
    getRandomInt: function getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    exportPDF: function exportPDF(campaignID, campaignName, force) {
      var _this6 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].generateCampaignReportPDF(campaignID, campaignName, force).then(function () {
        _this6.isLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this6.$swal({
          title: 'Error',
          text: error,
          type: 'error'
        });
        _this6.isLoading = false;
      });
    },
    refreshReportInf: function refreshReportInf() {
      var _this7 = this;

      var reportID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].generateCampaignReport(this.selectedCampaignID, null, true, 'json', reportID).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (response && response.success) {
                    _this7.getCampaignReport(_this7.selectedCampaignID, false, 'json', null);
                  }

                case 1:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this7);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this7.isLoading = false;
        console.error(error);
      });
    },
    getCampaignReport: function getCampaignReport(campaignID) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _this8 = this;

      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'json';
      var reportID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].generateCampaignReport(campaignID, null, force, format, reportID).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee4(response) {
          var data;
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(response && response.success)) {
                    _context4.next = 35;
                    break;
                  }

                  data = _this8.normalizeCampaignReportData(response.data);

                  _this8.respData = data;
                  _this8.summary = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, data.summary);
                  if (_this8.summary.outreach) {
                    _this8.summary.outreach = Number(_this8.summary.outreach);
                  }

                  _this8.posts = [];
                  _this8.posts = data.posts.sort(function (a, b) {
                    return a.lineUpIndex - b.lineUpIndex;
                  });
                  _this8.campaignData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, data.campaign_details);
                  _this8.campaignData.angles = _this8.campaignData.angles ? __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].fixAnglesData(_this8.campaignData.angles) : [];
                  _this8.campaignData.segment = _this8.campaignData.segment || __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].getDefaultSegments();
                  _this8.campaignData.lineUp = _this8.campaignData.lineUp || [];
                  _this8.campaignData.startDate = _this8.campaignData.startDate || '';
                  _this8.campaignData.endDate = _this8.campaignData.endDate || '';
                  _this8.campaignData.optionalRemarks = _this8.campaignData.optionalRemarks || '';
                  _this8.campaignData.AINotableComments = [];
                  if (_this8.campaignData.commentAnalysisResult) {
                    _this8.campaignData.AINotableComments = _this8.campaignData.commentAnalysisResult.notableComments;
                  }
                  _this8.reportHistory = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], data.report_history);
                  _this8.client = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, data.client);
                  _this8.generateChart();
                  _this8.switchRevenue();
                  _this8.isLoading = false;
                  _this8.setFilteredReports();
                  _context4.next = 24;
                  return _this8.setPostIds();

                case 24:
                  _context4.next = 26;
                  return _this8.setMultipleInfs();

                case 26:
                  _this8.isLoading = true;
                  _this8.isLoading = false;
                  _this8.setPostTypes();
                  _this8.selectedPosts = [];
                  _this8.filteredPosts = [];
                  _this8.filteredPosts = _this8.posts.map(function (p) {
                    return p;
                  });

                  setInterval(function () {
                    $('.v-data-table__wrapper').scroll(function () {
                      $('.v-footer-wrapper').scrollLeft($('.v-data-table__wrapper').scrollLeft());
                    });
                  }, 1000);
                  _context4.next = 37;
                  break;

                case 35:
                  _this8.resetCampaignReportData();
                  _this8.$swal({
                    title: 'Error',
                    text: response && response.message || 'Unable to load campaign report',
                    type: 'error'
                  });

                case 37:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this8);
        }));

        return function (_x6) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this8.resetCampaignReportData();
        _this8.isLoading = false;
        console.error(error);
      });
    },
    normalizeCampaignReportData: function normalizeCampaignReportData(data) {
      data = data || {};
      return {
        summary: data.summary || {},
        posts: this.normalizeReportRows(data.posts),
        campaign_details: data.campaign_details || {},
        report_history: Array.isArray(data.report_history) ? data.report_history : [],
        client: data.client || {}
      };
    },
    normalizeReportRows: function normalizeReportRows(posts) {
      if (!Array.isArray(posts)) return [];
      return posts.filter(Boolean).map(function (post) {
        var normalizeLinkedInReport = function normalizeLinkedInReport(report) {
          var platform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__["a" /* getReportPlatform */])(report);
          var normalizePostUrl = function normalizePostUrl(value) {
            if (typeof value === 'string') return value;
            if (!value || (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(value)) !== 'object') return '';
            return value.link || value.url || value.href || '';
          };
          var isLinkedIn = platform === 'linkedin';
          var isTwitter = platform === 'twitter';
          if (isLinkedIn) {
            var insightHistory = Array.isArray(report.insights) ? report.insights : [];
            var latestInsight = insightHistory[insightHistory.length - 1];
            var insights = latestInsight && latestInsight.data ? latestInsight.data : report.insights || {};
            report.insightHistory = insightHistory;
            report.insights = insights;
            report.platform = 'linkedin';
            report.postType = report.postType || 'LIP';
            report.typeName = 'LinkedIn Post';
            report.currentInsight = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, report.currentInsight || {}, {
              like_count: insights.like_count != null ? insights.like_count : (report.currentInsight || {}).like_count,
              comment_count: insights.comment_count != null ? insights.comment_count : (report.currentInsight || {}).comment_count,
              impressions: insights.impressions != null ? insights.impressions : (report.currentInsight || {}).impressions,
              reach: insights.reach != null ? insights.reach : insights.outreach != null ? insights.outreach : (report.currentInsight || {}).reach,
              saved: insights.saved != null ? insights.saved : insights.bookmarks != null ? insights.bookmarks : (report.currentInsight || {}).saved
            });
            report.inputtedInsights = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, report.inputtedInsights || {}, {
              shares: insights.shares != null ? insights.shares : (report.inputtedInsights || {}).shares,
              saved: insights.saved != null ? insights.saved : insights.bookmarks != null ? insights.bookmarks : (report.inputtedInsights || {}).saved,
              impressions: insights.impressions != null ? insights.impressions : (report.inputtedInsights || {}).impressions,
              reach: insights.reach != null ? insights.reach : insights.outreach != null ? insights.outreach : (report.inputtedInsights || {}).reach,
              video_views: insights.video_views != null ? insights.video_views : (report.inputtedInsights || {}).video_views,
              profile_viewers: insights.profile_viewers != null ? insights.profile_viewers : (report.inputtedInsights || {}).profile_viewers
            });
            report.postLink = normalizePostUrl(report.postURL) || normalizePostUrl(report.postLink) || normalizePostUrl(report.post_details) || '';
            if (!report.type || report.type === 'Others' || report.type === 'Other Post') {
              report.type = 'LinkedIn Post';
            }
          }
          if (isTwitter) {
            var _insightHistory = Array.isArray(report.insights) ? report.insights : [];
            var _latestInsight = _insightHistory[_insightHistory.length - 1];
            var insightData = _latestInsight && _latestInsight.data ? _latestInsight.data : report.insights || {};
            var _insights = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, insightData, report.currentInsight || {}, report.inputtedInsights || {});
            report.insightHistory = _insightHistory;
            report.insights = _insights;
            report.platform = 'twitter';
            report.postType = report.postType || 'XTP';
            report.typeName = 'X (Twitter) Post';
            report.type = 'X (Twitter) Post';
            report.currentInsight = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, report.currentInsight || {}, {
              like_count: _insights.like_count != null ? _insights.like_count : (report.currentInsight || {}).like_count,
              comment_count: _insights.comment_count != null ? _insights.comment_count : (report.currentInsight || {}).comment_count,
              impressions: _insights.impressions != null ? _insights.impressions : _insights.views != null ? _insights.views : (report.currentInsight || {}).impressions,
              views: _insights.views != null ? _insights.views : (report.currentInsight || {}).views
            });
            report.inputtedInsights = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, report.inputtedInsights || {}, {
              shares: _insights.shares != null ? _insights.shares : (report.inputtedInsights || {}).shares,
              saved: _insights.saved != null ? _insights.saved : (report.inputtedInsights || {}).saved,
              impressions: _insights.impressions != null ? _insights.impressions : _insights.views != null ? _insights.views : (report.inputtedInsights || {}).impressions,
              views: _insights.views != null ? _insights.views : (report.inputtedInsights || {}).views
            });
            report.postLink = normalizePostUrl(report.postURL) || normalizePostUrl(report.postLink) || normalizePostUrl(report.post_details) || '';
          }
          return report;
        };
        if (post.reportGroup) {
          post.reports = Array.isArray(post.reports) ? post.reports.filter(Boolean).map(normalizeLinkedInReport) : [];
          post.filteredReports = Array.isArray(post.filteredReports) ? post.filteredReports.filter(Boolean).map(normalizeLinkedInReport) : post.reports.map(function (report) {
            return report;
          });
        }
        return normalizeLinkedInReport(post);
      });
    },
    resetCampaignReportData: function resetCampaignReportData() {
      this.respData = null;
      this.summary = {};
      this.posts = [];
      this.filteredPosts = [];
      this.reportHistory = [];
      this.client = {};
      this.isLoading = false;
    },
    setPostIds: function setPostIds() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, reports, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, elementOne;

        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this9.selectedPosts = [];
                _this9.reviewers = new __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default.a();
                _this9.totalCounts.contents = 0;
                _this9.totalCounts.amount = 0;
                _this9.selectedPostIds = new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_map___default.a();_iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 8;
                _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this9.posts);

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context5.next = 46;
                  break;
                }

                element = _step.value;

                if (element) {
                  _context5.next = 14;
                  break;
                }

                return _context5.abrupt('continue', 43);

              case 14:
                element.searchable = '';

                if (!element.reportGroup) {
                  _context5.next = 40;
                  break;
                }

                element.panel = [0];
                element.typeName = '';
                reports = Array.isArray(element.reports) ? element.reports : [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 22;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(reports); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  elementOne = _step2.value;

                  _this9.reviewers.add(elementOne.instagram ? elementOne.instagram.toLowerCase() : '');
                  element.typeName += ' ' + elementOne.instagram + ' ' + elementOne.typeName + ' ';
                  elementOne = _this9.beautifyPostData(elementOne);
                }
                _context5.next = 30;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5['catch'](22);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 30:
                _context5.prev = 30;
                _context5.prev = 31;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 33:
                _context5.prev = 33;

                if (!_didIteratorError2) {
                  _context5.next = 36;
                  break;
                }

                throw _iteratorError2;

              case 36:
                return _context5.finish(33);

              case 37:
                return _context5.finish(30);

              case 38:
                _context5.next = 43;
                break;

              case 40:
                _this9.reviewers.add(element.instagram ? element.instagram.toLowerCase() : '');
                element.searchable += element.instagram + ' ' + element.typeName + ' ';
                element = _this9.beautifyPostData(element);

              case 43:
                _iteratorNormalCompletion = true;
                _context5.next = 10;
                break;

              case 46:
                _context5.next = 52;
                break;

              case 48:
                _context5.prev = 48;
                _context5.t1 = _context5['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context5.t1;

              case 52:
                _context5.prev = 52;
                _context5.prev = 53;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 55:
                _context5.prev = 55;

                if (!_didIteratorError) {
                  _context5.next = 58;
                  break;
                }

                throw _iteratorError;

              case 58:
                return _context5.finish(55);

              case 59:
                return _context5.finish(52);

              case 60:
                _this9.totalCounts.amount = parseFloat(_this9.totalCounts.amount).toFixed(2);

              case 61:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9, [[8, 48, 52, 60], [22, 26, 30, 38], [31,, 33, 37], [53,, 55, 59]]);
      }))();
    },
    setFilteredReports: function setFilteredReports() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, element, reports;

        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context6.prev = 3;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this10.posts); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  element = _step3.value;

                  if (element.reportGroup) {
                    reports = Array.isArray(element.reports) ? element.reports : [];

                    element.filteredReports = reports.map(function (r) {
                      return r;
                    });
                  }
                }
                _context6.next = 11;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](3);
                _didIteratorError3 = true;
                _iteratorError3 = _context6.t0;

              case 11:
                _context6.prev = 11;
                _context6.prev = 12;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 14:
                _context6.prev = 14;

                if (!_didIteratorError3) {
                  _context6.next = 17;
                  break;
                }

                throw _iteratorError3;

              case 17:
                return _context6.finish(14);

              case 18:
                return _context6.finish(11);

              case 19:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[3, 7, 11, 19], [12,, 14, 18]]);
      }))();
    },
    setPostTypes: function setPostTypes() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, element, reports, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, elementOne;

        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context7.prev = 3;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this11.posts);

              case 5:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context7.next = 45;
                  break;
                }

                element = _step4.value;

                if (!element.reportGroup) {
                  _context7.next = 39;
                  break;
                }

                reports = Array.isArray(element.reports) ? element.reports : [];
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context7.prev = 12;
                _iterator5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(reports);

              case 14:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context7.next = 22;
                  break;
                }

                elementOne = _step5.value;
                _context7.next = 18;
                return _this11.getPostType(elementOne);

              case 18:
                elementOne = _context7.sent;

              case 19:
                _iteratorNormalCompletion5 = true;
                _context7.next = 14;
                break;

              case 22:
                _context7.next = 28;
                break;

              case 24:
                _context7.prev = 24;
                _context7.t0 = _context7['catch'](12);
                _didIteratorError5 = true;
                _iteratorError5 = _context7.t0;

              case 28:
                _context7.prev = 28;
                _context7.prev = 29;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 31:
                _context7.prev = 31;

                if (!_didIteratorError5) {
                  _context7.next = 34;
                  break;
                }

                throw _iteratorError5;

              case 34:
                return _context7.finish(31);

              case 35:
                return _context7.finish(28);

              case 36:
                element.filteredReports = reports.map(function (r) {
                  return r;
                });
                _context7.next = 42;
                break;

              case 39:
                _context7.next = 41;
                return _this11.getPostType(element);

              case 41:
                element = _context7.sent;

              case 42:
                _iteratorNormalCompletion4 = true;
                _context7.next = 5;
                break;

              case 45:
                _context7.next = 51;
                break;

              case 47:
                _context7.prev = 47;
                _context7.t1 = _context7['catch'](3);
                _didIteratorError4 = true;
                _iteratorError4 = _context7.t1;

              case 51:
                _context7.prev = 51;
                _context7.prev = 52;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 54:
                _context7.prev = 54;

                if (!_didIteratorError4) {
                  _context7.next = 57;
                  break;
                }

                throw _iteratorError4;

              case 57:
                return _context7.finish(54);

              case 58:
                return _context7.finish(51);

              case 59:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11, [[3, 47, 51, 59], [12, 24, 28, 36], [29,, 31, 35], [52,, 54, 58]]);
      }))();
    },
    getPostType: function getPostType(elementOne) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var storyInsights;
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                storyInsights = {
                  impressions: 0,
                  reach: 0,
                  replies: 0,
                  exits: 0,
                  taps_back: 0,
                  taps_forward: 0,
                  shares: 0,
                  link_clicks: 0,
                  sticker_taps: 0
                };

                if (!elementOne.isStory && !elementOne.isTikTok && !elementOne.isYoutube && !elementOne.isOthers && !_this12.isLinkedInReport(elementOne) && !_this12.isTwitterReport(elementOne) && elementOne.post_details && elementOne.post_details.shortcode) {
                  _this12.selectedPostIds.set(elementOne.post_details.shortcode, 1);
                } else if (elementOne.isTikTok && elementOne.post_details && elementOne.post_details.shortcode) {
                  elementOne.tikTokPost = __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].getTikTokPost(elementOne.post_details.shortcode);
                } else if (elementOne.isYoutube && elementOne.post_details && elementOne.post_details.shortcode) {
                  elementOne.youtubePost = __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].getYoutubePost(elementOne.post_details.shortcode);
                } else if (elementOne.isMultipleContents && !elementOne.insights) {
                  elementOne.insights = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, storyInsights);
                }
                return _context8.abrupt('return', elementOne);

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this12);
      }))();
    },
    beautifyPostData: function beautifyPostData(elementOne) {
      elementOne = this.setDefaultEditFields(elementOne);
      this.calculateTotals(elementOne);
      if (elementOne.live_date !== undefined && elementOne.live_date !== '' && elementOne.live_date !== null) {
        if (elementOne.live_date === 'Invalid date') {
          elementOne.live_date = '';
        }
        if (elementOne.live_date.includes('/')) {
          elementOne.live_date = this.parseDate(elementOne.live_date);
        }
        this.liveDates.push(this.refreshJSON(elementOne.live_date));
        elementOne.live_date = this.formatDate(elementOne.live_date);
      }
      if (elementOne.due_date === 'Invalid date') {
        elementOne.due_date = '';
      }
      elementOne.due_date = this.formatDate(elementOne.due_date);
    },
    exportExcel: function exportExcel(campaignID, campaignName) {
      var _this13 = this;

      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].generateCampaignReportExcel(campaignID, campaignName, force).then(function () {
        _this13.isLoading = false;
      }).catch(function (error) {
        _this13.isLoading = false;
        console.log(error);
      });
    },
    exportExcelPosts: function exportExcelPosts(campaignID, campaignName) {
      var _this14 = this;

      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].generateCampaignReportExcelonPosts(campaignID, campaignName, force).then(function () {
        _this14.isLoading = false;
      }).catch(function (error) {
        _this14.isLoading = false;
        console.log(error);
      });
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this15 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this15.viewCampaignData = response;
        _this15.viewCampaignModalDialog = true;
        _this15.isLoading = false;
      }).catch(function (error) {
        _this15.viewCampaignModalDialog = false;
        console.log(error);
        _this15.isLoading = false;
      });
    },
    handleDragDropUpdate: function handleDragDropUpdate(items) {
      if (items.length === 0) {
        return;
      }
      var groupID = items[0].groupID;
      if (groupID) {
        this.lineUpItems = this.posts.map(function (p) {
          if (p.id === groupID) {
            p.reports = Array.isArray(items) ? items : [];
          }
          return p;
        });
      } else {
        this.lineUpItems = items;
      }
      this.disableSaveArrange = false;
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(event, items) {
      if (items.length === 0) {
        return;
      }
      var tmpPosts = [];
      var groupID = items[0].groupID;
      if (groupID) {
        var group = this.posts.find(function (p) {
          return p.id === groupID;
        });
        if (group) {
          tmpPosts = Array.isArray(group.reports) ? group.reports : [];
        }
      } else {
        tmpPosts = this.posts;
      }
      var movedItem = tmpPosts.splice(event.oldIndex, 1)[0];
      tmpPosts.splice(event.newIndex, 0, movedItem);
      if (groupID) {
        this.posts = this.posts.map(function (p) {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(function (tmp) {
              return tmp;
            });
          }
          return p;
        });
      } else {
        this.posts = tmpPosts.map(function (tmp) {
          return tmp;
        });
      }
      this.lineUpItems = [];
      this.lineUpItems = this.posts;
      this.disableSaveArrange = false;
    },
    viewReport: function viewReport() {
      var routeData = this.$router.resolve({ name: 'CampaignSummaryReports', query: { id: this.selectedCampaignID } });
      window.open(routeData.href, '_blank');
    },
    viewPayoutsReport: function viewPayoutsReport() {
      var routeData = this.$router.resolve({ name: 'Payouts Report', query: { id: this.selectedCampaignID } });
      window.open(routeData.href, '_blank');
    },
    updateLineUp: function updateLineUp() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this16.lineUpItems.map(function (item, index) {
                  var data = {};
                  if (item.reportGroup) {
                    data.groupID = item.id;
                    data.lineUpIndex = index;
                    var reports = Array.isArray(item.reports) ? item.reports : [];
                    data.posts = reports.map(function (element, rindex) {
                      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, { id: element.id, lineUpIndex: rindex });
                    });
                  } else {
                    data = {
                      reportID: item.id,
                      campaignID: item.campaignID,
                      lineUpIndex: index
                    };
                  }
                  __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
                _this16.$swal.fire({
                  type: 'success',
                  title: 'Saved!',
                  showCancelButton: false,
                  width: 300
                });

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this16);
      }))();
    },
    saveLineUp: function saveLineUp() {
      this.updateLineUp();
    },
    switchRevenue: function switchRevenue() {
      if (this.campaignData.revenueCalculation !== undefined) {
        if (this.campaignData.revenueCalculation === 'engagement') {
          this.swtRevenue = 'engagement';
          this.revenueSubText = 'by engagement';
        } else {
          this.swtRevenue = 'content';
          this.revenueSubText = 'by contents';
        }
      } else {
        this.swtRevenue = 'engagement';
        this.revenueSubText = 'by engagement';
      }
    },
    selectAllPosts: function selectAllPosts($event) {
      if ($event.value && $event.items.length === 0 || !$event.value) {
        this.selectedPosts = [];
        return;
      }
      if (this.selectedPosts.length === 0) {
        this.selectedPosts = $event.items.filter(function (item) {
          if (item.reportGroup) return false;
          return true;
        });
      } else {
        this.selectedPosts = [];
      }
    },
    openReportGroupModal: function openReportGroupModal() {
      this.reportGroupDialog = true;
    },
    deleteReportGroup: function deleteReportGroup(groupID, groupName) {
      var _this17 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete this group (' + groupName + ')?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].deleteReportGroup(groupID).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this17.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this17.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this17.quickReload();

          _this17.$swal({
            title: 'Deleted',
            text: 'The group has been deleted successfully',
            type: 'success'
          });
        } else {}
      });
    },
    savedReportGroup: function savedReportGroup() {
      this.selectedPosts = [];
      this.quickReload();
    },
    getPaymentStatus: function getPaymentStatus(statusVal) {
      var statusText = 'Please Confirm Payout';
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.paymentStatuses).forEach(function (item) {
        if (statusVal === item[1].value) {
          statusText = item[1].text;
        }
      });
      return statusText;
    },
    getIMSStatus: function getIMSStatus(statusVal, paymentStatusVal) {
      if (this.imsStatuses.NEW.value === statusVal) {
        if (paymentStatusVal) {
          return '-';
        }
        return this.imsStatuses.NEW.text;
      } else if (this.imsStatuses.SUBMITTED.value === statusVal) {
        return this.imsStatuses.SUBMITTED.text;
      } else if (this.imsStatuses.NOT_SUBMITTED.value === statusVal) {
        return this.imsStatuses.NOT_SUBMITTED.text;
      }
      return '-';
    },
    openEditItem: function openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true;
      item.editReport = true;
      this.posts = this.refreshJSON(this.posts);
      this.disableSaveEdit = false;
      this.selectedPosts = [];
    },
    saveEditingData: function saveEditingData() {
      var _this18 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this18.isEditing = true;
          var data = _this18.filteredPosts.filter(function (item) {
            return item.editReport && item.editReport === true;
          });
          var groupedPosts = _this18.filteredPosts.filter(function (item) {
            return item.reportGroup && item.reportGroup === true;
          });

          groupedPosts.map(function (p) {
            var reports = Array.isArray(p.reports) ? p.reports : [];
            reports.map(function (rp) {
              data.push(rp);
            });
          });
          data = data.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
              id: item.id,
              live_date: item.live_date,
              due_date: item.due_date,
              amount: item.amount,
              ims_status: item.ims_status,
              payment_status: item.payment_status,
              type: item.type
            });
          });

          __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].saveEditedReportData(data).then(function (response) {
            _this18.isEditing = false;
            _this18.cancelEdit();
            _this18.setPostIds();

            _this18.$swal({
              text: 'Report Updated',
              type: 'success'
            });
          }).catch(function (error) {
            _this18.isEditing = false;

            console.log('error', error);
            _this18.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    cancelEdit: function cancelEdit() {
      var _this19 = this;

      this.filteredPosts = this.filteredPosts.map(function (inf) {
        inf = _this19.setDefaultEditFields(inf);
        if (inf.reportGroup) {
          var reports = Array.isArray(inf.reports) ? inf.reports : [];
          inf.reports = reports.map(function (infg) {
            infg = _this19.setDefaultEditFields(infg);
            return infg;
          });
        }
        return inf;
      });
      this.disableSaveEdit = true;
    },
    setDefaultEditFields: function setDefaultEditFields(obj) {
      obj.liveDateEdit = false;
      obj.dueDateEdit = false;
      obj.amountEdit = false;

      obj.imsStatusEdit = false;
      obj.paymentStatusEdit = false;
      obj.editReport = false;
      obj.liveCal = false;
      obj.dueCal = false;
      return obj;
    },
    refreshJSON: function refreshJSON(json) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(json || []));
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      var formattedDate = day + '/' + month + '/' + year;
      if (formattedDate.includes('undefined')) {
        return date;
      }
      return formattedDate;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    customSearch: function customSearch(value, search, item) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(item).some(function (v) {
        return v && v.toString().toLowerCase().includes(search);
      });
    },
    renderVideo: function renderVideo(publicID) {
      this.cld.videoPlayer('cloud-player-' + publicID, {
        transformation: { width: 320, height: 400 }
      });
    },
    getMedia: function getMedia(post) {
      post.internalView = true;
      if (post.isStory) {
        post.type = 'story';
        post.embed_url = post.media_url;
      }
      return __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].customMediaConfig(post, this.campaignData.campaignType);
    },
    getFiltered: function getFiltered() {
      var _this20 = this;

      this.filteredPosts = this.posts.map(function (post) {
        if (post.reportGroup) {
          var reports = Array.isArray(post.reports) ? post.reports : [];
          post.filteredReports = reports.map(function (gprpt) {
            return gprpt;
          });
        }
        return post;
      });
      if (this.postType && this.postType.toLowerCase() !== 'all') {
        this.filteredPosts = this.posts.filter(function (post) {
          if (post.reportGroup) {
            var hasReports = false;
            var reports = Array.isArray(post.reports) ? post.reports : [];
            post.filteredReports = reports.filter(function (gpPost) {
              if (gpPost.typeName === _this20.postType) {
                hasReports = true;
                return true;
              } else return false;
            });
            return hasReports;
          } else if (post.typeName === _this20.postType) {
            return true;
          }
          return false;
        });
      }
      if (this.searchMonth) {
        var splitMonth = this.searchMonth.split('-');
        var searchText = splitMonth[1] + '/' + splitMonth[0];
        this.filteredPosts = this.posts.filter(function (post) {
          if (post.reportGroup) {
            var hasReports = false;
            var reports = Array.isArray(post.reports) ? post.reports : [];
            post.filteredReports = reports.filter(function (gpPost) {
              if (gpPost.live_date && gpPost.live_date.includes(searchText)) {
                hasReports = true;
                return true;
              } else return false;
            });
            return hasReports;
          } else if (post.live_date && post.live_date.includes(searchText)) {
            return true;
          }
          return false;
        });
      }
      if (this.searchFilter) {
        this.filteredPosts = this.posts.filter(function (post) {
          if (post.reportGroup) {
            var hasReports = false;
            var reports = Array.isArray(post.reports) ? post.reports : [];
            post.filteredReports = reports.filter(function (gpPost) {
              if (gpPost.instagram && gpPost.instagram.toLowerCase().includes(_this20.searchFilter)) {
                hasReports = true;
                return true;
              } else return false;
            });
            return hasReports;
          } else if (post.instagram && post.instagram.toLowerCase().includes(_this20.searchFilter)) {
            return true;
          }
          return false;
        });
      }
    },
    calculateTotals: function calculateTotals(element) {
      this.totalCounts.contents += 1;
      if (element.amountLocked !== true) {
        this.totalCounts.amount += Number(element.amount || 0);
      }
    },
    searchMonthOk: function searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.getFiltered();
    },

    customSort: function customSort(items, index, isDesc) {
      items.sort(function (a, b) {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      this.lineUpItems = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], items);
      this.disableSaveArrange = false;
      return items;
    },
    openEditHandleModal: function openEditHandleModal(post) {
      this.editReportHandleDialog = true;
      this.editHandleReport = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, post);
    },
    getFbPost: function getFbPost(url) {
      if (!url) return '';
      if (/facebook\.com\/plugins\/post\.php/i.test(url)) return url;
      return 'https://www.facebook.com/plugins/post.php?href=' + encodeURIComponent(url) + '&show_text=true&width=500';
    },
    setMultipleInfs: function setMultipleInfs() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, item, infID, resp, infs;

        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context10.prev = 3;
                _iterator6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this21.posts);

              case 5:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context10.next = 27;
                  break;
                }

                item = _step6.value;
                infID = null;
                _context10.next = 10;
                return __WEBPACK_IMPORTED_MODULE_20__Influencer_influencerAPIs__["a" /* default */].getInfluencerByHandles({
                  searchHandles: [item.instagram]
                });

              case 10:
                resp = _context10.sent;

                if (resp.length) {
                  resp = resp[0];
                  infID = resp.id;
                }

                if (infID) {
                  _context10.next = 14;
                  break;
                }

                return _context10.abrupt('continue', 24);

              case 14:
                infs = [];
                _context10.next = 17;
                return _this21.$store.dispatch('influencer/getInfluencerDetail', {
                  id: infID
                });

              case 17:
                if (_this21.infDetail.instagram) {
                  infs.push({
                    reportID: item.id,
                    platform: 'Instagram',
                    handle: _this21.infDetail.instagram.instagramHandle,
                    instagramID: _this21.infDetail.instagram.instagramID,
                    picture: _this21.infDetail.audience ? _this21.infDetail.audience.user_profile.picture : _this21.infDetail.instagram.picture,
                    instagram: true
                  });
                }
                if (_this21.infDetail.tiktok) {
                  infs.push({
                    reportID: item.id,
                    platform: 'TikTok',
                    handle: _this21.infDetail.tiktok.tiktokHandle,
                    tiktokID: _this21.infDetail.tiktok.tiktokID,
                    picture: _this21.infDetail.tiktokaudience ? _this21.infDetail.tiktokaudience.user_profile.picture : _this21.infDetail.tiktok.picture,
                    tiktok: true
                  });
                }
                if (_this21.infDetail.youtube) {
                  infs.push({
                    reportID: item.id,
                    platform: 'Youtube',
                    handle: _this21.infDetail.youtube.youtubeHandle,
                    youtubeID: _this21.infDetail.youtube.youtubeID,
                    picture: _this21.infDetail.youtubeaudience ? _this21.infDetail.youtubeaudience.user_profile.picture : _this21.infDetail.youtube.picture,
                    youtube: true
                  });
                }
                if (_this21.infDetail.xiaohongshu) {
                  infs.push({
                    reportID: item.id,
                    platform: 'Xiaohongshu',
                    handle: _this21.infDetail.xiaohongshu.xhsHandle,
                    xhsID: _this21.infDetail.xiaohongshu.xhsID,
                    picture: _this21.infDetail.xiaohongshu ? _this21.infDetail.xiaohongshu.profilePicture : '',
                    xhs: true
                  });
                }
                if (_this21.infDetail.facebook) {
                  infs.push({
                    reportID: item.id,
                    platform: 'Facebook',
                    handle: _this21.infDetail.facebook.handle,
                    xhsID: _this21.infDetail.facebook.facebookId,
                    picture: _this21.infDetail.facebook ? _this21.infDetail.facebook.profilePicture : '',
                    facebook: true
                  });
                }
                if (_this21.infDetail.linkedin) {
                  infs.push({
                    reportID: item.id,
                    platform: 'LinkedIn',
                    handle: _this21.infDetail.linkedin.linkedinHandle,
                    picture: '',
                    linkedin: true
                  });
                }
                item.multipleInfs = infs;

              case 24:
                _iteratorNormalCompletion6 = true;
                _context10.next = 5;
                break;

              case 27:
                _context10.next = 33;
                break;

              case 29:
                _context10.prev = 29;
                _context10.t0 = _context10['catch'](3);
                _didIteratorError6 = true;
                _iteratorError6 = _context10.t0;

              case 33:
                _context10.prev = 33;
                _context10.prev = 34;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 36:
                _context10.prev = 36;

                if (!_didIteratorError6) {
                  _context10.next = 39;
                  break;
                }

                throw _iteratorError6;

              case 39:
                return _context10.finish(36);

              case 40:
                return _context10.finish(33);

              case 41:
                _this21.posts = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], _this21.posts);

              case 42:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this21, [[3, 29, 33, 41], [34,, 36, 40]]);
      }))();
    },
    changePlatform: function changePlatform(obj, index) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this22.isLoading = true;
                saveData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
                  id: obj.reportID,
                  handle: obj.handle,
                  platform: obj.platform
                });
                _context11.next = 4;
                return _this22.$store.dispatch('campaign/updateReportHandle', {
                  updateData: saveData
                });

              case 4:
                _this22.isLoading = false;
                if (_this22.updatedReport) {
                  _this22.$swal({
                    text: 'Successfully Updated.',
                    type: 'success'
                  }).then(function (result) {
                    _this22.quickReload();
                  });
                } else {
                  _this22.$swal({
                    text: 'Error Updating Handle!',
                    type: 'error'
                  });
                }

              case 6:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this22);
      }))();
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.headers)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref3 = _step7.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var key = _ref4[0];
          var value = _ref4[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                columns = _this23.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this23.userProfile.tableSettings) {
                  tableSettings = _this23.userProfile.tableSettings;
                }
                tableSettings.reportCols = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this23.currentUserID,
                  tableSettings: tableSettings
                };
                _context12.next = 8;
                return __WEBPACK_IMPORTED_MODULE_38__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this23.colStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, columns);
                _this23.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this23);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return __WEBPACK_IMPORTED_MODULE_38__User_userAPIs__["a" /* default */].getUser(_this24.currentUserID);

              case 2:
                resp = _context13.sent;

                if (resp && resp.id) {
                  _this24.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this24);
      }))();
    },
    getAllCampaignPayouts: function getAllCampaignPayouts() {
      var _this25 = this;

      __WEBPACK_IMPORTED_MODULE_20__Influencer_influencerAPIs__["a" /* default */].getAllCampaignPayouts({
        campaignID: this.selectedCampaignID
      }).then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee14(response) {
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _this25.campaignPayouts = response.data;

                  _this25.campaignPayouts = _this25.campaignPayouts.map(function (element) {
                    var resultData = {
                      campaignName: element.campaignName,
                      influencerID: element.influencerID,
                      createdAt: element.createdAt,
                      toMakePaymentAt: __WEBPACK_IMPORTED_MODULE_15_moment___default()(element.createdAt).add(30, 'days').format(),
                      payoutAmount: element.payoutAmount || '',

                      images: element.images || [],
                      posts: element.posts || [],
                      stories: element.stories || [],
                      deliverablePosts: element.deliverablePosts || []
                    };
                    if (element.tiktok) {
                      resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : '';
                      resultData.platform = 'tiktok';
                    } else {
                      resultData.handle = element.instagram ? element.instagram.instagramHandle : '';
                      resultData.platform = 'instagram';
                      resultData.xhsID = element.xhsID || '';
                    }
                    if (!resultData.handle) {
                      if (element.handle) {
                        resultData.handle = element.handle;
                        resultData.platform = element.platform || 'instagram';
                        resultData.xhsID = element.xhsID || '';
                      }
                    }
                    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({
                      id: element.id,
                      campaignID: element.campaignID,
                      postID: element.postID
                    }, resultData);
                  });

                case 2:
                case 'end':
                  return _context14.stop();
              }
            }
          }, _callee14, _this25);
        }));

        return function (_x9) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log('error', error);
      });
    },
    changeSettings: function changeSettings(item) {
      this.campaignData = item;
      this.campaignSettingsDialog = !this.campaignSettingsDialog;
    },
    handleLoadingStatus: function handleLoadingStatus(status) {
      this.isLoading = status;
    },
    logScrapingStatus: function logScrapingStatus(message) {
      this.scrapingStatusMessage = message;
      console.log('[STATUS] ' + message);
    },
    scrapComments: function scrapComments(link, postID) {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var post, platform, result, comments;
        return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!link || !postID)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt('return', false);

              case 2:
                post = _this26.posts.find(function (item) {
                  return item.id === postID;
                });
                platform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_reportPlatform__["a" /* getReportPlatform */])(post || {});

                if (['instagram', 'tiktok'].includes(platform)) {
                  _context15.next = 7;
                  break;
                }

                _this26.$swal({ title: 'Info', text: 'Comment extraction supports Instagram and TikTok.', type: 'info' });
                return _context15.abrupt('return', false);

              case 7:
                _this26.isScrapLoading = true;
                _this26.updatePostScrapingStatus(postID, true, null);
                _context15.prev = 9;
                _context15.next = 12;
                return __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].extractReportPost(link, platform, 'comments');

              case 12:
                result = _context15.sent;
                comments = result.comments;

                if (Array.isArray(comments)) {
                  _context15.next = 16;
                  break;
                }

                throw new Error('Comment extraction returned invalid data.');

              case 16:
                if (!comments.length) {
                  _context15.next = 20;
                  break;
                }

                _context15.next = 19;
                return __WEBPACK_IMPORTED_MODULE_19__campaignAPIs__["a" /* default */].updateReportsByIds([{ id: postID, comments: comments }]);

              case 19:
                _this26.quickReload();

              case 20:
                _this26.updatePostScrapingStatus(postID, false, comments);
                _this26.$swal({ title: 'Success', text: comments.length ? comments.length + ' comments saved.' : 'No comments were found.', type: 'info' });
                return _context15.abrupt('return', comments);

              case 25:
                _context15.prev = 25;
                _context15.t0 = _context15['catch'](9);

                _this26.updatePostScrapingStatus(postID, false, null);
                _this26.$swal({ title: 'Error', text: _context15.t0.response && _context15.t0.response.data && _context15.t0.response.data.message || _context15.t0.message || 'Comment extraction failed.', type: 'error' });
                return _context15.abrupt('return', false);

              case 30:
                _context15.prev = 30;

                _this26.isScrapLoading = false;
                return _context15.finish(30);

              case 33:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this26, [[9, 25, 30, 33]]);
      }))();
    },
    updatePostScrapingStatus: function updatePostScrapingStatus(postID, status, comments) {
      this.posts = this.posts.map(function (p) {
        if (p.id === postID) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, p, {
            isScrapingComments: status,
            scrapedComments: comments
          });
        }
        return p;
      });
      this.filteredPosts = this.posts.map(function (p) {
        return p;
      });
    },
    openCommentsDialog: function openCommentsDialog(post) {
      if (post.comments && Array.isArray(post.comments)) {
        this.selectedPostComments = post.comments;
        this.viewCommentsDialog = true;
      } else {
        this.selectedPostComments = [];
        this.$swal({ title: 'Info', text: 'No comments data found for this post.', type: 'info' });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40_vuex__["b" /* mapState */])({
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    },
    updatedReport: function updatedReport(state) {
      return state.campaign.updatedReport;
    },
    infDetail: function infDetail(state) {
      return state.influencer.infDetail;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40_vuex__["c" /* mapGetters */])('payment', ['paymentStatusOptions']), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    campaignStatusDisplay: function campaignStatusDisplay() {
      return __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatusDisplay;
    },
    currentCampaignStatusDisplay: function currentCampaignStatusDisplay() {
      if (!this.campaignData || this.campaignData.status === undefined || this.campaignData.status === null) return 'N/A';
      var status = this.campaignStatusDisplay[this.campaignData.status];
      return status && status.display ? status.display : 'N/A';
    },
    minLiveDate: function minLiveDate() {
      var liveDates = this.refreshJSON(this.liveDates);
      var orderedDates = liveDates.sort(function (a, b) {
        return new Date(a) - new Date(b);
      });
      return orderedDates.length > 0 ? __WEBPACK_IMPORTED_MODULE_15_moment___default()(orderedDates[0]).format('DD/MM/YYYY') : 0;
    },
    maxLiveDate: function maxLiveDate() {
      var liveDates = this.refreshJSON(this.liveDates);
      var orderedDates = liveDates.sort(function (a, b) {
        return new Date(a) - new Date(b);
      });
      return orderedDates.length > 0 ? __WEBPACK_IMPORTED_MODULE_15_moment___default()(orderedDates[orderedDates.length - 1]).format('DD/MM/YYYY') : 0;
    },
    outreachCurrent: function outreachCurrent() {
      return Number(this.summary && this.summary.outreach ? this.summary.outreach : 0);
    },
    outreachTarget: function outreachTarget() {
      return Number(this.campaignData && this.campaignData.outreach ? this.campaignData.outreach : 0);
    },
    outreachRatio: function outreachRatio() {
      if (!this.outreachTarget || this.outreachTarget <= 0) {
        return 0;
      }
      return this.outreachCurrent / this.outreachTarget;
    },
    outreachGaugeRatio: function outreachGaugeRatio() {
      return Math.min(Math.max(this.outreachRatio, 0), 1);
    },
    outreachRatioPercent: function outreachRatioPercent() {
      return (this.outreachRatio * 100).toFixed(1);
    },
    outreachNeedleRotation: function outreachNeedleRotation() {
      return -90 + this.outreachGaugeRatio * 180;
    },
    outreachArcLength: function outreachArcLength() {
      return Math.PI * 75;
    },
    outreachArcOffset: function outreachArcOffset() {
      return this.outreachArcLength * (1 - this.outreachGaugeRatio);
    },
    outreachOdometerDigits: function outreachOdometerDigits() {
      var current = Math.max(0, Math.floor(this.outreachCurrent));
      var target = Math.max(0, Math.floor(this.outreachTarget));
      var maxDigits = Math.max(String(current).length, String(target).length, 6);
      return String(current).padStart(maxDigits, '0').split('');
    },
    contentsCurrent: function contentsCurrent() {
      return Number(this.summary && this.summary.contents ? this.summary.contents : 0);
    },
    contentsTarget: function contentsTarget() {
      return Number(this.campaignData && this.campaignData.min_content ? this.campaignData.min_content : 0);
    },
    contentsRatio: function contentsRatio() {
      if (!this.contentsTarget || this.contentsTarget <= 0) {
        return 0;
      }
      return this.contentsCurrent / this.contentsTarget;
    },
    contentsGaugeRatio: function contentsGaugeRatio() {
      return Math.min(Math.max(this.contentsRatio, 0), 1);
    },
    contentsRatioPercent: function contentsRatioPercent() {
      return (this.contentsRatio * 100).toFixed(1);
    },
    contentsProgressFillPercent: function contentsProgressFillPercent() {
      return this.contentsGaugeRatio * 100;
    },

    imsStatusOptions: function imsStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.imsStatuses).forEach(function (item) {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    },

    budget: function budget() {
      return Math.floor(this.campaignData.budget * 0.26);
    },
    markupCOGSAmount: function markupCOGSAmount() {
      return __WEBPACK_IMPORTED_MODULE_21__campaignHelper__["a" /* default */].getMarkupCOGS(this.campaignData.ioNumbers, this.client);
    },
    cogsPercentage: function cogsPercentage() {
      return this.campaignData ? (this.totalCounts.amount / this.campaignData.budget * 100).toFixed(2) : 0;
    },
    revenueByContents: function revenueByContents() {
      return this.summary.revenueByContents ? Number(this.summary.revenueByContents) : 0;
    },
    revenueByEng: function revenueByEng() {
      return this.summary.revenue ? Number(this.summary.revenue) : 0;
    },
    revenueByContentsPercent: function revenueByContentsPercent() {
      return this.summary.revenueByContents_percentage && this.summary.revenueByContents_percentage !== 'NaN' ? Math.floor(this.summary.revenueByContents_percentage).toFixed(2) : 0;
    },
    revenueEngPercent: function revenueEngPercent() {
      return this.summary.revenue_percentage && this.summary.revenue_percentage !== 'NaN' ? Math.floor(this.summary.revenue_percentage).toFixed(2) : 0;
    },
    UnRecognisedRevenueContent: function UnRecognisedRevenueContent() {
      return this.campaignData ? (this.campaignData.budget - this.summary.revenueByContents).toFixed(2) : 0;
    },
    UnRecognisedRevenueContentPercentage: function UnRecognisedRevenueContentPercentage() {
      return this.campaignData ? (this.UnRecognisedRevenueContent / this.campaignData.budget * 100).toFixed(2) : 0;
    },
    UnRecognisedRevenueEng: function UnRecognisedRevenueEng() {
      return this.campaignData ? this.campaignData.budget - this.summary.revenue : 0;
    },
    UnRecognisedRevenueEngPercentage: function UnRecognisedRevenueEngPercentage() {
      return this.campaignData ? (this.UnRecognisedRevenueEng / this.campaignData.budget * 100).toFixed(2) : 0;
    },
    outreachImpressionsTotal: function outreachImpressionsTotal() {
      var outreach = Number(this.summary && this.summary.outreach ? this.summary.outreach : 0);
      var impressions = Number(this.summary && this.summary.impressions ? this.summary.impressions : 0);
      return outreach + impressions;
    },

    numberOfReviewers: function numberOfReviewers() {
      return this.reviewers.size;
    },
    computedHeaders: function computedHeaders() {
      var _this27 = this;

      var reportCols = null;
      var headers = __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.refreshJSON(this.headers);
      headers = headers.map(function (h) {
        if (h.value === 'labels') {
          h.text = '';
        }
        return h;
      });

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.reportCols) {
          reportCols = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.reportCols);
        }
      }
      if (reportCols) {
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, reportCols);
      } else {
        headers.map(function (header) {
          if (!_this27.defaultHideCols.includes(header.value)) {
            _this27.colStatuses[header.value] = true;
          }
        });
      }
      return headers.filter(function (h) {
        if (_this27.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    }
  }),
  directives: {
    sortableDataTable: {
      bind: function bind(el, binding, vnode) {
        var items = vnode.child.items;
        var options = {
          animation: 150,
          onUpdate: function onUpdate(event) {
            vnode.child.$emit('sorted', event, items);
          }
        };
        __WEBPACK_IMPORTED_MODULE_42_sortablejs__["a" /* default */].create(el.getElementsByTagName('tbody')[0], options);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68)))

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FeedbackAccessPanel_vue__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FeedbackAccessPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__FeedbackAccessPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssignCStoCampaignModal__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssignCStoCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AssignCStoCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ChangeCampaignStatusModal__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ChangeCampaignStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ChangeCampaignStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportPasscodeModal__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReportPasscodeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ReportPasscodeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(11);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignSettings',
  components: {
    FeedbackAccessPanel: __WEBPACK_IMPORTED_MODULE_9__FeedbackAccessPanel_vue___default.a,
    AssignCsToCampaignModal: __WEBPACK_IMPORTED_MODULE_10__AssignCStoCampaignModal___default.a,
    ChangeStatusModal: __WEBPACK_IMPORTED_MODULE_11__ChangeCampaignStatusModal___default.a,
    ReportPasscodeModal: __WEBPACK_IMPORTED_MODULE_12__ReportPasscodeModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal___default.a
  },
  props: {
    value: Boolean,
    campaign: Object
  },
  data: function data() {
    return {
      currentTab: 'tab-brief',
      assignCsToCampaignDialog: false,
      postAnalysisColSettingsDialog: false,
      postAnalysisTableColsItems: [],
      storyAnalysisColSettingsDialog: false,
      storyAnalysisTableColsItems: [],
      tiktokAnalysisColSettingsDialog: false,
      tiktokAnalysisTableColsItems: [],
      reelAnalysisColSettingsDialog: false,
      reelAnalysisTableColsItems: [],
      youtubeAnalysisColSettingsDialog: false,
      youtubeAnalysisTableColsItems: [],
      fbAnalysisColSettingsDialog: false,
      fbAnalysisTableColsItems: [],
      linkedInAnalysisColSettingsDialog: false,
      linkedInAnalysisTableColsItems: [],
      twitterAnalysisColSettingsDialog: false,
      twitterAnalysisTableColsItems: [],
      xhsAnalysisColSettingsDialog: false,
      xhsAnalysisTableColsItems: [],
      lemonAnalysisColSettingsDialog: false,
      lemonAnalysisTableColsItems: [],
      reportPasscodeDialog: false,
      changeCampaignStatusDialog: false,
      campaignData: null,
      campaignDataForStatusChange: null,
      campaignDataForCsAssign: null,
      submittingData: {
        settings: {
          sendWeeklyReport: false,
          autoUpdate: false,
          showBudgetToClient: false,
          enableVideoBrief: false,
          enableEventBrief: false,
          enablePostAnalysis: false,
          enableStoryAnalysis: false,
          enableReelAnalysis: false,
          enableTikTokAnalysis: false,
          enableYoutubeAnalysis: false,
          enableFbAnalysis: false,
          enableLinkedInAnalysis: false,
          enableTwitterAnalysis: false,
          enableXHSAnalysis: false,
          enableLemonAnalysis: false,
          enableOverallSection: false,

          postAnalysisStatus: {},
          storyAnalysisStatus: {},
          reelAnalysisStatus: {},
          tiktokAnalysisStatus: {},
          youtubeAnalysisStatus: {},
          fbAnalysisStatus: {},
          linkedInAnalysisStatus: {},
          twitterAnalysisStatus: {},
          xhsAnalysisStatus: {},
          lemonAnalysisStatus: {}
        }
      },

      defaultPostsAnalysisStatus: {
        showEngagement: true,
        showEngagementView: false,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false,
        showBookmarks: false,
        showShares: false,
        showInteractions: false,
        showViews: false,
        likes: false,
        comments: false,
        shares: false,
        showReach: false,
        showImpressions: false,
        showPlays: false,
        showWatches: false,
        liveDate: false,
        url: false
      },
      defaultStoryAnalysisStatus: {
        showShares: true,
        showReplies: true,
        showLinkClicks: true,
        showStickerTaps: true,
        showInteractions: false,
        showReach: false,
        showImpressions: false,
        showAvgViews: false,
        showAvgReelsPlays: false,
        liveDate: false
      },
      defaultReelAnalysisStatus: {
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false,
        showBookmarks: true,
        showShares: false,
        showInteractions: false,
        showViews: false,
        likes: true,
        comments: false,
        shares: true,
        showReach: false,
        showImpressions: false,
        showPlays: false,
        showWatches: false,
        liveDate: false,
        url: false
      },
      defaultTikTokAnalysisStatus: {
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateTotalViewers: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showViews: false,
        likes: false,
        comments: false,
        shares: false,
        showBookmarks: true,
        showInteractions: false,
        showReach: false,
        showImpressions: false,
        showPlays: false,
        showWatches: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        avgSaves: false,
        avgShares: false,
        showWatchedFullVideo: false,
        liveDate: false,
        url: false
      },
      defaultYoutubeAnalysisStatus: {
        showEngagement: true,
        showEngagementView: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showViews: false,
        likes: false,
        comments: false,
        showInteractions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        liveDate: false,
        url: false
      },
      defaultFbAnalysisStatus: {
        showLikes: true,
        showComments: true,
        showViews: true,
        showShares: true,
        showBookmarks: false,
        showInteractions: false,
        liveDate: false,
        url: false,
        showReach: false
      },
      defaultLinkedInAnalysisStatus: {
        liveDate: false,
        url: false,
        showImpressions: true,
        showReach: true,
        showVideoViews: true,
        showProfileViewers: true,
        showLikes: true,
        showComments: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      defaultTwitterAnalysisStatus: {
        liveDate: false,
        url: false,
        showImpressions: true,
        showComments: true,
        showLikes: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      defaultXHSAnalysisStatus: {
        showViews: true,
        showWatches: true,
        showLikes: true,
        showComments: true,
        showBookmarks: false,
        showShares: true,
        showInteractions: false,
        liveDate: false,
        url: false,
        showReach: false
      },
      defaultLemonAnalysisStatus: {
        showViews: true,
        showWatches: true,
        showLikes: true,
        showComments: true,
        showBookmarks: false,
        showShares: true,
        showInteractions: false,
        liveDate: false,
        url: false,
        showReach: false
      },

      postAnalysisColumns: [{
        name: 'liveDate',
        label: 'Live Date'
      }, {
        name: 'url',
        label: 'Post URL'
      }, {
        name: 'outreach',
        label: 'Audience Size'
      }, {
        name: 'showReach',
        label: 'Accounts Reached'
      }, {
        name: 'showImpressions',
        label: 'Impressions'
      }, {
        name: 'likes',
        label: 'Likes'
      }, {
        name: 'showShares',
        label: 'Shares'
      }, {
        name: 'comments',
        label: 'Comments'
      }, {
        name: 'showBookmarks',
        label: 'Bookmarks'
      }, {
        name: 'showInteractions',
        label: 'Interactions'
      }, {
        name: 'showEngagement',
        label: 'Engagement Rate by Audience Size'
      }, {
        name: 'showEngRateReach',
        label: 'Engagement Rate by Reach'
      }, {
        name: 'showAvgEngagement',
        label: 'Avg. Engagement Rate'
      }, {
        name: 'showMediaEngagement',
        label: 'Median Engagement Rate'
      }, {
        name: 'showAvgLikes',
        label: 'Average Likes'
      }, {
        name: 'showAvgComments',
        label: 'Average Comments'
      }, {
        name: 'showAvgViews',
        label: 'Average Views'
      }],
      storyAnalysisColumns: [{ name: 'showShares', label: 'Shares' }, { name: 'showReplies', label: 'Replies' }, { name: 'showLinkClicks', label: 'Links Click' }, { name: 'showStickerTaps', label: 'Sticker Taps' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showReach', label: 'Reach' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'showAvgViews', label: 'Average Views' }, { name: 'showAvgReelsPlays', label: 'Average Reels Plays' }, { name: 'liveDate', label: 'Live Date' }],
      reelAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'outreach', label: 'Audience Size' }, { name: 'showReach', label: 'Accounts Reached' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'likes', label: 'Likes' }, { name: 'comments', label: 'Comments' }, { name: 'showBookmarks', label: 'Bookmarks' }, { name: 'showShares', label: 'Shares' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showViews', label: 'Plays' }, { name: 'showPlays', label: 'Watch Time' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showAvgReelsPlays', label: 'Avg Reels Plays' }, { name: 'showEngagement', label: 'Engagement Rate by Audience Size' }, { name: 'showEngagementView', label: 'Play Rate (by Audience Size)' }, { name: 'showInteractionPlays', label: 'Engagement Rate by Plays' }, { name: 'showEngRateReach', label: 'Engagement Rate by Reach' }, { name: 'showAvgEngagement', label: 'Avg. Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }, { name: 'showAvgLikes', label: 'Average Likes' }, { name: 'showAvgComments', label: 'Average Comments' }, { name: 'showAvgViews', label: 'Average Views' }],
      tiktokAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'outreach', label: 'Audience Size' }, { name: 'showReach', label: 'Accounts Reached' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'likes', label: 'Likes' }, { name: 'comments', label: 'Comments' }, { name: 'shares', label: 'Shares' }, { name: 'showBookmarks', label: 'Bookmarks' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'showViews', label: 'Plays' }, { name: 'showPlays', label: 'Total Play Time' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showWatchedFullVideo', label: 'Watched Full Video' }, { name: 'showEngagement', label: 'Engagement Rate by Audience Size' }, { name: 'showEngagementView', label: 'Play Rate (by Audience Size)' }, { name: 'showInteractionPlays', label: 'Engagement Rate by Plays' }, { name: 'showEngRateTotalViewers', label: 'Engagement Rate by Accounts Reached' }, { name: 'showAvgEngagement', label: 'Avg. Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }, { name: 'avgViews', label: 'Average Views' }, { name: 'avgLikes', label: 'Average Likes' }, { name: 'avgComments', label: 'Average Comments' }, { name: 'avgSaves', label: 'Average Saves' }, { name: 'avgShares', label: 'Average Shares' }],
      youtubeAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'showEngagement', label: 'Engagement Rate by Interactions' }, { name: 'showEngagementView', label: 'Engagement Rate by Views' }, { name: 'showAvgEngagement', label: 'Average Engagement Rate' }, { name: 'showMediaEngagement', label: 'Median Engagement Rate' }, { name: 'showViews', label: 'Total Views' }, { name: 'likes', label: 'Likes' }, { name: 'comments', label: 'Comments' }, { name: 'showInteractions', label: 'Interactions' }, { name: 'avgViews', label: 'Average Views' }, { name: 'avgLikes', label: 'Average Likes' }, { name: 'avgComments', label: 'Average Comments' }],
      fbAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'showShares', label: 'Shares' }, { name: 'showLikes', label: 'Likes' }, { name: 'showComments', label: 'Comments' }, { name: 'showViews', label: 'Views' }, { name: 'showReach', label: 'Reach' }, { name: 'showBookmarks', label: 'Bookmarks' }, { name: 'showInteractions', label: 'Interactions' }],
      linkedInAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'showReach', label: 'Members reached' }, { name: 'showVideoViews', label: 'Video views' }, { name: 'showProfileViewers', label: 'Profile viewers from this post' }, { name: 'showLikes', label: 'Reactions' }, { name: 'showComments', label: 'Comments' }, { name: 'showShares', label: 'Reposts' }, { name: 'showBookmarks', label: 'Saves' }],
      twitterAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'url', label: 'Post URL' }, { name: 'showImpressions', label: 'Impressions' }, { name: 'showComments', label: 'Replies' }, { name: 'showLikes', label: 'Likes' }, { name: 'showShares', label: 'Reposts' }, { name: 'showBookmarks', label: 'Bookmarks' }],
      xhsAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'showReach', label: 'Reach' }, { name: 'showViews', label: 'Views' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showLikes', label: 'Likes' }, { name: 'showBookmarks', label: 'Saves' }, { name: 'showComments', label: 'Comments' }, { name: 'showShares', label: 'Shares' }, { name: 'showInteractions', label: 'Interactions' }],
      lemonAnalysisColumns: [{ name: 'liveDate', label: 'Live Date' }, { name: 'showReach', label: 'Reach' }, { name: 'showViews', label: 'Views' }, { name: 'showWatches', label: 'Average Watch Time' }, { name: 'showLikes', label: 'Likes' }, { name: 'showBookmarks', label: 'Saves' }, { name: 'showComments', label: 'Comments' }, { name: 'showShares', label: 'Shares' }, { name: 'showInteractions', label: 'Interactions' }],

      show1: false,
      passcodeCopied: false,
      reportLink: '',
      aiReportLink: '',
      aiReportLinkCopied: false,
      feedbackLink: '',
      isCopyFeedback: false,
      linkCopied: false,
      reportLinkCopied: false,
      brandLinkCopied: false,
      brandSheetLink: ''
    };
  },

  methods: {
    getOrderedColumns: function getOrderedColumns(columnDefs, currentStatus, defaultStatus) {
      var currentOrder = [];
      var currentKeys = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a();

      if (currentStatus && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(currentStatus).length > 0) {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(currentStatus).forEach(function (key) {
          var colDef = columnDefs.find(function (c) {
            return c.name === key;
          });
          if (colDef) {
            currentOrder.push({
              title: colDef.label,
              key: key,
              value: currentStatus[key]
            });
            currentKeys.add(key);
          }
        });
      }

      columnDefs.forEach(function (colDef) {
        if (!currentKeys.has(colDef.name)) {
          currentOrder.push({
            title: colDef.label,
            key: colDef.name,

            value: defaultStatus.hasOwnProperty(colDef.name) ? defaultStatus[colDef.name] : false
          });
          currentKeys.add(colDef.name);
        }
      });
      return currentOrder;
    },
    updateColumnsStatus: function updateColumnsStatus(items, campaignDataProp, dialogProp) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newStatusObject, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newStatusObject = {};

                items.forEach(function (item) {
                  newStatusObject[item.key] = item.value;
                });

                data = [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
                  id: _this.campaignData.id
                }, campaignDataProp, newStatusObject))];
                _context.prev = 3;
                _context.next = 6;
                return _this.$store.dispatch('campaign/updateCampaignByIds', data);

              case 6:
                _this.campaignData[campaignDataProp] = newStatusObject;
                _this[dialogProp] = false;

                _this.$swal.fire({
                  type: 'success',
                  title: 'Updated!',
                  text: 'Column settings saved successfully.',
                  showCancelButton: false,
                  width: 300
                });
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](3);

                console.error('Error updating campaign settings:', _context.t0);
                _this.$swal.fire({
                  type: 'error',
                  title: 'Error',
                  text: 'Failed to save column settings. Please try again.',
                  showCancelButton: false,
                  width: 300
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 11]]);
      }))();
    },
    initializePostAnalysisTableCols: function initializePostAnalysisTableCols() {
      this.postAnalysisTableColsItems = this.getOrderedColumns(this.postAnalysisColumns, this.campaignData.postAnalysisStatus, this.defaultPostsAnalysisStatus);
    },
    openPostAnalysisColSettingsModal: function openPostAnalysisColSettingsModal() {
      this.initializePostAnalysisTableCols();
      this.postAnalysisColSettingsDialog = true;
    },
    updatePostAnalysisStatus: function updatePostAnalysisStatus(items) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.updateColumnsStatus(items, 'postAnalysisStatus', 'postAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    initializeStoryAnalysisTableCols: function initializeStoryAnalysisTableCols() {
      this.storyAnalysisTableColsItems = this.getOrderedColumns(this.storyAnalysisColumns, this.campaignData.storyAnalysisStatus, this.defaultStoryAnalysisStatus);
    },
    openStoryAnalysisColSettingsModal: function openStoryAnalysisColSettingsModal() {
      this.initializeStoryAnalysisTableCols();
      this.storyAnalysisColSettingsDialog = true;
    },
    updateStoryAnalysisStatus: function updateStoryAnalysisStatus(items) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.updateColumnsStatus(items, 'storyAnalysisStatus', 'storyAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    initializeReelAnalysisTableCols: function initializeReelAnalysisTableCols() {
      this.reelAnalysisTableColsItems = this.getOrderedColumns(this.reelAnalysisColumns, this.campaignData.reelAnalysisStatus, this.defaultReelAnalysisStatus);
    },
    openReelAnalysisColSettingsModal: function openReelAnalysisColSettingsModal() {
      this.initializeReelAnalysisTableCols();
      this.reelAnalysisColSettingsDialog = true;
    },
    updateReelAnalysisStatus: function updateReelAnalysisStatus(items) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.updateColumnsStatus(items, 'reelAnalysisStatus', 'reelAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    initializeTikTokAnalysisTableCols: function initializeTikTokAnalysisTableCols() {
      this.tiktokAnalysisTableColsItems = this.getOrderedColumns(this.tiktokAnalysisColumns, this.campaignData.tikTokAnalysisStatus, this.defaultTikTokAnalysisStatus);
    },
    openTikTokAnalysisColSettingsModal: function openTikTokAnalysisColSettingsModal() {
      this.initializeTikTokAnalysisTableCols();
      this.tiktokAnalysisColSettingsDialog = true;
    },
    updateTikTokAnalysisStatus: function updateTikTokAnalysisStatus(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.updateColumnsStatus(items, 'tikTokAnalysisStatus', 'tiktokAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    initializeYoutubeAnalysisTableCols: function initializeYoutubeAnalysisTableCols() {
      this.youtubeAnalysisTableColsItems = this.getOrderedColumns(this.youtubeAnalysisColumns, this.campaignData.youtubeAnalysisStatus, this.defaultYoutubeAnalysisStatus);
    },
    openYoutubeAnalysisColSettingsModal: function openYoutubeAnalysisColSettingsModal() {
      this.initializeYoutubeAnalysisTableCols();
      this.youtubeAnalysisColSettingsDialog = true;
    },
    updateYoutubeAnalysisStatus: function updateYoutubeAnalysisStatus(items) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.updateColumnsStatus(items, 'youtubeAnalysisStatus', 'youtubeAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    initializeFbAnalysisTableCols: function initializeFbAnalysisTableCols() {
      this.fbAnalysisTableColsItems = this.getOrderedColumns(this.fbAnalysisColumns, this.campaignData.fbAnalysisStatus, this.defaultFbAnalysisStatus);
    },
    openFbAnalysisColSettingsModal: function openFbAnalysisColSettingsModal() {
      this.initializeFbAnalysisTableCols();
      this.fbAnalysisColSettingsDialog = true;
    },
    updateFbAnalysisStatus: function updateFbAnalysisStatus(items) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.updateColumnsStatus(items, 'fbAnalysisStatus', 'fbAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    initializeLinkedInAnalysisTableCols: function initializeLinkedInAnalysisTableCols() {
      this.linkedInAnalysisTableColsItems = this.getOrderedColumns(this.linkedInAnalysisColumns, this.campaignData.linkedInAnalysisStatus, this.defaultLinkedInAnalysisStatus);
    },
    openLinkedInAnalysisColSettingsModal: function openLinkedInAnalysisColSettingsModal() {
      this.initializeLinkedInAnalysisTableCols();
      this.linkedInAnalysisColSettingsDialog = true;
    },
    updateLinkedInAnalysisStatus: function updateLinkedInAnalysisStatus(items) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this8.updateColumnsStatus(items, 'linkedInAnalysisStatus', 'linkedInAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    initializeTwitterAnalysisTableCols: function initializeTwitterAnalysisTableCols() {
      this.twitterAnalysisTableColsItems = this.getOrderedColumns(this.twitterAnalysisColumns, this.campaignData.twitterAnalysisStatus, this.defaultTwitterAnalysisStatus);
    },
    openTwitterAnalysisColSettingsModal: function openTwitterAnalysisColSettingsModal() {
      this.initializeTwitterAnalysisTableCols();
      this.twitterAnalysisColSettingsDialog = true;
    },
    updateTwitterAnalysisStatus: function updateTwitterAnalysisStatus(items) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.updateColumnsStatus(items, 'twitterAnalysisStatus', 'twitterAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    initializeXHSAnalysisTableCols: function initializeXHSAnalysisTableCols() {
      this.xhsAnalysisTableColsItems = this.getOrderedColumns(this.xhsAnalysisColumns, this.campaignData.xhsAnalysisStatus, this.defaultXHSAnalysisStatus);
    },
    openXHSAnalysisColSettingsModal: function openXHSAnalysisColSettingsModal() {
      this.initializeXHSAnalysisTableCols();
      this.xhsAnalysisColSettingsDialog = true;
    },
    updateXHSAnalysisStatus: function updateXHSAnalysisStatus(items) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this10.updateColumnsStatus(items, 'xhsAnalysisStatus', 'xhsAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    initializeLemonAnalysisTableCols: function initializeLemonAnalysisTableCols() {
      this.lemonAnalysisTableColsItems = this.getOrderedColumns(this.lemonAnalysisColumns, this.campaignData.lemonAnalysisStatus, this.defaultLemonAnalysisStatus);
    },
    openLemonAnalysisColSettingsModal: function openLemonAnalysisColSettingsModal() {
      this.initializeLemonAnalysisTableCols();
      this.lemonAnalysisColSettingsDialog = true;
    },
    updateLemonAnalysisStatus: function updateLemonAnalysisStatus(items) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this11.updateColumnsStatus(items, 'lemonAnalysisStatus', 'lemonAnalysisColSettingsDialog');

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    changeCampaignStatus: function changeCampaignStatus() {
      this.campaignDataForStatusChange = this.campaignData;
      this.changeCampaignStatusDialog = !this.changeCampaignStatusDialog;
    },
    startAssignCS: function startAssignCS() {
      this.campaignDataForCsAssign = this.campaignData;
      this.assignCsToCampaignDialog = !this.assignCsToCampaignDialog;
    },
    startReportPasscode: function startReportPasscode() {
      this.reportPasscodeDialog = !this.reportPasscodeDialog;
    },
    close: function close() {
      this.$emit('input');
    },
    save: function save() {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_8__campaignAPIs__["a" /* default */].updateCampaignSetting(this.campaignData.id, this.submittingData).then(function (response) {
        console.log('update success');
        _this12.reload();
        _this12.close();
      }).catch(function (error) {
        console.log(error);
      });
    },
    reload: function reload() {
      this.close();
      this.$emit('saved', true);
    },
    copyReportLink: function copyReportLink() {
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.reportLink = protocol + '//' + host + '/reports/campaign/summary?id=' + this.campaignData.id;
      var vm = this;
      setTimeout(function () {
        vm.reportLinkCopied = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.copyToClipboard('#copy-reportlink');
      }, 100);
      setTimeout(function () {
        vm.reportLinkCopied = false;
      }, 1000);
    },
    copyAIReportLink: function copyAIReportLink() {
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.aiReportLink = protocol + '//' + host + '/reports/campaign/html?id=' + this.campaignData.id + '&passcode=' + encodeURIComponent(this.campaignData.passcode || '');
      var vm = this;
      setTimeout(function () {
        vm.aiReportLinkCopied = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.copyToClipboard('#copy-ai-reportlink');
      }, 100);
      setTimeout(function () {
        vm.aiReportLinkCopied = false;
      }, 1000);
    },
    copyBrandSheetLink: function copyBrandSheetLink() {
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.brandSheetLink = protocol + '//' + host + __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].BRAND_SHEET_FORM_URL + '/' + this.campaignData.id;
      var vm = this;
      setTimeout(function () {
        vm.brandLinkCopied = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.copyToClipboard('#copy-brand-link');
      }, 100);
      setTimeout(function () {
        vm.brandLinkCopied = false;
      }, 1000);
    },
    copyFeedbackShow: function copyFeedbackShow() {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userPermissions']['campaign']['clientFeedback'];
      if (Array.isArray(buttonPermission) && this.selectedAMList.length) {
        return buttonPermission.includes(this.currentUserRole);
      }
      return false;
    },
    copyReportPasscode: function copyReportPasscode() {
      var vm = this;
      setTimeout(function () {
        vm.passcodeCopied = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.copyToClipboard('#copy-passcode');
      }, 100);
      setTimeout(function () {
        vm.passcodeCopied = false;
      }, 1000);
    },
    fetchAMlist: function fetchAMlist(assignedTo) {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (resp) {
        _this13.accountManagers = resp.users;
        if (assignedTo) {
          resp.users.map(function (item) {
            assignedTo.map(function (id) {
              if (item.id === id) {
                _this13.selectedAMList.push(id);
              }
            });
          });

          _this13.isCopyFeedback = _this13.copyFeedbackShow();
        }
      }).catch(function (err) {
        return console.error(err);
      });
    }
  },
  computed: {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isCampaignPasscode: function isCampaignPasscode() {
      if (this.campaignData.passcode) {
        return true;
      }
      return false;
    }
  },
  watch: {
    campaign: function campaign(newCampaign) {
      if (newCampaign !== null) {
        var settings = newCampaign.settings || {};
        this.campaignData = newCampaign;

        this.submittingData.settings.showBudgetToClient = settings.showBudgetToClient || false;
        this.submittingData.settings.enableVideoBrief = settings.enableVideoBrief || false;
        this.submittingData.settings.enableEventBrief = settings.enableEventBrief || false;
        this.submittingData.settings.enablePostAnalysis = settings.enablePostAnalysis || false;
        this.submittingData.settings.enableStoryAnalysis = settings.enableStoryAnalysis || false;
        this.submittingData.settings.enableReelAnalysis = settings.enableReelAnalysis || false;
        this.submittingData.settings.enableTikTokAnalysis = settings.enableTikTokAnalysis || false;
        this.submittingData.settings.enableYoutubeAnalysis = settings.enableYoutubeAnalysis || false;
        this.submittingData.settings.enableFbAnalysis = settings.enableFbAnalysis || false;
        this.submittingData.settings.enableLinkedInAnalysis = settings.enableLinkedInAnalysis || false;
        this.submittingData.settings.enableTwitterAnalysis = settings.enableTwitterAnalysis || false;
        this.submittingData.settings.enableXHSAnalysis = settings.enableXHSAnalysis || false;
        this.submittingData.settings.enableLemonAnalysis = settings.enableLemonAnalysis || false;
        this.submittingData.settings.enableOverallSection = settings.enableOverallSection || false;
        this.submittingData.settings.sendWeeklyReport = settings.sendWeeklyReport || false;
        this.submittingData.settings.autoUpdate = settings.autoUpdate || false;

        this.campaignData.postAnalysisStatus = this.campaignData.postAnalysisStatus || {};
        this.initializePostAnalysisTableCols();

        this.campaignData.storyAnalysisStatus = this.campaignData.storyAnalysisStatus || {};
        this.initializeStoryAnalysisTableCols();

        this.campaignData.reelAnalysisStatus = this.campaignData.reelAnalysisStatus || {};
        this.initializeReelAnalysisTableCols();

        this.campaignData.tikTokAnalysisStatus = this.campaignData.tikTokAnalysisStatus || {};
        this.initializeTikTokAnalysisTableCols();

        this.campaignData.youtubeAnalysisStatus = this.campaignData.youtubeAnalysisStatus || {};
        this.initializeYoutubeAnalysisTableCols();

        this.campaignData.fbAnalysisStatus = this.campaignData.fbAnalysisStatus || {};
        this.initializeFbAnalysisTableCols();

        this.campaignData.linkedInAnalysisStatus = this.campaignData.linkedInAnalysisStatus || {};
        this.initializeLinkedInAnalysisTableCols();

        this.campaignData.twitterAnalysisStatus = this.campaignData.twitterAnalysisStatus || {};
        this.initializeTwitterAnalysisTableCols();

        this.campaignData.xhsAnalysisStatus = this.campaignData.xhsAnalysisStatus || {};
        this.initializeXHSAnalysisTableCols();

        this.campaignData.lemonAnalysisStatus = this.campaignData.lemonAnalysisStatus || {};
        this.initializeLemonAnalysisTableCols();

        this.selectedAMList = [];
        this.fetchAMlist(this.campaignData.assignedTo);
      }
    }
  }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay_dist_vue_loading_css__);







var TIME_PERIOD = {
  THIS_MONTH: 'THIS_MONTH',
  THIS_YEAR: 'THIS_YEAR',
  THIS_QUARTER: 'THIS_QUARTER',
  LAST_QUARTER: 'LAST_QUARTER',
  CUSTOM: 'CUSTOM'
};





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  },
  data: function data(vm) {
    return {
      isLoading: false,
      MONTH_FORMAT: 'YYYY-MM',
      search: null,
      searchPeriod: { title: 'This Quarter', value: 'THIS_QUARTER' },
      periods: [{
        title: 'This Month',
        value: TIME_PERIOD.THIS_MONTH
      }, {
        title: 'This Year',
        value: TIME_PERIOD.THIS_YEAR
      }, {
        title: 'This Quarter',
        value: TIME_PERIOD.THIS_QUARTER
      }, {
        title: 'Custom',
        value: TIME_PERIOD.CUSTOM
      }],
      summary: {},
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
      menu1Date: null,
      menu2Date: null,
      headers: [],
      campaigns: [],
      months: [],
      stats: [],

      viewEngagement: true,
      viewRevenue: true,
      viewOutreach: true,
      revenueOpt: 'eng'
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.generateQuarter();
              _context.next = 3;
              return _this.fetchReports();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return month + '/' + day + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    searchPeriodChanged: function searchPeriodChanged(data) {
      var value = data.value;
      switch (value) {
        case TIME_PERIOD.THIS_MONTH:
          this.startDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format(this.MONTH_FORMAT);
          this.endDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format(this.MONTH_FORMAT);
          break;
        case TIME_PERIOD.THIS_YEAR:
          this.startDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf('year').format(this.MONTH_FORMAT);
          this.endDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf('year').format(this.MONTH_FORMAT);
          break;
        case TIME_PERIOD.THIS_QUARTER:
          var quarter = __WEBPACK_IMPORTED_MODULE_5_moment___default()().quarter();
          this.generateQuarter(quarter);
          break;
      }
    },
    fetchReports: function fetchReports() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fromOriginal, toOriginal, from, to, reports, campaigns;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                fromOriginal = __WEBPACK_IMPORTED_MODULE_5_moment___default()(_this2.startDate, _this2.MONTH_FORMAT);
                toOriginal = __WEBPACK_IMPORTED_MODULE_5_moment___default()(_this2.endDate, _this2.MONTH_FORMAT);
                from = fromOriginal.format('MM-YYYY');
                to = toOriginal.format('MM-YYYY');
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_7__campaignAPIs__["a" /* default */].getMonthlyCampaignsReport({ from: from, to: to });

              case 8:
                reports = _context2.sent;
                campaigns = reports.map(function (rp) {
                  return {
                    id: rp.id,
                    clientID: rp.clientID,
                    name: rp.name,
                    outreach: rp.outreach,
                    engagement: rp.engagement,
                    budget: rp.budget
                  };
                });

                _this2.campaigns = campaigns;
                _this2.generateStats(reports);
                _this2.generateHeaders(fromOriginal, toOriginal);
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

              case 18:
                _context2.prev = 18;

                _this2.isLoading = false;
                return _context2.finish(18);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 15, 18, 21]]);
      }))();
    },
    generateHeaders: function generateHeaders(from, to) {
      var headers = [{ text: 'Campaign', value: 'campaignName' }];
      var months = [];
      for (var date = from; date.isSameOrBefore(to); date.add(1, 'month')) {
        headers.push({
          align: 'center',
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Engagement)',
          sortable: false,
          value: 'engagement'
        });
        headers.push({
          align: 'center',
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Contents)',
          sortable: false,
          value: 'contents'
        });
        headers.push({
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Outreach)',
          sortable: false,
          value: 'outreach'
        });
        headers.push({
          month: date.format('MM-YYYY'),
          text: date.format('MMM YYYY') + '\n(Revenue)',
          sortable: false,
          value: 'revenue'
        });
        months.push(date.format('MM-YYYY'));
      }
      this.headers = headers;
      this.months = months;
    },
    generateQuarter: function generateQuarter() {
      var thisQuarter = __WEBPACK_IMPORTED_MODULE_5_moment___default()().quarter();
      var dateRage = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.getQuarterRange(thisQuarter);
      var from = dateRage.from;
      var to = dateRage.to;
      this.startDate = from.format(this.MONTH_FORMAT);
      this.endDate = to.format(this.MONTH_FORMAT);
    },
    generateStats: function generateStats(reports) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var stats, summary, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, report, data, monthlySummary, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, value, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref, _ref2, key, _value;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                stats = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                summary = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 5;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(reports); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  report = _step.value;
                  data = stats.get(report.campaignId) || {};

                  if (!stats.has(report.campaignId)) {
                    data['campaignName'] = report.campaignName;
                    data['campaignId'] = report.campaignId;
                  }
                  data[report.datetime] = report;
                  monthlySummary = summary.get(report.datetime);

                  if (monthlySummary) {
                    monthlySummary['revenue'] += report.revenue;
                    monthlySummary['engagement'] += report.engagement;
                    monthlySummary['revenueByContents'] += report.revenueByContents;
                    monthlySummary['contents'] += report.contents;
                    monthlySummary['outreach'] += report.outreach;
                    monthlySummary['revenueCalculation'] = report.revenueCalculation;
                  } else {
                    monthlySummary = {
                      revenue: report.revenue,
                      engagement: report.engagement,
                      revenueByContents: report.revenueByContents,
                      contents: report.contents,
                      outreach: report.outreach,
                      revenueCalculation: report.revenueCalculation
                    };
                  }
                  summary.set(report.datetime, monthlySummary);
                  stats.set(report.campaignId, data);
                }
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 13:
                _context3.prev = 13;
                _context3.prev = 14;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 16:
                _context3.prev = 16;

                if (!_didIteratorError) {
                  _context3.next = 19;
                  break;
                }

                throw _iteratorError;

              case 19:
                return _context3.finish(16);

              case 20:
                return _context3.finish(13);

              case 21:
                _this3.stats = [];
                _this3.summary = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 26;
                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(stats.values()); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  value = _step2.value;

                  _this3.stats.push(value);
                }
                _context3.next = 34;
                break;

              case 30:
                _context3.prev = 30;
                _context3.t1 = _context3['catch'](26);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t1;

              case 34:
                _context3.prev = 34;
                _context3.prev = 35;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 37:
                _context3.prev = 37;

                if (!_didIteratorError2) {
                  _context3.next = 40;
                  break;
                }

                throw _iteratorError2;

              case 40:
                return _context3.finish(37);

              case 41:
                return _context3.finish(34);

              case 42:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context3.prev = 45;
                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(summary.entries()); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  _ref = _step3.value;
                  _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                  key = _ref2[0];
                  _value = _ref2[1];

                  _value.revenue = Number(_value.revenue).toFixed(2);
                  _this3.summary[key] = _value;
                }
                _context3.next = 53;
                break;

              case 49:
                _context3.prev = 49;
                _context3.t2 = _context3['catch'](45);
                _didIteratorError3 = true;
                _iteratorError3 = _context3.t2;

              case 53:
                _context3.prev = 53;
                _context3.prev = 54;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 56:
                _context3.prev = 56;

                if (!_didIteratorError3) {
                  _context3.next = 59;
                  break;
                }

                throw _iteratorError3;

              case 59:
                return _context3.finish(56);

              case 60:
                return _context3.finish(53);

              case 61:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[5, 9, 13, 21], [14,, 16, 20], [26, 30, 34, 42], [35,, 37, 41], [45, 49, 53, 61], [54,, 56, 60]]);
      }))();
    },
    radioOnChangeHandler: function radioOnChangeHandler() {
      var fromOriginal = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.startDate, this.MONTH_FORMAT);
      var toOriginal = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.endDate, this.MONTH_FORMAT);
      this.generateHeaders(fromOriginal, toOriginal);
    }
  }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UpdateCampaignQuarterModal__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UpdateCampaignQuarterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UpdateCampaignQuarterModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    campaign: Object,
    campaignIds: Array
  },
  components: {
    UpdateCampaignQuarterModal: __WEBPACK_IMPORTED_MODULE_5__UpdateCampaignQuarterModal___default.a
  },
  data: function data() {
    return {
      campaignStatusDisplay: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatusDisplay,
      campaignStatuses: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatus,
      campaignData: null,
      options: [0, 1, 2, 3, 4, 5],
      selectedStatus: null,
      campaignQuarterDialog: false,
      viewCampaignId: null,
      multipleCampaignIds: []
    };
  },

  methods: {
    changeStatus: function changeStatus() {
      var _this = this;

      if (this.selectedStatus === null) {
        this.$swal({
          title: 'Error',
          type: 'error',
          text: 'Empty Status'
        });
      } else {
        if (this.selectedStatus === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatus.REVIEW) {
          this.openUpdateCampaignQuarterModal();
          return;
        }
        if (this.campaignIds && this.campaignIds.length > 0) {
          this.changeBulkCampaignStatus();
          return;
        }
        __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].changeStatus(this.campaignData.id, this.selectedStatus).then(function (response) {
          if (response.success) {
            _this.$emit('updated', true);
            _this.$emit('input');
            _this.$swal({
              title: 'Success',
              text: 'Campaign Status Changed. Do you want to go to updated stage?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No, Stay here'
            }).then(function (result) {
              if (result.value) {
                _this.$router.push({ name: _this.displayStatus(_this.selectedStatus) });
              } else {
                _this.closeModal();
              }
            });
          } else {
            _this.$swal('Campaign Status Changed Failed');
          }
        }).catch(function (err) {
          return console.error(err);
        });
      }
    },
    changeBulkCampaignStatus: function changeBulkCampaignStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].changeBulkStatus(this.campaignIds, this.selectedStatus).then(function (response) {
        if (response.success) {
          _this2.$emit('updated', true);
          _this2.$emit('input');
          _this2.$swal({
            title: 'Success',
            text: 'Campaign Status Changed. Do you want to go to updated stage?',
            type: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, Stay here'
          }).then(function (result) {
            if (result.value) {
              _this2.$router.push({ name: _this2.displayStatus(_this2.selectedStatus) });
            } else {
              _this2.closeModal();
            }
          });
        } else {
          _this2.$swal('Campaign Status Changed Failed');
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    openUpdateCampaignQuarterModal: function openUpdateCampaignQuarterModal() {
      var _this3 = this;

      this.$swal({
        title: 'Push to Review',
        html: 'Are you sure you want to push to review stage',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (result.value) {
                    if (_this3.campaignIds && _this3.campaignIds.length > 0) {
                      _this3.multipleCampaignIds = _this3.campaignIds;
                    } else {
                      _this3.viewCampaignId = _this3.campaignData.id;
                    }
                    _this3.campaignQuarterDialog = true;
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    displayStatus: function displayStatus(status) {
      return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatusDisplay[status]['display'] + ' campaigns';
    },
    closeModal: function closeModal() {
      this.$emit('updated', true);
      this.$emit('input');
    }
  },
  computed: {
    status_options: function status_options() {
      var _this4 = this;

      var data = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.campaignStatuses).forEach(function (item) {
        if (item[1] !== _this4.campaignStatuses.RATE_CARD && item[1] !== _this4.campaignStatuses.PAIRING_BRIEF) {
          data.push({
            status: item[1],
            display: _this4.campaignStatusDisplay[item[1]]['display'] + ' campaigns'
          });
        }
      });
      return data;
    }
  },
  watch: {
    campaign: function campaign(newCampaign) {
      if (newCampaign !== null) {
        this.campaignData = newCampaign;
        this.selectedStatus = newCampaign.status;
      }
    }
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Company_companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UsageCircularBox_vue__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UsageCircularBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__UsageCircularBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__static_sources_countries__);




























var campaignData = {
  companyID: '',
  clientID: '',
  enableVideoBrief: false
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateCampaignModal',
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      submitting: false,
      showVideoBrief: false,
      showEventBrief: false,
      company_options: [],
      allClients: [],
      selectedClient: null,
      search: null,
      startCal: false,
      endCal: false,
      startTimeDialog: false,
      endTimeDialog: false,
      eventDateDialog: false,
      videoDateDialog: false,
      previewImage: null,
      clientAccountSummary: {
        clientID: null,
        budgetUsage: 0,
        campaignUsage: 0,
        contentUsage: 0,
        outReachUsage: 0,
        engagementUsage: 0,
        usedBudget: 0,
        usedCampaigns: 0,
        usedContent: 0,
        usedEngagement: 0,
        usedOutreach: 0
      },
      clientCampaigns: [],
      campaign: campaignData,
      campaignModelSections: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignModelSections,
      campaignModelSectionType: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignModelSectionType,
      images: [],
      angelOptions: [],
      viewClientData: null,
      viewClientDialog: false,
      AM: [],
      selectedAM: [],
      CO: [],
      selectedCO: [],
      dedicatedPersons: [],
      supportingPersons: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      IONumberItems: [],
      campaignVerticals: [],
      selectedCampaignVertical: [],
      newCampaignVertical: '',
      countries: [] };
  },

  components: {
    UsageBox: __WEBPACK_IMPORTED_MODULE_14__UsageCircularBox_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay___default.a,
    ViewClientModal: __WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default.a
  },
  validations: function validations() {
    var validationRules = {
      campaign: {}
    };
    this.campaignModelSections.forEach(function (section) {
      section.content.forEach(function (field) {
        if (field.validations && field.validations.length > 0) {
          field.validations.forEach(function (validation) {
            validationRules['campaign'][field.name] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, validation.name, validation.value);
          });
        }
      });
    });

    return validationRules;
  },
  watch: {
    showVideoBrief: function showVideoBrief(val) {
      this.campaign.settings = { enableVideoBrief: val };
    },
    showEventBrief: function showEventBrief(val) {
      this.campaign.settings = { enableEventBrief: val };
    },
    selectedCampaignVertical: function selectedCampaignVertical(val, prev) {
      var _this = this;

      if (val.length === prev.length) return;

      this.selectedCampaignVertical = val.map(function (v) {
        if (typeof v === 'string') {
          v = {
            id: 0,
            name: v
          };
          _this.campaignVerticals.push(v);
        }

        return v;
      });
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    client_options: function client_options() {
      var clientList = [];
      this.allClients.forEach(function (element) {
        var client = {
          name: element.name,
          id: element.id
        };
        clientList.push(client);
      });
      return clientList;
    },
    needCompany: function needCompany() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW) {
        return false;
      } else if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      }

      return false;
    },
    needClient: function needClient() {
      if (this.needCompany || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        return true;
      }

      return false;
    }
  },
  methods: {
    close: function close() {
      this.clearData();
      this.$emit('input');
    },

    getUsage: function getUsage(used, available) {
      return Math.ceil(used / available * 100);
    },
    getMaxValueOf: function getMaxValueOf(campaignFieldName) {
      if (this.selectedClient === null || this.clientAccountSummary === null) {
        return;
      } else {
        switch (campaignFieldName) {
          case 'budget':
            return this.selectedClient.account.budget - this.clientAccountSummary.usedBudget;
          case 'outreach':
            return this.selectedClient.account.totalOutreach - this.clientAccountSummary.usedOutreach;
          case 'engagement':
            return this.selectedClient.account.totalEngagement - this.clientAccountSummary.usedEngagement;
          case 'min_content':
            return this.selectedClient.account.maxContent - this.clientAccountSummary.usedContent;
          case 'max_content':
            return this.selectedClient.account.maxContent - this.clientAccountSummary.usedContent;
          default:
            return 0;
        }
      }
    },
    addMoreImage: function addMoreImage(optionIndex, secondOptionIndex) {
      var _this2 = this;

      var el = document.getElementById('optionImages_' + optionIndex + '_' + secondOptionIndex);
      var img = this.renderImageSelection(optionIndex, secondOptionIndex);
      var imgId = img.id;
      el.insertAdjacentHTML('beforeend', img.html);
      var btnRemove = document.getElementById('btnRemove_' + imgId);
      var inputFile = document.getElementById('inputFile_' + imgId);
      btnRemove.addEventListener('click', function () {
        _this2.removeImage(optionIndex, imgId);
      });
      inputFile.addEventListener('change', function (event) {
        _this2.processImage(event, 'angel', optionIndex, secondOptionIndex, imgId);
      });
      var imageRadio = document.getElementById('radio_image_' + imgId);
      imageRadio.addEventListener('change', function (event) {
        _this2.changeOptionType(imgId, 'image');
      });
      var linkRadio = document.getElementById('radio_link_' + imgId);
      linkRadio.addEventListener('change', function (event) {
        _this2.changeOptionType(imgId, 'link');
      });
      var videoLinkInput = document.getElementById('video_link_' + imgId);
      videoLinkInput.addEventListener('change', function (event) {
        _this2.changeVideoLink('angel', optionIndex, secondOptionIndex, imgId);
      });
    },
    removeImage: function removeImage(optionIndex, imgId) {
      var el = document.getElementById('input_group_' + imgId);
      el.remove();
      __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.removeElementFromArray(this.images, imgId, 'imgId', __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].TYPE.OBJECT);
      __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.removeElementFromArray(this.angelOptions, imgId, 'imgId', __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].TYPE.OBJECT);
    },
    renderImageSelection: function renderImageSelection(optionIndex) {
      var imgIndex = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.makeid(6);
      return {
        html: '\n        <div class="input-group pb-2" id="input_group_' + imgIndex + '">\n          <label class="pr-2">\n            <input type=\'radio\' id="radio_image_' + imgIndex + '" name="type_' + imgIndex + '" value=\'image\' checked="true" /> Image\n          </label>\n          <label>\n            <input type=\'radio\' id="radio_link_' + imgIndex + '" name="type_' + imgIndex + '" value=\'link\' /> Video Link\n          </label>\n          <div>\n            <input type="text" class="custom-input" style="display:none" id="video_link_' + imgIndex + '" />\n          </div>\n          <div\n            class="image-input" id="img_upload_' + imgIndex + '"\n          >\n            <input\n              type="file"\n              id="inputFile_' + imgIndex + '"\n              ref="files"\n            />\n          </div>\n        </div>\n        <button\n          type="button"\n          id="btnRemove_' + imgIndex + '"\n          class="btn btn-link btn-link-danger btn-remove-input"\n        >Remove</button>',
        id: imgIndex
      };
    },

    setClientData: function setClientData(clientID) {
      var _this3 = this;

      this.getSummaryAccountDetails(clientID);
      this.getClientData(clientID);
      this.allClients.map(function (client) {
        if (client.id === clientID) {
          _this3.selectedClient = client;
        }
      });
      this.getCampaignsByClientID(clientID);
    },
    getSummaryAccountDetails: function getSummaryAccountDetails(clientID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_11__Client_clientAPIs__["a" /* default */].getClientAccountSummary(clientID).then(function (response) {
        response.deals.map(function (item) {
          _this4.IONumberItems.push(item.IO);
        });
        _this4.clientAccountSummary = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, response);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getClientData: function getClientData(clientID) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_11__Client_clientAPIs__["a" /* default */].getClient(clientID).then(function (response) {
        _this5.viewClientData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, response);
        _this5.getPersonsFromClient(_this5.viewClientData.handledBy, _this5.viewClientData.supportedBy || []);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getCampaignsByClientID: function getCampaignsByClientID(clientID) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_9__campaignAPIs__["a" /* default */].getCampaignsByClientID(clientID).then(function (response) {
        _this6.campaignModelSections = _this6.campaignModelSections.map(function (section) {
          if (section.type === _this6.campaignModelSectionType.CAMPAIGN_SUMMARY) {
            section.content.forEach(function (field) {
              if (field.name === 'name') {
                field.value = [];
                _this6.clientCampaigns = response.campaigns;
                response.campaigns.map(function (c) {
                  field.value.push(c.name);
                });
              }
            });
          }
          return section;
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getPersonsFromClient: function getPersonsFromClient(handledBy) {
      var _this7 = this;

      var supportedBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      this.dedicatedPersons = [];
      this.selectedDedicatedPersons = [];
      this.supportingPersons = [];
      this.selectedSupportingPersons = [];

      handledBy.map(function (userId) {
        __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__["a" /* default */].getUser(userId).then(function (response) {
          _this7.dedicatedPersons.push(response);
          _this7.selectedDedicatedPersons.push(response);
        }).catch(function (error) {
          console.log('error', error);
        });
      });
      supportedBy.map(function (userId) {
        __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__["a" /* default */].getUser(userId).then(function (response) {
          _this7.supportingPersons.push(response);
          _this7.selectedSupportingPersons.push(response);
        }).catch(function (error) {
          console.log('error', error);
        });
      });
    },
    createCampaign: function createCampaign() {
      var _this8 = this;

      if (this.campaign.campaignType === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignType.NO_PREFERENCE) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please Select Campaign Type.'
        });
        return;
      } else if (this.selectedCampaignVertical.length === 0) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please Select Campaign Vertical.'
        });
        return;
      }
      var campaign = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.campaign);
      var campaignID = campaign.id;

      campaign['vertical'] = this.selectedCampaignVertical;

      campaign.assignedTo = this.selectedDedicatedPersons.map(function (d) {
        return d.id;
      });
      campaign.assignedSupportingTo = this.selectedSupportingPersons.map(function (sp) {
        return sp.id;
      });

      campaign['targetAge'] = campaign['targetAge'] ? campaign['targetAge'].map(function (t) {
        return t.value;
      }) : [];

      if (campaign['targetLocation']) {
        campaign['targetLocation'] = campaign['targetLocation'].map(function (v) {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            };
          }
          return v;
        });
      }

      campaign['platform'] = campaign['platform'] ? campaign['platform'].map(function (t) {
        return t.value;
      }) : [];

      campaign['segment'] = campaign['segment'] ? campaign['segment'].map(function (t) {
        return t.value;
      }) : [];

      if (this.needCompany === false) {
        delete campaign.companyID;
      }
      var formData = new FormData();
      formData.append('campaign', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(campaign));
      formData.append('angelOptions', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.angelOptions));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.images), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('images', val.element);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this8.submitting = true;

          __WEBPACK_IMPORTED_MODULE_9__campaignAPIs__["a" /* default */].editCampaign(campaignID, formData).then(function (response) {
            _this8.$emit('createCampaign', response);

            _this8.clearData();
            _this8.close();

            _this8.submitting = false;

            _this8.$swal({
              text: 'Campaign Created',
              type: 'success'
            });
          }).catch(function (error) {
            _this8.submitting = false;

            console.log('error', error);
            _this8.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    processImage: function processImage(e, type, opt, opt2, imgId) {
      var _this9 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.pushElementToArray(_this9.angelOptions, { opt: opt, opt2: opt2, name: element.name, type: type, imgId: imgId }, 'imgId', __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].TYPE.OBJECT);
        __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.pushElementToArray(_this9.images, { element: element, imgId: imgId, opt: opt, opt2: opt2 }, 'imgId', __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].TYPE.OBJECT);
      });
    },
    addAttendee: function addAttendee(fieldName) {
      var attendeeField = this.campaign['eventBrief'][fieldName][0];
      var newAttendeeField = {};
      for (var key in attendeeField) {
        newAttendeeField[key] = '';
      }

      this.campaign['eventBrief'][fieldName].push(newAttendeeField);
    },
    deleteAttendee: function deleteAttendee(fieldName, index) {
      var newAttendeeField = this.campaign['eventBrief'][fieldName];
      if (index < newAttendeeField.length) {
        newAttendeeField.splice(index, 1);
        this.campaign['eventBrief'][fieldName] = newAttendeeField;
      }
    },
    deleteOption: function deleteOption(campaignAttribute, campaignAttributeIndex) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignAttributeIndex < campaignOptions.length) {
        campaignOptions.splice(campaignAttributeIndex, 1);
        this.campaign[campaignAttribute] = campaignOptions;
        this.angelOptions = this.angelOptions.filter(function (e) {
          return e.opt !== campaignAttributeIndex;
        });
        this.images = this.images.filter(function (e) {
          return e.opt !== campaignAttributeIndex;
        });
      }
    },
    deleteSecondOption: function deleteSecondOption(campaignAttribute, campaignAttributeIndex, optionName, optionIndex) {
      var secondOptions = this.campaign[campaignAttribute][campaignAttributeIndex][optionName];
      if (optionIndex < secondOptions.length) {
        secondOptions.splice(optionIndex, 1);
        this.campaign[campaignAttribute][campaignAttributeIndex][optionName] = secondOptions;
      }
    },
    addOption: function addOption(campaignAttribute) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};

        for (var key in campaignOptions[0]) {
          if (campaignAttribute === 'angles') {
            if (key === 'actionRequired_action' || key === 'actionRequired_receive' || key === 'actionRequired_time' || key === 'actionRequired_value' || key === 'formats') {
              campaignOptionsTemplate[key] = campaignOptions[0][key];
              if (key === 'formats') {
                campaignOptionsTemplate[key] = [this.getAngleFormat()];
              }
            }
          } else {
            campaignOptionsTemplate[key] = '';
          }
        }

        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute] = campaignOptions;
      }
    },
    addSecondOption: function addSecondOption(campaignAttribute, optionIndex, optionName) {
      var campaignOptions = this.campaign[campaignAttribute][optionIndex][optionName];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};

        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
          if (key === 'formats') {
            var format = this.getAngleFormat();
            campaignOptionsTemplate[key] = format;
          }
        }
        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute][optionIndex][optionName] = campaignOptions;
      }
    },
    changeOptionType: function changeOptionType(elementID, value) {
      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#img_upload_' + elementID).hide();
      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#video_link_' + elementID).hide();
      if (value === 'image') {
        __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#img_upload_' + elementID).show();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#video_link_' + elementID).show();
      }
    },
    changeVideoLink: function changeVideoLink(type, opt, opt2, imgId) {
      var value = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('#video_link_' + imgId).val();
      __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.pushElementToArray(this.angelOptions, { opt: opt, opt2: opt2, name: value, type: type, optionType: 'link', imgId: imgId }, 'imgId', __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].TYPE.OBJECT);
    },
    getAngleFormat: function getAngleFormat() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        required_action: '',
        image_angle: '',
        content_angle: '',
        sample_images: ''
      });
    },
    changeCampaignName: function changeCampaignName(name) {
      var campaignOne = this.clientCampaigns.find(function (c) {
        return c.name === name;
      });
      if (typeof campaignOne.targetAge === 'string') {
        campaignOne.targetAge = [campaignOne.targetAge];
      }
      if (typeof campaignOne.targetLocation === 'string') {
        if (campaignOne.targetLocation === '-') {
          campaignOne.targetLocation = '';
        } else {
          var location = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].targetAudienceDisplay.LOCATION.find(function (l) {
            return l.text === campaignOne.targetLocation;
          });
          if (location) campaignOne.targetLocation = [location.value];
        }
      }
      campaignOne.goal = Array.isArray(campaignOne.goal) ? campaignOne.goal : [campaignOne.goal];
      campaignOne.influencer_ideal = Array.isArray(campaignOne.influencer_ideal) ? campaignOne.influencer_ideal : [campaignOne.influencer_ideal];
      campaignOne.influencer_unwanted = Array.isArray(campaignOne.influencer_unwanted) ? campaignOne.influencer_unwanted : [campaignOne.influencer_unwanted];
      this.campaign = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.refreshJSON(campaignOne);
    },

    clearData: function clearData() {
      this.selectedClient = null;
      this.clientAccountSummary = {};
    },
    initFileUpload: function initFileUpload() {

      __WEBPACK_IMPORTED_MODULE_7_jquery___default()(document).on('click', '.btn-remove-input', function () {
        __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).remove();
      });
    },
    targetAgelimiter: function targetAgelimiter(e) {
      if (e.length > 3) {
        e.pop();
      }
    },
    getCountries: function getCountries() {
      this.countries = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_20__static_sources_countries___default.a);
    }
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignModelSections.forEach(function (section) {
      if (section.type === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignModelSectionType.EVENT_BRIEF) {
        var eventObject = {};
        section.content.forEach(function (field) {
          if (field.type === 'multiple_options') {
            var optionObj = {};
            field.template.forEach(function (template) {
              optionObj[template.name] = '';
            });
            eventObject[field.name] = [optionObj];
          } else if (field.type === 'template') {
            var templateObj = {};
            field.template.forEach(function (template) {
              templateObj[template.name] = '';
            });
            eventObject[field.name] = templateObj;
          } else {
            eventObject[field.name] = '';
          }
        });
        campaignData.eventBrief = eventObject;
      } else {
        section.content.forEach(function (field) {
          campaignData[field.name] = '';

          if (field.type === 'select') {
            campaignData[field.name] = field.defaultValue;
          } else if (field.type === 'autocomplete') {
            campaignData[field.name] = field.defaultValue;
          } else if (field.type === 'multiple_options') {
            var newOption = {};
            field.template.forEach(function (template) {
              newOption[template.name] = '';
              if (template.type === 'select') {
                newOption[template.name] = template.defaultValue;
              } else if (template.type === 'multiple_options') {
                newOption[template.name] = [];
                newOption[template.name].push({});
                template.template[0].forEach(function (secondTemplate) {
                  newOption[template.name][0][secondTemplate.name] = '';
                });
              }
            });
            campaignData[field.name] = [newOption];
          } else if (field.type === 'radio') {
            campaignData[field.name] = field.defaultValue;
          } else if (field.type === 'chips') {
            campaignData[field.name] = field.value;
          }

          if (field.name === 'budget') {
            campaignData[field.showToClient.name] = field.showToClient.defaultValue;
          }
        });
      }
    });
  },
  mounted: function mounted() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
                __WEBPACK_IMPORTED_MODULE_10__Company_companyAPIs__["a" /* default */].getAllCompanies(false).then(function (response) {
                  _this10.company_options = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });
              }

              if (_this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
                __WEBPACK_IMPORTED_MODULE_11__Client_clientAPIs__["a" /* default */].getAllClients(false).then(function (response) {
                  _this10.allClients = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });

                __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (response) {
                  _this10.AM = response.users;
                  _this10.selectedAM = response.users;
                }).catch(function (error) {
                  console.log('error', error);
                });

                __WEBPACK_IMPORTED_MODULE_9__campaignAPIs__["a" /* default */].getAllCampaignVerticals(false).then(function (response) {
                  _this10.campaignVerticals = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });
              }

              if (_this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
                _this10.campaign.companyID = _this10.$store.state.user.companyID;
              }
              _this10.initFileUpload();
              _this10.images = [];
              _this10.angelOptions = [];
              _this10.getCountries();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this10);
    }))();
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__static_sources_countries__);



























var campaignDataTemplate = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditCampaignModal',
  props: {
    value: Boolean,
    campaignId: String
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay___default.a,
    ViewClientModal: __WEBPACK_IMPORTED_MODULE_17__Client_ViewClientModal___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      campaign: {},
      showBudget: false,
      showVideoBrief: false,
      showEventBrief: false,
      startCal: false,
      endCal: false,
      startTimeDialog: false,
      endTimeDialog: false,
      eventDateDialog: false,
      videoDateDialog: false,
      campaignModelSections: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSections,
      campaignModelSectionType: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSectionType,
      allClients: [],
      inputMoreImages: 1,
      images: [],
      angelOptions: [],
      viewClientData: null,
      viewClientDialog: false,
      AM: [],
      selectedAM: [],
      CO: [],
      selectedCO: [],
      dedicatedPersons: [],
      supportingPersons: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      IONumbers: [],
      campaignVerticals: [],
      selectedCampaignVertical: [],
      userTypes: [{
        title: 'AM',
        role: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.ACCOUNT_MANAGER
      }, {
        title: 'CC',
        role: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.AD_STRATEGIST
      }],
      countries: [] };
  },

  watch: {
    campaignId: function campaignId(newCampaignId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_11__campaignAPIs__["a" /* default */].getCampaign(newCampaignId).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          var location, array, _array, segments;

          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.showBudget = response.settings ? response.settings.showBudgetToClient : response.showBudgetToClient;
                  _this.showVideoBrief = response.settings ? response.settings.enableVideoBrief : response.enableVideoBrief;
                  _this.showEventBrief = response.settings ? response.settings.enableEventBrief : response.enableEventBrief;
                  if (typeof response.targetAge === 'string') {
                    response.targetAge = [response.targetAge];
                  }
                  if (typeof response.targetLocation === 'string') {
                    if (response.targetLocation === '-') {
                      response.targetLocation = [];
                    } else {
                      location = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].targetAudienceDisplay.LOCATION.find(function (l) {
                        return l.text === response.targetLocation;
                      });

                      if (location) response.targetLocation = [location.value];
                    }
                  }
                  response.targetLocation = __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].formatCountry(_this.countries, response.targetLocation || []);

                  if (!_this.showVideoBrief) {
                    array = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSections.filter(function (sections) {
                      return sections.type !== _this.campaignModelSectionType.VIDEO_BRIEF;
                    });

                    _this.campaignModelSections = array;
                  } else {
                    _this.campaignModelSections = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSections;
                  }

                  if (!_this.showEventBrief) {
                    _array = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSections.filter(function (sections) {
                      return sections.type !== _this.campaignModelSectionType.EVENT_BRIEF;
                    });

                    _this.campaignModelSections = _array;
                  } else {
                    _this.campaignModelSections = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSections;
                  }
                  response.angles = __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].fixAnglesData(response.angles);

                  if (response.segment) {
                    segments = [];

                    response.segment.map(function (s) {
                      campaignDataTemplate.segment.map(function (s2) {
                        if (s === s2.value) {
                          segments.push(s2);
                        }
                      });
                    });
                    response.segment = segments;
                  }

                  if (response.min_influencer || response.max_influencer) {
                    response.min_content = response.min_influencer;
                    response.max_content = response.max_influencer;
                    delete response.min_influencer;
                    delete response.max_influencer;
                  }

                  response.goal = Array.isArray(response.goal) ? response.goal : [response.goal];
                  response.influencer_ideal = Array.isArray(response.influencer_ideal) ? response.influencer_ideal : response.influencer_ideal.split(',');
                  response.influencer_unwanted = Array.isArray(response.influencer_unwanted) ? response.influencer_unwanted : response.influencer_unwanted.split(',');
                  _this.campaign = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(campaignDataTemplate, response);
                  if (!response.platform) {
                    _this.campaign.platform = [];
                  } else {
                    response.platform = response.platform.map(function (p) {
                      var matchPlatform = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].targetAudienceDisplay.PLATFORM.find(function (t) {
                        return t.value === p;
                      });
                      if (matchPlatform) {
                        p = matchPlatform;
                      }
                      return p;
                    });
                    _this.campaign.platform = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], response.platform);
                  }
                  _this.setClientData(_this.campaign);
                  _this.getCampaignsByClientID(_this.campaign.clientID);
                  if (_this.campaign.assignedTo) {
                    setTimeout(function () {
                      _this.CO.map(function (item) {
                        response.assignedTo.map(function (userId) {
                          if (item.id === userId) {
                            _this.selectedCO.push(item);
                          }
                        });
                      });
                    }, 500);

                    _this.AM.map(function (item) {
                      response.assignedTo.map(function (userId) {
                        if (item.id === userId) {
                          _this.selectedAM.push(item);
                        }
                      });
                    });
                  }

                  if (_this.campaign.revenueCalculation === undefined || _this.campaign.revenueCalculation === '') {
                    _this.campaign.revenueCalculation = 'content';
                  }

                  __WEBPACK_IMPORTED_MODULE_11__campaignAPIs__["a" /* default */].getAllCampaignVerticals(false).then(function (responsevertical) {
                    _this.campaignVerticals = [];
                    _this.campaignVerticals = responsevertical.data;
                    _this.selectedCampaignVertical = [];
                    if (response.vertical) {
                      _this.campaignVerticals.map(function (item) {
                        response.vertical.map(function (verticalId) {
                          if (item.id === verticalId) {
                            _this.selectedCampaignVertical.push(item);
                          }
                        });
                      });
                    }
                  }).catch(function (error) {
                    console.log('error', error);
                  });

                  _this.getClientData(response.clientID);

                case 22:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log('error', error);
      });
    },
    selectedCampaignVertical: function selectedCampaignVertical(val, prev) {
      var _this2 = this;

      if (val.length === prev.length) return;

      this.selectedCampaignVertical = val.map(function (v) {
        if (typeof v === 'string') {
          v = {
            id: 0,
            name: v
          };
          _this2.campaignVerticals.push(v);
        }

        return v;
      });
    }
  },
  validations: function validations() {
    var validationRules = {
      campaign: {}
    };
    this.campaignModelSections.forEach(function (section) {
      section.content.forEach(function (field) {
        if (field.validations && field.validations.length > 0) {
          if (field.validations) {
            field.validations.forEach(function (validation) {
              validationRules['campaign'][field.name] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, validation.name, validation.value);
            });
          }
        }
      });
    });

    return validationRules;
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    client_options: function client_options() {
      var clientList = [];
      this.allClients.forEach(function (element) {
        var client = {
          name: element.name,
          id: element.id
        };
        clientList.push(client);
      });
      return clientList;
    },
    editClient: function editClient() {
      if (this.campaign.status === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus.DRAFT) {
        return true;
      }
      return false;
    }
  },
  methods: {
    setClientData: function setClientData(campaign) {
      var _this3 = this;

      var clientID = campaign.clientID;

      __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__["a" /* default */].getClient(clientID).then(function (response) {
        _this3.viewClientData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, response);

        _this3.getPersonsFromClient(campaign, _this3.viewClientData);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getClientData: function getClientData(clientID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__["a" /* default */].getClient(clientID).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (response.account.deals !== undefined) {
                    response.account.deals.map(function (item) {
                      _this4.IONumbers.push(item.IO);
                    });
                  }

                case 1:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this4);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log('error', error);
      });
    },

    getPersonsFromClient: function getPersonsFromClient(campaign, client) {
      var _this5 = this;

      this.dedicatedPersons = [];
      this.selectedDedicatedPersons = [];
      this.supportingPersons = [];
      this.selectedSupportingPersons = [];

      client.handledBy.map(function (userId) {
        __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__["a" /* default */].getUser(userId).then(function (response) {
          _this5.dedicatedPersons.push(response);
          if (campaign.assignedTo) {
            if (campaign.assignedTo.includes(response.id)) {
              _this5.selectedDedicatedPersons.push(response);
            }
          } else {
            _this5.selectedDedicatedPersons.push(response);
          }
        }).catch(function (error) {
          console.log('error', error);
        });
      });
      if (client.supportedBy) {
        client.supportedBy.map(function (userId) {
          __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__["a" /* default */].getUser(userId).then(function (response) {
            _this5.supportingPersons.push(response);
            if (campaign.assignedSupportingTo) {
              if (campaign.assignedSupportingTo.includes(response.id)) {
                _this5.selectedSupportingPersons.push(response);
              }
            } else {
              _this5.selectedSupportingPersons.push(response);
            }
          }).catch(function (error) {
            console.log('error', error);
          });
        });
      }
    },
    close: function close() {
      this.$emit('input');
    },
    addMoreImage: function addMoreImage(optionIndex, secondOptionIndex) {
      var _this6 = this;

      var el = document.getElementById('optionImages_' + optionIndex + '_' + secondOptionIndex);
      var img = this.renderImageSelection(optionIndex, secondOptionIndex);
      var imgId = img.id;
      el.insertAdjacentHTML('beforeend', img.html);
      var btnRemove = document.getElementById('btnRemove_' + imgId);
      var inputFile = document.getElementById('inputFile_' + imgId);
      btnRemove.addEventListener('click', function () {
        _this6.removeImage(optionIndex, imgId);
      });
      inputFile.addEventListener('change', function (event) {
        _this6.processImage(event, 'angel', optionIndex, secondOptionIndex, imgId);
      });
      var imageRadio = document.getElementById('radio_image_' + imgId);
      imageRadio.addEventListener('change', function (event) {
        _this6.changeOptionType(imgId, 'image');
      });
      var linkRadio = document.getElementById('radio_link_' + imgId);
      linkRadio.addEventListener('change', function (event) {
        _this6.changeOptionType(imgId, 'link');
      });
      var videoLinkInput = document.getElementById('video_link_' + imgId);
      videoLinkInput.addEventListener('change', function (event) {
        _this6.changeVideoLink('angel', optionIndex, secondOptionIndex, imgId);
      });
    },
    removeImage: function removeImage(optionIndex, imgId) {
      var el = document.getElementById('input_group_' + imgId);
      el.remove();
      __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.removeElementFromArray(this.images, imgId, 'imgId', __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].TYPE.OBJECT);
      __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.removeElementFromArray(this.angelOptions, imgId, 'imgId', __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].TYPE.OBJECT);
    },
    renderImageSelection: function renderImageSelection(optionIndex) {
      var imgIndex = __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.makeid(6);
      return {
        html: '\n        <div class="input-group pb-2" id="input_group_' + imgIndex + '">\n          <label class="pr-2">\n            <input type=\'radio\' id="radio_image_' + imgIndex + '" name="type_' + imgIndex + '" value=\'image\' checked="true" /> Image\n          </label>\n          <label>\n            <input type=\'radio\' id="radio_link_' + imgIndex + '" name="type_' + imgIndex + '" value=\'link\' /> Video Link\n          </label>\n          <div>\n            <input type="text" class="custom-input" style="display:none" id="video_link_' + imgIndex + '" />\n          </div>\n          <div\n            class="image-input" id="img_upload_' + imgIndex + '"\n          >\n            <input\n              type="file"\n              id="inputFile_' + imgIndex + '"\n              ref="files"\n            />\n          </div>\n        </div>\n        <button\n          type="button"\n          id="btnRemove_' + imgIndex + '"\n          class="btn btn-link btn-link-danger btn-remove-input"\n        >Remove</button>',
        id: imgIndex
      };
    },

    processImage: function processImage(e, type, opt, opt2, imgId) {
      var _this7 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.pushElementToArray(_this7.angelOptions, { opt: opt, opt2: opt2, name: element.name, type: type, imgId: imgId }, 'imgId', __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].TYPE.OBJECT);
        __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.pushElementToArray(_this7.images, { element: element, imgId: imgId, opt: opt, opt2: opt2 }, 'imgId', __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].TYPE.OBJECT);
      });
    },
    editCampaign: function editCampaign() {
      var _this8 = this;

      if (this.campaign.platform && this.campaign.platform.length) {
        this.campaign.platform = this.campaign.platform.filter(function (p) {
          return typeof p !== 'string';
        });
      }
      if (this.campaign.campaignType === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignType.NO_PREFERENCE || this.campaign.campaignType === undefined) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please Select Product Type.'
        });
        return;
      } else if (!this.campaign.targetLocation || !this.campaign.targetLocation.length) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please Select Target Location'
        });
        return;
      } else if (!this.campaign.platform.length) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please Select Platform'
        });
        return;
      } else if (this.selectedCampaignVertical.length === 0) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please Select Campaign Vertical.'
        });
        return;
      }
      this.isLoading = true;

      var campaign = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.campaign);
      var campaignID = campaign.id;

      delete campaign.id;

      campaign.assignedTo = this.selectedDedicatedPersons.map(function (d) {
        return d.id;
      });
      campaign.assignedSupportingTo = this.selectedSupportingPersons.map(function (sp) {
        return sp.id;
      });

      campaign.vertical = this.selectedCampaignVertical;

      campaign['segment'] = campaign['segment'] ? campaign['segment'].map(function (t) {
        return t.value;
      }) : [];

      if (campaign['targetAge']) {
        campaign['targetAge'] = campaign['targetAge'].map(function (t) {
          if ((typeof t === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(t)) === 'object') {
            return t.value;
          }
          return t;
        });
      }

      if (campaign['targetLocation']) {
        campaign['targetLocation'] = campaign['targetLocation'].map(function (v) {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            };
          }
          return v;
        });
      }

      campaign['platform'] = campaign['platform'] ? campaign['platform'].map(function (t) {
        return t.value || '';
      }) : [];

      var formData = new FormData();
      formData.append('campaign', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(campaign));
      formData.append('angelOptions', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.angelOptions));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.images), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('images', val.element);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_11__campaignAPIs__["a" /* default */].editCampaign(campaignID, formData).then(function (response) {
        _this8.$emit('editCampaign', response);
        _this8.isLoading = false;

        _this8.$swal({
          text: 'Campaign Updated',
          type: 'success'
        }).then(function (result) {
          if (result.value) {
            _this8.close();
          }
        });
      }).catch(function (error) {
        _this8.isLoading = false;
        console.log('error', error);
      });
    },
    addAttendee: function addAttendee(fieldName) {
      var attendeeField = this.campaign['eventBrief'][fieldName][0];
      var newAttendeeField = {};
      for (var key in attendeeField) {
        newAttendeeField[key] = '';
      }

      this.campaign['eventBrief'][fieldName].push(newAttendeeField);
    },
    deleteAttendee: function deleteAttendee(fieldName, index) {
      var newAttendeeField = this.campaign['eventBrief'][fieldName];
      if (index < newAttendeeField.length) {
        newAttendeeField.splice(index, 1);
        this.campaign['eventBrief'][fieldName] = newAttendeeField;
      }
    },
    deleteOption: function deleteOption(campaignAttribute, campaignAttributeIndex) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignAttributeIndex < campaignOptions.length) {
        campaignOptions.splice(campaignAttributeIndex, 1);
        this.campaign[campaignAttribute] = campaignOptions;
        this.angelOptions = this.angelOptions.filter(function (e) {
          return e.opt !== campaignAttributeIndex;
        });
        this.images = this.images.filter(function (e) {
          return e.opt !== campaignAttributeIndex;
        });
      }
    },
    deleteSecondOption: function deleteSecondOption(campaignAttribute, campaignAttributeIndex, optionName, optionIndex) {
      var secondOptions = this.campaign[campaignAttribute][campaignAttributeIndex][optionName];
      if (optionIndex < secondOptions.length) {
        secondOptions.splice(optionIndex, 1);
        this.campaign[campaignAttribute][campaignAttributeIndex][optionName] = secondOptions;
      }
    },
    addOption: function addOption(campaignAttribute) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};
        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
          if (key === 'formats') {
            campaignOptionsTemplate[key] = [this.getAngleFormat()];
          }
        }

        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute] = campaignOptions;
      }
    },
    addSecondOption: function addSecondOption(campaignAttribute, optionIndex, optionName) {
      var campaignOptions = this.campaign[campaignAttribute][optionIndex][optionName];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};

        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
          if (key === 'formats') {
            var format = this.getAngleFormat();
            campaignOptionsTemplate[key] = format;
          }
        }
        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute][optionIndex][optionName] = campaignOptions;
      }
    },
    changeOptionType: function changeOptionType(elementID, value) {
      __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#img_upload_' + elementID).hide();
      __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#video_link_' + elementID).hide();
      if (value === 'image') {
        __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#img_upload_' + elementID).show();
      } else {
        __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#video_link_' + elementID).show();
      }
    },
    changeVideoLink: function changeVideoLink(type, opt, opt2, imgId) {
      var value = __WEBPACK_IMPORTED_MODULE_8_jquery___default()('#video_link_' + imgId).val();
      __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.pushElementToArray(this.angelOptions, { opt: opt, opt2: opt2, name: value, type: type, optionType: 'link', imgId: imgId }, 'imgId', __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].TYPE.OBJECT);
    },

    constructImageURL: function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    },
    checkMediaURL: function checkMediaURL(url) {
      if (url.includes('drive.google.com')) {
        return 'drive';
      }
      return 'link';
    },

    clearData: function clearData() {
      this.campaign = {
        name: '',
        goal: '',
        budget: ''
      };
    },
    getAngleFormat: function getAngleFormat() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
        required_action: '',
        image_angle: '',
        content_angle: '',
        sample_images: ''
      });
    },
    changeCampaignName: function changeCampaignName(name) {
      var campaignOne = this.clientCampaigns.find(function (c) {
        return c.name === name;
      });
      if (typeof campaignOne.targetAge === 'string') {
        campaignOne.targetAge = [campaignOne.targetAge];
      }
      if (typeof campaignOne.targetLocation === 'string') {
        if (campaignOne.targetLocation === '-') {
          campaignOne.targetLocation = '';
        } else {
          var location = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].targetAudienceDisplay.LOCATION.find(function (l) {
            return l.text === campaignOne.targetLocation;
          });
          if (location) campaignOne.targetLocation = [location.value];
        }
      }
      campaignOne.goal = Array.isArray(campaignOne.goal) ? campaignOne.goal : [campaignOne.goal];
      campaignOne.influencer_ideal = Array.isArray(campaignOne.influencer_ideal) ? campaignOne.influencer_ideal : [campaignOne.influencer_ideal];
      campaignOne.influencer_unwanted = Array.isArray(campaignOne.influencer_unwanted) ? campaignOne.influencer_unwanted : [campaignOne.influencer_unwanted];
      this.campaign = __WEBPACK_IMPORTED_MODULE_16__utils__["a" /* default */].func.refreshJSON(campaignOne);
    },
    removeUpload: function removeUpload() {
      this.inputMoreImages--;
    },
    removeUploadedImage: function removeUploadedImage(optionIndex, secondOptionIndex, i) {
      this.campaign.angles[optionIndex].formats[secondOptionIndex].sample_images.splice(i, 1);
    },
    onEnter: function onEnter(val) {
      this.campaignVertical.push(val);
      this.campaign['vertical'] = '';
    },
    removeChip: function removeChip(index) {
      this.campaignVertical.splice(index, 1);
    },
    targetAgelimiter: function targetAgelimiter(e) {
      if (e.length > 2) {
        e.pop();
      }
    },

    getCampaignsByClientID: function getCampaignsByClientID(clientID) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_11__campaignAPIs__["a" /* default */].getCampaignsByClientID(clientID).then(function (response) {
        _this9.campaignModelSections = _this9.campaignModelSections.map(function (section) {
          if (section.type === _this9.campaignModelSectionType.CAMPAIGN_SUMMARY) {
            section.content.forEach(function (field) {
              if (field.name === 'name') {
                field.value = [];
                _this9.clientCampaigns = response.campaigns;
                response.campaigns.map(function (c) {
                  field.value.push(c.name);
                });
              }
            });
          }
          return section;
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    filterByRole: function filterByRole(users, role) {
      return users.filter(function (u) {
        return u.role === role;
      });
    },
    getCountries: function getCountries() {
      this.countries = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_20__static_sources_countries___default.a);
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.AD_STRATEGIST || _this10.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
                __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__["a" /* default */].getAllClients(false).then(function (response) {
                  _this10.allClients = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });

                __WEBPACK_IMPORTED_MODULE_18__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (response) {
                  _this10.AM = response.users;
                }).catch(function (error) {
                  console.log('error', error);
                });

                __WEBPACK_IMPORTED_MODULE_11__campaignAPIs__["a" /* default */].getAllCampaignVerticals(false).then(function (response) {
                  _this10.campaignVerticals = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });

                _this10.getCountries();
              }
              _this10.images = [];
              _this10.angelOptions = [];

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this10);
    }))();
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSections.forEach(function (section) {
      if (section.type === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].campaignModelSectionType.EVENT_BRIEF) {
        var eventObject = {};
        section.content.forEach(function (field) {
          if (field.type === 'multiple_options') {
            var optionObj = {};
            field.template.forEach(function (template) {
              optionObj[template.name] = '';
            });
            eventObject[field.name] = [optionObj];
          } else if (field.type === 'template') {
            var templateObj = {};
            field.template.forEach(function (template) {
              templateObj[template.name] = '';
            });
            eventObject[field.name] = templateObj;
          } else {
            eventObject[field.name] = '';
          }
        });
        campaignDataTemplate.eventBrief = eventObject;
      } else {
        section.content.forEach(function (field) {
          campaignDataTemplate[field.name] = '';

          if (field.type === 'select') {
            campaignDataTemplate[field.name] = field.defaultValue;
          } else if (field.type === 'multiple_options') {
            var newOption = {};
            field.template.forEach(function (template) {
              newOption[template.name] = '';
              if (template.type === 'select') {
                newOption[template.name] = template.defaultValue;
              } else if (template.type === 'multiple_options') {
                newOption[template.name] = [];
                newOption[template.name].push({});
                template.template[0].forEach(function (secondTemplate) {
                  newOption[template.name][0][secondTemplate.name] = '';
                });
              }
            });
            campaignDataTemplate[field.name] = [newOption];
          } else if (field.type === 'chips') {
            campaignDataTemplate[field.name] = field.value;
          }
        });
      }
    });
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__ = __webpack_require__(16);









var campaignDataTemplate = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditPairingBriefModal',
  props: ['modalId', 'campaignId'],
  data: function data() {
    return {
      campaign: {},
      pairingBriefModelSections: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].pairingBriefModelSections,
      pairingBriefModelSectionType: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].pairingBriefModelSectionType
    };
  },

  watch: {
    campaignId: function campaignId(newCampaignId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].getCampaign(newCampaignId).then(function (response) {
        response.angles = response.angles.map(function (angle) {
          var cpAngle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, angle);
          var sampleImages = angle.sample_images ? angle.sample_images : [];
          if (cpAngle.sample_image) {
            sampleImages.push(cpAngle.sample_image);
          }
          delete cpAngle.sample_images;
          delete cpAngle.sample_image;
          cpAngle.sample_images = sampleImages;
          return cpAngle;
        });
        _this.campaign = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(campaignDataTemplate, response);
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  },
  validations: function validations() {
    var validationRules = {
      campaign: {}
    };
    this.pairingBriefModelSections.forEach(function (section) {
      section.content.forEach(function (field) {
        if (field.validations && field.validations.length > 0) {
          if (field.validations) {
            field.validations.forEach(function (validation) {
              validationRules['campaign'][field.name] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, validation.name, validation.value);
            });
          }
        }
      });
    });

    return validationRules;
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    editCampaign: function editCampaign() {
      var _this2 = this;

      var fileData = {};
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.image-input-edit input').each(function (i, el) {
        var input = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(el);
        if (input[0].files.length > 0) {
          var index = input.parent().parent().data('index');
          if (fileData[index] === undefined) {
            fileData[index] = [];
          }
          fileData[index].push(input[0].files[0]);
        }
      });

      var campaign = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.campaign);
      var campaignID = campaign.id;

      delete campaign.companyID;
      delete campaign.clientID;
      delete campaign.id;

      var formData = new FormData();
      var sampleImageList = [];
      formData.append('campaign', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(campaign));
      for (var i in fileData) {
        for (var j in fileData[i]) {
          sampleImageList.push(i + '_' + j);
        }
      }

      formData.append('sampleImageList', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sampleImageList));

      for (i in fileData) {
        for (j in fileData[i]) {
          formData.append('sampleImage_' + i + '_' + j, fileData[i][j]);
        }
      }

      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].editCampaign(campaignID, formData).then(function (response) {
        _this2.$emit('editCampaign', response);

        _this2.$refs.closeButton.click();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    deleteOption: function deleteOption(campaignAttribute, campaignAttributeIndex) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignAttributeIndex < campaignOptions.length) {
        campaignOptions.splice(campaignAttributeIndex, 1);
        this.campaign[campaignAttribute] = campaignOptions;
      }
    },
    addOption: function addOption(campaignAttribute) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};

        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
        }

        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute] = campaignOptions;
      }
    },
    constructImageURL: function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    },
    clearData: function clearData() {
      this.campaign = {
        name: '',
        goal: '',
        budget: ''
      };
    },
    initFileUpload: function initFileUpload() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).on('click', '.btn-add-more-image-edit', function (event) {
        event.preventDefault();
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).prev('.image-input-container-edit').append('\n          <div class="image-input">\n            <input type="file" ref="files"/>\n            <button type="button" class="btn btn-link btn-link-danger btn-remove-input-edit">Remove</button>\n          </div>\n        ');
      });

      __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document).on('click', '.btn-remove-input-edit', function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).parent().remove();
      });
    },
    removeImage: function removeImage(optionIndex, i) {
      this.campaign.angles[optionIndex].sample_images.splice(i, 1);
    }
  },
  mounted: function mounted() {
    this.initFileUpload();
  },
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].pairingBriefModelSections.forEach(function (section) {
      section.content.forEach(function (field) {
        campaignDataTemplate[field.name] = '';
        if (field.type === 'select') {
          campaignDataTemplate[field.name] = field.defaultValue;
        } else if (field.type === 'multiple_options') {
          var newOption = {};
          field.template.forEach(function (template) {
            newOption[template.name] = '';
          });
          campaignDataTemplate[field.name] = [newOption];
        }
      });
    });
  }
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__ = __webpack_require__(16);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: { campaignId: { type: String, required: true } },
  data: function data() {
    return { accepting: false, expiresAt: null, busy: false, link: '', error: '', message: '' };
  },
  watch: {
    campaignId: {
      immediate: true,
      handler: function handler(id) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var state;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.busy = true;
                  _this.link = '';
                  _this.accepting = false;
                  _this.expiresAt = null;
                  _this.error = '';
                  _this.message = '';
                  _context.prev = 6;
                  _context.next = 9;
                  return __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getFeedbackAccess(id);

                case 9:
                  state = _context.sent;

                  if (!(id !== _this.campaignId)) {
                    _context.next = 12;
                    break;
                  }

                  return _context.abrupt('return');

                case 12:
                  _this.accepting = state.accepting;
                  _this.expiresAt = state.expiresAt;
                  _this.link = state.token ? window.location.origin + '/client/feedback-form/' + id + '#token=' + encodeURIComponent(state.token) : '';
                  _context.next = 20;
                  break;

                case 17:
                  _context.prev = 17;
                  _context.t0 = _context['catch'](6);

                  _this.error = 'Unable to load feedback settings.';

                case 20:
                  _context.prev = 20;

                  _this.busy = false;
                  return _context.finish(20);

                case 23:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[6, 17, 20, 23]]);
        }))();
      }
    }
  },
  methods: {
    copy: function copy() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.error = '';
                _this2.message = '';
                _context2.prev = 2;
                _context2.next = 5;
                return navigator.clipboard.writeText(_this2.link);

              case 5:
                _this2.message = 'Feedback link copied.';
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                _this2.error = 'Unable to copy link.';

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 8]]);
      }))();
    },
    change: function change(accepting) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var state;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.busy = true;
                _this3.error = '';
                _this3.message = '';
                _context3.prev = 3;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].changeFeedbackAccess(_this3.campaignId, accepting);

              case 6:
                state = _context3.sent;

                _this3.accepting = state.accepting;
                _this3.expiresAt = state.expiresAt;
                _this3.link = state.token ? window.location.origin + '/client/feedback-form/' + _this3.campaignId + '#token=' + encodeURIComponent(state.token) : '';

                if (!(accepting && _this3.link)) {
                  _context3.next = 22;
                  break;
                }

                _context3.prev = 11;
                _context3.next = 14;
                return navigator.clipboard.writeText(_this3.link);

              case 14:
                _this3.message = 'Feedback link copied.';
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](11);

                _this3.error = 'Unable to copy link.';

              case 20:
                _context3.next = 23;
                break;

              case 22:
                _this3.message = 'Feedback closed.';

              case 23:
                _context3.next = 28;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t1 = _context3['catch'](3);

                _this3.error = 'Unable to change feedback settings.';

              case 28:
                _context3.prev = 28;

                _this3.busy = false;
                return _context3.finish(28);

              case 31:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 25, 28, 31], [11, 17]]);
      }))();
    }
  }
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'influencer-posts',
  components: {
    ViewCampaignModal: __WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal___default.a
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      posts: [],
      keyword: '',
      fields: [{
        key: 'pairingStatusDisplay',
        label: 'Status'
      }, {
        key: 'name'
      }, {
        key: 'goal'
      }, {
        key: 'budget'
      }, {
        key: 'updatedAt'
      }, {
        key: 'actions'
      }],
      viewCampaignData: null
    };
  },
  created: function created() {
    this.fetchPosts();
  },

  filters: {
    postStatusText: function postStatusText(value) {
      return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatusDisplay[value] ? __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatusDisplay[value] : '';
    }
  },
  methods: {
    canApprove: function canApprove(status) {
      return status === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatus.DRAFT || status === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatus.CLIENT_PENDING;
    },
    fetchPosts: function fetchPosts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].getPostsForClient(this.$store.state.user.clientID).then(function (response) {
        _this.posts = response;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this2.viewCampaignData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    approvePost: function approvePost(post) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].approvePost(post.id, post.status).then(function (response) {
        _this3.fetchPosts();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddTagModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    items: Object
  },
  validations: {
    updateData: {
      activeYear: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      years: ['2022', '2023', '2024'],
      updateData: {
        activeYear: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    savedMasterList: function savedMasterList(state) {
      return state.campaign.savedMasterList;
    }
  })),
  watch: {
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(newValue) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.updateData = {
                  activeYear: []
                };

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function value(_x) {
        return _ref.apply(this, arguments);
      }

      return value;
    }()
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var updateData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.isLoading = true;
                updateData = [];

                _this2.items.map(function (item) {
                  updateData.push({
                    id: item.id,
                    activeYear: _this2.updateData.activeYear
                  });
                });
                _context3.next = 5;
                return _this2.$store.dispatch('campaign/updateMasterlistActiveYear', {
                  data: updateData
                });

              case 5:
                _this2.isLoading = false;
                if (_this2.savedMasterList) {
                  _this2.$swal({
                    text: 'Successfully Updated.',
                    type: 'success'
                  });
                  _this2.close();
                } else {
                  _this2.$swal({
                    text: 'Error Updating Active Year!',
                    type: 'error'
                  });
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Xero_XeroAPIs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InvoiceSentEditModal__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InvoiceSentEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InvoiceSentEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InvoiceSentActivityModal__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InvoiceSentActivityModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__InvoiceSentActivityModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TimelineAmountUpdateModal__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TimelineAmountUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__TimelineAmountUpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(169);


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateQuoteModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a,
    InvoiceSentEditModal: __WEBPACK_IMPORTED_MODULE_10__InvoiceSentEditModal___default.a,
    InvoiceSentActivityModal: __WEBPACK_IMPORTED_MODULE_11__InvoiceSentActivityModal___default.a,
    TimelineAmountUpdateModal: __WEBPACK_IMPORTED_MODULE_12__TimelineAmountUpdateModal___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6_vuelidate__["validationMixin"]],
  validations: function validations() {
    return this.rules;
  },
  props: ['value', 'saleUsers', 'editData'],
  data: function data() {
    return {
      xeroContacts: [],
      quoteData: {
        acceptanceDate: '',
        salePerson: '',
        billingContact: '',
        quoteNo: '',
        quoteAmt: 0,
        quoteAmtFC: 0,
        estExchangeRate: 0,
        confirmExchangeRate: 0,
        priceRdo: 1,
        indicateCost: '',
        invoiceSent: 0,
        invoiceCreated: 0,
        invoicePending: 0,
        priorYear: 0,
        nextYear: 0,
        accruedRevenue: 0,
        deferredRevenue: 0,
        currency: 'SGD',
        quoteData: []
      },
      isLoading: false,
      invoiceSentEditDialog: false,
      invoiceSentActivityDialog: false,
      timelineUpdateDialog: false,
      activityData: null,
      editActivityData: [],
      editTimelineData: null,
      editTimelineIdx: null,
      currencyLists: ['SGD', 'USD', 'RM', 'JPY'],
      isInvalidQuoteDate: false,
      quoteStatuses: __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].quoteStatuses,
      calculatedRate: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    savedMasterList: function savedMasterList(state) {
      return state.campaign.savedMasterList;
    },
    masterListErr: function masterListErr(state) {
      return state.campaign.masterListErr;
    }
  }), {
    disableMasterLists: function disableMasterLists() {
      return this.$v.quoteData.$invalid;
    },
    invalidInvoiceSent: function invalidInvoiceSent() {
      return Number(this.quoteData.quoteAmt) < Number(this.quoteData.invoiceSent);
    },
    rules: function rules() {
      var validationRules = {
        quoteData: {
          acceptanceDate: {
            required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
          },
          salePerson: {
            required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
          },
          quoteNo: {
            required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
          },
          quoteAmt: {
            required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
          }
        }
      };
      return validationRules;
    },
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()().format('YYYY');
    },
    nextYear: function nextYear() {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()().add(1, 'years').format('YYYY');
    },
    isOtherCurrency: function isOtherCurrency() {
      if (this.quoteData.currency !== 'SGD') {
        return true;
      }
      return false;
    },
    acceptanceDateErrors: function acceptanceDateErrors() {
      var errors = [];
      if (!this.$v.quoteData.acceptanceDate.$dirty) return errors;
      !this.$v.quoteData.acceptanceDate.required && errors.push('This field is required.');
      return errors;
    },
    salePersonErrors: function salePersonErrors() {
      var errors = [];
      if (!this.$v.quoteData.salePerson.$dirty) return errors;
      !this.$v.quoteData.salePerson.required && errors.push('This field is required.');
      return errors;
    },
    quoteNoErrors: function quoteNoErrors() {
      var errors = [];
      if (!this.$v.quoteData.quoteNo.$dirty) return errors;
      !this.$v.quoteData.quoteNo.required && errors.push('This field is required.');
      return errors;
    },
    quoteAmtErrors: function quoteAmtErrors() {
      var errors = [];
      if (!this.$v.quoteData.quoteAmt.$dirty) return errors;
      !this.$v.quoteData.quoteAmt.required && errors.push('This field is required.');
      return errors;
    },
    invoiceSentErrors: function invoiceSentErrors() {
      var errors = [];
      if (!this.$v.quoteData.invoiceSent.$dirty) return errors;
      !this.$v.quoteData.invoiceSent.required && errors.push('This field is required.');
      return errors;
    },
    invoiceCreatedErrors: function invoiceCreatedErrors() {
      var errors = [];
      if (!this.$v.quoteData.invoiceCreated.$dirty) return errors;
      !this.$v.quoteData.invoiceCreated.required && errors.push('This field is required.');
      return errors;
    }
  }),
  watch: {
    editData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (newValue) {
                  _context.next = 4;
                  break;
                }

                delete this.quoteData.id;
                this.resetQuoteData();
                return _context.abrupt('return');

              case 4:
                this.quoteData.id = newValue.id;
                this.quoteData.acceptanceDate = newValue.acceptanceDate;
                this.quoteData.salePerson = newValue.salePerson;
                this.quoteData.billingContact = newValue.billingContact;
                this.quoteData.quoteNo = newValue.quoteNo.replace('IO-', '');
                this.quoteData.quoteAmt = newValue.quoteAmt;
                this.quoteData.invoiceSent = newValue.invoiceSent || 0;
                this.quoteData.invoiceCreated = newValue.invoiceCreated || 0;
                this.quoteData.invoicePending = newValue.invoicePending;

                this.quoteData.activity = newValue.activity || [];
                this.quoteData.currency = newValue.currency || 'SGD';
                this.quoteData.confirmExchangeRate = newValue.confirmExchangeRate || 0;
                this.quoteData.estExchangeRate = newValue.estExchangeRate || 0;
                this.quoteData.quoteAmtFC = newValue.quoteAmtFC || 0;
                this.quoteData.priceRdo = newValue.priceRdo || 1;
                this.quoteData.quoteData = newValue.quoteData || [];

                this.calcExgAmt();

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editData(_x) {
        return _ref.apply(this, arguments);
      }

      return editData;
    }()
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.fetchXeroContact();

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  methods: {
    saveQuote: function saveQuote() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this2.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to save changes?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
                    var saveData, quoteData;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result.value) {
                              _context3.next = 24;
                              break;
                            }

                            _this2.isLoading = true;
                            saveData = [];
                            quoteData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.quoteData);

                            quoteData.quoteNo = 'IO-' + quoteData.quoteNo;
                            quoteData.quoteAmt = Number(quoteData.quoteAmt);
                            quoteData.invoiceSent = Number(quoteData.invoiceSent);
                            quoteData.invoiceCreated = Number(quoteData.invoiceCreated);
                            quoteData.quoteAmtFC = Number(quoteData.quoteAmtFC || 0);
                            quoteData.confirmExchangeRate = Number(quoteData.confirmExchangeRate || 0);
                            quoteData.estExchangeRate = Number(quoteData.estExchangeRate || 0);

                            if (!quoteData.id) {
                              quoteData.activeYear = [_this2.currentYear];
                              if (quoteData.invoiceSent) {
                                quoteData.activity = [{
                                  timestamp: __WEBPACK_IMPORTED_MODULE_13_moment___default()().toISOString(),
                                  amount: Number(quoteData.invoiceSent),
                                  remarks: ''
                                }];
                              }
                            }
                            if (quoteData.quoteAmt) {
                              quoteData.invoicePending = Number(Number(quoteData.quoteAmt) - Number(quoteData.invoiceCreated));
                            }
                            saveData.push(quoteData);
                            _context3.next = 16;
                            return _this2.$store.dispatch('campaign/saveCampaignMasterLists', {
                              data: saveData
                            });

                          case 16:
                            _this2.isLoading = false;

                            if (_this2.savedMasterList) {
                              _context3.next = 20;
                              break;
                            }

                            _this2.$swal({
                              text: _this2.masterListErr ? _this2.masterListErr : 'Error Saving Quote Data.',
                              type: 'error'
                            });
                            return _context3.abrupt('return');

                          case 20:
                            _this2.resetQuoteData();

                            _this2.$swal({
                              text: 'Successfully saved.',
                              type: 'success'
                            });
                            _this2.$emit('created');
                            _this2.close();

                          case 24:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    processQuoteData: function processQuoteData(index, status) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var totalAmt, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, q, aval, statusTxt;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                totalAmt = 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context6.prev = 4;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.quoteData.quoteData); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  q = _step.value;

                  totalAmt += Number(q.quoteAmt);
                }
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context6.t0;

              case 12:
                _context6.prev = 12;
                _context6.prev = 13;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 15:
                _context6.prev = 15;

                if (!_didIteratorError) {
                  _context6.next = 18;
                  break;
                }

                throw _iteratorError;

              case 18:
                return _context6.finish(15);

              case 19:
                return _context6.finish(12);

              case 20:
                aval = Number(_this3.quoteData.invoiceCreated) - Number(totalAmt);

                if (!(aval < 0)) {
                  _context6.next = 24;
                  break;
                }

                _this3.$swal({
                  text: 'Available Amount Not Enough.',
                  type: 'error'
                });
                return _context6.abrupt('return', false);

              case 24:
                statusTxt = '';

                if (!(status === _this3.quoteStatuses.ACCEPT)) {
                  _context6.next = 29;
                  break;
                }

                statusTxt = 'Approve';

                if (_this3.checkQuoteAmt(index)) {
                  _context6.next = 29;
                  break;
                }

                return _context6.abrupt('return', false);

              case 29:
                if (status === _this3.quoteStatuses.REJECT) {
                  statusTxt = 'Reject';
                }
                _this3.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to ' + statusTxt + '?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(result) {
                    var saveData, saveObj;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!result.value) {
                              _context5.next = 17;
                              break;
                            }

                            _this3.isLoading = true;
                            saveData = [];
                            saveObj = {
                              id: _this3.quoteData.id
                            };

                            _this3.quoteData.quoteData[index].status = status;

                            saveObj.quoteData = _this3.quoteData.quoteData;
                            saveObj.activity = _this3.quoteData.activity;
                            saveData.push(saveObj);
                            _context5.next = 10;
                            return _this3.$store.dispatch('campaign/saveCampaignMasterLists', {
                              data: saveData
                            });

                          case 10:
                            _this3.isLoading = false;

                            if (_this3.savedMasterList) {
                              _context5.next = 14;
                              break;
                            }

                            _this3.$swal({
                              text: 'Error Saving Quote Data.',
                              type: 'error'
                            });
                            return _context5.abrupt('return');

                          case 14:
                            _this3.$swal({
                              text: 'Successfully saved.',
                              type: 'success'
                            });
                            _this3.$emit('created');
                            _this3.close();

                          case 17:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this3);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this3, [[4, 8, 12, 20], [13,, 15, 19]]);
      }))();
    },
    updateActivityData: function updateActivityData(activity) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var saveData, saveObj;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this4.isLoading = true;
                saveData = [];
                saveObj = {
                  id: _this4.quoteData.id
                };

                saveObj.activity = activity;
                saveData.push(saveObj);
                _context7.next = 7;
                return _this4.$store.dispatch('campaign/saveCampaignMasterLists', {
                  data: saveData
                });

              case 7:
                _this4.isLoading = false;

                if (_this4.savedMasterList) {
                  _context7.next = 11;
                  break;
                }

                _this4.$swal({
                  text: 'Error Saving Quote Data.',
                  type: 'error'
                });
                return _context7.abrupt('return');

              case 11:
                _this4.$swal({
                  text: 'Successfully saved.',
                  type: 'success'
                });

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this4);
      }))();
    },
    fetchXeroContact: function fetchXeroContact() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var resp, respData, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__Xero_XeroAPIs__["a" /* default */].getXeroContacts();

              case 3:
                resp = _context8.sent;
                respData = resp.data;
                data = respData.data;

                _this5.xeroContacts = data || [];
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this5, [[0, 9]]);
      }))();
    },
    resetQuoteData: function resetQuoteData() {
      this.quoteData = {
        acceptanceDate: '',
        salePerson: '',
        billingContact: '',
        quoteNo: '',
        quoteAmt: 0,
        indicateCost: '',
        invoiceSent: 0,
        invoiceCreated: 0,
        invoicePending: 0,
        currency: 'SGD',
        quoteData: []
      };
    },
    changeInvoiceSent: function changeInvoiceSent() {
      if (!isNaN(this.quoteData.quoteAmt) && !isNaN(this.quoteData.invoiceSent)) {
        if (this.quoteData.quoteAmt > 0) {
          this.quoteData.invoicePending = this.quoteData.quoteAmt - (this.quoteData.invoiceCreated ? Number(this.quoteData.invoiceCreated) : 0);
        }
      }
    },
    openInvoiceSentEditDialog: function openInvoiceSentEditDialog() {
      this.invoiceSentEditDialog = true;
    },
    openTimelineUpdateDialog: function openTimelineUpdateDialog() {
      this.editTimelineData = null;
      this.editTimelineIdx = null;
      this.timelineUpdateDialog = true;
    },
    openTimelineUpdateDialogForEdit: function openTimelineUpdateDialogForEdit(item, idx) {
      this.editTimelineIdx = idx;
      this.editTimelineData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.timelineUpdateDialog = true;
    },
    openInvoiceSentActivityDialog: function openInvoiceSentActivityDialog(activity) {
      this.editActivityData = [];
      if (Array.isArray(activity)) {
        this.editActivityData = activity.map(function (act) {
          act.remarksEdit = false;
          return act;
        });
      }
      this.invoiceSentActivityDialog = true;
    },
    updatedInvoiceSent: function updatedInvoiceSent(updateData) {
      this.quoteData.activity = updateData.activity;
      this.quoteData.invoiceSent = updateData.invoiceSent;
      this.quoteData.invoicePending = updateData.invoicePending;
      this.$emit('created');
    },
    updateTimelineAmount: function updateTimelineAmount(updateData) {
      this.quoteData.quoteData = updateData.quoteData;
      this.$emit('created');
    },
    changeQuoteDate: function changeQuoteDate() {
      this.isInvalidQuoteDate = false;
      if (this.quoteData.acceptanceDate && !this.isDateValid(this.quoteData.acceptanceDate)) {
        this.isInvalidQuoteDate = true;
        return;
      }
    },
    isDateValid: function isDateValid(givenDate) {
      if (!givenDate) return true;
      var regex = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].regexPattern.date_format;
      if (givenDate.match(regex)) return true;
      return false;
    },
    close: function close() {
      this.$emit('input');
    },
    formatMonth: function formatMonth(value) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(value).format('MMM YYYY');
    },
    checkQuoteAmt: function checkQuoteAmt(index) {
      var distributeAmt = 0;
      var enteredQuoteAmt = 0;
      if (Array.isArray(this.quoteData.quoteData)) {
        enteredQuoteAmt += Number(this.quoteData.quoteData[index].quoteAmt);
      }
      distributeAmt += Number(this.quoteData.invoiceCreated || 0);
      if (distributeAmt < enteredQuoteAmt) {
        this.$swal({
          text: 'Available Amount Not Enough.',
          type: 'error'
        });
        return false;
      } else if (Number(this.quoteData.quoteAmt) < distributeAmt) {
        this.$swal({
          text: 'Quote Amount Exceeded.',
          type: 'error'
        });
        return false;
      }
      return true;
    },
    getApprovedQuotes: function getApprovedQuotes(quoteData) {
      var _this6 = this;

      if (Array.isArray(quoteData)) {
        return quoteData.filter(function (q) {
          return q.status === _this6.quoteStatuses.ACCEPT;
        });
      }
      return false;
    },
    deleteTimeline: function deleteTimeline(idx) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this7.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to Delete?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(result) {
                    var deletedData, saveData;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            if (!result.value) {
                              _context9.next = 15;
                              break;
                            }

                            _this7.isLoading = true;
                            deletedData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], _this7.quoteData.quoteData);

                            deletedData.splice(idx, 1);
                            saveData = [];

                            saveData.push({
                              id: _this7.quoteData.id,
                              quoteData: deletedData
                            });
                            _context9.next = 8;
                            return _this7.$store.dispatch('campaign/saveCampaignMasterLists', {
                              data: saveData
                            });

                          case 8:
                            _this7.isLoading = false;

                            if (_this7.savedMasterList) {
                              _context9.next = 12;
                              break;
                            }

                            _this7.$swal({
                              text: _this7.masterListErr ? _this7.masterListErr : 'Error Saving Quote Data.',
                              type: 'error'
                            });
                            return _context9.abrupt('return');

                          case 12:
                            _this7.$swal({
                              text: 'Successfully deleted.',
                              type: 'success'
                            });
                            _this7.$emit('created');
                            _this7.quoteData.quoteData.splice(idx, 1);

                          case 15:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this7);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this7);
      }))();
    },
    calcExgAmt: function calcExgAmt() {
      if (this.quoteData.priceRdo === 1) {
        if (this.quoteData.quoteAmtFC && this.quoteData.estExchangeRate) {
          this.calculatedRate = (this.quoteData.quoteAmtFC * this.quoteData.estExchangeRate).toFixed(0);
        }
      } else {
        if (this.quoteData.quoteAmtFC && this.quoteData.confirmExchangeRate) {
          this.calculatedRate = (this.quoteData.quoteAmtFC * this.quoteData.confirmExchangeRate).toFixed(0);
        }
      }
    },
    addLinkIO: function addLinkIO() {
      this.quoteData.linkedIOs.push('');
    },
    deleteLinkIO: function deleteLinkIO(idx) {
      this.quoteData.linkedIOs.splice(idx, 1);
    }
  }
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CreateQuoteModal__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CreateQuoteModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CreateQuoteModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SalesEditModal__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SalesEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SalesEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RecognizedRevenueModal__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RecognizedRevenueModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__RecognizedRevenueModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ActiveYearModal__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ActiveYearModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ActiveYearModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DistributionEditModal__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DistributionEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__DistributionEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_uniq__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_reverse__);


























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MasterListsDataTable',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay___default.a,
    CreateQuoteModal: __WEBPACK_IMPORTED_MODULE_14__CreateQuoteModal___default.a,
    SalesEditModal: __WEBPACK_IMPORTED_MODULE_15__SalesEditModal___default.a,
    RecognizedRevenueModal: __WEBPACK_IMPORTED_MODULE_16__RecognizedRevenueModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_TableColsShowHideModal___default.a,
    ActiveYearModal: __WEBPACK_IMPORTED_MODULE_17__ActiveYearModal___default.a,
    DistributionEditModal: __WEBPACK_IMPORTED_MODULE_18__DistributionEditModal___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].tableHeaders,
      dynamicMonthLists: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].dynamicMonthLists,
      saleUsers: [],
      AM: [],
      CC: [],
      campaignVerticals: [],
      filteredItems: [],
      filter: '',
      createQuoteDialog: false,
      salesEditDialog: false,
      isLoading: false,
      editData: null,
      yearEditData: null,
      colSettingsDialog: false,
      revRecognizedDialog: false,
      activeYearDialog: false,
      colStatuses: {},
      userProfile: {},
      selectedFilter: {
        year: 2026,
        salePerson: '',
        AM: '',
        acceptedMonth: ''
      },
      totalValues: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].defaultTotalValues,
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      IOSearched: false,
      selectedLists: [],
      distributionEditDialog: false,
      editDistribution: {},
      masterListSummary: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    masterLists: function masterLists(state) {
      return state.campaign.masterLists;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isSuperAdmin: function isSuperAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isQuoteEdit: function isQuoteEdit() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.FINANCE || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isSalesEdit: function isSalesEdit() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isAmtEdit: function isAmtEdit() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.FINANCE || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    computedHeaders: function computedHeaders() {
      var _this = this;

      var masterListCols = null;
      var headers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.headers);
      if (this.selectedFilter.year) {
        var filterYear = '';
        if (this.selectedFilter.year === 'All') {
          filterYear = parseInt(this.currentYear);
        } else {
          filterYear = this.selectedFilter.year;
        }

        headers = headers.map(function (h) {
          if (h.value === 'priorYear') {
            h.text = 'Prior ' + filterYear;
          }
          if (h.value === 'nextYear') {
            h.text = 'For Year ' + (filterYear + 1);
          }
          var matchMonth = _this.dynamicMonthLists.find(function (dMonth) {
            return dMonth === h.value;
          });
          if (matchMonth) {
            h.text = matchMonth + '-' + filterYear;
          }

          if (h.value === 'revenueYetRecognise') {
            h.text = _this.getRevYetColTitle();
          }
          return h;
        });
      }

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.masterListCols) {
          masterListCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.masterListCols);
        }
      }
      if (masterListCols) {
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, masterListCols);
      } else {
        headers.map(function (header) {
          _this.colStatuses[header.value] = true;
        });
      }
      return headers.filter(function (h) {
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentMonth: function currentMonth() {
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('MMM');
    },
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('YYYY');
    },
    currentMonthYear: function currentMonthYear() {
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('MMM YYYY');
    },
    daysInMonth: function daysInMonth() {
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()().daysInMonth();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getUsers();

            case 2:
              _context.next = 4;
              return _this2.getSaleUsers();

            case 4:
              _this2.saleUsers = _context.sent;
              _context.next = 7;
              return _this2.getAllCampaigns();

            case 7:
              _this2.getMasterLists();
              _context.next = 10;
              return _this2.getUserProfile();

            case 10:
              if (_this2.$route.query.IO && !_this2.IOSearched) {
                _this2.filter = _this2.$route.query.IO;
              }

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    getMasterLists: function getMasterLists() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;
                _context2.next = 3;
                return _this3.$store.dispatch('campaign/getCampaignMasterLists', {
                  filters: {
                    year: _this3.selectedFilter.year
                  }
                });

              case 3:
                _this3.searchFilter();
                _this3.isLoading = false;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = [];
      var items = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.masterLists);
      this.filteredItems = items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (i) {
          var AMs = i.AM.map(function (a) {
            return a.id;
          });
          if (AMs.includes(_this4.selectedFilter.AM)) {
            return true;
          } else {
            if (_this4.selectedFilter.AM === 'Empty') {
              return AMs.length === 0;
            }
          }
          return false;
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (i) {
          var CCs = i.CC.map(function (a) {
            return a.id;
          });
          if (CCs.includes(_this4.selectedFilter.CC)) {
            return true;
          } else {
            if (_this4.selectedFilter.CC === 'Empty') {
              return CCs.length === 0;
            }
          }
          return false;
        });
      }
      if (this.selectedFilter.salePerson) {
        this.filteredItems = this.filteredItems.filter(function (i) {
          return i.salePerson === _this4.selectedFilter.salePerson;
        });
      }
      if (this.selectedFilter.acceptedMonth) {
        this.filteredItems = this.filteredItems.filter(function (i) {
          return i.formattedAcceptanceDate.includes(_this4.selectedFilter.acceptedMonth);
        });
      }
      this.masterListSummary = this.getMasterListSummary();
    },
    getUsers: function getUsers() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = null;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 3:
                response = _context3.sent;

                if (response) {
                  _this5.AM = response.users;
                  _this5.AM = _this5.AM.map(function (am) {
                    am.name = am.firstName + ' ' + am.lastName;
                    return am;
                  });
                  _this5.AM.unshift({
                    id: 'Empty',
                    firstName: 'Empty'
                  });
                }
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 7:
                response = _context3.sent;

                if (response) {
                  _this5.CC = response.users;
                  _this5.CC = _this5.CC.map(function (cc) {
                    cc.name = cc.firstName + ' ' + cc.lastName;
                    return cc;
                  });
                  _this5.CC.unshift({
                    id: 'Empty',
                    firstName: 'Empty'
                  });
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getCampaignVerticals: function getCampaignVerticals() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var vResp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].getAllCampaignVerticals(false);

              case 2:
                vResp = _context4.sent;

                _this6.campaignVerticals = vResp.data;

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getSaleUsers: function getSaleUsers() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW);

              case 2:
                resp = _context5.sent;
                return _context5.abrupt('return', resp.users);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    getCampaignByIONumber: function getCampaignByIONumber(ioNumbers) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var filter;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                filter = {
                  filters: {
                    ioNumbers: ioNumbers
                  }
                };
                _context6.next = 3;
                return _this8.$store.dispatch('campaign/getCampaigns', filter);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    getAllCampaigns: function getAllCampaigns() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this9.$store.dispatch('campaign/getCampaigns', {});

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    formatCampaignVerticals: function formatCampaignVerticals(campaign) {
      var selectedCampaignVertical = [];
      if (campaign.vertical) {
        this.campaignVerticals.map(function (item) {
          campaign.vertical.map(function (vertical) {
            if (item.id === vertical) {
              selectedCampaignVertical.push(item);
            }
          });
        });
      }
      return selectedCampaignVertical;
    },
    getProductName: function getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut';
      }
      return itemName;
    },
    openCreateQuoteModal: function openCreateQuoteModal() {
      this.editData = null;
      this.createQuoteDialog = true;
    },
    openDistributionEditModal: function openDistributionEditModal(item, month) {
      this.distributionEditDialog = false;
      var monthNo = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.getMonthNo(month);
      this.editDistribution = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
        id: item.id,
        amount: item[month] || 0,
        recordedMonths: item.recordedMonths || [],
        editedMonths: item.editedMonths || [],
        recordCheck: false,
        editedMonth: this.selectedFilter.year + '-' + monthNo,
        editedCheck: false,
        currentMonth: '' + month + this.selectedFilter.year,
        monthlyRates: item.monthlyRates,
        editHistory: item.editHistory || []
      });
      this.editDistribution.editHistory = __WEBPACK_IMPORTED_MODULE_23_lodash_reverse___default()(this.editDistribution.editHistory);
      if (item.recordedMonths) {
        if (Array.isArray(item.recordedMonths)) {
          if (item.recordedMonths.includes('' + month + this.selectedFilter.year)) {
            this.editDistribution.recordCheck = true;
          }
        }
      }
      if (item.editedMonths) {
        if (Array.isArray(item.editedMonths)) {
          if (item.editedMonths.includes(this.selectedFilter.year + '-' + monthNo)) {
            this.editDistribution.editedCheck = true;
          }
        }
      }
      this.distributionEditDialog = true;
    },
    reload: function reload() {
      this.getMasterLists();
    },
    displayVerticals: function displayVerticals(verticals) {
      return verticals.join(', ');
    },
    displayCampaigns: function displayCampaigns(campaigns) {
      var displayNames = campaigns.map(function (c) {
        return c.name;
      });
      return displayNames.join(', ');
    },
    displayUsers: function displayUsers(users) {
      var displayNames = users.map(function (c) {
        return c.firstName + ' ' + c.lastName;
      });
      displayNames = __WEBPACK_IMPORTED_MODULE_22_lodash_uniq___default()(displayNames);
      return displayNames.join(', ');
    },
    openFinanceEditDialog: function openFinanceEditDialog(item) {
      this.editData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);
      this.createQuoteDialog = true;
    },
    openSalesEditDialog: function openSalesEditDialog(item) {
      this.editData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);
      this.salesEditDialog = true;
    },
    formatMonth: function formatMonth(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()(date).format('MMM YYYY');
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_21_moment___default()(date).format('DD/MM/YYYY');
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.headers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                columns = _this10.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this10.userProfile.tableSettings) {
                  tableSettings = _this10.userProfile.tableSettings;
                }
                tableSettings.masterListCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this10.currentUserID,
                  tableSettings: tableSettings
                };
                _context8.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this10.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                _this10.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getUser(_this11.currentUserID);

              case 2:
                resp = _context9.sent;

                if (resp && resp.id) {
                  _this11.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    getFiltered: function getFiltered(filtered) {
      var _this12 = this;

      this.totalValues = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].defaultTotalValues);
      if (filtered.length > 0) {
        filtered.map(function (f) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].defaultTotalValues)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var key = _step2.value;

              _this12.totalValues[key] += f[key] && !isNaN(f[key]) ? Number(f[key]) : 0;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].defaultTotalValues)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            this.totalValues[key] = this.totalValues[key].toFixed(2);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    },
    getRevYetColTitle: function getRevYetColTitle() {
      if (Number(this.selectedFilter.year) === Number(this.currentYear)) {
        return 'Revenue yet to recognise (as at end ' + this.daysInMonth + ' of ' + this.currentMonth + ')';
      } else {
        return 'Revenue yet to recognise (as at end 31 of Dec)';
      }
    },
    openRecognizedRevenueModal: function openRecognizedRevenueModal() {
      this.revRecognizedDialog = true;
    },
    downloadMasterlistRpt: function downloadMasterlistRpt() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var masterListIds, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this13.isLoading = true;
                masterListIds = _this13.filteredItems.map(function (i) {
                  return i.id;
                });
                data = {
                  year: _this13.selectedFilter.year,
                  masterListIds: masterListIds
                };

                __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].downloadMasterListsReport(data).then(function () {
                  _this13.isLoading = false;
                }).catch(function (error) {
                  _this13.isLoading = false;
                  console.log('error in downloading masterlists report', error);
                });

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    showLock: function showLock(monthYear) {
      var lockedMonths = [];
      var selectedYear = this.selectedFilter.year;
      if (this.filteredItems.length > 0) {
        lockedMonths = this.filteredItems[0].lockedMonths;
      }
      var monthLists = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.dynamicMonthLists);
      monthLists = monthLists.map(function (m) {
        return '' + m + selectedYear;
      });
      if (monthLists.includes(monthYear) && !lockedMonths.includes(monthYear)) {
        return true;
      }
      return false;
    },
    showUnlock: function showUnlock(month) {
      var lockedMonths = [];
      var selectedYear = this.selectedFilter.year;
      var monthLists = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.dynamicMonthLists);
      monthLists = monthLists.map(function (m) {
        return '' + m + selectedYear;
      });
      if (this.filteredItems.length > 0) {
        lockedMonths = this.filteredItems[0].lockedMonths;
      }
      if (monthLists.includes(month) && lockedMonths.includes(month)) {
        return true;
      }
      return false;
    },
    getCellStatClr: function getCellStatClr(month, item) {
      var currentMthYear = '' + month + this.selectedFilter.year;
      var isNewDistr = false;
      var isEditedAmt = false;
      if (item.lockedMonths) {
        if (item.lockedMonths.includes(currentMthYear)) {
          return 'bg-grey lighten-1';
        }
      }
      if (item[month]) {
        isNewDistr = true;
      }
      if (item.recordedMonths) {
        if (Array.isArray(item.recordedMonths)) {
          if (item.recordedMonths.includes(currentMthYear)) {
            isNewDistr = false;
          }
        }
      }
      if (item.editedMonths) {
        if (Array.isArray(item.editedMonths)) {
          var editMonths = item.editedMonths.map(function (e) {
            return __WEBPACK_IMPORTED_MODULE_21_moment___default()(e).format('MMMYYYY');
          });
          if (editMonths.includes(currentMthYear)) {
            isNewDistr = false;
            isEditedAmt = true;
          }
        }
      }
      if (isEditedAmt) {
        return 'bg-blue';
      }
      if (isNewDistr) {
        return 'bg-yellow';
      }
      return '';
    },
    changeLock: function changeLock(value, status) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var dataObj;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this14.isLoading = true;
                dataObj = {
                  month: value,
                  year: _this14.selectedFilter.year,
                  status: status
                };
                _context11.next = 4;
                return _this14.$store.dispatch('campaign/changeMasterListLock', dataObj);

              case 4:
                _this14.getMasterLists();

              case 5:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    selectAllCampaigns: function selectAllCampaigns($event) {
      if ($event.value && $event.items.length === 0 || !$event.value) {
        this.selectedLists = [];
        return;
      }
      if (this.selectedLists.length === 0) {
        this.selectedLists = $event.items;
      } else this.selectedLists = [];
    },
    openActiveYearDialog: function openActiveYearDialog() {
      this.activeYearDialog = true;
    },
    isPendingTimeline: function isPendingTimeline(timelines) {
      if (!timelines) return false;
      var isPending = false;
      timelines.map(function (t) {
        if (t.status === 0) isPending = true;
      });
      return isPending;
    },
    getMasterListSummary: function getMasterListSummary() {
      var selectedYear = this.selectedFilter.year ? this.selectedFilter.year : __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('YYYY');
      var revRecon = 0;
      var revReconForMonth = 0;
      var unRecon = 0;
      var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var currentMonthYear = __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('MMM') + '' + __WEBPACK_IMPORTED_MODULE_21_moment___default()().format('YYYY');
      var matchMonths = shortMonths.map(function (m) {
        return '' + m + selectedYear;
      });
      var revsForMonthYear = matchMonths.map(function (m) {
        return {
          month: m,
          amount: 0,
          unallocatedAmt: 0,
          totalRevenue: 0,
          allocatedCampaigns: 0
        };
      });

      var _loop = function _loop(item) {
        var allAmts = 0;
        var createdMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()(item.createdAt).format('MMMYYYY');
        if (item.monthlyRates) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(item.monthlyRates)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var _ref3 = _step6.value;

              var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

              var key = _ref4[0];
              var value = _ref4[1];

              allAmts += parseFloat(value);
              if (key === currentMonthYear) {
                revReconForMonth += parseFloat(value);
              }
              if (key.includes(selectedYear)) {
                revRecon += parseFloat(value);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
        unRecon += parseFloat(item.quoteAmt - allAmts);
        var revMYIdx = revsForMonthYear.findIndex(function (rev) {
          return rev.month === createdMonth;
        });
        if (revMYIdx !== -1) {
          revsForMonthYear[revMYIdx].unallocatedAmt += parseFloat(unRecon);
        }
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.filteredItems), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          _loop(item);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _loop2 = function _loop2(item) {
        var createdMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()(item.createdAt).format('MMMYYYY');
        if (item.monthlyRates) {
          var _loop3 = function _loop3(key, value) {
            var revMYIdx = revsForMonthYear.findIndex(function (rev) {
              return rev.month === key;
            });
            if (revMYIdx !== -1) {
              revsForMonthYear[revMYIdx].amount += parseFloat(value);
            }
          };

          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(item.monthlyRates)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _ref5 = _step7.value;

              var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

              var key = _ref6[0];
              var value = _ref6[1];

              _loop3(key, value);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }

        var revMYIdx = revsForMonthYear.findIndex(function (rev) {
          return rev.month === createdMonth;
        });
        if (revMYIdx !== -1) {
          revsForMonthYear[revMYIdx].totalRevenue += parseFloat(item.quoteAmt);
        }

        if (revMYIdx !== -1) {
          revsForMonthYear[revMYIdx].allocatedCampaigns += item.campaignIDs ? parseInt(item.campaignIDs.length) : 0;
        }
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.masterLists), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          _loop2(item);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      revsForMonthYear = revsForMonthYear.map(function (rm) {
        rm.month = rm.month.replace(selectedYear.toString(), ' ' + selectedYear);
        rm.amount = parseFloat(parseFloat(rm.amount, 2).toFixed(2));
        rm.unallocatedAmt = parseFloat(parseFloat(rm.unallocatedAmt, 2).toFixed(2));
        rm.totalRevenue = parseFloat(parseFloat(rm.totalRevenue, 2).toFixed(2));
        return rm;
      });
      var activeDealCt = this.filteredItems.filter(function (item) {
        return item.lineOfServices !== 'Loading Fees' && item.lineOfServices !== 'Academy';
      }).length;
      return {
        revRecon: parseFloat(parseFloat(revRecon, 2).toFixed(2)),
        revReconForMonth: parseFloat(parseFloat(revReconForMonth, 2).toFixed(2)),
        unRecon: parseFloat(parseFloat(unRecon, 2).toFixed(2)),
        revsForMonthYear: revsForMonthYear,
        activeDealCt: activeDealCt
      };
    },
    refreshMasterList: function refreshMasterList(item) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this15.isLoading = true;
                _context12.next = 3;
                return _this15.$store.dispatch('campaign/refreshMasterList', {
                  data: [{
                    id: item.id
                  }]
                });

              case 3:
                _this15.getMasterLists();

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    isCurrentMth: function isCurrentMth(mth) {
      return this.currentMonth === mth;
    },
    showLinkedIO: function showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return '';
      IOs = IOs.map(function (i) {
        if (!i.includes('IO-')) {
          i = 'IO-' + i;
        }
        return i;
      });
      return IOs.join(', ');
    },
    isLockMonth: function isLockMonth(item, month) {
      if (item.lockedMonths) {
        if (item.lockedMonths.includes('' + month + this.selectedFilter.year)) {
          return true;
        }
      }
      return false;
    }
  }
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DistributionEditModal',
  props: ['value', 'editItem'],
  data: function data() {
    return {
      editData: {
        amount: 0,
        recordCheck: false,
        editedCheck: ''
      },
      resetEdit: false
    };
  },

  watch: {
    value: function value(_value) {
      if (_value) {
        this.editData.amount = this.editItem.amount;
        this.editData.recordCheck = this.editItem.recordCheck;
        this.editData.editedCheck = this.editItem.editedCheck;
        if (this.editItem.editHistory.length) {
          this.editData.remarks = this.editItem.editHistory[this.editItem.editHistory.length - 1].remarks;
        }
        this.resetEdit = false;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    savedMasterList: function savedMasterList(state) {
      return state.campaign.savedMasterList;
    },
    masterListErr: function masterListErr(state) {
      return state.campaign.masterListErr;
    }
  }), {
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY');
    }
  }),
  methods: {
    saveData: function saveData() {
      var _this = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save changes?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var saveData, quoteData, recordedMonths, matchIdx, editedMonths, _matchIdx, mthlyRates, editHistory;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 27;
                    break;
                  }

                  _this.isLoading = true;
                  saveData = [];
                  quoteData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                    id: _this.editItem.id
                  });
                  recordedMonths = _this.editItem.recordedMonths;

                  if (_this.editData.recordCheck && !_this.resetEdit) {
                    if (!recordedMonths.includes(_this.editItem.currentMonth)) {
                      recordedMonths.push(_this.editItem.currentMonth);
                    }
                  } else {
                    matchIdx = recordedMonths.findIndex(function (r) {
                      return r === _this.editItem.currentMonth;
                    });

                    if (matchIdx !== -1) {
                      recordedMonths.splice(matchIdx, 1);
                    }
                  }
                  quoteData.recordedMonths = recordedMonths;
                  editedMonths = _this.editItem.editedMonths;

                  if (!_this.resetEdit) {
                    if (!editedMonths.includes(_this.editItem.currentMonth)) {
                      editedMonths.push(_this.editItem.editedMonth);
                    }
                  } else {
                    _matchIdx = editedMonths.findIndex(function (r) {
                      return r === _this.editItem.editedMonth;
                    });

                    if (_matchIdx !== -1) {
                      editedMonths.splice(_matchIdx, 1);
                    }
                  }
                  quoteData.editedMonths = editedMonths;

                  if (!_this.editItem.monthlyRates[_this.editItem.currentMonth]) {
                    _this.editItem.monthlyRates[_this.editItem.currentMonth] = '';
                  }
                  mthlyRates = _this.editItem.monthlyRates;

                  mthlyRates[_this.editItem.currentMonth] = Number(_this.editData.amount);
                  quoteData.monthlyRates = mthlyRates;
                  editHistory = _this.editItem.editHistory;

                  editHistory.push({
                    amount: _this.editData.amount,
                    recordCheck: _this.editData.recordCheck,
                    remarks: _this.editData.remarks
                  });
                  quoteData.editHistory = editHistory;
                  saveData.push(quoteData);
                  _context.next = 20;
                  return _this.$store.dispatch('campaign/saveCampaignMasterLists', {
                    data: saveData
                  });

                case 20:
                  _this.isLoading = false;

                  if (_this.savedMasterList) {
                    _context.next = 24;
                    break;
                  }

                  _this.$swal({
                    text: _this.masterListErr ? _this.masterListErr : 'Error Saving Quote Data.',
                    type: 'error'
                  });
                  return _context.abrupt('return');

                case 24:
                  _this.$swal({
                    text: 'Successfully saved.',
                    type: 'success'
                  });
                  _this.$emit('updated');
                  _this.close();

                case 27:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetEditedMonth: function resetEditedMonth() {
      this.resetEdit = true;
      this.editData.amount = '';
    },
    close: function close() {
      this.$emit('input');
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format('DD-MM-YYYY hh:mm:ss');
    }
  }
});

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_DataTableMixin__ = __webpack_require__(227);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceSentActivityModal',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_DataTableMixin__["a" /* default */]],
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a },
  data: function data() {
    return {
      activityData: [],
      isLoading: false,
      showEditActions: false
    };
  },

  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        if (!this.data) return;
        this.activityData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.data);
      }
    }
  },
  methods: {
    updateActivity: function updateActivity() {
      this.$emit('updateActivityData', this.activityData);
      var vm = this;
      setTimeout(function () {
        vm.cancelEdit();
      }, 1000);
    },
    cancelEdit: function cancelEdit() {
      this.activityData = this.activityData.map(function (act) {
        act.remarksEdit = false;
        return act;
      });
      this.showEditActions = false;
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD-MM-YYYY hh:mm:ss');
    },
    formatMonth: function formatMonth(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('MMM YYYY');
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceSentEditModal',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a },
  data: function data() {
    return {
      activeMasterListData: null,
      startCal: false,
      endCal: false,
      isLoading: false
    };
  },

  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        this.activeMasterListData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.data);
        if (!this.data.id) return;
        this.activeMasterListData.id = this.data.id;
        this.activeMasterListData.invoiceSent = 0;
        this.activeMasterListData.invoicePending = this.data.invoicePending || 0;
        this.activeMasterListData.activity = this.data.activity || [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    savedMasterList: function savedMasterList(state) {
      return state.campaign.savedMasterList;
    }
  }), {
    invalidInvoiceSent: function invalidInvoiceSent() {
      var amt = 0;
      if (Array.isArray(this.activeMasterListData.activity)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.activeMasterListData.activity), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var act = _step.value;

            if (act.amount) {
              amt += Number(act.amount);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return Number(this.activeMasterListData.quoteAmt) < amt + Number(this.activeMasterListData.invoiceSent);
    },
    disableMasterLists: function disableMasterLists() {
      return this.$v.activeMasterListData.$invalid;
    }
  }),
  validations: {
    activeMasterListData: {
      invoiceSent: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      },
      invoicePending: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    processUpdate: function processUpdate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var saveData, activity, totalInvoiceSent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 6;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Make sure you filled the required information correctly.'
                });
                return _context.abrupt('return');

              case 6:
                if (!_this.invalidInvoiceSent) {
                  _context.next = 9;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Invoice Sent must be less than Quote Amount!'
                });
                return _context.abrupt('return');

              case 9:
                _this.isLoading = true;
                saveData = [];
                activity = [];

                if (_this.activeMasterListData.activity) {
                  activity = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this.activeMasterListData.activity);
                }
                activity.push({
                  timestamp: __WEBPACK_IMPORTED_MODULE_6_moment___default()().toISOString(),
                  amount: Number(_this.activeMasterListData.invoiceSent),

                  remarks: _this.activeMasterListData.remarks
                });
                _this.changeInvoiceSent();
                totalInvoiceSent = Number(_this.data.invoiceSent) + Number(_this.activeMasterListData.invoiceSent);

                saveData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                  id: _this.activeMasterListData.id,
                  invoiceSent: totalInvoiceSent,
                  invoicePending: _this.activeMasterListData.invoicePending,
                  activity: activity
                }));
                _this.activeMasterListData.activity = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], activity);
                _context.next = 20;
                return _this.$store.dispatch('campaign/saveCampaignMasterLists', {
                  data: saveData
                });

              case 20:
                _this.isLoading = false;

                if (_this.savedMasterList) {
                  _context.next = 24;
                  break;
                }

                _this.$swal({
                  text: 'Error Updating Invoice Sent.',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 24:
                _this.$swal({
                  text: 'Successfully updated.',
                  type: 'success'
                });
                _this.$emit('created', _this.activeMasterListData);
                _this.clearForm();
                _this.close();

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clearForm: function clearForm() {
      this.activeMasterListData = null;
    },
    close: function close() {
      this.$emit('input');
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(value).format('DD-MM-YYYY hh:mm:ss');
    },
    changeInvoiceSent: function changeInvoiceSent() {
      if (!isNaN(this.activeMasterListData.invoicePending) && !isNaN(this.activeMasterListData.invoiceSent)) {
        if (this.activeMasterListData.invoicePending > 0) {
          this.activeMasterListData.invoicePending = this.activeMasterListData.invoicePending - this.activeMasterListData.invoiceSent;
        }
      }
    }
  }
});

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecognizedRevenueModal',
  props: ['value', 'masterlists', 'monthYearValues', 'AM', 'CC', 'selectedYear'],
  data: function data() {
    return {
      AMCC: [],
      selectedFilter: {
        AMCC: ''
      },
      headers: [{
        text: 'Month',
        value: 'month'
      }, {
        text: 'Recognised Revenue',
        value: 'amount'
      }],
      filteredMthYearVals: []
    };
  },

  computed: {
    computedHeaders: function computedHeaders() {
      var _this = this;

      var headers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.headers);
      if (this.selectedFilter && this.selectedFilter.AMCC) {
        if (this.selectedFilter.AMCC !== 'Empty') {
          var matchAM = this.AMCC.find(function (a) {
            return a.id === _this.selectedFilter.AMCC;
          });
          if (matchAM) {
            headers.push({
              text: 'Revenue ' + matchAM.firstName + ' ' + (matchAM.lastName || ''),
              value: 'filteredAmt'
            });
          }
        }
      }
      return headers;
    },

    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY');
    },
    totalAmount: function totalAmount() {
      var total = 0;
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(function (m) {
          if (m.amount) {
            total += parseFloat(m.amount);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    unallocatedAmt: function unallocatedAmt() {
      var total = 0;
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(function (m) {
          if (m.unallocatedAmt) {
            total += parseFloat(m.unallocatedAmt);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    totalRevenue: function totalRevenue() {
      var total = 0;
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(function (m) {
          if (m.totalRevenue) {
            total += parseFloat(m.totalRevenue);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    allocatedCampaigns: function allocatedCampaigns() {
      var total = 0;
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(function (m) {
          if (m.allocatedCampaigns) {
            total += parseFloat(m.allocatedCampaigns);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    totalFilteredAmount: function totalFilteredAmount() {
      var total = 0;
      if (this.filteredMthYearVals) {
        this.filteredMthYearVals.map(function (m) {
          if (m.filteredAmt) {
            total += parseFloat(m.filteredAmt);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    totalFilterPercent: function totalFilterPercent() {
      return (this.totalFilteredAmount / this.totalAmount * 100).toFixed(2);
    }
  },
  watch: {
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.AMCC = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.AM), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.CC)));
                this.AMCC = this.AMCC.filter(function (a) {
                  return a.id !== 'Empty';
                });
                this.filteredMthYearVals = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.monthYearValues);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function value(_x) {
        return _ref.apply(this, arguments);
      }

      return value;
    }()
  },
  methods: {
    getRevPercent: function getRevPercent(item) {
      return (item.filteredAmt / item.amount * 100).toFixed(2);
    },
    changeFilter: function changeFilter() {
      var _this2 = this;

      this.filteredMthYearVals = this.filteredMthYearVals.map(function (f) {
        f.filteredAmt = 0;
        return f;
      });
      if (this.selectedFilter.AMCC) {
        var filteredMasterLists = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.masterlists);
        filteredMasterLists = filteredMasterLists.filter(function (i) {
          var AMs = i.AM.map(function (a) {
            return a.id;
          });
          if (AMs.includes(_this2.selectedFilter.AMCC)) {
            return true;
          }
          var CCs = i.CC.map(function (a) {
            return a.id;
          });
          if (CCs.includes(_this2.selectedFilter.AMCC)) {
            return true;
          }
          return false;
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(filteredMasterLists), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.monthlyRates) {
              var _loop = function _loop(key, value) {
                var revMYIdx = _this2.filteredMthYearVals.findIndex(function (rev) {
                  return rev.month.replace(' ', '') === key;
                });
                if (revMYIdx !== -1) {
                  _this2.filteredMthYearVals[revMYIdx].filteredAmt += parseFloat(value);
                }
              };

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(item.monthlyRates)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var _ref2 = _step2.value;

                  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

                  var key = _ref3[0];
                  var value = _ref3[1];

                  _loop(key, value);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SalesEditModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  validations: function validations() {
    return this.rules;
  },
  props: ['value', 'editData'],
  data: function data() {
    return {
      masterData: {
        startMonth: 0,
        endMonth: 0
      },
      quoteStatuses: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].quoteStatuses,
      quoteData: [],
      activityData: [],
      minDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    masterLists: function masterLists(state) {
      return state.campaign.masterLists;
    },
    savedMasterList: function savedMasterList(state) {
      return state.campaign.savedMasterList;
    }
  }), {
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY');
    },
    nextYear: function nextYear() {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()().add(1, 'years').format('YYYY');
    },
    disableMasterLists: function disableMasterLists() {
      return this.$v.masterData.$invalid;
    },
    availableAmt: function availableAmt() {
      var _this = this;

      if (!this.editData) return 0;
      var amt = 0;
      var enteredAmts = 0;
      if (this.editData.invoiceCreated) {
        amt += Number(this.editData.invoiceCreated);
      }

      if (this.editData.linkedIOs) {
        var matchMasterlist = this.masterLists.find(function (m) {
          return _this.editData.linkedIOs.includes(m.quoteNo.replace('IO-', ''));
        });
        if (matchMasterlist) {
          amt += Number(matchMasterlist.invoiceCreated || 0);
        }
      }

      if (this.editData.quoteData) {
        if (Array.isArray(this.editData.quoteData)) {
          this.editData.quoteData.map(function (quote) {
            if (quote.quoteAmt && (quote.status === 1 || quote.status === 0)) {
              enteredAmts += Number(quote.quoteAmt);
            }
          });
        }
      }
      if (amt > 0) {
        return Number(amt) - Number(enteredAmts);
      }
      return 0;
    },
    currentAvailableAmt: function currentAvailableAmt() {
      var _this2 = this;

      if (!this.editData) return 0;
      var amt = 0;
      var enteredAmts = 0;
      if (this.editData.invoiceCreated) {
        amt += Number(this.editData.invoiceCreated);
      }

      if (this.editData.linkedIOs) {
        var matchMasterlist = this.masterLists.find(function (m) {
          return _this2.editData.linkedIOs.includes(m.quoteNo.replace('IO-', ''));
        });
        if (matchMasterlist) {
          amt += Number(matchMasterlist.invoiceCreated || 0);
        }
      }

      if (this.quoteData) {
        if (Array.isArray(this.quoteData)) {
          this.quoteData.map(function (quote) {
            if (quote.quoteAmt && (quote.status === 1 || quote.status === 0)) {
              enteredAmts += Number(quote.quoteAmt);
            }
          });
        }
      }
      if (amt > 0) {
        return Number(amt) - Number(enteredAmts);
      }
      return 0;
    },
    showTitle: function showTitle() {
      var titleTxt = '';
      if (this.editData) {
        if (this.editData.billingContact) {
          titleTxt += this.editData.billingContact.Name;
        }
        titleTxt += ' (' + this.editData.quoteNo + ')';
      }
      return titleTxt;
    },
    rules: function rules() {
      var validationRules = {
        masterData: {
          startMonth: {
            required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
          },
          endMonth: {
            required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
          }
        }
      };
      return validationRules;
    },
    startMonthErrors: function startMonthErrors() {
      var errors = [];
      if (!this.$v.masterData.startMonth.$dirty) return errors;
      !this.$v.masterData.startMonth.required && errors.push('This field is required.');
      return errors;
    },
    endMonthErrors: function endMonthErrors() {
      var errors = [];
      if (!this.$v.masterData.endMonth.$dirty) return errors;
      !this.$v.masterData.endMonth.required && errors.push('This field is required.');
      return errors;
    }
  }),
  watch: {
    editData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (newValue) {
                  _context.next = 4;
                  break;
                }

                delete this.masterData.id;
                this.resetQuoteData();
                return _context.abrupt('return');

              case 4:
                this.masterData.id = newValue.id;
                this.masterData.quoteAmt = newValue.quoteAmt;
                this.masterData.activity = newValue.activity || [];
                this.masterData.invoiceSent = newValue.invoiceSent || 0;
                this.masterData.invoicePending = newValue.invoicePending || 0;
                this.masterData.invoiceCreated = newValue.invoiceCreated || 0;

                this.quoteData = [];
                if (newValue.quoteData) {
                  this.quoteData = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(newValue.quoteData);
                  this.quoteData = this.quoteData.map(function (q) {
                    q.editMode = false;
                    return q;
                  });
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editData(_x) {
        return _ref.apply(this, arguments);
      }

      return editData;
    }()
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  methods: {
    addQuoteData: function addQuoteData() {
      this.quoteData.push({
        quoteAmt: 0,
        startMonth: '',
        endMonth: '',
        status: 0,
        new: true
      });
    },
    removeQuoteData: function removeQuoteData(index) {
      this.quoteData.splice(index, 1);
    },
    saveMasterData: function saveMasterData() {
      var _this4 = this;

      var isUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.currentAvailableAmt < 0)) {
                  _context4.next = 3;
                  break;
                }

                _this4.$swal({
                  text: 'Available Amount Not Enough.',
                  type: 'error'
                });
                return _context4.abrupt('return', false);

              case 3:
                _this4.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to save changes?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
                    var sendFinanceEmail, isUpdateEmail, quote, masterData, saveData;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result.value) {
                              _context3.next = 23;
                              break;
                            }

                            _this4.isLoading = true;
                            sendFinanceEmail = false;
                            isUpdateEmail = false;
                            quote = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this4.quoteData);

                            quote = quote.map(function (a) {
                              delete a.startCal;
                              delete a.endCal;
                              if (a.editMode && isUpdate) {
                                isUpdateEmail = true;
                                a.status = 0;
                              }
                              if (a.new) sendFinanceEmail = true;
                              delete a.editMode;
                              delete a.new;
                              return a;
                            });
                            quote = quote.filter(function (q) {
                              return q.quoteAmt && q.startMonth && q.endMonth;
                            });

                            if (quote.length) {
                              _context3.next = 11;
                              break;
                            }

                            _this4.$swal({
                              text: 'Invalid Quote Data.',
                              type: 'error'
                            });
                            _this4.isLoading = false;
                            return _context3.abrupt('return');

                          case 11:
                            masterData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                              id: _this4.editData.id,
                              quoteData: quote,
                              sendFinanceEmail: sendFinanceEmail,
                              isUpdateEmail: isUpdateEmail
                            });
                            saveData = [];

                            saveData.push(masterData);
                            _context3.next = 16;
                            return _this4.$store.dispatch('campaign/saveCampaignMasterLists', {
                              data: saveData
                            });

                          case 16:
                            _this4.isLoading = false;

                            if (_this4.savedMasterList) {
                              _context3.next = 20;
                              break;
                            }

                            _this4.$swal({
                              text: 'Error Saving Data.',
                              type: 'error'
                            });
                            return _context3.abrupt('return');

                          case 20:
                            _this4.$swal({
                              text: 'Successfully saved.',
                              type: 'success'
                            });
                            _this4.$emit('created');
                            if (!isUpdate) {
                              _this4.resetMasterData();
                              _this4.close();
                            }

                          case 23:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    resetMasterData: function resetMasterData() {
      this.masterData = {
        startMonth: 0,
        endMonth: 0
      };
    },
    close: function close() {
      this.$emit('input');
    },
    changeEditStatus: function changeEditStatus(index, status) {
      this.quoteData[index].editMode = status;
      this.quoteData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.quoteData);
    }
  }
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(169);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoiceSentEditModal',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a },
  data: function data() {
    return {
      activeMasterListData: {
        quoteAmt: '',
        startMonth: '',
        endMonth: '',
        remarks: ''
      },
      quoteAmt: 0,
      startCal: false,
      endCal: false,
      isLoading: false,
      minDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
      quoteStatuses: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].quoteStatuses
    };
  },

  props: {
    value: Boolean,
    data: Object,
    editTimelineData: Object,
    editTimelineIdx: Number
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        if (!this.data.id) return;
        this.quoteAmt = this.data.quoteAmt || 0;

        this.activeMasterListData.id = this.data.id;
        this.activeMasterListData.quoteData = this.data.quoteData || [];
        this.activeMasterListData.activity = this.data.activity || [];
        this.activeMasterListData.invoiceCreated = this.data.invoiceCreated || 0;

        this.activeMasterListData.quoteAmt = 0;
        this.activeMasterListData.startMonth = '';
        this.activeMasterListData.endMonth = '';
        this.activeMasterListData.remarks = '';
        if (this.editTimelineData) {
          this.activeMasterListData.startMonth = this.editTimelineData.startMonth || '';
          this.activeMasterListData.endMonth = this.editTimelineData.endMonth || '';
          this.activeMasterListData.quoteAmt = this.editTimelineData.quoteAmt || 0;
          this.activeMasterListData.remarks = this.editTimelineData.remarks || '';
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    masterLists: function masterLists(state) {
      return state.campaign.masterLists;
    },
    savedMasterList: function savedMasterList(state) {
      return state.campaign.savedMasterList;
    }
  }), {
    disableMasterLists: function disableMasterLists() {
      return this.$v.activeMasterListData.$invalid;
    },
    availableAmt: function availableAmt() {
      var _this = this;

      var amt = 0;
      var enteredAmts = 0;

      if (this.data.invoiceCreated) {
        amt += Number(this.data.invoiceCreated);
      }

      if (this.data.linkedIOs) {
        var matchMasterlist = this.masterLists.find(function (m) {
          return _this.data.linkedIOs.includes(m.quoteNo.replace('IO-', ''));
        });
        if (matchMasterlist) {
          amt += Number(matchMasterlist.invoiceCreated || 0);
        }
      }

      if (this.data.quoteData) {
        if (Array.isArray(this.data.quoteData)) {
          this.data.quoteData.map(function (quote, idx) {
            if (quote.quoteAmt && (quote.status === 1 || quote.status === 0) && idx !== _this.editTimelineIdx) {
              enteredAmts += Number(quote.quoteAmt);
            }
          });
        }
      }

      if (amt > 0) {
        return Number(amt) - Number(enteredAmts);
      }
      return 0;
    }
  }),
  validations: {
    activeMasterListData: {
      quoteAmt: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      },
      startMonth: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      },
      endMonth: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    processUpdate: function processUpdate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var totalAvalAmt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$v.$touch();

                if (!_this2.$v.$invalid) {
                  _context2.next = 4;
                  break;
                }

                _this2.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Make sure you filled the required information correctly.'
                });
                return _context2.abrupt('return');

              case 4:
                totalAvalAmt = _this2.availableAmt - Number(_this2.activeMasterListData.quoteAmt);

                if (!(totalAvalAmt < 0)) {
                  _context2.next = 8;
                  break;
                }

                _this2.$swal({
                  text: 'Available Amount Not Enough.',
                  type: 'error'
                });
                return _context2.abrupt('return', false);

              case 8:
                _this2.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to save changes?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                    var saveData, quoteData, createQuoteData;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!result.value) {
                              _context.next = 19;
                              break;
                            }

                            _this2.isLoading = true;
                            saveData = [];
                            quoteData = [];

                            if (_this2.activeMasterListData.quoteData) {
                              quoteData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], _this2.activeMasterListData.quoteData);
                            }
                            createQuoteData = {
                              quoteAmt: Number(_this2.activeMasterListData.quoteAmt),
                              startMonth: _this2.activeMasterListData.startMonth,
                              endMonth: _this2.activeMasterListData.endMonth,
                              remarks: _this2.activeMasterListData.remarks,
                              status: _this2.quoteStatuses.ACCEPT
                            };

                            if (_this2.editTimelineData) {
                              quoteData[_this2.editTimelineIdx] = createQuoteData;
                            } else {
                              quoteData.push(createQuoteData);
                            }
                            saveData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                              id: _this2.activeMasterListData.id,
                              quoteData: quoteData
                            }));
                            _this2.activeMasterListData.quoteData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], quoteData);
                            _context.next = 11;
                            return _this2.$store.dispatch('campaign/saveCampaignMasterLists', {
                              data: saveData
                            });

                          case 11:
                            _this2.isLoading = false;

                            if (_this2.savedMasterList) {
                              _context.next = 15;
                              break;
                            }

                            _this2.$swal({
                              text: 'Error Updating Invoice Sent.',
                              type: 'error'
                            });
                            return _context.abrupt('return');

                          case 15:
                            _this2.$swal({
                              text: 'Successfully updated.',
                              type: 'success'
                            });
                            _this2.$emit('created', _this2.activeMasterListData);
                            _this2.clearForm();
                            _this2.close();

                          case 19:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    clearForm: function clearForm() {
      this.activeMasterListData = {
        quoteAmt: '',
        startMonth: '',
        endMonth: '',
        remarks: ''
      };
    },
    close: function close() {
      this.$emit('input');
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format('DD-MM-YYYY hh:mm:ss');
    }
  }
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-master-lists',
  components: {
    MasterListsDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignListPaymentStatus',
  props: ['item'],
  data: function data() {
    return {
      payoutStatus: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].payoutStatus
    };
  }
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a },
  data: function data() {
    return {
      activePairingData: null,
      isLoading: false
    };
  },

  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        this.activePairingData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
        this.clearForm();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])(['user']), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isClientRole: function isClientRole() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.CLIENT;
    }
  }),
  validations: {
    activePairingData: {
      notes: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    saveNote: function saveNote() {
      var _this = this;

      if (this.activePairingData !== null) {
        var formData = new FormData();
        formData.append('pairingID', this.activePairingData.pairingID);
        formData.append('notes', this.activePairingData.notes);
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_3__Pairing_pairingAPIs__["a" /* default */].saveClientNote(formData).then(function (response) {
          _this.isLoading = false;
          _this.activePairingData.clientNotes = response.clientNotes;
          _this.beautifyData();
          _this.$swal({
            position: 'top-center',
            title: 'Successfully Saved Notes!',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this.$emit('savedNotes');
          _this.$emit('input');
        }).catch(function (error) {
          _this.isLoading = false;
          _this.$swal({
            position: 'top-center',
            title: 'Error while saving note',
            type: 'error',
            timer: 1500
          });
          console.log(error);
        });
      }
    },
    deleteNote: function deleteNote(fileIndex) {
      var _this2 = this;

      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete note?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var updateNote = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], _this2.activePairingData.clientNotes);
          updateNote.splice(fileIndex, 1);
          var formData = new FormData();
          formData.append('pairingID', _this2.activePairingData.pairingID);
          formData.append('clientNotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updateNote));
          _this2.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_3__Pairing_pairingAPIs__["a" /* default */].saveClientNote(formData).then(function (response) {
            _this2.activePairingData.clientNotes = updateNote;
            _this2.isLoading = false;

            _this2.$swal({
              text: 'Note Deleted',
              type: 'success'
            });
            _this2.$emit('savedNotes');
          }).catch(function (error) {
            console.log('error', error);
            _this2.isLoading = false;
          });
        }
      });
    },
    beautifyData: function beautifyData() {
      if (this.activePairingData.clientNotes !== undefined) {
        this.activePairingData.clientNotes = __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default()(this.activePairingData.clientNotes);
      }
    },
    showAction: function showAction(item) {
      if (item.author !== undefined) {
        if (item.author.id === this.currentUserID && this.isClientRole) {
          return true;
        }
      }
      return false;
    },
    clearForm: function clearForm() {
      this.activePairingData.notes = '';
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).fromNow();
    }
  }
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EstimatedLiveDateModal',
  props: {
    value: Boolean,
    pairing: Object,
    multiplePairings: Array
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      submissionDate: '',
      menu: '',
      isLoading: false,
      showDialog: false
    };
  },

  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push('Email is required');
      return errors;
    },
    submissionDateFormatted: function submissionDateFormatted() {
      return this.submissionDate ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.submissionDate).format('MM/yyyy') : '';
    }
  },
  watch: {
    pairing: function pairing(value) {
      this.showDialog = true;
      if (value.pairing_details) {
        if (value.pairing_details.estimatedLiveDate) {
          this.submissionDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value.pairing_details.estimatedLiveDate).format('YYYY-MM-DD');
        }
      }
    },
    value: function value(newValue) {
      this.showDialog = true;
    }
  },
  methods: {
    updateSubmission: function updateSubmission() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, pairingIDs, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.submissionDate) {
                  _context.next = 3;
                  break;
                }

                _this.$swal({
                  type: 'warning',
                  title: 'Invalid Estimated Live Date',
                  text: 'Make sure you filled the date correctly.'
                });
                return _context.abrupt('return');

              case 3:
                _this.isLoading = true;
                formData = new FormData();

                if (_this.multiplePairings.length) {
                  pairingIDs = _this.multiplePairings.map(function (m) {
                    return m.id;
                  });

                  formData.append('multiplepairingIDs', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(pairingIDs));
                } else {
                  formData.append('pairingID', _this.pairing.id);
                }
                formData.append('estimatedLiveDate', _this.submissionDate);
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].updateSubmissionDate(formData);

              case 9:
                resp = _context.sent;

                _this.isLoading = false;

                if (resp.status) {
                  _context.next = 14;
                  break;
                }

                _this.$swal({
                  text: 'Error updating estimated live date.',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 14:
                _this.$swal({
                  text: 'Successfully updated Estimated Live Date.',
                  type: 'success'
                });
                _this.$emit('updated');
                _this.closeModal();

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    closeModal: function closeModal() {
      this.showDialog = false;
      this.$emit('input');
      this.$emit('closeModal');
      this.submissionDate = '';
    }
  }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Contract_Influencer_contract__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CampaignInvite_QandA__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CampaignInvite_QandA___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CampaignInvite_QandA__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CampaignInvite_InfluencerContractModal__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CampaignInvite_InfluencerContractModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CampaignInvite_InfluencerContractModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__editor_vue2Editor__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__editor_vue2Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__editor_vue2Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__editor_sunEditor__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__editor_sunEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__editor_sunEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__editor_editorjs__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__editor_editorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__editor_editorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__editor_generator_HTMLToPDF__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_generator_blocksToHtml__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__followUp__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__followUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__followUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_mustache__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__);
































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Invoices-Brief-Dialog',
  props: ['dialog', 'influencer', 'influencerProfile', 'close', 'loadAllQuestions', 'selectedTab', 'briefDetailContent', 'newPairingFlow', 'isDownload', 'isFinalPayout', 'isGetInvoice'],
  components: {
    QandA: __WEBPACK_IMPORTED_MODULE_11__CampaignInvite_QandA___default.a,
    InfluencerContractModal: __WEBPACK_IMPORTED_MODULE_14__CampaignInvite_InfluencerContractModal___default.a,
    Vue2Editor: __WEBPACK_IMPORTED_MODULE_17__editor_vue2Editor___default.a,
    SunEditor: __WEBPACK_IMPORTED_MODULE_18__editor_sunEditor___default.a,
    editor: __WEBPACK_IMPORTED_MODULE_19__editor_editorjs___default.a,
    FollowUp: __WEBPACK_IMPORTED_MODULE_22__followUp___default.a
  },
  data: function data() {
    return {
      showContractModal: false,
      showAmountRowSpan: '',
      influencerContract: {},
      invoiceContract: {},
      rowSpanCount: 0,
      editorContentChange: false,
      submissionDate: '',
      menu: false,
      livedate_menu: false,
      liveDate: '',
      deliverableNotes: '',
      invoiceRemarks: '',
      snackbar: false,
      snackbarTimeout: 2000,
      snackbarText: '',
      showFollowUpModal: false,
      chkGST: false,
      chkSpecialPaymentTerms: false,
      currentPayout: 0,
      totalPayout: 0,
      oldPayoutDetails: [],
      emailTemplateHTML: '',
      emailTemplateView: {
        influencer_name: '',
        submission_date: '',
        live_date: '',
        co_email: ''
      },
      briefSaveStatusId: 1,
      selectedUser: '',
      influencerEmail: '',
      contractFile: '',
      defaultMsg: 'Server Error',
      tabShow: false,
      editorOpened: false,
      loader: null,
      loading: false,
      downloadloading: false,
      currencies: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].currencies,
      currency: 'SGD',
      briefDetailContentNew: ''
    };
  },

  watch: {
    watchInfluencer: function watchInfluencer(val, oval) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var emailTemplate, html, vm, updatedSubmission;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.briefDetailContentNew = _this.briefDetailContent;
                _this.close();
                _this.submissionDate = '';
                _this.liveDate = '';
                _this.chkGST = false;
                _this.editorOpened = true;
                _this.showAmountRowSpan = '';
                _this.currency = 'SGD';
                _this.contentChangeFalse();
                if (val.pairing_details.submission_date) {
                  _this.submissionDate = new Date(val.pairing_details.submission_date).toISOString().substr(0, 10);
                }

                if (val.pairing_details.live_date) {
                  _this.liveDate = new Date(val.pairing_details.live_date).toISOString().substr(0, 10);
                }
                _this.chkGST = val.pairing_details.GST;
                _this.chkSpecialPaymentTerms = val.pairing_details.SpecialPaymentTerms;
                _this.deliverableNotes = val.pairing_details.deliverable_notes || '';
                _this.invoiceRemarks = val.pairing_details.remarks || '';
                _this.currentPayout = val.payout;
                _this.totalPayout = val.payout;

                _this.oldPayoutDetails = {};
                if (val.payout_details) {
                  _this.currency = val.payout_details.currency || 'SGD';
                  if (!Array.isArray(val.payout_details.boostingFees)) {
                    _this.$set(val.payout_details, 'boostingFees', []);
                  }
                  _this.oldPayoutDetails = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(val.payout_details)));
                }

                emailTemplate = '<p>Hello <b>{{influencer_name}}</b>,</p>\nStoked to have you on board for this campaign Charmaine! We have scheduled delivery to your mailing address tomorrow.<br/><p>Date of Submission: <b>{{submission_date}}</b></p><br/><p>You will find 2 documents attached below:\nInvoice\nCampaign Brief Document</p><br/><p>It is important to read through the campaign brief before executing your campaign, do ensure you take backup photos to avoid any possible reshoots or revisions to save you time and effort.</p><br/><p>Do you have any questions about the campaign brief or the submission date?\nYou can reach me at <b>{{co_email}}</b> for any urgent matters, Looking forward to your seeing your content!</p><br/>Cheers';

                _this.emailTemplateView.influencer_name = val.influencer_details.fullname;
                _this.emailTemplateView.submission_date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this.submissionDate).format('DD/MM/yyyy');

                _this.emailTemplateView.co_email = _this.currentUser.email;
                html = __WEBPACK_IMPORTED_MODULE_23_mustache___default.a.render(emailTemplate, _this.emailTemplateView);

                _this.emailTemplateHTML = html;
                vm = _this;

                if (_this.selectedTab === 2) {
                  setTimeout(function () {
                    vm.close();
                    vm.approvedClick();
                    setTimeout(function () {
                      __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__["fonts"] = {
                        Arial: {
                          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
                        }
                      };
                    }, 1000);
                  }, 100);
                }

                if (!_this.isDownload) {
                  _context.next = 33;
                  break;
                }

                _this.close();
                _context.next = 31;
                return _this.updateSubmission(false);

              case 31:
                updatedSubmission = _context.sent;

                if (updatedSubmission) _this.updateSend();

              case 33:
                if (!_this.isGetInvoice) {
                  _context.next = 39;
                  break;
                }

                _this.close();
                _context.next = 37;
                return _this.getInvoiceContract();

              case 37:
                if (!_context.sent) {
                  _context.next = 39;
                  break;
                }

                _this.$emit('generatedInvoice', _this.contractFile);

              case 39:
                setTimeout(function () {
                  vm.tabShow = true;
                }, 500);

              case 40:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loader: function loader() {
      var l = this.loader;
      this[l] = !this[l];
      this.loader = null;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    currentUser: function currentUser() {
      return this.$store.state.user;
    },
    currentInfluencerEmail: function currentInfluencerEmail() {
      if (this.influencer) {
        return this.influencer.influencer_details.contact_details ? this.influencer.influencer_details.contact_details.email : '';
      }
    },
    currentUserFullName: function currentUserFullName() {
      return this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName;
    },

    profilePicture: function profilePicture() {
      return this.influencerProfile.profilePicture ? this.influencerProfile.profilePicture : '/static/img/avatar/user.png';
    },
    fullName: function fullName() {
      if (this.influencer.influencer_details) {
        return this.influencer.influencer_details.fullname;
      } else return null;
    },
    numberOfTikTokPost: function numberOfTikTokPost() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_tiktok_posts;
      } else return null;
    },
    numberOfXHSPost: function numberOfXHSPost() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_xhs_posts;
      } else return null;
    },
    numberOfPost: function numberOfPost() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_posts;
      } else return null;
    },
    numberOfCarousels: function numberOfCarousels() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_carousels;
      } else return null;
    },
    numberOfStories: function numberOfStories() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_stories;
      } else return null;
    },
    numberOfVideo: function numberOfVideo() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_video;
      } else return null;
    },
    numberOfIGReels: function numberOfIGReels() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_reels;
      } else return null;
    },
    numberOfLinkedInPosts: function numberOfLinkedInPosts() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_li_posts;
      } else return null;
    },
    numberOfXPosts: function numberOfXPosts() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.no_of_x_posts;
      } else return null;
    },
    numberOfYoutube: function numberOfYoutube() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.youtube;
      } else return null;
    },
    isLoadingWhitelist: function isLoadingWhitelist() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.loading_whitelisting;
      } else return null;
    },
    isExclusivity: function isExclusivity() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.loading_whitelisting;
      } else return null;
    },
    numberOfPA: function numberOfPA() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.physical_attendance;
      } else return null;
    },
    numberOfOA: function numberOfOA() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.online_attendance;
      } else return null;
    },
    numberOfCustoms: function numberOfCustoms() {
      if (this.influencer.deliverables) {
        return this.influencer.deliverables.custom || [];
      } else return null;
    },
    GST: function GST() {
      if (this.influencer.pairing_details.GST) {
        return this.influencer.pairing_details.GST;
      }
    },
    campaignBackground: function campaignBackground() {
      if (this.influencer.campaign_brief_details) {
        if (this.influencer.campaign_brief_details.campaignBackground) {
          return this.influencer.campaign_brief_details.campaignBackground;
        }
      }
    },
    interestedStatus: function interestedStatus() {
      if (this.influencer.status === this.pairingStatus.INTERESTED.value) {
        return true;
      } else return false;
    },
    notInterestedStatus: function notInterestedStatus() {
      if (this.influencer.status === this.pairingStatus.NOT_INTERESTED.value) {
        return true;
      } else return false;
    },
    inquiryStatus: function inquiryStatus() {
      if (this.influencer.status === this.pairingStatus.INQUIRY.value) {
        return true;
      } else return false;
    },
    notAcceptedStatus: function notAcceptedStatus() {
      if (this.influencer.status === this.pairingStatus.NOT_ACCEPTED.value) {
        return true;
      } else return false;
    },
    acceptedStatus: function acceptedStatus() {
      if (this.influencer.status === this.pairingStatus.ACCEPTED.value) {
        return true;
      } else return false;
    },
    pendingStatus: function pendingStatus() {
      if (this.influencer.status === this.pairingStatus.INVITED.value) {
        return true;
      } else return false;
    },
    rejectReasons: function rejectReasons() {
      if (this.influencer.pairing_details.reject_reason) {
        return this.influencer.pairing_details.reject_reason;
      } else return null;
    },
    briefDetail: function briefDetail() {
      if (this.briefDetailContent === undefined) {
        return '';
      }
      return this.briefDetailContent;
    },
    getRowSpanCount: function getRowSpanCount() {
      this.rowSpanCount = 0;
      if (this.influencerContract.deliverables.no_of_carousels > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_igTv > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_tiktok_posts > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_xhs_posts > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_fb_posts > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_posts > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_stories > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_video > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_reels > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_li_posts > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.no_of_x_posts > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.youtube > 0) this.rowSpanCount++;
      if (this.influencerContract.deliverables.loading_whitelisting) this.rowSpanCount++;
      if (this.influencerContract.deliverables.exclusivity) this.rowSpanCount++;
      if (this.influencerContract.deliverables.physical_attendance) this.rowSpanCount++;
      if (this.influencerContract.deliverables.online_attendance) this.rowSpanCount++;
      if (this.influencerContract.deliverables.custom) this.rowSpanCount += this.influencerContract.deliverables.custom.length;

      return this.rowSpanCount;
    },
    watchInfluencer: function watchInfluencer() {
      return this.influencer;
    },
    submissionDateFormatted: function submissionDateFormatted() {
      return this.submissionDate ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.submissionDate).format('DD/MM/yyyy') : '';
    },
    liveDateFormatted: function liveDateFormatted() {
      return this.liveDate ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.liveDate).format('DD/MM/yyyy') : '';
    },
    filterContentItems: function filterContentItems() {
      if (this.influencer.contentAngles) {
        return this.influencer.contentAngles.slice(0, 1);
      } else return null;
    },
    chkPayoutGST: function chkPayoutGST() {
      var payout = this.influencerContract.payout;

      if (this.influencerContract.payout_details && this.influencerContract.payout_details.boostingFees && Array.isArray(this.influencerContract.payout_details.boostingFees)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.influencerContract.payout_details.boostingFees), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var boostingFee = _step.value;

            payout -= Number(boostingFee.value) || 0;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (this.influencerContract.GST) {
        return Number(payout - this.influencerContract.GSTpercent).toFixed(2);
      } else {
        return Number(payout).toFixed(2);
      }
    },
    modalMaxWidth: function modalMaxWidth() {
      if (this.newPairingFlow) {
        return this.selectedTab === 0 ? '700px' : '100%';
      }
      return '100%';
    },
    modalTitle: function modalTitle() {
      if (this.newPairingFlow) {
        return this.selectedTab === 0 ? 'Edit Invoice & Contract' : 'Edit Creators Brief';
      }
      return 'Influencer Details';
    },
    reportName: function reportName() {
      var reportName = '';
      reportName += this.influencer.CampaignName + '_';
      reportName += this.influencer.influencer_details ? this.influencer.influencer_details.userHandle + '_' : '';
      return reportName;
    }
  }),
  methods: {
    updateEmailTemplate: function updateEmailTemplate(template) {
      var strReplace = void 0;
      strReplace = template.toString().replace(/<p><br><\/p>/g, '');
      this.emailTemplateHTML = strReplace.toString().replace(/\n/g, '<br/>');
    },
    formatPayout: function formatPayout(n) {
      var currency = 'SGD';
      if (this.influencerContract) {
        currency = this.influencerContract.currency || 'SGD';
      }
      if (!n) return n;
      if (n.toString().indexOf('-') !== -1) {
        var str = n.toString().split('-');
        return currency + ' ' + parseFloat(str[0]) + ' - ' + str[1];
      } else {
        return currency + ' ' + parseFloat(n);
      }
    },
    getStatusColor: function getStatusColor(status) {
      if (status) {
        if (status === this.pairingStatus.INVITED.value) {
          return 'orange';
        } else if (status === this.pairingStatus.INTERESTED.value) {
          return '#81C784';
        } else if (status === this.pairingStatus.NOT_INTERESTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.ACCEPTED.value) {
          return '#66BB6A';
        } else if (status === this.pairingStatus.NOT_ACCEPTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.INQUIRY.value) {
          return '#1E88E5';
        } else return 'white';
      }
    },
    viewInvitation: function viewInvitation(campaign, influencer, type) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var invitation, contractDataObj, message;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                invitation = void 0;

                if (!(type === 'tiktok')) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getInvitationTikTok(campaign, influencer);

              case 5:
                invitation = _context2.sent;
                _context2.next = 35;
                break;

              case 8:
                if (!(type === 'youtube')) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getInvitationYoutube(campaign, influencer);

              case 11:
                invitation = _context2.sent;
                _context2.next = 35;
                break;

              case 14:
                if (!(type === 'facebook')) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 17;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getInvitationFacebook(campaign, influencer);

              case 17:
                invitation = _context2.sent;
                _context2.next = 35;
                break;

              case 20:
                if (!(type === 'xiaohongshu')) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 23;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getInvitationXHS(campaign, influencer);

              case 23:
                invitation = _context2.sent;
                _context2.next = 35;
                break;

              case 26:
                if (!(type === 'others')) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 29;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getInvitationOthers(campaign, influencer);

              case 29:
                invitation = _context2.sent;
                _context2.next = 35;
                break;

              case 32:
                _context2.next = 34;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getInvitationbyIGHandle(campaign, influencer);

              case 34:
                invitation = _context2.sent;

              case 35:
                contractDataObj = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, invitation);

                contractDataObj.campaignID = _this2.influencer.CampaignID;

                _this2.influencerContract = contractDataObj;
                _context2.next = 45;
                break;

              case 40:
                _context2.prev = 40;
                _context2.t0 = _context2['catch'](0);

                _this2.influencerContract.notInvoked = true;
                message = _context2.t0 ? _context2.t0.response.data || _this2.defaultMsg : _this2.defaultMsg;

                if (message.includes('not invoked')) {
                  _this2.$swal({
                    type: 'error',
                    text: 'Influencer Not Invited.'
                  });
                }

              case 45:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 40]]);
      }))();
    },
    generateContract: function generateContract() {
      var tableBody = [];
      var contractTemplate = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(__WEBPACK_IMPORTED_MODULE_9__Contract_Influencer_contract__["a" /* default */]);

      contractTemplate.header.text = 'Date: ' + this.dateFormat(Date.now());
      contractTemplate.defaultStyle = { font: 'Arial' };

      if (this.influencerContract.influencer_details.platform === 'tiktok') {
        contractTemplate.content[2].table.body[1][0].text = 'TikTok Handle: ' + this.influencerContract.influencer_details.userHandle;
      } else if (this.influencerContract.influencer_details.platform === 'instagram') {
        contractTemplate.content[2].table.body[1][0].text = 'Instagram Handle: ' + this.influencerContract.influencer_details.userHandle;
      } else if (this.influencerContract.influencer_details.platform === 'youtube') {
        contractTemplate.content[2].table.body[1][0].text = 'Youtube Handle: ' + this.influencerContract.influencer_details.userHandle;
      } else if (this.influencerContract.influencer_details.platform === 'facebook') {
        contractTemplate.content[2].table.body[1][0].text = 'Facebook Handle: ' + this.influencerContract.influencer_details.userHandle;
      } else if (this.influencerContract.influencer_details.platform === 'twitter') {
        contractTemplate.content[2].table.body[1][0].text = 'X (Twitter) Handle: ' + this.influencerContract.influencer_details.userHandle;
      } else if (this.influencerContract.influencer_details.platform === 'others') {
        contractTemplate.content[2].table.body[1][0].text = this.influencerContract.influencer_details.platformName + ' Handle: ' + this.influencerContract.influencer_details.userHandle;
      } else {
        contractTemplate.content[2].table.body[1][0].text = 'Platform Handle: ' + this.influencerContract.influencer_details.userHandle;
      }

      contractTemplate.content[4].table.body[1][0].text = this.influencerContract.brief.campaignName;

      contractTemplate.content[4].table.body[2][0].text = 'Campaign Ref: ' + this.influencerContract.campaignID;

      tableBody.push([{ text: 'DESCRIPTION', style: 'tableHeader', alignment: 'center' }, { text: 'QTY', style: 'tableHeader', alignment: 'center' }, { text: 'AMOUNT', style: 'tableHeader', alignment: 'center' }]);
      if (this.influencerContract.deliverables.no_of_stories) {
        tableBody.push(['IG Story', { text: this.influencerContract.deliverables.no_of_stories, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_stories') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_xhs_posts) {
        tableBody.push(['XHS Post', { text: this.influencerContract.deliverables.no_of_xhs_posts, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_xhs_posts') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_fb_posts) {
        tableBody.push(['FB Post', { text: this.influencerContract.deliverables.no_of_fb_posts, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_fb_posts') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_tiktok_posts) {
        tableBody.push(['TikTok Post', { text: this.influencerContract.deliverables.no_of_tiktok_posts, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_tiktok_posts') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_posts) {
        tableBody.push(['IG Post', { text: this.influencerContract.deliverables.no_of_posts, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_posts') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_carousels) {
        tableBody.push(['IG Carousel', { text: this.influencerContract.deliverables.no_of_carousels, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_carousels') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_video > 0) {
        tableBody.push(['IG Video', { text: this.influencerContract.deliverables.no_of_video, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_video') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_igTv > 0) {
        tableBody.push(['IG TV', { text: this.influencerContract.deliverables.no_of_igTv, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_igTv') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_reels > 0) {
        tableBody.push(['IG Reel', { text: this.influencerContract.deliverables.no_of_reels, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_reels') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_li_posts) {
        tableBody.push(['LinkedIn Post', { text: this.influencerContract.deliverables.no_of_li_posts, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_li_posts') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.no_of_x_posts) {
        tableBody.push(['X (Twitter) Post', { text: this.influencerContract.deliverables.no_of_x_posts, alignment: 'center' }, this.checkShowAmountRowSpan('no_of_x_posts') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.youtube > 0) {
        tableBody.push(['Youtube', { text: this.influencerContract.deliverables.youtube, alignment: 'center' }, this.checkShowAmountRowSpan('youtube') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.loading_whitelisting) {
        tableBody.push(['Loading/Whitelisting', { text: this.influencerContract.deliverables.loading_whitelisting, alignment: 'center' }, this.checkShowAmountRowSpan('loading_whitelisting') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.exclusivity) {
        tableBody.push(['Exclusivity', { text: this.influencerContract.deliverables.exclusivity, alignment: 'center' }, this.checkShowAmountRowSpan('exclusivity') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.physical_attendance > 0) {
        tableBody.push(['Physical Attendance', { text: this.influencerContract.deliverables.physical_attendance, alignment: 'center' }, this.checkShowAmountRowSpan('physical_attendance') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.online_attendance > 0) {
        tableBody.push(['Online Attendance', { text: this.influencerContract.deliverables.online_attendance, alignment: 'center' }, this.checkShowAmountRowSpan('online_attendance') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
      }
      if (this.influencerContract.deliverables.custom && this.influencerContract.deliverables.custom.length > 0) {
        var customDeliverables = this.influencerContract.deliverables.custom;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(customDeliverables.entries()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref = _step2.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var index = _ref2[0];
            var obj = _ref2[1];

            console.log(index);
            tableBody.push([obj.label, { text: obj.value, alignment: 'center' }, this.checkShowAmountRowSpan('custom') ? { rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      if (this.influencerContract.payout_details && this.influencerContract.payout_details.boostingFees && this.influencerContract.payout_details.boostingFees.length > 0) {
        var boostingFees = this.influencerContract.payout_details.boostingFees;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(boostingFees.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _ref3 = _step3.value;

            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

            var _index = _ref4[0];
            var boostingFee = _ref4[1];

            console.log(_index);
            tableBody.push([{ colSpan: 2, text: boostingFee.label }, '', { text: this.formatPayout(boostingFee.value), alignment: 'center' }]);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      if (this.influencerContract.GST) {
        tableBody.push(['GST', { text: 1, alignment: 'center' }, { rowSpan: 1, text: this.formatPayout(this.influencerContract.GSTpercent), alignment: 'center', margin: 10 }]);
      }
      if (this.influencerContract.deliverableNotes) {
        tableBody.push([{ colSpan: 3, text: this.influencerContract.deliverableNotes, alignment: 'left' }]);
      }
      tableBody.push([{ border: [false, true, false, false], text: '' }, { fillColor: '#3F3FFF', color: 'white', colSpan: 2, rowSpan: 1, text: 'TOTAL: ' + this.formatPayout(this.influencerContract.payout || 0), alignment: 'center' }]);
      contractTemplate.content[5].table.body = tableBody;
      if (this.influencerContract.invoiceRemarks) {
        contractTemplate.content.splice(6, 0, {
          margin: [0, 20, 0, 0],
          table: {
            widths: ['100%'],
            body: [[{ text: 'Remarks', style: 'tableHeader', alignment: 'left' }], [{ text: this.influencerContract.invoiceRemarks, border: [true, true, true, true] }]]
          }
        });
      }
      return contractTemplate;
    },
    saveContractInvoice: function saveContractInvoice() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var briefPdfData, data, pdfDocGenerator, coInfo, formData, htmlToPdf;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$emit('loadingDialogOpen');

                if (_this3.influencerEmail) {
                  if (_this3.influencer.influencer_details.contact_details.email === undefined || !_this3.influencer.influencer_details.contact_details.email) {
                    _this3.influencer.influencer_details.contact_details.email = _this3.influencerEmail;
                  }
                }
                briefPdfData = null;
                data = {
                  pairingID: _this3.influencer.id,
                  userID: _this3.currentUser.id,
                  content_contract: _this3.generateContract(),
                  email_content: _this3.emailTemplateHTML
                };
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].addContracts(data);

              case 6:
                _this3.briefDetailSave(false);
                _context3.next = 9;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].doAction(_this3.influencer.id, 'accepted');

              case 9:
                pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__["createPdf"](data.content_contract);
                _context3.next = 12;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  pdfDocGenerator.getDataUrl(function (dataUrl) {
                    var response = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.dataURLtoFile(dataUrl, 'invoice_contract.pdf');
                    resolve(response);
                  });
                });

              case 12:
                _this3.contractFile = _context3.sent;
                coInfo = {
                  'co_email': _this3.selectedUser.email,
                  'co_name': _this3.selectedUser.firstName + ' ' + _this3.selectedUser.lastName
                };
                formData = new FormData();

                formData.append('pairedID', _this3.influencer.id);
                formData.append('template', __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].sendGridTemplateIds.co_approve_influencer_for_campaign);
                formData.append('subject', 'Next steps for ' + _this3.influencer.CampaignName + ' Campaign!');
                formData.append('influencer', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(_this3.influencer.influencer_details));
                formData.append('campaign_name', _this3.influencer.CampaignName);
                formData.append('co', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(coInfo));
                formData.append('emailBody', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(_this3.emailTemplateHTML));
                formData.append('submission_date', __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this3.submissionDate).format('DD/MM/yyyy'));
                formData.append('live_date', __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this3.liveDate).format('DD/MM/yyyy'));

                if (!_this3.isDownload) {
                  _context3.next = 29;
                  break;
                }

                formData.append('updateSend', 1);
                if (_this3.isFinalPayout) {
                  formData.append('finalPayout', 1);
                }
                _context3.next = 34;
                break;

              case 29:
                htmlToPdf = new __WEBPACK_IMPORTED_MODULE_20__editor_generator_HTMLToPDF__["a" /* default */](_this3.briefDetailContent, 'Arial');
                _context3.next = 32;
                return htmlToPdf.generate();

              case 32:
                briefPdfData = _context3.sent;

                formData.append('brifeDetail', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(briefPdfData));

              case 34:
                formData.append('contractFile', _this3.contractFile);
                _context3.next = 37;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].sendContractToInfluencer(formData);

              case 37:
                _this3.$emit('loadInfluencer');
                _this3.close();

              case 39:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    approvedClick: function approvedClick() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var vm;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.influencer.influencer_details.platform && _this4.influencer.influencer_details.platform === 'tiktok')) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return _this4.viewInvitation(_this4.influencer.CampaignID, _this4.influencer.influencer_details.userHandle, 'tiktok');

              case 3:
                _context4.next = 22;
                break;

              case 5:
                if (!(_this4.influencer.influencer_details.platform && _this4.influencer.influencer_details.platform === 'youtube')) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 8;
                return _this4.viewInvitation(_this4.influencer.CampaignID, _this4.influencer.influencer_details.userHandle, 'youtube');

              case 8:
                _context4.next = 22;
                break;

              case 10:
                if (!(_this4.influencer.influencer_details.platform && _this4.influencer.influencer_details.platform === 'xiaohongshu')) {
                  _context4.next = 15;
                  break;
                }

                _context4.next = 13;
                return _this4.viewInvitation(_this4.influencer.CampaignID, _this4.influencer.influencer_details.userHandle, 'xiaohongshu');

              case 13:
                _context4.next = 22;
                break;

              case 15:
                if (!(_this4.influencer.influencer_details.platform && _this4.influencer.influencer_details.platform === 'others')) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 18;
                return _this4.viewInvitation(_this4.influencer.CampaignID, _this4.influencer.influencer_details.userHandle, 'others');

              case 18:
                _context4.next = 22;
                break;

              case 20:
                _context4.next = 22;
                return _this4.viewInvitation(_this4.influencer.CampaignID, _this4.influencer.influencer_details.userHandle, 'instagram');

              case 22:
                if (!_this4.influencerContract.notInvoked) {
                  _context4.next = 24;
                  break;
                }

                return _context4.abrupt('return', false);

              case 24:
                if (_this4.influencerContract.submission_date) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 27;
                return _this4.checkSubmissionLiveDate('Submission', 'Please, Save the submission date before accepted.');

              case 27:
                return _context4.abrupt('return', false);

              case 28:
                if (_this4.checkDeliverables()) {
                  _context4.next = 30;
                  break;
                }

                return _context4.abrupt('return', false);

              case 30:
                vm = _this4;

                _this4.selectedTab = 1;
                setTimeout(function () {
                  vm.briefSaveStatusId++;
                  vm.selectedTab = 0;
                }, 1000);

                if (_this4.influencer.Users) {
                  _this4.selectedUser = _this4.influencer.Users.length > 0 ? _this4.influencer.Users[0] : '';
                }
                _this4.invoiceContract = _this4.generateContract();
                _this4.showContractModal = true;

              case 36:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    upatedApproved: function upatedApproved() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (email) {
        this.influencerEmail = email;
      }

      this.saveContractInvoice();
    },
    notAccepted: function notAccepted() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var confirmed, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.$emit('loadingDialogOpen');

                if (_this5.influencer.influencer_details.influencerID) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return _this5.checkInfluencer();

              case 4:
                return _context5.abrupt('return', false);

              case 5:
                _context5.next = 7;
                return _this5.rejectionBox();

              case 7:
                confirmed = _context5.sent;

                if (confirmed) {
                  _context5.next = 11;
                  break;
                }

                _this5.$emit('loadingDialogClose');return _context5.abrupt('return');

              case 11:
                data = {
                  'pairedID': _this5.influencer.id,
                  'template': __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].sendGridTemplateIds.co_reject_influencer_for_campaign,

                  'subject': 'Sorry, we can\'t work together this time..',
                  'influencer_name': _this5.influencer.influencer_details.fullname ? _this5.influencer.influencer_details.fullname : _this5.influencer.userHandle,
                  'campaign_name': _this5.influencer.CampaignName,
                  'status': _this5.pairingStatus.NOT_ACCEPTED.value,
                  'email': _this5.influencer.influencer_details.contact_details.email,
                  'co': {
                    'co_email': _this5.currentUser.email,
                    'co_name': _this5.currentUser.firstName + ' ' + _this5.currentUser.lastName
                  }
                };
                _context5.next = 14;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].updateStatusEmail(data);

              case 14:
                _this5.$emit('loadInfluencer');

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    rejectionBox: function rejectionBox() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.$swal({
                  title: 'Please confirm',
                  text: 'Are you sure to reject this influencer?',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, Reject.'
                });

              case 2:
                result = _context6.sent;
                return _context6.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    approveBox: function approveBox() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.$swal({
                  title: 'Please confirm',
                  html: '<p>Would you like to see a preview of an influencer contract before you approve?</p>',
                  type: 'question',
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#66BB6A',
                  confirmButtonText: 'Yes, Show me a preview',
                  cancelButtonText: 'No, Approve & Send'
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt('return', result);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    checkInfluencer: function checkInfluencer() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this8.$swal({
                  title: 'Not Registered',
                  text: 'This influencer is not resgistered in IMS.',
                  type: 'warning',
                  confirmButtonText: 'Ok'
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt('return', result);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    checkSubmissionLiveDate: function checkSubmissionLiveDate(title, text) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this9.$swal({
                  title: title,
                  text: text,
                  type: 'warning',
                  confirmButtonText: 'Ok'
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt('return', result);

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    checkEditorContentSaved: function checkEditorContentSaved() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this10.$swal({
                  title: 'Brief Detail',
                  text: 'Your brief detail is not saved.!',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonColor: '#d33'
                });

              case 2:
                result = _context10.sent;
                return _context10.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    closeInfluencerContractModal: function closeInfluencerContractModal() {
      this.showContractModal = false;
    },
    reloadDataTable: function reloadDataTable() {
      this.$emit('reRenderDatTable');
    },
    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('DD/MM/yyyy');
    },
    contentChangeTrue: function contentChangeTrue() {
      this.editorContentChange = true;
    },
    contentChangeFalse: function contentChangeFalse() {
      this.editorContentChange = false;
    },
    generateEmailTempate: function generateEmailTempate() {
      var emailTemplate = '<p>Hello <b>{{influencer_name}}</b>,</p>\nStoked to have you on board for this campaign! <br/><p>Your Date of Submission: <b>{{submission_date}}</b></p><br/><p>It is important to read through the campaign brief before executing your campaign, do ensure you take backup photos to avoid any possible reshoots or revisions to save you time and effort.</p><p>You will find 3 documents attached below:\nInvoice\nCampaign Brief Document\nPlatform Guide on Onboarding <a href="https://drive.google.com/file/d/1w51Oaa_UZt7jTWmgJC-biPuT8dTN7IET/view?usp=sharing">here</a></p><br/><br/><p>Do you have any questions about the campaign brief or the submission date?\nYou can reach me at <b>{{co_email}}</b> for any urgent matters, Looking forward to your seeing your content!</p><br/>Cheers';
      this.emailTemplateView.influencer_name = this.influencer.influencer_details.fullname;
      this.emailTemplateView.submission_date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.submissionDate).format('DD/MM/yyyy');

      this.emailTemplateView.co_email = this.currentUser.email;
      var html = __WEBPACK_IMPORTED_MODULE_23_mustache___default.a.render(emailTemplate, this.emailTemplateView);
      this.emailTemplateHTML = html;
    },
    closeModel: function closeModel() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var checked;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!_this11.editorContentChange) {
                  _context11.next = 6;
                  break;
                }

                _context11.next = 3;
                return _this11.checkEditorContentSaved();

              case 3:
                checked = _context11.sent;

                if (checked) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt('return', false);

              case 6:
                _this11.reloadDataTable();
                _this11.close();
                _this11.tabShow = false;

              case 9:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    updateSubmission: function updateSubmission() {
      var _this12 = this;

      var successMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, boostingFee, deliverablesDetails, payoutDetails, pdfDocGenerator, formData, params, res;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (_this12.submissionDate) {
                  _context12.next = 3;
                  break;
                }

                _this12.$swal({
                  type: 'error',
                  text: 'Please Select Submission Date.'
                });
                return _context12.abrupt('return', false);

              case 3:
                if (!(_this12.influencer.payout_details && _this12.influencer.payout_details.boostingFees && Array.isArray(_this12.influencer.payout_details.boostingFees))) {
                  _context12.next = 31;
                  break;
                }

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context12.prev = 7;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this12.influencer.payout_details.boostingFees);

              case 9:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context12.next = 17;
                  break;
                }

                boostingFee = _step4.value;

                if (!(!boostingFee.label || boostingFee.label.trim() === '')) {
                  _context12.next = 14;
                  break;
                }

                _this12.$swal({
                  type: 'warning',
                  text: 'Please enter additional line item description'
                });
                return _context12.abrupt('return', false);

              case 14:
                _iteratorNormalCompletion4 = true;
                _context12.next = 9;
                break;

              case 17:
                _context12.next = 23;
                break;

              case 19:
                _context12.prev = 19;
                _context12.t0 = _context12['catch'](7);
                _didIteratorError4 = true;
                _iteratorError4 = _context12.t0;

              case 23:
                _context12.prev = 23;
                _context12.prev = 24;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 26:
                _context12.prev = 26;

                if (!_didIteratorError4) {
                  _context12.next = 29;
                  break;
                }

                throw _iteratorError4;

              case 29:
                return _context12.finish(26);

              case 30:
                return _context12.finish(23);

              case 31:
                if (!(_this12.influencer.influencer_details.platform && _this12.influencer.influencer_details.platform === 'tiktok')) {
                  _context12.next = 36;
                  break;
                }

                _context12.next = 34;
                return _this12.viewInvitation(_this12.influencer.CampaignID, _this12.influencer.influencer_details.userHandle, 'tiktok');

              case 34:
                _context12.next = 58;
                break;

              case 36:
                if (!(_this12.influencer.influencer_details.platform && _this12.influencer.influencer_details.platform === 'youtube')) {
                  _context12.next = 41;
                  break;
                }

                _context12.next = 39;
                return _this12.viewInvitation(_this12.influencer.CampaignID, _this12.influencer.influencer_details.userHandle, 'youtube');

              case 39:
                _context12.next = 58;
                break;

              case 41:
                if (!(_this12.influencer.influencer_details.platform && _this12.influencer.influencer_details.platform === 'xiaohongshu')) {
                  _context12.next = 46;
                  break;
                }

                _context12.next = 44;
                return _this12.viewInvitation(_this12.influencer.CampaignID, _this12.influencer.influencer_details.userHandle, 'xiaohongshu');

              case 44:
                _context12.next = 58;
                break;

              case 46:
                if (!(_this12.influencer.influencer_details.platform && _this12.influencer.influencer_details.platform === 'facebook')) {
                  _context12.next = 51;
                  break;
                }

                _context12.next = 49;
                return _this12.viewInvitation(_this12.influencer.CampaignID, _this12.influencer.influencer_details.userHandle, 'facebook');

              case 49:
                _context12.next = 58;
                break;

              case 51:
                if (!(_this12.influencer.influencer_details.platform && _this12.influencer.influencer_details.platform === 'others')) {
                  _context12.next = 56;
                  break;
                }

                _context12.next = 54;
                return _this12.viewInvitation(_this12.influencer.CampaignID, _this12.influencer.influencer_details.userHandle, 'others');

              case 54:
                _context12.next = 58;
                break;

              case 56:
                _context12.next = 58;
                return _this12.viewInvitation(_this12.influencer.CampaignID, _this12.influencer.influencer_details.userHandle, 'instagram');

              case 58:
                if (_this12.influencer.payout_details) {
                  if (_this12.influencer.payout_details.amount) {
                    _this12.influencer.payout_details.amount = Number(_this12.totalPayout);
                  }
                }
                deliverablesDetails = _this12.getDeliverablesForSave(_this12.influencerContract.deliverables);
                payoutDetails = _this12.getPayoutDetailsForSave(_this12.influencerContract.payout_details);

                _this12.syncEditedInvoiceToContract(deliverablesDetails, payoutDetails);
                _this12.invoiceContract = _this12.generateContract();
                pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__["createPdf"](_this12.invoiceContract);
                _context12.next = 66;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  pdfDocGenerator.getDataUrl(function (dataUrl) {
                    var response = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.dataURLtoFile(dataUrl, 'invoice_contract.pdf');
                    resolve(response);
                  });
                });

              case 66:
                _this12.contractFile = _context12.sent;
                formData = new FormData();

                formData.append('pairingID', _this12.influencer.id);
                formData.append('submissionDate', __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this12.submissionDate).format('YYYY-MM-DD'));
                formData.append('liveDate', new Date(_this12.liveDate));
                formData.append('GST', _this12.chkGST);
                formData.append('SpecialPaymentTerms', _this12.chkSpecialPaymentTerms);
                formData.append('deliverableNotes', _this12.deliverableNotes);
                formData.append('invoiceRemarks', _this12.invoiceRemarks);
                formData.append('contractFile', _this12.contractFile);
                formData.append('deliverablesDetails', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(deliverablesDetails));
                formData.append('payoutDetails', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payoutDetails));
                _context12.next = 80;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].updateSubmissionAndLiveDates(formData);

              case 80:
                params = {
                  pairingID: _this12.influencer.id,
                  submissionDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this12.submissionDate).format('YYYY-MM-DD'),
                  liveDate: new Date(_this12.liveDate),
                  GST: _this12.chkGST,
                  SpecialPaymentTerms: _this12.chkSpecialPaymentTerms,
                  deliverableNotes: _this12.deliverableNotes,
                  invoiceRemarks: _this12.invoiceRemarks,
                  currency: _this12.currency,
                  payoutDetails: payoutDetails
                };
                _context12.next = 83;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].updateGSTamount(params);

              case 83:
                res = _context12.sent;

                if (res.status === 200) {
                  _this12.$set(_this12.influencer, 'payout_details', __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(payoutDetails));
                  _this12.totalPayout = Number(payoutDetails.amount || 0);
                  _this12.currentPayout = _this12.totalPayout;
                  _this12.influencer.payout = _this12.totalPayout;
                  _this12.oldPayoutDetails = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(payoutDetails)));
                  _this12.generateEmailTempate();
                  if (successMsg) {
                    _this12.snackbarText = 'Successfully, Saved!';
                    _this12.snackbar = true;
                  }
                  _this12.$emit('reRenderDatTable');
                }
                return _context12.abrupt('return', true);

              case 86:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12, [[7, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    updateSend: function updateSend() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this13.downloadloading = true;

                if (!(_this13.influencer.influencer_details.platform && _this13.influencer.influencer_details.platform === 'tiktok')) {
                  _context13.next = 6;
                  break;
                }

                _context13.next = 4;
                return _this13.viewInvitation(_this13.influencer.CampaignID, _this13.influencer.influencer_details.userHandle, 'tiktok');

              case 4:
                _context13.next = 28;
                break;

              case 6:
                if (!(_this13.influencer.influencer_details.platform && _this13.influencer.influencer_details.platform === 'youtube')) {
                  _context13.next = 11;
                  break;
                }

                _context13.next = 9;
                return _this13.viewInvitation(_this13.influencer.CampaignID, _this13.influencer.influencer_details.userHandle, 'youtube');

              case 9:
                _context13.next = 28;
                break;

              case 11:
                if (!(_this13.influencer.influencer_details.platform && _this13.influencer.influencer_details.platform === 'xiaohongshu')) {
                  _context13.next = 16;
                  break;
                }

                _context13.next = 14;
                return _this13.viewInvitation(_this13.influencer.CampaignID, _this13.influencer.influencer_details.userHandle, 'xiaohongshu');

              case 14:
                _context13.next = 28;
                break;

              case 16:
                if (!(_this13.influencer.influencer_details.platform && _this13.influencer.influencer_details.platform === 'facebook')) {
                  _context13.next = 21;
                  break;
                }

                _context13.next = 19;
                return _this13.viewInvitation(_this13.influencer.CampaignID, _this13.influencer.influencer_details.userHandle, 'facebook');

              case 19:
                _context13.next = 28;
                break;

              case 21:
                if (!(_this13.influencer.influencer_details.platform && _this13.influencer.influencer_details.platform === 'others')) {
                  _context13.next = 26;
                  break;
                }

                _context13.next = 24;
                return _this13.viewInvitation(_this13.influencer.CampaignID, _this13.influencer.influencer_details.userHandle, 'others');

              case 24:
                _context13.next = 28;
                break;

              case 26:
                _context13.next = 28;
                return _this13.viewInvitation(_this13.influencer.CampaignID, _this13.influencer.influencer_details.userHandle, 'instagram');

              case 28:
                if (_this13.checkDeliverables()) {
                  _context13.next = 30;
                  break;
                }

                return _context13.abrupt('return', false);

              case 30:
                _this13.invoiceContract = _this13.generateContract();

                if (_this13.invoiceContract) {
                  _context13.next = 33;
                  break;
                }

                return _context13.abrupt('return', false);

              case 33:
                _this13.saveContractInvoice();

              case 34:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    getInvoiceContract: function getInvoiceContract() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var pdfDocGenerator;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(_this14.influencer.influencer_details.platform && _this14.influencer.influencer_details.platform === 'tiktok')) {
                  _context14.next = 5;
                  break;
                }

                _context14.next = 3;
                return _this14.viewInvitation(_this14.influencer.CampaignID, _this14.influencer.influencer_details.userHandle, 'tiktok');

              case 3:
                _context14.next = 27;
                break;

              case 5:
                if (!(_this14.influencer.influencer_details.platform && _this14.influencer.influencer_details.platform === 'youtube')) {
                  _context14.next = 10;
                  break;
                }

                _context14.next = 8;
                return _this14.viewInvitation(_this14.influencer.CampaignID, _this14.influencer.influencer_details.userHandle, 'youtube');

              case 8:
                _context14.next = 27;
                break;

              case 10:
                if (!(_this14.influencer.influencer_details.platform && _this14.influencer.influencer_details.platform === 'xiaohongshu')) {
                  _context14.next = 15;
                  break;
                }

                _context14.next = 13;
                return _this14.viewInvitation(_this14.influencer.CampaignID, _this14.influencer.influencer_details.userHandle, 'xiaohongshu');

              case 13:
                _context14.next = 27;
                break;

              case 15:
                if (!(_this14.influencer.influencer_details.platform && _this14.influencer.influencer_details.platform === 'facebook')) {
                  _context14.next = 20;
                  break;
                }

                _context14.next = 18;
                return _this14.viewInvitation(_this14.influencer.CampaignID, _this14.influencer.influencer_details.userHandle, 'facebook');

              case 18:
                _context14.next = 27;
                break;

              case 20:
                if (!(_this14.influencer.influencer_details.platform && _this14.influencer.influencer_details.platform === 'others')) {
                  _context14.next = 25;
                  break;
                }

                _context14.next = 23;
                return _this14.viewInvitation(_this14.influencer.CampaignID, _this14.influencer.influencer_details.userHandle, 'others');

              case 23:
                _context14.next = 27;
                break;

              case 25:
                _context14.next = 27;
                return _this14.viewInvitation(_this14.influencer.CampaignID, _this14.influencer.influencer_details.userHandle, 'instagram');

              case 27:
                if (_this14.checkDeliverables()) {
                  _context14.next = 29;
                  break;
                }

                return _context14.abrupt('return', false);

              case 29:
                _this14.invoiceContract = _this14.generateContract();
                pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__["createPdf"](_this14.invoiceContract);
                _context14.next = 33;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  pdfDocGenerator.getDataUrl(function (dataUrl) {
                    var response = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.dataURLtoFile(dataUrl, 'invoice_contract.pdf');
                    resolve(response);
                  });
                });

              case 33:
                _this14.contractFile = _context14.sent;
                return _context14.abrupt('return', true);

              case 35:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this14);
      }))();
    },
    followUp: function followUp() {
      this.showFollowUpModal = true;
    },
    followUpClose: function followUpClose() {
      this.showFollowUpModal = false;
    },
    checkDeliverables: function checkDeliverables() {
      if (this.influencerContract.deliverables === undefined) {
        this.$swal({
          type: 'error',
          text: 'Please submit deliverables to generate invoice.'
        });
        return false;
      }
      return true;
    },
    download: function download() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var htmlToPdf, pdfData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this15.loader = 'loading';
                htmlToPdf = new __WEBPACK_IMPORTED_MODULE_20__editor_generator_HTMLToPDF__["a" /* default */](_this15.briefDetailContent, 'Arial');
                _context15.next = 4;
                return htmlToPdf.generate();

              case 4:
                pdfData = _context15.sent;

                __WEBPACK_IMPORTED_MODULE_24_pdfmake_build_pdfmake_js__["createPdf"](pdfData).download(_this15.reportName + 'brief.pdf');

                _this15.loading = false;
                _this15.loader = null;

              case 8:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this15);
      }))();
    },
    briefDetailSave: function briefDetailSave() {
      var _this16 = this;

      var isSnackBar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var data = {
        pairingID: this.influencer.id,
        userID: this.currentUser.id,
        contentHTML: this.briefDetailContentNew
      };
      __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].updatePairingBriefDetails(data).then(function () {
        _this16.contentChangeFalse();
      });
      if (isSnackBar) {
        this.snackbarText = 'Successfully, Saved!';
        this.snackbar = true;
      }
    },
    changeBriefContent: function changeBriefContent(content) {
      this.briefDetailContent = content;
      this.briefDetailContentNew = content;
      this.editorOpened = false;
      this.contentChangeTrue();
    },
    changeEditorOpen: function changeEditorOpen() {
      this.editorOpened = false;
    },
    focusBriefContent: function focusBriefContent() {
      this.changeEditorOpen();
      this.contentChangeTrue();
    },
    loadingDialogOpen: function loadingDialogOpen() {
      this.$emit('loadingDialogOpen');
    },
    loadingDialogClose: function loadingDialogClose() {
      this.$emit('loadingDialogClose');
    },
    restoreCampaignBrief: function restoreCampaignBrief() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var blocks, blocksTohtml;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__campaignHelper__["a" /* default */].generateBlocks(_this17.influencer);

              case 2:
                blocks = _context16.sent;
                blocksTohtml = new __WEBPACK_IMPORTED_MODULE_21__editor_generator_blocksToHtml__["a" /* default */](blocks);

                _this17.briefDetailContent = blocksTohtml.generate(false);

              case 5:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this17);
      }))();
    },
    checkShowAmountRowSpan: function checkShowAmountRowSpan(type) {
      if (!this.showAmountRowSpan) {
        this.showAmountRowSpan = type;
        return true;
      } else if (this.showAmountRowSpan === type) return true;
      return false;
    },
    ensureDeliverables: function ensureDeliverables() {
      var defaultDeliverables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.influencer.deliverables) {
        this.$set(this.influencer, 'deliverables', __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(defaultDeliverables || {}));
      }
      if (!Array.isArray(this.influencer.deliverables.custom)) {
        this.$set(this.influencer.deliverables, 'custom', []);
      }
      return this.influencer.deliverables;
    },
    ensurePayoutDetails: function ensurePayoutDetails() {
      var defaultPayoutDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.influencer.payout_details) {
        this.$set(this.influencer, 'payout_details', __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(defaultPayoutDetails || {}));
      }
      if (!Array.isArray(this.influencer.payout_details.boostingFees)) {
        this.$set(this.influencer.payout_details, 'boostingFees', []);
      }
      return this.influencer.payout_details;
    },
    getDeliverablesForSave: function getDeliverablesForSave() {
      var defaultDeliverables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var deliverables = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(this.ensureDeliverables(defaultDeliverables));
      deliverables.custom = (deliverables.custom || []).filter(function (custom) {
        return custom && custom.label;
      });
      return deliverables;
    },
    getPayoutDetailsForSave: function getPayoutDetailsForSave() {
      var defaultPayoutDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var payoutDetails = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(this.ensurePayoutDetails(defaultPayoutDetails));
      payoutDetails.boostingFees = (payoutDetails.boostingFees || []).filter(function (boostingFee) {
        return boostingFee && boostingFee.label;
      });
      payoutDetails.currency = this.currency;
      return this.normalizePayoutDetailsForSave(payoutDetails);
    },
    parsePayoutAmount: function parsePayoutAmount(value) {
      var amount = Number(value);
      return isNaN(amount) ? 0 : amount;
    },
    getBoostingFeesTotal: function getBoostingFeesTotal(boostingFees) {
      var _this18 = this;

      if (!Array.isArray(boostingFees)) return 0;
      return boostingFees.reduce(function (total, boostingFee) {
        return total + _this18.parsePayoutAmount(boostingFee && boostingFee.value);
      }, 0);
    },
    getPayoutOriginAmount: function getPayoutOriginAmount() {
      var payoutDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (payoutDetails.originAmount !== undefined && payoutDetails.originAmount !== null && payoutDetails.originAmount !== '') {
        return this.parsePayoutAmount(payoutDetails.originAmount);
      }
      var existingFees = this.getBoostingFeesTotal(this.oldPayoutDetails.boostingFees);
      var existingGST = this.parsePayoutAmount(this.oldPayoutDetails.GSTpercent);

      var incomingFees = this.getBoostingFeesTotal(payoutDetails.boostingFees);
      if (incomingFees !== existingFees) {
        if (this.oldPayoutDetails.originAmount !== undefined && this.oldPayoutDetails.originAmount !== null && this.oldPayoutDetails.originAmount !== '') {
          return this.parsePayoutAmount(this.oldPayoutDetails.originAmount);
        }
        if (this.oldPayoutDetails.amount !== undefined && this.oldPayoutDetails.amount !== null && this.oldPayoutDetails.amount !== '') {
          return this.parsePayoutAmount(this.oldPayoutDetails.amount) - existingFees - existingGST;
        }
      }
      return this.parsePayoutAmount(this.currentPayout) - existingFees - existingGST;
    },
    normalizePayoutDetailsForSave: function normalizePayoutDetailsForSave() {
      var payoutDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var originAmount = this.getPayoutOriginAmount(payoutDetails);
      var subtotal = originAmount + this.getBoostingFeesTotal(payoutDetails.boostingFees);
      var GSTpercent = this.chkGST ? subtotal * 0.09 : 0;
      payoutDetails.originAmount = parseFloat(originAmount || 0).toFixed(2);
      payoutDetails.amount = parseFloat(subtotal + GSTpercent || 0).toFixed(2);
      payoutDetails.GSTpercent = GSTpercent > 0 ? parseFloat(GSTpercent).toFixed(2) : 0;
      return payoutDetails;
    },
    syncEditedInvoiceToContract: function syncEditedInvoiceToContract() {
      var deliverablesDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var payoutDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.influencerContract || this.influencerContract.notInvoked) {
        return;
      }
      if (this.influencer.deliverables || deliverablesDetails) {
        this.influencerContract.deliverables = deliverablesDetails || this.getDeliverablesForSave();
      }
      if (this.influencer.payout_details || payoutDetails) {
        this.influencerContract.payout_details = payoutDetails || this.getPayoutDetailsForSave();
      }
      this.influencerContract.GST = this.chkGST;
      this.influencerContract.SpecialPaymentTerms = this.chkSpecialPaymentTerms;
      this.influencerContract.deliverableNotes = this.deliverableNotes;
      this.influencerContract.invoiceRemarks = this.invoiceRemarks;
      this.influencerContract.currency = this.currency;
      if (payoutDetails && payoutDetails.amount !== undefined && payoutDetails.amount !== null && payoutDetails.amount !== '') {
        this.influencerContract.payout = Number(payoutDetails.amount);
        this.influencerContract.GSTpercent = payoutDetails.GSTpercent;
      } else if (this.totalPayout !== undefined && this.totalPayout !== null && this.totalPayout !== '') {
        this.influencerContract.payout = Number(this.totalPayout);
      }
    },
    addCustom: function addCustom() {
      this.ensureDeliverables().custom.push({
        label: '',
        value: ''
      });
    },
    addBoostingFee: function addBoostingFee() {
      this.ensurePayoutDetails().boostingFees.push({
        label: '',
        value: ''
      });
    },
    updateTotalPayoutWithBoostingFee: function updateTotalPayoutWithBoostingFee() {
      var payoutDetails = this.ensurePayoutDetails();
      var feeAmount = this.getBoostingFeesTotal(payoutDetails.boostingFees);
      var originAmount = this.getPayoutOriginAmount(payoutDetails);
      var GSTpercent = this.chkGST ? (originAmount + feeAmount) * 0.09 : 0;
      this.totalPayout = Number(parseFloat(originAmount + feeAmount + GSTpercent).toFixed(2));
    },
    deleteBoostingFees: function deleteBoostingFees(bIndex) {
      this.influencer.payout_details.boostingFees.splice(bIndex, 1);
      var vm = this;
      setTimeout(function () {
        vm.updateTotalPayoutWithBoostingFee(0);
      }, 500);
    }
  }
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerListModal',
  props: {
    result: Object,
    value1: Boolean,
    keyword: Array,
    influencers: Array },
  data: function data() {
    return {
      keysearch: '',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['relevancyScore'],
        sortDesc: [true]
      },
      selectedInfluencers: [],
      totalItems: 0,
      headers: [{
        text: 'Handle',
        sortable: false
      }, { text: 'Followers', sortable: true, value: 'totalFollowers' }, { text: 'Eng. Rate', sortable: true, value: 'engagementRate' }, { text: 'Aud. Cred', sortable: true, value: 'audienceCredibility' }, { text: 'Relevancy', sortable: true, value: 'relevancyScore' }, { text: 'Act.', sortable: false }],
      items: [],
      originalItems: []
    };
  },

  computed: {},
  watch: {
    result: function result(data) {
      this.totalItems = data.totalItems;
      this.originalItems = data.originalItems;
      this.paginate();
    },
    influencers: function influencers(value) {
      this.selectedInfluencers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], value);
    },
    pagination: function pagination() {
      this.paginate();
    },
    keyword: function keyword(value) {
      this.keysearch = value.join(', ');
    }
  },
  methods: {
    close: function close() {
      this.$emit('input1');
    },
    isSelected: function isSelected(igHandle) {
      var index = this.selectedInfluencers.findIndex(function (item) {
        return item === igHandle;
      });
      return index;
    },
    selectInfluencer: function selectInfluencer(influencer, i) {
      var index = this.isSelected(influencer.instagramHandle);
      if (index === -1) {
        this.selectedInfluencers.push(influencer.instagramHandle);
        this.items[i].isSelected = true;
        this.items.splice();
        this.$emit('select', influencer.instagramHandle);
      }
    },
    deselectInfluencer: function deselectInfluencer(influencer, i) {
      var index = this.isSelected(influencer.instagramHandle);
      this.selectedInfluencers.splice(index, 1);
      this.items[i].isSelected = false;
      this.items.splice();
      this.$emit('select', influencer.instagramHandle);
    },
    updateItems: function updateItems(influencers) {
      var _this = this;

      var displayItems = influencers.map(function (element) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: element._id }, {
          instagramHandle: element.instagram ? element.instagram.instagramHandle : null,
          instagramID: element.instagram ? element.instagram.instagramID : null,
          totalFollowers: element.instagram ? element.instagram.totalFollowers : 0,
          audience: element.audience || {},
          instagram: element.instagram || {},
          relevancyScore: element.relevancyScore ? Number(element.relevancyScore).toFixed(2) : 0,
          engagementRate: element.audience && element.audience.user_profile ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2) : 0,
          isSelected: _this.isSelected(element.instagram ? element.instagram.instagramHandle : '') !== -1,
          audienceCredibility: element.audience && element.audience.audience_followers && (element.audience.audience_followers.success || element.audience.audience_followers.data) ? Number(element.audience.audience_followers.data.audience_credibility * 100).toFixed(2) : 0
        });
      });
      this.items = displayItems;
    },
    paginate: function paginate() {
      var _pagination = this.pagination,
          page = _pagination.page,
          sortBy = _pagination.sortBy,
          sortDesc = _pagination.sortDesc,
          itemsPerPage = _pagination.itemsPerPage;

      if (sortBy.length === 1 && sortDesc.length === 1) {
        this.sort(sortBy[0], sortDesc[0]);
      }
      var items = this.originalItems.slice((page - 1) * itemsPerPage, itemsPerPage * page);
      this.updateItems(items);
    },
    sort: function sort(sortBy, descending) {
      var _this2 = this;

      var sortCriteria = '';
      switch (sortBy) {
        case 'totalFollowers':
          sortCriteria = 'instagram.totalFollowers';
          break;
        case 'engagementRate':
          sortCriteria = 'audience.user_profile.engagement_rate';
          break;
        case 'audienceCredibility':
          sortCriteria = 'audience.audience_followers.data.audience_credibility';
          break;
        case 'relevancyScore':
          sortCriteria = 'relevancyScore';
          break;
        default:
          sortCriteria = 'relevancyScore';
      }
      this.originalItems.sort(function (a, b) {
        var prev = _this2.getValueByPath(a, sortCriteria);
        var last = _this2.getValueByPath(b, sortCriteria);
        if (descending) {
          return last > prev ? 1 : last < prev ? -1 : 0;
        }
        return last > prev ? -1 : last > prev ? 1 : 0;
      });
    },
    getValueByPath: function getValueByPath(obj, path) {
      var val = obj;
      var paths = path.split('.');
      paths.forEach(function (p) {
        if (val) val = val[p];
      });
      return Number(val || 0);
    }
  }
});

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewInfluencerListModal__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewInfluencerListModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ViewInfluencerListModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerDataTable',
  props: ['refresh'],
  components: {
    ViewInfluencerListModal: __WEBPACK_IMPORTED_MODULE_4__ViewInfluencerListModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      headers: [{
        text: 'Name',
        value: 'name'
      }, {
        text: 'Action',
        value: 'action'
      }],
      filter: '',
      viewCreator: null,
      filteredItems: [],
      viewInfListDialog: false,
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    infLists: function infLists(state) {
      return state.pairing.infLists;
    },
    saved: function saved(state) {
      return state.pairing.saved;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getInfLists();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    openCreateModal: function openCreateModal() {
      this.viewCreator = null;
      this.viewInfListDialog = true;
    },
    reload: function reload() {
      this.getInfLists();
    },
    getInfLists: function getInfLists() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('pairing/getInfLists');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getDataToView: function getDataToView(item) {
      this.viewInfListDialog = true;
      this.viewCreator = item;
    },
    deleteInf: function deleteInf(item) {
      var _this3 = this;

      this.$swal({
        title: 'Confirm',
        text: 'Are you sure to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
          var payload;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!result.value) {
                    _context3.next = 6;
                    break;
                  }

                  _this3.isLoading = true;
                  payload = {
                    id: item.id
                  };
                  _context3.next = 5;
                  return _this3.$store.dispatch('pairing/deleteInfListData', payload);

                case 5:
                  if (_this3.saved) {
                    _this3.isLoading = false;
                    _this3.$swal({
                      title: 'Successfully Deleted!',
                      type: 'success'
                    });
                    _this3.reload();
                  }

                case 6:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerListModal__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerListModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__InfluencerListModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_KToast__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_KToast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_KToast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_FullScreenProgress__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_FullScreenProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_FullScreenProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_scoped_influencer_InfluencerSearchBox__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_scoped_influencer_InfluencerSearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_scoped_influencer_InfluencerSearchBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chartjs_Pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chartjs_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_chartjs_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_sortBy__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuex__ = __webpack_require__(12);







































var SearchTypeEnum = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze___default()({ KEYWORD: 'keyword', HANDLE: 'handle', BULKUPLOAD: 'bulkupload' });
var Steps = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze___default()({ FIND_INFLUENCERS: 1, REVIEW: 2, ELIMINATION: 3 });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPairingModal',
  props: {
    value: Boolean,
    creator: Object
  },
  components: {
    influencerList: __WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue___default.a,
    pairingInfluencersTable: __WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay___default.a,
    InfluencerListModal: __WEBPACK_IMPORTED_MODULE_19__InfluencerListModal___default.a,
    KInfluencerSearchBox: __WEBPACK_IMPORTED_MODULE_24__components_scoped_influencer_InfluencerSearchBox___default.a,
    KToast: __WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_KToast___default.a,
    FullScreenProgress: __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_FullScreenProgress___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_29_vuedraggable___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_30__components_chartjs_Pie___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_28__components_scoped_custom_SocialHandle___default.a
  },
  data: function data() {
    return {
      toast: {
        variant: '',
        content: '',
        header: ''
      },
      fromAI: {
        force: false,
        page: 0
      },
      loadingAI: false,
      bulkProgress: {
        loading: true,
        processing: 0,
        complete: 0
      },
      showEditDialog: false,
      reasonDialog: false,
      settingAIDialog: false,

      lockedPayout: false,
      reqApprovalDialog: false,
      editPayoutDialog: false,
      eliminationDialog: false,
      campaingDataForElimination: {},

      reqApprovalPairing: {},
      payoutEditPairing: {},
      reqAmt: '',
      reqReasons: '',
      eliminationReason: '',

      eliminationStatus: __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].eliminationStatus,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].payoutStatus,
      genders: ['Male', 'Female'],
      ageGroups: ['18-24', '25-34', '35-44', '13-17', '45-64', '65-'],
      actions: [{ name: 'Delete', color: 'red', method: 'delete', icon: 'delete' }, { name: 'Edit', color: 'primary', method: 'edit', icon: 'edit' }, { name: 'View', color: 'primary', method: 'view', icon: 'mdi-eye' }],
      headers: [{
        text: 'Influencer',
        align: 'center',
        sortable: false,
        value: 'userHandle',
        name: 'influencer'
      }, { text: 'Remark', sortable: true, value: 'remarks', align: 'center', name: 'remark' }, { text: 'Gender', sortable: false, value: 'gender', align: 'center', name: 'gender' }, { text: 'Age Group', sortable: false, value: 'age_group', align: 'center', name: 'ageGroup' }, { text: 'Aud. Age Group', sortable: false, value: 'aud_age_group', align: 'center', name: 'audAgeGroup' }, { text: 'Aud. Country', sortable: false, value: 'country', align: 'center', name: 'country' }, { text: 'Followers', align: 'center', sortable: false, value: 'followers', name: 'followers' }, { text: 'Follower Gender', sortable: false, value: 'genderPercentage', align: 'center', name: 'genderPercentage' }, { text: 'Audience Cred.', sortable: false, align: 'center', value: 'audience_credibility', name: 'audienceCred' }, { text: 'Avg. Likes', sortable: false, align: 'center', value: 'avg_likes', name: 'avgLikes' }, { text: 'Avg. Comments', sortable: false, align: 'center', value: 'avg_comments', name: 'avgComments' }, { text: 'Avg. Reels Plays (IG)', sortable: false, align: 'center', value: 'avg_reels_plays', name: 'avgReelsPlays' }, { text: 'Avg. Views (TT)', sortable: false, align: 'center', value: 'avg_views', name: 'avgViews' }, { text: 'Avg. Saves (TT)', sortable: false, align: 'center', value: 'avg_saves', name: 'avgSaves' }, { text: 'Avg. Shares (TT)', sortable: false, align: 'center', value: 'avg_shares', name: 'avgShares' }, { text: 'Median Engagement Rate', sortable: false, align: 'center', value: 'median_engagement_rate', name: 'medianEngagementRate' }, { text: 'Influencer interests', sortable: false, align: 'center', value: 'infInterests', name: 'infInterests' }, { text: 'Audience interests', sortable: false, align: 'center', value: 'audience_interests', name: 'interests' }, { text: 'Engagement', sortable: false, align: 'center', value: 'engagement_rate', name: 'engagement' }],
      json_fields: {
        'Handle': {
          callback: function callback(item) {
            if (item.platform === 'instagram') {
              return '<a href=\'http://instagram.com/' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'tiktok') {
              return '<a href=\'https://www.tiktok.com/@' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'youtube') {
              return '<a href=\'https://youtube.com/@' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'xiaohongshu') {
              return '<a href=\'https://xiaohongshu.com/user/profile/' + item.xhsID + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'facebook') {
              return '<a href=\'https://facebook.com/@' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
          }
        },
        Platform: 'platform',
        Remark: 'remarks',
        Gender: 'gender',
        'Age Group': 'age_group',
        'Aud. Age Group': 'displayAudAge',
        'Aud. Country': 'displaytopCountry',
        Followers: 'followers',
        'Follower Gender': 'audGenderDisplay',
        'Audience Cred.': 'audience_credibility',
        'Avg. Likes': 'avg_likes',
        'Avg. Comments': 'avg_comments',
        'Avg. Reels Plays (IG)': 'avg_reels_plays',
        'Avg. Views (TT)': 'avg_views',
        'Avg. Saves (TT)': 'avg_saves',
        'Avg. Shares (TT)': 'avg_shares',
        'Median Engagement Rate': 'medianEngRateDisplay',
        'Influencer Interests': 'infInterestDisplay',
        'Aud. Interests': 'audInterestDisplay',
        Engagement: 'engagementRateDisplay',
        'TikTok Posts': 'no_of_tiktok_posts',
        'Posts': 'no_of_posts',
        'Carousels': 'no_of_carousels',
        Videos: 'no_of_video',
        Stories: 'no_of_stories',
        Reels: 'no_of_reels',
        Youtube: 'youtube',
        XHS: 'no_of_xhs_posts',
        Facebook: 'no_of_fb_posts',
        Remarks: 'remarks'
      },
      showHideFields: [{
        name: 'influencer',
        label: 'Influencer'
      }, {
        name: 'remark',
        label: 'Remarks'
      }, {
        name: 'gender',
        label: 'Gender'
      }, {
        name: 'ageGroup',
        label: 'Age Group'
      }, {
        name: 'audAgeGroup',
        label: 'Aud. Age Group'
      }, {
        name: 'country',
        label: 'Aud. Country'
      }, {
        name: 'followers',
        label: 'Followers'
      }, {
        name: 'genderPercentage',
        label: 'Follower Gender'
      }, {
        name: 'audienceCred',
        label: 'Audience Cred.'
      }, {
        name: 'avgLikes',
        label: 'Avg. Likes'
      }, {
        name: 'avgComments',
        label: 'Avg. Comments'
      }, {
        name: 'avgReelsPlays',
        label: 'Avg. Reels Plays (IG)'
      }, {
        name: 'avgViews',
        label: 'Avg. Views (TT)'
      }, {
        name: 'avgSaves',
        label: 'Avg. Saves (TT)'
      }, {
        name: 'avgShares',
        label: 'Avg. Shares (TT)'
      }, {
        name: 'medianEngagementRate',
        label: 'Median Engagement Rate'
      }, {
        name: 'infInterests',
        label: 'Influencer interests'
      }, {
        name: 'interests',
        label: 'Audience interests'
      }, {
        name: 'engagement',
        label: 'Engagement'
      }, {
        name: 'rateCard',
        label: 'Rate Card'
      }, {
        name: 'AIPayout',
        label: 'Deliverables'
      }, {
        name: 'payout',
        label: 'Payout'
      }, {
        name: 'eliminationStatus',
        label: 'Elimination Status'
      }, {
        name: 'pairingStatus',
        label: 'Pairing Status'
      }],
      defaultPairingDisplayStatus: {
        influencer: true,
        remark: true,
        gender: true,
        genderPercentage: true,
        ageGroup: true,
        audAgeGroup: true,
        country: true,
        followers: true,
        audienceCred: true,
        avgLikes: true,
        avgComments: true,
        avgViews: true,
        avgReelsPlays: true,
        medianEngagementRate: true,
        infInterests: true,
        interests: true,
        engagement: true,
        rateCard: true,
        AIPayout: true,
        payout: true,
        eliminationStatus: true,
        pairingStatus: true
      },
      items: [],
      pairedInfluencers: [],
      listReview: [],
      suggestedInfluencers: [],
      isLoading: false,
      campaign: {},
      searchKeywordAction: '',
      SearchTypeEnum: SearchTypeEnum,
      Steps: Steps,
      igHandle: '',
      viewOnly: false,
      searchType: SearchTypeEnum.HANDLE,
      actionSelected: [],
      selected: [],
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0
      },
      historySearchResult: null,
      currentKeywordSearch: '',
      pairingStepper: Steps.FIND_INFLUENCERS,
      showInfluencerSearchResult: false,
      influencerSearchResult: null,
      activePairingData: null,
      updatePairingDialog: false,
      priceMultiplierDialog: false,
      priceMultiplierInfluencerData: null,
      lineUpItems: [],
      genderItems: ['Male', 'Female'],
      genderPie: {
        title: 'Report Abuse in %',
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center'
          }
        },
        width: 50,
        height: 50
      },
      searchInfluencerTypes: ['Instagram', 'TikTok', 'Youtube'],
      filteredItems: [],
      ageItems: [],
      locationItems: [],
      searchGender: '',
      searchAge: '',
      searchLocation: '',
      searchPairingStatus: '',
      searchAudCrediblity: '',
      searchInfluencer: 'Instagram',
      topFiveAudienceInterests: [],
      disableSaveLineUp: true,
      disableSaveEdit: true,
      isOpen: '',
      openExpansion: [],
      inputRates: {},
      rateCardFormRates: {},
      isPricingDeskEmpty: false,
      isEditing: false,
      searchFilter: '',
      audCrediblityFilters: [{ name: 'Red', min: 0, max: 30 }, { name: 'Orange', min: 30, max: 50 }, { name: 'Green', min: 50, max: 100 }],
      markupCOGSAmount: false,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_14__campaignHelper__["a" /* default */],
      oldEditItem: null,
      isMultipleDeliverables: false,
      infListTitle: 'Untitled'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_vuex__["b" /* mapState */])({
    rateCards: function rateCards(state) {
      return state.influencer.rateCards;
    },
    requestedPayoutEdit: function requestedPayoutEdit(state) {
      return state.pairing.requestedPayoutEdit;
    },
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    },
    infDetail: function infDetail(state) {
      return state.influencer.infDetail;
    }
  }), {
    filteredHeaders: function filteredHeaders() {
      var _this = this;

      return this.headers.filter(function (h) {
        var pairingDisplayStatus = _this.campaign.pairingDisplayStatus;
        if (pairingDisplayStatus !== undefined) {
          if (h.name !== undefined && !pairingDisplayStatus[h.name]) {
            return false;
          }
        }
        return true;
      });
    },
    selectAllStatus: function selectAllStatus() {
      return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.actionSelected);
    },

    showBtnCO: function showBtnCO() {
      if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        return true;
      } else {
        return false;
      }
    },
    showBtnAM: function showBtnAM() {
      if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        return true;
      } else {
        return false;
      }
    },
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAdmin: function isAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    pairingStatusOptions: function pairingStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    },
    acceptPairingStatusOptions: function acceptPairingStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        if (item[1].value === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.ACCEPTED || item[1].value === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NOT_ACCEPTED) {
          data.push({
            status: item[1].value,
            display: item[1].text
          });
        }
      });
      return data;
    },
    filterPairingStatusOptions: function filterPairingStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        if (item[1].value === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NEW || item[1].value === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.ACCEPTED || item[1].value === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NOT_ACCEPTED) {
          data.push({
            status: item[1].value,
            display: item[1].text
          });
        }
      });
      data.unshift({
        status: '',
        display: 'All'
      });
      return data;
    },
    budget: function budget() {
      this.markupCOGSAmount = __WEBPACK_IMPORTED_MODULE_14__campaignHelper__["a" /* default */].getMarkupCOGS(this.campaign.ioNumbers, this.client);
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaign.budget * 0.26);
    },
    newPairings: function newPairings() {
      var _this2 = this;

      return this.items.filter(function (item) {
        return item.pairingStatus === _this2.pairingStatus.NEW.value;
      }).length;
    },
    accepted: function accepted() {
      var _this3 = this;

      return this.items.filter(function (item) {
        return item.pairingStatus === _this3.pairingStatus.ACCEPTED.value;
      }).length;
    },
    notAccepted: function notAccepted() {
      var _this4 = this;

      return this.items.filter(function (item) {
        return item.pairingStatus === _this4.pairingStatus.NOT_ACCEPTED.value;
      }).length;
    },
    newEliminations: function newEliminations() {
      var _this5 = this;

      return this.items.filter(function (item) {
        return item.eliminationStatus === _this5.eliminationStatus.NEW;
      }).length;
    },
    noOfSelected: function noOfSelected() {
      var _this6 = this;

      return this.items.filter(function (item) {
        return item.eliminationStatus === _this6.eliminationStatus.SELECTED;
      }).length;
    },
    noOfEliminated: function noOfEliminated() {
      var _this7 = this;

      return this.items.filter(function (item) {
        return item.eliminationStatus === _this7.eliminationStatus.ELIMINATED;
      }).length;
    },
    disableLockedCOGS: function disableLockedCOGS() {
      return this.campaign.lockedCOGS || false;
    },
    showLockBtn: function showLockBtn() {
      if (this.campaign.id && !this.campaign.lockedCOGS && (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].userRoles.AD_STRATEGIST)) {
        return true;
      }
      return false;
    }
  }),
  watch: {
    value: function value(newVal) {
      if (newVal) {
        this.resetData();
        if (this.creator) {
          this.infListTitle = this.creator.name;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(this.creator.creators), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var creator = _step.value;

              creator = this.beautifyData(creator);
              creator.success = true;
              this.items.push(creator);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.resetData();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    getPairingStatusLabels: function getPairingStatusLabels(status) {
      var lable = void 0;
      __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        if (item[1].value === status) {
          lable = item[1].text;
        }
      });
      return lable;
    },
    priceMultiplierHandler: function priceMultiplierHandler(item) {
      this.priceMultiplierInfluencerData = item;
      this.isMultipleDeliverables = false;
      this.priceMultiplierDialog = true;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagements = item.engagements;
      return engagements * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts;
    },
    pairChanged: function pairChanged() {
      this.updatePairingDialog = false;
      this.priceMultiplierDialog = false;
      this.getPairedInfluencers(this.campaign.id);
    },
    openDeliverableUpdateDialog: function openDeliverableUpdateDialog() {
      this.isMultipleDeliverables = true;
      this.priceMultiplierDialog = true;
    },
    updatePairingStatusHandler: function updatePairingStatusHandler(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = false;
    },
    viewDetailPairing: function viewDetailPairing(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = true;
    },
    executeMethod: function executeMethod(method, data) {
      switch (method) {
        case 'delete':
          this.removeSelectedInfluencer(data.userHandle, data.platform);
          break;
        case 'view':
          this.viewDetailPairing(data);
          break;
        case 'edit':
          this.updatePairingStatusHandler(data);
          break;
        case 'refresh':
          this.refreshPairingData(data);
          break;
      }
    },
    refreshPairingData: function refreshPairingData(data) {
      this.isLoading = true;
      this.refreshInfluencerDetail(data.userHandle, data.platform.toLowerCase(), data.pairingID);
      this.addToSelectedInfluencers(data.userHandle, data.platform.toLowerCase());
    },
    paramsUpdated: function paramsUpdated() {
      this.settingAIDialog = false;
      this.getSuggestedInfluencerFromAI(this.campaign.id, true);
    },
    enableSettingForAI: function enableSettingForAI() {
      this.settingAIDialog = !this.settingAIDialog;
    },
    showReason: function showReason(text) {
      this.eliminationReason = text;
      this.reasonDialog = true;
    },
    editAmount: function editAmount(item) {
      var index = this.items.findIndex(function (element) {
        return element.userHandle === item.userHandle;
      });
      if (index === -1) return;
      this.items[index].isEditting = true;
      this.items.splice();
    },
    isSelected: function isSelected(igHandle, platform) {
      return this.selected.find(function (e) {
        return e.handle === igHandle && e.platform === platform;
      });
    },
    updateLineUp: function updateLineUp() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this8.lineUpItems.map(function (item, index) {
                  var data = {
                    pairingID: item.pairingID,
                    lineUpIndex: index
                  };
                  __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    invokeSendToAM: function invokeSendToAM() {
      var _this9 = this;

      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this9.isLoading = true;
              __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].sendCOGSExceedReminder(_this9.campaign.id).then(function (sents) {
                _this9.isLoading = false;
                _this9.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: 'The request for release has been sent to Admin.'
                });
                _this9.getPairedInfluencers(_this9.campaign.id);
              }).catch(function () {
                _this9.isLoading = false;
              });
            }
          });
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this9.sendToAM();
            }
          });
        }
        return;
      } else {
        this.sendToAM();
      }
    },
    sendToAM: function sendToAM() {
      var _this10 = this;

      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: this.newEliminations + ' new influencer(s) will be sent to AM for approval.'
      }).then(function (result) {
        if (result.value) {
          _this10.isLoading = true;
          if (_this10.lineUpItems.length > 0) {
            _this10.updateLineUp();
            __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToAM(_this10.campaign.id).then(function () {
              _this10.isLoading = false;
              _this10.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to client.'
              });
              _this10.getPairedInfluencers(_this10.campaign.id);
            }).catch(function () {
              _this10.isLoading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToAM(_this10.campaign.id).then(function () {
              _this10.isLoading = false;
              _this10.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to AM.'
              });
              _this10.getPairedInfluencers(_this10.campaign.id);
            }).catch(function () {
              _this10.isLoading = false;
            });
          }
        }
      });
    },
    showPairingEliminEditModal: function showPairingEliminEditModal() {
      this.eliminationDialog = true;
      this.campaingDataForElimination = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.campaign);
    },
    invokeSendToClient: function invokeSendToClient() {
      var _this11 = this;

      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this11.isLoading = true;
              __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].sendCOGSExceedReminder(_this11.campaign.id).then(function (sents) {
                _this11.isLoading = false;
                _this11.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: 'The request for release has been sent to Admin.'
                });
                _this11.getPairedInfluencers(_this11.campaign.id);
              }).catch(function () {
                _this11.isLoading = false;
              });
            }
          });
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this11.sendToClient();
            }
          });
        }
        return;
      } else {
        this.sendToClient();
      }
    },
    sendToClient: function sendToClient() {
      var _this12 = this;

      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: this.newEliminations + ' new influencer(s) will be sent to client for elimination.'
      }).then(function (result) {
        if (result.value) {
          _this12.isLoading = true;
          if (_this12.lineUpItems.length > 0) {
            _this12.updateLineUp();
            __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToClient(_this12.campaign.id).then(function (sents) {
              _this12.isLoading = false;
              _this12.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to client.'
              });
              _this12.getPairedInfluencers(_this12.campaign.id);
            }).catch(function () {
              _this12.isLoading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToClient(_this12.campaign.id).then(function (sents) {
              _this12.isLoading = false;
              _this12.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to client.'
              });
              _this12.getPairedInfluencers(_this12.campaign.id);
            }).catch(function () {
              _this12.isLoading = false;
            });
          }
        }
      });
    },
    close: function close() {
      this.saveInfData(true);
      this.$emit('input');
    },
    input1: function input1() {
      this.showInfluencerSearchResult = false;
    },
    select: function select(userHandle, platform) {
      if (this.selected.find(function (e) {
        return e.handle === userHandle && e.platform === platform.toLowerCase();
      })) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'Influencer is being selected'
        });
      } else {
        if (platform === 'Instagram') {
          userHandle = userHandle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.regexMatchIg(userHandle, __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].regexPattern.instagram_profile)) : '';
        } else if (platform === 'TikTok') {
          userHandle = userHandle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.extractTikTokHandle(userHandle)) : '';
        }
        this.crawlInfluencerDetail(userHandle, this.searchInfluencer);
        this.addToSelectedInfluencers(userHandle, platform.toLowerCase());
      }
    },
    removeSelectedInfluencer: function removeSelectedInfluencer(userHandle, platform) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var item, payload;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                item = _this13.items.find(function (element) {
                  return element.userHandle === userHandle && element.platform === platform;
                });

                __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.removePairingElementFromArray(_this13.items, userHandle, 'object', 'userHandle', platform);
                __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.removePairingElementFromArray(_this13.selected, userHandle, 'string', 'handle', platform);
                __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.removeElementFromArray(_this13.ageItems, _this13.items.country, 'object', 'country');

                if (!_this13.creator) {
                  _context3.next = 11;
                  break;
                }

                if (!_this13.creator.id) {
                  _context3.next = 11;
                  break;
                }

                if (!item.pairingID) {
                  _context3.next = 11;
                  break;
                }

                payload = {
                  creatorId: item.pairingID
                };

                if (_this13.creator) {
                  payload.creatorListId = _this13.creator.id;
                }
                _context3.next = 11;
                return _this13.$store.dispatch('pairing/deleteInfDetailData', payload);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this13);
      }))();
    },
    addToSelectedInfluencers: function addToSelectedInfluencers(userHandle, platform) {
      var inf = {
        userHandle: userHandle,
        remarks: '',
        pairingStatus: '',
        eliminationStatus: '',
        gender: '',
        age_group: '',
        followers: '0',
        country: '',
        audience_interests: [],
        audience_credibility: '0',
        engagements: 0,
        engagement_rate: '0',
        payoutAmount: '0',
        isLoading: true,
        platform: platform
      };
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.pushPairingElementToArray(this.items, inf, 'userHandle', 'object', platform);
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.pushPairingElementToArray(this.selected, { handle: userHandle, platform: platform }, 'handle', 'object', platform);
    },
    getSuggestedInfluencerFromAI: function getSuggestedInfluencerFromAI(campaignID, force) {
      var _this14 = this;

      this.loadingAI = true;
      __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].getInfluencerFromAI(campaignID, force).then(function (resp) {
        _this14.loadingAI = false;
        if (resp) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(resp), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var inf = _step2.value;

              inf.platform = 'instagram';
              __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.pushElementToArray(_this14.suggestedInfluencers, inf, 'userHandle', __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].TYPE.OBJECT);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }).catch(function (err) {
        _this14.loadingAI = false;
        console.error(err);
      });
    },
    refreshInfluencerDetail: function refreshInfluencerDetail(ighandle, platform, pairingID) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].refreshInfluencerDetails({ ighandle: ighandle, campaignID: this.campaign.id, platform: platform.toLowerCase(), pairingID: pairingID }).then(function (response) {
        var index = _this15.items.findIndex(function (item) {
          return item.userHandle === ighandle && item.platform === platform.toLowerCase();
        });
        var inf = _this15.items[index];
        if (response.success) {
          var data = response.data;
          inf = _this15.beautifyData(data);
        } else {
          inf.message = response.message || '';
          inf.socialDataErrMessage = response.socialDataErrMessage || '';
          inf.audience_credibility = response.audience_credibility || 0;
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50';
          inf = _this15.initEditFields(inf);
        }
        inf.isLoading = false;
        inf.success = response.success;
        _this15.items[index] = inf;
        _this15.items = _this15.items.slice();
        _this15.setAgeGroupItems(_this15.items);
        _this15.getTopFiveAudienceInterests(_this15.items);
        _this15.setMultipleInfs();
        _this15.isLoading = false;
      });
    },
    crawlInfluencerDetail: function crawlInfluencerDetail(userHandle, platform) {
      var _this16 = this;

      __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].fetchInfluencerForList({ userHandle: userHandle, platform: platform.toLowerCase() }).then(function (response) {
        var index = _this16.items.findIndex(function (item) {
          return item.userHandle === userHandle && item.platform === platform.toLowerCase();
        });
        var inf = _this16.items[index];
        if (response.success) {
          var data = response.data;
          inf = _this16.beautifyData(data);
        } else {
          inf.message = response.message || '';
          inf.socialDataErrMessage = response.socialDataErrMessage || '';
          inf.audience_credibility = response.audience_credibility || 0;
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50';
          inf = _this16.initEditFields(inf);
        }
        inf.isLoading = false;
        inf.success = response.success;
        _this16.items[index] = inf;
        _this16.items = _this16.items.slice();
        _this16.setAgeGroupItems(_this16.items);
        _this16.getTopFiveAudienceInterests(_this16.items);
        _this16.setMultipleInfs();
      });
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      inf = data.influencer_details;
      inf.influencer_details = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, data.influencer_details);
      var deliverablesDetails = data.deliverables_details || {};
      var additionalDetails = data.additional_details || {};
      var audienceDetails = data.avg_performances || null;
      inf.remarks = additionalDetails.remarks;
      inf.deliverableDetails = deliverablesDetails;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.no_of_fb_posts = deliverablesDetails.no_of_fb_posts || 0;
      inf.no_of_xhs_posts = deliverablesDetails.no_of_xhs_posts || 0;
      inf.loading_whitelisting = deliverablesDetails.loading_whitelisting || '';
      inf.youtube = deliverablesDetails.youtube || 0;
      inf.exclusivity = deliverablesDetails.exclusivity || '';
      inf.physical_attendance = deliverablesDetails.physical_attendance || 0;
      inf.online_attendance = deliverablesDetails.online_attendance || 0;
      inf.customDeliverables = deliverablesDetails.custom || [];
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram';
      inf.audience_genders = inf.audience_genders || [];
      inf = this.initEditFields(inf);
      if (!inf.userHandle) inf.userHandle = inf.instagramHandle;
      if (inf.platform && inf.platform === 'xiaohongshu') {
        inf.userHandle = inf.fullName;
        inf.xhsID = inf.xhsID || inf.instagramHandle;
      }
      if (audienceDetails) {
        inf.avg_likes = audienceDetails.avg_likes || '';
        inf.avg_comments = audienceDetails.avg_comments || '';
        inf.avg_views = audienceDetails.avg_views || '';
        inf.avg_reels_plays = audienceDetails.avg_reels_plays || '';
        inf.avg_saves = audienceDetails.avg_saves || '';
        inf.avg_shares = audienceDetails.avg_shares || '';
        inf.median_engagement_rate = audienceDetails.median_engagement_rate || '';
      }
      inf.topAudAges = [];
      if (inf.audAges) {
        inf.audAges = __WEBPACK_IMPORTED_MODULE_31_lodash_sortBy___default()(inf.audAges, 'lineupIndex');
        inf.audAges = inf.audAges.map(function (a) {
          if (!a.lineupIndex) {
            a.lineupIndex = 999;
          } else if (a.lineupIndex !== 999) {
            inf.topAudAges.push(a.code);
          }
          return a;
        });
        inf.audAges = inf.audAges.sort(function (a, b) {
          return a.lineupIndex - b.lineupIndex;
        });
        if (inf.topAudAges.length) {
          inf.audAgesDisplay = inf.audAges.slice(0, inf.topAudAges.length);
        }
      } else {
        inf.audAges = [];
      }

      if (inf.audAges && inf.audAges.length) {
        inf.displayAudAge = inf.audAges.slice(0, 3);
        if (inf.displayAudAge.length) {
          inf.displayAudAge = inf.displayAudAge.map(function (d) {
            return d.code + ' (' + (d.weight * 100).toFixed(2) + '%)';
          }).join('\n');
        }
      }
      inf.topCountries = [];
      if (inf.countries) {
        inf.countries = __WEBPACK_IMPORTED_MODULE_31_lodash_sortBy___default()(inf.countries, 'lineupIndex');
        inf.countries = inf.countries.map(function (a) {
          if (!a.lineupIndex) {
            a.lineupIndex = 999;
          } else if (a.lineupIndex !== 999) {
            inf.topCountries.push(a.name);
          }
          return a;
        });
        if (inf.topCountries.length) {
          inf.topCountryDisplay = inf.countries.slice(0, inf.topCountries.length);
        }
      } else {
        inf.countries = [];
      }

      if (inf.countries && inf.countries.length) {
        inf.displaytopCountry = inf.countries.slice(0, 3);
        if (inf.displaytopCountry.length) {
          inf.displaytopCountry = inf.displaytopCountry.map(function (d) {
            return d.name + ' (' + (d.weight * 100).toFixed(2) + '%)';
          }).join('\n');
        }
      }

      if (inf.infInterests) {
        if (inf.infInterests.length) {
          inf.infInterestDisplay = inf.infInterests.map(function (i) {
            return i.name;
          }).join(',');
        }
      }

      if (inf.audience_interests) {
        if (inf.audience_interests) {
          inf.audInterestDisplay = inf.audience_interests.map(function (i) {
            return i.name;
          }).join(',');
        }
      }

      var audGenderRet = [];
      if (Array.isArray(inf.audience_genders)) {
        var male = inf.audience_genders.find(function (a) {
          return a.code === 'MALE';
        });
        if (male) audGenderRet.push(male);
        var female = inf.audience_genders.find(function (a) {
          return a.code === 'FEMALE';
        });
        if (female) audGenderRet.push(female);
        audGenderRet = audGenderRet.map(function (gender) {
          return gender.code + ' (' + (gender.weight * 100).toFixed(2) + '%)';
        }).join('\n');
      }
      inf.audGenderDisplay = audGenderRet;

      inf.engagementRateDisplay = '';
      if (inf.engagement_rate) inf.engagementRateDisplay = inf.engagement_rate + '%';
      inf.medianEngRateDisplay = '';
      if (inf.median_engagement_rate) inf.medianEngRateDisplay = inf.median_engagement_rate + '%';
      inf.genderEdit = false;
      inf.ageGroupEdit = false;
      inf.audAgesEdit = false;
      inf.audCountryEdit = false;
      return inf;
    },
    setMultipleInfs: function setMultipleInfs() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item, infs;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 3;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(_this17.items);

              case 5:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context4.next = 21;
                  break;
                }

                item = _step3.value;

                if (item.influencerID) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt('continue', 18);

              case 9:
                infs = [];
                _context4.next = 12;
                return _this17.$store.dispatch('influencer/getInfluencerDetail', {
                  id: item.influencerID
                });

              case 12:
                if (_this17.infDetail.instagram) {
                  infs.push({
                    handle: _this17.infDetail.instagram.instagramHandle,
                    instagramID: _this17.infDetail.instagram.instagramID,
                    picture: _this17.infDetail.audience ? _this17.infDetail.audience.user_profile.picture : _this17.infDetail.instagram.picture,
                    instagram: true
                  });
                }
                if (_this17.infDetail.tiktok) {
                  infs.push({
                    handle: _this17.infDetail.tiktok.tiktokHandle,
                    tiktokID: _this17.infDetail.tiktok.tiktokID,
                    picture: _this17.infDetail.tiktokaudience ? _this17.infDetail.tiktokaudience.user_profile.picture : _this17.infDetail.tiktok.picture,
                    tiktok: true
                  });
                }
                if (_this17.infDetail.youtube) {
                  infs.push({
                    handle: _this17.infDetail.youtube.youtubeHandle,
                    youtubeID: _this17.infDetail.youtube.youtubeID,
                    picture: _this17.infDetail.youtubeaudience ? _this17.infDetail.youtubeaudience.user_profile.picture : _this17.infDetail.youtube.picture,
                    youtube: true
                  });
                }
                if (_this17.infDetail.xiaohongshu) {
                  infs.push({
                    handle: _this17.infDetail.xiaohongshu.xhsHandle,
                    xhsID: _this17.infDetail.xiaohongshu.xhsID,
                    picture: _this17.infDetail.xiaohongshu ? _this17.infDetail.xiaohongshu.profilePicture : '',
                    xhs: true
                  });
                }
                if (_this17.infDetail.facebook) {
                  infs.push({
                    handle: _this17.infDetail.facebook.handle,
                    xhsID: _this17.infDetail.facebook.facebookId,
                    picture: _this17.infDetail.facebook ? _this17.infDetail.facebook.profilePicture : '',
                    facebook: true
                  });
                }
                item.multipleInfs = infs;

              case 18:
                _iteratorNormalCompletion3 = true;
                _context4.next = 5;
                break;

              case 21:
                _context4.next = 27;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4['catch'](3);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t0;

              case 27:
                _context4.prev = 27;
                _context4.prev = 28;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 30:
                _context4.prev = 30;

                if (!_didIteratorError3) {
                  _context4.next = 33;
                  break;
                }

                throw _iteratorError3;

              case 33:
                return _context4.finish(30);

              case 34:
                return _context4.finish(27);

              case 35:
                _this17.items = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this17.items);

              case 36:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this17, [[3, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    searchManually: function searchManually(searchType) {
      switch (searchType) {
        case SearchTypeEnum.KEYWORD:
          this.searchByKeyword();
          break;
        case SearchTypeEnum.HANDLE:
          this.searchByHandle(this.igHandle);
          this.igHandle = '';
          break;
      }
    },
    searchByHandle: function searchByHandle(ighandle) {
      if (!ighandle || ighandle === '') {
        var errMsg = '';
        if (this.searchInfluencer === 'Instagram') {
          errMsg = 'Please enter the Instagram Handle';
        } else if (this.searchInfluencer === 'Facebook') {
          errMsg = 'Please enter the Facebook ID';
        } else if (this.searchInfluencer === 'Youtube') {
          errMsg = 'Please enter the Youtube ID';
        } else {
          errMsg = 'Please enter the TikTok Handle';
        }
        this.$swal({
          title: 'Error',
          text: errMsg,
          type: 'info'
        });
        return;
      }

      this.select(ighandle, this.searchInfluencer);
    },
    searchByKeyword: function searchByKeyword() {
      this.isLoading = true;
      this.searchKeywordAction = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.makeid(5);
    },
    resultFromSearchKeyword: function resultFromSearchKeyword(value) {
      this.isLoading = false;
      if (value.success) {
        this.currentKeywordSearch = value.keyword;
        this.historySearchResult = value;
        this.showResult(value);
      }
    },
    isBudgetOver: function isBudgetOver(target, current) {
      return current / target > 1;
    },
    showResult: function showResult(result) {
      this.showInfluencerSearchResult = true;
      this.influencerSearchResult = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, result);
      this.selected.splice();
    },
    getPairedInfluencers: function getPairedInfluencers(campaignID) {
      var _this18 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID).then(function (resp) {
        _this18.isLoading = false;
        if (resp) {
          var items = [];
          var selected = [];
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(resp), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var data = _step4.value;

              var inf = _this18.beautifyData(data);
              inf.isLoading = false;
              inf.success = true;
              items.push(inf);
              selected.push({ handle: inf.userHandle, platform: inf.platform });
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          var pairedInfluencer = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], items);
          _this18.items = pairedInfluencer.sort(function (a, b) {
            return a.lineUpIndex - b.lineUpIndex;
          });
          _this18.filteredItems = _this18.items;
          _this18.selected = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], selected);
          _this18.setAgeGroupItems(_this18.items);
          _this18.getTopFiveAudienceInterests(_this18.items);
          _this18.checkOpenPayoutEditDialog();
          _this18.setMultipleInfs();
          _this18.handleTableUpdate(_this18.items);
          if (_this18.unlockCogs) {
            _this18.changeLock(_this18.campaign, false);
            _this18.$emit('setUnlockCogs', false);
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this18.isLoading = false;
      });
    },
    setAgeGroupItems: function setAgeGroupItems(items) {
      var arrayItem = [];
      items.map(function (item) {
        if (item.age_group) {
          arrayItem.push(item.age_group);
        }
      });
      this.ageItems = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(arrayItem)));
    },
    goToStep: function goToStep(step) {
      this.pairingStepper = step;
    },
    getAge: function getAge(birthday) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()().format('YYYY') - __WEBPACK_IMPORTED_MODULE_12_moment___default()(birthday).format('YYYY');
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatCurrency: function formatCurrency(number) {
      return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.formatCurrency(number);
    },
    formatNumber: function formatNumber(number) {
      return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.formatNumber(number);
    },
    formatUploadedDate: function formatUploadedDate(value) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).format('DD/MM/YYYY');
    },
    handleTableUpdate: function handleTableUpdate(items) {
      this.lineUpItems = items;
      this.updateLineUp();
    },
    actionSelectChange: function actionSelectChange() {
      this.actionSelected = this.items.filter(function (i) {
        return i.isDelete;
      });
    },
    clearFilter: function clearFilter() {
      this.searchGender = '';
      this.searchAge = '';
      this.searchLocation = '';
      this.searchPairingStatus = '';
      this.searchAudCrediblity = '';
      this.getPairedInfluencers(this.campaign.id);
    },
    clearPairingData: function clearPairingData() {
      this.items = [];
      this.filteredItems = [];
    },
    clearActionSelected: function clearActionSelected() {
      this.items = this.items.map(function (inf) {
        delete inf.isDelete;
        return inf;
      });
      this.actionSelected = [];
    },
    genderOnChangeHandler: function genderOnChangeHandler() {
      var _this19 = this;

      if (this.searchAge && this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this19.searchGender.toString().toUpperCase() && item.age_group === _this19.searchAge.toString().toUpperCase() && item.country === _this19.searchLocation;
        });
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this19.searchAge.toString().toUpperCase() && item.gender === _this19.searchGender.toString().toUpperCase();
        });
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this19.searchGender.toString().toUpperCase() && item.country === _this19.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this19.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this19.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      } else this.items = this.filteredItems.filter(function (item) {
        return item.gender === _this19.searchGender.toString().toUpperCase();
      });
      this.getTopFiveAudienceInterests(this.items);
    },
    ageOnChangeHandler: function ageOnChangeHandler() {
      var _this20 = this;

      if (this.searchGender && this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this20.searchGender.toString().toUpperCase() && item.age_group === _this20.searchAge.toString().toUpperCase() && item.country === _this20.searchLocation;
        });
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this20.searchGender.toString().toUpperCase() && item.age_group === _this20.searchAge.toString().toUpperCase();
        });
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this20.searchAge.toString().toUpperCase() && item.country === _this20.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this20.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this20.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      } else this.items = this.filteredItems.filter(function (item) {
        return item.age_group === _this20.searchAge.toString().toUpperCase();
      });
      this.getTopFiveAudienceInterests(this.items);
    },
    countryOnChangeHandler: function countryOnChangeHandler() {
      var _this21 = this;

      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this21.searchGender.toString().toUpperCase() && item.age_group === _this21.searchAge.toString().toUpperCase() && item.country === _this21.searchLocation;
        });
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this21.searchAge.toString().toUpperCase() && item.country === _this21.searchLocation;
        });
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this21.searchGender.toString().toUpperCase() && item.country === _this21.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this21.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this21.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      } else this.items = this.filteredItems.filter(function (item) {
        return item.country === _this21.searchLocation;
      });
      this.getTopFiveAudienceInterests(this.items);
    },
    pairingStatusOnChangeHandler: function pairingStatusOnChangeHandler() {
      var _this22 = this;

      this.items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this22.searchGender.toString().toUpperCase() && item.age_group === _this22.searchAge.toString().toUpperCase() && item.country === _this22.searchLocation;
        });
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this22.searchAge.toString().toUpperCase() && item.country === _this22.searchLocation;
        });
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this22.searchGender.toString().toUpperCase() && item.country === _this22.searchLocation;
        });
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.country === _this22.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this22.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this22.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      }
      this.getTopFiveAudienceInterests(this.items);
    },
    getCountries: function getCountries() {
      var _this23 = this;

      __WEBPACK_IMPORTED_MODULE_18__Influencer_influencerAPIs__["a" /* default */].getCountries().then(function (countries) {
        _this23.locationItems = countries.map(function (item) {
          return item.name;
        });
      });
    },
    getTopFiveAudienceInterests: function getTopFiveAudienceInterests(items) {
      var _this24 = this;

      var audienceInterests = [];
      this.topFiveAudienceInterests = [];
      items.map(function (item) {
        if (item.audience_interests) {
          audienceInterests = item.audience_interests;
        }
        _this24.topFiveAudienceInterests.push([].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(audienceInterests)).sort(function (a, b) {
          return b.weight - a.weight;
        }).slice(0, 5));
      });
    },
    saveLineUp: function saveLineUp() {
      this.updateLineUp();
      this.$swal.fire({
        type: 'success',
        title: 'Saved!',
        showCancelButton: false,
        width: 300
      });
    },
    confirmDelete: function confirmDelete() {
      var _this25 = this;

      var text = "You won't be able to revert this!";
      this.$swal({
        title: 'Are you sure to delete?',
        icon: 'warning',
        showCancelButton: true,
        text: text
      }).then(function (result) {
        if (result.value) {
          _this25.isLoading = true;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(_this25.actionSelected), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var item = _step5.value;

              _this25.executeMethod('delete', item);
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          _this25.isLoading = false;
          _this25.$swal({
            text: 'Successfully Deleted.',
            type: 'success'
          });
          _this25.clearActionSelected();
        }
      });
    },
    invokeSaveInfData: function invokeSaveInfData() {
      var _this26 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this26.saveInfData();
        }
      });
    },
    saveInfData: function saveInfData() {
      var _this27 = this;

      var autoSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var saveData = {
        title: this.infListTitle,
        creatorIds: this.items.map(function (i) {
          return i.pairingID;
        })
      };
      if (this.creator) {
        saveData.id = this.creator.id;
      }
      __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].saveInfListData(saveData).then(function (response) {
        if (!autoSave) {
          _this27.$swal({
            text: 'Influencer List Saved',
            type: 'success'
          });
          _this27.$emit('reload');
          _this27.close();
        } else {
          _this27.$emit('reload');
        }
      }).catch(function (error) {
        _this27.isEditing = false;

        console.log('error', error);
        if (!autoSave) {
          _this27.$swal({
            text: error,
            type: 'error'
          });
        }
      });
    },
    getRateCardLists: function getRateCardLists() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this28.$store.dispatch('influencer/getRateCardLists', { filters: {} });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this28);
      }))();
    },
    calcMeasurements: function calcMeasurements(newList) {
      var _this29 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      newList.forEach(function (item) {
        if (item.eliminationStatus !== _this29.eliminationStatus.ELIMINATED) {
          _this29.measurement.total += Number(_this29.calculateContents(item));
          _this29.measurement.outreach += Number(_this29.calculateOutreach(item));
          _this29.measurement.engagement += Number(_this29.calculateEngagement(item));
          if (item.pairingStatus === _this29.pairingStatus.ACCEPTED.value) {
            _this29.measurement.budget += Number(item.payoutAmount || 0);
          }
        }
      });
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaign.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaign.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.campaign.budget * 100).toFixed(2);
      var content = this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
    },
    getFileType: function getFileType(item) {
      var filename = item.url.substring(item.url.lastIndexOf('/') + 1);
      var fileExt = filename.split('.')[1];

      return fileExt;
    },
    igHandleBulkUpload: function igHandleBulkUpload(e) {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var uploadedFiles, handles, handleItems, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, items, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, record;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context6.next = 4;
                  break;
                }

                _this30.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context6.abrupt('return');

              case 4:
                _context6.next = 6;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var fr = new FileReader();
                  fr.onload = function (e) {
                    var tmp = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.parserToJson(e.target.result);
                    resolve(tmp);
                  };
                  fr.readAsArrayBuffer(e.target.files[0]);
                  fr.onerror = reject;
                });

              case 6:
                handles = _context6.sent;
                handleItems = [];
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context6.prev = 11;
                _iterator6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(handles);

              case 13:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context6.next = 37;
                  break;
                }

                items = _step6.value;
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context6.prev = 18;

                for (_iterator7 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(items); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  record = _step7.value;

                  if (record.handle) {
                    if (record.type === 'instagram') {
                      record.handle = record.handle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.regexMatchIg(record.handle, __WEBPACK_IMPORTED_MODULE_27__config__["a" /* default */].regexPattern.instagram_profile)) : '';
                    } else if (record.type === 'tiktok') {
                      record.handle = record.handle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.extractTikTokHandle(record.handle)) : '';
                    }
                    handleItems.push({ handle: record.handle, platform: record.type });
                  }
                }
                _context6.next = 26;
                break;

              case 22:
                _context6.prev = 22;
                _context6.t0 = _context6['catch'](18);
                _didIteratorError7 = true;
                _iteratorError7 = _context6.t0;

              case 26:
                _context6.prev = 26;
                _context6.prev = 27;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 29:
                _context6.prev = 29;

                if (!_didIteratorError7) {
                  _context6.next = 32;
                  break;
                }

                throw _iteratorError7;

              case 32:
                return _context6.finish(29);

              case 33:
                return _context6.finish(26);

              case 34:
                _iteratorNormalCompletion6 = true;
                _context6.next = 13;
                break;

              case 37:
                _context6.next = 43;
                break;

              case 39:
                _context6.prev = 39;
                _context6.t1 = _context6['catch'](11);
                _didIteratorError6 = true;
                _iteratorError6 = _context6.t1;

              case 43:
                _context6.prev = 43;
                _context6.prev = 44;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 46:
                _context6.prev = 46;

                if (!_didIteratorError6) {
                  _context6.next = 49;
                  break;
                }

                throw _iteratorError6;

              case 49:
                return _context6.finish(46);

              case 50:
                return _context6.finish(43);

              case 51:
                _this30.uploadBulkHandle(handleItems);

              case 52:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this30, [[11, 39, 43, 51], [18, 22, 26, 34], [27,, 29, 33], [44,, 46, 50]]);
      }))();
    },
    uploadBulkHandle: function uploadBulkHandle(handleItems) {
      var _this31 = this;

      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'No Influencer Handle Found'
        });
        return;
      }
      var vm = this;
      this.resetBulkProgress();
      this.bulkProgress.show = true;
      this.bulkProgress.complete = handleItems.length;
      var importSelected = [];
      var interval = 100;
      handleItems.forEach(function (el, index) {
        setTimeout(function () {
          var handleItem = el;
          if (vm.selected.find(function (e) {
            return e.handle === handleItem && e.platform === el.platform;
          })) {
            importSelected.push({ handle: handleItem.handle, platform: handleItem.platform });
          } else {
            vm.crawlInfluencerDetail(handleItem.handle, handleItem.platform);
            vm.addToSelectedInfluencers(handleItem.handle, handleItem.platform);
            console.log('\uD83D\uDE80 ~ IG Handle: ' + handleItem.handle);
          }
          _this31.bulkProgress.processing = index + 1;
          if (_this31.bulkProgress.complete === _this31.bulkProgress.processing) {
            _this31.bulkProgress.show = false;
            _this31.showAlreadySelectedAlert(importSelected);
          }
        }, index * interval);
      });
      this.$refs.igBulkHandle.value = null;
    },
    showAlreadySelectedAlert: function showAlreadySelectedAlert(importSelected) {
      if (importSelected.length > 0) {
        var displayBlock = '';
        importSelected.map(function (a) {
          displayBlock += '<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">\n            <span class="v-chip__content">' + a + '</span>\n          </span>';
        });
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Influencers being selected: <div>' + displayBlock + '</div>'
        });
      }
      return;
    },
    resetBulkProgress: function resetBulkProgress() {
      this.bulkProgress.processing = 0;
      this.bulkProgress.complete = 0;
      this.bulkProgress.show = false;
    },
    openEditItem: function openEditItem(itemID, itemName) {
      if (this.disableLockedCOGS) {
        return;
      }
      var index = this.items.findIndex(function (i) {
        return i.pairingID === itemID;
      });
      if (itemName === 'payout') {
        if (this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return;
        }
      }
      if (itemName === 'status') {
        if (this.campaign.lockedCOGS || this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return;
        }
      }
      this.items[index][itemName + 'Edit'] = true;
      this.items[index].editPairing = true;
      this.oldEditItem = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.items[index]);
      this.disableSaveEdit = false;
    },
    cancelEdit: function cancelEdit() {
      var _this32 = this;

      this.items = this.items.map(function (inf) {
        inf = _this32.initEditFields(inf);
        return inf;
      });
      this.disableSaveEdit = true;
    },
    initEditFields: function initEditFields(inf) {
      inf.remarkEdit = false;
      inf.payoutEdit = false;
      inf.statusEdit = false;
      inf.editPairing = false;
      return inf;
    },
    changeBulkPairingStatus: function changeBulkPairingStatus(status) {
      var items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.items);
      items = items.map(function (i) {
        if (i.isDelete) {
          i.pairingStatus = status;
          i.editPairing = true;
        }
        return i;
      });
      this.saveEditingData(items);
    },
    selectAllPairings: function selectAllPairings($event) {
      if (!$event.value) {
        this.items = this.items.map(function (i) {
          i.isDelete = false;return i;
        });
      } else {
        this.items = this.items.map(function (i) {
          i.isDelete = true;
          return i;
        });
      }
      this.actionSelectChange();
    },
    updatePairingDisplayStatus: function updatePairingDisplayStatus() {
      var _this33 = this;

      var data = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        pairingDisplayStatus: this.campaign.pairingDisplayStatus
      });
      var formData = new FormData();
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

      __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].updatePairingDisplayStatus(this.campaign.id, formData).then(function (response) {
        console.log('successfully updated!');
      }).catch(function (error) {
        console.log('error', error);
        _this33.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    displayFields: function displayFields(field) {
      return true;
    },
    renderRemark: function renderRemark(remark) {
      if (remark !== undefined && remark !== null) {
        return remark.replace(/\n/g, '<br>');
      }
      return '-';
    },
    downloadSampleUpload: function downloadSampleUpload() {
      var link = document.createElement('a');

      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getGenderPieData: function getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        var ret = [];
        var male = audienceGenders.find(function (a) {
          return a.code === 'MALE';
        });
        if (male) ret.push(male);
        var female = audienceGenders.find(function (a) {
          return a.code === 'FEMALE';
        });
        if (female) ret.push(female);
        return ret.map(function (gender) {
          return (gender.weight * 100).toFixed(2);
        });
      }
    },
    displayGSTText: function displayGSTText(item) {
      if (item.isGST) {
        return '$' + (item.payoutAmount + parseFloat(item.GSTpercent || 0)) + ' (If GST Included)';
      }
      return item.min_payout ? '$' + item.min_payout + ' - $' + item.max_payout : '$' + item.max_payout;
    },
    openLockedPayoutEditDialog: function openLockedPayoutEditDialog(item) {
      this.lockedPayout = true;
      this.payoutEditPairing = item;
      this.editPayoutDialog = true;
    },
    openLockedCOGSDialog: function openLockedCOGSDialog(item) {
      var _this34 = this;

      this.$swal({
        title: 'Send Unlock Request',
        html: 'Are you sure to send request to unlock COGS?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7(result) {
          var reqData;
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!result.value) {
                    _context7.next = 5;
                    break;
                  }

                  reqData = {
                    campaignID: item.id
                  };
                  _context7.next = 4;
                  return _this34.$store.dispatch('pairing/requestPayoutEdit', reqData);

                case 4:
                  if (_this34.requestedPayoutEdit) {
                    _this34.$swal({
                      text: 'Successfully Requested.',
                      type: 'success'
                    });
                  }

                case 5:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this34);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    changeLock: function changeLock(item, status) {
      var _this35 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var lockTxt;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                lockTxt = status ? 'Lock' : 'Unlock';

                _this35.$swal({
                  title: 'Are you sure to ' + lockTxt + '?',
                  icon: 'warning',
                  confirmButtonText: lockTxt,
                  showCancelButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8(result) {
                    var updateObj, updateData;
                    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!result.value) {
                              _context8.next = 11;
                              break;
                            }

                            updateObj = {
                              id: item.id,
                              lockedCOGS: status
                            };

                            if (status === false) {
                              updateObj.unlockCogsEmail = true;
                            }
                            updateData = [updateObj];
                            _context8.next = 6;
                            return _this35.$store.dispatch('campaign/updateCampaignByIds', updateData);

                          case 6:
                            if (_this35.campaignUpdated) {
                              _context8.next = 9;
                              break;
                            }

                            _this35.$swal({
                              text: 'Error Campaign Update.',
                              type: 'error'
                            });
                            return _context8.abrupt('return');

                          case 9:
                            _this35.$swal({
                              text: 'Successfully ' + lockTxt + 'ed.',
                              type: 'success'
                            });
                            item.lockedCOGS = status;

                          case 11:
                            _this35.getPairedInfluencers(_this35.campaign.id);

                          case 12:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this35);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this35);
      }))();
    },
    savedGetApproval: function savedGetApproval() {
      this.getPairedInfluencers(this.campaign.id);
    },
    openPayoutEditDialog: function openPayoutEditDialog(item) {
      this.lockedPayout = false;
      this.payoutEditPairing = item;
      this.editPayoutDialog = true;
    },
    openReqApprovalDialog: function openReqApprovalDialog(updateData) {
      this.reqAmt = Number(updateData.amount);
      this.reqReasons = updateData.reasons;
      this.reqApprovalDialog = true;
    },
    checkOpenPayoutEditDialog: function checkOpenPayoutEditDialog() {
      if (this.$route.query.payoutConfirm && this.$route.query.handle) {
        var handle = this.$route.query.handle;
        var matchItem = this.filteredItems.find(function (f) {
          return f.userHandle === handle;
        });
        if (matchItem) {
          if (matchItem.payoutStatus === this.payoutStatus.CONFIRMED) {
            this.openLockedPayoutEditDialog(matchItem);
          } else {
            this.openPayoutEditDialog(matchItem);
          }
        }
      }
    },
    changePairingStatus: function changePairingStatus(item) {
      var _this36 = this;

      if (item.pairingStatus === __WEBPACK_IMPORTED_MODULE_26__config__["a" /* default */].pairingStatus.ACCEPTED) {
        var totalDeliverables = __WEBPACK_IMPORTED_MODULE_14__campaignHelper__["a" /* default */].getTotalDeliverables(item.deliverableDetails);
        if (totalDeliverables <= 0) {
          this.$swal({
            text: 'Please submit deliverables to accept.',
            type: 'warning'
          });

          this.items = this.items.map(function (i) {
            if (i.pairingID === item.pairingID) {
              if (_this36.oldEditItem) {
                i.pairingStatus = _this36.oldEditItem.pairingStatus;
                i.statusEdit = false;
              }
            }
            return i;
          });
          return;
        }
        if (item.payoutAmount === 0) {
          this.$swal({
            html: 'The Payout is 0$.<br>Please confirm this creator doesn\u2019t need payment.',
            type: 'warning'
          });
        }
      }
    },
    openRateCardView: function openRateCardView(rateCard) {
      window.open('/influencers/rate-cards?id=' + rateCard.id, '_blank');
    },
    changePairingColEdit: function changePairingColEdit(colName, item, status) {
      var matchItemIdx = this.items.findIndex(function (f) {
        return f.pairingID === item.pairingID;
      });
      if (matchItemIdx !== -1) {
        this.items[matchItemIdx][colName] = status;
        this.items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.items);
      }
    },
    updatePairingCol: function updatePairingCol(item, field) {
      var _this37 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var updatePairings, idx, _loop, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, fieldItem, _idx, _loop2, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _fieldItem, formData, resp, _matchItemIdx, tmp;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this37.isLoading = true;
                updatePairings = [];

                if (field === 'gender') {
                  item.influencer_details.gender = item.gender;
                  updatePairings.push({
                    id: item.pairingID,
                    'influencer_details': item.influencer_details
                  });
                }
                if (field === 'age_group') {
                  item.influencer_details.age_group = item.age_group;
                  updatePairings.push({
                    id: item.pairingID,
                    'influencer_details': item.influencer_details
                  });
                }

                if (!(field === 'topAudAges')) {
                  _context10.next = 30;
                  break;
                }

                if (!item.influencer_details.audAges) {
                  item.influencer_details.audAges = [];
                }

                item.influencer_details.audAges = item.influencer_details.audAges.filter(function (c) {
                  return !c.manual;
                });

                item.influencer_details.audAges = item.influencer_details.audAges.map(function (a) {
                  delete a.lineupIndex;
                  return a;
                });
                idx = 1;

                _loop = function _loop(fieldItem) {
                  var matchItemIdx = item.influencer_details.audAges.findIndex(function (a) {
                    return a.code === fieldItem;
                  });
                  if (matchItemIdx !== -1) {
                    item.influencer_details.audAges[matchItemIdx].lineupIndex = idx;
                  } else {
                    item.influencer_details.audAges.push({
                      code: fieldItem,
                      weight: 0,
                      lineupIndex: idx,
                      manual: true
                    });
                  }
                  idx += 1;
                };

                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context10.prev = 13;

                for (_iterator8 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(item[field]); !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  fieldItem = _step8.value;

                  _loop(fieldItem);
                }
                _context10.next = 21;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10['catch'](13);
                _didIteratorError8 = true;
                _iteratorError8 = _context10.t0;

              case 21:
                _context10.prev = 21;
                _context10.prev = 22;

                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }

              case 24:
                _context10.prev = 24;

                if (!_didIteratorError8) {
                  _context10.next = 27;
                  break;
                }

                throw _iteratorError8;

              case 27:
                return _context10.finish(24);

              case 28:
                return _context10.finish(21);

              case 29:
                updatePairings.push({
                  id: item.pairingID,
                  'influencer_details': item.influencer_details
                });

              case 30:
                if (!(field === 'topCountries')) {
                  _context10.next = 56;
                  break;
                }

                if (!item.influencer_details.countries) {
                  item.influencer_details.countries = [];
                }
                item.influencer_details.countries = item.influencer_details.countries.filter(function (c) {
                  return !c.manual;
                });
                item.influencer_details.countries = item.influencer_details.countries.map(function (a) {
                  delete a.lineupIndex;
                  return a;
                });
                _idx = 1;

                _loop2 = function _loop2(_fieldItem) {
                  var matchItemIdx = item.influencer_details.countries.findIndex(function (a) {
                    return a.name === _fieldItem;
                  });
                  if (matchItemIdx !== -1) {
                    item.influencer_details.countries[matchItemIdx].lineupIndex = _idx;
                  } else {
                    item.influencer_details.countries.push({
                      name: _fieldItem,
                      weight: 0,
                      lineupIndex: _idx,
                      manual: true
                    });
                  }
                  _idx += 1;
                };

                _iteratorNormalCompletion9 = true;
                _didIteratorError9 = false;
                _iteratorError9 = undefined;
                _context10.prev = 39;

                for (_iterator9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(item[field]); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  _fieldItem = _step9.value;

                  _loop2(_fieldItem);
                }
                _context10.next = 47;
                break;

              case 43:
                _context10.prev = 43;
                _context10.t1 = _context10['catch'](39);
                _didIteratorError9 = true;
                _iteratorError9 = _context10.t1;

              case 47:
                _context10.prev = 47;
                _context10.prev = 48;

                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }

              case 50:
                _context10.prev = 50;

                if (!_didIteratorError9) {
                  _context10.next = 53;
                  break;
                }

                throw _iteratorError9;

              case 53:
                return _context10.finish(50);

              case 54:
                return _context10.finish(47);

              case 55:
                updatePairings.push({
                  id: item.pairingID,
                  'influencer_details': item.influencer_details
                });

              case 56:
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context10.next = 60;
                return __WEBPACK_IMPORTED_MODULE_20__Pairing_pairingAPIs__["a" /* default */].updatePairings(formData);

              case 60:
                resp = _context10.sent;

                if (resp) {
                  _matchItemIdx = _this37.items.findIndex(function (f) {
                    return f.pairingID === item.pairingID;
                  });

                  if (_matchItemIdx !== -1) {
                    _this37.items[_matchItemIdx][field] = item[field];
                    if (field === 'topAudAges') {
                      item.influencer_details.audAges = __WEBPACK_IMPORTED_MODULE_31_lodash_sortBy___default()(item.influencer_details.audAges, 'lineupIndex');
                      _this37.items[_matchItemIdx].audAges = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], item.influencer_details.audAges);
                      _this37.items[_matchItemIdx].audAgesDisplay = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this37.items[_matchItemIdx].audAges.splice(0, item.topAudAges.length));
                      _this37.items[_matchItemIdx].audAgesEdit = false;
                    }
                    if (field === 'topCountries') {
                      item.influencer_details.countries = __WEBPACK_IMPORTED_MODULE_31_lodash_sortBy___default()(item.influencer_details.countries, 'lineupIndex');
                      _this37.items[_matchItemIdx].countries = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], item.influencer_details.countries);
                      _this37.items[_matchItemIdx].topCountryDisplay = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this37.items[_matchItemIdx].countries.splice(0, item.topCountries.length));
                      _this37.items[_matchItemIdx].audCountryEdit = false;
                    }
                    if (field === 'gender') {
                      _this37.items[_matchItemIdx].genderEdit = false;
                      _this37.items[_matchItemIdx].influencer_details.gender = item.influencer_details.gender;
                    }
                    if (field === 'age_group') {
                      _this37.items[_matchItemIdx].ageGroupEdit = false;
                      _this37.items[_matchItemIdx].influencer_details.age_group = item.influencer_details.age_group;
                    }
                    tmp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this37.items);

                    _this37.items = [];
                    _this37.items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(tmp);
                  }
                }
                _this37.isLoading = false;

              case 63:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this37, [[13, 17, 21, 29], [22,, 24, 28], [39, 43, 47, 55], [48,, 50, 54]]);
      }))();
    },
    checkSelectLimit: function checkSelectLimit(item, field) {
      if (item[field].length > 2) {
        item[field].pop();
      }
    },
    resetData: function resetData() {
      this.infListTitle = 'Untitled';
      this.igHandle = '';
      this.items = [];
      this.selected = [];
    }
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cogs-summary',
  components: {
    InfluencerDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__editor_generator_blocksToHtml__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Influencer_SigningForm_ViewModalDialog__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Influencer_SigningForm_ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__Influencer_SigningForm_ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Pairing_CreatorConcept_ViewModalDialog__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Pairing_CreatorConcept_ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__Pairing_CreatorConcept_ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__UpdateCreatorEmailModal__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__UpdateCreatorEmailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__UpdateCreatorEmailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__UpdateSubmissionDateModal__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__UpdateSubmissionDateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__UpdateSubmissionDateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__EstimatedLiveDateModal__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__EstimatedLiveDateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__EstimatedLiveDateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SubmissionDateModal__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__SubmissionDateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__SubmissionDateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_loading_overlay_dist_vue_loading_css__);





































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'invoices-brief-confirmation',
  props: {
    viewCampaignID: String,
    isView: Boolean
  },
  components: {
    influencerDetailModal: __WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_21__scoped_custom_SocialHandle___default.a,
    ViewSigninFormModal: __WEBPACK_IMPORTED_MODULE_25__Influencer_SigningForm_ViewModalDialog___default.a,
    ViewCreatorConceptModalDialog: __WEBPACK_IMPORTED_MODULE_26__Pairing_CreatorConcept_ViewModalDialog___default.a,
    UpdateCreatorEmailModal: __WEBPACK_IMPORTED_MODULE_27__UpdateCreatorEmailModal___default.a,
    UpdateSubmissionDateModal: __WEBPACK_IMPORTED_MODULE_28__UpdateSubmissionDateModal___default.a,
    EstimatedLiveDateModal: __WEBPACK_IMPORTED_MODULE_29__EstimatedLiveDateModal___default.a,
    SubmissionDateModal: __WEBPACK_IMPORTED_MODULE_30__SubmissionDateModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_31_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      loading: false,
      utilsFunc: __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func,
      viewSigninFormData: {},
      viewContentScriptsData: {},
      viewSigninFormModalDialog: false,
      viewcontentScriptModalDialog: false,
      updateMultipleSubmissionDateDialog: false,
      influencerList: [],
      totalInfluencer: 0,
      search: '',
      briefConfirmationSearch: '',
      filter: '',
      options: {},
      snack: false,
      snackColor: '',
      snackText: '',
      amount: 0,
      dialog: false,
      influencer: '',
      influencerProfile: '',
      loadAllQuestoins: [],
      selectedTab: '',
      loadingDialog: false,
      briefDetailContent: {
        time: Date.now(),
        blocks: []
      },
      briefDetailsHTML: '',
      campaignList: [],

      campaignID: '',
      pairedID: '',
      pairedInfluencers: [],
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      },
      payoutStatusDisplay: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].payoutStatusDisplay,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].payoutStatus,
      pairingSendStatusDisplay: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingSendStatusDisplay,
      pairingSendStatus: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingSendStatus,
      invoiceDownload: false,
      isFinalPayout: false,
      copySucceeded: false,
      pairedHeaders: [{
        text: 'Handle',
        value: 'influencer_details.userHandle',
        width: '210px',
        class: 'invoice-handle-column',
        cellClass: 'invoice-handle-column'
      }, {
        text: 'Platform',
        value: 'platformName',
        width: '170px',
        class: 'invoice-platform-column',
        cellClass: 'invoice-platform-column'
      }, {
        text: 'Followers',
        value: 'followers'
      }, {
        text: 'Eng. Rate',
        value: 'engagement_rate'
      }, {
        text: 'Aud. Cred',
        value: 'audience_credibility'
      }, {
        text: 'Deliverable Details',
        value: 'deliverablesDisplay'
      }, {
        text: 'Payout Amount (Inclusive GST)',
        value: 'payoutAmount'
      }, {
        text: 'Payout Amount (Exclusive GST)',
        value: 'payoutAmountExclusive'
      }, {
        text: 'GST Amount',
        value: 'gstAmount'
      }, {
        text: 'Submission Date',
        value: 'submission_date'
      }, {
        text: 'Estimated Live Month',
        value: 'estimatedLiveMonth'
      }, {
        text: 'Creators Invoice, Contract & Brief',
        value: 'creatorInvoice'
      }, {
        text: 'Signing Form',
        value: 'signinForm'
      }, {
        text: 'Content Scripts Form',
        value: 'contentScriptForm'
      }, {
        text: 'Confirmation',
        value: 'confirmation'
      }, {
        text: 'Status',
        value: 'status'
      }],
      signinFormLink: '',
      conceptFormLink: '',
      viewPairingData: null,
      multiplePairings: null,
      updateCreatorEmailDialog: false,
      updateSubmissionDateDialog: false,
      updateEstimatedLiveDateDialog: false,
      allClients: [],
      selectedItems: []
    };
  },
  mounted: function mounted() {
    this.fetchCampaignList();
    this.getAllUsers();
    this.getAllClients();
    this.$store.dispatch('payment/getCurrencyRates');
  },

  watch: {
    campaignID: function campaignID(value) {
      this.$router.push({
        path: '/influencers/invoices-brief-confirmation',
        query: {
          id: value
        }
      });
      this.getPairedInfluencers(value, false);
    },
    viewCampaignID: function viewCampaignID(value) {
      this.pairedInfluencers = [];
      this.getPairedInfluencers(value, false);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_vuex__["b" /* mapState */])({
    requestedPayoutEdit: function requestedPayoutEdit(state) {
      return state.pairing.requestedPayoutEdit;
    },
    saved: function saved(state) {
      return state.pairing.saved;
    },
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    },
    infDetail: function infDetail(state) {
      return state.influencer.infDetail;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  }), {
    computedPairedHeaders: function computedPairedHeaders() {
      if (this.isView) {
        return this.pairedHeaders.filter(function (p) {
          return p.value !== 'creatorInvoice' && p.value !== 'confirmation' && p.value !== 'signinForm';
        });
      } else {
        return this.pairedHeaders;
      }
    },
    params: function params(nv) {
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, this.options);
    },
    currentUser: function currentUser() {
      return this.$store.state.user;
    },

    isAdmin: function isAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isCampaignAM: function isCampaignAM() {
      if (this.campaignCOEB.campaignId) {
        var matchUser = this.campaignCOEB.Users.find(function (u) {
          return u.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
        });
        if (matchUser) {
          return true;
        }
        return false;
      }
      return true;
    },
    isCampaignCC: function isCampaignCC() {
      if (this.campaignCOEB.campaignId) {
        var matchUser = this.campaignCOEB.Users.find(function (u) {
          return u.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST;
        });
        if (matchUser) {
          return true;
        }
        return false;
      }
      return true;
    },
    budget: function budget() {
      var _this = this;

      var campaignClient = this.allClients.find(function (client) {
        return client.id === _this.campaignCOEB.clientID;
      });
      var markupCOGSAmount = __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].getMarkupCOGS(this.campaignCOEB.ioNumbers, campaignClient);
      return markupCOGSAmount || Math.floor(this.campaignCOEB.budget * 0.26);
    },
    disableLockedCOGS: function disableLockedCOGS() {
      return this.campaignCOEB.lockedCOGS || false;
    },
    showLockBtn: function showLockBtn() {
      if (this.campaignCOEB.campaignId && !this.campaignCOEB.lockedCOGS && (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST)) {
        return true;
      }
      return false;
    }
  }),
  methods: {
    formatDeliverableCounts: function formatDeliverableCounts(value) {
      return String(value || '').replace(/X \(Twitter\) Post/g, 'XTP').replace(/(\d+(?:hrs)?) X /g, '$1 x ');
    },
    getFacebookHandle: function getFacebookHandle() {
      var influencerDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var facebook = influencerDetails.facebook && __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(influencerDetails.facebook) === 'object' ? influencerDetails.facebook : {};
      return influencerDetails.facebookHandle || influencerDetails.fbHandle || facebook.handle || facebook.facebookHandle || influencerDetails.facebookId || facebook.facebookId || influencerDetails.userHandle || influencerDetails.instagramHandle || '';
    },
    getPairedInfluencers: function getPairedInfluencers(campaignID) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var campaignResp, client, elements, Users, pairingResp, items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, inf, invitedItems, notInvitedItems;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isLoading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].getCampaign(campaignID);

              case 3:
                campaignResp = _context.sent;

                if (!campaignResp) {
                  _context.next = 26;
                  break;
                }

                if (!(campaignResp.campaignType === undefined)) {
                  _context.next = 11;
                  break;
                }

                _this2.$swal({
                  title: 'Error',
                  text: 'Invalid Campaign Type!',
                  type: 'error'
                }).then(function () {});
                _this2.$emit('confirmBrief');
                _this2.isLoading = false;
                _this2.$emit('closeBriefModal');
                return _context.abrupt('return', false);

              case 11:
                client = null;
                _context.prev = 12;
                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_14__Client_clientAPIs__["a" /* default */].getClient(campaignResp.clientID);

              case 15:
                client = _context.sent;
                _context.next = 24;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](12);
                elements = document.getElementsByClassName('vld-overlay');

                __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(elements).forEach(function (element) {
                  element.remove();
                });

                _this2.$swal({
                  title: 'Error',
                  text: 'Invalid Client!',
                  type: 'error'
                }).then(function () {
                  _this2.isLoading = false;
                  _this2.$emit('closeBriefModal');
                });
                return _context.abrupt('return', false);

              case 24:
                Users = _this2.Users.filter(function (c) {
                  return campaignResp.assignedTo && campaignResp.assignedTo.includes(c.id);
                });

                _this2.campaignCOEB = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                  campaignId: campaignResp.id,
                  campaignName: campaignResp.name,
                  companyID: campaignResp.companyID,
                  clientID: campaignResp.clientID,
                  ioNumbers: campaignResp.ioNumbers,
                  clientName: client.name,
                  Users: Users,
                  campaignOutreach: campaignResp.outreach,
                  campaignEngagement: campaignResp.engagement,
                  campaignBudget: campaignResp.budget,
                  max_content: campaignResp.max_content,
                  min_content: campaignResp.min_content,
                  outreach: campaignResp.outreach,
                  engagement: campaignResp.engagement,
                  budget: campaignResp.budget,
                  campaign_brief_details: campaignResp,
                  lockedCOGS: campaignResp.lockedCOGS
                });

              case 26:
                _context.next = 28;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID);

              case 28:
                pairingResp = _context.sent;

                if (!pairingResp) {
                  _context.next = 57;
                  break;
                }

                items = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 34;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(pairingResp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  inf = _this2.beautifyData(data);

                  if (inf.pairingStatus === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ACCEPTED) {
                    items.push(inf);
                  }
                }
                _context.next = 42;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context['catch'](34);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 42:
                _context.prev = 42;
                _context.prev = 43;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 45:
                _context.prev = 45;

                if (!_didIteratorError) {
                  _context.next = 48;
                  break;
                }

                throw _iteratorError;

              case 48:
                return _context.finish(45);

              case 49:
                return _context.finish(42);

              case 50:
                _this2.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], items);
                _this2.setMultipleInfs();
                _this2.campaignMeasurement(items);
                invitedItems = items.filter(function (e) {
                  return e.pairingStatus !== __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this2.campaignMeasurementInvited(invitedItems);

                notInvitedItems = items.filter(function (e) {
                  return e.pairingStatus === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this2.campaignMeasurementNotInvited(notInvitedItems);

              case 57:
                _this2.isLoading = false;

              case 58:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[12, 18], [34, 38, 42, 50], [43,, 45, 49]]);
      }))();
    },
    campaignMeasurement: function campaignMeasurement(items) {
      var _this3 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(function (item) {
        _this3.measurement.total += Number(_this3.calculateContents(item));
        _this3.measurement.outreach += Number(_this3.calculateOutreach(item));
        _this3.measurement.engagement += Number(_this3.calculateEngagement(item));
        var amt = Number(item.payout - (item.GSTpercent || 0) || 0);
        if (item.currency !== 'SGD') {
          var rate = _this3.currencyRates[item.currency];
          amt = Number(amt / rate).toFixed(2);
        }
        _this3.measurement.budget += Number(amt || 0);
      });
      var content = this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaignCOEB.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaignCOEB.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.campaignCOEB.budget * 100).toFixed(2);
    },
    campaignMeasurementInvited: function campaignMeasurementInvited(items) {
      var _this4 = this;

      this.measurement.invitedTotal = 0;
      items.map(function (item) {
        _this4.measurement.invitedTotal += Number(_this4.calculateContents(item));
        _this4.measurement.invitedOutreach += Number(_this4.calculateOutreach(item));
        _this4.measurement.invitedEngagement += Number(_this4.calculateEngagement(item));
        _this4.measurement.invitedBudget += Number(item.payout || 0);
      });
    },
    campaignMeasurementNotInvited: function campaignMeasurementNotInvited(items) {
      var _this5 = this;

      this.measurement.notInvitedTotal = 0;
      items.map(function (item) {
        _this5.measurement.notInvitedTotal += Number(_this5.calculateContents(item));
        _this5.measurement.notInvitedOutreach += Number(_this5.calculateOutreach(item));
        _this5.measurement.notInvitedEngagement += Number(_this5.calculateEngagement(item));
        _this5.measurement.notInvitedBudget += Number(item.payout || 0);
      });
    },
    getInfluencer: function getInfluencer() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.pairedID = _this6.$route.params.pairedID;

                if (!_this6.pairedID) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencer(_this6.pairedID);

              case 4:
                response = _context2.sent;

                _this6.viewClick(response.items);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    loadQuestions: function loadQuestions(campaignID, userID) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var allQuestions, questionArray, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, questionObj;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getQuestions(campaignID, userID);

              case 2:
                allQuestions = _context3.sent;
                questionArray = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 7;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(allQuestions); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  questionObj = _step2.value;

                  questionArray.push(questionObj);
                }
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 15:
                _context3.prev = 15;
                _context3.prev = 16;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 18:
                _context3.prev = 18;

                if (!_didIteratorError2) {
                  _context3.next = 21;
                  break;
                }

                throw _iteratorError2;

              case 21:
                return _context3.finish(18);

              case 22:
                return _context3.finish(15);

              case 23:
                _this7.loadAllQuestoins = questionArray;

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[7, 11, 15, 23], [16,, 18, 22]]);
      }))();
    },
    formatPayout: function formatPayout(n) {
      if (n.toString().indexOf('-') !== -1) {
        var str = n.toString().split('-');
        return __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.formatCurrency(parseFloat(str[0])) + ' - ' + str[1];
      } else {
        return __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.formatCurrency(parseFloat(n));
      }
    },
    UpdatePayout: function UpdatePayout(id, payout) {
      var _this8 = this;

      var params = {
        'pairedID': id,
        'amount': payout
      };
      __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].updatePayoutById(params).then(function (res) {
        _this8.snack = true;
        _this8.snackColor = 'success';
        _this8.snackText = 'Updated Payout to: ' + payout;
      });
    },
    onKeyPressHandle: function onKeyPressHandle(event) {
      if (event.key === 'Enter') {
        if (this.search) this.searchClick();else this.loadInfluencerData();
      }
    },
    onChangeHandle: function onChangeHandle(event) {
      if (event.target.value === '') {
        this.loadInfluencerData();
      }
    },
    fetchPairedInfluencerFromAPI: function fetchPairedInfluencerFromAPI(page, limit) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var userID, influencer;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userID = void 0;

                if (_this9.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST || _this9.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
                  userID = _this9.currentUser.id;
                }
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getAllPairedInfluencer(userID, page, limit);

              case 4:
                influencer = _context4.sent;
                return _context4.abrupt('return', influencer);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    searchClick: function searchClick() {
      var _this10 = this;

      if (this.search) {
        this.loading = true;
        var userID = void 0;
        var search = this.search.trim().toLowerCase();
        if (this.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
          userID = this.currentUser.id;
        }
        __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getAllPairedInfluencer(userID).then(function (data) {
          if (search) {
            data.items = data.items.filter(function (item) {
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(item).join(',').toLowerCase().includes(search);
            });
          }
          _this10.influencerList = data.items;
          _this10.totalInfluencer = data.items.length;
          _this10.loading = false;
        });
      } else this.loadInfluencerData();
    },
    loadInfluencerData: function loadInfluencerData() {
      this.getPairedInfluencers(this.campaignID);
      this.loadingDialog = false;
      this.multiplePairings = [];
      this.selectedItems = [];
    },
    prepareDataTable: function prepareDataTable() {
      var _this11 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _options = _this11.options,
            sortBy = _options.sortBy,
            sortDesc = _options.sortDesc,
            page = _options.page,
            itemsPerPage = _options.itemsPerPage;

        _this11.fetchPairedInfluencerFromAPI(page, itemsPerPage).then(function (data) {
          if (_this11.options.sortBy) {
            data.items = data.items.sort(function (a, b) {
              var sortA = a[sortBy[0]];
              var sortB = b[sortBy[0]];

              if (sortDesc[0]) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }

          var total = data.totalRows;
          setTimeout(function () {
            resolve({ items: data.items, total: total });
          }, 300);
        });
      });
    },
    getStatusColor: function getStatusColor(status) {
      if (status) {
        if (status === this.pairingStatus.INVITED.value) {
          return 'orange';
        } else if (status === this.pairingStatus.INTERESTED.value) {
          return '#81C784';
        } else if (status === this.pairingStatus.NOT_INTERESTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.ACCEPTED.value) {
          return '#66BB6A';
        } else if (status === this.pairingStatus.NOT_ACCEPTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.INQUIRY.value) {
          return '#1E88E5';
        } else return 'white';
      }
    },
    payoutStatusColor: function payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return '';
      } else if (status === this.payoutStatus.INCOMPLETE) {
        return 'warning';
      } else {
        return 'green';
      }
    },
    getUserByInfluencer: function getUserByInfluencer(id) {
      var _this12 = this;

      var param = {
        'influencerID': id
      };
      __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getUserByInfluencer(param).then(function (res) {
        _this12.influencerProfile = res;
      });
    },
    preSelectTabs: function preSelectTabs(status) {
      if (status === this.pairingStatus.INQUIRY.value) {
        this.selectedTab = 1;
      } else {
        this.selectedTab = 0;
      }
    },
    preparedViewItem: function preparedViewItem(item, type) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var oldData, blocksTohtml;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (item.influencerID) {
                  _this13.getUserByInfluencer(item.influencerID);
                }
                _this13.influencer = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);

                if (!(item.brief_details && item.brief_details.contentHTML !== undefined && item.brief_details.contentHTML !== null)) {
                  _context5.next = 6;
                  break;
                }

                _this13.briefDetailsHTML = item.brief_details.contentHTML;
                _this13.selectedTab = type;
                return _context5.abrupt('return');

              case 6:
                oldData = false;

                if (!(item.brief_details && item.brief_details.content !== undefined && item.brief_details.content !== '' && item.brief_details.content.length > 0)) {
                  _context5.next = 12;
                  break;
                }

                _this13.briefDetailContent.blocks = item.brief_details.content;
                oldData = true;
                _context5.next = 15;
                break;

              case 12:
                _context5.next = 14;
                return __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].generateBlocks(item);

              case 14:
                _this13.briefDetailContent.blocks = _context5.sent;

              case 15:
                blocksTohtml = new __WEBPACK_IMPORTED_MODULE_20__editor_generator_blocksToHtml__["a" /* default */](_this13.briefDetailContent.blocks);

                _this13.briefDetailsHTML = blocksTohtml.generate(oldData);
                _this13.selectedTab = type;

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this13);
      }))();
    },
    viewClick: function viewClick(item, type) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var blocksTohtml, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(type === 2 && item.brief_details === undefined)) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].generateBlocks(item);

              case 3:
                _this14.briefDetailContent.blocks = _context6.sent;
                blocksTohtml = new __WEBPACK_IMPORTED_MODULE_20__editor_generator_blocksToHtml__["a" /* default */](_this14.briefDetailContent.blocks);

                _this14.briefDetailsHTML = blocksTohtml.generate(false);
                data = {
                  pairingID: item.id,
                  userID: _this14.currentUser.id,
                  contentHTML: _this14.briefDetailsHTML
                };
                _context6.next = 9;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].updatePairingBriefDetails(data);

              case 9:
                item.brief_details = {
                  userID: _this14.currentUser.id,
                  contentHTML: _this14.briefDetailsHTML
                };

              case 10:
                _this14.invoiceDownload = false;
                _context6.next = 13;
                return _this14.preparedViewItem(item, type);

              case 13:
                _this14.selectedTab = type;
                _this14.dialog = true;

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this14);
      }))();
    },
    confirmPayout: function confirmPayout(item) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var pairedResp, payload, confirmPayoutBlock, message;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this15.isLoading = true;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencer(item.id);

              case 3:
                pairedResp = _context9.sent;

                if (!pairedResp.items) {
                  _context9.next = 9;
                  break;
                }

                if (!pairedResp.items.id) {
                  _context9.next = 9;
                  break;
                }

                if (!(pairedResp.items.status !== __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].pairingStatus.ACCEPTED)) {
                  _context9.next = 9;
                  break;
                }

                _this15.$swal({
                  type: 'warning',
                  text: 'Please accept influencer for pairing.'
                });
                return _context9.abrupt('return');

              case 9:
                payload = _this15.getRptOwnerCheckPayload(item);
                _context9.next = 12;
                return __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].invokeReportOwnerCheck(_this15, payload);

              case 12:
                confirmPayoutBlock = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.confirmPayout;
                message = confirmPayoutBlock.html;

                _this15.isFinalPayout = false;

                _this15.isLoading = false;
                if (_this15.checkFinalPayoutConfirm(item)) {
                  _this15.$swal({
                    title: confirmPayoutBlock.title,
                    html: message,
                    confirmButtonText: confirmPayoutBlock.confirmButtonText,
                    type: 'info',
                    showCancelButton: true,
                    showCloseButton: true
                  }).then(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(result) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              if (!result.value) {
                                _context7.next = 7;
                                break;
                              }

                              _this15.invoiceDownload = true;
                              _this15.isFinalPayout = true;
                              _context7.next = 5;
                              return _this15.preparedViewItem(item, -1);

                            case 5:
                              _this15.selectedTab = -1;
                              _this15.dialog = true;

                            case 7:
                            case 'end':
                              return _context7.stop();
                          }
                        }
                      }, _callee7, _this15);
                    }));

                    return function (_x2) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                } else {
                  _this15.$swal({
                    title: confirmPayoutBlock.title,
                    html: message,
                    confirmButtonText: confirmPayoutBlock.confirmButtonText,
                    type: 'info',
                    showCancelButton: true,
                    showCloseButton: true
                  }).then(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8(result) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              if (!result.value) {
                                _context8.next = 6;
                                break;
                              }

                              _this15.invoiceDownload = true;
                              _context8.next = 4;
                              return _this15.preparedViewItem(item, -1);

                            case 4:
                              _this15.selectedTab = -1;
                              _this15.dialog = true;

                            case 6:
                            case 'end':
                              return _context8.stop();
                          }
                        }
                      }, _callee8, _this15);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }

              case 17:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this15);
      }))();
    },
    cancelPayout: function cancelPayout(item) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var cancelPayoutBlock, message;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                cancelPayoutBlock = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.cancelPayout;
                message = cancelPayoutBlock.html;

                _this16.$swal({
                  title: cancelPayoutBlock.title,
                  html: message,
                  confirmButtonText: cancelPayoutBlock.confirmButtonText,
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10(result) {
                    var reasonText;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            if (!result.value) {
                              _context10.next = 11;
                              break;
                            }

                            _this16.loadingDialog = true;
                            reasonText = document.getElementById('cancel-payout-reason').value;

                            if (reasonText) {
                              _context10.next = 7;
                              break;
                            }

                            _this16.loadingDialog = false;
                            _this16.cancelPayout(item);
                            return _context10.abrupt('return', false);

                          case 7:
                            _context10.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].cancelAdminPayout(item.id, reasonText);

                          case 9:
                            _this16.loadingDialog = false;
                            _this16.loadInfluencerData();

                          case 11:
                          case 'end':
                            return _context10.stop();
                        }
                      }
                    }, _callee10, _this16);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this16);
      }))();
    },
    closeModal: function closeModal() {
      this.selectedTab = '';
      this.dialog = false;
    },
    loadInfluencerDataForBriefDetails: function loadInfluencerDataForBriefDetails() {
      var _this17 = this;

      this.prepareDataTable().then(function (data) {
        _this17.influencerList = data.items;
        _this17.totalInfluencer = data.total;
      });
    },
    loadingDialogOpen: function loadingDialogOpen() {
      this.loadingDialog = true;
    },
    loadingDialogClose: function loadingDialogClose() {
      this.loadingDialog = false;
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_xhs_posts;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_xhs_posts);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_reels + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_xhs_posts);
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};

      inf.influencer_details = influencerDetails;
      inf.contact_details = influencerDetails.contact_details;
      inf.pairing_details = data.pairing_details;
      inf.elimination_details = data.elimination_details;
      inf.influencerID = influencerDetails.influencerID || null;
      inf.pairingStatus = data.pairing_details.status;
      inf.status = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.Users = this.campaignCOEB ? this.campaignCOEB.Users : [];
      inf.campaign_brief_details = this.campaignCOEB.campaign_brief_details;
      inf.id = data.id;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.no_of_xhs_posts = deliverablesDetails.no_of_xhs_posts || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.signinForm = data.signinForm || null;
      inf.contentScriptForm = data.contentScriptForm || false;
      inf.deliverables = deliverablesDetails;
      inf.deliverablesDisplay = __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].getDeliverableDetails(deliverablesDetails);
      inf.sentStatus = influencerDetails.sentStatus || 0;
      inf.platform = influencerDetails.platform || 'instagram';
      inf.platformName = inf.influencer_details.platformName || inf.platform;
      if (!inf.userHandle) inf.userHandle = inf.influencer_details.instagramHandle;
      if (!inf.influencer_details.userHandle) inf.influencer_details.userHandle = inf.influencer_details.instagramHandle;
      if (inf.platform === 'linkedin') {
        var linkedinHandle = inf.influencer_details.linkedinHandle || inf.influencer_details.userHandle || inf.influencer_details.instagramHandle;
        inf.userHandle = linkedinHandle;
        inf.influencer_details.userHandle = linkedinHandle;
        inf.influencer_details.linkedinHandle = linkedinHandle;
      }
      if (inf.platform === 'twitter') {
        var xHandle = inf.influencer_details.twitterHandle || inf.influencer_details.userHandle || inf.influencer_details.instagramHandle;
        inf.userHandle = xHandle;
        inf.influencer_details.userHandle = xHandle;
        inf.influencer_details.twitterHandle = xHandle;
      }
      if (inf.platform === 'facebook') {
        var facebookHandle = this.getFacebookHandle(inf.influencer_details);
        inf.userHandle = facebookHandle;
        inf.influencer_details.userHandle = facebookHandle;
        inf.influencer_details.facebookHandle = facebookHandle;
      }
      if (inf.platform && inf.platform === 'xiaohongshu') {
        inf.userHandle = inf.fullName;
        inf.xhsID = inf.xhsID;
      }
      if (data.payout_details) {
        inf.payout_details = data.payout_details;
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.GSTIncluded = data.payout_details.GSTpercent || false;
        inf.GSTpercent = data.payout_details.GSTpercent;
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? __WEBPACK_IMPORTED_MODULE_22_lodash_reverse___default()(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        inf.currency = data.payout_details.currency || 'SGD';
        if (inf.currency !== 'SGD') {
          inf.sgdAmt = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.convertCurrency(inf.currency, inf.payoutAmount, this.currencyRates);
        }
        inf.payout_details.boostingFees = data.payout_details.boostingFees || [];
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details;
      }
      if (data.previousSigninForm) {
        inf.previousSigninForm = data.previousSigninForm;
      }
      if (!inf.previousSigninForm) {
        if (inf.signinForm) {
          inf.previousSigninForm = [inf.signinForm];
        }
      }
      return inf;
    },
    getAllUsers: function getAllUsers() {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST).then(function (response) {
        _this18.Users = response.users;
        _this18.Users = response.users.map(function (user) {
          user.name = user.firstName + ' ' + user.lastName;
          return user;
        });
        _this18.getAllAMUsers();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getAllAMUsers: function getAllAMUsers() {
      var _this19 = this;

      __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (response) {
        response.users.map(function (user) {
          user.name = user.firstName + ' ' + user.lastName;
          _this19.Users.push(user);
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this20 = this;

      __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
        var campaigns = response;
        campaigns = campaigns.filter(function (c) {
          return c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.ONGOING || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.REVIEW || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.COMPLETE;
        });

        _this20.campaignList = campaigns.map(function (element) {
          return {
            name: element.ioNumbers ? element.ioNumbers + ' - ' + element.name : element.name,
            id: element.id,
            lockedCOGS: element.lockedCOGS || false
          };
        });

        if (_this20.$route.query.id) {
          _this20.campaignID = _this20.$route.query.id;
        }
      }).catch(function (err) {
        console.log('Error:' + err);
      });
    },
    getRptOwnerCheckPayload: function getRptOwnerCheckPayload(item) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
        campaignID: item.CampaignID,
        handle: item.influencer_details ? item.influencer_details.twitterHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle : null,
        platform: item.influencer_details ? item.influencer_details.platform : null
      });
    },
    formatSubmissionDate: function formatSubmissionDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_24_moment___default()(date).format('DD/MM/yyyy') : 'Empty!';
    },
    formatLiveMonth: function formatLiveMonth(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_24_moment___default()(date).format('MM/yyyy') : 'Empty!';
    },
    displayGSTText: function displayGSTText(item) {
      return '$' + (item.payoutAmount - item.GSTpercent) + ' + $' + item.GSTpercent + ' (GST)';
    },
    checkFinalPayoutConfirm: function checkFinalPayoutConfirm(item) {
      var _this21 = this;

      var unConfirmed = this.pairedInfluencers.filter(function (p) {
        return p.id !== item.id && p.payout_details.status !== _this21.payoutStatus.CONFIRMED;
      }).length;
      if (Number(this.measurement.total) < Number(this.campaignCOEB.min_content) || unConfirmed) {
        return false;
      }
      return true;
    },
    openLockedCOGSDialog: function openLockedCOGSDialog(item) {
      var _this22 = this;

      this.$swal({
        title: 'Send Unlock Request',
        html: 'Are you sure to send request to unlock COGS?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12(result) {
          var reqData;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (!result.value) {
                    _context12.next = 5;
                    break;
                  }

                  reqData = {
                    campaignID: item.campaignId
                  };
                  _context12.next = 4;
                  return _this22.$store.dispatch('pairing/requestPayoutEdit', reqData);

                case 4:
                  if (_this22.requestedPayoutEdit) {
                    _this22.$swal({
                      text: 'Successfully Requested.',
                      type: 'success'
                    });
                  }

                case 5:
                case 'end':
                  return _context12.stop();
              }
            }
          }, _callee12, _this22);
        }));

        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    changeLock: function changeLock(item, status) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var lockTxt;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                lockTxt = status ? 'Lock' : 'Unlock';

                _this23.$swal({
                  title: 'Are you sure to ' + lockTxt + '?',
                  icon: 'warning',
                  confirmButtonText: lockTxt,
                  showCancelButton: true
                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13(result) {
                    var updateObj, updateData;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            if (!result.value) {
                              _context13.next = 11;
                              break;
                            }

                            updateObj = {
                              id: item.campaignId,
                              lockedCOGS: status
                            };

                            if (status === false) {
                              updateObj.unlockCogsEmail = true;
                            }
                            updateData = [updateObj];
                            _context13.next = 6;
                            return _this23.$store.dispatch('campaign/updateCampaignByIds', updateData);

                          case 6:
                            if (_this23.campaignUpdated) {
                              _context13.next = 9;
                              break;
                            }

                            _this23.$swal({
                              text: 'Error Campaign Update.',
                              type: 'error'
                            });
                            return _context13.abrupt('return');

                          case 9:
                            _this23.$swal({
                              text: 'Successfully ' + lockTxt + 'ed.',
                              type: 'success'
                            });
                            item.lockedCOGS = status;

                          case 11:
                            _this23.loadInfluencerData();

                          case 12:
                          case 'end':
                            return _context13.stop();
                        }
                      }
                    }, _callee13, _this23);
                  }));

                  return function (_x6) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this23);
      }))();
    },
    copySignInFormLink: function copySignInFormLink(pairing) {
      this.copySucceeded = true;
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.signinFormLink = protocol + '//' + host + __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].SIGNING_IN_FORM_URL + '/' + pairing.id;
      setTimeout(function () {
        pairing.linkCopied = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.copyToClipboard('#copy-link');
      }, 100);
    },
    copyContentScriptFormLink: function copyContentScriptFormLink(pairing) {
      this.copySucceeded = true;
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.conceptFormLink = protocol + '//' + host + '/influencers/content-storyboard/' + pairing.id;
      setTimeout(function () {
        pairing.linkCopied = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.copyToClipboard('#copy-concept-link');
      }, 100);
    },
    getSigninDataToView: function getSigninDataToView(viewData) {
      this.viewSigninFormData = viewData;
      this.viewSigninFormModalDialog = true;
    },
    downloadSigningPDF: function downloadSigningPDF(signingForm) {
      if (signingForm.contractFile) {
        window.open(signingForm.contractFile.url, '_blank');
      }
    },
    signingFormsForDownload: function signingFormsForDownload(item) {
      var previousForms = item && Array.isArray(item.previousSigninForm) ? item.previousSigninForm.slice().reverse() : [];
      var forms = [item && item.signinForm].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(previousForms));
      var seenUrls = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      return forms.filter(function (form) {
        var url = form && form.contractFile && form.contractFile.url;
        if (!url || seenUrls.has(url)) {
          return false;
        }
        seenUrls.add(url);
        return true;
      });
    },
    openUpdateEmailDialog: function openUpdateEmailDialog(item) {
      this.viewPairingData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);
      this.updateCreatorEmailDialog = true;
    },
    openUpdateSubmissionDialog: function openUpdateSubmissionDialog(item) {
      this.viewPairingData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);
      this.updateSubmissionDateDialog = true;
    },
    openEstimatedLiveDateDialog: function openEstimatedLiveDateDialog(item) {
      this.multiplePairings = [];
      this.viewPairingData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);
      this.updateEstimatedLiveDateDialog = true;
    },
    openMultipleEstimatedLiveDateDialog: function openMultipleEstimatedLiveDateDialog() {
      this.multiplePairings = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.selectedItems);
      this.updateEstimatedLiveDateDialog = true;
    },
    openMultipleSubmissionDateDialog: function openMultipleSubmissionDateDialog() {
      this.multiplePairings = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.selectedItems);
      this.updateMultipleSubmissionDateDialog = true;
    },
    refreshPairingInfFromIMS: function refreshPairingInfFromIMS(item) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var campaignID;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this24.loadingDialog = true;
                campaignID = item.campaignId;
                _context15.next = 4;
                return _this24.getPairedInfluencers(campaignID);

              case 4:
                _this24.loadingDialog = false;

              case 5:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this24);
      }))();
    },
    getAllClients: function getAllClients() {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__Client_clientAPIs__["a" /* default */].getAllClients(false);

              case 2:
                response = _context16.sent;

                _this25.allClients = response.data;

              case 4:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this25);
      }))();
    },
    cancelAccept: function cancelAccept(item) {
      var _this26 = this;

      this.$swal({
        title: 'Cancel Accept',
        html: 'Are you sure to cancel accept?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17(result) {
          var reqData;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  if (!result.value) {
                    _context17.next = 5;
                    break;
                  }

                  reqData = {
                    id: item.id
                  };
                  _context17.next = 4;
                  return _this26.$store.dispatch('pairing/cancelPairingStatus', reqData);

                case 4:
                  if (_this26.saved) {
                    _this26.$swal({
                      text: 'Successfully Canceled Accept.',
                      type: 'success'
                    });
                    _this26.getPairedInfluencers(_this26.campaignID);
                  }

                case 5:
                case 'end':
                  return _context17.stop();
              }
            }
          }, _callee17, _this26);
        }));

        return function (_x7) {
          return _ref6.apply(this, arguments);
        };
      }());
    },
    viewContentScriptDialog: function viewContentScriptDialog(id) {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getContentScriptByPairingID(id);

              case 2:
                _this27.viewContentScriptsData = _context18.sent;

                if (!_this27.viewContentScriptsData) {
                  _this27.$swal({
                    text: 'No Content Scripts Data.',
                    type: 'warning'
                  });
                }
                _this27.viewcontentScriptModalDialog = true;
                console.log('content script dialog');

              case 6:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this27);
      }))();
    },
    setMultipleInfs: function setMultipleInfs() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item, infs, facebookHandle;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context19.prev = 3;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this28.pairedInfluencers);

              case 5:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context19.next = 23;
                  break;
                }

                item = _step3.value;

                if (item.influencerID) {
                  _context19.next = 9;
                  break;
                }

                return _context19.abrupt('continue', 20);

              case 9:
                infs = [];
                _context19.next = 12;
                return _this28.$store.dispatch('influencer/getInfluencerDetail', {
                  id: item.influencerID
                });

              case 12:
                if (_this28.infDetail.instagram) {
                  infs.push({
                    handle: _this28.infDetail.instagram.instagramHandle,
                    instagramID: _this28.infDetail.instagram.instagramID,
                    picture: _this28.infDetail.audience ? _this28.infDetail.audience.user_profile.picture : _this28.infDetail.instagram.picture,
                    instagram: true,
                    platform: 'instagram'
                  });
                }
                if (_this28.infDetail.tiktok) {
                  infs.push({
                    handle: _this28.infDetail.tiktok.tiktokHandle,
                    tiktokID: _this28.infDetail.tiktok.tiktokID,
                    picture: _this28.infDetail.tiktokaudience ? _this28.infDetail.tiktokaudience.user_profile.picture : _this28.infDetail.tiktok.picture,
                    tiktok: true,
                    platform: 'tiktok'
                  });
                }
                if (_this28.infDetail.youtube) {
                  infs.push({
                    handle: _this28.infDetail.youtube.youtubeHandle,
                    youtubeID: _this28.infDetail.youtube.youtubeID,
                    picture: _this28.infDetail.youtubeaudience ? _this28.infDetail.youtubeaudience.user_profile.picture : _this28.infDetail.youtube.picture,
                    youtube: true,
                    platform: 'youtube'
                  });
                }
                if (_this28.infDetail.xiaohongshu) {
                  infs.push({
                    handle: _this28.infDetail.xiaohongshu.xhsHandle,
                    xhsID: _this28.infDetail.xiaohongshu.xhsID,
                    picture: _this28.infDetail.xiaohongshu ? _this28.infDetail.xiaohongshu.profilePicture : '',
                    xhs: true,
                    platform: 'xiaohongshu'
                  });
                }
                if (_this28.infDetail.facebook) {
                  facebookHandle = _this28.infDetail.facebook.handle || _this28.infDetail.facebook.facebookHandle || _this28.infDetail.facebook.facebookId || '';

                  infs.push({
                    handle: facebookHandle,
                    xhsID: _this28.infDetail.facebook.facebookId,
                    picture: _this28.infDetail.facebook ? _this28.infDetail.facebook.profilePicture : '',
                    facebook: true,
                    platform: 'facebook'
                  });
                  if (item.influencer_details.platform === 'facebook' && facebookHandle) {
                    _this28.$set(item.influencer_details, 'facebookHandle', facebookHandle);
                    _this28.$set(item.influencer_details, 'userHandle', facebookHandle);
                    _this28.$set(item, 'userHandle', facebookHandle);
                  }
                }
                if (_this28.infDetail.linkedin) {
                  infs.push({
                    handle: _this28.infDetail.linkedin.linkedinHandle,
                    picture: '',
                    linkedin: true,
                    platform: 'linkedin'
                  });
                }
                if (_this28.infDetail.twitter) {
                  infs.push({
                    handle: _this28.infDetail.twitter.twitterHandle,
                    picture: '',
                    twitter: true,
                    platform: 'twitter'
                  });
                }
                item.multipleInfs = infs;

              case 20:
                _iteratorNormalCompletion3 = true;
                _context19.next = 5;
                break;

              case 23:
                _context19.next = 29;
                break;

              case 25:
                _context19.prev = 25;
                _context19.t0 = _context19['catch'](3);
                _didIteratorError3 = true;
                _iteratorError3 = _context19.t0;

              case 29:
                _context19.prev = 29;
                _context19.prev = 30;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 32:
                _context19.prev = 32;

                if (!_didIteratorError3) {
                  _context19.next = 35;
                  break;
                }

                throw _iteratorError3;

              case 35:
                return _context19.finish(32);

              case 36:
                return _context19.finish(29);

              case 37:
                _this28.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this28.pairedInfluencers);

              case 38:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this28, [[3, 25, 29, 37], [30,, 32, 36]]);
      }))();
    },
    selectAllItems: function selectAllItems($event) {
      if (!$event.value) {
        this.items = this.pairedInfluencers.map(function (i) {
          i.isSelected = false;return i;
        });
      } else {
        this.pairedInfluencers = this.pairedInfluencers.map(function (i) {
          i.isSelected = true;
          return i;
        });
      }
      this.actionSelectChange();
    },
    actionSelectChange: function actionSelectChange() {
      this.selectedItems = this.pairedInfluencers.filter(function (i) {
        return i.isSelected;
      });
    }
  }
});

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoicesBriefConfirmation_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InvoicesBriefConfirmation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InvoicesBriefConfirmation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdateCampaignQuarterModal__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdateCampaignQuarterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UpdateCampaignQuarterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvoicesBriefViewModal',
  components: {
    InvoicesBriefConfirmation: __WEBPACK_IMPORTED_MODULE_3__InvoicesBriefConfirmation_vue___default.a,
    UpdateCampaignQuarterModal: __WEBPACK_IMPORTED_MODULE_4__UpdateCampaignQuarterModal___default.a
  },
  props: {
    value: Boolean,
    campaignID: String
  },
  data: function data() {
    return {
      isLoading: false,
      campaignQuarterDialog: false,
      viewCampaignID: ''
    };
  },

  watch: {
    campaignID: function campaignID(value) {
      this.viewCampaignID = value;
    }
  },
  methods: {
    confirmBrief: function confirmBrief() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].changeStatus(this.viewCampaignID, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].campaignStatus.REVIEW).then(function (response) {
        if (response.success) {
          _this.$emit('updated', true);
          _this.$emit('input');
          _this.$swal({
            title: 'Success',
            text: 'Campaign Status Changed. Do you want to go to updated stage?',
            type: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, Stay here'
          }).then(function (result) {
            if (result.value) {
              _this.$router.push({ name: _this.displayStatus(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].campaignStatus.REVIEW) });
            } else {
              _this.$emit('reload');
            }
          });
        } else {
          _this.$swal('Campaign Status Changed Failed');
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    openUpdateCampaignQuarterModal: function openUpdateCampaignQuarterModal() {
      var _this2 = this;

      this.$swal({
        title: 'Push to Review',
        html: 'Are you sure you want to push to review stage',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (result.value) {
                    _this2.campaignQuarterDialog = true;
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    displayStatus: function displayStatus(status) {
      return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].campaignStatusDisplay[status]['display'] + ' campaigns';
    },

    closeModal: function closeModal() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PayoutConfirmModal__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PayoutConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__PayoutConfirmModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_reverse__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PairedInfAdminViewDialog',
  props: ['value', 'campaign', 'clients'],
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle___default.a,
    PayoutConfirmModal: __WEBPACK_IMPORTED_MODULE_12__PayoutConfirmModal___default.a
  },
  data: function data() {
    return {
      payoutStatus: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].payoutStatus,
      payoutStatusDisplay: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].payoutStatusDisplay,
      pairedHeaders: [{
        text: 'Handle',
        value: 'instagramHandle'
      }, {
        text: 'Followers',
        value: 'followers'
      }, {
        text: 'Eng. Rate',
        value: 'engagement_rate'
      }, {
        text: 'Aud. Cred',
        value: 'audience_credibility'
      }, {
        text: 'Deliverable Details',
        value: 'deliverables'
      }, {
        text: 'Status',
        value: 'payoutStatus'
      }, {
        text: 'Payout Amount',
        value: 'payoutAmount'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      pairedInfluencers: [],
      pairedFilterItems: [],
      pairedFilter: {
        payoutStatus: '',
        search: ''
      },
      payoutConfirmDialog: false,
      payoutConfirmData: {},
      influencer: '',
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      }
    };
  },

  computed: {
    campaignStatus: function campaignStatus() {
      return this.$route.meta.campaignStatus;
    },
    showConfirmPayout: function showConfirmPayout() {
      return __WEBPACK_IMPORTED_MODULE_8__campaignHelper__["a" /* default */].isAOKCampaign(this.campaignCOEB.campaignType);
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isNotClientRole: function isNotClientRole() {
      return Number(this.$store.state.user.role) !== __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.CLIENT;
    },
    payoutStatusOptions: function payoutStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.payoutStatusDisplay).forEach(function (item) {
        data.push({
          status: item[0],
          display: item[1]
        });
      });
      data.unshift({
        status: '',
        display: 'All'
      });
      return data;
    },
    budget: function budget() {
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaignCOEB.budget * 0.3);
    },
    markupCOGSAmount: function markupCOGSAmount() {
      var _this = this;

      var campaignClient = this.clients.find(function (client) {
        return client.id === _this.campaignCOEB.clientID;
      });
      return __WEBPACK_IMPORTED_MODULE_8__campaignHelper__["a" /* default */].getMarkupCOGS(this.campaignCOEB.ioNumbers, campaignClient);
    }
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        this.pairedInfluencers = [];
        this.pairedFilterItems = [];
        this.getPairedInfluencers(this.campaign);
      }
    }
  },
  methods: {
    getPairedInfluencers: function getPairedInfluencers(campaign) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var campaignResp, pairingResp, items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, inf, invitedItems, notInvitedItems;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__campaignAPIs__["a" /* default */].getCampaign(campaign.id);

              case 2:
                campaignResp = _context.sent;

                if (campaignResp) {
                  _this2.campaignCOEB = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
                    id: campaignResp.id,
                    campaignId: campaignResp.id,
                    campaignName: campaignResp.name,
                    campaignType: campaignResp.campaignType,
                    companyID: campaignResp.companyID,
                    clientID: campaignResp.clientID,
                    ioNumbers: campaignResp.ioNumbers,
                    campaignOutreach: campaignResp.outreach,
                    campaignEngagement: campaignResp.engagement,
                    campaignBudget: campaignResp.budget,
                    max_content: campaignResp.max_content,
                    min_content: campaignResp.min_content,
                    outreach: campaignResp.outreach,
                    engagement: campaignResp.engagement,
                    budget: campaignResp.budget
                  });
                }
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaign.id);

              case 6:
                pairingResp = _context.sent;

                if (!pairingResp) {
                  _context.next = 35;
                  break;
                }

                items = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 12;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(pairingResp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  inf = _this2.beautifyData(data);

                  if (inf.pairingStatus === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].pairingStatus.ACCEPTED) {
                    items.push(inf);
                  }
                }
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 20:
                _context.prev = 20;
                _context.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context.prev = 23;

                if (!_didIteratorError) {
                  _context.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context.finish(23);

              case 27:
                return _context.finish(20);

              case 28:
                _this2.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], items);
                _this2.campaignMeasurement(items);
                invitedItems = items.filter(function (e) {
                  return e.pairingStatus !== __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this2.campaignMeasurementInvited(invitedItems);

                notInvitedItems = items.filter(function (e) {
                  return e.pairingStatus === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this2.campaignMeasurementNotInvited(notInvitedItems);
                _this2.pairingSearchFilter();

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[12, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};
      inf = data.influencer_details;
      inf.influencer_details = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.refreshJSON(influencerDetails);
      inf.pairing_details = data.pairing_details;
      inf.elimination_details = data.elimination_details;
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.pairingID = data.id;
      inf.id = data.id;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = __WEBPACK_IMPORTED_MODULE_8__campaignHelper__["a" /* default */].getDeliverableDetails(deliverablesDetails);
      if (!inf.userHandle) {
        inf.userHandle = inf.instagramHandle;
        inf.influencer_details.userHandle = inf.instagramHandle;
      }
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? __WEBPACK_IMPORTED_MODULE_14_lodash_reverse___default()(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        if (inf.payoutStatus === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].payoutStatus.SUBMITTED) {
          inf.payoutSubmitted = true;
        }
        if (inf.payoutStatus >= __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].payoutStatus.CONFIRMED) {
          inf.payoutVerified = true;
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details;
      }
      return inf;
    },
    campaignMeasurement: function campaignMeasurement(items) {
      var _this3 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(function (item) {
        _this3.measurement.total += Number(_this3.calculateContents(item));
        _this3.measurement.outreach += Number(_this3.calculateOutreach(item));
        _this3.measurement.engagement += Number(_this3.calculateEngagement(item));
        _this3.measurement.budget += Number(item.payout || 0);
      });
      var content = this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaignCOEB.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaignCOEB.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.campaignCOEB.budget * 100).toFixed(2);
    },
    campaignMeasurementInvited: function campaignMeasurementInvited(items) {
      var _this4 = this;

      this.measurement.invitedTotal = 0;
      items.map(function (item) {
        _this4.measurement.invitedTotal += Number(_this4.calculateContents(item));
        _this4.measurement.invitedOutreach += Number(_this4.calculateOutreach(item));
        _this4.measurement.invitedEngagement += Number(_this4.calculateEngagement(item));
        _this4.measurement.invitedBudget += Number(item.payout || 0);
      });
    },
    campaignMeasurementNotInvited: function campaignMeasurementNotInvited(items) {
      var _this5 = this;

      this.measurement.notInvitedTotal = 0;
      items.map(function (item) {
        _this5.measurement.notInvitedTotal += Number(_this5.calculateContents(item));
        _this5.measurement.notInvitedOutreach += Number(_this5.calculateOutreach(item));
        _this5.measurement.notInvitedEngagement += Number(_this5.calculateEngagement(item));
        _this5.measurement.notInvitedBudget += Number(item.payout || 0);
      });
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagement = item.engagement;
      return engagement * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    payoutStatusColor: function payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return '';
      } else if (status === this.payoutStatus.INCOMPLETE || status === this.payoutStatus.SUBMITTED) {
        return 'warning';
      } else {
        return 'green';
      }
    },
    pairingSearchFilter: function pairingSearchFilter() {
      var _this6 = this;

      this.pairedFilterItems = this.pairedInfluencers.map(function (i) {
        return i;
      });
      if (this.pairedFilter.payoutStatus) {
        this.pairedFilterItems = this.pairedFilterItems.filter(function (item) {
          return parseInt(item.payoutStatus) === parseInt(_this6.pairedFilter.payoutStatus);
        });
      }
    },
    openConfirmPayoutDialog: function openConfirmPayoutDialog(item) {
      this.influencer = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, item);
      this.payoutConfirmData = item;
      this.invoiceDownload = false;
      this.payoutConfirmDialog = true;
    },
    setConfirmedPayout: function setConfirmedPayout(item) {
      this.pairedInfluencers = this.pairedInfluencers.map(function (p) {
        if (p.pairingID === item.pairingID) {
          p.payoutAmount = item.payout || 0;
          p.payout = item.payout || 0;
          p.history = item.history;
          p.payoutStatus = item.payoutStatus;
          if (p.payoutSubmitted) {
            delete p.payoutSubmitted;
          }
          if (!p.payoutVerified) {
            p.payoutVerified = true;
          }
        }
        return p;
      });
    },
    linkPayoutInternal: function linkPayoutInternal(item) {
      window.open('/campaignPayoutsInternal?influencerID=' + item.influencer_details.influencerID + '&campaignID=' + item.CampaignID + '&verified=true', '_blank');
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userPermissions']['campaign'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }
      return false;
    },
    buttonPayoutViewShow: function buttonPayoutViewShow(item) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userPermissions']['campaign']['viewPayout'];
      if (buttonPermission.userRoles.includes(this.currentUserRole) && item.payoutVerified !== undefined) {
        return true;
      }
      return false;
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPairingElimination',
  props: {
    value: Boolean,
    campaingData: Object
  },
  components: {
    pairingInfluencersTable: __WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      campaign: {},
      sortBy: 'name',
      sortDesc: false,
      items: [],
      pairedInfluencers: [],
      allOptions: [],
      headers: [{
        text: 'Action',
        sortable: false
      }, {
        text: 'InstagramHandle',
        value: 'igHandle'
      }, {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'instagramFullname'
      }, { text: 'Age', value: 'age' }, { text: 'Gender', value: 'gender' }, { text: 'Followers', value: 'totalFollowers' }, { text: 'Engagement Rates', value: 'engagementRate' }, { text: 'Location', value: 'country' }, { text: 'Status', value: 'selected' }]
    };
  },

  watch: {
    campaingData: function campaingData(campaign) {
      this.campaign = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, campaign);
      this.getPairingList();
    }
  },
  computed: {
    termsAndCondition: function termsAndCondition() {
      return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.html;
    }
  },
  methods: {
    eliminationSubmitted: function eliminationSubmitted() {
      this.getPairingList();
      this.close();
    },
    getPairingList: function getPairingList() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(this.campaign.id).then(function (response) {
        if (response.length > 0) {
          var pairedInfluencersRes = response.map(function (element) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.beautifyData(element));
          });
          _this.pairedInfluencers = pairedInfluencersRes.sort(function (a, b) {
            return a.lineUpIndex - b.lineUpIndex;
          });
          _this.allOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.pairedInfluencers);
          _this.changeOption();
          _this.isLoading = false;
        } else {
          _this.pairedInfluencers = [];
          _this.isLoading = false;
        }
      });
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      inf = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};
      var additionalDetails = data.additional_details || {};
      inf.remarks = additionalDetails.remarks;
      inf.contentFeature = additionalDetails.contentFeature;
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.eliminationReason = data.elimination_details.reason;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram';
      inf.platformName = data.influencer_details.platformName || inf.platform;
      inf.clientNotes = data.clientNotes ? __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default()(data.clientNotes) : [];
      inf.audience_genders = inf.audience_genders || [];
      inf.options = data.options || 0;
      inf.topAudAges = [];
      inf.topCountries = [];
      if (inf.audAges) {
        if (inf.audAges.length > 1) {
          inf.audAges = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(inf.audAges, 'lineupIndex');
          inf.topAudAges = [inf.audAges[0], inf.audAges[1]];
        }
      }
      if (inf.countries) {
        if (inf.countries.length > 1) {
          inf.countries = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(inf.countries, 'lineupIndex');
          inf.topCountries = [inf.countries[0], inf.countries[1]];
        }
      }
      return inf;
    },
    changeOption: function changeOption() {
      var _this2 = this;

      var optionShows = this.allOptions.filter(function (p) {
        if (_this2.optionVal === 0) {
          return !p.options || p.options === _this2.optionVal;
        } else {
          return p.options && p.options === _this2.optionVal;
        }
      });
      this.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], optionShows);
    },
    invokeSendToClient: function invokeSendToClient() {
      this.close();
      this.$emit('invokeSendToClient');
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CampaignListPaymentStatus__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CampaignListPaymentStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__CampaignListPaymentStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_generator_blocksToHtml__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_moment__);




























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'payment-consolidation-status',
  components: {
    influencerDetailModal: __WEBPACK_IMPORTED_MODULE_19__InfluencerDetailViewModal___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_22__scoped_custom_SocialHandle___default.a,
    CampaignListPaymentStatus: __WEBPACK_IMPORTED_MODULE_20__CampaignListPaymentStatus___default.a
  },
  data: function data() {
    return {
      loading: false,
      utilsFunc: __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func,
      influencerList: [],
      totalInfluencer: 0,
      search: '',
      briefConfirmationSearch: '',
      filter: '',
      options: {},
      snack: false,
      snackColor: '',
      snackText: '',
      amount: 0,
      dialog: false,
      influencer: '',
      influencerProfile: '',
      loadAllQuestoins: [],
      selectedTab: '',
      loadingDialog: false,
      briefDetailContent: {
        time: Date.now(),
        blocks: []
      },
      briefDetailsHTML: '',
      campaignList: [],
      sharedDataPromise: null,
      paymentListsPromise: null,
      paymentListsLoaded: false,

      campaignID: '',
      pairedID: '',
      pairedInfluencers: [],
      preProcessingPayments: [],
      importedPayments: [],
      formattedCompletedPayments: [],
      financePayments: [],
      campaignCOEB: {},
      payoutStatusDisplay: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].payoutStatusDisplay,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].payoutStatus,
      pairingSendStatusDisplay: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingSendStatusDisplay,
      pairingSendStatus: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingSendStatus,
      invoiceDownload: false,
      pairedHeaders: [{
        text: 'Handle',
        value: 'influencer_details.instagramHandle'
      }, {
        text: 'Deliverable Details',
        value: 'deliverablesDisplay'
      }, {
        text: 'Produced Deliverables',
        value: 'producedDeliverables'
      }, {
        text: 'Payout Amount',
        value: 'payoutAmount'
      }, {
        text: 'Submission Date',
        value: 'submission_date'
      }, {
        text: 'Payout Confirmation',
        value: ''
      }, {
        text: 'Content Status',
        value: ''
      }, {
        text: 'Payment Status',
        value: 'paymentStatusDisplay'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.sharedDataPromise = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([_this.getAllUsers(), _this.$store.dispatch('payment/getCurrencyRates')]);
              _context.next = 3;
              return _this.fetchCampaignList();

            case 3:
              _this.loadCampaignSummary();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    campaignID: function campaignID(value) {
      if (!value) {
        this.clearCampaignSelection();
        return;
      }
      this.getPairedInfluencers(value, false);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_vuex__["b" /* mapState */])({
    reports: function reports(state) {
      return state.campaign.reports;
    },
    completedPayments: function completedPayments(state) {
      return state.payment.completedPayments;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    },
    infDetail: function infDetail(state) {
      return state.influencer.infDetail;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_vuex__["c" /* mapGetters */])('payment', ['getPaymentStatus', 'formatPreProcessingPayments', 'formatImportedPayments', 'formatCompletedPayments', 'formatFinancePayments', 'getPaymentConsolidationStatusDisplay', 'isPaymentConsolidationRecordMatch']), {
    params: function params(nv) {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.options);
    },
    currentUser: function currentUser() {
      return this.$store.state.user;
    },

    budget: function budget() {
      return Math.floor(this.campaignCOEB.budget * 0.3);
    },
    disableLockedCOGS: function disableLockedCOGS() {
      return this.campaignCOEB.lockedCOGS || false;
    },
    isAM: function isAM() {
      return this.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    }
  }),
  methods: {
    formatDeliverableDetails: function formatDeliverableDetails(value) {
      return this.formatDeliverableCounts(value).replace(/X\s*\(Twitter\)\s*Post/g, 'XTP');
    },
    formatDeliverableCounts: function formatDeliverableCounts(value) {
      return String(value || '').replace(/(\d+(?:hrs)?) X /g, '$1 x ');
    },
    getPairedInfluencers: function getPairedInfluencers(campaignID) {
      var _this2 = this;

      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (campaignID) {
                  _context2.next = 3;
                  break;
                }

                _this2.clearCampaignSelection();
                return _context2.abrupt('return');

              case 3:

                _this2.loadingDialog = true;
                _context2.prev = 4;
                _context2.next = 7;
                return _this2.loadPairedInfluencers(campaignID, refresh);

              case 7:
                return _context2.abrupt('return', _context2.sent);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                console.error('Unable to load campaign payment status:', _context2.t0);

              case 13:
                _context2.prev = 13;

                _this2.loadingDialog = false;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 10, 13, 16]]);
      }))();
    },
    clearCampaignSelection: function clearCampaignSelection() {
      this.loadingDialog = false;
      this.pairedInfluencers = [];
      this.campaignCOEB = {};
    },
    loadPairedInfluencers: function loadPairedInfluencers(campaignID) {
      var _this3 = this;

      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref, _ref2, campaignResp, pairingResp, clientPromise, client, Users, items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, isAccepted, inf;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], {});
                _this3.campaignCOEB = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {});

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].getCampaign(campaignID), __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID)]);

              case 4:
                _ref = _context3.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                campaignResp = _ref2[0];
                pairingResp = _ref2[1];

                if (!campaignResp) {
                  _context3.next = 24;
                  break;
                }

                if (!(campaignResp.campaignType === undefined || !__WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].isOtherCampaign(campaignResp.campaignType))) {
                  _context3.next = 12;
                  break;
                }

                _this3.$swal({
                  title: 'Error',
                  text: 'Invalid Campaign Type!',
                  type: 'error'
                }).then(function () {});
                return _context3.abrupt('return', false);

              case 12:
                clientPromise = __WEBPACK_IMPORTED_MODULE_14__Client_clientAPIs__["a" /* default */].getClient(campaignResp.clientID);
                _context3.next = 15;
                return _this3.sharedDataPromise;

              case 15:
                _context3.next = 17;
                return _this3.$store.dispatch('campaign/getReportsByCampaignIDRefresh', {
                  campaignIDs: [campaignID],
                  refresh: refresh
                });

              case 17:
                _context3.next = 19;
                return _this3.ensurePaymentLists(refresh);

              case 19:
                _context3.next = 21;
                return clientPromise;

              case 21:
                client = _context3.sent;
                Users = _this3.Users.filter(function (c) {
                  return campaignResp.assignedTo && campaignResp.assignedTo.includes(c.id);
                });

                _this3.campaignCOEB = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                  campaignId: campaignResp.id,
                  campaignName: campaignResp.name,
                  companyID: campaignResp.companyID,
                  clientID: campaignResp.clientID,
                  ioNumbers: campaignResp.ioNumbers,
                  clientName: client.name,
                  Users: Users,
                  campaignOutreach: campaignResp.outreach,
                  campaignEngagement: campaignResp.engagement,
                  campaignBudget: campaignResp.budget,
                  max_content: campaignResp.max_content,
                  min_content: campaignResp.min_content,
                  outreach: campaignResp.outreach,
                  engagement: campaignResp.engagement,
                  budget: campaignResp.budget,
                  campaign_brief_details: campaignResp,
                  lockedCOGS: campaignResp.lockedCOGS || false
                });

              case 24:
                if (!pairingResp) {
                  _context3.next = 57;
                  break;
                }

                items = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 29;
                _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(pairingResp);

              case 31:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 42;
                  break;
                }

                data = _step.value;
                isAccepted = data.pairing_details && data.pairing_details.status === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].pairingStatus.ACCEPTED;

                if (!isAccepted) {
                  _context3.next = 39;
                  break;
                }

                _context3.next = 37;
                return _this3.beautifyData(data);

              case 37:
                inf = _context3.sent;

                items.push(inf);

              case 39:
                _iteratorNormalCompletion = true;
                _context3.next = 31;
                break;

              case 42:
                _context3.next = 48;
                break;

              case 44:
                _context3.prev = 44;
                _context3.t0 = _context3['catch'](29);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 48:
                _context3.prev = 48;
                _context3.prev = 49;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 51:
                _context3.prev = 51;

                if (!_didIteratorError) {
                  _context3.next = 54;
                  break;
                }

                throw _iteratorError;

              case 54:
                return _context3.finish(51);

              case 55:
                return _context3.finish(48);

              case 56:
                _this3.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], items);

              case 57:
                _context3.next = 59;
                return _this3.setMultipleInfs();

              case 59:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[29, 44, 48, 56], [49,, 51, 55]]);
      }))();
    },
    setMultipleInfs: function setMultipleInfs() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var connectedItems, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, infID, infs;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                connectedItems = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 4;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this4.pairedInfluencers);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 21;
                  break;
                }

                item = _step2.value;
                infID = item.influencer_details && item.influencer_details.influencerID;
                infs = _this4.getPairedAccountOptions(infID);

                if (!infID) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 13;
                return _this4.$store.dispatch('influencer/getInfluencerDetail', {
                  id: infID
                });

              case 13:
                if (_this4.isCurrentPlatformConnected(item, _this4.infDetail)) {
                  _context4.next = 15;
                  break;
                }

                return _context4.abrupt('continue', 18);

              case 15:
                infs.push.apply(infs, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this4.getProfileAccountOptions(item.id)));

              case 16:
                item.multipleInfs = _this4.uniqueAccountOptions(infs);
                connectedItems.push(item);

              case 18:
                _iteratorNormalCompletion2 = true;
                _context4.next = 6;
                break;

              case 21:
                _context4.next = 27;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 27:
                _context4.prev = 27;
                _context4.prev = 28;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 30:
                _context4.prev = 30;

                if (!_didIteratorError2) {
                  _context4.next = 33;
                  break;
                }

                throw _iteratorError2;

              case 33:
                return _context4.finish(30);

              case 34:
                return _context4.finish(27);

              case 35:
                _this4.pairedInfluencers = connectedItems;

              case 36:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    isCurrentPlatformConnected: function isCurrentPlatformConnected(item, influencer) {
      var details = item.influencer_details || {};
      var platform = String(details.platform || item.platform || 'instagram').toLowerCase();
      var platformKey = platform === 'x' ? 'twitter' : platform;
      var connectedPlatformKeys = ['instagram', 'tiktok', 'youtube', 'xiaohongshu', 'facebook', 'linkedin', 'twitter'];
      return !connectedPlatformKeys.includes(platformKey) || Boolean(influencer && influencer[platformKey]);
    },
    getPairedAccountOptions: function getPairedAccountOptions(influencerID) {
      var _this5 = this;

      if (!influencerID) return [];
      return this.pairedInfluencers.filter(function (item) {
        return item.influencer_details && item.influencer_details.influencerID === influencerID;
      }).map(function (item) {
        return _this5.createPairingAccountOption(item);
      }).filter(Boolean);
    },
    getPlatformHandle: function getPlatformHandle(details, platform) {
      var account = details || {};
      switch (String(platform || account.platform || 'instagram').toLowerCase()) {
        case 'facebook':
          return account.facebookHandle || account.fbHandle || account.facebook && account.facebook.handle || account.userHandle || account.instagramHandle || '';
        case 'twitter':
        case 'x':
          return account.twitterHandle || account.xHandle || account.twitter && account.twitter.twitterHandle || account.userHandle || account.instagramHandle || '';
        case 'linkedin':
          return account.linkedinHandle || account.linkedin && account.linkedin.linkedinHandle || account.userHandle || account.instagramHandle || '';
        case 'tiktok':
          return account.tiktokHandle || account.userHandle || account.instagramHandle || '';
        case 'youtube':
          return account.youtubeHandle || account.userHandle || account.instagramHandle || '';
        default:
          return account.userHandle || account.instagramHandle || '';
      }
    },
    createPairingAccountOption: function createPairingAccountOption(item) {
      var details = item.influencer_details || {};
      var platform = String(details.platform || 'instagram').toLowerCase();
      var normalizedPlatform = platform === 'x' ? 'twitter' : platform;
      var handle = this.getPlatformHandle(details, normalizedPlatform);
      if (!handle) return null;
      var option = {
        reportID: item.id,
        platform: normalizedPlatform === 'tiktok' ? 'TikTok' : normalizedPlatform === 'youtube' ? 'Youtube' : normalizedPlatform === 'xiaohongshu' ? 'Xiaohongshu' : normalizedPlatform === 'facebook' ? 'Facebook' : normalizedPlatform === 'linkedin' ? 'LinkedIn' : normalizedPlatform === 'twitter' ? 'X (Twitter)' : 'Instagram',
        handle: handle,
        picture: details.picture || ''
      };
      var platformFlag = normalizedPlatform === 'xiaohongshu' ? 'xhs' : normalizedPlatform === 'others' ? 'instagram' : normalizedPlatform;
      option[platformFlag] = true;
      return option;
    },
    getProfileAccountOptions: function getProfileAccountOptions(reportID) {
      var infs = [];
      if (this.infDetail.instagram) infs.push({ reportID: reportID, platform: 'Instagram', handle: this.infDetail.instagram.instagramHandle, instagram: true });
      if (this.infDetail.tiktok) infs.push({ reportID: reportID, platform: 'TikTok', handle: this.infDetail.tiktok.tiktokHandle, tiktok: true });
      if (this.infDetail.youtube) infs.push({ reportID: reportID, platform: 'Youtube', handle: this.infDetail.youtube.youtubeHandle, youtube: true });
      if (this.infDetail.xiaohongshu) infs.push({ reportID: reportID, platform: 'Xiaohongshu', handle: this.infDetail.xiaohongshu.xhsHandle, xhs: true });
      if (this.infDetail.facebook) infs.push({ reportID: reportID, platform: 'Facebook', handle: this.infDetail.facebook.handle, facebook: true });
      if (this.infDetail.linkedin) infs.push({ reportID: reportID, platform: 'LinkedIn', handle: this.infDetail.linkedin.linkedinHandle, linkedin: true });
      if (this.infDetail.twitter) infs.push({ reportID: reportID, platform: 'X (Twitter)', handle: this.infDetail.twitter.twitterHandle, twitter: true });
      return infs.filter(function (inf) {
        return inf.handle;
      });
    },
    uniqueAccountOptions: function uniqueAccountOptions(accounts) {
      var seen = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      return accounts.filter(function (account) {
        var key = account.platform + ':' + String(account.handle).trim().toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    fetchPairedInfluencerFromAPI: function fetchPairedInfluencerFromAPI(page, limit) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var userID, influencer;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userID = void 0;

                if (_this6.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST || _this6.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
                  userID = _this6.currentUser.id;
                }
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getAllPairedInfluencer(userID, page, limit);

              case 4:
                influencer = _context5.sent;
                return _context5.abrupt('return', influencer);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    searchClick: function searchClick() {
      var _this7 = this;

      if (this.search) {
        this.loading = true;
        var userID = void 0;
        var search = this.search.trim().toLowerCase();
        if (this.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUser.role === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
          userID = this.currentUser.id;
        }
        __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getAllPairedInfluencer(userID).then(function (data) {
          if (search) {
            data.items = data.items.filter(function (item) {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(item).join(',').toLowerCase().includes(search);
            });
          }
          _this7.influencerList = data.items;
          _this7.totalInfluencer = data.items.length;
          _this7.loading = false;
        });
      } else this.loadInfluencerData();
    },
    loadInfluencerData: function loadInfluencerData() {
      var _this8 = this;

      this.getPairedInfluencers(this.campaignID);
      this.campaignList = [];
      setTimeout(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this8.fetchCampaignList();

              case 2:
                _this8.loadCampaignSummary();

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      })), 1000);
    },
    prepareDataTable: function prepareDataTable() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var _options = _this9.options,
            sortBy = _options.sortBy,
            sortDesc = _options.sortDesc,
            page = _options.page,
            itemsPerPage = _options.itemsPerPage;

        _this9.fetchPairedInfluencerFromAPI(page, itemsPerPage).then(function (data) {
          if (_this9.options.sortBy) {
            data.items = data.items.sort(function (a, b) {
              var sortA = a[sortBy[0]];
              var sortB = b[sortBy[0]];

              if (sortDesc[0]) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }
          var total = data.totalRows;
          setTimeout(function () {
            resolve({ items: data.items, total: total });
          }, 300);
        });
      });
    },
    getStatusColor: function getStatusColor(status) {
      if (status) {
        if (status === this.pairingStatus.INVITED.value) {
          return 'orange';
        } else if (status === this.pairingStatus.INTERESTED.value) {
          return '#81C784';
        } else if (status === this.pairingStatus.NOT_INTERESTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.ACCEPTED.value) {
          return '#66BB6A';
        } else if (status === this.pairingStatus.NOT_ACCEPTED.value) {
          return 'red';
        } else if (status === this.pairingStatus.INQUIRY.value) {
          return '#1E88E5';
        } else return 'white';
      }
    },
    payoutStatusColor: function payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return '';
      } else if (status === this.payoutStatus.INCOMPLETE) {
        return 'warning';
      } else {
        return 'green';
      }
    },
    getUserByInfluencer: function getUserByInfluencer(id) {
      var _this10 = this;

      var param = {
        'influencerID': id
      };
      __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getUserByInfluencer(param).then(function (res) {
        _this10.influencerProfile = res;
      });
    },
    preSelectTabs: function preSelectTabs(status) {
      if (status === this.pairingStatus.INQUIRY.value) {
        this.selectedTab = 1;
      } else {
        this.selectedTab = 0;
      }
    },
    preparedViewItem: function preparedViewItem(item, type) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var oldData, blocksTohtml;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (item.influencerID) {
                  _this11.getUserByInfluencer(item.influencerID);
                }
                _this11.influencer = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);

                if (!(item.brief_details && item.brief_details.contentHTML !== undefined && item.brief_details.contentHTML !== null)) {
                  _context7.next = 6;
                  break;
                }

                _this11.briefDetailsHTML = item.brief_details.contentHTML;
                _this11.selectedTab = type;
                return _context7.abrupt('return');

              case 6:
                oldData = false;

                if (!(item.brief_details && item.brief_details.content !== undefined && item.brief_details.content !== '' && item.brief_details.content.length > 0)) {
                  _context7.next = 12;
                  break;
                }

                _this11.briefDetailContent.blocks = item.brief_details.content;
                oldData = true;
                _context7.next = 15;
                break;

              case 12:
                _context7.next = 14;
                return __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].generateBlocks(item);

              case 14:
                _this11.briefDetailContent.blocks = _context7.sent;

              case 15:
                blocksTohtml = new __WEBPACK_IMPORTED_MODULE_21__editor_generator_blocksToHtml__["a" /* default */](_this11.briefDetailContent.blocks);

                _this11.briefDetailsHTML = blocksTohtml.generate(oldData);
                _this11.selectedTab = type;

              case 18:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    updateSend: function updateSend(item) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var payload, confirmPayoutBlock, message;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                payload = _this12.getRptOwnerCheckPayload(item);
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].invokeReportOwnerCheck(_this12, payload);

              case 3:
                confirmPayoutBlock = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.confirmPayout;
                message = confirmPayoutBlock.html;

                _this12.$swal({
                  title: confirmPayoutBlock.title,
                  html: message,
                  confirmButtonText: confirmPayoutBlock.confirmButtonText,
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee8(result) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!result.value) {
                              _context8.next = 6;
                              break;
                            }

                            _this12.invoiceDownload = true;
                            _context8.next = 4;
                            return _this12.preparedViewItem(item, -1);

                          case 4:
                            _this12.selectedTab = -1;
                            _this12.dialog = true;

                          case 6:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this12);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    cancelPayout: function cancelPayout(item) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var cancelPayoutBlock, message;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                cancelPayoutBlock = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignConfirmation.cancelPayout;
                message = cancelPayoutBlock.html;

                _this13.$swal({
                  title: cancelPayoutBlock.title,
                  html: message,
                  confirmButtonText: cancelPayoutBlock.confirmButtonText,
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee10(result) {
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            if (!result.value) {
                              _context10.next = 6;
                              break;
                            }

                            _this13.loadingDialog = true;
                            _context10.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].cancelAdminPayout(item.id);

                          case 4:
                            _this13.loadingDialog = false;
                            _this13.loadInfluencerData();

                          case 6:
                          case 'end':
                            return _context10.stop();
                        }
                      }
                    }, _callee10, _this13);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },
    closeModal: function closeModal() {
      this.selectedTab = '';
      this.dialog = false;
    },
    loadingDialogOpen: function loadingDialogOpen() {
      this.loadingDialog = true;
    },
    loadingDialogClose: function loadingDialogClose() {
      this.loadingDialog = false;
    },
    beautifyData: function beautifyData(data) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var inf, influencerDetails, deliverablesDetails, hasProducedDeliverables, platformHandle, infInfluencerID, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, rpt, rptOwner, isOwnerMatch, paymentConsolidationRecords, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _rpt, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _rpt2, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _rpt3, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _rpt4;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                inf = {};
                influencerDetails = data.influencer_details;
                deliverablesDetails = data.deliverables_details || {};

                hasProducedDeliverables = function hasProducedDeliverables(value) {
                  return value !== undefined && value !== null && value !== '';
                };

                inf.influencer_details = influencerDetails;
                inf.pairing_details = data.pairing_details;
                inf.elimination_details = data.elimination_details;
                inf.pairingStatus = data.pairing_details.status;
                inf.status = data.pairing_details.status;
                inf.eliminationStatus = data.elimination_details.status;
                inf.remarks = data.additional_details ? data.additional_details.remarks : '';
                inf.CampaignID = _this14.campaignCOEB ? _this14.campaignCOEB.campaignId : '';
                inf.CampaignName = _this14.campaignCOEB ? _this14.campaignCOEB.campaignName : '';
                inf.Users = _this14.campaignCOEB ? _this14.campaignCOEB.Users : [];
                inf.campaign_brief_details = _this14.campaignCOEB.campaign_brief_details;
                inf.id = data.id;
                inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
                inf.no_of_video = deliverablesDetails.no_of_video || 0;
                inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
                inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
                inf.instagramFullname = influencerDetails.fullname;
                inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
                inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
                inf.no_of_li_posts = deliverablesDetails.no_of_li_posts || 0;
                inf.no_of_x_posts = deliverablesDetails.no_of_x_posts || 0;
                inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
                inf.followers = influencerDetails.followers || 0;
                inf.engagement = influencerDetails.engagements || 0;
                inf.engagement_rate = influencerDetails.engagement_rate || 0;
                inf.deliverables = deliverablesDetails;
                inf.deliverablesDisplay = __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].getDeliverableDetails(deliverablesDetails);
                inf.sentStatus = data.sentStatus || 0;
                inf.platform = String(influencerDetails.platform || 'instagram').toLowerCase();
                if (inf.platform === 'x') inf.platform = 'twitter';
                inf.influencer_details.platform = inf.platform;
                platformHandle = _this14.getPlatformHandle(inf.influencer_details, inf.platform);

                if (!inf.userHandle) inf.userHandle = platformHandle;
                if (!inf.influencer_details.userHandle) inf.influencer_details.userHandle = platformHandle;
                if (data.payout_details) {
                  inf.payout_details = data.payout_details;
                  inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
                  inf.GSTIncluded = data.payout_details.GSTpercent || false;
                  inf.GSTpercent = data.payout_details.GSTpercent;
                  inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
                  inf.history = data.payout_details.history ? __WEBPACK_IMPORTED_MODULE_23_lodash_reverse___default()(data.payout_details.history) : [];
                  inf.payoutStatus = data.payout_details.status || 0;
                  inf.currency = data.payout_details.currency || 'SGD';
                  if (inf.currency !== 'SGD') {
                    inf.sgdAmt = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.convertCurrency(inf.currency, inf.payoutAmount, _this14.currencyRates);
                  }
                }
                if (data.brief_details) {
                  inf.brief_details = data.brief_details;
                }
                inf.paymentStatuses = [];
                infInfluencerID = inf.influencer_details ? inf.influencer_details.influencerID : null;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context12.prev = 45;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this14.reports);

              case 47:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context12.next = 57;
                  break;
                }

                rpt = _step3.value;

                if (!rpt.imported) {
                  _context12.next = 51;
                  break;
                }

                return _context12.abrupt('continue', 54);

              case 51:
                rptOwner = _this14.getReportOwnerIdentity(rpt);
                isOwnerMatch = rptOwner.pairingID && rptOwner.pairingID === inf.id || infInfluencerID && rptOwner.influencerID && rptOwner.influencerID === infInfluencerID || rptOwner.handle && inf.userHandle && rptOwner.handle === String(inf.userHandle).trim().toLowerCase();

                if (isOwnerMatch) {
                  inf.inReport = true;
                  if (hasProducedDeliverables(rpt.producedDeliverables)) {
                    inf.producedDeliverables = rpt.producedDeliverables;
                  } else if (!hasProducedDeliverables(inf.producedDeliverables) && hasProducedDeliverables(rpt.deliverables)) {
                    inf.producedDeliverables = rpt.deliverables;
                  }
                }

              case 54:
                _iteratorNormalCompletion3 = true;
                _context12.next = 47;
                break;

              case 57:
                _context12.next = 63;
                break;

              case 59:
                _context12.prev = 59;
                _context12.t0 = _context12['catch'](45);
                _didIteratorError3 = true;
                _iteratorError3 = _context12.t0;

              case 63:
                _context12.prev = 63;
                _context12.prev = 64;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 66:
                _context12.prev = 66;

                if (!_didIteratorError3) {
                  _context12.next = 69;
                  break;
                }

                throw _iteratorError3;

              case 69:
                return _context12.finish(66);

              case 70:
                return _context12.finish(63);

              case 71:
                paymentConsolidationRecords = _this14.getPaymentConsolidationRecords();
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context12.prev = 75;

                for (_iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this14.preProcessingPayments); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  _rpt = _step4.value;

                  if (_rpt.campaign.id === inf.CampaignID) {
                    if (_rpt.influencer_details) {
                      if (_this14.isPaymentConsolidationRecordMatch(_rpt, inf.CampaignID, inf.userHandle, infInfluencerID)) {
                        inf.inReport = true;
                        if (!inf.producedDeliverables) {
                          inf.producedDeliverables = _rpt.deliverables;
                        }

                        _rpt.payment_status = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].paymentStatus.PROCESSING;
                        inf.paymentStatuses.push(_rpt);
                      }
                    }
                  }
                }

                _context12.next = 83;
                break;

              case 79:
                _context12.prev = 79;
                _context12.t1 = _context12['catch'](75);
                _didIteratorError4 = true;
                _iteratorError4 = _context12.t1;

              case 83:
                _context12.prev = 83;
                _context12.prev = 84;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 86:
                _context12.prev = 86;

                if (!_didIteratorError4) {
                  _context12.next = 89;
                  break;
                }

                throw _iteratorError4;

              case 89:
                return _context12.finish(86);

              case 90:
                return _context12.finish(83);

              case 91:
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context12.prev = 94;

                for (_iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this14.importedPayments); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  _rpt2 = _step5.value;

                  if (_rpt2.campaign.id === inf.CampaignID) {
                    if (_rpt2.influencer_details) {
                      if (_this14.isPaymentConsolidationRecordMatch(_rpt2, inf.CampaignID, inf.userHandle, infInfluencerID)) {
                        inf.inReport = true;
                        if (!inf.producedDeliverables) {
                          inf.producedDeliverables = _rpt2.deliverables;
                        }

                        _rpt2.payment_status = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].paymentStatus.PROCESSING;
                        inf.paymentStatuses.push(_rpt2);
                      }
                    }
                  }
                }
                _context12.next = 102;
                break;

              case 98:
                _context12.prev = 98;
                _context12.t2 = _context12['catch'](94);
                _didIteratorError5 = true;
                _iteratorError5 = _context12.t2;

              case 102:
                _context12.prev = 102;
                _context12.prev = 103;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 105:
                _context12.prev = 105;

                if (!_didIteratorError5) {
                  _context12.next = 108;
                  break;
                }

                throw _iteratorError5;

              case 108:
                return _context12.finish(105);

              case 109:
                return _context12.finish(102);

              case 110:
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context12.prev = 113;

                for (_iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this14.formattedCompletedPayments); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  _rpt3 = _step6.value;

                  if (_rpt3.campaign.id === inf.CampaignID) {
                    if (_rpt3.influencer_details) {
                      if (_this14.isPaymentConsolidationRecordMatch(_rpt3, inf.CampaignID, inf.userHandle, infInfluencerID)) {
                        inf.inReport = true;
                        if (!inf.producedDeliverables) {
                          inf.producedDeliverables = _rpt3.deliverables;
                        }

                        _rpt3.payment_status = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].paymentStatus.PAID;
                        inf.paymentStatuses.push(_rpt3);
                      }
                    }
                  }
                }
                _context12.next = 121;
                break;

              case 117:
                _context12.prev = 117;
                _context12.t3 = _context12['catch'](113);
                _didIteratorError6 = true;
                _iteratorError6 = _context12.t3;

              case 121:
                _context12.prev = 121;
                _context12.prev = 122;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 124:
                _context12.prev = 124;

                if (!_didIteratorError6) {
                  _context12.next = 127;
                  break;
                }

                throw _iteratorError6;

              case 127:
                return _context12.finish(124);

              case 128:
                return _context12.finish(121);

              case 129:
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context12.prev = 132;

                for (_iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this14.financePayments); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  _rpt4 = _step7.value;

                  if (_rpt4.campaign.id === inf.CampaignID) {
                    if (_rpt4.influencer_details) {
                      if (_this14.isPaymentConsolidationRecordMatch(_rpt4, inf.CampaignID, inf.userHandle, infInfluencerID)) {
                        inf.inReport = true;
                        if (!inf.producedDeliverables) {
                          inf.producedDeliverables = _rpt4.deliverables;
                        }

                        _rpt4.payment_status = _rpt4.status;
                        inf.paymentStatuses.push(_rpt4);
                      }
                    }
                  }
                }
                _context12.next = 140;
                break;

              case 136:
                _context12.prev = 136;
                _context12.t4 = _context12['catch'](132);
                _didIteratorError7 = true;
                _iteratorError7 = _context12.t4;

              case 140:
                _context12.prev = 140;
                _context12.prev = 141;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 143:
                _context12.prev = 143;

                if (!_didIteratorError7) {
                  _context12.next = 146;
                  break;
                }

                throw _iteratorError7;

              case 146:
                return _context12.finish(143);

              case 147:
                return _context12.finish(140);

              case 148:
                inf.paymentStatuses = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(inf.paymentStatuses));
                inf.paymentStatusDisplay = _this14.getPaymentConsolidationStatusDisplay(paymentConsolidationRecords, inf.CampaignID, inf.userHandle, infInfluencerID, inf.id);
                return _context12.abrupt('return', inf);

              case 151:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this14, [[45, 59, 63, 71], [64,, 66, 70], [75, 79, 83, 91], [84,, 86, 90], [94, 98, 102, 110], [103,, 105, 109], [113, 117, 121, 129], [122,, 124, 128], [132, 136, 140, 148], [141,, 143, 147]]);
      }))();
    },
    getReportOwnerIdentity: function getReportOwnerIdentity(rpt) {
      if (!rpt) return { pairingID: null, handle: null, influencerID: null };
      var ownerObj = rpt.success && rpt.post_details && rpt.post_details.owner ? rpt.post_details.owner : rpt.owner && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rpt.owner) === 'object' ? rpt.owner : null;
      var rawHandle = ownerObj && ownerObj.username ? ownerObj.username : typeof rpt.owner === 'string' ? rpt.owner : rpt.instagram;
      var handle = rawHandle ? String(rawHandle).trim().toLowerCase() : null;
      var influencerID = rpt.influencerID || (ownerObj ? ownerObj.influencerID : null) || null;
      var pairingID = rpt.pairingID || (ownerObj ? ownerObj.pairingID : null) || null;
      return { pairingID: pairingID, handle: handle, influencerID: influencerID };
    },
    getPaymentConsolidationRecords: function getPaymentConsolidationRecords() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.preProcessingPayments), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.importedPayments), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.financePayments), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.formattedCompletedPayments));
    },
    refreshPaymentLists: function refreshPaymentLists() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([_this15.getPreProcessingPayments(), _this15.getImportedPayments(), _this15.getCompletedPayment(), _this15.fetchFinancePayments()]);

              case 2:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this15);
      }))();
    },
    ensurePaymentLists: function ensurePaymentLists() {
      var _this16 = this;

      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!(!refresh && _this16.paymentListsLoaded)) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt('return');

              case 2:
                if (!(!refresh && _this16.paymentListsPromise)) {
                  _context14.next = 4;
                  break;
                }

                return _context14.abrupt('return', _this16.paymentListsPromise);

              case 4:

                _this16.paymentListsPromise = _this16.refreshPaymentLists().then(function () {
                  _this16.paymentListsLoaded = true;
                }).finally(function () {
                  _this16.paymentListsPromise = null;
                });
                return _context14.abrupt('return', _this16.paymentListsPromise);

              case 6:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this16);
      }))();
    },
    getAllUsers: function getAllUsers() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var _ref6, _ref7, coResponse, amResponse;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.AD_STRATEGIST), __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).catch(function (error) {
                  console.log('error', error);
                  return { users: [] };
                })]);

              case 2:
                _ref6 = _context15.sent;
                _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref6, 2);
                coResponse = _ref7[0];
                amResponse = _ref7[1];

                _this17.Users = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(coResponse.users), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(amResponse.users)).map(function (user) {
                  user.name = user.firstName + ' ' + user.lastName;
                  return user;
                });

              case 7:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this17);
      }))();
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var response, campaigns;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this18.loadingDialog = true;
                _context16.prev = 1;

                if (!_this18.$route.query.id) {
                  _context16.next = 9;
                  break;
                }

                _context16.next = 5;
                return __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].getCampaign(_this18.$route.query.id);

              case 5:
                _context16.t1 = _context16.sent;
                _context16.t0 = [_context16.t1];
                _context16.next = 12;
                break;

              case 9:
                _context16.next = 11;
                return __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].getAllCampaignsNoStatus();

              case 11:
                _context16.t0 = _context16.sent;

              case 12:
                response = _context16.t0;
                campaigns = response.filter(Boolean);

                campaigns = campaigns.filter(function (c) {
                  return c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.ONGOING || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.REVIEW || c.status === __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].campaignStatus.COMPLETE;
                });

                _this18.campaignList = campaigns.map(function (element) {
                  return {
                    name: element.name,
                    ioNumber: element.ioNumbers || '',

                    searchText: element.ioNumbers ? element.ioNumbers + ' - ' + element.name : element.name,
                    id: element.id,
                    lockedCOGS: element.lockedCOGS || false,
                    statusLoading: true,
                    statusUnavailable: false
                  };
                });
                if (_this18.$route.query.id) {
                  _this18.campaignID = _this18.$route.query.id;
                  _this18.campaignList = _this18.campaignList.filter(function (c) {
                    return c.id === _this18.campaignID;
                  });
                }
                _this18.loadingDialog = false;
                _context16.next = 24;
                break;

              case 20:
                _context16.prev = 20;
                _context16.t2 = _context16['catch'](1);

                _this18.loadingDialog = false;
                console.log('Error:' + _context16.t2);

              case 24:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this18, [[1, 20]]);
      }))();
    },
    loadCampaignSummary: function loadCampaignSummary() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var campaignIDs, summaries;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                campaignIDs = _this19.campaignList.map(function (element) {
                  return element.id;
                });

                if (campaignIDs.length) {
                  _context17.next = 3;
                  break;
                }

                return _context17.abrupt('return');

              case 3:
                _context17.prev = 3;
                _context17.next = 6;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getCampaignPaymentStatusSummary(campaignIDs);

              case 6:
                summaries = _context17.sent;

                _this19.setCampaignRptPaymentStatus(summaries);
                _context17.next = 14;
                break;

              case 10:
                _context17.prev = 10;
                _context17.t0 = _context17['catch'](3);

                console.error('Unable to load campaign payment summaries:', _context17.t0);
                _this19.campaignList.forEach(function (campaign) {
                  campaign.statusUnavailable = true;
                });

              case 14:
                _context17.prev = 14;

                _this19.campaignList.forEach(function (campaign) {
                  campaign.statusLoading = false;
                });
                return _context17.finish(14);

              case 17:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this19, [[3, 10, 14, 17]]);
      }))();
    },
    setCampaignRptPaymentStatus: function setCampaignRptPaymentStatus() {
      var _this20 = this;

      var summaries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var summariesByCampaign = summaries.reduce(function (result, summary) {
        result[summary.campaignID] = summary;
        return result;
      }, {});
      this.campaignList.forEach(function (campaign) {
        var summary = summariesByCampaign[campaign.id];
        campaign.payoutStatus = summary && summary.allPayoutsConfirmed ? _this20.payoutStatus.CONFIRMED : null;
        campaign.inReport = Boolean(summary && summary.allAcceptedPairingsInReport);
      });
    },
    getRptOwnerCheckPayload: function getRptOwnerCheckPayload(item) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
        campaignID: item.CampaignID,
        handle: item.influencer_details ? item.influencer_details.instagramHandle : null,
        platform: item.influencer_details ? item.influencer_details.platform : null
      });
    },
    formatSubmissionDate: function formatSubmissionDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_25_moment___default()(date).format('DD/MM/yyyy') : 'Empty!';
    },
    displayGSTText: function displayGSTText(item) {
      return '$' + (item.payoutAmount - item.GSTpercent) + ' + $' + item.GSTpercent + ' (GST)';
    },
    getPreProcessingPayments: function getPreProcessingPayments() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return _this21.$store.dispatch('payment/getPreProcessingPayments', {});

              case 2:
                _this21.preProcessingPayments = _this21.formatPreProcessingPayments(_this21.Users);

              case 3:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this21);
      }))();
    },
    getImportedPayments: function getImportedPayments() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee19() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return _this22.$store.dispatch('payment/getImportedPayments', {});

              case 2:
                _this22.importedPayments = _this22.formatImportedPayments(_this22.Users);

              case 3:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this22);
      }))();
    },
    getCompletedPayment: function getCompletedPayment() {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee20() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return _this23.$store.dispatch('payment/getCompletedPayments', {});

              case 2:
                _this23.formattedCompletedPayments = _this23.formatCompletedPayments(_this23.Users);

              case 3:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this23);
      }))();
    },
    fetchFinancePayments: function fetchFinancePayments() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee21() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return _this24.$store.dispatch('payment/getFinancePayments', {});

              case 2:
                _this24.financePayments = _this24.formatFinancePayments(_this24.Users);

              case 3:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this24);
      }))();
    }
  }
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__ = __webpack_require__(19);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PayoutActivityDataTable',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a
  },
  props: ['pairing', 'activityRefresh'],
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */],
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    savedPayoutActivity: function savedPayoutActivity(state) {
      return state.pairing.savedPayoutActivity;
    }
  })),
  watch: {
    activityRefresh: {
      handler: function handler() {
        this.setActivities();
      },

      deep: true
    }
  },
  methods: {
    updatePairingActivity: function updatePairingActivity(item, status) {
      var _this = this;

      this.$swal({
        title: 'Are you sure you want to ' + status + '?',
        icon: 'warning',
        confirmButtonText: 'Confirm',
        showCancelButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var saveData;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 7;
                    break;
                  }

                  _this.isLoading = true;
                  saveData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                    pairingID: _this.pairing.pairingID,
                    createdAt: item.createdAt,
                    status: status
                  });
                  _context.next = 5;
                  return _this.$store.dispatch('pairing/updatePayoutActivity', saveData);

                case 5:
                  _this.isLoading = false;
                  if (_this.savedPayoutActivity) {
                    _this.$swal({
                      text: 'Payout ' + (status === 'approve' ? 'Approved' : 'Rejected') + '.',
                      type: 'success'
                    });
                    _this.$emit('saved');
                  } else {
                    _this.$swal({
                      text: 'Error Payout Confirmation!',
                      type: 'error'
                    });
                  }

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    setActivities: function setActivities() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref2, _ref3, key, value, user, actionUser;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.pairing.activity && Array.isArray(_this2.pairing.activity))) {
                  _context2.next = 38;
                  break;
                }

                _this2.pairing.activity = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this2.pairing.activity);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 5;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(_this2.pairing.activity));

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 24;
                  break;
                }

                _ref2 = _step.value;
                _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                key = _ref3[0];
                value = _ref3[1];
                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__["a" /* default */].getUser(value.userID);

              case 14:
                user = _context2.sent;

                if (user) {
                  _this2.pairing.activity[key].requestor = user.firstName + ' ' + user.lastName;
                }

                if (!value.actionUserID) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 19;
                return __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__["a" /* default */].getUser(value.actionUserID);

              case 19:
                actionUser = _context2.sent;

                if (actionUser) {
                  _this2.pairing.activity[key].actor = actionUser.firstName + ' ' + actionUser.lastName;
                }

              case 21:
                _iteratorNormalCompletion = true;
                _context2.next = 7;
                break;

              case 24:
                _context2.next = 30;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 30:
                _context2.prev = 30;
                _context2.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 33:
                _context2.prev = 33;

                if (!_didIteratorError) {
                  _context2.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context2.finish(33);

              case 37:
                return _context2.finish(30);

              case 38:
                _this2.pairing.activity = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.refreshJSON(_this2.pairing.activity);

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 26, 30, 38], [31,, 33, 37]]);
      }))();
    }
  }
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InfluencerDetailViewModal__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InfluencerDetailViewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__InfluencerDetailViewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { influencerDetailModal: __WEBPACK_IMPORTED_MODULE_7__InfluencerDetailViewModal___default.a, Loading: __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay___default.a },
  data: function data() {
    return {
      activePairingData: null,
      uploadFiles: [],
      deleteObjectKeys: [],
      isLoading: false,
      invoiceDialog: false,
      isGetInvoice: false
    };
  },

  props: {
    value: Boolean,
    data: Object,
    amount: Number,
    influencer: Object
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        this.activePairingData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.data);
        this.clearForm();
        this.isGetInvoice = false;
      }
    }
  },
  computed: {},
  validations: {
    activePairingData: {
      payout: {
        required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
      },
      remarks: {
        required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    processConfirmPayout: function processConfirmPayout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 4;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Make sure you filled the required information correctly.'
                });
                return _context.abrupt('return');

              case 4:
                payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                  campaignID: _this.activePairingData.CampaignID,
                  handle: _this.activePairingData.instagramHandle,
                  platform: _this.activePairingData.platform
                });
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_8__campaignHelper__["a" /* default */].invokeReportOwnerCheck(_this, payload);

              case 7:
                _this.influencer = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.refreshJSON(_this.influencer);
                _this.isGetInvoice = true;
                _this.invoiceDialog = true;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    confirmPayout: function confirmPayout(contractFile) {
      var _this2 = this;

      if (this.activePairingData !== null) {
        var formData = new FormData();
        formData.append('pairingID', this.activePairingData.pairingID);
        formData.append('amount', this.activePairingData.payout);
        formData.append('remarks', this.activePairingData.remarks);
        formData.append('uploadFile', contractFile);

        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__["a" /* default */].confirmAdminPayout(formData).then(function (response) {
          _this2.isGetInvoice = false;
          _this2.isLoading = false;
          _this2.activePairingData.payoutStatus = response.status;
          _this2.activePairingData.history = response.history;
          _this2.beautifyData();
          _this2.$swal({
            position: 'top-center',
            title: 'Payout Updated',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this2.$emit('input');
          _this2.$emit('confirmedPayout', _this2.activePairingData);
        }).catch(function (error) {
          _this2.isLoading = false;
          _this2.$swal({
            position: 'top-center',
            title: 'Error while updating payout',
            type: 'error',
            timer: 1500
          });
          console.log(error);
        });
      }
    },
    deletePayout: function deletePayout(fileIndex) {
      var _this3 = this;

      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete payout?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var history = _this3.activePairingData.history[fileIndex];
          var updateHistory = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this3.activePairingData.history);
          if (history.invoices !== undefined) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(history.invoices), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var invoice = _step.value;

                var filename = invoice.url.substring(invoice.url.lastIndexOf('/') + 1);
                _this3.deleteObjectKeys.push(filename);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          updateHistory.splice(fileIndex, 1);
          var formData = new FormData();
          formData.append('id', _this3.activePairingData.pairingID);
          formData.append('history', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(updateHistory));
          _this3.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__["a" /* default */].updatePayoutHistory(formData).then(function (response) {
            _this3.activePairingData.history = updateHistory;
            _this3.activePairingData.payoutStatus = response.status;
            _this3.isLoading = false;
            if (_this3.deleteObjectKeys.length > 0) {
              _this3.deleteObjectKeys.map(function (item) {
                __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].request('delete', '/api/v1/posts/s3/delete', true, { image: item });
              });
            }
            _this3.$emit('confirmedPayout', _this3.activePairingData);

            _this3.$swal({
              text: 'Invoice Deleted',
              type: 'success'
            });
          }).catch(function (error) {
            console.log('error', error);
            _this3.isLoading = false;
          });
        }
      });
    },
    prepareUpload: function prepareUpload(e) {
      var _this4 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var fileType = element.name.split('.')[1];
        if (fileType !== 'pdf') {
          _this4.$swal('File Type Not Supported, Please select a video or an image');
        } else {
          _this4.uploadFiles = [];
          _this4.uploadFiles.push(element);
          var reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    closeModal: function closeModal() {
      this.isGetInvoice = false;
      this.invoiceDialog = false;
    },
    deleteFile: function deleteFile(fileIndex) {
      this.uploadFiles.splice(fileIndex, 1);
    },
    beautifyData: function beautifyData() {
      if (this.activePairingData.history !== undefined) {
        this.activePairingData.history = __WEBPACK_IMPORTED_MODULE_13_lodash_reverse___default()(this.activePairingData.history);
        console.log(this.activePairingData.history);
      }
    },
    clearForm: function clearForm() {
      this.activePairingData.remarks = '';
      this.uploadFiles = [];
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).format('DD-MM-YYYY hh:mm:ss');
    }
  }
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PayoutActivityDataTable__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PayoutActivityDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PayoutActivityDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PayoutUpdateModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default.a,
    PayoutActivityDataTable: __WEBPACK_IMPORTED_MODULE_7__PayoutActivityDataTable___default.a
  },
  props: {
    value: Boolean,
    lockedPayout: Boolean,
    pairing: Object,
    campaign: Object,
    cappedCOGS: Number,
    currentCOGS: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  validations: function validations() {
    var validationRules = {
      updateData: {
        amount: { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] }
      }
    };
    if (this.lockedPayout && !this.isAdmins) {
      validationRules['updateData']['reasons'] = { required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"] };
    }
    return validationRules;
  },
  data: function data() {
    return {
      utilsFunc: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func,
      isLoading: false,
      activityrefresh: 0,
      currencies: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].currencies,
      updateData: {
        currency: 'SGD',
        amount: '',
        reasons: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('payment/getCurrencyRates');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])({
    savedAmountApproval: function savedAmountApproval(state) {
      return state.pairing.savedAmountApproval;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  }), {
    isAdmins: function isAdmins() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    }
  }),
  watch: {
    value: function value(newValue) {
      var _this2 = this;

      this.updateData = {
        amount: '',
        reasons: ''
      };
      if (newValue) {
        setTimeout(function () {
          _this2.activityrefresh += 1;
        }, 100);
        if (this.pairing.currency) {
          this.updateData.currency = this.pairing.currency;
        }
      }
      this.setCurrency();
    },
    campaign: function campaign(newValue) {
      this.setCurrency();
    }
  },
  methods: {
    savePayoutAmount: function savePayoutAmount() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this3.isBudgetOver() && !_this3.isAdmins)) {
                  _context4.next = 3;
                  break;
                }

                _this3.$swal({
                  text: 'Your new amount is exceeding the capped COGS, Please continue to request for Approval',
                  type: 'warning',
                  confirmButtonText: 'Continue',
                  showCancelButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (result.value) {
                              _this3.close();
                              _this3.$emit('budgetExceeded', _this3.updateData);
                            }

                          case 1:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                return _context4.abrupt('return');

              case 3:
                _this3.$swal({
                  title: 'Are you sure you want to update?',
                  type: 'warning',
                  confirmButtonText: 'Confirm',
                  showCancelButton: true
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
                    var saveData, resp;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result.value) {
                              _context3.next = 11;
                              break;
                            }

                            if (!(_this3.lockedPayout && !_this3.isAdmins)) {
                              _context3.next = 4;
                              break;
                            }

                            _this3.saveGetApproval();
                            return _context3.abrupt('return');

                          case 4:
                            _this3.isLoading = true;
                            saveData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                              pairingID: _this3.pairing.pairingID,
                              payoutAmount: _this3.updateData.amount,
                              currency: _this3.updateData.currency
                            });
                            _context3.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].updatePayoutAmount(saveData);

                          case 8:
                            resp = _context3.sent;

                            _this3.isLoading = false;
                            if (resp) {
                              _this3.$swal({
                                text: 'Payout Updated.',
                                type: 'success'
                              });
                              _this3.close();
                              setTimeout(function () {
                                _this3.$emit('refreshPairing');
                              }, 100);
                            } else {
                              _this3.$swal({
                                text: 'Error Updating Amount!',
                                type: 'error'
                              });
                            }

                          case 11:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    saveGetApproval: function saveGetApproval() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.isLoading = true;
                saveData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                  pairingID: _this4.pairing.pairingID,
                  amount: _this4.updateData.amount,
                  reasons: _this4.updateData.reasons,
                  currency: _this4.updateData.currency
                });
                _context5.next = 4;
                return _this4.$store.dispatch('pairing/saveAmountApproval', saveData);

              case 4:
                _this4.isLoading = false;
                if (_this4.savedAmountApproval) {
                  _this4.$swal({
                    text: 'Payout Approval Sent.',
                    type: 'success'
                  });
                  _this4.close();
                  setTimeout(function () {
                    _this4.$emit('refreshPairing');
                  }, 100);
                } else {
                  _this4.$swal({
                    text: 'Error Updating Amount!',
                    type: 'error'
                  });
                }

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    isBudgetOver: function isBudgetOver() {
      var currencyAmt = 0;
      var updateAmt = 0;
      if (this.updateData.currency !== 'SGD') {
        updateAmt = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.convertCurrency(this.updateData.currency, this.updateData.amount, this.currencyRates);
      }
      if (this.pairing.currency !== 'SGD') {
        currencyAmt = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.convertCurrency(this.pairing.currency, this.pairing.payoutAmount, this.currencyRates);
      } else {
        currencyAmt = this.pairing.payoutAmount;
      }
      var currentBudget = this.currentCOGS - Number(currencyAmt) + Number(updateAmt);
      return currentBudget / Number(this.cappedCOGS) > 1;
    },
    savedPayoutActivity: function savedPayoutActivity() {
      var _this5 = this;

      this.close();
      setTimeout(function () {
        _this5.$emit('refreshPairing');
      }, 100);
    },
    close: function close() {
      this.$emit('input');
    },
    setCurrency: function setCurrency() {
      if (!this.campaign || this.pairing.payoutAmount) return;
      var currencyOptions = [{ text: 'SG', value: 'SGD' }, { text: 'ID', value: 'IDR' }, { text: 'PH', value: 'PHP' }, { text: 'TH', value: 'THB' }, { text: 'MY', value: 'MYR' }, { text: 'VN', value: 'VND' }];
      var targetLocation = Array.isArray(this.campaign.targetLocation) ? this.campaign.targetLocation[0] : this.campaign.targetLocation;
      var selectedCurrency = currencyOptions.find(function (option) {
        return option.text === targetLocation;
      });
      if (selectedCurrency) {
        this.updateData.currency = selectedCurrency.value;
      }
    }
  }
});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__ = __webpack_require__(28);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    pairedInfluencer: Object,
    campaignData: Object,
    multiple: Boolean,
    multipleInfs: Array
  },
  data: function data() {
    return {
      influencer: null,
      campaign: null,
      selectedPriceMethod: null,
      priceEffortMultiplier: {},
      showEmptyAlert: false,

      no_of_tiktok_posts: 0,
      no_of_xhs_posts: 0,
      no_of_fb_posts: 0,
      no_of_posts: 0,
      no_of_carousels: 0,
      no_of_video: 0,
      no_of_stories: 0,
      no_of_reels: 0,
      no_of_li_posts: 0,
      no_of_x_posts: 0,
      loading_whitelisting: 0,
      youtube: 0,
      exclusivity: 0,
      physical_attendance: 0,
      online_attendance: 0,
      customDeliverables: []
    };
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },
    save: function save() {
      var _this = this;

      if (this.multiple) {
        this.saveMultiple();
        return;
      }
      var saveCustomDeliverables = this.customDeliverables.filter(function (custom) {
        return custom.label;
      });
      var data = {
        pairingID: this.influencer.pairingID,

        no_of_tiktok_posts: this.no_of_tiktok_posts,
        no_of_fb_posts: this.no_of_fb_posts,
        no_of_xhs_posts: this.no_of_xhs_posts,
        no_of_posts: this.no_of_posts,
        no_of_carousels: this.no_of_carousels,
        no_of_stories: this.no_of_stories,
        no_of_reels: this.no_of_reels + this.no_of_video,
        no_of_li_posts: this.no_of_li_posts,
        no_of_x_posts: this.no_of_x_posts,
        loading_whitelisting: parseInt(this.loading_whitelisting),
        youtube: this.youtube,
        exclusivity: parseInt(this.exclusivity),
        physical_attendance: this.physical_attendance,
        online_attendance: this.online_attendance,
        customDeliverables: saveCustomDeliverables,
        remarks: this.pairedInfluencer.remarks || ''
      };
      __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].updatePairingStatus(data).then(function () {
        _this.$swal({
          position: 'top-center',
          title: 'Saved Changes',
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        });
        _this.$emit('savedFromPriceMultplier');
      }).catch(function (error) {
        _this.$swal({
          position: 'top-center',
          title: 'Error while updating pairing',
          type: 'error',
          timer: 1500
        });
        console.log(error);
      });
    },
    saveMultiple: function saveMultiple() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, inf, saveCustomDeliverables;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this2.multipleInfs);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 15;
                  break;
                }

                inf = _step.value;
                saveCustomDeliverables = _this2.customDeliverables.filter(function (custom) {
                  return custom.label;
                });

                data = {
                  pairingID: inf.pairingID,

                  no_of_tiktok_posts: _this2.no_of_tiktok_posts,
                  no_of_fb_posts: _this2.no_of_fb_posts,
                  no_of_xhs_posts: _this2.no_of_xhs_posts,
                  no_of_posts: _this2.no_of_posts,
                  no_of_carousels: _this2.no_of_carousels,
                  no_of_stories: _this2.no_of_stories,
                  no_of_reels: _this2.no_of_reels + _this2.no_of_video,
                  no_of_li_posts: _this2.no_of_li_posts,
                  no_of_x_posts: _this2.no_of_x_posts,
                  loading_whitelisting: parseInt(_this2.loading_whitelisting),
                  youtube: _this2.youtube,
                  exclusivity: parseInt(_this2.exclusivity),
                  physical_attendance: _this2.physical_attendance,
                  online_attendance: _this2.online_attendance,
                  customDeliverables: saveCustomDeliverables,
                  remarks: inf.remarks || ''
                };
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].updatePairingStatus(data);

              case 12:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 21:
                _context.prev = 21;
                _context.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context.prev = 24;

                if (!_didIteratorError) {
                  _context.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context.finish(24);

              case 28:
                return _context.finish(21);

              case 29:
                _this2.$swal({
                  position: 'top-center',
                  title: 'Saved Changes',
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });
                _this2.$emit('clearSelected');
                _this2.$emit('savedFromPriceMultplier');

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 17, 21, 29], [22,, 24, 28]]);
      }))();
    },
    multipliedAmount: function multipliedAmount(price1, price2) {
      if (this.selectedPriceMethod === 'price1') {
        return this.calculateActulPrice(Number(price1));
      } else if (this.selectedPriceMethod === 'price2') {
        return this.calculateActulPrice(Number(price2));
      } else {
        return 0;
      }
    },
    calculateActulPrice: function calculateActulPrice(predictedPrice) {
      var basePrice = predictedPrice;
      var requiredActionMultiplier = this.priceEffortMultiplier.requiredActionMultiplier;
      var timeRequiredMultiplier = this.priceEffortMultiplier.timeRequiredMultiplier;
      var productValueMultiplier = this.priceEffortMultiplier.productValueMultiplier;
      var audienceCredibilityMultiplier = this.priceEffortMultiplier.audienceCredibilityMultiplier;
      var deliverablesMultiplier = this.getDeliverablesMultiplier(Number(this.no_of_tiktok_posts), Number(this.no_of_posts), Number(this.no_of_carousels), Number(this.no_of_video), Number(this.no_of_stories), Number(this.no_of_reels));
      this.priceEffortMultiplier.deliverablesMultiplier = deliverablesMultiplier;
      var actualPrice = Math.round(basePrice * requiredActionMultiplier * timeRequiredMultiplier * productValueMultiplier * audienceCredibilityMultiplier * deliverablesMultiplier * 100) / 100;
      return actualPrice;
    },
    getDeliverablesMultiplier: function getDeliverablesMultiplier(tikTokPostCount, postCount, carouselsCount, videoCount, storyCount, reelCount) {
      var arbValueVideo = 1.2;
      var arbValueStory = 0.5;
      var arbValueReel = 2;
      var tiktokPostResult = tikTokPostCount > 0 ? Math.round((1 + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default()(tikTokPostCount)) * 100) / 100 : 1;
      var postResult = postCount > 0 ? Math.round((1 + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default()(postCount)) * 100) / 100 : 1;
      var carouselsResult = carouselsCount > 0 ? Math.round((1 + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default()(carouselsCount)) * 100) / 100 : 1;
      var videoResult = videoCount > 0 ? Math.round((1 + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default()(videoCount)) * arbValueVideo * 100) / 100 : 1;
      var storyResult = storyCount > 0 ? Math.round((1 + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default()(storyCount) * arbValueStory) * 100) / 100 : 1;
      var reelResult = reelCount > 0 ? Math.round((1 + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_log10___default()(reelCount) * arbValueReel) * 100) / 100 : 1;
      return Math.round(tiktokPostResult * postResult * carouselsResult * videoResult * storyResult * reelResult * 100) / 100;
    },
    appendNewCustom: function appendNewCustom() {
      this.customDeliverables.push({
        label: '',
        value: 0
      });
    },
    deleteCustom: function deleteCustom(index) {
      this.customDeliverables.splice(index, 1);
    },
    resetData: function resetData() {
      this.no_of_tiktok_posts = 0;
      this.no_of_fb_posts = 0;
      this.no_of_xhs_posts = 0;
      this.no_of_posts = 0;
      this.no_of_carousels = 0;
      this.no_of_video = 0;
      this.no_of_stories = 0;
      this.no_of_reels = 0;
      this.no_of_li_posts = 0;
      this.no_of_x_posts = 0;
      this.loading_whitelisting = 0;
      this.youtube = 0;
      this.exclusivity = 0;
      this.physical_attendance = 0;
      this.online_attendance = 0;
      this.customDeliverables = 0;
    }
  },
  watch: {
    pairedInfluencer: function pairedInfluencer(newData) {
      this.resetData();
      if (newData) {
        this.influencer = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newData);

        if (!this.multiple) {
          this.no_of_tiktok_posts = newData.no_of_tiktok_posts;
          this.no_of_fb_posts = newData.no_of_fb_posts || 0;
          this.no_of_xhs_posts = newData.no_of_xhs_posts;
          this.no_of_posts = newData.no_of_posts;
          this.no_of_carousels = newData.no_of_carousels;
          this.no_of_video = newData.no_of_video;
          this.no_of_stories = newData.no_of_stories;
          this.no_of_reels = newData.no_of_reels;
          this.no_of_li_posts = newData.no_of_li_posts || 0;
          this.no_of_x_posts = newData.no_of_x_posts || 0;
          this.loading_whitelisting = newData.loading_whitelisting || 0;
          this.youtube = newData.youtube || 0;
          this.exclusivity = newData.exclusivity || 0;
          this.physical_attendance = newData.physical_attendance || 0;
          this.online_attendance = newData.online_attendance || 0;
          this.customDeliverables = newData.customDeliverables;
          this.priceEffortMultiplier = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newData.priceEffortMultiplier);
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.priceEffortMultiplier).length === 0 && this.priceEffortMultiplier.constructor === Object ? this.showEmptyAlert = true : this.showEmptyAlert = false;
        }
      }
    },
    campaignData: function campaignData(newData) {
      if (newData) {
        this.campaign = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newData);
      }
    }
  }
});

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReqCOGSApproval',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    pairing: Object,
    campaignID: String,
    amount: Number,
    reasons: String,
    budget: Number,
    currentCOGS: Number,
    cogsPercent: Number
  },
  validations: {
    updateData: {
      amount: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      reasons: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      updateData: {
        amount: '',
        reasons: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    savedAmountApproval: function savedAmountApproval(state) {
      return state.pairing.savedAmountApproval;
    }
  })),
  watch: {
    value: function value(newValue) {
      this.updateData.amount = this.amount;
      this.updateData.reasons = this.reasons;
    }
  },
  methods: {
    saveReqApproval: function saveReqApproval() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$swal({
                  title: 'Are you sure?',
                  type: 'warning',
                  confirmButtonText: 'Proceed',
                  showCancelButton: true,
                  text: 'Your request will be sent to the admin for approval, please note that this campaign will be reflected as burst cogs if approved and will be evaluated during appraisal accordingly.'
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
                    var saveData;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!result.value) {
                              _context2.next = 7;
                              break;
                            }

                            _this2.isLoading = true;
                            saveData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                              pairingID: _this2.pairing.pairingID,
                              campaignID: _this2.campaignID,
                              budget: _this2.budget,
                              currentCOGS: _this2.currentCOGS,
                              cogsPercent: _this2.cogsPercent,
                              amount: _this2.updateData.amount,
                              reasons: _this2.updateData.reasons,
                              status: 'pending'
                            });
                            _context2.next = 5;
                            return _this2.$store.dispatch('pairing/saveAmountApproval', saveData);

                          case 5:
                            _this2.isLoading = false;
                            if (_this2.savedAmountApproval) {
                              _this2.$swal({
                                text: 'Successfully Requested for Approval.',
                                type: 'success'
                              });
                              _this2.$emit('saved');
                              _this2.close();
                            } else {
                              _this2.$swal({
                                text: 'Error Approval Request!',
                                type: 'error'
                              });
                            }

                          case 7:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      size: this.$store.state.aiMatchParams.size,
      minFollowers: this.$store.state.aiMatchParams.minFollowers,
      postDate: this.$store.state.aiMatchParams.postDate
    };
  },

  methods: {
    close: function close() {
      this.$emit('input');
    },
    saveChanges: function saveChanges() {
      var params = {
        size: this.size,
        minFollowers: this.minFollowers,
        postDate: this.postDate
      };
      this.$store.commit('SET_MATCH_PARAMS', params);
      this.$emit('paramsUpdated');
      this.close();
    }
  },
  computed: {
    formattedDate: function formattedDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.postDate).format('DD-MM-YYYY');
    }
  }
});

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activePairingData: null
    };
  },

  props: {
    value: Boolean,
    viewOnly: Boolean,
    data: Object
  },
  watch: {
    data: function data(value) {
      if (value) {
        this.activePairingData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, value);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    pairingStatusOptions: function pairingStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    }
  }),
  methods: {
    updatePairingStatus: function updatePairingStatus() {
      var _this = this;

      if (this.activePairingData !== null) {
        var data = {
          pairingID: this.activePairingData.pairingID,
          pairingStatus: this.activePairingData.pairingStatus,
          remarks: this.activePairingData.remarks,
          min_payout: this.activePairingData.min_payout,
          max_payout: this.activePairingData.max_payout
        };
        __WEBPACK_IMPORTED_MODULE_3__Pairing_pairingAPIs__["a" /* default */].updatePairingStatus(data).then(function () {
          _this.$swal({
            position: 'top-center',
            title: 'Status Updated',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this.$emit('pairChanged');
        }).catch(function (error) {
          _this.$swal({
            position: 'top-center',
            title: 'Error while updating pairing',
            type: 'error',
            timer: 1500
          });
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubmissionDateModal',
  props: {
    value: Boolean,
    pairing: Object,
    multiplePairings: Array
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      submissionDate: '',
      menu: '',
      isLoading: false,
      showDialog: false
    };
  },

  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push('Email is required');
      return errors;
    },
    submissionDateFormatted: function submissionDateFormatted() {
      return this.submissionDate ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.submissionDate).format('DD/MM/yyyy') : '';
    }
  },
  watch: {
    pairing: function pairing(value) {
      this.showDialog = true;
      if (value.pairing_details) {
        if (value.pairing_details.submission_date) {
          this.submissionDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value.pairing_details.submission_date).format('YYYY-MM-DD');
        }
      }
    },
    value: function value(newValue) {
      this.showDialog = true;
    }
  },
  methods: {
    updateSubmission: function updateSubmission() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, pairingIDs, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.submissionDate) {
                  _context.next = 3;
                  break;
                }

                _this.$swal({
                  type: 'warning',

                  title: 'Invalid Submission Date',
                  text: 'Make sure you filled the date correctly.'
                });
                return _context.abrupt('return');

              case 3:
                _this.isLoading = true;
                formData = new FormData();

                if (_this.multiplePairings.length) {
                  pairingIDs = _this.multiplePairings.map(function (m) {
                    return m.id;
                  });

                  formData.append('multiplepairingIDs', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(pairingIDs));
                } else {
                  formData.append('pairingID', _this.pairing.id);
                }

                formData.append('submissionDate', _this.submissionDate);

                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].updateSubmissionDate(formData);

              case 9:
                resp = _context.sent;

                _this.isLoading = false;

                if (resp.status) {
                  _context.next = 14;
                  break;
                }

                _this.$swal({
                  text: 'Error updating submission date.',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 14:
                _this.$swal({
                  text: 'Successfully updated Submission Date.',
                  type: 'success'
                });
                _this.$emit('updated');
                _this.closeModal();

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    closeModal: function closeModal() {
      this.showDialog = false;
      this.$emit('input');
      this.$emit('closeModal');
      this.submissionDate = '';
    }
  }
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdateCreatorEmailModal',
  props: {
    value: Boolean,
    pairing: Object
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      email: '',
      isLoading: false
    };
  },

  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    influencerHandle: function influencerHandle() {
      return this.pairing && this.pairing.influencer_details ? this.pairing.influencer_details.instagramHandle : '';
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push('Email is required');
      return errors;
    }
  },
  methods: {
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    },
    updateEmail: function updateEmail() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contactDetails, infDtls, updatePairings, formData, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 4;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Invalid Email',
                  text: 'Make sure you filled the passcode correctly.'
                });
                return _context.abrupt('return');

              case 4:
                if (!(!_this.pairing || !_this.pairing.id)) {
                  _context.next = 7;
                  break;
                }

                _this.$swal({
                  text: 'Pairing data is unavailable. Please refresh and try again.',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 7:
                _this.isLoading = true;
                contactDetails = {};
                infDtls = null;

                if (_this.pairing.influencer_details) {
                  infDtls = _this.pairing.influencer_details;
                  if (_this.pairing.influencer_details.contact_details) {
                    contactDetails = _this.pairing.influencer_details.contact_details;
                  }
                  contactDetails.email = _this.email;
                  infDtls.contact_details = contactDetails;
                }
                updatePairings = [{
                  id: _this.pairing.id,
                  'influencer_details': infDtls
                }];
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context.next = 16;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].updatePairings(formData);

              case 16:
                resp = _context.sent;

                if (!(_this.pairing && _this.pairing.influencer_details && _this.pairing.influencer_details.influencerID)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return __WEBPACK_IMPORTED_MODULE_6__Influencer_influencerAPIs__["a" /* default */].editInfluencer({
                  id: _this.pairing.influencer_details.influencerID,
                  email: _this.email
                });

              case 20:
                _this.isLoading = false;

                if (resp.status) {
                  _context.next = 24;
                  break;
                }

                _this.$swal({
                  text: 'Error updating email.',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 24:
                _this.$swal({
                  text: 'Successfully updated email.',
                  type: 'success'
                });
                _this.$emit('updated');
                _this.closeModal();

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    closeModal: function closeModal() {
      this.$v.$reset();
      this.$emit('input');
      this.email = '';
    }
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdateSubmissionDateModal',
  props: {
    value: Boolean,
    pairing: Object
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      submissionDate: '',
      menu: '',
      isLoading: false,
      showDialog: false
    };
  },

  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push('Email is required');
      return errors;
    },
    submissionDateFormatted: function submissionDateFormatted() {
      return this.submissionDate ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.submissionDate).format('DD/MM/yyyy') : '';
    }
  },
  watch: {
    pairing: function pairing(value) {
      this.showDialog = true;
      if (value.pairing_details) {
        if (value.pairing_details.submission_date) {
          this.submissionDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value.pairing_details.submission_date).format('YYYY-MM-DD');
        }
      }
    }
  },
  methods: {
    updateSubmission: function updateSubmission() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.submissionDate) {
                  _context.next = 3;
                  break;
                }

                _this.$swal({
                  type: 'warning',
                  title: 'Invalid Submission Date',
                  text: 'Make sure you filled the date correctly.'
                });
                return _context.abrupt('return');

              case 3:
                _this.isLoading = true;
                formData = new FormData();

                formData.append('pairingID', _this.pairing.id);
                formData.append('submissionDate', _this.submissionDate);
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_5__Pairing_pairingAPIs__["a" /* default */].updateSubmissionDate(formData);

              case 9:
                resp = _context.sent;

                _this.isLoading = false;

                if (resp.status) {
                  _context.next = 14;
                  break;
                }

                _this.$swal({
                  text: 'Error updating submission date.',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 14:
                _this.$swal({
                  text: 'Successfully updated Submission Date.',
                  type: 'success'
                });
                _this.$emit('updated');
                _this.closeModal();

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    closeModal: function closeModal() {
      this.showDialog = false;
      this.$emit('input');
      this.$emit('closeModal');
      this.submissionDate = '';
    }
  }
});

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerListModal__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InfluencerListModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__InfluencerListModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReqCogsApprovalModal__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReqCogsApprovalModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ReqCogsApprovalModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PayoutUpdateModal__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PayoutUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__PayoutUpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scoped_custom_KToast__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scoped_custom_KToast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__scoped_custom_KToast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_custom_FullScreenProgress__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_custom_FullScreenProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__scoped_custom_FullScreenProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_influencer_InfluencerSearchBox__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_influencer_InfluencerSearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__scoped_influencer_InfluencerSearchBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Influencer_RateCard_Preview_vue__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Influencer_RateCard_Preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Influencer_RateCard_Preview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsForAIModal__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SettingsForAIModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__SettingsForAIModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__SettingsForPairing__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__SettingsForPairing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__SettingsForPairing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PriceMultiplierModal__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PriceMultiplierModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__PriceMultiplierModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__PairingEliminationEditModal__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__PairingEliminationEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__PairingEliminationEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_chartjs_Pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_chartjs_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_chartjs_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_lodash_sortBy__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuex__ = __webpack_require__(12);















































var SearchTypeEnum = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze___default()({ KEYWORD: 'keyword', HANDLE: 'handle', BULKUPLOAD: 'bulkupload' });
var Steps = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_freeze___default()({ FIND_INFLUENCERS: 1, REVIEW: 2, ELIMINATION: 3 });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPairingModal',
  props: {
    value: Boolean,
    campaignData: Object,
    client: Object,
    unlockCogs: Boolean
  },
  components: {
    influencerList: __WEBPACK_IMPORTED_MODULE_16__Influencer_InfluencerDataTable_vue___default.a,
    pairingInfluencersTable: __WEBPACK_IMPORTED_MODULE_17__Pairing_PairingDataTable_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_23_vue_loading_overlay___default.a,
    InfluencerListModal: __WEBPACK_IMPORTED_MODULE_19__InfluencerListModal___default.a,
    KInfluencerSearchBox: __WEBPACK_IMPORTED_MODULE_26__scoped_influencer_InfluencerSearchBox___default.a,
    KToast: __WEBPACK_IMPORTED_MODULE_24__scoped_custom_KToast___default.a,
    FullScreenProgress: __WEBPACK_IMPORTED_MODULE_25__scoped_custom_FullScreenProgress___default.a,
    SettingsForAiModal: __WEBPACK_IMPORTED_MODULE_31__SettingsForAIModal___default.a,
    SettingsForPairing: __WEBPACK_IMPORTED_MODULE_32__SettingsForPairing___default.a,
    PriceMultiplierModal: __WEBPACK_IMPORTED_MODULE_33__PriceMultiplierModal___default.a,
    PairingEliminationEditModal: __WEBPACK_IMPORTED_MODULE_34__PairingEliminationEditModal___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_36_vuedraggable___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_37__components_chartjs_Pie___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle___default.a,
    RateCardPreview: __WEBPACK_IMPORTED_MODULE_27__Influencer_RateCard_Preview_vue___default.a,

    ReqCogsApprovalModal: __WEBPACK_IMPORTED_MODULE_20__ReqCogsApprovalModal___default.a,
    PayoutUpdateModal: __WEBPACK_IMPORTED_MODULE_21__PayoutUpdateModal___default.a
  },
  data: function data() {
    var _this = this;

    return {
      optionVal: 0,
      showFrozenPairingColumns: true,
      toast: {
        variant: '',
        content: '',
        header: ''
      },
      fromAI: {
        force: false,
        page: 0
      },
      loadingAI: false,
      bulkProgress: {
        loading: true,
        processing: 0,
        complete: 0
      },
      utilsFunc: __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func,
      showEditDialog: false,
      reasonDialog: false,
      settingAIDialog: false,

      lockedPayout: false,
      reqApprovalDialog: false,
      editPayoutDialog: false,
      eliminationDialog: false,
      campaingDataForElimination: {},

      reqApprovalPairing: {},
      payoutEditPairing: {},
      reqAmt: '',
      reqReasons: '',
      eliminationReason: '',

      eliminationStatus: __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].eliminationStatus,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].payoutStatus,
      genders: ['Male', 'Female'],
      ageGroups: ['18-24', '25-34', '35-44', '13-17', '45-64', '65-'],
      actions: [{ name: 'Delete', color: 'red', method: 'delete', icon: 'delete' }, { name: 'Edit', color: 'secondary', method: 'edit', icon: 'edit' }, { name: 'View', color: 'secondary', method: 'view', icon: 'mdi-eye' }],
      headers: [{ text: 'Last Report Date', sortable: true, value: 'lastReportDate', align: 'center', name: 'lastReportDate' }, {
        text: 'Influencer',
        align: 'center',
        sortable: false,
        value: 'userHandle',
        name: 'influencer'
      }, { text: 'Platform', sortable: true, value: 'platformName', align: 'center', name: 'platformName' }, { text: 'Remark', sortable: true, value: 'remarks', align: 'center', name: 'remark' }, { text: 'Content Feature/pillar', sortable: true, value: 'contentFeature', align: 'center', name: 'contentFeature' }, { text: 'Gender', sortable: false, value: 'gender', align: 'center', name: 'gender' }, { text: 'Age Group', sortable: false, value: 'age_group', align: 'center', name: 'ageGroup' }, { text: 'Aud. Age Group', sortable: false, value: 'aud_age_group', align: 'center', name: 'audAgeGroup' }, { text: 'Aud. Country', sortable: false, value: 'country', align: 'center', name: 'country' }, { text: 'Followers', align: 'center', sortable: false, value: 'followers', name: 'followers' }, { text: 'Follower Gender', sortable: false, value: 'genderPercentage', align: 'center', name: 'genderPercentage' }, { text: 'Audience Cred.', sortable: false, align: 'center', value: 'audience_credibility', name: 'audienceCred' }, { text: 'Avg. Likes', sortable: false, align: 'center', value: 'avg_likes', name: 'avgLikes' }, { text: 'Avg. Comments', sortable: false, align: 'center', value: 'avg_comments', name: 'avgComments' }, { text: 'Avg. Reels Plays (IG)', sortable: false, align: 'center', value: 'avg_reels_plays', name: 'avgReelsPlays' }, { text: 'Avg. Views (TT)', sortable: false, align: 'center', value: 'avg_views', name: 'avgViews' }, { text: 'Avg. Saves (TT)', sortable: false, align: 'center', value: 'avg_saves', name: 'avgSaves' }, { text: 'Avg. Shares (TT)', sortable: false, align: 'center', value: 'avg_shares', name: 'avgShares' }, { text: 'Median Engagement Rate', sortable: false, align: 'center', value: 'median_engagement_rate', name: 'medianEngagementRate' }, { text: 'Influencer interests', sortable: false, align: 'center', value: 'infInterests', name: 'infInterests' }, { text: 'Audience interests', sortable: false, align: 'center', value: 'audience_interests', name: 'interests' }, { text: 'Engagement', sortable: false, align: 'center', value: 'engagement_rate', name: 'engagement' }, { text: 'Rate Card', sortable: false, align: 'center', value: '', name: 'rateCard' }, { text: 'Elimination Status', sortable: false, align: 'center', value: '', name: 'eliminationStatus' }, { text: 'Deliverables', sortable: false, align: 'center', value: 'predictedAmount', name: 'AIPayout', class: 'pairing-freeze-deliverables' }, { text: 'Payout', sortable: false, align: 'center', value: 'payoutAmount', name: 'payout', class: 'pairing-freeze-payout' }, { text: 'Pairing Status', sortable: false, align: 'center', value: '', name: 'pairingStatus', class: 'pairing-freeze-pairing' }],
      json_fields: {
        'Handle': {
          callback: function callback(item) {
            if (item.platform === 'instagram') {
              return '<a href=\'http://instagram.com/' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'tiktok') {
              return '<a href=\'https://www.tiktok.com/@' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'youtube') {
              return '<a href=\'https://youtube.com/@' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'xiaohongshu') {
              return '<a href=\'https://xiaohongshu.com/user/profile/' + item.xhsID + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'facebook') {
              return '<a href=\'https://facebook.com/@' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'linkedin') {
              return '<a href=\'https://www.linkedin.com/in/' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'twitter') {
              return '<a href=\'https://x.com/' + item.userHandle + '\'>' + item.userHandle + '</a>';
            }
            if (item.platform === 'others') {
              return '<a>' + item.userHandle + '</a>';
            }
          }
        },
        Platform: 'platform',
        'Custom Platform Name': 'platformName',
        Remark: 'remarks',
        'Content Feature/pillar': 'contentFeature',
        Gender: 'gender',
        'Age Group': 'age_group',
        'Aud. Age Group': 'displayAudAge',
        'Aud. Country': 'displaytopCountry',
        Followers: 'followers',
        'Follower Gender': 'audGenderDisplay',
        'Audience Cred.': 'audience_credibility',
        'Avg. Likes': 'avg_likes',
        'Avg. Comments': 'avg_comments',
        'Avg. Reels Plays (IG)': 'avg_reels_plays',
        'Avg. Views (TT)': 'avg_views',
        'Avg. Saves (TT)': 'avg_saves',
        'Avg. Shares (TT)': 'avg_shares',
        'Median Engagement Rate': 'medianEngRateDisplay',
        'Influencer Interests': 'infInterestDisplay',
        'Aud. Interests': 'audInterestDisplay',
        Engagement: 'engagementRateDisplay',
        'TikTok Posts': 'no_of_tiktok_posts',
        'Posts': 'no_of_posts',
        'Carousels': 'no_of_carousels',
        Videos: 'no_of_video',
        Stories: 'no_of_stories',
        Reels: 'no_of_reels',
        Youtube: 'youtube',
        XHS: 'no_of_xhs_posts',
        Facebook: 'no_of_fb_posts',
        LinkedIn: 'no_of_li_posts',
        X: 'no_of_x_posts',
        'Elimination Status': {
          callback: function callback(item) {
            if (item.eliminationStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].eliminationStatus.SELECTED) {
              return 'SELECTED';
            }
            if (item.eliminationStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].eliminationStatus.PENDING) {
              return 'PENDING CLIENT';
            }
            if (item.eliminationStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].eliminationStatus.NEW) {
              return 'NEW';
            }
            return 'ELIMINATED';
          }
        },
        'Pairing Status': {
          field: 'pairingStatus',
          callback: function callback(value) {
            var pairingLable = void 0;
            __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(_this.pairingStatus).forEach(function (item) {
              if (item[1].value === value) {
                pairingLable = item[1].text;
              }
            });

            return pairingLable;
          }
        },
        'Elimination Reason': 'eliminationReason',
        Remarks: 'remarks'
      },
      showHideFields: [{
        name: 'influencer',
        label: 'Influencer'
      }, {
        name: 'lastReportDate',
        label: 'Last Report Date'
      }, {
        name: 'platformName',
        label: 'Platform Name'
      }, {
        name: 'remark',
        label: 'Remarks'
      }, {
        name: 'contentFeature',
        label: 'Content Feature'
      }, {
        name: 'gender',
        label: 'Gender'
      }, {
        name: 'ageGroup',
        label: 'Age Group'
      }, {
        name: 'audAgeGroup',
        label: 'Aud. Age Group'
      }, {
        name: 'country',
        label: 'Aud. Country'
      }, {
        name: 'followers',
        label: 'Followers'
      }, {
        name: 'genderPercentage',
        label: 'Follower Gender'
      }, {
        name: 'audienceCred',
        label: 'Audience Cred.'
      }, {
        name: 'avgLikes',
        label: 'Avg. Likes'
      }, {
        name: 'avgComments',
        label: 'Avg. Comments'
      }, {
        name: 'avgReelsPlays',
        label: 'Avg. Reels Plays (IG)'
      }, {
        name: 'avgViews',
        label: 'Avg. Views (TT)'
      }, {
        name: 'avgSaves',
        label: 'Avg. Saves (TT)'
      }, {
        name: 'avgShares',
        label: 'Avg. Shares (TT)'
      }, {
        name: 'medianEngagementRate',
        label: 'Median Engagement Rate'
      }, {
        name: 'infInterests',
        label: 'Influencer interests'
      }, {
        name: 'interests',
        label: 'Audience interests'
      }, {
        name: 'engagement',
        label: 'Engagement'
      }, {
        name: 'rateCard',
        label: 'Rate Card'
      }, {
        name: 'AIPayout',
        label: 'Deliverables'
      }],
      defaultPairingDisplayStatus: {
        influencer: true,
        lastReportDate: true,
        platformName: true,
        remark: true,
        contentFeature: true,
        gender: true,
        genderPercentage: true,
        ageGroup: true,
        audAgeGroup: true,
        country: true,
        followers: true,
        audienceCred: true,
        avgLikes: true,
        avgComments: true,
        avgViews: true,
        avgReelsPlays: true,
        medianEngagementRate: true,
        infInterests: true,
        interests: true,
        engagement: true,
        rateCard: true,
        AIPayout: true,
        payout: true,
        eliminationStatus: true,
        pairingStatus: true
      },
      items: [],
      pairedInfluencers: [],
      listReview: [],
      suggestedInfluencers: [],
      isLoading: false,
      campaign: {},
      searchKeywordAction: '',
      SearchTypeEnum: SearchTypeEnum,
      Steps: Steps,
      igHandle: '',
      viewOnly: false,
      searchType: SearchTypeEnum.HANDLE,
      actionSelected: [],
      selected: [],
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0
      },
      historySearchResult: null,
      currentKeywordSearch: '',
      pairingStepper: Steps.FIND_INFLUENCERS,
      showInfluencerSearchResult: false,
      influencerSearchResult: null,
      activePairingData: null,
      updatePairingDialog: false,
      priceMultiplierDialog: false,
      priceMultiplierInfluencerData: null,
      lineUpItems: [],
      genderItems: ['Male', 'Female'],
      genderPie: {
        title: 'Report Abuse in %',
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center'
          }
        },
        width: 50,
        height: 50
      },
      searchInfluencerTypes: [{ text: 'Instagram', value: 'Instagram', icon: 'mdi-instagram', iconColor: '#E1306C' }, { text: 'TikTok', value: 'TikTok', imgIcon: '/static/img/tiktok-32.png' }, { text: 'Youtube', value: 'Youtube', icon: 'mdi-youtube', iconColor: '#FF0000' }, { text: 'Facebook', value: 'Facebook', icon: 'mdi-facebook', iconColor: '#1877F2' }, { text: 'LinkedIn', value: 'LinkedIn', icon: 'mdi-linkedin', iconColor: '#0A66C2' }, { text: 'X (Twitter)', value: 'Twitter', imgIcon: '/static/img/x-logo.svg' }, { text: 'Xiaohongshu', value: 'Xiaohongshu', imgIcon: '/static/img/xhs-black.png' }, { text: 'Others', value: 'Others', icon: 'mdi-help-circle', iconColor: '#616161' }],
      filteredItems: [],
      ageItems: [],
      locationItems: [],
      searchGender: '',
      searchAge: '',
      searchLocation: '',
      searchPairingStatus: '',
      searchAudCrediblity: '',
      searchInfluencer: 'Instagram',
      platformName: '',
      topFiveAudienceInterests: [],
      disableSaveLineUp: true,
      disableSaveEdit: true,
      isOpen: '',
      openExpansion: [],
      inputRates: {},
      rateCardFormRates: {},
      isPricingDeskEmpty: false,
      isEditing: false,
      searchFilter: '',
      audCrediblityFilters: [{ name: 'Red', min: 0, max: 30 }, { name: 'Orange', min: 30, max: 50 }, { name: 'Green', min: 50, max: 100 }],
      markupCOGSAmount: false,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_14__campaignHelper__["a" /* default */],
      oldEditItem: null,
      isMultipleDeliverables: false,
      showPie: true,
      currencyTotals: {},
      disableSort: false,
      searchMethods: [{ text: 'Search by Handle', value: SearchTypeEnum.HANDLE }, { text: 'Search by Keyboard', value: SearchTypeEnum.KEYWORD }, { text: 'Bulk Upload', value: SearchTypeEnum.BULKUPLOAD }]
    };
  },

  watch: {
    campaignData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee(newCampaignData) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.campaign = newCampaignData;
                this.campaign.pairingDisplayStatus = this.campaign.pairingDisplayStatus || this.defaultPairingDisplayStatus;

                this.measurement = {
                  total: 0,
                  outreach: 0,
                  engagement: 0,
                  budget: 0,
                  outreachPercentage: 0,
                  engagementPercentage: 0,
                  cogsPercentage: 0
                };
                this.toast = {
                  content: '',
                  header: '',
                  variant: ''
                };
                this.clearPairingData();
                _context.next = 7;
                return this.$store.dispatch('payment/getCurrencyRates');

              case 7:
                this.getPairedInfluencers(this.campaign.id);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function campaignData(_x) {
        return _ref.apply(this, arguments);
      }

      return campaignData;
    }(),
    items: function items(newList) {
      this.calcMeasurements(newList);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40_vuex__["b" /* mapState */])({
    rateCards: function rateCards(state) {
      return state.influencer.rateCards;
    },
    requestedPayoutEdit: function requestedPayoutEdit(state) {
      return state.pairing.requestedPayoutEdit;
    },
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    },
    infDetail: function infDetail(state) {
      return state.influencer.infDetail;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  }), {
    filteredHeaders: function filteredHeaders() {
      var _this2 = this;

      return this.headers.filter(function (h) {
        if (!_this2.showFrozenPairingColumns && ['AIPayout', 'payout', 'pairingStatus'].includes(h.name)) {
          return false;
        }
        var pairingDisplayStatus = _this2.campaign.pairingDisplayStatus;
        if (pairingDisplayStatus !== undefined) {
          if (h.name !== undefined && !pairingDisplayStatus[h.name]) {
            return false;
          }
        }
        return true;
      });
    },
    selectAllStatus: function selectAllStatus() {
      return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.actionSelected);
    },

    showBtnCO: function showBtnCO() {
      if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        return true;
      } else {
        return false;
      }
    },
    showBtnAM: function showBtnAM() {
      if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        return true;
      } else {
        return false;
      }
    },
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAdmin: function isAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    pairingStatusOptions: function pairingStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    },
    acceptPairingStatusOptions: function acceptPairingStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        if (item[1].value === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.ACCEPTED || item[1].value === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NOT_ACCEPTED) {
          data.push({
            status: item[1].value,
            display: item[1].text
          });
        }
      });
      return data;
    },
    filterPairingStatusOptions: function filterPairingStatusOptions() {
      var data = [{
        status: '',
        display: 'Status (All)'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NEW,
        display: 'Status (New) - ' + this.newPairings
      }, {
        status: __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.ACCEPTED,
        display: 'Status (Accepted) - ' + this.accepted
      }, {
        status: __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NOT_ACCEPTED,
        display: 'Status (Not Accepted) - ' + this.notAccepted
      }];

      return data;
    },
    budget: function budget() {
      this.markupCOGSAmount = __WEBPACK_IMPORTED_MODULE_14__campaignHelper__["a" /* default */].getMarkupCOGS(this.campaign.ioNumbers, this.client);
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaign.budget * 0.26);
    },
    newPairings: function newPairings() {
      var _this3 = this;

      return this.items.filter(function (item) {
        return item.pairingStatus === _this3.pairingStatus.NEW.value;
      }).length;
    },
    accepted: function accepted() {
      var _this4 = this;

      return this.items.filter(function (item) {
        return item.pairingStatus === _this4.pairingStatus.ACCEPTED.value;
      }).length;
    },
    notAccepted: function notAccepted() {
      var _this5 = this;

      return this.items.filter(function (item) {
        return item.pairingStatus === _this5.pairingStatus.NOT_ACCEPTED.value;
      }).length;
    },
    newEliminations: function newEliminations() {
      var _this6 = this;

      return this.items.filter(function (item) {
        return item.eliminationStatus === _this6.eliminationStatus.NEW;
      }).length;
    },
    noOfSelected: function noOfSelected() {
      var _this7 = this;

      return this.items.filter(function (item) {
        return item.eliminationStatus === _this7.eliminationStatus.SELECTED;
      }).length;
    },
    noOfEliminated: function noOfEliminated() {
      var _this8 = this;

      return this.items.filter(function (item) {
        return item.eliminationStatus === _this8.eliminationStatus.ELIMINATED;
      }).length;
    },
    disableLockedCOGS: function disableLockedCOGS() {
      return this.campaign.lockedCOGS || false;
    },
    showLockBtn: function showLockBtn() {
      if (this.campaign.id && !this.campaign.lockedCOGS && (Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].userRoles.AD_STRATEGIST)) {
        return true;
      }
      return false;
    }
  }),
  mounted: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(this.campaign).length !== 0 && this.campaign.constructor !== Object) {
                this.getPairedInfluencers(this.campaign.id);
              }
              this.getCountries();
              _context2.next = 4;
              return this.getRateCardLists();

            case 4:
              _context2.next = 6;
              return this.$store.dispatch('payment/getCurrencyRates');

            case 6:
              this.checkHoverSortIcon();

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    formatPairingDeliverables: function formatPairingDeliverables(value) {
      return this.formatDeliverableCounts(value).replace(/X\s*\(Twitter\)\s*Post/g, 'XTP');
    },
    formatDeliverableCounts: function formatDeliverableCounts(value) {
      return String(value || '').replace(/(\d+(?:hrs)?) X /g, '$1 x ');
    },
    getPairingStatusLabels: function getPairingStatusLabels(status) {
      var lable = void 0;
      __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_entries___default()(this.pairingStatus).forEach(function (item) {
        if (item[1].value === status) {
          lable = item[1].text;
        }
      });
      return lable;
    },
    priceMultiplierHandler: function priceMultiplierHandler(item) {
      this.priceMultiplierInfluencerData = item;
      this.isMultipleDeliverables = false;
      this.priceMultiplierDialog = true;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagements = item.engagements;
      return engagements * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts;
    },
    pairChanged: function pairChanged() {
      this.updatePairingDialog = false;
      this.priceMultiplierDialog = false;
      this.getPairedInfluencers(this.campaign.id);
    },
    openDeliverableUpdateDialog: function openDeliverableUpdateDialog() {
      this.isMultipleDeliverables = true;
      this.priceMultiplierDialog = true;
    },
    updatePairingStatusHandler: function updatePairingStatusHandler(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = false;
    },
    viewDetailPairing: function viewDetailPairing(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = true;
    },
    executeMethod: function executeMethod(method, data) {
      switch (method) {
        case 'delete':
          this.removeSelectedInfluencer(data.userHandle, data.platform);
          break;
        case 'view':
          this.viewDetailPairing(data);
          break;
        case 'edit':
          this.updatePairingStatusHandler(data);
          break;
        case 'refresh':
          this.refreshPairingData(data);
          break;
      }
    },
    refreshPairingData: function refreshPairingData(data) {
      this.isLoading = true;
      this.refreshInfluencerDetail(data.instagramHandle, data.platform.toLowerCase(), data.pairingID);
      this.addToSelectedInfluencers(data.instagramHandle, data.platform.toLowerCase());
    },
    paramsUpdated: function paramsUpdated() {
      this.settingAIDialog = false;
      this.getSuggestedInfluencerFromAI(this.campaign.id, true);
    },
    enableSettingForAI: function enableSettingForAI() {
      this.settingAIDialog = !this.settingAIDialog;
    },
    showReason: function showReason(text) {
      this.eliminationReason = text;
      this.reasonDialog = true;
    },
    editAmount: function editAmount(item) {
      var index = this.items.findIndex(function (element) {
        return element.userHandle === item.userHandle;
      });
      if (index === -1) return;
      this.items[index].isEditting = true;
      this.items.splice();
    },
    isSelected: function isSelected(igHandle, platform) {
      return this.selected.find(function (e) {
        return e.handle === igHandle && e.platform === platform;
      });
    },
    updateLineUp: function updateLineUp() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this9.lineUpItems.map(function (item, index) {
                  var data = {
                    pairingID: item.pairingID,
                    lineUpIndex: index
                  };
                  __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].updateLineUpIndex(data);
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    invokeSendToAM: function invokeSendToAM() {
      var _this10 = this;

      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this10.isLoading = true;
              __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].sendCOGSExceedReminder(_this10.campaign.id).then(function (sents) {
                _this10.isLoading = false;
                _this10.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: 'The request for release has been sent to Admin.'
                });
                _this10.getPairedInfluencers(_this10.campaign.id);
              }).catch(function () {
                _this10.isLoading = false;
              });
            }
          });
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this10.sendToAM();
            }
          });
        }
        return;
      } else {
        this.sendToAM();
      }
    },
    sendToAM: function sendToAM() {
      var _this11 = this;

      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: this.newEliminations + ' new influencer(s) will be sent to AM for approval.'
      }).then(function (result) {
        if (result.value) {
          _this11.isLoading = true;
          if (_this11.lineUpItems.length > 0) {
            _this11.updateLineUp();
            __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToAM(_this11.campaign.id).then(function () {
              _this11.isLoading = false;
              _this11.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to client.'
              });
              _this11.getPairedInfluencers(_this11.campaign.id);
            }).catch(function () {
              _this11.isLoading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToAM(_this11.campaign.id).then(function () {
              _this11.isLoading = false;
              _this11.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to AM.'
              });
              _this11.getPairedInfluencers(_this11.campaign.id);
            }).catch(function () {
              _this11.isLoading = false;
            });
          }
        }
      });
    },
    showPairingEliminEditModal: function showPairingEliminEditModal() {
      this.eliminationDialog = true;
      this.campaingDataForElimination = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.campaign);
    },
    invokeSendToClient: function invokeSendToClient() {
      var _this12 = this;

      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this12.isLoading = true;
              __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].sendCOGSExceedReminder(_this12.campaign.id).then(function (sents) {
                _this12.isLoading = false;
                _this12.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: 'The request for release has been sent to Admin.'
                });
                _this12.getPairedInfluencers(_this12.campaign.id);
              }).catch(function () {
                _this12.isLoading = false;
              });
            }
          });
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: 'The current budget for this campaign is exceeded the limited. Please check again'
          }).then(function (result) {
            if (result.value) {
              _this12.sendToClient();
            }
          });
        }
        return;
      } else {
        this.sendToClient();
      }
    },
    sendToClient: function sendToClient() {
      var _this13 = this;

      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: this.newEliminations + ' new influencer(s) will be sent to client for elimination.'
      }).then(function (result) {
        if (result.value) {
          _this13.isLoading = true;
          if (_this13.lineUpItems.length > 0) {
            _this13.updateLineUp();
            __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToClient(_this13.campaign.id).then(function (sents) {
              _this13.isLoading = false;
              _this13.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to client.'
              });
              _this13.getPairedInfluencers(_this13.campaign.id);
            }).catch(function () {
              _this13.isLoading = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].sendListInfluencersToClient(_this13.campaign.id).then(function (sents) {
              _this13.isLoading = false;
              _this13.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: 'The list has been sent to client.'
              });
              _this13.getPairedInfluencers(_this13.campaign.id);
            }).catch(function () {
              _this13.isLoading = false;
            });
          }
        }
      });
    },
    close: function close() {
      this.$emit('input');
    },
    input1: function input1() {
      this.showInfluencerSearchResult = false;
    },
    select: function select(userHandle, platform) {
      if (this.selected.find(function (e) {
        return e.handle === userHandle && e.platform === platform.toLowerCase();
      })) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'Influencer is being selected'
        });
      } else {
        if (platform === 'Instagram') {
          userHandle = userHandle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.regexMatchIg(userHandle, __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].regexPattern.instagram_profile)) : '';
        } else if (platform === 'TikTok') {
          userHandle = userHandle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.extractTikTokHandle(userHandle)) : '';
        } else if (platform === 'LinkedIn') {
          userHandle = this.normalizeLinkedInHandle(userHandle);
        }
        this.crawlInfluencerDetail(userHandle, this.searchInfluencer);
        this.addToSelectedInfluencers(userHandle, platform.toLowerCase());
      }
    },
    removeSelectedInfluencer: function removeSelectedInfluencer(userHandle, platform) {
      var item = this.items.find(function (element) {
        return element.userHandle === userHandle && element.platform === platform;
      });
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.removePairingElementFromArray(this.items, userHandle, 'object', 'userHandle', platform);
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.removePairingElementFromArray(this.selected, userHandle, 'string', 'handle', platform);
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.removeElementFromArray(this.ageItems, this.items.country, 'object', 'country');
      if (item.pairingID) {
        __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].removePairing(item.pairingID).then(function () {
          console.log('removed', item);
        });
      }
    },
    addToSelectedInfluencers: function addToSelectedInfluencers(userHandle, platform) {
      var remarks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var inf = {
        userHandle: userHandle,
        remarks: remarks,
        pairingStatus: '',
        eliminationStatus: '',
        gender: '',
        age_group: '',
        followers: '0',
        country: '',
        audience_interests: [],
        audience_credibility: '0',
        engagements: 0,
        engagement_rate: '0',
        payoutAmount: '0',
        isLoading: true,
        platform: platform
      };
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.pushPairingElementToArray(this.items, inf, 'userHandle', 'object', platform);
      __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.pushPairingElementToArray(this.selected, { handle: userHandle, platform: platform }, 'handle', 'object', platform);
    },
    getSuggestedInfluencerFromAI: function getSuggestedInfluencerFromAI(campaignID, force) {
      var _this14 = this;

      this.loadingAI = true;
      __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].getInfluencerFromAI(campaignID, force).then(function (resp) {
        _this14.loadingAI = false;
        if (resp) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(resp), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var inf = _step.value;

              inf.platform = 'instagram';
              __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.pushElementToArray(_this14.suggestedInfluencers, inf, 'userHandle', __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].TYPE.OBJECT);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }).catch(function (err) {
        _this14.loadingAI = false;
        console.error(err);
      });
    },
    refreshInfluencerDetail: function refreshInfluencerDetail(ighandle, platform, pairingID) {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].refreshInfluencerDetails({ ighandle: ighandle, campaignID: this.campaign.id, platform: platform.toLowerCase(), pairingID: pairingID }).then(function (response) {
        var index = _this15.items.findIndex(function (item) {
          return item.userHandle === ighandle && item.platform === platform.toLowerCase();
        });
        var inf = _this15.items[index];
        if (response.success) {
          var data = response.data;
          inf = _this15.beautifyData(data);
        } else {
          inf.message = response.message || '';
          inf.socialDataErrMessage = response.socialDataErrMessage || '';
          inf.audience_credibility = response.audience_credibility || 0;
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50';
          inf = _this15.initEditFields(inf);
        }
        inf.isLoading = false;
        inf.success = response.success;
        _this15.items[index] = inf;
        _this15.items = _this15.items.slice();
        _this15.setAgeGroupItems(_this15.items);
        _this15.getTopFiveAudienceInterests(_this15.items);
        _this15.setMultipleInfs();
        _this15.isLoading = false;
      });
    },
    crawlInfluencerDetail: function crawlInfluencerDetail(userHandle, platform) {
      var _this16 = this;

      var remarks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].crawlInfluencerDetails({ userHandle: userHandle, campaignID: this.campaign.id, platform: platform.toLowerCase(), platformName: this.platformName, options: this.optionVal, remarks: remarks }).then(function (response) {
        var index = _this16.items.findIndex(function (item) {
          return item.userHandle === userHandle && item.platform === platform.toLowerCase();
        });
        var inf = _this16.items[index];
        if (response.success) {
          var data = response.data;
          inf = _this16.beautifyData(data);
        } else {
          inf.message = response.message || '';
          inf.socialDataErrMessage = response.socialDataErrMessage || '';
          inf.audience_credibility = response.audience_credibility || 0;
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50';
          inf = _this16.initEditFields(inf);
        }
        inf.isLoading = false;
        inf.success = response.success;
        _this16.items[index] = inf;
        _this16.items = _this16.items.slice();
        _this16.setAgeGroupItems(_this16.items);
        _this16.getTopFiveAudienceInterests(_this16.items);
        _this16.setMultipleInfs();
      });
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      inf = data.influencer_details;
      inf.influencer_details = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, data.influencer_details);
      var deliverablesDetails = data.deliverables_details || {};
      var additionalDetails = data.additional_details || {};
      var audienceDetails = data.avg_performances || null;
      inf.remarks = additionalDetails.remarks;
      inf.contentFeature = additionalDetails.contentFeature;
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.eliminationReason = data.elimination_details.reason;
      inf.payoutAmount = Number(data.payout_details.amount);
      inf.predictedAmount = data.payout_details.predicted_amount || 0;
      inf.predictedAmountHigh = data.payout_details.predicted2_amount || 0;
      inf.multipliedPrice1 = data.payout_details.multipliedPrice1 || 0;
      inf.multipliedPrice2 = data.payout_details.multipliedPrice2 || 0;
      inf.min_payout = data.payout_details.min_payout || 0;
      inf.priceEffortMultiplier = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, data.payout_details.priceEffortMultiplier);
      inf.activity = data.activity && Array.isArray(data.activity) ? __WEBPACK_IMPORTED_MODULE_38_lodash_reverse___default()(data.activity) : [];
      inf.deliverableDetails = deliverablesDetails;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.no_of_fb_posts = deliverablesDetails.no_of_fb_posts || 0;
      inf.no_of_xhs_posts = deliverablesDetails.no_of_xhs_posts || 0;
      inf.no_of_li_posts = deliverablesDetails.no_of_li_posts || 0;
      inf.no_of_x_posts = deliverablesDetails.no_of_x_posts || 0;
      inf.loading_whitelisting = deliverablesDetails.loading_whitelisting || '';
      inf.youtube = deliverablesDetails.youtube || 0;
      inf.exclusivity = deliverablesDetails.exclusivity || '';
      inf.physical_attendance = deliverablesDetails.physical_attendance || 0;
      inf.online_attendance = deliverablesDetails.online_attendance || 0;
      inf.customDeliverables = deliverablesDetails.custom || [];
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram';
      inf.platformName = inf.platformName || inf.platform;
      inf.audience_genders = inf.audience_genders || [];
      inf.lastReportDate = inf.lastReportDate || '';
      inf.options = data.options || 0;
      inf.allOptions = data.allOptions || null;

      var audGenderRet = [];
      if (Array.isArray(inf.audience_genders)) {
        var male = inf.audience_genders.find(function (a) {
          return a.code === 'MALE';
        });
        if (male) audGenderRet.push(male);
        var female = inf.audience_genders.find(function (a) {
          return a.code === 'FEMALE';
        });
        if (female) audGenderRet.push(female);
        audGenderRet = audGenderRet.map(function (gender) {
          return gender.code + ' (' + (gender.weight * 100).toFixed(2) + '%)';
        }).join('\n');
      }
      inf.audGenderDisplay = audGenderRet;
      inf.audience_genders = this.getGenderPieData(inf.audience_genders);
      inf.contentScriptForm = data.contentScriptForm;
      inf = this.initEditFields(inf);
      if (!inf.userHandle) inf.userHandle = inf.instagramHandle;
      if (inf.platform === 'linkedin' || inf.platform === 'twitter' || inf.platform === 'x') {
        var platformHandle = inf.platform === 'linkedin' ? inf.linkedinHandle || inf.userHandle || inf.instagramHandle : inf.twitterHandle || inf.userHandle || inf.instagramHandle;
        var trimmedHandle = typeof platformHandle === 'string' ? platformHandle.trim() : platformHandle;

        inf.userHandle = trimmedHandle;
        inf.influencer_details.userHandle = trimmedHandle;
        if (inf.platform === 'linkedin') {
          inf.linkedinHandle = trimmedHandle;
          inf.influencer_details.linkedinHandle = trimmedHandle;
        } else {
          inf.twitterHandle = trimmedHandle;
          inf.influencer_details.twitterHandle = trimmedHandle;
        }
      }
      if (inf.platform && inf.platform === 'xiaohongshu') {
        inf.userHandle = inf.fullName;
        inf.xhsID = inf.xhsID || inf.instagramHandle;
      }
      inf.isGST = data.pairing_details.GST;
      inf.GSTpercent = data.payout_details.GSTpercent;
      if (inf.isGST && inf.GSTpercent) {
        inf.payoutAmount = inf.payoutAmount - Number(inf.GSTpercent);
      }
      if (data.payout_details) {
        inf.payoutStatus = data.payout_details.status || null;
        inf.currency = data.payout_details.currency || 'SGD';
        if (inf.currency !== 'SGD') {
          inf.sgdAmt = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.convertCurrency(inf.currency, inf.payoutAmount, this.currencyRates);
        }
      }
      inf.max_payout = data.payout_details.max_payout || inf.payoutAmount;
      if (inf.platform === 'tiktok') {
        inf.rateCard = this.rateCards.find(function (r) {
          return r.tiktokHandle === inf.userHandle;
        });
      }
      if (inf.platform === 'instagram') {
        inf.rateCard = this.rateCards.find(function (r) {
          return r.instagramHandle === inf.userHandle;
        });
      }
      if (audienceDetails) {
        inf.avg_likes = audienceDetails.avg_likes || '';
        inf.avg_comments = audienceDetails.avg_comments || '';
        inf.avg_views = audienceDetails.avg_views || '';
        inf.avg_reels_plays = audienceDetails.avg_reels_plays || '';
        inf.avg_saves = audienceDetails.avg_saves || '';
        inf.avg_shares = audienceDetails.avg_shares || '';
        inf.median_engagement_rate = audienceDetails.median_engagement_rate || '';
      }
      inf.topAudAges = [];
      if (inf.audAges) {
        inf.audAges = __WEBPACK_IMPORTED_MODULE_39_lodash_sortBy___default()(inf.audAges, 'lineupIndex');
        inf.audAges = inf.audAges.map(function (a) {
          if (!a.lineupIndex) {
            a.lineupIndex = 999;
          } else if (a.lineupIndex !== 999) {
            inf.topAudAges.push(a.code);
          }
          return a;
        });
        inf.audAges = inf.audAges.sort(function (a, b) {
          return a.lineupIndex - b.lineupIndex;
        });
        if (inf.topAudAges.length) {
          inf.audAgesDisplay = inf.audAges.slice(0, inf.topAudAges.length);
        }
      } else {
        inf.audAges = [];
      }

      if (inf.audAges && inf.audAges.length) {
        inf.displayAudAge = inf.audAges.slice(0, 3);
        if (inf.displayAudAge.length) {
          inf.displayAudAge = inf.displayAudAge.map(function (d) {
            return d.code + ' (' + (d.weight * 100).toFixed(2) + '%)';
          }).join('\n');
        }
      }
      inf.topCountries = [];
      if (inf.countries) {
        inf.countries = __WEBPACK_IMPORTED_MODULE_39_lodash_sortBy___default()(inf.countries, 'lineupIndex');
        inf.countries = inf.countries.map(function (a) {
          if (!a.lineupIndex) {
            a.lineupIndex = 999;
          } else if (a.lineupIndex !== 999) {
            inf.topCountries.push(a.name);
          }
          return a;
        });
        if (inf.topCountries.length) {
          inf.topCountryDisplay = inf.countries.slice(0, inf.topCountries.length);
        }
      } else {
        inf.countries = [];
      }

      if (inf.countries && inf.countries.length) {
        inf.displaytopCountry = inf.countries.slice(0, 3);
        if (inf.displaytopCountry.length) {
          inf.displaytopCountry = inf.displaytopCountry.map(function (d) {
            return d.name + ' (' + (d.weight * 100).toFixed(2) + '%)';
          }).join('\n');
        }
      }

      if (inf.infInterests) {
        if (inf.infInterests.length) {
          inf.infInterestDisplay = inf.infInterests.map(function (i) {
            return i.name;
          }).join(',');
        }
      }

      if (inf.audience_interests) {
        if (inf.audience_interests) {
          inf.audInterestDisplay = inf.audience_interests.map(function (i) {
            return i.name;
          }).join(',');
        }
      }

      inf.engagementRateDisplay = '';
      if (inf.engagement_rate) inf.engagementRateDisplay = inf.engagement_rate + '%';
      inf.medianEngRateDisplay = '';
      if (inf.median_engagement_rate) inf.medianEngRateDisplay = inf.median_engagement_rate + '%';
      inf.genderEdit = false;
      inf.followersEdit = false;
      inf.ageGroupEdit = false;
      inf.audAgesEdit = false;
      inf.audCountryEdit = false;
      return inf;
    },
    changePlatform: function changePlatform(oldHandle, ighandle, platform, pairingID) {
      var _this17 = this;

      this.$swal({
        title: 'Switch Platform?',
        icon: 'warning',
        html: '<div style="text-align:center"><b>' + oldHandle + ' \u2192 ' + ighandle + '</b></div><br>Changing the platform will reset the audience details.<br> Do you want to proceed?',
        confirmButtonText: 'Switch Platform',
        cancelButtonText: 'Cancel',
        showCancelButton: true
      }).then(function (result) {
        if (result.value) {
          _this17.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].refreshInfluencerDetails({
            ighandle: ighandle,
            campaignID: _this17.campaign.id,
            platform: platform.toLowerCase(),
            pairingID: pairingID,
            isChange: true
          }).then(function (response) {
            var index = _this17.items.findIndex(function (item) {
              return item.pairingID === pairingID;
            });
            var inf = _this17.items[index];
            if (response.success) {
              var data = response.data;
              inf = _this17.beautifyData(data);
              _this17.$swal({
                title: 'Success',
                icon: 'success',
                text: 'Successfully Switched to ' + ighandle,
                showCancelButton: false
              });
            } else {
              inf.message = response.message || '';
              inf.socialDataErrMessage = response.socialDataErrMessage || '';
              inf.audience_credibility = response.audience_credibility || 0;
              inf.audience_credibility_color = response.audience_credibility_color || '#4caf50';
              inf = _this17.initEditFields(inf);
            }
            inf.isLoading = false;
            inf.success = response.success;
            _this17.items[index] = inf;
            _this17.items = _this17.items.slice();
            _this17.setAgeGroupItems(_this17.items);
            _this17.getTopFiveAudienceInterests(_this17.items);
            _this17.setMultipleInfs();
            _this17.isLoading = false;
          });
        }
      });
    },
    setMultipleInfs: function setMultipleInfs() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, infs, facebookHandle;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 3;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this18.items);

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 24;
                  break;
                }

                item = _step2.value;

                if (item.influencerID) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt('continue', 21);

              case 9:
                infs = [];
                _context4.next = 12;
                return _this18.$store.dispatch('influencer/getInfluencerDetail', {
                  id: item.influencerID
                });

              case 12:
                _this18.$set(item, 'isPlatformConnected', _this18.isCurrentPlatformConnected(item, _this18.infDetail));
                if (_this18.infDetail.instagram) {
                  infs.push({
                    handle: _this18.infDetail.instagram.instagramHandle,
                    instagramID: _this18.infDetail.instagram.instagramID,
                    picture: _this18.infDetail.audience ? _this18.infDetail.audience.user_profile.picture : _this18.infDetail.instagram.picture,
                    instagram: true,
                    platform: 'instagram',
                    pairingID: item.pairingID
                  });
                }
                if (_this18.infDetail.tiktok) {
                  infs.push({
                    handle: _this18.infDetail.tiktok.tiktokHandle,
                    tiktokID: _this18.infDetail.tiktok.tiktokID,
                    picture: _this18.infDetail.tiktokaudience ? _this18.infDetail.tiktokaudience.user_profile.picture : _this18.infDetail.tiktok.picture,
                    tiktok: true,
                    platform: 'tiktok',
                    pairingID: item.pairingID
                  });
                }
                if (_this18.infDetail.youtube) {
                  infs.push({
                    handle: _this18.infDetail.youtube.youtubeHandle,
                    youtubeID: _this18.infDetail.youtube.youtubeID,
                    picture: _this18.infDetail.youtubeaudience ? _this18.infDetail.youtubeaudience.user_profile.picture : _this18.infDetail.youtube.picture,
                    youtube: true,
                    platform: 'youtube',
                    pairingID: item.pairingID
                  });
                }
                if (_this18.infDetail.xiaohongshu) {
                  infs.push({
                    handle: _this18.infDetail.xiaohongshu.xhsHandle,
                    xhsID: _this18.infDetail.xiaohongshu.xhsID,
                    picture: _this18.infDetail.xiaohongshu ? _this18.infDetail.xiaohongshu.profilePicture : '',
                    xhs: true,
                    platform: 'xiaohongshu',
                    pairingID: item.pairingID
                  });
                }
                if (_this18.infDetail.facebook) {
                  facebookHandle = _this18.infDetail.facebook.handle || _this18.infDetail.facebook.facebookHandle || _this18.infDetail.facebook.facebookId;

                  if (facebookHandle) {
                    infs.push({
                      handle: _this18.normalizeFacebookHandle(facebookHandle),
                      facebookID: _this18.infDetail.facebook.facebookId,
                      picture: _this18.infDetail.facebook ? _this18.infDetail.facebook.profilePicture : '',
                      facebook: true,
                      platform: 'facebook',
                      pairingID: item.pairingID
                    });
                  }
                }
                if (_this18.infDetail.linkedin && _this18.infDetail.linkedin.linkedinHandle) {
                  infs.push({
                    handle: _this18.normalizeLinkedInHandle(_this18.infDetail.linkedin.linkedinHandle),
                    picture: '',
                    linkedin: true,
                    platform: 'linkedin',
                    pairingID: item.pairingID
                  });
                }
                if (_this18.infDetail.twitter && _this18.infDetail.twitter.twitterHandle) {
                  infs.push({
                    handle: _this18.normalizeTwitterHandle(_this18.infDetail.twitter.twitterHandle),
                    picture: '',
                    twitter: true,
                    platform: 'twitter',
                    pairingID: item.pairingID
                  });
                }
                item.multipleInfs = infs;

              case 21:
                _iteratorNormalCompletion2 = true;
                _context4.next = 5;
                break;

              case 24:
                _context4.next = 30;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 30:
                _context4.prev = 30;
                _context4.prev = 31;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 33:
                _context4.prev = 33;

                if (!_didIteratorError2) {
                  _context4.next = 36;
                  break;
                }

                throw _iteratorError2;

              case 36:
                return _context4.finish(33);

              case 37:
                return _context4.finish(30);

              case 38:
                _this18.items = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this18.items);

              case 39:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this18, [[3, 26, 30, 38], [31,, 33, 37]]);
      }))();
    },
    isCurrentPlatformConnected: function isCurrentPlatformConnected(item, influencer) {
      var platform = String(item.platform || item.influencer_details && item.influencer_details.platform || 'instagram').toLowerCase();
      var platformKey = platform === 'x' ? 'twitter' : platform;
      var connectedPlatformKeys = ['instagram', 'tiktok', 'youtube', 'xiaohongshu', 'facebook', 'linkedin', 'twitter'];
      return !connectedPlatformKeys.includes(platformKey) || Boolean(influencer && influencer[platformKey]);
    },
    searchManually: function searchManually(searchType) {
      switch (searchType) {
        case SearchTypeEnum.KEYWORD:
          this.searchByKeyword();
          break;
        case SearchTypeEnum.HANDLE:
          this.searchByHandle(this.igHandle);
          this.igHandle = '';
          break;
      }
    },
    searchByHandle: function searchByHandle(ighandle) {
      if (!ighandle || ighandle === '') {
        var errMsg = '';
        if (this.searchInfluencer === 'Instagram') {
          errMsg = 'Please enter the Instagram Handle';
        } else if (this.searchInfluencer === 'Facebook') {
          errMsg = 'Please enter the Facebook ID';
        } else if (this.searchInfluencer === 'LinkedIn') {
          errMsg = 'Please enter the LinkedIn Handle';
        } else if (this.searchInfluencer === 'Twitter') {
          errMsg = 'Please enter the X (Twitter) Handle';
        } else if (this.searchInfluencer === 'Youtube') {
          errMsg = 'Please enter the Youtube ID';
        } else if (this.searchInfluencer === 'TikTok') {
          errMsg = 'Please enter the TikTok Handle';
        } else {
          errMsg = 'Please enter the TikTok Handle';
        }
        this.$swal({
          title: 'Error',
          text: errMsg,
          type: 'info'
        });
        return;
      }
      if (this.searchInfluencer === 'Facebook') {
        ighandle = this.normalizeFacebookHandle(ighandle);
      } else if (this.searchInfluencer === 'LinkedIn') {
        ighandle = this.normalizeLinkedInHandle(ighandle);
      } else if (this.searchInfluencer === 'Twitter') {
        ighandle = this.normalizeTwitterHandle(ighandle);
      }
      if (/^https?:\/\//i.test(ighandle) && this.searchInfluencer !== 'Xiaohongshu') {
        this.$swal({
          title: 'Error!',
          icon: 'error',
          showCancelButton: false,
          text: 'Invalid Handle'
        });
        return;
      }
      this.select(ighandle, this.searchInfluencer);
    },
    normalizeFacebookHandle: function normalizeFacebookHandle(value) {
      var handle = (value || '').trim();
      var facebookUrl = handle.match(/^(?:https?:\/\/)?(?:www\.|m\.)?(?:facebook\.com|fb\.com)\/([^/?#]+)/i);
      if (facebookUrl) {
        handle = facebookUrl[1];
        if (handle.toLowerCase() === 'profile.php') {
          var profileId = String(value).match(/[?&]id=([^&#]+)/i);
          if (profileId) handle = profileId[1];
        }
      }
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    normalizeLinkedInHandle: function normalizeLinkedInHandle(value) {
      var handle = (value || '').trim();
      var linkedinUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i);
      if (linkedinUrl) handle = linkedinUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    normalizeTwitterHandle: function normalizeTwitterHandle(value) {
      var handle = (value || '').trim();
      var twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i);
      if (twitterUrl) handle = twitterUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    searchByKeyword: function searchByKeyword() {
      this.isLoading = true;
      this.searchKeywordAction = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.makeid(5);
    },
    resultFromSearchKeyword: function resultFromSearchKeyword(value) {
      this.isLoading = false;
      if (value.success) {
        this.currentKeywordSearch = value.keyword;
        this.historySearchResult = value;
        this.showResult(value);
      }
    },
    isBudgetOver: function isBudgetOver(target, current) {
      return current / target > 1;
    },
    showResult: function showResult(result) {
      this.showInfluencerSearchResult = true;
      this.influencerSearchResult = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, result);
      this.selected.splice();
    },
    getPairedInfluencers: function getPairedInfluencers(campaignID) {
      var _this19 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID, true).then(function (resp) {
        _this19.isLoading = false;
        if (resp) {
          var items = [];
          var selected = [];
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(resp), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var data = _step3.value;

              var inf = _this19.beautifyData(data);
              inf.isLoading = false;
              inf.success = true;
              items.push(inf);
              selected.push({ handle: inf.userHandle, platform: inf.platform });
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          var pairedInfluencer = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], items);
          pairedInfluencer = pairedInfluencer.filter(function (p) {
            if (p.allOptions) {
              return true;
            }
            if (_this19.optionVal === 0) {
              return !p.options || p.options === _this19.optionVal;
            } else {
              return p.options && p.options === _this19.optionVal;
            }
          });
          _this19.items = pairedInfluencer.sort(function (a, b) {
            return a.lineUpIndex - b.lineUpIndex;
          });
          _this19.filteredItems = _this19.items;
          _this19.selected = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], selected);
          _this19.setAgeGroupItems(_this19.items);
          _this19.getTopFiveAudienceInterests(_this19.items);
          _this19.checkOpenPayoutEditDialog();
          _this19.setMultipleInfs();
          _this19.handleTableUpdate(_this19.items);
          _this19.detectCurrency(_this19.filteredItems);
          if (_this19.unlockCogs) {
            _this19.changeLock(_this19.campaign, false);
            _this19.$emit('setUnlockCogs', false);
          }
        }
      }).catch(function (error) {
        console.log(error);
        _this19.isLoading = false;
      });
    },
    setAgeGroupItems: function setAgeGroupItems(items) {
      var arrayItem = [];
      items.map(function (item) {
        if (item.age_group) {
          arrayItem.push(item.age_group);
        }
      });
      this.ageItems = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(arrayItem)));
    },
    goToStep: function goToStep(step) {
      this.pairingStepper = step;
    },
    getAge: function getAge(birthday) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()().format('YYYY') - __WEBPACK_IMPORTED_MODULE_12_moment___default()(birthday).format('YYYY');
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatCurrency: function formatCurrency(number) {
      return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.formatCurrency(number);
    },
    formatNumber: function formatNumber(number) {
      return __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.formatNumber(number);
    },
    formatUploadedDate: function formatUploadedDate(value) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).format('DD/MM/YYYY');
    },
    handleTableUpdate: function handleTableUpdate(items) {
      this.lineUpItems = items;
      this.updateLineUp();
    },
    actionSelectChange: function actionSelectChange() {
      this.actionSelected = this.items.filter(function (i) {
        return i.isDelete;
      });
    },
    clearFilter: function clearFilter() {
      this.searchGender = '';
      this.searchAge = '';
      this.searchLocation = '';
      this.searchPairingStatus = '';
      this.searchAudCrediblity = '';
      this.getPairedInfluencers(this.campaign.id);
    },
    clearPairingData: function clearPairingData() {
      this.items = [];
      this.filteredItems = [];
      this.currencyTotals = {};
    },
    clearActionSelected: function clearActionSelected() {
      this.items = this.items.map(function (inf) {
        delete inf.isDelete;
        return inf;
      });
      this.actionSelected = [];
    },
    genderOnChangeHandler: function genderOnChangeHandler() {
      var _this20 = this;

      if (this.searchAge && this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this20.searchGender.toString().toUpperCase() && item.age_group === _this20.searchAge.toString().toUpperCase() && item.country === _this20.searchLocation;
        });
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this20.searchAge.toString().toUpperCase() && item.gender === _this20.searchGender.toString().toUpperCase();
        });
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this20.searchGender.toString().toUpperCase() && item.country === _this20.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this20.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this20.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      } else this.items = this.filteredItems.filter(function (item) {
        return item.gender === _this20.searchGender.toString().toUpperCase();
      });
      this.getTopFiveAudienceInterests(this.items);
    },
    ageOnChangeHandler: function ageOnChangeHandler() {
      var _this21 = this;

      if (this.searchGender && this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this21.searchGender.toString().toUpperCase() && item.age_group === _this21.searchAge.toString().toUpperCase() && item.country === _this21.searchLocation;
        });
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this21.searchGender.toString().toUpperCase() && item.age_group === _this21.searchAge.toString().toUpperCase();
        });
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this21.searchAge.toString().toUpperCase() && item.country === _this21.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this21.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this21.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      } else this.items = this.filteredItems.filter(function (item) {
        return item.age_group === _this21.searchAge.toString().toUpperCase();
      });
      this.getTopFiveAudienceInterests(this.items);
    },
    countryOnChangeHandler: function countryOnChangeHandler() {
      var _this22 = this;

      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this22.searchGender.toString().toUpperCase() && item.age_group === _this22.searchAge.toString().toUpperCase() && item.country === _this22.searchLocation;
        });
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this22.searchAge.toString().toUpperCase() && item.country === _this22.searchLocation;
        });
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this22.searchGender.toString().toUpperCase() && item.country === _this22.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this22.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this22.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      } else this.items = this.filteredItems.filter(function (item) {
        return item.country === _this22.searchLocation;
      });
      this.getTopFiveAudienceInterests(this.items);
    },
    pairingStatusOnChangeHandler: function pairingStatusOnChangeHandler() {
      var _this23 = this;

      this.items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this23.searchGender.toString().toUpperCase() && item.age_group === _this23.searchAge.toString().toUpperCase() && item.country === _this23.searchLocation;
        });
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(function (item) {
          return item.age_group === _this23.searchAge.toString().toUpperCase() && item.country === _this23.searchLocation;
        });
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(function (item) {
          return item.gender === _this23.searchGender.toString().toUpperCase() && item.country === _this23.searchLocation;
        });
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(function (item) {
          return item.country === _this23.searchLocation;
        });
      } else if (this.searchPairingStatus || this.searchPairingStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.NEW) {
        this.items = this.filteredItems.filter(function (item) {
          return item.pairingStatus === _this23.searchPairingStatus;
        });
      } else if (this.searchAudCrediblity) {
        var searchedCred = this.audCrediblityFilters.find(function (aud) {
          return aud.name === _this23.searchAudCrediblity;
        });
        this.items = this.filteredItems.filter(function (item) {
          return item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max;
        });
      }
      this.getTopFiveAudienceInterests(this.items);
    },
    getCountries: function getCountries() {
      var _this24 = this;

      __WEBPACK_IMPORTED_MODULE_18__Influencer_influencerAPIs__["a" /* default */].getCountries().then(function (countries) {
        _this24.locationItems = countries.map(function (item) {
          return item.name;
        });
      });
    },
    getTopFiveAudienceInterests: function getTopFiveAudienceInterests(items) {
      var _this25 = this;

      var audienceInterests = [];
      this.topFiveAudienceInterests = [];
      items.map(function (item) {
        if (item.audience_interests) {
          audienceInterests = item.audience_interests;
        }
        _this25.topFiveAudienceInterests.push([].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(audienceInterests)).sort(function (a, b) {
          return b.weight - a.weight;
        }).slice(0, 5));
      });
    },
    saveLineUp: function saveLineUp() {
      this.updateLineUp();
      this.$swal.fire({
        type: 'success',
        title: 'Saved!',
        showCancelButton: false,
        width: 300
      });
    },
    confirmDelete: function confirmDelete() {
      var _this26 = this;

      var text = "You won't be able to revert this!";
      this.$swal({
        title: 'Are you sure to delete?',
        icon: 'warning',
        showCancelButton: true,
        text: text
      }).then(function (result) {
        if (result.value) {
          _this26.isLoading = true;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this26.actionSelected), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var item = _step4.value;

              _this26.executeMethod('delete', item);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          _this26.isLoading = false;
          _this26.$swal({
            text: 'Successfully Deleted.',
            type: 'success'
          });
          _this26.clearActionSelected();
        }
      });
    },
    saveEditingData: function saveEditingData() {
      var _this27 = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.calcMeasurements(this.items);

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this27.isEditing = true;
          if (items.length > 0) {
            _this27.items = items;
          }
          var data = _this27.items.filter(function (item) {
            return item.editPairing && item.editPairing === true;
          });
          data = data.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
              id: item.pairingID,
              platformName: item.platformName,
              followers: item.followers,
              remarks: item.remarks,
              contentFeature: item.contentFeature,
              payoutAmount: item.payoutAmount,
              status: item.pairingStatus,
              eliminationStatus: item.pairingStatus === _this27.pairingStatus.ACCEPTED.value ? _this27.eliminationStatus.SELECTED : item.eliminationStatus,
              GSTpercent: 0,
              GST: false
            });
          });

          __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].saveEditedPairingData(data).then(function (response) {
            _this27.isEditing = false;
            _this27.cancelEdit();
            _this27.clearActionSelected();
            data.map(function (item) {
              var itemIndex = _this27.items.findIndex(function (i) {
                return i.pairingID === item.id;
              });
              if (itemIndex !== -1) {
                _this27.items[itemIndex].isGST = false;
                _this27.items[itemIndex].max_payout = item.payoutAmount;
              }
            });

            _this27.$swal({
              text: 'Pairing Updated',
              type: 'success'
            });
          }).catch(function (error) {
            _this27.isEditing = false;

            console.log('error', error);
            _this27.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    getRateCardLists: function getRateCardLists() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this28.$store.dispatch('influencer/getRateCardLists', { filters: {} });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this28);
      }))();
    },
    calcMeasurements: function calcMeasurements(newList) {
      var _this29 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      newList.forEach(function (item) {
        if (item.eliminationStatus !== _this29.eliminationStatus.ELIMINATED) {
          if (item.pairingStatus === _this29.pairingStatus.ACCEPTED.value) {
            _this29.measurement.total += Number(_this29.calculateContents(item));
            _this29.measurement.outreach += Number(_this29.calculateOutreach(item));
            _this29.measurement.engagement += Number(_this29.calculateEngagement(item));
            var amt = Number(item.payoutAmount || 0);
            if (item.currency !== 'SGD') {
              var rate = _this29.currencyRates[item.currency];
              amt = Number(amt / rate).toFixed(2);
            }
            _this29.measurement.budget += Number(amt || 0);
          }
        }
      });
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaign.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaign.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.campaign.budget * 100).toFixed(2);
      var content = this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
    },
    getFileType: function getFileType(item) {
      var filename = item.url.substring(item.url.lastIndexOf('/') + 1);
      var fileExt = filename.split('.')[1];

      return fileExt;
    },
    igHandleBulkUpload: function igHandleBulkUpload(e) {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var uploadedFiles, handles, handleItems, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, items, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, record;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context6.next = 4;
                  break;
                }

                _this30.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context6.abrupt('return');

              case 4:
                _context6.next = 6;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var fr = new FileReader();
                  fr.onload = function (e) {
                    var tmp = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.parserToJson(e.target.result);
                    resolve(tmp);
                  };
                  fr.readAsArrayBuffer(e.target.files[0]);
                  fr.onerror = reject;
                });

              case 6:
                handles = _context6.sent;
                handleItems = [];
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context6.prev = 11;
                _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(handles);

              case 13:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context6.next = 37;
                  break;
                }

                items = _step5.value;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context6.prev = 18;

                for (_iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(items); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  record = _step6.value;

                  if (record.handle) {
                    if (record.type === 'instagram') {
                      record.handle = record.handle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.regexMatchIg(record.handle, __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].regexPattern.instagram_profile)) : '';
                    } else if (record.type === 'tiktok') {
                      record.handle = record.handle ? __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.extractTikTokHandle(record.handle)) : '';
                    }
                    handleItems.push({ handle: record.handle, platform: record.type, remarks: record.remarks });
                  }
                }
                _context6.next = 26;
                break;

              case 22:
                _context6.prev = 22;
                _context6.t0 = _context6['catch'](18);
                _didIteratorError6 = true;
                _iteratorError6 = _context6.t0;

              case 26:
                _context6.prev = 26;
                _context6.prev = 27;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 29:
                _context6.prev = 29;

                if (!_didIteratorError6) {
                  _context6.next = 32;
                  break;
                }

                throw _iteratorError6;

              case 32:
                return _context6.finish(29);

              case 33:
                return _context6.finish(26);

              case 34:
                _iteratorNormalCompletion5 = true;
                _context6.next = 13;
                break;

              case 37:
                _context6.next = 43;
                break;

              case 39:
                _context6.prev = 39;
                _context6.t1 = _context6['catch'](11);
                _didIteratorError5 = true;
                _iteratorError5 = _context6.t1;

              case 43:
                _context6.prev = 43;
                _context6.prev = 44;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 46:
                _context6.prev = 46;

                if (!_didIteratorError5) {
                  _context6.next = 49;
                  break;
                }

                throw _iteratorError5;

              case 49:
                return _context6.finish(46);

              case 50:
                return _context6.finish(43);

              case 51:
                _this30.uploadBulkHandle(handleItems);

              case 52:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this30, [[11, 39, 43, 51], [18, 22, 26, 34], [27,, 29, 33], [44,, 46, 50]]);
      }))();
    },
    uploadBulkHandle: function uploadBulkHandle(handleItems) {
      var _this31 = this;

      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'No Influencer Handle Found'
        });
        return;
      }
      var vm = this;
      this.resetBulkProgress();
      this.bulkProgress.show = true;
      this.bulkProgress.complete = handleItems.length;
      var importSelected = [];
      var interval = 100;
      handleItems.forEach(function (el, index) {
        setTimeout(function () {
          var handleItem = el;
          if (vm.selected.find(function (e) {
            return e.handle === handleItem && e.platform === el.platform;
          })) {
            importSelected.push({ handle: handleItem.handle, platform: handleItem.platform });
          } else {
            vm.crawlInfluencerDetail(handleItem.handle, handleItem.platform, handleItem.remarks);
            vm.addToSelectedInfluencers(handleItem.handle, handleItem.platform, handleItem.remarks);
            console.log('\uD83D\uDE80 ~ IG Handle: ' + handleItem.handle);
          }
          _this31.bulkProgress.processing = index + 1;
          if (_this31.bulkProgress.complete === _this31.bulkProgress.processing) {
            _this31.bulkProgress.show = false;
            _this31.showAlreadySelectedAlert(importSelected);
          }
        }, index * interval);
      });
      this.$refs.igBulkHandle.value = null;
    },
    showAlreadySelectedAlert: function showAlreadySelectedAlert(importSelected) {
      if (importSelected.length > 0) {
        var displayBlock = '';
        importSelected.map(function (a) {
          displayBlock += '<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">\n            <span class="v-chip__content">' + a + '</span>\n          </span>';
        });
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Influencers being selected: <div>' + displayBlock + '</div>'
        });
      }
      return;
    },
    resetBulkProgress: function resetBulkProgress() {
      this.bulkProgress.processing = 0;
      this.bulkProgress.complete = 0;
      this.bulkProgress.show = false;
    },
    openEditItem: function openEditItem(itemID, itemName) {
      if (this.disableLockedCOGS) {
        return;
      }
      var index = this.items.findIndex(function (i) {
        return i.pairingID === itemID;
      });
      if (itemName === 'payout') {
        if (this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return;
        }
      }
      if (itemName === 'status') {
        if (this.campaign.lockedCOGS || this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return;
        }
      }
      this.items[index][itemName + 'Edit'] = true;
      this.items[index].editPairing = true;
      this.oldEditItem = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.items[index]);
      this.disableSaveEdit = false;
    },
    cancelEdit: function cancelEdit() {
      var _this32 = this;

      this.items = this.items.map(function (inf) {
        inf = _this32.initEditFields(inf);
        return inf;
      });
      this.disableSaveEdit = true;
    },
    initEditFields: function initEditFields(inf) {
      inf.platformNameEdit = false;
      inf.remarkEdit = false;
      inf.contentFeatureEdit = false;
      inf.payoutEdit = false;
      inf.statusEdit = false;
      inf.editPairing = false;
      return inf;
    },
    changeBulkPairingStatus: function changeBulkPairingStatus(status) {
      var items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.items);
      items = items.map(function (i) {
        if (i.isDelete) {
          i.pairingStatus = status;
          i.editPairing = true;
        }
        return i;
      });
      this.saveEditingData(items);
    },
    selectAllPairings: function selectAllPairings($event) {
      var _this33 = this;

      if (!$event.value) {
        this.items = this.items.map(function (i) {
          i.isDelete = false;return i;
        });
      } else {
        this.items = this.items.map(function (i) {
          if (i.payoutStatus !== _this33.payoutStatus.CONFIRMED) {
            i.isDelete = true;
          }
          return i;
        });
      }
      this.actionSelectChange();
    },
    updatePairingDisplayStatus: function updatePairingDisplayStatus() {
      var _this34 = this;

      var data = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
        pairingDisplayStatus: this.campaign.pairingDisplayStatus
      });
      var formData = new FormData();
      formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

      __WEBPACK_IMPORTED_MODULE_13__campaignAPIs__["a" /* default */].updatePairingDisplayStatus(this.campaign.id, formData).then(function (response) {
        console.log('successfully updated!');
      }).catch(function (error) {
        console.log('error', error);
        _this34.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    displayFields: function displayFields(field) {
      if (this.campaign.pairingDisplayStatus !== undefined) {
        if (this.campaign.pairingDisplayStatus[field]) {
          return true;
        }
      }
      return false;
    },
    renderRemark: function renderRemark(remark) {
      if (remark !== undefined && remark !== null) {
        return remark.replace(/\n/g, '<br>');
      }
      return '-';
    },
    downloadSampleUpload: function downloadSampleUpload() {
      var link = document.createElement('a');

      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getGenderPieData: function getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        var ret = [];
        var male = audienceGenders.find(function (a) {
          return a.code === 'MALE';
        });
        if (male) ret.push(male);
        var female = audienceGenders.find(function (a) {
          return a.code === 'FEMALE';
        });
        if (female) ret.push(female);
        return ret.map(function (gender) {
          return (gender.weight * 100).toFixed(2);
        });
      }
    },
    displayGSTText: function displayGSTText(item) {
      var currency = item.currency;
      if (item.isGST) {
        return 'The amount show here is excluding GST. If GST is included, the payout amount is: \n        ' + currency + ' ' + this.$options.filters.thousandSeprator(parseFloat(item.payoutAmount) + parseFloat(item.GSTpercent || 0));
      }
      return item.min_payout ? currency + ' ' + item.min_payout + ' - ' + currency + ' ' + item.max_payout : currency + ' ' + this.$options.filters.thousandSeprator(item.max_payout);
    },
    openLockedPayoutEditDialog: function openLockedPayoutEditDialog(item) {
      this.lockedPayout = true;
      this.payoutEditPairing = item;
      this.editPayoutDialog = true;
      this.$router.push({
        path: window.location.pathname,
        query: {
          campaignID: this.campaign.id,
          handle: item.instagramHandle,
          payoutConfirm: true
        }
      });
    },
    openLockedCOGSDialog: function openLockedCOGSDialog(item) {
      var _this35 = this;

      this.$swal({
        title: 'Send Unlock Request',
        html: 'Are you sure to send request to unlock COGS?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee7(result) {
          var reqData;
          return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!result.value) {
                    _context7.next = 5;
                    break;
                  }

                  reqData = {
                    campaignID: item.id
                  };
                  _context7.next = 4;
                  return _this35.$store.dispatch('pairing/requestPayoutEdit', reqData);

                case 4:
                  if (_this35.requestedPayoutEdit) {
                    _this35.$swal({
                      text: 'Successfully Requested.',
                      type: 'success'
                    });
                  }

                case 5:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this35);
        }));

        return function (_x5) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    changeLock: function changeLock(item, status) {
      var _this36 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var lockTxt;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                lockTxt = status ? 'Lock' : 'Unlock';

                _this36.$swal({
                  title: 'Are you sure to ' + lockTxt + '?',
                  icon: 'warning',
                  confirmButtonText: lockTxt,
                  showCancelButton: true
                }).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee8(result) {
                    var updateObj, updateData;
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!result.value) {
                              _context8.next = 12;
                              break;
                            }

                            updateObj = {
                              id: item.id,
                              lockedCOGS: status
                            };

                            if (status === false) {
                              updateObj.unlockCogsEmail = true;
                            }
                            updateData = [updateObj];
                            _context8.next = 6;
                            return _this36.$store.dispatch('campaign/updateCampaignByIds', updateData);

                          case 6:
                            if (_this36.campaignUpdated) {
                              _context8.next = 9;
                              break;
                            }

                            _this36.$swal({
                              text: 'Error Campaign Update.',
                              type: 'error'
                            });
                            return _context8.abrupt('return');

                          case 9:
                            _this36.$swal({
                              text: 'Successfully ' + lockTxt + 'ed.',
                              type: 'success'
                            });
                            _this36.$set(item, 'lockedCOGS', status);
                            _this36.$emit('cogs-lock-changed', item.id, status);

                          case 12:
                            _this36.getPairedInfluencers(_this36.campaign.id);

                          case 13:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this36);
                  }));

                  return function (_x6) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this36);
      }))();
    },
    savedGetApproval: function savedGetApproval() {
      this.getPairedInfluencers(this.campaign.id);
    },
    openPayoutEditDialog: function openPayoutEditDialog(item) {
      this.lockedPayout = false;
      this.payoutEditPairing = item;
      this.editPayoutDialog = true;
    },
    openReqApprovalDialog: function openReqApprovalDialog(updateData) {
      this.reqAmt = Number(updateData.amount);
      this.reqReasons = updateData.reasons;
      this.reqApprovalDialog = true;
    },
    checkOpenPayoutEditDialog: function checkOpenPayoutEditDialog() {
      if (this.$route.query.payoutConfirm && this.$route.query.handle) {
        var handle = this.$route.query.handle;
        var matchItem = this.filteredItems.find(function (f) {
          return f.instagramHandle === handle;
        });
        if (matchItem) {
          if (matchItem.payoutStatus === this.payoutStatus.CONFIRMED) {
            this.openLockedPayoutEditDialog(matchItem);
          } else {
            this.openPayoutEditDialog(matchItem);
          }
        }
      }
    },
    changePairingStatus: function changePairingStatus(item) {
      var _this37 = this;

      if (item.pairingStatus === __WEBPACK_IMPORTED_MODULE_29__config__["a" /* default */].pairingStatus.ACCEPTED) {
        var totalDeliverables = __WEBPACK_IMPORTED_MODULE_14__campaignHelper__["a" /* default */].getTotalDeliverables(item.deliverableDetails);
        if (totalDeliverables <= 0) {
          this.$swal({
            text: 'Please submit deliverables to accept.',
            type: 'warning'
          });

          this.items = this.items.map(function (i) {
            if (i.pairingID === item.pairingID) {
              if (_this37.oldEditItem) {
                i.pairingStatus = _this37.oldEditItem.pairingStatus;
                i.statusEdit = false;
              }
              if (item.pairingStatus === _this37.pairingStatus.ACCEPTED.value) {
                i.eliminationStatus = _this37.eliminationStatus.SELECTED;
              }
            }
            return i;
          });
          return;
        }
        if (item.payoutAmount === 0) {
          this.$swal({
            html: 'The Payout is 0$.<br>Please confirm this creator doesn\u2019t need payment.',
            type: 'warning'
          });
        }
      }
      this.items = this.items.map(function (i) {
        if (i.pairingID === item.pairingID) {
          if (item.pairingStatus === _this37.pairingStatus.ACCEPTED.value) {
            i.eliminationStatus = _this37.eliminationStatus.SELECTED;
          } else {
            console.log('selected', item.pairingStatus);
            i.eliminationStatus = _this37.eliminationStatus.NEW;
          }
        }
        return i;
      });
    },
    openRateCardView: function openRateCardView(rateCard) {
      window.open('/influencers/rate-cards?id=' + rateCard.id, '_blank');
    },
    changePairingColEdit: function changePairingColEdit(colName, item, status) {
      var matchItemIdx = this.items.findIndex(function (f) {
        return f.pairingID === item.pairingID;
      });
      if (matchItemIdx !== -1) {
        this.items[matchItemIdx][colName] = status;
        this.items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(this.items);
      }
    },
    updatePairingCol: function updatePairingCol(item, field) {
      var _this38 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var updatePairings, idx, _loop, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, fieldItem, _idx, _loop2, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _fieldItem, formData, resp, _matchItemIdx, tmp;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this38.isLoading = true;
                updatePairings = [];

                if (field === 'platformName') {
                  item.influencer_details.platformName = item.platformName;
                  updatePairings.push({
                    id: item.pairingID,
                    'influencer_details': item.influencer_details
                  });
                }
                if (field === 'gender') {
                  item.influencer_details.gender = item.gender;
                  updatePairings.push({
                    id: item.pairingID,
                    'influencer_details': item.influencer_details
                  });
                }
                if (field === 'followers') {
                  item.influencer_details.followers = item.followers;
                  updatePairings.push({
                    id: item.pairingID,
                    'influencer_details': item.influencer_details
                  });
                }
                if (field === 'age_group') {
                  item.influencer_details.age_group = item.age_group;
                  updatePairings.push({
                    id: item.pairingID,
                    'influencer_details': item.influencer_details
                  });
                }

                if (!(field === 'topAudAges')) {
                  _context10.next = 32;
                  break;
                }

                if (!item.influencer_details.audAges) {
                  item.influencer_details.audAges = [];
                }

                item.influencer_details.audAges = item.influencer_details.audAges.filter(function (c) {
                  return !c.manual;
                });

                item.influencer_details.audAges = item.influencer_details.audAges.map(function (a) {
                  delete a.lineupIndex;
                  return a;
                });
                idx = 1;

                _loop = function _loop(fieldItem) {
                  var matchItemIdx = item.influencer_details.audAges.findIndex(function (a) {
                    return a.code === fieldItem;
                  });
                  if (matchItemIdx !== -1) {
                    item.influencer_details.audAges[matchItemIdx].lineupIndex = idx;
                  } else {
                    item.influencer_details.audAges.push({
                      code: fieldItem,
                      weight: 0,
                      lineupIndex: idx,
                      manual: true
                    });
                  }
                  idx += 1;
                };

                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context10.prev = 15;

                for (_iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(item[field]); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  fieldItem = _step7.value;

                  _loop(fieldItem);
                }
                _context10.next = 23;
                break;

              case 19:
                _context10.prev = 19;
                _context10.t0 = _context10['catch'](15);
                _didIteratorError7 = true;
                _iteratorError7 = _context10.t0;

              case 23:
                _context10.prev = 23;
                _context10.prev = 24;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 26:
                _context10.prev = 26;

                if (!_didIteratorError7) {
                  _context10.next = 29;
                  break;
                }

                throw _iteratorError7;

              case 29:
                return _context10.finish(26);

              case 30:
                return _context10.finish(23);

              case 31:
                updatePairings.push({
                  id: item.pairingID,
                  'influencer_details': item.influencer_details
                });

              case 32:
                if (!(field === 'topCountries')) {
                  _context10.next = 58;
                  break;
                }

                if (!item.influencer_details.countries) {
                  item.influencer_details.countries = [];
                }
                item.influencer_details.countries = item.influencer_details.countries.filter(function (c) {
                  return !c.manual;
                });
                item.influencer_details.countries = item.influencer_details.countries.map(function (a) {
                  delete a.lineupIndex;
                  return a;
                });
                _idx = 1;

                _loop2 = function _loop2(_fieldItem) {
                  var matchItemIdx = item.influencer_details.countries.findIndex(function (a) {
                    return a.name === _fieldItem;
                  });
                  if (matchItemIdx !== -1) {
                    item.influencer_details.countries[matchItemIdx].lineupIndex = _idx;
                  } else {
                    item.influencer_details.countries.push({
                      name: _fieldItem,
                      weight: 0,
                      lineupIndex: _idx,
                      manual: true
                    });
                  }
                  _idx += 1;
                };

                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context10.prev = 41;

                for (_iterator8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(item[field]); !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  _fieldItem = _step8.value;

                  _loop2(_fieldItem);
                }
                _context10.next = 49;
                break;

              case 45:
                _context10.prev = 45;
                _context10.t1 = _context10['catch'](41);
                _didIteratorError8 = true;
                _iteratorError8 = _context10.t1;

              case 49:
                _context10.prev = 49;
                _context10.prev = 50;

                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }

              case 52:
                _context10.prev = 52;

                if (!_didIteratorError8) {
                  _context10.next = 55;
                  break;
                }

                throw _iteratorError8;

              case 55:
                return _context10.finish(52);

              case 56:
                return _context10.finish(49);

              case 57:
                updatePairings.push({
                  id: item.pairingID,
                  'influencer_details': item.influencer_details
                });

              case 58:
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context10.next = 62;
                return __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].updatePairings(formData);

              case 62:
                resp = _context10.sent;

                if (resp) {
                  _matchItemIdx = _this38.items.findIndex(function (f) {
                    return f.pairingID === item.pairingID;
                  });

                  if (_matchItemIdx !== -1) {
                    _this38.items[_matchItemIdx][field] = item[field];
                    if (field === 'topAudAges') {
                      item.influencer_details.audAges = __WEBPACK_IMPORTED_MODULE_39_lodash_sortBy___default()(item.influencer_details.audAges, 'lineupIndex');
                      _this38.items[_matchItemIdx].audAges = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], item.influencer_details.audAges);
                      _this38.items[_matchItemIdx].audAgesDisplay = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this38.items[_matchItemIdx].audAges.splice(0, item.topAudAges.length));
                      _this38.items[_matchItemIdx].audAgesEdit = false;
                    }
                    if (field === 'topCountries') {
                      item.influencer_details.countries = __WEBPACK_IMPORTED_MODULE_39_lodash_sortBy___default()(item.influencer_details.countries, 'lineupIndex');
                      _this38.items[_matchItemIdx].countries = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], item.influencer_details.countries);
                      _this38.items[_matchItemIdx].topCountryDisplay = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this38.items[_matchItemIdx].countries.splice(0, item.topCountries.length));
                      _this38.items[_matchItemIdx].audCountryEdit = false;
                    }
                    if (field === 'gender') {
                      _this38.items[_matchItemIdx].genderEdit = false;
                      _this38.items[_matchItemIdx].influencer_details.gender = item.influencer_details.gender;
                    }
                    if (field === 'followers') {
                      _this38.items[_matchItemIdx].followersEdit = false;
                      _this38.items[_matchItemIdx].influencer_details.followers = item.influencer_details.followers;
                    }
                    if (field === 'platformName') {
                      _this38.items[_matchItemIdx].platformNameEdit = false;
                      _this38.items[_matchItemIdx].influencer_details.platformName = item.influencer_details.platformName;
                    }
                    if (field === 'age_group') {
                      _this38.items[_matchItemIdx].ageGroupEdit = false;
                      _this38.items[_matchItemIdx].influencer_details.age_group = item.influencer_details.age_group;
                    }
                    tmp = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this38.items);

                    _this38.items = [];
                    _this38.items = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.refreshJSON(tmp);
                  }
                }
                _this38.isLoading = false;

              case 65:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this38, [[15, 19, 23, 31], [24,, 26, 30], [41, 45, 49, 57], [50,, 52, 56]]);
      }))();
    },
    checkSelectLimit: function checkSelectLimit(item, field) {
      if (item[field].length > 2) {
        item[field].pop();
      }
    },
    detectCurrency: function detectCurrency(items) {
      var _this39 = this;

      var currencies = __WEBPACK_IMPORTED_MODULE_30__config__["a" /* default */].currencies;
      currencies.map(function (c) {
        _this39.currencyTotals[c] = 0;
      });
      items.map(function (item) {
        if (item.currency && item.pairingStatus === _this39.pairingStatus.ACCEPTED.value) {
          _this39.currencyTotals[item.currency] += Number(item.payoutAmount || 0);
        }
      });
    },
    isPendingActivity: function isPendingActivity(item) {
      if (item.activity) {
        if (Array.isArray(item.activity)) {
          var matchPending = item.activity.filter(function (item) {
            return item.status === 'pending';
          });
          if (matchPending.length) return true;
        }
      }
      return false;
    },
    updatePagination: function updatePagination(pagination) {
      var _this40 = this;

      this.showPie = false;
      setTimeout(function () {
        _this40.showPie = true;
      }, 500);
    },
    checkHoverSortIcon: function checkHoverSortIcon() {
      var vm = this;
      setInterval(function () {
        vm.disableSort = true;
        var elements = document.querySelectorAll('.move-cursor');
        elements.forEach(function (element) {
          if (element) {
            if (element.matches(':hover')) {
              vm.disableSort = false;
            }
          }
        });
      }, 1);
    },
    checkReportDate: function checkReportDate(date) {
      if (!date) return false;
      if (__WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format('YYYY-MM-DD') < __WEBPACK_IMPORTED_MODULE_12_moment___default()().subtract(182, 'days').format('YYYY-MM-DD')) {
        return true;
      }
      return false;
    },
    moveOption: function moveOption(targetOption) {
      var _this41 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, selectOne, updatePairings, formData;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this41.isLoading = true;
                _iteratorNormalCompletion9 = true;
                _didIteratorError9 = false;
                _iteratorError9 = undefined;
                _context11.prev = 4;
                _iterator9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this41.actionSelected);

              case 6:
                if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                  _context11.next = 16;
                  break;
                }

                selectOne = _step9.value;
                updatePairings = [{
                  id: selectOne.pairingID,
                  'options': Number(targetOption),
                  allOptions: null
                }];
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context11.next = 13;
                return __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].updatePairings(formData);

              case 13:
                _iteratorNormalCompletion9 = true;
                _context11.next = 6;
                break;

              case 16:
                _context11.next = 22;
                break;

              case 18:
                _context11.prev = 18;
                _context11.t0 = _context11['catch'](4);
                _didIteratorError9 = true;
                _iteratorError9 = _context11.t0;

              case 22:
                _context11.prev = 22;
                _context11.prev = 23;

                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }

              case 25:
                _context11.prev = 25;

                if (!_didIteratorError9) {
                  _context11.next = 28;
                  break;
                }

                throw _iteratorError9;

              case 28:
                return _context11.finish(25);

              case 29:
                return _context11.finish(22);

              case 30:
                _this41.actionSelected = [];
                _this41.getPairedInfluencers(_this41.campaign.id);
                _this41.isLoading = false;
                _this41.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: 'Successfully Moved.'
                });

              case 34:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this41, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },
    moveAllOption: function moveAllOption(option) {
      var _this42 = this;

      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, selectOne, updatePairings, formData;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this42.isLoading = true;
                _iteratorNormalCompletion10 = true;
                _didIteratorError10 = false;
                _iteratorError10 = undefined;
                _context12.prev = 4;
                _iterator10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_this42.actionSelected);

              case 6:
                if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                  _context12.next = 16;
                  break;
                }

                selectOne = _step10.value;
                updatePairings = [{
                  id: selectOne.pairingID,
                  allOptions: true,
                  options: null
                }];
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context12.next = 13;
                return __WEBPACK_IMPORTED_MODULE_22__Pairing_pairingAPIs__["a" /* default */].updatePairings(formData);

              case 13:
                _iteratorNormalCompletion10 = true;
                _context12.next = 6;
                break;

              case 16:
                _context12.next = 22;
                break;

              case 18:
                _context12.prev = 18;
                _context12.t0 = _context12['catch'](4);
                _didIteratorError10 = true;
                _iteratorError10 = _context12.t0;

              case 22:
                _context12.prev = 22;
                _context12.prev = 23;

                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }

              case 25:
                _context12.prev = 25;

                if (!_didIteratorError10) {
                  _context12.next = 28;
                  break;
                }

                throw _iteratorError10;

              case 28:
                return _context12.finish(25);

              case 29:
                return _context12.finish(22);

              case 30:
                _this42.actionSelected = [];
                _this42.getPairedInfluencers(_this42.campaign.id);
                _this42.isLoading = false;
                _this42.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: 'Successfully Moved.'
                });

              case 34:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this42, [[4, 18, 22, 30], [23,, 25, 29]]);
      }))();
    }
  }
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pairing_pairingAPIs__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'followUp',
  props: ['dialog', 'dialogClose', 'from', 'fromName', 'to', 'toName'],
  data: function data() {
    return {
      MessageRules: [function (value) {
        return !!value || 'Required.';
      }],
      subjectRules: [function (value) {
        return !!value || 'Required.';
      }],
      valid: true,
      subject: '',
      message: '',
      progressBar: false
    };
  },
  methods: {
    send: function send() {
      var _this = this;

      if (this.$refs.form.validate()) {
        this.progressBar = true;
        var formData = {
          fromEmail: this.from,
          fromName: this.fromName,
          toEmail: this.to,
          toName: this.toName,
          subject: this.subject,
          message: this.message
        };
        __WEBPACK_IMPORTED_MODULE_0__Pairing_pairingAPIs__["a" /* default */].sendFollowUpEmail(formData).then(function () {
          _this.progressBar = false;
          _this.cancel();
        });
      }
    },
    cancel: function cancel() {
      this.subject = '';
      this.message = '';
      this.$refs.form.resetValidation();
      this.dialogClose();
    }
  }
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaignHelper__ = __webpack_require__(25);
















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    payout: Object
  },
  data: function data() {
    return {
      payoutData: '',
      moneyoutData: {},
      influencerData: {},
      campaignData: {},
      clientData: {},
      pickDate: false,
      rules: {
        required: function required(v) {
          return !!v || 'Amount is required';
        }
      },
      submissionData: {
        toMakePaymentDate: '',
        payoutAmount: ''
      },
      pairedAmount: 0,
      clients: [],
      userCs: [],
      loadingDialog: false
    };
  },

  computed: {
    payoutExceeded: function payoutExceeded() {
      if (this.submissionData.payoutAmount > this.pairedAmount) {
        return true;
      }
      return false;
    },
    diffPayoutAmount: function diffPayoutAmount() {
      return Math.round((this.submissionData.payoutAmount - this.pairedAmount) * 100) / 100;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    buildFormData: function buildFormData() {
      var payout = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        payoutAmount: this.pairedAmount,
        toMakePaymentDate: this.submissionData.toMakePaymentDate
      });
      var formData = new FormData();
      formData.append('moneyout', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.constructMoneyOutData(this.moneyoutData)));
      formData.append('payout', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(payout));
      return formData;
    },

    updateAmount: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        var payload, editData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.pairedAmount === 0)) {
                  _context.next = 3;
                  break;
                }

                this.$swal('Incorrect Amount');
                return _context.abrupt('return');

              case 3:
                payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
                  campaignID: this.payout.campaignID,
                  handle: this.payout.handle,
                  platform: this.payout.platform
                });
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12__campaignHelper__["a" /* default */].invokeReportOwnerCheck(this, payload);

              case 6:
                editData = this.buildFormData();

                this.$swal({
                  title: 'Are you sure the amount is correct?',
                  type: 'question',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showCancelButton: true,
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function preConfirm() {
                    _this.loadingDialog = true;
                    return __WEBPACK_IMPORTED_MODULE_6__Influencer_influencerAPIs__["a" /* default */].editCampaignPayout(_this.payoutData.id, editData).then(function (response) {
                      _this.loadingDialog = false;
                      return response;
                    }).catch(function (error) {
                      _this.loadingDialog = false;
                      _this.$swal({
                        text: error,
                        type: 'error'
                      });
                    });
                  },
                  allowOutsideClick: function allowOutsideClick() {
                    return !_this.$swal.isLoading();
                  }
                }).then(function (result) {
                  _this.loadingDialog = false;
                  if (result.value) {
                    _this.$swal({
                      title: 'Saved successfully',
                      type: 'success'
                    }).then(function () {
                      _this.$emit('input');
                      _this.$emit('payoutAmountUpdated');
                    });
                  }
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateAmount() {
        return _ref.apply(this, arguments);
      }

      return updateAmount;
    }(),
    calDaysLeft: function calDaysLeft(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()().to(date);
    },
    changeDateFormat: function changeDateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('DD-MM-YYYY');
    },
    calCogsRate: function calCogsRate(currentUse, cogs) {
      return (currentUse / cogs * 100).toFixed(2);
    },
    fetchRequireData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payout) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loadingDialog = true;

                if (payout.postID && !payout.influencerID) {
                  __WEBPACK_IMPORTED_MODULE_5__Post_postApi__["a" /* default */].getPostById(payout.postID).then(function (response) {
                    _this2.loadingDialog = false;
                    _this2.getInfluencer(response.mainPost.influencerID);
                  }).catch(function (err) {
                    _this2.loadingDialog = false;
                    _this2.$swal({
                      title: 'Couldn\'t Load the Post',
                      type: 'error',
                      text: err
                    });
                  });
                } else {
                  this.getInfluencer(payout.influencerID);
                }

                __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__["a" /* default */].getCampaign(payout.campaignID).then(function (campaign) {
                  _this2.campaignData = {
                    id: campaign.id,
                    budget: campaign.budget,
                    cogs: campaign.budget * 0.3,
                    name: campaign.name,
                    assignedTo: campaign.assignedTo,
                    clientID: campaign.clientID
                  };
                }).catch(function (err) {
                  _this2.$swal({
                    title: 'Couldn\'t load the Campaign',
                    type: 'error',
                    text: err
                  });
                });
                this.loadingDialog = false;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchRequireData(_x) {
        return _ref2.apply(this, arguments);
      }

      return fetchRequireData;
    }(),
    getInfluencer: function getInfluencer(influencerID) {
      var _this3 = this;

      if (!influencerID) return;
      __WEBPACK_IMPORTED_MODULE_6__Influencer_influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (influencer) {
        _this3.loadingDialog = false;
        _this3.influencerData = {
          influencerID: influencer.id,
          bankAccount: influencer.bankAccount,
          bankName: influencer.bankName,
          fullName: influencer.fullName,
          mailingAddress: influencer.mailingAddress
        };
        if (influencer.tiktokaudience) {
          _this3.influencerData.engagementRate = influencer.tiktokaudience ? influencer.tiktokaudience.user_profile.engagement_rate : '-';
          _this3.influencerData.followers = influencer.tiktokaudience ? influencer.tiktokaudience.user_profile.followers : '-';
        } else {
          _this3.influencerData.engagementRate = influencer.audience ? influencer.audience.user_profile.engagement_rate : '-';
          _this3.influencerData.followers = influencer.audience ? influencer.audience.user_profile.followers : '-';
        }
        _this3.getPairingDetails();
      }).catch(function (err) {
        _this3.loadingDialog = false;
        _this3.$swal({
          title: 'Couldn\'t Load Influencer Data',
          type: 'error',
          text: err
        });
      });
    },
    getPairingDetails: function getPairingDetails() {
      var _this4 = this;

      this.loadingDialog = true;
      this.pairedAmount = 0;
      __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__["a" /* default */].getPairedAmount(this.payoutData.campaignID, this.influencerData.influencerID).then(function (pairingData) {
        _this4.loadingDialog = false;
        if (pairingData.payout_details) {
          _this4.pairedAmount = pairingData.payout_details.amount;
        }
      }).catch(function (err) {
        _this4.loadingDialog = false;
        _this4.$swal({
          title: 'Couldn\'t load the PairingData',
          type: 'error',
          text: err
        });
      });
    },
    fetchCSs: function fetchCSs() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, users;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 3:
                resp = _context3.sent;
                users = resp.users;

                _this5.userCs = users.map(function (user) {
                  return {
                    name: user.firstName + ' ' + user.lastName,
                    id: user.id
                  };
                });
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                _this5.$swal({
                  text: 'Cannot fetch the list of CS',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    fetchClient: function fetchClient() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp, clients;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__Client_clientAPIs__["a" /* default */].getAllClients(true);

              case 3:
                resp = _context4.sent;
                clients = resp.data;

                _this6.clients = clients.map(function (user) {
                  return {
                    name: user.name,
                    id: user.id
                  };
                });
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);
                _this6.$swal({
                  text: 'Cannot fetch the list of clients',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 8]]);
      }))();
    },
    constructMoneyOutData: function constructMoneyOutData(input) {
      var _this7 = this;

      var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, input);
      if (input.id) {
        data.id = input.id;
      }
      if (this.payoutData.platform === 'tiktok') {
        data.tiktokHandle = this.payoutData.handle;
      } else {
        data.instagramHandle = this.payoutData.handle;
      }
      data.payoutID = this.payoutData.id;
      data.postID = this.payoutData.postID;
      data.campaign = {
        name: this.campaignData.name,
        id: this.campaignData.id,
        clientID: this.campaignData.clientID
      };
      data.client = this.clients.find(function (c) {
        return c.id === _this7.campaignData.clientID;
      });
      data.cs = this.userCs.filter(function (user) {
        return _this7.campaignData.assignedTo && _this7.campaignData.assignedTo.includes(user.id);
      });
      data.bankAccountNo = this.influencerData.bankAccount;
      data.receivingName = this.influencerData.fullName;
      data.amount = this.submissionData.payoutAmount;
      return data;
    },
    resetMoneyOutData: function resetMoneyOutData() {
      this.moneyoutData = {
        bankAccountNo: '',
        csName: '',
        receivingName: '',
        instagramHandle: '',
        BIBREF: '',
        FTREF: '',
        bankSwiftCode: '',
        REF: '',
        postID: '',
        status: 'PENDING',
        billingContact: '',
        campaign: null,
        amount: 0
      };
    },

    showRequiredActions: function showRequiredActions() {
      return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.INFLUENCER !== this.currentUserRole;
    }
  },
  watch: {
    payout: function payout(newPayout) {
      this.fetchCSs();
      if (this.showRequiredActions()) {
        this.fetchClient();
      }
      this.fetchRequireData(newPayout);
      this.payoutData = newPayout;
      if (newPayout.moneyOut) {
        this.moneyoutData = newPayout.moneyOut;
      } else this.resetMoneyOutData();
      this.submissionData.toMakePaymentDate = newPayout.toMakePaymentAt;
      this.submissionData.payoutAmount = newPayout.payoutAmount;
    }
  },
  mounted: function mounted() {
    this.resetMoneyOutData();
  }
});

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-rate-card',
  components: {
    ViewCampaignModal: __WEBPACK_IMPORTED_MODULE_3__ViewCampaignModal___default.a
  },
  data: function data() {
    return {
      campaigns: [],
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      editRateCardStatus: '',
      fields: [{
        key: 'campaign.name'
      }, {
        key: 'campaign.budget'
      }, {
        key: 'influencer.instagram.instagramHandle',
        label: 'IG Handle'
      }, {
        key: 'initialRateCard',
        label: 'Normal Rate Card'
      }, {
        key: 'editRateCard',
        label: 'Requested Rate Card'
      }, {
        key: 'actions'
      }],
      viewCampaignData: null
    };
  },
  created: function created() {
    this.paginate(1);
  },

  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    }
  },
  methods: {
    paginate: function paginate() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].paginateRateCard({
        editRateCardStatus: 1
      }).then(function (response) {
        var campaigns = response;

        _this.campaigns = campaigns;
        _this.totalRows = response.totalCampaigns;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this2.viewCampaignData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    approveRateCard: function approveRateCard(rowID, editRateCard) {
      var _this3 = this;

      var rateCardConfirmation = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].rateCardConfirmation.approval;

      this.$swal({
        title: rateCardConfirmation['confirmation']['title'],
        text: rateCardConfirmation['confirmation']['text'],
        type: rateCardConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: rateCardConfirmation['confirmation']['confirmText'],
        cancelButtonText: rateCardConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].approveRateCard(rowID, editRateCard).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this3.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this3.paginate(1);

          _this3.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].campaignStatusFlow['approve'][_this3.campaignStatus],
            data: null
          });

          _this3.$swal({
            title: rateCardConfirmation['confirm']['title'],
            text: rateCardConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    rejectRateCard: function rejectRateCard(rowID) {
      var _this4 = this;

      var rateCardConfirmation = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].rateCardConfirmation.rejection;

      this.$swal({
        title: rateCardConfirmation['confirmation']['title'],
        text: rateCardConfirmation['confirmation']['text'],
        type: rateCardConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: rateCardConfirmation['confirmation']['confirmText'],
        cancelButtonText: rateCardConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_1__campaignAPIs__["a" /* default */].rejectRateCard(rowID).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this4.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this4.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this4.paginate(1);

          _this4.$store.commit('SET_CAMPAIGNS', {
            campaignStatus: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].campaignStatusFlow['approve'][_this4.campaignStatus],
            data: null
          });

          _this4.$swal({
            title: rateCardConfirmation['confirm']['title'],
            text: rateCardConfirmation['confirm']['text'],
            type: 'success'
          });
        } else {}
      });
    },
    buttonShowPairing: function buttonShowPairing(pairingStatus) {
      return pairingStatus === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].pairingStatus.INVITED;
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    }
  }
});

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReleaseToCcModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    campaign: Object
  },
  validations: {
    updateData: {
      deadline: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      remarks: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      deadlineCal: false,
      isLoading: false,
      updateData: {
        deadline: '',
        remarks: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  watch: {
    value: function value(newValue) {
      this.updateData = {
        deadline: '',
        remarks: ''
      };
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _this2.updateData.createdAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString();
                _this2.updateData.userID = _this2.currentUserID;
                saveData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                  id: _this2.campaign.id,
                  CCInputs: _this2.updateData,
                  releasedToAdmin: true
                });
                _context2.next = 6;
                return _this2.$store.dispatch('campaign/updateCampaignByIds', [saveData]);

              case 6:
                _this2.isLoading = false;

                if (!_this2.campaignUpdated) {
                  _context2.next = 15;
                  break;
                }

                _this2.$swal({
                  text: 'Successfully Released to Admin.',
                  type: 'success'
                });
                _context2.next = 11;
                return _this2.$store.dispatch('campaign/sendCampaignReleaseEmailToAdmin', {
                  id: _this2.campaign.id
                });

              case 11:
                _this2.$emit('saved', _this2.campaign.id);
                _this2.close();
                _context2.next = 16;
                break;

              case 15:
                _this2.$swal({
                  text: 'Error Release to Admin!',
                  type: 'error'
                });

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReleaseToCcModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    campaign: Object
  },
  validations: {
    updateData: {
      deadline: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      remarks: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      deadlineCal: false,
      isLoading: false,
      updateData: {
        deadline: '',
        remarks: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  watch: {
    value: function value(newValue) {
      this.updateData = {
        deadline: '',
        remarks: ''
      };
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _this2.updateData.createdAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString();
                _this2.updateData.userID = _this2.currentUserID;
                saveData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                  id: _this2.campaign.id,
                  AMInputs: _this2.updateData
                });
                _context2.next = 6;
                return _this2.$store.dispatch('campaign/updateCampaignByIds', [saveData]);

              case 6:
                _this2.isLoading = false;
                if (_this2.campaignUpdated) {
                  _this2.$emit('saved', _this2.campaign.id);
                  _this2.close();
                } else {
                  _this2.$swal({
                    text: 'Error Release to Client!',
                    type: 'error'
                  });
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportGroupModal',
  props: {
    selectedPosts: Array,
    campaignID: String,
    value: Boolean
  },
  data: function data() {
    return {
      reportGroups: [],
      selectedGroup: '',
      newReportGroup: '',
      loading: false
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue === true) {
        this.getReportGroups();
      }
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    saveReportGroup: function saveReportGroup() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = _this2.buildFormData();

                _this2.loading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].addReportGroup(formData);

              case 5:
                response = _context2.sent;

                if (response) {
                  _this2.getReportGroups();

                  _this2.loading = false;
                  _this2.$swal({
                    title: 'Successful',
                    text: 'Reports are added to (' + (response.group.name || '-') + ')',
                    type: 'success'
                  }).then(function () {
                    _this2.$emit('input');
                    _this2.$emit('saved', true);
                  });
                }
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                _this2.loading = false;
                _this2.$swal({
                  title: 'Error',
                  text: _context2.t0,
                  type: 'error'
                });
                console.log('error', _context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 9]]);
      }))();
    },
    buildFormData: function buildFormData() {
      var formData = new FormData();
      formData.append('group', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedGroup));
      formData.append('reports', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedPosts.map(function (c) {
        return c.id;
      })));
      return formData;
    },
    closeModal: function closeModal() {
      this.$emit('input');
      this.selectedGroup = '';
    },
    getReportGroups: function getReportGroups() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].getReportGroups(_this3.campaignID);

              case 3:
                resp = _context3.sent;

                if (resp.success) {
                  _this3.reportGroups = resp.data;
                  _this3.selectedGroup = '';
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Finance_PayoutScreenshotsDialog_vue__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Finance_PayoutScreenshotsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Finance_PayoutScreenshotsDialog_vue__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportPayoutLists',
  props: ['campaignID', 'refresh', 'source'],
  components: {
    PayoutScreenshotsDialog: __WEBPACK_IMPORTED_MODULE_13__Finance_PayoutScreenshotsDialog_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_10__components_scoped_custom_DatePicker___default.a
  },
  data: function data() {
    return {
      headers: [{ value: 'handle', text: 'Handle', sortable: true, width: '210px', class: 'report-payout-handle-column', cellClass: 'report-payout-handle-column' }, { value: 'createdAt', text: 'Submitted date', sortable: true }, { value: 'satisfaction_level_on_kobe', text: 'Satisfication Level on Kobe', sortable: true }, { value: 'satisfaction_level_on_advertiser', text: 'Satisfication Level on Client', sortable: true }, { value: 'promotingProducts', text: 'What do you like most about this product/service you are promoting?', sortable: true }, { value: 'improved', text: 'What are areas of improvement about this product/service that will be valuable feedback for them?', sortable: true }, { value: 'audienceEnjoyment', text: 'What do you think your audience enjoyed about your content?', sortable: true }, { value: 'otherCampaigns', text: 'What other campaigns would you want to work more on with us?', sortable: true }, { value: 'action', text: 'Stats Submitted' }],
      items: [],
      filteredItems: [],
      moneyouts: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      payoutViewDialog: false,
      payoutViewData: null,
      viewScreenShotsDialog: false,
      imagesToView: [],
      imageViewerDialog: false,
      activeImage: '',
      searchFilters: {},
      campaignFilterLists: [],
      subDateCal: false,
      dueDateCal: false,
      copySucceeded: false,
      formLink: '',
      totalValues: {
        submitted: {
          actual: 0,
          total: 0,
          percent: 0
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  }),
  watch: {
    campaignID: function campaignID(value) {
      if (value) {
        this.searchFilters.campaignID = value;
        this.getAllCampaignPayouts();
      }
    },
    refresh: function refresh(value) {
      if (value) {
        this.resetFilters();
        this.getAllCampaignPayouts();
      }
    }
  },
  methods: {
    viewMedia: function viewMedia(img) {
      this.activeImage = img;
      this.imageViewerDialog = true;
    },
    viewImages: function viewImages(item) {
      this.imagesToView = item;
      this.viewScreenShotsDialog = true;
    },
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */]['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateItems: function updateItems(newItems) {
      this.items = newItems;
      this.totalRows = this.items.length;
      this.setFilteredItems();
      this.filterbyDates();
      this.calcTotalSummary(this.filteredItems);
    },
    getAllCampaignPayouts: function getAllCampaignPayouts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_11__Influencer_influencerAPIs__["a" /* default */].getAllCampaignPayouts(this.searchFilters).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          var displayItems, campaignPayouts;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.getPairedInfluencers(_this.searchFilters.campaignID);

                case 2:
                  displayItems = _context.sent;
                  campaignPayouts = response.data;

                  campaignPayouts = campaignPayouts.map(function (element) {
                    var elementPlatform = String(element.platform || '').toLowerCase();
                    var resultData = {
                      campaignName: element.campaignName,
                      postID: element.postID,
                      influencerID: element.influencerID,
                      collaboration: element.collaboration || null,
                      improved: element.improved || null,
                      promotingProducts: element.promotingProducts || null,
                      audienceEnjoyment: element.audienceEnjoyment || null,
                      otherCampaigns: element.otherCampaigns || null,
                      other_social_media_post_url: element.otherSocialMediaPostUrl,
                      satisfaction_level_on_campaign: element.satisfactionLevel,
                      satisfaction_level_on_kobe: element.kobeSatisfactionLevel,
                      satisfaction_level_on_advertiser: element.advertiserSatisfactionLevel || 0,
                      createdAt: element.createdAt,
                      toMakePaymentAt: __WEBPACK_IMPORTED_MODULE_6_moment___default()(element.createdAt).add(30, 'days').format(),
                      payoutAmount: element.payoutAmount || '',

                      images: element.images || [],
                      posts: element.posts || [],
                      stories: element.stories || [],
                      deliverablePosts: element.deliverablePosts || []
                    };
                    if (element.linkedin || elementPlatform === 'linkedin') {
                      resultData.handle = element.linkedin && (element.linkedin.linkedinHandle || element.linkedin.handle) || element.linkedinHandle || element.handle || element.instagram && element.instagram.instagramHandle || '';
                      resultData.fullName = element.linkedin && (element.linkedin.linkedinFullname || element.linkedin.fullName) || element.fullName || '';
                      resultData.linkedin_post_url = element.linkedinPostURL || element.otherSocialMediaPostUrl || '';
                      resultData.platform = 'linkedin';
                    } else if (element.twitter || elementPlatform === 'twitter' || elementPlatform === 'x') {
                      resultData.handle = element.twitter && (element.twitter.twitterHandle || element.twitter.handle) || element.twitterHandle || element.userHandle || element.handle || element.instagram && element.instagram.instagramHandle || '';
                      resultData.fullName = element.twitter && (element.twitter.twitterFullname || element.twitter.fullName) || element.fullName || '';
                      resultData.twitter_post_url = element.twitterPostURL || element.otherSocialMediaPostUrl || '';
                      resultData.platform = 'twitter';
                    } else if (element.tiktok) {
                      resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : '';
                      resultData.fullName = element.tiktok ? element.tiktok.tiktokFullname : '';
                      resultData.tiktok_post_url = element.tiktokPostURL;
                      resultData.platform = 'tiktok';
                    } else {
                      resultData.handle = element.instagram ? element.instagram.instagramHandle : '';
                      resultData.fullName = element.instagram ? element.instagram.instagramFullname : '';
                      resultData.instagram_post_url = element.instagramPostURL;
                      resultData.platform = 'instagram';
                      resultData.xhsID = element.xhsID || '';
                    }
                    if (!resultData.handle) {
                      if (element.handle) {
                        resultData.handle = element.handle;
                        resultData.platform = element.platform || 'instagram';
                        resultData.xhsID = element.xhsID || '';
                      }
                    }
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
                      id: element.id,
                      campaignID: element.campaignID,
                      postID: element.postID
                    }, resultData);
                  });
                  displayItems = displayItems.map(function (item) {
                    var matchPayout = campaignPayouts.find(function (c) {
                      return c.handle === item.handle && c.platform === item.platform || c.influencerID && c.influencerID === item.influencerID;
                    });
                    if (matchPayout) {
                      var handle = item.handle;
                      var platform = item.platform;
                      item = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, matchPayout);
                      item.handle = handle;
                      item.platform = platform;
                    }
                    return item;
                  });

                  _this.updateItems(displayItems);
                  _this.lastUpdate = response.lastUpdate;

                case 8:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log('error', error);
      });
    },
    getPairedInfluencers: function getPairedInfluencers(campaignID) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var items, pairingResp, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, inf;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                items = [];
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID);

              case 3:
                pairingResp = _context2.sent;

                if (!pairingResp) {
                  _context2.next = 24;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 8;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pairingResp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  inf = _this2.beautifyPairingData(data);

                  if (inf.pairingStatus === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].pairingStatus.ACCEPTED) {
                    items.push(inf);
                  }
                }
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 16:
                _context2.prev = 16;
                _context2.prev = 17;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 19:
                _context2.prev = 19;

                if (!_didIteratorError) {
                  _context2.next = 22;
                  break;
                }

                throw _iteratorError;

              case 22:
                return _context2.finish(19);

              case 23:
                return _context2.finish(16);

              case 24:
                return _context2.abrupt('return', items);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[8, 12, 16, 24], [17,, 19, 23]]);
      }))();
    },
    beautifyPairingData: function beautifyPairingData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var rawPlatform = String(influencerDetails.platform || 'instagram').toLowerCase();
      var platform = rawPlatform === 'x' ? 'twitter' : rawPlatform;
      inf.pairingID = data.id;
      inf.influencerID = influencerDetails.influencerID || null;
      inf.handle = platform === 'linkedin' ? influencerDetails.linkedinHandle || influencerDetails.instagramHandle || influencerDetails.userHandle : platform === 'twitter' ? influencerDetails.twitterHandle || influencerDetails.userHandle || influencerDetails.twitter && influencerDetails.twitter.twitterHandle || influencerDetails.instagramHandle : influencerDetails.instagramHandle;
      inf.platform = platform;
      inf.xhsID = influencerDetails.xhsID || influencerDetails.instagramHandle;
      inf.fullName = influencerDetails.fullName || '';
      inf.pairingStatus = data.pairing_details.status;
      inf.images = [];
      inf.posts = [];
      inf.stories = [];
      inf.deliverablePosts = [];
      inf.pending = true;
      return inf;
    },

    calDaysLeft: function calDaysLeft(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()().to(date);
    },
    changeDateFormat: function changeDateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('DD-MM-YYYY');
    },
    disableViewScreenshot: function disableViewScreenshot(item) {
      return !item.images.length > 0 && !item.posts.length > 0 && !item.stories.length > 0 && !item.deliverablePosts.length > 0;
    },
    filterbyDates: function filterbyDates() {
      var _this3 = this;

      if (this.searchFilters.submissionDate) {
        this.filteredItems = this.items.filter(function (item) {
          return item.createdAt && __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === _this3.searchFilters.submissionDate;
        });
      }
      if (this.searchFilters.dueDate) {
        var filterDueDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.searchFilters.dueDate).subtract(30, 'days').format('YYYY-MM-DD');
        this.filteredItems = this.items.filter(function (item) {
          return item.createdAt && __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === filterDueDate;
        });
      }
      this.calcTotalSummary(this.filteredItems);
    },
    setSubmissionDateFilter: function setSubmissionDateFilter(value) {
      this.searchFilters.submissionDate = value;
      this.setFilteredItems();
      this.filterbyDates();
    },
    setDueDateFilter: function setDueDateFilter(value) {
      this.searchFilters.dueDate = value;
      this.setFilteredItems();
      this.filterbyDates();
    },
    setFilteredItems: function setFilteredItems() {
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.items);
    },
    resetFilters: function resetFilters() {
      this.searchFilters.submissionDate = '';
      this.searchFilters.dueDate = '';
      this.filter = '';
    },
    resetTotalValues: function resetTotalValues() {
      this.totalValues = {
        submitted: {
          actual: 0,
          total: 0,
          percent: 0
        }
      };
    },
    calcTotalSummary: function calcTotalSummary() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.resetTotalValues();
      if (!items.length) {
        return;
      }
      var totalItems = items.length;
      this.totalValues.submitted.total = totalItems;
      var actualSubmitted = items.filter(function (f) {
        return !f.pending;
      }).length;
      if (actualSubmitted) {
        this.totalValues.submitted.actual = actualSubmitted;
        this.totalValues.submitted.percent = (actualSubmitted / totalItems * 100).toFixed(2);
      }
    },
    currentItems: function currentItems() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.calcTotalSummary(_this4.$refs.ReportPayoutListsTable.$children[0].filteredItems);
      });
    },
    copyFormLink: function copyFormLink(item) {
      this.copySucceeded = true;
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.formLink = protocol + '//' + host + '/submit-post-payout?pairingID=' + item.pairingID;
      setTimeout(function () {
        item.linkCopied = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.copyToClipboard('#copy-link');
      }, 100);
    },
    linkedInProfileUrl: function linkedInProfileUrl(item) {
      var explicitUrl = item.linkedinURL || item.linkedinUrl || item.linkedin_profile_url;
      if (explicitUrl) return explicitUrl;
      if (item.handle && /^https?:\/\//i.test(item.handle)) return item.handle;
      return 'https://www.linkedin.com/in/' + (item.handle || '');
    }
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this5.campaignID) {
                _this5.searchFilters.campaignID = _this5.campaignID;
                _this5.getAllCampaignPayouts();
              }

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: Boolean,
      default: false
    },

    comments: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    dialog: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (!val) {
          this.$emit('close');
        }
      }
    }
  },
  filters: {
    dateFormat: function dateFormat(dateString) {
      if (!dateString) return 'N/A';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateString).format('DD-MM-YYYY');
    }
  }
});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportPasscodeModal',
  props: {
    campaign: Object,
    value: Boolean
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      show1: false,
      passcode: ''
    };
  },

  validations: {
    passcode: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    passcodeErrors: function passcodeErrors() {
      var errors = [];
      if (!this.$v.passcode.$dirty) return errors;
      !this.$v.passcode.required && errors.push('Passcode is required');
      return errors;
    }
  },
  methods: {
    resetPasscode: function resetPasscode() {
      var _this = this;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0__campaignAPIs__["a" /* default */].resetPasscode(this.campaign.id, this.passcode).then(function (response) {
        _this.$swal({
          title: 'Success',
          text: 'Successfully Changed Passcode.',
          type: 'success'
        }).then(function () {
          _this.$emit('updated');
          _this.closeModal();
        });
      }).catch(function (error) {
        _this.$swal({
          title: 'Error',
          type: 'error',
          text: error
        });
        console.log('error', error);
      });
    },
    closeModal: function closeModal() {
      this.$v.$reset();
      this.$emit('input');
      this.passcode = '';
    },
    removeSpaces: function removeSpaces() {
      this.$v.passcode.$touch();
      this.passcode = this.passcode.replace(/\s/g, '');
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  }
});

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Timeline_AddReviewMeetingDate__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Timeline_AddReviewMeetingDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Timeline_AddReviewMeetingDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReviewDeckUrlModal__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReviewDeckUrlModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ReviewDeckUrlModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReviewMeetingChecklistModal__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReviewMeetingChecklistModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ReviewMeetingChecklistModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_ViewEditMode__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay_dist_vue_loading_css__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpComingReviewMeetingDataTable',
  props: ['refresh'],
  mixins: [__WEBPACK_IMPORTED_MODULE_18__mixins_ViewEditMode__["a" /* default */]],
  components: {
    AddReviewMeetingDate: __WEBPACK_IMPORTED_MODULE_15__Timeline_AddReviewMeetingDate___default.a,
    ReviewDeckUrlModal: __WEBPACK_IMPORTED_MODULE_16__ReviewDeckUrlModal___default.a,
    ReviewMeetingChecklistModal: __WEBPACK_IMPORTED_MODULE_17__ReviewMeetingChecklistModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_21_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].tableHeaders,
      AM: [],
      CC: [],
      filteredItems: [],
      revMeetingSections: [],
      revMeetingSectionTypes: {
        new: 0,
        processing: 1,
        completed: 2
      },
      reviewDeckItem: {},
      reviewDateCol: '',
      checkItem: {},
      checkCol: '',
      filter: '',
      reviewMeetingFilters: {
        showPastData: false,
        showEmptyReviewDate: false
      },
      feedbackLink: '',
      reviewDeckURLDialog: false,
      checkListsDialog: false,
      disableSave: false,
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    reviewMeetings: function reviewMeetings(state) {
      return state.campaignTimeline.reviewMeetings;
    },
    savedReviewMeeting: function savedReviewMeeting(state) {
      return state.campaignTimeline.savedReviewMeeting;
    }
  }), {
    overallAlignmentColAllow: function overallAlignmentColAllow() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    amReadyDeckColAllow: function amReadyDeckColAllow() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    ccReadyDeckColAllow: function ccReadyDeckColAllow() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    sentimentDateColAllow: function sentimentDateColAllow() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    approvedByAdminAllow: function approvedByAdminAllow() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  watch: {
    refresh: function refresh(value) {
      if (value) this.init();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref, _ref2, key, value, items;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _context2.next = 3;
                return _this2.getUsers();

              case 3:
                _this2.resetRevMeetingSections();
                _context2.next = 6;
                return _this2.$store.dispatch('campaignTimeline/getReviewMeetingLists', {
                  filters: {}
                });

              case 6:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 9;
                _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(_this2.revMeetingSections));

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 25;
                  break;
                }

                _ref = _step.value;
                _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                key = _ref2[0];
                value = _ref2[1];
                items = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], _this2.reviewMeetings);
                _context2.next = 19;
                return _this2.setFeedbackForms(items);

              case 19:
                items = _context2.sent;

                items = _this2.beautifyCampaignData(items, value.type);
                _this2.revMeetingSections[key].data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], items);

              case 22:
                _iteratorNormalCompletion = true;
                _context2.next = 11;
                break;

              case 25:
                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 31:
                _context2.prev = 31;
                _context2.prev = 32;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 34:
                _context2.prev = 34;

                if (!_didIteratorError) {
                  _context2.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context2.finish(34);

              case 38:
                return _context2.finish(31);

              case 39:
                _this2.isLoading = false;

              case 40:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[9, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    beautifyCampaignData: function beautifyCampaignData(items, type) {
      var _this3 = this;

      items = items.map(function (item) {
        item.AM = _this3.AM.filter(function (am) {
          return item.assignedTo && item.assignedTo.includes(am.id);
        }).map(function (am) {
          return am.name;
        }).join(', ');
        item.CC = _this3.CC.filter(function (co) {
          return item.assignedTo && item.assignedTo.includes(co.id);
        }).map(function (co) {
          return co.name;
        }).join(', ');
        var campaignTimeline = item.reviewmeetings.find(function (t) {
          return t.campaignID === item.id;
        });
        item.overallAlignmentCol = campaignTimeline && campaignTimeline.overallAlignmentCol || { status: false };
        item.AMReadyDeckCol = campaignTimeline && campaignTimeline.AMReadyDeckCol || { status: false };
        item.CCReadyDeckCol = campaignTimeline && campaignTimeline.CCReadyDeckCol || { status: false };
        item.SentimentDateCol = campaignTimeline && campaignTimeline.SentimentDateCol || { status: false };
        item.approvedByAdminCol = campaignTimeline && campaignTimeline.approvedByAdminCol || { status: false };
        if (campaignTimeline && campaignTimeline.reviewMeetingDate) {
          var meetingReviewDates = {
            reviewMeetingDate: campaignTimeline.reviewMeetingDate,
            overallAlignmentDate: campaignTimeline.overallAlignmentDate,
            amDeckReadyDate: campaignTimeline.amDeckReadyDate,
            ccDeckReadyDate: campaignTimeline.ccDeckReadyDate,
            statsReadyByLivePostsDate: campaignTimeline.statsReadyByLivePostsDate,
            statsReadyByReviewMeetingDate: campaignTimeline.statsReadyByReviewMeetingDate
          };
          item = _this3.getMeetingReviewDates(meetingReviewDates, item);
        }
        return item;
      });

      var todayDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD');

      if (type === this.revMeetingSectionTypes.new) {
        items = items.filter(function (item) {
          return item.minContentMeet && !item.reviewMeetingDate;
        });
      }

      if (type === this.revMeetingSectionTypes.processing) {
        var _items;

        var clonedItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], items);
        var upcomingItems = clonedItems.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(c.reviewMeetingDate) >= todayDate && !_this3.isRevCompleted(c);
        });
        var pastItems = clonedItems.filter(function (c) {
          return __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(c.reviewMeetingDate) < todayDate && !c.feedbackForm && !_this3.isRevCompleted(c);
        });
        pastItems = __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default()(pastItems, ['reviewMeetingDateSortFormat'], ['asc']);
        items = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], upcomingItems);
        items = __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default()(items, ['reviewMeetingDateSortFormat'], ['asc']);
        (_items = items).push.apply(_items, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(pastItems));
      }

      if (type === this.revMeetingSectionTypes.completed) {
        items = items.filter(function (item) {
          if (_this3.isRevCompleted(item)) return true;
          return false;
        });
      }
      return items;
    },
    getMeetingReviewDates: function getMeetingReviewDates(meetingReviewDates, item) {
      item.reviewMeetingDate = meetingReviewDates.reviewMeetingDate;
      item.reviewMeetingDateSortFormat = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(meetingReviewDates.reviewMeetingDate);
      item.overallAlignmentDate = meetingReviewDates.overallAlignmentDate;
      item.amDeckReadyDate = meetingReviewDates.amDeckReadyDate;
      item.ccDeckReadyDate = meetingReviewDates.ccDeckReadyDate;
      item.statsReadyByLivePostsDate = meetingReviewDates.statsReadyByLivePostsDate;
      item.statsReadyByReviewMeetingDate = meetingReviewDates.statsReadyByReviewMeetingDate;

      item.sentimentDueDate = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.getLatestDate(__WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(meetingReviewDates.statsReadyByLivePostsDate), __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(meetingReviewDates.statsReadyByReviewMeetingDate), 'DD/MM/YYYY');

      var formattedDeckReadyDate = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(item.ccDeckReadyDate);
      var formattedSentimentDate = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(item.sentimentDueDate);
      if (formattedSentimentDate > formattedDeckReadyDate) {
        item.sentimentDueDate = item.ccDeckReadyDate;
      }
      return item;
    },
    invokeReviewMeetingUpdated: function invokeReviewMeetingUpdated(item, value) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var itemIdx;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                itemIdx = _this4.filteredItems.indexOf(item);

                _this4.filteredItems[itemIdx] = _this4.getMeetingReviewDates(value, item);
                _this4.filteredItems = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.refreshJSON(_this4.filteredItems);
                _this4.filteredItems = __WEBPACK_IMPORTED_MODULE_19_lodash_orderBy___default()(_this4.filteredItems, ['reviewMeetingDateSortFormat'], ['asc']);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    saveChanges: function saveChanges() {
      var _this5 = this;

      var saveItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                saveItems = saveItems.map(function (item) {
                  return {
                    campaignID: item.id,
                    overallAlignmentCol: item.overallAlignmentCol || null,
                    AMReadyDeckCol: item.AMReadyDeckCol || null,
                    CCReadyDeckCol: item.CCReadyDeckCol || null,
                    SentimentDateCol: item.SentimentDateCol || null,
                    approvedByAdminCol: item.approvedByAdminCol || null,
                    dueDates: {
                      reviewMeetingDate: item.reviewMeetingDate,
                      sentimentDueDate: item.sentimentDueDate,
                      ccDeckReadyDate: item.ccDeckReadyDate,
                      amDeckReadyDate: item.amDeckReadyDate,
                      overallAlignmentDate: item.overallAlignmentDate
                    },
                    checkChgCol: item.chgCol || null
                  };
                });
                formData = new FormData();

                formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(saveItems));
                _context4.next = 5;
                return _this5.$store.dispatch('campaignTimeline/saveReviewMeeting', formData);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    saveReviewDeckURL: function saveReviewDeckURL(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                item[_this6.reviewDateCol].status = true;
                _context5.next = 3;
                return _this6.saveChanges([item]);

              case 3:
                _this6.setItem(item);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    closeReviewDeckModal: function closeReviewDeckModal(item) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.setItem(item);

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    saveReviewMeetingCheckList: function saveReviewMeetingCheckList(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                item[_this8.checkCol].status = true;
                _context7.next = 3;
                return _this8.saveChanges([item]);

              case 3:
                _this8.setItem(item);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    closeCheckListModal: function closeCheckListModal(item) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.setItem(item);

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    setItem: function setItem(item) {
      var _this10 = this;

      var items = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
      this.filteredItems = [];
      setTimeout(function () {
        _this10.filteredItems = items.map(function (fItem) {
          if (fItem.id === item.id) {
            fItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
          }
          return fItem;
        });
      }, 0);
    },
    getUsers: function getUsers() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                response = null;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 3:
                response = _context9.sent;

                if (response) {
                  _this11.AM = response.users;
                  _this11.AM = _this11.AM.map(function (am) {
                    am.name = am.firstName + ' ' + am.lastName;
                    return am;
                  });
                }
                _this11.AM.unshift({ id: '', name: 'All Team' });
                _context9.next = 8;
                return __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 8:
                response = _context9.sent;

                if (response) {
                  _this11.CC = response.users;
                  _this11.CC = _this11.CC.map(function (cc) {
                    cc.name = cc.firstName + ' ' + cc.lastName;
                    return cc;
                  });
                  _this11.CC.unshift({ id: '', name: 'All Team' });
                }

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    setFeedbackForms: function setFeedbackForms(items) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, feedbacksForms;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__Campaign_campaignAPIs__["a" /* default */].getClientFeedbacks({});

              case 2:
                response = _context10.sent;
                feedbacksForms = response.feedbacks;

                items = items.map(function (item) {
                  var matchForm = feedbacksForms.find(function (f) {
                    return f.campaignID === item.id;
                  });
                  if (matchForm) item.feedbackForm = matchForm;
                  return item;
                });
                return _context10.abrupt('return', items);

              case 6:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },
    copyFeedbackLink: function copyFeedbackLink(campaign) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var state;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__Campaign_campaignAPIs__["a" /* default */].getFeedbackAccess(campaign.id);

              case 3:
                state = _context11.sent;

                if (!(!state.accepting || !state.token)) {
                  _context11.next = 7;
                  break;
                }

                _this13.$swal({ title: 'Feedback is closed.', type: 'info' });
                return _context11.abrupt('return');

              case 7:
                _this13.feedbackLink = '' + window.location.origin + __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].CLIENT_FEEDBACK_FORM_URL + '/' + campaign.id + '#token=' + encodeURIComponent(state.token);
                setTimeout(function () {
                  campaign.linkCopied = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.copyToClipboard('#copy-link');
                }, 100);
                _context11.next = 14;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11['catch'](0);

                _this13.$swal({ title: 'Unable to create feedback link', type: 'error' });

              case 14:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this13, [[0, 11]]);
      }))();
    },
    changeCheckBox: function changeCheckBox(item, colName) {
      if (!this.checkPreviousStage(item, colName)) {
        return;
      }
      item.chgCol = colName;
      var chgCol = item[colName];
      chgCol.userID = this.currentUserID;
      chgCol.createdAt = __WEBPACK_IMPORTED_MODULE_9_moment___default()().toISOString();
      if (chgCol.status && colName === 'SentimentDateCol') {
        this.reviewDateCol = colName;
        this.reviewDeckItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
        this.reviewDeckURLDialog = true;
      } else if (chgCol.status) {
        this.checkCol = colName;
        this.checkItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);
        this.checkListsDialog = true;
      } else {
        delete chgCol.reviewDateURL;
        this.saveChanges([item]);
      }
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
    },
    showOverdueLabel: function showOverdueLabel(checkDate, checked) {
      if (!checkDate || checked) return false;
      var todayDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD');
      var formattedDate = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.parseDate(checkDate);
      return todayDate > formattedDate;
    },
    checkPreviousStage: function checkPreviousStage(item, colName) {
      var errorColName = '';
      var isError = false;
      if (colName === 'CCReadyDeckCol' && item.CCReadyDeckCol.status && !item.SentimentDateCol.status) {
        isError = true;
        errorColName = 'Stats and Sentiment Due Date';
        item.CCReadyDeckCol.status = false;
      } else if (colName === 'AMReadyDeckCol' && item.CCReadyDeckCol && !item.CCReadyDeckCol.status) {
        isError = true;
        errorColName = 'Completed by CC';
        item.AMReadyDeckCol.status = false;
      } else if (colName === 'overallAlignmentCol' && item.AMReadyDeckCol && !item.AMReadyDeckCol.status) {
        isError = true;
        errorColName = 'Completed by AM';
        item.overallAlignmentCol.status = false;
      }

      if (isError) {
        this.setItem(item);
        this.$swal({
          text: 'Please complete "' + errorColName + '".',
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    resetRevMeetingSections: function resetRevMeetingSections() {
      this.revMeetingSections = [{
        title: 'New',
        type: this.revMeetingSectionTypes.new,
        currentMode: 'view',
        data: []
      }, {
        title: 'Processing',
        type: this.revMeetingSectionTypes.processing,
        currentMode: 'view',
        data: []
      }, {
        title: 'Completed',
        type: this.revMeetingSectionTypes.completed,
        currentMode: 'view',
        data: []
      }];
    },
    changeModeCustom: function changeModeCustom(mode, item) {
      item.currentMode = mode;
    },
    isRevCompleted: function isRevCompleted(item) {
      if (item.reviewMeetingDate && item.overallAlignmentCol.status && item.AMReadyDeckCol.status && item.CCReadyDeckCol.status && item.SentimentDateCol.status && item.approvedByAdminCol.status) return true;
      return false;
    }
  }
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReviewDeckUrlModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    item: Object,
    dateCol: String
  },
  validations: {
    reviewDeckURL: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      isLoading: false,
      reviewDeckURL: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    reviewDeckURLErrors: function reviewDeckURLErrors() {
      var errors = [];
      if (!this.$v.reviewDeckURL.$dirty) return errors;
      !this.$v.reviewDeckURL.required && errors.push('This field is required.');
      return errors;
    }
  },
  watch: {
    value: function value(newValue) {
      this.reviewDeckURL = '';
    }
  },
  methods: {
    save: function save() {
      this.item[this.dateCol].reviewDateURL = this.reviewDeckURL;
      this.$emit('saveClicked', this.item);
      this.$emit('input');
    },
    close: function close() {
      this.item[this.dateCol].status = false;
      this.$emit('closeClicked', this.item);
      this.$emit('input');
    }
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(336);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReviewMeetingChecklistModal',
  props: {
    value: Boolean,
    item: Object,
    dateCol: String
  },
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker___default.a
  },
  data: function data() {
    return {
      alignmentSyncDate: '',
      alignementSyncErr: false,
      checkLists: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    showTitle: function showTitle() {
      if (this.dateCol === 'overallAlignmentCol') {
        return 'Confirm Date';
      } else if (this.dateCol === 'AMReadyDeckCol') {
        return 'Release deck to admin for vetting';
      }
      return 'Confirm Checklists';
    },
    isConfirmAllowed: function isConfirmAllowed() {
      if (this.dateCol === 'approvedByAdminCol') {
        return this.item.SentimentDateCol.status && this.item.CCReadyDeckCol.status && this.item.AMReadyDeckCol.status && this.item.overallAlignmentCol.status;
      }
      return true;
    }
  },
  watch: {
    value: function value(newValue) {
      this.alignmentSyncDate = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_2_moment___default()(), 'DD/MM/YYYY');
      this.checkLists = '';
      this.alignementSyncErr = false;
      if (this.dateCol === 'CCReadyDeckCol') {
        this.checkLists = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].reviewMeetingChecklists.completedByCC.html;
      }
      if (this.dateCol === 'AMReadyDeckCol') {
        this.checkLists = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].reviewMeetingChecklists.completedByAM.html;
      }
    }
  },
  methods: {
    checkDate: function checkDate(dateVal) {
      this.alignementSyncErr = true;
      if (__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].func.isDateFormatValid(dateVal) || !dateVal) {
        this.alignementSyncErr = false;
      }
    },
    setDateFromPicker: function setDateFromPicker(value) {
      this.alignmentSyncDate = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.checkDate(this.alignmentSyncDate);
    },
    save: function save() {
      if (this.dateCol === 'overallAlignmentCol') {
        this.alignementSyncErr = false;

        if (this.alignementSyncErr || !this.alignmentSyncDate) {
          this.alignementSyncErr = true;
          return;
        } else {
          this.item[this.dateCol].alignmentDate = this.alignmentSyncDate;
        }
      }
      this.$emit('saveClicked', this.item);
      this.$emit('input');
    },
    close: function close() {
      this.item[this.dateCol].status = false;
      this.$emit('closeClicked', this.item);
      this.$emit('input');
    }
  }
});

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upcoming-review-meetings',
  components: {
    ReviewMeetingDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reports_LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reports_LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_reports_LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(810);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatisticsAnalysisDataTable',
  props: ['viewHandle'],
  components: {
    LegendIcon: __WEBPACK_IMPORTED_MODULE_11__components_reports_LegendIcon___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default.a
  },
  watch: {
    viewHandle: function viewHandle(newVal) {
      this.handle = newVal;
      this.changeHandle();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    reports: function reports(state) {
      return state.campaign.reports;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    computedPostTableHeaders: function computedPostTableHeaders() {
      var _this = this;

      var statsAnalysisPostCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisPostCols) {
          statsAnalysisPostCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisPostCols);
        }
      }
      if (statsAnalysisPostCols) {
        this.postColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisPostCols);
      } else {
        this.postAnalysisTableHeaders.map(function (header) {
          _this.postColStatuses[header.value] = true;
        });
      }
      return this.postAnalysisTableHeaders.filter(function (h) {
        if (_this.postColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedStoryTableHeaders: function computedStoryTableHeaders() {
      var _this2 = this;

      var statsAnalysisStoryCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisStoryCols) {
          statsAnalysisStoryCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisStoryCols);
        }
      }
      if (statsAnalysisStoryCols) {
        this.storyColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisStoryCols);
      } else {
        this.storyAnalysisTableHeaders.map(function (header) {
          _this2.storyColStatuses[header.value] = true;
        });
      }
      return this.storyAnalysisTableHeaders.filter(function (h) {
        if (_this2.storyColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedReelTableHeaders: function computedReelTableHeaders() {
      var _this3 = this;

      var statsAnalysisReelCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisReelCols) {
          statsAnalysisReelCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisReelCols);
        }
      }
      if (statsAnalysisReelCols) {
        this.reelColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisReelCols);
      } else {
        this.reelAnalysisTableHeaders.map(function (header) {
          _this3.reelColStatuses[header.value] = true;
        });
      }
      return this.reelAnalysisTableHeaders.filter(function (h) {
        if (_this3.reelColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedTikTokTableHeaders: function computedTikTokTableHeaders() {
      var _this4 = this;

      var statsAnalysisTikTokCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisTikTokCols) {
          statsAnalysisTikTokCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisTikTokCols);
        }
      }
      if (statsAnalysisTikTokCols) {
        this.tiktokColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisTikTokCols);
      } else {
        this.tiktokAnalysisTableHeaders.map(function (header) {
          _this4.tiktokColStatuses[header.value] = true;
        });
      }
      return this.tiktokAnalysisTableHeaders.filter(function (h) {
        if (_this4.tiktokColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedYoutubeTableHeaders: function computedYoutubeTableHeaders() {
      var _this5 = this;

      var statsAnalysisYoutubeCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisYoutubeCols) {
          statsAnalysisYoutubeCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisYoutubeCols);
        }
      }
      if (statsAnalysisYoutubeCols) {
        this.youtubeColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisYoutubeCols);
      } else {
        this.youtubeAnalysisTableHeaders.map(function (header) {
          _this5.youtubeColStatuses[header.value] = true;
        });
      }
      return this.youtubeAnalysisTableHeaders.filter(function (h) {
        if (_this5.youtubeColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedXHSTableHeaders: function computedXHSTableHeaders() {
      var _this6 = this;

      var statsAnalysisXHSCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisXHSCols) {
          statsAnalysisXHSCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisXHSCols);
        }
      }
      if (statsAnalysisXHSCols) {
        this.xhsColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisXHSCols);
      } else {
        this.xhsAnalysisTableHeaders.map(function (header) {
          _this6.xhsColStatuses[header.value] = true;
        });
      }
      return this.xhsAnalysisTableHeaders.filter(function (h) {
        if (_this6.xhsColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedFbTableHeaders: function computedFbTableHeaders() {
      var _this7 = this;

      var statsAnalysisFbCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.statsAnalysisFbCols) {
          statsAnalysisFbCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.statsAnalysisFbCols);
        }
      }
      if (statsAnalysisFbCols) {
        this.fbColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, statsAnalysisFbCols);
      } else {
        this.fbAnalysisTableHeaders.map(function (header) {
          _this7.fbColStatuses[header.value] = true;
        });
      }
      return this.fbAnalysisTableHeaders.filter(function (h) {
        if (_this7.fbColStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    totalTikTokPlayTime: function totalTikTokPlayTime() {
      var count = 0;
      this.tiktokAnalysisData.map(function (item) {
        if (item.plays) {
          count += 1;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculateTotalPlayTime(this.tiktokAnalysisData, count);
    },
    avgTikTokPlayTime: function avgTikTokPlayTime() {
      var count = 0;
      this.tiktokAnalysisData.map(function (item) {
        if (item.plays) {
          count += 1;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculateTotalPlayTime(this.selectedTikTokAnalysis, count);
    },
    totalPlayTime: function totalPlayTime() {
      var count = 0;
      this.tiktokAnalysisData.map(function (item) {
        if (item.plays) {
          count += 1;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculateTotalPlayTime(this.reelAnalysisData, count);
    },
    totalReelWatchTime: function totalReelWatchTime() {
      var count = 0;
      this.reelAnalysisData.map(function (item) {
        if (item.watches) {
          count += 1;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculateTotalReelWatchTime(this.reelAnalysisData, count);
    },
    totalAvgPlayTime: function totalAvgPlayTime() {
      var count = 0;
      this.tiktokAnalysisData.map(function (item) {
        if (item.plays) {
          count += 1;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculateTotalPlayTime(this.selectedReelAnalysis, count);
    },
    totalAvgReelWatchTime: function totalAvgReelWatchTime() {
      var count = 0;
      this.tiktokAnalysisData.map(function (item) {
        if (item.watches) {
          count += 1;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculateTotalReelWatchTime(this.selectedReelAnalysis, count);
    }
  }),
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func,
      viewData: null,
      viewDialog: false,
      colSettingsDialog: false,
      colStatuses: {},
      postColStatuses: {},
      storyColStatuses: {},
      reelColStatuses: {},
      tiktokColStatuses: {},
      youtubeColStatuses: {},
      xhsColStatuses: {},
      fbColStatuses: {},
      userProfile: {},
      postAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].postAnalysisTableHeaders,
      storyAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].storyAnalysisTableHeaders,
      reelAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].reelAnalysisTableHeaders,
      tiktokAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].tiktokAnalysisTableHeaders,
      youtubeAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].youtubeAnalysisTableHeaders,
      xhsAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].xhsAnalysisTableHeaders,
      fbAnalysisTableHeaders: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].fbAnalysisTableHeaders,
      headers: [{
        text: '',
        value: 'contents'
      }, {
        text: 'Live Date',
        value: 'live_date',
        legendText: 'Live Date'
      }, {
        text: 'Outreach',
        value: 'outreach',
        legendText: 'The number of followers the creator has at the time where the post was made '
      }, {
        text: 'Likes',
        value: 'likes',
        legendText: 'The number of times users have tapped the “like” button on a post.'
      }, {
        text: 'Comments',
        value: 'comments',
        legendText: 'The number of written responses to a post.'
      }, {
        text: 'Bookmarks',
        value: 'saved',
        legendText: 'The number of times users have saved a post to their “Saved” folder.'
      }, {
        text: 'Shares',
        value: 'shares',
        legendText: 'The number of times users have reposted / shared a post.'
      }, {
        text: 'Views',
        value: 'views',
        legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
      }, {
        text: 'Reach',
        value: 'reach',
        legendText: 'The total number of unique users who viewed the content'
      }, {
        text: 'Impressions',
        value: 'impressions',
        legendText: 'The total number of times the content is displayed on an user\'s feed'
      }, {
        text: 'Replies',
        value: 'replies',
        legendText: 'The number of replies to a story.'
      }, {
        text: 'Links Click',
        value: 'link_clicks',
        legendText: 'The number of times users have tapped the link attached on a story.'
      }, {
        text: 'Sticker Taps',
        value: 'sticker_taps',
        legendText: 'The number of times users have tapped the hashtags and mentions attached on a story.'
      }, {
        text: 'Engagement Rate',
        value: 'new_engagement_rate',
        legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by the outreach numbers'
      }, {
        text: 'Avg. Engagement Rate',
        value: 'engagement_rate_sd',
        legendText: 'The average sum of engagement rate on the last 30 posts'
      }, {
        text: 'Median Engagement Rate',
        value: 'median_engagement_rate',
        legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
      }, {
        text: 'Total Play Time',
        value: 'plays',
        legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
      }, {
        text: 'Average Watch Time',
        value: 'watches',
        legendText: 'How many seconds your video is viewed for'
      }, {
        text: 'Average Likes',
        value: 'avg_likes',
        legendText: 'Average likes over the last 30 posts'
      }, {
        text: 'Average Comments',
        value: 'avg_comments',
        legendText: 'Average comments over the last 30 posts'
      }, {
        text: 'Average Views',
        value: 'avg_views',
        legendText: 'Average views over the last 30 posts'
      }, {
        text: 'Average Reels Plays',
        value: 'avg_reels_plays',
        legendText: 'Average plays over the last 30 posts'
      }],

      creators: [],
      filter: '',
      normalReports: null,
      compareReports: null,
      isLoading: false,
      postAnalysisData: [],
      storyAnalysisData: [],
      reelAnalysisData: [],
      tiktokAnalysisData: [],
      youtubeAnalysisData: [],
      xhsAnalysisData: [],
      fbAnalysisData: [],
      selectedPostAnalysis: [],
      selectedStoryAnalysis: [],
      selectedReelAnalysis: [],
      selectedTikTokAnalysis: [],
      selectedYoutubeAnalysis: [],
      selectedXhsAnalysis: [],
      selectedFbAnalysis: [],
      avgPostAnalysisDialog: false,
      avgStoryAnalysisDialog: false,
      avgReelAnalysisDialog: false,
      avgTiktokAnalysisDialog: false,
      avgYoutubeAnalysisDialog: false,
      avgXhsAnalysisDialog: false,
      avgFbAnalysisDialog: false,
      updatingTableType: ''
    };
  },
  mounted: function mounted() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this8.getUserProfile();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this8);
    }))();
  },

  methods: {
    changeHandle: function changeHandle() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newCreators, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, creator, handle, oldData;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this9.handle && !_this9.compareHandle)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this9.isLoading = true;
                newCreators = [{
                  index: 0,
                  handle: _this9.handle
                }, {
                  index: 1,
                  handle: _this9.compareHandle
                }];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 7;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(newCreators);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 29;
                  break;
                }

                creator = _step.value;

                if (!creator.handle) {
                  _context2.next = 25;
                  break;
                }

                handle = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.espaceHandleSign(creator.handle);
                oldData = null;

                if (!_this9.viewHandle) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__["a" /* default */].getStatsData(_this9.viewHandle);

              case 17:
                oldData = _context2.sent;

                if (oldData.handle) {
                  _this9.postAnalysisData = oldData.post || [];
                  _this9.storyAnalysisData = oldData.story || [];
                  _this9.reelAnalysisData = oldData.reel || [];
                  _this9.tiktokAnalysisData = oldData.tiktok || [];
                  _this9.youtubeAnalysisData = oldData.youtube || [];
                  _this9.xhsAnalysisData = oldData.xhs || [];
                  _this9.fbAnalysisData = oldData.fb || [];
                }

              case 19:
                if (!(!oldData || !oldData.handle)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 22;
                return _this9.$store.dispatch('campaign/getReportsByHandle', handle);

              case 22:
                _this9.formatReports(handle, creator.index);

              case 23:
                _context2.next = 26;
                break;

              case 25:
                _this9.creators[creator.index] = null;

              case 26:
                _iteratorNormalCompletion = true;
                _context2.next = 9;
                break;

              case 29:
                _context2.next = 35;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 35:
                _context2.prev = 35;
                _context2.prev = 36;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 38:
                _context2.prev = 38;

                if (!_didIteratorError) {
                  _context2.next = 41;
                  break;
                }

                throw _iteratorError;

              case 41:
                return _context2.finish(38);

              case 42:
                return _context2.finish(35);

              case 43:
                _this9.resetAnalysisData();
                _this9.isLoading = false;

              case 45:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this9, [[7, 31, 35, 43], [36,, 38, 42]]);
      }))();
    },
    formatReports: function formatReports(handle, creatorIdx) {
      this.postAnalysisData = [];
      this.storyAnalysisData = [];
      this.reelAnalysisData = [];
      this.tiktokAnalysisData = [];
      this.youtubeAnalysisData = [];
      this.xhsAnalysisData = [];
      this.fbAnalysisData = [];
      var posts = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.reports);
      posts = posts.filter(function (p) {
        return !p.imported;
      });
      posts = posts.map(function (p) {
        p = __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].calculatePostData(p, null);
        return p;
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(posts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var post = _step2.value;

          var campaigns = [];

          campaigns.push(post);

          var matchCampaignIdx = campaigns.length - 1;
          var campaignOne = campaigns[matchCampaignIdx];
          campaignOne.impressions = campaignOne.impressions || 0;
          campaignOne.engagement = campaignOne.engagement || 0;
          campaignOne.reach = campaignOne.reach || 0;
          campaignOne.likes = campaignOne.likes || 0;
          campaignOne.comments = campaignOne.comments || 0;
          campaignOne.outreach = campaignOne.outreach || 0;
          campaignOne.engagement_rate = campaignOne.engagement_rate || 0;
          campaignOne.engagement_rate_sd = campaignOne.engagement_rate_sd || 0;
          campaignOne.median_engagement_rate = campaignOne.median_engagement_rate || 0;
          campaignOne.new_engagement_rate_view = campaignOne.new_engagement_rate_view || '';
          campaignOne.engagement_rate_reach = campaignOne.engagement_rate_reach || '';
          campaignOne.interactions = campaignOne.interactions || '';
          campaignOne.avg_likes = campaignOne.avg_likes || 0;
          campaignOne.avg_comments = campaignOne.avg_comments || 0;
          campaignOne.avg_views = campaignOne.avg_views || 0;
          campaignOne.avg_reels_plays = campaignOne.avg_reels_plays || 0;
          campaignOne.saved = campaignOne.saved || 0;
          campaignOne.shares = campaignOne.shares || 0;
          campaignOne.views = campaignOne.views || 0;
          campaignOne.reach = campaignOne.reach || 0;
          campaignOne.impressions = campaignOne.impressions || 0;
          campaignOne.replies = campaignOne.replies || 0;
          campaignOne.exits = campaignOne.exits || 0;
          campaignOne.taps_back = campaignOne.taps_back || 0;
          campaignOne.taps_forward = campaignOne.taps_forward || 0;
          campaignOne.sticker_taps = campaignOne.sticker_taps || 0;
          campaignOne.link_clicks = campaignOne.link_clicks || 0;
          campaignOne.storyTotalInteractions = campaignOne.storyTotalInteractions || 0;
          campaignOne.plays = campaignOne.plays || 0;
          campaignOne.watches = campaignOne.watches || 0;
          campaignOne.watchedFullVideo = campaignOne.watchedFullVideo || 0;

          campaigns[matchCampaignIdx] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, campaignOne);
          if (campaignOne.type === 'post/carousel') {
            this.postAnalysisData.push(campaignOne);
          }
          if (campaignOne.type === 'reel') {
            this.reelAnalysisData.push(campaignOne);
          }
          if (campaignOne.type === 'story' || campaignOne.type === 'gdrive') {
            this.storyAnalysisData.push(campaignOne);
          }
          if (campaignOne.type === 'tiktok') {
            this.tiktokAnalysisData.push(campaignOne);
          }
          if (campaignOne.type === 'youtube') {
            this.youtubeAnalysisData.push(campaignOne);
          }
          if (campaignOne.type === 'xhs') {
            this.xhsAnalysisData.push(campaignOne);
          }
          if (campaignOne.type === 'facebook') {
            this.fbAnalysisData.push(campaignOne);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.storeStatsData({
        handle: handle
      });
    },
    getRowClass: function getRowClass(item) {
      if (item.contentType) {
        return 'row-content';
      } else {
        return 'row-campaign';
      }
    },
    showTikTokPlayTime: function showTikTokPlayTime(time) {
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].showTikTokPlayTime(time);
    },
    showReelPlayTime: function showReelPlayTime(time) {
      return __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].showReelPlayTime(time);
    },
    openColSettingsModal: function openColSettingsModal(type) {
      this.updatingTableType = type;
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (type === 'post') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.postColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.postColStatuses);
        } else {
          this.postAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.postAnalysisTableHeaders)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _ref = _step3.value;

            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            if (value.text) {
              this.tableColsItems.push({
                title: value.text,
                key: value.value,
                value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      if (type === 'story') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.storyColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.storyColStatuses);
        } else {
          this.storyAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.storyAnalysisTableHeaders)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _ref3 = _step4.value;

            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

            var _key = _ref4[0];
            var _value = _ref4[1];

            if (_value.text) {
              this.tableColsItems.push({
                title: _value.text,
                key: _value.value,
                value: tmpStatuses[_value.value] ? tmpStatuses[_value.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      if (type === 'reel') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.reelColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.reelColStatuses);
        } else {
          this.reelAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.reelAnalysisTableHeaders)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _ref5 = _step5.value;

            var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

            var _key2 = _ref6[0];
            var _value2 = _ref6[1];

            if (_value2.text) {
              this.tableColsItems.push({
                title: _value2.text,
                key: _value2.value,
                value: tmpStatuses[_value2.value] ? tmpStatuses[_value2.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
      if (type === 'tiktok') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.tiktokColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.tiktokColStatuses);
        } else {
          this.tiktokAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.tiktokAnalysisTableHeaders)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _ref7 = _step6.value;

            var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);

            var _key3 = _ref8[0];
            var _value3 = _ref8[1];

            if (_value3.text) {
              this.tableColsItems.push({
                title: _value3.text,
                key: _value3.value,
                value: tmpStatuses[_value3.value] ? tmpStatuses[_value3.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }
      if (type === 'youtube') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.youtubeColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.youtubeColStatuses);
        } else {
          this.youtubeAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.youtubeAnalysisTableHeaders)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _ref9 = _step7.value;

            var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref9, 2);

            var _key4 = _ref10[0];
            var _value4 = _ref10[1];

            if (_value4.text) {
              this.tableColsItems.push({
                title: _value4.text,
                key: _value4.value,
                value: tmpStatuses[_value4.value] ? tmpStatuses[_value4.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
      if (type === 'xhs') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.xhsColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.xhsColStatuses);
        } else {
          this.xhsAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.xhsAnalysisTableHeaders)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var _ref11 = _step8.value;

            var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref11, 2);

            var _key5 = _ref12[0];
            var _value5 = _ref12[1];

            if (_value5.text) {
              this.tableColsItems.push({
                title: _value5.text,
                key: _value5.value,
                value: tmpStatuses[_value5.value] ? tmpStatuses[_value5.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
      if (type === 'facebook') {
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fbColStatuses).length) {
          tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.fbColStatuses);
        } else {
          this.fbAnalysisTableHeaders.map(function (header) {
            tmpStatuses[header.value] = true;
          });
        }
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.fbAnalysisTableHeaders)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var _ref13 = _step9.value;

            var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref13, 2);

            var _key6 = _ref14[0];
            var _value6 = _ref14[1];

            if (_value6.text) {
              this.tableColsItems.push({
                title: _value6.text,
                key: _value6.value,
                value: tmpStatuses[_value6.value] ? tmpStatuses[_value6.value] : false
              });
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }
      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var tableSettings, columns, _columns, _columns2, _columns3, _columns4, _columns5, _columns6, updateData;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tableSettings = {};

                if (_this10.updatingTableType === 'post') {
                  columns = _this10.postColStatuses;

                  items.map(function (item) {
                    columns[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisPostCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                  _this10.postColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                }
                if (_this10.updatingTableType === 'story') {
                  _columns = _this10.storyColStatuses;

                  items.map(function (item) {
                    _columns[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisStoryCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns);
                  _this10.storyColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns);
                }
                if (_this10.updatingTableType === 'reel') {
                  _columns2 = _this10.reelColStatuses;

                  items.map(function (item) {
                    _columns2[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisReelCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns2);
                  _this10.reelColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns2);
                }
                if (_this10.updatingTableType === 'tiktok') {
                  _columns3 = _this10.tiktokColStatuses;

                  items.map(function (item) {
                    _columns3[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisTikTokCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns3);
                  _this10.tiktokColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns3);
                }
                if (_this10.updatingTableType === 'youtube') {
                  _columns4 = _this10.youtubeColStatuses;

                  items.map(function (item) {
                    _columns4[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisYoutubeCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns4);
                  _this10.youtubeColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns4);
                }
                if (_this10.updatingTableType === 'xhs') {
                  _columns5 = _this10.xhsColStatuses;

                  items.map(function (item) {
                    _columns5[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisXHSCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns5);
                  _this10.xhsColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns5);
                }
                if (_this10.updatingTableType === 'facebook') {
                  _columns6 = _this10.fbColStatuses;

                  items.map(function (item) {
                    _columns6[item.key] = item.value;
                  });
                  if (_this10.userProfile.tableSettings) {
                    tableSettings = _this10.userProfile.tableSettings;
                  }
                  tableSettings.statsAnalysisFbCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns6);
                  _this10.fbColStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, _columns6);
                }
                updateData = {
                  id: _this10.currentUserID,
                  tableSettings: tableSettings
                };
                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].editUser(updateData);

              case 11:
                _this10.colSettingsDialog = false;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this10);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].getUser(_this11.currentUserID);

              case 2:
                resp = _context4.sent;

                if (resp && resp.id) {
                  _this11.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this11);
      }))();
    },
    displayFields: function displayFields(fieldName) {
      if (this.colStatuses[fieldName]) return true;
      return false;
    },
    getUpdateColTitle: function getUpdateColTitle() {
      if (this.updatingTableType === 'post') {
        return 'Post Analysis Summary';
      }
      if (this.updatingTableType === 'story') {
        return 'Story Analysis Summary';
      }
      if (this.updatingTableType === 'reel') {
        return 'Reel Analysis Summary';
      }
      if (this.updatingTableType === 'tiktok') {
        return 'TikTok Analysis Summary';
      }
      if (this.updatingTableType === 'youtube') {
        return 'Youtube Analysis Summary';
      }
      if (this.updatingTableType === 'xhs') {
        return 'XHS Analysis Summary';
      }
      if (this.updatingTableType === 'facebook') {
        return 'Facebook Analysis Summary';
      }
    },
    calPostTotal: function calPostTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.postAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count = 0;
        this.postAnalysisData.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (item.reach > 0) {
            _count += 1;
          }
        });
        if (_count > 0) {
          return (reach / _count).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count2 = 0;
        this.postAnalysisData.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (item.impressions > 0) {
            _count2 += 1;
          }
        });
        if (_count2 > 0) {
          return (impressions / _count2).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalLikes') {
        var likes = 0;
        var _count3 = 0;
        this.postAnalysisData.map(function (item) {
          likes += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count3 += 1;
          }
        });
        if (_count3 > 0) {
          return (likes / _count3).toFixed(0);
        }
        return likes;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count4 = 0;
        this.postAnalysisData.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count4 += 1;
          }
        });
        if (_count4 > 0) {
          return (shares / _count4).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalComments') {
        var comments = 0;
        var _count5 = 0;
        this.postAnalysisData.map(function (item) {
          comments += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count5 += 1;
          }
        });
        if (_count5 > 0) {
          return (comments / _count5).toFixed(0);
        }
        return comments;
      }
      if (field === 'totalSaved') {
        var saved = 0;
        var _count6 = 0;
        this.postAnalysisData.map(function (item) {
          saved += item.saved ? item.saved : 0;
          if (item.saved > 0) {
            _count6 += 1;
          }
        });
        if (_count6 > 0) {
          return (saved / _count6).toFixed(0);
        }
        return saved;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count7 = 0;
        this.postAnalysisData.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count7 += 1;
          }
        });
        if (_count7 > 0) {
          return (interactions / _count7).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalViews') {
        var views = 0;
        var _count8 = 0;
        this.postAnalysisData.map(function (item) {
          views += item.views ? item.views : 0;
          if (item.views > 0) {
            _count8 += 1;
          }
        });
        if (_count8 > 0) {
          return (views / _count8).toFixed(0);
        }
        return views;
      }
      if (field === 'totalEngagementRate') {
        var engTotal = 0;
        var _count9 = 0;
        this.postAnalysisData.map(function (item) {
          engTotal += item.new_engagement_rate ? item.new_engagement_rate : 0;
          if (item.new_engagement_rate > 0) {
            _count9 += 1;
          }
        });
        if (_count9 > 0) {
          return (engTotal / _count9).toFixed(2);
        }
        return engTotal;
      }
      if (field === 'totalEngagementRateView') {
        var _engTotal = 0;
        var _count10 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count10 += 1;
          }
        });
        if (_count10 > 0) {
          return (_engTotal / _count10).toFixed(2);
        }
        return _engTotal;
      }
      if (field === 'totalEngagementRateReach') {
        var _engTotal2 = 0;
        var _count11 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal2 += item.engagement_rate_reach ? item.engagement_rate_reach : 0;
          if (item.engagement_rate_reach > 0) {
            _count11 += 1;
          }
        });
        if (_count11 > 0 && _engTotal2 > 0) {
          return (_engTotal2 / _count11).toFixed(2);
        }
        return _engTotal2;
      }
      if (field === 'totalEngRateSd') {
        var _engTotal3 = 0;
        var _count12 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal3 += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0;
          if (Number(item.engagement_rate_sd) > 0) {
            _count12 += 1;
          }
        });
        if (_count12 > 0) {
          return (_engTotal3 / _count12).toFixed(2);
        }
        return _engTotal3;
      }
      if (field === 'totalMedianEngRate') {
        var _engTotal4 = 0;
        var _count13 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal4 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count13 += 1;
          }
        });
        if (_count13 > 0) {
          return (_engTotal4 / _count13).toFixed(2);
        }
        return _engTotal4;
      }
      if (field === 'totalAvgLikes') {
        var _engTotal5 = 0;
        var _count14 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal5 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count14 += 1;
          }
        });
        if (_count14 > 0) {
          return (_engTotal5 / _count14).toFixed(2);
        }
        return _engTotal5;
      }
      if (field === 'totalAvgComments') {
        var _engTotal6 = 0;
        var _count15 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal6 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count15 += 1;
          }
        });
        if (_count15 > 0) {
          return (_engTotal6 / _count15).toFixed(2);
        }
        return _engTotal6;
      }
      if (field === 'totalAvgViews') {
        var _engTotal7 = 0;
        var _count16 = 0;
        this.postAnalysisData.map(function (item) {
          _engTotal7 += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count16 += 1;
          }
        });
        if (_count16 > 0) {
          return (_engTotal7 / _count16).toFixed(2);
        }
        return _engTotal7;
      }
    },
    calStoryTotal: function calStoryTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.storyAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count17 = 0;
        this.storyAnalysisData.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (item.reach > 0) {
            _count17 += 1;
          }
        });
        if (_count17 > 0) {
          return (reach / _count17).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count18 = 0;
        this.storyAnalysisData.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (item.impressions > 0) {
            _count18 += 1;
          }
        });
        if (_count18 > 0) {
          return (impressions / _count18).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalReplies') {
        var replies = 0;
        var _count19 = 0;
        this.storyAnalysisData.map(function (item) {
          replies += item.replies ? item.replies : 0;
          if (item.replies > 0) {
            _count19 += 1;
          }
        });
        if (_count19 > 0) {
          return (replies / _count19).toFixed(0);
        }
        return replies;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count20 = 0;
        this.storyAnalysisData.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count20 += 1;
          }
        });
        if (_count20 > 0) {
          return (shares / _count20).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalLinkClicks') {
        var linkClicks = 0;
        var _count21 = 0;
        this.storyAnalysisData.map(function (item) {
          linkClicks += item.link_clicks ? item.link_clicks : 0;
          if (item.link_clicks > 0) {
            _count21 += 1;
          }
        });
        if (_count21 > 0) {
          return (linkClicks / _count21).toFixed(0);
        }
        return linkClicks;
      }
      if (field === 'totalStickerTaps') {
        var stickerTaps = 0;
        var _count22 = 0;
        this.storyAnalysisData.map(function (item) {
          stickerTaps += item.sticker_taps ? item.sticker_taps : 0;
          if (item.sticker_taps > 0) {
            _count22 += 1;
          }
        });
        if (_count22 > 0) {
          return (stickerTaps / _count22).toFixed(0);
        }
        return stickerTaps;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count23 = 0;
        this.storyAnalysisData.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count23 += 1;
          }
        });
        if (_count23 > 0) {
          return (interactions / _count23).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalAvgViews') {
        var calData = 0;
        var _count24 = 0;
        this.storyAnalysisData.map(function (item) {
          calData += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count24 += 1;
          }
        });
        if (_count24 > 0) {
          return (calData / _count24).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalAvgReelPlays') {
        var _calData = 0;
        var _count25 = 0;
        this.storyAnalysisData.map(function (item) {
          _calData += item.avg_reels_plays ? item.avg_reels_plays : 0;
          if (item.avg_reels_plays > 0) {
            _count25 += 1;
          }
        });
        if (_count25 > 0) {
          return (_calData / _count25).toFixed(0);
        }
        return _calData;
      }
    },
    calReelTotal: function calReelTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.reelAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count26 = 0;
        this.reelAnalysisData.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (reach > 0) {
            _count26 += 1;
          }
        });
        if (_count26 > 0) {
          return (reach / _count26).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count27 = 0;
        this.reelAnalysisData.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (impressions > 0) {
            _count27 += 1;
          }
        });
        if (_count27 > 0) {
          return (impressions / _count27).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalLikes') {
        var likes = 0;
        var _count28 = 0;
        this.reelAnalysisData.map(function (item) {
          likes += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count28 += 1;
          }
        });
        if (_count28 > 0) {
          return (likes / _count28).toFixed(0);
        }
        return likes;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count29 = 0;
        this.reelAnalysisData.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count29 += 1;
          }
        });
        if (_count29 > 0) {
          return (shares / _count29).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalComments') {
        var comments = 0;
        var _count30 = 0;
        this.reelAnalysisData.map(function (item) {
          comments += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count30 += 1;
          }
        });
        if (_count30 > 0) {
          return (comments / _count30).toFixed(0);
        }
        return comments;
      }
      if (field === 'totalSaved') {
        var saved = 0;
        var _count31 = 0;
        this.reelAnalysisData.map(function (item) {
          saved += item.saved ? item.saved : 0;
          if (item.saved > 0) {
            _count31 += 1;
          }
        });
        if (_count31 > 0) {
          return (saved / _count31).toFixed(0);
        }
        return saved;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count32 = 0;
        this.reelAnalysisData.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count32 += 1;
          }
        });
        if (_count32 > 0) {
          return (interactions / _count32).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalViews') {
        var views = 0;
        var _count33 = 0;
        this.reelAnalysisData.map(function (item) {
          views += item.views ? item.views : 0;
          if (item.views > 0) {
            _count33 += 1;
          }
        });
        if (_count33 > 0) {
          return (views / _count33).toFixed(0);
        }
        return views;
      }
      if (field === 'totalEngagementRate') {
        var engRate = 0;
        var _count34 = 0;
        this.reelAnalysisData.map(function (item) {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0;
          if (item.new_engagement_rate > 0) {
            _count34 += 1;
          }
        });
        if (_count34 > 0) {
          return (engRate / _count34).toFixed(2);
        }
        return engRate;
      }
      if (field === 'totalEngagementRateView') {
        var _engRate = 0;
        var _count35 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count35 += 1;
          }
        });
        if (_count35 > 0) {
          return (_engRate / _count35).toFixed(2);
        }
        return _engRate;
      }
      if (field === 'totalInteractionRatePlays') {
        var _engRate2 = 0;
        var _count36 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate2 += item.interaction_rate_plays ? item.interaction_rate_plays : 0;
          if (item.interaction_rate_plays > 0) {
            _count36 += 1;
          }
        });
        if (_count36 > 0) {
          return (_engRate2 / _count36).toFixed(2);
        }
        return _engRate2;
      }
      if (field === 'totalEngagementRateReach') {
        var _engRate3 = 0;
        var _count37 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate3 += item.engagement_rate_reach ? item.engagement_rate_reach : 0;
          if (item.engagement_rate_reach > 0) {
            _count37 += 1;
          }
        });
        if (_count37 > 0) {
          return (_engRate3 / _count37).toFixed(2);
        }
        return _engRate3;
      }
      if (field === 'totalEngRateSd') {
        var _engRate4 = 0;
        var _count38 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate4 += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0;
          if (item.engagement_rate_sd > 0) {
            _count38 += 1;
          }
        });
        if (_count38 > 0) {
          return (_engRate4 / _count38).toFixed(2);
        }
        return _engRate4;
      }
      if (field === 'totalMedianEngRate') {
        var _engRate5 = 0;
        var _count39 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate5 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count39 += 1;
          }
        });
        if (_count39 > 0) {
          return (_engRate5 / _count39).toFixed(2);
        }
        return _engRate5;
      }
      if (field === 'totalMedianEngRate') {
        var _engRate6 = 0;
        var _count40 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate6 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count40 += 1;
          }
        });
        if (_count40 > 0) {
          return (_engRate6 / _count40).toFixed(2);
        }
        return _engRate6;
      }
      if (field === 'totalAvgLikes') {
        var _engRate7 = 0;
        var _count41 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate7 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count41 += 1;
          }
        });
        if (_count41 > 0) {
          return (_engRate7 / _count41).toFixed(2);
        }
        return _engRate7;
      }
      if (field === 'totalAvgComments') {
        var _engRate8 = 0;
        var _count42 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate8 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count42 += 1;
          }
        });
        if (_count42 > 0) {
          return (_engRate8 / _count42).toFixed(2);
        }
        return _engRate8;
      }
      if (field === 'totalAvgViews') {
        var _engRate9 = 0;
        var _count43 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate9 += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count43 += 1;
          }
        });
        if (_count43 > 0) {
          return (_engRate9 / _count43).toFixed(2);
        }
        return _engRate9;
      }
      if (field === 'totalReelPlays') {
        var _engRate10 = 0;
        var _count44 = 0;
        this.reelAnalysisData.map(function (item) {
          _engRate10 += item.avg_reels_plays ? item.avg_reels_plays : 0;
          if (item.avg_reels_plays > 0) {
            _count44 += 1;
          }
        });
        if (_count44 > 0) {
          return (_engRate10 / _count44).toFixed(2);
        }
        return _engRate10;
      }
    },
    calTikTokTotal: function calTikTokTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.tiktokAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalWatches') {
        var watches = 0;
        var _count45 = 0;
        this.tiktokAnalysisData.map(function (item) {
          watches += item.watches ? __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].formatWatchTime(item.watches) : 0;
          if (item.watches) {
            _count45 += 1;
          }
        });
        if (_count45 > 0) {
          return (watches / _count45).toFixed(2) + 's';
        }
        return watches + 's';
      }
      if (field === 'totalLikes') {
        var likes = 0;
        var _count46 = 0;
        this.tiktokAnalysisData.map(function (item) {
          likes += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count46 += 1;
          }
        });
        if (_count46 > 0) {
          return (likes / _count46).toFixed(0);
        }
        return likes;
      }
      if (field === 'totalComments') {
        var comments = 0;
        var _count47 = 0;
        this.tiktokAnalysisData.map(function (item) {
          comments += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count47 += 1;
          }
        });
        if (_count47 > 0) {
          return (comments / _count47).toFixed(0);
        }
        return comments;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count48 = 0;
        this.tiktokAnalysisData.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count48 += 1;
          }
        });
        if (_count48 > 0) {
          return (shares / _count48).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalBookmarks') {
        var saved = 0;
        var _count49 = 0;
        this.tiktokAnalysisData.map(function (item) {
          saved += item.saved ? item.saved : 0;
          if (item.saved > 0) {
            _count49 += 1;
          }
        });
        if (_count49 > 0) {
          return (saved / _count49).toFixed(0);
        }
        return saved;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count50 = 0;
        this.tiktokAnalysisData.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count50 += 1;
          }
        });
        if (_count50 > 0) {
          return (interactions / _count50).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalViews') {
        var views = 0;
        var _count51 = 0;
        this.tiktokAnalysisData.map(function (item) {
          views += item.views ? item.views : 0;
          if (item.views > 0) {
            _count51 += 1;
          }
        });
        if (_count51 > 0) {
          return (views / _count51).toFixed(0);
        }
        return views;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count52 = 0;
        this.tiktokAnalysisData.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (item.reach > 0) {
            _count52 += 1;
          }
        });
        if (_count52 > 0) {
          return (reach / _count52).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count53 = 0;
        this.tiktokAnalysisData.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (item.impressions > 0) {
            _count53 += 1;
          }
        });
        if (_count53 > 0) {
          return (impressions / _count53).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalAvgViews') {
        var calData = 0;
        var _count54 = 0;
        this.tiktokAnalysisData.map(function (item) {
          calData += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count54 += 1;
          }
        });
        if (_count54 > 0) {
          return (calData / _count54).toFixed(2);
        }
        return calData;
      }
      if (field === 'totalAvgLikes') {
        var _calData2 = 0;
        var _count55 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _calData2 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count55 += 1;
          }
        });
        if (_count55 > 0) {
          return (_calData2 / _count55).toFixed(2);
        }
        return _calData2;
      }
      if (field === 'totalAvgComments') {
        var _calData3 = 0;
        var _count56 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _calData3 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count56 += 1;
          }
        });
        if (_count56 > 0) {
          return (_calData3 / _count56).toFixed(2);
        }
        return _calData3;
      }
      if (field === 'totalAvgSaves') {
        var _calData4 = 0;
        var _count57 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _calData4 += item.avg_saves ? item.avg_saves : 0;
          if (item.avg_saves > 0) {
            _count57 += 1;
          }
        });
        if (_count57 > 0) {
          return (_calData4 / _count57).toFixed(2);
        }
        return _calData4;
      }
      if (field === 'totalAvgShares') {
        var _calData5 = 0;
        var _count58 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _calData5 += item.avg_saves ? item.avg_saves : 0;
          if (item.avg_saves > 0) {
            _count58 += 1;
          }
        });
        if (_count58 > 0) {
          return (_calData5 / _count58).toFixed(2);
        }
        return _calData5;
      }
      if (field === 'totalEngagementRate') {
        var engRate = 0;
        var _count59 = 0;
        this.tiktokAnalysisData.map(function (item) {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0;
          if (item.new_engagement_rate > 0) {
            _count59 += 1;
          }
        });
        if (_count59 > 0) {
          return (engRate / _count59).toFixed(2);
        }
        return engRate;
      }
      if (field === 'totalEngagementRateView') {
        var _engRate11 = 0;
        var _count60 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _engRate11 += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count60 += 1;
          }
        });
        if (_count60 > 0) {
          return (_engRate11 / _count60).toFixed(2);
        }
        return _engRate11;
      }
      if (field === 'totalInteractionRatePlays') {
        var _engRate12 = 0;
        var _count61 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _engRate12 += item.interaction_rate_plays ? item.interaction_rate_plays : 0;
          if (item.interaction_rate_plays > 0) {
            _count61 += 1;
          }
        });
        if (_count61 > 0) {
          return (_engRate12 / _count61).toFixed(0);
        }
        return _engRate12;
      }
      if (field === 'totalEngRateTotalViewers') {
        var _engRate13 = 0;
        var _count62 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _engRate13 += item.eng_rate_total_viewers ? item.eng_rate_total_viewers : 0;
          if (item.eng_rate_total_viewers > 0) {
            _count62 += 1;
          }
        });
        if (_count62 > 0) {
          return (_engRate13 / _count62).toFixed(2);
        }
        return _engRate13;
      }
      if (field === 'totalEngRateSd') {
        var _engRate14 = 0;
        var _count63 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _engRate14 += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
          if (item.engagement_rate_sd > 0) {
            _count63 += 1;
          }
        });
        if (_count63 > 0) {
          return (_engRate14 / _count63).toFixed(2);
        }
        return _engRate14;
      }
      if (field === 'totalMedianEngRateSd') {
        var _engRate15 = 0;
        var _count64 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _engRate15 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count64 += 1;
          }
        });
        if (_count64 > 0) {
          return (_engRate15 / _count64).toFixed(2);
        }
        return _engRate15;
      }
      if (field === 'totalWatchedFullVideo') {
        var _engRate16 = 0;
        var _count65 = 0;
        this.tiktokAnalysisData.map(function (item) {
          _engRate16 += item.watchedFullVideo ? item.watchedFullVideo : 0;
          if (item.watchedFullVideo > 0) {
            _count65 += 1;
          }
        });
        if (_count65 > 0) {
          return (_engRate16 / _count65).toFixed(2);
        }
        return _engRate16;
      }
    },
    calYoutubeTotal: function calYoutubeTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.youtubeAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalViews') {
        var calData = 0;
        var _count66 = 0;
        this.youtubeAnalysisData.map(function (item) {
          calData += item.views ? item.views : 0;
          if (item.views > 0) {
            _count66 += 1;
          }
        });
        if (_count66 > 0) {
          return (calData / _count66).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalLikes') {
        var _calData6 = 0;
        var _count67 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData6 += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count67 += 1;
          }
        });
        if (_count67 > 0) {
          return (_calData6 / _count67).toFixed(0);
        }
        return _calData6;
      }
      if (field === 'totalComments') {
        var _calData7 = 0;
        var _count68 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData7 += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count68 += 1;
          }
        });
        if (_count68 > 0) {
          return (_calData7 / _count68).toFixed(0);
        }
        return _calData7;
      }
      if (field === 'totalInteractions') {
        var _calData8 = 0;
        var _count69 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData8 += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count69 += 1;
          }
        });
        if (_count69 > 0) {
          return (_calData8 / _count69).toFixed(0);
        }
        return _calData8;
      }
      if (field === 'totalAvgViews') {
        var _calData9 = 0;
        var _count70 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData9 += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count70 += 1;
          }
        });
        if (_count70 > 0) {
          return (_calData9 / _count70).toFixed(2);
        }
        return _calData9;
      }
      if (field === 'totalAvgLikes') {
        var _calData10 = 0;
        var _count71 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData10 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count71 += 1;
          }
        });
        if (_count71 > 0) {
          return (_calData10 / _count71).toFixed(2);
        }
        return _calData10;
      }
      if (field === 'totalAvgComments') {
        var _calData11 = 0;
        var _count72 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData11 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count72 += 1;
          }
        });
        if (_count72 > 0) {
          return (_calData11 / _count72).toFixed(2);
        }
        return _calData11;
      }
      if (field === 'totalEngagementRate') {
        var _calData12 = 0;
        var _count73 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData12 += item.new_engagement_rate ? Number(item.new_engagement_rate) : 0;
          if (item.new_engagement_rate > 0) {
            _count73 += 1;
          }
        });
        if (_count73 > 0) {
          return (_calData12 / _count73).toFixed(2);
        }
        return _calData12;
      }
      if (field === 'totalEngagementRateView') {
        var _calData13 = 0;
        var _count74 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData13 += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count74 += 1;
          }
        });
        if (_count74 > 0) {
          return (_calData13 / _count74).toFixed(2);
        }
        return _calData13;
      }
      if (field === 'totalEngagementRateSd') {
        var _calData14 = 0;
        var _count75 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData14 += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
          if (item.engagement_rate_sd > 0) {
            _count75 += 1;
          }
        });
        if (_count75 > 0) {
          return (_calData14 / _count75).toFixed(2);
        }
        return _calData14;
      }
      if (field === 'totalEngagementRateSd') {
        var _calData15 = 0;
        var _count76 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData15 += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
          if (item.engagement_rate_sd > 0) {
            _count76 += 1;
          }
        });
        if (_count76 > 0) {
          return (_calData15 / _count76).toFixed(2);
        }
        return _calData15;
      }
      if (field === 'totalMedianEngagementRate') {
        var _calData16 = 0;
        var _count77 = 0;
        this.youtubeAnalysisData.map(function (item) {
          _calData16 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count77 += 1;
          }
        });
        if (_count77 > 0) {
          return (_calData16 / _count77).toFixed(2);
        }
        return _calData16;
      }
    },
    calXHSTotal: function calXHSTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.xhsAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalLikes') {
        var calData = 0;
        var _count78 = 0;
        this.xhsAnalysisData.map(function (item) {
          calData += item.like_count ? item.like_count : 0;
          if (item.like_count > 0) {
            _count78 += 1;
          }
        });
        if (_count78 > 0) {
          return (calData / _count78).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalComments') {
        var _calData17 = 0;
        var _count79 = 0;
        this.xhsAnalysisData.map(function (item) {
          _calData17 += item.comment_count ? item.comment_count : 0;
          if (item.comment_count > 0) {
            _count79 += 1;
          }
        });
        if (_count79 > 0) {
          return (_calData17 / _count79).toFixed(0);
        }
        return _calData17;
      }
      if (field === 'totalViews') {
        var _calData18 = 0;
        var _count80 = 0;
        this.xhsAnalysisData.map(function (item) {
          _calData18 += item.views ? item.views : 0;
          if (item.views > 0) {
            _count80 += 1;
          }
        });
        if (_count80 > 0) {
          return (_calData18 / _count80).toFixed(0);
        }
        return _calData18;
      }
      if (field === 'totalShares') {
        var _calData19 = 0;
        var _count81 = 0;
        this.xhsAnalysisData.map(function (item) {
          _calData19 += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count81 += 1;
          }
        });
        if (_count81 > 0) {
          return (_calData19 / _count81).toFixed(0);
        }
        return _calData19;
      }
      if (field === 'totalBookmarks') {
        var _calData20 = 0;
        var _count82 = 0;
        this.xhsAnalysisData.map(function (item) {
          _calData20 += item.bookmarks ? item.bookmarks : 0;
          if (item.bookmarks > 0) {
            _count82 += 1;
          }
        });
        if (_count82 > 0) {
          return (_calData20 / _count82).toFixed(0);
        }
        return _calData20;
      }
      if (field === 'totalInteractions') {
        var _calData21 = 0;
        var _count83 = 0;
        this.xhsAnalysisData.map(function (item) {
          _calData21 += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count83 += 1;
          }
        });
        if (_count83 > 0) {
          return (_calData21 / _count83).toFixed(0);
        }
        return _calData21;
      }
    },
    calFbTotal: function calFbTotal(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.fbAnalysisData.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalLikes') {
        var calData = 0;
        var _count84 = 0;
        this.fbAnalysisData.map(function (item) {
          calData += item.like_count ? item.like_count : 0;
          if (item.like_count > 0) {
            _count84 += 1;
          }
        });
        if (_count84 > 0) {
          return (calData / _count84).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalComments') {
        var _calData22 = 0;
        var _count85 = 0;
        this.fbAnalysisData.map(function (item) {
          _calData22 += item.comment_count ? item.comment_count : 0;
          if (item.comment_count > 0) {
            _count85 += 1;
          }
        });
        if (_count85 > 0) {
          return (_calData22 / _count85).toFixed(0);
        }
        return _calData22;
      }
      if (field === 'totalViews') {
        var _calData23 = 0;
        var _count86 = 0;
        this.fbAnalysisData.map(function (item) {
          _calData23 += item.views ? item.views : 0;
          if (item.views > 0) {
            _count86 += 1;
          }
        });
        if (_count86 > 0) {
          return (_calData23 / _count86).toFixed(0);
        }
        return _calData23;
      }
      if (field === 'totalShares') {
        var _calData24 = 0;
        var _count87 = 0;
        this.fbAnalysisData.map(function (item) {
          _calData24 += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count87 += 1;
          }
        });
        if (_count87 > 0) {
          return (_calData24 / _count87).toFixed(0);
        }
        return _calData24;
      }
      if (field === 'totalBookmarks') {
        var _calData25 = 0;
        var _count88 = 0;
        this.fbAnalysisData.map(function (item) {
          _calData25 += item.bookmarks ? item.bookmarks : 0;
          if (item.bookmarks > 0) {
            _count88 += 1;
          }
        });
        if (_count88 > 0) {
          return (_calData25 / _count88).toFixed(0);
        }
        return _calData25;
      }
      if (field === 'totalInteractions') {
        var _calData26 = 0;
        var _count89 = 0;
        this.fbAnalysisData.map(function (item) {
          _calData26 += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count89 += 1;
          }
        });
        if (_count89 > 0) {
          return (_calData26 / _count89).toFixed(0);
        }
        return _calData26;
      }
    },
    calPostAvg: function calPostAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedPostAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count90 = 0;
        this.selectedPostAnalysis.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (item.reach > 0) {
            _count90 += 1;
          }
        });
        if (_count90 > 0) {
          return (reach / _count90).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count91 = 0;
        this.selectedPostAnalysis.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (item.impressions > 0) {
            _count91 += 1;
          }
        });
        if (_count91 > 0) {
          return (impressions / _count91).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalLikes') {
        var likes = 0;
        var _count92 = 0;
        this.selectedPostAnalysis.map(function (item) {
          likes += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count92 += 1;
          }
        });
        if (_count92 > 0) {
          return (likes / _count92).toFixed(0);
        }
        return likes;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count93 = 0;
        this.selectedPostAnalysis.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count93 += 1;
          }
        });
        if (_count93 > 0) {
          return (shares / _count93).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalComments') {
        var comments = 0;
        var _count94 = 0;
        this.selectedPostAnalysis.map(function (item) {
          comments += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count94 += 1;
          }
        });
        if (_count94 > 0) {
          return (comments / _count94).toFixed(0);
        }
        return comments;
      }
      if (field === 'totalSaved') {
        var saved = 0;
        var _count95 = 0;
        this.selectedPostAnalysis.map(function (item) {
          saved += item.saved ? item.saved : 0;
          if (item.saved > 0) {
            _count95 += 1;
          }
        });
        if (_count95 > 0) {
          return (saved / _count95).toFixed(0);
        }
        return saved;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count96 = 0;
        this.selectedPostAnalysis.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count96 += 1;
          }
        });
        if (_count96 > 0) {
          return (interactions / _count96).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalViews') {
        var views = 0;
        var _count97 = 0;
        this.selectedPostAnalysis.map(function (item) {
          views += item.views ? item.views : 0;
          if (item.views > 0) {
            _count97 += 1;
          }
        });
        if (_count97 > 0) {
          return (views / _count97).toFixed(0);
        }
        return views;
      }
      if (field === 'totalEngagementRate') {
        var engTotal = 0;
        var _count98 = 0;
        this.selectedPostAnalysis.map(function (item) {
          engTotal += item.new_engagement_rate ? item.new_engagement_rate : 0;
          if (item.new_engagement_rate > 0) {
            _count98 += 1;
          }
        });
        if (_count98 > 0) {
          return (engTotal / _count98).toFixed(2);
        }
        return engTotal;
      }
      if (field === 'totalEngagementRateView') {
        var _engTotal8 = 0;
        var _count99 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal8 += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count99 += 1;
          }
        });
        if (_count99 > 0) {
          return (_engTotal8 / _count99).toFixed(2);
        }
        return _engTotal8;
      }
      if (field === 'totalEngagementRateReach') {
        var _engTotal9 = 0;
        var _count100 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal9 += item.engagement_rate_reach ? item.engagement_rate_reach : 0;
          if (item.engagement_rate_reach > 0) {
            _count100 += 1;
          }
        });
        if (_count100 > 0 && _engTotal9 > 0) {
          return (_engTotal9 / _count100).toFixed(2);
        }
        return _engTotal9;
      }
      if (field === 'totalEngRateSd') {
        var _engTotal10 = 0;
        var _count101 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal10 += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0;
          if (Number(item.engagement_rate_sd) > 0) {
            _count101 += 1;
          }
        });
        if (_count101 > 0) {
          return (_engTotal10 / _count101).toFixed(2);
        }
        return _engTotal10;
      }
      if (field === 'totalMedianEngRate') {
        var _engTotal11 = 0;
        var _count102 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal11 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count102 += 1;
          }
        });
        if (_count102 > 0) {
          return (_engTotal11 / _count102).toFixed(2);
        }
        return _engTotal11;
      }
      if (field === 'totalAvgLikes') {
        var _engTotal12 = 0;
        var _count103 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal12 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count103 += 1;
          }
        });
        if (_count103 > 0) {
          return (_engTotal12 / _count103).toFixed(2);
        }
        return _engTotal12;
      }
      if (field === 'totalAvgComments') {
        var _engTotal13 = 0;
        var _count104 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal13 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count104 += 1;
          }
        });
        if (_count104 > 0) {
          return (_engTotal13 / _count104).toFixed(2);
        }
        return _engTotal13;
      }
      if (field === 'totalAvgViews') {
        var _engTotal14 = 0;
        var _count105 = 0;
        this.selectedPostAnalysis.map(function (item) {
          _engTotal14 += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count105 += 1;
          }
        });
        if (_count105 > 0) {
          return (_engTotal14 / _count105).toFixed(2);
        }
        return _engTotal14;
      }
    },
    calStoryAvg: function calStoryAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedStoryAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count106 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (item.reach > 0) {
            _count106 += 1;
          }
        });
        if (_count106 > 0) {
          return (reach / _count106).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count107 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (item.impressions > 0) {
            _count107 += 1;
          }
        });
        if (_count107 > 0) {
          return (impressions / _count107).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalReplies') {
        var replies = 0;
        var _count108 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          replies += item.replies ? item.replies : 0;
          if (item.replies > 0) {
            _count108 += 1;
          }
        });
        if (_count108 > 0) {
          return (replies / _count108).toFixed(0);
        }
        return replies;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count109 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count109 += 1;
          }
        });
        if (_count109 > 0) {
          return (shares / _count109).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalLinkClicks') {
        var linkClicks = 0;
        var _count110 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          linkClicks += item.link_clicks ? item.link_clicks : 0;
          if (item.link_clicks > 0) {
            _count110 += 1;
          }
        });
        if (_count110 > 0) {
          return (linkClicks / _count110).toFixed(0);
        }
        return linkClicks;
      }
      if (field === 'totalStickerTaps') {
        var stickerTaps = 0;
        var _count111 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          stickerTaps += item.sticker_taps ? item.sticker_taps : 0;
          if (item.sticker_taps > 0) {
            _count111 += 1;
          }
        });
        if (_count111 > 0) {
          return (stickerTaps / _count111).toFixed(0);
        }
        return stickerTaps;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count112 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count112 += 1;
          }
        });
        if (_count112 > 0) {
          return (interactions / _count112).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalAvgViews') {
        var calData = 0;
        var _count113 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          calData += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count113 += 1;
          }
        });
        if (_count113 > 0) {
          return (calData / _count113).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalAvgReelPlays') {
        var _calData27 = 0;
        var _count114 = 0;
        this.selectedStoryAnalysis.map(function (item) {
          _calData27 += item.avg_reels_plays ? item.avg_reels_plays : 0;
          if (item.avg_reels_plays > 0) {
            _count114 += 1;
          }
        });
        if (_count114 > 0) {
          return (_calData27 / _count114).toFixed(0);
        }
        return _calData27;
      }
    },
    calReelAvg: function calReelAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedReelAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count115 = 0;
        this.selectedReelAnalysis.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (reach > 0) {
            _count115 += 1;
          }
        });
        if (_count115 > 0) {
          return (reach / _count115).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count116 = 0;
        this.selectedReelAnalysis.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (impressions > 0) {
            _count116 += 1;
          }
        });
        if (_count116 > 0) {
          return (impressions / _count116).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalLikes') {
        var likes = 0;
        var _count117 = 0;
        this.selectedReelAnalysis.map(function (item) {
          likes += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count117 += 1;
          }
        });
        if (_count117 > 0) {
          return (likes / _count117).toFixed(0);
        }
        return likes;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count118 = 0;
        this.selectedReelAnalysis.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count118 += 1;
          }
        });
        if (_count118 > 0) {
          return (shares / _count118).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalComments') {
        var comments = 0;
        var _count119 = 0;
        this.selectedReelAnalysis.map(function (item) {
          comments += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count119 += 1;
          }
        });
        if (_count119 > 0) {
          return (comments / _count119).toFixed(0);
        }
        return comments;
      }
      if (field === 'totalSaved') {
        var saved = 0;
        var _count120 = 0;
        this.selectedReelAnalysis.map(function (item) {
          saved += item.saved ? item.saved : 0;
          if (item.saved > 0) {
            _count120 += 1;
          }
        });
        if (_count120 > 0) {
          return (saved / _count120).toFixed(0);
        }
        return saved;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count121 = 0;
        this.selectedReelAnalysis.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count121 += 1;
          }
        });
        if (_count121 > 0) {
          return (interactions / _count121).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalViews') {
        var views = 0;
        var _count122 = 0;
        this.selectedReelAnalysis.map(function (item) {
          views += item.views ? item.views : 0;
          if (item.views > 0) {
            _count122 += 1;
          }
        });
        if (_count122 > 0) {
          return (views / _count122).toFixed(0);
        }
        return views;
      }
      if (field === 'totalEngagementRate') {
        var engRate = 0;
        var _count123 = 0;
        this.selectedReelAnalysis.map(function (item) {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0;
          if (item.new_engagement_rate > 0) {
            _count123 += 1;
          }
        });
        if (_count123 > 0) {
          return (engRate / _count123).toFixed(2);
        }
        return engRate;
      }
      if (field === 'totalEngagementRateView') {
        var _engRate17 = 0;
        var _count124 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate17 += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count124 += 1;
          }
        });
        if (_count124 > 0) {
          return (_engRate17 / _count124).toFixed(2);
        }
        return _engRate17;
      }
      if (field === 'totalInteractionRatePlays') {
        var _engRate18 = 0;
        var _count125 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate18 += item.interaction_rate_plays ? item.interaction_rate_plays : 0;
          if (item.interaction_rate_plays > 0) {
            _count125 += 1;
          }
        });
        if (_count125 > 0) {
          return (_engRate18 / _count125).toFixed(2);
        }
        return _engRate18;
      }
      if (field === 'totalEngagementRateReach') {
        var _engRate19 = 0;
        var _count126 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate19 += item.engagement_rate_reach ? item.engagement_rate_reach : 0;
          if (item.engagement_rate_reach > 0) {
            _count126 += 1;
          }
        });
        if (_count126 > 0) {
          return (_engRate19 / _count126).toFixed(2);
        }
        return _engRate19;
      }
      if (field === 'totalEngRateSd') {
        var _engRate20 = 0;
        var _count127 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate20 += item.engagement_rate_sd ? Number(item.engagement_rate_sd) : 0;
          if (item.engagement_rate_sd > 0) {
            _count127 += 1;
          }
        });
        if (_count127 > 0) {
          return (_engRate20 / _count127).toFixed(2);
        }
        return _engRate20;
      }
      if (field === 'totalMedianEngRate') {
        var _engRate21 = 0;
        var _count128 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate21 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count128 += 1;
          }
        });
        if (_count128 > 0) {
          return (_engRate21 / _count128).toFixed(2);
        }
        return _engRate21;
      }
      if (field === 'totalMedianEngRate') {
        var _engRate22 = 0;
        var _count129 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate22 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count129 += 1;
          }
        });
        if (_count129 > 0) {
          return (_engRate22 / _count129).toFixed(2);
        }
        return _engRate22;
      }
      if (field === 'totalAvgLikes') {
        var _engRate23 = 0;
        var _count130 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate23 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count130 += 1;
          }
        });
        if (_count130 > 0) {
          return (_engRate23 / _count130).toFixed(2);
        }
        return _engRate23;
      }
      if (field === 'totalAvgComments') {
        var _engRate24 = 0;
        var _count131 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate24 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count131 += 1;
          }
        });
        if (_count131 > 0) {
          return (_engRate24 / _count131).toFixed(2);
        }
        return _engRate24;
      }
      if (field === 'totalAvgViews') {
        var _engRate25 = 0;
        var _count132 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate25 += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count132 += 1;
          }
        });
        if (_count132 > 0) {
          return (_engRate25 / _count132).toFixed(2);
        }
        return _engRate25;
      }
      if (field === 'totalReelPlays') {
        var _engRate26 = 0;
        var _count133 = 0;
        this.selectedReelAnalysis.map(function (item) {
          _engRate26 += item.avg_reels_plays ? item.avg_reels_plays : 0;
          if (item.avg_reels_plays > 0) {
            _count133 += 1;
          }
        });
        if (_count133 > 0) {
          return (_engRate26 / _count133).toFixed(2);
        }
        return _engRate26;
      }
    },
    calTikTokAvg: function calTikTokAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalWatches') {
        var watches = 0;
        var _count134 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          watches += item.watches ? __WEBPACK_IMPORTED_MODULE_10__campaignHelper__["a" /* default */].formatWatchTime(item.watches) : 0;
          if (item.watches) {
            _count134 += 1;
          }
        });
        if (_count134 > 0) {
          return (watches / _count134).toFixed(2) + 's';
        }
        return watches + 's';
      }
      if (field === 'totalLikes') {
        var likes = 0;
        var _count135 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          likes += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count135 += 1;
          }
        });
        if (_count135 > 0) {
          return (likes / _count135).toFixed(0);
        }
        return likes;
      }
      if (field === 'totalComments') {
        var comments = 0;
        var _count136 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          comments += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count136 += 1;
          }
        });
        if (_count136 > 0) {
          return (comments / _count136).toFixed(0);
        }
        return comments;
      }
      if (field === 'totalShares') {
        var shares = 0;
        var _count137 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          shares += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count137 += 1;
          }
        });
        if (_count137 > 0) {
          return (shares / _count137).toFixed(0);
        }
        return shares;
      }
      if (field === 'totalBookmarks') {
        var saved = 0;
        var _count138 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          saved += item.saved ? item.saved : 0;
          if (item.saved > 0) {
            _count138 += 1;
          }
        });
        if (_count138 > 0) {
          return (saved / _count138).toFixed(0);
        }
        return saved;
      }
      if (field === 'totalInteractions') {
        var interactions = 0;
        var _count139 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          interactions += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count139 += 1;
          }
        });
        if (_count139 > 0) {
          return (interactions / _count139).toFixed(0);
        }
        return interactions;
      }
      if (field === 'totalViews') {
        var views = 0;
        var _count140 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          views += item.views ? item.views : 0;
          if (item.views > 0) {
            _count140 += 1;
          }
        });
        if (_count140 > 0) {
          return (views / _count140).toFixed(0);
        }
        return views;
      }
      if (field === 'totalReach') {
        var reach = 0;
        var _count141 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          reach += item.reach ? item.reach : 0;
          if (item.reach > 0) {
            _count141 += 1;
          }
        });
        if (_count141 > 0) {
          return (reach / _count141).toFixed(0);
        }
        return reach;
      }
      if (field === 'totalImpressions') {
        var impressions = 0;
        var _count142 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          impressions += item.impressions ? item.impressions : 0;
          if (item.impressions > 0) {
            _count142 += 1;
          }
        });
        if (_count142 > 0) {
          return (impressions / _count142).toFixed(0);
        }
        return impressions;
      }
      if (field === 'totalAvgViews') {
        var calData = 0;
        var _count143 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          calData += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count143 += 1;
          }
        });
        if (_count143 > 0) {
          return (calData / _count143).toFixed(2);
        }
        return calData;
      }
      if (field === 'totalAvgLikes') {
        var _calData28 = 0;
        var _count144 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _calData28 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count144 += 1;
          }
        });
        if (_count144 > 0) {
          return (_calData28 / _count144).toFixed(2);
        }
        return _calData28;
      }
      if (field === 'totalAvgComments') {
        var _calData29 = 0;
        var _count145 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _calData29 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count145 += 1;
          }
        });
        if (_count145 > 0) {
          return (_calData29 / _count145).toFixed(2);
        }
        return _calData29;
      }
      if (field === 'totalAvgSaves') {
        var _calData30 = 0;
        var _count146 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _calData30 += item.avg_saves ? item.avg_saves : 0;
          if (item.avg_saves > 0) {
            _count146 += 1;
          }
        });
        if (_count146 > 0) {
          return (_calData30 / _count146).toFixed(2);
        }
        return _calData30;
      }
      if (field === 'totalAvgShares') {
        var _calData31 = 0;
        var _count147 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _calData31 += item.avg_saves ? item.avg_saves : 0;
          if (item.avg_saves > 0) {
            _count147 += 1;
          }
        });
        if (_count147 > 0) {
          return (_calData31 / _count147).toFixed(2);
        }
        return _calData31;
      }
      if (field === 'totalEngagementRate') {
        var engRate = 0;
        var _count148 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          engRate += item.new_engagement_rate ? item.new_engagement_rate : 0;
          if (item.new_engagement_rate > 0) {
            _count148 += 1;
          }
        });
        if (_count148 > 0) {
          return (engRate / _count148).toFixed(2);
        }
        return engRate;
      }
      if (field === 'totalEngagementRateView') {
        var _engRate27 = 0;
        var _count149 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _engRate27 += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count149 += 1;
          }
        });
        if (_count149 > 0) {
          return (_engRate27 / _count149).toFixed(2);
        }
        return _engRate27;
      }
      if (field === 'totalInteractionRatePlays') {
        var _engRate28 = 0;
        var _count150 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _engRate28 += item.interaction_rate_plays ? item.interaction_rate_plays : 0;
          if (item.interaction_rate_plays > 0) {
            _count150 += 1;
          }
        });
        if (_count150 > 0) {
          return (_engRate28 / _count150).toFixed(0);
        }
        return _engRate28;
      }
      if (field === 'totalEngRateTotalViewers') {
        var _engRate29 = 0;
        var _count151 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _engRate29 += item.eng_rate_total_viewers ? item.eng_rate_total_viewers : 0;
          if (item.eng_rate_total_viewers > 0) {
            _count151 += 1;
          }
        });
        if (_count151 > 0) {
          return (_engRate29 / _count151).toFixed(2);
        }
        return _engRate29;
      }
      if (field === 'totalEngRateSd') {
        var _engRate30 = 0;
        var _count152 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _engRate30 += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
          if (item.engagement_rate_sd > 0) {
            _count152 += 1;
          }
        });
        if (_count152 > 0) {
          return (_engRate30 / _count152).toFixed(2);
        }
        return _engRate30;
      }
      if (field === 'totalMedianEngRateSd') {
        var _engRate31 = 0;
        var _count153 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _engRate31 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count153 += 1;
          }
        });
        if (_count153 > 0) {
          return (_engRate31 / _count153).toFixed(2);
        }
        return _engRate31;
      }
      if (field === 'totalWatchedFullVideo') {
        var _engRate32 = 0;
        var _count154 = 0;
        this.selectedTikTokAnalysis.map(function (item) {
          _engRate32 += item.watchedFullVideo ? item.watchedFullVideo : 0;
          if (item.watchedFullVideo > 0) {
            _count154 += 1;
          }
        });
        if (_count154 > 0) {
          return (_engRate32 / _count154).toFixed(2);
        }
        return _engRate32;
      }
    },
    calYoutubeAvg: function calYoutubeAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalViews') {
        var calData = 0;
        var _count155 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          calData += item.views ? item.views : 0;
          if (item.views > 0) {
            _count155 += 1;
          }
        });
        if (_count155 > 0) {
          return (calData / _count155).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalLikes') {
        var _calData32 = 0;
        var _count156 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData32 += item.likes ? item.likes : 0;
          if (item.likes > 0) {
            _count156 += 1;
          }
        });
        if (_count156 > 0) {
          return (_calData32 / _count156).toFixed(0);
        }
        return _calData32;
      }
      if (field === 'totalComments') {
        var _calData33 = 0;
        var _count157 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData33 += item.comments ? item.comments : 0;
          if (item.comments > 0) {
            _count157 += 1;
          }
        });
        if (_count157 > 0) {
          return (_calData33 / _count157).toFixed(0);
        }
        return _calData33;
      }
      if (field === 'totalInteractions') {
        var _calData34 = 0;
        var _count158 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData34 += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count158 += 1;
          }
        });
        if (_count158 > 0) {
          return (_calData34 / _count158).toFixed(0);
        }
        return _calData34;
      }
      if (field === 'totalAvgViews') {
        var _calData35 = 0;
        var _count159 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData35 += item.avg_views ? item.avg_views : 0;
          if (item.avg_views > 0) {
            _count159 += 1;
          }
        });
        if (_count159 > 0) {
          return (_calData35 / _count159).toFixed(2);
        }
        return _calData35;
      }
      if (field === 'totalAvgLikes') {
        var _calData36 = 0;
        var _count160 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData36 += item.avg_likes ? item.avg_likes : 0;
          if (item.avg_likes > 0) {
            _count160 += 1;
          }
        });
        if (_count160 > 0) {
          return (_calData36 / _count160).toFixed(2);
        }
        return _calData36;
      }
      if (field === 'totalAvgComments') {
        var _calData37 = 0;
        var _count161 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData37 += item.avg_comments ? item.avg_comments : 0;
          if (item.avg_comments > 0) {
            _count161 += 1;
          }
        });
        if (_count161 > 0) {
          return (_calData37 / _count161).toFixed(2);
        }
        return _calData37;
      }
      if (field === 'totalEngagementRate') {
        var _calData38 = 0;
        var _count162 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData38 += item.new_engagement_rate ? Number(item.new_engagement_rate) : 0;
          if (item.new_engagement_rate > 0) {
            _count162 += 1;
          }
        });
        if (_count162 > 0) {
          return (_calData38 / _count162).toFixed(2);
        }
        return _calData38;
      }
      if (field === 'totalEngagementRateView') {
        var _calData39 = 0;
        var _count163 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData39 += item.new_engagement_rate_view ? item.new_engagement_rate_view : 0;
          if (item.new_engagement_rate_view > 0) {
            _count163 += 1;
          }
        });
        if (_count163 > 0) {
          return (_calData39 / _count163).toFixed(2);
        }
        return _calData39;
      }
      if (field === 'totalEngagementRateSd') {
        var _calData40 = 0;
        var _count164 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData40 += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
          if (item.engagement_rate_sd > 0) {
            _count164 += 1;
          }
        });
        if (_count164 > 0) {
          return (_calData40 / _count164).toFixed(2);
        }
        return _calData40;
      }
      if (field === 'totalEngagementRateSd') {
        var _calData41 = 0;
        var _count165 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData41 += item.engagement_rate_sd ? item.engagement_rate_sd : 0;
          if (item.engagement_rate_sd > 0) {
            _count165 += 1;
          }
        });
        if (_count165 > 0) {
          return (_calData41 / _count165).toFixed(2);
        }
        return _calData41;
      }
      if (field === 'totalMedianEngagementRate') {
        var _calData42 = 0;
        var _count166 = 0;
        this.selectedYoutubeAnalysis.map(function (item) {
          _calData42 += item.median_engagement_rate ? item.median_engagement_rate : 0;
          if (item.median_engagement_rate > 0) {
            _count166 += 1;
          }
        });
        if (_count166 > 0) {
          return (_calData42 / _count166).toFixed(2);
        }
        return _calData42;
      }
    },
    calXhsAvg: function calXhsAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedXhsAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalLikes') {
        var calData = 0;
        var _count167 = 0;
        this.selectedXhsAnalysis.map(function (item) {
          calData += item.like_count ? item.like_count : 0;
          if (item.like_count > 0) {
            _count167 += 1;
          }
        });
        if (_count167 > 0) {
          return (calData / _count167).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalComments') {
        var _calData43 = 0;
        var _count168 = 0;
        this.selectedXhsAnalysis.map(function (item) {
          _calData43 += item.comment_count ? item.comment_count : 0;
          if (item.comment_count > 0) {
            _count168 += 1;
          }
        });
        if (_count168 > 0) {
          return (_calData43 / _count168).toFixed(0);
        }
        return _calData43;
      }
      if (field === 'totalViews') {
        var _calData44 = 0;
        var _count169 = 0;
        this.selectedXhsAnalysis.map(function (item) {
          _calData44 += item.views ? item.views : 0;
          if (item.views > 0) {
            _count169 += 1;
          }
        });
        if (_count169 > 0) {
          return (_calData44 / _count169).toFixed(0);
        }
        return _calData44;
      }
      if (field === 'totalShares') {
        var _calData45 = 0;
        var _count170 = 0;
        this.selectedXhsAnalysis.map(function (item) {
          _calData45 += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count170 += 1;
          }
        });
        if (_count170 > 0) {
          return (_calData45 / _count170).toFixed(0);
        }
        return _calData45;
      }
      if (field === 'totalBookmarks') {
        var _calData46 = 0;
        var _count171 = 0;
        this.selectedXhsAnalysis.map(function (item) {
          _calData46 += item.bookmarks ? item.bookmarks : 0;
          if (item.bookmarks > 0) {
            _count171 += 1;
          }
        });
        if (_count171 > 0) {
          return (_calData46 / _count171).toFixed(0);
        }
        return _calData46;
      }
      if (field === 'totalInteractions') {
        var _calData47 = 0;
        var _count172 = 0;
        this.selectedXhsAnalysis.map(function (item) {
          _calData47 += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count172 += 1;
          }
        });
        if (_count172 > 0) {
          return (_calData47 / _count172).toFixed(0);
        }
        return _calData47;
      }
    },
    calFbAvg: function calFbAvg(field) {
      if (field === 'totalOutreach') {
        var outreach = 0;
        var count = 0;
        this.selectedFbAnalysis.map(function (item) {
          outreach += item.outreach ? item.outreach : 0;
          if (item.outreach > 0) {
            count += 1;
          }
        });
        if (count > 0) {
          return (outreach / count).toFixed(0);
        }
        return outreach;
      }
      if (field === 'totalLikes') {
        var calData = 0;
        var _count173 = 0;
        this.selectedFbAnalysis.map(function (item) {
          calData += item.like_count ? item.like_count : 0;
          if (item.like_count > 0) {
            _count173 += 1;
          }
        });
        if (_count173 > 0) {
          return (calData / _count173).toFixed(0);
        }
        return calData;
      }
      if (field === 'totalComments') {
        var _calData48 = 0;
        var _count174 = 0;
        this.selectedFbAnalysis.map(function (item) {
          _calData48 += item.comment_count ? item.comment_count : 0;
          if (item.comment_count > 0) {
            _count174 += 1;
          }
        });
        if (_count174 > 0) {
          return (_calData48 / _count174).toFixed(0);
        }
        return _calData48;
      }
      if (field === 'totalViews') {
        var _calData49 = 0;
        var _count175 = 0;
        this.selectedFbAnalysis.map(function (item) {
          _calData49 += item.views ? item.views : 0;
          if (item.views > 0) {
            _count175 += 1;
          }
        });
        if (_count175 > 0) {
          return (_calData49 / _count175).toFixed(0);
        }
        return _calData49;
      }
      if (field === 'totalShares') {
        var _calData50 = 0;
        var _count176 = 0;
        this.selectedFbAnalysis.map(function (item) {
          _calData50 += item.shares ? item.shares : 0;
          if (item.shares > 0) {
            _count176 += 1;
          }
        });
        if (_count176 > 0) {
          return (_calData50 / _count176).toFixed(0);
        }
        return _calData50;
      }
      if (field === 'totalBookmarks') {
        var _calData51 = 0;
        var _count177 = 0;
        this.selectedFbAnalysis.map(function (item) {
          _calData51 += item.bookmarks ? item.bookmarks : 0;
          if (item.bookmarks > 0) {
            _count177 += 1;
          }
        });
        if (_count177 > 0) {
          return (_calData51 / _count177).toFixed(0);
        }
        return _calData51;
      }
      if (field === 'totalInteractions') {
        var _calData52 = 0;
        var _count178 = 0;
        this.selectedFbAnalysis.map(function (item) {
          _calData52 += item.interactions ? item.interactions : 0;
          if (item.interactions > 0) {
            _count178 += 1;
          }
        });
        if (_count178 > 0) {
          return (_calData52 / _count178).toFixed(0);
        }
        return _calData52;
      }
    },
    openPostAnalysisAvgModal: function openPostAnalysisAvgModal() {
      this.avgPostAnalysisDialog = true;
    },
    openStoryAnalysisAvgModal: function openStoryAnalysisAvgModal() {
      this.avgStoryAnalysisDialog = true;
    },
    openReelAnalysisAvgModal: function openReelAnalysisAvgModal() {
      this.avgReelAnalysisDialog = true;
    },
    openTikTokAnalysisAvgModal: function openTikTokAnalysisAvgModal() {
      this.avgTiktokAnalysisDialog = true;
    },
    openYoutubeAnalysisAvgModal: function openYoutubeAnalysisAvgModal() {
      this.avgYoutubeAnalysisDialog = true;
    },
    openXhsAnalysisAvgModal: function openXhsAnalysisAvgModal() {
      this.avgXhsAnalysisDialog = true;
    },
    openFbAnalysisAvgModal: function openFbAnalysisAvgModal() {
      this.avgFbAnalysisDialog = true;
    },
    resetAnalysisData: function resetAnalysisData() {
      this.selectedPostAnalysis = [];
      this.selectedStoryAnalysis = [];
      this.selectedReelAnalysis = [];
      this.selectedTikTokAnalysis = [];
      this.selectedYoutubeAnalysis = [];
      this.selectedXhsAnalysis = [];
      this.selectedFbAnalysis = [];
    },
    storeStatsData: function storeStatsData(data) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__["a" /* default */].storeStatsData(data).then(function (response) {}).catch(function (error) {
        console.log('error', error);
        _this12.$swal({
          text: error,
          type: 'error'
        });
      });
    }
  }
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewModalDialog',
  components: {
    StatsDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: {
    value: Boolean,
    handle: String
  },
  data: function data() {
    return {};
  },

  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'statistics-analysis',
  components: {
    StatisticsAnalysisDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__campaignAPIs__ = __webpack_require__(16);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TableAiAnalysisModal',
  props: {
    value: Boolean,
    campaign: Object,
    posts: Array,
    typeKey: String,
    label: String },
  data: function data() {
    return {
      text: '',
      generating: false,
      saving: false
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(open) {
        if (open) {
          var saved = this.campaign && this.campaign.AITableSummaries || {};
          this.text = saved[this.typeKey] || '';
        }
      }
    }
  },
  methods: {
    rowsContext: function rowsContext() {
      var n = function n(v) {
        return v === null || v === undefined || v === '' ? 0 : Number(v) || 0;
      };
      var rows = (this.posts || []).map(function (p) {
        var row = {
          creator: p.name || p.instagram || 'unknown',
          liveDate: p.live_date,
          audienceSize: n(p.outreach)
        };
        var add = function add(key, val) {
          if (n(val)) row[key] = n(val);
        };
        add('reach', p.reach);
        add('impressions', p.impressions);
        add('plays', p.views);
        add('likes', p.likes !== undefined ? p.likes : p.like_count);
        add('comments', p.comments !== undefined ? p.comments : p.comment_count);
        add('shares', p.shares);
        add('saves', p.saved !== undefined ? p.saved : p.bookmarks);
        add('replies', p.replies);
        add('linkClicks', p.link_clicks);
        add('engagementRatePct', p.new_engagement_rate);
        return row;
      });
      return {
        campaign: this.campaign && this.campaign.name || 'Campaign',
        contentType: this.label,
        contents: rows.length,
        rows: rows.slice(0, 60)
      };
    },
    generate: function generate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.generating = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__campaignAPIs__["a" /* default */].getCampaignAISummary({
                  campaignContext: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.rowsContext()),
                  mode: 'table' });

              case 4:
                resp = _context.sent;

                if (resp && resp.analysis) _this.text = String(resp.analysis).trim();
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.error('table AI generate failed', _context.t0);
                _this.$swal({ text: 'Could not generate the analysis. Try again.', type: 'error' });

              case 12:
                _context.prev = 12;

                _this.generating = false;
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 12, 15]]);
      }))();
    },
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var merged, formData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.saving = true;
                _context2.prev = 1;
                merged = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.campaign && _this2.campaign.AITableSummaries || {});

                if (_this2.text && _this2.text.trim()) merged[_this2.typeKey] = _this2.text.trim();else delete merged[_this2.typeKey];
                formData = new FormData();

                formData.append('data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ AITableSummaries: merged }));
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4__campaignAPIs__["a" /* default */].updateCampaignSummary(_this2.campaign.id, formData);

              case 8:
                _this2.$set(_this2.campaign, 'AITableSummaries', merged);
                _this2.$emit('saved', merged);
                _this2.$emit('input', false);
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](1);

                console.error('table AI save failed', _context2.t0);
                _this2.$swal({ text: 'Could not save the analysis.', type: 'error' });

              case 17:
                _context2.prev = 17;

                _this2.saving = false;
                return _context2.finish(17);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13, 17, 20]]);
      }))();
    }
  }
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddReviewMeetingDate',
  props: ['campaignID', 'oldReviewDate', 'oldActivatingDate', 'options'],
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker___default.a
  },
  data: function data() {
    return {
      reviewMeetingDate: '',
      activatingDate: '',
      invalidDate: false,
      invalidActivatingDate: false,
      utils: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    reports: function reports(state) {
      return state.campaign.reports;
    },
    savedReviewMeeting: function savedReviewMeeting(state) {
      return state.campaignTimeline.savedReviewMeeting;
    },
    savedTimeline: function savedTimeline(state) {
      return state.campaignTimeline.savedTimeline;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('campaignTimeline', ['getReviewDates'])),
  watch: {
    oldReviewDate: function oldReviewDate(value) {
      this.reviewMeetingDate = value;
      if (value) {
        this.checkDate(value, false);
      }
    },
    oldActivatingDate: function oldActivatingDate(value) {
      this.activatingDate = value;
      if (value) {
        this.checkActDate(value);
      }
    }
  },
  mounted: function mounted() {
    this.reviewMeetingDate = this.oldReviewDate;
    if (this.reviewMeetingDate) {
      this.checkDate(this.reviewMeetingDate, false);
    }
  },

  methods: {
    checkDate: function checkDate(dateVal) {
      var forceSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.invalidDate = true;
      if (__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.isDateFormatValid(dateVal) || !dateVal) {
        this.invalidDate = false;
        if (this.options.theme && this.options.theme === 'tableview' && forceSave) {
          this.saveChanges();
        }
      }
    },
    setDateFromPicker: function setDateFromPicker(value) {
      this.reviewMeetingDate = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.checkDate(this.reviewMeetingDate);
    },
    saveChanges: function saveChanges() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var reviewDates, saveData, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('campaign/getReportsByCampaignIDs', [_this.campaignID]);

              case 2:
                reviewDates = _this.getReviewDates(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.parseDate(_this.reviewMeetingDate), _this.reports);
                saveData = [__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                  campaignID: _this.campaignID,
                  checkChgCol: 'ReviewMeetingDateCol'
                }, reviewDates)];
                formData = new FormData();

                formData.append('data', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(saveData));
                _context.next = 8;
                return _this.$store.dispatch('campaignTimeline/saveReviewMeeting', formData);

              case 8:
                if (_this.savedReviewMeeting) {
                  if (_this.options.theme === 'default') {
                    _this.$swal({
                      text: 'Successfully Saved.',
                      type: 'success'
                    });
                  }
                  _this.$emit('updated', reviewDates);
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkActDate: function checkActDate(dateVal) {
      this.invalidActivatingDate = true;
      if (__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.isDateFormatValid(dateVal) || !dateVal) {
        this.invalidActivatingDate = false;
      }
    },
    setActDateFromPicker: function setActDateFromPicker(value) {
      this.activatingDate = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.checkDate(this.activatingDate);
    },
    saveActivatingDate: function saveActivatingDate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveData, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                saveData = [{
                  campaignID: _this2.campaignID,
                  activatingDate: _this2.activatingDate
                }];
                formData = new FormData();

                formData.append('data', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(saveData));
                _context2.next = 5;
                return _this2.$store.dispatch('campaignTimeline/saveTimeline', formData);

              case 5:
                if (_this2.savedTimeline) {
                  _this2.$swal({
                    text: 'Successfully Saved.',
                    type: 'success'
                  });
                  _this2.$emit('reloadTimeline');
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CardSummary',
  props: ['summary']
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html_to_image__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_LinearProgress__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddReviewMeetingDate__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddReviewMeetingDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AddReviewMeetingDate__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-timeline-datatable',
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_DatePicker___default.a,
    LinearProgress: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_LinearProgress___default.a,
    AddReviewMeetingDate: __WEBPACK_IMPORTED_MODULE_13__AddReviewMeetingDate___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default.a
  },
  props: ['campaignID', 'selectedCampaign', 'refresh'],
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].tableHeaders,
      timelineTypeLists: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].timelineTypeLists,
      timelineTypes: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].timelineTypes,
      filteredItems: [],
      filter: '',
      oldReviewDate: '',
      oldActivatingDate: '',
      currentMode: 'view',
      isLoading: false,
      disableSave: false,
      hideForPrint: false,
      utils: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    detail: function detail(state) {
      return state.campaignTimeline.timelineDetail;
    },
    reviewMeetingDetail: function reviewMeetingDetail(state) {
      return state.campaignTimeline.reviewMeetingDetail;
    },
    savedTimeline: function savedTimeline(state) {
      return state.campaignTimeline.savedTimeline;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('campaignTimeline', ['getStageDays']), {
    viewMode: function viewMode() {
      return this.currentMode === 'view';
    },
    editMode: function editMode() {
      return this.currentMode === 'edit';
    },
    computedHeaders: function computedHeaders() {
      if (this.viewMode) {
        return this.headers.filter(function (h) {
          return h.value !== 'controlAction';
        });
      }
      return this.headers;
    }
  }),
  watch: {
    refresh: function refresh(value) {
      if (value) this.getCampaignTimelines();
    }
  },
  mounted: function mounted() {},

  methods: {
    getCampaignTimelines: function getCampaignTimelines() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var timelineDetail;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.filteredItems = [];
                _this.oldReviewDate = '';
                _this.oldActivatingDate = '';
                _context.next = 5;
                return _this.$store.dispatch('campaignTimeline/getCampaignTimeline', _this.campaignID);

              case 5:
                timelineDetail = _context.sent;

                if (timelineDetail && Array.isArray(timelineDetail.schedules) && timelineDetail.schedules.length) {
                  _this.filteredItems = timelineDetail.schedules.map(function (schedule) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, schedule);
                  });
                  _this.beautifyScheduleData();
                  _this.filteredItems = _this.resetDateValidators(_this.filteredItems);
                  if (timelineDetail.activatingDate) {
                    _this.oldActivatingDate = timelineDetail.activatingDate;
                  }
                } else {
                  _this.populateDefaultItems();
                }
                _context.next = 9;
                return _this.$store.dispatch('campaignTimeline/getReviewMeeting', _this.campaignID);

              case 9:
                if (_this.reviewMeetingDetail.reviewMeetingDate) {
                  _this.oldReviewDate = _this.reviewMeetingDetail.reviewMeetingDate ? _this.reviewMeetingDetail.reviewMeetingDate : '';
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    beautifyScheduleData: function beautifyScheduleData() {
      var _this2 = this;

      this.filteredItems = this.filteredItems.map(function (f) {
        var matchType = _this2.timelineTypeLists.find(function (t) {
          return t.value === f.actionType;
        });
        if (matchType) {
          f.actionType = matchType;
        }
        if (f.actionType === 0) f.actionType = '-';
        return f;
      });
    },
    changeMode: function changeMode(mode) {
      this.currentMode = mode;
      if (mode === 'edit') {
        if (!this.detail.activatingDate) {
          this.$swal({
            text: 'Please Enter Activating Date.',
            type: 'warning'
          });
          this.currentMode = 'view';
        }
        this.checkSaveChangesBtnState();
      }
    },
    saveChanges: function saveChanges() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveItems, saveData, formData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.checkDeleteBtnState()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                saveItems = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.refreshJSON(_this3.filteredItems);

                saveItems = saveItems.map(function (f) {
                  if (f.actionType && f.actionType.value) {
                    f.actionType = f.actionType.value;
                  }
                  delete f.validStartDate;
                  delete f.validEndDate;
                  delete f.validActivatingDueDate;
                  delete f.validPairingDueDate;
                  return f;
                });
                saveData = [{
                  campaignID: _this3.campaignID,
                  schedules: saveItems,
                  numberOfDaysPerStage: _this3.getStageDays(saveItems)
                }];
                formData = new FormData();

                formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(saveData));
                _context2.next = 9;
                return _this3.$store.dispatch('campaignTimeline/saveTimeline', formData);

              case 9:
                if (_this3.savedTimeline) {
                  _this3.currentMode = 'view';
                  _this3.$swal({
                    text: 'Successfully Saved.',
                    type: 'success'
                  });
                  _this3.getCampaignTimelines();
                  _this3.$emit('updated');
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    downloadImage: function downloadImage() {
      var vm = this;
      this.isLoading = true;
      this.hideForPrint = true;
      var node = document.getElementById('img-node');
      __WEBPACK_IMPORTED_MODULE_8_html_to_image__["a" /* toPng */](node).then(function (dataUrl) {
        vm.isLoading = false;
        vm.hideForPrint = false;
        __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.downloadURI(dataUrl, (vm.selectedCampaign ? vm.selectedCampaign.name : 'campaign-timeline') + '.png');
      }).catch(function (error) {
        vm.isLoading = false;
        vm.hideForPrint = false;
        console.error('oops, something went wrong!', error);
      });
    },
    populateDefaultItems: function populateDefaultItems() {
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].defaultTableItems);
      this.filteredItems = this.resetDateValidators(this.filteredItems);
    },
    resetDateValidators: function resetDateValidators(items) {
      items = items.map(function (d) {
        d.validStartDate = true;
        d.validEndDate = true;
        d.validActivatingDueDate = true;
        d.validPairingDueDate = true;
        return d;
      });

      return items;
    },
    formatDesc: function formatDesc(text) {
      return text.replaceAll('\n', '</br>');
    },
    setDateFromPicker: function setDateFromPicker(item, fieldName, value) {
      var itemIdx = this.filteredItems.indexOf(item);
      this.filteredItems[itemIdx][fieldName] = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      this.checkSaveChangesBtnState();
    },
    checkDate: function checkDate(item, fieldName, validFieldName) {
      item[validFieldName] = false;
      var itemIdx = this.filteredItems.indexOf(item);
      if (__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.isDateFormatValid(item[fieldName]) || !item[fieldName]) {
        item[validFieldName] = true;
      }
      this.filteredItems[itemIdx] = item;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      this.checkSaveChangesBtnState();
    },
    checkSaveChangesBtnState: function checkSaveChangesBtnState() {
      var _this4 = this;

      this.disableSave = false;
      this.filteredItems.map(function (f) {
        if (f.actionType !== _this4.timelineTypes.EMPTY) {
          if (!f.validStartDate || !f.validEndDate || !f.startDate && !f.endDate || (f.actionType === _this4.timelineTypes.ACTIVATING || f.actionType === _this4.timelineTypes.LINEUP) && (!f.validActivatingDueDate || !f.validPairingDueDate)) {
            _this4.disableSave = true;
          }
        }
      });
    },
    addAction: function addAction() {
      var _this5 = this;

      this.filteredItems.push({
        timelineDate: '',
        startDate: '',
        endDate: '',
        actionType: this.timelineTypeLists.find(function (t) {
          return t.value === _this5.timelineTypes.ACTIVATING;
        }),
        actionDesc: '-',
        actionBy: '',
        validStartDate: true,
        validEndDate: true,
        createdAt: __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString()
      });
      this.checkSaveChangesBtnState();
    },
    displayActionType: function displayActionType(actionType) {
      if (actionType.value) {
        var matchType = this.timelineTypeLists.find(function (t) {
          return t.value === actionType.value;
        });
        if (matchType) return matchType.title;
      }
      if (actionType) {
        return actionType;
      }
      return '';
    },
    deleteItem: function deleteItem(item) {
      if (!this.checkDeleteBtnState()) return;
      this.filteredItems.splice(this.filteredItems.indexOf(item), 1);
      this.checkSaveChangesBtnState();
    },
    invokeReviewMeetingUpdated: function invokeReviewMeetingUpdated() {
      this.$emit('updated');
    },
    handleDataTableDragDrop: function handleDataTableDragDrop(items) {
      if (this.viewMode) return;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], items);
    },
    changeActionType: function changeActionType() {
      this.checkSaveChangesBtnState();
    },
    checkDeleteBtnState: function checkDeleteBtnState() {
      var _this6 = this;

      var missingStages = [];
      var validFourStages = this.timelineTypeLists.filter(function (t) {
        return t.value !== _this6.timelineTypes.EMPTY;
      });
      validFourStages = validFourStages.map(function (v) {
        v.count = 0;return v;
      });
      this.filteredItems.map(function (f) {
        var idx = validFourStages.findIndex(function (v) {
          return f.actionType && v.value === f.actionType.value;
        });
        if (idx !== -1) {
          validFourStages[idx].count = 1;
        }
      });
      validFourStages.map(function (v) {
        if (!v.count) missingStages.push(v.title);
      });
      if (missingStages.length) {
        var notifyText = '';
        if (missingStages.length > 1) {
          notifyText = '"' + missingStages.join(', ') + '" stage(s) are missing.';
        } else {
          notifyText = '"' + missingStages.join(', ') + '" stage is missing.';
        }
        notifyText += ' Please complete all stages.';
        this.$swal({
          title: 'Error',
          text: notifyText,
          type: 'error'
        });
        return false;
      }
      return true;
    },
    showActivatingDueDateBox: function showActivatingDueDateBox(item) {
      if (item.actionType && item.actionType.value === this.timelineTypes.ACTIVATING && item.startDate && item.endDate) {
        return true;
      }
      return false;
    },
    showPairingDueDateBox: function showPairingDueDateBox(item) {
      if (item.actionType && item.actionType.value === this.timelineTypes.LINEUP && item.startDate && item.endDate) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AverageBoxes',
  props: ['totalValues']
});

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AverageBoxes__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AverageBoxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AverageBoxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuSummary__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__MenuSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(12);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CogsSummaryDataTable',
  props: ['refresh'],
  components: {
    AverageBoxes: __WEBPACK_IMPORTED_MODULE_8__AverageBoxes___default.a,
    MenuSummary: __WEBPACK_IMPORTED_MODULE_9__MenuSummary___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].summaryTableHeaders,
      summaries: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].defaultSummaries,
      defaultYears: ['All', 2022, 2023, 2024],
      items: [],
      filter: '',
      filteredItems: [],
      AM: [],
      CC: [],
      isLoading: false,
      selectedFilter: {
        AM: '',
        CC: '',
        year: 2024
      },
      totalValues: {
        activating: 0,
        pairing: 0,
        cocreating: 0,
        complete: 0,
        duration: 0
      },
      summaryDetails: {}
    };
  },

  watch: {
    refresh: function refresh(value) {
      if (value) this.init();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
    timelineStages: function timelineStages(state) {
      return state.campaignTimeline.timelineStages;
    },
    timelineSummary: function timelineSummary(state) {
      return state.campaignTimeline.timelineSummary;
    },
    actualDays: function actualDays(state) {
      return state.campaignTimeline.actualDays;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('campaignTimeline', ['getActivatingActualDays', 'getPairingActualDays', 'getCocreatingActualDays', 'getCompleteActualDays']), {
    isAdmin: function isAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _context2.next = 3;
                return _this2.getUsers();

              case 3:
                _context2.next = 5;
                return _this2.getCampaigns();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getCampaigns: function getCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoading = true;
                _context3.next = 3;
                return _this3.$store.dispatch('campaignTimeline/getCampaignTimelineSummary', {
                  filters: {
                    year: _this3.selectedFilter.year
                  }
                });

              case 3:
                if (_this3.timelineSummary) {
                  _this3.items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this3.timelineSummary);
                  _this3.beautifyData();
                  _this3.searchFilter();
                }
                _this3.isLoading = false;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    beautifyData: function beautifyData() {
      var _this4 = this;

      this.items = this.items.filter(function (item) {
        return item.campaign;
      });
      this.items = this.items.map(function (item) {
        if (item.campaign) {
          item.campaignID = item.campaign.id;
          item.name = item.campaign.name || '';
          item.assignedTo = item.campaign.assignedTo || [];
        }
        item.AM = _this4.AM.filter(function (am) {
          return item.campaign.assignedTo && item.campaign.assignedTo.includes(am.id);
        }).map(function (am) {
          return am.name;
        }).join(', ');
        item.CC = _this4.CC.filter(function (cc) {
          return item.campaign.assignedTo && item.campaign.assignedTo.includes(cc.id);
        }).map(function (cc) {
          return cc.name;
        }).join(', ');
        if (item.actualNumOfDaysPerStage) {
          var actualDays = item.actualNumOfDaysPerStage;
          item.activating = actualDays.activating ? actualDays.activating.days : 0;
          item.pairing = actualDays.pairing ? actualDays.pairing.days : 0;
          item.cocreating = actualDays.cocreating ? actualDays.cocreating.days : 0;
          item.complete = actualDays.complete ? actualDays.complete.days : 0;
          item.totalDuration = item.activating + item.pairing + item.cocreating + item.complete;
        }
        return item;
      });
    },
    getUsers: function getUsers() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                response = null;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 4:
                response = _context4.sent;

                if (response) {
                  _this5.AM = response.users;
                  _this5.AM = _this5.AM.map(function (am) {
                    am.name = am.firstName + ' ' + am.lastName;
                    return am;
                  });
                }
                _this5.AM.unshift({ id: '', name: 'All Team' });
                _context4.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 9:
                response = _context4.sent;

                if (response) {
                  _this5.CC = response.users;
                  _this5.CC = _this5.CC.map(function (cc) {
                    cc.name = cc.firstName + ' ' + cc.lastName;
                    return cc;
                  });
                  _this5.CC.unshift({ id: '', name: 'All Team' });
                }
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](0);

                console.log('error', _context4.t0);
                return _context4.abrupt('return', false);

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 13]]);
      }))();
    },
    resetFilter: function resetFilter() {
      this.selectedFilter = {
        campaignType: '',
        AM: '',
        CC: '',
        year: '2024'
      };
      this.filter = '';
      this.searchFilter();
    },
    searchFilter: function searchFilter() {
      var _this6 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.assignedTo && item.assignedTo.includes(_this6.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.assignedTo && item.assignedTo.includes(_this6.selectedFilter.CC);
        });
      }
      this.calAvgSummary();
    },
    formatDecimal: function formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    calAvgSummary: function calAvgSummary() {
      var customItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.totalValues = {
        activating: 0,
        pairing: 0,
        cocreating: 0,
        complete: 0
      };
      var calcItems = [];
      if (customItems.length) {
        calcItems = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], customItems);
      } else {
        calcItems = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
      }
      var totalItems = calcItems.length;
      if (!totalItems) return;
      var activating = 0;
      var pairing = 0;
      var cocreating = 0;
      var complete = 0;
      calcItems.map(function (f) {
        if (f.activating) activating += parseInt(f.activating || 0);
        if (f.pairing) pairing += parseInt(f.pairing || 0);
        if (f.cocreating) cocreating += parseInt(f.cocreating || 0);
        if (f.complete) complete += parseInt(f.complete || 0);
        return f;
      });
      var totalDuration = activating + pairing + cocreating + complete;
      var avgDuration = Number(totalDuration / customItems.length);

      var totalActivating = calcItems.filter(function (c) {
        return c.activating;
      }).length;
      var totalPairing = calcItems.filter(function (c) {
        return c.pairing;
      }).length;
      var totalCocreating = calcItems.filter(function (c) {
        return c.cocreating;
      }).length;
      var totalComplete = calcItems.filter(function (c) {
        return c.complete;
      }).length;

      this.totalValues.activating = Math.round(activating / totalActivating, 0);
      this.totalValues.pairing = Math.round(pairing / totalPairing, 0);
      this.totalValues.cocreating = Math.round(cocreating / totalCocreating, 0);
      this.totalValues.complete = Math.round(complete / totalComplete, 0);
      this.totalValues.duration = Math.round(avgDuration, 0);
    },
    getSummaryDetails: function getSummaryDetails(item, type) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.$store.dispatch('campaignTimeline/getActualDays', {
                  campaignID: item.campaignID,
                  type: type
                });

              case 2:
                result = null;
                _context5.t0 = type;
                _context5.next = _context5.t0 === _this7.timelineStages.activating ? 6 : _context5.t0 === _this7.timelineStages.pairing ? 8 : _context5.t0 === _this7.timelineStages.cocreating ? 10 : _context5.t0 === _this7.timelineStages.complete ? 12 : 14;
                break;

              case 6:
                result = _this7.getActivatingActualDays(_this7.summaries[type], _this7.actualDays);
                return _context5.abrupt('break', 15);

              case 8:
                result = _this7.getPairingActualDays(_this7.summaries[type], _this7.actualDays);
                return _context5.abrupt('break', 15);

              case 10:
                result = _this7.getCocreatingActualDays(_this7.summaries[type], _this7.actualDays);
                return _context5.abrupt('break', 15);

              case 12:
                result = _this7.getCompleteActualDays(_this7.summaries[type], _this7.actualDays);
                return _context5.abrupt('break', 15);

              case 14:
                return _context5.abrupt('break', 15);

              case 15:
                _this7.summaryDetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, result);

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    currentItems: function currentItems() {
      var _this8 = this;

      this.$nextTick(function () {
        _this8.calAvgSummary(_this8.$refs.TimelineSummaryTable.$children[0].filteredItems);
      });
    }
  }
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuSummary',
  props: ['summary']
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cogs-summary',
  components: {
    TimelineSummaryDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CardSummary__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CardSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__CardSummary__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimelineSummaryBoxes',
  components: {
    CardSummary: __WEBPACK_IMPORTED_MODULE_9__CardSummary___default.a
  },
  props: ['campaignID', 'refresh'],
  data: function data() {
    return {
      summaries: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].defaultSummaries
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    campaignDetail: function campaignDetail(state) {
      return state.campaign.campaignDetail;
    },
    reports: function reports(state) {
      return state.campaign.reports;
    },
    detail: function detail(state) {
      return state.campaignTimeline.timelineDetail;
    },
    reviewMeetingDetail: function reviewMeetingDetail(state) {
      return state.campaignTimeline.reviewMeetingDetail;
    },
    savedTimeline: function savedTimeline(state) {
      return state.campaignTimeline.savedTimeline;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('campaignTimeline', ['getActivatingDays', 'getProjectedDaysByStage', 'getPairingDays', 'getCocreatingDays', 'getCompleteDays'])),
  watch: {
    refresh: function refresh(value) {
      if (value) this.getSummaryMain();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getSummaryMain: function getSummaryMain() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('campaign/getCampaignDetail', _this2.campaignID);

              case 2:
                _context2.next = 4;
                return _this2.$store.dispatch('campaignTimeline/getCampaignTimeline', _this2.campaignID);

              case 4:
                _context2.next = 6;
                return _this2.$store.dispatch('campaignTimeline/getReviewMeeting', _this2.campaignID);

              case 6:
                _context2.next = 8;
                return _this2.$store.dispatch('campaign/getReportsByCampaignIDs', [_this2.campaignID]);

              case 8:
                _this2.setActivating();
                _this2.setPairing();
                _this2.setCocreating();
                _this2.setComplete();

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setActivating: function setActivating() {
      var activatingDays = this.getActivatingDays(this.campaignDetail);
      var projectedDays = this.getProjectedDaysByStage(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].timelineTypes.ACTIVATING);
      var activatingDaysDisplay = {
        briefingDays: activatingDays.briefing.days,
        briefingStartDate: activatingDays.briefing.startDate,
        briefingEndDate: activatingDays.briefing.endDate
      };
      this.summaries.activating.projected = projectedDays ? projectedDays + ' days' : 'invalid';
      this.summaries.activating.actual = activatingDaysDisplay.briefingDays ? activatingDaysDisplay.briefingDays + ' days' : 'invalid';
      this.summaries.activating.actualTasks[0].value = activatingDaysDisplay.briefingStartDate ? '' + activatingDaysDisplay.briefingStartDate : 'invalid';
      this.summaries.activating.actualTasks[1].value = activatingDaysDisplay.briefingEndDate ? '' + activatingDaysDisplay.briefingEndDate : 'invalid';
    },
    setPairing: function setPairing() {
      var pairingDays = this.getPairingDays(this.campaignDetail);
      var projectedDays = this.getProjectedDaysByStage(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].timelineTypes.LINEUP);
      var actualDays = 0;
      if (pairingDays.firstPayoutConfirmed.days) actualDays += parseInt(pairingDays.firstPayoutConfirmed.days);
      if (pairingDays.allPayoutConfirmed.days) actualDays += parseInt(pairingDays.allPayoutConfirmed.days);
      this.summaries.pairing.projected = projectedDays ? projectedDays + ' days' : 'invalid';
      this.summaries.pairing.actual = actualDays ? actualDays + ' days' : 'invalid';
      var idx = 0;
      var pairingDaysDisplay = {
        firstPayoutConfirmedStartDate: pairingDays.firstPayoutConfirmed.startDate,
        allPayoutConfirmedStartDate: pairingDays.allPayoutConfirmed.startDate,
        allPayoutConfirmedEndDate: pairingDays.allPayoutConfirmed.endDate };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(pairingDaysDisplay)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          this.summaries.pairing.actualTasks[idx].value = value || value === 0 ? '' + value : 'invalid';
          idx += 1;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    setCocreating: function setCocreating() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var projectedDays, postResp, cocreatingDays, actualDays, idx, cocreatingDaysDisplay, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref3, _ref4, key, value;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                projectedDays = _this3.getProjectedDaysByStage(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].timelineTypes.COCREATING);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__Post_postApi__["a" /* default */].getPost({ campaignId: _this3.campaignID, status: -1 });

              case 3:
                postResp = _context3.sent;
                _context3.next = 6;
                return _this3.getCocreatingDays(postResp.posts || [], _this3.reports);

              case 6:
                cocreatingDays = _context3.sent;
                actualDays = 0;

                if (cocreatingDays.firstContentSubmitted.days) actualDays += parseInt(cocreatingDays.firstContentSubmitted.days);
                if (cocreatingDays.firstReportLive.days) actualDays += parseInt(cocreatingDays.firstReportLive.days);
                if (cocreatingDays.lastReportLive.days) actualDays += parseInt(cocreatingDays.lastReportLive.days);
                _this3.summaries.cocreating.projected = projectedDays ? projectedDays + ' days' : 'invalid';
                _this3.summaries.cocreating.actual = actualDays ? actualDays + ' days' : 'invalid';
                idx = 0;
                cocreatingDaysDisplay = {
                  firstContentSubmittedStartDate: cocreatingDays.firstContentSubmitted.startDate,

                  firstReportLiveStartDate: cocreatingDays.firstReportLive.startDate,

                  lastReportLiveStartDate: cocreatingDays.lastReportLive.startDate,
                  lastReportLiveEndDate: cocreatingDays.lastReportLive.endDate
                };
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 18;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(cocreatingDaysDisplay)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _ref3 = _step2.value;
                  _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                  key = _ref4[0];
                  value = _ref4[1];

                  _this3.summaries.cocreating.actualTasks[idx].value = value || value === 0 ? '' + value : 'invalid';
                  idx += 1;
                }
                _context3.next = 26;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3['catch'](18);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 26:
                _context3.prev = 26;
                _context3.prev = 27;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 29:
                _context3.prev = 29;

                if (!_didIteratorError2) {
                  _context3.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context3.finish(29);

              case 33:
                return _context3.finish(26);

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[18, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    setComplete: function setComplete() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var projectedDays, completeDays, actualDays, idx, completeDaysDisplay, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref5, _ref6, key, value;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                projectedDays = _this4.getProjectedDaysByStage(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].timelineTypes.COMPLETE);
                _context4.next = 3;
                return _this4.getCompleteDays(_this4.reports);

              case 3:
                completeDays = _context4.sent;
                actualDays = 0;

                if (completeDays.reviewDate.days) actualDays += parseInt(completeDays.reviewDate.days);
                _this4.summaries.complete.projected = projectedDays || projectedDays === 0 ? projectedDays + ' days' : 'invalid';
                _this4.summaries.complete.actual = actualDays ? actualDays + ' days' : 'invalid';
                idx = 0;
                completeDaysDisplay = {
                  reviewDateStartDate: completeDays.reviewDate.startDate,
                  reviewDateEndDate: completeDays.reviewDate.endDate
                };
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 13;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(completeDaysDisplay)); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  _ref5 = _step3.value;
                  _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                  key = _ref6[0];
                  value = _ref6[1];

                  _this4.summaries.complete.actualTasks[idx].value = value || value === 0 ? '' + value : 'invalid';
                  idx += 1;
                }
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](13);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t0;

              case 21:
                _context4.prev = 21;
                _context4.prev = 22;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 24:
                _context4.prev = 24;

                if (!_didIteratorError3) {
                  _context4.next = 27;
                  break;
                }

                throw _iteratorError3;

              case 27:
                return _context4.finish(24);

              case 28:
                return _context4.finish(21);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[13, 17, 21, 29], [22,, 24, 28]]);
      }))();
    }
  }
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SummaryBoxes__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SummaryBoxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SummaryBoxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'campaign-timeline',
  components: {
    TimelineDataTable: __WEBPACK_IMPORTED_MODULE_4__DataTable___default.a,
    SummaryBoxes: __WEBPACK_IMPORTED_MODULE_5__SummaryBoxes___default.a
  },
  data: function data() {
    return {
      campaignList: [],
      campaignID: '',
      selectedCampaign: null,
      isRefresh: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTimelineCampaigns();

            case 2:
              if (_this.$route.query.campaignID) {
                _this.campaignID = _this.$route.query.campaignID;
                _this.changeCampaign();
              }

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getTimelineCampaigns: function getTimelineCampaigns() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var statuses;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                statuses = [__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.DRAFT, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.ONGOING, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.COMPLETE];
                _context2.next = 3;
                return _this2.$store.dispatch('campaign/paginateCampaigns', {
                  filters: {
                    per_page: 999,
                    status: statuses.join(','),
                    sort: 'updatedAt DESC'
                  }
                });

              case 3:
                _this2.campaignList = _this2.campaigns.map(function (element) {
                  return {
                    name: element.name,
                    id: element.id
                  };
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeCampaign: function changeCampaign() {
      var _this3 = this;

      this.selectedCampaign = this.campaignList.find(function (c) {
        return c.id === _this3.campaignID;
      });
      this.isRefresh += 1;
    },
    invokeTimelineUpdated: function invokeTimelineUpdated() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    campaignID: String,
    multipleCampaignIds: Array
  },
  data: function data() {
    return {
      valid: true,
      isLoading: false,
      data: {
        quarter: '',
        year: ''
      },
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      quarters: [{
        name: 'Q1',
        title: 'QUARTER 1'
      }, {
        name: 'Q2',
        title: 'QUARTER 2'
      }, {
        name: 'Q3',
        title: 'QUARTER 3'
      }, {
        name: 'Q4',
        title: 'QUARTER 4'
      }],
      MessageRules: [function (value) {
        return !!value || 'Required.';
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    },
    savedCampaignCogs: function savedCampaignCogs(state) {
      return state.campaign.savedCampaignCogs;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  watch: {},
  methods: {
    save: function save() {
      var _this2 = this;

      if (!this.$refs.quarterForm.validate()) {
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var campaignIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, campaignID, campaign, yearQuarter, data;

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result.value) {
                    _context2.next = 38;
                    break;
                  }

                  _this2.isLoading = true;
                  campaignIds = [];

                  if (_this2.multipleCampaignIds && _this2.multipleCampaignIds.length) {
                    campaignIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], _this2.multipleCampaignIds);
                  } else {
                    campaignIds.push(_this2.campaignID);
                  }
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context2.prev = 7;
                  _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(campaignIds);

                case 9:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context2.next = 22;
                    break;
                  }

                  campaignID = _step.value;
                  _context2.next = 13;
                  return __WEBPACK_IMPORTED_MODULE_5__Campaign_campaignAPIs__["a" /* default */].getCampaign(campaignID);

                case 13:
                  campaign = _context2.sent;
                  yearQuarter = '' + _this2.data.year + _this2.data.quarter;

                  if (campaign) {
                    if (campaign.activeYear) {
                      if (Array.isArray(campaign.activeYear)) {
                        if (!campaign.activeYear.includes(_this2.data.year)) {
                          campaign.activeYear.push(_this2.data.year);
                        }
                      }
                    } else {
                      campaign.activeYear = [_this2.data.year];
                    }
                  }
                  data = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                    id: campaign.id,
                    activeYear: campaign.activeYear,
                    yearQuarter: yearQuarter.replace('20', ''),
                    lockedCOGS: true,
                    status: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.REVIEW
                  })];
                  _context2.next = 19;
                  return _this2.$store.dispatch('campaign/updateCampaignByIds', data);

                case 19:
                  _iteratorNormalCompletion = true;
                  _context2.next = 9;
                  break;

                case 22:
                  _context2.next = 28;
                  break;

                case 24:
                  _context2.prev = 24;
                  _context2.t0 = _context2['catch'](7);
                  _didIteratorError = true;
                  _iteratorError = _context2.t0;

                case 28:
                  _context2.prev = 28;
                  _context2.prev = 29;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 31:
                  _context2.prev = 31;

                  if (!_didIteratorError) {
                    _context2.next = 34;
                    break;
                  }

                  throw _iteratorError;

                case 34:
                  return _context2.finish(31);

                case 35:
                  return _context2.finish(28);

                case 36:
                  _this2.isLoading = false;
                  if (_this2.campaignUpdated) {
                    _this2.$emit('updated');
                    _this2.close();
                    _this2.$swal({
                      text: 'Successfully Saved.',
                      type: 'success'
                    });
                  }

                case 38:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[7, 24, 28, 36], [29,, 31, 35]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetForm: function resetForm() {
      this.data = {
        quarter: ''
      };
      this.valid = true;
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    usage: Number,
    used: Number,
    available: Number,
    name: String,
    color: String
  },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_logoDataURL__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewBrandSheetModal',
  props: {
    value: Boolean,
    brandSheetData: Object
  },
  data: function data() {
    return {
      campaignTypes: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].campaignType,
      bfsTypes: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].bfsTypes,
      brandSheetFormSections: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].brandSheetFormSections,
      brandSheetAOKFormSections: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].brandSheetAOKFormSections,
      brandSheetKobeLiteFormSections: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].brandSheetKobeLiteFormSections,
      userGenderDisplay: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userGenderDisplay,
      brandSheetLogo: __WEBPACK_IMPORTED_MODULE_1__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png',
      brandSheet: {}
    };
  },

  computed: {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isUGC: function isUGC() {
      return this.brandSheet.type === this.bfsTypes.UGC || this.brandSheet.ugcVideo;
    },
    isStoryTell: function isStoryTell() {
      return this.brandSheet.type === this.campaignTypes.STORY_TELL;
    },
    isAOK: function isAOK() {
      return this.brandSheet.type === this.campaignTypes.AOK || this.brandSheet.type === this.campaignTypes.Uncut || this.brandSheet.type === this.bfsTypes.AOK;
    },
    isKobeLite: function isKobeLite() {
      return this.brandSheet.type === this.bfsTypes.KOBE_LITE;
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },
    showFieldValue: function showFieldValue(value, name) {
      if (name === 'mobilePhone') {
        return '';
      }
      if (name === 'gender') {
        var result = this.userGenderDisplay.find(function (u) {
          return u.value === value;
        });
        if (result) {
          return result.text;
        }
      }
      if (name === 'mobileCountry') {
        return this.brandSheet.mobilePhone;
      }
      if (name === 'campaignBudget') {
        if (this.brandSheet.budgetCurrency) {
          return this.brandSheet.budgetCurrency + ' ' + this.brandSheet.campaignBudget;
        } else {
          return this.brandSheet.campaignBudget;
        }
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return '-';
        }
        return value.join(', ');
      }
      if (name === 'sampleVideoContent') {
        return value || '';
      }
      return value || '-';
    }
  },
  watch: {
    brandSheetData: function brandSheetData(newBrandSheetData) {
      this.brandSheet = newBrandSheetData;
    }
  }
});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chatbox__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chatbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__chatbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AmCcInputsModal__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AmCcInputsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AmCcInputsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_sources_countries__);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewCampaignModal',
  props: {
    value: Boolean,
    campaignData: Object
  },
  components: {
    AmCcInputsModal: __WEBPACK_IMPORTED_MODULE_11__AmCcInputsModal___default.a,
    chatbox: __WEBPACK_IMPORTED_MODULE_7__chatbox___default.a
  },
  data: function data() {
    return {
      campaign: {},
      campaignModelSections: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignModelSections,
      comments: [],
      commentTitle: 'Comment list',
      campaignAttribute: '',
      sectionName: '',
      currentSectionSelected: null,
      unreadComments: 0,
      copyrightText: 'All Rights Reserved. © Kobe Global Technologies Pte Ltd',
      campaignModelSectionType: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignModelSectionType,
      showBudget: false,
      showVideoBrief: false,
      showEventBrief: false,
      campaignVerticals: [],
      selectedCampaignVertical: [],
      MONTH_FORMAT: 'MMM YYYY',
      amCCInputsDialog: false
    };
  },

  computed: {
    isPendingCampaign: function isPendingCampaign() {
      return this.campaign.status === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL;
    },
    isClient: function isClient() {
      return __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT === this.currentUserRole;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserId: function currentUserId() {
      return this.$store.state.user.id;
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },

    sendComment: function sendComment(comment) {
      var newComment = {
        sectionName: this.sectionName,
        text: comment
      };
      if (!this.isClient) {
        newComment.internal = true;
      }
      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].createComment(this.campaign.id, newComment).then(function (comment) {}).catch(function (error) {
        console.log('error', error);
      });
    },
    viewComments: function viewComments(section) {
      var _this = this;

      if (!section && this.currentSectionSelected) {
        section = this.currentSectionSelected;
      } else if (section) {
        this.currentSectionSelected = section;
      } else {
        return;
      }
      var content = section.content;
      var attributes = [];
      var queryType = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].queryType.EQUAL;
      var sectionName = section.title;
      if (section.type === this.campaignModelSectionType.INFLUENCER_EXPERIENCE) {
        queryType = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].queryType.LIKE;
        attributes = content[0].name;
      } else {
        attributes = content.map(function (item) {
          return item.name;
        });
      }
      var commentConditions = {
        campaignAttribute: attributes,
        sectionName: sectionName,
        queryType: queryType
      };
      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].getComments(this.campaign.id, commentConditions, queryType).then(function (commentList) {
        _this.unreadComments = commentList.length;
        _this.comments = commentList.map(function (comment) {
          var isSelf = false;
          if (_this.currentUserRole === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT) {
            isSelf = comment.createdBy.role === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT;
          } else {
            isSelf = comment.createdBy.role !== __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT;
          }
          return {
            text: comment.text,
            author: comment.createdBy ? comment.createdBy.name : '',
            createdAt: comment.createdAt,
            self: isSelf
          };
        });
        var unreadCommentIds = section.unreadComments.map(function (item) {
          return item.id;
        });
        section.unreadComments = [];
        if (unreadCommentIds.length > 0) {
          _this.markCommentAsRead(unreadCommentIds);
        }
      }).catch(function (error) {
        console.log('error', error);
      });
      this.commentTitle = section.title;
      this.sectionName = sectionName;
      return false;
    },

    markCommentAsRead: function markCommentAsRead(commentIds) {
      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].markCommentAsRead(commentIds).then(function (response) {}).catch(function (error) {
        return console.error(error);
      });
    },

    getUnreadComments: function getUnreadComments() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].getUnreadComments(this.campaign.id).then(function (response) {
        _this2.detectSection(response);
      }).catch(function (error) {
        console.error(error);
      });
    },

    detectSection: function detectSection(comments) {
      var _this3 = this;

      this.campaignModelSections.forEach(function (campaignModel) {
        campaignModel.unreadComments = [];

        var _loop = function _loop(comment) {
          if (comment.sectionName && comment.sectionName === campaignModel.title) {
            campaignModel.unreadComments.push(comment);
          } else {
            var template = campaignModel.title === _this3.campaignModelSectionType.INFLUENCER_EXPERIENCE ? campaignModel.content[0].template : campaignModel.content;
            template.forEach(function (content) {
              if (comment.campaignAttribute && (content.name === comment.campaignAttribute || comment.campaignAttribute.includes(content.name))) {
                campaignModel.unreadComments.push(comment);
              }
            });
          }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(comments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var comment = _step.value;

            _loop(comment);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    constructImageURL: function constructImageURL(imageName) {
      return __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.constructImageURL(imageName);
    },
    getDisplayValueFromSelect: function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(function (option) {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    },
    getCountryDisplayValueFromSelect: function getCountryDisplayValueFromSelect(selectList, value) {
      var countryLists = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_13__static_sources_countries___default.a);
      if (typeof value === 'string') return value;
      var selectedOption = countryLists.filter(function (option) {
        return value.includes(option.code);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.name;
      }).join(', ') : '-';
    },

    toDataURL: function toDataURL(url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var reader = new FileReader();
          reader.onloadend = function () {
            return resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
    },
    savePDF: function savePDF() {
      this.doc = {};
      this.doc = __WEBPACK_IMPORTED_MODULE_10__campaignPDF__["a" /* default */].convertPDFLayout(this.campaignModelSections, this.campaignData, this.showBudget, this.copyrightText);
      var vm = this;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["fonts"] = {
          Arial: {
            normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
            bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
          }
        };
        __WEBPACK_IMPORTED_MODULE_12_pdfmake_build_pdfmake_js__["createPdf"](vm.doc).download(vm.campaignData.name + '.pdf');
      }, 1000);
    },

    hideRequiredActions: function hideRequiredActions() {
      return __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
    },
    getAngleFormat: function getAngleFormat() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        required_action: '',
        image_angle: '',
        content_angle: '',
        sample_images: ''
      });
    },
    checkMediaURL: function checkMediaURL(url) {
      if (url.includes('drive.google.com')) {
        return 'drive';
      }
      return 'link';
    },
    openAMCCInputsDialog: function openAMCCInputsDialog() {
      this.amCCInputsDialog = true;
    }
  },
  watch: {
    campaignData: function campaignData(newCampaignData) {
      var _this4 = this;

      if (!newCampaignData.id) return;
      newCampaignData.angles = __WEBPACK_IMPORTED_MODULE_6__campaignHelper__["a" /* default */].fixAnglesData(newCampaignData.angles);
      if (newCampaignData.goal && Array.isArray(newCampaignData.goal)) {
        newCampaignData.goal = newCampaignData.goal.join(',');
      }

      if (newCampaignData.min_influencer || newCampaignData.max_influencer) {
        newCampaignData.min_content = newCampaignData.min_influencer;
        newCampaignData.max_content = newCampaignData.max_influencer;
        delete newCampaignData.min_influencer;
        delete newCampaignData.max_influencer;
      }

      this.showBudget = newCampaignData.settings ? newCampaignData.settings.showBudgetToClient : newCampaignData.showBudgetToClient;
      this.showVideoBrief = newCampaignData.settings ? newCampaignData.settings.enableVideoBrief : newCampaignData.enableVideoBrief;
      this.showEventBrief = newCampaignData.settings ? newCampaignData.settings.enableEventBrief : newCampaignData.enableEventBrief;
      this.campaignModelSections = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignModelSections;

      if (!this.showVideoBrief) {
        var array = this.campaignModelSections.filter(function (sections) {
          return sections.type !== __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignModelSectionType.VIDEO_BRIEF;
        });
        this.campaignModelSections = array;
      }

      if (!this.showEventBrief) {
        var _array = this.campaignModelSections.filter(function (sections) {
          return sections.type !== __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignModelSectionType.EVENT_BRIEF;
        });
        this.campaignModelSections = _array;
      }

      if (!this.showBudget && __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.CLIENT === this.currentUserRole) {
        var sections = this.campaignModelSections;
        var filteredContent = void 0;
        sections.forEach(function (section, index) {
          if (section.type === _this4.campaignModelSectionType.BUDGET_ALLOCATION) {
            filteredContent = section.content.filter(function (field) {
              return field.name !== 'budget';
            });
            _this4.campaignModelSections[index].content = filteredContent;
          }
        });
        delete this.campaignData.budget;
      }
      newCampaignData.startDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(newCampaignData.startDate).format(this.MONTH_FORMAT);
      newCampaignData.endDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(newCampaignData.endDate).format(this.MONTH_FORMAT);
      this.campaign = newCampaignData;
      this.comments = [];
      this.commentTitle = 'Comment list';
      this.campaignAttribute = '';

      this.getUnreadComments();

      __WEBPACK_IMPORTED_MODULE_5__campaignAPIs__["a" /* default */].getAllCampaignVerticals(false).then(function (response) {
        _this4.campaignVerticals = response.data;
        _this4.selectedCampaignVertical = [];
        if (newCampaignData.vertical) {
          _this4.campaignVerticals.map(function (item) {
            newCampaignData.vertical.map(function (verticalId) {
              if (item.id === verticalId) {
                _this4.selectedCampaignVertical.push(item);
              }
            });
          });
        }
      }).catch(function (error) {
        console.log('error', error);
      });

      this.currentSectionSelected = null;
      setTimeout(function () {
        var divFlexs = document.querySelectorAll('.flex');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(divFlexs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var divFlex = _step2.value;

            if (divFlex.textContent.trim() === '') {
              divFlex.classList.add('is-empty');
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }, 100);
    }
  },
  beforeUpdate: function beforeUpdate() {
    this.doc = __WEBPACK_IMPORTED_MODULE_10__campaignPDF__["a" /* default */].convertPDFLayout(this.campaignModelSections, this.campaignData, this.showBudget, this.copyrightText);
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chatbox__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chatbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chatbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPairingBriefDetailedModal',
  props: ['modalId', 'campaignData', 'rateCardData'],
  components: {
    chatbox: __WEBPACK_IMPORTED_MODULE_3__chatbox___default.a
  },
  data: function data() {
    return {
      campaign: {},
      pairingBriefModelSections: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].pairingBriefModelSections,
      comments: [],
      commentTitle: 'Comment list',
      campaignAttribute: ''
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    enableComment: function enableComment() {
      return this.campaign.status === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL;
    },
    sendComment: function sendComment(comment) {
      var newComment = {
        campaignAttribute: this.campaignAttribute,
        text: comment
      };
      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].createComment(this.campaign.id, newComment).then(function (comment) {}).catch(function (error) {
        console.log('error', error);
      });
    },
    viewComments: function viewComments(fieldPath, fieldName) {
      var _this = this;

      var commentConditions = {
        campaignAttribute: fieldPath
      };
      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getComments(this.campaign.id, commentConditions).then(function (commentList) {
        _this.comments = commentList.map(function (comment) {
          var isSelf = false;
          if (_this.currentUserRole === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT) {
            isSelf = comment.createdBy.role === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT;
          } else {
            isSelf = comment.createdBy.role !== __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT;
          }
          return {
            text: comment.text,
            self: isSelf
          };
        });
      }).catch(function (error) {
        console.log('error', error);
      });

      this.commentTitle = fieldName;
      this.campaignAttribute = fieldPath;
      return false;
    },
    constructImageURL: function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    },
    getDisplayValueFromSelect: function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(function (option) {
        return option.value === value;
      });

      return selectedOption ? selectedOption.text : '-';
    }
  },
  watch: {
    campaignData: function campaignData(newCampaignData) {
      newCampaignData.angles = newCampaignData.angles.map(function (angle) {
        var cpAngle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, angle);
        var sampleImages = angle.sample_images ? angle.sample_images : [];
        if (cpAngle.sample_image) {
          sampleImages.push(cpAngle.sample_image);
        }
        delete cpAngle.sample_images;
        delete cpAngle.sample_image;
        cpAngle.sample_images = sampleImages;
        return cpAngle;
      });
      this.campaign = newCampaignData;
      this.comments = [];
      this.commentTitle = 'Comment list';
      this.campaignAttribute = '';
    }
  }
});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chatbox__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chatbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chatbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPairingBriefModal',
  props: ['modalId', 'campaignData'],
  components: {
    chatbox: __WEBPACK_IMPORTED_MODULE_3__chatbox___default.a
  },
  data: function data() {
    return {
      campaign: {},
      pairingBriefModelSections: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].pairingBriefModelSections,
      comments: [],
      commentTitle: 'Comment list',
      campaignAttribute: '',
      viewPairingBriefSummarisedModalId: 'view_pairing_brief_summarised_modal',
      viewPairingBriefDetailedModalId: 'view_pairing_brief_detailed_modal'
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    enableComment: function enableComment() {
      return this.campaign.status === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL;
    },
    sendComment: function sendComment(comment) {
      var newComment = {
        campaignAttribute: this.campaignAttribute,
        text: comment
      };
      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].createComment(this.campaign.id, newComment).then(function (comment) {}).catch(function (error) {
        console.log('error', error);
      });
    },
    viewComments: function viewComments(fieldPath, fieldName) {
      var _this = this;

      var commentConditions = {
        campaignAttribute: fieldPath
      };
      __WEBPACK_IMPORTED_MODULE_2__campaignAPIs__["a" /* default */].getComments(this.campaign.id, commentConditions).then(function (commentList) {
        _this.comments = commentList.map(function (comment) {
          var isSelf = false;
          if (_this.currentUserRole === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT) {
            isSelf = comment.createdBy.role === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT;
          } else {
            isSelf = comment.createdBy.role !== __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT;
          }
          return {
            text: comment.text,
            self: isSelf
          };
        });
      }).catch(function (error) {
        console.log('error', error);
      });

      this.commentTitle = fieldName;
      this.campaignAttribute = fieldPath;
      return false;
    },
    constructImageURL: function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    },
    getDisplayValueFromSelect: function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(function (option) {
        return option.value === value;
      });

      return selectedOption ? selectedOption.text : '-';
    }
  },
  watch: {
    campaignData: function campaignData(newCampaignData) {
      newCampaignData.angles = newCampaignData.angles.map(function (angle) {
        var cpAngle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, angle);
        var sampleImages = angle.sample_images ? angle.sample_images : [];
        if (cpAngle.sample_image) {
          sampleImages.push(cpAngle.sample_image);
        }
        delete cpAngle.sample_images;
        delete cpAngle.sample_image;
        cpAngle.sample_images = sampleImages;
        return cpAngle;
      });
      this.campaign = newCampaignData;
      this.comments = [];
      this.commentTitle = 'Comment list';
      this.campaignAttribute = '';
    }
  }
});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_sortBy__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPairingElimination',
  props: {
    value: Boolean,
    campaingData: Object
  },
  components: {
    pairingInfluencersTable: __WEBPACK_IMPORTED_MODULE_1__Pairing_PairingDataTable_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      campaign: {},
      sortBy: 'name',
      sortDesc: false,
      items: [],
      allOptions: [],
      pairedInfluencers: [],
      headers: [{
        text: 'Action',
        sortable: false
      }, {
        text: 'InstagramHandle',
        value: 'igHandle'
      }, {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'instagramFullname'
      }, { text: 'Age', value: 'age' }, { text: 'Gender', value: 'gender' }, { text: 'Followers', value: 'totalFollowers' }, { text: 'Engagement Rates', value: 'engagementRate' }, { text: 'Location', value: 'country' }, { text: 'Status', value: 'selected' }]
    };
  },

  watch: {
    campaingData: function campaingData(campaign) {
      this.campaign = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, campaign);
      this.getPairingList();
    }
  },
  computed: {
    termsAndCondition: function termsAndCondition() {
      return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.html;
    }
  },
  methods: {
    eliminationSubmitted: function eliminationSubmitted() {
      this.getPairingList();
      this.close();
    },
    getPairingList: function getPairingList() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(this.campaign.id).then(function (response) {
        if (response.length > 0) {
          var pairedInfluencersRes = response.map(function (element) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.beautifyData(element));
          });
          _this.pairedInfluencers = pairedInfluencersRes.sort(function (a, b) {
            return a.lineUpIndex - b.lineUpIndex;
          });
          _this.allOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.pairedInfluencers);
          _this.changeOption();
          _this.isLoading = false;
        } else {
          _this.pairedInfluencers = [];
          _this.isLoading = false;
        }
      });
    },
    changeOption: function changeOption() {
      var _this2 = this;

      var optionShows = this.allOptions.filter(function (p) {
        if (_this2.optionVal === 0) {
          return !p.options || p.options === _this2.optionVal;
        } else {
          return p.options && p.options === _this2.optionVal;
        }
      });
      this.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], optionShows);
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      inf = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};
      var additionalDetails = data.additional_details || {};
      var payoutDetails = data.payout_details || {};
      inf.remarks = additionalDetails.remarks;
      inf.contentFeature = additionalDetails.contentFeature || '';
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.eliminationReason = data.elimination_details.reason;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.options = data.options || 0;
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram';
      inf.platformName = inf.platformName || inf.platform;
      inf.clientNotes = data.clientNotes ? __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default()(data.clientNotes) : [];
      inf.audience_genders = inf.audience_genders || [];
      inf.topAudAges = [];
      inf.topCountries = [];
      inf.payoutDetails = payoutDetails;
      if (inf.audAges) {
        if (inf.audAges.length > 1) {
          inf.audAges = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(inf.audAges, 'lineupIndex');
          inf.topAudAges = [inf.audAges[0], inf.audAges[1]];
        }
      }
      if (inf.countries) {
        if (inf.countries.length > 1) {
          inf.countries = __WEBPACK_IMPORTED_MODULE_7_lodash_sortBy___default()(inf.countries, 'lineupIndex');
          inf.topCountries = [inf.countries[0], inf.countries[1]];
        }
      }
      return inf;
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(26);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPostModal',
  props: ['modalId', 'campaignData'],
  data: function data() {
    return {
      newPost: {},
      campaign: {},
      sortBy: 'name',
      sortDesc: false,
      fields: [{ key: 'statusDisplay', label: 'Status', sortable: true }, { key: 'description', sortable: true }, { key: 'location', sortable: true }, { key: 'hashtag', sortable: true }, { key: 'imageURL', label: 'Image', sortable: true }, { key: 'instagramURL', label: 'Instagram Url', sortable: true }, { key: 'actions', sortable: false }],
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      showInputUpdateInstagram: '',
      instagramURL: '',
      currentPost: {}
    };
  },

  watch: {
    campaignData: function campaignData(newCampaignData) {
      this.campaign = newCampaignData;

      this.refreshPostList();
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  methods: {
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */]['userPermissions']['post'][type];

      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }

      return false;
    },

    acceptButtonShow: function acceptButtonShow(postStatus) {
      var _rules;

      var rules = (_rules = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.DRAFT, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.AD_STRATEGIST_REJECT, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.CLIENT_PENDING, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.CLIENT_REJECT, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.CLIENT_APPROVE, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.INFLUENCER]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.LIVE, []), _rules);
      return rules[postStatus].includes(this.currentUserRole);
    },
    rejectButtonShow: function rejectButtonShow(postStatus) {
      var _rules2;

      var rules = (_rules2 = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.DRAFT, []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.AD_STRATEGIST_REJECT, []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.CLIENT_PENDING, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.CLIENT]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.CLIENT_REJECT, [__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.CLIENT_APPROVE, []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_rules2, __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.LIVE, []), _rules2);
      return rules[postStatus].includes(this.currentUserRole);
    },
    updateInstagramURLShow: function updateInstagramURLShow(postStatus) {
      return postStatus === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.LIVE;
    },
    createPost: function createPost() {
      var _this = this;

      var form = new FormData();

      form.append('description', this.newPost.description);
      form.append('location', this.newPost.location);
      form.append('hashtag', this.newPost.hashtag);

      if (this.$refs.newPostImage.files.length > 0) {
        form.append('photo', this.$refs.newPostImage.files[0]);
      }

      __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].createPost(this.campaign.id, form).then(function (response) {
        _this.refreshPostList();
        _this.newPost = {};
        _this.$refs.newPostImage.value = '';
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    approvePost: function approvePost(post) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].approvePost(post.id, post.status).then(function (response) {
        _this2.refreshPostList();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    rejectPost: function rejectPost(post) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].rejectPost(post.id, post.status).then(function (response) {
        _this3.refreshPostList();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    showModalUpdateInstagramURL: function showModalUpdateInstagramURL(post) {
      var _this4 = this;

      if (this.showInputUpdateInstagram !== post.id) {
        this.instagramURL = post.instagramURL;
        this.showInputUpdateInstagram = post.id;
      } else {
        __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].updatePost(this.campaign.id, post.id, this.instagramURL).then(function (response) {
          _this4.showInputUpdateInstagram = '';
          _this4.instagramURL = '';
          _this4.refreshPostList();
        }).catch(function (error) {
          console.log('error', error);
        });
      }
    },

    refreshPostList: function refreshPostList() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].getPosts(this.campaign.id).then(function (response) {
        var newItems = response.map(function (post) {
          post.statusDisplay = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatusDisplay[post.status];

          return post;
        });

        _this5.items = newItems;
        _this5.totalRows = _this5.items.length;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    showModalEditPost: function showModalEditPost(post) {
      this.currentPost = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, post);
    },
    editPost: function editPost() {
      var _this6 = this;

      var form = new FormData();

      form.append('description', this.currentPost.description);
      form.append('location', this.currentPost.location);
      form.append('hashtag', this.currentPost.hashtag);

      if (this.$refs.editPostImage.files.length > 0) {
        form.append('photo', this.$refs.editPostImage.files[0]);
      }

      __WEBPACK_IMPORTED_MODULE_3__campaignAPIs__["a" /* default */].editPost(this.campaign.id, this.currentPost.id, form).then(function (response) {
        _this6.refreshPostList();
        _this6.currentPost = {};
        _this6.$refs.editPostImage.value = '';
        _this6.$refs.btnCloseEditPostModal.click();
      }).catch(function (error) {
        _this6.$refs.btnCloseEditPostModal.click();
        console.log('error', error);
      });
    },
    canEditPost: function canEditPost(post) {
      return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].postStatus.AD_STRATEGIST_REJECT === post.status;
    }
  }
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chatBox',
  props: {
    messages: Array,
    title: String,
    readOnly: Boolean
  },
  data: function data() {
    return {
      messageText: ''
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      var message = {
        text: this.messageText,
        createdAt: new Date(),
        author: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.user.firstName,
        self: true
      };
      if (this.messageText === '') {
        this.$swal.fire("Message can't be empty", '', 'error');
      } else {
        this.messages.push(message);
        this.$emit('sendMessage', this.messageText);
        this.messageText = '';
      }
    },
    reloadMessage: function reloadMessage() {
      this.$emit('reloadMessage');
    },
    getRelativeTime: function getRelativeTime(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).fromNow();
    }
  }
});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CreateCampaignModal__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CreateCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__CreateCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__EditCampaignModal__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__EditCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__EditCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ViewCampaignModal__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ViewCampaignModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ViewCampaignModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ReleaseToCcModal__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ReleaseToCcModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ReleaseToCcModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ReleaseToAdminModal__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ReleaseToAdminModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__ReleaseToAdminModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BriefReleaseChecklistModal__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BriefReleaseChecklistModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__BriefReleaseChecklistModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PairingInfluencer_ViewPairingModal__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PairingInfluencer_ViewPairingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__PairingInfluencer_ViewPairingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ViewBrandSheetModal__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ViewBrandSheetModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ViewBrandSheetModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PairingInfluencer_PayoutConfirmModal__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PairingInfluencer_PayoutConfirmModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__PairingInfluencer_PayoutConfirmModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PairingInfluencer_InvoicesBriefViewModal__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PairingInfluencer_InvoicesBriefViewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__PairingInfluencer_InvoicesBriefViewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ViewPairingInfluencerElimination__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ViewPairingInfluencerElimination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ViewPairingInfluencerElimination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ViewPostModal__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ViewPostModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ViewPostModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ViewPairingBriefModal__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ViewPairingBriefModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ViewPairingBriefModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__EditPairingBriefModal__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__EditPairingBriefModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__EditPairingBriefModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PairingInfluencer_InfluencerDetailViewModal__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PairingInfluencer_InfluencerDetailViewModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__PairingInfluencer_InfluencerDetailViewModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AllCampaignsReport_AllReportsPasscodeModal__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AllCampaignsReport_AllReportsPasscodeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__AllCampaignsReport_AllReportsPasscodeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ChangeCampaignStatusModal__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ChangeCampaignStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__ChangeCampaignStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__AmCcInputsModal__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__AmCcInputsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__AmCcInputsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__editor_generator_blocksToHtml__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CampaignSettingsModal__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CampaignSettingsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__CampaignSettingsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__static_sources_countries__);



















































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Campaign',
  components: {
    CreateCampaignModal: __WEBPACK_IMPORTED_MODULE_19__CreateCampaignModal___default.a,
    EditCampaignModal: __WEBPACK_IMPORTED_MODULE_20__EditCampaignModal___default.a,
    ViewCampaignModal: __WEBPACK_IMPORTED_MODULE_21__ViewCampaignModal___default.a,
    ViewPairingBriefModal: __WEBPACK_IMPORTED_MODULE_31__ViewPairingBriefModal___default.a,
    EditPairingBriefModal: __WEBPACK_IMPORTED_MODULE_32__EditPairingBriefModal___default.a,
    ViewPairingModal: __WEBPACK_IMPORTED_MODULE_25__PairingInfluencer_ViewPairingModal___default.a,
    ViewBrandSheetModal: __WEBPACK_IMPORTED_MODULE_26__ViewBrandSheetModal___default.a,
    PayoutConfirmModal: __WEBPACK_IMPORTED_MODULE_27__PairingInfluencer_PayoutConfirmModal___default.a,
    influencerDetailModal: __WEBPACK_IMPORTED_MODULE_33__PairingInfluencer_InfluencerDetailViewModal___default.a,
    ChangeStatusModal: __WEBPACK_IMPORTED_MODULE_36__ChangeCampaignStatusModal___default.a,
    InfluencerElimination: __WEBPACK_IMPORTED_MODULE_29__ViewPairingInfluencerElimination___default.a,
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_30__ViewPostModal___default.a,
    CampaignSettings: __WEBPACK_IMPORTED_MODULE_39__CampaignSettingsModal___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_35__scoped_custom_SocialHandle___default.a,
    AllReportsPasscodeModal: __WEBPACK_IMPORTED_MODULE_34__AllCampaignsReport_AllReportsPasscodeModal___default.a,
    ReleaseToCcModal: __WEBPACK_IMPORTED_MODULE_22__ReleaseToCcModal___default.a,
    ReleaseToAdminModal: __WEBPACK_IMPORTED_MODULE_23__ReleaseToAdminModal___default.a,
    AmCcInputsModal: __WEBPACK_IMPORTED_MODULE_37__AmCcInputsModal___default.a,
    BriefReleaseChecklistModal: __WEBPACK_IMPORTED_MODULE_24__BriefReleaseChecklistModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_45__components_scoped_custom_TableColsShowHideModal___default.a,
    InvoicesBriefViewModal: __WEBPACK_IMPORTED_MODULE_28__PairingInfluencer_InvoicesBriefViewModal___default.a
  },
  data: function data() {
    return {
      createModalDialog: false,
      editModalDialog: false,
      viewInfluencerDialog: false,
      viewInfluencerAdminDialog: false,
      payoutConfirmDialog: false,
      invoiceUploadDialog: false,
      pairedInfluencers: [],
      viewModalDialog: false,
      viewPairingModalDialog: false,
      viewBrandSheetModalDialog: false,
      allReportsPasscodeDialog: false,
      payoutConfirmData: {},
      eliminationDialog: false,
      viewPairingModalId: 'view_pairing_modal',
      editPairingBriefModalId: 'edit_pairing_brief_modal',
      viewPairingBriefModalId: 'view_pairing_brief_modal',
      viewPostModalId: 'view_post_modal',
      viewCampaignId: null,
      editCampaignId: null,
      viewCampaignData: null,
      campaingDataForElimination: null,
      viewPairingCampaignData: null,
      viewPostCampaignData: null,
      campaignSettingsDialog: false,
      colSettingsDialog: false,
      invoicesBriefViewDialog: false,
      colStatuses: {},
      tableColsItems: [],
      userProfile: {},
      sortBy: 'name',
      sortDesc: false,
      allClients: [],
      loading: false,
      headers: [{
        text: 'Billing Name as per Xero',
        value: 'clientName'
      }, {
        text: 'Campaign Name',
        value: 'name'
      }, {
        text: 'Campaign Type',
        value: 'campaignType'
      }, {
        text: 'IO Number',
        value: 'ioNumbers'
      }, {
        text: 'Budget',
        value: 'budget'
      }, {
        text: 'COGS Capped',
        value: 'target'
      }, {
        text: 'COGS Current',
        value: 'cogs'
      }, {
        text: 'COGS %',
        value: 'cogsPercentage'
      }, {
        text: 'AM',
        value: 'AM'
      }, {
        text: 'CC',
        value: 'CO'
      }, {
        text: 'Updated On',
        value: 'updatedAtDisplay'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      clientHeaders: [{
        text: 'Campaign Name',
        value: 'name'
      }, {
        text: 'Updated On',
        value: 'updatedAtDisplay'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      allCampaignHeaders: [{
        text: 'IO Number',
        value: 'ioNumbers'
      }, {
        text: 'Billing Name as per Xero',
        value: 'clientName'
      }, {
        text: 'Campaign Name',
        value: 'name'
      }, {
        text: 'Campaign Type',
        value: 'campaignType'
      }, {
        text: 'Country (Location)',
        value: 'countryDisplay'
      }, {
        text: 'Vertical',
        value: 'vertical'
      }, {
        text: 'Budget',
        value: 'budget'
      }, {
        text: 'COGS Capped',
        value: 'target'
      }, {
        text: 'COGS Current',
        value: 'cogs'
      }, {
        text: 'COGS %',
        value: 'cogsPercentage'
      }, {
        text: 'Stage',
        value: 'campaignStatusDisplay'
      }, {
        text: 'AM',
        value: 'AM'
      }, {
        text: 'CC',
        value: 'CO'
      }, {
        text: 'Campaign Period',
        value: 'campaignPeriod'
      }, {
        text: 'Start Month',
        value: 'startMonth'
      }, {
        text: 'End Month',
        value: 'endMonth'
      }, {
        text: 'First Post Date',
        value: 'firstPostDate'
      }, {
        text: 'Last Post Date',
        value: 'lastPostDate'
      }, {
        text: 'Updated On',
        value: 'updatedAtDisplay'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      AM: [],
      CO: [],
      campaignVerticals: [],
      verifiedFilters: ['All', 'Verified Payouts'],
      selectedFilter: {
        campaignType: '',
        vertical: '',
        targetLocation: '',
        AM: '',
        CO: '',
        client: '',
        stage: 'All',
        verified: 'All',
        searchStartMonth: '',
        searchLastMonth: '',
        htmlReport: false,
        archive: true
      },
      items: [],
      filteredItems: [],
      pagination: {
        rowsPerPage: 15
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      filter: '',
      campaignStatuses: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus,
      pairingStatusDisplay: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].pairingStatusDisplay,
      payoutStatusDisplay: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].payoutStatusDisplay,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].payoutStatus,
      campaignModelSections: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignModelSections,
      campaignModelSectionType: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignModelSectionType,
      campaignStageDisplay: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignStageDisplay,
      campaignStage: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignStage,
      campaignTypeDisplayFilter: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignTypeDisplay,
      targetLocationDisplayFilter: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].targetAudienceDisplay.LOCATION,
      tableActions: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].tableActions,
      showBudget: false,
      showVideoBrief: false,
      showEventBrief: false,
      copyrightText: 'All Rights Reserved. © Kobe Global Technologies Pte Ltd',
      campaignCOEB: {},
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0,
        invitedTotal: 0,
        invitedOutreach: 0,
        invitedEngagement: 0,
        invitedBudget: 0,
        notInvitedTotal: 0,
        notInvitedOutreach: 0,
        notInvitedEngagement: 0,
        notInvitedBudget: 0
      },
      brandSheets: [],
      invoiceDownload: false,
      invoiceDialog: false,
      influencer: '',
      influencerProfile: '',
      briefDetailContent: {
        time: Date.now(),
        blocks: []
      },
      selectedTab: '',
      loadingDialog: false,
      payoutSubmittedPairings: [],
      pairedHeaders: [{
        text: 'Handle',
        value: 'instagramHandle'
      }, {
        text: 'Followers',
        value: 'followers'
      }, {
        text: 'Eng. Rate',
        value: 'engagement_rate'
      }, {
        text: 'Aud. Cred',
        value: 'audience_credibility'
      }, {
        text: 'Deliverable Details',
        value: 'deliverables'
      }, {
        text: 'Status',
        value: 'payoutStatus'
      }, {
        text: 'Payout Amount',
        value: 'payoutAmount'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      pairedFilter: {
        payoutStatus: '',
        search: ''
      },
      pairedFilterItems: [],
      campaignDataForStatusChange: null,
      campaignDataForSubmitDraft: null,
      campaignDataForAccept: null,
      campaignDataForRelease: null,
      selectedCampaigns: [],
      selectedCampaignIds: [],
      campaignClient: {},
      releaseToCCDialog: false,
      releaseToAdminDialog: false,
      changeStatusDialog: false,
      amCCInputsDialog: false,
      briefReleaseChecklistDialog: false,
      countries: [],
      startMonthPicker: false,
      selectedStartMonth: '',
      endMonthPicker: false,
      selectedEndMonth: '',
      downloadReportType: '',
      exportType: '',
      isUnlockCogs: false,
      showActionsColumn: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    campaignUpdated: function campaignUpdated(state) {
      return state.campaign.campaignUpdated;
    },

    reports: function reports(state) {
      return state.campaign.reports;
    },
    influencers: function influencers(state) {
      return state.influencer.influencers;
    }
  }), {
    computedAllCampaignHeaders: function computedAllCampaignHeaders() {
      var _this = this;

      var allCampaignCols = null;
      var headers = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], this.allCampaignHeaders);

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.allCampaignCols) {
          allCampaignCols = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.allCampaignCols);
        }
      }
      if (allCampaignCols) {
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, allCampaignCols);
      } else {
        headers.map(function (header) {
          _this.colStatuses[header.value] = true;
        });
      }
      return headers.filter(function (h) {
        if (h.value === 'action') {
          return _this.showActionsColumn;
        }
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    computedCampaignHeaders: function computedCampaignHeaders() {
      var headers = this.isNotClientRole ? this.headers : this.clientHeaders;
      return this.showActionsColumn ? headers : headers.filter(function (header) {
        return header.value !== 'action';
      });
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.lastUpdate).fromNow();
    },
    editPairingBriefModalIdDisplay: function editPairingBriefModalIdDisplay() {
      return '#' + this.editPairingBriefModalId;
    },
    viewPairingBriefModalIdDisplay: function viewPairingBriefModalIdDisplay() {
      return '#' + this.viewPairingBriefModalId;
    },
    viewPostModalIdDisplay: function viewPostModalIdDisplay() {
      return '#' + this.viewPostModalId;
    },
    campaignStatus: function campaignStatus() {
      return this.$route.meta.campaignStatus;
    },
    isArchive: function isArchive() {
      return this.$route.meta.archive || false;
    },
    campaignActivationStatusConfig: function campaignActivationStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignActivationStatus;
    },
    isNotClientRole: function isNotClientRole() {
      return Number(this.$store.state.user.role) !== __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.CLIENT;
    },
    budget: function budget() {
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaignCOEB.budget * 0.3);
    },
    markupCOGSAmount: function markupCOGSAmount() {
      var _this2 = this;

      var campaignClient = this.allClients.find(function (client) {
        return client.id === _this2.campaignCOEB.clientID;
      });
      return __WEBPACK_IMPORTED_MODULE_15__campaignHelper__["a" /* default */].getMarkupCOGS(this.campaignCOEB.ioNumbers, campaignClient);
    },
    showConfirmPayout: function showConfirmPayout() {
      return __WEBPACK_IMPORTED_MODULE_15__campaignHelper__["a" /* default */].isAOKCampaign(this.campaignCOEB.campaignType);
    },
    payoutStatusOptions: function payoutStatusOptions() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(this.payoutStatusDisplay).forEach(function (item) {
        data.push({
          status: item[0],
          display: item[1]
        });
      });
      data.unshift({
        status: '',
        display: 'All'
      });
      return data;
    }
  }),
  watch: {
    campaignStatus: function campaignStatus(newCampaignStatus) {
      this.paginate(1);
    },
    isArchive: function isArchive(newValue) {
      this.paginate(1);
    },
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    },

    pagination: {
      handler: function handler() {
        this.currentPage = this.pagination.page;
      },

      deep: true
    }
  },
  methods: {
    constructImageURL: function constructImageURL(imageName) {
      return __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.constructImageURL(imageName);
    },
    getDisplayValueFromSelect: function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(function (option) {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    },

    toDataURL: function toDataURL(url) {
      return fetch(url).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        return new __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var reader = new FileReader();
          reader.onloadend = function () {
            return resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      });
    },
    checkForVendorFormComplete: function checkForVendorFormComplete() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_18__Client_clientAPIs__["a" /* default */].getClient(this.user.clientID).then(function (response) {
        var client = response;
        if (!client.acceptTerms) {
          _this3.$swal({
            title: 'Complete the Vendor Creation Form',
            type: 'info',
            text: 'You need to complete the vendor creation form and accept the terms to continue.'
          }).then(function () {
            return _this3.$router.push({ path: '/client/vendor-creation-form' });
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    startEliminate: function startEliminate(campaignID) {
      var _this4 = this;

      this.$swal({
        title: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.title,
        html: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.html,
        type: 'info',
        width: 500,
        backdrop: 'rgba(0,0,1, 0.9)',
        showCancelButton: true,
        confirmButtonText: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.confirmButtonText,
        cancelButtonText: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.pairingTermsAndCondition.cancelButtonText,
        allowOutsideClick: false
      }).then(function (result) {
        if (!result.value) {
          _this4.eliminationDialog = false;
        } else {
          __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
            _this4.campaingDataForElimination = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, response);
            _this4.eliminationDialog = true;
          }).catch(function (error) {
            _this4.eliminationDialog = false;
            console.log('error', error);
          });
        }
      });
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */]['userPermissions']['campaign'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }
      return false;
    },
    buttonShowPairing: function buttonShowPairing(pairingStatus) {
      if (pairingStatus === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].pairingStatus.INVITED) {
        return true;
      }
      return false;
    },
    buttonShowBrandSheet: function buttonShowBrandSheet(item) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */]['userPermissions']['campaign']['viewBrandFactSheet'];
      var hasBrandSheet = this.brandSheets.some(function (b) {
        return b.campaignID === item.id;
      });
      if (buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(item.status) && hasBrandSheet) {
        return true;
      }
      return false;
    },
    buttonPayoutViewShow: function buttonPayoutViewShow(item) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */]['userPermissions']['campaign']['viewPayout'];
      if (buttonPermission.userRoles.includes(this.currentUserRole) && item.payoutVerified !== undefined) {
        return true;
      }
      return false;
    },
    reload: function reload() {
      this.paginate(1);
    },
    updateItems: function updateItems(response) {
      var _this5 = this;

      var campaigns = response.campaigns;
      campaigns = campaigns.map(function (item) {
        item.campaignType = _this5.getProductName(item.campaignType);
        item.vertical = _this5.formatCampaignVerticals(item);
        item.verticalDisplay = item.vertical.map(function (v) {
          return v.name || '';
        }).join(', ');
        item.countryDisplay = _this5.getCountryDisplayValueFromSelect(item.targetLocation || []);
        item.campaignStatusDisplay = _this5.getStageName(item.status);
        item.updatedAtDisplay = _this5.formatTime(item.updatedAt);
        item.clientName = _this5.getClientName(item.clientID);
        item.AM = _this5.AM.filter(function (am) {
          return item.assignedTo && item.assignedTo.includes(am.id);
        }).map(function (am) {
          return am.name;
        }).join(', ');
        item.CO = _this5.CO.filter(function (co) {
          return item.assignedTo && item.assignedTo.includes(co.id);
        }).map(function (co) {
          return co.name;
        }).join(', ');

        item.payoutStatus = item.payoutStatus || '';
        if (item.payoutStatus && item.payoutStatus === _this5.payoutStatus.CONFIRMED) {
          item.payoutStatusDisplay = _this5.payoutStatusDisplay[item.payoutStatus];
        } else {
          item.payoutStatusDisplay = 'Pending Payout';
        }

        return item;
      });

      this.items = campaigns;
      this.searchFilter();
      this.totalRows = this.filteredItems.length;
      this.getReportsByCampaignIDs(campaigns);
    },
    paginate: function paginate() {
      var _this6 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.clearSelectedCampaigns();
      this.currentPage = page;
      this.loading = true;
      if (this.isArchive) this.selectedFilter.archive = false;
      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].paginate({
        page: page,
        status: this.campaignStatus,
        archive: this.isArchive,
        includeArchive: this.selectedFilter.archive,

        sort: 'updatedAt DESC'
      }).then(function (response) {
        _this6.loading = false;
        _this6.updateItems(response);
        _this6.checkShowURLParam();
      }).catch(function (error) {
        _this6.loading = false;
        console.log('error', error);
      });
    },
    searchFilter: function searchFilter() {
      var _this7 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.assignedTo && item.assignedTo.includes(_this7.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CO) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.assignedTo && item.assignedTo.includes(_this7.selectedFilter.CO);
        });
      }
      if (this.selectedFilter.client) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.clientID && item.clientID === _this7.selectedFilter.client;
        });
      }
      if (this.selectedFilter.campaignType) {
        if (this.selectedFilter.campaignType === -1) {
          this.filteredItems = this.filteredItems.filter(function (item) {
            if (item.campaignType) {
              return !_this7.campaignTypeDisplayFilter.some(function (v) {
                return item.campaignType.includes(v.value);
              });
            } else return true;
          });
          this.filteredItems = this.filteredItems.filter(function (item) {
            return !item.campaignType;
          });
        } else {
          this.filteredItems = this.filteredItems.filter(function (item) {
            return item.campaignType && item.campaignType === _this7.selectedFilter.campaignType;
          });
        }
      }
      if (this.selectedFilter.vertical) {
        if (this.selectedFilter.vertical === -1) {
          this.filteredItems = this.filteredItems.filter(function (item) {
            var filterVerticals = [];
            if (Array.isArray(item.vertical)) {
              filterVerticals = item.vertical.map(function (v) {
                return v.id;
              });
            }
            if (filterVerticals) {
              return !_this7.campaignVerticals.some(function (v) {
                return filterVerticals.includes(v.id);
              });
            } else return true;
          });
        } else {
          this.filteredItems = this.filteredItems.filter(function (item) {
            var filterVerticals = [];
            if (Array.isArray(item.vertical)) {
              filterVerticals = item.vertical.map(function (v) {
                return v.id;
              });
            }
            return filterVerticals && filterVerticals.includes(_this7.selectedFilter.vertical);
          });
        }
      }
      if (this.selectedFilter.targetLocation) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.targetLocation && item.targetLocation.includes(_this7.selectedFilter.targetLocation);
        });
      }

      if (this.selectedFilter.stage) {
        var stage = this.selectedFilter.stage;
        this.filteredItems = this.filteredItems.filter(function (item) {
          if (stage === _this7.campaignStage.ALL) {
            return true;
          }

          if (stage === _this7.campaignStage.ACTIVATING) {
            if (item.status === _this7.campaignStatuses.DRAFT || item.status === _this7.campaignStatuses.PENDING_CLIENT_APPROVAL) {
              return true;
            }
          }

          if (stage === _this7.campaignStage.PAIRING) {
            if (item.status === _this7.campaignStatuses.PAIRING_BRIEF || item.status === _this7.campaignStatuses.PAIRING_INFLUENCER || item.status === _this7.campaignStatuses.RATE_CARD) {
              return true;
            }
          }

          if (stage === _this7.campaignStage.COCREATING && item.status === _this7.campaignStatuses.ONGOING) {
            return true;
          }

          if (stage === _this7.campaignStage.REVIEW && item.status === _this7.campaignStatuses.REVIEW) {
            return true;
          }

          if (stage === _this7.campaignStage.COMPLETE && item.status === _this7.campaignStatuses.COMPLETE) {
            return true;
          }
          return false;
        });
      }

      if (this.selectedFilter.verified === 'Verified Payouts') {
        var campaignIDs = this.payoutSubmittedPairings.map(function (p) {
          return p.campaignID;
        });
        this.filteredItems = this.filteredItems.filter(function (item) {
          return campaignIDs.includes(item.id);
        });
      }

      if (this.selectedFilter.searchStartMonth) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          if (item.firstPostDate) {
            var firstPostDate = __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.parseDate(item.firstPostDate);
            if (firstPostDate >= _this7.selectedFilter.searchStartMonth) return true;
          }
          return false;
        });
      }

      if (this.selectedFilter.searchLastMonth) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          if (item.lastPostDate) {
            var lastPostDate = __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.parseDate(item.lastPostDate);
            if (lastPostDate <= _this7.selectedFilter.searchLastMonth) return true;
          }
          return false;
        });
      }

      if (this.selectedFilter.htmlReport) {
        var rptCampaignIDs = this.reports.map(function (rpt) {
          return rpt.campaignID;
        });
        this.filteredItems = this.filteredItems.filter(function (item) {
          if (rptCampaignIDs.includes(item.id)) {
            return true;
          }
          return false;
        });
      }
    },
    pairingSearchFilter: function pairingSearchFilter() {
      var _this8 = this;

      this.pairedFilterItems = this.pairedInfluencers.map(function (i) {
        return i;
      });
      if (this.pairedFilter.payoutStatus) {
        this.pairedFilterItems = this.pairedFilterItems.filter(function (item) {
          return parseInt(item.payoutStatus) === parseInt(_this8.pairedFilter.payoutStatus);
        });
      }
    },
    createCampaign: function createCampaign(campaignData) {
      this.paginate(1);
    },
    clearSelectedCampaigns: function clearSelectedCampaigns() {
      this.selectedCampaigns = [];
      this.selectedCampaignIds = [];
    },
    deleteCampaign: function deleteCampaign(campaignID) {
      var _this9 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the campaign?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].deleteCampaign(campaignID).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this9.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this9.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this9.items = _this9.items.filter(function (campaign) {
            return campaign.id !== campaignID;
          });

          _this9.$swal({
            title: 'Deleted',
            text: 'The campaign has been deleted successfully',
            type: 'success'
          });
        } else {}
      });
    },
    deleteBulkCampaigns: function deleteBulkCampaigns(campaignIds) {
      var _this10 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaigns will be deleted',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].deleteBulkCampaigns(campaignIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this10.$swal({
              title: 'Error in deleting Campaign, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this10.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this10.$swal({
            title: 'Success',
            text: 'Successfully Deleted',
            type: 'success'
          });

          _this10.$emit('input');
          _this10.paginate(1);
        } else {}
      });
    },
    archiveCampaign: function archiveCampaign(campaignIds) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this11.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to archive?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                    var data;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!result.value) {
                              _context.next = 10;
                              break;
                            }

                            data = campaignIds.map(function (campaignID) {
                              return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
                                id: campaignID,
                                archive: true
                              });
                            });
                            _context.next = 4;
                            return _this11.$store.dispatch('campaign/updateCampaignByIds', data);

                          case 4:
                            _this11.isLoading = false;

                            if (_this11.campaignUpdated) {
                              _context.next = 8;
                              break;
                            }

                            _this11.$swal({
                              text: 'Error Archiving Campaigns.',
                              type: 'error'
                            });
                            return _context.abrupt('return');

                          case 8:
                            _this11.$swal({
                              text: 'Successfully Archived.',
                              type: 'success'
                            });
                            _this11.paginate(1);

                          case 10:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this11);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this11);
      }))();
    },
    getPairedInfluencers: function getPairedInfluencers(campaign) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var campaignResp, pairingResp, items, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, inf, invitedItems, notInvitedItems;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaign.id);

              case 2:
                campaignResp = _context3.sent;

                if (campaignResp) {
                  _this12.campaignCOEB = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
                    id: campaignResp.id,
                    campaignId: campaignResp.id,
                    campaignName: campaignResp.name,
                    campaignType: campaignResp.campaignType,
                    companyID: campaignResp.companyID,
                    clientID: campaignResp.clientID,
                    ioNumbers: campaignResp.ioNumbers,
                    campaignOutreach: campaignResp.outreach,
                    campaignEngagement: campaignResp.engagement,
                    campaignBudget: campaignResp.budget,
                    max_content: campaignResp.max_content,
                    min_content: campaignResp.min_content,
                    outreach: campaignResp.outreach,
                    engagement: campaignResp.engagement,
                    budget: campaignResp.budget
                  });
                }
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_40__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaign.id);

              case 6:
                pairingResp = _context3.sent;

                if (!pairingResp) {
                  _context3.next = 35;
                  break;
                }

                items = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 12;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(pairingResp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  inf = _this12.beautifyData(data);

                  if (inf.pairingStatus === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].pairingStatus.ACCEPTED) {
                    items.push(inf);
                  }
                }
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context3.prev = 23;

                if (!_didIteratorError) {
                  _context3.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context3.finish(23);

              case 27:
                return _context3.finish(20);

              case 28:
                _this12.pairedInfluencers = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], items);
                _this12.campaignMeasurement(items);
                invitedItems = items.filter(function (e) {
                  return e.pairingStatus !== __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this12.campaignMeasurementInvited(invitedItems);

                notInvitedItems = items.filter(function (e) {
                  return e.pairingStatus === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].pairingStatus.ELIMINATION_PENDING;
                });

                _this12.campaignMeasurementNotInvited(notInvitedItems);
                if (_this12.isNotClientRole) {
                  _this12.pairingSearchFilter();
                  _this12.viewInfluencerAdminDialog = true;
                } else {
                  _this12.viewInfluencerDialog = true;
                }

              case 35:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this12, [[12, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    campaignMeasurement: function campaignMeasurement(items) {
      var _this13 = this;

      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      items.map(function (item) {
        _this13.measurement.total += Number(_this13.calculateContents(item));
        _this13.measurement.outreach += Number(_this13.calculateOutreach(item));
        _this13.measurement.engagement += Number(_this13.calculateEngagement(item));
        _this13.measurement.budget += Number(item.payout || 0);
      });
      var content = this.measurement.total / (this.campaignCOEB.min_content || this.campaignCOEB.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaignCOEB.outreach * 100).toFixed(2);
      this.measurement.engagementPercentage = (this.measurement.engagement / this.campaignCOEB.engagement * 100).toFixed(2);
      this.measurement.cogsPercentage = (this.measurement.budget / this.budget * 100).toFixed(2);
    },
    campaignMeasurementInvited: function campaignMeasurementInvited(items) {
      var _this14 = this;

      this.measurement.invitedTotal = 0;
      items.map(function (item) {
        _this14.measurement.invitedTotal += Number(_this14.calculateContents(item));
        _this14.measurement.invitedOutreach += Number(_this14.calculateOutreach(item));
        _this14.measurement.invitedEngagement += Number(_this14.calculateEngagement(item));
        _this14.measurement.invitedBudget += Number(item.payout || 0);
      });
    },
    campaignMeasurementNotInvited: function campaignMeasurementNotInvited(items) {
      var _this15 = this;

      this.measurement.notInvitedTotal = 0;
      items.map(function (item) {
        _this15.measurement.notInvitedTotal += Number(_this15.calculateContents(item));
        _this15.measurement.notInvitedOutreach += Number(_this15.calculateOutreach(item));
        _this15.measurement.notInvitedEngagement += Number(_this15.calculateEngagement(item));
        _this15.measurement.notInvitedBudget += Number(item.payout || 0);
      });
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    calculateEngagement: function calculateEngagement(item) {
      var engagement = item.engagement;
      return (engagement || 0) * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels);
    },
    beautifyData: function beautifyData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};
      inf = data.influencer_details;
      inf.influencer_details = __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.refreshJSON(influencerDetails);
      inf.pairing_details = data.pairing_details;
      inf.elimination_details = data.elimination_details;
      inf.pairingStatus = data.pairing_details.status;
      inf.eliminationStatus = data.elimination_details.status;
      inf.remarks = data.additional_details ? data.additional_details.remarks : '';
      inf.CampaignID = this.campaignCOEB ? this.campaignCOEB.campaignId : '';
      inf.CampaignName = this.campaignCOEB ? this.campaignCOEB.campaignName : '';
      inf.pairingID = data.id;
      inf.id = data.id;
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_igTv = deliverablesDetails.no_of_igTv || 0;
      inf.instagramFullname = influencerDetails.fullname;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate || 0;
      inf.deliverables = __WEBPACK_IMPORTED_MODULE_15__campaignHelper__["a" /* default */].getDeliverableDetails(deliverablesDetails);
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
        inf.history = data.payout_details.history ? __WEBPACK_IMPORTED_MODULE_44_lodash_reverse___default()(data.payout_details.history) : [];
        inf.payoutStatus = data.payout_details.status || 0;
        if (inf.payoutStatus === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].payoutStatus.SUBMITTED) {
          inf.payoutSubmitted = true;
        }
        if (inf.payoutStatus >= __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].payoutStatus.CONFIRMED) {
          inf.payoutVerified = true;
        }
      }
      if (data.brief_details) {
        inf.brief_details = data.brief_details;
      }
      return inf;
    },
    getCampaignDataToEdit: function getCampaignDataToEdit(campaignID) {
      this.editCampaignId = campaignID;
      this.editModalDialog = true;
    },
    changeSettings: function changeSettings(item) {
      this.viewCampaignData = item;
      this.campaignSettingsDialog = !this.campaignSettingsDialog;
    },
    viewCampaignByClient: function viewCampaignByClient(campaignID) {
      var _this16 = this;

      if (this.campaignStatus === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL) {
        this.$swal({
          title: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.termsAndCondition.title,
          html: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.termsAndCondition.html,
          type: 'info',
          width: 500,
          backdrop: 'rgba(0,0,1, 0.9)',
          showCancelButton: true,
          confirmButtonText: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.termsAndCondition.confirmButtonText,
          cancelButtonText: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.termsAndCondition.cancelButtonText,
          allowOutsideClick: false
        }).then(function (result) {
          if (!result.value) {
            _this16.viewModalDialog = false;
          } else {
            _this16.getCampaignDataToView(campaignID);
          }
        });
      } else {
        this.getCampaignDataToView(campaignID);
      }
    },
    getCampaignDataToView: function getCampaignDataToView(campaignID) {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
        _this17.viewCampaignData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, response);
        _this17.viewModalDialog = true;
      }).catch(function (error) {
        _this17.viewModalDialog = false;
        console.log('error', error);
      });
    },
    handleCogsLockChanged: function handleCogsLockChanged(campaignID, lockedCOGS) {
      var _this18 = this;

      var campaigns = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.items), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.filteredItems), [this.viewPairingCampaignData, this.viewCampaignData]);
      campaigns.forEach(function (campaign) {
        if (campaign && campaign.id === campaignID) {
          _this18.$set(campaign, 'lockedCOGS', lockedCOGS);
        }
      });
    },
    viewInfluencerPairingModal: function viewInfluencerPairingModal(campaignData) {
      this.viewPairingCampaignData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, campaignData);
      if (campaignData.clientID) {
        this.campaignClient = this.allClients.find(function (client) {
          return client.id === campaignData.clientID;
        });
      }
      if (!this.$route.query.payoutConfirm) {
        this.$router.push({
          path: window.location.pathname,
          query: {
            campaignID: this.viewPairingCampaignData.id,
            pairing: true
          }
        });
        this.viewPairingModalDialog = true;
      } else {
        this.viewPairingModalDialog = true;
      }
    },
    openBrandSheetModalDialog: function openBrandSheetModalDialog(campaign) {
      var data = this.brandSheets.find(function (b) {
        return b.campaignID === campaign.id;
      });
      data.clientName = this.getClientName(campaign.clientID);
      this.viewbrandSheetData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, data);
      this.viewBrandSheetModalDialog = true;
    },
    getPostDataToView: function getPostDataToView(campaignData) {
      this.viewPostCampaignData = campaignData;
    },
    showAMCCInputsDialog: function showAMCCInputsDialog(campaignID) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var campaign;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this19.amCCInputsDialog = true;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaignID);

              case 3:
                campaign = _context4.sent;

                _this19.campaignDataForRelease = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, campaign);
                return _context4.abrupt('return');

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this19);
      }))();
    },
    activateCampaign: function activateCampaign(campaignID, status) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var campaignConfirmation;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                campaignConfirmation = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.activation[status];

                _this20.$swal({
                  title: campaignConfirmation['confirmation']['title'],
                  text: campaignConfirmation['confirmation']['text'],
                  type: campaignConfirmation['confirmation']['type'],
                  showCancelButton: true,
                  confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
                  cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
                  showCloseButton: true,
                  allowOutsideClick: function allowOutsideClick() {
                    return !_this20.$swal.isLoading();
                  }
                }).then(function (result) {
                  if (result.value) {
                    __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].updateCampaignActivationStatus(campaignID, status).then(function (response) {
                      var campaign = response.campaign;
                      campaign.campaignStatusDisplay = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatusDisplay[campaign.status].display;
                      campaign.updatedAtDisplay = _this20.formatTime(campaign.updatedAt);
                      campaign.clientName = _this20.getClientName(campaign.clientID);
                      _this20.editCampaign(campaign);
                    }).catch(function (error) {
                      console.log('error', error);
                    });
                  } else {}
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this20);
      }))();
    },
    releaseToAdmin: function releaseToAdmin(campaignID) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var campaign;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this21.campaignStatus === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL)) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaignID);

              case 3:
                campaign = _context6.sent;

                _this21.campaignDataForAccept = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, campaign);
                _this21.releaseToAdminDialog = true;
                return _context6.abrupt('return');

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this21);
      }))();
    },
    approveCampaign: function approveCampaign(campaignID) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var campaign;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this22.campaignStatus === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus.DRAFT)) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaignID);

              case 3:
                campaign = _context7.sent;

                _this22.campaignDataForSubmitDraft = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, campaign);
                _this22.releaseToCCDialog = true;
                return _context7.abrupt('return');

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this22);
      }))();
    },
    proceedReleaseToAdmin: function proceedReleaseToAdmin(campaignID) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this23);
      }))();
    },
    proceedApproveCampaign: function proceedApproveCampaign(campaignID) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var campaignConfirmation, sweetAlertOptions;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                campaignConfirmation = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.approval[_this24.campaignStatus];
                sweetAlertOptions = {
                  title: campaignConfirmation['confirmation']['title'],
                  text: campaignConfirmation['confirmation']['text'],
                  type: campaignConfirmation['confirmation']['type'],
                  showCancelButton: true,
                  confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
                  cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function preConfirm(login) {
                    return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].approveCampaign(campaignID, _this24.campaignStatus).then(function (response) {
                      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getCampaign(campaignID).then(function (response) {
                        if (response.status === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER) {
                          _this24.viewCampaignData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, response);
                          _this24.prepareForPDF();
                          _this24.doc = __WEBPACK_IMPORTED_MODULE_42__campaignPDF__["a" /* default */].convertPDFLayout(_this24.campaignModelSections, _this24.viewCampaignData, _this24.showBudget, _this24.copyrightText);
                          __WEBPACK_IMPORTED_MODULE_42__campaignPDF__["a" /* default */].generatePDF(_this24.doc).then(function (pdfData) {
                            _this24.sendEmail(campaignID, pdfData);
                          }).catch(function (error) {
                            console.log('error in converting PDF', error);
                          });
                        }
                      }).catch(function (error) {
                        console.log('error', error);
                      });

                      return response;
                    }).catch(function (error) {
                      console.log('error', error);

                      _this24.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
                    });
                  },
                  allowOutsideClick: function allowOutsideClick() {
                    return !_this24.$swal.isLoading();
                  }
                };

                if (_this24.campaignStatus === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL) {
                  sweetAlertOptions.html = campaignConfirmation['confirmation']['html'];
                  sweetAlertOptions.input = campaignConfirmation['confirmation']['input'];
                  sweetAlertOptions.inputValue = 0;
                  sweetAlertOptions.inputPlaceholder = 'I have read and agree to the Terms and Conditions';
                  sweetAlertOptions.showCancelButton = false;
                  sweetAlertOptions.inputValidator = function (result) {
                    return !result && 'You need to agree with T&C';
                  };
                  sweetAlertOptions.width = 850;
                }

                _this24.$swal(sweetAlertOptions).then(function (result) {
                  if (result.value) {
                    _this24.paginate(1);

                    __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].commit('SET_CAMPAIGNS', {
                      campaignStatus: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignStatusFlow['approve'][_this24.campaignStatus],
                      data: null
                    });

                    _this24.$swal({
                      title: campaignConfirmation['confirm']['title'],
                      text: campaignConfirmation['confirm']['text'],
                      type: 'success'
                    });
                  } else {}
                });

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this24);
      }))();
    },
    pushReviewCampaign: function pushReviewCampaign(campaignID) {
      var _this25 = this;

      this.invoicesBriefViewDialog = true;
      setTimeout(function () {
        _this25.viewCampaignId = campaignID;
      }, 100);
    },
    sendEmail: function sendEmail(campaignID, pdfData) {
      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].sendCampaignPDF(campaignID, pdfData).then(function (response) {
        return response;
      }).catch(function (error) {
        console.log('error in sending email with pdf attached', error);
      });
    },
    acceptInvite: function acceptInvite(pairingID) {
      var _this26 = this;

      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].acceptInvite(pairingID).then(function (response) {
        _this26.paginate(1);

        __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].commit('SET_CAMPAIGNS', {
          campaignStatus: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignStatusFlow['approve'][_this26.campaignStatus],
          data: null
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    rejectInvite: function rejectInvite(pairingID) {
      var _this27 = this;

      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].acceptInvite(pairingID).then(function (response) {
        _this27.paginate(1);

        __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].commit('SET_CAMPAIGNS', {
          campaignStatus: __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignStatusFlow['approve'][_this27.campaignStatus],
          data: null
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    editCampaign: function editCampaign(campaignData) {
      var selectedIndex = -1;

      this.items.forEach(function (campaign, index) {
        if (campaign.id === campaignData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, campaignData);
      }

      this.paginate(1);
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).fromNow();
    },
    getClientName: function getClientName(id) {
      var result = null;
      this.allClients.forEach(function (item) {
        if (item.id === id) {
          if (item.group) {
            result = item.group.Name || item.name;
          } else {
            result = item.name;
          }
        }
      });
      return result;
    },
    eliminationStatusDisplay: function eliminationStatusDisplay(id) {
      if (id === 0) {
        return 'Pending';
      } else if (id === 1) {
        return 'Selected';
      } else {
        return 'Eliminated';
      }
    },
    eliminatinStatusColor: function eliminatinStatusColor(id) {
      if (id === 0) {
        return 'primary';
      } else if (id === 1) {
        return '#8BC34A';
      } else {
        return 'red';
      }
    },
    payoutStatusColor: function payoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return '';
      } else if (status === this.payoutStatus.INCOMPLETE || status === this.payoutStatus.SUBMITTED) {
        return 'warning';
      } else {
        return 'green';
      }
    },
    campaignPayoutStatusColor: function campaignPayoutStatusColor(status) {
      if (status === this.payoutStatus.PENDING) {
        return '#2196f3';
      } else if (status === this.payoutStatus.CONFIRMED) {
        return '#4CAF50';
      } else return '#2196f3';
    },
    prepareForPDF: function prepareForPDF() {
      var _this28 = this;

      this.showBudget = this.viewCampaignData.settings ? this.viewCampaignData.settings.showBudgetToClient : this.viewCampaignData.showBudgetToClient;
      this.showVideoBrief = this.viewCampaignData.settings ? this.viewCampaignData.settings.enableVideoBrief : this.viewCampaignData.enableVideoBrief;
      this.showEventBrief = this.viewCampaignData.settings ? this.viewCampaignData.settings.enableEventBrief : this.viewCampaignData.enableEventBrief;

      if (!this.showVideoBrief) {
        var array = this.campaignModelSections.filter(function (sections) {
          return sections.type !== __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignModelSectionType.VIDEO_BRIEF;
        });
        this.campaignModelSections = array;
      }

      if (!this.showEventBrief) {
        var _array = this.campaignModelSections.filter(function (sections) {
          return sections.type !== __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignModelSectionType.EVENT_BRIEF;
        });
        this.campaignModelSections = _array;
      }

      if (!this.showBudget && __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.CLIENT === this.currentUserRole) {
        var sections = this.campaignModelSections;
        var filteredContent = void 0;
        sections.forEach(function (section, index) {
          if (section.type === _this28.campaignModelSectionType.BUDGET_ALLOCATION) {
            filteredContent = section.content.filter(function (field) {
              return field.name !== 'budget';
            });
            _this28.campaignModelSections[index].content = filteredContent;
          }
        });
        delete this.campaignData.budget;
      }
    },
    openConfirmPayoutDialog: function openConfirmPayoutDialog(item) {
      this.influencer = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, item);
      this.payoutConfirmData = item;
      this.invoiceDownload = false;
      this.payoutConfirmDialog = true;
    },
    setConfirmedPayout: function setConfirmedPayout(item) {
      this.pairedInfluencers = this.pairedInfluencers.map(function (p) {
        if (p.pairingID === item.pairingID) {
          p.payoutAmount = item.payout || 0;
          p.payout = item.payout || 0;
          p.history = item.history;
          p.payoutStatus = item.payoutStatus;
          if (p.payoutSubmitted) {
            delete p.payoutSubmitted;
          }
          if (!p.payoutVerified) {
            p.payoutVerified = true;
          }
        }
        return p;
      });
      this.reload();
    },
    getStageName: function getStageName(status) {
      if (status === this.campaignStatuses.DRAFT || status === this.campaignStatuses.PENDING_CLIENT_APPROVAL) {
        return this.campaignStage.ACTIVATING;
      } else if (status === this.campaignStatuses.PAIRING_BRIEF || status === this.campaignStatuses.PAIRING_INFLUENCER || status === this.campaignStatuses.RATE_CARD) {
        return this.campaignStage.PAIRING;
      } else if (status === this.campaignStatuses.ONGOING) {
        return this.campaignStage.COCREATING;
      } else if (status === this.campaignStatuses.REVIEW) {
        return this.campaignStage.REVIEW;
      } else {
        return this.campaignStage.COMPLETE;
      }
    },
    formatDecimal: function formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    downloadCampaignDetailsReport: function downloadCampaignDetailsReport(exportType) {
      var _this29 = this;

      this.loadingDialogOpen();
      var campaignIDs = this.filteredItems.map(function (i) {
        return i.id;
      });
      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].downloadCampaignDetailsReport(campaignIDs, exportType).then(function (response) {
        _this29.loadingDialogClose();
        if (exportType === 'sync') {
          _this29.$swal({
            text: 'Started Syncing Creator Statistics Report.',
            type: 'success'
          });
        }
      }).catch(function (error) {
        _this29.loadingDialogClose();
        console.log('error in downloading all campaigns report', error);
      });
    },
    downloadAllCampaignsReport: function downloadAllCampaignsReport(exportType) {
      var _this30 = this;

      this.loadingDialogOpen();
      var exportItems = this.filteredItems.map(function (item) {
        item.createdDate = __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'DD/MM/YYYY');
        if (item.activity) {
          var activity = item.activity;
          item.briefAcceptedAt = activity.clientApproveAt ? __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.formatCustomDate(activity.clientApproveAt, 'DD/MM/YYYY') : '';
        }
        return item;
      });
      __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].downloadAllCampaignsReport(exportItems, exportType).then(function () {
        _this30.loadingDialogClose();
        if (exportType === 'sync') {
          _this30.$swal({
            text: 'Started Syncing Cost & Period Report.',
            type: 'success'
          });
        }
      }).catch(function (error) {
        _this30.loadingDialogClose();
        console.log('error in downloading all campaigns report', error);
      });
    },
    downloadCampaignPairingsReport: function downloadCampaignPairingsReport(exportType) {
      var _this31 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var campaignIDs;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this31.loadingDialogOpen();
                campaignIDs = _this31.filteredItems.map(function (i) {
                  return i.id;
                });

                __WEBPACK_IMPORTED_MODULE_40__Pairing_pairingAPIs__["a" /* default */].downloadCampaignPairingsReport(campaignIDs, exportType).then(function () {
                  if (exportType === 'sync') {
                    _this31.$swal({
                      text: 'Started Syncing Creator Payout Report.',
                      type: 'success'
                    });
                  }
                  _this31.loadingDialogClose();
                }).catch(function (error) {
                  _this31.loadingDialogClose();
                  console.log('error in downloading all campaigns report', error);
                });

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this31);
      }))();
    },
    downloadSystemPerformanceReport: function downloadSystemPerformanceReport(exportType) {
      var _this32 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this32.loadingDialogOpen();
                __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].downloadSystemPerformanceReport(exportType).then(function () {
                  _this32.loadingDialogClose();
                  if (exportType === 'sync') {
                    _this32.$swal({
                      text: 'Started Syncing Campaign Performance Report.',
                      type: 'success'
                    });
                  }
                }).catch(function (error) {
                  _this32.loadingDialogClose();
                  console.log('error in downloading system performance report', error);
                });

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this32);
      }))();
    },
    updateSend: function updateSend(item) {
      var _this33 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var payload, confirmPayoutBlock, message;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                payload = _this33.getRptOwnerCheckPayload(item);
                _context13.next = 3;
                return __WEBPACK_IMPORTED_MODULE_15__campaignHelper__["a" /* default */].invokeReportOwnerCheck(_this33, payload);

              case 3:
                confirmPayoutBlock = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.confirmPayout;
                message = confirmPayoutBlock.htmlAOK;

                _this33.$swal({
                  title: confirmPayoutBlock.title,
                  html: message,
                  confirmButtonText: confirmPayoutBlock.confirmButtonText,
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12(result) {
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            if (!result.value) {
                              _context12.next = 4;
                              break;
                            }

                            _context12.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_40__Pairing_pairingAPIs__["a" /* default */].confirmAdminPayoutOnly(item.id);

                          case 3:
                            _this33.loadInfluencerData();

                          case 4:
                          case 'end':
                            return _context12.stop();
                        }
                      }
                    }, _callee12, _this33);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 6:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this33);
      }))();
    },
    cancelPayout: function cancelPayout(item) {
      var _this34 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var cancelPayoutBlock, message;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                cancelPayoutBlock = __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].campaignConfirmation.cancelPayout;
                message = cancelPayoutBlock.html;

                _this34.$swal({
                  title: cancelPayoutBlock.title,
                  html: message,
                  confirmButtonText: cancelPayoutBlock.confirmButtonText,
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14(result) {
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            if (!result.value) {
                              _context14.next = 5;
                              break;
                            }

                            _this34.loadingDialog = true;
                            _context14.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_40__Pairing_pairingAPIs__["a" /* default */].cancelAdminPayout(item.id);

                          case 4:
                            _this34.loadInfluencerData();

                          case 5:
                          case 'end':
                            return _context14.stop();
                        }
                      }
                    }, _callee14, _this34);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this34);
      }))();
    },
    preparedViewItem: function preparedViewItem(item, type) {
      if (item.influencerID) {
        this.getUserByInfluencer(item.influencerID);
      }
      this.influencer = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, item);

      if (item.brief_details && item.brief_details.contentHTML !== undefined) {
        this.briefDetailsHTML = item.brief_details.contentHTML;

        this.selectedTab = type;
        return;
      }
      var oldData = false;
      if (item.brief_details && item.brief_details.content !== '' && item.brief_details.content.length > 0) {
        this.briefDetailContent.blocks = item.brief_details.content;
        oldData = true;
      } else {
        this.briefDetailContent.blocks = __WEBPACK_IMPORTED_MODULE_15__campaignHelper__["a" /* default */].generateBlocks(item);
      }
      var blocksTohtml = new __WEBPACK_IMPORTED_MODULE_38__editor_generator_blocksToHtml__["a" /* default */](this.briefDetailContent.blocks);
      this.briefDetailsHTML = blocksTohtml.generate(oldData);

      this.selectedTab = type;
    },
    getUserByInfluencer: function getUserByInfluencer(id) {
      var _this35 = this;

      var param = {
        'influencerID': id
      };
      __WEBPACK_IMPORTED_MODULE_41__User_userAPIs__["a" /* default */].getUserByInfluencer(param).then(function (res) {
        _this35.influencerProfile = res;
      });
    },
    resetFilter: function resetFilter() {
      this.selectedFilter = {
        campaignType: '',
        vertical: '',
        targetLocation: '',
        AM: '',
        CO: '',
        client: '',
        stage: 'All'
      };
      this.filter = '';
      this.searchFilter();
    },
    closeModal: function closeModal() {
      this.dialog = false;
    },
    loadingDialogOpen: function loadingDialogOpen() {
      this.loadingDialog = true;
    },
    loadingDialogClose: function loadingDialogClose() {
      this.loadingDialog = false;
    },
    loadInfluencerData: function loadInfluencerData() {
      this.getPairedInfluencers(this.campaignCOEB);
      this.loadingDialog = false;
    },
    linkPayoutInternal: function linkPayoutInternal(item) {
      window.open('/campaignPayoutsInternal?influencerID=' + item.influencer_details.influencerID + '&campaignID=' + item.CampaignID + '&verified=true', '_blank');
    },
    getSubmittedCount: function getSubmittedCount(item) {
      return this.payoutSubmittedPairings.filter(function (p) {
        return p.campaignID === item.id;
      }).length;
    },
    getRptOwnerCheckPayload: function getRptOwnerCheckPayload(item) {
      return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
        campaignID: item.CampaignID,
        handle: item.instagramHandle,
        platform: item.platform
      });
    },
    clearPairingFilters: function clearPairingFilters() {
      this.pairedFilter = {
        payoutStatus: '',
        search: ''
      };
    },
    selectAllCampaigns: function selectAllCampaigns($event) {
      if ($event.value && $event.items.length === 0 || !$event.value) {
        this.selectedCampaigns = [];
        return;
      }
      if (this.selectedCampaigns.length === 0) {
        this.selectedCampaigns = $event.items;
      } else this.selectedCampaigns = [];
    },
    performSelected: function performSelected(action) {
      var ids = this.selectedCampaigns.map(function (item) {
        return item.id;
      });
      switch (action) {
        case 'changeStatus':
          this.changeBulkStatus(ids);
          break;
        case 'deleteCampaign':
          this.deleteBulkCampaigns(ids);
          break;
        case 'archiveCampaign':
          this.archiveCampaign(ids);
          break;
      }
    },
    changeBulkStatus: function changeBulkStatus(ids) {
      this.selectedCampaignIds = ids;
      this.campaignDataForStatusChange = this.selectedCampaigns[0];
      this.changeStatusDialog = true;
    },
    restoreArchive: function restoreArchive() {
      var _this36 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16(result) {
          var data;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (!result.value) {
                    _context16.next = 11;
                    break;
                  }

                  data = _this36.selectedCampaigns.map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
                      id: item.id,
                      archive: false
                    });
                  });
                  _context16.next = 4;
                  return _this36.$store.dispatch('campaign/updateCampaignByIds', data);

                case 4:
                  _this36.isLoading = false;

                  if (_this36.campaignUpdated) {
                    _context16.next = 8;
                    break;
                  }

                  _this36.$swal({
                    text: 'Error Restoring Campaigns.',
                    type: 'error'
                  });
                  return _context16.abrupt('return');

                case 8:
                  _this36.selectedCampaigns = [];

                  _this36.$swal({
                    text: 'Successfully restored.',
                    type: 'success'
                  });
                  _this36.paginate(1);

                case 11:
                case 'end':
                  return _context16.stop();
              }
            }
          }, _callee16, _this36);
        }));

        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    formatCampaignVerticals: function formatCampaignVerticals(campaign) {
      var selectedCampaignVertical = [];
      if (campaign.vertical) {
        this.campaignVerticals.map(function (item) {
          campaign.vertical.map(function (vertical) {
            if (item.id === vertical) {
              selectedCampaignVertical.push(item);
            }
          });
        });
      }
      return selectedCampaignVertical;
    },
    getProductName: function getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut';
      }
      return itemName;
    },

    getCountryDisplayValueFromSelect: function getCountryDisplayValueFromSelect(value) {
      if (typeof value === 'string') return value;
      var selectedOption = this.countries.filter(function (option) {
        return value.includes(option.code);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.name;
      }).join(', ') : '-';
    },
    beautifyExportData: function beautifyExportData(data) {
      var inf = {};
      var influencerDetails = data.influencer_details;
      var deliverablesDetails = data.deliverables_details || {};
      var campaign = this.filteredItems.find(function (f) {
        return f.id === data.campaignID;
      });
      inf = data.influencer_details;
      inf.influencer_details = __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.refreshJSON(influencerDetails);
      inf.pairing_details = data.pairing_details;
      inf.elimination_details = data.elimination_details;
      inf.campaignName = campaign ? campaign.name : '';
      inf.followers = influencerDetails.followers || 0;
      inf.engagement = influencerDetails.engagements || 0;
      inf.engagement_rate = influencerDetails.engagement_rate ? influencerDetails.engagement_rate + '%' : 0;
      inf.deliverables = __WEBPACK_IMPORTED_MODULE_15__campaignHelper__["a" /* default */].getDeliverableDetails(deliverablesDetails);
      if (data.payout_details) {
        inf.payoutAmount = data.payout_details ? data.payout_details.amount : '';
        inf.payout = data.payout_details.amount ? Number(data.payout_details.amount) : 0;
      }
      if (data.pairing_details) {
        inf.submission_date = data.pairing_details.submission_date ? __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.formatCustomDate(data.pairing_details.submission_date, 'DD/MM/YYYY') : '';
      }
      return inf;
    },
    searchStartMonthOk: function searchStartMonthOk() {
      this.$refs.startMonthPicker.save(this.selectedFilter.searchStartMonth);
      this.searchFilter();
    },
    searchEndMonthOk: function searchEndMonthOk() {
      this.$refs.endMonthPicker.save(this.selectedFilter.searchLastMonth);
      this.searchFilter();
    },
    checkShowURLParam: function checkShowURLParam() {
      var _this37 = this;

      this.isUnlockCogs = false;
      if (this.$route.query.campaignID && (this.$route.query.payoutConfirm || this.$route.query.pairing)) {
        var campaign = this.items.find(function (item) {
          return item.id === _this37.$route.query.campaignID;
        });
        this.viewInfluencerPairingModal(campaign);
      } else if (this.$route.query.campaignID && this.$route.query.unlockCogs) {
        var _campaign = this.items.find(function (item) {
          return item.id === _this37.$route.query.campaignID;
        });
        this.isUnlockCogs = true;
        this.viewInfluencerPairingModal(_campaign);
      } else if (this.$route.query.campaignID) {
        this.getCampaignDataToView(this.$route.query.campaignID);
      }
    },
    openReportPasscodeDialog: function openReportPasscodeDialog(type, exportType) {
      this.exportType = exportType;
      this.downloadReportType = type;
      this.allReportsPasscodeDialog = true;
    },
    reportPasscodeSuccess: function reportPasscodeSuccess() {
      if (this.downloadReportType === 'details') {
        this.downloadCampaignDetailsReport(this.exportType);
      } else if (this.downloadReportType === 'all') {
        this.downloadAllCampaignsReport(this.exportType);
      } else if (this.downloadReportType === 'pairings') {
        this.downloadCampaignPairingsReport(this.exportType);
      } else if (this.downloadReportType === 'performance') {
        this.downloadSystemPerformanceReport(this.exportType);
      }
    },
    getReportsByCampaignIDs: function getReportsByCampaignIDs(campaigns) {
      var campaignIDs = campaigns.map(function (c) {
        return c.id;
      });
      this.$store.dispatch('campaign/getReportsByCampaignIDs', campaignIDs);
    },
    showCheckListDialog: function showCheckListDialog(campaign) {
      this.campaignDataForRelease = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, campaign);
      this.briefReleaseChecklistDialog = true;
    },
    proceedActivateCampaign: function proceedActivateCampaign(campaignID) {
      this.activateCampaign(campaignID, this.campaignActivationStatusConfig.ACTIVATED);
    },
    formatMonth: function formatMonth(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format('MMM YYYY');
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.allCampaignHeaders.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_entries___default()(this.allCampaignHeaders)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref5 = _step2.value;

          var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);

          var key = _ref6[0];
          var value = _ref6[1];

          if (value.text && value.value !== 'action') {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this38 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                columns = _this38.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this38.userProfile.tableSettings) {
                  tableSettings = _this38.userProfile.tableSettings;
                }
                tableSettings.allCampaignCols = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this38.currentUserID,
                  tableSettings: tableSettings
                };
                _context17.next = 8;
                return __WEBPACK_IMPORTED_MODULE_41__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this38.colStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, columns);
                _this38.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this38);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this39 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return __WEBPACK_IMPORTED_MODULE_41__User_userAPIs__["a" /* default */].getUser(_this39.currentUserID);

              case 2:
                resp = _context18.sent;

                if (resp && resp.id) {
                  _this39.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this39);
      }))();
    },
    getCountries: function getCountries() {
      this.countries = __WEBPACK_IMPORTED_MODULE_46__static_sources_countries___default.a;
      this.countries = this.countries.map(function (c) {
        return c;
      });
      this.countries.unshift({
        name: 'All Countries',
        code: ''
      });
    },
    setUnlockCogs: function setUnlockCogs(status) {
      this.isUnlockCogs = status;
    },
    directClient: function directClient(campaignID) {
      var _this40 = this;

      this.$swal({
        title: 'Direct Release Client',
        text: 'Are you sure you want to direct release client?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        allowOutsideClick: function allowOutsideClick() {
          return !_this40.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].updateCampaignDirectRelease(campaignID).then(function (response) {
            if (!response.success) {
              _this40.$swal({
                text: 'Error Direct Release to Client.',
                type: 'error'
              });
              return;
            }

            _this40.$swal({
              text: 'Successfully direct released to client.',
              type: 'success'
            });
            _this40.paginate(1);
          }).catch(function (error) {
            console.log('error', error);
          });
        } else {}
      });
    }
  },
  mounted: function mounted() {
    var _this41 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19() {
      var response, vResp;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (!(_this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || _this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || _this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || _this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.AD_STRATEGIST || _this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || _this41.currentUserRole === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.FINANCE)) {
                _context19.next = 36;
                break;
              }

              _context19.prev = 1;
              _context19.next = 4;
              return __WEBPACK_IMPORTED_MODULE_18__Client_clientAPIs__["a" /* default */].getAllClients(false);

            case 4:
              response = _context19.sent;

              _this41.allClients = response.data;
              _this41.allClients.unshift({ id: '', name: 'All Clients' });
              _context19.next = 9;
              return __WEBPACK_IMPORTED_MODULE_41__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

            case 9:
              response = _context19.sent;

              if (response) {
                _this41.AM = response.users;
                _this41.AM = _this41.AM.map(function (am) {
                  am.name = am.firstName + ' ' + am.lastName;
                  return am;
                });
              }
              _this41.AM.unshift({ id: '', name: 'All Team' });
              _context19.next = 14;
              return __WEBPACK_IMPORTED_MODULE_41__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 14:
              response = _context19.sent;

              if (response) {
                _this41.CO = response.users;
                _this41.CO = _this41.CO.map(function (co) {
                  co.name = co.firstName + ' ' + co.lastName;
                  return co;
                });
                _this41.CO.unshift({ id: '', name: 'All Team' });
              }

              __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getAllBrandSheets().then(function (response) {
                if (response.success) {
                  _this41.brandSheets = response.data;
                }
              }).catch(function (error) {
                console.log('error', error);
              });

              _this41.getCountries();
              _context19.next = 20;
              return __WEBPACK_IMPORTED_MODULE_17__campaignAPIs__["a" /* default */].getAllCampaignVerticals(false);

            case 20:
              vResp = _context19.sent;

              _this41.campaignVerticals = vResp.data;
              _this41.campaignVerticals.unshift({ id: -1, name: 'Empty Verticals' });
              _this41.campaignVerticals.unshift({ id: '', name: 'All Verticals' });

              _this41.campaignTypeDisplayFilter = __WEBPACK_IMPORTED_MODULE_43__utils__["a" /* default */].func.refreshJSON(_this41.campaignTypeDisplayFilter);
              _this41.campaignTypeDisplayFilter.unshift({ value: -1, text: 'Empty Types' });
              _this41.campaignTypeDisplayFilter.unshift({ value: '', text: 'All Types' });
              _context19.next = 29;
              return __WEBPACK_IMPORTED_MODULE_40__Pairing_pairingAPIs__["a" /* default */].getAllPayoutSubmittedPairings();

            case 29:
              _this41.payoutSubmittedPairings = _context19.sent;

              if (_this41.$route.query.verified) {
                _this41.selectedFilter.verified = 'Verified Payouts';
              }
              _context19.next = 36;
              break;

            case 33:
              _context19.prev = 33;
              _context19.t0 = _context19['catch'](1);

              console.log('error', _context19.t0);

            case 36:
              _this41.getUserProfile();
              _this41.paginate(1);

            case 38:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this41, [[1, 33]]);
    }))();
  }
});

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      totalRow: 0,
      perPage: 10,
      records: [],
      selectedRecord: null,
      headers: [{
        text: 'Client',
        value: 'name'
      }, {
        text: 'Campaign',
        value: 'name'
      }, {
        text: 'Amount',
        value: 'amount'
      }, {
        text: 'Status',
        value: 'status'
      }, {
        text: 'Time',
        value: 'name'
      }, {
        text: 'Actions'
      }],
      paymentStatus: [{
        text: 'Submitted',
        value: 0
      }, {
        text: 'Approve',
        value: 1
      }],
      viewPaymentDetailDialog: false
    };
  },
  created: function created() {
    this.fetchPaymentRecords();
  },

  filters: {
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    }
  },
  methods: {
    fetchPaymentRecords: function fetchPaymentRecords() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/clients/payment-records?page=' + this.currentPage + '&per_page=' + this.perPage, true).then(function (response) {
        if (response.data.records) {
          _this.records = response.data.records;
          _this.totalRow = response.data.totalRecords;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    showModalEdit: function showModalEdit(record) {
      this.selectedRecord = record;
      this.viewPaymentDetailDialog = true;
    },
    deleteRecord: function deleteRecord() {
      var _this2 = this;

      this.$swal({
        title: 'Are You Sure?',
        text: 'This task cannot be undone.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I understand'
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('delete', '/api/v1/clients/payment-records/' + _this2.selectedRecord.id, true).then(function (response) {
            _this2.viewPaymentDetailDialog = false;
            _this2.selectedRecord = null;
            _this2.fetchPaymentRecords();
          }).catch(function (err) {
            console.log(err);
          });
        } else {}
      });
    },
    updateRecord: function updateRecord() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/api/v1/clients/payment-records/' + this.selectedRecord.id, true, {
        amount: this.selectedRecord.amount,
        status: this.selectedRecord.status
      }).then(function (response) {
        _this3.viewPaymentDetailDialog = false;
        _this3.fetchPaymentRecords();
        _this3.selectedRecord = null;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignTeam',
  props: ['assignUsers', 'dedicatedData', 'supportingData', 'viewMode'],
  data: function data() {
    return {
      userRoles: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles,
      userTypes: [{
        title: 'AM',
        role: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.ACCOUNT_MANAGER
      }, {
        title: 'CC',
        role: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST
      }],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      AMUsers: [],
      CCUsers: []
    };
  },

  computed: {
    computedSupportingPersons: function computedSupportingPersons() {
      var personIds = this.selectedDedicatedPersons.map(function (v) {
        return v.id;
      });
      return this.assignUsers.filter(function (a) {
        return !personIds.includes(a.id);
      });
    }
  },
  watch: {
    dedicatedData: function dedicatedData(newValues) {
      this.getAMCCUsers();
      this.selectedDedicatedPersons = newValues.map(function (s) {
        return s;
      });
    },
    supportingData: function supportingData(newValues) {
      this.selectedSupportingPersons = newValues.map(function (s) {
        return s;
      });
    },

    selectedDedicatedPersons: function selectedDedicatedPersons(newValue) {
      var _this = this;

      if (this.dedicatedData && this.dedicatedData.length < 3 || !this.dedicatedData) {
        var newIds = newValue.map(function (v) {
          return v.id;
        });

        var totalAMs = newIds.filter(function (v) {
          return _this.AMUsers.includes(v);
        });
        if (totalAMs.length > 1) {
          var removeAM = totalAMs[0];
          newValue = newValue.filter(function (v) {
            return v.id !== removeAM;
          });
        }

        var totalCCs = newIds.filter(function (v) {
          return _this.CCUsers.includes(v);
        });
        if (totalCCs.length > 1) {
          var removeCC = totalCCs[0];
          newValue = newValue.filter(function (v) {
            return v.id !== removeCC;
          });
        }
        if (totalAMs.length > 1 || totalCCs.length > 1) {
          this.selectedDedicatedPersons = newValue;
        }
        this.selectedSupportingPersons = this.selectedSupportingPersons.filter(function (s) {
          return !newValue.includes(s.id);
        });
      }
      this.$emit('updateSelectedDedicated', newValue);
    },
    selectedSupportingPersons: function selectedSupportingPersons(newValue) {
      this.$emit('updateSelectedSupporting', newValue);
    }
  },
  mounted: function mounted() {
    this.selectedDedicatedPersons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.dedicatedData);
    this.selectedSupportingPersons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.supportingData);
    this.getAMCCUsers();
  },

  methods: {
    filterByRole: function filterByRole(users, role) {
      return users.filter(function (u) {
        return u.role === role;
      });
    },
    getAMCCUsers: function getAMCCUsers() {
      this.AMUsers = this.filterByRole(this.assignUsers, __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);
      this.AMUsers = this.AMUsers.map(function (a) {
        return a.id;
      });
      this.CCUsers = this.filterByRole(this.assignUsers, __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST);
      this.CCUsers = this.CCUsers.map(function (a) {
        return a.id;
      });
    }
  }
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Xero_XeroAPIs__ = __webpack_require__(111);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientGroupModal',
  props: {
    selectedClients: Array,
    value: Boolean
  },
  data: function data() {
    return {
      clientGroups: [],
      selectedGroup: '',
      newClientGroup: '',
      loading: false
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue === true) {
        this.getClientGroups();
      }
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    saveClientGroup: function saveClientGroup() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = _this2.buildFormData();

                _this2.loading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__clientAPIs__["a" /* default */].addClientGroup(formData);

              case 5:
                response = _context2.sent;

                if (response) {
                  _this2.getClientGroups();

                  _this2.loading = false;
                  _this2.$swal({
                    title: 'Successful',
                    text: 'Clients are added to (' + (response.group.Name || '-') + ')',
                    type: 'success'
                  }).then(function () {
                    _this2.$emit('input');
                    _this2.$emit('saved', true);
                  });
                }
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                _this2.loading = false;
                _this2.$swal({
                  title: 'Error',
                  text: _context2.t0,
                  type: 'error'
                });
                console.log('error', _context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 9]]);
      }))();
    },
    buildFormData: function buildFormData() {
      var formData = new FormData();
      formData.append('group', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedGroup));
      formData.append('clients', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedClients.map(function (c) {
        return c.id;
      })));
      return formData;
    },
    closeModal: function closeModal() {
      this.$emit('input');
      this.selectedGroup = '';
    },
    getClientGroups: function getClientGroups() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__Xero_XeroAPIs__["a" /* default */].getXeroContacts();

              case 3:
                resp = _context3.sent;

                if (resp.data.success) {
                  _this3.clientGroups = resp.data.data;
                  _this3.selectedGroup = '';
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Company_companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssignTeam__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssignTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AssignTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__clientConfig_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Xero_XeroAPIs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__upload__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__static_sources_countries__);




























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateClientModal',
  props: {
    modalId: String,
    value: Boolean
  },
  components: {
    AssignTeam: __WEBPACK_IMPORTED_MODULE_13__AssignTeam___default.a,
    uploadMedia: __WEBPACK_IMPORTED_MODULE_20__upload___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_22__components_scoped_custom_DatePicker___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_18_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_23__static_sources_countries___default.a,
      xeroContacts: [],
      company_options: [],
      salePerson_options: [],
      numberOfCampaigns: [1, 2, 3, 4, 5],
      panels: [0],
      contactPanels: [0],
      sameWithContactInfo: false,
      startCal: false,
      expireCal: false,
      moreStartCal: false,
      moreExpireCal: false,
      durationCal: false,
      loading: false,
      pickDate: false,
      clientGroups: [],
      ioNumbers: [],
      selectedGroup: '',
      client: {
        xeroContact: null,
        name: '',

        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',

        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: '',
          natureOfDeal: '',
          remark: ''
        },
        deals: {
          previewBudget: 0,
          budget: 0,
          IO: '',
          linkedIOs: [''],
          markupCOGS: false,
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          servicesLine: '',
          natureOfDeal: '',
          activationDate: ''
        },
        media: [],
        handledBy: [],
        supportedBy: [],
        contacts: []
      },
      addDialog: false,
      addDealsDialog: false,
      productName: '',
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      },
      uploadMediaKey: 0,
      CO: [],
      AM: [],
      assignUsers: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      dealNatureLists: [],
      newDealNature: '',
      dealCounter: 0,

      clientTypes: [{
        title: 'Direct',
        value: 'direct'
      }, {
        title: 'Agency',
        value: 'agency'
      }],
      natureOfDealOptions: ['Loading Fees/whitelisting', 'Physical Attendance/Event'],
      lineOfServices: ['Storytell', 'Storytell + BCA', 'Storytell + Uncut', 'Uncut', 'Loading Fees', 'Academy'],
      displayMasterLists: []
    };
  },

  validations: {
    client: {
      name: { required: __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__["required"] },
      email: { email: __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__["email"] }
    }
  },
  watch: {
    sameWithContactInfo: function sameWithContactInfo(newInfo) {
      if (newInfo) {
        this.sameWithContactInfo = newInfo;
        this.client.billingPhoneNumber = this.client.phoneNumber;
        this.client.billingEmail = this.client.email;
        this.client.billingAddress = this.client.address;
      }
    },
    value: function value(newValue) {
      if (newValue === true) {
        this.addDefaultContact();
        this.getAllClientGroups();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    campaignVerticals: function campaignVerticals(state) {
      return state.campaign.campaignVerticals;
    },
    masterLists: function masterLists(state) {
      return state.campaign.masterLists;
    },
    dealNatures: function dealNatures(state) {
      return state.client.dealNatures;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    needCompany: function needCompany() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW) {
        return false;
      } else if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      }
      return false;
    },
    clientPaymentModes: function clientPaymentModes() {
      return __WEBPACK_IMPORTED_MODULE_15__clientConfig_js__["a" /* default */].clientPaymentModes;
    },
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.client.name.$dirty) return errors;
      !this.$v.client.name.required && errors.push('Name is required');
      return errors;
    },
    addressErrors: function addressErrors() {
      var errors = [];
      if (!this.$v.client.address.$dirty) return errors;
      !this.$v.client.address.required && errors.push('Address is required');
      return errors;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.client.email.$dirty) return errors;
      !this.$v.client.email.email && errors.push('Invalid email format');
      return errors;
    },
    accept: function accept() {
      return 'image/*';
    },
    showProductName: function showProductName() {
      if (this.productName === 'AOK') {
        return 'AOK/Uncut';
      }
      return this.productName;
    },
    invalidContactEmail: function invalidContactEmail() {
      var isInvalid = false;
      this.client.contacts.map(function (c) {
        if (c.invalid) isInvalid = true;
      });
      return isInvalid;
    },
    isEmptyContact: function isEmptyContact() {
      if (this.client.contacts.length) {
        if (!this.client.contacts[0].email) {
          return true;
        }
        return false;
      }
      return true;
    }
  }),
  methods: {
    createClient: function createClient() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var hasAM, hasCC, dedicatedIDs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, AM, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, CC, client;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.client.handledBy = [];
                _this.client.supportedBy = [];
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 6;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Make sure you filled the required information correctly.'
                });
                return _context.abrupt('return');

              case 6:
                if (!_this.invalidContactEmail) {
                  _context.next = 9;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Contact email already exists.'
                });
                return _context.abrupt('return');

              case 9:
                if (!_this.isEmptyContact) {
                  _context.next = 12;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Please add at least one contact.'
                });
                return _context.abrupt('return');

              case 12:
                hasAM = false;
                hasCC = false;
                dedicatedIDs = _this.selectedDedicatedPersons.map(function (s) {
                  return s.id;
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 18;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this.AM); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  AM = _step.value;

                  if (dedicatedIDs.includes(AM.id)) {
                    hasAM = true;
                  }
                }
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context['catch'](18);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 37;
                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this.CO); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  CC = _step2.value;

                  if (dedicatedIDs.includes(CC.id)) {
                    hasCC = true;
                  }
                }

                _context.next = 45;
                break;

              case 41:
                _context.prev = 41;
                _context.t1 = _context['catch'](37);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 45:
                _context.prev = 45;
                _context.prev = 46;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 48:
                _context.prev = 48;

                if (!_didIteratorError2) {
                  _context.next = 51;
                  break;
                }

                throw _iteratorError2;

              case 51:
                return _context.finish(48);

              case 52:
                return _context.finish(45);

              case 53:
                if (!(!hasAM || !hasCC)) {
                  _context.next = 56;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Please select at least one AM and CC'
                });
                return _context.abrupt('return');

              case 56:

                _this.selectedDedicatedPersons.map(function (item) {
                  _this.client.handledBy.push(item.id);
                });

                _this.selectedSupportingPersons.map(function (item) {
                  _this.client.supportedBy.push(item.id);
                });

                client = _this.buildFormData(_this.client);

                _this.loading = true;
                _context.next = 62;
                return __WEBPACK_IMPORTED_MODULE_10__clientAPIs__["a" /* default */].createClient(client).then(function (response) {
                  _this.loading = false;
                  _this.$emit('createClient', response);

                  if (response.handledBy) {
                    response.handledBy.map(function (userId) {
                      var users = {
                        id: userId,
                        companyID: response.companyID
                      };
                      __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].editUser(users);
                    });
                  }

                  if (response.supportedBy) {
                    response.supportedBy.map(function (userId) {
                      var users = {
                        id: userId,
                        companyID: response.companyID
                      };
                      __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].editUser(users);
                    });
                  }
                  _this.$swal({
                    title: 'Successful',
                    text: 'Client account is created and a welcome email will sent to contact email address if provided.',
                    type: 'success'
                  }).then(function () {
                    _this.clearData();
                    _this.uploadMediaKey += 1;
                    _this.$emit('input');
                  });
                }).catch(function (error) {
                  _this.loading = false;
                  _this.$swal({
                    title: 'Error',
                    text: error,
                    type: 'error'
                  });
                  console.log('error', error);
                });

              case 62:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[18, 22, 26, 34], [27,, 29, 33], [37, 41, 45, 53], [46,, 48, 52]]);
      }))();
    },
    buildFormData: function buildFormData(clientData) {
      clientData = this.filterEmptyContacts(clientData);
      var formData = new FormData();
      var client = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, clientData);

      if (this.needCompany === false) {
        delete client.companyID;
      } else {
        formData.append('companyID', client.companyID);
      }
      var medias = client.media ? client.media.map(function (m) {
        return m.file;
      }) : [];

      delete client.moreAccount;
      delete client.media;
      delete client.deals;
      formData.append('client', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(client));

      if (medias) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(medias), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var media = _step3.value;

            formData.append('images', media);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return formData;
    },

    clearData: function clearData() {
      this.$v.$reset();
      this.client = {
        name: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: '',
          remark: ''
        },
        deals: {
          budget: 0,
          IO: '',
          linkedIOs: [''],
          markupCOGS: '',
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          activationDate: ''
        },
        media: [],
        contacts: []
      };
      this.productName = '';
      this.sameWithContactInfo = false;
      this.selectedDedicatedPersons = [];
    },
    clearDeals: function clearDeals() {
      this.client.deals.name = '';
      this.client.deals.previewBudget = 0;
      this.client.deals.budget = 0;
      this.client.deals.IO = '';
      this.client.deals.linkedIOs = [''];
      this.client.deals.quoteAcceptanceDate = '';
      this.client.deals.remarks = '';
      this.client.deals.markupCOGS = '';
      this.client.deals.cogsAmount = '';
      this.client.deals.activationDate = '';
      this.client.deals.masterListID = '';
      this.client.deals.products = [];
      this.client.deals.country = [];
      this.client.deals.clientType = '';
      this.client.deals.servicesLine = '';
      this.client.deals.vertical = [];
    },
    clearMoreAccountData: function clearMoreAccountData() {
      this.client.moreAccount.budget = '';
      this.client.moreAccount.totalOutReach = '';
      this.client.moreAccount.totalEngagement = '';
      this.client.moreAccount.minContent = '';
      this.client.moreAccount.maxContent = '';
      this.client.moreAccount.maxCampaigns = '';
      this.client.moreAccount.startDate = '';
      this.client.moreAccount.expireDate = '';
      this.client.moreAccount.views = '';
      this.client.moreAccount.noOfContents = '';
      this.client.moreAccount.duration = '';
      this.client.moreAccount.remark = '';
    },
    fetchXeroContact: function fetchXeroContact() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resp, respData, data;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__Xero_XeroAPIs__["a" /* default */].getXeroContacts();

              case 3:
                resp = _context2.sent;
                respData = resp.data;
                data = respData.data;

                _this2.xeroContacts = data || [];
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    addMoreProducts: function addMoreProducts(name) {
      this.productName = name;
      this.addDialog = true;
    },
    addProduct: function addProduct() {
      var products = {};
      if (this.isProductBudgetExceeded()) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.checkNatureOfDeals();
        switch (this.productName.toLowerCase()) {
          case 'storytell':
            products = {
              name: this.productName.toLowerCase(),

              totalOutReach: this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-',
              totalEngagement: this.client.moreAccount.totalEngagement ? this.client.moreAccount.totalEngagement : '-',
              minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
              maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
              noOfCampaigns: this.client.moreAccount.maxCampaigns ? this.client.moreAccount.maxCampaigns : '-',
              startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
              expireDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
              createdDate: Date.now()
            };
            break;
          case 'amplify':
            products = {
              name: this.productName.toLowerCase(),

              views: this.client.moreAccount.views ? this.client.moreAccount.views : '-',
              minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
              maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
              duration: this.client.moreAccount.duration ? this.client.moreAccount.duration : '-',
              startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
              expireDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
              createdDate: Date.now()
            };
            break;
          case 'uncut':
            products = {
              name: this.productName.toLowerCase(),

              totalOutReach: this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-',
              minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
              maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
              kpiOnboarded: this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-',
              startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
              endDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
              createdDate: Date.now()
            };
            break;
          case 'aok':
            products = {
              name: this.productName.toLowerCase(),

              totalOutReach: this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-',
              minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
              maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
              kpiOnboarded: this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-',
              startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
              endDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
              createdDate: Date.now()
            };
            break;
          case 'others':
            products = {
              name: this.productName.toLowerCase(),

              startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
              expireDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
              remark: this.client.moreAccount.remark ? this.client.moreAccount.remark : '-',
              natureOfDeal: this.client.moreAccount.natureOfDeal ? this.client.moreAccount.natureOfDeal : '-'
            };
            break;
          case 'loading fees':
            products = {
              name: this.productName.toLowerCase(),

              remark: this.client.moreAccount.remark ? this.client.moreAccount.remark : '-'
            };
            break;
          default:
            break;
        }
        this.client.deals.products.push(products);

        this.addDialog = false;
        this.$refs.form.reset();
        this.clearMoreAccountData();
      }
    },
    addDeals: function addDeals() {
      var _this3 = this;

      if (this.$refs.dealForm.validate()) {
        if (!this.client.deals.country.length) {
          this.$swal({
            type: 'warning',
            title: 'Please select country.'
          });
          return;
        }
        this.changeLinkedIO();
        this.dealCounter += 1;
        this.client.deals.IO = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.escapeSpecialChars(this.client.deals.IO);
        this.checkCountrySave();
        var deals = {
          name: this.client.deals.name,
          budget: this.client.deals.budget,
          IO: 'IO-' + this.client.deals.IO,
          linkedIOs: this.client.deals.linkedIOs,
          quoteAcceptanceDate: this.client.deals.quoteAcceptanceDate,
          remarks: this.client.deals.remarks,
          markupCOGS: this.client.deals.markupCOGS,
          cogsAmount: this.client.deals.cogsAmount,
          products: this.client.deals.products,
          country: this.client.deals.country,
          clientType: this.client.deals.clientType,
          servicesLine: this.client.deals.servicesLine,
          vertical: this.client.deals.vertical,
          masterListID: this.client.deals.masterListID || '',
          create_at: this.formattedDate(Date.now())
        };
        this.client.account.deals.push(deals);


        deals.products.map(function (item) {
          if (item.totalOutReach && item.totalOutReach !== '-') {
            _this3.client.account.totalOutreach += item.totalOutReach;
          }

          if (item.totalEngagement && item.totalEngagement !== '-') {
            _this3.client.account.totalEngagement += item.totalEngagement;
          }

          if (item.minContent && item.minContent !== '-') {
            _this3.client.account.minContent += item.minContent;
          }

          if (item.maxContent && item.maxContent !== '-') {
            _this3.client.account.maxContent += item.maxContent;
          }

          if (item.noOfCampaigns && item.noOfCampaigns !== '-') {
            _this3.client.account.maxCampaigns += item.noOfCampaigns;
          }
        });

        this.addDealsDialog = false;
        this.clearDeals();
      }
    },
    closeCreateModal: function closeCreateModal() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var confirm;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.closeConfirmationModal();

              case 2:
                confirm = _context3.sent;

                if (confirm) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                _this4.clearData();
                _this4.uploadMediaKey += 1;
                _this4.$emit('input');

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    deleteProductsFromAccountDetails: function deleteProductsFromAccountDetails(i, j) {

      if (this.client.account.totalOutreach) {
        this.client.account.totalOutreach -= this.client.account.deals[i].products[j].totalOutReach;
      }

      if (this.client.account.totalEngagement) {
        this.client.account.totalEngagement -= this.client.account.deals[i].products[j].totalEngagement;
      }

      if (this.client.account.minContent) {
        this.client.account.minContent -= this.client.account.deals[i].products[j].minContent;
      }

      if (this.client.account.maxContent) {
        this.client.account.maxContent -= this.client.account.deals[i].products[j].maxContent;
      }

      if (this.client.account.maxCampaigns) {
        this.client.account.maxCampaigns -= this.client.account.deals[i].products[j].noOfCampaigns;
      }

      this.client.account.deals[i].products.splice(j, 1);
    },
    deleteProducts: function deleteProducts(i) {

      if (this.client.account.totalOutreach) {
        this.client.account.totalOutreach -= this.client.deals.products[i].totalOutReach;
      }

      if (this.client.account.totalEngagement) {
        this.client.account.totalEngagement -= this.client.deals.products[i].totalEngagement;
      }

      if (this.client.account.minContent) {
        this.client.account.minContent -= this.client.deals.products[i].minContent;
      }

      if (this.client.account.maxContent) {
        this.client.account.maxContent -= this.client.deals.products[i].maxContent;
      }

      if (this.client.account.maxCampaigns) {
        this.client.account.maxCampaigns -= this.client.deals.products[i].noOfCampaigns;
      }

      this.client.deals.products.splice(i, 1);
    },
    deleteDeals: function deleteDeals(i) {
      var _this5 = this;

      if (this.client.account.budget) {
        this.client.account.budget -= this.client.account.deals[i].budget;
      }

      this.client.account.deals[i].products.map(function (item) {
        if (_this5.client.account.totalOutreach) {
          _this5.client.account.totalOutreach -= item.totalOutReach;
        }

        if (_this5.client.account.totalEngagement) {
          _this5.client.account.totalEngagement -= item.totalEngagement;
        }

        if (_this5.client.account.minContent) {
          _this5.client.account.minContent -= item.minContent;
        }

        if (_this5.client.account.maxContent) {
          _this5.client.account.maxContent -= item.maxContent;
        }

        if (_this5.client.account.maxCampaigns) {
          _this5.client.account.maxCampaigns -= item.noOfCampaigns;
        }
      });

      this.client.account.deals.splice(i, 1);
      if (this.client.account.deals.length === 0) {
        this.dealCounter = 0;
      }
    },
    closeAddProductsModal: function closeAddProductsModal() {
      this.$refs.form.reset();
      this.addDialog = false;
    },
    closeDealsModal: function closeDealsModal() {
      this.clearDeals();
      this.addDealsDialog = false;
    },
    formattedDate: function formattedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(date).format('DD MMM, YYYY');
    },
    formattedMonth: function formattedMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(date).format('MMM, YYYY');
    },
    closeConfirmationModal: function closeConfirmationModal() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.$swal({
                  title: 'Please confirm',
                  text: 'Are you sure to close?',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Yes'
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    mediaChanged: function mediaChanged(media) {
      this.client.media = media;
    },
    getAllClientGroups: function getAllClientGroups() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_10__clientAPIs__["a" /* default */].getClientGroups().then(function (response) {
        _this7.clientGroups = response.data;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getIONumbers: function getIONumbers(contactID) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this8.$store.dispatch('campaign/getCampaignMasterListsIONumbers', {
                  filters: {
                    contactID: contactID
                  }
                });

              case 2:
                _this8.displayMasterLists = [];
                if (_this8.client.group) {
                  _this8.displayMasterLists = _this8.masterLists.map(function (m) {
                    m.quoteNo = m.quoteNo ? _this8.cutIO(m.quoteNo) : '';
                    return m;
                  });
                  if (_this8.client.group.ContactID) {
                    _this8.displayMasterLists = _this8.displayMasterLists.filter(function (master) {
                      if (master.billingContact) {
                        if (master.billingContact.ContactID === _this8.client.group.ContactID) return true;
                      }
                      return false;
                    });
                  }
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    addDefaultContact: function addDefaultContact() {
      this.client.contacts.push({
        contactName: '',
        email: '',
        includeEmail: true,
        invalid: false
      });
    },
    removeContact: function removeContact(index) {
      this.client.contacts.splice(index, 1);
    },
    filterEmptyContacts: function filterEmptyContacts(clientData) {
      if (clientData.contacts !== undefined) {
        clientData.contacts = clientData.contacts.filter(function (c) {
          return c.contactName !== '' && c.email !== '';
        });
        clientData.contacts = clientData.contacts.map(function (c) {
          c.email = c.email.toLowerCase();
          return c;
        });
      }
      return clientData;
    },
    getProductName: function getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut';
      }
      return itemName;
    },
    changeClientGroup: function changeClientGroup() {
      this.client.name = this.client.group ? this.client.group.Name : '';
      this.getIONumbers(this.client.group.ContactID);
    },
    displayCampaignVerticals: function displayCampaignVerticals(vertical) {
      var selectedCampaignVertical = [];
      if (vertical) {
        this.campaignVerticals.map(function (item) {
          vertical.map(function (v) {
            if (item.id === v.id) {
              selectedCampaignVertical.push(item);
            }
          });
        });
      }
      return selectedCampaignVertical.map(function (s) {
        return s.name;
      }).join(', ');
    },

    getCountryDisplayValueFromSelect: function getCountryDisplayValueFromSelect(value) {
      if (typeof value === 'string') return value;
      var selectedOption = this.countries.filter(function (option) {
        return value.includes(option.value);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.text;
      }).join(', ') : '-';
    },
    getClientTypeDisplayValue: function getClientTypeDisplayValue(value) {
      if (value) {
        var matchClient = this.clientTypes.find(function (c) {
          return c.value === value;
        });
        if (matchClient) return matchClient.title;
      }
      return '-';
    },
    displayNatureOfDeals: function displayNatureOfDeals(deals) {
      return Array.isArray(deals) ? deals.map(function (d) {
        return d.name || '';
      }).join(', ') : '';
    },
    updateSelectedDedicated: function updateSelectedDedicated(newValue) {
      this.selectedDedicatedPersons = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], newValue);
    },
    updateSelectedSupporting: function updateSelectedSupporting(newValue) {
      this.selectedSupportingPersons = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], newValue);
    },
    checkNatureOfDeals: function checkNatureOfDeals() {
      var _this9 = this;

      if (this.client.moreAccount) {
        if (this.client.moreAccount.natureOfDeal) {
          this.client.moreAccount.natureOfDeal = this.client.moreAccount.natureOfDeal.map(function (v) {
            if (typeof v === 'string') {
              v = {
                id: 0,
                name: v
              };
              _this9.dealNatureLists.push(v);
            }
            return v;
          });
        }
      }
    },
    checkCountrySave: function checkCountrySave() {},
    changeIONumber: function changeIONumber() {
      var _this10 = this;

      var matchMasterData = this.findMasterList(this.client.deals.IO);
      this.client.deals.masterListID = '';
      this.client.deals.quoteAcceptanceDate = '';
      this.client.deals.previewBudget = '';
      this.client.deals.budget = '';
      this.client.deals.linkedIOs = [];
      if (matchMasterData) {
        var mainIO = this.normalizeIONumber(matchMasterData.quoteNo);
        var linkedIOs = Array.isArray(matchMasterData.linkedIOs) ? matchMasterData.linkedIOs : [];
        this.client.deals.linkedIOs = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(linkedIOs.map(function (linkedIO) {
          return _this10.normalizeIONumber(linkedIO);
        }).filter(function (linkedIO) {
          return linkedIO && linkedIO !== mainIO && _this10.findMasterList(linkedIO);
        }))));
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData);
        this.client.deals.masterListID = matchMasterData.id;
        this.client.deals.quoteAcceptanceDate = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.parseDate(matchMasterData.acceptanceDate);
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs);
      }
    },
    changeLinkedIO: function changeLinkedIO() {
      var _this11 = this;

      var matchMasterData = this.findMasterList(this.client.deals.IO);
      if (matchMasterData) {
        var mainIO = this.normalizeIONumber(matchMasterData.quoteNo);
        this.client.deals.linkedIOs = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a((this.client.deals.linkedIOs || []).map(function (linkedIO) {
          return _this11.normalizeIONumber(linkedIO);
        }).filter(function (linkedIO) {
          return linkedIO && linkedIO !== mainIO;
        }))));
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData);
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs);
      }
    },
    normalizeIONumber: function normalizeIONumber(value) {
      return String(value || '').trim().replace(/^IO-/i, '');
    },
    findMasterList: function findMasterList(ioNumber) {
      var _this12 = this;

      var normalizedIO = this.normalizeIONumber(ioNumber);
      return this.masterLists.find(function (master) {
        return _this12.normalizeIONumber(master.quoteNo) === normalizedIO;
      });
    },
    getIOBudget: function getIOBudget(masterList) {
      if (!masterList) return 0;
      var budget = Number(String(masterList.quoteAmt || 0).replace(/,/g, ''));
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(budget) ? budget : 0;
    },
    calculateTotalIOBudget: function calculateTotalIOBudget(mainMasterList, linkedIOs) {
      var _this13 = this;

      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(linkedIOs || []))).reduce(function (total, linkedIO) {
        return total + _this13.getIOBudget(_this13.findMasterList(linkedIO));
      }, this.getIOBudget(mainMasterList));
    },
    cutIO: function cutIO(IO) {
      var re = new RegExp('IO-', 'g');
      return IO.replace(re, '');
    },
    isProductBudgetExceeded: function isProductBudgetExceeded() {
      if (Number(this.client.moreAccount.budget) > Number(this.client.deals.budget)) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Product budget cannot be greater than Deal Budget'
        });
        return true;
      }
      return false;
    },
    setDateFromPicker: function setDateFromPicker(fieldName, value) {
      this.client.deals[fieldName] = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.client.deals = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.client.deals);
    },
    checkDate: function checkDate(fieldName) {
      if (!this.client.deals[fieldName]) return;
      this.validActivationDate = false;
      if (__WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.isDateFormatValid(this.client.deals[fieldName]) || !this.client.deals[fieldName]) {
        this.validActivationDate = true;
      }
      this.client.deals = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.client.deals);
    },
    checkAccEmail: function checkAccEmail(index) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var contactOne, resp;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this14.invalidContactEmail = false;
                _this14.client.contacts[index].invalid = false;
                contactOne = _this14.client.contacts[index];
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].checkClientUser({
                  clientID: null,
                  email: contactOne.email.toLowerCase()
                });

              case 5:
                resp = _context6.sent;

                if (!resp.success) {
                  _this14.client.contacts[index].invalid = true;
                  _this14.invalidContactEmail = true;
                }

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this14);
      }))();
    },
    showLinkedIO: function showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return '';
      IOs = IOs.map(function (i) {
        if (!i.includes('IO-')) {
          i = 'IO-' + i;
        }
        return i;
      });
      return IOs.join(', ');
    },
    addLinkIO: function addLinkIO() {
      this.client.deals.linkedIOs.push('');
    },
    deleteLinkIO: function deleteLinkIO(idx) {
      this.client.deals.linkedIOs.splice(idx, 1);
      this.changeLinkedIO();
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  },
  mounted: function mounted() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var resp;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (_this15.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this15.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
                __WEBPACK_IMPORTED_MODULE_11__Company_companyAPIs__["a" /* default */].getAllCompanies(false).then(function (response) {
                  _this15.company_options = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });
              }

              __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW).then(function (response) {
                _this15.salePerson_options = response.users;
              }).catch(function (error) {
                console.log('error', error);
              });
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 4:
              resp = _context7.sent;

              if (resp) _this15.CO = resp.users;
              _context7.next = 8;
              return __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

            case 8:
              resp = _context7.sent;

              if (resp) _this15.AM = resp.users;
              _this15.assignUsers = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this15.CO), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this15.AM)));

              _this15.getAllClientGroups();
              _this15.fetchXeroContact();
              _this15.$store.dispatch('campaign/getCampaignVerticals');
              _context7.next = 16;
              return _this15.$store.dispatch('campaign/getCountries');

            case 16:
              _context7.next = 18;
              return _this15.$store.dispatch('client/getDealNatures');

            case 18:
              _this15.dealNatureLists = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this15.dealNatures);

            case 19:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this15);
    }))();
  }
});

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clientConfig_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_logoDataURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_submissionID__ = __webpack_require__(831);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateFeedbacksForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_6_vuelidate__["validationMixin"]],
  validations: function validations() {
    var _feedback,
        _this = this;

    var validationRules = {
      feedback: (_feedback = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_feedback, this.feedbackFormSections.what_did_well.name, { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"] }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_feedback, this.feedbackFormSections.what_can_improve.name, { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"] }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_feedback, this.feedbackFormSections.buyagain_decision.name, this.feedbackFormSections.buyagain_decision.required ? {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.other_buyagain_decisions;
        })
      } : {}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_feedback, this.feedbackFormSections.sea_countries.name, this.feedbackFormSections.sea_countries.required ? {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.other_sea_countries;
        })
      } : {}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_feedback, this.feedbackFormSections.platforms.name, this.feedbackFormSections.platforms.required ? {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.other_platforms;
        })
      } : {}), _feedback),
      other_buyagain_decisions: this.feedbackFormSections.buyagain_decision.required ? {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.feedback.buyagain_decisions.length;
        })
      } : {},
      other_sea_countries: this.feedbackFormSections.sea_countries.required ? {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.feedback.sea_countries.length;
        })
      } : {},
      other_platforms: this.feedbackFormSections.platforms.required ? {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["requiredIf"])(function () {
          return !this.feedback.platforms.length;
        })
      } : {}
    };

    var multiplevalidations = ['good_ratings', 'likely_recommend', 'likely_consider_again', 'inf_line_up', 'inf_content_created', 'kobe_questions', 'refer_info', 'contact_info'];

    multiplevalidations.map(function (val) {
      _this.feedbackFormSections[val].fields.forEach(function (field) {
        var addRule = false;
        if (val === 'kobe_questions') {
          addRule = field.name !== 'open_sharing_feedback';
        } else addRule = true;
        if (addRule) validationRules['feedback'][field.name] = { required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"] };
      });
    });
    return validationRules;
  },
  data: function data() {
    return {
      formLoading: true,
      formError: '',
      feedbackReady: false,
      complete: false,
      dialog: true,
      submitting: false,
      valid: true,
      campaignID: '',
      campaign_name: '',
      amID: '',
      amFirstName: '',
      amLastName: '',
      amFullName: '',
      amEmail: '',
      coID: '',
      coFullName: '',
      clientID: '',
      clientName: '',
      feedbackFormSections: __WEBPACK_IMPORTED_MODULE_5__clientConfig_js__["a" /* default */].feedbackFormSections,
      feedback: {
        buyagain_decisions: [],
        sea_countries: [],
        platforms: [],
        scheduleSharing: false
      },
      submissionID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_submissionID__["a" /* createSubmissionID */])(),
      other_buyagain_decisions: '',
      other_sea_countries: '',
      other_platforms: '',
      logoDataUrl: __WEBPACK_IMPORTED_MODULE_9__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png'
    };
  },

  watch: {
    other_buyagain_decisions: {
      handler: function handler(newValue, oldValue) {
        var index = this.feedback.buyagain_decisions.indexOf(oldValue);
        if (index === -1) {
          this.feedback.buyagain_decisions.push(newValue);
        } else {
          this.feedback.buyagain_decisions[index] = newValue;
        }
        this.feedback.buyagain_decisions = this.feedback.buyagain_decisions.filter(function (el) {
          return el !== '';
        });
      }
    },
    other_sea_countries: {
      handler: function handler(newValue, oldValue) {
        var index = this.feedback.sea_countries.indexOf(oldValue);
        if (index === -1) {
          this.feedback.sea_countries.push(newValue);
        } else {
          this.feedback.sea_countries[index] = newValue;
        }
        this.feedback.sea_countries = this.feedback.sea_countries.filter(function (el) {
          return el !== '';
        });
      }
    },
    other_platforms: {
      handler: function handler(newValue, oldValue) {
        var index = this.feedback.platforms.indexOf(oldValue);
        if (index === -1) {
          this.feedback.platforms.push(newValue);
        } else {
          this.feedback.platforms[index] = newValue;
        }
        this.feedback.platforms = this.feedback.platforms.filter(function (el) {
          return el !== '';
        });
      }
    }
  },
  computed: {
    starSize: function starSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 28;
        case 'sm':
          return 30;
        case 'md':
          return 30;
        case 'lg':
          return 30;
        case 'xl':
          return 30;
      }
    }
  },
  methods: {
    close: function close() {
      this.$router.push({ path: '/client' });
    },
    submitFeedback: function submitFeedback() {
      var _this2 = this;

      if (this.submitting || this.complete || !this.feedbackReady) return;
      this.$v.$touch();
      if (this.$v.feedback.$error) {
        return false;
      }
      this.submitting = true;
      var feedback = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.feedback);
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var formData = new FormData();
          formData.append('feedback', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(feedback));
          formData.append('campaignID', _this2.campaignID);
          formData.append('token', new URLSearchParams(_this2.$route.hash.slice(1)).get('token') || '');
          formData.append('submissionID', _this2.submissionID);
          __WEBPACK_IMPORTED_MODULE_8__Campaign_campaignAPIs__["a" /* default */].createClientFeedback(formData).then(function (response) {
            setTimeout(function () {
              _this2.submitting = false;
            }, 2000);
            _this2.complete = true;
          }).catch(function (error) {
            setTimeout(function () {
              _this2.submitting = false;
            }, 2000);

            console.log('error', error);
            _this2.$swal({
              text: error.response && error.response.data && error.response.data.message || 'Unable to submit feedback. Your answers have been kept.',
              type: 'error'
            });
          });
        } else {
          setTimeout(function () {
            _this2.submitting = false;
          }, 1000);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.campaignID = this.$route.params.campaignId;
    __WEBPACK_IMPORTED_MODULE_8__Campaign_campaignAPIs__["a" /* default */].getCampaignDetailForFeedbackInvitation(this.campaignID, new URLSearchParams(this.$route.hash.slice(1)).get('token') || '').then(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (response.id) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Invalid feedback link.');

              case 2:
                _this3.campaignID = response.id;
                _this3.campaign_name = response.name;
                _this3.amID = response.am.id;
                _this3.amFirstName = response.am.firstName;
                _this3.amFirstName = response.am.lastName;
                _this3.amFullName = response.am.firstName + ' ' + response.am.lastName;
                _this3.amEmail = response.am.email;
                _this3.coID = response.co.id;
                _this3.coFullName = response.co.firstName + ' ' + response.co.lastName;
                _this3.clientID = response.client.id;
                _this3.clientName = response.client.name;
                _this3.feedbackReady = true;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(function (error) {
      _this3.formError = error.response && error.response.data && error.response.data.message || 'This feedback link is unavailable. Please request a new link from your account manager.';
    }).finally(function () {
      _this3.formLoading = false;
    });
  }
});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PayoutUpdateModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    dealData: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vuelidate__["validationMixin"]],
  validations: function validations() {
    var validationRules = {
      updateData: {
        amount: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
      }
    };
    return validationRules;
  },
  data: function data() {
    return {
      isLoading: false,
      updateData: {
        amount: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    value: function value(newValue) {
      this.updateData = {
        amount: ''
      };
    }
  },
  methods: {
    saveCustomAmount: function saveCustomAmount() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newDealData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$v.$touch();
                newDealData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.dealData);

                newDealData.amount = _this2.updateData.amount;
                _this2.$emit('addedAmount', newDealData);
                _this2.close();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__clientConfig_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Company_companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Xero_XeroAPIs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__upload__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AssignTeam__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AssignTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__AssignTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__static_sources_countries__);






























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditClientModal',
  props: {
    modalId: String,
    clientData: Object,
    viewMode: Boolean,
    value: Boolean
  },
  components: {
    AssignTeam: __WEBPACK_IMPORTED_MODULE_22__AssignTeam___default.a,
    uploadMedia: __WEBPACK_IMPORTED_MODULE_20__upload___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_DatePicker___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_18_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_25__static_sources_countries___default.a,
      xeroContacts: [],
      company_options: [],
      salePerson_options: [],
      numberOfCampaigns: [1, 2, 3, 4, 5],
      panels: [0],
      contactPanels: [0],
      sameWithContactInfo: false,
      startCal: false,
      expireCal: false,
      moreStartCal: false,
      moreExpireCal: false,
      durationCal: false,
      loading: false,
      pickDate: false,
      client: {
        xeroContact: null,
        name: '',

        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        salePerson: '',

        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: '',
          remark: ''
        },
        deals: {
          previewBudget: 0,
          budget: 0,
          IO: '',
          linkedIOs: [],
          markupCOGS: false,
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          servicesLine: '',
          activationDate: ''
        },
        media: [],
        contacts: []
      },
      addEditDialog: false,
      addDealsDialog: false,
      productName: '',
      accountProducts: [],
      accountDeals: [],
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      },
      productAction: '',
      editItemIndex: '',
      dealAction: '',
      editDealItemIndex: '',
      handledBy: [],
      CO: [],
      orgHandledBy: [],
      AM: [],
      assignUsers: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      dedicatedData: [],
      supportingData: [],
      dealNatureLists: [],
      newDealNature: '',
      dealCounter: 0,

      clientTypes: [{
        title: 'Direct',
        value: 'direct'
      }, {
        title: 'Agency',
        value: 'agency'
      }],
      natureOfDealOptions: ['Loading Fees/whitelisting', 'Physical Attendance/Event'],
      lineOfServices: ['Storytell', 'Storytell + BCA', 'Storytell + Uncut', 'Uncut', 'Loading Fees', 'Academy'],
      displayMasterLists: []
    };
  },

  watch: {
    clientData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee(newClientData) {
        var _this = this;

        var ObjMoreAccount, ObjDeals;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('campaign/getCountries');

              case 2:
                _context.next = 4;
                return this.getIONumbers(newClientData.group ? newClientData.group.ContactID : null);

              case 4:
                this.handledBy = [];
                ObjMoreAccount = {
                  budget: 0,
                  totalOutReach: 0,
                  totalEngagement: 0,
                  minContent: 0,
                  maxContent: 0,
                  maxCampaigns: 0,
                  startDate: '',
                  expireDate: '',
                  views: '',
                  durations: '',
                  noOfContents: ''
                };

                newClientData.moreAccount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, ObjMoreAccount);

                ObjDeals = {
                  budget: 0,
                  IO: '',
                  linkedIOs: [],
                  markupCOGS: false,
                  cogsAmount: '',
                  activationDate: '',
                  products: []
                };

                newClientData.deals = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, ObjDeals);
                _context.next = 11;
                return this.getAssignUsers();

              case 11:
                this.dedicatedData = [];
                this.supportingData = [];
                if (newClientData.handledBy) {
                  this.assignUsers.map(function (item) {
                    newClientData.handledBy.map(function (userId) {
                      if (item.id === userId) {
                        _this.dedicatedData.push(item);
                        _this.selectedDedicatedPersons.push(item);
                      }
                    });
                  });
                }
                if (newClientData.supportedBy) {
                  this.assignUsers.map(function (item) {
                    newClientData.supportedBy.map(function (userId) {
                      if (item.id === userId) {
                        _this.supportingData.push(item);
                      }
                    });
                  });
                }

                if (!newClientData.account) {
                  this.client.account = {
                    budget: 0,
                    totalOutreach: 0,
                    totalEngagement: 0,
                    minContent: 0,
                    maxContent: 0,
                    maxCampaigns: 0,
                    startDate: '',
                    expireDate: '',
                    deals: []
                  };
                  this.accountDeals = [];
                } else {
                  if (newClientData.account.deals) {
                    newClientData.account.deals = newClientData.account.deals.map(function (deal) {
                      if (deal.country) {
                        if (_this.countries.length) {
                          deal.country = __WEBPACK_IMPORTED_MODULE_24__Campaign_campaignHelper__["a" /* default */].formatCountry(_this.countries, deal.country || []);
                        }
                      }
                      if (deal.IO) {
                        deal.masterListCheck = _this.getMasterlistCheck(deal.IO);
                      }
                      return deal;
                    });
                    this.accountDeals = newClientData.account.deals;
                    this.dealCounter = newClientData.account.deals.length;
                  } else {
                    this.accountDeals = [];
                    this.dealCounter = 0;
                  }
                }
                this.client = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, newClientData);

                _context.next = 19;
                return this.getCampaignsByClientID();

              case 19:
                if (this.client.contacts === undefined) {
                  this.client.contacts = [];
                } else {
                  this.client.contacts = this.client.contacts.map(function (c) {
                    if (c.campaigns !== undefined) {
                      c.campaigns = _this.campaigns.filter(function (campaign) {
                        return c.campaigns.includes(campaign.id);
                      });
                    }
                    return c;
                  });
                }

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function clientData(_x) {
        return _ref.apply(this, arguments);
      }

      return clientData;
    }(),
    sameWithContactInfo: function sameWithContactInfo(newInfo) {
      if (newInfo) {
        this.sameWithContactInfo = newInfo;
        this.client.billingPhoneNumber = this.client.phoneNumber;
        this.client.billingEmail = this.client.email;
        this.client.billingAddress = this.client.address;
      }
    }
  },
  validations: {
    client: {
      email: { email: __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__["email"] },
      name: { required: __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__["required"] },
      address: { required: __WEBPACK_IMPORTED_MODULE_17_vuelidate_lib_validators__["required"] }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    campaignVerticals: function campaignVerticals(state) {
      return state.campaign.campaignVerticals;
    },
    dealNatures: function dealNatures(state) {
      return state.client.dealNatures;
    },
    masterLists: function masterLists(state) {
      return state.campaign.masterLists;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isLinkMasterListBtn: function isLinkMasterListBtn() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.FINANCE;
    },
    needCompany: function needCompany() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW) {
        return false;
      } else if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        return true;
      }
      return false;
    },
    clientPaymentModes: function clientPaymentModes() {
      return __WEBPACK_IMPORTED_MODULE_11__clientConfig_js__["a" /* default */].clientPaymentModes;
    },
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.client.name.$dirty) return errors;
      !this.$v.client.name.required && errors.push('Name is required');
      return errors;
    },
    addressErrors: function addressErrors() {
      var errors = [];
      if (!this.$v.client.address.$dirty) return errors;
      !this.$v.client.address.required && errors.push('Address is required');
      return errors;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.client.email.$dirty) return errors;
      !this.$v.client.email.email && errors.push('Invalid email format');
      return errors;
    },
    showProductName: function showProductName() {
      if (this.productName === 'aok') {
        return 'AOK/Uncut';
      }
      return this.productName;
    },
    invalidContactEmail: function invalidContactEmail() {
      var isInvalid = false;
      this.client.contacts.map(function (c) {
        if (c.invalid) isInvalid = true;
      });
      return isInvalid;
    },
    isEmptyContact: function isEmptyContact() {
      if (this.client.contacts.length) {
        if (!this.client.contacts[0].email) {
          return true;
        }
        return false;
      }
      return true;
    }
  }),
  methods: {
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    },
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */]['userPermissions']['client'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },

    editClient: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var hasAM, hasCC, dedicatedIDs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, AM, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, CC, client, clientFormData;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$v.$touch();

                if (!this.$v.$invalid) {
                  _context2.next = 4;
                  break;
                }

                this.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Make sure you filled the required information correctly.'
                });
                return _context2.abrupt('return');

              case 4:
                if (!this.invalidContactEmail) {
                  _context2.next = 7;
                  break;
                }

                this.$swal({
                  type: 'error',
                  title: 'Contact email already exists.'
                });
                return _context2.abrupt('return');

              case 7:
                if (!this.isEmptyContact) {
                  _context2.next = 10;
                  break;
                }

                this.$swal({
                  type: 'error',
                  title: 'Please add at least one contact.'
                });
                return _context2.abrupt('return');

              case 10:
                hasAM = false;
                hasCC = false;
                dedicatedIDs = this.selectedDedicatedPersons.map(function (s) {
                  return s.id;
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 16;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.AM); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  AM = _step.value;

                  if (dedicatedIDs.includes(AM.id)) {
                    hasAM = true;
                  }
                }
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](16);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 24:
                _context2.prev = 24;
                _context2.prev = 25;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 27:
                _context2.prev = 27;

                if (!_didIteratorError) {
                  _context2.next = 30;
                  break;
                }

                throw _iteratorError;

              case 30:
                return _context2.finish(27);

              case 31:
                return _context2.finish(24);

              case 32:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 35;
                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.CO); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  CC = _step2.value;

                  if (dedicatedIDs.includes(CC.id)) {
                    hasCC = true;
                  }
                }
                _context2.next = 43;
                break;

              case 39:
                _context2.prev = 39;
                _context2.t1 = _context2['catch'](35);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t1;

              case 43:
                _context2.prev = 43;
                _context2.prev = 44;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 46:
                _context2.prev = 46;

                if (!_didIteratorError2) {
                  _context2.next = 49;
                  break;
                }

                throw _iteratorError2;

              case 49:
                return _context2.finish(46);

              case 50:
                return _context2.finish(43);

              case 51:
                if (!(!hasAM || !hasCC)) {
                  _context2.next = 54;
                  break;
                }

                this.$swal({
                  type: 'error',
                  title: 'Please select at least one AM and CC'
                });
                return _context2.abrupt('return');

              case 54:
                client = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.client);

                delete client.companyID;
                delete client.moreAccount;
                delete client.deals;

                client.handledBy = [];
                this.selectedDedicatedPersons.map(function (item) {
                  if (!client.handledBy.includes(item.id)) {
                    client.handledBy.push(item.id);
                  }
                });
                client.supportedBy = [];
                this.selectedSupportingPersons.map(function (item) {
                  if (!client.supportedBy.includes(item.id)) {
                    client.supportedBy.push(item.id);
                  }
                });
                if (client.contacts.length > 0) {
                  this.client.contacts = this.client.contacts.map(function (c) {
                    if (c.campaigns !== undefined) {
                      c.campaigns = c.campaigns.map(function (c) {
                        return c.id;
                      });
                    }
                    return c;
                  });
                }
                clientFormData = this.buildFormData(client);

                this.loading = true;
                _context2.next = 67;
                return __WEBPACK_IMPORTED_MODULE_12__clientAPIs__["a" /* default */].editClient(clientFormData, client.id).then(function (response) {
                  _this2.loading = false;
                  _this2.updateClientUserCampaigns();

                  _this2.$emit('editClient', response);
                  _this2.$swal({
                    title: 'Successful',
                    text: 'Client account is updated.',
                    type: 'success'
                  }).then(function () {
                    _this2.clearData();
                    _this2.$emit('input');
                  });
                }).catch(function (error) {
                  _this2.loading = false;
                  _this2.$swal({
                    title: 'Error',
                    text: error,
                    type: 'error'
                  });
                  console.log('error', error);
                });

              case 67:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[16, 20, 24, 32], [25,, 27, 31], [35, 39, 43, 51], [44,, 46, 50]]);
      }));

      function editClient() {
        return _ref2.apply(this, arguments);
      }

      return editClient;
    }(),
    buildFormData: function buildFormData(clientData) {
      clientData = this.filterEmptyContacts(clientData);
      var formData = new FormData();
      var client = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, clientData);

      var medias = client.media ? client.media.map(function (m) {
        return m.file;
      }) : [];

      delete client.media;
      formData.append('client', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(client));

      if (medias) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(medias), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var media = _step3.value;

            formData.append('images', media);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return formData;
    },

    clearData: function clearData() {
      this.$v.$reset();
      this.client = {
        name: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        salePerson: '',
        email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          products: [],
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: ''
        },
        deals: {
          budget: 0,
          IO: '',
          linkedIOs: [],
          markupCOGS: false,
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          activationDate: ''
        },
        contacts: []
      };
      this.productName = '';
    },
    fetchXeroContact: function fetchXeroContact() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, respData, data;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__Xero_XeroAPIs__["a" /* default */].getXeroContacts();

              case 3:
                resp = _context3.sent;
                respData = resp.data;
                data = respData.data;

                _this3.xeroContacts = data || [];
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    formattedDate: function formattedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(date).format('DD MMM, YYYY');
    },
    formattedMonth: function formattedMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(date).format('MMM, YYYY');
    },
    clearMoreAccountData: function clearMoreAccountData() {
      this.client.moreAccount.budget = '';
      this.client.moreAccount.totalOutReach = '';
      this.client.moreAccount.totalEngagement = '';
      this.client.moreAccount.minContent = '';
      this.client.moreAccount.maxContent = '';
      this.client.moreAccount.maxCampaigns = '';
      this.client.moreAccount.startDate = '';
      this.client.moreAccount.expireDate = '';
      this.client.moreAccount.views = '';
      this.client.moreAccount.noOfContents = '';
      this.client.moreAccount.duration = '';
    },
    addDeals: function addDeals() {
      this.dealAction = 'add';
      this.addDealsDialog = true;
    },
    dealsEdit: function dealsEdit(i) {
      var productsObject = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], this.client.account.deals[i].products);
      this.dealAction = 'edit';
      this.editDealItemIndex = i;
      this.accountProducts = productsObject;
      this.client.deals.name = this.client.account.deals[i].name;
      this.client.deals.budget = this.client.account.deals[i].budget;
      this.client.deals.IO = this.cutIO(this.client.account.deals[i].IO);
      this.client.deals.linkedIOs = this.client.account.deals[i].linkedIOs;
      this.client.deals.quoteAcceptanceDate = this.client.account.deals[i].quoteAcceptanceDate;
      this.client.deals.country = this.client.account.deals[i].country;
      this.client.deals.clientType = this.client.account.deals[i].clientType;
      this.client.deals.servicesLine = this.client.account.deals[i].servicesLine;
      this.client.deals.vertical = this.client.account.deals[i].vertical;
      this.client.deals.remarks = this.client.account.deals[i].remarks;
      this.client.deals.markupCOGS = this.client.account.deals[i].markupCOGS;
      this.client.deals.activationDate = this.client.account.deals[i].activationDate;
      this.client.deals.cogsAmount = this.client.account.deals[i].cogsAmount;
      this.addDealsDialog = true;
    },
    addProducts: function addProducts(name) {
      this.productAction = 'add';
      this.productName = name;
      this.addEditDialog = true;
    },
    productEdit: function productEdit(item, index) {
      this.productAction = 'edit';
      this.editItemIndex = index;
      this.productName = item.name;
      this.client.moreAccount.budget = item.budget;
      this.client.moreAccount.totalOutReach = item.totalOutReach;
      this.client.moreAccount.totalEngagement = item.totalEngagement;
      this.client.moreAccount.minContent = item.minContent;
      this.client.moreAccount.maxContent = item.maxContent;
      this.client.moreAccount.maxCampaigns = item.noOfCampaigns;
      this.client.moreAccount.kpiOnboarded = item.kpiOnboarded;
      this.client.moreAccount.noOfContents = item.noOfContents;
      this.client.moreAccount.views = item.views;
      this.client.moreAccount.duration = item.duration;
      this.client.moreAccount.remark = item.remark;
      this.client.moreAccount.natureOfDeal = item.natureOfDeal;


      this.addEditDialog = true;
    },
    addEditProduct: function addEditProduct() {
      var products = {};
      if (this.isProductBudgetExceeded()) {
        return;
      }
      if (this.productAction === 'add') {
        if (this.$refs.form.validate()) {
          this.checkNatureOfDeals();
          switch (this.productName.toLowerCase()) {
            case 'storytell':
              products = {
                name: this.productName.toLowerCase(),
                budget: this.client.moreAccount.budget ? this.client.moreAccount.budget : '-',
                totalOutReach: this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-',
                totalEngagement: this.client.moreAccount.totalEngagement ? this.client.moreAccount.totalEngagement : '-',
                minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
                maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
                noOfCampaigns: this.client.moreAccount.maxCampaigns ? this.client.moreAccount.maxCampaigns : '-',
                startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
                expireDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
                createdDate: Date.now()
              };
              break;
            case 'amplify':
              products = {
                name: this.productName.toLowerCase(),
                budget: this.client.moreAccount.budget ? this.client.moreAccount.budget : '-',
                views: this.client.moreAccount.views ? this.client.moreAccount.views : '-',
                minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
                maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
                duration: this.client.moreAccount.duration ? this.client.moreAccount.duration : '-',
                startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
                expireDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
                createdDate: Date.now()
              };
              break;
            case 'uncut':
              products = {
                name: this.productName.toLowerCase(),
                budget: this.client.moreAccount.budget ? this.client.moreAccount.budget : '-',
                totalOutReach: this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-',
                minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
                maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
                kpiOnboarded: this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-',
                startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
                endDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
                createdDate: Date.now()
              };
              break;
            case 'aok':
              products = {
                name: this.productName.toLowerCase(),
                budget: this.client.moreAccount.budget ? this.client.moreAccount.budget : '-',
                totalOutReach: this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-',
                minContent: this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-',
                maxContent: this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-',
                kpiOnboarded: this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-',
                startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
                endDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
                createdDate: Date.now()
              };
              break;
            case 'others':
              products = {
                name: this.productName.toLowerCase(),
                budget: this.client.moreAccount.budget ? this.client.moreAccount.budget : '-',
                startDate: this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-',
                expireDate: this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-',
                remark: this.client.moreAccount.remark ? this.client.moreAccount.remark : '-',
                natureOfDeal: this.client.moreAccount.natureOfDeal ? this.client.moreAccount.natureOfDeal : '-'
              };
              break;
            case 'loading fees':
              products = {
                name: this.productName.toLowerCase(),
                budget: this.client.moreAccount.budget ? this.client.moreAccount.budget : '-',
                remark: this.client.moreAccount.remark ? this.client.moreAccount.remark : '-'
              };
              break;
            default:
              break;
          }
          this.accountProducts.push(products);

          this.addEditDialog = false;
          this.$refs.form.reset();
          this.clearMoreAccountData();
        }
      } else {
        this.checkNatureOfDeals();
        this.accountProducts[this.editItemIndex].budget = this.client.moreAccount.budget ? this.client.moreAccount.budget : '-';
        this.accountProducts[this.editItemIndex].totalOutReach = this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-';
        this.accountProducts[this.editItemIndex].views = this.client.moreAccount.views ? this.client.moreAccount.views : '-';
        this.accountProducts[this.editItemIndex].noOfContents = this.client.moreAccount.noOfContents ? this.client.moreAccount.noOfContents : '-';
        this.accountProducts[this.editItemIndex].duration = this.client.moreAccount.duration ? this.client.moreAccount.duration : '-';
        this.accountProducts[this.editItemIndex].totalEngagement = this.client.moreAccount.totalEngagement ? this.client.moreAccount.totalEngagement : '-';
        this.accountProducts[this.editItemIndex].minContent = this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-';
        this.accountProducts[this.editItemIndex].maxContent = this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-';
        this.accountProducts[this.editItemIndex].noOfCampaigns = this.client.moreAccount.maxCampaigns ? this.client.moreAccount.maxCampaigns : '-';
        this.accountProducts[this.editItemIndex].kpiOnboarded = this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-';
        this.accountProducts[this.editItemIndex].remark = this.client.moreAccount.remark ? this.client.moreAccount.remark : '-';
        this.accountProducts[this.editItemIndex].natureOfDeal = this.client.moreAccount.natureOfDeal ? this.client.moreAccount.natureOfDeal : '-';
        this.accountProducts[this.editItemIndex].startDate = this.client.moreAccount.startDate ? this.client.moreAccount.startDate : '-';
        if (this.accountProducts[this.editItemIndex].name.toLowerCase() === 'uncut') {
          this.accountProducts[this.editItemIndex].endDate = this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-';
        } else {
          this.accountProducts[this.editItemIndex].expireDate = this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-';
        }
        this.accountProducts[this.editItemIndex].createdDate = Date.now();

        var totalBudget = 0;
        var totalOutreach = 0;
        var totalEngagement = 0;
        var totalMinContents = 0;
        var totalMaxContents = 0;
        var noOfCampaigns = 0;
        this.accountProducts.map(function (item) {
          totalBudget += item.budget;
          totalOutreach += item.totalOutReach;
          totalEngagement += item.totalEngagement;
          totalMinContents += item.minContent;
          totalMaxContents += item.maxContent;
          noOfCampaigns += item.noOfCampaigns;
        });
        this.client.account.budget = totalBudget;
        this.client.account.totalOutreach = totalOutreach;
        this.client.account.totalEngagement = totalEngagement;
        this.client.account.minContent = totalMinContents;
        this.client.account.maxContent = totalMaxContents;
        this.client.account.maxCampaigns = noOfCampaigns;

        this.addEditDialog = false;
        this.$refs.form.reset();
        this.clearMoreAccountData();
      }
    },
    addEditDeals: function addEditDeals() {
      var _this4 = this;

      if (this.$refs.dealForm.validate()) {
        if (!this.client.deals.country.length) {
          this.$swal({
            type: 'warning',
            title: 'Please select country.'
          });
          return;
        }
        this.changeLinkedIO();
        if (this.dealAction === 'add') {
          this.client.deals.IO = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.escapeSpecialChars(this.client.deals.IO);
          this.checkCountrySave();
          this.dealCounter += 1;
          var deals = {
            name: this.client.deals.name,
            budget: this.client.deals.budget,
            IO: this.prefixIO(this.client.deals.IO),
            linkedIOs: this.client.deals.linkedIOs || [],
            quoteAcceptanceDate: this.client.deals.quoteAcceptanceDate,
            remarks: this.client.deals.remarks,
            markupCOGS: this.client.deals.markupCOGS,
            activationDate: this.client.deals.activationDate,
            cogsAmount: this.client.deals.cogsAmount,
            products: this.accountProducts,
            country: this.client.deals.country,
            clientType: this.client.deals.clientType,
            servicesLine: this.client.deals.servicesLine,
            vertical: this.client.deals.vertical,
            masterListID: this.client.deals.masterListID,
            masterListCheck: this.getMasterlistCheck(this.client.deals.IO),
            create_at: this.formattedDate(Date.now())
          };

          this.accountDeals.push(deals);

          deals.products.map(function (item) {
            if (item.totalOutReach && item.totalOutReach !== '-') {
              _this4.client.account.totalOutreach += item.totalOutReach;
            }

            if (item.totalEngagement && item.totalEngagement !== '-') {
              _this4.client.account.totalEngagement += item.totalEngagement;
            }

            if (item.minContent && item.minContent !== '-') {
              _this4.client.account.minContent += item.minContent;
            }

            if (item.maxContent && item.maxContent !== '-') {
              _this4.client.account.maxContent += item.maxContent;
            }

            if (item.noOfCampaigns && item.noOfCampaigns !== '-') {
              _this4.client.account.maxCampaigns += item.noOfCampaigns;
            }
          });
          this.client.account.deals = this.accountDeals;
        } else {
          this.client.deals.IO = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.escapeSpecialChars(this.client.deals.IO);
          this.accountDeals[this.editDealItemIndex].name = this.client.deals.name ? this.client.deals.name : '-';
          this.accountDeals[this.editDealItemIndex].IO = this.client.deals.IO ? this.prefixIO(this.client.deals.IO) : '-';
          this.accountDeals[this.editDealItemIndex].masterListCheck = this.getMasterlistCheck(this.client.deals.IO ? this.prefixIO(this.client.deals.IO) : '-');
          this.accountDeals[this.editDealItemIndex].linkedIOs = this.client.deals.linkedIOs ? this.client.deals.linkedIOs : [];
          this.accountDeals[this.editDealItemIndex].quoteAcceptanceDate = this.client.deals.quoteAcceptanceDate ? this.client.deals.quoteAcceptanceDate : '-';
          this.accountDeals[this.editDealItemIndex].markupCOGS = this.client.deals.markupCOGS ? this.client.deals.markupCOGS : false;
          this.accountDeals[this.editDealItemIndex].activationDate = this.client.deals.activationDate ? this.client.deals.activationDate : '';
          this.accountDeals[this.editDealItemIndex].cogsAmount = this.client.deals.cogsAmount ? this.client.deals.cogsAmount : '';
          this.accountDeals[this.editDealItemIndex].remarks = this.client.deals.remarks ? this.client.deals.remarks : '-';
          this.accountDeals[this.editDealItemIndex].country = this.client.deals.country ? this.client.deals.country : '-';
          this.accountDeals[this.editDealItemIndex].clientType = this.client.deals.clientType ? this.client.deals.clientType : '-';
          this.accountDeals[this.editDealItemIndex].servicesLine = this.client.deals.servicesLine ? this.client.deals.servicesLine : '-';
          this.accountDeals[this.editDealItemIndex].vertical = this.client.deals.vertical ? this.client.deals.vertical : '-';
          this.accountDeals[this.editDealItemIndex].masterListID = this.client.deals.masterListID ? this.client.deals.masterListID : '';
          this.accountDeals[this.editDealItemIndex].create_at = this.formattedDate(Date.now());
          this.accountDeals[this.editDealItemIndex].products = this.accountProducts;

          var totalOutreach = 0;
          var totalEngagement = 0;
          var totalMinContents = 0;
          var totalMaxContents = 0;
          var noOfCampaigns = 0;
          this.accountDeals[this.editDealItemIndex].products.map(function (item) {
            if (item.totalOutReach) {
              totalOutreach += item.totalOutReach;
            }

            if (item.totalEngagement) {
              totalEngagement += item.totalEngagement;
            }

            if (item.minContent) {
              totalMinContents += item.minContent;
            }

            if (item.maxContent) {
              totalMaxContents += item.maxContent;
            }

            if (item.noOfCampaigns) {
              noOfCampaigns += item.noOfCampaigns;
            }
          });

          this.client.account.totalOutreach = totalOutreach;
          this.client.account.totalEngagement = totalEngagement;
          this.client.account.minContent = totalMinContents;
          this.client.account.maxContent = totalMaxContents;
          this.client.account.maxCampaigns = noOfCampaigns;
          this.client.account.deals[this.editDealItemIndex].name = this.client.deals.name;
          this.client.account.deals[this.editDealItemIndex].budget = this.client.deals.budget;
          this.client.account.deals[this.editDealItemIndex].IO = this.prefixIO(this.client.deals.IO);
          this.client.account.deals[this.editDealItemIndex].masterListCheck = this.getMasterlistCheck(this.client.deals.IO ? this.prefixIO(this.client.deals.IO) : '-');
          this.client.account.deals[this.editDealItemIndex].linkedIOs = this.client.deals.linkedIOs;
          this.client.account.deals[this.editDealItemIndex].quoteAcceptanceDate = this.client.deals.quoteAcceptanceDate;
          this.client.account.deals[this.editDealItemIndex].remarks = this.client.deals.remarks;
          this.client.account.deals[this.editDealItemIndex].activationDate = this.client.deals.activationDate;
          this.client.account.deals[this.editDealItemIndex].markupCOGS = this.client.deals.markupCOGS;
          this.client.account.deals[this.editDealItemIndex].cogsAmount = this.client.deals.cogsAmount;
          this.client.account.deals[this.editDealItemIndex].country = this.client.deals.country;
          this.client.account.deals[this.editDealItemIndex].clientType = this.client.deals.clientType;
          this.client.account.deals[this.editDealItemIndex].servicesLine = this.client.deals.servicesLine;
          this.client.account.deals[this.editDealItemIndex].vertical = this.client.deals.vertical;
          this.client.account.deals[this.editDealItemIndex].masterListID = this.client.deals.masterListID;
        }
        this.addDealsDialog = false;
        this.clearDeals();
      }
    },
    clearDeals: function clearDeals() {
      this.client.deals.name = '';
      this.client.deals.budget = 0;
      this.client.deals.IO = '';
      this.client.deals.linkedIOs = [];
      this.client.deals.masterListID = '';
      this.client.deals.activationDate = '';
      this.client.deals.markupCOGS = false;
      this.client.deals.cogsAmount = 0;
      this.client.deals.products = [];
      this.client.deals.country = [];
      this.client.deals.clientType = '';
      this.client.deals.servicesLine = '';
      this.client.deals.vertical = [];
      this.accountProducts = [];
    },
    closeAddEditProductsModal: function closeAddEditProductsModal() {
      this.$refs.form.reset();
      this.addEditDialog = false;
    },
    directCloseModal: function directCloseModal() {
      this.$emit('input');
    },
    closeEditModal: function closeEditModal() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var confirm;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.closeConfirmationModal();

              case 2:
                confirm = _context4.sent;

                if (confirm) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                _this5.$emit('input');
                _this5.accountProducts = [];
                _this5.handledBy = [];

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    deleteProducts: function deleteProducts(i) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var deleteIt;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this6.deletConfirmationModal('Are you sure to delete this product?');

              case 2:
                deleteIt = _context5.sent;

                if (deleteIt) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt('return');

              case 5:

                _this6.accountProducts.splice(i, 1);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    deletConfirmationModal: function deletConfirmationModal(msg) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this7.$swal({
                  title: 'Please confirm',
                  text: msg,
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, Delete.'
                });

              case 2:
                result = _context6.sent;
                return _context6.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    closeConfirmationModal: function closeConfirmationModal() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this8.$swal({
                  title: 'Please confirm',
                  text: 'Are you sure to close?',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Yes'
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt('return', result.value);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    mediaChanged: function mediaChanged(media) {
      this.client.media = media;
    },
    deleteDeals: function deleteDeals(i) {
      var _this9 = this;

      var modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var deleteIt;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!modal) {
                  _context8.next = 6;
                  break;
                }

                _context8.next = 3;
                return _this9.deletConfirmationModal('Are you sure to delete this deal?');

              case 3:
                deleteIt = _context8.sent;

                if (deleteIt) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt('return');

              case 6:

                if (_this9.client.account.budget) {
                  _this9.client.account.budget -= _this9.accountDeals[i].budget;
                }

                _this9.accountDeals[i].products.map(function (item) {
                  if (_this9.client.account.totalOutreach) {
                    _this9.client.account.totalOutreach -= item.totalOutReach;
                  }

                  if (_this9.client.account.totalEngagement) {
                    _this9.client.account.totalEngagement -= item.totalEngagement;
                  }

                  if (_this9.client.account.minContent) {
                    _this9.client.account.minContent -= item.minContent;
                  }

                  if (_this9.client.account.maxContent) {
                    _this9.client.account.maxContent -= item.maxContent;
                  }

                  if (_this9.client.account.maxCampaigns) {
                    _this9.client.account.maxCampaigns -= item.noOfCampaigns;
                  }
                });

                _this9.accountDeals.splice(i, 1);
                if (_this9.accountDeals.length === 0) {
                  _this9.dealCounter = 0;
                }

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    deleteProductsFromAccountDetails: function deleteProductsFromAccountDetails(i, j) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var deleteIt;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this10.deletConfirmationModal('Are you sure to delete this product?');

              case 2:
                deleteIt = _context9.sent;

                if (deleteIt) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt('return');

              case 5:
                if (_this10.client.account.budget && _this10.client.account.deals[i].budget) {
                  _this10.client.account.budget -= parseInt(_this10.client.account.deals[i].products[j].budget, 10);
                  _this10.client.account.deals[i].budget -= parseInt(_this10.client.account.deals[i].products[j].budget, 10);
                }

                if (_this10.client.account.deals[i].products[j].totalOutReach) {
                  _this10.client.account.totalOutreach -= parseInt(_this10.client.account.deals[i].products[j].totalOutReach, 10);
                }

                if (_this10.client.account.deals[i].products[j].totalEngagement) {
                  _this10.client.account.totalEngagement -= parseInt(_this10.client.account.deals[i].products[j].totalEngagement, 10);
                }

                if (_this10.client.account.deals[i].products[j].minContent) {
                  _this10.client.account.minContent -= parseInt(_this10.client.account.deals[i].products[j].minContent, 10);
                }

                if (_this10.client.account.deals[i].products[j].maxContent) {
                  _this10.client.account.maxContent -= parseInt(_this10.client.account.deals[i].products[j].maxContent, 10);
                }

                if (_this10.client.account.deals[i].products[j].noOfCampaigns) {
                  _this10.client.account.maxCampaigns -= parseInt(_this10.client.account.deals[i].products[j].noOfCampaigns, 10);
                }

                _this10.client.account.deals[i].products.splice(j, 1);
                if (_this10.client.account.deals[i].products.length === 0) {
                  _this10.deleteDeals(i);
                }

              case 13:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    closeDealsModal: function closeDealsModal() {
      this.$refs.dealForm.reset();
      this.accountProducts = [];
      this.addDealsDialog = false;
    },
    cutIO: function cutIO(IO) {
      var re = new RegExp('IO-', 'g');
      return IO.replace(re, '');
    },
    prefixIO: function prefixIO(value) {
      return 'IO-' + value;
    },
    addDefaultContact: function addDefaultContact() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      this.client.contacts.push({
        contactName: name,
        email: email,
        includeEmail: true,
        invalid: false
      });
      this.client = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.client);
    },
    removeContact: function removeContact(index) {
      var _client$deletedContac;

      if (this.client.deletedContacts === undefined) {
        this.client.deletedContacts = [];
      }
      (_client$deletedContac = this.client.deletedContacts).push.apply(_client$deletedContac, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.client.contacts.splice(index, 1)));
    },
    filterEmptyContacts: function filterEmptyContacts(clientData) {
      if (clientData.contacts !== undefined) {
        clientData.contacts = clientData.contacts.filter(function (c) {
          return c.contactName !== '' && c.email !== '';
        });
        clientData.contacts = clientData.contacts.map(function (c) {
          c.email = c.email.toLowerCase();
          return c;
        });
      }
      return clientData;
    },
    getProductName: function getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut';
      }
      return itemName;
    },
    getCampaignsByClientID: function getCampaignsByClientID() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__["a" /* default */].getCampaignsByClientID(_this11.client.id);

              case 2:
                response = _context10.sent;

                if (response) {
                  _this11.campaigns = response.campaigns.map(function (r) {
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, { id: r.id, name: r.name });
                  });
                }

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    changeMarkupCOGS: function changeMarkupCOGS() {
      this.client = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.client);
    },
    changeClientGroup: function changeClientGroup() {
      this.client.name = this.client.group ? this.client.group.Name : '';
      this.getIONumbers(this.client.group.ContactID);
    },
    displayCampaignVerticals: function displayCampaignVerticals(vertical) {
      var selectedCampaignVertical = [];
      if (vertical) {
        this.campaignVerticals.map(function (item) {
          vertical.map(function (v) {
            if (item.id === v.id) {
              selectedCampaignVertical.push(item);
            }
          });
        });
      }
      return selectedCampaignVertical.map(function (s) {
        return s.name;
      }).join(', ');
    },

    getCountryDisplayValueFromSelect: function getCountryDisplayValueFromSelect(value) {
      if (typeof value === 'string') return value;
      var selectedOption = this.countries.filter(function (option) {
        return value.includes(option.value);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.text;
      }).join(', ') : '-';
    },
    getClientTypeDisplayValue: function getClientTypeDisplayValue(value) {
      if (value) {
        var matchClient = this.clientTypes.find(function (c) {
          return c.value === value;
        });
        if (matchClient) return matchClient.title;
      }
      return '-';
    },
    displayNatureOfDeals: function displayNatureOfDeals(deals) {
      return Array.isArray(deals) ? deals.map(function (d) {
        return d.name || '';
      }).join(', ') : '';
    },
    updateSelectedDedicated: function updateSelectedDedicated(newValue) {
      this.selectedDedicatedPersons = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], newValue);
    },
    updateSelectedSupporting: function updateSelectedSupporting(newValue) {
      this.selectedSupportingPersons = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], newValue);
    },
    getAssignUsers: function getAssignUsers() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                resp = _context11.sent;

                if (resp) _this12.CO = resp.users;
                _context11.next = 6;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                resp = _context11.sent;

                if (resp) _this12.AM = resp.users;
                _this12.assignUsers = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this12.CO), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this12.AM)));

              case 9:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },
    checkNatureOfDeals: function checkNatureOfDeals() {
      var _this13 = this;

      if (this.client.moreAccount) {
        if (this.client.moreAccount.natureOfDeal) {
          this.client.moreAccount.natureOfDeal = this.client.moreAccount.natureOfDeal.map(function (v) {
            if (typeof v === 'string') {
              v = {
                id: 0,
                name: v
              };
              _this13.dealNatureLists.push(v);
            }
            return v;
          });
        }
      }
    },
    checkCountrySave: function checkCountrySave() {
      var _this14 = this;

      if (this.client.deals.country) {
        this.client.deals.country = this.client.deals.country.map(function (v) {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            };
            _this14.countries.push(v);
          }
          return v;
        });
      }
    },
    reqForDelete: function reqForDelete(dealIdx) {
      var _this15 = this;

      var productIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var deleteIt, reqData, resp;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this15.$swal({
                  title: 'Please confirm',
                  text: 'Are you sure to send delete request?',
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Send Request'
                });

              case 2:
                deleteIt = _context12.sent;

                if (deleteIt.value) {
                  _context12.next = 5;
                  break;
                }

                return _context12.abrupt('return');

              case 5:
                reqData = {
                  dealName: _this15.accountDeals[dealIdx].name,
                  productName: ''
                };

                if (productIdx !== null) {
                  reqData.productName = _this15.accountDeals[dealIdx].products[productIdx].name;
                }
                _context12.next = 9;
                return __WEBPACK_IMPORTED_MODULE_12__clientAPIs__["a" /* default */].sendDeleteReq(reqData, _this15.client.id);

              case 9:
                resp = _context12.sent;

                if (resp) {
                  _this15.$swal({
                    type: 'success',
                    title: 'Successfully requested for deletion.'
                  });
                } else {
                  _this15.$swal({
                    type: 'error',
                    title: 'Error sending delete request.'
                  });
                }

              case 11:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    getIONumbers: function getIONumbers(contactID) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!contactID) {
                  _context13.next = 5;
                  break;
                }

                _context13.next = 3;
                return _this16.$store.dispatch('campaign/getCampaignMasterListsIONumbers', {
                  filters: {
                    contactID: contactID
                  }
                });

              case 3:
                _context13.next = 7;
                break;

              case 5:
                _context13.next = 7;
                return _this16.$store.dispatch('campaign/getCampaignMasterListsIONumbers', {});

              case 7:
                _this16.displayMasterLists = [];
                _this16.displayMasterLists = _this16.masterLists.map(function (m) {
                  m.quoteNo = m.quoteNo ? _this16.cutIO(m.quoteNo) : '';
                  return m;
                });
                if (contactID) {
                  _this16.displayMasterLists = _this16.displayMasterLists.filter(function (master) {
                    if (master.billingContact) {
                      if (master.billingContact.ContactID === contactID) return true;
                    }
                    return false;
                  });
                }

              case 10:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this16);
      }))();
    },
    changeIONumber: function changeIONumber() {
      var _this17 = this;

      var matchMasterData = this.findMasterList(this.client.deals.IO);
      this.client.deals.masterListID = '';
      this.client.deals.quoteAcceptanceDate = '';
      this.client.deals.previewBudget = '';
      this.client.deals.budget = '';
      this.client.deals.linkedIOs = [];
      if (matchMasterData) {
        var mainIO = this.normalizeIONumber(matchMasterData.quoteNo);
        var linkedIOs = Array.isArray(matchMasterData.linkedIOs) ? matchMasterData.linkedIOs : [];
        this.client.deals.linkedIOs = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(linkedIOs.map(function (linkedIO) {
          return _this17.normalizeIONumber(linkedIO);
        }).filter(function (linkedIO) {
          return linkedIO && linkedIO !== mainIO && _this17.findMasterList(linkedIO);
        }))));
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData);
        this.client.deals.masterListID = matchMasterData.id;
        this.client.deals.quoteAcceptanceDate = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.parseDate(matchMasterData.acceptanceDate);
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs);
      }
    },
    changeLinkedIO: function changeLinkedIO() {
      var _this18 = this;

      var matchMasterData = this.findMasterList(this.client.deals.IO);
      if (matchMasterData) {
        var mainIO = this.normalizeIONumber(matchMasterData.quoteNo);
        this.client.deals.linkedIOs = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a((this.client.deals.linkedIOs || []).map(function (linkedIO) {
          return _this18.normalizeIONumber(linkedIO);
        }).filter(function (linkedIO) {
          return linkedIO && linkedIO !== mainIO;
        }))));
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData);
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs);
      }
    },
    normalizeIONumber: function normalizeIONumber(value) {
      return String(value || '').trim().replace(/^IO-/i, '');
    },
    findMasterList: function findMasterList(ioNumber) {
      var _this19 = this;

      var normalizedIO = this.normalizeIONumber(ioNumber);
      return this.masterLists.find(function (master) {
        return _this19.normalizeIONumber(master.quoteNo) === normalizedIO;
      });
    },
    getIOBudget: function getIOBudget(masterList) {
      if (!masterList) return 0;
      var budget = Number(String(masterList.quoteAmt || 0).replace(/,/g, ''));
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(budget) ? budget : 0;
    },
    calculateTotalIOBudget: function calculateTotalIOBudget(mainMasterList, linkedIOs) {
      var _this20 = this;

      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(linkedIOs || []))).reduce(function (total, linkedIO) {
        return total + _this20.getIOBudget(_this20.findMasterList(linkedIO));
      }, this.getIOBudget(mainMasterList));
    },
    getMasterlistCheck: function getMasterlistCheck(IONumber) {
      var _this21 = this;

      var masterListExist = this.masterLists.find(function (m) {
        return _this21.cutIO(m.quoteNo) === _this21.cutIO(IONumber);
      });
      if (masterListExist) return true;
      return false;
    },
    linkMasterlist: function linkMasterlist(item) {
      var _this22 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure to link masterlist',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee14(result) {
          var updateData;
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!result.value) {
                    _context14.next = 9;
                    break;
                  }

                  _this22.loading = true;
                  updateData = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, {
                    clientID: _this22.client.id,
                    salePerson: _this22.client.salePerson,
                    billingContact: _this22.client.group,
                    IO: item.IO,
                    budget: item.budget,
                    quoteAcceptanceDate: item.quoteAcceptanceDate,
                    clientType: item.clientType
                  });
                  _context14.next = 5;
                  return _this22.$store.dispatch('campaign/linkMasterlist', updateData);

                case 5:
                  _context14.next = 7;
                  return _this22.getIONumbers(_this22.client.group.ContactID);

                case 7:
                  _this22.loading = false;
                  _this22.$swal({
                    title: 'Successful',
                    text: 'Successfully Linked Masterlist.',
                    type: 'success'
                  });

                case 9:
                case 'end':
                  return _context14.stop();
              }
            }
          }, _callee14, _this22);
        }));

        return function (_x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    isProductBudgetExceeded: function isProductBudgetExceeded() {
      if (Number(this.client.moreAccount.budget) > Number(this.client.deals.budget)) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Product budget cannot be greater than Deal Budget'
        });
        return true;
      }
      return false;
    },
    setDateFromPicker: function setDateFromPicker(fieldName, value) {
      this.client.deals[fieldName] = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.client.deals = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.client.deals);
    },
    checkDate: function checkDate(fieldName) {
      if (!this.client.deals[fieldName]) return;
      this.validActivationDate = false;
      if (__WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.isDateFormatValid(this.client.deals[fieldName]) || !this.client.deals[fieldName]) {
        this.validActivationDate = true;
      }
      this.client.deals = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.client.deals);
    },
    checkAccEmail: function checkAccEmail(index) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var contactOne, resp;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this23.invalidContactEmail = false;
                _this23.client.contacts[index].invalid = false;
                contactOne = _this23.client.contacts[index];
                _context15.next = 5;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].checkClientUser({
                  clientID: _this23.client.id,
                  email: contactOne.email.toLowerCase()
                });

              case 5:
                resp = _context15.sent;

                if (!resp.success) {
                  _this23.client.contacts[index].invalid = true;
                  _this23.invalidContactEmail = true;
                }

              case 7:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this23);
      }))();
    },
    updateClientUserCampaigns: function updateClientUserCampaigns() {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var _loop, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, contact;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _loop = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _loop(contact) {
                  var email, campaigns, updateContact;
                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _loop$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          email = contact.email;
                          campaigns = [];

                          _this24.client.contacts.map(function (c) {
                            if (c.email === email) {
                              if (c.campaigns) {
                                c.campaigns.map(function (campaign) {
                                  campaigns.push(campaign);
                                });
                              }
                            }
                          });
                          updateContact = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, contact);

                          updateContact.campaigns = campaigns;
                          _context16.next = 7;
                          return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].updateClientUserCampaigns(updateContact);

                        case 7:
                        case 'end':
                          return _context16.stop();
                      }
                    }
                  }, _loop, _this24);
                });
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context17.prev = 4;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this24.client.contacts);

              case 6:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context17.next = 12;
                  break;
                }

                contact = _step4.value;
                return _context17.delegateYield(_loop(contact), 't0', 9);

              case 9:
                _iteratorNormalCompletion4 = true;
                _context17.next = 6;
                break;

              case 12:
                _context17.next = 18;
                break;

              case 14:
                _context17.prev = 14;
                _context17.t1 = _context17['catch'](4);
                _didIteratorError4 = true;
                _iteratorError4 = _context17.t1;

              case 18:
                _context17.prev = 18;
                _context17.prev = 19;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 21:
                _context17.prev = 21;

                if (!_didIteratorError4) {
                  _context17.next = 24;
                  break;
                }

                throw _iteratorError4;

              case 24:
                return _context17.finish(21);

              case 25:
                return _context17.finish(18);

              case 26:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee16, _this24, [[4, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },
    showLinkedIO: function showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return '';
      IOs = IOs.map(function (i) {
        if (i) {
          if (!i.includes('IO-')) {
            i = 'IO-' + i;
          }
        }
        return i;
      });
      return IOs.join(', ');
    },
    addLinkIO: function addLinkIO() {
      this.client.deals.linkedIOs.push('');
    },
    deleteLinkIO: function deleteLinkIO(idx) {
      this.client.deals.linkedIOs.splice(idx, 1);
      this.changeLinkedIO();
    }
  },
  mounted: function mounted() {
    var _this25 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (_this25.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this25.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
                __WEBPACK_IMPORTED_MODULE_13__Company_companyAPIs__["a" /* default */].getAllCompanies(false).then(function (response) {
                  _this25.company_options = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });
              }

              __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW).then(function (response) {
                _this25.salePerson_options = response.users;
              }).catch(function (error) {
                console.log('error', error);
              });

              _this25.fetchXeroContact();
              _this25.$store.dispatch('campaign/getCampaignVerticals');
              _context18.next = 6;
              return _this25.$store.dispatch('client/getDealNatures');

            case 6:
              _this25.dealNatureLists = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], _this25.dealNatures);

            case 7:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee17, _this25);
    }))();
  }
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewFeedbackModal__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewFeedbackModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ViewFeedbackModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__clientConfig_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay_dist_vue_loading_css__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FeedbacksForm',
  components: {
    ViewFeedbackModal: __WEBPACK_IMPORTED_MODULE_5__ViewFeedbackModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      feedbackFormSections: __WEBPACK_IMPORTED_MODULE_10__clientConfig_js__["a" /* default */].feedbackFormSections,
      viewFeedbackData: null,
      viewModalDialog: false,
      allClients: [],
      allClientUsers: [],
      AM: [],
      CO: [],
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      NPSFilters: [{
        text: 'All',
        value: 0
      }, {
        text: '>= 9 NPS Score',
        value: 1
      }],
      selectedFilter: {
        NPS: 0,
        AM: '',
        CO: '',
        submittedDate: [],
        year: 2026
      },
      allCampaigns: [],
      headers: [{
        text: 'Campaign Name',
        value: 'campaignName'
      }, {
        text: 'Billing Name as per Xero',
        value: 'clientName'
      }, {
        text: 'Account Manager',
        value: 'accountManager'
      }, {
        text: 'Content & Community Curator',
        value: 'CO'
      }, {
        text: 'NPS Score',
        value: 'likely_recommend'
      }, {
        text: 'Creator line up',
        value: 'infLineUpIdx'
      }, {
        text: 'Creator content created',
        value: 'infContentCreatedIdx'
      }, {
        text: 'AM Score',
        value: 'amScore'
      }, {
        text: 'Submitter Name',
        value: 'name'
      }, {
        text: 'Submitter Email',
        value: 'email'
      }, {
        text: 'Submitted Date',
        value: 'updatedAtDisplay'
      }, {
        text: 'Actions',
        value: 'action',
        sortable: false
      }],
      items: [],
      filteredItems: [],
      selectedForms: [],
      pagination: {
        rowsPerPage: 15
      },
      totalValues: {
        recommended: 0,
        creatorLineup: 0,
        contentCreated: 0,
        amScore: 0
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      filter: '',
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    feedbackFormUpdated: function feedbackFormUpdated(state) {
      return state.campaign.feedbackFormUpdated;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isArchive: function isArchive() {
      return this.$route.meta.archive || false;
    },
    showSummaryPerson: function showSummaryPerson() {
      var _this = this;

      var respNames = [];
      var respStr = '';
      if (this.selectedFilter.AM) {
        var matchAM = this.AM.find(function (a) {
          return a.id === _this.selectedFilter.AM;
        });
        if (matchAM) {
          respNames.push(matchAM.name);
        }
      }
      if (this.selectedFilter.CO) {
        var matchCO = this.CO.find(function (a) {
          return a.id === _this.selectedFilter.CO;
        });
        if (matchCO) {
          respNames.push(matchCO.name);
        }
      }
      if (respNames.length) {
        respStr += 'for ';
      }
      respStr += respNames.join(', ');
      return respStr;
    },
    showFilterDate: function showFilterDate() {
      if (this.selectedFilter.submittedDate && this.selectedFilter.submittedDate.length) {
        var respDateStr = 'in ';
        respDateStr += __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.formatCustomDate(this.selectedFilter.submittedDate[0], 'MMM YYYY');
        if (this.selectedFilter.submittedDate.length > 1) {
          respDateStr += ' - ' + __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.formatCustomDate(this.selectedFilter.submittedDate[1], 'MMM YYYY');
        }
        return respDateStr;
      }
      return '';
    },
    showCCBox: function showCCBox() {
      return !this.selectedFilter.AM || this.selectedFilter.CO || !this.selectedFilter.AM && !this.selectedFilter.CO;
    },
    showAMBox: function showAMBox() {
      return !this.selectedFilter.CO || this.selectedFilter.AM || !this.selectedFilter.AM && !this.selectedFilter.CO;
    }
  }),
  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    },

    allClients: {
      handler: function handler(value) {
        this.paginate(this.currentPage);
      }
    },
    AM: {
      handler: function handler(value) {
        this.paginate(this.currentPage);
      }
    }
  },
  methods: {
    updateItems: function updateItems(response) {
      var _this2 = this;

      var infLineUp = this.feedbackFormSections.inf_line_up.values;
      var infContentCreated = this.feedbackFormSections.inf_content_created.values;
      var feedbacks = response.feedbacks;
      feedbacks = feedbacks.map(function (item) {
        item.updatedAtDisplay = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'DD/MM/YYYY');
        item.clientName = _this2.getClientName(item.clientID);
        item.accountManager = _this2.getAMName(item.amID);
        if (item.coID) {
          item.CO = _this2.getCOName(item.coID);
        }
        item.infLineUpIdx = infLineUp.findIndex(function (f) {
          return f === item.inf_line_up;
        });
        item.infContentCreatedIdx = infContentCreated.findIndex(function (f) {
          return f === item.inf_content_created;
        });
        if (item.infLineUpIdx >= 0) {
          item.infLineUpIdx = item.infLineUpIdx + 1;
        } else {
          item.infLineUpIdx = 0;
        }
        if (item.infContentCreatedIdx >= 0) {
          item.infContentCreatedIdx = item.infContentCreatedIdx + 1;
        } else {
          item.infContentCreatedIdx = 0;
        }
        item.amScore = (item.dependable || 0) + (item.initiative || 0) + (item.knowledgeable || 0);
        return item;
      });
      this.items = feedbacks;
      this.totalRows = response.totalFeedbacks;
      this.searchFilter();
    },
    paginate: function paginate() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.resetFilter();
      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__["a" /* default */].getClientFeedbacks({
        page: page,
        keyword: this.filter,
        archive: this.isArchive,
        sort: 'updatedAt DESC'
      }).then(function (response) {
        _this3.updateItems(response);
        if (!reload) {
          _this3.loadFeedbackFormByURL();
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.NPS) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.likely_recommend >= 9;
        });
      }
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.amID === _this4.selectedFilter.AM;
        });
      }
      if (this.selectedFilter.CO) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.coID === _this4.selectedFilter.CO;
        });
      }
      if (this.selectedFilter.year) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          var createdYear = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'YYYY');
          return Number(createdYear) === Number(_this4.selectedFilter.year);
        });
      }
      if (this.selectedFilter.submittedDate && this.selectedFilter.submittedDate.length) {
        var dates = this.selectedFilter.submittedDate;
        this.filteredItems = this.filteredItems.filter(function (item) {
          var createdMonth = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.formatCustomDate(item.createdAt, 'YYYY-MM');
          if (dates.length === 1) {
            return createdMonth === _this4.selectedFilter.submittedDate[0];
          } else if (dates.length === 2) {
            return createdMonth >= dates[0] && createdMonth <= dates[1];
          }
          return false;
        });
      }
      this.calTotalSummary();
    },
    calTotalSummary: function calTotalSummary() {
      var customItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.totalValues = {
        recommended: 0,
        creatorLineup: 0,
        contentCreated: 0,
        amScore: 0
      };
      var calcItems = [];
      if (customItems.length) {
        calcItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], customItems);
      } else {
        calcItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
      }
      var totalItems = calcItems.length;
      if (!totalItems) return;
      var recommend = 0;
      var creatorLineup = 0;
      var contentCreated = 0;
      var amScore = 0;
      calcItems.map(function (f) {
        if (f.likely_recommend) recommend += parseFloat(f.likely_recommend || 0);
        if (f.infLineUpIdx) creatorLineup += parseFloat(f.infLineUpIdx || 0);
        if (f.infContentCreatedIdx) contentCreated += parseFloat(f.infContentCreatedIdx || 0);
        if (f.amScore) amScore += parseFloat(f.amScore || 0);
        return f;
      });
      var totalRecommended = calcItems.filter(function (c) {
        return c.likely_recommend;
      }).length;
      var totalLineUp = calcItems.filter(function (c) {
        return c.infLineUpIdx;
      }).length;
      var totalContentCreated = calcItems.filter(function (c) {
        return c.infContentCreatedIdx;
      }).length;
      var totalAMScore = calcItems.filter(function (c) {
        return c.amScore;
      }).length;

      this.totalValues.recommended = (recommend / totalRecommended).toFixed(2);
      this.totalValues.creatorLineup = (creatorLineup / totalLineUp * 2.5).toFixed(2);
      this.totalValues.contentCreated = (contentCreated / totalContentCreated * 2.5).toFixed(2);
      this.totalValues.amScore = (amScore / totalAMScore / 12 * 10).toFixed(2);
    },
    resetFilter: function resetFilter() {
      this.selectedFilter = {
        NPS: 0,
        AM: '',
        CO: '',
        submittedDate: [],
        year: 2026
      };
      this.selectedForms = [];
      this.searchFilter();
    },
    getClientName: function getClientName(id) {
      var result = null;
      this.allClients.forEach(function (item) {
        if (item.id === id) {
          if (item.group) {
            result = item.group.Name || item.name;
          } else {
            result = item.name;
          }
        }
      });
      return result;
    },
    getClientFullName: function getClientFullName(id) {
      var _this5 = this;

      var result = null;
      this.allClientUsers.forEach(function (item) {
        if (item.id === id) {
          var clientName = _this5.getClientName(item.clientID);
          result = item.firstName + ' ' + item.lastName + ' (' + clientName + ')';
        }
      });
      return result;
    },
    getCampaignName: function getCampaignName(id) {
      var result = null;
      this.allCampaigns.forEach(function (item) {
        if (item.id === id) {
          result = item.name;
        }
      });
      return result;
    },
    getAMName: function getAMName(id) {
      var result = null;
      this.AM.forEach(function (item) {
        if (item.id === id) {
          result = item.firstName + ' ' + item.lastName;
        }
      });
      return result;
    },
    getCOName: function getCOName(id) {
      var result = null;
      this.CO.forEach(function (item) {
        if (item.id === id) {
          result = item.firstName + ' ' + item.lastName;
        }
      });
      return result;
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).fromNow();
    },
    getFeedbackDataToView: function getFeedbackDataToView(viewData) {
      this.viewFeedbackData = viewData;
      this.viewModalDialog = true;
    },
    loadFeedbackFormByURL: function loadFeedbackFormByURL() {
      var feedbackFormID = this.$route.query.id;
      if (feedbackFormID) {
        var formOne = this.items.find(function (i) {
          return i.id === feedbackFormID;
        });
        if (formOne) {
          this.getFeedbackDataToView(formOne);
        }
      }
    },
    selectAllForms: function selectAllForms($event) {
      if ($event.value && $event.items.length === 0 || !$event.value) {
        this.selectedForms = [];
        return;
      }
      if (this.selectedForms.length === 0) {
        this.selectedForms = $event.items;
      } else this.selectedForms = [];
    },
    currentItems: function currentItems() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.calTotalSummary(_this6.$refs.feedbackForm.$children[0].filteredItems);
      });
    },
    restoreArchive: function restoreArchive() {
      var _this7 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var ids, data;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 12;
                    break;
                  }

                  ids = _this7.selectedForms.map(function (item) {
                    return item.id;
                  });
                  data = ids.map(function (feedbackFormID) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                      id: feedbackFormID,
                      archive: false
                    });
                  });

                  _this7.isLoading = true;
                  _context.next = 6;
                  return _this7.$store.dispatch('campaign/updateFeedbackFormByIds', data);

                case 6:
                  _this7.isLoading = false;

                  if (_this7.feedbackFormUpdated) {
                    _context.next = 10;
                    break;
                  }

                  _this7.$swal({
                    text: 'Error Restoring Feedback Forms.',
                    type: 'error'
                  });
                  return _context.abrupt('return');

                case 10:
                  _this7.$swal({
                    text: 'Successfully Restored.',
                    type: 'success'
                  });
                  _this7.paginate(1, true);

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this7);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    archiveFeedbackForm: function archiveFeedbackForm() {
      var _this8 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var ids, data;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result.value) {
                    _context2.next = 12;
                    break;
                  }

                  ids = _this8.selectedForms.map(function (item) {
                    return item.id;
                  });
                  data = ids.map(function (feedbackFormID) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                      id: feedbackFormID,
                      archive: true
                    });
                  });

                  _this8.isLoading = true;
                  _context2.next = 6;
                  return _this8.$store.dispatch('campaign/updateFeedbackFormByIds', data);

                case 6:
                  _this8.isLoading = false;

                  if (_this8.feedbackFormUpdated) {
                    _context2.next = 10;
                    break;
                  }

                  _this8.$swal({
                    text: 'Error Archiving Feedback Forms.',
                    type: 'error'
                  });
                  return _context2.abrupt('return');

                case 10:
                  _this8.$swal({
                    text: 'Successfully Archived.',
                    type: 'success'
                  });
                  _this8.paginate(1, true);

                case 12:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this8);
        }));

        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    cancelMonth: function cancelMonth() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this9.submittedDateCal = false;
                _this9.selectedFilter.submittedDate = [];
                _this9.searchFilter();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    searchMonthOk: function searchMonthOk() {
      this.submittedDateCal = false;
      this.searchFilter();
    },
    download: function download() {
      var _this10 = this;

      this.isLoading = true;
      var feedbackIds = this.filteredItems.map(function (i) {
        return i.id;
      });
      var data = {
        feedbackIds: feedbackIds
      };
      __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__["a" /* default */].downloadClientFeedback(data).then(function () {
        _this10.isLoading = false;
      }).catch(function (error) {
        _this10.isLoading = false;
        console.log('error in downloading client feedback report', error);
      });
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    this.paginate(1);

    if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.AD_STRATEGIST) {
      __WEBPACK_IMPORTED_MODULE_7__clientAPIs__["a" /* default */].getAllClients(false).then(function (response) {
        _this11.allClients = response.data;
      }).catch(function (error) {
        console.log('error', error);
      });

      __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.CLIENT).then(function (response) {
        _this11.allClientUsers = response.users;
      }).catch(function (error) {
        console.log('error', error);
      });

      __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.ACCOUNT_MANAGER).then(function (response) {
        _this11.AM = response.users;
        _this11.AM = _this11.AM.map(function (am) {
          am.name = am.firstName + ' ' + am.lastName;
          return am;
        });
        _this11.AM.unshift({ id: '', name: 'All Team' });
      }).catch(function (error) {
        console.log('error', error);
      });

      __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.AD_STRATEGIST).then(function (response) {
        _this11.CO = response.users;
        _this11.CO = _this11.CO.map(function (cc) {
          cc.name = cc.firstName + ' ' + cc.lastName;
          return cc;
        });
        _this11.CO.unshift({ id: '', name: 'All Team' });
      }).catch(function (error) {
        console.log('error', error);
      });
    }

    if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.CLIENT) {
      this.checkForVendorFormComplete();
    }
  }
});

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clientAPIs__ = __webpack_require__(46);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewClientPayments',
  data: function data() {
    return {
      addForm: {
        campaignID: '',
        amount: 0,
        image: null
      },
      records: [],
      campaigns: [],
      unpaidCampaigns: [],
      headers: [{
        text: 'Campaign',
        value: 'campaignName'
      }, {
        text: 'Amount',
        value: 'amount'
      }, {
        text: 'Submitted Time',
        value: 'createdAt'
      }, {
        text: 'Status',
        value: 'status'
      }],
      dialog: false,
      previewImage: null,
      imageName: ' ',
      loadDialog: false
    };
  },
  created: function created() {
    this.fetchClientCampaigns();
    this.fetchPaymentRecords();
    this.fetchAllCampaigns();
  },

  filters: {
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    }
  },
  methods: {
    fetchAllCampaigns: function fetchAllCampaigns() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__clientAPIs__["a" /* default */].getCampaignsForClient({
        sort: 'updatedAt DESC'
      }).then(function (response) {
        var results = [];
        response.campaigns.forEach(function (campaign) {
          var item = {
            id: campaign.id,
            name: campaign.name
          };
          results.push(item);
        });
        _this.campaigns = results;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    campaignName: function campaignName(id) {
      var c = this.campaigns.find(function (c) {
        return c.id === id;
      });
      return c ? c.name : '';
    },
    prepareUpload: function prepareUpload(e) {
      var _this2 = this;

      var img = e.target.files[0];
      this.addForm.image = img;
      this.imageName = img.name;
      var reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = function (e) {
        _this2.previewImage = e.target.result;
      };
    },
    add: function add() {
      var _this3 = this;

      if (this.addForm.amount <= 0) {
        this.$swal({
          title: 'Please Enter a correct Amount',
          type: 'error'
        });
      } else if (this.addForm.image === null) {
        this.$swal({
          title: 'Please Attach a receipt of your payment',
          type: 'error'
        });
      } else {
        this.loadDialog = true;
        var formData = new FormData();
        formData.append('image', this.addForm.image);
        formData.append('campaignID', this.addForm.campaignID);
        formData.append('amount', this.addForm.amount);
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('post', '/api/v1/clients/payment-records', true, formData).then(function (response) {
          if (response.status === 200) {
            _this3.loadDialog = false;
            _this3.dialog = false;
            _this3.addForm.amount = 0;
            _this3.addForm.image = null;
            _this3.fetchPaymentRecords();
          }
        }).catch(function (err) {
          _this3.loadDialog = false;
          _this3.$swal({
            title: 'Error in submitting, please try again',
            type: 'error'
          });
          console.log(err);
        });
      }
    },
    fetchPaymentRecords: function fetchPaymentRecords() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/clients/payment-records', true).then(function (response) {
        if (response.data.records) {
          _this4.records = response.data.records;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchClientCampaigns: function fetchClientCampaigns() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', '/api/v1/campaigns/client-campaigns', true).then(function (response) {
        _this5.unpaidCampaigns = response.data.campaigns;

        if (!_this5.addForm.campaignID && _this5.unpaidCampaigns.length > 0) {
          _this5.addForm.campaignID = _this5.unpaidCampaigns[0].id;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    openAddDialog: function openAddDialog() {
      if (this.unpaidCampaigns.length > 0) {
        this.dialog = true;
      } else {
        this.$swal({
          title: 'You do not have any Campaigns to make payment',
          text: 'Please check back later',
          type: 'info'
        });
      }
    }
  }
});

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdateClientUserModal',
  props: {
    existingAccounts: Array,
    clientContacts: Array,
    clientLoginData: Object,
    value: Boolean
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      show1: false,
      userClient: {
        firstName: '',
        lastName: '',
        email: '',
        profilePicture: '',
        password: ''
      },
      newEmails: [],
      newAccounts: [],
      deleted: []
    };
  },

  watch: {
    clientLoginData: function clientLoginData(newClientData) {
      var clientObj = this.userClient;
      this.userClient = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(clientObj, newClientData);
      this.userClient.password = '';
      this.newAccounts = [];
      this.deleted = [];
    },
    existingAccounts: function existingAccounts(newVal) {
      var existEmails = newVal.map(function (e) {
        return e.email;
      });
      if (this.userClient.contacts) {
        this.newEmails = this.userClient.contacts.filter(function (val) {
          return !existEmails.includes(val.email);
        });
      }
    }
  },
  validations: {
    userClient: {
      password: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      }
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.userClient.password.$dirty) return errors;
      !this.$v.userClient.password.required && errors.push('Password is required');
      return errors;
    },
    disableAddNew: function disableAddNew() {
      if (this.newAccounts.length === this.newEmails.length) {
        return true;
      }
      return false;
    },
    invalidContactEmail: function invalidContactEmail() {
      var isInvalid = false;
      this.newAccounts.map(function (c) {
        if (c.invalid) isInvalid = true;
      });
      return isInvalid;
    }
  },
  methods: {
    updateClientUser: function updateClientUser() {
      var _this = this;

      var hasDuplicates = function hasDuplicates(arr) {
        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(arr).size !== _this.newAccounts.length;
      };
      var emails = this.newAccounts.map(function (a) {
        return a.email;
      });
      if (hasDuplicates(emails)) {
        this.$swal({
          type: 'error',
          title: 'Duplicated Email Accounts',
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }
      if (this.invalidContactEmail) {
        this.$swal({
          type: 'error',
          title: 'Account email already exists.'
        });
        return;
      }

      this.existingAccounts = this.existingAccounts.filter(function (e) {
        return e.password;
      });

      var client = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        userClient: this.userClient,
        userAccounts: this.newAccounts,
        existingAccounts: this.existingAccounts,
        deleteAccounts: this.deleted.map(function (d) {
          return d.id;
        })
      });
      delete client.companyID;

      __WEBPACK_IMPORTED_MODULE_6__clientAPIs__["a" /* default */].updateClientUser(client).then(function (response) {
        _this.updateClientUserCampaigns();

        _this.$swal({
          title: 'Success',
          text: 'You have updated the client login details. Please take note the login details in a secure place.',
          type: 'success'
        }).then(function () {
          _this.$emit('reRenderDataTable');
          _this.closeModal();
        });
      }).catch(function (error) {
        _this.$swal({
          title: 'Error',
          type: 'error',
          text: error
        });
        console.log('error', error);
      });
    },
    addNewAccount: function addNewAccount() {
      var newAccount = {
        clientID: this.clientLoginData.clientID,
        email: '',
        password: '',
        newEmails: __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(this.newEmails),
        show1: false,
        invalid: false
      };
      this.newAccounts.push(newAccount);
    },
    removeExistingAccount: function removeExistingAccount(index) {
      this.deleted.push(this.existingAccounts[index]);
      this.existingAccounts.splice(index, 1);
    },
    removeNewAccount: function removeNewAccount(index) {
      this.newAccounts.splice(index, 1);
    },
    clearData: function clearData() {
      this.userClient = {
        firstName: '',
        lastName: '',
        email: '',
        profilePicture: ''
      };
    },
    closeModal: function closeModal() {
      this.$v.$reset();
      this.clearData();
      this.$emit('input');
    },
    updateAccShow: function updateAccShow(index) {
      this.existingAccounts[index].show1 = !this.existingAccounts[index].show1;
      this.existingAccounts = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.existingAccounts));
    },
    checkAccEmail: function checkAccEmail(index) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contactOne, resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.invalidContactEmail = false;
                _this2.newAccounts[index].invalid = false;
                contactOne = _this2.newAccounts[index];
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__["a" /* default */].checkClientUser({
                  clientID: _this2.clientLoginData.clientID,
                  email: contactOne.email
                });

              case 5:
                resp = _context.sent;

                if (!resp.success) {
                  _this2.newAccounts[index].invalid = true;
                  _this2.invalidContactEmail = true;
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    updateClientUserCampaigns: function updateClientUserCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contact;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _loop = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(contact) {
                  var email, campaigns, updateContact;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          email = contact.email;
                          campaigns = [];

                          _this3.userClient.contacts.map(function (c) {
                            if (c.email === email) {
                              if (c.campaigns) {
                                c.campaigns.map(function (campaign) {
                                  campaigns.push(campaign);
                                });
                              }
                            }
                          });
                          updateContact = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, contact);

                          updateContact.campaigns = campaigns;
                          _context2.next = 7;
                          return __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__["a" /* default */].updateClientUserCampaigns(updateContact);

                        case 7:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _loop, _this3);
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.userClient.contacts);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 12;
                  break;
                }

                contact = _step.value;
                return _context3.delegateYield(_loop(contact), 't0', 9);

              case 9:
                _iteratorNormalCompletion = true;
                _context3.next = 6;
                break;

              case 12:
                _context3.next = 18;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t1 = _context3['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 18:
                _context3.prev = 18;
                _context3.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context3.prev = 21;

                if (!_didIteratorError) {
                  _context3.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context3.finish(21);

              case 25:
                return _context3.finish(18);

              case 26:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee2, _this3, [[4, 14, 18, 26], [19,, 21, 25]]);
      }))();
    }
  }
});

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clientConfig_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_userAPIs_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignHelper__ = __webpack_require__(25);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewClientModal',
  props: {
    clientData: Object,
    value: Boolean
  },
  data: function data() {
    return {
      panels: [0, 2],
      salePersonUser: {},
      userList: [],
      assignUsers: [],
      dedicatedUserList: [],
      supportingUserList: [],
      client: {
        name: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: '',
          totalOutreach: '',
          totalEngagement: '',
          minContent: '',
          maxContent: '',
          maxCampaigns: '',
          startDate: '',
          expireDate: ''
        },
        contacts: []
      },

      clientTypes: [{
        title: 'Direct',
        value: 'direct'
      }, {
        title: 'Agency',
        value: 'agency'
      }],
      natureOfDealOptions: ['Loading Fees/whitelisting', 'Physical Attendance/Event'],
      campaigns: []
    };
  },

  methods: {
    clientPaymentModesDisplay: function clientPaymentModesDisplay(mode) {
      var display = this.clientPaymentModes.filter(function (item) {
        return item.value === mode;
      });
      return display.length > 0 ? display[0].name : '';
    },
    fetchUserList: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(clientId) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_8__User_userAPIs_js__["a" /* default */].findByRole(clientId).then(function (resp) {
                  _this.userList = resp.users;
                }).catch(function (err) {
                  return console.error(err);
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchUserList(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchUserList;
    }(),
    fetchUserSalePerson: function fetchUserSalePerson(userID) {
      var _this2 = this;

      if (!userID) return;
      __WEBPACK_IMPORTED_MODULE_8__User_userAPIs_js__["a" /* default */].getUser(userID).then(function (response) {
        _this2.salePersonUser = response;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    getHandleUsers: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(client) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs_js__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                resp = _context2.sent;

                if (resp) this.CO = resp.users;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs_js__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                resp = _context2.sent;

                if (resp) this.AM = resp.users;
                this.assignUsers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.CO), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.AM)));
                if (client.handledBy) {
                  this.dedicatedUserList = this.assignUsers.filter(function (a) {
                    return client.handledBy.includes(a.id);
                  });
                }
                if (client.supportedBy) {
                  this.supportingUserList = this.assignUsers.filter(function (a) {
                    return client.supportedBy.includes(a.id);
                  });
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getHandleUsers(_x2) {
        return _ref2.apply(this, arguments);
      }

      return getHandleUsers;
    }(),
    addDefaultContact: function addDefaultContact() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      this.client.contacts.push({
        contactName: name,
        email: email,
        includeEmail: false
      });
    },
    formattedDate: function formattedDate(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format('DD MMM, YYYY');
    },
    formattedMonth: function formattedMonth(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format('MMM, YYYY');
    },
    formattedDuration: function formattedDuration(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format('MMM, YYYY');
    },
    getProductName: function getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut';
      }
      return itemName;
    },
    displayCampaignVerticals: function displayCampaignVerticals(vertical) {
      var selectedCampaignVertical = [];
      if (vertical) {
        this.campaignVerticals.map(function (item) {
          vertical.map(function (v) {
            if (item.id === v.id) {
              selectedCampaignVertical.push(item);
            }
          });
        });
      }
      return selectedCampaignVertical.map(function (s) {
        return s.name;
      }).join(', ');
    },

    getCountryDisplayValueFromSelect: function getCountryDisplayValueFromSelect(value) {
      if (typeof value === 'string') return value;
      var selectedOption = this.countries.filter(function (option) {
        return value.includes(option.value);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.text;
      }).join(', ') : '-';
    },
    getClientTypeDisplayValue: function getClientTypeDisplayValue(value) {
      if (value) {
        var matchClient = this.clientTypes.find(function (c) {
          return c.value === value;
        });
        if (matchClient) return matchClient.title;
      }
      return '-';
    },
    displayNatureOfDeals: function displayNatureOfDeals(deals) {
      return Array.isArray(deals) ? deals.map(function (d) {
        return d.name || '';
      }).join(', ') : '';
    },
    getCampaignsByClientID: function getCampaignsByClientID() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__Campaign_campaignAPIs__["a" /* default */].getCampaignsByClientID(_this3.client.id);

              case 2:
                response = _context3.sent;

                if (response) {
                  _this3.campaigns = response.campaigns.map(function (r) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { id: r.id, name: r.name });
                  });
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getMasterlistCheck: function getMasterlistCheck(IONumber) {
      var _this4 = this;

      var masterListExist = this.masterLists.find(function (m) {
        return m.quoteNo === _this4.cutIO(IONumber);
      });
      if (masterListExist) return true;
      return false;
    },
    cutIO: function cutIO(IO) {
      var re = new RegExp('IO-', 'g');
      return IO.replace(re, '');
    }
  },
  watch: {
    clientData: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(newClientData) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$store.dispatch('campaign/getCountries');

              case 2:
                if (newClientData.account && newClientData.account.deals) {
                  newClientData.account.deals = newClientData.account.deals.map(function (deal) {
                    if (deal.country) {
                      if (_this5.countries.length) {
                        deal.country = __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignHelper__["a" /* default */].formatCountry(_this5.countries, deal.country || []);
                      }
                    }
                    return deal;
                  });
                  this.accountDeals = newClientData.account.deals;
                  this.dealCounter = newClientData.account.deals.length;
                }
                this.client = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, newClientData);
                if (!newClientData.account) {
                  this.client.account = {};
                }

                this.fetchUserList(this.client.id);
                this.fetchUserSalePerson(this.client.salePerson);
                this.getHandleUsers(this.client);
                _context4.next = 10;
                return this.getCampaignsByClientID();

              case 10:
                if (this.client.contacts === undefined) {
                  this.client.contacts = [];
                  this.addDefaultContact(this.client.contactName, this.client.email);
                } else {
                  this.client.contacts = this.client.contacts.map(function (c) {
                    if (c.campaigns !== undefined) {
                      c.campaigns = _this5.campaigns.filter(function (campaign) {
                        return c.campaigns.includes(campaign.id);
                      });
                    }
                    return c;
                  });
                }

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function clientData(_x5) {
        return _ref3.apply(this, arguments);
      }

      return clientData;
    }()
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    countries: function countries(state) {
      return state.campaign.countries;
    },
    campaignVerticals: function campaignVerticals(state) {
      return state.campaign.campaignVerticals;
    },
    masterLists: function masterLists(state) {
      return state.campaign.masterLists;
    }
  }), {
    clientPaymentModes: function clientPaymentModes() {
      return __WEBPACK_IMPORTED_MODULE_7__clientConfig_js__["a" /* default */].clientPaymentModes;
    }
  }),
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_8__User_userAPIs_js__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.AD_STRATEGIST).then(function (response) {
                _this6.CO = response.users;
              }).catch(function (error) {
                console.log('error', error);
              });

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  }
});

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clientConfig_js__ = __webpack_require__(126);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewFeedbackModal',
  props: {
    value: Boolean,
    feedbackData: Object
  },
  data: function data() {
    return {
      feedbackFormSections: __WEBPACK_IMPORTED_MODULE_1__clientConfig_js__["a" /* default */].feedbackFormSections,
      feedback: {}
    };
  },

  computed: {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },
    filterOtherBuyAgain: function filterOtherBuyAgain() {
      var values = this.feedback[this.feedbackFormSections.buyagain_decision.name];
      var buyAgainDecisions = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.feedbackFormSections.buyagain_decision.fields.map(function (_ref) {
        var value = _ref.value;
        return value;
      }));
      return values.filter(function (v) {
        return !buyAgainDecisions.has(v);
      });
    },
    filterMarketingChallenge: function filterMarketingChallenge() {
      var values = this.feedback[this.feedbackFormSections.marketing_challenges.name];
      var marketingChallenges = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.feedbackFormSections.marketing_challenges.fields.map(function (_ref2) {
        var value = _ref2.value;
        return value;
      }));
      return values.filter(function (v) {
        return !marketingChallenges.has(v);
      });
    }
  },
  watch: {
    feedbackData: function feedbackData(newfeedbackData) {
      this.feedback = newfeedbackData;
    }
  }
});

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Xero_XeroAPIs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CreateClientModal__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CreateClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CreateClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditClientModal__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__EditClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UpdateClientUserModal__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UpdateClientUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__UpdateClientUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ViewClientModal__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ViewClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ViewClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ClientGroupModal__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ClientGroupModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ClientGroupModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CustomAmountUpdateModal__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CustomAmountUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__CustomAmountUpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__static_sources_countries__);



























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Client',
  components: {
    CreateClientModal: __WEBPACK_IMPORTED_MODULE_15__CreateClientModal___default.a,
    EditClientModal: __WEBPACK_IMPORTED_MODULE_16__EditClientModal___default.a,
    UpdateClientUserModal: __WEBPACK_IMPORTED_MODULE_17__UpdateClientUserModal___default.a,
    ViewClientModal: __WEBPACK_IMPORTED_MODULE_18__ViewClientModal___default.a,
    ClientGroupModal: __WEBPACK_IMPORTED_MODULE_19__ClientGroupModal___default.a,
    CustomAmountUpdateModal: __WEBPACK_IMPORTED_MODULE_20__CustomAmountUpdateModal___default.a
  },
  data: function data() {
    return {
      countries: __WEBPACK_IMPORTED_MODULE_22__static_sources_countries___default.a,
      createClientDialog: false,
      editClientDialog: false,
      viewClientDialog: false,
      updateClientLoginModal: false,
      clientGroupDialog: false,
      customAmountUpdateDialog: false,
      isViewMode: false,
      editClientData: null,
      updateClientLoginData: null,
      viewClientData: null,
      viewDealData: null,
      sortBy: 'name',
      sortDesc: false,
      options: {
        groupDesc: false
      },
      fields: [{ value: 'name', text: 'Client Name', sortable: true, groupable: false }, { value: 'phoneNumber', text: 'Contact Number', sortable: true, groupable: false }, { value: 'showEmail', text: 'Contact Email', sortable: true, groupable: false }, { value: 'IO', text: 'IO Number', sortable: true, groupable: false }, { value: 'budget', text: 'Budget', sortable: true, groupable: false }, { value: 'action', text: 'Actions', sortable: false, groupable: false }],
      dealFields: [{ value: 'name', text: 'Deal Name', sortable: true, groupable: false }, { value: 'IO', text: 'IO Number', sortable: true, groupable: false }, { value: 'campaignType', text: 'Product Type', sortable: true, groupable: false }, { value: 'budget', text: 'Budget', sortable: true, groupable: false }, { value: 'email', text: 'Email', sortable: true, groupable: false }, { value: 'quoteAcceptanceDate', text: 'Quote Acceptance Date', sortable: true, groupable: false }, { value: 'action', text: 'Allocate Campaign', sortable: false, groupable: false }],
      campaignFields: [{ value: 'name', text: 'Campaign Name', sortable: true, groupable: false }, { value: 'partCode', text: 'Part Code', sortable: true, groupable: false }, { value: 'budget', text: 'Budget', sortable: true, groupable: false }, { value: 'outreach', text: 'KPI Outreach', sortable: true, groupable: false }, { value: 'content', text: 'KPI Content', sortable: true, groupable: false }, { value: 'engagement', text: 'KPI Engagement', sortable: true, groupable: false }, { value: 'kpi_onboarded', text: 'KPI Onboarded', sortable: true, groupable: false }, { value: 'campaignType', text: 'Product Type', sortable: true, groupable: false }, { value: 'country', text: 'Country', sortable: true, groupable: false }, { value: 'vertical', text: 'Vertical', sortable: true, groupable: false }, { value: 'assignedTo', text: 'Assigned CC', sortable: true, groupable: false }, { value: 'assignedToAM', text: 'Assigned AM', sortable: true, groupable: false }, { value: 'action', text: 'Actions', sortable: false, groupable: false }],
      campaigns: [],
      campaignType: __WEBPACK_IMPORTED_MODULE_9__Campaign_config__["a" /* default */].campaignType,
      campaignTypeDisplay: __WEBPACK_IMPORTED_MODULE_9__Campaign_config__["a" /* default */].campaignTypeDisplay,

      pagination: {
        rowsPerPage: 10,
        sortBy: 'name',
        descending: false
      },
      items: [],
      selectedClients: [],
      submitting: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filter: '',
      clientGroups: [],
      xeroContacts: [],
      existingAccounts: [],
      campaignVerticals: [],
      selectedCampaignVertical: [],
      assignUsers: []
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.lastUpdate).fromNow();
    }
  },
  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    }
  },
  methods: {
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */]['userPermissions']['client'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    updateItems: function updateItems(response) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var displayItems;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.items = [];
                displayItems = response.clients.map(function (element) {
                  var deals = [];
                  var hasDeals = false;
                  if (typeof element.account !== 'undefined') {
                    if (typeof element.account.deals !== 'undefined') {
                      if (element.account.deals.length > 0) {
                        hasDeals = true;
                      }
                    }
                  }
                  if (hasDeals) {
                    deals = element.account.deals.map(function (deal, index) {
                      var dealCampaigns = _this.campaigns.filter(function (c) {
                        if ((deal.dealCode && c.dealCode && deal.dealCode === c.dealCode || deal.IO && deal.IO === c.ioNumbers) && c.clientID && c.clientID === element.id) {
                          return true;
                        }
                        return false;
                      });
                      dealCampaigns = dealCampaigns.map(function (campaign, campaignIndex) {
                        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
                          clientID: element.id,
                          companyID: element.companyID,
                          dealCode: deal.dealCode,
                          id: campaign.id,
                          campaignIndex: campaignIndex
                        }, {
                          name: campaign.name,
                          partCode: campaign.partCode || '-',
                          ioNumbers: campaign.ioNumbers || '',
                          dealBudget: deal.budget,
                          budget: campaign.budget,
                          outreach: campaign.outreach,
                          min_content: campaign.min_content,
                          max_content: campaign.max_content,
                          kpi_onboarded: campaign.kpi_onboarded,
                          country: __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignHelper__["a" /* default */].formatCountry(_this.countries, campaign.targetLocation || []),
                          vertical: _this.formatCampaignVerticals(campaign),
                          engagement: campaign.engagement,
                          period: '-',
                          campaignType: _this.getProductName(campaign.campaignType),
                          assignedTo: _this.getDedicatedPersons(element.handledBy || [], __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.AD_STRATEGIST),
                          assignedToAM: _this.getDedicatedPersons(element.handledBy || [], __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.ACCOUNT_MANAGER),
                          recognizedRevenue: campaign.revenueRecognized || campaign.revenueRecognized === 0 ? campaign.revenueRecognized : '',
                          unRecognizedRevenue: campaign.unrecognizedRevenue || campaign.unrecognizedRevenue === 0 ? campaign.unrecognizedRevenue : '',
                          cogs: campaign.cogs || '',
                          cogsPercentage: campaign.cogsPercentage || '',
                          allocatePercent: campaign.allocatePercent || '',
                          status: campaign.status,
                          edit: false
                        });
                      });

                      dealCampaigns.sort(function (a, b) {
                        if (a.partCode < b.partCode) {
                          return -1;
                        }
                        if (a.partCode > b.partCode) {
                          return 1;
                        }
                        return 0;
                      });

                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ clientID: element.id,
                        companyID: element.companyID,
                        index: index
                      }, {
                        name: deal.name || element.name,
                        contactName: element.contactName || '',
                        contacts: element.contacts,
                        IO: deal.IO,
                        linkedIOs: deal.linkedIOs || [],
                        campaignType: deal.products.map(function (p) {
                          return _this.getProductName(p.name);
                        }).join(','),
                        budget: deal.budget,
                        email: element.email,
                        dealCode: deal.dealCode || 'N/A',
                        handledBy: element.handledBy,
                        quoteAcceptanceDate: deal.quoteAcceptanceDate,
                        vertical: deal.vertical || [],
                        country: deal.country || [],
                        products: deal.products,
                        campaigns: dealCampaigns
                      });
                    });
                  }

                  var _getDealsGroupSummary = _this.getDealsGroupSummary(deals),
                      IO = _getDealsGroupSummary.IO,
                      dealCode = _getDealsGroupSummary.dealCode,
                      budget = _getDealsGroupSummary.budget;

                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ id: element.id }, {
                    name: element.name,
                    contactName: element.contactName || '',
                    contacts: element.contacts,
                    group: element.group || '',
                    phoneNumber: element.phoneNumber,
                    email: element.email || '',
                    showEmail: _this.getClientEmails(element),
                    address: element.address || '-',
                    startDate: element.account && element.account.startDate ? element.account.startDate : '-',
                    expireDate: element.account && element.account.expireDate ? element.account.expireDate : '-',
                    deals: deals,
                    IO: IO,
                    dealCode: dealCode,
                    budget: budget
                  });
                });

                _this.items = displayItems;
                _this.totalRows = response.totalClients;
                _context.next = 6;
                return _this.getClientGroupItems(_this.items);

              case 6:
                _this.items = _context.sent;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    paginate: function paginate() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].paginate(page, this.perPage, this.filter).then(function (response) {
        _this2.updateItems(response);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    createClient: function createClient(clientData) {
      this.selectedClients = [];
      this.items.push(clientData);
    },
    deleteClient: function deleteClient(clientID) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the client?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].deleteClient(clientID).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this3.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this3.items = _this3.items.filter(function (client) {
            if (client.isGroup && client.clients) {
              client.clients = client.clients.filter(function (cl) {
                return cl.id !== clientID;
              });
              if (client.clients.length) {
                return true;
              } else return false;
            } else {
              return client.id !== clientID;
            }
          });

          _this3.$swal({
            title: 'Deleted',
            text: 'The client has been deleted successfully',
            type: 'success'
          });
        } else {}
      });
    },
    getClientDataToEdit: function getClientDataToEdit(clientID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].getClient(clientID).then(function (response) {
        _this4.editClientData = response;
        _this4.editClientDialog = true;
        _this4.isViewMode = false;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getClientDataToView: function getClientDataToView(clientID) {
      var _this5 = this;

      this.isViewMode = false;
      __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].getClient(clientID).then(function (response) {
        _this5.editClientData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, response);
        _this5.editClientDialog = true;
        _this5.isViewMode = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getClientUserDataToUpdate: function getClientUserDataToUpdate(item) {
      var _this6 = this;

      var clientID = item.id;
      __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].getClientUser(clientID).then(function (response) {
        response = Array.isArray(response) ? response : [];
        var updateData = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(response.find(function (r) {
          return r.email === item.email;
        }));

        if (!updateData && response.length > 0) {
          var responseOne = response[0];
          updateData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
            firstName: responseOne.firstName,
            lastName: responseOne.lastName
          });
        }

        updateData.clientID = clientID;
        updateData.contacts = item.contacts || [];

        if (!updateData.email) {
          if (item.email) {
            updateData.email = item.email;
          }
        }
        _this6.updateClientLoginData = updateData;

        _this6.existingAccounts = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], response);
        _this6.existingAccounts = _this6.existingAccounts.map(function (e) {
          e.password = '';
          e.show1 = false;
          return e;
        });
        _this6.updateClientLoginModal = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    editClient: function editClient(clientData) {
      var selectedIndex = -1;

      this.items.forEach(function (client, index) {
        if (client.id === clientData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, clientData);
      }

      this.selectedClients = [];
      console.log('Client edited');
      this.paginate(1);
    },
    reRenderDataTable: function reRenderDataTable() {
      this.paginate(this.currentPage);
    },
    selectAllClients: function selectAllClients($event) {
      if (!$event.value) {
        this.selectedClients = [];
        return;
      }
      this.selectedClients = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], this.items);
    },
    openClientGroupModal: function openClientGroupModal() {
      this.clientGroupDialog = true;
    },
    savedClientGroup: function savedClientGroup() {
      this.selectedClients = [];
      this.reRenderDataTable();
    },
    openGroupEdit: function openGroupEdit(item) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var groupIndex = this.items.findIndex(function (i) {
        return i.id === item.id;
      });
      this.items[groupIndex].groupEdit = status;
      this.items = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.refreshJSON(this.items);
      this.selectedClients = [];
    },
    updateXeroContact: function updateXeroContact(item) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_12__Xero_XeroAPIs__["a" /* default */].updateXeroContact(item.id, { name: item.name }).then(function (response) {
        item.groupEdit = false;
        _this7.selectedClients = [];
      }).catch(function (error) {
        console.log('error', error);

        _this7.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
      });
    },
    deleteClientGroup: function deleteClientGroup(groupID, groupName) {
      var _this8 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete this group (' + groupName + ')?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].deleteClientGroup(groupID).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this8.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this8.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this8.clientGroups = _this8.clientGroups.filter(function (group) {
            return group.id !== groupID;
          });
          _this8.reRenderDataTable();

          _this8.$swal({
            title: 'Deleted',
            text: 'The group has been deleted successfully',
            type: 'success'
          });
        } else {}
      });
    },
    addAllocate: function addAllocate(item, type) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this9.expanded = true;
                updateData = {
                  deal: item,
                  products: [],
                  type: type
                };

                if (type === 'all') {
                  updateData.products = item.products;
                  _this9.allocateCampaign(updateData);
                } else {
                  updateData.products.push({ type: 'custom' });
                  _this9.viewDealData = updateData;
                  _this9.customAmountUpdateDialog = true;
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this9);
      }))();
    },
    allocateCampaign: function allocateCampaign(obj) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var budget, item, products, type, budgetPercentAmt, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, product, partCode, outreach, minContent, maxContent, kpiOnboarded, engagement, campaignType, _type, countryLists;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                budget = 0;
                item = obj.deal;
                products = obj.products;
                type = obj.type;

                if (type === 'all') {
                  budget = item.budget || 0;
                } else {
                  budgetPercentAmt = Number((Number(item.budget) * Number(obj.amount) / 100).toFixed(2));

                  budget = budgetPercentAmt;
                }
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 8;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(products);

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 30;
                  break;
                }

                product = _step.value;
                partCode = '';

                if (!(item.dealCode && item.dealCode !== 'N/A')) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 16;
                return _this10.getPartCodebyDeal(item.dealCode, item.campaigns);

              case 16:
                partCode = _context3.sent;

              case 17:
                outreach = 0;
                minContent = 0;
                maxContent = 0;
                kpiOnboarded = 0;
                engagement = 0;
                campaignType = _this10.campaignType.NO_PREFERENCE;

                if (type === 'all' && product !== null) {
                  if (product.name.toLowerCase() === _this10.campaignType.AMPLIFY.toLowerCase()) {
                    outreach = product.views || 0;
                  } else {
                    outreach = product.totalOutReach || 0;
                  }
                  minContent = product.minContent || 0;
                  maxContent = product.maxContent || 0;
                  kpiOnboarded = product.kpiOnboarded || 0;
                  engagement = product.totalEngagement || 0;
                }
                if (item.campaignType !== null) {
                  _type = _this10.campaignTypeDisplay.find(function (c) {
                    return c.value.toLowerCase() === item.campaignType.toLowerCase();
                  });

                  if (_type) {
                    campaignType = _type.value;
                  }
                }
                countryLists = _this10.countries.filter(function (c) {
                  return item.country.includes(c.code);
                });

                item.campaigns.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
                  clientID: item.clientID,
                  companyID: item.companyID,
                  dealCode: item.dealCode,
                  id: 0,
                  campaignIndex: item.campaigns.length,
                  country: countryLists || [],
                  vertical: item.vertical || []
                }, {
                  name: item.name || '',
                  partCode: partCode,
                  ioNumbers: item.IO,
                  budget: budget,
                  outreach: outreach,
                  min_content: minContent,
                  max_content: maxContent,
                  kpi_onboarded: kpiOnboarded,
                  engagement: engagement,
                  assignedTo: _this10.getDedicatedPersons(item.handledBy || [], __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.AD_STRATEGIST),
                  assignedToAM: _this10.getDedicatedPersons(item.handledBy || [], __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.ACCOUNT_MANAGER),
                  period: '-',
                  campaignType: campaignType,
                  allocateType: type,
                  allocatePercent: obj.amount,
                  recognizedRevenue: '',
                  unRecognizedRevenue: '',
                  cogs: '',
                  edit: true
                }));

              case 27:
                _iteratorNormalCompletion = true;
                _context3.next = 10;
                break;

              case 30:
                _context3.next = 36;
                break;

              case 32:
                _context3.prev = 32;
                _context3.t0 = _context3['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 36:
                _context3.prev = 36;
                _context3.prev = 37;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 39:
                _context3.prev = 39;

                if (!_didIteratorError) {
                  _context3.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context3.finish(39);

              case 43:
                return _context3.finish(36);

              case 44:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this10, [[8, 32, 36, 44], [37,, 39, 43]]);
      }))();
    },
    saveCampaign: function saveCampaign(item) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var checkstatus;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('save campaign', item);
                checkstatus = _this11.checkBudget(_this11.getRootCampaigns(item));

                if (!(item.campaignType === __WEBPACK_IMPORTED_MODULE_9__Campaign_config__["a" /* default */].campaignType.NO_PREFERENCE || item.campaignType === undefined)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt('return', _this11.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Please Select Product Type'
                }));

              case 6:
                if (!(!item.country || !item.country.length)) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt('return', _this11.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Please Select Country'
                }));

              case 10:
                if (!(item.vertical.length === 0)) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt('return', _this11.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Please Select Campaign Vertical.'
                }));

              case 12:
                if (!checkstatus) {
                  _this11.$swal({
                    title: 'Not Enough Budget.',
                    icon: 'warning',
                    text: 'The current budget for this campaign is exceeded the limited. Please check again',
                    confirmButtonText: 'Continue',
                    showCancelButton: true
                  }).then(function (result) {
                    if (result.value) {
                      _this11.doSaveCampaign(item);
                    }
                  });
                } else {
                  _this11.doSaveCampaign(item);
                }

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this11);
      }))();
    },
    doSaveCampaign: function doSaveCampaign(item) {
      var _this12 = this;

      var campaign = this.buildCampaignFormData(item);
      var formData = new FormData();
      formData.append('campaign', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(campaign));
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this12.submitting = true;

          __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].createCampaignByAllocate(formData).then(function (response) {
            item.edit = false;
            var alertText = '';
            _this12.updateClient(item);
            if (item.id === 0) {
              item.id = response.id;
              alertText = 'You can set up the campaign timeline now or stay here and continue later.';

              _this12.$swal({
                title: 'Campaign allocated',
                text: alertText,
                type: 'success',
                confirmButtonText: 'Go to Campaign Timeline',
                showCancelButton: true,
                cancelButtonText: 'Stay here',
                allowOutsideClick: false
              }).then(function (result) {
                if (result.value) {
                  _this12.$router.push({
                    path: '/campaigns/timeline',
                    query: {
                      campaignID: item.id
                    }
                  });
                }
              });
            } else {
              item.partCode = response.partCode || '-';
              alertText = 'Campaign Updated';

              _this12.$swal({
                text: alertText,
                type: 'success'
              });
            }

            _this12.submitting = false;
          }).catch(function (error) {
            _this12.submitting = false;

            if (error.response.status === 400) {
              _this12.$swal({
                text: 'Campaign name already exists. Please change campaign name.',
                type: 'error'
              });
            }
          });
        }
      });
    },
    deleteCampaign: function deleteCampaign(item) {
      var _this13 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the campaign?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].deleteCampaign(item.id).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this13.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this13.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this13.cancelCampaignRow(item);

          _this13.$swal({
            title: 'Deleted',
            text: 'The campaign has been deleted successfully',
            type: 'success'
          });
        } else {}
      });
    },
    buildCampaignFormData: function buildCampaignFormData(item) {
      if (item.country) {
        item.country = item.country.map(function (v) {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            };
          }
          return v;
        });
      }
      var campaignCode = item.dealCode;
      if (item.partCode !== '-') {
        campaignCode = campaignCode + '-' + item.partCode;
      }
      var data = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        id: item.id,
        clientID: item.clientID,
        companyID: item.companyID,
        dealCode: item.dealCode,
        name: item.name,
        campaignCode: campaignCode,
        partCode: item.partCode !== '-' ? item.partCode : null,
        ioNumbers: item.ioNumbers,
        budget: item.budget,
        outreach: item.outreach,
        min_content: item.min_content,
        max_content: item.max_content,
        kpi_onboarded: item.kpi_onboarded,
        targetLocation: item.country,
        vertical: item.vertical,
        engagement: item.engagement,
        campaignType: item.campaignType,
        allocateType: item.allocateType,
        allocatePercent: item.allocatePercent
      });

      if (data.id === 0) {
        data.assignedTo = item.assignedTo.map(function (a) {
          return a.id;
        });
        if (item.assignedToAM) {
          item.assignedToAM.map(function (a) {
            data.assignedTo.push(a.id);
          });
        }
        data.goal = [];
        data.angles = [__WEBPACK_IMPORTED_MODULE_10__Campaign_campaignHelper__["a" /* default */].getDefaultAngle()];
        data.influencer_ideal = [];
        data.influencer_unwanted = [];
        data.targetAge = ['25 - 34'];
      }
      return data;
    },
    cancelCampaignRow: function cancelCampaignRow(item) {
      var campaigns = this.getRootCampaigns(item);
      var index = campaigns.findIndex(function (c) {
        return c.id === item.id;
      });
      campaigns.splice(index, 1);
      campaigns = campaigns.map(function (c, index) {
        c.campaignIndex = index;
        return c;
      });
      return true;
    },
    switchRevenue: function switchRevenue(revenueCalculation) {
      if (revenueCalculation !== undefined) {
        if (revenueCalculation === 'engagement') {
          return 'engagement';
        } else {
          return 'content';
        }
      } else {
        return 'engagement';
      }
    },
    getClientGroupItems: function getClientGroupItems(items) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _groups;

        var groups, noGroupItems;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.fetchXeroContact();

              case 2:
                groups = _this14.xeroContacts;

                groups = groups.map(function (group) {
                  var groupItems = items.filter(function (c) {
                    return c.group && c.group.id === group.id;
                  });

                  var _getDealsGroupSummary2 = _this14.getDealsGroupSummary(groupItems),
                      IO = _getDealsGroupSummary2.IO,
                      dealCode = _getDealsGroupSummary2.dealCode,
                      budget = _getDealsGroupSummary2.budget;

                  group = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(group, {
                    name: group.Name,
                    phoneNumber: '',
                    showEmail: _this14.getGroupedClientEmails(groupItems),
                    address: '',
                    startDate: '',
                    expireDate: '',
                    clients: groupItems,
                    IO: IO,
                    dealCode: dealCode,
                    budget: budget,
                    isGroup: true
                  });
                  return group;
                });

                groups = groups.filter(function (g) {
                  return g.clients && g.clients.length > 0;
                });
                noGroupItems = items.filter(function (c) {
                  return !c.group;
                });

                (_groups = groups).push.apply(_groups, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(noGroupItems));
                return _context5.abrupt('return', groups);

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    },
    getClientGroups: function getClientGroups() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].getClientGroups();

              case 3:
                resp = _context6.sent;

                if (resp.success) {
                  _this15.clientGroups = resp.data;
                }
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);

                console.error(_context6.t0);

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this15, [[0, 7]]);
      }))();
    },
    getRootCampaigns: function getRootCampaigns(item) {
      var _getCampaignRootIndex = this.getCampaignRootIndexes(item),
          groupIndex = _getCampaignRootIndex.groupIndex,
          clientIndex = _getCampaignRootIndex.clientIndex,
          dealIndex = _getCampaignRootIndex.dealIndex,
          isGroup = _getCampaignRootIndex.isGroup;

      var campaigns = [];
      if (isGroup) {
        campaigns = this.items[groupIndex].clients[clientIndex].deals[dealIndex].campaigns;
      } else {
        clientIndex = this.items.findIndex(function (i) {
          return i.id === item.clientID;
        });
        dealIndex = this.items[clientIndex].deals.findIndex(function (d) {
          return d.dealCode === item.dealCode || d.IO === item.ioNumbers;
        });
        campaigns = this.items[clientIndex].deals[dealIndex].campaigns;
      }
      return campaigns;
    },
    getCampaignRootIndexes: function getCampaignRootIndexes(item) {
      var groupIndex = 0;
      var clientIndex = 0;
      var dealIndex = 0;
      var isGroup = false;
      this.items.map(function (loopItem, mainIndex) {
        if (loopItem.isGroup) {
          loopItem.clients.map(function (client, index) {
            if (client.id === item.clientID) {
              clientIndex = index;
              groupIndex = mainIndex;
              dealIndex = client.deals.findIndex(function (d) {
                return d.dealCode === item.dealCode || d.IO === item.ioNumbers;
              });
              isGroup = true;
            }
          });
        }
      });
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        groupIndex: groupIndex,
        clientIndex: clientIndex,
        dealIndex: dealIndex,
        isGroup: isGroup
      });
    },
    getUsedBudgets: function getUsedBudgets(campaigns) {
      var amount = 0;
      campaigns.map(function (c) {
        if (c.budget) {
          amount += Number(c.budget);
        }
      });
      return amount.toFixed(2);
    },
    getRemainBudgets: function getRemainBudgets(campaigns) {
      var usedAmount = this.getUsedBudgets(campaigns);
      var totalAmount = 0;
      var remainAmount = 0;
      if (campaigns.length > 0) {
        totalAmount = campaigns.length > 0 ? campaigns[0].dealBudget : 0;
      }
      if (totalAmount > 0) {
        remainAmount = totalAmount - usedAmount;
      }
      return remainAmount.toFixed(2);
    },
    checkBudget: function checkBudget(campaigns) {
      var remainBudgets = this.getRemainBudgets(campaigns);
      if (remainBudgets < 0) {
        return false;
      }
      return true;
    },
    getPartCodebyDeal: function getPartCodebyDeal(dealCode, campaigns) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, count, addCampaignCount;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].getDealCampaignCount(dealCode);

              case 3:
                response = _context7.sent;
                count = response.count;
                addCampaignCount = campaigns.filter(function (c) {
                  return c.edit === true;
                }).length;
                return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.numToAlphabet(addCampaignCount + count + 1));

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);

              case 12:
                return _context7.abrupt('return', '');

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this16, [[0, 9]]);
      }))();
    },
    getDealsGroupSummary: function getDealsGroupSummary(deals) {
      var _ref = '',
          IO = _ref.IO,
          dealCode = _ref.dealCode,
          budget = _ref.budget;

      if (deals.length > 0) {
        IO = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(deals.map(function (d) {
          return d.IO ? d.IO.trim() : '';
        }))));
        IO = IO.filter(function (val) {
          return val !== undefined && val !== null && val !== '';
        }).join(', ');
        dealCode = deals.filter(function (d) {
          return d.dealCode !== 'N/A';
        }).map(function (m) {
          return m.dealCode;
        }).join(', ');
        budget = deals.map(function (d) {
          return parseInt(d.budget || 0);
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
      }
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        IO: IO,
        dealCode: dealCode,
        budget: budget
      });
    },
    fetchXeroContact: function fetchXeroContact() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var resp, respData, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__Xero_XeroAPIs__["a" /* default */].getXeroContacts();

              case 3:
                resp = _context8.sent;
                respData = resp.data;
                data = respData.data;

                _this17.xeroContacts = data || [];
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this17, [[0, 9]]);
      }))();
    },
    getAllCampaigns: function getAllCampaigns() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus();

              case 2:
                response = _context9.sent;

                if (response) {
                  _this18.campaigns = response;
                }

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this18);
      }))();
    },
    getGroupedClientEmails: function getGroupedClientEmails(clients) {
      var emails = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      clients.map(function (contact) {
        emails.add(contact.showEmail);
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(emails)).join(', ');
    },
    getClientEmails: function getClientEmails(client) {
      var emails = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      if (client.email !== '') {
        emails.add(client.email);
      }
      if (client.contacts !== undefined) {
        client.contacts.map(function (contact) {
          if (contact.email !== '') {
            emails.add(contact.email);
          }
        });
      }
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(emails)).join(', ');
    },
    getDefaultContact: function getDefaultContact(clientID) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var email = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      return {
        clientID: clientID,
        name: name,
        email: email
      };
    },
    formatDecimal: function formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    getProductName: function getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut';
      }
      return itemName;
    },
    getCampaignVerticals: function getCampaignVerticals() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var responsevertical;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].getAllCampaignVerticals(false);

              case 2:
                responsevertical = _context10.sent;

                _this19.campaignVerticals = [];
                _this19.campaignVerticals = responsevertical.data;

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this19);
      }))();
    },

    getCountryDisplayValueFromSelect: function getCountryDisplayValueFromSelect(value) {
      if (typeof value === 'string') return value;
      var selectedOption = this.countries.filter(function (option) {
        return value.includes(option.code);
      });
      return selectedOption ? selectedOption.map(function (o) {
        return o.name;
      }).join(', ') : '-';
    },
    formatCampaignVerticals: function formatCampaignVerticals(campaign) {
      var selectedCampaignVertical = [];
      if (campaign.vertical) {
        this.campaignVerticals.map(function (item) {
          campaign.vertical.map(function (vertical) {
            if (item.id === vertical.id) {
              selectedCampaignVertical.push(item);
            }
          });
        });
      }
      return selectedCampaignVertical;
    },
    getAssignUsers: function getAssignUsers() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                resp = _context11.sent;

                if (resp) _this20.CO = resp.users;
                _context11.next = 6;
                return __WEBPACK_IMPORTED_MODULE_14__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 6:
                resp = _context11.sent;

                if (resp) _this20.AM = resp.users;
                _this20.assignUsers = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this20.CO), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this20.AM)));

              case 9:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this20);
      }))();
    },
    getDedicatedPersons: function getDedicatedPersons(handledBy) {
      var role = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var dedicatedData = [];
      if (handledBy) {
        this.assignUsers.map(function (item) {
          handledBy.map(function (userId) {
            if (item.id === userId) {
              if (role) {
                if (role === item.role) dedicatedData.push(item);
              } else dedicatedData.push(item);
            }
          });
        });
      }
      return dedicatedData;
    },
    showLinkedIO: function showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return '';
      IOs = IOs.map(function (i) {
        if (!i.includes('IO-')) {
          i = 'IO-' + i;
        }
        return i;
      });
      return IOs.join(', ');
    },
    updateClient: function updateClient(item) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var clientData, formData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].getClient(item.clientID);

              case 2:
                clientData = _context12.sent;

                if (item.ioNumbers) {
                  if (clientData.account) {
                    if (clientData.account.deals) {
                      clientData.account.deals = clientData.account.deals.map(function (d) {
                        d.allocatePercent = item.allocatePercent;
                        d.allocateType = item.allocateType;
                        return d;
                      });
                    }
                  }
                }
                formData = new FormData();

                formData.append('client', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(clientData));
                _context12.next = 8;
                return __WEBPACK_IMPORTED_MODULE_11__clientAPIs__["a" /* default */].updateClient({ clientID: item.clientID, clientInfoFormData: formData });

              case 8:
                return _context12.abrupt('return', true);

              case 9:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this21);
      }))();
    }
  },
  created: function created() {
    var _this22 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _this22.campaignTypeDisplay = _this22.campaignTypeDisplay.filter(function (c) {
                return c.value !== _this22.campaignType.NO_PREFERENCE;
              });
              _context13.next = 3;
              return _this22.getAllCampaigns();

            case 3:
              _context13.next = 5;
              return _this22.getCampaignVerticals();

            case 5:
              _context13.next = 7;
              return _this22.getAssignUsers();

            case 7:
              _this22.paginate(1);

            case 8:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this22);
    }))();
  }
});

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateCompanyModal',
  props: ['modalId'],
  data: function data() {
    return {
      company: {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      }
    };
  },

  validations: {
    company: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      website: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(8)
      }
    }
  },
  methods: {
    createCompany: function createCompany() {
      var _this = this;

      var company = this.company;

      __WEBPACK_IMPORTED_MODULE_0__companyAPIs__["a" /* default */].createCompany(company).then(function (response) {
        _this.$emit('createCompany', response);

        _this.$refs.closeButton.click();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    clearData: function clearData() {
      this.company = {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      };
    }
  }
});

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditCompanyModal',
  props: ['modalId', 'companyData'],
  data: function data() {
    return {
      company: null
    };
  },

  watch: {
    companyData: function companyData(newCompanyData) {
      this.company = newCompanyData;
    }
  },
  validations: {
    company: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      website: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      phoneNumber: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(8)
      }
    }
  },
  methods: {
    editCompany: function editCompany() {
      var _this = this;

      var company = this.company;

      __WEBPACK_IMPORTED_MODULE_0__companyAPIs__["a" /* default */].editCompany(company).then(function (response) {
        _this.$emit('editCompany', response);

        _this.$refs.closeButton.click();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    clearData: function clearData() {
      this.company = {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      };
    }
  }
});

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewCompanyModal',
  props: ['modalId', 'companyData'],
  data: function data() {
    return {
      company: {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      }
    };
  },

  watch: {
    companyData: function companyData(newCompanyData) {
      this.company = newCompanyData;
    }
  }
});

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateCompanyModal__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateCompanyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CreateCompanyModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCompanyModal__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCompanyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditCompanyModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewCompanyModal__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewCompanyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ViewCompanyModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Company',
  components: {
    CreateCompanyModal: __WEBPACK_IMPORTED_MODULE_2__CreateCompanyModal___default.a,
    EditCompanyModal: __WEBPACK_IMPORTED_MODULE_3__EditCompanyModal___default.a,
    ViewCompanyModal: __WEBPACK_IMPORTED_MODULE_4__ViewCompanyModal___default.a
  },
  data: function data() {
    return {
      createModalId: 'create_company_modal',
      editModalId: 'edit_company_modal',
      viewModalId: 'view_company_modal',
      editCompanyData: null,
      viewCompanyData: null,
      sortBy: 'name',
      sortDesc: false,
      fields: [{ text: 'Name', value: 'name' }, { text: 'Address', value: 'address' }, { text: 'Website', value: 'website' }, { text: 'Phone Number', value: 'phoneNumber' }, { text: 'Actions', value: 'actions', sortable: false }],
      items: [],
      pagination: {
        page: 1,
        itemsPerPage: 15
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filter: ''
    };
  },

  computed: {
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.lastUpdate).fromNow();
    },
    createModalIdDisplay: function createModalIdDisplay() {
      return '#' + this.createModalId;
    },
    editModalIdDisplay: function editModalIdDisplay() {
      return '#' + this.editModalId;
    },
    viewModalIdDisplay: function viewModalIdDisplay() {
      return '#' + this.viewModalId;
    }
  },
  watch: {
    pagination: function pagination(newVal) {
      this.paginate(newVal.page);
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateItems: function updateItems(response) {
      this.items = response.companies;
      this.totalRows = response.totalCompanies;
    },
    paginate: function paginate() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_1__companyAPIs__["a" /* default */].paginate(page, this.perPage, this.filter).then(function (response) {
        _this.updateItems(response);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    createCompany: function createCompany(companyData) {
      this.paginate(1);
    },
    deleteCompany: function deleteCompany(companyID) {
      var _this2 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the company?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_1__companyAPIs__["a" /* default */].deleteCompany(companyID).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);
            _this2.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this2.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this2.items = _this2.items.filter(function (company) {
            return company.id !== companyID;
          });
          _this2.$swal({
            title: 'Deleted',
            text: 'The company has been deleted successfully',
            type: 'success'
          });
        }
      });
    },
    getCompanyDataToEdit: function getCompanyDataToEdit(companyID) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__companyAPIs__["a" /* default */].getCompany(companyID).then(function (response) {
        _this3.editCompanyData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getCompanyDataToView: function getCompanyDataToView(companyID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__companyAPIs__["a" /* default */].getCompany(companyID).then(function (response) {
        _this4.viewCompanyData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    editCompany: function editCompany(companyData) {
      var selectedIndex = -1;

      this.items.forEach(function (company, index) {
        if (company.id === companyData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, companyData);
      }
      console.log('Company edited');
    }
  },
  created: function created() {
    this.paginate(1);
  }
});

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contentAnalysisAPI__ = __webpack_require__(127);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentAnalysisResultModal',
  props: ['modalId', 'postData'],
  data: function data() {
    return {
      imageProcessingData: [],
      nluProcessingData: [],
      imageRecognitionResultsTable: [],
      concepts: [],
      sentimentScoreCss: {},
      sentiment: '+60.57',
      shortCode: null,
      igPost: null,
      imageProcessingFields: [{
        key: 'Tags',
        sortable: true
      }, {
        key: 'Value',
        sortable: true
      }],
      imageProcessingPagging: {
        totalRows: 0,
        perPage: 10,
        currentPage: 1,
        items: []
      }
    };
  },

  watch: {
    postData: function postData(newPostData) {
      var _this = this;

      this.shortCode = newPostData.short_code;
      this.nluProcessingData = newPostData.nlu_processing_data;
      this.imageProcessingData = newPostData.image_processing_data;
      this.imageProcessingData.sort(function (a, b) {
        return b.value - a.value;
      });
      this.imageRecognitionResultsTable = [];
      this.imageProcessingData.forEach(function (item) {
        _this.imageRecognitionResultsTable.push({
          Value: (item.value * 100).toFixed(2) + '%',
          Tags: item.name
        });
      });

      if (this.nluProcessingData.concepts) {
        this.concepts = [];
        this.concepts = this.nluProcessingData.concepts;
      }

      if (this.nluProcessingData.sentiment) {
        var sentimentScore = (this.nluProcessingData.sentiment.score * 100).toFixed(2);
        this.sentiment = sentimentScore + '%';
        if (sentimentScore > 0) {
          this.sentiment = '+' + this.sentiment;
        }
        if (sentimentScore < -0.5) {
          this.sentimentScoreCss = { 'color': 'red' };
        } else if (sentimentScore < -0) {
          this.sentimentScoreCss = { 'color': 'orange' };
        } else if (sentimentScore < 0.5) {
          this.sentimentScoreCss = { 'color': '#ffd400' };
        } else {
          this.sentimentScoreCss = { 'color': 'green' };
        }
      }
      this.imageProcessingPagging.totalRows = this.imageProcessingData.length;
      this.paginateImageProcessing();
      this.getInstagramPost();
    },
    'imageProcessingPagging.currentPage': function imageProcessingPaggingCurrentPage(currentPage) {
      this.paginateImageProcessing();
    }
  },
  methods: {
    paginateImageProcessing: function paginateImageProcessing() {
      var start = (this.imageProcessingPagging.currentPage - 1) * this.imageProcessingPagging.perPage;
      var end = start + this.imageProcessingPagging.perPage;
      this.imageProcessingPagging.items = this.imageRecognitionResultsTable.slice(start, end);
    },
    getInstagramPost: function getInstagramPost() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__contentAnalysisAPI__["a" /* default */].oembed(this.shortCode).then(function (data) {
        _this2.igPost = data.oembed;
        setTimeout(function () {
          window.instgrm.Embeds.process();
        }, 100);
      }).catch(function () {
        _this2.igPost = '';
      });
    }
  }
});

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentAnalysisResultModal__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentAnalysisResultModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ContentAnalysisResultModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contentAnalysisAPI__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentAnalysis',
  components: {
    ContentAnalysisResultModal: __WEBPACK_IMPORTED_MODULE_0__ContentAnalysisResultModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      contentAnalysisResultModal: 'contentAnalysisResultModal',
      igUrl: '',
      postAnalytics: null,
      isLoading: false,
      histories: [],
      items: [],
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      fields: [{
        value: 'updatedAt',
        text: 'Date'
      }, {
        value: 'instagram',
        text: 'Instagram Post'
      }, {
        value: 'actions',
        text: 'Actions'
      }]
    };
  },

  computed: {
    viewModalIdDisplay: function viewModalIdDisplay() {
      return '#' + this.contentAnalysisResultModal;
    }
  },
  mounted: function mounted() {
    this.getHistories();
    this.$nextTick(function () {
      $(document).trigger("resize");
    });
  },
  watch: {
    currentPage: function currentPage(newValue) {
      this.paginate();
    }
  },
  methods: {
    analyse: function analyse(igUrl) {
      var _this = this;

      var shortCode = '';
      if (!igUrl) {
        this.$swal({
          title: 'Empty Post URL',
          text: 'Please Input a valid URL',
          type: 'error'
        });
        return;
      } else {
        if (igUrl.indexOf('https://www.instagram.com/p/') !== -1) {
          var regex = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].regexPattern.instagram;

          if (igUrl.match(regex)) {
            var searchShortCodes = regex.exec(igUrl);
            shortCode = searchShortCodes[1];
          }
        }
        if (shortCode.trim().length === 0) {
          this.$swal({
            title: 'Error',
            text: 'Please Input a valid URL',
            type: 'error'
          });
        } else {
          this.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_1__contentAnalysisAPI__["a" /* default */].analyse(shortCode).then(function (result) {
            _this.postAnalytics = result.post_analytics;
            document.getElementById('viewModalIdDisplay').click();
            _this.isLoading = false;
            _this.getHistories();
          }).catch(function (error) {
            console.log(error);
            _this.$swal({
              title: 'Error',
              text: 'Cannot found the post',
              type: 'error'
            });
            _this.isLoading = false;
          });
        }
      }
    },

    getHistories: function getHistories() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__contentAnalysisAPI__["a" /* default */].getHistories().then(function (data) {
        _this2.histories = data;
        _this2.totalRows = _this2.histories.length;
        _this2.paginate();
      });
    },
    paginate: function paginate() {
      var start = (this.currentPage - 1) * this.perPage;
      var end = start + this.perPage;
      this.items = this.histories.slice(start, end);
    },
    view: function view(item) {
      this.analyse(item.instagram);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68)))

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_ServicesHealthList_vue__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_ServicesHealthList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DashboardComponents_ServicesHealthList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_KobeOverview_vue__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_KobeOverview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DashboardComponents_KobeOverview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_ChangePasswordModal__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_ChangePasswordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__User_ChangePasswordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_PostsSummary_vue__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_PostsSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DashboardComponents_PostsSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DashboardComponents_CampaignSummary_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DashboardComponents_CampaignSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DashboardComponents_CampaignSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_InfluencerTasks_vue__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_InfluencerTasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DashboardComponents_InfluencerTasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DashboardComponents_ContentStrategistTasks_vue__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DashboardComponents_ContentStrategistTasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__DashboardComponents_ContentStrategistTasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_SalePersonTasks_vue__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_SalePersonTasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__DashboardComponents_SalePersonTasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_ClientTasks_vue__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_ClientTasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__DashboardComponents_ClientTasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scoped_xero_ConnectXero__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scoped_xero_ConnectXero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__scoped_xero_ConnectXero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_AudienceInsightPreview_vue__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_AudienceInsightPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__DashboardComponents_AudienceInsightPreview_vue__);





















var healthData = [];

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ServicesHealthList: __WEBPACK_IMPORTED_MODULE_5__DashboardComponents_ServicesHealthList_vue___default.a,
    KobeOverview: __WEBPACK_IMPORTED_MODULE_6__DashboardComponents_KobeOverview_vue___default.a,
    ChangePasswordModal: __WEBPACK_IMPORTED_MODULE_7__User_ChangePasswordModal___default.a,
    CampaignSummary: __WEBPACK_IMPORTED_MODULE_9__DashboardComponents_CampaignSummary_vue___default.a,
    PostsSummary: __WEBPACK_IMPORTED_MODULE_8__DashboardComponents_PostsSummary_vue___default.a,
    ConnectXero: __WEBPACK_IMPORTED_MODULE_14__scoped_xero_ConnectXero___default.a,
    InfluencerTasks: __WEBPACK_IMPORTED_MODULE_10__DashboardComponents_InfluencerTasks_vue___default.a,
    ContentStrategistTasks: __WEBPACK_IMPORTED_MODULE_11__DashboardComponents_ContentStrategistTasks_vue___default.a,
    SalePersonTasks: __WEBPACK_IMPORTED_MODULE_12__DashboardComponents_SalePersonTasks_vue___default.a,
    ClientTasks: __WEBPACK_IMPORTED_MODULE_13__DashboardComponents_ClientTasks_vue___default.a,
    AudienceInsightPreview: __WEBPACK_IMPORTED_MODULE_15__DashboardComponents_AudienceInsightPreview_vue___default.a
  },
  data: function data() {
    return {
      passwordModalDialog: false,
      words: null,
      healthCheckData: null,
      currentTime: null,
      pwdWarning: false,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      userData: {},
      showInfluencerRequiredField: false
    };
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch('LOG_OUT');

      this.$router.push({ name: 'Login' });
    },
    passwordChanged: function passwordChanged() {
      var _this = this;

      this.passwordModalDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your password has been changed. Please login again!',
        type: 'success'
      }).then(function () {
        _this.logout();
      });
    },
    updatePassword: function updatePassword() {
      this.passwordModalDialog = true;
    },
    setupMailchimpPopup: function setupMailchimpPopup() {
      var mailchimpConfig = {
        baseUrl: 'mc.us19.list-manage.com',
        uuid: 'd509617a8b3dea7957f9fb6f4',
        lid: '59d7d5ceb3'
      };

      var chimpPopupLoader = document.createElement('script');
      chimpPopupLoader.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/signup-forms/popup/embed.js';
      chimpPopupLoader.setAttribute('data-dojo-config', 'usePlainJson: true, isDebug: false');
      var chimpPopup = document.createElement('script');
      chimpPopup.appendChild(document.createTextNode('require(["mojo/signup-forms/Loader"], function (L) { L.start({"baseUrl": "' + mailchimpConfig.baseUrl + '", "uuid": "' + mailchimpConfig.uuid + '", "lid": "' + mailchimpConfig.lid + '"})});'));
      chimpPopupLoader.onload = function () {
        document.body.appendChild(chimpPopup);
      };
      document.body.appendChild(chimpPopupLoader);
    },

    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getRandomRotation: function getRandomRotation(min, max) {
      return Math.random() * (max - min) + min;
    },
    showOnDashboard: function showOnDashboard(section) {
      var dashboardPermission = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */]['userPermissions']['dashboard'][section];
      return dashboardPermission.includes(this.user.role);
    },
    getServicesHealthData: function getServicesHealthData() {
      healthData = [];
      this.healthcheck('posts');
      this.healthcheck('users');
      this.healthcheck('clients');
      this.healthcheck('pairings');
      this.healthcheck('campaigns');
      this.healthcheck('companies');
      this.healthcheck('instagrams');
      this.healthcheck('influencers');
      this.healthcheck('social-data');
      this.healthcheck('content-analysis');
      this.healthcheck('payments');
      this.currentTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('LTS');
      this.healthCheckData = healthData;
    },
    healthcheck: function healthcheck(service) {
      var host = location.protocol + '//' + location.hostname + ':' + location.port;
      var url = host + '/api/v1/' + service + '/healthcheck';
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', url, true).then(function (res) {
        healthData.push(res.data);
      }).catch(function () {
        healthData.push({ service: 'Error in ' + service + '_service' });
      });
    },
    getUserProfile: function getUserProfile() {
      if (!this.influencerID || !this.currentUserID) {
        return;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    influencerID: function influencerID() {
      return this.user.influencerID;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    if (this.user.role === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
      this.$router.push({ name: 'am-dashboard' });
    }
    if (this.user.role === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST) {
      this.$router.push({ name: 'co-dashboard' });
    }
    if (this.user.role === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.INFLUENCER) {
      this.setupMailchimpPopup();
    }
    if (this.user.role === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH) {
      this.getServicesHealthData();
    }
    this.pwdWarning = this.user.pwdWarning;

    this.getUserProfile();
  }
});

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Campaign_config__ = __webpack_require__(26);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignBriefDataTable',
  data: function data() {
    return {
      headers: [{
        text: 'Deal Name',
        value: 'name',
        align: 'center'
      }, {
        text: 'Timeline',
        value: 'timeline',
        align: 'center'
      }, {
        text: 'Status',
        value: 'status',
        align: 'center'
      }, {
        text: 'Deadline for approval',
        value: 'AMDeadline',
        align: 'center'
      }],
      items: [],
      filteredItems: [],
      selectedFilter: {
        AM: '',
        CC: ''
      },
      dashboardStatusDisplay: __WEBPACK_IMPORTED_MODULE_6__Campaign_config__["a" /* default */].dashboardStatusDisplay,
      loading: false
    };
  },

  props: ['AM', 'CC'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    dashboardCampaigns: function dashboardCampaigns(state) {
      return state.campaign.dashboardBriefings;
    },
    savedDashboardStatus: function savedDashboardStatus(state) {
      return state.campaign.savedDashboardStatus;
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAM: function isAM() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    isCC: function isCC() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    isLinkAllow: function isLinkAllow() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();
              setTimeout(function () {
                _this.setAMCC();
              }, 2000);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.$store.dispatch('campaign/getDashboardCampaigns', {});

              case 3:
                _this2.items = _this2.dashboardCampaigns.map(function (d) {
                  return d;
                });
                _this2.filteredItems = _this2.items.map(function (item) {
                  return item;
                });
                _this2.loading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this3 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to confirm date?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!result.value) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.next = 3;
                  return _this3.$store.dispatch('campaign/saveDashboardStatus', {
                    id: item.id,
                    type: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].dashboardTypes.brief,
                    status: 1
                  });

                case 3:
                  _this3.init();
                  _context3.next = 7;
                  break;

                case 6:
                  item.checkedStatus = 0;

                case 7:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    formatDate: function formatDate(date) {
      if (!date || date.includes('/')) return '';
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay: function getDashboardStatusDisplay(status) {
      if (!status) return '';
      return this.dashboardStatusDisplay[status];
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.CC);
        });
      }
    },
    openCampaignModal: function openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID);
    },
    setAMCC: function setAMCC() {
      var _this5 = this;

      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        var matchAM = this.AM.find(function (a) {
          return a.id === _this5.currentUserID;
        });
        this.selectedFilter.AM = matchAM;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID;
      }
    }
  }
});

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  data: function data() {
    return {
      totalCount: 0,
      summaryList: [{
        status: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.DRAFT,
        aIcon: 'mdi-file-document-edit',
        title: 'Draft',
        value: 0,
        path: this.getPath() + '/draft'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL,
        aIcon: 'mdi-file-clock',
        title: 'Pending for Approval',
        value: 0,
        path: this.getPath() + '/pending_approval'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER,
        aIcon: 'mdi-account-switch',
        title: 'Pairing',
        value: 0,
        path: this.getPath() + '/pairing_influencer'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.ONGOING,
        aIcon: 'mdi-file-check',
        title: 'Ongoing',
        value: 0,
        path: this.getPath() + '/on_going'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus.COMPLETE,
        aIcon: 'mdi-zip-box-outline',
        title: 'Completed',
        value: 0,
        path: this.getPath() + '/completed'
      }, {
        status: 7,
        aIcon: 'mdi-archive',
        title: 'Archived',
        value: 0,
        path: this.getPath() + '/archive'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    campaignsCount: function campaignsCount(state) {
      return state.campaign.campaignsCount;
    }
  })),
  methods: {
    changeRoute: function changeRoute(item) {
      this.$router.push({ path: item.path });
    },
    getPath: function getPath() {
      return '/campaigns';
    },
    fetchCampaigns: function fetchCampaigns() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var statuses, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                statuses = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].campaignStatus;

                statuses['ARCHIVE'] = 7;
                _this.totalCount = 0;
                _loop = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop() {
                  var status;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          status = statuses[key];
                          _context.next = 3;
                          return _this.$store.dispatch('campaign/getCampaignsCountByStatus', {
                            status: status,
                            archive: status === 7 || false
                          });

                        case 3:
                          if (_this.campaignsCount) {
                            _this.summaryList.forEach(function (item) {
                              if (item.status === status) {
                                item.value = Number(_this.campaignsCount);
                                _this.totalCount += Number(_this.campaignsCount);
                              }
                            });
                          }

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _loop, _this);
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 7;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(statuses));

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 15;
                  break;
                }

                key = _step.value;
                return _context2.delegateYield(_loop(), 't0', 12);

              case 12:
                _iteratorNormalCompletion = true;
                _context2.next = 9;
                break;

              case 15:
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 21:
                _context2.prev = 21;
                _context2.prev = 22;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(21);

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, _this, [[7, 17, 21, 29], [22,, 24, 28]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.fetchCampaigns();
  }
});

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignsActivities',
  components: {
    seeMore: __WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue___default.a
  },
  props: {
    title: { type: String },
    theme: { type: String },
    previews: { type: Object },
    detail: { type: Object },
    fields: { type: Array },
    filters: { type: Array },
    filterCampaigns: { type: Array },
    type: { type: String }
  },
  data: function data() {
    return {
      selectedFilter: '',
      itemArray: [],
      seeMoreDialog: false,
      seeMoreDialogKey: 0
    };
  },
  computed: {},
  mounted: function mounted() {},

  methods: {
    selectedChangeHandler: function selectedChangeHandler() {
      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        CO: this.selectedFilter
      });
      this.$emit('searchFilter', { filter: filter, type: this.type, filterSource: 'previews' });
    },
    seeMoreFilter: function seeMoreFilter(filters) {
      this.$emit('searchFilter', filters);
    },
    seeMoreModalOpen: function seeMoreModalOpen() {
      this.seeMoreDialog = true;
    },
    seeMoreModalClose: function seeMoreModalClose() {
      this.seeMoreDialog = false;
      this.seeMoreDialogKey += 1;
    }
  }
});

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bar-Chart',
  props: {
    id: { type: String },
    title: { type: String },
    filters: { type: Array },
    firstFilters: { type: Array },
    firstFilterLabel: { type: String },
    labels: { type: Array },
    datasets: { type: Array },
    summaryTitle: { type: String },
    summary: { type: Array },
    detail: { type: Boolean },
    color: { type: String },
    yAxes: { type: Object }
  },
  data: function data() {
    return {
      toggle_filter: 0,
      selectedFilter: {
        monthly: true,
        quarterly: false,
        yearly: false,
        firstFilterId: ''
      }
    };
  },
  mounted: function mounted() {
    this.renderChart();
  },

  watch: {
    labels: function labels() {
      this.renderChart();
    },
    datasets: function datasets() {
      this.renderChart();
    }
  },
  methods: {
    detailClick: function detailClick() {
      this.$emit('detailClick');
    },
    monthlyClick: function monthlyClick() {
      if (this.selectedFilter.monthly) {
        return;
      }
      this.changePeriodGroup('monthly');
    },
    quartelyClick: function quartelyClick() {
      if (this.selectedFilter.quarterly) {
        return;
      }
      this.changePeriodGroup('quarterly');
    },
    yearlyClick: function yearlyClick() {
      if (this.selectedFilter.yearly) {
        return;
      }
      this.changePeriodGroup('yearly');
    },
    changePeriodGroup: function changePeriodGroup(period) {
      this.selectedFilter.monthly = period === 'monthly';
      this.selectedFilter.quarterly = period === 'quarterly';
      this.selectedFilter.yearly = period === 'yearly';
      this.search();
    },
    search: function search() {
      this.$emit('searchfilter', this.selectedFilter);
    },
    renderChart: function renderChart() {
      var ctx = document.getElementById(this.id);
      var config = {
        type: 'bar',
        data: {
          'labels': this.labels,
          'datasets': this.datasets
        }
      };

      var options = {
        responsive: true,
        interaction: {
          intersect: false
        }
      };
      if (this.id !== 'spend_revenue_chart') {
        options.scales = {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          },
          yAxes: [{
            ticks: {
              min: this.yAxes.min,
              max: this.yAxes.max,
              stepSize: this.yAxes.stepSize
            },
            scaleLabel: {
              display: true,
              labelString: this.yAxes.label
            }
          }]
        };
        if (this.id === 'campaign_spend_cogs_chart') {
          options.scales.yAxes[0].ticks.callback = function (value) {
            return value + '%';
          };
        }
      }
      config.options = options;
      if (this.id === 'campaign_speed_turnaround_chart') {
        if (window.speedTurnaroundChart !== undefined) {
          window.speedTurnaroundChart.destroy();
        }

        window.speedTurnaroundChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      } else if (this.id === 'campaign_spend_cogs_chart') {
        if (window.spendCogsChart !== undefined) {
          window.spendCogsChart.destroy();
        }

        window.spendCogsChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      } else if (this.id === 'spend_revenue_chart') {
        if (window.spendRevenueChart !== undefined) {
          window.spendRevenueChart.destroy();
        }

        window.spendRevenueChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      }
    }
  }
});

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Line-Chart',
  props: {
    id: { type: String },
    title: { type: String },
    filters: { type: Array },
    firstFilters: { type: Array },
    firstFilterLabel: { type: String },
    labels: { type: Array },
    datasets: { type: Array },
    summaryTitle: { type: String },
    summary: { type: Array },
    detail: { type: Boolean },
    color: { type: String },
    yAxes: { type: Object }
  },
  data: function data() {
    return {
      toggle_filter: 0,
      selectedFilter: {
        monthly: true,
        quarterly: false,
        yearly: false,
        firstFilterId: ''
      }
    };
  },
  mounted: function mounted() {
    this.renderChart();
  },

  watch: {
    labels: function labels() {
      this.renderChart();
    },
    datasets: function datasets() {
      this.renderChart();
    }
  },
  methods: {
    detailClick: function detailClick() {
      this.$emit('detailClick');
    },
    monthlyClick: function monthlyClick() {
      if (this.selectedFilter.monthly) {
        return;
      }
      this.changePeriodGroup('monthly');
    },
    quartelyClick: function quartelyClick() {
      if (this.selectedFilter.quarterly) {
        return;
      }
      this.changePeriodGroup('quarterly');
    },
    yearlyClick: function yearlyClick() {
      if (this.selectedFilter.yearly) {
        return;
      }
      this.changePeriodGroup('yearly');
    },
    changePeriodGroup: function changePeriodGroup(period) {
      this.selectedFilter.monthly = period === 'monthly';
      this.selectedFilter.quarterly = period === 'quarterly';
      this.selectedFilter.yearly = period === 'yearly';
      this.search();
    },
    search: function search() {
      this.$emit('searchfilter', this.selectedFilter);
    },
    renderChart: function renderChart() {
      var ctx = document.getElementById(this.id);
      var options = {
        legend: {
          position: 'top'
        }
      };
      if (this.id !== 'spend_avg_per_campaign_chart') {
        options.scales = {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          },
          yAxes: [{
            ticks: {
              min: this.yAxes.min,
              max: this.yAxes.max,
              stepSize: this.yAxes.stepSize
            },
            scaleLabel: {
              display: true,
              labelString: this.yAxes.label
            }
          }]
        };
      }
      var config = {
        type: 'line',
        data: {
          'labels': this.labels,
          'datasets': this.datasets
        },
        options: options
      };
      if (this.id === 'influencer_line_chart') {
        if (window.influencerChart !== undefined) {
          window.influencerChart.destroy();
        }

        window.influencerChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      } else if (this.id === 'spend_avg_per_campaign_chart') {
        if (window.spendAvgPerCampaignChart !== undefined) {
          window.spendAvgPerCampaignChart.destroy();
        }

        window.spendAvgPerCampaignChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      } else {
        if (window.clientChart !== undefined) {
          window.clientChart.destroy();
        }

        window.clientChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, config);
      }
    }
  }
});

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_piecelabel_js__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_piecelabel_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chart_piecelabel_js__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pie-Chart',
  props: {
    theme: { type: String },
    id: { type: String },
    title: { type: String },
    filters: { type: Array },
    labels: { type: Array },
    backgroundColors: { type: Array },
    items: { type: Array },
    filterCampaigns: { type: Array },
    filterUsers: { type: Array }
  },
  data: function data() {
    return {
      toggle_filter: 0,
      selectedFilter: { CampaignId: '', UserId: '' },
      searchMonth: '',
      selectedMonth: '',
      monthPicker: false
    };
  },
  mounted: function mounted() {
    this.renderChart();
  },

  watch: {
    items: function items() {
      this.renderChart();
    }
  },
  methods: {
    renderChart: function renderChart() {
      var ctx = document.getElementById('pieChart');
      var config = {
        type: 'pie',
        plugins: [__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_datalabels___default.a],
        data: {
          'labels': this.labels,
          'datasets': [{
            'data': this.items,
            'backgroundColor': this.backgroundColors
          }]
        },
        options: {
          responsive: true,
          legend: false,
          pieceLabel: {
            render: 'label',
            fontColor: '#000',
            position: 'outside',
            segment: true
          },
          plugins: {
            datalabels: {
              color: '#000',
              font: {
                weight: 'bold'
              },
              formatter: function formatter(value, context) {
                return value + '%';
              }
            }
          }
        }
      };
      if (window.pie !== undefined) {
        window.pie.destroy();
      }

      window.pie = new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, config);
    },
    search: function search() {
      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        CampaignId: this.selectedFilter.CampaignId,
        UserId: this.selectedFilter.UserId,
        month: this.searchMonth
      });
      this.$emit('searchfilter', filter);
    },
    searchMonthOk: function searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.search();
    }
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientQualityRating',
  props: {
    theme: { type: String },
    title: { type: String },
    headers: { type: Array },
    items: { type: Array },
    filterCampaigns: { type: Array },
    filterUsers: { type: Array },
    filterUserLabel: { type: String }
  },
  data: function data() {
    return {
      selectedFilter: { CampaignId: '', UserId: '' },
      itemArray: [],
      seeMoreDialog: false,
      searchMonth: '',
      selectedMonth: '',
      monthPicker: false,
      dataTableKey: 0
    };
  },
  computed: {},
  mounted: function mounted() {},

  methods: {
    search: function search() {
      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        CampaignId: this.selectedFilter.CampaignId,
        UserId: this.selectedFilter.UserId,
        month: this.searchMonth
      });
      this.$emit('searchfilter', filter);
    },
    searchMonthOk: function searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.search();
    }
  }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientTasks',
  data: function data() {
    return {
      items: []
    };
  },


  methods: {
    loadTasks: function loadTasks() {
      this.items = [];

      this.checkForPendingPosts();
      this.checkForPendingCampaigns();
      this.checkForPairingCampaigns();
      this.checkForLivePosts();
    },
    actionOnTask: function actionOnTask(task, id) {
      switch (task) {
        case 'viewPost':
          this.$router.push({ path: '/clients/posts', query: { action: 'view', id: id } });
          break;
        case 'viewCampaign':
          this.$router.push({ path: '/clients/campaigns' });
          break;
        case 'viewPublished':
          this.$router.push({ path: '/clients/posts' });
          break;
        case 'viewPairingInfluencersCampaign':
          this.$router.push({ path: '/clients/campaigns' });
          break;
        case 'goToVendorForm':
          this.$router.push({ path: '/client/vendor-creation-form' });
      }
    },
    checkForVendorCreationForm: function checkForVendorCreationForm() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__Client_clientAPIs__["a" /* default */].getClient(this.user.clientID).then(function (response) {
        var client = response;
        if (!client.acceptTerms) {
          _this.items.push({
            action: 'goToVendorForm',
            title: 'Complete Vendor Creation Form',
            text: 'You need to complete the vendor creation form to activate your account'
          });
        }
      });
    },
    checkForPairingCampaigns: function checkForPairingCampaigns() {
      var _this2 = this;

      var status = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER;
      __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__["a" /* default */].paginate({
        page: 1,
        status: status
      }).then(function (response) {
        var campaigns = response.campaigns;
        if (campaigns.length > 0) {
          _this2.items.push({
            action: 'viewPairingInfluencersCampaign',
            title: 'Approve the Creator Line Up',
            text: campaigns.length + ' campaign(s) in pairing step'
          });
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    checkForPendingCampaigns: function checkForPendingCampaigns() {
      var _this3 = this;

      var status = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.PENDING_CLIENT_APPROVAL;
      __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__["a" /* default */].paginate({
        page: 1,
        status: status
      }).then(function (response) {
        var campaigns = response.campaigns;
        if (campaigns.length > 0) {
          _this3.items.push({
            action: 'viewCampaign',
            title: 'Pending your approval',
            text: campaigns.length + ' campaign(s) waiting your approval'
          });
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    checkForPendingPosts: function checkForPendingPosts() {
      var _this4 = this;

      var status = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.CLIENT_PENDING;
      __WEBPACK_IMPORTED_MODULE_2__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
        var posts = response.posts;
        if (posts.length > 0) {
          _this4.items.push({
            action: 'viewPost',
            title: 'Pending your approval',
            text: posts.length + ' draft(s) to vet.'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    },
    checkForLivePosts: function checkForLivePosts() {
      var _this5 = this;

      var status = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.LIVE;
      __WEBPACK_IMPORTED_MODULE_2__Post_postApi__["a" /* default */].getPost({ status: status }).then(function (response) {
        var posts = response.posts;
        if (posts.length > 0) {
          _this5.items.push({
            action: 'viewPublished',
            title: 'See the live posts',
            text: posts.length + ' posts published'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    }
  },
  mounted: function mounted() {
    this.loadTasks();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['user']), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  })
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);














/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: []
    };
  },
  mounted: function mounted() {
    this.loadTasks();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    unsubmittedInfluencers: function unsubmittedInfluencers(state) {
      return state.pairing.unsubmittedInfluencers;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  methods: {
    loadTasks: function loadTasks() {
      this.items = [];
      this.checkForApprovedPost();
      this.checkForNewComments();
      this.checkForSubmittedPosts();

      this.checkForAbuseReportedPosts();
      this.checkForUnsubmittedPosts();
    },
    actionOnTask: function actionOnTask(task, postID) {
      switch (task) {
        case 'viewApproved':
          this.$router.push({ path: '/posts/internal/approved' });
          break;
        case 'viewSubmitted':
          this.$router.push({ path: '/posts/internal/pending-kobe' });
          break;
        case 'viewPost':
          this.$router.push({ path: '/posts/internal/pending-client', query: { action: 'view', id: postID } });
          break;
        case 'viewAbusePosts':
          this.$router.push({ path: '/posts/internal/pending-client' });
          break;
        case 'viewVerifiedCampaigns':
          this.$router.push({ path: '/campaigns/all?verified=true' });
          break;
        case 'viewUnsubmittedInfluencers':
          this.$router.push({ path: '/posts/draft-submissions-report?date=' + __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_3_moment___default()(), 'YYYY-MM-DD') });
          break;
      }
    },
    checkForUnverifiedPayouts: function checkForUnverifiedPayouts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7__Influencer_influencerAPIs__["a" /* default */].getAllCampaignPayouts().then(function (response) {
        var campaignPayouts = response.data;
        var unverifiedPayouts = campaignPayouts.filter(function (element) {
          return !element.payoutAmount;
        });
        if (unverifiedPayouts.length > 0) {
          _this.items.push({
            action: 'viewPayouts',
            title: 'New payouts found',
            text: unverifiedPayouts.length + ' payout(s) require your verification.'
          });
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    checkForAbuseReportedPosts: function checkForAbuseReportedPosts() {
      var _this2 = this;

      var status = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].postStatus.CLIENT_PENDING;
      __WEBPACK_IMPORTED_MODULE_6__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
        var posts = response.posts;
        var abuseReportedPosts = posts.filter(function (post) {
          var reports = post.clientReportAbuse.map(function (item) {
            return item.draftPostId;
          });
          return reports.includes(post.draftId);
        });
        if (abuseReportedPosts.length > 0) {
          _this2.items.push({
            action: 'viewAbusePosts',
            title: 'Abuse Reported by Client',
            text: abuseReportedPosts.length + ' post(s) need to revive.'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    },
    checkForApprovedPost: function checkForApprovedPost() {
      var _this3 = this;

      var status = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].postStatus.APPROVE;
      __WEBPACK_IMPORTED_MODULE_6__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
        var posts = response.posts;
        if (posts.length > 0) {
          _this3.items.push({
            action: 'viewApproved',
            title: 'Remind Influencer to publish the post',
            text: posts.length + ' scheduled post(s) to publish.'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    },
    checkForNewComments: function checkForNewComments() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', '/api/v1/notifications', true).then(function (response) {
        if (response.status !== 200) {
          return;
        }
        response.data.forEach(function (element) {
          if (!element.readAt) {
            _this4.items.push({
              action: 'viewPost',
              title: element.title,
              text: element.body,
              type: element.type,
              postID: element.postID
            });
          }
        });
      }).catch(function () {});
    },
    checkForSubmittedPosts: function checkForSubmittedPosts() {
      var _this5 = this;

      var status = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING;
      __WEBPACK_IMPORTED_MODULE_6__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
        var posts = response.posts;
        var unAssignedPosts = posts.filter(function (item) {
          return !item.campaignID;
        });
        if (unAssignedPosts.length > 0) {
          _this5.items.push({
            action: 'viewSubmitted',
            title: 'Assign Campaigns for this posts',
            text: unAssignedPosts.length + ' post(s) to assign the related campaigns.'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    },
    checkForUnsubmittedPosts: function checkForUnsubmittedPosts() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.$store.dispatch('pairing/getPostUnsubmittedPairingInfluencers', {
                  date: [__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_3_moment___default()(), 'YYYY-MM-DD')]
                });

              case 2:
                _this6.items.push({
                  action: 'viewUnsubmittedInfluencers',
                  title: 'Remind Influencer(s) for Content Submissions',
                  text: _this6.unsubmittedInfluencers.length + ' Influencer(s) to submit drafts today'
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    }
  }
});

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardActivationDataTable',
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_DatePicker___default.a
  },
  data: function data() {
    return {
      headers: [{
        text: 'Deal Name',
        value: 'name',
        align: 'center'
      }, {
        text: 'IO Number',
        value: 'IONumber',
        align: 'center'
      }, {
        text: 'IO amount',
        value: 'budget',
        align: 'center'
      }, {
        text: 'Quote Acceptance Date',
        value: 'quoteAcceptanceDate',
        align: 'center'
      }, {
        text: 'Activation Date',
        value: 'activationDate',
        align: 'center'
      }],
      items: [],
      filteredItems: [],
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false
    };
  },

  props: ['AM', 'CC'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    dashboardCampaigns: function dashboardCampaigns(state) {
      return state.campaign.dashboardActivations;
    },
    savedDashboardStatus: function savedDashboardStatus(state) {
      return state.campaign.savedDashboardStatus;
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAM: function isAM() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    isCC: function isCC() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();
              setTimeout(function () {
                _this.setAMCC();
              }, 2000);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.$store.dispatch('campaign/getDashboardActivation', {});

              case 3:
                _this2.items = _this2.dashboardCampaigns.map(function (d) {
                  return d;
                });
                _this2.filteredItems = _this2.items.map(function (item) {
                  return item;
                });
                _this2.loading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateData: function updateData(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch('campaign/saveDashboardStatus', {
                  id: item.id,
                  type: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].dashboardTypes.activation,
                  activationDate: item.activationDate
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD/MM/YYYY');
    },
    checkDate: function checkDate(item, fieldName, validFieldName, isUpdate) {
      item[validFieldName] = false;
      var itemIdx = this.filteredItems.indexOf(item);
      if (__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.isDateFormatValid(item[fieldName]) || !item[fieldName]) {
        item[validFieldName] = true;
        if (isUpdate) {
          this.updateData(item);
        }
      }
      this.filteredItems[itemIdx] = item;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
    },
    setDateFromPicker: function setDateFromPicker(item, fieldName, value) {
      var itemIdx = this.filteredItems.indexOf(item);
      this.filteredItems[itemIdx][fieldName] = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      this.updateData(item);
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.CC);
        });
      }
    },
    setAMCC: function setAMCC() {
      var _this5 = this;

      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        var matchAM = this.AM.find(function (a) {
          return a.id === _this5.currentUserID;
        });
        this.selectedFilter.AM = matchAM;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID;
      }
    }
  }
});

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DraftsDataTable',
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker___default.a
  },
  data: function data() {
    return {
      headers: [{
        text: 'Deal Name',
        value: 'name',
        align: 'center'
      }, {
        text: 'Timeline',
        value: 'timeline',
        align: 'center'
      }, {
        text: 'Drafts status',
        value: 'status',
        align: 'center'
      }, {
        text: 'Deadline for submission',
        value: 'submissionDate',
        align: 'center'
      }, {
        text: 'Review date',
        value: 'reviewDate',
        align: 'center'
      }],
      items: [],
      filteredItems: [],
      dashboardStatusDisplay: __WEBPACK_IMPORTED_MODULE_4__Campaign_config__["a" /* default */].dashboardStatusDisplay,
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false
    };
  },

  props: ['AM', 'CC'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    dashboardCampaigns: function dashboardCampaigns(state) {
      return state.campaign.dashboardDrafts;
    },
    savedDashboardStatus: function savedDashboardStatus(state) {
      return state.campaign.savedDashboardStatus;
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAM: function isAM() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    isCC: function isCC() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isLinkAllow: function isLinkAllow() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();
              setTimeout(function () {
                _this.setAMCC();
              }, 2000);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.$store.dispatch('campaign/getDashboardDrafts', {});

              case 3:
                _this2.items = _this2.dashboardCampaigns.map(function (d) {
                  return d;
                });
                _this2.filteredItems = _this2.items.map(function (item) {
                  return item;
                });
                _this2.loading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateData: function updateData(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch('campaign/saveDashboardStatus', {
                  id: item.id,
                  type: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].dashboardTypes.drafts,
                  reviewDate: item.reviewDate
                });

              case 2:
                _this3.init();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    formatDate: function formatDate(date) {
      if (!date || date.includes('/')) return '';
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay: function getDashboardStatusDisplay(status) {
      if (!status) return '';
      return this.dashboardStatusDisplay[status];
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.CC);
        });
      }
    },
    checkDate: function checkDate(item, fieldName, validFieldName, isUpdate) {
      item[validFieldName] = false;
      var itemIdx = this.filteredItems.indexOf(item);
      if (__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.isDateFormatValid(item[fieldName]) || !item[fieldName]) {
        item[validFieldName] = true;
        if (isUpdate) {
          this.updateData(item);
        }
      }
      this.filteredItems[itemIdx] = item;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
    },
    setDateFromPicker: function setDateFromPicker(item, fieldName, value) {
      var itemIdx = this.filteredItems.indexOf(item);
      this.filteredItems[itemIdx][fieldName] = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      this.updateData(item);
    },
    openCampaignModal: function openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID);
    },
    setAMCC: function setAMCC() {
      var _this5 = this;

      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        var matchAM = this.AM.find(function (a) {
          return a.id === _this5.currentUserID;
        });
        this.selectedFilter.AM = matchAM;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID;
      }
    }
  }
});

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DurationStage',

  components: {
    seeMore: __WEBPACK_IMPORTED_MODULE_1__DashboardComponents_SeeMoreModal_vue___default.a
  },
  props: {
    title: { type: String },
    theme: { type: String },
    items: { type: Array },
    total: { type: Object },
    filters: { type: Array }
  },
  data: function data() {
    return {
      selectedFilter: '',
      itemArray: [],
      seeMoreDialog: false,
      headers: [{
        name: 'name',
        header: 'Name',
        type: 'string',
        format: ['single']
      }, {
        name: 'ACTIVATION',
        header: 'Activation',
        type: 'string',
        format: ['single']
      }, {
        name: 'PAIRING',
        header: 'Pairing',
        type: 'string',
        format: ['single']
      }, {
        name: 'CREATING',
        header: 'CO-Creating',
        type: 'string',
        format: ['single']
      }, {
        name: 'COMPLETE',
        header: 'Completion',
        type: 'string',
        format: ['single']
      }, {
        name: 'Overall',
        header: 'Overall Average',
        type: 'string',
        format: ['single']
      }]
    };
  },
  computed: {
    top5Rows: function top5Rows() {
      return this.items.slice(0, 6);
    }
  },
  mounted: function mounted() {
    this.itemArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.items.sort(function (a, b) {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    }));
  },

  methods: {
    selectedChangeHandler: function selectedChangeHandler() {
      var _this = this;

      if (this.selectedFilter === 3) {
        this.items = this.itemArray;
      } else {
        this.items = this.itemArray.filter(function (item) {
          return item.id === _this.selectedFilter;
        });
      }
    },
    seeMoreModalOpen: function seeMoreModalOpen() {
      this.seeMoreDialog = true;
    },
    seeMoreModalClose: function seeMoreModalClose() {
      this.seeMoreDialog = false;
    }
  }
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerQualityRating',
  props: {
    theme: { type: String },
    title: { type: String },
    headers: { type: Array },
    items: { type: Array },
    filterCampaigns: { type: Array },
    filterUsers: { type: Array }
  },
  data: function data() {
    return {
      selectedFilter: { CampaignId: '', UserId: '' },
      searchMonth: '',
      selectedMonth: '',
      monthPicker: false,
      dataTableKey: 0,
      expanded: [],
      influencerDetailHeaders: [{ value: 'profilePicture', text: 'Avatar', sortable: true }, { value: 'instagramHandle', text: 'instagram Handle', sortable: true }, { value: 'avg_satisfy', text: 'Average Satisfaction with Campaign', sortable: true }, { value: 'avg_advertiser', text: 'Average Experience with Advertiser', sortable: true }, { value: 'avg_kobe', text: 'Average Satisfaction with Kobe', sortable: true }, { value: 'avg_overall', text: 'Overall Rating', sortable: true }],
      avatarSize: 45 };
  },
  computed: {},
  mounted: function mounted() {},

  methods: {
    search: function search() {
      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        CampaignId: this.selectedFilter.CampaignId,
        UserId: this.selectedFilter.UserId,
        month: this.searchMonth
      });
      this.$emit('searchfilter', filter);
    },
    searchMonthOk: function searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.search();
    },
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return '';
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    }
  }
});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);













/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: []
    };
  },

  methods: {
    loadTasks: function loadTasks() {
      this.items = [{
        action: 'submitDraft',
        title: 'Submit Draft Post',
        text: 'Submit your draft post for the campaign.'
      }];
      this.checkForApprovedPost();
      this.checkForProfileEdit();
      this.checkForNewComments();
    },
    actionOnTask: function actionOnTask(task, postID) {
      switch (task) {
        case 'updateProfile':
          this.$router.push({ path: 'profile' });
          break;
        case 'submitDraft':
          this.$router.push({ path: 'v2/submit-draft-post' });
          break;
        case 'viewApproved':
          this.$router.push({ path: '/posts/approved' });
          break;
        case 'viewPost':
          this.$router.push({ path: '/posts/pending-client', query: { action: 'view', id: postID } });
          break;
        case 'invitedCampaign':
          this.$router.push({ path: '/campaigns/invited' });
      }
    },
    checkForApprovedPost: function checkForApprovedPost() {
      var _this = this;

      var status = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].postStatus.APPROVE;
      __WEBPACK_IMPORTED_MODULE_5__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
        var posts = response.posts;
        if (posts.length > 0) {
          _this.items.push({
            action: 'viewApproved',
            title: 'Get Ready to publish',
            text: 'You have ' + posts.length + ' scheduled post(s) to publish.'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    },
    checkForProfileEdit: function checkForProfileEdit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__User_userAPIs__["a" /* default */].getUser(this.currentUserID).then(function (user) {
        if (!user.influencer.bankAccount || !user.influencer.mailingAddress || !user.influencer.bankName || !user.influencer.fullName) {
          _this2.items.push({
            action: 'updateProfile',
            title: 'Please Update Your Profile',
            text: 'We found that you haven\u2019t completed the required information.'
          });
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    checkForNewComments: function checkForNewComments() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', '/api/v1/notifications', true).then(function (response) {
        if (response.status !== 200) {
          return;
        }
        response.data.forEach(function (element) {
          if (!element.readAt) {
            _this3.items.push({
              action: 'viewPost',
              title: element.title,
              text: element.body,
              type: element.type,
              postID: element.postID
            });
          }
        });
      }).catch(function () {});
    },
    getInvitedCampaign: function getInvitedCampaign(influencerID, status) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var campaigns;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__Pairing_pairingAPIs__["a" /* default */].getInvitedCampaigns(influencerID, status);

              case 3:
                campaigns = _context.sent;

                _this4.campaigns = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], campaigns);
                if (campaigns.length > 0) {
                  _this4.items.push({
                    action: 'invitedCampaign',
                    title: 'Your invited campaigns',
                    text: 'You have been invited for ' + campaigns.length + ' campaign(s).'
                  });
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 8]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadTasks();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    influencerID: function influencerID() {
      return this.$store.state.user.influencerID;
    },
    statusINVITED: function statusINVITED() {
      return this.pairingStatus.INVITED.value;
    },
    statusINTERESTED: function statusINTERESTED() {
      return this.pairingStatus.INTERESTED.value;
    },
    statusNOTINTERESTED: function statusNOTINTERESTED() {
      return this.pairingStatus.NOT_INTERESTED.value;
    },
    statusACCEPTED: function statusACCEPTED() {
      return this.pairingStatus.ACCEPTED.value;
    },
    statusNOTACCEPTED: function statusNOTACCEPTED() {
      return this.pairingStatus.NOT_ACCEPTED.value;
    },
    statusINQUIRY: function statusINQUIRY() {
      return this.pairingStatus.INQUIRY.value;
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  })
});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KobeOverviewHelper__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
var _this5 = this;




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    userRole: Number
  },
  data: function data() {
    return {
      totalInfluencers: 0,
      totalClients: 0,
      totalCompanies: 0,
      totalCampaigns: 0,
      showInfluencerOverview: false,
      showClientOverview: false,
      showCompanyOverview: false,
      showCampaignOverview: false
    };
  },

  methods: {
    loadData: function loadData() {
      if (this.userRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.CLIENT) {
        this.loadTotalCampaigns();
      } else if (this.userRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST || this.userRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.FINANCE || this.userRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        this.loadTotalCampaigns();
        this.loadTotalInfluencers();
        this.loadTotalClients();
      } else if (this.userRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.userRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        this.loadTotalCampaigns();
        this.loadTotalInfluencers();
        this.loadTotalClients();
        this.loadTotalCompanies();
      }
    },
    loadTotalInfluencers: function loadTotalInfluencers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__KobeOverviewHelper__["a" /* default */].getTotalInfluencers().then(function (response) {
        _this.totalInfluencers = response;
        _this.showInfluencerOverview = true;
      }).catch(function () {
        _this.showInfluencerOverview = false;
      });
    },
    loadTotalClients: function loadTotalClients() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__KobeOverviewHelper__["a" /* default */].getTotalClients().then(function (response) {
        _this2.totalClients = response;
        _this2.showClientOverview = true;
      }).catch(function () {
        _this2.showClientOverview = false;
      });
    },
    loadTotalCampaigns: function loadTotalCampaigns() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__KobeOverviewHelper__["a" /* default */].getTotalCampaigns().then(function (response) {
        _this3.totalCampaigns = response;
        _this3.showCampaignOverview = true;
      }).catch(function () {
        _this3.showCampaignOverview = false;
      });
    },
    loadTotalCompanies: function loadTotalCompanies() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__KobeOverviewHelper__["a" /* default */].getTotalCompanies().then(function (response) {
        _this4.totalCompanies = response;
        _this4.showCompanyOverview = true;
      }).catch(function () {
        _this4.showCompanyOverview = false;
      });
    }
  },
  watch: {
    userRole: function userRole() {
      return _this5.loadData();
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
});

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PairingLineupDataTable',
  data: function data() {
    return {
      headers: [{
        text: 'Deal Name',
        value: 'name',
        align: 'center'
      }, {
        text: 'Timeline',
        value: 'timeline',
        align: 'center'
      }, {
        text: 'Status',
        value: 'status',
        align: 'center'
      }, {
        text: 'Deadline for pairing submission',
        value: 'dueDate',
        align: 'center'
      }],
      items: [],
      filteredItems: [],
      dashboardStatusDisplay: __WEBPACK_IMPORTED_MODULE_4__Campaign_config__["a" /* default */].dashboardStatusDisplay,
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false
    };
  },

  props: ['AM', 'CC'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    dashboardCampaigns: function dashboardCampaigns(state) {
      return state.campaign.dashboardPairings;
    },
    savedDashboardStatus: function savedDashboardStatus(state) {
      return state.campaign.savedDashboardStatus;
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAM: function isAM() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    isCC: function isCC() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isLinkAllow: function isLinkAllow() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();
              setTimeout(function () {
                _this.setAMCC();
              }, 2000);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.$store.dispatch('campaign/getDashboardPairings', {});

              case 3:
                _this2.items = _this2.dashboardCampaigns.map(function (d) {
                  return d;
                });
                _this2.filteredItems = _this2.items.map(function (item) {
                  return item;
                });
                _this2.loading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this3 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to confirm date?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!result.value) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.next = 3;
                  return _this3.$store.dispatch('campaign/saveDashboardStatus', {
                    id: item.id,
                    type: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].dashboardTypes.brief,
                    status: 1
                  });

                case 3:
                  _this3.init();
                  _context3.next = 7;
                  break;

                case 6:
                  item.checkedStatus = 0;

                case 7:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    formatDate: function formatDate(date) {
      if (!date || date.includes('/')) return '';
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay: function getDashboardStatusDisplay(status) {
      if (!status) return '';
      return this.dashboardStatusDisplay[status];
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.CC);
        });
      }
    },
    openCampaignModal: function openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID);
    },
    setAMCC: function setAMCC() {
      var _this5 = this;

      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        var matchAM = this.AM.find(function (a) {
          return a.id === _this5.currentUserID;
        });
        this.selectedFilter.AM = matchAM;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID;
      }
    }
  }
});

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Post_postApi__ = __webpack_require__(42);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  computed: {},
  data: function data() {
    return {
      totalCount: 0,
      summaryList: [{
        status: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING,
        aIcon: 'assignment_turned_in',
        title: 'Submitted to Kobe',
        value: 0,
        path: this.getPath() + '/pending-kobe'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus.CLIENT_PENDING,
        aIcon: 'watch_later',
        title: 'Pending for Approval',
        value: 0,
        path: this.getPath() + '/pending-client'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus.APPROVE,
        aIcon: 'verified_user',
        title: 'Scheduled to Publish',
        value: 0,
        path: this.getPath() + '/approved'
      }, {
        status: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus.LIVE,
        aIcon: 'cloud_done',
        title: 'Ongoing Posts',
        value: 0,
        path: this.getPath() + '/published'
      }]
    };
  },

  methods: {
    changeRoute: function changeRoute(item) {
      this.$router.push({ path: item.path });
    },
    getPath: function getPath() {
      var role = this.$store.state.user.role;
      return role === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.INFLUENCER || role === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.CLIENT ? '/posts' : '/posts/internal';
    },
    fetchPosts: function fetchPosts() {
      var _this = this;

      var _loop = function _loop(pStatus) {
        var status = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus[pStatus];
        __WEBPACK_IMPORTED_MODULE_1__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
          var posts = response.posts;
          _this.summaryList.forEach(function (item) {
            if (item.status === status) {
              item.value = posts.length;
              _this.totalCount += posts.length;
            }
          });
        }).catch(function (err) {
          console.error(err);
        });
      };

      for (var pStatus in __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus) {
        _loop(pStatus);
      }
    }
  },
  mounted: function mounted() {
    this.fetchPosts();
  }
});

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Campaign_ReviewMeeting_ReviewDeckUrlModal__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Campaign_ReviewMeeting_ReviewDeckUrlModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Campaign_ReviewMeeting_ReviewDeckUrlModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DraftsDataTable',
  components: {
    ReviewDeckUrlModal: __WEBPACK_IMPORTED_MODULE_7__Campaign_ReviewMeeting_ReviewDeckUrlModal___default.a
  },
  data: function data() {
    return {
      headers: [{
        text: 'Deal Name',
        value: 'name',
        align: 'center'
      }, {
        text: 'Review date',
        value: 'reviewMeetingDate',
        align: 'center'
      }, {
        text: 'Stats submitted',
        value: 'status',
        align: 'center'
      }, {
        text: 'Deadline for submission',
        value: 'submissionDate',
        align: 'center'
      }, {
        text: 'Review Deck',
        value: 'reviewDeck',
        align: 'center'
      }, {
        text: 'Action',
        value: 'action',
        align: 'center'
      }],
      items: [],
      filteredItems: [],
      dashboardStatusDisplay: __WEBPACK_IMPORTED_MODULE_5__Campaign_config__["a" /* default */].dashboardStatusDisplay,
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false,
      reviewDeckURLDialog: false,
      reviewDeckItem: {},
      reviewDeckCol: 'reviewDeck'
    };
  },

  props: ['AM', 'CC'],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    dashboardCampaigns: function dashboardCampaigns(state) {
      return state.campaign.dashboardReportings;
    },
    savedDashboardStatus: function savedDashboardStatus(state) {
      return state.campaign.savedDashboardStatus;
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH;
    },
    isAM: function isAM() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    isCC: function isCC() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isLinkAllow: function isLinkAllow() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();
              setTimeout(function () {
                _this.setAMCC();
              }, 2000);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.$store.dispatch('campaign/getDashboardReporting', {});

              case 3:
                _this2.items = _this2.dashboardCampaigns.map(function (d) {
                  return d;
                });
                _this2.filteredItems = _this2.items.map(function (item) {
                  return item;
                });
                _this2.loading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this3 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to confirm date?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!result.value) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.next = 3;
                  return _this3.$store.dispatch('campaign/saveDashboardStatus', {
                    id: item.id,
                    type: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].dashboardTypes.brief,
                    status: 1
                  });

                case 3:
                  _this3.init();
                  _context3.next = 7;
                  break;

                case 6:
                  item.checkedStatus = 0;

                case 7:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    formatDate: function formatDate(date) {
      if (!date || date.includes('/')) return '';
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay: function getDashboardStatusDisplay(status) {
      if (!status) return '';
      return this.dashboardStatusDisplay[status];
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.AM);
        });
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(function (item) {
          return item.users && item.users.includes(_this4.selectedFilter.CC);
        });
      }
    },
    openCampaignModal: function openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID);
    },
    proceedApproveCampaign: function proceedApproveCampaign(campaignID) {
      var _this5 = this;

      var campaignConfirmation = __WEBPACK_IMPORTED_MODULE_5__Campaign_config__["a" /* default */].campaignConfirmation.approval[__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatus.ONGOING];
      var sweetAlertOptions = {
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__["a" /* default */].approveCampaign(campaignID, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].campaignStatus.ONGOING).then(function (response) {
            return response;
          }).catch(function (error) {
            console.log('error', error);

            _this5.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this5.$swal.isLoading();
        }
      };

      this.$swal(sweetAlertOptions).then(function (result) {
        if (result.value) {
          _this5.$swal({
            title: 'Success',
            text: 'Successfully Closed Campaign',
            type: 'success'
          });
          _this5.init();
        } else {}
      });
    },
    saveReviewDeckURL: function saveReviewDeckURL(item) {
      var _this6 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!result.value) {
                    _context4.next = 4;
                    break;
                  }

                  _context4.next = 3;
                  return _this6.$store.dispatch('campaignTimeline/saveReviewDeck', {
                    dashboardID: item.id,
                    campaignID: item.campaignID,
                    reviewDeckURL: item.reviewDeck.reviewDateURL
                  });

                case 3:
                  _this6.init();

                case 4:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this6);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    openReviewDeckDialog: function openReviewDeckDialog(item) {
      item.reviewDeck = {
        reviewDateURL: ''
      };
      this.reviewDeckItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.reviewDeckURLDialog = true;
    },
    setAMCC: function setAMCC() {
      var _this7 = this;

      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        var matchAM = this.AM.find(function (a) {
          return a.id === _this7.currentUserID;
        });
        this.selectedFilter.AM = matchAM;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID;
      }
    }
  }
});

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Post_postApi__ = __webpack_require__(42);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      items: []
    };
  },


  methods: {
    loadTasks: function loadTasks() {
      this.items = [];
      this.checkForPendingRelease();
    },
    actionOnTask: function actionOnTask(task, postID) {
      switch (task) {
        case 'viewPost':
          this.$router.push({ path: '/posts/internal/pending-kobe', query: { action: 'view', id: postID } });
          break;
      }
    },
    checkForPendingRelease: function checkForPendingRelease() {
      var _this = this;

      var status = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING;
      __WEBPACK_IMPORTED_MODULE_1__Post_postApi__["a" /* default */].getPost({ status: status, page: 1 }).then(function (response) {
        var posts = response.posts;
        var pendingReleasePosts = posts.filter(function (item) {
          return item.waiting_release;
        });
        if (pendingReleasePosts.length > 0) {
          _this.items.push({
            action: 'viewPost',
            title: 'Pending your approval',
            text: pendingReleasePosts.length + ' draft(s) to release.'
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    }
  },
  mounted: function mounted() {
    this.loadTasks();
  },

  computed: {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }
});

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'seeMoreModal',
  props: ['dialog', 'title', 'theme', 'headers', 'avgArray', 'DataItems', 'total', 'filterSelected', 'filterItems', 'filterCampaigns', 'type', 'closeDialog'],
  data: function data() {
    return {
      DataTableHeaders: [],
      itemArray: [],
      averageArrayItems: [],
      selectedFilter: '',
      selectedCampaignFilter: '',
      dataTableKey: 0
    };
  },
  mounted: function mounted() {
    this.generateHeaders(this.headers);
  },

  methods: {
    generateHeaders: function generateHeaders(headers) {
      var _this = this;

      var itemVlaue = void 0;
      headers.map(function (item, index) {
        if (Array.isArray(item.name)) {
          itemVlaue = item.name[0];
        } else {
          itemVlaue = item.name;
        }
        if (index === 0) {
          _this.DataTableHeaders.push({
            text: item.header,
            value: itemVlaue
          });
        } else {
          _this.DataTableHeaders.push({
            text: item.header,
            value: itemVlaue,
            align: 'center'
          });
        }
      });
    },
    selectedChangeHandler: function selectedChangeHandler() {
      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        CO: this.selectedFilter,
        Campaign: this.selectedCampaignFilter
      });
      this.$emit('searchFilter', { filter: filter, type: this.type, filterSource: 'detail' });
    }
  }
});

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['serviceList'],
  data: function data() {
    return {
      items: [{ service: '[no Data]' }]
    };
  }
});

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SpeedHelper__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignsActivities__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignsActivities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CampaignsActivities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DurationStage_vue__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DurationStage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DurationStage_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpeedStages',
  components: {
    campaignsActivities: __WEBPACK_IMPORTED_MODULE_7__CampaignsActivities___default.a,
    DurationStage: __WEBPACK_IMPORTED_MODULE_8__DurationStage_vue___default.a
  },
  props: {
    filterUser: { type: Array }
  },
  data: function data() {
    return {
      breadCrumbsItems: [{
        text: 'Dashboard',
        disabled: false,
        href: '/co/dashboard'
      }, {
        text: 'Speed',
        disabled: true,
        href: ''
      }],
      campaigns: [],
      filterCampaigns: [],
      DURATION: {
        title: 'Duration per stage',
        items: [],
        total: {
          top5: {
            activation: 0,
            pairing: 0,
            creating: 0,
            complete: 0,
            overall: 0
          },
          all: {
            activation: 0,
            pairing: 0,
            creating: 0,
            complete: 0,
            overall: 0
          }
        }
      },
      ACTIVATION: {
        title: 'Activation',
        type: 'activation',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: { 'avg': 0, 'title': 'Average time to activate' },
            accounts: { 'avg': 0, 'title': 'Total Number of accounts' }
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: { 'avg': 0, 'title': 'Average time to activate' },
            accounts: { 'avg': 0, 'title': 'Total Number of accounts' }
          }
        },
        fieldsSet: [{
          name: 'name',
          header: 'Campaigns',
          type: 'string',
          format: ['single']
        }, {
          name: 'days',
          header: 'Days',
          type: 'string',
          format: ['single']
        }]
      },
      CREATING: {
        title: 'CO-CREATING',
        type: 'creating',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: { 'avg': 0, 'title': 'Average time to activate' },
            accounts: { 'avg': 0, 'title': 'Total Number of accounts' }
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: { 'avg': 0, 'title': 'Average time to activate' },
            accounts: { 'avg': 0, 'title': 'Total Number of accounts' }
          }
        },
        fieldsSet: [{
          name: 'name',
          header: 'Campaigns',
          type: 'string',
          format: ['single']
        }, {
          name: 'days',
          header: 'Days',
          type: 'string',
          format: ['single']
        }]
      },
      PAIRING: {
        title: 'Pairing',
        type: 'pairing',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to activate'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to activate'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        fieldsSet: [{
          name: 'name',
          header: 'Campaigns',
          type: 'string',
          format: ['single']
        }, {
          name: 'days',
          header: 'Days',
          type: 'string',
          format: ['single']
        }]
      },
      COMPLETE: {
        title: 'Complete',
        type: 'complete',
        allDetail: [],
        previews: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to submit'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        detail: {
          items: [],
          avgBlocks: {
            time: {
              'avg': 0,
              'title': 'Average time to activate'
            },
            accounts: {
              'avg': 0,
              'title': 'Total Number of accounts'
            }
          }
        },
        fieldsSet: [{
          name: 'name',
          header: 'Campaigns',
          type: 'string',
          format: ['single']
        }, {
          name: ['totalPayouts', 'totalPosts'],
          header: 'Submit Payout',
          type: 'string',
          format: ['multiple']
        }, {
          name: ['yetToPayouts', 'totalPosts'],
          header: 'Yet To Submit',
          type: 'string',
          format: ['multiple']
        }]
      },
      campaignActivity: {
        ACTIVATION: 'activation',
        PAIRING: 'pairing',
        CREATING: 'creating',
        COMPLETE: 'complete'
      },
      seeMoreDialog: false,
      seeMoreHeader: [],
      seeMoreItems: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = void 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__SpeedHelper__["a" /* default */].getAllCampaignsNoStatus();

            case 3:
              response = _context.sent;

              if (response) {
                _this.campaigns = response;
                _this.filterCampaigns = response;
                _this.filterCampaigns.unshift({ id: '', name: 'All Campaigns' });
              }
              _context.next = 7;
              return _this.getSpeedData(_this.ACTIVATION.type, {});

            case 7:
              _context.next = 9;
              return _this.getSpeedData(_this.PAIRING.type, {});

            case 9:
              _context.next = 11;
              return _this.getSpeedData(_this.CREATING.type, {});

            case 11:
              _context.next = 13;
              return _this.getSpeedData(_this.COMPLETE.type, {});

            case 13:
              _context.next = 15;
              return _this.getDurationStage();

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getSpeedData: function getSpeedData(type, filters, filterSource) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var typeName, response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                typeName = type.toUpperCase();
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__SpeedHelper__["a" /* default */].getSpeedData(type, filters);

              case 3:
                response = _context2.sent;

                if (response) {
                  if (!filterSource) {
                    _this2[typeName].allDetail = response.all;
                  }
                  if (!filterSource || filterSource && filterSource === 'previews') {
                    _this2[typeName].previews.items = response.previews;
                    _this2[typeName].previews.avgBlocks.time.avg = response.avgTime;
                    if (type !== _this2.COMPLETE.type) {
                      _this2[typeName].previews.avgBlocks.accounts.avg = response.totalAccounts;
                    }
                  }
                  if (!filterSource || filterSource && filterSource === 'detail') {
                    _this2[typeName].detail.items = response.all;
                    _this2[typeName].detail.avgBlocks.time.avg = response.avgTime;
                    if (type !== _this2.COMPLETE.type) {
                      _this2[typeName].detail.avgBlocks.accounts.avg = response.totalAccounts;
                    }
                  }
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterSearch: function filterSearch(filters) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getSpeedData(filters.type, filters.filter, filters.filterSource);

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getDurationStage: function getDurationStage() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var vm;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                vm = _this4;

                _this4.DURATION.items = _this4.filterUser.map(function (c) {
                  var totalDays = 0;
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.campaignActivity).map(function (key) {
                    var activationCampaigns = vm[key].allDetail.filter(function (a) {
                      return a.assignedTo && a.assignedTo.includes(c.id);
                    });
                    var activationDays = activationCampaigns.map(function (c) {
                      return c.days;
                    }).reduce(function (one, two) {
                      return one + two;
                    }, 0);
                    c[key] = activationDays > 0 ? Math.round(activationDays / activationCampaigns.length, 0) : 0;
                    totalDays += c[key];
                  });
                  c.Overall = totalDays > 0 ? Math.round(totalDays / __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.campaignActivity).length, 0) : 0;
                  return c;
                });

                _this4.DURATION.items = _this4.DURATION.items.filter(function (d) {
                  return d.id !== '';
                });
                _this4.DURATION.items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this4.DURATION.items.sort(function (a, b) {
                  return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
                }));
                _this4.DURATION.total.top5 = _this4.calculateTotalDuration(_this4.DURATION.items.slice(0, 6));
                _this4.DURATION.total.all = _this4.calculateTotalDuration(_this4.DURATION.items);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    calculateTotalDuration: function calculateTotalDuration(items) {
      var _this5 = this;

      var vm = this;
      var total = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.campaignActivity).map(function (key) {
        total[vm.campaignActivity[key]] = 0;
      });
      items.map(function (item) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.campaignActivity).map(function (key) {
          total[vm.campaignActivity[key]] += item[key];
        });
      });
      var allTotal = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.campaignActivity).map(function (key) {
        total[vm.campaignActivity[key]] = Math.round(total[vm.campaignActivity[key]] / items.length, 0);
        allTotal += total[vm.campaignActivity[key]];
      });
      total.overall = allTotal > 0 ? Math.round(allTotal / __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.campaignActivity).length, 0) : 0;
      return total;
    }
  }
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'totalNumbers',
  props: ['number', 'title'],
  data: function data() {
    return {
      displayNumber: 0,
      interval: false
    };
  },
  ready: function ready() {
    this.displayNumber = this.number ? this.number : 0;
  },

  watch: {
    number: function number() {
      var _this = this;

      clearInterval(this.interval);

      if (this.number === this.displayNumber) {
        return;
      }

      this.interval = window.setInterval(function () {
        if (_this.displayNumber !== _this.number) {
          var change = (_this.number - _this.displayNumber) / 10;
          change = change >= 0 ? Math.ceil(change) : Math.floor(change);
          _this.displayNumber = _this.displayNumber + change;
        }
      }, 20);
    }
  }
});

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashboardComponents_SpendHelper__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Summary_Of_Account',
  props: {
    filterUsers: { type: Array },
    userType: { type: String }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      dataTableKey: 0,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      isLoading: false,
      overviewHeaders: [{
        'text': 'Client Name',
        'align': 'start',
        'value': 'name',
        'sortable': true,
        'groupable': false
      }, {
        'text': 'Number Of IO',
        'align': 'center',
        'value': 'numberOfIOs',
        'sortable': true,
        'groupable': false
      }, {
        'text': 'Total IO Amount',
        'align': 'center',
        'sortable': true,
        'groupable': false,
        'value': 'totalIOAmount'
      }, {
        'text': 'Total Revenue Recognize',
        'align': 'center',
        'sortable': true,
        'groupable': false,
        'value': 'totalRevenue'
      }, {
        'text': '% Completion',
        'align': 'center',
        'sortable': true,
        'groupable': false,
        'value': 'totalCompletion'
      }, {
        'text': 'Amount Paid',
        'align': 'center',
        'sortable': true,
        'groupable': false,
        'value': 'totalPayout'
      }, {
        'text': 'Date Of Last IO',
        'align': 'center',
        'sortable': true,
        'groupable': false,
        'value': 'lastIODate'
      }, {
        'text': 'CC',
        'align': 'center',
        'sortable': true,
        'groupable': false,
        'value': 'CO'
      }],
      overviewData: [],
      detailsHeaders: [{
        'text': 'IO Number',
        'align': 'start',
        'value': 'ioNumbers',
        'groupable': false
      }, {
        'text': 'IO Amount',
        'align': 'center',
        'sortable': false,
        'value': 'IOAmount',
        'groupable': false
      }, {
        'text': 'Amount Paid',
        'align': 'center',
        'sortable': false,
        'value': 'payout',
        'groupable': false
      }, {
        'text': 'Campaign Name',
        'align': 'center',
        'sortable': false,
        'value': 'name',
        'groupable': false
      }, {
        'text': 'Product Name',
        'align': 'center',
        'sortable': false,
        'value': 'ProductName',
        'groupable': false
      }, {
        'text': 'Budget',
        'align': 'center',
        'sortable': false,
        'value': 'budget',
        'groupable': false
      }, {
        'text': 'Revenue',
        'align': 'center',
        'sortable': false,
        'value': 'revenvue',
        'groupable': false
      }, {
        'text': '% Completion',
        'align': 'center',
        'sortable': false,
        'value': 'completion',
        'groupable': false
      }, {
        'text': 'Date',
        'align': 'center',
        'sortable': false,
        'value': 'dateAt',
        'groupable': false
      }, {
        'text': 'AM',
        'align': 'center',
        'sortable': false,
        'value': 'AM'
      }],
      expanded: [],
      filterItems: [],
      selectedFilter: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getOverviewData({});

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getOverviewData: function getOverviewData(filter) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__DashboardComponents_SpendHelper__["a" /* default */].getOverviewReportData(filter);

              case 3:
                _this2.overviewData = _context2.sent;

                _this2.isLoading = false;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getColor: function getColor(minusNumber) {
      if (minusNumber) {
        if (minusNumber.toString().indexOf('-') !== -1) return 'red';
      }
    },
    search: function search() {
      var filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        User: this.selectedFilter,
        userType: this.userType
      });
      this.getOverviewData(filter);
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('MMM-YYYY');
    }
  }
});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'APITesting',
  data: function data() {
    return {
      url: '',
      method: 'GET',
      methods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'],
      headers: [{ key: 'Content-Type', value: 'application/json' }],
      body: '',
      response: {
        type: '',
        text: '',
        data: ''
      }
    };
  },

  methods: {
    addHeader: function addHeader() {
      this.headers.push({ key: '', value: '' });
    },
    removeHeader: function removeHeader(index) {
      this.headers.splice(index, 1);
    },
    testAPI: function testAPI() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var headers, hd, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                headers = {};
                hd = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], _this.headers);

                hd.forEach(function (element) {
                  headers[element.key] = element.value;
                });
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                  method: _this.method,
                  url: _this.url,
                  headers: headers,
                  data: _this.body
                });

              case 6:
                resp = _context.sent;

                console.log(resp);
                _this.response.type = 'success';
                _this.response.text = 'Success';
                _this.response.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(resp.data, null, 4);
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.response.type = 'error';
                _this.response.text = 'Error';
                _this.response.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_context.t0);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    }
  }
});

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__express_gateway_api_js__ = __webpack_require__(811);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExpressGateWayUsers',
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    check: function check() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__express_gateway_api_js__["a" /* default */].checkExistdUser(this.email).then(function (resp) {
        _this.$swal({
          title: 'Found!!!',
          text: 'User already existed',
          type: 'success'
        });
      }).catch(function () {
        _this.$swal({
          title: 'Not Found!!!',
          text: 'User does not exist',
          type: 'error',
          buttons: ['Create User']
        });
      });
    },
    create: function create() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__express_gateway_api_js__["a" /* default */].createUserGateWay(this.email).then(function (resp) {
        _this2.$swal({
          title: 'Success',
          text: 'Created',
          type: 'success'
        });
      }).catch(function (error) {
        console.error(error);
        _this2.$swal({
          title: 'Error',
          text: error.message,
          type: 'error'
        });
      });
    }
  }
});

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActualAmountModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    report: Object
  },
  validations: {
    amount: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      isLoading: false,
      amount: '',
      paidSearch: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    amountErrors: function amountErrors() {
      var errors = [];
      if (!this.$v.amount.$dirty) return errors;
      !this.$v.amount.required && errors.push('This field is required.');
      return errors;
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var updateData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
            reportID: _this2.report.reportID,
            campaignID: _this2.report.campaign.id,
            actualAmount: _this2.amount
          });

          _this2.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__["a" /* default */].saveReportActualAmount(_this2.report.reportID, updateData).then(function (response) {
            _this2.isLoading = false;
            _this2.close();

            _this2.$swal({
              text: 'Actual Amount Updated',
              type: 'success'
            });
            _this2.$emit('updated');
          }).catch(function (error) {
            _this2.isLoading = false;

            console.log('error', error);
            _this2.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    close: function close() {
      this.$emit('input');
    }
  },
  watch: {
    value: function value(newValue) {
      this.amount = '';
      if (this.report) {
        if (this.report.actualAmount) {
          this.amount = this.report.actualAmount;
        }
      }
    }
  }
});

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Campaign_config__ = __webpack_require__(26);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArchiveList',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle___default.a
  },
  data: function data() {
    return {
      headers: [{ value: 'liveDate', text: 'Live Date', sortable: true }, { value: 'dueDate', text: 'Due Date', sortable: true }, { value: 'swiftCode', text: 'Swift Code', sortable: true }, { value: 'bankAccount', text: 'Bank A/C No.', sortable: true }, { value: 'username', text: 'Payee Name', sortable: true }, { value: 'country', text: 'Country', sortable: true }, { value: 'bankName', text: 'Bank Name', sortable: true }, { value: 'email', text: 'Email', sortable: true }, { value: 'amount', text: 'Amount', sortable: true }, { value: 'instagram', text: 'IG Handle/Tiktok Handle', sortable: true }, { value: 'clientName', text: 'Client Name', sortable: true }, { value: 'campaignName', text: 'Campaign Name', sortable: true }, { value: 'IONumber', text: 'Campaign IO Number', sortable: true }, { value: 'paymentDate', text: 'Payment Date (DD/MM/YYYY)', sortable: true }, { value: 'paymentSubmissionDate', text: 'Submission Date (DD/MM/YYYY)', sortable: true }, { value: 'paymentStatus', text: 'Payment Status', sortable: true }, { value: 'bankReference', text: 'Bank Reference', sortable: true }, { value: 'POCDisplay', text: 'POC', sortable: true }, { value: 'agreedDeliverables', text: 'Agreed Deliverables', sortable: true }, { value: 'deliverables', text: 'Produced Deliverables', sortable: true }, { value: 'action', text: 'Actions', sortable: true }],
      defaultSections: {
        imported: [],
        batchOne: [],
        batchTwo: [],
        approvalFinance: [],
        approvalLead: [],
        partiallyPaid: [],
        completed: []
      },
      archiveReportSections: {},
      filteredItems: [],
      selectedItems: [],
      items: [],
      filter: {
        search: ''
      },
      sectionIDs: __WEBPACK_IMPORTED_MODULE_9__Campaign_config__["a" /* default */].paymentConsSectionIDs
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    archiveReports: function archiveReports(state) {
      return state.campaign.archiveReports;
    },
    updatedReport: function updatedReport(state) {
      return state.campaign.updatedReport;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('payment', ['getPaymentStatus', 'formatPosts', 'setBatchTableSections'])),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAllUsers();

            case 2:
              _this.getArchiveLists();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    selectAllItems: function selectAllItems($event) {
      if ($event.value && $event.items.length === 0) {
        return;
      }
      var batchIndex = null;
      if ($event.items.length > 0) {
        batchIndex = this.filteredItems.findIndex(function (i) {
          return i.batchNo === $event.items[0].batchNo;
        });
      }
      if (!$event.value) {
        this.filteredItems[batchIndex].selectedPayments = [];
        return;
      }
      this.filteredItems[batchIndex].selectedPayments = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], $event.items);
    },
    restoreArchive: function restoreArchive(batchIndex) {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var data;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result.value) {
                    _context2.next = 14;
                    break;
                  }

                  data = _this2.filteredItems[batchIndex].selectedPayments.map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                      id: item.id,
                      archive: false
                    });
                  });
                  _context2.next = 4;
                  return _this2.$store.dispatch('campaign/updateReportsByIds', data);

                case 4:
                  if (!(_this2.filteredItems[batchIndex].batchNo === _this2.sectionIDs.PAID)) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.next = 7;
                  return _this2.$store.dispatch('payment/updateCompletedPaymentsByReportID', {
                    data: data
                  });

                case 7:
                  _this2.isLoading = false;

                  if (_this2.updatedReport) {
                    _context2.next = 11;
                    break;
                  }

                  _this2.$swal({
                    text: 'Error Archiving Reports.',
                    type: 'error'
                  });
                  return _context2.abrupt('return');

                case 11:
                  _this2.selectedItems = [];

                  _this2.$swal({
                    text: 'Successfully restored.',
                    type: 'success'
                  });
                  _this2.getArchiveLists();

                case 14:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    changeSearch: function changeSearch(batchFilter, keyword) {
      batchFilter.workingSearch = keyword;
    },
    close: function close() {
      this.$emit('input');
    },
    searchGlobal: function searchGlobal() {
      var _this3 = this;

      this.filteredItems = this.items.map(function (item) {
        item.filter.workingSearch = _this3.searchText;
        return item;
      });
    },
    getArchiveLists: function getArchiveLists() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload, formattedRets;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                  filters: {
                    archive: true
                  }
                });
                _context3.next = 3;
                return _this4.$store.dispatch('campaign/getPaymentConsolidateReport', payload);

              case 3:
                _this4.clearArchives();
                formattedRets = _this4.formatPosts(_this4.archiveReports, _this4.archiveReportSections, _this4.Users, {});

                _this4.archiveReports = formattedRets.posts;
                _this4.archiveReportSections = formattedRets.sections;
                _this4.setBatchTableSections(_this4.items, _this4.headers, _this4.archiveReportSections);
                _this4.filteredItems = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this4.items);
                _this4.isLoading = false;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    clearArchives: function clearArchives() {
      this.items = [];
      this.archiveReportSections = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.refreshJSON(this.defaultSections);
    },
    getAllUsers: function getAllUsers() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH + ',' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW + ',' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH + ',' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW + ',' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.AD_STRATEGIST + ',' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.FINANCE + ',' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 2:
                response = _context4.sent;

                if (response) {
                  _this5.Users = response.users;
                  _this5.Users = _this5.Users.map(function (u) {
                    u.name = '' + u.firstName;
                    return u;
                  });
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  }
});

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_SocialHandleView__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_SocialHandleView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_SocialHandleView__);





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateCogsEstimateModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_15_vue_loading_overlay___default.a,
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_CustomFileUpload___default.a,
    SocialHandleView: __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_SocialHandleView___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8_vuelidate__["validationMixin"]],
  props: {
    value: Boolean,
    editItem: Object
  },
  validations: function validations() {
    return this.rules;
  },
  data: function data() {
    return {
      estimationTypes: ['Loading/Boosting Fee', 'Ad Expenses', 'Logistics', 'Others'],
      payout: {
        handle: null,
        campaign: null,
        live_date: '',
        amount: '',
        remarks: '',
        estimationType: '',
        duplicate: false
      },
      pickDate: false,
      search: null,
      searchCs: null,
      campaigns: [],
      clients: [],
      influencers: [],
      searchClient: null,
      isLoading: false,
      isInvalidLiveDate: false,
      unPaidAmtErr: false,
      invoiceFiles: [],
      fileUploadRefresh: 1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapState */])({
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])('payment', ['allowedStatuses', 'allowedStatusesForPayoutCreate']), {
    rules: function rules() {
      var validationRules = {
        payout: {
          campaign: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          live_date: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          estimationType: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          amount: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          }
        }
      };
      return validationRules;
    },
    selectedCampaignErrors: function selectedCampaignErrors() {
      var errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    estimationTypeErrors: function estimationTypeErrors() {
      var errors = [];
      if (!this.$v.payout.estimationType.$dirty) return errors;
      !this.$v.payout.estimationType.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors: function amountErrors() {
      var errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    liveDateErrors: function liveDateErrors() {
      var errors = [];
      if (!this.$v.payout.live_date.$dirty) return errors;
      !this.$v.payout.live_date.required && errors.push('This field is required.');
      return errors;
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    campaignStatus: function campaignStatus() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus).join();
    },
    disableSavePayout: function disableSavePayout() {
      return this.$v.payout.$invalid || this.unPaidAmtErr || this.isInvalidLiveDate;
    }
  }),
  watch: {
    value: function value(newValue) {
      this.disableEdit = false;
      this.payout.campaign = null;
      this.resetForm();
    },
    editItem: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        var matchCampaign, matchInf;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (newValue) {
                  _context.next = 3;
                  break;
                }

                delete this.payout.id;
                return _context.abrupt('return');

              case 3:
                matchCampaign = this.campaigns.find(function (campaign) {
                  return campaign.id === newValue.campaignID;
                });

                if (!matchCampaign) {
                  _context.next = 16;
                  break;
                }

                this.payout.id = newValue.id;
                this.payout.campaign = matchCampaign;
                this.payout.live_date = this.formatDate(newValue.liveDate);
                this.payout.amount = newValue.amount;
                this.payout.remarks = newValue.remarks;
                this.payout.estimationType = newValue.estimationType || '';
                this.payout.customType = newValue.customType || '';
                if (!newValue.created) {
                  this.disableEdit = true;
                }
                _context.next = 15;
                return this.changeCampaign();

              case 15:
                if (newValue.handle) {
                  matchInf = this.influencers.find(function (i) {
                    return i.handle === newValue.handle;
                  });

                  if (matchInf) {
                    this.payout.handle = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, matchInf);
                  }
                }

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editItem(_x) {
        return _ref.apply(this, arguments);
      }

      return editItem;
    }()
  },
  mounted: function mounted() {
    this.fetchCampaigns();
    this.fetchClient();
  },

  methods: {
    close: function close() {
      this.$emit('input');
    },
    savePayout: function savePayout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this.isLoading = true;
                formData = _this.constructData(_this.payout);
                _context2.next = 5;
                return _this.$store.dispatch('payment/createCogsEstimate', formData);

              case 5:
                _this.isLoading = false;
                _this.$emit('created');
                _this.$emit('input');
                _this.$swal({
                  text: _this.payout.id ? 'Successfully updated COGS Estimation' : 'New COGS Estimation is created',
                  type: 'success'
                });
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](0);

                _this.isLoading = false;
                console.error(_context2.t0);
                _this.$swal({
                  text: _context2.t0.message,
                  type: 'error'
                });

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 11]]);
      }))();
    },
    fetchCampaigns: function fetchCampaigns() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, data, campaigns;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__["a" /* default */].getAllCampaigns(_this2.campaignStatus, false);

              case 3:
                resp = _context3.sent;
                data = resp.data;
                campaigns = data.campaigns;

                _this2.campaigns = campaigns.map(function (cmp) {
                  return {
                    displayName: cmp.ioNumbers ? cmp.ioNumbers + ' - ' + cmp.name : cmp.name,
                    name: cmp.name,
                    id: cmp.id,
                    ioNumbers: cmp.ioNumbers,
                    assignedTo: cmp.assignedTo,
                    clientID: cmp.clientID
                  };
                });
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                _this2.$swal({
                  text: 'Cannot fetch the list of campaigns',
                  icon: 'error'
                });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 9]]);
      }))();
    },
    filterClientByCampaigns: function filterClientByCampaigns(clientID) {
      var client = this.clients.find(function (cmp) {
        return cmp.id === clientID;
      });
      return client;
    },
    constructData: function constructData(input) {
      var formData = new FormData();
      var saveData = {
        handle: input.handle ? input.handle.handle : null,
        platform: input.handle ? input.handle.platform : null,
        username: input.handle ? input.handle.username : null,
        campaign: {
          id: input.campaign.id,
          name: input.campaign.name,
          clientName: input.client.name,
          IONumber: input.campaign.ioNumbers,
          POC: input.campaign.assignedTo
        },
        pairedAmount: input.handle ? Number(input.handle.amount) : 0,
        amount: Number(input.amount),
        estimationType: input.estimationType,
        customType: input.customType,
        liveDate: this.parseDate(input.live_date),
        remarks: input.remarks
      };
      if (input.id) {
        saveData.id = input.id;
      }
      formData.append('data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(saveData));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.invoiceFiles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('isInvoice', true);
          formData.append('uploadFile', val);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formData;
    },
    changeCampaign: function changeCampaign() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newValue, resp;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                newValue = _this3.payout.campaign;

                if (newValue && newValue.clientID) {
                  _this3.payout.client = _this3.filterClientByCampaigns(newValue.clientID);
                }

                if (!(newValue && newValue.name)) {
                  _context4.next = 14;
                  break;
                }

                _context4.prev = 3;
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(newValue.id);

              case 6:
                resp = _context4.sent;

                _this3.setInfluencers(resp);
                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](3);

                console.log(_context4.t0);
                _this3.$swal({
                  text: 'Cannot fetch the list of Influencers',
                  icon: 'error'
                });

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[3, 10]]);
      }))();
    },
    setInfluencers: function setInfluencers(resp) {
      resp = resp.filter(function (r) {
        if (r.pairing_details && r.pairing_details.status) {
          if (r.pairing_details.status === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].pairingStatus.ACCEPTED) {
            return true;
          }
        }
        return false;
      });
      this.influencers = resp.map(function (pairing) {
        if (pairing.influencer_details) {
          var influencerDetails = pairing.influencer_details;
          var payoutDetails = pairing.payout_details;
          var respData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
            campaignID: pairing.campaignID,
            influencerID: influencerDetails.influencerID || '',
            handle: influencerDetails.instagramHandle,
            username: influencerDetails.fullname || '',
            platform: influencerDetails.platform || 'instagram',
            amount: payoutDetails.amount || 0
          });
          if (respData.platform === 'xiaohongshu') {
            respData.handle = influencerDetails.fullName;
          }
          return respData;
        }
      });
    },
    fetchClient: function fetchClient() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var resp, clients;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__Client_clientAPIs__["a" /* default */].getAllClients(true);

              case 3:
                resp = _context5.sent;
                clients = resp.data;

                _this4.clients = clients.map(function (user) {
                  return {
                    name: user.name,
                    id: user.id
                  };
                });
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);
                _this4.$swal({
                  text: 'Cannot fetch the list of clients',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[0, 8]]);
      }))();
    },
    resetForm: function resetForm() {
      this.payout.handle = null;
      this.payout.live_date = '';
      this.payout.amount = '';
      this.payout.estimationType = '';
      this.payout.customType = '';
      this.influencers = [];
      this.invoiceFiles = [];
      this.fileUploadRefresh += 1;
    },
    updateInvoices: function updateInvoices(medias) {
      this.invoiceFiles = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], medias);
    },
    changeLiveDate: function changeLiveDate() {
      this.$v.payout.live_date.$touch();
      this.isInvalidLiveDate = false;
      this.payout.due_date = '';
      if (!this.isDateValid(this.payout.live_date)) {
        this.isInvalidLiveDate = true;
        return;
      }
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split = date.split('/'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          day = _date$split2[0],
          month = _date$split2[1],
          year = _date$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          year = _date$split4[0],
          month = _date$split4[1],
          day = _date$split4[2];

      var formattedDate = day + '/' + month + '/' + year;
      if (formattedDate.includes('undefined')) {
        return date;
      }
      return formattedDate;
    },
    isDateValid: function isDateValid(givenDate) {
      if (!givenDate) return true;
      var regex = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].regexPattern.date_format;
      if (givenDate.match(regex)) return true;
      return false;
    }
  }
});

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CreateCogsEstimateModal__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CreateCogsEstimateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CreateCogsEstimateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MoreDetailsModal__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MoreDetailsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__MoreDetailsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TotalSummaryModal__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TotalSummaryModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__TotalSummaryModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_sumBy__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__User_userAPIs__ = __webpack_require__(19);



























var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CogsEstimateDataTable',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default.a,
    CreateCogsEstimateModal: __WEBPACK_IMPORTED_MODULE_14__CreateCogsEstimateModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal___default.a,
    MoreDetailsModal: __WEBPACK_IMPORTED_MODULE_16__MoreDetailsModal___default.a,
    TotalSummaryModal: __WEBPACK_IMPORTED_MODULE_17__TotalSummaryModal___default.a
  },
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].tableHeaders,
      countries: __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].countries,
      utilsFunc: __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func,
      items: [],
      editCogsEstimate: null,
      filter: '',
      filteredItems: [],
      selectedFilter: {
        startDate: '',
        endDate: '',
        searchDate: '',
        country: '',
        cc: '',
        batchOne: false,
        batchTwo: false,
        createdOnly: false,
        reload: false
      },
      searchDateCal: false,
      startDateCal: false,
      endDateCal: false,
      totalValues: {
        cogsEstimate: 0
      },
      isLoading: false,
      createCogsEstimateDialog: false,
      colSettingsDialog: false,
      moreDetailsDialog: false,
      totalSummaryDialog: false,
      colStatuses: {},
      currentMthCOGS: 0,
      nextMthCOGS: 0,
      startDate: '',
      endDate: '',
      dataTableFilteredItems: [],
      Users: [],
      CCUsers: [],
      revsForMonthYear: [],
      monthsData: [],
      selectedCOGS: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["b" /* mapState */])({
    creatorCogsEstimate: function creatorCogsEstimate(state) {
      return state.payment.creatorCogsEstimate;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["c" /* mapGetters */])('payment', ['formatDate']), {
    currentMonthLabel: function currentMonthLabel() {
      return moment().format('MMM YYYY');
    },
    nextMonthLabel: function nextMonthLabel() {
      return moment().add(1, 'months').format('MMM YYYY');
    },

    showFilterDate: function showFilterDate() {
      if (this.selectedFilter.startDate || this.selectedFilter.endDate) {
        var respDateStr = 'for ';
        if (this.selectedFilter.startDate) {
          respDateStr += __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.formatCustomDate(this.selectedFilter.startDate, 'MMM YYYY');
        }
        if (this.selectedFilter.startDate && this.selectedFilter.endDate) {
          respDateStr += ' - ';
        }
        if (this.selectedFilter.endDate) {
          respDateStr += __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.formatCustomDate(this.selectedFilter.endDate, 'MMM YYYY');
        }
        return respDateStr;
      }
      return '';
    },
    computedHeaders: function computedHeaders() {
      var _this = this;

      if (localStorage.getItem('cogsEstimationCols')) {
        this.colStatuses = JSON.parse(localStorage.getItem('cogsEstimationCols'));
      } else {
        this.headers.map(function (header) {
          _this.colStatuses[header.value] = true;
        });
      }
      return this.headers.filter(function (h) {
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch('payment/getCurrencyRates');

            case 2:
              _this2.init();
              _this2.getAllUsers();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    init: function init() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.countries.unshift('Overseas');
                _this3.startDate = moment().format('YYYY') + '-01';
                _this3.endDate = moment().format('YYYY') + '-12';
                _this3.getCogsEstimation();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getCurrentMonthCOGS: function getCurrentMonthCOGS() {
      var items = this.filteredItems.filter(function (item) {
        return item.estimatedLiveDate === moment().format('YYYY-MM');
      });
      this.currentMthCOGS = Number(__WEBPACK_IMPORTED_MODULE_22_lodash_sumBy___default()(items, function (item) {
        if (item.sgdGstIncluded) {
          return !isNaN(item.sgdGstIncluded) && item.sgdGstIncluded !== undefined && item.sgdGstIncluded !== 'undefined' ? Number(item.sgdGstIncluded || 0) : 0;
        } else {
          return !isNaN(item.GSTExcludedAmt) && item.GSTExcludedAmt !== undefined && item.GSTExcludedAmt !== 'undefined' ? Number(item.GSTExcludedAmt || 0) : 0;
        }
      }));
      this.currentMthCOGS = this.currentMthCOGS.toFixed(2);
    },
    getNextMonthCOGS: function getNextMonthCOGS() {
      var items = this.filteredItems.filter(function (item) {
        return item.estimatedLiveDate === moment().add(1, 'months').format('YYYY-MM');
      });
      this.nextMthCOGS = Number(__WEBPACK_IMPORTED_MODULE_22_lodash_sumBy___default()(items, function (item) {
        if (item.sgdGstIncluded) {
          return !isNaN(item.sgdGstIncluded) && item.sgdGstIncluded !== undefined && item.sgdGstIncluded !== 'undefined' ? Number(item.sgdGstIncluded || 0) : 0;
        } else {
          return !isNaN(item.GSTExcludedAmt) && item.GSTExcludedAmt !== undefined && item.GSTExcludedAmt !== 'undefined' ? Number(item.GSTExcludedAmt || 0) : 0;
        }
      }));
      this.nextMthCOGS = this.nextMthCOGS.toFixed(2);
    },
    getCogsEstimation: function getCogsEstimation() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.isLoading = true;
                _this4.selectedFilter.startDate = _this4.startDate;
                _this4.selectedFilter.endDate = _this4.endDate;
                _context3.next = 5;
                return _this4.$store.dispatch('payment/getCreatorCogsEstimate', {
                  filters: _this4.selectedFilter
                });

              case 5:
                _this4.searchFilter();
                _this4.calcTotalSummary(_this4.filteredItems);
                _this4.getCurrentMonthCOGS();
                _this4.getNextMonthCOGS();
                _this4.selectedFilter.reload = false;
                _this4.isLoading = false;

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    beautifyData: function beautifyData() {
      var _this5 = this;

      this.creatorCogsEstimate = this.creatorCogsEstimate.map(function (inf) {
        if (inf.currency && inf.currency !== 'SGD') {
          inf.sgdAmt = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.convertCurrency(inf.currency, Number(inf.amount || 0), _this5.currencyRates);
          inf.sgdGstIncluded = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.convertCurrency(inf.currency, Number(inf.GSTExcludedAmt || 0), _this5.currencyRates);
        }
        inf.estimatedLiveDate = _this5.formatYM(inf.estimatedLiveDate);
        inf.selectedCOGS = [];
        return inf;
      });
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.creatorCogsEstimate);
    },
    searchFilter: function searchFilter() {
      var _this6 = this;

      this.items = this.beautifyData();
      this.filteredItems = this.creatorCogsEstimate.map(function (i) {
        return i;
      });
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_23_lodash_orderBy___default()(this.filteredItems, ['estimatedLiveDate'], ['desc']);
      if (this.selectedFilter.cc) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.POC && f.POC.includes(_this6.selectedFilter.cc);
        });
      }
      if (this.selectedFilter.createdOnly) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.created;
        });
      }
      this.getTotalSummary();
      this.monthsData = this.generateMonthArray();
      this.monthsData = this.monthsData.map(function (m) {
        m.data = _this6.filteredItems.filter(function (fm) {
          return fm.estimatedLiveDate === m.month;
        });
        return m;
      });
      this.monthsData = this.monthsData.filter(function (f) {
        return f.data.length;
      });
    },
    resetTotalValues: function resetTotalValues() {
      this.totalValues = {
        cogsEstimate: 0
      };
    },
    calcTotalSummary: function calcTotalSummary() {
      var _this7 = this;

      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.resetTotalValues();
      if (!items.length) {
        return;
      }
      this.totalValues.cogsEstimate = Number(__WEBPACK_IMPORTED_MODULE_22_lodash_sumBy___default()(items, function (item) {
        if (!item.duplicate) {
          var otherAmts = 0;
          var gstIncluded = 0;
          otherAmts += item.cogsRelated ? Number(item.cogsRelated) : 0;
          otherAmts += item.internalClaims ? Number(item.internalClaims) : 0;
          otherAmts += item.logistics ? Number(item.logistics) : 0;
          otherAmts += item.otherAdjustment ? Number(item.otherAdjustment) : 0;
          if (item.currency && item.currency !== 'SGD') {
            gstIncluded = __WEBPACK_IMPORTED_MODULE_21__utils__["a" /* default */].func.convertCurrency(item.currency, item.GSTExcludedAmt, _this7.currencyRates);
          } else {
            gstIncluded = Number(item.GSTExcludedAmt);
          }
          return Number(gstIncluded) - otherAmts;
        }
      }));
      this.totalValues.cogsEstimate = this.totalValues.cogsEstimate.toFixed(2);
    },
    getFiltered: function getFiltered() {
      var _this8 = this;

      this.$nextTick(function () {
        if (_this8.$refs.CreatorCogsTable.$children) {
          _this8.calcTotalSummary(_this8.$refs.CreatorCogsTable.$children[0].filteredItems);
          _this8.dataTableFilteredItems = _this8.$refs.CreatorCogsTable.$children[0].filteredItems;
        }
      });
    },
    openCreateCogsEstimateModal: function openCreateCogsEstimateModal() {
      this.editCogsEstimate = null;
      this.createCogsEstimateDialog = true;
    },
    openMoreDetailsDialog: function openMoreDetailsDialog() {
      this.moreDetailsDialog = true;
    },
    openTotalSummaryDialog: function openTotalSummaryDialog(selectedCOGS) {
      this.selectedCOGS = selectedCOGS;
      this.totalSummaryDialog = false;
      this.totalSummaryDialog = true;
    },
    remove: function remove(item) {
      this.selectedFilter.country.splice(this.selectedFilter.country.indexOf(item), 1);
      this.selectedFilter.country = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.selectedFilter.country));
    },
    reload: function reload() {
      this.selectedFilter.reload = true;
      this.getCogsEstimation();
    },
    openColSettingsModal: function openColSettingsModal() {
      var _this9 = this;

      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }

      var _loop = function _loop(key, value) {
        var header = _this9.headers.find(function (item) {
          return item.value === key;
        });
        if (header) {
          _this9.tableColsItems.push({
            title: header.text,
            key: key,
            value: value
          });
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(tmpStatuses)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          _loop(key, value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var columns = this.colStatuses;
      items.map(function (item) {
        columns[item.key] = item.value;
      });
      localStorage.setItem('cogsEstimationCols', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(columns));
      this.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
      this.colSettingsDialog = false;
    },
    viewEditDialog: function viewEditDialog(item) {
      this.editCogsEstimate = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, item);
      this.createCogsEstimateDialog = true;
    },
    changeDuplicate: function changeDuplicate(item, status) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var formData, saveData;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                formData = new FormData();
                saveData = {
                  id: item.id,
                  duplicate: status,
                  liveDate: item.liveDate
                };

                formData.append('data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(saveData));
                _context4.next = 5;
                return _this10.$store.dispatch('payment/createCogsEstimate', formData);

              case 5:
                _this10.calcTotalSummary(_this10.filteredItems);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split = date.split('/'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          day = _date$split2[0],
          month = _date$split2[1],
          year = _date$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    downloadCogsEstimateRpt: function downloadCogsEstimateRpt() {
      var _this11 = this;

      this.isLoading = true;
      var filters = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.selectedFilter);

      filters.reportIds = this.filteredItems.map(function (item) {
        return item.id;
      });
      __WEBPACK_IMPORTED_MODULE_18__paymentAPIs__["a" /* default */].downloadCogsEstimateRpt(filters).then(function () {
        _this11.isLoading = false;
      }).catch(function (error) {
        _this11.isLoading = false;
        console.log('error in downloading cogs estimation report', error);
      });
    },
    getAllUsers: function getAllUsers() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_24__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH + ',' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW + ',' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH + ',' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW + ',' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST + ',' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.FINANCE + ',' + __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);

              case 2:
                response = _context5.sent;

                if (response) {
                  _this12.Users = response.users;
                  _this12.Users = _this12.Users.map(function (u) {
                    u.name = '' + u.firstName;
                    return u;
                  });
                  _this12.CCUsers = _this12.Users.filter(function (c) {
                    return c.role === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST;
                  });
                  _this12.CCUsers.unshift({
                    id: '',
                    name: 'All CC'
                  });
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this12);
      }))();
    },
    getTotalSummary: function getTotalSummary() {
      var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var currentYear = moment().format('YYYY');
      var matchMonths = shortMonths.map(function (m) {
        return m + ' ' + currentYear;
      });
      var revsForMonthYear = matchMonths.map(function (m) {
        return {
          month: m,
          totalAmt: 0
        };
      });

      this.filteredItems.map(function (item) {
        var createdMonth = moment(item.estimatedLiveDate).format('MMM YYYY');
        var revMYIdx = revsForMonthYear.findIndex(function (rev) {
          return rev.month === createdMonth;
        });
        if (revMYIdx !== -1) {
          if (item.sgdGstIncluded) {
            revsForMonthYear[revMYIdx].totalAmt += !isNaN(item.sgdGstIncluded) && item.sgdGstIncluded !== undefined && item.sgdGstIncluded !== 'undefined' ? Number(item.sgdGstIncluded || 0) : 0;
          } else {
            revsForMonthYear[revMYIdx].totalAmt += !isNaN(item.GSTExcludedAmt) && item.GSTExcludedAmt !== undefined && item.GSTExcludedAmt !== 'undefined' ? Number(item.GSTExcludedAmt || 0) : 0;
          }
        }
      });
      revsForMonthYear = revsForMonthYear.map(function (rm) {
        if (rm.totalAmt) {
          rm.totalAmt = Number(rm.totalAmt).toFixed(2);
        }
        return rm;
      });
      this.revsForMonthYear = revsForMonthYear;
    },
    formatYM: function formatYM(date) {
      return moment(date).format('YYYY-MM');
    },
    formatDMY: function formatDMY(date) {
      if (date.includes('00:00:00')) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    formatTitle: function formatTitle(date) {
      if (!date) return;
      return moment(date).format('MMM YYYY');
    },
    generateMonthArray: function generateMonthArray() {
      var monthArray = [];
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var startMonth = 12;
      for (var i = 0; i < 13; i++) {
        var year = i === 0 ? currentYear + 1 : currentYear;
        var month = (startMonth - i + 12) % 12 || 12;
        var monthString = year + '-' + month.toString().padStart(2, '0');
        monthArray.push({ month: monthString, data: [] });
      }

      monthArray.sort(function (a, b) {
        return b.month.localeCompare(a.month);
      });
      return monthArray;
    },
    openTotalSummaryModal: function openTotalSummaryModal(selectedCOGS) {
      this.selectedCOGS = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], selectedCOGS);
      this.totalSummaryDialog = true;
    }
  }
});

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecognizedRevenueModal',
  props: ['value', 'monthYearValues'],
  data: function data() {
    return {
      AMCC: [],
      selectedFilter: {
        AMCC: ''
      },
      headers: [{
        text: 'Month',
        value: 'month'
      }, {
        text: 'Total Amount',
        value: 'totalAmt'
      }],
      filteredMthYearVals: []
    };
  },

  computed: {
    currentYear: function currentYear() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY');
    },
    totalAmount: function totalAmount() {
      var total = 0;
      if (this.monthYearValues) {
        this.monthYearValues.map(function (m) {
          if (m.totalAmt) {
            total += parseFloat(m.totalAmt);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    },
    totalCogsAmount: function totalCogsAmount() {
      var total = 0;
      if (this.monthYearValues) {
        this.monthYearValues.map(function (m) {
          if (m.totalAmt) {
            total += parseFloat(m.totalAmt);
          }
        });
      }
      return parseFloat(total).toFixed(2);
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    selectedCOGS: Array
  },
  data: function data() {
    return {
      valid: true,
      isLoading: false,
      totalValues: {
        entries: 0,
        totalAmts: 0
      },
      currencyTotals: {},
      utilsFunc: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  })),
  watch: {
    selectedCOGS: function selectedCOGS(newSelectedCOGS) {
      var _this2 = this;

      this.totalValues = {
        entries: 0,
        totalAmts: 0
      };
      this.totalValues.entries = newSelectedCOGS.length;
      newSelectedCOGS.map(function (ns) {
        _this2.totalValues.totalAmts += Number(ns.sgdGstIncluded) || Number(ns.amount);
      });
      this.detectCurrency(newSelectedCOGS);
      this.totalValues.totalAmts = this.totalValues.totalAmts.toFixed(2);
    }
  },
  methods: {
    detectCurrency: function detectCurrency(items) {
      var _this3 = this;

      var currencies = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].currencies;
      currencies.map(function (c) {
        _this3.currencyTotals[c] = 0;
      });
      items.map(function (item) {
        if (item.currency !== 'SGD') {
          _this3.currencyTotals['SGD'] += Number(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.convertCurrency(item.currency, Number(item.GSTExcludedAmt) || Number(item.amount || 0), _this3.currencyRates));
          _this3.currencyTotals[item.currency] += Number(item.GSTExcludedAmt) || Number(item.amount || 0);
        } else {
          _this3.currencyTotals[item.currency] += Number(item.sgdGstIncluded) || Number(item.amount || 0);
        }
      });

      for (var currency in this.currencyTotals) {
        if (this.currencyTotals.hasOwnProperty(currency)) {
          if (this.currencyTotals[currency] > 0) {
            this.currencyTotals[currency] = this.currencyTotals[currency].toFixed(2);
          }
        }
      }
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cogs-estimate',
  components: {
    CogsEstimateDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_SocialHandleView__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_SocialHandleView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_SocialHandleView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Campaign_config__ = __webpack_require__(26);

























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_17_vue_loading_overlay___default.a,
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomFileUpload___default.a,
    SocialHandleView: __WEBPACK_IMPORTED_MODULE_19__components_scoped_custom_SocialHandleView___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8_vuelidate__["validationMixin"]],
  props: {
    value: Boolean,
    reports: Array,
    editData: Object,
    reportUpdate: Boolean
  },
  validations: function validations() {
    return this.rules;
  },
  data: function data() {
    return {
      payout: {
        bankAccountNo: null,
        receivingName: null,
        handle: null,
        bankSwiftCode: null,
        status: __WEBPACK_IMPORTED_MODULE_22__components_views_Campaign_config__["a" /* default */].paymentStatus.PROCESSING,
        campaign: null,
        bank_reference: '',
        payment_date: '',
        payment_submission_date: '',
        live_date: '',
        due_date: '',
        amount: '',
        remainAmt: '',
        paidAmt: '',
        processingAmt: '',
        chkGST: false,
        remarks: ''
      },
      pickDate: false,
      userCs: [],
      search: null,
      searchCs: null,
      campaigns: [],
      clients: [],
      influencers: [],
      searchClient: null,
      sales: [],
      invoiceFiles: [],
      fileUploadRefresh: 1,
      isLoading: false,
      isInvalidLiveDate: false,
      unPaidAmtErr: false,
      preProcessingPayments: [],
      importedPayments: [],
      formattedCompletedPayments: [],
      financePayments: [],
      utilsFunc: __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapState */])({
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])('payment', ['allowedStatuses', 'allowedStatusesForPayoutCreate', 'formatPreProcessingPayments', 'formatImportedPayments', 'formatCompletedPayments', 'formatFinancePayments', 'isPaymentConsolidationRecordMatch']), {
    rules: function rules() {
      var validationRules = {
        payout: {
          campaign: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          handle: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          status: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          amount: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          live_date: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          },
          due_date: {
            required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"]
          }
        }
      };

      if (this.isBankInfoRequired) {
        validationRules.payout.bankSwiftCode = { required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"] };
        validationRules.payout.bankAccountNo = { required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"] };
        validationRules.payout.receivingName = { required: __WEBPACK_IMPORTED_MODULE_9_vuelidate_lib_validators__["required"] };
      } else {
        validationRules.payout.bankSwiftCode = {};
        validationRules.payout.bankAccountNo = {};
        validationRules.payout.receivingName = {};
      }

      return validationRules;
    },
    selectedCampaignErrors: function selectedCampaignErrors() {
      var errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    bankNoErrors: function bankNoErrors() {
      var errors = [];
      if (this.isBankInfoRequired) {
        if (!this.$v.payout.bankAccountNo.$dirty) return errors;
        !this.$v.payout.bankAccountNo.required && errors.push('This field is required.');
      }
      return errors;
    },
    receivingNameErrors: function receivingNameErrors() {
      var errors = [];
      if (this.isBankInfoRequired) {
        if (!this.$v.payout.receivingName.$dirty) return errors;
        !this.$v.payout.receivingName.required && errors.push('This field is required.');
      }
      return errors;
    },
    handleErrors: function handleErrors() {
      var errors = [];
      if (!this.$v.payout.handle.$dirty) return errors;
      !this.$v.payout.handle.required && errors.push('This field is required.');
      return errors;
    },
    bankSwiftCodeErrors: function bankSwiftCodeErrors() {
      var errors = [];
      if (this.isBankInfoRequired) {
        if (!this.$v.payout.bankSwiftCode.$dirty) return errors;
        !this.$v.payout.bankSwiftCode.required && errors.push('This field is required.');
      }
      return errors;
    },
    csNameErrors: function csNameErrors() {
      var errors = [];
      if (!this.$v.payout.csName.$dirty) return errors;
      !this.$v.payout.csName.required && errors.push('This field is required.');
      return errors;
    },
    BIBREFErrors: function BIBREFErrors() {
      var errors = [];
      if (!this.$v.payout.BIBREF.$dirty) return errors;
      !this.$v.payout.BIBREF.required && errors.push('This field is required.');
      return errors;
    },
    FTREFErrors: function FTREFErrors() {
      var errors = [];
      if (!this.$v.payout.FTREF.$dirty) return errors;
      !this.$v.payout.FTREF.required && errors.push('This field is required.');
      return errors;
    },
    REFErrors: function REFErrors() {
      var errors = [];
      if (!this.$v.payout.REF.$dirty) return errors;
      !this.$v.payout.REF.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors: function amountErrors() {
      var errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    statusErrors: function statusErrors() {
      var errors = [];
      if (!this.$v.payout.status.$dirty) return errors;
      !this.$v.payout.status.required && errors.push('This field is required.');
      return errors;
    },
    bankRefErrors: function bankRefErrors() {
      var errors = [];
      if (!this.$v.payout.bank_reference.$dirty) return errors;
      !this.$v.payout.bank_reference.required && errors.push('This field is required.');
      return errors;
    },
    paymentDateErrors: function paymentDateErrors() {
      var errors = [];
      if (!this.$v.payout.payment_date.$dirty) return errors;
      !this.$v.payout.payment_date.required && errors.push('This field is required.');
      return errors;
    },
    paymentSubmissionDateErrors: function paymentSubmissionDateErrors() {
      var errors = [];
      if (!this.$v.payout.payment_submission_date.$dirty) return errors;
      !this.$v.payout.payment_submission_date.required && errors.push('This field is required.');
      return errors;
    },
    liveDateErrors: function liveDateErrors() {
      var errors = [];
      if (this.isSpecialPayment) {
        if (!this.$v.payout.live_date.$dirty) return errors;
        !this.$v.payout.live_date.required && errors.push('This field is required.');
      }
      return errors;
    },
    dueDateErrors: function dueDateErrors() {
      var errors = [];
      if (this.isSpecialPayment) {
        if (!this.$v.payout.due_date.$dirty) return errors;
        !this.$v.payout.due_date.required && errors.push('This field is required.');
      }
      return errors;
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isBankRef: function isBankRef() {
      return this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    isPaymentDate: function isPaymentDate() {
      return this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    isPaymentSubmissionDate: function isPaymentSubmissionDate() {
      return this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].userRoles.AD_STRATEGIST;
    },
    isBankInfoRequired: function isBankInfoRequired() {
      return this.payout.status === this.paymentStatuses.APPROVAL_FINANCE.value;
    },
    isSpecialPayment: function isSpecialPayment() {
      return this.payout.handle && this.payout.handle.specialPayment;
    },
    disableSavePayout: function disableSavePayout() {
      return this.$v.payout.$invalid || this.unPaidAmtErr || this.isInvalidLiveDate;
    }
  }),
  watch: {
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (newValue) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return this.fetchCampaigns();

              case 4:
                _context.next = 6;
                return this.fetchCSs();

              case 6:
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([this.fetchClient(), this.fetchSales(), this.fetchPreProcessingPayments(), this.fetchImportedPayments(), this.fetchCompletedPayments(), this.fetchFinancePayments()]);

              case 8:
                this.resetForm();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function value(_x) {
        return _ref.apply(this, arguments);
      }

      return value;
    }(),
    editData: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(newValue) {
        var _this = this;

        var campaign;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (newValue.update) {
                  this.payout.id = newValue.id;
                  this.payout.update = true;
                }

                if (this.campaigns.length) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.fetchCampaigns();

              case 4:
                campaign = this.campaigns.find(function (c) {
                  return c.id === newValue.campaignID;
                });

                this.payout.campaign = campaign;
                _context2.next = 8;
                return this.changeCampaign();

              case 8:
                this.payout.handle = this.influencers.find(function (i) {
                  return i.handle === _this.editData.instagram;
                });
                _context2.next = 11;
                return this.changeInfluencer();

              case 11:
                this.payout.live_date = this.editData.liveDate;
                this.payout.due_date = this.editData.dueDate;
                this.payout.amount = this.editData.amount;
                this.payout.bank_reference = this.editData.bankReference;
                this.payout.payment_date = this.editData.paymentDate || '';
                this.payout.payment_submission_date = this.editData.paymentSubmissionDate || '';
                this.payout.chkGST = this.editData.GST || false;
                this.payout.remarks = this.editData.remarks;
                this.payout.status = this.allowedStatusesForPayoutCreate.find(function (al) {
                  return al.status === _this.editData.paymentStatus;
                });
                if (!this.payout.bankSwiftCode && this.editData.swiftCode) {
                  this.payout.bankSwiftCode = this.editData.swiftCode || '';
                }
                if (!this.payout.bankAccountNo && this.editData.bankAccount) {
                  this.payout.bankAccountNo = this.editData.bankAccount || '';
                }
                if (!this.payout.receivingName && this.editData.fullName) {
                  this.payout.receivingName = this.editData.fullName || '';
                }

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editData(_x2) {
        return _ref2.apply(this, arguments);
      }

      return editData;
    }()
  },
  mounted: function mounted() {},

  methods: {
    close: function close() {
      this.$emit('input');
    },
    savePayout: function savePayout() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this2.isLoading = true;
                formData = _this2.constructData(_this2.payout);
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__["a" /* default */].savePaymentConsolidatedPayout(formData);

              case 5:
                _this2.fetchCompletedPayments();
                _this2.isLoading = false;
                _this2.$emit('created');
                _this2.$emit('input');
                _this2.$swal({
                  text: _this2.payout.id ? 'Successfully updated payout record' : 'New payout record is created',
                  type: 'success'
                });
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);
                _this2.$swal({
                  text: _context3.t0.message,
                  type: 'error'
                });

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 12]]);
      }))();
    },
    fetchCampaigns: function fetchCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data, campaigns;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__["a" /* default */].getPayoutCampaignPicker();

              case 3:
                data = _context4.sent;
                campaigns = data.campaigns;

                _this3.campaigns = campaigns.map(function (cmp) {
                  return {
                    name: cmp.ioNumbers ? cmp.ioNumbers + ' - ' + cmp.name : cmp.name,
                    id: cmp.id,
                    assignedTo: cmp.assignedTo,
                    clientID: cmp.clientID
                  };
                });
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);
                _this3.$swal({
                  text: 'Cannot fetch the list of campaigns',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[0, 8]]);
      }))();
    },
    filterClientByCampaigns: function filterClientByCampaigns(clientID) {
      var client = this.clients.find(function (cmp) {
        return cmp.id === clientID;
      });
      return client;
    },
    filterCsByCampaigns: function filterCsByCampaigns(campaignName) {
      if (!campaignName) return null;
      var userCampaign = this.campaigns.find(function (c) {
        return c.name === campaignName;
      });
      if (!userCampaign) return null;
      var cs = this.userCs.filter(function (user) {
        return userCampaign.assignedTo && userCampaign.assignedTo.find(function (item) {
          return user.id === item;
        });
      });
      return cs;
    },
    constructData: function constructData(input) {
      var formData = new FormData();
      var defaultCreateData = {
        imported: true,
        campaignID: input.campaign.id,
        pairingID: input.handle.pairingID || '',
        payment_status: input.status && input.status.status ? input.status.status : input.status,
        amount: input.amount ? Number(parseFloat(input.amount).toFixed(2)) : '',
        GST: input.chkGST,
        remarks: input.remarks
      };
      if (input.id && input.update) defaultCreateData.id = input.id;
      if (input.bank_reference) defaultCreateData.bank_reference = input.bank_reference;
      if (input.payment_date) defaultCreateData.payment_date = input.payment_date;
      if (input.invoices) defaultCreateData.invoices = input.invoices;
      if (input.live_date && this.isDateValid(input.live_date)) defaultCreateData.live_date = this.parseDate(input.live_date);
      if (input.due_date && this.isDateValid(input.due_date)) defaultCreateData.due_date = this.parseDate(input.due_date);
      var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        influencerID: input.handle.influencerID || '',
        handle: input.handle.handle,
        platform: input.handle.platform,
        swift_code: input.bankSwiftCode,
        bank_account: input.bankAccountNo,
        fullName: input.receivingName
      });
      var userCampaign = this.campaigns.find(function (c) {
        return c.id === input.campaign.id;
      });
      if (userCampaign) {
        if (Array.isArray(userCampaign.assignedTo)) {
          var cs = this.userCs.filter(function (user) {
            return userCampaign.assignedTo && userCampaign.assignedTo.find(function (item) {
              return user.id === item;
            });
          });
          defaultCreateData.CC = cs || [];
        }
      }
      data.defaultCreateData = defaultCreateData;
      formData.append('data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
      if (this.reportUpdate) formData.append('reportUpdate', true);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.invoiceFiles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('isInvoice', true);
          formData.append('uploadFile', val);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formData;
    },
    changeCampaign: function changeCampaign() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var newValue, resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.resetForm();
                newValue = _this4.payout.campaign;

                if (newValue && newValue.clientID) {
                  _this4.payout.client = _this4.filterClientByCampaigns(newValue.clientID);
                }

                if (!(newValue && newValue.name)) {
                  _context5.next = 16;
                  break;
                }

                _this4.payout.cs = _this4.filterCsByCampaigns(newValue.name);
                _context5.prev = 5;
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(newValue.id);

              case 8:
                resp = _context5.sent;

                _this4.setInfluencers(resp);
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](5);

                console.log(_context5.t0);
                _this4.$swal({
                  text: 'Cannot fetch the list of Influencers',
                  icon: 'error'
                });

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[5, 12]]);
      }))();
    },
    setInfluencers: function setInfluencers(resp) {
      resp = resp.filter(function (r) {
        if (r.pairing_details && r.pairing_details.status) {
          if (r.pairing_details.status === __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].pairingStatus.ACCEPTED) {
            return true;
          }
        }
        return false;
      });
      this.influencers = resp.map(function (pairing) {
        if (pairing.influencer_details) {
          var influencerDetails = pairing.influencer_details;
          var payoutDetails = pairing.payout_details;
          var specialPayment = false;
          if (pairing.pairing_details) {
            specialPayment = pairing.pairing_details.SpecialPaymentTerms || false;
          }
          var respData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
            pairingID: pairing.id,
            campaignID: pairing.campaignID,
            influencerID: influencerDetails.influencerID || '',
            handle: influencerDetails.instagramHandle,
            platform: influencerDetails.platform || 'instagram',
            amount: payoutDetails.amount || 0,
            currency: payoutDetails.currency || 'SGD',
            specialPayment: specialPayment
          });

          return respData;
        }
      });
    },
    calcPaidAmt: function calcPaidAmt(campaignID, handle, influencerID) {
      var _this5 = this;

      var usedAmts = 0;
      var actualAmount = 0;
      var completedCurrency = 'SGD';
      this.formattedCompletedPayments.map(function (rpt) {
        if (_this5.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0);
          completedCurrency = rpt.currency;
          actualAmount = rpt.actualAmount || 0;
        }
      });
      return {
        usedAmts: usedAmts,
        completedCurrency: completedCurrency,
        actualAmount: actualAmount
      };
    },
    calcProcessingAmt: function calcProcessingAmt(campaignID, handle, amt, influencerID) {
      var _this6 = this;

      var usedAmts = 0;
      this.preProcessingPayments.map(function (rpt) {
        if (rpt.imported && _this6.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0);
        }
      });
      this.importedPayments.map(function (rpt) {
        if (_this6.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0);
        }
      });
      this.financePayments.map(function (rpt) {
        if (_this6.isPaymentConsolidationRecordMatch(rpt, campaignID, handle, influencerID)) {
          usedAmts += Number(rpt.amount || 0);
        }
      });
      return usedAmts.toFixed(2);
    },
    changeInfluencer: function changeInfluencer() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var completedPaymentObj, convertedPaidAmt, convertedEstAmt, sgdPaidAmt, resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.payout.bankSwiftCode = null;
                _this7.payout.bankAccountNo = null;
                _this7.payout.receivingName = null;
                _this7.payout.remainAmt = 0;
                _this7.payout.currency = 'SGD';
                _this7.payout.status = _this7.paymentStatuses.PROCESSING.value;
                if (_this7.payout.handle) {
                  _this7.payout.processingAmt = _this7.calcProcessingAmt(_this7.payout.handle.campaignID || '', _this7.payout.handle.handle, null, _this7.payout.handle.influencerID);
                  _this7.payout.currency = _this7.payout.handle.currency;
                  completedPaymentObj = _this7.calcPaidAmt(_this7.payout.handle.campaignID || '', _this7.payout.handle.handle, _this7.payout.handle.influencerID);

                  _this7.payout.completedCurrency = '';
                  _this7.payout.actualAmount = 0;
                  if (completedPaymentObj) {
                    _this7.payout.completedCurrency = completedPaymentObj.completedCurrency;
                    _this7.payout.paidAmt = completedPaymentObj.usedAmts;
                    _this7.payout.actualAmount = completedPaymentObj.actualAmount;
                  }
                  convertedPaidAmt = 0;

                  if (_this7.payout.currency) {
                    if (_this7.payout.currency !== 'SGD') {
                      convertedPaidAmt = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.convertCurrency(_this7.payout.currency, _this7.payout.paidAmt, _this7.currencyRates);
                    } else {
                      convertedPaidAmt = _this7.payout.paidAmt;
                    }
                  } else {
                    convertedPaidAmt = _this7.payout.paidAmt;
                  }
                  _this7.payout.convertedPaidAmt = convertedPaidAmt;
                  convertedEstAmt = 0;

                  if (_this7.payout.completedCurrency) {
                    if (_this7.payout.completedCurrency === 'SGD') {
                      convertedEstAmt = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.convertOtherCurrency(_this7.payout.currency, _this7.payout.paidAmt, _this7.currencyRates);
                    } else {
                      convertedEstAmt = _this7.payout.paidAmt;
                    }
                  } else {
                    convertedEstAmt = _this7.payout.paidAmt;
                  }
                  _this7.payout.convertedPaidAmt = convertedPaidAmt;
                  _this7.payout.convertedEstAmt = convertedEstAmt;
                  if (_this7.payout.currency) {
                    if (_this7.payout.currency === 'SGD') {
                      if (_this7.payout.completedCurrency !== 'SGD') {
                        sgdPaidAmt = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.convertCurrency(_this7.payout.completedCurrency, _this7.payout.convertedEstAmt, _this7.currencyRates);

                        _this7.payout.remainAmt = (Number(_this7.payout.handle.amount) - (Number(_this7.payout.processingAmt) + Number(sgdPaidAmt))).toFixed(2);
                      } else {
                        _this7.payout.remainAmt = (Number(_this7.payout.handle.amount) - (Number(_this7.payout.processingAmt) + Number(convertedPaidAmt))).toFixed(2);
                      }
                    } else {
                      _this7.payout.remainAmt = (Number(_this7.payout.handle.amount) - (Number(_this7.payout.processingAmt) + Number(convertedEstAmt))).toFixed(2);
                    }
                  }
                  _this7.payout.currency = _this7.payout.handle.currency || 'SGD';
                }

                if (!(_this7.payout.handle && _this7.payout.handle.influencerID)) {
                  _context6.next = 21;
                  break;
                }

                _context6.prev = 8;
                _context6.next = 11;
                return __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__["a" /* default */].getInfluencer(_this7.payout.handle.influencerID);

              case 11:
                resp = _context6.sent;

                if (!_this7.payout.bankSwiftCode) {
                  _this7.payout.bankSwiftCode = resp.swiftCode || '';
                }
                if (!_this7.payout.bankAccountNo) {
                  _this7.payout.bankAccountNo = resp.bankAccount || '';
                }
                if (!_this7.payout.receivingName) {
                  _this7.payout.receivingName = resp.fullName || '';
                }
                _context6.next = 21;
                break;

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6['catch'](8);

                console.log(_context6.t0);
                _this7.$swal({
                  text: 'Cannot fetch Influencer Data',
                  icon: 'error'
                });

              case 21:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[8, 17]]);
      }))();
    },
    fetchCSs: function fetchCSs() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var resp, users;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 3:
                resp = _context7.sent;
                users = resp.users;

                _this8.userCs = users.map(function (user) {
                  return {
                    name: user.firstName + ' ' + user.lastName,
                    id: user.id
                  };
                });
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](0);

                console.log(_context7.t0);
                _this8.$swal({
                  text: 'Cannot fetch the list of CS',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 8]]);
      }))();
    },
    fetchClient: function fetchClient() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var resp, clients;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__["a" /* default */].getAllClients(true);

              case 3:
                resp = _context8.sent;
                clients = resp.data;

                _this9.clients = clients.map(function (user) {
                  return {
                    name: user.name,
                    id: user.id
                  };
                });
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);
                _this9.$swal({
                  text: 'Cannot fetch the list of clients',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[0, 8]]);
      }))();
    },
    fetchSales: function fetchSales() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var resp, users;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW);

              case 3:
                resp = _context9.sent;
                users = resp.users;

                _this10.sales = users.map(function (user) {
                  return {
                    id: user.id,
                    name: user.firstName + ' ' + user.lastName
                  };
                });
                _context9.next = 12;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9['catch'](0);

                console.log(_context9.t0);
                _this10.$swal({
                  text: 'Cannot fetch the list of CS',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[0, 8]]);
      }))();
    },
    resetForm: function resetForm() {
      this.payout.bankAccountNo = null;
      this.payout.receivingName = null;
      this.payout.handle = null;
      this.payout.bankSwiftCode = null;
      this.payout.status = __WEBPACK_IMPORTED_MODULE_22__components_views_Campaign_config__["a" /* default */].paymentStatus.PROCESSING;
      this.payout.bank_reference = '';
      this.payout.payment_date = '';
      this.payout.payment_submission_date = '';
      this.payout.live_date = '';
      this.payout.due_date = '';
      this.payout.amount = '';
      this.payout.remainAmt = '';
      this.payout.paidAmt = '';
      this.payout.processingAmt = '';
      this.influencers = [];
      this.invoiceFiles = [];
      this.fileUploadRefresh += 1;
    },
    updateInvoices: function updateInvoices(medias) {
      this.invoiceFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], medias);
    },
    changeLiveDate: function changeLiveDate() {
      this.$v.payout.live_date.$touch();
      this.isInvalidLiveDate = false;
      this.payout.due_date = '';
      if (!this.isDateValid(this.payout.live_date)) {
        this.isInvalidLiveDate = true;
        return;
      }
      var dueDate = this.payout.live_date ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.parseDate(this.payout.live_date)).add(30, 'days').format('YYYY-MM-DD') : '';
      dueDate = this.formatDate(dueDate);
      this.payout.due_date = dueDate;
    },
    checkUnpaidAmount: function checkUnpaidAmount() {
      this.$v.payout.amount.$touch();
      this.unPaidAmtErr = false;
      if (Number(this.payout.remainAmt) < Number(this.payout.amount)) {
        this.unPaidAmtErr = true;
      }
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split = date.split('/'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          day = _date$split2[0],
          month = _date$split2[1],
          year = _date$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          year = _date$split4[0],
          month = _date$split4[1],
          day = _date$split4[2];

      var formattedDate = day + '/' + month + '/' + year;
      if (formattedDate.includes('undefined')) {
        return date;
      }
      return formattedDate;
    },
    isDateValid: function isDateValid(givenDate) {
      if (!givenDate) return true;
      var regex = __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].regexPattern.date_format;
      if (givenDate.match(regex)) return true;
      return false;
    },
    fetchCompletedPayments: function fetchCompletedPayments() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this11.$store.dispatch('payment/getCompletedPayments', {});

              case 2:
                _this11.formattedCompletedPayments = _this11.formatCompletedPayments(_this11.userCs);

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    fetchPreProcessingPayments: function fetchPreProcessingPayments() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this12.$store.dispatch('payment/getPreProcessingPayments', {});

              case 2:
                _this12.preProcessingPayments = _this12.formatPreProcessingPayments(_this12.userCs);

              case 3:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },
    fetchImportedPayments: function fetchImportedPayments() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this13.$store.dispatch('payment/getImportedPayments', {});

              case 2:
                _this13.importedPayments = _this13.formatImportedPayments(_this13.userCs);

              case 3:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this13);
      }))();
    },
    fetchFinancePayments: function fetchFinancePayments() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this14.$store.dispatch('payment/getFinancePayments', {});

              case 2:
                _this14.financePayments = _this14.formatFinancePayments(_this14.userCs);

              case 3:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this14);
      }))();
    },
    refreshPairingInfs: function refreshPairingInfs() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, inf;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context14.prev = 3;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this15.influencers);

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context14.next = 13;
                  break;
                }

                inf = _step2.value;

                if (!inf.influencerID) {
                  _context14.next = 10;
                  break;
                }

                _context14.next = 10;
                return __WEBPACK_IMPORTED_MODULE_13__Pairing_pairingAPIs__["a" /* default */].refreshInfluencerDetails({ ighandle: inf.handle, campaignID: inf.campaignID, platform: inf.platform.toLowerCase(), pairingID: inf.pairingID });

              case 10:
                _iteratorNormalCompletion2 = true;
                _context14.next = 5;
                break;

              case 13:
                _context14.next = 19;
                break;

              case 15:
                _context14.prev = 15;
                _context14.t0 = _context14['catch'](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context14.t0;

              case 19:
                _context14.prev = 19;
                _context14.prev = 20;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 22:
                _context14.prev = 22;

                if (!_didIteratorError2) {
                  _context14.next = 25;
                  break;
                }

                throw _iteratorError2;

              case 25:
                return _context14.finish(22);

              case 26:
                return _context14.finish(19);

              case 27:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this15, [[3, 15, 19, 27], [20,, 22, 26]]);
      }))();
    }
  }
});

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);














/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  props: {
    value: Boolean,
    mode: {
      type: String,
      default: 'new'
    },
    data: Object
  },
  validations: {
    payment: {
      customer: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      }
    }
  },
  data: function data() {
    return {
      payment: {
        customer: null,
        referenceNo: null,
        voucherNo: null,
        description: null,
        debit: null,
        credit: null,
        date: null,
        remarks: null,
        IOQuoteNo: null,
        invoiceNo: null,
        salePerson: null
      },
      pickDate: false,
      userCs: [],
      sales: [],
      search: null,
      searchSale: null,
      searchCampaign: null,
      searchClient: null,
      campaigns: [],
      filteredCampaigns: [],
      clients: []
    };
  },

  computed: {
    customerErrors: function customerErrors() {
      var errors = [];
      if (!this.$v.payment.customer.$dirty) return errors;
      !this.$v.payment.customer.required && errors.push(' This field is required.');
      return errors;
    },
    referenceNoErrors: function referenceNoErrors() {
      var errors = [];
      if (!this.$v.payment.referenceNo.$dirty) return errors;
      !this.$v.payment.referenceNo.required && errors.push('This field is required.');
      return errors;
    },
    ioQuoteNoErrors: function ioQuoteNoErrors() {
      var errors = [];
      if (!this.$v.payment.IOQuoteNo.$dirty) return errors;
      !this.$v.payment.IOQuoteNo.required && errors.push('This field is required.');
      return errors;
    },
    campaignStatus: function campaignStatus() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignStatus).join();
    }
  },
  mounted: function mounted() {
    this.fetchSales();
    this.fetchClient();
    this.fetchCampaigns();
  },

  watch: {
    data: function data(newValue) {
      if (newValue.campaign && !newValue.campaign.id) {
        newValue.campaign = newValue.campaign.name;
      }
      this.payment = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, newValue);
    },

    'payment.customer': function paymentCustomer(newValue) {
      if ((typeof newValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(newValue)) === 'object' && newValue.id) {
        this.filteredCampaigns = this.filterCampaignByClient(newValue.id);
      } else {
        this.filteredCampaigns = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.campaignsFF);
      }
    }
  },
  methods: {
    doAction: function doAction() {
      switch (this.mode) {
        case 'new':
          this.create();
          break;
        case 'edit':
          this.update();
          break;
      }
    },
    fetchSales: function fetchSales() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, users;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW);

              case 3:
                resp = _context.sent;
                users = resp.users;

                _this.sales = users.map(function (user) {
                  return {
                    id: user.id,
                    name: user.firstName + ' ' + user.lastName
                  };
                });
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this.$swal({
                  text: 'Cannot fetch the list of CS',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    fetchClient: function fetchClient() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resp, clients;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__Client_clientAPIs__["a" /* default */].getAllClients(true);

              case 3:
                resp = _context2.sent;
                clients = resp.data;

                _this2.clients = clients.map(function (user) {
                  return {
                    name: user.name,
                    id: user.id
                  };
                });
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                _this2.$swal({
                  text: 'Cannot fetch the list of clients',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    filterCampaignByClient: function filterCampaignByClient(clientID) {
      var campaigns = this.campaigns.filter(function (cmp) {
        return cmp.clientID === clientID;
      });
      return campaigns;
    },
    fetchCampaigns: function fetchCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, campaigns;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__["a" /* default */].paginate({});

              case 3:
                resp = _context3.sent;
                campaigns = resp.campaigns;

                _this3.campaigns = campaigns.map(function (cmp) {
                  return {
                    name: cmp.name,
                    id: cmp.id,
                    clientID: cmp.clientID
                  };
                });
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                _this3.$swal({
                  text: 'Cannot fetch the list of clients',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8]]);
      }))();
    },
    close: function close() {
      this.$emit('input');
    },
    constructData: function constructData(input) {
      var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, input);
      if (typeof data.customer === 'string') {
        data.customer = {
          name: data.customer
        };
      }
      if (typeof data.campaign === 'string') {
        data.campaign = {
          name: data.campaign
        };
      }
      return data;
    },
    create: function create() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                data = _this4.constructData(_this4.payment);
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__paymentAPIs__["a" /* default */].createPaymentOrReceipt(data);

              case 4:
                _this4.$swal({
                  text: 'New payment record is created',
                  type: 'success'
                });
                _this4.$emit('created');
                _this4.$emit('input');
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);
                _this4.$swal({
                  text: _context4.t0.message,
                  type: 'error'
                });

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    update: function update() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                data = _this5.constructData(_this5.payment);
                id = data.id;

                if (id) {
                  _context5.next = 6;
                  break;
                }

                _this5.$swal({
                  text: 'Record id not found',
                  type: 'warning'
                });
                return _context5.abrupt('return');

              case 6:
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_7__paymentAPIs__["a" /* default */].updatePaymentOrReceipt(id, data);

              case 8:
                _this5.$swal({
                  text: 'New payment record is updated',
                  type: 'success'
                });
                _this5.$emit('created');
                _this5.$emit('input');
                _context5.next = 17;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](0);

                console.error(_context5.t0);
                _this5.$swal({
                  text: _context5.t0.message,
                  type: 'error'
                });

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 13]]);
      }))();
    }
  }
});

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vuelidate__["validationMixin"]],
  props: {
    value: Boolean,
    mode: {
      type: String,
      default: 'new'
    },
    data: Object
  },
  validations: {
    payout: {
      campaign: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      },
      bankAccountNo: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      },
      receivingName: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      },
      instagramHandle: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      },
      approvalDate: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      },
      amount: {
        required: __WEBPACK_IMPORTED_MODULE_5_vuelidate_lib_validators__["required"]
      }
    }
  },
  data: function data() {
    return {
      payout: {
        bankAccountNo: null,
        csName: null,
        receivingName: null,
        instagramHandle: null,
        BIBREF: null,
        FTREF: null,
        bankSwiftCode: null,
        REF: null,
        status: null,
        billingContact: null,
        campaign: null,
        approvalDate: null,
        amount: null
      },
      pickDate: false,
      userCs: [],
      search: null,
      searchCs: null,
      campaigns: [],
      clients: [],
      searchClient: null,
      sales: [],
      statuses: ['APPROVED', 'PENDING APPROVAL', 'ON_HOLD', 'REJECTED']
    };
  },

  watch: {
    data: function data(newValue) {
      this.payout = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, newValue);
      if (newValue.cs) {
        console.log(newValue.cs);
        newValue.cs = newValue.cs.map(function (e) {
          if (e && !e.id) {
            e = e.name;
          }
          console.log(e);
          return e;
        });
      }
    },
    'payout.campaign': function payoutCampaign(newValue) {
      if (newValue && newValue.clientID) {
        this.payout.client = this.filterClientByCampaigns(newValue.clientID);
      }
      if (newValue && newValue.name) {
        if (!this.payout.id) {
          this.payout.cs = this.filterCsByCampaigns(newValue.name);
        }
      }
    }
  },
  computed: {
    selectedCampaignErrors: function selectedCampaignErrors() {
      var errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    bankNoErrors: function bankNoErrors() {
      var errors = [];
      if (!this.$v.payout.bankAccountNo.$dirty) return errors;
      !this.$v.payout.bankAccountNo.required && errors.push('This field is required.');
      return errors;
    },
    receivingNameErrors: function receivingNameErrors() {
      var errors = [];
      if (!this.$v.payout.receivingName.$dirty) return errors;
      !this.$v.payout.receivingName.required && errors.push('This field is required.');
      return errors;
    },
    instagramHandleErrors: function instagramHandleErrors() {
      var errors = [];
      if (!this.$v.payout.instagramHandle.$dirty) return errors;
      !this.$v.payout.instagramHandle.required && errors.push('This field is required.');
      return errors;
    },
    csNameErrors: function csNameErrors() {
      var errors = [];
      if (!this.$v.payout.csName.$dirty) return errors;
      !this.$v.payout.csName.required && errors.push('This field is required.');
      return errors;
    },
    BIBREFErrors: function BIBREFErrors() {
      var errors = [];
      if (!this.$v.payout.BIBREF.$dirty) return errors;
      !this.$v.payout.BIBREF.required && errors.push('This field is required.');
      return errors;
    },
    FTREFErrors: function FTREFErrors() {
      var errors = [];
      if (!this.$v.payout.FTREF.$dirty) return errors;
      !this.$v.payout.FTREF.required && errors.push('This field is required.');
      return errors;
    },
    REFErrors: function REFErrors() {
      var errors = [];
      if (!this.$v.payout.REF.$dirty) return errors;
      !this.$v.payout.REF.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors: function amountErrors() {
      var errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    campaignStatus: function campaignStatus() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].campaignStatus).join();
    }
  },
  mounted: function mounted() {
    this.fetchCampaigns();
    this.fetchCSs();
    this.fetchClient();
    this.fetchSales();
  },

  methods: {
    doAction: function doAction() {
      switch (this.mode) {
        case 'new':
          this.create();
          break;
        case 'edit':
          this.update();
          break;
      }
    },
    close: function close() {
      this.$emit('input');
    },
    create: function create() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = _this.constructData(_this.payout);
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__paymentAPIs__["a" /* default */].createPayout(data);

              case 4:
                _this.$emit('created');
                _this.$emit('input');
                _this.$swal({
                  text: 'New payout record is created',
                  type: 'success'
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this.$swal({
                  text: _context.t0.message,
                  type: 'error'
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    update: function update() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, id;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = _this2.constructData(_this2.payout);
                id = data.id;

                if (id) {
                  _context2.next = 6;
                  break;
                }

                _this2.$swal({
                  text: 'Record id not found',
                  type: 'warning'
                });
                return _context2.abrupt('return');

              case 6:
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__paymentAPIs__["a" /* default */].updatePayout(id, data);

              case 8:
                _this2.$swal({
                  text: 'Updated!',
                  type: 'success'
                });
                _this2.$emit('created');
                _this2.$emit('input');
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);
                _this2.$swal({
                  text: _context2.t0.message,
                  type: 'error'
                });

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 13]]);
      }))();
    },
    fetchCampaigns: function fetchCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, data, campaigns;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__["a" /* default */].getAllCampaigns(_this3.campaignStatus, false);

              case 3:
                resp = _context3.sent;
                data = resp.data;
                campaigns = data.campaigns;

                _this3.campaigns = campaigns.map(function (cmp) {
                  return {
                    name: cmp.name,
                    id: cmp.id,
                    assignedTo: cmp.assignedTo,
                    clientID: cmp.clientID
                  };
                });
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                _this3.$swal({
                  text: 'Cannot fetch the list of campaigns',
                  icon: 'error'
                });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    filterClientByCampaigns: function filterClientByCampaigns(clientID) {
      var client = this.clients.find(function (cmp) {
        return cmp.id === clientID;
      });
      return client;
    },
    filterCsByCampaigns: function filterCsByCampaigns(campaignName) {
      if (!campaignName) return null;
      var userCampaign = this.campaigns.find(function (c) {
        return c.name === campaignName;
      });
      if (!userCampaign) return null;
      var cs = this.userCs.filter(function (user) {
        return userCampaign.assignedTo && userCampaign.assignedTo.find(function (item) {
          return user.id === item;
        });
      });
      return cs;
    },
    constructData: function constructData(input) {
      var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, input);
      if (data.cs) {
        data.cs = data.cs.map(function (element) {
          if (typeof element === 'string') {
            element = {
              name: element
            };
          }
          return element;
        });
      }

      if (typeof data.campaign === 'string') {
        data.campaign = {
          name: data.campaign
        };
      }
      if (typeof data.client === 'string') {
        data.client = {
          name: data.client
        };
      }
      return data;
    },
    fetchCSs: function fetchCSs() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp, users;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 3:
                resp = _context4.sent;
                users = resp.users;

                _this4.userCs = users.map(function (user) {
                  return {
                    name: user.firstName + ' ' + user.lastName,
                    id: user.id
                  };
                });
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);
                _this4.$swal({
                  text: 'Cannot fetch the list of CS',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8]]);
      }))();
    },
    fetchClient: function fetchClient() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var resp, clients;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__Client_clientAPIs__["a" /* default */].getAllClients(true);

              case 3:
                resp = _context5.sent;
                clients = resp.data;

                _this5.clients = clients.map(function (user) {
                  return {
                    name: user.name,
                    id: user.id
                  };
                });
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);
                _this5.$swal({
                  text: 'Cannot fetch the list of clients',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8]]);
      }))();
    },
    fetchSales: function fetchSales() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var resp, users;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW);

              case 3:
                resp = _context6.sent;
                users = resp.users;

                _this6.sales = users.map(function (user) {
                  return {
                    id: user.id,
                    name: user.firstName + ' ' + user.lastName
                  };
                });
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0);
                _this6.$swal({
                  text: 'Cannot fetch the list of CS',
                  icon: 'error'
                });

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 8]]);
      }))();
    }
  }
});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__charts_LineChart__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreatePaymentRecordModal__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreatePaymentRecordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CreatePaymentRecordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TotalNumber__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TotalNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TotalNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_6__charts_LineChart__["a" /* default */],
    TotalNumber: __WEBPACK_IMPORTED_MODULE_8__TotalNumber___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a,
    CreatePaymentRecord: __WEBPACK_IMPORTED_MODULE_7__CreatePaymentRecordModal___default.a
  },
  data: function data() {
    return {
      mode: 'new',
      data: null,
      thisWeek: null,
      thisMonth: null,
      searchKeyWords: null,
      selectDateModal: false,
      createPayoutModal: false,
      totalThisMonth: 0,
      totalThisWeek: 0,
      totalDiscount: 0,
      totalAmount: 0,
      totalItems: 0,
      isLoading: false,
      menus: [{ title: 'Edit', value: 'edit' }, { title: 'Delete', value: 'delete' }],
      dates: [],
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 10
      },
      items: [],
      headers: [{
        text: 'Date',
        value: 'date',
        sortable: false
      }, {
        text: 'Supplier/Customer',
        value: 'customerName',
        sortable: false
      }, {
        text: 'Reference No.',
        value: 'referenceNo',
        sortable: false
      }, {
        text: 'I/O Quote No.',
        value: 'IOQuoteNo',
        sortable: false
      }, {
        text: 'Voucher No.',
        value: 'voucherNo',
        sortable: false
      }, {
        text: 'Description',
        value: 'description',
        sortable: false
      }, {
        text: 'Debit',
        value: 'debit',
        sortable: false
      }, {
        text: 'Credit',
        value: 'credit',
        sortable: false
      }, {
        text: 'Remarks',
        value: 'remarks',
        sortable: false
      }, {
        text: 'Actions',
        value: 'actions'
      }],
      campaigns: [],
      totalCampaigns: 0
    };
  },

  watch: {
    pagging: function pagging(newValue) {
      console.log(newValue);
      this.findAll(newValue);
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    dateRangeText: function dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  methods: {
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */]['userPermissions']['financial'][type];

      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }

      return false;
    },
    perpareImport: function perpareImport(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var uploadedFiles, file, formData, result, total, created;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context.next = 4;
                  break;
                }

                _this.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context.abrupt('return');

              case 4:
                file = uploadedFiles[0];
                formData = new FormData();

                formData.append('income', file);
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].importPaymentRecords(formData);

              case 9:
                result = _context.sent;
                total = result.totalRecords || 0;
                created = result.created || 0;

                _this.$swal({
                  type: 'success',
                  title: 'Import successfully',
                  text: created + '/' + total + ' records were uploaded!'
                });
                _this.refresh();

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    create: function create() {
      this.createPayoutModal = true;
      this.mode = 'new';
      this.data = null;
    },
    edit: function edit(item) {
      this.createPayoutModal = true;
      this.mode = 'edit';
      this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
    },
    doAction: function doAction(action, item) {
      switch (action) {
        case 'edit':
          this.edit(item);
          break;
        case 'delete':
          this.delete(item);
          break;
        default:
          return;
      }
    },
    delete: function _delete(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var id, result, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (item) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                id = item.id;
                _context2.next = 6;
                return _this2.$swal({
                  icon: 'warning',
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!'
                });

              case 6:
                result = _context2.sent;

                if (!result.value) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].deletePaymentRecords(id);

              case 10:
                _this2.refresh();
                _this2.$swal({
                  icon: 'success',
                  text: 'Deleted!'
                });

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);
                message = _context2.t0.message || 'Cannot delete this item';

                _this2.$swal({
                  icon: 'error',
                  text: message
                });

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 14]]);
      }))();
    },
    filter: function filter() {
      var keywords = this.searchKeyWords;
      if (!keywords) return;
      this.findAll({ q: keywords });
    },
    refresh: function refresh() {
      this.findAll();
      this.getSummary();
    },
    getSummary: function getSummary() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, data, week;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.isLoading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].getPaymentOrReceiptSummary();

              case 4:
                resp = _context3.sent;

                if (resp.success) {
                  data = resp.data;

                  _this3.totalThisMonth = data.totalThisMonth;
                  _this3.totalThisWeek = data.totalThisWeek;
                  _this3.totalAmount = data.totalIncome;
                  _this3.totalDiscount = data.totalDiscount;
                  week = data.week || {};

                  _this3.thisWeek = week.startTime + ' to ' + week.endTime;
                  _this3.thisMonth = data.month;
                  _this3.totalItems = data.totalItems;
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 11:
                _context3.prev = 11;

                _this3.isLoading = false;
                return _context3.finish(11);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8, 11, 14]]);
      }))();
    },
    findAll: function findAll() {
      var _this4 = this;

      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].getPaymentRecords(filter);

              case 4:
                resp = _context4.sent;

                if (!resp.success) {
                  _context4.next = 10;
                  break;
                }

                data = resp.data;

                if (data.incomes) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt('return');

              case 9:
                _this4.items = data.incomes.map(function (item) {
                  item.customerName = item.customer ? item.customer.name : '';
                  return item;
                });

              case 10:
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 15:
                _context4.prev = 15;

                _this4.isLoading = false;
                return _context4.finish(15);

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 12, 15, 18]]);
      }))();
    },
    payoutCreated: function payoutCreated() {
      this.refresh();
    }
  },
  mounted: function mounted() {
    this.getSummary();
  }
});

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__charts_LineChart__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreatePayoutRecordModal__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreatePayoutRecordModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CreatePayoutRecordModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TotalNumber__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TotalNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TotalNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_6__charts_LineChart__["a" /* default */],
    TotalNumber: __WEBPACK_IMPORTED_MODULE_8__TotalNumber___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a,
    CreatePayoutRecord: __WEBPACK_IMPORTED_MODULE_7__CreatePayoutRecordModal___default.a
  },
  data: function data() {
    return {
      thisWeek: null,
      thisMonth: null,
      mode: 'new',
      data: null,
      menus: [{ title: 'Edit', value: 'edit' }, { title: 'Delete', value: 'delete' }],
      searchKeyWords: null,
      selectDateModal: false,
      createPayoutModal: false,
      totalThisMonth: 0,
      totalThisWeek: 0,
      totalAmount: 0,
      totalItems: 0,
      isLoading: false,
      dates: [],
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 10
      },
      items: [],
      headers: [{
        text: 'Received Name',
        value: 'receivingName',
        sortable: false
      }, {
        text: 'Instagram/TikTok Handle',
        value: 'handle',
        sortable: false
      }, {
        text: 'CS Name',
        value: 'csName',
        sortable: false
      }, {
        text: 'Amount',
        value: 'amount',
        sortable: false
      }, {
        text: 'Campaign',
        value: 'campaignName',
        sortable: false
      }, {
        text: 'REF',
        value: 'REF',
        sortable: false
      }, {
        text: 'Status',
        value: 'status',
        sortable: false
      }, {
        text: 'Approval Date',
        value: 'approvalDate',
        sortable: false
      }, {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }],
      campaigns: [],
      totalCampaigns: 0,
      statuses: ['APPROVED', 'PENDING APPROVAL', 'ON_HOLD', 'REJECTED'],
      createdIds: [],
      updatedIds: []
    };
  },

  watch: {
    pagging: function pagging(newValue) {
      this.findAll(newValue);
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    dateRangeText: function dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  methods: {
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */]['userPermissions']['financial'][type];

      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.campaignStatus.includes(this.campaignStatus);
      }

      return false;
    },
    perpareImport: function perpareImport(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var uploadedFiles, file, formData, result, total, created, updated, html;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context.next = 4;
                  break;
                }

                _this.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context.abrupt('return');

              case 4:
                file = uploadedFiles[0];
                formData = new FormData();

                formData.append('outcome', file);
                _this.isLoading = true;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].importPaymoutRecords(formData);

              case 10:
                result = _context.sent;

                _this.isLoading = false;
                total = result.totalRecords || 0;
                created = result.created || 0;
                updated = result.updated || 0;
                html = '';

                _this.createdIds = [];
                _this.updatedIds = [];
                if (created.length > 0) {
                  _this.createdIds = created.map(function (c) {
                    return c.id;
                  });
                  html += created.length + '/' + total + ' records were created!<br>';
                }
                if (updated.length > 0) {
                  _this.updatedIds = updated.map(function (u) {
                    return u.id;
                  });
                  html += updated.length + '/' + total + ' records were updated!';
                }
                _this.$swal({
                  type: 'success',
                  title: 'Import successfully',
                  html: html
                });
                _this.refresh();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    create: function create() {
      this.createPayoutModal = true;
      this.mode = 'new';
      this.data = null;
    },
    edit: function edit(item) {
      this.createPayoutModal = true;
      this.mode = 'edit';
      this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
    },
    doAction: function doAction(action, item) {
      switch (action) {
        case 'edit':
          this.edit(item);
          break;
        case 'delete':
          this.delete(item);
          break;
        default:
          return;
      }
    },
    delete: function _delete(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var id, result, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (item) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                id = item.id;
                _context2.next = 6;
                return _this2.$swal({
                  icon: 'warning',
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!'
                });

              case 6:
                result = _context2.sent;

                if (!result.value) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].deletePayoutRecords(id);

              case 10:
                _this2.refresh();
                _this2.$swal({
                  icon: 'success',
                  text: 'Deleted!'
                });

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);
                message = _context2.t0.message || 'Cannot delete this item';

                _this2.$swal({
                  icon: 'error',
                  text: message
                });

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 14]]);
      }))();
    },
    filter: function filter() {
      var keywords = this.searchKeyWords;
      if (!keywords) {
        this.findAll();return;
      }
      this.findAll({ q: keywords });
    },
    refresh: function refresh() {
      this.findAll();
      this.getSummary();
      this.$refs.outcome.value = null;
    },
    getSummary: function getSummary() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var resp, data, week;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.isLoading = true;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].getSummary();

              case 4:
                resp = _context3.sent;

                if (resp.success) {
                  data = resp.data;

                  _this3.totalThisMonth = data.totalThisMonth;
                  _this3.totalThisWeek = data.totalThisWeek;
                  _this3.totalAmount = data.totalPayout;
                  _this3.totalItems = data.totalItems;
                  week = data.week || {};

                  _this3.thisWeek = week.startTime + ' to ' + week.endTime;
                  _this3.thisMonth = data.month;
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 11:
                _context3.prev = 11;

                _this3.isLoading = false;
                return _context3.finish(11);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8, 11, 14]]);
      }))();
    },
    findAll: function findAll() {
      var _this4 = this;

      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].getPayouts(filter);

              case 4:
                resp = _context4.sent;

                if (resp.success) {
                  data = resp.data;

                  _this4.items = data.outcomes.map(function (item) {
                    item.campaignName = item.campaign ? item.campaign.name : '';
                    item.csName = item.cs ? item.cs.map(function (e) {
                      return e.name;
                    }).join(',') : '';
                    item.salePersonName = item.salePersons ? item.salePersons.name : '';
                    item.clientName = item.client ? item.client.name : '';
                    if (_this4.createdIds.includes(item.id)) {
                      item.color = 'yellow lighten-5';
                    } else if (_this4.updatedIds.includes(item.id)) {
                      item.color = 'blue lighten-4';
                    }
                    return item;
                  });
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 11:
                _context4.prev = 11;

                _this4.isLoading = false;
                return _context4.finish(11);

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8, 11, 14]]);
      }))();
    },
    payoutCreated: function payoutCreated() {
      this.refresh();
    },
    updateItemStatus: function updateItemStatus(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__paymentAPIs__["a" /* default */].updatePayoutStatus(item.id, { status: item.status });

              case 3:
                resp = _context5.sent;

                if (resp.success) {
                  item.statusEdit = false;
                }
                _context5.next = 11;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);

                _this5.$swal({
                  text: 'Error on Status Update',
                  icon: 'error'
                });
                console.error(_context5.t0);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 7]]);
      }))();
    },
    openEditItem: function openEditItem(item) {
      this.items = this.items.map(function (itemOne) {
        if (itemOne.id === item.id) {
          itemOne.statusEdit = true;
        }
        return itemOne;
      });
    },
    rowColor: function rowColor(item) {
      if (item.color) return item.color;
      return '';
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.getSummary();

    var onClickOutside = function onClickOutside(e) {
      if (e.target.className && !e.target.className.includes('status') && !e.target.className.includes('v-list-item__title') && !e.target.className.includes('v-list-item')) {
        _this6.items = _this6.items.map(function (itemOne) {
          itemOne.statusEdit = false;
          return itemOne;
        });
      }
    };
    window.addEventListener('click', onClickOutside);
  }
});

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PartialAmountModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    report: Object
  },
  validations: {
    amount: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      isLoading: false,
      amount: '',
      paidSearch: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    amountErrors: function amountErrors() {
      var errors = [];
      if (!this.$v.amount.$dirty) return errors;
      !this.$v.amount.required && errors.push('This field is required.');
      return errors;
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var updateData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
            handle: _this2.report.instagram,
            type: _this2.report.type,
            amount: _this2.amount
          });

          _this2.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__["a" /* default */].saveReportPartialAmount(_this2.report.campaignID, updateData).then(function (response) {
            _this2.isLoading = false;
            _this2.close();

            _this2.$swal({
              text: 'Partial Amount Updated',
              type: 'success'
            });
            _this2.$emit('updated');
          }).catch(function (error) {
            _this2.isLoading = false;

            console.log('error', error);
            _this2.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    close: function close() {
      this.$emit('input');
    }
  },
  watch: {
    value: function value(newValue) {
      this.amount = '';
    }
  }
});

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UpdatePaymentInfoModal__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UpdatePaymentInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__UpdatePaymentInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PartialAmountModal__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PartialAmountModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__PartialAmountModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ActualAmountModal__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ActualAmountModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ActualAmountModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reportNotesModal__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__reportNotesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__reportNotesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CreatePaymentConsolidateModal__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CreatePaymentConsolidateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__CreatePaymentConsolidateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__UploadInvoiceModal__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__UploadInvoiceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__UploadInvoiceModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UploadedInvoiceListModal__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UploadedInvoiceListModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__UploadedInvoiceListModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PaymentInvoiceModal__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PaymentInvoiceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__PaymentInvoiceModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__static_sources_swift_codes__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__static_sources_swift_codes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__static_sources_swift_codes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__static_sources_bank_accounts__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__static_sources_bank_accounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__static_sources_bank_accounts__);

































var FileSaver = __webpack_require__(119);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaymentConsolidation',
  components: {
    UpdatePaymentInfoModal: __WEBPACK_IMPORTED_MODULE_20__UpdatePaymentInfoModal___default.a,
    PartialAmountModal: __WEBPACK_IMPORTED_MODULE_21__PartialAmountModal___default.a,
    ActualAmountModal: __WEBPACK_IMPORTED_MODULE_22__ActualAmountModal___default.a,
    reportNotesModal: __WEBPACK_IMPORTED_MODULE_23__reportNotesModal___default.a,
    CreatePaymentConsolidateModal: __WEBPACK_IMPORTED_MODULE_24__CreatePaymentConsolidateModal___default.a,
    UploadInvoiceModal: __WEBPACK_IMPORTED_MODULE_25__UploadInvoiceModal___default.a,
    UploadedInvoiceListModal: __WEBPACK_IMPORTED_MODULE_26__UploadedInvoiceListModal___default.a,
    PaymentInvoiceModal: __WEBPACK_IMPORTED_MODULE_27__PaymentInvoiceModal___default.a,

    Loading: __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      headers: [{ value: 'liveDate', text: 'Live Date', sortable: true }, { value: 'dueDate', text: 'Due Date', sortable: true }, { value: 'swiftCode', text: 'Swift Code', sortable: true }, { value: 'bankAccount', text: 'Bank A/C No.', sortable: true }, { value: 'username', text: 'Payee Name', sortable: true }, { value: 'country', text: 'Country', sortable: true }, { value: 'bankName', text: 'Bank Name', sortable: true }, { value: 'email', text: 'Email', sortable: true }, { value: 'amount', text: 'Amount', sortable: true }, { value: 'instagram', text: 'Handle', sortable: true }, { value: 'clientName', text: 'Client Name', sortable: true }, { value: 'campaignName', text: 'Campaign Name', sortable: true }, { value: 'IONumber', text: 'Campaign IO Number', sortable: true }, { value: 'PVNumber', text: 'PV Number', sortable: true }, { value: 'paymentDate', text: 'Payment Date (DD/MM/YYYY)', sortable: true }, { value: 'paymentSubmissionDate', text: 'Submission Date (DD/MM/YYYY)', sortable: true }, { value: 'paymentStatus', text: 'Payment Status', sortable: true }, { value: 'bankReference', text: 'Bank Reference', sortable: true }, { value: 'POCDisplay', text: 'CC', sortable: true }, { value: 'batch', text: 'Batch No', sortable: true }, { value: 'agreedDeliverables', text: 'Agreed Deliverables', sortable: true }, { value: 'deliverables', text: 'Produced Deliverables', sortable: true }, { value: 'action', text: 'Actions', sortable: true }],
      batchOne: [],
      batchTwo: [],
      defaultSections: {
        imported: [],
        batchOne: [],
        batchTwo: [],
        approvalFinance: [],

        partiallyPaid: [],
        completed: []
      },
      batchSections: {},
      batches: [],
      archiveReportSections: {},

      paidPanel: [0],
      paymentStatus: __WEBPACK_IMPORTED_MODULE_17__Campaign_config__["a" /* default */].paymentStatus,
      sectionIDs: __WEBPACK_IMPORTED_MODULE_17__Campaign_config__["a" /* default */].paymentConsSectionIDs,
      Users: [],
      CCUsers: [],
      selectedPayments: [],
      selectedReport: {},
      campaigns: [],
      originalPosts: [],
      countries: [],
      selectedPaymentStatus: '',
      editInvoice: {},
      swiftCodes: [],
      bankNames: [],
      newBankName: '',
      allBanks: [],
      disableBankSelect: false,
      reportUpdate: false,
      isLoading: false,
      isPaidLoading: false,
      paymentInfoDialog: false,
      partialAmountDialog: false,
      actualAmountDialog: false,
      reportNotesDialog: false,
      createPaymentConsolidateDialog: false,
      invoiceDialog: false,
      invoiceViewDialog: false,
      paymentInvoiceDialog: false,
      selectedInvoicePayment: {},

      searchText: '',
      filterCountries: [],
      mainFilter: {
        POC: false
      },
      globalFilter: {
        liveDatePicker: false,
        searchliveDateMonth: ''
      },
      utils: __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setCountries();
              _this.changeCountry('Singapore');
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([_this.$store.dispatch('payment/getCurrencyRates'), _this.getAllUsers(), _this.getUploadedInvoiceLists()]);

            case 4:
              _context.next = 6;
              return _this.getPaymentConsolidateReport();

            case 6:
              _this.swiftCodes = __WEBPACK_IMPORTED_MODULE_32__static_sources_swift_codes___default.a;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_vuex__["b" /* mapState */])({
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    },
    sectionsByRoles: function sectionsByRoles(state) {
      return state.payment.sectionsByRoles;
    },
    exportTypes: function exportTypes(state) {
      return state.payment.exportTypes;
    },
    bankSwiftCodes: function bankSwiftCodes(state) {
      return state.payment.bankSwiftCodes;
    },
    consolidateReports: function consolidateReports(state) {
      return state.campaign.consolidateReports;
    },
    archiveReports: function archiveReports(state) {
      return state.campaign.archiveReports;
    },
    updatedReport: function updatedReport(state) {
      return state.campaign.updatedReport;
    },
    preProcessingPayments: function preProcessingPayments(state) {
      return state.payment.preProcessingPayments;
    },
    importedPayments: function importedPayments(state) {
      return state.payment.importedPayments;
    },
    completedPayments: function completedPayments(state) {
      return state.payment.completedPayments;
    },
    savedCompletedPayments: function savedCompletedPayments(state) {
      return state.payment.savedCompletedPayments;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    },
    invoiceLists: function invoiceLists(state) {
      return state.campaign.invoiceLists;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_vuex__["c" /* mapGetters */])('payment', ['paymentStatusOptions', 'allowedStatuses', 'allowedActions', 'allowTableFieldEdit', 'allowFilters', 'formatPosts', 'formatPreProcessingPayments', 'formatImportedPayments', 'formatFinancePayments', 'formatCompletedPayments', 'setBatchTableSections', 'searchParams']), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return this.$store.state.user.role;
    }
  }),
  methods: {
    getPaymentPlatform: function getPaymentPlatform(item) {
      var details = item && item.influencer_details || {};
      var platform = details.platform || item.platform || details.activePlatform || item.activePlatform || '';
      var normalizedPlatform = String(platform).trim().toLowerCase();
      return normalizedPlatform === 'x' ? 'twitter' : normalizedPlatform;
    },
    isLinkedInPayment: function isLinkedInPayment(item) {
      return this.getPaymentPlatform(item) === 'linkedin';
    },
    isTwitterPayment: function isTwitterPayment(item) {
      return this.getPaymentPlatform(item) === 'twitter';
    },
    enrichTwitterPayments: function enrichTwitterPayments(payments) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var influencerIDs, influencers, influencersByID;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                influencerIDs = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a(payments.map(function (payment) {
                  var details = payment.influencer_details || {};
                  return payment.influencerID || details.influencerID;
                }).filter(Boolean))));

                if (influencerIDs.length) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__["a" /* default */].getInfluencerByIds({ searchIds: influencerIDs });

              case 6:
                influencers = _context2.sent;
                influencersByID = (influencers || []).reduce(function (profiles, influencer) {
                  profiles[influencer.id] = influencer;
                  return profiles;
                }, {});


                payments.forEach(function (payment) {
                  var details = payment.influencer_details || {};
                  var influencerID = payment.influencerID || details.influencerID;
                  var influencer = influencersByID[influencerID];
                  var recordPlatform = String(details.platform || payment.platform || '').toLowerCase();
                  if (recordPlatform && recordPlatform !== 'twitter' && recordPlatform !== 'x') return;
                  if (!influencer || String(influencer.activePlatform).toLowerCase() !== 'twitter') return;

                  _this2.$set(payment, 'isTwitter', true);
                  _this2.$set(payment, 'platform', 'twitter');
                  if (influencer.twitterHandle) {
                    _this2.$set(payment, 'instagram', influencer.twitterHandle);
                  }
                });
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](3);

                console.log('Error resolving payment platforms:', _context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 11]]);
      }))();
    },
    getPaymentConsolidateReport: function getPaymentConsolidateReport() {
      var _this3 = this;

      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var posts, preProcessingPayments, importedPayments, financePayments, formattedCompletedPayments, formattedRets;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoading = true;
                _this3.oldBatches = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this3.batches);
                posts = [];
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a.all([_this3.$store.dispatch('payment/getPreProcessingPayments', {}), _this3.$store.dispatch('payment/getImportedPayments', {}), _this3.$store.dispatch('payment/getFinancePayments', {}), _this3.$store.dispatch('payment/getCompletedPayments', {})]);

              case 5:
                preProcessingPayments = _this3.formatPreProcessingPayments(_this3.CCUsers, _this3.invoiceLists);

                preProcessingPayments.map(function (payment) {
                  posts.push(payment);
                });
                importedPayments = _this3.formatImportedPayments(_this3.CCUsers, _this3.invoiceLists);

                importedPayments.map(function (payment) {
                  posts.push(payment);
                });
                financePayments = _this3.formatFinancePayments(_this3.CCUsers, _this3.invoiceLists);

                financePayments.map(function (payment) {
                  posts.push(payment);
                });
                formattedCompletedPayments = _this3.formatCompletedPayments(_this3.CCUsers, _this3.invoiceLists);

                formattedCompletedPayments.map(function (payment) {
                  posts.push(payment);
                });
                _context3.next = 15;
                return _this3.enrichTwitterPayments(posts);

              case 15:
                _this3.clearBatches();
                formattedRets = _this3.formatPosts(posts, _this3.batchSections, _this3.CCUsers, _this3.mainFilter);

                posts = formattedRets.posts;
                _this3.batchSections = formattedRets.sections;
                _this3.setBatchTableSections(_this3.batches, _this3.headers, _this3.batchSections);
                _this3.restoreChanges();
                _this3.batches = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.refreshJSON(_this3.batches);
                _this3.batches = _this3.batches.filter(function (b) {
                  return b.batchNo !== '';
                });
                _this3.isLoading = false;
                _this3.setFilterCountries();

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getPaymentStatus: function getPaymentStatus(statusVal) {
      var statusText = '-';
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.paymentStatuses).forEach(function (item) {
        if (statusVal === item[1].value) {
          statusText = item[1].text;
        }
      });
      return statusText;
    },
    openEditItem: function openEditItem(item, itemName, batch) {
      if (!this.allowTableFieldEdit(itemName, batch.batchNo)) return false;
      item[itemName + 'Edit'] = true;
      item.editReport = true;
      batch.disableSaveEdit = false;
    },
    saveChanges: function saveChanges(posts, batch) {
      var _this4 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this4.isLoading = true;
          var data = posts.filter(function (item) {
            if (_this4.checkReportUpdate(item)) {
              return true;
            }
            return false;
          });
          var unregisteredInfluencers = [];
          data = data.map(function (item) {
            var bankNameValue = '';
            if (item.bankName && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item.bankName) === 'object' && item.bankName.bank) {
              bankNameValue = item.bankName.bank;
            } else if (item.bankName && typeof item.bankName === 'string') {
              bankNameValue = item.bankName;
            }
            var updateObj = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
              id: item.id,
              influencerID: item.influencerID,
              handle: item.instagram,
              platform: item.platform,
              campaignID: item.campaignID,
              type: item.type,
              swift_code: item.swiftCode,
              bank_account: item.bankAccount,
              country: item.country,
              bankName: bankNameValue,
              email: item.email,
              fullName: item.username,
              payment_date: item.paymentDate,
              payment_status: item.paymentStatus,
              bank_reference: item.bankReference,
              PVNumber: item.PVNumber,
              pairingID: item.pairingID || null
            });
            if (item.imported && item.imported !== undefined) {
              updateObj.imported = item.imported;
            }
            if (_this4.currentUserRole === __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.AD_STRATEGIST) {
              var newPOC = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                id: _this4.currentUserID,
                timestamp: __WEBPACK_IMPORTED_MODULE_18_moment___default()().toISOString()
              });
              var POC = item.POC || [];
              var oldPOC = POC.find(function (p) {
                return p.id === _this4.currentUserID;
              });
              if (!oldPOC) {
                POC.unshift(newPOC);
                updateObj.POC = POC;
              }
            }
            if (!item.influencerID && item.editReport) {
              unregisteredInfluencers.push(updateObj);
            }
            return updateObj;
          });

          __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].savePaymentConsolidatedData(data).then(function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(response) {
              var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, unregInf, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, d;

              return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _this4.isLoading = false;

                      _this4.cancelEdit(posts, batch);

                      if (!unregisteredInfluencers.length) {
                        _context4.next = 29;
                        break;
                      }

                      _iteratorNormalCompletion = true;
                      _didIteratorError = false;
                      _iteratorError = undefined;
                      _context4.prev = 6;
                      _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(unregisteredInfluencers);

                    case 8:
                      if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context4.next = 15;
                        break;
                      }

                      unregInf = _step.value;
                      _context4.next = 12;
                      return _this4.$store.dispatch('pairing/savePairingBillingInfo', [unregInf]);

                    case 12:
                      _iteratorNormalCompletion = true;
                      _context4.next = 8;
                      break;

                    case 15:
                      _context4.next = 21;
                      break;

                    case 17:
                      _context4.prev = 17;
                      _context4.t0 = _context4['catch'](6);
                      _didIteratorError = true;
                      _iteratorError = _context4.t0;

                    case 21:
                      _context4.prev = 21;
                      _context4.prev = 22;

                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }

                    case 24:
                      _context4.prev = 24;

                      if (!_didIteratorError) {
                        _context4.next = 27;
                        break;
                      }

                      throw _iteratorError;

                    case 27:
                      return _context4.finish(24);

                    case 28:
                      return _context4.finish(21);

                    case 29:
                      _iteratorNormalCompletion2 = true;
                      _didIteratorError2 = false;
                      _iteratorError2 = undefined;
                      _context4.prev = 32;
                      _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data);

                    case 34:
                      if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                        _context4.next = 52;
                        break;
                      }

                      d = _step2.value;

                      if (!(d.payment_status === _this4.paymentStatus.PROCESSING && !d.imported)) {
                        _context4.next = 41;
                        break;
                      }

                      _context4.next = 39;
                      return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].updatePreProcessingPayment(d);

                    case 39:
                      _context4.next = 49;
                      break;

                    case 41:
                      if (!(d.payment_status === _this4.paymentStatus.PROCESSING && d.imported)) {
                        _context4.next = 46;
                        break;
                      }

                      _context4.next = 44;
                      return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].updateImportedPayment(d);

                    case 44:
                      _context4.next = 49;
                      break;

                    case 46:
                      if (!(d.payment_status === _this4.paymentStatus.APPROVAL_FINANCE || d.payment_status === _this4.paymentStatus.PARTIAL)) {
                        _context4.next = 49;
                        break;
                      }

                      _context4.next = 49;
                      return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].updateProcessingPayment(d);

                    case 49:
                      _iteratorNormalCompletion2 = true;
                      _context4.next = 34;
                      break;

                    case 52:
                      _context4.next = 58;
                      break;

                    case 54:
                      _context4.prev = 54;
                      _context4.t1 = _context4['catch'](32);
                      _didIteratorError2 = true;
                      _iteratorError2 = _context4.t1;

                    case 58:
                      _context4.prev = 58;
                      _context4.prev = 59;

                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                      }

                    case 61:
                      _context4.prev = 61;

                      if (!_didIteratorError2) {
                        _context4.next = 64;
                        break;
                      }

                      throw _iteratorError2;

                    case 64:
                      return _context4.finish(61);

                    case 65:
                      return _context4.finish(58);

                    case 66:
                      _this4.$swal({
                        text: 'Payment Updated',
                        type: 'success'
                      });
                      _context4.next = 69;
                      return _this4.getPaymentConsolidateReport();

                    case 69:
                      document.getElementById(batch.batchNo).scrollIntoView();

                    case 70:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, _this4, [[6, 17, 21, 29], [22,, 24, 28], [32, 54, 58, 66], [59,, 61, 65]]);
            }));

            return function (_x2) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (error) {
            _this4.isLoading = false;

            console.log('error', error);
            _this4.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    saveArchive: function saveArchive(batch) {
      var _this5 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee5(result) {
          var selected, data;
          return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!result.value) {
                    _context5.next = 15;
                    break;
                  }

                  if (!(batch.status === _this5.paymentStatus.PAID)) {
                    _context5.next = 4;
                    break;
                  }

                  _this5.archiveCompletedPayments(batch);
                  return _context5.abrupt('return');

                case 4:
                  selected = batch.selectedPayments;
                  data = selected.map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                      id: item.id,
                      archive: true
                    });
                  });
                  _context5.next = 8;
                  return _this5.$store.dispatch('campaign/updateReportsByIds', data);

                case 8:
                  _this5.isLoading = false;

                  if (_this5.updatedReport) {
                    _context5.next = 12;
                    break;
                  }

                  _this5.$swal({
                    text: 'Error Archiving Reports.',
                    type: 'error'
                  });
                  return _context5.abrupt('return');

                case 12:
                  _this5.cancelEdit(batch.displayData, batch);

                  _this5.$swal({
                    text: 'Successfully Archived.',
                    type: 'success'
                  });
                  _this5.getPaymentConsolidateReport();

                case 15:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this5);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    archiveCompletedPayments: function archiveCompletedPayments(batch) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var selected, reportArchiveData, completedArchiveData;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                selected = batch.selectedPayments;
                reportArchiveData = [];
                completedArchiveData = [];

                selected.map(function (item) {
                  reportArchiveData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                    id: item.reportID,
                    archive: true
                  }));
                  completedArchiveData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                    id: item.id,
                    archive: true
                  }));
                });
                _context6.next = 6;
                return _this6.$store.dispatch('campaign/updateReportsByIds', reportArchiveData);

              case 6:
                _context6.next = 8;
                return _this6.$store.dispatch('payment/saveCompletedPayments', {
                  data: completedArchiveData
                });

              case 8:
                _this6.isLoading = false;

                if (!(!_this6.updatedReport || !_this6.savedCompletedPayments)) {
                  _context6.next = 12;
                  break;
                }

                _this6.$swal({
                  text: 'Error Archiving Reports.',
                  type: 'error'
                });
                return _context6.abrupt('return');

              case 12:
                _this6.$swal({
                  text: 'Successfully Archived.',
                  type: 'success'
                });
                _this6.getPaymentConsolidateReport();

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    cancelEdit: function cancelEdit(posts, batch) {
      var _this7 = this;

      posts = posts.map(function (inf) {
        inf = _this7.setDefaultEditFields(inf);
        return inf;
      });
      batch.disableSaveEdit = true;
    },
    setDefaultEditFields: function setDefaultEditFields(obj) {
      obj.swiftCodeEdit = false;
      obj.bankAccountEdit = false;
      obj.usernameEdit = false;
      obj.paymentDateEdit = false;
      obj.bankReferenceEdit = false;
      obj.paymentStatusEdit = false;
      obj.emailEdit = false;
      obj.bankNameEdit = false;
      obj.countryEdit = false;
      obj.PVNumberEdit = false;
      obj.editReport = false;
      return obj;
    },
    selectAllPayments: function selectAllPayments($event) {
      if ($event.value && $event.items.length === 0) {
        return;
      }
      var batchIndex = null;
      if ($event.items.length > 0) {
        batchIndex = this.batches.findIndex(function (i) {
          return i.batchNo === $event.items[0].batchNo;
        });
      }
      if (!$event.value) {
        this.batches[batchIndex].selectedPayments = [];
      }

      var filteredItems = $event.items.filter(function (item) {
        if (!$event.value) {
          return false;
        }
        return true;
      });
      this.batches[batchIndex].selectedPayments = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], filteredItems);
    },
    getFiltered: function getFiltered(filtered) {
      var batch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var batchIndex = null;
      if (filtered.length > 0) {
        batchIndex = this.batches.findIndex(function (i) {
          return i.batchNo === filtered[0].batchNo;
        });
        this.batches[batchIndex].totalAmount = this.calculateTotalAmt(filtered);
      } else {
        if (batch) {
          batchIndex = this.batches.findIndex(function (i) {
            return i.batchNo === batch.batchNo;
          });
          this.batches[batchIndex].totalAmount = 0;
        }
      }
    },
    calculateTotalAmt: function calculateTotalAmt(items) {
      return items.map(function (item) {
        return item.amount ? Number(item.amount) : 0;
      }).reduce(function (a, b) {
        return a + b;
      });
    },
    openPaymentUpdateModal: function openPaymentUpdateModal(selectedPayments) {
      this.selectedPayments = selectedPayments;
      var batchNo = this.selectedPayments[0].batchNo;
      var matchBatch = this.batches.find(function (batch) {
        return batch.batchNo === batchNo;
      });
      this.selectedPaymentStatus = matchBatch.status;
      this.paymentInfoDialog = true;
    },
    openPartialAmountDialog: function openPartialAmountDialog(item) {
      if (item.payment_status === this.paymentStatus.APPROVAL_LEAD || item.payment_status === this.paymentStatus.APPROVAL_LEAD || item.payment_status === this.paymentStatus.PARTIAL) {
        this.selectedReport = item;
        this.partialAmountDialog = true;
      }
      return false;
    },
    openActualAmountDialog: function openActualAmountDialog(item) {
      if (item.payment_status === this.paymentStatus.PAID) {
        this.selectedReport = item;
        this.actualAmountDialog = true;
      }
      return false;
    },
    openPaymentInvoiceModal: function openPaymentInvoiceModal(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var signedInvoices;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.selectedInvoicePayment = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, item, { signedInvoices: [] });
                _this8.paymentInvoiceDialog = true;

                if (item.pairingID) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt('return');

              case 4:
                _context7.prev = 4;
                _context7.next = 7;
                return __WEBPACK_IMPORTED_MODULE_15__Pairing_pairingAPIs__["a" /* default */].getSignedInvoices(item.pairingID);

              case 7:
                signedInvoices = _context7.sent;

                if (_this8.selectedInvoicePayment.pairingID === item.pairingID) {
                  _this8.$set(_this8.selectedInvoicePayment, 'signedInvoices', signedInvoices);
                }
                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7['catch'](4);

                console.log(_context7.t0);

              case 14:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[4, 11]]);
      }))();
    },
    exportReport: function exportReport(batch) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var exportData;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.isLoading = true;
                _context8.next = 3;
                return _this9.fetchCampaignList();

              case 3:
                exportData = [];

                if (batch.selectedPayments.length) {
                  batch.selectedPayments = __WEBPACK_IMPORTED_MODULE_28_lodash_orderBy___default()(batch.selectedPayments, ['IONumber'], ['asc']);
                  exportData = batch.selectedPayments.map(function (data) {
                    return _this9.beautifyExportData(data);
                  });
                } else {
                  batch.displayData = __WEBPACK_IMPORTED_MODULE_28_lodash_orderBy___default()(batch.displayData, ['IONumber'], ['asc']);
                  exportData = batch.displayData.map(function (data) {
                    return _this9.beautifyExportData(data);
                  });
                }
                __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].exportBankReport(exportData, batch.exportType).then(function (response) {
                  _this9.isLoading = false;
                  var blob = new Blob([response], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  });
                  if (batch.exportType === _this9.exportTypes.CO) {
                    FileSaver.saveAs(blob, batch.name + '_' + __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('X') + '.xlsx');
                  } else {
                    FileSaver.saveAs(blob, 'bank_import_' + __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('X') + '.xlsx');
                  }
                }).catch(function (error) {
                  _this9.isLoading = false;

                  console.log('error', error);
                  _this9.$swal({
                    text: error,
                    type: 'error'
                  });
                });

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    exportReportAllBatch: function exportReportAllBatch() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var exportData, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, batch, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, data, newData;

        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this10.isLoading = true;
                _context9.next = 3;
                return _this10.fetchCampaignList();

              case 3:
                exportData = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context9.prev = 7;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this10.batches);

              case 9:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context9.next = 34;
                  break;
                }

                batch = _step3.value;

                if (!Array.isArray(batch.displayData)) {
                  _context9.next = 31;
                  break;
                }

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context9.prev = 15;

                for (_iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(batch.displayData); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  data = _step4.value;
                  newData = _this10.beautifyExportData(data);

                  exportData.push(newData);
                }
                _context9.next = 23;
                break;

              case 19:
                _context9.prev = 19;
                _context9.t0 = _context9['catch'](15);
                _didIteratorError4 = true;
                _iteratorError4 = _context9.t0;

              case 23:
                _context9.prev = 23;
                _context9.prev = 24;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 26:
                _context9.prev = 26;

                if (!_didIteratorError4) {
                  _context9.next = 29;
                  break;
                }

                throw _iteratorError4;

              case 29:
                return _context9.finish(26);

              case 30:
                return _context9.finish(23);

              case 31:
                _iteratorNormalCompletion3 = true;
                _context9.next = 9;
                break;

              case 34:
                _context9.next = 40;
                break;

              case 36:
                _context9.prev = 36;
                _context9.t1 = _context9['catch'](7);
                _didIteratorError3 = true;
                _iteratorError3 = _context9.t1;

              case 40:
                _context9.prev = 40;
                _context9.prev = 41;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 43:
                _context9.prev = 43;

                if (!_didIteratorError3) {
                  _context9.next = 46;
                  break;
                }

                throw _iteratorError3;

              case 46:
                return _context9.finish(43);

              case 47:
                return _context9.finish(40);

              case 48:
                __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].exportBankReport(exportData, _this10.exportTypes.CO).then(function (response) {
                  _this10.isLoading = false;
                  var blob = new Blob([response], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  });
                  FileSaver.saveAs(blob, 'payment_consolidation_' + __WEBPACK_IMPORTED_MODULE_18_moment___default()().format('X') + '.xlsx');
                }).catch(function (error) {
                  _this10.isLoading = false;

                  console.log('error', error);
                  _this10.$swal({
                    text: error,
                    type: 'error'
                  });
                });

              case 49:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[7, 36, 40, 48], [15, 19, 23, 31], [24,, 26, 30], [41,, 43, 47]]);
      }))();
    },
    beautifyExportData: function beautifyExportData(data, type) {
      var campaign = this.campaigns.find(function (c) {
        return c.id === data.campaignID;
      });
      var refNo = 'KOBE';
      if (campaign) {
        if (campaign.campaignCode !== undefined) {
          refNo += 'x' + campaign.campaignCode.split('-')[0];
        }
      }
      var handle = '';
      if (data.isXHS || data.xhsOwner) {
        handle = data.fullName || data.instagram;
      } else {
        handle = data.instagram;
      }
      return {
        liveDate: data.liveDate,
        dueDate: data.dueDate,
        handle: handle,
        swiftCode: data.swiftCode,
        bankAccount: data.bankAccount,
        bankAccountName: data.username,
        country: data.country,
        bankName: data.bankName,
        email: data.email,
        amount: data.amount,
        campaignName: data.campaignName,
        clientName: data.clientName,
        IONumber: data.IONumber,
        CO: data.CO,
        remark: '',
        paymentDate: data.paymentDate,
        paymentSubmissionDate: data.paymentSubmissionDate,
        paymentStatus: this.getPaymentStatus(data.paymentStatus),
        beneficiaryRef: refNo,
        POCDisplay: data.POCDisplay,
        agreedDeliverables: data.agreedDeliverables,
        deliverables: data.deliverables
      };
    },
    searchFilter: function searchFilter(batch) {
      var filterOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      batch.displayData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], batch.data);
      if (batch.filter.searchliveDateMonth) {
        batch.displayData = batch.displayData.filter(function (b) {
          var searchMonth = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.parseDate(b.liveDate);
          return searchMonth === batch.filter.searchliveDateMonth;
        });
      }
      if (batch.filter.searchDueDateMonth) {
        batch.displayData = batch.displayData.filter(function (b) {
          var searchMonth = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.parseDate(b.dueDate);
          return searchMonth === batch.filter.searchDueDateMonth;
        });
      }
      if (batch.filter.searchPaymentDateMonth) {
        batch.displayData = batch.displayData.filter(function (b) {
          var searchMonth = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.parseMonth(b.paymentDate);
          return searchMonth === batch.filter.searchPaymentDateMonth;
        });
      }
      if (batch.filter.imported) {
        batch.displayData = batch.displayData.filter(function (b) {
          return b.imported;
        });
      }
      if (batch.filter.cc && batch.filter.cc !== 'All') {
        batch.displayData = batch.displayData.filter(function (b) {
          return b.assignedTo && b.assignedTo.includes(batch.filter.cc);
        });
      }
      if (batch.filter.country && batch.filter.country !== 'All Country') {
        batch.displayData = batch.displayData.filter(function (b) {
          return b.country === batch.filter.country;
        });
      }
      if (filterOnly) return batch;
      this.batches = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.refreshJSON(this.batches);
      this.getFiltered(batch.displayData, batch);
    },
    searchLiveDataFilter: function searchLiveDataFilter(batches) {
      var _this11 = this;

      if (!this.globalFilter.searchliveDateMonth) {
        this.batches.forEach(function (batch) {
          batch.displayData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], batch.data);
          _this11.searchFilter(batch, true);
          _this11.getFiltered(batch.displayData, batch);
        });
        return;
      }

      this.batches.forEach(function (batch) {
        batch.displayData = batch.data.filter(function (item) {
          var searchMonth = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.parseMonth(item.liveDate);
          return searchMonth === _this11.globalFilter.searchliveDateMonth;
        });
        _this11.getFiltered(batch.displayData, batch);
      });
      this.batches = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.refreshJSON(this.batches);
    },
    searchGlobalMonthOk: function searchGlobalMonthOk(type) {
      switch (type) {
        case 'liveDate':
          this.globalFilter.liveDatePicker = false;
          break;
      }
      this.searchLiveDataFilter();
    },
    cancelGlobalMonth: function cancelGlobalMonth(type) {
      switch (type) {
        case 'liveDate':
          this.globalFilter.liveDatePicker = false;
          this.globalFilter.searchliveDateMonth = '';
          break;
      }
      this.searchLiveDataFilter();
    },
    searchMonthOk: function searchMonthOk(batch, type) {
      switch (type) {
        case 'liveDate':
          batch.filter.liveDatePicker = false;
          break;
        case 'dueDate':
          batch.filter.dueDatePicker = false;
          break;
        case 'paymentDate':
          batch.filter.paymentDatePicker = false;
          break;
      }
      this.searchFilter(batch);
    },
    cancelMonth: function cancelMonth(batch, type) {
      switch (type) {
        case 'liveDate':
          batch.filter.liveDatePicker = false;
          batch.filter.searchliveDateMonth = '';
          break;
        case 'dueDate':
          batch.filter.dueDatePicker = false;
          batch.filter.searchDueDateMonth = '';
          break;
        case 'paymentDate':
          batch.filter.paymentDatePicker = false;
          batch.filter.searchPaymentDateMonth = '';
          break;
      }
      this.searchFilter(batch);
    },
    clearselectedBatch: function clearselectedBatch(batchNo) {
      if (batchNo === this.sectionIDs.BATCH_ONE) {
        this.batches[0].data = [];
      } else {
        this.batches[1].data = [];
      }
    },
    restoreChanges: function restoreChanges() {
      var _this12 = this;

      this.oldBatches.map(function (batch, index) {
        var currentBatch = _this12.batches[index];
        currentBatch.disableSaveEdit = batch.disableSaveEdit;
        var selectedIds = batch.selectedPayments.map(function (selected) {
          return selected.id;
        });
        currentBatch.selectedPayments = _this12.batches[index].displayData.filter(function (display) {
          return selectedIds.includes(display.id);
        });
        currentBatch.filter = batch.filter;
        _this12.batches[index] = currentBatch;
      });
      this.batches = this.batches.map(function (batch) {
        batch = _this12.searchFilter(batch, true);
        return batch;
      });
      this.batches = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.batches);
      this.searchGlobal();
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split = date.split('/'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          day = _date$split2[0],
          month = _date$split2[1],
          year = _date$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    parseMonth: function parseMonth(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0');
    },
    getAllUsers: function getAllUsers() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                response = _context10.sent;

                if (response) {
                  _this13.Users = response.users;
                  _this13.Users = _this13.Users.map(function (u) {
                    u.name = '' + u.firstName;
                    return u;
                  });
                  _this13.CCUsers = _this13.Users.filter(function (c) {
                    return c.role === __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.AD_STRATEGIST;
                  });
                  _this13.CCUsers.unshift({
                    id: '',
                    name: 'All CC'
                  });
                }

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!_this14.campaigns.length) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt('return', _this14.campaigns);

              case 2:
                _context11.prev = 2;
                _context11.next = 5;
                return __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus();

              case 5:
                _this14.campaigns = _context11.sent;
                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11['catch'](2);

                console.log('Error:' + _context11.t0);

              case 11:
                return _context11.abrupt('return', _this14.campaigns);

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this14, [[2, 8]]);
      }))();
    },
    changePaymentStatus: function changePaymentStatus(item) {
      if (!this.checkPaymentStatus(item)) {
        this.$swal({
          text: 'Please Enter SwiftCode, Bank Account, Payee Name, Country, Bank Name and Email.',
          type: 'warning'
        });
      }
    },
    checkPaymentStatus: function checkPaymentStatus(item) {
      if ((!item.swiftCode || !item.bankAccount || !item.username || !item.country || !item.bankName || !item.email) && item.paymentStatus === this.paymentStatuses.PAID.value) {
        return false;
      }
      return true;
    },
    checkReportUpdate: function checkReportUpdate(item) {
      var isReportValid = true;
      if (!item.editReport || item.editReport === false) {
        isReportValid = false;
      }
      isReportValid = this.checkPaymentStatus(item) && item.editReport;
      return isReportValid;
    },
    openReportNotesDialog: function openReportNotesDialog(item) {
      this.reportNotesData = item;
      this.reportNotesDialog = true;
      this.markNotesAsRead(item);
    },
    appendNote: function appendNote(internalNotes) {
      this.reportNotesData.internalNotes = this.reportNotesData.internalNotes || internalNotes;
    },
    getNoteUnreadCount: function getNoteUnreadCount(item) {
      var _this15 = this;

      var unread = 0;
      if (item.internalNotes !== undefined) {
        item.internalNotes.map(function (note) {
          note.read = note.read || [];
          if (!note.read.includes(_this15.currentUserID)) {
            unread++;
          }
        });
      }
      return unread;
    },
    markNotesAsRead: function markNotesAsRead(item) {
      var unreadNoteIDs = [];
      if (item.internalNotes !== undefined) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(item.internalNotes), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var note = _step5.value;

            note.read = note.read || [];
            if (!note.read.includes(this.currentUserID)) {
              unreadNoteIDs.push(this.currentUserID);
              note.read.push(this.currentUserID);
              this.updateReadNote(item.id, unreadNoteIDs);
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
      item.internalNotes = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.refreshJSON(item.internalNotes);
    },
    updateReadNote: function updateReadNote(id, unreadNoteIDs) {
      var formData = new FormData();
      formData.append('reportID', id);
      formData.append('unreads', unreadNoteIDs);
      __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignAPIs__["a" /* default */].saveReportNoteRead(formData).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    changeBankName: function changeBankName(item) {
      item.swiftCode = '';
      var bank = '';
      if (item.bankName && item.bankName.bank) {
        bank = item.bankName.bank;
      } else {
        bank = item.bankName;
      }
      var matchBank = this.swiftCodes.find(function (b) {
        return b.bank === bank;
      });
      if (matchBank) {
        item.swiftCode = matchBank.code;
      } else {
        var matchBankAcc = __WEBPACK_IMPORTED_MODULE_33__static_sources_bank_accounts___default.a.find(function (b) {
          return b.bank === bank;
        });
        if (matchBankAcc) {
          item.swiftCode = matchBankAcc.code;
        }
      }
    },
    changeCountry: function changeCountry(item) {
      try {
        this.bankNames = [];
        var country = this.countries.find(function (c) {
          return c.name === item;
        });
        if (!country) {
          return;
        }
        this.disableBankSelect = true;
        this.getBanks(country.code);
        this.disableBankSelect = false;
      } catch (err) {
        console.log(err);
        this.bankNames = [];
        this.disableBankSelect = false;
      }
    },
    getBanks: function getBanks(code) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response, matchBank;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__["a" /* default */].getBanks(code);

              case 3:
                response = _context12.sent;

                _this16.allBanks = response || [];
                matchBank = _this16.allBanks.find(function (bank) {
                  return bank.country_code === code;
                });

                if (matchBank && matchBank.list !== undefined) {
                  _this16.bankNames = matchBank.list.filter(function (bank) {
                    return bank.branch === null;
                  });
                }
                _context12.next = 14;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12['catch'](0);

                console.log('Error fetching banks:', _context12.t0);
                _this16.allBanks = [];
                _this16.bankNames = [];

              case 14:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this16, [[0, 9]]);
      }))();
    },
    clearBatches: function clearBatches() {
      this.batches = [];
      this.batchSections = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.refreshJSON(this.defaultSections);
    },
    filterPaymentStatusOptions: function filterPaymentStatusOptions(item) {
      var batchNo = item.batchNo;
      var matchBatch = this.batches.find(function (batch) {
        return batch.batchNo === batchNo;
      });
      if (matchBatch) {
        return this.allowedStatuses.filter(function (al) {
          return al.allowedStatusChange.includes(matchBatch.status);
        });
      }
      return [];
    },
    buttonShow: function buttonShow(type) {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        return false;
      }
      return true;
    },
    openCreatePaymentConsolidateModal: function openCreatePaymentConsolidateModal() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.editInvoice = {};
      this.reportUpdate = false;
      if (item) {
        this.editInvoice = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, item);
        this.reportUpdate = true;
      }
      this.createPaymentConsolidateDialog = true;
    },
    openInvoiceModal: function openInvoiceModal() {
      this.invoiceDialog = true;
    },
    searchGlobal: function searchGlobal() {
      var _this17 = this;

      this.batches = this.batches.map(function (batch) {
        batch.filter.workingSearch = _this17.searchText;
        return batch;
      });
      this.invoiceSearch = this.searchText;
    },
    changeSearch: function changeSearch(batch, batchFilter, keyword) {
      batchFilter.workingSearch = keyword;
    },
    openViewInvoiceModal: function openViewInvoiceModal() {
      this.invoiceViewDialog = true;
    },
    deleteReport: function deleteReport(id, item) {
      var _this18 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee13(result) {
          var payload;
          return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  if (!result.value) {
                    _context13.next = 9;
                    break;
                  }

                  _this18.isLoading = true;
                  _context13.next = 4;
                  return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].deleteImportedPayment(id);

                case 4:
                  if (!item.reportID) {
                    _context13.next = 8;
                    break;
                  }

                  payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                    id: id,
                    params: { noreload: true }
                  });
                  _context13.next = 8;
                  return _this18.$store.dispatch('campaign/deleteReport', payload);

                case 8:
                  _this18.$swal({
                    text: 'Successfully deleted.',
                    type: 'success'
                  });

                case 9:
                  _this18.getPaymentConsolidateReport();

                case 10:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, _this18);
        }));

        return function (_x7) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    deleteMultipleReport: function deleteMultipleReport() {
      var _this19 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee14(result) {
          var _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, batch, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, payment, payload;

          return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!result.value) {
                    _context14.next = 69;
                    break;
                  }

                  _this19.isLoading = true;
                  _iteratorNormalCompletion6 = true;
                  _didIteratorError6 = false;
                  _iteratorError6 = undefined;
                  _context14.prev = 5;
                  _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this19.batches);

                case 7:
                  if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                    _context14.next = 53;
                    break;
                  }

                  batch = _step6.value;
                  _iteratorNormalCompletion7 = true;
                  _didIteratorError7 = false;
                  _iteratorError7 = undefined;
                  _context14.prev = 12;
                  _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(batch.selectedPayments);

                case 14:
                  if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                    _context14.next = 36;
                    break;
                  }

                  payment = _step7.value;

                  if (!(payment.status === _this19.paymentStatuses.PARTIAL.value || payment.status === _this19.paymentStatuses.APPROVAL_FINANCE.value)) {
                    _context14.next = 21;
                    break;
                  }

                  _context14.next = 19;
                  return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].deleteProcessingPayment(payment.id);

                case 19:
                  _context14.next = 33;
                  break;

                case 21:
                  if (!payment.imported) {
                    _context14.next = 30;
                    break;
                  }

                  _context14.next = 24;
                  return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].deleteImportedPayment(payment.id);

                case 24:
                  if (!payment.reportID) {
                    _context14.next = 28;
                    break;
                  }

                  payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                    id: payment.reportID,
                    params: { noreload: true }
                  });
                  _context14.next = 28;
                  return _this19.$store.dispatch('campaign/deleteReport', payload);

                case 28:
                  _context14.next = 33;
                  break;

                case 30:
                  if (!(payment.status === _this19.paymentStatuses.PROCESSING.value)) {
                    _context14.next = 33;
                    break;
                  }

                  _context14.next = 33;
                  return __WEBPACK_IMPORTED_MODULE_12__paymentAPIs__["a" /* default */].deletePreProcessingPayment(payment.id);

                case 33:
                  _iteratorNormalCompletion7 = true;
                  _context14.next = 14;
                  break;

                case 36:
                  _context14.next = 42;
                  break;

                case 38:
                  _context14.prev = 38;
                  _context14.t0 = _context14['catch'](12);
                  _didIteratorError7 = true;
                  _iteratorError7 = _context14.t0;

                case 42:
                  _context14.prev = 42;
                  _context14.prev = 43;

                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }

                case 45:
                  _context14.prev = 45;

                  if (!_didIteratorError7) {
                    _context14.next = 48;
                    break;
                  }

                  throw _iteratorError7;

                case 48:
                  return _context14.finish(45);

                case 49:
                  return _context14.finish(42);

                case 50:
                  _iteratorNormalCompletion6 = true;
                  _context14.next = 7;
                  break;

                case 53:
                  _context14.next = 59;
                  break;

                case 55:
                  _context14.prev = 55;
                  _context14.t1 = _context14['catch'](5);
                  _didIteratorError6 = true;
                  _iteratorError6 = _context14.t1;

                case 59:
                  _context14.prev = 59;
                  _context14.prev = 60;

                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }

                case 62:
                  _context14.prev = 62;

                  if (!_didIteratorError6) {
                    _context14.next = 65;
                    break;
                  }

                  throw _iteratorError6;

                case 65:
                  return _context14.finish(62);

                case 66:
                  return _context14.finish(59);

                case 67:
                  _this19.$swal({
                    text: 'Successfully deleted.',
                    type: 'success'
                  });
                  _this19.getPaymentConsolidateReport();

                case 69:
                case 'end':
                  return _context14.stop();
              }
            }
          }, _callee14, _this19, [[5, 55, 59, 67], [12, 38, 42, 50], [43,, 45, 49], [60,, 62, 66]]);
        }));

        return function (_x8) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    displayGSTText: function displayGSTText(item) {
      return '$' + (item.amount + (item.paidAmount || 0) - item.GSTPercent) + ' + $' + item.GSTPercent + ' (GST)';
    },
    changeSwiftCode: function changeSwiftCode(item) {
      var matchBank = this.bankSwiftCodes.find(function (b) {
        return b.code === item.swiftCode;
      });
      if (matchBank) {
        item.bankName = matchBank.bank;
      }
    },
    setCountries: function setCountries() {
      this.countries = __WEBPACK_IMPORTED_MODULE_31__static_sources_countries___default.a;
    },
    setFilterCountries: function setFilterCountries() {
      var countries = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a();
      this.consolidateReports.map(function (c) {
        if (c.country) countries.add(c.country);
      });
      this.filterCountries = [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(countries));
      this.filterCountries.unshift({ name: 'All Country' });
    },
    resetFilter: function resetFilter(batch) {
      batch.filter = this.searchParams();
      this.searchFilter(batch);
    },
    isDeleteAction: function isDeleteAction(selectedPayments) {
      var _this20 = this;

      var isImported = selectedPayments.find(function (s) {
        return (s.paymentStatus === _this20.paymentStatus.APPROVAL_FINANCE || s.paymentStatus === _this20.paymentStatus.PARTIAL || s.paymentStatus === _this20.paymentStatus.PROCESSING) && _this20.currentUserRole === __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || s.imported;
      });
      return isImported ? true : false;
    },
    fixTwoDec: function fixTwoDec(amt) {
      return Number(amt).toFixed(2);
    },
    getUploadedInvoiceLists: function getUploadedInvoiceLists() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _this21.$store.dispatch('campaign/getUploadedInvoiceLists');

              case 2:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this21);
      }))();
    },
    refreshPayCons: function refreshPayCons() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee16() {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return _this22.getUploadedInvoiceLists();

              case 2:
                _this22.getPaymentConsolidateReport();

              case 3:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this22);
      }))();
    }
  }
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paymentAPIs__ = __webpack_require__(90);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaymentInvoiceModal',
  props: {
    value: Boolean,
    payment: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      files: [],
      loading: false,
      headers: [{ value: 'filename', text: 'File', sortable: true }, { value: 'source', text: 'Source', sortable: true }, { value: 'timestamp', text: 'Uploaded At', sortable: true }, { value: 'action', text: 'Actions', sortable: false }]
    };
  },

  computed: {
    invoiceItems: function invoiceItems() {
      return Array.isArray(this.payment.paymentInvoices) ? this.payment.paymentInvoices : [];
    },
    displayInvoices: function displayInvoices() {
      var invoices = this.normalizedSignedInvoices.concat(this.normalizedUploadedInvoices).concat(this.normalizedGeneratedInvoices).filter(function (invoice) {
        return invoice.url;
      });
      var urls = [];
      return invoices.filter(function (invoice) {
        if (urls.includes(invoice.url)) return false;
        urls.push(invoice.url);
        return true;
      });
    },
    normalizedUploadedInvoices: function normalizedUploadedInvoices() {
      var _this = this;

      var paymentInvoices = this.invoiceItems.map(function (invoice, index) {
        return _this.normalizeInvoice(invoice, {
          fallbackName: 'Uploaded Invoice ' + (index + 1),
          source: 'Uploaded',
          deletable: true,
          deleteType: 'payment'
        });
      });
      var reportInvoices = this.reportInvoiceItems.map(function (invoice, index) {
        return _this.normalizeInvoice(invoice, {
          fallbackName: 'Uploaded Invoice ' + (paymentInvoices.length + index + 1),
          source: 'Uploaded',
          deletable: !!invoice.id,
          deleteType: 'report'
        });
      });
      return paymentInvoices.concat(reportInvoices);
    },
    normalizedSignedInvoices: function normalizedSignedInvoices() {
      var _this2 = this;

      return this.signedInvoiceItems.map(function (invoice, index) {
        return _this2.normalizeInvoice(invoice, {
          fallbackName: 'Creator Signed Invoice ' + (index + 1),
          source: 'Creator Signed',
          deletable: false
        });
      });
    },
    normalizedGeneratedInvoices: function normalizedGeneratedInvoices() {
      var invoices = [];
      if (this.payment.invoice) {
        invoices.push(this.normalizeInvoice(this.payment.invoice, {
          fallbackName: 'Generated Invoice',
          source: 'Generated',
          deletable: false
        }));
      }
      return invoices;
    },
    reportInvoiceItems: function reportInvoiceItems() {
      return Array.isArray(this.payment.uploadInvoice) ? this.payment.uploadInvoice : [];
    },
    signedInvoiceItems: function signedInvoiceItems() {
      return Array.isArray(this.payment.signedInvoices) ? this.payment.signedInvoices : [];
    },
    recordTitle: function recordTitle() {
      var handle = this.payment.instagram ? '@' + this.payment.instagram : '';
      return [this.payment.campaignName, handle].filter(Boolean).join(' - ');
    },
    paymentType: function paymentType() {
      if (this.payment.batchNo === 'imported') return 'imported';
      if (this.payment.paymentStatus === 1) return 'completed';
      if (this.payment.paymentStatus === 5 || this.payment.paymentStatus === 6) return 'finance';
      return 'pre-processing';
    }
  },
  watch: {
    value: function value(val) {
      if (!val) this.files = [];
    }
  },
  methods: {
    prepareUpload: function prepareUpload(e) {
      this.files = this.files.concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      }));
      e.target.value = '';
    },
    removeFile: function removeFile(index) {
      this.files.splice(index, 1);
    },
    formatDate: function formatDate(date) {
      if (!date) return '-';
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('DD/MM/YYYY hh:mm:ss A');
    },
    normalizeInvoice: function normalizeInvoice(invoice, options) {
      if (!invoice) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, options, { url: '' });
      }
      var isString = typeof invoice === 'string';
      var url = isString ? invoice : invoice.url;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, isString ? {} : invoice, {
        url: url,
        filename: isString ? options.fallbackName : invoice.filename || invoice.name || options.fallbackName,
        source: options.source,
        deletable: options.deletable,
        deleteType: options.deleteType || null
      });
    },
    upload: function upload() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.loading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__paymentAPIs__["a" /* default */].uploadPaymentInvoices(_this3.paymentType, _this3.payment.id, _this3.files);

              case 4:
                response = _context.sent;

                _this3.loading = false;

                if (!(response && Array.isArray(response.uploadInvoice))) {
                  _context.next = 12;
                  break;
                }

                _this3.$set(_this3.payment, 'paymentInvoices', response.uploadInvoice);
                _this3.files = [];
                _this3.$emit('updated');
                _this3.$swal({ text: 'Invoices uploaded', type: 'success' });
                return _context.abrupt('return');

              case 12:
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this3.loading = false;

              case 18:
                _this3.$swal({ text: 'Error uploading invoices', type: 'error' });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 14]]);
      }))();
    },
    deleteInvoice: function deleteInvoice(invoice) {
      var _this4 = this;

      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete this invoice?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var response;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (result.value) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt('return');

                case 2:
                  _context2.prev = 2;

                  _this4.loading = true;

                  if (!(invoice.deleteType === 'report')) {
                    _context2.next = 10;
                    break;
                  }

                  _context2.next = 7;
                  return _this4.deleteReportInvoice(invoice);

                case 7:
                  _context2.t0 = _context2.sent;
                  _context2.next = 13;
                  break;

                case 10:
                  _context2.next = 12;
                  return __WEBPACK_IMPORTED_MODULE_6__paymentAPIs__["a" /* default */].deletePaymentInvoice(_this4.paymentType, _this4.payment.id, invoice.id);

                case 12:
                  _context2.t0 = _context2.sent;

                case 13:
                  response = _context2.t0;

                  _this4.loading = false;

                  if (!(response && (response.success || Array.isArray(response.uploadInvoice)))) {
                    _context2.next = 21;
                    break;
                  }

                  if (Array.isArray(response.uploadInvoice)) {
                    _this4.$set(_this4.payment, 'paymentInvoices', response.uploadInvoice);
                  } else if (invoice.deleteType === 'payment') {
                    _this4.$set(_this4.payment, 'paymentInvoices', _this4.invoiceItems.filter(function (item) {
                      if (invoice.id && item.id) return item.id !== invoice.id;
                      return item.url !== invoice.url;
                    }));
                  }
                  if (invoice.deleteType === 'report') {
                    _this4.$set(_this4.payment, 'uploadInvoice', _this4.reportInvoiceItems.filter(function (item) {
                      return item.id !== invoice.id;
                    }));
                  }
                  _this4.$emit('updated');
                  _this4.$swal({ text: 'Invoice deleted', type: 'success' });
                  return _context2.abrupt('return');

                case 21:
                  _context2.next = 27;
                  break;

                case 23:
                  _context2.prev = 23;
                  _context2.t1 = _context2['catch'](2);

                  console.log(_context2.t1);
                  _this4.loading = false;

                case 27:
                  _this4.$swal({ text: 'Error deleting invoice', type: 'error' });

                case 28:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this4, [[2, 23]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    deleteReportInvoice: function deleteReportInvoice(invoice) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__Campaign_campaignAPIs__["a" /* default */].bulkDeleteInvoices({ ids: [invoice.id] });

              case 2:
                _context3.next = 4;
                return _this5.$store.dispatch('campaign/getUploadedInvoiceLists');

              case 4:
                return _context3.abrupt('return', { success: true });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    close: function close() {
      this.$emit('input', false);
    }
  }
});

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PayoutScreenshotsDialog',
  props: ['value', 'imagesToView'],
  data: function data() {
    return {
      imageViewerDialog: false,
      activeImage: ''
    };
  },

  computed: {
    hasPosts: function hasPosts() {
      if (this.imagesToView.posts && this.imagesToView.posts.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.imagesToView.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var post = _step.value;

            if (post.instagramPostURL !== '' || post.images && post.images.length > 0) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return false;
    },
    hasStories: function hasStories() {
      if (this.imagesToView.stories && this.imagesToView.stories.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.imagesToView.stories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var post = _step2.value;

            if (post.label !== '' || post.images && post.images.length > 0) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return false;
    },
    hasDeliverablePosts: function hasDeliverablePosts() {
      if (this.imagesToView.deliverablePosts && this.imagesToView.deliverablePosts.length > 0) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.imagesToView.deliverablePosts), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var allPosts = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(allPosts.posts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var post = _step4.value;

                if (post.label !== '' || post.images && post.images.length > 0) {
                  return true;
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return false;
    }
  },
  methods: {
    viewMedia: function viewMedia(img) {
      this.activeImage = img;
      this.imageViewerDialog = true;
    },
    getPostType: function getPostType(type) {
      if (type === 'IGS') {
        return 'label';
      } else return 'url';
    },
    filterEmptyPosts: function filterEmptyPosts(posts) {
      posts = posts.filter(function (post) {
        if (post.label || post.images.length > 0) {
          return true;
        }
        return false;
      });
      return posts;
    },
    getLongPostTitle: function getLongPostTitle(title) {
      if (title === 'TTP') {
        return 'TikTok Post';
      } else if (title === 'IGP') {
        return 'IG Post';
      } else if (title === 'IGC') {
        return 'IG Carousel';
      } else if (title === 'IGS') {
        return 'IG Story';
      } else if (title === 'IGV') {
        return 'IG Video';
      } else if (title === 'IGR') {
        return 'IG Reel';
      } else return title;
    },
    getMediaType: function getMediaType(mediaUrl) {
      var videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4'];
      var images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP'];
      var url = new URL(mediaUrl);
      var extension = url.pathname.split('.')[4];
      if (videos.includes(extension)) {
        return 'video';
      } else if (images.includes(extension)) {
        return 'image';
      } else {
        return 'image';
      }
    }
  }
});

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paymentAPIs__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reports_LegendIcon__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reports_LegendIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_reports_LegendIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_sumBy__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_orderBy__);













var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfitSummaryDataTable',
  components: {
    LegendIcon: __WEBPACK_IMPORTED_MODULE_5__components_reports_LegendIcon___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      headers: [{
        text: 'Campaign Creation Date',
        value: 'createdAt',
        align: 'start'
      }, {
        text: 'IO Number',
        value: 'IONumber',
        align: 'start'
      }, {
        text: 'Client Name',
        value: 'clientName',
        align: 'start'
      }, {
        text: 'Campaign Name',
        value: 'name',
        align: 'start'
      }, {
        text: 'Budget',
        value: 'budget',
        align: 'start'
      }, {
        text: 'COGS',
        value: 'cogsTotal',
        align: 'start'
      }, {
        text: 'Target COGS',
        value: 'targetCOGS',
        align: 'start'
      }, {
        text: 'COGS Savings',
        value: 'savingCOGS',
        align: 'start'
      }, {
        text: 'Gross Profit',
        legendText: 'Budget - COGS',
        value: 'grossProfit',
        align: 'start'
      }],
      items: [],
      filterQuaters: [{
        label: 'Q1',
        value: 'Q1'
      }, {
        label: 'Q2',
        value: 'Q2'
      }, {
        label: 'Q3',
        value: 'Q3'
      }, {
        label: 'Q4',
        value: 'Q4'
      }],
      filter: '',
      filteredItems: [],
      selectedFilter: {
        startDate: '',
        endDate: '',
        quarter: '',
        reload: false
      },
      startDate: '',
      endDate: '',
      startDateCal: false,
      endDateCal: false,
      totalValues: {
        profit: 0
      },
      isLoading: false,
      createCogsEstimateDialog: false,
      currentMthProfit: 0,
      dataTableFilteredItems: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    profitSummary: function profitSummary(state) {
      return state.payment.profitSummary;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('payment', ['formatDate']), {
    currentMonthLabel: function currentMonthLabel() {
      return moment().format('MMM YYYY');
    },

    showFilterDate: function showFilterDate() {
      if (this.selectedFilter.startDate || this.selectedFilter.endDate) {
        var respDateStr = 'for ';
        if (this.selectedFilter.startDate) {
          respDateStr += __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.formatCustomDate(this.selectedFilter.startDate, 'MMM YYYY');
        }
        if (this.selectedFilter.startDate && this.selectedFilter.endDate) {
          respDateStr += ' - ';
        }
        if (this.selectedFilter.endDate) {
          respDateStr += __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.formatCustomDate(this.selectedFilter.endDate, 'MMM YYYY');
        }
        return respDateStr;
      }
      return '';
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.init();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.startDate = moment().format('YYYY') + '-01';
                _this2.endDate = moment().format('YYYY') + '-12';
                _context2.next = 4;
                return _this2.getCurrentMonthProfit();

              case 4:
                _this2.getProfitSumary();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getCurrentMonthProfit: function getCurrentMonthProfit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var items;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoading = true;
                _context3.next = 3;
                return _this3.$store.dispatch('payment/getProfitSummary', {
                  filters: {
                    startDate: moment().format('YYYY-MM'),
                    endDate: moment().format('YYYY-MM')
                  }
                });

              case 3:
                items = _this3.beautifyData();

                _this3.currentMthProfit = Number(__WEBPACK_IMPORTED_MODULE_10_lodash_sumBy___default()(items, function (item) {
                  return Number(item.grossProfit);
                }));
                _this3.currentMthProfit = _this3.currentMthProfit.toFixed(2);
                _this3.isLoading = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getProfitSumary: function getProfitSumary() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoading = true;
                _this4.selectedFilter.startDate = _this4.startDate;
                _this4.selectedFilter.endDate = _this4.endDate;
                _context4.next = 5;
                return _this4.$store.dispatch('payment/getProfitSummary', {
                  filters: _this4.selectedFilter
                });

              case 5:
                _this4.searchFilter();
                _this4.calcTotalSummary(_this4.filteredItems);
                _this4.isLoading = false;
                _this4.selectedFilter.reload = false;

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    beautifyData: function beautifyData() {
      var items = [];
      this.profitSummary.map(function (p) {
        if (p.campaigns && Array.isArray(p.campaigns)) {
          var _items;

          (_items = items).push.apply(_items, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(p.campaigns));
        }
      });
      items = items.map(function (item) {
        item.cogsTotal = Number(item.cogsTotal).toFixed(2);
        item.grossProfit = Number(item.grossProfit).toFixed(2);
        return item;
      });
      return items;
    },
    searchFilter: function searchFilter() {
      this.items = this.beautifyData();
      this.filteredItems = this.items.map(function (i) {
        return i;
      });
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_11_lodash_orderBy___default()(this.filteredItems, ['createdAt'], ['desc']);

      if (this.selectedFilter.quarter) {
        var currentYear = moment().format('YYYY');
        if (this.selectedFilter.quarter === 'Q1') {
          this.startDate = currentYear + '-01';
          this.endDate = currentYear + '-03';
        } else if (this.selectedFilter.quarter === 'Q2') {
          this.startDate = currentYear + '-04';
          this.endDate = currentYear + '-06';
        } else if (this.selectedFilter.quarter === 'Q3') {
          this.startDate = currentYear + '-07';
          this.endDate = currentYear + '-09';
        } else if (this.selectedFilter.quarter === 'Q4') {
          this.startDate = currentYear + '-10';
          this.endDate = currentYear + '-12';
        }
        this.selectedFilter.startDate = this.startDate;
        this.selectedFilter.endDate = this.endDate;
      }
    },
    changeQuater: function changeQuater(item) {
      var _this5 = this;

      this.filterQuaters = this.filterQuaters.map(function (ct) {
        if (ct.value === item) {
          if (!ct.selected) {
            ct.selected = true;
            _this5.selectedFilter.quarter = ct.value;
          } else {
            _this5.selectedFilter.quarter = '';
            ct.selected = false;
            _this5.init();
          }
        } else {
          ct.selected = false;
        }
        return ct;
      });
      this.getProfitSumary();
    },
    resetTotalValues: function resetTotalValues() {
      this.totalValues = {
        profit: 0
      };
    },
    calcTotalSummary: function calcTotalSummary() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.resetTotalValues();
      if (!items.length) {
        return;
      }
      this.totalValues.profit = Number(__WEBPACK_IMPORTED_MODULE_10_lodash_sumBy___default()(items, function (item) {
        return Number(item.grossProfit);
      }));
      this.totalValues.profit = this.totalValues.profit.toFixed(2);
    },
    getFiltered: function getFiltered() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.calcTotalSummary(_this6.$refs.ProfitSummaryTable.$children[0].filteredItems);
        _this6.dataTableFilteredItems = _this6.$refs.ProfitSummaryTable.$children[0].filteredItems;
      });
    },
    formatDateTime: function formatDateTime(createdAt) {
      return moment(createdAt).format('DD/MM/YYYY');
    },
    downloadProfitSummaryRpt: function downloadProfitSummaryRpt() {
      var _this7 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_4__paymentAPIs__["a" /* default */].downloadProfitSummaryRpt(this.dataTableFilteredItems).then(function () {
        _this7.isLoading = false;
      }).catch(function (error) {
        _this7.isLoading = false;
        console.log('error in downloading profit summary report', error);
      });
    },
    reload: function reload() {
      this.selectedFilter.reload = true;
      this.selectedFilter.quarter = '';
      this.filterQuaters = this.filterQuaters.map(function (f) {
        f.selected = false;
        return f;
      });
      this.init();
    }
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profit-summary',
  components: {
    ProfitSummaryDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {
    reload: function reload() {
      this.isRefresh += 1;
    }
  }
});

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    total: Number,
    title: String,
    subtitle: String
  }
});

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_12_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    payments: Object,
    selectedPaymentStatus: Number
  },
  data: function data() {
    return {
      valid: true,
      isLoading: false,
      data: {
        bank_reference: '',
        payment_date: '',
        payment_submission_date: '',
        batch: '',
        payment_status: 0,
        actualAmount: 0
      },
      paidSearch: '',
      totalAmount: 0,
      paymentStatus: __WEBPACK_IMPORTED_MODULE_8__Campaign_config__["a" /* default */].paymentStatus,
      paymentConsSectionIDs: __WEBPACK_IMPORTED_MODULE_8__Campaign_config__["a" /* default */].paymentConsSectionIDs,
      showStatuses: [],
      batches: ['Batch 1', 'Batch 2'],
      currencyTotals: {},
      MessageRules: [function (value) {
        return !!value || 'Required.';
      }],
      utilsFunc: __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])({
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    },
    paymentUpdateFields: function paymentUpdateFields(state) {
      return state.payment.paymentUpdateFields;
    },
    savedCompletedPayments: function savedCompletedPayments(state) {
      return state.payment.savedCompletedPayments;
    },
    currencyRates: function currencyRates(state) {
      return state.payment.currencyRates;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])('payment', ['paymentStatusOptions', 'allowedStatuses']), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isAdmin: function isAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    }
  }),
  methods: {
    getPaymentStatus: function getPaymentStatus(statusVal) {
      var statusText = '-';
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.paymentStatuses).forEach(function (item) {
        if (statusVal === item[1].value) {
          statusText = item[1].text;
        }
      });
      return statusText;
    },
    save: function save() {
      var _this2 = this;

      if (!this.$refs.paymentForm.validate()) {
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var savePayments = [];
          var hasDisabled = false;
          _this2.payments.map(function (item) {
            if (_this2.checkDisabled(item)) {
              hasDisabled = true;
            } else {
              savePayments.push(item);
            }
          });
          if (hasDisabled) {
            _this2.$swal({
              html: 'Please Enter SwiftCode, Bank Account, Payee Name, Country, Bank Name and Email.',
              type: 'warning'
            }).then(function (result) {
              if (result.value) {
                if (savePayments.length) {
                  _this2.saveEditedPayment(savePayments);
                }
              }
            });
          } else {
            if (savePayments.length) {
              _this2.saveEditedPayment(savePayments);
            }
          }
        }
      });
    },
    saveEditedPayment: function saveEditedPayment(savePayments) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                updateData = savePayments.map(function (item) {
                  var updateObj = {};
                  updateObj.id = item.id;
                  updateObj.handle = item.instagram;
                  if (item.influencerID) {
                    updateObj.influencerID = item.influencerID;
                  }
                  updateObj.campaignID = item.campaignID;
                  updateObj.type = item.type;
                  if (item.reportID) {
                    updateObj.reportUpdateID = item.reportID;
                  } else {
                    updateObj.reportUpdateID = item.id;
                  }
                  if (item.campaign) {
                    updateObj.campaignID = item.campaign.id;
                  }
                  if (item.imported && item.imported !== undefined) {
                    updateObj.imported = item.imported;
                  }
                  if (_this3.data.payment_date !== '') {
                    updateObj.payment_date = _this3.data.payment_date;
                  }
                  if (_this3.data.payment_submission_date !== '') {
                    updateObj.payment_submission_date = _this3.data.payment_submission_date;
                  }
                  if (_this3.data.payment_status !== _this3.paymentStatus.NEW) {
                    updateObj.payment_status = _this3.data.payment_status;
                  }
                  if (_this3.data.bank_reference !== '') {
                    updateObj.bank_reference = _this3.data.bank_reference;
                  }
                  if (_this3.data.PVNumber !== '') {
                    updateObj.PVNumber = _this3.data.PVNumber;
                  }
                  if (_this3.data.batchNo !== '') {
                    updateObj.batchNo = _this3.data.batchNo;
                  }
                  if (item.currency !== '') {
                    updateObj.currency = item.currency;
                  }
                  if (item.actualAmount) {
                    updateObj.actualAmount = item.actualAmount;
                  }
                  var newPOC = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                    id: _this3.currentUserID,
                    timestamp: __WEBPACK_IMPORTED_MODULE_11_moment___default()().toISOString()
                  });
                  var POC = item.POC || [];
                  var oldPOC = POC.find(function (p) {
                    return p.id === _this3.currentUserID;
                  });
                  if (!oldPOC) {
                    POC.unshift(newPOC);
                    updateObj.POC = POC;
                  }
                  return updateObj;
                });
                _context3.next = 3;
                return _this3.saveCompletedPayments(savePayments, updateData);

              case 3:
                _this3.isLoading = true;
                __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__["a" /* default */].savePaymentConsolidatedData(updateData).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this3.isLoading = false;
                            _this3.close();
                            _this3.$emit('updated', updateData);

                            _this3.$swal({
                              text: 'Payment Updated',
                              type: 'success'
                            });

                          case 4:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  _this3.isLoading = false;

                  console.log('error', error);
                  _this3.$swal({
                    text: error,
                    type: 'error'
                  });
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    saveCompletedPayments: function saveCompletedPayments(selectedPayments, updatePayments) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var preProcessingPayments, importedPayments, financePayments, completedPayments, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, saveData, _saveData, _saveData2, _saveData3;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                preProcessingPayments = [];
                importedPayments = [];
                financePayments = [];
                completedPayments = [];

                _loop = function _loop(data) {
                  if (data.payment_status === _this4.paymentStatus.PROCESSING && !data.imported) {
                    var spIdx = selectedPayments.findIndex(function (s) {
                      return s.id === data.id;
                    });
                    if (selectedPayments[spIdx]) {
                      preProcessingPayments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, selectedPayments[spIdx], data));
                    }
                  } else {
                    if (data.payment_status === _this4.paymentStatus.PROCESSING && data.imported) {
                      var _spIdx = selectedPayments.findIndex(function (s) {
                        return s.id === data.id;
                      });
                      if (selectedPayments[_spIdx]) {
                        importedPayments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, selectedPayments[_spIdx], data));
                      }
                    }
                  }
                  if (data.payment_status === _this4.paymentStatus.PARTIAL || data.payment_status === _this4.paymentStatus.APPROVAL_FINANCE) {
                    var _spIdx2 = selectedPayments.findIndex(function (s) {
                      return s.id === data.id;
                    });
                    if (selectedPayments[_spIdx2]) {
                      financePayments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, selectedPayments[_spIdx2], data));
                    }
                  }
                  if (data.payment_status === _this4.paymentStatus.PAID) {
                    var _spIdx3 = selectedPayments.findIndex(function (s) {
                      return s.id === data.id;
                    });
                    if (selectedPayments[_spIdx3]) {
                      completedPayments.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, selectedPayments[_spIdx3], data));
                    }
                  }
                };

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 8;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(updatePayments); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;

                  _loop(data);
                }
                _context4.next = 16;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 16:
                _context4.prev = 16;
                _context4.prev = 17;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 19:
                _context4.prev = 19;

                if (!_didIteratorError) {
                  _context4.next = 22;
                  break;
                }

                throw _iteratorError;

              case 22:
                return _context4.finish(19);

              case 23:
                return _context4.finish(16);

              case 24:
                if (!preProcessingPayments.length) {
                  _context4.next = 32;
                  break;
                }

                _context4.next = 27;
                return _this4.buildPaymentsData(preProcessingPayments);

              case 27:
                saveData = _context4.sent;

                if (saveData) {
                  _context4.next = 30;
                  break;
                }

                return _context4.abrupt('return');

              case 30:
                _context4.next = 32;
                return _this4.$store.dispatch('payment/savePreProcessingPayments', {
                  data: saveData
                });

              case 32:
                if (!importedPayments.length) {
                  _context4.next = 40;
                  break;
                }

                _context4.next = 35;
                return _this4.buildPaymentsData(importedPayments);

              case 35:
                _saveData = _context4.sent;

                if (_saveData) {
                  _context4.next = 38;
                  break;
                }

                return _context4.abrupt('return');

              case 38:
                _context4.next = 40;
                return _this4.$store.dispatch('payment/saveImportedPayments', {
                  data: _saveData
                });

              case 40:
                if (!financePayments.length) {
                  _context4.next = 48;
                  break;
                }

                _context4.next = 43;
                return _this4.buildPaymentsData(financePayments);

              case 43:
                _saveData2 = _context4.sent;

                if (_saveData2) {
                  _context4.next = 46;
                  break;
                }

                return _context4.abrupt('return');

              case 46:
                _context4.next = 48;
                return _this4.$store.dispatch('payment/saveFinancePayments', {
                  data: _saveData2
                });

              case 48:
                if (!completedPayments.length) {
                  _context4.next = 56;
                  break;
                }

                _context4.next = 51;
                return _this4.buildPaymentsData(completedPayments);

              case 51:
                _saveData3 = _context4.sent;

                if (_saveData3) {
                  _context4.next = 54;
                  break;
                }

                return _context4.abrupt('return');

              case 54:
                _context4.next = 56;
                return _this4.$store.dispatch('payment/saveCompletedPayments', {
                  data: _saveData3,
                  emailToCreator: true
                });

              case 56:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[8, 12, 16, 24], [17,, 19, 23]]);
      }))();
    },
    buildPaymentsData: function buildPaymentsData(payments) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, _loop2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, payment, _ret2;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                data = [];
                _loop2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _loop2(payment) {
                  var _newObj, newObj, pairings, matchPairing;

                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _loop2$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!payment.reportID) {
                            _context5.next = 11;
                            break;
                          }

                          payment.status = payment.payment_status;
                          _newObj = {
                            reportID: payment.reportID,
                            pairingID: payment.pairingID,
                            influencer_details: payment.influencer_details,
                            transaction_details: payment.transaction_details,
                            deliverables: payment.deliverables,
                            invoices: payment.invoices,
                            campaign: payment.campaign,
                            batch: payment.batch || '',
                            CC: payment.CC,
                            liveDate: payment.liveDate,
                            dueDate: payment.dueDate,
                            status: payment.status
                          };

                          if (payment.deliverables) {
                            if (typeof payment.deliverables === 'string') {
                              _newObj.deliverables = {
                                agreed: payment.agreedDeliverables,
                                produced: payment.deliverables
                              };
                            } else {
                              _newObj.deliverables = payment.deliverables;
                            }
                          } else {
                            _newObj.deliverables = {
                              agreed: payment.agreedDeliverables || '',
                              produced: payment.deliverables || ''
                            };
                          }
                          if (payment.PVNumber) {
                            _newObj.transaction_details.PVNumber = payment.PVNumber;
                          }
                          if (payment.payment_date) {
                            _newObj.transaction_details.paymentDate = payment.payment_date;
                          }
                          if (payment.bank_reference) {
                            _newObj.transaction_details.bankReference = payment.bank_reference;
                          }
                          if (payment.imported) {
                            _newObj.imported = payment.imported;
                          }
                          if (payment.payment_status === _this5.paymentStatus.PROCESSING || payment.payment_status === _this5.paymentStatus.PARTIAL || payment.payment_status === _this5.paymentStatus.APPROVAL_FINANCE) {
                            if (payment.id) {
                              _newObj.id = payment.id;
                            }
                          }
                          data.push(_newObj);
                          return _context5.abrupt('return', 'continue');

                        case 11:
                          newObj = {
                            reportID: payment.id,
                            pairingID: payment.pairingID,
                            influencer_details: {},
                            transaction_details: {},
                            deliverables: {},
                            invoices: {}
                          };
                          _context5.next = 14;
                          return __WEBPACK_IMPORTED_MODULE_7__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(payment.campaignID);

                        case 14:
                          pairings = _context5.sent;
                          matchPairing = pairings.find(function (pairing) {
                            return pairing.influencer_details && pairing.influencer_details.instagramHandle === payment.handle;
                          });

                          if (matchPairing) {
                            newObj.influencer_details = matchPairing.influencer_details;

                            newObj.influencer_details.handle = payment.handle;
                            delete newObj.influencer_details.instagramHandle;
                          }
                          newObj.influencer_details.bankName = payment.bankName || '';
                          newObj.influencer_details.bankAccount = payment.bankAccount || '';
                          newObj.influencer_details.swiftCode = payment.swiftCode || '';
                          newObj.influencer_details.username = payment.username || '';
                          newObj.influencer_details.email = payment.email || '';

                          newObj.transaction_details = {
                            PVNumber: payment.PVNumber || '',
                            bankReference: payment.bank_reference,
                            submissionDate: payment.payment_submission_date,
                            paymentDate: payment.payment_date,
                            GSTPercent: payment.GSTPercent || null,
                            specialPayment: payment.specialPayment || false,
                            currency: payment.currency || 'SGD',
                            pairedAmount: parseFloat(payment.pairedAmount),
                            amount: parseFloat(payment.amount),
                            remainAmount: 0
                          };
                          if (payment.actualAmount) {
                            newObj.transaction_details.actualAmount = payment.actualAmount;
                          }

                          newObj.campaign = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                            id: payment.campaignID,
                            name: payment.campaignName,
                            clientName: payment.clientName,
                            IONumber: payment.IONumber
                          });

                          if (payment.deliverables) {
                            if (typeof payment.deliverables === 'string') {
                              newObj.deliverables = {
                                agreed: payment.agreedDeliverables,
                                produced: payment.deliverables || ''
                              };
                            } else {
                              newObj.deliverables = payment.deliverables;
                            }
                          } else {
                            newObj.deliverables = {
                              agreed: payment.agreedDeliverables || '',
                              produced: payment.deliverables || ''
                            };
                          }

                          if (payment.invoice) {
                            newObj.invoices.internalInvoice = payment.invoice;
                          }
                          if (payment.uploadInvoice) {
                            newObj.invoices.uploadInvoice = payment.uploadInvoice;
                          }

                          if (payment.imported) {
                            newObj.imported = payment.imported;

                            newObj.transaction_details.remainAmount = parseFloat(payment.pairedAmount - payment.amount);
                          }
                          newObj.batch = payment.batch || '';
                          newObj.CC = payment.CC;
                          newObj.liveDate = payment.liveDate || '';
                          newObj.dueDate = payment.dueDate || '';
                          newObj.status = payment.payment_status;
                          data.push(newObj);

                        case 35:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _loop2, _this5);
                });
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 6;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(payments);

              case 8:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 17;
                  break;
                }

                payment = _step2.value;
                return _context6.delegateYield(_loop2(payment), 't0', 11);

              case 11:
                _ret2 = _context6.t0;

                if (!(_ret2 === 'continue')) {
                  _context6.next = 14;
                  break;
                }

                return _context6.abrupt('continue', 14);

              case 14:
                _iteratorNormalCompletion2 = true;
                _context6.next = 8;
                break;

              case 17:
                _context6.next = 23;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t1 = _context6['catch'](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t1;

              case 23:
                _context6.prev = 23;
                _context6.prev = 24;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 26:
                _context6.prev = 26;

                if (!_didIteratorError2) {
                  _context6.next = 29;
                  break;
                }

                throw _iteratorError2;

              case 29:
                return _context6.finish(26);

              case 30:
                return _context6.finish(23);

              case 31:
                return _context6.abrupt('return', data);

              case 34:
                _context6.prev = 34;
                _context6.t2 = _context6['catch'](0);
                return _context6.abrupt('return', false);

              case 37:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee5, _this5, [[0, 34], [6, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    checkDisabled: function checkDisabled(item) {
      if (item.payment_status === this.paymentStatus.PROCESSING) {
        if (!item.swiftCode || !item.bankAccount || !item.username) {
          return true;
        }
      }
      return false;
    },
    showField: function showField(fieldName) {
      var matchField = this.paymentUpdateFields.find(function (field) {
        return field.name === fieldName;
      });
      if (matchField) {
        return matchField.permissions.includes(this.currentUserRole) && matchField.status.includes(this.data.payment_status);
      }
      return false;
    },
    resetForm: function resetForm() {
      this.data = {
        bank_reference: '',
        payment_date: '',
        payment_submission_date: '',
        batch: '',
        payment_status: 0
      };
      this.valid = true;
    },
    close: function close() {
      this.$emit('input');
    },
    setDefaultPaymentForSelect: function setDefaultPaymentForSelect(batchNo) {
      if (batchNo === this.paymentConsSectionIDs.IMPORTED || batchNo === this.paymentConsSectionIDs.BATCH_ONE || batchNo === this.paymentConsSectionIDs.BATCH_TWO) {
        this.data.payment_status = this.paymentStatus.APPROVAL_FINANCE;
      }
      if (batchNo === this.paymentConsSectionIDs.APPROVAL_FINANCE) {
        this.data.payment_status = this.paymentStatus.PARTIAL;
      }
      if (batchNo === this.paymentConsSectionIDs.APPROVAL_LEAD) {
        this.data.payment_status = this.paymentStatus.PARTIAL;
      }
      if (batchNo === this.paymentConsSectionIDs.WIP_FINANCE) {
        this.data.payment_status = this.paymentStatus.PAID;
      }
    },
    changeStatus: function changeStatus() {
      this.selectedPaymentStatus = this.data.payment_status;
    },
    detectCurrency: function detectCurrency(items) {
      var _this6 = this;

      var currencies = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].currencies;
      currencies.map(function (c) {
        _this6.currencyTotals[c] = 0;
      });
      items.map(function (item) {
        if (item.currency !== 'SGD') {
          _this6.currencyTotals['SGD'] += Number(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.convertCurrency(item.currency, Number(item.amount), _this6.currencyRates));
        }
        _this6.currencyTotals[item.currency] += Number(item.amount || 0);
      });

      for (var currency in this.currencyTotals) {
        if (this.currencyTotals.hasOwnProperty(currency)) {
          if (this.currencyTotals[currency] > 0) {
            this.currencyTotals[currency] = this.currencyTotals[currency].toFixed(2);
          }
        }
      }
    }
  },
  watch: {
    payments: function payments(newPayments) {
      var _this7 = this;

      this.totalAmount = 0;
      this.totalAmount += newPayments.map(function (payment) {
        return payment.amount || 0;
      }).reduce(function (amt1, amt2) {
        return Number(amt1) + Number(amt2);
      }, 0);
      this.totalAmount = this.totalAmount.toFixed(2);
      this.detectCurrency(newPayments);

      if (this.isAdmin) {
        this.showStatuses = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.allowedStatuses);
      } else this.showStatuses = this.allowedStatuses.filter(function (al) {
        return al.allowedStatusChange.includes(_this7.selectedPaymentStatus);
      });
      this.resetForm();
      if (newPayments.length) {
        this.setDefaultPaymentForSelect(newPayments[0].batchNo);
      }
    }
  }
});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__scoped_custom_CustomFileUpload__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7_vuelidate__["validationMixin"]],
  props: {
    value: Boolean
  },
  validations: {
    payout: {
      campaign: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      handle: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      bankAccountNo: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      receivingName: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      amount: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      }
    }
  },
  components: {
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_14__scoped_custom_CustomFileUpload___default.a
  },
  data: function data() {
    return {
      payout: {
        campaign: null,
        handle: null,
        bankAccountNo: null,
        bankSwiftCode: null,
        receivingName: null,
        amount: '',
        chkGST: false,
        remarks: ''
      },
      pickDate: false,
      search: null,
      campaigns: [],
      influencers: [],
      invoiceFiles: [],
      fileUploadRefresh: 1,
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapState */])({
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapGetters */])('payment', ['paymentStatusOptions']), {
    selectedCampaignErrors: function selectedCampaignErrors() {
      var errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    bankNoErrors: function bankNoErrors() {
      var errors = [];
      if (!this.$v.payout.bankAccountNo.$dirty) return errors;
      !this.$v.payout.bankAccountNo.required && errors.push('This field is required.');
      return errors;
    },
    receivingNameErrors: function receivingNameErrors() {
      var errors = [];
      if (!this.$v.payout.receivingName.$dirty) return errors;
      !this.$v.payout.receivingName.required && errors.push('This field is required.');
      return errors;
    },
    handleErrors: function handleErrors() {
      var errors = [];
      if (!this.$v.payout.handle.$dirty) return errors;
      !this.$v.payout.handle.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors: function amountErrors() {
      var errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    campaignStatus: function campaignStatus() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].campaignStatus).join();
    }
  }),
  watch: {
    value: function value(newValue) {
      this.payout.campaign = null;
      this.resetForm();
    }
  },
  mounted: function mounted() {
    this.fetchCampaigns();
  },

  methods: {
    close: function close() {
      this.$emit('input');
    },
    savePayout: function savePayout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this.invoiceFiles.length) {
                  _context.next = 4;
                  break;
                }

                _this.$swal({
                  text: 'Please Upload Invoice',
                  type: 'error'
                });
                return _context.abrupt('return');

              case 4:
                _this.loading = true;
                formData = _this.constructData(_this.payout);
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_9__Campaign_campaignAPIs__["a" /* default */].savePaymentConsolidatedInvoice(formData);

              case 8:
                _this.loading = false;
                _this.$emit('created');
                _this.$emit('input');
                _this.$swal({
                  text: 'New invoice record is created',
                  type: 'success'
                });
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this.loading = false;
                _this.$swal({
                  text: _context.t0.message,
                  type: 'error'
                });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 14]]);
      }))();
    },
    fetchCampaigns: function fetchCampaigns() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resp, data, campaigns;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__Campaign_campaignAPIs__["a" /* default */].getAllCampaigns(_this2.campaignStatus, false);

              case 3:
                resp = _context2.sent;
                data = resp.data;
                campaigns = data.campaigns;

                _this2.campaigns = campaigns.map(function (cmp) {
                  return {
                    name: cmp.name,
                    id: cmp.id,
                    assignedTo: cmp.assignedTo,
                    clientID: cmp.clientID
                  };
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                _this2.$swal({
                  text: 'Cannot fetch the list of campaigns',
                  icon: 'error'
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    constructData: function constructData(input) {
      var formData = new FormData();
      var defaultCreateData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
        campaignID: input.campaign.id,
        influencerID: input.handle.influencerID || '',
        handle: input.handle.handle,
        platform: input.handle.platform,
        swift_code: input.bankSwiftCode,
        bank_account: input.bankAccountNo,
        amount: parseInt(input.amount),
        fullName: input.receivingName,
        GST: input.chkGST,
        remarks: input.remarks
      });
      formData.append('data', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(defaultCreateData));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoiceFiles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('uploadFile', val);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formData;
    },
    changeCampaign: function changeCampaign() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newValue, resp;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.resetForm();
                newValue = _this3.payout.campaign;

                if (!(newValue && newValue.name)) {
                  _context3.next = 14;
                  break;
                }

                _context3.prev = 3;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(newValue.id);

              case 6:
                resp = _context3.sent;

                _this3.setInfluencers(resp);
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](3);

                console.log(_context3.t0);
                _this3.$swal({
                  text: 'Cannot fetch the list of Influencers',
                  icon: 'error'
                });

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 10]]);
      }))();
    },
    setInfluencers: function setInfluencers(resp) {
      this.influencers = resp.map(function (pairing) {
        if (pairing.influencer_details) {
          var influencerDetails = pairing.influencer_details;
          var payoutDetails = pairing.payout_details;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
            influencerID: influencerDetails.influencerID || '',
            handle: influencerDetails.instagramHandle,
            platform: influencerDetails.platform || 'instagram',
            amount: payoutDetails.amount || 0
          });
        }
      });
    },
    changeInfluencer: function changeInfluencer() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.payout.bankSwiftCode = null;
                _this4.payout.bankAccountNo = null;
                _this4.payout.receivingName = null;

                if (!_this4.payout.handle.influencerID) {
                  _context4.next = 17;
                  break;
                }

                _context4.prev = 4;
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_11__Influencer_influencerAPIs__["a" /* default */].getInfluencer(_this4.payout.handle.influencerID);

              case 7:
                resp = _context4.sent;

                _this4.payout.bankSwiftCode = resp.swiftCode || '';
                _this4.payout.bankAccountNo = resp.bankAccount || '';
                _this4.payout.receivingName = resp.fullName || '';
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](4);

                console.log(_context4.t0);
                _this4.$swal({
                  text: 'Cannot fetch Influencer Data',
                  icon: 'error'
                });

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 13]]);
      }))();
    },
    resetForm: function resetForm() {
      this.payout.bankAccountNo = null;
      this.payout.receivingName = null;
      this.payout.handle = null;
      this.payout.bankSwiftCode = null;
      this.influencers = [];
      this.invoiceFiles = [];
      this.fileUploadRefresh += 1;
    },
    updateInvoices: function updateInvoices(medias) {
      this.invoiceFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], medias);
    }
  }
});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UploadedInvoiceListModal',
  props: ['value'],
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_7__components_scoped_custom_SocialHandle___default.a
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func,
      filteredItems: [],
      selectedItems: [],
      headers: [{ value: 'handle', text: 'IG Handle/Tiktok Handle', sortable: true }, { value: 'swiftCode', text: 'Swift Code', sortable: true }, { value: 'bankAccount', text: 'Bank A/C No.', sortable: true }, { value: 'username', text: 'Payee Name', sortable: true }, { value: 'amount', text: 'Amount', sortable: true }, { value: 'clientName', text: 'Client Name', sortable: true }, { value: 'campaignName', text: 'Campaign Name', sortable: true }, { value: 'IONumber', text: 'Campaign IO Number', sortable: true }, { value: 'CO', text: 'CC', sortable: true }, { value: 'remarks', text: 'Remark', sortable: true }, { value: 'createdAt', text: 'Uploaded Date (DD/MM/YYYY)', sortable: true }, { value: 'action', text: 'Actions', sortable: true }],
      filter: {
        search: '',
        searchMonth: '',
        selectedMonth: '',
        monthPicker: false
      },
      panel: [0],
      disableSaveEdit: false,
      loading: false,
      CO: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    items: function items(state) {
      return state.campaign.invoiceLists;
    },
    invoiceDeleteSuccess: function invoiceDeleteSuccess(state) {
      return state.campaign.invoiceDeleteSuccess;
    },
    paymentStatuses: function paymentStatuses(state) {
      return state.payment.status;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('payment', ['paymentStatusOptions', 'allowedStatuses']), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isFinance: function isFinance() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.FINANCE) {
        return true;
      }
      return false;
    }
  }),
  watch: {
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(_value) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_value) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.getCOs();

              case 3:
                _context.next = 5;
                return this.getUploadedInvoiceLists();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function value(_x) {
        return _ref.apply(this, arguments);
      }

      return value;
    }()
  },
  methods: {
    getUploadedInvoiceLists: function getUploadedInvoiceLists() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.isLoading = true;
                _context2.next = 3;
                return _this.$store.dispatch('campaign/getUploadedInvoiceLists');

              case 3:
                _this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], _this.items);
                _this.filteredItems = _this.filteredItems.map(function (item) {
                  item.CO = _this.CO.filter(function (co) {
                    return item.assignedTo && item.assignedTo.includes(co.id);
                  }).map(function (co) {
                    return co.name;
                  }).join(', ');
                  return item;
                });
                _this.cancelEdit();
                _this.isLoading = false;
                _this.selectedItems = [];

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    openEditItem: function openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true;
      item.editInvoice = true;
      this.disableSaveEdit = false;
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
    },
    saveChanges: function saveChanges() {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this2.isLoading = true;
          var data = _this2.buildData();

          __WEBPACK_IMPORTED_MODULE_8__Campaign_campaignAPIs__["a" /* default */].updateReportInvoice(data).then(function (response) {
            _this2.isLoading = false;
            _this2.cancelEdit();

            _this2.$swal({
              text: 'Invoice Updated',
              type: 'success'
            });
            _this2.getUploadedInvoiceLists();
            _this2.$emit('updated');
            _this2.$emit('input');
          }).catch(function (error) {
            _this2.isLoading = false;

            console.log('error', error);
            _this2.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    buildData: function buildData() {
      var _this3 = this;

      var data = this.filteredItems.filter(function (item) {
        if (_this3.checkInvoiceUpdate(item)) return true;
        return false;
      });
      data = data.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
          id: item.id,
          influencerID: item.influencerID,
          handle: item.handle,
          campaignID: item.campaignID,
          swift_code: item.swiftCode,
          bank_account: item.bankAccount,
          fullName: item.username,
          amount: parseInt(item.amount),
          payment_date: item.paymentDate,
          payment_status: item.paymentStatus,
          bank_reference: item.bankReference,
          remarks: item.remarks
        });
      });
      return data;
    },
    formatPaymentStatus: function formatPaymentStatus(statusVal) {
      var statusText = '-';
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.paymentStatuses).forEach(function (item) {
        if (statusVal === item[1].value) {
          statusText = item[1].text;
        }
      });
      return statusText;
    },
    searchFilter: function searchFilter() {
      var _this4 = this;

      this.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.items);
      if (this.filter.searchMonth) {
        this.filteredItems = this.items.filter(function (b) {
          var searchMonth = _this4.utils.formatCustomDate(b.createdAt, 'YYYY-MM');

          return searchMonth === _this4.filter.searchMonth;
        });
      }
    },
    cancelEdit: function cancelEdit() {
      var _this5 = this;

      this.filteredItems = this.filteredItems.map(function (item) {
        item = _this5.setDefaultEditFields(item);
        return item;
      });
      this.disableSaveEdit = true;
    },
    setDefaultEditFields: function setDefaultEditFields(obj) {
      obj.swiftCodeEdit = false;
      obj.bankAccountEdit = false;
      obj.usernameEdit = false;
      obj.paymentDateEdit = false;
      obj.bankReferenceEdit = false;
      obj.paymentStatusEdit = false;
      obj.remarksEdit = false;
      obj.editInvoice = false;
      return obj;
    },
    changePaymentStatus: function changePaymentStatus(item) {
      if (!this.checkPaymentStatus(item)) {
        this.$swal({
          text: 'Please Enter SwiftCode, Bank Account and Payee Name.',
          type: 'warning'
        });
      }
    },
    checkPaymentStatus: function checkPaymentStatus(item) {
      if ((!item.swiftCode || !item.bankAccount || !item.username) && item.paymentStatus === this.paymentStatuses.PAID.value) return false;
      return item.editInvoice || false;
    },
    checkInvoiceUpdate: function checkInvoiceUpdate(item) {
      var isInvoiceValid = true;
      if (!item.editInvoice || item.editInvoice === false) {
        isInvoiceValid = false;
      }
      isInvoiceValid = this.checkPaymentStatus(item);
      return isInvoiceValid;
    },
    downloadInvoices: function downloadInvoices() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this6.selectedItems);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 13;
                  break;
                }

                item = _step.value;

                if (!item.invoice) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 10;
                return __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.downloadFile(item.handle + '_invoice', item.invoice.url);

              case 10:
                _iteratorNormalCompletion = true;
                _context3.next = 5;
                break;

              case 13:
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 19:
                _context3.prev = 19;
                _context3.prev = 20;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 22:
                _context3.prev = 22;

                if (!_didIteratorError) {
                  _context3.next = 25;
                  break;
                }

                throw _iteratorError;

              case 25:
                return _context3.finish(22);

              case 26:
                return _context3.finish(19);

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[3, 15, 19, 27], [20,, 22, 26]]);
      }))();
    },
    selectAllItems: function selectAllItems($event) {
      if ($event.value && $event.items.length === 0 || !$event.value) {
        this.selectedItems = [];
        return;
      }
      if (this.selectedItems.length === 0) {
        this.selectedItems = $event.items;
      } else this.selectedItems = [];
    },
    searchMonthOk: function searchMonthOk() {
      this.filter.monthPicker = false;
      this.searchFilter();
    },
    cancelMonth: function cancelMonth() {
      this.filter.monthPicker = false;
      this.filter.searchMonth = '';
      this.searchFilter();
    },
    deleteInvoice: function deleteInvoice(items) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to delete?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(result) {
                    var selectedIds;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!result.value) {
                              _context4.next = 5;
                              break;
                            }

                            selectedIds = items.map(function (item) {
                              return item.id;
                            });
                            _context4.next = 4;
                            return _this7.$store.dispatch('campaign/deleteInvoiceByIds', {
                              ids: selectedIds
                            });

                          case 4:
                            if (_this7.invoiceDeleteSuccess) {
                              _this7.$swal({
                                text: 'Invoice Deleted',
                                type: 'success'
                              });
                              _this7.getUploadedInvoiceLists();
                              _this7.$emit('updated');
                              _this7.$emit('input');
                            }

                          case 5:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this7);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    openEditModal: function openEditModal(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.close();
                item.instagram = item.handle;
                item.paymentSubmissionDate = item.payment_submission_date;
                item.update = true;
                _this8.$emit('openEdit', item);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    getCOs: function getCOs() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST);

              case 2:
                response = _context7.sent;

                if (response) {
                  _this9.CO = response.users;
                  _this9.CO = _this9.CO.map(function (co) {
                    co.name = co.firstName + ' ' + co.lastName;
                    return co;
                  });
                }

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'payouts-report',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      campaignReportHeaders: [{
        'text': 'Client Name',
        'align': 'start',
        'value': 'clientName',
        'sortable': true
      }, {
        'text': 'Campaign Name',
        'align': 'center',
        'sortable': true,
        'value': 'name'
      }, {
        'text': 'IO Number',
        'align': 'center',
        'sortable': true,
        'value': 'ioNumbers'
      }, {
        'text': 'Vertical',
        'align': 'center',
        'sortable': true,
        'value': 'vertical'
      }, {
        'text': 'Total IO Budget',
        'align': 'center',
        'sortable': true,
        'value': 'IOAmount'
      }, {
        'text': 'COGS Amount',
        'align': 'center',
        'sortable': true,
        'value': 'cogs'
      }, {
        'text': 'Revenue Recognize',
        'align': 'center',
        'sortable': true,
        'value': 'revenue'
      }, {
        'text': 'NPS',
        'align': 'center',
        'sortable': true,
        'value': 'nps'
      }, {
        'text': 'Average Influencer Ratings',
        'align': 'center',
        'sortable': true,
        'value': 'avgInfluencerRatings'
      }, {
        'text': 'Average Client Ratings',
        'align': 'center',
        'sortable': true,
        'value': 'avgClientRatings'
      }, {
        'text': 'Amount Paid to Creators',
        'align': 'center',
        'sortable': true,
        'value': 'amountPaid'
      }],
      detailsHeaders: [{
        'text': 'Handle',
        'align': 'start',
        'value': 'handle',
        'sortable': true
      }, {
        'text': 'Following',
        'align': 'start',
        'value': 'following',
        'sortable': true
      }, {
        'text': 'Engagement Rate',
        'align': 'start',
        'value': 'engagementRate',
        'sortable': true
      }, {
        'text': 'Status',
        'align': 'start',
        'value': 'status',
        'sortable': true
      }, {
        'text': 'Amount',
        'align': 'start',
        'value': 'amount',
        'sortable': true
      }, {
        'text': 'Live Date',
        'align': 'start',
        'value': 'liveDate',
        'sortable': true
      }, {
        'text': 'Payment Date',
        'align': 'start',
        'value': 'paymentDate',
        'sortable': true
      }, {
        'text': 'Payee Name',
        'align': 'start',
        'value': 'payeeName',
        'sortable': true
      }, {
        'text': 'Bank A/C No.',
        'align': 'start',
        'value': 'bankACNo',
        'sortable': true
      }, {
        'text': 'Swift Code',
        'align': 'start',
        'value': 'swiftCode',
        'sortable': true
      }, {
        'text': 'BIB REF',
        'align': 'start',
        'value': 'BIBRef',
        'sortable': true
      }, {
        'text': 'FT REF',
        'align': 'start',
        'value': 'FTRef',
        'sortable': true
      }, {
        'text': 'Deliverable',
        'align': 'start',
        'value': 'deliverable',
        'sortable': true
      }, {
        'text': 'Rating from Influencer',
        'align': 'start',
        'value': 'influencerRating',
        'sortable': true
      }, {
        'text': 'Date paid to influencer',
        'align': 'start',
        'value': 'paidDate',
        'sortable': true
      }, {
        'text': 'Source',
        'align': 'start',
        'value': 'source',
        'sortable': true
      }],
      campaignReportData: [],
      billingFilterItems: [],
      campaignFilterItems: [],
      billingSelectedFilter: '',
      campaignSelectedFilter: '',

      currentFilter: {},
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['user']), {
    currentUserRole: function currentUserRole() {
      return this.user.role;
    },
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resp, clientResp, clientIDs;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.campaignReportDataObject = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this.campaignReportData, []);
              if (_this.$route.query.id) {
                _this.campaignSelectedFilter = _this.$route.query.id;
              }
              _context.prev = 2;

              _this.search({});
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__["a" /* default */].getUnfinishedCampaigns();

            case 6:
              resp = _context.sent;

              _this.campaignFilterItems = resp;
              _this.campaignFilterItems.unshift({ id: '', name: 'All Campaigns' });
              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_8__Client_clientAPIs__["a" /* default */].getAllClients();

            case 11:
              clientResp = _context.sent;

              _this.billingFilterItems = clientResp.data;
              clientIDs = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(_this.campaignFilterItems.map(function (c) {
                return c.clientID;
              }))));

              _this.billingFilterItems = _this.billingFilterItems.filter(function (b) {
                return clientIDs.includes(b.id);
              });
              _this.billingFilterItems.unshift({ id: '', name: 'All Clients' });
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context['catch'](2);

              console.log(_context.t0);
              _this.$swal({
                text: 'Cannot fetch required data!',
                icon: 'error'
              });

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 18]]);
    }))();
  },

  methods: {
    getInfluencerReport: function getInfluencerReport(filter) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__Campaign_campaignAPIs__["a" /* default */].getCampaignsInfluencerReport(filter);

              case 4:
                result = _context2.sent;

                if (result) {
                  _this2.campaignReportData = result.groups;
                }
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                _this2.$swal({
                  text: 'Cannot fetch Influencer Report',
                  icon: 'error'
                });

              case 12:
                _context2.prev = 12;

                _this2.isLoading = false;
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8, 12, 15]]);
      }))();
    },
    getColor: function getColor(minusNumber) {
      if (minusNumber) {
        if (minusNumber.toString().indexOf('-') !== -1) return 'red';
      }
    },
    search: function search(filter) {
      if (!filter) {
        filter = this.currentFilter;
      }
      var allFilter = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(filter, {
        clientID: this.billingSelectedFilter,
        campaignID: this.campaignSelectedFilter
      });
      this.currentFilter = allFilter;
      this.getInfluencerReport(allFilter);
    },
    clearFilter: function clearFilter() {
      this.billingSelectedFilter = '';
      this.campaignSelectedFilter = '';
      this.getInfluencerReport(this.filter);
    }
  }
});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a },
  data: function data() {
    return {
      reportData: null,
      isLoading: false
    };
  },

  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value: function value(_value) {
      if (_value) {
        this.reportData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
        this.clearForm();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])(['user']), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  validations: {
    reportData: {
      note: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    saveNote: function saveNote() {
      var _this = this;

      if (this.reportData !== null) {
        var formData = new FormData();
        formData.append('reportID', this.reportData.id);
        formData.append('note', this.reportData.note);
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__["a" /* default */].saveReportNote(formData).then(function (response) {
          _this.isLoading = false;
          _this.reportData.internalNotes = response.internalNotes;
          _this.beautifyData();
          _this.$swal({
            position: 'top-center',
            title: 'Successfully Saved Notes!',
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          });
          _this.$emit('savedNotes');
          _this.$emit('input');
        }).catch(function (error) {
          _this.isLoading = false;
          _this.$swal({
            position: 'top-center',
            title: 'Error while saving note',
            type: 'error',
            timer: 1500
          });
          console.log(error);
        });
      }
    },
    deleteNote: function deleteNote(fileIndex) {
      var _this2 = this;

      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete note?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          var updateNote = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], _this2.reportData.internalNotes);
          updateNote.splice(fileIndex, 1);
          var formData = new FormData();
          formData.append('reportID', _this2.reportData.id);
          formData.append('internalNotes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updateNote));
          _this2.isLoading = true;
          __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignAPIs__["a" /* default */].saveReportNote(formData).then(function (response) {
            _this2.reportData.internalNotes = updateNote;
            _this2.isLoading = false;

            _this2.$swal({
              text: 'Note Deleted',
              type: 'success'
            });
            _this2.$emit('savedNotes');
          }).catch(function (error) {
            console.log('error', error);
            _this2.isLoading = false;
          });
        }
      });
    },
    beautifyData: function beautifyData() {
      if (this.reportData.internalNotes !== undefined) {
        this.reportData.internalNotes = __WEBPACK_IMPORTED_MODULE_6_lodash_reverse___default()(this.reportData.internalNotes);
      }
    },
    showAction: function showAction(item) {
      if (item.author !== undefined) {
        if (item.author.id === this.currentUserID) {
          return true;
        }
      }
      return false;
    },
    clearForm: function clearForm() {
      this.reportData.note = '';
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).fromNow();
    }
  }
});

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scoped_custom_FullScreenProgress__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scoped_custom_FullScreenProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__scoped_custom_FullScreenProgress__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddInfluencerPairingModal',
  props: {
    selectedInfluencers: Array,
    value: Boolean
  },
  components: {
    FullScreenProgress: __WEBPACK_IMPORTED_MODULE_9__scoped_custom_FullScreenProgress___default.a
  },
  data: function data() {
    return {
      campaigns: [],
      selectedCampaign: '',
      selected: [],
      loading: false,
      bulkProgress: {
        loading: true,
        processing: 0,
        complete: 0
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getCampaigns();
            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    savePairing: function savePairing() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('save pairing');

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    buildFormData: function buildFormData() {
      var formData = new FormData();
      formData.append('group', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.selectedGroup));
      formData.append('reports', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.selectedPosts.map(function (c) {
        return c.id;
      })));
      return formData;
    },
    closeModal: function closeModal() {
      this.$emit('input');
      this.selectedGroup = '';
    },
    getCampaigns: function getCampaigns() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  __WEBPACK_IMPORTED_MODULE_5__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
                    _this3.campaigns = response.filter(function (c) {
                      return c.status === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignStatus.ONGOING || c.status === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER;
                    });
                    _this3.campaigns = _this3.campaigns.map(function (element) {
                      return {
                        name: element.name,
                        id: element.id
                      };
                    });
                  }).catch(function (err) {
                    console.log('Error:' + err);
                  });
                } catch (error) {
                  console.error(error);
                }

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addtoPairing: function addtoPairing() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var vm, handleItems, importSelected, added, interval;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this4.getPairedInfluencers(_this4.selectedCampaign);

              case 2:
                if (!(_this4.selectedInfluencers.length === 0)) {
                  _context6.next = 5;
                  break;
                }

                _this4.$swal({
                  title: 'Warning!',
                  icon: 'warning',
                  showCancelButton: false,
                  text: 'No Influencer Selected.'
                });
                return _context6.abrupt('return');

              case 5:
                vm = _this4;
                handleItems = _this4.selectedInfluencers.map(function (inf) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                    handle: inf.instagramHandle,
                    platform: inf.platform
                  });
                });

                _this4.resetBulkProgress();
                _this4.bulkProgress.show = true;
                _this4.bulkProgress.complete = handleItems.length;
                importSelected = [];
                added = [];
                interval = 100;

                handleItems.forEach(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(el, index) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            setTimeout(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
                              var handleItem;
                              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                while (1) {
                                  switch (_context4.prev = _context4.next) {
                                    case 0:
                                      handleItem = el;

                                      if (!vm.selected.find(function (e) {
                                        return e.handle === handleItem.handle && e.platform === el.platform;
                                      })) {
                                        _context4.next = 5;
                                        break;
                                      }

                                      importSelected.push({ handle: handleItem.handle, platform: handleItem.platform });
                                      _context4.next = 10;
                                      break;

                                    case 5:
                                      _context4.next = 7;
                                      return __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].crawlInfluencerDetails({ userHandle: handleItem.handle, campaignID: _this4.selectedCampaign, platform: handleItem.platform.toLowerCase() });

                                    case 7:
                                      __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.pushPairingElementToArray(_this4.selected, { handle: handleItem.handle, platform: handleItem.platform }, 'handle', 'object', handleItem.platform);
                                      added.push({ handle: handleItem.handle, platform: handleItem.platform });
                                      console.log('\uD83D\uDE80 ~ Handle: ' + handleItem.handle);

                                    case 10:
                                      _this4.bulkProgress.processing = index + 1;
                                      if (_this4.bulkProgress.complete === _this4.bulkProgress.processing) {
                                        _this4.bulkProgress.show = false;
                                        _this4.showSuccessMessage(importSelected, added);
                                      }

                                    case 12:
                                    case 'end':
                                      return _context4.stop();
                                  }
                                }
                              }, _callee4, _this4);
                            })), index * interval);

                          case 1:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this4);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 14:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    resetBulkProgress: function resetBulkProgress() {
      this.bulkProgress.processing = 0;
      this.bulkProgress.complete = 0;
      this.bulkProgress.show = false;
    },
    getPairedInfluencers: function getPairedInfluencers(campaignID) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var resp, selected, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, inf;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID);

              case 3:
                resp = _context7.sent;

                if (!resp) {
                  _context7.next = 26;
                  break;
                }

                selected = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context7.prev = 9;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(resp); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  data = _step.value;
                  inf = data.influencer_details;

                  inf.platform = inf.platform || 'instagram';
                  selected.push({ handle: inf.instagramHandle, platform: inf.platform });
                }
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context7.t0;

              case 17:
                _context7.prev = 17;
                _context7.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 20:
                _context7.prev = 20;

                if (!_didIteratorError) {
                  _context7.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context7.finish(20);

              case 24:
                return _context7.finish(17);

              case 25:
                _this5.selected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], selected);

              case 26:
                _context7.next = 31;
                break;

              case 28:
                _context7.prev = 28;
                _context7.t1 = _context7['catch'](0);

                console.error(_context7.t1);

              case 31:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5, [[0, 28], [9, 13, 17, 25], [18,, 20, 24]]);
      }))();
    },
    showSuccessMessage: function showSuccessMessage(importSelected, added) {
      var _this6 = this;

      var displayBlock = '';
      if (importSelected.length > 0) {
        importSelected.map(function (a) {
          displayBlock += '<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">\n            <span class="v-chip__content">' + a.handle + '</span>\n          </span>';
        });
        this.$swal({
          title: 'Error!',
          icon: 'error',
          showCancelButton: false,
          html: 'Influencer(s) can be found in pairing for this campaign <div>' + displayBlock + '</div>'
        }).then(function () {
          _this6.$emit('input');
        });
      } else {
        added.map(function (a) {
          displayBlock += '<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:green;color:#fff">\n            <span class="v-chip__content">' + a.handle + '</span>\n          </span>';
        });
        this.$swal({
          title: 'Successful',
          html: 'Influencers added: <div>' + displayBlock + '</div>',
          type: 'success'
        }).then(function () {
          _this6.$emit('input');
        });
      }
      return;
    }
  }
});

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuewordcloud__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuewordcloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuewordcloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__charts_LineChart_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__charts_BarChart_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_chartjs_Bar__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_chartjs_Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_chartjs_Bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__charts_CircleChart_js__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay__);





var _components;










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AudienceDataReportModal',
  props: {
    value: Boolean,
    audienceData: Object,
    handle: String,
    platform: String
  },
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_vuewordcloud___default.a.name, __WEBPACK_IMPORTED_MODULE_4_vuewordcloud___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'LineChart', __WEBPACK_IMPORTED_MODULE_5__charts_LineChart_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'BarChart', __WEBPACK_IMPORTED_MODULE_6__charts_BarChart_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'CircleChart', __WEBPACK_IMPORTED_MODULE_8__charts_CircleChart_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'BarChartJs', __WEBPACK_IMPORTED_MODULE_7__components_chartjs_Bar___default.a), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_components, 'Loading', __WEBPACK_IMPORTED_MODULE_11_vue_loading_overlay___default.a), _components),
  data: function data() {
    return {
      userGender_options: {},

      influencer: null,
      influencerProfile: null,

      audienceFollowers: null,
      audienceLikes: null,
      reportInfo: null,
      datacollection: null,
      wordCloud: null,
      barChartOptions: {
        barPercentage: 0.1,
        maxBarThickness: 'flex',
        categoryPercentage: 0.5
      },
      audChartOptions: {
        responsive: true,
        interaction: {
          intersect: false
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          }
        }
      },
      audienceReachabilityData: null,
      audienceFollowersGenderPerAge: null,
      audienceFollowersAge: null,
      audienceFollowersGender: null,
      avgLikes: null,
      followingData: null,
      chartOptions: {},
      words: [],
      emojiPath: '/static/img/emoji/',
      showLoading: false
    };
  },

  watch: {
    audienceData: function audienceData(newInfluencerData) {
      this.formatAudience(newInfluencerData);
      this.resetChart();
      this.influencer = newInfluencerData;
    },
    influencer: function influencer(newData) {
      if (newData.success) {
        this.createChartDataFollowers();
        this.createChartDataEngagements();
        this.createChartDataFollowing();
        this.createChartDataAudienceReachability();
        this.createChartDataAudienceGendersPerAge();
        this.createChartDataAudienceGenders();
        this.createWordCloud();
      }
    }
  },
  mounted: function mounted() {
    this.influencer = {};
    this.resetChart();
  },


  computed: {
    reportCreatedAt: function reportCreatedAt() {
      if (this.influencer && this.influencer.report_info) {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.influencer.report_info.created).format('DD-MM-YYYY HH:MM');
      }
      return '';
    },
    followingStat: function followingStat() {
      if (this.influencerProfile && this.influencerProfile.stat_history.length > 0) {
        var followers = this.influencerProfile.followers;
        var followersLastmonth = this.influencerProfile.stat_history[this.influencerProfile.stat_history.length - 2].followers;
        var rate = (followers - followersLastmonth) / followersLastmonth;
        rate = (rate * 100).toFixed(2);
        var type = 'asc';
        if (rate < 0) {
          rate *= -1;
          type = 'desc';
        }
        return {
          rate: rate,
          type: type
        };
      }
      return null;
    }
  },
  methods: {
    close: function close() {
      this.value = false;
      this.$emit('input');
    },
    refreshReport: function refreshReport() {
      if (!this.influencer.success) {
        this.getReportByHandlePlatform(this.handle, this.platform);
      } else {
        var reportId = this.influencer.report_info.report_id;
        __WEBPACK_IMPORTED_MODULE_10__influencerAPIs__["a" /* default */].refreshAudienceReport(reportId).then(function (data) {
          console.log(data);
        });
      }
    },
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return '';
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    downloadPdf: function downloadPdf() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var reportId, username;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reportId = _this.reportInfo.report_id;
                username = _this.influencerProfile.username;

                if (reportId) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return', _this.$swal({
                  title: 'Opp!!!',
                  text: 'The report does not exist',
                  type: 'info'
                }));

              case 4:
                _this.$emit('showLoadingEvent', true);
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_10__influencerAPIs__["a" /* default */].downloadAudienceReport(reportId, username);

              case 7:
                _this.$emit('showLoadingEvent', false);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formatAudience: function formatAudience(data) {
      if (data && data.success) {
        this.influencerProfile = data.user_profile || {};
        this.influencerProfile.top_mentions = this.influencerProfile.top_mentions || [];
        this.influencerProfile.top_hashtags = this.influencerProfile.top_hashtags || [];
        this.influencerProfile.brand_affinity = this.influencerProfile.brand_affinity || [];
        this.influencerProfile.stat_history = this.influencerProfile.stat_history || [];
        this.influencerProfile.relevant_tags = this.influencerProfile.relevant_tags || [];
        this.influencerProfile.similar_users = this.influencerProfile.similar_users || [];
        this.influencerProfile.commercial_posts = this.influencerProfile.commercial_posts || [];
        this.audienceFollowers = data.audience_followers.success ? data.audience_followers.data : {};
        this.audienceLikes = data.audience_likers.success ? data.audience_likers.data : {};
        this.reportInfo = data.report_info || {};

        this.audienceFollowers.credibility_class = this.audienceFollowers.credibility_class || 'normal';
        this.audienceFollowers.audience_genders = this.audienceFollowers.audience_genders || [];
        this.audienceFollowers.audience_ages = this.audienceFollowers.audience_ages || [];
        this.audienceFollowers.audience_genders_per_age = this.audienceFollowers.audience_genders_per_age || [];
        this.audienceFollowers.audience_ethnicities = this.audienceFollowers.audience_ethnicities || [];
        this.audienceFollowers.audience_brand_affinity = this.audienceFollowers.audience_brand_affinity || [];
        this.audienceFollowers.audience_interests = this.audienceFollowers.audience_interests || [];
        this.audienceFollowers.audience_lookalikes = this.audienceFollowers.audience_lookalikes || [];
        this.audienceFollowers.audience_geo = this.audienceFollowers.audience_geo || {};

        this.audienceFollowers.audience_languages = this.audienceFollowers.audience_languages || [];
      } else {
        this.influencerProfile = {};
        this.audienceFollowers = {};
        this.audienceLikes = {};
        this.reportInfo = {};
      }
    },
    createChartDataFollowers: function createChartDataFollowers() {
      var stats = this.influencerProfile.stat_history;
      var followers = {
        label: 'Followers',
        borderColor: '#42a5f5',
        fill: true,
        data: []
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(stats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stat = _step.value;

          followers.data.push(stat.followers);
          this.datacollection.labels.push(__WEBPACK_IMPORTED_MODULE_9_moment___default()(stat.month).format('Y-MMM'));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.datacollection.datasets.push(followers);
    },
    createChartDataEngagements: function createChartDataEngagements() {
      var stats = this.influencerProfile.stat_history;
      var likes = {
        label: 'Likes',
        borderColor: '#42a5f5',
        fill: true,
        data: []
      };
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(stats), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var stat = _step2.value;

          likes.data.push(stat.avg_likes);
          this.avgLikes.labels.push(__WEBPACK_IMPORTED_MODULE_9_moment___default()(stat.month).format('Y-MMM'));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.avgLikes.datasets.push(likes);
    },
    createChartDataFollowing: function createChartDataFollowing() {
      var stats = this.influencerProfile.stat_history;
      var following = {
        label: 'Following',
        borderColor: '#42a5f5',
        fill: true,
        data: []
      };
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(stats), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var stat = _step3.value;

          following.data.push(stat.following);
          this.followingData.labels.push(__WEBPACK_IMPORTED_MODULE_9_moment___default()(stat.month).format('Y-MMM'));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.followingData.datasets.push(following);
    },
    createChartDataAudienceGenders: function createChartDataAudienceGenders() {
      var geners = this.audienceFollowers.audience_genders;
      var genderData = {
        backgroundColor: ['#42a5f5', '#ff595e'],
        fill: false,
        data: []
      };

      var maleGender = geners.find(function (g) {
        return g.code === 'MALE';
      });
      if (maleGender) {
        this.audienceFollowersGender.labels.push(maleGender.code);
        genderData.data.push((maleGender.weight * 100).toFixed(2));
      }

      var femaleGender = geners.find(function (g) {
        return g.code === 'FEMALE';
      });
      if (femaleGender) {
        this.audienceFollowersGender.labels.push(femaleGender.code);
        genderData.data.push((femaleGender.weight * 100).toFixed(2));
      }
      this.audienceFollowersGender.datasets.push(genderData);
    },
    createChartDataAudienceGendersPerAge: function createChartDataAudienceGendersPerAge() {
      var audienceGendersPerAge = this.audienceFollowers.audience_genders_per_age;
      var audienceGendersPerAgeMale = {
        label: 'Male',
        backgroundColor: '#42a5f5',
        data: []
      };
      var audienceGendersPerAgeFemale = {
        label: 'Female',
        backgroundColor: '#ff595e',
        data: []
      };
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audienceGendersPerAge), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var data = _step4.value;

          audienceGendersPerAgeMale.data.push((data.male * 100).toFixed(2));
          this.audienceFollowersGenderPerAge.labels.push(data.code);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audienceGendersPerAge), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _data = _step5.value;

          audienceGendersPerAgeFemale.data.push((_data.female * 100).toFixed(2));
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.audienceFollowersGenderPerAge.datasets.push(audienceGendersPerAgeMale);
      this.audienceFollowersGenderPerAge.datasets.push(audienceGendersPerAgeFemale);
    },
    createChartDataAudienceReachability: function createChartDataAudienceReachability() {
      var audienceReachabilities = this.audienceFollowers.audience_reachability;
      var audienceReachability = {
        label: 'Audience Reachability',
        backgroundColor: '#3F3FFF',
        borderColor: 'black',
        data: []
      };
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(audienceReachabilities), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var reacher = _step6.value;

          audienceReachability.data.push((reacher.weight * 100).toFixed(2));
          if (reacher.code.startsWith('-')) {
            reacher.code = reacher.code.replace('-', '<');
          } else if (reacher.code.endsWith('-')) {
            reacher.code = reacher.code.replace('-', '>');
          }
          this.audienceReachabilityData.labels.push(reacher.code + ' Followings');
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.audienceReachabilityData.datasets.push(audienceReachability);
    },
    createWordCloud: function createWordCloud() {
      var relevantTags = this.influencerProfile.relevant_tags || [];
      this.wordCloud = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(relevantTags), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var relevant = _step7.value;

          var freq = Number(relevant.freq).toFixed(2);
          this.wordCloud.push([relevant.tag, Number(freq) * 10]);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    },
    resetChart: function resetChart() {
      this.datacollection = {
        labels: [],
        datasets: []
      };
      this.avgLikes = {
        labels: [],
        datasets: []
      };
      this.followingData = {
        labels: [],
        datasets: []
      };
      this.audienceReachabilityData = {
        labels: [],
        datasets: []
      };
      this.audienceFollowersGender = {
        labels: [],
        datasets: []
      };
      this.audienceFollowersGenderPerAge = {
        labels: [],
        datasets: []
      };
    },

    getRandomColor: function getRandomColor() {
      return '#947ded';
    },
    getRandomRotation: function getRandomRotation(min, max) {
      return Math.random() * (max - min) + min;
    },
    toPercent: function toPercent(num) {
      return (num * 100).toFixed(2);
    },

    getCredibilityColor: function getCredibilityColor(credibility) {
      var rate = this.toPercent(credibility);
      if (rate >= 0 && rate <= 29) {
        return '#f44336';
      } else if (rate >= 30 && rate <= 59) {
        return '#f9a825';
      } else if (rate >= 60 && rate <= 100) {
        return '#4caf50';
      } else {
        return 'primary';
      }
    },
    getReportByHandlePlatform: function getReportByHandlePlatform(handle, platform) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit('showLoadingEvent', true);
                result = null;

                if (!(platform === 'instagram')) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_10__influencerAPIs__["a" /* default */].getAudienceData(handle);

              case 5:
                result = _context2.sent;
                _context2.next = 18;
                break;

              case 8:
                if (!(platform === 'tiktok')) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_10__influencerAPIs__["a" /* default */].getTikTokAudienceData(handle);

              case 11:
                result = _context2.sent;
                _context2.next = 18;
                break;

              case 14:
                if (!(platform === 'youtube')) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 17;
                return __WEBPACK_IMPORTED_MODULE_10__influencerAPIs__["a" /* default */].getYoutubeAudienceData(handle);

              case 17:
                result = _context2.sent;

              case 18:
                _this2.$emit('showLoadingEvent', false);

                if (!result.error) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt('return', _this2.$swal({
                  title: 'Opps!',
                  text: result.error.error.message,
                  type: 'info'
                }));

              case 23:
                _this2.formatAudience(result);
                _this2.resetChart();
                _this2.influencer = result;

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignListsModal',
  props: ['items', 'value', 'handle'],
  data: function data() {
    return {
      headers: [{
        text: 'Campaign Name',
        value: 'name'
      }, {
        text: 'Campaign Type',
        value: 'campaignType'
      }, {
        text: 'Campaign Verticals',
        value: 'showVerticals'
      }],
      dataTableKey: 1
    };
  },

  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__influencerAPIs__ = __webpack_require__(34);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateCampaignPayout',
  data: function data() {
    return {
      user: {},
      alert_message: '',
      alert_header: '',
      alert_style: 'alert-success',
      campaignPayout: {
        campaignName: '',
        instagram_post_url: '',
        other_social_media_post_url: '',
        satisfaction_level: 5,
        advertiser_satisfaction_level: 5,
        feedback: '',
        subscription: 1
      },
      ratingLevels: [{
        level: '1',
        value: 1
      }, {
        level: '2',
        value: 2
      }, {
        level: '3',
        value: 3
      }, {
        level: '4',
        value: 4
      }, {
        level: '5',
        value: 5
      }]
    };
  },

  validations: {
    campaignPayout: {
      campaignName: {},
      instagram_post_url: {}
    }
  },
  computed: {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  },
  methods: {
    close_alert_message: function close_alert_message() {
      this.alert_message = '';
    },
    createCampaignPayout: function createCampaignPayout() {
      var _this = this;

      var campaignPayout = this.campaignPayout;

      __WEBPACK_IMPORTED_MODULE_1__influencerAPIs__["a" /* default */].createCampaignPayout(this.user.influencerId, campaignPayout).then(function (response) {
        _this.clearData();

        _this.alert_style = 'alert-success';
        _this.alert_header = 'Successful submission!';
        _this.alert_message = 'We have received your campaign payout submission and will proceed with your payout as soon as possible. Stay tuned!';

        _this.$swal({
          title: 'Payment Information',
          html: '<p><b>Kobe</b> shall pay Fees by cheque or bank transfer within forty-five (45) days after the end of each given month.</p> <p>Influencer must provide all applicable personal and bank account information after receiving the live URL link of your posting upon approval of client.</p>',
          type: 'info',
          confirmButtonText: 'OK'
        });

        _this.scrollToTop();
      }).catch(function (error) {
        _this.alert_style = 'alert-error';
        _this.alert_header = 'Something went wrong!';
        _this.alert_message = 'Please kindly try again or contact us directly';

        _this.scrollToTop();

        console.log('error', error);
      });
    },
    clearData: function clearData() {
      this.campaignPayout = {
        campaignName: '',
        instagram_post_url: '',
        other_social_media_post_url: '',
        satisfaction_level: 5,
        advertiser_satisfaction_level: 5,
        feedback: '',
        subscription: 1
      };
    },
    scrollToTop: function scrollToTop() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.scrollToTop);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__User_userAPIs__["a" /* default */].getUser(this.currentUserID).then(function (response) {
      _this2.user = {
        firstName: response.firstName,
        lastName: response.lastName,
        email: response.influencer.email,
        birthday: response.influencer.birthday,
        gender: response.influencer.gender,
        fullName: response.influencer.fullName,
        bankName: response.influencer.bankName,
        bankAccount: response.influencer.bankAccount,
        mailingAddress: response.influencer.mailingAddress,
        influencerId: response.influencer.id
      };
    }).catch(function (error) {
      console.log('error', error);
    });
  }
});

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateInfluencerModal',
  props: ['modalId'],
  data: function data() {
    return {
      influencer: {
        handle: ''
      }
    };
  },

  validations: {
    influencer: {
      handle: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    createInfluencer: function createInfluencer() {
      var _this = this;

      var influencer = this.influencer;

      __WEBPACK_IMPORTED_MODULE_0__influencerAPIs__["a" /* default */].createInfluencer(influencer).then(function (response) {
        _this.$emit('createInfluencer', response);

        _this.$refs.closeButton.click();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    clearData: function clearData() {
      this.influencer = {
        handle: ''
      };
    }
  }
});

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jimp__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jimp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_sources_bank_accounts__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_sources_bank_accounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_sources_bank_accounts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_sources_swift_codes__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_sources_swift_codes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_sources_swift_codes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__influencerHelper__ = __webpack_require__(91);






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditInfluencerModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a
  },
  props: ['value', 'modalId', 'influencerData', 'processEdit'],
  data: function data() {
    return {
      valid: true,
      countries: [],
      bankAccounts: [],
      swiftCodes: [],
      userGender_options: [],
      ethnicity_options: [{
        value: 'chinese',
        text: 'Chinese'
      }, {
        value: 'malay',
        text: 'Malay'
      }, {
        value: 'Indian',
        text: 'indian'
      }, {
        value: 'eurasian',
        text: 'Eurasian'
      }, {
        value: 'others',
        text: 'Others'
      }],
      inputedRates: {
        igStatic: null,
        igCarousel: null,
        igStory: null,
        igTv: null,
        tiktok: null,
        blog: null,
        loadingFee: null,
        remark: '',
        pricingDecks: []
      },
      openExpansion: [0, 1, 2, 3],
      influencer: null,
      swiftCode: '',
      isLoading: false,
      disableBankSelect: false,
      bankNames: [],
      pricingDecksMedia: [],
      images: [],
      decksFiles: [],
      deleteObjectKeys: [],
      MessageRules: [function (value) {
        return !!value || 'Required.';
      }],
      categories: __WEBPACK_IMPORTED_MODULE_17__influencerHelper__["a" /* default */].getCategories()
    };
  },

  watch: {
    influencerData: function influencerData(newInfluencerData) {
      if (!newInfluencerData) return;
      this.influencer = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, newInfluencerData);
      this.influencer.inputedRates = {};
      this.swiftCode = this.influencer.swiftCode || '';
      if (this.influencer.xiaohongshu) {
        if (this.influencer.xiaohongshu.xiaohongshu) {
          this.influencer.xiaohongshu = this.influencer.xiaohongshu.xiaohongshu;
        }
      }

      this.getUserProfile();
    },
    processEdit: function processEdit(newProcessEdit) {
      if (newProcessEdit) {}
    }
  },
  computed: {
    hasFirstName: function hasFirstName() {
      if (this.influencer && (this.influencer.firstName || this.influencer.firstName === '')) {
        return true;
      }
      return false;
    },
    hasLastName: function hasLastName() {
      if (this.influencer && (this.influencer.lastName || this.influencer.lastName === '')) {
        return true;
      }
      return false;
    }
  },
  methods: {
    isMainPlatform: function isMainPlatform(platform) {
      var mainPlatform = String(this.influencer && (this.influencer.activePlatform || this.influencer.platform) || '').toLowerCase();
      if (!mainPlatform) return true;
      return mainPlatform === platform || platform === 'xiaohongshu' && mainPlatform === 'xhs';
    },

    editInfluencer: function editInfluencer() {
      var _this = this;

      if (!this.$refs.form.validate()) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please fill the required information correctly.'
        });
        return;
      }
      this.$emit('showLoading', true);
      if (this.influencer.email) {
        this.influencer.email = this.influencer.email.toLowerCase();
      }
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(this.influencer.bankName) === 'object') {
        this.swiftCode = this.influencer.bankName.swift_code || '';
        this.influencer.bankName = this.influencer.bankName.bank;
      }
      var edittingUserProfile = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.influencer);
      edittingUserProfile.firstName = edittingUserProfile.firstName || '';
      edittingUserProfile.lastName = edittingUserProfile.lastName || '';
      edittingUserProfile.email = (this.influencer.email || '').trim();
      edittingUserProfile.swiftCode = this.swiftCode;
      edittingUserProfile.inputedRates = this.inputedRates;
      delete edittingUserProfile.audience;
      delete edittingUserProfile.tiktokaudience;
      delete edittingUserProfile.instagram;
      delete edittingUserProfile.tiktok;
      var formData = new FormData();

      formData.append('editProfile', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(edittingUserProfile));
      var files = this.pricingDecksMedia;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('deckFile', val);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__["a" /* default */].editInfluencerFromAdmin(formData).then(function (response) {
        _this.$emit('showLoading', false);
        if (_this.deleteObjectKeys.length > 0) {
          _this.deleteObjectKeys.map(function (item) {
            __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('delete', '/api/v1/posts/s3/delete', true, { image: item });
          });
        }

        _this.$emit('editInfluencer', response);

        _this.close();
        _this.$swal({
          text: 'Influencer Updated',
          type: 'success'
        });
        _this.deleteObjectKeys = [];
        _this.getUserProfile();
      }).catch(function (error) {
        console.log('error', error);
        _this.$emit('showLoading', false);
      });
    },
    getUserProfile: function getUserProfile() {
      var _this2 = this;

      if (!this.influencer.userID) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_10__User_userAPIs__["a" /* default */].getUser(this.influencer.userID).then(function (response) {
        _this2.images = [];
        _this2.decksFiles = [];
        if (response.influencer.inputedRates) {
          _this2.inputedRates = {
            igStatic: response.influencer.inputedRates['igStatic'],
            igCarousel: response.influencer.inputedRates['igCarousel'],
            igStory: response.influencer.inputedRates['igStory'],
            igTv: response.influencer.inputedRates['igTv'],
            tiktok: response.influencer.inputedRates['tiktok'],
            blog: response.influencer.inputedRates['blog'],
            loadingFee: response.influencer.inputedRates['loadingFee'],
            remark: response.influencer.inputedRates['remark'],
            pricingDecks: response.influencer.inputedRates['pricingDecks']
          };

          if (_this2.inputedRates.pricingDecks.length > 0) {
            _this2.inputedRates.pricingDecks.map(function (item) {
              var mediaType = item.type.split('/')[0];
              if (mediaType === 'image') {
                _this2.images.push(item);
              } else {
                _this2.decksFiles.push(item);
              }
            });
          }
        }
        _this2.influencer.firstName = response.firstName;
        _this2.influencer.lastName = response.lastName;
        _this2.influencer.fullName = response.influencer.fullName;
        _this2.influencer.country = response.influencer.country;
        _this2.influencer.bankName = response.influencer.bankName;
        _this2.swiftCode = response.influencer.swiftCode || _this2.influencer.swiftCode || '';
        _this2.influencer.swiftCode = _this2.swiftCode;
        _this2.changeCountry();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    prepareUpload: function prepareUpload(e) {
      var _this3 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var mediaType = element.type.split('/')[0];
        var fileType = element.name.split('.')[1];

        if (mediaType !== 'image' && fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'ppt' && fileType !== 'txt' && fileType !== 'docx') {
          _this3.$swal('File Type Not Supported, Please select a video or an image');
        } else if (mediaType === 'image') {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buffer = e.target.result;
            __WEBPACK_IMPORTED_MODULE_13_jimp___default.a.read(buffer, function (err, img) {
              if (err) console.error(111, err);
              img.resize(500, __WEBPACK_IMPORTED_MODULE_13_jimp___default.a.AUTO).quality(100).getBase64(__WEBPACK_IMPORTED_MODULE_13_jimp___default.a.MIME_PNG, function (err, buff) {
                if (err) console.error(222, err);
                var file = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
                _this3.pricingDecksMedia.push(file);
                _this3.images.push({
                  url: buff,
                  src: buff,
                  name: element.name
                });
              });
            });
          };

          e.target.value = '';
        } else {
          _this3.decksFiles.push(element);
          _this3.pricingDecksMedia.push(element);
          var _reader = new FileReader();
          _reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteImage: function deleteImage(imgIndex) {
      var imgURl = this.images[imgIndex].url;

      var filename = this.images[imgIndex].url.substring(this.images[imgIndex].url.lastIndexOf('/') + 1);

      this.deleteObjectKeys.push(filename);
      this.images.splice(imgIndex, 1);

      var pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(function (item) {
        return item.url === imgURl;
      });
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1);

      var inputRateIndex = this.inputedRates.pricingDecks.findIndex(function (item) {
        return item.url === imgURl;
      });
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1);
    },
    deleteFile: function deleteFile(fileIndex) {
      var fileURL = '';
      if (this.decksFiles[fileIndex].url) {
        fileURL = this.decksFiles[fileIndex].url;
        var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        this.deleteObjectKeys.push(fileName);
      }
      this.decksFiles.splice(fileIndex, 1);

      var pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(function (item) {
        return item.url === fileURL;
      });
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1);

      var inputRateIndex = this.inputedRates.pricingDecks.findIndex(function (item) {
        return item.url === fileURL;
      });
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1);
    },

    close: function close() {
      this.$emit('closeModal');
    },
    changeBankName: function changeBankName(selectedValue) {
      this.swiftCode = '';
      var selectedBank = selectedValue || this.influencer.bankName;
      if (selectedBank && (typeof selectedBank === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(selectedBank)) === 'object' && selectedBank.swift_code) {
        this.swiftCode = selectedBank.swift_code;
        this.influencer.swiftCode = this.swiftCode;
        return;
      }
      var bank = '';
      if (selectedBank && selectedBank.bank) {
        bank = selectedBank.bank;
      } else {
        bank = selectedBank;
      }
      var matchBank = this.bankNames.find(function (b) {
        return b.bank === bank;
      });
      if (matchBank) {
        this.swiftCode = matchBank.swift_code || '';
        this.influencer.swiftCode = this.swiftCode;
        return;
      }
      matchBank = this.swiftCodes.find(function (b) {
        return b.bank === bank;
      });
      if (matchBank) {
        this.swiftCode = matchBank.code;
      } else {
        var legacyBank = this.bankAccounts.find(function (b) {
          return b.bank === bank;
        });
        if (legacyBank) {
          this.swiftCode = legacyBank.code;
        }
      }
      this.influencer.swiftCode = this.swiftCode;
    },
    changeCountry: function changeCountry() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var country, matchBank, bankName, selectedBank;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this4.bankNames = [];
                country = _this4.countries.find(function (c) {
                  return c.name === _this4.influencer.country;
                });

                if (country) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this4.disableBankSelect = true;
                _context.next = 8;
                return _this4.getBanks(country.code);

              case 8:
                matchBank = _this4.allBanks.find(function (bank) {
                  return bank.country_code === country.code;
                });

                if (matchBank && matchBank.list !== undefined) {
                  _this4.bankNames = matchBank.list.filter(function (bank) {
                    return bank.branch === null;
                  });
                  if (!_this4.swiftCode && _this4.influencer.bankName) {
                    bankName = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(_this4.influencer.bankName) === 'object' ? _this4.influencer.bankName.bank : _this4.influencer.bankName;
                    selectedBank = _this4.bankNames.find(function (bank) {
                      return bank.bank === bankName;
                    });

                    if (selectedBank) {
                      _this4.swiftCode = selectedBank.swift_code || '';
                      _this4.influencer.swiftCode = _this4.swiftCode;
                    }
                  }
                }
                _this4.disableBankSelect = false;
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                _this4.bankNames = [];
                _this4.disableBankSelect = false;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 13]]);
      }))();
    },
    getBanks: function getBanks(code) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__Influencer_influencerAPIs__["a" /* default */].getBanks(code);

              case 3:
                _this5.allBanks = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                console.log('error', _context2.t0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 6]]);
      }))();
    },
    removeSpaces: function removeSpaces() {
      this.influencer.email = this.influencer.email.replace(/\s/g, '');
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  },
  mounted: function mounted() {
    this.userGender_options = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userGenderDisplay;

    this.countries = __WEBPACK_IMPORTED_MODULE_14__static_sources_countries___default.a;

    this.bankAccounts = __WEBPACK_IMPORTED_MODULE_15__static_sources_bank_accounts___default.a;

    this.swiftCodes = __WEBPACK_IMPORTED_MODULE_16__static_sources_swift_codes___default.a;
  }
});

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InputedRates__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InputedRates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__InputedRates__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComparisonModal',
  props: {
    value: Boolean,
    influencer: Object,
    compareInf: Object
  },
  components: {
    InputedRates: __WEBPACK_IMPORTED_MODULE_9__InputedRates___default.a
  },
  data: function data() {
    return {
      openExpansion: [0, 1, 2, 3],
      userGender_options: {},
      inputedRates: {},
      compareInputedRates: {},
      primaryInf: null,
      tab: null,
      comparisonStates: {
        PRIMARY: 1,
        COMPARE: 2
      },
      comparisons: {
        email: 1,
        phone: 1,
        bankName: 1,
        bankAccount: 1,
        fullName: 1,
        country: 1,
        mailingAddress: 1,
        gender: 1,
        birthday: 1
      }
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue) this.initData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    savedInfMerge: function savedInfMerge(state) {
      return state.influencer.savedInfMerge;
    }
  }), {
    isEmail: function isEmail() {
      return this.primaryInf.email || this.compareInf.email;
    },
    isPhone: function isPhone() {
      return this.primaryInf.phone || this.compareInf.phone;
    },
    isBankName: function isBankName() {
      return this.primaryInf.bankName || this.compareInf.bankName;
    },
    isBankAccount: function isBankAccount() {
      return this.primaryInf.bankAccount || this.compareInf.bankAccount;
    },
    isFullName: function isFullName() {
      return this.primaryInf.fullName || this.compareInf.fullName;
    },
    isCountry: function isCountry() {
      return this.primaryInf.country || this.compareInf.country;
    },
    isMailingAddress: function isMailingAddress() {
      return this.primaryInf.mailingAddress || this.compareInf.mailingAddress;
    },
    isGender: function isGender() {
      return this.primaryInf.gender || this.compareInf.gender;
    },
    isBirthday: function isBirthday() {
      return this.primaryInf.birthday || this.compareInf.birthday;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.userGender_options = {};
    __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userGenderDisplay.forEach(function (element) {
      _this.userGender_options[element.value] = element.text;
    });
  },

  methods: {
    initData: function initData() {
      var _this2 = this;

      this.inputedRates = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.influencer.inputedRates);
      this.compareInputedRates = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.compareInf.inputedRates);
      setTimeout(function () {
        _this2.primaryInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _this2.influencer);
      }, 1000);
    },
    saveMerge: function saveMerge() {
      var _this3 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure to save changes?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var saveInf, compareInf, formData;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 10;
                    break;
                  }

                  saveInf = _this3.mergeToPrimary();
                  compareInf = null;

                  if (_this3.compareInf.tiktok) {
                    compareInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                      id: _this3.compareInf.influencerID,
                      tiktok: _this3.compareInf.tiktok.id,
                      tiktokID: _this3.compareInf.tiktok.tiktokID,
                      tiktokaudience: _this3.compareInf.audience.id,
                      tiktokHandle: _this3.compareInf.audience.user_profile.username
                    });
                  } else if (_this3.compareInf.youtube) {
                    compareInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                      id: _this3.compareInf.influencerID,
                      youtube: _this3.compareInf.youtube.id,
                      youtubeID: _this3.compareInf.youtube.youtubeID,
                      youtubeaudience: _this3.compareInf.audience.id,
                      youtubeHandle: _this3.compareInf.audience.user_profile.username || _this3.compareInf.audience.user_profile.custom_name
                    });
                  } else if (_this3.compareInf.instagram) {
                    compareInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                      id: _this3.compareInf.influencerID,
                      instagram: _this3.compareInf.instagram.id,
                      instagramID: _this3.compareInf.instagram.instagramID,
                      audience: _this3.compareInf.audience.id,
                      handle: _this3.compareInf.audience.user_profile.username
                    });
                  } else if (_this3.compareInf.facebook) {
                    compareInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                      id: _this3.compareInf.influencerID,
                      facebook: _this3.compareInf.facebook.id,
                      facebookId: _this3.compareInf.facebook.facebookId,
                      handle: _this3.compareInf.facebook.handle
                    });
                  } else if (_this3.compareInf.xiaohongshuID) {
                    compareInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
                      id: _this3.compareInf.influencerID,
                      xiaohongshuID: _this3.compareInf.xiaohongshu.id,
                      handle: _this3.compareInf.xiaohongshu.xhsHandle
                    });
                  }
                  formData = new FormData();

                  formData.append('saveInf', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(saveInf));
                  formData.append('compareInf', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(compareInf));
                  _context.next = 9;
                  return _this3.$store.dispatch('influencer/mergeInf', {
                    formData: formData
                  });

                case 9:
                  if (_this3.savedInfMerge) {
                    _this3.close();
                    _this3.$emit('mergeSuccess');
                  }

                case 10:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    mergeToPrimary: function mergeToPrimary() {
      var mergeInf = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.primaryInf);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.comparisons)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (this.comparisons[key] === this.comparisonStates.COMPARE) {
            mergeInf[key] = this.compareInf[key] || this.primaryInf[key];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.tab === 'tab-2') {
        mergeInf.inputedRates = this.compareInf.inputedRates || this.primaryInf.inputedRates;
      }
      delete mergeInf.audience;
      delete mergeInf.tiktokaudience;
      delete mergeInf.youtubeaudience;
      return mergeInf;
    },
    close: function close() {
      this.$emit('showLoading', false);
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_DataTableMixin__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfPlatformDataTable',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_DataTableMixin__["a" /* default */]],
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_6__components_scoped_custom_SocialHandle___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    influencerID: String,
    items: Array
  },
  watch: {
    items: function items(value) {
      this.refreshItems();
    }
  },
  data: function data() {
    return {
      filter: '',
      filteredItems: [],
      dataSourceName: 'filteredItems',
      showEditActions: false,
      headers: [{
        text: 'Platform',
        value: 'text'
      }, {
        text: 'Handle',
        value: 'handle'
      }, {
        text: 'Actions',
        value: 'action'
      }],
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    saved: function saved(state) {
      return state.influencer.savedPlatforms;
    },
    savedErr: function savedErr(state) {
      return state.influencer.savedPlatformsNotFoundErr;
    },
    igInf: function igInf(state) {
      return state.influencer.igInf;
    },
    tiktokInf: function tiktokInf(state) {
      return state.influencer.tiktokInf;
    },
    youtubeInf: function youtubeInf(state) {
      return state.influencer.youtubeInf;
    },
    xhsInf: function xhsInf(state) {
      return state.influencer.xhsInf;
    },
    fbInf: function fbInf(state) {
      return state.influencer.fbInf;
    },
    linkedinInf: function linkedinInf(state) {
      return state.influencer.linkedinInf;
    },
    twitterInf: function twitterInf(state) {
      return state.influencer.twitterInf;
    }
  })),
  mounted: function mounted() {
    this.refreshItems();
  },

  methods: {
    connectAction: function connectAction(item, type) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure to ' + (type === 'connect' ? 'connect' : 'disconnect') + '?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!result.value) {
                              _context.next = 11;
                              break;
                            }

                            _this.isLoading = true;
                            _context.t0 = type;
                            _context.next = _context.t0 === 'connect' ? 5 : _context.t0 === 'disconnect' ? 9 : 11;
                            break;

                          case 5:
                            _context.next = 7;
                            return _this.checkInf(item.handle, item.value);

                          case 7:
                            if (_this.igInf && _this.igInf.influencerID) {
                              _this.$emit('showCompareModal', _this.igInf);
                              _this.isLoading = false;
                            } else if (_this.youtubeInf && _this.youtubeInf.influencerID) {
                              _this.$emit('showCompareModal', _this.youtubeInf);
                              _this.isLoading = false;
                            } else if (_this.tiktokInf && _this.tiktokInf.influencerID) {
                              _this.$emit('showCompareModal', _this.tiktokInf);
                              _this.isLoading = false;
                            } else if (_this.xhsInf && _this.xhsInf.influencerID) {
                              _this.$emit('showCompareModal', _this.xhsInf);
                              _this.isLoading = false;
                            } else if (_this.fbInf && _this.fbInf.influencerID) {
                              _this.$emit('showCompareModal', _this.fbInf);
                              _this.isLoading = false;
                            } else if (_this.linkedinInf && _this.linkedinInf.influencerID) {
                              _this.$emit('showCompareModal', _this.linkedinInf);
                              _this.isLoading = false;
                            } else if (_this.twitterInf && _this.twitterInf.influencerID) {
                              _this.$emit('showCompareModal', _this.twitterInf);
                              _this.isLoading = false;
                            } else {
                              _this.saveChanges([item], 'connect');
                            }
                            return _context.abrupt('break', 11);

                          case 9:
                            _this.disconnectInf([item]);
                            return _context.abrupt('break', 11);

                          case 11:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    saveChanges: function saveChanges(items) {
      var _this2 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'save';
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, msg;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _this2.buildFormData(items);
                _context3.next = 3;
                return _this2.$store.dispatch('influencer/createMultiplePlatforms', { data: data });

              case 3:
                _this2.isLoading = false;

                if (!_this2.saved) {
                  _context3.next = 13;
                  break;
                }

                msg = 'Successfully ' + (source === 'connect' ? 'Connnected' : 'Updated');

                _this2.$swal({
                  text: msg,
                  type: 'success'
                });
                _this2.resetEdit();
                _this2.changeConnectState(items.length ? items[0] : {}, true);
                _this2.$emit('reload');
                return _context3.abrupt('return');

              case 13:
                if (_this2.savedErr) {
                  _this2.$swal({
                    text: 'Social Data Not Found!',
                    type: 'error'
                  });
                }

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    disconnectInf: function disconnectInf(items) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data, msg;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this3.buildFormData(items);
                _context4.next = 3;
                return _this3.$store.dispatch('influencer/discountPlatforms', { data: data });

              case 3:
                _this3.isLoading = false;

                if (!_this3.saved) {
                  _context4.next = 11;
                  break;
                }

                msg = 'Successfully Disconnected';

                _this3.$swal({
                  text: msg,
                  type: 'success'
                });
                _this3.resetEdit();
                _this3.changeConnectState(items.length ? items[0] : {}, false);
                _this3.$emit('reload');
                return _context4.abrupt('return');

              case 11:
                _this3.$swal({
                  text: 'Unknown Error Occured!',
                  type: 'error'
                });

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    rejectPlatform: function rejectPlatform(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var formData, msg;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.isLoading = true;
                formData = new FormData();

                formData.append('platform', item.value);
                formData.append('influencerID', _this4.influencerID);
                _context5.next = 6;
                return _this4.$store.dispatch('influencer/rejectPlatform', formData);

              case 6:
                _this4.isLoading = false;

                if (!_this4.saved) {
                  _context5.next = 14;
                  break;
                }

                msg = 'Successfully Rejected';

                _this4.$swal({
                  text: msg,
                  type: 'success'
                });
                _this4.resetEdit();
                _this4.$emit('reload');
                _this4.$emit('close');
                return _context5.abrupt('return');

              case 14:
                _this4.$swal({
                  text: 'Unknown Error Occured!',
                  type: 'error'
                });

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    checkInf: function checkInf(handle, platform) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(platform === 'tiktok')) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 3;
                return _this5.$store.dispatch('influencer/getInfluencerByTikTokHandle', {
                  filters: {
                    tiktokHandle: handle
                  }
                });

              case 3:
                _context6.next = 32;
                break;

              case 5:
                if (!(platform === 'youtube')) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 8;
                return _this5.$store.dispatch('influencer/getInfluencerByYoutubeHandle', {
                  filters: {
                    youtubeHandle: handle
                  }
                });

              case 8:
                _context6.next = 32;
                break;

              case 10:
                if (!(platform === 'xiaohongshu')) {
                  _context6.next = 15;
                  break;
                }

                _context6.next = 13;
                return _this5.$store.dispatch('influencer/getInfluencerByXHSHandle', {
                  filters: {
                    xhsHandle: handle
                  }
                });

              case 13:
                _context6.next = 32;
                break;

              case 15:
                if (!(platform === 'facebook')) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 18;
                return _this5.$store.dispatch('influencer/getInfluencerByFbHandle', {
                  filters: {
                    fbHandle: handle
                  }
                });

              case 18:
                _context6.next = 32;
                break;

              case 20:
                if (!(platform === 'linkedin')) {
                  _context6.next = 25;
                  break;
                }

                _context6.next = 23;
                return _this5.$store.dispatch('influencer/getInfluencerByLinkedInHandle', {
                  filters: {
                    linkedinHandle: handle
                  }
                });

              case 23:
                _context6.next = 32;
                break;

              case 25:
                if (!(platform === 'twitter')) {
                  _context6.next = 30;
                  break;
                }

                _context6.next = 28;
                return _this5.$store.dispatch('influencer/getInfluencerByTwitterHandle', {
                  filters: { twitterHandle: handle }
                });

              case 28:
                _context6.next = 32;
                break;

              case 30:
                _context6.next = 32;
                return _this5.$store.dispatch('influencer/getInfluencerByIgHandle', {
                  filters: {
                    instagramHandle: handle
                  }
                });

              case 32:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    resetEdit: function resetEdit() {
      this.filteredItems = this.resetEditFields(this.filteredItems, ['handle']);
      this.showEditActions = false;
    },
    changeConnectState: function changeConnectState(item, state) {
      var itemIndex = this.filteredItems.indexOf(item);
      if (itemIndex !== -1) {
        this.filteredItems[itemIndex].connected = state;
        if (state) this.filteredItems[itemIndex].requested = false;
      }
    },
    buildFormData: function buildFormData(items) {
      var _this6 = this;

      var savePlatforms = [];
      items.map(function (item) {
        if (item.handle) {
          var handle = item.handle;
          if (item.value === 'instagram') {
            handle = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.regexMatchIg(handle, __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].regexPattern.instagram_profile));
          } else if (item.value === 'tiktok') {
            handle = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.extractTikTokHandle(handle));
          } else if (item.value === 'twitter') {
            handle = _this6.normalizeTwitterHandle(handle);
          }
          var matchItemIdx = _this6.filteredItems.findIndex(function (f) {
            return f.handle === item.handle;
          });
          if (matchItemIdx !== -1) {
            _this6.filteredItems[matchItemIdx].handle = handle;
          }
          savePlatforms.push({
            handle: handle,
            platform: item.value
          });
        }
      });
      var formData = new FormData();
      formData.append('platforms', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(savePlatforms));
      formData.append('influencerID', this.influencerID);
      return formData;
    },
    refreshItems: function refreshItems() {
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.items);
      this.resetEdit();
      this.filteredItems = this.filteredItems.map(function (item) {
        if (!item.connected && !item.handle || item.requested) {
          item.handleEdit = true;
        }
        return item;
      });
      this.filteredItems = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
    },
    normalizeTwitterHandle: function normalizeTwitterHandle(value) {
      var handle = String(value || '').trim();
      var twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i);
      if (twitterUrl) handle = twitterUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    }
  }
});

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComparisonModal__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComparisonModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ComparisonModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfPlatformsViewModal',
  props: {
    value: Boolean,
    influencerID: String,
    platforms: Array,
    influencer: Object
  },
  components: {
    ComparisonModal: __WEBPACK_IMPORTED_MODULE_2__ComparisonModal___default.a,
    InfPlatformDataTable: __WEBPACK_IMPORTED_MODULE_1__DataTable___default.a
  },
  data: function data() {
    return {
      compareDefaultInf: null,
      compareInf: null,
      comparisonDialog: false
    };
  },

  methods: {
    showCompareModal: function showCompareModal(inf) {
      var _this = this;

      this.compareDefaultInf = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.influencer);
      this.compareInf = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, inf);
      this.comparisonDialog = false;
      setTimeout(function () {
        _this.comparisonDialog = true;
      }, 500);
    },
    mergeSuccess: function mergeSuccess() {
      this.$emit('reload');
      this.close();
      this.$swal({
        text: 'Influencers Merged',
        type: 'success'
      });
    },
    reloadPage: function reloadPage() {
      this.$emit('reload');
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewInfluencerModal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewInfluencerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ViewInfluencerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AudienceDataReportModal__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    influencers: Array,
    elimination: Boolean
  },
  components: {
    ViewInfluencerModal: __WEBPACK_IMPORTED_MODULE_3__ViewInfluencerModal___default.a,
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_4__AudienceDataReportModal___default.a
  },
  data: function data() {
    return {
      selected: [],
      viewInfluencerData: null,
      audienceDataReport: null,
      viewAudienceDataDialog: false,
      viewInfluencerDialog: false,
      itemsPerPage: 10,
      headers: [{
        text: 'Instagram',
        value: 'igHandle'
      }, {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'instagramFullname'
      }, { text: 'Followers', value: 'totalFollowers' }, { text: 'Audience Credibility', value: 'audienceCredibility' }, { text: 'Engagement', value: 'engagementRate' }, { text: 'Amount', value: 'amount' }, { text: 'Registration', value: 'id' }, { text: 'Actions', value: 'action' }]
    };
  },

  methods: {
    showReport: function showReport(influencer) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__influencerAPIs__["a" /* default */].fetchLocalAudienceReport(influencer.id, influencer.instagramID, influencer.instagramHandle).then(function (resp) {
        _this.audienceDataReport = resp.data;
        console.log('viewAudienceData' + resp);
        _this.viewAudienceDataDialog = true;
      }).catch(function (err) {
        console.error(err);
      });
    },
    getInfluencerDataToView: function getInfluencerDataToView(influencerID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (response) {
        _this2.viewInfluencerData = response;
        document.getElementById('viewInfluencer').click();
      }).catch(function (error) {
        console.log('error', error);
      });
    },

    getCredibilityColor: function getCredibilityColor(credibility) {
      var rate = this.toPercent(credibility);
      if (rate >= 0 && rate <= 29) {
        return '#f44336';
      } else if (rate >= 30 && rate <= 59) {
        return '#f9a825';
      } else if (rate >= 60 && rate <= 100) {
        return '#4caf50';
      }
    },
    toPercent: function toPercent(num) {
      return (num * 100).toFixed(2);
    },
    enterAmount: function enterAmount(item, index) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, amount;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$swal({
                  title: 'Enter payout amount for @' + item.instagramHandle,
                  showCancelButton: true,
                  inputValue: item.amount,
                  input: 'text',
                  inputValidator: function inputValidator(value) {
                    if (!value) {
                      return 'You need to enter amount!';
                    }
                  }
                });

              case 2:
                _ref = _context.sent;
                amount = _ref.value;

                _this3.$emit('amountChanged', amount, item);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    eliminateInfluencer: function eliminateInfluencer(igHandle) {
      this.influencerItems.map(function (item) {
        if (igHandle === item.instagramHandle) {
          item.status = 1;
        }
      });
    },
    showEliminationStatus: function showEliminationStatus(value) {
      if (value === 0) {
        return 'Selected';
      } else if (value === 1) {
        return 'Eliminated';
      } else {
        return 'Pending';
      }
    },
    emitSelected: function emitSelected(event) {
      this.$emit('sendSelected', this.selected);
    }
  },
  computed: {
    influencerItems: function influencerItems() {
      return this.influencers;
    },
    isElimination: function isElimination() {
      return this.elimination || false;
    }
  },
  watch: {}
});

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentAnalysis_contentAnalysisAPI__ = __webpack_require__(127);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerPostModal',
  props: ['modalId', 'title', 'shortCodes', 'platform'],
  data: function data() {
    return {
      posts: []
    };
  },

  watch: {
    shortCodes: function shortCodes(newValue) {
      this.shortCodes = newValue;
      if (!this.platform || this.platform === 'instagram') {
        this.posts = [];
        this.retrivePost();
      } else {
        this.posts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.shortCodes);
      }
    }
  },
  methods: {
    retrivePost: function retrivePost() {
      var _this = this;

      this.shortCodes.forEach(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(code) {
          var resp;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_3__ContentAnalysis_contentAnalysisAPI__["a" /* default */].oembed(code);

                case 2:
                  resp = _context.sent;

                  if (resp.oembed.length > 0) {
                    _this.posts.push(resp);
                  }
                  setTimeout(function () {
                    window.instgrm.Embeds.process();
                  }, 100);

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InputedRates',
  props: {
    inputedRates: Object
  },
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default.a
  }
});

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ViewModalDialog__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VerifyDialog__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VerifyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__VerifyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__InfOnboardPasswordModal_vue__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__InfOnboardPasswordModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__InfOnboardPasswordModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RateCardDataTable',
  components: {
    ViewModalDialog: __WEBPACK_IMPORTED_MODULE_10__ViewModalDialog___default.a,
    VerifyDialog: __WEBPACK_IMPORTED_MODULE_11__VerifyDialog___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_SocialHandle___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_TableColsShowHideModal___default.a,
    InfOnboardPasswordModal: __WEBPACK_IMPORTED_MODULE_14__InfOnboardPasswordModal_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_22_vue_loading_overlay___default.a
  },
  props: ['reload', 'isDownload'],
  watch: {
    reload: function reload(value) {
      if (value) {
        this.resetFilters();
        this.getRateCardLists();
      }
    },
    isDownload: function isDownload(value) {
      if (value) {
        this.downloadCreatorCommunityRpt();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    items: function items(state) {
      return state.influencer.creatorCommunities;
    },
    savedCreatorCommunity: function savedCreatorCommunity(state) {
      return state.influencer.savedCreatorCommunity;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isAdmin: function isAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isSortCurrency: function isSortCurrency() {
      var sortCol = this.sort.column;
      return sortCol === 'IG Story' || sortCol === 'IG Post' || sortCol === 'IG Carousel' || sortCol === 'IG Reel' || sortCol === 'Loading Fee' || sortCol === 'Event Attendance' || sortCol === 'TikTok';
    },
    computedHeaders: function computedHeaders() {
      var _this = this;

      var creatorCommunityCols = null;
      var headers = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.refreshJSON(this.headers);
      headers = headers.map(function (h) {
        if (h.value === 'labels') {
          h.text = '';
        }
        return h;
      });

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.creatorCommunityCols) {
          creatorCommunityCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.creatorCommunityCols);
        }
      }
      if (creatorCommunityCols) {
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, creatorCommunityCols);
      } else {
        headers.map(function (header) {
          _this.colStatuses[header.value] = true;
        });
      }
      return headers.filter(function (h) {
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    }
  }),
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func,
      viewData: null,
      viewDialog: false,
      verifyDialog: false,
      verifyData: null,
      infPassResetDialog: false,
      selectedInfluencerID: '',
      rateCardConfig: __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */],
      headers: __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].tableHeaders,
      rateCardLabels: __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].rateCardLabels,
      filteredItems: [],
      exportItems: [],
      filter: '',
      colStatuses: {},
      CC: [],
      colSettingsDialog: false,
      dateOfBirthCal: false,
      tableColsItems: [],
      userProfile: {},
      categories: __WEBPACK_IMPORTED_MODULE_19__influencerHelper__["a" /* default */].getCategories('en'),
      currencyOptions: __WEBPACK_IMPORTED_MODULE_17__config__["a" /* default */].currencyOptions,
      contentTypes: [{ title: 'IG Story', value: 'igStory' }, { title: 'IG Post', value: 'igPost' }, { title: 'IG Carousel', value: 'igCarousel' }, { title: 'IG Video', value: 'igVideo' }, { title: 'IG Reel', value: 'igReel' }, { title: 'IG TV', value: 'igTv' }, { title: 'Loading Fee', value: 'loadingFee' }, { title: 'Event Appearance', value: 'eventAppearance' }, { title: 'TikTok', value: 'tiktok' }],
      sortColumns: ['IG followers', 'TikTok followers', 'Date of Birth', 'Last Updated', 'IG Story', 'IG Post', 'IG Carousel', 'IG Reel', 'Loading Fee', 'Event Attendance', 'TikTok'],
      sortTypes: ['Ascending', 'Descending'],
      statuses: ['Pending', 'Valid', 'Invalid'],
      sort: {
        column: 'Updated At',
        currency: '',
        type: 'Ascending'
      },
      filters: {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        cc: '',
        status: '',
        followers: { from: '', to: '' },
        tiktokFollowers: { from: '', to: '' },
        contentType: '',
        rateCurrency: '',
        rate: { from: '', to: '' },
        age: { min: '', max: '' },
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      },
      totalValues: {
        pending: '',
        verified: '',
        unverified: ''
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var matchItem, resp;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.countries = __WEBPACK_IMPORTED_MODULE_21__static_sources_countries___default.a;
              _this2.countries = _this2.countries.map(function (c) {
                return c.name;
              });
              _context.next = 4;
              return _this2.getRateCardLists();

            case 4:
              if (_this2.$route.query.id) {
                matchItem = _this2.filteredItems.find(function (item) {
                  return item.id === _this2.$route.query.id;
                });

                _this2.getDataToView(matchItem);
              }
              _context.next = 7;
              return _this2.getUserProfile();

            case 7:
              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 9:
              resp = _context.sent;

              if (resp) _this2.CC = resp.users;

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: {
    getDataToView: function getDataToView(item) {
      this.$router.push({
        path: '/influencers/join-community',
        query: {
          id: item.id
        }
      });
      this.viewData = item;
      this.viewDialog = true;
    },
    getRateCardLists: function getRateCardLists() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var items;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$store.dispatch('influencer/getCreatorCommunityLists');

              case 2:
                items = _this3.items.map(function (i) {
                  return i;
                });

                items = items.map(function (item) {
                  if (!item.preferentialRates) {
                    item.preferentialRates = {};
                  }
                  if (!item.ordinaryRates) {
                    item.ordinaryRates = {
                      igStory: item.igStory || 0,
                      igStoryCurrency: 'SGD',
                      igPost: item.igPost || 0,
                      igPostCurrency: 'SGD',
                      igCarousel: item.igCarousel || 0,
                      igCarouselCurrency: 'SGD',
                      igVideo: item.igVideo || 0,
                      igVideoCurrency: 'SGD',
                      igReel: item.igReel || 0,
                      igReelCurrency: 'SGD',
                      igTv: item.igTv || 0,
                      igTvCurrency: 'SGD',
                      loadingFee: item.loadingFee || 0,
                      loadingFeeCurrency: 'SGD',
                      eventAppearance: item.eventAppearance || 0,
                      eventAppearanceCurrency: 'SGD',
                      tiktok: item.tiktok || 0,
                      tiktokCurrency: 'SGD'
                    };
                  }
                  if (!item.keywords) item.keywords = [];
                  if (!item.mainCategories) item.mainCategories = [];
                  if (!item.subCategories) item.subCategories = [];
                  return item;
                });
                _this3.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], items);
                _this3.searchFilter();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getPlatformUrl: function getPlatformUrl(item, platform) {
      if (item.platforms) {
        if (Array.isArray(item.platforms)) {
          var matchYoutube = item.platforms.find(function (p) {
            return p.platform === platform;
          });
          if (matchYoutube) {
            return matchYoutube.url;
          }
        }
      }
      return '';
    },
    getHandlePreview: function getHandlePreview(item, platform) {
      var url = this.getPlatformUrl(item, platform);
      var result = url;
      if (!url.includes('watch?')) {
        var lastSlashIndex = url.lastIndexOf('/');
        result = url.substring(lastSlashIndex + 1);
      }
      return result;
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.headers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                columns = _this4.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this4.userProfile.tableSettings) {
                  tableSettings = _this4.userProfile.tableSettings;
                }
                tableSettings.creatorCommunityCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this4.currentUserID,
                  tableSettings: tableSettings
                };
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this4.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                _this4.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getUser(_this5.currentUserID);

              case 2:
                resp = _context4.sent;

                if (resp && resp.id) {
                  _this5.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    downloadCreatorCommunityRpt: function downloadCreatorCommunityRpt() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var creatorCommunityIds, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.isLoading = true;
                creatorCommunityIds = _this6.filteredItems.map(function (i) {
                  return i.id;
                });
                data = {
                  creatorCommunityIds: creatorCommunityIds
                };

                __WEBPACK_IMPORTED_MODULE_20__influencerAPIs__["a" /* default */].downloadCreatorCommunityRpt(data).then(function () {
                  _this6.isLoading = false;
                }).catch(function (error) {
                  _this6.isLoading = false;
                  console.log('error in downloading creator community report', error);
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    searchFilter: function searchFilter() {
      var _this7 = this;

      this.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.items);
      if (this.filters.country) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.country === _this7.filters.country;
        });
      }
      if (this.filters.category) {
        var categoryTh = __WEBPACK_IMPORTED_MODULE_19__influencerHelper__["a" /* default */].getCategories('th');
        var categoryVn = __WEBPACK_IMPORTED_MODULE_19__influencerHelper__["a" /* default */].getCategories('vn');
        var categoryId = __WEBPACK_IMPORTED_MODULE_19__influencerHelper__["a" /* default */].getCategories('id');
        var categoryCn = __WEBPACK_IMPORTED_MODULE_19__influencerHelper__["a" /* default */].getCategories('cn');
        var catIdx = this.categories.findIndex(function (f) {
          return f === _this7.filters.category;
        });
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.keywords.includes(_this7.filters.category) || f.keywords.includes(categoryTh[catIdx]) || f.keywords.includes(categoryVn[catIdx]) || f.keywords.includes(categoryId[catIdx]) || f.keywords.includes(categoryCn[catIdx]);
        });
      }
      if (this.filters.followers.from) {
        var from = this.filters.followers.from.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igFollowerCount >= Number(from);
        });
      }
      if (this.filters.followers.to) {
        var to = this.filters.followers.to.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igFollowerCount <= Number(to);
        });
      }
      if (this.filters.tiktokFollowers.from) {
        var _from = this.filters.tiktokFollowers.from.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktokFollowerCount >= Number(_from);
        });
      }
      if (this.filters.tiktokFollowers.to) {
        var _to = this.filters.tiktokFollowers.to.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktokFollowerCount <= Number(_to);
        });
      }
      if (this.filters.isTikTokEmpty) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return !f.tiktokFollowerCount;
        });
      }
      if (this.filters.isIgEmpty) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return !f.igFollowerCount;
        });
      }
      if (this.filters.dateOfBirth) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.dateOfBirth && f.dateOfBirth.includes(_this7.filters.dateOfBirth);
        });
      }
      if (this.filters.age.min || this.filters.age.max) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          if (!f.dateOfBirth) return false;
          var today = new Date();
          var birthDate = new Date(f.dateOfBirth);
          var age = today.getFullYear() - birthDate.getFullYear();
          var monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) {
            age--;
          }
          if (_this7.filters.age.min && age < Number(_this7.filters.age.min)) return false;
          if (_this7.filters.age.max && age > Number(_this7.filters.age.max)) return false;
          return true;
        });
      }
      if (this.filters.starOnly) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.star;
        });
      }
      if (this.filters.mainCategory) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.mainCategories && f.mainCategories.includes(_this7.filters.mainCategory);
        });
      }
      if (this.filters.subCategory) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.subCategories && f.subCategories.includes(_this7.filters.subCategory);
        });
      }
      if (this.filters.cc) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.sourceID === _this7.filters.cc;
        });
      }

      if (this.filters.status) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          if (_this7.filters.status === 'Pending') {
            return f.verify === null || f.verify === undefined;
          } else if (_this7.filters.status === 'Valid') {
            return f.verify === true;
          } else if (_this7.filters.status === 'Invalid') {
            return f.verify === false;
          }
          return true;
        });
      }

      if (this.filters.contentType) {
        var contentTypeValue = this.filters.contentType.value;
        this.filteredItems = this.filteredItems.filter(function (f) {
          var rates = f.ordinaryRates || {};
          var rateValue = rates[contentTypeValue];
          if (!rateValue) return false;

          if (_this7.filters.rateCurrency) {
            var currencyKey = contentTypeValue + 'Currency';
            if (rates[currencyKey] !== _this7.filters.rateCurrency) {
              return false;
            }
          }

          if (_this7.filters.rate.from !== '' && _this7.filters.rate.from !== null) {
            if (Number(rateValue) < Number(_this7.filters.rate.from)) {
              return false;
            }
          }
          if (_this7.filters.rate.to !== '' && _this7.filters.rate.to !== null) {
            if (Number(rateValue) > Number(_this7.filters.rate.to)) {
              return false;
            }
          }

          return true;
        });
      }

      var sortCol = this.sort.column;
      var sortType = this.sort.type === 'Ascending' ? 'asc' : 'desc';
      this.filteredItems = this.filteredItems.map(function (f) {
        if (f.igFollowerCount) {
          f.igFollowerCount = Number(f.igFollowerCount);
        }
        if (f.tiktokFollowerCount) {
          f.tiktokFollowerCount = Number(f.tiktokFollowerCount);
        }
        var rates = f.ordinaryRates || {};
        if (rates.igStory) {
          f.igStory = Number(rates.igStory);
          f.igStoryCurrency = rates.igStoryCurrency;
        }
        if (rates.igPost) {
          f.igPost = Number(rates.igPost);
          f.igPostCurrency = rates.igPostCurrency;
        }
        if (rates.igCarousel) {
          f.igCarousel = Number(rates.igCarousel);
          f.igCarouselCurrency = rates.igCarouselCurrency;
        }
        if (rates.igVideo) {
          f.igVideo = Number(rates.igVideo);
          f.igVideoCurrency = rates.igVideoCurrency;
        }
        if (rates.igReel) {
          f.igReel = Number(rates.igReel);
          f.igReelCurrency = rates.igReelCurrency;
        }
        if (rates.igTv) {
          f.igTv = Number(rates.igTv);
          f.igTvCurrency = rates.igTvCurrency;
        }
        if (rates.loadingFee) {
          f.loadingFee = Number(rates.loadingFee);
          f.loadingFeeCurrency = rates.loadingFeeCurrency;
        }
        if (rates.eventAppearance) {
          f.eventAppearance = Number(rates.eventAppearance);
          f.eventAppearanceCurrency = rates.eventAppearanceCurrency;
        }
        if (rates.tiktok) {
          f.tiktok = Number(rates.tiktok);
          f.tiktokCurrency = rates.tiktokCurrency;
        }
        return f;
      });
      if (sortCol === 'IG followers') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igFollowerCount;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['igFollowerCount'], [sortType]);
      }
      if (sortCol === 'TikTok followers') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktokFollowerCount;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['tiktokFollowerCount'], [sortType]);
      }
      if (sortCol === 'Date of Birth') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.dateOfBirth;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['dateOfBirth'], [sortType]);
      }
      if (sortCol === 'Last Updated') {
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['updatedAt'], [sortType]);
      }
      if (sortCol === 'IG Story') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igStory;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['igStory'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igStoryCurrency === _this7.sort.currency;
          });
        }
      }
      if (sortCol === 'IG Post') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igPost;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['igPost'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igPostCurrency === _this7.sort.currency;
          });
        }
      }
      if (sortCol === 'IG Carousel') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igCarousel;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['igCarousel'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igCarouselCurrency === _this7.sort.currency;
          });
        }
      }
      if (sortCol === 'IG Reel') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igReel;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['igReel'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igReelCurrency === _this7.sort.currency;
          });
        }
      }
      if (sortCol === 'Loading Fee') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.loadingFee;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['loadingFee'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.loadingFeeCurrency === _this7.sort.currency;
          });
        }
      }
      if (sortCol === 'Event Attendance') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.eventAppearance;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['eventAppearance'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.eventAppearanceCurrency === _this7.sort.currency;
          });
        }
      }
      if (sortCol === 'TikTok') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktok;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_18_lodash_orderBy___default()(this.filteredItems, ['tiktok'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.tiktokCurrency === _this7.sort.currency;
          });
        }
      }

      this.totalValues.pending = this.filteredItems.filter(function (f) {
        return f.verify === null || f.verify === undefined;
      }).length;
      this.totalValues.verified = this.filteredItems.filter(function (f) {
        return f.verify === true;
      }).length;
      this.totalValues.unverified = this.filteredItems.filter(function (f) {
        return f.verify === false;
      }).length;
    },
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    },
    openResetDialog: function openResetDialog(item) {
      if (!item.email) {
        this.$swal({
          title: 'Empty Email',
          text: 'Please update email to reset password.',
          type: 'warning'
        });
        return;
      }
      this.viewData = item;

      this.infPassResetDialog = true;
    },
    deleteRateCard: function deleteRateCard(id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to delete?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(result) {
                    var payload;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!result.value) {
                              _context6.next = 13;
                              break;
                            }

                            _this8.isLoading = true;
                            payload = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                              id: id
                            });
                            _context6.next = 5;
                            return _this8.$store.dispatch('influencer/deleteCreatorCommunity', payload);

                          case 5:
                            _this8.isLoading = false;

                            if (_this8.savedCreatorCommunity) {
                              _context6.next = 9;
                              break;
                            }

                            _this8.$swal({
                              text: 'Error Deleting Rate Card.',
                              type: 'error'
                            });
                            return _context6.abrupt('return');

                          case 9:
                            _this8.$swal({
                              text: 'Successfully deleted.',
                              type: 'success'
                            });
                            _context6.next = 12;
                            return _this8.getRateCardLists();

                          case 12:
                            _this8.searchFilter();

                          case 13:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this8);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    chgStarStatus: function chgStarStatus(item, status) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var data, matchIdx;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.isLoading = true;
                data = [{
                  id: item.id,
                  star: status
                }];
                _context8.next = 4;
                return _this9.$store.dispatch('influencer/updateCreatorCommunityByIds', data);

              case 4:
                _this9.isLoading = false;
                if (_this9.savedCreatorCommunity) {
                  matchIdx = _this9.filteredItems.findIndex(function (f) {
                    return f.id === item.id;
                  });

                  _this9.filteredItems[matchIdx].star = status;
                  _this9.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this9.filteredItems);
                }

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    resetFilters: function resetFilters() {
      this.filters = {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        cc: '',
        followers: { from: '', to: '' },
        tiktokFollowers: { from: '', to: '' },
        contentType: '',
        rateCurrency: '',
        rate: { from: '', to: '' },
        age: { min: '', max: '' },
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      };
    },
    cancelDOB: function cancelDOB() {
      this.dateOfBirthCal = false;
      this.searchFilter();
    },
    searchIGFollower: function searchIGFollower() {
      this.sort.column = 'IG followers';
      this.sort.type = 'Descending';
      this.searchFilter();
    },
    searchTikTokFollower: function searchTikTokFollower() {
      this.sort.column = 'TikTok followers';
      this.sort.type = 'Descending';
      this.searchFilter();
    },
    changeLabel: function changeLabel(item) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this10.isLoading = true;
                data = [{
                  id: item.id,
                  mainCategories: item.mainCategories,
                  subCategories: item.subCategories
                }];
                _context9.next = 4;
                return _this10.$store.dispatch('influencer/updateCreatorCommunityByIds', data);

              case 4:
                _this10.isLoading = false;
                if (_this10.savedCreatorCommunity) {
                  _this10.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this10.filteredItems);
                }

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    onBoardSuccess: function onBoardSuccess() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                data = [{
                  id: _this11.viewData.id,
                  accountExist: true
                }];
                _context10.next = 3;
                return _this11.$store.dispatch('influencer/updateCreatorCommunityByIds', data);

              case 3:
                _this11.getRateCardLists();

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    openVerifyDialog: function openVerifyDialog(item) {
      this.verifyData = item;
      this.verifyDialog = true;
    },
    handleVerified: function handleVerified() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this12.getRateCardLists();

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    }
  }
});

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_sources_cities__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_sources_cities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_sources_cities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_sources_dialCodes__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_sources_dialCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_sources_dialCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RateCardTermsModal__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RateCardTermsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__RateCardTermsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_flag_icons_css_flag_icons_min_css__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_flag_icons_css_flag_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_flag_icons_css_flag_icons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__config_logoDataURL__);
























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RateCardForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_10_vuelidate__["validationMixin"]],
  validations: function validations() {
    var _this = this;

    var validationRules = {
      rateCardData: {
        name: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },
        email: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"],
          email: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["email"]
        },
        country: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },
        ethnicity: {
          requiredIfSpecificCountry: function requiredIfSpecificCountry(value) {
            var country = _this.rateCardData.country;
            if (country === 'Singapore' || country === 'Malaysia') {
              return value && value.length > 0;
            }
            return true;
          }
        },
        gender: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },

        aboutYou: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        }
      }
    };

    return validationRules;
  },
  components: {
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload___default.a,
    RateCardTermsModal: __WEBPACK_IMPORTED_MODULE_18__RateCardTermsModal___default.a
  },
  props: {
    mode: String,
    editData: Object
  },
  data: function data() {
    return {
      logoDataUrl: __WEBPACK_IMPORTED_MODULE_20__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png',
      dialog: true,
      rateCardDOB: false,
      formConfig: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].formConfig,
      langs: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].langs,
      countryCodeOptions: __WEBPACK_IMPORTED_MODULE_17__static_sources_dialCodes___default.a.map(function (d) {
        return d.dc;
      }),
      genderOptions: ['Male', 'Female'],
      ethnicityOptions: ['Chinese', 'Malay', 'Indian', 'Eurasian', 'Others'],
      rateCardData: {
        platforms: [],
        keywords: [],
        type: 'direct',
        agencyName: '',
        country: 'Singapore',
        city: '',
        ethnicity: '',
        otherEth: '',
        contactNo: '',
        gender: '',
        dateOfBirth: '',
        loadContent: '',
        loadContentText: '',
        giftBrand: '',
        igFollowerCount: '',
        tiktokFollowerCount: '',

        preferentialRates: {
          igStory: 0,
          igStoryCurrency: 'SGD',
          igPost: 0,
          igPostCurrency: 'SGD',
          igCarousel: 0,
          igCarouselCurrency: 'SGD',
          igVideo: 0,
          igVideoCurrency: 'SGD',
          igReel: 0,
          igReelCurrency: 'SGD',
          igTv: 0,
          igTvCurrency: 'SGD',
          loadingFee: 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: 0,
          tiktokCurrency: 'SGD'
        },
        ordinaryRates: {
          igStory: 0,
          igStoryCurrency: 'SGD',
          igPost: 0,
          igPostCurrency: 'SGD',
          igCarousel: 0,
          igCarouselCurrency: 'SGD',
          igVideo: 0,
          igVideoCurrency: 'SGD',
          igReel: 0,
          igReelCurrency: 'SGD',
          igTv: 0,
          igTvCurrency: 'SGD',
          loadingFee: 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: 0,
          tiktokCurrency: 'SGD'
        }
      },
      deckFiles: [],
      fileUploadRefresh: false,
      submitting: false,
      categories: [],
      countries: [],
      citiesByCountry: [],
      dialCodes: __WEBPACK_IMPORTED_MODULE_17__static_sources_dialCodes___default.a,
      currenyOptions: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].currencyOptions,
      langOptions: [{
        icon: 'fi-gb-eng',
        title: 'EN',
        value: 'en'
      }, {
        icon: 'fi-th',
        title: 'TH',
        value: 'th'
      }, {
        icon: 'fi-vn',
        title: 'VN',
        value: 'vn'
      }, {
        icon: 'fi-id',
        title: 'ID',
        value: 'id'
      }, {
        icon: 'fi-cn',
        title: 'CN',
        value: 'cn'
      }, {
        icon: 'fi-jp',
        title: 'JP',
        value: 'jp'
      }],
      selectedLang: 'en',
      minBirthDate: __WEBPACK_IMPORTED_MODULE_15_moment___default()().subtract(13, 'years').format('YYYY-MM-DD'),
      DOBDateCal: false,
      showAgreementModal: false
    };
  },

  watch: {
    editData: function editData(newValue) {
      if (newValue) {
        this.rateCardData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.editData);
        if (this.rateCardData.contactNo) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.countryCodeOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var code = _step.value;

              if (this.rateCardData.contactNo.includes(code)) {
                this.rateCardData.contactNo = this.rateCardData.contactNo.replaceAll(code, '');
                this.countryCode = code;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
    },
    selectedLang: function selectedLang(newValue) {
      this.updateCategories(newValue);
    }
  },
  methods: {
    close: function close() {
      this.$router.push({ path: '/' });
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    },
    submitForm: function submitForm() {
      this.showAgreementModal = false;
      this.$v.$touch();
      if (this.$v.rateCardData.$error) {
        return false;
      }
      if (!this.rateCardData.instagramHandle && !this.rateCardData.tiktokHandle) {
        this.$swal({
          text: this.getLang('enterIgTikTok'),
          type: 'warning'
        });
        return;
      }

      if (!this.rateCardData.keywords.length) {
        this.$swal({
          text: 'Please select preferred type of campaigns/genre!',
          type: 'warning'
        });
        return;
      }

      if (this.rateCardData.instagramHandle) {
        var igRates = this.rateCardData.ordinaryRates;
        var igFieldsEmpty = !igRates.igStory && !igRates.igPost && !igRates.igCarousel && !igRates.igVideo && !igRates.igReel && !igRates.igTv && !igRates.loadingFee && !igRates.eventAppearance;

        if (igFieldsEmpty) {
          this.$swal({
            text: 'Please enter IG Rates',
            type: 'warning'
          });
          return;
        }
      }

      if (this.rateCardData.tiktokHandle) {
        var tiktokRate = this.rateCardData.ordinaryRates.tiktok;

        if (!tiktokRate) {
          this.$swal({
            text: 'Please enter TikTok Rates',
            type: 'warning'
          });
          return;
        }
      }

      this.showAgreementModal = true;
    },
    confirmSave: function confirmSave() {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var formData;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 6;
                    break;
                  }

                  _this2.submitting = true;
                  formData = _this2.constructData();
                  _context.next = 5;
                  return _this2.$store.dispatch('influencer/saveCreatorCommunity', formData);

                case 5:
                  if (_this2.savedCreatorCommunity) {
                    _this2.submitting = false;

                    _this2.$swal({
                      text: 'Community Form ' + (_this2.rateCardData.id ? 'Updated' : 'Submitted'),
                      type: 'success'
                    }).then(function (result) {
                      window.location.href = 'https://getkobe.com';
                    });
                  } else {
                    _this2.submitting = false;
                    _this2.$swal({
                      text: 'Error saving Community Form.',
                      type: 'error'
                    });
                  }

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    constructData: function constructData() {
      var saveData = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.rateCardData);
      saveData.lang = this.selectedLang;
      saveData.instagramHandle = saveData.instagramHandle ? __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.regexMatchIg(saveData.instagramHandle, __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].regexPattern.instagram_profile)) : '';
      saveData.tiktokHandle = saveData.tiktokHandle ? __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.extractTikTokHandle(saveData.tiktokHandle)) : '';
      saveData.contactNo = '' + this.countryCode + saveData.contactNo;
      var formData = new FormData();
      formData.append('data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(saveData));
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.deckFiles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var val = _step2.value;

          formData.append('uploadFile', val);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return formData;
    },
    updatePricingDecks: function updatePricingDecks(medias) {
      this.deckFiles = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], medias);
    },
    addPlatform: function addPlatform(fieldName) {
      this.rateCardData[fieldName].push({
        platform: '',
        url: '',
        rate: '',
        rateCurrency: 'SGD'
      });
    },
    changeDate: function changeDate() {
      this.$refs.datePicker.save(this.rateCardData.dateOfBirth);
    },
    changeCountry: function changeCountry() {
      var _this3 = this;

      var optionOne = this.dialCodes.find(function (o) {
        return o.cn === _this3.rateCardData.country;
      });
      if (optionOne) {
        this.countryCode = optionOne.dc;
      }
      this.rateCardData.city = '';

      this.citiesByCountry = [];
      var selectedCities = __WEBPACK_IMPORTED_MODULE_16__static_sources_cities___default.a[this.rateCardData.country];
      if (Array.isArray(selectedCities)) {
        this.citiesByCountry = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], selectedCities);
      }
      this.setCurrencyOptionsOnLang();
    },
    getLang: function getLang(attr) {
      return this.langs[this.selectedLang][attr] || '';
    },
    updateCategories: function updateCategories(newValue) {
      this.categories = __WEBPACK_IMPORTED_MODULE_13__influencerHelper__["a" /* default */].getCategories(newValue);
    },
    setLangParam: function setLangParam() {
      var queries = this.$route.query;
      queries.lang = this.selectedLang;

      var queryString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(queries).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(queries[key]);
      }).join('&');
      window.location.href = window.location.pathname + '?' + queryString;
    },
    setCurrencyOptionsOnLang: function setCurrencyOptionsOnLang() {
      var _this4 = this;

      var currencyOptions = [{ lang: 'Singapore', value: 'SGD' }, { lang: 'en', value: 'USD' }, { lang: 'Indonesia', value: 'IDR' }, { lang: 'Philippines', value: 'PHP' }, { lang: 'Thailand', value: 'THB' }, { lang: 'Malaysia', value: 'MYR' }, { lang: 'Vietnam', value: 'VND' }, { lang: 'Japan', value: 'JPY' }];

      var selectedCurrency = currencyOptions.find(function (option) {
        return option.lang === _this4.rateCardData.country;
      });
      if (selectedCurrency) {
        var currencyValue = selectedCurrency.value;
        var currencyFields = ['igStoryCurrency', 'igPostCurrency', 'igCarouselCurrency', 'igVideoCurrency', 'igReelCurrency', 'igTvCurrency', 'loadingFeeCurrency', 'eventAppearanceCurrency', 'tiktokCurrency'];

        currencyFields.forEach(function (field) {
          _this4.rateCardData.preferentialRates[field] = currencyValue;
          _this4.rateCardData.ordinaryRates[field] = currencyValue;
        });
      }
    },
    changeLang: function changeLang() {
      this.setLangParam();
    },
    onlyForNumber: function onlyForNumber($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    savedCreatorCommunity: function savedCreatorCommunity(state) {
      return state.influencer.savedCreatorCommunity;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isCreateMode: function isCreateMode() {
      return !this.mode;
    },
    isEditMode: function isEditMode() {
      return this.mode === 'edit';
    }
  }),
  mounted: function mounted() {
    if (this.$route.query.lang) {
      this.selectedLang = this.$route.query.lang;
    }
    if (this.$route.query.name) {
      this.rateCardData.name = this.$route.query.name;
    }
    if (this.$route.query.email) {
      this.rateCardData.email = this.$route.query.email;
    }
    if (this.$route.query.influencerID) {
      this.rateCardData.influencerID = this.$route.query.influencerID;
    }
    if (this.$route.query.sourceid) {
      this.rateCardData.sourceID = this.$route.query.sourceid;
    }
    this.addPlatform('platforms');

    this.countries = __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].targetCountries;
    this.changeCountry();
    this.updateCategories(this.selectedLang);
  }
});

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfOnboardPasswordModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    influencer: Object
  },
  data: function data() {
    return {
      user: {},
      generatedPass: '',
      errorMessage: null,
      show: {
        password: false
      }
    };
  },

  watch: {
    influencer: function influencer(newInfluencerData) {
      this.user = {
        newPassword: ''
      };
      this.generatePass();
    }
  },

  computed: {
    passwordError: function passwordError() {
      var errors = [];
      if (!this.$v.user.newPassword.$dirty) return errors;
      !this.$v.user.newPassword.required && errors.push('Password is required.');
      return errors;
    }
  },

  validations: {
    user: {
      newPassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit('input');
    },
    changePassword: function changePassword() {
      var _this = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to onboard for ' + this.influencer.email,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this.errorMessage = null;
          var editingInfo = {
            email: _this.influencer.email,
            password: _this.user.newPassword,
            igHandle: _this.influencer.instagramHandle,
            tiktokHandle: _this.influencer.tiktokHandle
          };
          _this.isLoading = true;

          __WEBPACK_IMPORTED_MODULE_0__User_userAPIs__["a" /* default */].createCommunityOnboardLink(editingInfo).then(function (response) {
            _this.$emit('reload', response);

            _this.closeModal();
            _this.$swal({
              html: 'Please save a copy of users credentials.<br><br>\n                <b>' + _this.influencer.email + '</b><br>\n                <b>' + _this.user.newPassword + '</b><br><br>\n                <i style=\'font-size:13px\'>Once confirmed, this password will no longer be visible</i>',
              type: 'success'
            });
            _this.isLoading = false;
          }).catch(function (error) {
            _this.errorMessage = error.response.data.message;
            console.log('error.response', error.response);
            console.log('error.response.data', error.response.data);
            console.log('error', error.response.data.message);
            _this.isLoading = false;
          });
        }
      });
    },
    copyPass: function copyPass() {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].func.copyToClipboard('#copy-pass');
      }, 100);
      this.password = this.generatedPass;
    },

    generatePass: function generatePass() {
      this.generatedPass = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].func.generatePassword();
    },
    clearData: function clearData() {
      this.user = {
        newPassword: ''
      };
    }
  },
  mounted: function mounted() {
    this.user = {
      newPassword: ''
    };
  }
});

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(172);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Influencer-Terms-Modal',
  props: {
    dialogTitle: String,
    value: Boolean,
    selectedLang: String
  },
  data: function data() {
    return {
      termsAndConditions: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].rateCardTermsAndCondition,
      showContractModal: false,
      agreement: '',
      valid: true,
      alert: false
    };
  },

  methods: {
    agree: function agree() {
      this.$emit('termsAggrement', true);
      this.$emit('input');
    },
    disagree: function disagree() {
      this.$emit('input');
    },
    getLang: function getLang() {
      this.$emit('getLang');
    }
  }
});

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(172);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VerifyDialog',
  props: {
    value: Boolean,
    item: Object
  },
  data: function data() {
    return {
      verifying: false,
      checklist: [],
      isLoading: true
    };
  },

  watch: {
    item: {
      handler: function handler(newItem) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(newItem && newItem.id)) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return _this.loadChecklist();

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      },

      deep: true
    }
  },
  computed: {},
  methods: {
    close: function close() {
      this.$emit('input', false);
    },
    checkFollowerData: function checkFollowerData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__influencerAPIs__["a" /* default */].checkFollowers(_this2.item.id);

              case 3:
                result = _context2.sent;
                return _context2.abrupt('return', result);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.error('Error fetching public profile:', _context2.t0);
                throw _context2.t0;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    loadChecklist: function loadChecklist() {
      var _this3 = this;

      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var followerData, updatedMinimumFollowersCheck, errorCheck;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isLoading = true;

                _this3.checklist = _this3.generateChecklist(_this3.item, null);

                _context3.prev = 2;

                if (!(_this3.item.verify === undefined || force)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 6;
                return _this3.checkFollowerData();

              case 6:
                followerData = _context3.sent;
                updatedMinimumFollowersCheck = _this3.generateChecklist(_this3.item, followerData)[0];

                updatedMinimumFollowersCheck.loading = false;
                _this3.$set(_this3.checklist, 0, updatedMinimumFollowersCheck);
                _this3.verifyCreatorCommunity();
                _context3.next = 14;
                break;

              case 13:
                _this3.checklist[0].loading = false;

              case 14:
                _context3.next = 21;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](2);

                console.error('Error loading checklist:', _context3.t0);
                errorCheck = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.checklist[0], { loading: false, igFollower: 0, tiktokFollower: 0, passed: false });

                _this3.$set(_this3.checklist, 0, errorCheck);

              case 21:
                _context3.prev = 21;

                _this3.isLoading = false;
                return _context3.finish(21);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 16, 21, 24]]);
      }))();
    },
    generateChecklist: function generateChecklist(item, followerData) {
      var targetCountries = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].targetCountries;

      var hasOrdinaryRates = item.ordinaryRates && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.ordinaryRates).some(function (key) {
        if (key.includes('Currency')) return false;
        return item.ordinaryRates[key] && item.ordinaryRates[key] > 0;
      });

      var igFollowerCount = 0;
      var tiktokFollowerCount = 0;

      if (followerData) {
        if (followerData.instagram && followerData.instagram.data && followerData.instagram.data.followers) {
          igFollowerCount = followerData.instagram.data.followers;
        }
        if (followerData.tiktok && followerData.tiktok.data && followerData.tiktok.data.followers) {
          tiktokFollowerCount = followerData.tiktok.data.followers;
        }
      } else {
        if (item.igFollowerCount) {
          igFollowerCount = item.igFollowerCount;
        }
        if (item.tiktokFollowerCount) {
          tiktokFollowerCount = item.tiktokFollowerCount;
        }
      }

      return [{
        text: item.country === 'Singapore' ? 'Minimum 5000 followers' : 'Minimum 10,000 followers',
        loading: this.isLoading,
        passed: item.country === 'Singapore' ? igFollowerCount >= 5000 || tiktokFollowerCount >= 5000 : igFollowerCount >= 10000 || tiktokFollowerCount >= 10000,
        igFollower: igFollowerCount,
        tiktokFollower: tiktokFollowerCount
      }, {
        text: 'Aligned to the country',
        passed: targetCountries.includes(item.country),
        value: item.country
      }, {
        text: 'Clearly defined category/vertical',
        passed: item.keywords && item.keywords.length > 0,
        value: item.keywords
      }, {
        text: 'Complete bio/description',
        passed: !!item.aboutYou,
        value: item.aboutYou
      }, {
        text: 'Accurate contact details',
        passed: !!item.email || !!item.contactNo,
        email: item.email,
        contactNo: item.contactNo
      }, {
        text: 'Updated rate card',
        passed: hasOrdinaryRates,
        value: hasOrdinaryRates ? 'Ratecards Present' : 'NO DATA'
      }];
    },
    verifyCreatorCommunity: function verifyCreatorCommunity() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var allChecksPassed;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.verifying = true;
                _context4.prev = 1;
                allChecksPassed = _this4.checklist.every(function (check) {
                  return check.passed;
                });
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__influencerAPIs__["a" /* default */].updateCreatorCommunityById({
                  id: _this4.item.id,
                  verify: allChecksPassed
                });

              case 5:
                _this4.$emit('verified');
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](1);

                _this4.$swal({
                  text: 'Error saving creator community.',
                  type: 'error'
                });

              case 11:
                _context4.prev = 11;

                _this4.verifying = false;
                return _context4.finish(11);

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 8, 11, 14]]);
      }))();
    }
  }
});

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewModalDialog',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default.a,
    FilePreview: __WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview___default.a,
    RateCardForm: __WEBPACK_IMPORTED_MODULE_2__Form___default.a
  },
  props: {
    value: Boolean,
    data: Object,
    rateCardDialog: Boolean
  },
  data: function data() {
    return {
      openExpansion: [0, 1],
      campaignVerticals: [],
      currentMode: 'detail',
      editData: null,
      utils: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue) {
        this.currentMode = 'detail';
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },
    changeMode: function changeMode(mode) {
      var _this = this;

      this.currentMode = mode;
      setTimeout(function () {
        _this.editData = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.refreshJSON(_this.data);
      }, 100);
    },
    updatedRateCardForm: function updatedRateCardForm() {
      this.close();
      this.$emit('updated');
    },
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    },
    transPreferredEng: function transPreferredEng(keyword) {
      var categoryEn = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('en');
      var categoryTh = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('th');
      var categoryVn = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('vn');
      var categoryId = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('id');
      var categoryCn = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('cn');
      var matchIdx = -1;
      matchIdx = categoryTh.findIndex(function (c) {
        return c === keyword;
      });
      if (matchIdx < 0) {
        matchIdx = categoryVn.findIndex(function (c) {
          return c === keyword;
        });
      }
      if (matchIdx < 0) {
        matchIdx = categoryId.findIndex(function (c) {
          return c === keyword;
        });
      }
      if (matchIdx < 0) {
        matchIdx = categoryCn.findIndex(function (c) {
          return c === keyword;
        });
      }
      if (matchIdx >= 0) {
        return categoryEn[matchIdx];
      }
      return keyword;
    }
  }
});

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DataTable__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Brand Fact Sheet',
  components: {
    RateCardDataTable: __WEBPACK_IMPORTED_MODULE_8__DataTable___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      rateCardLink: '',
      rateCardCopied: false,
      importLoading: false,
      importItems: [],
      viewID: null,
      isRefresh: 0,
      isDownload: 0,
      CO: []
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isAdmin: function isAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    }
  },
  methods: {
    copyLink: function copyLink(id) {
      var protocol = window.location.protocol;
      var host = window.location.host;

      var selectedCO = this.CO.find(function (co) {
        return co.id === id;
      });
      var coName = selectedCO ? selectedCO.name : '';
      this.rateCardLink = protocol + '//' + host + __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].JOIN_COMMUNITY_FORM_URL + '?sourceid=' + id + '&cc=' + encodeURIComponent(coName);
      var vm = this;
      setTimeout(function () {
        vm.rateCardCopied = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.copyToClipboard('#copy-link');
      }, 100);
      setTimeout(function () {
        vm.rateCardCopied = false;
      }, 1000);
    },
    reload: function reload() {
      this.isRefresh += 1;
    },
    download: function download() {
      this.isDownload += 1;
    },
    importFileUpload: function importFileUpload(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var uploadedFiles, uploadResp, importItems;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.importLoading = true;
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context.next = 5;
                  break;
                }

                _this.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context.abrupt('return');

              case 5:
                _context.next = 7;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var fr = new FileReader();
                  fr.onload = function (e) {
                    var tmp = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.parserToJson(e.target.result);
                    resolve(tmp);
                  };
                  fr.readAsArrayBuffer(e.target.files[0]);
                  fr.onerror = reject;
                });

              case 7:
                uploadResp = _context.sent;

                if (uploadResp.length) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                importItems = [];

                if (uploadResp.length > 1) {
                  importItems = uploadResp[1];
                } else {
                  importItems = uploadResp[0];
                }
                _this.uploadRateCard(importItems);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    uploadRateCard: function uploadRateCard(importItems) {
      var _this2 = this;

      if (importItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Imported Rate Card Found'
        });
        return;
      }

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        importItems: importItems
      });
      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].importRateCard(data).then(function (resp) {
        _this2.importLoading = false;

        var success = resp.success;
        var fails = resp.failed;
        var htmlTxt = 'Successfully Imported.';
        if (success) {
          htmlTxt += '<br>Success: ' + success;
        }
        if (Array.isArray(fails) && fails.length > 0) {
          htmlTxt += '<br>Failed Rows at: ' + fails.join(', ');
        }
        _this2.$swal({
          title: 'Success',
          icon: 'info',
          html: htmlTxt
        });
        _this2.reload();
      }).catch(function (err) {
        _this2.importLoading = false;
        console.error(err);
        _this2.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Failed to Import Influencers'
        });
      });
      this.$refs.rateCardFileInput.value = null;
    },
    downloadSampleUpload: function downloadSampleUpload() {
      var link = document.createElement('a');

      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_ratecard_template.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].userRoles.AD_STRATEGIST);

            case 2:
              response = _context2.sent;

              if (response) {
                _this3.CO = response.users;
                _this3.CO = _this3.CO.map(function (co) {
                  co.name = '' + co.firstName;
                  return co;
                });
              }

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_sources_countries__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SettingsModal',
  props: ['value', 'oldSettings'],
  data: function data() {
    return {
      searchConfig: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */],
      countries: [],
      infGender: '',
      audGender: '',
      settings: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].searchSettings
    };
  },

  watch: {
    value: function value(newVal) {
      if (newVal) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.oldSettings).length) {
          this.settings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.oldSettings);
        }
      }
    }
  },
  methods: {
    saveSettings: function saveSettings() {
      this.close();
      this.$emit('saveSettings', this.settings);
    },
    getCountries: function getCountries() {
      this.countries = __WEBPACK_IMPORTED_MODULE_3__static_sources_countries___default.a;
      this.countries = this.countries.map(function (c) {
        return c.name;
      });
    },
    resetFilters: function resetFilters() {
      this.settings = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].searchSettings;
    },
    close: function close() {
      this.$emit('input');
    }
  },
  mounted: function mounted() {
    this.getCountries();
  }
});

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignListsModal',
  props: ['items', 'value', 'handle', 'platform'],
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default.a
  },
  data: function data() {
    return {
      headers: [{
        text: 'Handle',
        value: 'handle'
      }, {
        text: 'Country',
        value: 'countryName'
      }, {
        text: 'Followers',
        value: 'followers'
      }],
      dataTableKey: 1,
      avatarSize: 45 };
  },

  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AudienceDataReportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InfluencerPostsModal__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InfluencerPostsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__InfluencerPostsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SimilarUsersModal__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SimilarUsersModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SimilarUsersModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SettingsModal__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SettingsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SettingsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuewordcloud__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuewordcloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuewordcloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__);






var _components;

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchKeyword',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  validations: function validations() {
    var validationRules = {
      searchSettings: {
        influencerGeos: {
          required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
        },
        audGeos: {
          required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
        },
        infGender: {
          required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
        }
      },
      platform: {
        required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"]
      }
    };

    return validationRules;
  },
  components: (_components = {
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_10__AudienceDataReportModal___default.a,
    InfluencerPostModal: __WEBPACK_IMPORTED_MODULE_11__InfluencerPostsModal___default.a,
    SimilarUsersModal: __WEBPACK_IMPORTED_MODULE_12__SimilarUsersModal___default.a,
    SettingsModal: __WEBPACK_IMPORTED_MODULE_13__SettingsModal___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_14__components_scoped_custom_SocialHandle___default.a
  }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_15_vuewordcloud___default.a.name, __WEBPACK_IMPORTED_MODULE_15_vuewordcloud___default.a), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components, 'Loading', __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default.a), _components),
  data: function data() {
    return {
      audienceDataReportId: 'audience_data_report_modal',
      influencerPostModalId: 'influencerPostModalId',
      viewAudienceDataDialog: false,
      viewInfluencerData: null,
      audienceDataReport: null,
      expand: false,
      loading: false,
      keywordLoading: false,
      peformSearch: 'none',
      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [''],
        itemsPerPage: 20
      },
      localPagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [''],
        itemsPerPage: 20
      },
      totalItems: 0,
      localTotalItems: 0,
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      originalItems: [],
      postsTitle: '',
      avatarSize: 35,
      shortCodes: [],
      searchConfig: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      fields: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].localTableHeaders,
      countries: [],
      items: [],
      totalRows: 0,
      currentPage: 1,
      localCurrentPage: 1,
      perPage: 20,
      searchedItems: [],
      searchItems: [],
      resultMessage: '',
      keyword: [],
      multipleKeywords: [],
      wordCloudData: [],
      platformList: ['Instagram', 'TikTok', 'Youtube'],
      platform: 'Instagram',
      overlayLoading: false,
      dialog: false,
      searchSettings: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].searchSettings,
      viewSimilarUsersDialog: false,
      similarHandle: '',
      similarItems: [],

      iqDataHeaders: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].iqDataTableHeaders,
      iqDataItems: [],
      isIqData: true,
      isMainSearch: false,
      isLocal: false,
      iqDataTotal: 0,
      iqDataTableSearch: '',
      step: 1,

      newAudLookKeyword: '',
      audLookKeyword: '',
      audLookItems: [],
      audLookLoading: false,

      newInfLookKeyword: '',
      infLookKeyword: '',
      infLookItems: [],
      lookLoading: false
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isSuperAdminRole: function isSuperAdminRole() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    audienceDataReportDisplay: function audienceDataReportDisplay() {
      return '#' + this.audienceDataReportId;
    },
    influencerPostDisplay: function influencerPostDisplay() {
      return '#' + this.influencerPostModalId;
    },
    platformShort: function platformShort() {
      return this.platform.toLowerCase();
    },
    localPayload: function localPayload() {
      var perPage = this.localPagination.itemsPerPage <= 0 ? 20 : this.localPagination.itemsPerPage;
      var distance = 0;
      var freq = 0;
      if (this.searchSettings.distance) {
        distance = (this.searchSettings.distance / 100).toFixed(2);
      }
      if (this.searchSettings.frequency) {
        freq = (this.searchSettings.frequency / 10).toFixed(2);
      }
      var topicKeyword = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.keyword);
      if (this.multipleKeywords.length) {
        topicKeyword = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.multipleKeywords);
      }
      return {
        filter: {
          platform: this.platformShort,
          tags: topicKeyword,
          relevancy: (this.searchSettings.relevantKeywords / 100).toFixed(2),
          distance: distance,
          freq: freq,
          influencerGeos: this.searchSettings.influencerGeos,
          audGeos: this.searchSettings.audGeos,
          audGeoPercent: Number(this.searchSettings.audGeoPercent.replace('≥', '').replace('%', '')) / 100,
          infGender: this.searchSettings.infGender,
          audGender: this.searchSettings.audGender,
          audGenderPercent: Number(this.searchSettings.audGenderPercent.replace('≥', '').replace('%', '')) / 100,
          followers: this.searchSettings.followers,
          engagements: this.searchSettings.engagements,
          engagementRate: this.searchSettings.engagementRate,
          bio: this.searchSettings.bio,
          keywords: this.searchSettings.keywords,
          mentions: this.searchSettings.mentions,
          hashtags: this.searchSettings.hashtags,
          audLookalike: this.audLookKeyword || '',
          infLookalike: this.infLookKeyword || '',
          isIqData: false
        },
        paging: {
          per_page: perPage,
          page: 1,
          sortBy: this.localPagination.sortBy[0],
          descending: this.localPagination.sortDesc[0]
        }
      };
    }
  },
  watch: {
    pagination: function pagination(newVal) {
      this.paginate(newVal.page);
    },
    localPagination: function localPagination(newVal) {},
    keyword: function keyword(newVal) {
      this.refreshWordCloud();
    }
  },
  methods: {
    searchInf: function searchInf() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isMainSearch = true;
                _this.isIqData = true;
                _this.paginate();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    payload: function payload(page) {
      var perPage = this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage;
      var distance = 0;
      var freq = 0;
      if (this.isIqData) {
        perPage = 20;
      }
      if (this.searchSettings.distance) {
        distance = (this.searchSettings.distance / 100).toFixed(2);
      }
      if (this.searchSettings.frequency) {
        freq = (this.searchSettings.frequency / 10).toFixed(2);
      }
      var topicKeyword = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.keyword);
      if (this.multipleKeywords.length) {
        topicKeyword = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.multipleKeywords);
      }
      return {
        filter: {
          platform: this.platformShort,
          tags: topicKeyword,
          relevancy: (this.searchSettings.relevantKeywords / 100).toFixed(2),
          distance: distance,
          freq: freq,
          influencerGeos: this.searchSettings.influencerGeos,
          audGeos: this.searchSettings.audGeos,
          audGeoPercent: Number(this.searchSettings.audGeoPercent.replace('≥', '').replace('%', '')) / 100,
          infGender: this.searchSettings.infGender,
          audGender: this.searchSettings.audGender,
          audGenderPercent: Number(this.searchSettings.audGenderPercent.replace('≥', '').replace('%', '')) / 100,
          followers: this.searchSettings.followers,
          engagements: this.searchSettings.engagements,
          engagementRate: this.searchSettings.engagementRate,
          bio: this.searchSettings.bio,
          keywords: this.searchSettings.keywords,
          mentions: this.searchSettings.mentions,
          hashtags: this.searchSettings.hashtags,
          audLookalike: this.audLookKeyword || '',
          infLookalike: this.infLookKeyword || '',
          isIqData: this.isIqData
        },
        paging: {
          per_page: perPage,
          page: page,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    },
    paginate: function paginate() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isContinue;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.isIqData) {
                  _context2.next = 7;
                  break;
                }

                if (!_this2.iqDataTotal) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return _this2.checkRemainInf();

              case 4:
                isContinue = _context2.sent;

                if (isContinue) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:
                _this2.setRouteParams();

                _this2.loading = true;
                __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].searchAudDataKeyword(_this2.payload(page)).then(function (response) {
                  _this2.loading = false;

                  if (_this2.isMainSearch) {
                    _this2.iqDataItems = [];
                    _this2.isMainSearch = false;
                  }
                  _this2.updateIqDataItems(response.influencers);
                  _this2.iqDataTotal += response.influencers.length;
                  _this2.totalItems = response.totalInfluencers;
                  if (_this2.pagination.itemsPerPage === -1) {
                    _this2.pagination.itemsPerPage = 20;
                  }
                  _this2.currentPage = page;
                }).catch(function (error) {
                  _this2.loading = false;
                  console.log(error);
                });

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    localPaginate: function localPaginate() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isContinue;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.isIqData) {
                  _context3.next = 7;
                  break;
                }

                if (!_this3.iqDataTotal) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return _this3.checkRemainInf();

              case 4:
                isContinue = _context3.sent;

                if (isContinue) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return');

              case 7:
                _this3.setRouteParams();
                _this3.localPayload.paging.page = page;
                _this3.localLoading = true;
                __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].searchAudDataKeyword(_this3.localPayload).then(function (response) {
                  _this3.localLoading = false;

                  _this3.updateItems(response.influencers);
                  _this3.localTotalItems = response.totalInfluencers;
                  if (_this3.localPagination.itemsPerPage === -1) {
                    _this3.localPagination.itemsPerPage = 20;
                  }
                  _this3.localCurrentPage = page;
                }).catch(function (error) {
                  _this3.localLoading = false;
                  console.log(error);
                });

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    updateItems: function updateItems(response) {
      var _this4 = this;

      var displayItems = response.map(function (element) {
        var tags = [];
        if (element.user_profile) {
          if (element.user_profile.relevant_tags) {
            var matchTags = element.user_profile.relevant_tags.filter(function (rt) {
              return _this4.keyword.includes(rt.tag) || _this4.multipleKeywords.includes(rt.tag);
            });
            if (matchTags) {
              tags = matchTags.map(function (m) {
                return m.tag;
              });
            }
          }
        }

        var resp = {
          id: element.id,
          reportID: element.report_info.report_id,
          handle: element.user_profile ? element.user_profile.username || element.user_profile.custom_name : '',
          fullName: element.user_profile ? element.user_profile.fullname : '',
          totalFollowers: element.user_profile ? element.user_profile.followers : '',
          profilePicture: element.user_profile ? element.user_profile.picture || '/static/img/avatar/user.png' : '/static/img/avatar/user.png',
          engagementRate: element.user_profile ? (Number(element.user_profile.engagement_rate) * 100).toFixed(2) : 0,
          avgViews: element.user_profile.avg_views || '',
          avgLikes: element.user_profile.avg_likes || '',
          avgComments: element.user_profile.avg_comments || '',
          avgReelPlays: element.user_profile.avg_reels_plays || '',
          tags: tags,
          top_posts: element.user_profile.top_posts,
          recent_posts: element.user_profile.recent_posts,
          similarUsers: element.user_profile.similar_users || [],
          countryName: ''
        };
        return resp;
      });
      this.items = displayItems;
      this.totalRows = response.totalInfluencers;
      this.setProfilePics();
    },
    updateIqDataItems: function updateIqDataItems(response) {
      var _this5 = this;

      response.map(function (element) {
        var userProfile = null;
        if (element.account) {
          userProfile = element.account.user_profile;
        }
        var resp = {
          handle: userProfile ? userProfile.username || userProfile.custom_name : '',
          fullName: userProfile ? userProfile.fullname : '',
          totalFollowers: userProfile ? userProfile.followers : '',
          profilePicture: userProfile ? userProfile.picture || '/static/img/avatar/user.png' : '/static/img/avatar/user.png',
          engagementRate: userProfile ? (Number(userProfile.engagement_rate) * 100).toFixed(2) : '',
          engagements: userProfile ? (Number(userProfile.engagements) * 100).toFixed(2) : ''
        };
        if (typeof resp.handle === 'undefined') {
          resp.hidden = true;
        }
        _this5.iqDataItems.push(resp);
        return resp;
      });
    },
    viewInfluencerPosts: function viewInfluencerPosts(item) {
      var posts = item.top_posts || [];
      if (posts.length > 0) {
        posts = this.getPostShortCode(posts);
        posts = posts.filter(function (p) {
          return p.shortCode;
        });
        this.shortCodes = posts.map(function (item) {
          return item.shortCode;
        });
        document.getElementById('viewPosts').click();
        this.postsTitle = 'Related Posts (' + item.handle + ')';
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    viewRecentPosts: function viewRecentPosts(item) {
      var posts = item.recent_posts || [];
      if (posts.length > 0) {
        posts = this.getPostShortCode(posts);
        posts = posts.filter(function (p) {
          return p.shortCode;
        });
        this.shortCodes = posts.map(function (item) {
          return item.shortCode;
        });
        document.getElementById('viewPosts').click();
        this.postsTitle = 'Recent Posts(' + item.handle + ')';
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    getPostShortCode: function getPostShortCode(posts) {
      var _this6 = this;

      posts = posts.map(function (p) {
        var matches = void 0;
        if (_this6.platformShort === 'instagram') {
          if ((matches = p.link.match(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].regexPattern.instagram_post)) !== null) {
            p.shortCode = matches[1];
          }
        } else if (_this6.platformShort === 'tiktok') {
          if ((matches = p.link.match(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].regexPattern.TIKTOK_POST)) !== null) {
            p.shortCode = matches[1];
            if (p.shortCode) {
              p.shortCode = __WEBPACK_IMPORTED_MODULE_17__Campaign_campaignHelper__["a" /* default */].getTikTokPost(p.shortCode);
            }
          }
        } else if (_this6.platformShort === 'youtube') {
          if ((matches = p.link.match(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].regexPattern.YOUTUBE_POST)) !== null) {
            p.shortCode = matches[1];
            if (p.shortCode) {
              p.shortCode = __WEBPACK_IMPORTED_MODULE_17__Campaign_campaignHelper__["a" /* default */].getYoutubePost(p.shortCode);
            }
          }
        }
        return p;
      });
      return posts;
    },
    viewSimilarUsers: function viewSimilarUsers(item) {
      this.similarItems = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], item.similarUsers);
      if (this.similarItems) {
        this.similarItems = this.similarItems.map(function (element) {
          if (element.geo) {
            if (element.geo.country.name) {
              element.countryName = element.geo.country.name;
            }
          }
          return element;
        });
      }
      this.similarHandle = item.handle;
      this.viewSimilarUsersDialog = true;
    },
    showReport: function showReport(influencer) {
      var _this7 = this;

      this.overlayLoading = true;
      __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].fetchLocalAudienceReport(influencer.id, null, influencer.handle, 'instagram').then(function (resp) {
        _this7.audienceDataReport = resp.data;

        _this7.viewAudienceDataDialog = true;
        _this7.overlayLoading = false;
      }).catch(function (err) {
        console.error(err);
        _this7.overlayLoading = false;
      });
    },
    searchByKeywords: function searchByKeywords() {
      var _this8 = this;

      if (!this.newKeyword || this.newKeyword === null) {
        return;
      }
      if (this.newKeyword.length < 2) {
        return;
      }
      setTimeout(function () {
        _this8.keywordLoading = true;
        __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].searchTopicKeyword(_this8.newKeyword).then(function (response) {
          if (response.data) {
            response.data.map(function (r) {
              var isItem = _this8.searchItems.find(function (s) {
                return s.value === r.value;
              });
              if (!isItem) {
                _this8.searchItems.push(r);
              }
            });
          }
          _this8.keywordLoading = false;
        }).catch(function (error) {
          console.log(error);
          _this8.$emit('result', { success: false });
          _this8.keywordLoading = false;
        });
      }, 500);
    },
    removeKeyword: function removeKeyword(item) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var kResp, topicKeywords;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!item.tag) {
                  _context4.next = 7;
                  break;
                }

                _this9.keyword = _this9.keyword.filter(function (k) {
                  return k !== item.tag;
                });
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].searchTopicKeyword(item.tag);

              case 4:
                kResp = _context4.sent;

                if (kResp.data) {
                  topicKeywords = kResp.data.map(function (r) {
                    return r.tag;
                  });

                  _this9.searchItems = _this9.searchItems.filter(function (s) {
                    return topicKeywords.includes(s.tag);
                  });
                }
                if (_this9.keyword.length) {
                  _this9.keyword.map(function (k) {
                    var isNotExist = _this9.searchItems.find(function (s) {
                      return s.tag !== k;
                    });
                    if (isNotExist) {
                      _this9.searchItems.push({
                        tag: k,
                        value: k
                      });
                    }
                  });
                }

              case 7:
                _this9.searchInf();

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    searchInfLookalike: function searchInfLookalike() {
      var _this10 = this;

      if (!this.newInfLookKeyword || this.newInfLookKeyword === null) {
        return;
      }
      if (this.newInfLookKeyword.length < 2) {
        return;
      }
      setTimeout(function () {
        _this10.lookLoading = true;
        __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].fetchLookalikeUsers(_this10.newInfLookKeyword).then(function (response) {
          if (response.data) {
            response.data.data.map(function (r) {
              var isItem = _this10.infLookItems.find(function (s) {
                return s === r.username;
              });
              if (!isItem) {
                _this10.infLookItems.push(r.username);
              }
            });
          }
          _this10.lookLoading = false;
        }).catch(function (error) {
          console.log(error);
          _this10.$emit('result', { success: false });
          _this10.lookLoading = false;
        });
      }, 500);
    },
    removeLookKeyword: function removeLookKeyword() {
      this.infLookKeyword = '';
    },
    searchAudLookalike: function searchAudLookalike() {
      var _this11 = this;

      if (!this.newAudLookKeyword || this.newAudLookKeyword === null) {
        return;
      }
      if (this.newAudLookKeyword.length < 2) {
        return;
      }
      setTimeout(function () {
        _this11.lookLoading = true;
        __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].fetchLookalikeUsers(_this11.newAudLookKeyword).then(function (response) {
          if (response.data) {
            response.data.data.map(function (r) {
              var isItem = _this11.audLookItems.find(function (s) {
                return s === r.username;
              });
              if (!isItem) {
                _this11.audLookItems.push(r.username);
              }
            });
          }
          _this11.lookLoading = false;
        }).catch(function (error) {
          console.log(error);
          _this11.$emit('result', { success: false });
          _this11.audLookLoading = false;
        });
      }, 500);
    },
    removeAudLookKeyword: function removeAudLookKeyword() {
      this.audLookKeyword = '';
    },

    getRandomColor: function getRandomColor() {
      return '#947ded';
    },
    saveSettings: function saveSettings(settings) {
      this.searchSettings = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], settings);
      this.refreshWordCloud();
      if (!this.searchSettings.relevantKeywords) {
        this.isLocal = false;
      }
    },
    refreshWordCloud: function refreshWordCloud() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var wordCount, keywords, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, keyword, resp, respTotal;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this12.wordCloudData = [];
                _this12.multipleKeywords = [];
                wordCount = 0;
                keywords = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], _this12.keyword);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 7;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keywords);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context5.next = 21;
                  break;
                }

                keyword = _step.value;
                _context5.next = 13;
                return __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].searchRelevantKeyword(keyword);

              case 13:
                resp = _context5.sent;

                if (_this12.keyword.length) {
                  _context5.next = 16;
                  break;
                }

                return _context5.abrupt('continue', 18);

              case 16:
                if (_this12.searchSettings.relevantKeywords > 0) {
                  respTotal = resp.data.length;

                  wordCount = Number((_this12.searchSettings.relevantKeywords / 100 * respTotal).toFixed(0));
                }
                if (resp.data) {
                  (function () {
                    var results = [];

                    __WEBPACK_IMPORTED_MODULE_16_lodash_sortBy___default()(resp.data, ['distance']);
                    resp.data.map(function (r, rIdx) {
                      results.push(r);

                      if (wordCount > 0 && rIdx < wordCount) {
                        var tagName = r.tag.replace('#', '');
                        if (!_this12.multipleKeywords.includes(tagName)) {
                          _this12.multipleKeywords.push(tagName);
                        }
                      }
                    });

                    results.map(function (r) {
                      var matchItem = _this12.wordCloudData.find(function (w) {
                        return w[0] === r.tag.replace('#', '');
                      });
                      if (!matchItem) {
                        _this12.wordCloudData.push([r.tag.replace('#', ''), Number(r.freq) * 100, 10, 'deg']);
                      }
                    });
                  })();
                }

              case 18:
                _iteratorNormalCompletion = true;
                _context5.next = 9;
                break;

              case 21:
                _context5.next = 27;
                break;

              case 23:
                _context5.prev = 23;
                _context5.t0 = _context5['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context5.t0;

              case 27:
                _context5.prev = 27;
                _context5.prev = 28;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 30:
                _context5.prev = 30;

                if (!_didIteratorError) {
                  _context5.next = 33;
                  break;
                }

                throw _iteratorError;

              case 33:
                return _context5.finish(30);

              case 34:
                return _context5.finish(27);

              case 35:
                _this12.searchInf();

              case 36:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this12, [[7, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    upperCasePlatform: function upperCasePlatform(p) {
      if (p === 'instagram') {
        return 'Instagram';
      } else if (p === 'tiktok') {
        return 'TikTok';
      } else if (p === 'youtube') {
        return 'Youtube';
      }
    },
    setRouteParams: function setRouteParams() {
      var routeParams = {
        platform: this.platformShort,
        topic: this.keyword.map(function (k) {
          return k;
        }).join(',')
      };
      if (this.searchSettings.relevantKeywords) {
        routeParams.relevantPercent = this.searchSettings.relevantKeywords;
      }
      if (this.searchSettings.influencerGeos.length) {
        routeParams.influencerGeos = this.searchSettings.influencerGeos.join(',');
      }
      if (this.searchSettings.audGeos.length) {
        routeParams.audGeos = this.searchSettings.audGeos.join(',');
      }
      if (this.searchSettings.infGender) {
        routeParams.infGender = this.searchSettings.infGender;
      }
      if (this.searchSettings.audGender) {
        routeParams.audGender = this.searchSettings.audGender;
      }
      if (this.searchSettings.bio) {
        routeParams.bio = this.searchSettings.bio;
      }
      if (this.searchSettings.keywords) {
        routeParams.keywords = this.searchSettings.keywords;
      }
      if (this.searchSettings.mentions) {
        routeParams.mentions = this.searchSettings.mentions;
      }
      if (this.searchSettings.hashtags) {
        routeParams.hashtags = this.searchSettings.hashtags;
      }
      if (this.searchSettings.followers) {
        if (this.searchSettings.followers.from || this.searchSettings.followers.to) {
          routeParams.followers = [this.searchSettings.followers.from, this.searchSettings.followers.to].join(',');
        }
      }
      if (this.searchSettings.engagements) {
        if (this.searchSettings.engagements.from || this.searchSettings.engagements.to) {
          routeParams.engagements = [this.searchSettings.engagements.from, this.searchSettings.engagements.to].join(',');
        }
      }
      if (this.searchSettings.engagementRate.from) {
        routeParams.engagementRate = this.searchSettings.engagementRate.from;
      }

      this.$router.replace({ query: routeParams });
    },
    setSettingsFromRouteParams: function setSettingsFromRouteParams() {
      var _this13 = this;

      if (this.$route.query.platform) {
        this.platform = this.upperCasePlatform(this.$route.query.platform);
      }
      if (this.$route.query.topic) {
        this.keyword = this.$route.query.topic.split(',');
        this.keyword.map(function (k) {
          _this13.searchItems.push({
            tag: k,
            value: k
          });
        });
      }
      if (this.$route.query.relevantPercent) {
        this.searchSettings.relevantKeywords = Number(this.$route.query.relevantPercent);
      }
      if (this.$route.query.influencerGeos) {
        this.searchSettings.influencerGeos = this.$route.query.influencerGeos.split(',');
      }
      if (this.$route.query.audGeos) {
        this.searchSettings.audGeos = this.$route.query.audGeos.split(',');
      }
      if (this.$route.query.infGender) {
        this.searchSettings.infGender = this.$route.query.infGender;
      }
      if (this.$route.query.audGender) {
        this.searchSettings.audGender = this.$route.query.audGender;
      }
      if (this.$route.query.followers) {
        var engRates = this.$route.query.followers.split(',');
        if (engRates.length > 1) {
          this.searchSettings.followers = {
            from: engRates[0],
            to: engRates[1]
          };
        }
      }
      if (this.$route.query.engagements) {
        var _engRates = this.$route.query.engagements.split(',');
        if (_engRates.length > 1) {
          this.searchSettings.engagements = {
            from: _engRates[0],
            to: _engRates[1]
          };
        }
      }
      if (this.$route.query.engagementRate) {
        this.searchSettings.engagementRate = {
          from: this.$route.query.engagementRate
        };
      }
      if (this.$route.query.bio) {
        this.searchSettings.bio = this.$route.query.bio;
      }
      if (this.$route.query.keywords) {
        this.searchSettings.keywords = this.$route.query.keywords;
      }
      if (this.$route.query.mentions) {
        this.searchSettings.mentions = this.$route.query.mentions;
      }
      if (this.$route.query.hashtags) {
        this.searchSettings.hashtags = this.$route.query.hashtags;
      }
    },
    refreshReport: function refreshReport(item) {
      var _this14 = this;

      this.overlayLoading = true;
      var reportId = item.reportID;
      __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].refreshAudienceReport(reportId).then(function (data) {
        _this14.overlayLoading = false;
        _this14.paginate(_this14.currentPage);
      }).catch(function (err) {
        console.error(err);
        _this14.overlayLoading = false;
        _this14.$swal({
          title: 'Warning',
          text: 'We are updating data. Please try again in a few minutes',
          type: 'info'
        });
      });
    },
    setProfilePics: function setProfilePics(picUrl) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 3;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this15.items);

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 19;
                  break;
                }

                item = _step2.value;
                _context6.prev = 7;
                _context6.next = 10;
                return fetch(item.profilePicture);

              case 10:
                _context6.next = 16;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](7);

                item.profilePicture = '/static/img/avatar/user.png';
                console.error(_context6.t0);

              case 16:
                _iteratorNormalCompletion2 = true;
                _context6.next = 5;
                break;

              case 19:
                _context6.next = 25;
                break;

              case 21:
                _context6.prev = 21;
                _context6.t1 = _context6['catch'](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t1;

              case 25:
                _context6.prev = 25;
                _context6.prev = 26;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 28:
                _context6.prev = 28;

                if (!_didIteratorError2) {
                  _context6.next = 31;
                  break;
                }

                throw _iteratorError2;

              case 31:
                return _context6.finish(28);

              case 32:
                return _context6.finish(25);

              case 33:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this15, [[3, 21, 25, 33], [7, 12], [26,, 28, 32]]);
      }))();
    },
    openSettingsDialog: function openSettingsDialog() {
      this.dialog = true;
    },
    checkRemainInf: function checkRemainInf() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var remainInf;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                remainInf = 500 - Number(_this16.iqDataTotal);

                if (!(remainInf <= 0)) {
                  _context7.next = 4;
                  break;
                }

                _this16.$swal({
                  title: 'Limit Reached',
                  text: 'IQData (30) Influencers Limit Reached',
                  type: 'warning'
                });
                return _context7.abrupt('return', false);

              case 4:
                return _context7.abrupt('return', true);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this16);
      }))();
    },
    changeIQDataSwitch: function changeIQDataSwitch() {
      if (this.isLocal) {
        this.isIqData = false;
        this.localPaginate();
      }
    },
    searchNextInf: function searchNextInf() {
      var newPage = this.currentPage + 1;
      this.isIqData = true;
      this.paginate(newPage);
    },
    changeNext: function changeNext() {
      this.$v.$touch();
      if (this.$v.searchSettings.$error) {
        return false;
      }

      this.step = 2;
    },
    exportExcel: function exportExcel() {
      var _this17 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this17.iqDataItems.length > 100)) {
                  _context8.next = 3;
                  break;
                }

                _this17.$swal({
                  text: 'Export Data cannot be more than 100 records!',
                  type: 'warning'
                });
                return _context8.abrupt('return');

              case 3:
                _this17.overlayLoading = true;
                __WEBPACK_IMPORTED_MODULE_9__influencerAPIs__["a" /* default */].downloadAudDataKeyword(_this17.payload(page), _this17.iqDataItems.length).then(function () {
                  _this17.overlayLoading = false;
                }).catch(function (error) {
                  _this17.overlayLoading = false;
                  console.log('error in downloading keyword search report', error);
                });

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this17);
      }))();
    }
  },
  created: function created() {
    this.countries = __WEBPACK_IMPORTED_MODULE_18__static_sources_countries___default.a;
    this.countries = this.countries.map(function (c) {
      return c.name;
    });
    this.setSettingsFromRouteParams();
  }
});

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MedianEngagementsModal',
  props: ['items', 'value', 'handle', 'engagementRate', 'followersRange'],
  data: function data() {
    return {
      headers: [{
        text: 'Engagements rate range',
        value: 'rate'
      }, {
        text: 'Influencers',
        value: 'total'
      }],
      items: [],
      dataTableKey: 1
    };
  },

  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__searchConfig__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__AudienceDataReportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CampaignListsModal__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CampaignListsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__CampaignListsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MedianEngagementsModal__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MedianEngagementsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__MedianEngagementsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AddInfluencerPairingModal__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AddInfluencerPairingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__AddInfluencerPairingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Campaign_AllCampaignsReport_AllReportsPasscodeModal__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Campaign_AllCampaignsReport_AllReportsPasscodeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Campaign_AllCampaignsReport_AllReportsPasscodeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_uniq__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__iqdata_interests_response_json__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__iqdata_interests_response_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__iqdata_interests_response_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chartjs_Pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chartjs_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_chartjs_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__charts_BarChart_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__RateCard_Preview_vue__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__RateCard_Preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__RateCard_Preview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__static_sources_countries__);





































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'influencer',
  components: {
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_18__AudienceDataReportModal___default.a,
    CampaignListsModal: __WEBPACK_IMPORTED_MODULE_19__CampaignListsModal___default.a,
    MedianEngagementsModal: __WEBPACK_IMPORTED_MODULE_20__MedianEngagementsModal___default.a,
    AddInfluencerPairingModal: __WEBPACK_IMPORTED_MODULE_21__AddInfluencerPairingModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_23__components_scoped_custom_TableColsShowHideModal___default.a,
    AllReportsPasscodeModal: __WEBPACK_IMPORTED_MODULE_22__Campaign_AllCampaignsReport_AllReportsPasscodeModal___default.a,
    RateCardPreview: __WEBPACK_IMPORTED_MODULE_30__RateCard_Preview_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_26_vue_loading_overlay___default.a,
    PieChart: __WEBPACK_IMPORTED_MODULE_28__components_chartjs_Pie___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_29__charts_BarChart_js__["a" /* default */]
  },
  data: function data() {
    return {
      audienceDataReport: null,
      allReportsPasscodeDialog: false,
      downloadReportType: null,
      barChartOptions: {
        barPercentage: 0.1,
        maxBarThickness: 'flex',
        categoryPercentage: 0.5,
        borderWidth: 0,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: false
            }
          }]
        }
      },
      sortBy: 'name',
      influencerGeos: 'Singapore',
      audGeos: [],
      audGeoPercent: '',
      audInterestPercent: '',
      search: null,
      expand: false,
      shouldCallApi: false,
      loading: false,
      isLoading: false,
      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: ['audienceCredibility'],
        itemsPerPage: 15
      },
      totalItems: 0,
      rowsPerPageItems: [15, 30, 60, 100],
      postsTitle: '',
      avatarSize: 40,
      countries: [],
      shortCodes: [],
      sortDesc: false,
      platforms: ['Instagram', 'Facebook'],
      selectedPlatform: 'instagram',
      openExpansion: [],
      inputRates: {},
      rateCardFormRates: {},
      searchFilter: __WEBPACK_IMPORTED_MODULE_14__searchConfig__["a" /* default */].searchFilters(),
      genderPie: {
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center'
          }
        },
        width: 30,
        height: 30
      },
      audienceInterestLists: __WEBPACK_IMPORTED_MODULE_27__iqdata_interests_response_json___default.a.data.interests,
      platformList: [{
        text: 'Instagram',
        value: 'instagram'
      }, {
        text: 'TikTok',
        value: 'tiktok'
      }, {
        text: 'Youtube',
        value: 'youtube'
      }],
      fields: [{
        value: 'profilePicture',
        text: 'Avatar',
        sortable: false,
        profilePicture: true
      }, {
        value: 'instagramHandle',
        text: 'Handle',
        sortable: false,
        instagramHandle: true
      }, {
        value: 'campaigns',
        text: 'Campaigns',
        sortable: false,
        campaigns: true
      }, {
        value: 'totalFollowers',
        text: 'Followers',
        totalFollowers: true
      }, {
        value: 'engagementRate',
        text: 'Eng. Rate',
        sortable: false,
        engagementRate: true
      }, {
        value: 'audienceCredibility',
        text: 'Aud. Credibility',
        sortable: false,
        audienceCredibility: true
      }, {
        value: 'gender',
        text: 'Gender',
        sortable: false,
        gender: true
      }, {
        value: 'genderPercentage',
        text: 'Aud. Gender',
        sortable: false,
        genderPercentage: true
      }, {
        value: 'ageGroup',
        text: 'Aud. Age Group',
        sortable: false,
        ageGroup: true
      }, {
        value: 'creatorAgeGroup',
        text: 'Age Group',
        sortable: false,
        creatorAgeGroup: true
      }, {
        value: 'country',
        text: 'Aud. Country',
        sortable: false,
        country: false
      }, {
        value: 'paidPstPerformance',
        text: 'Paid Post Performance',
        sortable: false,
        engagementRate: true
      }, {
        value: 'rateCard',
        text: 'Rate Card',
        sortable: false,
        rateCard: false
      }, {
        text: 'Influencer interests',
        sortable: false,
        value: 'infInterests',
        name: 'infInterests',
        infInterests: false
      }, {
        text: 'Audience interests',
        sortable: false,
        value: 'audienceInterests',
        name: 'audienceInterests',
        audienceInterests: false
      }, {
        text: 'Median Engagement',
        sortable: false,
        value: 'medianEngagements',
        name: 'medianEngagements',
        medianEngagements: false
      }, {
        text: 'Avg Views',
        sortable: true,
        value: 'avgViews',
        avgViews: false
      }, {
        text: 'Avg Likes',
        sortable: true,
        value: 'avgLikes',
        avgLikes: false
      }, {
        text: 'Avg Comments',
        sortable: true,
        value: 'avgComments',
        avgComments: false
      }, {
        text: 'Avg Reel Plays',
        sortable: true,
        value: 'avgReelPlays',
        avgReelPlays: false
      }, {
        value: 'action',
        text: 'Actions',
        action: true
      }],

      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      dialog: false,
      items: [],
      users: [],
      pairings: [],
      filterCampaigns: [],
      viewCampaigns: [],
      viewMedianEngs: [],
      viewHandle: '',
      viewEngRate: '',
      viewFollowersRange: {},
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      keyword: '',
      fromAge: '',
      toAge: '',
      fromFol: '',
      toFol: '',
      fromEng: '',
      toEng: '',
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      selectedLists: [],
      searchFilterLists: [],
      selectedCountries: ['all'],
      audCredibilities: ['#4caf50', '#f9a825', '#f44336'],
      colSettingsDialog: false,
      colStatuses: {},
      userProfile: {},
      resultMessage: '',
      monthPicker: false,
      showLoading: false,
      importLoading: false,
      viewCampaignListsDialog: false,
      viewMedianEngDialog: false,
      addInfluencerPairingDialog: false,
      audienceFollowersGenderPerAge: null,
      searchConfig: __WEBPACK_IMPORTED_MODULE_14__searchConfig__["a" /* default */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    rateCards: function rateCards(state) {
      return state.influencer.rateCards;
    },
    deletedAud: function deletedAud(state) {
      return state.influencer.deletedAud;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isAdminRole: function isAdminRole() {
      var role = Number(this.$store.state.user.role);
      return role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH;
    },
    isSuperAdminRole: function isSuperAdminRole() {
      var role = Number(this.$store.state.user.role);
      return role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || role === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.lastUpdate).fromNow();
    },
    createModalIdDisplay: function createModalIdDisplay() {
      return '#' + this.createModalId;
    },
    editModalIdDisplay: function editModalIdDisplay() {
      return '#' + this.editModalId;
    },
    viewCompanyModalIdDisplay: function viewCompanyModalIdDisplay() {
      return '#' + this.viewCompanyModalId;
    },
    influencerPostDisplay: function influencerPostDisplay() {
      return '#' + this.influencerPostModalId;
    },
    availableCountries: function availableCountries() {
      return __WEBPACK_IMPORTED_MODULE_25_lodash_uniq___default()(this.searchedItems.map(function (item) {
        return item.country;
      }));
    },
    payload: function payload() {
      var infInterest = this.searchFilter.infInterest;
      return {
        filter: {
          geo: this.influencerGeos,
          audience_geo: this.audGeos,
          audienceGeoPercent: this.audGeoPercent,
          audInterestPercent: this.audInterestPercent,
          igHandle: this.igHandle,
          platform: this.selectedPlatform,
          gender: this.searchFilter.gender,
          campaign: this.searchFilter.campaign,
          followers: this.searchFilter.followers,
          ageGroup: this.searchFilter.ageGroup,
          ageGroupPercent: this.searchFilter.ageGroupPercent,
          secAgeGroup: this.searchFilter.secAgeGroup,
          secAgeGroupPercent: this.searchFilter.secAgeGroupPercent,
          limit: this.searchFilter.limit,

          credibility: this.searchFilter.credibility,
          engagements: this.searchFilter.engagements,
          engagementRate: this.searchFilter.engagementRate,
          paidPstPerformance: this.searchFilter.paidPstPerformance,
          isIMS: this.searchFilter.isIMS,
          audience_interests: this.searchFilter.audienceInterest,
          inf_interests: infInterest,
          campaignType: this.searchFilter.campaignType
        },
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    },
    computedHeaders: function computedHeaders() {
      var _this = this;

      var allInfsCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.allInfsCols) {
          allInfsCols = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.allInfsCols);
        }
      }
      if (allInfsCols) {
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, allInfsCols);
      } else {
        this.fields.map(function (header) {
          _this.colStatuses[header.value] = header[header.value];
        });
      }
      return this.fields.filter(function (h) {
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    getFilterLists: function getFilterLists() {
      var type = '';
      type = 'mainCountry';
      if (this.influencerGeos) {
        if (this.influencerGeos.length) {
          var retData = {
            type: type,
            title: 'Country',
            icon: 'mdi-account',
            value: this.influencerGeos
          };
          this.setFilterItem(type, retData);
        } else {
          this.removeItemFromFilterList(type);
        }
      } else {
        this.removeItemFromFilterList(type);
      }

      type = 'gender';
      var genderRet = this.genderFilter;
      if (genderRet) {
        var _retData = {
          type: type,
          title: 'Gender',
          icon: 'mdi-account',
          value: genderRet
        };
        this.setFilterItem(type, _retData);
      } else {
        this.removeItemFromFilterList(type);
      }

      type = 'isIMS';
      var isIMS = this.imsFilter;
      if (isIMS) {
        var _retData2 = {
          type: type,
          title: 'IMS Status',
          icon: 'mdi-account',
          value: isIMS
        };
        this.setFilterItem(type, _retData2);
      } else {
        this.removeItemFromFilterList(type);
      }

      var campaign = this.campaignFilter;
      type = 'campaign';
      if (this.campaignFilter) {
        var _retData3 = {
          type: type,
          title: 'Campaign',
          icon: 'mdi-bullhorn',
          value: campaign
        };
        this.setFilterItem(type, _retData3);
      } else {
        this.removeItemFromFilterList(type);
      }

      var audCred = this.audCredibilityFilter;
      type = 'audCredibility';
      if (audCred) {
        var _retData4 = {
          type: type,
          title: 'Aud. Credibility',
          icon: 'mdi-account-multiple',
          htmlValue: audCred
        };
        this.setFilterItem(type, _retData4);
      } else {
        this.removeItemFromFilterList(type);
      }

      var audGeo = this.countryFilter;
      type = 'audGeo';
      if (audGeo) {
        var _retData5 = {
          type: type,
          title: 'Aud. Country',
          icon: 'mdi-account-multiple',
          value: audGeo
        };
        this.setFilterItem(type, _retData5);
      } else {
        this.removeItemFromFilterList(type);
      }

      var followerRet = this.followerFilter;
      type = 'followers';
      if (followerRet) {
        var _retData6 = {
          type: type,
          title: 'Followers',
          icon: 'mdi-account-multiple',
          value: followerRet
        };
        this.setFilterItem(type, _retData6);
      } else {
        this.removeItemFromFilterList(type);
      }

      var ageGroupRet = this.ageGroupFilter;
      type = 'ageGroup';
      if (ageGroupRet) {
        var _retData7 = {
          type: type,
          title: 'Age Group',
          icon: 'mdi-account-multiple',
          value: ageGroupRet
        };
        this.setFilterItem(type, _retData7);
      } else {
        this.removeItemFromFilterList(type);
      }

      var infInterestsRet = this.infInterestsFilter;
      type = 'infInterests';
      if (infInterestsRet) {
        var _retData8 = {
          type: type,
          title: 'Influencer Interests',
          icon: 'mdi-account',
          value: infInterestsRet
        };
        this.setFilterItem(type, _retData8);
      } else {
        this.removeItemFromFilterList(type);
      }

      var audInterestsRet = this.audInterestsFilter;
      type = 'audInterests';
      if (audInterestsRet) {
        var _retData9 = {
          type: type,
          title: 'Aud. Interests',
          icon: 'mdi-account-multiple',
          value: audInterestsRet
        };
        this.setFilterItem(type, _retData9);
      } else {
        this.removeItemFromFilterList(type);
      }

      var engRateRet = this.engRateFilter;
      type = 'engRate';
      if (engRateRet) {
        var _retData10 = {
          type: type,
          title: 'Eng. Rate',
          icon: 'mdi-bullhorn',
          value: engRateRet
        };
        this.setFilterItem(type, _retData10);
      } else {
        this.removeItemFromFilterList(type);
      }

      var paidPstRet = this.paidPstFilter;
      type = 'paidPstRet';
      if (paidPstRet) {
        var _retData11 = {
          type: type,
          title: 'Paid Post Performance',
          icon: 'mdi-bullhorn',
          value: paidPstRet
        };
        this.setFilterItem(type, _retData11);
      } else {
        this.removeItemFromFilterList(type);
      }
      return this.searchFilterLists;
    },
    mainCountryFilter: function mainCountryFilter() {
      var ret = '';
      if (this.influencerGeos) {
        if (this.influencerGeos.length) {
          ret = this.influencerGeos;
        }
      }
      return ret;
    },
    genderFilter: function genderFilter() {
      var ret = '';
      if (this.searchFilter.gender) {
        ret = this.searchFilter.gender;
      }
      return ret;
    },
    imsFilter: function imsFilter() {
      var _this2 = this;

      var ret = '';
      if (this.searchFilter.isIMS) {
        var matchOption = this.searchConfig.imsOptions.find(function (p) {
          return p.value === _this2.searchFilter.isIMS;
        });
        if (matchOption) {
          ret = matchOption.text;
        }
      }
      return ret;
    },
    countryFilter: function countryFilter() {
      var ret = '';
      if (this.audGeos.length) {
        ret += this.audGeos.join(',') + ' ';
      }
      if (this.audGeoPercent) {
        ret += this.audGeoPercent;
      }
      return ret;
    },
    followerFilter: function followerFilter() {
      var ret = '';
      if (this.searchFilter.followers.from || this.searchFilter.followers.to) {
        ret += 'Followers ';
      }
      if (this.searchFilter.followers.from && this.searchFilter.followers.to) {
        ret += this.searchFilter.followers.from + '-' + this.searchFilter.followers.to;
      } else if (this.searchFilter.followers.from) {
        ret += this.searchFilter.followers.from + '+';
      } else if (this.searchFilter.followers.to) {
        ret += 'Up to ' + this.searchFilter.followers.to;
      }
      return ret;
    },
    ageGroupFilter: function ageGroupFilter() {
      var ret = '';
      if (this.searchFilter.ageGroup) {
        ret += this.searchFilter.ageGroup + ' ';
      }
      if (this.searchFilter.ageGroupPercent) {
        ret += '(' + this.searchFilter.ageGroupPercent + ') ';
      }
      if ((this.searchFilter.ageGroup || this.searchFilter.ageGroupPercent) && (this.searchFilter.secAgeGroup || this.searchFilter.secAgeGroupPercent)) {
        ret += ', ';
      }
      if (this.searchFilter.secAgeGroup) {
        ret += this.searchFilter.secAgeGroup + ' ';
      }
      if (this.searchFilter.secAgeGroupPercent) {
        ret += '(' + this.searchFilter.secAgeGroupPercent + ')';
      }
      return ret;
    },
    infInterestsFilter: function infInterestsFilter() {
      var _this3 = this;

      var ret = '';
      if (this.searchFilter.infInterest) {
        var matchInterests = this.audienceInterestLists.filter(function (ai) {
          return _this3.searchFilter.infInterest.includes(ai.id);
        });
        if (matchInterests) {
          ret += matchInterests.map(function (i) {
            return i.name;
          }).join(',');
        }
      }
      return ret;
    },
    audInterestsFilter: function audInterestsFilter() {
      var ret = '';
      if (this.searchFilter.audienceInterest) {
        ret += this.searchFilter.audienceInterest.join(',');
      }
      if (this.audInterestPercent) {
        ret += ' ' + this.audInterestPercent + ' ';
      }
      return ret;
    },
    engRateFilter: function engRateFilter() {
      var ret = '';
      if (this.searchFilter.engagementRate.to) {
        ret += 'Eng. Rate Up to ' + this.searchFilter.engagementRate.to + '%';
      }
      return ret;
    },
    paidPstFilter: function paidPstFilter() {
      var ret = '';
      if (this.searchFilter.paidPstPerformance.from || this.searchFilter.paidPstPerformance.to) {
        ret += 'Paid Pst. Performance ';
      }
      if (this.searchFilter.paidPstPerformance.from && this.searchFilter.paidPstPerformance.to) {
        ret += this.searchFilter.paidPstPerformance.from + '%-' + this.searchFilter.paidPstPerformance.to + '%';
      } else if (this.searchFilter.paidPstPerformance.from) {
        ret += this.searchFilter.paidPstPerformance.from + '%+';
      } else if (this.searchFilter.paidPstPerformance.to) {
        ret += 'Up to ' + this.searchFilter.paidPstPerformance.to + '%';
      }
      return ret;
    },
    campaignFilter: function campaignFilter() {
      var _this4 = this;

      var ret = '';
      if (this.searchFilter.campaign) {
        var matchCampaign = this.filterCampaigns.find(function (f) {
          return f.id === _this4.searchFilter.campaign;
        });
        if (matchCampaign) {
          ret += matchCampaign.name;
        }
      }
      return ret;
    },
    audCredibilityFilter: function audCredibilityFilter() {
      var ret = '';
      if (this.searchFilter.credibility) {
        ret += '<div\n                style="width: 50px;\n                height: 10px;\n                background: ' + this.searchFilter.credibility + ';\n                border-radius: 5px;"\n              ></div>';
      }
      return ret;
    },
    showFilters: function showFilters() {
      return this.getFilterLists.length > 0;
    }
  }),
  watch: {
    pagination: function pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    }
  },
  methods: {
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */]['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    getCountries: function getCountries() {
      this.countries = __WEBPACK_IMPORTED_MODULE_32__static_sources_countries___default.a;
      this.countries = this.countries.map(function (c) {
        return c.name;
      });
    },
    updateItems: function updateItems(response) {
      var _this5 = this;

      var displayItems = response.influencers.map(function (element) {
        var country = _this5.getCountryName(element);
        var audienceCredibility = _this5.selectedPlatform === 'instagram' ? element.audience_followers && element.audience_followers.success ? Number(element.audience_followers.data.audience_credibility * 100).toFixed(2) : 0 : '-';
        var audienceData = element.audience_followers.data;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({ id: element._id || element.id }, {
          reportID: element.report_info.report_id,
          instagramHandle: element.user_profile ? element.user_profile.username : null,
          fullName: element.user_profile ? element.user_profile.fullname : null,
          url: element.user_profile ? element.user_profile.url : null,
          platform: _this5.selectedPlatform,
          isIMS: element.isIMS || null,
          importedCreator: element.importedCreator || null,
          influencerID: element.influencerID || null,
          instagramID: element.user_profile ? element.user_profile.user_id : null,
          instagramFullname: element.user_profile ? element.user_profile.username : null,
          totalFollowers: element.user_profile ? element.user_profile.followers : 0,
          profilePicture: element.user_profile ? element.user_profile.picture : '/static/img/avatar/user.png',
          engagements: element.user_profile ? (Number(element.user_profile.engagements) * 100).toFixed(2) : 0,
          engagementRate: element.user_profile ? (Number(element.user_profile.engagement_rate) * 100).toFixed(2) : 0,
          paidPstPerformance: element.user_profile ? element.user_profile.paid_post_performance ? (Number(element.user_profile.paid_post_performance) * 100).toFixed(2) : '-' : 0,
          gender: element.user_profile.gender,
          audienceCredibility: audienceCredibility,
          audienceCredibilityColor: __WEBPACK_IMPORTED_MODULE_24__utils__["a" /* default */].func.getCredibilityColor(audienceCredibility),
          audienceInterests: audienceData.audience_interests ? audienceData.audience_interests : null,
          infInterests: element.user_profile ? element.user_profile.interests : null,
          audienceGenders: audienceData.audience_genders ? audienceData.audience_genders : [],
          audienceGendersPerAge: audienceData.audience_genders_per_age ? audienceData.audience_genders_per_age : [],
          audienceAges: audienceData.audience_ages ? audienceData.audience_ages : [],
          ageGroup: element.user_profile.age_group,
          country: country !== null ? country[0].name : country,
          countries: audienceData.audience_geo ? audienceData.audience_geo.countries : [],
          avgViews: element.user_profile.avg_views || 0,
          avgLikes: element.user_profile.avg_likes || 0,
          avgComments: element.user_profile.avg_comments || 0,
          avgReelPlays: element.user_profile.avg_reels_plays || 0,
          followersRange: element.extra ? element.extra.followers_range || {} : {},
          medianEngagements: element.extra ? element.extra.engagement_rate_histogram || [] : [],
          ageGroupChart: {
            labels: [],
            datasets: []
          }
        });
      });
      this.items = displayItems;
      this.items = this.items.map(function (item) {
        item.medianEngagements = _this5.calculateMedians(item.medianEngagements, item.engagementRate, item.instagramHandle);
        item.influencerIndex = item.medianEngagements.findIndex(function (i) {
          return i.handle;
        });
        item.medianIndex = item.medianEngagements.findIndex(function (i) {
          return i.median;
        });
        item.ageGroupDisplay = _this5.createChartDataAudienceGendersPerAge(item);
        return item;
      });
      this.getTopFiveAudienceInterests(this.items);
      this.totalRows = response.totalInfluencers;

      this.searchedItems = displayItems;
    },
    getCountryName: function getCountryName(element) {
      var country = '';
      var audienceData = element.audience_followers.data;
      var countries = audienceData.audience_geo ? audienceData.audience_geo.countries : null;

      if (countries !== null) {
        if (countries.length > 0) {
          country = countries.filter(function (item) {
            return item.weight === Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(countries.map(function (w) {
              return w.weight;
            })).concat([0]));
          });
        } else {
          country = null;
        }
      } else {
        country = null;
      }
      return country;
    },
    paginate: function paginate() {
      var _this6 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      this.payload.paging.page = page;
      this.importLoading = true;
      __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__["a" /* default */].localAllAudienceData(this.payload).then(function (response) {
        _this6.updateItems(response);

        _this6.resultMessage = 'Showing [' + _this6.perPage + '] per page of total [' + _this6.totalRows + '] influencers result.';
        _this6.totalItems = _this6.totalRows;
        if (_this6.pagination.itemsPerPage === -1) {
          _this6.pagination.itemsPerPage = 20;
        }
        _this6.shouldCallApi = true;
        _this6.importLoading = false;
        _this6.selectedLists = [];
        _this6.setCampaignTypes();
      }).catch(function (error) {
        _this6.importLoading = false;
        console.log(error);
      });
    },
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return '';
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    showReport: function showReport(influencer) {
      var _this7 = this;

      this.importLoading = true;
      __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__["a" /* default */].fetchLocalAudienceReport(influencer.id, influencer.instagramID, influencer.instagramHandle, this.selectedPlatform).then(function (resp) {
        _this7.audienceDataReport = resp.data;
        _this7.viewAudienceDataDialog = true;
        _this7.importLoading = false;
      }).catch(function (err) {
        console.error(err);
      });
    },
    editInfluencer: function editInfluencer(influencerData) {
      var selectedIndex = -1;

      this.items.forEach(function (influencer, index) {
        if (influencer.id === influencerData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, influencerData);
      }

      console.log('influencer edited');
      this.getUsers();
    },
    exportInfluencers: function exportInfluencers() {
      var _this8 = this;

      this.showLoading = true;
      __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__["a" /* default */].exportNonIMSInfluencersByFilter(this.payload).then(function (response) {
        _this8.showLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this8.showLoading = false;
      });
    },
    filterItems: function filterItems() {
      var minAge = !this.fromAge ? 0 : this.fromAge;
      var maxAge = !this.toAge ? 150 : this.toAge;
      var minFol = !this.fromFol ? 0 : this.fromFol;
      var maxFol = !this.toFol ? 1000000000 : this.toFol;
      var minEng = !this.fromEng ? 0 : this.fromEng;
      var maxEng = !this.toEng ? 100 : this.toEng;
      var gender = this.filGender === 2 ? 'both' : this.filGender;
      var handle = this.igHandle;
      var countries = this.selectedCountries;

      var filteredItems = [];
      this.searchedItems.forEach(function (item, index) {
        var today = __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY');
        var bd = __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.birthday).format('YYYY');
        var age = today - bd;

        var countryStatus = false;
        countries.map(function (cnty) {
          if (cnty === item.country || cnty === 'all') {
            countryStatus = true;
          }
        });

        if (minAge <= age && maxAge >= age && minFol <= item.totalFollowers && maxFol >= item.totalFollowers && minEng <= item.engagementRate && maxEng >= item.engagementRate && (gender === item.gender || gender === 'both') && countryStatus && item.instagramHandle && (item.instagramHandle.includes(handle) || handle === '')) {
          filteredItems.push(item);
        }
      });

      this.items = filteredItems;
      this.resultMessage = 'Showing (Filtered Influencers) based on your searched results.';
    },
    igHandleBulkUpload: function igHandleBulkUpload(e) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var uploadedFiles, handles, handleItems, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, items, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, record, preferredCampaigns;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context.next = 4;
                  break;
                }

                _this9.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var fr = new FileReader();
                  fr.onload = function (e) {
                    var tmp = __WEBPACK_IMPORTED_MODULE_24__utils__["a" /* default */].func.parserToJson(e.target.result);
                    resolve(tmp);
                  };
                  fr.readAsArrayBuffer(e.target.files[0]);
                  fr.onerror = reject;
                });

              case 6:
                handles = _context.sent;
                handleItems = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 11;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(handles);

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 37;
                  break;
                }

                items = _step.value;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 18;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  record = _step2.value;

                  if (record.Instagram || record.TikTok || record.Youtube) {
                    preferredCampaigns = [];

                    if (record['Preferred Campaigns']) {
                      preferredCampaigns = record['Preferred Campaigns'].split(',');
                    }
                    preferredCampaigns = preferredCampaigns.map(function (p) {
                      return p.trim();
                    });
                    handleItems.push({
                      instagram: record['Instagram'],
                      tiktok: record['TikTok'],
                      youtube: record['Youtube'],
                      name: record['Name'],
                      followers: record['Followers'],
                      gender: record['Gender'],
                      country: record.Country.trim(),
                      type: record['Type'].trim().toLowerCase(),
                      agencyName: record['Agency Name'] || '',
                      preferredCampaigns: preferredCampaigns,
                      aboutYou: record['About You'] || '',
                      story: record['story'] || '',
                      post: record['post'] || '',
                      tiktokCount: record['Tiktok'] || '',
                      carousel: record['carousel'] || '',
                      sixtyReel: record['60s Reel'] || '',
                      oneEightyReel: record['180s Reel'] || '',
                      livestreamIntegration: record['Livestream integration'] || '',
                      livestreamEpisode: record['livestream episode buy'] || '',
                      dedicatedVideo: record['dedicated video post 5-10 minutes'] || '',
                      youtubeIntegration: record['youtube video integration'] || '',
                      youtubeEpisode: record['youtube episode buy'] || '',
                      genre: record['Genre'] || '',
                      loadingFee: record['Loading Fee'] || '',
                      eventAppearance: record['Event Apperance'] || '',
                      digitalUsage: record['Digital Usage Rights'] || '',
                      photoShoot: record['Photo Shoot'] || ''
                    });
                  }
                }
                _context.next = 26;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context['catch'](18);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t0;

              case 26:
                _context.prev = 26;
                _context.prev = 27;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 29:
                _context.prev = 29;

                if (!_didIteratorError2) {
                  _context.next = 32;
                  break;
                }

                throw _iteratorError2;

              case 32:
                return _context.finish(29);

              case 33:
                return _context.finish(26);

              case 34:
                _iteratorNormalCompletion = true;
                _context.next = 13;
                break;

              case 37:
                _context.next = 43;
                break;

              case 39:
                _context.prev = 39;
                _context.t1 = _context['catch'](11);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 43:
                _context.prev = 43;
                _context.prev = 44;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 46:
                _context.prev = 46;

                if (!_didIteratorError) {
                  _context.next = 49;
                  break;
                }

                throw _iteratorError;

              case 49:
                return _context.finish(46);

              case 50:
                return _context.finish(43);

              case 51:
                _this9.uploadBulkHandle(handleItems);

              case 52:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9, [[11, 39, 43, 51], [18, 22, 26, 34], [27,, 29, 33], [44,, 46, 50]]);
      }))();
    },
    uploadBulkHandle: function uploadBulkHandle(handleItems) {
      var _this10 = this;

      this.importLoading = true;
      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Influencer Handle Found'
        });
        return;
      }

      var data = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, {
        handleItems: handleItems
      });
      __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__["a" /* default */].importInfluencers(data).then(function (resp) {
        _this10.importLoading = false;

        _this10.$swal({
          title: 'Success',
          icon: 'info',
          text: 'Successfully Imported.'
        });
        _this10.paginate(_this10.currentPage);
      }).catch(function (err) {
        _this10.importLoading = false;
        console.error(err);
        _this10.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Failed to Import Influencers'
        });
      });
      this.$refs.igBulkHandle.value = null;
    },
    showFailedImportAlert: function showFailedImportAlert(failedInfluencers) {
      if (failedInfluencers.length > 0) {
        var displayBlock = '';
        failedInfluencers.map(function (a) {
          displayBlock += '<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">\n            <span class="v-chip__content">' + a.handle + '</span>\n          </span>';
        });
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Influencers failed to import: <div>' + displayBlock + '</div>'
        });
      }
      return;
    },
    resetFilters: function resetFilters() {
      this.fromAge = '';
      this.toAge = '';
      this.fromFol = '';
      this.toFol = '';
      this.fromEng = '';
      this.toEng = '';
      this.filGender = 'Any';
      this.igHandle = '';
      this.influencerGeos = [];
      this.audGeos = [];
      this.audGeoPercent = '';
      this.audInterestPercent = '';
      this.searchFilter = __WEBPACK_IMPORTED_MODULE_14__searchConfig__["a" /* default */].searchFilters();
      this.paginate(this.currentPage);
    },
    reloadAll: function reloadAll() {
      this.currentPage = 1;
      this.perPage = 15;
      this.keyword = '';
      this.igHandle = '';
      this.joinedMonth = '';
      this.resetFilters();
    },
    remove: function remove(item) {
      this.influencerGeos.splice(this.influencerGeos.indexOf(item), 1);
      this.influencerGeos = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.influencerGeos));
    },
    removeAudGeos: function removeAudGeos(item) {
      this.audGeos.splice(this.audGeos.indexOf(item), 1);
      this.audGeos = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.audGeos));
    },
    removeInfInterest: function removeInfInterest(item) {
      this.searchFilter.infInterest.splice(this.searchFilter.infInterest.indexOf(item), 1);
      this.searchFilter.infInterest = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.searchFilter.infInterest));
    },
    removeAudInterest: function removeAudInterest(item) {
      this.searchFilter.audienceInterest.splice(this.searchFilter.audienceInterest.indexOf(item), 1);
      this.searchFilter.audienceInterest = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.searchFilter.audienceInterest));
    },
    joinedMonthOk: function joinedMonthOk() {
      this.$refs.monthPicker.save(this.joinedMonth);
      this.paginate(this.currentPage);
    },
    getUsers: function getUsers() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER);

              case 2:
                response = _context2.sent;

                if (response) {
                  _this11.users = response.users;
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this11);
      }))();
    },
    formatDateTime: function formatDateTime(value) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).format('MMM DD, YYYY hh:mm:ss');
    },
    getTopFiveAudienceInterests: function getTopFiveAudienceInterests(items) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          if (item.audienceInterests) {
            item.audienceInterests = item.audienceInterests.sort(function (a, b) {
              return b.weight - a.weight;
            }).slice(0, 5);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    getGenderPieData: function getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        var ret = [];
        var male = audienceGenders.find(function (a) {
          return a.code === 'MALE';
        });
        if (male) ret.push(male);
        var female = audienceGenders.find(function (a) {
          return a.code === 'FEMALE';
        });
        if (female) ret.push(female);
        return ret.map(function (gender) {
          return (gender.weight * 100).toFixed(2);
        });
      }
    },
    setCampaignTypes: function setCampaignTypes() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _loop, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, item;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this12.pairings.length === 0)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__Pairing_pairingAPIs__["a" /* default */].getAllPairings();

              case 3:
                _this12.pairings = _context4.sent;

                _this12.pairings = _this12.pairings.filter(function (p) {
                  return p.pairing_details && p.pairing_details.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].pairingStatus.ACCEPTED;
                });

              case 5:
                _loop = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop(item) {
                  var campaignIDs, influencerCampaigns;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this12.getInfCampaignIDs(item);

                        case 2:
                          campaignIDs = _context3.sent;
                          influencerCampaigns = _this12.campaigns.filter(function (campaign) {
                            return campaignIDs.includes(campaign.id);
                          });
                          _context3.next = 6;
                          return _this12.getInfCampaignTypes(influencerCampaigns);

                        case 6:
                          item.campaignTypes = _context3.sent;

                        case 7:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _loop, _this12);
                });
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context4.prev = 9;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this12.items);

              case 11:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context4.next = 17;
                  break;
                }

                item = _step4.value;
                return _context4.delegateYield(_loop(item), 't0', 14);

              case 14:
                _iteratorNormalCompletion4 = true;
                _context4.next = 11;
                break;

              case 17:
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4['catch'](9);
                _didIteratorError4 = true;
                _iteratorError4 = _context4.t1;

              case 23:
                _context4.prev = 23;
                _context4.prev = 24;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 26:
                _context4.prev = 26;

                if (!_didIteratorError4) {
                  _context4.next = 29;
                  break;
                }

                throw _iteratorError4;

              case 29:
                return _context4.finish(26);

              case 30:
                return _context4.finish(23);

              case 31:
                _this12.items = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()([], _this12.items);

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee3, _this12, [[9, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    getInfCampaignIDs: function getInfCampaignIDs(item) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var infPairings, campaignIDs;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                infPairings = _this13.pairings.filter(function (pairing) {
                  var influencerDetails = pairing.influencer_details;
                  if (influencerDetails && influencerDetails.instagramHandle === item.instagramHandle) {
                    if (_this13.platform === 'tiktok') {
                      if (influencerDetails.platform === 'tiktok') {
                        return true;
                      }
                    } else return true;
                  }
                  return false;
                });
                campaignIDs = infPairings.map(function (p) {
                  return p.campaignID;
                });
                return _context5.abrupt('return', campaignIDs);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },
    getInfCampaignTypes: function getInfCampaignTypes(influencerCampaigns) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var campaignTypes, naIndex;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                campaignTypes = _this14.getCampaignTypes();
                naIndex = campaignTypes.findIndex(function (type) {
                  return type.value === -1;
                });

                influencerCampaigns.map(function (infCampaign) {
                  var matchIndex = campaignTypes.findIndex(function (type) {
                    return infCampaign.campaignType && type.value === infCampaign.campaignType;
                  });
                  if (matchIndex !== -1) {
                    campaignTypes[matchIndex].campaigns.push(infCampaign);
                    campaignTypes[matchIndex].count += 1;
                  } else {
                    campaignTypes[naIndex].campaigns.push(infCampaign);
                    campaignTypes[naIndex].count += 1;
                  }
                });
                return _context6.abrupt('return', campaignTypes);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    },
    getCampaignTypes: function getCampaignTypes() {
      var types = __WEBPACK_IMPORTED_MODULE_13__Campaign_config__["a" /* default */].campaignTypeDisplay.map(function (type) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, {
          name: type.text,
          value: type.value,
          count: 0,
          campaigns: []
        });
      });
      types.push({
        name: 'Others',
        value: -1,
        count: 0,
        campaigns: []
      });
      return types;
    },
    calculateMedians: function calculateMedians(medians, engagementRate, handle) {
      medians = medians.map(function (item) {
        item.min = item.min ? (Number(item.min) * 100).toFixed(2) : -1;
        item.max = item.max ? (Number(item.max) * 100).toFixed(2) : -1;

        if (engagementRate >= Number(item.min) && engagementRate <= Number(item.max)) {
          item.handle = handle;
        }
        item.rate = '';
        if (item.min === -1 && item.max >= 0) {
          item.rate += '< ' + item.max + '%';
        } else if (item.max === -1 && item.min >= 0) {
          item.rate += '> ' + item.min + '%';
        } else if (item.max > 0 && item.min >= 0) {
          item.rate += item.min + '% - ' + item.max + '%';
        }
        return item;
      });
      return medians;
    },
    openCampaignListsModal: function openCampaignListsModal(item, handle) {
      var _this15 = this;

      this.viewHandle = handle;
      this.viewCampaigns = [];
      item.campaignTypes.map(function (type) {
        var _viewCampaigns;

        (_viewCampaigns = _this15.viewCampaigns).push.apply(_viewCampaigns, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(type.campaigns));
      });
      this.setShowCampaignVerticals();
      this.viewCampaignListsDialog = true;
    },
    setShowCampaignVerticals: function setShowCampaignVerticals() {
      this.viewCampaigns = this.viewCampaigns.map(function (v) {
        if (v.vertical && v.vertical.length > 0) {
          v.showVerticals = v.vertical.map(function (vt) {
            return vt.name;
          }).join(', ');
        } else {
          v.showVerticals = '-';
        }
        return v;
      });
    },
    openMedianEngModal: function openMedianEngModal(item) {
      this.viewHandle = item.instagramHandle;
      this.viewEngRate = item.engagementRate;
      this.viewFollowersRange = item.followersRange;
      this.viewMedianEngs = item.medianEngagements;
      this.viewMedianEngDialog = true;
    },
    openAddPairingCampaignModal: function openAddPairingCampaignModal() {
      this.addInfluencerPairingDialog = true;
    },
    getRateCard: function getRateCard(item) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var influencerID;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                influencerID = item.influencerID;

                _this16.inputRates = {};
                if (influencerID) {
                  __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (item) {
                    _this16.inputRates = item.inputedRates || {};
                    if (_this16.inputRates.pricingDecks && _this16.inputRates.pricingDecks.length === 0) {
                      _this16.isPricingDeskEmpty = true;
                    }
                  });
                }
                _context7.next = 5;
                return _this16.getRateCardFormLists(item);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee6, _this16);
      }))();
    },
    getRateCardFormLists: function getRateCardFormLists(item) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var filters;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this17.rateCardFormRates = {};
                filters = {};

                if (item.platform) {
                  if (item.platform === 'tiktok') {
                    filters.tiktokHandle = item.instagramHandle;
                  } else {
                    filters.instagramHandle = item.instagramHandle;
                  }
                } else filters.instagramHandle = item.instagramHandle;
                _context8.next = 5;
                return _this17.$store.dispatch('influencer/getRateCardLists', { filters: filters });

              case 5:
                if (_this17.rateCards && _this17.rateCards.length > 0) {
                  _this17.rateCardFormRates = _this17.rateCards[0];
                }

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee7, _this17);
      }))();
    },
    showLoadingEvent: function showLoadingEvent(status) {
      this.importLoading = status;
    },
    downloadSampleUpload: function downloadSampleUpload() {
      var link = document.createElement('a');

      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_creator_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.fields.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.fields)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref = _step5.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                columns = _this18.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this18.userProfile.tableSettings) {
                  tableSettings = _this18.userProfile.tableSettings;
                }
                tableSettings.allInfsCols = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this18.currentUserID,
                  tableSettings: tableSettings
                };
                _context9.next = 8;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this18.colStatuses = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, columns);
                _this18.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee8, _this18);
      }))();
    },
    createChartDataAudienceGendersPerAge: function createChartDataAudienceGendersPerAge(item) {
      var audienceGendersPerAge = item.audienceGendersPerAge;
      var audienceGendersPerAgeMale = {
        label: 'Male',
        backgroundColor: '#42a5f5',
        data: []
      };
      var audienceGendersPerAgeFemale = {
        label: 'Female',
        backgroundColor: '#ff595e',
        data: []
      };
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(audienceGendersPerAge), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var data = _step6.value;

          audienceGendersPerAgeMale.data.push((data.male * 100).toFixed(2));
          item.ageGroupChart.labels.push(data.code);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(audienceGendersPerAge), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _data = _step7.value;

          audienceGendersPerAgeFemale.data.push((_data.female * 100).toFixed(2));
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      item.ageGroupChart.datasets.push(audienceGendersPerAgeMale);
      item.ageGroupChart.datasets.push(audienceGendersPerAgeFemale);
      return item.ageGroupChart;
    },
    getUserProfile: function getUserProfile() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__User_userAPIs__["a" /* default */].getUser(_this19.currentUserID);

              case 2:
                resp = _context10.sent;

                if (resp && resp.id) {
                  _this19.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee9, _this19);
      }))();
    },
    openReportPasscodeDialog: function openReportPasscodeDialog() {
      this.allReportsPasscodeDialog = true;
    },
    reportPasscodeSuccess: function reportPasscodeSuccess() {
      this.exportInfluencers();
    },
    refreshReport: function refreshReport(item) {
      var _this20 = this;

      this.isLoading = true;
      var reportId = item.reportID;
      __WEBPACK_IMPORTED_MODULE_15__influencerAPIs__["a" /* default */].refreshAudienceReport(reportId).then(function (data) {
        _this20.isLoading = false;
        _this20.paginate(_this20.currentPage);
      });
    },
    selectAllLists: function selectAllLists($event) {
      if (!$event.value) {
        this.selectedLists = [];
        return;
      }
      this.selectedLists = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()([], this.items);
    },
    deleteAud: function deleteAud(item) {
      var _this21 = this;

      this.$swal({
        title: 'Confirm',
        text: 'Are you sure to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(result) {
          var payload;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (!result.value) {
                    _context11.next = 5;
                    break;
                  }

                  payload = {
                    id: item.id,
                    platform: _this21.selectedPlatform
                  };
                  _context11.next = 4;
                  return _this21.$store.dispatch('influencer/deleteAud', payload);

                case 4:
                  if (_this21.deletedAud) {
                    _this21.$swal({
                      title: 'Successfully Deleted!',
                      type: 'success'
                    });
                    _this21.paginate();
                  }

                case 5:
                case 'end':
                  return _context11.stop();
              }
            }
          }, _callee10, _this21);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    getSortedAges: function getSortedAges(ages) {
      if (Array.isArray(ages)) {
        if (ages.length) {
          return __WEBPACK_IMPORTED_MODULE_31_lodash_orderBy___default()(ages, ['weight'], ['desc']);
        }
      }
      return ages;
    },
    removeFilterShow: function removeFilterShow(type) {
      if (type === 'mainCountry') {
        this.influencerGeos = [];
      }
      if (type === 'gender') {
        this.searchFilter.gender = '';
      }
      if (type === 'isIMS') {
        this.searchFilter.isIMS = 0;
      }
      if (type === 'campaign') {
        this.searchFilter.campaign = '';
      }
      if (type === 'audCredibility') {
        this.searchFilter.credibility = '';
      }
      if (type === 'audGeo') {
        this.audGeos = [];
        this.audGeoPercent = '';
      }
      if (type === 'followers') {
        this.searchFilter.followers = { from: '', to: '' };
      }
      if (type === 'ageGroup') {
        this.searchFilter.ageGroup = '';
        this.searchFilter.ageGroupPercent = '';
        this.searchFilter.secAgeGroup = '';
        this.searchFilter.secAgeGroupPercent = '';
      }
      if (type === 'infInterests') {
        this.searchFilter.infInterest = [];
      }
      if (type === 'audInterests') {
        this.searchFilter.audienceInterest = [];
      }
      if (type === 'engRate') {
        this.searchFilter.engagementRate = { to: '' };
      }
      if (type === 'paidPstRet') {
        this.searchFilter.paidPstPerformance = { from: '', to: '' };
      }
      this.removeItemFromFilterList(type);
      this.paginate();
    },
    setFilterItem: function setFilterItem(type, data) {
      var existIdx = this.searchFilterLists.findIndex(function (s) {
        return s.type === type;
      });
      if (existIdx !== -1) {
        this.searchFilterLists[existIdx] = data;
      } else {
        this.searchFilterLists.push(data);
      }
    },
    removeItemFromFilterList: function removeItemFromFilterList(type) {
      this.searchFilterLists = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()([], this.searchFilterLists.filter(function (sList) {
        return sList.type !== type;
      }));
    }
  },
  created: function created() {
    var _this22 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (_this22.$route.query.handle) {
                _this22.igHandle = _this22.$route.query.handle;
              }
              if (_this22.$route.query.platform) {
                _this22.selectedPlatform = _this22.$route.query.platform;
              }
              _this22.paginate(_this22.currentPage);
              _this22.getCountries();
              _this22.userGender_options = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userGenderDisplay;
              _this22.getUsers();
              _context12.next = 8;
              return _this22.getUserProfile();

            case 8:
              _context12.next = 10;
              return _this22.$store.dispatch('campaign/getCampaigns');

            case 10:
              _this22.filterCampaigns = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()([], _this22.campaigns);
              _this22.filterCampaigns.unshift({
                id: 'all',
                name: 'All Campaigns'
              }, {
                id: 'AOK',
                name: 'AOK Campaigns'
              }, {
                id: 'storytell',
                name: 'Storytell Campaigns'
              }, {
                id: 'empty',
                name: 'Empty Campaigns'
              });

            case 12:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee11, _this22);
    }))();
  }
});

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PayoutSampleModal',
  props: ['type', 'value'],
  data: function data() {
    return {
      imgBaseURL: '/static/img/payout_samples/',
      sampleConfig: [{
        title: 'IG Reel',
        type: 'igReel',
        images: [{
          title: 'IG Reel stats (reach, views, engagements)',
          url: 'IGR_IGP_eg.png'
        }]
      }, {
        title: 'IG Post',
        type: 'igPost',
        images: [{
          title: 'Igp stats (reach, impressions, engagements)',
          url: 'IGR_IGP_eg.png'
        }]
      }, {
        title: 'IG Story',
        type: 'igStory',
        images: [{
          title: 'Igs stats',
          url: 'IGS_eg.png'
        }]
      }, {
        title: 'TikTok',
        type: 'tiktok',
        images: [{
          title: 'Tiktok stats',
          url: 'tt_eg.png'
        }]
      }, {
        title: 'XHS Post',
        type: 'xhs',
        metrics: ['Views', 'Average Watch Time', 'Likes', 'Saves', 'Comments', 'Shares']
      }, {
        title: 'Facebook Post',
        type: 'facebook',
        metrics: ['Reach', 'Impressions', 'Reactions', 'Comments', 'Shares', 'Post clicks']
      }, {
        title: 'LinkedIn Post',
        type: 'linkedin',
        images: [{
          title: 'LinkedIn discovery insights',
          url: 'linkedin-discovery.png'
        }, {
          title: 'LinkedIn video performance and profile activity insights',
          url: 'linkedin-video-performance.png'
        }, {
          title: 'LinkedIn engagement insights',
          url: 'linkedin-engagement.png'
        }]
      }, {
        title: 'X (Twitter) Post',
        type: 'twitter',
        metrics: ['Impressions', 'Replies', 'Likes', 'Reposts', 'Bookmarks']
      }],
      viewSample: {},
      currentSlide: 0
    };
  },

  computed: {
    sampleImages: function sampleImages() {
      return this.viewSample.images || [];
    }
  },
  watch: {
    type: {
      immediate: true,
      handler: function handler(newType) {
        if (newType) {
          this.viewSample = this.sampleConfig.find(function (sample) {
            return sample.type === newType;
          });
          this.currentSlide = 0;
        }
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProfileTallyForm',
  data: function data() {
    return {
      dialog: true
    };
  },

  methods: {
    close: function close() {
      this.$router.push({ path: '/' });
    }
  },
  computed: {
    formUrl: function formUrl() {
      var url = 'https://tally.so/r/mJLz4Y?transparentBackground=1';
      var query = this.$route.query;
      if (query.igHandle) {
        url += '&igHandle=' + query.igHandle;
      }
      if (query.tiktokHandle) {
        url += '&tiktokHandle=' + query.tiktokHandle;
      }
      if (query.influencerID) {
        url += '&influencerID=' + query.influencerID;
      }
      return url;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewModalDialog',
  props: {
    value: Boolean,
    travelData: Object
  },
  data: function data() {
    return {
      travelFormData: {},
      influencer: {
        tiktok: {
          tiktokHandle: '',
          tiktokFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        youtube: {
          youtubeHandle: '',
          youtubeFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        instagram: {
          instagramHandle: '',
          instagramFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        }
      },
      excludeTitles: ['id', 'influencerID', 'Do you have more travel plan?', 'Do you still have more travel plan?', 'respondentId', 'submissionId']
    };
  },

  watch: {
    travelData: function travelData(newTravelData) {
      this.travelFormData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, newTravelData);
    }
  },
  mounted: function mounted() {},

  methods: {
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ViewModalDialog__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay__);























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RateCardDataTable',
  components: {
    ViewModalDialog: __WEBPACK_IMPORTED_MODULE_10__ViewModalDialog___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_11__components_scoped_custom_SocialHandle___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_12__components_scoped_custom_TableColsShowHideModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_20_vue_loading_overlay___default.a
  },
  props: ['reload', 'isDownload'],
  watch: {
    reload: function reload(value) {
      if (value) {
        this.resetFilters();
        this.getRateCardLists();
      }
    },
    isDownload: function isDownload(value) {
      if (value) {
        this.downloadRateCardRpt();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    items: function items(state) {
      return state.influencer.rateCards;
    },
    savedRateCard: function savedRateCard(state) {
      return state.influencer.savedRateCard;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isAdmin: function isAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    },
    isSortCurrency: function isSortCurrency() {
      var sortCol = this.sort.column;
      return sortCol === 'IG Story' || sortCol === 'IG Post' || sortCol === 'IG Carousel' || sortCol === 'IG Reel' || sortCol === 'Loading Fee' || sortCol === 'Event Attendance' || sortCol === 'TikTok';
    },
    activeFilterCount: function activeFilterCount() {
      var _this = this;

      var count = 0;
      var scalarFilters = ['country', 'category', 'mainCategory', 'subCategory', 'contentType', 'rateCurrency', 'dateOfBirth'];
      scalarFilters.forEach(function (key) {
        if (_this.filters[key]) count++;
      });
      if (this.filters.starOnly) count++;
      if (this.filters.isTikTokEmpty) count++;
      if (this.filters.isIgEmpty) count++;
      if (this.filters.followers && (this.filters.followers.from || this.filters.followers.to)) count++;
      if (this.filters.tiktokFollowers && (this.filters.tiktokFollowers.from || this.filters.tiktokFollowers.to)) count++;
      if (this.filters.rate && (this.filters.rate.from || this.filters.rate.to)) count++;
      return count;
    },
    computedHeaders: function computedHeaders() {
      var _this2 = this;

      var rateCardCols = null;
      var headers = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.refreshJSON(this.headers);
      headers = headers.map(function (h) {
        if (h.value === 'labels') {
          h.text = '';
        }
        return h;
      });

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.rateCardCols) {
          rateCardCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.rateCardCols);
        }
      }
      if (rateCardCols) {
        headers.forEach(function (header) {
          if (!Object.prototype.hasOwnProperty.call(rateCardCols, header.value)) {
            rateCardCols[header.value] = true;
          }
        });
        this.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, rateCardCols);
      } else {
        headers.map(function (header) {
          _this2.colStatuses[header.value] = true;
        });
      }
      return headers.filter(function (h) {
        if (_this2.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    }
  }),
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func,
      viewData: null,
      viewDialog: false,
      rateCardConfig: __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */],
      headers: __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].tableHeaders,
      rateCardLabels: __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].rateCardLabels,
      filteredItems: [],
      exportItems: [],
      filter: '',
      filtersExpanded: false,
      colStatuses: {},
      colSettingsDialog: false,
      dateOfBirthCal: false,
      tableColsItems: [],
      userProfile: {},
      categories: __WEBPACK_IMPORTED_MODULE_17__influencerHelper__["a" /* default */].getCategories('en'),
      currencyOptions: __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].currencyOptions,
      contentTypes: [{ title: 'IG Story', value: 'igStory', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Post', value: 'igPost', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Carousel', value: 'igCarousel', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Video', value: 'igVideo', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Reel', value: 'igReel', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG TV', value: 'igTv', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'Loading Fee', value: 'loadingFee', icon: 'mdi-cloud-upload-outline', iconColor: '#607D8B' }, { title: 'Event Appearance', value: 'eventAppearance', icon: 'mdi-calendar-star', iconColor: '#FF8F00' }, { title: 'TikTok', value: 'tiktok', imgIcon: '/static/img/tiktok.svg' }, { title: 'YouTube Post', value: 'youtube', icon: 'mdi-youtube', iconColor: '#FF0000' }, { title: 'Facebook Post', value: 'facebook', icon: 'mdi-facebook', iconColor: '#1877F2' }, { title: 'LinkedIn Post', value: 'linkedin', icon: 'mdi-linkedin', iconColor: '#0A66C2' }, { title: 'X (Twitter) Post', value: 'twitter', imgIcon: '/static/img/x-logo.svg' }, { title: 'Twitch Post', value: 'twitch', icon: 'mdi-twitch', iconColor: '#9146FF' }],
      sortColumns: ['IG followers', 'TikTok followers', 'Date of Birth', 'Last Updated', 'IG Story', 'IG Post', 'IG Carousel', 'IG Reel', 'Loading Fee', 'Event Attendance', 'TikTok'],
      sortTypes: ['Ascending', 'Descending'],
      sort: {
        column: 'Updated At',
        currency: '',
        type: 'Ascending'
      },
      filters: {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        followers: { from: '', to: '' },
        tiktokFollowers: { from: '', to: '' },
        contentType: '',
        rateCurrency: '',
        rate: { from: '', to: '' },
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      }
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var matchItem;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.countries = __WEBPACK_IMPORTED_MODULE_19__static_sources_countries___default.a;
              _this3.countries = _this3.countries.map(function (c) {
                return c.name;
              });
              _context.next = 4;
              return _this3.getRateCardLists();

            case 4:
              if (_this3.$route.query.id) {
                matchItem = _this3.filteredItems.find(function (item) {
                  return item.id === _this3.$route.query.id;
                });

                _this3.getDataToView(matchItem);
              }
              _context.next = 7;
              return _this3.getUserProfile();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },

  methods: {
    clearRateFilters: function clearRateFilters() {
      this.filters.contentType = '';
      this.filters.rateCurrency = '';
      this.filters.rate = { from: '', to: '' };
      this.searchFilter();
    },
    getDataToView: function getDataToView(item) {
      this.$router.push({
        path: '/influencers/rate-cards',
        query: {
          id: item.id
        }
      });
      this.viewData = item;
      this.viewDialog = true;
    },
    getRateCardLists: function getRateCardLists() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var items;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$store.dispatch('influencer/getRateCardLists');

              case 2:
                items = _this4.items.map(function (i) {
                  return i;
                });

                items = items.map(function (item) {
                  if (!item.preferentialRates) {
                    item.preferentialRates = {};
                  }
                  if (!item.ordinaryRates) {
                    item.ordinaryRates = {
                      igStory: item.igStory || 0,
                      igStoryCurrency: 'SGD',
                      igPost: item.igPost || 0,
                      igPostCurrency: 'SGD',
                      igCarousel: item.igCarousel || 0,
                      igCarouselCurrency: 'SGD',
                      igVideo: item.igVideo || 0,
                      igVideoCurrency: 'SGD',
                      igReel: item.igReel || 0,
                      igReelCurrency: 'SGD',
                      igTv: item.igTv || 0,
                      igTvCurrency: 'SGD',
                      loadingFee: item.loadingFee || 0,
                      loadingFeeCurrency: 'SGD',
                      eventAppearance: item.eventAppearance || 0,
                      eventAppearanceCurrency: 'SGD',
                      tiktok: item.tiktok || 0,
                      tiktokCurrency: 'SGD',
                      linkedin: 0,
                      linkedinCurrency: 'SGD',
                      twitter: 0,
                      twitterCurrency: 'SGD',
                      facebook: 0,
                      facebookCurrency: 'SGD',
                      youtube: 0,
                      youtubeCurrency: 'SGD',
                      twitch: 0,
                      twitchCurrency: 'SGD'
                    };
                  }
                  if (!item.keywords) item.keywords = [];
                  if (!item.mainCategories) item.mainCategories = [];
                  if (!item.subCategories) item.subCategories = [];
                  return item;
                });
                _this4.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], items);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getPlatformUrl: function getPlatformUrl(item, platform) {
      var platformEntry = this.getPlatformEntry(item, platform);
      return platformEntry && platformEntry.url ? platformEntry.url : '';
    },
    getPlatformRate: function getPlatformRate(item, platform) {
      if (item.ordinaryRates && item.ordinaryRates[platform]) return item.ordinaryRates[platform];
      var platformEntry = this.getPlatformEntry(item, platform);
      return platformEntry && platformEntry.rate ? platformEntry.rate : 0;
    },
    getPlatformRateCurrency: function getPlatformRateCurrency(item, platform) {
      if (item.ordinaryRates && item.ordinaryRates[platform + 'Currency']) return item.ordinaryRates[platform + 'Currency'];
      var platformEntry = this.getPlatformEntry(item, platform);
      return platformEntry && platformEntry.rateCurrency || 'SGD';
    },
    getPlatformEntry: function getPlatformEntry(item, platform) {
      var directHandle = item[platform + 'Handle'];
      if (directHandle) {
        var cleanHandle = String(directHandle).replace(/^@/, '');
        var platformUrls = {
          linkedin: 'https://www.linkedin.com/in/' + cleanHandle,
          twitter: 'https://x.com/' + cleanHandle,
          facebook: 'https://www.facebook.com/' + cleanHandle,
          youtube: 'https://www.youtube.com/@' + cleanHandle,
          twitch: 'https://www.twitch.tv/' + cleanHandle
        };
        return {
          handle: directHandle,
          url: platformUrls[platform] || ''
        };
      }
      if (item.platforms) {
        if (Array.isArray(item.platforms)) {
          var normalizedPlatform = platform === 'twitter' ? ['twitter', 'x', 'x (twitter)'] : [platform];
          var matchPlatform = item.platforms.find(function (p) {
            return normalizedPlatform.includes(String(p.platform || '').trim().toLowerCase());
          });
          if (matchPlatform) {
            return matchPlatform;
          }
        }
      }
      return null;
    },
    getHandlePreview: function getHandlePreview(item, platform) {
      var platformEntry = this.getPlatformEntry(item, platform);
      var savedHandle = platformEntry && (platformEntry.handle || platformEntry.username || platformEntry.userHandle || platformEntry.name);
      if (savedHandle) {
        return String(savedHandle).replace(/^@/, '');
      }

      var url = this.getPlatformUrl(item, platform);
      if (!url) return '';
      if (url.includes('watch?')) return url;

      var cleanUrl = String(url).trim().replace(/[?#].*$/, '').replace(/\/+$/, '');
      var result = '';
      try {
        var parsedUrl = new URL(cleanUrl);
        var pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
        if (pathSegments.length) {
          return decodeURIComponent(pathSegments[pathSegments.length - 1]);
        }
      } catch (error) {
        var lastSlashIndex = cleanUrl.lastIndexOf('/');
        result = lastSlashIndex >= 0 ? cleanUrl.substring(lastSlashIndex + 1) : cleanUrl;
        if (result) return result;
      }
      return platform === 'facebook' ? 'Facebook profile' : result;
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.headers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                columns = _this5.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this5.userProfile.tableSettings) {
                  tableSettings = _this5.userProfile.tableSettings;
                }
                tableSettings.rateCardCols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this5.currentUserID,
                  tableSettings: tableSettings
                };
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this5.colStatuses = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, columns);
                _this5.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getUserProfile: function getUserProfile() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__User_userAPIs__["a" /* default */].getUser(_this6.currentUserID);

              case 2:
                resp = _context4.sent;

                if (resp && resp.id) {
                  _this6.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    downloadRateCardRpt: function downloadRateCardRpt() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var rateCardIds, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.isLoading = true;
                rateCardIds = _this7.filteredItems.map(function (i) {
                  return i.id;
                });
                data = {
                  rateCardIds: rateCardIds
                };

                __WEBPACK_IMPORTED_MODULE_18__influencerAPIs__["a" /* default */].downloadRateCardRpt(data).then(function () {
                  _this7.isLoading = false;
                }).catch(function (error) {
                  _this7.isLoading = false;
                  console.log('error in downloading rate card report', error);
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    searchFilter: function searchFilter() {
      var _this8 = this;

      this.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], this.items);
      if (this.filters.country) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.country === _this8.filters.country;
        });
      }
      if (this.filters.category) {
        var categoryTh = __WEBPACK_IMPORTED_MODULE_17__influencerHelper__["a" /* default */].getCategories('th');
        var categoryVn = __WEBPACK_IMPORTED_MODULE_17__influencerHelper__["a" /* default */].getCategories('vn');
        var categoryId = __WEBPACK_IMPORTED_MODULE_17__influencerHelper__["a" /* default */].getCategories('id');
        var categoryCn = __WEBPACK_IMPORTED_MODULE_17__influencerHelper__["a" /* default */].getCategories('cn');
        var catIdx = this.categories.findIndex(function (f) {
          return f === _this8.filters.category;
        });
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.keywords.includes(_this8.filters.category) || f.keywords.includes(categoryTh[catIdx]) || f.keywords.includes(categoryVn[catIdx]) || f.keywords.includes(categoryId[catIdx]) || f.keywords.includes(categoryCn[catIdx]);
        });
      }
      if (this.filters.followers.from) {
        var from = this.filters.followers.from.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igFollowerCount >= Number(from);
        });
      }
      if (this.filters.followers.to) {
        var to = this.filters.followers.to.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igFollowerCount <= Number(to);
        });
      }
      if (this.filters.tiktokFollowers.from) {
        var _from = this.filters.tiktokFollowers.from.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktokFollowerCount >= Number(_from);
        });
      }
      if (this.filters.tiktokFollowers.to) {
        var _to = this.filters.tiktokFollowers.to.replace('K', '000').replace('M', '000000');
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktokFollowerCount <= Number(_to);
        });
      }
      if (this.filters.isTikTokEmpty) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return !f.tiktokFollowerCount;
        });
      }
      if (this.filters.isIgEmpty) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return !f.igFollowerCount;
        });
      }
      if (this.filters.dateOfBirth) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.dateOfBirth && f.dateOfBirth.includes(_this8.filters.dateOfBirth);
        });
      }
      if (this.filters.starOnly) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.star;
        });
      }
      if (this.filters.mainCategory) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.mainCategories && f.mainCategories.includes(_this8.filters.mainCategory);
        });
      }
      if (this.filters.subCategory) {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.subCategories && f.subCategories.includes(_this8.filters.subCategory);
        });
      }

      if (this.filters.contentType) {
        var contentTypeValue = this.filters.contentType.value;
        this.filteredItems = this.filteredItems.filter(function (f) {
          var rates = f.ordinaryRates || {};
          var rateValue = rates[contentTypeValue];
          if (!rateValue) return false;

          if (_this8.filters.rateCurrency) {
            var currencyKey = contentTypeValue + 'Currency';
            if (rates[currencyKey] !== _this8.filters.rateCurrency) {
              return false;
            }
          }

          if (_this8.filters.rate.from !== '' && _this8.filters.rate.from !== null) {
            if (Number(rateValue) < Number(_this8.filters.rate.from)) {
              return false;
            }
          }
          if (_this8.filters.rate.to !== '' && _this8.filters.rate.to !== null) {
            if (Number(rateValue) > Number(_this8.filters.rate.to)) {
              return false;
            }
          }

          return true;
        });
      }

      var sortCol = this.sort.column;
      var sortType = this.sort.type === 'Ascending' ? 'asc' : 'desc';
      this.filteredItems = this.filteredItems.map(function (f) {
        if (f.igFollowerCount) {
          f.igFollowerCount = Number(f.igFollowerCount);
        }
        if (f.tiktokFollowerCount) {
          f.tiktokFollowerCount = Number(f.tiktokFollowerCount);
        }
        var rates = f.ordinaryRates || {};
        if (rates.igStory) {
          f.igStory = Number(rates.igStory);
          f.igStoryCurrency = rates.igStoryCurrency;
        }
        if (rates.igPost) {
          f.igPost = Number(rates.igPost);
          f.igPostCurrency = rates.igPostCurrency;
        }
        if (rates.igCarousel) {
          f.igCarousel = Number(rates.igCarousel);
          f.igCarouselCurrency = rates.igCarouselCurrency;
        }
        if (rates.igVideo) {
          f.igVideo = Number(rates.igVideo);
          f.igVideoCurrency = rates.igVideoCurrency;
        }
        if (rates.igReel) {
          f.igReel = Number(rates.igReel);
          f.igReelCurrency = rates.igReelCurrency;
        }
        if (rates.igTv) {
          f.igTv = Number(rates.igTv);
          f.igTvCurrency = rates.igTvCurrency;
        }
        if (rates.loadingFee) {
          f.loadingFee = Number(rates.loadingFee);
          f.loadingFeeCurrency = rates.loadingFeeCurrency;
        }
        if (rates.eventAppearance) {
          f.eventAppearance = Number(rates.eventAppearance);
          f.eventAppearanceCurrency = rates.eventAppearanceCurrency;
        }
        if (rates.tiktok) {
          f.tiktok = Number(rates.tiktok);
          f.tiktokCurrency = rates.tiktokCurrency;
        }
        return f;
      });
      if (sortCol === 'IG followers') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igFollowerCount;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['igFollowerCount'], [sortType]);
      }
      if (sortCol === 'TikTok followers') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktokFollowerCount;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['tiktokFollowerCount'], [sortType]);
      }
      if (sortCol === 'Date of Birth') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.dateOfBirth;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['dateOfBirth'], [sortType]);
      }
      if (sortCol === 'Last Updated') {
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['updatedAt'], [sortType]);
      }
      if (sortCol === 'IG Story') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igStory;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['igStory'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igStoryCurrency === _this8.sort.currency;
          });
        }
      }
      if (sortCol === 'IG Post') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igPost;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['igPost'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igPostCurrency === _this8.sort.currency;
          });
        }
      }
      if (sortCol === 'IG Carousel') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igCarousel;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['igCarousel'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igCarouselCurrency === _this8.sort.currency;
          });
        }
      }
      if (sortCol === 'IG Reel') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.igReel;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['igReel'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.igReelCurrency === _this8.sort.currency;
          });
        }
      }
      if (sortCol === 'Loading Fee') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.loadingFee;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['loadingFee'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.loadingFeeCurrency === _this8.sort.currency;
          });
        }
      }
      if (sortCol === 'Event Attendance') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.eventAppearance;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['eventAppearance'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.eventAppearanceCurrency === _this8.sort.currency;
          });
        }
      }
      if (sortCol === 'TikTok') {
        this.filteredItems = this.filteredItems.filter(function (f) {
          return f.tiktok;
        });
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_16_lodash_orderBy___default()(this.filteredItems, ['tiktok'], [sortType]);
        if (this.sort.currency) {
          this.filteredItems = this.filteredItems.filter(function (f) {
            return f.tiktokCurrency === _this8.sort.currency;
          });
        }
      }
    },
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    },
    deleteRateCard: function deleteRateCard(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this9.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to delete?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6(result) {
                    var payload;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!result.value) {
                              _context6.next = 13;
                              break;
                            }

                            _this9.isLoading = true;
                            payload = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, {
                              id: id
                            });
                            _context6.next = 5;
                            return _this9.$store.dispatch('influencer/deleteRateCard', payload);

                          case 5:
                            _this9.isLoading = false;

                            if (_this9.savedRateCard) {
                              _context6.next = 9;
                              break;
                            }

                            _this9.$swal({
                              text: 'Error Deleting Rate Card.',
                              type: 'error'
                            });
                            return _context6.abrupt('return');

                          case 9:
                            _this9.$swal({
                              text: 'Successfully deleted.',
                              type: 'success'
                            });
                            _context6.next = 12;
                            return _this9.getRateCardLists();

                          case 12:
                            _this9.searchFilter();

                          case 13:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this9);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    chgStarStatus: function chgStarStatus(item, status) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var data, matchIdx;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this10.isLoading = true;
                data = [{
                  id: item.id,
                  star: status
                }];
                _context8.next = 4;
                return _this10.$store.dispatch('influencer/updateRateCardByIds', data);

              case 4:
                _this10.isLoading = false;
                if (_this10.savedRateCard) {
                  matchIdx = _this10.filteredItems.findIndex(function (f) {
                    return f.id === item.id;
                  });

                  _this10.filteredItems[matchIdx].star = status;
                  _this10.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this10.filteredItems);
                }

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    },
    resetFilters: function resetFilters() {
      this.filters = {
        country: '',
        category: '',
        mainCategory: '',
        subCategory: '',
        dateOfBirth: '',
        followers: { from: '', to: '' },
        tiktokFollowers: { from: '', to: '' },
        contentType: '',
        rateCurrency: '',
        rate: { from: '', to: '' },
        isTikTokEmpty: false,
        isIgEmpty: false,
        starOnly: false
      };
      this.filter = '';
    },
    cancelDOB: function cancelDOB() {
      this.dateOfBirthCal = false;
      this.searchFilter();
    },
    searchIGFollower: function searchIGFollower() {
      this.sort.column = 'IG followers';
      this.sort.type = 'Descending';
      this.searchFilter();
    },
    searchTikTokFollower: function searchTikTokFollower() {
      this.sort.column = 'TikTok followers';
      this.sort.type = 'Descending';
      this.searchFilter();
    },
    changeLabel: function changeLabel(item) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this11.isLoading = true;
                data = [{
                  id: item.id,
                  mainCategories: item.mainCategories,
                  subCategories: item.subCategories
                }];
                _context9.next = 4;
                return _this11.$store.dispatch('influencer/updateRateCardByIds', data);

              case 4:
                _this11.isLoading = false;
                if (_this11.savedRateCard) {
                  _this11.filteredItems = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], _this11.filteredItems);
                }

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    }
  }
});

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__config_logoDataURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_sources_cities__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_sources_cities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__static_sources_cities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_sources_dialCodes__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_sources_dialCodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__static_sources_dialCodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RateCardTermsModal__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RateCardTermsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__RateCardTermsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_flag_icons_css_flag_icons_min_css__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_flag_icons_css_flag_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_flag_icons_css_flag_icons_min_css__);


























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RateCardForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_10_vuelidate__["validationMixin"]],
  validations: function validations() {
    var validationRules = {
      rateCardData: {
        name: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },
        email: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },
        country: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },
        gender: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        },

        aboutYou: {
          required: __WEBPACK_IMPORTED_MODULE_11_vuelidate_lib_validators__["required"]
        }
      }
    };

    return validationRules;
  },
  components: {
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_12__scoped_custom_CustomFileUpload___default.a,
    RateCardTermsModal: __WEBPACK_IMPORTED_MODULE_20__RateCardTermsModal___default.a
  },
  props: {
    mode: String,
    editData: Object
  },
  data: function data() {
    return {
      dialog: true,
      rateCardDOB: false,
      formConfig: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].formConfig,
      langs: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].langs,
      countryCodeOptions: __WEBPACK_IMPORTED_MODULE_19__static_sources_dialCodes___default.a.map(function (d) {
        return d.dc;
      }),
      logoURL: __WEBPACK_IMPORTED_MODULE_16__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png',
      genderOptions: ['Male', 'Female'],
      ethnicityOptions: ['Chinese', 'Malay', 'Indian', 'Eurasian', 'Others'],
      rateCardData: {
        platforms: [],
        keywords: [],
        type: 'direct',
        agencyName: '',
        country: 'Singapore',
        city: '',
        ethnicity: '',
        otherEth: '',
        contactNo: '',
        gender: '',
        dateOfBirth: '',
        loadContent: '',
        loadContentText: '',
        giftBrand: '',
        igFollowerCount: '',
        tiktokFollowerCount: '',
        linkedinHandle: '',
        linkedinFollowerCount: '',
        twitterHandle: '',
        twitterFollowerCount: '',
        facebookHandle: '',
        facebookFollowerCount: '',
        youtubeHandle: '',
        youtubeFollowerCount: '',
        twitchHandle: '',
        twitchFollowerCount: '',

        preferentialRates: {
          igStory: 0,
          igStoryCurrency: 'SGD',
          igPost: 0,
          igPostCurrency: 'SGD',
          igCarousel: 0,
          igCarouselCurrency: 'SGD',
          igVideo: 0,
          igVideoCurrency: 'SGD',
          igReel: 0,
          igReelCurrency: 'SGD',
          igTv: 0,
          igTvCurrency: 'SGD',
          loadingFee: 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: 0,
          tiktokCurrency: 'SGD',
          linkedin: 0,
          linkedinCurrency: 'SGD',
          twitter: 0,
          twitterCurrency: 'SGD',
          facebook: 0,
          facebookCurrency: 'SGD',
          youtube: 0,
          youtubeCurrency: 'SGD',
          twitch: 0,
          twitchCurrency: 'SGD'
        },
        ordinaryRates: {
          igStory: 0,
          igStoryCurrency: 'SGD',
          igPost: 0,
          igPostCurrency: 'SGD',
          igCarousel: 0,
          igCarouselCurrency: 'SGD',
          igVideo: 0,
          igVideoCurrency: 'SGD',
          igReel: 0,
          igReelCurrency: 'SGD',
          igTv: 0,
          igTvCurrency: 'SGD',
          loadingFee: 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: 0,
          tiktokCurrency: 'SGD',
          linkedin: 0,
          linkedinCurrency: 'SGD',
          twitter: 0,
          twitterCurrency: 'SGD',
          facebook: 0,
          facebookCurrency: 'SGD',
          youtube: 0,
          youtubeCurrency: 'SGD',
          twitch: 0,
          twitchCurrency: 'SGD'
        }
      },
      deckFiles: [],
      fileUploadRefresh: false,
      submitting: false,
      categories: [],
      countries: [],
      citiesByCountry: [],
      dialCodes: __WEBPACK_IMPORTED_MODULE_19__static_sources_dialCodes___default.a,
      currenyOptions: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].currencyOptions,
      langOptions: [{
        icon: 'fi-gb-eng',
        title: 'EN',
        value: 'en'
      }, {
        icon: 'fi-th',
        title: 'TH',
        value: 'th'
      }, {
        icon: 'fi-vn',
        title: 'VN',
        value: 'vn'
      }, {
        icon: 'fi-id',
        title: 'ID',
        value: 'id'
      }, {
        icon: 'fi-cn',
        title: 'CN',
        value: 'cn'
      }],
      selectedLang: 'en',
      minBirthDate: __WEBPACK_IMPORTED_MODULE_15_moment___default()().subtract(13, 'years').format('YYYY-MM-DD'),
      DOBDateCal: false,
      showAgreementModal: false
    };
  },

  watch: {
    editData: {
      immediate: true,
      handler: function handler(newValue) {
        var _this = this;

        if (newValue) {
          var editData = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.refreshJSON(this.editData);
          editData.platforms = Array.isArray(editData.platforms) ? editData.platforms.map(function (platform) {
            return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, platform, {
              platform: _this.normalizePlatformKey(platform.platform)
            });
          }) : [];
          var standalonePlatforms = ['linkedin', 'twitter', 'facebook', 'youtube', 'twitch'];
          var ordinaryRateDefaults = {};
          var preferentialRateDefaults = {};
          standalonePlatforms.forEach(function (platform) {
            var legacyPlatform = editData.platforms.find(function (item) {
              return item.platform === platform;
            });
            var handleField = platform + 'Handle';
            editData[handleField] = editData[handleField] || _this.extractPlatformHandle(legacyPlatform && legacyPlatform.url, platform);
            ordinaryRateDefaults[platform] = legacyPlatform ? legacyPlatform.rate : 0;
            ordinaryRateDefaults[platform + 'Currency'] = legacyPlatform ? legacyPlatform.rateCurrency || 'SGD' : 'SGD';
            preferentialRateDefaults[platform] = 0;
            preferentialRateDefaults[platform + 'Currency'] = 'SGD';
          });
          editData.platforms = editData.platforms.filter(function (platform) {
            return !standalonePlatforms.includes(platform.platform);
          });
          editData.ordinaryRates = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(ordinaryRateDefaults, editData.ordinaryRates || {});
          editData.preferentialRates = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()(preferentialRateDefaults, editData.preferentialRates || {});
          this.rateCardData = editData;
          if (this.rateCardData.contactNo) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.countryCodeOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var code = _step.value;

                if (this.rateCardData.contactNo.includes(code)) {
                  this.rateCardData.contactNo = this.rateCardData.contactNo.replaceAll(code, '');
                  this.countryCode = code;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        }
      }
    },
    selectedLang: function selectedLang(newValue) {
      this.updateCategories(newValue);
    }
  },
  methods: {
    isStandaloneRateField: function isStandaloneRateField(fieldName) {
      return ['tiktok', 'linkedin', 'twitter', 'facebook', 'youtube', 'twitch'].includes(fieldName);
    },
    normalizePlatformKey: function normalizePlatformKey(platform) {
      var key = String(platform || '').trim().toLowerCase();
      return key === 'x' || key === 'x (twitter)' ? 'twitter' : key;
    },
    extractPlatformHandle: function extractPlatformHandle(value) {
      var handle = String(value || '').trim();
      if (!handle) return '';
      handle = handle.replace(/^@/, '').replace(/[?#].*$/, '').replace(/\/+$/, '');
      var urlMatch = handle.match(/(?:https?:\/\/)?(?:www\.)?(?:linkedin\.com\/in|x\.com|twitter\.com|facebook\.com|fb\.com|youtube\.com|youtu\.be|twitch\.tv)\/([^/]+)/i);
      if (urlMatch && urlMatch[1]) return decodeURIComponent(urlMatch[1]).replace(/^@/, '');
      if (handle.includes('/')) {
        var segments = handle.split('/').filter(Boolean);
        return segments[segments.length - 1] || '';
      }
      return handle;
    },
    close: function close() {
      this.$router.push({ path: '/' });
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    },
    submitForm: function submitForm() {
      this.showAgreementModal = false;
      this.$v.$touch();
      if (this.$v.rateCardData.$error) {
        return false;
      }
      if (!this.hasStandaloneMediaHandle) {
        this.$swal({
          text: this.getLang('enterIgTikTok'),
          type: 'warning'
        });
        return;
      }
      if (this.rateCardData.instagramHandle && !this.rateCardData.igFollowerCount) {
        this.$swal({
          text: 'Please enter Instagram Followers Count!',
          type: 'warning'
        });
        return;
      }
      if (this.rateCardData.tiktokHandle && !this.rateCardData.tiktokFollowerCount) {
        this.$swal({
          text: 'Please enter TikTok Followers Count!',
          type: 'warning'
        });
        return;
      }
      if (this.rateCardData.linkedinHandle && !this.rateCardData.linkedinFollowerCount) {
        this.$swal({
          text: 'Please enter Followers (Connections)!',
          type: 'warning'
        });
        return;
      }
      if (this.rateCardData.twitterHandle && !this.rateCardData.twitterFollowerCount) {
        this.$swal({
          text: 'Please enter X (Twitter) Followers Count!',
          type: 'warning'
        });
        return;
      }
      var followerRequirements = [['facebook', 'Facebook'], ['youtube', 'YouTube'], ['twitch', 'Twitch']];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(followerRequirements), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref = _step2.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var platform = _ref2[0];
          var label = _ref2[1];

          if (this.rateCardData[platform + 'Handle'] && !this.rateCardData[platform + 'FollowerCount']) {
            this.$swal({
              text: 'Please enter ' + label + ' Followers Count!',
              type: 'warning'
            });
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.showAgreementModal = true;
    },
    confirmSave: function confirmSave() {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var formData;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 6;
                    break;
                  }

                  _this2.submitting = true;
                  formData = _this2.constructData();
                  _context.next = 5;
                  return _this2.$store.dispatch('influencer/saveRateCard', formData);

                case 5:
                  if (_this2.savedRateCard) {
                    _this2.submitting = false;

                    _this2.$swal({
                      text: 'Rate Card ' + (_this2.rateCardData.id ? 'Updated' : 'Submitted'),
                      type: 'success'
                    }).then(function (result) {
                      if (_this2.rateCardData.id) {
                        _this2.$emit('updated');
                      } else {
                        _this2.$router.push({ path: '/client' });
                      }
                    });
                  } else {
                    _this2.submitting = false;
                    _this2.$swal({
                      text: 'Error saving rate card form.',
                      type: 'error'
                    });
                  }

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    constructData: function constructData() {
      var _this3 = this;

      var saveData = __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.refreshJSON(this.rateCardData);
      saveData.instagramHandle = saveData.instagramHandle ? __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.regexMatchIg(saveData.instagramHandle, __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].regexPattern.instagram_profile)) : '';
      saveData.tiktokHandle = saveData.tiktokHandle ? __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* default */].func.extractTikTokHandle(saveData.tiktokHandle)) : '';
      saveData.linkedinHandle = this.extractPlatformHandle(saveData.linkedinHandle, 'linkedin');
      saveData.twitterHandle = this.extractPlatformHandle(saveData.twitterHandle, 'twitter');
      saveData.facebookHandle = this.extractPlatformHandle(saveData.facebookHandle, 'facebook');
      saveData.youtubeHandle = this.extractPlatformHandle(saveData.youtubeHandle, 'youtube');
      saveData.twitchHandle = this.extractPlatformHandle(saveData.twitchHandle, 'twitch');
      saveData.platforms = (saveData.platforms || []).filter(function (platform) {
        var key = _this3.normalizePlatformKey(platform.platform);
        return key && !['linkedin', 'twitter', 'facebook', 'youtube', 'twitch'].includes(key);
      });
      saveData.contactNo = '' + this.countryCode + saveData.contactNo;
      var formData = new FormData();
      formData.append('data', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(saveData));
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(this.deckFiles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var val = _step3.value;

          formData.append('uploadFile', val);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return formData;
    },
    updatePricingDecks: function updatePricingDecks(medias) {
      this.deckFiles = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], medias);
    },
    addPlatform: function addPlatform(fieldName) {
      this.rateCardData[fieldName].push({
        platform: '',
        url: '',
        rate: '',
        rateCurrency: 'SGD'
      });
    },
    changeDate: function changeDate() {
      this.$refs.datePicker.save(this.rateCardData.dateOfBirth);
    },
    changeCountry: function changeCountry() {
      var _this4 = this;

      var optionOne = this.dialCodes.find(function (o) {
        return o.cn === _this4.rateCardData.country;
      });
      if (optionOne) {
        this.countryCode = optionOne.dc;
      }
      this.rateCardData.city = '';

      this.citiesByCountry = [];
      var selectedCities = __WEBPACK_IMPORTED_MODULE_18__static_sources_cities___default.a[this.rateCardData.country];
      if (Array.isArray(selectedCities)) {
        this.citiesByCountry = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()([], selectedCities);
      }
    },
    getLang: function getLang(attr) {
      return this.langs[this.selectedLang][attr] || this.langs.en[attr] || '';
    },
    updateCategories: function updateCategories(newValue) {
      this.categories = __WEBPACK_IMPORTED_MODULE_13__influencerHelper__["a" /* default */].getCategories(newValue);
    },
    setLangParam: function setLangParam() {
      var queries = this.$route.query;
      queries.lang = this.selectedLang;
      this.$router.replace({ query: queries });
    },
    changeLang: function changeLang() {
      this.setLangParam();
    },
    onlyForNumber: function onlyForNumber($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    savedRateCard: function savedRateCard(state) {
      return state.influencer.savedRateCard;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isCreateMode: function isCreateMode() {
      return !this.mode;
    },
    isEditMode: function isEditMode() {
      return this.mode === 'edit';
    },
    hasStandaloneMediaHandle: function hasStandaloneMediaHandle() {
      return Boolean(this.rateCardData.instagramHandle || this.rateCardData.tiktokHandle || this.rateCardData.linkedinHandle || this.rateCardData.twitterHandle || this.rateCardData.facebookHandle || this.rateCardData.youtubeHandle || this.rateCardData.twitchHandle);
    }
  }),
  mounted: function mounted() {
    if (this.$route.query.lang) {
      this.selectedLang = this.$route.query.lang;
    }
    if (this.$route.query.name) {
      this.rateCardData.name = this.$route.query.name;
    }
    if (this.$route.query.email) {
      this.rateCardData.email = this.$route.query.email;
    }
    if (this.$route.query.influencerID) {
      this.rateCardData.influencerID = this.$route.query.influencerID;
    }
    if (!this.rateCardData.platforms.length) {
      this.addPlatform('platforms');
    }

    this.countries = __WEBPACK_IMPORTED_MODULE_17__static_sources_countries___default.a;
    this.countries = this.countries.map(function (c) {
      return c.name;
    });
    this.changeCountry();
    this.updateCategories(this.selectedLang);
    this.setLangParam();
  }
});

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_FilePreview__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_FilePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_FilePreview__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RateCardPreview',
  components: {
    FilePreview: __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_FilePreview___default.a
  },
  props: ['data', 'type']
});

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(143);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Influencer-Terms-Modal',
  props: {
    dialogTitle: String,
    value: Boolean,
    selectedLang: String
  },
  data: function data() {
    return {
      termsAndConditions: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].rateCardTermsAndCondition,
      showContractModal: false,
      agreement: '',
      valid: true,
      alert: false
    };
  },

  methods: {
    agree: function agree() {
      this.$emit('termsAggrement', true);
      this.$emit('input');
    },
    disagree: function disagree() {
      this.$emit('input');
    },
    getLang: function getLang() {
      this.$emit('getLang');
    }
  }
});

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewModalDialog',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_0__components_scoped_custom_SocialHandle___default.a,
    FilePreview: __WEBPACK_IMPORTED_MODULE_1__components_scoped_custom_FilePreview___default.a,
    RateCardForm: __WEBPACK_IMPORTED_MODULE_2__Form___default.a
  },
  props: {
    value: Boolean,
    data: Object,
    rateCardDialog: Boolean
  },
  data: function data() {
    return {
      openExpansion: [0, 1],
      campaignVerticals: [],
      currentMode: 'detail',
      editData: null,
      utils: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue) {
        this.currentMode = 'detail';
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },
    changeMode: function changeMode(mode) {
      var _this = this;

      this.currentMode = mode;
      setTimeout(function () {
        _this.editData = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.refreshJSON(_this.data);
      }, 100);
    },
    updatedRateCardForm: function updatedRateCardForm() {
      this.close();
      this.$emit('updated');
    },
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    },
    getPlatformKey: function getPlatformKey(platform) {
      var key = String(platform || '').trim().toLowerCase();
      return key === 'x' || key === 'x (twitter)' ? 'twitter' : key;
    },
    getPlatformLabel: function getPlatformLabel(platform) {
      var key = this.getPlatformKey(platform);
      if (key === 'linkedin') return 'LinkedIn';
      if (key === 'twitter') return 'X (Twitter)';
      return platform;
    },
    getPlatformEntry: function getPlatformEntry(data, platform) {
      var _this2 = this;

      var keys = platform === 'twitter' ? ['twitter', 'x', 'x (twitter)'] : [platform];
      return (data.platforms || []).find(function (item) {
        return keys.includes(_this2.getPlatformKey(item.platform));
      }) || null;
    },
    getStandaloneHandle: function getStandaloneHandle(data, platform) {
      var directHandle = data[platform + 'Handle'];
      if (directHandle) return String(directHandle).replace(/^@/, '');
      var entry = this.getPlatformEntry(data, platform);
      if (!entry || !entry.url) return '';
      var cleanUrl = String(entry.url).replace(/[?#].*$/, '').replace(/\/+$/, '');
      var segments = cleanUrl.split('/').filter(Boolean);
      return decodeURIComponent(segments[segments.length - 1] || '').replace(/^@/, '');
    },
    getStandaloneRate: function getStandaloneRate(data, platform, rateType) {
      var rates = rateType === 'preferential' ? data.preferentialRates : data.ordinaryRates;
      if (rates && rates[platform]) return rates[platform];
      if (rateType === 'ordinary') {
        var entry = this.getPlatformEntry(data, platform);
        return entry && entry.rate;
      }
      return 0;
    },
    getStandaloneCurrency: function getStandaloneCurrency(data, platform, rateType) {
      var rates = rateType === 'preferential' ? data.preferentialRates : data.ordinaryRates;
      if (rates && rates[platform + 'Currency']) return rates[platform + 'Currency'];
      var entry = this.getPlatformEntry(data, platform);
      return entry && entry.rateCurrency || 'SGD';
    },
    getOtherPlatforms: function getOtherPlatforms(data) {
      var _this3 = this;

      return (data.platforms || []).filter(function (item) {
        return !['linkedin', 'twitter', 'facebook', 'youtube', 'twitch'].includes(_this3.getPlatformKey(item.platform));
      });
    },
    transPreferredEng: function transPreferredEng(keyword) {
      var categoryEn = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('en');
      var categoryTh = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('th');
      var categoryVn = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('vn');
      var categoryId = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('id');
      var categoryCn = __WEBPACK_IMPORTED_MODULE_3__influencerHelper__["a" /* default */].getCategories('cn');
      var matchIdx = -1;
      matchIdx = categoryTh.findIndex(function (c) {
        return c === keyword;
      });
      if (matchIdx < 0) {
        matchIdx = categoryVn.findIndex(function (c) {
          return c === keyword;
        });
      }
      if (matchIdx < 0) {
        matchIdx = categoryId.findIndex(function (c) {
          return c === keyword;
        });
      }
      if (matchIdx < 0) {
        matchIdx = categoryCn.findIndex(function (c) {
          return c === keyword;
        });
      }
      if (matchIdx >= 0) {
        return categoryEn[matchIdx];
      }
      return keyword;
    }
  }
});

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataTable__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(11);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Brand Fact Sheet',
  components: {
    RateCardDataTable: __WEBPACK_IMPORTED_MODULE_7__DataTable___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      rateCardLink: '',
      rateCardCopied: false,
      importLoading: false,
      importItems: [],
      viewID: null,
      isRefresh: 0,
      isDownload: 0
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isAdmin: function isAdmin() {
      return this.currentUserRole === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    }
  },
  methods: {
    copyLink: function copyLink() {
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.rateCardLink = protocol + '//' + host + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].RATE_CARD_FORM_URL;
      var vm = this;
      setTimeout(function () {
        vm.rateCardCopied = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.copyToClipboard('#copy-link');
      }, 100);
      setTimeout(function () {
        vm.rateCardCopied = false;
      }, 1000);
    },
    reload: function reload() {
      this.isRefresh += 1;
    },
    download: function download() {
      this.isDownload += 1;
    },
    importFileUpload: function importFileUpload(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var uploadedFiles, uploadResp, importItems;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.importLoading = true;
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context.next = 5;
                  break;
                }

                _this.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context.abrupt('return');

              case 5:
                _context.next = 7;
                return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var fr = new FileReader();
                  fr.onload = function (e) {
                    var tmp = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* default */].func.parserToJson(e.target.result);
                    resolve(tmp);
                  };
                  fr.readAsArrayBuffer(e.target.files[0]);
                  fr.onerror = reject;
                });

              case 7:
                uploadResp = _context.sent;

                if (uploadResp.length) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                importItems = [];

                if (uploadResp.length > 1) {
                  importItems = uploadResp[1];
                } else {
                  importItems = uploadResp[0];
                }
                _this.uploadRateCard(importItems);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    uploadRateCard: function uploadRateCard(importItems) {
      var _this2 = this;

      if (importItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Imported Rate Card Found'
        });
        return;
      }

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        importItems: importItems
      });
      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].importRateCard(data).then(function (resp) {
        _this2.importLoading = false;

        var success = resp.success;
        var fails = resp.failed;
        var htmlTxt = 'Successfully Imported.';
        if (success) {
          htmlTxt += '<br>Success: ' + success;
        }
        if (Array.isArray(fails) && fails.length > 0) {
          htmlTxt += '<br>Failed Rows at: ' + fails.join(', ');
        }
        _this2.$swal({
          title: 'Success',
          icon: 'info',
          html: htmlTxt
        });
        _this2.reload();
      }).catch(function (err) {
        _this2.importLoading = false;
        console.error(err);
        _this2.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Failed to Import Influencers'
        });
      });
      this.$refs.rateCardFileInput.value = null;
    },
    downloadSampleUpload: function downloadSampleUpload() {
      var link = document.createElement('a');

      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_ratecard_template.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RateCard_config__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__AudienceDataReportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Pairing_PairedCreators_CampaignListsModal__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Pairing_PairedCreators_CampaignListsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Pairing_PairedCreators_CampaignListsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RateCard_ViewModalDialog__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__RateCard_ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__RateCard_ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Pairing_PairedCreators_AddTagModal__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Pairing_PairedCreators_AddTagModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Pairing_PairedCreators_AddTagModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Campaign_StatisticsAnalysis_ViewModalDialog__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Campaign_StatisticsAnalysis_ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Campaign_StatisticsAnalysis_ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ViewInfluencerModal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ViewInfluencerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ViewInfluencerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ProfileTally_ViewModalDialog__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ProfileTally_ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ProfileTally_ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_moment__);



































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchCreators',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_27__components_scoped_custom_SocialHandle___default.a,
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_19__AudienceDataReportModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_TableColsShowHideModal___default.a,
    CampaignListsModal: __WEBPACK_IMPORTED_MODULE_21__Pairing_PairedCreators_CampaignListsModal___default.a,
    RatecardViewModalDialog: __WEBPACK_IMPORTED_MODULE_22__RateCard_ViewModalDialog___default.a,
    AddTagModal: __WEBPACK_IMPORTED_MODULE_23__Pairing_PairedCreators_AddTagModal___default.a,
    ViewInfluencerModal: __WEBPACK_IMPORTED_MODULE_25__ViewInfluencerModal___default.a,
    ViewTravelModal: __WEBPACK_IMPORTED_MODULE_26__ProfileTally_ViewModalDialog___default.a,
    ViewStatsModal: __WEBPACK_IMPORTED_MODULE_24__Campaign_StatisticsAnalysis_ViewModalDialog___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_28_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_29__utils__["a" /* default */].func,
      platformLists: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].platformLists,
      types: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].types,
      headers: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].tableHeaders,
      defaultCols: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].defaultCols,
      infTiers: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].influencerTiers,
      customSlots: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].customSlots,
      campaignStatuses: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].campaignStatus,
      campaignStage: __WEBPACK_IMPORTED_MODULE_14__Campaign_config__["a" /* default */].campaignStage,
      campaignTypeDisplayFilter: __WEBPACK_IMPORTED_MODULE_14__Campaign_config__["a" /* default */].campaignTypeDisplay,
      ageGroupDisplayFilter: ['13-17', '18-24', '25-34', '35-44', '45-64', '65+'],
      campaignVerticals: [],
      infCategories: [],
      countries: [],
      currencyOptions: __WEBPACK_IMPORTED_MODULE_15__RateCard_config__["a" /* default */].currencyOptions,
      filtersExpanded: false,
      rateFilterMenu: false,
      platformOptions: [{
        text: 'Any',
        value: '',
        icon: 'mdi-apps',
        iconColor: '#616161'
      }, {
        text: 'Instagram',
        value: 'instagram',
        icon: 'mdi-instagram',
        iconColor: '#E1306C'
      }, {
        text: 'TikTok',
        value: 'tiktok',
        imgIcon: '/static/img/tiktok.svg'
      }, {
        text: 'Youtube',
        value: 'youtube',
        icon: 'mdi-youtube',
        iconColor: '#FF0000'
      }, {
        text: 'LinkedIn',
        value: 'linkedin',
        icon: 'mdi-linkedin',
        iconColor: '#0A66C2'
      }, {
        text: 'X (Twitter)',
        value: 'twitter',
        imgIcon: '/static/img/x-logo.svg'
      }, {
        text: 'Xiaohongshu',
        value: 'xiaohongshu',
        imgIcon: '/static/img/xhs-black.png'
      }],
      filters: {
        keyword: '',
        platform: '',
        tags: [],
        tagHandles: [],
        gender: '',
        tier: '',
        country: [],
        dateOfBirth: '',
        infCategory: [],
        vertical: '',
        campaignType: '',
        ageGroup: '',
        age: '',
        imsOnly: false,
        rateCardOnly: false,
        pairedCreatorOnly: false,
        travelFormOnly: false,
        travelCountry: [],
        travelDate: '',
        validityCheck: false,
        campaign: '',
        contentType: '',
        rateCurrency: '',
        rate: { from: '', to: '' }
      },
      dateOfBirthCal: false,
      travelDateCal: false,
      loading: false,
      filteredItems: [],
      selectedLists: [],
      allCampaigns: [],
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [],
        itemsPerPage: 20
      },
      genderOptions: [{ text: 'All', value: '' }, { text: 'Male', value: 'Male' }, { text: 'Female', value: 'Female' }],
      sortColumns: [{
        text: 'IG followers',
        value: 'instagramFollowers'
      }, {
        text: 'TikTok followers',
        value: 'tiktokFollowers'
      }, {
        text: 'Youtube followers',
        value: 'youtubeFollowers'
      }, {
        text: 'XHS followers',
        value: 'xhsFollowers'
      }, {
        text: 'Past Campaigns',
        value: 'campaignsCount'
      }, {
        text: 'Last Updated',
        value: 'updatedAt'
      }],
      sortTypes: ['Ascending', 'Descending'],
      sort: {
        column: 'updatedAt',
        type: 'Descending'
      },
      totalItems: 0,
      shouldCallApi: false,
      importLoading: false,
      audienceDataReport: null,
      viewAudienceDataDialog: false,
      colSettingsDialog: false,
      colStatuses: {},
      userProfile: {},
      viewCampaigns: [],
      viewHandle: '',
      viewCampaignListsDialog: false,
      addTagDialog: false,
      rateCardViewData: null,
      rateCardViewDialog: false,
      editTagItem: null,
      viewInfluencerDialog: false,
      viewInfluencerData: null,
      viewTravelData: null,
      viewTravelDialog: false,
      viewStatsDialog: false,
      isCcRemarks: false,
      contentTypes: [{ title: 'IG Story', value: 'igStory', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Post', value: 'igPost', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Carousel', value: 'igCarousel', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Video', value: 'igVideo', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG Reel', value: 'igReel', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'IG TV', value: 'igTv', icon: 'mdi-instagram', iconColor: '#E1306C' }, { title: 'Loading Fee', value: 'loadingFee', icon: 'mdi-cloud-upload-outline', iconColor: '#607D8B' }, { title: 'Event Appearance', value: 'eventAppearance', icon: 'mdi-calendar-star', iconColor: '#FF8F00' }, { title: 'TikTok', value: 'tiktok', imgIcon: '/static/img/tiktok.svg' }, { title: 'YouTube Post', value: 'youtube', icon: 'mdi-youtube', iconColor: '#FF0000' }, { title: 'Facebook Post', value: 'facebook', icon: 'mdi-facebook', iconColor: '#1877F2' }, { title: 'LinkedIn Post', value: 'linkedin', icon: 'mdi-linkedin', iconColor: '#0A66C2' }, { title: 'X (Twitter) Post', value: 'twitter', imgIcon: '/static/img/x-logo.svg' }, { title: 'Twitch Post', value: 'twitch', icon: 'mdi-twitch', iconColor: '#9146FF' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    importedCreators: function importedCreators(state) {
      return state.influencer.importedCreators;
    },
    importedCreatorDtl: function importedCreatorDtl(state) {
      return state.influencer.importedCreatorDtl;
    },
    importedCreatorGenres: function importedCreatorGenres(state) {
      return state.influencer.importedCreatorGenres;
    },
    importedCreatorCols: function importedCreatorCols(state) {
      return state.influencer.importedCreatorCols;
    },
    savedImportedCreator: function savedImportedCreator(state) {
      return state.influencer.savedImportedCreator;
    },
    socialDataErrMsg: function socialDataErrMsg(state) {
      return state.influencer.socialDataErrMsg;
    },
    allTags: function allTags(state) {
      return state.influencer.allTags;
    },
    allAssignedTags: function allAssignedTags(state) {
      return state.influencer.allAssignedTags;
    },
    assignedTags: function assignedTags(state) {
      return state.influencer.assignedTags;
    }
  }), {
    computedHeaders: function computedHeaders() {
      var _this = this;

      var searchCreatorsCols = null;

      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.searchCreatorsCols) {
          searchCreatorsCols = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.userProfile.tableSettings.searchCreatorsCols);
        }
      }
      this.headers.map(function (header) {
        if (_this.defaultCols.includes(header.value)) {
          _this.colStatuses[header.value] = true;
        }
      });
      if (searchCreatorsCols) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(searchCreatorsCols)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            this.colStatuses[key] = searchCreatorsCols[key];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return this.headers.filter(function (h) {
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    activeFilterCount: function activeFilterCount() {
      var _this2 = this;

      var ignored = ['keyword', 'tagHandles', 'rate'];
      var count = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(this.filters).reduce(function (total, key) {
        if (ignored.includes(key)) return total;
        var value = _this2.filters[key];
        if (Array.isArray(value)) return total + (value.length ? 1 : 0);
        return total + (value !== '' && value !== false && value !== null ? 1 : 0);
      }, 0);
      if (this.filters.rate && (this.filters.rate.from || this.filters.rate.to)) count++;
      return count;
    },
    rateFilterLabel: function rateFilterLabel() {
      var parts = [];
      if (this.filters.contentType) {
        var selectedValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.filters.contentType) === 'object' ? this.filters.contentType.value : this.filters.contentType;
        var contentType = this.contentTypes.find(function (item) {
          return item.value === selectedValue;
        });
        var selectedLabel = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.filters.contentType) === 'object' ? this.filters.contentType.title || this.filters.contentType.text || selectedValue : selectedValue;
        parts.push(contentType ? contentType.title : selectedLabel);
      }
      if (this.filters.rateCurrency) parts.push(this.filters.rateCurrency);
      if (this.filters.rate && (this.filters.rate.from || this.filters.rate.to)) {
        var from = this.filters.rate.from || 'Any';
        var to = this.filters.rate.to || 'Any';
        parts.push(from + ' - ' + to);
      }
      return parts.join(' · ');
    },
    payload: function payload() {
      return {
        filter: this.filters,
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.sort.column || '',
          sortOrder: this.sort.type === 'Ascending' ? 1 : -1
        }
      };
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isAdminRole: function isAdminRole() {
      var role = Number(this.$store.state.user.role);
      return role === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || role === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW || role === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || role === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH;
    },
    isSuperAdmin: function isSuperAdmin() {
      var role = Number(this.$store.state.user.role);
      return role === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || role === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW;
    }
  }),
  watch: {
    pagination: function pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    },

    filters: {
      handler: function handler(newVal, oldValue) {
        if (newVal.vertical || newVal.campaignType) {
          this.filters.pairedCreatorOnly = true;
        }
        if (!newVal.vertical && !newVal.campaignType) {
          this.filters.pairedCreatorOnly = false;
        }
      },

      deep: true
    }
  },
  methods: {
    applyRateFilter: function applyRateFilter() {
      if (this.filters.contentType && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(this.filters.contentType) === 'object') {
        this.filters.contentType = this.filters.contentType.value || '';
      }
      this.rateFilterMenu = false;
      this.paginate();
    },
    clearRateFilter: function clearRateFilter() {
      this.filters.contentType = '';
      this.filters.rateCurrency = '';
      this.filters.rate = { from: '', to: '' };
      this.rateFilterMenu = false;
      this.paginate();
    },
    getLinkedInHandle: function getLinkedInHandle(item) {
      var linkedIn = item.linkedin && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.linkedin) === 'object' ? item.linkedin : {};
      return item.linkedinHandle || linkedIn.linkedinHandle || linkedIn.handle || '';
    },
    getTwitterHandle: function getTwitterHandle(item) {
      var twitter = item.twitter && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.twitter) === 'object' ? item.twitter : {};
      return item.twitterHandle || twitter.twitterHandle || twitter.handle || '';
    },
    getLinkedInFollowers: function getLinkedInFollowers(item) {
      var linkedIn = item.linkedin && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.linkedin) === 'object' ? item.linkedin : {};
      var value = item.linkedinFollowers !== undefined && item.linkedinFollowers !== null ? item.linkedinFollowers : linkedIn.totalFollowers;
      return value !== undefined && value !== null && value !== '' ? Number(value) : null;
    },
    getTwitterFollowers: function getTwitterFollowers(item) {
      var twitter = item.twitter && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(item.twitter) === 'object' ? item.twitter : {};
      var value = item.twitterFollowers !== undefined && item.twitterFollowers !== null ? item.twitterFollowers : twitter.totalFollowers;
      return value !== undefined && value !== null && value !== '' ? Number(value) : null;
    },
    paginate: function paginate() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var handles;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.currentPage = page;
                _this3.payload.paging.page = page;
                _this3.payload.export = false;
                _this3.loading = true;

                _this3.filters.tagHandles = [];

                if (!_this3.filters.tags.length) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return _this3.$store.dispatch('influencer/getAssignedTags', {
                  filters: {
                    tags: _this3.filters.tags
                  }
                });

              case 8:
                handles = _this3.assignedTags.map(function (a) {
                  return a.handle;
                });

                _this3.filters.tagHandles = handles;

              case 10:
                _context.next = 12;
                return _this3.$store.dispatch('influencer/getImportedCreators', _this3.payload);

              case 12:
                if (_this3.importedCreators) {
                  _this3.beautifyData();
                  _this3.setRemarks();
                  _this3.totalItems = _this3.importedCreators.totalInfluencers;
                  if (_this3.pagination.itemsPerPage === -1) {
                    _this3.pagination.itemsPerPage = 20;
                  }
                  _this3.shouldCallApi = true;
                }
                _this3.loading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    beautifyData: function beautifyData() {
      var _this4 = this;

      this.filteredItems = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], this.importedCreators.influencers);
      this.filteredItems = this.filteredItems.map(function (f) {
        f.genre = _this4.getGenreArr(f.genre);
        var matchTag = _this4.allAssignedTags.find(function (a) {
          if (a.handle === f.instagram && a.platform === 'instagram') return true;
          if (a.handle === f.tiktok && a.platform === 'tiktok') return true;
          if (a.handle === f.youtube && a.platform === 'youtube') return true;
          if (a.handle === f.xiaohongshu && a.platform === 'xhs') return true;
          return false;
        });
        if (matchTag) {
          f.tags = matchTag.names;
          f.tagStr = f.tags.join(', ');
        }
        f.emailEdit = false;
        return f;
      });
    },
    setRemarks: function setRemarks() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, handle, resPairing, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, resp;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 3;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(_this5.filteredItems);

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 39;
                  break;
                }

                item = _step2.value;
                handle = '';

                if (item.instagram) {
                  handle = item.instagram;
                }
                if (item.tiktok) {
                  handle = item.tiktok;
                }
                if (item.youtube) {
                  handle = item.youtube;
                }
                if (item.xiaohongshu) {
                  handle = item.xiaohongshu;
                }
                item.ccRemarksCount = 0;
                _context2.next = 15;
                return __WEBPACK_IMPORTED_MODULE_18__Pairing_pairingAPIs__["a" /* default */].getPairingsByHandle(handle);

              case 15:
                resPairing = _context2.sent;

                if (!resPairing) {
                  _context2.next = 36;
                  break;
                }

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context2.prev = 20;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(resPairing); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  resp = _step3.value;

                  if (resp.additional_details) {
                    if (resp.additional_details.remarks) {
                      item.ccRemarksCount += 1;
                    }
                  }
                }
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](20);
                _didIteratorError3 = true;
                _iteratorError3 = _context2.t0;

              case 28:
                _context2.prev = 28;
                _context2.prev = 29;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 31:
                _context2.prev = 31;

                if (!_didIteratorError3) {
                  _context2.next = 34;
                  break;
                }

                throw _iteratorError3;

              case 34:
                return _context2.finish(31);

              case 35:
                return _context2.finish(28);

              case 36:
                _iteratorNormalCompletion2 = true;
                _context2.next = 5;
                break;

              case 39:
                _context2.next = 45;
                break;

              case 41:
                _context2.prev = 41;
                _context2.t1 = _context2['catch'](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t1;

              case 45:
                _context2.prev = 45;
                _context2.prev = 46;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 48:
                _context2.prev = 48;

                if (!_didIteratorError2) {
                  _context2.next = 51;
                  break;
                }

                throw _iteratorError2;

              case 51:
                return _context2.finish(48);

              case 52:
                return _context2.finish(45);

              case 53:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[3, 41, 45, 53], [20, 24, 28, 36], [29,, 31, 35], [46,, 48, 52]]);
      }))();
    },
    setGenreFilters: function setGenreFilters() {
      var _this6 = this;

      this.infCategories = [];
      this.importedCreatorGenres.map(function (item) {
        if (item.name) {
          _this6.infCategories.push(item.name);
        }
      });
    },
    setImportedCreatorCols: function setImportedCreatorCols() {
      var _this7 = this;

      this.headers = [];
      this.importedCreatorCols.map(function (ipt) {
        _this7.headers.push({
          text: ipt,
          value: ipt,
          align: 'start'
        });
      });
      this.headers.push({
        text: 'createdAt',
        value: 'createdAt',
        align: 'start'
      }, {
        text: 'actions',
        value: 'actions',
        align: 'start'
      });
    },
    setAccountValidity: function setAccountValidity() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, influencer, igResp, tiktokResp, youtubeResp;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this8.filters.validityCheck) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _this8.importLoading = true;
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context3.prev = 6;
                _iterator4 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(_this8.filteredItems);

              case 8:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context3.next = 50;
                  break;
                }

                influencer = _step4.value;

                if (!influencer.instagram) {
                  _context3.next = 23;
                  break;
                }

                _context3.prev = 11;
                igResp = null;
                _context3.next = 15;
                return fetch('http://instagram.com/' + influencer.instagram);

              case 15:
                igResp = _context3.sent;

                if (igResp) {
                  influencer.igCheck = true;
                }
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3['catch'](11);

                influencer.igCheck = false;
                console.log(_context3.t0);

              case 23:
                if (!influencer.tiktok) {
                  _context3.next = 35;
                  break;
                }

                _context3.prev = 24;
                _context3.next = 27;
                return fetch('https://www.tiktok.com/@' + influencer.tiktok);

              case 27:
                tiktokResp = _context3.sent;

                if (tiktokResp) {
                  influencer.tiktokCheck = true;
                }
                _context3.next = 35;
                break;

              case 31:
                _context3.prev = 31;
                _context3.t1 = _context3['catch'](24);

                influencer.tiktokCheck = false;
                console.log(_context3.t1);

              case 35:
                if (!influencer.youtube) {
                  _context3.next = 47;
                  break;
                }

                _context3.prev = 36;
                _context3.next = 39;
                return fetch('https://www.youtube.com/@' + influencer.tiktok);

              case 39:
                youtubeResp = _context3.sent;

                if (youtubeResp) {
                  influencer.youtubeCheck = true;
                }
                _context3.next = 47;
                break;

              case 43:
                _context3.prev = 43;
                _context3.t2 = _context3['catch'](36);

                influencer.youtubeCheck = false;
                console.log(_context3.t2);

              case 47:
                _iteratorNormalCompletion4 = true;
                _context3.next = 8;
                break;

              case 50:
                _context3.next = 56;
                break;

              case 52:
                _context3.prev = 52;
                _context3.t3 = _context3['catch'](6);
                _didIteratorError4 = true;
                _iteratorError4 = _context3.t3;

              case 56:
                _context3.prev = 56;
                _context3.prev = 57;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 59:
                _context3.prev = 59;

                if (!_didIteratorError4) {
                  _context3.next = 62;
                  break;
                }

                throw _iteratorError4;

              case 62:
                return _context3.finish(59);

              case 63:
                return _context3.finish(56);

              case 64:
                _this8.importLoading = false;
                _this8.filters.validityCheck = false;
                _this8.filteredItems = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], _this8.filteredItems);

              case 67:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[6, 52, 56, 64], [11, 19], [24, 31], [36, 43], [57,, 59, 63]]);
      }))();
    },
    removeCategory: function removeCategory(item) {
      this.filters.infCategory.splice(this.filters.infCategory.indexOf(item), 1);
      this.filters.infCategory = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.filters.infCategory));
    },
    remove: function remove(item) {
      this.filters.country.splice(this.filters.country.indexOf(item), 1);
      this.filters.country = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.filters.country));
      this.paginate();
    },
    removeTravelCountry: function removeTravelCountry(item) {
      this.filters.travelCountry.splice(this.filters.travelCountry.indexOf(item), 1);
      this.filters.travelCountry = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.filters.travelCountry));
      this.paginate();
    },
    getTypeText: function getTypeText(type) {
      if (type === 'agency') return 'Agency';
      if (type === 'direct') return 'Direct';
      return '';
    },
    showReport: function showReport(item) {
      var _this9 = this;

      var platformParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.importLoading = true;
      var availInf = this.getInfHandleByPlatform(item, platformParam);
      var infID = availInf.infID;
      var platform = availInf.platform;
      var handle = availInf.handle;
      __WEBPACK_IMPORTED_MODULE_16__influencerAPIs__["a" /* default */].fetchLocalAudienceReport(infID, null, handle, platform).then(function (resp) {
        _this9.audienceDataReport = resp.data;
        _this9.viewAudienceDataDialog = true;
        _this9.importLoading = false;
      }).catch(function (err) {
        console.error(err);
      });
    },
    showLoadingEvent: function showLoadingEvent(status) {
      this.importLoading = status;
    },
    getIMSInfToView: function getIMSInfToView(item) {
      var availInf = this.getInfHandlePlatform(item);
      var infID = availInf.infID;
      window.open('/influencers?id=' + infID, '_blank');
    },
    getAllInfToView: function getAllInfToView(item) {
      var handle = '';
      var platform = '';
      if (item.instagram) {
        handle = item.instagram;
        platform = 'instagram';
      } else if (item.tiktok) {
        handle = item.tiktok;
        platform = 'tiktok';
      } else if (item.youtube) {
        handle = item.youtube;
        platform = 'youtube';
      }
      window.open('/all-influencers?handle=' + handle + '&platform=' + platform, '_blank');
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      var dynamicHeaders = this.headers;
      if (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        dynamicHeaders.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(dynamicHeaders)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref = _step5.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                columns = _this10.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this10.userProfile.tableSettings) {
                  tableSettings = _this10.userProfile.tableSettings;
                }
                tableSettings.searchCreatorsCols = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = {
                  id: _this10.currentUserID,
                  tableSettings: tableSettings
                };
                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_17__User_userAPIs__["a" /* default */].editUser(updateData);

              case 8:
                _this10.colStatuses = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, columns);
                _this10.colSettingsDialog = false;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    getInfHandlePlatform: function getInfHandlePlatform(item) {
      var infID = item.influencerID || null;
      var platform = null;
      var handle = null;
      if (item.instagram) {
        handle = item.instagram;
        platform = 'instagram';
      } else if (item.tiktok) {
        handle = item.tiktok;
        platform = 'tiktok';
      } else if (item.youtube) {
        infID = item.youtube;
        handle = item.youtube;
        platform = 'youtube';
      }
      return {
        infID: infID,
        platform: platform,
        handle: handle
      };
    },
    getInfHandleByPlatform: function getInfHandleByPlatform(item) {
      var platformParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var infID = item.influencerID || null;
      var platform = null;
      var handle = null;
      if (platformParam === 'instagram') {
        handle = item.instagram;
        platform = 'instagram';
      } else if (platformParam === 'tiktok') {
        handle = item.tiktok;
        platform = 'tiktok';
      } else if (platformParam === 'youtube') {
        handle = item.youtube;
        platform = 'youtube';
      }
      return {
        infID: infID,
        platform: platform,
        handle: handle
      };
    },
    getUserProfile: function getUserProfile() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_17__User_userAPIs__["a" /* default */].getUser(_this11.currentUserID);

              case 2:
                resp = _context5.sent;

                if (resp && resp.id) {
                  _this11.userProfile = resp;
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    downloadSampleUpload: function downloadSampleUpload() {
      var link = document.createElement('a');

      link.setAttribute('download', 'sample_creator_bulkupload');
      link.href = '/static/sample/sample_creator_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    igHandleBulkUpload: function igHandleBulkUpload(e) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var uploadedFiles, handles;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                uploadedFiles = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
                  return e.target.files[i];
                });

                if (!(!uploadedFiles || uploadedFiles.length === 0)) {
                  _context6.next = 4;
                  break;
                }

                _this12.$swal({
                  type: 'info',
                  text: 'No file uploaded'
                });
                return _context6.abrupt('return');

              case 4:
                _context6.next = 6;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var fr = new FileReader();
                  fr.onload = function (e) {
                    var tmp = __WEBPACK_IMPORTED_MODULE_29__utils__["a" /* default */].func.parserToJson(e.target.result);
                    resolve(tmp);
                  };
                  fr.readAsArrayBuffer(e.target.files[0]);
                  fr.onerror = reject;
                });

              case 6:
                handles = _context6.sent;

                if (handles.length) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt('return');

              case 9:
                _this12.uploadBulkHandle(handles[0]);

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this12);
      }))();
    },
    uploadBulkHandle: function uploadBulkHandle(handleItems) {
      var _this13 = this;

      this.importLoading = true;
      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Influencer Handle Found'
        });
        return;
      }

      var data = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, {
        handleItems: handleItems
      });
      __WEBPACK_IMPORTED_MODULE_16__influencerAPIs__["a" /* default */].importInfluencers(data).then(function (resp) {
        _this13.importLoading = false;

        var success = resp.success;
        var fails = resp.failed;
        var htmlTxt = 'Successfully Imported.';
        if (success) {
          htmlTxt += '<br>Success: ' + success;
        }
        if (Array.isArray(fails) && fails.length > 0) {
          htmlTxt += '<br>Failed Rows at: ' + fails.join(', ');
        }
        _this13.$swal({
          title: 'Success',
          icon: 'info',
          html: htmlTxt
        });
        _this13.paginate(_this13.currentPage);
      }).catch(function (err) {
        _this13.importLoading = false;
        console.error(err);
        _this13.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: 'Failed to Import Influencers'
        });
      });
      this.$refs.igBulkHandle.value = null;
    },
    deleteInf: function deleteInf(item) {
      var _this14 = this;

      this.$swal({
        title: 'Confirm',
        text: 'Are you sure to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(result) {
          var payload;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!result.value) {
                    _context7.next = 6;
                    break;
                  }

                  _this14.importLoading = true;
                  payload = {
                    items: [{
                      id: item._id
                    }]
                  };
                  _context7.next = 5;
                  return _this14.$store.dispatch('influencer/deleteImportedCreator', payload);

                case 5:
                  if (_this14.importedCreators) {
                    _this14.importLoading = false;
                    _this14.$swal({
                      title: 'Successfully Deleted!',
                      type: 'success'
                    });
                    _this14.paginate();
                  }

                case 6:
                case 'end':
                  return _context7.stop();
              }
            }
          }, _callee7, _this14);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    deleteMultipleInf: function deleteMultipleInf() {
      var _this15 = this;

      this.$swal({
        title: 'Confirm',
        text: 'Are you sure to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8(result) {
          var payload;
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!result.value) {
                    _context8.next = 7;
                    break;
                  }

                  _this15.importLoading = true;
                  payload = {
                    items: []
                  };

                  _this15.selectedLists.map(function (s) {
                    payload.items.push({
                      id: s._id
                    });
                  });
                  _context8.next = 6;
                  return _this15.$store.dispatch('influencer/deleteImportedCreator', payload);

                case 6:
                  if (_this15.importedCreators) {
                    _this15.importLoading = false;
                    _this15.$swal({
                      title: 'Successfully Deleted!',
                      type: 'success'
                    });
                    _this15.selectedLists = [];
                    _this15.paginate();
                  }

                case 7:
                case 'end':
                  return _context8.stop();
              }
            }
          }, _callee8, _this15);
        }));

        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    fetchIQData: function fetchIQData(item, platform) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var payload, updateItemIdx;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this16.importLoading = true;
                payload = {
                  id: item._id,
                  platform: platform
                };
                _context9.next = 4;
                return _this16.$store.dispatch('influencer/fetchIQDataImportedCreator', payload);

              case 4:
                _this16.importLoading = false;
                if (_this16.importedCreatorDtl) {
                  updateItemIdx = _this16.filteredItems.findIndex(function (fi) {
                    return fi._id === item._id;
                  });

                  if (updateItemIdx !== -1) {
                    _this16.filteredItems[updateItemIdx] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, _this16.importedCreatorDtl);
                    _this16.filteredItems = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], _this16.filteredItems);
                  }
                  _this16.$swal({
                    title: 'Successfully Fetched!',
                    type: 'success'
                  });
                } else {
                  _this16.$swal({
                    title: _this16.socialDataErrMsg,
                    type: 'warning'
                  });
                }

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this16);
      }))();
    },
    selectAllLists: function selectAllLists($event) {
      if (!$event.value) {
        this.selectedLists = [];
        return;
      }
      this.selectedLists = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], this.filteredItems);
    },
    getImportedCreatorGenres: function getImportedCreatorGenres() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this17.$store.dispatch('influencer/getImportedCreatorGenres');

              case 2:
                _this17.setGenreFilters();

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this17);
      }))();
    },
    getImportedCreatorsCols: function getImportedCreatorsCols() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this18.$store.dispatch('influencer/getImportedCreatorsCols');

              case 2:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this18);
      }))();
    },
    getAllCampaigns: function getAllCampaigns() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this19.$store.dispatch('campaign/getCampaigns', {
                  filters: {
                    defaultAll: true
                  }
                });

              case 2:
                _this19.allCampaigns = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()([], _this19.campaigns);
                _this19.allCampaigns = _this19.allCampaigns.map(function (element) {
                  return {
                    name: element.name,
                    fullName: element.ioNumbers ? element.ioNumbers + ' - ' + element.name : element.name,
                    id: element.id
                  };
                });

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this19);
      }))();
    },
    openCampaignListsModal: function openCampaignListsModal(item) {
      var _this20 = this;

      var isRemark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var pairings, campaignIDs, handle, resp, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, pairing;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this20.importLoading = true;
                _this20.isCcRemarks = false;
                pairings = [];
                campaignIDs = [];
                handle = '';

                if (item.instagram) {
                  handle = item.instagram;
                }
                if (item.tiktok) {
                  handle = item.tiktok;
                }
                if (item.youtube) {
                  handle = item.youtube;
                }
                if (item.xiaohongshu) {
                  handle = item.xiaohongshu;
                }
                _context13.next = 11;
                return __WEBPACK_IMPORTED_MODULE_18__Pairing_pairingAPIs__["a" /* default */].getPairingsByHandle(handle);

              case 11:
                resp = _context13.sent;

                if (!resp) {
                  _context13.next = 35;
                  break;
                }

                pairings.push.apply(pairings, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(resp));
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context13.prev = 17;
                for (_iterator6 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(pairings); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  pairing = _step6.value;

                  campaignIDs.push(pairing.campaignID);
                }
                _context13.next = 25;
                break;

              case 21:
                _context13.prev = 21;
                _context13.t0 = _context13['catch'](17);
                _didIteratorError6 = true;
                _iteratorError6 = _context13.t0;

              case 25:
                _context13.prev = 25;
                _context13.prev = 26;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 28:
                _context13.prev = 28;

                if (!_didIteratorError6) {
                  _context13.next = 31;
                  break;
                }

                throw _iteratorError6;

              case 31:
                return _context13.finish(28);

              case 32:
                return _context13.finish(25);

              case 33:
                _context13.next = 36;
                break;

              case 35:
                if (item.distinctCampaigns) {
                  campaignIDs = item.distinctCampaigns;
                }

              case 36:
                _this20.viewHandle = handle;
                _this20.viewCampaigns = _this20.allCampaigns.filter(function (c) {
                  return campaignIDs.includes(c.id);
                });

                _this20.viewCampaigns = _this20.viewCampaigns.map(function (v) {
                  var matchPairing = pairings.find(function (p) {
                    if (p.influencer_details) {
                      if (p.influencer_details.instagramHandle) {
                        if (p.campaignID === v.id && p.influencer_details.instagramHandle === handle) {
                          return true;
                        }
                      }
                    }
                    return false;
                  });
                  if (matchPairing) {
                    if (matchPairing.additional_details) {
                      v.ccRemarks = matchPairing.additional_details.remarks || '';
                    }
                    v.deliverables = matchPairing.deliverables_details;
                    v.payout = matchPairing.payout_details.amount;
                    v.pairingDate = matchPairing.createdAt ? __WEBPACK_IMPORTED_MODULE_32_moment___default()(matchPairing.createdAt).format('DD-MM-YYYY') : '';
                  }
                  return v;
                });
                _this20.emptyCampaigns = Number(item.campaignsCount) - _this20.viewCampaigns.length;
                _this20.setShowCampaignVerticals();
                _this20.viewCampaignListsDialog = true;
                _this20.importLoading = false;
                if (isRemark) {
                  _this20.viewCampaigns = _this20.viewCampaigns.filter(function (v) {
                    return v.ccRemarks;
                  });
                  _this20.isCcRemarks = true;
                }

              case 44:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this20, [[17, 21, 25, 33], [26,, 28, 32]]);
      }))();
    },
    setShowCampaignVerticals: function setShowCampaignVerticals() {
      var _this21 = this;

      this.viewCampaigns = this.viewCampaigns.map(function (v) {
        if (v.vertical && v.vertical.length > 0) {
          v.showVerticals = v.vertical.map(function (vt) {
            return vt.name;
          }).join(', ');
        } else {
          v.showVerticals = '-';
        }
        v.campaignStatusDisplay = _this21.getStageName(v.status);
        return v;
      });
    },
    getStageName: function getStageName(status) {
      if (status === this.campaignStatuses.DRAFT || status === this.campaignStatuses.PENDING_CLIENT_APPROVAL) {
        return this.campaignStage.ACTIVATING;
      } else if (status === this.campaignStatuses.PAIRING_BRIEF || status === this.campaignStatuses.PAIRING_INFLUENCER || status === this.campaignStatuses.RATE_CARD) {
        return this.campaignStage.PAIRING;
      } else if (status === this.campaignStatuses.ONGOING) {
        return this.campaignStage.COCREATING;
      } else {
        return this.campaignStage.COMPLETE;
      }
    },
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    },
    getAllTags: function getAllTags() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this22.$store.dispatch('influencer/getAllTags');

              case 2:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this22);
      }))();
    },
    getAllAssignedTags: function getAllAssignedTags() {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _this23.$store.dispatch('influencer/getAllAssignedTags');

              case 2:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this23);
      }))();
    },
    showAddTagDialog: function showAddTagDialog(post) {
      this.addTagDialog = true;
      if (post.instagram) {
        post.userHandle = post.instagram;
        post.platform = 'instagram';
      } else if (post.tiktok) {
        post.userHandle = post.tiktok;
        post.platform = 'tiktok';
      } else if (post.youtube) {
        post.userHandle = post.youtube;
        post.platform = 'youtube';
      } else if (post.xiaohongshu) {
        post.userHandle = post.xiaohongshu;
        post.platform = 'xhs';
      }
      this.editTagItem = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, post);
    },
    saveTagProcess: function saveTagProcess(tags) {
      var _this24 = this;

      var matchIdx = this.filteredItems.findIndex(function (f) {
        return f.id === _this24.editTagItem.id;
      });
      if (matchIdx !== -1) {
        this.filteredItems[matchIdx].tags = tags;
      }
    },
    getRateCardDataToView: function getRateCardDataToView(item) {
      if (!item) return;
      if (!item.preferentialRates) {
        item.preferentialRates = {};
      }
      if (!item.ordinaryRates) {
        item.ordinaryRates = {
          igStory: item.igStory || 0,
          igStoryCurrency: 'SGD',
          igPost: item.igPost || 0,
          igPostCurrency: 'SGD',
          igCarousel: item.igCarousel || 0,
          igCarouselCurrency: 'SGD',
          igVideo: item.igVideo || 0,
          igVideoCurrency: 'SGD',
          igReel: item.igReel || 0,
          igReelCurrency: 'SGD',
          igTv: item.igTv || 0,
          igTvCurrency: 'SGD',
          loadingFee: item.loadingFee || 0,
          loadingFeeCurrency: 'SGD',
          eventAppearance: item.eventAppearance || 0,
          eventAppearanceCurrency: 'SGD',
          tiktok: item.tiktok || 0,
          tiktokCurrency: 'SGD'
        };
      }
      if (!item.keywords) item.keywords = [];
      if (!item.mainCategories) item.mainCategories = [];
      if (!item.subCategories) item.subCategories = [];
      this.rateCardViewData = item;
      this.rateCardViewDialog = true;
    },
    getGenreArr: function getGenreArr(genres) {
      if (typeof genres === 'string') {
        genres = genres.split(',');
      }
      return genres;
    },
    reload: function reload() {
      this.filters = {
        keyword: '',
        platform: '',
        tags: [],
        tagHandles: [],
        gender: '',
        tier: '',
        dateOfBirth: '',
        vertical: '',
        campaignType: '',
        ageGroup: '',
        age: '',
        country: [],
        infCategory: [],
        imsOnly: false,
        rateCardOnly: false,
        pairedCreatorOnly: false,
        travelFormOnly: false,
        travelCountry: [],
        travelDate: '',
        validityCheck: false,
        campaign: '',
        contentType: '',
        rateCurrency: '',
        rate: { from: '', to: '' }
      };
      this.paginate();
    },
    getInfluencerDataToView: function getInfluencerDataToView(influencerID, infItem) {
      var _this25 = this;

      __WEBPACK_IMPORTED_MODULE_16__influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (response) {
        var influencerUserData = _this25.users.find(function (u) {
          return u.influencerID === response.id;
        });
        if (influencerUserData) {
          response.userID = influencerUserData.id || '';
          response.firstName = influencerUserData.firstName || '';
          response.lastName = influencerUserData.lastName || '';
        }
        if (infItem) {
          if (infItem.travelForm) {
            response.travelForm = infItem.travelForm;
            delete response.travelForm._id;
            delete response.travelForm.influencerID;
          }
        }
        _this25.viewInfluencerData = response;
        _this25.viewInfluencerDialog = true;
      }).catch(function (error) {
        console.log('error', error);
        if (error.response && error.response.status === 404) {
          _this25.$swal({
            title: 'Warning!',
            icon: 'warning',
            text: 'IMS Influencer Not Found'
          });
        }
      });
    },
    getTravelDataToView: function getTravelDataToView(item) {
      this.viewTravelData = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_assign___default()({}, item.travelForm);
      this.viewTravelDialog = true;
    },
    getUsers: function getUsers() {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return __WEBPACK_IMPORTED_MODULE_17__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userRoles.INFLUENCER);

              case 2:
                response = _context16.sent;

                if (response) {
                  _this26.users = response.users;
                }

              case 4:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this26);
      }))();
    },
    exportExcel: function exportExcel() {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _this27.importLoading = true;
                _this27.payload.export = true;
                __WEBPACK_IMPORTED_MODULE_16__influencerAPIs__["a" /* default */].downloadSearchCreatorRpt(_this27.payload).then(function () {
                  _this27.importLoading = false;
                }).catch(function (error) {
                  _this27.importLoading = false;
                  console.log('error in downloading search creator report', error);
                });

              case 3:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this27);
      }))();
    },
    getCampaignVerticals: function getCampaignVerticals() {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var vResp;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return __WEBPACK_IMPORTED_MODULE_31__Campaign_campaignAPIs__["a" /* default */].getAllCampaignVerticals(false);

              case 2:
                vResp = _context18.sent;

                _this28.campaignVerticals = vResp.data;

              case 4:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this28);
      }))();
    },
    changeImportedCreatorEdit: function changeImportedCreatorEdit(colName, item, status) {
      var matchItemIdx = this.filteredItems.findIndex(function (f) {
        return f._id === item._id;
      });
      if (matchItemIdx !== -1) {
        this.filteredItems[matchItemIdx][colName] = status;
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_29__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      }
    },
    updateImportedCreator: function updateImportedCreator(item, field) {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var updateIC, matchItemIdx;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this29.importLoading = true;
                updateIC = [{
                  id: item._id,
                  email: item[field]
                }];
                _context19.next = 4;
                return _this29.$store.dispatch('influencer/updateImportedCreatorByIds', updateIC);

              case 4:
                if (_this29.savedImportedCreator) {
                  matchItemIdx = _this29.filteredItems.findIndex(function (f) {
                    return f._id === item._id;
                  });

                  if (matchItemIdx !== -1) {
                    _this29.filteredItems[matchItemIdx][field] = item[field];
                    _this29.filteredItems = __WEBPACK_IMPORTED_MODULE_29__utils__["a" /* default */].func.refreshJSON(_this29.filteredItems);
                    if (_this29.filteredItems[matchItemIdx][field + 'Edit']) {
                      _this29.filteredItems[matchItemIdx][field + 'Edit'] = false;
                    }
                  }
                }
                _this29.importLoading = false;

              case 6:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this29);
      }))();
    },
    cancelDOB: function cancelDOB() {
      this.dateOfBirthCal = false;
    },
    okDOB: function okDOB() {
      this.dateOfBirthCal = false;
      this.paginate();
    },
    cancelTravelDate: function cancelTravelDate() {
      this.travelDateCal = false;
    },
    okTravelDate: function okTravelDate() {
      this.travelDateCal = false;
      this.paginate();
    },
    viewStatsAnalysis: function viewStatsAnalysis(item) {
      var handle = '';
      if (item.instagram) {
        handle = item.instagram;
      } else {
        if (item.tiktok) {
          handle = item.tiktok;
        }
        if (item.youtube) {
          handle = item.youtube;
        }
      }
      if (!handle) {
        this.$swal({
          type: 'info',
          text: 'Handle Not Found.'
        });
        return;
      }
      this.viewHandle = handle;
      this.viewStatsDialog = true;
    }
  },
  mounted: function mounted() {
    var _this30 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee20() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _this30.infTiers.unshift({
                text: 'All Tiers',
                value: ''
              });

              _this30.countries = __WEBPACK_IMPORTED_MODULE_30__static_sources_countries___default.a;
              _this30.countries = _this30.countries.map(function (c) {
                return c.name;
              });
              _this30.getAllTags();
              _this30.getAllAssignedTags();
              _this30.getImportedCreatorGenres();
              _this30.getImportedCreatorsCols();
              _this30.paginate();
              _this30.getAllCampaigns();
              _context20.next = 11;
              return _this30.getUserProfile();

            case 11:
              _this30.getUsers();
              _this30.getCampaignVerticals();

            case 13:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this30);
    }))();
  }
});

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-creators',
  components: {
    SearchCreatorsDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  props: ['refresh'],
  data: function data() {
    return {
      isRefresh: 1
    };
  },

  methods: {}
});

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContentAnalysis_contentAnalysisAPI__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AudienceDataReportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InfluencerPostsModal__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InfluencerPostsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InfluencerPostsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_influencer_InfluencerSearchBox__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_influencer_InfluencerSearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scoped_influencer_InfluencerSearchBox__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchKeyword',
  components: {
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_9__AudienceDataReportModal___default.a,
    InfluencerPostModal: __WEBPACK_IMPORTED_MODULE_10__InfluencerPostsModal___default.a,
    KInfluencerSearchBox: __WEBPACK_IMPORTED_MODULE_11__scoped_influencer_InfluencerSearchBox___default.a
  },
  data: function data() {
    return {
      audienceDataReportId: 'audience_data_report_modal',
      influencerPostModalId: 'influencerPostModalId',
      viewAudienceDataDialog: false,
      viewInfluencerData: null,
      audienceDataReport: null,
      expand: false,
      loading: false,
      peformSearch: 'none',
      pagination: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['postCreatedDate'],
        sortDesc: [true]
      },
      totalItems: 0,
      rowsPerPageItems: [10, 20, 50, 100],
      originalItems: [],
      postsTitle: '',
      avatarSize: 45,
      shortCodes: [],
      fields: [{
        text: 'Avatar',
        value: 'profilePicture',
        sortable: false
      }, {
        value: 'instagramHandle',
        text: 'Handle',
        sortable: false
      }, {
        value: 'totalFollowers',
        text: 'Followers',
        sortable: true
      }, {
        value: 'engagementRate',
        text: 'Engagement Rate',
        sortable: true,
        width: '60px'
      }, {
        value: 'audienceCredibility',
        text: 'Audience Credibility',
        sortable: true,
        width: '60px'
      }, {
        value: 'relevancyScore',
        text: 'Relevancy Score',
        sortable: true
      }, {
        value: 'tag',
        text: 'Tag',
        sortable: false
      }, {
        value: 'postCreatedDate',
        text: 'Post Created Date',
        sortable: true
      }, {
        value: 'action',
        text: 'Actions',
        sortable: false
      }],
      items: [],
      igPostItems: [],
      summary: null,
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      resultMessage: '',
      display: 1
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.lastUpdate).fromNow();
    },
    audienceDataReportDisplay: function audienceDataReportDisplay() {
      return '#' + this.audienceDataReportId;
    },
    influencerPostDisplay: function influencerPostDisplay() {
      return '#' + this.influencerPostModalId;
    },
    paginationLength: function paginationLength() {
      var round = this.totalItems / this.pagination.itemsPerPage;
      var decimal = this.totalItems % this.pagination.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    }
  },
  watch: {
    pagination: function pagination() {
      if (this.peformSearch !== 'none') {
        this.currentPage = this.pagination.page;
        this.searchByKeywords();
      }
    },
    display: function display(newVal) {
      if (newVal === 0) {
        this.cardSearchByKeywords();
      }
    }
  },
  methods: {
    searchByKeywords: function searchByKeywords() {
      this.items = [];

      this.loading = true;
      this.peformSearch = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.makeid(5);
    },
    cardSearchByKeywords: function cardSearchByKeywords() {
      this.display = 0;
      this.items = [];

      this.loading = true;
      this.currentPage = this.pagination.page;
      this.peformSearch = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.makeid(5);
    },
    searchDone: function searchDone(value) {
      this.loading = false;
      if (value.success) {
        this.items = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], value.originalItems);
        this.success = value.summary;
        this.totalItems = value.totalItems;
        this.paginate();
      } else {
        if (value.nokeyword) {} else {
          this.$swal({
            title: 'Could not load data',
            text: 'Oop!! There are something wrong',
            type: 'error'
          });
        }
      }
    },
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    paginate: function paginate() {
      var page = this.pagination.page;

      this.currentPage = page;

      this.updateItems(this.items);
      this.paserImageUrl();
      if (this.display === 0) {
        this.getInstagramPost();
      }
    },
    sort: function sort(sortBy, descending) {
      var _this = this;

      var sortCriteria = '';
      switch (sortBy) {
        case 'totalFollowers':
          sortCriteria = 'instagram.totalFollowers';
          break;
        case 'engagementRate':
          sortCriteria = 'audience.user_profile.engagement_rate';
          break;
        case 'audienceCredibility':
          sortCriteria = 'audience.audience_followers.data.audience_credibility';
          break;
        case 'relevancyScore':
          sortCriteria = 'relevancyScore';
          break;
        default:
          sortCriteria = 'relevancyScore';
      }
      this.items.sort(function (a, b) {
        var prev = _this.getValueByPath(a, sortCriteria);
        var last = _this.getValueByPath(b, sortCriteria);
        if (descending) {
          return last > prev ? 1 : last < prev ? -1 : 0;
        }
        return last > prev ? -1 : last > prev ? 1 : 0;
      });
    },
    getValueByPath: function getValueByPath(obj, path) {
      var val = obj;
      var paths = path.split('.');
      paths.forEach(function (p) {
        if (val) val = val[p];
      });
      return Number(val || 0);
    },
    updateItems: function updateItems(response) {
      var _this2 = this;

      var displayItems = response.map(function (element) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ id: element.id }, {
          instagramHandle: element.instagram ? element.instagram.instagramHandle : null,
          instagramID: element.instagram ? element.instagram.instagramID : null,
          instagramFullname: element.fullName || element.instagram ? element.instagram.instagramFullname : null,
          totalFollowers: element.instagram ? element.instagram.totalFollowers : 0,
          totalFollowing: element.instagram ? element.instagram.totalFollowing : 0,
          joinedAt: _this2.formatTime(element.createdAt),
          posts: element.posts || [],
          audience: element.audience || {},
          profilePicture: element.audience && element.audience.user_profile ? element.audience.user_profile.picture || '/static/img/avatar/user.png' : '/static/img/avatar/user.png',
          instagram: element.instagram || {},
          gender: element.gender,
          birthday: element.birthday || 'None',
          email: element.email || 'None',
          mailingAddress: element.mailingAddress || 'None',
          bankAccount: element.bankAccount || 'None',
          bankName: element.bankName || 'None',
          country: element.country || 'None',
          relevancyScore: element.relevancyScore,
          tags: element.keywords || [],
          engagementRate: element.audience && element.audience.user_profile ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2) : 0,
          audienceCredibility: element.audience && element.audience.audience_followers ? Number(element.audience.audience_followers.data.audience_credibility * 100).toFixed(2) : 0,
          postCreatedDate: element.post_information ? _this2.formatPostTime(element.post_information.post_created_time) : '',
          postShortCode: element.posts ? element.posts[0].shortCode : ''
        });
      });
      this.items = [];
      displayItems.map(function (d) {
        var exists = _this2.items.find(function (ig) {
          return ig.postShortCode === d.postShortCode;
        });
        if (!exists) {
          _this2.items.push(d);
        }
      });
      this.totalRows = response.totalInfluencers;

      this.searchedItems = displayItems;
    },
    viewInfluencerPosts: function viewInfluencerPosts(item) {
      var posts = item.posts || [];
      if (posts.length > 0) {
        this.shortCodes = posts.map(function (item) {
          return item.shortCode;
        });
        document.getElementById('viewPosts').click();
        this.postsTitle = 'Related Posts(' + item.instagramHandle + ')';
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    showReport: function showReport(influencer) {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_7__influencerAPIs__["a" /* default */].fetchLocalAudienceReport(null, influencer.instagramID, influencer.instagramHandle).then(function (resp) {
        _this3.audienceDataReport = resp.data;

        _this3.viewAudienceDataDialog = true;
        _this3.loading = false;
      }).catch(function (err) {
        console.error(err);
        _this3.loading = false;
      });
    },
    exportInfluencers: function exportInfluencers() {
      __WEBPACK_IMPORTED_MODULE_7__influencerAPIs__["a" /* default */].exportAllInfluencers().then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'influencers_' + __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('X') + '.csv');
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        console.log(error);
      });
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatPostTime: function formatPostTime(value) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(parseInt(value)).format('DD-MM-YYYY');
    },
    paserImageUrl: function paserImageUrl() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this4.items);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 19;
                  break;
                }

                item = _step.value;
                _context.prev = 7;
                _context.next = 10;
                return fetch(item.profilePicture);

              case 10:
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](7);

                console.error(_context.t0);
                item.profilePicture = '/static/img/avatar/user.png';

              case 16:
                _iteratorNormalCompletion = true;
                _context.next = 5;
                break;

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 25:
                _context.prev = 25;
                _context.prev = 26;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 28:
                _context.prev = 28;

                if (!_didIteratorError) {
                  _context.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context.finish(28);

              case 32:
                return _context.finish(25);

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[3, 21, 25, 33], [7, 12], [26,, 28, 32]]);
      }))();
    },
    getInstagramPost: function getInstagramPost() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.loading = true;
                _this5.igPostItems = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 5;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this5.items);

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 14;
                  break;
                }

                item = _step2.value;

                if (!item.posts.length) {
                  _context3.next = 11;
                  break;
                }

                return _context3.delegateYield(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var post, shortCode, data, exists;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          post = item.posts[0];
                          shortCode = post.shortCode;
                          _context2.next = 4;
                          return __WEBPACK_IMPORTED_MODULE_8__ContentAnalysis_contentAnalysisAPI__["a" /* default */].oembed(shortCode);

                        case 4:
                          data = _context2.sent;

                          setTimeout(function () {
                            window.instgrm.Embeds.process();
                          }, 100);
                          item.igPost = data.oembed;
                          if (item.igPost) {
                            exists = _this5.igPostItems.find(function (ig) {
                              return ig.postShortCode === shortCode;
                            });

                            if (!exists) {
                              _this5.igPostItems.push(item);
                            }
                          }

                        case 8:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this5);
                })(), 't0', 11);

              case 11:
                _iteratorNormalCompletion2 = true;
                _context3.next = 7;
                break;

              case 14:
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t1 = _context3['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t1;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 23:
                _context3.prev = 23;

                if (!_didIteratorError2) {
                  _context3.next = 26;
                  break;
                }

                throw _iteratorError2;

              case 26:
                return _context3.finish(23);

              case 27:
                return _context3.finish(20);

              case 28:
                _this5.loading = false;

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[5, 16, 20, 28], [21,, 23, 27]]);
      }))();
    }
  },
  created: function created() {}
});

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_signature_pad__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TermsAndConditions__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TermsAndConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__TermsAndConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Contract_Influencer_contract__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Campaign_PairingInfluencer_UpdateSubmissionDateModal__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Campaign_PairingInfluencer_UpdateSubmissionDateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Campaign_PairingInfluencer_UpdateSubmissionDateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__config_logoDataURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_pdfmake_build_pdfmake_js__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateSigningForm',
  components: {
    TermsAndConditions: __WEBPACK_IMPORTED_MODULE_13__TermsAndConditions___default.a,
    UpdateSubmissionDateModal: __WEBPACK_IMPORTED_MODULE_15__Campaign_PairingInfluencer_UpdateSubmissionDateModal___default.a
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func,
      campaign: {},
      displayData: {},
      logoDataUrl: __WEBPACK_IMPORTED_MODULE_16__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png',
      valid: true,
      signaturePad: null,
      errors: {
        signature: false
      },
      submitting: false,
      showRowSpan: '',
      viewPairingData: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    saved: function saved(state) {
      return state.pairing.saved;
    },
    pairingDetails: function pairingDetails(state) {
      return state.pairing.pairingDetails;
    }
  }), {
    secondaryColor: function secondaryColor() {
      return this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.currentTheme && this.$vuetify.theme.currentTheme.secondary ? this.$vuetify.theme.currentTheme.secondary : '#3F3FFF';
    },
    getRowSpanCount: function getRowSpanCount() {
      this.rowSpanCount = 0;
      if (this.pairingDetails.deliverables_details.no_of_carousels > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_igTv > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_tiktok_posts > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_xhs_posts > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_fb_posts > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_posts > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_stories > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_video > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_reels > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_li_posts > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.no_of_x_posts > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.youtube > 0) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.loading_whitelisting) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.exclusivity) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.physical_attendance) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.online_attendance) this.rowSpanCount++;
      if (this.pairingDetails.deliverables_details.custom) this.rowSpanCount += this.pairingDetails.deliverables_details.custom.length;
      return this.rowSpanCount;
    },
    chkPayoutGST: function chkPayoutGST() {
      var payout = this.pairingDetails.payout_details.amount;

      if (this.pairingDetails.payout_details && this.pairingDetails.payout_details.boostingFees && Array.isArray(this.pairingDetails.payout_details.boostingFees)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.pairingDetails.payout_details.boostingFees), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var boostingFee = _step.value;

            payout -= Number(boostingFee.value) || 0;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      if (this.pairingDetails.payout_details.GST) {
        return payout - this.pairingDetails.payout_details.GSTpercent;
      } else {
        return payout;
      }
    }
  }),
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.resetError();
      if (this.signaturePad.isEmpty()) {
        this.errors.signature = true;
      }
      if (!this.pairingDetails.pairing_details.submission_date) {
        this.$swal({
          text: 'Please update submission date.',
          type: 'info'
        });
        return;
      }

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var contractFileBlocks, pdfDocGenerator, contractFile, formData;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 18;
                    break;
                  }

                  _this.submitting = true;
                  _context.next = 4;
                  return _this.generateContract();

                case 4:
                  contractFileBlocks = _context.sent;
                  pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_17_pdfmake_build_pdfmake_js__["createPdf"](__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.refreshJSON(contractFileBlocks));
                  _context.next = 8;
                  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
                    pdfDocGenerator.getDataUrl(function (dataUrl) {
                      var response = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.dataURLtoFile(dataUrl, _this.pairingDetails.influencer_details.instagramHandle + '_Signin_Form.pdf');
                      resolve(response);
                    });
                  });

                case 8:
                  contractFile = _context.sent;
                  formData = new FormData();

                  formData.append('pairingID', _this.pairingDetails.id);
                  formData.append('signature', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this.signaturePad.toData()));
                  formData.append('contractFileBlocks', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(contractFileBlocks));
                  formData.append('contractFile', contractFile);
                  _context.next = 16;
                  return _this.$store.dispatch('pairing/saveSignInForm', formData);

                case 16:
                  _this.submitting = false;
                  if (_this.saved) {
                    _this.$swal({
                      text: 'Successfully Saved Sign in Form.',
                      type: 'success'
                    }).then(function (result) {
                      window.location.replace('/');
                    });
                  } else {
                    _this.$swal({
                      text: 'Error Saving Sign in Form.',
                      type: 'error'
                    });
                  }

                case 18:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    clearSignature: function clearSignature() {
      this.signaturePad.clear();
    },
    resetError: function resetError() {
      this.errors = {
        signature: false
      };
    },
    todayDate: function todayDate() {
      return this.utils.formatCustomDate(__WEBPACK_IMPORTED_MODULE_11_moment___default()(), 'DD/MM/YYYY');
    },
    generateContract: function generateContract() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tableBody, contractTemplate, xHandle, customDeliverables, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref2, _ref3, index, obj;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tableBody = [];
                contractTemplate = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].func.refreshJSON(__WEBPACK_IMPORTED_MODULE_14__Contract_Influencer_contract__["a" /* default */]);

                contractTemplate.header.text = 'Date: ' + _this2.dateFormat(Date.now());
                contractTemplate.defaultStyle = { font: 'Arial' };

                if (_this2.pairingDetails.influencer_details.platform === 'tiktok') {
                  contractTemplate.content[2].table.body[1][0].text = 'TikTok Handle: ' + _this2.pairingDetails.influencer_details.instagramHandle;
                } else if (_this2.pairingDetails.influencer_details.platform === 'instagram') {
                  contractTemplate.content[2].table.body[1][0].text = 'Instagram Handle: ' + _this2.pairingDetails.influencer_details.instagramHandle;
                } else if (_this2.pairingDetails.influencer_details.platform === 'youtube') {
                  contractTemplate.content[2].table.body[1][0].text = 'Youtube Handle: ' + _this2.pairingDetails.influencer_details.instagramHandle;
                } else if (_this2.pairingDetails.influencer_details.platform === 'xiaohongshu') {
                  contractTemplate.content[2].table.body[1][0].text = 'Xiaohongshu Handle: ' + _this2.pairingDetails.influencer_details.fullName;
                } else if (_this2.pairingDetails.influencer_details.platform === 'twitter') {
                  xHandle = _this2.pairingDetails.influencer_details.twitterHandle || _this2.pairingDetails.influencer_details.userHandle || _this2.pairingDetails.influencer_details.instagramHandle;

                  contractTemplate.content[2].table.body[1][0].text = 'X (Twitter) Handle: ' + xHandle;
                } else if (_this2.pairingDetails.influencer_details.platform === 'others') {
                  contractTemplate.content[2].table.body[1][0].text = _this2.pairingDetails.influencer_details.platformName + ' Handle: ' + _this2.pairingDetails.influencer_details.fullName;
                } else {
                  contractTemplate.content[2].table.body[1][0].text = 'Platform Handle: ' + _this2.pairingDetails.influencer_details.instagramHandle;
                }

                contractTemplate.content[4].table.body[1][0].text = _this2.displayData.campaignName;

                contractTemplate.content[4].table.body[2][0].text = 'Campaign Ref: ' + _this2.pairingDetails.campaignID;

                tableBody.push([{ text: 'DESCRIPTION', style: 'tableHeader', alignment: 'center' }, { text: 'QTY', style: 'tableHeader', alignment: 'center' }, { text: 'AMOUNT', style: 'tableHeader', alignment: 'center' }]);

                if (!_this2.pairingDetails.deliverables_details) {
                  _context2.next = 46;
                  break;
                }

                if (_this2.pairingDetails.deliverables_details.no_of_stories) {
                  tableBody.push(['IG Story', { text: _this2.pairingDetails.deliverables_details.no_of_stories, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_stories') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_xhs_posts) {
                  tableBody.push(['XHS Post', { text: _this2.pairingDetails.deliverables_details.no_of_xhs_posts, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_xhs_posts') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_fb_posts) {
                  tableBody.push(['FB Post', { text: _this2.pairingDetails.deliverables_details.no_of_fb_posts, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_fb_posts') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_tiktok_posts) {
                  tableBody.push(['TikTok Post', { text: _this2.pairingDetails.deliverables_details.no_of_tiktok_posts, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_tiktok_posts') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_posts) {
                  tableBody.push(['IG Post', { text: _this2.pairingDetails.deliverables_details.no_of_posts, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_posts') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_carousels) {
                  tableBody.push(['IG Carousel', { text: _this2.pairingDetails.deliverables_details.no_of_carousels, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_carousels') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_video > 0) {
                  tableBody.push(['IG Video', { text: _this2.pairingDetails.deliverables_details.no_of_video, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_video') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_igTv > 0) {
                  tableBody.push(['IG TV', { text: _this2.pairingDetails.deliverables_details.no_of_igTv, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_igTv') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_reels > 0) {
                  tableBody.push(['IG Reel', { text: _this2.pairingDetails.deliverables_details.no_of_reels, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_reels') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_li_posts > 0) {
                  tableBody.push(['LinkedIn Post', { text: _this2.pairingDetails.deliverables_details.no_of_li_posts, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_li_posts') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.no_of_x_posts > 0) {
                  tableBody.push(['X (Twitter) Post', { text: _this2.pairingDetails.deliverables_details.no_of_x_posts, alignment: 'center' }, _this2.checkShowAmountRowSpan('no_of_x_posts') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.youtube > 0) {
                  tableBody.push(['Youtube', { text: _this2.pairingDetails.deliverables_details.youtube, alignment: 'center' }, _this2.checkShowAmountRowSpan('youtube') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.loading_whitelisting) {
                  tableBody.push(['Loading/Whitelisting', { text: _this2.pairingDetails.deliverables_details.loading_whitelisting, alignment: 'center' }, _this2.checkShowAmountRowSpan('loading_whitelisting') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.exclusivity) {
                  tableBody.push(['Exclusivity', { text: _this2.pairingDetails.deliverables_details.exclusivity, alignment: 'center' }, _this2.checkShowAmountRowSpan('exclusivity') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.physical_attendance > 0) {
                  tableBody.push(['Physical Attendance', { text: _this2.pairingDetails.deliverables_details.physical_attendance, alignment: 'center' }, _this2.checkShowAmountRowSpan('physical_attendance') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                if (_this2.pairingDetails.deliverables_details.online_attendance > 0) {
                  tableBody.push(['Online Attendance', { text: _this2.pairingDetails.deliverables_details.online_attendance, alignment: 'center' }, _this2.checkShowAmountRowSpan('online_attendance') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }

                if (!(_this2.pairingDetails.deliverables_details.custom && _this2.pairingDetails.deliverables_details.custom.length > 0)) {
                  _context2.next = 46;
                  break;
                }

                customDeliverables = _this2.pairingDetails.deliverables_details.custom;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 30;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(customDeliverables.entries()); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _ref2 = _step2.value;
                  _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                  index = _ref3[0];
                  obj = _ref3[1];

                  console.log(index);
                  tableBody.push([obj.label, { text: obj.value, alignment: 'center' }, _this2.checkShowAmountRowSpan('custom') ? { rowSpan: _this2.getRowSpanCount, text: _this2.formatPayout(_this2.chkPayoutGST), alignment: 'center', margin: 10 } : '']);
                }
                _context2.next = 38;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t0 = _context2['catch'](30);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 38:
                _context2.prev = 38;
                _context2.prev = 39;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 41:
                _context2.prev = 41;

                if (!_didIteratorError2) {
                  _context2.next = 44;
                  break;
                }

                throw _iteratorError2;

              case 44:
                return _context2.finish(41);

              case 45:
                return _context2.finish(38);

              case 46:
                if (_this2.pairingDetails.GST) {
                  tableBody.push(['GST', { text: 1, alignment: 'center' }, { rowSpan: 1, text: _this2.formatPayout(_this2.pairingDetails.GSTpercent), alignment: 'center', margin: 10 }]);
                }
                if (_this2.pairingDetails.deliverableNotes) {
                  tableBody.push([{ colSpan: 3, text: _this2.pairingDetails.deliverableNotes, alignment: 'left' }]);
                }
                if (_this2.pairingDetails.pairing_details) {
                  if (_this2.pairingDetails.pairing_details.deliverable_notes) {
                    tableBody.push([{ colSpan: 3, text: _this2.pairingDetails.pairing_details.deliverable_notes, alignment: 'left' }]);
                  }
                }
                tableBody.push([{ border: [false, true, false, false], text: '' }, { fillColor: _this2.secondaryColor, color: 'white', colSpan: 2, rowSpan: 1, text: 'TOTAL: ' + _this2.formatPayout(_this2.pairingDetails.payout_details.amount || 0), alignment: 'center' }]);
                contractTemplate.content[5].table.body = tableBody;
                if (_this2.pairingDetails.pairing_details && _this2.pairingDetails.pairing_details.remarks) {
                  contractTemplate.content.splice(6, 0, {
                    margin: [0, 20, 0, 0],
                    table: {
                      widths: ['100%'],
                      body: [[{ text: 'Remarks', style: 'tableHeader', alignment: 'left' }], [{ text: _this2.pairingDetails.pairing_details.remarks, border: [true, true, true, true] }]]
                    }
                  });
                }
                contractTemplate.content.push({
                  text: '',
                  margin: [0, 20, 0, 0]
                });
                contractTemplate.content.push({
                  image: _this2.signaturePad.toDataURL(),
                  width: 200,
                  height: 200,
                  alignment: 'right'
                });
                contractTemplate.content.push({
                  text: 'Signature',
                  fontSize: '12',
                  alignment: 'right',
                  margin: [0, 0, 10, 0]
                });
                contractTemplate.content.push({
                  text: 'Date: ' + _this2.dateFormat(Date.now()),
                  fontSize: '12',
                  alignment: 'right',
                  margin: [0, 5, 10, 0]
                });
                return _context2.abrupt('return', contractTemplate);

              case 57:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[30, 34, 38, 46], [39,, 41, 45]]);
      }))();
    },
    dateFormat: function dateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format('DD/MM/yyyy');
    },
    checkShowAmountRowSpan: function checkShowAmountRowSpan(type) {
      if (!this.showRowSpan) {
        this.showRowSpan = type;
        return true;
      } else if (this.showRowSpan === type) return true;
      return false;
    },
    formatPayout: function formatPayout(n) {
      var currency = 'SGD';
      if (this.pairingDetails.payout_details) {
        currency = this.pairingDetails.payout_details.currency || 'SGD';
      }
      if (n === null || n === undefined || n === '') return n;
      var formatAmount = function formatAmount(value) {
        var amount = Number(value);
        return isNaN(amount) ? value : amount.toFixed(2);
      };
      if (n.toString().indexOf('-') !== -1) {
        var str = n.toString().split('-');
        return currency + ' ' + formatAmount(str[0]) + ' - ' + formatAmount(str[1]);
      } else {
        return currency + ' ' + formatAmount(n);
      }
    },
    formatDesc: function formatDesc(text) {
      return text.replaceAll('\n', '</br>');
    },
    formatSubmissionDate: function formatSubmissionDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format('DD/MM/yyyy') : '';
    },
    openUpdateSubmissionDialog: function openUpdateSubmissionDialog(item) {
      this.viewPairingData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.updateSubmissionDateDialog = true;
    },
    refreshPairing: function refreshPairing() {
      if (this.$route.params.pairingID) {
        this.$store.dispatch('pairing/getPairingDetails', this.$route.params.pairingID);
      }
    },
    closeSubmissionDialog: function closeSubmissionDialog() {
      this.updateSubmissionDateDialog = false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var canvas, infDetails;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_17_pdfmake_build_pdfmake_js__["fonts"] = {
                  Arial: {
                    normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                    bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
                  }
                };
              }, 1000);
              canvas = document.getElementById('signin-signature-pad');

              _this3.signaturePad = new __WEBPACK_IMPORTED_MODULE_8_signature_pad__["a" /* default */](canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
              });

              if (!_this3.$route.params.pairingID) {
                _context3.next = 15;
                break;
              }

              _context3.next = 6;
              return _this3.$store.dispatch('pairing/getPairingDetails', _this3.$route.params.pairingID);

            case 6:
              if (!_this3.pairingDetails.id) {
                window.location.replace('/');
              }
              if (_this3.pairingDetails.signinForm) {
                _this3.$swal({
                  text: 'This endorsement form is completed.',
                  type: 'warning',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false
                }).then(function (result) {
                  if (result.value) {
                    window.location.replace('/');
                  }
                });
              }

              if (!_this3.pairingDetails.campaignID) {
                _context3.next = 15;
                break;
              }

              _context3.next = 11;
              return __WEBPACK_IMPORTED_MODULE_10__Campaign_campaignAPIs__["a" /* default */].getCampaignDetailForFeedback(_this3.pairingDetails.campaignID);

            case 11:
              _this3.campaign = _context3.sent;
              infDetails = _this3.pairingDetails.influencer_details;

              _this3.displayData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                handle: infDetails.instagramHandle,
                platform: infDetails.platform,
                platformName: infDetails.platformName || 'Platform',
                campaignID: _this3.campaign.id,
                campaignName: _this3.campaign.name,
                clientName: _this3.campaign.client ? _this3.campaign.client.name : '-'
              });
              if (infDetails.platform && infDetails.platform === 'xiaohongshu') {
                _this3.displayData.handle = infDetails.fullName;
              }

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermsAndConditions'
});

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_signature_pad__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsAndConditions__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsAndConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TermsAndConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__ = __webpack_require__(16);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewSigninForm',
  props: {
    value: Boolean,
    signinFormData: Object
  },
  components: {
    TermsAndConditions: __WEBPACK_IMPORTED_MODULE_5__TermsAndConditions___default.a
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func,
      campaign: {},
      displayData: {},
      signinForm: {},
      signaturePad: null,
      signatureImg: null,
      downloadloading: false
    };
  },

  watch: {
    signinFormData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        var infDetails, canvas;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.signinForm = newValue.signinForm;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignAPIs__["a" /* default */].getCampaignDetailForFeedback(newValue.CampaignID);

              case 3:
                this.campaign = _context.sent;
                infDetails = newValue.influencer_details;

                this.displayData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
                  handle: infDetails.instagramHandle,
                  platform: infDetails.platform,
                  campaignName: this.campaign.name,
                  clientName: this.campaign.client ? this.campaign.client.name : '-'
                });
                canvas = document.getElementById('signin-signature-pad');

                this.signaturePad = new __WEBPACK_IMPORTED_MODULE_3_signature_pad__["a" /* default */](canvas, {
                  backgroundColor: 'rgb(255, 255, 255)'
                });
                this.signaturePad.fromData(this.signinForm.signature);
                this.signatureImg = this.signaturePad.toDataURL();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signinFormData(_x) {
        return _ref.apply(this, arguments);
      }

      return signinFormData;
    }()
  },
  methods: {
    downloadPDF: function downloadPDF() {},
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scoped_post_Deliverables__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scoped_post_Deliverables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__scoped_post_Deliverables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__paymentAPIs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jimp__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_jimp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PayoutSampleModal__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PayoutSampleModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__PayoutSampleModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__config__ = __webpack_require__(6);




























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubmitPayout',
  components: {
    PostDeliverables: __WEBPACK_IMPORTED_MODULE_10__scoped_post_Deliverables___default.a,
    PayoutSampleModal: __WEBPACK_IMPORTED_MODULE_22__PayoutSampleModal___default.a,
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_11__scoped_custom_CustomFileUpload___default.a
  },
  data: function data() {
    return {
      user: {},
      loading: false,
      urlIncluded: false,
      mainStep: 1,
      firstActiveStep: 1,
      secondActiveStep: 1,
      thirdActiveStep: 1,
      campaignPayout: {
        campaignName: '',
        campaignID: '',
        postID: '',
        otherSocialMediaPostUrl: '',

        satisfactionLevel: 0,
        kobeSatisfactionLevel: 0,
        advertiserSatisfactionLevel: 0,
        collaboration: '',
        improved: '',

        promotingProducts: '',
        audienceEnjoyment: '',
        otherCampaigns: ''
      },
      rules: {
        required: function required(v) {
          return !!v || 'This field is required';
        }
      },
      payoutImages: [],
      images: [],
      deliverables: null,

      firstSteppers: [],
      campaigns: [],
      allBanks: [],
      bankNames: [],
      editProfile: false,
      editData: {},
      isStoryTell: false,
      payoutSampleDialog: false,
      sampleType: '',
      payoutSampleTimer: null,
      autoShownPayoutSampleSteps: {},
      mediaFiles: [],
      fileUploadRefresh: false
    };
  },
  created: function created() {
    if (this.$route.query.id) {
      this.preLoadData(this.$route.query.id);
    }
    if (this.$route.query.pairingID) {
      this.getPairingDetails(this.$route.query.pairingID);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapState */])({
    pairingDetails: function pairingDetails(state) {
      return state.pairing.pairingDetails;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["c" /* mapGetters */])('pairing', {
    pairingStatus: 'status'
  }), {
    statusACCEPTED: function statusACCEPTED() {
      return this.pairingStatus.ACCEPTED.value;
    },
    isCampaign: function isCampaign() {
      if (this.$route.query.id) {
        return true;
      }
      return false;
    },
    isPairing: function isPairing() {
      if (this.$route.query.pairingID) {
        return true;
      }
      return false;
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    isCurrentUser: function isCurrentUser() {
      return this.$store.state.user;
    },
    isNotInfluencer: function isNotInfluencer() {
      var role = Number(this.$store.state.user.role);
      return role !== __WEBPACK_IMPORTED_MODULE_24__config__["a" /* default */].userRoles.INFLUENCER;
    },
    disableStepTwo: function disableStepTwo() {
      return !this.campaignPayout.promotingProducts || !this.campaignPayout.improved || !this.campaignPayout.audienceEnjoyment;
    },
    numberOfTikTokPost: function numberOfTikTokPost() {
      if (this.deliverables) {
        return this.deliverables.no_of_tiktok_posts;
      } else return null;
    },
    numberOfPost: function numberOfPost() {
      if (this.deliverables) {
        return this.deliverables.no_of_posts;
      } else return null;
    },
    numberOfCarousels: function numberOfCarousels() {
      if (this.deliverables) {
        return this.deliverables.no_of_carousels;
      } else return null;
    },
    numberOfStories: function numberOfStories() {
      if (this.deliverables) {
        return this.deliverables.no_of_stories;
      } else return null;
    },
    numberOfVideo: function numberOfVideo() {
      if (this.deliverables) {
        return this.deliverables.no_of_video;
      } else return null;
    },
    numberOfIGReels: function numberOfIGReels() {
      if (this.deliverables) {
        return this.deliverables.no_of_reels;
      } else return null;
    },
    numberOfFBPosts: function numberOfFBPosts() {
      if (this.deliverables) {
        return this.deliverables.no_of_fb_posts;
      } else return null;
    },
    numberOfLinkedInPosts: function numberOfLinkedInPosts() {
      if (this.deliverables) {
        return this.deliverables.no_of_li_posts;
      } else return null;
    },
    numberOfXPosts: function numberOfXPosts() {
      if (this.deliverables) {
        return this.deliverables.no_of_x_posts;
      } else return null;
    },
    numberOfXHSPosts: function numberOfXHSPosts() {
      if (this.deliverables) {
        return this.deliverables.no_of_xhs_posts;
      } else return null;
    },
    numberOfYoutubePosts: function numberOfYoutubePosts() {
      if (this.deliverables) {
        return this.deliverables.youtube;
      } else return null;
    },
    numberOfCustoms: function numberOfCustoms() {
      if (this.deliverables) {
        return this.deliverables.custom || [];
      } else return [];
    }
  }),
  watch: {
    firstActiveStep: function firstActiveStep(newStep, previousStep) {
      var _this = this;

      if (newStep === previousStep || this.mainStep !== 1) return;

      var activeStepper = this.firstSteppers[Number(newStep) - 1];
      if (!activeStepper) return;

      var activeSampleType = this.getPayoutSampleType(activeStepper);
      if (!this.isSupportedPayoutSampleType(activeSampleType)) return;

      var stepKey = this.getPayoutSampleStepKey(newStep, activeStepper);
      if (this.autoShownPayoutSampleSteps[stepKey]) return;
      this.$set(this.autoShownPayoutSampleSteps, stepKey, true);

      this.$nextTick(function () {
        _this.showPayoutSampleDialog(activeSampleType);
      });
    }
  },
  methods: {
    scrollTopFunction: function scrollTopFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    deleteImage: function deleteImage(imgIndex) {
      var imgName = this.images[imgIndex].name;
      this.images.splice(imgIndex, 1);

      var index = this.payoutImages.findIndex(function (item) {
        return item.name === imgName;
      });
      if (index !== -1) this.payoutImages.splice(index, 1);
    },
    deleteCustomImage: function deleteCustomImage(post, imgIndex) {
      var imgName = post.showImages[imgIndex].name;
      post.showImages.splice(imgIndex, 1);

      var index = post.images.findIndex(function (item) {
        return item.name === imgName;
      });
      if (index !== -1) post.images.splice(index, 1);
    },
    buildFormData: function buildFormData() {
      this.cleanPayoutPayload(this.campaignPayout);
      var formData = new FormData();
      var payoutData = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, this.campaignPayout);
      formData.append('influencerID', this.user.influencerId);
      formData.append('campaignPayout', __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(payoutData));

      if (this.campaignPayout.posts !== undefined) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.campaignPayout.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var post = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(post.images), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var img = _step2.value;

                formData.append('images', img.file);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (this.campaignPayout.stories !== undefined) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.campaignPayout.stories), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var story = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(story.images), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _img = _step4.value;

                formData.append('images', _img.file);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      if (this.campaignPayout.deliverablePosts !== undefined) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.campaignPayout.deliverablePosts), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var deliverable = _step5.value;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(deliverable.posts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _post = _step6.value;
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                  for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_post.images), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _img2 = _step7.value;

                    formData.append('deliverableImages', _img2.file);
                  }
                } catch (err) {
                  _didIteratorError7 = true;
                  _iteratorError7 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                      _iterator7.return();
                    }
                  } finally {
                    if (_didIteratorError7) {
                      throw _iteratorError7;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.mediaFiles), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var val = _step8.value;

          formData.append('uploadFile', val);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return formData;
    },
    cleanPayoutPayload: function cleanPayoutPayload() {
      if (this.campaignPayout.posts !== undefined) {
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.campaignPayout.posts), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var post = _step9.value;

            delete post.showImages;
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }

      if (this.campaignPayout.stories !== undefined) {
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.campaignPayout.stories), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var story = _step10.value;

            delete story.showImages;
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }
      }

      if (this.campaignPayout.deliverablePosts !== undefined) {
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.campaignPayout.deliverablePosts), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var deliverable = _step11.value;
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(deliverable.posts), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var _post2 = _step12.value;

                delete _post2.showImages;
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }
      }
    },
    prepareUpload: function prepareUpload(e) {
      var _this2 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          _this2.$swal('File Type Not Supported, Please select a video or an image');
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buffer = e.target.result;
            __WEBPACK_IMPORTED_MODULE_20_jimp___default.a.read(buffer, function (err, img) {
              if (err) console.error(111, err);
              img.resize(500, __WEBPACK_IMPORTED_MODULE_20_jimp___default.a.AUTO).quality(100).getBase64(__WEBPACK_IMPORTED_MODULE_20_jimp___default.a.MIME_PNG, function (err, buff) {
                if (err) console.error(222, err);
                var file = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
                _this2.payoutImages.push(file);
                _this2.images.push({
                  thumbnail: buff,
                  src: buff,
                  name: element.name
                });
              });
            });
          };

          e.target.value = '';
        }
      });
    },
    prepareCustomUpload: function prepareCustomUpload(e, post) {
      var _this3 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          _this3.$swal('File Type Not Supported, Please select a video or an image');
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buffer = e.target.result;
            var file = __WEBPACK_IMPORTED_MODULE_19__utils__["a" /* default */].func.dataURLtoFile(buffer, element.name);
            post.images.push({ name: element.name, file: file });
            post.showImages.push({
              thumbnail: buffer,
              src: buffer,
              name: element.name
            });
            _this3.refreshPayoutJSON();
          };

          e.target.value = '';
        }
      });
    },
    preLoadData: function preLoadData(postId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_13__Post_postApi__["a" /* default */].getPostById(postId).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (response.mainPost.campaignID) {
                    _this4.campaignPayout.postID = response._id;
                    _this4.campaignPayout.campaignID = response.mainPost.campaignID;
                    if (response.mainPost.postURL) {
                      _this4.urlIncluded = true;
                      _this4.campaignPayout.instagramPostURL = response.mainPost.postURL;
                    }
                    if (response.influencer) {
                      _this4.getCampaignData(_this4.campaignPayout.campaignID, response.influencer.username, response.influencer.platform);
                    }
                  } else {
                    _this4.$swal({
                      title: 'Post is not ready',
                      type: 'error',
                      text: 'The post isn\'t associated with any Campaign.'
                    }).then(function () {
                      return _this4.$router.push({ path: '/posts/approved' });
                    });
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        _this4.$swal({
          title: 'Can\'t Load the Post',
          type: 'error',
          text: err
        }).then(function () {
          return _this4.$router.push({ path: '/posts/approved' });
        });
      });
    },
    changeCampaign: function changeCampaign() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.getCampaignData(_this5.campaignPayout.campaignID, _this5.user.handle, _this5.user.platform);

              case 2:
                _this5.mainStep = 1;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    getCampaignData: function getCampaignData(campaignID, username, platform) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_14__Campaign_campaignAPIs__["a" /* default */].getCampaignDetailForStats(campaignID).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(campaign) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!_this6.isCurrentUser || _this6.isNotInfluencer) {
                              _this6.campaigns = [{
                                id: campaignID,
                                name: campaign.name
                              }];
                              _this6.campaignPayout.campaignID = campaignID;
                            }
                            _this6.campaignPayout.campaignName = campaign.name;
                            _this6.isStoryTell = false;

                            if (!(_this6.isCurrentUser && !_this6.isNotInfluencer)) {
                              _context3.next = 9;
                              break;
                            }

                            if (!(campaign.campaignType !== 'AOK' && campaign.campaignType !== __WEBPACK_IMPORTED_MODULE_18__Campaign_config__["a" /* default */].campaignType.AOK)) {
                              _context3.next = 7;
                              break;
                            }

                            _context3.next = 7;
                            return _this6.getPairingData(campaign.id, username, platform);

                          case 7:
                            _context3.next = 10;
                            break;

                          case 9:
                            _this6.deliverables = _this6.pairingDetails.deliverables_details;

                          case 10:
                            _this6.generateStepper(campaign);

                          case 11:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this6);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  _this6.$swal({
                    title: 'Couldn\'t get Campaign Information',
                    type: 'error',
                    text: err
                  }).then(function () {
                    return _this6.$router.push({ path: '/posts/approved' });
                  });
                });

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    getPairingDetails: function getPairingDetails(pairingID) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var influencerID, username, platform, influencerDetails;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.$store.dispatch('pairing/getPairingDetailsForStats', pairingID);

              case 2:
                if (_this7.pairingDetails) {
                  influencerID = '';
                  username = '';
                  platform = '';

                  if (_this7.pairingDetails.influencer_details) {
                    influencerDetails = _this7.pairingDetails.influencer_details;

                    platform = influencerDetails.platform || '';
                    username = _this7.getPairingHandle(influencerDetails, platform);
                    influencerID = influencerDetails.influencerID || '';
                    _this7.campaignPayout.pairingID = pairingID;
                    _this7.campaignPayout.influencerID = influencerID;
                    _this7.campaignPayout.handle = username;
                    _this7.campaignPayout.platform = platform || 'instagram';
                    _this7.campaignPayout.fullName = influencerDetails.fullname || influencerDetails.fullName || '';
                    _this7.campaignPayout.xhsID = influencerDetails.xhsID || '';
                  }
                  if (_this7.isCurrentUser) {
                    if (influencerID !== _this7.user.influencerId) {
                      _this7.campaignPayout.campaignID = _this7.pairingDetails.campaignID;
                      _this7.getCampaignData(_this7.pairingDetails.campaignID, username, platform);
                    }
                  } else {
                    _this7.campaignPayout.campaignID = _this7.pairingDetails.campaignID;
                    _this7.getCampaignData(_this7.pairingDetails.campaignID, username, platform);
                  }
                }

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    getPairingData: function getPairingData(campaignID, username, platform) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var pairings, matchesPairingHandle, pairingOne, influencerDetails, pairingPlatform;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!username && platform)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaign(campaignID);

              case 4:
                pairings = _context6.sent;

                matchesPairingHandle = function matchesPairingHandle(p) {
                  if (p.influencer_details) {
                    var influencerDetails = p.influencer_details;
                    var pairingPlatform = influencerDetails.platform || platform || 'instagram';
                    var pairingHandle = _this8.getPairingHandle(influencerDetails, pairingPlatform);
                    return _this8.normalizeHandle(pairingHandle) === _this8.normalizeHandle(username) && (!platform || pairingPlatform === platform);
                  }
                  return false;
                };

                pairingOne = pairings.find(matchesPairingHandle);

                if (!pairingOne) {
                  pairingOne = pairings.find(function (p) {
                    return p.influencer_details && p.influencer_details.influencerID === _this8.user.influencerId;
                  });
                }

                if (pairingOne) {
                  _this8.deliverables = pairingOne.deliverables_details;
                  influencerDetails = pairingOne.influencer_details || {};
                  pairingPlatform = influencerDetails.platform || platform || _this8.user.platform || 'instagram';

                  _this8.campaignPayout.pairingID = pairingOne.id || pairingOne.pairingID || '';
                  _this8.campaignPayout.influencerID = influencerDetails.influencerID || _this8.user.influencerId;
                  _this8.campaignPayout.handle = _this8.getPairingHandle(influencerDetails, pairingPlatform) || username;
                  _this8.campaignPayout.platform = pairingPlatform;
                  _this8.campaignPayout.fullName = influencerDetails.fullname || influencerDetails.fullName || _this8.user.fullName || '';
                  _this8.campaignPayout.xhsID = influencerDetails.xhsID || '';
                }

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    proceedStepTwo: function proceedStepTwo() {
      var invalidSteps = this.checkDeliverablePosts();
      if (invalidSteps.length) {
        this.firstActiveStep = invalidSteps[0];
        this.scrollTopFunction();
        return;
      }
      if (this.campaignPayout.advertiserSatisfactionLevel === 0 || this.campaignPayout.kobeSatisfactionLevel === 0) {
        var errText = '<div style="text-align:left;">';
        errText += '<h3 style="margin-top:-10px">Please complete the followings:</h3>';
        if (this.campaignPayout.advertiserSatisfactionLevel === 0) {
          errText += 'Step ' + (this.campaignPayout.deliverablePosts.length + 1) + ': Ratings for overall experience with client<br>';
        }
        if (this.campaignPayout.kobeSatisfactionLevel === 0) {
          errText += 'Step ' + (this.campaignPayout.deliverablePosts.length + 2) + ': Ratings for overall experience with Kobe';
        }
        errText += '</div>';
        this.$swal({
          html: errText,
          type: 'warning'
        });
      } else this.mainStep = 2;
    },

    createCampaignPayout: function createCampaignPayout() {
      var _this9 = this;

      this.loading = true;

      var campaignPayout = this.buildFormData();

      this.$swal({
        title: 'Payment Schedule and Terms',
        html: '<div class="text-left subtitle-1">\n        <ol>\n        <li> <b>Fees</b> - Creator shall be paid in accordance to the amount stated in the Invoice endorsed on the Platform.</li>\n        <li> <b>Payments</b> - Kobe shall pay fees by cheque or bank transfer within forty-five (45) days after submission of your live post URL. Creator must provide all applicable personal and bank account information after receiving the live URL link of your posting upon approval by client.</li>\n        <li> <b>Penalty fee</b> - It is the responsibility of the Creator to ensure that all personal and bank account information provided are accurate for payment purposes. Otherwise, a deduction of $5 will be made from the amount stated on the endorsed Invoice should there be a request for payment re-issuance due to wrong information provided by the Influencer.</li>\n        <li> <b>Forfeiture</b> - Payment will be forfeited should there be any infringement of rules stated in the Campaign Agreement, email correspondences and the Platform.</li>\n        </ol>\n        </div>',
        type: 'info',
        confirmButtonText: 'Agree and Continue',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          campaignPayout.influencerID = _this9.user.influencerId;
          __WEBPACK_IMPORTED_MODULE_15__paymentAPIs__["a" /* default */].createCampaignPayout(campaignPayout).then(function (response) {
            if (!_this9.isCampaign) {
              _this9.showPayoutSuccessMsg();
              return;
            }

            __WEBPACK_IMPORTED_MODULE_13__Post_postApi__["a" /* default */].publishPost(_this9.campaignPayout.postID, _this9.campaignPayout.instagramPostURL, true).then(function () {
              _this9.showPayoutSuccessMsg(true);
            }).catch(function () {
              _this9.loading = false;
              _this9.$swal({
                type: 'error',
                title: 'Error in marking as publish for the post',
                text: 'Don\'t worry, your payout submission is submitted.'
              });
            });
          }).catch(function (error) {
            _this9.loading = false;
            _this9.$swal({
              type: 'error',
              title: 'Error in submitting payout!',
              text: error
            });
          });
        } else {
          _this9.loading = false;
        }
      });
    },
    generateStepper: function generateStepper(campaign) {
      this.firstSteppers = [];
      this.firstActiveStep = 1;
      this.autoShownPayoutSampleSteps = {};
      if (campaign.campaignType === 'AOK' || campaign.campaignType === __WEBPACK_IMPORTED_MODULE_18__Campaign_config__["a" /* default */].campaignType.AOK) {
        this.generateAOKStepper();
      } else {
        this.isStoryTell = true;
        this.generateStoryTellStepper();
      }
      this.firstSteppers.push(this.stepperType('advertiserSatisfactionLevel'), this.stepperType('kobeSatisfactionLevel'));
      this.schedulePayoutSample();
    },
    generateAOKStepper: function generateAOKStepper() {
      this.firstSteppers.push(this.stepperType('storyCoverage'));
      this.firstSteppers.push(this.stepperType('postURL'));
      this.campaignPayout.posts = [];
      this.campaignPayout.stories = [];
      this.addMore('posts');
      this.addMore('stories');
    },
    generateStoryTellStepper: function generateStoryTellStepper() {
      if (!this.deliverables) {
        return;
      }
      var name = '';
      var sample = '';
      var deliverablePosts = [];
      if (this.numberOfTikTokPost > 0) {
        name = 'TTP';
        sample = 'tiktok';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfTikTokPost, name, sample));
      }
      if (this.numberOfPost > 0) {
        name = 'IGP';
        sample = 'igPost';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfPost, name, sample));
      }
      if (this.numberOfCarousels > 0) {
        name = 'IGC';
        sample = 'igPost';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfCarousels, name, sample));
      }
      if (this.numberOfStories > 0) {
        name = 'IGS';
        sample = 'igStory';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfStories, name, sample));
      }
      if (this.numberOfVideo > 0) {
        name = 'IGV';
        sample = 'igPost';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfVideo, name, sample));
      }
      if (this.numberOfIGReels > 0) {
        name = 'IGR';
        sample = 'igReel';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfIGReels, name, sample));
      }
      if (this.numberOfXHSPosts > 0) {
        name = 'XHS';
        sample = 'xhs';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfXHSPosts, name, sample));
      }
      if (this.numberOfYoutubePosts > 0) {
        name = 'Youtube';
        sample = 'youtube';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfYoutubePosts, name, sample));
      }
      if (this.numberOfFBPosts > 0) {
        name = 'FBP';
        sample = 'facebook';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfFBPosts, name, sample));
      }
      if (this.numberOfLinkedInPosts > 0) {
        name = 'LIP';
        sample = 'linkedin';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfLinkedInPosts, name, sample));
      }
      if (this.numberOfXPosts > 0) {
        name = 'XTP';
        sample = 'twitter';
        this.firstSteppers.push(this.stepperType('deliverable', { name: name }));
        deliverablePosts.push(this.getPostArray(this.numberOfXPosts, name, sample));
      }
      if (this.numberOfCustoms.length > 0) {
        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
          for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.deliverables.custom), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var custom = _step13.value;

            var customName = custom.label;
            sample = 'custom';
            this.firstSteppers.push(this.stepperType('deliverable', { name: customName }));
            deliverablePosts.push(this.getPostArray(custom.value, customName, sample));
          }
        } catch (err) {
          _didIteratorError13 = true;
          _iteratorError13 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion13 && _iterator13.return) {
              _iterator13.return();
            }
          } finally {
            if (_didIteratorError13) {
              throw _iteratorError13;
            }
          }
        }
      }
      this.campaignPayout.deliverablePosts = deliverablePosts;
      this.refreshPayoutJSON();
    },
    getPostArray: function getPostArray(total, type, sampleType) {
      var posts = [];
      for (var i = 1; i <= total; i++) {
        posts.push(this.getDeliverableObj(type, i));
      }
      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, {
        type: type,
        title: this.getLongTitle(type),
        posts: posts,
        sampleType: sampleType
      });
    },
    getDeliverablePost: function getDeliverablePost(type) {
      if (this.campaignPayout.deliverablePosts) {
        return this.campaignPayout.deliverablePosts.find(function (post) {
          return post.type === type;
        });
      } else return '';
    },
    stepperType: function stepperType(type) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return { type: type, fields: fields };
    },

    clearData: function clearData() {
      this.deliverables = null;
      this.firstSteppers = [];
      this.autoShownPayoutSampleSteps = {};
      this.campaignPayout = {
        campaignName: '',
        otherSocialMediaPostUrl: '',

        satisfactionLevel: 0,
        kobeSatisfactionLevel: 0,
        advertiserSatisfactionLevel: 0,
        collaboration: '',
        improved: '',

        promotingProducts: '',
        audienceEnjoyment: '',
        otherCampaigns: ''
      };
    },
    validURL: function validURL(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + '(\\?[;&a-z\\d%_.~+=-]*)?' + '(\\#[-a-z\\d_]*)?$', 'i');
      return !!pattern.test(str);
    },
    showFileUploader: function showFileUploader(id) {
      $('#' + id).click();
    },
    addMore: function addMore(type) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (type === 'posts') {
        this.campaignPayout.posts.push({
          instagramPostURL: '',
          images: [],
          showImages: []
        });
      }
      if (type === 'stories') {
        this.campaignPayout.stories.push({
          label: '',
          images: [],
          showImages: []
        });
      }
      if (type === 'deliverables') {
        var postOne = this.campaignPayout.deliverablePosts[index];
        postOne.posts.push(this.getDeliverableObj(postOne.type, postOne.posts.length + 1));
      }
      this.refreshPayoutJSON();
    },
    getDeliverableObj: function getDeliverableObj(type, number) {
      return {
        label: '',
        images: [],
        showImages: []
      };
    },
    getLongTitle: function getLongTitle(title) {
      var titleText = 'Enter the URL, Stats for ';
      if (title === 'TTP') {
        return titleText + ' TikTok Post';
      } else if (title === 'IGP') {
        return titleText + ' IG Post';
      } else if (title === 'IGC') {
        return titleText + ' IG Carousel';
      } else if (title === 'IGS') {
        return 'Upload your stats for IG Story(ies)';
      } else if (title === 'IGV') {
        return titleText + ' IG VIdeo';
      } else if (title === 'IGR') {
        return titleText + ' IG Reel(s)';
      } else if (title === 'LIP') {
        return titleText + ' LinkedIn Post';
      } else if (title === 'XTP') {
        return titleText + ' X (Twitter) Post';
      } else {
        return titleText + ' ' + title;
      }
    },
    getLabel: function getLabel(type) {
      if (type === 'IGS') {
        return 'label';
      } else return 'Post URL';
    },
    getHint: function getHint(type) {
      if (type === 'IGS') {
        return 'label IGS 1, IGS 2 etc for multiple stories';
      } else return '';
    },
    getPairingHandle: function getPairingHandle(influencerDetails, platform) {
      if (!influencerDetails) return '';
      if (platform === 'linkedin') {
        return influencerDetails.linkedinHandle || influencerDetails.userHandle || influencerDetails.instagramHandle || '';
      }
      if (platform === 'twitter') {
        return influencerDetails.twitterHandle || influencerDetails.userHandle || influencerDetails.instagramHandle || '';
      }
      return influencerDetails.userHandle || influencerDetails.instagramHandle || '';
    },
    normalizeHandle: function normalizeHandle(handle) {
      return String(handle || '').trim().replace(/^@/, '').toLowerCase();
    },
    refreshPayoutJSON: function refreshPayoutJSON() {
      var tmp = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, this.campaignPayout);
      this.campaignPayout = tmp;
    },
    getInfluencerCampaigns: function getInfluencerCampaigns() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_16__Pairing_pairingAPIs__["a" /* default */].getInvitedCampaigns(_this10.user.influencerId, '' + _this10.statusACCEPTED);

              case 2:
                _this10.campaigns = _context7.sent;

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    showPayoutSuccessMsg: function showPayoutSuccessMsg() {
      var _this11 = this;

      var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loading = false;
      this.clearData();
      this.$swal({
        title: 'Payout Submitted',
        html: '<div class="text-left subtitle-1">\n        <ul>\n        <li style=\'list-style:none\'>Your content will remain publicly accessible through your social media account(s) for a minimum of six (6) months, and you do not work with a competitor brand for the next 4 weeks unless otherwise stated.</li>\n        </ul>\n        </div>',
        type: 'success'
      }).then(function () {
        if (redirect) {
          _this11.$router.push({ path: '/posts/published' });
        } else {
          _this11.$router.push({ path: '/' });
        }
      });
    },
    openProfileEdit: function openProfileEdit() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this12.editData = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, _this12.user);
                _this12.editProfile = true;
                if (!_this12.allBanks.length) {
                  _this12.getBankInfo();
                }

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this12);
      }))();
    },
    saveProfile: function saveProfile() {
      var _this13 = this;

      this.$swal({
        title: 'Confirm Update!',
        text: 'Are you sure you want update?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this13.loading = true;
          var formData = _this13.buildProfileFormData();

          __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].editProfile(formData).then(function () {
            _this13.loading = false;
            _this13.$swal({
              title: 'Successfully updated!',
              text: 'Your profile has been updated successfully. Thank you for working with us!',
              type: 'success'
            });

            _this13.user = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, _this13.editData);
            _this13.cancelEdit();
          }).catch(function (error) {
            _this13.loading = false;
            _this13.$swal({
              title: 'Error!',
              text: 'Please kindly try again or contact us!',
              type: 'error'
            });

            console.log('error', error);
          });
        }
      });
    },
    buildProfileFormData: function buildProfileFormData() {
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.editData.bankName) === 'object') {
        this.editData.swiftCode = this.editData.bankName.swift_code;
        this.editData.bankName = this.editData.bankName.bank;
      }
      var data = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, {
        id: this.currentUserID,
        fullName: this.editData.fullName,
        bankName: this.editData.bankName,
        swiftCode: this.editData.swiftCode,
        bankAccount: this.editData.bankAccount,
        email: this.editData.email,
        mailingAddress: this.editData.mailingAddress,
        briefUpdate: true
      });
      var formData = new FormData();
      formData.append('editProfile', __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(data));
      return formData;
    },
    cancelEdit: function cancelEdit() {
      this.editData = {};
      this.editProfile = false;
    },
    getBankInfo: function getBankInfo() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var country, matchBank;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this14.bankNames = [];
                country = __WEBPACK_IMPORTED_MODULE_23__static_sources_countries___default.a.find(function (c) {
                  return c.name === _this14.user.country;
                });

                if (country) {
                  _context9.next = 6;
                  break;
                }

                _this14.bankNames = [];
                return _context9.abrupt('return');

              case 6:
                _context9.next = 8;
                return _this14.getBanks(country.code);

              case 8:
                matchBank = _this14.allBanks.find(function (bank) {
                  return bank.country_code === country.code;
                });

                if (matchBank && matchBank.list !== undefined) {
                  _this14.bankNames = matchBank.list.filter(function (bank) {
                    return bank.branch === null;
                  });
                }
                _context9.next = 16;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9['catch'](0);

                console.log(_context9.t0);
                _this14.bankNames = [];

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this14, [[0, 12]]);
      }))();
    },
    getRatingStartIndex: function getRatingStartIndex() {
      return this.firstSteppers.findIndex(function (step) {
        return step.type === 'advertiserSatisfactionLevel';
      });
    },
    deletePostGroup: function deletePostGroup(groupArray, index) {
      groupArray.splice(index, 1);
      this.refreshPayoutJSON();
    },
    getBanks: function getBanks(code) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_17__influencerAPIs__["a" /* default */].getBanks(code);

              case 3:
                _this15.allBanks = _context10.sent;
                _context10.next = 9;
                break;

              case 6:
                _context10.prev = 6;
                _context10.t0 = _context10['catch'](0);

                console.log('error', _context10.t0);

              case 9:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this15, [[0, 6]]);
      }))();
    },
    showPayoutSampleDialog: function showPayoutSampleDialog(type) {
      if (this.payoutSampleTimer) {
        clearTimeout(this.payoutSampleTimer);
        this.payoutSampleTimer = null;
      }
      this.sampleType = type;
      this.payoutSampleDialog = true;
    },
    getPayoutSampleType: function getPayoutSampleType(stepper) {
      if (!stepper) return '';
      if (stepper.type === 'storyCoverage') return 'igStory';
      if (stepper.type !== 'deliverable') return '';

      var deliverable = this.getDeliverablePost(stepper.fields.name);
      return deliverable ? deliverable.sampleType : '';
    },
    isSupportedPayoutSampleType: function isSupportedPayoutSampleType(type) {
      return ['igReel', 'igPost', 'igStory', 'tiktok', 'xhs', 'facebook', 'linkedin', 'twitter'].includes(type);
    },
    getPayoutSampleStepKey: function getPayoutSampleStepKey(stepNumber, stepper) {
      var deliverableName = stepper && stepper.fields ? stepper.fields.name || '' : '';
      return stepNumber + ':' + stepper.type + ':' + deliverableName;
    },
    schedulePayoutSample: function schedulePayoutSample() {
      var _this16 = this;

      if (this.payoutSampleTimer) {
        clearTimeout(this.payoutSampleTimer);
      }

      var stepIndex = this.firstSteppers.findIndex(function (stepper) {
        return _this16.isSupportedPayoutSampleType(_this16.getPayoutSampleType(stepper));
      });
      if (stepIndex < 0) return;

      var stepper = this.firstSteppers[stepIndex];
      var sampleType = this.getPayoutSampleType(stepper);
      var stepKey = this.getPayoutSampleStepKey(stepIndex + 1, stepper);

      this.payoutSampleTimer = setTimeout(function () {
        _this16.payoutSampleTimer = null;
        if (_this16.autoShownPayoutSampleSteps[stepKey]) return;
        _this16.$set(_this16.autoShownPayoutSampleSteps, stepKey, true);
        _this16.showPayoutSampleDialog(sampleType);
      }, 3000);
    },
    checkProfileData: function checkProfileData() {
      if (!this.user.fullName || !this.user.bankName || !this.user.bankAccount || !this.user.email || !this.user.mailingAddress) {
        this.$swal({
          title: 'Error',
          type: 'error',
          text: 'Please update your profile before submission.'
        });
        this.thirdActiveStep = 1;
        return false;
      }
      return true;
    },
    checkDeliverablePosts: function checkDeliverablePosts() {
      var steps = [];
      if (this.campaignPayout.deliverablePosts !== undefined) {
        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;

        try {
          for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.campaignPayout.deliverablePosts)), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var _ref3 = _step14.value;

            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

            var key = _ref4[0];
            var deliverable = _ref4[1];

            var stepInvalid = false;
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(deliverable.posts), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var post = _step15.value;

                if (!post.label || !post.images.length) {
                  stepInvalid = true;
                }
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }

            if (stepInvalid) steps.push(parseInt(key) + 1);
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }
      }
      return steps;
    },
    updateMedias: function updateMedias(medias) {
      this.mediaFiles = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()([], medias);
    },
    isVideo: function isVideo(thumbnail) {
      return thumbnail.includes('video');
    },
    checkOpenBillingDialog: function checkOpenBillingDialog(currentInf) {
      if (!currentInf.fullName || !currentInf.country || !currentInf.bankName || !currentInf.bankAccount || !currentInf.billingEmail || !currentInf.mailingAddress) {
        this.$router.push({ path: '/profile' });
      }
    }
  },
  mounted: function mounted() {
    var _this17 = this;

    if (!this.isCurrentUser || this.isNotInfluencer) {
      return;
    }

    __WEBPACK_IMPORTED_MODULE_12__User_userAPIs__["a" /* default */].getUser(this.currentUserID).then(function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11(response) {
        var inf, activePlatform;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (response.influencer) {
                  inf = response.influencer;

                  if (!inf.instagram && !inf.tiktok && !inf.youtube && !inf.linkedin && !inf.twitter && !inf.reqIgHandle && !inf.reqTikTokHandle && !inf.reqYoutubeHandle) {
                    _this17.$swal({
                      text: 'Please Connect Platform',
                      type: 'warning',
                      allowOutsideClick: false
                    }).then(function (result) {
                      if (result.value) {}
                    });
                  }
                  if (inf) {
                    _this17.checkOpenBillingDialog(inf);
                  }
                }

                _this17.user = {
                  firstName: response.firstName,
                  lastName: response.lastName,
                  email: response.influencer.email,
                  country: response.influencer.country,
                  birthday: response.influencer.birthday,
                  gender: response.influencer.gender,
                  fullName: response.influencer.fullName,
                  bankName: response.influencer.bankName,
                  bankAccount: response.influencer.bankAccount,
                  swiftCode: response.influencer.swiftCode,
                  mailingAddress: response.influencer.mailingAddress,
                  influencerId: response.influencer.id
                };
                activePlatform = response.influencer.activePlatform;

                if (activePlatform === 'linkedin' && response.influencer.linkedin) {
                  _this17.user.handle = response.influencer.linkedin.linkedinHandle;
                  _this17.user.platform = 'linkedin';
                } else if (activePlatform === 'twitter' && response.influencer.twitter) {
                  _this17.user.handle = response.influencer.twitter.twitterHandle;
                  _this17.user.platform = 'twitter';
                } else if (activePlatform === 'tiktok' && response.influencer.tiktok) {
                  _this17.user.handle = response.influencer.tiktok.tiktokHandle;
                  _this17.user.platform = 'tiktok';
                } else if (activePlatform === 'instagram' && response.influencer.instagram) {
                  _this17.user.handle = response.influencer.instagram.instagramHandle;
                  _this17.user.platform = 'instagram';
                } else if (response.influencer.tiktok) {
                  _this17.user.handle = response.influencer.tiktok.tiktokHandle;
                  _this17.user.platform = 'tiktok';
                } else if (response.influencer.instagram) {
                  _this17.user.handle = response.influencer.instagram.instagramHandle;
                  _this17.user.platform = 'instagram';
                } else if (response.influencer.linkedin) {
                  _this17.user.handle = response.influencer.linkedin.linkedinHandle;
                  _this17.user.platform = 'linkedin';
                } else if (response.influencer.twitter) {
                  _this17.user.handle = response.influencer.twitter.twitterHandle;
                  _this17.user.platform = 'twitter';
                }

                if (_this17.isCampaign) {
                  _context11.next = 7;
                  break;
                }

                _context11.next = 7;
                return _this17.getInfluencerCampaigns();

              case 7:
                if (!_this17.isPairing) {
                  _context11.next = 10;
                  break;
                }

                _context11.next = 10;
                return _this17.getPairingDetails(_this17.$route.query.pairingID);

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this17);
      }));

      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }()).catch(function (error) {
      console.log('error', error);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.payoutSampleTimer) {
      clearTimeout(this.payoutSampleTimer);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68)))

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditReportHandleModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean
  },
  validations: {
    updateData: {
      handle: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      platform: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      platforms: ['Instagram', 'TikTok', 'Youtube', 'Facebook', 'LinkedIn', 'X (Twitter)'],
      updateData: {
        instagramHandle: '',
        tiktokHandle: '',
        youtubeHandle: '',
        facebookHandle: '',
        linkedinHandle: '',
        twitterHandle: '',
        platform: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    currentInfID: function currentInfID() {
      return this.$store.state.user.influencerID;
    }
  },
  watch: {
    value: function value(newValue) {
      this.updateData = {
        instagramHandle: '',
        tiktokHandle: '',
        youtubeHandle: '',
        facebookHandle: '',
        linkedinHandle: '',
        twitterHandle: '',
        platform: ''
      };
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveData, responseData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;

                _this2.updateData.instagramHandle = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.regexMatchIg(_this2.updateData.instagramHandle, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].regexPattern.instagram_profile));
                _this2.updateData.tiktokHandle = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.extractTikTokHandle(_this2.updateData.tiktokHandle));
                _this2.updateData.youtubeHandle = _this2.updateData.youtubeHandle ? _this2.updateData.youtubeHandle.trim() : '';
                _this2.updateData.facebookHandle = _this2.normalizeFacebookHandle(_this2.updateData.facebookHandle);
                _this2.updateData.linkedinHandle = _this2.normalizeLinkedInHandle(_this2.updateData.linkedinHandle);
                _this2.updateData.twitterHandle = _this2.normalizeTwitterHandle(_this2.updateData.twitterHandle);
                _this2.updateData.platform = [_this2.updateData.instagramHandle && 'Instagram', _this2.updateData.tiktokHandle && 'TikTok', _this2.updateData.youtubeHandle && 'YouTube', _this2.updateData.facebookHandle && 'Facebook', _this2.updateData.linkedinHandle && 'LinkedIn', _this2.updateData.twitterHandle && 'X (Twitter)'].filter(Boolean).join(', ');
                saveData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                  influencerID: _this2.currentInfID
                }, _this2.updateData));
                _context2.prev = 9;
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_5__influencerAPIs__["a" /* default */].updateInfPlatform(saveData);

              case 12:
                _this2.$swal({
                  text: 'Successfully Requested.',
                  type: 'success'
                }).then(function () {
                  _this2.close();
                  window.location.reload();
                });
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](9);
                responseData = _context2.t0 && _context2.t0.response ? _context2.t0.response.data : null;

                _this2.$swal({
                  text: responseData && responseData.message || 'Error updating ' + _this2.updateData.platform + '. Please try again.',
                  type: 'error'
                });

              case 19:
                _context2.prev = 19;

                _this2.isLoading = false;
                return _context2.finish(19);

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[9, 15, 19, 22]]);
      }))();
    },
    close: function close() {
      this.$emit('input');
    },
    normalizeTwitterHandle: function normalizeTwitterHandle(value) {
      var handle = (value || '').trim();
      var twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i);
      if (twitterUrl) handle = twitterUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    normalizeFacebookHandle: function normalizeFacebookHandle(value) {
      var handle = (value || '').trim();
      var profileURL = handle.match(/^(?:https?:\/\/)?(?:www\.)?facebook\.com\/profile\.php\?id=([^&#]+)/i);
      var pageURL = handle.match(/^(?:https?:\/\/)?(?:www\.)?facebook\.com\/([^/?#]+)/i);
      if (profileURL) handle = profileURL[1];else if (pageURL) handle = pageURL[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    normalizeLinkedInHandle: function normalizeLinkedInHandle(value) {
      var handle = (value || '').trim();
      var linkedInUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i);
      if (linkedInUrl) handle = linkedInUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    }
  }
});

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Company_companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__influencerAPIs__ = __webpack_require__(34);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewInfluencerCompanyModal',
  props: ['modalId', 'influencerData'],
  data: function data() {
    return {
      influencer: {},
      addCompanyID: '',
      company_options: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [{ key: 'name', sortable: true }, { key: 'address', sortable: true }, { key: 'website', sortable: true }, { key: 'phoneNumber', sortable: true }, { key: 'actions', sortable: false }],
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  },
  watch: {
    influencerData: function influencerData(newInfluencerData) {
      this.influencer = newInfluencerData;
      this.refreshCompanyList();
    }
  },
  methods: {
    assignCompany: function assignCompany() {
      var _this = this;

      if (this.addCompanyID) {
        __WEBPACK_IMPORTED_MODULE_1__influencerAPIs__["a" /* default */].assignCompany(this.influencer.id, this.addCompanyID).then(function (response) {
          _this.refreshCompanyList();
          _this.addCompanyID = '';
        }).catch(function (error) {
          console.log('error', error);
        });
      }
    },
    unassignCompany: function unassignCompany(companyID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__influencerAPIs__["a" /* default */].unassignCompany(this.influencer.id, companyID).then(function (response) {
        _this2.refreshCompanyList();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    refreshCompanyList: function refreshCompanyList() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__influencerAPIs__["a" /* default */].getInfluencerCompany(this.influencer.id).then(function (response) {
        _this3.items = response.companies;
        _this3.totalRows = _this3.items.length;

        __WEBPACK_IMPORTED_MODULE_0__Company_companyAPIs__["a" /* default */].getAllCompanies(false).then(function (response) {
          _this3.company_options = response.data;

          var displayCompanyListID = _this3.items.map(function (company) {
            return company.id;
          });

          _this3.company_options = _this3.company_options.filter(function (company) {
            return !displayCompanyListID.includes(company.id);
          });
        }).catch(function (error) {
          console.log('error', error);
        });
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  }
});

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuewordcloud__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuewordcloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuewordcloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditInfluencerModal__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditInfluencerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EditInfluencerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_ViewEditMode__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay__);




var _components;










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewInfluencerModal',
  props: {
    value: Boolean,
    influencerData: Object
  },
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_vuewordcloud___default.a.name, __WEBPACK_IMPORTED_MODULE_4_vuewordcloud___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'SocialHandle', __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_SocialHandle___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'EditInfluencerModal', __WEBPACK_IMPORTED_MODULE_7__EditInfluencerModal___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'Loading', __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay___default.a), _components),
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_ViewEditMode__["a" /* default */]],
  data: function data() {
    return {
      userGender_options: {},
      influencer: {
        tiktok: {
          tiktokHandle: '',
          tiktokFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        youtube: {
          youtubeHandle: '',
          youtubeFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        instagram: {
          instagramHandle: '',
          instagramFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        }
      },
      editInfluencerData: null,
      showWordCloud: false,
      words: [],
      loading: false,
      showWordCloudError: false,
      showWordCloudButton: true,
      openExpansion: [0, 1, 2, 3],
      images: [],
      decksFiles: [],
      inputedRates: {
        igStatic: null,
        igCarousel: null,
        igStory: null,
        igTv: null,
        tiktok: null,
        blog: null,
        loadingFee: null,
        remark: '',
        pricingDecks: []
      },
      isLoading: false,
      processEdit: false,
      excludeTitles: ['Do you have more travel plan?', 'Do you still have more travel plan?', 'respondentId', 'submissionId']
    };
  },

  watch: {
    influencerData: function influencerData(newInfluencerData) {
      this.influencer = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newInfluencerData);

      this.getUserProfile();
    },
    value: function value(newVal) {
      if (newVal) {
        this.changeMode('view');
      }
    }
  },
  computed: {
    isViewMode: function isViewMode() {
      return this.currentMode === 'view';
    },
    isEditMode: function isEditMode() {
      return this.currentMode === 'edit';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.userGender_options = {};
    __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userGenderDisplay.forEach(function (element) {
      _this.userGender_options[element.value] = element.text;
    });
    this.changeMode('view');
  },

  methods: {
    isMainPlatform: function isMainPlatform(platform) {
      var mainPlatform = String(this.influencer && (this.influencer.activePlatform || this.influencer.platform) || '').toLowerCase();
      return mainPlatform === platform;
    },
    getXiaohongshuData: function getXiaohongshuData() {
      var xiaohongshu = this.influencer && this.influencer.xiaohongshu;
      return xiaohongshu && xiaohongshu.xiaohongshu ? xiaohongshu.xiaohongshu : xiaohongshu;
    },
    getSocialMetric: function getSocialMetric(metric) {
      var facebook = this.influencer && this.influencer.facebook;
      var platforms = [this.influencer && this.influencer.tiktok, this.influencer && this.influencer.youtube, this.getXiaohongshuData(), facebook && facebook.facebook ? facebook.facebook : facebook, this.influencer && this.influencer.linkedin, this.influencer && this.influencer.twitter, this.influencer && this.influencer.instagram];
      var platform = platforms.find(function (item) {
        return item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' && item[metric] !== undefined && item[metric] !== null && item[metric] !== '';
      });

      return platform ? platform[metric] : '-';
    },
    close: function close() {
      this.$emit('input');
    },
    getUserProfile: function getUserProfile() {
      var _this2 = this;

      this.images = [];
      this.decksFiles = [];
      this.inputedRates = {};
      if (!this.influencer.userID) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__User_userAPIs__["a" /* default */].getUser(this.influencer.userID).then(function (response) {
        var profile = response.influencer || {};
        _this2.influencer = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.influencer, {
          bankName: profile.bankName || _this2.influencer.bankName,
          bankAccount: profile.bankAccount || _this2.influencer.bankAccount,
          swiftCode: profile.swiftCode || _this2.influencer.swiftCode,
          country: profile.country || _this2.influencer.country,
          mailingAddress: profile.mailingAddress || _this2.influencer.mailingAddress,
          postalCode: profile.postalCode || _this2.influencer.postalCode
        });
        if (response.influencer.inputedRates) {
          _this2.inputedRates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, response.influencer.inputedRates);

          if (_this2.inputedRates.pricingDecks && _this2.inputedRates.pricingDecks.length > 0) {
            _this2.inputedRates.pricingDecks.map(function (item) {
              var mediaType = item.type.split('/')[0];
              if (mediaType === 'image') {
                _this2.images.push(item);
              } else {
                _this2.decksFiles.push(item);
              }
            });
          }
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    createInfluencerWordCloud: function createInfluencerWordCloud() {
      var _this3 = this;

      this.words = [];
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].getWordcloud(this.influencerData.id).then(function (response) {
        _this3.words = response;
        _this3.showWordCloud = true;
        _this3.loading = false;
        _this3.showWordCloudError = false;
      }).catch(function (error) {
        console.log('Error in creating wordcloud: ' + error);
        _this3.showWordCloudError = true;
        _this3.loading = false;
        _this3.showWordCloudButton = false;
      });
      this.$on('update:progress', function () {
        console.log('Progress Event');
      });
    },

    getRandomColor: function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getRandomRotation: function getRandomRotation(min, max) {
      return Math.random() * (max - min) + min;
    },
    clearWords: function clearWords() {
      this.showWordCloud = false;
      this.words = [];
      this.loading = false;
      this.showWordCloudError = false;
      this.showWordCloudButton = true;
    },
    changeModeCustom: function changeModeCustom(mode) {
      if (mode === 'view') {
        this.editInfluencerData = null;
      } else {
        this.editInfluencerData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.influencer);
      }
      this.changeMode(mode);
    },
    showLoading: function showLoading(status) {
      this.isLoading = status;
    },
    processEdit: function processEdit() {
      this.processEdit = true;
    },
    formatInfKeywords: function formatInfKeywords(keywords) {
      if (keywords) {
        if (typeof keywords === 'string') {
          return keywords.split(',');
        }
      }
      return keywords;
    }
  }
});

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Post_postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CreateInfluencerModal__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CreateInfluencerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CreateInfluencerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditInfluencerModal__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditInfluencerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__EditInfluencerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewInfluencerModal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewInfluencerModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ViewInfluencerModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AudienceDataReportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__InfluencerPostsModal__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__InfluencerPostsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__InfluencerPostsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ViewInfluencerCompanyModal__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ViewInfluencerCompanyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ViewInfluencerCompanyModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__InfPlatforms_ViewModal_vue__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__InfPlatforms_ViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__InfPlatforms_ViewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__User_InfResetPasswordModal_vue__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__User_InfResetPasswordModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__User_InfResetPasswordModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_uniq__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_uniq__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'influencer',
  components: {
    CreateInfluencerModal: __WEBPACK_IMPORTED_MODULE_10__CreateInfluencerModal___default.a,
    EditInfluencerModal: __WEBPACK_IMPORTED_MODULE_11__EditInfluencerModal___default.a,
    ViewInfluencerModal: __WEBPACK_IMPORTED_MODULE_12__ViewInfluencerModal___default.a,
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_13__AudienceDataReportModal___default.a,
    InfluencerPostModal: __WEBPACK_IMPORTED_MODULE_14__InfluencerPostsModal___default.a,
    ViewInfluencerCompanyModal: __WEBPACK_IMPORTED_MODULE_15__ViewInfluencerCompanyModal___default.a,
    InfPlatformsViewModal: __WEBPACK_IMPORTED_MODULE_16__InfPlatforms_ViewModal_vue___default.a,
    InfResetPasswordModal: __WEBPACK_IMPORTED_MODULE_17__User_InfResetPasswordModal_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      viewInfluencerDialog: false,
      editInfluencerDialog: false,
      viewAudienceDataDialog: false,
      infPassResetDialog: false,
      viewAudHandle: '',
      viewAudPlatform: '',
      createModalId: 'create_influencer_modal',
      editModalId: 'edit_influencer_modal',
      viewCompanyModalId: 'view_influencer_company_modal',
      influencerPostModalId: 'influencerPostModalId',
      editInfluencerData: null,
      viewInfluencerData: null,
      audienceDataReport: null,
      viewInfluencerData_company: null,
      sortBy: 'name',
      influencerGeos: [],
      infCategories: __WEBPACK_IMPORTED_MODULE_18__influencerHelper__["a" /* default */].getCategories(),
      infCategory: [],
      search: null,
      expand: false,
      shouldCallApi: false,
      loading: false,
      isLoading: false,
      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: ['audienceCredibility'],
        itemsPerPage: 20
      },
      totalItems: 0,
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      postsTitle: '',
      avatarSize: 30,
      countries: [],
      shortCodes: [],
      sortDesc: false,
      platforms: ['Instagram', 'Facebook'],
      selectedPlatform: 'instagram',
      platformList: [{
        text: 'Instagram',
        value: 'instagram'
      }, {
        text: 'TikTok',
        value: 'tiktok'
      }, {
        text: 'Youtube',
        value: 'youtube'
      }, {
        text: 'Xiaohongshu',
        value: 'xiaohongshu'
      }, {
        text: 'Facebook',
        value: 'facebook'
      }, {
        text: 'LinkedIn',
        value: 'linkedin'
      }, {
        text: 'X (Twitter)',
        value: 'twitter'
      }],
      platformFilterOptions: [{ text: 'Instagram', filterKey: 'hasIG', icon: 'mdi-instagram', iconColor: '#E4405F' }, { text: 'TikTok', filterKey: 'hasTikTok', imgIcon: '/static/img/tiktok-32.png' }, { text: 'YouTube', filterKey: 'hasYoutube', icon: 'mdi-youtube', iconColor: '#ff0000' }, { text: 'XHS', filterKey: 'hasXHS', imgIcon: '/static/img/xhs-black.png' }, { text: 'Facebook', filterKey: 'hasFb', icon: 'mdi-facebook', iconColor: '#1877f2' }, { text: 'LinkedIn', filterKey: 'hasLinkedIn', icon: 'mdi-linkedin', iconColor: '#0a66c2' }, { text: 'X (Twitter)', filterKey: 'hasTwitter', imgIcon: '/static/img/x-logo.svg' }],
      viewPlatforms: [],
      selectedInfluencerID: '',
      searchInfID: '',
      fields: [{
        value: 'fullName',
        text: 'Full Name',
        sortable: false
      }, {
        value: 'email',
        text: 'Email',
        sortable: false
      }, {
        value: 'igHandle',
        text: 'Instagram Handle',
        sortable: false
      }, {
        value: 'tiktokHandle',
        text: 'TikTok Handle',
        sortable: false
      }, {
        value: 'youtubeHandle',
        text: 'Youtube Handle',
        sortable: false
      }, {
        value: 'fbHandle',
        text: 'FB Handle',
        sortable: false
      }, {
        value: 'xhsHandle',
        text: 'XHS Handle',
        sortable: false
      }, {
        value: 'linkedinHandle',
        text: 'LinkedIn Handle',
        sortable: false
      }, {
        value: 'twitterHandle',
        text: 'X (Twitter) Handle',
        sortable: false
      }, {
        value: 'joinedAt',
        text: 'Joint At',
        sortable: false
      }, {
        value: 'lastLoginAt',
        text: 'Last Login At',
        sortable: false
      }, {
        value: 'action',
        text: 'Actions'
      }],

      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      dialog: false,
      items: [],
      users: [],
      searchFilter: {
        hasIG: false,
        hasTikTok: false,
        hasYoutube: false,
        hasXHS: false,
        hasFb: false,
        hasLinkedIn: false,
        hasTwitter: false,
        pendingApproval: false
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      keyword: '',
      fromAge: '',
      toAge: '',
      fromFol: '',
      toFol: '',
      fromEng: '',
      toEng: '',
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      selectedCountries: ['all'],
      resultMessage: '',
      joinedMonth: '',
      monthPicker: false,
      showLoading: false,
      infPlatformsDialog: false,
      reportLink: '',
      linkCopied: false
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.lastUpdate).fromNow();
    },
    createModalIdDisplay: function createModalIdDisplay() {
      return '#' + this.createModalId;
    },
    editModalIdDisplay: function editModalIdDisplay() {
      return '#' + this.editModalId;
    },
    viewCompanyModalIdDisplay: function viewCompanyModalIdDisplay() {
      return '#' + this.viewCompanyModalId;
    },
    influencerPostDisplay: function influencerPostDisplay() {
      return '#' + this.influencerPostModalId;
    },
    availableCountries: function availableCountries() {
      return __WEBPACK_IMPORTED_MODULE_21_lodash_uniq___default()(this.searchedItems.map(function (item) {
        return item.country;
      }));
    },
    payload: function payload() {
      return {
        filter: {
          geo: this.influencerGeos,
          audience_geo: null,
          igHandle: this.igHandle,
          joinedMonth: this.joinedMonth,
          platform: this.selectedPlatform,
          influencerID: this.searchInfID,
          hasIG: this.searchFilter.hasIG,
          hasTikTok: this.searchFilter.hasTikTok,
          hasYoutube: this.searchFilter.hasYoutube,
          hasXHS: this.searchFilter.hasXHS,
          hasFb: this.searchFilter.hasFb,
          hasLinkedIn: this.searchFilter.hasLinkedIn,
          hasTwitter: this.searchFilter.hasTwitter,
          pendingApproval: this.searchFilter.pendingApproval
        },
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    }
  },
  watch: {
    pagination: function pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    }
  },
  methods: {
    togglePlatformFilter: function togglePlatformFilter(filterKey) {
      this.$set(this.searchFilter, filterKey, !this.searchFilter[filterKey]);
      this.paginate();
    },
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    getCountries: function getCountries() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].getCountries().then(function (countries) {
        _this.countries = countries.map(function (item) {
          return item.name;
        });
      });
    },
    updateItems: function updateItems(response) {
      var _this2 = this;

      var displayItems = response.influencers.map(function (element) {
        var item = {
          id: element._id || element.id,
          instagramID: element.instagram ? element.instagram.instagramID : null,
          instagramFullname: element.fullName || (element.instagram ? element.instagram.instagramFullname : null),
          tiktokID: element.tiktok ? element.tiktok.tiktokID : null,
          tiktokFullname: element.fullName || (element.tiktok ? element.tiktok.tiktokFullname : null),
          youtubeID: element.youtube ? element.youtube.youtubeID : null,
          youtubeFullname: element.fullName || (element.youtube ? element.youtube.youtubeFullname : null),
          xhsID: element.xiaohongshu ? element.xiaohongshu.xhsID : null,
          xhsFullname: element.xiaohongshu ? element.xiaohongshu.xhsFullname : null,
          fbID: element.facebook ? element.facebook.facebookId : null,
          fbFullname: element.facebook ? element.facebook.name : null,
          linkedinFullname: element.linkedin ? element.linkedin.linkedinFullname : null,
          fullName: element.fullName,
          email: element.email,
          joinedAt: _this2.formatTime(element.createdAt),
          posts: element.posts || [],
          audience: element.audience || {},
          tiktokaudience: element.tiktokaudience || {},
          youtubeaudience: element.youtubeaudience || {},
          instagram: element.instagram || {},
          tiktok: element.tiktok || null,
          youtube: element.youtube || null,
          xiaohongshu: element.xiaohongshu || null,
          facebook: element.facebook || null,
          linkedin: element.linkedin || null,
          twitter: element.twitter || null,
          gender: element.gender,
          birthday: element.birthday || 'None',
          keywords: element.keywords,
          mailingAddress: element.mailingAddress || 'None',
          bankAccount: element.bankAccount || 'None',
          bankName: element.bankName || 'None',
          swiftCode: element.swiftCode || '',
          country: element.country || 'None',
          relevancyScore: element.relevancyScore ? Number(element.relevancyScore).toFixed(2) : 0,
          tallySub: element.tallySub || {},
          lastLoginAt: element.lastLoginAt || ''
        };
        if (element.tiktok) {
          item.tiktokHandle = element.tiktok ? element.tiktok.tiktokHandle : null;
          item.tiktokProfilePicture = element.tiktokaudience && element.tiktokaudience.user_profile ? element.tiktokaudience.user_profile.picture : '/static/img/avatar/user.png';
          item.tiktokTotalFollowers = element.tiktok ? element.tiktok.totalFollowers : 0;
          item.tiktokTotalFollowing = element.tiktok ? element.tiktok.totalFollowing : 0;
          item.engagementRate = element.tiktokaudience && element.tiktokaudience.user_profile ? (Number(element.tiktokaudience.user_profile.engagement_rate) * 100).toFixed(2) : 0;
          item.audienceCredibility = 'N/A';
        }
        if (element.youtube) {
          item.youtubeHandle = element.youtube ? element.youtube.youtubeHandle : null;
          item.youtubeProfilePicture = element.youtubeaudience && element.youtubeaudience.user_profile ? element.youtubeaudience.user_profile.picture : '/static/img/avatar/user.png';
          item.youtubeTotalFollowers = element.youtube ? element.youtube.totalFollowers : 0;
          item.youtubeTotalFollowing = element.youtube ? element.youtube.totalFollowing : 0;
          item.engagementRate = element.youtubeaudience && element.youtubeaudience.user_profile ? (Number(element.youtubeaudience.user_profile.engagement_rate) * 100).toFixed(2) : 0;
          item.audienceCredibility = 'N/A';
        }
        if (element.facebook) {
          item.fbHandle = element.facebook ? element.facebook.handle : null;
          item.fbProfilePicture = element.facebook ? element.facebook.profilePicture : '/static/img/avatar/user.png';
          item.fbTotalFollowers = element.facebook ? element.facebook.totalFollowers : 0;
          item.fbTotalFollowing = element.facebook ? element.facebook.totalFollowing : 0;
          item.engagementRate = '';
          item.audienceCredibility = 'N/A';
          if (!item.fullName) {
            item.fullName = element.facebook ? element.facebook.name : '';
          }
        }
        if (element.xiaohongshu) {
          item.xhsHandle = element.xiaohongshu ? element.xiaohongshu.xhsHandle : null;
          item.xhsFullname = element.xiaohongshu ? element.xiaohongshu.xhsFullname : '';
          item.xhsID = element.xiaohongshu ? element.xiaohongshu.xhsID : '';
          item.xhsProfilePicture = element.xiaohongshu ? element.xiaohongshu.profilePicture : '/static/img/avatar/user.png';
          item.xhsTotalFollowers = element.xiaohongshu ? element.xiaohongshu.totalFollowers : 0;
          item.xhsTotalFollowing = element.xiaohongshu ? element.xiaohongshu.totalFollowing : 0;
          item.engagementRate = '';
          item.audienceCredibility = 'N/A';
          if (!item.fullName) {
            item.fullName = element.xiaohongshu ? element.xiaohongshu.xhsFullname : '';
          }
        }
        if (element.linkedin) {
          item.linkedinHandle = element.linkedin.linkedinHandle || null;
          item.linkedinProfilePicture = '/static/img/avatar/user.png';
          item.linkedinTotalFollowers = element.linkedin.totalFollowers || 0;
          item.engagementRate = '';
          item.audienceCredibility = 'N/A';
          if (!item.fullName) {
            item.fullName = element.linkedin.linkedinFullname || '';
          }
        }
        if (element.twitter) {
          item.twitterHandle = element.twitter.twitterHandle || null;
          item.twitterProfilePicture = '/static/img/avatar/user.png';
          item.twitterTotalFollowers = element.twitter.totalFollowers || 0;
          item.twitterTotalFollowing = element.twitter.totalFollowing || 0;
          item.engagementRate = '';
          item.audienceCredibility = 'N/A';
          if (!item.fullName) item.fullName = element.twitter.twitterFullname || '';
        }
        if (element.instagram) {
          item.igHandle = element.instagram ? element.instagram.instagramHandle : null;
          item.igProfilePicture = element.audience && element.audience.user_profile ? element.audience.user_profile.picture : '/static/img/avatar/user.png';
          item.totalFollowers = element.instagram ? element.instagram.totalFollowers : 0;
          item.totalFollowing = element.instagram ? element.instagram.totalFollowing : 0;
          item.engagementRate = element.audience && element.audience.user_profile ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2) : 0;
          item.audienceCredibility = element.audience && element.audience.audience_followers && element.audience.audience_followers.success ? Number(element.audience.audience_followers.data.audience_credibility * 100).toFixed(2) : 0;
        }
        return item;
      });
      this.items = displayItems;
      this.totalRows = response.totalInfluencers;

      this.searchedItems = displayItems;
    },
    paginate: function paginate() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      this.payload.paging.page = page;
      this.loading = true;
      this.shouldCallApi = false;
      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].paginate(this.payload).then(function (response) {
        _this3.updateItems(response);
        _this3.pagination.data = response.influencers;
        _this3.resultMessage = 'Showing [' + _this3.perPage + '] per page of total [' + _this3.totalRows + '] influencers result.';
        _this3.totalItems = _this3.totalRows;
        if (_this3.pagination.itemsPerPage === -1) {
          _this3.pagination.itemsPerPage = 20;
        }
        _this3.loading = false;
        setTimeout(function () {
          _this3.shouldCallApi = true;
        }, 1000);
        if (_this3.$route.query.id) {
          _this3.getInfluencerDataToView(_this3.$route.query.id, null);
        }
      }).catch(function (error) {
        _this3.loading = false;
        console.log(error);
      });
    },
    createInfluencer: function createInfluencer(influencerData) {
      this.getAllInfluencers(true);
    },
    deleteInfluencer: function deleteInfluencer(influencerID) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var matchInf, searchInfluencers, posts, pairings, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, inf, resp, htmlTxt;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                matchInf = _this4.items.find(function (item) {
                  return item.id === influencerID;
                });

                if (!matchInf) {
                  _context.next = 42;
                  break;
                }

                searchInfluencers = [];

                if (matchInf.igHandle) {
                  searchInfluencers.push({
                    handle: matchInf.igHandle,
                    platform: 'instagram',
                    influencerID: matchInf.id
                  });
                }
                if (matchInf.tiktokHandle) {
                  searchInfluencers.push({
                    handle: matchInf.tiktokHandle,
                    platform: 'tiktok',
                    influencerID: matchInf.id
                  });
                }
                if (matchInf.youtubeHandle) {
                  searchInfluencers.push({
                    handle: matchInf.youtubeHandle,
                    platform: 'youtube',
                    influencerID: matchInf.id
                  });
                }
                if (matchInf.fbHandle) {
                  searchInfluencers.push({
                    handle: matchInf.fbHandle,
                    platform: 'facebook',
                    influencerID: matchInf.id
                  });
                }
                _this4.isLoading = true;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__Post_postApi__["a" /* default */].getPostsByInfluencers(searchInfluencers);

              case 10:
                posts = _context.sent;
                pairings = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 15;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(searchInfluencers);

              case 17:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 26;
                  break;
                }

                inf = _step.value;
                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_8__Pairing_pairingAPIs__["a" /* default */].getPairingsByInfluencerID(inf.influencerID);

              case 21:
                resp = _context.sent;

                if (resp) {
                  (function () {
                    var respIDs = resp.map(function (r) {
                      return r.id;
                    });
                    var isPairingExists = pairings.find(function (p) {
                      return respIDs.includes(p.id);
                    });
                    if (!isPairingExists) {
                      pairings.push.apply(pairings, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(resp));
                    }
                  })();
                }

              case 23:
                _iteratorNormalCompletion = true;
                _context.next = 17;
                break;

              case 26:
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context['catch'](15);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 32:
                _context.prev = 32;
                _context.prev = 33;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 35:
                _context.prev = 35;

                if (!_didIteratorError) {
                  _context.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context.finish(35);

              case 39:
                return _context.finish(32);

              case 40:
                matchInf.totalPosts = posts.length;
                matchInf.totalPairings = pairings.length;

              case 42:
                _this4.isLoading = false;
                htmlTxt = 'Are you sure you want to delete this influencer? This action cannot be undone.<br>';

                htmlTxt += 'Total Posts: ' + matchInf.totalPosts + '<br>';
                htmlTxt += 'Total Pairings: ' + matchInf.totalPairings;
                _this4.$swal({
                  title: 'Double Check!',
                  html: htmlTxt,
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function (result) {
                  if (result.value) {
                    _this4.loading = true;
                    __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].deleteInfluencer(influencerID).then(function (response) {
                      _this4.items = _this4.items.filter(function (influencer) {
                        return influencer.id !== influencerID;
                      });
                    }).catch(function (error) {
                      _this4.loading = false;
                      console.log('error', error);
                    });
                    _this4.loading = false;
                  }
                });

              case 47:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[15, 28, 32, 40], [33,, 35, 39]]);
      }))();
    },
    getInfluencerDataToEdit: function getInfluencerDataToEdit(influencerID) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (response) {
        if (response) {
          var influencerUserData = _this5.users.find(function (u) {
            return u.influencerID === response.id;
          });
          if (influencerUserData) {
            response.userID = influencerUserData.id || '';
            response.firstName = influencerUserData.firstName || '';
            response.lastName = influencerUserData.lastName || '';
          }
          _this5.editInfluencerData = response;
          _this5.editInfluencerDialog = true;
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getInfluencerDataToView: function getInfluencerDataToView(influencerID, infItem) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (response) {
        var influencerUserData = _this6.users.find(function (u) {
          return u.influencerID === response.id;
        });
        if (influencerUserData) {
          response.userID = influencerUserData.id || '';
          response.firstName = influencerUserData.firstName || '';
          response.lastName = influencerUserData.lastName || '';

          response.platform = influencerUserData.platform || response.platform || '';
        }
        if (response.facebook) {
          var matchFb = _this6.items.find(function (i) {
            return i.facebook && i.facebook.id === response.facebook.id;
          });
          if (matchFb) response.facebook = matchFb.facebook;
        }
        if (response.xiaohongshuID) {
          var matchXHS = _this6.items.find(function (i) {
            return i.xiaohongshu && i.xiaohongshu.id === response.xiaohongshuID;
          });
          if (matchXHS) response.xiaohongshu = matchXHS;
        }
        if (infItem) {
          if (infItem.tallySub) {
            response.tallySub = infItem.tallySub;
            delete response.tallySub._id;
            delete response.tallySub.influencerID;
          }
        }
        _this6.viewInfluencerData = response;
        _this6.viewInfluencerDialog = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    viewInfluencerPosts: function viewInfluencerPosts(item) {
      var posts = item.posts || [];
      if (posts.length > 0) {
        this.shortCodes = posts.map(function (item) {
          return item.shortCode;
        });
        document.getElementById('viewPosts').click();
        this.postsTitle = 'Related Posts(' + item.instagramHandle + ')';
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return '/static/img/avatar/user.png';
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    showReport: function showReport(influencer, platform) {
      var _this7 = this;

      this.isLoading = true;
      this.viewAudHandle = '';
      this.viewAudPlatform = '';
      this.audienceDataReport = null;
      var audID = null;
      var handle = null;
      if (platform === 'tiktok') {
        audID = influencer.tiktokaudience ? influencer.tiktokaudience.id : null;
        handle = influencer.tiktokHandle;
      } else if (platform === 'youtube') {
        audID = influencer.youtubeaudience ? influencer.youtubeaudience.id : null;
        handle = influencer.youtubeHandle;
      } else {
        audID = influencer.audience ? influencer.audience.id : null;
        handle = influencer.igHandle;
      }
      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].fetchLocalAudienceReportByAudID(audID, handle, platform).then(function (resp) {
        _this7.audienceDataReport = resp.data;
        _this7.viewAudienceDataDialog = true;
        _this7.viewAudHandle = handle;
        _this7.viewAudPlatform = platform;
        _this7.isLoading = false;
      }).catch(function (err) {
        _this7.viewAudienceDataDialog = true;
        _this7.isLoading = false;
        console.error(err);
      });
    },
    getCompanyDataToView: function getCompanyDataToView(influencerData) {
      this.viewInfluencerData_company = influencerData;
      document.getElementById('viewCompany').click();
    },
    getPlatformDataToView: function getPlatformDataToView(influencerData) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].getInfluencer(influencerData.id).then(function (response) {
        _this8.viewPlatforms = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.refreshJSON(_this8.platformList);
        _this8.selectedInfluencerID = influencerData.id;
        _this8.viewInfluencerData = response;
        _this8.viewPlatforms = _this8.viewPlatforms.map(function (p) {
          var platformData = response[p.value] || influencerData[p.value];
          if (platformData && platformData.id) {
            p.connected = true;
            p.requested = false;
            switch (p.value) {
              case 'tiktok':
                p.handle = platformData.tiktokHandle;
                break;
              case 'youtube':
                p.handle = platformData.youtubeHandle;
                break;
              case 'xiaohongshu':
                p.handle = platformData.xhsHandle;
                break;
              case 'facebook':
                p.handle = platformData.handle;
                break;
              case 'linkedin':
                p.handle = platformData.linkedinHandle;
                break;
              case 'twitter':
                p.handle = _this8.normalizeTwitterHandle(platformData.twitterHandle);
                break;
              default:
                p.handle = platformData.instagramHandle;
                break;
            }
          }
          if ((!response.instagram || !response.instagram.instagramHandle) && p.value === 'instagram' && response.reqIgHandle) {
            p.handle = response.reqIgHandle;
            p.connected = false;
            p.requested = true;
          }
          if ((!response.tiktok || !response.tiktok.tiktokHandle) && p.value === 'tiktok' && response.reqTikTokHandle) {
            p.handle = response.reqTikTokHandle;
            p.connected = false;
            p.requested = true;
          }
          if ((!response.youtube || !response.youtube.youtubeHandle) && p.value === 'youtube' && response.reqYoutubeHandle) {
            p.handle = response.reqYoutubeHandle;
            p.connected = false;
            p.requested = true;
          }
          if (!p.connected && p.value === 'linkedin' && response.reqLinkedinHandle) {
            p.handle = response.reqLinkedinHandle;
            p.connected = false;
            p.requested = true;
          }
          return p;
        });
        _this8.infPlatformsDialog = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    normalizeTwitterHandle: function normalizeTwitterHandle(value) {
      var handle = String(value || '').trim();
      var twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i);
      if (twitterUrl) handle = twitterUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    editInfluencer: function editInfluencer(influencerData) {
      var selectedIndex = -1;

      this.items.forEach(function (influencer, index) {
        if (influencer.id === influencerData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, influencerData);
      }

      console.log('influencer edited');
      this.getUsers();
    },
    exportInfluencers: function exportInfluencers() {
      var _this9 = this;

      this.showLoading = true;
      __WEBPACK_IMPORTED_MODULE_6__influencerAPIs__["a" /* default */].exportInfluencersByFilter(this.payload).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'influencers_' + __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('X') + '.csv');
        document.body.appendChild(link);
        link.click();
        _this9.showLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this9.showLoading = false;
      });
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatDateTime: function formatDateTime(value) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format('MMM DD, YYYY hh:mm:ss');
    },
    filterItems: function filterItems() {
      var minAge = !this.fromAge ? 0 : this.fromAge;
      var maxAge = !this.toAge ? 150 : this.toAge;
      var minFol = !this.fromFol ? 0 : this.fromFol;
      var maxFol = !this.toFol ? 1000000000 : this.toFol;
      var minEng = !this.fromEng ? 0 : this.fromEng;
      var maxEng = !this.toEng ? 100 : this.toEng;
      var gender = this.filGender === 2 ? 'both' : this.filGender;
      var handle = this.igHandle;
      var countries = this.selectedCountries;

      var filteredItems = [];
      this.searchedItems.forEach(function (item, index) {
        var today = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY');
        var bd = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.birthday).format('YYYY');
        var age = today - bd;

        var countryStatus = false;
        countries.map(function (cnty) {
          if (cnty === item.country || cnty === 'all') {
            countryStatus = true;
          }
        });

        if (minAge <= age && maxAge >= age && minFol <= item.totalFollowers && maxFol >= item.totalFollowers && minEng <= item.engagementRate && maxEng >= item.engagementRate && (gender === item.gender || gender === 'both') && countryStatus && item.instagramHandle && (item.instagramHandle.includes(handle) || handle === '')) {
          filteredItems.push(item);
        }
      });

      this.items = filteredItems;
      this.resultMessage = 'Showing (Filtered Influencers) based on your searched results.';
    },
    resetFilters: function resetFilters() {
      this.fromAge = '';
      this.toAge = '';
      this.fromFol = '';
      this.toFol = '';
      this.fromEng = '';
      this.toEng = '';
      this.filGender = 'Any';
      this.igHandle = '';
      this.influencerGeos = [];
      this.paginate(this.currentPage);
    },
    reloadAll: function reloadAll() {
      this.currentPage = 1;
      this.perPage = 15;
      this.keyword = '';
      this.igHandle = '';
      this.joinedMonth = '';
      this.searchInfID = '';
      this.resetFilters();
    },
    remove: function remove(item) {
      this.influencerGeos.splice(this.influencerGeos.indexOf(item), 1);
      this.influencerGeos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.influencerGeos));
      this.paginate(this.currentPage);
    },
    removeCategory: function removeCategory(item) {
      this.infCategory.splice(this.infCategory.indexOf(item), 1);
      this.infCategory = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.infCategory));
    },
    joinedMonthOk: function joinedMonthOk() {
      this.$refs.monthPicker.save(this.joinedMonth);
      this.paginate(this.currentPage);
    },
    getUsers: function getUsers() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__User_userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].userRoles.INFLUENCER);

              case 2:
                response = _context2.sent;

                if (response) {
                  _this10.users = response.users;
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },
    showLoadingEvent: function showLoadingEvent(status) {
      this.isLoading = status;
    },
    copyLink: function copyLink(item) {
      var protocol = window.location.protocol;
      var host = window.location.host;
      var vm = this;
      if (item) {
        this.reportLink = protocol + '//' + host + '/creators/travel?';
        if (item.tiktokHandle) this.reportLink += 'tiktokHandle=' + item.tiktokHandle + '&';
        if (item.igHandle) this.reportLink += 'igHandle=' + item.igHandle + '&';
        this.reportLink += 'influencerID=' + item.id + '&';
        setTimeout(function () {
          item.linkCopied = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.copyToClipboard('#copy-reportlink');
        }, 100);
        setTimeout(function () {
          item.linkCopied = false;
        }, 1000);
      } else {
        this.reportLink = protocol + '//' + host + '/creators/travel';
        setTimeout(function () {
          vm.linkCopied = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.copyToClipboard('#copy-reportlink');
        }, 100);
        setTimeout(function () {
          vm.linkCopied = false;
        }, 1000);
      }
    },
    openResetDialog: function openResetDialog(item) {
      if (!item.email) {
        this.$swal({
          title: 'Empty Email',
          text: 'Please update email to reset password.',
          type: 'warning'
        });
        return;
      }
      this.viewInfluencerData = item;
      this.infPassResetDialog = true;
    }
  },
  created: function created() {
    if (this.$route.query.id) {
      this.searchInfID = this.$route.query.id;
    }
    this.paginate(this.currentPage);
    this.getCountries();
    this.userGender_options = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].userGenderDisplay;
    this.getUsers();
  }
});

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentAnalysis_contentAnalysisAPI__ = __webpack_require__(127);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerPostModal',
  props: ['modalId', 'title', 'shortCodes'],
  data: function data() {
    return {
      posts: []
    };
  },

  watch: {
    shortCodes: function shortCodes(newValue) {
      this.shortCodes = newValue;
      this.posts = [];
      this.retrivePost();
    }
  },
  methods: {
    retrivePost: function retrivePost() {
      var _this = this;

      this.shortCodes.forEach(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(code) {
          var oembed;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_2__ContentAnalysis_contentAnalysisAPI__["a" /* default */].oembed(code);

                case 2:
                  oembed = _context.sent;

                  _this.posts.push(oembed);
                  setTimeout(function () {
                    window.instgrm.Embeds.process();
                  }, 100);

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__influencerSearchAPIs__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Influencer_AudienceDataReportModal__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Influencer_AudienceDataReportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Influencer_AudienceDataReportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfluencerPostsModal__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfluencerPostsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InfluencerPostsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_uniq__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_uniq__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'influencer',
  components: {
    AudienceDataReportModal: __WEBPACK_IMPORTED_MODULE_5__Influencer_AudienceDataReportModal___default.a,
    InfluencerPostModal: __WEBPACK_IMPORTED_MODULE_6__InfluencerPostsModal___default.a
  },
  data: function data() {
    return {
      audienceDataReportId: 'audience_data_report_modal',
      influencerPostModalId: 'influencerPostModalId',
      audienceDataReport: null,
      sortBy: 'name',
      influencerGeos: [],
      search: null,
      expand: false,
      shouldCallApi: false,
      loading: false,
      pagination: {
        descending: true,
        page: 1,
        sortBy: '',
        rowsPerPage: 20,
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100]
      },
      postsTitle: '',
      avatarSize: 45,
      countries: ['Singapore', 'Thailand', 'Indonesia', 'Philippines'],
      shortCodes: [],
      sortDesc: false,
      fields: [{
        text: 'Avatar',
        sortable: false
      }, {
        value: 'instagramHandle',
        text: 'Handle',
        sortable: false
      }, {
        value: 'instagramFullname',
        text: 'Fullname',
        sortable: false
      }, {
        value: 'totalFollowers',
        text: 'Followers'
      }, {
        value: 'totalFollowing',
        text: 'Following',
        sortable: false
      }, {
        value: 'joinedAt',
        text: 'Joined At',
        sortable: false
      }],

      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      dialog: false,
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      keyword: '',
      fromAge: '',
      toAge: '',
      fromFol: '',
      toFol: '',
      fromEng: '',
      toEng: '',
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      selectedCountries: ['all'],
      resultMessage: ''
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.lastUpdate).fromNow();
    },
    audienceDataReportDisplay: function audienceDataReportDisplay() {
      return '#' + this.audienceDataReportId;
    },
    influencerPostDisplay: function influencerPostDisplay() {
      return '#' + this.influencerPostModalId;
    },
    availableCountries: function availableCountries() {
      return __WEBPACK_IMPORTED_MODULE_7_lodash_uniq___default()(this.searchedItems.map(function (item) {
        return item.country;
      }));
    },
    payload: function payload() {
      return {
        filter: {
          geo: this.influencerGeos,
          audience_geo: null,
          igHandle: this.igHandle
        },
        paging: {
          per_page: this.pagination.rowsPerPage <= 0 ? 20 : this.pagination.rowsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy,
          descending: this.pagination.descending
        }
      };
    },
    searchKeywordPayload: function searchKeywordPayload() {
      return {
        keyword: this.keyword,
        negative_keyword: this.negativeKeyword,
        negative_period: this.negativePeriod,
        opt_in_only: this.optInOnly,
        search_duration: this.searchDuration,
        search_image: false,
        search_nlu: this.searchNlu
      };
    }
  },
  watch: {
    pagination: function pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    }
  },
  methods: {
    buttonShow: function buttonShow(type) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */]['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    updateItems: function updateItems(response) {
      var _this = this;

      var displayItems = response.influencers.map(function (element) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ id: element.id }, {
          instagramHandle: element.instagram ? element.instagram.instagramHandle : null,
          instagramID: element.instagram ? element.instagram.instagramID : null,
          instagramFullname: element.fullName || element.instagram ? element.instagram.instagramFullname : null,
          totalFollowers: element.instagram ? element.instagram.totalFollowers : 0,
          totalFollowing: element.instagram ? element.instagram.totalFollowing : 0,
          joinedAt: _this.formatTime(element.createdAt),
          posts: element.posts || [],
          audience: element.audience || {},
          profilePicture: element.audience && element.audience.user_profile ? element.audience.user_profile.picture || '/static/img/avatar/user.png' : '/static/img/avatar/user.png',
          instagram: element.instagram || {},
          gender: element.gender,
          birthday: element.birthday || 'None',
          mailingAddress: element.mailingAddress || 'None',
          bankAccount: element.bankAccount || 'None',
          bankName: element.bankName || 'None',
          country: element.country || 'None',
          engagementRate: element.audience && element.audience.user_profile ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2) : 0
        });
      });
      this.items = displayItems;
      this.totalRows = response.totalInfluencers;

      this.searchedItems = displayItems;
    },
    paginate: function paginate() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      this.payload.paging.page = page;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_4__influencerSearchAPIs__["a" /* default */].paginate(this.payload).then(function (response) {
        _this2.updateItems(response);
        _this2.resultMessage = 'Showing [' + _this2.perPage + '] per page of total [' + _this2.totalRows + '] influencers result.';
        _this2.pagination.totalItems = _this2.totalRows;
        if (_this2.pagination.rowsPerPage === -1) {
          _this2.pagination.rowsPerPage = 20;
        }
        _this2.shouldCallApi = true;
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
        console.log(error);
      });
    },
    viewInfluencerPosts: function viewInfluencerPosts(item) {
      var posts = item.posts || [];
      if (posts.length > 0) {
        this.shortCodes = posts.map(function (item) {
          return item.shortCode;
        });
        document.getElementById('viewPosts').click();
        this.postsTitle = 'Related Posts(' + item.instagramHandle + ')';
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    showReport: function showReport(influencer) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__influencerSearchAPIs__["a" /* default */].fetchLocalAudienceReport(influencer.instagramID, influencer.instagramHandle).then(function (resp) {
        _this3.audienceDataReport = resp.data;
        document.getElementById('viewReport').click();
      }).catch(function (err) {
        console.error(err);
      });
    },
    editInfluencer: function editInfluencer(influencerData) {
      var selectedIndex = -1;

      this.items.forEach(function (influencer, index) {
        if (influencer.id === influencerData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, influencerData);
      }

      console.log('influencer edited');
    },
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    filterItems: function filterItems() {
      var minAge = !this.fromAge ? 0 : this.fromAge;
      var maxAge = !this.toAge ? 150 : this.toAge;
      var minFol = !this.fromFol ? 0 : this.fromFol;
      var maxFol = !this.toFol ? 1000000000 : this.toFol;
      var minEng = !this.fromEng ? 0 : this.fromEng;
      var maxEng = !this.toEng ? 100 : this.toEng;
      var gender = this.filGender === 2 ? 'both' : this.filGender;
      var handle = this.igHandle;
      var countries = this.selectedCountries;

      var filteredItems = [];
      this.searchedItems.forEach(function (item, index) {
        var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY');
        var bd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.birthday).format('YYYY');
        var age = today - bd;

        var countryStatus = false;
        countries.map(function (cnty) {
          if (cnty === item.country || cnty === 'all') {
            countryStatus = true;
          }
        });

        if (minAge <= age && maxAge >= age && minFol <= item.totalFollowers && maxFol >= item.totalFollowers && minEng <= item.engagementRate && maxEng >= item.engagementRate && (gender === item.gender || gender === 'both') && countryStatus && item.instagramHandle && (item.instagramHandle.includes(handle) || handle === '')) {
          filteredItems.push(item);
        }
      });

      this.items = filteredItems;
      this.resultMessage = 'Showing (Filtered Influencers) based on your searched results.';
    },
    resetFilters: function resetFilters() {
      this.fromAge = '';
      this.toAge = '';
      this.fromFol = '';
      this.toFol = '';
      this.fromEng = '';
      this.toEng = '';
      this.filGender = 'Any';
      this.igHandle = '';
      this.influencerGeos = [];
      this.paginate(this.currentPage);
    },
    searchByKeywords: function searchByKeywords() {
      var _this4 = this;

      if (this.keyword === '') {
        this.reloadAll();
      } else {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_4__influencerSearchAPIs__["a" /* default */].searchKeyword(this.searchKeywordPayload).then(function (response) {
          _this4.updateItems(response);
          _this4.perPage = response.totalInfluencers;
          _this4.pagination.totalItems = response.totalInfluencers;
          _this4.pagination.rowsPerPage = -1;
          _this4.shouldCallApi = false;
          _this4.loading = false;

          _this4.resultMessage = 'Showing related Influencers with your input " ' + _this4.keyword + ' "';
        }).catch(function (error) {
          _this4.loading = true;
          console.log(error);
        });
      }
    },
    reloadAll: function reloadAll() {
      this.currentPage = 1;
      this.perPage = 15;
      this.keyword = '';
      this.igHandle = '';
      this.resetFilters();
    },
    remove: function remove(item) {
      this.influencerGeos.splice(this.influencerGeos.indexOf(item), 1);
      this.influencerGeos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.influencerGeos));
    }
  },
  created: function created() {
    this.paginate(this.currentPage);
    this.userGender_options = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userGenderDisplay;
  }
});

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfluencerSocialData',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      selectedPlatform: 'instagram',
      platformList: [{
        text: 'Instagram',
        value: 'instagram'
      }, {
        text: 'TikTok',
        value: 'tiktok'
      }, {
        text: 'YouTube',
        value: 'youtube'
      }],
      userAccount: '',
      isLoading: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    download: function download() {
      var _this = this;

      if (this.userAccount.length > 0) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0__Influencer_influencerAPIs__["a" /* default */].downloadAudienceReportByInstagramHandle(this.userAccount, this.selectedPlatform).then(function () {
          _this.isLoading = false;
          _this.userAccount = '';
        }).catch(function () {
          _this.isLoading = false;
          _this.$swal({
            title: 'Error',
            text: 'Something went wrong',
            type: 'error'
          });
        });
      } else {
        this.$swal({
          title: 'Empty Instagram handle',
          text: 'Please Input a handle',
          type: 'error'
        });
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instagramAPIs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InstagramHandleAuth',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.isLoading = true;

    var authCode = this.$route.query.code;
    if (!authCode) {
      this.$router.push({ name: 'Profile' });
      this.isLoading = false;
    } else {
      __WEBPACK_IMPORTED_MODULE_1__instagramAPIs__["a" /* default */].handleInstagramAuthCallback(authCode).then(function (response) {
        _this.isLoading = false;
        if (response.success) {
          var data = response.data;
          var userData = data.userData;
          var jwtToken = data.jwtToken;

          var token = 'Bearer ' + jwtToken;

          _this.$store.commit('SET_USER', userData);
          _this.$store.commit('SET_TOKEN', token);

          if (window.localStorage) {
            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
            window.localStorage.setItem('token', token);
          }

          _this.$router.push(_this.$route.query.redirect ? _this.$route.query.redirect : { name: 'Profile' });
        } else {
          _this.$swal({
            title: 'Warning',
            text: response.message,
            type: 'warning'
          }).then(function () {
            return _this.$router.push({ name: 'Login' });
          });
        }
      }).catch(function (error) {
        _this.$swal({
          title: 'Error connecting to server.',
          text: 'Please kindly try again by different methods or contact us.',
          type: 'error'
        }).then(function () {
          return _this.$router.push({ name: 'Login' });
        });
        _this.isLoading = false;
        console.log('error', error);
      });
    }
  }
});

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__instagramAPIs__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a },
  name: 'InstagramHandleIntegrate',
  data: function data() {
    return {
      isLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var authCode = this.$route.query.code;
    var userID = this.$store.state.user.id;
    var facebookId = this.$store.state.user.facebookId;
    if (!authCode) {
      this.$router.push({ name: 'Profile' });
    } else {
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__instagramAPIs__["a" /* default */].handleInstagramIntegrateCallback(authCode, userID, facebookId).then(function (response) {
        _this.isLoading = false;
        var userData = response.userData;
        var jwtToken = response.jwtToken;

        var token = 'Bearer ' + jwtToken;

        _this.$store.commit('SET_USER', userData);
        _this.$store.commit('SET_TOKEN', token);

        if (window.localStorage) {
          window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userData));
          window.localStorage.setItem('token', token);
        }

        _this.$swal({
          title: 'Success',
          text: 'Your instagram has been connected.',
          type: 'success'
        }).then(function () {
          _this.$router.push(_this.$route.query.redirect ? _this.$route.query.redirect : { name: 'Profile' });
        });
      }).catch(function () {
        _this.$swal({
          title: 'Error',
          text: 'Something went wrong! Can not connect to your instagram account',
          type: 'error'
        }).then(function () {
          _this.$router.push(_this.$route.query.redirect ? _this.$route.query.redirect : { name: 'Profile' });
        });
      });
    }
  }
});

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_sunEditor__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_sunEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__editor_sunEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template__ = __webpack_require__(817);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContentScriptEditDialog',
  components: {
    SunEditor: __WEBPACK_IMPORTED_MODULE_2__editor_sunEditor___default.a
  },
  props: {
    value: Boolean,
    item: Object
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].func,
      editContent: ''
    };
  },

  watch: {
    value: function value(newValue) {
      if (newValue) {
        this.editContent = '';
        if (this.item) {
          if (this.item.contentScripts) {
            this.editContent = this.item.contentScripts;
          }
        }
      }
    }
  },
  methods: {
    save: function save() {
      this.editContent = this.editContent.replaceAll('background-color:transparent', '');
      this.item.contentScripts = this.editContent;
      this.$emit('saveClicked', this.item);
      this.$emit('input');
    },
    changeContent: function changeContent(content) {
      this.editContent = content;
    },
    restoreTemplate: function restoreTemplate() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.editContent = __WEBPACK_IMPORTED_MODULE_4__template__["a" /* default */].templateContents;

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    close: function close() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$swal({
                  title: 'Leave without saving changes?',
                  text: 'Your changes may not be saved.',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Leave',
                  cancelButtonText: 'Stay'
                });

              case 2:
                result = _context2.sent;

                if (result.value) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:

                _this2.$emit('input');

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ContentScriptEditDialog__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ContentScriptEditDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ContentScriptEditDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PostLinkUpdateModal__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PostLinkUpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__PostLinkUpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Campaign_campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_TableColsShowHideModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViewModalDialog__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViewModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ViewModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AMDashboard_speed_vue__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AMDashboard_speed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__AMDashboard_speed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__editor_generator_HTMLToPDF__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_pdfmake_build_pdfmake_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_pdfmake_build_pdfmake_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_pdfmake_build_pdfmake_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ContentWordGenerator__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ContentPDFGenerator__ = __webpack_require__(226);






























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PairedCreators',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_13__components_scoped_custom_SocialHandle___default.a,
    ContentScriptEditDialog: __WEBPACK_IMPORTED_MODULE_14__ContentScriptEditDialog___default.a,
    ViewCreatorConceptModalDialog: __WEBPACK_IMPORTED_MODULE_22__ViewModalDialog___default.a,
    PostLinkUpdateModal: __WEBPACK_IMPORTED_MODULE_15__PostLinkUpdateModal___default.a,
    TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_TableColsShowHideModal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_19_vue_loading_overlay___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_20__components_scoped_custom_DatePicker___default.a,
    Speed: __WEBPACK_IMPORTED_MODULE_23__AMDashboard_speed_vue___default.a
  },
  data: function data() {
    return {
      headers: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].headers,
      conceptStatuses: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].conceptStatuses,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_16__Campaign_campaignHelper__["a" /* default */],
      filteredCampaign: null,
      filters: {
        keyword: '',
        status: '',
        campaignIDs: []
      },
      filteredItems: [],
      contentScriptEditDialog: false,
      postLinkUpdateDialog: false,
      pairingItem: null,
      isLoading: false,
      filterTxt: '',
      currentPage: 1,
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [],
        itemsPerPage: 15
      },
      totalItems: 0,
      tableColsItems: [],
      colSettingsDialog: false,
      copySucceeded: false,
      viewcontentScriptModalDialog: false,
      viewContentScriptsData: null,
      colStatuses: {},
      conceptFormLink: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    pairings: function pairings(state) {
      return state.pairing.pairings;
    }
  }), {
    computedHeaders: function computedHeaders() {
      var _this = this;

      var creatorConceptCols = null;

      if (this.filteredCampaign && this.filteredCampaign.tableSettings) {
        if (this.filteredCampaign.tableSettings.creatorConceptCols) {
          creatorConceptCols = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.filteredCampaign.tableSettings.creatorConceptCols);
        }
      }
      this.headers.map(function (header) {
        _this.colStatuses[header.value] = true;
      });
      if (creatorConceptCols) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(creatorConceptCols)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            this.colStatuses[key] = creatorConceptCols[key];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var clientHeaderNames = ['shootDate', 'action'];
      return this.headers.filter(function (h) {
        if (_this.isClient) {
          if (clientHeaderNames.includes(h.value)) {
            return false;
          }
        }
        if (_this.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },
    payload: function payload() {
      if (this.filteredCampaign) {
        this.filters.campaignIDs = [this.filteredCampaign.id];
      } else {
        this.filters.campaignIDs = this.campaigns.map(function (c) {
          return c.id;
        });
      }
      return {
        filter: this.filters,
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    },
    filterStatuses: function filterStatuses() {
      var statuses = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], this.conceptStatuses);
      statuses.unshift({
        text: 'All',
        value: ''
      });
      return statuses;
    },
    clientID: function clientID() {
      return this.$store.state.user.clientID;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isClient: function isClient() {
      return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.CLIENT === this.currentUserRole;
    },
    isNotClient: function isNotClient() {
      return __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
    }
  }),
  watch: {
    pagination: function pagination(newVal) {
      this.paginate(newVal.page);
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var filters;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_25_pdfmake_build_pdfmake_js__["fonts"] = {
                  Arial: {
                    normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
                    bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
                  }
                };
              }, 1000);
              filters = {
                statuses: [__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignStatus.ONGOING, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].campaignStatus.REVIEW]
              };

              if (this.isClient) filters.clientID = this.clientID || null;
              _context.next = 5;
              return this.$store.dispatch('campaign/getCampaigns', {
                filters: filters
              });

            case 5:
              this.paginate();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    paginate: function paginate() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, data, inf;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _this2.currentPage = page;
                _this2.payload.paging.page = page;
                _context2.next = 5;
                return _this2.$store.dispatch('pairing/getCreatorConceptPairing', _this2.payload);

              case 5:
                if (!_this2.pairings.data) {
                  _context2.next = 31;
                  break;
                }

                _this2.filteredItems = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 10;
                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(_this2.pairings.data); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  data = _step2.value;
                  inf = _this2.beautifyData(data);

                  _this2.filteredItems.push(inf);
                }
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](10);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 18:
                _context2.prev = 18;
                _context2.prev = 19;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 21:
                _context2.prev = 21;

                if (!_didIteratorError2) {
                  _context2.next = 24;
                  break;
                }

                throw _iteratorError2;

              case 24:
                return _context2.finish(21);

              case 25:
                return _context2.finish(18);

              case 26:
                _this2.totalItems = _this2.pairings.total;
                if (_this2.pagination.itemsPerPage === -1) {
                  _this2.pagination.itemsPerPage = 20;
                }
                if (_this2.isClient) {
                  _this2.filteredItems = _this2.filteredItems.filter(function (f) {
                    return f.contentScriptForm && f.releaseContentScript;
                  });
                }
                if (_this2.$route.query.id) {
                  _this2.viewContentScriptDialog(_this2.$route.query.id);
                }
                _this2.isLoading = false;

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[10, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },
    beautifyData: function beautifyData(data) {
      var deliverablesDetails = data.deliverables_details || {};
      var inf = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, data.influencer_details || {});
      inf.deliverableDetails = deliverablesDetails;
      inf.pairingID = data.id;
      inf.concept_details = data.concept_details || {};
      inf.conceptStatus = inf.concept_details.conceptStatus || 1;
      inf.contentScripts = inf.concept_details.contentScripts || '';
      inf.postingLink = inf.concept_details.postingLink || '';
      inf.contentFeature = inf.concept_details.contentFeature || '';
      inf.kobeRemark = inf.concept_details.kobeRemark || '';
      inf.shootDate = inf.concept_details.shootDate || '';
      inf.campaignID = data.campaignID;
      inf.platform = String(inf.platform || 'instagram').toLowerCase();
      if (inf.platform === 'x') inf.platform = 'twitter';
      inf.contentScriptForm = data.contentScriptForm || false;
      inf.releaseContentScript = data.releaseContentScript || false;
      inf.invalidShootDate = false;
      inf.conceptStatusEdit = false;
      inf.contentScriptsEdit = false;
      inf.postingLinkEdit = false;
      inf.shootDateEdit = false;
      inf.contentFeatureEdit = false;
      inf.kobeRemarkEdit = false;
      if (!inf.userHandle) {
        inf.userHandle = inf.platform === 'twitter' ? inf.twitterHandle || inf.instagramHandle : inf.linkedinHandle || inf.instagramHandle;
      }
      if (inf.campaignID) {
        var matchCampaign = this.campaigns.find(function (c) {
          return c.id === data.campaignID;
        });
        if (matchCampaign) {
          inf.campaignName = matchCampaign.name;
        }
      }
      return inf;
    },
    conceptStatusDisplay: function conceptStatusDisplay(value) {
      var matchedItem = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].conceptStatuses.find(function (item) {
        return item.value === value;
      });
      if (matchedItem) {
        return matchedItem.text;
      } else {
        return '';
      }
    },
    saveContentScript: function saveContentScript(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var conptDetls, updatePairings, formData, resp, matchItemIdx;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                conptDetls = item.concept_details || {};

                conptDetls.contentScripts = item.contentScripts;
                updatePairings = [{
                  id: item.pairingID,
                  'concept_details': conptDetls
                }];
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].updatePairings(formData);

              case 7:
                resp = _context3.sent;

                if (resp) {
                  matchItemIdx = _this3.filteredItems.findIndex(function (f) {
                    return f.pairingID === item.pairingID;
                  });

                  if (matchItemIdx !== -1) {
                    _this3.filteredItems[matchItemIdx].contentScripts = item.contentScripts;
                    _this3.filteredItems = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(_this3.filteredItems);
                  }
                  _this3.$swal({
                    type: 'success',
                    text: 'Successfully Saved.'
                  });
                }

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    savePostLink: function savePostLink(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var conptDetls, updatePairings, formData, resp, matchItemIdx;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                conptDetls = item.concept_details || {};

                conptDetls.postingLink = item.postingLink;
                updatePairings = [{
                  id: item.pairingID,
                  'concept_details': conptDetls
                }];
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].updatePairings(formData);

              case 7:
                resp = _context4.sent;

                if (resp) {
                  matchItemIdx = _this4.filteredItems.findIndex(function (f) {
                    return f.pairingID === item.pairingID;
                  });

                  if (matchItemIdx !== -1) {
                    _this4.filteredItems[matchItemIdx].postingLink = item.postingLink;
                    _this4.filteredItems = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(_this4.filteredItems);
                  }
                }

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    updateCreatorConcept: function updateCreatorConcept(item, field) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var conptDetls, updatePairings, formData, resp, matchItemIdx;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.isLoading = true;
                conptDetls = item.concept_details || {};

                conptDetls[field] = item[field];
                updatePairings = [{
                  id: item.pairingID,
                  'concept_details': conptDetls
                }];
                formData = new FormData();

                formData.append('pairings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(updatePairings));
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].updatePairings(formData);

              case 8:
                resp = _context5.sent;

                if (resp) {
                  matchItemIdx = _this5.filteredItems.findIndex(function (f) {
                    return f.pairingID === item.pairingID;
                  });

                  if (matchItemIdx !== -1) {
                    _this5.filteredItems[matchItemIdx][field] = item[field];
                    _this5.filteredItems = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(_this5.filteredItems);
                    if (_this5.filteredItems[matchItemIdx][field + 'Edit']) {
                      _this5.filteredItems[matchItemIdx][field + 'Edit'] = false;
                    }
                  }
                }
                _this5.isLoading = false;

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    changeCreatorConceptEdit: function changeCreatorConceptEdit(colName, item, status) {
      var matchItemIdx = this.filteredItems.findIndex(function (f) {
        return f.pairingID === item.pairingID;
      });
      if (matchItemIdx !== -1) {
        this.filteredItems[matchItemIdx][colName] = status;
        this.filteredItems = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(this.filteredItems);
      }
    },
    openContentScriptEditModal: function openContentScriptEditModal(item) {
      this.pairingItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, item);
      this.contentScriptEditDialog = true;
    },
    openPostLinkEditModal: function openPostLinkEditModal(item) {
      this.pairingItem = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, item);
      this.postLinkUpdateDialog = true;
    },
    searchFilter: function searchFilter() {
      this.paginate(1);
    },
    resetFilter: function resetFilter() {
      this.filteredCampaign = null;
      this.filters = {
        keyword: '',
        campaignIDs: []
      };
      this.searchFilter();
    },
    conceptStatusClr: function conceptStatusClr(value) {
      var matchedItem = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].conceptStatuses.find(function (item) {
        return item.value === value;
      });
      if (matchedItem) {
        return matchedItem.color;
      } else {
        return '';
      }
    },
    checkActDate: function checkActDate(item, dateVal) {
      item.invalidShootDate = true;
      if (__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.isDateFormatValid(dateVal) || !dateVal) {
        item.invalidShootDate = false;
      }
    },
    setActDateFromPicker: function setActDateFromPicker(item, value) {
      item.shootDate = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.formatCustomDate(value, 'DD/MM/YYYY');
      this.checkDate(item.shootDate);
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.headers)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref2 = _step3.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var key = _ref3[0];
          var value = _ref3[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                columns = _this6.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this6.filteredCampaign.tableSettings) {
                  tableSettings = _this6.filteredCampaign.tableSettings;
                }
                tableSettings.creatorConceptCols = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = [{
                  id: _this6.filteredCampaign.id,
                  tableSettings: tableSettings
                }];
                _context6.next = 8;
                return _this6.$store.dispatch('campaign/updateCampaignByIds', updateData);

              case 8:
                _this6.filteredCampaign.tableSettings = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, tableSettings);
                _this6.colStatuses = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, columns);
                _this6.colSettingsDialog = false;

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    exportExcel: function exportExcel() {
      var _this7 = this;

      this.isLoading = true;
      this.payload.export = true;
      __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].downloadCreatorConceptRpt(this.payload).then(function () {
        _this7.isLoading = false;
      }).catch(function (error) {
        _this7.isLoading = false;
        console.log('error in downloading creator concepts report', error);
      });
    },
    downloadPDF: function downloadPDF(item) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var htmlToPdf, pdfData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                htmlToPdf = new __WEBPACK_IMPORTED_MODULE_24__editor_generator_HTMLToPDF__["a" /* default */](item.contentScripts, 'Arial');
                _context7.next = 3;
                return htmlToPdf.generate();

              case 3:
                pdfData = _context7.sent;

                __WEBPACK_IMPORTED_MODULE_25_pdfmake_build_pdfmake_js__["createPdf"](pdfData).download(item.userHandle + '_content_scripts.pdf');

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    copyContentScriptFormLink: function copyContentScriptFormLink(pairing) {
      this.copySucceeded = true;
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.conceptFormLink = protocol + '//' + host + '/influencers/content-storyboard/' + pairing.pairingID;
      setTimeout(function () {
        pairing.linkCopied = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.copyToClipboard('#copy-concept-link');
      }, 100);
    },
    viewContentScriptDialog: function viewContentScriptDialog(id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.viewContentScriptsData = {};
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].getContentScriptByPairingID(id);

              case 3:
                _this9.viewContentScriptsData = _context8.sent;

                if (!_this9.viewContentScriptsData) {
                  _this9.$swal({
                    text: 'No Content Scripts Data.',
                    type: 'secondary'
                  });
                }
                _this9.viewcontentScriptModalDialog = true;

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    downloadWord: function downloadWord(item) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this10.viewContentScriptsData = {};
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].getContentScriptByPairingID(item.pairingID);

              case 3:
                _this10.viewContentScriptsData = _context9.sent;

                if (!_this10.viewContentScriptsData) {
                  _this10.$swal({
                    text: 'No Content Scripts Data.',
                    type: 'secondary'
                  });
                }
                __WEBPACK_IMPORTED_MODULE_26__ContentWordGenerator__["a" /* default */].generateDocument(_this10.viewContentScriptsData);

              case 6:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    sendPdf: function sendPdf(id) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var doc;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this11.viewContentScriptsData = {};
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].getContentScriptByPairingID(id);

              case 3:
                _this11.viewContentScriptsData = _context11.sent;

                if (!_this11.viewContentScriptsData) {
                  _this11.$swal({
                    text: 'No Content Scripts Data.',
                    type: 'secondary'
                  });
                }
                doc = __WEBPACK_IMPORTED_MODULE_27__ContentPDFGenerator__["a" /* default */].generatePDF(_this11.viewContentScriptsData);

                __WEBPACK_IMPORTED_MODULE_17__Campaign_campaignPDF__["a" /* default */].generatePDF(doc).then(function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10(pdfData) {
                    var bfsBaseFmt, formData;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_17__Campaign_campaignPDF__["a" /* default */].generateBasePDF(doc);

                          case 2:
                            bfsBaseFmt = _context10.sent;
                            formData = new FormData();

                            formData.append('pairingID', id);
                            formData.append('contentFileBase', bfsBaseFmt);
                            formData.append('contentFile', pdfData);
                            _context10.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].sendContentFlowEmail(formData);

                          case 9:
                            return _context10.abrupt('return', true);

                          case 10:
                          case 'end':
                            return _context10.stop();
                        }
                      }
                    }, _callee10, _this11);
                  }));

                  return function (_x2) {
                    return _ref4.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log('error in converting PDF', error);
                });

              case 7:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    sendClientNoPdf: function sendClientNoPdf(id) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                formData = new FormData();

                formData.append('pairingID', id);
                formData.append('noPdf', true);
                _context12.next = 5;
                return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].sendContentFlowEmail(formData);

              case 5:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    changeRelease: function changeRelease(item, status) {
      var _this13 = this;

      var spTxt = status ? 'Release' : 'Suspend';

      this.$swal({
        title: 'Are you sure to ' + spTxt + '?',
        icon: 'secondary',
        confirmButtonText: 'Confirm',
        showCancelButton: true
      }).then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee13(result) {
          var updatePairings, formData, resp, matchItemIdx;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  if (!result.value) {
                    _context13.next = 17;
                    break;
                  }

                  updatePairings = [{
                    id: item.pairingID,
                    releaseContentScript: status
                  }];
                  formData = new FormData();

                  formData.append('pairings', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(updatePairings));
                  _context13.next = 6;
                  return __WEBPACK_IMPORTED_MODULE_18__pairingAPIs__["a" /* default */].updatePairings(formData);

                case 6:
                  resp = _context13.sent;

                  if (!resp) {
                    _context13.next = 14;
                    break;
                  }

                  _this13.$swal({
                    text: 'Successfully ' + (status ? 'Released' : 'Suspended') + '.',
                    type: 'success'
                  });
                  matchItemIdx = _this13.filteredItems.findIndex(function (f) {
                    return f.pairingID === item.pairingID;
                  });

                  if (matchItemIdx !== -1) {
                    _this13.filteredItems[matchItemIdx].releaseContentScript = status;
                    _this13.filteredItems = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func.refreshJSON(_this13.filteredItems);
                  }
                  if (status) {
                    _this13.sendClientNoPdf(item.pairingID);
                  }
                  _context13.next = 16;
                  break;

                case 14:
                  _this13.$swal({
                    text: 'Error Release.',
                    type: 'error'
                  });
                  return _context13.abrupt('return');

                case 16:
                  item.releaseContentScript = status;

                case 17:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, _this13);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    }
  }
});

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostLinkUpdateModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    item: Object
  },
  validations: {
    postingLink: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    }
  },
  data: function data() {
    return {
      isLoading: false,
      postingLink: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    postingLinkErrors: function postingLinkErrors() {
      var errors = [];
      if (!this.$v.postingLink.$dirty) return errors;
      !this.$v.postingLink.required && errors.push('This field is required.');
      return errors;
    }
  },
  watch: {
    item: function item(newValue) {
      this.postingLink = '';
      if (newValue.postingLink) {
        this.postingLink = newValue.postingLink;
      }
    }
  },
  methods: {
    save: function save() {
      this.item.postingLink = this.postingLink;
      this.$emit('saveClicked', this.item);
      this.$emit('input');
    },
    close: function close() {
      this.$emit('closeClicked', this.item);
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreatorConceptForm_Form__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreatorConceptForm_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CreatorConceptForm_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewModalDialog',
  components: {
    CreatorConceptForm: __WEBPACK_IMPORTED_MODULE_3__CreatorConceptForm_Form___default.a
  },
  props: {
    value: Boolean,
    data: Object
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func,
      editData: {}
    };
  },

  watch: {
    data: function data(newValue) {
      if (newValue) {
        this.editData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.data);
      }
    }
  },
  methods: {
    handleUpdatedContentScript: function handleUpdatedContentScript() {
      this.$emit('input');
    },
    close: function close() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$swal({
                  title: 'Leave without saving changes?',
                  text: 'Your changes may not be saved.',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Leave',
                  cancelButtonText: 'Stay'
                });

              case 2:
                result = _context.sent;

                if (result.value) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.$emit('input');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataTable__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'creator-concept',
  components: {
    CreatorConceptDataTable: __WEBPACK_IMPORTED_MODULE_0__DataTable___default.a
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chatbox__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chatbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__chatbox__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorComments',
  components: { chatbox: __WEBPACK_IMPORTED_MODULE_0__chatbox___default.a },
  props: {
    messages: { type: Array, required: true },
    title: { type: String, required: true }
  }
});

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorFormatInfo',
  props: {
    format: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VersionNoModal__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VersionNoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__VersionNoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_DirectFileUpload__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_DirectFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_DirectFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CreatorConcept_ContentPDFGenerator__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignPDF__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chatbox__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chatbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__chatbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_editor_sunEditor__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_editor_sunEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_editor_sunEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EditorFormatInfo__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EditorFormatInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__EditorFormatInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__EditorComments__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__EditorComments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__EditorComments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__config_logoDataURL__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__config_logoDataURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__config_logoDataURL__);



























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreatorConceptForm',
  components: {
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_CustomFileUpload___default.a,
    DirectFileUpload: __WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_DirectFileUpload___default.a,
    VersionNoModal: __WEBPACK_IMPORTED_MODULE_7__VersionNoModal___default.a,
    chatbox: __WEBPACK_IMPORTED_MODULE_17__chatbox___default.a,
    SunEditor: __WEBPACK_IMPORTED_MODULE_21__components_editor_sunEditor___default.a,
    EditorFormatInfo: __WEBPACK_IMPORTED_MODULE_22__EditorFormatInfo___default.a,
    EditorComments: __WEBPACK_IMPORTED_MODULE_23__EditorComments___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_12_vuelidate__["validationMixin"]],
  validations: function validations() {
    var validationRules = {
      creatorConceptData: {
        name: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        concept: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        reasonConcept: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        musicChoice: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        scenesInfo: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        storyScenesInfo: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        storyText: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        storyScenesInfoTwo: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        $each: {
          deliverables: {
            concept: {
              required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
            }
          }
        }
      }
    };

    return validationRules;
  },
  props: {
    value: Boolean,
    mode: String,
    editData: Object
  },
  data: function data() {
    return {
      creatorConceptData: {
        pairingID: '',
        campaignName: '',
        creatorHandle: '',
        submissionDate: '',
        concept: '',
        reasonConcept: '',
        musicChoice: '',
        deliverableLists: '',
        deliverables: []
      },
      mainData: {
        id: ''
      },
      deliverableLists: '',
      isCreateMode: true,
      valid: true,
      fileUploadRefresh: false,
      submitting: false,
      showVersionDialog: false,
      showVersionHistory: false,
      imgLoading: false,
      isLoading: false,
      commentShow: true,
      editContent: "",
      storyboardToolbar: [['undo', 'redo'], ['formatBlock'], ['bold', 'italic', 'underline', 'strike'], ['list', 'align'], ['fontColor', 'hiliteColor'], ['removeFormat']],
      storyboardPlaceholders: {
        scenesInfo: 'What will make your audience want to watch this content?\n\nScene 1:',
        briefText: 'Text:\nVO:\n\nRelate 2-3 pointers of brief into your concept (keep it less ad-like, \nDO NOT COPY USPs from the campaign brief)',
        briefTextTwo: 'Text:\nVO:\n\nRelate 2-3 pointers of brief into your concept (keep it less ad-like, \nDO NOT COPY USPs from the campaign brief)',
        bodyInfo: 'Showcase how you plan to execute every scene and how you\u2019ll feature the product/service that relates to the campaign brief.\n*Not every scene needs to have the product/ USPs\n\nScene 2:\n\nScene 3:',
        callToAction: 'CTA - Call To Action\n\nScene 8:'
      },
      logoDataUrl: __WEBPACK_IMPORTED_MODULE_24__config_logoDataURL___default.a.logo || '/static/img/kobe_bg_main.png'
    };
  },

  computed: {
    currentUserRole: function currentUserRole() {
      return this.$store.state.user ? Number(this.$store.state.user.role) : null;
    },
    isInternal: function isInternal() {
      return __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
    },
    isClient: function isClient() {
      return __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].userRoles.CLIENT === this.currentUserRole;
    },
    isNotClient: function isNotClient() {
      return __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
    },
    isCommentSection: function isCommentSection() {
      return this.$store.state.user && __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].userRoles.INFLUENCER !== this.currentUserRole;
    },
    isInternalView: function isInternalView() {
      return this.$store.state.user && __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].userRoles.INFLUENCER !== this.currentUserRole && __WEBPACK_IMPORTED_MODULE_19__config__["a" /* default */].userRoles.CLIENT !== this.currentUserRole;
    }
  },
  mounted: function mounted() {
    this.getPairedInfluencer();
  },

  watch: {
    editData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(newValue) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.getPairedInfluencer();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editData(_x) {
        return _ref.apply(this, arguments);
      }

      return editData;
    }()
  },
  methods: {
    addIgCarousel: function addIgCarousel(deliIndex, boxIdx) {
      this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images.push(this.normalizeImageComments({
        imgDescription: '',
        textImage: '',
        refLinkType: 'upload',
        link: ''
      }));
    },
    addImage: function addImage(deliIndex, boxIdx) {
      this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images.push({
        refLinkType: 'upload',
        link: ''
      });
    },
    deleteImage: function deleteImage(deliIndex, boxIdx, imgIdx) {
      var splicedImg = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images.splice(imgIdx, 1);
      if (splicedImg.length) {
        if (splicedImg[0].imgName) {
          __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__["a" /* default */].deleteS3Object(splicedImg[0].imgName);
        }
      }
    },
    submitCreatorConcept: function submitCreatorConcept() {
      var _this = this;

      this.submitting = true;
      if (this.isInternalView) {
        this.$swal({
          title: 'Double Check!',
          text: 'Make sure you filled all the required information',
          confirmButtonText: 'Save New',
          cancelButtonText: 'Save',
          type: 'info',
          showCancelButton: true,
          showCloseButton: true,
          cancelButtonColor: 'green'
        }).then(function (result) {
          if (result.value) {
            _this.submitting = false;
            _this.showVersionDialog = true;
            _this.creatorConceptData.saveOnly = false;
          } else if (result.dismiss === 'cancel') {
            _this.creatorConceptData.saveOnly = true;
            _this.saveCreatorConcept();
          }
          setTimeout(function () {
            _this.submitting = false;
          }, 1000);
        });
      } else {
        this.$swal({
          title: 'Double Check!',
          text: 'Make sure you filled all the required information',
          confirmButtonText: 'Confirm',
          type: 'info',
          showCancelButton: true,
          showCloseButton: true
        }).then(function (result) {
          if (result.value) {
            _this.saveCreatorConcept();
          } else {
            setTimeout(function () {
              _this.submitting = false;
            }, 1000);
          }
        });
      }
    },
    approveCreatorConcept: function approveCreatorConcept() {
      var _this2 = this;

      this.submitting = true;
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to approve',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'info',
        showCancelButton: true
      }).then(function (result) {
        var formData = new FormData();
        formData.append('creatorConceptID', _this2.creatorConceptData.id);
        __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].approveConceptForm(formData).then(function (response) {
          setTimeout(function () {
            _this2.submitting = false;
          }, 2000);

          _this2.$swal({
            text: 'Succesfully Approved Content Storyboard',
            type: 'success',
            allowOutsideClick: false
          }).then(function (result) {
            if (result.value) {
              _this2.$emit('updatedContentScript');
              _this2.sendPdf(_this2.creatorConceptData.pairingID);
            }
          });
        }).catch(function (error) {
          setTimeout(function () {
            _this2.submitting = false;
          }, 2000);

          console.log('error', error);
          _this2.$swal({
            text: error,
            type: 'error'
          });
        });
      });
    },
    sendPdf: function sendPdf(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var doc;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.viewContentScriptsData = {};
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].getContentScriptByPairingID(id);

              case 3:
                _this3.viewContentScriptsData = _context3.sent;

                if (!_this3.viewContentScriptsData) {
                  _this3.$swal({
                    text: 'No Content Scripts Data.',
                    type: 'secondary'
                  });
                }
                doc = __WEBPACK_IMPORTED_MODULE_10__CreatorConcept_ContentPDFGenerator__["a" /* default */].generatePDF(_this3.viewContentScriptsData);

                __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignPDF__["a" /* default */].generatePDF(doc).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(pdfData) {
                    var bfsBaseFmt, formData;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignPDF__["a" /* default */].generateBasePDF(doc);

                          case 2:
                            bfsBaseFmt = _context2.sent;
                            formData = new FormData();

                            formData.append('pairingID', id);
                            formData.append('contentFileBase', bfsBaseFmt);
                            formData.append('contentFile', pdfData);
                            _context2.next = 9;
                            return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].sendContentFlowEmail(formData);

                          case 9:
                            return _context2.abrupt('return', true);

                          case 10:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log('error in converting PDF', error);
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    saveWithVersion: function saveWithVersion(versionNo) {
      this.creatorConceptData.versionNo = versionNo;
      this.saveCreatorConcept();
    },
    saveCreatorConcept: function saveCreatorConcept() {
      var _this4 = this;

      var formData = new FormData();
      formData.append('creatorConcept', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.creatorConceptData));
      __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].createConceptForm(formData).then(function (response) {
        setTimeout(function () {
          _this4.submitting = false;
        }, 2000);
        if (_this4.mode === 'edit') {
          _this4.$swal({
            text: 'Succesfully Updated Content Scripts Form',
            type: 'success',
            allowOutsideClick: false
          }).then(function (result) {
            if (result.value) {
              _this4.$emit('updatedContentScript');
            }
          });
        } else {
          _this4.$swal({
            text: 'Succesfully Submitted Content Scripts Form',
            type: 'success',
            allowOutsideClick: false
          }).then(function (result) {
            if (result.value) {
              _this4.$router.push({ path: '/profile' });
            }
          });
        }
      }).catch(function (error) {
        setTimeout(function () {
          _this4.submitting = false;
        }, 2000);

        console.log('error', error);
        _this4.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    getReferenceFileName: function getReferenceFileName(item) {
      if (!item || !item.imgName) return '';
      return item.imgName.split('/').pop();
    },
    uploadFile: function uploadFile(deliIndex, boxIdx, imgIdx, medias) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var mediaIndex, targetImages, targetIndex, formData, response, url;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (medias.length) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _this5.imgLoading = true;
                _context4.prev = 3;
                mediaIndex = 0;

              case 5:
                if (!(mediaIndex < medias.length)) {
                  _context4.next = 19;
                  break;
                }

                targetImages = _this5.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images;
                targetIndex = imgIdx;

                if (mediaIndex > 0) {
                  targetImages.splice(imgIdx + mediaIndex, 0, _this5.normalizeImageComments({
                    refLinkType: 'upload',
                    link: ''
                  }));
                  targetIndex = imgIdx + mediaIndex;
                }
                formData = new FormData();

                formData.append('rawImage', true);
                formData.append('image', medias[mediaIndex]);
                _context4.next = 14;
                return __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__["a" /* default */].uploadImage(formData);

              case 14:
                response = _context4.sent;

                if (response) {
                  url = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.constructImageURL(response.url);

                  _this5.$set(targetImages[targetIndex], 'imgUrl', url);
                  _this5.$set(targetImages[targetIndex], 'imgName', response.url);
                }

              case 16:
                mediaIndex++;
                _context4.next = 5;
                break;

              case 19:
                _this5.imgLoading = false;
                _context4.next = 27;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4['catch'](3);

                _this5.imgLoading = false;

                console.log('error', _context4.t0);
                _this5.$swal({
                  text: _context4.t0,
                  type: 'error'
                });

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[3, 22]]);
      }))();
    },
    getPairedInfluencer: function getPairedInfluencer() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var pairingID, viewContentScriptsData, _paired, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, conceptVersion, deliDetails, _loop, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref3, _ref4, key, value, _ret, matchCreatorConcept, paired, _deliDetails, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref5, _ref6, _key, _value, _dataObj, i, pushObj, title, campaignID, campaignName, campaign;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.isLoading = true;
                _context5.prev = 1;
                pairingID = null;

                if (_this6.mode === 'edit') {
                  pairingID = _this6.editData.pairingID;
                } else {
                  pairingID = _this6.$route.params.id;
                }
                _context5.next = 6;
                return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].getContentScriptByPairingID(pairingID);

              case 6:
                viewContentScriptsData = _context5.sent;

                if (!viewContentScriptsData) {
                  _context5.next = 79;
                  break;
                }

                console.log('view script');
                _this6.creatorConceptData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, viewContentScriptsData);
                _this6.creatorConceptData.deliverables = _this6.creatorConceptData.deliverables.map(_this6.normalizeDeliverableComments);
                _context5.next = 13;
                return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].getContentScriptVersions(viewContentScriptsData.id);

              case 13:
                _this6.contentScriptVersions = _context5.sent;
                _context5.next = 16;
                return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].getPairedInfluencerStoryBoardOpen(pairingID);

              case 16:
                _paired = _context5.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 20;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this6.contentScriptVersions);

              case 22:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context5.next = 62;
                  break;
                }

                conceptVersion = _step.value;

                if (!_paired) {
                  _context5.next = 59;
                  break;
                }

                if (!_paired.items.deliverables_details) {
                  _context5.next = 59;
                  break;
                }

                deliDetails = _paired.items.deliverables_details;

                conceptVersion.deliverableLists = __WEBPACK_IMPORTED_MODULE_16__Campaign_campaignHelper__["a" /* default */].getDeliverableDetails(deliDetails);

                _loop = function _loop(key, value) {
                  if (key === 'custom') return 'continue';
                  var dataObj = {
                    concept: '',
                    reasonConcept: '',
                    musicChoice: '',
                    boxes: [{
                      scenesInfo: '',
                      briefText: '',
                      images: [{
                        refLinkType: 'upload',
                        link: ''
                      }]
                    }]
                  };
                  if (value > 0) {
                    if (key === 'no_of_tiktok_posts') {
                      dataObj.type = 'tiktok';
                      dataObj.title = 'TikTok';
                    } else if (key === 'no_of_fb_posts') {
                      dataObj.type = 'fb';
                      dataObj.title = 'Facebook';
                    } else if (key === 'no_of_xhs_posts') {
                      dataObj.type = 'xhs';
                      dataObj.title = 'Xiaohongshu';
                    } else if (key === 'no_of_posts') {
                      dataObj.type = 'igPost';
                      dataObj.title = 'IG Post';
                    } else if (key === 'no_of_carousels') {
                      dataObj.type = 'igCarousel';
                      dataObj.title = 'IG Carousel';
                    } else if (key === 'no_of_stories') {
                      dataObj.type = 'igStory';
                      dataObj.title = 'IG Story';
                    } else if (key === 'no_of_reels') {
                      dataObj.type = 'igReel';
                      dataObj.title = 'IG Reel';
                    } else if (key === 'no_of_li_posts') {
                      dataObj.type = 'linkedIn';
                      dataObj.title = 'LinkedIn Post';
                    } else if (key === 'youtube') {
                      dataObj.type = 'youtube';
                      dataObj.title = 'Youtube Post';
                    }
                    var totalCount = conceptVersion.deliverables.filter(function (deli) {
                      return deli.type === dataObj.type;
                    }).length;
                    if (totalCount < value) {
                      var remainCount = value - totalCount;
                      for (var i = 0; i < remainCount; i++) {
                        var pushObj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, dataObj);
                        pushObj.id = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.generateUniqueId();
                        if (remainCount > 0) {
                          var title = pushObj.title + ' ' + (totalCount + i + 1);
                          pushObj.title = title;
                        }
                        conceptVersion.deliverables.push(pushObj);
                        conceptVersion.deliverables = conceptVersion.deliverables.map(_this6.normalizeDeliverableComments);
                        conceptVersion.deliverables = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(conceptVersion.deliverables));
                      }
                    }
                  }
                };

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 32;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(deliDetails));

              case 34:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context5.next = 45;
                  break;
                }

                _ref3 = _step2.value;
                _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                key = _ref4[0];
                value = _ref4[1];
                _ret = _loop(key, value);

                if (!(_ret === 'continue')) {
                  _context5.next = 42;
                  break;
                }

                return _context5.abrupt('continue', 42);

              case 42:
                _iteratorNormalCompletion2 = true;
                _context5.next = 34;
                break;

              case 45:
                _context5.next = 51;
                break;

              case 47:
                _context5.prev = 47;
                _context5.t0 = _context5['catch'](32);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 51:
                _context5.prev = 51;
                _context5.prev = 52;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 54:
                _context5.prev = 54;

                if (!_didIteratorError2) {
                  _context5.next = 57;
                  break;
                }

                throw _iteratorError2;

              case 57:
                return _context5.finish(54);

              case 58:
                return _context5.finish(51);

              case 59:
                _iteratorNormalCompletion = true;
                _context5.next = 22;
                break;

              case 62:
                _context5.next = 68;
                break;

              case 64:
                _context5.prev = 64;
                _context5.t1 = _context5['catch'](20);
                _didIteratorError = true;
                _iteratorError = _context5.t1;

              case 68:
                _context5.prev = 68;
                _context5.prev = 69;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 71:
                _context5.prev = 71;

                if (!_didIteratorError) {
                  _context5.next = 74;
                  break;
                }

                throw _iteratorError;

              case 74:
                return _context5.finish(71);

              case 75:
                return _context5.finish(68);

              case 76:
                matchCreatorConcept = _this6.contentScriptVersions.find(function (c) {
                  return c.isMain;
                });

                if (matchCreatorConcept) {
                  _this6.creatorConceptData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, matchCreatorConcept);
                  _this6.mainData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, matchCreatorConcept);
                  _this6.creatorConceptData.deliverables = _this6.creatorConceptData.deliverables.map(_this6.normalizeDeliverableComments);
                }
                return _context5.abrupt('return');

              case 79:
                _context5.next = 81;
                return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].getPairedInfluencerStoryBoardOpen(pairingID);

              case 81:
                paired = _context5.sent;

                if (!paired) {
                  _context5.next = 134;
                  break;
                }

                console.log('view script paired');
                _this6.creatorConceptData.pairingID = pairingID;

                if (!paired.items) {
                  _context5.next = 134;
                  break;
                }

                if (paired.items.id) {
                  _this6.creatorConceptData.submissionDate = paired.items.pairing_details.submission_date;
                  if (_this6.creatorConceptData.submissionDate) {
                    _this6.creatorConceptData.submissionDate = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.formatCustomDate(_this6.creatorConceptData.submissionDate, 'DD/MM/YYYY');
                  }
                }
                if (paired.items.influencer_details) {
                  _this6.creatorConceptData.creatorHandle = paired.items.influencer_details.instagramHandle;
                  _this6.creatorConceptData.influencerID = paired.items.influencer_details.influencerID || null;
                }

                if (!paired.items.deliverables_details) {
                  _context5.next = 122;
                  break;
                }

                _deliDetails = paired.items.deliverables_details;

                _this6.creatorConceptData.deliverableLists = __WEBPACK_IMPORTED_MODULE_16__Campaign_campaignHelper__["a" /* default */].getDeliverableDetails(_deliDetails);
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context5.prev = 94;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(_deliDetails));

              case 96:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context5.next = 108;
                  break;
                }

                _ref5 = _step3.value;
                _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2);
                _key = _ref6[0];
                _value = _ref6[1];

                if (!(_key === 'custom')) {
                  _context5.next = 103;
                  break;
                }

                return _context5.abrupt('continue', 105);

              case 103:
                _dataObj = {
                  concept: '',
                  reasonConcept: '',
                  musicChoice: '',
                  boxes: [{
                    scenesInfo: '',
                    briefText: '',
                    introComments: [],
                    introCommentsTwo: [],
                    bodyComments: [],
                    bodyChatTwo: [],
                    ctaComments: [],
                    showChat: false,
                    showChatTwo: false,
                    showChatBody: false,
                    showChatBodyTwo: false,
                    showChatCta: false,
                    images: [{
                      refLinkType: 'upload',
                      link: ''
                    }]
                  }]
                };

                if (_value > 0) {
                  if (_key === 'no_of_tiktok_posts') {
                    _dataObj.type = 'tiktok';
                    _dataObj.title = 'TikTok';
                  } else if (_key === 'no_of_fb_posts') {
                    _dataObj.type = 'fb';
                    _dataObj.title = 'Facebook';
                  } else if (_key === 'no_of_xhs_posts') {
                    _dataObj.type = 'xhs';
                    _dataObj.title = 'Xiaohongshu';
                  } else if (_key === 'no_of_posts') {
                    _dataObj.type = 'igPost';
                    _dataObj.title = 'IG Post';
                  } else if (_key === 'no_of_carousels') {
                    _dataObj.type = 'igCarousel';
                    _dataObj.title = 'IG Carousel';
                  } else if (_key === 'no_of_stories') {
                    _dataObj.type = 'igStory';
                    _dataObj.title = 'IG Story';
                  } else if (_key === 'no_of_reels') {
                    _dataObj.type = 'igReel';
                    _dataObj.title = 'IG Reel';
                  } else if (_key === 'no_of_li_posts') {
                    _dataObj.type = 'linkedIn';
                    _dataObj.title = 'LinkedIn Post';
                  } else if (_key === 'youtube') {
                    _dataObj.type = 'youtube';
                    _dataObj.title = 'Youtube Post';
                  }
                  for (i = 0; i < _value; i++) {
                    pushObj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, _dataObj);

                    pushObj.id = __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.generateUniqueId();
                    if (_value > 1) {
                      title = pushObj.title + ' ' + (i + 1);

                      pushObj.title = title;
                    }
                    _this6.creatorConceptData.deliverables.push(pushObj);
                    _this6.creatorConceptData.deliverables = _this6.creatorConceptData.deliverables.map(_this6.normalizeDeliverableComments);
                    _this6.creatorConceptData.deliverables = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this6.creatorConceptData.deliverables));
                  }
                }

              case 105:
                _iteratorNormalCompletion3 = true;
                _context5.next = 96;
                break;

              case 108:
                _context5.next = 114;
                break;

              case 110:
                _context5.prev = 110;
                _context5.t2 = _context5['catch'](94);
                _didIteratorError3 = true;
                _iteratorError3 = _context5.t2;

              case 114:
                _context5.prev = 114;
                _context5.prev = 115;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 117:
                _context5.prev = 117;

                if (!_didIteratorError3) {
                  _context5.next = 120;
                  break;
                }

                throw _iteratorError3;

              case 120:
                return _context5.finish(117);

              case 121:
                return _context5.finish(114);

              case 122:
                campaignID = paired.items.campaignID || paired.items.CampaignID;
                campaignName = paired.items.campaignName || paired.items.CampaignName;


                if (campaignID) {
                  _this6.creatorConceptData.campaignID = campaignID;
                }

                if (!campaignName) {
                  _context5.next = 129;
                  break;
                }

                _this6.creatorConceptData.campaignName = campaignName;
                _context5.next = 134;
                break;

              case 129:
                if (!campaignID) {
                  _context5.next = 134;
                  break;
                }

                _context5.next = 132;
                return __WEBPACK_IMPORTED_MODULE_15__Campaign_campaignAPIs__["a" /* default */].getCampaignDetailForFeedback(campaignID);

              case 132:
                campaign = _context5.sent;

                _this6.creatorConceptData.campaignName = campaign.name;

              case 134:
                _context5.next = 139;
                break;

              case 136:
                _context5.prev = 136;
                _context5.t3 = _context5['catch'](1);

                console.error('Unable to load content storyboard', _context5.t3);

              case 139:
                _context5.prev = 139;

                _this6.isLoading = false;
                return _context5.finish(139);

              case 142:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[1, 136, 139, 142], [20, 64, 68, 76], [32, 47, 51, 59], [52,, 54, 58], [69,, 71, 75], [94, 110, 114, 122], [115,, 117, 121]]);
      }))();
    },
    normalizeImageComments: function normalizeImageComments(image) {
      this.$set(image, 'id', image.id || __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.generateUniqueId());
      this.$set(image, 'imgDescriptionComments', image.imgDescriptionComments || []);
      this.$set(image, 'textImageComments', image.textImageComments || []);
      return image;
    },
    normalizeDeliverableComments: function normalizeDeliverableComments(d) {
      var _this7 = this;

      d.showChat = false;
      d.showComment = true;
      d.comments = d.comments || [];
      d.boxes = (d.boxes || []).map(function (box) {
        box.id = box.id || __WEBPACK_IMPORTED_MODULE_18__utils__["a" /* default */].func.generateUniqueId();
        box.showChat = false;
        box.showChatTwo = false;
        box.showChatBody = false;
        box.showChatBodyTwo = false;
        box.showChatCta = false;
        box.showComment = true;
        box.introComments = box.introComments || [];
        box.introCommentsTwo = box.introCommentsTwo || [];
        box.bodyComments = box.bodyComments || [];
        box.bodyChatTwo = box.bodyChatTwo || [];
        box.ctaComments = box.ctaComments || [];
        box.images = (box.images || []).map(_this7.normalizeImageComments);
        return box;
      });
      return d;
    },

    sendComment: function sendComment(id, comment, commentField) {
      var _this8 = this;

      var newComment = {
        pairingID: this.creatorConceptData.pairingID,
        deliverableBoxId: id,
        text: comment
      };
      if (commentField) {
        newComment.commentField = commentField;
      }
      __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].createComment(newComment).then(function (comment) {
        _this8.creatorConceptData.saveOnly = true;
        var formData = new FormData();
        formData.append('creatorConcept', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this8.creatorConceptData));
        __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].createConceptForm(formData);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    sendCommentTwo: function sendCommentTwo(id, comment, commentField) {
      this.sendComment(id, comment, commentField);
    },
    sendBodyComment: function sendBodyComment(id, comment, commentField) {
      this.sendComment(id, comment, commentField);
    },
    sendBodyCommentTwo: function sendBodyCommentTwo(id, comment, commentField) {
      this.sendComment(id, comment, commentField);
    },
    sendCtaComment: function sendCtaComment(id, comment, commentField) {
      this.sendComment(id, comment, commentField);
    },
    showChatBox: function showChatBox(deliIndex, boxIdx) {
      if (boxIdx !== undefined) {
        var box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx];
        this.$set(box, 'showChat', !box.showChat);
        return;
      }
      this.creatorConceptData.deliverables[deliIndex].showChat = !this.creatorConceptData.deliverables[deliIndex].showChat;
    },
    showChatBoxTwo: function showChatBoxTwo(deliIndex, boxIdx) {
      if (boxIdx !== undefined) {
        var box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx];
        this.$set(box, 'showChatTwo', !box.showChatTwo);
        return;
      }
      this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatTwo', !this.creatorConceptData.deliverables[deliIndex].showChatTwo);
    },
    showBodyChatBox: function showBodyChatBox(deliIndex, boxIdx) {
      if (boxIdx !== undefined) {
        var box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx];
        this.$set(box, 'showChatBody', !box.showChatBody);
        return;
      }
      this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatBody', !this.creatorConceptData.deliverables[deliIndex].showChatBody);
    },
    showBodyChatBoxTwo: function showBodyChatBoxTwo(deliIndex, boxIdx) {
      if (boxIdx !== undefined) {
        var box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx];
        this.$set(box, 'showChatBodyTwo', !box.showChatBodyTwo);
        return;
      }
      this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatBodyTwo', !this.creatorConceptData.deliverables[deliIndex].showChatBodyTwo);
    },
    showCtaChatBox: function showCtaChatBox(deliIndex, boxIdx) {
      if (boxIdx !== undefined) {
        var box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx];
        this.$set(box, 'showChatCta', !box.showChatCta);
        return;
      }
      this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatCta', !this.creatorConceptData.deliverables[deliIndex].showChatCta);
    },
    closePutComment: function closePutComment(deliIndex, boxIdx) {
      if (boxIdx !== undefined) {
        var box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx];
        this.$set(box, 'showComment', !box.showComment);
        return;
      }
      this.creatorConceptData.deliverables[deliIndex].showComment = !this.creatorConceptData.deliverables[deliIndex].showComment;
    },
    switchVersion: function switchVersion(data) {
      this.creatorConceptData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, data);
      this.creatorConceptData.deliverables = this.creatorConceptData.deliverables.map(this.normalizeDeliverableComments);
    },
    setMainVersion: function setMainVersion(conceptId) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__pairingAPIs__["a" /* default */].setMainVer(conceptId);

              case 2:
                _this9.getPairedInfluencer();

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_20_moment___default()(date).format('DD-MM-YYYY, HH:mm');
    },
    renderHTML: function renderHTML(text) {
      if (text !== undefined && text !== null) {
        return text.replace(/\n/g, '<p><p>');
      }
      return '';
    }
  }
});

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'creator-concept-form',
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a },
  data: function data() {
    return {
      isLoading: false,
      contentScripts: [] };
  },

  computed: {
    influencerID: function influencerID() {
      return this.$store.state.user.influencerID;
    }
  },
  mounted: function mounted() {
    this.fetchPairingByInf();
  },

  methods: {
    fetchPairingByInf: function fetchPairingByInf() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__pairingAPIs__["a" /* default */].getContentScriptByinfID(this.influencerID).then(function (response) {
        _this.isLoading = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var resp = _step.value;

            _this.contentScripts.push(resp);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).catch(function (err) {
        console.log('Error:' + err);
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VersionNoModal',
  props: {
    value: Boolean
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      versionNo: ''
    };
  },

  validations: {
    versionNo: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    }
  },
  computed: {
    versionErrors: function versionErrors() {
      var errors = [];
      if (!this.$v.versionNo.$dirty) return errors;
      !this.$v.versionNo.required && errors.push('PIN is required');
      return errors;
    }
  },
  methods: {
    confirmVersionNo: function confirmVersionNo() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: 'Invalid Version No',
          text: 'Make sure you filled the version No correctly.'
        });
        return;
      }
      this.$emit('success', this.versionNo);
      this.closeModal();
      return;
    },
    closeModal: function closeModal() {
      this.$v.$reset();
      this.$emit('input');
      this.versionNo = '';
    }
  }
});

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chatBox',
  props: {
    messages: Array,
    title: String,
    readOnly: Boolean
  },
  data: function data() {
    return {
      messageText: ''
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      var message = {
        text: this.messageText,
        createdAt: new Date(),
        author: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.user.firstName,
        self: true
      };
      if (this.messageText === '') {
        this.$swal.fire("Message can't be empty", '', 'error');
      } else {
        this.messages.push(message);
        this.$emit('sendMessage', this.messageText);
        this.messageText = '';
      }
    },
    reloadMessage: function reloadMessage() {
      this.$emit('reloadMessage');
    },
    getRelativeTime: function getRelativeTime(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).fromNow();
    },
    renderHTML: function renderHTML(text) {
      if (text !== undefined && text !== null) {
        return text.replace(/\n/g, '<p><p>');
      }
      return '';
    }
  }
});

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddTagModal',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay___default.a
  },
  props: {
    value: Boolean,
    item: Object
  },
  validations: {
    updateData: {
      tag: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] }
    }
  },
  data: function data() {
    return {
      isLoading: false,
      updateData: {
        tag: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getAllTags();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])({
    allTags: function allTags(state) {
      return state.influencer.allTags;
    },
    customTag: function customTag(state) {
      return state.influencer.customTag;
    },
    updatedTag: function updatedTag(state) {
      return state.influencer.updatedTag;
    }
  })),
  watch: {
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(newValue) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.updateData = {
                  tag: []
                };
                this.getTags();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function value(_x) {
        return _ref.apply(this, arguments);
      }

      return value;
    }()
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.isLoading = true;
                if (_this2.updateData.tag) {
                  _this2.updateData.tag = _this2.updateData.tag.map(function (item) {
                    if ((typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object') {
                      return item.name;
                    }
                    return item;
                  });
                }
                saveData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                  influencerID: _this2.item.influencerID,
                  handle: _this2.item.userHandle,
                  platform: _this2.item.platform
                }, _this2.updateData));
                _context3.next = 5;
                return _this2.$store.dispatch('influencer/updateTag', {
                  updateData: saveData
                });

              case 5:
                _this2.isLoading = false;
                if (_this2.updatedTag) {
                  _this2.$swal({
                    text: 'Successfully Updated.',
                    type: 'success'
                  });
                  _this2.$emit('saved', _this2.updateData.tag);
                  _this2.close();
                } else {
                  _this2.$swal({
                    text: 'Error Updating Tag!',
                    type: 'error'
                  });
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getTags: function getTags() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _updateData$tag;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$store.dispatch('influencer/getCustomTags', {
                  filters: {
                    handle: _this3.item.userHandle
                  }
                });

              case 2:
                if (_this3.customTag) {
                  if (_this3.customTag.names) {
                    (_updateData$tag = _this3.updateData.tag).push.apply(_updateData$tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.customTag.names));
                  }
                }

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getAllTags: function getAllTags() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.$store.dispatch('influencer/getAllTags');

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Campaign_campaignHelper__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CampaignListsModal',
  props: ['items', 'value', 'handle', 'isRemark', 'emptyCampaigns'],
  data: function data() {
    return {
      headers: [{
        text: 'Campaign Name',
        value: 'name'
      }, {
        text: 'Campaign Type',
        value: 'campaignType'
      }, {
        text: 'Campaign Verticals',
        value: 'showVerticals'
      }, {
        text: 'Stage',
        value: 'campaignStatusDisplay'
      }, {
        text: 'Deliverables',
        value: 'deliverables'
      }, {
        text: 'Payout Amount',
        value: 'payout'
      }, {
        text: 'Pairing Date',
        value: 'pairingDate'
      }, {
        text: 'CC Remarks',
        value: 'ccRemarks'
      }, {
        text: 'Archive Status',
        value: 'isArchive'
      }],
      dataTableKey: 1,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_0__Campaign_campaignHelper__["a" /* default */]
    };
  },

  computed: {
    computedHeaders: function computedHeaders() {
      var exceptHeaders = ['campaignType', 'showVerticals', 'campaignStatusDisplay', 'deliverables', 'payout', 'pairingDate', 'isArchive'];
      if (this.isRemark) {
        return this.headers.filter(function (h) {
          return !exceptHeaders.includes(h.value);
        });
      }
      return this.headers;
    }
  },
  methods: {
    formatDesc: function formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>');
      }
      return text;
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Campaign_PairingInfluencer_ClientNotesModal__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Campaign_PairingInfluencer_ClientNotesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Campaign_PairingInfluencer_ClientNotesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chartjs_Pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_chartjs_Pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_chartjs_Pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ClientNotesModal: __WEBPACK_IMPORTED_MODULE_8__Campaign_PairingInfluencer_ClientNotesModal___default.a, SocialHandle: __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle___default.a, PieChart: __WEBPACK_IMPORTED_MODULE_14__components_chartjs_Pie___default.a, TableColsShowHideModal: __WEBPACK_IMPORTED_MODULE_15__components_scoped_custom_TableColsShowHideModal___default.a },
  props: {
    influencers: Array,
    elimination: Boolean,
    internalView: Boolean,
    campaignID: String,
    campaignData: Object
  },
  data: function data() {
    return {
      pairingStatus: __WEBPACK_IMPORTED_MODULE_10__Campaign_config__["a" /* default */].pairingStatus,
      eliminationStatus: __WEBPACK_IMPORTED_MODULE_10__Campaign_config__["a" /* default */].eliminationStatus,
      payoutStatus: __WEBPACK_IMPORTED_MODULE_10__Campaign_config__["a" /* default */].payoutStatus,
      changesDetected: false,
      viewReasonData: {},
      viewReasonDialog: false,
      clientNotesDialog: false,
      reasonDialog: false,
      workingIndex: null,
      workingID: null,
      eliminatedReason: '',
      limitReach: false,
      eliminatedPairings: [],
      selectedPairings: [],
      newPairings: [],
      eliminatedCount: 0,
      selectedCount: 0,
      newCount: 0,
      itemsPerPage: 30,
      influencerItems: [],
      headers: [{ text: 'Influencer', value: 'igHandle', sortable: false }, { text: 'Platform', value: 'platformName', sortable: false }, { text: 'Followers', value: 'totalFollowers', sortable: false }, { text: 'Aud. Gender', value: 'genderPercentage', sortable: false }, { text: 'Credibility', value: 'AudienceCredibility', sortable: false }, { text: 'Engagement', value: 'engagementRate', sortable: false }, { text: 'Remarks', value: 'remarks', sortable: false }, { text: 'Content Feature/pillar', value: 'contentFeature', sortable: false }, { text: 'Gender', value: 'gender', sortable: false }, { text: 'Age Group', value: 'age_group', sortable: false }, { text: 'Aud. Age Group (Majority)', value: 'aud_age_group', sortable: false }, { text: 'Aud. Country (Majority)', value: 'country', sortable: false }, { text: 'Status', value: 'selected', sortable: false }, { text: 'Eliminated Reason', value: 'eliminatedReason', sortable: false }, { text: 'Internal Notes', value: 'notes', sortable: false }],
      defaultOffCols: ['genderPercentage', 'aud_age_group', 'country'],
      measurement: {
        total: 0,
        outreach: 0,
        outreachPercentage: '',
        totalPercentage: ''
      },
      campaign: {},
      genderPie: {
        title: '',
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center',
            callbacks: {
              label: function label(tooltipItem, data) {
                var label = data.labels[tooltipItem.index] || '';
                return label;
              }
            }
          }
        },
        width: 70,
        height: 70
      },
      colSettingsDialog: false,
      colStatuses: {
        'igHandle': false,
        'platformName': false,
        'totalFollowers': false,
        'genderPercentage': false,
        'AudienceCredibility': false,
        'engagementRate': false,
        'remarks': false,
        'gender': false,
        'age_group': false,
        'aud_age_group': false,
        'country': false,
        'selected': false,
        'eliminatedReason': false,
        'notes': false,
        'contentFeature': false
      },
      tableColsItems: [],
      optionVal: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    displayFields: function displayFields(field) {
      if (this.colStatuses[field]) {
        return true;
      }
      return false;
    },
    calculateSummary: function calculateSummary() {
      var _this2 = this;

      this.measurement.total = this.measurement.outreach = 0;
      this.influencerItems.forEach(function (item) {
        if (item.eliminationStatus !== _this2.eliminationStatus.ELIMINATED) {
          _this2.measurement.total += Number(_this2.calculateContents(item));
          _this2.measurement.outreach += Number(_this2.calculateOutreach(item));
        }
      });
      this.measurement.outreachPercentage = (this.measurement.outreach / this.campaign.outreach * 100).toFixed(2);
      var content = this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
    },
    calculateContents: function calculateContents(item) {
      return item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_tiktok_posts + item.no_of_reels;
    },
    calculateOutreach: function calculateOutreach(item) {
      var followers = item.followers;
      return followers * (item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_tiktok_posts + item.no_of_reels);
    },
    updateCountStatus: function updateCountStatus() {
      var _this3 = this;

      var countUnselect = 0;
      var countSelect = 0;
      var countPending = 0;
      this.influencerItems.forEach(function (element) {
        if (element.eliminationStatus === _this3.eliminationStatus.ELIMINATED) countUnselect++;else if (element.eliminationStatus === _this3.eliminationStatus.SELECTED) countSelect++;else if (element.eliminationStatus === _this3.eliminationStatus.PENDING) countPending++;
      });
      this.eliminatedCount = countUnselect;
      this.selectedCount = countSelect;
      this.newCount = countPending;
    },
    isEliminated: function isEliminated(item) {
      return item.eliminationStatus === this.eliminationStatus.ELIMINATED;
    },
    isNew: function isNew(item) {
      return item.eliminationStatus === this.eliminationStatus.PENDING;
    },
    isSelected: function isSelected(item) {
      return item.eliminationStatus === this.eliminationStatus.SELECTED;
    },
    closeElimination: function closeElimination() {
      var _this4 = this;

      if (this.changesDetected) {
        this.$swal({
          title: 'You have unsaved changes, are you sure to close?',
          type: 'info',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          preConfirm: function preConfirm(reset) {
            _this4.resetWorkingData();
            _this4.changesDetected = false;
          },
          allowOutsideClick: function allowOutsideClick() {
            return !_this4.$swal.isLoading();
          }
        }).then(function (result) {
          if (result.value) {
            _this4.$emit('savedEliminationChanges');
          }
        });
      } else {
        this.$emit('savedEliminationChanges');
      }
    },
    viewReason: function viewReason(influencer) {
      this.viewReasonData.igHandle = influencer.instagramHandle;
      this.viewReasonData.text = influencer.eliminatedReason || influencer.eliminationReason;
      this.viewReasonDialog = true;
    },
    cancelReason: function cancelReason() {
      this.reasonDialog = false;
      this.resetWorkingData();
    },
    resetWorkingData: function resetWorkingData() {
      this.workingID = this.workingIndex = null;
      this.eliminatedReason = '';
    },
    doEliminate: function doEliminate(index, id, eliminatedData) {
      this.eliminatedPairings.push(eliminatedData);
      this.influencerItems[index].eliminationStatus = this.eliminationStatus.ELIMINATED;
      this.influencerItems[index].eliminatedReason = this.eliminatedReason;
      this.changesDetected = true;
      this.updateCountStatus();
      this.calculateSummary();
      this.resetWorkingData();
    },
    doSelect: function doSelect(index, id, statusTitle) {
      var newEliminationData = this.eliminatedPairings.filter(function (element) {
        return element.pairingID !== id;
      });
      this.eliminatedPairings = newEliminationData;
      if (statusTitle === 'New') {
        this.influencerItems[index].eliminationStatus = this.eliminationStatus.PENDING;
      } else if (statusTitle === 'Selected') {
        this.influencerItems[index].eliminationStatus = this.eliminationStatus.SELECTED;
      }
      this.influencerItems[index].eliminatedReason = '';
      this.changesDetected = true;
      this.updateCountStatus();
      this.calculateSummary();
      this.resetWorkingData();
    },
    actionHandler: function actionHandler(pairingID, statusTitle) {
      this.workingIndex = this.influencerItems.findIndex(function (i) {
        return i.pairingID === pairingID;
      });
      this.workingID = pairingID;
      if (statusTitle === 'Eliminated') {
        if (this.eliminatedCount < this.allowedAmount) {
          this.reasonDialog = true;
        } else {
          this.$swal({
            title: 'You have exceeded the maximum elimination limit.',
            text: 'Reselect the influencers if you want to continue.',
            type: 'warning'
          });
        }
      } else {
        this.doSelect(this.workingIndex, this.workingID, statusTitle);
      }
    },
    saveReason: function saveReason() {
      if (this.eliminatedReason === '') {
        this.$swal({
          title: 'Reason is required',
          type: 'error'
        });
      } else {
        var eliminatedObj = {
          pairingID: this.workingID,
          eliminatedReason: this.eliminatedReason
        };
        this.doEliminate(this.workingIndex, this.workingID, eliminatedObj);
        this.reasonDialog = false;
      }
    },
    saveEliminationChanges: function saveEliminationChanges(action) {
      var _this5 = this;

      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
        this.selectedPairings = [];
        this.newPairings = [];
        var selectedlist = [];
        var newList = [];
        var showSelectedCount = 0;
        if (action === 'save' || action === 'save_draft') {
          selectedlist = this.influencerItems.filter(function (item) {
            return item.eliminationStatus === _this5.eliminationStatus.SELECTED;
          });
          newList = this.influencerItems.filter(function (item) {
            return item.eliminationStatus === _this5.eliminationStatus.PENDING;
          });
          newList.forEach(function (item) {
            return _this5.newPairings.push(item.pairingID);
          });
          showSelectedCount = this.selectedCount;
        } else {
          selectedlist = this.influencerItems.filter(function (item) {
            return item.eliminationStatus !== _this5.eliminationStatus.ELIMINATED;
          });
          showSelectedCount = this.selectedCount + this.newCount;
        }
        selectedlist.forEach(function (item) {
          return _this5.selectedPairings.push(item.pairingID);
        });
        if (this.eliminatedPairings.length > 0 || this.selectedPairings.length > 0 || this.newPairings.length > 0) {
          var eliminationData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
            campaignID: this.campaignID,
            eliminated: this.eliminatedPairings,
            selected: this.selectedPairings,
            new: this.newPairings
          });
          if (action === 'save_draft') {
            eliminationData.action = action;
            __WEBPACK_IMPORTED_MODULE_9__pairingAPIs__["a" /* default */].submitEliminatedInfluencers(eliminationData).then(function (response) {
              _this5.$swal({
                title: 'Success',
                text: 'Your lineup is saved as draft, it has not been released to KOBE',
                type: 'success'
              });
              _this5.changesDetected = false;
              _this5.$emit('savedEliminationChanges');
            }).catch(function (error) {
              console.log(error);
              _this5.$swal.showValidationError('Error in saving changes! Pleae try again.');
            });
          } else {
            var unselectedTxt = '';
            if (action === 'save') {
              unselectedTxt = '<li style=\'list-style:none\'><strong>' + this.newCount + '</strong> creators unselected/new</li>';
            }
            this.$swal({
              html: '\n                <div style=\'font-weight:600;text-align:left\'>\n                <p>\n                  Upon Confirmation, the following will be submitted. <br>\n                  <ul>\n                    <li style=\'list-style:none\'><strong>' + showSelectedCount + '</strong> creators approved</li>\n                    ' + unselectedTxt + '\n                    <li style=\'list-style:none\'><strong>' + this.eliminatedCount + '</strong> creators eliminated</li>\n                  </ul>\n                  </p>\n                  <p>\n                  </div>\n                ',
              type: 'info',
              icon: 'swal2-icon-hide',
              showCancelButton: true,
              showCloseButton: true,
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              showLoaderOnConfirm: true,
              preConfirm: function preConfirm(callAPI) {
                return __WEBPACK_IMPORTED_MODULE_9__pairingAPIs__["a" /* default */].submitEliminatedInfluencers(eliminationData).then(function (response) {
                  return response;
                }).catch(function (error) {
                  console.log(error);
                  _this5.$swal.showValidationError('Error in saving changes! Pleae try again.');
                });
              },
              allowOutsideClick: function allowOutsideClick() {
                return !_this5.$swal.isLoading();
              }
            }).then(function (result) {
              if (result.value) {
                _this5.$swal({
                  title: 'Success',
                  text: 'Your changes are successfully saved',
                  type: 'success'
                });
                _this5.changesDetected = false;
                _this5.$emit('savedEliminationChanges');

                var influencerListForEmail = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _this5.influencerItems);
                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(influencerListForEmail).forEach(function (influencer) {
                  if (influencerListForEmail[influencer].eliminationStatus === 2) {
                    influencerListForEmail[influencer].eliminationStatus = 'Rejected';
                    influencerListForEmail[influencer].color = 'red';
                  } else if (influencerListForEmail[influencer].eliminationStatus === 1) {
                    influencerListForEmail[influencer].eliminationStatus = 'Approved';
                    influencerListForEmail[influencer].color = 'green';
                    influencerListForEmail[influencer].eliminationReason = '';
                  } else {
                    influencerListForEmail[influencer].eliminationStatus = 'Pending';
                    influencerListForEmail[influencer].color = 'grey';
                    influencerListForEmail[influencer].eliminationReason = '';
                  }
                });
                var influencerListArray = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(influencerListForEmail);

                var protocol = window.location.protocol;
                var host = window.location.host;
                var emailParam = {
                  influencerList: influencerListArray,
                  campaignID: _this5.campaignID,
                  pairing_influencer_url: protocol + '//' + host + '/campaigns/pairing_influencer'
                };
                __WEBPACK_IMPORTED_MODULE_9__pairingAPIs__["a" /* default */].sendClientAcceptedInfluencerListEmailNotify(emailParam);
              }
            });
          }
        }
      } else {
        this.$swal({
          title: 'Permissions Required',
          text: 'You don\'t have enough permissions to do this action.',
          type: 'info'
        });
      }
    },
    toPercent: function toPercent(num) {
      return (num * 100).toFixed(2);
    },
    showEliminationStatus: function showEliminationStatus(status) {
      if (status === this.eliminationStatus.SELECTED) {
        return 'Selected';
      } else if (status === this.eliminationStatus.ELIMINATED) {
        return 'Eliminated';
      } else {
        return 'New';
      }
    },
    openClientNotesDialog: function openClientNotesDialog(item) {
      this.clientNotesData = item;
      this.clientNotesDialog = true;
      if (this.isClientRole) {
        this.markNotesAsRead(item);
      }
    },
    refreshPairingData: function refreshPairingData() {
      this.$emit('savedClientNotes');
    },

    getSelectAttributes: function getSelectAttributes(item, type) {
      if (item.eliminationStatus === this.eliminationStatus.NEW || item.eliminationStatus === this.eliminationStatus.PENDING) {
        if (type === 'color') {
          return 'primary';
        } else if (type === 'icon') {
          return 'mdi-new-box';
        } else if (type === 'text') {
          return 'New';
        } else if (type === 'menus') {
          return this.getBtnTitleLists(['Selected', 'Eliminated']);
        }
      } else if (item.eliminationStatus === this.eliminationStatus.SELECTED) {
        if (type === 'color') {
          return 'green';
        } else if (type === 'icon') {
          return 'mdi-check';
        } else if (type === 'text') {
          return 'Selected';
        } else if (type === 'menus') {
          return this.getBtnTitleLists(['New', 'Eliminated']);
        }
      } else if (item.eliminationStatus === this.eliminationStatus.ELIMINATED) {
        if (type === 'color') {
          return 'red';
        } else if (type === 'icon') {
          return 'mdi-cancel';
        } else if (type === 'text') {
          return 'Eliminated';
        } else if (type === 'menus') {
          return this.getBtnTitleLists(['New', 'Selected']);
        }
      }
    },
    getBtnTitleLists: function getBtnTitleLists(titles) {
      var results = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(titles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var title = _step.value;

          results.push({ title: title });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results;
    },
    getIconByTitle: function getIconByTitle(title) {
      if (title === 'New') {
        return 'mdi-new-box';
      } else if (title === 'Selected') {
        return 'mdi-check';
      } else if (title === 'Eliminated') {
        return 'mdi-cancel';
      }
    },
    getClientUnreadCount: function getClientUnreadCount(item) {
      var _this6 = this;

      var unread = 0;
      if (item.clientNotes !== undefined) {
        item.clientNotes.map(function (note) {
          note.read = note.read || [];
          if (!note.read.includes(_this6.currentUserID)) {
            unread++;
          }
        });
      }
      return unread;
    },
    markNotesAsRead: function markNotesAsRead(item) {
      var unreadNoteIDs = [];
      if (item.clientNotes !== undefined) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(item.clientNotes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var note = _step2.value;

            note.read = note.read || [];
            if (!note.read.includes(this.currentUserID)) {
              unreadNoteIDs.push(this.currentUserID);
              note.read.push(this.currentUserID);
              this.updateReadNote(item.pairingID, unreadNoteIDs);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      item.clientNotes = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].func.refreshJSON(item.clientNotes);
    },
    updateReadNote: function updateReadNote(pairingID, unreadNoteIDs) {
      var formData = new FormData();
      formData.append('pairingID', pairingID);
      formData.append('unreads', unreadNoteIDs);
      __WEBPACK_IMPORTED_MODULE_9__pairingAPIs__["a" /* default */].saveClientNoteRead(formData).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    getGenderPieData: function getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        var ret = [];
        var male = audienceGenders.find(function (a) {
          return a.code === 'MALE';
        });
        if (male) ret.push(male);
        var female = audienceGenders.find(function (a) {
          return a.code === 'FEMALE';
        });
        if (female) ret.push(female);
        return ret.map(function (gender) {
          return (gender.weight * 100).toFixed(2);
        });
      }
    },
    confirmSendToClient: function confirmSendToClient() {
      this.$emit('sendToClient');
    },
    openColSettingsModal: function openColSettingsModal() {
      this.tableColsItems = [];
      var tmpStatuses = {};
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.colStatuses).length) {
        tmpStatuses = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.colStatuses);
      } else {
        this.headers.map(function (header) {
          tmpStatuses[header.value] = true;
        });
      }
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.headers)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref = _step3.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (value.text) {
            this.tableColsItems.push({
              title: value.text,
              key: value.value,
              value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
            });
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.colSettingsDialog = true;
    },
    updateTableCols: function updateTableCols(items) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var columns, tableSettings, updateData;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                columns = _this7.colStatuses;

                items.map(function (item) {
                  columns[item.key] = item.value;
                });
                tableSettings = {};

                if (_this7.campaign.tableSettings) {
                  tableSettings = _this7.campaign.tableSettings;
                }
                tableSettings.pairingEliminationCols = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, columns);
                updateData = [{
                  id: _this7.campaign.id,
                  tableSettings: tableSettings
                }];
                _context2.next = 8;
                return _this7.$store.dispatch('campaign/updateCampaignByIds', updateData);

              case 8:
                _this7.campaign.tableSettings = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, tableSettings);
                _this7.colStatuses = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, columns);
                _this7.colSettingsDialog = false;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    }
  },
  computed: {
    computedHeaders: function computedHeaders() {
      var _this8 = this;

      var pairingEliminationCols = null;

      if (this.campaign.tableSettings) {
        if (this.campaign.tableSettings.pairingEliminationCols) {
          pairingEliminationCols = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.campaign.tableSettings.pairingEliminationCols);
        }
      }
      this.headers.map(function (header) {
        if (!_this8.colStatuses[header.value]) {
          if (_this8.defaultOffCols.includes(header.value)) {
            _this8.colStatuses[header.value] = false;
          } else {
            _this8.colStatuses[header.value] = true;
          }
        } else {
          _this8.colStatuses[header.value] = true;
        }
      });
      if (pairingEliminationCols) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(pairingEliminationCols)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var key = _step4.value;

            this.colStatuses[key] = pairingEliminationCols[key];
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      return this.headers.filter(function (h) {
        if (_this8.colStatuses[h.value]) {
          return true;
        }
        return false;
      });
    },

    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isClientRole: function isClientRole() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT;
    },
    isElimination: function isElimination() {
      return this.elimination || false;
    },
    allowedAmount: function allowedAmount() {
      return this.influencers.length * 0.1;
    },
    campaignStatusConfig: function campaignStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].campaignStatus;
    },
    disableActions: function disableActions() {
      return this.campaignData.status === this.campaignStatusConfig.COMPLETE || this.internalView;
    }
  },
  watch: {
    influencers: function influencers(newList) {
      this.influencerItems = newList;
      this.selectedPairings = [];
      this.eliminatedPairings = [];
      this.campaign = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.campaignData);
      this.updateCountStatus();
      this.calculateSummary();
    },
    campaignData: function campaignData(newCampaign) {
      this.campaign = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, newCampaign);

      this.measurement = {
        total: 0,
        outreach: 0,
        outreachPercentage: '',
        totalPercentage: ''
      };
    }
  }
});

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postApi__ = __webpack_require__(42);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    post: Object
  },
  data: function data() {
    return {
      postData: null,
      campaignList: null,
      selectedCampaignID: null
    };
  },
  mounted: function mounted() {
    this.fetchCampaignList();
  },

  methods: {
    assignCampaign: function assignCampaign() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__postApi__["a" /* default */].csAssignCampaign(this.postData._id, this.selectedCampaignID).then(function (response) {
        _this.$emit('input');
        _this.$swal({
          title: 'Saved Changes',
          content: 'Page will reload to apply changes',
          type: 'success'
        }).then(function () {
          return _this.$emit('success');
        });
      }).catch(function (err) {
        _this.$swal({
          position: 'top-end',
          title: 'Can\'t Save Changes',
          text: err,
          type: 'error'
        });
      });
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
        var results = [];
        response = response.filter(function (r) {
          return r.status === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].campaignStatus.ONGOING || r.status === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER;
        });
        response.forEach(function (element) {
          var campaign = {
            name: element.name,
            id: element.id
          };
          results.push(campaign);
        });
        _this2.campaignList = results;
      }).catch(function (err) {
        console.log('Error:' + err);
        console.log('');
      });
    }
  },
  watch: {
    post: function post(newPost) {
      if (newPost !== null) {
        this.postData = newPost;
        this.selectedCampaignID = this.postData.campaignID || null;
      }
    }
  }
});

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__postApi__ = __webpack_require__(42);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    posts: Array
  },
  data: function data() {
    return {
      postData: [],
      campaignList: null,
      selectedCampaignID: null
    };
  },
  mounted: function mounted() {
    this.fetchCampaignList();
  },

  methods: {
    assignCampaign: function assignCampaign() {
      var _this = this;

      if (!this.selectedCampaignID) {
        this.$swal({
          title: 'Please choose a campaign',
          type: 'warning'
        });
        return;
      }

      var selectedPosts = Array.isArray(this.postData) ? this.postData : [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(selectedPosts.map(function (post) {
        return __WEBPACK_IMPORTED_MODULE_3__postApi__["a" /* default */].csAssignCampaign(post._id, _this.selectedCampaignID);
      })).then(function () {
        _this.$emit('input');
        _this.$swal({
          title: 'Saved Changes',
          content: 'Page will reload to apply changes',
          type: 'success'
        }).then(function () {
          return _this.$emit('success');
        });
      }).catch(function (err) {
        _this.$swal({
          position: 'top-end',
          title: 'Can\'t Save Changes',
          text: err,
          type: 'error'
        });
      });
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus().then(function (response) {
        var results = [];
        response = response.filter(function (r) {
          return r.status === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.ONGOING || r.status === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER;
        });
        response.forEach(function (element) {
          var campaign = {
            name: element.name,
            id: element.id
          };
          results.push(campaign);
        });
        _this2.campaignList = results;
      }).catch(function (err) {
        console.log('Error:' + err);
      });
    }
  },
  watch: {
    posts: function posts(newPostList) {
      if (Array.isArray(newPostList) && newPostList.length > 0) {
        this.postData = newPostList;
        this.selectedCampaignID = newPostList[0].campaignID || null;
      } else {
        this.postData = [];
        this.selectedCampaignID = null;
      }
    }
  }
});

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ViewPostModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ViewPostModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ViewPostModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy__);





var _this = this;













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_8__ViewPostModal_vue___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_9__components_scoped_custom_SocialHandle___default.a
  },
  data: function data() {
    return {
      viewPostDialog: false,
      viewPostData: null,
      focus: _this.today,
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day'
      },
      start: null,
      end: null,
      startDate: null,
      endDate: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      loading: false,
      selected: [],
      totalItems: '',
      posts: [],
      formLink: '',
      filter: {
        instagramHandle: null,
        campaignName: null,
        clientID: null,
        today: false,
        story: false
      }
    };
  },
  computed: {
    user: function user() {
      return this.$store.state.user;
    },
    today: function today() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD');
    },
    title: function title() {
      var start = this.start,
          end = this.end;

      if (!start || !end) {
        return '';
      }

      var startMonth = this.monthFormatter(start);
      var endMonth = this.monthFormatter(end);
      var suffixMonth = startMonth === endMonth ? '' : endMonth;

      var startYear = start.year;
      var endYear = end.year;
      var suffixYear = startYear === endYear ? '' : endYear;

      var startDay = start.day + this.nth(start.day);
      var endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return startMonth + ' ' + startYear;
        case 'week':
        case '4day':
          return startMonth + ' ' + startDay + ' ' + startYear + ' - ' + suffixMonth + ' ' + endDay + ' ' + suffixYear;
        case 'day':
          return startMonth + ' ' + startDay + ' ' + startYear;
      }
      return '';
    },
    monthFormatter: function monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long'
      });
    },

    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].postStatus;
    }
  },
  mounted: function mounted() {
    this.$refs.calendar.checkChange();
    this.fetchPosts();
  },

  methods: {
    viewDetailPost: function viewDetailPost(postID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__postApi__["a" /* default */].getPostById(postID).then(function (post) {
        _this2.viewPostData = post;
        _this2.viewPostDialog = true;
      }).catch(function (err) {
        _this2.viewPostDialog = false;
        _this2.$swal({
          title: 'Couldn\'t the Post',
          type: 'error',
          text: err
        });
      });
    },
    fetchPosts: function fetchPosts() {
      var _this3 = this;

      var status = this.postStatusConfig.APPROVE;
      this.loading = true;
      var query = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].func.clean(this.filter);
      query.status = status;
      query.lastSevenDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(6, 'days').format('YYYY-MM-DD');
      if (!this.startDate) this.startDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD');
      if (!this.endDate) this.endDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('YYYY-MM-DD');
      query.start = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.startDate).subtract(10, 'days').format('YYYY-MM-DD');
      query.end = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.endDate).add(10, 'days').format('YYYY-MM-DD');
      var campaignIds = [];
      __WEBPACK_IMPORTED_MODULE_13__Campaign_campaignAPIs__["a" /* default */].getReportsForCalendar(query).then(function (resp) {
        resp = __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy___default()(resp, function (item) {
          return item.campaignID + '|' + item.owner;
        });
        _this3.posts = resp;
        var eventArray = [];
        var eventObj = {};
        var colors = [];
        resp.forEach(function (post) {
          var inf = post.owner;
          var labelName = inf + ' (' + post.campaignName + ')';
          var nextSevDays = __WEBPACK_IMPORTED_MODULE_7_moment___default()(post.live_date).add(6, 'days').format('YYYY-MM-DD');
          var clr = '';
          var matchColor = colors.find(function (e) {
            return e.campaignID === post.campaignID;
          });
          if (matchColor) {
            clr = matchColor.color;
          } else {
            clr = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.getFixedClr();
            colors.push({
              campaignID: post.campaignID,
              color: clr
            });
          }
          eventObj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
            postID: post.id,
            color: clr,
            influencer: post.owner,
            campaignID: post.campaignID,
            campaignName: post.campaignName,
            name: labelName,
            liveDate: __WEBPACK_IMPORTED_MODULE_7_moment___default()(post.live_date).format('YYYY-MM-DD'),
            start: nextSevDays,
            end: nextSevDays,
            postLinks: post.postLinks
          });
          if (post.campaignID) {
            campaignIds.push(post.campaignID);
          }
          eventArray.push(eventObj);
        });
        _this3.getPairingsByCampaigns(campaignIds);
        _this3.events = eventArray;
        _this3.loading = false;
      }).catch(function (err) {
        _this3.loading = false;
        console.error(err);
      });
    },
    viewDay: function viewDay(_ref) {
      var date = _ref.date;

      this.focus = date;
      this.type = 'day';
    },
    getEventColor: function getEventColor(event) {
      return event.color;
    },
    setToday: function setToday() {
      this.focus = this.today;
    },
    prev: function prev() {
      this.$refs.calendar.prev();
    },
    next: function next() {
      this.$refs.calendar.next();
    },
    showEvent: function showEvent(_ref2) {
      var _this4 = this;

      var nativeEvent = _ref2.nativeEvent,
          event = _ref2.event;

      var open = function open() {
        _this4.selectedEvent = event;
        _this4.selectedElement = nativeEvent.target;
        setTimeout(function () {
          return _this4.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange: function updateRange(_ref3) {
      var start = _ref3.start,
          end = _ref3.end;

      this.start = start;
      this.end = end;
      this.startDate = String(start.date);
      this.endDate = String(end.date);
      this.fetchPosts();
    },
    nth: function nth(d) {
      return d > 3 && d < 21 ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
    },
    getPairingsByCampaigns: function getPairingsByCampaigns(campaignIDs) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var pairings, campaignPayouts, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__Pairing_pairingAPIs__["a" /* default */].getPairedInfluencersByCampaignIDs(campaignIDs);

              case 2:
                pairings = _context.sent;
                _context.next = 5;
                return _this5.getAllCampaignPayouts();

              case 5:
                campaignPayouts = _context.sent;

                _loop = function _loop(event) {
                  if (event.campaignID) {
                    var pairing = pairings.find(function (p) {
                      return p.campaignID === event.campaignID && p.influencer_details && (event.influencer === p.influencer_details.instagramHandle || event.influencerID === p.influencer_details.influencerID);
                    });
                    if (pairing) {
                      event.pairingID = pairing.id;
                      var matchCampaignPayout = campaignPayouts.find(function (c) {
                        return c.campaignID === pairing.campaignID && pairing.influencer_details && (c.handle === pairing.influencer_details.instagramHandle || c.influencerID === pairing.influencer_details.influencerID);
                      });
                      if (matchCampaignPayout) {
                        event.stats = true;
                        event.handle = matchCampaignPayout.handle;
                      }
                    }

                    var influencerPairing = pairings.find(function (p) {
                      return event.influencer && p.influencer_details.instagramHandle === event.influencer;
                    });
                    if (influencerPairing) {
                      if (influencerPairing.influencer_details) {
                        event.platform = influencerPairing.influencer_details.platform || 'instagram';
                      }
                    }
                  }
                };

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this5.events); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  event = _step.value;

                  _loop(event);
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[10, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },
    getAllCampaignPayouts: function getAllCampaignPayouts() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, campaignPayouts;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].getAllCampaignPayouts({});

              case 2:
                response = _context2.sent;
                campaignPayouts = response.data;

                campaignPayouts = campaignPayouts.map(function (element) {
                  var resultData = {
                    campaignName: element.campaignName,
                    campaignID: element.campaignID,
                    influencerID: element.influencerID
                  };
                  if (element.tiktok) {
                    resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : '';
                    resultData.fullName = element.tiktok ? element.tiktok.tiktokFullname : '';
                    resultData.tiktok_post_url = element.tiktokPostURL;
                    resultData.platform = 'tiktok';
                  } else {
                    resultData.handle = element.instagram ? element.instagram.instagramHandle : '';
                    resultData.fullName = element.instagram ? element.instagram.instagramFullname : '';
                    resultData.instagram_post_url = element.instagramPostURL;
                    resultData.platform = 'instagram';
                  }
                  if (!resultData.handle) {
                    if (element.handle) {
                      resultData.handle = element.handle;
                      resultData.platform = element.platform || 'instagram';
                    }
                  }
                  return resultData;
                });
                return _context2.abrupt('return', campaignPayouts);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    copyFormLink: function copyFormLink(item) {
      this.copySucceeded = true;
      var protocol = window.location.protocol;
      var host = window.location.host;
      this.formLink = protocol + '//' + host + '/submit-post-payout?pairingID=' + item.pairingID;
      setTimeout(function () {
        item.linkCopied = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].func.copyToClipboard('#copy-link');
      }, 100);
    },
    viewStatsLink: function viewStatsLink(item) {
      window.open('/campaignPayoutsInternal?influencerID=' + item.influencerID + '&campaignID=' + item.campaignID + '&handle=' + item.handle + '&stats=true', '_blank');
    },

    changeDateFormat: function changeDateFormat(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format('DD-MM-YYYY');
    }
  }
});

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    post: Object,
    postIds: Array
  },
  data: function data() {
    return {
      postData: null,
      options: [0, 1, 2, 3, 4, 5],
      selectedStatus: null
    };
  },

  methods: {
    changeStatus: function changeStatus() {
      var _this = this;

      if (this.selectedStatus === null) {
        this.$swal({
          title: 'Error',
          type: 'error',
          text: 'Empty Status'
        });
      } else {
        if (this.postIds.length > 0) {
          this.changeBulkPostStatus();
          return;
        }
        __WEBPACK_IMPORTED_MODULE_1__postApi__["a" /* default */].changeStatus(this.postData._id, this.selectedStatus).then(function (response) {
          if (response.success) {
            _this.$emit('updated', true);
            _this.$emit('input');
            _this.$swal({
              title: 'Success',
              text: 'Post Status Changed. Do you want to go to updated stage?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No, Stay here'
            }).then(function (result) {
              if (result.value) {
                _this.$router.push({ name: _this.displayStatus(_this.selectedStatus) });
              }
            });
          } else {
            _this.$swal('Post Status Changed Failed');
          }
        }).catch(function (err) {
          return console.error(err);
        });
      }
    },
    changeBulkPostStatus: function changeBulkPostStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__postApi__["a" /* default */].changeBulkStatus(this.postIds, this.selectedStatus).then(function (response) {
        if (response.success) {
          _this2.$emit('updated', true);
          _this2.$emit('input');
          _this2.$swal({
            title: 'Success',
            text: 'Post Status Changed. Do you want to go to updated stage?',
            type: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, Stay here'
          }).then(function (result) {
            if (result.value) {
              _this2.$router.push({ name: _this2.displayStatus(_this2.selectedStatus) });
            }
          });
        } else {
          _this2.$swal('Post Status Changed Failed');
        }
      }).catch(function (err) {
        return console.error(err);
      });
    },
    displayStatus: function displayStatus(status) {
      if (status === null || status === undefined) {
        return;
      }
      return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatusDisplayExternal[status]['display'];
    }
  },
  computed: {
    status_options: function status_options() {
      var data = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatus).forEach(function (item) {
        data.push({
          status: item[1],
          display: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].postStatusDisplayExternal[item[1]]['display']
        });
      });
      return data;
    },
    disableSubmit: function disableSubmit() {
      return !this.post && this.postIds && this.postIds.length === 0 || this.post && this.selectedStatus === this.post.status;
    }
  },
  watch: {
    post: function post(newPost) {
      if (newPost !== null) {
        this.postData = newPost;
        this.selectedStatus = newPost.status;
      }
    }
  }
});

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ClientChooseDateModal',
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_5__components_scoped_custom_DatePicker___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  props: {
    post: Object,
    ChooseDateDialogValue: Boolean
  },
  data: function data() {
    return {
      isLoading: false,
      submissionReview: {
        approveRatings: null,
        approveSuggestion: null,
        wantedLiveDate: null,
        propose_dates: []
      },
      utils: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    postUpdateStatus: function postUpdateStatus(state) {
      return state.post.updated;
    }
  })),
  methods: {
    resetForm: function resetForm() {
      this.submissionReview = {
        approveRatings: null,
        approveSuggestion: null,
        wantedLiveDate: null,
        propose_dates: []
      };
      this.valid = true;
    },
    close: function close() {
      this.proposeDialogValue = false;
      this.$emit('chooseDateClosed');
    },
    submitApprove: function submitApprove() {
      var _this2 = this;

      if (this.submissionReview.approveRatings === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        });
      } else if (this.submissionReview.approveSuggestion === null && this.submissionReview.approveCompliment === null) {
        this.$swal({
          title: 'Your comment is required',
          type: 'warning'
        });
      } else if (this.submissionReview.wantedLiveDate === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        });
      } else {
        this.$swal({
          title: 'Do you want to approve this date?',
          type: 'question',
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(function (result) {
          if (result.value) {
            var body = {
              rating: _this2.submissionReview.approveRatings,
              comment: _this2.submissionReview.approveSuggestion || _this2.submissionReview.approveCompliment,
              appLink: window.location.protocol + '//' + window.location.host + '/posts/internal/all-posts?campaignID=' + _this2.post.campaignID + '&postID=' + _this2.post._id,
              postDate: _this2.submissionReview.wantedLiveDate,
              isApprove: true
            };
            if (_this2.submissionReview.wantedLiveDate < __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_3_moment___default()(), 'YYYY-MM-DD')) {
              body.isDateOverdue = true;
            }
            __WEBPACK_IMPORTED_MODULE_6__postApi__["a" /* default */].clientApprovePost([{
              id: _this2.post._id,
              body: body
            }]).then(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _this2.$swal({
                        type: 'success',
                        title: 'Approved'
                      }).then(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                _this2.close();
                                _this2.$emit('postUpdated');
                                _this2.$router.push({ path: '/clients/posts' });

                              case 3:
                              case 'end':
                                return _context2.stop();
                            }
                          }
                        }, _callee2, _this2);
                      })));

                    case 1:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee3, _this2);
            }))).catch(function () {
              return _this2.$swal({
                type: 'error',
                title: 'Some thing went wrong'
              });
            });
          }
        });
      }
    },
    allowedDates: function allowedDates(val) {
      var proposeDates = this.submissionReview.propose_dates;
      if (Array.isArray(proposeDates) && proposeDates.length <= 3) {
        return proposeDates.includes(val);
      }
      return true;
    }
  },
  watch: {
    post: function post(newVal) {
      this.submissionReview.approveRatings = newVal.clientAcceptReview ? newVal.clientAcceptReview.rate : null;
      this.submissionReview.approveSuggestion = newVal.clientAcceptReview ? newVal.clientAcceptReview.comment : null;
      this.submissionReview.propose_dates = newVal.propose_dates;
    }
  }
});

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scoped_post_StoryForm__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scoped_post_StoryForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_scoped_post_StoryForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_post_PostForm__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_post_PostForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_scoped_post_PostForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scoped_post_VideoForm__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scoped_post_VideoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_scoped_post_VideoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InfluencerTermsModal__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InfluencerTermsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InfluencerTermsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_core_Loading__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_core_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_core_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pairing_pairingAPIs__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scoped_post_Deliverables__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scoped_post_Deliverables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__scoped_post_Deliverables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PostMediaPreviewModal_vue__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PostMediaPreviewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__PostMediaPreviewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__postConfig__ = __webpack_require__(74);



























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PostForm: __WEBPACK_IMPORTED_MODULE_8__components_scoped_post_PostForm___default.a,
    StoryForm: __WEBPACK_IMPORTED_MODULE_7__components_scoped_post_StoryForm___default.a,
    VideoForm: __WEBPACK_IMPORTED_MODULE_9__components_scoped_post_VideoForm___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_13__components_core_Loading___default.a,
    InfluencerTermsModal: __WEBPACK_IMPORTED_MODULE_10__InfluencerTermsModal___default.a,
    btnDownload: __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2___default.a,
    PostDeliverables: __WEBPACK_IMPORTED_MODULE_19__scoped_post_Deliverables___default.a,
    SocialHandle: __WEBPACK_IMPORTED_MODULE_21__components_scoped_custom_SocialHandle___default.a,
    PostMediaPreviewModal: __WEBPACK_IMPORTED_MODULE_22__PostMediaPreviewModal_vue___default.a
  },
  data: function data() {
    return {
      step: 1,
      campaigns: [],
      selectedCampaign: {
        name: null,
        id: null
      },
      isLoading: false,
      postType: __WEBPACK_IMPORTED_MODULE_23__postConfig__["a" /* default */].postTypes,
      posts: [],
      previewMedia: '',
      mediaType: '',
      imageDialog: false,
      postDetail: false,
      postData: '',
      influencerRole: __WEBPACK_IMPORTED_MODULE_16__config__["a" /* default */].userRoles.INFLUENCER,
      showAgreementModal: false,
      influencerProfile: {},
      currentInf: null,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_20__Campaign_campaignHelper__["a" /* default */],
      isCutOff: false,
      mediaPreviewDialog: false,
      mediaPreviewData: ''
    };
  },
  created: function created() {
    var status = __WEBPACK_IMPORTED_MODULE_11__components_views_Campaign_config__["a" /* default */].pairingStatus.ACCEPTED;

    this.fetchInvitedCampaign(this.influencer, status);
    this.getInfluencerData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['user', 'activePlatform', 'showActivePlatform']), {
    influencer: function influencer() {
      return this.$store.state.user.influencerID;
    },

    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUser: function currentUser() {
      return this.$store.state.user;
    },
    currentUserFullName: function currentUserFullName() {
      return this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName;
    }
  }),
  methods: {
    initPosts: function initPosts() {
      this.posts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.postType);
    },
    getPostTypeMeta: function getPostTypeMeta(type) {
      return this.postType.find(function (postType) {
        return postType.type === type;
      }) || {};
    },
    validateSubmitPosts: function validateSubmitPosts() {
      var posts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.posts);
      if (!this.validatePosts(posts)) {
        this.step = 2;
        return false;
      }
      this.mediaPreviewData = this.posts[0];
      this.mediaPreviewDialog = true;
    },
    termsAgreed: function termsAgreed(agree) {
      if (agree) {
        this.showAgreementModal = true;
      }
      return;
    },
    submitPosts: function submitPosts(agree) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var posts, success, fail, fails, i, post, formData, resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this.showAgreementModal = false;

                if (agree) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', false);

              case 4:
                posts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this.posts);

                _this.isLoading = true;
                success = 0;
                fail = 0;
                fails = [];
                i = 0;

              case 10:
                if (!(i < posts.length)) {
                  _context2.next = 20;
                  break;
                }

                post = posts[i];
                formData = _this.buildFormData(post);
                _context2.next = 15;
                return __WEBPACK_IMPORTED_MODULE_12__postApi__["a" /* default */].submitPost(formData);

              case 15:
                resp = _context2.sent;

                if (resp.success) {
                  success++;
                } else {
                  fail++;
                  fails.push(post);
                  console.error(resp.message);
                }

              case 17:
                i++;
                _context2.next = 10;
                break;

              case 20:
                _this.posts = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], fails);

                _this.isLoading = false;
                if (fail > 0) {
                  _this.$swal({
                    title: 'Post Submitted',
                    html: '<p><b>' + success + '</b> Post(s) are successfully submitted</p>' + '<p><b>' + fail + '</b> Posts(s) are fail to submit</p><p>Please re-submit the fail posts</p>',
                    type: 'warning'
                  });
                  _this.step = 2;
                } else {
                  _this.$swal({
                    type: 'success',
                    title: 'Successfully submitted',
                    html: '<div class="text-left subtitle-1">\n            <ul>\n              <li style=\'list-style:none\'>Your content will remain publicly accessible through your social media account(s) for a minimum of six (6) months, and you do not work with a competitor brand for the next 4 weeks unless otherwise stated.</li>\n            </ul>\n            </div>'
                  }).then(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (result.value) {
                                _this.$router.push({ path: '/posts/pending-kobe' });
                              }

                            case 1:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                }
                _context2.next = 29;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2['catch'](0);

                _this.isLoading = false;
                _this.$swal({ type: 'error', text: 'Unexpected error' });

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[0, 25]]);
      }))();
    },
    reset: function reset() {
      this.selectedCampaign = null;

      this.posts = [];

      this.step = 1;
    },
    buildFormData: function buildFormData(postData) {
      var formData = new FormData();
      var post = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, postData);
      post.campaignID = this.selectedCampaign.id;
      post.clientID = this.selectedCampaign.clientID;
      post.campaignName = this.selectedCampaign.name;
      post.submissionDate = this.selectedCampaign.submission_date;
      post.handle = this.influencerProfile.handle;
      post.platform = this.influencerProfile.platform || this.activePlatform;
      post.profilePicture = this.currentUser.profilePicture;

      var medias = post.media ? post.media.map(function (m) {
        return m.file;
      }) : [];
      delete post.media;
      formData.append('post', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(post));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(medias), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var media = _step.value;

          formData.append('images', media);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formData;
    },
    validatePosts: function validatePosts(posts) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(posts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var post = _step2.value;

          if ((!post.captionText || post.captionText.length <= 0) && post.type !== 'story') {
            this.$swal({
              type: 'warning',
              text: 'Post Caption is missing in your draft, please check.'
            });
            return false;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return true;
    },
    fetchInvitedCampaign: function fetchInvitedCampaign(influencerID, status) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var campaigns, message;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (influencerID) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('Your social media account is not connected.');

              case 3:
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_14__Pairing_pairingAPIs__["a" /* default */].getInvitedCampaigns(influencerID, status);

              case 5:
                campaigns = _context3.sent;

                _this2.campaigns = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], campaigns);
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);
                message = _context3.t0.message ? _context3.t0.message : 'Cannot get campaigns';

                _this2.$swal({
                  type: 'error',
                  text: message
                }).then(function (result) {
                  if (result.value) {
                    _this2.$router.push('Profile');
                  }
                });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 9]]);
      }))();
    },
    addPost: function addPost(postType) {
      var post = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, postType);
      this.posts.push(post);
    },
    deletePost: function deletePost(postIndex) {
      this.posts.splice(postIndex, 1);
    },
    postTypeChanged: function postTypeChanged(postIndex, postType) {
      if (this.posts[postIndex].type === postType.type) {
        return;
      }
      this.posts[postIndex] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.posts[postIndex], postType);
      this.posts.splice();
    },
    textChanged: function textChanged(text, index) {
      this.posts[index].captionText = text;
    },
    vdoLinkChanged: function vdoLinkChanged(text, index) {
      this.posts[index].vdoLink = text;
    },
    remarkChanged: function remarkChanged(text, index) {
      this.posts[index].remark = text;
    },
    mediaChanged: function mediaChanged(media, index) {
      this.posts[index].media = media;
    },
    viewMedia: function viewMedia(media) {
      this.imageDialog = true;
      this.previewMedia = '';
      this.previewMedia = media;
    },
    modalClickOutSide: function modalClickOutSide() {
      if (this.mediaType === 'vdo') {
        var vdoCtrl = document.getElementById('postVdo');
        vdoCtrl.pause();
        vdoCtrl.currentTime = 0;
        vdoCtrl.src = '';
      }
    },
    paserImageUrl: function paserImageUrl(url) {
      if (url) {
        var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    showDetails: function showDetails(post) {
      this.postData = post;
      this.postDetail = true;
    },
    checkOpenBillingDialog: function checkOpenBillingDialog(currentInf) {
      if (!currentInf.fullName || !currentInf.country || !currentInf.bankName || !currentInf.bankAccount || !currentInf.billingEmail || !currentInf.mailingAddress) {
        this.$router.push({ path: '/profile' });
      }
    },
    getInfluencerData: function getInfluencerData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_15__User_userAPIs__["a" /* default */].getUser(this.currentUserID).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(response) {
          var inf;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this3.influencerProfile.platform = _this3.activePlatform;

                  if (!_this3.showActivePlatform) {
                    _context4.next = 5;
                    break;
                  }

                  _this3.influencerProfile.handle = _this3.showActivePlatform.handle;
                  _context4.next = 18;
                  break;

                case 5:
                  _context4.t0 = _this3.activePlatform;
                  _context4.next = _context4.t0 === 'tiktok' ? 8 : _context4.t0 === 'youtube' ? 10 : _context4.t0 === 'linkedin' ? 12 : _context4.t0 === 'twitter' ? 14 : 16;
                  break;

                case 8:
                  _this3.influencerProfile.handle = _this3.currentUser.tiktokHandle;
                  return _context4.abrupt('break', 18);

                case 10:
                  _this3.influencerProfile.handle = _this3.currentUser.youtubeHandle;
                  return _context4.abrupt('break', 18);

                case 12:
                  _this3.influencerProfile.handle = _this3.currentUser.linkedinHandle;
                  return _context4.abrupt('break', 18);

                case 14:
                  _this3.influencerProfile.handle = _this3.currentUser.twitterHandle;
                  return _context4.abrupt('break', 18);

                case 16:
                  _this3.influencerProfile.handle = _this3.currentUser.igHandle;
                  return _context4.abrupt('break', 18);

                case 18:
                  if (!response.influencer) {
                    _context4.next = 32;
                    break;
                  }

                  _this3.currentInf = response.influencer;
                  inf = response.influencer;

                  if (!inf.instagram && !inf.tiktok && !inf.youtube && !inf.linkedin && !inf.twitter && !inf.reqIgHandle && !inf.reqTikTokHandle && !inf.reqYoutubeHandle) {
                    _this3.$swal({
                      text: 'Please Connect Platform',
                      type: 'warning',
                      allowOutsideClick: false
                    }).then(function (result) {
                      if (result.value) {
                        _this3.$router.push({ path: '/profile' });
                      }
                    });
                  } else if (!_this3.showActivePlatform) {
                    if (_this3.activePlatform === 'linkedin' && inf.linkedin) {
                      _this3.influencerProfile.handle = inf.linkedin.linkedinHandle;
                    } else if (_this3.activePlatform === 'twitter' && inf.twitter) {
                      _this3.influencerProfile.handle = inf.twitter.twitterHandle;
                    } else if (inf.reqIgHandle) {
                      _this3.influencerProfile.handle = inf.reqIgHandle;
                    } else if (inf.reqTikTokHandle) {
                      _this3.influencerProfile.handle = inf.reqTikTokHandle;
                    } else if (inf.reqYoutubeHandle) {
                      _this3.influencerProfile.handle = inf.reqYoutubeHandle;
                    }
                  }

                  if (_this3.influencerProfile) {
                    _context4.next = 27;
                    break;
                  }

                  _this3.$swal({ type: 'warning', text: 'Please Connect Platform' }).then(function (result) {
                    if (result.value) {
                      _this3.$router.push({ path: '/profile' });
                    }
                  });
                  return _context4.abrupt('return', false);

                case 27:
                  if (_this3.influencerProfile.handle) {
                    _context4.next = 30;
                    break;
                  }

                  _this3.$swal({ type: 'warning', text: 'Please Connect Platform' }).then(function (result) {
                    if (result.value) {
                      _this3.$router.push({ path: '/profile' });
                    }
                  });
                  return _context4.abrupt('return', false);

                case 30:
                  _context4.next = 33;
                  break;

                case 32:
                  _this3.$swal({
                    text: 'Error Occured. Please login again!',
                    type: 'warning',
                    allowOutsideClick: false
                  }).then(function (result) {
                    if (result.value) {
                      _this3.$store.dispatch('LOG_OUT');
                      _this3.$store.commit('REMOVE_ACTIVE_PLATFORM');

                      _this3.$router.push({ name: 'Login' });
                    }
                  });

                case 33:
                  if (_this3.currentInf) {
                    _this3.checkOpenBillingDialog(_this3.currentInf);
                  }

                case 34:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this3);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this3.$swal({
          text: 'Your current session is expired. Please login again.',
          type: 'warning',
          allowOutsideClick: false
        }).then(function (result) {
          if (result.value) {
            if (error.response.status === 403) {
              _this3.$store.dispatch('LOG_OUT');
              _this3.$router.push({ name: 'Login' });
            } else {
              _this3.$router.push({ path: '/profile' });
            }
          }
        });
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DraftSubmissionReport',
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_11__scoped_custom_SocialHandle___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      utils: __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* default */].func,
      loading: false,
      filter: {
        handle: '',
        campaignIDs: [],
        campaignID: '',
        clientID: '',
        filterDate: [],
        status: ''
      },
      submissionDatePicker: false,
      submissionStates: __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].submissionStates,
      submissionState: __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].submissionState,
      postTypeDeliverables: __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].postTypeDeliverables,
      headers: [{
        'text': 'Campaign',
        'align': 'start',
        'value': 'campaignName',
        'sortable': false
      }, {
        'text': 'Handle',
        'align': 'start',
        'value': 'handle',
        'sortable': false
      }, {
        'text': 'Submission Date',
        'align': 'start',
        'value': 'submissionDate',
        'sortable': false
      }, {
        'text': 'Deliverables',
        'align': 'start',
        'value': 'deliverables',
        'sortable': false
      }, {
        'text': 'Produced Deliverables',
        'align': 'start',
        'value': 'producedDeliverables',
        'sortable': false
      }, {
        'text': 'Stats',
        'align': 'start',
        'value': 'stats',
        'sortable': false
      }, {
        'text': 'Action',
        'align': 'start',
        'value': 'action',
        'sortable': false
      }],
      filteredItems: [],
      campaignFilterLists: [],
      clientFilterLists: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    unsubmittedInfluencers: function unsubmittedInfluencers(state) {
      return state.pairing.unsubmittedInfluencers;
    },
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    },
    clients: function clients(state) {
      return state.client.clients;
    },
    postDeliverables: function postDeliverables(state) {
      return state.post.strPostDeliverables;
    },
    totalDeliverables: function totalDeliverables(state) {
      return state.post.totalDeliverables;
    }
  }), {
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.query.date) {
                _this.filter.filterDate = _this.$route.query.date;
              }
              _context.next = 3;
              return _this.refresh();

            case 3:
              _this.beautifyData();
              _this.setFilterItems();
              _context.next = 7;
              return _this.getClients();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setFilterItems: function setFilterItems() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.filter.filterDate) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this2.refresh();

              case 3:
                _this2.filteredItems = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], _this2.unsubmittedInfluencers);
                if (_this2.filter.campaignID) {
                  _this2.filteredItems = _this2.filteredItems.filter(function (item) {
                    return item.campaignID === _this2.filter.campaignID;
                  });
                }
                if (_this2.filter.handle) {
                  _this2.filteredItems = _this2.filteredItems.filter(function (item) {
                    return item.handle === _this2.filter.handle;
                  });
                }
                if (_this2.filter.clientID) {
                  _this2.filteredItems = _this2.filteredItems.filter(function (item) {
                    return item.clientID === _this2.filter.clientID;
                  });
                }
                if (_this2.filter.status) {
                  _this2.filteredItems = _this2.filteredItems.filter(function (item) {
                    if (_this2.filter.status === _this2.submissionState.FULL && item.totalProducedDeliverables >= item.totalPairingDeliverables) {
                      return true;
                    }
                    if (_this2.filter.status === _this2.submissionState.PARTIAL && item.totalProducedDeliverables < item.totalPairingDeliverables) {
                      return true;
                    }
                    if (_this2.filter.status === _this2.submissionState.EMPTY && !item.totalProducedDeliverables) {
                      return true;
                    }
                    return false;
                  });
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    beautifyData: function beautifyData() {
      var _this3 = this;

      this.filteredItems = this.unsubmittedInfluencers.map(function (inf) {
        var campaign = _this3.campaigns.find(function (c) {
          return c.id === inf.campaignID;
        });
        if (campaign) {
          inf.clientID = campaign.clientID;
          inf.campaignName = campaign.name;
        }
        inf.deliverables = __WEBPACK_IMPORTED_MODULE_12__Campaign_campaignHelper__["a" /* default */].getDeliverableDetails(inf.deliverableDetails);
        inf.totalPairingDeliverables = __WEBPACK_IMPORTED_MODULE_12__Campaign_campaignHelper__["a" /* default */].getTotalDeliverables(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], inf.deliverableDetails));
        if (inf.posts.length > 0) {
          var infPosts = inf.posts.filter(function (post) {
            return post.campaignID === inf.campaignID;
          });
          _this3.$store.dispatch('post/setPostDeliverables', infPosts);
          inf.producedDeliverables = _this3.postDeliverables;
          inf.totalProducedDeliverables = _this3.totalDeliverables;
        }
        inf.stats = (inf.totalProducedDeliverables || 0) + ' / ' + inf.totalPairingDeliverables;
        return inf;
      });
    },
    getDraftSubmissions: function getDraftSubmissions() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.$store.dispatch('pairing/getPostUnsubmittedPairingInfluencers', _this4.filter);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getCampaigns: function getCampaigns() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var filter;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                filter = {
                  statuses: [__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignStatus.PAIRING_INFLUENCER, __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignStatus.ONGOING, __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].campaignStatus.REVIEW],
                  type: __WEBPACK_IMPORTED_MODULE_8__Campaign_config__["a" /* default */].campaignType.STORY_TELL
                };
                _context4.next = 3;
                return _this5.$store.dispatch('campaign/getCampaigns', filter);

              case 3:
                _this5.campaignFilterLists = [{ id: '', name: 'All Campaigns' }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this5.campaigns));

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    refresh: function refresh() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.loading = true;
                _context5.next = 3;
                return _this6.getCampaigns();

              case 3:
                _this6.filter.campaignIDs = _this6.campaigns.map(function (campaign) {
                  return campaign.id;
                });
                _context5.next = 6;
                return _this6.getDraftSubmissions();

              case 6:
                _this6.loading = false;
                _this6.beautifyData();

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    resetFilter: function resetFilter() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.filter = {
                  handle: '',
                  campaignID: '',
                  clientID: '',
                  filterDate: [],
                  status: ''
                };
                _context6.next = 3;
                return _this7.refresh();

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    cancelMonth: function cancelMonth() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.submissionDatePicker = false;
                _this8.filter.filterDate = [];
                _context7.next = 4;
                return _this8.refresh();

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    searchMonthOk: function searchMonthOk() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.submissionDatePicker = false;
                _context8.next = 3;
                return _this9.refresh();

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    getClients: function getClients() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var clientIDs;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this10.$store.dispatch('client/getClients');

              case 2:
                clientIDs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(_this10.campaigns.map(function (c) {
                  return c.clientID;
                }))));

                _this10.clientFilterLists = _this10.clients.filter(function (b) {
                  return clientIDs.includes(b.id);
                });
                _this10.clientFilterLists.unshift({ id: '', name: 'All Clients' });

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  }
});

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditLiveDateModal',
  components: {},
  props: {
    value: Boolean,
    post: Object
  },
  data: function data() {
    return {
      loading: false,
      postData: null,
      datePickerDialog: false,
      endDatePickerDialog: false,
      showSetDateOption: true,
      todayDatePick: '',
      influencerRole: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].userRoles.INFLUENCER,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_6__Campaign_campaignHelper__["a" /* default */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    updated: function updated(state) {
      return state.post.updated;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    }
  }),
  watch: {
    post: function post(newVal) {
      this.postData = newVal || null;
    }
  },
  mounted: function mounted() {
    this.todayDatePick = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');
  },

  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.postData.postDate || !this.postData.postDateEnd) {
        this.$swal({
          text: 'Please enter post dates.',
          type: 'error'
        });
        return;
      }
      var editData = this.buildFormData();
      this.$swal({
        title: 'Do you want to save changes?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: function allowOutsideClick() {
          return !_this.$swal.isLoading();
        }
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return _this.$store.dispatch('post/saveLiveDate', editData);

                case 3:
                  _this.$swal({
                    title: 'Submitted successfully',
                    type: 'success'
                  }).then(function () {
                    _this.$emit('input');
                    _this.$emit('postUpdated');
                  });

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    buildFormData: function buildFormData() {
      var form = document.getElementById('postLiveDateEditForm');
      var formData = new FormData(form);
      formData.append('postID', this.postData._id);
      return formData;
    },
    closeModal: function closeModal() {
      this.$emit('input');
      this.pauseVideo();
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('DD-MM-YYYY, HH:mm');
    },
    loadCampaign: function loadCampaign(post) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.postData = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.refreshJSON(_this2.postData);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postMedia__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editPostPayload__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuedraggable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_BtnDownload_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_BtnDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_BtnDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_sunEditor__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__editor_sunEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__editor_sunEditor__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_15_vuedraggable___default.a,
    btnDownload: __WEBPACK_IMPORTED_MODULE_16__components_scoped_custom_BtnDownload_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_17__scoped_custom_CustomMediaV2___default.a,
    SunEditor: __WEBPACK_IMPORTED_MODULE_21__editor_sunEditor___default.a
  },
  props: {
    value: Boolean,
    post: Object,
    userObj: Object,
    postAbuseHistory: Boolean
  },
  data: function data() {
    return {
      loading: false,
      postData: null,
      removed: [],
      imageChanges: [],
      viewImages: [],
      mediaUploadDialog: false,
      datePickerDialog: false,
      endDatePickerDialog: false,
      rules: {
        length: function length(len) {
          return function (v) {
            return (v || '').length <= len || 'Character Length should not more than ' + len;
          };
        },
        required: function required(v) {
          return !!v || 'This field is required';
        }
      },
      images: [],
      showSetDateOption: true,
      todayDatePick: '',

      allowedExtensions: /(image\/.|video\/.)$/i,
      allowDelete: true,
      influencerRole: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.INFLUENCER,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_18__Campaign_campaignHelper__["a" /* default */],
      cldConfig: __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].cldConfig,
      cld: null,
      cldFolderPath: 'POST SUBMISSIONS',
      clientReportAbuse: [],
      clientReportAbuseData: [],
      influencerData: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])({
    campaign: function campaign(state) {
      return state.campaign.campaignDetail;
    },
    cldSignature: function cldSignature(state) {
      return state.campaign.cldSignature;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    isVideoLink: function isVideoLink() {
      return this.postData.type === 'story' || this.postData.type === 'video' || this.postData.type === 'reel' || this.postData.type === 'tiktok' || this.postData.type === 'youtube' || this.postData.type === 'facebook' || this.postData.type === 'linkedin';
    },
    isRemark: function isRemark() {
      return this.currentUserRole <= __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.ACCOUNT_MANAGER;
    },
    isHashTag: function isHashTag() {
      return (this.postData.mandatoryHashtag || this.postData.mandatoryHashtag === '') && (this.currentUserRole <= __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);
    },
    isCallToActionLinks: function isCallToActionLinks() {
      return (this.postData.callToActionLinks || this.postData.callToActionLinks === '') && (this.currentUserRole <= __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.ACCOUNT_MANAGER);
    },
    isCaptionText: function isCaptionText() {
      return this.postData.captionText || this.postData.captionText === '';
    },
    captionLabel: function captionLabel() {
      return this.postData.type === 'story' ? 'Story Caption' : 'Caption';
    }
  }),
  watch: {
    post: function post(newVal) {
      this.postData = newVal || null;
      this.images = this.postData.images;
      this.removed = [];
      this.imageChanges = [];
      this.viewImages = [].concat(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_toConsumableArray___default()(this.postData.images));
      if (this.userObj.role === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.INFLUENCER && this.postData.status >= __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].postStatus.CLIENT_PENDING) {
        this.allowDelete = false;
      }
      this.clientReportAbuseData = newVal.reportAbuse;
      this.clientReportAbuse = newVal.reportAbuse ? newVal.reportAbuse.filter(function (item) {
        return newVal.draftId ? item.draftPostId === newVal.draftId : false;
      }) : [];
      this.getInfluencerData(newVal.influencerID);
      this.refreshMediaViews();
      if (this.postData.captionText) this.setCurrentCaptionText();
      if (!this.postData.callToActionLinks) {
        this.loadCampaign(this.postData);
      }
    },
    viewImages: function viewImages(nVal) {
      this.viewImages = nVal;
    },
    value: function value(newVal) {
      if (newVal) {
        setTimeout(function () {
          var modalHeight = $('.edit-post-modal').height();
          var reposeAbuseHeight = modalHeight - 210;
          var element = document.querySelector('.report-abuse-section-edit');
          element.setAttribute('style', 'max-height:' + reposeAbuseHeight + 'px!important;overflow-y:auto;padding:2px;');
        }, 1000);
      }
    }
  },
  mounted: function mounted() {
    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
    if (this.userObj.role === __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].userRoles.INFLUENCER) {
      this.showSetDateOption = false;
    }
    this.todayDatePick = __WEBPACK_IMPORTED_MODULE_14_moment___default()().format('YYYY-MM-DD');
  },

  methods: {
    isMissingMedia: function isMissingMedia(media) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__postMedia__["a" /* isMissingPostMedia */])(media, this.imageChanges);
    },
    prepareUpload: function prepareUpload(e) {
      var _this = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      this.viewImages.sort(function (a, b) {
        return a.index - b.index;
      });
      var index = this.viewImages.length > 0 ? this.viewImages[this.viewImages.length - 1].index || 0 : 0;
      uploadedFiles.forEach(function (element) {
        var type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          _this.$swal('File Type Not Supported, Please select a video or an image');
        } else if (type === 'video') {
          var reader = new FileReader();
          var vm = _this;
          reader.onload = function () {
            var blog = new Blob([reader.result], { type: element.type });
            var url = URL.createObjectURL(blog);
            vm.viewImages.push({
              index: index,
              url: url,
              type: element.type,
              isvideo: true,
              isNew: true
            });
            vm.imageChanges.push({
              index: index,
              element: element,
              url: url
            });
          };
          reader.readAsArrayBuffer(element);
        } else {
          var _reader = new FileReader();
          _reader.readAsDataURL(element);
          _reader.onload = function (e) {
            _this.viewImages.push({
              url: e.target.result,
              index: ++index,
              isNew: true
            });
            _this.imageChanges.push({
              index: index,
              element: element,
              url: e.target.result
            });
          };
        }
      });
    },
    deleteImages: function deleteImages(pos) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var img, delImages, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                img = _this2.viewImages[pos];

                _this2.removed.push(img.url);
                delImages = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], _this2.viewImages);

                delImages.splice(pos, 1);
                index = 0;

                _this2.viewImages = [];
                setTimeout(function () {
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(delImages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var _img = _step.value;

                      _img.index = index;
                      _this2.viewImages.push(_img);
                      index += 1;
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  _this2.imageChanges = _this2.imageChanges.filter(function (i) {
                    return i.url !== img.url;
                  });
                }, 500);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    submit: function submit() {
      var _this3 = this;

      var editData = this.buildFormData();

      this.$swal({
        title: 'Do you want to save changes to this post?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_12__postApi__["a" /* default */].editPost(_this3.postData._id, editData).then(function (response) {
            return response;
          }).catch(function (error) {
            _this3.$swal.showValidationError(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__editPostPayload__["a" /* getEditPostErrorMessage */])(error));
            return false;
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this3.$swal({
            title: 'Submitted successfully',
            type: 'success'
          }).then(function () {
            _this3.$emit('input');
            _this3.$emit('postUpdated');
          });
        }
      });
    },
    buildFormData: function buildFormData() {
      var form = document.getElementById('campaignForm');
      var formData = new FormData(form);
      formData.append('removed', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.removed));

      formData.delete('images');
      if (this.isRemark) {
        formData.delete('remark');
        formData.append('remark', this.postData.remark || '');
      }
      var pendingImageChanges = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__editPostPayload__["b" /* getPendingImageChanges */])(this.imageChanges);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(pendingImageChanges), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var val = _step2.value;

          formData.append('images', val.element, val.element.name);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      formData.append('viewImages', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__editPostPayload__["c" /* serializeViewImages */])(this.viewImages, this.imageChanges)));
      return formData;
    },
    deletePost: function deletePost() {
      var _this4 = this;

      this.$swal({
        title: 'Do you want to delete this post?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this4.loading = true;
          __WEBPACK_IMPORTED_MODULE_12__postApi__["a" /* default */].deletePost(_this4.postData.originalPost || _this4.postData._id).then(function () {
            _this4.loading = false;
            _this4.$swal({
              title: 'Deleted successfully',
              type: 'success'
            }).then(function () {
              _this4.$router.go();
            });
          }).catch(function (error) {
            _this4.loading = false;
            _this4.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    closeModal: function closeModal() {
      this.$emit('input');
      this.pauseVideo();
    },
    pauseVideo: function pauseVideo() {
      var video = document.getElementById('previewVideo');
      if (video) {
        video.pause();
      }
    },
    processUpload: function processUpload(error, result) {
      if (!error && result && result.event === 'success') {
        var INFO = result.info;
        this.imageChanges.push({
          publicID: INFO.public_id,
          file: INFO.secure_url,
          type: INFO.resource_type,
          preview: {
            thumbnail: INFO.thumbnail_url,
            src: INFO.thumbnail_url,
            name: INFO.original_filename,
            format: INFO.format
          }
        });
        var index = this.viewImages.length > 0 ? this.viewImages[this.viewImages.length - 1].index : 0;
        this.viewImages.push({
          url: INFO.secure_url,
          publicID: INFO.public_id,
          index: index,
          type: INFO.resource_type,
          isvideo: INFO.resource_type === 'video',
          new: true
        });
      } else if (error && error.status && error.status.includes('maximum allowed (300 MB)')) {
        this.myWidget.close();
        this.$swal({
          type: 'error',
          text: error.statusText
        });
        return;
      } else if (error) {
        this.$swal({
          type: 'error',
          text: 'Failed to multiple contents'
        });
        return;
      }
    },
    openCloudinaryUpload: function openCloudinaryUpload() {
      var username = 'N/A';
      var socialData = {};
      if (this.influencerData.tiktok) {
        socialData = this.influencerData.tiktok;
        username = socialData.tiktokHandle || 'N/A';
      } else if (this.influencerData.youtube) {
        socialData = this.influencerData.youtube;
        username = socialData.youtubeHandle || 'N/A';
      } else if (this.influencerData.xiaohongshu) {
        socialData = this.influencerData.xiaohongshu;
        username = socialData.xhsHandle || socialData.xhsFullname || 'N/A';
      } else if (this.influencerData.linkedin) {
        socialData = this.influencerData.linkedin;
        username = socialData.linkedinHandle || 'N/A';
      } else if (this.influencerData.instagram) {
        socialData = this.influencerData.instagram;
        username = socialData.instagramHandle || 'N/A';
      }
      this.openCloudinaryWidget(this.cldFolderPath + '/@' + __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.escapeCldSpecialChars(username));
    },
    openCloudinaryWidget: function openCloudinaryWidget(folder) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var tags;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tags = [_this5.postData.campaignName, 'tmp'];
                _context3.next = 3;
                return _this5.$store.dispatch('campaign/getCldSignature', {
                  filters: {
                    folder: folder,
                    source: 'uw',
                    tags: tags
                  }
                });

              case 3:
                _this5.myWidget = window.cloudinary.createUploadWidget({ cloudName: _this5.cldConfig.CLOUD_NAME,
                  uploadPreset: _this5.cldConfig.UPLOAD_PRESET,
                  folder: folder,
                  tags: tags,
                  thumbnailTransformation: [{ width: 320, height: 320, crop: 'fill' }],
                  sources: ['local', 'url', 'google_drive', 'facebook', 'instagram'],
                  api_key: _this5.cldConfig.API_KEY,
                  uploadSignature: _this5.cldSignature.signature,
                  uploadSignatureTimestamp: _this5.cldSignature.timestamp,
                  maxFileSize: 314572800,
                  prepareUploadParams: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(cb, params) {
                      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref2, _ref3, index, param;

                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              params = [].concat(params);
                              _iteratorNormalCompletion3 = true;
                              _didIteratorError3 = false;
                              _iteratorError3 = undefined;
                              _context2.prev = 4;
                              _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(params.entries());

                            case 6:
                              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                                _context2.next = 18;
                                break;
                              }

                              _ref2 = _step3.value;
                              _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                              index = _ref3[0];
                              param = _ref3[1];

                              if (!param.headers) {
                                _context2.next = 14;
                                break;
                              }

                              _context2.next = 14;
                              return _this5.$store.dispatch('campaign/getCldSignature', {
                                filters: {
                                  filename_override: param.filename_override,
                                  folder: param.folder,
                                  headers: param.headers,
                                  source: 'uw',
                                  tags: tags,
                                  timestamp: param.timestamp
                                }
                              });

                            case 14:
                              params[index] = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                                signature: _this5.cldSignature.signature
                              });

                            case 15:
                              _iteratorNormalCompletion3 = true;
                              _context2.next = 6;
                              break;

                            case 18:
                              _context2.next = 24;
                              break;

                            case 20:
                              _context2.prev = 20;
                              _context2.t0 = _context2['catch'](4);
                              _didIteratorError3 = true;
                              _iteratorError3 = _context2.t0;

                            case 24:
                              _context2.prev = 24;
                              _context2.prev = 25;

                              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                              }

                            case 27:
                              _context2.prev = 27;

                              if (!_didIteratorError3) {
                                _context2.next = 30;
                                break;
                              }

                              throw _iteratorError3;

                            case 30:
                              return _context2.finish(27);

                            case 31:
                              return _context2.finish(24);

                            case 32:
                              cb(params.length === 1 ? params[0] : params);

                            case 33:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this5, [[4, 20, 24, 32], [25,, 27, 31]]);
                    }));

                    return function prepareUploadParams(_x, _x2) {
                      return _ref.apply(this, arguments);
                    };
                  }()
                }, _this5.processUpload);
                _this5.myWidget.open();

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    getInfluencerData: function getInfluencerData(influencerID) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_19__Influencer_influencerAPIs__["a" /* default */].getInfluencer(influencerID).then(function (response) {
        _this6.influencerData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(date).format('DD-MM-YYYY, HH:mm');
    },
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return null;
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    dragEnd: function dragEnd() {
      this.drag = false;
      this.refreshMediaViews();
    },
    refreshMediaViews: function refreshMediaViews() {
      var vm = this;
      var tmpImages = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.viewImages);
      this.viewImages = [];
      setTimeout(function () {
        vm.viewImages = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(tmpImages);
      }, 0);
    },
    setCurrentCaptionText: function setCurrentCaptionText() {
      this.postData.defaultCaptionText = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.refreshJSON(this.postData.captionText);
    },
    loadCampaign: function loadCampaign(post) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var hashTags;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this7.$store.dispatch('campaign/getCampaignDetail', post.campaignID);

              case 2:
                hashTags = __WEBPACK_IMPORTED_MODULE_18__Campaign_campaignHelper__["a" /* default */].getMandatoryHashtagMentions(_this7.campaign);

                if (hashTags) _this7.postData.mandatoryHashtag = hashTags;
                if (_this7.campaign.callToActionLinks) _this7.postData.callToActionLinks = _this7.campaign.callToActionLinks || '';
                _this7.postData = __WEBPACK_IMPORTED_MODULE_20__utils__["a" /* default */].func.refreshJSON(_this7.postData);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68)))

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Campaign_config__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Influencer-Terms-Modal',
  props: {
    dialog: Boolean,
    dialogTitle: String,
    value: Boolean
  },
  data: function data() {
    return {
      termsAndConditions: __WEBPACK_IMPORTED_MODULE_0__Campaign_config__["a" /* default */].campaignConfirmation.influencerContractTermsAndCondition,
      showContractModal: false,
      agreement: '',
      valid: true,
      alert: false
    };
  },

  methods: {
    agree: function agree() {
      this.$refs.form.validate();
      if (this.$refs.form.validate()) {
        this.$emit('termsAggrement', true);
        this.$emit('input');
      }
    },
    disagree: function disagree() {
      this.$emit('termsAggrement', false);
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__postApi__ = __webpack_require__(42);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    post: Object
  },
  data: function data() {
    return {
      platform: 'instagram',
      postData: null,
      isValidating: false,
      handle: '',
      mapInfluencerObj: {
        instagramHandle: null,
        instagramID: null,
        picture: null
      }
    };
  },

  methods: {
    saveMappedInfluencer: function saveMappedInfluencer() {
      var _this = this;

      this.isValidating = true;
      __WEBPACK_IMPORTED_MODULE_0__postApi__["a" /* default */].mapInfluencerToPost(this.postData._id, { handle: this.handle, platform: this.platform }).then(function (response) {
        _this.isValidating = false;
        _this.$emit('successInfluencerMap');
        _this.close();
      }).catch(function (error) {
        _this.isValidating = false;
        _this.$swal({
          type: 'error',
          text: error
        });
        console.log(error);
      });
    },
    close: function close() {
      this.igHandle = '';
      this.mapInfluencerObj = {};
      this.$emit('input');
    }
  },
  watch: {
    post: function post(newPost) {
      if (newPost !== null) {
        this.postData = newPost;
        this.igHandle = newPost.mapInfluencer ? newPost.mapInfluencer.instagramHandle : '';
      }
    }
  }
});

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__postApi__ = __webpack_require__(42);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Boolean,
    posts: Array
  },
  data: function data() {
    return {
      platform: 'instagram',
      postData: [],
      isValidating: false,
      handle: ''
    };
  },

  methods: {
    saveMappedInfluencer: function saveMappedInfluencer() {
      var _this = this;

      if (!this.handle) {
        this.$swal({
          type: 'warning',
          title: 'Please input handle'
        });
        return;
      }

      this.isValidating = true;
      var selectedPosts = Array.isArray(this.postData) ? this.postData : [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(selectedPosts.map(function (post) {
        return __WEBPACK_IMPORTED_MODULE_1__postApi__["a" /* default */].mapInfluencerToPost(post._id, { handle: _this.handle, platform: _this.platform });
      })).then(function () {
        _this.isValidating = false;
        _this.$emit('successInfluencerMap');
        _this.close();
      }).catch(function (error) {
        _this.isValidating = false;
        _this.$swal({
          type: 'error',
          text: error
        });
        console.log(error);
      });
    },
    close: function close() {
      this.handle = '';
      this.$emit('input');
    }
  },
  watch: {
    posts: function posts(newPostList) {
      if (Array.isArray(newPostList) && newPostList.length > 0) {
        this.postData = newPostList;
      } else {
        this.postData = [];
      }
    }
  }
});

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostChatBox',
  props: ['messages', 'label', 'isClient', 'type'],
  data: function data() {
    return {
      messageText: ''
    };
  },

  methods: {
    sendMessage: function sendMessage() {
      if (this.messageText === '') {
        this.$swal.fire("Message can't be empty", '', 'error');
      } else {
        this.$emit('commented', this.messageText);
        this.messageText = '';
      }
    },
    reloadMessage: function reloadMessage() {
      this.$emit('reloadMessage');
    },
    getRelativeTime: function getRelativeTime(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).fromNow();
    },
    viewAuthor: function viewAuthor(author) {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.user.id !== author.id ? author.name : 'You';
    }
  }
});

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewPostModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewPostModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ViewPostModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_platformDisplay__ = __webpack_require__(141);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'postdetail',
  components: {
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_5__ViewPostModal_vue___default.a
  },
  data: function data() {
    return {
      loading: false,
      showConnectionError: false,
      approvedPost: {},
      viewPostDialog: false,
      showDetailModalFromRoute: false,
      showProposeDateAction: false
    };
  },

  methods: {
    getApprovedPost: function getApprovedPost(id) {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__postApi__["a" /* default */].getPostById(id).then(function (resp) {
        _this.loading = false;
        _this.showConfirmDate = false;
        _this.showConnectionError = false;
        resp.mainPost.labels = _this.getPostLabels(resp.mainPost);
        _this.approvedPost = resp;
        if (_this.$route.query.confirmDate && !_this.showDetailModalFromRoute) {
          _this.showDetailModalFromRoute = true;
          _this.viewDetailPost(resp.mainPost);
        }
      }).catch(function (err) {
        _this.showConnectionError = true;
        _this.loading = false;
        console.log('Error', err);
      });
      this.filterMenuOptions();
    },
    paserImageUrl: function paserImageUrl(url) {
      if (url) {
        var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    getPostLabels: function getPostLabels(post) {
      var labels = [];
      if (this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.AD_STRATEGIST) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }

      if (!post.waiting_release && this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          labels.push({
            text: 'Abuse Reported',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'deep-orange',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: 'New',
            outlined: true,
            dark: false,
            icon: 'new_releases',
            color: 'primary',
            action: 'viewDetailPost'
          });
        }
      }

      if (post.comments && this.postStatus < this.postStatusConfig.APPROVE && (this.currentUserRole === this.userRoles.INFLUENCER || this.currentUserRole === this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        labels.push({
          text: '(' + this.commentsInfo(post.comments) + ') Comments',
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: '' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: 'Today - ' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: false,
            dark: true,
            color: 'green',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'green',
            action: 'viewDetailPost'
          });
        }
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER && this.postStatus === this.postStatusConfig.APPROVE) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      if (post.type) {
        labels.push({
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_platformDisplay__["a" /* platformDisplayName */])(post.type),
          color: 'primary',
          action: 'viewDetailPost'
        });
      }
      return labels;
    },
    actionPostBy: function actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    exec: function exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    reloadPostView: function reloadPostView(postData) {
      this.viewDetailPost(postData);
    },
    viewDetailPost: function viewDetailPost(post) {
      if (post.status < __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if ((post.status === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.CLIENT_PENDING || post.status === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.APPROVE) && (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH)) {
        this.showProposeDateAction = true;
      } else {
        this.showProposeDateAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.CLIENT_PENDING && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.INFLUENCER) && post.campaignID) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id);
      this.viewPostDialog = true;
      this.getApprovedPost(post._id);
    },
    fetchPost: function fetchPost(postId, returnData) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__postApi__["a" /* default */].getPostById(postId).then(function (post) {
        _this2.viewPostData = post;
      }).catch(function (err) {
        _this2.$swal({
          title: 'Couldn\'t the Post',
          type: 'error',
          text: err
        });
      });
    },
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';

      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format(format);
    },
    checkAfter: function checkAfter(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.currentDate).isAfter(date);
    },
    checkSame: function checkSame(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.currentDate).isSame(date);
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */]['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    filterMenuOptions: function filterMenuOptions() {
      var _this3 = this;

      var options = __WEBPACK_IMPORTED_MODULE_4__postConfig__["a" /* default */].menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(function (option) {
          return _this3.buttonShow(option.action);
        });
      }
    },
    submitPostPayout: function submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.user;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function postStatus() {
      return this.$route.meta.postStatus;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].userRoles;
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].postStatus;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('ll');
    }
  },
  mounted: function mounted() {
    this.getApprovedPost(this.$route.params.postId);
  }
});

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scoped_custom_SocialHandle__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scoped_custom_SocialHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_scoped_custom_SocialHandle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMediaV2__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostMediaPreviewModal',
  props: ['value', 'selectedCampaign', 'postData'],
  components: {
    SocialHandle: __WEBPACK_IMPORTED_MODULE_2__components_scoped_custom_SocialHandle___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_4__scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      isIGCutOff: false,
      isIGStory: false,
      isTikTokCutOff: false,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_3__Campaign_campaignHelper__["a" /* default */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['user', 'activePlatform', 'showActivePlatform']), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUser: function currentUser() {
      return this.$store.state.user;
    },
    currentUserFullName: function currentUserFullName() {
      return this.$store.state.user.firstName + ' ' + this.$store.state.user.lastName;
    },
    overlayType: function overlayType() {
      if (this.isIGCutOff) {
        return 'IG';
      }
      if (this.isIGStory) {
        return 'IGStory';
      }
      if (this.isTikTokCutOff) {
        return 'TikTok';
      }
    }
  }),
  methods: {
    changeCutOff: function changeCutOff(type) {
      if (type === 'IG' && this.isIGCutOff) {
        this.isIGCutOff = true;
        this.isIGStory = false;
        this.isTikTokCutOff = false;
      } else if (type === 'IGStory' && this.isIGStory) {
        this.isIGCutOff = false;
        this.isIGStory = true;
        this.isTikTokCutOff = false;
      } else if (type === 'tiktok' && this.isTikTokCutOff) {
        this.isIGCutOff = false;
        this.isIGStory = false;
        this.isTikTokCutOff = true;
      } else {
        this.isIGCutOff = false;
        this.isIGStory = false;
        this.isTikTokCutOff = false;
      }
    },
    confirm: function confirm() {
      this.$emit('confirmed', true);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Campaign_campaignHelper__ = __webpack_require__(25);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PostMediaViewerModal',
  props: ['viewerValue', 'media', 'videoPlayer'],
  components: {
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_0__scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      isCutOff: false,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_1__Campaign_campaignHelper__["a" /* default */]
    };
  },

  methods: {
    close: function close() {
      this.viewerValue = false;
      this.$emit('closed');
    }
  }
});

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditPost_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditPost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__EditPost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Influencer_paymentAPIs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_platformDisplay__ = __webpack_require__(141);


































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Posts Index View',
  components: {
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue___default.a,
    AssignCampaignModal: __WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue___default.a,
    MapInfluencerModal: __WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue___default.a,
    EditPostModal: __WEBPACK_IMPORTED_MODULE_14__EditPost_vue___default.a,
    SubmissionReviewMultipleModal: __WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue___default.a,
    AddPostToCampaign: __WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign___default.a,
    ChangePostStatusModal: __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal___default.a,
    ClientChooseDateModal: __WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      posts: [],
      groupedPosts: [],
      rating: 3,
      viewChooseDatePost: {},
      filter: {
        instagramHandle: null,
        campaignName: null,
        campaignID: null,
        clientID: null,
        today: false,
        story: false,
        status: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 6
      },
      postFilter: null,
      showPostLayout: false,
      totalItems: 0,
      instagramHandleList: [],
      clients: [],
      rowsPerPage: [6, 12, 18, 26, { text: 'All', value: -1 }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      viewPostDialog: false,
      editPostDialog: false,
      chooseDateDialog: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      submissionReviewMultipleDialog: false,
      showCsEditAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      show_client_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      showPostHistory: false,
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      menuOptions: [],
      tableActions: [],
      selected: [],
      display: '',
      isFirstLoad: true,
      headers: [{ text: 'Campaign', value: 'campaignName', sortable: true }, { text: 'Influencer', value: 'submittedBy', sortable: true }, { text: 'Status', value: 'status', sortable: false }, { text: 'Actions', sortable: false }],
      stageFilters: __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].clientPostFilterStatuses,
      showConnectionError: false,
      loading: false,
      page: 1,
      addPostToCampaign: false,
      campaignDataForAddPost: null,
      postIdToUpdate: null,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_28__Campaign_campaignHelper__["a" /* default */],
      shownURLDetailModal: false
    };
  },

  watch: {
    posts: function posts(newPosts) {
      var tmpArr = [];
      newPosts.forEach(function (post) {
        tmpArr.push(post.author.linkedinHandle || post.author.instagramHandle);
      });
      this.instagramHandleList = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(tmpArr));
    },
    postStatus: function postStatus() {
      this.getPosts();
    },
    pagging: function pagging(previous, after) {
      if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(previous) !== __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(after)) {
        this.getPosts();
      }
    },
    selected: function selected() {
      this.validateTableActions(this.selected);
    },
    $route: function $route() {
      this.viewPostByRouter();
    }
  },
  methods: {
    openViewPostLayout: function openViewPostLayout(campaignName, campaignId, owner) {
      this.showPostLayout = true;
      var postFilter = {};
      if (campaignId) {
        postFilter.campaignId = campaignId;
      } else {
        this.filter.campaignID = null;
      }
      if (this.filter.instagramHandle) {
        postFilter.instagramHandle = this.filter.instagramHandle;
      }
      if (owner) {
        if (owner.tiktokHandle) {
          if (owner.tiktokHandle) {
            postFilter.tiktokHandle = owner.tiktokHandle;
          }
          if (owner.tiktokID) {
            postFilter.tiktokId = owner.tiktokID;
          }
        } else if (owner.youtubeHandle) {
          if (owner.youtubeHandle) {
            postFilter.youtubeHandle = owner.youtubeHandle;
          }
          if (owner.youtubeID) {
            postFilter.youtubeId = owner.youtubeID;
          }
        } else if (owner.linkedinHandle) {
          postFilter.instagramHandle = owner.linkedinHandle;
        } else {
          if (owner.instagramHandle) {
            postFilter.instagramHandle = owner.instagramHandle;
          }
          if (owner.instagramID) {
            postFilter.instagramId = owner.instagramID;
          }
        }
      }
      this.postFilter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, postFilter);
      this.getPosts();
    },
    closeViewPostLayout: function closeViewPostLayout() {
      this.showPostLayout = false;
      this.posts = [];

      this.postFilter = null;
    },
    changePostStatus: function changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changeStatusDialog = true;
    },
    postAdded: function postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
    },
    bulkApprove: function bulkApprove() {
      var _this = this;

      if (this.selected.length > 0) {
        this.$swal({
          title: 'Terms and Agreements',
          html: '<p class="text-xs-left subtitle-1">Please note that the content creator reserves full creative rights to the final execution of the post and will only do 1 shoot based on the brief approved by the client. Drafts sent to clients for vetting are for the sole purpose of fact-checking and stylistic changes will not be allowed. The client is entitled to only 1 revision. </p>',
          type: 'info',
          width: 500,
          backdrop: 'rgba(0,0,1, 0.7)',
          showCancelButton: true,
          confirmButtonText: 'Agree',
          cancelButtonText: 'Disagree',
          allowOutsideClick: false
        }).then(function (result) {
          if (result.value) {
            _this.submissionReviewMultipleDialog = true;
          }
        });
      }
    },
    resetFilter: function resetFilter() {
      this.filter = {
        instagramHandle: null,
        campaignName: null,
        clientID: null,
        today: false,
        story: false
      };
      this.getPosts();
    },
    assignedCampaign: function assignedCampaign() {
      this.getPosts();
    },
    influencerMapSuccess: function influencerMapSuccess() {
      this.getPosts();
    },
    validateTableActions: function validateTableActions(selected) {
      var disableApproveBtn = false;
      var disableReleaseBtn = false;
      if (!selected || selected.length === 0) {
        this.tableActions = this.tableActions.map(function (item) {
          item.disabled = true;
          return item;
        });
        return;
      }
      var disableAcceptBtn = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(selected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (!item.campaignID || !item.postDate || item.waiting_release || item.status !== this.postStatusConfig.AD_STRATEGIST_PENDING) {
            disableApproveBtn = true;
          }
          if (!item.waiting_release) {
            disableReleaseBtn = true;
          }
          if (item.status !== this.postStatusConfig.CLIENT_PENDING) {
            disableAcceptBtn = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.tableActions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var act = _step2.value;

          if (act.action === 'csApprove') {
            act.disabled = disableApproveBtn;
          } else if (act.action === 'saleApprove') {
            act.disabled = disableReleaseBtn;
          } else if (act.action === 'clientApprove') {
            act.disabled = disableAcceptBtn;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    performSelected: function performSelected(action) {
      var ids = this.selected.map(function (item) {
        return item._id;
      });
      switch (action) {
        case 'saleApprove':
          this.releasePosts(ids);
          break;
        case 'csApprove':
          this.approvePosts(ids);
          break;
        case 'clientApprove':
          this.bulkApprove();
          break;
      }
    },
    pageChanged: function pageChanged() {
      this.pagging.page = this.page;
      this.getPosts();
    },
    isIncludeInAbuseReport: function isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      var tmpArr = clientReportArr.map(function (item) {
        return item.draftPostId;
      });
      return tmpArr.includes(reportedDraftId);
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */]['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole);
      }
    },
    filterMenuOptions: function filterMenuOptions() {
      var _this2 = this;

      var options = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(function (option) {
          return _this2.buttonShow(option.action);
        });
      }
    },
    filterTableActions: function filterTableActions() {
      var _this3 = this;

      var options = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(function (option) {
          return _this3.buttonShow(option.action);
        });
      }
      this.tableActions = this.tableActions.map(function (item) {
        item.disabled = true;
        return item;
      });
    },
    actionPostBy: function actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'clientApproveDate':
          this.openChooseDateDialog(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    getPosts: function getPosts() {
      var _this4 = this;

      if (!this.postFilter) {
        return;
      }
      var status = -1;
      if (this.filter.status) {
        status = this.filter.status;
      }
      this.loading = true;
      var query = __WEBPACK_IMPORTED_MODULE_22__utils__["a" /* default */].func.clean(this.postFilter);
      query.status = status;
      query.sortBy = this.pagging.sortBy && this.pagging.sortBy.length > 0 ? this.pagging.sortBy[0] : null;
      query.descending = this.pagging.sortDesc && this.pagging.sortDesc.length > 0 ? this.pagging.sortDesc[0] : null;
      __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getPost(query).then(function (resp) {
        _this4.posts = [];
        _this4.selected = [];
        _this4.loading = false;
        _this4.showConnectionError = false;
        var posts = resp.posts;
        var totalItems = resp.totalItems;
        _this4.totalItems = totalItems;
        posts = posts.map(function (post) {
          post.labels = _this4.getPostLabels(post);
          post.author = post.mapInfluencer || post.submitedBy || _this4.defaultPoster;
          return post;
        });

        setTimeout(function () {
          _this4.posts = posts;
          _this4.checkShowURLParam();
        }, 0);
      }).catch(function (err) {
        _this4.showConnectionError = true;
        _this4.loading = false;
        console.error(err);
      });
      this.filterMenuOptions();
      this.filterTableActions();
    },
    getGroupedPosts: function getGroupedPosts() {
      var _this5 = this;

      var status = -1;
      this.loading = true;
      var query = __WEBPACK_IMPORTED_MODULE_22__utils__["a" /* default */].func.clean(this.filter);
      query.status = status;
      this.posts = [];

      __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getGroupedPosts(query).then(function (resp) {
        _this5.groupedPosts = [];
        _this5.selected = [];
        _this5.loading = false;
        _this5.showConnectionError = false;
        var groupedPosts = resp.posts;
        _this5.groupedPosts = groupedPosts;
      }).catch(function (err) {
        _this5.showConnectionError = true;
        _this5.loading = false;
        console.error(err);
      });
    },
    getClients: function getClients() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_21__Client_clientAPIs__["a" /* default */].getAllClients().then(function (resp) {
        var clients = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], resp.data);
        clients.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
        _this6.clients = [{ name: 'All', id: null }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(clients));
      });
    },
    reloadPostView: function reloadPostView(postData) {
      this.viewDetailPost(postData);
    },
    viewDetailPost: function viewDetailPost(post) {
      var _this7 = this;

      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status <= __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) && post.campaignID) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT && post.campaignID) {
        this.show_client_inf_chatbox = true;
      } else {
        this.show_client_inf_chatbox = false;
      }
      if (post.clientReportAbuse && this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER && post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id).then(function (post) {
        _this7.viewPostData = post;
        _this7.$store.dispatch('post/updatePostViewUser', { postID: post._id });
        _this7.viewPostDialog = true;
      });
    },

    editPostFromView: function editPostFromView(post) {
      this.editPost(post);
    },
    exec: function exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    getPostLabels: function getPostLabels(post) {
      var labels = [];
      if (post.type) {
        labels.push({
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_platformDisplay__["a" /* platformDisplayName */])(post.type),
          color: 'primary',
          action: 'viewDetailPost'
        });
      }
      if (post.status === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.AD_STRATEGIST) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }

      if (!post.waiting_release && post.status === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (this.currentUserRole !== this.userRoles.INFLUENCER && post.propose_dates) {
        labels.push({
          text: 'Propose Dates Available',
          icon: 'warning',
          outlined: true,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.APPROVE && this.currentUserRole !== this.userRoles.INFLUENCER && post.requestDate && !post.propose_dates) {
        labels.push({
          text: 'Live Date Change Requested',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'secondary',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.APPROVE && post.dateConfirmed) {
        labels.push({
          text: 'Approved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost',
          outlined: true,
          dark: false
        });
      }

      if (post.status === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'black',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'primary',
              action: 'viewDetailPost'
            });
          }
        }
      }

      if (post.comments && post.status < this.postStatusConfig.APPROVE && (this.currentUserRole === this.userRoles.INFLUENCER || this.currentUserRole === this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        labels.push({
          text: '(' + this.commentsInfo(post.comments) + ') Comments',
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.APPROVE && !post.requestDate) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: '' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'default',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: 'Today - ' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'default',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'default',
            action: 'viewDetailPost'
          });
        }
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER && (post.status === this.postStatusConfig.APPROVE || post.status === this.postStatusConfig.LIVE)) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      return labels;
    },
    editPost: function editPost(post) {
      this.editPostData = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, post);

      this.editPostDialog = true;
      this.getPosts();
    },
    assignCampaignToPost: function assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost: function mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    paserImageUrl: function paserImageUrl(url) {
      if (url) {
        var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    paserAudienceImageUrl: function paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },

    csApproveFromView: function csApproveFromView(post) {
      this.csApprovePost(post);
    },
    csApprovePost: function csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (!post.postDate) {
        this.$swal({
          title: 'Edit the post publishing date first before sending to client.',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from sale person.',
          type: 'info'
        });
      } else {
        var id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts: function approvePosts(postIds) {
      var _this8 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM person for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].approvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this8.$swal({
              title: 'Error in approving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this8.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this8.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from sale person.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this8.$emit('input');
          _this8.getPosts();
          _this8.viewPostDialog = false;
        } else {}
      });
    },
    saleReleasePost: function saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CS yet',
          type: 'warning'
        });
      } else {
        var id = post._id;
        this.releasePosts([id]);
      }
    },
    releasePosts: function releasePosts(postIds) {
      var _this9 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].releasePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this9.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this9.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this9.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });

          _this9.getPosts();
          _this9.$emit('input');
          _this9.viewPostDialog = false;
        } else {}
      });
    },
    startSubmissionReview: function startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout: function submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL: function enterPostURL(post) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_26__Campaign_campaignAPIs__["a" /* default */].getCampaign(post.campaignID).then(function (response) {
        _this10.campaignDataForAddPost = response;
        _this10.postIdToUpdate = post._id;
        _this10.addPostToCampaign = true;
      }).catch(function (err) {
        _this10.addPostToCampaign = true;
        _this10.$swal({
          type: 'error',
          title: 'Error Getting Campaign Information'
        });
        console.log(err);
      });
    },
    assignPostURL: function assignPostURL(post) {
      var _this11 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].publishPost(post._id, result.value).then(function () {
            _this11.$swal({
              title: postConfirmationText['confirm']['title'],
              text: 'Do you want to submit payout?',
              type: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then(function (confirmed) {
              if (confirmed.value) {
                var payout = {
                  campaignName: post.campaignName,
                  campaignID: post.campaignID,
                  postID: post._id,
                  influencerID: post.influencerID,
                  instagramPostURL: result.value,
                  otherSocialMediaPostUrl: '',
                  satisfactionLevel: 0,
                  advertiserSatisfactionLevel: 0
                };
                __WEBPACK_IMPORTED_MODULE_24__Influencer_paymentAPIs__["a" /* default */].createCampaignPayout(payout).then(function () {
                  _this11.$swal({
                    type: 'success',
                    title: 'Campaign payout created!'
                  });
                }).catch(function () {
                  _this11.$swal({
                    type: 'error',
                    title: 'Cannot create campaign payout for this post. Try again later!'
                  });
                });
              }
            });
            _this11.getPosts();
          }).catch(function () {
            _this11.$swal({
              type: 'error',
              title: 'Error in processing your request! Please try again'
            });
          });
        }
      });
    },
    completePost: function completePost(post) {
      var _this12 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].completePost(post._id).then(function () {
            _this12.$swal({
              type: 'success',
              title: postConfirmationText['confirm']['title'],
              text: postConfirmationText['confirm']['text']
            }).then(function () {
              _this12.getPosts();
            });
          }).catch(function (error) {
            return _this12.$swal({
              type: 'error',
              text: error
            });
          });
        }
      });
    },
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';

      return __WEBPACK_IMPORTED_MODULE_23_moment___default()(date).format(format);
    },
    checkAfter: function checkAfter(date) {
      return __WEBPACK_IMPORTED_MODULE_23_moment___default()(this.currentDate).isAfter(date);
    },
    checkSame: function checkSame(date) {
      return __WEBPACK_IMPORTED_MODULE_23_moment___default()(this.currentDate).isSame(date);
    },
    fetchPost: function fetchPost(postId, returnData) {
      var _this13 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getPostById(postId).then(function (post) {
          resolve(post);
        }).catch(function (err) {
          _this13.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
          reject(err);
        });
      });
    },
    commentsInfo: function commentsInfo(comments) {
      var _this14 = this;

      if (comments === undefined) {
        return;
      } else {
        var commentsArr = comments.filter(function (comment) {
          return comment.author.id !== _this14.user.id;
        });
        return commentsArr.length;
      }
    },
    viewPostByRouter: function viewPostByRouter() {
      var _this15 = this;

      var action = this.$route.query.action;
      var id = this.$route.query.id;
      if (action === 'view' && id) {
        __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getPostById(id).then(function (post) {
          _this15.viewDetailPost(post);
        }).catch(function (err) {
          _this15.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
        });
      } else {
        this.LoadPosts();
      }
    },
    LoadPosts: function LoadPosts() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this16.currentUserRole !== _this16.userRoles.CLIENT && _this16.currentUserRole !== _this16.userRoles.INFLUENCER)) {
                  _context.next = 7;
                  break;
                }

                _this16.getClients();
                _this16.getGroupedPosts();
                _this16.openViewPostLayout();
                _this16.viewPostByRouter();
                _context.next = 13;
                break;

              case 7:
                _this16.getGroupedPosts();
                _this16.openViewPostLayout();

                if (!(_this16.currentUserRole === _this16.userRoles.CLIENT)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return _this16.$store.dispatch('campaign/getCampaigns', {
                  filters: {
                    clientID: _this16.user.clientID
                  }
                });

              case 12:
                _this16.filterCampaigns = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], _this16.campaigns);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this16);
      }))();
    },
    searchFilter: function searchFilter() {
      if (!this.showPostLayout) {
        this.getGroupedPosts();
      } else {
        this.openViewPostLayout(null, this.filter.campaignID, this.filter);
      }
    },
    showAvailableMenu: function showAvailableMenu(post, action) {
      if (this.currentUserRole === this.userRoles.CLIENT) {
        if (action === 'clientReview') {
          if (post.status === this.postStatusConfig.CLIENT_PENDING && post.propose_dates) {
            return false;
          } else if (post.status === this.postStatusConfig.APPROVE || post.status === this.postStatusConfig.LIVE || post.status === this.postStatusConfig.COMPLETE) {
            return false;
          } else if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse) && !post.release_abuse_resolved) {
            return false;
          }
        }
        if (action === 'clientApproveDate' && !post.propose_dates) {
          return false;
        }
      }
      return true;
    },
    openChooseDateDialog: function openChooseDateDialog(post) {
      this.viewChooseDatePost = post;
      this.chooseDateDialog = true;
    },
    closeChooseDateModal: function closeChooseDateModal() {
      this.chooseDateDialog = false;
    },
    checkShowURLParam: function checkShowURLParam() {
      var _this17 = this;

      if (this.$route.query.id && !this.shownURLDetailModal) {
        var post = this.posts.find(function (p) {
          return p._id === _this17.$route.query.id;
        });
        this.viewDetailPost(post);
        this.shownURLDetailModal = true;
      }
    },
    loadPostStatusDisplay: function loadPostStatusDisplay(status) {
      return __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postStatusDisplayForClient[status];
    },
    getStageColor: function getStageColor(status) {
      if (status === this.postStatusConfig.CLIENT_PENDING) {
        return 'blue';
      } else {
        return 'green';
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    }
  }), {
    user: function user() {
      return this.$store.state.user;
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function postStatus() {
      return this.$route.meta.postStatus || -1;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles;
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_23_moment___default()().format('ll');
    },
    paginationLength: function paginationLength() {
      var round = this.totalItems / this.pagging.itemsPerPage;
      var decimal = this.totalItems % this.pagging.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    }
  }),
  mounted: function mounted() {
    this.LoadPosts();
    if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT) {
      this.display = 0;
    } else {
      this.display = 1;
    }
  }
});

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditPost_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditPost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__EditPost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EditLiveDateModal_vue__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EditLiveDateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__EditLiveDateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AssignCampaignModal_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AssignCampaignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AssignCampaignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MapInfluencerModal_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MapInfluencerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__MapInfluencerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AssignCampaignMultipleModal_vue__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AssignCampaignMultipleModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__AssignCampaignMultipleModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SubmissionReviewMultiple_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SubmissionReviewMultiple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__SubmissionReviewMultiple_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MapInfluencerMultipleModal_vue__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MapInfluencerMultipleModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__MapInfluencerMultipleModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Influencer_paymentAPIs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_campaign_AddPostToCampaign__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_campaign_AddPostToCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__scoped_campaign_AddPostToCampaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_platformDisplay__ = __webpack_require__(141);




































/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue___default.a,
    AddPostToCampaign: __WEBPACK_IMPORTED_MODULE_26__scoped_campaign_AddPostToCampaign___default.a,
    ChangePostStatusModal: __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal___default.a,
    AssignCampaignModal: __WEBPACK_IMPORTED_MODULE_16__AssignCampaignModal_vue___default.a,
    MapInfluencerModal: __WEBPACK_IMPORTED_MODULE_17__MapInfluencerModal_vue___default.a,
    AssignCampaignMultipleModal: __WEBPACK_IMPORTED_MODULE_18__AssignCampaignMultipleModal_vue___default.a,
    MapInfluencerMultipleModal: __WEBPACK_IMPORTED_MODULE_20__MapInfluencerMultipleModal_vue___default.a,
    SubmissionReviewMultipleModal: __WEBPACK_IMPORTED_MODULE_19__SubmissionReviewMultiple_vue___default.a,
    EditPostModal: __WEBPACK_IMPORTED_MODULE_14__EditPost_vue___default.a,
    EditLiveDateModal: __WEBPACK_IMPORTED_MODULE_15__EditLiveDateModal_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      posts: [],
      groupedPosts: [],
      rating: 3,
      viewPostData: {},
      postDataForEditLiveDate: {},
      filter: {
        instagramHandle: null,
        campaignName: null,
        campaignId: null,
        postID: null,
        influencerID: null,
        clientID: null,
        today: false,
        story: false,
        dateConfirmed: null,
        filterStatus: ''
      },
      pagging: {
        page: 1,
        itemsPerPage: 6
      },
      postFilter: null,
      showPostLayout: false,
      totalItems: 0,
      instagramHandleList: [],
      clients: [],
      rowsPerPage: [6, 12, 18, 26, { text: 'All', value: -1 }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      assignCampaignPosts: [],
      mapInfluencerPosts: [],
      viewPostDialog: false,
      editPostDialog: false,
      editLiveDateDialog: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      assignCampaignMultipleDialog: false,
      mapInfluencerMultipleDialog: false,
      submissionReviewMultipleDialog: false,
      showCsEditAction: false,
      showProposeDateAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      show_client_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      showPostHistory: false,
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      menuOptions: [],
      tableActions: [],
      selected: [],
      changePostIds: [],
      display: '',
      isFirstLoad: true,
      headers: [{ text: 'Campaign', value: 'campaignName', sortable: true }, { text: 'Influencer', value: 'submittedBy', sortable: true }, { text: 'Status', value: 'status', sortable: false }, { text: 'Format', value: 'format', sortable: false }, { text: 'Submitted At', value: 'createdAt', sortable: true }, { text: 'Actions', sortable: false }],
      showConnectionError: false,
      loading: false,
      page: 1,
      addPostToCampaign: false,
      campaignDataForAddPost: null,
      postIdToUpdate: null,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_28__Campaign_campaignHelper__["a" /* default */],
      pendingCount: 0,
      confirmedCount: 0,
      overdueCount: 0,
      proposeCount: 0,
      emptyLiveDateCount: 0,
      allPosts: false,
      campaignList: [],
      showDetailModalFromRoute: false
    };
  },

  watch: {
    posts: function posts(newPosts) {
      var tmpArr = [];
      newPosts.forEach(function (post) {
        tmpArr.push(post.author.instagramHandle);
      });
      this.instagramHandleList = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(tmpArr));
    },
    postStatus: function postStatus() {
      this.pagging.page = 1;
      this.page = 1;
      this.filter.postID = null;
      this.getPosts();
    },
    pagging: function pagging(previous, after) {
      if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(previous) !== __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(after) && this.postStatus === -1 && this.filter.campaignId) {
        this.getPosts();
      }
    },
    selected: function selected() {
      this.validateTableActions(this.selected);
    },
    $route: function $route() {
      this.pagging.page = 1;
      this.filter.filterStatus = '';
      this.filter.postID = null;
      this.viewPostByRouter();
    }
  },
  methods: {
    openViewPostLayout: function openViewPostLayout(campaignName, campaignId, instagramHandle, instagramId) {
      this.showPostLayout = true;
      var postFilter = {};
      if (campaignName) {
        postFilter.campaignName = campaignName;
      }
      if (campaignId) {
        postFilter.campaignId = campaignId;
      }
      if (instagramHandle) {
        postFilter.instagramHandle = instagramHandle;
      }
      if (instagramId) {
        postFilter.instagramId = instagramId;
      }
      this.postFilter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, postFilter);
      this.getPosts();
    },
    closeViewPostLayout: function closeViewPostLayout() {
      this.showPostLayout = false;
      this.posts = [];

      this.postFilter = null;
    },
    changePostStatus: function changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changePostIds = [];
      this.changeStatusDialog = true;
    },
    changeBulkPostStatus: function changeBulkPostStatus(ids) {
      this.changePostIds = ids;
      this.postDataForChangeStatus = this.posts[0];
      this.changeStatusDialog = true;
    },
    archivePost: function archivePost(ids) {
      var _this = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var data;
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 10;
                    break;
                  }

                  data = ids.map(function (postID) {
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, {
                      id: postID,
                      archive: true
                    });
                  });
                  _context.next = 4;
                  return _this.$store.dispatch('post/updatePostByIds', data);

                case 4:
                  _this.isLoading = false;

                  if (_this.postUpdateStatus) {
                    _context.next = 8;
                    break;
                  }

                  _this.$swal({
                    text: 'Error Archiving Posts.',
                    type: 'error'
                  });
                  return _context.abrupt('return');

                case 8:
                  _this.$swal({
                    text: 'Successfully Archived.',
                    type: 'success'
                  });
                  _this.getPosts();

                case 10:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    restoreArchive: function restoreArchive(ids) {
      var _this2 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var data;
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result.value) {
                    _context2.next = 10;
                    break;
                  }

                  data = ids.map(function (postID) {
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, {
                      id: postID,
                      archive: false
                    });
                  });
                  _context2.next = 4;
                  return _this2.$store.dispatch('post/updatePostByIds', data);

                case 4:
                  _this2.isLoading = false;

                  if (_this2.postUpdateStatus) {
                    _context2.next = 8;
                    break;
                  }

                  _this2.$swal({
                    text: 'Error Restoring Posts.',
                    type: 'error'
                  });
                  return _context2.abrupt('return');

                case 8:
                  _this2.$swal({
                    text: 'Successfully restored.',
                    type: 'success'
                  });
                  _this2.getPosts();

                case 10:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    postAdded: function postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
      this.getPosts();
    },
    bulkApprove: function bulkApprove() {
      if (this.selected.length > 0) {
        this.submissionReviewMultipleDialog = true;
      }
    },
    resetFilter: function resetFilter() {
      var campaignId = this.filter.campaignId;
      this.filter = {
        instagramHandle: null,
        campaignName: null,
        clientID: null,
        campaignId: campaignId,
        today: false,
        story: false
      };
      this.getPosts();
    },
    assignedCampaign: function assignedCampaign() {
      this.getPosts();
    },
    influencerMapSuccess: function influencerMapSuccess() {
      this.getPosts();
    },
    validateTableActions: function validateTableActions(selected) {
      var disableApproveBtn = false;
      var disableReleaseBtn = false;
      if (!selected || selected.length === 0) {
        this.tableActions = this.tableActions.map(function (item) {
          item.disabled = true;
          return item;
        });
        return;
      }
      var disableAcceptBtn = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(selected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (!item.campaignID || !item.postDate || item.waiting_release || item.status !== this.postStatusConfig.AD_STRATEGIST_PENDING) {
            disableApproveBtn = true;
          }
          if (!item.waiting_release) {
            disableReleaseBtn = true;
          }
          if (item.status !== this.postStatusConfig.CLIENT_PENDING) {
            disableAcceptBtn = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.tableActions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var act = _step2.value;

          if (act.action === 'csApprove') {
            act.disabled = disableApproveBtn;
          } else if (act.action === 'saleApprove') {
            act.disabled = disableReleaseBtn;
          } else if (act.action === 'clientApprove') {
            act.disabled = disableAcceptBtn;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.postStatus === this.postStatusConfig.ARCHIVE) {
        this.tableActions = this.tableActions.filter(function (act) {
          return act.action === 'restore';
        });
      } else {
        this.tableActions = this.tableActions.filter(function (act) {
          return act.action !== 'restore';
        });
      }
    },
    performSelected: function performSelected(action) {
      var ids = this.selected.map(function (item) {
        return item._id;
      });
      switch (action) {
        case 'saleApprove':
          this.releasePosts(ids);
          break;
        case 'directRelease':
          this.releasePosts(ids);
          break;
        case 'csApprove':
          this.approvePosts(ids);
          break;
        case 'clientApprove':
          this.bulkApprove();
          break;
        case 'deletePost':
          this.deletePosts(ids);
          break;
        case 'changeStatus':
          this.changeBulkPostStatus(ids);
          break;
        case 'archivePost':
          this.archivePost(ids);
          break;
        case 'markAsMetadataTagged':
          this.markMetadataTag(ids);
          break;
        case 'markAsAbuseResolved':
          this.abuseResolvePosts(ids);
          break;
        case 'releaseAbuseResolved':
          this.releaseAbuseResolvedPosts(ids);
          break;
        case 'restore':
          this.restoreArchive(ids);
          break;
        case 'assignCampaign':
          this.assignCampaignToPostMultiple(ids);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPostMultiple(ids);
          break;
      }
    },
    pageChanged: function pageChanged() {
      this.pagging.page = this.page;
      this.getPosts();
    },
    isIncludeInAbuseReport: function isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      var tmpArr = clientReportArr.map(function (item) {
        return item.draftPostId;
      });
      return tmpArr.includes(reportedDraftId);
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */]['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    filterMenuOptions: function filterMenuOptions() {
      var _this3 = this;

      var options = __WEBPACK_IMPORTED_MODULE_21__postConfig__["a" /* default */].menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else if (this.postStatus === -1) {
        if (this.currentUserRole !== this.userRoles.CLIENT && this.currentUserRole !== this.userRoles.INFLUENCER) {
          this.menuOptions = options;
        }
      } else {
        this.menuOptions = options.filter(function (option) {
          return _this3.buttonShow(option.action);
        });
      }
    },
    filterTableActions: function filterTableActions() {
      var _this4 = this;

      var options = __WEBPACK_IMPORTED_MODULE_21__postConfig__["a" /* default */].tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(function (option) {
          return _this4.buttonShow(option.action);
        });
      }
      this.tableActions = this.tableActions.map(function (item) {
        item.disabled = true;
        return item;
      });
    },
    actionPostBy: function actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'editLiveDate':
          this.editLiveDate(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'directRelease':
          this.directReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsMetadataTagged':
          this.markMetadataTag([post._id]);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'markAsAbuseResolved':
          this.abuseResolvePosts([post._id]);
          break;
        case 'releaseAbuseResolved':
          this.releaseAbuseResolvedPosts([post._id]);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    getPosts: function getPosts() {
      var _this5 = this;

      var status = this.postStatus;
      this.loading = true;
      var query = __WEBPACK_IMPORTED_MODULE_30__utils__["a" /* default */].func.clean(this.filter);
      query.page = this.pagging.page;
      query.perPage = this.pagging.itemsPerPage;
      query.status = status;
      query.sortBy = this.pagging.sortBy && this.pagging.sortBy.length > 0 ? this.pagging.sortBy[0] : null;
      query.descending = this.pagging.sortDesc && this.pagging.sortDesc.length > 0 ? this.pagging.sortDesc[0] : null;
      __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].getPost(query).then(function (resp) {
        _this5.posts = [];
        _this5.selected = [];
        _this5.loading = false;
        _this5.showConnectionError = false;
        var posts = resp.posts;
        var totalItems = resp.totalItems;
        _this5.totalItems = totalItems;
        _this5.pendingCount = resp.pendingCount;
        _this5.overdueCount = resp.overdueLiveDateCount;
        _this5.proposeCount = resp.proposeDateCount;
        _this5.emptyLiveDateCount = resp.emptyLiveDateCount;
        posts = posts.map(function (post) {
          post.labels = _this5.getPostLabels(post);
          post.author = post.mapInfluencer || post.submitedBy || _this5.defaultPoster;
          return post;
        });
        setTimeout(function () {
          _this5.posts = posts;
        }, 0);

        if (_this5.$route.query.postID && !_this5.showDetailModalFromRoute) {
          _this5.showDetailModalFromRoute = true;
          var matchPost = posts.find(function (p) {
            return p._id === _this5.$route.query.postID;
          });
          if (matchPost) {
            _this5.viewDetailPost(matchPost);
          }
        }
      }).catch(function (err) {
        _this5.showConnectionError = true;
        _this5.loading = false;
        console.error(err);
      });
      this.filterTableActions();
      this.filterMenuOptions();
    },
    getClients: function getClients() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_23__Client_clientAPIs__["a" /* default */].getAllClients().then(function (resp) {
        var clients = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], resp.data);
        clients.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
        _this6.clients = [{ name: 'All', id: null }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(clients));
      });
    },
    searchPosts: function searchPosts() {
      this.pagging.page = 1;
      this.page = 1;
      this.getPosts();
    },
    reloadPostView: function reloadPostView(postData) {
      this.viewDetailPost(postData);
      this.searchPosts();
    },
    viewDetailPost: function viewDetailPost(post) {
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST && (!post.waiting_release || post.additional_abuse_reported)) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if ((post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.CLIENT_PENDING || post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE) && (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH)) {
        this.showProposeDateAction = true;
      } else {
        this.showProposeDateAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.CLIENT_PENDING && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) && post.campaignID) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if ((this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST) && post.campaignID) {
        this.show_client_inf_chatbox = true;
      } else {
        this.show_client_inf_chatbox = false;
      }
      if (post.clientReportAbuse) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE || post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.LIVE && this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id);
      this.$store.dispatch('post/updatePostViewUser', { postID: post._id });
      this.viewPostDialog = true;
    },

    editPostFromView: function editPostFromView(post) {
      this.editPost(post);
    },
    editLiveDateFromView: function editLiveDateFromView(post) {
      this.editLiveDate(post);
    },
    exec: function exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    getPostLabels: function getPostLabels(post) {
      var labels = [];
      if (this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && (this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release && !post.abuse_resolved) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'blue',
            action: 'viewDetailPost'
          });
        }
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && !post.postDate && !post.postDateEnd && this.postStatus >= this.postStatusConfig.APPROVE) {
        labels.push({
          text: 'Empty Live Date',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'editLiveDate'
        });
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.abuse_resolved) {
        labels.push({
          text: 'Pending to release',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.APPROVE && (this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.requestDate && !post.propose_dates) {
        labels.push({
          text: 'Live Date Change Requested',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'secondary',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.APPROVE && (this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && !post.dateConfirmed) {
        labels.push({
          text: 'Pending Confirmation',
          icon: 'schedule',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.APPROVE && (this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.dateConfirmed) {
        labels.push({
          text: 'Confirmed Post Date',
          icon: 'check',
          outlined: true,
          dark: false,
          color: 'green',
          action: 'viewDetailPost'
        });
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.propose_dates) {
        labels.push({
          text: 'Propose Date Submitted',
          icon: 'check',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }
      if (!post.waiting_release && this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && (this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && !post.abuse_resolved && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && !post.abuse_resolved && !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'grey',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'green',
              action: 'viewDetailPost'
            });
          }
        }
      }

      if (post.comments && this.postStatus < this.postStatusConfig.APPROVE && (this.currentUserRole === this.userRoles.INFLUENCER || this.currentUserRole === this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        labels.push({
          text: '(' + this.commentsInfo(post.comments) + ') Comments',
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE && !post.postURL && post.postDate) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: '' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: 'Today - ' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: false,
            dark: true,
            color: 'green',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'green',
            action: 'viewDetailPost'
          });
        }
      }

      if (post.postURL) {
        labels.push({
          text: 'Post URL Added',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }
      if (post.hasReport) {
        labels.push({
          text: 'Present in Campaign Report',
          icon: 'check',
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (post.metadataTagged) {
        labels.push({
          text: 'Metadata Tagged',
          faIcon: 'fa fa-tag',
          color: 'blue',
          outlined: true,
          action: 'viewDetailPost'
        });
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER && this.postStatus === this.postStatusConfig.APPROVE) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      if (post.type) {
        labels.push({
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__utils_platformDisplay__["a" /* platformDisplayName */])(post.type),
          color: 'primary',
          postType: true,
          action: 'viewDetailPost'
        });
      }

      return labels;
    },
    editPost: function editPost(post) {
      var _this7 = this;

      this.fetchPostAsync(post._id).then(function (newPost) {
        post.reportAbuse = newPost.reportAbuse;
        _this7.editPostData = post;
        _this7.editPostDialog = true;
      });
    },
    editLiveDate: function editLiveDate(post) {
      this.postDataForEditLiveDate = post;
      this.editLiveDateDialog = true;
    },
    assignCampaignToPost: function assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost: function mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    assignCampaignToPostMultiple: function assignCampaignToPostMultiple(postIds) {
      var selectedPost = this.selected.filter(function (s) {
        return postIds.includes(s._id);
      });
      this.assignCampaignPosts = selectedPost;
      this.assignCampaignMultipleDialog = true;
    },
    mapInfluencerToPostMultiple: function mapInfluencerToPostMultiple(postIds) {
      var selectedPost = this.selected.filter(function (s) {
        return postIds.includes(s._id);
      });
      this.mapInfluencerPosts = selectedPost;
      this.mapInfluencerMultipleDialog = true;
    },
    paserImageUrl: function paserImageUrl(url) {
      if (url) {
        var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    paserAudienceImageUrl: function paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },

    csApproveFromView: function csApproveFromView(post) {
      this.csApprovePost(post);
    },
    csApprovePost: function csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from AM.',
          type: 'info'
        });
      } else {
        var id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts: function approvePosts(postIds) {
      var _this8 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].approvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this8.$swal({
              title: 'Error in approving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this8.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this8.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this8.$emit('input');
          _this8.getPosts();
          _this8.viewPostDialog = false;
        } else {}
      });
    },
    abuseResolvePosts: function abuseResolvePosts(postIds) {
      var _this9 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon Confirmation, the latest edited version will be send to AM as abuse resolved.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].abuseResolvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this9.$swal({
              title: 'Error in abuse resolving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this9.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this9.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this9.$emit('input');
          _this9.getPosts();
          _this9.viewPostDialog = false;
        } else {}
      });
    },
    releaseAbuseResolvedPosts: function releaseAbuseResolvedPosts(postIds) {
      var _this10 = this;

      this.$swal({
        title: 'Are you sure?',
        html: '<b>Upon confirmation, the post will be released to client as abuse resolved.</b>',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].releaseAbuseResolvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this10.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this10.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this10.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is sent to client.',
            type: 'success'
          });

          _this10.$emit('input');
          _this10.getPosts();
          _this10.viewPostDialog = false;
        } else {}
      });
    },
    saleReleasePost: function saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CC yet',
          type: 'warning'
        });
      } else {
        var id = post._id;
        this.releasePosts([id]);
      }
    },
    directReleasePost: function directReleasePost(post) {
      var id = post._id;
      this.releasePosts([id]);
    },
    releasePosts: function releasePosts(postIds) {
      var _this11 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_21__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].releasePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this11.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this11.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this11.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });

          _this11.getPosts();
          _this11.$emit('input');
          _this11.viewPostDialog = false;
        } else {}
      });
    },
    deletePosts: function deletePosts(postIds) {
      var _this12 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be deleted',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].bulkDeletePosts(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this12.$swal({
              title: 'Error in deleting Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this12.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this12.$swal({
            title: 'Success',
            text: 'Successfully Deleted',
            type: 'success'
          });

          _this12.$emit('input');
          _this12.getPosts();
          _this12.viewPostDialog = false;
        } else {}
      });
    },
    startSubmissionReview: function startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout: function submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL: function enterPostURL(post) {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_25__Campaign_campaignAPIs__["a" /* default */].getCampaign(post.campaignID).then(function (response) {
        _this13.campaignDataForAddPost = response;
        _this13.postIdToUpdate = post._id;
        _this13.addPostToCampaign = true;
        _this13.addPost = post;
      }).catch(function (err) {
        _this13.addPostToCampaign = true;
        _this13.$swal({
          type: 'error',
          title: 'Error Getting Campaign Information'
        });
        console.log(err);
      });
    },
    assignPostURL: function assignPostURL(post) {
      var _this14 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_21__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].publishPost(post._id, result.value).then(function () {
            _this14.$swal({
              title: postConfirmationText['confirm']['title'],
              text: 'Do you want to submit payout?',
              type: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then(function (confirmed) {
              if (confirmed.value) {
                var payout = {
                  campaignName: post.campaignName,
                  campaignID: post.campaignID,
                  postID: post._id,
                  influencerID: post.influencerID,
                  instagramPostURL: result.value,
                  otherSocialMediaPostUrl: '',
                  satisfactionLevel: 0,
                  advertiserSatisfactionLevel: 0
                };
                __WEBPACK_IMPORTED_MODULE_24__Influencer_paymentAPIs__["a" /* default */].createCampaignPayout(payout).then(function () {
                  _this14.$swal({
                    type: 'success',
                    title: 'Campaign payout created!'
                  });
                }).catch(function () {
                  _this14.$swal({
                    type: 'error',
                    title: 'Cannot create campaign payout for this post. Try again later!'
                  });
                });
              }
            });
            _this14.getPosts();
          }).catch(function () {
            _this14.$swal({
              type: 'error',
              title: 'Error in processing your request! Please try again'
            });
          });
        }
      });
    },
    completePost: function completePost(post) {
      var _this15 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_21__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].completePost(post._id).then(function () {
            _this15.$swal({
              type: 'success',
              title: postConfirmationText['confirm']['title'],
              text: postConfirmationText['confirm']['text']
            }).then(function () {
              _this15.getPosts();
            });
          }).catch(function (error) {
            return _this15.$swal({
              type: 'error',
              text: error
            });
          });
        }
      });
    },
    markMetadataTag: function markMetadataTag(ids) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this16.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to mark as metadata tagged?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
                    var data;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result.value) {
                              _context3.next = 10;
                              break;
                            }

                            data = ids.map(function (postID) {
                              return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, {
                                id: postID,
                                metadataTagged: true
                              });
                            });
                            _context3.next = 4;
                            return _this16.$store.dispatch('post/updatePostByIds', data);

                          case 4:
                            _this16.isLoading = false;

                            if (_this16.postUpdateStatus) {
                              _context3.next = 8;
                              break;
                            }

                            _this16.$swal({
                              text: 'Error Metadata Tag.',
                              type: 'error'
                            });
                            return _context3.abrupt('return');

                          case 8:
                            _this16.$swal({
                              text: 'Successfully Saved Metadata Tag.',
                              type: 'success'
                            });
                            _this16.getPosts();

                          case 10:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this16);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this16);
      }))();
    },
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';

      return __WEBPACK_IMPORTED_MODULE_31_moment___default()(date).format(format);
    },
    checkAfter: function checkAfter(date) {
      return __WEBPACK_IMPORTED_MODULE_31_moment___default()(this.currentDate).isAfter(date);
    },
    checkSame: function checkSame(date) {
      return __WEBPACK_IMPORTED_MODULE_31_moment___default()(this.currentDate).isSame(date);
    },
    fetchPost: function fetchPost(postId, returnData) {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].getPostById(postId).then(function (post) {
        _this17.viewPostData = post;
      }).catch(function (err) {
        _this17.$swal({
          title: 'Couldn\'t the Post',
          type: 'error',
          text: err
        });
      });
    },
    fetchPostAsync: function fetchPostAsync(postId, returnData) {
      var _this18 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].getPostById(postId).then(function (post) {
          resolve(post);
        }).catch(function (err) {
          _this18.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
          reject(err);
        });
      });
    },
    commentsInfo: function commentsInfo(comments) {
      var _this19 = this;

      if (comments === undefined) {
        return;
      } else {
        var commentsArr = comments.filter(function (comment) {
          return comment.author.id !== _this19.user.id;
        });
        return commentsArr.length;
      }
    },
    viewPostByRouter: function viewPostByRouter() {
      var _this20 = this;

      var action = this.$route.query.action;
      var id = this.$route.query.id;
      if (action === 'view' && id) {
        __WEBPACK_IMPORTED_MODULE_22__postApi__["a" /* default */].getPostById(id).then(function (post) {
          _this20.viewDetailPost(post);
        }).catch(function (err) {
          _this20.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
        });
      }
    },
    changePendingConfirmation: function changePendingConfirmation() {
      this.filter.pendingConfirmation = !this.filter.pendingConfirmation;
      this.getPosts();
    },
    changeOverdueDateFilter: function changeOverdueDateFilter() {
      this.filter.overdueLiveDate = !this.filter.overdueLiveDate;
      this.getPosts();
    },
    changeProposeDateFilter: function changeProposeDateFilter() {
      this.filter.proposeDate = !this.filter.proposeDate;
      this.getPosts();
    },
    changeEmptyLiveDateFilter: function changeEmptyLiveDateFilter() {
      this.filter.emptyLiveDate = !this.filter.emptyLiveDate;
      this.getPosts();
    },
    fetchCampaignList: function fetchCampaignList() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, campaigns;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_25__Campaign_campaignAPIs__["a" /* default */].getAllCampaignsNoStatus();

              case 2:
                response = _context5.sent;
                campaigns = response;

                _this21.campaignList = campaigns.map(function (element) {
                  return {
                    name: element.name,
                    id: element.id
                  };
                });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this21);
      }))();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    user: function user() {
      return this.$store.state.user;
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function postStatus() {
      return this.$route.meta.postStatus;
    },
    isAllPosts: function isAllPosts() {
      return this.$route.meta.postStatus;
    },
    statuses: function statuses() {
      var _this22 = this;

      var statuses = __WEBPACK_IMPORTED_MODULE_21__postConfig__["a" /* default */].postFilterStatuses.filter(function (status) {
        return status.permissions.includes(_this22.postStatus) || _this22.postStatus === -1;
      });
      if (this.postStatus === -1) {
        statuses = statuses.filter(function (s) {
          return s.value !== 2;
        });
      }
      return statuses;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles;
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_31_moment___default()().format('ll');
    },
    paginationLength: function paginationLength() {
      var round = this.totalItems / this.pagging.itemsPerPage;
      var decimal = this.totalItems % this.pagging.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    },
    showCampaignPosts: function showCampaignPosts() {
      return this.postStatus === -1;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
    postUpdateStatus: function postUpdateStatus(state) {
      return state.post.updated;
    }
  })),
  mounted: function mounted() {
    var _this23 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (_this23.$route.query.handle) {
                _this23.filter.instagramHandle = _this23.$route.query.handle;
              }
              if (_this23.$route.query.campaignID) {
                _this23.filter.campaignId = _this23.$route.query.campaignID;
              }
              if (_this23.$route.query.postID) {
                _this23.filter.postID = _this23.$route.query.postID;
              }
              _context6.next = 5;
              return _this23.fetchCampaignList();

            case 5:
              if (_this23.postStatus === -1 && (_this23.filter.campaignId || _this23.filter.postID) || _this23.postStatus !== -1) {
                _this23.getPosts();
              }
              if (_this23.currentUserRole !== _this23.userRoles.CLIENT && _this23.currentUserRole !== _this23.userRoles.INFLUENCER) {
                _this23.getClients();
              }
              _this23.display = 1;

            case 8:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this23);
    }))();
  },
  updated: function updated() {
    this.viewPostByRouter();
  }
});

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProposeDateModal',
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_4__components_scoped_custom_DatePicker___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay___default.a
  },
  props: {
    post: Object,
    proposeDialogValue: Boolean
  },
  data: function data() {
    return {
      isLoading: false,
      submissionReview: {
        propose_dates: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    postUpdateStatus: function postUpdateStatus(state) {
      return state.post.updated;
    }
  })),
  methods: {
    resetForm: function resetForm() {
      this.submissionReview = {
        propose_dates: []
      };
      this.valid = true;
    },
    close: function close() {
      this.proposeDialogValue = false;
      this.$emit('proposeClosed');
    },
    saveChangeDate: function saveChangeDate() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var saveData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.dateDialog.save(_this2.submissionReview.propose_dates);
                saveData = [{
                  id: _this2.post._id,
                  propose_dates: _this2.submissionReview.propose_dates
                }];
                _context2.next = 4;
                return _this2.$store.dispatch('post/updatePostByIds', saveData);

              case 4:
                if (!_this2.postUpdateStatus) {
                  _context2.next = 8;
                  break;
                }

                _this2.$swal({
                  text: 'Proposed Dates sent to Client',
                  type: 'success'
                });
                _context2.next = 8;
                return _this2.$store.dispatch('post/sendProposeDateClientEmail', {
                  id: _this2.post._id,
                  appLink: window.location.protocol + '//' + window.location.host + '/clients/posts?id=' + _this2.post._id
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    allowedDates: function allowedDates(val) {
      var proposeDates = this.submissionReview.propose_dates;
      if (Array.isArray(proposeDates) && proposeDates.length === 3) {
        return proposeDates.includes(val);
      }
      return true;
    }
  },
  watch: {}
});

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PostChatBox__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PostChatBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__PostChatBox__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      post: null,
      clientReportAbuse: [],
      influencerData: null,
      influencerIG: null,
      loading: false,
      showStartQuestion: true,
      showReviewSummary: true,
      reviewSection: false,
      reportSection: false,
      changeDate: false,
      askDate: true,
      showChangeRequest: false,
      showApprove: true,
      submissionReview: {
        abuseReasons: [],
        abuseComment: null,
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null,
        wantedLiveDate: null,
        influencerID: null,
        postID: null,
        abuseSubmitted: false
      },
      campaignHelper: __WEBPACK_IMPORTED_MODULE_11__Campaign_campaignHelper__["a" /* default */],
      files: [],
      fileUploadRefresh: 0,
      utilsFunc: __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func,
      clientMessages: []
    };
  },

  components: {
    btnDownload: __WEBPACK_IMPORTED_MODULE_8__components_scoped_custom_BtnDownload_vue___default.a,
    CustomFileUpload: __WEBPACK_IMPORTED_MODULE_10__scoped_custom_CustomFileUpload___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_9__scoped_custom_CustomMediaV2___default.a,
    chatBox: __WEBPACK_IMPORTED_MODULE_13__PostChatBox___default.a
  },
  computed: {
    notes: function notes() {
      return __WEBPACK_IMPORTED_MODULE_5__postConfig__["a" /* default */].submissionReviewNotes;
    },
    abuseReasons: function abuseReasons() {
      return __WEBPACK_IMPORTED_MODULE_5__postConfig__["a" /* default */].nonApprovalReasons;
    },
    user: function user() {
      return this.$store.state.user;
    },
    influencerProfileURL: function influencerProfileURL() {
      if (!this.influencerData) return '#';
      var username = String(this.influencerData.username || '').replace(/^@/, '');
      if (this.influencerData.platform === 'linkedin') {
        return 'https://www.linkedin.com/in/' + username;
      }
      if (this.influencerData.platform === 'tiktok') {
        return 'https://www.tiktok.com/@' + username;
      }
      if (this.influencerData.platform === 'youtube') {
        return 'https://youtube.com/@' + username;
      }
      if (this.influencerData.platform === 'facebook') {
        return 'https://facebook.com/' + username;
      }
      return 'https://instagram.com/' + username;
    },
    isVideoLink: function isVideoLink() {
      return this.post.type === 'story' || this.post.type === 'video' || this.post.type === 'reel' || this.post.type === 'tiktok' || this.post.type === 'youtube' || this.post.type === 'facebook' || this.post.type === 'linkedin';
    }
  },
  created: function created() {
    var _this = this;

    this.getPost(this.$route.query.id);
    this.$swal({
      title: 'Terms and Agreements',
      html: '<p class="text-xs-left subtitle-1">Please note that the content creator reserves full creative rights to the final execution of the post and will only do 1 shoot based on the brief approved by the client. Drafts sent to clients for vetting are for the sole purpose of fact-checking and stylistic changes will not be allowed. The client is entitled to only 1 revision. </p>',
      type: 'info',
      width: 500,
      backdrop: 'rgba(0,0,1, 0.7)',
      showCancelButton: true,
      confirmButtonText: 'Agree',
      cancelButtonText: 'Disagree',
      allowOutsideClick: false
    }).then(function (result) {
      if (!result.value) {
        _this.$router.push({ path: '/clients/posts' });
      }
    });
  },

  methods: {
    submitAbuse: function submitAbuse() {
      var _this2 = this;

      if (this.submissionReview.abuseReasons.length === 0) {
        this.$swal({
          title: 'Please select at least one reason.',
          type: 'warning'
        });
      } else if (this.submissionReview.abuseComment === null) {
        this.$swal({
          title: 'Comments is required',
          type: 'warning'
        });
      } else {
        this.submissionReview.abuseSubmitted = true;
        this.$swal({
          title: 'Do you want to report this post?',
          type: 'question',
          confirmButtonText: 'Yes, Report',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(function (result) {
          if (result.value) {
            var body = {
              comment: _this2.submissionReview.abuseComment,
              reasons: _this2.submissionReview.abuseReasons
            };
            var formData = new FormData();
            formData.append('data', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(body));
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this2.files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var val = _step.value;

                formData.append('uploadFile', val);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            __WEBPACK_IMPORTED_MODULE_6__postApi__["a" /* default */].clientReportPost(_this2.post._id, formData).then(function () {
              _this2.$swal({
                type: 'success',
                title: 'Reported'
              }).then(function () {
                return _this2.$router.push({ path: '/clients/posts' });
              });
            }).catch(function () {
              return _this2.$swal({
                type: 'error',
                title: 'Some thing went wrong'
              });
            });
          }
        });
      }
    },
    submitApprove: function submitApprove() {
      var _this3 = this;

      if (this.submissionReview.approveRatings === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        });
      } else if (this.submissionReview.approveSuggestion === null && this.submissionReview.approveCompliment === null) {
        this.$swal({
          title: 'Your comment is required',
          type: 'warning'
        });
      } else {
        var msgTitle = '';
        var confirmBtnText = '';
        if (this.showApprove) {
          msgTitle = 'Do you want to approve this post?';
          confirmBtnText = 'Yes, Approve';
        }
        if (this.showChangeRequest) {
          msgTitle = 'Do you want to request date change this post?';
          confirmBtnText = 'Yes, Request Change';
        }
        this.$swal({
          title: msgTitle,
          type: 'question',
          confirmButtonText: confirmBtnText,
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(function (result) {
          if (result.value) {
            var body = {
              rating: _this3.submissionReview.approveRatings,
              comment: _this3.submissionReview.approveSuggestion || _this3.submissionReview.approveCompliment,
              appLink: window.location.protocol + '//' + window.location.host + '/posts/internal/approved?campaignID=' + _this3.post.campaignID + '&postID=' + _this3.post._id + '&confirmDate=true',
              isRequestDateChange: _this3.showChangeRequest
            };
            if (_this3.showApprove) {
              body.postDate = _this3.submissionReview.wantedLiveDate || _this3.post.postDate;
              if (body.postDate < __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_12_moment___default()(), 'YYYY-MM-DD')) {
                body.isDateOverdue = true;
              }
              body.isApprove = true;
            }
            if (_this3.showChangeRequest) {
              body.postDate = _this3.submissionReview.wantedLiveDate || _this3.post.postDate;
            }
            __WEBPACK_IMPORTED_MODULE_6__postApi__["a" /* default */].clientApprovePost([{
              id: _this3.post._id,
              body: body
            }]).then(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
              var successTitle;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      successTitle = '';

                      if (_this3.showChangeRequest) {
                        successTitle = 'Your date change request has been captured, date is subjected to availability. The team will be in touch for next steps.';
                      } else if (_this3.showApprove) {
                        successTitle = 'Approved';
                      }
                      _this3.$swal({
                        type: 'success',
                        title: successTitle
                      }).then(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _this3.$router.push({ path: '/clients/posts' });

                              case 1:
                              case 'end':
                                return _context.stop();
                            }
                          }
                        }, _callee, _this3);
                      })));

                    case 3:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, _this3);
            }))).catch(function () {
              return _this3.$swal({
                type: 'error',
                title: 'Some thing went wrong'
              });
            });
          }
        });
      }
    },
    getPost: function getPost(postId) {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_6__postApi__["a" /* default */].getPostById(postId).then(function (response) {
        _this4.post = response.mainPost;
        _this4.influencerData = response.influencer;
        _this4.clientReportAbuse = response.reportAbuse;
        _this4.clientMessages = response.clientComments || [];
        _this4.loading = false;
      }).catch(function (err) {
        _this4.$swal({
          title: 'Can\'t Load the Post',
          type: 'error',
          text: err
        }).then(function () {
          return _this4.$router.push({ path: '/clients/posts' });
        });
      });
    },
    reset: function reset() {
      this.showStartQuestion = true;
      this.reviewSection = false;
      this.reportSection = false;
      this.changeDate = false;
      this.askDate = true;
      this.submissionReview = {
        abuseReasons: [],
        abuseComment: null,
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null,
        wantedLiveDate: null,
        abuseSubmitted: false
      };
    },
    saveWantedLiveDate: function saveWantedLiveDate() {
      this.$refs.dateDialog.save(this.submissionReview.wantedLiveDate);
      this.showApprove = false;
      if (!this.post.propose_dates) {
        this.showChangeRequest = true;
      } else {
        this.showApprove = true;
      }
    },
    allowedDates: function allowedDates(val) {
      if (this.post.propose_dates && this.post.propose_dates.length > 0) {
        return this.post.propose_dates.includes(val);
      }
      if (!this.post.propose_dates) return true;
      return false;
    },
    updateFiles: function updateFiles(medias) {
      this.files = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], medias);
    },

    sendClientMessage: function sendClientMessage(message) {
      var _this5 = this;

      if (!message) {
        this.$swal('Comment can\'t be empty');
      } else {
        __WEBPACK_IMPORTED_MODULE_6__postApi__["a" /* default */].clientComment(this.post._id, message).then(function (comment) {
          _this5.post.client_comments ? '' : _this5.post.client_comments = [];
          _this5.post.client_comments.push({
            comment: message,
            commentator: _this5.user.firstName,
            createdAt: __WEBPACK_IMPORTED_MODULE_12_moment___default()()
          });
          _this5.clientMessages.push(comment);
        }).catch(function (error) {
          _this5.$swal({
            title: 'Can\'t Make Comments now, try again later',
            type: 'error',
            content: error
          });
        });
      }
    }
  }
});

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    posts: Array,
    value: Boolean,
    internalApprove: Boolean
  },
  data: function data() {
    return {
      loading: false,
      submissionReview: {
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null
      }
    };
  },

  computed: {
    notes: function notes() {
      return __WEBPACK_IMPORTED_MODULE_2__postConfig__["a" /* default */].submissionReviewNotes;
    }
  },
  methods: {
    reset: function reset() {
      this.submissionReview = {
        approveRatings: null,
        approveSuggestion: null,
        approveCompliment: null
      };
    },
    close: function close() {
      this.reset();
      this.$emit('input');
    },
    submitApprove: function submitApprove() {
      var _this = this;

      if (this.submissionReview.approveRatings === null) {
        this.$swal({
          title: 'Rating is required',
          type: 'warning'
        });
      } else if (this.submissionReview.approveSuggestion === null && this.submissionReview.approveCompliment === null) {
        this.$swal({
          title: 'Your comment is required',
          type: 'warning'
        });
      } else {
        var data = [];
        var body = {
          rating: this.submissionReview.approveRatings,
          comment: this.submissionReview.approveSuggestion || this.submissionReview.approveCompliment,
          postDate: null,
          appLink: window.location.protocol + '//' + window.location.host
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.postDate < __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].func.formatCustomDate(__WEBPACK_IMPORTED_MODULE_3_moment___default()(), 'YYYY-MM-DD')) {
              body.isDateOverdue = true;
            }
            body.postDate = item.postDate;
            body.isApprove = true;
            data.push({
              id: item._id,
              body: body
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.$swal({
          type: 'question',
          title: 'Do you want to approve all the selected posts?',
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_1__postApi__["a" /* default */].clientApprovePost(data).then(function () {
              _this.$swal({
                type: 'success',
                title: 'Approved'
              }).then(function () {
                _this.$emit('successBulkApprove');
                _this.close();
              });
            }).catch(function () {
              return _this.$swal({
                type: 'error',
                title: 'Some thing went wrong'
              }).then(function () {
                return _this.close();
              });
            });
          }
        });
      }
    },
    submitApproveInternal: function submitApproveInternal() {
      var _this2 = this;

      if (this.posts.length <= 0) {
        this.$swal({
          title: 'Please select at least one post.',
          type: 'warning'
        });
      } else {
        var data = [];
        var body = {
          rating: null,
          comment: null,
          internalApproved: true,
          appLink: window.location.protocol + '//' + window.location.host
        };
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            data.push({
              id: item._id,
              body: body
            });
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.$swal({
          type: 'question',
          title: 'Do you want to approve all the selected posts?',
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          showCloseButton: true
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_1__postApi__["a" /* default */].clientApprovePost(data).then(function () {
              _this2.$swal({
                type: 'success',
                title: 'Approved'
              }).then(function () {
                _this2.$emit('successBulkApprove');
                _this2.close();
              });
            }).catch(function () {
              return _this2.$swal({
                type: 'error',
                title: 'Some thing went wrong'
              }).then(function () {
                return _this2.close();
              });
            });
          }
        });
      }
    }
  }
});

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PostMediaViewerModal_vue__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PostMediaViewerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PostMediaViewerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewPostDetailModal',
  components: {
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_3__scoped_custom_CustomMediaV2___default.a,
    PostMediaViewerModal: __WEBPACK_IMPORTED_MODULE_4__PostMediaViewerModal_vue___default.a
  },
  props: {
    campaignName: String,
    submittedCampaignName: String,
    postDetails: Object,
    postReviewApproved: Boolean,
    mappedInfluencerData: Object,
    influencerData: Object,
    userObj: Object,
    clientReportAbuse: Array,
    postAbuseHistory: Boolean,
    detailValue: Boolean
  },
  data: function data() {
    return {
      utilsFunc: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func,
      mediaViewerDialog: false,
      mediaItem: '',
      videoPlayer: false,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_2__Campaign_campaignHelper__["a" /* default */]
    };
  },

  watch: {
    detailValue: function detailValue(newVal) {}
  },
  methods: {
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return null;
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    viewMedia: function viewMedia(media, isVideo) {
      if (isVideo) {
        this.videoPlayer = true;
      } else {
        this.videoPlayer = false;
      }
      this.mediaItem = media;
      this.mediaViewerDialog = true;
    },
    loadPostStatusDisplay: function loadPostStatusDisplay(newPost) {
      var currentUserRole = this.userObj.role;
      if (currentUserRole === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.CLIENT) {
        return __WEBPACK_IMPORTED_MODULE_1__postConfig__["a" /* default */].postStatusDisplayForClient[newPost.status];
      } else if (currentUserRole === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.INFLUENCER) {
        return __WEBPACK_IMPORTED_MODULE_1__postConfig__["a" /* default */].postStatusDisplayForInfluencer[newPost.status];
      } else if (currentUserRole === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.AD_STRATEGIST || currentUserRole === __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        return __WEBPACK_IMPORTED_MODULE_1__postConfig__["a" /* default */].postStatusDisplayForCS[newPost.status];
      } else {
        return __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatusDisplayInternal[newPost.status].display;
      }
    },
    closeDetailModal: function closeDetailModal() {
      this.detailValue = false;
      this.$emit('detailClosed');
    },
    closeMediaViewerModal: function closeMediaViewerModal() {
      this.mediaViewerDialog = false;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('DD-MM-YYYY, HH:mm');
    },
    renderHTML: function renderHTML(text) {
      if (text !== undefined && text !== null) {
        return text.replace(/\n/g, '<p><p>');
      }
      return '';
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].postStatus;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].userRoles;
    }
  }
});

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__postMedia__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dompurify__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PostChatBox_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PostChatBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__PostChatBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostDetailModal_vue__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostDetailModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ViewPostDetailModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PostMediaViewerModal_vue__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PostMediaViewerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__PostMediaViewerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProposeDateModal_vue__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProposeDateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ProposeDateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ClientChooseDateModal_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ClientChooseDateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ClientChooseDateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Campaign_config__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(12);
























/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    post: Object,
    value: Boolean,
    csActions: Boolean,
    proposeDateActions: Boolean,
    saleActions: Boolean,
    clientActions: Boolean,
    influencerActions: Boolean,
    cs_inf_chatbox: Boolean,
    client_inf_chatbox: Boolean,
    postAbuseHistory: Boolean,
    postReviewApproved: Boolean,
    postHistory: Boolean,
    userObj: Object
  },
  components: {
    chatBox: __WEBPACK_IMPORTED_MODULE_12__PostChatBox_vue___default.a,
    btnDownload: __WEBPACK_IMPORTED_MODULE_17__components_scoped_custom_BtnDownload_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_18__scoped_custom_CustomMediaV2___default.a,
    ViewPostDetailModal: __WEBPACK_IMPORTED_MODULE_13__ViewPostDetailModal_vue___default.a,
    PostMediaViewerModal: __WEBPACK_IMPORTED_MODULE_14__PostMediaViewerModal_vue___default.a,
    ProposeDateModal: __WEBPACK_IMPORTED_MODULE_15__ProposeDateModal_vue___default.a,
    ClientChooseDateModal: __WEBPACK_IMPORTED_MODULE_16__ClientChooseDateModal_vue___default.a
  },
  data: function data() {
    return {
      utilsFunc: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func,
      postData: null,
      showSuggestEditBox: false,
      suggestionText: null,
      images: [],
      postStatusDisplay: '',
      viewPostDetailDialog: false,
      mediaViewerDialog: false,
      proposeDateDialog: false,
      chooseDateDialog: false,
      changeConfirmDate: false,
      showConfirmDateFromRoute: false,
      confirmDate: '',
      mediaItem: '',
      videoPlayer: false,
      messages: [],
      clientMessages: [],
      influencerData: null,
      postHistoryData: [],
      clientReportAbuse: [],
      clientReportAbuseData: [],
      overRideBySuperAdmin: false,
      influencerRole: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_19__Campaign_campaignHelper__["a" /* default */],
      isIGCutOff: false,
      isIGStory: false,
      isTikTokCutOff: false,
      postTypes: __WEBPACK_IMPORTED_MODULE_10__postConfig__["a" /* default */].postTypes,
      campaignTypes: __WEBPACK_IMPORTED_MODULE_20__Campaign_config__["a" /* default */].campaignType
    };
  },

  watch: {
    post: function post(newVal) {
      this.clearData();
      this.postData = newVal.mainPost || null;
      this.images = newVal.mainPost.images || newVal.images;
      this.messages = newVal.comments;
      this.clientMessages = newVal.clientComments;
      if (this.currentUserRole <= this.userRoles.AD_STRATEGIST && newVal.mainPost.mapInfluencer) {
        this.mappedInfluencerData = newVal.mainPost.mapInfluencer;
      } else {
        this.mappedInfluencerData = null;
      }
      this.influencerData = newVal.influencer;
      this.clientReportAbuseData = newVal.reportAbuse;
      this.clientReportAbuse = newVal.reportAbuse ? newVal.reportAbuse.filter(function (item) {
        return newVal.mainPost.draftId ? item.draftPostId === newVal.mainPost.draftId : false;
      }) : [];
      this.loadHistoryPosts(newVal);
      this.loadPostStatusDisplay(newVal);
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.overRideBySuperAdmin = true;
      }
      this.viewPostDetailDialog = false;
      if (!this.postData.callToActionLinks) {
        this.loadCampaign(this.postData);
      } else {
        if (this.postData.campaignID) {
          this.$store.dispatch('campaign/getCampaignDetail', this.postData.campaignID);
        }
      }
      this.setMultipleInfs(this.postData);
      if (this.$route.query.confirmDate && !this.showConfirmDateFromRoute) {
        this.showConfirmDateFromRoute = true;
        this.invokeConfirmDateChange();
      }
    },
    value: function value(newVal) {
      if (newVal) {
        setTimeout(function () {
          var modalHeight = $('.view-post-modal').height();
          var reposeAbuseHeight = modalHeight - 135;
          var element = document.querySelector('.report-abuse-section');
          if (element) {
            element.setAttribute('style', 'max-height:' + reposeAbuseHeight + 'px!important;overflow-y:auto;padding:2px;');
          }
        }, 1000);
      }
    }
  },
  methods: {
    isMissingMedia: function isMissingMedia(media) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__postMedia__["a" /* isMissingPostMedia */])(media);
    },
    getVideoLink: function getVideoLink(link) {
      try {
        var url = new URL(link);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
      } catch (error) {
        return '';
      }
    },
    getPostTypeMeta: function getPostTypeMeta(type) {
      return this.postTypes.find(function (postType) {
        return postType.type === type;
      }) || {};
    },
    changeCutOff: function changeCutOff(type) {
      if (type === 'IG' && this.isIGCutOff) {
        this.isIGCutOff = true;
        this.isIGStory = false;
        this.isTikTokCutOff = false;
      } else if (type === 'IGStory' && this.isIGStory) {
        this.isIGCutOff = false;
        this.isIGStory = true;
        this.isTikTokCutOff = false;
      } else if (type === 'tiktok' && this.isTikTokCutOff) {
        this.isIGCutOff = false;
        this.isIGStory = false;
        this.isTikTokCutOff = true;
      } else {
        this.isIGCutOff = false;
        this.isIGStory = false;
        this.isTikTokCutOff = false;
      }
    },
    clearData: function clearData() {
      this.postData = null;
      this.images = null;
      this.messages = null;
      this.mappedInfluencerData = null;
      this.influencerData = null;
      this.clientReportAbuseData = null;
      this.clientReportAbuse = null;
      this.postHistoryData = [];
      this.postStatusDisplay = null;
    },
    loadPostStatusDisplay: function loadPostStatusDisplay(newPost) {
      var currentUserRole = this.userObj.role;
      if (currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.CLIENT) {
        this.postStatusDisplay = __WEBPACK_IMPORTED_MODULE_10__postConfig__["a" /* default */].postStatusDisplayForClient[newPost.mainPost.status];
      } else if (currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER) {
        this.postStatusDisplay = __WEBPACK_IMPORTED_MODULE_10__postConfig__["a" /* default */].postStatusDisplayForInfluencer[newPost.mainPost.status];
      } else if (currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.AD_STRATEGIST || currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        this.postStatusDisplay = __WEBPACK_IMPORTED_MODULE_10__postConfig__["a" /* default */].postStatusDisplayForCS[newPost.mainPost.status];
      } else {
        this.postStatusDisplay = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].postStatusDisplayInternal[newPost.mainPost.status].display;
      }
    },
    paserImageUrl: function paserImageUrl(url) {
      if (!url) return '/static/img/avatar/user.png';
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    paserAudienceImageUrl: function paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    loadHistoryPosts: function loadHistoryPosts(newPost) {
      if (newPost.history) {
        this.postHistoryData = [];
        var postHistoryArray = newPost.history;
        postHistoryArray.push(newPost.mainPost);
        this.postHistoryData = postHistoryArray.sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_11_moment___default()(a.createdAt) - __WEBPACK_IMPORTED_MODULE_11_moment___default()(b.createdAt);
        });
      }
    },
    setPrimaryPost: function setPrimaryPost(postID) {
      var _this = this;

      if (postID === this.post.mainPost._id) {
        this.$swal('The draft is already set as Primary Post.');
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_9__postApi__["a" /* default */].setAsMainPost(postID).then(function (response) {
          _this.closeModal();
          _this.postData._id = _this.post._id;
          _this.$emit('mainPostChanged', _this.postData);
        }).catch(function (error) {
          _this.$swal({
            title: 'Error in submitting primary post',
            type: 'error',
            content: error
          });
        });
      }
    },
    switchPostView: function switchPostView(hpost) {
      this.postData = hpost;
      this.images = hpost.images;
      this.clientReportAbuse = this.clientReportAbuseData.filter(function (item) {
        return hpost.draftId === item.draftPostId || hpost._id === item.draftPostId;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format('DD-MM-YYYY, HH:mm');
    },
    release: function release() {
      this.$emit('saleReleased', this.postData);
    },
    directRelease: function directRelease() {
      this.$emit('directReleased', this.postData);
    },
    approve: function approve() {
      this.$emit('csApproved', this.postData);
    },
    edit: function edit() {
      this.$emit('editPost', this.postData);
      this.closeModal();
    },
    editLiveDate: function editLiveDate() {
      this.$emit('editLiveDate', this.postData);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.$emit('input');
      this.pauseVideo();
    },
    closeMediaViewerModal: function closeMediaViewerModal() {
      this.mediaViewerDialog = false;
    },
    closeDetailModal: function closeDetailModal() {
      this.viewPostDetailDialog = false;
    },
    pauseVideo: function pauseVideo() {
      var video = document.getElementById('previewVideo');
      if (video) {
        video.pause();
      }
    },
    viewMedia: function viewMedia(media, isVideo) {
      if (isVideo) {
        this.videoPlayer = true;
      } else {
        this.videoPlayer = false;
      }
      this.mediaItem = media;
      this.mediaViewerDialog = false;
      this.mediaViewerDialog = true;
    },

    sendMessage: function sendMessage(message) {
      var _this2 = this;

      if (!message) {
        this.$swal('Comment can\'t be empty');
      } else {
        __WEBPACK_IMPORTED_MODULE_9__postApi__["a" /* default */].csComment(this.postData._id, message).then(function (comment) {
          _this2.suggestionText = null;
          _this2.showSuggestEditBox = false;
          _this2.postData.cs_comments ? '' : _this2.postData.cs_comments = [];
          _this2.postData.cs_comments.push({
            comment: message,
            commentator: _this2.userObj.firstName,
            createdAt: __WEBPACK_IMPORTED_MODULE_11_moment___default()()
          });
          _this2.messages.push(comment);
        }).catch(function (error) {
          _this2.$swal({
            title: 'Can\'t Make Comments now, try again later',
            type: 'error',
            content: error
          });
        });
      }
    },
    sendClientMessage: function sendClientMessage(message) {
      var _this3 = this;

      if (!message) {
        this.$swal('Comment can\'t be empty');
      } else {
        __WEBPACK_IMPORTED_MODULE_9__postApi__["a" /* default */].clientComment(this.postData._id, message).then(function (comment) {
          _this3.postData.client_comments ? '' : _this3.postData.client_comments = [];
          _this3.postData.client_comments.push({
            comment: message,
            commentator: _this3.userObj.firstName,
            createdAt: __WEBPACK_IMPORTED_MODULE_11_moment___default()()
          });
          _this3.clientMessages.push(comment);
        }).catch(function (error) {
          _this3.$swal({
            title: 'Can\'t Make Comments now, try again later',
            type: 'error',
            content: error
          });
        });
      }
    },
    viewPostDetails: function viewPostDetails() {
      var _this4 = this;

      this.postDetails = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.postHistoryData);

      var _loop = function _loop(history) {
        if (_this4.currentUserRole <= _this4.userRoles.AD_STRATEGIST && history.mapInfluencer) {
          history.mappedInfluencerData = history.mapInfluencer;
        } else {
          history.mappedInfluencerData = null;
        }
        history.influencerData = history.influencer;

        history.clientReportAbuse = _this4.clientReportAbuseData.filter(function (item) {
          return history.draftId === item.draftPostId || history._id === item.draftPostId;
        });
        if (_this4.currentUserRole === _this4.userRoles.SUPER_ADMIN_HIGH) {
          history.overRideBySuperAdmin = true;
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.postDetails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var history = _step.value;

          _loop(history);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.viewPostDetailDialog = false;
      this.viewPostDetailDialog = true;
    },
    markMetadataTag: function markMetadataTag(ids) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to mark as metadata tagged?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(result) {
                    var data;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!result.value) {
                              _context.next = 10;
                              break;
                            }

                            data = ids.map(function (postID) {
                              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
                                id: postID,
                                metadataTagged: true
                              });
                            });
                            _context.next = 4;
                            return _this5.$store.dispatch('post/updatePostByIds', data);

                          case 4:
                            _this5.isLoading = false;

                            if (_this5.postUpdateStatus) {
                              _context.next = 8;
                              break;
                            }

                            _this5.$swal({
                              text: 'Error Metadata Tag.',
                              type: 'error'
                            });
                            return _context.abrupt('return');

                          case 8:
                            _this5.$swal({
                              text: 'Successfully Saved Metadata Tag.',
                              type: 'success'
                            });
                            _this5.closeModal();

                          case 10:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this5);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    abuseResolvePosts: function abuseResolvePosts(postIds) {
      var _this6 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon Confirmation, the latest edited version will be send to AM as abuse resolved.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_9__postApi__["a" /* default */].abuseResolvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this6.$swal({
              title: 'Error in abuse resolving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this6.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this6.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this6.$emit('input');
          _this6.$emit('postUpdated');
          _this6.closeModal();
        } else {}
      });
    },
    releaseAbuseResolvedPosts: function releaseAbuseResolvedPosts(postIds) {
      var _this7 = this;

      this.$swal({
        title: 'Are you sure?',
        html: '<b>Upon confirmation, the post will be released to client as abuse resolved.</b>',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_9__postApi__["a" /* default */].releaseAbuseResolvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this7.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this7.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this7.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is sent to client.',
            type: 'success'
          });

          _this7.$emit('input');
          _this7.$emit('postUpdated');
          _this7.closeModal();
        } else {}
      });
    },
    isIncludeInAbuseReport: function isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return false;
      var tmpArr = clientReportArr.map(function (item) {
        return item.postId;
      });
      var draftPostTmpArr = clientReportArr.map(function (item) {
        return item.draftPostId;
      });
      return tmpArr.includes(reportedDraftId) || draftPostTmpArr.includes(reportedDraftId);
    },
    openProposeDateDialog: function openProposeDateDialog() {
      this.proposeDateDialog = true;
    },
    closeProposeDateModal: function closeProposeDateModal() {
      this.proposeDateDialog = false;
    },
    openChooseDateDialog: function openChooseDateDialog() {
      this.chooseDateDialog = true;
    },
    closeChooseDateModal: function closeChooseDateModal() {
      this.chooseDateDialog = false;
    },
    invokeConfirmDateChange: function invokeConfirmDateChange() {
      this.confirmDate = this.postData.postDate;
      this.changeConfirmDate = true;
    },
    saveConfirmDate: function saveConfirmDate() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var saveData, payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this8.$refs.dateDialog.save(_this8.confirmDate);
                saveData = [{
                  id: _this8.post._id,
                  requestDate: null,
                  propose_dates: null,
                  postDate: _this8.confirmDate,
                  dateConfirmed: true,
                  status: _this8.postStatusConfig.APPROVE
                }];
                _context3.next = 4;
                return _this8.$store.dispatch('post/updatePostByIds', saveData);

              case 4:
                if (!_this8.postUpdateStatus) {
                  _context3.next = 14;
                  break;
                }

                _this8.$swal({
                  text: 'Successfully confirmed.',
                  type: 'success'
                });
                payload = {
                  id: _this8.post._id,
                  appLink: window.location.protocol + '//' + window.location.host + '/posts/internal/all-posts?campaignID=' + _this8.post.mainPost ? _this8.post.mainPost.campaignID : null + '&postID=' + _this8.post._id
                };
                _context3.next = 9;
                return _this8.$store.dispatch('post/sendClientAcceptPost', payload);

              case 9:
                if (!(_this8.postData.requestDate && _this8.postData.status === _this8.postStatusConfig.APPROVE)) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 12;
                return _this8.$store.dispatch('post/sendProposeDateAcceptedToClient', {
                  id: _this8.post._id,
                  postDate: _this8.confirmDate
                });

              case 12:
                _this8.closeModal();
                if (_this8.postData.status === _this8.postStatusConfig.APPROVE) {
                  _this8.$emit('postUpdated');
                } else {
                  _this8.$router.push({ path: '/posts/internal/approved' });
                }

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    },
    setMultipleInfs: function setMultipleInfs(postData) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var infs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                infs = [];
                _context4.next = 3;
                return _this9.$store.dispatch('influencer/getInfluencerDetail', {
                  id: postData.influencerID
                });

              case 3:
                if (_this9.infDetail.instagram) {
                  infs.push({
                    handle: _this9.infDetail.instagram.instagramHandle,
                    instagramID: _this9.infDetail.instagram.instagramID,
                    picture: _this9.infDetail.audience ? _this9.infDetail.audience.user_profile.picture : _this9.infDetail.instagram.picture,
                    instagram: true
                  });
                  if (postData.submitedBy && !_this9.mappedInfluencerData) {
                    if (!_this9.influencerData.platform || postData.submitedBy.instagramHandle) {
                      infs[infs.length - 1].default = true;
                      _this9.postData.defaultInf = infs[infs.length - 1];
                    }
                  }
                }
                if (_this9.infDetail.tiktok) {
                  infs.push({
                    handle: _this9.infDetail.tiktok.tiktokHandle,
                    tiktokID: _this9.infDetail.tiktok.tiktokID,
                    picture: _this9.infDetail.tiktokaudience ? _this9.infDetail.tiktokaudience.user_profile.picture : _this9.infDetail.tiktok.picture,
                    tiktok: true
                  });
                  if (postData.submitedBy && !_this9.mappedInfluencerData) {
                    if (!_this9.influencerData.platform || postData.submitedBy.tiktokHandle) {
                      infs[infs.length - 1].default = true;
                      _this9.postData.defaultInf = infs[infs.length - 1];
                    }
                  }
                }
                if (_this9.infDetail.youtube) {
                  infs.push({
                    handle: _this9.infDetail.youtube.youtubeHandle,
                    youtubeID: _this9.infDetail.youtube.youtubeID,
                    picture: _this9.infDetail.youtubeaudience ? _this9.infDetail.youtubeaudience.user_profile.picture : _this9.infDetail.youtube.picture,
                    youtube: true
                  });
                  if (postData.submitedBy && !_this9.mappedInfluencerData) {
                    if (!_this9.influencerData.platform || postData.submitedBy.youtubeHandle) {
                      infs[infs.length - 1].default = true;
                      _this9.postData.defaultInf = infs[infs.length - 1];
                    }
                  }
                }
                if (_this9.infDetail.linkedin) {
                  infs.push({
                    handle: _this9.infDetail.linkedin.linkedinHandle,
                    linkedinID: _this9.infDetail.linkedin.linkedinID,
                    picture: _this9.infDetail.linkedin.profilePicture,
                    linkedin: true
                  });
                  if (postData.submitedBy && !_this9.mappedInfluencerData && postData.submitedBy.linkedinHandle) {
                    infs[infs.length - 1].default = true;
                    _this9.postData.defaultInf = infs[infs.length - 1];
                  }
                }
                _this9.postData.influencers = infs;
                _this9.postData = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.refreshJSON(_this9.postData);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    changePlatform: function changePlatform(inf, index) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this10.isLoading = true;
                _context5.next = 3;
                return _this10.$store.dispatch('post/updatePostOwner', {
                  postID: _this10.postData._id,
                  owner: inf,
                  type: 'submitted_by'
                });

              case 3:
                if (_this10.postUpdateStatus) {
                  _this10.postData.defaultInf = _this10.postData.influencers[index];
                  _this10.postData = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.refreshJSON(_this10.postData);
                }
                _this10.isLoading = false;
                _this10.$emit('postUpdated');

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this10);
      }))();
    },
    loadCampaign: function loadCampaign(post) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var hashTags;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this11.$store.dispatch('campaign/getCampaignDetail', post.campaignID);

              case 2:
                hashTags = __WEBPACK_IMPORTED_MODULE_19__Campaign_campaignHelper__["a" /* default */].getMandatoryHashtagMentions(_this11.campaign);

                _this11.postData.mandatoryHashtag = hashTags;
                _this11.postData.callToActionLinks = _this11.campaign.callToActionLinks || '';
                _this11.postData = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].func.refreshJSON(_this11.postData);

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this11);
      }))();
    },
    changePostType: function changePostType(typeVal) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var updateData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this12.isLoading = true;
                updateData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, typeVal);

                updateData.postID = _this12.postData._id;
                _context7.next = 5;
                return _this12.$store.dispatch('post/updatePostTypes', updateData);

              case 5:
                if (_this12.postUpdateStatus) {
                  _this12.postData.type = typeVal.type;
                  _this12.postData.typeName = typeVal.typeName;
                }
                _this12.isLoading = false;

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this12);
      }))();
    },
    renderHTML: function renderHTML(text) {
      if (text !== undefined && text !== null && text !== '') {
        if (/<[a-z][\s\S]*>/i.test(text)) {
          return __WEBPACK_IMPORTED_MODULE_6_dompurify___default.a.sanitize(text);
        }
        return text.replace(/\n/g, '<br>');
      }
      return '-';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapState */])({
    campaign: function campaign(state) {
      return state.campaign.campaignDetail;
    },
    postUpdateStatus: function postUpdateStatus(state) {
      return state.post.updated;
    },
    infDetail: function infDetail(state) {
      return state.influencer.infDetail;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].postStatus;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles;
    },
    commentToLabel: function commentToLabel() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER) {
        return 'Message to Content Strategist';
      } else if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        return 'Message to Influencer';
      } else {
        return '';
      }
    },
    conversationWithName: function conversationWithName() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER) {
        return 'Comments';
      } else if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        return 'Comments';
      } else {
        return 'Conversations between KOBE and Creator';
      }
    },
    isVideoLink: function isVideoLink() {
      return this.postData.type === 'story' || this.postData.type === 'video' || this.postData.type === 'reel' || this.postData.type === 'tiktok' || this.postData.type === 'youtube' || this.postData.type === 'facebook';
    },
    isRemark: function isRemark() {
      return this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER;
    },
    isHashTag: function isHashTag() {
      return this.postData.mandatoryHashtag && (this.currentUserRole <= __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER && this.postData.status === this.postStatusConfig.APPROVE);
    },
    isCallToActionLinks: function isCallToActionLinks() {
      return this.postData.callToActionLinks && (this.currentUserRole <= __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.INFLUENCER && this.postData.status === this.postStatusConfig.APPROVE);
    },

    isClient: function isClient() {
      return Number(this.$store.state.user.role) === __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].userRoles.CLIENT;
    },
    mainViewGrid: function mainViewGrid() {
      var col = 12;
      if (this.postAbuseHistory && this.clientReportAbuse.length > 0) col -= 3;
      if (this.postAbuseHistory && this.postHistoryData.length > 0) col -= 3;
      return col;
    },
    captionLabel: function captionLabel() {
      return this.postData.type === 'story' ? 'Story Caption' : 'Caption';
    },
    overlayType: function overlayType() {
      if (this.isIGCutOff) {
        return 'IG';
      }
      if (this.isIGStory) {
        return 'IGStory';
      }
      if (this.isTikTokCutOff) {
        return 'TikTok';
      }
      return '';
    },
    showCutOffView: function showCutOffView() {
      if (Array.isArray(this.images)) {
        var totalMedias = this.images.length;
        var totalImgs = this.images.filter(function (i) {
          return !i.isvideo;
        }).length;
        if (totalMedias === totalImgs) {
          return false;
        }
      }
      return true;
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(68)))

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditPost_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditPost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__EditPost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Influencer_paymentAPIs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_platformDisplay__ = __webpack_require__(141);


































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Posts Index View',
  components: {
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_13__ViewPostModal_vue___default.a,
    AssignCampaignModal: __WEBPACK_IMPORTED_MODULE_15__AssignCampaignModal_vue___default.a,
    MapInfluencerModal: __WEBPACK_IMPORTED_MODULE_16__MapInfluencerModal_vue___default.a,
    EditPostModal: __WEBPACK_IMPORTED_MODULE_14__EditPost_vue___default.a,
    SubmissionReviewMultipleModal: __WEBPACK_IMPORTED_MODULE_17__SubmissionReviewMultiple_vue___default.a,
    AddPostToCampaign: __WEBPACK_IMPORTED_MODULE_25__scoped_campaign_AddPostToCampaign___default.a,
    ChangePostStatusModal: __WEBPACK_IMPORTED_MODULE_27__ChangePostStatusModal___default.a,
    ClientChooseDateModal: __WEBPACK_IMPORTED_MODULE_18__ClientChooseDateModal_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_29__scoped_custom_CustomMediaV2___default.a
  },
  data: function data() {
    return {
      posts: [],
      groupedPosts: [],
      rating: 3,
      viewChooseDatePost: {},
      filter: {
        instagramHandle: null,
        campaignName: null,
        campaignID: null,
        clientID: null,
        today: false,
        story: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 6
      },
      postFilter: null,
      showPostLayout: false,
      totalItems: 0,
      instagramHandleList: [],
      clients: [],
      rowsPerPage: [6, 12, 18, 26, { text: 'All', value: -1 }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      viewPostDialog: false,
      editPostDialog: false,
      chooseDateDialog: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      submissionReviewMultipleDialog: false,
      showCsEditAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      show_client_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      showPostHistory: false,
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      menuOptions: [],
      tableActions: [],
      selected: [],
      display: '',
      isFirstLoad: true,
      headers: [{ text: 'Campaign', value: 'campaignName', sortable: true }, { text: 'Influencer', value: 'submittedBy', sortable: true }, { text: 'Status', value: 'status', sortable: false }, { text: 'Submitted At', value: 'createdAt', sortable: true }, { text: 'Actions', sortable: false }],
      showConnectionError: false,
      loading: false,
      page: 1,
      addPostToCampaign: false,
      campaignDataForAddPost: null,
      postIdToUpdate: null,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      campaignHelper: __WEBPACK_IMPORTED_MODULE_28__Campaign_campaignHelper__["a" /* default */]
    };
  },

  watch: {
    posts: function posts(newPosts) {
      var tmpArr = [];
      newPosts.forEach(function (post) {
        tmpArr.push(post.author.instagramHandle);
      });
      this.instagramHandleList = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_set___default.a(tmpArr));
    },
    postStatus: function postStatus() {
      this.getPosts();
    },
    pagging: function pagging(previous, after) {
      if (__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(previous) !== __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_json_stringify___default()(after)) {
        this.getPosts();
      }
    },
    selected: function selected() {
      this.validateTableActions(this.selected);
    },
    $route: function $route() {
      this.viewPostByRouter();
    }
  },
  methods: {
    getTwitterHandle: function getTwitterHandle(post) {
      var author = post.author || {};
      if (author.twitterHandle) return author.twitterHandle;
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER && post.influencerID === this.user.influencerID) {
        if (this.user.twitterHandle) return this.user.twitterHandle;
        var selectedPlatform = this.$store.state.showActivePlatform;
        if (selectedPlatform && selectedPlatform.platform === 'twitter') {
          return selectedPlatform.handle.replace(/^@/, '');
        }
      }
      return author.instagramHandle || '';
    },
    openViewPostLayout: function openViewPostLayout(campaignName, campaignId, owner) {
      this.showPostLayout = true;
      var postFilter = {};
      if (campaignId) {
        postFilter.campaignId = campaignId;
      } else {
        this.filter.campaignID = null;
      }
      if (owner) {
        if (owner.tiktokHandle) {
          if (owner.tiktokHandle) {
            postFilter.tiktokHandle = owner.tiktokHandle;
          }
          if (owner.tiktokID) {
            postFilter.tiktokId = owner.tiktokID;
          }
        } else if (owner.youtubeHandle) {
          if (owner.youtubeHandle) {
            postFilter.youtubeHandle = owner.youtubeHandle;
          }
          if (owner.youtubeID) {
            postFilter.youtubeId = owner.youtubeID;
          }
        } else {
          if (owner.instagramHandle) {
            postFilter.instagramHandle = owner.instagramHandle;
          }
          if (owner.instagramID) {
            postFilter.instagramId = owner.instagramID;
          }
        }
      }
      this.postFilter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, postFilter);
      this.getPosts();
    },
    closeViewPostLayout: function closeViewPostLayout() {
      this.showPostLayout = false;
      this.posts = [];

      this.postFilter = null;
    },
    changePostStatus: function changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changeStatusDialog = true;
    },
    postAdded: function postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
    },
    bulkApprove: function bulkApprove() {
      var _this = this;

      if (this.selected.length > 0) {
        this.$swal({
          title: 'Terms and Agreements',
          html: '<p class="text-xs-left subtitle-1">Please note that the content creator reserves full creative rights to the final execution of the post and will only do 1 shoot based on the brief approved by the client. Drafts sent to clients for vetting are for the sole purpose of fact-checking and stylistic changes will not be allowed. The client is entitled to only 1 revision. </p>',
          type: 'info',
          width: 500,
          backdrop: 'rgba(0,0,1, 0.7)',
          showCancelButton: true,
          confirmButtonText: 'Agree',
          cancelButtonText: 'Disagree',
          allowOutsideClick: false
        }).then(function (result) {
          if (result.value) {
            _this.submissionReviewMultipleDialog = true;
          }
        });
      }
    },
    resetFilter: function resetFilter() {
      this.filter = {
        instagramHandle: null,
        campaignName: null,
        clientID: null,
        today: false,
        story: false
      };
      this.getPosts();
    },
    assignedCampaign: function assignedCampaign() {
      this.getPosts();
    },
    influencerMapSuccess: function influencerMapSuccess() {
      this.getPosts();
    },
    validateTableActions: function validateTableActions(selected) {
      var disableApproveBtn = false;
      var disableReleaseBtn = false;
      if (!selected || selected.length === 0) {
        this.tableActions = this.tableActions.map(function (item) {
          item.disabled = true;
          return item;
        });
        return;
      }
      var disableAcceptBtn = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(selected), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (!item.campaignID || !item.postDate || item.waiting_release || item.status !== this.postStatusConfig.AD_STRATEGIST_PENDING) {
            disableApproveBtn = true;
          }
          if (!item.waiting_release) {
            disableReleaseBtn = true;
          }
          if (item.status !== this.postStatusConfig.CLIENT_PENDING) {
            disableAcceptBtn = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(this.tableActions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var act = _step2.value;

          if (act.action === 'csApprove') {
            act.disabled = disableApproveBtn;
          } else if (act.action === 'saleApprove') {
            act.disabled = disableReleaseBtn;
          } else if (act.action === 'clientApprove') {
            act.disabled = disableAcceptBtn;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    performSelected: function performSelected(action) {
      var ids = this.selected.map(function (item) {
        return item._id;
      });
      switch (action) {
        case 'saleApprove':
          this.releasePosts(ids);
          break;
        case 'csApprove':
          this.approvePosts(ids);
          break;
        case 'clientApprove':
          this.bulkApprove();
          break;
      }
    },
    pageChanged: function pageChanged() {
      this.pagging.page = this.page;
      this.getPosts();
    },
    isIncludeInAbuseReport: function isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      var tmpArr = clientReportArr.map(function (item) {
        return item.draftPostId;
      });
      return tmpArr.includes(reportedDraftId);
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */]['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    filterMenuOptions: function filterMenuOptions() {
      var _this2 = this;

      var options = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(function (option) {
          return _this2.buttonShow(option.action);
        });
      }
    },
    filterTableActions: function filterTableActions() {
      var _this3 = this;

      var options = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(function (option) {
          return _this3.buttonShow(option.action);
        });
      }
      this.tableActions = this.tableActions.map(function (item) {
        item.disabled = true;
        return item;
      });
    },
    actionPostBy: function actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'clientApproveDate':
          this.openChooseDateDialog(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    getPosts: function getPosts() {
      var _this4 = this;

      if (!this.postFilter) {
        return;
      }
      var status = this.postStatus;
      this.loading = true;
      var query = __WEBPACK_IMPORTED_MODULE_22__utils__["a" /* default */].func.clean(this.postFilter);
      query.status = status;
      query.sortBy = this.pagging.sortBy && this.pagging.sortBy.length > 0 ? this.pagging.sortBy[0] : null;
      query.descending = this.pagging.sortDesc && this.pagging.sortDesc.length > 0 ? this.pagging.sortDesc[0] : null;
      __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getPost(query).then(function (resp) {
        _this4.posts = [];
        _this4.selected = [];
        _this4.loading = false;
        _this4.showConnectionError = false;
        var posts = resp.posts;
        var totalItems = resp.totalItems;
        _this4.totalItems = totalItems;
        posts = posts.map(function (post) {
          post.labels = _this4.getPostLabels(post);
          post.author = post.mapInfluencer || post.submitedBy || _this4.defaultPoster;
          return post;
        });
        if (query.tiktokHandle) {
          var handle = query.tiktokHandle;
          posts = posts.filter(function (post) {
            return post.author && post.author.tiktokHandle === handle;
          });
        }
        if (query.instagramHandle) {
          var _handle = query.instagramHandle;
          posts = posts.filter(function (post) {
            return post.author && post.author.instagramHandle === _handle;
          });
        }
        setTimeout(function () {
          _this4.posts = posts;
        }, 0);
        if (_this4.$route.query.postID) {
          var matchPost = posts.find(function (p) {
            return p._id === _this4.$route.query.postID;
          });
          if (matchPost) {
            _this4.viewDetailPost(matchPost);
          }
        }
      }).catch(function (err) {
        _this4.showConnectionError = true;
        _this4.loading = false;
        console.error(err);
      });
      this.filterMenuOptions();
      this.filterTableActions();
    },
    getGroupedPosts: function getGroupedPosts() {
      var _this5 = this;

      var status = this.postStatus;
      this.loading = true;
      var query = __WEBPACK_IMPORTED_MODULE_22__utils__["a" /* default */].func.clean(this.filter);
      query.status = status;
      this.posts = [];

      __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getGroupedPosts(query).then(function (resp) {
        _this5.groupedPosts = [];
        _this5.selected = [];
        _this5.loading = false;
        _this5.showConnectionError = false;
        var groupedPosts = resp.posts;
        _this5.groupedPosts = groupedPosts;
      }).catch(function (err) {
        _this5.showConnectionError = true;
        _this5.loading = false;
        console.error(err);
      });
    },
    getClients: function getClients() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_21__Client_clientAPIs__["a" /* default */].getAllClients().then(function (resp) {
        var clients = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], resp.data);
        clients.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
        _this6.clients = [{ name: 'All', id: null }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(clients));
      });
    },
    reloadPostView: function reloadPostView(postData) {
      this.viewDetailPost(postData);
    },
    viewDetailPost: function viewDetailPost(post) {
      var _this7 = this;

      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status <= __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) && post.campaignID) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT && post.campaignID) {
        this.show_client_inf_chatbox = true;
      } else {
        this.show_client_inf_chatbox = false;
      }
      if (post.clientReportAbuse && this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER && post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.AD_STRATEGIST) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id).then(function (post) {
        _this7.viewPostData = post;
        _this7.$store.dispatch('post/updatePostViewUser', { postID: post._id });
        _this7.viewPostDialog = true;
      });
    },

    editPostFromView: function editPostFromView(post) {
      this.editPost(post);
    },
    exec: function exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    getPostLabels: function getPostLabels(post) {
      var labels = [];
      if (this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.AD_STRATEGIST) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }

      if (!post.waiting_release && this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE && this.currentUserRole !== this.userRoles.INFLUENCER && post.propose_dates) {
        labels.push({
          text: 'Propose Dates Available',
          icon: 'warning',
          outlined: true,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE && this.currentUserRole !== this.userRoles.INFLUENCER && post.requestDate && !post.propose_dates) {
        labels.push({
          text: 'Live Date Change Requested',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'secondary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'black',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'primary',
              action: 'viewDetailPost'
            });
          }
        }
      }

      if (post.comments && this.postStatus < this.postStatusConfig.APPROVE && (this.currentUserRole === this.userRoles.INFLUENCER || this.currentUserRole === this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        labels.push({
          text: '(' + this.commentsInfo(post.comments) + ') Comments',
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: '' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: 'Today - ' + this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: false,
            dark: true,
            color: 'green',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'green',
            action: 'viewDetailPost'
          });
        }
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER && (this.postStatus === this.postStatusConfig.APPROVE || this.postStatus === this.postStatusConfig.LIVE)) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      if (post.type) {
        labels.push({
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__utils_platformDisplay__["a" /* platformDisplayName */])(post.type),
          color: 'primary',
          action: 'viewDetailPost'
        });
      }
      if (post.metadataTagged) {
        labels.push({
          text: 'Metadata Tagged',
          faIcon: 'fa fa-tag',
          color: 'blue',
          outlined: true,
          action: 'viewDetailPost'
        });
      }
      return labels;
    },
    editPost: function editPost(post) {
      this.editPostData = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, post);

      this.editPostDialog = true;
      this.getPosts();
    },
    assignCampaignToPost: function assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost: function mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    paserImageUrl: function paserImageUrl(url) {
      if (url) {
        var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    paserAudienceImageUrl: function paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },

    csApproveFromView: function csApproveFromView(post) {
      this.csApprovePost(post);
    },
    csApprovePost: function csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (!post.postDate) {
        this.$swal({
          title: 'Edit the post publishing date first before sending to client.',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from sale person.',
          type: 'info'
        });
      } else {
        var id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts: function approvePosts(postIds) {
      var _this8 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM person for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].approvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this8.$swal({
              title: 'Error in approving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this8.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this8.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from sale person.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this8.$emit('input');
          _this8.getPosts();
          _this8.viewPostDialog = false;
        } else {}
      });
    },
    saleReleasePost: function saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CS yet',
          type: 'warning'
        });
      } else {
        var id = post._id;
        this.releasePosts([id]);
      }
    },
    releasePosts: function releasePosts(postIds) {
      var _this9 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].releasePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this9.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this9.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this9.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });

          _this9.getPosts();
          _this9.$emit('input');
          _this9.viewPostDialog = false;
        } else {}
      });
    },
    startSubmissionReview: function startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout: function submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL: function enterPostURL(post) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_26__Campaign_campaignAPIs__["a" /* default */].getCampaign(post.campaignID).then(function (response) {
        _this10.campaignDataForAddPost = response;
        _this10.postIdToUpdate = post._id;
        _this10.addPostToCampaign = true;
      }).catch(function (err) {
        _this10.addPostToCampaign = true;
        _this10.$swal({
          type: 'error',
          title: 'Error Getting Campaign Information'
        });
        console.log(err);
      });
    },
    assignPostURL: function assignPostURL(post) {
      var _this11 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].publishPost(post._id, result.value).then(function () {
            _this11.$swal({
              title: postConfirmationText['confirm']['title'],
              text: 'Do you want to submit payout?',
              type: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then(function (confirmed) {
              if (confirmed.value) {
                var payout = {
                  campaignName: post.campaignName,
                  campaignID: post.campaignID,
                  postID: post._id,
                  influencerID: post.influencerID,
                  instagramPostURL: result.value,
                  otherSocialMediaPostUrl: '',
                  satisfactionLevel: 0,
                  advertiserSatisfactionLevel: 0
                };
                __WEBPACK_IMPORTED_MODULE_24__Influencer_paymentAPIs__["a" /* default */].createCampaignPayout(payout).then(function () {
                  _this11.$swal({
                    type: 'success',
                    title: 'Campaign payout created!'
                  });
                }).catch(function () {
                  _this11.$swal({
                    type: 'error',
                    title: 'Cannot create campaign payout for this post. Try again later!'
                  });
                });
              }
            });
            _this11.getPosts();
          }).catch(function () {
            _this11.$swal({
              type: 'error',
              title: 'Error in processing your request! Please try again'
            });
          });
        }
      });
    },
    completePost: function completePost(post) {
      var _this12 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_19__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].completePost(post._id).then(function () {
            _this12.$swal({
              type: 'success',
              title: postConfirmationText['confirm']['title'],
              text: postConfirmationText['confirm']['text']
            }).then(function () {
              _this12.getPosts();
            });
          }).catch(function (error) {
            return _this12.$swal({
              type: 'error',
              text: error
            });
          });
        }
      });
    },
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';

      return __WEBPACK_IMPORTED_MODULE_23_moment___default()(date).format(format);
    },
    checkAfter: function checkAfter(date) {
      return __WEBPACK_IMPORTED_MODULE_23_moment___default()(this.currentDate).isAfter(date);
    },
    checkSame: function checkSame(date) {
      return __WEBPACK_IMPORTED_MODULE_23_moment___default()(this.currentDate).isSame(date);
    },
    fetchPost: function fetchPost(postId, returnData) {
      var _this13 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getPostById(postId).then(function (post) {
          resolve(post);
        }).catch(function (err) {
          _this13.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
          reject(err);
        });
      });
    },
    commentsInfo: function commentsInfo(comments) {
      var _this14 = this;

      if (comments === undefined) {
        return;
      } else {
        var commentsArr = comments.filter(function (comment) {
          return comment.author.id !== _this14.user.id;
        });
        return commentsArr.length;
      }
    },
    viewPostByRouter: function viewPostByRouter() {
      var _this15 = this;

      var action = this.$route.query.action;
      var id = this.$route.query.id;
      if (action === 'view' && id) {
        __WEBPACK_IMPORTED_MODULE_20__postApi__["a" /* default */].getPostById(id).then(function (post) {
          _this15.viewDetailPost(post);
        }).catch(function (err) {
          _this15.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
        });
      } else {
        this.LoadPosts();
      }
    },
    LoadPosts: function LoadPosts() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this16.currentUserRole !== _this16.userRoles.CLIENT && _this16.currentUserRole !== _this16.userRoles.INFLUENCER)) {
                  _context.next = 7;
                  break;
                }

                _this16.getClients();
                _this16.getGroupedPosts();
                _this16.openViewPostLayout();
                _this16.viewPostByRouter();
                _context.next = 14;
                break;

              case 7:
                _this16.getGroupedPosts();
                _this16.openViewPostLayout();

                if (!(_this16.currentUserRole === _this16.userRoles.CLIENT)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return _this16.$store.dispatch('campaign/getCampaigns', {
                  filters: {
                    clientID: _this16.user.clientID
                  }
                });

              case 12:
                _this16.filterCampaigns = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], _this16.campaigns);
                _this16.filterCampaigns.unshift({ id: '', name: 'All Campaigns' });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this16);
      }))();
    },
    searchFilter: function searchFilter() {
      if (!this.showPostLayout) {
        this.getGroupedPosts();
      } else {
        this.openViewPostLayout(null, this.filter.campaignID, this.filter);
      }
    },
    showAvailableMenu: function showAvailableMenu(post, action) {
      if (this.currentUserRole === this.userRoles.CLIENT) {
        if (action === 'clientReview' && post.status === this.postStatusConfig.CLIENT_PENDING && post.propose_dates) {
          return false;
        }
        if (action === 'clientApproveDate' && post.status === this.postStatusConfig.APPROVE && !post.propose_dates) {
          return false;
        }
      }
      return true;
    },
    openChooseDateDialog: function openChooseDateDialog(post) {
      this.viewChooseDatePost = post;
      this.chooseDateDialog = true;
    },
    closeChooseDateModal: function closeChooseDateModal() {
      this.chooseDateDialog = false;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
    campaigns: function campaigns(state) {
      return state.campaign.campaigns;
    }
  }), {
    user: function user() {
      return this.$store.state.user;
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function postStatus() {
      return this.$route.meta.postStatus;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles;
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].postStatus;
    },
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_23_moment___default()().format('ll');
    },
    paginationLength: function paginationLength() {
      var round = this.totalItems / this.pagging.itemsPerPage;
      var decimal = this.totalItems % this.pagging.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    }
  }),
  mounted: function mounted() {
    this.LoadPosts();
    if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].userRoles.CLIENT) {
      this.display = 0;
    } else {
      this.display = 1;
    }
  }
});

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__postApi__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Campaign_campaignAPIs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Influencer_paymentAPIs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditPost_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditPost_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__EditPost_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ViewPostModal_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ViewPostModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ViewPostModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AssignCampaignModal_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AssignCampaignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__AssignCampaignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MapInfluencerModal_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MapInfluencerModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__MapInfluencerModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SubmissionReviewMultiple_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SubmissionReviewMultiple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__SubmissionReviewMultiple_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scoped_campaign_AddPostToCampaign__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scoped_campaign_AddPostToCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__scoped_campaign_AddPostToCampaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ChangePostStatusModal__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ChangePostStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ChangePostStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Campaign_campaignHelper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_custom_CustomMediaV2__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scoped_custom_CustomMediaV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__scoped_custom_CustomMediaV2__);































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cocreating_Status_Report',
  components: {
    ViewPostModal: __WEBPACK_IMPORTED_MODULE_17__ViewPostModal_vue___default.a,
    EditPostModal: __WEBPACK_IMPORTED_MODULE_16__EditPost_vue___default.a,
    AddPostToCampaign: __WEBPACK_IMPORTED_MODULE_23__scoped_campaign_AddPostToCampaign___default.a,
    ChangePostStatusModal: __WEBPACK_IMPORTED_MODULE_24__ChangePostStatusModal___default.a,
    AssignCampaignModal: __WEBPACK_IMPORTED_MODULE_20__AssignCampaignModal_vue___default.a,
    MapInfluencerModal: __WEBPACK_IMPORTED_MODULE_21__MapInfluencerModal_vue___default.a,
    SubmissionReviewMultipleModal: __WEBPACK_IMPORTED_MODULE_22__SubmissionReviewMultiple_vue___default.a,
    CustomMediaV2: __WEBPACK_IMPORTED_MODULE_26__scoped_custom_CustomMediaV2___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_18_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      showConnectionError: false,
      loading: false,
      campaigns: [],
      clients: [],
      filter: {
        instagramHandle: '',
        campaignID: '',
        clientID: '',
        filterStatus: '',
        status: [__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING, __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.CLIENT_PENDING, __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE]
      },
      reportData: [{
        campaignName: 'New Campaign',
        influencers: [{
          handle: 'N/A',
          submissionDate: '15/9/21',
          submittedDate: '16/9/21',
          status: 'Pending Client',
          deliverable: 'IGP'
        }]
      }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      viewPostDialog: false,
      editPostDialog: false,
      showCsEditAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      addPostToCampaign: false,
      showPostHistory: false,
      viewPostData: {},
      viewScreenShotsDialog: false,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      imagesToView: [],
      campaignHelper: __WEBPACK_IMPORTED_MODULE_25__Campaign_campaignHelper__["a" /* default */],
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      pagging: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
        groupDesc: false
      },

      statusReportHeaders: [{
        'text': 'Campaign',
        'align': 'start',
        'value': 'campaignName',
        'sortable': false
      }, {
        'text': 'Handle',
        'align': 'start',
        'value': 'handle',
        'sortable': false
      }, {
        'text': 'Status',
        'align': 'start',
        'value': 'status',
        'sortable': false
      }, {
        'text': 'Post Status',
        'align': 'start',
        'value': 'postStatus',
        'sortable': false
      }, {
        'text': 'Submission Date',
        'align': 'start',
        'value': 'submissionDate',
        'sortable': false
      }, {
        'text': 'Live Date',
        'align': 'start',
        'value': 'submittedDate',
        'sortable': false
      }, {
        'text': 'Format',
        'align': 'start',
        'value': 'format',
        'sortable': true
      }, {
        'text': 'Payout Due Date',
        'align': 'start',
        'value': 'payoutDueDate',
        'sortable': false
      }, {
        'text': 'Action',
        'align': 'start',
        'value': 'action',
        'sortable': false
      }]
    };
  },

  watch: {
    pagging: function pagging(newValue) {
      this.filter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.filter, newValue);
      this.getStatusReport();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
    user: function user() {
      return this.$store.state.user;
    },
    userRoles: function userRoles() {
      return __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles;
    },
    currentUserID: function currentUserID() {
      return this.$store.state.user.id;
    },
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    postStatusConfig: function postStatusConfig() {
      return __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus;
    },
    statuses: function statuses() {
      return __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].postFilterStatuses.filter(function (filterStatus) {
        return filterStatus.value !== __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].postFilterStatus.ABUSE_PENDING_RELEASE;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    postUpdateStatus: function postUpdateStatus(state) {
      return state.post.updated;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resp, clientResp, clientIDs;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('mounted');
              _context.prev = 1;

              if (_this.$route.query.handle) {
                _this.filter.instagramHandle = _this.$route.query.handle;
              }
              if (_this.$route.query.campaignID) {
                _this.filter.campaignID = _this.$route.query.campaignID;
              }
              _this.filter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, _this.filter, _this.pagging);
              _this.resetPaging();
              _this.getStatusReport();
              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_12__Campaign_campaignAPIs__["a" /* default */].getUnfinishedCampaigns();

            case 9:
              resp = _context.sent;

              _this.campaigns = [{ id: '', name: 'All Campaigns' }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(resp));
              _context.next = 13;
              return __WEBPACK_IMPORTED_MODULE_13__Client_clientAPIs__["a" /* default */].getAllClients();

            case 13:
              clientResp = _context.sent;

              _this.clients = clientResp.data;
              clientIDs = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(_this.campaigns.map(function (c) {
                return c.clientID;
              }))));

              _this.clients = _this.clients.filter(function (b) {
                return clientIDs.includes(b.id);
              });
              _this.clients.unshift({ id: '', name: 'All Clients' });
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context['catch'](1);

              console.log(_context.t0);
              _this.$swal({
                text: 'Cannot fetch required data!',
                icon: 'error'
              });

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 20]]);
    }))();
  },

  methods: {
    getStatusReport: function getStatusReport() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].getStatusReportData(_this2.filter);

              case 3:
                resp = _context2.sent;

                _this2.reportData = resp.posts;
                _this2.pagging.totalItems = resp.totalItems;
                _this2.reportData = _this2.reportData.map(function (post) {
                  post.labels = _this2.getPostLabels(post);
                  post.author = post.author || _this2.defaultPoster;
                  post.postStatus = _this2.loadPostStatusDisplay(post);
                  return post;
                });
                _this2.getAllCampaignPayouts();
                _this2.loading = false;
                _this2.filterTableActions();
                _this2.filterMenuOptions();

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadPostStatusDisplay: function loadPostStatusDisplay(newPost) {
      return __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatusDisplayInternal[newPost.status].display;
    },
    getPostLabels: function getPostLabels(post) {
      var labels = [];
      if (post.status === this.postStatusConfig.AD_STRATEGIST_PENDING) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release && !post.abuse_resolved) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.abuse_resolved) {
        labels.push({
          text: 'Pending to release',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }

      if (!post.waiting_release && post.status === this.postStatusConfig.AD_STRATEGIST_PENDING) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && !post.abuse_resolved && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (post.status === this.postStatusConfig.CLIENT_PENDING && !post.abuse_resolved && !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'grey',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'primary'
            });
          }
        }
      }

      if (post.status === this.postStatusConfig.APPROVE && !post.postURL) {
        labels.push({
          text: 'Approved',
          icon: 'assignment_turned_in',
          color: 'primary'
        });
      }

      if (post.postURL) {
        labels.push({
          text: 'Post URL Added',
          icon: 'check',
          color: 'green'
        });
      }
      if (post.hasReport) {
        labels.push({
          text: 'Present in Campaign Report',
          icon: 'check',
          color: 'primary'
        });
      }
      return labels;
    },
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';

      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(date).format(format);
    },
    checkAfter: function checkAfter(date) {
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(this.currentDate).isAfter(date);
    },
    checkSame: function checkSame(date) {
      return __WEBPACK_IMPORTED_MODULE_19_moment___default()(this.currentDate).isSame(date);
    },
    isIncludeInAbuseReport: function isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      var tmpArr = clientReportArr.map(function (item) {
        return item.draftPostId;
      });
      return tmpArr.includes(reportedDraftId);
    },
    search: function search() {
      this.resetPaging();
      this.getStatusReport();
    },
    viewDetailPost: function viewDetailPost(post) {
      var _this3 = this;

      if (post.status < __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.CLIENT_PENDING && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE && this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.AD_STRATEGIST || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.INFLUENCER) && post.campaignID) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (post.clientReportAbuse) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE || post.status === __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.LIVE && this.currentUserRole !== __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id).then(function (post) {
        _this3.viewPostData = post;
      });
      this.viewPostDialog = true;
    },
    fetchPost: function fetchPost(postId) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].getPostById(postId).then(function (post) {
          resolve(post);
        }).catch(function (err) {
          _this4.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
          reject(err);
        });
      });
    },

    csApproveFromView: function csApproveFromView(post) {
      this.csApprovePost(post);
    },
    csApprovePost: function csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (!post.postDate) {
        this.$swal({
          title: 'Edit the post publishing date first before sending to client.',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from AM.',
          type: 'info'
        });
      } else {
        var id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts: function approvePosts(postIds) {
      var _this5 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].approvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this5.$swal({
              title: 'Error in approving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this5.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this5.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this5.$emit('input');
          _this5.getStatusReport();
          _this5.viewPostDialog = false;
        } else {}
      });
    },
    abuseResolvePosts: function abuseResolvePosts(postIds) {
      var _this6 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM for abuse resolved',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].abuseResolvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this6.$swal({
              title: 'Error in abuse resolving Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this6.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this6.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });

          _this6.$emit('input');
          _this6.getPosts();
          _this6.viewPostDialog = false;
        } else {}
      });
    },
    releaseAbuseResolvedPosts: function releaseAbuseResolvedPosts(postIds) {
      var _this7 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be released to client as abuse resolved',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].releaseAbuseResolvePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this7.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this7.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this7.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is sent to client.',
            type: 'success'
          });

          _this7.$emit('input');
          _this7.getPosts();
          _this7.viewPostDialog = false;
        } else {}
      });
    },
    saleReleasePost: function saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CC yet',
          type: 'warning'
        });
      } else {
        var id = post._id;
        this.releasePosts([id]);
      }
    },
    releasePosts: function releasePosts(postIds) {
      var _this8 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].releasePost(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this8.$swal({
              title: 'Error in releasing Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this8.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this8.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });

          _this8.getStatusReport();
          _this8.$emit('input');
          _this8.viewPostDialog = false;
        } else {}
      });
    },
    deletePosts: function deletePosts(postIds) {
      var _this9 = this;

      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be deleted',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          return __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].bulkDeletePosts(postIds).then(function (data) {
            return data;
          }).catch(function (error) {
            console.error(error);
            _this9.$swal({
              title: 'Error in deleting Post, please try again',
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this9.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this9.$swal({
            title: 'Success',
            text: 'Successfully Deleted',
            type: 'success'
          });

          _this9.$emit('input');
          _this9.getPosts();
          _this9.viewPostDialog = false;
        } else {}
      });
    },
    startSubmissionReview: function startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout: function submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL: function enterPostURL(post) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_12__Campaign_campaignAPIs__["a" /* default */].getCampaign(post.campaignID).then(function (response) {
        _this10.campaignDataForAddPost = response;
        _this10.postIdToUpdate = post._id;
        _this10.addPostToCampaign = true;
        _this10.addPost = post;
      }).catch(function (err) {
        _this10.addPostToCampaign = true;
        _this10.$swal({
          type: 'error',
          title: 'Error Getting Campaign Information'
        });
        console.log(err);
      });
    },
    assignPostURL: function assignPostURL(post) {
      var _this11 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].publishPost(post._id, result.value).then(function () {
            _this11.$swal({
              title: postConfirmationText['confirm']['title'],
              text: 'Do you want to submit payout?',
              type: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then(function (confirmed) {
              if (confirmed.value) {
                var payout = {
                  campaignName: post.campaignName,
                  campaignID: post.campaignID,
                  postID: post._id,
                  influencerID: post.influencerID,
                  instagramPostURL: result.value,
                  otherSocialMediaPostUrl: '',
                  satisfactionLevel: 0,
                  advertiserSatisfactionLevel: 0
                };
                __WEBPACK_IMPORTED_MODULE_15__Influencer_paymentAPIs__["a" /* default */].createCampaignPayout(payout).then(function () {
                  _this11.$swal({
                    type: 'success',
                    title: 'Campaign payout created!'
                  });
                }).catch(function () {
                  _this11.$swal({
                    type: 'error',
                    title: 'Cannot create campaign payout for this post. Try again later!'
                  });
                });
              }
            });
            _this11.getPosts();
          }).catch(function () {
            _this11.$swal({
              type: 'error',
              title: 'Error in processing your request! Please try again'
            });
          });
        }
      });
    },
    completePost: function completePost(post) {
      var _this12 = this;

      var postConfirmationText = __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].completePost(post._id).then(function () {
            _this12.$swal({
              type: 'success',
              title: postConfirmationText['confirm']['title'],
              text: postConfirmationText['confirm']['text']
            }).then(function () {
              _this12.getPosts();
            });
          }).catch(function (error) {
            return _this12.$swal({
              type: 'error',
              text: error
            });
          });
        }
      });
    },
    markMetadataTag: function markMetadataTag(ids) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this13.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to mark as metadata tagged?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
                    var data;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!result.value) {
                              _context3.next = 10;
                              break;
                            }

                            data = ids.map(function (postID) {
                              return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, {
                                id: postID,
                                metadataTagged: true
                              });
                            });
                            _context3.next = 4;
                            return _this13.$store.dispatch('post/updatePostByIds', data);

                          case 4:
                            _this13.isLoading = false;

                            if (_this13.postUpdateStatus) {
                              _context3.next = 8;
                              break;
                            }

                            _this13.$swal({
                              text: 'Error Metadata Tag.',
                              type: 'error'
                            });
                            return _context3.abrupt('return');

                          case 8:
                            _this13.$swal({
                              text: 'Successfully Saved Metadata Tag.',
                              type: 'success'
                            });
                            _this13.getPosts();

                          case 10:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this13);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },

    editPostFromView: function editPostFromView(post) {
      this.editPost(post);
    },
    editPost: function editPost(post) {
      var _this14 = this;

      this.fetchPostAsync(post._id).then(function (newPost) {
        post.reportAbuse = newPost.reportAbuse;
        _this14.editPostData = post;
        _this14.editPostDialog = true;
      });
    },
    reloadPostView: function reloadPostView(postData) {
      this.viewPostDialog = false;
      this.viewDetailPost(postData);
    },
    fetchPostAsync: function fetchPostAsync(postId, returnData) {
      var _this15 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_11__postApi__["a" /* default */].getPostById(postId).then(function (post) {
          resolve(post);
        }).catch(function (err) {
          _this15.$swal({
            title: 'Couldn\'t the Post',
            type: 'error',
            text: err
          });
          reject(err);
        });
      });
    },
    getAllCampaignPayouts: function getAllCampaignPayouts() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, datas, campaignPayouts;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__Influencer_influencerAPIs__["a" /* default */].getAllCampaignPayouts();

              case 2:
                response = _context5.sent;
                datas = response.data;
                campaignPayouts = datas.map(function (element) {
                  return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({
                    id: element.id,
                    campaignID: element.campaignID,
                    influencerID: element.influencerID,
                    postID: element.postID
                  });
                });

                _this16.reportData = _this16.reportData.map(function (post) {
                  var matchItem = campaignPayouts.find(function (d) {
                    return d.influencerID === post.influencerID && d.campaignID === post.campaignID;
                  });
                  if (matchItem) {
                    post.payout = true;
                  }
                  return post;
                });

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this16);
      }))();
    },
    resetFilter: function resetFilter() {
      this.filter = {
        instagramHandle: '',
        campaignID: '',
        clientID: '',
        status: [__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.AD_STRATEGIST_PENDING, __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.CLIENT_PENDING, __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */].postStatus.APPROVE]
      };
      this.filter = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.filter, this.pagging);
      this.resetPaging();
      this.getStatusReport();
    },
    resetPaging: function resetPaging() {
      this.pagging.page = 1;
      this.pagging.totalItems = 0;
    },
    disableViewScreenshot: function disableViewScreenshot(item) {
      return !item.images.length > 0 && !item.posts.length > 0 && !item.stories.length > 0 && !item.deliverablePosts.length > 0;
    },
    filterMenuOptions: function filterMenuOptions() {
      var _this17 = this;

      var options = __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(function (option) {
          return _this17.buttonShow(option.action);
        });
      }
    },
    filterTableActions: function filterTableActions() {
      var _this18 = this;

      var options = __WEBPACK_IMPORTED_MODULE_9__postConfig__["a" /* default */].tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(function (option) {
          return _this18.buttonShow(option.action);
        });
      }
      this.tableActions = this.tableActions.map(function (item) {
        item.disabled = true;
        return item;
      });
    },
    buttonShow: function buttonShow(type) {
      var buttonPermission = __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */]['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if ((typeof buttonPermission === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(buttonPermission)) === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    actionPostBy: function actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsMetadataTagged':
          this.markMetadataTag([post._id]);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'markAsAbuseResolved':
          this.abuseResolvePosts([post._id]);
          break;
        case 'releaseAbuseResolved':
          this.releaseAbuseResolvedPosts([post._id]);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    assignCampaignToPost: function assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost: function mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    changePostStatus: function changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changePostIds = [];
      this.changeStatusDialog = true;
    },
    assignedCampaign: function assignedCampaign() {
      this.getStatusReport();
    },
    postAdded: function postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
      this.getStatusReport();
    }
  }
});

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Client_clientAPIs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignUserToClientModal',
  props: ['modalId', 'userData'],
  data: function data() {
    return {
      user: null,
      sortBy: 'name',
      sortDesc: false,
      fields: [{ text: 'name', sortable: true, value: 'name' }, { text: 'address', sortable: true, value: 'address' }, { text: 'website', sortable: true, value: 'website' }, { text: 'phoneNumber', sortable: true, value: 'phoneNumber' }, { text: 'actions', sortable: false }],
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      search: null,
      filter: null
    };
  },

  watch: {
    userData: function userData(newUserData) {
      this.user = newUserData;

      this.getAllClients(false);
    }
  },
  computed: {
    updatedOn: function updatedOn() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.lastUpdate).fromNow();
    }
  },
  methods: {
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateItems: function updateItems(newItems) {
      var _this = this;

      this.items = newItems.filter(function (item) {
        return _this.user && item.companyID === _this.user.companyID;
      });
      this.totalRows = this.items.length;
    },
    getAllClients: function getAllClients(force) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__Client_clientAPIs__["a" /* default */].getAllClients(force).then(function (response) {
        _this2.updateItems(response.data);
        _this2.lastUpdate = response.lastUpdate;
      }).catch(function (error) {
        console.log('error', error);
      });
    },

    isAlreadyAssigned: function isAlreadyAssigned(client) {
      var clientHandledBy = client.handledBy;

      return this.user && clientHandledBy && clientHandledBy.includes(this.user.id);
    },
    assignClient: function assignClient(client, shouldAssign) {
      var _this3 = this;

      var clientHandledBy = client.handledBy;
      if (!clientHandledBy) {
        clientHandledBy = [];
      }

      if (shouldAssign) {
        clientHandledBy.push(this.user.id);
      } else {
        clientHandledBy = clientHandledBy.filter(function (userID) {
          return userID !== _this3.user.id;
        });
      }

      var updatingClient = {
        id: client.id,
        handledBy: clientHandledBy
      };

      var clientData = this.buildFormData(updatingClient);
      __WEBPACK_IMPORTED_MODULE_2__Client_clientAPIs__["a" /* default */].editClient(clientData, client.id).then(function (response) {
        _this3.getAllClients(true);
      }).catch(function (error) {
        console.error(error);
      });
    },
    buildFormData: function buildFormData(clientData) {
      var formData = new FormData();
      var client = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, clientData);
      formData.append('client', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(client));
      return formData;
    }
  },
  mounted: function mounted() {
    this.getAllClients(false);
  }
});

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_sources_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuelidate__);







;






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BillingInfoModal',
  props: {
    value: Boolean,
    infData: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      countries: [],
      allBanks: [],
      bankNames: [],
      disableBankSelect: false,
      editData: {
        fullName: '',
        country: '',
        bankName: '',
        bankAccount: '',
        billingEmail: '',
        mailingAddress: ''
      }
    };
  },

  validations: {
    editData: {
      fullName: { required: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["required"] },
      country: { required: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["required"] },
      bankName: { required: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["required"] },
      bankAccount: { required: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["required"] },
      billingEmail: { required: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["required"] },
      mailingAddress: { required: __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["required"] }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['user', 'activePlatform']), {
    currentUserID: function currentUserID() {
      return this.user.id;
    }
  }),
  watch: {
    infData: function infData(newUserData) {
      this.editData.fullName = newUserData.fullName;
      this.editData.country = newUserData.country;
      this.editData.bankName = newUserData.bankName;
      this.editData.bankAccount = newUserData.bankAccount;
      this.editData.billingEmail = newUserData.billingEmail || '';
      this.editData.mailingAddress = newUserData.mailingAddress || '';
    }
  },
  mounted: function mounted() {
    this.countries = __WEBPACK_IMPORTED_MODULE_9__static_sources_countries___default.a;
    this.editData.fullName = this.infData.fullName;
    this.editData.country = this.infData.country;
    this.editData.bankName = this.infData.bankName;
    this.editData.bankAccount = this.infData.bankAccount;
    this.editData.billingEmail = this.infData.billingEmail || '';
    this.editData.mailingAddress = this.infData.mailingAddress || '';
  },

  methods: {
    saveBillingInfo: function saveBillingInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('dd');
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 5;
                  break;
                }

                _this.$swal({
                  type: 'error',
                  title: 'Can\'t Submit with errors',
                  text: 'Please fill the required information correctly.'
                });
                return _context.abrupt('return');

              case 5:
                _this.$swal({
                  title: 'Double Check!',
                  text: 'Are you sure you want to save?',
                  confirmButtonText: 'Confirm',
                  type: 'info',
                  showCancelButton: true,
                  showCloseButton: true
                }).then(function (result) {
                  _this.loading = true;
                  if (result.value) {
                    if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_this.editData.bankName) === 'object') {
                      _this.editData.swiftCode = _this.editData.bankName.swift_code;
                      _this.editData.bankName = _this.editData.bankName.bank;
                    }
                    var edittingUserProfile = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ id: _this.currentUserID }, _this.infData, _this.editData);
                    if (edittingUserProfile.billingEmail) {
                      edittingUserProfile.billingEmail = edittingUserProfile.billingEmail.toLowerCase();
                    }
                    var formData = _this.buildFormData(edittingUserProfile);

                    __WEBPACK_IMPORTED_MODULE_8__userAPIs__["a" /* default */].editProfile(formData).then(function (response) {
                      _this.loading = false;
                      _this.$swal({
                        title: 'Successfully updated!',
                        text: 'Your billing information has been updated successfully. Thank you for working with us!',
                        type: 'success'
                      });
                      _this.$emit('updated');
                      _this.close();
                    }).catch(function (error) {
                      _this.loading = false;
                      _this.$swal({
                        title: 'Error!',
                        text: 'Please kindly try again or contact us!',
                        type: 'error'
                      });

                      console.log('error', error);
                    });
                  }
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    buildFormData: function buildFormData(userProfile) {
      var formData = new FormData();

      formData.append('editProfile', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(userProfile));
      return formData;
    },
    changeCountry: function changeCountry() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var country, matchBank;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.bankNames = [];
                country = _this2.countries.find(function (c) {
                  return c.name === _this2.editData.country;
                });

                if (country) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                _this2.disableBankSelect = true;
                _context2.next = 8;
                return _this2.getBanks(country.code);

              case 8:
                matchBank = _this2.allBanks.find(function (bank) {
                  return bank.country_code === country.code;
                });

                if (matchBank && matchBank.list !== undefined) {
                  _this2.bankNames = matchBank.list.filter(function (bank) {
                    return bank.branch === null;
                  });
                }
                _this2.disableBankSelect = false;
                _context2.next = 18;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                _this2.bankNames = [];
                _this2.disableBankSelect = false;

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 13]]);
      }))();
    },
    getBanks: function getBanks(code) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__Influencer_influencerAPIs__["a" /* default */].getBanks(code);

              case 3:
                _this3.allBanks = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.log('error', _context3.t0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    close: function close() {
      this.$emit('input');
    }
  }
});

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);







var lowers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__["regex"])('lowers', __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].regexPattern.lowers);
var uppers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__["regex"])('uppers', __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].regexPattern.uppers);
var numbers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__["regex"])('numbers', __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].regexPattern.numbers);
var symbols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators_common__["regex"])('numbers', __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].regexPattern.symbols);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangePasswordModal',
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      user: {},
      errorMessage: null,
      show: {
        oldPassword: false,
        password: false,
        repeatPassword: false
      }
    };
  },

  watch: {},

  computed: {
    passwordError: function passwordError() {
      var errors = [];
      if (!this.$v.user.newPassword.$dirty) return errors;
      !this.$v.user.newPassword.required && errors.push('Password is required.');
      !this.$v.user.newPassword.uppers && errors.push('Password must contain upper letter.');
      !this.$v.user.newPassword.lowers && errors.push('Password must contain lower letters.');
      !this.$v.user.newPassword.numbers && errors.push('Password must contain numbers.');
      !this.$v.user.newPassword.symbols && errors.push('Password must contain non-alpha letters.');
      !this.$v.user.newPassword.minLength && errors.push('Password must be at least 8 characters.');
      return errors;
    },
    currentPasswordErrors: function currentPasswordErrors() {
      var errors = [];
      if (!this.$v.user.oldPassword.$dirty) return errors;
      !this.$v.user.oldPassword.required && errors.push('Old Password is required.');
      return errors;
    },
    repeatPasswordErrors: function repeatPasswordErrors() {
      var errors = [];
      if (!this.$v.user.repeatPassword.$dirty) return errors;
      !this.$v.user.repeatPassword.sameAsPassword && errors.push("Password doesn't match.");
      return errors;
    }
  },

  validations: {
    user: {
      oldPassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      newPassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(8),
        uppers: uppers,
        lowers: lowers,
        numbers: numbers,
        symbols: symbols
      },
      repeatPassword: {
        sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('newPassword')
      }
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit('input');
    },
    changePassword: function changePassword() {
      var _this = this;

      this.errorMessage = null;
      var editingInfo = {
        id: this.$store.state.user.id,
        oldPassword: this.user.oldPassword,
        newPassword: this.user.newPassword
      };

      __WEBPACK_IMPORTED_MODULE_0__userAPIs__["a" /* default */].changePassword(editingInfo).then(function (response) {
        _this.$emit('changePassword', response);

        _this.$refs.closeButton.click();
      }).catch(function (error) {
        _this.errorMessage = error.response.data.message;
        console.log('error.response', error.response);
        console.log('error.response.data', error.response.data);
        console.log('error', error.response.data.message);
      });
    },
    clearData: function clearData() {
      this.user = {
        newPassword: '',
        oldPassword: '',
        repeatPassword: ''
      };
    }
  },
  mounted: function mounted() {
    this.user = {
      newPassword: '',
      oldPassword: '',
      repeatPassword: ''
    };
  }
});

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userAPIs__ = __webpack_require__(19);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmUserModal',
  props: ['modalId', 'userData'],
  data: function data() {
    return {
      user: null
    };
  },

  watch: {
    userData: function userData(newUserData) {
      this.user = newUserData;
    }
  },
  methods: {
    editUser: function editUser() {
      var _this = this;

      var editingUser = {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email,
        activated: this.user.activated
      };

      __WEBPACK_IMPORTED_MODULE_0__userAPIs__["a" /* default */].editUser(editingUser).then(function (response) {
        _this.$emit('editUser', response);

        _this.$refs.closeButton.click();
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  }
});

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reverse__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_sources_countries__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreatePrivateLink',
  mixins: [__WEBPACK_IMPORTED_MODULE_9_vuelidate__["validationMixin"]],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      platform: 'instagram',
      rdoPlatformOption: 'default',
      search: '',
      name: '',
      email: '',
      location: '',
      igHandle: '',
      tiktokHandle: '',
      youtubeHandle: '',
      password: '',
      generatedPass: '',
      xhs: {
        xhsFullname: '',
        xhsHandle: '',
        xhsID: '',
        totalFollowers: '',
        totalLikesFavourites: ''
      },
      facebook: {
        fbFullname: '',
        fbHandle: '',
        fbID: '',
        totalFollowers: ''
      },
      linkedin: {
        linkedinFullname: '',
        linkedinHandle: '',
        totalFollowers: ''
      },
      linkedInLoading: false,
      validatedLinkedInHandle: '',
      publicProfileLoading: '',
      validatedFacebookHandle: '',
      validatedTwitterHandle: '',
      twitter: {
        twitterFullname: '',
        twitterHandle: '',
        totalFollowers: ''
      },
      invitePlatformOptions: [{
        text: 'IG / TikTok / YouTube',
        value: 'default',
        logos: [{ name: 'Instagram', icon: 'mdi-instagram', iconColor: '#111111' }, { name: 'TikTok', imgIcon: '/static/img/tiktok-32.png' }, { name: 'YouTube', icon: 'mdi-youtube', iconColor: '#ff0000' }]
      }, {
        text: 'XHS',
        value: 'xiaohongshu',
        logos: [{ name: 'XHS', imgIcon: '/static/img/xhs-black.png' }]
      }, {
        text: 'Facebook',
        value: 'facebook',
        logos: [{ name: 'Facebook', icon: 'mdi-facebook', iconColor: '#1877f2' }]
      }, {
        text: 'LinkedIn',
        value: 'linkedin',
        logos: [{ name: 'LinkedIn', icon: 'mdi-linkedin', iconColor: '#0a66c2' }]
      }, {
        text: 'X (Twitter)',
        value: 'twitter',
        logos: [{ name: 'X (Twitter)', imgIcon: '/static/img/x-logo.svg' }]
      }],
      copySucceeded: false,
      pendingUsers: [],
      locations: [],
      headers: [{
        text: 'Name',
        value: 'name'
      }, {
        text: 'Email',
        value: 'email'
      }, {
        text: 'Instagram Handle',
        value: 'igHandle'
      }, {
        text: 'TikTok Handle',
        value: 'tiktokHandle'
      }, {
        text: 'Youtube Handle',
        value: 'youtubeHandle'
      }, {
        text: 'XHS Handle',
        value: 'xhsHandle'
      }, {
        text: 'Facebook Handle',
        value: 'fbHandle'
      }, {
        text: 'LinkedIn Handle',
        value: 'linkedinHandle'
      }, {
        text: 'X Handle',
        value: 'twitterHandle'
      }, {
        text: 'Location',
        value: 'location'
      }, {
        text: 'Created At',
        value: 'createdAt'
      }],
      infUsers: [],
      isLoading: false
    };
  },

  validations: function validations() {
    var validationRules = {
      name: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      email: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"] },
      password: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] }
    };
    if (this.rdoPlatformOption === 'xiaohongshu') {
      validationRules.xhs = {
        xhsFullname: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        xhsHandle: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        xhsID: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        totalFollowers: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        totalLikesFavourites: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] }
      };
    }
    if (this.rdoPlatformOption === 'facebook') {
      validationRules.facebook = {
        fbFullname: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        fbHandle: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        fbID: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        totalFollowers: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] }
      };
    }
    if (this.rdoPlatformOption === 'linkedin') {
      validationRules.linkedin = {
        linkedinFullname: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        linkedinHandle: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        totalFollowers: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] }
      };
    }
    if (this.rdoPlatformOption === 'twitter') {
      validationRules.twitter = {
        twitterFullname: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        twitterHandle: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        totalFollowers: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] }
      };
    }
    return validationRules;
  },
  computed: {
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push('name is required');
      return errors;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('password is required');
      return errors;
    },
    xhsFullnameErrors: function xhsFullnameErrors() {
      var errors = [];
      if (!this.$v.xhs.xhsFullname.$dirty) return errors;
      !this.$v.xhs.xhsFullname.required && errors.push('XHS Fullname is required');
      return errors;
    },
    xhsHandleErrors: function xhsHandleErrors() {
      var errors = [];
      if (!this.$v.xhs.xhsHandle.$dirty) return errors;
      !this.$v.xhs.xhsHandle.required && errors.push('XHS Handle is required');
      return errors;
    },
    xhsIDErrors: function xhsIDErrors() {
      var errors = [];
      if (!this.$v.xhs.xhsID.$dirty) return errors;
      !this.$v.xhs.xhsID.required && errors.push('XHS ID is required');
      return errors;
    },
    xhsTotalFollowersErrors: function xhsTotalFollowersErrors() {
      var errors = [];
      if (!this.$v.xhs.totalFollowers.$dirty) return errors;
      !this.$v.xhs.totalFollowers.required && errors.push('XHS Total Followers is required');
      return errors;
    },
    xhsTotalLikesFavouritesErrors: function xhsTotalLikesFavouritesErrors() {
      var errors = [];
      if (!this.$v.xhs.totalLikesFavourites.$dirty) return errors;
      !this.$v.xhs.totalLikesFavourites.required && errors.push('XHS Total Likes Favourites is required');
      return errors;
    },
    fbHandleErrors: function fbHandleErrors() {
      var errors = [];
      if (!this.$v.facebook.fbHandle.$dirty) return errors;
      !this.$v.facebook.fbHandle.required && errors.push('Facebook Handle is required');
      return errors;
    },
    fbIDErrors: function fbIDErrors() {
      var errors = [];
      if (!this.$v.facebook.fbID.$dirty) return errors;
      !this.$v.facebook.fbID.required && errors.push('Facebook ID is required');
      return errors;
    },
    fbTotalFollowerErrors: function fbTotalFollowerErrors() {
      var errors = [];
      if (!this.$v.facebook.totalFollowers.$dirty) return errors;
      !this.$v.facebook.totalFollowers.required && errors.push('Facebook Total Followers is required');
      return errors;
    },
    linkedinFullnameErrors: function linkedinFullnameErrors() {
      var errors = [];
      if (!this.$v.linkedin.linkedinFullname.$dirty) return errors;
      !this.$v.linkedin.linkedinFullname.required && errors.push('LinkedIn Full Name is required');
      return errors;
    },
    linkedinHandleErrors: function linkedinHandleErrors() {
      var errors = [];
      if (!this.$v.linkedin.linkedinHandle.$dirty) return errors;
      !this.$v.linkedin.linkedinHandle.required && errors.push('LinkedIn Handle is required');
      return errors;
    },
    linkedinTotalFollowersErrors: function linkedinTotalFollowersErrors() {
      var errors = [];
      if (!this.$v.linkedin.totalFollowers.$dirty) return errors;
      !this.$v.linkedin.totalFollowers.required && errors.push('Followers (Connections) is required');
      return errors;
    },
    twitterFullnameErrors: function twitterFullnameErrors() {
      var errors = [];
      if (!this.$v.twitter.twitterFullname.$dirty) return errors;
      !this.$v.twitter.twitterFullname.required && errors.push('X display name is required');
      return errors;
    },
    twitterHandleErrors: function twitterHandleErrors() {
      var errors = [];
      if (!this.$v.twitter.twitterHandle.$dirty) return errors;
      !this.$v.twitter.twitterHandle.required && errors.push('X handle is required');
      return errors;
    },
    twitterTotalFollowersErrors: function twitterTotalFollowersErrors() {
      var errors = [];
      if (!this.$v.twitter.totalFollowers.$dirty) return errors;
      !this.$v.twitter.totalFollowers.required && errors.push('X total followers is required');
      return errors;
    }
  },
  watch: {
    rdoPlatformOption: {
      handler: function handler(newValue, oldValue) {
        this.email = '';
        this.password = '';
        if (newValue === 'xiaohongshu') {
          this.changeXhsId();
        }
        if (newValue === 'facebook') {
          this.changeFbId();
        }
      }
    },
    'facebook.fbHandle': function facebookFbHandle(value) {
      if ((value || '').trim().replace(/^@+/, '') !== this.validatedFacebookHandle) this.validatedFacebookHandle = '';
    },
    'twitter.twitterHandle': function twitterTwitterHandle(value) {
      if (this.normalizeTwitterHandle(value) !== this.validatedTwitterHandle) this.validatedTwitterHandle = '';
    }
  },
  methods: {
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    },
    getLocations: function getLocations() {
      this.locations = __WEBPACK_IMPORTED_MODULE_10__static_sources_countries___default.a.map(function (element) {
        return element.name;
      });
    },
    formatDate: function formatDate(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';

      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format(format);
    },
    handleCopyStatus: function handleCopyStatus(status) {
      this.copySucceeded = status;
    },
    getPendingRegistrations: function getPendingRegistrations() {
      var _this = this;

      console.log('fetching pending registrations');
      __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].getPendingTokenRegistrations().then(function (response) {
        _this.pendingUsers = response.pendingUsers;
        _this.pendingUsers = __WEBPACK_IMPORTED_MODULE_4_lodash_reverse___default()(_this.pendingUsers);
      });
    },
    registerInf: function registerInf() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.rdoPlatformOption === 'linkedin')) {
                  _context.next = 14;
                  break;
                }

                _this2.linkedin.linkedinHandle = _this2.normalizeLinkedInHandle(_this2.linkedin.linkedinHandle);
                _this2.$v.linkedin.linkedinHandle.$touch();

                if (!_this2.$v.linkedin.linkedinHandle.$invalid) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _context.next = 7;
                return _this2.validateLinkedInProfile();

              case 7:
                if (_context.sent) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:
                _this2.$v.linkedin.$touch();
                _this2.$v.name.$touch();

                if (!(_this2.$v.linkedin.$invalid || _this2.$v.name.$invalid)) {
                  _context.next = 14;
                  break;
                }

                _this2.$swal({
                  text: 'Please complete the required LinkedIn details',
                  type: 'info'
                });
                return _context.abrupt('return');

              case 14:
                if (!(_this2.rdoPlatformOption === 'twitter')) {
                  _context.next = 28;
                  break;
                }

                _this2.twitter.twitterHandle = _this2.normalizeTwitterHandle(_this2.twitter.twitterHandle);

                if (_this2.twitter.twitterHandle) {
                  _context.next = 19;
                  break;
                }

                _this2.$v.twitter.twitterHandle.$touch();
                return _context.abrupt('return');

              case 19:
                _context.next = 21;
                return _this2.validatePublicProfile('twitter');

              case 21:
                if (_context.sent) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt('return');

              case 23:
                _this2.$v.twitter.$touch();
                _this2.$v.name.$touch();

                if (!(_this2.$v.twitter.$invalid || _this2.$v.name.$invalid)) {
                  _context.next = 28;
                  break;
                }

                _this2.$swal({
                  text: 'Please complete the required X details',
                  type: 'info'
                });
                return _context.abrupt('return');

              case 28:
                if (!(_this2.rdoPlatformOption === 'facebook')) {
                  _context.next = 40;
                  break;
                }

                if (_this2.facebook.fbHandle) {
                  _context.next = 32;
                  break;
                }

                _this2.$v.facebook.fbHandle.$touch();
                return _context.abrupt('return');

              case 32:
                _context.next = 34;
                return _this2.validatePublicProfile('facebook');

              case 34:
                if (_context.sent) {
                  _context.next = 36;
                  break;
                }

                return _context.abrupt('return');

              case 36:
                _this2.$v.facebook.$touch();

                if (!_this2.$v.facebook.$invalid) {
                  _context.next = 40;
                  break;
                }

                _this2.$swal({ text: 'Please complete the required Facebook details', type: 'info' });
                return _context.abrupt('return');

              case 40:
                if (!(!_this2.rdoPlatformOption === 'facebook' && !_this2.rdoPlatformOption === 'xiaohongshu')) {
                  _context.next = 44;
                  break;
                }

                if (!(!_this2.igHandle && !_this2.tiktokHandle && !_this2.youtubeHandle)) {
                  _context.next = 44;
                  break;
                }

                _this2.$swal({
                  text: 'Please enter Instagram, TikTok or Youtube Handle',
                  type: 'info'
                });
                return _context.abrupt('return');

              case 44:
                if (_this2.password) {
                  _context.next = 47;
                  break;
                }

                _this2.$swal({
                  text: 'Please enter Password',
                  type: 'info'
                });
                return _context.abrupt('return');

              case 47:
                payload = {
                  name: _this2.name,
                  email: _this2.email.toLowerCase(),
                  igHandle: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.regexMatchIg(_this2.igHandle, __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].regexPattern.instagram_profile)),
                  tiktokHandle: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.espaceHandleSign(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.extractTikTokHandle(_this2.tiktokHandle)),
                  youtubeHandle: _this2.youtubeHandle,
                  platform: _this2.rdoPlatformOption,
                  location: _this2.location,
                  password: _this2.password,
                  xhs: _this2.xhs,
                  facebook: _this2.facebook,
                  linkedin: _this2.linkedin,
                  twitter: _this2.twitter
                };

                _this2.isLoading = true;
                __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].createPrivateLink(payload).then(function () {
                  _this2.isLoading = false;
                  _this2.$swal({
                    title: 'Success',
                    text: 'Account Created Successfully.',
                    type: 'success'
                  });
                  _this2.getRegisteredUsers();
                }).catch(function (error) {
                  _this2.isLoading = false;
                  var responseData = error && error.response ? error.response.data : null;
                  var errorMessage = typeof responseData === 'string' ? responseData : responseData && responseData.message || error.message || 'Unable to create the influencer account';
                  console.error(responseData || error);
                  if (errorMessage.includes('registered')) {
                    _this2.$swal({
                      text: errorMessage,
                      type: 'info',
                      showCancelButton: true,
                      confirmButtonText: 'Go to IMS Influencer',
                      cancelButtonText: 'Close'
                    }).then(function (result) {
                      if (result.value) {
                        if (errorMessage.includes('registered')) {
                          _this2.$router.push({ path: '/influencers' });
                        }
                      }
                    });
                  } else {
                    _this2.$swal({
                      text: errorMessage,
                      type: 'info'
                    });
                  }
                });

              case 50:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    deletePrivateLink: function deletePrivateLink(id) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete this link?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].deletePrivateLink(id).then(function (response) {
            return response;
          }).catch(function (error) {
            console.error(error.response.data);
            _this3.$swal({
              title: 'Error',
              text: error.response.data,
              type: 'error'
            });
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !_this3.$swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          _this3.$swal({
            title: 'Success',
            text: 'Successfully Deleted ',
            type: 'success'
          });
          _this3.getPendingRegistrations();
        } else {}
      });
    },
    copyPass: function copyPass() {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.copyToClipboard('#copy-pass');
      }, 100);
      this.password = this.generatedPass;
    },

    generatePass: function generatePass() {
      this.generatedPass = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].func.generatePassword();
    },
    getRegisteredUsers: function getRegisteredUsers() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].getAllUsersByRoleSource(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.INFLUENCER, 'inviteToIMS');

              case 2:
                resp = _context2.sent;

                if (resp) _this4.infUsers = resp.users;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    changeXhsId: function changeXhsId() {
      if (this.xhs.xhsID) {
        this.email = this.xhs.xhsID + '@getkobe.com';
      }
    },
    changeFbId: function changeFbId() {
      if (this.facebook.fbID) {
        this.email = this.facebook.fbID + '@getkobe.com';
      }
    },
    normalizeLinkedInHandle: function normalizeLinkedInHandle(value) {
      var handle = (value || '').trim();
      var linkedinUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i);
      if (linkedinUrl) {
        handle = linkedinUrl[1];
      }
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    },
    validateLinkedInProfile: function validateLinkedInProfile() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var handle, response, profile, responseData, message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                handle = _this5.normalizeLinkedInHandle(_this5.linkedin.linkedinHandle);

                if (handle) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return', false);

              case 3:
                if (!(_this5.validatedLinkedInHandle === handle && _this5.linkedin.linkedinFullname)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return', true);

              case 5:
                _this5.linkedInLoading = true;
                _context3.prev = 6;
                _context3.next = 9;
                return __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].getLinkedInProfile(handle);

              case 9:
                response = _context3.sent;
                profile = response && response.user_profile;

                if (!(!response || response.success !== true || !profile || !profile.username || !profile.fullname)) {
                  _context3.next = 13;
                  break;
                }

                throw new Error('Unable to validate the LinkedIn profile');

              case 13:
                _this5.linkedin.linkedinHandle = profile.username;
                _this5.linkedin.linkedinFullname = profile.fullname;
                if (profile.followers !== null && profile.followers !== undefined) {
                  _this5.linkedin.totalFollowers = profile.followers;
                }
                if (!_this5.name) _this5.name = profile.fullname;
                _this5.validatedLinkedInHandle = profile.username;
                if (profile.followers === null || profile.followers === undefined) {
                  _this5.$swal({
                    type: 'info',
                    text: 'LinkedIn profile verified, but its follower count is not public. Enter the follower count manually to continue.'
                  });
                }
                return _context3.abrupt('return', true);

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3['catch'](6);
                responseData = _context3.t0 && _context3.t0.response ? _context3.t0.response.data : null;

                if (!(_context3.t0 && _context3.t0.response && _context3.t0.response.status === 503)) {
                  _context3.next = 28;
                  break;
                }

                _this5.validatedLinkedInHandle = handle;
                return _context3.abrupt('return', true);

              case 28:
                _this5.validatedLinkedInHandle = '';
                message = responseData && responseData.message ? responseData.message : _context3.t0.message || 'Unable to validate the LinkedIn profile';

                _this5.$swal({ type: 'error', text: message });
                return _context3.abrupt('return', false);

              case 32:
                _context3.prev = 32;

                _this5.linkedInLoading = false;
                return _context3.finish(32);

              case 35:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[6, 22, 32, 35]]);
      }))();
    },
    validatePublicProfile: function validatePublicProfile(platform) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var isFacebook, enteredHandle, handle, validatedKey, fullName, response, profile, responseData, message;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isFacebook = platform === 'facebook';
                enteredHandle = isFacebook ? _this6.facebook.fbHandle : _this6.twitter.twitterHandle;
                handle = isFacebook ? (enteredHandle || '').trim().replace(/^@+/, '') : _this6.normalizeTwitterHandle(enteredHandle);

                if (handle) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return', false);

              case 5:
                validatedKey = isFacebook ? 'validatedFacebookHandle' : 'validatedTwitterHandle';
                fullName = isFacebook ? _this6.facebook.fbFullname : _this6.twitter.twitterFullname;

                if (!(_this6[validatedKey] === handle && fullName)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt('return', true);

              case 9:
                _this6.publicProfileLoading = platform;
                _context4.prev = 10;
                _context4.next = 13;
                return __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].getPublicProfile(platform, handle);

              case 13:
                response = _context4.sent;
                profile = response && response.user_profile;

                if (!(!response || response.success !== true || !profile || !profile.username || !profile.fullname)) {
                  _context4.next = 17;
                  break;
                }

                throw new Error('Unable to validate the ' + (isFacebook ? 'Facebook' : 'X') + ' profile');

              case 17:
                if (isFacebook) {
                  _this6.facebook.fbHandle = profile.username;
                  _this6.facebook.fbFullname = profile.fullname;
                  if (profile.id) _this6.facebook.fbID = profile.id;
                  if (profile.followers !== null && profile.followers !== undefined) _this6.facebook.totalFollowers = profile.followers;
                  _this6.changeFbId();
                } else {
                  _this6.twitter.twitterHandle = profile.username;
                  _this6.twitter.twitterFullname = profile.fullname;
                  if (profile.followers !== null && profile.followers !== undefined) _this6.twitter.totalFollowers = profile.followers;
                }
                if (!_this6.name) _this6.name = profile.fullname;
                _this6[validatedKey] = profile.username;
                if (profile.followers === null || profile.followers === undefined) {
                  _this6.$swal({
                    type: 'info',
                    text: (isFacebook ? 'Facebook' : 'X') + ' profile verified, but its follower count is not public. Enter it manually to continue.'
                  });
                }
                return _context4.abrupt('return', true);

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4['catch'](10);
                responseData = _context4.t0 && _context4.t0.response ? _context4.t0.response.data : null;

                if (!(_context4.t0 && _context4.t0.response && _context4.t0.response.status === 503)) {
                  _context4.next = 30;
                  break;
                }

                _this6[validatedKey] = handle;
                return _context4.abrupt('return', true);

              case 30:
                _this6[validatedKey] = '';
                message = responseData && responseData.message ? responseData.message : _context4.t0.message || 'Unable to validate the ' + (isFacebook ? 'Facebook' : 'X') + ' profile';

                _this6.$swal({ type: 'error', text: message });
                return _context4.abrupt('return', false);

              case 34:
                _context4.prev = 34;

                _this6.publicProfileLoading = '';
                return _context4.finish(34);

              case 37:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[10, 24, 34, 37]]);
      }))();
    },
    normalizeTwitterHandle: function normalizeTwitterHandle(value) {
      var handle = (value || '').trim();
      var twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i);
      if (twitterUrl) handle = twitterUrl[1];
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim();
    }
  },
  mounted: function mounted() {
    this.getLocations();

    this.getRegisteredUsers();
    this.generatePass();
  }
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Company_companyAPIs__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateUserModal',
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      userType_options: [],
      company_options: [],
      accountAdmins: [],
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: '',
        companyID: '',
        accountAdmins: []
      },
      xhs: {
        xhsFullname: '',
        xhsHandle: '',
        xhsID: '',
        totalFollowers: '',
        totalFollowing: '',
        totalLikesFavourites: ''
      },
      facebook: {
        fbHandle: '',
        fbID: '',
        totalFollowers: '',
        totalFollowing: ''
      },
      platform: '',
      platforms: ['Others', 'Facebook', 'XHS'],
      userRoles: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles
    };
  },

  validations: {
    user: {
      firstName: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      },
      companyID: {
        required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
      }
    }
  },
  computed: {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    needCompany: function needCompany() {
      if (this.currentUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW) {
        return false;
      }

      var newUserRole = Number(this.user.role);
      if (newUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH || newUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW || newUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.AD_STRATEGIST || newUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || newUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.FINANCE || newUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.MARKETING) {
        return true;
      }
      return false;
    },
    isInf: function isInf() {
      return this.user.role === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.INFLUENCER;
    },
    isXHSPlatform: function isXHSPlatform() {
      return this.platform === 'XHS';
    },
    isFacebookPlatform: function isFacebookPlatform() {
      return this.platform === 'Facebook';
    }
  },
  methods: {
    close: function close() {
      this.$emit('input');
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    },

    createUser: function createUser() {
      var _this = this;

      if (this.user.email) {
        this.user.email = this.user.email.trim();
      }
      var user = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.user);

      if (this.needCompany === false) {
        delete user.companyID;
      }

      if (this.platform === 'XHS') {
        user.xhs = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.xhs);
      }

      if (this.platform === 'Facebook') {
        this.facebook.firstName = user.firstName;
        this.facebook.lastName = user.lastName;
        this.facebook.fbFullname = this.facebook.firstName + ' ' + this.facebook.lastName;
        user.facebook = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.facebook);
      }

      __WEBPACK_IMPORTED_MODULE_5__userAPIs__["a" /* default */].createUser(user).then(function (response) {
        _this.$emit('createUser', response);
        _this.close();
      }).catch(function (error) {
        console.log('error', error);
        _this.$swal({
          title: 'Error',
          text: 'Error Creating User!',
          type: 'error'
        });
        _this.close();
      });
    },
    clearData: function clearData() {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: ''
      };
    },
    getAdminUsers: function getAdminUsers() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var adminUsers;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH);

              case 2:
                adminUsers = _context.sent;

                if (!adminUsers.users) {
                  _context.next = 7;
                  break;
                }

                adminUsers = adminUsers.users;
                adminUsers = adminUsers.map(function (user) {
                  return {
                    id: user.id,
                    name: user.firstName + ' ' + user.lastName
                  };
                });
                return _context.abrupt('return', adminUsers);

              case 7:
                return _context.abrupt('return', []);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var createUserList, userTypeTemp;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              createUserList = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userPermissions']['user']['create'][_this3.currentUserRole];
              userTypeTemp = [];

              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(createUserList).forEach(function (element) {
                var value = createUserList[element];
                userTypeTemp.push({
                  value: value,
                  text: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */]['userRolesDetails'][value]['display']
                });
              });
              _this3.userType_options = userTypeTemp;
              _this3.userType_options = _this3.userType_options.filter(function (u) {
                return u.text !== 'Influencer';
              });

              if (_this3.currentUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.SUPER_ADMIN_HIGH || _this3.currentUserRole === __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].userRoles.SUPER_ADMIN_LOW) {
                __WEBPACK_IMPORTED_MODULE_4__Company_companyAPIs__["a" /* default */].getAllCompanies(false).then(function (response) {
                  _this3.company_options = response.data;
                }).catch(function (error) {
                  console.log('error', error);
                });
              }
              _context2.next = 8;
              return _this3.getAdminUsers();

            case 8:
              _this3.accountAdmins = _context2.sent;

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditUserModal',
  props: ['modalId', 'userData'],
  data: function data() {
    return {
      userRoles: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles,
      user: null
    };
  },

  watch: {
    userData: function userData(newUserData) {
      this.user = newUserData;
    }
  },
  validations: {
    user: {
      firstName: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAdminUsers();

            case 2:
              _this.accountAdmins = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    editUser: function editUser() {
      var _this2 = this;

      if (this.user.email) {
        this.user.email = this.user.email.trim();
      }
      var editingUser = {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email
      };
      if (this.user.role === __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.ACCOUNT_MANAGER) {
        if (!this.user.accountAdmins.length) {
          this.$swal({
            text: 'Please select Account Admin',
            type: 'info'
          });
          return;
        }
        editingUser.accountAdmins = this.user.accountAdmins;
      }

      __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].editUser(editingUser).then(function (response) {
        _this2.$emit('editUser', response);

        _this2.$refs.closeButton.click();
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getAdminUsers: function getAdminUsers() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var adminUsers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__userAPIs__["a" /* default */].getAllUsersByRole(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].userRoles.COMPANY_ADMIN_HIGH);

              case 2:
                adminUsers = _context2.sent;

                if (!adminUsers.users) {
                  _context2.next = 7;
                  break;
                }

                adminUsers = adminUsers.users;
                adminUsers = adminUsers.map(function (user) {
                  return {
                    id: user.id,
                    name: user.firstName + ' ' + user.lastName
                  };
                });
                return _context2.abrupt('return', adminUsers);

              case 7:
                return _context2.abrupt('return', []);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },

    clearData: function clearData() {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
        accountAdmins: []
      };
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  }
});

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfResetPasswordModal',
  props: {
    value: Boolean,
    influencer: Object
  },
  data: function data() {
    return {
      user: {},
      generatedPass: '',
      errorMessage: null,
      show: {
        password: false
      }
    };
  },

  watch: {
    influencer: function influencer(newInfluencerData) {
      this.user = {
        newPassword: ''
      };
      this.generatePass();
    }
  },

  computed: {
    passwordError: function passwordError() {
      var errors = [];
      if (!this.$v.user.newPassword.$dirty) return errors;
      !this.$v.user.newPassword.required && errors.push('Password is required.');
      return errors;
    }
  },

  validations: {
    user: {
      newPassword: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit('input');
    },
    changePassword: function changePassword() {
      var _this = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to reset password for ' + this.influencer.email,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this.errorMessage = null;
          var editingInfo = {
            influencerID: _this.influencer.id,
            email: _this.influencer.email,
            password: _this.user.newPassword
          };

          __WEBPACK_IMPORTED_MODULE_0__userAPIs__["a" /* default */].resetInfPassword(editingInfo).then(function (response) {
            _this.$emit('reload', response);

            _this.closeModal();
            _this.$swal({
              html: 'Please save a copy of users credentials.<br><br>\n                <b>' + _this.influencer.email + '</b><br>\n                <b>' + _this.user.newPassword + '</b><br><br>\n                <i style=\'font-size:13px\'>Once confirmed, this password will no longer be visible</i>',
              type: 'success'
            });
          }).catch(function (error) {
            _this.errorMessage = error.response.data.message;
            console.log('error.response', error.response);
            console.log('error.response.data', error.response.data);
            console.log('error', error.response.data.message);
          });
        }
      });
    },
    copyPass: function copyPass() {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].func.copyToClipboard('#copy-pass');
      }, 100);
      this.password = this.generatedPass;
    },

    generatePass: function generatePass() {
      this.generatedPass = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].func.generatePassword();
    },
    clearData: function clearData() {
      this.user = {
        newPassword: ''
      };
    }
  },
  mounted: function mounted() {
    this.user = {
      newPassword: ''
    };
  }
});

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Influencer_RateCard_config__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_APIs__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_fb_sdk__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuelidate_lib_validators__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuelidate__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_scoped_influencer_ConnectInstagram__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_scoped_influencer_ConnectInstagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_scoped_influencer_ConnectInstagram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ChangeAvatarModal__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ChangeAvatarModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_ChangeAvatarModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Influencer_UpdatePlatformModal__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Influencer_UpdatePlatformModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Influencer_UpdatePlatformModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__BillingInfoModal__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__BillingInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__BillingInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_jimp__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_jimp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_jimp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_custom_CustomFileUpload__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scoped_custom_CustomFileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__scoped_custom_CustomFileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Influencer_influencerHelper__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__static_sources_countries__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__static_sources_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__static_sources_countries__);

































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Profile',
  components: { ConnectInstagram: __WEBPACK_IMPORTED_MODULE_20__components_scoped_influencer_ConnectInstagram___default.a, ChangeAvatarModal: __WEBPACK_IMPORTED_MODULE_21__components_ChangeAvatarModal___default.a, UpdatePlatformModal: __WEBPACK_IMPORTED_MODULE_22__Influencer_UpdatePlatformModal___default.a, BillingInfoModal: __WEBPACK_IMPORTED_MODULE_23__BillingInfoModal___default.a, CustomFileUpload: __WEBPACK_IMPORTED_MODULE_25__scoped_custom_CustomFileUpload___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_19_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      valid: true,
      tab: null,
      loginByFacebook: false,
      bdPicker: false,
      openedPanels: [0, 1, 2],
      formConfig: __WEBPACK_IMPORTED_MODULE_14__Influencer_RateCard_config__["a" /* default */].formConfig,
      userData: {
        firstName: null,
        lastName: null,
        fullName: null,
        bankName: null,
        bankAccount: null,
        mailingAddress: null,
        postalCode: null,
        email: null,
        birthday: '',
        gender: 2,
        phone: null,
        selectedSocialPlatforms: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].socialMediaPlatforms,
        keywords: [],
        country: null,
        engagementRate: null,
        totalFollowers: null,
        igHandle: null,
        twitterHandle: null,
        linkedinHandle: null,
        reqLinkedinHandle: null,
        influencer: {},
        ethnicity: null,
        occupation: null
      },
      inputedRates: {
        igStory: 0,
        igStoryCurrency: 'SGD',
        igPost: 0,
        igPostCurrency: 'SGD',
        igCarousel: 0,
        igCarouselCurrency: 'SGD',
        igVideo: 0,
        igVideoCurrency: 'SGD',
        igReel: 0,
        igReelCurrency: 'SGD',
        igTv: 0,
        igTvCurrency: 'SGD',
        loadingFee: 0,
        loadingFeeCurrency: 'SGD',
        eventAppearance: 0,
        eventAppearanceCurrency: 'SGD',
        tiktok: 0,
        tiktokCurrency: 'SGD',
        platforms: [],
        pricingDecks: [],
        type: ''
      },

      userGender_options: [],
      ethnicity_options: [{
        value: 'chinese',
        text: 'Chinese'
      }, {
        value: 'malay',
        text: 'Malay'
      }, {
        value: 'Indian',
        text: 'indian'
      }, {
        value: 'eurasian',
        text: 'Eurasian'
      }, {
        value: 'others',
        text: 'Others'
      }],
      socialPlatforms: [],
      countries: [],
      allBanks: [],
      bankNames: [],
      showUpdateInfo: false,
      showConnectBox: false,
      pwdWarning: false,
      pricingDecksMedia: [],
      images: [],
      decksFiles: [],
      loading: false,
      deleteObjectKeys: [],
      deleteSubmitting: false,
      cancelRequest: false,
      deleted: false,
      categories: __WEBPACK_IMPORTED_MODULE_26__Influencer_influencerHelper__["a" /* default */].getCategories(),
      changeAvatarDialog: false,
      disableBankSelect: false,
      updatePlatformDialog: false,
      billingInfoDialog: false,
      currenyOptions: ['SGD', 'USD', 'IDR', 'PHP', 'THB', 'MYR', 'VND']
    };
  },

  watch: {
    userData: function userData(newUserData) {
      this.userData = newUserData;
    }
  },
  validations: {
    userData: {
      firstName: { required: __WEBPACK_IMPORTED_MODULE_18_vuelidate_lib_validators__["required"] },

      email: { required: __WEBPACK_IMPORTED_MODULE_18_vuelidate_lib_validators__["required"] }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])(['user', 'activePlatform']), {
    currentUserID: function currentUserID() {
      return this.user.id;
    },
    influencerID: function influencerID() {
      return this.user.influencerID;
    },
    facebookId: function facebookId() {
      return this.user.facebookId;
    },
    activeUser: function activeUser() {
      return {
        displayName: this.user.firstName + ' ' + this.user.lastName,
        avatar: this.user.profilePicture ? this.user.profilePicture : '/static/img/avatar/user.png',
        email: this.user.email,
        createdAt: __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.user.createdAt).format('MMM D, YYYY'),
        role: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */]['userRolesDetails'][this.user.role]['display']
      };
    },
    firstNameErrors: function firstNameErrors() {
      var errors = [];
      if (!this.$v.userData.firstName.$dirty) return errors;
      !this.$v.userData.firstName.required && errors.push('Firstname is required');
      return errors;
    },
    lastNameErrors: function lastNameErrors() {
      var errors = [];
      if (!this.$v.userData.lastName.$dirty) return errors;
      !this.$v.userData.lastName.required && errors.push('Lastname is required');
      return errors;
    },
    mailingAddressErrors: function mailingAddressErrors() {
      var errors = [];
      if (!this.$v.userData.mailingAddress.$dirty) return errors;
      !this.$v.userData.mailingAddress.required && errors.push('Mailing Address is required');
      return errors;
    },
    phoneNumberErrors: function phoneNumberErrors() {
      var errors = [];
      if (!this.$v.userData.phone.$dirty) return errors;
      !this.$v.userData.phone.required && errors.push('Phone Number is required');
      return errors;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.userData.email.$dirty) return errors;
      !this.$v.userData.email.required && errors.push('Email is required');
      return errors;
    },
    countryErrors: function countryErrors() {
      var errors = [];
      if (!this.$v.userData.country.$dirty) return errors;
      !this.$v.userData.country.required && errors.push('Country is required');
      return errors;
    },
    bankNameErrors: function bankNameErrors() {
      var errors = [];
      if (!this.$v.userData.bankName.$dirty) return errors;
      !this.$v.userData.bankName.required && errors.push('Bank Name is required');
      return errors;
    },
    bankAccountErrors: function bankAccountErrors() {
      var errors = [];
      if (!this.$v.userData.bankAccount.$dirty) return errors;
      !this.$v.userData.bankAccount.required && errors.push('Bank Account is required');
      return errors;
    },
    fullNameErrors: function fullNameErrors() {
      var errors = [];
      if (!this.$v.userData.fullName.$dirty) return errors;
      !this.$v.userData.fullName.required && errors.push('Full Name is required');
      return errors;
    },
    isValidAccount: function isValidAccount() {
      var influencerID = this.influencerID;
      return influencerID !== '' && influencerID !== null && influencerID !== undefined;
    }
  }),
  methods: {
    openCloudinaryWidget: function openCloudinaryWidget() {
      window.cloudinary.openUploadWidget({
        cloudName: 'kobeglobal',
        uploadPreset: 'jhlmriux',
        sources: ['local', 'url'],
        googleApiKey: '',
        showAdvancedOptions: false,
        cropping: false,
        multiple: true,
        defaultSource: 'local'
      }, function (err, info) {
        if (!err) {
          console.log('Upload Widget event - ', info);
        }
      });
    },
    userHasConnectedInstagram: function userHasConnectedInstagram() {
      var _this = this;

      if (this.isValidAccount) {
        return true;
      }
      this.$swal({
        title: '<strong>Warning!</strong>',
        type: 'warning',
        html: 'Your instagram is not connected. Please connect with the necessary authorisation to proceed',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: 'primary',
        confirmButtonText: '<i class="fa fa-instagram"></i> Connect',
        cancelButtonText: 'Later'
      }).then(function (result) {
        if (result.value) {
          _this.connectInstagram();
        }
      });
    },

    changePasswordModalIdDisplay: function changePasswordModalIdDisplay() {
      return '#' + this.changePasswordModalId;
    },
    getFacebookStatus: function getFacebookStatus() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fbSdk;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__plugins_fb_sdk__["b" /* getFbSdk */])({ appId: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].FACEBOOK_APP_ID, version: 'v7.0' });

              case 2:
                fbSdk = _context.sent;

                fbSdk.getLoginStatus(function (response) {
                  _this2.loginByFacebook = response.status === 'connected';
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    buildFormData: function buildFormData(userProfile) {
      var formData = new FormData();

      formData.append('editProfile', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(userProfile));
      var files = this.pricingDecksMedia;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          formData.append('deckFile', val);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formData;
    },

    editProfile: function editProfile() {
      var _this3 = this;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: 'Can\'t Submit with errors',
          text: 'Please fill the required information correctly.'
        });
        return;
      }
      this.loading = true;
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.userData.bankName) === 'object') {
        this.userData.swiftCode = this.userData.bankName.swift_code;
        this.userData.bankName = this.userData.bankName.bank;
      }
      var edittingUserProfile = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ id: this.currentUserID }, this.userData);
      if (this.userData.birthday) {
        var birthDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.userData.birthday).format('YYYY-MM-DD');
        edittingUserProfile.birthday = birthDate;
      }
      edittingUserProfile.ethnicity = this.userData.ethnicity;
      edittingUserProfile.occupation = this.userData.occupation;
      delete edittingUserProfile.igHandle;
      delete edittingUserProfile.linkedinHandle;

      edittingUserProfile.inputedRates = this.inputedRates;
      if (edittingUserProfile.email) {
        edittingUserProfile.email = edittingUserProfile.email.toLowerCase();
      }
      var formData = this.buildFormData(edittingUserProfile);

      __WEBPACK_IMPORTED_MODULE_11__userAPIs__["a" /* default */].editProfile(formData).then(function (response) {
        if (_this3.deleteObjectKeys.length > 0) {
          _this3.deleteObjectKeys.map(function (item) {
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('delete', '/api/v1/posts/s3/delete', true, { image: item });
          });
        }

        _this3.loading = false;
        _this3.$swal({
          title: 'Successfully updated!',
          text: 'Your profile has been updated successfully. Thank you for working with us!',
          type: 'success'
        });

        var userState = _this3.$store.state.user;
        userState.firstName = _this3.userData.firstName;
        userState.lastName = _this3.userData.lastName;

        _this3.$store.commit('SET_USER', userState);
        if (window.localStorage) {
          window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(userState));
        }
        _this3.deleteObjectKeys = [];
        _this3.getUserProfile();
      }).catch(function (error) {
        _this3.loading = false;
        _this3.$swal({
          title: 'Error!',
          text: 'Please kindly try again or contact us!',
          type: 'error'
        });

        console.log('error', error);
      });
    },
    getUserProfile: function getUserProfile() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this4.influencerID || !_this4.currentUserID)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                __WEBPACK_IMPORTED_MODULE_11__userAPIs__["a" /* default */].getUser(_this4.currentUserID).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
                    var igEngRate, igTotalFollower, inputtedOtherPlatforms, keywords;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this4.images = [];
                            _this4.decksFiles = [];

                            if (!response.influencer.audience && !response.influencer.instagram && !response.influencer.tiktokaudience && !response.influencer.youtubeaudience && !response.influencer.linkedin && !response.influencer.twitter && !response.influencer.reqIgHandle && !response.influencer.reqTikTokHandle && !response.influencer.reqYoutubeHandle && !response.influencer.reqLinkedinHandle) {
                              _this4.updatePlatformDialog = true;
                            }
                            igEngRate = void 0, igTotalFollower = void 0;

                            if (response.influencer.instagram) {
                              igEngRate = (Number(response.influencer.instagram.pricingData ? response.influencer.instagram.pricingData.engagementRate : 0) * 100).toFixed(2) + '%';
                              igTotalFollower = response.influencer.instagram.totalFollowers;
                            } else if (response.influencer.tiktok) {
                              igEngRate = (Number(response.influencer.tiktok.pricingData ? response.influencer.tiktok.pricingData.engagementRate : 0) * 100).toFixed(2) + '%';
                              igTotalFollower = response.influencer.tiktok.totalFollowers;
                            } else if (response.influencer.linkedin) {
                              igTotalFollower = response.influencer.linkedin.totalFollowers;
                            }
                            inputtedOtherPlatforms = _this4.socialPlatforms.map(function (item) {
                              var storePlatform = {
                                label: item.label,
                                value: item.value
                              };
                              return storePlatform;
                            });

                            if (response.influencer.otherSocialMedias) {
                              response.influencer.otherSocialMedias.forEach(function (inputted) {
                                _this4.socialPlatforms.forEach(function (platform, pIndex) {
                                  if (platform.label === inputted.label) {
                                    inputtedOtherPlatforms[pIndex].value = inputted.value;
                                  }
                                });
                              });
                            }
                            keywords = [];

                            if (response.influencer.keywords && Array.isArray(response.influencer.keywords)) {
                              response.influencer.keywords.map(function (k) {
                                if (_this4.categories.includes(k)) {
                                  keywords.push(k);
                                }
                              });
                            }

                            _this4.userData = {
                              firstName: response.firstName,
                              lastName: response.lastName,
                              email: response.influencer.email,
                              phone: response.influencer.phone,
                              birthday: response.influencer.birthday ? __WEBPACK_IMPORTED_MODULE_9_moment___default()(response.influencer.birthday).format('YYYY-MM-DD') : '',
                              gender: response.influencer.gender,
                              ethnicity: response.influencer.ethnicity,
                              fullName: response.influencer.fullName,
                              bankName: response.influencer.bankName,
                              bankAccount: response.influencer.bankAccount,
                              mailingAddress: response.influencer.mailingAddress,
                              billingEmail: response.influencer.billingEmail || '',
                              postalCode: response.influencer.postalCode,
                              influencerId: response.influencer.id,
                              totalFollowers: igTotalFollower || 'No Data',
                              engagementRate: igEngRate || 'No Data',
                              selectedSocialPlatforms: inputtedOtherPlatforms,
                              country: response.influencer.country,
                              keywords: keywords,
                              occupation: response.influencer.occupation,
                              reqIgHandle: response.influencer.reqIgHandle,
                              reqTikTokHandle: response.influencer.reqTikTokHandle,
                              reqYoutubeHandle: response.influencer.reqYoutubeHandle,
                              reqLinkedinHandle: response.influencer.reqLinkedinHandle
                            };
                            if (response.influencer.instagram) {
                              _this4.userData.igHandle = response.igHandle || response.influencer.instagram.instagramHandle;
                              _this4.inputedRates.igHandle = _this4.userData.igHandle;
                            }
                            if (response.fbHandle || response.influencer.facebook || response.influencer.fbHandle) {
                              _this4.userData.fbHandle = response.fbHandle || (response.influencer.facebook ? response.influencer.facebook.handle : '') || response.influencer.fbHandle || '';
                            }
                            if (response.influencer.tiktok) {
                              _this4.userData.tiktokHandle = response.tiktokHandle || response.influencer.tiktok.tiktokHandle;
                              _this4.inputedRates.tiktokHandle = _this4.userData.tiktokHandle;
                            }
                            if (response.influencer.youtube) {
                              _this4.userData.youtubeHandle = response.youtubeHandle || response.influencer.youtube.youtubeHandle;
                            }
                            if (response.influencer.twitter) {
                              _this4.userData.twitterHandle = response.twitterHandle || response.influencer.twitter.twitterHandle;
                            }
                            if (response.influencer.linkedin) {
                              _this4.userData.linkedinHandle = response.linkedinHandle || response.influencer.linkedin.linkedinHandle;
                            }
                            if (response.influencer.inputedRates) {
                              if (!response.influencer.inputedRates.platforms) {
                                response.influencer.inputedRates.platforms = [];
                              }
                              _this4.inputedRates = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, response.influencer.inputedRates);

                              if (_this4.inputedRates.pricingDecks.length > 0) {
                                _this4.inputedRates.pricingDecks.map(function (item) {
                                  var mediaType = item.type.split('/')[0];
                                  if (mediaType === 'image') {
                                    _this4.images.push(item);
                                  } else {
                                    _this4.decksFiles.push(item);
                                  }
                                });
                              }
                            }

                            _this4.isProfileUpdated();
                            _this4.changeCountry();
                            _this4.fileUploadRefresh = false;
                            setTimeout(function () {
                              _this4.fileUploadRefresh = true;
                              _this4.checkOpenBillingDialog();
                            }, 1000);

                          case 21:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log('error', error);
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },

    isProfileUpdated: function isProfileUpdated() {
      if (this.userData.keywords == null || this.userData.country == null || this.userData.selectedSocialPlatforms == null || this.userData.email == null || this.userData.phone == null) {
        this.showUpdateInfo = true;
      } else if (this.userData.keywords === '' || this.userData.selectedSocialPlatforms === [] || this.userData.email === '' || this.userData.phone === '' || this.userData.bankName === '' || this.userData.bankAccount === '' || this.userData.mailingAddress === '') {
        this.showUpdateInfo = true;
      } else {
        this.showUpdateInfo = false;
      }
    },
    connectInstagram: function connectInstagram() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.getInstagramAuthURL({ facebookId: this.facebookId, userId: this.currentUserID }, __WEBPACK_IMPORTED_MODULE_16__config_APIs__["a" /* default */].INSTAGRAM_BASIC_DISPLAY_VERIFY);
    },
    prepareUpload: function prepareUpload(e) {
      var _this5 = this;

      var uploadedFiles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.target.files).map(function (i) {
        return e.target.files[i];
      });
      uploadedFiles.forEach(function (element) {
        var mediaType = element.type.split('/')[0];
        var fileType = element.name.split('.')[1];

        if (mediaType !== 'image' && fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'ppt' && fileType !== 'txt' && fileType !== 'docx') {
          _this5.$swal('File Type Not Supported, Please select a video or an image');
        } else if (mediaType === 'image') {
          var reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = function (e) {
            var buffer = e.target.result;
            __WEBPACK_IMPORTED_MODULE_24_jimp___default.a.read(buffer, function (err, img) {
              if (err) console.error(111, err);
              img.resize(500, __WEBPACK_IMPORTED_MODULE_24_jimp___default.a.AUTO).quality(100).getBase64(__WEBPACK_IMPORTED_MODULE_24_jimp___default.a.MIME_PNG, function (err, buff) {
                if (err) console.error(222, err);
                var file = __WEBPACK_IMPORTED_MODULE_15__utils__["a" /* default */].func.dataURLtoFile(buff, element.name);
                _this5.pricingDecksMedia.push(file);
                _this5.images.push({
                  url: buff,
                  src: buff,
                  name: element.name
                });
              });
            });
          };

          e.target.value = '';
        } else {
          _this5.decksFiles.push(element);
          _this5.pricingDecksMedia.push(element);
          var _reader = new FileReader();
          _reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteImage: function deleteImage(imgIndex) {
      var imgURl = this.images[imgIndex].url;

      var filename = this.images[imgIndex].url.substring(this.images[imgIndex].url.lastIndexOf('/') + 1);

      this.deleteObjectKeys.push(filename);
      this.images.splice(imgIndex, 1);

      var pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(function (item) {
        return item.url === imgURl;
      });
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1);

      var inputRateIndex = this.inputedRates.pricingDecks.findIndex(function (item) {
        return item.url === imgURl;
      });
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1);
    },
    deleteFile: function deleteFile(fileIndex) {
      var fileURL = '';
      if (this.decksFiles[fileIndex].url) {
        fileURL = this.decksFiles[fileIndex].url;
        var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        this.deleteObjectKeys.push(fileName);
      }
      this.decksFiles.splice(fileIndex, 1);

      var pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(function (item) {
        return item.url === fileURL;
      });
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1);

      var inputRateIndex = this.inputedRates.pricingDecks.findIndex(function (item) {
        return item.url === fileURL;
      });
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1);
    },
    accountDeleteReqAction: function accountDeleteReqAction() {
      var _this6 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to send Account Delete Requeest?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this6.deleteSubmitting = true;
          var requestData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
            influencerID: _this6.influencerID || '',
            instagramHandle: _this6.userData.igHandle || '',
            email: _this6.userData.email || '',
            firstName: _this6.userData.firstName || '',
            lastName: _this6.userData.lastName || ''
          });
          __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].accountDeleteRequest({ accountDeleteRequest: requestData }).then(function (response) {
            _this6.deleteSubmitting = false;
            _this6.cancelRequest = true;
          }).catch(function (error) {
            _this6.loading = false;
            _this6.$swal({
              title: 'Error!',
              text: 'Please kindly try again or contact us!',
              type: 'error'
            });

            console.log('error', error);
          });
        }
      });
    },
    cancelDeleteReqAction: function cancelDeleteReqAction() {
      var _this7 = this;

      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to cancel Account Delete Requeest?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(function (result) {
        if (result.value) {
          _this7.deleteSubmitting = true;
          __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].cancelDeleteRequest(_this7.influencerID).then(function (response) {
            _this7.deleteSubmitting = false;
            _this7.cancelRequest = false;
          }).catch(function (error) {
            _this7.loading = false;
            _this7.$swal({
              title: 'Error!',
              text: 'Please kindly try again or contact us!',
              type: 'error'
            });

            console.log('error', error);
          });
        }
      });
    },
    getInfluencerDeleteStatus: function getInfluencerDeleteStatus() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].accountDeleteStatus(_this8.influencerID).then(function (response) {
                  if (response && response.data.id) {
                    if (response.data.status === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].accountDeleteStatus.DELETED) {
                      _this8.deleted = true;
                    } else if (response.data.status === __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].accountDeleteStatus.PENDING) {
                      _this8.cancelRequest = true;
                    }
                  }
                }).catch(function (error) {
                  console.log('error', error);
                });

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    changeCountry: function changeCountry() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var country, matchBank;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this9.bankNames = [];
                country = _this9.countries.find(function (c) {
                  return c.name === _this9.userData.country;
                });

                if (country) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt('return');

              case 5:
                _this9.disableBankSelect = true;
                _context5.next = 8;
                return _this9.getBanks(country.code);

              case 8:
                matchBank = _this9.allBanks.find(function (bank) {
                  return bank.country_code === country.code;
                });

                if (matchBank && matchBank.list !== undefined) {
                  _this9.bankNames = matchBank.list.filter(function (bank) {
                    return bank.branch === null;
                  });
                }
                _this9.disableBankSelect = false;
                _context5.next = 18;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);
                _this9.bankNames = [];
                _this9.disableBankSelect = false;

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9, [[0, 13]]);
      }))();
    },
    changeProfilePicture: function changeProfilePicture() {
      this.changeAvatarDialog = true;
    },
    uploadAvatar: function uploadAvatar(path) {
      this.$store.commit('SET_AVATAR', path);
      this.changeAvatarDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your avatar is updated.',
        type: 'success'
      });
    },
    getBanks: function getBanks(code) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__Influencer_influencerAPIs__["a" /* default */].getBanks(code);

              case 3:
                _this10.allBanks = _context6.sent;
                _context6.next = 9;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);

                console.log('error', _context6.t0);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[0, 6]]);
      }))();
    },
    updatePricingDecks: function updatePricingDecks(medias) {
      this.pricingDecksMedia = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], medias);
    },
    addPlatform: function addPlatform(fieldName) {
      if (!this.inputedRates[fieldName]) {
        this.inputedRates[fieldName] = [];
      }
      this.inputedRates[fieldName].push({
        platform: '',
        url: '',
        rate: '',
        rateCurrency: 'SGD'
      });
    },
    openUpdatePlatformDialog: function openUpdatePlatformDialog() {
      this.updatePlatformDialog = true;
    },
    checkOpenBillingDialog: function checkOpenBillingDialog() {
      if (!this.userData.fullName || !this.userData.country || !this.userData.bankName || !this.userData.bankAccount || !this.userData.billingEmail || !this.userData.mailingAddress) {
        this.billingInfoDialog = true;
      }
    },
    removeSpaces: function removeSpaces() {
      this.$v.userData.email.$touch();
      this.userData.email = this.userData.email.replace(/\s/g, '');
    },
    preventPasteSpaces: function preventPasteSpaces(event) {
      var pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault();
      }
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this11.$v.$touch();

              _this11.userGender_options = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].userGenderDisplay;

              _this11.socialPlatforms = __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].socialMediaPlatforms;

              _this11.countries = __WEBPACK_IMPORTED_MODULE_27__static_sources_countries___default.a;

              _this11.pwdWarning = _this11.$store.state.user.pwdWarning;

              _this11.getFacebookStatus();

              _this11.getUserProfile();

              _this11.userHasConnectedInstagram();

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this11);
    }))();
  }
});

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userAPIs__ = __webpack_require__(19);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sortBy: 'name',
      fullPage: true,
      loader: null,
      loading: false,
      selected: [],
      headers: [{
        text: 'Instagram Handle',
        align: 'left',
        value: 'instagramHandle'
      }, { text: 'Fullname', align: 'center', value: 'fullName' }, { text: 'Email', value: 'email', align: 'left' }, { text: 'Location', value: 'location', align: 'left' }, { text: 'Created At', value: 'createdAt', align: 'left' }, { text: 'Actions', align: 'left', value: 'action' }],
      users: []
    };
  },

  methods: {
    formatTime: function formatTime(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YYYY-MM-DD hh:mm:ss');
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.users.slice();
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    getUsers: function getUsers() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var resp, displayUsers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__userAPIs__["a" /* default */].getNewUsers();

              case 3:
                resp = _context.sent;
                displayUsers = resp.users.map(function (user) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
                    id: user.id,
                    instagramHandle: user.igHandle,
                    fullName: user.firstName + ' ' + user.lastName,
                    email: user.email,
                    location: user.location,
                    createdAt: _this.formatTime(user.createdAt)
                  });
                });

                console.log(displayUsers);
                _this.users = displayUsers;
                _this.loading = false;
                return _context.abrupt('return');

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                _this.loading = false;
                _this.$swal({
                  title: 'Error',
                  text: 'Cannot load users',
                  type: 'error'
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    approveOrReject: function approveOrReject(action, userId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.showLoading();
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__userAPIs__["a" /* default */].approveOrReject(action, userId);

              case 4:
                _context2.next = 6;
                return _this2.getUsers();

              case 6:
                _this2.hideLoading();
                return _context2.abrupt('return');

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this2.hideLoading();
                _this2.$swal({
                  title: 'Error',
                  text: 'Action failed. Try again later',
                  type: 'error'
                });

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    showLoading: function showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      });
    },
    hideLoading: function hideLoading() {
      if (this.loader) this.loader.hide();
    }
  },
  created: function created() {
    this.getUsers();
  }
});

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewUserModal',
  props: ['modalId', 'userData'],
  data: function data() {
    return {
      user: null
    };
  },

  watch: {
    userData: function userData(newuserData) {
      this.user = newuserData;
    }
  },
  computed: {
    userRoleLabel: function userRoleLabel() {
      return this.user.role === undefined ? '-' : __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */]['userRolesDetails'][this.user.role]['display'];
    }
  }
});

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__userAPIs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreateUserModal__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreateUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CreateUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EditUserModal__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EditUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__EditUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ViewUserModal__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ViewUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ViewUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssignUserToClientModal__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssignUserToClientModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AssignUserToClientModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfirmUserModal__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfirmUserModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ConfirmUserModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__ = __webpack_require__(46);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'User',
  components: {
    CreateUserModal: __WEBPACK_IMPORTED_MODULE_7__CreateUserModal___default.a,
    EditUserModal: __WEBPACK_IMPORTED_MODULE_8__EditUserModal___default.a,
    ViewUserModal: __WEBPACK_IMPORTED_MODULE_9__ViewUserModal___default.a,
    AssignUserToClientModal: __WEBPACK_IMPORTED_MODULE_10__AssignUserToClientModal___default.a,
    ConfirmUserModal: __WEBPACK_IMPORTED_MODULE_11__ConfirmUserModal___default.a
  },
  data: function data() {
    return {
      createUserModalDialog: false,
      editModalId: 'edit_user_modal',
      viewModalId: 'view_user_modal',
      assignUserToClientModalId: 'assign_user_to_client_modal',
      confirmUserModalId: 'confirm_user_modal',
      editUserData: null,
      viewUserData: null,
      sortDesc: false,
      fields: [{
        text: 'First Name',
        value: 'firstName'
      }, {
        text: 'Last Name',
        value: 'lastName'
      }, {
        text: 'Email',
        value: 'email'
      }, {
        text: 'Role',
        value: 'role'
      }, {
        text: 'Actions',
        value: 'actions'
      }],
      items: [],

      pagination: {
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [],
        itemsPerPage: 15
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filters: {
        keyword: '',
        role: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    campaignsCount: function campaignsCount(state) {
      return state.campaign.campaignsCount;
    }
  }), {
    currentUserRole: function currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    editModalIdDisplay: function editModalIdDisplay() {
      return '#' + this.editModalId;
    },
    viewModalIdDisplay: function viewModalIdDisplay() {
      return '#' + this.viewModalId;
    },
    assignUserToClientModalIdDisplay: function assignUserToClientModalIdDisplay() {
      return '#' + this.assignUserToClientModalId;
    },
    confirmUserModalIdDisplay: function confirmUserModalIdDisplay() {
      return '#' + this.confirmUserModalId;
    },
    userRoleOptions: function userRoleOptions() {
      var userTypeTemp = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]['userRolesDetails']).forEach(function (element) {
        userTypeTemp.push({
          id: element,
          name: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]['userRolesDetails'][element]['display']
        });
      });
      userTypeTemp.unshift({
        id: '',
        name: '-- All --'
      });
      return userTypeTemp;
    }
  }),
  watch: {
    currentPage: function currentPage() {
      this.paginate(this.currentPage);
    },
    pagination: function pagination(newVal) {
      this.paginate(newVal.page);
    }
  },
  methods: {
    create: function create() {
      this.createUserModalDialog = true;
    },

    roleDisplay: function roleDisplay(value) {
      return value === undefined ? '-' : __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]['userRolesDetails'][value]['display'];
    },
    buttonShow: function buttonShow(type, role) {
      var roleAllow = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */]['userPermissions']['user'][type][this.currentUserRole];
      return roleAllow ? roleAllow.includes(role) : false;
    },
    updateItems: function updateItems(response) {
      this.items = response.users;
      this.totalRows = response.totalUsers;
    },
    paginate: function paginate() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.currentPage = page;
      __WEBPACK_IMPORTED_MODULE_6__userAPIs__["a" /* default */].paginate(page, this.perPage, this.filters.keyword, this.filters.role).then(function (response) {
        _this.updateItems(response);
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    createUser: function createUser(userData) {
      this.paginate(1);
    },
    deleteUser: function deleteUser(user) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var counts, userID, userRole, htmlTxt, resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                counts = {};
                userID = user.id;
                userRole = user.role;

                _this2.isLoading = false;
                htmlTxt = 'Are you sure you want to delete this influencer? This action cannot be undone.<br>';

                if (!(userRole === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].userRoles.AD_STRATEGIST || userRole === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].userRoles.ACCOUNT_MANAGER || userRole === __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].userRoles.COMPANY_ADMIN_LOW)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 8;
                return _this2.$store.dispatch('campaign/getCampaignsByAssignedID', {
                  userID: userID
                });

              case 8:
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_12__Client_clientAPIs__["a" /* default */].getClientsByAssignedID({ userID: userID });

              case 10:
                resp = _context.sent;

                if (resp) {
                  counts.clients = resp.count;
                }
                counts.campaigns = _this2.campaignsCount;
                htmlTxt += 'Total Clients: ' + counts.clients + '<br>';
                htmlTxt += 'Total Campaigns: ' + counts.campaigns;

              case 15:
                _this2.$swal({
                  title: 'Deleting',
                  html: htmlTxt,
                  type: 'error',
                  showCancelButton: true,
                  confirmButtonText: 'Delete',
                  cancelButtonText: 'Cancel',
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                  preConfirm: function preConfirm() {
                    return __WEBPACK_IMPORTED_MODULE_6__userAPIs__["a" /* default */].deleteUser(userID).then(function (response) {
                      return response;
                    }).catch(function (error) {
                      console.log('error', error);

                      _this2.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
                    });
                  },
                  allowOutsideClick: function allowOutsideClick() {
                    return !_this2.$swal.isLoading();
                  }
                }).then(function (result) {
                  if (result.value) {
                    _this2.items = _this2.items.filter(function (user) {
                      return user.id !== userID;
                    });

                    _this2.$swal({
                      title: 'Deleted',
                      text: 'The user has been deleted successfully',
                      type: 'success'
                    });
                  } else {}
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getUserDataToEdit: function getUserDataToEdit(userID) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__userAPIs__["a" /* default */].getUser(userID).then(function (response) {
        _this3.editUserData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getUserDataToView: function getUserDataToView(userID) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6__userAPIs__["a" /* default */].getUser(userID).then(function (response) {
        _this4.viewUserData = response;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    editUser: function editUser(userData) {
      var selectedIndex = -1;

      this.items.forEach(function (user, index) {
        if (user.id === userData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, userData);
      }
    }
  },
  created: function created() {
    this.paginate(this.currentPage);
  }
});

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__XeroAPIs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'XeroCallBackAuth',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    try {
      this.isLoading = true;

      var authCode = this.$route.query.code;
      if (!authCode) {
        this.$router.push({ name: 'Home' });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__XeroAPIs__["a" /* default */].handleCallback({ code: authCode }).then(function (success) {
          _this.$swal({
            type: 'success',
            text: 'Connected to Xero'
          }).then(function () {
            _this.$router.push({ name: 'Home' });
          });
        });
      }
    } catch (error) {} finally {
      this.isLoading = false;
    }
  }
});

/***/ }),
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 528,
	"./af.js": 528,
	"./am-et": 529,
	"./am-et.js": 529,
	"./ar": 537,
	"./ar-dz": 530,
	"./ar-dz.js": 530,
	"./ar-kw": 531,
	"./ar-kw.js": 531,
	"./ar-ly": 532,
	"./ar-ly.js": 532,
	"./ar-ma": 533,
	"./ar-ma.js": 533,
	"./ar-ps": 534,
	"./ar-ps.js": 534,
	"./ar-sa": 535,
	"./ar-sa.js": 535,
	"./ar-tn": 536,
	"./ar-tn.js": 536,
	"./ar.js": 537,
	"./az": 538,
	"./az.js": 538,
	"./be": 539,
	"./be.js": 539,
	"./bg": 540,
	"./bg.js": 540,
	"./bm": 541,
	"./bm.js": 541,
	"./bn": 543,
	"./bn-bd": 542,
	"./bn-bd.js": 542,
	"./bn.js": 543,
	"./bo": 544,
	"./bo.js": 544,
	"./br": 545,
	"./br.js": 545,
	"./bs": 546,
	"./bs.js": 546,
	"./ca": 547,
	"./ca.js": 547,
	"./cs": 548,
	"./cs.js": 548,
	"./cv": 549,
	"./cv.js": 549,
	"./cy": 550,
	"./cy.js": 550,
	"./da": 551,
	"./da.js": 551,
	"./de": 554,
	"./de-at": 552,
	"./de-at.js": 552,
	"./de-ch": 553,
	"./de-ch.js": 553,
	"./de.js": 554,
	"./dv": 555,
	"./dv.js": 555,
	"./el": 556,
	"./el.js": 556,
	"./en-au": 557,
	"./en-au.js": 557,
	"./en-ca": 558,
	"./en-ca.js": 558,
	"./en-gb": 559,
	"./en-gb.js": 559,
	"./en-ie": 560,
	"./en-ie.js": 560,
	"./en-il": 561,
	"./en-il.js": 561,
	"./en-in": 562,
	"./en-in.js": 562,
	"./en-nz": 563,
	"./en-nz.js": 563,
	"./en-sg": 564,
	"./en-sg.js": 564,
	"./eo": 565,
	"./eo.js": 565,
	"./es": 569,
	"./es-do": 566,
	"./es-do.js": 566,
	"./es-mx": 567,
	"./es-mx.js": 567,
	"./es-us": 568,
	"./es-us.js": 568,
	"./es.js": 569,
	"./et": 570,
	"./et.js": 570,
	"./eu": 571,
	"./eu.js": 571,
	"./fa": 572,
	"./fa.js": 572,
	"./fi": 573,
	"./fi.js": 573,
	"./fil": 574,
	"./fil.js": 574,
	"./fo": 575,
	"./fo.js": 575,
	"./fr": 578,
	"./fr-ca": 576,
	"./fr-ca.js": 576,
	"./fr-ch": 577,
	"./fr-ch.js": 577,
	"./fr.js": 578,
	"./fy": 579,
	"./fy.js": 579,
	"./ga": 580,
	"./ga.js": 580,
	"./gd": 581,
	"./gd.js": 581,
	"./gl": 582,
	"./gl.js": 582,
	"./gom-deva": 583,
	"./gom-deva.js": 583,
	"./gom-latn": 584,
	"./gom-latn.js": 584,
	"./gu": 585,
	"./gu.js": 585,
	"./he": 586,
	"./he.js": 586,
	"./hi": 587,
	"./hi.js": 587,
	"./hr": 588,
	"./hr.js": 588,
	"./hu": 589,
	"./hu.js": 589,
	"./hy-am": 590,
	"./hy-am.js": 590,
	"./id": 591,
	"./id.js": 591,
	"./is": 592,
	"./is.js": 592,
	"./it": 594,
	"./it-ch": 593,
	"./it-ch.js": 593,
	"./it.js": 594,
	"./ja": 595,
	"./ja.js": 595,
	"./jv": 596,
	"./jv.js": 596,
	"./ka": 597,
	"./ka.js": 597,
	"./kk": 598,
	"./kk.js": 598,
	"./km": 599,
	"./km.js": 599,
	"./kn": 600,
	"./kn.js": 600,
	"./ko": 601,
	"./ko.js": 601,
	"./ku": 603,
	"./ku-kmr": 602,
	"./ku-kmr.js": 602,
	"./ku.js": 603,
	"./ky": 604,
	"./ky.js": 604,
	"./lb": 605,
	"./lb.js": 605,
	"./lo": 606,
	"./lo.js": 606,
	"./lt": 607,
	"./lt.js": 607,
	"./lv": 608,
	"./lv.js": 608,
	"./me": 609,
	"./me.js": 609,
	"./mi": 610,
	"./mi.js": 610,
	"./mk": 611,
	"./mk.js": 611,
	"./ml": 612,
	"./ml.js": 612,
	"./mn": 613,
	"./mn.js": 613,
	"./mr": 614,
	"./mr.js": 614,
	"./ms": 616,
	"./ms-my": 615,
	"./ms-my.js": 615,
	"./ms.js": 616,
	"./mt": 617,
	"./mt.js": 617,
	"./my": 618,
	"./my.js": 618,
	"./nb": 619,
	"./nb.js": 619,
	"./ne": 620,
	"./ne.js": 620,
	"./nl": 622,
	"./nl-be": 621,
	"./nl-be.js": 621,
	"./nl.js": 622,
	"./nn": 623,
	"./nn.js": 623,
	"./oc-lnc": 624,
	"./oc-lnc.js": 624,
	"./pa-in": 625,
	"./pa-in.js": 625,
	"./pl": 626,
	"./pl.js": 626,
	"./ps": 627,
	"./ps.js": 627,
	"./pt": 629,
	"./pt-br": 628,
	"./pt-br.js": 628,
	"./pt.js": 629,
	"./ro": 630,
	"./ro.js": 630,
	"./ru": 631,
	"./ru.js": 631,
	"./sd": 632,
	"./sd.js": 632,
	"./se": 633,
	"./se.js": 633,
	"./si": 634,
	"./si.js": 634,
	"./sk": 635,
	"./sk.js": 635,
	"./sl": 636,
	"./sl.js": 636,
	"./sq": 637,
	"./sq.js": 637,
	"./sr": 639,
	"./sr-cyrl": 638,
	"./sr-cyrl.js": 638,
	"./sr.js": 639,
	"./ss": 640,
	"./ss.js": 640,
	"./sv": 641,
	"./sv.js": 641,
	"./sw": 642,
	"./sw.js": 642,
	"./ta": 643,
	"./ta.js": 643,
	"./te": 644,
	"./te.js": 644,
	"./tet": 645,
	"./tet.js": 645,
	"./tg": 646,
	"./tg.js": 646,
	"./th": 647,
	"./th.js": 647,
	"./tk": 648,
	"./tk.js": 648,
	"./tl-ph": 649,
	"./tl-ph.js": 649,
	"./tlh": 650,
	"./tlh.js": 650,
	"./tr": 651,
	"./tr.js": 651,
	"./tzl": 652,
	"./tzl.js": 652,
	"./tzm": 654,
	"./tzm-latn": 653,
	"./tzm-latn.js": 653,
	"./tzm.js": 654,
	"./ug-cn": 655,
	"./ug-cn.js": 655,
	"./uk": 656,
	"./uk.js": 656,
	"./ur": 657,
	"./ur.js": 657,
	"./uz": 659,
	"./uz-latn": 658,
	"./uz-latn.js": 658,
	"./uz.js": 659,
	"./vi": 660,
	"./vi.js": 660,
	"./x-pseudo": 661,
	"./x-pseudo.js": 661,
	"./yo": 662,
	"./yo.js": 662,
	"./zh-cn": 663,
	"./zh-cn.js": 663,
	"./zh-hk": 664,
	"./zh-hk.js": 664,
	"./zh-mo": 665,
	"./zh-mo.js": 665,
	"./zh-tw": 666,
	"./zh-tw.js": 666
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1670;

/***/ }),
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1339)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(2018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1384)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(2088),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1370)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(2068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1402)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(2115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1476)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(2224),
  /* scopeId */
  "data-v-7f87b417",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1543)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(2315),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1521)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(2288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1310)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1982),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(2228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1497)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(2262),
  /* scopeId */
  "data-v-ab12e462",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1395)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(2105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(2025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1550)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(2322),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1302)
__webpack_require__(1301)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1972),
  /* scopeId */
  "data-v-02c39e8d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1299)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1969),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1517)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(2283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1397)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(2108),
  /* scopeId */
  "data-v-495b8751",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1461)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(2202),
  /* scopeId */
  "data-v-753511ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1459)
__webpack_require__(1460)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(2201),
  /* scopeId */
  "data-v-75122d03",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1489)
__webpack_require__(1490)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(2248),
  /* scopeId */
  "data-v-9e5de260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1337)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(2014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1414)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(2139),
  /* scopeId */
  "data-v-5960f951",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(2089),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(2082),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(2134),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(2093),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1450)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(2193),
  /* scopeId */
  "data-v-72ededd2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1361)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(2051),
  /* scopeId */
  "data-v-29e75ff2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1326)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(2006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1353)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(2039),
  /* scopeId */
  "data-v-23e30d53",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1404)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(2117),
  /* scopeId */
  "data-v-4de1f01e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1487)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(2246),
  /* scopeId */
  "data-v-9dc481ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(2242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1427)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(2159),
  /* scopeId */
  "data-v-63f74616",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1440)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(2176),
  /* scopeId */
  "data-v-6bd84ab7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1975),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(2047),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(2102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1501)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(2268),
  /* scopeId */
  "data-v-b0a27590",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1391)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(2100),
  /* scopeId */
  "data-v-44950365",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(2103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1533)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(2304),
  /* scopeId */
  "data-v-dfb74610",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1374)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(2073),
  /* scopeId */
  "data-v-33f8a9b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(2148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(2119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1366)
__webpack_require__(1367)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(2064),
  /* scopeId */
  "data-v-2f736194",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(2120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1379)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(2077),
  /* scopeId */
  "data-v-36804d80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(2027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(2266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1408)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(2127),
  /* scopeId */
  "data-v-53a71053",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1393)
__webpack_require__(1394)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(2104),
  /* scopeId */
  "data-v-46aa5388",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(2211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(2043),
  /* scopeId */
  "data-v-25cebac0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1551)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(2323),
  /* scopeId */
  "data-v-f7abdb72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1321)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(2000),
  /* scopeId */
  "data-v-0e2d9daa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(931),
  /* template */
  __webpack_require__(2326),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(2284),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(933),
  /* template */
  __webpack_require__(2022),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(934),
  /* template */
  __webpack_require__(2238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1341)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(2020),
  /* scopeId */
  "data-v-1b50e593",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1411)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(2133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(939),
  /* template */
  __webpack_require__(2178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(2114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1382)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(941),
  /* template */
  __webpack_require__(2086),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1386)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(2091),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1467)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(2209),
  /* scopeId */
  "data-v-78d73f4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1405)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(2121),
  /* scopeId */
  "data-v-50023420",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1473)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(2219),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1378)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(2076),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1419)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(2142),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(2132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1452)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(2196),
  /* scopeId */
  "data-v-73a52fda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(1971),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1534)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(2305),
  /* scopeId */
  "data-v-e0beb9d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1434)
__webpack_require__(1433)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(2169),
  /* scopeId */
  "data-v-687afd8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(2280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(2157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1406)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(2124),
  /* scopeId */
  "data-v-52317ac6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1532)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(2303),
  /* scopeId */
  "data-v-dedad9e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1403)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(2116),
  /* scopeId */
  "data-v-4c7ac502",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1318)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(1995),
  /* scopeId */
  "data-v-0a246973",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(2137),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1392)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(962),
  /* template */
  __webpack_require__(2101),
  /* scopeId */
  "data-v-44fc84e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(2182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(2320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1464)
__webpack_require__(1463)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(2205),
  /* scopeId */
  "data-v-77514770",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(2222),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(2292),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1368)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(2065),
  /* scopeId */
  "data-v-2fb90f2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1346)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(2030),
  /* scopeId */
  "data-v-1e69c6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1516)
__webpack_require__(1515)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(974),
  /* template */
  __webpack_require__(2282),
  /* scopeId */
  "data-v-bd2e3964",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(975),
  /* template */
  __webpack_require__(2135),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(1981),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1400)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(978),
  /* template */
  __webpack_require__(2112),
  /* scopeId */
  "data-v-4be6504e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(979),
  /* template */
  __webpack_require__(2145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(2153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(981),
  /* template */
  __webpack_require__(1979),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(2001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(983),
  /* template */
  __webpack_require__(2294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1444)
__webpack_require__(1443)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(985),
  /* template */
  __webpack_require__(2183),
  /* scopeId */
  "data-v-6fb1cb00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(986),
  /* template */
  __webpack_require__(2063),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(987),
  /* template */
  __webpack_require__(2171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(988),
  /* template */
  __webpack_require__(2278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(989),
  /* template */
  __webpack_require__(1985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(990),
  /* template */
  __webpack_require__(2005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(991),
  /* template */
  __webpack_require__(2296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(993),
  /* template */
  __webpack_require__(2045),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(994),
  /* template */
  __webpack_require__(2254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1544)
__webpack_require__(1545)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(995),
  /* template */
  __webpack_require__(2316),
  /* scopeId */
  "data-v-f1c2f008",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1387)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(997),
  /* template */
  __webpack_require__(2092),
  /* scopeId */
  "data-v-3f3b8bfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(2301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1445)
__webpack_require__(1446)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(2184),
  /* scopeId */
  "data-v-6fc3ec28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1001),
  /* template */
  __webpack_require__(2257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1002),
  /* template */
  __webpack_require__(2078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(2060),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1510)
__webpack_require__(1511)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(2276),
  /* scopeId */
  "data-v-b846093c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1006),
  /* template */
  __webpack_require__(2229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1493)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1007),
  /* template */
  __webpack_require__(2256),
  /* scopeId */
  "data-v-a0a0d2ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(2024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1009),
  /* template */
  __webpack_require__(2062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1010),
  /* template */
  __webpack_require__(2122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1011),
  /* template */
  __webpack_require__(2156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1013),
  /* template */
  __webpack_require__(2308),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1465)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1017),
  /* template */
  __webpack_require__(2207),
  /* scopeId */
  "data-v-7853043a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1333)
__webpack_require__(1334)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1021),
  /* template */
  __webpack_require__(2011),
  /* scopeId */
  "data-v-12f87416",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1546)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1022),
  /* template */
  __webpack_require__(2317),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1024),
  /* template */
  __webpack_require__(2230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1380)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1025),
  /* template */
  __webpack_require__(2080),
  /* scopeId */
  "data-v-3b5c1165",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1415)
__webpack_require__(1416)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1026),
  /* template */
  __webpack_require__(2140),
  /* scopeId */
  "data-v-59e09c75",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1027),
  /* template */
  __webpack_require__(2053),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1028),
  /* template */
  __webpack_require__(2168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1439)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1029),
  /* template */
  __webpack_require__(2175),
  /* scopeId */
  "data-v-6b81115e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1528)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1030),
  /* template */
  __webpack_require__(2298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1345)
__webpack_require__(1344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1031),
  /* template */
  __webpack_require__(2028),
  /* scopeId */
  "data-v-1e5abced",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1495)
__webpack_require__(1496)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1033),
  /* template */
  __webpack_require__(2261),
  /* scopeId */
  "data-v-a90aa13c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1455)
__webpack_require__(1454)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1034),
  /* template */
  __webpack_require__(2198),
  /* scopeId */
  "data-v-73d1105e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1315)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1035),
  /* template */
  __webpack_require__(1990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1354)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1036),
  /* template */
  __webpack_require__(2040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1436)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1037),
  /* template */
  __webpack_require__(2172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1313)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1038),
  /* template */
  __webpack_require__(1986),
  /* scopeId */
  "data-v-0782bbe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1441)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1039),
  /* template */
  __webpack_require__(2177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1040),
  /* template */
  __webpack_require__(2306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1474)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1041),
  /* template */
  __webpack_require__(2221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1375)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1042),
  /* template */
  __webpack_require__(2074),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1536)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1045),
  /* template */
  __webpack_require__(2310),
  /* scopeId */
  "data-v-ecae0f50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1050),
  /* template */
  __webpack_require__(2160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1424)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1054),
  /* template */
  __webpack_require__(2151),
  /* scopeId */
  "data-v-60046f72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1056),
  /* template */
  __webpack_require__(2191),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1057),
  /* template */
  __webpack_require__(2072),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1360)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1059),
  /* template */
  __webpack_require__(2049),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(2188),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1063),
  /* template */
  __webpack_require__(2215),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1442)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1067),
  /* template */
  __webpack_require__(2180),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1338)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1068),
  /* template */
  __webpack_require__(2017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1069),
  /* template */
  __webpack_require__(1996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1070),
  /* template */
  __webpack_require__(2147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1429)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1071),
  /* template */
  __webpack_require__(2162),
  /* scopeId */
  "data-v-650502ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1514)
__webpack_require__(1513)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1072),
  /* template */
  __webpack_require__(2279),
  /* scopeId */
  "data-v-bacc1826",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1447)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1073),
  /* template */
  __webpack_require__(2187),
  /* scopeId */
  "data-v-710749e7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1074),
  /* template */
  __webpack_require__(2155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1075),
  /* template */
  __webpack_require__(2216),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1076),
  /* template */
  __webpack_require__(2249),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1077),
  /* template */
  __webpack_require__(2179),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1078),
  /* template */
  __webpack_require__(2181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1079),
  /* template */
  __webpack_require__(2094),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1423)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1080),
  /* template */
  __webpack_require__(2150),
  /* scopeId */
  "data-v-5ee1c366",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1081),
  /* template */
  __webpack_require__(2300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1324)
__webpack_require__(1323)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1082),
  /* template */
  __webpack_require__(2003),
  /* scopeId */
  "data-v-0f39eebe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1083),
  /* template */
  __webpack_require__(2144),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1372)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1085),
  /* template */
  __webpack_require__(2070),
  /* scopeId */
  "data-v-3324e6cf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1086),
  /* template */
  __webpack_require__(2244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1088),
  /* template */
  __webpack_require__(2055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1089),
  /* template */
  __webpack_require__(2032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1297)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1090),
  /* template */
  __webpack_require__(1966),
  /* scopeId */
  "data-v-015a6d0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1505)
__webpack_require__(1504)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1091),
  /* template */
  __webpack_require__(2271),
  /* scopeId */
  "data-v-b229900e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1092),
  /* template */
  __webpack_require__(2166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1093),
  /* template */
  __webpack_require__(2081),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1095),
  /* template */
  __webpack_require__(2131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1298)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1096),
  /* template */
  __webpack_require__(1967),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1388)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1097),
  /* template */
  __webpack_require__(2095),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1099),
  /* template */
  __webpack_require__(2195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1485)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1100),
  /* template */
  __webpack_require__(2243),
  /* scopeId */
  "data-v-977b889a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1101),
  /* template */
  __webpack_require__(2016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1104),
  /* template */
  __webpack_require__(2021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1412)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1105),
  /* template */
  __webpack_require__(2136),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1509)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1107),
  /* template */
  __webpack_require__(2275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1108),
  /* template */
  __webpack_require__(2029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1317)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1109),
  /* template */
  __webpack_require__(1993),
  /* scopeId */
  "data-v-09849f90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1305)
__webpack_require__(1306)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1110),
  /* template */
  __webpack_require__(1976),
  /* scopeId */
  "data-v-0362f15e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1111),
  /* template */
  __webpack_require__(2241),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1112),
  /* template */
  __webpack_require__(1991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1113),
  /* template */
  __webpack_require__(2109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1469)
__webpack_require__(1468)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1114),
  /* template */
  __webpack_require__(2210),
  /* scopeId */
  "data-v-7a8ac0a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1115),
  /* template */
  __webpack_require__(2167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1503)
__webpack_require__(1502)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1116),
  /* template */
  __webpack_require__(2269),
  /* scopeId */
  "data-v-b1368a38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1451)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1117),
  /* template */
  __webpack_require__(2194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1328)
__webpack_require__(1327)
__webpack_require__(1329)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1118),
  /* template */
  __webpack_require__(2007),
  /* scopeId */
  "data-v-10a04ce1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1462)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1119),
  /* template */
  __webpack_require__(2203),
  /* scopeId */
  "data-v-759d2863",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1526)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1120),
  /* template */
  __webpack_require__(2293),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1123),
  /* template */
  __webpack_require__(2270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1478)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1125),
  /* template */
  __webpack_require__(2226),
  /* scopeId */
  "data-v-80ae349c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1542)
__webpack_require__(1541)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1126),
  /* template */
  __webpack_require__(2314),
  /* scopeId */
  "data-v-ef0c73fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1492)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1127),
  /* template */
  __webpack_require__(2255),
  /* scopeId */
  "data-v-a04a259e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1432)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1128),
  /* template */
  __webpack_require__(2165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1531)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1129),
  /* template */
  __webpack_require__(2302),
  /* scopeId */
  "data-v-dcfc63ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1312)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1131),
  /* template */
  __webpack_require__(1984),
  /* scopeId */
  "data-v-0730ebca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1417)
__webpack_require__(1418)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1132),
  /* template */
  __webpack_require__(2141),
  /* scopeId */
  "data-v-5a277cfd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1133),
  /* template */
  __webpack_require__(2265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1553)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1134),
  /* template */
  __webpack_require__(2325),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1347)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1136),
  /* template */
  __webpack_require__(2031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1320)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1137),
  /* template */
  __webpack_require__(1998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1527)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1138),
  /* template */
  __webpack_require__(2297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1507)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1139),
  /* template */
  __webpack_require__(2273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1477)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1140),
  /* template */
  __webpack_require__(2225),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1401)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1141),
  /* template */
  __webpack_require__(2113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1142),
  /* template */
  __webpack_require__(2037),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1309)
__webpack_require__(1308)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1143),
  /* template */
  __webpack_require__(1980),
  /* scopeId */
  "data-v-05d5a88a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1144),
  /* template */
  __webpack_require__(2217),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1146),
  /* template */
  __webpack_require__(2239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1147),
  /* template */
  __webpack_require__(2034),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1330)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1148),
  /* template */
  __webpack_require__(2008),
  /* scopeId */
  "data-v-1114e1f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1331)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1150),
  /* template */
  __webpack_require__(2009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1151),
  /* template */
  __webpack_require__(2125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1153),
  /* template */
  __webpack_require__(1987),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1359)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1154),
  /* template */
  __webpack_require__(2048),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1420)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1157),
  /* template */
  __webpack_require__(2143),
  /* scopeId */
  "data-v-5bcf8a5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1158),
  /* template */
  __webpack_require__(2057),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1396)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1161),
  /* template */
  __webpack_require__(2106),
  /* scopeId */
  "data-v-48b52855",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1162),
  /* template */
  __webpack_require__(2250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1399)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1163),
  /* template */
  __webpack_require__(2111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1165),
  /* template */
  __webpack_require__(2295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1350)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1167),
  /* template */
  __webpack_require__(2035),
  /* scopeId */
  "data-v-20c19040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1169),
  /* template */
  __webpack_require__(2015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1426)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1170),
  /* template */
  __webpack_require__(2158),
  /* scopeId */
  "data-v-63b31dbd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1172),
  /* template */
  __webpack_require__(2107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1407)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1173),
  /* template */
  __webpack_require__(2126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1506)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1174),
  /* template */
  __webpack_require__(2272),
  /* scopeId */
  "data-v-b25ca306",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1175),
  /* template */
  __webpack_require__(1977),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1458)
__webpack_require__(1457)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1177),
  /* template */
  __webpack_require__(2200),
  /* scopeId */
  "data-v-7497676b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1179),
  /* template */
  __webpack_require__(2061),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1552)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1180),
  /* template */
  __webpack_require__(2324),
  /* scopeId */
  "data-v-fd06f5bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1357)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1181),
  /* template */
  __webpack_require__(2044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1456)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1182),
  /* template */
  __webpack_require__(2199),
  /* scopeId */
  "data-v-746876d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1453)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1184),
  /* template */
  __webpack_require__(2197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1472)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1185),
  /* template */
  __webpack_require__(2218),
  /* scopeId */
  "data-v-7d6a15c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1322)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1186),
  /* template */
  __webpack_require__(2002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1425)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1187),
  /* template */
  __webpack_require__(2154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1362)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1188),
  /* template */
  __webpack_require__(2052),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1336)
__webpack_require__(1335)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1189),
  /* template */
  __webpack_require__(2012),
  /* scopeId */
  "data-v-14d77608",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1190),
  /* template */
  __webpack_require__(2307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1422)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1191),
  /* template */
  __webpack_require__(2149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1480)
__webpack_require__(1479)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1192),
  /* template */
  __webpack_require__(2231),
  /* scopeId */
  "data-v-8779c2de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1519)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1193),
  /* template */
  __webpack_require__(2286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(2059),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("mdi-file-check")]), _vm._v(" Invoices\n      ")], 1)]), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "mt-3 no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [(_vm.selectedItems && _vm.selectedItems.length > 0) ? _c('div', [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteInvoice(_vm.selectedItems)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" Delete\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.downloadInvoices()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v(" Download (" + _vm._s(_vm.selectedItems.length) + ")\n                ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Uploaded Date",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.searchFilter()
            }
          },
          model: {
            value: (_vm.filter.searchMonth),
            callback: function($$v) {
              _vm.$set(_vm.filter, "searchMonth", $$v)
            },
            expression: "filter.searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.filter.monthPicker),
      callback: function($$v) {
        _vm.$set(_vm.filter, "monthPicker", $$v)
      },
      expression: "filter.monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filter.searchMonth),
      callback: function($$v) {
        _vm.$set(_vm.filter, "searchMonth", $$v)
      },
      expression: "filter.searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMonth()
      }
    }
  }, [_vm._v("\n                      Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchMonthOk()
      }
    }
  }, [_vm._v("\n                      OK\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter.search),
      callback: function($$v) {
        _vm.$set(_vm.filter, "search", $$v)
      },
      expression: "filter.search"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "items-per-page": 10,
      "search": _vm.filter.search,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllItems
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "custom-checkbox",
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedItems),
            callback: function($$v) {
              _vm.selectedItems = $$v
            },
            expression: "selectedItems"
          }
        })]
      }
    }, {
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('social-handle', {
          attrs: {
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": item.platform === 'instagram',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle
          }
        })], 1)]
      }
    }, {
      key: "item.swiftCode",
      fn: function(ref) {
        var item = ref.item;

        return [(item.swiftCodeEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'swiftCode')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.swiftCode))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.swiftCode),
            callback: function($$v) {
              _vm.$set(item, "swiftCode", $$v)
            },
            expression: "item.swiftCode"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.bankAccount",
      fn: function(ref) {
        var item = ref.item;

        return [(item.bankAccountEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'bankAccount')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.bankAccount))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.bankAccount),
            callback: function($$v) {
              _vm.$set(item, "bankAccount", $$v)
            },
            expression: "item.bankAccount"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.username",
      fn: function(ref) {
        var item = ref.item;

        return [(item.usernameEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'username')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.username))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.username),
            callback: function($$v) {
              _vm.$set(item, "username", $$v)
            },
            expression: "item.username"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("\n                  " + _vm._s(item.amount || '-') + "\n                  "), (item.GST) ? _c('v-icon', {
          attrs: {
            "small": "",
            "color": "warning",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "title": "Include GST 9%"
          }
        }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.remarks",
      fn: function(ref) {
        var item = ref.item;

        return [(item.remarksEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'remarks')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.remarks || '-'))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.remarks),
            callback: function($$v) {
              _vm.$set(item, "remarks", $$v)
            },
            expression: "item.remarks"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.createdAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.utils.formatCustomDate(item.createdAt, 'DD/MM/YYYY')) + "\n                ")])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Invoice",
            "href": item.invoice.url,
            "color": "info",
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action mb-2",
          staticStyle: {
            "height": "36px"
          },
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openEditModal(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action mb-2",
          staticStyle: {
            "height": "36px"
          },
          attrs: {
            "color": "error",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteInvoice([item])
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-delete")])], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [(_vm.alert_message != '') ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: _vm.alert_style
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close_alert_message
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.alert_header) + " ")]), _vm._v("\n          " + _vm._s(_vm.alert_message) + "            \n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': _vm.$v.campaignPayout.campaignName.$error
    }
  }, [_c('label', [_vm._v("Name of campaign")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.campaignName),
      expression: "campaignPayout.campaignName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter campaign name for payout"
    },
    domProps: {
      "value": (_vm.campaignPayout.campaignName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaignPayout, "campaignName", $event.target.value)
      }, function($event) {
        return _vm.$v.campaignPayout.campaignName.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.campaignPayout.campaignName.required && _vm.$v.campaignPayout.campaignName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Campaign name is required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': _vm.$v.campaignPayout.instagram_post_url.$error
    }
  }, [_c('label', [_vm._v("Please submit the URL to your Instagram posting here")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.instagram_post_url),
      expression: "campaignPayout.instagram_post_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter instagram post url for payout"
    },
    domProps: {
      "value": (_vm.campaignPayout.instagram_post_url)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaignPayout, "instagram_post_url", $event.target.value)
      }, function($event) {
        return _vm.$v.campaignPayout.instagram_post_url.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.campaignPayout.instagram_post_url.required && _vm.$v.campaignPayout.instagram_post_url.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Instagram post url is required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Please submit the URL to your other Social Media posting here")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.other_social_media_post_url),
      expression: "campaignPayout.other_social_media_post_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter other social media post url for payout"
    },
    domProps: {
      "value": (_vm.campaignPayout.other_social_media_post_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaignPayout, "other_social_media_post_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Please provide your satisfaction level with this campaign")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.satisfaction_level),
      expression: "campaignPayout.satisfaction_level"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaignPayout, "satisfaction_level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.ratingLevels), function(rating) {
    return _c('option', {
      key: rating.value,
      domProps: {
        "value": rating.value
      }
    }, [_vm._v(_vm._s(rating.level))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Please rate your experience with the advertiser's product/services.")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.advertiser_satisfaction_level),
      expression: "campaignPayout.advertiser_satisfaction_level"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaignPayout, "advertiser_satisfaction_level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.ratingLevels), function(rating) {
    return _c('option', {
      key: rating.value,
      domProps: {
        "value": rating.value
      }
    }, [_vm._v(_vm._s(rating.level))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("We are dedicated to make the world a better place for our Kobeers. Do provide us with your opinions on how we could improve! (Don't hold back - we're able to handle any opinions!)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.feedback),
      expression: "campaignPayout.feedback"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter feedback here"
    },
    domProps: {
      "value": (_vm.campaignPayout.feedback)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaignPayout, "feedback", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaignPayout.subscription),
      expression: "campaignPayout.subscription"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaignPayout, "subscription", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" Yes ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" No ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createCampaignPayout
    }
  }, [_vm._v("Submit")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("KOBE is exploring a new option where a portion of your payout will be contributed to a greater cause. "), _c('br'), _vm._v("\n          If you would like to be a part of this movement, kindly select \"Yes\" below and we will send you an email shortly with more details:\n          ")])
}]}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.divClassName ? _vm.divClassName : ''
  }, [(_vm.isTikTok) ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.tiktokHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.tiktokHandle))]) : _vm._e(), _vm._v(" "), (_vm.isInstagram) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openLink('http://instagram.com/' + _vm.instagramHandle)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.instagramHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebook && _vm.facebookHandle) ? _c('a', {
    attrs: {
      "href": 'https://facebook.com/' + _vm.facebookHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#1877F2 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(_vm.facebookHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isLinkedIn && _vm.linkedinHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#0A66C2 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.linkedinHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isTwitter && _vm.twitterHandle) ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + _vm.twitterHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.twitterHandle))]) : _vm._e(), _vm._v(" "), (_vm.isYoutube) ? _c('a', {
    attrs: {
      "href": _vm.showYoutubeURL(_vm.youtubeURL),
      "target": "_blank"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#FF0000 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.youtubeHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isXiaohongshu) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + _vm.xiaohongshuHandle)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/xhs-black.png",
      "width": "20px"
    }
  }), _vm._v(" " + _vm._s(_vm.xiaohongshuFullName || _vm.xiaohongshuHandle))]) : _vm._e(), _vm._v(" "), (_vm.isOthers) ? _c('a', [_c('v-icon', {
    staticStyle: {
      "color": "#616161 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-help-circle")]), _vm._v(" " + _vm._s(_vm.otherHandle))], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    attrs: {
      "id": "editorjs"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "editor-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1 white--text",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download\n      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "width": "200"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("\n      Close\n      ")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n        Close\n      ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("     \n    " + _vm._s(_vm.snackbarText) + "\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("XHS Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "xhs-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "item-key": "key",
      "items-per-page": -1,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": 'https://xiaohongshu.com/user/profile/' + item.name,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.name))])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n                  ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n                  ")]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n                  ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews === 0 ? '-' : _vm.totalViews)))] : (header.value === 'watches') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalWatches == 0 ? '-' : _vm.totalWatches)))] : (header.value === 'like_count') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'bookmarks') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalBookmarks === 0 ? '-' : _vm.totalBookmarks)))] : (header.value === 'comment_count') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "XHS Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatexhsAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Update Active Year\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-combobox', {
    attrs: {
      "items": _vm.years,
      "hide-selected": "",
      "chips": "",
      "label": "Active Year",
      "multiple": "",
      "error-messages": _vm.$v.updateData.activeYear.$error && "Active Year is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.activeYear.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.activeYear.$touch()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.updateData.activeYear),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "activeYear", $$v)
      },
      expression: "updateData.activeYear"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app-bar', {
    staticClass: "kobe-app-bar",
    attrs: {
      "app": "",
      "clipped-left": _vm.$vuetify.breakpoint.xsOnly,
      "dense": _vm.$vuetify.breakpoint.xsOnly,
      "color": "primary",
      "elevate-on-scroll": ""
    }
  }, [(_vm.$vuetify.breakpoint.xsOnly) ? _c('v-app-bar-nav-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('openDrawer')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.xsOnly) ? _c('v-toolbar-title', {
    class: {
      'pl-0': _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('div', {
    staticClass: "toolbar-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Logo"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.xsOnly) ? _c('v-spacer') : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.routerName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showActivePlatform) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [(_vm.showActivePlatform.icon) ? _c('v-icon', {
          staticClass: "pt-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(_vm.showActivePlatform.icon))]) : _vm._e(), _vm._v(" "), (_vm.showActivePlatform.imgIcon) ? _c('img', {
          attrs: {
            "src": _vm.showActivePlatform.imgIcon,
            "width": "20px"
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.showActivePlatform.handle) + " "), _c('v-icon', [_vm._v("mdi-chevron-down")])], 1)]
      }
    }], null, false, 2653615959)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.userPlatforms), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePlatform(obj)
        }
      }
    }, [_c('v-list-item-title', [(obj.icon) ? _c('v-icon', [_vm._v(_vm._s(obj.icon))]) : _vm._e(), _vm._v(" "), (obj.imgIcon) ? _c('img', {
      attrs: {
        "src": obj.imgIcon,
        "width": "20px"
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(obj.handle) + "\n          ")], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 370,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-avatar', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "icon": "",
            "size": "40"
          }
        }, on), [_c('img', {
          attrs: {
            "src": _vm.activeUser.avatar
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.profileMenu),
      callback: function($$v) {
        _vm.profileMenu = $$v
      },
      expression: "profileMenu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-item', [_c('v-list-item-avatar', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "size": "75"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.activeUser.avatar,
      "alt": "User Profile Image"
    },
    on: {
      "click": _vm.changeProfilePicture
    }
  })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.activeUser.displayName))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.activeUser.role)), _c('br'), _vm._v(_vm._s(_vm.activeUser.email))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.updateNewPassword
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('change-avatar-modal', {
    attrs: {
      "value": _vm.changeAvatarDialog
    },
    on: {
      "changeAvatar": _vm.uploadAvatar
    },
    model: {
      value: (_vm.changeAvatarDialog),
      callback: function($$v) {
        _vm.changeAvatarDialog = $$v
      },
      expression: "changeAvatarDialog"
    }
  }), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activePairingData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Confirm Payout")]), _vm._v(" "), _c('v-card-text', [_c('a', {
    staticClass: "title",
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.activePairingData.instagramHandle,
      "target": "_blank"
    }
  }, [_vm._v("@" + _vm._s(_vm.activePairingData.instagramHandle))]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hide-details": "",
      "prefix": "S$"
    },
    on: {
      "input": function($event) {
        return _vm.$v.activePairingData.payout.$touch()
      }
    },
    model: {
      value: (_vm.activePairingData.payout),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "payout", _vm._n($$v))
      },
      expression: "activePairingData.payout"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "remarks",
      "label": "Remarks",
      "hide-details": "",
      "value": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.activePairingData.remarks.$touch()
      }
    },
    model: {
      value: (_vm.activePairingData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "remarks", $$v)
      },
      expression: "activePairingData.remarks"
    }
  })], 1)], 1), _vm._v(" "), (_vm.activePairingData.history.length > 0) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('h4', [_vm._v("Payout History")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Date Time")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Old Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("New Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Invoice")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activePairingData.history), function(item, fileIndex) {
          return _c('tr', {
            key: item.timestamp
          }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(item.timestamp)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.old_amount)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks))]), _vm._v(" "), _c('td', [(item.invoices) ? _c('div', _vm._l((item.invoices), function(invoice, index) {
            return _c('v-btn', {
              key: index,
              attrs: {
                "text": "",
                "color": "warning",
                "href": invoice.url,
                "target": "_blank"
              }
            }, [_vm._v("\n                        View PDF\n                      ")])
          }), 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('v-btn', {
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Delete Payout",
              "color": "error",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.deletePayout(fileIndex)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("delete")])], 1)], 1)])
        }), 0)]
      },
      proxy: true
    }], null, false, 1998547521)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.viewOnly
    },
    on: {
      "click": function($event) {
        return _vm.processConfirmPayout()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.invoiceDialog,
      "influencer": _vm.influencer,
      "isGetInvoice": _vm.isGetInvoice,
      "close": _vm.closeModal
    },
    on: {
      "generatedInvoice": _vm.confirmPayout
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "absolute": "",
      "color": "primary",
      "width": "100%"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.contract.influencer_details) ? _c('v-container', [_c('v-tabs', {
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', [_vm._v("\n                Invoice\n              ")]), _vm._v(" "), _c('v-tab', [_vm._v("\n                Brief Details\n              ")]), _vm._v(" "), (_vm.hideRequiredActions()) ? _c('v-tab', [_vm._v("\n                Email Template\n              ")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "center"
    }
  }, [_c('img', {
    staticClass: "contract-logo",
    attrs: {
      "src": _vm.logoUrl
    }
  })])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin": "0px 20px 0px 0px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                        Kobe Global Technologies Pte Ltd."), _c('br'), _vm._v("\n                        GST Registration no. 201608755R"), _c('br'), _vm._v("\n                        51 Goldhill Plaza"), _c('br'), _vm._v("\n                        #14-01"), _c('br'), _vm._v("\n                        Singapore 308900"), _c('br'), _vm._v("\n                        finance@getkobe.com\n                      ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("\n                        Content Creator Details\n                      ")]), _vm._v(" "), (_vm.contract.influencer_details.platform === 'tiktok') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        TikTok Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'instagram') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        Instagram Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'youtube') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        Youtube Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'twitter') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        X (Twitter) Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'others') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("platformDisplayName")(_vm.contract.influencer_details.platformName)) + " Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        Platform Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("Company Rep Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v("Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('br'), _vm._v("\n                        (+65) 6255 5662 "), _c('br'), _vm._v("\n                        finance@getkobe.com\n                      ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("Campaign Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.contract.brief.campaignName))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v("\n                        Campaign Ref: " + _vm._s(_vm.contract.campaignID) + "\n                      ")])])])], 1), _vm._v(" "), (_vm.contract.deliverables && _vm.showDeliverables) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-top": "1px solid black"
    }
  }, [_c('thead', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "color": "white"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("AMOUNT")])])]), _vm._v(" "), _c('tbody', [(_vm.contract.deliverables.no_of_stories) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Story")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_stories))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_stories')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_tiktok_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("TikTok Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_tiktok_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_tiktok_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_xhs_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("XHS Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_xhs_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_xhs_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_fb_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Facebook ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_fb_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_fb_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_carousels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_carousels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_carousels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_video) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Video")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_video))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_video')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_igTv) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG TV")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_igTv))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_igTv')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_reels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Reels")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_reels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_reels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_li_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("LinkedIn Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_li_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_li_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_x_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("X (Twitter) Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_x_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_x_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.youtube) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Youtube")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.youtube))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('youtube')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.loading_whitelisting) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Loading/Whitelisting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.loading_whitelisting))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('loading_whitelisting')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.exclusivity) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Exclusivity ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.exclusivity))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('exclusivity')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.physical_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Physical Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.physical_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('physical_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.online_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Online Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.online_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('online_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contract.deliverables.custom), function(custom, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', [_vm._v(_vm._s(custom.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(custom.value))]), _vm._v(" "), (index === 0 && _vm.checkShowAmountRowSpan('custom')) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowspan": _vm.getRowSpanCount
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.contract.payout_details.boostingFees), function(boostingFee, index) {
    return (_vm.contract.payout_details) ? _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(boostingFee.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(boostingFee.value)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.contract.GST) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("\n                              GST\n                            ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.contract.GSTpercent)))])]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverableNotes) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.contract.deliverableNotes))
    }
  })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "text-align": "center",
      "color": "white",
      "border-left": "1px solid black"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(" TOTAL: " + _vm._s(_vm.formatPayout(_vm.contract.payout)) + " ")])])])], 2)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.contract.invoiceRemarks) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.contract.invoiceRemarks))
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTerms) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h1', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("I have read and accepted the terms of use ("), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.getkobe.com/influencer-terms-use-agreement/")]), _vm._v(").")]), _vm._v(" "), _c('li', [_vm._v("I have read and understood supporting campaign details that accompany this brief.")]), _vm._v(" "), _c('li', [_vm._v("I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.")]), _vm._v(" "), _c('li', [_vm._v("Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance,\n                          I may forfeit my rate or be deducted a penalty by the client.")]), _vm._v(" "), _c('li', [_vm._v("I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.")]), _vm._v(" "), _c('li', [_vm._v("I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.")]), _vm._v(" "), _c('li', [_vm._v("I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.")]), _vm._v(" "), _c('li', [_vm._v("If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.")]), _vm._v(" "), _c('li', [_vm._v("The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.")])])])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.briefDetailHTML)
    }
  })])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.users,
      "item-value": "id",
      "item-text": "name",
      "label": "From",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  })], 1)], 1), _vm._v(" "), (_vm.contract.influencer_details.platform === 'tiktok' || !_vm.contract.influencer_details.contact_details.email) ? _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Influencer Email",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.influencerEmail),
      callback: function($$v) {
        _vm.influencerEmail = $$v
      },
      expression: "influencerEmail"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.emailTemplateHTML),
      callback: function($$v) {
        _vm.emailTemplateHTML = $$v
      },
      expression: "emailTemplateHTML"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.showOptions) ? _c('v-checkbox', {
    attrs: {
      "align": "right",
      "rules": [function (v) { return !!v || 'You must agree to continue!'; }],
      "label": "I have read and agree to the Terms and Conditions"
    },
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "text": "",
      "dismissible": "",
      "border": "left",
      "type": "error"
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n                 Please indicate that you have read and agree to the terms and conditions.\n                ")]), _vm._v(" "), (this.selectedTab === 0 || this.selectedTab === 1) ? _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "loading": _vm.downloadloading,
      "disabled": _vm.downloadloading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download\n                "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1) : _vm._e(), _vm._v(" "), (_vm.showSendButton) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.sendClick
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-send")]), _vm._v("Send\n                ")], 1) : _vm._e(), _vm._v(" "), (_vm.showSubmitButton) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.agreeClick
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]), _vm._v("Agree")], 1) : _vm._e(), _vm._v(" "), (_vm.showDeclineButton) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.declineClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v(" mdi-cancel")]), _vm._v("Decline")], 1) : _vm._e(), _vm._v(" "), (_vm.showCancelButton) ? _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-minus-circle")]), _vm._v("Cancel")], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "error",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n          Close\n        ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarText) + "\n      ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout')
},staticRenderFns: []}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "content-class": "creator-community-modal",
      "width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Creator Community Form\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "creator-community-modal__controls"
  }, [_c('div', [_c('v-row', {
    staticClass: "text-right"
  }, [_c('v-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [(_vm.currentMode === 'detail') ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('edit')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("edit")]), _vm._v("\n              Edit\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('detail')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("close")]), _vm._v("\n              Cancel Edit\n            ")], 1) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), (_vm.currentMode === 'detail') ? _c('v-card-text', {
    staticClass: "bg-white creator-community-modal__body"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.name ? _vm.data.name : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.email ? _vm.data.email : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.dateOfBirth ? _vm.utils.formatCustomDate(_vm.data.dateOfBirth, 'DD/MM/YYYY') : '-') + "\n          ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Ethnicity")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.ethnicity && _vm.data.ethnicity !== 'Others' ? _vm.data.ethnicity : '')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.otherEth ? _vm.data.otherEth : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.country ? _vm.data.country : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.gender ? _vm.data.gender : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.contactNo ? _vm.data.contactNo : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Occupation")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.occupation || '-') + "\n          ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Instagram Handle")]), _vm._v(" "), (_vm.data.instagramHandle) ? _c('social-handle', {
    attrs: {
      "isInstagram": true,
      "instagramHandle": _vm.data.instagramHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.data.instagramHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Tiktok Handle")]), _vm._v(" "), (_vm.data.tiktokHandle) ? _c('social-handle', {
    attrs: {
      "isTikTok": true,
      "tiktokHandle": _vm.data.tiktokHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.data.tiktokHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Your IG Followers Count")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.igFollowerCount ? _vm.data.igFollowerCount : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Your TikTok Followers Count")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.tiktokFollowerCount ? _vm.data.tiktokFollowerCount : '-')))])])], 1), _vm._v(" "), _c('v-row', [(_vm.data.engagement) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Engagement")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.engagement ? (_vm.data.engagement | _vm.thousandSeprator) : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.data.views) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.views ? (_vm.data.views | _vm.thousandSeprator) : '-')))])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Content Type")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Ordinary Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Preferential rate")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Story")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igStory || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igStoryCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igStory || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igStoryCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igPost || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igPostCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igPost || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igPostCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igCarousel || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igCarouselCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igCarousel || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igCarouselCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Reel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igReel || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igReelCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igReel || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igReelCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Loading Fee")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.loadingFee || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.loadingFee || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Event Appearance")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 2401384982)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "tiktok-stats",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Tiktok")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.tiktok || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.tiktokCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.tiktok || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.tiktokCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 3338548331)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-divider', {
    staticClass: "ma-0"
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Handle of Other Platforms")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Platform")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.platforms), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v("\n                        " + _vm._s(item.platform) + "\n                        "), (item.platform === 'others') ? _c('span', [_vm._v(_vm._s(item.otherPlatform))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.rate) ? _c('span', [_vm._v(_vm._s(item.rateCurrency || 'SGD'))]) : _vm._e()])])
        }), 0)]
      },
      proxy: true
    }], null, false, 734665766)
  })], 1), _vm._v(" "), (_vm.data.pricingDecks && _vm.data.pricingDecks.length > 0) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Media Kit")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.data.pricingDecks
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.loadContent || '-') + "\n          ")]), _vm._v(" "), (_vm.data.loadContentText) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.data.loadContentText) + "\n          ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Would you like to be part of our PR or gifting collaborations with brands?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.giftBrand || '-') + "\n          ")])])], 1), _vm._v(" "), (_vm.data.keywords) ? _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Preferred type of campaigns/genre (please tick relevant)")]), _vm._v(" "), _c('div', _vm._l((_vm.data.keywords), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.transPreferredEng(item) || '-') + "\n            ")])
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.data.aboutYou) ? _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("A short description of your profile that best represents you")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.aboutYou || '-') + "\n          ")])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('div', {
    staticClass: "edit-rate-card-form creator-community-modal__body"
  }, [_c('rate-card-form', {
    attrs: {
      "value": _vm.rateCardDialog,
      "mode": "edit",
      "editData": _vm.editData
    },
    on: {
      "updated": _vm.updatedRateCardForm
    },
    model: {
      value: (_vm.rateCardDialog),
      callback: function($$v) {
        _vm.rateCardDialog = $$v
      },
      expression: "rateCardDialog"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "wrap": ""
    }
  }, [(_vm.post) ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [(_vm.influencerData) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.influencerProfileURL,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [(_vm.influencerData.platform === 'linkedin') ? _c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]) : _vm._e(), _vm._v("\n                  @" + _vm._s(_vm.influencerData.username) + "\n              ")], 1)]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.post.campaignName) + " Campaign")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "container--fluid": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.post.images.length === 0,
      "color": "info",
      "icon": "info",
      "outlined": ""
    }
  }, [_vm._v("\n                No Media found for this post.\n              ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "justify-space-around": ""
    }
  }, _vm._l((_vm.post.images), function(img, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "md4": "",
        "xs12": ""
      }
    }, [(!img.isvideo) ? _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('a', {
      attrs: {
        "href": img.url,
        "download": "",
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "src": img.url,
        "contain": "",
        "max-height": "300"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (img.publicID && img.isvideo) ? _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          videoDownload: true
        })
      }
    })], 1) : _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [(img.isvideo) ? _c('div', {
      staticClass: "elevation-8"
    }, [_c('video', {
      attrs: {
        "id": "previewVideo",
        "width": "100%",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n                        Your browser does not support the video tag.\n                      ")])]) : _vm._e()]), _vm._v(" "), (img.type === 'video/quicktime') ? _c('btn-download', {
      attrs: {
        "url": img.url
      }
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "label": "Caption",
      "value": _vm.post.captionText
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Kobe Remark",
      "counter": ""
    },
    model: {
      value: (_vm.post.remark),
      callback: function($$v) {
        _vm.$set(_vm.post, "remark", $$v)
      },
      expression: "post.remark"
    }
  })], 1), _vm._v(" "), (_vm.isVideoLink) ? _c('div', [(_vm.post.vdoLink) ? _c('div', {
    staticClass: "caption-text"
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "label": "Link",
      "value": _vm.post.vdoLink
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.post.postDate) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subtitle-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Scheduled Date: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.post.postDate))])])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("message")]), _vm._v("\n                      Internal Notes (for your internal communication only, neither Kobe nor the creators would have access to these notes)\n                    ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-container', [_c('chat-box', {
    attrs: {
      "label": "",
      "messages": _vm.clientMessages,
      "type": "internal_notes",
      "isClient": true
    },
    on: {
      "commented": _vm.sendClientMessage
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-space-between": "",
      "column": ""
    }
  }, [_c('v-flex', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStartQuestion),
      expression: "showStartQuestion"
    }],
    staticClass: "elevation-8"
  }, [(_vm.post.remark) ? _c('v-card-text', [_c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Kobe Remark",
      "counter": ""
    },
    model: {
      value: (_vm.post.remark),
      callback: function($$v) {
        _vm.$set(_vm.post, "remark", $$v)
      },
      expression: "post.remark"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "outlined": ""
    }
  }, [_vm._v(_vm._s(_vm.notes.beforeStart))])], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "text-center subtitle-1 font-weight-bold"
  }, [_vm._v("Is the Draft Approved?")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.reviewSection = true, _vm.showStartQuestion = false
      }
    }
  }, [_vm._v("YES, APPROVE AND SCHEDULE")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "block": "",
      "text": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.reportSection = true, _vm.showStartQuestion = false
      }
    }
  }, [_vm._v("NO, REPORT ABUSE")])], 1)], 1)], 1), _vm._v(" "), (_vm.clientReportAbuse.length > 0) ? _c('v-flex', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReviewSummary),
      expression: "showReviewSummary"
    }],
    staticClass: "elevation-8"
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Post Review History")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panels', _vm._l((_vm.clientReportAbuse), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_vm._v("\n                      Review " + _vm._s(i + 1) + "\n                    ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
      return _c('li', {
        key: r
      }, [_vm._v(_vm._s(r))])
    }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Non-Approval:")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(item.comment) + "\n                          ")]), _vm._v(" "), (item.files) ? _c('div', [_c('h4', [_vm._v("Uploaded Screenshots:")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.files), function(f, index) {
      return _c('li', {
        key: index
      }, [_c('a', {
        attrs: {
          "href": f.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.utilsFunc.getFileNameFromURL(f.url)))])])
    }), 0)])]) : _vm._e()])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.reviewSection) ? _c('v-card', [_c('v-form', [_c('v-card-text', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "size": "75"
    }
  }, [_vm._v("rate_review")]), _vm._v(" "), _c('p', [_vm._v("Rate & Review")])], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("Kindly Rate Influencer's Quality of Work")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "color": "secondary",
      "size": "45"
    },
    model: {
      value: (_vm.submissionReview.approveRatings),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveRatings", $$v)
      },
      expression: "submissionReview.approveRatings"
    }
  }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings <= 4),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "How can we make this a 5 stars?"
    },
    model: {
      value: (_vm.submissionReview.approveSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveSuggestion", $$v)
      },
      expression: "submissionReview.approveSuggestion"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)]), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings == 5),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings == 5"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "Leave Influencer a compliment?"
    },
    model: {
      value: (_vm.submissionReview.approveCompliment),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveCompliment", $$v)
      },
      expression: "submissionReview.approveCompliment"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)])], 1), _vm._v(" "), (_vm.post.postDate) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.post.propose_dates && _vm.askDate),
      expression: "!post.propose_dates && askDate"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                      Tentatively To go Live on\n                      "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.post.postDate))]), _vm._v(" ?\n                      "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.changeDate = true
      }
    }
  }, [_vm._v("No, Change Date")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.askDate = false
      }
    }
  }, [_vm._v("Yes, Date is Okay")])], 1)]), _vm._v(" "), (!_vm.askDate) ? _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                    Requested Date:\n                    "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.submissionReview.wantedLiveDate ? _vm.submissionReview.wantedLiveDate : _vm.post.postDate))]), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.changeDate = true
      }
    }
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    ref: "dateDialog",
    attrs: {
      "return-value": _vm.submissionReview.wantedLiveDate,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.submissionReview, "wantedLiveDate", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.submissionReview, "wantedLiveDate", $event)
      }
    },
    model: {
      value: (_vm.changeDate),
      callback: function($$v) {
        _vm.changeDate = $$v
      },
      expression: "changeDate"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.post.postDate,
      "allowed-dates": _vm.allowedDates
    },
    model: {
      value: (_vm.submissionReview.wantedLiveDate),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "wantedLiveDate", $$v)
      },
      expression: "submissionReview.wantedLiveDate"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-alert', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "dense": "",
      "type": "info"
    }
  }, [_vm._v("\n                      Tentative live date indicated is assuming the earliest available date\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.changeDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": [_vm.saveWantedLiveDate, function($event) {
        $event.stopPropagation();
        _vm.askDate = false
      }]
    }
  }, [_vm._v("OK")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.showChangeRequest) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submitApprove()
      }
    }
  }, [_vm._v("Request Date Change")]) : _vm._e(), _vm._v(" "), (_vm.showApprove) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.submitApprove()
      }
    }
  }, [_vm._v("Approve")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reportSection) ? _c('v-card', [_c('v-form', [_c('v-card-text', [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "deep-orange",
      "size": "75"
    }
  }, [_vm._v("report_problem")]), _vm._v(" "), _c('p', [_vm._v("Report an Abuse")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("1. Please select reasons for Non Approval")]), _vm._v(" "), _vm._l((_vm.abuseReasons), function(item, i) {
    return _c('v-checkbox', {
      key: i,
      attrs: {
        "label": item,
        "value": item,
        "height": "5"
      },
      model: {
        value: (_vm.submissionReview.abuseReasons),
        callback: function($$v) {
          _vm.$set(_vm.submissionReview, "abuseReasons", $$v)
        },
        expression: "submissionReview.abuseReasons"
      }
    })
  })], 2), _vm._v(" "), _c('v-container', [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("2. Comments for Abuse")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.submissionReview.abuseComment),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "abuseComment", $$v)
      },
      expression: "submissionReview.abuseComment"
    }
  })], 1), _vm._v(" "), _c('v-container', [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("3. Upload Screenshots")]), _vm._v(" "), _c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh,
      "multiple": true
    },
    on: {
      "setMedias": _vm.updateFiles
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "deep-orange"
    },
    on: {
      "click": function($event) {
        return _vm.submitAbuse()
      }
    }
  }, [_vm._v("Submit Abuse")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.showStartQuestion) ? _c('v-btn', {
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back_ios")]), _vm._v("Go Back\n        ")], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Upload Stats with AI")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "background-color": "primary"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    staticClass: "primary--text",
    staticStyle: {
      "background": "white"
    }
  }, [_vm._v("Use Submitted Stats")]), _vm._v(" "), _c('v-tab', {
    staticClass: "primary--text",
    staticStyle: {
      "background": "white"
    }
  }, [_vm._v("Upload Stats")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-container', [(!_vm.imagesToView) ? _c('h4', [_vm._v("\n                    Empty Submissions\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.imagesToView) ? _c('div', [(_vm.hasPosts) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_c('span', [_vm._v("Posts")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.changeContentImage(_vm.imagesToView.posts)
      }
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "dense": "",
      "row": ""
    },
    model: {
      value: (_vm.checkbox.post),
      callback: function($$v) {
        _vm.$set(_vm.checkbox, "post", $$v)
      },
      expression: "checkbox.post"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "dense": "",
      "value": "post",
      "label": "Select this Content"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.posts), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex,
      staticClass: "mb-5"
    }, [_c('v-row', {
      attrs: {
        "justify": "start",
        "align": "left"
      }
    }, [_vm._l((allPost.images), function(img, imgIndex) {
      return _c('v-col', {
        key: imgIndex,
        attrs: {
          "md": "4",
          "xs": "12"
        }
      }, [_c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
        attrs: {
          "width": "180px",
          "height": "200px",
          "src": img.url,
          "controls": ""
        }
      }, [_vm._v("             \n                                    Your browser does not support the video tag.\n                                ")]) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url)
          }
        }
      })], 1)], 1)], 1)
    }), _vm._v(" "), (allPost.instagramPostURL !== '' || allPost.images.length > 0) ? _c('v-col', {
      staticClass: "pt-0",
      attrs: {
        "md": "12",
        "xs": "12"
      }
    }, [_c('a', {
      attrs: {
        "href": allPost.instagramPostURL,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "mt-2",
      attrs: {
        "small": "",
        "text": "",
        "color": "warning"
      }
    }, [_vm._v(" " + _vm._s(allPost.instagramPostURL))])], 1)]) : _vm._e()], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasStories) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_c('span', [_vm._v("IG Stories")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.changeStoryImage(_vm.imagesToView.stories)
      }
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "dense": "",
      "row": ""
    },
    model: {
      value: (_vm.checkbox.story),
      callback: function($$v) {
        _vm.$set(_vm.checkbox, "story", $$v)
      },
      expression: "checkbox.story"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "dense": "",
      "value": "story",
      "label": "Select this Content"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.stories), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex,
      staticClass: "mb-5"
    }, [_c('v-row', {
      attrs: {
        "justify": "left",
        "align": "left"
      }
    }, [(allPost.label) ? _c('v-col', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "md": "12",
        "xs": "12"
      }
    }, [_c('div', {
      staticClass: "subtitle-1"
    }, [_vm._v(_vm._s(allPost.label))])]) : _vm._e(), _vm._v(" "), _vm._l((allPost.images), function(img, imgIndex) {
      return _c('v-col', {
        key: imgIndex,
        staticClass: "pt-1",
        attrs: {
          "md": "4",
          "xs": "12"
        }
      }, [_c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
        attrs: {
          "width": "180px",
          "height": "200px",
          "src": img.url,
          "controls": ""
        }
      }, [_vm._v("             \n                                    Your browser does not support the video tag.\n                                ")]) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url)
          }
        }
      })], 1)], 1)], 1)
    })], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasDeliverablePosts) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.deliverablePosts), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex
    }, [(_vm.filterEmptyPosts(allPost.posts).length > 0) ? _c('div', [_c('div', {
      staticClass: "subtitle-1 font-weight-bold d-flex flex-row justify-space-between"
    }, [_c('span', [_vm._v(_vm._s(_vm.getLongPostTitle(allPost.type)))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.changeContentImage(allPost.posts)
        }
      }
    }, [_c('v-radio-group', {
      staticStyle: {
        "margin-top": "-3px"
      },
      attrs: {
        "dense": "",
        "row": ""
      },
      model: {
        value: (_vm.checkbox.content),
        callback: function($$v) {
          _vm.$set(_vm.checkbox, "content", $$v)
        },
        expression: "checkbox.content"
      }
    }, [_c('v-radio', {
      staticClass: "justify-center",
      staticStyle: {
        "font-size": "13px"
      },
      attrs: {
        "dense": "",
        "value": ("content" + firstIndex),
        "label": "Select this Content"
      }
    })], 1)], 1)]), _vm._v(" "), _vm._l((_vm.filterEmptyPosts(allPost.posts)), function(post, pIndex) {
      return _c('v-row', {
        key: pIndex,
        attrs: {
          "justify": "left",
          "align": "left"
        }
      }, [(post.label && _vm.getPostType(allPost.type) === 'label') ? _c('v-col', {
        staticClass: "pt-5 pb-0",
        attrs: {
          "md": "12",
          "xs": "12"
        }
      }, [(_vm.getPostType(allPost.type) === 'label') ? _c('div', {
        staticClass: "subtitle-2"
      }, [_vm._v(_vm._s(post.label))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((post.images), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          attrs: {
            "md": "4",
            "xs": "12"
          }
        }, [_c('v-card', {
          attrs: {
            "text": "",
            "tile": ""
          }
        }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
          attrs: {
            "width": "180px",
            "height": "200px",
            "src": img.url,
            "controls": ""
          }
        }, [_vm._v("             \n                                      Your browser does not support the video tag.\n                                  ")]) : _c('v-img', {
          staticClass: "grey lighten-2 mx-auto",
          class: ("elevation-" + (_vm.hover ? 12 : 2)),
          attrs: {
            "src": img.url,
            "lazy-src": img.url,
            "aspect-ratio": "1"
          },
          on: {
            "click": function($event) {
              return _vm.viewMedia(img.url)
            }
          }
        })], 1)], 1)], 1)
      }), _vm._v(" "), (post.label && _vm.getPostType(allPost.type) === 'url') ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "md": "12",
          "xs": "12"
        }
      }, [_c('a', {
        attrs: {
          "href": post.label,
          "target": "_blank"
        }
      }, [_c('v-btn', {
        staticClass: "mt-2",
        attrs: {
          "small": "",
          "text": "",
          "color": "warning"
        }
      }, [_vm._v(" " + _vm._s(post.label))])], 1)]) : _vm._e()], 2)
    }), _vm._v(" "), _c('v-divider', {
      staticClass: "mb-4"
    })], 2) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.imagesToView.images && _vm.imagesToView.images.length > 0) ? _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, _vm._l((_vm.imagesToView.images), function(img) {
    return _c('v-col', {
      key: img.index,
      attrs: {
        "md": "4",
        "xs": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
      attrs: {
        "width": "180px",
        "height": "200px",
        "src": img.url,
        "controls": ""
      }
    }, [_vm._v("             \n                                Your browser does not support the video tag.\n                            ")]) : _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      class: ("elevation-" + (_vm.hover ? 12 : 2)),
      attrs: {
        "src": img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      },
      on: {
        "click": function($event) {
          return _vm.viewMedia(img.url)
        }
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-tab-item', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "multiple": true,
      "listMedia": _vm.media
    },
    on: {
      "change": _vm.mediaChanged
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.uploadMedias.length || _vm.selectedImages.length) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.extractData()
      }
    }
  }, [_vm._v("\n                  Extract with AI\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.dataResult) ? _c('div', [(_vm.postType === 'tiktok') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_play_time || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time (s):")]), _c('span'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.average_watch_time_seconds || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.likes || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.comments || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Favourites (Bookmarks):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.bookmarks || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Plays (Views):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.video_views || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Viewers (Reach):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Watched full video (%):")]), _vm._v(" "), (_vm.dataResult.watched_full_video_percentage) ? _c('span', [_vm._v(_vm._s(_vm.dataResult.watched_full_video_percentage) + "%")]) : _c('span', [_vm._v("N/A")])])])], 1) : (_vm.postType === 'reel') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Plays (Views):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.video_views || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.likes || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Saves (Bookmarks):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.bookmarks || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.comments || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_play_time || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), (_vm.dataResult.reel_watch_time) ? _c('span', [_vm._v(_vm._s(_vm.dataResult.reel_watch_time))]) : _c('span', [_vm._v("N/A")])])])], 1) : (_vm.postType === 'story') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.impressions || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Replies:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.replies || 'N/A'))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares || ''))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Link Clicks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.link_clicks))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Sticker Taps:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.sticker_taps || ''))])])])], 1) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.dataResult.average_watch_time_seconds) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time (s):")]), _c('span'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.average_watch_time_seconds) + "s")])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.likes) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.likes))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.comments) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.comments))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.new_followers) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Followers:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.new_followers))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.shares) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.shares))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.bookmarks) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Saved:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.bookmarks))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.video_views) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.video_views))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.reached) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reached))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.replies) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Replies:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.replies))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.link_clicks) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Link Clicks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.link_clicks))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.link_clicks) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Sticker Taps:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.sticker_taps))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.total_interactions) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_interactions))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.total_play_time) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.total_play_time))])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.watched_full_video_percentage) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.watched_full_video_percentage) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.dataResult.reel_watch_time) ? _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataResult.reel_watch_time))])]) : _vm._e()])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), (_vm.dataResult) ? _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.confirmStats
    }
  }, [_vm._v("Proceed")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    model: {
      value: (_vm.imageViewerDialog),
      callback: function($$v) {
        _vm.imageViewerDialog = $$v
      },
      expression: "imageViewerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.imageViewerDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.activeImage
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.activeImage,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "600"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activePairingData) ? _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Paired Influencer")]), _vm._v(" "), _c('v-card-text', [_c('a', {
    staticClass: "title",
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.activePairingData.instagramHandle,
      "target": "_blank"
    }
  }, [_vm._v("@" + _vm._s(_vm.activePairingData.instagramHandle))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.pairingStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "disabled": _vm.viewOnly,
      "label": "Pairing Status"
    },
    model: {
      value: (_vm.activePairingData.pairingStatus),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "pairingStatus", $$v)
      },
      expression: "activePairingData.pairingStatus"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Min Amount",
      "disabled": _vm.viewOnly,
      "type": "number",
      "prefix": "S$"
    },
    model: {
      value: (_vm.activePairingData.min_payout),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "min_payout", _vm._n($$v))
      },
      expression: "activePairingData.min_payout"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Max Amount",
      "disabled": _vm.viewOnly,
      "type": "number",
      "prefix": "S$"
    },
    model: {
      value: (_vm.activePairingData.max_payout),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "max_payout", _vm._n($$v))
      },
      expression: "activePairingData.max_payout"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "remarks",
      "label": "Remarks",
      "disabled": _vm.viewOnly,
      "hide-details": "",
      "value": ""
    },
    model: {
      value: (_vm.activePairingData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "remarks", $$v)
      },
      expression: "activePairingData.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.viewOnly
    },
    on: {
      "click": function($event) {
        return _vm.updatePairingStatus()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [(!_vm.isClient) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "6",
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "mr-2 primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v("Export Excel\n      ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaigns,
      "label": "Campaign",
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "return-object": true,
      "clearable": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n            " + _vm._s(item.name) + "  \n            "), (item.lockedCOGS && !_vm.isClient) ? _c('v-chip', {
          attrs: {
            "color": "error",
            "small": ""
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_c('v-icon', _vm._g({
          attrs: {
            "small": "",
            "left": ""
          }
        }, _vm.on), [_vm._v("mdi-lock")]), _vm._v(" Locked COGS")], 1)]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.filteredCampaign),
      callback: function($$v) {
        _vm.filteredCampaign = $$v
      },
      expression: "filteredCampaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "7",
      "lg": "7"
    }
  }, [(!_vm.isClient) ? _c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "min-width": "300px",
      "max-width": "300px",
      "padding-top": "10px"
    },
    attrs: {
      "items": _vm.filterStatuses,
      "item-value": "value",
      "item-text": "text",
      "label": "Status",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])], 1)])], 1), _vm._v(" "), (_vm.filteredCampaign && !_vm.isClient) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 1707098776)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 creator_concept_page__table",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "item-key": "dataTableKey",
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "items-per-page": 20,
      "no-data-text": 'Empty list'
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.userHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-left"
        }, [_c('social-handle', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": item.platform === 'instagram',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isYoutube": item.platform === 'youtube',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.userHandle,
            "instagramHandle": item.userHandle,
            "facebookHandle": item.userHandle,
            "linkedinHandle": item.userHandle,
            "twitterHandle": item.userHandle,
            "youtubeHandle": item.userHandle,
            "xiaohongshuHandle": item.xhsID,
            "xiaohongshuFullName": item.fullName,
            "youtubeURL": item.url
          }
        }), _vm._v(" "), (item.influencerID) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e()], 1)]
      }
    }, {
      key: "item.campaignName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.campaignName) + "\n          ")])]
      }
    }, {
      key: "item.conceptStatus",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-left"
        }, [(item.conceptStatusEdit) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [_c('v-select', {
          staticStyle: {
            "max-width": "320px"
          },
          attrs: {
            "items": _vm.conceptStatuses,
            "item-text": "text",
            "item-value": "value",
            "hide-details": "",
            "dense": ""
          },
          on: {
            "change": _vm.changeConceptStatus
          },
          model: {
            value: (item.conceptStatus),
            callback: function($$v) {
              _vm.$set(item, "conceptStatus", $$v)
            },
            expression: "item.conceptStatus"
          }
        }), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'conceptStatus')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('conceptStatusEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.conceptStatusEdit) ? _c('v-chip', {
          attrs: {
            "color": _vm.conceptStatusClr(item.conceptStatus),
            "small": ""
          }
        }, [_c('span', {
          class: ("statusdisplay-" + (item.conceptStatus))
        }, [_vm._v(_vm._s(_vm.conceptStatusDisplay(item.conceptStatus)))])]) : _vm._e(), _vm._v(" "), (!item.conceptStatusEdit && _vm.isNotClient) ? _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('conceptStatusEdit', item, true)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.contentScripts",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right"
        }, [_c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.contentScriptForm) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewContentScriptDialog(item.pairingID)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" "), (_vm.isClient) ? _c('span', [_vm._v("View")]) : _vm._e(), _vm._v(" "), (!_vm.isClient) ? _c('span', [_vm._v("Edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.contentScriptForm && !_vm.isClient) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "success",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.downloadWord(item)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          attrs: {
            "color": "success",
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Download\n              ")], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.isClient) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.copyContentScriptFormLink(item)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-copy+")]), _vm._v(" "), _c('span', [_vm._v("Copy link")])], 1) : _vm._e()], 1)], 1)])]
      }
    }, {
      key: "item.postingLink",
      fn: function(ref) {
        var item = ref.item;

        return [(item.postingLinkEdit) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.postingLinkEdit) ? _c('v-text-field', {
          staticStyle: {
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: (item.postingLink),
            callback: function($$v) {
              _vm.$set(item, "postingLink", $$v)
            },
            expression: "item.postingLink"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'postingLink')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('postingLinkEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.postingLinkEdit) ? _c('div', [_c('v-btn', {
          staticClass: "pa-0 ma-0",
          staticStyle: {
            "min-width": "20px"
          },
          attrs: {
            "text": "",
            "small": "",
            "color": "secondary",
            "href": item.postingLink,
            "target": '_blank',
            "disabled": !item.postingLink
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Link",
                  "small": ""
                }
              }, on), [_vm._v("mdi-link-variant")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Posting Link")])])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('postingLinkEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Posting Link")])])], 1)], 1) : _vm._e()]
      }
    }, {
      key: "item.shootDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right"
        }, [(item.shootDateEdit) ? _c('div', [_c('div', {
          staticClass: "d-flex flex-row"
        }, [_c('v-text-field', {
          staticClass: "edit-date-box",
          attrs: {
            "outlined": "",
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": function($event) {
              return _vm.checkActDate(item, item.shootDate)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.checkActDate(item, item.shootDate)
            }
          },
          model: {
            value: (item.shootDate),
            callback: function($$v) {
              _vm.$set(item, "shootDate", $$v)
            },
            expression: "item.shootDate"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "date-picker-inner"
        }, [_c('date-picker', {
          attrs: {
            "className": "input-field",
            "options": {
              theme: 'icon',
              confirm: true
            },
            "status": item.actEndDateCal
          },
          on: {
            "changeDate": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.setActDateFromPicker.apply(void 0, [ item ].concat( argsArray ))
            }
          }
        })], 1)], 1), _vm._v(" "), (item.shootDateEdit) ? _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1 ml-1",
            "x-small": "",
            "disabled": item.invalidShootDate
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'shootDate')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('shootDateEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.shootDateEdit) ? _c('div', [_vm._v("\n              " + _vm._s(item.shootDate) + "\n              "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('shootDateEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Shoot Date")])])], 1)], 1) : _vm._e()])]
      }
    }, {
      key: "item.deliverableDetails",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('p', {
          staticClass: "deliverable-txt mb-0"
        }, [_vm._v("\n              " + _vm._s(_vm.campaignHelper.getDeliverableDetails(item.deliverableDetails)) + "\n            ")])])]
      }
    }, {
      key: "item.contentFeature",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right pa-2"
        }, [(item.contentFeatureEdit) ? _c('v-textarea', {
          staticStyle: {
            "min-width": "150px",
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (item.contentFeature),
            callback: function($$v) {
              _vm.$set(item, "contentFeature", $$v)
            },
            expression: "item.contentFeature"
          }
        }) : _vm._e(), _vm._v(" "), (item.contentFeatureEdit) ? _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'contentFeature')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('contentFeatureEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.contentFeatureEdit) ? _c('div', [_vm._v("\n              " + _vm._s(item.contentFeature) + "\n              "), (!_vm.isClient) ? _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('contentFeatureEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Content feature/pillar")])])], 1) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.kobeRemark",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right pa-2"
        }, [(item.kobeRemarkEdit) ? _c('v-textarea', {
          staticStyle: {
            "min-width": "150px",
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (item.kobeRemark),
            callback: function($$v) {
              _vm.$set(item, "kobeRemark", $$v)
            },
            expression: "item.kobeRemark"
          }
        }) : _vm._e(), _vm._v(" "), (item.kobeRemarkEdit) ? _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'kobeRemark')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('kobeRemarkEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.kobeRemarkEdit) ? _c('div', [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "color": "black",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.kobeRemark || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.kobeRemark))
          }
        })]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('kobeRemarkEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Content feature/pillar")])])], 1)], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "170px"
          }
        }, [(item.releaseContentScript) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.changeRelease(item, false)
            }
          }
        }, [_vm._v("\n              Suspend\n              "), _c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-close-circle")])], 1) : _vm._e(), _vm._v(" "), (!item.releaseContentScript) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.changeRelease(item, true)
            }
          }
        }, [_vm._v("\n              Release\n              "), _c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1)]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('content-script-edit-dialog', {
    attrs: {
      "value": _vm.contentScriptEditDialog,
      "item": _vm.pairingItem
    },
    on: {
      "saveClicked": _vm.saveContentScript
    },
    model: {
      value: (_vm.contentScriptEditDialog),
      callback: function($$v) {
        _vm.contentScriptEditDialog = $$v
      },
      expression: "contentScriptEditDialog"
    }
  }), _vm._v(" "), _c('post-link-update-modal', {
    attrs: {
      "value": _vm.postLinkUpdateDialog,
      "item": _vm.pairingItem
    },
    on: {
      "saveClicked": _vm.savePostLink
    },
    model: {
      value: (_vm.postLinkUpdateDialog),
      callback: function($$v) {
        _vm.postLinkUpdateDialog = $$v
      },
      expression: "postLinkUpdateDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Creator Concept Columns",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.viewContentScriptsData) ? _c('view-creator-concept-modal-dialog', {
    attrs: {
      "value": _vm.viewcontentScriptModalDialog,
      "data": _vm.viewContentScriptsData
    },
    model: {
      value: (_vm.viewcontentScriptModalDialog),
      callback: function($$v) {
        _vm.viewcontentScriptModalDialog = $$v
      },
      expression: "viewcontentScriptModalDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-concept-link"
    },
    domProps: {
      "value": _vm.conceptFormLink
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n    Copied to Clipboard!\n    "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-concept-link"
    },
    domProps: {
      "value": _vm.conceptFormLink
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": _vm.isAdmins && _vm.pairing.activity && _vm.pairing.activity.length ? '700px' : '500px',
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Change Amount for '@" + _vm._s(_vm.pairing.userHandle) + "'\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Current Amount : " + _vm._s(_vm.utilsFunc.currencySym(_vm.pairing.currency)) + " " + _vm._s(_vm.$options.filters.thousandSeprator(_vm.pairing.payoutAmount)))])]), _vm._v(" "), (_vm.lockedPayout) ? _c('v-alert', {
    attrs: {
      "dense": "",
      "border": "left",
      "type": "warning"
    }
  }, [_vm._v("\n        (You are updating a payout that has been confirmed previously under invoice & brief confirmation tab.)\n      ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-combobox', {
    staticStyle: {
      "max-width": "100px",
      "font-size": "18px",
      "margin-right": "5px"
    },
    attrs: {
      "items": _vm.currencies,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.updateData.currency),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "currency", $$v)
      },
      expression: "updateData.currency"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "placeholder": "New Amount",
      "outlined": "",
      "error-messages": _vm.$v.updateData.amount.$error && !_vm.isAdmins ? "Amount is required." : ''
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.amount.$touch()
      }
    },
    model: {
      value: (_vm.updateData.amount),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "amount", $$v)
      },
      expression: "updateData.amount"
    }
  })], 1)]), _vm._v(" "), (_vm.lockedPayout && !_vm.isAdmins) ? _c('div', [_c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "Reasons",
      "outlined": "",
      "error-messages": _vm.$v.updateData.reasons.$error ? "Reasons is required." : ''
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.reasons.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.reasons.$touch()
      }
    },
    model: {
      value: (_vm.updateData.reasons),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "reasons", $$v)
      },
      expression: "updateData.reasons"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isAdmins && _vm.pairing.activity && _vm.pairing.activity.length) ? _c('div', [_c('payout-activity-data-table', {
    attrs: {
      "pairing": _vm.pairing,
      "activityRefresh": _vm.activityrefresh
    },
    on: {
      "saved": _vm.savedPayoutActivity
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": _vm.savePayoutAmount
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-main', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "#3F3FFF"
    }
  }, [_c('v-toolbar-title', [_vm._v("Instagram Pages")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('v-radio-group', {
    attrs: {
      "mandatory": true,
      "name": "list-ig"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._l((_vm.facebookData), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [_c('v-radio', {
      attrs: {
        "value": item.id
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v("@" + _vm._s(item.username))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.followers_count) + " followers")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.profile_picture_url
      }
    })])], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selected,
      "color": "secondary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    on: {
      "click:outside": _vm.closeDialog
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    style: ({
      'color': _vm.theme
    })
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), _c('hr', {
    staticStyle: {
      "width": "100%",
      "border": "solid",
      "border-color": "rgba(0, 0, 0, 0.12)",
      "border-width": "thin 0 0 0"
    }
  })]), _vm._v(" "), _c('v-card-text', [(_vm.filterItems) ? _c('v-row', {
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 0px 10px"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "attach": ""
    },
    on: {
      "change": _vm.selectedChangeHandler
    },
    model: {
      value: (_vm.selectedCampaignFilter),
      callback: function($$v) {
        _vm.selectedCampaignFilter = $$v
      },
      expression: "selectedCampaignFilter"
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 0px 10px"
    }
  }, [_c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterItems,
      "label": "Filter",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "attach": ""
    },
    on: {
      "change": _vm.selectedChangeHandler
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.DataTableHeaders,
      "items": _vm.DataItems,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.totalPayouts",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(item.totalPayouts) + "/" + _vm._s(item.totalPosts) + "\n                      ")]
      }
    }, {
      key: "item.yetToPayouts",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(item.yetToPayouts) + "/" + _vm._s(item.totalPosts) + "\n                      ")]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.avgArray), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      attrs: {
        "id": "avgTitle"
      }
    }, [_vm._v(_vm._s(item.title) + ": "), _c('span', {
      attrs: {
        "id": "avg"
      }
    }, [_vm._v(" " + _vm._s(item.avg))])])])
  }), 0)], 1), _vm._v(" "), (_vm.type === 'duration') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('div', {
    staticClass: "teamTitle"
  }, [_vm._v("Team")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Activation: " + _vm._s(_vm.total.activation))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Pairing: " + _vm._s(_vm.total.pairing))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("CO-Creating: " + _vm._s(_vm.total.creating))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Completion: " + _vm._s(_vm.total.complete))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "teamSubTitle"
  }, [_vm._v("Overall Average: " + _vm._s(_vm.total.overall))])])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "color": _vm.theme,
      "large": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n                OK\n            ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.signinForm.createdAt) ? _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "elevate-on-scroll": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Creator Signin Form")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-signinform-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "signInForm",
    staticClass: "sign-in-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "default-title font-weight-bold mb-2"
  }, [_vm._v("Date: " + _vm._s(_vm.utils.formatCustomDate(_vm.signinForm.createdAt, 'DD/MM/YYYY')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "address-title"
  }, [_vm._v("\n                    Kobe Global Technologies Pte Ltd."), _c('br'), _vm._v("\n                    GST Registration no. 201608755R"), _c('br'), _vm._v("\n                    51 Goldhill Plaza"), _c('br'), _vm._v("\n                    #14-01"), _c('br'), _vm._v("\n                    Singapore 308900"), _c('br'), _vm._v("\n                    finance@getkobe.com\n                  ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "default-title mb-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Client:")]), _vm._v(" " + _vm._s(_vm.displayData.clientName))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "default-title mb-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Campaign Name:")]), _vm._v(" " + _vm._s(_vm.displayData.campaignName))]), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Creator:")]), _vm._v(" @" + _vm._s(_vm.displayData.handle) + " on " + _vm._s(_vm.displayData.platform))]), _vm._v("\n                  (\n                    "), (_vm.platform === 'youtube') ? _c('a', {
    attrs: {
      "href": ("https://www.youtube.com/@" + (_vm.displayData.handle)),
      "target": "_blank"
    }
  }, [_vm._v("https://www.youtube.com/" + _vm._s(_vm.displayData.handle))]) : (_vm.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": ("https://www.tiktok.com/@" + (_vm.displayData.handle)),
      "target": "_blank"
    }
  }, [_vm._v("https://www.tiktok.com/" + _vm._s(_vm.displayData.handle))]) : _c('a', {
    attrs: {
      "href": ("https://www.instagram.com/" + (_vm.displayData.handle)),
      "target": "_blank"
    }
  }, [_vm._v("https://www.instagram.com/" + _vm._s(_vm.displayData.handle))]), _vm._v("\n                  )\n                ")])], 1), _vm._v(" "), _c('terms-and-conditions'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "max-width": "420px"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #cfcece",
      "margin-bottom": "10px"
    }
  }, [_c('canvas', {
    staticClass: "cls-signature-pad",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "signin-signature-pad",
      "width": "400",
      "height": "200"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.signatureImg,
      "width": "400",
      "height": "200"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_vm._v("Signature")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "loading": _vm.downloadloading,
      "disabled": _vm.downloadloading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.downloadPDF
    }
  }, [_vm._v("Download\n                "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("Release Campaign to Admin")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2 ims-modal-body",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', [_c('label', [_vm._v("Please schedule a call with your respective AM to finalise the brief and provide a summary on the following next steps:\n          "), _c('br'), _vm._v("What are you getting out of this campaign brief and type of rejections/challenges or stucks you foresee from the creators")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": "",
      "error-messages": _vm.$v.updateData.remarks.$error && "Remarks is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.remarks.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.remarks.$touch()
      }
    },
    model: {
      value: (_vm.updateData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "remarks", $$v)
      },
      expression: "updateData.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "error-messages": _vm.$v.updateData.deadline.$error && "Deadline is required.",
            "append-icon": "event",
            "outlined": "",
            "readonly": ""
          },
          on: {
            "input": function($event) {
              return _vm.$v.updateData.deadline.$touch()
            },
            "blur": function($event) {
              return _vm.$v.updateData.deadline.$touch()
            }
          },
          model: {
            value: (_vm.updateData.deadline),
            callback: function($$v) {
              _vm.$set(_vm.updateData, "deadline", $$v)
            },
            expression: "updateData.deadline"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.deadlineCal),
      callback: function($$v) {
        _vm.deadlineCal = $$v
      },
      expression: "deadlineCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.deadlineCal = false
      }
    },
    model: {
      value: (_vm.updateData.deadline),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "deadline", $$v)
      },
      expression: "updateData.deadline"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Release to Admin")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "box-header"
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "data-toggle": "modal",
      "data-target": _vm.createModalIdDisplay
    }
  }, [_vm._v("\n          Create new\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 secondary--text",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalRows
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.website))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phoneNumber))]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteCompany(item.id)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "ims-action primary ml-1",
            attrs: {
              "small": "",
              "data-toggle": "modal",
              "data-target": _vm.editModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getCompanyDataToEdit(item.id)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "ims-action ml-1",
            attrs: {
              "small": "",
              "color": "info",
              "data-toggle": "modal",
              "data-target": _vm.viewModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getCompanyDataToView(item.id)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-eye")])], 1)], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('create-company-modal', {
    attrs: {
      "modalId": _vm.createModalId
    },
    on: {
      "createCompany": _vm.createCompany
    }
  }), _vm._v(" "), _c('edit-company-modal', {
    attrs: {
      "modalId": _vm.editModalId,
      "companyData": _vm.editCompanyData
    },
    on: {
      "editCompany": _vm.editCompany
    }
  }), _vm._v(" "), _c('view-company-modal', {
    attrs: {
      "modalId": _vm.viewModalId,
      "companyData": _vm.viewCompanyData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Add Tag for "), (_vm.item && _vm.item.userHandle) ? _c('span', [_vm._v(" @" + _vm._s(_vm.item.userHandle))]) : _vm._e()]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-combobox', {
    attrs: {
      "items": _vm.allTags,
      "item-text": "name",
      "item-value": "name",
      "hide-selected": "",
      "chips": "",
      "label": "Tag",
      "multiple": "",
      "error-messages": _vm.$v.updateData.tag.$error && "Tag is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.tag.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.tag.$touch()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.updateData.tag),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "tag", $$v)
      },
      expression: "updateData.tag"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Update Active Year\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-combobox', {
    attrs: {
      "items": _vm.years,
      "hide-selected": "",
      "chips": "",
      "label": "Active Year",
      "multiple": "",
      "error-messages": _vm.$v.updateData.activeYear.$error && "Active Year is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.activeYear.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.activeYear.$touch()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.updateData.activeYear),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "activeYear", $$v)
      },
      expression: "updateData.activeYear"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.internalView) ? _c('v-layout', {
    staticClass: "mb-5"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "12",
      "md": "6"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignData.min_content) + " to " + _vm._s(_vm.campaignData.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + "%")])])], 1)]
      }
    }], null, false, 1347022726)
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "12",
      "md": "6"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignData.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }], null, false, 3245034452)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.internalView) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 1707098776)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "pairing-elimination-table elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.influencerItems,
      "items-per-page": _vm.itemsPerPage,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item, index) {
          return _c('tr', {
            key: item.name
          }, [(_vm.displayFields('igHandle')) ? _c('td', {
            class: {
              'table-row-eliminated': _vm.isEliminated(item)
            }
          }, [_c('social-handle', {
            attrs: {
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isYoutube": item.platform === 'youtube',
              "isFacebook": item.platform === 'facebook',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "isLinkedIn": item.platform === 'linkedin',
              "isTwitter": item.platform === 'twitter' || item.platform === 'x',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.instagramHandle,
              "instagramHandle": item.instagramHandle,
              "youtubeHandle": item.instagramHandle,
              "facebookHandle": item.instagramHandle,
              "linkedinHandle": item.linkedinHandle || item.userHandle || item.instagramHandle,
              "twitterHandle": item.twitterHandle || item.userHandle || item.instagramHandle,
              "otherHandle": item.instagramHandle,
              "xiaohongshuHandle": item.xhsID,
              "xiaohongshuFullName": item.fullName
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('platformName')) ? _c('td', [_vm._v(_vm._s(_vm._f("platformDisplayName")(item.platformName)))]) : _vm._e(), _vm._v(" "), (_vm.displayFields('totalFollowers')) ? _c('td', {
            class: {
              'table-row-eliminated': _vm.isEliminated(item)
            }
          }, [(item.followers) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.followers)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('genderPercentage')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticStyle: {
              "max-width": "70px"
            }
          }, [(item.audience_genders && item.audience_genders.length > 0) ? _c('PieChart', {
            attrs: {
              "name": ("genderPie" + (item.pairingID)),
              "title": _vm.genderPie.title,
              "labels": _vm.genderPie.labels,
              "backgroundColors": _vm.genderPie.backgroundColors,
              "items": _vm.getGenderPieData(item.audience_genders),
              "options": _vm.genderPie.options,
              "width": _vm.genderPie.width,
              "height": _vm.genderPie.height
            }
          }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('AudienceCredibility')) ? _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('engagementRate')) ? _c('td', [(item.engagement_rate) ? _c('span', [_vm._v(_vm._s(item.engagement_rate) + " %")]) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.displayFields('remarks')) ? _c('td', [_vm._v(_vm._s(item.remarks))]) : _vm._e(), _vm._v(" "), (_vm.displayFields('contentFeature')) ? _c('td', [_vm._v(_vm._s(item.contentFeature))]) : _vm._e(), _vm._v(" "), (_vm.displayFields('gender')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            class: ("ma-2 " + (_vm.isEliminated(item) ? 'eliminate-text': '')),
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.gender || '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('age_group')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            class: ("ma-2 " + (_vm.isEliminated(item) ? 'eliminate-text': '')),
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.age_group || '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('aud_age_group')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l((item.topAudAges), function(audAge, index) {
            return _c('div', {
              key: index,
              staticClass: "ml-2"
            }, [_c('v-chip', {
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(audAge.code))])], 1)
          }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('country')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l((item.topCountries), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "ml-2"
            }, [_c('v-chip', {
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))])], 1)
          }), 0)]) : _vm._e(), _vm._v(" "), (_vm.elimination && _vm.displayFields('selected')) ? _c('td', [_c('v-menu', {
            attrs: {
              "offset-y": "",
              "disabled": _vm.disableActions || item.eliminationStatus !== _vm.eliminationStatus.PENDING || item.payoutDetails.status === _vm.payoutStatus.CONFIRMED
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  class: _vm.disableActions || item.eliminationStatus !== _vm.eliminationStatus.PENDING || item.payoutDetails.status === _vm.payoutStatus.CONFIRMED ? 'v-btn--disabled v-btn--has-bg' : '',
                  attrs: {
                    "color": _vm.getSelectAttributes(item, 'color'),
                    "dense": "",
                    "dark": _vm.disableActions || item.eliminationStatus !== _vm.eliminationStatus.PENDING || item.payoutDetails.status === _vm.payoutStatus.CONFIRMED ? false : true
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "left": ""
                  }
                }, [_vm._v("\n                    " + _vm._s(_vm.getSelectAttributes(item, 'icon')) + "\n                  ")]), _vm._v(" " + _vm._s(_vm.getSelectAttributes(item, 'text')) + "\n                ")], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.getSelectAttributes(item, 'menus')), function(action, actionIndex) {
            return _c('v-list-item', {
              key: actionIndex,
              on: {
                "click": function($event) {
                  return _vm.actionHandler(item.pairingID, action.title)
                }
              }
            }, [_c('v-list-item-title', [_c('v-icon', {
              attrs: {
                "left": ""
              }
            }, [_vm._v("\n                    " + _vm._s(_vm.getIconByTitle(action.title)) + "\n                  ")]), _vm._v(" " + _vm._s(action.title))], 1)], 1)
          }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('eliminatedReason')) ? _c('td', [_c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (_vm.isEliminated(item)),
                    expression: "isEliminated(item)"
                  }],
                  attrs: {
                    "small": ""
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewReason(item)
                    }
                  }
                }, on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-file-document-box")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Reason")])])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('notes')) ? _c('td', [(!_vm.isClientRole && item.clientNotes.length) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "small": "",
                    "color": "warning"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.openClientNotesDialog(item)
                    }
                  }
                }, on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-file-document-box")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Note")])]) : _vm._e(), _vm._v(" "), (_vm.isClientRole) ? _c('v-badge', {
            attrs: {
              "value": _vm.getClientUnreadCount(item),
              "content": _vm.getClientUnreadCount(item),
              "color": "green",
              "overlap": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openClientNotesDialog(item)
              }
            }
          }, [_c('v-btn', {
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openClientNotesDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Add Note (" + _vm._s(item.clientNotes ? item.clientNotes.length : 0) + ")\n              ")], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.elimination && _vm.displayFields('selected')) ? _c('td', [_vm._v("\n            " + _vm._s(_vm.showEliminationStatus(item.eliminationStatus)) + "\n            "), _c('v-icon', {
            attrs: {
              "right": "",
              "color": _vm.isSelected(item) ? 'green' : 'red'
            }
          }, [_vm._v(_vm._s(_vm.isSelected(item) ? 'check' : 'cancel'))])], 1) : _vm._e()])
        }), 0)]
      }
    }])
  }), _vm._v(" "), (_vm.elimination && !_vm.internalView) ? _c('div', {
    staticClass: "text-right pt-2"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "secondary",
      "disabled": _vm.disableActions
    },
    on: {
      "click": function($event) {
        return _vm.saveEliminationChanges('accept')
      }
    }
  }, [_vm._v("Accept All")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "secondary",
      "disabled": _vm.disableActions
    },
    on: {
      "click": function($event) {
        return _vm.saveEliminationChanges('save_draft')
      }
    }
  }, [_vm._v("Save as Draft")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.disableActions
    },
    on: {
      "click": function($event) {
        return _vm.saveEliminationChanges('save')
      }
    }
  }, [_vm._v("Save and Submit")])], 1) : _vm._e(), _vm._v(" "), (_vm.internalView) ? _c('div', {
    staticClass: "pairing-elimination-actions text-right pt-2"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.closeElimination
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmSendToClient()
      }
    }
  }, [_vm._v("Confirm")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "480"
    },
    model: {
      value: (_vm.reasonDialog),
      callback: function($$v) {
        _vm.reasonDialog = $$v
      },
      expression: "reasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Share with us why this influencer is eliminated\n        "), _c('span', [_vm._v("(note to avoid subjective bias)")])]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": ""
    },
    model: {
      value: (_vm.eliminatedReason),
      callback: function($$v) {
        _vm.eliminatedReason = $$v
      },
      expression: "eliminatedReason"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.cancelReason
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.saveReason
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.viewReasonDialog),
      callback: function($$v) {
        _vm.viewReasonDialog = $$v
      },
      expression: "viewReasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Remarks for \n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://instagram.com/' + _vm.viewReasonData.igHandle
    }
  }, [_vm._v("@" + _vm._s(_vm.viewReasonData.igHandle))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "body-1"
  }, [_vm._v(_vm._s(_vm.viewReasonData.text))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewReasonDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('client-notes-modal', {
    attrs: {
      "value": _vm.clientNotesDialog,
      "data": _vm.clientNotesData
    },
    on: {
      "savedNotes": _vm.refreshPairingData
    },
    model: {
      value: (_vm.clientNotesDialog),
      callback: function($$v) {
        _vm.clientNotesDialog = $$v
      },
      expression: "clientNotesDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Client Elimination Columns",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.name.$error
    }
  }, [_c('label', [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter company name"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }, function($event) {
        return _vm.$v.company.name.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.name.required && _vm.$v.company.name.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Company name is required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.address.$error
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.address),
      expression: "company.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.company.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "address", $event.target.value)
      }, function($event) {
        return _vm.$v.company.address.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.address.required && _vm.$v.company.address.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Address is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.website.$error
    }
  }, [_c('label', [_vm._v("Website")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.website),
      expression: "company.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ..."
    },
    domProps: {
      "value": (_vm.company.website)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "website", $event.target.value)
      }, function($event) {
        return _vm.$v.company.website.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.website.required && _vm.$v.company.website.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Website is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.phoneNumber.$error
    }
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.phoneNumber),
      expression: "company.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ..."
    },
    domProps: {
      "value": (_vm.company.phoneNumber)
    },
    on: {
      "blur": function($event) {
        return _vm.$v.company.phoneNumber.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.$v.company.phoneNumber.required && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number is required\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.phoneNumber.numeric && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number must be a number\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.phoneNumber.minLength && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number must have at least 8 digits\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createCompany
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Create new company\n        ")])])
}]}

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "text-right w-100 mt-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetFilters()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("mdi-reload")]), _vm._v(" Reset\n          ")], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold mt-3 pb-3"
  }, [_vm._v("Inclusive of relevant topics (%)")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "ticks": "always",
      "step": "10",
      "thumb-size": 24,
      "thumb-label": "always"
    },
    model: {
      value: (_vm.settings.relevantKeywords),
      callback: function($$v) {
        _vm.$set(_vm.settings, "relevantKeywords", $$v)
      },
      expression: "settings.relevantKeywords"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticClass: "pr-2",
    staticStyle: {
      "min-width": "50%"
    }
  }, [_c('p', {
    staticClass: "body-2 mb-3"
  }, [_c('v-icon', [_vm._v("mdi-account")]), _vm._v(" Influencer")], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Influencer",
      "multiple": ""
    },
    model: {
      value: (_vm.settings.influencerGeos),
      callback: function($$v) {
        _vm.$set(_vm.settings, "influencerGeos", $$v)
      },
      expression: "settings.influencerGeos"
    }
  })], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "body-2 mb-3"
  }, [_c('v-icon', [_vm._v("mdi-account-multiple")]), _vm._v(" Audience")], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Audience",
      "multiple": ""
    },
    model: {
      value: (_vm.settings.audGeos),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGeos", $$v)
      },
      expression: "settings.audGeos"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "90px",
      "margin-top": "5px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.percentOptions
    },
    model: {
      value: (_vm.settings.audGeoPercent),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGeoPercent", $$v)
      },
      expression: "settings.audGeoPercent"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold"
  }, [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticStyle: {
      "min-width": "50%"
    }
  }, [_c('p', {
    staticClass: "body-2 mb-2"
  }, [_c('v-icon', [_vm._v("mdi-account")]), _vm._v(" Influencer")], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: (_vm.settings.infGender),
      callback: function($$v) {
        _vm.$set(_vm.settings, "infGender", $$v)
      },
      expression: "settings.infGender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Male or Female",
      "value": "KNOWN"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Male",
      "value": "MALE"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Female",
      "value": "FEMALE"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "body-2 mb-2"
  }, [_c('v-icon', [_vm._v("mdi-account-multiple")]), _vm._v(" Audience")], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: (_vm.settings.audGender),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGender", $$v)
      },
      expression: "settings.audGender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Any",
      "value": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Male",
      "value": "MALE"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Female",
      "value": "FEMALE"
    }
  })], 1), _vm._v(" "), (_vm.settings.audGender) ? _c('v-autocomplete', {
    staticStyle: {
      "max-width": "90px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.percentOptions
    },
    model: {
      value: (_vm.settings.audGenderPercent),
      callback: function($$v) {
        _vm.$set(_vm.settings, "audGenderPercent", $$v)
      },
      expression: "settings.audGenderPercent"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold"
  }, [_vm._v("Followers")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n                From\n                "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.from
    },
    model: {
      value: (_vm.settings.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.settings.followers, "from", $$v)
      },
      expression: "settings.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                To\n                "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.to
    },
    model: {
      value: (_vm.settings.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.settings.followers, "to", $$v)
      },
      expression: "settings.followers.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.saveSettings()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(!_vm.viewHandle) ? _c('div', {
    staticClass: "d-flex mb-5 justify-center"
  }, [_c('div', [_c('v-text-field', {
    staticStyle: {
      "min-width": "300px"
    },
    attrs: {
      "prefix": "@",
      "label": "Enter Handle",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeHandle(_vm.handle, 0)
      }
    },
    model: {
      value: (_vm.handle),
      callback: function($$v) {
        _vm.handle = $$v
      },
      expression: "handle"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Post Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('post')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedPostAnalysis && _vm.selectedPostAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openPostAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedPostAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedPostTableHeaders,
      "search": _vm.filter,
      "items": _vm.postAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedPostTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.shares === 0 ? '-' : item.shares) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.views === 0 ? '-' : item.views) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate === 0 ? '0' : item.new_engagement_rate) + " %\n            ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate_view === 0 || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_reach === 0 || item.engagement_rate_reach == 'Infinity' ? '-' : item.engagement_rate_reach + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n            ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || item.median_engagement_rate === 0 ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null || item.median_engagement_rate === 0 ? '-' : item.avg_likes)) + "\n          ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null || item.median_engagement_rate === 0 ? '-' : item.avg_comments)) + "\n          ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null || item.median_engagement_rate === 0 ? '-' : item.avg_views)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedPostAnalysis),
      callback: function($$v) {
        _vm.selectedPostAnalysis = $$v
      },
      expression: "selectedPostAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.contents),
      expression: "postColStatuses.contents"
    }]
  }, [_c('strong', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.live_date),
      expression: "postColStatuses.live_date"
    }]
  }, [_c('strong', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.url),
      expression: "postColStatuses.url"
    }]
  }, [_c('strong', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.outreach),
      expression: "postColStatuses.outreach"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalOutreach') === 0 ? '-' : _vm.calPostTotal('totalOutreach'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.reach),
      expression: "postColStatuses.reach"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalReach') === 0 ? '-' : _vm.calPostTotal('totalReach'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.impressions),
      expression: "postColStatuses.impressions"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalImpressions') === 0 ? '-' : _vm.calPostTotal('totalImpressions'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.likes),
      expression: "postColStatuses.likes"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalLikes') === 0 ? '-' : _vm.calPostTotal('totalLikes'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.shares),
      expression: "postColStatuses.shares"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalShares') === 0 ? '-' : _vm.calPostTotal('totalShares'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.comments),
      expression: "postColStatuses.comments"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalComments') === 0 ? '-' : _vm.calPostTotal('totalComments'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.saved),
      expression: "postColStatuses.saved"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalSaved') === 0 ? '-' : _vm.calPostTotal('totalSaved'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.interactions),
      expression: "postColStatuses.interactions"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalInteractions') === 0 ? '-' : _vm.calPostTotal('totalInteractions'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.views),
      expression: "postColStatuses.views"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostTotal('totalViews') === 0 ? '-' : _vm.calPostTotal('totalViews'))))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.new_engagement_rate),
      expression: "postColStatuses.new_engagement_rate"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.calPostTotal('totalEngagementRate') === 0 ? '-' : _vm.calPostTotal('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.new_engagement_rate_view),
      expression: "postColStatuses.new_engagement_rate_view"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.calPostTotal('totalEngagementRateView') === 0 ? '-' : _vm.calPostTotal('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.engagement_rate_reach),
      expression: "postColStatuses.engagement_rate_reach"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.calPostTotal('totalEngagementRateReach') === 0 || _vm.calPostTotal('totalEngagementRateReach') == 'Infinity' ? '-' : _vm.calPostTotal('totalEngagementRateReach') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.engagement_rate_sd),
      expression: "postColStatuses.engagement_rate_sd"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalEngRateSd') === 0 ? '-' : _vm.calPostTotal('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.median_engagement_rate),
      expression: "postColStatuses.median_engagement_rate"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalMedianEngRate') === 0 ? '-' : _vm.calPostTotal('totalMedianEngRate')))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.avg_likes),
      expression: "postColStatuses.avg_likes"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalAvgLikes') === 0 ? '-' : _vm.calPostTotal('totalAvgLikes')))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.avg_comments),
      expression: "postColStatuses.avg_comments"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalAvgComments') === 0 ? '-' : _vm.calPostTotal('totalAvgComments')))])]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postColStatuses.avg_views),
      expression: "postColStatuses.avg_views"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.calPostTotal('totalAvgViews') === 0 ? '-' : _vm.calPostTotal('totalAvgViews')))])])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Story Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('story')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedStoryAnalysis && _vm.selectedStoryAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openStoryAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedStoryAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedStoryTableHeaders,
      "search": _vm.filter,
      "items": _vm.storyAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedStoryTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.replies",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.replies === 0 ? '-' : item.replies)) + "\n          ")]
      }
    }, {
      key: "item.link_clicks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.link_clicks === 0 ? '-' : item.link_clicks)) + "\n          ")]
      }
    }, {
      key: "item.sticker_taps",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.sticker_taps === 0 ? '-' : item.sticker_taps)) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.reach === 0 ? '-' : item.reach)) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.impressions === 0 ? '-' : item.impressions)) + "\n          ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n          ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null ? '-' : item.avg_reels_plays)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedStoryAnalysis),
      callback: function($$v) {
        _vm.selectedStoryAnalysis = $$v
      },
      expression: "selectedStoryAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.storyColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalOutreach') === 0 ? '-' : _vm.calStoryTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalReach') === 0 ? '-' : _vm.calStoryTotal('totalReach'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.impressions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalImpressions') === 0 ? '-' : _vm.calStoryTotal('totalImpressions'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.replies) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalReplies') === 0 ? '-' : _vm.calStoryTotal('totalReplies'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalShares') === 0 ? '-' : _vm.calStoryTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.link_clicks) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalLinkClicks') === 0 ? '-' : _vm.calStoryTotal('totalLinkClicks'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.sticker_taps) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalStickerTaps') === 0 ? '-' : _vm.calStoryTotal('totalStickerTaps'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalInteractions') === 0 ? '-' : _vm.calStoryTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalAvgViews') === 0 ? '-' : _vm.calStoryTotal('totalAvgViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.storyColStatuses.avg_reels_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryTotal('totalAvgReelPlays') === 0 ? '-' : _vm.calStoryTotal('totalAvgReelPlays'))))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Reel Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('reel')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedReelAnalysis && _vm.selectedReelAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openReelAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedReelAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedReelTableHeaders,
      "search": _vm.filter,
      "items": _vm.reelAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedReelTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n          ")]
      }
    }, {
      key: "item.interactions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.interactions === 0 ? '-' : item.interactions)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.shares === 0 ? '-' : item.shares) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.views === 0 ? '-' : item.views) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n          ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.plays === 0 ? '-' : _vm.showReelPlayTime(item.plays)) + "\n          ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate === 0 ? '-' : item.new_engagement_rate + '%') + "\n            ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.new_engagement_rate_view === 0 || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n            ")])]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.interaction_rate_plays === 0 || !item.interaction_rate_plays ? '-' : item.interaction_rate_plays + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_reach === 0 || item.engagement_rate_reach == 'Infinity' || !item.engagement_rate_reach ? '-' : item.engagement_rate_reach + '%') + "\n            ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n              " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n            ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || item.median_engagement_rate === 0 ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null || !item.avg_likes ? '-' : item.avg_likes)) + "\n          ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null || !item.avg_comments ? '-' : item.avg_comments)) + "\n          ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null || !item.avg_views ? '-' : item.avg_views)) + "\n          ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null || !item.avg_reels_plays ? '-' : item.avg_reels_plays)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedReelAnalysis),
      callback: function($$v) {
        _vm.selectedReelAnalysis = $$v
      },
      expression: "selectedReelAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.reelColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.url) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalOutreach') === 0 ? '-' : _vm.calReelTotal('totalOutreach'))))])]), _vm._v(" "), (_vm.reelColStatuses.reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalReach') === 0 ? '-' : _vm.calReelTotal('totalReach'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.impressions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalImpressions') === 0 ? '-' : _vm.calReelTotal('totalImpressions'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalLikes') === 0 ? '-' : _vm.calReelTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalShares') === 0 ? '-' : _vm.calReelTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalComments') === 0 ? '-' : _vm.calReelTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.saved) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalSaved') === 0 ? '-' : _vm.calReelTotal('totalSaved'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalInteractions') === 0 ? '-' : _vm.calReelTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelTotal('totalViews') === 0 ? '-' : _vm.calReelTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalPlayTime))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.watches) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalReelWatchTime))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.new_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngagementRate') === 0 ? '-' : _vm.calReelTotal('totalEngagementRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.new_engagement_rate_view) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngagementRateView') === 0 ? '-' : _vm.calReelTotal('totalEngagementRateView') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.interaction_rate_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalInteractionRatePlays') === 0 ? '-' : _vm.calReelTotal('totalInteractionRatePlays') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.engagement_rate_reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngagementRateReach') === 0 ? '-' : _vm.calReelTotal('totalEngagementRateReach') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.engagement_rate_sd) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalEngRateSd') === 0 ? '-' : _vm.calReelTotal('totalEngRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.median_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalMedianEngRate') === 0 ? '-' : _vm.calReelTotal('totalMedianEngRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalAvgLikes') === 0 ? '-' : _vm.calReelTotal('totalAvgLikes')))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalAvgComments') === 0 ? '-' : _vm.calReelTotal('totalAvgComments')))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalAvgViews') === 0 ? '-' : _vm.calReelTotal('totalAvgViews')))])]) : _vm._e(), _vm._v(" "), (_vm.reelColStatuses.avg_reels_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calReelTotal('totalReelPlays') === 0 ? '-' : _vm.calReelTotal('totalReelPlays')))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("TikTok Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('tiktok')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedTikTokAnalysis && _vm.selectedTikTokAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openTikTokAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedTikTokAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedTikTokTableHeaders,
      "search": _vm.filter,
      "items": _vm.tiktokAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedTikTokTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n          ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n          ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.plays === 0 ? '-' : _vm.showTikTokPlayTime(item.plays)) + "\n          ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate === null || !item.new_engagement_rate ? '-' : item.new_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate_view === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n          ")]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.interaction_rate_plays === null || !item.interaction_rate_plays ? '-' : item.interaction_rate_plays + '%') + "\n          ")]
      }
    }, {
      key: "item.eng_rate_total_viewers",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.eng_rate_total_viewers === null || !item.eng_rate_total_viewers ? '-' : item.eng_rate_total_viewers + '%') + "\n          ")]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.engagement_rate_sd === null || !item.eng_rate_total_viewers ? '-' : item.engagement_rate_sd + '%') + "\n          ")]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || !item.eng_rate_total_viewers ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.watchedFullVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.watchedFullVideo === null ? '-' : item.watchedFullVideo + '%') + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedTikTokAnalysis),
      callback: function($$v) {
        _vm.selectedTikTokAnalysis = $$v
      },
      expression: "selectedTikTokAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.tiktokColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.url) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalOutreach') === 0 ? '-' : _vm.calTikTokTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.totalTikTokPlayTime))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.watches) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalWatches') === '0s' ? '-' : _vm.calTikTokTotal('totalWatches')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalLikes') === 0 ? '-' : _vm.calTikTokTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalComments') === 0 ? '-' : _vm.calTikTokTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalShares') === 0 ? '-' : _vm.calTikTokTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.saved) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalBookmarks') === 0 ? '-' : _vm.calTikTokTotal('totalBookmarks'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalInteractions') === 0 ? '-' : _vm.calTikTokTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalViews') === 0 ? '-' : _vm.calTikTokTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.reach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalReach') === 0 ? '-' : _vm.calTikTokTotal('totalReach'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.impressions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokTotal('totalImpressions') === 0 ? '-' : _vm.calTikTokTotal('totalImpressions'))))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgViews') === 0 ? '-' : _vm.calTikTokTotal('totalAvgViews')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgLikes') === 0 ? '-' : _vm.calTikTokTotal('totalAvgLikes')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgComments') === 0 ? '-' : _vm.calTikTokTotal('totalAvgComments')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_saves) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgSaves') === 0 ? '-' : _vm.calTikTokTotal('totalAvgSaves')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.avg_shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalAvgShares') === 0 ? '-' : _vm.calTikTokTotal('totalAvgShares')))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.new_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngagementRate') === 0 ? '-' : _vm.calTikTokTotal('totalEngagementRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.new_engagement_rate_view) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngagementRateView') === 0 || !_vm.calTikTokTotal('totalEngagementRateView') ? '-' : _vm.calTikTokTotal('totalEngagementRateView') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.interaction_rate_plays) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalInteractionRatePlays') === 0 || !_vm.calTikTokTotal('totalInteractionRatePlays') ? '-' : _vm.calTikTokTotal('totalInteractionRatePlays') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.eng_rate_total_viewers) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngRateTotalViewers') === 0 ? '-' : _vm.calTikTokTotal('totalEngRateTotalViewers') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.engagement_rate_sd) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalEngRateSd') === 0 || !_vm.calTikTokTotal('totalEngRateSd') ? '-' : _vm.calTikTokTotal('totalEngRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.median_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalMedianEngRateSd') === 0 ? '-' : _vm.calTikTokTotal('totalMedianEngRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.tiktokColStatuses.watchedFullVideo) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calTikTokTotal('totalWatchedFullVideo') === 0 ? '-' : _vm.calTikTokTotal('totalWatchedFullVideo') + '%'))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Youtube Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('youtube')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedYoutubeAnalysis && _vm.selectedYoutubeAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openYoutubeAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedYoutubeAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedYoutubeTableHeaders,
      "search": _vm.filter,
      "items": _vm.youtubeAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedYoutubeTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n          ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.new_engagement_rate_view === null || !item.new_engagement_rate_view ? '-' : item.new_engagement_rate_view + '%') + "\n          ")]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.engagement_rate_sd === null || !item.new_engagement_rate_view ? '-' : item.engagement_rate_sd + '%') + "\n          ")]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(item.median_engagement_rate === null || !item.new_engagement_rate_view ? '-' : item.median_engagement_rate + '%') + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedYoutubeAnalysis),
      callback: function($$v) {
        _vm.selectedYoutubeAnalysis = $$v
      },
      expression: "selectedYoutubeAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.youtubeColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.url) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalOutreach') === 0 ? '-' : _vm.calYoutubeTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalViews') === 0 ? '-' : _vm.calYoutubeTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalLikes') === 0 ? '-' : _vm.calYoutubeTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalComments') === 0 ? '-' : _vm.calYoutubeTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalInteractions') === 0 ? '-' : _vm.calYoutubeTotal('totalInteractions'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.avg_views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalAvgViews') === 0 ? '-' : _vm.calYoutubeTotal('totalAvgViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.avg_likes) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalAvgLikes') === 0 ? '-' : _vm.calYoutubeTotal('totalAvgLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.avg_comments) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeTotal('totalAvgComments') === 0 ? '-' : _vm.calYoutubeTotal('totalAvgComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.new_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalEngagementRate') === 0 ? '-' : _vm.calYoutubeTotal('totalEngagementRate') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.new_engagement_rate_view) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalEngagementRateView') === 0 ? '-' : _vm.calYoutubeTotal('totalEngagementRateView') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.engagement_rate_sd) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalEngagementRateSd') === 0 ? '-' : _vm.calYoutubeTotal('totalEngagementRateSd') + '%'))])]) : _vm._e(), _vm._v(" "), (_vm.youtubeColStatuses.median_engagement_rate) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm.calYoutubeTotal('totalMedianEngagementRate') === 0 ? '-' : _vm.calYoutubeTotal('totalMedianEngagementRate') + '%'))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("XHS Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('xhs')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedXhsAnalysis && _vm.selectedXhsAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openXhsAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedXhsAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedXHSTableHeaders,
      "search": _vm.filter,
      "items": _vm.xhsAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedXHSTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n          ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedXhsAnalysis),
      callback: function($$v) {
        _vm.selectedXhsAnalysis = $$v
      },
      expression: "selectedXhsAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.xhsColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalOutreach') === 0 ? '-' : _vm.calXHSTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.like_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalLikes') === 0 ? '-' : _vm.calXHSTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.comment_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalComments') === 0 ? '-' : _vm.calXHSTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalViews') === 0 ? '-' : _vm.calXHSTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalShares') === 0 ? '-' : _vm.calXHSTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.bookmarks) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalBookmarks') === 0 ? '-' : _vm.calXHSTotal('totalBookmarks'))))])]) : _vm._e(), _vm._v(" "), (_vm.xhsColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXHSTotal('totalInteractions') === 0 ? '-' : _vm.calXHSTotal('totalInteractions'))))])]) : _vm._e()])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-5 pb-5"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "h4 mb-2"
  }, [_vm._v("Facebook Analysis Summary")]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openColSettingsModal('facebook')
            }
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    staticClass: "action-section mb-0 mt-2 ml-1"
  }, [_c('v-col', {
    staticClass: "action-group-section pl-0",
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "gap": "3px"
    }
  }, [_c('div', [(_vm.selectedFbAnalysis && _vm.selectedFbAnalysis.length > 0) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openFbAnalysisAvgModal()
      }
    }
  }, [_vm._v("Calculate Average (" + _vm._s(_vm.selectedFbAnalysis.length) + ")")]) : _vm._e()], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "statistics-analysis-table elevation-1",
    attrs: {
      "headers": _vm.computedFbTableHeaders,
      "search": _vm.filter,
      "items": _vm.fbAnalysisData,
      "show-select": "",
      "single-select": false
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedFbTableHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "rootClass": "legend-row"
            }
          })]
        }
      }
    }), {
      key: "item.contents",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [(item.campaign) ? _c('span', [_vm._v(_vm._s(item.campaign.name))]) : _vm._e()])]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n          ")]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n          ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n          ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n          ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n          ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n          ")]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedFbAnalysis),
      callback: function($$v) {
        _vm.selectedFbAnalysis = $$v
      },
      expression: "selectedFbAnalysis"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("AVERAGE")])]), _vm._v(" "), (_vm.fbColStatuses.contents) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.live_date) ? _c('td', [_c('strong', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.outreach) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalOutreach') === 0 ? '-' : _vm.calFbTotal('totalOutreach'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.like_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalLikes') === 0 ? '-' : _vm.calFbTotal('totalLikes'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.comment_count) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalComments') === 0 ? '-' : _vm.calFbTotal('totalComments'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.views) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalViews') === 0 ? '-' : _vm.calFbTotal('totalViews'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.shares) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalShares') === 0 ? '-' : _vm.calFbTotal('totalShares'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.bookmarks) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalBookmarks') === 0 ? '-' : _vm.calFbTotal('totalBookmarks'))))])]) : _vm._e(), _vm._v(" "), (_vm.fbColStatuses.interactions) ? _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbTotal('totalInteractions') === 0 ? '-' : _vm.calFbTotal('totalInteractions'))))])]) : _vm._e()])])], 2)], 1)])], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": _vm.getUpdateColTitle(),
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgPostAnalysisDialog),
      callback: function($$v) {
        _vm.avgPostAnalysisDialog = $$v
      },
      expression: "avgPostAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Post Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedPostAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalOutreach') === 0 ? '-' : _vm.calPostAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalReach') === 0 ? '-' : _vm.calPostAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalImpressions') === 0 ? '-' : _vm.calPostAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalLikes') === 0 ? '-' : _vm.calPostAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalShares') === 0 ? '-' : _vm.calPostAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalComments') === 0 ? '-' : _vm.calPostAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Saves:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalSaved') === 0 ? '-' : _vm.calPostAvg('totalSaved'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalInteractions') === 0 ? '-' : _vm.calPostAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calPostAvg('totalViews') === 0 ? '-' : _vm.calPostAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngagementRate') === 0 ? '-' : _vm.calPostAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Play Rate (by Outreach)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngagementRateView') === 0 ? '-' : _vm.calPostAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Reach")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngagementRateReach') === 0 || _vm.calPostAvg('totalEngagementRateReach') == 'Infinity' ? '-' : _vm.calPostAvg('totalEngagementRateReach') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Avg. Engagement Rate")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalEngRateSd') === 0 ? '-' : _vm.calPostAvg('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalMedianEngRate') === 0 ? '-' : _vm.calPostAvg('totalMedianEngRate')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalAvgLikes') === 0 ? '-' : _vm.calPostAvg('totalAvgLikes')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalAvgComments') === 0 ? '-' : _vm.calPostAvg('totalAvgComments')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calPostAvg('totalAvgViews') === 0 ? '-' : _vm.calPostAvg('totalAvgViews')))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgPostAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgStoryAnalysisDialog),
      callback: function($$v) {
        _vm.avgStoryAnalysisDialog = $$v
      },
      expression: "avgStoryAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Story Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedStoryAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalOutreach') === 0 ? '-' : _vm.calStoryAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalReach') === 0 ? '-' : _vm.calStoryAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalImpressions') === 0 ? '-' : _vm.calStoryAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Replies:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalReplies') === 0 ? '-' : _vm.calStoryAvg('totalReplies'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalShares') === 0 ? '-' : _vm.calStoryAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalShares') === 0 ? '-' : _vm.calStoryAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Links Click:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalLinkClicks') === 0 ? '-' : _vm.calStoryAvg('totalLinkClicks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Sticker Taps:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalStickerTaps') === 0 ? '-' : _vm.calStoryAvg('totalStickerTaps'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalInteractions') === 0 ? '-' : _vm.calStoryAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalAvgViews') === 0 ? '-' : _vm.calStoryAvg('totalAvgViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Reels Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calStoryAvg('totalAvgReelPlays') === 0 ? '-' : _vm.calStoryAvg('totalAvgReelPlays'))))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgStoryAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgReelAnalysisDialog),
      callback: function($$v) {
        _vm.avgReelAnalysisDialog = $$v
      },
      expression: "avgReelAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Reel Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedReelAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalOutreach') === 0 ? '-' : _vm.calReelAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Accounts Reached:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalReach') === 0 ? '-' : _vm.calReelAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalImpressions') === 0 ? '-' : _vm.calReelAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalLikes') === 0 ? '-' : _vm.calReelAvg('totalReplies'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalShares') === 0 ? '-' : _vm.calReelAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalComments') === 0 ? '-' : _vm.calReelAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Saves:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalSaved') === 0 ? '-' : _vm.calReelAvg('totalSaved'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalInteractions') === 0 ? '-' : _vm.calReelAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calReelAvg('totalViews') === 0 ? '-' : _vm.calReelAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalAvgPlayTime))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalAvgReelWatchTime))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngagementRate') === 0 ? '-' : _vm.calReelAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Play Rate (by Outreach):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngagementRateView') === 0 ? '-' : _vm.calReelAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalInteractionRatePlays') === 0 ? '-' : _vm.calReelAvg('totalInteractionRatePlays') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Reach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngagementRateReach') === 0 ? '-' : _vm.calReelAvg('totalEngagementRateReach') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Avg. Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalEngRateSd') === 0 ? '-' : _vm.calReelAvg('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalMedianEngRate') === 0 ? '-' : _vm.calReelAvg('totalMedianEngRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalAvgLikes') === 0 ? '-' : _vm.calReelAvg('totalAvgLikes')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalAvgComments') === 0 ? '-' : _vm.calReelAvg('totalAvgComments')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalAvgViews') === 0 ? '-' : _vm.calReelAvg('totalAvgViews')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Reels Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calReelAvg('totalReelPlays') === 0 ? '-' : _vm.calReelAvg('totalReelPlays')))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgReelAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgTiktokAnalysisDialog),
      callback: function($$v) {
        _vm.avgTiktokAnalysisDialog = $$v
      },
      expression: "avgTiktokAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average TikTok Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedTikTokAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalOutreach') === 0 ? '-' : _vm.calReelAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Play Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.avgTikTokPlayTime))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Watch Time:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalWatches') === '0s' ? '-' : _vm.calTikTokAvg('totalWatches')))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalLikes') === 0 ? '-' : _vm.calTikTokAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalComments') === 0 ? '-' : _vm.calTikTokAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalShares') === 0 ? '-' : _vm.calTikTokAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Favourites:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalBookmarks') === 0 ? '-' : _vm.calTikTokAvg('totalBookmarks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalInteractions') === 0 ? '-' : _vm.calTikTokAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalViews') === 0 ? '-' : _vm.calTikTokAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Viewers:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalReach') === 0 ? '-' : _vm.calTikTokAvg('totalReach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Impressions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalImpressions') === 0 ? '-' : _vm.calTikTokAvg('totalImpressions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgViews') === 0 ? '-' : _vm.calTikTokAvg('totalAvgViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgLikes') === 0 ? '-' : _vm.calTikTokAvg('totalAvgLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgComments') === 0 ? '-' : _vm.calTikTokAvg('totalAvgComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Saves:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgSaves') === 0 ? '-' : _vm.calTikTokAvg('totalAvgSaves'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calTikTokAvg('totalAvgShares') === 0 ? '-' : _vm.calTikTokAvg('totalAvgShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngagementRate') === 0 ? '-' : _vm.calTikTokAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Play Rate (by Outreach):")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngagementRateView') === 0 ? '-' : _vm.calTikTokAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Plays:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalInteractionRatePlays') === 0 ? '-' : _vm.calTikTokAvg('totalInteractionRatePlays') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Total Viewers:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngRateTotalViewers') === 0 ? '-' : _vm.calTikTokAvg('totalEngRateTotalViewers') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalEngRateSd') === 0 ? '-' : _vm.calTikTokAvg('totalEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalMedianEngRateSd') === 0 ? '-' : _vm.calTikTokAvg('totalMedianEngRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Watched Full Video:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calTikTokAvg('totalWatchedFullVideo') === 0 ? '-' : _vm.calTikTokAvg('totalWatchedFullVideo') + '%'))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgTiktokAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgYoutubeAnalysisDialog),
      callback: function($$v) {
        _vm.avgYoutubeAnalysisDialog = $$v
      },
      expression: "avgYoutubeAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Youtube Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedYoutubeAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalOutreach') === 0 ? '-' : _vm.calYoutubeAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalViews') === 0 ? '-' : _vm.calYoutubeAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalLikes') === 0 ? '-' : _vm.calYoutubeAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalComments') === 0 ? '-' : _vm.calYoutubeAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalInteractions') === 0 ? '-' : _vm.calYoutubeAvg('totalInteractions'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalAvgViews') === 0 ? '-' : _vm.calYoutubeAvg('totalAvgViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalAvgLikes') === 0 ? '-' : _vm.calYoutubeAvg('totalAvgLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calYoutubeAvg('totalAvgComments') === 0 ? '-' : _vm.calYoutubeAvg('totalAvgComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalEngagementRate') === 0 ? '-' : _vm.calYoutubeAvg('totalEngagementRate') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Engagement Rate by Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalEngagementRateView') === 0 ? '-' : _vm.calYoutubeAvg('totalEngagementRateView') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Average Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalEngagementRateSd') === 0 ? '-' : _vm.calYoutubeAvg('totalEngagementRateSd') + '%'))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Median Engagement Rate:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.calYoutubeAvg('totalMedianEngagementRate') === 0 ? '-' : _vm.calYoutubeAvg('totalMedianEngagementRate') + '%'))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgYoutubeAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgXhsAnalysisDialog),
      callback: function($$v) {
        _vm.avgXhsAnalysisDialog = $$v
      },
      expression: "avgXhsAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average XHS Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedXhsAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalOutreach') === 0 ? '-' : _vm.calXhsAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalLikes') === 0 ? '-' : _vm.calXhsAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalComments') === 0 ? '-' : _vm.calXhsAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalViews') === 0 ? '-' : _vm.calXhsAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalShares') === 0 ? '-' : _vm.calXhsAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Bookmarks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalBookmarks') === 0 ? '-' : _vm.calXhsAvg('totalBookmarks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calXhsAvg('totalInteractions') === 0 ? '-' : _vm.calXhsAvg('totalInteractions'))))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgXhsAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.avgFbAnalysisDialog),
      callback: function($$v) {
        _vm.avgFbAnalysisDialog = $$v
      },
      expression: "avgFbAnalysisDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Average Facebook Analysis")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedFbAnalysis.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Outreach:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalOutreach') === 0 ? '-' : _vm.calFbAvg('totalOutreach'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Likes:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalLikes') === 0 ? '-' : _vm.calFbAvg('totalLikes'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Comments:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalComments') === 0 ? '-' : _vm.calFbAvg('totalComments'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Views:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalViews') === 0 ? '-' : _vm.calFbAvg('totalViews'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Shares:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalShares') === 0 ? '-' : _vm.calFbAvg('totalShares'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Bookmarks:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalBookmarks') === 0 ? '-' : _vm.calFbAvg('totalBookmarks'))))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Interactions:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.calFbAvg('totalInteractions') === 0 ? '-' : _vm.calFbAvg('totalInteractions'))))])])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.avgFbAnalysisDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [(_vm.item) ? _c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Checklists for " + _vm._s(_vm.item.name) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "height": "400px",
      "margin-top": "20px"
    }
  }, [_c('v-list', _vm._l((_vm.checklist), function(check, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "px-0"
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(check.loading) ? _c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "color": "warning",
        "size": "24"
      }
    }) : _c('v-icon', {
      attrs: {
        "color": check.passed ? 'success' : 'error'
      }
    }, [_vm._v("\n              " + _vm._s(check.passed ? 'mdi-check-circle' : 'mdi-close-circle') + "\n            ")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('div', {
      staticClass: "title-section"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(check.text))])], 1), _vm._v(" "), _c('div', {
      staticClass: "value-section"
    }, [((check.igFollower || check.tiktokFollower) && !_vm.isLoading) ? _c('div', {
      staticClass: "text-left"
    }, [(check.igFollower) ? _c('div', {
      staticClass: "value-item"
    }, [_vm._v("IG Followers: " + _vm._s(_vm._f("thousandSeprator")(check.igFollower)))]) : _vm._e(), _vm._v(" "), (check.tiktokFollower) ? _c('div', {
      staticClass: "value-item"
    }, [_vm._v("TikTok Followers: " + _vm._s(_vm._f("thousandSeprator")(check.tiktokFollower)))]) : _vm._e()]) : (check.email !== undefined) ? _c('div', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "value-item"
    }, [_vm._v("Email: " + _vm._s(check.email || 'N/A'))]), _vm._v(" "), _c('div', {
      staticClass: "value-item"
    }, [_vm._v("Contact No: " + _vm._s(check.contactNo || 'N/A'))])]) : (check.value !== undefined) ? _c('div', {
      staticClass: "text-left"
    }, [(Array.isArray(check.value)) ? _c('div', {
      staticClass: "value-item"
    }, [_vm._v("\n                  " + _vm._s(check.value.join(', ')) + "\n                ")]) : _c('div', {
      staticClass: "value-item"
    }, [_vm._v("\n                  " + _vm._s(check.value) + "\n                ")])]) : _vm._e()])])], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end pa-4"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        Done\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.verifying,
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadChecklist(true)
      }
    }
  }, [_vm._v("\n        Check Validation\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('summary-of-account', {
    attrs: {
      "filterUsers": _vm.filterUser,
      "userType": "AM"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activeMasterListData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline pb-5"
  }, [_vm._v(_vm._s(_vm.editTimelineData ? 'Update' : 'Add') + " Amount")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Available Amount: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.availableAmt)))])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Amount: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "hide-details": "",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.activeMasterListData.quoteAmt),
      callback: function($$v) {
        _vm.$set(_vm.activeMasterListData, "quoteAmt", $$v)
      },
      expression: "activeMasterListData.quoteAmt"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Start Month : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "input-field",
          attrs: {
            "hide-details": "",
            "append-icon": "event",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.activeMasterListData.startMonth),
            callback: function($$v) {
              _vm.$set(_vm.activeMasterListData, "startMonth", $$v)
            },
            expression: "activeMasterListData.startMonth"
          }
        }, on))]
      }
    }], null, false, 3294631694),
    model: {
      value: (_vm.startCal),
      callback: function($$v) {
        _vm.startCal = $$v
      },
      expression: "startCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.startCal = false
      }
    },
    model: {
      value: (_vm.activeMasterListData.startMonth),
      callback: function($$v) {
        _vm.$set(_vm.activeMasterListData, "startMonth", $$v)
      },
      expression: "activeMasterListData.startMonth"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("End Month : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "input-field",
          attrs: {
            "hide-details": "",
            "append-icon": "event",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.activeMasterListData.endMonth),
            callback: function($$v) {
              _vm.$set(_vm.activeMasterListData, "endMonth", $$v)
            },
            expression: "activeMasterListData.endMonth"
          }
        }, on))]
      }
    }], null, false, 29401697),
    model: {
      value: (_vm.endCal),
      callback: function($$v) {
        _vm.endCal = $$v
      },
      expression: "endCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.endCal = false
      }
    },
    model: {
      value: (_vm.activeMasterListData.endMonth),
      callback: function($$v) {
        _vm.$set(_vm.activeMasterListData, "endMonth", $$v)
      },
      expression: "activeMasterListData.endMonth"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Remarks : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.activeMasterListData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.activeMasterListData, "remarks", $$v)
      },
      expression: "activeMasterListData.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.disableSave
    },
    on: {
      "click": function($event) {
        return _vm.processUpdate()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Add Actual Amount for @" + _vm._s(_vm.report.instagram))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hide-details": "",
      "prefix": "S$",
      "error-messages": _vm.amountErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.amount.$touch()
      }
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = _vm._n($$v)
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.amount.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("TikTok Post Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "tiktok-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15 report-summary-table",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "items-per-page": 15,
      "page": _vm.page,
      "item-key": "key",
      "custom-sort": _vm.customSort
    },
    on: {
      "update:page": function($event) {
        _vm.page = $event
      },
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v("@" + _vm._s(item.name))])], 1)]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                        View\n                      ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n                  ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n                  ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n                  ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n                  ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.plays === 0 ? '-' : _vm.showTikTokPlayTime(item.plays)) + "\n                  ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.new_engagement_rate === null ? '-' : item.new_engagement_rate + '%') + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.new_engagement_rate_view === null ? '-' : item.new_engagement_rate_view + '%') + "\n                  ")]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.interaction_rate_plays === null ? '-' : item.interaction_rate_plays + '%') + "\n                  ")]
      }
    }, {
      key: "item.eng_rate_total_viewers",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.eng_rate_total_viewers === null ? '-' : item.eng_rate_total_viewers + '%') + "\n                  ")]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n                  ")]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.median_engagement_rate === null ? '-' : item.median_engagement_rate + '%') + "\n                  ")]
      }
    }, {
      key: "item.watchedFullVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.watchedFullVideo === null ? '-' : item.watchedFullVideo + '%') + "\n                  ")]
      }
    }, {
      key: "item.photo_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.photo_views === 0 ? '-' : item.photo_views)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'url') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'plays') ? [_vm._v(_vm._s(_vm.showTikTokPlayTime(_vm.totalPlayTime)))] : (header.value === 'watches') ? [_vm._v("-")] : (header.value === 'likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'comments') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'saved') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalBookmarks === 0 ? '-' : _vm.totalBookmarks)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews === 0 ? '-' : _vm.totalViews)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'avg_views') ? [_vm._v("-")] : (header.value === 'avg_likes') ? [_vm._v("-")] : (header.value === 'avg_comments') ? [_vm._v("-")] : (header.value === 'avg_saves') ? [_vm._v("-")] : (header.value === 'avg_shares') ? [_vm._v("-")] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm.totalEngagementRate === 0 ? '-' : _vm.totalEngagementRate) + " %")] : (header.value === 'new_engagement_rate_view') ? [_vm._v(_vm._s(_vm.totalEngagementRateView === 0 ? '-' : _vm.totalEngagementRateView) + " %")] : (header.value === 'interaction_rate_plays') ? [_vm._v(_vm._s(_vm.totalInteractionRatePlays === 0 ? '-' : _vm.totalInteractionRatePlays) + " %")] : (header.value === 'eng_rate_total_viewers') ? [_vm._v(_vm._s(_vm.totalEngRateTotalViewers === 0 ? '-' : _vm.totalEngRateTotalViewers) + " %")] : (header.value === 'engagement_rate_sd') ? [_vm._v(" - ")] : (header.value === 'median_engagement_rate') ? [_vm._v(" - ")] : (header.value === 'watchedFullVideo') ? [_vm._v(_vm._s(_vm.totalWatchedFullVideo === 0 ? '-' : _vm.totalWatchedFullVideo) + " %")] : (header.value === 'photo_views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalPhotoViews === 0 ? '-' : _vm.totalPhotoViews)))] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "TikTok Post Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateTikTokAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-dismiss": "modal"
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('v-card', {
      key: post.oembed
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(post.oembed)
      }
    })])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "row mt-0 mb-5"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateModal()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n        ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.infLists,
      "items-per-page": 15
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticStyle: {
            "width": "150px"
          }
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.getDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencer List"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteInf(item)
            }
          }
        }, [_c('v-icon', _vm._g({
          attrs: {
            "color": "white",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete",
            "small": ""
          }
        }, _vm.on), [_vm._v("mdi-delete-forever")])], 1)], 1)]
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('view-influencer-list-modal', {
    attrs: {
      "value": _vm.viewInfListDialog,
      "creator": _vm.viewCreator
    },
    on: {
      "reload": function($event) {
        return _vm.reload()
      }
    },
    model: {
      value: (_vm.viewInfListDialog),
      callback: function($$v) {
        _vm.viewInfListDialog = $$v
      },
      expression: "viewInfListDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("Projected COGS")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "recognized-revenue-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.monthYearValues,
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.month",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.month) ? _c('span', [_vm._v(_vm._s(item.month))]) : _vm._e()])]
      }
    }, {
      key: "item.totalAmt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.totalAmt) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.totalAmt)))]) : _vm._e()])]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.amount) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e()])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalCogsAmount)))])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalAmount)))])])])])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value && _vm.showDialog),
      expression: "value && showDialog"
    }],
    staticClass: "theme--dark"
  }, [(_vm.showDialog) ? _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Submission Date")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": _vm.submissionDateFormatted,
            "label": "",
            "prepend-icon": "mdi-calendar",
            "hint": "DD/MM/YYYY format",
            "readonly": ""
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 1854811427),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.submissionDate),
      callback: function($$v) {
        _vm.submissionDate = $$v
      },
      expression: "submissionDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.updateSubmission
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("\n        Create New User\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "filled": "",
      "items": _vm.userType_options,
      "label": "Select User Type",
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.user.role),
      callback: function($$v) {
        _vm.$set(_vm.user, "role", $$v)
      },
      expression: "user.role"
    }
  })], 1)], 1), _vm._v(" "), (_vm.user.role !== '') ? _c('v-row', [(_vm.needCompany) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "solo": "",
      "items": _vm.company_options,
      "label": "Assign User to a Company",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.user.companyID),
      callback: function($$v) {
        _vm.$set(_vm.user, "companyID", $$v)
      },
      expression: "user.companyID"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.firstName.$error
    },
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter user first name"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.firstName.$touch()
      }
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), (!_vm.$v.user.firstName.required && _vm.$v.user.firstName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("First name is required")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.lastName.$error
    },
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter user last name"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.lastName.$touch()
      }
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), (!_vm.$v.user.lastName.required && _vm.$v.user.lastName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Last name is required\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.email.$error
    },
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (!_vm.$v.user.email.required && _vm.$v.user.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Email is required\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    class: {
      'has-error': _vm.$v.user.password.$error
    },
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "solo": "",
      "type": "password",
      "placeholder": "Enter password"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.user.password.$touch()
      }
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), (!_vm.$v.user.password.required && _vm.$v.user.password.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Password is required\n          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isInf) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "filled": "",
      "items": _vm.platforms,
      "label": "Select User Type",
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.role === _vm.userRoles.ACCOUNT_MANAGER) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('label', [_vm._v("Account Admins")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "solo": "",
      "multiple": "",
      "items": _vm.accountAdmins,
      "label": "Select Admin Users",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.user.accountAdmins),
      callback: function($$v) {
        _vm.$set(_vm.user, "accountAdmins", $$v)
      },
      expression: "user.accountAdmins"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebookPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter Facebook Handle"
    },
    model: {
      value: (_vm.facebook.fbHandle),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "fbHandle", $$v)
      },
      expression: "facebook.fbHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebookPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Followers"
    },
    model: {
      value: (_vm.facebook.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "totalFollowers", $$v)
      },
      expression: "facebook.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebookPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Following"
    },
    model: {
      value: (_vm.facebook.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "totalFollowing", $$v)
      },
      expression: "facebook.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter XHS Fullname"
    },
    model: {
      value: (_vm.xhs.xhsFullname),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsFullname", $$v)
      },
      expression: "xhs.xhsFullname"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter XHS Handle"
    },
    model: {
      value: (_vm.xhs.xhsHandle),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsHandle", $$v)
      },
      expression: "xhs.xhsHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Enter XHS ID"
    },
    model: {
      value: (_vm.xhs.xhsID),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsID", $$v)
      },
      expression: "xhs.xhsID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Followers"
    },
    model: {
      value: (_vm.xhs.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalFollowers", $$v)
      },
      expression: "xhs.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Following"
    },
    model: {
      value: (_vm.xhs.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalFollowing", $$v)
      },
      expression: "xhs.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isXHSPlatform) ? _c('v-col', {
    attrs: {
      "md": "6",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "placeholder": "Enter Total Likes/Favourites"
    },
    model: {
      value: (_vm.xhs.totalLikesFavourites),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalLikesFavourites", $$v)
      },
      expression: "xhs.totalLikesFavourites"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.createUser()
      }
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    staticClass: "mb-2"
  }, [_c('v-col', {
    attrs: {
      "col": "6"
    }
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openCreatePaymentConsolidateModal(null)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.openViewInvoiceModal
    }
  }, [_c('v-icon', [_vm._v("mdi-file-check")]), _vm._v(" View Invoices\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.exportReportAllBatch()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v(" Export Excel")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "mx-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-2 mt-2",
    staticStyle: {
      "max-width": "200px"
    }
  }, [_c('v-menu', {
    ref: "globalLiveDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Live Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.searchLiveDataFilter()
            }
          },
          model: {
            value: (_vm.globalFilter.searchliveDateMonth),
            callback: function($$v) {
              _vm.$set(_vm.globalFilter, "searchliveDateMonth", $$v)
            },
            expression: "globalFilter.searchliveDateMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.globalFilter.liveDatePicker),
      callback: function($$v) {
        _vm.$set(_vm.globalFilter, "liveDatePicker", $$v)
      },
      expression: "globalFilter.liveDatePicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.globalFilter.searchliveDateMonth),
      callback: function($$v) {
        _vm.$set(_vm.globalFilter, "searchliveDateMonth", $$v)
      },
      expression: "globalFilter.searchliveDateMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelGlobalMonth('liveDate')
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchGlobalMonthOk('liveDate')
      }
    }
  }, [_vm._v("\n                OK\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        return _vm.searchGlobal()
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1)])], 1), _vm._v(" "), _vm._l((_vm.batches), function(batch, bindex) {
    return _c('div', {
      key: bindex,
      staticClass: "payment-consolidate-section",
      attrs: {
        "id": batch.batchNo
      }
    }, [_c('v-expansion-panels', {
      staticClass: "expansion-panels mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (batch.panel),
        callback: function($$v) {
          _vm.$set(batch, "panel", $$v)
        },
        expression: "batch.panel"
      }
    }, [_c('v-expansion-panel', {
      staticClass: "expansion-panel-main",
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "expansion-panel-header"
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(batch.name))])]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "expansion-panel-content"
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-row', {
      staticClass: "action-section mb-3"
    }, [_c('v-col', {
      staticClass: "action-group-section",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "gap": "3px"
      }
    }, [_c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exportReport(batch)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-file-excel")]), _vm._v(" Export Excel")], 1), _vm._v(" "), (_vm.allowedActions(batch.batchNo)) ? _c('div', [(batch.selectedPayments && batch.selectedPayments.length > 0 && batch.status !== _vm.paymentStatus.PAID) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openPaymentUpdateModal(batch.selectedPayments)
        }
      }
    }, [_vm._v("Update Status (" + _vm._s(batch.selectedPayments.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.isDeleteAction(batch.selectedPayments) && batch.status !== _vm.paymentStatus.PAID) ? _c('v-btn', {
      staticClass: "btn-payment-action",
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "color": "red mb-2",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteMultipleReport()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-delete")]), _vm._v(" Delete\n                      ")], 1) : _vm._e(), _vm._v(" "), (batch.selectedPayments && batch.selectedPayments.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.saveArchive(batch)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-archive")]), _vm._v(" Archive\n                      ")], 1) : _vm._e(), _vm._v(" "), (!batch.disableSaveEdit) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "success",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.saveChanges(batch.displayData, batch)
        }
      }
    }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (!batch.disableSaveEdit) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.cancelEdit(batch.displayData, batch)
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-right float-right"
    }, [_c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      on: {
        "keyup": function($event) {
          return _vm.changeSearch(batch, batch.filter, batch.filter.search)
        }
      },
      model: {
        value: (batch.filter.search),
        callback: function($$v) {
          _vm.$set(batch.filter, "search", $$v)
        },
        expression: "batch.filter.search"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mx-2"
    }, [_c('v-checkbox', {
      staticClass: "imported-only-checkbox",
      staticStyle: {
        "min-width": "150px",
        "max-width": "150px"
      },
      attrs: {
        "label": "Imported Only",
        "color": "secondary",
        "value": false,
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.searchFilter(batch)
        }
      },
      model: {
        value: (batch.filter.imported),
        callback: function($$v) {
          _vm.$set(batch.filter, "imported", $$v)
        },
        expression: "batch.filter.imported"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mx-2 mt-2",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "label": "All CC",
        "items": _vm.CCUsers,
        "item-text": "name",
        "item-value": "id",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.searchFilter(batch)
        }
      },
      model: {
        value: (batch.filter.cc),
        callback: function($$v) {
          _vm.$set(batch.filter, "cc", $$v)
        },
        expression: "batch.filter.cc"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mx-2 mt-2",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "label": "",
        "items": _vm.filterCountries,
        "item-text": "name",
        "item-value": "name",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.searchFilter(batch)
        }
      },
      model: {
        value: (batch.filter.country),
        callback: function($$v) {
          _vm.$set(batch.filter, "country", $$v)
        },
        expression: "batch.filter.country"
      }
    })], 1), _vm._v(" "), (_vm.allowFilters('paymentDate', batch.batchNo)) ? _c('div', {
      staticClass: "mx-2 mt-2"
    }, [_c('v-menu', {
      ref: "paymentDatePicker",
      refInFor: true,
      attrs: {
        "close-on-content-click": false,
        "transition": "scale-transition",
        "offset-y": "",
        "dense": "",
        "max-width": "290px",
        "min-width": "auto"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-text-field', _vm._g(_vm._b({
            attrs: {
              "label": "Payment Date",
              "readonly": "",
              "clearable": "",
              "outlined": "",
              "dense": "",
              "hide-details": "auto"
            },
            on: {
              "change": function($event) {
                return _vm.searchFilter(batch)
              }
            },
            model: {
              value: (batch.filter.searchPaymentDateMonth),
              callback: function($$v) {
                _vm.$set(batch.filter, "searchPaymentDateMonth", $$v)
              },
              expression: "batch.filter.searchPaymentDateMonth"
            }
          }, 'v-text-field', attrs, false), on))]
        }
      }], null, true),
      model: {
        value: (batch.filter.paymentDatePicker),
        callback: function($$v) {
          _vm.$set(batch.filter, "paymentDatePicker", $$v)
        },
        expression: "batch.filter.paymentDatePicker"
      }
    }, [_vm._v(" "), _c('v-date-picker', {
      attrs: {
        "type": "month",
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (batch.filter.searchPaymentDateMonth),
        callback: function($$v) {
          _vm.$set(batch.filter, "searchPaymentDateMonth", $$v)
        },
        expression: "batch.filter.searchPaymentDateMonth"
      }
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.cancelMonth(batch, 'paymentDate')
        }
      }
    }, [_vm._v("\n                              Cancel\n                          ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.searchMonthOk(batch, 'paymentDate')
        }
      }
    }, [_vm._v("\n                              OK\n                          ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mx-2"
    }, [_c('v-btn', {
      staticClass: "mt-3",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.resetFilter(batch)
        }
      }
    }, [_vm._v("Reset")])], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      key: _vm.dataTableKey,
      staticClass: "table-small payment-consolidate-table elevation-1",
      attrs: {
        "headers": batch.headers,
        "items": batch.displayData,
        "items-per-page": 10,
        "search": batch.filter.workingSearch,
        "no-data-text": 'Empty list',
        "show-select": "",
        "single-select": false
      },
      on: {
        "toggle-select-all": _vm.selectAllPayments,
        "current-items": _vm.getFiltered
      },
      scopedSlots: _vm._u([{
        key: "item.data-table-select",
        fn: function(ref) {
          var item = ref.item;

          return [_c('v-checkbox', {
            staticClass: "custom-checkbox",
            attrs: {
              "label": "",
              "value": item,
              "color": "grey darken-2"
            },
            model: {
              value: (batch.selectedPayments),
              callback: function($$v) {
                _vm.$set(batch, "selectedPayments", $$v)
              },
              expression: "batch.selectedPayments"
            }
          })]
        }
      }, {
        key: "item.instagram",
        fn: function(ref) {
          var item = ref.item;

          return [(item.isFacebook || item.fbOwner) ? _c('a', {
            attrs: {
              "href": 'https://facebook.com/' + item.instagram,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#1877F2 !important"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : (item.isTikTok || item.tiktokOwner) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagram,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagram))]) : (item.isYoutube || item.youtubeOwner) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/@' + item.instagram,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#FF0000 !important"
            }
          }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : (_vm.isLinkedInPayment(item) || item.linkedinOwner) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + item.instagram,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#0A66C2 !important"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : (item.twitterOwner || _vm.isTwitterPayment(item)) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + item.instagram,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(item.instagram))]) : (item.isXHS || item.xhsOwner) ? _c('a', {
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
              "target": "_blank"
            }
          }, [_c('img', {
            staticClass: "payment-xhs-logo",
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" " + _vm._s(item.fullName || item.instagram))]) : _c('a', {
            attrs: {
              "href": 'https://www.instagram.com/' + item.instagram,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#E1306C !important"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagram))], 1), _vm._v(" "), (item.platformHandlesObj && item.platformHandlesObj.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.platformHandlesObj), function(obj, i) {
            return _c('v-list-item', {
              key: i
            }, [_c('v-list-item-title', [(obj.type === 'xhs') ? _c('a', [_c('img', {
              staticClass: "payment-xhs-logo",
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.type === 'facebook') ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#1877F2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.type === 'tiktok') ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.type === 'youtube') ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#FF0000 !important"
              }
            }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.type === 'linkedin') ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#0A66C2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.type === 'twitter' || obj.type === 'x') ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "",
                "aria-hidden": "true"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#E1306C !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (item.imported) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              "title": "Imported"
            }
          }, [_vm._v("mdi-newspaper-plus")]) : _vm._e()]
        }
      }, {
        key: "item.liveDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', {
            staticStyle: {
              "min-width": "70px"
            }
          }, [_vm._v(_vm._s(item.liveDate))])]
        }
      }, {
        key: "item.dueDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.overdue) ? _c('div', [_c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.dueDate) + "\n                    ")])], 1) : (item.early) ? _c('div', [_c('v-chip', {
            attrs: {
              "small": "",
              "color": "yellow",
              "text-color": "black"
            }
          }, [_vm._v("\n                    " + _vm._s(item.dueDate) + "\n                    ")])], 1) : _c('div', {
            staticStyle: {
              "min-width": "70px"
            }
          }, [_vm._v(_vm._s(item.dueDate))])]
        }
      }, {
        key: "item.swiftCode",
        fn: function(ref) {
          var item = ref.item;

          return [(item.swiftCodeEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'swiftCode', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.swiftCode))])]) : _c('div', [_c('v-text-field', {
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            nativeOn: {
              "keyup": function($event) {
                return _vm.changeSwiftCode(item)
              }
            },
            model: {
              value: (item.swiftCode),
              callback: function($$v) {
                _vm.$set(item, "swiftCode", $$v)
              },
              expression: "item.swiftCode"
            }
          })], 1)]
        }
      }, {
        key: "item.bankAccount",
        fn: function(ref) {
          var item = ref.item;

          return [(item.bankAccountEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'bankAccount', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.bankAccount))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.bankAccount),
              callback: function($$v) {
                _vm.$set(item, "bankAccount", $$v)
              },
              expression: "item.bankAccount"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.username",
        fn: function(ref) {
          var item = ref.item;

          return [(item.usernameEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'username', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.username))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.username),
              callback: function($$v) {
                _vm.$set(item, "username", $$v)
              },
              expression: "item.username"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.country",
        fn: function(ref) {
          var item = ref.item;

          return [(item.countryEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'country', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.country))])]) : _c('div', {
            staticClass: "mt-3"
          }, [_c('v-select', {
            attrs: {
              "label": "",
              "items": _vm.countries,
              "item-text": "name",
              "item-value": "name",
              "dense": "",
              "outlined": ""
            },
            on: {
              "change": _vm.changeCountry
            },
            model: {
              value: (item.country),
              callback: function($$v) {
                _vm.$set(item, "country", $$v)
              },
              expression: "item.country"
            }
          })], 1)]
        }
      }, {
        key: "item.bankName",
        fn: function(ref) {
          var item = ref.item;

          return [(item.bankNameEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'bankName', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(typeof item.bankName === 'object' ? item.bankName.bank : item.bankName))])]) : _c('div', {
            staticClass: "mt-3"
          }, [_c('v-combobox', {
            attrs: {
              "items": _vm.bankNames,
              "label": "Bank Name (select your bank)",
              "item-text": "bank",
              "item-value": "bank",
              "search-input": _vm.newBankName,
              "attach": "",
              "dense": "",
              "outlined": ""
            },
            on: {
              "update:searchInput": function($event) {
                _vm.newBankName = $event
              },
              "update:search-input": function($event) {
                _vm.newBankName = $event
              },
              "change": function($event) {
                return _vm.changeBankName(item)
              }
            },
            scopedSlots: _vm._u([{
              key: "no-data",
              fn: function() {
                return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
                  staticClass: "subheading pr-2"
                }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
              },
              proxy: true
            }], null, true),
            model: {
              value: (item.bankName),
              callback: function($$v) {
                _vm.$set(item, "bankName", $$v)
              },
              expression: "item.bankName"
            }
          })], 1)]
        }
      }, {
        key: "item.email",
        fn: function(ref) {
          var item = ref.item;

          return [(item.emailEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'email', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.email))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.email),
              callback: function($$v) {
                _vm.$set(item, "email", $$v)
              },
              expression: "item.email"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.amount",
        fn: function(ref) {
          var item = ref.item;

          return [(item.amountLocked) ? _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v("-")])]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [(!item.GSTPercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                                " + _vm._s(_vm.utils.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                              ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.GSTPercent) ? _c('span', {
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": _vm.displayGSTText(item)
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                                " + _vm._s(_vm.utils.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                              ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.specialPayment) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              "title": "Special Payment Terms"
            }
          }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e(), _vm._v(" "), (item.GSTPercent) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "GST enabled"
            }
          }, [_vm._v("mdi-alert-circle")]) : _vm._e()], 1), _vm._v(" "), (batch.status === _vm.paymentStatus.PAID && item.currency !== 'SGD') ? _c('v-btn', {
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openActualAmountDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), (!item.actualAmount) ? _c('span', [_vm._v("Actual Amount")]) : _vm._e(), _vm._v(" "), (item.actualAmount) ? _c('span', [_vm._v("S$ " + _vm._s(_vm._f("thousandSeprator")(item.actualAmount)))]) : _vm._e()], 1) : _vm._e()], 1)])]
        }
      }, {
        key: "item.PVNumber",
        fn: function(ref) {
          var item = ref.item;

          return [(item.PVNumberEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'PVNumber', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.PVNumber))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.PVNumber),
              callback: function($$v) {
                _vm.$set(item, "PVNumber", $$v)
              },
              expression: "item.PVNumber"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.paymentStatus",
        fn: function(ref) {
          var item = ref.item;

          return [(item.paymentStatusEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'paymentStatus', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "50px"
            }
          }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.paymentStatus)))])]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "50px"
            }
          }, [_c('v-select', {
            staticClass: "input-field pt-3",
            attrs: {
              "items": _vm.filterPaymentStatusOptions(item),
              "item-value": "status",
              "item-text": "display",
              "label": "Payment Status",
              "dense": "",
              "outlined": ""
            },
            on: {
              "change": function($event) {
                return _vm.changePaymentStatus(item)
              }
            },
            model: {
              value: (item.paymentStatus),
              callback: function($$v) {
                _vm.$set(item, "paymentStatus", $$v)
              },
              expression: "item.paymentStatus"
            }
          })], 1)])]
        }
      }, {
        key: "item.paymentDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.paymentDateEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'paymentDate', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.paymentDate))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.paymentDate),
              callback: function($$v) {
                _vm.$set(item, "paymentDate", $$v)
              },
              expression: "item.paymentDate"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.paymentSubmissionDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', {
            staticClass: "item-edit"
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.paymentSubmissionDate))])])]
        }
      }, {
        key: "item.bankReference",
        fn: function(ref) {
          var item = ref.item;

          return [(item.bankReferenceEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'bankReference', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.bankReference))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.bankReference),
              callback: function($$v) {
                _vm.$set(item, "bankReference", $$v)
              },
              expression: "item.bankReference"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.action",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', {
            staticClass: "pt-2 pb-2 px-2"
          }, [_c('div', {
            staticClass: "pt-1"
          }, [_c('v-btn', {
            staticClass: "btn-payment-action",
            attrs: {
              "to": '/campaign-report-internal?id=' + item.campaignID,
              "target": "_blank",
              "color": "info",
              "small": ""
            }
          }, [_c('i', {
            staticClass: "fas fa-eye"
          }), _vm._v(" Campaign Report\n                      ")])], 1), _vm._v(" "), _c('div', {
            staticClass: "pt-1"
          }, [_c('v-btn', {
            staticClass: "btn-payment-action",
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.openPaymentInvoiceModal(item)
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-upload"
          }), _vm._v(" Manage Invoices\n                      ")])], 1), _vm._v(" "), (item.paymentStatus !== _vm.paymentStatus.PAID) ? _c('div', {
            staticClass: "pt-1"
          }, [_c('v-badge', {
            attrs: {
              "value": _vm.getNoteUnreadCount(item),
              "content": _vm.getNoteUnreadCount(item),
              "color": "green",
              "overlap": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openReportNotesDialog(item)
              }
            }
          }, [_c('v-btn', {
            staticClass: "btn-payment-action",
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openReportNotesDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Edit Note\n                        ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "pt-1"
          }, [(item.batchNo === 'imported') ? _c('v-btn', {
            staticClass: "btn-payment-action",
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteReport(item.id, item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("mdi-delete")]), _vm._v(" Delete\n                      ")], 1) : _vm._e()], 1)])]
        }
      }], null, true),
      model: {
        value: (batch.selectedPayments),
        callback: function($$v) {
          _vm.$set(batch, "selectedPayments", $$v)
        },
        expression: "batch.selectedPayments"
      }
    }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
      slot: "body.append"
    }, [_c('tr', [_c('th', {
      staticClass: "subtitle-2",
      attrs: {
        "colspan": "9"
      }
    }, [_vm._v("Total Amount:")]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "12"
      }
    }, [_c('v-chip', {
      attrs: {
        "small": "",
        "color": "primary",
        "text-color": "white"
      }
    }, [_c('v-icon', {
      staticClass: "mr-0",
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm.fixTwoDec(batch.totalAmount)) + "\n                      ")], 1)], 1)])])], 2)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('update-payment-info-modal', {
    attrs: {
      "payments": _vm.selectedPayments,
      "selectedPaymentStatus": _vm.selectedPaymentStatus
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.paymentInfoDialog),
      callback: function($$v) {
        _vm.paymentInfoDialog = $$v
      },
      expression: "paymentInfoDialog"
    }
  }), _vm._v(" "), _c('partial-amount-modal', {
    attrs: {
      "report": _vm.selectedReport
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.partialAmountDialog),
      callback: function($$v) {
        _vm.partialAmountDialog = $$v
      },
      expression: "partialAmountDialog"
    }
  }), _vm._v(" "), _c('actual-amount-modal', {
    attrs: {
      "report": _vm.selectedReport
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.actualAmountDialog),
      callback: function($$v) {
        _vm.actualAmountDialog = $$v
      },
      expression: "actualAmountDialog"
    }
  }), _vm._v(" "), _c('report-notes-modal', {
    attrs: {
      "value": _vm.reportNotesDialog,
      "data": _vm.reportNotesData
    },
    on: {
      "savedNotes": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.reportNotesDialog),
      callback: function($$v) {
        _vm.reportNotesDialog = $$v
      },
      expression: "reportNotesDialog"
    }
  }), _vm._v(" "), _c('create-payment-consolidate-modal', {
    attrs: {
      "value": _vm.createPaymentConsolidateDialog,
      "reports": _vm.consolidateReports,
      "editData": _vm.editInvoice,
      "reportUpdate": _vm.reportUpdate
    },
    on: {
      "created": _vm.refreshPayCons
    },
    model: {
      value: (_vm.createPaymentConsolidateDialog),
      callback: function($$v) {
        _vm.createPaymentConsolidateDialog = $$v
      },
      expression: "createPaymentConsolidateDialog"
    }
  }), _vm._v(" "), _c('upload-invoice-modal', {
    attrs: {
      "value": _vm.invoiceDialog
    },
    on: {
      "created": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.invoiceDialog),
      callback: function($$v) {
        _vm.invoiceDialog = $$v
      },
      expression: "invoiceDialog"
    }
  }), _vm._v(" "), _c('uploaded-invoice-list-modal', {
    attrs: {
      "value": _vm.invoiceViewDialog
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport,
      "openEdit": _vm.openCreatePaymentConsolidateModal
    },
    model: {
      value: (_vm.invoiceViewDialog),
      callback: function($$v) {
        _vm.invoiceViewDialog = $$v
      },
      expression: "invoiceViewDialog"
    }
  }), _vm._v(" "), _c('payment-invoice-modal', {
    attrs: {
      "value": _vm.paymentInvoiceDialog,
      "payment": _vm.selectedInvoicePayment
    },
    on: {
      "updated": _vm.refreshPayCons
    },
    model: {
      value: (_vm.paymentInvoiceDialog),
      callback: function($$v) {
        _vm.paymentInvoiceDialog = $$v
      },
      expression: "paymentInvoiceDialog"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("Change Campaign Settings")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), (_vm.campaignData) ? _c('v-card-text', {
    staticClass: "body-2 ims-modal-body campaign-settings-body"
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "label": "Campaign",
      "disabled": ""
    },
    model: {
      value: (_vm.campaignData.name),
      callback: function($$v) {
        _vm.$set(_vm.campaignData, "name", $$v)
      },
      expression: "campaignData.name"
    }
  }), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#tab-brief"
    }
  }, [_vm._v("Campaign Brief")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-report"
    }
  }, [_vm._v("Report")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-permissions"
    }
  }, [_vm._v("Permissions")])], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "tab-brief"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-switch', {
    attrs: {
      "label": "Show Budget To Client"
    },
    model: {
      value: (_vm.submittingData.settings.showBudgetToClient),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "showBudgetToClient", $$v)
      },
      expression: "submittingData.settings.showBudgetToClient"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Enable Video Brief"
    },
    model: {
      value: (_vm.submittingData.settings.enableVideoBrief),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableVideoBrief", $$v)
      },
      expression: "submittingData.settings.enableVideoBrief"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Enable Event Brief"
    },
    model: {
      value: (_vm.submittingData.settings.enableEventBrief),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableEventBrief", $$v)
      },
      expression: "submittingData.settings.enableEventBrief"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Send Weekly Report"
    },
    model: {
      value: (_vm.submittingData.settings.sendWeeklyReport),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "sendWeeklyReport", $$v)
      },
      expression: "submittingData.settings.sendWeeklyReport"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Auto Update Report"
    },
    model: {
      value: (_vm.submittingData.settings.autoUpdate),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "autoUpdate", $$v)
      },
      expression: "submittingData.settings.autoUpdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-report"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Post Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enablePostAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enablePostAnalysis", $$v)
      },
      expression: "submittingData.settings.enablePostAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openPostAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 2848695215)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable LinkedIn Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableLinkedInAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableLinkedInAnalysis", $$v)
      },
      expression: "submittingData.settings.enableLinkedInAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openLinkedInAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 2542830641)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable X (Twitter) Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableTwitterAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableTwitterAnalysis", $$v)
      },
      expression: "submittingData.settings.enableTwitterAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "icon": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.openTwitterAnalysisColSettingsModal
    }
  }, [_c('i', {
    staticClass: "fas fa-cog fa-lg",
    attrs: {
      "title": "Settings"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Story Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableStoryAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableStoryAnalysis", $$v)
      },
      expression: "submittingData.settings.enableStoryAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openStoryAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4291397140)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Reel Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableReelAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableReelAnalysis", $$v)
      },
      expression: "submittingData.settings.enableReelAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openReelAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 3255546921)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Tiktok Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableTikTokAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableTikTokAnalysis", $$v)
      },
      expression: "submittingData.settings.enableTikTokAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openTikTokAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 2261509425)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Youtube Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableYoutubeAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableYoutubeAnalysis", $$v)
      },
      expression: "submittingData.settings.enableYoutubeAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openYoutubeAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 3144399858)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Facebook Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableFbAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableFbAnalysis", $$v)
      },
      expression: "submittingData.settings.enableFbAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openFbAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4213888595)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable XHS Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableXHSAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableXHSAnalysis", $$v)
      },
      expression: "submittingData.settings.enableXHSAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openXHSAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 107774100)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0 pa-0 mb-3 d-flex align-center justify-space-between"
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-0",
    attrs: {
      "label": "Enable Lemon8 Analysis",
      "hide-details": ""
    },
    model: {
      value: (_vm.submittingData.settings.enableLemonAnalysis),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableLemonAnalysis", $$v)
      },
      expression: "submittingData.settings.enableLemonAnalysis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-1",
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openLemonAnalysisColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 226705938)
  })], 1)], 1), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Enable Overall Section"
    },
    model: {
      value: (_vm.submittingData.settings.enableOverallSection),
      callback: function($$v) {
        _vm.$set(_vm.submittingData.settings, "enableOverallSection", $$v)
      },
      expression: "submittingData.settings.enableOverallSection"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "tab-permissions"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    staticClass: "ims-btn-third",
    on: {
      "click": function($event) {
        return _vm.startAssignCS()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-account-switch")]), _vm._v("\n                    Manage Permissions\n                  ")], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "12",
      "md": "7"
    }
  }, [_c('v-btn', {
    staticClass: "btn__p100",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeCampaignStatus()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left-right")]), _vm._v(" "), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v("Change Campaign Status")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.copyReportLink()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy HTML Report Link")])], 1)]
      }
    }], null, false, 4048819226),
    model: {
      value: (_vm.reportLinkCopied),
      callback: function($$v) {
        _vm.reportLinkCopied = $$v
      },
      expression: "reportLinkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.copyAIReportLink()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy AI Report Link")])], 1)]
      }
    }], null, false, 238529799),
    model: {
      value: (_vm.aiReportLinkCopied),
      callback: function($$v) {
        _vm.aiReportLinkCopied = $$v
      },
      expression: "aiReportLinkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-reportlink"
    },
    domProps: {
      "value": _vm.reportLink
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-ai-reportlink"
    },
    domProps: {
      "value": _vm.aiReportLink
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "no-gutters"
  }, [_c('v-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-btn', {
    class: {
      'btn-change-pass btn__p100': _vm.isCampaignPasscode,
      'btn-change-pass rounded btn__p100': !_vm.isCampaignPasscode,
    },
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.startReportPasscode()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-lock")]), _vm._v("\n                        Change Passcode\n                      ")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [(_vm.isCampaignPasscode) ? _c('v-tooltip', {
    attrs: {
      "top": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "btn-copy-pass btn__p100",
          attrs: {
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.copyReportPasscode()
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Passcode")])], 1)]
      }
    }], null, false, 434988839),
    model: {
      value: (_vm.passcodeCopied),
      callback: function($$v) {
        _vm.passcodeCopied = $$v
      },
      expression: "passcodeCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-passcode"
    },
    domProps: {
      "value": _vm.campaign.passcode
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isCopyFeedback) ? _c('FeedbackAccessPanel', {
    attrs: {
      "campaign-id": String(_vm.campaignData.id)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "12",
      "md": "7"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "btn__p100",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.copyBrandSheetLink()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Brand Fact Sheet Link")])], 1)]
      }
    }], null, false, 1828213774),
    model: {
      value: (_vm.brandLinkCopied),
      callback: function($$v) {
        _vm.brandLinkCopied = $$v
      },
      expression: "brandLinkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm": "12",
      "md": "5"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-brand-link"
    },
    domProps: {
      "value": _vm.brandSheetLink
    }
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-btn', {
    attrs: {
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('assign-cs-to-campaign-modal', {
    attrs: {
      "campaign": _vm.campaignDataForCsAssign
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.assignCsToCampaignDialog),
      callback: function($$v) {
        _vm.assignCsToCampaignDialog = $$v
      },
      expression: "assignCsToCampaignDialog"
    }
  }), _vm._v(" "), _c('report-passcode-modal', {
    attrs: {
      "campaign": _vm.campaignData
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.reportPasscodeDialog),
      callback: function($$v) {
        _vm.reportPasscodeDialog = $$v
      },
      expression: "reportPasscodeDialog"
    }
  }), _vm._v(" "), _c('change-status-modal', {
    attrs: {
      "campaign": _vm.campaignDataForStatusChange
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.changeCampaignStatusDialog),
      callback: function($$v) {
        _vm.changeCampaignStatusDialog = $$v
      },
      expression: "changeCampaignStatusDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Post Analysis Columns",
      "items": _vm.postAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatePostAnalysisStatus
    },
    model: {
      value: (_vm.postAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.postAnalysisColSettingsDialog = $$v
      },
      expression: "postAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Story Analysis Columns",
      "items": _vm.storyAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateStoryAnalysisStatus
    },
    model: {
      value: (_vm.storyAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.storyAnalysisColSettingsDialog = $$v
      },
      expression: "storyAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Reel Analysis Columns",
      "items": _vm.reelAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateReelAnalysisStatus
    },
    model: {
      value: (_vm.reelAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.reelAnalysisColSettingsDialog = $$v
      },
      expression: "reelAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Tiktok Analysis Columns",
      "items": _vm.tiktokAnalysisTableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateTikTokAnalysisStatus
    },
    model: {
      value: (_vm.tiktokAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.tiktokAnalysisColSettingsDialog = $$v
      },
      expression: "tiktokAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Youtube Analysis Columns",
      "items": _vm.youtubeAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateYoutubeAnalysisStatus
    },
    model: {
      value: (_vm.youtubeAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.youtubeAnalysisColSettingsDialog = $$v
      },
      expression: "youtubeAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Facebook Analysis Columns",
      "items": _vm.fbAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateFbAnalysisStatus
    },
    model: {
      value: (_vm.fbAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.fbAnalysisColSettingsDialog = $$v
      },
      expression: "fbAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "LinkedIn Analysis Columns",
      "items": _vm.linkedInAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateLinkedInAnalysisStatus
    },
    model: {
      value: (_vm.linkedInAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.linkedInAnalysisColSettingsDialog = $$v
      },
      expression: "linkedInAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "X (Twitter) Analysis Columns",
      "items": _vm.twitterAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateTwitterAnalysisStatus
    },
    model: {
      value: (_vm.twitterAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.twitterAnalysisColSettingsDialog = $$v
      },
      expression: "twitterAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "XHS Analysis Columns",
      "items": _vm.xhsAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateXHSAnalysisStatus
    },
    model: {
      value: (_vm.xhsAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.xhsAnalysisColSettingsDialog = $$v
      },
      expression: "xhsAnalysisColSettingsDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Lemon8 Analysis Columns",
      "items": _vm.lemonAnalysisTableColsItems
    },
    on: {
      "updated": _vm.updateLemonAnalysisStatus
    },
    model: {
      value: (_vm.lemonAnalysisColSettingsDialog),
      callback: function($$v) {
        _vm.lemonAnalysisColSettingsDialog = $$v
      },
      expression: "lemonAnalysisColSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "body-2",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', [_c('label', [_vm._v("Please provide an overview of this campaign brief, include pointers to note for your stakeholders to support in getting the brief approved, ie past conversations with client")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": "",
      "error-messages": _vm.$v.updateData.remarks.$error && "This field is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.remarks.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.remarks.$touch()
      }
    },
    model: {
      value: (_vm.updateData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "remarks", $$v)
      },
      expression: "updateData.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "error-messages": _vm.$v.updateData.deadline.$error && "Deadline is required.",
            "append-icon": "event",
            "outlined": "",
            "readonly": ""
          },
          on: {
            "input": function($event) {
              return _vm.$v.updateData.deadline.$touch()
            },
            "blur": function($event) {
              return _vm.$v.updateData.deadline.$touch()
            }
          },
          model: {
            value: (_vm.updateData.deadline),
            callback: function($$v) {
              _vm.$set(_vm.updateData, "deadline", $$v)
            },
            expression: "updateData.deadline"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.deadlineCal),
      callback: function($$v) {
        _vm.deadlineCal = $$v
      },
      expression: "deadlineCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.deadlineCal = false
      }
    },
    model: {
      value: (_vm.updateData.deadline),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "deadline", $$v)
      },
      expression: "updateData.deadline"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Release to CC")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptions,
      "auto-update": _vm.autoUpdate
    }
  }, [_vm._l((_vm.images), function(img, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "slide-img",
      attrs: {
        "src": _vm.constructImageURL(img)
      }
    }), _vm._v(" "), (_vm.isShowDelete) ? _c('span', {
      staticClass: "del-image",
      on: {
        "click": function($event) {
          return _vm.$emit('delete', index)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "container container--fluid"
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content xs12 md7",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('iframe', {
    staticClass: "profile-iframe",
    attrs: {
      "src": _vm.formUrl,
      "width": "100%",
      "height": "100%",
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0",
      "title": "Travel"
    }
  })])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "close-on-content-click": false,
      "max-width": "360"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "editor-format-info__button",
          attrs: {
            "icon": "",
            "small": "",
            "color": "secondary",
            "aria-label": "Show editor format",
            "title": "Show editor format"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-information-outline")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "editor-format-info"
  }, [_c('v-card-title', {
    staticClass: "editor-format-info__title"
  }, [_vm._v("\n      Expected format\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "editor-format-info__content"
  }, [_vm._v("\n      " + _vm._s(_vm.format) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.contentScripts), function(script, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "md6": "",
        "sm12": "",
        "lg4": ""
      }
    }, [_c('v-card', {
      staticStyle: {
        "min-height": "140px"
      },
      attrs: {
        "color": "#363636",
        "dark": ""
      }
    }, [_c('v-card-title', {
      staticStyle: {
        "font-size": "23px"
      }
    }, [_vm._v(_vm._s(script.campaignName))]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-5"
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('v-btn', {
      attrs: {
        "to": '/influencers/content-storyboard/' + script.pairingID,
        "target": "_blank",
        "color": "warning",
        "right": ""
      }
    }, [_vm._v("Edit Content Storyboard Flow")])], 1)])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legacy-app",
    attrs: {
      "id": "app"
    }
  }, [_c('legacy-sunset-banner'), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.createModalDialog = true
      }
    }
  }, [_vm._v("Create new")]) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Creator Statistics Report\n          ")], 1)]
      }
    }], null, false, 2965343245)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('details', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('details', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('details', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Cost & Period Report\n          ")], 1)]
      }
    }], null, false, 3859430940)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('all', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('all', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('all', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Creator Payout Report\n          ")], 1)]
      }
    }], null, false, 1434504238)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('pairings', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('pairings', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('pairings', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Campaign Performance Report\n          ")], 1)]
      }
    }], null, false, 435468050)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('performance', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('performance', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('performance', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })]), _vm._v(" "), (_vm.buttonShow('create')) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset Filters")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [(_vm.isNotClientRole) ? _c('v-row', {
    staticClass: "filter-area"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignTypeDisplayFilter,
      "item-value": "value",
      "item-text": "text",
      "label": "Type",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.campaignType),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "campaignType", $$v)
      },
      expression: "selectedFilter.campaignType"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignVerticals,
      "item-value": "id",
      "item-text": "name",
      "label": "Campaign Verticals",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.vertical),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "vertical", $$v)
      },
      expression: "selectedFilter.vertical"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "item-value": "code",
      "item-text": "name",
      "label": "Target Location",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.targetLocation),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "targetLocation", $$v)
      },
      expression: "selectedFilter.targetLocation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CO,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CO),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CO", $$v)
      },
      expression: "selectedFilter.CO"
    }
  })], 1), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignStageDisplay,
      "label": "Stage",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.stage),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "stage", $$v)
      },
      expression: "selectedFilter.stage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.verifiedFilters,
      "label": "Verified Payouts",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.verified),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "verified", $$v)
      },
      expression: "selectedFilter.verified"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-row', [(_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "startMonthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedStartMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedStartMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedStartMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Start Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.selectedFilter.searchStartMonth),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "searchStartMonth", $$v)
            },
            expression: "selectedFilter.searchStartMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 625897265),
    model: {
      value: (_vm.startMonthPicker),
      callback: function($$v) {
        _vm.startMonthPicker = $$v
      },
      expression: "startMonthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.searchStartMonth),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "searchStartMonth", $$v)
      },
      expression: "selectedFilter.searchStartMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.startMonthPicker = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchStartMonthOk
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "endMonthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedEndMonth,
      "transition": "scale-transition",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedEndMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedEndMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "End Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.selectedFilter.searchLastMonth),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "searchLastMonth", $$v)
            },
            expression: "selectedFilter.searchLastMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 3717502516),
    model: {
      value: (_vm.endMonthPicker),
      callback: function($$v) {
        _vm.endMonthPicker = $$v
      },
      expression: "endMonthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.searchLastMonth),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "searchLastMonth", $$v)
      },
      expression: "selectedFilter.searchLastMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.endMonthPicker = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchEndMonthOk
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-checkbox', {
    staticClass: "filter-checkbox mt-1",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "label": "HTML Reports",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.htmlReport),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "htmlReport", $$v)
      },
      expression: "selectedFilter.htmlReport"
    }
  })], 1), _vm._v(" "), (!_vm.isArchive) ? _c('v-col', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-checkbox', {
    staticClass: "filter-checkbox mt-1",
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "label": "Load Archive",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.selectedFilter.archive),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "archive", $$v)
      },
      expression: "selectedFilter.archive"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-row', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "justify": "end"
    }
  }, [(!_vm.isArchive) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [_c('v-toolbar', {
    staticClass: "bulk-action float-left transparent",
    attrs: {
      "flat": ""
    }
  }, [(_vm.selectedCampaigns.length > 0) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "secondary"
          }
        }, on), [_vm._v("Bulk Action")])]
      }
    }], null, false, 1812722738)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.tableActions), function(menuItem, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.performSelected(menuItem.action)
        }
      }
    }, [_c('v-list-item-content', [_c('div', [_c('v-icon', [_vm._v("mdi-" + _vm._s(menuItem.icon))]), _vm._v(" " + _vm._s(menuItem.name) + "\n                      ")], 1)])], 1)
  }), 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isArchive) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [(_vm.selectedCampaigns.length > 0) ? _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": _vm.restoreArchive
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-restore")]), _vm._v(" Restore\n            ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isNotClientRole) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.isNotClientRole) ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-25px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-pressed": String(_vm.showActionsColumn),
      "title": _vm.showActionsColumn ? 'Hide Actions column' : 'Show Actions column',
      "aria-label": _vm.showActionsColumn ? 'Hide Actions column' : 'Show Actions column'
    },
    on: {
      "click": function($event) {
        _vm.showActionsColumn = !_vm.showActionsColumn
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showActionsColumn ? 'mdi-eye-off-outline' : 'mdi-eye-outline'))])], 1)], 1), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole) ? _c('v-data-table', {
    staticClass: "ims-sticky-actions-table table-small elevation-1",
    class: {
      'actions-column-visible': _vm.showActionsColumn
    },
    attrs: {
      "headers": _vm.computedAllCampaignHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "show-select": "",
      "single-select": false,
      "loading": _vm.loading
    },
    on: {
      "toggle-select-all": _vm.selectAllCampaigns
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), (item.archive) ? _c('v-chip', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("\n              Archived\n            ")]) : _c('div', [(item.lockedCOGS) ? _c('div', [_c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-lock")]), _vm._v(" Locked COGS\n                ")], 1)], 1) : _vm._e()])], 1)]
      }
    }, {
      key: "item.campaignType",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.campaignType))])]
      }
    }, {
      key: "item.countryDisplay",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.countryDisplay))])]
      }
    }, {
      key: "item.vertical",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((item.vertical), function(i, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-1",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n              " + _vm._s(i.name) + "\n            ")])
        }), 1)]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            $" + _vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n            "), (_vm.isNotClientRole && item.markupCOGS) ? _c('v-chip', {
          attrs: {
            "color": "warning",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n              Markup COGS\n            ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.target",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.target) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.target)))]) : _vm._e()])]
      }
    }, {
      key: "item.cogs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogs) ? _c('span', [_vm._v("\n              $" + _vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n              "), (item.cogs && item.target && item.cogs > item.target) ? _c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n                Burst COGS\n              ")]) : _vm._e()], 1) : _vm._e()])]
      }
    }, {
      key: "item.cogsPercentage",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogsPercentage) ? _c('span', [_vm._v(_vm._s(item.cogsPercentage) + "%")]) : _vm._e()])]
      }
    }, {
      key: "item.campaignPeriod",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.campaignPeriod || ''))])]
      }
    }, {
      key: "item.startMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.startMonth ? _vm.formatMonth(item.startMonth) : ''))])]
      }
    }, {
      key: "item.endMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.endMonth ? _vm.formatMonth(item.endMonth) : ''))])]
      }
    }, {
      key: "item.firstPostDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.firstPostDate || ''))])]
      }
    }, {
      key: "item.lastPostDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.lastPostDate || ''))])]
      }
    }, {
      key: "item.payoutStatus",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_c('div', [(item.payoutStatus && item.payoutStatus === _vm.payoutStatus.CONFIRMED) ? _c('v-chip', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "green",
            "outlined": "",
            "small": "",
            "target": "_blank",
            "to": '/finance/payment-consolidation/status?id=' + item.id
          }
        }, [_vm._v("\n                  " + _vm._s(item.payoutStatusDisplay) + "\n              ")]) : _c('v-chip', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "outlined": "",
            "small": "",
            "target": "_blank",
            "to": '/finance/payment-consolidation/status?id=' + item.id
          }
        }, [_vm._v("\n                  " + _vm._s(item.payoutStatusDisplay) + "\n                ")])], 1)])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "230px"
          }
        }, [(_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "to": '/campaign-report-internal?id=' + item.id,
            "target": "_blank",
            "color": "secondary",
            "title": "View Campaign Report Internal",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "aria-label": "View Campaign Report Internal"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action ims-btn-third",
          attrs: {
            "to": '/reports/campaign/summary?id=' + item.id,
            "target": "_blank",
            "aria-label": "View Campaign HTML Report",
            "title": "View Campaign HTML Report",
            "data-toggle": "tooltip",
            "data-placement": "top"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-web")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Change Setting",
            "aria-label": "Change Setting"
          },
          on: {
            "click": function($event) {
              return _vm.changeSettings(item)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders-h"
        })]), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Campaign",
            "color": "error",
            "aria-label": "Delete Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Edit Campaign",
            "aria-label": "Edit Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign",
            "aria-label": "View Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 0 || item.activated == undefined),
            expression: "item.activated == 0 || item.activated == undefined"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to Client",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showAMCCInputsDialog(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 1),
            expression: "item.activated == 1"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Deactivate Campaign",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.activateCampaign(item.id, _vm.campaignActivationStatusConfig.DEACTIVATED)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work_off")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.viewInfluencerPairingModal(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        }, [_vm._v("mdi-account-convert")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.startEliminate(item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-users-cog secondary--text",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        })]), _vm._v(" "), (_vm.buttonShowBrandSheet(item)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Brand Fact Sheet",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.openBrandSheetModalDialog(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-file-document")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "modal",
            "data-target": _vm.viewPairingBriefModalIdDisplay,
            "color": "info",
            "title": "View Pairing Brief",
            "aria-label": "View Pairing Brief"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Brief"
          }
        }, [_vm._v("pageview")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Pairing Brief",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.approveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.showConfirmPayout) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.getPairedInfluencers(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("people")]), _vm._v(" "), (_vm.payoutSubmittedPairings.length > 0 && _vm.getSubmittedCount(item) > 0) ? _c('v-badge', {
          attrs: {
            "color": "error",
            "content": _vm.getSubmittedCount(item)
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showConfirmPayout) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "to": '/influencers/invoices-brief-confirmation?id=' + item.id,
            "target": "_blank",
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("people")]), _vm._v(" "), (_vm.payoutSubmittedPairings.length > 0 && _vm.getSubmittedCount(item) > 0) ? _c('v-badge', {
          attrs: {
            "color": "error",
            "content": _vm.getSubmittedCount(item)
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedCampaigns),
      callback: function($$v) {
        _vm.selectedCampaigns = $$v
      },
      expression: "selectedCampaigns"
    }
  }) : _c('v-data-table', {
    key: _vm.campaignDataTableKey,
    staticClass: "ims-sticky-actions-table elevation-1",
    class: {
      'actions-column-visible': _vm.showActionsColumn
    },
    attrs: {
      "headers": _vm.computedCampaignHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "show-select": _vm.isNotClientRole,
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllCampaigns
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), (_vm.isNotClientRole && item.lockedCOGS) ? _c('div', [_c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-lock")]), _vm._v(" Locked COGS\n              ")], 1)], 1) : _vm._e()])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            $" + _vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n            "), (_vm.isNotClientRole && item.markupCOGS) ? _c('v-chip', {
          attrs: {
            "color": "warning",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n              Markup COGS\n            ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.target",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.target) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.target)))]) : _vm._e()])]
      }
    }, {
      key: "item.cogs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogs) ? _c('span', [_vm._v("\n              $" + _vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n              "), (item.cogs && item.target && item.cogs > item.target) ? _c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n                Burst COGS\n              ")]) : _vm._e()], 1) : _vm._e()])]
      }
    }, {
      key: "item.cogsPercentage",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogsPercentage) ? _c('span', [_vm._v(_vm._s(item.cogsPercentage) + "%")]) : _vm._e()])]
      }
    }, {
      key: "item.payoutStatus",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.payoutStatus ? _vm.payoutStatusDisplay[item.payoutStatus] : ''))])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center"
        }, [(_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "to": '/campaign-report-internal?id=' + item.id,
            "target": "_blank",
            "color": "secondary",
            "data-placement": "top",
            "data-toggle": "tooltip",
            "title": "View Campaign Report Internal",
            "aria-label": "View Campaign Report Internal"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi mdi-open-in-new")])], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action ims-btn-third",
          attrs: {
            "to": '/reports/campaign/summary?id=' + item.id,
            "target": "_blank",
            "title": "View Campaign HTML Report",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "aria-label": "View Campaign HTML Report"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-web")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('settings')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Change Settings",
            "aria-label": "Change Settings",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.changeSettings(item)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders-h"
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Campaign",
            "aria-label": "Delete Campaign",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('edit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Edit Campaign",
            "aria-label": "Edit Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign",
            "aria-label": "View Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('viewByClient')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true,
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign",
            "aria-label": "View Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.viewCampaignByClient(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('draftSubmit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to CC",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.approveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('releaseToAdmin')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "disabled": item.releasedToAdmin,
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to Admin",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.releaseToAdmin(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-send")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('clientApprove')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Campaign",
            "color": "success",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('activate')) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 0 || item.activated == undefined),
            expression: "item.activated == 0 || item.activated == undefined"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to Client",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showAMCCInputsDialog(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('directClient') && item.campaignType !== 'Storytell') ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Direct release to Client",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.directClient(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('activate')) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 1),
            expression: "item.activated == 1"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Deactivate Campaign",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.activateCampaign(item.id, _vm.campaignActivationStatusConfig.DEACTIVATED)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work_off")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('viewPairing')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.viewInfluencerPairingModal(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        }, [_vm._v("mdi-account-convert")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('eliminating')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true,
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.startEliminate(item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-users-cog secondary--text",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('startCampaign')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Start Campaign",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('reviewCampaign')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Push to Review",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.pushReviewCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("mdi-progress-upload")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('closeCampaign')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Close Campaign",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("power_settings_new")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShowBrandSheet(item)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Brand Fact Sheet",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.openBrandSheetModalDialog(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-file-document")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "modal",
            "data-target": _vm.editPairingBriefModalIdDisplay,
            "color": "info",
            "title": "Edit Pairing Brief",
            "aria-label": "Edit Pairing Brief"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Edit Pairing Brief",
            "color": "white",
            "small": ""
          }
        }, [_vm._v("rate_review")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "modal",
            "data-target": _vm.viewPairingBriefModalIdDisplay,
            "color": "info",
            "title": "View Pairing Brief",
            "aria-label": "View Pairing Brief"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Brief"
          }
        }, [_vm._v("pageview")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Pairing Brief",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('influencerAccept') && _vm.buttonShowPairing(item.pairingStatus)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Pairing Influencer",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.acceptInvite(item.pairingID)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('influencerAccept') && _vm.buttonShowPairing(item.pairingStatus)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Reject Pairing Influencer",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.rejectInvite(item.pairingID)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('viewInfluencers') && !_vm.buttonShowPairing(item.pairingStatus)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.getPairedInfluencers(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("people")]), _vm._v(" "), (_vm.payoutSubmittedPairings.length > 0 && _vm.getSubmittedCount(item) > 0) ? _c('v-badge', {
          attrs: {
            "color": "error",
            "content": _vm.getSubmittedCount(item)
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedCampaigns),
      callback: function($$v) {
        _vm.selectedCampaigns = $$v
      },
      expression: "selectedCampaigns"
    }
  })], 1)], 1), _vm._v(" "), _c('create-campaign-modal', {
    attrs: {
      "value": _vm.createModalDialog
    },
    on: {
      "createCampaign": _vm.createCampaign
    },
    model: {
      value: (_vm.createModalDialog),
      callback: function($$v) {
        _vm.createModalDialog = $$v
      },
      expression: "createModalDialog"
    }
  }), _vm._v(" "), _c('edit-campaign-modal', {
    attrs: {
      "value": _vm.editModalDialog,
      "campaignId": _vm.editCampaignId
    },
    on: {
      "editCampaign": _vm.editCampaign
    },
    model: {
      value: (_vm.editModalDialog),
      callback: function($$v) {
        _vm.editModalDialog = $$v
      },
      expression: "editModalDialog"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('edit-pairing-brief-modal', {
    attrs: {
      "modalId": _vm.editPairingBriefModalId,
      "campaignId": _vm.editCampaignId
    },
    on: {
      "editCampaign": _vm.editCampaign
    }
  }), _vm._v(" "), _c('view-pairing-brief-modal', {
    attrs: {
      "modalId": _vm.viewPairingBriefModalId,
      "campaignData": _vm.viewCampaignData
    }
  }), _vm._v(" "), _c('view-pairing-modal', {
    attrs: {
      "value": _vm.viewPairingModalDialog,
      "campaignData": _vm.viewPairingCampaignData,
      "client": _vm.campaignClient,
      "unlockCogs": _vm.isUnlockCogs
    },
    on: {
      "cogs-lock-changed": _vm.handleCogsLockChanged,
      "setUnlockCogs": _vm.setUnlockCogs
    },
    model: {
      value: (_vm.viewPairingModalDialog),
      callback: function($$v) {
        _vm.viewPairingModalDialog = $$v
      },
      expression: "viewPairingModalDialog"
    }
  }), _vm._v(" "), _c('influencer-elimination', {
    attrs: {
      "campaingData": _vm.campaingDataForElimination
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "modalId": _vm.viewPostModalId,
      "campaignData": _vm.viewPostCampaignData
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1250"
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Paired influencers for campaign")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.invitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.notInvitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])])], 1)]
      }
    }], null, false, 2284781340)
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Handle")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Followers")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Eng. Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Aud. Cred")]), _vm._v(" "), (_vm.isNotClientRole) ? _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Status")]) : _vm._e(), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Elimination Status")]), _vm._v(" "), (_vm.isNotClientRole) ? _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Payout Amount")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pairedInfluencers), function(item) {
          return _c('tr', {
            key: item.instagramHandle
          }, [_c('td', [(item.influencer_details.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagramHandle))]) : (item.influencer_details.platform === 'youtube') ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.followers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagement_rate) + "%")]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                " + _vm._s(item.audience_credibility) + "\n              ")], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "outlined": "",
              "x-small": ""
            }
          }, [_vm._v("\n                  " + _vm._s(_vm.pairingStatusDisplay[item.pairingStatus]) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('v-chip', _vm._g({
            staticClass: "ma-2",
            attrs: {
              "color": _vm.eliminatinStatusColor(item.eliminationStatus),
              "x-small": "",
              "text-color": "white"
            }
          }, _vm.on), [_vm._v("\n                  " + _vm._s(_vm.eliminationStatusDisplay(item.eliminationStatus)) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-check")])], 1)], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', {
            staticClass: "text-right"
          }, [_vm._v("$ " + _vm._s(item.payoutAmount))]) : _vm._e()])
        }), 0)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1250",
      "content-class": "ims-standard-dialog"
    },
    model: {
      value: (_vm.viewInfluencerAdminDialog),
      callback: function($$v) {
        _vm.viewInfluencerAdminDialog = $$v
      },
      expression: "viewInfluencerAdminDialog"
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("\n          Paired influencers for campaign:\n          "), _c('strong', [_vm._v(_vm._s(_vm.campaignCOEB.campaignName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerAdminDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.invitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.notInvitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])])], 1)]
      }
    }], null, false, 2284781340)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-select', {
    staticClass: "input-field pt-3",
    attrs: {
      "items": _vm.payoutStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "label": "Payout Status",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.pairingSearchFilter
    },
    model: {
      value: (_vm.pairedFilter.payoutStatus),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "payoutStatus", $$v)
      },
      expression: "pairedFilter.payoutStatus"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.pairedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "search", $$v)
      },
      expression: "pairedFilter.search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.pairedHeaders,
      "items": _vm.pairedFilterItems,
      "items-per-page": 10,
      "search": _vm.pairedFilter.search,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.instagramHandle,
            class: {
              'yellow lighten-4': item.payoutSubmitted
            }
          }, [_c('td', [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "tiktokHandle": item.instagramHandle,
              "instagramHandle": item.instagramHandle,
              "youtubeHandle": item.instagramHandle,
              "facebookHandle": item.instagramHandle
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.followers))])]), _vm._v(" "), _c('td', [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")])]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                      " + _vm._s(item.audience_credibility) + "\n                    ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.deliverables))]), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": _vm.payoutStatusColor(item.payoutStatus),
              "outlined": "",
              "small": ""
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.payoutStatusDisplay[item.payoutStatus || 0]) + "\n                        "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', {
            staticClass: "text-right"
          }, [_vm._v("$ " + _vm._s(item.payoutAmount))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-center paired-actions-cell"
          }, [_c('div', {
            staticClass: "paired-actions"
          }, [(_vm.buttonShow('editPayout')) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "secondary",
                    "aria-label": "Edit payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openConfirmPayoutDialog(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-pencil")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Edit payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus !== _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "primary",
                    "aria-label": "Confirm payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.updateSend(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-check")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Confirm payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus === _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "error",
                    "aria-label": "Cancel payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.cancelPayout(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-cancel")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Cancel payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonPayoutViewShow(item)) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn ims-btn-third",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "aria-label": "View payouts"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.linkPayoutInternal(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-eye")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View payouts")])]) : _vm._e()], 1)])])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerAdminDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('payout-confirm-modal', {
    attrs: {
      "value": _vm.payoutConfirmDialog,
      "data": _vm.payoutConfirmData,
      "influencer": _vm.influencer
    },
    on: {
      "confirmedPayout": _vm.setConfirmedPayout
    },
    model: {
      value: (_vm.payoutConfirmDialog),
      callback: function($$v) {
        _vm.payoutConfirmDialog = $$v
      },
      expression: "payoutConfirmDialog"
    }
  }), _vm._v(" "), _c('campaign-settings', {
    attrs: {
      "campaign": _vm.viewCampaignData
    },
    on: {
      "saved": _vm.reload
    },
    model: {
      value: (_vm.campaignSettingsDialog),
      callback: function($$v) {
        _vm.campaignSettingsDialog = $$v
      },
      expression: "campaignSettingsDialog"
    }
  }), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  }), _vm._v(" "), _c('view-brand-sheet-modal', {
    attrs: {
      "value": _vm.viewBrandSheetModalDialog,
      "brandSheetData": _vm.viewbrandSheetData
    },
    model: {
      value: (_vm.viewBrandSheetModalDialog),
      callback: function($$v) {
        _vm.viewBrandSheetModalDialog = $$v
      },
      expression: "viewBrandSheetModalDialog"
    }
  }), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.invoiceDialog,
      "influencer": _vm.influencer,
      "influencerProfile": _vm.influencerProfile,
      "selectedTab": _vm.selectedTab,
      "briefDetailContent": _vm.briefDetailsHTML,
      "close": _vm.closeModal,
      "newPairingFlow": true,
      "isDownload": _vm.invoiceDownload
    },
    on: {
      "loadInfluencer": _vm.loadInfluencerData,
      "reRenderDatTable": _vm.loadInfluencerData,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  }), _vm._v(" "), _c('change-status-modal', {
    attrs: {
      "campaign": _vm.campaignDataForStatusChange,
      "campaignIds": _vm.selectedCampaignIds
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('all-reports-passcode-modal', {
    attrs: {
      "value": _vm.allReportsPasscodeDialog,
      "reportType": _vm.downloadReportType
    },
    on: {
      "success": _vm.reportPasscodeSuccess
    },
    model: {
      value: (_vm.allReportsPasscodeDialog),
      callback: function($$v) {
        _vm.allReportsPasscodeDialog = $$v
      },
      expression: "allReportsPasscodeDialog"
    }
  }), _vm._v(" "), _c('release-to-cc-modal', {
    attrs: {
      "campaign": _vm.campaignDataForSubmitDraft
    },
    on: {
      "saved": _vm.proceedApproveCampaign
    },
    model: {
      value: (_vm.releaseToCCDialog),
      callback: function($$v) {
        _vm.releaseToCCDialog = $$v
      },
      expression: "releaseToCCDialog"
    }
  }), _vm._v(" "), _c('release-to-admin-modal', {
    attrs: {
      "campaign": _vm.campaignDataForAccept
    },
    on: {
      "saved": _vm.proceedReleaseToAdmin
    },
    model: {
      value: (_vm.releaseToAdminDialog),
      callback: function($$v) {
        _vm.releaseToAdminDialog = $$v
      },
      expression: "releaseToAdminDialog"
    }
  }), _vm._v(" "), _c('am-cc-inputs-modal', {
    attrs: {
      "campaign": _vm.campaignDataForRelease,
      "source": "release"
    },
    on: {
      "proceedBrief": _vm.showCheckListDialog
    },
    model: {
      value: (_vm.amCCInputsDialog),
      callback: function($$v) {
        _vm.amCCInputsDialog = $$v
      },
      expression: "amCCInputsDialog"
    }
  }), _vm._v(" "), _c('brief-release-checklist-modal', {
    attrs: {
      "campaign": _vm.campaignDataForRelease
    },
    on: {
      "confirmActivate": _vm.proceedActivateCampaign
    },
    model: {
      value: (_vm.briefReleaseChecklistDialog),
      callback: function($$v) {
        _vm.briefReleaseChecklistDialog = $$v
      },
      expression: "briefReleaseChecklistDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Masterlist",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('invoices-brief-view-modal', {
    attrs: {
      "campaignID": _vm.viewCampaignId,
      "value": _vm.invoicesBriefViewDialog
    },
    on: {
      "reload": _vm.reload
    },
    model: {
      value: (_vm.invoicesBriefViewDialog),
      callback: function($$v) {
        _vm.invoicesBriefViewDialog = $$v
      },
      expression: "invoicesBriefViewDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [(_vm.isValidAccount) ? _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [(_vm.showUpdateInfo) ? _c('v-alert', {
    attrs: {
      "border": "top",
      "prominent": "",
      "colored-border": "",
      "type": "warning"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "grow"
  }, [_vm._v("Please update your profile with all required fields.")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openedPanels),
      callback: function($$v) {
        _vm.openedPanels = $$v
      },
      expression: "openedPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Contact Information *")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    staticClass: "pp-section text-center",
    attrs: {
      "xs": "12",
      "sm": "12",
      "md": "2"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "120"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.activeUser.avatar,
      "alt": "User Profile Image"
    },
    on: {
      "click": _vm.changeProfilePicture
    }
  })]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "text-center mt-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    on: {
      "click": _vm.changeProfilePicture
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "15"
    }
  }, [_vm._v("mdi-pencil")]), _vm._v(" Edit")], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "10"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [(_vm.userData.reqIgHandle) ? _c('v-text-field', {
    attrs: {
      "label": "Instagram Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqIgHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqIgHandle", $$v)
      },
      expression: "userData.reqIgHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Instagram Account",
      "disabled": _vm.userData.igHandle !== ''
    },
    model: {
      value: (_vm.userData.igHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "igHandle", $$v)
      },
      expression: "userData.igHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqIgHandle) ? _c('v-icon', _vm._g({
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (!_vm.userData.igHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update Instagram")])])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Facebook Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.fbHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "fbHandle", $$v)
      },
      expression: "userData.fbHandle"
    }
  }), _vm._v(" "), (_vm.userData.fbHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "href": 'https://www.facebook.com/' + _vm.userData.fbHandle,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "x-small": "",
      "color": "warning"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("mdi-facebook")])]
      }
    }], null, false, 2648339379)
  }, [_vm._v(" "), _c('span', [_vm._v("View Facebook Profile")])])], 1) : _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update Facebook")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [(_vm.userData.reqTikTokHandle) ? _c('v-text-field', {
    attrs: {
      "label": "TikTok Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqTikTokHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqTikTokHandle", $$v)
      },
      expression: "userData.reqTikTokHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "TikTok Account",
      "disabled": _vm.userData.tiktokHandle !== ''
    },
    model: {
      value: (_vm.userData.tiktokHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "tiktokHandle", $$v)
      },
      expression: "userData.tiktokHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqTikTokHandle) ? _c('v-icon', _vm._g({
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (!_vm.userData.tiktokHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update TikTok")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [(_vm.userData.reqYoutubeHandle) ? _c('v-text-field', {
    attrs: {
      "label": "Youtube Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqYoutubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqYoutubeHandle", $$v)
      },
      expression: "userData.reqYoutubeHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Youtube Account",
      "disabled": _vm.userData.youtubeHandle !== ''
    },
    model: {
      value: (_vm.userData.youtubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "youtubeHandle", $$v)
      },
      expression: "userData.youtubeHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqYoutubeHandle) ? _c('v-icon', _vm._g({
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (!_vm.userData.youtubeHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update Youtube")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "X (Twitter) Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "twitterHandle", $$v)
      },
      expression: "userData.twitterHandle"
    }
  }), _vm._v(" "), (_vm.userData.twitterHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "href": 'https://x.com/' + _vm.userData.twitterHandle,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "x-small": "",
      "color": "warning"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('img', _vm._g({
          staticClass: "x-logo-white",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "12",
            "height": "12",
            "alt": "X (Twitter)"
          }
        }, on))]
      }
    }], null, false, 2131544379)
  }, [_vm._v(" "), _c('span', [_vm._v("View X (Twitter) Profile")])])], 1) : _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update X (Twitter)")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [(_vm.userData.reqLinkedinHandle) ? _c('v-text-field', {
    attrs: {
      "label": "LinkedIn Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.reqLinkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "reqLinkedinHandle", $$v)
      },
      expression: "userData.reqLinkedinHandle"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "LinkedIn Account",
      "disabled": ""
    },
    model: {
      value: (_vm.userData.linkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.userData, "linkedinHandle", $$v)
      },
      expression: "userData.linkedinHandle"
    }
  }), _vm._v(" "), (_vm.userData.reqLinkedinHandle) ? _c('v-icon', {
    staticStyle: {
      "height": "100%",
      "margin-top": "25px",
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-account-clock")]) : _vm._e(), _vm._v(" "), (_vm.userData.linkedinHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.userData.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "x-small": "",
      "color": "warning"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("mdi-linkedin")])]
      }
    }], null, false, 3145342333)
  }, [_vm._v(" "), _c('span', [_vm._v("View LinkedIn Profile")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.userData.linkedinHandle && !_vm.userData.reqLinkedinHandle) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "20px",
      "min-width": "10px"
    },
    attrs: {
      "x-small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openUpdatePlatformDialog()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "x-small": ""
          }
        }, on), [_vm._v("edit")])]
      }
    }], null, false, 2686221802)
  }, [_vm._v(" "), _c('span', [_vm._v("Update LinkedIn")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "First Name",
      "error-messages": _vm.firstNameErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.userData.firstName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.userData.firstName.$touch()
      }
    },
    model: {
      value: (_vm.userData.firstName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "firstName", $$v)
      },
      expression: "userData.firstName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.userData.lastName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "lastName", $$v)
      },
      expression: "userData.lastName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Email Address",
      "error-messages": _vm.emailErrors,
      "required": ""
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces,
      "blur": function($event) {
        return _vm.$v.userData.email.$touch()
      }
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Contact Number"
    },
    model: {
      value: (_vm.userData.phone),
      callback: function($$v) {
        _vm.$set(_vm.userData, "phone", $$v)
      },
      expression: "userData.phone"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Billing Information")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('table', [_c('tr', [_c('td', [_vm._v("Full Name "), _c('small', [_vm._v("(as per bank account)")])]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.fullName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "fullName", $$v)
      },
      expression: "userData.fullName"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Country")]), _vm._v(" "), _c('td', [_c('div', [_c('v-select', {
    attrs: {
      "label": "Country",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "attach": "",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "change": _vm.changeCountry
    },
    model: {
      value: (_vm.userData.country),
      callback: function($$v) {
        _vm.$set(_vm.userData, "country", $$v)
      },
      expression: "userData.country"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bank Name")]), _vm._v(" "), _c('td', [_c('div', [_c('v-combobox', {
    staticClass: "edit-field",
    attrs: {
      "items": _vm.bankNames,
      "item-text": "bank",
      "item-value": "bank",
      "search-input": _vm.newBankName,
      "attach": "",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newBankName = $event
      },
      "update:search-input": function($event) {
        _vm.newBankName = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
      },
      proxy: true
    }], null, false, 2535767177),
    model: {
      value: (_vm.userData.bankName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "bankName", $$v)
      },
      expression: "userData.bankName"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bank Account Number")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#################'),
      expression: "'#################'"
    }],
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.userData, "bankAccount", $$v)
      },
      expression: "userData.bankAccount"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Billing Email")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.billingEmail),
      callback: function($$v) {
        _vm.$set(_vm.userData, "billingEmail", $$v)
      },
      expression: "userData.billingEmail"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mailing Address")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.userData, "mailingAddress", $$v)
      },
      expression: "userData.mailingAddress"
    }
  }, _vm.on))], 1)])])])])], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("More About You")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": _vm.userGender_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.userData.gender),
      callback: function($$v) {
        _vm.$set(_vm.userData, "gender", $$v)
      },
      expression: "userData.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Your Birthday",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.userData.birthday),
            callback: function($$v) {
              _vm.$set(_vm.userData, "birthday", $$v)
            },
            expression: "userData.birthday"
          }
        }, on))]
      }
    }], null, false, 2796975143),
    model: {
      value: (_vm.bdPicker),
      callback: function($$v) {
        _vm.bdPicker = $$v
      },
      expression: "bdPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.bdPicker = false
      }
    },
    model: {
      value: (_vm.userData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.userData, "birthday", $$v)
      },
      expression: "userData.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ethnicity",
      "items": _vm.ethnicity_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.userData.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.userData, "ethnicity", $$v)
      },
      expression: "userData.ethnicity"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Occupation"
    },
    model: {
      value: (_vm.inputedRates.occupation),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "occupation", $$v)
      },
      expression: "inputedRates.occupation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_vm._v("\n                  What is your content niche/focus?\n                  "), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "max": "3",
      "column": ""
    },
    model: {
      value: (_vm.userData.keywords),
      callback: function($$v) {
        _vm.$set(_vm.userData, "keywords", $$v)
      },
      expression: "userData.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_vm._v("\n                  One liner about you (could emphasise on your niche to best represent your profile)\n                  "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.inputedRates.aboutYou),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "aboutYou", $$v)
      },
      expression: "inputedRates.aboutYou"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.inputedRates.type),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "type", $$v)
      },
      expression: "inputedRates.type"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "agency",
      "label": "Agency"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "direct",
      "label": "Direct"
    }
  })], 1), _vm._v(" "), (_vm.inputedRates.type === 'agency') ? _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Agency Name",
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.inputedRates.agencyName),
      callback: function($$v) {
        _vm.$set(_vm.inputedRates, "agencyName", $$v)
      },
      expression: "inputedRates.agencyName"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_c('p', [_vm._v("Your rates\n                  "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', {
    attrs: {
      "id": "profile-rate-card-form"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.formConfig.sections), function(section, index) {
    return _c('v-col', {
      key: index,
      class: section.class ? section.class : 'xs12 md6',
      style: (section.style || '')
    }, [_c('div', _vm._l((section.fields), function(field, index) {
      return _c('v-col', {
        key: index,
        class: field.class ? field.class : 'xs12 md6',
        style: (field.style || '')
      }, [(field.label !== '' && !field.hideInternal) ? _c('p', {
        class: ("h4 font-weight-bold mb-2 " + (field.labelClass || ''))
      }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
        staticClass: "red--text"
      }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (field.type === 'number') ? _c('div', {
        staticClass: "d-flex flex-row pl-3"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.inputedRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "inputedRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), (field.type === 'number') ? _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.inputedRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, field.name, _vm._n($$v))
          },
          expression: "inputedRates[field.name]"
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && !field.hideInternal) ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.inputedRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, field.name, $$v)
          },
          expression: "inputedRates[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
        attrs: {
          "filled": "",
          "auto-grow": "",
          "hint": field.hint || '',
          "persistent-hint": field.hint ? true : false,
          "placeholder": field.placeholder,
          "required": "",
          "hide-details": "auto"
        },
        model: {
          value: (_vm.inputedRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.inputedRates, field.name, $$v)
          },
          expression: "inputedRates[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', [_c('custom-file-upload', {
        attrs: {
          "refresh": _vm.fileUploadRefresh,
          "multiple": true
        },
        on: {
          "setMedias": _vm.updatePricingDecks
        }
      }), _vm._v(" "), (_vm.inputedRates.pricingDecks.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
        return _c('v-col', {
          key: index,
          staticClass: "d-flex child-flex",
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "2",
            "lg": "1"
          }
        }, [_c('v-hover', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var hover = ref.hover;

              return [_c('v-card', {
                staticClass: "d-flex",
                attrs: {
                  "flat": "",
                  "tile": "",
                  "elevation": hover ? 16 : 2
                }
              }, [_c('v-img', {
                staticClass: "grey lighten-2",
                attrs: {
                  "src": img.url,
                  "lazy-src": img.url,
                  "aspect-ratio": "1"
                }
              }), _vm._v(" "), _c('v-overlay', {
                attrs: {
                  "absolute": ""
                }
              }, [_c('v-btn', {
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteImage(index)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)], 1)], 1)]
            }
          }], null, true)
        })], 1)
      }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type === 'multiple') ? _c('div', [_vm._l((_vm.inputedRates[field.name]), function(multipleOne, pIndex) {
        return _c('v-list', {
          key: pIndex
        }, [_c('v-list-item', {
          staticClass: "pa-0"
        }, _vm._l((field.options), function(multipleOption, oIndex) {
          return _c('v-list-item-content', {
            key: oIndex,
            style: (multipleOption.style || '')
          }, [(multipleOption.type === 'select') ? _c('v-select', {
            staticClass: "pr-1",
            style: (multipleOption.style || ''),
            attrs: {
              "items": multipleOption.options,
              "item-value": "value",
              "item-text": "label",
              "hide-details": "",
              "label": multipleOption.label,
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "inputedRates[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'textbox') ? _c('v-text-field', {
            staticClass: "px-1",
            attrs: {
              "dense": "",
              "outlined": "",
              "hide-details": "",
              "placeholder": multipleOption.placeholder
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "inputedRates[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'number') ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticClass: "currency-select",
            attrs: {
              "items": _vm.currenyOptions,
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][((multipleOption.name) + "Currency")]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], ((multipleOption.name) + "Currency"), _vm._n($$v))
              },
              expression: "inputedRates[field.name][pIndex][`${multipleOption.name}Currency`]"
            }
          }), _vm._v(" "), _c('v-text-field', {
            class: multipleOption.class || '',
            attrs: {
              "type": "number",
              "dense": "",
              "outlined": "",
              "hide-details": "",
              "placeholder": multipleOption.name
            },
            model: {
              value: (_vm.inputedRates[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.inputedRates[field.name][pIndex], multipleOption.name, _vm._n($$v))
              },
              expression: "inputedRates[field.name][pIndex][multipleOption.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (multipleOption.type === 'delete') ? _c('v-btn', {
            attrs: {
              "color": "danger",
              "text": "",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                _vm.inputedRates[field.name].splice(pIndex, 1)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "red"
            }
          }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
        }), 1), _vm._v(" "), (_vm.inputedRates[field.name][pIndex][field.child.parentName] === 'others') ? _c('v-list', [_c('v-text-field', {
          staticClass: "px-2",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.child.placeholder
          },
          model: {
            value: (_vm.inputedRates[field.name][pIndex][field.child.name]),
            callback: function($$v) {
              _vm.$set(_vm.inputedRates[field.name][pIndex], field.child.name, $$v)
            },
            expression: "inputedRates[field.name][pIndex][field.child.name]"
          }
        })], 1) : _vm._e()], 1)
      }), _vm._v(" "), _c('v-list', {
        staticClass: "float-right"
      }, [_c('v-list-item', {
        staticStyle: {
          "margin-top": "-20px"
        }
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            return _vm.addPlatform(field.name)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                                ")], 1)], 1)], 1)], 2) : _vm._e()], 1)
    }), 1)])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0 font-weight-light",
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.editProfile
    }
  }, [_vm._v("Update Profile")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isValidAccount) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('p', [_c('b', [_vm._v("Notice:")]), _vm._v(" "), _c('i', [_vm._v("\n          Your account is not connected with your Instagram. Please click the button below to connect your Instagram account. \n          "), _c('br'), _vm._v("If you have registered with Kobe before, please reauthorise and refresh due to the change of Facebook API requirement.\n        ")])]), _vm._v(" "), _c('connect-instagram')], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Updating...\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('change-avatar-modal', {
    attrs: {
      "value": _vm.changeAvatarDialog
    },
    on: {
      "changeAvatar": _vm.uploadAvatar
    },
    model: {
      value: (_vm.changeAvatarDialog),
      callback: function($$v) {
        _vm.changeAvatarDialog = $$v
      },
      expression: "changeAvatarDialog"
    }
  }), _vm._v(" "), _c('update-platform-modal', {
    attrs: {
      "value": _vm.updatePlatformDialog
    },
    on: {
      "connectIG": _vm.connectInstagram
    },
    model: {
      value: (_vm.updatePlatformDialog),
      callback: function($$v) {
        _vm.updatePlatformDialog = $$v
      },
      expression: "updatePlatformDialog"
    }
  }), _vm._v(" "), _c('billing-info-modal', {
    attrs: {
      "value": _vm.billingInfoDialog,
      "infData": _vm.userData
    },
    on: {
      "updated": function($event) {
        return _vm.getUserProfile()
      }
    },
    model: {
      value: (_vm.billingInfoDialog),
      callback: function($$v) {
        _vm.billingInfoDialog = $$v
      },
      expression: "billingInfoDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value && _vm.showDialog),
      expression: "value && showDialog"
    }],
    staticClass: "theme--dark"
  }, [(_vm.showDialog) ? _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Update Submission Date")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": _vm.submissionDateFormatted,
            "label": "",
            "prepend-icon": "mdi-calendar",
            "hint": "DD/MM/YYYY format",
            "readonly": ""
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 1854811427),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.submissionDate),
      callback: function($$v) {
        _vm.submissionDate = $$v
      },
      expression: "submissionDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.updateSubmission
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overall-section",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Overall")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "icon": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.openColSettingsModal
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('i', {
    staticClass: "fas fa-cog fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Settings"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "overall-content"
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "40px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n                                Total Deliverables\n                            ")]), _vm._v(" "), (_vm.displayFields('totalContents')) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "28px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignKPI.minContent)) + " to " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignKPI.maxContent)) + " Contents\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.displayFields('totalOutreach')) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "28px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignKPI.outreach)) + " Audience Size\n                            ")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                    Achieved\n                                ")])])], 1)], 1), _vm._v(" "), (_vm.displayFields('contents')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.contents)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Contents\n                            ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('outreachImpressions')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.outreachImpressions)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Audience Size + Impressions\n                            ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('outreach')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.outreach)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Audience Size\n                            ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('interactions')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.engagement)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Interactions\n                            ")])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 pt-2",
    staticStyle: {
      "border-top": "1px solid #212121"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [(_vm.displayFields('postEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.postEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Post Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('reelEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.reelEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Reel Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('tiktokEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.tiktokEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        TikTok Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('youtubeEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.youtubeEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Youtube Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 pt-2",
    staticStyle: {
      "border-top": "1px solid #212121"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [(_vm.displayFields('postEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.postEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Post Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('reelEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.reelEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Reel Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('tiktokEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.tiktokEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        TikTok Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('youtubeEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.youtubeEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Youtube Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.displayFields('industryBenchmark')) ? _c('v-row', {
    attrs: {
      "align": "left",
      "justify": "left"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._v("\n                                            Industry Benchmark for \n                                        ")]), _vm._v(" "), _c('div', [(_vm.editBenchmark) ? _c('span', {
    staticClass: "benchmark-fields"
  }, [_c('v-text-field', {
    staticClass: "edit-box",
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.campaignKPI.benchmarkTitle),
      callback: function($$v) {
        _vm.$set(_vm.campaignKPI, "benchmarkTitle", $$v)
      },
      expression: "campaignKPI.benchmarkTitle"
    }
  })], 1) : _c('span', {
    staticClass: "benchmark-fields"
  }, [_vm._v(_vm._s(_vm.campaignKPI.benchmarkTitle))])]), _vm._v(" "), _c('div', [_vm._v(" : ")]), _vm._v(" "), _c('div', [(_vm.editBenchmark) ? _c('span', {
    staticClass: "benchmark-fields"
  }, [_c('v-text-field', {
    staticClass: "edit-box",
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.campaignKPI.benchmarkValue),
      callback: function($$v) {
        _vm.$set(_vm.campaignKPI, "benchmarkValue", $$v)
      },
      expression: "campaignKPI.benchmarkValue"
    }
  })], 1) : _c('span', {
    staticClass: "benchmark-fields"
  }, [_vm._v(_vm._s(_vm.campaignKPI.benchmarkValue))])]), _vm._v(" "), _c('div', {
    staticClass: "benchmark-edit"
  }, [(_vm.editBenchmark && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "dark": ""
    },
    on: {
      "click": _vm.saveBenchmark
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-done")]), _vm._v(" Save\n                                            ")], 1) : _vm._e(), _vm._v(" "), (!_vm.editBenchmark && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": "",
      "dark": ""
    },
    on: {
      "click": _vm.editBenchmarkAction
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": "Edit Campaign Summary"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1)])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Overall",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updatePerformanceAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), (_vm.approvedPost.influencer) ? _c('v-row', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "4",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return _c('v-card', {
          staticClass: "mx-auto my-12",
          class: ("elevation-" + (hover ? 12 : 2))
        }, [_c('v-list-item', [_c('v-list-item-avatar', {
          attrs: {
            "color": "grey"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(_vm.approvedPost.influencer.profilePicture),
            "alt": "avatar"
          }
        })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "subtitle-1 ma-0"
        }, [_vm._v(_vm._s(_vm.approvedPost.mainPost.campaignName))]), _vm._v(" "), _c('v-list-item-subtitle', {
          staticClass: "caption font-italic"
        }, [_vm._v("\n                    By\n                    "), _c('a', {
          attrs: {
            "href": 'https://instagram.com/' + _vm.approvedPost.influencer.username,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(_vm.approvedPost.influencer.username))])])], 1)], 1), _vm._v(" "), (!_vm.approvedPost.mainPost.images[0]) ? _c('v-img', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "src": "/static/img/upload-post-photo.png",
            "height": "300px"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(_vm.approvedPost.mainPost)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.approvedPost.mainPost.images[0] && !_vm.approvedPost.mainPost.images[0].isvideo) ? _c('v-img', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "src": _vm.approvedPost.mainPost.images[0].url,
            "height": "300px"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(_vm.approvedPost.mainPost)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.approvedPost.mainPost.images[0] && _vm.approvedPost.mainPost.images[0].isvideo) ? _c('video', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "height": "300px",
            "width": "100%"
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(_vm.approvedPost.mainPost)
            }
          }
        }, [_c('source', {
          attrs: {
            "src": _vm.approvedPost.mainPost.images[0].url,
            "type": "video/mp4"
          }
        }), _vm._v("\n                Your browser does not support the video tag.\n              ")]) : _vm._e(), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_vm._l((_vm.approvedPost.mainPost.labels), function(label) {
          return _c('v-chip', {
            key: label.text,
            staticClass: "ma-1",
            attrs: {
              "small": "",
              "color": label.color,
              "outlined": label.outlined,
              "dark": label.dark
            },
            on: {
              "click": function($event) {
                return _vm.exec(label.action, _vm.approvedPost.mainPost)
              }
            }
          }, [_vm._v("\n                  " + _vm._s(label.text) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v(_vm._s(label.icon))])], 1)
        }), _vm._v(" "), _c('v-spacer')], 2)], 1)
      }
    }], null, false, 3724328977)
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "proposeDateActions": _vm.showProposeDateAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "postAbuseHistory": false,
      "postReviewApproved": false,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "custom-card-title"
  }, [_vm._v("\n        Platforms\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('inf-platform-data-table', {
    attrs: {
      "items": _vm.platforms,
      "influencerID": _vm.influencerID
    },
    on: {
      "showCompareModal": _vm.showCompareModal,
      "reload": _vm.reloadPage,
      "close": _vm.close
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.compareDefaultInf) ? _c('comparison-modal', {
    attrs: {
      "influencer": _vm.compareDefaultInf,
      "compareInf": _vm.compareInf
    },
    on: {
      "mergeSuccess": _vm.mergeSuccess
    },
    model: {
      value: (_vm.comparisonDialog),
      callback: function($$v) {
        _vm.comparisonDialog = $$v
      },
      expression: "comparisonDialog"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "col-xs-offset-2 col-xs-8",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "btn text-uppercase",
    attrs: {
      "id": "check-btn"
    },
    on: {
      "click": _vm.check
    }
  }, [_vm._v("Check")]), _vm._v(" "), _c('a', {
    staticClass: "btn text-uppercase",
    attrs: {
      "id": "create-btn"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Kobe Tech Team")])])])
}]}

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logoPrimary
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "divbox"
    }
  }, [_c('div', {
    attrs: {
      "id": "number"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.displayNumber) + "\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('p', {
    staticClass: "headline",
    staticStyle: {
      "margin-bottom": "50px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n    Invite influencers for campaign:\n    "), _c('strong', [_vm._v(_vm._s(_vm.campaign.campaignName))])]), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', [_c('div', {
    staticClass: "client_deteial_title"
  }, [_vm._v("Client Details")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Client Name:")]), _vm._v(" " + _vm._s(_vm.client.clientName))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.client.clientEmail))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.clientPhoneNumber),
      expression: "client.clientPhoneNumber"
    }],
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Phone:")]), _vm._v(" " + _vm._s(_vm.client.clientPhoneNumber))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.clientWebsite),
      expression: "client.clientWebsite"
    }],
    staticClass: "ma-0 subtitle-1"
  }, [_c('strong', [_vm._v("Website:")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.client.clientWebsite
    }
  }, [_vm._v(_vm._s(_vm.client.clientWebsite))])])])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#78909C",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaign.min_content) + " to " + _vm._s(_vm.campaign.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#00838F",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#00C853",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#0091EA",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.invitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.notInvitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "disabled": _vm.disableSaveEdit
    },
    on: {
      "click": _vm.saveEditingData
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), (!_vm.disableSaveEdit) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.influencers,
      "sort-by": "calories",
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllInfluencers
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function() {
        return [_c('v-toolbar', {
          attrs: {
            "flat": "",
            "color": "white"
          }
        }, [_c('v-toolbar-title', [_vm._v("Influencers")]), _vm._v(" "), _c('v-divider', {
          staticClass: "mx-4",
          attrs: {
            "inset": "",
            "vertical": ""
          }
        }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
          attrs: {
            "max-width": "500px",
            "content-class": "ims-standard-dialog"
          },
          model: {
            value: (_vm.dialog),
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        }, [_c('v-card', {
          staticClass: "ims-modal-card"
        }, [_c('v-card-title', {
          staticClass: "edit-influencer-title"
        }, [_c('span', {
          staticClass: "headline"
        }, [_vm._v("Edit Influencer" + _vm._s(_vm.formTitle ? (" - " + _vm.formTitle) : ''))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "color": "secondary",
            "aria-label": "Close",
            "title": "Close"
          },
          on: {
            "click": _vm.close
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "12"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Email",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.email),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "email", $$v)
            },
            expression: "editedItem.email"
          }
        })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Post deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_posts),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_posts", $$v)
            },
            expression: "editedItem.no_of_posts"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Carousel deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_carousels),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_carousels", $$v)
            },
            expression: "editedItem.no_of_carousels"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Story deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_stories),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_stories", $$v)
            },
            expression: "editedItem.no_of_stories"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG Video deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_video),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_video", $$v)
            },
            expression: "editedItem.no_of_video"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('v-text-field', {
          attrs: {
            "type": "number",
            "min": "0",
            "label": "IG TV deliverables",
            "color": "secondary"
          },
          model: {
            value: (_vm.editedItem.no_of_igTv),
            callback: function($$v) {
              _vm.$set(_vm.editedItem, "no_of_igTv", $$v)
            },
            expression: "editedItem.no_of_igTv"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Save")])], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_c('v-checkbox', {
            attrs: {
              "value": item.id,
              "disabled": !_vm.isValidPairing(item)
            },
            model: {
              value: (_vm.selectedInfluencers),
              callback: function($$v) {
                _vm.selectedInfluencers = $$v
              },
              expression: "selectedInfluencers"
            }
          })], 1), _vm._v(" "), _c('td', [(item.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagramHandle))]) : _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1), _vm._v(" "), (!item.isLoading && item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && !item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.emailEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'email')
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.email))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "mt-3",
            staticStyle: {
              "width": "290px"
            },
            attrs: {
              "outlined": "",
              "color": "secondary"
            },
            model: {
              value: (item.email),
              callback: function($$v) {
                _vm.$set(item, "email", $$v)
              },
              expression: "item.email"
            }
          }, _vm.on))], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(item.payout)))]), _vm._v(" "), _c('td', [(item.no_of_posts) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_posts > 0 ? item.no_of_posts : '') + " " + _vm._s(item.no_of_posts > 0 ? item.no_of_posts > 1 ? 'Posts' : 'Post' : ''))])]) : _vm._e(), _vm._v(" "), (item.no_of_carousels) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_carousels > 0 ? item.no_of_carousels : '') + " " + _vm._s(item.no_of_carousels > 0 ? item.no_of_carousels > 1 ? 'Carousels' : 'Carousels' : ''))])]) : _vm._e(), _vm._v(" "), (item.no_of_stories) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_stories > 0 ? item.no_of_stories : '') + "  " + _vm._s(item.no_of_stories > 0 ? (item.no_of_stories > 1 ? 'Stories' : 'Story') : '') + " ")])]) : _vm._e(), _vm._v(" "), (item.no_of_video) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_video > 0 ? item.no_of_video : '') + " " + _vm._s(item.no_of_video > 0 ? item.no_of_video > 1 ? 'Videos' : 'Video' : ''))])]) : _vm._e(), _vm._v(" "), (item.no_of_igTv) ? _c('p', {
            staticClass: "ma-0 body-2"
          }, [_c('span', [_vm._v(_vm._s(item.no_of_igTv > 0 ? item.no_of_igTv : '') + " " + _vm._s(item.no_of_igTv > 0 ? item.no_of_igTv > 1 ? 'TVs' : 'TV' : ''))])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('pairing-status', {
            attrs: {
              "status": item.pairingStatus
            }
          })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
            attrs: {
              "fab": "",
              "small": "",
              "color": "secondary"
            },
            on: {
              "click": function($event) {
                return _vm.editItem(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "fab": "",
              "small": "",
              "color": "secondary"
            },
            on: {
              "click": function($event) {
                return _vm.preview(item, _vm.selectedTemplate.templateHTML)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-file-find")])], 1)], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.emailDialog = true
      }
    }
  }, [_vm._v("          \n        Invite with Email\n        "), _c('v-icon', {
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("\n          mdi-email-plus\n        ")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "disabled": !_vm.selectedInfluencers || _vm.selectedInfluencers.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.updateInvitedStatus(_vm.selectedInfluencers)
      }
    }
  }, [_vm._v("Invite (" + _vm._s(_vm.selectedInfluencers.length) + ")")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700",
      "persistent": ""
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        Email template creation\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-autocomplete', {
    staticClass: "mb-2",
    attrs: {
      "items": _vm.templates,
      "item-text": "name",
      "hide-details": "",
      "dense": "",
      "filled": "",
      "return-object": "",
      "label": "Select Template"
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "mb-2",
    attrs: {
      "items": _vm.fromEmail,
      "item-text": "name",
      "hide-details": "",
      "dense": "",
      "filled": "",
      "return-object": "",
      "label": "From:"
    },
    model: {
      value: (_vm.selectedFromEmail),
      callback: function($$v) {
        _vm.selectedFromEmail = $$v
      },
      expression: "selectedFromEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "margin": "10px 0px 10px 0px"
    },
    attrs: {
      "lass": "mb-2",
      "hide-details": "",
      "label": "Subject",
      "single-line": "",
      "filled": ""
    },
    model: {
      value: (_vm.selectedTemplate.subject),
      callback: function($$v) {
        _vm.$set(_vm.selectedTemplate, "subject", $$v)
      },
      expression: "selectedTemplate.subject"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "margin": "10px 0px 10px 0px"
    },
    attrs: {
      "lass": "mb-2",
      "label": "Campaign Invite URL",
      "filled": "",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.inviteUrl),
      callback: function($$v) {
        _vm.inviteUrl = $$v
      },
      expression: "inviteUrl"
    }
  }), _vm._v(" "), _c('vue-editor', {
    model: {
      value: (_vm.selectedTemplate.templateHTML),
      callback: function($$v) {
        _vm.$set(_vm.selectedTemplate, "templateHTML", $$v)
      },
      expression: "selectedTemplate.templateHTML"
    }
  }), _vm._v(" "), (_vm.keywords && _vm.keywords.length > 0) ? _c('p', {
    staticClass: "title"
  }, [_vm._v("Map values")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.keywords), function(keyword) {
    return _c('v-row', {
      key: keyword,
      attrs: {
        "align": "center",
        "justify": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "5",
        "align": "end",
        "justify": "end"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Source",
        "filled": "",
        "disabled": "",
        "hide-details": "",
        "value": keyword
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "2",
        "align": "center",
        "justify": "center"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-arrow-left-right")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "5",
        "align": "center",
        "justify": "center"
      }
    }, [_c('v-autocomplete', {
      staticClass: "mb-2",
      attrs: {
        "items": _vm.fields,
        "hide-details": "",
        "value": _vm.keywordsMap.get(keyword),
        "dense": "",
        "filled": "",
        "label": "Target"
      },
      on: {
        "change": function($event) {
          return _vm.mapValue($event, keyword)
        }
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": !_vm.selectedTemplate._id
    },
    on: {
      "click": function($event) {
        return _vm.saveTemplateChanges(_vm.selectedTemplate._id)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.saveNewTemplate
    }
  }, [_vm._v("Save As")])], 1)], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary",
      "disabled": !_vm.selectedInfluencers || _vm.selectedInfluencers.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.sendBulkInvitation(_vm.selectedInfluencers, _vm.selectedTemplate._id)
      }
    }
  }, [_vm._v("Send invite (" + _vm._s(_vm.selectedInfluencers.length) + ")")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "id": "sweetAlertContainer"
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    model: {
      value: (_vm.previewDialog),
      callback: function($$v) {
        _vm.previewDialog = $$v
      },
      expression: "previewDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Preview content")])]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewText)
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.previewDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('k-toast', {
    attrs: {
      "variant": _vm.toast.variant,
      "header": _vm.toast.header,
      "content": _vm.toast.content
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400px"
    },
    model: {
      value: (_vm.sendingInvitationDialog),
      callback: function($$v) {
        _vm.sendingInvitationDialog = $$v
      },
      expression: "sendingInvitationDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [(_vm.isSending) ? _c('span', {
    staticClass: "headline"
  }, [_vm._v("In progress...")]) : _vm._e(), _vm._v(" "), (!_vm.isSending) ? _c('span', {
    staticClass: "headline"
  }, [_vm._v("Finished")]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [(_vm.isSending) ? _c('v-progress-linear', {
    attrs: {
      "height": "15",
      "indeterminate": "",
      "color": "yellow darken-2"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "color": "primary"
    }
  }, _vm._l((_vm.sendings), function(item, i) {
    return _c('v-list-item', {
      key: i
    }, [_c('v-list-item-icon', [(item.isSuccess) ? _c('v-icon', {
      attrs: {
        "color": "success"
      }
    }, [_vm._v("mdi-check")]) : _vm._e(), _vm._v(" "), (!item.isSuccess) ? _c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("@" + _vm._s(item.instagramHandle))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.isSending,
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.sendingInvitationDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Influencer Handle")]), _vm._v(" "), (_vm.inputedRates.instagramHandle) ? _c('social-handle', {
    attrs: {
      "isInstagram": true,
      "instagramHandle": _vm.inputedRates.instagramHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inputedRates.instagramHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Tiktok Handle")]), _vm._v(" "), (_vm.inputedRates.tiktokHandle) ? _c('social-handle', {
    attrs: {
      "isTikTok": true,
      "tiktokHandle": _vm.inputedRates.tiktokHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inputedRates.tiktokHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Story")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igStory || '-'))]), _vm._v(" "), (_vm.inputedRates.igStory) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igPost || '-'))]), _vm._v(" "), (_vm.inputedRates.igPost) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igCarousel || '-'))]), _vm._v(" "), (_vm.inputedRates.igCarousel) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Video")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igVideo || '-'))]), _vm._v(" "), (_vm.inputedRates.igVideo) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Reel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igReel || '-'))]), _vm._v(" "), (_vm.inputedRates.igReel) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Loading Fee")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.loadingFee || '-'))]), _vm._v(" "), (_vm.inputedRates.loadingFee) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Event Appearance")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.inputedRates.eventAppearance) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])])])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (Instagram)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.inputedRates.igRemarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "tiktok-stats",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Tiktok")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.tiktok || '-'))]), _vm._v(" "), (_vm.inputedRates.tiktok) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])])])]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (TikTok)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.inputedRates.tiktokRemarks || '-'))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-divider', {
    staticClass: "ma-0"
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Handle of Other Platforms")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Platform")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inputedRates.platforms), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v("\n                    " + _vm._s(item.platform) + "\n                    "), (item.platform === 'others') ? _c('span', [_vm._v(_vm._s(item.otherPlatform))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.rate) ? _c('span', [_vm._v("$ SGD")]) : _vm._e()])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("About You")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.inputedRates.aboutYou || '-') + "\n          ")])]), _vm._v(" "), (_vm.inputedRates.pricingDecks && _vm.inputedRates.pricingDecks.length > 0) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Media Kit")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.inputedRates.pricingDecks
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-brief"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Reload Campaigns"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.fields,
      "items": _vm.campaigns,
      "items-per-page": _vm.itemsPerPage,
      "data-app": ""
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "modal",
            "data-target": "#view_campaign_modal",
            "disabled": (item.activated === _vm.campaignActivationStatusConfig.ACTIVATED) ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), (item.status === _vm.campaignStatusConfig.PENDING_CLIENT_APPROVAL) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Campaign",
            "color": "success",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.approveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.startEliminate(item.id, item.status)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-users-cog",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        })])], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data Received")]
      },
      proxy: true
    }], null, true)
  })], 1)])]), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('influencer-elimination', {
    attrs: {
      "campaingData": _vm.campaingData
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1250"
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Paired influencers")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Handle")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Followers")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Eng. Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Aud. Cred")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Elimination Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pairedInfluencers), function(item) {
          return _c('tr', {
            key: item.instagramHandle
          }, [_c('td', [(item.influencer_details.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagramHandle))]) : (item.influencer_details.platform === 'youtube') ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.followers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagement_rate) + "%")]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                " + _vm._s(item.audience_credibility) + "\n              ")], 1), _vm._v(" "), _c('td', [_c('v-chip', _vm._g({
            staticClass: "ma-2",
            attrs: {
              "color": _vm.eliminatinStatusColor(item.eliminationStatus),
              "x-small": "",
              "text-color": "white"
            }
          }, _vm.on), [_vm._v("\n                  " + _vm._s(_vm.eliminationStatusDisplay(item.eliminationStatus)) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-check")])], 1)], 1)])
        }), 0)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.brandSheet.id) ? _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "brand-fact-sheet-view-card",
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "elevate-on-scroll": ""
    }
  }, [(_vm.isStoryTell) ? _c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Brand Fact Sheet - " + _vm._s(_vm.brandSheet.clientName))]) : _vm._e(), _vm._v(" "), (_vm.isUGC) ? _c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Brand Fact Sheet - " + _vm._s(_vm.brandSheet.campaignName))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.brandSheet.type) ? _c('v-container', {
    staticClass: "ims-modal-body brand-fact-sheet-view-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.isStoryTell) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("STORYTELL - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/storytell_bg.jpg"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.title))])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.subtitle))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    })])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionTwo.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionTwo.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    })])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionThree.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionThree.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type === 'textbox' || field.type === 'textarea' || field.type === 'select') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'checkbox') ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [(_vm.brandSheet[field.name].length === 0) ? _c('p', [_vm._v("-")]) : _vm._e(), _vm._v(" "), _vm._l((field.detailFields.filter(function (v) { return _vm.brandSheet[field.name].includes(v.value); })), function(age) {
      return _c('v-flex', {
        key: age.key,
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('p', [_vm._v(_vm._s(age.label))])])
    })], 2) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', [(_vm.brandSheet[field.name].length > 0) ? _c('v-row', _vm._l((_vm.brandSheet[field.name]), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1) : _vm._e()], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isAOK) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Uncut - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.subtitle))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/aok_bg.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("SELECTION CRITERIA")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("It is recommended for our clients to make your own logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("There will be a 5 working day turnaround for all logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will not be responsible for any damaged or lost parcels.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("ADDITIONAL ENGAGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type !== 'file') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file' && _vm.brandSheet[field.name].length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet[field.name]), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1)], 1) : _vm._e()])])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isKobeLite) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Lite - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetKobeLiteFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetKobeLiteFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type !== 'file') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file' && _vm.brandSheet[field.name].length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet[field.name]), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1)], 1) : _vm._e()])])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUGC) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("UGC (User-Generated-Content) Videos Application Form")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h5 font-weight-bold mb-0"
  }, [_vm._v("I am aware that kobe’s full service of S$15k and up, includes:")]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.")]), _vm._v(" "), _c('li', [_vm._v("Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.")]), _vm._v(" "), _c('li', [_vm._v("Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.")]), _vm._v(" "), _c('li', [_vm._v("Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.")]), _vm._v(" "), _c('li', [_vm._v("Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.")]), _vm._v(" "), _c('li', [_vm._v("Up to 3 accesses to our Influencer Management System® to streamline influencer campaign management.")]), _vm._v(" "), _c('li', [_vm._v("Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.")])])]), _vm._v(" "), _c('p', [_vm._v("Lead time: 4 weeks")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("To proceed with UGC videos application, please complete the following.")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.brandSheet.ugcVideo) + "\n              ")]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_c('strong', [_vm._v("Includes:")])]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Utilization and exposure to a nano-reviewer base of 10,000 individuals with follower counts up to 3,000.")]), _vm._v(" "), _c('li', [_vm._v("Guidance and assistance in the creation of email invitations for reviewer outreach and engagement.")]), _vm._v(" "), _c('li', [_vm._v("Immediate notifications when content is posted, with seamless collection of content assets for future use.")]), _vm._v(" "), _c('li', [_vm._v("Direct access to reviewer contact information for the purpose of building relationships and facilitating additional collaborations.")])])])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://uat.app.getkobe.com/static/img/brand_sheet/ugc_process.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFLUENCER SELECTION")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-0"
  }, [_vm._v("For products")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('ul', [_c('li', [_vm._v("It is recommended for our clients to make your own logistics arrangements.")]), _vm._v(" "), _c('li', [_vm._v("For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.")]), _vm._v(" "), _c('li', [_vm._v("Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.")]), _vm._v(" "), _c('li', [_vm._v("There will be a 5 working day turnaround for all logistics arrangements.")]), _vm._v(" "), _c('li', [_vm._v("KOBE will not be responsible for any damaged or lost parcels.")])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-0"
  }, [_vm._v("For experience")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('ul', [_c('li', [_vm._v("Creator attend the experience directly and client to verify")]), _vm._v(" "), _c('li', [_vm._v("Creator can make the purchase of experience with attached receipt for 100% reimbursement from client")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("UGC VIDEOS TRACKING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("POST CAMPAIGN")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.type !== 'custom') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.showFieldValue(_vm.brandSheet[field.name], field.name))
      }
    }) : _vm._e(), _vm._v(" "), (field.name === 'sampleVideoContent') ? _c('div', [(typeof _vm.brandSheet.sampleVideoContent === 'string') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.brandSheet.sampleVideoContent)
      }
    }) : _vm._e(), _vm._v(" "), (typeof _vm.brandSheet.sampleVideoContent === 'object') ? _c('v-row', {
      staticClass: "mb-3"
    }, _vm._l((_vm.brandSheet.sampleVideoContent), function(item, index) {
      return _c('v-col', {
        key: index,
        staticClass: "pb-0",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12",
          "align": "left"
        }
      }, [_c('a', {
        attrs: {
          "href": item.link,
          "target": "_blank"
        }
      }, [_vm._v("\n                              " + _vm._s(item.link) + "\n                            ")])])
    }), 1) : _vm._e(), _vm._v(" "), (_vm.brandSheet.sampleVideoContentFiles.length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet.sampleVideoContentFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12",
          "align": "left"
        }
      }, [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v("\n                                Click to View\n                              ")])])
    }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.name === 'marketingCollaterals') ? _c('div', [(typeof _vm.brandSheet.marketingURL === 'string') ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.brandSheet.marketingURL)
      }
    }) : _vm._e(), _vm._v(" "), (typeof _vm.brandSheet.marketingURL === 'object') ? _c('v-row', {
      staticClass: "mb-3"
    }, _vm._l((_vm.brandSheet.marketingURL), function(item, index) {
      return _c('v-col', {
        key: index,
        staticClass: "pb-0",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12",
          "align": "left"
        }
      }, [_c('a', {
        attrs: {
          "href": item.link,
          "target": "_blank"
        }
      }, [_vm._v("\n                              " + _vm._s(item.link) + "\n                            ")])])
    }), 1) : _vm._e(), _vm._v(" "), (_vm.brandSheet.marketingCollaterals.length > 0) ? _c('div', [_c('v-row', _vm._l((_vm.brandSheet.marketingCollaterals), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('image') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        staticClass: "grey lighten-2",
        attrs: {
          "width": "67",
          "height": "85",
          "src": item.url,
          "lazy-src": item.url,
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e()])
    }), 1)], 1) : _vm._e()], 1) : _vm._e()])])
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-0 ma-0 body-1 white--text"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-space-between"
  }, [_c('div', [_vm._v("Actual :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.summary.actual))])])]), _vm._v(" "), _c('div', {
    staticClass: "pl-1"
  }, _vm._l((_vm.summary.actualTasks), function(task, index) {
    return _c('div', {
      key: index,
      staticClass: "pa-0 ma-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-space-between"
    }, [_c('div', [_vm._v(_vm._s(task.title) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(task.value))])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "color": "white",
      "app": "",
      "inset": "",
      "absolute": "",
      "padless": ""
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "font-weight-bold text-wrap"
  }, [_c('p', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("\n        Influencer Terms & Conditions\n      ")]), _c('br'), _c('br'), _vm._v("\n      Website\n      "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n      "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy.")]), _c('br'), _c('br'), _vm._v("\n        Patent: "), _c('a', {
    attrs: {
      "href": "https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1",
      "target": "_blank"
    }
  }, [_vm._v(" KOBE 11201807777W ℗ ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      All rights reserved. Copyright © 2016-" + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/",
      "target": "_blank"
    }
  }, [_vm._v(" Kobe Global Technologies Pte Ltd")]), _vm._v(".\n      ")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sectionTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": _vm.sectionId,
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    staticClass: "custom-table",
    attrs: {
      "id": (_vm.sectionId + "-table"),
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "items-per-page": 50,
      "hide-default-footer": true,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.name))])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [(item.url) ? _c('a', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": item.url,
            "target": "_blank"
          }
        }, [_vm._v("View Post")]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n                  ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.impressions === 0 ? '-' : item.impressions)) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.reach === 0 ? '-' : item.reach)) + "\n                  ")]
      }
    }, {
      key: "item.video_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.video_views === 0 ? '-' : item.video_views)) + "\n                  ")]
      }
    }, {
      key: "item.profile_viewers",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.profile_viewers === 0 ? '-' : item.profile_viewers)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'url') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'like_count') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'comment_count') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews === 0 ? '-' : _vm.totalViews)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'video_views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalVideoViews === 0 ? '-' : _vm.totalVideoViews)))] : (header.value === 'profile_viewers') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalProfileViewers === 0 ? '-' : _vm.totalProfileViewers)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'bookmarks') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalBookmarks === 0 ? '-' : _vm.totalBookmarks)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": _vm.sectionTitle,
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateFbAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-right",
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "right": "",
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Table View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("mdi-calendar-range")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Calendar View")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.display === 0) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.filteredItems.length > 0) ? _c('div', [_c('report-table', {
    attrs: {
      "headers": _vm.headers,
      "filteredItems": _vm.filteredItems,
      "loading": _vm.loading,
      "refresh": _vm.tableRefresh
    },
    on: {
      "viewInfluencers": _vm.viewInfluencers,
      "updated": _vm.refreshTableView
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('influencer-modal', {
    attrs: {
      "headers": _vm.influencerHeaders,
      "filteredItems": _vm.filteredInfluencers,
      "filter": _vm.influencerFilter,
      "campaign": _vm.selectedCampaign,
      "overall": _vm.overallTotals,
      "posted": _vm.postedTotals,
      "postedDeliverables": _vm.deliverableTotals,
      "totals": _vm.filterInfTotals,
      "value": _vm.viewInfluencerDialog,
      "loading": _vm.infLoading
    },
    on: {
      "filtered": _vm.filterInfluencerList,
      "dataTableFiltered": _vm.infDataTableFiltered,
      "closed": _vm.closeInfModal
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.display === 1) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('calendar-table', {
    attrs: {
      "headers": _vm.calendarHeaders,
      "calendarMonths": _vm.showMonths,
      "filteredItems": _vm.filteredCalCampaigns,
      "filter": _vm.calendarFilter,
      "loading": _vm.loading,
      "disableLeftArrow": _vm.disableLeftArrow,
      "disableRightArrow": _vm.disableRightArrow
    },
    on: {
      "filterDate": _vm.filterMonth,
      "changeMonth": _vm.changeMonth
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "client-login-account-modal"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Update Client Login Account")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "client-login-account-modal__content"
  }, [_c('v-card-text', {
    staticClass: "client-login-account-modal__accounts"
  }, [_vm._l((_vm.existingAccounts), function(account, index) {
    return _c('v-list', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "perm_identity",
        "label": "Client Login Email",
        "placeholder": "Create new Client Account",
        "value": account.email,
        "disabled": ""
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "prepend-icon": "security",
        "append-icon": account.show1 ? 'visibility' : 'visibility_off',
        "type": account.show1 ? 'text' : 'password',
        "label": "Enter Password",
        "hint": "Recommended for at least 8 characters",
        "counter": ""
      },
      on: {
        "click:append": function($event) {
          return _vm.updateAccShow(index)
        }
      },
      model: {
        value: (account.password),
        callback: function($$v) {
          _vm.$set(account, "password", $$v)
        },
        expression: "account.password"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeExistingAccount(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete                         \n                ")], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.newAccounts), function(account, index) {
    return _c('v-list', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-select', {
      staticClass: "mb-2",
      attrs: {
        "items": account.newEmails,
        "item-text": "email",
        "outlined": "",
        "label": "Client Login Email",
        "dense": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.checkAccEmail(index)
        }
      },
      model: {
        value: (account.email),
        callback: function($$v) {
          _vm.$set(account, "email", $$v)
        },
        expression: "account.email"
      }
    })], 1), _vm._v(" "), (account.invalid) ? _c('v-list-item', {
      staticStyle: {
        "margin-top": "-15px"
      },
      attrs: {
        "dense": ""
      }
    }, [_c('p', {
      staticClass: "pt-2 text-danger"
    }, [_vm._v("Email Already Exists.")])]) : _vm._e(), _vm._v(" "), _c('v-list-item', [_c('v-text-field', {
      attrs: {
        "prepend-icon": "security",
        "append-icon": account.show1 ? 'visibility' : 'visibility_off',
        "type": account.show1 ? 'text' : 'password',
        "label": "Enter Password",
        "hint": "Recommended for at least 8 characters",
        "counter": ""
      },
      on: {
        "click:append": function($event) {
          account.show1 = !account.show1
        }
      },
      model: {
        value: (account.password),
        callback: function($$v) {
          _vm.$set(account, "password", $$v)
        },
        expression: "account.password"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeNewAccount(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete                         \n                ")], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info",
      "disabled": _vm.disableAddNew
    },
    on: {
      "click": function($event) {
        return _vm.addNewAccount()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Account\n            ")], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "info",
    on: {
      "click": _vm.updateClientUser
    }
  }, [_vm._v("Save changes")])], 1), _vm._v(" "), _c('small', [_vm._v("*If client don't have the email address, the system will automatically create a login email.")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "1000px",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "absolute": "",
      "color": "primary",
      "width": "100%"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.termsAndConditions.title[_vm.selectedLang]))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.termsAndConditions.title[_vm.selectedLang]))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.termsAndConditions.html[_vm.selectedLang])
    }
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.agree
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]), _vm._v(_vm._s(_vm.termsAndConditions.confirmButtonText))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v(" mdi-cancel")]), _vm._v(_vm._s(_vm.termsAndConditions.cancelButtonText))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1300px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    staticClass: "pairing-elimination-toolbar",
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "pairing-elimination-title"
  }, [_c('h2', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            Please check the columns and influencers list before sending to client.\n          ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', {
    staticClass: "pairing-elimination-options mt-1 mb-2",
    attrs: {
      "justify": "right"
    }
  }, [_c('v-btn-toggle', {
    staticClass: "mr-3",
    attrs: {
      "mandatory": "",
      "color": "secondary"
    },
    on: {
      "change": function($event) {
        return _vm.changeOption()
      }
    },
    model: {
      value: (_vm.optionVal),
      callback: function($$v) {
        _vm.optionVal = $$v
      },
      expression: "optionVal"
    }
  }, [_c('v-btn', {
    staticClass: "option-btn"
  }, [_vm._v("Option A")]), _vm._v(" "), _c('v-btn', {
    staticClass: "option-btn"
  }, [_vm._v("Option B")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('pairing-influencers-table', {
    attrs: {
      "influencers": _vm.pairedInfluencers,
      "elimination": "",
      "internalView": "",
      "campaignID": _vm.campaign.id,
      "campaignData": _vm.campaign
    },
    on: {
      "savedEliminationChanges": _vm.eliminationSubmitted,
      "savedClientNotes": _vm.getPairingList,
      "sendToClient": _vm.invokeSendToClient
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportInfluencers.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadAll()
      }
    }
  }, [_vm._v("\n            Reload All\n            "), _c('i', {
    staticClass: "fa fa-repeat"
  })]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": "",
      "open-on-hover": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.copyLink(null)
            }
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_vm._v("Copy Travel Form")]), _vm._v(" \n                "), _c('v-icon', _vm._g({
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "small": ""
          }
        }, on), [_vm._v("mdi-content-copy")])], 1)]
      }
    }]),
    model: {
      value: (_vm.linkCopied),
      callback: function($$v) {
        _vm.linkCopied = $$v
      },
      expression: "linkCopied"
    }
  }, [_vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "color": "white darken-2"
    }
  }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin": "30px 0px 0px 0px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Email, Handle, Fullname",
      "hide-details": "auto",
      "id": "igHandle"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Influencer Location"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n            ")])]
      }
    }]),
    model: {
      value: (_vm.influencerGeos),
      callback: function($$v) {
        _vm.influencerGeos = $$v
      },
      expression: "influencerGeos"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.infCategories,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Categories"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeCategory(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n            ")])]
      }
    }]),
    model: {
      value: (_vm.infCategory),
      callback: function($$v) {
        _vm.infCategory = $$v
      },
      expression: "infCategory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.joinedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.joinedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.joinedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Joined Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.paginate()
            }
          },
          model: {
            value: (_vm.joinedMonth),
            callback: function($$v) {
              _vm.joinedMonth = $$v
            },
            expression: "joinedMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.joinedMonth),
      callback: function($$v) {
        _vm.joinedMonth = $$v
      },
      expression: "joinedMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.joinedMonthOk
    }
  }, [_vm._v("\n              OK\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "platform-filter",
    attrs: {
      "role": "group",
      "aria-label": "Filter influencers by platform"
    }
  }, [_c('span', {
    staticClass: "platform-filter__label"
  }, [_vm._v("Platforms")]), _vm._v(" "), _vm._l((_vm.platformFilterOptions), function(platform) {
    return _c('v-btn', {
      key: platform.filterKey,
      staticClass: "platform-filter__button",
      class: {
        'platform-filter__button--active': _vm.searchFilter[platform.filterKey]
      },
      attrs: {
        "text": "",
        "small": "",
        "aria-pressed": String(_vm.searchFilter[platform.filterKey])
      },
      on: {
        "click": function($event) {
          return _vm.togglePlatformFilter(platform.filterKey)
        }
      }
    }, [(platform.imgIcon) ? _c('img', {
      staticClass: "platform-filter__logo",
      attrs: {
        "src": platform.imgIcon,
        "alt": ((platform.text) + " logo")
      }
    }) : _c('v-icon', {
      attrs: {
        "left": "",
        "size": "18",
        "color": platform.iconColor
      }
    }, [_vm._v("\n              " + _vm._s(platform.icon) + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(platform.text))])], 1)
  })], 2)]), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "200px",
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-checkbox', {
    staticClass: "pending-approval-checkbox mt-0",
    attrs: {
      "label": "Pending Approval",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.pendingApproval),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "pendingApproval", $$v)
      },
      expression: "searchFilter.pendingApproval"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewCompany",
      "data-toggle": "modal",
      "data-target": _vm.viewCompanyModalIdDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "ims-sticky-actions-table actions-column-visible elevation-1",
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "loading": _vm.loading,
      "options": _vm.pagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.totalItems,
      "item-key": "_id"
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.profilePicture",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.profilePicture),
            "alt": "avatar"
          }
        })])], 1)])]
      }
    }, {
      key: "item.igHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.igHandle) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.igHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.igProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + item.igHandle
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#E4405F",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.igHandle))], 1)], 1) : _vm._e()])])]
      }
    }, {
      key: "item.tiktokHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.tiktokHandle) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.tiktokHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.tiktokProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.tiktokHandle) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.tiktok.com/@' + item.tiktokHandle
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.tiktokHandle))]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: "item.youtubeHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.youtubeHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.youtubeProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.youtubeHandle) ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/@' + item.youtubeHandle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.youtubeHandle))], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.fbHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.fbHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.fbProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.fbHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.facebook.com/' + item.fbHandle,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#1877F2",
            "small": ""
          }
        }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.fbHandle))], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.xhsHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.xhsHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.xhsProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.xhsHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/xhs-black.png",
            "width": "18px",
            "alt": "",
            "aria-hidden": "true"
          }
        }), _vm._v(" @" + _vm._s(item.xhsFullname))]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.linkedinHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.linkedinHandle) ? _c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.linkedinProfilePicture),
            "alt": "avatar"
          }
        })]) : _vm._e(), _vm._v(" "), (item.linkedinHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.linkedin.com/in/' + item.linkedinHandle,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#0A66C2",
            "small": ""
          }
        }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.linkedinHandle))], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.twitterHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.twitterHandle) ? _c('a', {
          attrs: {
            "href": 'https://x.com/' + item.twitterHandle,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "15px",
            "alt": "",
            "aria-hidden": "true"
          }
        }), _vm._v(" @" + _vm._s(item.twitterHandle))]) : _vm._e()])])]
      }
    }, {
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.platform === 'tiktok') ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.tiktok.com/@' + item.handle
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.handle))]) : (item.platform === 'youtube') ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/' + item.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.handle))], 1) : _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + item.handle
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle))], 1)])])]
      }
    }, {
      key: "item.joinedAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDateTime(item.joinedAt)))])])]
      }
    }, {
      key: "item.lastLoginAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.lastLoginAt),
            expression: "item.lastLoginAt"
          }],
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDateTime(item.lastLoginAt)))])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.totalFollowers))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.audienceCredibility) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.formatDateTime(props.item.joinedAt)))])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [(_vm.buttonShow('view')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.getInfluencerDataToView(item.id, item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-account-edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Influencer")])])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action text--secondary",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getPlatformDataToView(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-account-group")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Assign Platform")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteInfluencer(item.id)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticStyle: {
                  "color": "#fff"
                }
              }, on), [_vm._v("mdi-delete")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "right": "",
            "open-on-hover": false
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.copyLink(item)
                  }
                }
              }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                attrs: {
                  "bottom": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;

                    return [_c('v-icon', _vm._g({
                      staticStyle: {
                        "color": "#fff"
                      },
                      attrs: {
                        "small": ""
                      }
                    }, on), [_vm._v("mdi-content-copy")])]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('span', [_vm._v("Copy Travel Form")])])], 1)]
            }
          }], null, true),
          model: {
            value: (item.linkCopied),
            callback: function($$v) {
              _vm.$set(item, "linkCopied", $$v)
            },
            expression: "item.linkCopied"
          }
        }, [_vm._v(" "), _c('span', [_c('v-icon', {
          attrs: {
            "color": "white darken-2"
          }
        }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)]), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openResetDialog(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticStyle: {
                  "color": "#fff"
                }
              }, on), [_vm._v("mdi-pencil-lock")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Reset Password")])])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.igHandle),
            expression: "item.igHandle"
          }],
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'instagram')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('i', _vm._g({
                staticClass: "fab fa-instagram"
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Instagram Audience")])])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.tiktokHandle),
            expression: "item.tiktokHandle"
          }],
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'tiktok')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('img', _vm._g({
                attrs: {
                  "src": "/static/img/tik-tok-white.png",
                  "width": "20px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View TikTok Audience")])])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.youtubeHandle),
            expression: "item.youtubeHandle"
          }],
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'youtube')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-youtube")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Youtube Audience")])])], 1)], 1)])]
      }
    }], null, true)
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-reportlink"
    },
    domProps: {
      "value": _vm.reportLink
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('create-influencer-modal', {
    attrs: {
      "modalId": _vm.createModalId
    },
    on: {
      "createInfluencer": _vm.createInfluencer
    }
  }), _vm._v(" "), _c('view-influencer-modal', {
    attrs: {
      "influencerData": _vm.viewInfluencerData
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport,
      "handle": _vm.viewAudHandle,
      "platform": _vm.viewAudPlatform
    },
    on: {
      "showLoadingEvent": _vm.showLoadingEvent
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('view-influencer-company-modal', {
    attrs: {
      "modalId": _vm.viewCompanyModalId,
      "influencerData": _vm.viewInfluencerData_company
    }
  }), _vm._v(" "), _c('influencer-post-modal', {
    attrs: {
      "modalId": _vm.influencerPostModalId,
      "title": _vm.postsTitle,
      "shortCodes": _vm.shortCodes
    }
  }), _vm._v(" "), _c('inf-platforms-view-modal', {
    attrs: {
      "platforms": _vm.viewPlatforms,
      "influencerID": _vm.selectedInfluencerID,
      "influencer": _vm.viewInfluencerData
    },
    on: {
      "reload": function($event) {
        return _vm.paginate(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.infPlatformsDialog),
      callback: function($$v) {
        _vm.infPlatformsDialog = $$v
      },
      expression: "infPlatformsDialog"
    }
  }), _vm._v(" "), _c('inf-reset-password-modal', {
    attrs: {
      "influencerID": _vm.selectedInfluencerID,
      "influencer": _vm.viewInfluencerData
    },
    on: {
      "reload": function($event) {
        return _vm.paginate(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.infPassResetDialog),
      callback: function($$v) {
        _vm.infPassResetDialog = $$v
      },
      expression: "infPassResetDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Exporting your data.\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payout record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "error-messages": _vm.selectedCampaignErrors,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Campaign Name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "change": function($event) {
        return _vm.changeCampaign()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.influencers,
      "item-text": "handle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.handle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.handle.$touch()
      },
      "change": function($event) {
        return _vm.changeInfluencer()
      }
    },
    model: {
      value: (_vm.payout.handle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "handle", $$v)
      },
      expression: "payout.handle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Swift Code",
      "hide-details": "",
      "placeholder": "RABONL2U",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.bankSwiftCode),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankSwiftCode", $$v)
      },
      expression: "payout.bankSwiftCode"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank A/C No.",
      "placeholder": "Bank A/C No.(omit dashes)",
      "error-messages": _vm.bankNoErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankAccountNo),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankAccountNo", $$v)
      },
      expression: "payout.bankAccountNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Payee Name",
      "placeholder": "Payee Name.",
      "error-messages": _vm.receivingNameErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      }
    },
    model: {
      value: (_vm.payout.receivingName),
      callback: function($$v) {
        _vm.$set(_vm.payout, "receivingName", $$v)
      },
      expression: "payout.receivingName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "placeholder": "300",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Include GST 9%"
    },
    model: {
      value: (_vm.payout.chkGST),
      callback: function($$v) {
        _vm.$set(_vm.payout, "chkGST", $$v)
      },
      expression: "payout.chkGST"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "label": "Remarks",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payout, "remarks", $$v)
      },
      expression: "payout.remarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh
    },
    on: {
      "setMedias": _vm.updateInvoices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.$v.payout.$invalid || _vm.loading,
      "text": ""
    },
    on: {
      "click": _vm.savePayout
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    class: ("" + (_vm.isEditMode ? 'no-boxshadow' : '')),
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('div', {
    class: ("" + (_vm.isCreateMode ? 'container container--fluid' : ''))
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "id": "rate-card-form",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    class: ("content xs12 " + (_vm.isCreateMode ? 'md7' : 'md12'))
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-right pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "100px",
      "float": "right"
    },
    attrs: {
      "item-text": "title",
      "item-value": "value",
      "items": _vm.langOptions,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeLang()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('span', {
          class: ("fi " + (item.icon))
        }), _vm._v(" " + _vm._s(item.title))])]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('span', {
          class: ("fi " + (item.icon))
        }), _vm._v(" " + _vm._s(item.title))])]
      }
    }]),
    model: {
      value: (_vm.selectedLang),
      callback: function($$v) {
        _vm.selectedLang = $$v
      },
      expression: "selectedLang"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isCreateMode) ? _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoURL,
      "alt": "KOBE Logo"
    }
  })])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.formConfig.title))])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "px-5 clearfix",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('name')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "textbox",
      "outlined": "",
      "required": "",
      "hide-details": "",
      "error-messages": _vm.$v.rateCardData.name.$error && "Name is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.name.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.name),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "name", $$v)
      },
      expression: "rateCardData.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('email')) + "  "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "email",
      "outlined": "",
      "required": "",
      "hide-details": "",
      "error-messages": _vm.$v.rateCardData.email.$error && "Email is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.rateCardData.email),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "email", $$v)
      },
      expression: "rateCardData.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('dateOfBirth')))]), _vm._v(" "), _c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.rateCardDOB,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.rateCardDOB = $event
      },
      "update:return-value": function($event) {
        _vm.rateCardDOB = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "append-icon": "event",
            "hide-details": "",
            "outlined": "",
            "readonly": ""
          },
          model: {
            value: (_vm.rateCardData.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData, "dateOfBirth", $$v)
            },
            expression: "rateCardData.dateOfBirth"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.DOBDateCal),
      callback: function($$v) {
        _vm.DOBDateCal = $$v
      },
      expression: "DOBDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "id": "rate-card-date-picker",
      "type": "date",
      "max": _vm.minBirthDate,
      "show-current": _vm.minBirthDate
    },
    model: {
      value: (_vm.rateCardData.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "dateOfBirth", $$v)
      },
      expression: "rateCardData.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.DOBDateCal = false
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.changeDate
    }
  }, [_vm._v("\n                            OK\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('ethnicity')))]), _vm._v(" "), _c('v-select', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.ethnicityOptions,
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: (_vm.rateCardData.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "ethnicity", $$v)
      },
      expression: "rateCardData.ethnicity"
    }
  }), _vm._v(" "), (_vm.rateCardData.ethnicity === 'Others') ? _c('v-text-field', {
    staticClass: "pr-1 mt-2",
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.otherEth),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "otherEth", $$v)
      },
      expression: "rateCardData.otherEth"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('country')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.countries,
      "hide-details": "",
      "outlined": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.country.$error && "Country is required."
    },
    on: {
      "change": function($event) {
        return _vm.changeCountry()
      },
      "input": function($event) {
        return _vm.$v.rateCardData.country.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.country),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "country", $$v)
      },
      expression: "rateCardData.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('city')))]), _vm._v(" "), _c('v-combobox', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.citiesByCountry,
      "hide-details": "",
      "outlined": ""
    },
    model: {
      value: (_vm.rateCardData.city),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "city", $$v)
      },
      expression: "rateCardData.city"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('gender')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "purple-input",
    attrs: {
      "items": _vm.genderOptions,
      "type": "textbox",
      "outlined": "",
      "hide-details": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.gender.$error && "Gender is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.gender.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.gender),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "gender", $$v)
      },
      expression: "rateCardData.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('ContactNo')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "12px",
      "padding-left": "15px"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "100px",
      "border-radius": "5px 0 0 5px"
    },
    attrs: {
      "items": _vm.countryCodeOptions,
      "outlined": ""
    },
    model: {
      value: (_vm.countryCode),
      callback: function($$v) {
        _vm.countryCode = $$v
      },
      expression: "countryCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    staticStyle: {
      "border-radius": "0 5px 5px 0"
    },
    attrs: {
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.contactNo),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "contactNo", $$v)
      },
      expression: "rateCardData.contactNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('occupation')))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.occupation),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "occupation", $$v)
      },
      expression: "rateCardData.occupation"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formConfig.sections), function(section, index) {
    return _c('v-col', {
      key: index,
      class: section.class ? section.class : 'xs12 md6',
      style: (section.style || '')
    }, [_c('div', {
      class: [
        'rate-card-platform-section',
        {
          'rate-card-platform-section--common-fees': section.title === 'Common Fees'
        }
      ]
    }, [_c('h3', {
      staticClass: "rate-card-platform-section__title"
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _vm._l((section.fields), function(field, index) {
      return _c('v-col', {
        key: index,
        class: [
          field.class ? field.class : 'xs12 md6',
          {
            'rate-card-single-rate-field': field.type === 'number' && _vm.isStandaloneRateField(field.name)
          }
        ],
        style: (field.style || '')
      }, [(field.label !== '') ? _c('p', {
        class: ("h4 font-weight-bold mb-2 " + (field.labelClass || ''))
      }, [_vm._v("\n                        " + _vm._s(_vm.getLang(field.name)) + " \n                        "), (field.required) ? _c('span', {
        staticClass: "red--text"
      }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (field.type === 'number') ? _c('div', {
        class: [
          'd-flex flex-column',
          {
            'rate-card-single-rate-control': _vm.isStandaloneRateField(field.name)
          }
        ]
      }, [(_vm.isEditMode && field.name === 'igStory') ? _c('div', [_c('p', {
        staticClass: "rate-label-title"
      }, [_vm._v("Ordinary")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-row"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.rateCardData.ordinaryRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.ordinaryRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "rateCardData.ordinaryRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), _c('v-text-field', {
        class: [
          'purple-input',
          {
            'rate-card-single-rate-value': _vm.isStandaloneRateField(field.name)
          }
        ],
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "hide-details": _vm.isStandaloneRateField(field.name),
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData.ordinaryRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.ordinaryRates, field.name, _vm._n($$v))
          },
          expression: "rateCardData.ordinaryRates[field.name]"
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (field.type === 'number' && _vm.isEditMode && !_vm.isStandaloneRateField(field.name)) ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [(field.name === 'igStory') ? _c('div', [_c('p', {
        staticClass: "rate-label-title pl-3"
      }, [_vm._v("Preferential")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-row pl-3"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.rateCardData.preferentialRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.preferentialRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "rateCardData.preferentialRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData.preferentialRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.preferentialRates, field.name, _vm._n($$v))
          },
          expression: "rateCardData.preferentialRates[field.name]"
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'normalNumber') ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "number",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        on: {
          "keypress": _vm.onlyForNumber
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
        attrs: {
          "filled": "",
          "auto-grow": "",
          "hint": field.hint || '',
          "persistent-hint": field.hint ? true : false,
          "placeholder": field.placeholder,
          "required": "",
          "hide-details": "auto"
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('custom-file-upload', {
        attrs: {
          "refresh": _vm.fileUploadRefresh,
          "multiple": true
        },
        on: {
          "setMedias": _vm.updatePricingDecks
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'multiple') ? _c('div', [_vm._l((_vm.rateCardData[field.name]), function(multipleOne, pIndex) {
        return _c('v-list', {
          key: pIndex
        }, [_c('v-list-item', {
          staticClass: "pa-0"
        }, _vm._l((field.options), function(multipleOption, oIndex) {
          return _c('v-list-item-content', {
            key: oIndex,
            style: (multipleOption.style || '')
          }, [(multipleOption.type === 'select') ? _c('v-select', {
            staticClass: "platform-select pr-1",
            style: (multipleOption.style || ''),
            attrs: {
              "items": multipleOption.options,
              "item-value": "value",
              "item-text": "label",
              "hide-details": "",
              "label": multipleOption.label,
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (_vm.rateCardData[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.rateCardData[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "rateCardData[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'textbox') ? _c('v-text-field', {
            staticClass: "px-1 pt-5",
            style: (multipleOption.style || ''),
            attrs: {
              "dense": "",
              "outlined": "",
              "hide-details": "",
              "placeholder": multipleOption.placeholder
            },
            model: {
              value: (_vm.rateCardData[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.rateCardData[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "rateCardData[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'textarea') ? _c('v-textarea', {
            staticClass: "px-1 pt-5",
            style: (multipleOption.style || ''),
            attrs: {
              "rows": "2",
              "dense": "",
              "outlined": "",
              "hide-details": "",
              "placeholder": multipleOption.placeholder
            },
            model: {
              value: (_vm.rateCardData[field.name][pIndex][multipleOption.name]),
              callback: function($$v) {
                _vm.$set(_vm.rateCardData[field.name][pIndex], multipleOption.name, $$v)
              },
              expression: "rateCardData[field.name][pIndex][multipleOption.name]"
            }
          }) : _vm._e(), _vm._v(" "), (multipleOption.type === 'delete') ? _c('v-btn', {
            attrs: {
              "color": "danger",
              "text": "",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                _vm.rateCardData[field.name].splice(pIndex, 1)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "red"
            }
          }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
        }), 1), _vm._v(" "), (_vm.rateCardData[field.name][pIndex][field.child.parentName] === 'others') ? _c('v-list', [_c('v-text-field', {
          staticClass: "pb-2",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.child.placeholder
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex][field.child.name]),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], field.child.name, $$v)
            },
            expression: "rateCardData[field.name][pIndex][field.child.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-row"
        }, [_c('v-select', {
          staticClass: "currency-select-multiple",
          attrs: {
            "items": _vm.currenyOptions,
            "hide-details": "",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.rateCardData.platforms[pIndex].rateCurrency),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData.platforms[pIndex], "rateCurrency", _vm._n($$v))
            },
            expression: "rateCardData.platforms[pIndex].rateCurrency"
          }
        }), _vm._v(" "), _c('v-text-field', {
          staticClass: "px-1 multiple-rate",
          staticStyle: {
            "max-width": "150px",
            "margin-left": "6px"
          },
          attrs: {
            "type": "number",
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": "rate"
          },
          model: {
            value: (_vm.rateCardData.platforms[pIndex].rate),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData.platforms[pIndex], "rate", _vm._n($$v))
            },
            expression: "rateCardData.platforms[pIndex].rate"
          }
        })], 1)], 1)
      }), _vm._v(" "), _c('v-list', {
        staticClass: "float-right"
      }, [_c('v-list-item', {
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            return _vm.addPlatform(field.name)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                            ")], 1)], 1)], 1)], 2) : _vm._e()], 1)
    })], 2)])
  }), _vm._v(" "), _c('v-col', {
    staticClass: "px-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('preferredCampaigns')))]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary white--text",
      "column": "",
      "required": ""
    },
    model: {
      value: (_vm.rateCardData.keywords),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "keywords", $$v)
      },
      expression: "rateCardData.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('bestRepresent')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "required": "",
      "hide-details": "auto",
      "error-messages": _vm.$v.rateCardData.aboutYou.$error && "This field is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.aboutYou.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.aboutYou),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "aboutYou", $$v)
      },
      expression: "rateCardData.aboutYou"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('loadContent')))]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.rateCardData.loadContent),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "loadContent", $$v)
      },
      expression: "rateCardData.loadContent"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "Yes",
      "label": _vm.getLang('yes'),
      "color": "secondary"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "No",
      "label": _vm.getLang('no'),
      "color": "secondary"
    }
  })], 1), _vm._v(" "), (_vm.rateCardData.loadContent === 'No') ? _c('v-text-field', {
    staticClass: "px-2",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.loadContentText),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "loadContentText", $$v)
      },
      expression: "rateCardData.loadContentText"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('giftBrand')))]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.rateCardData.giftBrand),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "giftBrand", $$v)
      },
      expression: "rateCardData.giftBrand"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "Yes",
      "label": _vm.getLang('yes'),
      "color": "secondary"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "No",
      "label": _vm.getLang('noPaidCampaign'),
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 2)], 1), _vm._v(" "), (!_vm.hasStandaloneMediaHandle) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0 px-5 mx-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(_vm._s(_vm.getLang('enterIgTikTok')) + " *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('rate-card-terms-modal', {
    attrs: {
      "value": _vm.showAgreementModal,
      "selectedLang": _vm.selectedLang
    },
    on: {
      "termsAggrement": _vm.confirmSave
    },
    model: {
      value: (_vm.showAgreementModal),
      callback: function($$v) {
        _vm.showAgreementModal = $$v
      },
      expression: "showAgreementModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right mb-1"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-badge', {
          attrs: {
            "value": _vm.messages.length,
            "content": _vm.messages.length,
            "color": "black",
            "overlap": ""
          }
        }, [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": "",
            "small": "",
            "aria-label": _vm.title + ' comments'
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "color": "secondary"
          }
        }, [_vm._v("chat")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "300"
    }
  }, [_c('chatbox', {
    attrs: {
      "messages": _vm.messages,
      "title": _vm.title
    },
    on: {
      "sendMessage": function($event) {
        return _vm.$emit('sendMessage', $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Map the Influencer on behalf\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [(_vm.postData.length) ? _c('p', [_vm._v("\n        Mapping influencer for "), _c('strong', [_vm._v(_vm._s(_vm.postData.length))]), _vm._v(" selected posts.\n      ")]) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Instagram",
      "value": "instagram"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "TikTok",
      "value": "tiktok"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Youtube",
      "value": "youtube"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "LinkedIn",
      "value": "linkedin"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prefix": "@",
      "label": "Handle",
      "block": "",
      "disabled": _vm.isValidating,
      "outlined": ""
    },
    model: {
      value: (_vm.handle),
      callback: function($$v) {
        _vm.handle = $$v
      },
      expression: "handle"
    }
  }), _vm._v(" "), (_vm.postData.length) ? _c('table', {
    staticClass: "post-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Influencer")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Campaign")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.postData), function(item, index) {
    return _c('tr', {
      key: item._id || index
    }, [_c('td', {
      staticClass: "text-xs-justify pa-1"
    }, [(item.author && item.author.tiktokHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author && item.author.youtubeHandle) ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + item.author.youtubeHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author && item.author.linkedinHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + item.author.linkedinHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.author.linkedinHandle))], 1) : (item.author && item.author.instagramHandle) ? _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + item.author.instagramHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(item.campaignName || '-'))])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveMappedInfluencer()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "drafts-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          on: {
            "click": function($event) {
              return _vm.openCampaignModal(item.campaignID)
            }
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.reviewMeetingDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.reviewMeetingDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.reviewMeetingDate || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/campaign-report-internal?id=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(item.submittedInfs || 0) + " / " + _vm._s(item.pairingInfs || 0) + "\n          ")])])]
      }
    }, {
      key: "item.submissionDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('span', [_vm._v(_vm._s(item.submissionDate ? _vm.formatDate(item.submissionDate) : ''))])])]
      }
    }, {
      key: "item.reviewDeck",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : '')),
          staticStyle: {
            "min-width": "100px"
          }
        }, [(item.reviewDeckURL) ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "btn-view-review-deck",
          attrs: {
            "href": item.reviewDeckURL,
            "target": "_blank",
            "color": "warning",
            "small": "",
            "text": ""
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "x-small": "",
            "left": ""
          }
        }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('span', [_vm._v("View Review Deck")])], 1) : _c('v-btn', _vm._g(_vm._b({
          staticClass: "btn-view-review-deck",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openReviewDeckDialog(item)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n            Add Review Deck\n          ")])], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : '')),
          staticStyle: {
            "min-width": "100px"
          }
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Close Campaign",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.campaignID)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("power_settings_new")])], 1)], 1)]
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('review-deck-url-modal', {
    attrs: {
      "value": _vm.reviewDeckURLDialog,
      "item": _vm.reviewDeckItem,
      "dateCol": _vm.reviewDeckCol
    },
    on: {
      "saveClicked": _vm.saveReviewDeckURL
    },
    model: {
      value: (_vm.reviewDeckURLDialog),
      callback: function($$v) {
        _vm.reviewDeckURLDialog = $$v
      },
      expression: "reviewDeckURLDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "persistent": "",
      "scrollable": "",
      "width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Edit Content Script for @" + _vm._s(_vm.item ? _vm.item.userHandle : '') + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.restoreTemplate
    }
  }, [_vm._v("Load Default")])], 1)], 1)], 1), _vm._v(" "), _c('sun-editor', {
    staticStyle: {
      "height": "650px"
    },
    attrs: {
      "content": _vm.editContent
    },
    on: {
      "contentChanged": _vm.changeContent
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": !_vm.editContent
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8",
      "lg": "8"
    }
  }, [_c('duration-stage', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.DURATION.title,
      "items": _vm.DURATION.items,
      "total": _vm.DURATION.total,
      "filters": _vm.filtersItem
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#3F3FFF",
      "title": _vm.ACTIVATION.title,
      "previews": _vm.ACTIVATION.previews,
      "detail": _vm.ACTIVATION.detail,
      "fields": _vm.ACTIVATION.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.ACTIVATION.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#009688",
      "title": _vm.PAIRING.title,
      "previews": _vm.PAIRING.previews,
      "detail": _vm.PAIRING.detail,
      "fields": _vm.PAIRING.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.PAIRING.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#F44336",
      "title": _vm.CREATING.title,
      "previews": _vm.CREATING.previews,
      "detail": _vm.CREATING.detail,
      "fields": _vm.CREATING.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.CREATING.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('campaigns-activities', {
    attrs: {
      "theme": "#5F8CDC",
      "title": _vm.COMPLETE.title,
      "previews": _vm.COMPLETE.previews,
      "detail": _vm.COMPLETE.detail,
      "fields": _vm.COMPLETE.fieldsSet,
      "filters": _vm.filterUser,
      "filterCampaigns": _vm.filterCampaigns,
      "type": _vm.COMPLETE.type
    },
    on: {
      "searchFilter": _vm.filterSearch
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": !_vm.disablePersistent,
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-card-text', {
    staticClass: "loading-dialog-text"
  }, [_vm._v("\n      " + _vm._s(_vm.text || 'Please stand by') + "\n      "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "secondary"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.company != null) ? _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.name.$error
    }
  }, [_c('label', [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter company name"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }, function($event) {
        return _vm.$v.company.name.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.name.required && _vm.$v.company.name.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Company name is required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.address.$error
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.address),
      expression: "company.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter address"
    },
    domProps: {
      "value": (_vm.company.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "address", $event.target.value)
      }, function($event) {
        return _vm.$v.company.address.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.address.required && _vm.$v.company.address.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Address is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.website.$error
    }
  }, [_c('label', [_vm._v("Website")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.website),
      expression: "company.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ..."
    },
    domProps: {
      "value": (_vm.company.website)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "website", $event.target.value)
      }, function($event) {
        return _vm.$v.company.website.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.company.website.required && _vm.$v.company.website.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Website is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.company.phoneNumber.$error
    }
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.phoneNumber),
      expression: "company.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ..."
    },
    domProps: {
      "value": (_vm.company.phoneNumber)
    },
    on: {
      "blur": function($event) {
        return _vm.$v.company.phoneNumber.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.$v.company.phoneNumber.required && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number is required\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.phoneNumber.numeric && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number must be a number\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.phoneNumber.minLength && _vm.$v.company.phoneNumber.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Phone number must have at least 8 digits\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCompany
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Edit company\n        ")])])
}]}

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-row', {
    staticClass: "row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": 'video/*|image/*',
      "listMedia": _vm.media
    },
    on: {
      "change": _vm.mediaChanged
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "fullscreen": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-2"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Audience Data")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.influencer == null || !_vm.influencer.success) ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "color": "rgba(0,0,0,.38)"
    }
  }, [_vm._v("Empty data")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text ml-0",
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.refreshReport
    }
  }, [_vm._v("\n                  Refresh\n                  "), _c('v-icon', {
    attrs: {
      "float-right": "",
      "dark": ""
    }
  }, [_vm._v("refresh")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.influencer != null && _vm.influencer.success) ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.influencer && _vm.influencer.success) ? _c('div', [_c('h5', [_vm._v("Created: " + _vm._s(_vm.influencer ? _vm.reportCreatedAt : ''))]), _vm._v(" "), _c('h5', [_vm._v("Version: " + _vm._s(_vm.influencer ? _vm.influencer.version : ''))])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text ml-0",
    attrs: {
      "color": "blue-grey"
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_vm._v("\n                    Download\n                    "), _c('v-icon', {
    attrs: {
      "float-right": "",
      "dark": ""
    }
  }, [_vm._v("save_alt")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('center', {
    staticClass: "m-t-30"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.paserImageUrl(_vm.influencerProfile.picture),
      "width": "150"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title m-t-10"
  }, [_vm._v(_vm._s(_vm.influencerProfile.fullname))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.influencerProfile.url,
      "target": "_blank"
    }
  }, [_c('h3', [_vm._v("@" + _vm._s(_vm.influencerProfile.username))])]), _vm._v(" "), (_vm.influencerProfile.is_business) ? _c('h4', {
    staticClass: "card-subtitle"
  }, [_vm._v("Business Account")]) : _vm._e(), _vm._v(" "), (!_vm.influencerProfile.is_business) ? _c('h6', {
    staticClass: "card-subtitle"
  }, [_vm._v("Personal Account")]) : _vm._e()])], 1)])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card border p-1"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('p', {
    staticClass: "card-title",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Followers")]), _vm._v(" "), _c('span', {
    staticClass: "card-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.influencerProfile.followers))]), _vm._v(" "), (_vm.followingStat) ? _c('span', {
    class: 'text stat-label ng-star-inserted ' + 'stat-label--' + _vm.followingStat.type,
    attrs: {
      "_ngcontent-c16": ""
    }
  }, [_c('span', {
    attrs: {
      "_ngcontent-c16": ""
    }
  }, [_vm._v(_vm._s(_vm.followingStat.rate) + "%")])]) : _vm._e()])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card border p-1"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('p', {
    staticClass: "card-title mb-0",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('h2', {
    staticClass: "card-title mt-0"
  }, [_vm._v(_vm._s(_vm.audienceFollowers.audience_geo.countries ? (_vm.audienceFollowers.audience_geo.countries.length ? _vm.audienceFollowers.audience_geo.countries[0].name : '---') : '---'))])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card border p-1"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.influencerProfile.engagements) + "\n                    "), _c('small', [_vm._v("engagements")])])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.influencerProfile.avg_likes) + "\n                    "), _c('small', [_vm._v("Avg Likes")])])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.influencerProfile.avg_comments) + "\n                    "), _c('small', [_vm._v("Avg Comments")])])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.datacollection
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.avgLikes
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.followingData
    }
  })], 1)])])], 1), _vm._v(" "), _c('v-row', [(_vm.wordCloud && _vm.wordCloud.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center",
    staticStyle: {
      "height": "350px"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Social Cloud")]), _vm._v(" "), _c('vue-word-cloud', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "v-show": true,
      "words": _vm.wordCloud,
      "color": function (ref) { return _vm.getRandomColor(); },
      "font-family": "Roboto"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Popular @")]), _vm._v(" "), _vm._l((_vm.influencerProfile.top_mentions.slice(0, 10)), function(mention) {
    return _c('v-chip', {
      key: mention.tag,
      attrs: {
        "color": "#eff4fa",
        "text-color": "#4a4a4a"
      }
    }, [_vm._v("@" + _vm._s(mention.tag))])
  })], 2)])]), _vm._v(" "), _c('v-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Popular #")]), _vm._v(" "), _vm._l((_vm.influencerProfile.top_hashtags.slice(0, 10)), function(hashtag) {
    return _c('v-chip', {
      key: hashtag.tag,
      attrs: {
        "color": "#eff4fa",
        "text-color": "#4a4a4a"
      }
    }, [_vm._v("#" + _vm._s(hashtag.tag))])
  })], 2)])])], 1)], 1), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [_c('v-col', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Audience Data")])])], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Followers Credibility")]), _vm._v(" "), _c('h3', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.getCredibilityColor(_vm.audienceFollowers.audience_credibility)
    }
  }, [_vm._v("supervised_user_circle")])], 1)])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Notable Followers")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.toPercent(_vm.audienceFollowers.notable_users_ratio)) + "%")])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Age Split")]), _vm._v(" "), _c('bar-chart', {
    attrs: {
      "options": _vm.barChartOptions,
      "chart-data": _vm.audienceFollowersGenderPerAge
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Gender Split")]), _vm._v(" "), _c('circle-chart', {
    attrs: {
      "chart-data": _vm.audienceFollowersGender
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('div', [_c('bar-chart-js', {
    attrs: {
      "name": "audBarChart",
      "chartData": _vm.audienceReachabilityData,
      "options": _vm.audChartOptions
    }
  })], 1)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [(_vm.audienceFollowers.audience_geo && _vm.audienceFollowers.audience_geo.countries.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Location by Country")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_geo.countries.slice(0, 3)), function(country) {
    return _c('div', {
      key: country.code
    }, [_c('h5', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("\n                      " + _vm._s(country.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((country.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "value": country.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_ethnicities.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Ethnicity")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_ethnicities.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.code
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "show-progress": "",
        "animated": "",
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_languages.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Language")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_languages.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.code
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [(_vm.audienceFollowers.audience_brand_affinity.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Audience Brand Affinity")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_brand_affinity.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.name
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_interests.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Audience Interests")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_interests.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.name
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "show-progress": "",
        "animated": "",
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.notable_users.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Notable Followers")]), _vm._v(" "), _c('ul', {
    staticClass: "products-list product-list-in-box"
  }, _vm._l((_vm.audienceFollowers.notable_users.slice(0, 4)), function(item) {
    return _c('li', {
      key: item.username,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.paserImageUrl(item.picture),
        "alt": "Avatar"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('a', {
      staticClass: "product-title",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v("@" + _vm._s(item.username))]), _vm._v(" "), _c('span', {
      staticClass: "product-description"
    }, [_vm._v(_vm._s(item.fullname))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_geo && _vm.audienceFollowers.audience_geo.countries.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Location by Country")]), _vm._v(" "), _c('div', [_c('v-simple-table', {
    staticClass: "aud-location-table no-border",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Followers")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.audienceFollowers.audience_geo.countries), function(country) {
          return _c('tr', {
            key: country.code
          }, [_c('td', {
            staticClass: "text-left pl-0"
          }, [_c('h5', {
            staticStyle: {
              "font-weight": "600"
            }
          }, [_vm._v("\n                                " + _vm._s(country.name) + "\n                              ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s((country.weight * 100).toFixed(2)) + "%")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 437158719)
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_interests && _vm.audienceFollowers.audience_interests.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Audience Interest Affinity")]), _vm._v(" "), _c('div', [_c('v-simple-table', {
    staticClass: "aud-location-table no-border",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Interest")]), _vm._v(" "), _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Followers")]), _vm._v(" "), _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Followers affinity")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.audienceFollowers.audience_interests.slice(0, 15)), function(brand) {
          return _c('tr', {
            key: brand.code
          }, [_c('td', {
            staticClass: "text-left pl-0"
          }, [_c('h5', {
            staticStyle: {
              "font-weight": "600"
            }
          }, [_vm._v("\n                                " + _vm._s(brand.name) + "\n                              ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s((brand.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s((brand.affinity * 100).toFixed(2)) + "%")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3036307875)
  })], 1)])])]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("Release Brief Checklist")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2 ims-modal-body",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Please check and confirm these steps below")]), _vm._v(" "), _c('ol', {
    staticClass: "text-left body-1"
  }, [_c('li', [_vm._v("The brief uses clear language to lead and guide stakeholders' interpretation.")]), _vm._v(" "), _c('li', [_vm._v("The brief is aligned with audience-first approach.")]), _vm._v(" "), _c('li', [_vm._v("The brief is aligned with content best practices.")])])])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', [_vm._v("Last update: " + _vm._s(_vm.updatedOn))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getAllClients(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])], 1)]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Clients\n            "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.website))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phoneNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [(!_vm.isAlreadyAssigned(item)) ? _c('v-btn', {
            attrs: {
              "color": "secondary",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.assignClient(item, true)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-plus"
          })]) : _c('v-btn', {
            attrs: {
              "color": "danger",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.assignClient(item, false)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-minus"
          })])], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Assign client to ad strategist")])])
}]}

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    on: {
      "click:outside": function($event) {
        return _vm.$emit('close')
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline grey darken-3 d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-h6"
  }, [_vm._v("Post Comments (" + _vm._s(_vm.comments.length) + ")")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [(_vm.comments && _vm.comments.length > 0) ? _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "450px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Commenter")]), _vm._v(" "), _c('th', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px"
          }
        }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Comment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.comments), function(comment, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [(comment.comment_user_url) ? _c('a', {
            attrs: {
              "href": comment.comment_user_url,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(comment.comment_user))]) : _c('span', [_vm._v("@" + _vm._s(comment.comment_user))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormat")(comment.comment_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comment.comment))])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3263868770)
  }) : _c('div', {
    staticClass: "text-center pa-5"
  }, [_vm._v("\n        No comments found for this post.\n      ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "content-class": "loading-dialog"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [(_vm.isStatus) ? _c('div', {
    staticClass: "float-right"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.processing))]), _vm._v(" / "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.complete))])]) : _vm._e(), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.color,
      "height": "10",
      "value": _vm.percent,
      "striped": ""
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(!_vm.tenant) ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "color": "indigo"
    },
    on: {
      "click": _vm.connect
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-up-circle-outline")]), _vm._v("Connect Xero\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.tenant) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-checkbox-marked-circle")])], 1), _vm._v("Connected\n    ")], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-card-title', [_vm._v(_vm._s(_vm.tenant.tenantName))]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
    staticClass: "ma-0 pa-0"
  }, [_vm._v(_vm._s(_vm.tenant.tenantType))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0"
  }, [_vm._v(_vm._s(_vm.tenant.tenantId))])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.syncXeroResource('Contacts')
      }
    }
  }, [_vm._v("Sync Contacts")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.syncXeroResource('Invoices')
      }
    }
  }, [_vm._v("Sync Invoices")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.syncXeroResource('Quotes')
      }
    }
  }, [_vm._v("Sync Quotes")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1000"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [(_vm.isRemark) ? _c('v-card-title', {
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("CC Remarks for @" + _vm._s(_vm.handle))])]) : _c('v-card-title', {
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Campaign Lists for @" + _vm._s(_vm.handle))]), _vm._v(" "), (_vm.emptyCampaigns) ? _c('span', {
    staticStyle: {
      "color": "grey",
      "font-size": "12px"
    }
  }, [_vm._v("(" + _vm._s(_vm.emptyCampaigns) + ") Campaigns Not Found")]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "campaign-lists-table elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.items,
      "items-per-page": 10,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "item.pairingDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "100px"
          }
        }, [_vm._v("\n                  " + _vm._s(item.pairingDate) + "\n                ")])])]
      }
    }, {
      key: "item.isArchive",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.archive) ? _c('span', [_vm._v("YES")]) : _c('span', [_vm._v("NO")])])])]
      }
    }, {
      key: "item.deliverables",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(_vm.campaignHelper.getDeliverableDetails(item.deliverables)) + "\n                ")])])]
      }
    }, {
      key: "item.payout",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  $ " + _vm._s(_vm._f("thousandSeprator")(item.payout)) + "\n                ")])])]
      }
    }, {
      key: "item.ccRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "color": "black",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.ccRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.ccRemarks))
          }
        })])], 1)])]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "#3F3FFF"
    }
  }, [_c('v-toolbar-title', [_vm._v("All Posts Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v("\n        (" + _vm._s(_vm.totalCount) + ") Total\n      ")], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": "",
      "color": "background-white"
    }
  }, _vm._l((_vm.summaryList), function(item, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.changeRoute(item)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(item.aIcon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.value))]), _vm._v("\n              " + _vm._s(item.value >= 2 ? 'Posts' : 'Post') + "\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value1,
      "max-width": "800"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input1')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n        Search result for keysearch:   \n        "), _c('strong', [_vm._v(_vm._s(_vm.keysearch))])]), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 5,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item, index) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_c('a', {
            attrs: {
              "href": 'https://www.instagram.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalFollowers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.audienceCredibility) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.relevancyScore))]), _vm._v(" "), _c('td', [(!item.isSelected) ? _c('v-btn', {
            attrs: {
              "color": "secondary",
              "fab": "",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.selectInfluencer(item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (item.isSelected) ? _c('v-btn', {
            attrs: {
              "color": "red",
              "fab": "",
              "x-small": "",
              "dark": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deselectInfluencer(item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("clear")])], 1) : _vm._e()], 1)])
        }), 0)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "white--text direct-file-upload-btn",
    class: {
      'direct-file-upload-btn--icon-only': _vm.iconOnly
    },
    attrs: {
      "small": "",
      "depressed": "",
      "color": "secondary",
      "aria-label": _vm.iconOnly ? 'Upload files' : null,
      "title": _vm.iconOnly ? 'Upload files' : null
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [(!_vm.iconOnly) ? _c('span', [_vm._v(_vm._s(_vm.title ? _vm.title : 'Browse'))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": "",
      "right": !_vm.iconOnly,
      "dark": ""
    }
  }, [_vm._v("\n      mdi-folder-open-outline\n    ")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx",
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Reset Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage && _vm.errorMessage !== null),
      expression: "errorMessage && errorMessage !== null"
    }],
    staticClass: "col-md-12"
  }, [_c('b-alert', {
    attrs: {
      "dismissible": "",
      "variant": "danger"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])])], 1), _vm._v(" "), _c('form', [_c('v-container', {
    staticClass: "remove-padding",
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Generate a strong password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-space-between"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "500",
      "padding-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.generatedPass))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyPass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.generatePass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-reload")])], 1)], 1)]), _vm._v(" "), _c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Set Password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    staticClass: "input-group--focused mt-0 pt-0",
    attrs: {
      "error-messages": _vm.passwordError,
      "type": "text",
      "autocomplete": "new-password",
      "name": "new-password",
      "color": "#1687c0",
      "label": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.password = !_vm.show.password
      }
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1)])], 1)], 1)], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "disabled": _vm.$v.user.$invalid
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-pass"
    },
    domProps: {
      "value": _vm.generatedPass
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Enter Custom Percent\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "placeholder": "Percent",
      "outlined": "",
      "error-messages": _vm.$v.updateData.amount.$error && !_vm.isAdmins ? "Amount is required." : ''
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.amount.$touch()
      }
    },
    model: {
      value: (_vm.updateData.amount),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "amount", $$v)
      },
      expression: "updateData.amount"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": _vm.saveCustomAmount
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Lemon8 Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "lemon-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                    " + _vm._s(group.groupName || group.groupID) + "\n                  ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "item-key": "key",
      "items-per-page": -1,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                            mdi-arrow-all\n                          ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                              mdi-reload\n                            ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": 'https://lemon8-app.com/' + item.name,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.name))])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                      ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n                      ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n                      ")]
      }
    }, {
      key: "item.like_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(_vm._f("thousandSeprator")(item.like_count === 0 ? '-' : item.like_count)) + "\n                      ")]
      }
    }, {
      key: "item.comment_count",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(_vm._f("thousandSeprator")(item.comment_count === 0 ? '-' : item.comment_count)) + "\n                      ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                      ")]
      }
    }, {
      key: "item.bookmarks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                        " + _vm._s(_vm._f("thousandSeprator")(item.bookmarks === 0 ? '-' : item.bookmarks)) + "\n                      ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews === 0 ? '-' : _vm.totalViews)))] : (header.value === 'watches') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalWatches == 0 ? '-' : _vm.totalWatches)))] : (header.value === 'like_count') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'bookmarks') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalBookmarks === 0 ? '-' : _vm.totalBookmarks)))] : (header.value === 'comment_count') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Lemon8 Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatelemonAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Update Status")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Total Influencers: " + _vm._s(_vm.payments.length))]), _vm._v(" "), _vm._l((_vm.currencyTotals), function(item, index) {
          return _c('span', {
            key: index
          }, [(item) ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("Total "), (index === 'SGD') ? _c('span', [_vm._v("Amount in ")]) : _vm._e(), _vm._v(" " + _vm._s(index) + ": " + _vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))]) : _vm._e()])
        })], 2)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-form', {
    ref: "paymentForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.showField('PVNumber')) ? _c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "PV Number",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.PVNumber),
      callback: function($$v) {
        _vm.$set(_vm.data, "PVNumber", $$v)
      },
      expression: "data.PVNumber"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showField('bankReference')) ? _c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Bank Reference",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.bank_reference),
      callback: function($$v) {
        _vm.$set(_vm.data, "bank_reference", $$v)
      },
      expression: "data.bank_reference"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showField('paymentDate')) ? _c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Payment Date (DD/MM/YYYY)",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.payment_date),
      callback: function($$v) {
        _vm.$set(_vm.data, "payment_date", $$v)
      },
      expression: "data.payment_date"
    }
  }, _vm.on)) : _vm._e(), _vm._v(" "), (_vm.showField('submissionDate')) ? _c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Submission Date (DD/MM/YYYY)",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.payment_submission_date),
      callback: function($$v) {
        _vm.$set(_vm.data, "payment_submission_date", $$v)
      },
      expression: "data.payment_submission_date"
    }
  }, _vm.on)) : _vm._e(), _vm._v(" "), (_vm.showField('batch')) ? _c('v-select', {
    attrs: {
      "items": _vm.batches,
      "label": "Select Batch",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.batch),
      callback: function($$v) {
        _vm.$set(_vm.data, "batch", $$v)
      },
      expression: "data.batch"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showField('paymentStatus')) ? _c('v-select', {
    attrs: {
      "items": _vm.showStatuses,
      "item-value": "status",
      "item-text": "display",
      "label": "Payment Status",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    on: {
      "change": function($event) {
        return _vm.changeStatus()
      }
    },
    model: {
      value: (_vm.data.payment_status),
      callback: function($$v) {
        _vm.$set(_vm.data, "payment_status", $$v)
      },
      expression: "data.payment_status"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showField('actualAmount')) ? _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Handle")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Actual Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments), function(item) {
          return _c('tr', {
            key: item.title
          }, [_c('td', [_c('div', [_vm._v(_vm._s(item.instagram))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(item.amount))])]), _vm._v(" "), _c('td', [(item.currency !== 'SGD') ? _c('v-text-field', {
            attrs: {
              "label": "Amount",
              "type": "number",
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "hide-details": "auto"
            },
            model: {
              value: (item.actualAmount),
              callback: function($$v) {
                _vm.$set(item, "actualAmount", $$v)
              },
              expression: "item.actualAmount"
            }
          }) : _vm._e()], 1)])
        }), 0)]
      },
      proxy: true
    }], null, false, 2559575621)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Upcoming Activation")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "dashboard-activation-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "items-per-page": 5,
      "search": _vm.selectedFilter.search
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n          " + _vm._s(item.name || '') + "\n        ")])]
      }
    }, {
      key: "item.IONumber",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.IONumber || '') + "\n        ")])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])])]
      }
    }, {
      key: "item.quoteAcceptanceDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_c('span', [_vm._v(_vm._s(item.quoteAcceptanceDate ? _vm.formatDate(item.quoteAcceptanceDate) : ''))])])]
      }
    }, {
      key: "item.activationDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center pt-2 pb-2"
        }, [_c('div', {
          staticClass: "d-flex flex-row",
          staticStyle: {
            "justify-content": "center"
          }
        }, [_c('v-text-field', {
          staticClass: "edit-date-box",
          attrs: {
            "placeholder": "Activation Date",
            "outlined": "",
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": function($event) {
              return _vm.checkDate(item, 'activationDate', 'validActivationDate', null)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.checkDate(item, 'activationDate', 'validActivationDate', true)
            }
          },
          model: {
            value: (item.activationDate),
            callback: function($$v) {
              _vm.$set(item, "activationDate", $$v)
            },
            expression: "item.activationDate"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "date-picker-inner"
        }, [_c('date-picker', {
          attrs: {
            "className": "input-field",
            "options": {
              theme: 'icon',
              confirm: true
            },
            "status": item.actDateCal
          },
          on: {
            "changeDate": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.setDateFromPicker.apply(void 0, [ item, 'activationDate' ].concat( argsArray ))
            }
          }
        })], 1)], 1), _vm._v(" "), (item.validActivationDate === false) ? _c('div', [_c('span', {
          staticClass: "text-danger ma-0 pt-1"
        }, [_vm._v("Invalid Start Date")])]) : _vm._e()])]
      }
    }], null, true)
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-col', [_c('v-sheet', {
    attrs: {
      "height": "64"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.setToday
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.next
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "outlined": ""
          }
        }, on), [_c('span', [_vm._v(_vm._s(_vm.typeToLabel[_vm.type]))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-menu-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.type = 'day'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Day")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.type = 'week'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Week")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.type = 'month'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Month")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-sheet', {
    attrs: {
      "height": "600"
    }
  }, [_c('v-calendar', {
    ref: "calendar",
    style: ({
      maxHeight: '1000px',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }),
    attrs: {
      "color": "primary",
      "events": _vm.events,
      "event-color": _vm.getEventColor,
      "event-margin-bottom": 3,
      "now": _vm.today,
      "type": _vm.type
    },
    on: {
      "click:event": _vm.showEvent,
      "click:more": _vm.viewDay,
      "click:date": _vm.viewDay,
      "change": _vm.updateRange
    },
    model: {
      value: (_vm.focus),
      callback: function($$v) {
        _vm.focus = $$v
      },
      expression: "focus"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "activator": _vm.selectedElement,
      "offset-x": "",
      "min-width": "350px",
      "max-width": "350px"
    },
    model: {
      value: (_vm.selectedOpen),
      callback: function($$v) {
        _vm.selectedOpen = $$v
      },
      expression: "selectedOpen"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "grey lighten-4",
      "min-width": "350px",
      "max-width": "350px",
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": _vm.selectedEvent.color,
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedEvent.name)
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Campaign : "), _c('strong', [_vm._v(_vm._s(_vm.selectedEvent.campaignName))])]), _vm._v(" "), (_vm.selectedEvent.influencer) ? _c('p', [_vm._v("Influencer :\n                "), _vm._v(" "), _c('social-handle', {
    attrs: {
      "divClassName": "d-inline",
      "isInstagram": _vm.selectedEvent.platform === 'instagram' || !_vm.selectedEvent.platform,
      "isTikTok": _vm.selectedEvent.platform === 'tiktok',
      "isYoutube": _vm.selectedEvent.platform === 'youtube',
      "isFacebook": _vm.selectedEvent.platform === 'facebook',
      "isXiaohongshu": _vm.selectedEvent.platform === 'xiaohongshu',
      "instagramHandle": _vm.selectedEvent.influencer,
      "tiktokHandle": _vm.selectedEvent.influencer,
      "youtubeHandle": _vm.selectedEvent.influencer,
      "facebookHandle": _vm.selectedEvent.influencer,
      "xiaohongshuHandle": _vm.selectedEvent.influencer,
      "xiaohongshuFullName": _vm.selectedEvent.influencer
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Live Date : "), _c('strong', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.selectedEvent.liveDate)))])]), _vm._v(" "), _c('p', [_vm._v("Last Stats Submission Date : "), _c('strong', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.selectedEvent.end)))])]), _vm._v(" "), (_vm.selectedEvent.postLinks && _vm.selectedEvent.postLinks.length) ? _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('p', [_vm._v("Post Links : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, _vm._l((_vm.selectedEvent.postLinks), function(item, idx) {
    return _c('div', {
      key: idx
    }, [_c('a', {
      attrs: {
        "href": item,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedOpen = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selectedEvent.stats) ? _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "color": "secondary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewStatsLink(_vm.selectedEvent)
      }
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('span', [_vm._v("View Stats")])]) : _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "color": "secondary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyFormLink(_vm.selectedEvent)
      }
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Stats Submission")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": false,
      "saleActions": false,
      "clientActions": false,
      "influencerActions": false,
      "cs_inf_chatbox": false,
      "postAbuseHistory": false,
      "postReviewApproved": false,
      "postHistory": false,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n      Copied to Clipboard!\n      "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.formLink
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("AM / CC Inputs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.campaign) ? _c('v-card-text', {
    staticClass: "body-2 ims-modal-body",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [(_vm.campaign.AMInputs) ? _c('div', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("AM Inputs")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Please provide an overview of this campaign brief, include pointers to note for your stakeholders to support in getting the brief approved, ie past conversations with client")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "readonly": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaign.AMInputs.remarks),
      callback: function($$v) {
        _vm.$set(_vm.campaign.AMInputs, "remarks", $$v)
      },
      expression: "campaign.AMInputs.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-text-field', _vm._g({
    attrs: {
      "append-icon": "event",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: (_vm.campaign.AMInputs.deadline),
      callback: function($$v) {
        _vm.$set(_vm.campaign.AMInputs, "deadline", $$v)
      },
      expression: "campaign.AMInputs.deadline"
    }
  }, _vm.on))], 1)]) : _vm._e(), _vm._v(" "), (_vm.campaign.CCInputs) ? _c('div', [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("CC Inputs")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Please schedule a call with your respective AM to finalise the brief and provide a summary on the following next steps:"), _c('br'), _vm._v("What are you getting out of this campaign brief and type of rejections/challenges or stucks you foresee from the creators")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "readonly": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaign.CCInputs.remarks),
      callback: function($$v) {
        _vm.$set(_vm.campaign.CCInputs, "remarks", $$v)
      },
      expression: "campaign.CCInputs.remarks"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Deadline")]), _vm._v(" "), _c('v-text-field', _vm._g({
    attrs: {
      "append-icon": "event",
      "outlined": "",
      "readonly": ""
    },
    model: {
      value: (_vm.campaign.CCInputs.deadline),
      callback: function($$v) {
        _vm.$set(_vm.campaign.CCInputs, "deadline", $$v)
      },
      expression: "campaign.CCInputs.deadline"
    }
  }, _vm.on))], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isSuperAdmin && _vm.source === 'release') ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.proceedBrief()
      }
    }
  }, [_vm._v("Proceed with brief")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedString)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.text.length > _vm.maxChars),
      expression: "text.length > maxChars"
    }]
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadMore),
      expression: "!isReadMore"
    }],
    attrs: {
      "href": _vm.link,
      "id": "readmore"
    },
    on: {
      "click": function($event) {
        return _vm.triggerReadMore($event, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.moreStr))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReadMore),
      expression: "isReadMore"
    }],
    attrs: {
      "href": _vm.link,
      "id": "readmore"
    },
    on: {
      "click": function($event) {
        return _vm.triggerReadMore($event, false)
      }
    }
  }, [_vm._v(_vm._s(_vm.lessStr))])])])
},staticRenderFns: []}

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": 220
          }
        }, [_c('v-card-title', {
          staticClass: "headline pb-1"
        }, [_vm._v(_vm._s(_vm.summary.title))]), _vm._v(" "), _c('v-divider', {
          staticClass: "ma-0 pa-0"
        }), _vm._v(" "), _c('v-card-subtitle', [_c('div', {
          staticClass: "pa-0 ma-0 body-1 white--text"
        }, [_c('div', {
          staticClass: "d-flex flex-row justify-space-between"
        }, [_c('div', [_vm._v("Projected :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.summary.projected))])])]), _vm._v(" "), _c('div', {
          staticClass: "pa-0 ma-0 body-1 white--text"
        }, [_c('div', {
          staticClass: "d-flex flex-row justify-space-between"
        }, [_c('div', [_vm._v("Actual :")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.summary.actual))])])]), _vm._v(" "), _c('div', {
          staticClass: "pl-1"
        }, _vm._l((_vm.summary.actualTasks), function(task, index) {
          return _c('div', {
            key: index,
            staticClass: "pa-0 ma-0"
          }, [_c('div', {
            staticClass: "d-flex flex-row justify-space-between"
          }, [_c('div', [_vm._v(_vm._s(task.title) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(task.value))])])])
        }), 0)])], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [(_vm.currentUserRole === _vm.userRoles.INFLUENCER) ? _c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Campaign",
      "placeholder": "Campaign Name",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignName", $$v)
      },
      expression: "filter.campaignName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentUserRole === _vm.userRoles.CLIENT) ? _c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Instagram",
      "placeholder": "Instagram Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "instagramHandle", $$v)
      },
      expression: "filter.instagramHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && _vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clients,
      "outlined": true,
      "label": "Client",
      "placeholder": "Select Client"
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Filter")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openViewPostLayout()
      }
    }
  }, [_vm._v("View All")])], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.showPostLayout) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.groupedPosts.length === 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('p', [_vm._v("No record found!")])])]) : _vm._e(), _vm._v(" "), _c('v-expansion-panels', _vm._l((_vm.groupedPosts), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('p', {
      staticClass: "ma-0 title",
      staticStyle: {
        "color": "#3F3FFF"
      }
    }, [_vm._v(_vm._s(item._id.campaignName))]), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "max-width": "120px"
      },
      attrs: {
        "color": "purple",
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
        }
      }
    }, [_vm._v("View Posts")])], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "3",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2)),
            attrs: {
              "max-width": "250"
            }
          }, [_c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
              }
            }
          }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "color": "purple",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
              }
            }
          }, [_vm._v("View All Posts")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
        }
      }], null, true)
    })], 1), _vm._v(" "), _vm._l((item.influencers), function(inf, j) {
      return _c('v-col', {
        key: j,
        attrs: {
          "cols": "12",
          "md": "4",
          "lg": "3",
          "sm": "12"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [(inf.owner) ? _c('v-card', {
              staticClass: "mx-auto",
              attrs: {
                "max-width": "250",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [(inf.owner.tiktokHandle) ? _c('a', {
              attrs: {
                "href": 'https://www.tiktok.com/@' + inf.owner.tiktokHandle,
                "target": "_blank"
              }
            }, [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(inf.owner.tiktokHandle))]) : (inf.owner.youtubeHandle) ? _c('a', {
              attrs: {
                "href": 'https://youtube.com/' + inf.owner.youtubeHandle,
                "target": "_blank"
              }
            }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(inf.owner.youtubeHandle))], 1) : _c('a', {
              attrs: {
                "href": 'https://instagram.com/' + inf.owner.instagramHandle,
                "target": "_blank"
              }
            }, [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(inf.owner.instagramHandle))], 1)]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(inf.noOfPosts) + " " + _vm._s(inf.noOfPosts > 1 ? 'Posts' : 'Post'))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "color": "purple",
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, inf.owner)
                }
              }
            }, [_vm._v("View Posts")]), _vm._v(" "), _c('v-spacer')], 1)], 1) : _vm._e()]
          }
        }], null, true)
      })], 1)
    })], 2)], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPostLayout) ? _c('v-container', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "tile": "",
      "outlined": ""
    },
    on: {
      "click": _vm.closeViewPostLayout
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "align": "right"
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "left": "",
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }], null, false, 159256613)
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }], null, false, 207488929)
  }, [_vm._v(" "), _c('span', [_vm._v("Grid View")])])], 1)], 1)], 1), _vm._v(" "), (_vm.display === 1) ? _c('v-row', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [(_vm.posts.length === 0) ? _c('v-flex', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('p', [_vm._v("No record found!")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "4",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2))
          }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
            staticClass: "subtitle-1 ma-0"
          }, [_vm._v(_vm._s(post.campaignName))]), _vm._v(" "), _c('v-list-item-subtitle', {
            staticClass: "caption font-italic"
          }, [_vm._v("\n                      By\n                      "), (post.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + post.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(post.author.tiktokHandle))]) : (post.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + post.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(post.author.youtubeHandle))], 1) : (post.author.xhsHandle) ? _c('a', {
            on: {
              "click": function($event) {
                return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + post.author.xhsHandle)
              }
            }
          }, [_vm._v(_vm._s(post.author.xhsHandle))]) : (post.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + post.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(post.author.linkedinHandle))], 1) : (post.type === 'twitter' || post.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + _vm.getTwitterHandle(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(_vm.getTwitterHandle(post)))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + post.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(post.author.instagramHandle))], 1)])], 1)], 1), _vm._v(" "), (!post.images[0]) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && !post.images[0].publicID) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": post.images[0].url,
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticClass: "post-cld-img cursor-pointer",
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {})
            }
          })], 1) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && !post.images[0].publicID) ? _c('video', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "height": "194px",
              "width": "100%"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('source', {
            attrs: {
              "src": post.images[0].url,
              "type": "video/mp4"
            }
          }), _vm._v("Your browser does not support the video tag.\n                ")]) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticStyle: {
              "max-height": "200px",
              "overflow": "hidden"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {
                videoPreview: true
              })
            }
          })], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [(post.type !== 'post/carousel' && post.vdoLink) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            staticStyle: {
              "margin-top": "5px !important"
            },
            attrs: {
              "outlined": "",
              "color": "indigo",
              "target": "_blank",
              "href": post.vdoLink,
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-link")]), _vm._v("\n                        Video Link\n                      ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_vm._l((post.labels), function(label) {
            return _c('v-chip', {
              key: label.text,
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, post)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                    ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(label.text) + "\n                    "), (label.icon) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))]) : _vm._e()], 1)
          }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
            attrs: {
              "bottom": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "icon": ""
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return (_vm.showAvailableMenu(post, menuItem.action)) ? _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, post)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1) : _vm._e()
          }), 1)], 1)], 2)], 1)
        }
      }], null, true)
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.display === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "secondary"
          }
        }, on), [_vm._v("Bulk Action")])]
      }
    }], null, false, 1812722738)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.tableActions), function(menuItem, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "disabled": menuItem.disabled
      },
      on: {
        "click": function($event) {
          return _vm.performSelected(menuItem.action)
        }
      }
    }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "item-key": "_id",
      "show-select": true,
      "server-items-length": _vm.totalItems,
      "options": _vm.pagging,
      "headers": _vm.headers,
      "items": _vm.posts,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPage
      }
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item._id
          }, [_c('td', [_c('v-checkbox', {
            attrs: {
              "checked": false,
              "value": item,
              "primary": "",
              "hide-details": ""
            },
            model: {
              value: (_vm.selected),
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.campaignName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-justify pa-1"
          }, [(item.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + item.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.author.linkedinHandle))], 1) : (item.type === 'twitter' || item.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + _vm.getTwitterHandle(item),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(_vm.getTwitterHandle(item)))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._l((item.labels), function(label) {
            return _c('div', {
              key: label.text
            }, [_c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, item)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                          ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(label.text) + "\n                          "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))])], 1)], 1)
          }), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && item.postURL) ? _c('div', [_c('v-btn', {
            attrs: {
              "rounded": "",
              "small": "",
              "color": "#F58529",
              "href": item.postURL,
              "target": "_blink"
            }
          }, [_vm._v("\n                          View on\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-instagram")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm.formatDate(item.createdAt, 'LLL')))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('v-menu', {
            attrs: {
              "bottom": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({}, on), [_vm._v("\n                            Actions\n                            "), _c('v-icon', {
                  attrs: {
                    "right": ""
                  }
                }, [_vm._v("mdi-menu")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return (_vm.showAvailableMenu(item, menuItem.action)) ? _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, item)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1) : _vm._e()
          }), 1)], 1)], 1)])
        }), 0)]
      }
    }], null, false, 1620014219),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "client_inf_chatbox": _vm.show_client_inf_chatbox,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "postReviewApproved": _vm.showPostReviewApproved,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('edit-post-modal', {
    attrs: {
      "post": _vm.editPostData,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "value": _vm.editPostDialog,
      "userObj": _vm.user
    },
    on: {
      "postUpdated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.editPostDialog),
      callback: function($$v) {
        _vm.editPostDialog = $$v
      },
      expression: "editPostDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-modal', {
    attrs: {
      "post": _vm.assignCampaignPostData
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignDialog),
      callback: function($$v) {
        _vm.assignCampaignDialog = $$v
      },
      expression: "assignCampaignDialog"
    }
  }), _vm._v(" "), _c('map-influencer-modal', {
    attrs: {
      "post": _vm.mapInfluencerPostData
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.influencerMapSuccess($event)
      }
    },
    model: {
      value: (_vm.mapInfluencerDialog),
      callback: function($$v) {
        _vm.mapInfluencerDialog = $$v
      },
      expression: "mapInfluencerDialog"
    }
  }), _vm._v(" "), _c('submission-review-multiple-modal', {
    attrs: {
      "posts": _vm.selected,
      "internalApprove": false
    },
    on: {
      "successBulkApprove": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.submissionReviewMultipleDialog),
      callback: function($$v) {
        _vm.submissionReviewMultipleDialog = $$v
      },
      expression: "submissionReviewMultipleDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataForAddPost,
      "postID": _vm.postIdToUpdate
    },
    on: {
      "done": _vm.postAdded
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('change-post-status-modal', {
    attrs: {
      "post": _vm.postDataForChangeStatus
    },
    on: {
      "updated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('client-choose-date-modal', {
    attrs: {
      "post": _vm.viewChooseDatePost,
      "ChooseDateDialogValue": _vm.chooseDateDialog
    },
    on: {
      "chooseDateClosed": _vm.closeChooseDateModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('timeline-summary-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Follow Up")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progressBar),
      expression: "progressBar"
    }],
    attrs: {
      "indeterminate": "",
      "color": "green"
    }
  }), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "From",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "To",
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Subject",
      "rules": _vm.subjectRules,
      "required": ""
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "counter": "",
      "label": "Message",
      "rules": _vm.MessageRules,
      "rows": "8",
      "row-height": "30"
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-minus-circle")]), _vm._v("Cancel\n                ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-send")]), _vm._v("Send\n                ")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-5 pt-5 pr-5",
          staticStyle: {
            "max-width": "215px"
          },
          attrs: {
            "placeholder": "From",
            "append-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          on: {
            "click:clear": function($event) {
              _vm.dateFilter.startDate = null
            }
          },
          model: {
            value: (_vm.dateFilter.startDate),
            callback: function($$v) {
              _vm.$set(_vm.dateFilter, "startDate", $$v)
            },
            expression: "dateFilter.startDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.startCal),
      callback: function($$v) {
        _vm.startCal = $$v
      },
      expression: "startCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.startCal = false
      }
    },
    model: {
      value: (_vm.dateFilter.startDate),
      callback: function($$v) {
        _vm.$set(_vm.dateFilter, "startDate", $$v)
      },
      expression: "dateFilter.startDate"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-5 pt-5 pr-5",
          staticStyle: {
            "max-width": "215px"
          },
          attrs: {
            "placeholder": "To",
            "append-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          on: {
            "click:clear": function($event) {
              _vm.dateFilter.endDate = null
            }
          },
          model: {
            value: (_vm.dateFilter.endDate),
            callback: function($$v) {
              _vm.$set(_vm.dateFilter, "endDate", $$v)
            },
            expression: "dateFilter.endDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.endCal),
      callback: function($$v) {
        _vm.endCal = $$v
      },
      expression: "endCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.endCal = false
      }
    },
    model: {
      value: (_vm.dateFilter.endDate),
      callback: function($$v) {
        _vm.$set(_vm.dateFilter, "endDate", $$v)
      },
      expression: "dateFilter.endDate"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "btn-search",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-chevron",
    attrs: {
      "text": "",
      "disabled": _vm.disableLeftArrow
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeMonth', 'previous')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v("mdi-chevron-left-circle")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-chevron",
    attrs: {
      "text": "",
      "disabled": _vm.disableRightArrow
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeMonth', 'next')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v("mdi-chevron-right-circle")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "table-calendar elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "item.poc",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n        " + _vm._s(item.poc) + "\n      ")])]
      }
    }, {
      key: "item.bfs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.bfs) ? _c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "to": '/client/brand-fact-sheet?id=' + item.bfs,
            "target": '_blank'
          }
        }, [_vm._v("\n          View BFS\n        ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])]
      }
    }, _vm._l((_vm.calendarMonths), function(month) {
      return {
        key: ("item." + month),
        fn: function(ref) {
          var item = ref.item;

          return [(item[month] || item[month] === 0) ? _c('td', {
            staticClass: "text-center",
            style: (("background-color:" + (item.bgColor) + ";opacity:0.8"))
          }, [_c('div', {
            staticClass: "text-inside"
          }, [_vm._v(_vm._s(item[month]))])]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n        " + _vm._s(item[month]) + "\n      ")])]
        }
      }
    })], null, true)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1250",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("\n          Paired influencers for campaign:\n          "), _c('strong', [_vm._v(_vm._s(_vm.campaignCOEB.campaignName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), (_vm.measurement.totalPercentage && _vm.measurement.totalPercentage !== 'NaN' && _vm.measurement.totalPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), (_vm.measurement.outreachPercentage && _vm.measurement.outreachPercentage !== 'NaN' && _vm.measurement.outreachPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), (_vm.measurement.engagementPercentage && _vm.measurement.engagementPercentage !== 'NaN' && _vm.measurement.engagementPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [(_vm.budget) ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : 0")]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), (_vm.measurement.cogsPercentage && _vm.measurement.cogsPercentage !== 'NaN' && _vm.measurement.cogsPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }], null, false, 2495958124)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-select', {
    staticClass: "input-field pt-3",
    attrs: {
      "items": _vm.payoutStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "label": "Payout Status",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.pairingSearchFilter
    },
    model: {
      value: (_vm.pairedFilter.payoutStatus),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "payoutStatus", $$v)
      },
      expression: "pairedFilter.payoutStatus"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.pairedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "search", $$v)
      },
      expression: "pairedFilter.search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.pairedHeaders,
      "items": _vm.pairedFilterItems,
      "items-per-page": 10,
      "search": _vm.pairedFilter.search,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.instagramHandle,
            class: {
              'yellow lighten-4': item.payoutSubmitted
            }
          }, [_c('td', [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.instagramHandle,
              "instagramHandle": item.instagramHandle,
              "youtubeHandle": item.instagramHandle,
              "facebookHandle": item.instagramHandle,
              "otherHandle": item.instagramHandle
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.followers))])]), _vm._v(" "), _c('td', [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")])]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                      " + _vm._s(item.audience_credibility) + "\n                    ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.deliverables))]), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": _vm.payoutStatusColor(item.payoutStatus),
              "outlined": "",
              "small": ""
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.payoutStatusDisplay[item.payoutStatus || 0]) + "\n                        "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', {
            staticClass: "text-right"
          }, [_vm._v("$ " + _vm._s(item.payoutAmount))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-center paired-actions-cell"
          }, [_c('div', {
            staticClass: "paired-actions"
          }, [(_vm.buttonShow('editPayout')) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "secondary",
                    "aria-label": "Edit payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openConfirmPayoutDialog(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-pencil")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Edit payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus !== _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "primary",
                    "aria-label": "Confirm payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.updateSend(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-check")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Confirm payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus === _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "error",
                    "aria-label": "Cancel payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.cancelPayout(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-cancel")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Cancel payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonPayoutViewShow(item)) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn ims-btn-third",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "aria-label": "View payouts"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.linkPayoutInternal(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-eye")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View payouts")])]) : _vm._e()], 1)])])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('payout-confirm-modal', {
    attrs: {
      "value": _vm.payoutConfirmDialog,
      "data": _vm.payoutConfirmData,
      "influencer": _vm.influencer
    },
    on: {
      "confirmedPayout": _vm.setConfirmedPayout
    },
    model: {
      value: (_vm.payoutConfirmDialog),
      callback: function($$v) {
        _vm.payoutConfirmDialog = $$v
      },
      expression: "payoutConfirmDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-toast', {
    attrs: {
      "id": "kobe-toast",
      "variant": _vm.toastVariant,
      "solid": ""
    },
    scopedSlots: _vm._u([{
      key: "toast-title",
      fn: function() {
        return [_c('div', {
          staticClass: "d-flex flex-grow-1 align-items-baseline"
        }, [_c('strong', {
          staticClass: "mr-auto"
        }, [_vm._v(_vm._s(_vm.toastHeader))])])]
      },
      proxy: true
    }])
  }, [_vm._v("\n  " + _vm._s(_vm.toastContent) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Campaign Brief")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "campaign-brief-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.timeline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || ''))])])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          on: {
            "click": function($event) {
              return _vm.openCampaignModal(item.campaignID)
            }
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/campaigns/pending_approval?campaignID=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.getDashboardStatusDisplay(item.status)) + "\n          ")])])]
      }
    }, {
      key: "item.AMDeadline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.AMDeadline ? _vm.formatDate(item.AMDeadline) : '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.AMDeadline ? _vm.formatDate(item.AMDeadline) : ''))])])]
      }
    }], null, true)
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "legacy-workspace"
  }, [_c('core-drawer', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "toggleDrawer": _vm.toggleDrawer
    }
  }), _vm._v(" "), _c('core-toolbar', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "openDrawer": _vm.openDrawer
    }
  }), _vm._v(" "), _c('v-main', [(_vm.containerView) ? _c('div', {
    staticClass: "container-fluid pb-3"
  }, [_c('router-view')], 1) : _c('router-view')], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Post Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    attrs: {
      "id": "post-analysis-summary"
    }
  }, [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "item-key": "key",
      "items-per-page": 15,
      "page": _vm.page
    },
    on: {
      "update:page": function($event) {
        _vm.page = $event
      },
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v("@" + _vm._s(item.profileHandle || item.name))])], 1)]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                        View\n                      ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n                  ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n                  ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.shares === 0 ? '-' : item.shares) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.views === 0 ? '-' : item.views) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.new_engagement_rate === 0 ? '0' : item.new_engagement_rate) + " %\n                    ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.new_engagement_rate_view === 0 ? '0' : item.new_engagement_rate_view) + " %\n                    ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.engagement_rate_reach === 0 ? '0' : item.engagement_rate_reach) + " %\n                    ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n                      " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n                    ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.median_engagement_rate === null ? '-' : item.median_engagement_rate + '%') + "\n                  ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null ? '-' : item.avg_likes)) + "\n                  ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null ? '-' : item.avg_comments)) + "\n                  ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'url') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'comments') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'saved') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalSaved === 0 ? '-' : _vm.totalSaved)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm.totalEngagementRate === 0 ? '-' : _vm.totalEngagementRate) + " %")] : (header.value === 'engagement_rate_reach') ? [_vm._v(_vm._s(_vm.totalEngagementRateReach === 0 ? '-' : _vm.totalEngagementRateReach) + " %")] : (header.value === 'engagement_rate_sd') ? [_vm._v("-")] : (header.value === 'median_engagement_rate') ? [_vm._v("-")] : (header.value === 'avg_likes') ? [_vm._v("-")] : (header.value === 'avg_comments') ? [_vm._v("-")] : (header.value === 'avg_views') ? [_vm._v("-")] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Post Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatePostAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.downloadProfitSummaryRpt
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-menu', {
    ref: "startDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "250px",
            "max-width": "250px"
          },
          attrs: {
            "label": "Start Date",
            "placeholder": "Start Date",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateCal),
      callback: function($$v) {
        _vm.startDateCal = $$v
      },
      expression: "startDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }, [_c('v-spacer')], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "date-divider"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('v-menu', {
    ref: "endDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-3",
          staticStyle: {
            "min-width": "250px",
            "max-width": "250px"
          },
          attrs: {
            "label": "End Date",
            "placeholder": "End Date",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateCal),
      callback: function($$v) {
        _vm.endDateCal = $$v
      },
      expression: "endDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }, [_c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "pt-0",
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.getProfitSumary
    }
  }, [_vm._v("Apply")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row mt-3",
    staticStyle: {
      "justify-content": "space-between",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Profit Summary for " + _vm._s(_vm.currentMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.currentMthProfit)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "sm8": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Profit Summary " + _vm._s(_vm.showFilterDate))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.profit)))])])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-row', [_c('v-col', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.filterQuaters), function(quater, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-2"
    }, [_c('v-btn', _vm._g(_vm._b({
      attrs: {
        "color": quater.selected ? 'warning' : 'default',
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeQuater(quater.value)
        }
      }
    }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n            " + _vm._s(quater.label) + "\n          ")])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('v-data-table', {
    ref: "ProfitSummaryTable",
    staticClass: "profit-summary-table elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "items-per-page": 15
    },
    on: {
      "current-items": _vm.getFiltered
    },
    scopedSlots: _vm._u([_vm._l((_vm.headers), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h,
              "iconColor": "#fb8c00"
            }
          })]
        }
      }
    }), {
      key: "item.createdAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.createdAt) ? _c('span', [_vm._v(_vm._s(_vm.formatDateTime(item.createdAt)))]) : _vm._e()])]
      }
    }, {
      key: "item.IONumber",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.IONumber) ? _c('span', [_vm._v(_vm._s(item.IONumber))]) : _vm._e()])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.budget) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))]) : _vm._e()])]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.amount) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e()])]
      }
    }, {
      key: "item.cogsTotal",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.cogsTotal) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsTotal)))]) : _vm._e()])]
      }
    }, {
      key: "item.targetCOGS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.targetCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.targetCOGS)))]) : _vm._e()])]
      }
    }, {
      key: "item.actualCOGS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.actualCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.actualCOGS)))]) : _vm._e()])]
      }
    }, {
      key: "item.savingCOGS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.savingCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.savingCOGS)) + " " + _vm._s(item.savingPercent ? ("(" + (item.savingPercent) + "%)") : ''))]) : _vm._e()])]
      }
    }, {
      key: "item.grossProfit",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.grossProfit) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.grossProfit)))]) : _vm._e()])]
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "600"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("\n          Add contents to  "), _c('strong', [_vm._v(_vm._s(_vm.campaignData ? _vm.campaignData.name : ''))]), _vm._v(" \n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-select', {
    staticClass: "mt-5 pt-5",
    attrs: {
      "items": _vm.postTypes,
      "item-text": "title",
      "item-value": "name",
      "label": "Content Type",
      "filled": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changeContentType
    },
    model: {
      value: (_vm.postType),
      callback: function($$v) {
        _vm.postType = $$v
      },
      expression: "postType"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panels', {
    staticClass: "mt-5",
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [(_vm.showPanel === 'story') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Story Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding story insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle,
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName
          }
        })]
      }
    }], null, false, 1795247707),
    model: {
      value: (_vm.storyIgHandle),
      callback: function($$v) {
        _vm.storyIgHandle = $$v
      },
      expression: "storyIgHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle,
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName
          }
        })]
      }
    }], null, false, 1795247707),
    model: {
      value: (_vm.storyIgHandle),
      callback: function($$v) {
        _vm.storyIgHandle = $$v
      },
      expression: "storyIgHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.storyCountry),
      callback: function($$v) {
        _vm.storyCountry = $$v
      },
      expression: "storyCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Story Media URL"
    },
    model: {
      value: (_vm.storyMediaUrl),
      callback: function($$v) {
        _vm.storyMediaUrl = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "storyMediaUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.storyLiveDate),
            callback: function($$v) {
              _vm.storyLiveDate = $$v
            },
            expression: "storyLiveDate"
          }
        }, on))]
      }
    }], null, false, 2503307858),
    model: {
      value: (_vm.storyLiveCal),
      callback: function($$v) {
        _vm.storyLiveCal = $$v
      },
      expression: "storyLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.storyLiveCal = false
      }
    },
    model: {
      value: (_vm.storyLiveDate),
      callback: function($$v) {
        _vm.storyLiveDate = $$v
      },
      expression: "storyLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.storyIgHandle, 'story')
      }
    }
  }, [_vm._v("\n                      Upload Stats with AI\n                    ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "reach", _vm._n($$v))
      },
      expression: "storyInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "impressions", _vm._n($$v))
      },
      expression: "storyInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Story Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.story_likes),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "story_likes", _vm._n($$v))
      },
      expression: "storyInsights.story_likes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Replies",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.replies),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "replies", _vm._n($$v))
      },
      expression: "storyInsights.replies"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "shares", _vm._n($$v))
      },
      expression: "storyInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Link Clicks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.link_clicks),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "link_clicks", _vm._n($$v))
      },
      expression: "storyInsights.link_clicks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sticker Taps",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsights.sticker_taps),
      callback: function($$v) {
        _vm.$set(_vm.storyInsights, "sticker_taps", _vm._n($$v))
      },
      expression: "storyInsights.sticker_taps"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addStoryInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Post Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding post insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                            " + _vm._s(item.fullName) + "\n                          ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                            " + _vm._s(item.instagramHandle) + "\n                          ")]) : _c('span', [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 3631065275),
    model: {
      value: (_vm.postIgHandle),
      callback: function($$v) {
        _vm.postIgHandle = $$v
      },
      expression: "postIgHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                            " + _vm._s(item.fullName) + "\n                          ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                            " + _vm._s(item.instagramHandle) + "\n                          ")]) : _c('span', [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 3631065275),
    model: {
      value: (_vm.postIgHandle),
      callback: function($$v) {
        _vm.postIgHandle = $$v
      },
      expression: "postIgHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.postCountry),
      callback: function($$v) {
        _vm.postCountry = $$v
      },
      expression: "postCountry"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postURL),
      callback: function($$v) {
        _vm.postURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post Image URL",
      "placeholder": "Optional"
    },
    model: {
      value: (_vm.postImageURL),
      callback: function($$v) {
        _vm.postImageURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "postImageURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.postLiveDate),
            callback: function($$v) {
              _vm.postLiveDate = $$v
            },
            expression: "postLiveDate"
          }
        }, on))]
      }
    }], null, false, 1035117641),
    model: {
      value: (_vm.postLiveCal),
      callback: function($$v) {
        _vm.postLiveCal = $$v
      },
      expression: "postLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.postLiveCal = false
      }
    },
    model: {
      value: (_vm.postLiveDate),
      callback: function($$v) {
        _vm.postLiveDate = $$v
      },
      expression: "postLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.postIgHandle, 'post')
      }
    }
  }, [_vm._v("\n                      Upload Stats with AI\n                    ")])], 1)], 1), _vm._v(" "), (_vm.postType === 'IGP' || _vm.postType === 'IGC') ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "inputtedInsights.impressions"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "inputtedInsights.shares"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "inputtedInsights.saved"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.postType === 'IGR') ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "views", _vm._n($$v))
      },
      expression: "inputtedInsights.views"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "inputtedInsights.saved"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "inputtedInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.reposts),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "reposts", _vm._n($$v))
      },
      expression: "inputtedInsights.reposts"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Watch Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "d",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.day),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "day", $$v)
      },
      expression: "reelTotalPlayTime.day"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "hour", $$v)
      },
      expression: "reelTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "minute", $$v)
      },
      expression: "reelTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "second", $$v)
      },
      expression: "reelTotalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.inputtedInsights, "watches", $$v)
      },
      expression: "inputtedInsights.watches"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addPostInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'tiktok') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using TikTok URL")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is semi-customised way of adding Tiktok insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.tikTokHandle),
      callback: function($$v) {
        _vm.tikTokHandle = $$v
      },
      expression: "tikTokHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": _vm.getAccountOptionValue,
      "hide-details": "auto",
      "return-object": "",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.tikTokHandle),
      callback: function($$v) {
        _vm.tikTokHandle = $$v
      },
      expression: "tikTokHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tiktokCountry),
      callback: function($$v) {
        _vm.tiktokCountry = $$v
      },
      expression: "tiktokCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.tikTokPostURL),
      callback: function($$v) {
        _vm.tikTokPostURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "tikTokPostURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.tiktokLiveDate),
            callback: function($$v) {
              _vm.tiktokLiveDate = $$v
            },
            expression: "tiktokLiveDate"
          }
        }, on))]
      }
    }], null, false, 4237074295),
    model: {
      value: (_vm.tiktokLiveCal),
      callback: function($$v) {
        _vm.tiktokLiveCal = $$v
      },
      expression: "tiktokLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.tiktokLiveCal = false
      }
    },
    model: {
      value: (_vm.tiktokLiveDate),
      callback: function($$v) {
        _vm.tiktokLiveDate = $$v
      },
      expression: "tiktokLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.tikTokHandle, 'tiktok')
      }
    }
  }, [_vm._v("\n                      Upload Stats with AI\n                    ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "hour", $$v)
      },
      expression: "totalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "minute", $$v)
      },
      expression: "totalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "second", $$v)
      },
      expression: "totalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "watches", $$v)
      },
      expression: "tikTokInputtedInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "like_count", _vm._n($$v))
      },
      expression: "tikTokInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "comment_count", _vm._n($$v))
      },
      expression: "tikTokInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "shares", _vm._n($$v))
      },
      expression: "tikTokInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Favourites (Bookmarks)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "saved", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInsights, "views", _vm._n($$v))
      },
      expression: "tikTokInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Total viewers (Reach)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "reach", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Watched full video (%)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.watchedFullVideo),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "watchedFullVideo", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.watchedFullVideo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Photo Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.tikTokInputtedInsights.photo_views),
      callback: function($$v) {
        _vm.$set(_vm.tikTokInputtedInsights, "photo_views", _vm._n($$v))
      },
      expression: "tikTokInputtedInsights.photo_views"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addTikTokInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'youtube') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using Youtube URL")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding Youtube insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.youtubeHandle),
      callback: function($$v) {
        _vm.youtubeHandle = $$v
      },
      expression: "youtubeHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.youtubeHandle),
      callback: function($$v) {
        _vm.youtubeHandle = $$v
      },
      expression: "youtubeHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.youtubeCountry),
      callback: function($$v) {
        _vm.youtubeCountry = $$v
      },
      expression: "youtubeCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Youtube Video URL"
    },
    model: {
      value: (_vm.youtubeURL),
      callback: function($$v) {
        _vm.youtubeURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "youtubeURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.youtubeLiveDate),
            callback: function($$v) {
              _vm.youtubeLiveDate = $$v
            },
            expression: "youtubeLiveDate"
          }
        }, on))]
      }
    }], null, false, 3381681204),
    model: {
      value: (_vm.youtubeLiveCal),
      callback: function($$v) {
        _vm.youtubeLiveCal = $$v
      },
      expression: "youtubeLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.youtubeLiveCal = false
      }
    },
    model: {
      value: (_vm.youtubeLiveDate),
      callback: function($$v) {
        _vm.youtubeLiveDate = $$v
      },
      expression: "youtubeLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInsights, "like_count", _vm._n($$v))
      },
      expression: "youtubeInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInsights, "comment_count", _vm._n($$v))
      },
      expression: "youtubeInsights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInsights, "views", _vm._n($$v))
      },
      expression: "youtubeInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "youtubeInputtedInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Unique Viewers",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInputtedInsights.unique_viewers),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInputtedInsights, "unique_viewers", _vm._n($$v))
      },
      expression: "youtubeInputtedInsights.unique_viewers"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.youtubeInputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.youtubeInputtedInsights, "watches", _vm._n($$v))
      },
      expression: "youtubeInputtedInsights.watches"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addYoutubeInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'Others' || _vm.showPanel === 'LinkedIn Post' || _vm.showPanel === 'X (Twitter) Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using " + _vm._s(_vm.showPanel === 'LinkedIn Post' ? 'LinkedIn' : (_vm.showPanel === 'X (Twitter) Post' ? 'X (Twitter)' : 'Others')) + " URL")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is a customised way of adding " + _vm._s(_vm.showPanel === 'LinkedIn Post' ? 'LinkedIn' : (_vm.showPanel === 'X (Twitter) Post' ? 'X (Twitter)' : 'other platform')) + " insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.otherInfluencers,
      "item-text": "displayHandle",
      "item-value": "displayHandle",
      "return-object": "",
      "loading": _vm.pairedInfluencersLoading,
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.displayHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.displayHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "twitterHandle": item.twitterHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 489606698),
    model: {
      value: (_vm.otherHandle),
      callback: function($$v) {
        _vm.otherHandle = $$v
      },
      expression: "otherHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.otherInfluencers,
      "item-text": "displayHandle",
      "item-value": "displayHandle",
      "return-object": "",
      "loading": _vm.pairedInfluencersLoading,
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.displayHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.displayHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "twitterHandle": item.twitterHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 489606698),
    model: {
      value: (_vm.otherHandle),
      callback: function($$v) {
        _vm.otherHandle = $$v
      },
      expression: "otherHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.otherCountry),
      callback: function($$v) {
        _vm.otherCountry = $$v
      },
      expression: "otherCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.otherPostURL),
      callback: function($$v) {
        _vm.otherPostURL = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "otherPostURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.otherMediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.otherLiveDate),
            callback: function($$v) {
              _vm.otherLiveDate = $$v
            },
            expression: "otherLiveDate"
          }
        }, on))]
      }
    }], null, false, 3894645781),
    model: {
      value: (_vm.otherLiveCal),
      callback: function($$v) {
        _vm.otherLiveCal = $$v
      },
      expression: "otherLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.otherLiveCal = false
      }
    },
    model: {
      value: (_vm.otherLiveDate),
      callback: function($$v) {
        _vm.otherLiveDate = $$v
      },
      expression: "otherLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "hour", $$v)
      },
      expression: "otherTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "minute", $$v)
      },
      expression: "otherTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "second", $$v)
      },
      expression: "otherTotalPlayTime.second"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "watches", $$v)
      },
      expression: "otherInsights.watches"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Discovery")])]) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post' || _vm.showPanel === 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "impressions", _vm._n($$v))
      },
      expression: "otherInsights.impressions"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Members reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "reach", _vm._n($$v))
      },
      expression: "otherInsights.reach"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Video Performance")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Video views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.video_views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "video_views", _vm._n($$v))
      },
      expression: "otherInsights.video_views"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Profile Activity")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Profile viewers from this post",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.profile_viewers),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "profile_viewers", _vm._n($$v))
      },
      expression: "otherInsights.profile_viewers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'LinkedIn Post') ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Engagement")])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'LinkedIn Post' ? 'Reactions' : 'Likes',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "like_count", _vm._n($$v))
      },
      expression: "otherInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'X (Twitter) Post' ? 'Replies' : 'Comments',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'LinkedIn Post' || _vm.showPanel === 'X (Twitter) Post' ? 'Reposts' : 'Shares',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "shares", _vm._n($$v))
      },
      expression: "otherInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'LinkedIn Post' ? 'Saves' : (_vm.showPanel === 'X (Twitter) Post' ? 'Bookmarks' : 'Favourites (Bookmarks)'),
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "saved", _vm._n($$v))
      },
      expression: "otherInsights.saved"
    }
  })], 1), _vm._v(" "), (_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.showPanel === 'X (Twitter) Post' ? 'Views' : 'Plays (Views)',
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "views", _vm._n($$v))
      },
      expression: "otherInsights.views"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel !== 'LinkedIn Post' && _vm.showPanel !== 'X (Twitter) Post') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Total viewers (Reach)",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.otherInsights, "reach", _vm._n($$v))
      },
      expression: "otherInsights.reach"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addOtherInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'Facebook Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Facebook Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding facebook insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.fbHandle),
      callback: function($$v) {
        _vm.fbHandle = $$v
      },
      expression: "fbHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.fbHandle),
      callback: function($$v) {
        _vm.fbHandle = $$v
      },
      expression: "fbHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.fbCountry),
      callback: function($$v) {
        _vm.fbCountry = $$v
      },
      expression: "fbCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Facebook Media URL"
    },
    model: {
      value: (_vm.fbMediaUrl),
      callback: function($$v) {
        _vm.fbMediaUrl = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "fbMediaUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.fbLiveDate),
            callback: function($$v) {
              _vm.fbLiveDate = $$v
            },
            expression: "fbLiveDate"
          }
        }, on))]
      }
    }], null, false, 2923034869),
    model: {
      value: (_vm.fbLiveCal),
      callback: function($$v) {
        _vm.fbLiveCal = $$v
      },
      expression: "fbLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.fbLiveCal = false
      }
    },
    model: {
      value: (_vm.fbLiveDate),
      callback: function($$v) {
        _vm.fbLiveDate = $$v
      },
      expression: "fbLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Outreach",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.outreach),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "outreach", _vm._n($$v))
      },
      expression: "fbInsights.outreach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "like_count", _vm._n($$v))
      },
      expression: "fbInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "comment_count", _vm._n($$v))
      },
      expression: "fbInsights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "views", _vm._n($$v))
      },
      expression: "fbInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "shares", _vm._n($$v))
      },
      expression: "fbInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bookmarks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbInsights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.fbInsights, "bookmarks", _vm._n($$v))
      },
      expression: "fbInsights.bookmarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addFbInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'XHS Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add XHS Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding XHS insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.xhsHandle),
      callback: function($$v) {
        _vm.xhsHandle = $$v
      },
      expression: "xhsHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.xhsHandle),
      callback: function($$v) {
        _vm.xhsHandle = $$v
      },
      expression: "xhsHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.xhsCountry),
      callback: function($$v) {
        _vm.xhsCountry = $$v
      },
      expression: "xhsCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "XHS Link"
    },
    model: {
      value: (_vm.xhsLink),
      callback: function($$v) {
        _vm.xhsLink = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "xhsLink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.xhsMediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.xhsLiveDate),
            callback: function($$v) {
              _vm.xhsLiveDate = $$v
            },
            expression: "xhsLiveDate"
          }
        }, on))]
      }
    }], null, false, 2295750034),
    model: {
      value: (_vm.xhsLiveCal),
      callback: function($$v) {
        _vm.xhsLiveCal = $$v
      },
      expression: "xhsLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.xhsLiveCal = false
      }
    },
    model: {
      value: (_vm.xhsLiveDate),
      callback: function($$v) {
        _vm.xhsLiveDate = $$v
      },
      expression: "xhsLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.xhsFollowers),
      callback: function($$v) {
        _vm.xhsFollowers = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "xhsFollowers"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "views", _vm._n($$v))
      },
      expression: "xhsInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "watches", $$v)
      },
      expression: "xhsInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "like_count", _vm._n($$v))
      },
      expression: "xhsInsights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "bookmarks", _vm._n($$v))
      },
      expression: "xhsInsights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "comment_count", _vm._n($$v))
      },
      expression: "xhsInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.xhsInsights, "shares", _vm._n($$v))
      },
      expression: "xhsInsights.shares"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addXHSInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'Lemon Post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Lemon8 Insights Manually")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is customised way of adding XHS insights.")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'lemon8') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 952534873),
    model: {
      value: (_vm.lemonHandle),
      callback: function($$v) {
        _vm.lemonHandle = $$v
      },
      expression: "lemonHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'lemon8') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 952534873),
    model: {
      value: (_vm.lemonHandle),
      callback: function($$v) {
        _vm.lemonHandle = $$v
      },
      expression: "lemonHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lemonCountry),
      callback: function($$v) {
        _vm.lemonCountry = $$v
      },
      expression: "lemonCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Lemon8 Link"
    },
    model: {
      value: (_vm.lemonLink),
      callback: function($$v) {
        _vm.lemonLink = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "lemonLink"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.lemonMediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.lemonLiveDate),
            callback: function($$v) {
              _vm.lemonLiveDate = $$v
            },
            expression: "lemonLiveDate"
          }
        }, on))]
      }
    }], null, false, 3797069012),
    model: {
      value: (_vm.lemonLiveCal),
      callback: function($$v) {
        _vm.lemonLiveCal = $$v
      },
      expression: "lemonLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.lemonLiveCal = false
      }
    },
    model: {
      value: (_vm.lemonLiveDate),
      callback: function($$v) {
        _vm.lemonLiveDate = $$v
      },
      expression: "lemonLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.lemonFollowers),
      callback: function($$v) {
        _vm.lemonFollowers = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "lemonFollowers"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "views", _vm._n($$v))
      },
      expression: "lemonInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "watches", $$v)
      },
      expression: "lemonInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "like_count", _vm._n($$v))
      },
      expression: "lemonInsights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "bookmarks", _vm._n($$v))
      },
      expression: "lemonInsights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "comment_count", _vm._n($$v))
      },
      expression: "lemonInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.lemonInsights, "shares", _vm._n($$v))
      },
      expression: "lemonInsights.shares"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addLemonInsightsManually()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'story') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add Multiple Contents")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is to upload multiple contents without full insights data. (Can update the insights after uploaded)")]), _c('br'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-1",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [(_vm.campaignData.campaignType === _vm.campaignTypes.AOK) ? _c('v-combobox', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.multipleIgHandle),
      callback: function($$v) {
        _vm.multipleIgHandle = $$v
      },
      expression: "multipleIgHandle"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "instagramHandle",
      "item-value": "instagramHandle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.platform === 'xiaohongshu') ? _c('span', [_vm._v("\n                          " + _vm._s(item.fullName) + "\n                        ")]) : (item.instagramHandle) ? _c('span', [_vm._v("\n                          " + _vm._s(item.instagramHandle) + "\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.linkedinHandle || item.instagramHandle,
            "xiaohongshuHandle": item.fullName,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        })]
      }
    }], null, false, 2946995003),
    model: {
      value: (_vm.multipleIgHandle),
      callback: function($$v) {
        _vm.multipleIgHandle = $$v
      },
      expression: "multipleIgHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: (_vm.multipleCountry),
      callback: function($$v) {
        _vm.multipleCountry = $$v
      },
      expression: "multipleCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "placeholder": "Live Date",
            "append-icon": "event",
            "readonly": "",
            "dense": ""
          },
          model: {
            value: (_vm.multipleLiveDate),
            callback: function($$v) {
              _vm.multipleLiveDate = $$v
            },
            expression: "multipleLiveDate"
          }
        }, on))]
      }
    }], null, false, 895853665),
    model: {
      value: (_vm.multipleLiveCal),
      callback: function($$v) {
        _vm.multipleLiveCal = $$v
      },
      expression: "multipleLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.multipleLiveCal = false
      }
    },
    model: {
      value: (_vm.multipleLiveDate),
      callback: function($$v) {
        _vm.multipleLiveDate = $$v
      },
      expression: "multipleLiveDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": "*",
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaignData
    },
    on: {
      "change": _vm.mediaChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', _vm._l((_vm.gdriveFiles), function(gd, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "xs": "6"
      }
    }, [_c('v-btn', {
      staticClass: "ims-action btn-gdrive-del",
      attrs: {
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deletegDriveFile(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("close")])], 1), _vm._v(" "), _c('iframe', {
      staticClass: "media-iframe",
      attrs: {
        "width": "100%",
        "height": "100%",
        "src": gd.embedURL,
        "allowFullScreen": ""
      }
    })], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.saveMutlipleContents()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanel === 'post') ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Add using Instagram Graph API")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("(Recommended)")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('i', {
    staticClass: "subtitle"
  }, [_vm._v("This method is officially supported by Instagram. It is required approved permissions from the influencers who logged in via Facebook.")]), _c('br'), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-5",
    attrs: {
      "height": "30px",
      "prefix": "@",
      "hide-details": "",
      "placeholder": "Filter by instagram handle"
    }
  }), _vm._v(" "), _vm._l((_vm.pairedInfluencers), function(influencer, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-1",
      attrs: {
        "outlined": "",
        "pill": "",
        "small": "",
        "color": "primary",
        "label": ""
      },
      on: {
        "click": function($event) {
          return _vm.showRecentPosts(influencer.instagramHandle)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v("\n                  " + _vm._s(influencer.fullName) + "(" + _vm._s(influencer.instagramHandle) + ")\n                ")], 1)
  })], 2)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "dialog": _vm.loading
    }
  }), _vm._v(" "), _c('PostView', {
    attrs: {
      "selectedPostIds": _vm.selectedPostIds,
      "value": _vm.recentPostDialog,
      "title": _vm.postListTitle,
      "posts": _vm.listPosts
    },
    on: {
      "onSelect": _vm.postSelected,
      "prev_page": function($event) {
        return _vm.showRecentPosts(_vm.selectedInstagramHandle, 'prev')
      },
      "next_page": function($event) {
        return _vm.showRecentPosts(_vm.selectedInstagramHandle, 'next')
      }
    },
    model: {
      value: (_vm.recentPostDialog),
      callback: function($$v) {
        _vm.recentPostDialog = $$v
      },
      expression: "recentPostDialog"
    }
  }), _vm._v(" "), _c('upload-stats-modal', {
    attrs: {
      "value": _vm.uploadStatsDialog,
      "postType": _vm.aiPostType,
      "imagesToView": _vm.campaignPayout
    },
    on: {
      "statsConfirmed": _vm.confirmedStats
    },
    model: {
      value: (_vm.uploadStatsDialog),
      callback: function($$v) {
        _vm.uploadStatsDialog = $$v
      },
      expression: "uploadStatsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.showCompanyOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Companies")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalCompanies))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-business",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCampaignOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Campaigns")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalCampaigns))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-stats",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showInfluencerOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Influencers")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalInfluencers))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-people",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showClientOverview) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Clients")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('h3', [_vm._v(_vm._s(_vm.totalClients))]), _vm._v(" "), _c('div', {
    staticClass: "icon pt-5"
  }, [_c('i', {
    staticClass: "ion ion-ios-contacts",
    staticStyle: {
      "color": "#c3c3c3"
    }
  })])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('influencer-quality-rating', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.INFLUENCER_RATING.title,
      "headers": _vm.influencerHeaders,
      "items": _vm.INFLUENCER_RATING.items,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers
    },
    on: {
      "searchfilter": _vm.influencerSearch
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('client-quality-rating', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.CLIENT_RATING.title,
      "headers": _vm.clientHeaders,
      "items": _vm.CLIENT_RATING.items,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers,
      "filterUserLabel": "CC Filter"
    },
    on: {
      "searchfilter": _vm.clientSearch
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('pie-chart', {
    attrs: {
      "theme": "#36a2eb",
      "labels": _vm.REPORT_ABUSE.labels,
      "title": _vm.REPORT_ABUSE.title,
      "items": _vm.REPORT_ABUSE.items,
      "backgroundColors": _vm.REPORT_ABUSE.backgroundColors,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers
    },
    on: {
      "searchfilter": _vm.reportAbuseSearch
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "green darken-4",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Audience Insight")])], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Unlock Audience Insights.\n          Join our 1 year membership program for just $4.29 per year!\n        ")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    class: ("" + (_vm.isEditMode ? 'no-boxshadow' : '')),
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('div', {
    class: ("" + (_vm.isCreateMode ? 'container container--fluid' : ''))
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "id": "rate-card-form",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    class: ("content xs12 " + (_vm.isCreateMode ? 'md7' : 'md12'))
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-right pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "100px",
      "float": "right"
    },
    attrs: {
      "item-text": "title",
      "item-value": "value",
      "items": _vm.langOptions,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeLang()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('span', {
          class: ("fi " + (item.icon))
        }), _vm._v(" " + _vm._s(item.title))])]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('span', {
          class: ("fi " + (item.icon))
        }), _vm._v(" " + _vm._s(item.title))])]
      }
    }]),
    model: {
      value: (_vm.selectedLang),
      callback: function($$v) {
        _vm.selectedLang = $$v
      },
      expression: "selectedLang"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isCreateMode) ? _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "KOBE Logo"
    }
  })])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.formConfig.title))])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "px-5 clearfix",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('name')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "textbox",
      "outlined": "",
      "required": "",
      "hide-details": "",
      "error-messages": _vm.$v.rateCardData.name.$error && "Name is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.name.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.name),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "name", $$v)
      },
      expression: "rateCardData.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('email')) + "  "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "email",
      "outlined": "",
      "required": "",
      "hide-details": "",
      "error-messages": _vm.$v.rateCardData.email.$error && (!_vm.$v.rateCardData.email.required ? 'Email is required.' : !_vm.$v.rateCardData.email.email ? 'Please enter a valid email address.' : '')
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.rateCardData.email),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "email", $$v)
      },
      expression: "rateCardData.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('dateOfBirth')))]), _vm._v(" "), _c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.rateCardDOB,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.rateCardDOB = $event
      },
      "update:return-value": function($event) {
        _vm.rateCardDOB = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "append-icon": "event",
            "hide-details": "",
            "outlined": "",
            "readonly": ""
          },
          model: {
            value: (_vm.rateCardData.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData, "dateOfBirth", $$v)
            },
            expression: "rateCardData.dateOfBirth"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.DOBDateCal),
      callback: function($$v) {
        _vm.DOBDateCal = $$v
      },
      expression: "DOBDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "id": "rate-card-date-picker",
      "type": "month",
      "max": _vm.minBirthDate,
      "show-current": _vm.minBirthDate
    },
    model: {
      value: (_vm.rateCardData.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "dateOfBirth", $$v)
      },
      expression: "rateCardData.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.DOBDateCal = false
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.changeDate
    }
  }, [_vm._v("\n                            OK\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('country')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.countries,
      "hide-details": "",
      "outlined": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.country.$error && "Country is required."
    },
    on: {
      "change": function($event) {
        return _vm.changeCountry()
      },
      "input": function($event) {
        return _vm.$v.rateCardData.country.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.country),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "country", $$v)
      },
      expression: "rateCardData.country"
    }
  })], 1), _vm._v(" "), (_vm.rateCardData.country === 'Singapore' || _vm.rateCardData.country === 'Malaysia') ? _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('ethnicity')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pr-1",
    attrs: {
      "items": _vm.ethnicityOptions,
      "hide-details": "",
      "outlined": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.ethnicity.$error && "Ethnicity is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.ethnicity.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "ethnicity", $$v)
      },
      expression: "rateCardData.ethnicity"
    }
  }), _vm._v(" "), (_vm.rateCardData.ethnicity === 'Others') ? _c('v-text-field', {
    staticClass: "pr-1 mt-2",
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.otherEth),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "otherEth", $$v)
      },
      expression: "rateCardData.otherEth"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('gender')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "purple-input",
    attrs: {
      "items": _vm.genderOptions,
      "type": "textbox",
      "outlined": "",
      "hide-details": "",
      "required": "",
      "error-messages": _vm.$v.rateCardData.gender.$error && "Gender is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.gender.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.gender),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "gender", $$v)
      },
      expression: "rateCardData.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('ContactNo')))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "12px",
      "padding-left": "15px"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "100px",
      "border-radius": "5px 0 0 5px"
    },
    attrs: {
      "items": _vm.countryCodeOptions,
      "outlined": ""
    },
    model: {
      value: (_vm.countryCode),
      callback: function($$v) {
        _vm.countryCode = $$v
      },
      expression: "countryCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    staticStyle: {
      "border-radius": "0 5px 5px 0"
    },
    attrs: {
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.contactNo),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "contactNo", $$v)
      },
      expression: "rateCardData.contactNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('occupation')))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "type": "textbox",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.rateCardData.occupation),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "occupation", $$v)
      },
      expression: "rateCardData.occupation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.formConfig.sections), function(section, index) {
    return _c('v-col', {
      key: index,
      class: section.class ? section.class : 'xs12 md6',
      style: (section.style || '')
    }, [_c('div', _vm._l((section.fields), function(field, index) {
      return _c('v-col', {
        key: index,
        staticClass: "align-center",
        class: field.class ? field.class : 'xs12 md6',
        style: (field.style || '')
      }, [(field.label !== '') ? _c('p', {
        class: ("h4 font-weight-bold mb-2 " + (field.labelClass || '')),
        staticStyle: {
          "min-height": "39.59px"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.getLang(field.name)) + " \n                          "), (field.required) ? _c('span', {
        staticClass: "red--text"
      }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (field.type === 'number') ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [(_vm.isEditMode && field.name === 'igStory') ? _c('div', [_c('p', {
        staticClass: "rate-label-title"
      }, [_vm._v("Ordinary")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-row"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.rateCardData.ordinaryRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.ordinaryRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "rateCardData.ordinaryRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData.ordinaryRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.ordinaryRates, field.name, _vm._n($$v))
          },
          expression: "rateCardData.ordinaryRates[field.name]"
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (field.type === 'number' && _vm.isEditMode) ? _c('div', {
        staticClass: "d-flex flex-column"
      }, [(field.name === 'igStory') ? _c('div', [_c('p', {
        staticClass: "rate-label-title pl-3"
      }, [_vm._v("Preferential")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "d-flex flex-row pl-3"
      }, [_c('v-select', {
        staticClass: "currency-select",
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "items": _vm.currenyOptions,
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        model: {
          value: (_vm.rateCardData.preferentialRates[((field.name) + "Currency")]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.preferentialRates, ((field.name) + "Currency"), _vm._n($$v))
          },
          expression: "rateCardData.preferentialRates[`${field.name}Currency`]"
        }
      }), _vm._v(" "), _c('v-text-field', {
        staticClass: "purple-input",
        attrs: {
          "type": "number",
          "outlined": "",
          "dense": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData.preferentialRates[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData.preferentialRates, field.name, _vm._n($$v))
          },
          expression: "rateCardData.preferentialRates[field.name]"
        }
      })], 1)]) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && (field.name !== 'instagramHandle' && field.name !== 'tiktokHandle')) ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && (field.name === 'instagramHandle' || field.name === 'tiktokHandle')) ? _c('v-text-field', {
        staticClass: "purple-input social-handle-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "textbox",
          "outlined": "",
          "prefix": "@",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'normalNumber') ? _c('v-text-field', {
        staticClass: "purple-input",
        style: (field.fieldStyle || ''),
        attrs: {
          "type": "number",
          "outlined": "",
          "placeholder": field.placeholder ? field.placeholder : ''
        },
        on: {
          "keypress": _vm.onlyForNumber
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
        attrs: {
          "filled": "",
          "auto-grow": "",
          "hint": field.hint || '',
          "persistent-hint": field.hint ? true : false,
          "placeholder": field.placeholder,
          "required": "",
          "hide-details": "auto"
        },
        model: {
          value: (_vm.rateCardData[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.rateCardData, field.name, $$v)
          },
          expression: "rateCardData[field.name]"
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('custom-file-upload', {
        attrs: {
          "refresh": _vm.fileUploadRefresh,
          "multiple": true
        },
        on: {
          "setMedias": _vm.updatePricingDecks
        }
      }) : _vm._e(), _vm._v(" "), (field.type === 'multiple') ? _c('div', [_c('div', {
        staticClass: "social-platform-list"
      }, [_vm._l((_vm.rateCardData[field.name]), function(multipleOne, pIndex) {
        return _c('div', {
          key: pIndex,
          staticClass: "social-platform-entry"
        }, [_c('div', {
          staticClass: "social-platform-main"
        }, [_c('v-select', {
          staticClass: "social-platform-select",
          attrs: {
            "items": field.options[0].options,
            "item-value": "value",
            "item-text": "label",
            "hide-details": "",
            "label": field.options[0].label,
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].platform),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "platform", $$v)
            },
            expression: "rateCardData[field.name][pIndex].platform"
          }
        }), _vm._v(" "), _c('v-text-field', {
          staticClass: "social-platform-url",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.options[1].placeholder
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].url),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "url", $$v)
            },
            expression: "rateCardData[field.name][pIndex].url"
          }
        }), _vm._v(" "), _c('v-btn', {
          staticClass: "social-platform-delete",
          attrs: {
            "icon": "",
            "small": "",
            "aria-label": "Remove platform"
          },
          on: {
            "click": function($event) {
              _vm.rateCardData[field.name].splice(pIndex, 1)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("mdi-delete-forever")])], 1)], 1), _vm._v(" "), (_vm.rateCardData[field.name][pIndex][field.child.parentName] === 'others') ? _c('v-text-field', {
          staticClass: "social-platform-other",
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": field.child.placeholder
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex][field.child.name]),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], field.child.name, $$v)
            },
            expression: "rateCardData[field.name][pIndex][field.child.name]"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "social-platform-rate"
        }, [_c('v-select', {
          staticClass: "currency-select-multiple",
          attrs: {
            "items": _vm.currenyOptions,
            "hide-details": "",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].rateCurrency),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "rateCurrency", _vm._n($$v))
            },
            expression: "rateCardData[field.name][pIndex].rateCurrency"
          }
        }), _vm._v(" "), _c('v-text-field', {
          staticClass: "multiple-rate",
          attrs: {
            "type": "number",
            "dense": "",
            "outlined": "",
            "hide-details": "",
            "placeholder": "Rate"
          },
          model: {
            value: (_vm.rateCardData[field.name][pIndex].rate),
            callback: function($$v) {
              _vm.$set(_vm.rateCardData[field.name][pIndex], "rate", _vm._n($$v))
            },
            expression: "rateCardData[field.name][pIndex].rate"
          }
        })], 1)], 1)
      }), _vm._v(" "), _c('div', {
        staticClass: "text-right"
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            return _vm.addPlatform(field.name)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                              ")], 1)], 1)], 2)]) : _vm._e()], 1)
    }), 1)])
  }), 1), _vm._v(" "), (!_vm.rateCardData.instagramHandle && !_vm.rateCardData.tiktokHandle) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0 px-5 mx-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.getLang('enterIgTikTok')) + " *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "px-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('preferredCampaigns')))]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary white--text",
      "column": "",
      "required": ""
    },
    model: {
      value: (_vm.rateCardData.keywords),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "keywords", $$v)
      },
      expression: "rateCardData.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }), 1), _vm._v(" "), (_vm.rateCardData.keywords !== null && !_vm.rateCardData.keywords.length) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v(_vm._s(_vm.getLang('preferredCampaigns')))]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('bestRepresent')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "required": "",
      "hide-details": "auto",
      "error-messages": _vm.$v.rateCardData.aboutYou.$error && "This field is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.rateCardData.aboutYou.$touch()
      }
    },
    model: {
      value: (_vm.rateCardData.aboutYou),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "aboutYou", $$v)
      },
      expression: "rateCardData.aboutYou"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.getLang('giftBrand')))]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "color": "secondary"
    },
    model: {
      value: (_vm.rateCardData.giftBrand),
      callback: function($$v) {
        _vm.$set(_vm.rateCardData, "giftBrand", $$v)
      },
      expression: "rateCardData.giftBrand"
    }
  }, [_c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "Yes",
      "label": _vm.getLang('yes'),
      "color": "secondary"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "justify-center",
    attrs: {
      "value": "No",
      "label": _vm.getLang('noPaidCampaign'),
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-space-between align-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.$route.query.cc) ? _c('div', {
    staticClass: "text-left"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Referred By:")]), _vm._v(" " + _vm._s(_vm.$route.query.cc) + "\n                ")]) : _c('div'), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('rate-card-terms-modal', {
    attrs: {
      "value": _vm.showAgreementModal,
      "selectedLang": _vm.selectedLang
    },
    on: {
      "termsAggrement": _vm.confirmSave
    },
    model: {
      value: (_vm.showAgreementModal),
      callback: function($$v) {
        _vm.showAgreementModal = $$v
      },
      expression: "showAgreementModal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "transition": "fade-transition",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h2', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Edit Campaign")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body",
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', [(_vm.editClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.client_options,
      "label": "Client",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        return _vm.setClientData(_vm.campaign)
      }
    },
    model: {
      value: (_vm.campaign.clientID),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "clientID", $$v)
      },
      expression: "campaign.clientID"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-2"
  }, [_vm._v("\n                Assigned Team\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-subheader', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                      Dedicated Persons\n                    ")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "active-class": "secondary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedDedicatedPersons),
      callback: function($$v) {
        _vm.selectedDedicatedPersons = $$v
      },
      expression: "selectedDedicatedPersons"
    }
  }, _vm._l((_vm.userTypes), function(userType, typeIndex) {
    return _c('div', {
      key: typeIndex,
      staticStyle: {
        "width": "100%"
      }
    }, [(_vm.filterByRole(_vm.dedicatedPersons, userType.role).length > 0) ? _c('p', {
      staticClass: "h4 font-weight-bold mb-0 pl-3"
    }, [_vm._v(_vm._s(userType.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterByRole(_vm.dedicatedPersons, userType.role)), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "value": item,
          "filter": ""
        }
      }, [_c('v-avatar', {
        staticStyle: {
          "margin-right": "5px"
        }
      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
    })], 2)
  }), 0)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }]
  }, [_vm._v("\n                      Supporting Persons\n                    ")]), _vm._v(" "), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }],
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('v-chip-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }],
    attrs: {
      "multiple": "",
      "active-class": "secondary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedSupportingPersons),
      callback: function($$v) {
        _vm.selectedSupportingPersons = $$v
      },
      expression: "selectedSupportingPersons"
    }
  }, _vm._l((_vm.userTypes), function(userType, typeIndex) {
    return _c('div', {
      key: typeIndex,
      staticStyle: {
        "width": "100%"
      }
    }, [(_vm.filterByRole(_vm.supportingPersons, userType.role).length > 0) ? _c('p', {
      staticClass: "h4 font-weight-bold mb-0 pl-3"
    }, [_vm._v(_vm._s(userType.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterByRole(_vm.supportingPersons, userType.role)), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "value": item,
          "filter": ""
        }
      }, [_c('v-avatar', {
        staticStyle: {
          "margin-right": "5px"
        }
      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
    })], 2)
  }), 0)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.campaignModelSections), function(section) {
    return _c('v-layout', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "width": "100%"
      }
    }, [_c('v-card-title', {
      staticClass: "title grey lighten-2"
    }, [_vm._v("\n                    " + _vm._s(section.title) + "\n                    "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('v-container', [(
      (section.type === _vm.campaignModelSectionType.CAMPAIGN_SUMMARY) ||
      (section.type === _vm.campaignModelSectionType.INFLUENCER_SELECTION) ||
      (section.type === _vm.campaignModelSectionType.BUDGET_ALLOCATION) ||
      (section.type === _vm.campaignModelSectionType.VIDEO_BRIEF && _vm.showVideoBrief)) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [(section.type === _vm.campaignModelSectionType.BUDGET_ALLOCATION) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "info",
        "elevation": "4"
      },
      on: {
        "click": function($event) {
          _vm.viewClientDialog = true
        }
      }
    }, [_vm._v("\n                              Client Details\n                              "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                                mdi-account-details\n                              ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md6": "",
          "xl4": ""
        }
      }, [(campaignField.type === 'text' && campaignField.name === 'vertical') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-combobox', {
        attrs: {
          "items": _vm.campaignVerticals,
          "item-text": "name",
          "item-value": "name",
          "hide-selected": "",
          "chips": "",
          "label": campaignField.placeholder,
          "multiple": "",
          "solo": "",
          "attach": ""
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                    " + _vm._s(item.name) + "\n                                  ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                    $delete\n                                  ")])], 1) : _vm._e()]
          }
        }], null, true),
        model: {
          value: (_vm.selectedCampaignVertical),
          callback: function($$v) {
            _vm.selectedCampaignVertical = $$v
          },
          expression: "selectedCampaignVertical"
        }
      })], 1) : (campaignField.type === 'text' || campaignField.type === 'slider') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder,
          "disabled": campaignField.name === 'budget' ? true : false
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-textarea', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'combobox') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'targetAge') ? _c('v-combobox', {
        attrs: {
          "items": campaignField.items,
          "multiple": "",
          "solo": "",
          "chips": "",
          "placeholder": campaignField.placeholder
        },
        on: {
          "input": _vm.targetAgelimiter
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : (campaignField.name === 'targetLocation') ? _c('v-autocomplete', {
        attrs: {
          "search-input": _vm.newCountry,
          "items": _vm.countries,
          "item-text": "name",
          "item-value": "code",
          "hide-selected": "",
          "multiple": "",
          "solo": "",
          "chips": "",
          "label": "Country",
          "dense": ""
        },
        on: {
          "update:searchInput": function($event) {
            _vm.newCountry = $event
          },
          "update:search-input": function($event) {
            _vm.newCountry = $event
          }
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                    " + _vm._s(item.name) + "\n                                  ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                    $delete\n                                  ")])], 1) : _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                    " + _vm._s(item) + "\n                                  ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                    $delete\n                                  ")])], 1)]
          }
        }], null, true),
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _c('v-combobox', {
        attrs: {
          "items": campaignField.items,
          "multiple": "",
          "solo": "",
          "chips": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'ioNumbers') ? _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": _vm.IONumbers,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _vm._e(), _vm._v(" "), (campaignField.name !== 'ioNumbers' && campaignField.name !== 'name') ? _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _vm._e(), _vm._v(" "), (campaignField.name !== 'ioNumbers' && campaignField.name === 'name') ? _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        on: {
          "change": function($event) {
            return _vm.changeCampaignName(_vm.campaign[campaignField.name])
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'autocomplete') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-autocomplete', {
        attrs: {
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value",
          "hide-selected": "",
          "chips": "",
          "label": campaignField.placeholder,
          "multiple": "",
          "solo": "",
          "attach": ""
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                    " + _vm._s(item.text) + "\n                                  ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                    $delete\n                                  ")])], 1) : _vm._e()]
          }
        }], null, true),
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'chips') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', [_c('draggable', {
        staticClass: "row no-gutters flex-wrap flex-row fill-height",
        staticStyle: {
          "width": "100%"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }, _vm._l((_vm.campaign[campaignField.name]), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "value": item,
            "filter": ""
          }
        }, [_vm._v("\n                                  " + _vm._s(item.text) + "\n                                ")])
      }), 1)], 1)]) : _vm._e(), _vm._v(" "), (campaignField.type == 'upload') ? _c('div', [_c('a', {
        staticClass: "campaign-image",
        attrs: {
          "href": _vm.constructImageURL(_vm.campaign[campaignField.name]),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "src": _vm.constructImageURL(_vm.campaign[campaignField.name])
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "canvas-image-input"
      }, [_c('input', {
        ref: "files",
        refInFor: true,
        attrs: {
          "type": "file"
        },
        on: {
          "change": function($event) {
            return _vm.processImage($event, 'canvas', null, 'canvas')
          }
        }
      })])])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'startDate') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.startCal),
          callback: function($$v) {
            _vm.startCal = $$v
          },
          expression: "startCal"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "type": "month"
        },
        on: {
          "input": function($event) {
            _vm.startCal = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'endDate') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.endCal),
          callback: function($$v) {
            _vm.endCal = $$v
          },
          expression: "endCal"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "type": "month"
        },
        on: {
          "input": function($event) {
            _vm.endCal = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'radio') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-radio-group', {
        attrs: {
          "row": ""
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }, [_c('v-radio', {
        attrs: {
          "label": "by engagement",
          "value": "engagement"
        }
      }), _vm._v(" "), _c('v-radio', {
        attrs: {
          "label": "by contents",
          "value": "content"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'video_live_date') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.videoDateDialog),
          callback: function($$v) {
            _vm.videoDateDialog = $$v
          },
          expression: "videoDateDialog"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        on: {
          "input": function($event) {
            _vm.videoDateDialog = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.CONTENT_ANGLE) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'select') ? _c('div', {
        staticClass: "action-required"
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('h4', [_vm._v("\n                                " + _vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1) + "\n                                "), (_vm.campaign[campaignField.name].length > 1) ? _c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteOption(campaignField.name, optionIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash ims-text-error"
        })]) : _vm._e()], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('v-text-field', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('v-textarea', {
            attrs: {
              "solo": "",
              "auto-grow": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionField.type == 'multiple_options') ? _c('div', [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(secondOption, secondOptionIndex) {
            return _c('div', {
              key: secondOptionIndex
            }, [_c('h4', [_vm._v("\n                                            Required action " + _vm._s(secondOptionIndex + 1) + "\n                                            "), (_vm.campaign[campaignField.name][optionIndex][optionField.name].length > 1) ? _c('v-btn', {
              attrs: {
                "text": "",
                "icon": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.deleteSecondOption(campaignField.name, optionIndex, optionField.name, secondOptionIndex)
                }
              }
            }, [_c('i', {
              staticClass: "fa fa-trash ims-text-error"
            })]) : _vm._e()], 1), _vm._v(" "), _vm._l((optionField.template), function(optionField2, optionIndex2) {
              return _c('v-layout', {
                key: optionIndex2,
                attrs: {
                  "wrap": ""
                }
              }, _vm._l((optionField2), function(format, i) {
                return _c('v-flex', {
                  key: i,
                  attrs: {
                    "xs6": ""
                  }
                }, [(format.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-text-field', {
                  attrs: {
                    "solo": "",
                    "placeholder": format.placeholder
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type == 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-textarea', {
                  attrs: {
                    "solo": "",
                    "placeholder": format.placeholder
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type === 'combobox') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-combobox', {
                  attrs: {
                    "items": format.items,
                    "multiple": "",
                    "solo": "",
                    "chips": "",
                    "placeholder": format.placeholder,
                    "append-icon": ""
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]), function(image, i) {
                  return _c('div', {
                    key: image
                  }, [(image.type === 'image') ? _c('a', {
                    staticClass: "campaign-image",
                    attrs: {
                      "href": _vm.constructImageURL(image.url),
                      "target": "_blank"
                    }
                  }, [(image.url) ? _c('img', {
                    staticStyle: {
                      "width": "100%"
                    },
                    attrs: {
                      "src": _vm.constructImageURL(image.url)
                    }
                  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (image.type === 'link') ? _c('a', {
                    staticClass: "campaign-image",
                    attrs: {
                      "href": image.url,
                      "target": "_blank"
                    }
                  }, [(_vm.checkMediaURL(image.url) === 'drive') ? _c('iframe', {
                    staticClass: "media-iframe",
                    attrs: {
                      "width": "120px",
                      "height": "100%",
                      "src": image.url,
                      "allowFullScreen": ""
                    }
                  }) : _c('p', [_vm._v(_vm._s(image.url))])]) : _vm._e(), _vm._v(" "), _c('button', {
                    staticClass: "btn btn-link btn-link-danger",
                    attrs: {
                      "type": "button"
                    },
                    on: {
                      "click": function($event) {
                        $event.preventDefault();
                        return _vm.removeUploadedImage(optionIndex, secondOptionIndex, i)
                      }
                    }
                  }, [_vm._v("Remove")])])
                }), _vm._v(" "), _c('div', {
                  staticClass: "image-input-container",
                  attrs: {
                    "id": 'optionImages_' + optionIndex + '_' + secondOptionIndex,
                    "data-index": optionIndex
                  }
                }, [_c('div', {
                  staticClass: "input-group pb-2",
                  attrs: {
                    "id": 'input_group_0_' + optionIndex + '_' + secondOptionIndex
                  }
                }, [_c('label', {
                  staticClass: "pr-2"
                }, [_c('input', {
                  attrs: {
                    "type": "radio",
                    "id": 'radio_image_' + optionIndex + '_' + secondOptionIndex,
                    "name": 'type_' + optionIndex + '_' + secondOptionIndex,
                    "value": "image",
                    "checked": "true"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'image')
                    }
                  }
                }), _vm._v(" Image\n                                                    ")]), _vm._v(" "), _c('label', [_c('input', {
                  attrs: {
                    "type": "radio",
                    "id": 'radio_link_' + optionIndex + '_' + secondOptionIndex,
                    "name": 'type_' + optionIndex + '_' + secondOptionIndex,
                    "value": "link"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'link')
                    }
                  }
                }), _vm._v(" Video Link\n                                                    ")]), _vm._v(" "), _c('div', [_c('input', {
                  staticClass: "custom-input",
                  staticStyle: {
                    "display": "none"
                  },
                  attrs: {
                    "type": "text",
                    "id": 'video_link_0_' + optionIndex + '_' + secondOptionIndex
                  },
                  on: {
                    "keyup": function($event) {
                      return _vm.changeVideoLink('angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                })]), _vm._v(" "), _c('div', {
                  staticClass: "image-input",
                  attrs: {
                    "id": 'img_upload_0_' + optionIndex + '_' + secondOptionIndex
                  }
                }, [_c('input', {
                  ref: "files",
                  refInFor: true,
                  attrs: {
                    "type": "file"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.processImage($event, 'angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                })])]), _vm._v(" "), _c('button', {
                  staticClass: "btn btn-link btn-link-danger btn-remove-input",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      return _vm.removeImage(optionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                }, [_vm._v("Remove")])]), _vm._v(" "), _c('button', {
                  staticClass: "btn btn-default btn-sm btn-add-more-image",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.addMoreImage(optionIndex, secondOptionIndex)
                    }
                  }
                }, [_vm._v("+ Add more image")])], 2) : _vm._e()])
              }), 1)
            })], 2)
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "default",
            attrs: {
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSecondOption(campaignField.name, optionIndex, optionField.name)
              }
            }
          }, [_vm._v("+ Add more angle")])], 2) : _vm._e()])
        }), 1)], 1)], 1)
      }), _vm._v(" "), _c('div', [_c('v-btn', {
        staticClass: "secondary",
        attrs: {
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addOption(campaignField.name)
          }
        }
      }, [_vm._v("Add new option")])], 1)], 2) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.EVENT_BRIEF && _vm.showEventBrief) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-textarea', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign.eventBrief[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign.eventBrief, campaignField.name, $$v)
          },
          expression: "campaign.eventBrief[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(campaignField.label) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.campaign.eventBrief[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": "",
              "md3": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), (_vm.campaign.eventBrief[campaignField.name].length > 1) ? _c('v-icon', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (optionField.name === 'attendeeName'),
              expression: "optionField.name === 'attendeeName'"
            }],
            attrs: {
              "text": "",
              "icon": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteAttendee(campaignField.name, optionIndex)
              }
            }
          }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign.eventBrief[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign.eventBrief[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign.eventBrief[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e()])
        }), 1)], 1)], 1)
      }), _vm._v(" "), _c('div', [_c('v-btn', {
        staticClass: "secondary",
        attrs: {
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addAttendee(campaignField.name)
          }
        }
      }, [_vm._v("Add an Attendee")])], 1)], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'template') ? _c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(campaignField.label) + "\n                          ")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, _vm._l((campaignField.template), function(templateField, i) {
        return _c('v-flex', {
          key: i,
          attrs: {
            "xs12": "",
            "md4": ""
          }
        }, [(templateField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "solo": "",
            "placeholder": templateField.placeholder
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'radioButton') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-checkbox', {
          attrs: {
            "label": _vm.campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes' : 'No'
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'date' && templateField.name === 'eventDate') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "solo": ""
                },
                model: {
                  value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
                  callback: function($$v) {
                    _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
                  },
                  expression: "campaign.eventBrief[campaignField.name][templateField.name]"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (_vm.eventDateDialog),
            callback: function($$v) {
              _vm.eventDateDialog = $$v
            },
            expression: "eventDateDialog"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          on: {
            "input": function($event) {
              _vm.eventDateDialog = false
            }
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-textarea', {
          attrs: {
            "solo": "",
            "placeholder": templateField.placeholder
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e()])
      }), 1)], 1)], 1) : _vm._e()])
    }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer ims-modal-actions"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": _vm.editCampaign
    }
  }, [_vm._v("Save changes")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [(!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }, {
      key: "item.startDate",
      fn: function(ref) {
        var item = ref.item;

        return [(item.startDateEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'startDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.startDate)) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                staticClass: "input-field mt-3",
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "dense": "",
                  "outlined": ""
                },
                model: {
                  value: (item.startDate),
                  callback: function($$v) {
                    _vm.$set(item, "startDate", $$v)
                  },
                  expression: "item.startDate"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (item.startCal),
            callback: function($$v) {
              _vm.$set(item, "startCal", $$v)
            },
            expression: "item.startCal"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          attrs: {
            "type": "month"
          },
          on: {
            "input": function($event) {
              item.startCal = false
            }
          },
          model: {
            value: (item.startDate),
            callback: function($$v) {
              _vm.$set(item, "startDate", $$v)
            },
            expression: "item.startDate"
          }
        })], 1)], 1)])]
      }
    }, {
      key: "item.endDate",
      fn: function(ref) {
        var item = ref.item;

        return [(item.endDateEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'endDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.endDate)) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
          staticClass: "text-center"
        }, [_c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                staticClass: "input-field mt-3",
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "dense": "",
                  "outlined": ""
                },
                model: {
                  value: (item.endDate),
                  callback: function($$v) {
                    _vm.$set(item, "endDate", $$v)
                  },
                  expression: "item.endDate"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (item.endCal),
            callback: function($$v) {
              _vm.$set(item, "endCal", $$v)
            },
            expression: "item.endCal"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          attrs: {
            "type": "month"
          },
          on: {
            "input": function($event) {
              item.endCal = false
            }
          },
          model: {
            value: (item.endDate),
            callback: function($$v) {
              _vm.$set(item, "endDate", $$v)
            },
            expression: "item.endDate"
          }
        })], 1)], 1)])]
      }
    }, {
      key: "item.onboardKPI",
      fn: function(ref) {
        var item = ref.item;

        return [(item.onboardKPIEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'onboardKPI')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.onboardKPI) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.onboardKPI),
            callback: function($$v) {
              _vm.$set(item, "onboardKPI", $$v)
            },
            expression: "item.onboardKPI"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.actualOnboarded",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          class: {
            'td-bg-red item-edit': item.lowonboardKPI,
            'item-edit': !item.lowonboardKPI
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.actualOnboarded) + "\n        ")])])]
      }
    }, {
      key: "item.achieved",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n        " + _vm._s(item.achieved) + " %\n      ")])]
      }
    }, {
      key: "item.coverageKPI",
      fn: function(ref) {
        var item = ref.item;

        return [(item.coverageKPIEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'coverageKPI')
            }
          }
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n          " + _vm._s(item.coverageKPI) + " "), _c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.coverageKPI),
            callback: function($$v) {
              _vm.$set(item, "coverageKPI", $$v)
            },
            expression: "item.coverageKPI"
          }
        }, _vm.on))], 1)]
      }
    }, {
      key: "item.currentProgress",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n        " + _vm._s(item.currentProgress) + " %\n      ")])]
      }
    }, {
      key: "item.totalAchieved",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n        " + _vm._s(item.totalAchieved) + " %\n      ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.$emit('viewInfluencers', item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          }
        }, [_vm._v("people")])], 1)], 1)]
      }
    }], null, true)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "720px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("AI Analysis · " + _vm._s(_vm.label))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2 pt-4"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "hide-details": "",
      "placeholder": ("Short paragraph about " + _vm.label + " performance…")
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input', false)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": "",
      "loading": _vm.generating,
      "disabled": !_vm.posts || !_vm.posts.length
    },
    on: {
      "click": _vm.generate
    }
  }, [_c('i', {
    staticClass: "fas fa-magic mr-2"
  }), _vm._v(" Generate with AI\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(!_vm.options.theme) ? _c('v-text-field', _vm._g(_vm._b({
          class: _vm.className,
          attrs: {
            "placeholder": _vm.options.placeholder || '',
            "label": _vm.options.placeholder || '',
            "append-icon": "event",
            "readonly": "",
            "dense": _vm.options.dense || _vm.options.dense === false ? _vm.options.dense : true,
            "hide-details": _vm.options.hideDetails || false,
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.date = _vm.parseDate(_vm.dateFormatted)
            },
            "change": _vm.changeDate
          },
          model: {
            value: (_vm.computedDateFormatted),
            callback: function($$v) {
              _vm.computedDateFormatted = $$v
            },
            expression: "computedDateFormatted"
          }
        }, 'v-text-field', attrs, false), on)) : _vm._e(), _vm._v(" "), (_vm.options.theme && _vm.options.theme === 'icon') ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("event")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": _vm.options.type ? 'month' : 'date'
    },
    on: {
      "input": _vm.changeInput
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [(_vm.options.confirm) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.status = false
      }
    }
  }, [_vm._v("\n          Cancel\n      ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(_vm.date)
      }
    }
  }, [_vm._v("\n          OK\n      ")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal create-client-modal",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "700px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card create-client-card"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Create new Client Account")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-client-body"
  }, [_c('v-form', [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panels),
      callback: function($$v) {
        _vm.panels = $$v
      },
      expression: "panels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Contact Person Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [(_vm.needCompany) ? _c('v-select', {
    attrs: {
      "prepend-icon": "business",
      "label": "Assign an Agency Company to client",
      "items": _vm.company_options,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.client.companyID),
      callback: function($$v) {
        _vm.$set(_vm.client, "companyID", $$v)
      },
      expression: "client.companyID"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "person_outline",
      "label": "Sales Representative",
      "items": _vm.salePerson_options,
      "item-text": "firstName",
      "item-value": "id"
    },
    model: {
      value: (_vm.client.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.client, "salePerson", $$v)
      },
      expression: "client.salePerson"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "prepend-icon": "groups",
      "items": _vm.xeroContacts,
      "label": "Billing Name as per Xero",
      "item-text": "Name",
      "attach": "",
      "dense": "",
      "return-object": ""
    },
    on: {
      "change": _vm.changeClientGroup
    },
    model: {
      value: (_vm.client.group),
      callback: function($$v) {
        _vm.$set(_vm.client, "group", $$v)
      },
      expression: "client.group"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "business",
      "label": "Client Name (enter only if billing name as per xero cannot be found above)",
      "placeholder": "",
      "error-messages": _vm.nameErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.name.$touch()
      }
    },
    model: {
      value: (_vm.client.name),
      callback: function($$v) {
        _vm.$set(_vm.client, "name", $$v)
      },
      expression: "client.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "phone",
      "label": "Primary Contact Number",
      "placeholder": "",
      "required": ""
    },
    model: {
      value: (_vm.client.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.client, "phoneNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "client.phoneNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "location_on",
      "label": "Address (to be included in invoice)",
      "placeholder": "Enter Contact Address",
      "required": ""
    },
    model: {
      value: (_vm.client.address),
      callback: function($$v) {
        _vm.$set(_vm.client, "address", $$v)
      },
      expression: "client.address"
    }
  })], 1), _vm._v(" "), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.contactPanels),
      callback: function($$v) {
        _vm.contactPanels = $$v
      },
      expression: "contactPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                              Contacts\n                            ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_vm._l((_vm.client.contacts), function(contact, index) {
    return _c('v-list', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "label": "Include in Email",
        "color": "secondary",
        "true-value": true,
        "false-value": false,
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: (contact.includeEmail),
        callback: function($$v) {
          _vm.$set(contact, "includeEmail", $$v)
        },
        expression: "contact.includeEmail"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "person",
        "label": "Contact Person",
        "placeholder": "",
        "required": ""
      },
      model: {
        value: (contact.contactName),
        callback: function($$v) {
          _vm.$set(contact, "contactName", $$v)
        },
        expression: "contact.contactName"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "email",
        "label": "Contact Email",
        "placeholder": ""
      },
      on: {
        "change": function($event) {
          return _vm.checkAccEmail(index)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
        },
        "paste": _vm.preventPasteSpaces
      },
      model: {
        value: (contact.email),
        callback: function($$v) {
          _vm.$set(contact, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "contact.email"
      }
    })], 1), _vm._v(" "), (contact.invalid) ? _c('v-list-item', {
      staticStyle: {
        "margin-top": "-15px"
      },
      attrs: {
        "dense": ""
      }
    }, [_c('p', {
      staticClass: "text-danger"
    }, [_vm._v("Email Already Exists.")])]) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeContact(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                              ")], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.addDefaultContact()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Contact\n                          ")], 1)], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Account Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.deals.length > 0),
      expression: "client.account.deals.length > 0"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.client.account.deals), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "disable-icon-rotate": ""
      }
    }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-row', {
      staticClass: "pa-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Deals Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget || '-'))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("IO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.IO || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.activationDate) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Activation Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.activationDate)))])])], 1) : _vm._e(), _vm._v(" "), (item.linkedIOs && item.linkedIOs.length) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Linked IO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Quote Acceptance Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.quoteAcceptanceDate)))])])], 1), _vm._v(" "), (item.cogsAmount) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Markup COGS Amount")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cogsAmount || '-'))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.vertical) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaign Vertical")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.displayCampaignVerticals(item.vertical)))])])], 1) : _vm._e(), _vm._v(" "), (item.country) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('p', _vm._l((item.country), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                            " + _vm._s(item.name) + "\n                                          ")])
    }), 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Client Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getClientTypeDisplayValue(item.clientType)))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Line of Services")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.servicesLine))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.remarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-expansion-panels', _vm._l((item.products), function(product, pindex) {
      return _c('v-expansion-panel', {
        key: pindex
      }, [_c('v-expansion-panel-header', {
        staticStyle: {
          "text-transform": "capitalize"
        }
      }, [_vm._v(_vm._s(_vm.getProductName(product.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'storytell'),
          expression: "product.name.toLowerCase() === 'storytell'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-clipboard-list-outline")]), _vm._v(" No. of Campaigns: "), _c('strong', [_vm._v(_vm._s(product.noOfCampaigns))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(product.totalOutReach))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-chart-areaspline ")]), _vm._v(" Total Engagement: "), _c('strong', [_vm._v(_vm._s(product.totalEngagement))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1), _vm._v(" "), _c('v-row')], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'amplify'),
          expression: "product.name.toLowerCase() === 'amplify'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-file-eye-outline ")]), _vm._v(" Views: "), _c('strong', [_vm._v(_vm._s(product.views))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent || product.noOfContents))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Duration: "), _c('strong', [_vm._v(_vm._s(product.duration) + " Months")])], 1)], 1), _vm._v(" "), _c('v-row'), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'),
          expression: "product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(product.totalOutReach || '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent || product.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" KPI Onboarded: "), _c('strong', [_vm._v(_vm._s(product.kpiOnboarded || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'others'),
          expression: "product.name.toLowerCase() === 'others'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(product.remark))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Nature of deal: "), _c('strong', [_vm._v(_vm._s(_vm.displayNatureOfDeals(product.natureOfDeal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'loading fees'),
          expression: "product.name.toLowerCase() === 'loading fees'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(product.remark))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
        attrs: {
          "text": "",
          "color": "error"
        },
        on: {
          "click": function($event) {
            return _vm.deleteProductsFromAccountDetails(index, pindex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                                              ")], 1)], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDeals(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                                  ")], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.addDealsDialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("\n                      mdi-plus\n                      ")]), _vm._v("\n                      Add Deals\n                    ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Assigned Team")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('AssignTeam', {
    attrs: {
      "assignUsers": _vm.assignUsers
    },
    on: {
      "updateSelectedDedicated": _vm.updateSelectedDedicated,
      "updateSelectedSupporting": _vm.updateSelectedSupporting
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Billing Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "Billing information is same as contact information"
    },
    model: {
      value: (_vm.sameWithContactInfo),
      callback: function($$v) {
        _vm.sameWithContactInfo = $$v
      },
      expression: "sameWithContactInfo"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "payment",
      "label": "Payment Mode",
      "items": _vm.clientPaymentModes,
      "item-text": "name",
      "item-value": "value"
    },
    model: {
      value: (_vm.client.paymentMode),
      callback: function($$v) {
        _vm.$set(_vm.client, "paymentMode", $$v)
      },
      expression: "client.paymentMode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "location_on",
      "label": "Billing Address",
      "placeholder": "Enter Billing Address",
      "disabled": _vm.sameWithContactInfo
    },
    model: {
      value: (_vm.client.billingAddress),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingAddress", $$v)
      },
      expression: "client.billingAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "phone",
      "label": "Billing Contact",
      "placeholder": "Enter billing contact number",
      "disabled": _vm.sameWithContactInfo
    },
    model: {
      value: (_vm.client.billingPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingPhoneNumber", $$v)
      },
      expression: "client.billingPhoneNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "email",
      "label": "Billing Email",
      "placeholder": "Enter billing email",
      "disabled": _vm.sameWithContactInfo,
      "error-messages": _vm.emailErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.email.$touch()
      }
    },
    model: {
      value: (_vm.client.billingEmail),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "client.billingEmail"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions create-client-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeCreateModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.createClient
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.addDealsDialog),
      callback: function($$v) {
        _vm.addDealsDialog = $$v
      },
      expression: "addDealsDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "350px"
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add New Deals")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "dealForm"
  }, [_c('v-container', [_c('v-autocomplete', {
    staticClass: "mt-5",
    attrs: {
      "items": _vm.displayMasterLists,
      "item-text": "quoteNo",
      "item-value": "quoteNo",
      "label": "IO Number",
      "prepend-icon": "mdi-file-outline",
      "prefix": "IO-",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "change": _vm.changeIONumber
    },
    model: {
      value: (_vm.client.deals.IO),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "IO", $$v)
      },
      expression: "client.deals.IO"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('label', [_vm._v("Linked IO")]), _c('br'), _vm._v(" "), _vm._l((_vm.client.deals.linkedIOs), function(linkIO, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-row mb-2"
    }, [_c('v-text-field', _vm._g({
      attrs: {
        "prefix": "IO-",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": _vm.changeLinkedIO
      },
      model: {
        value: (_vm.client.deals.linkedIOs[index]),
        callback: function($$v) {
          _vm.$set(_vm.client.deals.linkedIOs, index, $$v)
        },
        expression: "client.deals.linkedIOs[index]"
      }
    }, _vm.on)), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "min-width": "30px",
        "height": "36px",
        "margin-left": "5px"
      },
      attrs: {
        "color": "red",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteLinkIO(index)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-delete-outline")])], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2 ml-0",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.addLinkIO()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n              ")], 1)], 2), _vm._v(" "), _c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "pt-3",
          attrs: {
            "label": "Quote Acceptance Date *",
            "prepend-icon": "event",
            "dense": "",
            "readonly": "",
            "disabled": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.client.deals.quoteAcceptanceDate),
            callback: function($$v) {
              _vm.$set(_vm.client.deals, "quoteAcceptanceDate", $$v)
            },
            expression: "client.deals.quoteAcceptanceDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.pickDate = false
      }
    },
    model: {
      value: (_vm.client.deals.quoteAcceptanceDate),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "quoteAcceptanceDate", $$v)
      },
      expression: "client.deals.quoteAcceptanceDate"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prepend-icon": "attach_money",
      "label": "Budget",
      "placeholder": "Enter budget",
      "disabled": ""
    },
    model: {
      value: (_vm.client.deals.previewBudget),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "previewBudget", _vm._n($$v))
      },
      expression: "client.deals.previewBudget"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prepend-icon": "attach_money",
      "label": "Total Budget",
      "placeholder": "Enter Total Budget",
      "rules": [_vm.rules.required],
      "disabled": ""
    },
    model: {
      value: (_vm.client.deals.budget),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "budget", _vm._n($$v))
      },
      expression: "client.deals.budget"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "text",
      "prepend-icon": "mdi-file-outline",
      "label": "Deal Name *",
      "placeholder": "Enter Deal Name",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.name),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "name", $$v)
      },
      expression: "client.deals.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Activation Date",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.checkDate('activationDate')
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkDate('activationDate')
      }
    },
    model: {
      value: (_vm.client.deals.activationDate),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "activationDate", $$v)
      },
      expression: "client.deals.activationDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon'
      },
      "status": _vm.actDateCal
    },
    on: {
      "changeDate": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.setDateFromPicker.apply(void 0, [ 'activationDate' ].concat( argsArray ))
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-combobox', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.campaignVerticals,
      "item-text": "name",
      "item-value": "name",
      "prepend-icon": "mdi-file-outline",
      "hide-selected": "",
      "dense": "",
      "label": "Campaign Vertical",
      "multiple": "",
      "rules": [_vm.rules.required]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                    $delete\n                  ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.client.deals.vertical),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "vertical", $$v)
      },
      expression: "client.deals.vertical"
    }
  }), _vm._v(" "), _c('v-combobox', {
    staticClass: "mt-5",
    attrs: {
      "prepend-icon": "mdi-file-outline",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "code",
      "rules": [_vm.rules.required],
      "hide-selected": "",
      "multiple": "",
      "chips": "",
      "label": "Country",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                    $delete\n                  ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.client.deals.country),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "country", $$v)
      },
      expression: "client.deals.country"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "mt-5",
    attrs: {
      "items": _vm.clientTypes,
      "item-text": "title",
      "item-value": "value",
      "label": "Client Type",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.client.deals.clientType),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "clientType", $$v)
      },
      expression: "client.deals.clientType"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.lineOfServices,
      "label": "Line of Services",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.servicesLine),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "servicesLine", $$v)
      },
      expression: "client.deals.servicesLine"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "mt-5",
    attrs: {
      "filled": "",
      "label": "Remarks",
      "prepend-icon": "mdi-bookmark-check-outline"
    },
    model: {
      value: (_vm.client.deals.remarks),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "remarks", $$v)
      },
      expression: "client.deals.remarks"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "this is a mark-up deal (special approval has been obtained prior)",
      "small": ""
    },
    model: {
      value: (_vm.client.deals.markupCOGS),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "markupCOGS", $$v)
      },
      expression: "client.deals.markupCOGS"
    }
  }), _vm._v(" "), (_vm.client.deals.markupCOGS) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "COGS Amount",
      "placeholder": "Enter COGS Amount",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.cogsAmount),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "cogsAmount", $$v)
      },
      expression: "client.deals.cogsAmount"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-2 white--text",
          attrs: {
            "color": "info"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "dark": ""
          }
        }, [_vm._v("\n            mdi-plus\n            ")]), _vm._v("\n            Add Products\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addMoreProducts('Storytell')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Storytell")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addMoreProducts('Amplify')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Amplify")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addMoreProducts('AOK')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("AOK/Uncut")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addMoreProducts('Loading Fees')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Loading Fees")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addMoreProducts('Others')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Others")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.deals.products.length > 0),
      expression: "client.deals.products.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.deals.products.length > 0),
      expression: "client.deals.products.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.client.deals.products), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.getProductName(item.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'storytell'),
        expression: "item.name.toLowerCase() === 'storytell'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-clipboard-list-outline")]), _vm._v(" No. of Campaigns: "), _c('strong', [_vm._v(_vm._s(item.noOfCampaigns))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(item.totalOutReach))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-chart-areaspline ")]), _vm._v(" Total Engagement: "), _c('strong', [_vm._v(_vm._s(item.totalEngagement))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'amplify'),
        expression: "item.name.toLowerCase() === 'amplify'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-file-eye-outline ")]), _vm._v(" Views: "), _c('strong', [_vm._v(_vm._s(item.views))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent || item.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Duration: "), _c('strong', [_vm._v(_vm._s(item.duration) + " Months")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'uncut' || item.name.toLowerCase() === 'aok'),
        expression: "item.name.toLowerCase() === 'uncut' || item.name.toLowerCase() === 'aok'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(item.totalOutReach || '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent || item.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" KPI Onboarded: "), _c('strong', [_vm._v(_vm._s(item.kpiOnboarded || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'loading fees'),
        expression: "item.name.toLowerCase() === 'loading fees'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-bookmark-check-outline")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(item.remark))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'others'),
        expression: "item.name.toLowerCase() === 'others'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-currency-usd")]), _vm._v(" Account Budget: "), _c('strong', [_vm._v(_vm._s(item.budget))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-bookmark-check-outline")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(item.remark))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-file-outline")]), _vm._v(" Nature of deal: "), _c('strong', [_vm._v(_vm._s(_vm.displayNatureOfDeals(item.natureOfDeal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "id": "deleteDealsProduct",
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteProducts(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                      ")], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeDealsModal
    }
  }, [_vm._v("\n            Close\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.addDeals
    }
  }, [_vm._v("\n            Add\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.addDialog),
      callback: function($$v) {
        _vm.addDialog = $$v
      },
      expression: "addDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.showProductName))])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form"
  }, [_c('v-container', [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'amplify'),
      expression: "productName.toLowerCase() === 'amplify'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "mdi-file-eye-outline",
      "label": "Views",
      "placeholder": "Enter views"
    },
    model: {
      value: (_vm.client.moreAccount.views),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "views", _vm._n($$v))
      },
      expression: "client.moreAccount.views"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'amplify'),
      expression: "productName.toLowerCase() === 'amplify'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "mdi-calendar",
      "label": "Duration",
      "placeholder": "Enter No. of months"
    },
    model: {
      value: (_vm.client.moreAccount.duration),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "duration", _vm._n($$v))
      },
      expression: "client.moreAccount.duration"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' && _vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "scatter_plot",
      "label": "Total Outreach",
      "placeholder": "Enter total outreach"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.totalOutReach),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "totalOutReach", _vm._n($$v))
      },
      expression: "client.moreAccount.totalOutReach"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' &&
        _vm.productName.toLowerCase() !== 'uncut' &&
        _vm.productName.toLowerCase() !== 'aok' &&
        _vm.productName.toLowerCase() !== 'others' &&
        _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' &&\n                  productName.toLowerCase() !== 'uncut' &&\n                  productName.toLowerCase() !== 'aok' &&\n                  productName.toLowerCase() !== 'others' &&\n                  productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "score",
      "label": "Total Engagement",
      "placeholder": "Enter total engagement"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.totalEngagement),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "totalEngagement", _vm._n($$v))
      },
      expression: "client.moreAccount.totalEngagement"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "notes",
      "label": "Min. original content",
      "placeholder": "Enter minimum numbers of content"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.minContent),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "minContent", _vm._n($$v))
      },
      expression: "client.moreAccount.minContent"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "sort",
      "label": "Max. original content",
      "placeholder": "Enter maximum numbers of content"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.maxContent),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "maxContent", _vm._n($$v))
      },
      expression: "client.moreAccount.maxContent"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'uncut' || _vm.productName.toLowerCase() === 'aok'),
      expression: "productName.toLowerCase() === 'uncut' || productName.toLowerCase() === 'aok'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "sort",
      "label": "KPI Onboarded",
      "placeholder": "Enter KPI Onboarded"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.kpiOnboarded),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "kpiOnboarded", _vm._n($$v))
      },
      expression: "client.moreAccount.kpiOnboarded"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' && _vm.productName.toLowerCase() !== 'uncut' && _vm.productName.toLowerCase() !== 'aok' && _vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'uncut' && productName.toLowerCase() !== 'aok' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "list_alt",
      "label": "No. of Campaigns",
      "placeholder": "Enter numbers of campaigns"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.maxCampaigns),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "maxCampaigns", _vm._n($$v))
      },
      expression: "client.moreAccount.maxCampaigns"
    }
  }), _vm._v(" "), _c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'others' || _vm.productName.toLowerCase() === 'loading fees'),
      expression: "productName.toLowerCase() === 'others' || productName.toLowerCase() === 'loading fees'"
    }],
    attrs: {
      "filled": "",
      "label": "Remark",
      "placeholder": "Remark",
      "prepend-icon": "mdi-bookmark-check-outline"
    },
    model: {
      value: (_vm.client.moreAccount.remark),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "remark", $$v)
      },
      expression: "client.moreAccount.remark"
    }
  }), _vm._v(" "), _c('v-combobox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'others'),
      expression: "productName.toLowerCase() === 'others'"
    }],
    attrs: {
      "prepend-icon": "mdi-file-outline",
      "label": "Nature of deal",
      "search-input": _vm.newDealNature,
      "items": _vm.dealNatureLists,
      "item-text": "name",
      "item-value": "id",
      "chips": "",
      "multiple": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newDealNature = $event
      },
      "update:search-input": function($event) {
        _vm.newDealNature = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v("Press Enter to Create")]), _vm._v(" "), _c('v-chip', {
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.newDealNature) + "\n                      ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.client.moreAccount.natureOfDeal),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "natureOfDeal", $$v)
      },
      expression: "client.moreAccount.natureOfDeal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeAddProductsModal
    }
  }, [_vm._v("\n          Close\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "info",
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("\n          Add\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Add to Pairing Influencer")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaigns,
      "label": "Select Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaign),
      callback: function($$v) {
        _vm.selectedCampaign = $$v
      },
      expression: "selectedCampaign"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', [_c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-list-item-content', _vm._l((_vm.selectedInfluencers), function(inf, index) {
    return _c('v-list-item-subtitle', {
      key: index
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v(" "), (inf.platform === 'tiktok') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": 'https://www.tiktok.com/@' + inf.instagramHandle
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(inf.instagramHandle))]) : _c('a', {
      attrs: {
        "target": "_blank",
        "href": 'https://instagram.com/' + inf.instagramHandle
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(inf.instagramHandle))], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": !_vm.selectedCampaign
    },
    on: {
      "click": _vm.addtoPairing
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('full-screen-progress', {
    attrs: {
      "show": _vm.bulkProgress.show,
      "isStatus": "true",
      "processing": _vm.bulkProgress.processing,
      "complete": _vm.bulkProgress.complete,
      "color": _vm.secondary
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(_vm.status === _vm.statusINTERESTED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "success",
      "text-color": "white",
      "close-icon": "mdi-check"
    }
  }, [_vm._v("Interested")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTINTERESTED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "red",
      "text-color": "white",
      "close-icon": "mdi-cancel"
    }
  }, [_vm._v("Not Interested")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINVITED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "primary",
      "text-color": "white",
      "close-icon": "mdi-account-clock"
    }
  }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED && (_vm.isAgree === null || _vm.isAgree === undefined)) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "success",
      "text-color": "white",
      "close-icon": "mdi-check"
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTACCEPTED) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "red",
      "text-color": "white",
      "close-icon": "mdi-cancel"
    }
  }, [_vm._v("Not Accepted")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINQUIRY) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "info",
      "text-color": "white",
      "close-icon": "mdi-account-clock"
    }
  }, [_vm._v("Inquiry")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusELIMINATION_PENDING) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "primary",
      "text-color": "white",
      "close-icon": "mdi-account-clock"
    }
  }, [_vm._v("Not Invited")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED && _vm.isAgree === false) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "red",
      "text-color": "white",
      "close-icon": "mdi-cancel"
    }
  }, [_vm._v("Declined")]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED && _vm.isAgree === true) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "close": "",
      "small": "",
      "color": "success",
      "text-color": "white",
      "close-icon": "mdi-check"
    }
  }, [_vm._v("Agreed")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-8"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.title) + " Comments")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.reloadMessage()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "max-height": "300px"
    }
  }, [(_vm.messages.length > 0) ? _c('v-card-text', _vm._l((_vm.messages), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('p', {
      staticClass: "body-2 font-weight-bold"
    }, [_vm._v(_vm._s(msg.author))]), _vm._v(" "), _c('p', {
      staticClass: "body-1 font-weight-medium"
    }, [_vm._v(_vm._s(msg.text))]), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.getRelativeTime(msg.createdAt)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0) : _c('v-card-text', [_c('p', {
    staticClass: "body-1 fong-weight-bold"
  }, [_vm._v("\n        No Comments\n      ")])])], 1), _vm._v(" "), (!_vm.readOnly) ? _c('v-card-actions', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "rows": "2",
      "auto-grow": "",
      "placeholder": "Write your comments here..."
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.readOnly) ? _c('v-btn', {
    attrs: {
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("Add Comment")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Change Post Status")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Current Status",
      "filled": "",
      "disabled": "",
      "value": _vm.displayStatus(_vm.post ? _vm.post.status : null)
    }
  })], 1), _vm._v(" "), _c('v-icon', [_vm._v("mdi-arrow-right-thick")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_options,
      "item-text": "display",
      "item-value": "status",
      "menu-props": {
        maxHeight: '400'
      },
      "label": "New Status",
      "filled": "",
      "hint": "Select new Post Status",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', {
    staticClass: "row pa-2"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("                  \n          " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.CampaignId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CampaignId", $$v)
      },
      expression: "selectedFilter.CampaignId"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterUsers,
      "label": _vm.filterUserLabel,
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.UserId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "UserId", $$v)
      },
      expression: "selectedFilter.UserId"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Year Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.search()
            }
          },
          model: {
            value: (_vm.searchMonth),
            callback: function($$v) {
              _vm.searchMonth = $$v
            },
            expression: "searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.searchMonth),
      callback: function($$v) {
        _vm.searchMonth = $$v
      },
      expression: "searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n                  Cancel\n              ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchMonthOk
    }
  }, [_vm._v("\n                  OK\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.vertical",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.vertical), function(v, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('span', [_vm._v(_vm._s(v.name))])])
        })
      }
    }], null, true)
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content campaign-payout-list"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCampaignPayouts.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "box-body",
    staticStyle: {
      "padding": "5px 25px 0"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignFilterLists,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])]
      }
    }]),
    model: {
      value: (_vm.searchFilters.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.searchFilters, "campaignID", $$v)
      },
      expression: "searchFilters.campaignID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(!_vm.searchFilters.campaignID) ? _c('v-card-title', [_c('v-row', {
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        placeholder: 'Submission Date'
      },
      "date": _vm.searchFilters.submissionDate,
      "status": _vm.subDateCal
    },
    on: {
      "changeDate": _vm.setSubmissionDateFilter
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        placeholder: 'Due Date'
      },
      "date": _vm.searchFilters.dueDate,
      "status": _vm.dueDateCal
    },
    on: {
      "changeDate": _vm.setDueDateFilter
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.searchFilters.campaignID) ? _c('div', [_c('report-payout-lists', {
    attrs: {
      "campaignID": _vm.searchFilters.campaignID,
      "refresh": _vm.refreshPayouts,
      "source": "payout"
    }
  })], 1) : _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.filter
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [(item.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.handle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.handle) + "\n                      ")]) : (item.platform === 'youtube') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://youtube.com/' + item.handle
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'facebook') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://facebook.com/' + item.handle
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'xiaohongshu') ? _c('a', {
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.fullName || item.handle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.handle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle || item.instagram) + "\n                      ")], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.campaignName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.changeDateFormat(item.createdAt)))]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(item.satisfaction_level_on_kobe) + " / 5\n                    ")]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(item.satisfaction_level_on_advertiser) + " / 5\n                    ")]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.promotingProducts) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.promotingProducts,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.improved) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.improved,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.audienceEnjoyment) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.audienceEnjoyment,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.otherCampaigns) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.otherCampaigns,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "115px"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "ims-action",
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.verifyPayout(item)
                    }
                  }
                }, on), [_c('i', {
                  staticClass: "fas fa-money-check-alt"
                })])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Payout Verification")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "ims-action",
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "disabled": _vm.disableViewScreenshot(item)
                  },
                  on: {
                    "click": function($event) {
                      return _vm.viewImages(item)
                    }
                  }
                }, on), [_c('v-icon', [_vm._v("mdi-image-multiple")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Attached Screenshots")])]), _vm._v(" "), (item.uploadMedias.length) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "ims-action",
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "disabled": !item.uploadMedias.length
                  },
                  on: {
                    "click": function($event) {
                      return _vm.downloadInvoice(item)
                    }
                  }
                }, on), [_c('v-icon', [_vm._v("mdi-download")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Download Invoice")])]) : _vm._e()], 1)])
        }), 0)]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\n                  Your search for \"" + _vm._s(_vm.filter) + "\" found no results.\n                ")])]
      },
      proxy: true
    }])
  })], 1)], 1)])])], 1)]), _vm._v(" "), _c('payout-verification-modal', {
    attrs: {
      "payout": _vm.payoutViewData
    },
    on: {
      "payoutAmountUpdated": function($event) {
        return _vm.getAllCampaignPayouts()
      }
    },
    model: {
      value: (_vm.payoutViewDialog),
      callback: function($$v) {
        _vm.payoutViewDialog = $$v
      },
      expression: "payoutViewDialog"
    }
  }), _vm._v(" "), _c('payout-screenshots-dialog', {
    attrs: {
      "value": _vm.viewScreenShotsDialog,
      "imagesToView": _vm.imagesToView
    },
    model: {
      value: (_vm.viewScreenShotsDialog),
      callback: function($$v) {
        _vm.viewScreenShotsDialog = $$v
      },
      expression: "viewScreenShotsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Story Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "story-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15 report-summary-table",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "item-key": "key",
      "items-per-page": -1,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v("@" + _vm._s(item.profileHandle || item.name))])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.replies",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.replies === 0 ? '-' : item.replies)) + "\n                  ")]
      }
    }, {
      key: "item.link_clicks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.link_clicks === 0 ? '-' : item.link_clicks)) + "\n                  ")]
      }
    }, {
      key: "item.sticker_taps",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.sticker_taps === 0 ? '-' : item.sticker_taps)) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.reach === 0 ? '-' : item.reach)) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.impressions === 0 ? '-' : item.impressions)) + "\n                  ")]
      }
    }, {
      key: "item.story_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.story_likes === 0 ? '-' : item.story_likes)) + "\n                  ")]
      }
    }, {
      key: "item.interactions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.interactions === 0 ? '-' : item.interactions)) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.new_engagement_rate === 0 || !item.new_engagement_rate ? '-' : item.new_engagement_rate)) + "\n                  ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n                  ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null ? '-' : item.avg_reels_plays)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'story_likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalStoryLikes === 0 ? '-' : _vm.totalStoryLikes)))] : (header.value === 'replies') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReplies === 0 ? '-' : _vm.totalReplies)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'link_clicks') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLinkClicks === 0 ? '-' : _vm.totalLinkClicks)))] : (header.value === 'sticker_taps') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalStickerTaps === 0 ? '-' : _vm.totalStickerTaps)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalNewEngagementRate === 0 ? '-' : _vm.totalNewEngagementRate)))] : (header.value === 'avg_views') ? [_vm._v("-")] : (header.value === 'avg_reels_plays') ? [_vm._v("-")] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Story Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateStoryAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', {
    staticClass: "client-login-background"
  }, [_c('v-container', {
    staticClass: "fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "8",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "height": "150",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "client-login-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Kobe"
    }
  })]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "title text-center"
  }, [_vm._v("Advertiser Login")]), _vm._v(" "), _c('v-form', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.emailErrors,
      "prepend-icon": "person",
      "name": "login",
      "label": "Login",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.passwordErrors,
      "id": "password",
      "prepend-icon": "lock",
      "name": "password",
      "label": "Password",
      "type": "password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkCreds()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.checkCreds()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-center": "",
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/forgot-password"
    }
  }, [_vm._v("Forgot password?")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "title text-center"
  }, [_vm._v("\n                For Influencers "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "dark": "",
      "to": "login"
    }
  }, [_vm._v("\n                    Go to Influencer Login\n                  ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n                By logging in, you confirm that you have read the\n                "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/website-terms-use/",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" , that you understand them and that you agree to be bound by them.\n              ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "dark": "",
      "height": "auto",
      "color": "#1A1A1A"
    }
  }, [_c('v-row', {
    attrs: {
      "row": "",
      "wrap": "",
      "white--text": "",
      "text-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Singapore")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "tel:+6562555662"
    }
  }, [_vm._v("6255 5662")]), _vm._v(" /\n          "), _c('a', {
    attrs: {
      "href": "mailto:creator@getkobe.com"
    }
  }, [_vm._v("creator@getkobe.com")]), _vm._v(" "), _c('br'), _vm._v("51 Goldhill Plaza #14-01 Singapore 308900\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('br'), _vm._v("Website\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n          "), _c('br'), _vm._v("\n          All Rights Reserved © 2016-" + _vm._s(_vm.year) + " Kobe Global Technologies Pte Ltd\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center mb-0 pt-2"
  }, [_vm._v("\n          Patent: "), _c('a', {
    attrs: {
      "href": "https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1",
      "target": "_blank"
    }
  }, [_vm._v(" KOBE 11201807777W ℗ ")])])])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "#A3FF12",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Update Handle for "), (_vm.report && _vm.report.instagram) ? _c('span', [_vm._v(" @" + _vm._s(_vm.report.instagram))]) : _vm._e()]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-select', {
    attrs: {
      "dense": "",
      "placeholder": "Platform",
      "items": _vm.platforms,
      "error-messages": _vm.$v.updateData.platform.$error && "Platform is required.",
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.platform.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.platform.$touch()
      },
      "change": function($event) {
        return _vm.changePlatform()
      }
    },
    model: {
      value: (_vm.updateData.platform),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "platform", $$v)
      },
      expression: "updateData.platform"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-select', {
    attrs: {
      "dense": "",
      "placeholder": "Handle",
      "items": _vm.viewPlatforms,
      "error-messages": _vm.$v.updateData.handle.$error && "Handle is required.",
      "outlined": "",
      "attach": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.handle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.handle.$touch()
      }
    },
    model: {
      value: (_vm.updateData.handle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "handle", $$v)
      },
      expression: "updateData.handle"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Change Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.errorMessage !== null,
      "dismissible": "",
      "variant": "danger"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])])], 1), _vm._v(" "), _c('form', [_c('v-container', {
    staticClass: "remove-padding",
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": _vm.show.oldPassword ? 'visibility_off' : 'visibility',
      "type": _vm.show.oldPassword ? 'text' : 'password',
      "error-messages": _vm.currentPasswordErrors,
      "autocomplete": "current-password",
      "name": "current-password",
      "label": "Current Password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.oldPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.oldPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.oldPassword = !_vm.show.oldPassword
      }
    },
    model: {
      value: (_vm.user.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "oldPassword", $$v)
      },
      expression: "user.oldPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "error-messages": _vm.passwordError,
      "append-icon": _vm.show.password ? 'visibility_off' : 'visibility',
      "type": _vm.show.password ? 'text' : 'password',
      "autocomplete": "new-password",
      "name": "new-password",
      "color": "#1687c0",
      "label": "New Password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.password = !_vm.show.password
      }
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "append-icon": _vm.show.repeatPassword ? 'visibility_off' : 'visibility',
      "type": _vm.show.repeatPassword ? 'text' : 'password',
      "error-messages": _vm.repeatPasswordErrors,
      "name": "repeat-password",
      "autocomplete": "new-password",
      "label": "Repeat Password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.repeatPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.repeatPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.repeatPassword = !_vm.show.repeatPassword
      }
    },
    model: {
      value: (_vm.user.repeatPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "repeatPassword", $$v)
      },
      expression: "user.repeatPassword"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "disabled": _vm.$v.user.$invalid
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Change Password")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.campaignList), function(campaign, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "md6": "",
        "sm12": "",
        "lg4": ""
      }
    }, [_c('v-card', {
      staticStyle: {
        "min-height": "170px"
      },
      attrs: {
        "color": "#363636",
        "dark": ""
      }
    }, [_c('v-card-title', {
      staticStyle: {
        "font-size": "23px"
      }
    }, [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-5"
    }, [_c('div', {
      staticClass: "text-right"
    }, [_c('v-btn', {
      attrs: {
        "to": '/reports/campaign/summary?id=' + campaign.id,
        "target": "_blank",
        "color": "warning",
        "right": ""
      }
    }, [_vm._v("View HTML Report")])], 1)])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.showTitle))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.checkLists)
    }
  }), _vm._v(" "), (_vm.dateCol === 'overallAlignmentCol') ? _c('div', [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('p', {
    staticClass: "mb-0 pt-3 pr-2"
  }, [_vm._v("Alignment Sync Date - ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "edit-date-box",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkDate(_vm.alignmentSyncDate)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkDate(_vm.alignmentSyncDate)
      }
    },
    model: {
      value: (_vm.alignmentSyncDate),
      callback: function($$v) {
        _vm.alignmentSyncDate = $$v
      },
      expression: "alignmentSyncDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon'
      },
      "status": _vm.dateCal
    },
    on: {
      "changeDate": _vm.setDateFromPicker
    }
  })], 1)], 1), _vm._v(" "), (_vm.alignementSyncErr) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Please enter valid Alignment Sync Date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.dateCol === 'approvedByAdminCol') ? _c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Please check and confirm these steps below")]), _vm._v(" "), _c('ol', {
    staticClass: "text-left body-1"
  }, [_c('li', [_vm._v("Stats and Sentiment Due Date - "), _c('b', [_vm._v(_vm._s(_vm.item.SentimentDateCol && _vm.item.SentimentDateCol.status ? 'Ready' : 'Not Ready!'))])]), _vm._v(" "), _c('li', [_vm._v("Completed by CC - "), _c('b', [_vm._v(_vm._s(_vm.item.CCReadyDeckCol && _vm.item.CCReadyDeckCol.status ? 'Ready' : 'Not Ready!'))])]), _vm._v(" "), _c('li', [_vm._v("Completed by AM - "), _c('b', [_vm._v(_vm._s(_vm.item.AMReadyDeckCol && _vm.item.AMReadyDeckCol.status ? 'Ready' : 'Not Ready!'))])]), _vm._v(" "), _c('li', [_vm._v("Alignment Sync - "), _c('b', [_vm._v(_vm._s(_vm.item.overallAlignmentCol && _vm.item.overallAlignmentCol.status ? ("Ready (" + (_vm.item.overallAlignmentCol.alignmentDate) + ")") : 'Not Ready!'))])])]), _vm._v(" "), (_vm.item.SentimentDateCol && _vm.item.SentimentDateCol.reviewDateURL) ? _c('div', {
    staticClass: "pl-2"
  }, [_c('p', {
    staticClass: "mb-0 subtitle-2"
  }, [_vm._v("Review Deck URL")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.item.SentimentDateCol.reviewDateURL
    }
  }, [_vm._v(_vm._s(_vm.item.SentimentDateCol.reviewDateURL))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": !_vm.isConfirmAllowed
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('v-card-text', [_c('v-row', _vm._l((_vm.posts), function(post, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4"
      }
    }, [_c('Post', {
      attrs: {
        "post": post,
        "isSelected": _vm.selectedPostIds.has(post.shortcode)
      },
      on: {
        "selected": function($event) {
          return _vm.$emit('onSelect', post)
        }
      }
    })], 1)
  }), 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "tile": "",
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev_page')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v(" Back ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "tile": "",
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next_page')
      }
    }
  }, [_vm._v(" Next"), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2094 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "col": "6"
    }
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('import')) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.income.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-home-import-outline")]), _vm._v("Import\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-autorenew")]), _vm._v("Refresh\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalAmount,
      "title": 'Total payment',
      "subtitle": 'Total payment received'
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalThisWeek,
      "title": 'Total this week',
      "subtitle": _vm.thisWeek
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalThisMonth,
      "title": 'Total this month',
      "subtitle": _vm.thisMonth
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalDiscount,
      "title": 'Total discount',
      "subtitle": 'Total discount'
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "hint": "Press 'Enter' to search",
      "hide-detail": "auto",
      "placeholder": "Supplier/Customer, Reference No., Voucher No.",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filter()
      }
    },
    model: {
      value: (_vm.searchKeyWords),
      callback: function($$v) {
        _vm.searchKeyWords = $$v
      },
      expression: "searchKeyWords"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.pagging,
      "server-items-length": _vm.totalItems
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.debit",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.debit)))]
      }
    }, {
      key: "item.credit",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.credit)))]
      }
    }, (_vm.buttonShow('actions')) ? {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "small": "",
                  "dense": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("Actions")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(action, index) {
          return _c('v-list-item', {
            key: index,
            on: {
              "click": function($event) {
                return _vm.doAction(action.value, item)
              }
            }
          }, [_c('v-list-item-title', [_vm._v(_vm._s(action.title))])], 1)
        }), 1)], 1)]
      }
    } : null], null, true)
  }), _vm._v(" "), _c('create-payment-record', {
    attrs: {
      "value": _vm.createPayoutModal,
      "mode": _vm.mode,
      "data": _vm.data
    },
    on: {
      "created": _vm.payoutCreated
    },
    model: {
      value: (_vm.createPayoutModal),
      callback: function($$v) {
        _vm.createPayoutModal = $$v
      },
      expression: "createPayoutModal"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "income",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "income"
    },
    on: {
      "change": _vm.perpareImport
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': _vm.$v.influencer.handle.$error
    }
  }, [_c('label', [_vm._v("Influencer handle")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.influencer.handle),
      expression: "influencer.handle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter influencer name"
    },
    domProps: {
      "value": (_vm.influencer.handle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.influencer, "handle", $event.target.value)
      }, function($event) {
        return _vm.$v.influencer.handle.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.influencer.handle.required && _vm.$v.influencer.handle.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Influencer name is required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createInfluencer
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Create new influencer\n        ")])])
}]}

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Assign Campaign to the Post\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [(_vm.postData !== null) ? _c('p', [_vm._v("\n        Inputted name from Creator: "), _c('span', {
    staticClass: "font-italic"
  }, [_vm._v(_vm._s(_vm.postData.campaignName))])]) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignList,
      "label": "Choose Campaigns in IMS:",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaignID),
      callback: function($$v) {
        _vm.selectedCampaignID = $$v
      },
      expression: "selectedCampaignID"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.assignCampaign()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "id": "content-story-form",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content xs12 pt-2 md12"
  }, [_c('div', {
    staticClass: "storyboard-page-toolbar"
  }, [(_vm.isCreateMode) ? _c('h2', {
    staticClass: "form-title mb-0"
  }, [_vm._v("Content Storyboard Flow")]) : _vm._e(), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
    staticClass: "version-history-toggle",
    attrs: {
      "color": "secondary",
      "text": "",
      "aria-expanded": _vm.showVersionHistory ? 'true' : 'false'
    },
    on: {
      "click": function($event) {
        _vm.showVersionHistory = !_vm.showVersionHistory
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-history")]), _vm._v("\n                  " + _vm._s(_vm.showVersionHistory ? 'Hide history' : 'Version history') + "\n                  "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v(_vm._s(_vm.showVersionHistory ? 'mdi-chevron-left' : 'mdi-chevron-right'))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "storyboard-workspace"
  }, [_c('v-slide-x-transition', [(_vm.isInternalView && _vm.showVersionHistory) ? _c('aside', {
    staticClass: "version-history-column"
  }, [_c('v-card', {
    staticClass: "version-history-card"
  }, [_c('v-card-title', {
    staticClass: "version-history-title"
  }, [_vm._v("\n                        Version History\n                      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "version-history-list"
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.contentScriptVersions), function(hpost, i) {
    return [_c('v-list-item', {
      key: hpost.id + i,
      class: {
        'version-history-item--selected': hpost.id === _vm.creatorConceptData.id
      },
      on: {
        "click": function($event) {
          return _vm.switchVersion(hpost)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                                " + _vm._s(hpost.versionNo) + " " + _vm._s(hpost.isMain ? "(Active)" : '') + "\n                              ")]), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                                " + _vm._s(hpost.isMain ? ("" + (_vm.formatDate(hpost.createdAt))) : _vm.formatDate(hpost.createdAt)) + "\n                              ")])], 1), _vm._v(" "), (hpost.id === _vm.creatorConceptData.id) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), (hpost.id !== _vm.creatorConceptData.id && hpost.id === _vm.mainData.id) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_circle_outline")])], 1) : _vm._e()], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "version-history-actions"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setMainVersion(_vm.creatorConceptData.id)
      }
    }
  }, [_vm._v("\n                            Change to this version\n                        ")])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "storyboard-editor-column"
  }, [(_vm.creatorConceptData.approved) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "dense": ""
    }
  }, [_vm._v("\n                        Approved\n                      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "px-5 pt-0 clearfix",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "col-xs-12 col-md-12 pb-0"
  }, [_c('div', {
    staticClass: "storyboard-header"
  }, [_c('div', {
    staticClass: "storyboard-meta"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Campaign Name")]), _vm._v(": \n                                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.campaignName))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Creator Handle")]), _vm._v(": \n                                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.creatorHandle))])])]), _vm._v(" "), (_vm.isCreateMode) ? _c('div', {
    staticClass: "avatar-logo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "KOBE Logo"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Draft Submission Date")]), _vm._v(": \n                            "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.submissionDate))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Deliverable Details")]), _vm._v(": \n                            "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.creatorConceptData.deliverableLists))])])]), _vm._v(" "), _vm._l((_vm.creatorConceptData.deliverables), function(deliItem, deliIndex) {
    return _c('div', {
      key: deliIndex
    }, [_c('v-col', {
      staticClass: "col-xs-12 col-md-12 pt-1 pb-1",
      staticStyle: {
        "background": "rgb(244, 244, 244)"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 pt-0 pb-0"
    }, [_vm._v(_vm._s(deliItem.title))]), _vm._v(" "), _c('div', [_c('v-menu', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (deliItem.showChat),
        expression: "deliItem.showChat"
      }],
      attrs: {
        "close-on-content-click": false,
        "bottom": "",
        "offset-x": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [(_vm.isCommentSection) ? _c('v-badge', {
            staticStyle: {
              "margin-left": "-10px"
            },
            attrs: {
              "value": deliItem.comments ? deliItem.comments.length : '',
              "content": deliItem.comments ? deliItem.comments.length : '',
              "color": "black",
              "overlap": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.showChatBox(deliIndex)
              }
            }
          }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
            staticStyle: {
              "padding": "0",
              "min-width": "34px"
            },
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.showChatBox(deliIndex)
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', {
            attrs: {
              "color": "secondary"
            }
          }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-card', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "max-width": "300"
      }
    }, [_c('v-card-text', {
      staticStyle: {
        "background-color": "#fff",
        "padding": "0"
      }
    }, [_c('chatbox', {
      attrs: {
        "messages": deliItem.comments,
        "title": ""
      },
      on: {
        "sendMessage": function($event) {
          return _vm.sendComment(deliItem.id, $event)
        }
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (deliItem.showComment),
        expression: "deliItem.showComment"
      }],
      staticClass: "putComment"
    }, [_c('span', [_vm._v("Put your comments here")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.closePutComment(deliIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "white"
      }
    }, [_vm._v("mdi-close-circle")])], 1)])], 1)])]), _vm._v(" "), (deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn') ? _c('div', [_c('v-col', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "d-flex row col mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.concept),
        callback: function($$v) {
          _vm.$set(deliItem, "concept", $$v)
        },
        expression: "deliItem.concept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex row col mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Reason for concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.reasonConcept),
        callback: function($$v) {
          _vm.$set(deliItem, "reasonConcept", $$v)
        },
        expression: "deliItem.reasonConcept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex row col mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Music choice:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.musicChoice),
        callback: function($$v) {
          _vm.$set(deliItem, "musicChoice", $$v)
        },
        expression: "deliItem.musicChoice"
      }
    })], 1)]), _vm._v(" "), _vm._l((deliItem.boxes), function(boxItem, boxIdx) {
      return _c('v-col', {
        key: boxIdx,
        staticClass: "col-xs-12 col-md-12 d-flex flex-row"
      }, [_c('v-flex', {
        staticClass: "xs12"
      }, [_c('table', {
        staticClass: "content-script-table",
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "dense": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                          Descriptions of scenes/ footage\n                                        ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                          Include text overlays / voiceover script in each scene\n                                        ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                          Reference links/images\n                                        ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
        staticClass: "d-flex flex-row align-center justify-space-between mb-1"
      }, [_c('span', {
        staticClass: "tbl-inner-title"
      }, [_vm._v("INTRO: (can be hook/ theme/ title of your video)")]), _vm._v(" "), _c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.scenesInfo
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChat),
          expression: "boxItem.showChat"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.introComments ? boxItem.introComments.length : '',
                "content": boxItem.introComments ? boxItem.introComments.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showChatBox(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showChatBox(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.introComments,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendComment(boxItem.id, $event, 'introComments')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.scenesInfo,
          "width": "100%",
          "height": "150"
        },
        model: {
          value: (boxItem.scenesInfo),
          callback: function($$v) {
            _vm.$set(boxItem, "scenesInfo", $$v)
          },
          expression: "boxItem.scenesInfo"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('p', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "150px",
          "max-height": "150px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.scenesInfo))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "text-right mb-1",
        staticStyle: {
          "min-height": "18px"
        }
      }, [_c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.briefText
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatTwo),
          expression: "boxItem.showChatTwo"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.introCommentsTwo ? boxItem.introCommentsTwo.length : '',
                "content": boxItem.introCommentsTwo ? boxItem.introCommentsTwo.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.introCommentsTwo,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendCommentTwo(boxItem.id, $event, 'introCommentsTwo')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.briefText,
          "width": "100%",
          "height": "150"
        },
        model: {
          value: (boxItem.briefText),
          callback: function($$v) {
            _vm.$set(boxItem, "briefText", $$v)
          },
          expression: "boxItem.briefText"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "150px",
          "max-height": "150px",
          "overflow-y": "auto",
          "margin-top": "5px"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.briefText))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', {
        staticClass: "reference-cell",
        attrs: {
          "rowspan": "3"
        }
      }, [_c('div', {
        staticClass: "reference-upload-list"
      }, [_vm._l((boxItem.images), function(item, imgIdx) {
        return _c('div', {
          key: imgIdx,
          staticClass: "reference-upload-card"
        }, [_c('div', {
          staticClass: "reference-upload-header"
        }, [_c('span', {
          staticClass: "reference-upload-title"
        }, [_vm._v("Reference " + _vm._s(imgIdx + 1))]), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn', {
          staticClass: "reference-remove-btn",
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteImage(deliIndex, boxIdx, imgIdx)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "red",
            "small": ""
          }
        }, [_vm._v("mdi-close-circle")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn-toggle', {
          staticClass: "reference-type-toggle",
          attrs: {
            "mandatory": "",
            "dense": ""
          },
          model: {
            value: (item.refLinkType),
            callback: function($$v) {
              _vm.$set(item, "refLinkType", $$v)
            },
            expression: "item.refLinkType"
          }
        }, [_c('v-btn', {
          attrs: {
            "value": "upload",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-image-outline")]), _vm._v("\n                                                  Image\n                                                ")], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "value": "link",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-link-variant")]), _vm._v("\n                                                  Link\n                                                ")], 1)], 1) : _vm._e(), _vm._v(" "), (item.refLinkType === 'upload') ? _c('div', {
          staticClass: "reference-upload-dropzone",
          class: {
            'has-file': item.imgName
          }
        }, [_c('v-icon', {
          staticClass: "reference-upload-icon",
          attrs: {
            "color": "secondary"
          }
        }, [_vm._v("\n                                                  " + _vm._s(item.imgName ? 'mdi-check-circle' : 'mdi-cloud-upload-outline') + "\n                                                ")]), _vm._v(" "), _c('div', {
          staticClass: "reference-upload-copy"
        }, [(item.imgName) ? _c('a', {
          attrs: {
            "href": item.imgUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getReferenceFileName(item)))]) : _vm._e(), _vm._v(" "), (!item.imgName) ? _c('span', [_vm._v("Upload image")]) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('small', [_vm._v("Select multiple files to add references at once")]) : _vm._e()]), _vm._v(" "), (_vm.isNotClient) ? _c('direct-file-upload', {
          staticClass: "reference-upload-action",
          attrs: {
            "icon-only": true,
            "multiple": true
          },
          on: {
            "setMedias": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.uploadFile.apply(void 0, [ deliIndex, boxIdx, imgIdx ].concat( argsArray ))
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.refLinkType === 'link') ? _c('v-text-field', {
          staticClass: "purple-input reference-link-field",
          attrs: {
            "dense": "",
            "disabled": _vm.isClient,
            "type": "textbox",
            "outlined": "",
            "required": "",
            "hide-details": "",
            "placeholder": "Paste reference link"
          },
          model: {
            value: (item.link),
            callback: function($$v) {
              _vm.$set(item, "link", $$v)
            },
            expression: "item.link"
          }
        }) : _vm._e()], 1)
      }), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn', {
        staticClass: "reference-add-btn",
        attrs: {
          "small": "",
          "text": ""
        },
        on: {
          "click": function($event) {
            return _vm.addImage(deliIndex, boxIdx)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v("\n                                              Add reference\n                                            ")], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
        staticClass: "d-flex flex-row align-center justify-space-between mb-1"
      }, [_c('span', {
        staticClass: "tbl-inner-title"
      }, [_vm._v("BODY")]), _vm._v(" "), _c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.bodyInfo
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatBody),
          expression: "boxItem.showChatBody"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.bodyComments ? boxItem.bodyComments.length : '',
                "content": boxItem.bodyComments ? boxItem.bodyComments.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showBodyChatBox(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showBodyChatBox(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.bodyComments,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendBodyComment(boxItem.id, $event, 'bodyComments')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        staticClass: "body-info-txt",
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.bodyInfo,
          "width": "100%",
          "height": "420"
        },
        model: {
          value: (boxItem.bodyInfo),
          callback: function($$v) {
            _vm.$set(boxItem, "bodyInfo", $$v)
          },
          expression: "boxItem.bodyInfo"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('p', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "420px",
          "max-height": "420px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.bodyInfo))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "text-right mb-1",
        staticStyle: {
          "min-height": "18px"
        }
      }, [_c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.briefText
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatBodyTwo),
          expression: "boxItem.showChatBodyTwo"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.bodyChatTwo ? boxItem.bodyChatTwo.length : '',
                "content": boxItem.bodyChatTwo ? boxItem.bodyChatTwo.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showBodyChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showBodyChatBoxTwo(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.bodyChatTwo,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendBodyCommentTwo(boxItem.id, $event, 'bodyChatTwo')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        staticClass: "body-info-txt",
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.briefText,
          "width": "100%",
          "height": "420"
        },
        model: {
          value: (boxItem.briefPointer),
          callback: function($$v) {
            _vm.$set(boxItem, "briefPointer", $$v)
          },
          expression: "boxItem.briefPointer"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "420px",
          "max-height": "420px",
          "overflow-y": "auto",
          "margin-top": "5px"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.briefPointer))
        }
      }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "d-flex flex-row align-center justify-space-between mb-1"
      }, [_c('span', {
        staticClass: "tbl-inner-title"
      }, [_vm._v("CTA (input your final CTA scene, not caption)")]), _vm._v(" "), _c('div', {
        staticClass: "editor-header-actions"
      }, [(_vm.isNotClient) ? _c('editor-format-info', {
        attrs: {
          "format": _vm.storyboardPlaceholders.callToAction
        }
      }) : _vm._e(), _vm._v(" "), _c('v-menu', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (boxItem.showChatCta),
          expression: "boxItem.showChatCta"
        }],
        attrs: {
          "close-on-content-click": false,
          "bottom": "",
          "offset-x": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;
            var attrs = ref.attrs;

            return [(_vm.isCommentSection) ? _c('v-badge', {
              staticStyle: {
                "margin-left": "-10px"
              },
              attrs: {
                "value": boxItem.ctaComments ? boxItem.ctaComments.length : '',
                "content": boxItem.ctaComments ? boxItem.ctaComments.length : '',
                "color": "black",
                "overlap": ""
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.showCtaChatBox(deliIndex, boxIdx)
                }
              }
            }, [(_vm.isCommentSection) ? _c('v-btn', _vm._g(_vm._b({
              staticStyle: {
                "padding": "0",
                "min-width": "34px"
              },
              attrs: {
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.showCtaChatBox(deliIndex, boxIdx)
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', {
              attrs: {
                "color": "secondary"
              }
            }, [_vm._v("chat")])], 1) : _vm._e()], 1) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-card', {
        staticStyle: {
          "text-align": "left"
        },
        attrs: {
          "max-width": "300"
        }
      }, [_c('v-card-text', {
        staticStyle: {
          "background-color": "#fff",
          "padding": "0"
        }
      }, [_c('chatbox', {
        attrs: {
          "messages": boxItem.ctaComments,
          "title": ""
        },
        on: {
          "sendMessage": function($event) {
            return _vm.sendCtaComment(boxItem.id, $event, 'ctaComments')
          }
        }
      })], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
        attrs: {
          "button-list": _vm.storyboardToolbar,
          "placeholder": _vm.storyboardPlaceholders.callToAction,
          "width": "100%",
          "height": "150"
        },
        model: {
          value: (boxItem.callToAction),
          callback: function($$v) {
            _vm.$set(boxItem, "callToAction", $$v)
          },
          expression: "boxItem.callToAction"
        }
      }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('p', {
        staticClass: "cp",
        staticStyle: {
          "min-height": "150px",
          "max-height": "150px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(boxItem.callToAction))
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', {
        staticClass: "pa-2"
      })])])])])], 1)
    })], 2) : _vm._e(), _vm._v(" "), (deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn') ? _c('div', [_c('v-col', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "d-flex flex-row mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.concept),
        callback: function($$v) {
          _vm.$set(deliItem, "concept", $$v)
        },
        expression: "deliItem.concept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-row mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Reason for concept:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.reasonConcept),
        callback: function($$v) {
          _vm.$set(deliItem, "reasonConcept", $$v)
        },
        expression: "deliItem.reasonConcept"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-row mb-2"
    }, [_c('span', {
      staticClass: "h4 font-weight-bold mb-2 col-2",
      staticStyle: {
        "min-width": "160px"
      }
    }, [_vm._v("Music choice:")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "disabled": _vm.isClient,
        "outlined": "",
        "required": "",
        "dense": "",
        "hide-details": "",
        "rows": "5"
      },
      model: {
        value: (deliItem.musicChoice),
        callback: function($$v) {
          _vm.$set(deliItem, "musicChoice", $$v)
        },
        expression: "deliItem.musicChoice"
      }
    })], 1)]), _vm._v(" "), _vm._l((deliItem.boxes), function(boxItem, boxIdx) {
      return _c('v-col', {
        key: boxIdx,
        staticClass: "col-xs-12 col-md-12"
      }, [_c('table', {
        staticClass: "content-script-table carousel-content-table",
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "dense": ""
        }
      }, [_c('thead', [_c('tr', [_c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "5%"
        }
      }, [_vm._v("\n                                        IMAGE\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "40%"
        }
      }, [_vm._v("\n                                        Description of image/gif\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "30%"
        }
      }, [_vm._v("\n                                        Text on image (if any)\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "20%"
        }
      }, [_vm._v("\n                                        Reference image\n                                      ")]), _vm._v(" "), _c('th', {
        staticClass: "text-left",
        attrs: {
          "width": "5%"
        }
      })])]), _vm._v(" "), _c('tbody', _vm._l((boxItem.images), function(imgRow, imgRowIndex) {
        return _c('tr', {
          key: imgRow.id
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n                                        " + _vm._s(imgRowIndex + 1) + "\n                                      ")]), _vm._v(" "), _c('td', {
          staticClass: "pt-0"
        }, [(_vm.isCommentSection) ? _c('editor-comments', {
          attrs: {
            "messages": imgRow.imgDescriptionComments,
            "title": "Image description"
          },
          on: {
            "sendMessage": function($event) {
              return _vm.sendComment(imgRow.id, $event, 'imgDescriptionComments')
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
          attrs: {
            "button-list": _vm.storyboardToolbar,
            "placeholder": "",
            "width": "100%",
            "height": "150"
          },
          model: {
            value: (imgRow.imgDescription),
            callback: function($$v) {
              _vm.$set(imgRow, "imgDescription", $$v)
            },
            expression: "imgRow.imgDescription"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
          staticClass: "cp",
          staticStyle: {
            "min-height": "150px",
            "max-height": "150px",
            "overflow-y": "auto",
            "margin-top": "5px"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.renderHTML(imgRow.imgDescription))
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "pt-0"
        }, [(_vm.isCommentSection) ? _c('editor-comments', {
          attrs: {
            "messages": imgRow.textImageComments,
            "title": "Text on image"
          },
          on: {
            "sendMessage": function($event) {
              return _vm.sendComment(imgRow.id, $event, 'textImageComments')
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('sun-editor', {
          attrs: {
            "button-list": _vm.storyboardToolbar,
            "placeholder": "",
            "width": "100%",
            "height": "150"
          },
          model: {
            value: (imgRow.textImage),
            callback: function($$v) {
              _vm.$set(imgRow, "textImage", $$v)
            },
            expression: "imgRow.textImage"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.isClient) ? _c('div', {
          staticClass: "cp",
          staticStyle: {
            "min-height": "150px",
            "max-height": "150px",
            "overflow-y": "auto",
            "margin-top": "5px"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.renderHTML(imgRow.textImage))
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "pt-0"
        }, [_c('div', {
          staticClass: "reference-upload-card carousel-reference-card"
        }, [(_vm.isNotClient) ? _c('v-btn-toggle', {
          staticClass: "reference-type-toggle",
          attrs: {
            "mandatory": "",
            "dense": ""
          },
          model: {
            value: (imgRow.refLinkType),
            callback: function($$v) {
              _vm.$set(imgRow, "refLinkType", $$v)
            },
            expression: "imgRow.refLinkType"
          }
        }, [_c('v-btn', {
          attrs: {
            "value": "upload",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-image-outline")]), _vm._v("\n                                              Image\n                                            ")], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "value": "link",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-link-variant")]), _vm._v("\n                                              Link\n                                            ")], 1)], 1) : _vm._e(), _vm._v(" "), (imgRow.refLinkType === 'link') ? _c('v-text-field', {
          staticClass: "purple-input reference-link-field",
          attrs: {
            "dense": "",
            "type": "textbox",
            "outlined": "",
            "required": "",
            "hide-details": "",
            "placeholder": "Paste reference link"
          },
          model: {
            value: (imgRow.link),
            callback: function($$v) {
              _vm.$set(imgRow, "link", $$v)
            },
            expression: "imgRow.link"
          }
        }) : _vm._e(), _vm._v(" "), (imgRow.refLinkType === 'upload') ? _c('div', {
          staticClass: "reference-upload-dropzone",
          class: {
            'has-file': imgRow.imgName
          }
        }, [_c('v-icon', {
          staticClass: "reference-upload-icon",
          attrs: {
            "color": "secondary"
          }
        }, [_vm._v("\n                                              " + _vm._s(imgRow.imgName ? 'mdi-check-circle' : 'mdi-cloud-upload-outline') + "\n                                            ")]), _vm._v(" "), _c('div', {
          staticClass: "reference-upload-copy"
        }, [(imgRow.imgName) ? _c('a', {
          attrs: {
            "href": imgRow.imgUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getReferenceFileName(imgRow)))]) : _vm._e(), _vm._v(" "), (!imgRow.imgName) ? _c('span', [_vm._v("Upload image")]) : _vm._e(), _vm._v(" "), (_vm.isNotClient) ? _c('small', [_vm._v("Select multiple files to add rows at once")]) : _vm._e()]), _vm._v(" "), (_vm.isNotClient) ? _c('direct-file-upload', {
          staticClass: "reference-upload-action",
          attrs: {
            "icon-only": true,
            "multiple": true
          },
          on: {
            "setMedias": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.uploadFile.apply(void 0, [ deliIndex, boxIdx, imgRowIndex ].concat( argsArray ))
            }
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('td', [(_vm.isNotClient) ? _c('v-btn', {
          attrs: {
            "color": "danger",
            "text": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteImage(deliIndex, boxIdx, imgRowIndex)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("mdi-close-circle")])], 1) : _vm._e()], 1)])
      }), 0)]), _vm._v(" "), (_vm.isNotClient) ? _c('v-btn', {
        staticClass: "reference-add-btn",
        attrs: {
          "small": "",
          "text": ""
        },
        on: {
          "click": function($event) {
            return _vm.addIgCarousel(deliIndex, boxIdx)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "small": ""
        }
      }, [_vm._v("mdi-plus")]), _vm._v("\n                                Add reference\n                              ")], 1) : _vm._e()], 1)
    })], 2) : _vm._e()], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.isNotClient) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": _vm.submitCreatorConcept
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                        Submit\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.isClient && !_vm.creatorConceptData.approved) ? _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": _vm.approveCreatorConcept
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                        Approve\n                      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.creatorConceptData.versionNo) ? _c('v-col', {
    staticClass: "text-left pl-5",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.creatorConceptData.versionNo) + ", " + _vm._s(_vm.formatDate(_vm.creatorConceptData.createdAt)) + "\n                    ")]) : _vm._e()], 1)], 1)], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.imgLoading),
      callback: function($$v) {
        _vm.imgLoading = $$v
      },
      expression: "imgLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n          Uploading...\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('version-no-modal', {
    on: {
      "updated": _vm.reload,
      "success": _vm.saveWithVersion
    },
    model: {
      value: (_vm.showVersionDialog),
      callback: function($$v) {
        _vm.showVersionDialog = $$v
      },
      expression: "showVersionDialog"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "blue-grey",
      "disabled": _vm.checkDisable
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title ? _vm.title : 'Upload') + "\n    "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("\n      mdi-cloud-upload\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.tmpImages.length > 0) ? _c('div', _vm._l((_vm.tmpImages), function(img, index) {
    return _c('v-col', {
      key: index,
      staticClass: "d-flex child-flex",
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "2"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "d-flex",
            attrs: {
              "flat": "",
              "tile": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.url,
              "lazy-src": img.url,
              "aspect-ratio": "1"
            }
          }), _vm._v(" "), _c('v-overlay', {
            attrs: {
              "absolute": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "dark": "",
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteImage(index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "dark": "",
              "color": "red"
            }
          }, [_vm._v("cancel")])], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tmpFiles.length > 0) ? _c('v-row', _vm._l((_vm.tmpFiles), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "2",
        "align": "center"
      }
    }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/pdf.png",
        "aspect-ratio": "1"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/ppt.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/doc.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/text.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx",
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-2"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.title) + " Comments")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "max-height": "300px"
    }
  }, [(_vm.messages.length > 0) ? _c('v-card-text', {
    staticStyle: {
      "padding": "0"
    }
  }, _vm._l((_vm.messages), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('p', {
      staticClass: "body-2 mb-1 font-weight-bold"
    }, [_vm._v(_vm._s(msg.author))]), _vm._v(" "), _c('p', {
      staticClass: "body-1 mb-1 font-weight-medium",
      domProps: {
        "innerHTML": _vm._s(_vm.renderHTML(msg.text))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.getRelativeTime(msg.createdAt)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0) : _c('v-card-text', [_c('p', {
    staticClass: "body-1 mb-0 fong-weight-bold"
  }, [_vm._v("\n          No Comments\n        ")])])], 1), _vm._v(" "), (!_vm.readOnly) ? _c('v-card-actions', [_c('v-textarea', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    },
    attrs: {
      "outlined": "",
      "rows": "3",
      "auto-grow": "",
      "placeholder": "Write your comments here..."
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.readOnly) ? _c('v-btn', {
    attrs: {
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("Add Comment")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('client-quality-rating', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.CLIENT_RATING.title,
      "headers": _vm.clientHeaders,
      "items": _vm.CLIENT_RATING.items,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers,
      "filterUserLabel": "AM Filter"
    },
    on: {
      "searchfilter": _vm.clientSearch
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-payment-option"
  }, [_c('div', {
    staticClass: "campaign-payment-option__identity"
  }, [_c('span', {
    staticClass: "campaign-payment-option__name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.item.ioNumber) ? _c('span', {
    staticClass: "campaign-payment-option__io"
  }, [_vm._v(_vm._s(_vm.item.ioNumber))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "campaign-payment-option__statuses"
  }, [(_vm.item.statusLoading) ? _c('v-chip', {
    attrs: {
      "color": "grey",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_vm._v("Checking status…")])]) : (_vm.item.statusUnavailable) ? _c('v-chip', {
    attrs: {
      "color": "grey darken-1",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_vm._v("Status unavailable")])]) : [(_vm.item.payoutStatus !== _vm.payoutStatus.CONFIRMED) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Pending Payout Confirmation")], 1)]) : _c('v-chip', {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("done")]), _vm._v(" Payouts Confirmed")], 1)]), _vm._v(" "), (!_vm.item.inReport) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Pending in Report")], 1)]) : _c('v-chip', {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("done")]), _vm._v(" Present in Report")], 1)])]], 2)])
},staticRenderFns: []}

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": _vm.color
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400",
      "padding-right": "15px"
    }
  }, [_vm._v("Filter by")]), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "small": "",
      "dense": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.monthlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.quartelyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.yearlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "max-width": "330",
      "height": "180",
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "text-h6 text--primary"
  }, [_vm._v("\n              " + _vm._s(_vm.summaryTitle) + "\n              ")]), _vm._v(" "), _vm._l((_vm.summary), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text--primary",
      staticStyle: {
        "font-size": "14px",
        "margin": "5px"
      }
    }, [_vm._v("\n                " + _vm._s(item.text) + ": "), _c('strong', [_vm._v(_vm._s(item.value) + " " + _vm._s((_vm.name === 'revenue' ? 'SGD' : (_vm.name === 'renewal') ? '' : 'Days')))]), _vm._v(" "), (_vm.name === 'revenue' && index + 1 === _vm.summary.length) ? _c('div', {
      staticStyle: {
        "font-size": "14px",
        "margin": "5px 0px"
      }
    }, [_vm._v("Shortfall: "), _c('strong', [_vm._v(_vm._s((_vm.target - item.value)) + " SGD")])]) : _vm._e()])
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.name,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "align": "end"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.detailCLick(_vm.name)
      }
    }
  }, [_vm._v("Details")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400",
      "padding-right": "15px"
    }
  }, [_vm._v("Turnaround for campaigns - Filter by")]), _vm._v(" "), _c('v-btn-toggle', {
    attrs: {
      "small": "",
      "dense": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.monthlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.quartelyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.yearlyClick(_vm.name)
      }
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.name,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "end",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.name)
      }
    }
  }, [_vm._v("Details")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "brand-fact-sheet-page",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [(_vm.type) ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    staticClass: "brand-fact-sheet-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.type === _vm.campaignTypes.STORY_TELL) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("STORYTELL - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/storytell_bg.jpg"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.title))])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-center pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionOne.subtitle))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'select') ? _c('v-select', {
      attrs: {
        "items": field.defaultOptions,
        "outlined": "",
        "dense": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeSelect(field.name, _vm.brandSheet[field.name])
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionTwo.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionTwo.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.name === 'campaignBudget') ? _c('div', {
      staticClass: "d-flex flex-row"
    }, [_c('v-select', {
      staticClass: "currency-select",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "items": _vm.currenyOptions,
        "hide-details": "",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: (_vm.brandSheet.budgetCurrency),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, "budgetCurrency", _vm._n($$v))
        },
        expression: "brandSheet.budgetCurrency"
      }
    }), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": "",
        "type": field.numberText ? 'number' : ''
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type === 'textbox' && field.name !== 'campaignBudget') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": "",
        "type": field.numberText ? 'number' : ''
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetFormSections.sectionThree.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetFormSections.sectionThree.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'select') ? _c('v-select', {
      attrs: {
        "items": field.defaultOptions,
        "item-text": "text",
        "item-value": "value",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'checkbox') ? _c('v-layout', {
      attrs: {
        "wrap": "",
        "justify-center": "",
        "mb-2": ""
      }
    }, _vm._l((field.detailFields), function(df) {
      return _c('v-flex', {
        key: df.key,
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('v-checkbox', {
        staticClass: "mt-0",
        attrs: {
          "label": df.label,
          "value": df.value
        },
        model: {
          value: (_vm.brandSheet[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.brandSheet, field.name, $$v)
          },
          expression: "brandSheet[field.name]"
        }
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "mb-3"
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                  Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === _vm.bfsTypes.AOK || _vm.type === _vm.bfsTypes.Uncut) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Uncut - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetAOKFormSections.sectionOne.subtitle))])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/brand_sheet/aok_bg.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("SELECTION CRITERIA")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("It is recommended for our clients to make your own logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("There will be a 5 working day turnaround for all logistics arrangements.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will not be responsible for any damaged or lost parcels.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("ADDITIONAL ENGAGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "mb-3"
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === _vm.bfsTypes.KOBE_LITE) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("KOBE Lite - BRAND FACT SHEET")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.brandSheetKobeLiteFormSections.sectionOne.title))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LEAD TIME")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("14 days upon receiving this brand fact sheet and logistics from the client.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CAMPAIGN INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetKobeLiteFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
      staticClass: "mb-3"
    }, [_c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 1) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === _vm.bfsTypes.UGC || _vm.type === _vm.bfsTypes.UGC) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.brandSheetLogo,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "form-title"
  }, [_vm._v("UGC (User-Generated-Content) Videos Application Form")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "I am aware that kobe’s full service of S$15k and up, includes: ",
      "value": "aggreedKobeServiceInclude"
    },
    model: {
      value: (_vm.brandSheet['aggreedKobeServiceInclude']),
      callback: function($$v) {
        _vm.$set(_vm.brandSheet, 'aggreedKobeServiceInclude', $$v)
      },
      expression: "brandSheet['aggreedKobeServiceInclude']"
    }
  }), _vm._v(" "), (_vm.$v.brandSheet['aggreedKobeServiceInclude'].$error) ? _c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("This field is required!")]) : _vm._e(), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.")]), _vm._v(" "), _c('li', [_vm._v("Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.")]), _vm._v(" "), _c('li', [_vm._v("Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.")]), _vm._v(" "), _c('li', [_vm._v("Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.")]), _vm._v(" "), _c('li', [_vm._v("Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.")]), _vm._v(" "), _c('li', [_vm._v("Up to 3 accesses to our Influencer Management System® to streamline influencer campaign management.")]), _vm._v(" "), _c('li', [_vm._v("Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.")])])]), _vm._v(" "), _c('p', [_vm._v("Lead time: 4 weeks")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("Process:")]), _vm._v(" "), _c('v-img', {
    staticStyle: {
      "max-width": "800px"
    },
    attrs: {
      "src": "/static/img/brand_sheet/ugc_process.png"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("TIME/DATE OF PUBLISH")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Creators are free to post at any preferred time and day during the campaign period.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFLUENCER SELECTION")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("CREATORS CONTENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference. You are not allowed to request for reshoot, edits or amendments.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("INFORMATION SHARING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("LOGISTICS ARRANGEMENT")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("For products")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Client to send products to creators directly for free")]), _vm._v(" "), _c('li', [_vm._v("Client to arrange a pick-up point for creators to collect the products directly")]), _vm._v(" "), _c('li', [_vm._v("Creator can make the purchase of product with attached receipt for 100% reimbursement from client")])])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', [_vm._v("For experience")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Creator attend the experience directly and client to verify")]), _vm._v(" "), _c('li', [_vm._v("Creator can make the purchase of experience with attached receipt for 100% reimbursement from client")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("UGC VIDEOS TRACKING")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v("POST CAMPAIGN")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "mb-0 pb-2"
  }, [_vm._v("You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.brandSheetAOKFormSections.sectionOne.fields), function(field, index) {
    return _c('v-flex', {
      key: index,
      class: field.class ? field.class : 'xs12 md6'
    }, [_c('div', [(field.label !== '') ? _c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]) : _c('p', {
      staticClass: "form-label"
    }), _vm._v(" "), (field.hint && field.hint !== '') ? _c('p', {
      staticClass: "caption caption-text ma-0 pb-2",
      domProps: {
        "innerHTML": _vm._s(field.hint)
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textbox') ? _c('v-text-field', {
      class: field.class ? field.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.type === 'textarea') ? _c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.brandSheet[field.name].$error && ((field.label) + " is required."),
        "placeholder": field.placeholder ? field.placeholder : '',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.brandSheet[field.name].$touch()
        }
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }) : _vm._e(), _vm._v(" "), (field.name === 'productExperienceType') ? _c('div', [_c('v-radio-group', {
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.brandSheet[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.brandSheet, field.name, $$v)
        },
        expression: "brandSheet[field.name]"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": "Deliver directly",
        "value": "Deliver directly"
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "label": "Pick Up Point",
        "value": "Pick Up Point"
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "label": "Reimbursement Basis",
        "value": "Reimbursement Basis"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (field.name === 'sampleVideoContent') ? _c('div', {
      staticClass: "mb-3"
    }, [_vm._l((_vm.brandSheet.sampleVideoContent), function(vt, index) {
      return _c('div', {
        key: index,
        staticClass: "d-flex flex-row"
      }, [_c('v-text-field', {
        staticClass: "mt-0",
        attrs: {
          "outlined": "",
          "dense": "",
          "placeholder": ""
        },
        model: {
          value: (vt.link),
          callback: function($$v) {
            _vm.$set(vt, "link", $$v)
          },
          expression: "vt.link"
        }
      }), _vm._v(" "), (_vm.brandSheet.sampleVideoContent.length > 1) ? _c('v-btn', {
        attrs: {
          "color": "danger",
          "text": "",
          "x-small": ""
        },
        on: {
          "click": function($event) {
            return _vm.brandSheet.sampleVideoContent.splice(index, 1)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.addVideoURL()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                          ")], 1)], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.videoUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.videos.length > 0) ? _c('v-row', _vm._l((_vm.videos), function(vdo, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": vdo.url,
                "lazy-src": vdo.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteVideo(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.videoFiles.length > 0) ? _c('v-row', _vm._l((_vm.videoFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png",
          "aspect-ratio": "1"
        }
      })], 1), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteVideoFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (field.name === 'marketingCollaterals') ? _c('div', {
      staticClass: "mb-3"
    }, [_vm._l((_vm.brandSheet.marketingURL), function(mct, index) {
      return _c('div', {
        key: index,
        staticClass: "d-flex flex-row"
      }, [_c('v-text-field', {
        staticClass: "mt-0",
        attrs: {
          "outlined": "",
          "dense": "",
          "placeholder": ""
        },
        model: {
          value: (mct.link),
          callback: function($$v) {
            _vm.$set(mct, "link", $$v)
          },
          expression: "mct.link"
        }
      }), _vm._v(" "), (_vm.brandSheet.marketingURL.length > 1) ? _c('v-btn', {
        attrs: {
          "color": "danger",
          "text": "",
          "x-small": ""
        },
        on: {
          "click": function($event) {
            return _vm.brandSheet.marketingURL.splice(index, 1)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.addMarketingURL()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-plus")]), _vm._v(" Add\n                          ")], 1)], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "white--text",
      attrs: {
        "color": "blue-grey"
      },
      on: {
        "click": function($event) {
          return _vm.$refs.mediaUpload.click()
        }
      }
    }, [_vm._v("\n                          Upload\n                          "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                            mdi-cloud-upload\n                          ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
      return _c('v-col', {
        key: index,
        staticClass: "d-flex child-flex",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [_c('v-card', {
              staticClass: "d-flex",
              attrs: {
                "flat": "",
                "tile": "",
                "elevation": hover ? 16 : 2
              }
            }, [_c('v-img', {
              staticClass: "grey lighten-2",
              attrs: {
                "src": img.url,
                "lazy-src": img.url,
                "aspect-ratio": "1"
              }
            }), _vm._v(" "), _c('v-overlay', {
              attrs: {
                "absolute": ""
              }
            }, [_c('v-btn', {
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deleteImage(index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "2",
          "lg": "1",
          "align": "center"
        }
      }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/pdf.png",
          "aspect-ratio": "1"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/ppt.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/doc.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "width": "67",
          "height": "85",
          "src": "/static/img/text.png"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "dark": "",
          "icon": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteFile(index)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "red"
        }
      }, [_vm._v("cancel")])], 1)], 1)
    }), 1) : _vm._e()], 1)], 2) : _vm._e()], 1)])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.$v.brandSheet.$error) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v("Please complete all required fields. *")])])], 1) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    staticClass: "h4 font-weight-bold mb-2 prefer-video-chk",
    attrs: {
      "label": "I prefer to receive the videos without the creators posting it on their social media platform.",
      "value": "preferVideosWithoutCreatorsPosting"
    },
    model: {
      value: (_vm.brandSheet['preferVideosWithoutCreatorsPosting']),
      callback: function($$v) {
        _vm.$set(_vm.brandSheet, 'preferVideosWithoutCreatorsPosting', $$v)
      },
      expression: "brandSheet['preferVideosWithoutCreatorsPosting']"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitBrandSheet.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Submit\n                ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('input', {
    ref: "videoUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "video",
      "id": "videoToUpload",
      "accept": "video/*"
    },
    on: {
      "change": _vm.prepareVideoUpload
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "nav": ""
    }
  }, [_vm._l((_vm.singleMenus), function(menu, i) {
    return _c('div', {
      key: i,
      staticClass: "mb-3"
    }, [(!menu.subMenus) ? _c('v-list-item', {
      attrs: {
        "active-class": "ims-nav-active",
        "to": menu.link
      }
    }, [_c('v-list-item-icon', [_c('v-icon', {
      domProps: {
        "textContent": _vm._s(menu.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(menu.name)
      }
    })], 1) : _vm._e(), _vm._v(" "), (menu.subMenus) ? _c('v-list-group', {
      class: {
        'ims-nav-group-active': _vm.isMenuRouteActive(menu)
      },
      attrs: {
        "prepend-icon": menu.icon,
        "no-action": "",
        "active-class": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-title', [_vm._v(_vm._s(menu.name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((menu.subMenus), function(smenu, i) {
      return _c('v-list-item', {
        key: i,
        attrs: {
          "exact": "",
          "to": smenu.link,
          "active-class": "ims-nav-active"
        }
      }, [_c('v-list-item-title', {
        domProps: {
          "textContent": _vm._s(smenu.name)
        }
      }), _vm._v(" "), _c('v-list-item-icon', [_c('v-icon', {
        domProps: {
          "textContent": _vm._s(smenu.icon)
        }
      })], 1)], 1)
    })], 2) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.isNotClientRole) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.groupMenus), function(gmenu) {
    return _c('v-list-group', {
      key: gmenu.name,
      class: [("menu-" + (gmenu.name) + "-group"), {
        'ims-nav-group-active': _vm.isMenuRouteActive(gmenu)
      }],
      attrs: {
        "prepend-icon": gmenu.icon,
        "no-action": "",
        "active-class": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-title', [_vm._v(_vm._s(gmenu.name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((gmenu.subMenus), function(smenu, i) {
      return _c('v-list-item', {
        key: i,
        attrs: {
          "exact": "",
          "to": smenu.link,
          "active-class": "ims-nav-active"
        }
      }, [_c('v-list-item-title', {
        domProps: {
          "textContent": _vm._s(smenu.name)
        }
      }), _vm._v(" "), _c('v-list-item-icon', [_c('v-icon', {
        domProps: {
          "textContent": _vm._s(smenu.icon)
        }
      })], 1)], 1)
    })], 2)
  })], 2) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v(_vm._s(_vm.selectedCampaign ? _vm.selectedCampaign.name : 'Select campaign'))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("Create your posts")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Review")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 1
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "elevation": "0"
    }
  }, [(_vm.campaigns && _vm.campaigns.length > 0) ? _c('v-card-text', [_c('v-list', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-subheader', [_vm._v("AVAILABLE CAMPAIGNS")]), _vm._v(" "), _c('v-list-item-group', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.selectedCampaign),
      callback: function($$v) {
        _vm.selectedCampaign = $$v
      },
      expression: "selectedCampaign"
    }
  }, _vm._l((_vm.campaigns), function(item, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "value": item
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-5",
    attrs: {
      "label": "Campaign Name",
      "placeholder": "Enter a new campaign",
      "outlined": ""
    },
    model: {
      value: (_vm.selectedCampaign.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedCampaign, "name", $$v)
      },
      expression: "selectedCampaign.name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": !_vm.selectedCampaign.name,
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("Create Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 2
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [(_vm.selectedCampaign && _vm.selectedCampaign.deliverables) ? _c('p', {
    staticClass: "deliverables"
  }, [_vm._v("\n            Your deliverables for this campaign:              \n            "), _vm._v(" "), _c('post-deliverables', {
    attrs: {
      "deliverables": _vm.selectedCampaign.deliverables
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post, postIndex) {
    return _c('v-row', {
      key: postIndex
    }, [_c('v-col', [_c('v-card', {
      attrs: {
        "rounded": "",
        "elevation": "0",
        "outlined": ""
      }
    }, [_c('v-card-title', {
      staticClass: "pt-1 pb-1"
    }, [_c('v-row', {
      staticStyle: {
        "margin-top": "1px",
        "margin-bottom": "20px"
      }
    }, [_c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "align": "left",
        "justify": "center"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            staticClass: "ma-0",
            attrs: {
              "color": "#3F3FFF",
              "small": "",
              "text-color": "white"
            }
          }, on), [(_vm.getPostTypeMeta(post.type).imgIcon) ? _c('img', {
            staticClass: "mr-1",
            staticStyle: {
              "object-fit": "contain",
              "filter": "invert(1)"
            },
            attrs: {
              "src": _vm.getPostTypeMeta(post.type).imgIcon,
              "width": "15px",
              "height": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }) : _c('v-icon', {
            staticStyle: {
              "color": "#ffffff !important"
            },
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v(_vm._s(_vm.getPostTypeMeta(post.type).icon))]), _vm._v("\n                            " + _vm._s(post.typeName) + "\n                            "), _c('v-icon', {
            attrs: {
              "small": "",
              "right": ""
            }
          }, [_vm._v("mdi-chevron-down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item-group', _vm._l((_vm.postType), function(item, postTypeIndex) {
      return _c('v-list-item', {
        key: postTypeIndex,
        attrs: {
          "value": item.type
        },
        on: {
          "click": function($event) {
            return _vm.postTypeChanged(postIndex, item)
          }
        }
      }, [_c('v-list-item-icon', {
        staticClass: "mr-3"
      }, [(item.imgIcon) ? _c('img', {
        staticStyle: {
          "object-fit": "contain"
        },
        attrs: {
          "src": item.imgIcon,
          "width": "20px",
          "height": "20px",
          "alt": "",
          "aria-hidden": "true"
        }
      }) : _c('v-icon', {
        style: (("color: " + (item.iconColor) + " !important;")),
        attrs: {
          "size": "20"
        }
      }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.typeName))])], 1)
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "align": "right",
        "justify": "center"
      }
    }, [_c('v-btn', _vm._g({
      staticClass: "ma-0",
      attrs: {
        "small": "",
        "color": "red",
        "outlined": "",
        "pill": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deletePost(postIndex)
        }
      }
    }, _vm.on), [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-trash-can-outline")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0 ma-0"
    }, [_c('post-form', {
      attrs: {
        "post": post,
        "influencer": _vm.influencerProfile,
        "campaign": _vm.selectedCampaign
      },
      on: {
        "text-changed": function($event) {
          return _vm.textChanged($event, postIndex)
        },
        "media-changed": function($event) {
          return _vm.mediaChanged($event, postIndex)
        },
        "vdo-link-changed": function($event) {
          return _vm.vdoLinkChanged($event, postIndex)
        },
        "remark-changed": function($event) {
          return _vm.remarkChanged($event, postIndex)
        }
      }
    })], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('v-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-0",
          attrs: {
            "color": "secondary",
            "outlined": "",
            "pill": ""
          }
        }, on), [_vm._v("\n                          Add New Content\n                          "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-plus")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postType), function(item, postTypeIndex2) {
    return _c('v-list-item', {
      key: postTypeIndex2,
      on: {
        "click": function($event) {
          return _vm.addPost(item)
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(item.imgIcon) ? _c('img', {
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": item.imgIcon,
        "width": "20px",
        "height": "20px",
        "alt": "",
        "aria-hidden": "true"
      }
    }) : _c('v-icon', {
      style: (("color: " + (item.iconColor) + " !important;")),
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.typeName))])], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n              Back\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Review")]), _vm._v(" "), _c('v-spacer')], 1)], 2)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "step": 3
    }
  }, [_c('v-card', {
    staticClass: "max-auto",
    attrs: {
      "elevation": "0",
      "flat": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, _vm._l((_vm.posts), function(post, postIndex) {
    return _c('v-col', {
      key: postIndex,
      attrs: {
        "cols": "12",
        "md": "3",
        "lg": "3",
        "sm": "12"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2)),
            attrs: {
              "max-width": "344"
            }
          }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
            staticClass: "subtitle-1 ma-0"
          }, [_vm._v("\n                        " + _vm._s(_vm.selectedCampaign.name) + "\n                      ")]), _vm._v(" "), _c('v-list-item-subtitle', {
            staticClass: "caption font-italic"
          }, [(_vm.currentUserFullName && _vm.showActivePlatform) ? _c('social-handle', {
            attrs: {
              "isInstagram": _vm.activePlatform === 'instagram',
              "isTikTok": _vm.activePlatform === 'tiktok',
              "isYoutube": _vm.activePlatform === 'youtube',
              "isXiaohongshu": _vm.activePlatform === 'xiaohongshu',
              "isLinkedIn": _vm.activePlatform === 'linkedin',
              "isTwitter": _vm.activePlatform === 'twitter',
              "instagramHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "tiktokHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "youtubeHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "xiaohongshuHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "linkedinHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "twitterHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "xiaohongshuFullName": _vm.showActivePlatform.fullName
            }
          }) : _vm._e(), _vm._v(" "), (_vm.currentUserFullName && !_vm.showActivePlatform) ? _c('social-handle', {
            attrs: {
              "isInstagram": _vm.activePlatform === 'instagram' || !_vm.activePlatform || _vm.currentInf.reqIgHandle,
              "isTikTok": _vm.activePlatform === 'tiktok' || _vm.currentInf.reqTikTokHandle,
              "isYoutube": _vm.activePlatform === 'youtube' || _vm.currentInf.reqYoutubeHandle,
              "isXiaohongshu": _vm.activePlatform === 'xiaohongshu',
              "isLinkedIn": _vm.activePlatform === 'linkedin',
              "isTwitter": _vm.activePlatform === 'twitter',
              "instagramHandle": _vm.currentUser.igHandle || _vm.currentInf.reqIgHandle,
              "tiktokHandle": _vm.currentUser.tiktokHandle || _vm.currentInf.reqTikTokHandle,
              "youtubeHandle": _vm.currentUser.youtubeHandle || _vm.currentInf.reqYoutubeHandle,
              "xiaohongshuHandle": _vm.currentUser.xhsHandle,
              "linkedinHandle": _vm.currentUser.linkedinHandle || (_vm.currentInf.linkedin && _vm.currentInf.linkedin.linkedinHandle),
              "twitterHandle": _vm.currentUser.twitterHandle || (_vm.currentInf.twitter && _vm.currentInf.twitter.twitterHandle)
            }
          }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-menu', {
            attrs: {
              "bottom": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "icon": ""
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          })], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticStyle: {
              "padding": "0px"
            },
            on: {
              "click": function($event) {
                return _vm.showDetails(post)
              }
            }
          }, [(!post.media) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            }
          }) : _vm._e(), _vm._v(" "), (post.media && post.media.length) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": post.media[0].preview.thumbnail,
              "aspect-ratio": "1"
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [(post.captionText) ? _c('div', {
            staticClass: "text-truncate"
          }, [_c('strong', [_vm._v(_vm._s(post.captionText))])]) : _vm._e(), _vm._v(" "), (post.type !== 'post' && post.type !== 'carousel' && post.vdoLink) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            staticStyle: {
              "margin-top": "5px !important"
            },
            attrs: {
              "outlined": "",
              "color": "indigo",
              "target": "_blank",
              "href": post.vdoLink,
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-link")]), _vm._v("\n                        Video Link\n                      ")], 1)], 1) : _vm._e(), _vm._v(" "), (post.type === 'story' && post.remark && _vm.currentUserRole !== 5) ? _c('div', {
            staticClass: "text-truncate",
            staticStyle: {
              "margin-top": "20px"
            }
          }, [_c('strong', [_vm._v("Remark:")]), _vm._v("\n                        " + _vm._s(post.remark) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-chip', _vm._g({
            staticStyle: {
              "margin-bottom": "5px",
              "margin-left": "10px"
            },
            attrs: {
              "color": "#3F3FFF",
              "small": "",
              "text-color": "white"
            }
          }, _vm.on), [(_vm.getPostTypeMeta(post.type).imgIcon) ? _c('img', {
            staticClass: "mr-1",
            staticStyle: {
              "object-fit": "contain",
              "filter": "invert(1)"
            },
            attrs: {
              "src": _vm.getPostTypeMeta(post.type).imgIcon,
              "width": "15px",
              "height": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }) : _c('v-icon', {
            staticStyle: {
              "color": "#ffffff !important"
            },
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v(_vm._s(_vm.getPostTypeMeta(post.type).icon))]), _vm._v("\n                      " + _vm._s(post.typeName) + "                            \n                    ")], 1)], 1)], 1)
        }
      }], null, true)
    })], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n              Back\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.validateSubmitPosts
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "text": 'Please stand by',
      "dialog": _vm.isLoading
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    on: {
      "click:outside": _vm.modalClickOutSide
    },
    model: {
      value: (_vm.imageDialog),
      callback: function($$v) {
        _vm.imageDialog = $$v
      },
      expression: "imageDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.imageDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('custom-media-v2', {
    attrs: {
      "media": _vm.campaignHelper.customPostMediaConfig(_vm.previewMedia, {
        overlay: _vm.isCutOff,
        creatorView: true,
        postView: true
      })
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.previewMedia.preview) ? _c('a', {
    attrs: {
      "href": _vm.previewMedia.preview.src,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1000px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.postDetail),
      callback: function($$v) {
        _vm.postDetail = $$v
      },
      expression: "postDetail"
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card draft-post-detail-card"
  }, [_c('v-toolbar', {
    staticClass: "ims-modal-header",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedCampaign.name) + " Campaign\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.postDetail = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body draft-post-detail-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "pa-0 pt-2",
    attrs: {
      "xs": "1",
      "md": "1",
      "lg": "1"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "xs": "6"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.currentUserFullName) + "\n                "), (_vm.currentUserFullName && _vm.showActivePlatform) ? _c('social-handle', {
    attrs: {
      "isInstagram": _vm.activePlatform === 'instagram',
      "isTikTok": _vm.activePlatform === 'tiktok',
      "isYoutube": _vm.activePlatform === 'youtube',
      "isLinkedIn": _vm.activePlatform === 'linkedin',
      "isTwitter": _vm.activePlatform === 'twitter',
      "instagramHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "tiktokHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "youtubeHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "linkedinHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "twitterHandle": _vm.showActivePlatform.handle.replace('@', '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentUserFullName && !_vm.showActivePlatform) ? _c('social-handle', {
    attrs: {
      "isInstagram": _vm.activePlatform === 'instagram' || !_vm.activePlatform,
      "isTikTok": _vm.activePlatform === 'tiktok',
      "isYoutube": _vm.activePlatform === 'youtube',
      "isLinkedIn": _vm.activePlatform === 'linkedin',
      "isTwitter": _vm.activePlatform === 'twitter',
      "instagramHandle": _vm.currentUser.igHandle,
      "tiktokHandle": _vm.currentUser.tiktokHandle,
      "youtubeHandle": _vm.currentUser.youtubeHandle,
      "linkedinHandle": _vm.currentUser.linkedinHandle || (_vm.currentInf.linkedin && _vm.currentInf.linkedin.linkedinHandle),
      "twitterHandle": _vm.currentUser.twitterHandle || (_vm.currentInf.twitter && _vm.currentInf.twitter.twitterHandle)
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData) ? _c('v-chip', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [(_vm.getPostTypeMeta(_vm.postData.type).imgIcon) ? _c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "object-fit": "contain",
      "filter": "invert(1)"
    },
    attrs: {
      "src": _vm.getPostTypeMeta(_vm.postData.type).imgIcon,
      "width": "15px",
      "height": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('v-icon', {
    staticStyle: {
      "color": "#ffffff !important"
    },
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.getPostTypeMeta(_vm.postData.type).icon))]), _vm._v("\n              " + _vm._s(_vm.postData.typeName) + "\n            ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "align": "left",
      "justify": "left"
    }
  }, _vm._l((_vm.postData.media), function(media, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "4",
        "sm": "3"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(media.preview.thumbnail) ? _c('v-card', {
            staticClass: "max-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            },
            on: {
              "click": function($event) {
                return _vm.viewMedia(media)
              }
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": media.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1) : _c('v-card', {
            staticClass: "max-auto",
            attrs: {
              "flat": ""
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": media.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), (!media.preview.thumbnail) ? _c('btn-download', {
      attrs: {
        "url": media.preview.src
      }
    }) : _vm._e()], 1)
  }), 1), _vm._v(" "), (_vm.postData.captionText) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "draft-post-detail-copy"
  }, [_c('strong', [_vm._v("Caption")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.postData.captionText) + "\n            ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type === 'story' || _vm.postData.type === 'video' || _vm.postData.type === 'reel' || _vm.postData.type === 'tiktok') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "color": "indigo",
      "target": "_blank",
      "href": _vm.postData.vdoLink
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-link")]), _vm._v("\n                Video Link\n            ")], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type === 'story' && _vm.currentUserRole !== _vm.influencerRole) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "draft-post-detail-copy"
  }, [_c('strong', [_vm._v("Remark")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.postData.remark) + "\n            ")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions draft-post-detail-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.postDetail = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('influencer-terms-modal', {
    attrs: {
      "dialog": _vm.showAgreementModal
    },
    on: {
      "termsAggrement": _vm.submitPosts
    }
  }), _vm._v(" "), _c('post-media-preview-modal', {
    attrs: {
      "selectedCampaign": _vm.selectedCampaign,
      "postData": _vm.mediaPreviewData,
      "value": _vm.mediaPreviewDialog
    },
    on: {
      "confirmed": _vm.termsAgreed
    },
    model: {
      value: (_vm.mediaPreviewDialog),
      callback: function($$v) {
        _vm.mediaPreviewDialog = $$v
      },
      expression: "mediaPreviewDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "items": _vm.filterCampaigns,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "instagramHandle", $$v)
      },
      expression: "filter.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": ""
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "left": "",
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Grid View")])])], 1), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.pendingConfirmation ? 'warning' : 'default',
      "large": ""
    },
    on: {
      "click": _vm.changePendingConfirmation
    }
  }, [_vm._v("\n                  Upcoming Post Confirmation\n                  "), (_vm.pendingCount) ? _c('v-badge', {
    attrs: {
      "color": "blue",
      "content": _vm.pendingCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.overdueLiveDate ? 'warning' : 'default',
      "large": ""
    },
    on: {
      "click": _vm.changeOverdueDateFilter
    }
  }, [_vm._v("\n                  Overdue live date confirmation\n                  "), (_vm.overdueCount) ? _c('v-badge', {
    attrs: {
      "color": "green",
      "content": _vm.overdueCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.proposeDate ? 'warning' : 'default',
      "large": ""
    },
    on: {
      "click": _vm.changeProposeDateFilter
    }
  }, [_vm._v("\n                  Propose new dates\n                  "), (_vm.proposeCount) ? _c('v-badge', {
    attrs: {
      "color": "green",
      "content": _vm.proposeCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": "",
      "color": "info"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.showPostLayout) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.groupedPosts.length === 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('p', [_vm._v("No record found!")])])]) : _vm._e(), _vm._v(" "), _c('v-expansion-panels', _vm._l((_vm.groupedPosts), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('p', {
      staticClass: "ma-0 title",
      staticStyle: {
        "color": "#3F3FFF"
      }
    }, [_vm._v(_vm._s(item._id.campaignName))]), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "max-width": "120px"
      },
      attrs: {
        "color": "purple",
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
        }
      }
    }, [_vm._v("View Posts")])], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "3",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2)),
            attrs: {
              "max-width": "250"
            }
          }, [_c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
              }
            }
          }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "color": "purple",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
              }
            }
          }, [_vm._v("View All Posts")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
        }
      }], null, true)
    })], 1), _vm._v(" "), _vm._l((item.influencers), function(inf, j) {
      return _c('v-col', {
        key: j,
        attrs: {
          "cols": "12",
          "md": "4",
          "lg": "3",
          "sm": "12"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [(inf.owner) ? _c('v-card', {
              staticClass: "mx-auto",
              attrs: {
                "max-width": "250",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-img', {
              attrs: {
                "src": inf.owner.picture,
                "lazy-src": "/static/img/avatar/user.png",
                "height": "200px"
              }
            }), _vm._v(" "), _c('v-card-title', [(inf.owner.tiktokHandle) ? _c('a', {
              attrs: {
                "href": 'https://www.tiktok.com/@' + inf.owner.tiktokHandle,
                "target": "_blank"
              }
            }, [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(inf.owner.tiktokHandle))]) : (inf.owner.youtubeHandle) ? _c('a', {
              attrs: {
                "href": 'https://youtube.com/' + inf.owner.youtubeHandle,
                "target": "_blank"
              }
            }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(inf.owner.youtubeHandle))], 1) : (inf.owner.linkedinHandle) ? _c('a', {
              attrs: {
                "href": 'https://www.linkedin.com/in/' + inf.owner.linkedinHandle,
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_c('v-icon', {
              attrs: {
                "color": "#0A66C2",
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(inf.owner.linkedinHandle))], 1) : _c('a', {
              attrs: {
                "href": 'https://instagram.com/' + inf.owner.instagramHandle,
                "target": "_blank"
              }
            }, [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(inf.owner.instagramHandle))], 1)]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(inf.noOfPosts) + " " + _vm._s(inf.noOfPosts > 1 ? 'Posts' : 'Post'))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "color": "purple",
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, inf.owner)
                }
              }
            }, [_vm._v("View Posts")]), _vm._v(" "), _c('v-spacer')], 1)], 1) : _vm._e()]
          }
        }], null, true)
      })], 1)
    })], 2)], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPostLayout) ? _c('div', {
    staticClass: "pa-0",
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [(_vm.display === 1) ? _c('v-row', {
    staticClass: "mt-2",
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [(_vm.posts.length === 0) ? _c('v-flex', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('p', [_vm._v("No record found!")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "4",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2))
          }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
            staticClass: "subtitle-1 ma-0"
          }, [_vm._v(_vm._s(post.campaignName))]), _vm._v(" "), _c('v-list-item-subtitle', {
            staticClass: "caption font-italic"
          }, [_vm._v("\n                      By\n                      "), (post.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + post.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(post.author.tiktokHandle))]) : (post.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + post.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(post.author.youtubeHandle))], 1) : (post.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + post.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(post.author.linkedinHandle))], 1) : (post.type === 'twitter' || post.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + (post.author.twitterHandle || post.author.instagramHandle),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(post.author.twitterHandle || post.author.instagramHandle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + post.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(post.author.instagramHandle))], 1)])], 1)], 1), _vm._v(" "), (!post.images[0]) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && !post.images[0].publicID) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": post.images[0].url,
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticClass: "post-cld-img cursor-pointer",
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {})
            }
          })], 1) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && !post.images[0].publicID) ? _c('video', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "height": "194px",
              "width": "100%"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('source', {
            attrs: {
              "src": post.images[0].url,
              "type": "video/mp4"
            }
          }), _vm._v("Your browser does not support the video tag.\n                ")]) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticStyle: {
              "max-height": "200px",
              "overflow": "hidden"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {
                videoPreview: true
              })
            }
          })], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [(post.type !== 'post/carousel' && post.vdoLink) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            staticStyle: {
              "margin-top": "5px !important"
            },
            attrs: {
              "outlined": "",
              "color": "indigo",
              "target": "_blank",
              "href": post.vdoLink,
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-link")]), _vm._v("\n                        Video Link\n                      ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_vm._l((post.labels), function(label) {
            return _c('v-chip', {
              key: label.text,
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, post)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                    ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(label.text) + "\n                    "), (label.icon) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))]) : _vm._e()], 1)
          }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
            attrs: {
              "bottom": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "icon": ""
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return (_vm.showAvailableMenu(post, menuItem.action)) ? _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, post)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1) : _vm._e()
          }), 1)], 1)], 2)], 1)
        }
      }], null, true)
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.display === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "secondary"
          }
        }, on), [_vm._v("Bulk Action")])]
      }
    }], null, false, 1812722738)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.tableActions), function(menuItem, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "disabled": menuItem.disabled
      },
      on: {
        "click": function($event) {
          return _vm.performSelected(menuItem.action)
        }
      }
    }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "item-key": "_id",
      "show-select": true,
      "headers": _vm.headers,
      "items": _vm.posts
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item._id
          }, [_c('td', [_c('v-checkbox', {
            attrs: {
              "checked": false,
              "value": item,
              "primary": "",
              "hide-details": ""
            },
            model: {
              value: (_vm.selected),
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.campaignName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-justify pa-1"
          }, [(item.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + item.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.author.linkedinHandle))], 1) : (item.type === 'twitter' || item.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + (item.author.twitterHandle || item.author.instagramHandle),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(item.author.twitterHandle || item.author.instagramHandle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "300px"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l((item.labels), function(label) {
            return _c('div', {
              key: label.text
            }, [_c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, item)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                            ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(label.text) + "\n                            "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))])], 1)], 1)
          }), 0)]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "d-flex justify-content-between"
          }, _vm._l((_vm.menuOptions), function(menuItem, i) {
            return (_vm.showAvailableMenu(item, menuItem.action)) ? _c('div', {
              key: i,
              staticClass: "pr-2"
            }, [_c('v-btn', {
              attrs: {
                "small": "",
                "color": menuItem.color || 'warning'
              },
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, item)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "color": menuItem.color === 'default' ? 'black' : 'white',
                "small": ""
              }
            }, [_vm._v(_vm._s(menuItem.icon))]), _vm._v(" " + _vm._s(menuItem.name) + "\n                          ")], 1)], 1) : _vm._e()
          }), 0)])])
        }), 0)]
      }
    }], null, false, 341838639),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "client_inf_chatbox": _vm.show_client_inf_chatbox,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "postReviewApproved": _vm.showPostReviewApproved,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('edit-post-modal', {
    attrs: {
      "post": _vm.editPostData,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "value": _vm.editPostDialog,
      "userObj": _vm.user
    },
    on: {
      "postUpdated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.editPostDialog),
      callback: function($$v) {
        _vm.editPostDialog = $$v
      },
      expression: "editPostDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-modal', {
    attrs: {
      "post": _vm.assignCampaignPostData
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignDialog),
      callback: function($$v) {
        _vm.assignCampaignDialog = $$v
      },
      expression: "assignCampaignDialog"
    }
  }), _vm._v(" "), _c('map-influencer-modal', {
    attrs: {
      "post": _vm.mapInfluencerPostData
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.influencerMapSuccess($event)
      }
    },
    model: {
      value: (_vm.mapInfluencerDialog),
      callback: function($$v) {
        _vm.mapInfluencerDialog = $$v
      },
      expression: "mapInfluencerDialog"
    }
  }), _vm._v(" "), _c('submission-review-multiple-modal', {
    attrs: {
      "posts": _vm.selected,
      "internalApprove": false
    },
    on: {
      "successBulkApprove": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.submissionReviewMultipleDialog),
      callback: function($$v) {
        _vm.submissionReviewMultipleDialog = $$v
      },
      expression: "submissionReviewMultipleDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataForAddPost,
      "postID": _vm.postIdToUpdate
    },
    on: {
      "done": _vm.postAdded
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('change-post-status-modal', {
    attrs: {
      "post": _vm.postDataForChangeStatus
    },
    on: {
      "updated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('client-choose-date-modal', {
    attrs: {
      "post": _vm.viewChooseDatePost,
      "ChooseDateDialogValue": _vm.chooseDateDialog
    },
    on: {
      "chooseDateClosed": _vm.closeChooseDateModal,
      "postUpdated": function($event) {
        return _vm.getPosts()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kobe-html-report"
  }, [(_vm.showLogin) ? _c('report-login-modal', {
    attrs: {
      "value": _vm.showLogin,
      "campaignID": _vm.campaignID
    },
    on: {
      "loggedIn": _vm.onLoggedIn,
      "input": function () {}
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "state"
  }, [_vm._v("Generating report…")]) : (_vm.error) ? _c('div', {
    staticClass: "state error"
  }, [_vm._v(_vm._s(_vm.error))]) : (_vm.html) ? _c('iframe', {
    ref: "frame",
    staticClass: "report-frame",
    attrs: {
      "srcdoc": _vm.html,
      "frameborder": "0"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "720"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Lookalikes - @" + _vm._s(_vm.handle))])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 10,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-avatar', {
          staticStyle: {
            "margin": "10px 0"
          },
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": item.picture,
            "alt": "avatar"
          }
        })]), _vm._v(" "), _c('social-handle', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": _vm.platform === 'tiktok',
            "isInstagram": _vm.platform === 'instagram',
            "isYoutube": _vm.platform === 'youtube',
            "tiktokHandle": item.username,
            "instagramHandle": item.username,
            "youtubeHandle": item.custom_name
          }
        })], 1)])]
      }
    }, {
      key: "item.countryName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item.countryName) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(item.countryName) + "\n                ")]) : _vm._e()])]
      }
    }, {
      key: "item.followers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(_vm._f("thousandSeprator")(item.followers)) + "\n                ")])])]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', {
    class: _vm.isInternalView ? 'internal-view-container' : ''
  }, [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                Campaign Summary\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-btn', {
    staticClass: "mr-1 secondary--text surface",
    on: {
      "click": function($event) {
        return _vm.cancelEdit('summary')
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editCampaignSummary && !_vm.uploadSubmitting) ? _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveEdit
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-done")]), _vm._v(" Save\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.editCampaignSummary && _vm.uploadSubmitting) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "dark": "",
      "disabled": true
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 20
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editCampaignSummary && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.editCampaignSummary = true
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": "",
      "title": "Edit Campaign Summary"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_vm._l((_vm.campaign.angles), function(angle, index) {
    return _c('div', {
      key: index
    }, [(angle.context || _vm.editCampaignSummary) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "flex-one",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                        Campaign Context\n                      ")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
      staticClass: "report-summary-editor",
      attrs: {
        "solo": ""
      },
      model: {
        value: (angle.context),
        callback: function($$v) {
          _vm.$set(angle, "context", $$v)
        },
        expression: "angle.context"
      }
    }) : _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(angle.context))])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((angle.formats), function(format, index) {
      return _c('v-layout', {
        key: index,
        staticClass: "pb-5",
        attrs: {
          "wrap": ""
        }
      }, [(format.required_action || _vm.editCampaignSummary) ? _c('v-flex', {
        staticClass: "flex-one",
        attrs: {
          "xs6": "",
          "md6": ""
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("Required action")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
        staticClass: "report-summary-editor",
        attrs: {
          "solo": ""
        },
        model: {
          value: (format.required_action),
          callback: function($$v) {
            _vm.$set(format, "required_action", $$v)
          },
          expression: "format.required_action"
        }
      }) : _c('p', {
        staticClass: "description"
      }, [_vm._v(_vm._s(format.required_action))])], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
        staticClass: "flex-one",
        attrs: {
          "xs6": "",
          "md6": ""
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("Image/Video Pointers")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
        staticClass: "report-summary-editor",
        attrs: {
          "solo": ""
        },
        model: {
          value: (format.image_angle),
          callback: function($$v) {
            _vm.$set(format, "image_angle", $$v)
          },
          expression: "format.image_angle"
        }
      }) : _c('p', {
        staticClass: "description"
      }, [_vm._v(_vm._s(format.image_angle))])], 1)]), _vm._v(" "), _c('v-flex', {
        staticClass: "flex-one",
        attrs: {
          "xs6": "",
          "md6": ""
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v("Content Pointers")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
        staticClass: "report-summary-editor",
        attrs: {
          "solo": ""
        },
        model: {
          value: (format.content_angle),
          callback: function($$v) {
            _vm.$set(format, "content_angle", $$v)
          },
          expression: "format.content_angle"
        }
      }) : _c('p', {
        staticClass: "description"
      }, [_vm._v(_vm._s(format.content_angle))])], 1)]), _vm._v(" "), _c('v-flex', {
        staticClass: "bottomLine",
        attrs: {
          "xs12": "",
          "md12": ""
        }
      })], 1)
    })], 2)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Campaign Period")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-layout', {
    staticClass: "pa-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "290px",
            "float": "left",
            "padding-right": "10px"
          },
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "solo": ""
          },
          model: {
            value: (_vm.campaign.startDate),
            callback: function($$v) {
              _vm.$set(_vm.campaign, "startDate", $$v)
            },
            expression: "campaign.startDate"
          }
        }, on))]
      }
    }], null, false, 521130108),
    model: {
      value: (_vm.startCal),
      callback: function($$v) {
        _vm.startCal = $$v
      },
      expression: "startCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.startCal = false
      }
    },
    model: {
      value: (_vm.campaign.startDate),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "startDate", $$v)
      },
      expression: "campaign.startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "max-width": "20px",
      "padding": "10px 2px 10px"
    },
    attrs: {
      "xs12": "",
      "md1": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticStyle: {
            "width": "290px",
            "float": "left"
          },
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "solo": ""
          },
          model: {
            value: (_vm.campaign.endDate),
            callback: function($$v) {
              _vm.$set(_vm.campaign, "endDate", $$v)
            },
            expression: "campaign.endDate"
          }
        }, on))]
      }
    }], null, false, 3415128048),
    model: {
      value: (_vm.endCal),
      callback: function($$v) {
        _vm.endCal = $$v
      },
      expression: "endCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.endCal = false
      }
    },
    model: {
      value: (_vm.campaign.endDate),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "endDate", $$v)
      },
      expression: "campaign.endDate"
    }
  })], 1)], 1)], 1) : _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.startDate) + " - " + _vm._s(_vm.endDate))])], 1)]), _vm._v(" "), ((_vm.campaign.lineUp && _vm.campaign.lineUp.length > 0) || _vm.editCampaignSummary) ? _c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Creator Line Up")]), _vm._v(" "), (_vm.showRequiredActions() && _vm.editCampaignSummary) ? _c('v-layout', {
    staticClass: "p-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "md3": ""
    }
  }, [_c('v-file-input', {
    attrs: {
      "accept": "image/png, image/jpeg, image/bmp",
      "label": "Select Pictures",
      "prepend-icon": "",
      "multiple": ""
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('image-swiper', {
    attrs: {
      "images": _vm.campaign.lineUp,
      "isShowDelete": _vm.showRequiredActions() && _vm.editCampaignSummary
    },
    on: {
      "delete": _vm.deleteImage
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.campaign.optionalRemarks || _vm.editCampaignSummary) ? _c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Remarks")]), _vm._v(" "), (_vm.editCampaignSummary) ? _c('v-textarea', {
    staticClass: "report-summary-editor",
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.campaign.optionalRemarks),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "optionalRemarks", $$v)
      },
      expression: "campaign.optionalRemarks"
    }
  }) : _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.campaign.optionalRemarks))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.campaign.segment) ? _c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Creator Strategy")]), _vm._v(" "), _c('div', [(_vm.showRequiredActions()) ? _c('draggable', {
    staticClass: "row no-gutters flex-wrap flex-row fill-height",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "update": function($event) {
        return _vm.handleDragDropUpdate(_vm.campaign.segment)
      }
    },
    model: {
      value: (_vm.campaign.segment),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "segment", $$v)
      },
      expression: "campaign.segment"
    }
  }, _vm._l((_vm.campaign.segment), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2"
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  }), 1) : _vm._l((_vm.campaign.segment), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2"
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  })], 2)])]) : _vm._e()], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInternalView),
      expression: "isInternalView"
    }],
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                AI Analysis Summary\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editAIAnalysis) ? _c('v-btn', {
    staticClass: "mr-1 secondary--text surface",
    on: {
      "click": function($event) {
        return _vm.cancelEdit('ai')
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editAIAnalysis) ? _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "loading": _vm.generatingSummary,
      "color": "primary",
      "text": "",
      "title": "Generate with AI"
    },
    on: {
      "click": function($event) {
        return _vm.generateAISummary(false)
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic mr-2"
  }), _vm._v(" Generate with AI\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editAIAnalysis && !_vm.uploadSubmitting) ? _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveEdit
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-done")]), _vm._v(" Save\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.editAIAnalysis && _vm.uploadSubmitting) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "dark": "",
      "disabled": true
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 20
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editAIAnalysis && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.editAIAnalysis = true
      }
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": "",
      "title": "Edit AI Analysis Summary"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [(_vm.campaign.AISummary || _vm.editAIAnalysis || _vm.campaign.AISummary === '') ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "flex-one",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("AI-Powered Analysis")]), _vm._v(" "), (_vm.editAIAnalysis) ? _c('v-textarea', {
    staticClass: "report-summary-editor",
    attrs: {
      "solo": "",
      "auto-grow": "",
      "rows": "8"
    },
    model: {
      value: (_vm.campaign.AISummary),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "AISummary", $$v)
      },
      expression: "campaign.AISummary"
    }
  }) : _c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.renderRemark(_vm.campaign.AISummary))
    }
  })], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInternalView),
      expression: "isInternalView"
    }],
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                AI Notable Comments\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 mt-1",
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.aiCommentsLoading,
      "title": "Generate with AI"
    },
    on: {
      "click": _vm.fetchAINotableComments
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic"
  })]), _vm._v(" "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "form-group"
  }, [(_vm.campaign.commentAnalysisResult && _vm.campaign.commentAnalysisResult.notableComments && _vm.campaign.commentAnalysisResult.notableComments.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.aiHeaders,
      "items": _vm.campaign.commentAnalysisResult.notableComments,
      "items-per-page": 5,
      "loading": _vm.aiCommentsLoading,
      "loading-text": "Analyzing comments...",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.comment",
      fn: function(ref) {
        var item = ref.item;

        return [_c('p', [_vm._v(_vm._s(item.comment ? item.comment.comment : 'N/A'))])]
      }
    }, {
      key: "item.relevance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "color": item.relevance === 'RELEVANT' ? 'success' : 'error',
            "small": ""
          }
        }, [_vm._v("\n                            " + _vm._s(item.relevance) + "\n                        ")])]
      }
    }, {
      key: "item.reason",
      fn: function(ref) {
        var item = ref.item;

        return [_c('p', [_vm._v(_vm._s(item.reason))])]
      }
    }, {
      key: "item.checkbox",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              return _vm.updateNotableCheckFromTable(item, $event)
            }
          },
          model: {
            value: (item.checked),
            callback: function($$v) {
              _vm.$set(item, "checked", $$v)
            },
            expression: "item.checked"
          }
        })]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("\n                        No notable comments found in the latest analysis.\n                    ")]
      },
      proxy: true
    }], null, false, 301129300)
  }) : _vm._e()], 1)])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "content-class": "edit-post-modal",
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.postData) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Edit Live Date")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    attrs: {
      "id": "postLiveDateEditForm"
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.showSetDateOption) ? _c('v-dialog', {
    ref: "dateDialog",
    attrs: {
      "return-value": _vm.postData.postDate,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.postData, "postDate", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.postData, "postDate", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Pick a Date that this post should publish",
            "append-icon": "event",
            "name": "postDate",
            "readonly": ""
          },
          model: {
            value: (_vm.postData.postDate),
            callback: function($$v) {
              _vm.$set(_vm.postData, "postDate", $$v)
            },
            expression: "postData.postDate"
          }
        }, on))]
      }
    }], null, false, 2478162075),
    model: {
      value: (_vm.datePickerDialog),
      callback: function($$v) {
        _vm.datePickerDialog = $$v
      },
      expression: "datePickerDialog"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.todayDatePick
    },
    model: {
      value: (_vm.postData.postDate),
      callback: function($$v) {
        _vm.$set(_vm.postData, "postDate", $$v)
      },
      expression: "postData.postDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.datePickerDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dateDialog.save(_vm.postData.postDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showSetDateOption) ? _c('v-dialog', {
    ref: "endDateDialog",
    attrs: {
      "return-value": _vm.postData.postDateEnd,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.postData, "postDateEnd", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.postData, "postDateEnd", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Pick a Date that this post should publish latest by",
            "append-icon": "event",
            "name": "postDateEnd",
            "readonly": ""
          },
          model: {
            value: (_vm.postData.postDateEnd),
            callback: function($$v) {
              _vm.$set(_vm.postData, "postDateEnd", $$v)
            },
            expression: "postData.postDateEnd"
          }
        }, on))]
      }
    }], null, false, 4140622619),
    model: {
      value: (_vm.endDatePickerDialog),
      callback: function($$v) {
        _vm.endDatePickerDialog = $$v
      },
      expression: "endDatePickerDialog"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.postData.postDate
    },
    model: {
      value: (_vm.postData.postDateEnd),
      callback: function($$v) {
        _vm.$set(_vm.postData, "postDateEnd", $$v)
      },
      expression: "postData.postDateEnd"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.endDatePickerDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.endDateDialog.save(_vm.postData.postDateEnd)
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.influencer || _vm.multiple) ? _c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-2"
    }
  }, [(!_vm.multiple) ? _c('h2', {
    staticClass: "headline"
  }, [_vm._v("@" + _vm._s(_vm.influencer.userHandle) + " ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.multiple) ? _c('h2', {
    staticClass: "headline"
  }, [_vm._v("Update Deliverables")]) : _c('h2', {
    staticClass: "headline"
  }, [_vm._v("Deliverables")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.multiple) ? _c('h3', [_vm._v(_vm._s(_vm.influencer.payoutAmount) + "$")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [(!_vm.multiple) ? _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }), _vm._v(" "), _c('v-list-item-action', [_c('p', {
    staticClass: "body-1 mb-0"
  }, [_vm._v("\n                " + _vm._s('$' + _vm.pairedInfluencer.multipliedPrice1 + ' - $' + _vm.pairedInfluencer.multipliedPrice2) + "\n                "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-account-cog")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                TikTok Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "min": "0",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_tiktok_posts),
      callback: function($$v) {
        _vm.no_of_tiktok_posts = _vm._n($$v)
      },
      expression: "no_of_tiktok_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of TikTok Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                XHS Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "min": "0",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_xhs_posts),
      callback: function($$v) {
        _vm.no_of_xhs_posts = _vm._n($$v)
      },
      expression: "no_of_xhs_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Xiaohongshu Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                FB Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "min": "0",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_fb_posts),
      callback: function($$v) {
        _vm.no_of_fb_posts = _vm._n($$v)
      },
      expression: "no_of_fb_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Facebook Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_posts),
      callback: function($$v) {
        _vm.no_of_posts = _vm._n($$v)
      },
      expression: "no_of_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Posts")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Carousels\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_carousels),
      callback: function($$v) {
        _vm.no_of_carousels = _vm._n($$v)
      },
      expression: "no_of_carousels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Carousels")])], 1)], 1), _vm._v(" "), (_vm.no_of_video) ? _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Videos\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_video),
      callback: function($$v) {
        _vm.no_of_video = _vm._n($$v)
      },
      expression: "no_of_video"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Videos")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Stories\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_stories),
      callback: function($$v) {
        _vm.no_of_stories = _vm._n($$v)
      },
      expression: "no_of_stories"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Stories")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                IG Reels\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_reels),
      callback: function($$v) {
        _vm.no_of_reels = _vm._n($$v)
      },
      expression: "no_of_reels"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of IG Reels")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                LinkedIn Posts\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_li_posts),
      callback: function($$v) {
        _vm.no_of_li_posts = _vm._n($$v)
      },
      expression: "no_of_li_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of LinkedIn Posts")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("X (Twitter) Posts")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.no_of_x_posts),
      callback: function($$v) {
        _vm.no_of_x_posts = _vm._n($$v)
      },
      expression: "no_of_x_posts"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of X (Twitter) Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, [_c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Youtube\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.youtube),
      callback: function($$v) {
        _vm.youtube = _vm._n($$v)
      },
      expression: "youtube"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in number of Youtube videos")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Loading/Whitelisting\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "hide-details": "",
      "solo": "",
      "dense": ""
    },
    model: {
      value: (_vm.loading_whitelisting),
      callback: function($$v) {
        _vm.loading_whitelisting = $$v
      },
      expression: "loading_whitelisting"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in months")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Exclusivity\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "0",
      "solo": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.exclusivity),
      callback: function($$v) {
        _vm.exclusivity = $$v
      },
      expression: "exclusivity"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in months")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Physical Attendance\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.physical_attendance),
      callback: function($$v) {
        _vm.physical_attendance = _vm._n($$v)
      },
      expression: "physical_attendance"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in hours")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb--10"
  }, [_c('v-list-item-content', {
    staticClass: "pt-2"
  }, [_c('v-list-item-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n                Online Attendance\n              ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "solo": "",
      "dense": "",
      "min": "0",
      "hide-details": ""
    },
    model: {
      value: (_vm.online_attendance),
      callback: function($$v) {
        _vm.online_attendance = _vm._n($$v)
      },
      expression: "online_attendance"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint--text"
  }, [_vm._v("in hours")])], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0"
  }, _vm._l((_vm.customDeliverables), function(custom, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "mb--10"
    }, [_c('v-list-item-content', {
      staticClass: "pt-0",
      staticStyle: {
        "margin-top": "-10px"
      }
    }, [_c('v-list-item-title', {
      staticClass: "subtitle-2"
    }, [_vm._v("\n                Custom\n              ")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": ""
      },
      model: {
        value: (custom.label),
        callback: function($$v) {
          _vm.$set(custom, "label", $$v)
        },
        expression: "custom.label"
      }
    })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-text-field', {
      staticStyle: {
        "max-width": "200px"
      },
      attrs: {
        "type": "number",
        "solo": "",
        "append-outer-icon": "mdi-delete-forever"
      },
      on: {
        "click:append-outer": function($event) {
          return _vm.deleteCustom(index)
        }
      },
      model: {
        value: (custom.value),
        callback: function($$v) {
          _vm.$set(custom, "value", _vm._n($$v))
        },
        expression: "custom.value"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-ongoing"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.campaigns,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group",
            "aria-label": "Basic example"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#view_pairing_brief_detailed_modal"
          },
          on: {
            "click": function($event) {
              _vm.getCampaignDataToView(row.item.id);
              _vm.getRateCardDataToView(row.item.id, _vm.influencerID);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), (_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.acceptInvite(row.item.pairingID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.rejectCampaign(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e(), _vm._v(" "), (!_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#view_post_modal"
          },
          on: {
            "click": function($event) {
              return _vm.getPostDataToView(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file"
        })]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "md"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('view-pairing-brief-detailed-modal', {
    attrs: {
      "modalId": 'view_pairing_brief_detailed_modal',
      "campaignData": _vm.viewCampaignData,
      "rateCardData": _vm.viewRateCardData
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "modalId": 'view_post_modal',
      "campaignData": _vm.viewPostCampaignData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logoPrimary
    }
  })]), _vm._v(" "), _c('v-card-text', [_c('b-card', {
    attrs: {
      "bg-variant": "light"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.fail
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), (!_vm.sent) ? _c('p', {
    staticClass: "center-block"
  }, [_vm._v("Enter your email address and we will send you a link to reset your password.")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.$v.email.$error
    }
  }, [(!_vm.sent) ? _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter your email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$v.email.required && _vm.$v.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter your email")]) : _vm._e(), _vm._v(" "), (!_vm.$v.email.validEmail && _vm.$v.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter a valid email")]) : _vm._e()], 1), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "success",
      "show": _vm.sent
    }
  }, [_vm._v("Check your inbox for a password reset email.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.sent) ? _c('v-btn', {
    staticClass: "send-email",
    attrs: {
      "disabled": _vm.$v.$invalid,
      "block": "",
      "color": "secondary",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmailResetPassword('')
      }
    }
  }, [_vm._v("Send password reset email")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v(_vm._s(_vm.showTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "30px 50px 0"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Available Amount: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.availableAmt)))])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.quoteData), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('v-row', [_c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "5",
        "sm": "12"
      }
    }, [_c('p', {
      staticClass: "title-1 form-label"
    }, [_vm._v("Amount: ")])]), _vm._v(" "), _c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "7",
        "sm": "12"
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "disabled": item.status === _vm.quoteStatuses.ACCEPT,
        "hide-details": "",
        "placeholder": "",
        "prefix": "$",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: (item.quoteAmt),
        callback: function($$v) {
          _vm.$set(item, "quoteAmt", $$v)
        },
        expression: "item.quoteAmt"
      }
    })], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "mt-2"
    }, [_c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "5",
        "sm": "12"
      }
    }, [_c('p', {
      staticClass: "title-1 form-label"
    }, [_vm._v("Start Month : ")])]), _vm._v(" "), _c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "7",
        "sm": "12"
      }
    }, [_c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 40,
        "transition": "scale-transition",
        "offset-y": "",
        "min-width": "290px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-text-field', _vm._g({
            staticClass: "input-field",
            attrs: {
              "disabled": item.status === _vm.quoteStatuses.ACCEPT && !item.editMode,
              "hide-details": "",
              "append-icon": "event",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.startMonth),
              callback: function($$v) {
                _vm.$set(item, "startMonth", $$v)
              },
              expression: "item.startMonth"
            }
          }, on))]
        }
      }], null, true),
      model: {
        value: (item.startCal),
        callback: function($$v) {
          _vm.$set(item, "startCal", $$v)
        },
        expression: "item.startCal"
      }
    }, [_vm._v(" "), _c('v-date-picker', {
      attrs: {
        "type": "month",
        "min": _vm.minDate
      },
      on: {
        "input": function($event) {
          item.startCal = false
        }
      },
      model: {
        value: (item.startMonth),
        callback: function($$v) {
          _vm.$set(item, "startMonth", $$v)
        },
        expression: "item.startMonth"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "5",
        "sm": "12"
      }
    }, [_c('p', {
      staticClass: "title-1 form-label"
    }, [_vm._v("End Month : ")])]), _vm._v(" "), _c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "7",
        "sm": "12"
      }
    }, [_c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 40,
        "transition": "scale-transition",
        "offset-y": "",
        "min-width": "290px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-text-field', _vm._g({
            staticClass: "input-field",
            attrs: {
              "disabled": item.status === _vm.quoteStatuses.ACCEPT && !item.editMode,
              "hide-details": "",
              "append-icon": "event",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.endMonth),
              callback: function($$v) {
                _vm.$set(item, "endMonth", $$v)
              },
              expression: "item.endMonth"
            }
          }, on))]
        }
      }], null, true),
      model: {
        value: (item.endCal),
        callback: function($$v) {
          _vm.$set(item, "endCal", $$v)
        },
        expression: "item.endCal"
      }
    }, [_vm._v(" "), _c('v-date-picker', {
      attrs: {
        "type": "month",
        "min": _vm.minDate
      },
      on: {
        "input": function($event) {
          item.endCal = false
        }
      },
      model: {
        value: (item.endMonth),
        callback: function($$v) {
          _vm.$set(item, "endMonth", $$v)
        },
        expression: "item.endMonth"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "5",
        "sm": "12"
      }
    }, [_c('p', {
      staticClass: "title-1 form-label"
    }, [_vm._v("Remarks: ")])]), _vm._v(" "), _c('v-col', {
      staticClass: "pb-0",
      attrs: {
        "cols": "12",
        "md": "7",
        "sm": "12"
      }
    }, [_c('v-textarea', {
      attrs: {
        "disabled": item.status === _vm.quoteStatuses.ACCEPT && !item.editMode,
        "placeholder": "",
        "outlined": "",
        "dense": "",
        "rows": "2"
      },
      model: {
        value: (item.remarks),
        callback: function($$v) {
          _vm.$set(item, "remarks", $$v)
        },
        expression: "item.remarks"
      }
    })], 1)], 1), _vm._v(" "), (!item.editMode) ? _c('v-row', {
      staticClass: "mt-5",
      staticStyle: {
        "justify-content": "right"
      }
    }, [(item.status === _vm.quoteStatuses.ACCEPT) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.changeEditStatus(index, true)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-pencil")]), _vm._v("  Edit\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "color": "error",
        "disabled": item.status === _vm.quoteStatuses.ACCEPT
      },
      on: {
        "click": function($event) {
          return _vm.removeQuoteData(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (item.editMode) ? _c('v-row', {
      staticClass: "mt-5",
      staticStyle: {
        "justify-content": "right"
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.changeEditStatus(index, false)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-close-circle")]), _vm._v("  Cancel\n            ")], 1), _vm._v(" "), (item.status === _vm.quoteStatuses.ACCEPT) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "green"
      },
      on: {
        "click": function($event) {
          return _vm.saveMasterData(true)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-upload")]), _vm._v("  Update\n            ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "btn-invoice-sent-edit ml-0",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.addQuoteData
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n          ")], 1)], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveMasterData(false)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-0"
  }, [_c('div', [_c('figure', {
    staticClass: "pb-3 text-center"
  }, [_c('UploadIcon', {
    on: {
      "clicked": function($event) {
        return _vm.driveIconClicked()
      }
    }
  }), _vm._v(" "), _c('h4', {
    on: {
      "click": function($event) {
        return _vm.driveIconClicked()
      }
    }
  }, [_vm._v("Connect to Google Drive")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "width": "100%",
      "max-height": "300px"
    }
  }, [_c('v-card-text', _vm._l((_vm.messages), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('p', {
      staticClass: "body-2 font-weight-bold"
    }, [_vm._v(_vm._s(_vm.viewAuthor(msg.author)))]), _vm._v(" "), _c('p', {
      staticClass: "body-1 font-weight-medium"
    }, [_vm._v(_vm._s(msg.text))]), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.getRelativeTime(msg.createdAt)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0)], 1), _vm._v(" "), (_vm.type === 'internal_notes' && _vm.isClient) ? _c('v-card-actions', [_c('v-textarea', {
    attrs: {
      "label": _vm.label,
      "rows": "2",
      "auto-grow": ""
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("\n      Save\n      "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type !== 'internal_notes') ? _c('v-card-actions', [_c('v-textarea', {
    attrs: {
      "label": _vm.label,
      "rows": "2",
      "auto-grow": ""
    },
    model: {
      value: (_vm.messageText),
      callback: function($$v) {
        _vm.messageText = $$v
      },
      expression: "messageText"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("\n      Save\n      "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('summary-of-account', {
    attrs: {
      "filterUsers": _vm.filterUser
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Influencers for '" + _vm._s(_vm.campaign.name) + "'")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "6",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": "195px"
          }
        }, [_c('v-card-title', {
          staticClass: "title"
        }, [_vm._v("Overall Summary")]), _vm._v(" "), _c('v-card-subtitle', _vm._l((_vm.overall), function(total, index) {
          return _c('p', {
            key: index,
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("\n                    " + _vm._s(total.title) + ": " + _vm._s(_vm._f("thousandSeprator")(total.value)) + "\n                  ")])
        }), 0)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "6",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": "195px"
          }
        }, [_c('v-card-title', {
          staticClass: "title"
        }, [_vm._v("Posted")]), _vm._v(" "), _c('v-card-subtitle', _vm._l((_vm.posted), function(total, index) {
          return _c('p', {
            key: index,
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("\n                    " + _vm._s(total.title) + ": " + _vm._s(_vm._f("thousandSeprator")(total.value)) + "\n                  ")])
        }), 0)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "sm": "6",
      "md": "4"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2,
            "min-height": "195px"
          }
        }, [_c('v-card-title', {
          staticClass: "title"
        }, [_vm._v("Posted Deliverables")]), _vm._v(" "), _c('v-card-subtitle', _vm._l((_vm.postedDeliverables), function(total, index) {
          return _c('p', {
            key: index,
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("\n                    " + _vm._s(total.title) + ": " + _vm._s(_vm._f("thousandSeprator")(total.value)) + "\n                  ")])
        }), 0)], 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [(!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (!_vm.disableSave) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.YesNoOptions,
      "item-text": "text",
      "item-value": "value",
      "label": "Completed Form",
      "filled": "",
      "dense": "",
      "small": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.customFilter.completedForm),
      callback: function($$v) {
        _vm.$set(_vm.customFilter, "completedForm", $$v)
      },
      expression: "customFilter.completedForm"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.YesNoOptions,
      "item-text": "text",
      "item-value": "value",
      "label": "Review in IMS",
      "filled": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.customFilter.imsReview),
      callback: function($$v) {
        _vm.$set(_vm.customFilter, "imsReview", $$v)
      },
      expression: "customFilter.imsReview"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "loading": _vm.loading
    },
    on: {
      "current-items": _vm.getDataTableFiltered
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }, {
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.platform === 'tiktok') ? _c('a', {
          attrs: {
            "href": 'https://www.tiktok.com/@' + item.handle,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.handle))]) : _c('a', {
          attrs: {
            "href": 'https://www.instagram.com/' + item.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle))], 1)])]
      }
    }, {
      key: "item.followers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(_vm._f("thousandSeprator")(item.followers)) + "\n            ")])]
      }
    }, {
      key: "item.completedForm",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.completedFormEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'completedForm')
            }
          }
        }, [_c('span', {
          staticClass: "text-center"
        }, [_vm._v("\n                  " + _vm._s(_vm.completedFormText(item.completedForm)) + "\n                ")])]) : _c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_c('v-select', {
          staticClass: "input-field pt-3",
          attrs: {
            "items": _vm.getCompletedFormOptions,
            "item-value": "value",
            "item-text": "text",
            "label": "Completed Form",
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.completedForm),
            callback: function($$v) {
              _vm.$set(item, "completedForm", $$v)
            },
            expression: "item.completedForm"
          }
        })], 1)])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(_vm.getStatusText(item.pairingStatus)) + "\n            ")])]
      }
    }, {
      key: "item.imsReview",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(item.imsReview ? 'YES' : 'NO') + "\n            ")])]
      }
    }, {
      key: "item.numberOfReviews",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v("\n              " + _vm._s(item.numberOfReviews) + "\n            ")])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticClass: "subtitle-2"
  }, [_vm._v("Total:")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm._f("thousandSeprator")(_vm.totals.followers)) + "\n              ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm.totals.completedForm) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm.totals.imsReview) + "\n              ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm._f("thousandSeprator")(_vm.totals.numberOfReviews)) + "\n              ")])])])], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fill-height"
  }, [_c('v-row', {
    staticClass: "mb-5",
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "item-text": "title",
      "item-value": "value",
      "items": _vm.periods,
      "hide-details": ""
    },
    on: {
      "change": _vm.searchPeriodChanged
    },
    model: {
      value: (_vm.searchPeriod),
      callback: function($$v) {
        _vm.searchPeriod = $$v
      },
      expression: "searchPeriod"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.startDate,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.startDate = $event
      },
      "update:return-value": function($event) {
        _vm.startDate = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "From",
            "readonly": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.menu1 = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.menu1.save(_vm.startDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.endDate,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.endDate = $event
      },
      "update:return-value": function($event) {
        _vm.endDate = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "To",
            "readonly": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.menu2 = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.menu2.save(_vm.endDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Filter campaign",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.fetchReports
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "fab": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.fetchReports
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.stats
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', [_c('tr', {
          staticClass: "tr-summary"
        }, _vm._l((_vm.headers), function(header, index) {
          return _c('td', {
            key: index,
            staticClass: "caption text-xs-center",
            attrs: {
              "align": "center"
            }
          }, [(header.value === 'campaignName') ? _c('p', {
            staticClass: "caption ma-0",
            attrs: {
              "align": "left"
            }
          }, [_c('b', [_vm._v("Summary")])]) : _vm._e(), _vm._v(" "), (header.value === 'engagement') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? _vm.summary[header.month].engagement : 0))))])], 1)], 1) : _vm._e(), _vm._v(" "), (header.value === 'contents') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? _vm.summary[header.month].contents : 0))))])], 1)], 1) : _vm._e(), _vm._v(" "), (header.value === 'outreach') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? _vm.summary[header.month].outreach : 0))) + "\n                  ")], 1)], 1) : _vm._e(), _vm._v(" "), (header.value === 'revenue') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? (_vm.summary[header.month].revenueCalculation === 'content' ? _vm.summary[header.month].revenueByContents : _vm.summary[header.month].revenue) | _vm.thousandSeprator : 0))))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.summary[header.month] ? (_vm.summary[header.month].revenueCalculation === 'content' ? 'Revenue by contents' : 'Revenue by engagement') : 'N/A')))])])], 1)], 1) : _vm._e()])
        }), 0), _vm._v(" "), _vm._l((items), function(item, index) {
          return _c('tr', {
            key: index
          }, _vm._l((_vm.headers), function(header, index) {
            return _c('td', {
              key: index,
              staticClass: "caption",
              attrs: {
                "align": "center"
              }
            }, [(header.value === 'campaignName') ? _c('p', {
              staticClass: "caption ma-0",
              attrs: {
                "align": "left"
              }
            }, [_vm._v(_vm._s(item.campaignName))]) : _vm._e(), _vm._v(" "), (header.value === 'engagement') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? item[header.month].engagement : 0))))])]) : _vm._e(), _vm._v(" "), (header.value === 'contents') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? item[header.month].contents : 0))))])]) : _vm._e(), _vm._v(" "), (header.value === 'outreach') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? item[header.month].outreach : 0))))]) : _vm._e(), _vm._v(" "), (header.value === 'revenue') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "color": "green",
                "small": "",
                "text-color": "white"
              }
            }, [_c('v-icon', {
              staticClass: "mr-0",
              attrs: {
                "small": "",
                "left": ""
              }
            }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('v-tooltip', {
              attrs: {
                "bottom": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;
                  var attrs = ref.attrs;

                  return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? (item[header.month].revenueCalculation === 'content' ? item[header.month].revenueByContents : item[header.month].revenue) | _vm.thousandSeprator : 0))))])])]
                }
              }], null, true)
            }, [_vm._v(" "), _c('span', [_vm._v(_vm._s((item[header.month] ? (item[header.month].revenueCalculation === 'content' ? 'Revenue by contents' : 'Revenue by engagement') : 'N/A')))])])], 1)], 1) : _vm._e()])
          }), 0)
        })], 2)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('CardSummary', {
    attrs: {
      "summary": _vm.summaries.activating
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('CardSummary', {
    attrs: {
      "summary": _vm.summaries.pairing
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('CardSummary', {
    attrs: {
      "summary": _vm.summaries.cocreating
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('CardSummary', {
    attrs: {
      "summary": _vm.summaries.complete
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-fade-transition', [_c('v-app', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "theme--dark"
  }, [_c('div', {
    staticClass: "hero-container"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/report/hero.jpg",
      "aspect-ratio": "1.7",
      "gradient": "to bottom right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, .7)"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "open-delay": 10000,
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-form', {
    ref: "passcodeForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "text-h5",
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-lock")]), _vm._v(" Enter Passcode")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-7"
  }, [_c('v-fade-transition', [(_vm.invalid) ? _c('v-alert', {
    attrs: {
      "type": "error",
      "dense": ""
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.errText) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "security",
      "append-icon": _vm.show1 ? 'visibility' : 'visibility_off',
      "type": _vm.show1 ? 'text' : 'password',
      "label": "Passcode",
      "error-messages": _vm.passcodeErrors
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces,
      "click:append": function($event) {
        _vm.show1 = !_vm.show1
      },
      "blur": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "keyup": function($event) {
        _vm.invalid = false
      }
    },
    model: {
      value: (_vm.passcode),
      callback: function($$v) {
        _vm.passcode = $$v
      },
      expression: "passcode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end pb-5"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "type": "submit",
      "disabled": _vm.submitting
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n              Submit\n              ")])], 1)], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activeMasterListData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline pb-5"
  }, [_vm._v("Add Invoice Sent")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("New Invoice to send: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.activeMasterListData.invoiceSent),
      callback: function($$v) {
        _vm.$set(_vm.activeMasterListData, "invoiceSent", $$v)
      },
      expression: "activeMasterListData.invoiceSent"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Remarks: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.activeMasterListData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.activeMasterListData, "remarks", $$v)
      },
      expression: "activeMasterListData.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.processUpdate()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Enter Version Name")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "",
      "error-messages": _vm.versionErrors,
      "counter": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.versionNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.versionNo.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmPasscode.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.versionNo),
      callback: function($$v) {
        _vm.versionNo = $$v
      },
      expression: "versionNo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.confirmVersionNo
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [(_vm.showCampaignPosts) ? _c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    model: {
      value: (_vm.filter.campaignId),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignId", $$v)
      },
      expression: "filter.campaignId"
    }
  }) : _c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Campaign",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchPosts.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignName", $$v)
      },
      expression: "filter.campaignName"
    }
  })], 1), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchPosts.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "instagramHandle", $$v)
      },
      expression: "filter.instagramHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && _vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clients,
      "outlined": true,
      "label": "Client"
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && _vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": true,
      "item-text": "text",
      "item-value": "value",
      "items": _vm.statuses,
      "outlined": true,
      "label": "Status"
    },
    model: {
      value: (_vm.filter.filterStatus),
      callback: function($$v) {
        _vm.$set(_vm.filter, "filterStatus", $$v)
      },
      expression: "filter.filterStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "sm12": ""
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "left": "",
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Grid View")])])], 1), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.pendingConfirmation ? 'warning' : 'default',
      "small": ""
    },
    on: {
      "click": _vm.changePendingConfirmation
    }
  }, [_vm._v("\n                    Upcoming Post Confirmation\n                    "), (_vm.pendingCount) ? _c('v-badge', {
    attrs: {
      "color": "blue",
      "content": _vm.pendingCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.overdueLiveDate ? 'warning' : 'default',
      "small": ""
    },
    on: {
      "click": _vm.changeOverdueDateFilter
    }
  }, [_vm._v("\n                    Overdue live date confirmation\n                    "), (_vm.overdueCount) ? _c('v-badge', {
    attrs: {
      "color": "green",
      "content": _vm.overdueCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.proposeDate ? 'warning' : 'default',
      "small": ""
    },
    on: {
      "click": _vm.changeProposeDateFilter
    }
  }, [_vm._v("\n                    Propose new dates\n                    "), (_vm.proposeCount) ? _c('v-badge', {
    attrs: {
      "color": "green",
      "content": _vm.proposeCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "margin-top": "-18px"
    },
    attrs: {
      "color": _vm.filter.emptyLiveDate ? 'warning' : 'default',
      "small": ""
    },
    on: {
      "click": _vm.changeEmptyLiveDateFilter
    }
  }, [_vm._v("\n                    Empty Live Dates\n                    "), (_vm.emptyLiveDateCount) ? _c('v-badge', {
    attrs: {
      "color": "green",
      "content": _vm.emptyLiveDateCount
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": "",
      "color": "info"
    },
    on: {
      "click": _vm.searchPosts
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.display === 1) ? _c('v-container', [_c('v-row', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "transition": "slide-x-transition"
    }
  }, _vm._l((_vm.posts), function(post, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "3",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2)),
            attrs: {
              "max-width": "344"
            }
          }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
            staticClass: "subtitle-1 ma-0"
          }, [_vm._v(_vm._s(post.campaignName))]), _vm._v(" "), _c('v-list-item-subtitle', {
            staticClass: "caption font-italic"
          }, [_vm._v("\n                        By\n                        "), (post.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + post.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(post.author.tiktokHandle))]) : (post.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + post.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(post.author.youtubeHandle))], 1) : (post.author.xhsHandle) ? _c('a', {
            on: {
              "click": function($event) {
                return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + post.author.xhsHandle)
              }
            }
          }, [_vm._v(_vm._s(post.author.xhsHandle))]) : (post.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + post.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(post.author.linkedinHandle))], 1) : (post.type === 'twitter' || post.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + (post.author.twitterHandle || post.author.instagramHandle),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(post.author.twitterHandle || post.author.instagramHandle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + post.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(post.author.instagramHandle))], 1)])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-menu', {
            attrs: {
              "bottom": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "icon": ""
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, post)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1)
          }), 1)], 1)], 1)], 1), _vm._v(" "), (!post.images[0]) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && !post.images[0].publicID) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": post.images[0].url,
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticClass: "post-cld-img cursor-pointer",
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {})
            }
          })], 1) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && !post.images[0].publicID) ? _c('video', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "height": "194px",
              "width": "100%"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('source', {
            attrs: {
              "src": post.images[0].url,
              "type": "video/mp4"
            }
          }), _vm._v("Your browser does not support the video tag.\n                  ")]) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticStyle: {
              "max-height": "200px",
              "overflow": "hidden"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {
                videoPreview: true
              })
            }
          })], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [(post.type !== 'post/carousel' && post.vdoLink) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            staticStyle: {
              "margin-top": "5px !important"
            },
            attrs: {
              "outlined": "",
              "color": "indigo",
              "target": "_blank",
              "href": post.vdoLink,
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-link")]), _vm._v("\n                        Video Link\n                      ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', _vm._l((post.labels), function(label) {
            return _c('v-chip', {
              key: label.text,
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, post)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                          ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(label.text) + "\n                          "), (label.icon) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))]) : _vm._e()], 1)
          }), 1)], 1)], 1)], 1)
        }
      }], null, true)
    })], 1)
  }), 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-pagination', {
    attrs: {
      "circle": "",
      "value": _vm.pagging.page,
      "length": _vm.paginationLength
    },
    on: {
      "input": function($event) {
        return _vm.pageChanged()
      }
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.display === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.selected.length > 0) ? _c('v-menu', {
    attrs: {
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "secondary"
          }
        }, on), [_vm._v("Bulk Action")])]
      }
    }], null, false, 1812722738)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.tableActions), function(menuItem, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.performSelected(menuItem.action)
        }
      }
    }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))])], 1)
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "item-key": "_id",
      "show-select": true,
      "server-items-length": _vm.totalItems,
      "options": _vm.pagging,
      "headers": _vm.headers,
      "items": _vm.posts,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPage
      }
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item._id
          }, [_c('td', [_c('v-checkbox', {
            staticClass: "pa-0 ma-0",
            attrs: {
              "checked": false,
              "value": item,
              "primary": "",
              "hide-details": ""
            },
            model: {
              value: (_vm.selected),
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.campaignName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-justify pa-1"
          }, [(item.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + item.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.author.linkedinHandle))], 1) : (item.type === 'twitter' || item.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + (item.author.twitterHandle || item.author.instagramHandle),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(item.author.twitterHandle || item.author.instagramHandle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._l((item.labels), function(label) {
            return _c('div', {
              key: label.text
            }, [(!label.postType) ? _c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, item)
                }
              }
            }, [_vm._v("\n                          " + _vm._s(label.text) + "\n                          "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))])], 1) : _vm._e()], 1)
          }), _vm._v(" "), (_vm.postStatus === _vm.postStatusConfig.LIVE && item.postURL) ? _c('div', [_c('v-btn', {
            attrs: {
              "rounded": "",
              "small": "",
              "color": "secondary",
              "href": item.postURL,
              "target": "_blink"
            }
          }, [_vm._v("\n                          View Live Post\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("link")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, _vm._l((item.labels), function(label) {
            return _c('div', {
              key: label.text
            }, [(label.postType) ? _c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, item)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                          ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(label.text) + "\n                          "), (label.icon) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))]) : _vm._e()], 1) : _vm._e()], 1)
          }), 0), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm.formatDate(item.createdAt, 'LLL')))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('v-menu', {
            attrs: {
              "bottom": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({}, on), [_vm._v("Action")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, item)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1)
          }), 1)], 1)], 1)])
        }), 0)]
      }
    }], null, false, 2877161339),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "proposeDateActions": _vm.showProposeDateAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "client_inf_chatbox": _vm.show_client_inf_chatbox,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "postReviewApproved": _vm.showPostReviewApproved,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "directReleased": _vm.directReleasePost,
      "editPost": _vm.editPostFromView,
      "editLiveDate": _vm.editLiveDateFromView,
      "mainPostChanged": _vm.reloadPostView,
      "postUpdated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('edit-post-modal', {
    attrs: {
      "post": _vm.editPostData,
      "postAbuseHistory": true,
      "value": _vm.editPostDialog,
      "userObj": _vm.user
    },
    on: {
      "postUpdated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.editPostDialog),
      callback: function($$v) {
        _vm.editPostDialog = $$v
      },
      expression: "editPostDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-modal', {
    attrs: {
      "post": _vm.assignCampaignPostData
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignDialog),
      callback: function($$v) {
        _vm.assignCampaignDialog = $$v
      },
      expression: "assignCampaignDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-multiple-modal', {
    attrs: {
      "posts": _vm.assignCampaignPosts
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignMultipleDialog),
      callback: function($$v) {
        _vm.assignCampaignMultipleDialog = $$v
      },
      expression: "assignCampaignMultipleDialog"
    }
  }), _vm._v(" "), _c('map-influencer-modal', {
    attrs: {
      "post": _vm.mapInfluencerPostData
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.influencerMapSuccess($event)
      }
    },
    model: {
      value: (_vm.mapInfluencerDialog),
      callback: function($$v) {
        _vm.mapInfluencerDialog = $$v
      },
      expression: "mapInfluencerDialog"
    }
  }), _vm._v(" "), _c('map-influencer-multiple-modal', {
    attrs: {
      "posts": _vm.mapInfluencerPosts
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.influencerMapSuccess($event)
      }
    },
    model: {
      value: (_vm.mapInfluencerMultipleDialog),
      callback: function($$v) {
        _vm.mapInfluencerMultipleDialog = $$v
      },
      expression: "mapInfluencerMultipleDialog"
    }
  }), _vm._v(" "), _c('submission-review-multiple-modal', {
    attrs: {
      "posts": _vm.selected,
      "internalApprove": true
    },
    on: {
      "successBulkApprove": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.submissionReviewMultipleDialog),
      callback: function($$v) {
        _vm.submissionReviewMultipleDialog = $$v
      },
      expression: "submissionReviewMultipleDialog"
    }
  }), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataForAddPost,
      "postID": _vm.postIdToUpdate,
      "post": _vm.addPost
    },
    on: {
      "done": _vm.postAdded
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('change-post-status-modal', {
    attrs: {
      "post": _vm.postDataForChangeStatus,
      "postIds": _vm.changePostIds
    },
    on: {
      "updated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('edit-live-date-modal', {
    attrs: {
      "post": _vm.postDataForEditLiveDate
    },
    on: {
      "postUpdated": function($event) {
        return _vm.searchPosts()
      }
    },
    model: {
      value: (_vm.editLiveDateDialog),
      callback: function($$v) {
        _vm.editLiveDateDialog = $$v
      },
      expression: "editLiveDateDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("Total Submissions")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "recognized-revenue-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.monthYearValues,
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.month",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.month) ? _c('span', [_vm._v(_vm._s(_vm.formatCurrentMonth(item.month)))]) : _vm._e()])]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.amount) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e()])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("Total " + _vm._s(_vm.currentYear))])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalAmount)))])])])])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "text-center",
    staticStyle: {
      "border": "1px solid #fff"
    },
    attrs: {
      "dark": _vm.darkTheme ? _vm.darkTheme : false,
      "elevation": "0",
      "max-width": "350px",
      "height": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "75px!important"
    }
  }, [_c('a', {
    staticClass: "view-link",
    attrs: {
      "href": _vm.url,
      "target": '_blank'
    }
  }, [_c('v-icon', {
    attrs: {
      "size": 50,
      "color": "grey"
    }
  }, [_vm._v("mdi-play-circle-outline")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex flex-row pb-3 pt-2",
    style: (("justify-content:" + (_vm.options.theme === 'default' ? 'space-between' : 'left') + ";"))
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [(_vm.options.theme === 'default') ? _c('p', {
    staticClass: "mb-0 pt-3 pr-2"
  }, [_vm._v("Activating Date - ")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    staticClass: "edit-date-box",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkActDate(_vm.activatingDate)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkActDate(_vm.activatingDate)
      }
    },
    model: {
      value: (_vm.activatingDate),
      callback: function($$v) {
        _vm.activatingDate = $$v
      },
      expression: "activatingDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon',
        confirm: true
      },
      "status": _vm.actEndDateCal
    },
    on: {
      "changeDate": _vm.setActDateFromPicker
    }
  })], 1), _vm._v(" "), (_vm.options.theme === 'default') ? _c('v-btn', {
    staticClass: "mt-1 secondary",
    attrs: {
      "small": "",
      "disabled": _vm.invalidActivatingDate
    },
    on: {
      "click": function($event) {
        return _vm.saveActivatingDate()
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("check")]), _vm._v("\n          Save\n        ")], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.invalidActivatingDate) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Invalid Activating Date")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [(_vm.options.theme === 'default') ? _c('p', {
    staticClass: "mb-0 pt-3 pr-2"
  }, [_vm._v("Review Meeting Date - ")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    staticClass: "edit-date-box",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.checkDate(_vm.reviewMeetingDate)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkDate(_vm.reviewMeetingDate)
      }
    },
    model: {
      value: (_vm.reviewMeetingDate),
      callback: function($$v) {
        _vm.reviewMeetingDate = $$v
      },
      expression: "reviewMeetingDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon',
        confirm: true
      },
      "status": _vm.endDateCal
    },
    on: {
      "changeDate": _vm.setDateFromPicker
    }
  })], 1), _vm._v("\n         "), (_vm.reviewMeetingDate && !_vm.invalidDate) ? _c('span', {
    class: ("pt-2 " + (_vm.utils.func.getDaysDiff(_vm.reviewMeetingDate) < 0 ? 'text-red': ''))
  }, [_vm._v("(" + _vm._s(_vm.utils.func.getDaysDiff(_vm.reviewMeetingDate)) + ")")]) : _vm._e(), _vm._v(" "), (_vm.options.theme === 'default') ? _c('v-btn', {
    staticClass: "mt-1 secondary",
    attrs: {
      "small": "",
      "disabled": _vm.invalidDate
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("check")]), _vm._v("\n          Save\n        ")], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.invalidDate) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Invalid Meeting Date")]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "#3F3FFF",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("My Tasks")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTasks()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-item', {
      key: item.title,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.actionOnTask(item.action, item.postID)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.text) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "720"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Campaign Lists for @" + _vm._s(_vm.handle))])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 10,
      "no-data-text": 'Empty list'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap"
  }, [_c('v-switch', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.busy,
      "hide-details": "",
      "label": "Accepting feedback",
      "loading": _vm.busy,
      "input-value": _vm.accepting
    },
    on: {
      "change": function($event) {
        _vm.change(Boolean($event))
      }
    }
  }), _vm._v(" "), (_vm.accepting && _vm.expiresAt) ? _c('span', {
    staticClass: "ml-3 text-caption"
  }, [_vm._v("Valid until " + _vm._s(new Date(_vm.expiresAt).toLocaleString()))]) : _vm._e()], 1), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('v-alert', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.link) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Copy link")]) : _vm._e(), _vm._v(" "), (_vm.link) ? _c('v-text-field', {
    attrs: {
      "label": "Feedback link",
      "value": _vm.link,
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "subtitle-1 ma-0"
  }, [_vm._v("\n            Ensure that you have an active account on our KOBE platform:\n            "), _c('a', {
    attrs: {
      "href": "https://app.getkobe.com"
    }
  }, [_vm._v("https://app.getkobe.com")]), _vm._v(" with all your updated details.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-2 ma-0"
  }, [_vm._v("Reminder:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Both client and influencer will be mutually rated after each campaign and all scores will be kept confidential.")]), _vm._v(" "), _c('li', [_vm._v("Submitting of drafts and payments will be done seamlessly via our Kobe platform (your payout will be credited to your bank account once your post goes live and statistics uploaded on our platform)")]), _vm._v(" "), _c('li', [_vm._v("Do not live your post until you have received clearance from us, you will be notified through our platform and your email.")]), _vm._v(" "), _c('li', [_vm._v("For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation and penalty from the campaign.")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("Campaign summary")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6",
      "align": "left",
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "headline font-regular font-weight-bold ml-2"
  }, [_vm._v(_vm._s(_vm.brief.campaignName))]), _vm._v(" "), (_vm.status === _vm.statusINVITED) ? _c('div', [_c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.doAction('interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Interested\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.doReject('not_interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Interested\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.doAction('inquiry')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-help")]), _vm._v("Inquiry\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINQUIRY) ? _c('div', [_c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.doAction('interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Interested\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.doReject('not_interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Interested\n                ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-help-circle-outline ")])], 1), _vm._v("You have asked the question about this invitation.\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINTERESTED) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-checkbox-marked-circle")])], 1), _vm._v("You are interested in this campaign\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTINTERESTED) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "red",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1), _vm._v("You have not interested in this invitation.\n                ")], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Reasons of rejection")]), _vm._v(" "), (_vm.rejectReasons) ? _c('ul', [(_vm.rejectReasons.campaign_proposed) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_proposed))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.campaign_timeline) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_timeline))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.payout_issue) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.payout_issue))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.competitor) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.competitor))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.not_associate) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.not_associate))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.others) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.others))]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED) ? _c('div', [_c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-check")])], 1), _vm._v("You are interested in this campaign\n                  ")], 1)], 1), _vm._v(" "), _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-check")])], 1), _vm._v("You have been accepted for this campaign.\n                  ")], 1)], 1), _vm._v(" "), ((_vm.isAgree === 0 || _vm.isAgree === undefined)) ? _c('div', [(_vm.briefDetailsHTML) ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin": "20px 10px 0 10px"
    }
  }, [_vm._v("\n                  Review invoice and terms here.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.briefDetailsHTML) ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.showAgreement
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Invoice and Contract\n                  ")], 1) : _vm._e()], 1) : _c('div', [(_vm.isAgree) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-check")])], 1), _vm._v("You have agreed to the terms and conditions.\n                  ")], 1) : _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "red",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-cancel")])], 1), _vm._v("\n                      You do not agree to the terms and conditions.\n                    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "rounded": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.showAgreement
    }
  }, [_vm._v("Change your mind?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin-left": "15px"
    }
  }, [_vm._v("A Kobe representative will be in touch.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTACCEPTED) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "red",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1), _vm._v("You have been not accepted for this campaign.\n                ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('p', {
    staticClass: "headline font-regular"
  }, [_vm._v("\n                Payout:\n                "), (_vm.GST) ? _c('span', {
    staticClass: "success--text bold headline"
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.payout + (_vm.payout * 0.08))))]) : _c('span', {
    staticClass: "success--text bold headline"
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.payout)))])]), _vm._v(" "), _c('p', {
    staticClass: "title ma-0 font-regular"
  }, [_vm._v("Deliverables")]), _vm._v(" "), (_vm.deliverables) ? _c('ul', [(_vm.deliverables.no_of_posts) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_posts))]), _vm._v(" x Instagram Post\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_stories) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_stories))]), _vm._v(" x Instagram Stories\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_carousels) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_carousels))]), _vm._v(" x Instagram Carousel\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_video) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_video))]), _vm._v(" x Instagram Video\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_igTv) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_igTv))]), _vm._v(" x Instagram TV\n                ")]) : _vm._e()]) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.status === _vm.statusINQUIRY) ? _c('v-row', [_c('v-col', {
    attrs: {
      "col": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("\n            Recent Questions\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "info"
    },
    on: {
      "click": _vm.inquiryBox
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("New Question\n          ")], 1), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUnderLine || this.loadAllQuestoins.length > 0),
      expression: "showUnderLine || this.loadAllQuestoins.length > 0"
    }]
  }), _vm._v(" "), _c('QandA', {
    key: _vm.QandAComponentKey,
    attrs: {
      "Questions": _vm.loadAllQuestoins,
      "campaignID": this.$route.params.campaignID,
      "influencerID": this.influencer,
      "TriggerEmail": true,
      "pairedID": _vm.pairingID
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [((_vm.status === _vm.statusINTERESTED || _vm.status === _vm.statusACCEPTED || _vm.status === _vm.statusNOTACCEPTED) && (_vm.briefDetailsHTML && _vm.briefDetailsHTML !== {})) ? _c('v-col', {
    attrs: {
      "col": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("\n            Brief Details\n            "), _c('hr')]), _vm._v(" "), _c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(this.briefDetailsHTML)
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brief.campaignBackground),
      expression: "brief.campaignBackground"
    }]
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n          Campaign Background\n        ")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.brief.campaignBackground))])])], 1)], 1)], 1), _vm._v(" "), _c('reject-modal', {
    attrs: {
      "dialog": _vm.showRejectModal,
      "close": _vm.closeRejectModal,
      "pairingID": _vm.pairingID,
      "updateStatus": _vm.updatStatus
    }
  }), _vm._v(" "), _c('influencer-contract-modal', {
    attrs: {
      "dialogTitle": "Invoice and Contract",
      "dialog": _vm.showContractModal,
      "close": _vm.closeInfluencerContractModal,
      "contract": _vm.influencerContract,
      "didAgree": _vm.didAgree,
      "didNotAgree": _vm.didNotAgree,
      "showTerms": true,
      "showSendButton": false,
      "showSubmitButton": true,
      "showDeclineButton": true,
      "showOptions": true,
      "showCancelButton": false,
      "isAgreement": true,
      "briefDetailHTML": _vm.briefDetailsHTML
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "href": _vm.post && _vm.post.permalink,
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.post ? (_vm.post.media_type === 'VIDEO' ? _vm.post.thumbnail_url : _vm.post.media_url) : null,
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.post && _vm.post.caption ? _vm.post.caption.substring(0, 25) : '') + "... ")]), _vm._v(" "), _c('v-card-actions', [_c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.isSelected ? 'primary' : 'red',
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [(_vm.isSelected) ? _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]) : _vm._e(), _vm._v(" "), (!_vm.isSelected) ? _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close-circle")]) : _vm._e()], 1), _vm._v("\n      " + _vm._s(_vm.post && _vm.post.isStory ? 'Story' : 'Post') + "\n    ")], 1), _vm._v(" "), (!_vm.isSelected) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('selected')
      }
    }
  }, [_vm._v("\n      Select\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.show = !_vm.show
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.show ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.post ? _vm.post.caption : '') + "\n      ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_vm._v("\n      No Data\n    ")]
      },
      proxy: true
    }, {
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Requestor")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Date Time")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Old Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("New Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Reasons")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pairing.activity), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(item.requestor || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.utils.func.formatCustomDate(item.createdAt, 'DD/MM/YYYY hh:mm:ss')))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.oldAmount)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.newAmount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reasons))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "100px"
            }
          }, [(item.status === 'pending') ? _c('div', {
            staticClass: "text-center"
          }, [_c('v-btn', {
            staticClass: "btn__p100 ma-1",
            attrs: {
              "small": "",
              "color": "success"
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingActivity(item, 'approve')
              }
            }
          }, [_vm._v("\n                Approve\n              ")]), _vm._v(" "), _c('v-btn', {
            staticClass: "btn__p100 ma-1",
            attrs: {
              "small": "",
              "color": "error"
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingActivity(item, 'reject')
              }
            }
          }, [_vm._v("\n                Reject\n              ")])], 1) : _c('div', [(item.status === 'approve') ? _c('v-chip', {
            attrs: {
              "color": "success",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                Approved\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 'reject') ? _c('v-chip', {
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                Rejected\n              ")]) : _vm._e(), _vm._v(" "), (item.status === 'cancel') ? _c('v-chip', {
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                Cancelled\n              ")]) : _vm._e(), _vm._v(" "), (item.actor) ? _c('span', {
            staticClass: "text-caption",
            staticStyle: {
              "font-size": "10px!important"
            }
          }, [_vm._v("by " + _vm._s(item.actor))]) : _vm._e()], 1)])])
        }), 0)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Payout History")])])
}]}

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', [_c('v-row', {
    staticStyle: {
      "justify-content": "right",
      "margin-top": "-110px",
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": function (item) { return item.firstName + ' ' + item.lastName; },
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "CC"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.cc),
      callback: function($$v) {
        _vm.$set(_vm.filters, "cc", $$v)
      },
      expression: "filters.cc"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Pending")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.pending))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Valid")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.verified))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Invalid")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.unverified))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end",
      "width": "100%",
      "padding-top": "12px",
      "gap": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  TikTok Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.tiktokFollowers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "from", $$v)
      },
      expression: "filters.tiktokFollowers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.tiktokFollowers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "to", $$v)
      },
      expression: "filters.tiktokFollowers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isTikTokEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isTikTokEmpty", $$v)
      },
      expression: "filters.isTikTokEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchTikTokFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  IG Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "from", $$v)
      },
      expression: "filters.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "to", $$v)
      },
      expression: "filters.followers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isIgEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isIgEmpty", $$v)
      },
      expression: "filters.isIgEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchIGFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  Rate "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Content Type\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.contentTypes,
      "item-text": "title",
      "item-value": "value"
    },
    model: {
      value: (_vm.filters.contentType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "contentType", $$v)
      },
      expression: "filters.contentType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.filters.rateCurrency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCurrency", $$v)
      },
      expression: "filters.rateCurrency"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "from", $$v)
      },
      expression: "filters.rate.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "to", $$v)
      },
      expression: "filters.rate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  Age "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      Min Age\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.age.min),
      callback: function($$v) {
        _vm.$set(_vm.filters.age, "min", $$v)
      },
      expression: "filters.age.min"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      Max Age\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.age.max),
      callback: function($$v) {
        _vm.$set(_vm.filters.age, "max", $$v)
      },
      expression: "filters.age.max"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.countries,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.rateCardLabels,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Main Category"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.mainCategory),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mainCategory", $$v)
      },
      expression: "filters.mainCategory"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.statuses,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Status"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "width": "100%",
      "justify-content": "right"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "margin-left": "-25px"
    },
    attrs: {
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Sort By\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.sortColumns
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  })], 1), _vm._v(" "), (_vm.isSortCurrency) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.sort.currency),
      callback: function($$v) {
        _vm.$set(_vm.sort, "currency", $$v)
      },
      expression: "sort.currency"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Type\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-20px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "id": "rate-card-data-table",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]
      }
    }, {
      key: "item.email",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.email) + "\n          ")])]
      }
    }, {
      key: "item.dateOfBirth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n            " + _vm._s(item.dateOfBirth ? _vm.utils.formatCustomDate(item.dateOfBirth, 'MMM, YYYY') : '') + "\n          ")])]
      }
    }, {
      key: "item.ethnicity",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.ethnicity && item.ethnicity !== 'Others' ? item.ethnicity : '') + "\n            " + _vm._s(item.otherEth ? item.otherEth : '') + "\n          ")])]
      }
    }, {
      key: "item.country",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.country) + "\n          ")])]
      }
    }, {
      key: "item.city",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.city) + "\n          ")])]
      }
    }, {
      key: "item.gender",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.gender) + "\n          ")])]
      }
    }, {
      key: "item.contactNo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.contactNo) + "\n          ")])]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.instagramHandle) ? _c('social-handle', {
          attrs: {
            "isInstagram": true,
            "instagramHandle": item.instagramHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.igFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.igFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.tiktokHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.tiktokHandle) ? _c('social-handle', {
          attrs: {
            "isTikTok": true,
            "tiktokHandle": item.tiktokHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.tiktokFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.tiktokFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.cc",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.sourceID) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.CC.find(function (cc) { return cc.id === item.sourceID; }) ? _vm.CC.find(function (cc) { return cc.id === item.sourceID; }).firstName + ' ' + _vm.CC.find(function (cc) { return cc.id === item.sourceID; }).lastName : '') + "\n            ")]) : _vm._e()])]
      }
    }, {
      key: "item.youtube",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'youtube')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'youtube'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'youtube')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.facebook",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'facebook')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'facebook'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-facebook")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'facebook')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.twitch",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'twitch')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'twitch'),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getHandlePreview(item, 'twitch')))])]) : _vm._e()])]
      }
    }, {
      key: "item.igStory",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igStoryCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igStory)))]) : _vm._e()])]
      }
    }, {
      key: "item.igPost",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igPostCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igPost)))]) : _vm._e()])]
      }
    }, {
      key: "item.igCarousel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igCarouselCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igCarousel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igVideoCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igVideo)))]) : _vm._e()])]
      }
    }, {
      key: "item.igReel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igReelCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igReel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.igRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.igRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.tiktok",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.tiktokCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.tiktok)))]) : _vm._e()])]
      }
    }, {
      key: "item.tiktokRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.tiktokRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.tiktokRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.eventAppearance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.eventAppearanceCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.eventAppearance)))]) : _vm._e()])]
      }
    }, {
      key: "item.loadingFee",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.loadingFeeCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.loadingFee)))]) : _vm._e()])]
      }
    }, {
      key: "item.uploadMediaKit",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, _vm._l((item.pricingDecks), function(deck, idx) {
          return _c('v-btn', {
            key: idx,
            attrs: {
              "small": "",
              "text": "",
              "color": "secondary",
              "href": deck.url,
              "target": "_blank"
            }
          }, [_vm._v("\n              View Media\n            ")])
        }), 1)]
      }
    }, {
      key: "item.preferredCampaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.keywords || item.keywords.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.keywords), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.keywords),
            expression: "item.keywords"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.keywords && item.keywords.length > 1),
                  expression: "item.keywords && item.keywords.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Preferred Campaigns / Genre")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.keywords), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest))])
        })], 2)], 1)], 1)], 2)]
      }
    }, {
      key: "item.labels",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.labels || item.labels.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.labels), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.labels),
            expression: "item.labels"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.labels && item.labels.length > 0),
                  expression: "item.labels && item.labels.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Labellings")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.labels), function(label, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        })], 2)], 1)], 1), _vm._v(" "), _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mb-1 pa-0",
                attrs: {
                  "color": "secondary",
                  "small": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("edit")]), _vm._v("  Label\n                ")], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('div', [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Main Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.mainCategories),
            callback: function($$v) {
              _vm.$set(item, "mainCategories", $$v)
            },
            expression: "item.mainCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Sub Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "multiple": "",
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.subCategories),
            callback: function($$v) {
              _vm.$set(item, "subCategories", $$v)
            },
            expression: "item.subCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1)], 1)])], 1)], 2)]
      }
    }, {
      key: "item.aboutYou",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.aboutYou || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.aboutYou))
          }
        })])], 1)]
      }
    }, {
      key: "item.loadContent",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.loadContent) + "\n            " + _vm._s(item.loadContentText) + "\n          ")])]
      }
    }, {
      key: "item.giftBrand",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.giftBrand) + "\n          ")])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.verify === true) ? _c('v-chip', {
          attrs: {
            "color": "primary",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("\n              Valid\n            ")]) : (item.verify === false) ? _c('v-chip', {
          attrs: {
            "color": "error",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("\n              Invalid\n            ")]) : _c('v-chip', {
          attrs: {
            "color": "secondary",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("\n              Pending\n            ")])], 1)]
      }
    }, {
      key: "item.updatedAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "105px!important"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.utils.formatCustomDate(item.updatedAt, 'DD-MM-YYYY')) + "\n          ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('div', {
          staticStyle: {
            "display": "flex",
            "gap": "5px"
          }
        }, [_c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Details"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "success",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.openVerifyDialog(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Verify"
          }
        }, [_vm._v("mdi-check-circle")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": "",
            "disabled": item.accountExist
          },
          on: {
            "click": function($event) {
              return _vm.openResetDialog(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "secondary"
                }
              }, on), [_vm._v("mdi-account-plus")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Onboard to IMS")])])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Rate Card",
            "color": "error",
            "text": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteRateCard(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _vm._v(" "), (_vm.viewData) ? _c('view-modal-dialog', {
    attrs: {
      "value": _vm.viewDialog,
      "data": _vm.viewData
    },
    model: {
      value: (_vm.viewDialog),
      callback: function($$v) {
        _vm.viewDialog = $$v
      },
      expression: "viewDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('verify-dialog', {
    attrs: {
      "item": _vm.verifyData
    },
    on: {
      "verified": _vm.handleVerified
    },
    model: {
      value: (_vm.verifyDialog),
      callback: function($$v) {
        _vm.verifyDialog = $$v
      },
      expression: "verifyDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Ratecard Forms",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('inf-onboard-password-modal', {
    attrs: {
      "influencer": _vm.viewData
    },
    on: {
      "reload": _vm.onBoardSuccess
    },
    model: {
      value: (_vm.infPassResetDialog),
      callback: function($$v) {
        _vm.infPassResetDialog = $$v
      },
      expression: "infPassResetDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2 mt-3"
  }, [_c('master-lists-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-toolbar-title', [_c('h2', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("View Campaign Brief")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isClient) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openAMCCInputsDialog()
      }
    }
  }, [_vm._v("\n          AM, CC Inputs\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue-grey",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.savePDF()
      }
    }
  }, [_c('v-icon', [_vm._v("get_app")]), _vm._v("Download PDF\n        ")], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body",
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, _vm._l((_vm.campaignModelSections), function(section) {
    return _c('v-layout', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "hover": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewComments(section)
        }
      }
    }, [_c('v-toolbar', {
      attrs: {
        "dense": "",
        "flat": ""
      }
    }, [_c('v-toolbar-title', {
      staticClass: "title"
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-badge', {
      attrs: {
        "value": section.unreadComments.length,
        "content": section.unreadComments.length,
        "color": "green",
        "overlap": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.viewComments(section)
        }
      }
    }, [_c('v-btn', [_c('v-icon', {
      attrs: {
        "color": section.unreadComments.length == 0 ? 'secondary' : 'red'
      }
    }, [_vm._v("chat")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [(
      (section.type === _vm.campaignModelSectionType.CAMPAIGN_SUMMARY) ||
      (section.type === _vm.campaignModelSectionType.INFLUENCER_SELECTION) ||
      (section.type === _vm.campaignModelSectionType.BUDGET_ALLOCATION) ||
      (section.type === _vm.campaignModelSectionType.VIDEO_BRIEF && _vm.showVideoBrief)) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [(campaignField.type === 'text' && campaignField.name === 'vertical' && !_vm.isClient) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', _vm._l((_vm.selectedCampaignVertical), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          on: {
            "click:close": function($event) {
              return _vm.removeChip(index)
            }
          }
        }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                        ")])
      }), 1)]) : (_vm.campaign[campaignField.name] && (campaignField.type === 'text' && campaignField.name !== 'vertical') && (campaignField.name !== 'dont' || _vm.hideRequiredActions()) && _vm.campaign[campaignField.name] !== '' || (campaignField.type === 'slider' && _vm.campaign[campaignField.name] !== '')) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'combobox' && _vm.campaign[campaignField.name] && _vm.campaign[campaignField.name].length > 0) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (Array.isArray(_vm.campaign[campaignField.name]) && campaignField.name !== 'targetLocation') ? _c('div', _vm._l((_vm.campaign[campaignField.name]), function(value) {
        return _c('v-chip', {
          key: value,
          staticClass: "ma-2"
        }, [_vm._v(_vm._s(value))])
      }), 1) : (Array.isArray(_vm.campaign[campaignField.name]) && campaignField.name === 'targetLocation') ? _c('div', _vm._l((_vm.campaign[campaignField.name]), function(value) {
        return _c('v-chip', {
          key: value,
          staticClass: "ma-2"
        }, [_vm._v(_vm._s(value))])
      }), 1) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.campaign[campaignField.name]))])])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea' && _vm.campaign[campaignField.name] !== '') ? _c('div', [((campaignField.name !== 'visualMust' &&
        campaignField.name !== 'copyMust') || _vm.hideRequiredActions()) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', {
        staticStyle: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (campaignField.type === 'select' && _vm.campaign[campaignField.name] && _vm.campaign[campaignField.name] != 'No preference' && (campaignField.name === 'gender' || campaignField.name === 'targetGender' || _vm.hideRequiredActions())) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'ioNumbers') ? _c('p', [_vm._v(_vm._s((_vm.campaign[campaignField.name] ? _vm.campaign[campaignField.name] : '-')))]) : (campaignField.name === 'name') ? _c('p', [_vm._v(_vm._s((_vm.campaign[campaignField.name] ? _vm.campaign[campaignField.name] : '-')) + " "), (_vm.campaign.campaignCode) ? _c('span', [_vm._v("(" + _vm._s(_vm.campaign.campaignCode) + ")")]) : _vm._e()]) : _c('p', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'autocomplete' && _vm.campaign[campaignField.name]) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCountryDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'chips' && _vm.campaign[campaignField.name]) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', _vm._l((_vm.campaign[campaignField.name]), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "value": item,
            "filter": ""
          }
        }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])
      }), 1)]) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && _vm.campaign[campaignField.name] !== '') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', [_c('a', {
        staticClass: "campaign-image",
        attrs: {
          "href": _vm.constructImageURL(_vm.campaign[campaignField.name]),
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "src": _vm.constructImageURL(_vm.campaign[campaignField.name])
        }
      })])])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'radio' && (campaignField.name === 'revenueCalculation' && _vm.hideRequiredActions()) && _vm.campaign[campaignField.name] !== undefined && _vm.campaign[campaignField.name] !== '') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_c('v-chip', [_vm._v(_vm._s(_vm.campaign[campaignField.name] === undefined || _vm.campaign[campaignField.name] === '' ? 'CONTENT' : _vm.campaign[campaignField.name].toUpperCase()))])], 1)]) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.CONTENT_ANGLE) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'select' && ((campaignField.name === 'actionRequired_time' ||
        campaignField.name === 'actionRequired_action' ||
        campaignField.name === 'actionRequired_receive' ||
        campaignField.name === 'actionRequired_value') && _vm.hideRequiredActions())) ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', {
        attrs: {
          "xs12": ""
        }
      }, _vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex,
          staticClass: "form-group col-xs-12 pa-0"
        }, _vm._l((campaignField.template), function(optionField) {
          return _c('element', {
            key: optionField.name
          }, [(optionField.type == 'text') ? _c('div', {
            staticClass: "form-group col-xs-12 pa-0 mb-0"
          }, [_c('h4', {
            staticClass: "mb-1"
          }, [_c('strong', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] ? 'Concept ' + (optionIndex + 1) + ': ' + _vm.campaign[campaignField.name][optionIndex][optionField.name] : 'Option ' + (optionIndex + 1)))])])]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea' && _vm.campaign[campaignField.name][optionIndex][optionField.name]) ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-12 mb-1 pb-0 pl-0"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('p', {
            staticStyle: {
              "white-space": "pre-line"
            }
          }, [_vm._v(_vm._s(!_vm.campaign[campaignField.name][optionIndex][optionField.name] ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'multiple_options') ? _c('div', _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(secondOption, secondOptionIndex) {
            return _c('div', {
              key: secondOptionIndex
            }, _vm._l((optionField.template), function(optionField2, optionIndex2) {
              return _c('v-layout', {
                key: optionIndex2,
                staticClass: "multiple-format",
                attrs: {
                  "wrap": ""
                }
              }, _vm._l((optionField2), function(format, i) {
                return _c('v-flex', {
                  key: i,
                  attrs: {
                    "xs6": ""
                  }
                }, [(format.type == 'text' && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) ? _c('div', {
                  staticClass: "form-group col-xs-12"
                }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] : '-'))])])]) : _vm._e(), _vm._v(" "), (format.type == 'textarea' && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) ? _c('div', {
                  staticClass: "form-group col-xs-12 pa-0 ma-0"
                }, [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('p', {
                  staticStyle: {
                    "white-space": "pre-line"
                  }
                }, [_vm._v(_vm._s(!_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]))])]) : _vm._e(), _vm._v(" "), (format.type === 'combobox' && Array.isArray(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name].length > 0) ? _c('div', {
                  staticClass: "form-group col-xs-12 pa-0 ma-0"
                }, [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), (Array.isArray(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name])) ? _c('div', _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]), function(value) {
                  return _c('v-chip', {
                    key: value,
                    staticClass: "ma-2"
                  }, [_vm._v(_vm._s(value))])
                }), 1) : _c('div', [_c('p', [_vm._v(_vm._s(!_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]))])])]) : _vm._e(), _vm._v(" "), (format.type == 'upload' && Array.isArray(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) && _vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name].length > 0) ? _c('div', {
                  staticClass: "form-group col-xs-12 pa-0 ma-0 img-insp-block"
                }, [_c('div', {
                  staticClass: "col-12 pl-0"
                }, [_c('label', [_vm._v(_vm._s(format.label))])]), _vm._v(" "), _c('div', {
                  staticClass: "d-flex flex-sm-column flex-column"
                }, _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]), function(image) {
                  return _c('div', {
                    key: image,
                    staticClass: "pl-0"
                  }, [(image.type === 'image') ? _c('a', {
                    key: image,
                    staticClass: "campaign-image",
                    attrs: {
                      "href": _vm.constructImageURL(image.url),
                      "target": "_blank"
                    }
                  }, [_c('img', {
                    staticStyle: {
                      "width": "100%"
                    },
                    attrs: {
                      "src": _vm.constructImageURL(image.url)
                    }
                  })]) : _vm._e(), _vm._v(" "), (image.type === 'link') ? _c('a', {
                    key: image,
                    staticClass: "campaign-image",
                    attrs: {
                      "href": image.url,
                      "target": "_blank"
                    }
                  }, [(_vm.checkMediaURL(image.url) === 'drive') ? _c('iframe', {
                    staticClass: "media-iframe",
                    attrs: {
                      "width": "150px",
                      "height": "100%",
                      "src": image.url,
                      "allowFullScreen": ""
                    }
                  }) : _c('p', [_vm._v(_vm._s(image.url))])]) : _vm._e()])
                }), 0)]) : _vm._e()])
              }), 1)
            }), 1)
          }), 0) : _vm._e()])
        }), 0)
      }), 0) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.EVENT_BRIEF && _vm.showEventBrief && _vm.campaign.eventBrief) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'textarea') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(campaignField.label))])]), _vm._v(" "), _c('p', {
        staticStyle: {
          "white-space": "pre-wrap"
        }
      }, [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name]))])], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(campaignField.label))])]), _vm._v(" "), _vm._l((_vm.campaign.eventBrief[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": "",
              "md3": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e()])
        }), 1)], 1)], 1)
      })], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'template') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(campaignField.label))])]), _vm._v(" "), _c('v-container', [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, _vm._l((campaignField.template), function(templateField, i) {
        return _c('v-flex', {
          key: i,
          attrs: {
            "xs12": "",
            "md4": ""
          }
        }, [(templateField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name]))])]) : _vm._e(), _vm._v(" "), (templateField.type === 'radioButton') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes' : 'No'))])]) : _vm._e(), _vm._v(" "), (templateField.type === 'date' && templateField.name === 'eventDate') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name]))])]) : _vm._e(), _vm._v(" "), (templateField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('p', {
          staticStyle: {
            "white-space": "pre-wrap"
          }
        }, [_vm._v(_vm._s(_vm.campaign.eventBrief[campaignField.name][templateField.name]))])]) : _vm._e()])
      }), 1)], 1)], 1) : _vm._e()])
    }), 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.currentSectionSelected !== null) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('chatbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentSectionSelected.type === section.type),
        expression: "currentSectionSelected.type === section.type"
      }],
      attrs: {
        "messages": _vm.comments,
        "title": _vm.commentTitle,
        "readOnly": !_vm.isPendingCampaign
      },
      on: {
        "sendMessage": _vm.sendComment,
        "reloadMessage": _vm.viewComments
      }
    })], 1) : _vm._e()], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('am-cc-inputs-modal', {
    attrs: {
      "campaign": _vm.campaignData
    },
    model: {
      value: (_vm.amCCInputsDialog),
      callback: function($$v) {
        _vm.amCCInputsDialog = $$v
      },
      expression: "amCCInputsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-container', [(_vm.type === 'post/carousel' || _vm.type === 'reel') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.engagement !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.engagement)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.likes !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.likes)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comments !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comments)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.saved && _vm.post.saved !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.saved)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares && _vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views && _vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.plays && _vm.post.plays !== '0h:0m:0s' && _vm.post.plays !== 'h:m:s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watch Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.showTikTokPlayTime(_vm.post.plays))))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches && _vm.post.watches !== '0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Average Watch Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.post.type !== 'story') ? _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "350px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.igPost)
    }
  })]) : _vm._e()], 1)], 1)], 1) : (_vm.type === 'story') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.storyTotalInteractions !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.storyTotalInteractions)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.link_clicks !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Link Clicks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.link_clicks)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.replies !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Replies")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.replies)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.sticker_taps !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Sticker Taps")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.sticker_taps)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.MEDIA_URL_TYPE === 'video') ? _c('video', {
    attrs: {
      "width": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.POST_URL,
      "type": "video/mp4"
    }
  }), _vm._v("\n                        Your browser does not support HTML5 video.\n                      ")]) : (_vm.MEDIA_URL_TYPE === 'image') ? _c('img', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "src": _vm.POST_URL
    }
  }) : (_vm.MEDIA_URL_TYPE === 'driveView') ? _c('gDrive-post-view', {
    attrs: {
      "url": _vm.POST_URL,
      "darkTheme": true
    }
  }) : (_vm.MEDIA_URL_TYPE === 'cld') ? _c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans
    }
  }) : (_vm.MEDIA_URL_TYPE === 'iframe') ? _c('iframe', {
    staticClass: "media-iframe",
    attrs: {
      "height": "100%",
      "src": _vm.POST_URL,
      "allowFullScreen": ""
    }
  }) : _c('div', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_c('v-alert', {
    attrs: {
      "width": "350"
    }
  }, [_vm._v("\n                          Media type unsupported!\n                        ")])], 1)], 1)], 1)], 1)], 1) : (_vm.type === 'tiktok') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tik-tok-pink.png",
      "width": "36px"
    }
  }), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.engagement !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.engagement)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.likes !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.likes)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comments !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comments)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.saved && _vm.post.saved !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.saved)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares && _vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.plays !== 0 && _vm.post.plays !== '0h:0m:0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Play Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.showTikTokPlayTime(_vm.post.plays))))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0 && _vm.post.watches !== '0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Average Watch Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watchedFullVideo !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watched Full Video")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watchedFullVideo)) + "%")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.photo_views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Photo Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.photo_views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.tikTokPost) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "177.7778%",
      "padding-top": "90px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "height": "100%",
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "src": _vm.tikTokPost,
      "allow": "fullscreen"
    }
  })])]) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'youtube') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fab fa-youtube pr-3",
    staticStyle: {
      "font-size": "36px",
      "color": "#dd2476"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.likes !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.likes)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comments !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comments)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.youtubePost) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "177.7778%",
      "padding-top": "90px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "height": "100%",
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "src": _vm.youtubePost,
      "allow": "fullscreen"
    }
  })])]) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'facebook') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "177.7778%",
      "padding-top": "90px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.getFbPost(_vm.post.url),
      "allow": "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
      "allowfullscreen": "true",
      "scrolling": "no"
    }
  })])]) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'xhs') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watches")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)) + "s")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans,
      "download": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.download(_vm.getMedia(_vm.post).URL)
      }
    }
  }, [_vm._v("\n                              Download\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.xhsLink)
      }
    }
  }, [_vm._v("\n                              View on XHS\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-outline")])], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'lemon') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watches")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)) + "s")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [_c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans,
      "download": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.download(_vm.getMedia(_vm.post).URL)
      }
    }
  }, [_vm._v("\n                              Download\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.lemonLink)
      }
    }
  }, [_vm._v("\n                              View on Lemon8\n                              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-outline")])], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1) : (_vm.type === 'linkedin') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "#0A66C2"
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" "), _c('div', [_vm._v("LinkedIn Post - @" + _vm._s(_vm.post.name))])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "linkedin-insights"
  }, [(_vm.hasPositiveMetric(_vm.post.impressions)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Impressions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.impressions || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.reach)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Members reached")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.reach || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.like_count)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Reactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.like_count || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.comment_count)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.comment_count || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.shares)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Reposts")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.shares || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasPositiveMetric(_vm.post.saved != null ? _vm.post.saved : _vm.post.bookmarks)) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Saves")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.post.saved || _vm.post.bookmarks || 0))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#0A66C2",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7",
      "align": "center"
    }
  }, [(_vm.getLinkedInEmbedUrl(_vm.post.url)) ? _c('iframe', {
    staticClass: "linkedin-post-embed",
    attrs: {
      "src": _vm.getLinkedInEmbedUrl(_vm.post.url),
      "title": ("LinkedIn post by " + (_vm.post.name)),
      "width": "100%",
      "height": "560",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _c('v-alert', {
    attrs: {
      "width": "500"
    }
  }, [_vm._v("This LinkedIn post cannot be embedded.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "small": "",
      "color": "secondary",
      "href": _vm.post.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                          View on LinkedIn\n                          "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-linkedin")])], 1)], 1)], 1)], 1)], 1) : (_vm.type === 'twitter') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "mr-2",
    staticStyle: {
      "filter": "invert(1)"
    },
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "24px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twitter-report-title-text"
  }, [_vm._v("X (Twitter) Post · @" + _vm._s(_vm.post.name))])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "twitter-insights"
  }, [(_vm.twitterMetric(_vm.post, 'impressions') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Impressions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'impressions'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'replies') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Replies")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'replies'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'likes') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'likes'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'reposts') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Reposts")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'reposts'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitterMetric(_vm.post, 'bookmarks') > 0) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.twitterMetric(_vm.post, 'bookmarks'))))]), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-auto",
    attrs: {
      "color": "#ffffff",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7",
      "align": "center"
    }
  }, [(_vm.getTwitterEmbedUrl(_vm.post.url)) ? _c('div', {
    staticClass: "twitter-embed-viewport"
  }, [_c('iframe', {
    staticClass: "twitter-post-embed",
    attrs: {
      "src": _vm.getTwitterEmbedUrl(_vm.post.url),
      "title": ("X post by " + (_vm.post.name)),
      "width": "100%",
      "height": "560",
      "frameborder": "0",
      "scrolling": "auto"
    }
  })]) : _c('v-alert', {
    attrs: {
      "width": "500"
    }
  }, [_vm._v("This X post cannot be embedded.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "small": "",
      "color": "secondary",
      "href": _vm.post.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                          View on X\n                          "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)], 1)], 1)], 1) : (_vm.type === 'others') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "d-flex",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name) + " ")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.views !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Views")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.views)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.watches !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Watches")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.watches)) + "s")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.like_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Likes")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.like_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.comment_count !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Comments")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.comment_count)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.bookmarks !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Bookmarks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.bookmarks)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.plays !== 0 && _vm.post.plays !== '0h:0m:0s') ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Play Time")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.showTikTokPlayTime(_vm.post.plays))))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [(_vm.post.url) ? _c('div', {
    staticStyle: {
      "max-width": "350px"
    }
  }, [(_vm.post.media_type === 'video') ? _c('video', {
    attrs: {
      "width": "350",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.post.url,
      "type": "video/mp4"
    }
  }), _vm._v("\n                            Your browser does not support HTML5 video.\n                          ")]) : (_vm.post.media_type === 'image') ? _c('img', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "src": _vm.post.url
    }
  }) : _c('div', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_c('v-alert', {
    attrs: {
      "width": "350"
    }
  }, [_vm._v("\n                              Media type unsupported!\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "justify-content": "center",
      "margin-top": "10px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.embed_url)
      }
    }
  }, [_vm._v("\n                            Download\n                            "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.post.postLink)
      }
    }
  }, [_vm._v("\n                            View\n                            "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-outline")])], 1)], 1)])], 1)], 1)], 1) : (_vm.type === 'gdrive') ? _c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("  " + _vm._s(_vm.post.title) + " - @" + _vm._s(_vm.post.name))], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.post.outreach && _vm.post.outreach !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Audience Size")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.outreach)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.storyTotalInteractions && _vm.post.storyTotalInteractions !== 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1000"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Total Interactions")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.storyTotalInteractions)))]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.link_clicks && _vm.post.link_clicks !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Link Clicks")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.link_clicks)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.shares && _vm.post.shares !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Shares")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.shares)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.replies && _vm.post.replies !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Replies")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.replies)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.post.sticker_taps && _vm.post.sticker_taps !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "IG-reaction-title"
  }, [_vm._v("Sticker Taps")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "IG-reaction-value"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.post.sticker_taps)))])]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "color": "#E1306C",
      "width": "250px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "col": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "align": "center"
    }
  }, [_c('custom-media', {
    attrs: {
      "className": _vm.getMedia(_vm.post).className,
      "type": _vm.getMedia(_vm.post).type,
      "publicID": _vm.getMedia(_vm.post).publicID,
      "videoID": _vm.getMedia(_vm.post).videoID,
      "URL": _vm.getMedia(_vm.post).URL,
      "width": _vm.getMedia(_vm.post).width,
      "height": _vm.getMedia(_vm.post).height,
      "trans": _vm.getMedia(_vm.post).trans,
      "download": true
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "client-feedback-form-page",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.formLoading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "secondary"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formError) ? _c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _vm._v(" "), (_vm.complete) ? _c('v-alert', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("Thank you. Your feedback has been submitted.")]) : _vm._e(), _vm._v(" "), (_vm.feedbackReady && !_vm.complete) ? _c('v-form', {
    ref: "feedbackform",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "form-title"
  }, [_vm._v("Kobe Feedback Form")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.account_manager.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.amFullName))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.client_name.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.clientName))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.content_curator.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.coFullName))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Campaign Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.campaign_name))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold mb-0"
  }, [_vm._v("Your feedback helps decide what improvements should be made and what new features to work on in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("We would like to take this opportunity to find out your experience working with Kobe.")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("This form will take you 5 minutes to complete.")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("Thank you for your time.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-data-table', {
    staticClass: "rate-data-table elevation-0",
    attrs: {
      "headers": _vm.feedbackFormSections.good_ratings.headers,
      "items": _vm.feedbackFormSections.good_ratings.fields,
      "hide-default-footer": "",
      "disable-sort": "true"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item, index) {
          return _c('tr', {
            key: index,
            class: {
              'bg--white': !item.selected,
              'bg-soft-grey': item.selected
            }
          }, [_c('td', {
            staticClass: "d-block d-sm-table-cell text-xs-left"
          }, [_c('p', {
            staticClass: "mb-0 pt-xs-5 pb-2"
          }, [_vm._v(_vm._s(item.title) + " "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.required),
              expression: "item.required"
            }],
            staticClass: "red--text"
          }, [_vm._v("*")])]), _vm._v(" "), _c('v-fade-transition', [_c('v-alert', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.$v.feedback[item.name].$error),
              expression: "$v.feedback[item.name].$error"
            }],
            staticClass: "td-error rounded-0",
            attrs: {
              "dense": "",
              "color": "red"
            }
          }, [_vm._v("\n                            " + _vm._s(item.title) + " Required.\n                          ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.feedbackFormSections.good_ratings.values), function(v, vindex) {
            return _c('td', {
              key: vindex,
              staticClass: "d-block d-sm-table-cell"
            }, [_c('v-radio-group', {
              attrs: {
                "required": ""
              },
              on: {
                "change": _vm.changeSelected
              },
              model: {
                value: (_vm.feedback[item.name]),
                callback: function($$v) {
                  _vm.$set(_vm.feedback, item.name, $$v)
                },
                expression: "feedback[item.name]"
              }
            }, [_c('v-layout', {
              attrs: {
                "wrap": ""
              }
            }, [_c('v-flex', {
              attrs: {
                "xs1": "",
                "md12": ""
              }
            }, [_c('v-radio', {
              staticClass: "justify-center float-xs-left",
              attrs: {
                "value": v,
                "color": "secondary"
              }
            })], 1), _vm._v(" "), _c('v-flex', {
              attrs: {
                "xs11": "",
                "md6": ""
              }
            }, [_c('span', {
              staticClass: "d-md-none d-lg-none d-xl-none d-sm-none pl-2"
            }, [_vm._v(_vm._s(v))])])], 1)], 1)], 1)
          })], 2)
        }), 0)]
      }
    }], null, false, 1303790547)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-data-table', {
    staticClass: "rate-data-table elevation-0",
    attrs: {
      "items": _vm.feedbackFormSections.likely_recommend.fields,
      "hide-default-header": "",
      "hide-default-footer": "",
      "disable-sort": "true"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item, index) {
          return _c('tr', {
            key: index,
            class: {
              'bg--white': !item.selected,
              'bg-soft-grey': item.selected
            }
          }, [_c('td', {
            staticClass: "d-block d-sm-table-cell no-border text-xs-left"
          }, [_c('p', {
            staticClass: "mb-0 pt-5"
          }, [_vm._v(_vm._s(item.title) + " "), (item.required) ? _c('span', {
            staticClass: "red--text"
          }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('p', {
            staticClass: "caption mb-xs-0"
          }, [_vm._v(_vm._s(item.caption))]), _vm._v(" "), _c('v-fade-transition', [_c('v-alert', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.$v.feedback[item.name].$error),
              expression: "$v.feedback[item.name].$error"
            }],
            staticClass: "td-error rounded-0",
            attrs: {
              "dense": "",
              "color": "red"
            }
          }, [_vm._v("\n                              " + _vm._s(item.title) + " Required.\n                            ")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "d-block d-sm-table-cell no-border pa-5"
          }, [_c('v-rating', {
            staticClass: "rating-icon float-md-right",
            attrs: {
              "length": "10",
              "color": "secondary",
              "background-color": "grey lighten-1",
              "size": _vm.starSize,
              "dense": "",
              "hover": ""
            },
            scopedSlots: _vm._u([{
              key: "item",
              fn: function(props) {
                return [_c('v-icon', {
                  staticClass: "rating-icon",
                  attrs: {
                    "large": "",
                    "color": props.isFilled ? 'secondary' : ''
                  },
                  domProps: {
                    "textContent": _vm._s(("mdi-numeric-" + (props.index + 1) + "-box"))
                  },
                  on: {
                    "click": props.click
                  }
                })]
              }
            }], null, true),
            model: {
              value: (_vm.feedback[item.name]),
              callback: function($$v) {
                _vm.$set(_vm.feedback, item.name, $$v)
              },
              expression: "feedback[item.name]"
            }
          })], 1)])
        }), 0)]
      }
    }], null, false, 3945985623)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-data-table', {
    staticClass: "rate-data-table elevation-0",
    attrs: {
      "items": _vm.feedbackFormSections.likely_consider_again.fields,
      "hide-default-header": "",
      "hide-default-footer": "",
      "disable-sort": "true"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item, index) {
          return _c('tr', {
            key: index,
            class: {
              'bg--white': !item.selected,
              'bg-soft-grey': item.selected
            }
          }, [_c('td', {
            staticClass: "d-block d-sm-table-cell no-border text-xs-left"
          }, [_c('p', {
            staticClass: "mb-0 pt-xs-5"
          }, [_vm._v(_vm._s(item.title) + " "), (item.required) ? _c('span', {
            staticClass: "red--text"
          }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('p', {
            staticClass: "caption mb-xs-0"
          }, [_vm._v(_vm._s(item.caption))]), _vm._v(" "), _c('v-fade-transition', [_c('v-alert', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.$v.feedback[item.name].$error),
              expression: "$v.feedback[item.name].$error"
            }],
            staticClass: "td-error rounded-0",
            attrs: {
              "dense": "",
              "color": "red"
            }
          }, [_vm._v("\n                              " + _vm._s(item.title) + " Required.\n                            ")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "d-block d-sm-table-cell no-border pa-5"
          }, [_c('v-rating', {
            staticClass: "float-md-right",
            attrs: {
              "length": "10",
              "color": "secondary",
              "background-color": "grey lighten-1",
              "size": _vm.starSize,
              "dense": "",
              "hover": ""
            },
            scopedSlots: _vm._u([{
              key: "item",
              fn: function(props) {
                return [_c('v-icon', {
                  staticClass: "rating-icon",
                  attrs: {
                    "large": "",
                    "color": props.isFilled ? 'secondary' : ''
                  },
                  domProps: {
                    "textContent": _vm._s(("mdi-numeric-" + (props.index + 1) + "-box"))
                  },
                  on: {
                    "click": props.click
                  }
                })]
              }
            }], null, true),
            model: {
              value: (_vm.feedback[item.name]),
              callback: function($$v) {
                _vm.$set(_vm.feedback, item.name, $$v)
              },
              expression: "feedback[item.name]"
            }
          })], 1)])
        }), 0)]
      }
    }], null, false, 212861328)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('p', {
    staticClass: "h4 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.buyagain_decision.title) + " "), (_vm.feedbackFormSections.buyagain_decision.required) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l((_vm.feedbackFormSections.buyagain_decision.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [(b.type == 'checkbox') ? _c('v-checkbox', {
      staticClass: "mt-0",
      attrs: {
        "label": b.label,
        "value": b.value,
        "error": _vm.$v.feedback[_vm.feedbackFormSections.buyagain_decision.name].$error,
        "color": "secondary"
      },
      model: {
        value: (_vm.feedback[_vm.feedbackFormSections.buyagain_decision.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, _vm.feedbackFormSections.buyagain_decision.name, $$v)
        },
        expression: "feedback[feedbackFormSections.buyagain_decision.name]"
      }
    }) : _vm._e(), _vm._v(" "), (b.type == 'textfield') ? _c('v-text-field', {
      staticClass: "v-text-field-sm mt-0",
      attrs: {
        "label": b.label,
        "outlined": "",
        "dense": "",
        "error": _vm.$v.other_buyagain_decisions.$error,
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.$v.other_buyagain_decisions.$touch()
        }
      },
      model: {
        value: (_vm.other_buyagain_decisions),
        callback: function($$v) {
          _vm.other_buyagain_decisions = $$v
        },
        expression: "other_buyagain_decisions"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-fade-transition', [(_vm.$v.feedback[_vm.feedbackFormSections.buyagain_decision.name].$error || _vm.$v.other_buyagain_decisions.$error) ? _c('v-chip', {
    staticClass: "checkboxes-error rounded-0 float-md-left",
    attrs: {
      "color": "red",
      "text-color": "white",
      "small": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.feedbackFormSections.buyagain_decision.title) + " Required.\n                    ")]) : _vm._e()], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.what_did_well.title) + " "), (_vm.feedbackFormSections.what_did_well.required) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "error-messages": _vm.$v.feedback[_vm.feedbackFormSections.what_did_well.name].$error && _vm.feedbackFormSections[_vm.feedbackFormSections.what_did_well.name].title + ' is required.',
      "required": ""
    },
    on: {
      "input": function($event) {
        _vm.$v.feedback[_vm.feedbackFormSections.what_did_well.name].$touch()
      }
    },
    model: {
      value: (_vm.feedback[_vm.feedbackFormSections.what_did_well.name]),
      callback: function($$v) {
        _vm.$set(_vm.feedback, _vm.feedbackFormSections.what_did_well.name, $$v)
      },
      expression: "feedback[feedbackFormSections.what_did_well.name]"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.what_can_improve.title) + " "), (_vm.feedbackFormSections.what_can_improve.required) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "error-messages": _vm.$v.feedback[_vm.feedbackFormSections.what_can_improve.name].$error && _vm.feedbackFormSections.what_can_improve.title + ' is required.',
      "required": ""
    },
    on: {
      "input": function($event) {
        _vm.$v.feedback[_vm.feedbackFormSections.what_can_improve.name].$touch()
      }
    },
    model: {
      value: (_vm.feedback[_vm.feedbackFormSections.what_can_improve.name]),
      callback: function($$v) {
        _vm.$set(_vm.feedback, _vm.feedbackFormSections.what_can_improve.name, $$v)
      },
      expression: "feedback[feedbackFormSections.what_can_improve.name]"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('p', {
    staticClass: "h4 font-weight-bold mb-0"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.account_manager_status.rate_title))]), _vm._v(" "), _c('p', {
    staticClass: "h4 mb-5",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.account_manager_status.rate_desc))]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-weight-bold mb-3"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.account_manager_status.title) + " " + _vm._s(_vm.amFullName) + ", is")]), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5",
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.account_manager_status.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      staticClass: "mb-3",
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('p', {
      staticClass: "h4 font-weight-bold mb-1"
    }, [_vm._v(_vm._s(b.label))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (b.caption),
        expression: "b.caption"
      }],
      staticClass: "caption mb-2"
    }, [_vm._v(_vm._s(b.caption))]), _vm._v(" "), _c('v-rating', {
      staticClass: "float-md-left",
      attrs: {
        "length": "4",
        "color": "secondary",
        "background-color": "grey lighten-1",
        "size": _vm.starSize,
        "dense": "",
        "hover": ""
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function(props) {
          return [_c('v-icon', {
            staticClass: "rating-icon",
            attrs: {
              "large": "",
              "color": props.isFilled ? 'secondary' : ''
            },
            domProps: {
              "textContent": _vm._s(("mdi-numeric-" + (props.index + 1) + "-box"))
            },
            on: {
              "click": props.click
            }
          })]
        }
      }], null, true),
      model: {
        value: (_vm.feedback[b.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, b.name, $$v)
        },
        expression: "feedback[b.name]"
      }
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.inf_line_up.fields), function(lineup, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "mb-5",
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('div', [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(lineup.label) + " "), (lineup.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (lineup.caption),
        expression: "lineup.caption"
      }],
      staticClass: "caption mb-2"
    }, [_vm._v(_vm._s(lineup.caption))]), _vm._v(" "), (lineup.type === 'radio') ? _c('div', [_c('v-radio-group', {
      attrs: {
        "required": "",
        "column": ""
      },
      model: {
        value: (_vm.feedback[lineup.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, lineup.name, $$v)
        },
        expression: "feedback[lineup.name]"
      }
    }, _vm._l((_vm.feedbackFormSections.inf_line_up.values), function(v, vindex) {
      return _c('v-radio', {
        key: vindex,
        staticClass: "justify-center",
        attrs: {
          "value": v,
          "label": v,
          "color": "secondary"
        }
      })
    }), 1), _vm._v(" "), _c('v-fade-transition', [_c('v-chip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.feedback[lineup.name].$error),
        expression: "$v.feedback[lineup.name].$error"
      }],
      staticClass: "rounded-0",
      staticStyle: {
        "margin-top": "-30px"
      },
      attrs: {
        "color": "red",
        "text-color": "white",
        "small": ""
      }
    }, [_vm._v("\n                        " + _vm._s(lineup.label) + " Required.\n                        ")])], 1)], 1) : _vm._e()])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.inf_content_created.fields), function(contentCreated, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "mb-5",
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('div', [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(contentCreated.label) + " "), (contentCreated.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (contentCreated.caption),
        expression: "contentCreated.caption"
      }],
      staticClass: "caption mb-2"
    }, [_vm._v(_vm._s(contentCreated.caption))]), _vm._v(" "), (contentCreated.type === 'radio') ? _c('div', [_c('v-radio-group', {
      attrs: {
        "required": "",
        "column": ""
      },
      model: {
        value: (_vm.feedback[contentCreated.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, contentCreated.name, $$v)
        },
        expression: "feedback[contentCreated.name]"
      }
    }, _vm._l((_vm.feedbackFormSections.inf_content_created.values), function(v, vindex) {
      return _c('v-radio', {
        key: vindex,
        staticClass: "justify-center",
        attrs: {
          "value": v,
          "label": v,
          "color": "secondary"
        }
      })
    }), 1), _vm._v(" "), _c('v-fade-transition', [_c('v-chip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.feedback[contentCreated.name].$error),
        expression: "$v.feedback[contentCreated.name].$error"
      }],
      staticClass: "rounded-0",
      staticStyle: {
        "margin-top": "-30px"
      },
      attrs: {
        "color": "red",
        "text-color": "white",
        "small": ""
      }
    }, [_vm._v("\n                        " + _vm._s(contentCreated.label) + " Required.\n                        ")])], 1)], 1) : _vm._e()])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('p', {
    staticClass: "h4 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.sea_countries.title) + " "), (_vm.feedbackFormSections.sea_countries.required) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l((_vm.feedbackFormSections.sea_countries.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [(b.type == 'checkbox') ? _c('v-checkbox', {
      staticClass: "mt-0",
      attrs: {
        "label": b.label,
        "value": b.value,
        "error": _vm.$v.feedback[_vm.feedbackFormSections.sea_countries.name].$error,
        "color": "secondary"
      },
      model: {
        value: (_vm.feedback[_vm.feedbackFormSections.sea_countries.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, _vm.feedbackFormSections.sea_countries.name, $$v)
        },
        expression: "feedback[feedbackFormSections.sea_countries.name]"
      }
    }) : _vm._e(), _vm._v(" "), (b.type == 'textfield') ? _c('v-text-field', {
      staticClass: "v-text-field-sm mt-0",
      attrs: {
        "label": b.label,
        "outlined": "",
        "dense": "",
        "error": _vm.$v.other_sea_countries.$error,
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.$v.other_sea_countries.$touch()
        }
      },
      model: {
        value: (_vm.other_sea_countries),
        callback: function($$v) {
          _vm.other_sea_countries = $$v
        },
        expression: "other_sea_countries"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-fade-transition', [(_vm.$v.feedback[_vm.feedbackFormSections.sea_countries.name].$error || _vm.$v.other_sea_countries.$error) ? _c('v-chip', {
    staticClass: "checkboxes-error rounded-0 float-md-left",
    attrs: {
      "color": "red",
      "text-color": "white",
      "small": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.feedbackFormSections.sea_countries.title) + " Required.\n                    ")]) : _vm._e()], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('p', {
    staticClass: "h4 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.platforms.title) + " "), (_vm.feedbackFormSections.platforms.required) ? _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l((_vm.feedbackFormSections.platforms.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [(b.type == 'checkbox') ? _c('v-checkbox', {
      staticClass: "mt-0",
      attrs: {
        "label": b.label,
        "value": b.value,
        "error": _vm.$v.feedback[_vm.feedbackFormSections.platforms.name].$error,
        "color": "secondary"
      },
      model: {
        value: (_vm.feedback[_vm.feedbackFormSections.platforms.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, _vm.feedbackFormSections.platforms.name, $$v)
        },
        expression: "feedback[feedbackFormSections.platforms.name]"
      }
    }) : _vm._e(), _vm._v(" "), (b.type == 'textfield') ? _c('v-text-field', {
      staticClass: "v-text-field-sm mt-0",
      attrs: {
        "label": b.label,
        "outlined": "",
        "dense": "",
        "error": _vm.$v.other_platforms.$error,
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.$v.other_platforms.$touch()
        }
      },
      model: {
        value: (_vm.other_platforms),
        callback: function($$v) {
          _vm.other_platforms = $$v
        },
        expression: "other_platforms"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-fade-transition', [(_vm.$v.feedback[_vm.feedbackFormSections.platforms.name].$error || _vm.$v.other_platforms.$error) ? _c('v-chip', {
    staticClass: "checkboxes-error rounded-0 float-md-left",
    attrs: {
      "color": "red",
      "text-color": "white",
      "small": ""
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.feedbackFormSections.platforms.title) + " Required.\n                    ")]) : _vm._e()], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l((_vm.feedbackFormSections.kobe_questions.fields), function(kobe, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "mb-3",
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [(kobe.name !== 'open_sharing_feedback') ? _c('div', [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(kobe.label) + " "), (kobe.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (kobe.type === 'radio') ? _c('div', [_c('v-radio-group', {
      attrs: {
        "required": "",
        "row": ""
      },
      model: {
        value: (_vm.feedback[kobe.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, kobe.name, $$v)
        },
        expression: "feedback[kobe.name]"
      }
    }, _vm._l((_vm.feedbackFormSections.kobe_questions.values), function(v, vindex) {
      return _c('v-radio', {
        key: vindex,
        staticClass: "justify-center",
        attrs: {
          "value": v,
          "label": v,
          "color": "secondary"
        }
      })
    }), 1), _vm._v(" "), _c('v-fade-transition', [_c('v-chip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$v.feedback[kobe.name].$error),
        expression: "$v.feedback[kobe.name].$error"
      }],
      staticClass: "rounded-0",
      staticStyle: {
        "margin-top": "-30px"
      },
      attrs: {
        "color": "red",
        "text-color": "white",
        "small": ""
      }
    }, [_vm._v("\n                        " + _vm._s(kobe.label) + " Required.\n                        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (kobe.type === 'textarea') ? _c('div', {
      staticClass: "mt-3"
    }, [_c('v-textarea', {
      attrs: {
        "outlined": "",
        "error-messages": _vm.$v.feedback[kobe.name].$error && kobe.label + ' Required.',
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.feedback[kobe.name].$touch()
        }
      },
      model: {
        value: (_vm.feedback[kobe.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, kobe.name, $$v)
        },
        expression: "feedback[kobe.name]"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (kobe.caption),
        expression: "kobe.caption"
      }],
      staticClass: "caption"
    }, [_vm._v(_vm._s(kobe.caption))])]) : _vm._e()])
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-row', [_c('v-col', [_c('p', {
    staticClass: "h4 font-weight-bold mb-3"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.refer_info.title) + " "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.refer_info.fields), function(contact, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', [_c('v-text-field', {
      class: contact.class ? contact.class + ' mt-0' : 'mt-0',
      attrs: {
        "label": contact.label,
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.feedback[contact.name].$error && ((contact.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.feedback[contact.name].$touch()
        }
      },
      model: {
        value: (_vm.feedback[contact.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, contact.name, $$v)
        },
        expression: "feedback[contact.name]"
      }
    })], 1)])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', [_c('v-checkbox', {
    staticClass: "schedule-sharing-chk mt-0",
    attrs: {
      "label": "I would like for Kobe to schedule an internal sharing for the rest of my business teams",
      "value": false,
      "color": "secondary"
    },
    model: {
      value: (_vm.feedback.scheduleSharing),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "scheduleSharing", $$v)
      },
      expression: "feedback.scheduleSharing"
    }
  })], 1)])], 2)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.contact_info.fields), function(contact, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', [_c('p', {
      staticClass: "h4 font-weight-bold mb-2"
    }, [_vm._v(_vm._s(contact.label) + " "), (contact.required) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-text-field', {
      class: contact.class ? contact.class + ' mt-0' : 'mt-0',
      attrs: {
        "outlined": "",
        "dense": "",
        "error-messages": _vm.$v.feedback[contact.name].$error && ((contact.label) + " is required."),
        "required": ""
      },
      on: {
        "input": function($event) {
          _vm.$v.feedback[contact.name].$touch()
        }
      },
      model: {
        value: (_vm.feedback[contact.name]),
        callback: function($$v) {
          _vm.$set(_vm.feedback, contact.name, $$v)
        },
        expression: "feedback[contact.name]"
      }
    })], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitFeedback.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                Submit\n              ")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-row', {
    staticClass: "submit-post-payout pa-3"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "card-box"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.isCurrentUser && !_vm.isNotInfluencer) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.isCampaign) ? _c('v-text-field', {
    attrs: {
      "label": "Campaign Name",
      "filled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.campaignPayout.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "campaignName", $$v)
      },
      expression: "campaignPayout.campaignName"
    }
  }) : _c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaigns,
      "label": "Select Campaign",
      "item-value": "id",
      "item-text": "name"
    },
    on: {
      "change": _vm.changeCampaign
    },
    model: {
      value: (_vm.campaignPayout.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "campaignID", $$v)
      },
      expression: "campaignPayout.campaignID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isCurrentUser || _vm.isNotInfluencer) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Campaign Name")]), _vm._v(": \n                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.campaignPayout.campaignName))])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "h4 font-weight-bold mb-2"
  }, [_vm._v("Creator Handle")]), _vm._v(": \n                "), _c('span', {
    staticClass: "h5 font-weight-bold mb-2",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.campaignPayout.fullName) + " (" + _vm._s(_vm.campaignPayout.handle) + ")")])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.isStoryTell && _vm.deliverables) ? _c('div', {
    staticClass: "deliverables"
  }, [_vm._v("\n                Your deliverables for this campaign:\n                "), _c('post-deliverables', {
    attrs: {
      "deliverables": _vm.deliverables
    }
  })], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), (_vm.campaignPayout.campaignID) ? _c('div', {
    staticClass: "card-box"
  }, [_c('v-stepper', {
    model: {
      value: (_vm.mainStep),
      callback: function($$v) {
        _vm.mainStep = $$v
      },
      expression: "mainStep"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.mainStep > 1
    }
  }, [_vm._v("Stats submission & Ratings")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.mainStep > 2
    }
  }, [_vm._v("Feedback Questions")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Others")])], 1), _vm._v(" "), _c('v-stepper-items', {
    staticClass: "stepper-items"
  }, [_c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 1
    }
  }, [(_vm.firstSteppers.length) ? _c('v-stepper', {
    staticClass: "card-box",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.firstActiveStep),
      callback: function($$v) {
        _vm.firstActiveStep = $$v
      },
      expression: "firstActiveStep"
    }
  }, _vm._l((_vm.firstSteppers), function(step, stepIndex) {
    return _c('div', {
      key: stepIndex
    }, [_c('span', {
      staticClass: "d-none"
    }, [_vm._v(_vm._s(stepIndex))]), _vm._v(" "), (step.type === 'storyCoverage') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    Upload your coverage and statistics for IG Story(ies)\n                    "), _c('v-btn', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "text": "",
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.showPayoutSampleDialog('igStory')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "center": "",
        "small": ""
      }
    }, [_vm._v("mdi-newspaper")]), _vm._v(" View stats required here\n                    ")], 1)], 1) : _vm._e(), _vm._v(" "), (step.type === 'storyCoverage') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_vm._l((_vm.campaignPayout.stories), function(story, index) {
      return _c('v-card', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "flat": ""
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "label",
          "hint": "label IGS 1, IGS 2 etc for multiple stories",
          "persistent-hint": "",
          "outlined": "",
          "dense": ""
        },
        scopedSlots: _vm._u([{
          key: "append-outer",
          fn: function() {
            return [_c('v-btn', {
              staticStyle: {
                "margin-top": "-6px"
              },
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deletePostGroup(_vm.campaignPayout.stories, index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)]
          },
          proxy: true
        }], null, true),
        model: {
          value: (story.label),
          callback: function($$v) {
            _vm.$set(story, "label", $$v)
          },
          expression: "story.label"
        }
      }), _vm._v(" "), _c('v-row', {
        staticClass: "mb-5"
      }, [_vm._l((story.showImages), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          staticClass: "d-flex child-flex img-box",
          attrs: {
            "cols": "4"
          }
        }, [_c('v-hover', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var hover = ref.hover;

              return [_c('v-card', {
                staticClass: "d-flex",
                attrs: {
                  "flat": "",
                  "tile": "",
                  "elevation": hover ? 16 : 2
                }
              }, [_c('v-img', {
                staticClass: "grey lighten-2",
                attrs: {
                  "src": img.thumbnail,
                  "lazy-src": img.thumbnail,
                  "aspect-ratio": "1"
                }
              }), _vm._v(" "), _c('v-overlay', {
                attrs: {
                  "absolute": ""
                }
              }, [_c('v-btn', {
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteCustomImage(story, imgIndex)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)], 1)], 1)]
            }
          }], null, true)
        })], 1)
      }), _vm._v(" "), _c('v-col', {
        staticClass: "d-flex child-flex img-box",
        attrs: {
          "cols": "4"
        }
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 1
        }
      }, [_c('v-card', {
        staticClass: "d-flex",
        staticStyle: {
          "height": "100%"
        },
        attrs: {
          "outlined": "",
          "flat": "",
          "tile": ""
        },
        on: {
          "click": function($event) {
            return _vm.showFileUploader('storyUpload' + index)
          }
        }
      }, [_c('v-btn', {
        staticClass: "ma-auto",
        attrs: {
          "dark": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
        ref: 'storyUpload' + index,
        refInFor: true,
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "name": "images",
          "id": 'storyUpload' + index,
          "accept": "image/*, video/*"
        },
        on: {
          "change": function($event) {
            return _vm.prepareCustomUpload($event, story)
          }
        }
      })], 1)], 1)], 1)], 2)], 1)
    }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.addMore('stories')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Add More")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      }
    }, [_vm._v("Continue")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (step.type === 'postURL') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    Enter the URL to your in-feed content here\n                    ")]) : _vm._e(), _vm._v(" "), (step.type === 'postURL') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_vm._l((_vm.campaignPayout.posts), function(post, index) {
      return _c('v-card', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "flat": ""
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Post URL",
          "outlined": "",
          "dense": ""
        },
        scopedSlots: _vm._u([{
          key: "append-outer",
          fn: function() {
            return [_c('v-btn', {
              staticStyle: {
                "margin-top": "-6px"
              },
              attrs: {
                "dark": "",
                "icon": ""
              },
              on: {
                "click": function($event) {
                  return _vm.deletePostGroup(_vm.campaignPayout.posts, index)
                }
              }
            }, [_c('v-icon', {
              attrs: {
                "dark": "",
                "color": "red"
              }
            }, [_vm._v("cancel")])], 1)]
          },
          proxy: true
        }], null, true),
        model: {
          value: (post.instagramPostURL),
          callback: function($$v) {
            _vm.$set(post, "instagramPostURL", $$v)
          },
          expression: "post.instagramPostURL"
        }
      }), _vm._v(" "), _c('v-row', {
        staticClass: "mb-2"
      }, [_vm._l((post.showImages), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          staticClass: "d-flex child-flex img-box",
          attrs: {
            "cols": "4"
          }
        }, [_c('v-hover', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var hover = ref.hover;

              return [_c('v-card', {
                staticClass: "d-flex",
                attrs: {
                  "flat": "",
                  "tile": "",
                  "elevation": hover ? 16 : 2
                }
              }, [_c('v-img', {
                staticClass: "grey lighten-2",
                attrs: {
                  "src": img.thumbnail,
                  "lazy-src": img.thumbnail,
                  "aspect-ratio": "1"
                }
              }), _vm._v(" "), _c('v-overlay', {
                attrs: {
                  "absolute": ""
                }
              }, [_c('v-btn', {
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deleteCustomImage(post, imgIndex)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)], 1)], 1)]
            }
          }], null, true)
        })], 1)
      }), _vm._v(" "), _c('v-col', {
        staticClass: "d-flex child-flex img-box",
        attrs: {
          "cols": "4"
        }
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 1
        }
      }, [_c('v-card', {
        staticClass: "d-flex",
        staticStyle: {
          "height": "100%"
        },
        attrs: {
          "outlined": "",
          "flat": "",
          "tile": ""
        },
        on: {
          "click": function($event) {
            return _vm.showFileUploader('mediaUpload' + index)
          }
        }
      }, [_c('v-btn', {
        staticClass: "ma-auto",
        attrs: {
          "dark": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "dark": "",
          "color": "primary"
        }
      }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
        ref: 'mediaUpload' + index,
        refInFor: true,
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "name": "images",
          "id": 'mediaUpload' + index,
          "accept": "image/*, video/*"
        },
        on: {
          "change": function($event) {
            return _vm.prepareCustomUpload($event, post)
          }
        }
      })], 1)], 1)], 1)], 2)], 1)
    }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.addMore('posts')
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Add More")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      }
    }, [_vm._v("Continue")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (step.type === 'deliverable') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDeliverablePost(step.fields.name).title) + "\n                    "), (_vm.getDeliverablePost(step.fields.name).sampleType !== 'custom' && _vm.getDeliverablePost(step.fields.name).sampleType !== 'youtube') ? _c('v-btn', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "text": "",
        "small": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          _vm.showPayoutSampleDialog(_vm.getDeliverablePost(step.fields.name).sampleType)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "center": "",
        "small": ""
      }
    }, [_vm._v("mdi-newspaper")]), _vm._v(" View stats required here\n                    ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (step.type === 'deliverable') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, _vm._l((_vm.campaignPayout.deliverablePosts), function(allPost, contentIndex) {
      return _c('div', {
        key: contentIndex
      }, [(allPost.type === step.fields.name) ? _c('div', [_vm._l((_vm.campaignPayout.deliverablePosts[contentIndex].posts), function(post, index) {
        return _c('v-card', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "flat": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": _vm.getLabel(step.fields.name),
            "hide-details": "",
            "outlined": "",
            "dense": ""
          },
          scopedSlots: _vm._u([{
            key: "append-outer",
            fn: function() {
              return [_c('v-btn', {
                staticStyle: {
                  "margin-top": "-6px"
                },
                attrs: {
                  "dark": "",
                  "icon": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.deletePostGroup(_vm.campaignPayout.deliverablePosts[contentIndex].posts, index)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "color": "red"
                }
              }, [_vm._v("cancel")])], 1)]
            },
            proxy: true
          }], null, true),
          model: {
            value: (post.label),
            callback: function($$v) {
              _vm.$set(post, "label", $$v)
            },
            expression: "post.label"
          }
        }), _vm._v(" "), (!_vm.campaignPayout.deliverablePosts[contentIndex].posts[index].label) ? _c('p', {
          staticClass: "text-danger"
        }, [_vm._v("This field is required")]) : _vm._e(), _vm._v(" "), _c('v-row', {
          staticClass: "mb-5 mt-2"
        }, [_vm._l((post.showImages), function(img, imgIndex) {
          return _c('v-col', {
            key: imgIndex,
            staticClass: "d-flex child-flex img-box",
            attrs: {
              "cols": "4"
            }
          }, [_c('v-hover', {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(ref) {
                var hover = ref.hover;

                return [_c('v-card', {
                  staticClass: "d-flex",
                  attrs: {
                    "flat": "",
                    "tile": "",
                    "elevation": hover ? 16 : 2
                  }
                }, [(_vm.isVideo(img.thumbnail)) ? _c('video', {
                  attrs: {
                    "src": img.thumbnail,
                    "controls": ""
                  }
                }, [_vm._v("             \n                                      Your browser does not support the video tag.\n                                  ")]) : _vm._e(), _vm._v(" "), _c('v-img', {
                  staticClass: "grey lighten-2",
                  attrs: {
                    "src": img.thumbnail,
                    "lazy-src": img.thumbnail,
                    "aspect-ratio": "1"
                  }
                }), _vm._v(" "), _c('v-overlay', {
                  attrs: {
                    "absolute": ""
                  }
                }, [_c('v-btn', {
                  attrs: {
                    "dark": "",
                    "icon": ""
                  },
                  on: {
                    "click": function($event) {
                      return _vm.deleteCustomImage(post, imgIndex)
                    }
                  }
                }, [_c('v-icon', {
                  attrs: {
                    "dark": "",
                    "color": "red"
                  }
                }, [_vm._v("cancel")])], 1)], 1)], 1)]
              }
            }], null, true)
          })], 1)
        }), _vm._v(" "), _c('v-col', {
          staticClass: "d-flex child-flex img-box",
          attrs: {
            "cols": "4"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1
          }
        }, [_c('v-card', {
          staticClass: "d-flex",
          staticStyle: {
            "height": "100%"
          },
          attrs: {
            "outlined": "",
            "flat": "",
            "tile": ""
          },
          on: {
            "click": function($event) {
              return _vm.showFileUploader('deliverableUpload' + contentIndex + index)
            }
          }
        }, [_c('v-btn', {
          staticClass: "ma-auto",
          attrs: {
            "dark": "",
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "color": "primary"
          }
        }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
          ref: 'deliverableUpload' + contentIndex + index,
          refInFor: true,
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "name": "images",
            "id": 'deliverableUpload' + contentIndex + index,
            "accept": "image/*, video/*"
          },
          on: {
            "change": function($event) {
              return _vm.prepareCustomUpload($event, post)
            }
          }
        })], 1)], 1)], 1)], 2), _vm._v(" "), (!post.showImages.length) ? _c('p', {
          staticClass: "text-danger mb-5",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("This field is required")]) : _vm._e()], 1)
      }), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
        attrs: {
          "color": "secondary",
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addMore('deliverables', contentIndex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Add More")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
        attrs: {
          "color": "secondary"
        },
        on: {
          "click": function($event) {
            _vm.firstActiveStep = stepIndex + 2
          }
        }
      }, [_vm._v("Continue")])], 1)], 1)], 2) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (step.type === 'advertiserSatisfactionLevel') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    How would you rate your overall experience with the client?\n                  ")]) : _vm._e(), _vm._v(" "), (step.type === 'advertiserSatisfactionLevel') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_c('v-rating', {
      staticClass: "mb-5",
      attrs: {
        "size": "30",
        "dense": "",
        "color": "secondary"
      },
      on: {
        "input": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      },
      model: {
        value: (_vm.campaignPayout.advertiserSatisfactionLevel),
        callback: function($$v) {
          _vm.$set(_vm.campaignPayout, "advertiserSatisfactionLevel", $$v)
        },
        expression: "campaignPayout.advertiserSatisfactionLevel"
      }
    })], 1) : _vm._e(), _vm._v(" "), (step.type === 'kobeSatisfactionLevel') ? _c('v-stepper-step', {
      attrs: {
        "editable": "",
        "complete": _vm.firstActiveStep > (stepIndex + 1),
        "step": stepIndex + 1
      }
    }, [_vm._v("\n                    How would you rate your overall experience with Kobe?\n                  ")]) : _vm._e(), _vm._v(" "), (step.type === 'kobeSatisfactionLevel') ? _c('v-stepper-content', {
      attrs: {
        "step": stepIndex + 1
      }
    }, [_c('v-rating', {
      staticClass: "mb-5",
      attrs: {
        "size": "30",
        "dense": "",
        "color": "secondary"
      },
      on: {
        "input": function($event) {
          _vm.firstActiveStep = stepIndex + 2
        }
      },
      model: {
        value: (_vm.campaignPayout.kobeSatisfactionLevel),
        callback: function($$v) {
          _vm.$set(_vm.campaignPayout, "kobeSatisfactionLevel", $$v)
        },
        expression: "campaignPayout.kobeSatisfactionLevel"
      }
    })], 1) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right pa-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.proceedStepTwo
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 2
    }
  }, [_c('p', {
    staticClass: "body-2 pa-3 pt-5 pb-0"
  }, [_vm._v("The questions below will allow us to share on behalf your experience and feedback, during the review meeting with the clients:")]), _vm._v(" "), _c('v-stepper', {
    staticClass: "card-box",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.secondActiveStep),
      callback: function($$v) {
        _vm.secondActiveStep = $$v
      },
      expression: "secondActiveStep"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "editable": "",
      "complete": _vm.secondActiveStep > 1,
      "step": "1"
    }
  }, [_vm._v("\n                  What do you like most about this product/service you are promoting? "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.promotingProducts),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "promotingProducts", $$v)
      },
      expression: "campaignPayout.promotingProducts"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary",
      "disabled": !_vm.campaignPayout.promotingProducts
    },
    on: {
      "click": function($event) {
        _vm.secondActiveStep = 2
      }
    }
  }, [_vm._v("Continue")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "complete": _vm.secondActiveStep > 2,
      "step": "2"
    }
  }, [_vm._v("\n                  What are areas of improvement about this product/service that will be valuable feedback for them? "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.improved),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "improved", $$v)
      },
      expression: "campaignPayout.improved"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary",
      "disabled": !_vm.campaignPayout.improved
    },
    on: {
      "click": function($event) {
        _vm.secondActiveStep = 3
      }
    }
  }, [_vm._v("Continue")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "3"
    }
  }, [_vm._v("\n                  What do you think your audience enjoyed about your content? "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.audienceEnjoyment),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "audienceEnjoyment", $$v)
      },
      expression: "campaignPayout.audienceEnjoyment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right pa-3"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.mainStep = 1
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n                    Back\n                ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.disableStepTwo
    },
    on: {
      "click": function($event) {
        _vm.mainStep = 3
      }
    }
  }, [_vm._v("Next")])], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 3
    }
  }, [_c('v-stepper', {
    staticClass: "card-box",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.thirdActiveStep),
      callback: function($$v) {
        _vm.thirdActiveStep = $$v
      },
      expression: "thirdActiveStep"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "editable": "",
      "complete": _vm.thirdActiveStep > 1,
      "step": "1"
    }
  }, [_vm._v("\n                  What other campaigns would you want to work more on with us?\n                ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    staticClass: "body-2 mt-2 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "",
      "outlined": ""
    },
    model: {
      value: (_vm.campaignPayout.otherCampaigns),
      callback: function($$v) {
        _vm.$set(_vm.campaignPayout, "otherCampaigns", $$v)
      },
      expression: "campaignPayout.otherCampaigns"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.thirdActiveStep = 2
      }
    }
  }, [_vm._v("Continue")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "editable": "",
      "step": "2"
    }
  }, [_vm._v("\n                  Upload Invoice for agencies (optional)\n                ")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    staticClass: "body-2 mt-2 pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh,
      "multiple": true
    },
    on: {
      "setMedias": _vm.updateMedias
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right pa-3"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.mainStep = 2
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n                    Back\n                ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.createCampaignPayout
    }
  }, [_vm._v("Submit Payout")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('payout-sample-modal', {
    attrs: {
      "type": _vm.sampleType
    },
    model: {
      value: (_vm.payoutSampleDialog),
      callback: function($$v) {
        _vm.payoutSampleDialog = $$v
      },
      expression: "payoutSampleDialog"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content container"
  }, [_vm._m(0), _vm._v(" "), (_vm.campaignId !== null) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.pairingBriefModelSections), function(section) {
    return _c('div', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('h3', [_vm._v(_vm._s(section.title))]), _vm._v(" "), _vm._l((section.content), function(campaignField, index) {
      return _c('element', {
        key: index
      }, [(campaignField.type === 'text') ? _c('div', {
        staticClass: "form-group col-xs-12 col-sm-6",
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campaign[campaignField.name]),
          expression: "campaign[campaignField.name]"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": campaignField.placeholder
        },
        domProps: {
          "value": (_vm.campaign[campaignField.name])
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.campaign, campaignField.name, $event.target.value)
          }, function($event) {
            _vm.$v.campaign[campaignField.name].$touch()
          }]
        }
      }), _vm._v(" "), _vm._l((campaignField.validations), function(validation, index) {
        return _c('span', {
          key: index,
          staticClass: "help-block"
        }, [(_vm.$v.campaign[campaignField.name] && !_vm.$v.campaign[campaignField.name][validation.name] && _vm.$v.campaign[campaignField.name].$error) ? _c('span', [_vm._v("\n                      " + _vm._s(validation.message) + "\n                    ")]) : _vm._e()])
      })], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
        staticClass: "form-group col-xs-12 col-sm-6",
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campaign[campaignField.name]),
          expression: "campaign[campaignField.name]"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "row": "5",
          "placeholder": campaignField.placeholder
        },
        domProps: {
          "value": (_vm.campaign[campaignField.name])
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.campaign, campaignField.name, $event.target.value)
          }, function($event) {
            _vm.$v.campaign[campaignField.name].$touch()
          }]
        }
      }), _vm._v(" "), _vm._l((campaignField.validations), function(validation, index) {
        return _c('span', {
          key: index,
          staticClass: "help-block"
        }, [(_vm.$v.campaign[campaignField.name] && !_vm.$v.campaign[campaignField.name][validation.name] && _vm.$v.campaign[campaignField.name].$error) ? _c('span', [_vm._v("\n                      " + _vm._s(validation.message) + "\n                    ")]) : _vm._e()])
      })], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', {
        staticClass: "form-group col-xs-12 col-sm-6"
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.campaign[campaignField.name]),
          expression: "campaign[campaignField.name]"
        }],
        staticClass: "form-control",
        attrs: {
          "name": campaignField.name
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.campaign, campaignField.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((campaignField.value), function(option, index) {
        return _c('option', {
          key: index,
          domProps: {
            "value": option.value,
            "selected": {
              selected: option.selected
            }
          }
        }, [_vm._v("\n                      " + _vm._s(option.text) + "\n                    ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('element', [_c('div', {
        staticClass: "form-group col-xs-12"
      }, [_vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex,
          staticClass: "form-group col-xs-12"
        }, [_c('div', {
          staticClass: "form-group col-xs-12"
        }, [_c('h4', [_vm._v(_vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1))]), _vm._v(" "), (_vm.campaign[campaignField.name].length > 1) ? _c('b-button', {
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteOption(campaignField.name, optionIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash ims-text-error"
        })]) : _vm._e()], 1), _vm._v(" "), _vm._l((campaignField.template), function(optionField, index) {
          return _c('element', {
            key: index
          }, [(optionField.type == 'text') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text",
              "placeholder": optionField.placeholder
            },
            domProps: {
              "value": (_vm.campaign[campaignField.name][optionIndex][optionField.name])
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $event.target.value)
              }
            }
          })]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('textarea', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text",
              "placeholder": optionField.placeholder
            },
            domProps: {
              "value": (_vm.campaign[campaignField.name][optionIndex][optionField.name])
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $event.target.value)
              }
            }
          })]) : _vm._e(), _vm._v(" "), (optionField.type == 'upload') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-12"
          }, _vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(image, i) {
            return _c('div', {
              key: image
            }, [(image != '') ? _c('div', [_c('a', {
              staticClass: "campaign-image",
              attrs: {
                "href": _vm.constructImageURL(image),
                "target": "_blank"
              }
            }, [_c('img', {
              staticStyle: {
                "width": "100%"
              },
              attrs: {
                "src": _vm.constructImageURL(image)
              }
            })]), _vm._v(" "), _c('button', {
              staticClass: "btn btn-link btn-link-danger",
              attrs: {
                "type": "button"
              },
              on: {
                "click": function($event) {
                  $event.preventDefault();
                  return _vm.removeImage(optionIndex, i)
                }
              }
            }, [_vm._v("Remove")])]) : _vm._e()])
          }), 0), _vm._v(" "), _c('div', {
            staticClass: "col-xs-12"
          }, [_c('div', {
            staticClass: "image-input-container-edit",
            attrs: {
              "data-index": optionIndex
            }
          }, [_c('div', {
            staticClass: "image-input-edit"
          }, [_c('input', {
            ref: "files",
            refInFor: true,
            attrs: {
              "type": "file"
            }
          }), _vm._v(" "), _c('button', {
            staticClass: "btn btn-link btn-link-danger btn-remove-input-edit",
            attrs: {
              "type": "button"
            }
          }, [_vm._v("Remove")])])]), _vm._v(" "), _c('button', {
            staticClass: "btn btn-default btn-sm btn-add-more-image-edit",
            attrs: {
              "type": "button"
            }
          }, [_vm._v("+ Add more image")])])]) : _vm._e(), _vm._v(" "), (optionField.type === 'select') ? _c('div', {
            staticClass: "form-group col-xs-12 col-sm-6"
          }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('select', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }],
            staticClass: "form-control",
            attrs: {
              "name": optionField.name
            },
            on: {
              "change": function($event) {
                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                  return o.selected
                }).map(function(o) {
                  var val = "_value" in o ? o._value : o.value;
                  return val
                });
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }
            }
          }, _vm._l((optionField.value), function(option, index) {
            return _c('option', {
              key: index,
              domProps: {
                "value": option.value,
                "selected": {
                  selected: option.selected
                }
              }
            }, [_vm._v("\n                            " + _vm._s(option.text) + "\n                          ")])
          }), 0)]) : _vm._e()])
        })], 2)
      }), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-12"
      }, [_c('button', {
        staticClass: "btn btn-primary",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.addOption(campaignField.name)
          }
        }
      }, [_vm._v("\n                        Add new option\n                      ")])])], 2)]) : _vm._e()])
    })], 2)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default secondary--text",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Close\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary primary--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCampaign
    }
  }, [_vm._v("\n          Save changes\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Edit Pairing Brief\n        ")])])
}]}

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Assign Campaign to the Post\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignList,
      "label": "Choose Campaigns in IMS:",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaignID),
      callback: function($$v) {
        _vm.selectedCampaignID = $$v
      },
      expression: "selectedCampaignID"
    }
  }), _vm._v(" "), (_vm.postData.length) ? _c('table', {
    staticClass: "post-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Influencer")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Campaign")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.postData), function(item, index) {
    return _c('tr', {
      key: item._id || index
    }, [_c('td', {
      staticClass: "text-xs-justify pa-1"
    }, [(item.author && item.author.tiktokHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author && item.author.youtubeHandle) ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + item.author.youtubeHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author && item.author.instagramHandle) ? _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + item.author.instagramHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(item.campaignName || '-'))])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.assignCampaign()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "720px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-document-multiple")]), _vm._v("Payment Invoices\n      ")], 1)]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v(_vm._s(_vm.recordTitle))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('input', {
    ref: "invoiceInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*,.pdf,.ppt,.pptx,.txt,.doc,.docx,.xls,.xlsx"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$refs.invoiceInput.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-cloud-upload")]), _vm._v("Select Invoices\n          ")], 1), _vm._v(" "), (_vm.files.length) ? _c('span', {
    staticClass: "ml-2 caption"
  }, [_vm._v(_vm._s(_vm.files.length) + " selected")]) : _vm._e()], 1), _vm._v(" "), (_vm.files.length) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.files), function(file, index) {
    return _c('v-chip', {
      key: file.name + index,
      staticClass: "ma-1",
      attrs: {
        "close": "",
        "small": ""
      },
      on: {
        "click:close": function($event) {
          return _vm.removeFile(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(file.name) + "\n          ")])
  }), 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.displayInvoices,
      "items-per-page": 5,
      "no-data-text": "No invoices uploaded"
    },
    scopedSlots: _vm._u([{
      key: "item.filename",
      fn: function(ref) {
        var item = ref.item;

        return [_c('a', {
          attrs: {
            "href": item.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.filename || 'Invoice'))])]
      }
    }, {
      key: "item.source",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          attrs: {
            "small": "",
            "color": item.deletable ? 'secondary' : 'grey lighten-1',
            "text-color": "white"
          }
        }, [_vm._v("\n                " + _vm._s(item.source) + "\n              ")])]
      }
    }, {
      key: "item.timestamp",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n              " + _vm._s(_vm.formatDate(item.timestamp || item.uploadedAt)) + "\n            ")]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "small": "",
            "href": item.url,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-download")])], 1), _vm._v(" "), (item.deletable) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "error",
            "small": "",
            "disabled": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.deleteInvoice(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "white"
          }
        }, [_vm._v("mdi-delete")])], 1) : _vm._e()]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red darken-1",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "green darken-1",
      "disabled": !_vm.files.length || _vm.loading
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("\n        Upload\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Request for Approval in Exceeding COGS cap\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Current Amount : SGD " + _vm._s(_vm.pairing.payoutAmount))])]), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "number",
      "placeholder": "Requested Amount",
      "outlined": "",
      "error-messages": _vm.$v.updateData.amount.$error && "Amount is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.amount.$touch()
      }
    },
    model: {
      value: (_vm.updateData.amount),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "amount", $$v)
      },
      expression: "updateData.amount"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-textarea', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "Reasons",
      "outlined": "",
      "error-messages": _vm.$v.updateData.reasons.$error && "Reasons is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.reasons.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.reasons.$touch()
      }
    },
    model: {
      value: (_vm.updateData.reasons),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "reasons", $$v)
      },
      expression: "updateData.reasons"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.saveReqApproval()
      }
    }
  }, [_vm._v("Get Approval")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-dismiss": "modal"
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.posts.length === 0) ? _c('div', [_c('p', {
    staticClass: "no-posts"
  }, [_vm._v("Post is private or deleted")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('v-card', {
      key: post,
      staticClass: "mb-2"
    }, [(!_vm.platform || _vm.platform === 'instagram') ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(post.oembed)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.platform === 'tiktok') ? _c('div', [_c('div', {
      staticStyle: {
        "left": "0",
        "width": "100%",
        "height": "0",
        "position": "relative",
        "padding-bottom": "177.7778%",
        "padding-top": "90px"
      }
    }, [_c('iframe', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "left": "0px",
        "height": "100%",
        "width": "100%",
        "border": "none"
      },
      attrs: {
        "src": post,
        "allow": "fullscreen"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.platform === 'youtube') ? _c('div', {
      staticStyle: {
        "max-width": "300px",
        "max-height": "500px"
      }
    }, [_c('div', {
      staticStyle: {
        "left": "0",
        "width": "100%",
        "height": "0",
        "position": "relative",
        "padding-bottom": "100%",
        "padding-top": "90px"
      }
    }, [_c('iframe', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "left": "0px",
        "height": "100%",
        "width": "100%",
        "border": "none"
      },
      attrs: {
        "src": post,
        "allow": "fullscreen"
      }
    })])]) : _vm._e()])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    staticClass: "mb-2"
  }, [_c('v-col', {
    attrs: {
      "col": "6"
    }
  }), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        return _vm.searchGlobal()
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.filteredItems), function(batch, bindex) {
    return _c('div', {
      key: bindex,
      attrs: {
        "id": ("archive-" + (batch.batchNo))
      }
    }, [_c('v-expansion-panels', {
      staticClass: "mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (batch.panel),
        callback: function($$v) {
          _vm.$set(batch, "panel", $$v)
        },
        expression: "batch.panel"
      }
    }, [_c('v-expansion-panel', {
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', [_c('h3', [_vm._v(_vm._s(batch.name))])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', {
      staticClass: "mt-3 no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [(batch.selectedPayments.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "success",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.restoreArchive(bindex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-restore")]), _vm._v(" Restore\n                ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
      staticClass: "float-right",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      on: {
        "keyup": function($event) {
          return _vm.changeSearch(batch.filter, batch.filter.search)
        }
      },
      model: {
        value: (batch.filter.search),
        callback: function($$v) {
          _vm.$set(batch.filter, "search", $$v)
        },
        expression: "batch.filter.search"
      }
    })], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      key: _vm.dataTableKey,
      staticClass: "table-small elevation-1",
      attrs: {
        "headers": _vm.headers,
        "items": batch.displayData,
        "items-per-page": 10,
        "search": batch.filter.workingSearch,
        "no-data-text": 'Empty list',
        "show-select": "",
        "single-select": false
      },
      on: {
        "toggle-select-all": _vm.selectAllItems
      },
      scopedSlots: _vm._u([{
        key: "item.data-table-select",
        fn: function(ref) {
          var item = ref.item;

          return [_c('v-checkbox', {
            staticClass: "custom-checkbox",
            attrs: {
              "label": "",
              "value": item,
              "color": "grey darken-2"
            },
            model: {
              value: (batch.selectedPayments),
              callback: function($$v) {
                _vm.$set(batch, "selectedPayments", $$v)
              },
              expression: "batch.selectedPayments"
            }
          })]
        }
      }, {
        key: "item.instagram",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-left"
          }, [_c('social-handle', {
            attrs: {
              "isTikTok": item.isTikTok || item.tiktokOwner,
              "isInstagram": !item.isTikTok && !item.tiktokOwner,
              "tiktokHandle": item.instagram,
              "instagramHandle": item.instagram
            }
          })], 1)]
        }
      }, {
        key: "item.amount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                  ")], 1)]
        }
      }, {
        key: "item.paymentStatus",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "50px"
            }
          }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.paymentStatus)))])]
        }
      }], null, true),
      model: {
        value: (batch.selectedPayments),
        callback: function($$v) {
          _vm.$set(batch, "selectedPayments", $$v)
        },
        expression: "batch.selectedPayments"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('speed-stages', {
    attrs: {
      "filterUser": _vm.filterUser
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Last name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.userRoleLabel))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          View user\n        ")])])
}]}

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "col": "6"
    }
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.createPayoutModal = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('import')) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.outcome.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-home-import-outline")]), _vm._v("Import\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-autorenew")]), _vm._v("Refresh\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalAmount,
      "title": 'Total Payout',
      "subtitle": 'Total payout to influencers'
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalThisWeek,
      "title": 'Total this week',
      "subtitle": _vm.thisWeek
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6"
    }
  }, [_c('total-number', {
    attrs: {
      "total": _vm.totalThisMonth,
      "title": 'Total this month',
      "subtitle": _vm.thisMonth
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "hint": "Press 'Enter' to search",
      "placeholder": "Campaign name, Instagram handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filter()
      }
    },
    model: {
      value: (_vm.searchKeyWords),
      callback: function($$v) {
        _vm.searchKeyWords = $$v
      },
      expression: "searchKeyWords"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.pagging,
      "server-items-length": _vm.totalItems,
      "item-class": _vm.rowColor
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('a', {
          attrs: {
            "href": 'https://instagram.com/' + item.instagramHandle,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle))])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "item-status"
        }, [(!item.statusEdit) ? _c('p', {
          staticClass: "status-label",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item)
            }
          }
        }, [_vm._v(_vm._s(item.status))]) : _c('v-combobox', {
          attrs: {
            "items": _vm.statuses,
            "hide-details": "auto",
            "dense": "",
            "outlined": ""
          },
          on: {
            "change": function($event) {
              return _vm.updateItemStatus(item)
            }
          },
          model: {
            value: (item.status),
            callback: function($$v) {
              _vm.$set(item, "status", $$v)
            },
            expression: "item.status"
          }
        })], 1)]
      }
    }, (_vm.buttonShow('actions')) ? {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "small": "",
                  "dense": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("Actions")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(action, index) {
          return _c('v-list-item', {
            key: index,
            on: {
              "click": function($event) {
                return _vm.doAction(action.value, item)
              }
            }
          }, [_c('v-list-item-title', [_vm._v(_vm._s(action.title))])], 1)
        }), 1)], 1)]
      }
    } : null], null, true)
  }), _vm._v(" "), _c('create-payout-record', {
    attrs: {
      "value": _vm.createPayoutModal,
      "mode": _vm.mode,
      "data": _vm.data
    },
    on: {
      "created": _vm.payoutCreated
    },
    model: {
      value: (_vm.createPayoutModal),
      callback: function($$v) {
        _vm.createPayoutModal = $$v
      },
      expression: "createPayoutModal"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "outcome",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "outcome"
    },
    on: {
      "change": _vm.perpareImport
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pd-bottom-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("                  \n                " + _vm._s(_vm.title) + "\n              ")])])], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Name\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Activation\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Pairing\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                CO-Creating\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Completion\n                            ")]), _vm._v(" "), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "border": "none !important"
          }
        }, [_vm._v("\n                                Overall Average\n                            ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.top5Rows), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticClass: "left-div-border",
            style: ({
              'border-left-color': _vm.theme
            })
          }), _vm._v("\n                              " + _vm._s(item.name) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.ACTIVATION) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.PAIRING) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.CREATING) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.COMPLETE) + "\n                            ")]), _vm._v(" "), _c('td', {
            staticStyle: {
              "line-height": "35px",
              "padding": "0px 0px",
              "font-weight": "300"
            },
            attrs: {
              "align": "center"
            }
          }, [_vm._v("\n                              " + _vm._s(item.Overall) + "\n                            ")])])
        }), _vm._v(" "), _c('tr', [_c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "left-div-border",
          style: ({
            'border-left-color': _vm.theme
          })
        }), _vm._v("\n                              Team\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.activation) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.pairing) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.creating) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.complete) + "\n                            ")]), _vm._v(" "), _c('td', {
          staticStyle: {
            "line-height": "35px",
            "padding": "0px 0px",
            "font-weight": "300"
          },
          attrs: {
            "align": "center"
          }
        }, [_vm._v("\n                             " + _vm._s(_vm.total.top5.overall) + "\n                            ")])])], 2)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mg-top-0"
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "text": "",
      "color": _vm.theme
    },
    on: {
      "click": _vm.seeMoreModalOpen
    }
  }, [_vm._v("See More...")])], 1)], 1)], 1), _vm._v(" "), _c('see-more', {
    attrs: {
      "dialog": _vm.seeMoreDialog,
      "title": _vm.title,
      "closeDialog": _vm.seeMoreModalClose,
      "headers": _vm.headers,
      "DataItems": _vm.items,
      "total": _vm.total.all,
      "theme": _vm.theme,
      "type": "duration"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Pairing")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "campaign-brief-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.timeline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || ''))])])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          on: {
            "click": function($event) {
              return _vm.openCampaignModal(item.campaignID)
            }
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/campaigns/pairing_influencer?campaignID=' + item.campaignID + '&payoutConfirm=true',
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.getDashboardStatusDisplay(item.status)) + "\n          ")])])]
      }
    }, {
      key: "item.dueDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.dueDate ? _vm.formatDate(item.dueDate) : '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.dueDate ? _vm.formatDate(item.dueDate) : ''))])])]
      }
    }], null, true)
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "width": "400px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("Influencers Database Selection")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    staticClass: "caption mb-1",
    attrs: {
      "text": "",
      "dense": "",
      "border": "bottom",
      "type": "info"
    }
  }, [_vm._v("\n            Please Take Note that based on the selection of Size, Minimum Followers and Date, the execution time could be vary.\n            If you are not sure, please leave default values.\n          ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "mdi-book-open-page-variant",
      "label": "Size",
      "placeholder": "Number of posts from the sliced database.",
      "type": "number"
    },
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = _vm._n($$v)
      },
      expression: "size"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "mdi-account-group",
      "label": "Minimum Followers",
      "placeholder": "Minimum followers accounts to be selected.",
      "type": "number"
    },
    model: {
      value: (_vm.minFollowers),
      callback: function($$v) {
        _vm.minFollowers = _vm._n($$v)
      },
      expression: "minFollowers"
    }
  }), _vm._v(" "), _c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "value": _vm.formattedDate,
            "label": "Influencers' posts to date",
            "prepend-icon": "event",
            "readonly": ""
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.postDate),
      callback: function($$v) {
        _vm.postDate = $$v
      },
      expression: "postDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.menu.save(_vm.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.user != null) ? _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.user.firstName.$error
    }
  }, [_c('label', [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter first name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }, function($event) {
        return _vm.$v.user.firstName.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.user.firstName.required && _vm.$v.user.firstName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("First name is required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.user.lastName.$error
    }
  }, [_c('label', [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter last name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }, function($event) {
        return _vm.$v.user.lastName.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.user.lastName.required && _vm.$v.user.lastName.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Last name is required\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6",
    class: {
      'has-error': _vm.$v.user.email.$error
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }, function($event) {
        return _vm.$v.user.email.$touch()
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    }
  }), _vm._v(" "), (!_vm.$v.user.email.required && _vm.$v.user.email.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n            Email is required\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.user.role === _vm.userRoles.ACCOUNT_MANAGER) ? _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Account Admins")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "solo": "",
      "multiple": "",
      "dense": "",
      "items": _vm.accountAdmins,
      "label": "Select Admin Users",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.user.accountAdmins),
      callback: function($$v) {
        _vm.$set(_vm.user, "accountAdmins", $$v)
      },
      expression: "user.accountAdmins"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Edit User\n        ")])])
}]}

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Total Summary")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedCOGS.length))])]), _vm._v(" "), _vm._l((_vm.currencyTotals), function(item, index) {
          return _c('span', {
            key: index
          }, [(item && index === 'SGD') ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
          }, [_vm._v("Total Amount in " + _vm._s(index) + ": "), _c('span', [_vm._v(_vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))])]) : _vm._e(), _vm._v(" "), (item && index !== 'SGD') ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
          }, [_vm._v("Inclusive (" + _vm._s(index) + "): "), _c('span', [_vm._v(_vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))])]) : _vm._e()])
        })], 2)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', {
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    on: {
      "change": _vm.changeCampaign
    },
    model: {
      value: (_vm.campaignID),
      callback: function($$v) {
        _vm.campaignID = $$v
      },
      expression: "campaignID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('SummaryBoxes', {
    attrs: {
      "refresh": _vm.isRefresh,
      "campaignID": _vm.campaignID
    }
  })], 1), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaignID),
      expression: "campaignID"
    }]
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('timeline-data-table', {
    attrs: {
      "refresh": _vm.isRefresh,
      "campaignID": _vm.campaignID,
      "selectedCampaign": _vm.selectedCampaign
    },
    on: {
      "updated": _vm.invokeTimelineUpdated
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline pb-5"
  }, [_vm._v("Invoice Sent History")]), _vm._v(" "), _c('v-card-text', [(_vm.activityData) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [(_vm.showEditActions) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateActivity()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (_vm.showEditActions) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Date Time")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Invoice Sent")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activityData), function(activity, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(activity.timestamp)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(activity.amount)))]), _vm._v(" "), _c('td', [(activity.remarksEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(activity, 'remarks', 'activityData')
              }
            }
          }, [_vm._v("\n                      " + _vm._s(activity.remarks || '') + "\n                      "), _c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "warning",
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1) : _c('div', [_c('div', {
            staticClass: "mt-2"
          }, [_c('v-textarea', {
            attrs: {
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "rows": "2"
            },
            model: {
              value: (activity.remarks),
              callback: function($$v) {
                _vm.$set(activity, "remarks", $$v)
              },
              expression: "activity.remarks"
            }
          })], 1)])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3784600236)
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1000px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card safe-zone-preview-card"
  }, [_c('v-toolbar', {
    staticClass: "ims-modal-header",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Preview of safe zones")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body safe-zone-preview-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "safe-zone-preview-options"
  }, [_c('v-col', {
    staticClass: "pa-0 d-flex flex-wrap justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-switch', {
    staticClass: "mr-5",
    attrs: {
      "label": "Preview IG Reel"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IG')
      }
    },
    model: {
      value: (_vm.isIGCutOff),
      callback: function($$v) {
        _vm.isIGCutOff = $$v
      },
      expression: "isIGCutOff"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "mr-5",
    attrs: {
      "label": "Preview IG Story"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IGStory')
      }
    },
    model: {
      value: (_vm.isIGStory),
      callback: function($$v) {
        _vm.isIGStory = $$v
      },
      expression: "isIGStory"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Preview Tiktok"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('tiktok')
      }
    },
    model: {
      value: (_vm.isTikTokCutOff),
      callback: function($$v) {
        _vm.isTikTokCutOff = $$v
      },
      expression: "isTikTokCutOff"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "safe-zone-preview-media"
  }, _vm._l((_vm.postData.media), function(media, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(media, {
          overlay: true,
          overlayType: _vm.overlayType,
          creatorView: true,
          postView: true
        })
      }
    }), _vm._v(" "), (!media.preview.thumbnail) ? _c('btn-download', {
      attrs: {
        "url": media.preview.src
      }
    }) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions safe-zone-preview-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": this.accept,
      "listMedia": _vm.media,
      "influencer": _vm.influencer,
      "campaign": _vm.campaign
    },
    on: {
      "change": _vm.mediaChanged
    }
  }), _vm._v(" "), (_vm.supportsVideoUpload) ? _c('div', {
    staticClass: "video-compression-suggestion mt-3"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("mdi-information-outline")]), _vm._v(" "), _c('span', [_vm._v("Video file too large?")]), _vm._v(" "), _c('a', {
    staticClass: "ml-1",
    attrs: {
      "href": "https://www.veed.io/new?tool=compress",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Compress your video with VEED")]), _vm._v(" "), _c('span', [_vm._v("  before uploading.")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isVideoLink) ? _c('v-row', {
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-bottom": "0px !important"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "clearable": "",
      "type": "text",
      "label": "Video or Drive Link (use this field if automatic upload do not work or your video file exceeds 100mb)",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.vdoLink),
      callback: function($$v) {
        _vm.vdoLink = $$v
      },
      expression: "vdoLink"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isRemark) ? _c('v-row', {
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-bottom": "0px !important"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "remark",
      "label": "Remark",
      "clearable": "",
      "auto-grow": "",
      "filled": "",
      "rows": "4",
      "rules": [_vm.rules.length(2200)],
      "counter": ""
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "caption",
      "label": _vm.captionLabel,
      "clearable": "",
      "auto-grow": "",
      "filled": "",
      "rows": "4",
      "rules": [_vm.rules.length(2200)],
      "counter": ""
    },
    model: {
      value: (_vm.caption),
      callback: function($$v) {
        _vm.caption = $$v
      },
      expression: "caption"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("What's Next")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTasks()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-item', {
      key: item.title,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.actionOnTask(item.action, item.postID)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.text) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', {
    staticClass: "row pa-2"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.CampaignId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CampaignId", $$v)
      },
      expression: "selectedFilter.CampaignId"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterUsers,
      "label": "CC Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.UserId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "UserId", $$v)
      },
      expression: "selectedFilter.UserId"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Year Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.search()
            }
          },
          model: {
            value: (_vm.searchMonth),
            callback: function($$v) {
              _vm.searchMonth = $$v
            },
            expression: "searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.searchMonth),
      callback: function($$v) {
        _vm.searchMonth = $$v
      },
      expression: "searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n                Cancel\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchMonthOk
    }
  }, [_vm._v("\n                OK\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "pieChart",
      "width": "500",
      "height": "200"
    }
  })])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pb-5",
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.disableEdit ? 'Edit' : 'Create') + " COGS Estimation")])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "0px 50px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [(!_vm.payout.id) ? _c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "hide-details": "auto",
      "item-text": "displayName",
      "error-messages": _vm.selectedCampaignErrors,
      "label": "IO or Campaign",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "change": function($event) {
        return _vm.changeCampaign()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                        No results matching \"\n                        "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                      ")])], 1)], 1)]
      },
      proxy: true
    }], null, false, 1677632798),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payout.id && _vm.payout.campaign) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Campaign : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "body-2 mb-0"
  }, [_vm._v(_vm._s(_vm.payout.campaign.ioNumbers) + " - " + _vm._s(_vm.payout.campaign.name))])])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Incurred Date (DD/MM/YYYY) : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "disabled": _vm.disableEdit
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.live_date.$touch()
      },
      "input": _vm.changeLiveDate,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeLiveDate.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.payout.live_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "live_date", $$v)
      },
      expression: "payout.live_date"
    }
  }, _vm.on)), _vm._v(" "), (_vm.isInvalidLiveDate) ? _c('span', {
    staticClass: "custom-danger ma-0 pt-1"
  }, [_vm._v("Invalid Incurred Date")]) : _vm._e(), _vm._v(" "), (!_vm.isInvalidLiveDate && !_vm.payout.live_date) ? _c('span', {
    staticClass: "custom-danger ma-0 pt-1"
  }, [_vm._v("This field is required")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Creator Handle : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [(!_vm.disableEdit) ? _c('v-combobox', {
    attrs: {
      "items": _vm.influencers,
      "item-text": "handle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle,
            "youtubeHandle": item.handle,
            "facebookHandle": item.handle,
            "xiaohongshuHandle": item.handle
          }
        })]
      }
    }], null, false, 4074452561),
    model: {
      value: (_vm.payout.handle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "handle", $$v)
      },
      expression: "payout.handle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.disableEdit && _vm.payout.handle) ? _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v(_vm._s(_vm.payout.handle.handle))]) : _vm._e(), _vm._v(" "), (_vm.disableEdit && !_vm.payout.handle) ? _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Type : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.estimationTypes,
      "label": "Type",
      "error-messages": _vm.estimationTypeErrors,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.estimationType.$touch()
      }
    },
    model: {
      value: (_vm.payout.estimationType),
      callback: function($$v) {
        _vm.$set(_vm.payout, "estimationType", $$v)
      },
      expression: "payout.estimationType"
    }
  }), _vm._v(" "), (_vm.payout.estimationType === 'Others') ? _c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "placeholder": "Custom",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.payout.customType),
      callback: function($$v) {
        _vm.$set(_vm.payout, "customType", $$v)
      },
      expression: "payout.customType"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Amount : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "disabled": _vm.disableEdit,
      "error-messages": _vm.amountErrors,
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Remarks : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "disabled": _vm.disableEdit,
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payout, "remarks", $$v)
      },
      expression: "payout.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "title": "Upload Invoices",
      "refresh": _vm.fileUploadRefresh,
      "multiple": true
    },
    on: {
      "setMedias": _vm.updateInvoices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.disableSavePayout,
      "text": ""
    },
    on: {
      "click": _vm.savePayout
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getType() === 'v-img') ? _c('v-img', {
    staticClass: "elevation-2",
    attrs: {
      "src": _vm.URL,
      "width": _vm.width,
      "height": _vm.height
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getType() === 'v-img' && _vm.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.URL,
      "label": "Download",
      "noBlock": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getType() === 'cld-image') ? _c('cld-image', {
    attrs: {
      "cloudName": _vm.cldConfig.CLOUD_NAME,
      "public-id": _vm.publicID,
      "width": _vm.width,
      "loading": _vm.trans.loading || ''
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getType() === 'cld-video') ? _c('div', {
    class: _vm.className || ''
  }, [_c('video', {
    staticClass: "cld-video-player cld-fluid",
    attrs: {
      "id": ("cld-player-" + _vm.videoID),
      "data-cld-public-id": _vm.publicID,
      "controls": ""
    }
  }), _vm._v(" "), (_vm.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.URL,
      "label": "Download"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getType() === 'video') ? _c('div', {
    class: _vm.className || ''
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('video', {
    staticClass: "custom-preview-img",
    attrs: {
      "id": "postVdoMedia",
      "src": _vm.URL,
      "width": _vm.width,
      "height": _vm.height,
      "controls": ""
    }
  }, [_vm._v("             \n          Your browser does not support the video tag.\n      ")]), _vm._v(" "), (_vm.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.URL,
      "label": "Download",
      "noBlock": true
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.getType() === 'iframe') ? _c('iframe', {
    class: _vm.className || '',
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "src": _vm.URL,
      "allow": "autoplay",
      "scrolling": "no",
      "seamless": "",
      "allowFullScreen": ""
    }
  }) : (_vm.getType() === 'driveCustomView') ? _c('gDrive-post-view', {
    attrs: {
      "url": _vm.URL,
      "darkTheme": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.rootClass || ''
  }, [_c('div', {
    staticClass: "col-header-title"
  }, [_vm._v(_vm._s(_vm.header.text))]), _vm._v(" "), (_vm.header.legendText) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({}, on), [_c('v-icon', {
          attrs: {
            "small": "",
            "color": _vm.iconColor || ''
          }
        }, [_vm._v("mdi-information-outline")])], 1)]
      }
    }], null, false, 1668216842)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.header.legendText))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "offset": "3",
      "align": "center"
    }
  }, [_c('k-influencer-search-box', {
    attrs: {
      "search": _vm.peformSearch,
      "page": _vm.currentPage,
      "limit": _vm.pagination.itemsPerPage,
      "sortBy": _vm.pagination.sortBy[0],
      "descending": _vm.pagination.sortDesc[0]
    },
    on: {
      "result": _vm.searchDone
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "offset": "3",
      "align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.searchByKeywords
    }
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewReport",
      "data-toggle": "modal",
      "data-target": _vm.audienceDataReportDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), (_vm.summary) ? _c('table', {
    staticClass: "summary"
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('th', [_vm._v("High-tier")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.summary.hightier.count))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(Number(_vm.summary.hightier.total_outreach).toLocaleString()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.summary.hightier.average_engagement) + "%")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Everyday")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.summary.everyday.count))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(Number(_vm.summary.everyday.total_outreach).toLocaleString()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.summary.everyday.average_engagement) + "%")])])]) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "row mb-1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "2",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Card View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])])], 1)], 1)], 1), _vm._v(" "), (_vm.display === 0) ? _c('div', [_c('v-row', {
    staticClass: "no-gutters",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, _vm._l((_vm.igPostItems), function(post) {
    return _c('v-col', {
      key: post.id,
      staticClass: "pa-2",
      attrs: {
        "cols": "auto",
        "sm": "12",
        "md": "4",
        "lg": "4"
      }
    }, [_c('v-card', {
      staticClass: "mx-auto campaign-post",
      attrs: {
        "color": "#62727b",
        "dark": "",
        "max-width": "400",
        "elevation": 2
      }
    }, [_c('v-card-title', _vm._l((post.tags), function(tag) {
      return _c('v-chip', {
        key: tag,
        staticClass: "mr-2",
        attrs: {
          "label": "",
          "color": "green",
          "small": "",
          "text-color": "white"
        }
      }, [_c('v-icon', {
        attrs: {
          "float-left": ""
        }
      }, [_vm._v("label")]), _vm._v("\n                  " + _vm._s(tag) + "\n                ")], 1)
    }), 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "headline font-weight-bold",
      staticStyle: {
        "min-height": "560px"
      }
    }, [(post.igPost) ? _c('div', {
      staticClass: "content-igPost-block",
      staticStyle: {
        "max-width": "350px"
      },
      domProps: {
        "innerHTML": _vm._s(post.igPost)
      }
    }) : _vm._e()])], 1)], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "ma-5"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-pagination', {
    attrs: {
      "circle": "",
      "value": _vm.pagination.page,
      "length": _vm.paginationLength,
      "total-visible": 7
    },
    on: {
      "input": function($event) {
        return _vm.cardSearchByKeywords()
      }
    },
    model: {
      value: (_vm.pagination.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "page", $$v)
      },
      expression: "pagination.page"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.display === 1) ? _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.pagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.totalItems,
      "item-key": "instagramHandle"
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('v-avatar', {
            attrs: {
              "size": _vm.avatarSize,
              "color": "grey lighten-4"
            }
          }, [_c('img', {
            attrs: {
              "src": item.profilePicture,
              "alt": "avatar"
            }
          })])], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.totalFollowers))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.audienceCredibility) + "%")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.relevancyScore))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, _vm._l((item.tags), function(tag) {
            return _c('v-chip', {
              key: tag,
              attrs: {
                "label": "",
                "color": "green",
                "small": "",
                "text-color": "white"
              }
            }, [_c('v-icon', {
              attrs: {
                "float-left": ""
              }
            }, [_vm._v("label")]), _vm._v("\n                    " + _vm._s(tag) + "\n                  ")], 1)
          }), 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                  " + _vm._s(item.postCreatedDate) + "\n                ")]), _vm._v(" "), _c('td', {
            staticClass: "justify-center layout px-0"
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.showReport(item)
                    }
                  }
                }, on), [_vm._v("assessment")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewInfluencerPosts(item)
                    }
                  }
                }, on), [_vm._v("local_library")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Posts")])])], 1)])
        }), 0)]
      }
    }], null, false, 495010801)
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('influencer-post-modal', {
    attrs: {
      "modalId": _vm.influencerPostModalId,
      "title": _vm.postsTitle,
      "shortCodes": _vm.shortCodes
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("Total Outreach")]), _vm._v(" "), _c('th', [_vm._v("Average Engagement")])])
}]}

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.reportData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("For your internal communication only")]), _vm._v(" "), _c('v-card-text', [(_vm.reportData.isTikTok && _vm.reportData.isTikTok === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.reportData.instagram,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.reportData.instagram))]) : _c('a', {
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.reportData.instagram,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.reportData.instagram))], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "notes",
      "label": "",
      "hide-details": "",
      "value": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.reportData.note.$touch()
      }
    },
    model: {
      value: (_vm.reportData.note),
      callback: function($$v) {
        _vm.$set(_vm.reportData, "note", $$v)
      },
      expression: "reportData.note"
    }
  })], 1)], 1), _vm._v(" "), (_vm.reportData.internalNotes.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "max-height": "300px"
    }
  }, [(_vm.reportData.internalNotes.length > 0) ? _c('v-card-text', {
    staticClass: "mt-0 pt-0"
  }, _vm._l((_vm.reportData.internalNotes), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('v-row', [_c('v-col', [_c('p', {
      staticClass: "body-2 font-weight-bold"
    }, [_vm._v(_vm._s(msg.author ? msg.author.name : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right"
    }, [(_vm.showAction(msg)) ? _c('v-btn', {
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Delete Note",
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteNote(_vm.fileIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white",
        "small": ""
      }
    }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('p', {
      staticClass: "body-1 font-weight-medium"
    }, [_vm._v(_vm._s(msg.notes))]), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.formatTime(msg.timestamp)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0) : _c('v-card-text', [_c('p', {
    staticClass: "body-1 fong-weight-bold"
  }, [_vm._v("\n                No Internal Notes\n              ")])])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNote()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1000"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', {
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Engagements rate for @" + _vm._s(_vm.handle))])]), _vm._v(" "), _c('v-card-subtitle', [_c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("Distrubution by engagement rate for influencers having followers between " + _vm._s(_vm._f("abbr")((_vm.followersRange.left_number || 0))) + " and " + _vm._s(_vm._f("abbr")((_vm.followersRange.right_number || 0))))])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": "50",
      "hide-default-footer": true,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "item.rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', {
          class: {
            'font-weight-bold': item.handle
          }
        }, [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.handle) ? _c('span', {
          staticClass: "font-weight-bold ml-5"
        }, [_vm._v("@" + _vm._s(item.handle))]) : _vm._e(), _vm._v(" "), (item.median) ? _c('span', {
          staticClass: "caption ml-5"
        }, [_vm._v("Median")]) : _vm._e()])])]
      }
    }, {
      key: "item.total",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(_vm._f("thousandSeprator")(item.total)) + "\n                ")])])]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.viewMode ? 'View' : 'Edit') + " Client Account")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panels),
      callback: function($$v) {
        _vm.panels = $$v
      },
      expression: "panels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Contact Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [(_vm.needCompany) ? _c('v-select', {
    attrs: {
      "prepend-icon": "business",
      "label": "Assign a Company to client",
      "items": _vm.company_options,
      "item-text": "name",
      "item-value": "id",
      "readonly": _vm.viewMode
    },
    model: {
      value: (_vm.client.companyID),
      callback: function($$v) {
        _vm.$set(_vm.client, "companyID", $$v)
      },
      expression: "client.companyID"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "person_outline",
      "label": "Sales Representative",
      "items": _vm.salePerson_options,
      "readonly": _vm.viewMode,
      "item-text": "firstName",
      "item-value": "id"
    },
    model: {
      value: (_vm.client.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.client, "salePerson", $$v)
      },
      expression: "client.salePerson"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "prepend-icon": "groups",
      "items": _vm.xeroContacts,
      "readonly": _vm.viewMode,
      "label": "Billing Name as per Xero",
      "item-text": "Name",
      "attach": "",
      "dense": "",
      "return-object": ""
    },
    on: {
      "change": _vm.changeClientGroup
    },
    model: {
      value: (_vm.client.group),
      callback: function($$v) {
        _vm.$set(_vm.client, "group", $$v)
      },
      expression: "client.group"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "business",
      "label": "Client Name (enter only if billing name as per xero cannot be found above)",
      "placeholder": "",
      "readonly": _vm.viewMode,
      "error-messages": _vm.nameErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.name.$touch()
      }
    },
    model: {
      value: (_vm.client.name),
      callback: function($$v) {
        _vm.$set(_vm.client, "name", $$v)
      },
      expression: "client.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "phone",
      "label": "Primary Contact Number",
      "placeholder": "",
      "readonly": _vm.viewMode,
      "required": ""
    },
    model: {
      value: (_vm.client.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.client, "phoneNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "client.phoneNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "location_on",
      "label": "Address (to be included in invoice)",
      "placeholder": "Enter Contact Address",
      "readonly": _vm.viewMode,
      "error-messages": _vm.addressErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.address.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.address.$touch()
      }
    },
    model: {
      value: (_vm.client.address),
      callback: function($$v) {
        _vm.$set(_vm.client, "address", $$v)
      },
      expression: "client.address"
    }
  })], 1), _vm._v(" "), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.contactPanels),
      callback: function($$v) {
        _vm.contactPanels = $$v
      },
      expression: "contactPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                        Contacts\n                      ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_vm._l((_vm.client.contacts), function(contact, index) {
    return _c('v-list', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "readonly": _vm.viewMode,
        "label": "Include in Email",
        "color": "secondary",
        "true-value": true,
        "false-value": false,
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: (contact.includeEmail),
        callback: function($$v) {
          _vm.$set(contact, "includeEmail", $$v)
        },
        expression: "contact.includeEmail"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "person",
        "label": "Contact Person",
        "placeholder": "",
        "readonly": _vm.viewMode,
        "required": ""
      },
      model: {
        value: (contact.contactName),
        callback: function($$v) {
          _vm.$set(contact, "contactName", $$v)
        },
        expression: "contact.contactName"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "email",
        "label": "Contact Email",
        "placeholder": "",
        "readonly": _vm.viewMode
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
        },
        "paste": _vm.preventPasteSpaces,
        "change": function($event) {
          return _vm.checkAccEmail(index)
        }
      },
      model: {
        value: (contact.email),
        callback: function($$v) {
          _vm.$set(contact, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "contact.email"
      }
    })], 1), _vm._v(" "), (contact.invalid) ? _c('v-list-item', {
      staticStyle: {
        "margin-top": "-15px"
      },
      attrs: {
        "dense": ""
      }
    }, [_c('p', {
      staticClass: "text-danger"
    }, [_vm._v("Email Already Exists.")])]) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-combobox', {
      staticClass: "ma-0 mb-3 pa-0",
      attrs: {
        "prepend-icon": "mdi-file-check",
        "readonly": _vm.viewMode,
        "items": _vm.campaigns,
        "item-text": "name",
        "item-value": "id",
        "outlined": "",
        "dense": "",
        "small-chips": "",
        "label": "Campaigns",
        "multiple": "",
        "hide-details": ""
      },
      model: {
        value: (contact.campaigns),
        callback: function($$v) {
          _vm.$set(contact, "campaigns", $$v)
        },
        expression: "contact.campaigns"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [(!_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeContact(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                        ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), (!_vm.viewMode) ? _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.addDefaultContact()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Contact\n                    ")], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Account Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('div', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountDeals.length > 0),
      expression: "accountDeals.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.accountDeals), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "disable-icon-rotate": ""
      }
    }, [_c('span', [_c('p', {
      staticClass: "pr-2 pb-2 mb-0"
    }, [_vm._v("\n                                  " + _vm._s(_vm.getProductName(item.name)) + "\n                                ")]), _vm._v(" "), (item.masterListCheck && !_vm.viewMode) ? _c('v-chip', {
      attrs: {
        "color": "green",
        "outlined": "",
        "x-small": "",
        "readonly": _vm.viewMode
      }
    }, [_vm._v("\n                                  Masterlist \n                                  "), _c('v-icon', {
      attrs: {
        "color": "success",
        "small": ""
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e(), _vm._v(" "), (!item.masterListCheck && !_vm.viewMode && _vm.isLinkMasterListBtn) ? _c('v-btn', {
      attrs: {
        "color": "warning",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.linkMasterlist(item)
        }
      }
    }, [_vm._v("\n                                  Link Masterlist\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-row', {
      staticClass: "pa-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Deals Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget || '-'))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("IO")]), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v(_vm._s(item.IO || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.activationDate) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Activation Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.activationDate))])])], 1) : _vm._e(), _vm._v(" "), (item.linkedIOs && item.linkedIOs.length) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Linked IO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Quote Acceptance Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.quoteAcceptanceDate)))])])], 1), _vm._v(" "), (item.markupCOGS) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Markup COGS Amount")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cogsAmount || '-'))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.vertical) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaign Vertical")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.displayCampaignVerticals(item.vertical)))])])], 1) : _vm._e(), _vm._v(" "), (item.country) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('p', _vm._l((item.country), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                          " + _vm._s(item.name) + "\n                                        ")])
    }), 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Client Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getClientTypeDisplayValue(item.clientType)))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Line of Services")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.servicesLine))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.remarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-expansion-panels', _vm._l((item.products), function(product, pindex) {
      return _c('v-expansion-panel', {
        key: pindex
      }, [_c('v-expansion-panel-header', {
        staticStyle: {
          "text-transform": "capitalize"
        }
      }, [_vm._v(_vm._s(_vm.getProductName(product.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'storytell'),
          expression: "product.name.toLowerCase() === 'storytell'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-clipboard-list-outline")]), _vm._v(" No. of Campaigns: "), _c('strong', [_vm._v(_vm._s(product.noOfCampaigns))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(product.totalOutReach))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-chart-areaspline ")]), _vm._v(" Total Engagement: "), _c('strong', [_vm._v(_vm._s(product.totalEngagement))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'amplify'),
          expression: "product.name.toLowerCase() === 'amplify'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-file-eye-outline ")]), _vm._v(" Views: "), _c('strong', [_vm._v(_vm._s(product.views))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent || product.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Duration: "), _c('strong', [_vm._v(_vm._s(product.duration) + " " + _vm._s((product.duration > 1 ? 'Months' : 'Month')))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'),
          expression: "product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(product.totalOutReach || '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent || product.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" KPI Onboarded: "), _c('strong', [_vm._v(_vm._s(product.kpiOnboarded || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'others'),
          expression: "product.name.toLowerCase() === 'others'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(product.remark))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-file-outline")]), _vm._v(" Nature of Deal: "), _c('strong', [_vm._v(_vm._s(_vm.displayNatureOfDeals(product.natureOfDeal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'loading fees'),
          expression: "product.name.toLowerCase() === 'loading fees'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(product.remark))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
        attrs: {
          "text": "",
          "color": "error"
        },
        on: {
          "click": function($event) {
            return _vm.deleteProductsFromAccountDetails(index, pindex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                                            ")], 1) : _vm._e(), _vm._v(" "), (!_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
        attrs: {
          "text": "",
          "color": "warning"
        },
        on: {
          "click": function($event) {
            return _vm.reqForDelete(index, pindex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-delete-forever")]), _vm._v(" Request for Delete\n                                            ")], 1) : _vm._e()], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.dealsEdit(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-pencil")]), _vm._v(" Edit\n                                ")], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDeals(index, true)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                                ")], 1) : _vm._e(), _vm._v(" "), (!_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.reqForDelete(index, null)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Request for Delete\n                                ")], 1) : _vm._e()], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.viewMode) ? _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.addDeals
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("\n                    mdi-plus\n                    ")]), _vm._v("\n                    Add Deals\n                  ")], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Assigned Team")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('AssignTeam', {
    attrs: {
      "assignUsers": _vm.assignUsers,
      "dedicatedData": _vm.dedicatedData,
      "supportingData": _vm.supportingData,
      "viewMode": _vm.viewMode
    },
    on: {
      "updateSelectedDedicated": _vm.updateSelectedDedicated,
      "updateSelectedSupporting": _vm.updateSelectedSupporting
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Billing Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "Billing information is same as contact information",
      "readonly": _vm.viewMode
    },
    model: {
      value: (_vm.sameWithContactInfo),
      callback: function($$v) {
        _vm.sameWithContactInfo = $$v
      },
      expression: "sameWithContactInfo"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "payment",
      "label": "Payment Mode",
      "items": _vm.clientPaymentModes,
      "item-text": "name",
      "item-value": "value",
      "readonly": _vm.viewMode
    },
    model: {
      value: (_vm.client.paymentMode),
      callback: function($$v) {
        _vm.$set(_vm.client, "paymentMode", $$v)
      },
      expression: "client.paymentMode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "location_on",
      "label": "Billing Address",
      "placeholder": "Enter Billing Address",
      "disabled": _vm.sameWithContactInfo || _vm.viewMode
    },
    model: {
      value: (_vm.client.billingAddress),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingAddress", $$v)
      },
      expression: "client.billingAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "phone",
      "label": "Billing Contact",
      "placeholder": "Enter billing contact number",
      "disabled": _vm.sameWithContactInfo || _vm.viewMode
    },
    model: {
      value: (_vm.client.billingPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingPhoneNumber", $$v)
      },
      expression: "client.billingPhoneNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "email",
      "label": "Billing Email",
      "placeholder": "Enter billing email",
      "disabled": _vm.sameWithContactInfo || _vm.viewMode,
      "error-messages": _vm.emailErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.email.$touch()
      }
    },
    model: {
      value: (_vm.client.billingEmail),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "client.billingEmail"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.viewMode) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.editClient
    }
  }, [_vm._v("Save")])], 1) : _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.directCloseModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.addDealsDialog),
      callback: function($$v) {
        _vm.addDealsDialog = $$v
      },
      expression: "addDealsDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "350px"
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add New Deals")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "dealForm"
  }, [_c('v-container', [_c('v-autocomplete', {
    staticClass: "mt-5",
    attrs: {
      "items": _vm.displayMasterLists,
      "item-text": "quoteNo",
      "item-value": "quoteNo",
      "label": "IO Number",
      "prepend-icon": "mdi-file-outline",
      "prefix": "IO-",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "change": _vm.changeIONumber
    },
    model: {
      value: (_vm.client.deals.IO),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "IO", $$v)
      },
      expression: "client.deals.IO"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('label', [_vm._v("Linked IO")]), _c('br'), _vm._v(" "), _vm._l((_vm.client.deals.linkedIOs), function(linkIO, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-row mb-2"
    }, [_c('v-text-field', _vm._g({
      attrs: {
        "prefix": "IO-",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": _vm.changeLinkedIO
      },
      model: {
        value: (_vm.client.deals.linkedIOs[index]),
        callback: function($$v) {
          _vm.$set(_vm.client.deals.linkedIOs, index, $$v)
        },
        expression: "client.deals.linkedIOs[index]"
      }
    }, _vm.on)), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "min-width": "30px",
        "height": "36px",
        "margin-left": "5px"
      },
      attrs: {
        "color": "red",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteLinkIO(index)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-delete-outline")])], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2 ml-0",
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.addLinkIO()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n              ")], 1)], 2), _vm._v(" "), _c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "pt-3",
          attrs: {
            "label": "Quote Acceptance Date *",
            "prepend-icon": "event",
            "dense": "",
            "readonly": "",
            "disabled": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.client.deals.quoteAcceptanceDate),
            callback: function($$v) {
              _vm.$set(_vm.client.deals, "quoteAcceptanceDate", $$v)
            },
            expression: "client.deals.quoteAcceptanceDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.pickDate = false
      }
    },
    model: {
      value: (_vm.client.deals.quoteAcceptanceDate),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "quoteAcceptanceDate", $$v)
      },
      expression: "client.deals.quoteAcceptanceDate"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prepend-icon": "attach_money",
      "label": "Budget",
      "placeholder": "Enter budget",
      "disabled": ""
    },
    model: {
      value: (_vm.client.deals.previewBudget),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "previewBudget", _vm._n($$v))
      },
      expression: "client.deals.previewBudget"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prepend-icon": "attach_money",
      "label": "Total Budget",
      "placeholder": "Enter Total Budget",
      "rules": [_vm.rules.required],
      "disabled": ""
    },
    model: {
      value: (_vm.client.deals.budget),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "budget", _vm._n($$v))
      },
      expression: "client.deals.budget"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "text",
      "prepend-icon": "mdi-file-outline",
      "label": "Deal Name *",
      "placeholder": "Enter Deal Name",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.name),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "name", $$v)
      },
      expression: "client.deals.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Activation Date",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.checkDate('activationDate')
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkDate('activationDate')
      }
    },
    model: {
      value: (_vm.client.deals.activationDate),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "activationDate", $$v)
      },
      expression: "client.deals.activationDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon'
      },
      "status": _vm.actDateCal
    },
    on: {
      "changeDate": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.setDateFromPicker.apply(void 0, [ 'activationDate' ].concat( argsArray ))
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-combobox', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.campaignVerticals,
      "item-text": "name",
      "item-value": "name",
      "prepend-icon": "mdi-file-outline",
      "hide-selected": "",
      "dense": "",
      "label": "Campaign Vertical",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                    $delete\n                  ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.client.deals.vertical),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "vertical", $$v)
      },
      expression: "client.deals.vertical"
    }
  }), _vm._v(" "), _c('v-combobox', {
    staticClass: "mt-5",
    attrs: {
      "prepend-icon": "mdi-file-outline",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "code",
      "hide-selected": "",
      "multiple": "",
      "chips": "",
      "label": "Country",
      "dense": "",
      "rules": [_vm.rules.required]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                    $delete\n                  ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.client.deals.country),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "country", $$v)
      },
      expression: "client.deals.country"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.clientTypes,
      "item-text": "title",
      "item-value": "value",
      "label": "Client Type",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.client.deals.clientType),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "clientType", $$v)
      },
      expression: "client.deals.clientType"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.lineOfServices,
      "label": "Line of Services",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.servicesLine),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "servicesLine", $$v)
      },
      expression: "client.deals.servicesLine"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "filled": "",
      "label": "Remarks",
      "prepend-icon": "mdi-bookmark-check-outline"
    },
    model: {
      value: (_vm.client.deals.remarks),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "remarks", $$v)
      },
      expression: "client.deals.remarks"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "this is a mark-up deal (special approval has been obtained prior)",
      "small": ""
    },
    on: {
      "change": _vm.changeMarkupCOGS
    },
    model: {
      value: (_vm.client.deals.markupCOGS),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "markupCOGS", $$v)
      },
      expression: "client.deals.markupCOGS"
    }
  }), _vm._v(" "), (_vm.client.deals.markupCOGS) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "COGS Amount",
      "placeholder": "Enter COGS Amount",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.cogsAmount),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "cogsAmount", $$v)
      },
      expression: "client.deals.cogsAmount"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-2 white--text",
          attrs: {
            "color": "info"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "dark": ""
          }
        }, [_vm._v("\n              mdi-plus\n              ")]), _vm._v("\n              Add Products\n            ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Storytell')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Storytell")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Amplify')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Amplify")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('aok')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("AOK/Uncut")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Loading Fees')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Loading Fees")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Others')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Others")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountProducts.length > 0),
      expression: "accountProducts.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountProducts.length > 0),
      expression: "accountProducts.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.accountProducts), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.getProductName(item.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'storytell'),
        expression: "item.name.toLowerCase() === 'storytell'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-clipboard-list-outline")]), _vm._v(" No. of Campaigns: "), _c('strong', [_vm._v(_vm._s(item.noOfCampaigns))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(item.totalOutReach))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-chart-areaspline ")]), _vm._v(" Total Engagement: "), _c('strong', [_vm._v(_vm._s(item.totalEngagement))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'amplify'),
        expression: "item.name.toLowerCase() === 'amplify'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-file-eye-outline ")]), _vm._v(" Views: "), _c('strong', [_vm._v(_vm._s(item.views))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent || item.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Duration: "), _c('strong', [_vm._v(_vm._s(item.duration) + " Months")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'uncut' || item.name.toLowerCase() === 'aok'),
        expression: "item.name.toLowerCase() === 'uncut'  || item.name.toLowerCase() === 'aok'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(item.totalOutReach || '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent || item.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" KPI Onboarded: "), _c('strong', [_vm._v(_vm._s(item.kpiOnboarded || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'others'),
        expression: "item.name.toLowerCase() === 'others'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-bookmark-check-outline")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(item.remark))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-file-outline")]), _vm._v(" Nature of deal: "), _c('strong', [_vm._v(_vm._s(_vm.displayNatureOfDeals(item.natureOfDeal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'loading fees'),
        expression: "item.name.toLowerCase() === 'loading fees'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-bookmark-check-outline")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(item.remark))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.productEdit(item, index)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" Edit\n                      ")], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "id": "deleteDealsProduct",
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteProducts(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                      ")], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeDealsModal
    }
  }, [_vm._v("\n            Close\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "info",
    on: {
      "click": _vm.addEditDeals
    }
  }, [_vm._v("\n            " + _vm._s((this.dealAction === 'add' ? 'Add' : 'Save')) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.addEditDialog),
      callback: function($$v) {
        _vm.addEditDialog = $$v
      },
      expression: "addEditDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.showProductName))])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form"
  }, [_c('v-container', [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'amplify' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() === 'amplify' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "mdi-file-eye-outline",
      "label": "Views",
      "placeholder": "Enter views"
    },
    model: {
      value: (_vm.client.moreAccount.views),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "views", _vm._n($$v))
      },
      expression: "client.moreAccount.views"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'amplify' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() === 'amplify' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "mdi-calendar",
      "label": "Duration",
      "placeholder": "Enter No. of months"
    },
    model: {
      value: (_vm.client.moreAccount.duration),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "duration", _vm._n($$v))
      },
      expression: "client.moreAccount.duration"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' && _vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "scatter_plot",
      "label": "Total Outreach",
      "placeholder": "Enter total outreach"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.totalOutReach),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "totalOutReach", _vm._n($$v))
      },
      expression: "client.moreAccount.totalOutReach"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' &&
        _vm.productName.toLowerCase() !== 'uncut' &&
        _vm.productName.toLowerCase() !== 'aok' &&
        _vm.productName.toLowerCase() !== 'others' &&
        _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' &&\n                  productName.toLowerCase() !== 'uncut' &&\n                  productName.toLowerCase() !== 'aok' &&\n                  productName.toLowerCase() !== 'others' &&\n                  productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "score",
      "label": "Total Engagement",
      "placeholder": "Enter total engagement"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.totalEngagement),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "totalEngagement", _vm._n($$v))
      },
      expression: "client.moreAccount.totalEngagement"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "notes",
      "label": "Min. original content",
      "placeholder": "Enter minimum numbers of content"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.minContent),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "minContent", _vm._n($$v))
      },
      expression: "client.moreAccount.minContent"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "sort",
      "label": "Max. original content",
      "placeholder": "Enter maximum numbers of content"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.maxContent),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "maxContent", _vm._n($$v))
      },
      expression: "client.moreAccount.maxContent"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'uncut' || _vm.productName.toLowerCase() === 'aok'),
      expression: "productName.toLowerCase() === 'uncut' || productName.toLowerCase() === 'aok'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "sort",
      "label": "KPI Onboarded",
      "placeholder": "Enter KPI Onboarded"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.kpiOnboarded),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "kpiOnboarded", _vm._n($$v))
      },
      expression: "client.moreAccount.kpiOnboarded"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' && _vm.productName.toLowerCase() !== 'uncut' && _vm.productName.toLowerCase() !== 'aok' && _vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'uncut' && productName.toLowerCase() !== 'aok' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "list_alt",
      "label": "No. of Campaigns",
      "placeholder": "Enter numbers of campaigns"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.maxCampaigns),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "maxCampaigns", _vm._n($$v))
      },
      expression: "client.moreAccount.maxCampaigns"
    }
  }), _vm._v(" "), _c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'others' || _vm.productName.toLowerCase() === 'loading fees'),
      expression: "productName.toLowerCase() === 'others' || productName.toLowerCase() === 'loading fees'"
    }],
    attrs: {
      "filled": "",
      "label": "Remark",
      "placeholder": "Remark",
      "prepend-icon": "mdi-bookmark-check-outline"
    },
    model: {
      value: (_vm.client.moreAccount.remark),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "remark", $$v)
      },
      expression: "client.moreAccount.remark"
    }
  }), _vm._v(" "), _c('v-combobox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'others'),
      expression: "productName.toLowerCase() === 'others'"
    }],
    attrs: {
      "prepend-icon": "mdi-file-outline",
      "label": "Nature of deal",
      "search-input": _vm.newDealNature,
      "items": _vm.dealNatureLists,
      "item-text": "name",
      "item-value": "id",
      "chips": "",
      "multiple": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newDealNature = $event
      },
      "update:search-input": function($event) {
        _vm.newDealNature = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v("Press Enter to Create")]), _vm._v(" "), _c('v-chip', {
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.newDealNature) + "\n                      ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.client.moreAccount.natureOfDeal),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "natureOfDeal", $$v)
      },
      expression: "client.moreAccount.natureOfDeal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeAddEditProductsModal
    }
  }, [_vm._v("\n          Close\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.addEditProduct
    }
  }, [_vm._v("\n          " + _vm._s((this.productAction === 'add' ? 'Add' : 'Save')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [(_vm.isQuoteEdit) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateQuoteModal()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.downloadMasterlistRpt()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel\n        ")], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-0",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px",
      "float": "right"
    },
    attrs: {
      "items": _vm.defaultYears,
      "label": "Year",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getMasterLists()
      }
    },
    model: {
      value: (_vm.selectedFilter.year),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "year", $$v)
      },
      expression: "selectedFilter.year"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.masterListSummary) ? _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Total Revenue Recognised - " + _vm._s(_vm.selectedFilter.year === 'All' ? '2024' : _vm.selectedFilter.year))]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.revRecon)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line pb-0"
  }, [_vm._v("Total Revenue for " + _vm._s(_vm.currentMonthYear) + " (Current Month)")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('h3', {
    staticClass: "pt-3 mb-1"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.revReconForMonth)))])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.openRecognizedRevenueModal
    }
  }, [_vm._v("\n            More Details\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Unallocated Revenues")]), _vm._v(" "), _c('v-card-text', [(_vm.selectedFilter.year === 'All') ? _c('h3', [_vm._v("-")]) : _c('h3', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.unRecon)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "172px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Active Deal")]), _vm._v(" "), _c('v-card-text', [(_vm.selectedFilter.year === 'All') ? _c('h3', [_vm._v("-")]) : _c('h3', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.masterListSummary.activeDealCt)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3 mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2",
      "md": "2",
      "lg": "2"
    }
  }, [(_vm.selectedLists.length > 0 && _vm.isSuperAdmin) ? _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.openActiveYearDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")]), _vm._v(" Update Active Year\n      ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "md": "10",
      "lg": "10"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "autocomplete-filter",
    attrs: {
      "items": _vm.saleUsers,
      "item-value": "id",
      "item-text": "firstName",
      "label": "Sale Person",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "salePerson", $$v)
      },
      expression: "selectedFilter.salePerson"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "autocomplete-filter",
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "firstName",
      "label": "AM",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "autocomplete-filter",
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "firstName",
      "label": "CC",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  }), _vm._v(" "), _c('v-menu', {
    ref: "quoteDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "autocomplete-filter",
          staticStyle: {
            "max-width": "250px"
          },
          attrs: {
            "label": "Quote Acceptance Date",
            "placeholder": "Quote Acceptance Date",
            "clearable": "",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          on: {
            "change": function($event) {
              return _vm.searchFilter()
            }
          },
          model: {
            value: (_vm.selectedFilter.acceptedMonth),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "acceptedMonth", $$v)
            },
            expression: "selectedFilter.acceptedMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.quoteDateCal),
      callback: function($$v) {
        _vm.quoteDateCal = $$v
      },
      expression: "quoteDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.acceptedMonth),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "acceptedMonth", $$v)
      },
      expression: "selectedFilter.acceptedMonth"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "master-lists-table elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "items-per-page": 15,
      "show-select": "",
      "single-select": false
    },
    on: {
      "current-items": _vm.getFiltered,
      "toggle-select-all": _vm.selectAllLists
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('div', {
            key: index,
            staticClass: "col-header-title"
          }, [_vm._v("\n          " + _vm._s(h.text) + "\n          "), (_vm.showLock(("" + (h.value) + (_vm.selectedFilter.year))) && _vm.isQuoteEdit) ? _c('v-btn', {
            attrs: {
              "x-small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(("" + (h.value) + (_vm.selectedFilter.year)), 'lock')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({}, on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-lock-open-variant")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Lock")])])], 1) : _vm._e(), _vm._v(" "), (_vm.showUnlock(("" + (h.value) + (_vm.selectedFilter.year))) && _vm.isQuoteEdit) ? _c('v-btn', {
            attrs: {
              "x-small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(("" + (h.value) + (_vm.selectedFilter.year)), 'unlock')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({}, on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-lock")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Unlock")])])], 1) : _vm._e()], 1)]
        }
      }
    }), {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "30px!important"
          }
        }, [(_vm.isQuoteEdit) ? _c('div', {
          staticClass: "w-100 pt-1",
          staticStyle: {
            "margin-right": "10px"
          }
        }, [(_vm.isPendingTimeline(item.quoteData)) ? _c('v-badge', {
          staticClass: "masterlist-badge",
          attrs: {
            "color": "success",
            "icon": "mdi-clock-outline",
            "x-small": "",
            "overlap": ""
          }
        }, [_c('v-btn', {
          staticClass: "btn-action",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFinanceEditDialog(item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": "Edit Quote",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" Edit Quote\n              ")], 1)], 1) : _c('v-btn', {
          staticClass: "btn-action",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFinanceEditDialog(item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Edit Quote",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" Edit Quote\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSalesEdit) ? _c('div', {
          staticClass: "w-100 pt-1 pb-2"
        }, [_c('v-btn', {
          staticClass: "btn-action",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "color": "green",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openSalesEditDialog(item)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" Update\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "w-100 pb-1"
        }, [_c('v-btn', {
          staticClass: "btn-action",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.refreshMasterList(item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat fa-xs"
        }), _vm._v("  Refresh\n            ")])], 1)])]
      }
    }, {
      key: "item.formattedAcceptanceDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.formattedAcceptanceDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(item.formattedAcceptanceDate)))]) : _vm._e()])]
      }
    }, {
      key: "item.salePersonName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.salePersonName) ? _c('span', [_vm._v(_vm._s(item.salePersonName))]) : _vm._e()])]
      }
    }, {
      key: "item.billingContactName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "custom-text-truncate"
              }, [_vm._v(_vm._s(item.billingContactDisplay.Name || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.billingContactDisplay.Name || '-'))])])], 1)]
      }
    }, {
      key: "item.quoteNo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.quoteNo) ? _c('div', [_vm._v(_vm._s(item.quoteNo))]) : _vm._e(), _vm._v(" "), (item.linkedIOs) ? _c('span', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))]) : _vm._e()])]
      }
    }, {
      key: "item.quoteAmt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.quoteAmt) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.quoteAmt)))]) : _vm._e()])]
      }
    }, {
      key: "item.invoiceSent",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.invoiceSent) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.invoiceSent)))]) : _vm._e()])]
      }
    }, {
      key: "item.invoiceCreated",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.invoiceCreated) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.invoiceCreated)))]) : _vm._e()])]
      }
    }, {
      key: "item.invoicePending",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.invoicePending) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.invoicePending)))]) : _vm._e()])]
      }
    }, {
      key: "item.verticals",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.vertical) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.displayVerticals(item.vertical)) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.campaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "200px!important"
          }
        }, [(item.campaignDisplays) ? _c('div', _vm._l((item.campaignDisplays), function(campaign, index) {
          return _c('div', {
            key: index
          }, [_c('v-chip', {
            staticClass: "campaign-name-chip",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "secondary"
            }
          }, [_vm._v("\n                " + _vm._s(campaign.name) + "\n              ")])], 1)
        }), 0) : _vm._e()])]
      }
    }, {
      key: "item.indicateCost",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.indicateCost) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.indicateCost)))]) : _vm._e()])]
      }
    }, {
      key: "item.AM",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.AM) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.displayUsers(item.AM)) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.CC",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.CC) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.displayUsers(item.CC)) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.startMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.startMonth)) + "\n        ")])]
      }
    }, {
      key: "item.endMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.formatMonth(item.endMonth)) + "\n        ")])]
      }
    }, {
      key: "item.totalMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "30px!important"
          }
        }, [_c('b', {
          staticClass: "custom-bold"
        }, [_vm._v(_vm._s(item.totalMonth))])])]
      }
    }, {
      key: "item.priorYear",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.priorYear) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.priorYear)))]) : _vm._e()])]
      }
    }, {
      key: "item.Jan",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Jan', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Jan) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Jan)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Jan')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Jan')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Feb",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Feb', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Feb) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Feb)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Feb')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Feb')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Mar",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Mar', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Mar) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Mar)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Mar')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Mar')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Apr",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Apr', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Apr) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Apr)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Apr')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Apr')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.May",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('May', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.May) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.May)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'May')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'May')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Jun",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Jun', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Jun) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Jun)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Jun')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Jun')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Jul",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Jul', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Jul) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Jul)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Jul')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Jul')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Aug",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Aug', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Aug) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Aug)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Aug')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Aug')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Sep",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Sep', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Sep) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Sep)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Sep')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Sep')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Oct",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Oct', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Oct) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Oct)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Oct')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Oct')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Nov",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Nov', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Nov) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Nov)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Nov')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Nov')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.Dec",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-start " + (_vm.getCellStatClr('Dec', item))),
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.Dec) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.Dec)))]) : _vm._e(), _vm._v(" "), (_vm.isAmtEdit && !_vm.isLockMonth(item, 'Dec')) ? _c('v-btn', {
          attrs: {
            "color": "warning btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDistributionEditModal(item, 'Dec')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.nextYear",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.nextYear) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.nextYear)))]) : _vm._e()])]
      }
    }, {
      key: "item.revenueYetRecognise",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.revenueYetRecognise) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.revenueYetRecognise)))]) : _vm._e()])]
      }
    }, {
      key: "item.unrecognisedRevenues",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.unrecognisedRevenues) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.unrecognisedRevenues)))]) : _vm._e()])]
      }
    }, {
      key: "item.accruedRevenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.accruedRevenue) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.accruedRevenue)))]) : _vm._e()])]
      }
    }, {
      key: "item.deferredRevenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.deferredRevenue) ? _c('b', {
          staticClass: "custom-bold"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.deferredRevenue)))]) : _vm._e()])]
      }
    }], null, true),
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.computedHeaders), function(item, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center"
    }, [(_vm.totalValues[item.value]) ? _c('v-chip', {
      staticClass: "summary-chip",
      attrs: {
        "small": "",
        "color": "primary",
        "text-color": "white"
      }
    }, [_c('v-icon', {
      staticClass: "mr-0",
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues[item.value])) + "\n            ")], 1) : _vm._e()], 1)
  })], 2)])], 2)], 1), _vm._v(" "), _c('create-quote-modal', {
    attrs: {
      "value": _vm.createQuoteDialog,
      "editData": _vm.editData,
      "saleUsers": _vm.saleUsers
    },
    on: {
      "created": _vm.reload
    },
    model: {
      value: (_vm.createQuoteDialog),
      callback: function($$v) {
        _vm.createQuoteDialog = $$v
      },
      expression: "createQuoteDialog"
    }
  }), _vm._v(" "), _c('sales-edit-modal', {
    attrs: {
      "value": _vm.salesEditDialog,
      "editData": _vm.editData
    },
    on: {
      "created": _vm.reload
    },
    model: {
      value: (_vm.salesEditDialog),
      callback: function($$v) {
        _vm.salesEditDialog = $$v
      },
      expression: "salesEditDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Masterlist",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.masterListSummary) ? _c('recognized-revenue-modal', {
    attrs: {
      "value": _vm.revRecognizedDialog,
      "monthYearValues": _vm.masterListSummary.revsForMonthYear,
      "selectedFilter": _vm.selectedFilter,
      "masterlists": _vm.masterLists,
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    model: {
      value: (_vm.revRecognizedDialog),
      callback: function($$v) {
        _vm.revRecognizedDialog = $$v
      },
      expression: "revRecognizedDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('active-year-modal', {
    attrs: {
      "value": _vm.activeYearDialog,
      "items": _vm.selectedLists
    },
    model: {
      value: (_vm.activeYearDialog),
      callback: function($$v) {
        _vm.activeYearDialog = $$v
      },
      expression: "activeYearDialog"
    }
  }), _vm._v(" "), _c('distribution-edit-modal', {
    attrs: {
      "value": _vm.distributionEditDialog,
      "editItem": _vm.editDistribution
    },
    on: {
      "updated": _vm.getMasterLists
    },
    model: {
      value: (_vm.distributionEditDialog),
      callback: function($$v) {
        _vm.distributionEditDialog = $$v
      },
      expression: "distributionEditDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Youtube Post Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "youtube-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15 report-summary-table",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "items-per-page": -1,
      "item-key": "key",
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": 'https://youtube.com/' + item.name,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.name))])], 1)]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                        View\n                      ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.views === 0 ? '-' : item.views)) + "\n                  ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n                  ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.new_engagement_rate === null ? '-' : item.new_engagement_rate + '%') + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.new_engagement_rate_view === null ? '-' : item.new_engagement_rate_view + '%') + "\n                  ")]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n                  ")]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.median_engagement_rate === null ? '-' : item.median_engagement_rate + '%') + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'url') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews === 0 ? '-' : _vm.totalViews)))] : (header.value === 'likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'comments') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'avg_views') ? [_vm._v("-")] : (header.value === 'avg_likes') ? [_vm._v("-")] : (header.value === 'avg_comments') ? [_vm._v("-")] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm.totalEngagementRate === 0 ? '-' : _vm.totalEngagementRate) + " %")] : (header.value === 'new_engagement_rate_view') ? [_vm._v(_vm._s(_vm.totalEngagementRateView === 0 ? '-' : _vm.totalEngagementRateView) + " %")] : (header.value === 'avg_engagement_rate') ? [_vm._v(" - ")] : (header.value === 'median_engagement_rate') ? [_vm._v(" - ")] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Youtube Post Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateYoutubeAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "max-width": "600px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Influencer Payout Verification")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body"
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Submitted By: ")]), _vm._v(" "), _c('p', [(_vm.payoutData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.payoutData.handle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.payoutData.handle) + "\n                  ")]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.payoutData.handle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.payoutData.handle) + "\n                  ")], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("For Campaign: ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.payoutData.campaignName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Submitted Date:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.payoutData.createdAt)))])]), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("To Make Payment:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.payoutData.toMakePaymentAt)) + " (" + _vm._s(_vm.calDaysLeft(_vm.payoutData.toMakePaymentAt)) + ")")])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Engagement Rate")]), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.influencerData.engagementRate * 100).toFixed(2)) + " %")])]) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.payoutData.platform === 'tiktok') ? _c('label', [_vm._v("TikTok Followers")]) : _c('label', [_vm._v("Instagram Followers")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.followers))])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Receiving Bank A/C No:")]), _vm._v(" "), _c('small', [_vm._v("(omit dashes)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.bankAccount))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Receiving A/C Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.fullName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Bank")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.bankName))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Mailing Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.influencerData.mailingAddress))])]), _vm._v(" "), (!_vm.showRequiredActions()) ? _c('v-flex', {
    staticClass: "mb-2 grey lighten-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [(_vm.moneyoutData.bankSwiftCode) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Bank Swift Code")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.bankSwiftCode ? _vm.moneyoutData.bankSwiftCode : '-'))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.BIBREF) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("BIB REF")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.BIBREF))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.FTREF) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("FT REF")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.FTREF))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.REF) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("REF")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.REF))])])]) : _vm._e(), _vm._v(" "), (_vm.moneyoutData.billingContact) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("Billing Contact")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.moneyoutData.billingContact))])])]) : _vm._e(), _vm._v(" "), (_vm.submissionData.payoutAmount) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('label', [_vm._v("Payout Amount")]), _vm._v(" "), _c('p', [_vm._v("$ "), _c('b', [_vm._v(_vm._s(_vm.submissionData.payoutAmount))])])]) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("How would you rate your overall experience with the client?")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "background-color": "grey",
      "color": "secondary",
      "size": "30",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.payoutData.satisfaction_level_on_advertiser),
      callback: function($$v) {
        _vm.$set(_vm.payoutData, "satisfaction_level_on_advertiser", $$v)
      },
      expression: "payoutData.satisfaction_level_on_advertiser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("How would you rate your overall experience with Kobe?")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "background-color": "grey",
      "color": "secondary",
      "size": "30",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.payoutData.satisfaction_level_on_kobe),
      callback: function($$v) {
        _vm.$set(_vm.payoutData, "satisfaction_level_on_kobe", $$v)
      },
      expression: "payoutData.satisfaction_level_on_kobe"
    }
  })], 1), _vm._v(" "), (_vm.payoutData.collaboration) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What do you like about this collaboration?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.collaboration)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payoutData.improved) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What are areas of improvement about this product/service that will be valuable feedback for them?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.improved)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payoutData.promotingProducts) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What do you like most about this product/service you are promoting?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.promotingProducts)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.payoutData.audienceEnjoyment) ? _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', [_vm._v("What do you think your audience enjoyed about your content?")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.payoutData.audienceEnjoyment)
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('small')], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Company name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.company.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.company.address))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Website")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.company.website))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.company.phoneNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          View company\n        ")])])
}]}

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.influencerItems,
      "items-per-page": _vm.itemsPerPage,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item, index) {
          return _c('tr', {
            key: item.instagramHandle
          }, [_c('td', [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.instagramFullname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalFollowers))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.toPercent(item.audienceCredibility)) + " %\n            "), _c('v-icon', {
            attrs: {
              "color": _vm.getCredibilityColor(item.audienceCredibility)
            }
          }, [_vm._v("supervised_user_circle")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagementRate) + " %")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id ? 'Registered on IMS' : 'Unregistered'))]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.showReport(item)
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({}, on), [_vm._v("assessment")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])])], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "info"
            },
            on: {
              "click": function($event) {
                return _vm.enterAmount(item, index)
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({}, on), [_vm._v("attach_money")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Enter payout amount")])])], 1)], 1)])
        }), 0)]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._v(" "), _c('view-influencer-modal', {
    attrs: {
      "influencerData": _vm.viewInfluencerData
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  })], 1), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getType() === 'v-img') ? _c('v-img', {
    staticClass: "elevation-2",
    attrs: {
      "src": _vm.media.URL,
      "width": _vm.media.width,
      "height": _vm.media.height
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "position-relative text-center"
  }, [(_vm.getType() === 'cld-image') ? _c('cld-image', {
    class: _vm.media.overlay ? 'overlay-main-img' : '',
    attrs: {
      "cloudName": _vm.cldConfig.CLOUD_NAME,
      "public-id": _vm.media.publicID,
      "width": _vm.media.width,
      "loading": _vm.media.trans.loading || ''
    }
  }, [_c('cld-transformation', {
    attrs: {
      "fetch-format": _vm.media.trans.fetchFormat || 'auto',
      "width": _vm.media.trans.width || 720,
      "crop": _vm.media.trans.crop || 'scale'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    staticClass: "overlay-img-area"
  }, [(_vm.getType() === 'cld-image') ? _c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  }) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.getType() === 'cld-video') ? _c('div', {
    class: (_vm.media.className) || ''
  }, [_c('div', [_c('video', {
    class: ("cld-video-player " + (_vm.media.postView ? 'post-view' : '') + " cld-fluid"),
    attrs: {
      "id": ("cld-player-" + (_vm.media.videoID)),
      "data-cld-public-id": _vm.media.publicID,
      "controls": ""
    }
  })]), _vm._v(" "), (_vm.media.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.checkURL(_vm.media.URL),
      "label": "Download"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    class: ("overlay-img-area " + (_vm.media.creatorView ? 'creator-view': '')),
    on: {
      "click": function($event) {
        return _vm.videoAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.getType() === 'native-image') ? _c('v-img', {
    staticClass: "custom-preview-img grey lighten-2",
    attrs: {
      "src": _vm.previewMedia
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    staticClass: "overlay-img-area"
  }, [(_vm.getType() === 'native-image') ? _c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  }) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getType() === 'native-video'),
      expression: "getType() === 'native-video'"
    }],
    class: (_vm.media.className) || ''
  }, [_c('div', {
    class: (_vm.media.vdoClassName) || ''
  }, [_c('video', {
    staticClass: "custom-preview-video",
    attrs: {
      "id": _vm.mediaFileName,
      "controls": ""
    }
  }, [_vm._v("             \n          Your browser does not support the video tag.\n      ")])]), _vm._v(" "), (_vm.media.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.checkURL(_vm.media.URL),
      "label": "Download"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    class: ("overlay-img-area " + (_vm.media.creatorView ? 'creator-view': '')),
    on: {
      "click": function($event) {
        return _vm.videoAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getType() === 's3-video'),
      expression: "getType() === 's3-video'"
    }],
    class: (_vm.media.className) || ''
  }, [_c('div', {
    class: (_vm.media.vdoClassName) || ''
  }, [_c('video', {
    staticClass: "custom-preview-video",
    attrs: {
      "id": _vm.mediaFileName,
      "src": _vm.media.URL,
      "controls": ""
    }
  }, [_vm._v("             \n          Your browser does not support the video tag.\n      ")])]), _vm._v(" "), (_vm.media.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.checkURL(_vm.media.URL),
      "label": "Download"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    class: ("overlay-img-area " + (_vm.media.creatorView ? 'creator-view': '')),
    on: {
      "click": function($event) {
        return _vm.videoAction()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.getType() === 's3-image') ? _c('div', [_c('v-img', {
    staticClass: "custom-preview-img grey lighten-2",
    attrs: {
      "src": _vm.media.URL
    }
  }), _vm._v(" "), (_vm.media.overlay) ? _c('div', {
    staticClass: "overlay-img-area"
  }, [_c('img', {
    attrs: {
      "src": _vm.getOverlayType()
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getType() === 'iframe') ? _c('iframe', {
    class: _vm.media.className || '',
    attrs: {
      "width": _vm.media.width,
      "height": _vm.media.height,
      "src": _vm.media.URL,
      "allow": "autoplay",
      "scrolling": "no",
      "seamless": "",
      "allowFullScreen": ""
    }
  }) : (_vm.getType() === 'driveCustomView') ? _c('gDrive-post-view', {
    attrs: {
      "url": _vm.media.URL,
      "darkTheme": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-cached\n        ")]), _vm._v("\n        Reload\n      ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel\n      ")], 1)], 1), _vm._v(" "), (_vm.showSummaryPerson || _vm.showFilterDate) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "sub-title ma-0 pa-0"
  }, [_vm._v("Score " + _vm._s(_vm.showSummaryPerson) + " " + _vm._s(_vm.showFilterDate) + " \n        ")])], 1) : _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "sub-title ma-0 pa-0"
  }, [_vm._v("\n        Score for Entire team\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("NPS Score")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.recommended))])])], 1)], 1), _vm._v(" "), (_vm.showCCBox) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Creator line up")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.creatorLineup))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCCBox) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Creator content created")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.contentCreated))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAMBox) ? _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("AM Score")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.amScore))])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_c('v-icon', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": "",
      "color": "secondary"
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _vm._v(" All points are calculated by 10\n    ")], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pl-0"
  }, [_c('v-col', {
    staticClass: "pb-0 pl-0",
    attrs: {
      "cols": "2"
    }
  }, [(_vm.isArchive) ? _c('div', [(_vm.selectedForms.length > 0) ? _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": _vm.restoreArchive
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-restore")]), _vm._v(" Restore\n            ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isArchive && _vm.isSuperAdmin) ? _c('div', [(_vm.selectedForms.length > 0) ? _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.archiveFeedbackForm
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-archive")]), _vm._v(" Archive\n            ")], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.NPSFilters,
      "item-value": "value",
      "item-text": "text",
      "label": "NPS Score",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.NPS),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "NPS", $$v)
      },
      expression: "selectedFilter.NPS"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CO,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CO),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CO", $$v)
      },
      expression: "selectedFilter.CO"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "submittedDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Month Range",
            "placeholder": "Month Range",
            "dense": "",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": ""
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.selectedFilter.submittedDate),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "submittedDate", $$v)
            },
            expression: "selectedFilter.submittedDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.submittedDateCal),
      callback: function($$v) {
        _vm.submittedDateCal = $$v
      },
      expression: "submittedDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": "",
      "range": ""
    },
    model: {
      value: (_vm.selectedFilter.submittedDate),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "submittedDate", $$v)
      },
      expression: "selectedFilter.submittedDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMonth()
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchMonthOk()
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.defaultYears,
      "label": "Year",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.year),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "year", $$v)
      },
      expression: "selectedFilter.year"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    ref: "feedbackForm",
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllForms,
      "current-items": _vm.currentItems
    },
    scopedSlots: _vm._u([{
      key: "item.likely_recommend",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_vm._v("\n              " + _vm._s(item.likely_recommend) + " / 10\n            ")])], 1)]
      }
    }, {
      key: "item.likely_consider_again",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_vm._v("\n              " + _vm._s(item.likely_consider_again) + " / 10\n            ")])], 1)]
      }
    }, {
      key: "item.infLineUpIdx",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_vm._v("\n              " + _vm._s(item.infLineUpIdx) + " / 4\n            ")])], 1)]
      }
    }, {
      key: "item.infContentCreatedIdx",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_vm._v("\n              " + _vm._s(item.infContentCreatedIdx) + " / 4\n            ")])], 1)]
      }
    }, {
      key: "item.amScore",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_vm._v("\n              " + _vm._s(item.amScore) + " / 12\n            ")])], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.getFeedbackDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign"
          }
        }, [_vm._v("remove_red_eye")])], 1)], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedForms),
      callback: function($$v) {
        _vm.selectedForms = $$v
      },
      expression: "selectedForms"
    }
  })], 1)], 1), _vm._v(" "), _c('view-feedback-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "feedbackData": _vm.viewFeedbackData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "150px"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    staticStyle: {
      "height": "100%",
      "min-width": "100px"
    },
    attrs: {
      "outlined": "",
      "flat": "",
      "tile": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-auto",
    attrs: {
      "dark": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": _vm.accept,
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "padding": "10px 30px 10px 30px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('draggable', {
    staticClass: "row align-center justify-center",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.media),
      callback: function($$v) {
        _vm.media = $$v
      },
      expression: "media"
    }
  }, _vm._l((_vm.media), function(img, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4",
        "md": "2",
        "lg": "2",
        "sm": "3"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(img.preview.thumbnail) ? _c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            },
            on: {
              "click": function($event) {
                return _vm.viewMedia(img)
              }
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1) : _c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": ""
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            staticStyle: {
              "max-height": "226px"
            },
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      }
    }, [_c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index, img)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    on: {
      "click:outside": _vm.modalClickOutSide
    },
    model: {
      value: (_vm.imageDialog),
      callback: function($$v) {
        _vm.imageDialog = $$v
      },
      expression: "imageDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mediaType === 'image') ? _c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.previewMedia
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mediaType === 'vdo') ? _c('video', {
    staticClass: "custom-preview-img",
    attrs: {
      "id": "postVdo",
      "controls": ""
    }
  }, [_vm._v("             \n            Your browser does not support the video tag.\n        ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n         Content Analysis\n        ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "data-dismiss": "modal"
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.igPost)
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [_c('p', {
    staticClass: "title text-center"
  }, [_vm._v("\n                  NLU (Natural Language Understanding) Result\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("\n                  Concepts\n                ")]), _vm._v(" "), (_vm.concepts.length <= 0) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n                  No Data\n                ")]) : _vm._e(), _vm._v(" "), _c('p', _vm._l((_vm.concepts), function(content) {
    return _c('v-chip', {
      key: content.id
    }, [_vm._v(_vm._s(content.text))])
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("\n                  Sentiment\n                ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-capitalize",
    attrs: {
      "id": "nlu_sentiment_label"
    }
  }, [_vm._v("Positive")]), _vm._v(" score of\n                 "), _c('span', {
    style: (_vm.sentimentScoreCss),
    attrs: {
      "id": "nlu_sentiment_score"
    }
  }, [_vm._v(_vm._s(_vm.sentiment))])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [_c('p', {
    staticClass: "title text-center"
  }, [_vm._v("\n                  Image Recognition Result\n                ")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "items": _vm.imageProcessingPagging.items,
      "fields": _vm.imageProcessingFields
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.imageProcessingPagging.totalRows,
      "per-page": _vm.imageProcessingPagging.perPage,
      "size": "sm",
      "align": "center"
    },
    model: {
      value: (_vm.imageProcessingPagging.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.imageProcessingPagging, "currentPage", $$v)
      },
      expression: "imageProcessingPagging.currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("OK")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Tell us why you reject this campaign to work on more relevant pairing in the future.")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "width": "90%"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "body-1",
    attrs: {
      "label": "The campaign proposed was not relevant to me.",
      "color": "primary",
      "value": "The campaign proposed was not relevant to me.",
      "error": _vm.errors,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.campaign_proposed),
      callback: function($$v) {
        _vm.campaign_proposed = $$v
      },
      expression: "campaign_proposed"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "I can't accommodate the campaign timeline.",
      "color": "primary",
      "value": "I can't accommodate the campaign timeline.",
      "error": _vm.errors,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.campaign_timeline),
      callback: function($$v) {
        _vm.campaign_timeline = $$v
      },
      expression: "campaign_timeline"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Payout is an issue",
      "hint": "",
      "error": _vm.errors,
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.payout_issue),
      callback: function($$v) {
        _vm.payout_issue = $$v
      },
      expression: "payout_issue"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "error": _vm.errors,
      "label": "I am doing a competitor brand",
      "value": "I am doing a competitor brand",
      "color": "primary",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.competitor),
      callback: function($$v) {
        _vm.competitor = $$v
      },
      expression: "competitor"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "error": _vm.errors,
      "label": "I do not associate with the brand.",
      "value": "I do not associate with the brand.",
      "color": "primary",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.not_associate),
      callback: function($$v) {
        _vm.not_associate = $$v
      },
      expression: "not_associate"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Others",
      "error": _vm.errors,
      "hint": "",
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        _vm.errors = false
      }
    },
    model: {
      value: (_vm.others),
      callback: function($$v) {
        _vm.others = $$v
      },
      expression: "others"
    }
  })], 1)], 1), _vm._v(" "), (_vm.errors) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(this.errorMessage) + " ")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info",
      "width": "150"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-minus-circle")]), _vm._v(" Cancel ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "error",
      "width": "150"
    },
    on: {
      "click": function($event) {
        return _vm.reject()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Reject ")], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payment/receipt record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.clients,
      "search-input": _vm.searchClient,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Supplier/Customer",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchClient = $event
      },
      "update:search-input": function($event) {
        _vm.searchClient = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchClient))]), _vm._v("\". Press\n                      "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payment.customer),
      callback: function($$v) {
        _vm.$set(_vm.payment, "customer", $$v)
      },
      expression: "payment.customer"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.filteredCampaigns,
      "search-input": _vm.searchCampaign,
      "hide-details": "auto",
      "label": "Campaign Name",
      "item-text": "name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchCampaign = $event
      },
      "update:search-input": function($event) {
        _vm.searchCampaign = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchCampaign))]), _vm._v("\". Press\n                      "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payment.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payment, "campaign", $$v)
      },
      expression: "payment.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reference No.",
      "placeholder": "2019001467",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.referenceNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "referenceNo", $$v)
      },
      expression: "payment.referenceNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "I/O Quote No.",
      "placeholder": "IO-2019001521",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.IOQuoteNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "IOQuoteNo", $$v)
      },
      expression: "payment.IOQuoteNo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Voucher No.",
      "placeholder": "RV2006002",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.voucherNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "voucherNo", $$v)
      },
      expression: "payment.voucherNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Invoice No.",
      "placeholder": "2019001521",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.invoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "invoiceNo", $$v)
      },
      expression: "payment.invoiceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "description",
      "dense": "",
      "hide-details": "auto",
      "label": "Description",
      "placeholder": "IO-2019001465 I Invoice 2019001467"
    },
    model: {
      value: (_vm.payment.description),
      callback: function($$v) {
        _vm.$set(_vm.payment, "description", $$v)
      },
      expression: "payment.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Debit",
      "placeholder": "3,000",
      "prefix": "$",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.debit),
      callback: function($$v) {
        _vm.$set(_vm.payment, "debit", $$v)
      },
      expression: "payment.debit"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Credit",
      "prefix": "$",
      "hide-details": "auto",
      "placeholder": "500",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.credit),
      callback: function($$v) {
        _vm.$set(_vm.payment, "credit", $$v)
      },
      expression: "payment.credit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "remark",
      "dense": "",
      "hide-details": "auto",
      "label": "Remarks",
      "placeholder": "Remarks"
    },
    model: {
      value: (_vm.payment.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payment, "remarks", $$v)
      },
      expression: "payment.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.sales,
      "search-input": _vm.searchSale,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Sale Person",
      "dense": "",
      "multiple": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchSale = $event
      },
      "update:search-input": function($event) {
        _vm.searchSale = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchSale))]), _vm._v("\". Press\n                      "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payment.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.payment, "salePerson", $$v)
      },
      expression: "payment.salePerson"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.payment.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.payment, "date", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.payment, "date", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Date",
            "prepend-inner-icon": "event",
            "outlined": "",
            "dense": "",
            "readonly": ""
          },
          model: {
            value: (_vm.payment.date),
            callback: function($$v) {
              _vm.$set(_vm.payment, "date", $$v)
            },
            expression: "payment.date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.pickDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.pickDate.save(_vm.payment.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.$v.payment.$invalid,
      "text": ""
    },
    on: {
      "click": _vm.doAction
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.methods,
      "outlined": "",
      "label": "Select method"
    },
    model: {
      value: (_vm.method),
      callback: function($$v) {
        _vm.method = $$v
      },
      expression: "method"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "URL",
      "outlined": "",
      "placeholder": "URL"
    },
    model: {
      value: (_vm.url),
      callback: function($$v) {
        _vm.url = $$v
      },
      expression: "url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h3', [_vm._v("Header options")]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('v-row', {
      key: header.key
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-text-field', {
      attrs: {
        "outlined": "",
        "hide-details": "",
        "label": "Name",
        "placeholder": "Name"
      },
      model: {
        value: (header.key),
        callback: function($$v) {
          _vm.$set(header, "key", $$v)
        },
        expression: "header.key"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "outlined": "",
        "hide-details": "",
        "label": "Value",
        "placeholder": "Value"
      },
      model: {
        value: (header.value),
        callback: function($$v) {
          _vm.$set(header, "value", $$v)
        },
        expression: "header.value"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.removeHeader(index)
        }
      }
    }, [_vm._v("Remove")])], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.addHeader()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "input-7-1",
      "label": "Body"
    },
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.testAPI
    }
  }, [_vm._v("Send Request")])], 1)], 1)], 2), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', [_c('v-col', [_c('v-alert', {
    attrs: {
      "type": _vm.response.type
    }
  }, [_vm._v(_vm._s(_vm.response.text))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "input-7-1",
      "label": "Response",
      "readonly": ""
    },
    model: {
      value: (_vm.response.data),
      callback: function($$v) {
        _vm.$set(_vm.response, "data", $$v)
      },
      expression: "response.data"
    }
  })], 1)], 1)], 1)], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('h3', [_vm._v("API Testing")])])])
}]}

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payout record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "error-messages": _vm.selectedCampaignErrors,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Campaign Name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.clients,
      "search-input": _vm.searchClient,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Client",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchClient = $event
      },
      "update:search-input": function($event) {
        _vm.searchClient = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchClient))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.client),
      callback: function($$v) {
        _vm.$set(_vm.payout, "client", $$v)
      },
      expression: "payout.client"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Receiving Bank A/C No.",
      "placeholder": "Receiving Bank A/C No.(omit dashes)",
      "error-messages": _vm.bankNoErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankAccountNo),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankAccountNo", $$v)
      },
      expression: "payout.bankAccountNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Receiving A/C Name",
      "placeholder": "Receiving A/C Name.",
      "error-messages": _vm.receivingNameErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      }
    },
    model: {
      value: (_vm.payout.receivingName),
      callback: function($$v) {
        _vm.$set(_vm.payout, "receivingName", $$v)
      },
      expression: "payout.receivingName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Swift Code",
      "hide-details": "",
      "placeholder": "RABONL2U",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.bankSwiftCode),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankSwiftCode", $$v)
      },
      expression: "payout.bankSwiftCode"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.statuses,
      "hide-details": "auto",
      "label": "Status",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.status),
      callback: function($$v) {
        _vm.$set(_vm.payout, "status", $$v)
      },
      expression: "payout.status"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Instagram Handle",
      "hide-details": "auto",
      "error-messages": _vm.instagramHandleErrors,
      "placeholder": "Instagram Handle",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.instagramHandle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.instagramHandle.$touch()
      }
    },
    model: {
      value: (_vm.payout.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "instagramHandle", $$v)
      },
      expression: "payout.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.userCs,
      "min-height": "30px",
      "multiple": "",
      "item-text": "name",
      "hide-details": "auto",
      "dense": "",
      "search-input": _vm.searchCs,
      "label": "CS Name",
      "outlined": "",
      "small-chips": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchCs = $event
      },
      "update:search-input": function($event) {
        _vm.searchCs = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchCs))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.cs),
      callback: function($$v) {
        _vm.$set(_vm.payout, "cs", $$v)
      },
      expression: "payout.cs"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "BIB REF",
      "placeholder": "BK19010043050112",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.BIBREF),
      callback: function($$v) {
        _vm.$set(_vm.payout, "BIBREF", $$v)
      },
      expression: "payout.BIBREF"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "FT REF",
      "hide-details": "auto",
      "placeholder": "FT19010043050143",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.FTREF),
      callback: function($$v) {
        _vm.$set(_vm.payout, "FTREF", $$v)
      },
      expression: "payout.FTREF"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "REF",
      "hide-details": "auto",
      "placeholder": "KOBE-AN-KW",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.REF),
      callback: function($$v) {
        _vm.$set(_vm.payout, "REF", $$v)
      },
      expression: "payout.REF"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Billing Contact",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.billingContact),
      callback: function($$v) {
        _vm.$set(_vm.payout, "billingContact", $$v)
      },
      expression: "payout.billingContact"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "error-messages": _vm.amountErrors,
      "placeholder": "300",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Approval Date *",
            "prepend-inner-icon": "event",
            "outlined": "",
            "dense": "",
            "readonly": ""
          },
          model: {
            value: (_vm.payout.approvalDate),
            callback: function($$v) {
              _vm.$set(_vm.payout, "approvalDate", $$v)
            },
            expression: "payout.approvalDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.pickDate = false
      }
    },
    model: {
      value: (_vm.payout.approvalDate),
      callback: function($$v) {
        _vm.$set(_vm.payout, "approvalDate", $$v)
      },
      expression: "payout.approvalDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.$v.payout.$invalid,
      "text": ""
    },
    on: {
      "click": _vm.doAction
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activePairingData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("For your internal communication only, neither Kobe nor the creators would have access to these notes")]), _vm._v(" "), _c('v-card-text', [(_vm.activePairingData.platform && _vm.activePairingData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.activePairingData.instagramHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.activePairingData.instagramHandle))]) : _c('a', {
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.activePairingData.instagramHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.activePairingData.instagramHandle))], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2"
  }, [(_vm.isClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "notes",
      "label": "",
      "hide-details": "",
      "value": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.activePairingData.notes.$touch()
      }
    },
    model: {
      value: (_vm.activePairingData.notes),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "notes", $$v)
      },
      expression: "activePairingData.notes"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.activePairingData.clientNotes.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "max-height": "300px"
    }
  }, [(_vm.activePairingData.clientNotes.length > 0) ? _c('v-card-text', {
    staticClass: "mt-0 pt-0"
  }, _vm._l((_vm.activePairingData.clientNotes), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('v-row', [_c('v-col', [_c('p', {
      staticClass: "body-2 font-weight-bold"
    }, [_vm._v(_vm._s(msg.author ? msg.author.name : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right"
    }, [(_vm.showAction(msg)) ? _c('v-btn', {
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Delete Note",
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteNote(_vm.fileIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white",
        "small": ""
      }
    }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('p', {
      staticClass: "body-1 font-weight-medium"
    }, [_vm._v(_vm._s(msg.notes))]), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.formatTime(msg.timestamp)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0) : _c('v-card-text', [_c('p', {
    staticClass: "body-1 font-weight-bold"
  }, [_vm._v("\n                No Internal Notes\n              ")])])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.isClientRole) ? _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNote()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "transition": "fade-transition",
      "fullscreen": "",
      "no-click-animation": "",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    staticClass: "pairing-modal-toolbar",
    attrs: {
      "color": "#3F3FFF",
      "dark": "",
      "elevation": 1
    }
  }, [_c('v-toolbar-title', {
    staticClass: "pairing-modal-title-wrap"
  }, [_c('h3', {
    staticClass: "text-xs-center white--text pairing-modal-title",
    staticStyle: {
      "font-size": "1.25rem"
    }
  }, [_vm._v("\n                Pair influencers for campaign:\n                "), _c('strong', [_vm._v(_vm._s(_vm.campaign.name))])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pairing-modal-close",
    attrs: {
      "icon": "",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-content ims-modal-body"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaign.min_content) + " to " + _vm._s(_vm.campaign.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaign.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("COGS")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Capped : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _vm._l((_vm.currencyTotals), function(item, index) {
          return _c('span', {
            key: index
          }, [(index !== 'SGD' && item) ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("Total " + _vm._s(index) + ": " + _vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))]) : _vm._e()])
        }), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])], 2)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-col', {
    staticClass: "col-md-12 col-xs-12",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('h3', {
    staticClass: "mr-5 pa-2 pt-1"
  }, [_vm._v("Add Creators")]), _vm._v(" "), _c('v-select', {
    staticClass: "mt-3",
    staticStyle: {
      "max-width": "250px",
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.searchMethods,
      "outlined": "",
      "attach": ""
    },
    model: {
      value: (_vm.searchType),
      callback: function($$v) {
        _vm.searchType = $$v
      },
      expression: "searchType"
    }
  }), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-text-field', {
    staticClass: "mt-3 pr-2",
    attrs: {
      "label": _vm.searchInfluencer === 'Youtube' ? 'Enter Handle' : 'Enter handle',
      "hide-details": "",
      "outlined": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchManually(_vm.searchType)
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-select', {
    staticClass: "mt-3 mr-2",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.searchInfluencerTypes,
      "item-text": "text",
      "item-value": "value",
      "outlined": "",
      "attach": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.imgIcon) ? _c('img', {
          staticClass: "mr-2",
          style: (item.iconFilter ? ("filter: " + (item.iconFilter) + " !important;") : ''),
          attrs: {
            "src": item.imgIcon,
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _c('v-icon', {
          staticClass: "mr-2",
          style: (("color: " + (item.iconColor) + " !important;")),
          attrs: {
            "size": "20"
          }
        }, [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [(item.imgIcon) ? _c('img', {
          staticClass: "mr-2",
          style: (item.iconFilter ? ("filter: " + (item.iconFilter) + " !important;") : ''),
          attrs: {
            "src": item.imgIcon,
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _c('v-icon', {
          staticClass: "mr-2",
          style: (("color: " + (item.iconColor) + " !important;")),
          attrs: {
            "size": "20"
          }
        }, [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])]
      }
    }], null, false, 1476219676),
    model: {
      value: (_vm.searchInfluencer),
      callback: function($$v) {
        _vm.searchInfluencer = $$v
      },
      expression: "searchInfluencer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE && _vm.searchInfluencer === 'Others') ? _c('v-text-field', {
    staticClass: "mt-3 mr-2 pl-2",
    attrs: {
      "label": "Enter Platform Name",
      "hide-details": "",
      "outlined": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchManually(_vm.searchType)
      }
    },
    model: {
      value: (_vm.platformName),
      callback: function($$v) {
        _vm.platformName = $$v
      },
      expression: "platformName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('k-influencer-search-box', {
    attrs: {
      "search": _vm.searchKeywordAction
    },
    on: {
      "result": _vm.resultFromSearchKeyword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('v-btn', {
    staticClass: "mt-5 mr-2",
    staticStyle: {
      "min-height": "40px"
    },
    attrs: {
      "disabled": !_vm.historySearchResult,
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showResult(_vm.historySearchResult)
      }
    }
  }, [_vm._v("View results")]) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "secondary",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.igBulkHandle.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-home-import-outline")]), _vm._v("Import Excel\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "color": "secondary",
      "large": ""
    },
    on: {
      "click": _vm.downloadSampleUpload
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v("Download Sample Import\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.searchType !== _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "mt-5",
    staticStyle: {
      "min-width": "150px",
      "min-height": "40px"
    },
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchManually(_vm.searchType)
      }
    }
  }, [_vm._v("ADD")]) : _vm._e()], 1), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pairing-control-row",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pairing-primary-controls",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "pairing-toolbar-actions"
  }, [(_vm.disableLockedCOGS) ? _c('v-chip', {
    staticClass: "pairing-toolbar-chip",
    attrs: {
      "color": "error"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS\n                    ")], 1) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openLockedCOGSDialog(_vm.campaign)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Request Unlock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaign, false)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Unlock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.showLockBtn) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaign, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock")]), _vm._v(" Lock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.items && _vm.items.length > 0) ? _c('download-excel', {
    staticClass: "download-excel-secondary pairing-toolbar-download",
    attrs: {
      "data": _vm.items,
      "fields": _vm.json_fields,
      "worksheet": "Predicted price",
      "name": "pairing.xls"
    }
  }, [_vm._v("Download Excel")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "pairing-toolbar-btn",
          attrs: {
            "small": "",
            "color": "secondary",
            "disabled": _vm.actionSelected.length === 0 || _vm.disableLockedCOGS
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-format-list-bulleted")]), _vm._v("\n                        Bulk Action\n                        "), (_vm.actionSelected.length) ? _c('span', {
          staticClass: "ml-1"
        }, [_vm._v("(" + _vm._s(_vm.actionSelected.length) + ")")]) : _vm._e(), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": "",
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pairing-bulk-action-menu",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.changeBulkPairingStatus(_vm.pairingStatus.ACCEPTED.value)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Accept")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.changeBulkPairingStatus(_vm.pairingStatus.NOT_ACCEPTED.value)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_vm._v("mdi-close-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Not Accept")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openDeliverableUpdateDialog()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-pencil-box-multiple")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Update Deliverables")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveOption(0)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-bold-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move to Option A")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveOption(1)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-right-bold-circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move to Option B")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveAllOption(0)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-collapse-left")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move All to Option A")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.moveAllOption(1)
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("mdi-arrow-collapse-right")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Move All to Option B")])], 1)], 1)], 1), _vm._v(" "), (!_vm.disableSaveLineUp) ? _c('v-btn', {
    staticClass: "pairing-toolbar-btn",
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.saveLineUp
    }
  }, [_vm._v("Save LineUp")]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.disableSaveEdit) ? _c('v-col', {
    staticClass: "pairing-search-controls",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [(!_vm.disableSaveEdit) ? _c('div', {
    staticClass: "pairing-edit-actions"
  }, [_c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.saveEditingData
    }
  }, [_vm._v("Save Changes")])], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0 pairing-filter-row"
  }, [_c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8",
      "lg": "8"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "70px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1",
      "align": "right"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n                          Filters:\n                        ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filterPairingStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "label": "Pairing Status",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.pairingStatusOnChangeHandler
    },
    model: {
      value: (_vm.searchPairingStatus),
      callback: function($$v) {
        _vm.searchPairingStatus = $$v
      },
      expression: "searchPairingStatus"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.genderItems,
      "label": "Gender",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.genderOnChangeHandler
    },
    model: {
      value: (_vm.searchGender),
      callback: function($$v) {
        _vm.searchGender = $$v
      },
      expression: "searchGender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.ageItems,
      "label": "Age Group",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.ageOnChangeHandler
    },
    model: {
      value: (_vm.searchAge),
      callback: function($$v) {
        _vm.searchAge = $$v
      },
      expression: "searchAge"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.locationItems,
      "label": "Location",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.countryOnChangeHandler
    },
    model: {
      value: (_vm.searchLocation),
      callback: function($$v) {
        _vm.searchLocation = $$v
      },
      expression: "searchLocation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.audCrediblityFilters,
      "item-text": "name",
      "label": "Audience Cred.",
      "dense": "",
      "solo": "",
      "attach": ""
    },
    on: {
      "change": _vm.pairingStatusOnChangeHandler
    },
    model: {
      value: (_vm.searchAudCrediblity),
      callback: function($$v) {
        _vm.searchAudCrediblity = $$v
      },
      expression: "searchAudCrediblity"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "92px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), (this.campaign.pairingDisplayStatus) ? _c('v-col', {
    staticClass: "pairing-table-tools",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "pairing-table-search",
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  }), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-pairing",
    staticStyle: {
      "max-height": "500px",
      "min-height": "500px"
    },
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "max-height": "500px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-3",
          attrs: {
            "icon": "",
            "color": "secondary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
      }
    }], null, false, 1822390752)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.showHideFields), function(field, index) {
    return _c('v-list-item', {
      key: index
    }, [_c('v-checkbox', {
      attrs: {
        "label": field.label,
        "color": "secondary",
        "true-value": true,
        "false-value": false,
        "hide-details": ""
      },
      on: {
        "change": _vm.updatePairingDisplayStatus
      },
      model: {
        value: (_vm.campaign.pairingDisplayStatus[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.campaign.pairingDisplayStatus, field.name, $$v)
        },
        expression: "campaign.pairingDisplayStatus[field.name]"
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "icon": "",
      "color": "secondary",
      "title": _vm.showFrozenPairingColumns ? 'Hide frozen columns' : 'Show frozen columns',
      "aria-label": _vm.showFrozenPairingColumns ? 'Hide frozen columns' : 'Show frozen columns',
      "aria-pressed": String(_vm.showFrozenPairingColumns)
    },
    on: {
      "click": function($event) {
        _vm.showFrozenPairingColumns = !_vm.showFrozenPairingColumns
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showFrozenPairingColumns ? 'mdi-eye-off-outline' : 'mdi-eye-outline'))])], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 page__table pairing-freeze-table",
    class: {
      'pairing-freeze-active': _vm.showFrozenPairingColumns && _vm.displayFields('AIPayout') && _vm.displayFields('payout') && _vm.displayFields('pairingStatus')
    },
    attrs: {
      "headers": _vm.filteredHeaders,
      "items": _vm.items,
      "item-key": "dataTableKey",
      "search": _vm.searchFilter,
      "items-per-page": 20,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false,
      "mobile-breakpoint": 0
    },
    on: {
      "update:page": _vm.updatePagination,
      "toggle-select-all": _vm.selectAllPairings
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('draggable', {
          attrs: {
            "list": props.items,
            "tag": "tbody"
          },
          on: {
            "update": function($event) {
              return _vm.handleTableUpdate(props.items)
            }
          }
        }, _vm._l((props.items), function(item, parentIndex) {
          return _c('tr', {
            key: item.instagram,
            class: {
              'danger': (!item.success || item.eliminationStatus === _vm.eliminationStatus.ELIMINATED) && !item.isLoading
            }
          }, [_c('td', {
            staticStyle: {
              "min-width": "100px",
              "padding": "0 14px!important"
            }
          }, [_c('v-icon', {
            staticClass: "move-cursor",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                              mdi-arrow-all\n                            ")]), _vm._v(" "), (item.isLoading) ? _c('v-progress-circular', {
            attrs: {
              "width": 2,
              "color": "green",
              "indeterminate": ""
            }
          }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
            staticClass: "multi-select-checkbox",
            attrs: {
              "label": "",
              "color": "grey darken-2",
              "disabled": item.payoutStatus == _vm.payoutStatus.CONFIRMED
            },
            on: {
              "change": _vm.actionSelectChange
            },
            model: {
              value: (item.isDelete),
              callback: function($$v) {
                _vm.$set(item, "isDelete", $$v)
              },
              expression: "item.isDelete"
            }
          }), _vm._v(" "), (item.platform !== 'others') ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "btn-reload",
                  attrs: {
                    "text": "",
                    "x-small": "",
                    "color": "secondary"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.executeMethod('refresh', item)
                    }
                  }
                }, on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                                    mdi-reload\n                                  ")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Click to refresh data")])]) : _vm._e()], 1), _vm._v(" "), (_vm.displayFields('lastReportDate')) ? _c('td', {
            staticStyle: {
              "min-width": "150px",
              "max-width": "150px"
            },
            attrs: {
              "align": "center"
            }
          }, [(item.lastReportDate) ? _c('span', [_vm._v(_vm._s(_vm.utilsFunc.formatCustomDate(item.lastReportDate, 'DD/MM/YYYY')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('influencer')) ? _c('td', {
            staticStyle: {
              "min-width": "200px",
              "max-width": "200px"
            },
            attrs: {
              "align": "left"
            }
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isFacebook": item.platform === 'facebook',
              "isLinkedIn": item.platform === 'linkedin',
              "isTwitter": item.platform === 'twitter',
              "isYoutube": item.platform === 'youtube',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.userHandle,
              "instagramHandle": item.userHandle,
              "facebookHandle": item.userHandle,
              "linkedinHandle": item.userHandle,
              "twitterHandle": item.userHandle,
              "youtubeHandle": item.userHandle,
              "xiaohongshuHandle": item.xhsID,
              "xiaohongshuFullName": item.fullName,
              "youtubeURL": item.url,
              "otherHandle": item.userHandle
            }
          }), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            staticStyle: {
              "max-height": "500px"
            },
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "text": "",
                    "color": "secondary"
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "secondary",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(item.userHandle, obj.handle, obj.platform, item.pairingID)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              staticStyle: {
                "filter": "invert(27%) sepia(87%) saturate(4714%) hue-rotate(340deg) brightness(103%) contrast(103%) !important"
              },
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#1877F2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.linkedin) ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#0A66C2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.twitter) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "X (Twitter)"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#FF0000 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#E1306C !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (!item.isLoading && item.influencerID && item.isPlatformConnected !== false) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && item.influencerID && item.isPlatformConnected === false) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Platform handle disconnected")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && !item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e(), _vm._v(" "), (item.socialDataErrMessage) ? _c('p', {
            staticClass: "text-danger mb-0"
          }, [_vm._v("(" + _vm._s(item.socialDataErrMessage) + ")")]) : _vm._e(), _vm._v(" "), (_vm.checkReportDate(item.lastReportDate)) ? _c('p', {
            staticClass: "caption caption-text ma-0",
            staticStyle: {
              "font-size": "12px"
            }
          }, [_vm._v("(Last date is over 6 months. Please refresh data)")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.platformNameEdit === false && _vm.displayFields('platformName')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'platformName')
              }
            }
          }, [_c('p', [_vm._v(_vm._s(_vm._f("platformDisplayName")(item.platformName)))]), _vm._v(" "), (!item.platformNameEdit && item.platform === 'others') ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Platform"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('platformNameEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.platformNameEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-text-field', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.platformName),
              callback: function($$v) {
                _vm.$set(item, "platformName", $$v)
              },
              expression: "item.platformName"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'platformName')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('platformNameEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === false && _vm.displayFields('remark')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'remark')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": "",
              "max-width": "300px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_c('p', {
                  staticClass: "remark-text"
                }, [_vm._v(_vm._s(item.remarks || '-'))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.renderRemark(item.remarks))
            }
          })])], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-textarea', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.remarks),
              callback: function($$v) {
                _vm.$set(item, "remarks", $$v)
              },
              expression: "item.remarks"
            }
          })], 1) : _vm._e(), _vm._v(" "), (item.contentFeatureEdit === false && _vm.displayFields('contentFeature')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'contentFeature')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": "",
              "max-width": "300px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_c('p', {
                  staticClass: "remark-text"
                }, [_vm._v(_vm._s(item.contentFeature || '-'))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.renderRemark(item.contentFeature))
            }
          })])], 1) : _vm._e(), _vm._v(" "), (item.contentFeatureEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-textarea', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.contentFeature),
              callback: function($$v) {
                _vm.$set(item, "contentFeature", $$v)
              },
              expression: "item.contentFeature"
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('gender')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.genderEdit) ? _c('div', {
            staticClass: "d-flex flex-row pa-2"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "100px",
              "max-width": "100px"
            },
            attrs: {
              "items": _vm.genders,
              "dense": "",
              "hide-details": ""
            },
            model: {
              value: (item.gender),
              callback: function($$v) {
                _vm.$set(item, "gender", $$v)
              },
              expression: "item.gender"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'gender')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('genderEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.genderEdit) ? _c('div', [(!item.genderEdit) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.gender || '-'))]) : _vm._e(), _vm._v(" "), (!item.genderEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Gender"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('genderEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('ageGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.ageGroupEdit) ? _c('div', {
            staticClass: "d-flex flex-row pa-2"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "100px",
              "max-width": "100px"
            },
            attrs: {
              "items": _vm.ageGroups,
              "dense": "",
              "hide-details": ""
            },
            model: {
              value: (item.age_group),
              callback: function($$v) {
                _vm.$set(item, "age_group", $$v)
              },
              expression: "item.age_group"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'age_group')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('ageGroupEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.ageGroupEdit) ? _c('div', [_c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.age_group || '-'))]), _vm._v(" "), (!item.ageGroupEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Age Group"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('ageGroupEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audAgeGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', [(item.audAgesEdit) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "120px",
              "max-width": "320px"
            },
            attrs: {
              "items": _vm.ageGroups,
              "item-text": "code",
              "item-value": "code",
              "hide-details": "",
              "dense": "",
              "multiple": ""
            },
            on: {
              "change": function($event) {
                return _vm.checkSelectLimit(item, 'topAudAges')
              }
            },
            model: {
              value: (item.topAudAges),
              callback: function($$v) {
                _vm.$set(item, "topAudAges", $$v)
              },
              expression: "item.topAudAges"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'topAudAges')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audAgesEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), ((!item.audAges || (Array.isArray(item.audAges) && item.audAges.length === 0)) && (!item.topAudAges || (Array.isArray(item.topAudAges) && item.topAudAges.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.audAges) && Array.isArray(item.topAudAges)) ? _c('div', [((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit) ? _c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit),
                    expression: "(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "text": "",
                    "color": "secondary"
                  }
                }, 'v-btn', attrs, false), on), [(item.topAudAges && item.topAudAges.length) ? _c('span', [_vm._v("\n                                        " + _vm._s(item.topAudAges ? item.topAudAges[0] : '-') + "\n                                      ")]) : _c('span', [_vm._v("\n                                        " + _vm._s(item.audAges.length ? item.audAges[0].code : '-') + "\n                                      ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Age Group (Majority)")]), _vm._v(" "), (item.audAgesDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.audAgesDisplay), function(audAge, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(audAge.code))]), _vm._v(" "), (audAge.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((audAge.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audAges), function(age, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(age.code))]), _vm._v(" "), _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((age.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.audAgesEdit) ? _c('div', [(!item.audAgesEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Aud. Age Group"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audAgesEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('country')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.audCountryEdit) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "120px",
              "max-width": "320px"
            },
            attrs: {
              "items": _vm.locationItems,
              "item-text": "name",
              "item-value": "name",
              "hide-details": "",
              "dense": "",
              "multiple": ""
            },
            on: {
              "change": function($event) {
                return _vm.checkSelectLimit(item, 'topCountries')
              }
            },
            model: {
              value: (item.topCountries),
              callback: function($$v) {
                _vm.$set(item, "topCountries", $$v)
              },
              expression: "item.topCountries"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'topCountries')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audCountryEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), ((!item.countries || (Array.isArray(item.countries) && item.countries.length === 0)) && (!item.topCountries || (Array.isArray(item.topCountries) && item.topCountries.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.countries) && Array.isArray(item.topCountries)) ? _c('div', [_c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
              expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
                    expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "text": "",
                    "color": "secondary"
                  }
                }, 'v-btn', attrs, false), on), [(item.topCountries && item.topCountries.length) ? _c('span', [_vm._v("\n                                      " + _vm._s(item.topCountries ? item.topCountries[0] : '-') + "\n                                    ")]) : _c('span', [_vm._v("\n                                      " + _vm._s(item.countries.length ? item.countries[0].name : '-') + "\n                                    ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Country (Majority)")]), _vm._v(" "), (item.topCountryDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.topCountryDisplay), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.countries), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.audCountryEdit) ? _c('div', [(!item.audCountryEdit) ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Aud. Country"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audCountryEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('followers')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.followersEdit) ? _c('div', {
            staticClass: "d-flex flex-row pa-2"
          }, [_c('v-text-field', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%",
              "min-width": "150px"
            },
            attrs: {
              "type": "number",
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.followers),
              callback: function($$v) {
                _vm.$set(item, "followers", $$v)
              },
              expression: "item.followers"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row mt-2"
          }, [_c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'followers')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "error",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('followersEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.followersEdit) ? _c('div', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.followers ? _vm.formatNumber(item.followers) : '-'))]), _vm._v(" "), (!item.followersEdit && item.platform === 'others') ? _c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "color": "secondary",
              "title": "Edit Followers"
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('followersEdit', item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('genderPercentage')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticStyle: {
              "width": "75px"
            }
          }, [(item.audience_genders && item.audience_genders.length > 0 && _vm.showPie) ? _c('PieChart', {
            attrs: {
              "name": ("genderPie" + parentIndex),
              "title": _vm.genderPie.title,
              "labels": _vm.genderPie.labels,
              "backgroundColors": _vm.genderPie.backgroundColors,
              "items": item.audience_genders,
              "options": _vm.genderPie.options,
              "width": _vm.genderPie.width,
              "height": _vm.genderPie.height
            }
          }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audienceCred')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": "",
              "color": item.audience_credibility_color,
              "text-color": "white"
            }
          }, [_vm._v(_vm._s(item.audience_credibility) + "%")]), _vm._v(" "), (item.message) ? _c('span', {
            staticClass: "text-danger"
          }, [_vm._v("(" + _vm._s(item.message) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgLikes')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_likes ? _vm.formatNumber(item.avg_likes) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgComments')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_comments ? _vm.formatNumber(item.avg_comments) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgReelsPlays')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_reels_plays ? _vm.formatNumber(item.avg_reels_plays) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgViews')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_views ? _vm.formatNumber(item.avg_views) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgSaves')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_saves ? _vm.formatNumber(item.avg_saves) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgShares')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_shares ? _vm.formatNumber(item.avg_shares) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('medianEngagementRate')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.median_engagement_rate ? ((item.median_engagement_rate) + "%") : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('infInterests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.infInterests || item.infInterests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.infInterests),
              expression: "item.infInterests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.infInterests && item.infInterests.length > 0),
                    expression: "item.infInterests && item.infInterests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + item.id,
                    "color": "secondary",
                    "x-small": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                  More...\n                                ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Influencer Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index !== 0),
                expression: "index !== 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('interests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.audience_interests || item.audience_interests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.audience_interests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.audience_interests),
              expression: "item.audience_interests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.audience_interests && item.audience_interests.length > 0),
                    expression: "item.audience_interests && item.audience_interests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "color": "secondary",
                    "x-small": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                    More...\n                                  ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Audience Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audience_interests), function(interest, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))]), _vm._v(" "), _c('span', {
              staticStyle: {}
            }, [_vm._v("(" + _vm._s((interest.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('engagement')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.engagement_rate && item.engagement_rate !== '0.00') ? _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")]) : (item.engagement_rate === '0.00') ? _c('span', {
            staticClass: "caption"
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Hidden"
            }
          }, [_vm._v("mdi-eye-off")])], 1) : _c('span', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.displayFields('rateCard')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-hover', {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function(ref) {
                var hover = ref.hover;

                return [(item.rateCard) ? _c('v-chip', {
                  staticClass: "ma-2",
                  class: {
                    'on-hover': hover
                  },
                  attrs: {
                    "color": "primary",
                    "x-small": "",
                    "text-color": "white",
                    "elevation": hover ? 12 : 2
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openRateCardView(item.rateCard)
                    }
                  }
                }, [_vm._v("\n                                View Details\n                              ")]) : _vm._e()]
              }
            }], null, true)
          }), _vm._v(" "), (item.rateCard) ? _c('div', {
            staticStyle: {
              "font-size": "13px"
            }
          }, [_vm._v("\n                              (" + _vm._s(_vm.formatUploadedDate(item.rateCard.createdAt)) + ")\n                            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('eliminationStatus')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.eliminationStatus === _vm.eliminationStatus.NEW) ? _c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "primary",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                              New\n                              "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("new_releases")])], 1) : _vm._e(), _vm._v(" "), (item.eliminationStatus === _vm.eliminationStatus.PENDING) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-chip', _vm._g({
                  staticClass: "ma-2",
                  attrs: {
                    "color": "primary",
                    "x-small": "",
                    "text-color": "white"
                  }
                }, on), [_vm._v("\n                                  Pending Client\n                                  "), _c('v-icon', {
                  attrs: {
                    "right": "",
                    "x-small": ""
                  }
                }, [_vm._v("loop")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Pending Client's Response")])]) : _vm._e(), _vm._v(" "), (item.eliminationStatus === _vm.eliminationStatus.SELECTED) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-chip', _vm._g({
                  staticClass: "ma-2",
                  attrs: {
                    "color": "#8BC34A",
                    "x-small": "",
                    "text-color": "white"
                  }
                }, on), [_vm._v("\n                                  Selected\n                                  "), _c('v-icon', {
                  attrs: {
                    "right": "",
                    "x-small": ""
                  }
                }, [_vm._v("mdi-check")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Client selected this influencer")])]) : _vm._e(), _vm._v(" "), (item.eliminationStatus === _vm.eliminationStatus.ELIMINATED) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-chip', _vm._g({
                  staticClass: "ma-2",
                  attrs: {
                    "color": "red",
                    "x-small": "",
                    "text-color": "white"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.showReason(item.eliminationReason)
                    }
                  }
                }, on), [_vm._v("\n                                  Eliminated\n                                  "), _c('v-icon', {
                  attrs: {
                    "x-small": ""
                  }
                }, [_vm._v("mdi-close")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Click to view the reason")])]) : _vm._e(), _vm._v(" "), (!item.success && !item.isLoading) ? _c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("Fail")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && _vm.displayFields('AIPayout')) ? _c('td', {
            staticClass: "pairing-freeze-deliverables",
            attrs: {
              "align": "center"
            }
          }, [_c('p', {
            staticClass: "deliverable-txt mb-0"
          }, [_vm._v("\n                              " + _vm._s(_vm.formatPairingDeliverables(_vm.campaignHelper.getDeliverableDetails(item.deliverableDetails))) + "\n                            ")]), _vm._v(" "), (!_vm.disableLockedCOGS) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Edit"
            },
            on: {
              "click": function($event) {
                return _vm.priceMultiplierHandler(item)
              }
            }
          }, [_vm._v("edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.payoutEdit === false && _vm.displayFields('payout')) ? _c('td', {
            staticClass: "pairing-freeze-payout",
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                                  " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + "\n                                  " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                                  "), (item.isGST) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "GST enabled"
                  }
                }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Locked COGS"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openLockedCOGSDialog(_vm.campaign)
                    }
                  }
                }, [_vm._v("mdi-lock")]) : (item.payoutStatus == _vm.payoutStatus.CONFIRMED && _vm.isPendingActivity(item)) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Pending Payouts"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openLockedPayoutEditDialog(item)
                    }
                  }
                }, [_vm._v("mdi-clock-alert-outline")]) : (item.payoutStatus == _vm.payoutStatus.CONFIRMED && !_vm.isPendingActivity(item)) ? _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Locked"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openLockedPayoutEditDialog(item)
                    }
                  }
                }, [_vm._v("mdi-lock")]) : _c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title": "Edit"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openPayoutEditDialog(item)
                    }
                  }
                }, [_vm._v("edit")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayGSTText(item)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.payoutEdit === true && _vm.displayFields('payout')) ? _c('td', {
            staticClass: "pairing-freeze-payout",
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('v-text-field', {
            staticClass: "mt-3",
            staticStyle: {
              "width": "100px"
            },
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.payoutAmount),
              callback: function($$v) {
                _vm.$set(item, "payoutAmount", $$v)
              },
              expression: "item.payoutAmount"
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.statusEdit === false && _vm.displayFields('pairingStatus')) ? _c('td', {
            staticClass: "pairing-freeze-pairing",
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'status')
              }
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "outlined": "",
              "x-small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(_vm.getPairingStatusLabels(item.pairingStatus)) + "\n                              "), (item.payoutStatus == _vm.payoutStatus.CONFIRMED) ? _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-lock")]) : _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showFrozenPairingColumns && item.statusEdit === true) ? _c('td', {
            staticClass: "pairing-freeze-pairing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-select', {
            attrs: {
              "items": _vm.acceptPairingStatusOptions,
              "item-value": "status",
              "item-text": "display",
              "label": "Pairing Status"
            },
            on: {
              "change": function($event) {
                return _vm.changePairingStatus(item)
              }
            },
            model: {
              value: (item.pairingStatus),
              callback: function($$v) {
                _vm.$set(item, "pairingStatus", $$v)
              },
              expression: "item.pairingStatus"
            }
          })], 1) : _vm._e()])
        }), 0)]
      }
    }]),
    model: {
      value: (_vm.selectAllStatus),
      callback: function($$v) {
        _vm.selectAllStatus = $$v
      },
      expression: "selectAllStatus"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions pairing-modal-actions"
  }, [_c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "color": "secondary"
    },
    on: {
      "change": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.optionVal),
      callback: function($$v) {
        _vm.optionVal = $$v
      },
      expression: "optionVal"
    }
  }, [_c('v-btn', {
    staticClass: "option-btn",
    class: {
      'secondary': _vm.optionVal === 0
    }
  }, [_vm._v("Option A")]), _vm._v(" "), _c('v-btn', {
    staticClass: "option-btn",
    class: {
      'secondary': _vm.optionVal === 1
    }
  }, [_vm._v("Option B")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showBtnCO) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.invokeSendToAM()
      }
    }
  }, [_vm._v("Send to AM")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showPairingEliminEditModal()
      }
    }
  }, [_vm._v("Send To Client")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "target": "_blank",
      "to": '/campaigns/' + _vm.campaign.id + '/invite-influencer'
    }
  }, [_vm._v("Send Invitation")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "target": "_blank",
      "to": '/influencers/invoices-brief-confirmation?id=' + _vm.campaign.id
    }
  }, [_vm._v("Invoices & Brief Confirmation")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "target": "_blank",
      "to": '/finance/payment-consolidation/status?id=' + _vm.campaign.id
    }
  }, [_vm._v("Payment Consolidation Status")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('influencer-list-modal', {
    attrs: {
      "value1": _vm.showInfluencerSearchResult,
      "result": _vm.influencerSearchResult,
      "influencers": _vm.selected,
      "keyword": _vm.currentKeywordSearch
    },
    on: {
      "input1": _vm.input1,
      "select": _vm.select
    },
    model: {
      value: (_vm.showInfluencerSearchResult),
      callback: function($$v) {
        _vm.showInfluencerSearchResult = $$v
      },
      expression: "showInfluencerSearchResult"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.reasonDialog),
      callback: function($$v) {
        _vm.reasonDialog = $$v
      },
      expression: "reasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Reason for elimination")]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.eliminationReason))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.reasonDialog = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('k-toast', {
    attrs: {
      "variant": _vm.toast.variant,
      "header": _vm.toast.header,
      "content": _vm.toast.content
    }
  }), _vm._v(" "), _c('settings-for-ai-modal', {
    attrs: {
      "value": _vm.settingAIDialog
    },
    on: {
      "paramsUpdated": function($event) {
        return _vm.paramsUpdated()
      }
    },
    model: {
      value: (_vm.settingAIDialog),
      callback: function($$v) {
        _vm.settingAIDialog = $$v
      },
      expression: "settingAIDialog"
    }
  }), _vm._v(" "), _c('settings-for-pairing', {
    attrs: {
      "value": _vm.updatePairingDialog,
      "view-only": _vm.viewOnly,
      "data": _vm.activePairingData
    },
    on: {
      "pairChanged": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.updatePairingDialog),
      callback: function($$v) {
        _vm.updatePairingDialog = $$v
      },
      expression: "updatePairingDialog"
    }
  }), _vm._v(" "), _c('price-multiplier-modal', {
    attrs: {
      "value": _vm.priceMultiplierDialog,
      "pairedInfluencer": _vm.priceMultiplierInfluencerData,
      "campaignData": _vm.campaign,
      "multiple": _vm.isMultipleDeliverables,
      "multipleInfs": _vm.actionSelected
    },
    on: {
      "clearSelected": function($event) {
        return _vm.clearActionSelected()
      },
      "savedFromPriceMultplier": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.priceMultiplierDialog),
      callback: function($$v) {
        _vm.priceMultiplierDialog = $$v
      },
      expression: "priceMultiplierDialog"
    }
  }), _vm._v(" "), _c('full-screen-progress', {
    attrs: {
      "show": _vm.bulkProgress.show,
      "isStatus": "true",
      "processing": _vm.bulkProgress.processing,
      "complete": _vm.bulkProgress.complete,
      "color": _vm.secondary
    }
  }), _vm._v(" "), _c('req-cogs-approval-modal', {
    attrs: {
      "value": _vm.reqApprovalDialog,
      "pairing": _vm.payoutEditPairing,
      "amount": _vm.reqAmt,
      "reasons": _vm.reqReasons,
      "budget": _vm.budget,
      "currentCOGS": _vm.measurement.budget,
      "cogsPercent": _vm.measurement.cogsPercentage
    },
    on: {
      "saved": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.reqApprovalDialog),
      callback: function($$v) {
        _vm.reqApprovalDialog = $$v
      },
      expression: "reqApprovalDialog"
    }
  }), _vm._v(" "), _c('payout-update-modal', {
    attrs: {
      "value": _vm.editPayoutDialog,
      "pairing": _vm.payoutEditPairing,
      "lockedPayout": _vm.lockedPayout,
      "cappedCOGS": _vm.budget,
      "currentCOGS": _vm.measurement.budget,
      "campaign": _vm.campaign
    },
    on: {
      "budgetExceeded": _vm.openReqApprovalDialog,
      "refreshPairing": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.editPayoutDialog),
      callback: function($$v) {
        _vm.editPayoutDialog = $$v
      },
      expression: "editPayoutDialog"
    }
  }), _vm._v(" "), _c('pairing-elimination-edit-modal', {
    attrs: {
      "campaingData": _vm.campaingDataForElimination
    },
    on: {
      "invokeSendToClient": _vm.invokeSendToClient
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "width": "1300px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Stats Analysis\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "overflow": "hidden",
      "margin-top": "10px",
      "min-height": "35px"
    }
  }, [_c('div', [_c('stats-data-table', {
    attrs: {
      "isView": "true",
      "viewHandle": _vm.handle
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className || 'mt-2'
  }, [_c('v-btn', {
    attrs: {
      "block": !_vm.noBlock,
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.url)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label || 'Download Video') + "\n    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('h4', {
    staticClass: "text-bold"
  }, [_vm._v("Dedicated Persons")]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedDedicatedPersons),
      callback: function($$v) {
        _vm.selectedDedicatedPersons = $$v
      },
      expression: "selectedDedicatedPersons"
    }
  }, _vm._l((_vm.userTypes), function(userType, typeIndex) {
    return _c('div', {
      key: typeIndex
    }, [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "margin-left": "-7px"
      }
    }, _vm._l((_vm.filterByRole(_vm.assignUsers, userType.role)), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "value": item,
          "filter": "",
          "readonly": _vm.viewMode
        }
      }, [_c('v-avatar', {
        staticStyle: {
          "margin-right": "5px"
        }
      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n            " + _vm._s(item.firstName + ' ' + item.lastName) + "\n          ")], 1)
    }), 1)])
  }), 0)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', [_c('h4', {
    staticClass: "text-bold"
  }, [_vm._v("Supporting Persons")]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedSupportingPersons),
      callback: function($$v) {
        _vm.selectedSupportingPersons = $$v
      },
      expression: "selectedSupportingPersons"
    }
  }, _vm._l((_vm.userTypes), function(userType, typeIndex) {
    return _c('div', {
      key: typeIndex
    }, [_c('p', {
      staticClass: "h4 font-weight-bold mb-0"
    }, [_vm._v(_vm._s(userType.title))]), _vm._v(" "), _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "margin-left": "-7px"
      }
    }, _vm._l((_vm.filterByRole(_vm.computedSupportingPersons, userType.role)), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-2",
        attrs: {
          "value": item,
          "filter": "",
          "readonly": _vm.viewMode
        }
      }, [_c('v-avatar', {
        staticStyle: {
          "margin-right": "5px"
        }
      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n            " + _vm._s(item.firstName + ' ' + item.lastName) + "\n          ")], 1)
    }), 1)])
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("COGS Estimation")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "recognized-revenue-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.monthYearValues,
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.month",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.month) ? _c('span', [_vm._v(_vm._s(item.month))]) : _vm._e()])]
      }
    }, {
      key: "item.totalAmt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.totalAmt) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.totalAmt)))]) : _vm._e()])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalAmount)))])])])])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "secondary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("My Tasks")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTasks()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-item', {
      key: item.title,
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.actionOnTask(item.action, item.postID)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.text) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files.length > 0) ? _c('v-row', _vm._l((_vm.files), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "3",
        "lg": "3",
        "align": "center"
      }
    }, [(item.type.indexOf('image') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "d-flex",
            attrs: {
              "flat": "",
              "tile": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": item.url,
              "lazy-src": item.url,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('pdf') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/pdf.png",
        "aspect-ratio": "1"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/ppt.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/doc.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "/static/img/text.png"
      }
    })], 1) : _vm._e()])
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-5 pt-0 pb-0"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "between"
    }
  }, [_c('v-col', {
    staticClass: "sub-title",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("Drafts")]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "search", $$v)
      },
      expression: "selectedFilter.search"
    }
  })], 1), _vm._v(" "), (_vm.isSuperAdmin || _vm.isAM) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin || _vm.isCC) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-data-table', {
    staticClass: "drafts-data-table elevation-1",
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.selectedFilter.search,
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.timeline",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [(_vm.isLinkAllow) ? _c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/campaigns/timeline?campaignID=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v("\n            " + _vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || '') + "\n          ")]) : _c('span', [_vm._v(_vm._s(item.startDate || '') + " - " + _vm._s(item.endDate || ''))])])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-left " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": ("/influencers/invoices-brief-confirmation?id=" + (item.campaignID)),
            "target": '_blank'
          }
        }, [_vm._v(_vm._s(item.name || ''))])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('a', {
          staticClass: "custom-link",
          attrs: {
            "href": '/posts/internal/all-posts?campaignID=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v("\n            " + _vm._s(item.producedDeliverables || 0) + " / " + _vm._s(item.pairingDeliverables || 0) + "\n          ")])])]
      }
    }, {
      key: "item.submissionDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('span', [_vm._v(_vm._s(item.submissionDate ? _vm.formatDate(item.submissionDate) : ''))])])]
      }
    }, {
      key: "item.reviewDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          class: ("text-center pt-2 pb-2 " + (item.overdue ? 'overdue-highlight' : ''))
        }, [_c('div', {
          staticClass: "d-flex flex-row",
          staticStyle: {
            "justify-content": "center"
          }
        }, [_c('v-text-field', {
          staticClass: "edit-date-box",
          attrs: {
            "placeholder": "Review Date",
            "outlined": "",
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": function($event) {
              return _vm.checkDate(item, 'reviewDate', 'validReviewDate')
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.checkDate(item, 'reviewDate', 'validReviewDate', true)
            }
          },
          model: {
            value: (item.reviewDate),
            callback: function($$v) {
              _vm.$set(item, "reviewDate", $$v)
            },
            expression: "item.reviewDate"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "date-picker-inner"
        }, [_c('date-picker', {
          attrs: {
            "className": "input-field",
            "options": {
              theme: 'icon',
              confirm: true
            },
            "status": item.reviewDateCal
          },
          on: {
            "changeDate": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.setDateFromPicker.apply(void 0, [ item, 'reviewDate' ].concat( argsArray ))
            }
          }
        })], 1)], 1), _vm._v(" "), (item.validReviewDate === false) ? _c('div', [_c('span', {
          staticClass: "text-danger ma-0 pt-1"
        }, [_vm._v("Invalid Start Date")])]) : _vm._e()])]
      }
    }], null, true)
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "pink",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("What's Next")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadTasks()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-item', {
      key: item.title,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          return _vm.actionOnTask(item.action, item.postID)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.text) + "\n                  ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": _vm.color
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "pa-3 mt-3",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn-toggle', {
    staticClass: "btn-filter-group pa-3",
    attrs: {
      "small": "",
      "dense": "",
      "mandatory": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.monthlyClick
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.quartelyClick
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.yearlyClick
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "col-md-3 col-sm-12 col-xs-12 pa-3",
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.firstFilters,
      "label": _vm.firstFilterLabel,
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.firstFilterId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "firstFilterId", $$v)
      },
      expression: "selectedFilter.firstFilterId"
    }
  }), _vm._v(" "), (_vm.summary && _vm.summary.length) ? _c('v-card', {
    staticClass: "summary-card",
    attrs: {
      "max-width": "330",
      "height": "180",
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "text-h6 text--primary"
  }, [_vm._v("\n                  " + _vm._s(_vm.summaryTitle) + "\n                ")]), _vm._v(" "), _vm._l((_vm.summary), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text--primary",
      staticStyle: {
        "font-size": "14px",
        "margin": "5px"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.data)))])])
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.id,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), (_vm.detail) ? _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "end",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.detailClick
    }
  }, [_vm._v("Details")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "30vw",
      "value": _vm.value,
      "max-width": "30vw",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "headline ims-modal-header"
  }, [_vm._v("\n      Update Content for  "), _c('strong', [_vm._v(" @" + _vm._s(_vm.ighandle) + " ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "color": "secondary",
      "aria-label": "Close update content dialog"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-combobox', {
    staticClass: "mr-2",
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "accountLabel",
      "item-value": "accountKey",
      "return-object": "",
      "loading": _vm.pairedInfluencersLoading,
      "hide-details": "auto",
      "label": "Handle",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.changePlatform
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.displayHandle || item.instagramHandle) ? _c('span', [_vm._v("\n              " + _vm._s(item.displayHandle || item.instagramHandle) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(item) + "\n            ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center justify-space-between account-option"
        }, [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.instagramHandle,
            "twitterHandle": item.twitterHandle || item.instagramHandle,
            "xiaohongshuHandle": item.instagramHandle,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "caption grey--text ml-3"
        }, [_vm._v(_vm._s(_vm.getPlatformDisplayName(item.platform)))])], 1)]
      }
    }]),
    model: {
      value: (_vm.updateHandle),
      callback: function($$v) {
        _vm.updateHandle = $$v
      },
      expression: "updateHandle"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.platformTypes,
      "label": "Platform",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.updatePlatform),
      callback: function($$v) {
        _vm.updatePlatform = $$v
      },
      expression: "updatePlatform"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  })], 1), _vm._v(" "), (_vm.isStory) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.storyInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Story Media URL"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData, "media_url", $$v)
      },
      expression: "storyInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Story Media URL"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData, "embed_url", $$v)
      },
      expression: "storyInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.storyInsightSubmittingData.live_date = _vm.parseDate(_vm.storyInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedDateFormatted),
            callback: function($$v) {
              _vm.computedDateFormatted = $$v
            },
            expression: "computedDateFormatted"
          }
        }, on))]
      }
    }], null, false, 3972542783),
    model: {
      value: (_vm.storyLiveCal),
      callback: function($$v) {
        _vm.storyLiveCal = $$v
      },
      expression: "storyLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.storyLiveCal = false
      }
    },
    model: {
      value: (_vm.storyInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData, "live_date", $$v)
      },
      expression: "storyInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog('story')
      }
    }
  }, [_vm._v("\n              Upload Stats with AI\n            ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.reach),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "reach", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "impressions", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Story Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.story_likes),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "story_likes", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.story_likes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Replies",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.replies),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "replies", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.replies"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Link Clicks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.link_clicks),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "link_clicks", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.link_clicks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sticker Taps",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.sticker_taps),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "sticker_taps", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.sticker_taps"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.storyInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isTikTok) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.postInsightSubmittingData.live_date = _vm.parseDate(_vm.postInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedTikTokDateFormatted),
            callback: function($$v) {
              _vm.computedTikTokDateFormatted = $$v
            },
            expression: "computedTikTokDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.tiktokLiveCal),
      callback: function($$v) {
        _vm.tiktokLiveCal = $$v
      },
      expression: "tiktokLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.tiktokLiveCal = false
      }
    },
    model: {
      value: (_vm.postInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "live_date", $$v)
      },
      expression: "postInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("TikTok Insights")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog('tiktok')
      }
    }
  }, [_vm._v("\n              Upload Stats with AI\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary",
      "disabled": _vm.isLoading || !_vm.getScrapeTargetLink()
    },
    on: {
      "click": function($event) {
        _vm.scrapComments(_vm.getScrapeTargetLink(), _vm.postInsightReportID)
      }
    }
  }, [_vm._v("\n              Extract Stats\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-13px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "hour", $$v)
      },
      expression: "totalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "minute", $$v)
      },
      expression: "totalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "second", $$v)
      },
      expression: "totalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watches", $$v)
      },
      expression: "postInsightSubmittingData.inputtedInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "shares", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Favourites (Bookmarks)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Total Viewers (Reach)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Watched full video (%)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watchedFullVideo),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watchedFullVideo", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.watchedFullVideo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Photo Views",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.photo_views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "photo_views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.photo_views"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.postInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isYoutube) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.postInsightSubmittingData.live_date = _vm.parseDate(_vm.postInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedYoutubeDateFormatted),
            callback: function($$v) {
              _vm.computedYoutubeDateFormatted = $$v
            },
            expression: "computedYoutubeDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.youtubeLiveCal),
      callback: function($$v) {
        _vm.youtubeLiveCal = $$v
      },
      expression: "youtubeLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.youtubeLiveCal = false
      }
    },
    model: {
      value: (_vm.postInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "live_date", $$v)
      },
      expression: "postInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("Youtube Insights")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary",
      "disabled": _vm.isLoading || !_vm.getScrapeTargetLink()
    },
    on: {
      "click": function($event) {
        _vm.scrapComments(_vm.getScrapeTargetLink(), _vm.postInsightReportID)
      }
    }
  }, [_vm._v("\n              Extract Stats\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Outreach",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.outreach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "outreach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.outreach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Engagement Rate",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.engagement_rate),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "engagement_rate", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.engagement_rate"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Unique Viewers",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.unique_viewers),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "unique_viewers", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.unique_viewers"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watches", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.watches"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.postInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isXHS) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "media_url", $$v)
      },
      expression: "xhsPostInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "embed_url", $$v)
      },
      expression: "xhsPostInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.xhsLink) ? _c('v-text-field', {
    attrs: {
      "label": "XHS Link"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.xhsLink),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "xhsLink", $$v)
      },
      expression: "xhsPostInsightSubmittingData.xhsLink"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.xhsFullname) ? _c('v-text-field', {
    attrs: {
      "label": "Full name"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.xhsFullname),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "xhsFullname", $$v)
      },
      expression: "xhsPostInsightSubmittingData.xhsFullname"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.xhsFollowers || _vm.xhsPostInsightSubmittingData.xhsFollowers === '0' || _vm.xhsPostInsightSubmittingData.xhsFollowers === 0) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.xhsFollowers),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "xhsFollowers", $$v)
      },
      expression: "xhsPostInsightSubmittingData.xhsFollowers"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.xhsPostInsightSubmittingData.live_date = _vm.parseDate(_vm.xhsPostInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedXHSDateFormatted),
            callback: function($$v) {
              _vm.computedXHSDateFormatted = $$v
            },
            expression: "computedXHSDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.xhsLiveCal),
      callback: function($$v) {
        _vm.xhsLiveCal = $$v
      },
      expression: "xhsLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.xhsLiveCal = false
      }
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "live_date", $$v)
      },
      expression: "xhsPostInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.watches),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "watches", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "bookmarks", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.shares"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.xhsPostInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isLemon) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "media_url", $$v)
      },
      expression: "lemonPostInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "embed_url", $$v)
      },
      expression: "lemonPostInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.lemonLink) ? _c('v-text-field', {
    attrs: {
      "label": "lemon Link"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.lemonLink),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "lemonLink", $$v)
      },
      expression: "lemonPostInsightSubmittingData.lemonLink"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.lemonFullname) ? _c('v-text-field', {
    attrs: {
      "label": "Full name"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.lemonFullname),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "lemonFullname", $$v)
      },
      expression: "lemonPostInsightSubmittingData.lemonFullname"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.lemonFollowers) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.lemonFollowers),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "lemonFollowers", $$v)
      },
      expression: "lemonPostInsightSubmittingData.lemonFollowers"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.lemonPostInsightSubmittingData.live_date = _vm.parseDate(_vm.lemonPostInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedLemonDateFormatted),
            callback: function($$v) {
              _vm.computedLemonDateFormatted = $$v
            },
            expression: "computedLemonDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.lemonLiveCal),
      callback: function($$v) {
        _vm.lemonLiveCal = $$v
      },
      expression: "lemonLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.lemonLiveCal = false
      }
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "live_date", $$v)
      },
      expression: "lemonPostInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.watches),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "watches", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "bookmarks", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.shares"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.lemonPostInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isFacebook) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.fbPostInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Post Media URL"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData, "media_url", $$v)
      },
      expression: "fbPostInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Post Media URL"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData, "embed_url", $$v)
      },
      expression: "fbPostInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.fbPostInsightSubmittingData.live_date = _vm.parseDate(_vm.fbPostInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedFacebookDateFormatted),
            callback: function($$v) {
              _vm.computedFacebookDateFormatted = $$v
            },
            expression: "computedFacebookDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.fbLiveCal),
      callback: function($$v) {
        _vm.fbLiveCal = $$v
      },
      expression: "fbLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.fbLiveCal = false
      }
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData, "live_date", $$v)
      },
      expression: "fbPostInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.outreach),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "outreach", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.outreach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bookmarks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "bookmarks", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.bookmarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.fbPostInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isLinkedIn || _vm.isTwitter || _vm.isOthers) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.postURL) ? _c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "postURL", $$v)
      },
      expression: "otherInsightSubmittingData.postURL"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isLinkedIn && !_vm.isTwitter) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "media_url", $$v)
      },
      expression: "otherInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "embed_url", $$v)
      },
      expression: "otherInsightSubmittingData.embed_url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLinkedIn && !_vm.isTwitter) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.othersFullname) ? _c('v-text-field', {
    attrs: {
      "label": "Full name"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.othersFullname),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "othersFullname", $$v)
      },
      expression: "otherInsightSubmittingData.othersFullname"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLinkedIn && !_vm.isTwitter) ? _c('v-row', [(!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.othersFollowers) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.othersFollowers),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "othersFollowers", $$v)
      },
      expression: "otherInsightSubmittingData.othersFollowers"
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.otherInsightSubmittingData.live_date = _vm.parseDate(_vm.otherInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedOthersDateFormatted),
            callback: function($$v) {
              _vm.computedOthersDateFormatted = $$v
            },
            expression: "computedOthersDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.otherLiveCal),
      callback: function($$v) {
        _vm.otherLiveCal = $$v
      },
      expression: "otherLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.otherLiveCal = false
      }
    },
    model: {
      value: (_vm.otherInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "live_date", $$v)
      },
      expression: "otherInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.isLinkedIn) ? _c('v-row', [(!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "hour", $$v)
      },
      expression: "otherTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "minute", $$v)
      },
      expression: "otherTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "second", $$v)
      },
      expression: "otherTotalPlayTime.second"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.views"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.watches),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "watches", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.watches"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isTwitter) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "impressions", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Replies",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bookmarks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "saved", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.saved"
    }
  })], 1)], 1) : (_vm.isLinkedIn) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Discovery")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "impressions", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Members reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.reach),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "reach", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Video Performance")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Video views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.video_views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "video_views", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.video_views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Profile Activity")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Profile viewers from this post",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.profile_viewers),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "profile_viewers", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.profile_viewers"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Engagement")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reactions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "saved", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.saved"
    }
  })], 1)], 1) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "saved", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.like_count"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.otherInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post Image URL",
      "placeholder": "Optional"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postImageURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postImageURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postImageURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.postInsightSubmittingData.live_date = _vm.parseDate(_vm.postInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedPostDateFormatted),
            callback: function($$v) {
              _vm.computedPostDateFormatted = $$v
            },
            expression: "computedPostDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.postLiveCal),
      callback: function($$v) {
        _vm.postLiveCal = $$v
      },
      expression: "postLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.postLiveCal = false
      }
    },
    model: {
      value: (_vm.postInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "live_date", $$v)
      },
      expression: "postInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("Post Insights")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.isReel ? 'reel' : 'post')
      }
    }
  }, [_vm._v("\n              Upload Stats with AI\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary",
      "disabled": _vm.isLoading || !_vm.getScrapeTargetLink()
    },
    on: {
      "click": function($event) {
        _vm.scrapComments(_vm.getScrapeTargetLink(), _vm.postInsightReportID)
      }
    }
  }, [_vm._v("\n              Extract Stats\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), (!_vm.isReel) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts Reached",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.saved"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isReel) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts Reached",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reposts),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reposts", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reposts"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Watch Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "d",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.day),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "day", $$v)
      },
      expression: "reelTotalPlayTime.day"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "hour", $$v)
      },
      expression: "reelTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "minute", $$v)
      },
      expression: "reelTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "second", $$v)
      },
      expression: "reelTotalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watches", $$v)
      },
      expression: "postInsightSubmittingData.inputtedInsights.watches"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.postInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('upload-stats-modal', {
    attrs: {
      "value": _vm.uploadStatsDialog,
      "postType": _vm.aiPostType,
      "imagesToView": _vm.imagesToView
    },
    on: {
      "statsConfirmed": _vm.confirmedStats
    },
    model: {
      value: (_vm.uploadStatsDialog),
      callback: function($$v) {
        _vm.uploadStatsDialog = $$v
      },
      expression: "uploadStatsDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "800px"
    },
    on: {
      "input": _vm.close
    }
  }, [_c('v-card', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v(_vm._s(_vm.viewSample.title || 'Stats example'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.sampleImages.length) ? _c('div', [(_vm.sampleImages.length > 1) ? _c('v-carousel', {
    staticClass: "grey lighten-2 payout-sample-carousel",
    attrs: {
      "show-arrows": "",
      "height": "580"
    },
    model: {
      value: (_vm.currentSlide),
      callback: function($$v) {
        _vm.currentSlide = $$v
      },
      expression: "currentSlide"
    }
  }, _vm._l((_vm.sampleImages), function(image) {
    return _c('v-carousel-item', {
      key: image.url
    }, [_c('v-img', {
      staticClass: "white",
      attrs: {
        "src": _vm.imgBaseURL + image.url,
        "lazy-src": _vm.imgBaseURL + image.url,
        "alt": image.title,
        "contain": "",
        "height": "530"
      }
    })], 1)
  }), 1) : _c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.imgBaseURL + _vm.sampleImages[0].url,
      "lazy-src": _vm.imgBaseURL + _vm.sampleImages[0].url,
      "alt": _vm.sampleImages[0].title,
      "contain": "",
      "max-height": "560"
    }
  }), _vm._v(" "), (_vm.sampleImages.length > 1) ? _c('div', {
    staticClass: "text-center caption font-weight-medium mt-2",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v("\n            Slide " + _vm._s(_vm.currentSlide + 1) + " of " + _vm._s(_vm.sampleImages.length) + "\n          ")]) : _vm._e()], 1) : (_vm.viewSample.metrics) ? _c('v-card', {
    staticClass: "pa-5",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-3"
  }, [_vm._v("Stats to submit")]), _vm._v(" "), _vm._l((_vm.viewSample.metrics), function(metric) {
    return _c('v-chip', {
      key: metric,
      staticClass: "ma-1",
      attrs: {
        "color": "secondary",
        "outlined": ""
      }
    }, [_vm._v(_vm._s(metric))])
  })], 2) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.primaryInf) ? _c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Merge Influencer\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('v-alert', {
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("\n        Please check and merge the influencers\n      ")]), _vm._v(" "), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openExpansion),
      callback: function($$v) {
        _vm.openExpansion = $$v
      },
      expression: "openExpansion"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Contact Information\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [(_vm.isEmail) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.email),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "email", $$v)
      },
      expression: "comparisons.email"
    }
  }, [(_vm.primaryInf.email) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.email,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.email) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.email,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isPhone) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.phone),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "phone", $$v)
      },
      expression: "comparisons.phone"
    }
  }, [(_vm.primaryInf.phone) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.phone,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.phone) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.phone,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Billing Information\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [(_vm.isBankName) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Bank name")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.bankName),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "bankName", $$v)
      },
      expression: "comparisons.bankName"
    }
  }, [(_vm.primaryInf.bankName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.bankName,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.bankName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.bankName,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isBankAccount) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Bank account")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "bankAccount", $$v)
      },
      expression: "comparisons.bankAccount"
    }
  }, [(_vm.primaryInf.bankAccount) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.bankAccount,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.bankAccount) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.bankAccount,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [(_vm.isFullName) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Fullname as per Bank Account")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.fullName),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "fullName", $$v)
      },
      expression: "comparisons.fullName"
    }
  }, [(_vm.primaryInf.fullName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.fullName,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.fullName) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.fullName,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isCountry) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.country),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "country", $$v)
      },
      expression: "comparisons.country"
    }
  }, [(_vm.primaryInf.country) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.country,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.country) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.country,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [(_vm.isMailingAddress) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Mailing address")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "mailingAddress", $$v)
      },
      expression: "comparisons.mailingAddress"
    }
  }, [(_vm.primaryInf.mailingAddress) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.mailingAddress,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.mailingAddress) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.mailingAddress,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Your Rates "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "margin-left": "5px"
    }
  }, [_vm._v("(in SGD per item)")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-tabs', {
    staticClass: "mb-3",
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.primaryInf.audience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryInf.audience.user_profile ? _vm.primaryInf.audience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.primaryInf.tiktokaudience && !_vm.primaryInf.audience && !_vm.primaryInf.youtubeaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryInf.tiktokaudience.user_profile ? _vm.primaryInf.tiktokaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.primaryInf.youtubeaudience && !_vm.primaryInf.audience && !_vm.primaryInf.tiktokaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.primaryInf.youtubeaudience.user_profile ? _vm.primaryInf.youtubeaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.compareInf.audience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.compareInf.audience.user_profile ? _vm.compareInf.audience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.compareInf.tiktokaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.compareInf.tiktokaudience.user_profile ? _vm.compareInf.tiktokaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.compareInf.youtubeaudience) ? _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.compareInf.youtubeaudience.user_profile ? _vm.compareInf.youtubeaudience.user_profile.fullname : '') + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 1,
    attrs: {
      "value": "tab-1"
    }
  }, [_c('inputed-rates', {
    attrs: {
      "inputedRates": _vm.inputedRates
    }
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    attrs: {
      "value": "tab-2"
    }
  }, [_c('inputed-rates', {
    attrs: {
      "inputedRates": _vm.compareInputedRates
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n            Additional Information\n          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [(_vm.isGender) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.gender),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "gender", $$v)
      },
      expression: "comparisons.gender"
    }
  }, [(_vm.primaryInf.gender) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.userGender_options[_vm.primaryInf.gender] ? _vm.userGender_options[_vm.primaryInf.gender] : '-',
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.gender) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.userGender_options[_vm.compareInf.gender] ? _vm.userGender_options[_vm.compareInf.gender] : '-',
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isBirthday) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Birthday")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "column": ""
    },
    model: {
      value: (_vm.comparisons.birthday),
      callback: function($$v) {
        _vm.$set(_vm.comparisons, "birthday", $$v)
      },
      expression: "comparisons.birthday"
    }
  }, [(_vm.primaryInf.birthday) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.primaryInf.birthday,
      "color": "warning",
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.compareInf.birthday) ? _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": _vm.compareInf.birthday,
      "color": "warning",
      "value": 2
    }
  })], 1) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.saveMerge
    }
  }, [_vm._v("Save changes")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-brief"
    }
  }, [_c('section', {
    staticClass: "content box-columns"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.id,
      staticClass: "box insta-box"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": post.influencer.instagram.profilePicture
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(post.influencer.fullName))]), _vm._v(" "), _c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(post.location))]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_vm._v("Tags: " + _vm._s(post.hashtag))]), _vm._v(" "), _c('span', {
      staticClass: "label label-default post-status"
    }, [_vm._v(_vm._s(_vm._f("postStatusText")(post.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [(post.imageURL) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": post.imageURL
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text-center",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._v("No image")]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_vm._v("\n          " + _vm._s(post.description) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "box-footer"
    }, [(_vm.canApprove(post.status)) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.approvePost(post)
        }
      }
    }, [_vm._v("Approve Post")]) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 2197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.user != null) ? _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("First name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.firstName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Last name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Account Activation")]), _vm._v(" "), _c('p', [_c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.activated == null || _vm.user.activated == 1),
      expression: "user.activated == null || user.activated == 1"
    }],
    attrs: {
      "disabled": "",
      "variant": "secondary"
    }
  }, [_vm._v("Activated")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.activated != null && _vm.user.activated != 1),
      expression: "user.activated != null && user.activated != 1"
    }],
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.user.activated = 1
      }
    }
  }, [_vm._v("Activate Now")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("Save changes")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Influencer Activation\n        ")])])
}]}

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        _vm.createClientDialog = true
      }
    }
  }, [_vm._v("\n          Create new\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 pt-2 secondary--text",
    attrs: {
      "color": "secondary",
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat secondary--text"
  })]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pl-3",
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search an Existing Client",
      "single-line": "",
      "hide-details": "",
      "solo": "",
      "dense": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-card-title', {
    staticClass: "pl-0 pr-0"
  }, [(_vm.selectedClients) ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "warning",
      "disabled": !_vm.selectedClients || _vm.selectedClients.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openClientGroupModal()
      }
    }
  }, [_vm._v("Add to Group (" + _vm._s(_vm.selectedClients.length) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "client-nested-table client-root-table elevation-1",
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "headers": _vm.fields,
      "items": _vm.items,
      "search": _vm.filter,
      "show-select": "",
      "show-expand": "",
      "expanded": _vm.expanded,
      "item-key": "id",
      "single-select": false
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      },
      "toggle-select-all": _vm.selectAllClients
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-expand",
      fn: function(ref) {
        var item = ref.item;
        var expand = ref.expand;
        var isExpanded = ref.isExpanded;

        return [_c('span', [(isExpanded) ? _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(false)
            }
          }
        }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(true)
            }
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }, {
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.isGroup) ? _c('v-checkbox', {
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedClients),
            callback: function($$v) {
              _vm.selectedClients = $$v
            },
            expression: "selectedClients"
          }
        }) : _c('v-icon', [_vm._v("mdi-domain")])]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [(item.isGroup && item.groupEdit) ? _c('div', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": "",
            "placeholder": "Campaign Name"
          },
          model: {
            value: (item.name),
            callback: function($$v) {
              _vm.$set(item, "name", $$v)
            },
            expression: "item.name"
          }
        }, _vm.on))], 1) : _c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.name))])])]
      }
    }, {
      key: "item.IO",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.IO))])])]
      }
    }, {
      key: "item.dealCode",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.dealCode))])])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [(item.budget) ? _c('td', {
          staticClass: "text-center"
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))]) : _c('td', {
          staticClass: "text-center"
        })])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [(item.isGroup) ? _c('td', [(item.groupEdit) ? _c('div', [_c('v-btn', {
          attrs: {
            "color": "success",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateXeroContact(item)
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "small": ""
          },
          on: {
            "click": function($event) {
              item.groupEdit = false
            }
          }
        }, [_vm._v("\n                Cancel\n              ")])], 1) : _c('div', [(_vm.buttonShow('edit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openGroupEdit(item, true)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "xmall": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "error"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteClientGroup(item.id, item.name)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)]) : _c('td', [(_vm.buttonShow('delete')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "error"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteClient(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('edit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.getClientDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "xmall": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.getClientDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('updateUser')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.getClientUserDataToUpdate(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("perm_identity")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\n            Your search for \"" + _vm._s(_vm.filter) + "\" found no results.\n          ")])]
      },
      proxy: true
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.clients) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "client-nested-table client-group-table elevation-1",
          attrs: {
            "headers": _vm.fields,
            "items": item.clients,
            "show-expand": "",
            "expanded": _vm.expanded,
            "show-select": "",
            "single-select": false
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded = $event
            },
            "toggle-select-all": _vm.selectAllClients
          },
          scopedSlots: _vm._u([{
            key: "item.data-table-expand",
            fn: function(ref) {
              var item = ref.item;
              var expand = ref.expand;
              var isExpanded = ref.isExpanded;

              return [_c('span', [(isExpanded) ? _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(false)
                  }
                }
              }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(true)
                  }
                }
              }, [_vm._v("mdi-chevron-down")])], 1)]
            }
          }, {
            key: "item.data-table-select",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-checkbox', {
                attrs: {
                  "label": "",
                  "value": item,
                  "color": "grey darken-2"
                },
                model: {
                  value: (_vm.selectedClients),
                  callback: function($$v) {
                    _vm.selectedClients = $$v
                  },
                  expression: "selectedClients"
                }
              })]
            }
          }, {
            key: "item.IO",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_c('td', {
                staticClass: "text-center"
              }, [_vm._v(_vm._s(item.IO))])])]
            }
          }, {
            key: "item.dealCode",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_c('td', {
                staticClass: "text-center"
              }, [_vm._v(_vm._s(item.dealCode))])])]
            }
          }, {
            key: "item.budget",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [(item.budget) ? _c('td', {
                staticClass: "text-center"
              }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))]) : _c('td', {
                staticClass: "text-center"
              })])]
            }
          }, {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', [(_vm.buttonShow('delete')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "error"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.deleteClient(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "color": "white",
                  "small": ""
                }
              }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('edit')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.getClientDataToEdit(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "xmall": ""
                }
              }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.getClientDataToView(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('updateUser')) ? _c('v-btn', {
                staticClass: "ims-action",
                attrs: {
                  "color": "secondary"
                },
                on: {
                  "click": function($event) {
                    return _vm.getClientUserDataToUpdate(item)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("perm_identity")])], 1) : _vm._e()], 1)]
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [_c('td', {
                staticClass: "client-expanded-cell",
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-data-table', {
                staticClass: "client-nested-table client-deal-table elevation-1",
                attrs: {
                  "striped": "",
                  "bordered": "",
                  "hover": "",
                  "responsive": "",
                  "headers": _vm.dealFields,
                  "items": item.deals,
                  "show-expand": "",
                  "expanded": _vm.expanded,
                  "item-key": "index",
                  "single-select": false
                },
                on: {
                  "update:expanded": function($event) {
                    _vm.expanded = $event
                  }
                },
                scopedSlots: _vm._u([{
                  key: "item.data-table-expand",
                  fn: function(ref) {
                    var item = ref.item;
                    var expand = ref.expand;
                    var isExpanded = ref.isExpanded;

                    return [_c('span', [(isExpanded) ? _c('v-icon', {
                      on: {
                        "click": function($event) {
                          return expand(false)
                        }
                      }
                    }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
                      on: {
                        "click": function($event) {
                          return expand(true)
                        }
                      }
                    }, [_vm._v("mdi-chevron-down")])], 1)]
                  }
                }, {
                  key: "item.budget",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])]
                  }
                }, {
                  key: "item.IO",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_c('div', [_vm._v(_vm._s(item.IO))]), _vm._v(" "), (item.linkedIOs) ? _c('span', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))]) : _vm._e()])]
                  }
                }, {
                  key: "item.action",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-menu', {
                      attrs: {
                        "offset-y": ""
                      },
                      scopedSlots: _vm._u([{
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on;
                          var attrs = ref.attrs;

                          return [_c('v-btn', _vm._g(_vm._b({
                            attrs: {
                              "color": "secondary",
                              "small": ""
                            }
                          }, 'v-btn', attrs, false), on), [_vm._v("\n                            Allocate\n                          ")])]
                        }
                      }], null, true)
                    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
                      on: {
                        "click": function($event) {
                          return _vm.addAllocate(item, 'all')
                        }
                      }
                    }, [_c('v-list-item-title', [_vm._v("All (100%)")])], 1), _vm._v(" "), _c('v-list-item', {
                      attrs: {
                        "link": ""
                      },
                      on: {
                        "click": function($event) {
                          return _vm.addAllocate(item, 'custom')
                        }
                      }
                    }, [_c('v-list-item-title', [_vm._v("Custom")])], 1)], 1)], 1)]
                  }
                }, {
                  key: "expanded-item",
                  fn: function(ref) {
                    var headers = ref.headers;
                    var item = ref.item;

                    return [(item.campaigns) ? _c('td', {
                      staticClass: "client-expanded-cell",
                      attrs: {
                        "colspan": headers.length
                      }
                    }, [_c('v-hover', {
                      scopedSlots: _vm._u([{
                        key: "default",
                        fn: function(ref) {
                          var hover = ref.hover;

                          return [_c('v-card', {
                            class: {
                              'mx-auto mb-2 text-center on-hover': hover,
                              'mx-auto mb-2 text-center': !hover
                            },
                            staticStyle: {
                              "width": "300px"
                            },
                            attrs: {
                              "color": "#363636",
                              "dark": "",
                              "elevation": hover ? 12 : 2
                            }
                          }, [_c('v-card-subtitle', [_c('p', {
                            staticClass: "pa-0 ma-0 custom-font"
                          }, [_vm._v("Used Budget: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getUsedBudgets(item.campaigns))))]), _vm._v(" "), _c('p', {
                            staticClass: "pa-0 ma-0 custom-font"
                          }, [_vm._v("Remain Budgets: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getRemainBudgets(item.campaigns))))])])], 1)]
                        }
                      }], null, true)
                    }), _vm._v(" "), _c('v-data-table', {
                      key: _vm.dataTableKey,
                      staticClass: "client-nested-table campaign-data-table client-table-small elevation-1",
                      attrs: {
                        "striped": "",
                        "bordered": "",
                        "hover": "",
                        "responsive": "",
                        "headers": _vm.campaignFields,
                        "items": item.campaigns,
                        "item-key": "campaignIndex"
                      },
                      scopedSlots: _vm._u([{
                        key: "item.name",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Campaign Name"
                            },
                            model: {
                              value: (item.name),
                              callback: function($$v) {
                                _vm.$set(item, "name", $$v)
                              },
                              expression: "item.name"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("\n                              " + _vm._s(item.name) + "\n                               "), (item.allocatePercent) ? _c('span', [_vm._v("( " + _vm._s(item.allocatePercent) + "% )")]) : _vm._e()])])]
                        }
                      }, {
                        key: "item.partCode",
                        fn: function(ref) {
                          var item = ref.item;

                          return [_c('td', {
                            staticClass: "text-center"
                          }, [_vm._v(_vm._s(item.partCode))])]
                        }
                      }, {
                        key: "item.outreach",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Outreach"
                            },
                            model: {
                              value: (item.outreach),
                              callback: function($$v) {
                                _vm.$set(item, "outreach", $$v)
                              },
                              expression: "item.outreach"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
                        }
                      }, {
                        key: "item.period",
                        fn: function(ref) {
                          var item = ref.item;

                          return [_c('td', {
                            staticClass: "text-center"
                          }, [_vm._v(_vm._s(item.period))])]
                        }
                      }, {
                        key: "item.recognizedRevenue",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.recognizedRevenue !== '') ? _c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.recognizedRevenue))))]) : _c('td', {
                            staticClass: "text-center"
                          })]
                        }
                      }, {
                        key: "item.unRecognizedRevenue",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.unRecognizedRevenue !== '') ? _c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.unRecognizedRevenue))))]) : _c('td', {
                            staticClass: "text-center"
                          })]
                        }
                      }, {
                        key: "item.cogs",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.cogs !== '') ? _c('td', {
                            staticClass: "text-center"
                          }, [_vm._v("$" + _vm._s(item.cogs) + " (" + _vm._s(item.cogsPercentage) + "%)")]) : _c('td', {
                            staticClass: "text-center"
                          })]
                        }
                      }, {
                        key: "item.budget",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Budget"
                            },
                            model: {
                              value: (item.budget),
                              callback: function($$v) {
                                _vm.$set(item, "budget", $$v)
                              },
                              expression: "item.budget"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])])]
                        }
                      }, {
                        key: "item.content",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3 mb-1",
                            attrs: {
                              "type": "number",
                              "hide-details": "",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "min"
                            },
                            model: {
                              value: (item.min_content),
                              callback: function($$v) {
                                _vm.$set(item, "min_content", $$v)
                              },
                              expression: "item.min_content"
                            }
                          }, _vm.on)), _vm._v(" "), _c('p', {
                            staticClass: "text-center ma-0"
                          }, [_vm._v("to")]), _vm._v(" "), _c('v-text-field', _vm._g({
                            staticClass: "input-field mb-1",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "max"
                            },
                            model: {
                              value: (item.max_content),
                              callback: function($$v) {
                                _vm.$set(item, "max_content", $$v)
                              },
                              expression: "item.max_content"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(item.min_content) + " - " + _vm._s(item.max_content))])])]
                        }
                      }, {
                        key: "item.engagement",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "Engagement"
                            },
                            model: {
                              value: (item.engagement),
                              callback: function($$v) {
                                _vm.$set(item, "engagement", $$v)
                              },
                              expression: "item.engagement"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagement)))])])]
                        }
                      }, {
                        key: "item.kpi_onboarded",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                            staticClass: "input-field mt-3",
                            attrs: {
                              "type": "number",
                              "dense": "",
                              "outlined": "",
                              "placeholder": "KPI Onboarded"
                            },
                            model: {
                              value: (item.kpi_onboarded),
                              callback: function($$v) {
                                _vm.$set(item, "kpi_onboarded", $$v)
                              },
                              expression: "item.kpi_onboarded"
                            }
                          }, _vm.on))], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.kpi_onboarded)))])])]
                        }
                      }, {
                        key: "item.campaignType",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-select', {
                            staticClass: "input-field",
                            attrs: {
                              "items": _vm.campaignTypeDisplay,
                              "label": "Product Type",
                              "dense": "",
                              "outlined": ""
                            },
                            model: {
                              value: (item.campaignType),
                              callback: function($$v) {
                                _vm.$set(item, "campaignType", $$v)
                              },
                              expression: "item.campaignType"
                            }
                          })], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, [_vm._v(_vm._s(item.campaignType))])])]
                        }
                      }, {
                        key: "item.country",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-combobox', {
                            attrs: {
                              "search-input": _vm.newCountry,
                              "items": _vm.countries,
                              "item-text": "name",
                              "item-value": "code",
                              "hide-selected": "",
                              "chips": "",
                              "label": "Country",
                              "multiple": "",
                              "dense": "",
                              "outlined": ""
                            },
                            on: {
                              "update:searchInput": function($event) {
                                _vm.newCountry = $event
                              },
                              "update:search-input": function($event) {
                                _vm.newCountry = $event
                              }
                            },
                            scopedSlots: _vm._u([{
                              key: "selection",
                              fn: function(ref) {
                                var attrs = ref.attrs;
                                var item = ref.item;
                                var parent = ref.parent;
                                var selected = ref.selected;

                                return [(item === Object(item)) ? _c('v-chip', _vm._b({
                                  attrs: {
                                    "input-value": selected,
                                    "label": "",
                                    "small": ""
                                  }
                                }, 'v-chip', attrs, false), [_c('span', {
                                  staticClass: "pr-2"
                                }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                    ")]), _vm._v(" "), _c('v-icon', {
                                  attrs: {
                                    "small": ""
                                  },
                                  on: {
                                    "click": function($event) {
                                      return parent.selectItem(item)
                                    }
                                  }
                                }, [_vm._v("\n                                      $delete\n                                    ")])], 1) : _c('v-chip', _vm._b({
                                  attrs: {
                                    "input-value": selected,
                                    "label": "",
                                    "small": ""
                                  }
                                }, 'v-chip', attrs, false), [_c('span', {
                                  staticClass: "pr-2"
                                }, [_vm._v("\n                                      " + _vm._s(item) + "\n                                    ")]), _vm._v(" "), _c('v-icon', {
                                  attrs: {
                                    "small": ""
                                  },
                                  on: {
                                    "click": function($event) {
                                      return parent.selectItem(item)
                                    }
                                  }
                                }, [_vm._v("\n                                      $delete\n                                    ")])], 1)]
                              }
                            }], null, true),
                            model: {
                              value: (item.country),
                              callback: function($$v) {
                                _vm.$set(item, "country", $$v)
                              },
                              expression: "item.country"
                            }
                          })], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, _vm._l((item.country), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-1",
                              attrs: {
                                "small": ""
                              }
                            }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
                          }), 1)])]
                        }
                      }, {
                        key: "item.vertical",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.edit) ? _c('div', [_c('v-combobox', {
                            attrs: {
                              "items": _vm.campaignVerticals,
                              "item-text": "name",
                              "item-value": "name",
                              "hide-selected": "",
                              "dense": "",
                              "outlined": "",
                              "label": "Campaign Vertical",
                              "multiple": ""
                            },
                            scopedSlots: _vm._u([{
                              key: "selection",
                              fn: function(ref) {
                                var attrs = ref.attrs;
                                var item = ref.item;
                                var parent = ref.parent;
                                var selected = ref.selected;

                                return [(item === Object(item)) ? _c('v-chip', _vm._b({
                                  attrs: {
                                    "input-value": selected,
                                    "label": "",
                                    "small": ""
                                  }
                                }, 'v-chip', attrs, false), [_c('span', {
                                  staticClass: "pr-2"
                                }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                    ")]), _vm._v(" "), _c('v-icon', {
                                  attrs: {
                                    "small": ""
                                  },
                                  on: {
                                    "click": function($event) {
                                      return parent.selectItem(item)
                                    }
                                  }
                                }, [_vm._v("\n                                      $delete\n                                    ")])], 1) : _vm._e()]
                              }
                            }], null, true),
                            model: {
                              value: (item.vertical),
                              callback: function($$v) {
                                _vm.$set(item, "vertical", $$v)
                              },
                              expression: "item.vertical"
                            }
                          })], 1) : _c('div', {
                            staticClass: "item-edit"
                          }, [_c('td', {
                            staticClass: "text-xs-left"
                          }, _vm._l((item.vertical), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-1",
                              attrs: {
                                "small": ""
                              }
                            }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
                          }), 1)])]
                        }
                      }, {
                        key: "item.assignedTo",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.assignedTo) ? _c('div', _vm._l((item.assignedTo), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-2",
                              attrs: {
                                "value": item,
                                "filter": "",
                                "small": ""
                              }
                            }, [_c('v-avatar', {
                              staticStyle: {
                                "margin-right": "5px"
                              }
                            }, [_c('v-icon', {
                              attrs: {
                                "small": ""
                              }
                            }, [_vm._v("account_circle")])], 1), _vm._v("\n                                " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                              ")], 1)
                          }), 1) : _vm._e()]
                        }
                      }, {
                        key: "item.assignedToAM",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(item.assignedToAM) ? _c('div', _vm._l((item.assignedToAM), function(item, index) {
                            return _c('v-chip', {
                              key: index,
                              staticClass: "ma-2",
                              attrs: {
                                "value": item,
                                "filter": "",
                                "small": ""
                              }
                            }, [_c('v-avatar', {
                              staticStyle: {
                                "margin-right": "5px"
                              }
                            }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                                " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                              ")], 1)
                          }), 1) : _vm._e()]
                        }
                      }, {
                        key: "item.action",
                        fn: function(ref) {
                          var item = ref.item;

                          return [(!item.edit) ? _c('div', [(_vm.buttonShow('edit')) ? _c('v-btn', {
                            staticClass: "ims-action",
                            attrs: {
                              "small": "",
                              "color": "secondary"
                            },
                            on: {
                              "click": function($event) {
                                item.edit = true
                              }
                            }
                          }, [_c('v-icon', {
                            attrs: {
                              "xmall": ""
                            }
                          }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
                            staticClass: "ims-action",
                            attrs: {
                              "small": "",
                              "color": "error"
                            },
                            on: {
                              "click": function($event) {
                                return _vm.deleteCampaign(item)
                              }
                            }
                          }, [_c('v-icon', {
                            attrs: {
                              "color": "white",
                              "small": ""
                            }
                          }, [_vm._v("delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.edit) ? _c('div', [_c('v-btn', {
                            staticClass: "mb-2",
                            attrs: {
                              "color": "success",
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return _vm.saveCampaign(item)
                              }
                            }
                          }, [_vm._v("Save")]), _vm._v(" "), (item.id === 0) ? _c('v-btn', {
                            attrs: {
                              "color": "secondary",
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return _vm.cancelCampaignRow(item)
                              }
                            }
                          }, [_vm._v("\n                                Cancel\n                              ")]) : _c('v-btn', {
                            attrs: {
                              "color": "secondary",
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                item.edit = false
                              }
                            }
                          }, [_vm._v("\n                                Cancel\n                              ")])], 1) : _vm._e()]
                        }
                      }], null, true)
                    })], 1) : _vm._e()]
                  }
                }], null, true)
              })], 1)]
            }
          }], null, true),
          model: {
            value: (_vm.selectedClients),
            callback: function($$v) {
              _vm.selectedClients = $$v
            },
            expression: "selectedClients"
          }
        })], 1) : _c('td', {
          staticClass: "client-expanded-cell",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "client-nested-table client-deal-table elevation-1",
          attrs: {
            "striped": "",
            "bordered": "",
            "hover": "",
            "responsive": "",
            "headers": _vm.dealFields,
            "items": item.deals,
            "show-expand": "",
            "expanded": _vm.expanded,
            "item-key": "index",
            "single-select": false
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "item.data-table-expand",
            fn: function(ref) {
              var item = ref.item;
              var expand = ref.expand;
              var isExpanded = ref.isExpanded;

              return [_c('span', [(isExpanded) ? _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(false)
                  }
                }
              }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
                on: {
                  "click": function($event) {
                    return expand(true)
                  }
                }
              }, [_vm._v("mdi-chevron-down")])], 1)]
            }
          }, {
            key: "item.linkedIOs",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', {
                staticClass: "text-xs-left"
              }, [(item.linkedIOs) ? _c('span', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))]) : _vm._e()])]
            }
          }, {
            key: "item.budget",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', {
                staticClass: "text-xs-left"
              }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])]
            }
          }, {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-menu', {
                attrs: {
                  "offset-y": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;
                    var attrs = ref.attrs;

                    return [_c('v-btn', _vm._g(_vm._b({
                      attrs: {
                        "color": "secondary",
                        "small": ""
                      }
                    }, 'v-btn', attrs, false), on), [_vm._v("\n                      Allocate\n                    ")])]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
                attrs: {
                  "link": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.addAllocate(item, 'custom')
                  }
                }
              }, [_c('v-list-item-title', [_vm._v("New")])], 1), _vm._v(" "), _c('v-list-item', {
                on: {
                  "click": function($event) {
                    return _vm.addAllocate(item, 'all')
                  }
                }
              }, [_c('v-list-item-title', [_vm._v("All")])], 1)], 1)], 1)]
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [(item.campaigns) ? _c('td', {
                staticClass: "client-expanded-cell",
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-hover', {
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function(ref) {
                    var hover = ref.hover;

                    return [_c('v-card', {
                      class: {
                        'mx-auto mb-2 text-center on-hover': hover,
                        'mx-auto mb-2 text-center': !hover
                      },
                      staticStyle: {
                        "width": "300px"
                      },
                      attrs: {
                        "color": "#363636",
                        "dark": "",
                        "elevation": hover ? 12 : 2
                      }
                    }, [_c('v-card-subtitle', [_c('p', {
                      staticClass: "pa-0 ma-0 custom-font"
                    }, [_vm._v("Used Budget: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getUsedBudgets(item.campaigns))))]), _vm._v(" "), _c('p', {
                      staticClass: "pa-0 ma-0 custom-font"
                    }, [_vm._v("Remain Budgets: $" + _vm._s(_vm._f("thousandSeprator")(_vm.getRemainBudgets(item.campaigns))))])])], 1)]
                  }
                }], null, true)
              }), _vm._v(" "), _c('v-data-table', {
                key: _vm.dataTableKey,
                staticClass: "client-nested-table campaign-data-table client-table-small elevation-1",
                attrs: {
                  "striped": "",
                  "bordered": "",
                  "hover": "",
                  "responsive": "",
                  "headers": _vm.campaignFields,
                  "items": item.campaigns,
                  "item-key": "campaignIndex"
                },
                scopedSlots: _vm._u([{
                  key: "item.name",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Campaign Name"
                      },
                      model: {
                        value: (item.name),
                        callback: function($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-center"
                    }, [_vm._v(_vm._s(item.name))])])]
                  }
                }, {
                  key: "item.partCode",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-center"
                    }, [_vm._v(_vm._s(item.partCode))])]
                  }
                }, {
                  key: "item.outreach",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Outreach"
                      },
                      model: {
                        value: (item.outreach),
                        callback: function($$v) {
                          _vm.$set(item, "outreach", $$v)
                        },
                        expression: "item.outreach"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
                  }
                }, {
                  key: "item.period",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('td', {
                      staticClass: "text-center"
                    }, [_vm._v(_vm._s(item.period))])]
                  }
                }, {
                  key: "item.recognizedRevenue",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.recognizedRevenue !== '') ? _c('td', {
                      staticClass: "text-center"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.recognizedRevenue))))]) : _c('td', {
                      staticClass: "text-center"
                    })]
                  }
                }, {
                  key: "item.unRecognizedRevenue",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.unRecognizedRevenue !== '') ? _c('td', {
                      staticClass: "text-center"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.formatDecimal(item.unRecognizedRevenue))))]) : _c('td', {
                      staticClass: "text-center"
                    })]
                  }
                }, {
                  key: "item.cogs",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.cogs !== '') ? _c('td', {
                      staticClass: "text-center"
                    }, [_vm._v("$" + _vm._s(item.cogs) + " (" + _vm._s(item.cogsPercentage) + "%)")]) : _c('td', {
                      staticClass: "text-center"
                    })]
                  }
                }, {
                  key: "item.budget",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Budget"
                      },
                      model: {
                        value: (item.budget),
                        callback: function($$v) {
                          _vm.$set(item, "budget", $$v)
                        },
                        expression: "item.budget"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])])]
                  }
                }, {
                  key: "item.content",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3 mb-1",
                      attrs: {
                        "type": "number",
                        "hide-details": "",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "min"
                      },
                      model: {
                        value: (item.min_content),
                        callback: function($$v) {
                          _vm.$set(item, "min_content", $$v)
                        },
                        expression: "item.min_content"
                      }
                    }, _vm.on)), _vm._v(" "), _c('p', {
                      staticClass: "text-center ma-0"
                    }, [_vm._v("to")]), _vm._v(" "), _c('v-text-field', _vm._g({
                      staticClass: "input-field mb-1",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "max"
                      },
                      model: {
                        value: (item.max_content),
                        callback: function($$v) {
                          _vm.$set(item, "max_content", $$v)
                        },
                        expression: "item.max_content"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(item.min_content) + " - " + _vm._s(item.max_content))])])]
                  }
                }, {
                  key: "item.engagement",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "Engagement"
                      },
                      model: {
                        value: (item.engagement),
                        callback: function($$v) {
                          _vm.$set(item, "engagement", $$v)
                        },
                        expression: "item.engagement"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagement)))])])]
                  }
                }, {
                  key: "item.kpi_onboarded",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-text-field', _vm._g({
                      staticClass: "input-field mt-3",
                      attrs: {
                        "type": "number",
                        "dense": "",
                        "outlined": "",
                        "placeholder": "KPI Onboarded"
                      },
                      model: {
                        value: (item.kpi_onboarded),
                        callback: function($$v) {
                          _vm.$set(item, "kpi_onboarded", $$v)
                        },
                        expression: "item.kpi_onboarded"
                      }
                    }, _vm.on))], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.kpi_onboarded)))])])]
                  }
                }, {
                  key: "item.campaignType",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-select', {
                      staticClass: "input-field",
                      attrs: {
                        "items": _vm.campaignTypeDisplay,
                        "label": "Product Type",
                        "dense": "",
                        "outlined": ""
                      },
                      model: {
                        value: (item.campaignType),
                        callback: function($$v) {
                          _vm.$set(item, "campaignType", $$v)
                        },
                        expression: "item.campaignType"
                      }
                    })], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, [_vm._v(_vm._s(item.campaignType))])])]
                  }
                }, {
                  key: "item.country",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-combobox', {
                      attrs: {
                        "search-input": _vm.newCountry,
                        "items": _vm.countries,
                        "item-text": "name",
                        "item-value": "code",
                        "hide-selected": "",
                        "chips": "",
                        "label": "Country",
                        "multiple": "",
                        "dense": "",
                        "outlined": ""
                      },
                      on: {
                        "update:searchInput": function($event) {
                          _vm.newCountry = $event
                        },
                        "update:search-input": function($event) {
                          _vm.newCountry = $event
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "selection",
                        fn: function(ref) {
                          var attrs = ref.attrs;
                          var item = ref.item;
                          var parent = ref.parent;
                          var selected = ref.selected;

                          return [(item === Object(item)) ? _c('v-chip', _vm._b({
                            attrs: {
                              "input-value": selected,
                              "label": "",
                              "small": ""
                            }
                          }, 'v-chip', attrs, false), [_c('span', {
                            staticClass: "pr-2"
                          }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('v-icon', {
                            attrs: {
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return parent.selectItem(item)
                              }
                            }
                          }, [_vm._v("\n                                $delete\n                              ")])], 1) : _c('v-chip', _vm._b({
                            attrs: {
                              "input-value": selected,
                              "label": "",
                              "small": ""
                            }
                          }, 'v-chip', attrs, false), [_c('span', {
                            staticClass: "pr-2"
                          }, [_vm._v("\n                                " + _vm._s(item) + "\n                              ")]), _vm._v(" "), _c('v-icon', {
                            attrs: {
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return parent.selectItem(item)
                              }
                            }
                          }, [_vm._v("\n                                $delete\n                              ")])], 1)]
                        }
                      }], null, true),
                      model: {
                        value: (item.country),
                        callback: function($$v) {
                          _vm.$set(item, "country", $$v)
                        },
                        expression: "item.country"
                      }
                    })], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, _vm._l((item.country), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-1",
                        attrs: {
                          "small": ""
                        }
                      }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
                    }), 1)])]
                  }
                }, {
                  key: "item.vertical",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.edit) ? _c('div', [_c('v-combobox', {
                      attrs: {
                        "items": _vm.campaignVerticals,
                        "item-text": "name",
                        "item-value": "name",
                        "hide-selected": "",
                        "dense": "",
                        "outlined": "",
                        "label": "Campaign Vertical",
                        "multiple": ""
                      },
                      scopedSlots: _vm._u([{
                        key: "selection",
                        fn: function(ref) {
                          var attrs = ref.attrs;
                          var item = ref.item;
                          var parent = ref.parent;
                          var selected = ref.selected;

                          return [(item === Object(item)) ? _c('v-chip', _vm._b({
                            attrs: {
                              "input-value": selected,
                              "label": "",
                              "small": ""
                            }
                          }, 'v-chip', attrs, false), [_c('span', {
                            staticClass: "pr-2"
                          }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('v-icon', {
                            attrs: {
                              "small": ""
                            },
                            on: {
                              "click": function($event) {
                                return parent.selectItem(item)
                              }
                            }
                          }, [_vm._v("\n                                $delete\n                              ")])], 1) : _vm._e()]
                        }
                      }], null, true),
                      model: {
                        value: (item.vertical),
                        callback: function($$v) {
                          _vm.$set(item, "vertical", $$v)
                        },
                        expression: "item.vertical"
                      }
                    })], 1) : _c('div', {
                      staticClass: "item-edit"
                    }, [_c('td', {
                      staticClass: "text-xs-left"
                    }, _vm._l((item.vertical), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-1",
                        attrs: {
                          "small": ""
                        }
                      }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
                    }), 1)])]
                  }
                }, {
                  key: "item.assignedTo",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.assignedTo) ? _c('div', _vm._l((item.assignedTo), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-2",
                        attrs: {
                          "value": item,
                          "filter": ""
                        }
                      }, [_c('v-avatar', {
                        staticStyle: {
                          "margin-right": "5px"
                        }
                      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
                    }), 1) : _vm._e()]
                  }
                }, {
                  key: "item.assignedToAM",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.assignedToAM) ? _c('div', _vm._l((item.assignedToAM), function(item, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-2",
                        attrs: {
                          "value": item,
                          "filter": ""
                        }
                      }, [_c('v-avatar', {
                        staticStyle: {
                          "margin-right": "5px"
                        }
                      }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
                    }), 1) : _vm._e()]
                  }
                }, {
                  key: "item.action",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(!item.edit) ? _c('div', [(_vm.buttonShow('edit')) ? _c('v-btn', {
                      staticClass: "ims-action",
                      attrs: {
                        "small": "",
                        "color": "secondary"
                      },
                      on: {
                        "click": function($event) {
                          item.edit = true
                        }
                      }
                    }, [_c('v-icon', {
                      attrs: {
                        "xmall": ""
                      }
                    }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
                      staticClass: "ims-action",
                      attrs: {
                        "small": "",
                        "color": "error"
                      },
                      on: {
                        "click": function($event) {
                          return _vm.deleteCampaign(item)
                        }
                      }
                    }, [_c('v-icon', {
                      attrs: {
                        "color": "white",
                        "small": ""
                      }
                    }, [_vm._v("delete")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.edit) ? _c('div', [_c('v-btn', {
                      staticClass: "mb-2",
                      attrs: {
                        "color": "success",
                        "small": ""
                      },
                      on: {
                        "click": function($event) {
                          return _vm.saveCampaign(item)
                        }
                      }
                    }, [_vm._v("Save")]), _vm._v(" "), (item.id === 0) ? _c('v-btn', {
                      attrs: {
                        "color": "secondary",
                        "small": ""
                      },
                      on: {
                        "click": function($event) {
                          return _vm.cancelCampaignRow(item)
                        }
                      }
                    }, [_vm._v("\n                          Cancel\n                        ")]) : _c('v-btn', {
                      attrs: {
                        "color": "secondary",
                        "small": ""
                      },
                      on: {
                        "click": function($event) {
                          item.edit = false
                        }
                      }
                    }, [_vm._v("\n                          Cancel\n                        ")])], 1) : _vm._e()]
                  }
                }], null, true)
              })], 1) : _vm._e()]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true),
    model: {
      value: (_vm.selectedClients),
      callback: function($$v) {
        _vm.selectedClients = $$v
      },
      expression: "selectedClients"
    }
  })], 1)], 1), _vm._v(" "), _c('create-client-modal', {
    on: {
      "createClient": _vm.createClient
    },
    model: {
      value: (_vm.createClientDialog),
      callback: function($$v) {
        _vm.createClientDialog = $$v
      },
      expression: "createClientDialog"
    }
  }), _vm._v(" "), _c('edit-client-modal', {
    attrs: {
      "clientData": _vm.editClientData,
      "viewMode": _vm.isViewMode
    },
    on: {
      "editClient": _vm.editClient
    },
    model: {
      value: (_vm.editClientDialog),
      callback: function($$v) {
        _vm.editClientDialog = $$v
      },
      expression: "editClientDialog"
    }
  }), _vm._v(" "), _c('update-client-user-modal', {
    attrs: {
      "clientLoginData": _vm.updateClientLoginData,
      "existingAccounts": _vm.existingAccounts
    },
    on: {
      "reRenderDataTable": _vm.reRenderDataTable
    },
    model: {
      value: (_vm.updateClientLoginModal),
      callback: function($$v) {
        _vm.updateClientLoginModal = $$v
      },
      expression: "updateClientLoginModal"
    }
  }), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  }), _vm._v(" "), _c('client-group-modal', {
    attrs: {
      "selectedClients": _vm.selectedClients
    },
    on: {
      "saved": _vm.savedClientGroup
    },
    model: {
      value: (_vm.clientGroupDialog),
      callback: function($$v) {
        _vm.clientGroupDialog = $$v
      },
      expression: "clientGroupDialog"
    }
  }), _vm._v(" "), _c('custom-amount-update-modal', {
    attrs: {
      "value": _vm.customAmountUpdateDialog,
      "dealData": _vm.viewDealData
    },
    on: {
      "addedAmount": _vm.allocateCampaign
    },
    model: {
      value: (_vm.customAmountUpdateDialog),
      callback: function($$v) {
        _vm.customAmountUpdateDialog = $$v
      },
      expression: "customAmountUpdateDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "custom-card-title"
  }, [_vm._v("\n        Please complete your Billing Information for the payment process.\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("Full Name "), _c('small', [_vm._v("(as per bank account)")])]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.fullName),
      callback: function($$v) {
        _vm.$set(_vm.editData, "fullName", $$v)
      },
      expression: "editData.fullName"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Country")]), _vm._v(" "), _c('td', [_c('div', [_c('v-select', {
    attrs: {
      "label": "Country",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "attach": "",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "change": _vm.changeCountry
    },
    model: {
      value: (_vm.editData.country),
      callback: function($$v) {
        _vm.$set(_vm.editData, "country", $$v)
      },
      expression: "editData.country"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bank Name")]), _vm._v(" "), _c('td', [_c('div', [_c('v-combobox', {
    staticClass: "edit-field",
    attrs: {
      "items": _vm.bankNames,
      "item-text": "bank",
      "item-value": "bank",
      "search-input": _vm.newBankName,
      "attach": "",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newBankName = $event
      },
      "update:search-input": function($event) {
        _vm.newBankName = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.editData.bankName),
      callback: function($$v) {
        _vm.$set(_vm.editData, "bankName", $$v)
      },
      expression: "editData.bankName"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bank Account Number")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#################'),
      expression: "'#################'"
    }],
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.editData, "bankAccount", $$v)
      },
      expression: "editData.bankAccount"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Billing Email")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.billingEmail),
      callback: function($$v) {
        _vm.$set(_vm.editData, "billingEmail", $$v)
      },
      expression: "editData.billingEmail"
    }
  }, _vm.on))], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mailing Address")]), _vm._v(" "), _c('td', [_c('div', [_c('v-text-field', _vm._g({
    staticClass: "edit-field",
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.editData, "mailingAddress", $$v)
      },
      expression: "editData.mailingAddress"
    }
  }, _vm.on))], 1)])])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "disabled": _vm.$v.editData.$invalid
    },
    on: {
      "click": _vm.saveBillingInfo
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "content-class": "view-post-detail-modal",
      "max-width": "900px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    on: {
      "input": function($event) {
        return _vm.$emit('detailClosed')
      }
    },
    model: {
      value: (_vm.detailValue),
      callback: function($$v) {
        _vm.detailValue = $$v
      },
      expression: "detailValue"
    }
  }, [(_vm.postData !== null) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "text-no-wrap font-weight-bold"
        }, on), [_vm._v(_vm._s(_vm.campaignName) + " Campaign")])]
      }
    }], null, false, 1423457430)
  }, [_vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('span', [_vm._v("Submitted as "), _c('strong', [_vm._v(_vm._s(_vm.submittedCampaignName || _vm.campaignName + ' (Unverified)'))])]) : _vm._e()])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeDetailModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-post-detail-modal__body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "md": "12",
      "xs": "12"
    }
  }, [_vm._l((_vm.postDetails), function(postData, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "md": "8",
        "xs": "12"
      }
    }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      staticClass: "text-right",
      attrs: {
        "xs": "12"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-history")]), _vm._v(" " + _vm._s(_vm.formatDate(postData.createdAt)) + "\n                        ")], 1)], 1), _vm._v(" "), (_vm.influencerData && !_vm.mappedInfluencerData) ? _c('div', [_c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      attrs: {
        "xs": "6"
      }
    }, [(_vm.influencerData.platform === 'tiktok') ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#0A66C2",
        "small": ""
      }
    }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
      attrs: {
        "href": 'https://x.com/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/x-logo.svg",
        "width": "15px",
        "alt": "",
        "aria-hidden": "true"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "xs": "6"
      }
    }, [(postData.type) ? _c('v-chip', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm._f("platformDisplayName")(postData.type)) + "\n                            ")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mappedInfluencerData && _vm.currentUserRole <= _vm.userRoles.AD_STRATEGIST) ? _c('div', [_c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-col', {
      attrs: {
        "xs": "6"
      }
    }, [(_vm.mappedInfluencerData.tiktokHandle) ? _c('a', {
      attrs: {
        "href": 'https://tiktok.com/' + _vm.mappedInfluencerData.tiktokHandle,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.tiktokHandle))]) : (_vm.mappedInfluencerData.youtubeHandle) ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + _vm.mappedInfluencerData.youtubeHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.youtubeHandle))], 1) : (_vm.mappedInfluencerData.linkedinHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + _vm.mappedInfluencerData.linkedinHandle,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#0A66C2",
        "small": ""
      }
    }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.linkedinHandle))], 1) : (postData.type === 'twitter' || _vm.mappedInfluencerData.twitterHandle) ? _c('a', {
      attrs: {
        "href": 'https://x.com/' + (_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/x-logo.svg",
        "width": "15px",
        "alt": "",
        "aria-hidden": "true"
      }
    }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle))]) : _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + _vm.mappedInfluencerData.instagramHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.instagramHandle))], 1)]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "xs": "6"
      }
    }, [(postData.type) ? _c('v-chip', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm._f("platformDisplayName")(postData.type)) + "\n                            ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
      attrs: {
        "cols": "12"
      }
    }, [(_vm.influencerData) ? _c('v-col', {
      staticClass: "text-center"
    }, [_c('p', [_vm._v("\n                            Submitted By:\n                            "), _vm._v(" "), (_vm.influencerData.platform === 'tiktok') ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#0A66C2",
        "small": ""
      }
    }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
      attrs: {
        "href": 'https://x.com/' + _vm.influencerData.username,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/x-logo.svg",
        "width": "15px",
        "alt": "",
        "aria-hidden": "true"
      }
    }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + _vm.influencerData.username,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-sm": "",
        "container--fluid": ""
      }
    }, [_c('v-alert', {
      attrs: {
        "value": postData.images.length === 0,
        "color": "info",
        "icon": "info",
        "outlined": ""
      }
    }, [_vm._v("\n                          No Media found for this post.\n                        ")]), _vm._v(" "), (postData.images !== undefined) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": "",
        "justify-space-around": ""
      }
    }, _vm._l((postData.images), function(img) {
      return _c('v-flex', {
        key: img.url,
        attrs: {
          "md4": "",
          "xs12": ""
        }
      }, [(img.publicID && img.isvideo) ? _c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('custom-media-v2', {
        attrs: {
          "media": _vm.campaignHelper.customPostMediaConfig(img, {
            videoDownload: true
          })
        }
      })], 1) : _c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [(!img.isvideo) ? _c('v-hover', [(img.publicID) ? _c('div', {
        staticClass: "post-cld-img cursor-pointer",
        on: {
          "click": function($event) {
            return _vm.viewMedia(img)
          }
        }
      }, [_c('custom-media-v2', {
        attrs: {
          "media": _vm.campaignHelper.customPostMediaConfig(img, {
            trans: {
              width: 320,
              crop: 'scale'
            }
          })
        }
      })], 1) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.thumbnail || img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url, img.video)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (img.isvideo) ? _c('div', {
        staticClass: "elevation-8"
      }, [_c('video', {
        attrs: {
          "id": "previewVideo",
          "width": "100%",
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": img.url,
          "type": "video/mp4"
        }
      }), _vm._v("\n                                  Your browser does not support the video tag.\n                                ")])]) : _vm._e()], 1), _vm._v(" "), (img.type === 'video/quicktime') ? _c('btn-download', {
        attrs: {
          "url": img.url
        }
      }) : _vm._e()], 1)
    }), 1) : _vm._e()], 1), _vm._v(" "), (postData.captionText) ? _c('div', {
      staticClass: "body-1"
    }, [_c('v-textarea', {
      staticClass: "post-caption-textarea",
      attrs: {
        "readonly": "",
        "filled": "",
        "auto-grow": "",
        "rows": "4",
        "label": "Caption",
        "counter": ""
      },
      model: {
        value: (postData.captionText),
        callback: function($$v) {
          _vm.$set(postData, "captionText", $$v)
        },
        expression: "postData.captionText"
      }
    })], 1) : _vm._e(), _vm._v(" "), (postData.type === 'story' || postData.type === 'video' || postData.type === 'reel' || postData.type === 'tiktok' || postData.type === 'youtube' || postData.type === 'facebook') ? _c('div', [(postData.vdoLink) ? _c('div', {
      staticClass: "caption-label"
    }, [_vm._v(" \n                          Link\n                        ")]) : _vm._e(), _vm._v(" "), (postData.vdoLink) ? _c('div', {
      staticClass: "caption-text"
    }, [_vm._v("\n                          " + _vm._s(postData.vdoLink) + "\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (postData.type === 'story' && _vm.currentUserRole !== 5) ? _c('div', {
      staticClass: "body-1"
    }, [_c('v-textarea', {
      attrs: {
        "readonly": "",
        "filled": "",
        "auto-grow": "",
        "rows": "4",
        "label": "Remark",
        "counter": ""
      },
      model: {
        value: (postData.remark),
        callback: function($$v) {
          _vm.$set(postData, "remark", $$v)
        },
        expression: "postData.remark"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": ""
      }
    }, [(postData.postDate) ? _c('div', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('v-chip', {
      staticClass: "subheading ma-1",
      attrs: {
        "label": ""
      }
    }, [_c('span', [_vm._v("Scheduled: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(postData.postDate))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(postData.postDateEnd ? ("  to " + (postData.postDateEnd)) : ''))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('v-chip', {
      staticClass: "subheading ma-1",
      attrs: {
        "label": ""
      }
    }, [_c('span', [_vm._v("Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.loadPostStatusDisplay(postData)))])])], 1), _vm._v(" "), (postData.postURL) ? _c('div', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('v-chip', {
      staticClass: "subtitle-1 ma-1",
      attrs: {
        "label": ""
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('strong', [_c('a', {
      attrs: {
        "href": postData.postURL,
        "target": "_blink"
      }
    }, [_vm._v("View Live Post")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.postReviewApproved) ? _c('v-flex', {
      attrs: {
        "centered": ""
      }
    }, [(postData.clientAcceptReview) ? _c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-center",
      attrs: {
        "md6": "",
        "xs12": ""
      }
    }, [_c('p', {
      staticClass: "subtitle-1"
    }, [_vm._v("Rating on influencer's quality of work")]), _vm._v(" "), _c('v-rating', {
      staticClass: "ma-5",
      attrs: {
        "color": "secondary",
        "size": "30",
        "readonly": "",
        "dense": ""
      },
      model: {
        value: (postData.clientAcceptReview.rate),
        callback: function($$v) {
          _vm.$set(postData.clientAcceptReview, "rate", $$v)
        },
        expression: "postData.clientAcceptReview.rate"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(postData.clientAcceptReview.rate) + "/5 stars Rated")])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-center",
      attrs: {
        "md6": "",
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "subtitle-1",
      attrs: {
        "max-width": "100"
      }
    }, [_c('p', [_vm._v("Comment for Influencer")]), _vm._v(" "), _c('v-textarea', {
      attrs: {
        "text": "",
        "filled": "",
        "readonly": ""
      },
      model: {
        value: (postData.clientAcceptReview.comment),
        callback: function($$v) {
          _vm.$set(postData.clientAcceptReview, "comment", $$v)
        },
        expression: "postData.clientAcceptReview.comment"
      }
    })], 1)])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.postAbuseHistory && postData.clientReportAbuse.length > 0) ? _c('v-col', {
      attrs: {
        "md": "4",
        "xs": "12"
      }
    }, [_c('v-expansion-panels', {
      staticClass: "detail-report-abuse-section"
    }, _vm._l((postData.clientReportAbuse), function(item, i) {
      return _c('v-expansion-panel', {
        key: i
      }, [_c('v-expansion-panel-header', [_c('div', {
        staticClass: "subtitle-1",
        attrs: {
          "color": "red lighten-4"
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "deep-orange"
        }
      }, [_vm._v("report_problem")]), _vm._v("\n                          Reported Abuse\n                        ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', {
        staticClass: "report-abuse-expansion"
      }, [_c('v-card', [_c('v-card-text', {
        staticClass: "grey lighten-3 pl-1 pr-1"
      }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
        return _c('li', {
          key: r
        }, [_vm._v(_vm._s(r))])
      }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Abuse:")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "max-height": "300px",
          "min-height": "200px",
          "overflow-y": "auto"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.renderHTML(item.comment))
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "text-xs-right caption font-weight-italic"
      }, [_vm._v(_vm._s(_vm.formatDate(item.date)))]), _vm._v(" "), (item.files) ? _c('div', [_c('h4', [_vm._v("Uploaded Screenshots:")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.files), function(f, index) {
        return _c('li', {
          key: index
        }, [(f.url) ? _c('a', {
          attrs: {
            "href": f.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.utilsFunc.getFileNameFromURL(f.url)))]) : _vm._e()])
      }), 0)])]) : _vm._e()])], 1)], 1)], 1)
    }), 1)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('v-card', [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDetailModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 2)], 1), _vm._v(" "), _c('post-media-viewer-modal', {
    attrs: {
      "viewerValue": _vm.mediaViewerDialog,
      "media": _vm.mediaItem,
      "videoPlayer": _vm.videoPlayer
    },
    on: {
      "closed": _vm.closeMediaViewerModal
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.reportData.campaign) ? _c('div', {
    attrs: {
      "id": "internal-report-summary"
    }
  }, [(_vm.reportData.campaign.enablePostAnalysis && _vm.postsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "postSummary"
    }
  }, [_c('post-summary', {
    attrs: {
      "posts": _vm.postsAnalysisData,
      "defaultCols": _vm.defaultPostsAnalysisStatus,
      "campaign": _vm.reportData.campaign,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('post', 'IG Post', _vm.postsAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableReelAnalysis && _vm.reelAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "reelSummary"
    }
  }, [_c('reel-summary', {
    attrs: {
      "posts": _vm.reelAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultReelAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('reel', 'IG Reel', _vm.reelAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storyAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "storySummary"
    }
  }, [_c('story-summary', {
    attrs: {
      "posts": _vm.storyAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultStoryAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('story', 'IG Story', _vm.storyAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTikTokAnalysis && _vm.tikTokAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "tiktokSummary"
    }
  }, [_c('tiktok-summary', {
    attrs: {
      "posts": _vm.tikTokAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultTikTokAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('tiktok', 'TikTok Post', _vm.tikTokAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableYoutubeAnalysis && _vm.youtubeAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "youtubeSummary"
    }
  }, [_c('youtube-summary', {
    attrs: {
      "posts": _vm.youtubeAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultYoutubeAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('youtube', 'YouTube Post', _vm.youtubeAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableFbAnalysis && _vm.fbAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "fbSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "posts": _vm.fbAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultFbAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('facebook', 'Facebook', _vm.fbAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLinkedInAnalysis && _vm.linkedInAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "linkedInSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "linkedin",
      "posts": _vm.linkedInAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultLinkedInAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('linkedin', 'LinkedIn', _vm.linkedInAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTwitterAnalysis && _vm.twitterAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "twitterSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "twitter",
      "posts": _vm.twitterAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultTwitterAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        _vm.openAi('twitter', 'X (Twitter)', _vm.twitterAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableXHSAnalysis && _vm.xhsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "xhsSummary"
    }
  }, [_c('xhs-summary', {
    attrs: {
      "posts": _vm.xhsAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultXhsAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('xhs', 'XHS', _vm.xhsAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLemonAnalysis && _vm.lemonAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "lemonSummary"
    }
  }, [_c('lemon-summary', {
    attrs: {
      "posts": _vm.lemonAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultLemonAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('lemon', 'Lemon8', _vm.lemonAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('table-ai-analysis-modal', {
    attrs: {
      "campaign": _vm.reportData.campaign,
      "posts": _vm.aiPosts,
      "typeKey": _vm.aiTypeKey,
      "label": _vm.aiLabel
    },
    model: {
      value: (_vm.aiDialog),
      callback: function($$v) {
        _vm.aiDialog = $$v
      },
      expression: "aiDialog"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instagram-post-embed"
  }, [(_vm.permalink) ? _c('blockquote', {
    key: _vm.permalink,
    staticClass: "instagram-media",
    attrs: {
      "data-instgrm-permalink": _vm.permalink,
      "data-instgrm-version": "14"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.permalink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("View on Instagram")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "1000px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Travel Form\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('v-row', _vm._l((_vm.travelFormData), function(tallyForm, title) {
    return (!_vm.excludeTitles.includes(title) && tallyForm !== null) ? _c('v-col', {
      key: title,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('label', [_vm._v(_vm._s(title))]), _vm._v(" "), (Array.isArray(tallyForm)) ? _c('div', [_vm._v("\n            " + _vm._s(tallyForm.join(', ') || '-') + "\n          ")]) : _c('div', [_vm._v("\n            " + _vm._s(tallyForm || '-') + "\n          ")])]) : _vm._e()
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('speed-stages', {
    attrs: {
      "filterUser": _vm.filterUser
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "transition": "fade-transition",
      "fullscreen": "",
      "no-click-animation": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "#3F3FFF",
      "elevation": 1
    }
  }, [_c('v-toolbar-title', [_c('v-text-field', {
    staticClass: "pairing-list-title-input col-12 mt-3 pr-2 float-left",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "label": "Enter Title",
      "hide-details": ""
    },
    model: {
      value: (_vm.infListTitle),
      callback: function($$v) {
        _vm.infListTitle = $$v
      },
      expression: "infListTitle"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-col', {
    staticClass: "col-md-5 col-xs-5",
    attrs: {
      "align": "center"
    }
  }, [_c('h3', {
    staticClass: "mb-1"
  }, [_vm._v("Find influencers manually")]), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-text-field', {
    staticClass: "col-8 mt-3 pr-2 float-left",
    attrs: {
      "label": _vm.searchInfluencer === 'Youtube' ? 'Enter Handle' : 'Enter handle',
      "hide-details": "",
      "outlined": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchManually(_vm.searchType)
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-select', {
    staticClass: "col-4 mt-3 float-left",
    attrs: {
      "items": _vm.searchInfluencerTypes,
      "outlined": "",
      "attach": ""
    },
    model: {
      value: (_vm.searchInfluencer),
      callback: function($$v) {
        _vm.searchInfluencer = $$v
      },
      expression: "searchInfluencer"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  }), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('k-influencer-search-box', {
    attrs: {
      "search": _vm.searchKeywordAction
    },
    on: {
      "result": _vm.resultFromSearchKeyword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType !== _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "float-right mt-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchManually(_vm.searchType)
      }
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('v-btn', {
    staticClass: "mt-2 float-right",
    attrs: {
      "disabled": !_vm.historySearchResult,
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showResult(_vm.historySearchResult)
      }
    }
  }, [_vm._v("View search results")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "-45px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "7"
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "7",
      "lg": "7"
    }
  }, [_c('div', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "5"
    }
  }, [(_vm.items && _vm.items.length > 0) ? _c('download-excel', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.items,
      "fields": _vm.json_fields,
      "worksheet": "Creators",
      "name": "creator_lists.xls"
    }
  }, [_vm._v("Download Excel")]) : _vm._e(), _vm._v(" "), (_vm.actionSelected.length > 0 && !_vm.disableLockedCOGS) ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("delete")]), _vm._v(" Delete")], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "item-key": "dataTableKey",
      "search": _vm.searchFilter,
      "items-per-page": 20,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllPairings
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return _vm._l((props.items), function(item, parentIndex) {
          return _c('tr', {
            key: item.instagram,
            class: {
              'danger': !item.success && !item.isLoading
            }
          }, [_c('td', {
            staticStyle: {
              "min-width": "100px",
              "padding": "0 14px!important"
            }
          }, [_c('v-checkbox', {
            staticClass: "multi-select-checkbox",
            staticStyle: {
              "padding-left": "20px"
            },
            attrs: {
              "label": "",
              "color": "grey darken-2"
            },
            on: {
              "change": _vm.actionSelectChange
            },
            model: {
              value: (item.isDelete),
              callback: function($$v) {
                _vm.$set(item, "isDelete", $$v)
              },
              expression: "item.isDelete"
            }
          })], 1), _vm._v(" "), (_vm.displayFields('influencer')) ? _c('td', {
            staticStyle: {
              "min-width": "200px",
              "max-width": "200px"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isFacebook": item.platform === 'facebook',
              "isYoutube": item.platform === 'youtube',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "tiktokHandle": item.userHandle,
              "instagramHandle": item.userHandle,
              "facebookHandle": item.userHandle,
              "youtubeHandle": item.userHandle,
              "xiaohongshuHandle": item.xhsID,
              "xiaohongshuFullName": item.fullName,
              "youtubeURL": item.url
            }
          }), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (!item.isLoading && item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && !item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e(), _vm._v(" "), (item.socialDataErrMessage) ? _c('p', {
            staticClass: "text-danger mb-0"
          }, [_vm._v("(" + _vm._s(item.socialDataErrMessage) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === false && _vm.displayFields('remark')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'remark')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": "",
              "max-width": "300px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_c('p', {
                  staticClass: "remark-text"
                }, [_vm._v(_vm._s(item.remarks || '-'))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.renderRemark(item.remarks))
            }
          })])], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-textarea', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.remarks),
              callback: function($$v) {
                _vm.$set(item, "remarks", $$v)
              },
              expression: "item.remarks"
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('gender')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.genderEdit) ? _c('div', [(!item.genderEdit) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.gender || '-'))]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('ageGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.ageGroupEdit) ? _c('div', [_c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.age_group || '-'))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audAgeGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', [((!item.audAges || (Array.isArray(item.audAges) && item.audAges.length === 0)) && (!item.topAudAges || (Array.isArray(item.topAudAges) && item.topAudAges.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.audAges) && Array.isArray(item.topAudAges)) ? _c('div', [((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit) ? _c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit),
                    expression: "(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [(item.topAudAges && item.topAudAges.length) ? _c('span', [_vm._v("\n                                      " + _vm._s(item.topAudAges ? item.topAudAges[0] : '-') + "\n                                    ")]) : _c('span', [_vm._v("\n                                      " + _vm._s(item.audAges.length ? item.audAges[0].code : '-') + "\n                                    ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Age Group (Majority)")]), _vm._v(" "), (item.audAgesDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.audAgesDisplay), function(audAge, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(audAge.code))]), _vm._v(" "), (audAge.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((audAge.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audAges), function(age, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(age.code))]), _vm._v(" "), _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((age.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.audAgesEdit) ? _c('div') : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('country')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.audCountryEdit) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "120px",
              "max-width": "320px"
            },
            attrs: {
              "items": _vm.locationItems,
              "item-text": "name",
              "item-value": "name",
              "hide-details": "",
              "dense": "",
              "multiple": ""
            },
            on: {
              "change": function($event) {
                return _vm.checkSelectLimit(item, 'topCountries')
              }
            },
            model: {
              value: (item.topCountries),
              callback: function($$v) {
                _vm.$set(item, "topCountries", $$v)
              },
              expression: "item.topCountries"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "success btn-edit-mth mr-1",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'topCountries')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "white",
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "red btn-edit-mth",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audCountryEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "white",
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), ((!item.countries || (Array.isArray(item.countries) && item.countries.length === 0)) && (!item.topCountries || (Array.isArray(item.topCountries) && item.topCountries.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.countries) && Array.isArray(item.topCountries)) ? _c('div', [_c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
              expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
                    expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [(item.topCountries && item.topCountries.length) ? _c('span', [_vm._v("\n                                    " + _vm._s(item.topCountries ? item.topCountries[0] : '-') + "\n                                  ")]) : _c('span', [_vm._v("\n                                    " + _vm._s(item.countries.length ? item.countries[0].name : '-') + "\n                                  ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Country (Majority)")]), _vm._v(" "), (item.topCountryDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.topCountryDisplay), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.countries), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.audCountryEdit) ? _c('div') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('followers')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.followers ? _vm.formatNumber(item.followers) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('genderPercentage')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticStyle: {
              "width": "75px"
            }
          }, [(item.audience_genders && item.audience_genders.length > 0) ? _c('PieChart', {
            attrs: {
              "name": ("genderPie" + parentIndex),
              "title": _vm.genderPie.title,
              "labels": _vm.genderPie.labels,
              "backgroundColors": _vm.genderPie.backgroundColors,
              "items": _vm.getGenderPieData(item.audience_genders),
              "options": _vm.genderPie.options,
              "width": _vm.genderPie.width,
              "height": _vm.genderPie.height
            }
          }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audienceCred')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": "",
              "color": item.audience_credibility_color,
              "text-color": "white"
            }
          }, [_vm._v(_vm._s(item.audience_credibility) + "%")]), _vm._v(" "), (item.message) ? _c('span', {
            staticClass: "text-danger"
          }, [_vm._v("(" + _vm._s(item.message) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgLikes')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_likes ? _vm.formatNumber(item.avg_likes) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgComments')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_comments ? _vm.formatNumber(item.avg_comments) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgReelsPlays')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_reels_plays ? _vm.formatNumber(item.avg_reels_plays) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgViews')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_views ? _vm.formatNumber(item.avg_views) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgSaves')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_saves ? _vm.formatNumber(item.avg_saves) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgShares')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_shares ? _vm.formatNumber(item.avg_shares) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('medianEngagementRate')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.median_engagement_rate ? ((item.median_engagement_rate) + "%") : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('infInterests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.infInterests || item.infInterests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.infInterests),
              expression: "item.infInterests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.infInterests && item.infInterests.length > 0),
                    expression: "item.infInterests && item.infInterests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + item.id,
                    "color": "secondary",
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                More...\n                              ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Influencer Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index !== 0),
                expression: "index !== 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('interests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.audience_interests || item.audience_interests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.audience_interests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.audience_interests),
              expression: "item.audience_interests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.audience_interests && item.audience_interests.length > 0),
                    expression: "item.audience_interests && item.audience_interests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "color": "secondary",
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                  More...\n                                ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Audience Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audience_interests), function(interest, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))]), _vm._v(" "), _c('span', {
              staticStyle: {}
            }, [_vm._v("(" + _vm._s((interest.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('engagement')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.engagement_rate && item.engagement_rate !== '0.00') ? _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")]) : (item.engagement_rate === '0.00') ? _c('span', {
            staticClass: "caption"
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Hidden"
            }
          }, [_vm._v("mdi-eye-off")])], 1) : _c('span', [_vm._v("-")])]) : _vm._e()])
        })
      }
    }]),
    model: {
      value: (_vm.selectAllStatus),
      callback: function($$v) {
        _vm.selectAllStatus = $$v
      },
      expression: "selectAllStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2 text-right"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "color": "warning",
      "target": "_blank"
    },
    on: {
      "click": _vm.invokeSaveInfData
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('influencer-list-modal', {
    attrs: {
      "value1": _vm.showInfluencerSearchResult,
      "result": _vm.influencerSearchResult,
      "influencers": _vm.selected,
      "keyword": _vm.currentKeywordSearch
    },
    on: {
      "input1": _vm.input1,
      "select": _vm.select
    },
    model: {
      value: (_vm.showInfluencerSearchResult),
      callback: function($$v) {
        _vm.showInfluencerSearchResult = $$v
      },
      expression: "showInfluencerSearchResult"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.reasonDialog),
      callback: function($$v) {
        _vm.reasonDialog = $$v
      },
      expression: "reasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Reason for elimination")]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.eliminationReason))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.reasonDialog = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('k-toast', {
    attrs: {
      "variant": _vm.toast.variant,
      "header": _vm.toast.header,
      "content": _vm.toast.content
    }
  }), _vm._v(" "), _c('settings-for-ai-modal', {
    attrs: {
      "value": _vm.settingAIDialog
    },
    on: {
      "paramsUpdated": function($event) {
        return _vm.paramsUpdated()
      }
    },
    model: {
      value: (_vm.settingAIDialog),
      callback: function($$v) {
        _vm.settingAIDialog = $$v
      },
      expression: "settingAIDialog"
    }
  }), _vm._v(" "), _c('settings-for-pairing', {
    attrs: {
      "value": _vm.updatePairingDialog,
      "view-only": _vm.viewOnly,
      "data": _vm.activePairingData
    },
    on: {
      "pairChanged": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.updatePairingDialog),
      callback: function($$v) {
        _vm.updatePairingDialog = $$v
      },
      expression: "updatePairingDialog"
    }
  }), _vm._v(" "), _c('price-multiplier-modal', {
    attrs: {
      "value": _vm.priceMultiplierDialog,
      "pairedInfluencer": _vm.priceMultiplierInfluencerData,
      "campaignData": _vm.campaign,
      "multiple": _vm.isMultipleDeliverables,
      "multipleInfs": _vm.actionSelected
    },
    on: {
      "clearSelected": function($event) {
        return _vm.clearActionSelected()
      },
      "savedFromPriceMultplier": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.priceMultiplierDialog),
      callback: function($$v) {
        _vm.priceMultiplierDialog = $$v
      },
      expression: "priceMultiplierDialog"
    }
  }), _vm._v(" "), _c('full-screen-progress', {
    attrs: {
      "show": _vm.bulkProgress.show,
      "isStatus": "true",
      "processing": _vm.bulkProgress.processing,
      "complete": _vm.bulkProgress.complete,
      "color": _vm.secondary
    }
  }), _vm._v(" "), _c('req-cogs-approval-modal', {
    attrs: {
      "value": _vm.reqApprovalDialog,
      "pairing": _vm.payoutEditPairing,
      "amount": _vm.reqAmt,
      "reasons": _vm.reqReasons,
      "budget": _vm.budget,
      "currentCOGS": _vm.measurement.budget,
      "cogsPercent": _vm.measurement.cogsPercentage
    },
    on: {
      "saved": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.reqApprovalDialog),
      callback: function($$v) {
        _vm.reqApprovalDialog = $$v
      },
      expression: "reqApprovalDialog"
    }
  }), _vm._v(" "), _c('payout-update-modal', {
    attrs: {
      "value": _vm.editPayoutDialog,
      "pairing": _vm.payoutEditPairing,
      "lockedPayout": _vm.lockedPayout,
      "cappedCOGS": _vm.budget,
      "currentCOGS": _vm.measurement.budget
    },
    on: {
      "budgetExceeded": _vm.openReqApprovalDialog,
      "refreshPairing": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.editPayoutDialog),
      callback: function($$v) {
        _vm.editPayoutDialog = $$v
      },
      expression: "editPayoutDialog"
    }
  }), _vm._v(" "), _c('pairing-elimination-edit-modal', {
    attrs: {
      "campaingData": _vm.campaingDataForElimination
    },
    on: {
      "invokeSendToClient": _vm.invokeSendToClient
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', [(_vm.internalApprove) ? _c('v-card-text', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "size": "75"
    }
  }, [_vm._v("rate_review")]), _vm._v(" "), _c('p', [_vm._v("Approve Drafts")])], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "outlined": ""
    }
  }, [_vm._v(_vm._s(_vm.notes.internalApproveWarning))])], 1)], 1)], 1) : _c('v-card-text', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "size": "75"
    }
  }, [_vm._v("rate_review")]), _vm._v(" "), _c('p', [_vm._v("Rate & Review")])], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("Kindly Rate Influencer's Quality of Works")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "color": "secondary",
      "size": "45"
    },
    model: {
      value: (_vm.submissionReview.approveRatings),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveRatings", $$v)
      },
      expression: "submissionReview.approveRatings"
    }
  }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings <= 4),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "How can we make this a 5 stars?"
    },
    model: {
      value: (_vm.submissionReview.approveSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveSuggestion", $$v)
      },
      expression: "submissionReview.approveSuggestion"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)]), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings == 5),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings == 5"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "Leave Influencer a compliment?"
    },
    model: {
      value: (_vm.submissionReview.approveCompliment),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveCompliment", $$v)
      },
      expression: "submissionReview.approveCompliment"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "outlined": ""
    }
  }, [_vm._v(_vm._s(_vm.notes.beforeStart))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.internalApprove) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.submitApproveInternal()
      }
    }
  }, [_vm._v("Approve All")]) : _c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.submitApprove()
      }
    }
  }, [_vm._v("Approve All")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('h4', [_vm._v("Pairing Brief Summary")]), _vm._v(" "), _c('p', [_vm._v("Hi there,")]), _vm._v(" "), _c('p', [_vm._v("We have an upcoming campaign with one of our clients and will like to extend and an invitation to you! Please find below more information regarding this collaboration: ")]), _vm._v(" "), _vm._l((_vm.pairingBriefModelSections[0].content), function(campaignField, index) {
    return _c('element', {
      key: index
    }, [(campaignField.type === 'text') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "white-space": "pre-line"
      }
    }, [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('element', [_c('div', {
      staticClass: "form-group col-xs-12"
    }, _vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
      return _c('div', {
        key: optionIndex,
        staticClass: "form-group col-xs-12"
      }, [_c('div', {
        staticClass: "form-group col-xs-12"
      }, [_c('h4', [_vm._v(_vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1))])]), _vm._v(" "), _vm._l((campaignField.template), function(optionField, index) {
        return _c('element', {
          key: index
        }, [(optionField.type == 'text') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'upload') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12"
        }, [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(image) {
          return [(image != '') ? _c('div', {
            key: image
          }, [_c('a', {
            key: image,
            staticClass: "campaign-image",
            attrs: {
              "href": _vm.constructImageURL(image),
              "target": "_blank"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "src": _vm.constructImageURL(image)
            }
          })])]) : _vm._e()]
        })], 2)]) : _vm._e(), _vm._v(" "), (optionField.type === 'select') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(optionField.value, _vm.campaign[campaignField.name][optionIndex][optionField.name])))])]) : _vm._e()])
      })], 2)
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n          If you will like to confirm your participation in this campaign, please accept within 3 days.\n          More details on the campaign will be shown after you have accepted the invite. \n          For further clarification, you may also drop us an email or reach us on Telegram @ 85199997!\n\n          Thank you and looking forward to have you onboard in this life-changing movement! :)\n          ")])], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Instructions")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', _vm._l((_vm.pairingBriefModelSections[1].content), function(campaignField, index) {
    return _c('element', {
      key: index
    }, [(campaignField.type === 'text') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('element', [_c('div', {
      staticClass: "form-group col-xs-12"
    }, _vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
      return _c('div', {
        key: optionIndex,
        staticClass: "form-group col-xs-12"
      }, [_c('div', {
        staticClass: "form-group col-xs-12"
      }, [_c('h4', [_vm._v(_vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1))])]), _vm._v(" "), _vm._l((campaignField.template), function(optionField, index) {
        return _c('element', {
          key: index
        }, [(optionField.type == 'text') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'upload') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12"
        }, [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(image) {
          return [(image != '') ? _c('div', {
            key: image
          }, [_c('a', {
            key: image,
            staticClass: "campaign-image",
            attrs: {
              "href": _vm.constructImageURL(image),
              "target": "_blank"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "src": _vm.constructImageURL(image)
            }
          })])]) : _vm._e()]
        })], 2)]) : _vm._e(), _vm._v(" "), (optionField.type === 'select') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(optionField.value, _vm.campaign[campaignField.name][optionIndex][optionField.name])))])]) : _vm._e()])
      })], 2)
    }), 0)]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Pairing Brief\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Your Payout:")]), _vm._v(" $___ "), _c('br'), _vm._v("\n          (With effect from 1st October 2018, all payouts would be processed 30 days after the post is up)"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Pairing Brief Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          MUST READ "), _c('br'), _vm._v("\n          (Drop us an email at huanrong@getkobe.com if you need any help) "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Reminder:"), _c('br'), _vm._v(" "), _c('ol', [_c('li', [_vm._v(" Both client and influencer will be mutually rated after each campaign and scores will be kept with Kobe to keep making the world a better place.")]), _vm._v(" "), _c('li', [_vm._v(" Do not make your post live until approval from client.")]), _vm._v(" "), _c('li', [_vm._v(" It is NON-MANDATORY for client to be giving a discount or any value added services.")]), _vm._v(" "), _c('li', [_vm._v(" For any discounts or value-added services that has been extended to you - it is entirely up to the sole discretion of the client - KOBE is not commissioned, neither do we enjoy similar perks.")]), _vm._v(" "), _c('li', [_vm._v(" KOBE gets you rewarded and recognized for sharing on social media, whilst at the same time provide word of mouth to businesses. Kobe isn’t a money making platform. ")]), _vm._v(" "), _c('li', [_vm._v(" For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation from campaign.")])])])
}]}

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Campaigns Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "campaign-summary-total"
  }, [_c('span', {
    staticClass: "campaign-summary-total__count"
  }, [_vm._v("(" + _vm._s(_vm.totalCount) + ")")]), _vm._v(" "), _c('span', [_vm._v("Total")])])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": "",
      "color": "background-white"
    }
  }, _vm._l((_vm.summaryList), function(item, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.changeRoute(item)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(item.aIcon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.value))]), _vm._v("\n              " + _vm._s(item.value >= 2 ? 'Campaigns' : 'Campaign') + "\n            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaignID),
      callback: function($$v) {
        _vm.selectedCampaignID = $$v
      },
      expression: "selectedCampaignID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "8",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": _vm.viewReport
    }
  }, [_vm._v("View HTML Report")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": _vm.viewPayoutsReport
    }
  }, [_vm._v("View Payouts Report")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.selectedCampaignID === null
    },
    on: {
      "click": function($event) {
        return _vm.getCampaignDataToView(_vm.selectedCampaignID)
      }
    }
  }, [_vm._v("View Campaign Brief")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.exportPDF(_vm.selectedCampaignID, _vm.campaignData.name, false)
      }
    }
  }, [_vm._v("\n              Download PDF\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-pdf-box")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel(_vm.selectedCampaignID, _vm.campaignData.name, false)
      }
    }
  }, [_vm._v("\n              Download Excel\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-file-excel")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.quickReload()
      }
    }
  }, [_vm._v("\n              Reload Page\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedCampaignID,
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.getCampaignReport(_vm.selectedCampaignID, true)
      }
    }
  }, [_vm._v("\n              Refresh Data\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 5px 10px 0px"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.changeSettings(_vm.campaignData)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders-h"
  }), _vm._v(" Campaign Settings\n            ")])], 1)])])], 1), _vm._v(" "), _c('div', [(_vm.campaignData) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "460px"
    },
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-2 pb-0"
  }, [_vm._v("\n              Campaign Name: " + _vm._s(_vm.campaignData ? _vm.campaignData.name : 'N/A') + "\n              "), (_vm.markupCOGSAmount) ? _c('v-chip', {
    attrs: {
      "color": "warning",
      "small": "",
      "text-color": "white"
    }
  }, [_vm._v("\n                Markup COGS\n              ")]) : _vm._e(), _vm._v(" "), (_vm.campaignData.lockedCOGS) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS")], 1)]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('p', {
    staticClass: "subtitle-2 font-weight-light"
  }, [_vm._v(" Current Status: " + _vm._s(_vm.currentCampaignStatusDisplay))])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n              Client Name: " + _vm._s(_vm.client ? _vm.client.name : 'N/A') + "\n            ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0 pt-2",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              IO Number: " + _vm._s(_vm.campaignData ? (_vm.campaignData.ioNumbers || 'N/A') : 'N/A') + "\n            ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Budget: $" + _vm._s(_vm._f("thousandSeprator")(_vm.campaignData.budget)) + "\n            ")]), _vm._v(" "), (_vm.campaignData.revenueCalculation === 'engagement') ? _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Calculation Method: Engagement\n            ")]) : _vm._e(), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-0",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Campaign Period: " + _vm._s(_vm.minLiveDate) + " - " + _vm._s(_vm.maxLiveDate) + "\n            ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pb-3",
    staticStyle: {
      "font-size": "17px!important"
    }
  }, [_vm._v("\n              Number of Reviewers: " + _vm._s(_vm.numberOfReviewers) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-container', {
    staticClass: "pl-0 pr-0",
    staticStyle: {
      "padding-top": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "md6": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "outreach-kpi-row"
  }, [_c('div', {
    staticClass: "display-text"
  }, [_c('v-card-title', {
    staticClass: "ma-0 pa-0 headline mb-3 font-weight-medium",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Outreach KPI")]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.summary.outreach)) + " / " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignData.outreach)))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.summary.outreach_percentage) + "%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "odometer-gauge"
  }, [_c('div', {
    staticClass: "odometer-arc"
  }, [_c('svg', {
    staticClass: "odometer-arc-svg",
    attrs: {
      "viewBox": "0 0 170 90",
      "preserveAspectRatio": "none"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "outreachArcGradient",
      "x1": "0%",
      "y1": "0%",
      "x2": "100%",
      "y2": "0%"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#ef5350"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "#66bb6a"
    }
  })], 1)], 1), _vm._v(" "), _c('path', {
    staticClass: "odometer-arc-track-path",
    attrs: {
      "d": "M 10 85 A 75 75 0 0 1 160 85"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "odometer-arc-progress-path",
    style: ({
      strokeDasharray: ("" + _vm.outreachArcLength),
      strokeDashoffset: ("" + _vm.outreachArcOffset),
      stroke: 'url(#outreachArcGradient)'
    }),
    attrs: {
      "d": "M 10 85 A 75 75 0 0 1 160 85"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "odometer-needle",
    style: ({
      transform: ("translateX(-50%) rotate(" + _vm.outreachNeedleRotation + "deg)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "odometer-arc-center"
  })]), _vm._v(" "), _c('div', {
    staticClass: "odometer-meta"
  }, [_c('span', {
    staticClass: "odometer-percent"
  }, [_vm._v(_vm._s(_vm.outreachRatioPercent) + "%")])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "contents-kpi-row"
  }, [_c('div', {
    staticClass: "display-text"
  }, [_c('v-card-title', {
    staticClass: "ma-0 pa-0 headline mb-3 font-weight-medium",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Contents KPI")]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm.summary.contents) + " / " + _vm._s(_vm.campaignData.min_content))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.summary.contents_percentage) + "%")])], 1), _vm._v(" "), _c('div', {
    staticClass: "contents-progress-gauge"
  }, [_c('div', {
    staticClass: "contents-progress-head"
  }, [_c('span', {
    staticClass: "contents-progress-percent"
  }, [_vm._v(_vm._s(_vm.contentsRatioPercent) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "contents-progress-track"
  }, [_c('div', {
    staticClass: "contents-progress-fill",
    style: ({
      width: (_vm.contentsProgressFillPercent + "%")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-progress-scale"
  }, [_c('span', [_vm._v("0%")]), _vm._v(" "), _c('span', [_vm._v("50%")]), _vm._v(" "), _c('span', [_vm._v("100%")])])])])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "135px"
    },
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Outreach + Impressions")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.outreachImpressionsTotal)))])])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#363636",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("COGS KPI")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalCounts.amount)) + " / $" + _vm._s(_vm._f("thousandSeprator")(_vm.budget)))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.cogsPercentage) + "%")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.campaignData) ? _c('campaign-summary', {
    attrs: {
      "campaign": _vm.campaignData,
      "isInternalView": true,
      "respData": _vm.respData
    },
    on: {
      "loading-status": _vm.handleLoadingStatus,
      "saved": function($event) {
        return _vm.quickReload()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedCampaignID) ? _c('div', [(_vm.respData && _vm.selectedCampaignID) ? _c('report-for-summary', {
    attrs: {
      "respData": _vm.respData,
      "campaignID": _vm.selectedCampaignID
    },
    on: {
      "loading-status": _vm.handleLoadingStatus
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "10",
      "md": "10",
      "lg": "10"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "rounded": "",
      "color": "secondary",
      "disabled": !_vm.selectedCampaignID
    },
    on: {
      "click": function($event) {
        return _vm.addPost()
      }
    }
  }, [_vm._v("Add Content")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "disabled": _vm.disableSaveArrange,
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveLineUp()
      }
    }
  }, [_vm._v("Save Posts Arrangement")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    attrs: {
      "rounded": "",
      "color": "warning",
      "disabled": !_vm.selectedPosts || _vm.selectedPosts.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openReportGroupModal()
      }
    }
  }, [_vm._v("Add to Group (" + _vm._s(_vm.selectedPosts.length) + ")")])], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    attrs: {
      "xs": "12",
      "sm": "2",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-btn-toggle', {
    staticClass: "float-right",
    attrs: {
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Grid View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "fill-height": ""
    }
  }, [(_vm.posts.length) ? _c('v-row', {
    staticClass: "justify-right"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.postTypes,
      "item-text": "title",
      "item-value": "title",
      "label": "Content Type",
      "filled": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.postType),
      callback: function($$v) {
        _vm.postType = $$v
      },
      expression: "postType"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Live Date",
            "readonly": "",
            "clearable": "",
            "filled": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.getFiltered()
            }
          },
          model: {
            value: (_vm.searchMonth),
            callback: function($$v) {
              _vm.searchMonth = $$v
            },
            expression: "searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 3538331557),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.searchMonth),
      callback: function($$v) {
        _vm.searchMonth = $$v
      },
      expression: "searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchMonthOk
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-5",
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        return _vm.getFiltered()
      }
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.display === 0) ? _c('div', {
    staticClass: "no-gutters",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "margin-bottom": "10px",
      "padding": "10px"
    }
  }, [_c('draggable', {
    staticClass: "row clearfix",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "update": function($event) {
        return _vm.handleDragDropUpdate(_vm.filteredPosts)
      }
    },
    model: {
      value: (_vm.filteredPosts),
      callback: function($$v) {
        _vm.filteredPosts = $$v
      },
      expression: "filteredPosts"
    }
  }, _vm._l((_vm.filteredPosts), function(post) {
    return _c('div', {
      key: post.id,
      class: {
        'pa-2 col-sm-12 col-md-4 col-lg-3 col': !post.reportGroup && !_vm.isTwitterReport(post),
        'pa-2 col-sm-12 col-md-6 col-lg-4 col twitter-grid-column': !post.reportGroup && _vm.isTwitterReport(post),
        'row mb-2': post.reportGroup
      },
      style: (post.reportGroup ? 'width:100%' : '')
    }, [(post.reportGroup) ? _c('v-col', {
      staticClass: "pa-3 pr-0 mt-3",
      attrs: {
        "cols": "auto",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-expansion-panels', {
      staticClass: "post-group-panel",
      attrs: {
        "multiple": "",
        "dark": "",
        "accordion": "",
        "focusable": ""
      },
      model: {
        value: (post.panel),
        callback: function($$v) {
          _vm.$set(post, "panel", $$v)
        },
        expression: "post.panel"
      }
    }, [_c('v-expansion-panel', {
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', [_vm._v(_vm._s(post.name) + " (" + _vm._s(post.reports.length) + ")")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.reports) ? _c('v-row', {
      staticClass: "no-gutters",
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "10px"
      }
    }, [_c('draggable', {
      staticClass: "row no-gutters flex-wrap flex-row fill-height",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "update": function($event) {
          return _vm.handleDragDropUpdate(post.reports)
        }
      },
      model: {
        value: (post.reports),
        callback: function($$v) {
          _vm.$set(post, "reports", $$v)
        },
        expression: "post.reports"
      }
    }, _vm._l((post.reports), function(post) {
      return _c('v-col', {
        key: post.id,
        staticClass: "pa-2",
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": _vm.isTwitterReport(post) ? 6 : 4,
          "lg": _vm.isTwitterReport(post) ? 4 : 3
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [(post.success && !_vm.isLinkedInReport(post) && !_vm.isTwitterReport(post)) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.post_details.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.profileHandle || post.profile_handle || post.post_details.owner.username)),
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.post_details.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [_c('instagram-post-embed', {
              attrs: {
                "url": _vm.getReportPostUrl(post)
              }
            })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Post Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isTwitterReport(post) ? 'Replies' : 'Comments'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
                },
                proxy: true
              }], null, true)
            }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Graph Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Update Insights\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.scrapComments(post.post_details.link, post.id)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Extract Comments\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                      Remove\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                      View on IG\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-instagram")])], 1)], 1)], 1) : (post.isOthers || _vm.isLinkedInReport(post) || _vm.isTwitterReport(post)) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover,
                'linkedin-campaign-post': _vm.isLinkedInReport(post),
                'twitter-campaign-post': _vm.isTwitterReport(post)
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": _vm.isTwitterReport(post) ? 420 : 300,
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.owner.username)),
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold",
              class: {
                'twitter-embed-card-text': _vm.isTwitterReport(post)
              }
            }, [(_vm.isLinkedInReport(post) && _vm.getLinkedInEmbedUrl(post)) ? _c('iframe', {
              staticClass: "linkedin-post-embed",
              attrs: {
                "src": _vm.getLinkedInEmbedUrl(post),
                "title": ("LinkedIn post by " + (post.owner.username)),
                "width": "100%",
                "height": "300",
                "frameborder": "0",
                "allowfullscreen": ""
              }
            }) : (_vm.isTwitterReport(post) && _vm.getTwitterEmbedUrl(post)) ? _c('div', {
              staticClass: "twitter-embed-shell"
            }, [_c('iframe', {
              staticClass: "twitter-post-embed",
              attrs: {
                "src": _vm.getTwitterEmbedUrl(post),
                "title": ("X post by " + (post.owner.username)),
                "frameborder": "0",
                "allowfullscreen": ""
              }
            })]) : _vm._e(), _vm._v(" "), (post.media_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
              attrs: {
                "className": _vm.getMedia(post).className,
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
              staticClass: "elevation-0",
              attrs: {
                "width": "100%",
                "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
              }
            }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
              attrs: {
                "width": "100%",
                "controls": ""
              }
            }, [_c('source', {
              attrs: {
                "src": post.media_url,
                "type": "video/mp4"
              }
            }), _vm._v("\n                                        Your browser does not support HTML5 video.\n                                      ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
              attrs: {
                "url": post.media_url
              }
            }) : _vm._e(), _vm._v(" "), (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
              staticClass: "media-iframe",
              attrs: {
                "width": "100%",
                "height": "100%",
                "src": post.media_url,
                "scrolling": "no",
                "seamless": "",
                "allowFullScreen": ""
              }
            }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Post Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isTwitterReport(post) ? 'Replies' : 'Comments'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
                },
                proxy: true
              }], null, true)
            }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Graph Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Update Insights\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                      Remove\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                      " + _vm._s(_vm.isLinkedInReport(post) ? 'View on LinkedIn' : (_vm.isTwitterReport(post) ? 'View on X' : 'View')) + "\n                                      "), (_vm.isLinkedInReport(post)) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-linkedin")]) : (_vm.isTwitterReport(post)) ? _c('img', {
              staticClass: "ml-2",
              staticStyle: {
                "filter": "invert(1)"
              },
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "18px",
                "alt": "",
                "aria-hidden": "true"
              }
            }) : _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-open-in-new")])], 1)], 1)], 1) : (post.isStory) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (post.media_url) ? _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
              attrs: {
                "className": _vm.getMedia(post).className,
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
              staticClass: "elevation-0",
              attrs: {
                "width": "100%",
                "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
              }
            }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
              attrs: {
                "width": "100%",
                "controls": ""
              }
            }, [_c('source', {
              attrs: {
                "src": post.media_url,
                "type": "video/mp4"
              }
            }), _vm._v("\n                                    Your browser does not support HTML5 video.\n                                  ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
              attrs: {
                "url": post.media_url
              }
            }) : _vm._e(), _vm._v(" "), (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
              staticClass: "media-iframe",
              attrs: {
                "width": "100%",
                "height": "100%",
                "src": post.media_url,
                "scrolling": "no",
                "seamless": "",
                "allowFullScreen": ""
              }
            }) : _vm._e()], 1) : _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [_c('div', [_c('v-alert', {
              attrs: {
                "width": "100%"
              }
            }, [_vm._v("\n                                      Media type unsupported!\n                                    ")])], 1)]), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Story Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Accounts Reached")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                    Update Insights\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (post.media_url) ? _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View Story Media\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1)], 1) : (post.isTikTok) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank",
                "rel": "noopener noreferrer"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                          " + _vm._s(post.type) + "\n                                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.tikTokPost) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('div', {
              staticStyle: {
                "left": "0",
                "width": "100%",
                "height": "0",
                "position": "relative",
                "padding-bottom": "177.7778%",
                "padding-top": "120px"
              }
            }, [_c('iframe', {
              staticStyle: {
                "position": "absolute",
                "top": "0px",
                "left": "0px",
                "height": "100%",
                "width": "100%"
              },
              attrs: {
                "src": post.tikTokPost,
                "allow": "fullscreen"
              }
            })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Post Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [(post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Total Play Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Favourites (Bookmarks)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Watched Full Video")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watchedFullVideo))])]) : _vm._e()])]
                },
                proxy: true
              }], null, true)
            }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                          Graph Insights\n                                        ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Update Insights\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.scrapComments(post.post_details.link, post.id)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        Extract Comments\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": "",
                "color": "blue-grey",
                "disabled": !post.comments || post.comments.length === 0
              },
              on: {
                "click": function($event) {
                  return _vm.openCommentsDialog(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                        View Comments (" + _vm._s(post.comments ? post.comments.length : 0) + ")\n                                        "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-comment-text-multiple")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                      Remove\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                      View on TikTok "), _c('img', {
              attrs: {
                "src": "/static/img/tik-tok-white.png",
                "width": "18px"
              }
            })])], 1)], 1) : (post.isFacebook) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', {
              staticClass: "campaign-post-header"
            }, [_c('v-list-item', {
              staticClass: "grow pa-0 campaign-post-header-row"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.owner.username)),
                "href": 'https://www.facebook.com/' + post.owner.username,
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))]), _vm._v(" "), _c('v-icon', {
              staticClass: "cursor-pointer",
              attrs: {
                "color": "warning",
                "x-small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openEditHandleModal(post)
                }
              }
            }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.media_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('div', {
              staticStyle: {
                "left": "0",
                "width": "100%",
                "height": "0",
                "position": "relative",
                "padding-bottom": "177.7778%",
                "padding-top": "120px"
              }
            }, [_c('iframe', {
              staticStyle: {
                "position": "absolute",
                "top": "0px",
                "left": "0px",
                "height": "100%",
                "width": "100%"
              },
              attrs: {
                "src": _vm.getFbPost(post.media_url),
                "allow": "fullscreen"
              }
            })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Facebook\n                                  ")])], 1)], 1) : (post.isXHS) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": 'https://www.xiaohongshu.com/user/profile/' + post.owner.xhsID,
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), _c('v-icon', {
              staticClass: "cursor-pointer",
              attrs: {
                "color": "warning",
                "x-small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openEditHandleModal(_vm.item)
                }
              }
            }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.embed_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('custom-media', {
              attrs: {
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on XHS\n                                  ")])], 1)], 1) : (post.isLemon) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": ""
              }
            }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), _c('v-icon', {
              staticClass: "cursor-pointer",
              attrs: {
                "color": "warning",
                "x-small": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openEditHandleModal(_vm.item)
                }
              }
            }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.embed_url) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('custom-media', {
              attrs: {
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.media_url,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Lemon8\n                                  ")])], 1)], 1) : (post.isYoutube) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', {
              staticClass: "campaign-post-owner-content"
            }, [_c('v-list-item-title', {
              staticClass: "campaign-post-owner-title"
            }, [_c('a', {
              staticClass: "caption campaign-post-owner-handle",
              attrs: {
                "title": ("@" + (post.owner.username)),
                "href": 'https://www.youtube.com/' + post.owner.username,
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
              staticClass: "campaign-post-type-action"
            }, [(post.type) ? _c('v-chip', {
              staticClass: "campaign-post-type-chip",
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_c('span', {
              staticClass: "campaign-post-type-title",
              attrs: {
                "title": post.type
              }
            }, [_vm._v(_vm._s(post.type))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [(post.youtubePost) ? _c('div', {
              staticClass: "igPost-block",
              staticStyle: {
                "max-width": "350px"
              }
            }, [_c('div', {
              staticStyle: {
                "left": "0",
                "width": "100%",
                "height": "0",
                "position": "relative",
                "padding-bottom": "177.7778%",
                "padding-top": "120px"
              }
            }, [_c('iframe', {
              staticStyle: {
                "position": "absolute",
                "top": "0px",
                "left": "0px",
                "height": "100%",
                "width": "100%"
              },
              attrs: {
                "src": post.youtubePost,
                "allow": "fullscreen"
              }
            })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Post Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.impressions != null) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.unique_viewers != null) ? _c('tr', [_c('td', [_vm._v("Unique Viewers")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.unique_viewers))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches != null) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.outreach))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                      Update Insights\n                                      "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Youtube  "), _c('i', {
              staticClass: "fab fa-youtube"
            })])], 1)], 1) : (post.isMultipleContents) ? _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-list-item', {
              staticClass: "grow pa-0"
            }, [_c('v-list-item-avatar', {
              attrs: {
                "color": "grey darken-3"
              }
            }, [_c('v-img', {
              staticClass: "elevation-6",
              attrs: {
                "src": post.owner.profile_pic_url
              }
            })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
              staticClass: "caption",
              attrs: {
                "href": _vm.getAccountProfileUrl(post),
                "target": "_blank"
              }
            }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
              attrs: {
                "color": "primary",
                "small": ""
              }
            }, [_vm._v("\n                                        " + _vm._s(post.type) + "\n                                      ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "headline font-weight-bold"
            }, [_c('custom-media', {
              attrs: {
                "type": _vm.getMedia(post).type,
                "publicID": _vm.getMedia(post).publicID,
                "videoID": _vm.getMedia(post).videoID,
                "URL": _vm.getMedia(post).URL,
                "width": _vm.getMedia(post).width,
                "height": _vm.getMedia(post).height,
                "trans": _vm.getMedia(post).trans
              }
            })], 1), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
              staticClass: "text-center"
            }, [_c('v-chip', {
              staticClass: "subheading ma-1",
              attrs: {
                "dark": "",
                "label": ""
              }
            }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                                        Story Insights\n                                      ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
              attrs: {
                "dark": "",
                "dense": ""
              },
              scopedSlots: _vm._u([{
                key: "default",
                fn: function() {
                  return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Exits")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.exits))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Back")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_back))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Forward")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_forward))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
                },
                proxy: true
              }], null, true)
            })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
              attrs: {
                "block": ""
              },
              on: {
                "click": function($event) {
                  return _vm.updatePostInsightsHandler(post)
                }
              }
            }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                                    Update Insights\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
              staticClass: "justify-center"
            }, [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1)], 1)], 1) : _c('v-card', {
              staticClass: "mx-auto campaign-post",
              class: {
                'on-hover': hover
              },
              attrs: {
                "color": "#62727b",
                "dark": "",
                "max-width": "300",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [_c('v-icon', {
              attrs: {
                "large": "",
                "left": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('span', {
              staticClass: "caption font-weight-light"
            }, [_vm._v("Anonymous User")])], 1), _vm._v(" "), _c('v-card-text', {
              staticClass: "title font-weight-bold"
            }, [_vm._v("\n                                  Post might be deleted or private. Click\n                                  "), _c('a', {
              attrs: {
                "target": "_blank",
                "href": ("https://instagram.com/p/" + (post.post_details.shortcode))
              }
            }, [_vm._v("Here")]), _vm._v(" for more details.\n                                ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "small": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  return _vm.removeContent(post.id)
                }
              }
            }, [_vm._v("\n                                    Remove\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
              attrs: {
                "small": "",
                "color": "secondary",
                "href": post.post_details.link,
                "target": '_blank'
              }
            }, [_vm._v("\n                                    View on Instagram\n                                    "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v("mdi-instagram")])], 1)], 1)], 1)]
          }
        }], null, true)
      })], 1)
    }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _c('div', [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(post.success && !_vm.isLinkedInReport(post) && !_vm.isTwitterReport(post)) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.post_details.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.profileHandle || post.profile_handle || post.post_details.owner.username)),
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.post_details.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(post.type) + "\n                            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [_c('instagram-post-embed', {
            attrs: {
              "url": _vm.getReportPostUrl(post)
            }
          })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Post Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Graph Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Update Insights\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.scrapComments(post.post_details.link, post.id)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Extract Comments\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": "",
              "color": "blue-grey",
              "disabled": !post.comments || post.comments.length === 0
            },
            on: {
              "click": function($event) {
                return _vm.openCommentsDialog(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            View Comments (" + _vm._s(post.comments ? post.comments.length : 0) + ")\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-comment-text-multiple")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                          Remove\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                          View on IG\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-instagram")])], 1)], 1)], 1) : (post.isOthers || _vm.isLinkedInReport(post) || _vm.isTwitterReport(post)) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover,
              'linkedin-campaign-post': _vm.isLinkedInReport(post),
              'twitter-campaign-post': _vm.isTwitterReport(post)
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": _vm.isTwitterReport(post) ? 420 : 300,
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.owner.username)),
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(post.type) + "\n                            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold",
            class: {
              'twitter-embed-card-text': _vm.isTwitterReport(post)
            }
          }, [(_vm.isLinkedInReport(post) && _vm.getLinkedInEmbedUrl(post)) ? _c('iframe', {
            staticClass: "linkedin-post-embed",
            attrs: {
              "src": _vm.getLinkedInEmbedUrl(post),
              "title": ("LinkedIn post by " + (post.owner.username)),
              "width": "100%",
              "height": "300",
              "frameborder": "0",
              "allowfullscreen": ""
            }
          }) : (_vm.isTwitterReport(post) && _vm.getTwitterEmbedUrl(post)) ? _c('div', {
            staticClass: "twitter-embed-shell"
          }, [_c('iframe', {
            staticClass: "twitter-post-embed",
            attrs: {
              "src": _vm.getTwitterEmbedUrl(post),
              "title": ("X post by " + (post.owner.username)),
              "frameborder": "0",
              "allowfullscreen": ""
            }
          })]) : _vm._e(), _vm._v(" "), (post.media_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
            attrs: {
              "className": _vm.getMedia(post).className,
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
            staticClass: "elevation-0",
            attrs: {
              "width": "100%",
              "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
            }
          }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
            attrs: {
              "width": "100%",
              "controls": ""
            }
          }, [_c('source', {
            attrs: {
              "src": post.media_url,
              "type": "video/mp4"
            }
          }), _vm._v("\n                            Your browser does not support HTML5 video.\n                          ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
            attrs: {
              "url": post.media_url
            }
          }) : _vm._e(), _vm._v(" "), (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
            staticClass: "media-iframe",
            attrs: {
              "width": "100%",
              "height": "100%",
              "src": post.media_url,
              "scrolling": "no",
              "seamless": "",
              "allowFullScreen": ""
            }
          }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Post Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [(post.inputtedInsights && !_vm.isTwitterReport(post) && (!_vm.isLinkedInReport(post) || post.inputtedInsights.reach != null)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Members reached' : 'Reach'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && (!_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post) || post.inputtedInsights.impressions != null)) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Video views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isLinkedInReport(post) && post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Profile viewers from this post")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-'))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Reactions' : 'Likes'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) ? 'Saves' : (_vm.isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.isLinkedInReport(post) || _vm.isTwitterReport(post) ? 'Reposts' : 'Shares'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null) ? _c('tr', [_c('td', [_vm._v("Reposts")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reposts))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && !_vm.isTwitterReport(post) && !_vm.isLinkedInReport(post)) ? _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.views))])]) : _vm._e()])]
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Graph Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Update Insights\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                          Remove\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                          " + _vm._s(_vm.isLinkedInReport(post) ? 'View on LinkedIn' : (_vm.isTwitterReport(post) ? 'View on X' : 'View')) + "\n                          "), (_vm.isLinkedInReport(post)) ? _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-linkedin")]) : (_vm.isTwitterReport(post)) ? _c('img', {
            staticClass: "ml-2",
            staticStyle: {
              "filter": "invert(1)"
            },
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "18px",
              "alt": "",
              "aria-hidden": "true"
            }
          }) : _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-open-in-new")])], 1)], 1)], 1) : (post.isStory) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1)], 1)], 1), _vm._v(" "), (post.media_url) ? _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(_vm.MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id) ? _c('custom-media', {
            attrs: {
              "className": _vm.getMedia(post).className,
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          }) : (post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url) ? _c('img', {
            staticClass: "elevation-0",
            attrs: {
              "width": "100%",
              "src": post.media_type == 'IMAGE' || _vm.MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url
            }
          }) : (post.media_url && _vm.MEDIA_URL_TYPE(post.media_url) === 'video') ? _c('video', {
            attrs: {
              "width": "100%",
              "controls": ""
            }
          }, [_c('source', {
            attrs: {
              "src": post.media_url,
              "type": "video/mp4"
            }
          }), _vm._v("\n                        Your browser does not support HTML5 video.\n                      ")]) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'driveView') ? _c('gDrive-post-view', {
            attrs: {
              "url": post.media_url
            }
          }) : (_vm.MEDIA_URL_TYPE(post.media_url) === 'iframe') ? _c('iframe', {
            staticClass: "media-iframe",
            attrs: {
              "width": "100%",
              "height": "100%",
              "src": post.media_url,
              "scrolling": "no",
              "seamless": "",
              "allowFullScreen": ""
            }
          }) : _vm._e()], 1) : _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [_c('div', [_c('v-alert', {
            attrs: {
              "width": "100%"
            }
          }, [_vm._v("\n                          Media type unsupported!\n                        ")])], 1)]), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Story Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Accounts Reached")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                        Update Insights\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (post.media_url) ? _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View Story Media\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1)], 1) : (post.isTikTok) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                              " + _vm._s(post.type) + "\n                            ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.tikTokPost) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('div', {
            staticStyle: {
              "left": "0",
              "width": "100%",
              "height": "0",
              "position": "relative",
              "padding-bottom": "177.7778%",
              "padding-top": "120px"
            }
          }, [_c('iframe', {
            staticStyle: {
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "height": "100%",
              "width": "100%"
            },
            attrs: {
              "src": post.tikTokPost,
              "allow": "fullscreen"
            }
          })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Post Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [(post.currentInsight) ? _c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [(post.inputtedInsights && post.inputtedInsights.plays) ? _c('tr', [_c('td', [_vm._v("Total Play Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.plays))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.shares))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Favourites (Bookmarks)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.saved))])]) : _vm._e(), _vm._v(" "), (post.currentInsight.views) ? _c('tr', [_c('td', [_vm._v("Plays (Views)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.views))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.reach))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights) ? _c('tr', [_c('td', [_vm._v("Watched Full Video")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watchedFullVideo))])]) : _vm._e()])]
              },
              proxy: true
            }], null, true)
          }) : _vm._e()], 1)], 1), _vm._v(" "), (post.graphInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                              Graph Insights\n                            ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Saved")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.graphInsight.saved))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Update Insights\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.scrapComments(post.post_details.link, post.id)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            Extract Comments\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": "",
              "color": "blue-grey",
              "disabled": !post.comments || post.comments.length === 0
            },
            on: {
              "click": function($event) {
                return _vm.openCommentsDialog(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                            View Comments (" + _vm._s(post.comments ? post.comments.length : 0) + ")\n                            "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-comment-text-multiple")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                          Remove\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                          View on TikTok "), _c('img', {
            attrs: {
              "src": "/static/img/tik-tok-white.png",
              "width": "18px"
            }
          })])], 1)], 1) : (post.isFacebook) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', {
            staticClass: "campaign-post-header"
          }, [_c('v-list-item', {
            staticClass: "grow pa-0 campaign-post-header-row"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.owner.username)),
              "href": 'https://www.facebook.com/' + post.owner.username,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.media_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('div', {
            staticStyle: {
              "left": "0",
              "width": "100%",
              "height": "0",
              "position": "relative",
              "padding-bottom": "177.7778%",
              "padding-top": "120px"
            }
          }, [_c('iframe', {
            staticStyle: {
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "height": "100%",
              "width": "100%"
            },
            attrs: {
              "src": _vm.getFbPost(post.media_url),
              "allow": "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
              "allowfullscreen": "true",
              "scrolling": "no"
            }
          })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Facebook\n                      ")])], 1)], 1) : (post.isXHS) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + post.owner.xhsID,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.embed_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('custom-media', {
            attrs: {
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on XHS \n                      ")])], 1)], 1) : (post.isLemon) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": ""
            }
          }, [_vm._v("@" + _vm._s(post.owner.fullName || post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.embed_url) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('custom-media', {
            attrs: {
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          })], 1) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.insights) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.outreach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.comment_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Views")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.views))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bookmarks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.bookmarks))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.media_url,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Lemon8 \n                      ")])], 1)], 1) : (post.isYoutube) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "campaign-post-owner-content"
          }, [_c('v-list-item-title', {
            staticClass: "campaign-post-owner-title"
          }, [_c('a', {
            staticClass: "caption campaign-post-owner-handle",
            attrs: {
              "title": ("@" + (post.owner.username)),
              "href": 'https://www.youtube.com/' + post.owner.username,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.owner.username))]), _vm._v(" "), (post.multipleInfs && post.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "max-width": "20px",
                    "padding": "0",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((post.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "campaign-post-type-action"
          }, [(post.type) ? _c('v-chip', {
            staticClass: "campaign-post-type-chip",
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_c('span', {
            staticClass: "campaign-post-type-title",
            attrs: {
              "title": post.type
            }
          }, [_vm._v(_vm._s(post.type))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [(post.youtubePost) ? _c('div', {
            staticClass: "igPost-block",
            staticStyle: {
              "max-width": "350px"
            }
          }, [_c('div', {
            staticStyle: {
              "left": "0",
              "width": "100%",
              "height": "0",
              "position": "relative",
              "padding-bottom": "177.7778%",
              "padding-top": "120px"
            }
          }, [_c('iframe', {
            staticStyle: {
              "position": "absolute",
              "top": "0px",
              "left": "0px",
              "height": "100%",
              "width": "100%"
            },
            attrs: {
              "src": post.youtubePost,
              "allow": "fullscreen"
            }
          })])]) : _vm._e()]), _vm._v(" "), _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [(post.currentInsight) ? _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Post Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Engagement")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.engagement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Likes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.like_count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Comments")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.comment_count))])]), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.impressions != null) ? _c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.impressions))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.unique_viewers != null) ? _c('tr', [_c('td', [_vm._v("Unique Viewers")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.unique_viewers))])]) : _vm._e(), _vm._v(" "), (post.inputtedInsights && post.inputtedInsights.watches != null) ? _c('tr', [_c('td', [_vm._v("Average Watch Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.inputtedInsights.watches))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Outreach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.currentInsight.outreach))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                          Update Insights\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Youtube "), _c('i', {
            staticClass: "fab fa-youtube"
          })])], 1)], 1) : (post.isMultipleContents) ? _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-list-item', {
            staticClass: "grow pa-0"
          }, [_c('v-list-item-avatar', {
            attrs: {
              "color": "grey darken-3"
            }
          }, [_c('v-img', {
            staticClass: "elevation-6",
            attrs: {
              "src": post.owner.profile_pic_url
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('a', {
            staticClass: "caption",
            attrs: {
              "href": _vm.getAccountProfileUrl(post),
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(post.profileHandle || post.profile_handle || post.owner.username))])])], 1), _vm._v(" "), _c('v-list-item-action', [(post.type) ? _c('v-chip', {
            attrs: {
              "color": "primary",
              "small": ""
            }
          }, [_vm._v("\n                            " + _vm._s(post.type) + "\n                          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "headline font-weight-bold"
          }, [_c('custom-media', {
            attrs: {
              "type": _vm.getMedia(post).type,
              "publicID": _vm.getMedia(post).publicID,
              "videoID": _vm.getMedia(post).videoID,
              "URL": _vm.getMedia(post).URL,
              "width": _vm.getMedia(post).width,
              "height": _vm.getMedia(post).height,
              "trans": _vm.getMedia(post).trans
            }
          })], 1), _vm._v(" "), (post.insights) ? _c('v-card-text', [_c('div', {
            staticClass: "text-center"
          }, [_c('v-chip', {
            staticClass: "subheading ma-1",
            attrs: {
              "dark": "",
              "label": ""
            }
          }, [_c('span', [_vm._v("IMS Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.getIMSStatus(post.ims_status, post.payment_status)))])])], 1), _vm._v(" "), _c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                            Story Insights\n                          ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-simple-table', {
            attrs: {
              "dark": "",
              "dense": ""
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function() {
                return [_c('tbody', [_c('tr', [_c('td', [_vm._v("Impressions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.impressions))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reach")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.reach))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Replies")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.replies))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Exits")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.exits))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Back")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_back))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Taps Forward")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.taps_forward))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shares")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.shares))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Link Clicks")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.link_clicks))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sticker Taps")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(post.insights.sticker_taps))])])])]
              },
              proxy: true
            }], null, true)
          })], 1)], 1), _vm._v(" "), _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "block": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePostInsightsHandler(post)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n                        Update Insights\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
            staticClass: "justify-center"
          }, [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1)], 1)], 1) : _c('v-card', {
            staticClass: "mx-auto campaign-post",
            class: {
              'on-hover': hover
            },
            attrs: {
              "color": "#62727b",
              "dark": "",
              "max-width": "300",
              "elevation": hover ? 12 : 2
            }
          }, [_c('v-card-title', [_c('v-icon', {
            attrs: {
              "large": "",
              "left": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('span', {
            staticClass: "caption font-weight-light"
          }, [_vm._v("Anonymous User")])], 1), _vm._v(" "), _c('v-card-text', {
            staticClass: "title font-weight-bold"
          }, [_vm._v("\n                      Post might be deleted or private. Click\n                      "), _c('a', {
            attrs: {
              "target": "_blank",
              "href": ("https://instagram.com/p/" + (post.post_details.shortcode))
            }
          }, [_vm._v("Here")]), _vm._v(" for more details.\n                    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "small": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.removeContent(post.id)
              }
            }
          }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "small": "",
              "color": "secondary",
              "href": post.post_details.link,
              "target": '_blank'
            }
          }, [_vm._v("\n                        View on Instagram\n                        "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-instagram")])], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.display === 1) ? _c('div', {
    staticClass: "no-gutters",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "7",
      "lg": "7"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "success",
      "disabled": _vm.disableSaveEdit
    },
    on: {
      "click": _vm.saveEditingData
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), (!_vm.disableSaveEdit) ? _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    staticStyle: {
      "max-width": "50px",
      "float": "right"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 1707098776)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-1 report__table",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "items-per-page": 20,
      "no-data-text": 'Empty list',
      "show-select": "",
      "show-expand": "",
      "expanded": _vm.expanded,
      "search": _vm.searchFilter,
      "single-select": false,
      "custom-sort": _vm.customSort
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      },
      "toggle-select-all": _vm.selectAllPosts,
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([{
      key: "item.instagram",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "210px"
          }
        }, [(item.reportGroup) ? _c('label', [_vm._v(_vm._s(item.instagram) + " (" + _vm._s(item.reports.length) + ")\n                ")]) : _vm._e(), _vm._v(" "), (!item.reportGroup && !item.isTikTok && !item.isYoutube && !item.isFacebook && !_vm.isLinkedInReport(item) && !_vm.isTwitterReport(item) && !item.isXHS && !item.isLemon) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": _vm.getAccountProfileUrl(item)
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isTikTok) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": _vm.getAccountProfileUrl(item)
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isYoutube) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://youtube.com/' + item.instagram
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isFacebook) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://facebook.com/' + item.instagram
          }
        }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isLinkedInReport(item)) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.linkedin.com/in/' + item.instagram
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#0A66C2",
            "small": ""
          }
        }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isTwitterReport(item)) ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://x.com/' + item.instagram
          }
        }, [_c('img', {
          staticClass: "mr-1",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "14px",
            "alt": "",
            "aria-hidden": "true"
          }
        }), _vm._v(" @" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isXHS) ? _c('a', {
          attrs: {
            "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
            "target": "_blank"
          }
        }, [_vm._v("@" + _vm._s(item.fullName))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isLemon) ? _c('a', [_vm._v("@" + _vm._s(item.fullName))]) : _vm._e(), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
          attrs: {
            "bottom": "",
            "origin": "center center",
            "transition": "scale-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticStyle: {
                  "min-width": "0",
                  "max-width": "20px",
                  "padding": "0",
                  "margin-top": "-3px"
                },
                attrs: {
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                attrs: {
                  "bottom": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;

                    return [_c('v-icon', _vm._g({
                      attrs: {
                        "color": "warning",
                        "small": ""
                      }
                    }, on), [_vm._v("mdi-chevron-down-circle")])]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
          return _c('v-list-item', {
            key: i,
            attrs: {
              "link": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePlatform(obj, i)
              }
            }
          }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
        }), 1)], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.media_url",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "100px"
          }
        }, [(item.media_url === '-' || item.media_url === '') ? _c('p', [_vm._v("-")]) : _c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                    View Media\n                  ")])], 1)])]) : _vm._e()]
      }
    }, {
      key: "item.typeName",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.typeName))])])]) : _c('div', [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "display": "none"
          }
        }, [_vm._v(_vm._s(item.typeName))])])])]
      }
    }, {
      key: "item.live_date",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.liveDateEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'liveDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.live_date))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          staticStyle: {
            "width": "290px",
            "float": "left"
          },
          attrs: {
            "solo": ""
          },
          model: {
            value: (item.live_date),
            callback: function($$v) {
              _vm.$set(item, "live_date", $$v)
            },
            expression: "item.live_date"
          }
        }, _vm.on))], 1)]) : _vm._e()]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
      }
    }, {
      key: "item.due_date",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.dueDateEdit === false) ? _c('div', {
          staticClass: "item-edit",
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'dueDate')
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v(_vm._s(item.due_date))])]) : _c('div', [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          staticStyle: {
            "width": "290px",
            "float": "left"
          },
          attrs: {
            "solo": ""
          },
          model: {
            value: (item.due_date),
            callback: function($$v) {
              _vm.$set(item, "due_date", $$v)
            },
            expression: "item.due_date"
          }
        }, _vm.on))], 1)]) : _vm._e()]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.amountLocked) ? _c('div', [_c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("-")])])]) : _c('div', [_c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))])])])]) : _vm._e()]
      }
    }, {
      key: "item.ims_status",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [(item.imsStatusEdit === false) ? _c('div', {
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'imsStatus')
            }
          }
        }, [(!item.noPayout) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.getIMSStatus(item.ims_status, item.payment_status)) + "\n                ")]) : _vm._e()]) : _c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "75px"
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.imsStatusOptions,
            "item-value": "status",
            "item-text": "display",
            "label": "IMS Status"
          },
          model: {
            value: (item.ims_status),
            callback: function($$v) {
              _vm.$set(item, "ims_status", $$v)
            },
            expression: "item.ims_status"
          }
        })], 1)])]) : _vm._e()]
      }
    }, {
      key: "item.payment_status",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.reportGroup) ? _c('div', [_c('div', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.payment_status)))])])]) : _vm._e()]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [(item.reportGroup) ? _c('td', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteReportGroup(item.id, item.name)
            }
          }
        }, [_vm._v("\n                Remove Group\n                "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1)], 1) : _c('td', [(item.type === 'Post') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.post_details.link,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View on IG\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-instagram")])], 1)], 1) : (item.type === 'Story') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View Story Media\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (item.type === 'TikTok') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View TikTok Media\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (_vm.isLinkedInReport(item) || item.type === 'LinkedIn Post') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.post_details ? item.post_details.link : '',
            "target": '_blank'
          }
        }, [_vm._v("\n                  View on LinkedIn\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-linkedin")])], 1)], 1) : (_vm.isTwitterReport(item) || item.type === 'X (Twitter) Post' || item.type === 'X Post') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": _vm.getReportPostUrl(item),
            "target": "_blank"
          }
        }, [_vm._v("\n                  View on X\n                  "), _c('img', {
          staticClass: "ml-2",
          staticStyle: {
            "filter": "invert(1)"
          },
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "18px",
            "alt": "",
            "aria-hidden": "true"
          }
        })])], 1) : (item.type === 'Others') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1)], 1) : (item.type === 'facebook') ? _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.media_url,
            "target": '_blank'
          }
        }, [_vm._v("\n                  View Facebook Post\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-facebook")])], 1) : _vm._e()], 1) : _c('div', [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.removeContent(item.id)
            }
          }
        }, [_vm._v("\n                  Remove\n                  "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.isYoutube || item.platform === 'instagram') ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "href": item.post_details ? item.post_details.link : '',
            "target": '_blank'
          }
        }, [(item.isYoutube) ? _c('span', [_vm._v("\n                    View on Youtube "), _c('i', {
          staticClass: "fab fa-youtube"
        })]) : _vm._e(), _vm._v(" "), (item.platform === 'instagram') ? _c('span', [_vm._v("\n                    View on Instagram\n                    "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-instagram")])], 1) : _vm._e()]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.data-table-expand",
      fn: function(ref) {
        var item = ref.item;
        var expand = ref.expand;
        var isExpanded = ref.isExpanded;

        return [(item.reportGroup) ? _c('span', [(isExpanded) ? _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(false)
            }
          }
        }, [_vm._v("mdi-chevron-up")]) : _c('v-icon', {
          on: {
            "click": function($event) {
              return expand(true)
            }
          }
        }, [_vm._v("mdi-chevron-down")])], 1) : _c('v-icon', [_vm._v("mdi-file-chart")])]
      }
    }, {
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "50px"
          }
        }, [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": "",
            "md6": ""
          }
        }, [(!item.reportGroup) ? _c('v-checkbox', {
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedPosts),
            callback: function($$v) {
              _vm.selectedPosts = $$v
            },
            expression: "selectedPosts"
          }
        }) : _c('v-icon', [_vm._v("mdi-file-multiple")])], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": "",
            "md6": ""
          }
        }, [(!item.reportGroup) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                      mdi-reload\n                    ")])], 1) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.filteredReports) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          directives: [{
            name: "sortable-data-table",
            rawName: "v-sortable-data-table"
          }],
          staticClass: "elevation-1",
          attrs: {
            "headers": headers,
            "items": item.filteredReports,
            "show-select": "",
            "single-select": false,
            "custom-sort": _vm.customSort,
            "search": _vm.searchFilter
          },
          on: {
            "sorted": _vm.handleDataTableDragDrop
          },
          scopedSlots: _vm._u([{
            key: "item.data-table-select",
            fn: function(ref) {
              var item = ref.item;

              return [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "50px"
                }
              }, [_c('v-layout', {
                attrs: {
                  "wrap": ""
                }
              }, [_c('v-flex', {
                attrs: {
                  "xs6": "",
                  "md6": ""
                }
              }, [_c('v-checkbox', {
                attrs: {
                  "label": "",
                  "value": item,
                  "color": "grey darken-2"
                },
                model: {
                  value: (_vm.selectedPosts),
                  callback: function($$v) {
                    _vm.selectedPosts = $$v
                  },
                  expression: "selectedPosts"
                }
              })], 1), _vm._v(" "), _c('v-flex', {
                attrs: {
                  "xs6": "",
                  "md6": ""
                }
              }, [_c('v-btn', {
                staticClass: "btn-reload",
                attrs: {
                  "text": "",
                  "x-small": "",
                  "color": "warning"
                },
                on: {
                  "click": function($event) {
                    return _vm.refreshReportInf(item.id)
                  }
                }
              }, [_c('v-icon', {
                attrs: {
                  "dark": "",
                  "small": ""
                }
              }, [_vm._v("\n                            mdi-reload\n                          ")])], 1)], 1)], 1)], 1)]
            }
          }, {
            key: "item.instagram",
            fn: function(ref) {
              var item = ref.item;

              return [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "100px"
                }
              }, [(item.reportGroup) ? _c('label', [_vm._v(_vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && !item.isTikTok && !item.isYoutube && !item.isFacebook && !_vm.isLinkedInReport(item) && !_vm.isTwitterReport(item) && !item.isLemon) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": _vm.getAccountProfileUrl(item)
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isYoutube) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://youtube.com/' + item.instagram
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isTikTok) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": _vm.getAccountProfileUrl(item)
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isFacebook) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://facebook.com/' + item.instagram
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isLinkedInReport(item)) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://www.linkedin.com/in/' + item.instagram
                }
              }, [_c('v-icon', {
                attrs: {
                  "color": "#0A66C2",
                  "small": ""
                }
              }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : _vm._e(), _vm._v(" "), (!item.reportGroup && _vm.isTwitterReport(item)) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://x.com/' + item.instagram
                }
              }, [_c('img', {
                staticClass: "mr-1",
                attrs: {
                  "src": "/static/img/x-logo.svg",
                  "width": "14px",
                  "alt": "",
                  "aria-hidden": "true"
                }
              }), _vm._v(" @" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (!item.reportGroup && item.isLemon) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": ""
                }
              }, [_vm._v("@" + _vm._s(item.instagram))]) : _vm._e(), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
                attrs: {
                  "bottom": "",
                  "origin": "center center",
                  "transition": "scale-transition"
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on;
                    var attrs = ref.attrs;

                    return [_c('v-btn', _vm._g(_vm._b({
                      staticStyle: {
                        "min-width": "0",
                        "max-width": "20px",
                        "padding": "0",
                        "margin-top": "-3px"
                      },
                      attrs: {
                        "dark": "",
                        "text": ""
                      }
                    }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                      attrs: {
                        "bottom": ""
                      },
                      scopedSlots: _vm._u([{
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on;

                          return [_c('v-icon', _vm._g({
                            attrs: {
                              "color": "warning",
                              "small": ""
                            }
                          }, on), [_vm._v("mdi-chevron-down-circle")])]
                        }
                      }], null, true)
                    }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
                  }
                }], null, true)
              }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
                return _c('v-list-item', {
                  key: i,
                  attrs: {
                    "link": ""
                  },
                  on: {
                    "click": function($event) {
                      return _vm.changePlatform(obj, i)
                    }
                  }
                }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
                  attrs: {
                    "src": "/static/img/xhs-black.png",
                    "width": "20px"
                  }
                }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
                  attrs: {
                    "color": "#000000",
                    "small": ""
                  }
                }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
                  attrs: {
                    "src": "/static/img/tiktok-32.png",
                    "width": "20px"
                  }
                }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
                  attrs: {
                    "color": "#000000",
                    "small": ""
                  }
                }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
              }), 1)], 1) : _vm._e()], 1)])]
            }
          }, {
            key: "item.media_url",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "100px"
                }
              }, [(item.media_url === '-' || item.media_url === '') ? _c('p', [_vm._v("-")]) : _c('v-btn', {
                attrs: {
                  "small": "",
                  "text": "",
                  "color": "secondary",
                  "elevation": "0",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                          View Media\n                        ")])], 1)])]) : _vm._e()]
            }
          }, {
            key: "item.type",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "120px"
                }
              }, [_vm._v(_vm._s(item.typeName))])])]) : _vm._e()]
            }
          }, {
            key: "item.live_date",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.liveDateEdit === false) ? _c('div', {
                staticClass: "item-edit",
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'liveDate')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(item.live_date))])]) : _c('div', [_c('v-text-field', _vm._g({
                staticClass: "mt-3",
                staticStyle: {
                  "width": "290px",
                  "float": "left"
                },
                attrs: {
                  "solo": ""
                },
                model: {
                  value: (item.live_date),
                  callback: function($$v) {
                    _vm.$set(item, "live_date", $$v)
                  },
                  expression: "item.live_date"
                }
              }, _vm.on))], 1)]) : _vm._e()]
            }
          }, {
            key: "item.outreach",
            fn: function(ref) {
              var item = ref.item;

              return [_c('tr', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.outreach)))])])]
            }
          }, {
            key: "item.due_date",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.dueDateEdit === false) ? _c('div', {
                staticClass: "item-edit",
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'dueDate')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(item.due_date))])]) : _c('div', [_c('v-text-field', _vm._g({
                staticClass: "mt-3",
                staticStyle: {
                  "width": "290px",
                  "float": "left"
                },
                attrs: {
                  "solo": ""
                },
                model: {
                  value: (item.due_date),
                  callback: function($$v) {
                    _vm.$set(item, "due_date", $$v)
                  },
                  expression: "item.due_date"
                }
              }, _vm.on))], 1)]) : _vm._e()]
            }
          }, {
            key: "item.amount",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.amountLocked) ? _c('div', [_c('div', {
                staticClass: "item-edit"
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v("-")])])]) : _c('div', [(item.amountEdit === false) ? _c('div', {
                staticClass: "item-edit",
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'amount')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))])]) : _c('div', [_c('td', {
                staticClass: "text-xs-left"
              }, [_c('v-text-field', {
                staticClass: "mt-3",
                staticStyle: {
                  "width": "150px"
                },
                attrs: {
                  "solo": "",
                  "type": "number"
                },
                model: {
                  value: (item.amount),
                  callback: function($$v) {
                    _vm.$set(item, "amount", $$v)
                  },
                  expression: "item.amount"
                }
              })], 1)])])]) : _vm._e()]
            }
          }, {
            key: "item.ims_status",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.imsStatusEdit === false && !item.noPayout) ? _c('div', {
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'imsStatus')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_vm._v(_vm._s(_vm.getIMSStatus(item.ims_status, item.payment_status)))])]) : _c('div', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "75px"
                }
              }, [_c('v-select', {
                attrs: {
                  "items": _vm.imsStatusOptions,
                  "item-value": "status",
                  "item-text": "display",
                  "label": "IMS Status"
                },
                model: {
                  value: (item.ims_status),
                  callback: function($$v) {
                    _vm.$set(item, "ims_status", $$v)
                  },
                  expression: "item.ims_status"
                }
              })], 1)])]) : _vm._e()]
            }
          }, {
            key: "item.payment_status",
            fn: function(ref) {
              var item = ref.item;

              return [(!item.reportGroup) ? _c('div', [(item.paymentStatusEdit === false) ? _c('div', {
                on: {
                  "click": function($event) {
                    return _vm.openEditItem(item, 'paymentStatus')
                  }
                }
              }, [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "50px"
                }
              }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.payment_status)))])]) : _c('div', [_c('td', {
                staticClass: "text-xs-left",
                staticStyle: {
                  "min-width": "50px"
                }
              }, [_c('v-select', {
                attrs: {
                  "items": _vm.paymentStatusOptions,
                  "item-value": "status",
                  "item-text": "display",
                  "label": "Payment Status"
                },
                model: {
                  value: (item.payment_status),
                  callback: function($$v) {
                    _vm.$set(item, "payment_status", $$v)
                  },
                  expression: "item.payment_status"
                }
              })], 1)])]) : _vm._e()]
            }
          }, {
            key: "item.action",
            fn: function(ref) {
              var item = ref.item;

              return [(item.reportGroup) ? _c('td', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.deleteReportGroup(item.id, item.name)
                  }
                }
              }, [_vm._v("\n                      Remove Group\n                      "), _c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("delete")])], 1)], 1) : _c('td', [(item.type === 'Post') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.post_details.link,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View on IG\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-instagram")])], 1)], 1) : (item.type === 'Story') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View Story Media\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (item.type === 'TikTok') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View TikTok Media\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-clipboard-play")])], 1) : _vm._e()], 1) : (_vm.isLinkedInReport(item) || item.type === 'LinkedIn Post') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.post_details ? item.post_details.link : '',
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View on LinkedIn\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-linkedin")])], 1)], 1) : (_vm.isTwitterReport(item) || item.type === 'X (Twitter) Post' || item.type === 'X Post') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": _vm.getReportPostUrl(item),
                  "target": "_blank"
                }
              }, [_vm._v("\n                        View on X\n                        "), _c('img', {
                staticClass: "ml-2",
                staticStyle: {
                  "filter": "invert(1)"
                },
                attrs: {
                  "src": "/static/img/x-logo.svg",
                  "width": "18px",
                  "alt": "",
                  "aria-hidden": "true"
                }
              })])], 1) : (item.type === 'facebook') ? _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), (item.media_url) ? _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.media_url,
                  "target": '_blank'
                }
              }, [_vm._v("\n                        View Facebook Post\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-facebook")])], 1) : _vm._e()], 1) : _c('div', [_c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "red"
                },
                on: {
                  "click": function($event) {
                    return _vm.removeContent(item.id)
                  }
                }
              }, [_vm._v("\n                        Remove\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-delete")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "small": "",
                  "color": "secondary",
                  "href": item.post_details ? item.post_details.link : '',
                  "target": '_blank'
                }
              }, [(item.isYoutube) ? _c('span', [_vm._v("\n                        View on Youtube "), _c('i', {
                staticClass: "fab fa-youtube"
              })]) : _c('span', [_vm._v("\n                        View on Instagram\n                        "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-instagram")])], 1)])], 1)])]
            }
          }], null, true),
          model: {
            value: (_vm.selectedPosts),
            callback: function($$v) {
              _vm.selectedPosts = $$v
            },
            expression: "selectedPosts"
          }
        })], 1) : _vm._e()]
      }
    }], null, true),
    model: {
      value: (_vm.selectedPosts),
      callback: function($$v) {
        _vm.selectedPosts = $$v
      },
      expression: "selectedPosts"
    }
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center font-weight-bold"
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalCounts.contents)))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.summary.outreach)))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center font-weight-bold"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  })])])], 2)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedCampaignID) ? _c('div', [_c('report-payout-lists', {
    attrs: {
      "campaignID": _vm.selectedCampaignID
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "selectedPostIds": _vm.selectedPostIds,
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataView,
      "campaignPayouts": _vm.campaignPayouts
    },
    on: {
      "done": function($event) {
        return _vm.quickReload()
      },
      "addedReport": _vm.addReportManually
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "value": _vm.viewCampaignModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewCampaignModalDialog),
      callback: function($$v) {
        _vm.viewCampaignModalDialog = $$v
      },
      expression: "viewCampaignModalDialog"
    }
  }), _vm._v(" "), _c('update-insights-modal', {
    attrs: {
      "value": _vm.postInsightdialog,
      "post": _vm.updatePostInsightsData,
      "campaign": _vm.campaignData,
      "imagesToView": _vm.campaignPayout
    },
    on: {
      "done": function($event) {
        return _vm.quickReload()
      }
    },
    model: {
      value: (_vm.postInsightdialog),
      callback: function($$v) {
        _vm.postInsightdialog = $$v
      },
      expression: "postInsightdialog"
    }
  }), _vm._v(" "), _c('report-group-modal', {
    attrs: {
      "selectedPosts": _vm.selectedPosts,
      "campaignID": _vm.selectedCampaignID
    },
    on: {
      "saved": _vm.savedReportGroup
    },
    model: {
      value: (_vm.reportGroupDialog),
      callback: function($$v) {
        _vm.reportGroupDialog = $$v
      },
      expression: "reportGroupDialog"
    }
  }), _vm._v(" "), _c('edit-report-handle-modal', {
    attrs: {
      "report": _vm.editHandleReport
    },
    on: {
      "saved": function($event) {
        return _vm.quickReload()
      }
    },
    model: {
      value: (_vm.editReportHandleDialog),
      callback: function($$v) {
        _vm.editReportHandleDialog = $$v
      },
      expression: "editReportHandleDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Table Settings",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('campaign-settings', {
    attrs: {
      "campaign": _vm.campaignData
    },
    on: {
      "saved": function($event) {
        return _vm.quickReload()
      }
    },
    model: {
      value: (_vm.campaignSettingsDialog),
      callback: function($$v) {
        _vm.campaignSettingsDialog = $$v
      },
      expression: "campaignSettingsDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.isScrapLoading),
      callback: function($$v) {
        _vm.isScrapLoading = $$v
      },
      expression: "isScrapLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4 text-center"
  }, [_c('v-progress-linear', {
    staticClass: "mb-3",
    attrs: {
      "indeterminate": "",
      "color": "white",
      "height": "6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle-1",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.scrapingStatusMessage))])], 1)], 1)], 1), _vm._v(" "), _c('view-post-comments-modal', {
    attrs: {
      "value": _vm.viewCommentsDialog,
      "comments": _vm.selectedPostComments
    },
    on: {
      "close": function($event) {
        _vm.viewCommentsDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [(_vm.step === 1) ? _c('div', {
    staticStyle: {
      "margin-left": "30%",
      "max-width": "600px"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-container', {
    staticClass: "coverage-form-container",
    staticStyle: {
      "max-width": "1200px"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Choose Platform "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "max-width": "200px",
      "margin-top": "10px"
    },
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "items": _vm.platformList,
      "required": "",
      "error-messages": _vm.$v.platform.$error && "Platform is required."
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      },
      "input": function($event) {
        return _vm.$v.platform.$touch()
      }
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Inf. Country "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "200px",
      "margin-top": "10px"
    },
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "",
      "multiple": "",
      "required": "",
      "error-messages": _vm.$v.searchSettings.influencerGeos.$error && "Country is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.searchSettings.influencerGeos.$touch()
      }
    },
    model: {
      value: (_vm.searchSettings.influencerGeos),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "influencerGeos", $$v)
      },
      expression: "searchSettings.influencerGeos"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Aud. Country "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "200px",
      "margin-top": "10px"
    },
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "",
      "multiple": "",
      "required": "",
      "error-messages": _vm.$v.searchSettings.audGeos.$error && "Country is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.searchSettings.audGeos.$touch()
      }
    },
    model: {
      value: (_vm.searchSettings.audGeos),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "audGeos", $$v)
      },
      expression: "searchSettings.audGeos"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "90px",
      "margin-top": "10px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.percentOptions
    },
    model: {
      value: (_vm.searchSettings.audGeoPercent),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "audGeoPercent", $$v)
      },
      expression: "searchSettings.audGeoPercent"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Followers "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.from
    },
    model: {
      value: (_vm.searchSettings.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings.followers, "from", $$v)
      },
      expression: "searchSettings.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.to
    },
    model: {
      value: (_vm.searchSettings.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings.followers, "to", $$v)
      },
      expression: "searchSettings.followers.to"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Gender "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: (_vm.searchSettings.infGender),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "infGender", $$v)
      },
      expression: "searchSettings.infGender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Male or Female",
      "value": "KNOWN"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Male",
      "value": "MALE"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Female",
      "value": "FEMALE"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-5 mb-5 justify-end"
  }, [_c('v-btn', {
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeNext()
      }
    }
  }, [_c('v-icon', _vm._g({}, _vm.on), [_vm._v("mdi-skip-next")]), _vm._v(" Next\n        ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row pt-2"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('v-text-field', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Bio",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInf()
      }
    },
    model: {
      value: (_vm.searchSettings.bio),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "bio", $$v)
      },
      expression: "searchSettings.bio"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-2"
  }, [_c('v-text-field', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Keywords",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInf()
      }
    },
    model: {
      value: (_vm.searchSettings.keywords),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "keywords", $$v)
      },
      expression: "searchSettings.keywords"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row pt-2"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('v-combobox', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Mentions",
      "outlined": "",
      "dense": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "auto"
    },
    on: {
      "change": function($event) {
        return _vm.searchInf()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e()]
      }
    }], null, false, 742319186),
    model: {
      value: (_vm.searchSettings.mentions),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "mentions", $$v)
      },
      expression: "searchSettings.mentions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-2"
  }, [_c('v-combobox', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Hashtags",
      "outlined": "",
      "dense": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "auto"
    },
    on: {
      "change": function($event) {
        return _vm.searchInf()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e()]
      }
    }], null, false, 742319186),
    model: {
      value: (_vm.searchSettings.hashtags),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "hashtags", $$v)
      },
      expression: "searchSettings.hashtags"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row pt-2"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('v-autocomplete', {
    staticClass: "search-keyword min-max-200",
    attrs: {
      "items": _vm.audLookItems,
      "loading": _vm.audLookLoading,
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "dense": "",
      "label": "Aud. Lookalikes",
      "search-input": _vm.newAudLookKeyword
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newAudLookKeyword = $event
      },
      "update:search-input": function($event) {
        _vm.newAudLookKeyword = $event
      },
      "keyup": _vm.searchAudLookalike
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeAudLookKeyword()
            }
          }
        }, [_vm._v(_vm._s(data.item))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("@" + _vm._s(data.item))]), _vm._v(" "), _c('v-list-item-subtitle')], 1)]
        ]
      }
    }], null, false, 4060976889),
    model: {
      value: (_vm.audLookKeyword),
      callback: function($$v) {
        _vm.audLookKeyword = $$v
      },
      expression: "audLookKeyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-2"
  }, [_c('v-autocomplete', {
    staticClass: "search-keyword min-max-200",
    attrs: {
      "items": _vm.infLookItems,
      "loading": _vm.lookLoading,
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "dense": "",
      "label": "Inf. Lookalikes",
      "search-input": _vm.newInfLookKeyword
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newInfLookKeyword = $event
      },
      "update:search-input": function($event) {
        _vm.newInfLookKeyword = $event
      },
      "keyup": _vm.searchInfLookalike
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeLookKeyword()
            }
          }
        }, [_vm._v(_vm._s(data.item))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("@" + _vm._s(data.item))]), _vm._v(" "), _c('v-list-item-subtitle')], 1)]
        ]
      }
    }], null, false, 3169878793),
    model: {
      value: (_vm.infLookKeyword),
      callback: function($$v) {
        _vm.infLookKeyword = $$v
      },
      expression: "infLookKeyword"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "pr-2 pt-2"
  }, [_c('v-autocomplete', {
    staticClass: "search-keyword min-max-250",
    attrs: {
      "items": _vm.searchItems,
      "item-text": "tag",
      "loading": _vm.keywordLoading,
      "multiple": "",
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "dense": "",
      "label": "Search by Topic",
      "search-input": _vm.newKeyword
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newKeyword = $event
      },
      "update:search-input": function($event) {
        _vm.newKeyword = $event
      },
      "keyup": _vm.searchByKeywords
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeKeyword(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.item.tag))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(data.item.tag))]), _vm._v(" "), _c('v-list-item-subtitle')], 1)]
        ]
      }
    }], null, false, 400024750),
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "topic-platform-select min-max-250 pt-2",
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.platformList
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right pt-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.searchInf
    }
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "pt-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.openSettingsDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red lighten-2",
      "dark": ""
    }
  }, [_vm._v("settings")])], 1)], 1)]), _vm._v(" "), _c('settings-modal', {
    attrs: {
      "value": _vm.dialog,
      "oldSettings": _vm.searchSettings
    },
    on: {
      "saveSettings": _vm.saveSettings
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  })], 1)], 1), _vm._v(" "), (_vm.wordCloudData.length) ? _c('div', {
    staticClass: "text-center mt-3 mb-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [_c('vue-word-cloud', {
    staticStyle: {
      "position": "relative",
      "max-width": "700px",
      "height": "200px",
      "margin-left": "25%"
    },
    attrs: {
      "v-show": true,
      "words": _vm.wordCloudData,
      "color": function (ref) { return _vm.getRandomColor(); },
      "animation-duration": 1,
      "font-size-ratio": 2,
      "spacing": 0.5,
      "font-family": "Roboto"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 pb-0",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('strong', [_vm._v("Total Influencers: " + _vm._s(_vm._f("thousandSeprator")(_vm.totalItems)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('v-text-field', {
    staticClass: "float-right mb-2",
    staticStyle: {
      "min-width": "500px",
      "max-width": "500px"
    },
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.iqDataTableSearch),
      callback: function($$v) {
        _vm.iqDataTableSearch = $$v
      },
      expression: "iqDataTableSearch"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v("Export\n          ")], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.iqDataHeaders,
      "items": _vm.iqDataItems,
      "items-per-page": 20,
      "page": _vm.currentPage,
      "item-key": "handle",
      "loading": _vm.loading,
      "search": _vm.iqDataTableSearch,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "no-data-text": "Empty list"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [(items.length) ? _c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.handle
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "200px"
            }
          }, [_c('v-avatar', {
            attrs: {
              "size": _vm.avatarSize,
              "color": "grey lighten-4"
            }
          }, [_c('img', {
            attrs: {
              "src": item.profilePicture,
              "alt": "avatar"
            }
          })]), _vm._v(" "), (item.hidden) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({
                  staticClass: "hidden-text"
                }, on), [_vm._v("Hidden")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Hidden")])]) : _c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": _vm.platformShort === 'tiktok',
              "isInstagram": _vm.platformShort === 'instagram',
              "isYoutube": _vm.platformShort === 'youtube',
              "tiktokHandle": item.handle,
              "instagramHandle": item.handle,
              "youtubeHandle": item.handle
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.fullName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalFollowers)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagements)))])])
        }), 0) : _c('tbody', [_c('div', {
          staticClass: "pa-3"
        }, [_vm._v("Empty List")])])]
      }
    }], null, false, 1131942457)
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center pt-3"
  }, [_c('v-btn', {
    staticStyle: {
      "min-width": "101px"
    },
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.searchNextInf
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-next")]), _vm._v(" More\n      ")], 1)], 1), _vm._v(" "), (_vm.isSuperAdminRole) ? _c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLocal) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.localPagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.localTotalItems,
      "item-key": "handle",
      "loading": _vm.localLoading,
      "no-data-text": 'Empty list'
    },
    on: {
      "update:options": function($event) {
        _vm.localPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [(items.length) ? _c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.handle
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "200px"
            }
          }, [_c('v-avatar', {
            attrs: {
              "size": _vm.avatarSize,
              "color": "grey lighten-4"
            }
          }, [_c('img', {
            attrs: {
              "src": item.profilePicture,
              "alt": "avatar"
            }
          })]), _vm._v(" "), _c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": _vm.platformShort === 'tiktok',
              "isInstagram": _vm.platformShort === 'instagram',
              "isYoutube": _vm.platformShort === 'youtube',
              "tiktokHandle": item.handle,
              "instagramHandle": item.handle,
              "youtubeHandle": item.handle
            }
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "btn-reload pl-0",
            attrs: {
              "text": "",
              "x-small": "",
              "color": "warning"
            },
            on: {
              "click": function($event) {
                return _vm.refreshReport(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "dark": "",
              "small": ""
            }
          }, [_vm._v("\n                        mdi-reload\n                      ")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.fullName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(item.tags && item.tags.length > 0) ? _c('v-chip', {
            staticClass: "mr-1",
            attrs: {
              "label": "",
              "color": "green",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            attrs: {
              "float-left": "",
              "small": ""
            }
          }, [_vm._v("label")]), _vm._v(" \n                      " + _vm._s(item.tags[0]) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.infInterests),
              expression: "item.infInterests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.tags && item.tags.length > 1),
                    expression: "item.tags && item.tags.length > 1"
                  }],
                  attrs: {
                    "id": 'btnMore_' + item.id,
                    "color": "primary",
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                          More...\n                        ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('b', [_vm._v("Tags")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.tags), function(tag, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index !== 0),
                expression: "index !== 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "label": "",
                "color": "green",
                "small": "",
                "text-color": "white"
              }
            }, [_c('v-icon', {
              attrs: {
                "float-left": "",
                "small": ""
              }
            }, [_vm._v("label")]), _vm._v(" \n                          " + _vm._s(tag) + "\n                          ")], 1)
          })], 2)], 1)], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalFollowers)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgViews)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgLikes)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgComments)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgReelPlays)))]), _vm._v(" "), _c('td', {
            staticClass: "justify-center layout px-0"
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.showReport(item)
                    }
                  }
                }, on), [_vm._v("assessment")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewInfluencerPosts(item)
                    }
                  }
                }, on), [_vm._v("local_library")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Top Posts")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewRecentPosts(item)
                    }
                  }
                }, on), [_vm._v("mdi-file-clock-outline")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Recent Posts")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewSimilarUsers(item)
                    }
                  }
                }, on), [_vm._v("mdi-account-group")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Lookalikes")])])], 1)])
        }), 0) : _c('tbody', [_c('div', {
          staticClass: "pa-3"
        }, [_vm._v("Empty List")])])]
      }
    }], null, false, 3400726194)
  })], 1)])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('influencer-post-modal', {
    attrs: {
      "modalId": _vm.influencerPostModalId,
      "title": _vm.postsTitle,
      "platform": _vm.platformShort,
      "shortCodes": _vm.shortCodes
    }
  }), _vm._v(" "), _c('similar-users-modal', {
    attrs: {
      "handle": _vm.similarHandle,
      "items": _vm.similarItems,
      "platform": _vm.platformShort
    },
    model: {
      value: (_vm.viewSimilarUsersDialog),
      callback: function($$v) {
        _vm.viewSimilarUsersDialog = $$v
      },
      expression: "viewSimilarUsersDialog"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewReport",
      "data-toggle": "modal",
      "data-target": _vm.audienceDataReportDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.overlayLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.overlayLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getAllBrandSheets()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-cached\n        ")]), _vm._v(" \n        Reload\n      ")], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("\n              mdi-content-copy\n            ")]), _vm._v(" Copy Link\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(action, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.copyBrandSheetLink(action.value)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(action.title))])], 1)
  }), 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-brand-link"
    },
    domProps: {
      "value": _vm.brandSheetLink
    }
  }), _vm._v(" "), (_vm.brandLinkCopied) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "elevation": "0",
      "text": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-check\n        ")]), _vm._v("Copied\n      ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row mt-3",
    staticStyle: {
      "justify-content": "space-between",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Submissions for " + _vm._s(_vm.currentMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalValues.currentMonth)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Total Submissions for " + _vm._s(_vm.currentYearLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalValues.currentYear)))])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.openTotalSubmissionsModal
    }
  }, [_vm._v("\n                More Details\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item.type",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [_vm._v("\n            " + _vm._s(item.type === 'UGC' ? 'UGC Videos' : item.type) + "\n          ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.getBrandSheetDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.downloadBFS(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Download"
          }
        }, [_vm._v("download")])], 1)], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('view-brand-sheet-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "brandSheetData": _vm.viewBrandSheetData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('total-submissions-modal', {
    attrs: {
      "value": _vm.totalSubmissionsModalDialog,
      "monthYearValues": _vm.monthYearValues
    },
    model: {
      value: (_vm.totalSubmissionsModalDialog),
      callback: function($$v) {
        _vm.totalSubmissionsModalDialog = $$v
      },
      expression: "totalSubmissionsModalDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', {
    staticClass: "row pa-2"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.CampaignId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CampaignId", $$v)
      },
      expression: "selectedFilter.CampaignId"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterUsers,
      "label": "CC Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.UserId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "UserId", $$v)
      },
      expression: "selectedFilter.UserId"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    ref: "monthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Year Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.search()
            }
          },
          model: {
            value: (_vm.searchMonth),
            callback: function($$v) {
              _vm.searchMonth = $$v
            },
            expression: "searchMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.monthPicker),
      callback: function($$v) {
        _vm.monthPicker = $$v
      },
      expression: "monthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.searchMonth),
      callback: function($$v) {
        _vm.searchMonth = $$v
      },
      expression: "searchMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.monthPicker = false
      }
    }
  }, [_vm._v("\n                  Cancel\n              ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchMonthOk
    }
  }, [_vm._v("\n                  OK\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "single-expand": "",
      "expanded": _vm.expanded,
      "items-per-page": 5,
      "show-expand": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.avg_satisfy",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v(_vm._s(item.avg_satisfy) + " / 5")]
      }
    }, {
      key: "item.avg_advertiser",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v(_vm._s(item.avg_advertiser) + " / 5")]
      }
    }, {
      key: "item.avg_kobe",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v(_vm._s(item.avg_kobe) + " / 5")]
      }
    }, {
      key: "item.avg_overall",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v(_vm._s(item.avg_overall) + " / 5")]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [_c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.influencerDetailHeaders,
            "items": item.influencerRatings
          },
          scopedSlots: _vm._u([{
            key: "item.profilePicture",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-avatar', {
                attrs: {
                  "size": _vm.avatarSize,
                  "color": "grey lighten-4"
                }
              }, [_c('img', {
                attrs: {
                  "src": _vm.paserImageUrl(item.profilePicture),
                  "alt": "avatar"
                }
              })])]
            }
          }, {
            key: "item.instagramHandle",
            fn: function(ref) {
              var item = ref.item;

              return [(item.instagramHandle) ? _c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://instagram.com/' + item.instagramHandle
                }
              }, [_vm._v("@" + _vm._s(item.instagramHandle))]) : _c('span', [_vm._v("N/A")])]
            }
          }, {
            key: "item.avg_satisfy",
            fn: function(ref) {
              var item = ref.item;

              return [_vm._v(_vm._s(item.avg_satisfy) + " / 5")]
            }
          }, {
            key: "item.avg_advertiser",
            fn: function(ref) {
              var item = ref.item;

              return [_vm._v(_vm._s(item.avg_advertiser) + " / 5")]
            }
          }, {
            key: "item.avg_kobe",
            fn: function(ref) {
              var item = ref.item;

              return [_vm._v(_vm._s(item.avg_kobe) + " / 5")]
            }
          }, {
            key: "item.avg_overall",
            fn: function(ref) {
              var item = ref.item;

              return [_vm._v(_vm._s(item.avg_overall) + " / 5")]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-card', {
    attrs: {
      "width": "100%",
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-container', [(_vm.showUpload || !_vm.isEdit) ? _c('v-row', {
    attrs: {
      "align": "start",
      "justify": "left"
    }
  }, [_c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.media.length === 0),
      expression: "media.length === 0 "
    }],
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "14px",
      "font-weight": "400"
    }
  }, [_vm._v("Client Logo")]), _vm._v(" "), _c('v-responsive', {
    attrs: {
      "aspect-ratio": 1
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "outlined": "",
      "flat": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-auto",
    attrs: {
      "dark": "",
      "icon": "",
      "x-large": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-cloud-upload")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": "image/*"
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.showUpload = false
      }
    }
  }, [_vm._v("\n                  Cancel\n                ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.media), function(img, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      }
    }, [_c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  })], 2) : _c('v-row', {
    attrs: {
      "align": "start",
      "justify": "left"
    }
  }, [(_vm.logoURI !== null && _vm.logoURI !== '') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.logoURI,
      "lazy-src": _vm.logoURI,
      "cover": ""
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "grey lighten-5"
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 4034393411)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpload = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "lazy-src": "/static/img/upload-post-photo.png",
      "src": "/static/img/upload-post-photo.png",
      "cover": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpload = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content report-payout-list"
  }, [(_vm.source !== 'payout') ? _c('div', [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Submitted Payouts")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%",
      "color": "rgba(0,0,0,0.12)",
      "margin-top": "10px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Payout Submitted")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v(_vm._s(_vm.totalValues.submitted.actual) + " / " + _vm._s(_vm.totalValues.submitted.total))]), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pa-0 subtitle-1"
  }, [_vm._v(_vm._s(_vm.totalValues.submitted.percent) + "%")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-card-title', [_c('v-row', {
    staticStyle: {
      "justify-content": "right"
    }
  }, [(_vm.source == 'payout') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        placeholder: 'Submission Date'
      },
      "date": _vm.searchFilters.submissionDate,
      "status": _vm.subDateCal
    },
    on: {
      "changeDate": _vm.setSubmissionDateFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.source == 'payout') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        placeholder: 'Due Date'
      },
      "date": _vm.searchFilters.dueDate,
      "status": _vm.dueDateCal
    },
    on: {
      "changeDate": _vm.setDueDateFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    ref: "ReportPayoutListsTable",
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "search": _vm.filter
    },
    on: {
      "current-items": _vm.currentItems
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', {
            staticClass: "report-payout-handle-column"
          }, [(item.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.handle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.handle) + "\n                    ")]) : (item.platform === 'youtube') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://youtube.com/' + item.handle
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'facebook') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://facebook.com/' + item.handle
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'linkedin') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": _vm.linkedInProfileUrl(item)
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.handle))], 1) : (item.platform === 'twitter') ? _c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://x.com/' + item.handle
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(item.handle))]) : (item.platform === 'xiaohongshu') ? _c('a', {
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.fullName || item.handle))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.handle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.handle || item.instagram) + "\n                    ")], 1)]), _vm._v(" "), _c('td', [(item.pending) ? _c('div', [_vm._v("\n                      -\n                    ")]) : _c('div', [_vm._v("\n                      " + _vm._s(_vm.changeDateFormat(item.createdAt)) + "\n                    ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.pending) ? _c('div', [_vm._v("\n                      -\n                    ")]) : _c('div', [_vm._v("\n                      " + _vm._s(item.satisfaction_level_on_kobe) + " / 5\n                    ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.pending) ? _c('div', [_vm._v("\n                      -\n                    ")]) : _c('div', [_vm._v("\n                      " + _vm._s(item.satisfaction_level_on_advertiser) + " / 5\n                    ")])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.promotingProducts) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.promotingProducts,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.improved) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.improved,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.audienceEnjoyment) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.audienceEnjoyment,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "read-more-text"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_vm._v("\n                      -\n                    ")]) : _c('div', [(item.otherCampaigns) ? _c('div', [_c('read-more', {
            attrs: {
              "more-str": "read more",
              "text": item.otherCampaigns,
              "link": "#",
              "less-str": "read less",
              "max-chars": 50
            }
          })], 1) : _c('div', [_vm._v("\n                        Empty\n                      ")])])]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.pending) ? _c('div', {
            staticClass: "pending-text"
          }, [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.copyFormLink(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Stats Submit Form")])], 1)], 1) : _c('div', [_c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "ims-action",
                  attrs: {
                    "small": "",
                    "color": "secondary",
                    "disabled": _vm.disableViewScreenshot(item)
                  },
                  on: {
                    "click": function($event) {
                      return _vm.viewImages(item)
                    }
                  }
                }, on), [_c('v-icon', [_vm._v("mdi-image-multiple")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Attached Screenshots")])])], 1)])])
        }), 0)]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('v-alert', {
          attrs: {
            "color": "error",
            "icon": "warning"
          }
        }, [_vm._v("\n                Your search for \"" + _vm._s(_vm.filter) + "\" found no results.\n              ")])]
      },
      proxy: true
    }])
  })], 1)])])])]), _vm._v(" "), _c('payout-screenshots-dialog', {
    attrs: {
      "value": _vm.viewScreenShotsDialog,
      "imagesToView": _vm.imagesToView
    },
    model: {
      value: (_vm.viewScreenShotsDialog),
      callback: function($$v) {
        _vm.viewScreenShotsDialog = $$v
      },
      expression: "viewScreenShotsDialog"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n      Copied to Clipboard!\n      "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.formLink
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', _vm._l((_vm.serviceList ? _vm.serviceList : _vm.items), function(item) {
    return _c('v-list-item', {
      key: item.service
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(item.service)
      }
    })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": item.status ? 'green' : 'red'
      }
    }, [_vm._v("cloud_circle")])], 1)], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('cogs-estimate-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Posting Link")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "hide-details": "",
      "error-messages": _vm.postingLink
    },
    on: {
      "input": function($event) {
        return _vm.$v.postingLink.$touch()
      },
      "blur": function($event) {
        return _vm.$v.postingLink.$touch()
      }
    },
    model: {
      value: (_vm.postingLink),
      callback: function($$v) {
        _vm.postingLink = $$v
      },
      expression: "postingLink"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.postingLink.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "8",
      "md": "6"
    }
  }, [_c('v-card', [_c('v-spacer'), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "invite-platform-selector",
    attrs: {
      "role": "radiogroup",
      "aria-label": "Select invitation platform"
    }
  }, [_c('span', {
    staticClass: "invite-platform-selector__label"
  }, [_vm._v("Platform")]), _vm._v(" "), _vm._l((_vm.invitePlatformOptions), function(platformOption) {
    return _c('v-btn', {
      key: platformOption.value,
      staticClass: "invite-platform-selector__button",
      class: {
        'invite-platform-selector__button--active': _vm.rdoPlatformOption === platformOption.value
      },
      attrs: {
        "text": "",
        "small": "",
        "role": "radio",
        "aria-checked": String(_vm.rdoPlatformOption === platformOption.value)
      },
      on: {
        "click": function($event) {
          _vm.rdoPlatformOption = platformOption.value
        }
      }
    }, [_c('span', {
      staticClass: "invite-platform-selector__logos"
    }, [_vm._l((platformOption.logos), function(platformLogo, logoIndex) {
      return [(platformLogo.imgIcon) ? _c('img', {
        key: ((platformOption.value) + "-" + logoIndex),
        staticClass: "invite-platform-selector__logo",
        attrs: {
          "src": platformLogo.imgIcon,
          "alt": ((platformLogo.name) + " logo")
        }
      }) : _c('v-icon', {
        key: ((platformOption.value) + "-" + logoIndex),
        attrs: {
          "size": "18",
          "color": platformLogo.iconColor
        }
      }, [_vm._v("\n                    " + _vm._s(platformLogo.icon) + "\n                  ")])]
    })], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(platformOption.text))])])
  })], 2), _vm._v(" "), (_vm.rdoPlatformOption === 'default') ? _c('div', [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "mdi-account",
      "error-messages": _vm.nameErrors,
      "label": "Name",
      "placeholder": "Name",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "mdi-instagram",
      "label": "Instagram Handle",
      "placeholder": "Instagram Handle",
      "outlined": ""
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "fab fa-tiktok",
      "label": "TikTok Handle",
      "placeholder": "TikTok Handle",
      "outlined": ""
    },
    model: {
      value: (_vm.tiktokHandle),
      callback: function($$v) {
        _vm.tiktokHandle = $$v
      },
      expression: "tiktokHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "fab fa-youtube",
      "label": "Youtube Handle or URL",
      "placeholder": "Youtube Handle or URL",
      "outlined": ""
    },
    model: {
      value: (_vm.youtubeHandle),
      callback: function($$v) {
        _vm.youtubeHandle = $$v
      },
      expression: "youtubeHandle"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "prepend-inner-icon": "my_location",
      "items": _vm.locations,
      "label": "Select your location",
      "outlined": ""
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rdoPlatformOption === 'xiaohongshu') ? _c('div', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter XHS Fullname",
      "label": "Enter XHS Fullname",
      "prepend-inner-icon": "mdi-file-document-outline",
      "error-messages": _vm.xhsFullnameErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.xhs.xhsFullname.$touch()
      },
      "blur": function($event) {
        return _vm.$v.xhs.xhsFullname.$touch()
      }
    },
    model: {
      value: (_vm.xhs.xhsFullname),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsFullname", $$v)
      },
      expression: "xhs.xhsFullname"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter XHS Handle",
      "label": "Enter XHS Handle",
      "prepend-inner-icon": "mdi-file-document-outline",
      "error-messages": _vm.xhsHandleErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.xhs.xhsHandle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.xhs.xhsHandle.$touch()
      }
    },
    model: {
      value: (_vm.xhs.xhsHandle),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsHandle", $$v)
      },
      expression: "xhs.xhsHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter XHS ID",
      "label": "Enter XHS ID",
      "prepend-inner-icon": "mdi-file-document-outline",
      "error-messages": _vm.xhsIDErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.xhs.xhsID.$touch()
      },
      "blur": function($event) {
        return _vm.$v.xhs.xhsID.$touch()
      },
      "keyup": function($event) {
        return _vm.changeXhsId()
      }
    },
    model: {
      value: (_vm.xhs.xhsID),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "xhsID", $$v)
      },
      expression: "xhs.xhsID"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter XHS Total Followers",
      "label": "Enter XHS Total Followers",
      "prepend-inner-icon": "mdi-account-group",
      "type": "number",
      "error-messages": _vm.xhsTotalFollowersErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.xhs.totalFollowers.$touch()
      },
      "blur": function($event) {
        return _vm.$v.xhs.totalFollowers.$touch()
      }
    },
    model: {
      value: (_vm.xhs.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalFollowers", $$v)
      },
      expression: "xhs.totalFollowers"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter XHS Total Likes Favourites",
      "label": "Enter XHS Total Likes Favourites",
      "prepend-inner-icon": "mdi-heart",
      "type": "number",
      "error-messages": _vm.xhsTotalLikesFavouritesErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.xhs.totalLikesFavourites.$touch()
      },
      "blur": function($event) {
        return _vm.$v.xhs.totalLikesFavourites.$touch()
      }
    },
    model: {
      value: (_vm.xhs.totalLikesFavourites),
      callback: function($$v) {
        _vm.$set(_vm.xhs, "totalLikesFavourites", $$v)
      },
      expression: "xhs.totalLikesFavourites"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rdoPlatformOption === 'facebook') ? _c('div', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter Handle",
      "label": "Enter Handle",
      "prepend-inner-icon": "mdi-account-group-outline",
      "append-icon": "mdi-check-circle-outline",
      "loading": _vm.publicProfileLoading === 'facebook',
      "error-messages": _vm.fbHandleErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.facebook.fbHandle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.facebook.fbHandle.$touch()
      },
      "click:append": function($event) {
        return _vm.validatePublicProfile('facebook')
      }
    },
    model: {
      value: (_vm.facebook.fbHandle),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "fbHandle", $$v)
      },
      expression: "facebook.fbHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter Facebook ID",
      "label": "Enter Facebook ID",
      "prepend-inner-icon": "mdi-file-document-outline",
      "error-messages": _vm.fbIDErrors
    },
    on: {
      "keyup": function($event) {
        return _vm.changeFbId()
      },
      "input": function($event) {
        return _vm.$v.facebook.fbID.$touch()
      },
      "blur": function($event) {
        return _vm.$v.facebook.fbID.$touch()
      }
    },
    model: {
      value: (_vm.facebook.fbID),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "fbID", $$v)
      },
      expression: "facebook.fbID"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter Total Followers",
      "label": "Enter Total Followers",
      "prepend-inner-icon": "mdi-account-group",
      "type": "number",
      "error-messages": _vm.fbTotalFollowerErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.facebook.totalFollowers.$touch()
      },
      "blur": function($event) {
        return _vm.$v.facebook.totalFollowers.$touch()
      }
    },
    model: {
      value: (_vm.facebook.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.facebook, "totalFollowers", $$v)
      },
      expression: "facebook.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rdoPlatformOption === 'linkedin') ? _c('div', [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "mdi-account",
      "error-messages": _vm.nameErrors,
      "label": "Name",
      "placeholder": "Name",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter LinkedIn Handle",
      "label": "Enter LinkedIn Handle",
      "prepend-inner-icon": "mdi-linkedin",
      "append-icon": "mdi-check-circle-outline",
      "loading": _vm.linkedInLoading,
      "error-messages": _vm.linkedinHandleErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.linkedin.linkedinHandle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.linkedin.linkedinHandle.$touch()
      },
      "click:append": _vm.validateLinkedInProfile
    },
    model: {
      value: (_vm.linkedin.linkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.linkedin, "linkedinHandle", $$v)
      },
      expression: "linkedin.linkedinHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter LinkedIn Full Name",
      "label": "Enter LinkedIn Full Name",
      "prepend-inner-icon": "mdi-account-card-details",
      "error-messages": _vm.linkedinFullnameErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.linkedin.linkedinFullname.$touch()
      },
      "blur": function($event) {
        return _vm.$v.linkedin.linkedinFullname.$touch()
      }
    },
    model: {
      value: (_vm.linkedin.linkedinFullname),
      callback: function($$v) {
        _vm.$set(_vm.linkedin, "linkedinFullname", $$v)
      },
      expression: "linkedin.linkedinFullname"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter Followers",
      "label": "Followers",
      "prepend-inner-icon": "mdi-account-group",
      "type": "number",
      "error-messages": _vm.linkedinTotalFollowersErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.linkedin.totalFollowers.$touch()
      },
      "blur": function($event) {
        return _vm.$v.linkedin.totalFollowers.$touch()
      }
    },
    model: {
      value: (_vm.linkedin.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.linkedin, "totalFollowers", $$v)
      },
      expression: "linkedin.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.rdoPlatformOption === 'twitter') ? _c('div', [_c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "mdi-account",
      "error-messages": _vm.nameErrors,
      "label": "Name",
      "placeholder": "Name",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter X (Twitter) Handle",
      "label": "Enter X (Twitter) Handle",
      "append-icon": "mdi-check-circle-outline",
      "loading": _vm.publicProfileLoading === 'twitter',
      "error-messages": _vm.twitterHandleErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.twitter.twitterHandle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.twitter.twitterHandle.$touch()
      },
      "click:append": function($event) {
        return _vm.validatePublicProfile('twitter')
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.twitter.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.twitter, "twitterHandle", $$v)
      },
      expression: "twitter.twitterHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter X Display Name",
      "label": "Enter X Display Name",
      "prepend-inner-icon": "mdi-account-card-details",
      "error-messages": _vm.twitterFullnameErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.twitter.twitterFullname.$touch()
      },
      "blur": function($event) {
        return _vm.$v.twitter.twitterFullname.$touch()
      }
    },
    model: {
      value: (_vm.twitter.twitterFullname),
      callback: function($$v) {
        _vm.$set(_vm.twitter, "twitterFullname", $$v)
      },
      expression: "twitter.twitterFullname"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "Enter Total Followers",
      "label": "Enter Total Followers",
      "prepend-inner-icon": "mdi-account-group",
      "type": "number",
      "min": "0",
      "error-messages": _vm.twitterTotalFollowersErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.twitter.totalFollowers.$touch()
      },
      "blur": function($event) {
        return _vm.$v.twitter.totalFollowers.$touch()
      }
    },
    model: {
      value: (_vm.twitter.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.twitter, "totalFollowers", $$v)
      },
      expression: "twitter.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-inner-icon": "email",
      "error-messages": _vm.emailErrors,
      "label": "Email",
      "placeholder": "Email",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "0px 12px 30px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Generate a strong password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-space-between"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "500",
      "padding-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.generatedPass))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyPass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.generatePass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-reload")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.passwordErrors,
      "id": "regPassword",
      "prepend-inner-icon": "lock",
      "name": "regPassword",
      "label": "Password",
      "type": "text",
      "outlined": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": !_vm.email,
      "block": ""
    },
    on: {
      "click": _vm.registerInf
    }
  }, [_vm._v("Register")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.infUsers,
      "items-per-page": 5,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', [_vm._v(_vm._s(item.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [(item.igHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('v-icon', {
            attrs: {
              "size": "18",
              "color": "#E4405F"
            }
          }, [_vm._v("mdi-instagram")]), _vm._v("\n                  @" + _vm._s(item.igHandle) + "\n                ")], 1) : _vm._e()]), _vm._v(" "), _c('td', [(item.tiktokHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('img', {
            staticClass: "social-handle__logo",
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "alt": "TikTok"
            }
          }), _vm._v("\n                  @" + _vm._s(item.tiktokHandle) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [(item.youtubeHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('v-icon', {
            attrs: {
              "size": "18",
              "color": "#FF0000"
            }
          }, [_vm._v("mdi-youtube")]), _vm._v("\n                  @" + _vm._s(item.youtubeHandle) + "\n                ")], 1) : _vm._e()]), _vm._v(" "), _c('td', [(item.xhsHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('img', {
            staticClass: "social-handle__logo",
            attrs: {
              "src": "/static/img/xhs-black.png",
              "alt": "Xiaohongshu"
            }
          }), _vm._v("\n                  @" + _vm._s(item.xhsHandle) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [(item.fbHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('v-icon', {
            attrs: {
              "size": "18",
              "color": "#1877F2"
            }
          }, [_vm._v("mdi-facebook")]), _vm._v("\n                  @" + _vm._s(item.fbHandle) + "\n                ")], 1) : _vm._e()]), _vm._v(" "), _c('td', [(item.linkedinHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('v-icon', {
            attrs: {
              "size": "18",
              "color": "#0A66C2"
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v("\n                  @" + _vm._s(item.linkedinHandle) + "\n                ")], 1) : _vm._e()]), _vm._v(" "), _c('td', [(item.twitterHandle) ? _c('span', {
            staticClass: "social-handle"
          }, [_c('img', {
            staticClass: "social-handle__logo",
            attrs: {
              "src": "/static/img/x-logo.svg",
              "alt": "X"
            }
          }), _vm._v("\n                  @" + _vm._s(item.twitterHandle) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.createdAt)))])])
        }), 0)]
      }
    }])
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n        Copied to Clipboard!\n        "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n          Close\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-pass"
    },
    domProps: {
      "value": _vm.generatedPass
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "persistent": "",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-2"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Create new Campaign")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', [(_vm.needCompany) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.company_options,
      "item-text": "name",
      "item-value": "id",
      "name": "state",
      "label": "Company",
      "filled": ""
    },
    model: {
      value: (_vm.campaign.companyID),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "companyID", $$v)
      },
      expression: "campaign.companyID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.needClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.client_options,
      "label": "Client",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        return _vm.setClientData(_vm.campaign.clientID)
      }
    },
    model: {
      value: (_vm.campaign.clientID),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "clientID", $$v)
      },
      expression: "campaign.clientID"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-2"
  }, [_vm._v("\n                  Assigned Team\n                ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-subheader', [_vm._v("\n                        Dedicated Persons\n                      ")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "active-class": "primary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedDedicatedPersons),
      callback: function($$v) {
        _vm.selectedDedicatedPersons = $$v
      },
      expression: "selectedDedicatedPersons"
    }
  }, _vm._l((_vm.dedicatedPersons), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_c('v-avatar', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }]
  }, [_vm._v("\n                       Supporting Persons\n                      ")]), _vm._v(" "), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }],
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedSupportingPersons),
      callback: function($$v) {
        _vm.selectedSupportingPersons = $$v
      },
      expression: "selectedSupportingPersons"
    }
  }, _vm._l((_vm.supportingPersons), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_c('v-avatar', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                            " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                          ")], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.campaignModelSections), function(section) {
    return _c('v-layout', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "width": "100%"
      }
    }, [_c('v-card-title', {
      staticClass: "title grey lighten-2"
    }, [_vm._v("\n                  " + _vm._s(section.title) + "\n                  "), _c('v-spacer'), _vm._v(" "), (section.type == _vm.campaignModelSectionType.VIDEO_BRIEF) ? _c('v-switch', {
      attrs: {
        "label": "Enable Video Brief"
      },
      model: {
        value: (_vm.showVideoBrief),
        callback: function($$v) {
          _vm.showVideoBrief = $$v
        },
        expression: "showVideoBrief"
      }
    }) : _vm._e(), _vm._v(" "), (section.type == _vm.campaignModelSectionType.EVENT_BRIEF) ? _c('v-switch', {
      attrs: {
        "label": "Enable Event Brief"
      },
      model: {
        value: (_vm.showEventBrief),
        callback: function($$v) {
          _vm.showEventBrief = $$v
        },
        expression: "showEventBrief"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('v-container', [(section.type === _vm.campaignModelSectionType.BUDGET_ALLOCATION) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [(_vm.selectedClient != null) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "info",
        "elevation": "4"
      },
      on: {
        "click": function($event) {
          _vm.viewClientDialog = true
        }
      }
    }, [_vm._v("\n                            Client Details\n                             "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                              mdi-account-details\n                            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md6": "",
          "xl4": ""
        }
      }, [(campaignField.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": _vm.IONumberItems,
          "item-text": "text",
          "item-value": "value",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'slider') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "hide-details": "",
          "placeholder": campaignField.placeholder,
          "solo": "",
          "type": "number"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }), _vm._v(" "), (_vm.selectedClient !== null) ? _c('div', {
        staticClass: "font-weight-light text-xs-right"
      }, [_vm._v(_vm._s(_vm.getUsage(_vm.campaign[campaignField.name], _vm.getMaxValueOf(campaignField.name))) + "% of Remaining amount")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'text') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'startDate') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.startCal),
          callback: function($$v) {
            _vm.startCal = $$v
          },
          expression: "startCal"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "type": "month"
        },
        on: {
          "input": function($event) {
            _vm.startCal = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'endDate') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        ref: "monthPicker",
        refInFor: true,
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.endCal),
          callback: function($$v) {
            _vm.endCal = $$v
          },
          expression: "endCal"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "type": "month"
        },
        on: {
          "input": function($event) {
            _vm.endCal = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'radio') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-radio-group', {
        attrs: {
          "row": ""
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }, [_c('v-radio', {
        attrs: {
          "label": "by engagement",
          "value": "engagement"
        }
      }), _vm._v(" "), _c('v-radio', {
        attrs: {
          "label": "by contents",
          "value": "content"
        }
      })], 1)], 1) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), (
      (section.type === _vm.campaignModelSectionType.CAMPAIGN_SUMMARY) ||
      (section.type === _vm.campaignModelSectionType.INFLUENCER_SELECTION) ||
      (section.type === _vm.campaignModelSectionType.VIDEO_BRIEF && _vm.showVideoBrief)) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md12": "",
          "xl4": ""
        }
      }, [(campaignField.type === 'text' && campaignField.name === 'vertical') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-autocomplete', {
        attrs: {
          "items": _vm.campaignVerticals,
          "item-text": "name",
          "item-value": "name",
          "hide-selected": "",
          "chips": "",
          "label": campaignField.placeholder,
          "multiple": "",
          "solo": "",
          "attach": ""
        },
        model: {
          value: (_vm.selectedCampaignVertical),
          callback: function($$v) {
            _vm.selectedCampaignVertical = $$v
          },
          expression: "selectedCampaignVertical"
        }
      })], 1) : (campaignField.type === 'text') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-textarea', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'combobox') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'targetAge') ? _c('v-combobox', {
        attrs: {
          "items": campaignField.items,
          "multiple": "",
          "solo": "",
          "chips": "",
          "placeholder": campaignField.placeholder
        },
        on: {
          "input": _vm.targetAgelimiter
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : (campaignField.name === 'targetLocation') ? _c('v-autocomplete', {
        attrs: {
          "search-input": _vm.newCountry,
          "items": _vm.countries,
          "item-text": "name",
          "item-value": "code",
          "hide-selected": "",
          "multiple": "",
          "solo": "",
          "chips": "",
          "label": "Country",
          "dense": ""
        },
        on: {
          "update:searchInput": function($event) {
            _vm.newCountry = $event
          },
          "update:search-input": function($event) {
            _vm.newCountry = $event
          }
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                  $delete\n                                ")])], 1) : _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                  " + _vm._s(item) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                  $delete\n                                ")])], 1)]
          }
        }], null, true),
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _c('v-combobox', {
        attrs: {
          "items": campaignField.items,
          "multiple": "",
          "solo": "",
          "chips": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'name') ? _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        on: {
          "change": function($event) {
            return _vm.changeCampaignName(_vm.campaign[campaignField.name])
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'autocomplete') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-autocomplete', {
        attrs: {
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "name",
          "hide-selected": "",
          "chips": "",
          "label": campaignField.placeholder,
          "multiple": "",
          "solo": "",
          "attach": ""
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                  " + _vm._s(item.text) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                  $delete\n                                ")])], 1) : _vm._e()]
          }
        }], null, true),
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'chips') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('draggable', {
        staticClass: "row no-gutters flex-wrap flex-row fill-height",
        staticStyle: {
          "width": "100%"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }, _vm._l((_vm.campaign[campaignField.name]), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "value": item,
            "filter": ""
          }
        }, [_vm._v("\n                              " + _vm._s(item.text) + "\n                            ")])
      }), 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', {
        staticClass: "canvas-image-input"
      }, [_c('input', {
        ref: "files",
        refInFor: true,
        attrs: {
          "type": "file"
        },
        on: {
          "change": function($event) {
            return _vm.processImage($event, 'canvas', null, null, 'canvas')
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'video_live_date') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.videoDateDialog),
          callback: function($$v) {
            _vm.videoDateDialog = $$v
          },
          expression: "videoDateDialog"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        on: {
          "input": function($event) {
            _vm.videoDateDialog = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.CONTENT_ANGLE) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'select') ? _c('div', {
        staticClass: "action-required"
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('h4', [_vm._v("\n                              " + _vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1) + "\n                              "), (_vm.campaign[campaignField.name].length > 1) ? _c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteOption(campaignField.name, optionIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash ims-text-error"
        })]) : _vm._e()], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('v-text-field', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('v-textarea', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionField.type == 'multiple_options') ? _c('div', [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(secondOption, secondOptionIndex) {
            return _c('div', {
              key: secondOptionIndex
            }, [_c('h4', [_vm._v("\n                                          Required Action " + _vm._s(secondOptionIndex + 1) + "\n                                          "), (_vm.campaign[campaignField.name][optionIndex][optionField.name].length > 1) ? _c('v-btn', {
              attrs: {
                "text": "",
                "icon": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.deleteSecondOption(campaignField.name, optionIndex, optionField.name, secondOptionIndex)
                }
              }
            }, [_c('i', {
              staticClass: "fa fa-trash ims-text-error"
            })]) : _vm._e()], 1), _vm._v(" "), _vm._l((optionField.template), function(optionField2, optionIndex2) {
              return _c('v-layout', {
                key: optionIndex2,
                attrs: {
                  "wrap": ""
                }
              }, _vm._l((optionField2), function(format, i) {
                return _c('v-flex', {
                  key: i,
                  attrs: {
                    "xs6": ""
                  }
                }, [(format.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-text-field', {
                  attrs: {
                    "solo": "",
                    "placeholder": format.placeholder
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type == 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-textarea', {
                  attrs: {
                    "solo": "",
                    "placeholder": format.placeholder
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type === 'combobox') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-combobox', {
                  attrs: {
                    "items": format.items,
                    "multiple": "",
                    "solo": "",
                    "chips": "",
                    "placeholder": format.placeholder,
                    "append-icon": ""
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('div', {
                  staticClass: "image-input-container",
                  attrs: {
                    "id": 'optionImages_' + optionIndex + '_' + secondOptionIndex,
                    "data-index": optionIndex
                  }
                }, [_c('div', {
                  staticClass: "input-group pb-2",
                  attrs: {
                    "id": 'input_group_0_' + optionIndex + '_' + secondOptionIndex
                  }
                }, [_c('label', {
                  staticClass: "pr-2"
                }, [_c('input', {
                  attrs: {
                    "type": "radio",
                    "id": 'radio_image_' + optionIndex + '_' + secondOptionIndex,
                    "name": 'type_' + optionIndex + '_' + secondOptionIndex,
                    "value": "image",
                    "checked": "true"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'image')
                    }
                  }
                }), _vm._v(" Image\n                                                  ")]), _vm._v(" "), _c('label', [_c('input', {
                  attrs: {
                    "type": "radio",
                    "id": 'radio_link_' + optionIndex + '_' + secondOptionIndex,
                    "name": 'type_' + optionIndex + '_' + secondOptionIndex,
                    "value": "link"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'link')
                    }
                  }
                }), _vm._v(" Video Link\n                                                  ")]), _vm._v(" "), _c('div', [_c('input', {
                  staticClass: "custom-input",
                  staticStyle: {
                    "display": "none"
                  },
                  attrs: {
                    "type": "text",
                    "id": 'video_link_0_' + optionIndex + '_' + secondOptionIndex
                  },
                  on: {
                    "keyup": function($event) {
                      return _vm.changeVideoLink('angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                })]), _vm._v(" "), _c('div', {
                  staticClass: "image-input",
                  attrs: {
                    "id": 'img_upload_0_' + optionIndex + '_' + secondOptionIndex
                  }
                }, [_c('input', {
                  ref: "files",
                  refInFor: true,
                  attrs: {
                    "type": "file"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.processImage($event, 'angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                })])]), _vm._v(" "), _c('button', {
                  staticClass: "btn btn-link btn-link-danger btn-remove-input",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      return _vm.removeImage(optionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                }, [_vm._v("Remove")])]), _vm._v(" "), _c('button', {
                  staticClass: "btn btn-default btn-sm btn-add-more-image",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.addMoreImage(optionIndex, secondOptionIndex)
                    }
                  }
                }, [_vm._v("+ Add more image")])]) : _vm._e()])
              }), 1)
            })], 2)
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "default",
            attrs: {
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSecondOption(campaignField.name, optionIndex, optionField.name)
              }
            }
          }, [_vm._v("+ Add Required Action")])], 2) : _vm._e()])
        }), 1)], 1)], 1)
      }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('v-btn', {
        staticClass: "secondary",
        attrs: {
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addOption(campaignField.name)
          }
        }
      }, [_vm._v("Add new Concept")])], 1)], 2) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.EVENT_BRIEF && _vm.showEventBrief) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-textarea', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign.eventBrief[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign.eventBrief, campaignField.name, $$v)
          },
          expression: "campaign.eventBrief[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(campaignField.label) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.campaign.eventBrief[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": "",
              "md3": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), (_vm.campaign.eventBrief[campaignField.name].length > 1) ? _c('v-icon', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (optionField.name === 'attendeeName'),
              expression: "optionField.name === 'attendeeName'"
            }],
            attrs: {
              "text": "",
              "icon": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteAttendee(campaignField.name, optionIndex)
              }
            }
          }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign.eventBrief[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign.eventBrief[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign.eventBrief[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e()])
        }), 1)], 1)], 1)
      }), _vm._v(" "), _c('div', [_c('v-btn', {
        staticClass: "secondary",
        attrs: {
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addAttendee(campaignField.name)
          }
        }
      }, [_vm._v("Add an Attendee")])], 1)], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'template') ? _c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(campaignField.label) + "\n                          ")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, _vm._l((campaignField.template), function(templateField, i) {
        return _c('v-flex', {
          key: i,
          attrs: {
            "xs12": "",
            "md4": ""
          }
        }, [(templateField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "solo": "",
            "placeholder": templateField.placeholder
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'radioButton') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-checkbox', {
          attrs: {
            "label": _vm.campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes' : 'No'
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'date' && templateField.name === 'eventDate') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "solo": ""
                },
                model: {
                  value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
                  callback: function($$v) {
                    _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
                  },
                  expression: "campaign.eventBrief[campaignField.name][templateField.name]"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (_vm.eventDateDialog),
            callback: function($$v) {
              _vm.eventDateDialog = $$v
            },
            expression: "eventDateDialog"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          on: {
            "input": function($event) {
              _vm.eventDateDialog = false
            }
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-textarea', {
          attrs: {
            "solo": "",
            "placeholder": templateField.placeholder
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e()])
      }), 1)], 1)], 1) : _vm._e()])
    }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCampaign.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n            Save Changes\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.submitting,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.submitting = $event
      }
    }
  })], 1), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [(_vm.type === 'IMS') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Static"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igStatic ? _vm.data.igStatic : '-')))])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Carousel"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igCarousel ? _vm.data.igCarousel : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Story"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igStory ? _vm.data.igStory : '-')))])]), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Post"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igPost ? _vm.data.igPost : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      IG Reel"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igReel ? _vm.data.igReel : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'IMS') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      Blog"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.blog ? _vm.data.blog : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "8",
      "lg": "8"
    }
  }, [_vm._v("\n      Event Appearance "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.eventAppearance ? _vm.data.eventAppearance : '-')))])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_vm._v("\n      Tiktok"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.tiktok ? _vm.data.tiktok : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      Loading Fee"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.loadingFee ? _vm.data.loadingFee : '-')))])])], 1), _vm._v(" "), _c('v-row'), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      IG Remarks"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.igRemarks ? _vm.data.igRemarks : '-')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'rateCard') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      Tiktok Remarks"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s((_vm.data.tiktokRemarks ? _vm.data.tiktokRemarks : '-')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'IMS') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n      Remark"), _c('br'), _vm._v(" "), (_vm.data.remark) ? _c('strong', [_vm._v(_vm._s((_vm.data.remark ? _vm.data.remark : '-')))]) : _vm._e(), _vm._v(" "), (_vm.data.remarks) ? _c('strong', [_vm._v(_vm._s((_vm.data.remarks ? _vm.data.remarks : '-')))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.data.pricingDecks && _vm.data.pricingDecks.length > 0) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('label', [_vm._v("Pricing Decks")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.data.pricingDecks
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [(_vm.message.show) ? _c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "green darken-3",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e()], 1), _vm._v(" "), (_vm.pwdWarning) ? _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "#ffdce0",
      "type": "error",
      "icon": "warning"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#86181d"
    }
  }, [_vm._v("\n          The password you provided is weak and can be easily guessed. To increase your security, please\n          "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("update your password")]), _vm._v("as soon as possible.\n        ")], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('kobeOverview')) ? _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('kobe-overview', {
    attrs: {
      "userRole": _vm.currentUserRole
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('servicesHealth')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Services Health")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.getServicesHealthData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "subtitle-1 text-xs-right"
  }, [_vm._v("Latest Updates : " + _vm._s(_vm.currentTime))]), _vm._v(" "), _c('services-health-list', {
    attrs: {
      "serviceList": _vm.healthCheckData
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('xero')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Xero Dashboard")])], 1), _vm._v(" "), _c('v-card-text', [_c('connect-xero')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('influencerTasks')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('influencer-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('csTasks')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('content-strategist-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('saleTasks')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('sale-person-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('clientTasks')) ? _c('v-flex', {
    attrs: {
      "md12": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('client-tasks')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('postsSummary')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('posts-summary')], 1) : _vm._e(), _vm._v(" "), (_vm.showOnDashboard('campaignSummary')) ? _c('v-flex', {
    attrs: {
      "md4": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('campaign-summary')], 1) : _vm._e()], 1), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-2",
    staticStyle: {
      "padding": "20%"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('influencer-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Reel Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "reel-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15 report-summary-table",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "item-key": "key",
      "items-per-page": -1,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v("@" + _vm._s(item.profileHandle || item.name))])], 1)]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                        View\n                      ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n                  ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n                  ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n                  ")]
      }
    }, {
      key: "item.interactions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.interactions === 0 ? '-' : item.interactions)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.views === 0 ? '-' : item.views) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n                  ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.plays === 0 ? '-' : _vm.showPlayTime(item.plays)) + "\n                  ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.new_engagement_rate === 0 ? '0' : item.new_engagement_rate) + " %\n                    ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.new_engagement_rate_view === 0 ? '0' : item.new_engagement_rate_view) + " %\n                    ")])]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.interaction_rate_plays === 0 ? '0' : item.interaction_rate_plays) + " %\n                    ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.engagement_rate_reach === 0 ? '0' : item.engagement_rate_reach) + " %\n                    ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n                      " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n                    ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.median_engagement_rate === null ? '-' : item.median_engagement_rate + '%') + "\n                  ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null ? '-' : item.avg_likes)) + "\n                  ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null ? '-' : item.avg_comments)) + "\n                  ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n                  ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null ? '-' : item.avg_reels_plays)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'url') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'comments') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'saved') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalSaved === 0 ? '-' : _vm.totalSaved)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews == 0 ? '-' : _vm.totalViews)))] : (header.value === 'plays') ? [_vm._v(_vm._s(_vm.showPlayTime(_vm.totalPlayTime)))] : (header.value === 'watches') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalWatches == 0 ? '-' : _vm.totalWatches)))] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm.totalEngagementRate) + "%")] : (header.value === 'new_engagement_rate_view') ? [_vm._v(_vm._s(_vm.totalEngagementRateView) + "%")] : (header.value === 'interaction_rate_plays') ? [_vm._v(_vm._s(_vm.totalInteractionRatePlays) + "%")] : (header.value === 'engagement_rate_reach') ? [_vm._v(_vm._s(_vm.totalEngagementRateReach) + "%")] : (header.value === 'engagement_rate_sd') ? [_vm._v(" - ")] : (header.value === 'median_engagement_rate') ? [_vm._v(" - ")] : (header.value === 'avg_likes') ? [_vm._v(" - ")] : (header.value === 'avg_comments') ? [_vm._v(" - ")] : (header.value === 'avg_views') ? [_vm._v(" - ")] : (header.value === 'avg_reels_plays') ? [_vm._v(" - ")] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Reel Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatePostAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', {
    staticClass: "login-background"
  }, [_c('v-container', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12 login-card"
  }, [_c('v-toolbar', {
    staticClass: "brand-login-toolbar",
    attrs: {
      "height": "172",
      "tabs": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "login-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Kobe"
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    staticClass: "login-tabs",
    attrs: {
      "slot": "extension",
      "centered": "",
      "slider-color": "#3F3FFF",
      "grow": ""
    },
    slot: "extension",
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    staticClass: "login-tab",
    attrs: {
      "href": "#login-tab"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-tab', {
    staticClass: "login-tab",
    attrs: {
      "href": "#signup-tab"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab()
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "login-card-text"
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    staticClass: "text-center",
    attrs: {
      "value": "login-tab"
    }
  }, [_c('v-row', {
    staticClass: "pt-5",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "sm": "12",
      "lg": "8"
    }
  }, [_c('v-btn', {
    staticClass: "white--text ma-1 mb-2",
    attrs: {
      "width": "260px",
      "color": "secondary"
    },
    on: {
      "click": _vm.instagramLogin
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("Login with instagram\n                      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "g-login-container"
  }, [_c('div', {
    ref: "googleLoginBtn"
  })])], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "8"
    }
  }, [_c('v-form', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.emailErrors,
      "prepend-icon": "person",
      "name": "email",
      "label": "Email",
      "type": "text",
      "width": "260px"
    },
    on: {
      "blur": function($event) {
        return _vm.$v.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.passwordErrors,
      "id": "password",
      "prepend-icon": "lock",
      "name": "password",
      "label": "Password",
      "type": "password",
      "width": "260px"
    },
    on: {
      "input": function($event) {
        return _vm.$v.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkCreds()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "secondary",
      "rounded": "",
      "width": "260px"
    },
    on: {
      "click": function($event) {
        return _vm.checkCreds()
      }
    }
  }, [_vm._v("Login ")])], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "to": "/forgot-password",
      "color": "secondary"
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showRegisterTab()
      }
    }
  }, [_vm._v("Create New Account")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n                    By logging in, you confirm that you have read the\n                    "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" , that you understand them and that you agree to be bound by them.\n                  ")])], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "value": "signup-tab"
    }
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('v-btn', {
    staticClass: "white--text ma-1 mb-2",
    attrs: {
      "width": "280px",
      "color": "secondary"
    },
    on: {
      "click": _vm.doFacebookLogin
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "medium": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v("Continue with Facebook\n                    ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text ma-1 mb-2",
    attrs: {
      "width": "280px",
      "color": "secondary"
    },
    on: {
      "click": _vm.instagramLogin
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("Signup with instagram\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "g-login-container"
  }, [_c('div', {
    ref: "googleSignUpBtn"
  })]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center msg-box"
  }, [_c('p', [_vm._v("\n                      If you require further technical assistance, please refer to this platform "), _c('a', {
    attrs: {
      "href": "https://drive.google.com/file/d/1aBHRO61bi3Q0XRvDYK-b8VnImvqCBoqz/view",
      "target": "_blank"
    }
  }, [_vm._v("guide")]), _vm._v(" or reach out to us at "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mail.google.com/mail/?view=cm&fs=1&to=creator@getkobe.com",
      "target": "_blank"
    }
  }, [_vm._v("creator@getkobe.com")])])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.showUpdateDialog),
      callback: function($$v) {
        _vm.showUpdateDialog = $$v
      },
      expression: "showUpdateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n            New Updates to Kobe's IMS\n          ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_c('br'), _vm._v("\n            Kobe's tech team is always on the ball to keep our platform safe, secure, and user-friendly. Unfortunately, sometimes we may need to make changes too.\n            Unbeknownst to many, in January 2018, Facebook publicly announced its plans to shut down the Instagram Legacy API platform through a sequenced approach. What this means for us in human language is that we will need to change your login methods very soon. "), _c('br'), _vm._v("\n            And since it's a mandatory change, we will be making a compulsory switch from Instagram Login to Facebook Login method starting from 29th June.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Do take note of the following:\n            "), _c('ol', [_c('li', [_vm._v("If you are using Email and Password to login to app.getkobe.com, no actions are required. (mainly for our clients)")]), _vm._v(" "), _c('li', [_vm._v("If you are using Instagram to login to app.getkobe.com, you will need to re-login with the new Facebook login instead. (Your account will be automatically associated if your Facebook and Instagram account is linked) please ensure your profile switched to either a creator/business profile.")])])]), _vm._v(" "), _c('p', [_vm._v("\n            For some reasons, if you're stuck, reply to this email and we will help you with the setup! We're here to help make this switch as seamless as possible.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Feel free to drop us a message if you have any problems/questions and we hope to see you in our campaign inboxes soon!\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            Love, "), _c('br'), _vm._v("\n            Kobe Fam.\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpdateDialog = false
      }
    }
  }, [_vm._v("\n              Close\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "dark": "",
      "color": "#1A1A1A"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "white--text": "",
      "text-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Singapore")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "tel:+6562555662"
    }
  }, [_vm._v("6255 5662")]), _vm._v(" /\n          "), _c('a', {
    attrs: {
      "href": "mailto:creator@getkobe.com"
    }
  }, [_vm._v("creator@getkobe.com")]), _vm._v(" "), _c('br'), _vm._v("51 Goldhill Plaza #14-01 Singapore 308900\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('br'), _vm._v("Website\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n          "), _c('br'), _vm._v("\n          All Rights Reserved © 2016-" + _vm._s(_vm.year) + " Kobe Global Technologies Pte Ltd\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center mb-0 pt-2"
  }, [_vm._v("\n          Patent: "), _c('a', {
    attrs: {
      "href": "https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1",
      "target": "_blank"
    }
  }, [_vm._v(" KOBE 11201807777W ℗ ")])])])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "#A3FF12",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "g_id_onload",
      "data-client_id": _vm.gSigninConfig.CLIENT_ID,
      "data-login_uri": _vm.currentDomain,
      "data-auto_prompt": "false"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 rate-card-page"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "rate-card-page__toolbar",
    attrs: {
      "flat": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "rate-card-page__eyebrow"
  }, [_vm._v("Creator directory")]), _vm._v(" "), _c('h1', {
    staticClass: "rate-card-page__title"
  }, [_vm._v("Rate Cards")]), _vm._v(" "), _c('p', {
    staticClass: "rate-card-page__subtitle"
  }, [_vm._v("Review creator pricing, platform details, and media kits in one place.")])]), _vm._v(" "), _c('div', {
    staticClass: "rate-card-page__actions"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cached")]), _vm._v(" Refresh\n          ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.copyLink()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-content-copy")]), _vm._v(" Copy form link\n          ")], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.rateCardLink
    }
  }), _vm._v(" "), (_vm.rateCardCopied) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "elevation": "0",
      "text": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Copied\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.rateCardFileInput.click()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-home-import-outline")]), _vm._v("Import\n          ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "outlined": ""
    },
    on: {
      "click": _vm.downloadSampleUpload
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v("Template\n          ")], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-file-excel-outline")]), _vm._v(" Export\n          ")], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('rate-card-data-table', {
    attrs: {
      "reload": _vm.isRefresh,
      "isDownload": _vm.isDownload
    }
  }), _vm._v(" "), _c('input', {
    ref: "rateCardFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "rateCardFileInput"
    },
    on: {
      "change": _vm.importFileUpload
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.importLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.importLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.campaign) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Change Campaign Status")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Current Status",
      "filled": "",
      "disabled": "",
      "value": _vm.displayStatus(_vm.campaign.status)
    }
  })], 1), _vm._v(" "), _c('v-icon', [_vm._v("mdi-arrow-right-thick")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_options,
      "item-text": "display",
      "item-value": "status",
      "menu-props": {
        maxHeight: '400'
      },
      "label": "New Status",
      "filled": "",
      "hint": "Select new Campaign Status",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.selectedStatus === _vm.campaign.status
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('update-campaign-quarter-modal', {
    attrs: {
      "value": _vm.campaignQuarterDialog,
      "campaignID": _vm.viewCampaignId,
      "multipleCampaignIds": _vm.multipleCampaignIds
    },
    on: {
      "updated": _vm.closeModal
    },
    model: {
      value: (_vm.campaignQuarterDialog),
      callback: function($$v) {
        _vm.campaignQuarterDialog = $$v
      },
      expression: "campaignQuarterDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.name,
      "width": "500",
      "height": "300"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "sub-title ma-0 pa-0"
  }, [_vm._v("\n        Average Summary\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Activating")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.activating) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Pairing")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.pairing) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Cocreating")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.cocreating) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Complete")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.complete) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Average Duration")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.duration) + " days")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "320px"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Billing Name as per Xero")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "prepend-icon": "groups",
      "items": _vm.clientGroups,
      "label": "Select Group",
      "hide-details": "",
      "item-text": "Name",
      "chips": "",
      "return-object": ""
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', [_c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-list-item-content', _vm._l((_vm.selectedClients), function(client, index) {
    return _c('v-list-item-subtitle', {
      key: index
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v(" " + _vm._s(client.name))], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": !_vm.selectedGroup
    },
    on: {
      "click": _vm.saveClientGroup
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "box-header"
  }, [(_vm.buttonShow('create', _vm.currentUserRole)) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("\n          Create new\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "pr-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.userRoleOptions,
      "label": "Role Filter",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "auto-select-first": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.filters.role),
      callback: function($$v) {
        _vm.$set(_vm.filters, "role", $$v)
      },
      expression: "filters.role"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalRows
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', [_vm._v(_vm._s(item.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roleDisplay(item.role)))]), _vm._v(" "), _c('td', [(_vm.buttonShow('delete', item.role)) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteUser(item)
              }
            }
          }, [_c('v-icon', _vm._g({
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('update', item.role)) ? _c('v-btn', {
            staticClass: "ims-action primary",
            attrs: {
              "small": "",
              "data-toggle": "modal",
              "data-target": _vm.editModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getUserDataToEdit(item.id)
              }
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-account-edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view', item.role)) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "small": "",
              "color": "info",
              "data-toggle": "modal",
              "data-target": _vm.viewModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getUserDataToView(item.id)
              }
            }
          }, [_c('v-icon', _vm._g({
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('confirmUser', item.role)) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "small": "",
              "color": "info",
              "data-toggle": "modal",
              "data-target": _vm.confirmUserModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getUserDataToEdit(item.id)
              }
            }
          }, [_c('v-icon', _vm._g({
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-check")])], 1) : _vm._e()], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('create-user-modal', {
    on: {
      "createUser": _vm.createUser
    },
    model: {
      value: (_vm.createUserModalDialog),
      callback: function($$v) {
        _vm.createUserModalDialog = $$v
      },
      expression: "createUserModalDialog"
    }
  }), _vm._v(" "), _c('edit-user-modal', {
    attrs: {
      "modalId": _vm.editModalId,
      "userData": _vm.editUserData
    },
    on: {
      "editUser": _vm.editUser
    }
  }), _vm._v(" "), _c('view-user-modal', {
    attrs: {
      "modalId": _vm.viewModalId,
      "userData": _vm.viewUserData
    }
  }), _vm._v(" "), _c('assign-user-to-client-modal', {
    attrs: {
      "modalId": _vm.assignUserToClientModalId,
      "userData": _vm.viewUserData
    }
  }), _vm._v(" "), _c('confirm-user-modal', {
    attrs: {
      "modalId": _vm.confirmUserModalId,
      "userData": _vm.editUserData
    },
    on: {
      "editUser": _vm.editUser
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "persistent": "",
      "scrollable": "",
      "fullscreen": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Edit Content Storyboard\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "background": "#cccccc"
    }
  }, [_c('creator-concept-form', {
    attrs: {
      "mode": "edit",
      "editData": _vm.editData,
      "value": _vm.value
    },
    on: {
      "updatedContentScript": _vm.handleUpdatedContentScript
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('closed')
      }
    },
    model: {
      value: (_vm.viewerValue),
      callback: function($$v) {
        _vm.viewerValue = $$v
      },
      expression: "viewerValue"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), (_vm.media.publicID && _vm.media.isvideo) ? _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('custom-media-v2', {
    attrs: {
      "media": _vm.campaignHelper.customPostMediaConfig(_vm.media, {
        videoDownload: true,
        overlay: _vm.isCutOff
      })
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.media.publicID && !_vm.media.isvideo) ? _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('custom-media-v2', {
    attrs: {
      "media": _vm.campaignHelper.customPostMediaConfig(_vm.media, {
        overlay: _vm.isCutOff
      })
    }
  })], 1) : _c('v-card-text', {
    staticClass: "text-center"
  }, [(!_vm.videoPlayer) ? _c('v-img', {
    attrs: {
      "src": _vm.media
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videoPlayer) ? _c('video', {
    attrs: {
      "width": "300",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.media,
      "type": "video/mp4"
    }
  }), _vm._v("\n        Your browser does not support HTML5 video.\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.media.url || _vm.media,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2 pa-0",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', {
          ref: "sortableTbody"
        }, _vm._l((_vm.localItems), function(item, index) {
          return _c('tr', {
            key: item.key,
            staticStyle: {
              "border-bottom": "1px solid #ededed"
            },
            attrs: {
              "data-id": item.key
            }
          }, [(_vm.isSort) ? _c('td', {
            staticClass: "sort-handle",
            staticStyle: {
              "width": "20px",
              "cursor": "grab"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-arrow-all")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "50px",
              "text-align": "right"
            }
          }, [_c('v-checkbox', {
            staticClass: "mt-1 pb-2 d-inline-block",
            attrs: {
              "label": "",
              "true-value": true,
              "false-value": false,
              "color": "primary",
              "hide-details": ""
            },
            model: {
              value: (_vm.localItems[index].value),
              callback: function($$v) {
                _vm.$set(_vm.localItems[index], "value", $$v)
              },
              expression: "localItems[index].value"
            }
          })], 1)])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "600px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', [_vm._v("Attached Media")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body payout-screenshots-body"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.hasPosts) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v("Posts")]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.posts), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex,
      staticClass: "mb-5"
    }, [_c('v-row', {
      attrs: {
        "justify": "start",
        "align": "left"
      }
    }, [_vm._l((allPost.images), function(img, imgIndex) {
      return _c('v-col', {
        key: imgIndex,
        attrs: {
          "md": "4",
          "xs": "12"
        }
      }, [_c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
        attrs: {
          "width": "180px",
          "height": "200px",
          "src": img.url,
          "controls": ""
        }
      }, [_vm._v("             \n                      Your browser does not support the video tag.\n                  ")]) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url)
          }
        }
      })], 1)], 1)], 1)
    }), _vm._v(" "), (allPost.instagramPostURL !== '' || allPost.images.length > 0) ? _c('v-col', {
      staticClass: "pt-0",
      attrs: {
        "md": "12",
        "xs": "12"
      }
    }, [_c('a', {
      attrs: {
        "href": allPost.instagramPostURL,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "mt-2",
      attrs: {
        "small": "",
        "color": "secondary"
      }
    }, [_c('v-icon', {
      attrs: {
        "float-left": ""
      }
    }, [_vm._v("remove_red_eye")]), _vm._v(" Open URL")], 1)], 1)]) : _vm._e()], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasStories) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v("IG Stories")]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.stories), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex,
      staticClass: "mb-5"
    }, [_c('v-row', {
      attrs: {
        "justify": "left",
        "align": "left"
      }
    }, [(allPost.label) ? _c('v-col', {
      staticClass: "mb-0 pb-0",
      attrs: {
        "md": "12",
        "xs": "12"
      }
    }, [_c('div', {
      staticClass: "subtitle-1"
    }, [_vm._v(_vm._s(allPost.label))])]) : _vm._e(), _vm._v(" "), _vm._l((allPost.images), function(img, imgIndex) {
      return _c('v-col', {
        key: imgIndex,
        staticClass: "pt-1",
        attrs: {
          "md": "4",
          "xs": "12"
        }
      }, [_c('v-card', {
        attrs: {
          "text": "",
          "tile": ""
        }
      }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
        attrs: {
          "width": "180px",
          "height": "200px",
          "src": img.url,
          "controls": ""
        }
      }, [_vm._v("             \n                      Your browser does not support the video tag.\n                  ")]) : _c('v-img', {
        staticClass: "grey lighten-2 mx-auto",
        class: ("elevation-" + (_vm.hover ? 12 : 2)),
        attrs: {
          "src": img.url,
          "lazy-src": img.url,
          "aspect-ratio": "1"
        },
        on: {
          "click": function($event) {
            return _vm.viewMedia(img.url)
          }
        }
      })], 1)], 1)], 1)
    })], 2)], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasDeliverablePosts) ? _c('div', {
    staticClass: "pb-5"
  }, [_c('div', {
    staticClass: "h3 mt-2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('v-divider', {
    staticClass: "ma-0 mb-4"
  }), _vm._v(" "), _vm._l((_vm.imagesToView.deliverablePosts), function(allPost, firstIndex) {
    return _c('div', {
      key: firstIndex
    }, [(_vm.filterEmptyPosts(allPost.posts).length > 0) ? _c('div', [_c('div', {
      staticClass: "subtitle-1 font-weight-bold"
    }, [_vm._v(_vm._s(_vm.getLongPostTitle(allPost.type)))]), _vm._v(" "), _vm._l((_vm.filterEmptyPosts(allPost.posts)), function(post, pIndex) {
      return _c('v-row', {
        key: pIndex,
        attrs: {
          "justify": "left",
          "align": "left"
        }
      }, [(post.label && _vm.getPostType(allPost.type) === 'label') ? _c('v-col', {
        staticClass: "pt-5 pb-0",
        attrs: {
          "md": "12",
          "xs": "12"
        }
      }, [(_vm.getPostType(allPost.type) === 'label') ? _c('div', {
        staticClass: "subtitle-2"
      }, [_vm._v(_vm._s(post.label))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((post.images), function(img, imgIndex) {
        return _c('v-col', {
          key: imgIndex,
          attrs: {
            "md": "4",
            "xs": "12"
          }
        }, [_c('v-card', {
          attrs: {
            "text": "",
            "tile": ""
          }
        }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
          attrs: {
            "width": "180px",
            "height": "200px",
            "src": img.url,
            "controls": ""
          }
        }, [_vm._v("             \n                        Your browser does not support the video tag.\n                    ")]) : _c('v-img', {
          staticClass: "grey lighten-2 mx-auto",
          class: ("elevation-" + (_vm.hover ? 12 : 2)),
          attrs: {
            "src": img.url,
            "lazy-src": img.url,
            "aspect-ratio": "1"
          },
          on: {
            "click": function($event) {
              return _vm.viewMedia(img.url)
            }
          }
        })], 1)], 1)], 1)
      }), _vm._v(" "), (post.label && _vm.getPostType(allPost.type) === 'url') ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "md": "12",
          "xs": "12"
        }
      }, [_c('a', {
        attrs: {
          "href": post.label,
          "target": "_blank"
        }
      }, [_c('v-btn', {
        staticClass: "mt-2",
        attrs: {
          "small": "",
          "color": "secondary"
        }
      }, [_c('v-icon', {
        attrs: {
          "float-left": ""
        }
      }, [_vm._v("remove_red_eye")]), _vm._v(" Open URL")], 1)], 1)]) : _vm._e()], 2)
    }), _vm._v(" "), _c('v-divider', {
      staticClass: "mb-4"
    })], 2) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.imagesToView.images && _vm.imagesToView.images.length > 0) ? _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, _vm._l((_vm.imagesToView.images), function(img) {
    return _c('v-col', {
      key: img.index,
      attrs: {
        "md": "4",
        "xs": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-hover', [(_vm.getMediaType(img.url) === 'video') ? _c('video', {
      attrs: {
        "width": "180px",
        "height": "200px",
        "src": img.url,
        "controls": ""
      }
    }, [_vm._v("             \n                  Your browser does not support the video tag.\n              ")]) : _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      class: ("elevation-" + (_vm.hover ? 12 : 2)),
      attrs: {
        "src": img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      },
      on: {
        "click": function($event) {
          return _vm.viewMedia(img.url)
        }
      }
    })], 1)], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "700"
    },
    model: {
      value: (_vm.imageViewerDialog),
      callback: function($$v) {
        _vm.imageViewerDialog = $$v
      },
      expression: "imageViewerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.imageViewerDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.activeImage
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.activeImage,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.divClassName ? _vm.divClassName : ''
  }, [(_vm.isTikTok) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.tiktokHandle))]) : _vm._e(), _vm._v(" "), (_vm.isInstagram) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__instagram",
    attrs: {
      "color": "#E1306C",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.instagramHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebook) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__facebook",
    attrs: {
      "color": "#1877F2",
      "small": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(_vm.facebookHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isLinkedIn) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__linkedin",
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.linkedinHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isTwitter) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.twitterHandle))]) : _vm._e(), _vm._v(" "), (_vm.isYoutube) ? _c('span', [_c('v-icon', {
    staticClass: "social-handle-view__youtube",
    attrs: {
      "color": "#FF0000",
      "small": ""
    }
  }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.youtubeHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isXiaohongshu) ? _c('span', [_c('img', {
    staticStyle: {
      "border-radius": "15%"
    },
    attrs: {
      "src": "/static/img/xhs-black.png",
      "width": "15px"
    }
  }), _vm._v(" " + _vm._s(_vm.xiaohongshuFullName || _vm.xiaohongshuHandle))]) : _vm._e(), _vm._v(" "), (_vm.isOthers) ? _c('span', [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-help-circle")]), _vm._v(" " + _vm._s(_vm.otherHandle))], 1) : _vm._e(), _vm._v(" "), (!_vm.hasExplicitPlatform && _vm.otherHandle) ? _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "X"
    }
  }), _vm._v(" @" + _vm._s(_vm.otherHandle))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline white--text"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.total)))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-ongoing"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.campaigns,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group",
            "aria-label": "Basic example"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#view_pairing_brief_detailed_modal"
          },
          on: {
            "click": function($event) {
              _vm.getCampaignDataToView(row.item.id);
              _vm.getRateCardDataToView(row.item.id, _vm.influencerID);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), (_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.acceptInvite(row.item.pairingID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.rejectCampaign(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e(), _vm._v(" "), (!_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#view_post_modal"
          },
          on: {
            "click": function($event) {
              return _vm.getPostDataToView(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file"
        })]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "md"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('view-pairing-brief-detailed-modal', {
    attrs: {
      "modalId": 'view_pairing_brief_detailed_modal',
      "campaignData": _vm.viewCampaignData,
      "rateCardData": _vm.viewRateCardData
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "modalId": 'view_post_modal',
      "campaignData": _vm.viewPostCampaignData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('creator-concept-data-table')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticStyle: {
      "padding": "10px 30px 10px 30px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('draggable', {
    staticClass: "row align-center justify-center",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.media),
      callback: function($$v) {
        _vm.media = $$v
      },
      expression: "media"
    }
  }, _vm._l((_vm.media), function(img, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4",
        "md": "2",
        "lg": "2",
        "sm": "3"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(img.preview.thumbnail) ? _c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            },
            on: {
              "click": function($event) {
                return _vm.viewMedia(img)
              }
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1) : _c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": ""
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            staticStyle: {
              "max-height": "226px"
            },
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      }
    }, [_vm._v("\n            " + _vm._s(img.preview.name) + "." + _vm._s(img.preview.format) + " \n            "), _c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index, img)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "20px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "150px"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    staticStyle: {
      "height": "100%",
      "min-width": "100px"
    },
    attrs: {
      "outlined": "",
      "flat": "",
      "tile": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-auto",
    attrs: {
      "dark": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": _vm.accept,
      "multiple": _vm.multiple || false
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    on: {
      "click:outside": _vm.modalClickOutSide
    },
    model: {
      value: (_vm.imageDialog),
      callback: function($$v) {
        _vm.imageDialog = $$v
      },
      expression: "imageDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mediaType === 'image') ? _c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.previewMedia
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.mediaType === 'vdo') ? _c('video', {
    staticClass: "custom-preview-img",
    attrs: {
      "id": "postVdo",
      "controls": ""
    }
  }, [_vm._v("             \n            Your browser does not support the video tag.\n        ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-cached\n        ")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("\n              mdi-content-copy\n            ")]), _vm._v(" Copy Link\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.CO), function(co) {
    return _c('v-list-item', {
      key: co.id,
      on: {
        "click": function($event) {
          return _vm.copyLink(co.id)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(co.name))])], 1)
  }), 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.rateCardLink
    }
  }), _vm._v(" "), (_vm.rateCardCopied) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "elevation": "0",
      "text": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-check\n        ")]), _vm._v("Copied\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel\n      ")], 1)], 1)], 1), _vm._v(" "), _c('rate-card-data-table', {
    attrs: {
      "reload": _vm.isRefresh,
      "isDownload": _vm.isDownload
    }
  }), _vm._v(" "), _c('input', {
    ref: "rateCardFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "rateCardFileInput"
    },
    on: {
      "change": _vm.importFileUpload
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.importLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.importLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    staticClass: "white--text ma-1",
    attrs: {
      "rounded": "",
      "width": "260px",
      "color": "instagram"
    },
    on: {
      "click": _vm.connectInstagram
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("Connect with instagram\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [(item.handleEdit === false) ? _c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-left"
        }, [(item.handle) ? _c('social-handle', {
          attrs: {
            "isInstagram": item.value === 'instagram',
            "isTikTok": item.value === 'tiktok',
            "isYoutube": item.value === 'youtube',
            "isXiaohongshu": item.value === 'xiaohongshu',
            "isFacebook": item.value === 'facebook',
            "isLinkedIn": item.value === 'linkedin',
            "isTwitter": item.value === 'twitter',
            "instagramHandle": item.handle,
            "tiktokHandle": item.handle,
            "youtubeHandle": item.handle,
            "xiaohongshuHandle": item.handle,
            "facebookHandle": item.handle,
            "linkedinHandle": item.handle,
            "twitterHandle": item.handle,
            "divClassName": "float-left"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-icon', {
          staticClass: "cursor-pointer pl-2",
          attrs: {
            "color": "warning",
            "x-small": "",
            "disabled": item.connected
          },
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'handle', _vm.dataSourceName)
            }
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', {
          staticClass: "item-edit"
        }, [_c('td', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.handle),
            callback: function($$v) {
              _vm.$set(item, "handle", $$v)
            },
            expression: "item.handle"
          }
        }, _vm.on))], 1)])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', [(item.connected) ? _c('v-btn', {
          attrs: {
            "disabled": "",
            "color": "success",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-check")]), _vm._v(" "), _c('span', [_vm._v("Connected")])], 1) : _vm._e(), _vm._v(" "), (item.handle && !item.connected && !item.requested) ? _c('v-btn', {
          attrs: {
            "color": "success",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.connectAction(item, 'connect')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-check")]), _vm._v(" "), _c('span', [_vm._v("Connect")])], 1) : _vm._e(), _vm._v(" "), (item.connected) ? _c('v-btn', {
          attrs: {
            "color": "error",
            "small": "",
            "disabled": _vm.filteredItems.filter(function (f) { return f.connected; }).length === 1
          },
          on: {
            "click": function($event) {
              return _vm.connectAction(item, 'disconnect')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-remove")]), _vm._v(" Disconnect\n            ")], 1) : _vm._e(), _vm._v(" "), (item.handle && item.requested) ? _c('v-btn', {
          attrs: {
            "color": "success",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.connectAction(item, 'connect')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-check")]), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1) : _vm._e(), _vm._v(" "), (item.handle && item.requested) ? _c('v-btn', {
          attrs: {
            "color": "red",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.rejectPlatform(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-close")]), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('profit-summary-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.Questions), function(item, questionIndex) {
    return _c('v-row', {
      key: questionIndex
    }, [_c('v-col', {
      attrs: {
        "col": "12"
      }
    }, [_c('v-img', {
      staticClass: "user-avatar",
      attrs: {
        "src": _vm.questionUserProfile.avatar,
        "alt": "User Profile Image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user-display-name"
    }, [_vm._v(_vm._s(_vm.questionUserProfile.displayName))]), _vm._v(" "), _c('div', {
      staticClass: "post-question-datetime"
    }, [_vm._v(_vm._s(_vm.createdDate(item.createdAt)))]), _vm._v(" "), _c('div', {
      staticClass: "question"
    }, [_vm._v("\n              " + _vm._s(item.question) + "                          \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "answers-obj"
    }, _vm._l((item.answers), function(res, answerIndex) {
      return _c('v-row', {
        key: answerIndex
      }, [_c('v-col', {
        attrs: {
          "col": "12"
        }
      }, [_c('v-img', {
        staticClass: "user-avatar",
        attrs: {
          "src": res.profilePicture,
          "alt": "User Profile Image"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "user-display-name"
      }, [_vm._v(_vm._s(res.profileName))]), _vm._v(" "), _c('div', {
        staticClass: "post-question-datetime"
      }, [_vm._v(_vm._s(_vm.createdDate(res.createdAt)))]), _vm._v(" "), _c('div', {
        staticClass: "answers"
      }, [_vm._v(_vm._s(res.comment))])], 1)], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "reply-box noActive",
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "id": 'reply_question_' + questionIndex
      }
    }, [_c('form', [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-textarea', {
      staticStyle: {
        "margin-bottom": "0px !important"
      },
      attrs: {
        "counter": "",
        "outlined": "",
        "placeholder": "reply here..."
      },
      model: {
        value: (_vm.comment),
        callback: function($$v) {
          _vm.comment = $$v
        },
        expression: "comment"
      }
    })], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "text": "",
        "tile": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.submitClick(questionIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v("Submit\n                ")], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "text": "",
        "tile": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.cancelClick(questionIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-cancel")]), _vm._v("Cancel\n                ")], 1)], 1)]), _vm._v(" "), (item.userID !== _vm.activeUser.id || item.answers.length > 0) ? _c('div', {
      staticClass: "reply-btn",
      attrs: {
        "id": 'reply_question_btn_' + questionIndex
      }
    }, [_c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "text": "",
        "tile": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.replyClick(questionIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-message")]), _vm._v("Reply\n              ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('hr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (questionIndex < _vm.Questions.length - 1),
        expression: "questionIndex < Questions.length - 1"
      }],
      staticStyle: {
        "margin-left": "auto",
        "margin-right": "auto"
      },
      attrs: {
        "width": "98%"
      }
    })], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "googleDriveIcon"
    }
  }, [_c('svg', {
    attrs: {
      "width": "104px",
      "height": "104px",
      "viewBox": "0 0 104 104",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('clicked')
      }
    }
  }, [_c('defs', [_c('circle', {
    attrs: {
      "id": "path-1",
      "cx": "36",
      "cy": "36",
      "r": "36"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "x": "-37.5%",
      "y": "-29.2%",
      "width": "175.0%",
      "height": "175.0%",
      "filterUnits": "objectBoundingBox",
      "id": "filter-2"
    }
  }, [_c('feOffset', {
    attrs: {
      "dx": "0",
      "dy": "6",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter1"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8",
      "in": "shadowOffsetOuter1",
      "result": "shadowBlurOuter1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0.0117647059   0 0 0 0 0.0862745098   0 0 0 0 0.160784314  0 0 0 0.08 0",
      "type": "matrix",
      "in": "shadowBlurOuter1",
      "result": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dx": "0",
      "dy": "1",
      "in": "SourceAlpha",
      "result": "shadowOffsetOuter2"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "1",
      "in": "shadowOffsetOuter2",
      "result": "shadowBlurOuter2"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0.0117647059   0 0 0 0 0.0862745098   0 0 0 0 0.160784314  0 0 0 0.11 0",
      "type": "matrix",
      "in": "shadowBlurOuter2",
      "result": "shadowMatrixOuter2"
    }
  }), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter1"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "shadowMatrixOuter2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-460.000000, -125.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-4",
      "transform": "translate(412.000000, 129.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Drive-icon-",
      "transform": "translate(58.000000, 0.000000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#2196F3",
      "opacity": "0.100000001",
      "cx": "42",
      "cy": "42",
      "r": "42"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group",
      "transform": "translate(6.000000, 6.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Oval"
    }
  }, [_c('use', {
    attrs: {
      "fill": "black",
      "fill-opacity": "1",
      "filter": "url(#filter-2)",
      "xlink:href": "#path-1"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#FFFFFF",
      "fill-rule": "evenodd",
      "xlink:href": "#path-1"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "google-drive",
      "transform": "translate(20.000000, 22.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "fill": "#FFC107",
      "points": "21.4163769 20.1846154 32 20.1846154 21.4163769 0 10.8307692 0"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Path",
      "fill": "#2196F3",
      "points": "9.97143698 20.1846154 5.41538462 28.0615385 27.01526 28.0615385 32 20.1846154"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Path",
      "fill": "#4CAF50",
      "points": "10.6240847 0 0 18.7070242 5.3130384 28.0615385 15.7538462 9.67722198"
    }
  })])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("            \n              Change Avatar\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "card vue-avatar-cropper-demo text-center"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('img', {
    staticClass: "card-img avatar",
    attrs: {
      "src": _vm.currentAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-img-overlay"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "id": "pick-avatar"
    }
  }, [_vm._v("\n                    Select a new photo\n                  ")])])]), _vm._v(" "), _c('avatar-cropper', {
    attrs: {
      "trigger": "#pick-avatar",
      "upload-form-name": "avatar",
      "upload-form-data": _vm.formData,
      "upload-headers": _vm.uploadHeaders,
      "upload-url": _vm.uploadUrl,
      "labels": _vm.labels
    },
    on: {
      "uploading": _vm.handleUploading,
      "uploaded": _vm.handleUploaded,
      "completed": _vm.handleCompleted,
      "error": _vm.handlerError
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "vld-parent"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    attrs: {
      "id": "campaign-report"
    }
  }, [(_vm.reportData.campaign) ? _c('div', [_c('div', [_c('div', {
    staticClass: "hero-container"
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/report/html-rpt-bg.jpg",
      "aspect-ratio": "1.7",
      "gradient": "to bottom right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, .7)"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "client"
  }, [_c('v-img', {
    staticClass: "client-logo",
    attrs: {
      "src": _vm.reportData.campaign.client.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "client-name"
  }, [_vm._v(_vm._s(_vm.reportData.campaign.client.name))]), _vm._v(" "), _c('div', {
    staticClass: "current-date"
  }, [_vm._v(_vm._s(_vm.formatedCurrentDate))])], 1), _vm._v(" "), _c('div', {
    staticClass: "campaign"
  }, [_vm._v("\n                      " + _vm._s(_vm.reportData.campaign.name) + "\n                      "), _c('div', {
    staticClass: "objective-div"
  }, [_c('div', {
    staticClass: "objectives-title"
  }, [_vm._v("\n                          Objectives\n                          "), _c('ul', {
    staticClass: "objective"
  }, _vm._l((_vm.reportData.campaign.objectives), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                                  " + _vm._s(item) + "\n                              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "deliverable-title"
  }, [_vm._v("\n                          Deliverables\n                          "), _c('ul', {
    staticClass: "deliverable"
  }, _vm._l((_vm.reportData.campaign.deliverables), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                                  " + _vm._s(item) + "\n                              ")])
  }), 0)])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#post"
    }
  }, [_c('div', {
    staticClass: "scroll"
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sideNavContents"
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "max-width": "180"
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "mini-variant": _vm.mini,
      "permanent": "",
      "right": "",
      "expand-on-hover": "",
      "dark": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      },
      "update:mini-variant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "color": "#212121",
      "dense": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": "",
      "href": "#campaignSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-check")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Campaign Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enablePostAnalysis && _vm.postsAnalysisData.length > 0),
      expression: "reportData.campaign.enablePostAnalysis && postsAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#postSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-image-multiple")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Post Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableReelAnalysis && _vm.reelAnalysisData.length > 0),
      expression: "reportData.campaign.enableReelAnalysis && reelAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#reelSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-movie-roll")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Reel Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storyAnalysisData.length > 0),
      expression: "storyAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#storySummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-movie-open")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Story Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableTikTokAnalysis && _vm.tikTokAnalysisData.length > 0),
      expression: "reportData.campaign.enableTikTokAnalysis && tikTokAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#tiktokSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/tik-tok-white.png",
      "aspect-ratio": "1"
    }
  })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("TikTok Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableYoutubeAnalysis && _vm.youtubeAnalysisData.length > 0),
      expression: "reportData.campaign.enableYoutubeAnalysis && youtubeAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#youtubeSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('i', {
    staticClass: "fab fa-youtube",
    staticStyle: {
      "font-size": "25px"
    }
  })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Youtube Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableFbAnalysis && _vm.fbAnalysisData.length > 0),
      expression: "reportData.campaign.enableFbAnalysis && fbAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#fbSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('i', {
    staticClass: "fab fa-facebook",
    staticStyle: {
      "font-size": "25px"
    }
  })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Facebook Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableLinkedInAnalysis && _vm.linkedInAnalysisData.length > 0),
      expression: "reportData.campaign.enableLinkedInAnalysis && linkedInAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#linkedInSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-linkedin")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("LinkedIn Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableTwitterAnalysis && _vm.twitterAnalysisData.length > 0),
      expression: "reportData.campaign.enableTwitterAnalysis && twitterAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#twitterSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('span', {
    staticClass: "report-nav-x-logo",
    attrs: {
      "role": "img",
      "aria-label": "X (Twitter)"
    }
  })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("X (Twitter) Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableXHSAnalysis && _vm.xhsAnalysisData.length > 0),
      expression: "reportData.campaign.enableXHSAnalysis && xhsAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#xhsSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-outline")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("XHS Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableLemonAnalysis && _vm.lemonAnalysisData.length > 0),
      expression: "reportData.campaign.enableLemonAnalysis && lemonAnalysisData.length > 0"
    }],
    attrs: {
      "link": "",
      "href": "#lemonSummary"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-file-outline")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Lemon8 Summary")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportData.campaign.enableOverallSection),
      expression: "reportData.campaign.enableOverallSection"
    }],
    attrs: {
      "link": "",
      "href": "#performance"
    }
  }, [_c('v-list-item-icon', {
    staticStyle: {
      "margin-right": "32px"
    }
  }, [_c('v-icon', [_vm._v("mdi-chart-bar")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Overall")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "fab-btn-up",
    attrs: {
      "id": "goTop",
      "elevation": "24",
      "color": "#3F3FFF",
      "fab": "",
      "small": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "raised": ""
    },
    on: {
      "click": _vm.scrollTopFunction
    }
  }, [_c('v-icon', [_vm._v("mdi-menu-up")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "campaignSummary"
    }
  }, [_c('campaign-summary', {
    attrs: {
      "campaign": _vm.reportData.campaign
    }
  })], 1), _vm._v(" "), (_vm.reportData.campaign.enablePostAnalysis && _vm.postsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "postSummary"
    }
  }, [_c('post-summary', {
    attrs: {
      "posts": _vm.postsAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableReelAnalysis && _vm.reelAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "reelSummary"
    }
  }, [_c('reel-summary', {
    attrs: {
      "posts": _vm.reelAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storyAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "storySummary"
    }
  }, [_c('story-summary', {
    attrs: {
      "posts": _vm.storyAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTikTokAnalysis && _vm.tikTokAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "tiktokSummary"
    }
  }, [_c('tiktok-summary', {
    attrs: {
      "posts": _vm.tikTokAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableYoutubeAnalysis && _vm.youtubeAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "youtubeSummary"
    }
  }, [_c('youtube-summary', {
    attrs: {
      "posts": _vm.youtubeAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableFbAnalysis && _vm.fbAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "fbSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "posts": _vm.fbAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLinkedInAnalysis && _vm.linkedInAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "linkedInSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "linkedin",
      "posts": _vm.linkedInAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultLinkedInAnalysisStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTwitterAnalysis && _vm.twitterAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "twitterSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "twitter",
      "posts": _vm.twitterAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultTwitterAnalysisStatus
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableXHSAnalysis && _vm.xhsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "xhsSummary"
    }
  }, [_c('xhs-summary', {
    attrs: {
      "posts": _vm.xhsAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLemonAnalysis && _vm.lemonAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "lemonSummary"
    }
  }, [_c('lemon-summary', {
    attrs: {
      "posts": _vm.lemonAnalysisData,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableOverallSection) ? _c('section', {
    attrs: {
      "id": "performance"
    }
  }, [_c('campaign-performance', {
    attrs: {
      "posts": _vm.postsAnalysisData,
      "reels": _vm.reelAnalysisData,
      "tikTokPosts": _vm.tikTokAnalysisData,
      "youtubePosts": _vm.youtubeAnalysisData,
      "summary": _vm.reportData.campaign.summary,
      "campaignID": _vm.reportData.campaign.id,
      "campaignKPI": _vm.reportData.campaign.kpi,
      "campaign": _vm.reportData.campaign
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "post"
    }
  }, _vm._l((_vm.campaignPosts), function(item, index) {
    return _c('div', {
      key: index
    }, [(item.reportGroup && item.reports.length > 0) ? _c('div', [_c('v-container', [_c('v-expansion-panels', {
      attrs: {
        "multiple": "",
        "dark": "",
        "accordion": "",
        "focusable": ""
      },
      model: {
        value: (item.panel),
        callback: function($$v) {
          _vm.$set(item, "panel", $$v)
        },
        expression: "item.panel"
      }
    }, [_c('v-expansion-panel', {
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', [_c('v-toolbar-title', [_vm._v("\n                            " + _vm._s(item.name) + " (" + _vm._s(item.reports.length) + ")\n                          ")])], 1), _vm._v(" "), _c('v-expansion-panel-content', _vm._l((item.reports), function(item2, index) {
      return _c('posts', {
        key: index,
        attrs: {
          "type": item2.type,
          "post": item2,
          "campaign": _vm.reportData.campaign
        }
      })
    }), 1)], 1)], 1)], 1)], 1) : _c('div', [_c('posts', {
      key: index,
      attrs: {
        "type": item.type,
        "post": item,
        "campaign": _vm.reportData.campaign
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('v-footer', {
    staticClass: "report-footer",
    attrs: {
      "padless": "",
      "color": "#000000"
    }
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "72px",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.kobeGreenLogo,
      "width": "72px"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "https://www.getkobe.com",
      "target": "_blank"
    }
  }, [_vm._v("www.getkobe.com")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('report-login-modal', {
    attrs: {
      "value": _vm.loginModalDialog,
      "campaignID": _vm.campaignID
    },
    on: {
      "loggedIn": _vm.loggedIn
    },
    model: {
      value: (_vm.loginModalDialog),
      callback: function($$v) {
        _vm.loginModalDialog = $$v
      },
      expression: "loginModalDialog"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payout record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.campaigns,
      "search-input": _vm.search,
      "error-messages": _vm.selectedCampaignErrors,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Campaign Name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.campaign.$touch()
      },
      "change": function($event) {
        return _vm.changeCampaign()
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.search))]), _vm._v("\". Press "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payout.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payout, "campaign", $$v)
      },
      expression: "payout.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.influencers,
      "item-text": "handle",
      "hide-details": "auto",
      "label": "Influencers",
      "prefix": "@",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.handleErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.handle.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.handle.$touch()
      },
      "change": function($event) {
        return _vm.changeInfluencer()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle,
            "youtubeHandle": item.handle,
            "facebookHandle": item.handle,
            "xiaohongshuHandle": item.handle
          }
        })]
      }
    }]),
    model: {
      value: (_vm.payout.handle),
      callback: function($$v) {
        _vm.$set(_vm.payout, "handle", $$v)
      },
      expression: "payout.handle"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Swift Code",
      "hide-details": "auto",
      "error-messages": _vm.bankSwiftCodeErrors,
      "placeholder": "RABONL2U",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankSwiftCode.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankSwiftCode.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankSwiftCode),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankSwiftCode", $$v)
      },
      expression: "payout.bankSwiftCode"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank A/C No.",
      "placeholder": "Bank A/C No.(omit dashes)",
      "error-messages": _vm.bankNoErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.bankAccountNo.$touch()
      }
    },
    model: {
      value: (_vm.payout.bankAccountNo),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bankAccountNo", $$v)
      },
      expression: "payout.bankAccountNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Payee Name",
      "placeholder": "Payee Name.",
      "error-messages": _vm.receivingNameErrors,
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.payout.receivingName.$touch()
      }
    },
    model: {
      value: (_vm.payout.receivingName),
      callback: function($$v) {
        _vm.$set(_vm.payout, "receivingName", $$v)
      },
      expression: "payout.receivingName"
    }
  }), _vm._v(" "), (_vm.payout.handle) ? _c('caption', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Paired Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.handle.amount || 0))]) : _vm._e(), _vm._v(" "), (_vm.payout.completedCurrency && _vm.payout.completedCurrency === 'SGD') ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("\n              Paid Amount: S$ " + _vm._s(_vm.payout.paidAmt || 0)), _c('br'), _vm._v(" "), (_vm.payout.currency !== 'SGD') ? _c('span', [_vm._v("(Est: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.convertedEstAmt) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.payout.completedCurrency && _vm.payout.completedCurrency !== 'SGD') ? _c('caption', {
    staticClass: "font-weight-bold pb-0 pt-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("\n              Paid Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.completedCurrency)) + " " + _vm._s(_vm.payout.paidAmt || 0) + " "), _c('br'), _vm._v(" "), (_vm.payout.actualAmount) ? _c('span', [_vm._v("(Actual: S$ " + _vm._s(_vm.payout.actualAmount) + ")")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("(Est: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.completedCurrency)) + " " + _vm._s(_vm.payout.convertedEstAmt) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.payout.handle && !_vm.payout.completedCurrency) ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Paid Amount: 0")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "placeholder": "300",
      "prefix": _vm.payout.currency,
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    on: {
      "input": function($event) {
        return _vm.checkUnpaidAmount()
      },
      "blur": function($event) {
        return _vm.$v.payout.amount.$touch()
      }
    },
    model: {
      value: (_vm.payout.amount),
      callback: function($$v) {
        _vm.$set(_vm.payout, "amount", $$v)
      },
      expression: "payout.amount"
    }
  }), _vm._v(" "), (_vm.unPaidAmtErr) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Amount entered is exceeding than remain amount.")]) : _vm._e(), _vm._v(" "), (_vm.payout.processingAmt !== '') ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Processing Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.processingAmt || 0))]) : _vm._e(), _vm._v(" "), (_vm.payout.remainAmt !== '') ? _c('caption', {
    staticClass: "font-weight-bold pb-0",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_vm._v("Remaining Amount: " + _vm._s(_vm.utilsFunc.currencySym(_vm.payout.currency)) + " " + _vm._s(_vm.payout.remainAmt || 0))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Live Date (DD/MM/YYYY)",
      "hide-details": "auto",
      "error-messages": _vm.liveDateErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.live_date.$touch()
      },
      "input": _vm.changeLiveDate,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeLiveDate.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.payout.live_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "live_date", $$v)
      },
      expression: "payout.live_date"
    }
  }, _vm.on)), _vm._v(" "), (_vm.isInvalidLiveDate) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Invalid Live Date")]) : _vm._e(), _vm._v(" "), (!_vm.isInvalidLiveDate && !_vm.payout.live_date) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Required")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Due Date (DD/MM/YYYY)",
      "hide-details": "auto",
      "error-messages": _vm.dueDateErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.payout.due_date.$touch()
      }
    },
    model: {
      value: (_vm.payout.due_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "due_date", $$v)
      },
      expression: "payout.due_date"
    }
  }, _vm.on)), _vm._v(" "), (!_vm.payout.due_date) ? _c('span', {
    staticClass: "text-danger ma-0 pt-1"
  }, [_vm._v("Required")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.isBankRef) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Reference",
      "placeholder": "BK19010043050112",
      "persistent-hint": "",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payout.bank_reference),
      callback: function($$v) {
        _vm.$set(_vm.payout, "bank_reference", $$v)
      },
      expression: "payout.bank_reference"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pt-1",
    staticStyle: {
      "color": "#fb8c00 !important"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _vm._v(" For Finance Only\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isPaymentDate) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Payment Date (DD/MM/YYYY)",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.payout.payment_date),
      callback: function($$v) {
        _vm.$set(_vm.payout, "payment_date", $$v)
      },
      expression: "payout.payment_date"
    }
  }, _vm.on)), _vm._v(" "), _c('p', {
    staticClass: "ma-0 pt-1",
    staticStyle: {
      "color": "#fb8c00 !important"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _vm._v(" For Finance Only\n            ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Include GST 9%"
    },
    model: {
      value: (_vm.payout.chkGST),
      callback: function($$v) {
        _vm.$set(_vm.payout, "chkGST", $$v)
      },
      expression: "payout.chkGST"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "label": "Remarks",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.payout.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payout, "remarks", $$v)
      },
      expression: "payout.remarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('custom-file-upload', {
    attrs: {
      "refresh": _vm.fileUploadRefresh
    },
    on: {
      "setMedias": _vm.updateInvoices
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.disableSavePayout,
      "text": ""
    },
    on: {
      "click": _vm.savePayout
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.campaignFilterLists,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.setFilterItems
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setFilterItems.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.handle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "handle", $$v)
      },
      expression: "filter.handle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clientFilterLists,
      "outlined": true,
      "label": "Client",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.setFilterItems
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    ref: "submissionDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Submission Date",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.setFilterItems()
            }
          },
          model: {
            value: (_vm.filter.filterDate),
            callback: function($$v) {
              _vm.$set(_vm.filter, "filterDate", $$v)
            },
            expression: "filter.filterDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.submissionDatePicker),
      callback: function($$v) {
        _vm.submissionDatePicker = $$v
      },
      expression: "submissionDatePicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "range": ""
    },
    model: {
      value: (_vm.filter.filterDate),
      callback: function($$v) {
        _vm.$set(_vm.filter, "filterDate", $$v)
      },
      expression: "filter.filterDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMonth()
      }
    }
  }, [_vm._v("\n                      Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchMonthOk()
      }
    }
  }, [_vm._v("\n                      OK\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "text",
      "item-value": "value",
      "items": _vm.submissionStates,
      "outlined": true,
      "label": "Status",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.setFilterItems
    },
    model: {
      value: (_vm.filter.status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "status", $$v)
      },
      expression: "filter.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-2 primary",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle', {
          attrs: {
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": item.platform === 'instagram',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle
          }
        })]
      }
    }, {
      key: "item.submissionDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticStyle: {
            "min-width": "70px"
          }
        }, [_vm._v(_vm._s(_vm.utils.formatCustomDate(item.submissionDate, 'DD/MM/YYYY')))])]
      }
    }, {
      key: "item.stats",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', {
          attrs: {
            "href": '/posts/internal/all-posts?handle=' + item.handle + '&campaignID=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.stats))])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "secondary--text",
          attrs: {
            "color": "primary",
            "small": "",
            "to": '/posts/internal/all-posts?handle=' + item.handle + '&campaignID=' + item.campaignID
          }
        }, [_vm._v("\n                View Post "), _c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("mdi-magnify")])], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": _vm.name
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Enter PIN")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "security",
      "append-icon": _vm.show1 ? 'visibility' : 'visibility_off',
      "type": _vm.show1 ? 'text' : 'password',
      "label": "",
      "error-messages": _vm.passcodeErrors,
      "counter": ""
    },
    on: {
      "click:append": function($event) {
        _vm.show1 = !_vm.show1
      },
      "input": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "blur": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmPasscode.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.passcode),
      callback: function($$v) {
        _vm.passcode = $$v
      },
      expression: "passcode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.confirmPasscode
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legend-section"
  }, [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('h2', {
    staticClass: "legend-top-title"
  }, [_vm._v("Legend")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "legend-right-section",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('h3', {
    staticClass: "side-title"
  }, [_vm._v(_vm._s(_vm.rightTitle))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', [_c('v-simple-table', {
    staticClass: "legend-table",
    attrs: {
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', _vm._l((_vm.rightSections), function(item) {
          return _c('tr', {
            key: item.title
          }, [_c('td', [_c('h3', {
            staticClass: "title mt-3 mb-0"
          }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
            staticClass: "caption"
          }, [_vm._v(_vm._s(item.description))])])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1)])], 1)], 1)], 1), _vm._v(" "), (_vm.showleftSideIcon) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-img', {
    staticClass: "float-left mt-2",
    attrs: {
      "src": "/static/img/instagram.png",
      "width": "64px"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-img', {
    staticClass: "float-right",
    attrs: {
      "src": "/static/img/kobe_white.png",
      "width": "72px"
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-img', {
    staticClass: "float-right",
    attrs: {
      "src": "/static/img/kobe_white.png",
      "width": "72px"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Report Passcode")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "security",
      "append-icon": _vm.show1 ? 'visibility' : 'visibility_off',
      "type": _vm.show1 ? 'text' : 'password',
      "label": "Enter Passcode",
      "error-messages": _vm.passcodeErrors,
      "hint": "Recommended for at least 8 characters",
      "counter": ""
    },
    on: {
      "click:append": function($event) {
        _vm.show1 = !_vm.show1
      },
      "input": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "blur": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.passcode),
      callback: function($$v) {
        _vm.passcode = $$v
      },
      expression: "passcode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.resetPasscode
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creator-search-view"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "creator-search-view__content",
    attrs: {
      "cols": "12"
    }
  }, [_c('search-creators-data-table')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getCampaigns()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n          mdi-cached\n        ")]), _vm._v("\n        Reload\n      ")], 1), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "max-width": "200px",
      "float": "right"
    },
    attrs: {
      "items": _vm.defaultYears,
      "label": "Year",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getCampaigns()
      }
    },
    model: {
      value: (_vm.selectedFilter.year),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "year", $$v)
      },
      expression: "selectedFilter.year"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-5"
  }, [_c('average-boxes', {
    attrs: {
      "totalValues": _vm.totalValues
    }
  })], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', [_c('v-row', {
    staticClass: "filter-area"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    ref: "TimelineSummaryTable",
    staticClass: "timeline-summary-table elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "items-per-page": 15
    },
    on: {
      "current-items": _vm.currentItems
    },
    scopedSlots: _vm._u([{
      key: "item.activating",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_c('v-menu', {
          attrs: {
            "color": "#363636",
            "dark": "",
            "max-height": "500px",
            "close-on-content-click": false,
            "top": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "text": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.getSummaryDetails(item, 'activating')
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                " + _vm._s(item.activating) + " days\n              ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left",
            "width": "300px"
          },
          attrs: {
            "max-width": "350",
            "min-height": "100"
          }
        }, [_c('v-card-text', [(_vm.summaryDetails.actual) ? _c('div', [_c('menu-summary', {
          attrs: {
            "summary": _vm.summaryDetails
          }
        })], 1) : _vm._e()])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.pairing",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_c('v-menu', {
          attrs: {
            "color": "#363636",
            "dark": "",
            "max-height": "500px",
            "close-on-content-click": false,
            "top": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "text": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.getSummaryDetails(item, 'pairing')
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                " + _vm._s(item.pairing) + " days\n              ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left",
            "width": "300px"
          },
          attrs: {
            "max-width": "350",
            "min-height": "120"
          }
        }, [_c('v-card-text', [(_vm.summaryDetails.actual) ? _c('div', [_c('menu-summary', {
          attrs: {
            "summary": _vm.summaryDetails
          }
        })], 1) : _vm._e()])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.cocreating",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_c('v-menu', {
          attrs: {
            "color": "#363636",
            "dark": "",
            "max-height": "500px",
            "close-on-content-click": false,
            "top": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "text": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.getSummaryDetails(item, 'cocreating')
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                " + _vm._s(item.cocreating) + " days\n              ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left",
            "width": "300px"
          },
          attrs: {
            "max-width": "350",
            "min-height": "140"
          }
        }, [_c('v-card-text', [(_vm.summaryDetails.actual) ? _c('div', [_c('menu-summary', {
          attrs: {
            "summary": _vm.summaryDetails
          }
        })], 1) : _vm._e()])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.complete",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_c('v-menu', {
          attrs: {
            "color": "#363636",
            "dark": "",
            "max-height": "500px",
            "close-on-content-click": false,
            "top": "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "text": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.getSummaryDetails(item, 'complete')
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  " + _vm._s(item.complete) + " days\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left",
            "width": "300px"
          },
          attrs: {
            "max-width": "350",
            "min-height": "100"
          }
        }, [_c('v-card-text', [(_vm.summaryDetails.actual) ? _c('div', [_c('menu-summary', {
          attrs: {
            "summary": _vm.summaryDetails
          }
        })], 1) : _vm._e()])], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.totalDuration",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-layout', {
          staticClass: "text-center",
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "rating-num"
        }, [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_vm._v("\n            " + _vm._s(item.totalDuration) + " days\n          ")])], 1)], 1)]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "100px"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary",
            "target": "_blank",
            "to": '/campaigns/timeline?campaignID=' + item.campaignID
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("remove_red_eye")]), _vm._v(" View Timeline\n        ")], 1)], 1)]
      }
    }], null, true)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-analysis-data-table')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("View Client Data")]), _vm._v(" "), (_vm.client.acceptTerms) ? _c('v-alert', {
    attrs: {
      "dense": "",
      "text": "",
      "type": "success"
    }
  }, [_vm._v("\n      This client completed the\n      "), _c('strong', [_vm._v("Vendor Creation Form")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-layout', [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panels),
      callback: function($$v) {
        _vm.panels = $$v
      },
      expression: "panels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Contact Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', [_vm._v("Group")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.groupName || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.name || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.phoneNumber || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.address || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Handled By")]), _vm._v(" "), _c('p', [_c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l((_vm.dedicatedUserList), function(user) {
    return _c('v-chip', {
      key: user.id,
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                               " + _vm._s(user.firstName || '-') + " " + _vm._s(user.lastName || '-') + "\n                            ")], 1)
  }), 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Supported By")]), _vm._v(" "), _c('p', [_c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l((_vm.supportingUserList), function(user) {
    return _c('v-chip', {
      key: user.id,
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                               " + _vm._s(user.firstName || '-') + " " + _vm._s(user.lastName || '-') + "\n                            ")], 1)
  }), 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Sale Person")]), _vm._v(" "), _c('p', [_c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                            " + _vm._s(_vm.salePersonUser.firstName || '-') + "\n                          ")], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), (_vm.client.contacts) ? _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.contactPanels),
      callback: function($$v) {
        _vm.contactPanels = $$v
      },
      expression: "contactPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                      Contact Person Details\n                      "), _c('v-chip', {
    staticStyle: {
      "max-width": "30px",
      "margin-left": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.client.contacts.length))])])], 1), _vm._v(" "), _c('v-expansion-panel-content', _vm._l((_vm.client.contacts), function(contact, index) {
    return _c('v-list', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [(contact.includeEmail) ? _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v("  Include in Email\n                          ")], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Contact Person")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(contact.contactName || '-'))])])], 1)], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Contact Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(contact.email || '-'))])])], 1)], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaigns")]), _vm._v(" "), _c('p', _vm._l((contact.campaigns), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
    }), 1)])], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Account Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Account Budget:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.account.budget || '-'))])])], 1), _vm._v(" "), (_vm.client.account.deals) ? _c('div', [_c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.deals.length > 0),
      expression: "client.account.deals.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.deals.length > 0),
      expression: "client.account.deals.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.client.account.deals), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "disable-icon-rotate": ""
      }
    }, [_c('span', [_c('p', {
      staticClass: "pr-2 pb-2 mb-0"
    }, [_vm._v("\n                                      " + _vm._s(_vm.getProductName(item.name)) + "\n                                    ")]), _vm._v(" "), (_vm.getMasterlistCheck(item.IO)) ? _c('v-chip', {
      attrs: {
        "color": "green",
        "outlined": "",
        "x-small": ""
      }
    }, [_vm._v("\n                                      Masterlist \n                                      "), _c('v-icon', {
      attrs: {
        "color": "success",
        "small": ""
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-row', {
      staticClass: "pa-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Deals Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget || '-'))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("IO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.IO || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Quote Acceptance Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.quoteAcceptanceDate) || '-'))])])], 1), _vm._v(" "), (item.cogsAmount) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Markup COGS Amount")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cogsAmount || '-'))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.vertical) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaign Vertical")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.displayCampaignVerticals(item.vertical)))])])], 1) : _vm._e(), _vm._v(" "), (item.country) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('p', _vm._l((item.country), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                              " + _vm._s(item.name) + "\n                                            ")])
    }), 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Client Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getClientTypeDisplayValue(item.clientType)))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.remarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-expansion-panels', _vm._l((item.products), function(product, pindex) {
      return _c('v-expansion-panel', {
        key: pindex
      }, [_c('v-expansion-panel-header', {
        staticStyle: {
          "text-transform": "capitalize"
        }
      }, [_vm._v(_vm._s(_vm.getProductName(product.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'storytell'),
          expression: "product.name.toLowerCase() === 'storytell'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("No. of Campaigns")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.noOfCampaigns || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalOutReach || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Engagement")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalEngagement || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'amplify'),
          expression: "product.name.toLowerCase() === 'amplify'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.views || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("No. of Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.noOfContents || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.duration || '-') + " " + _vm._s((product.duration > 1 ? 'Months' : 'Month')))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'uncut'),
          expression: "product.name.toLowerCase() === 'uncut'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalOutReach || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.kpiOnboarded || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'aok'),
          expression: "product.name.toLowerCase() === 'aok'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalOutReach || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.kpiOnboarded || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'others'),
          expression: "product.name.toLowerCase() === 'others'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.remark || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Nature of deal")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.natureOfDeal ? _vm.displayNatureOfDeals(product.natureOfDeal) : '-'))])])], 1)], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client.account.products) ? _c('div', [_c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.products.length > 0),
      expression: "client.account.products.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.products.length > 0),
      expression: "client.account.products.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    }
  }, _vm._l((_vm.client.account.products), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.getProductName(item.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'storytell'),
        expression: "item.name.toLowerCase() === 'storytell'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("No. of Campaigns")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.noOfCampaigns))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.totalOutReach))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Total Engagement")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.totalEngagement))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'amplify'),
        expression: "item.name.toLowerCase() === 'amplify'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.views))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("No. of Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.noOfContents))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.duration) + " " + _vm._s((item.duration > 1 ? 'Months' : 'Month')))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'uncut'),
        expression: "item.name.toLowerCase() === 'uncut'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.kpiOnboarded || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'aok'),
        expression: "item.name.toLowerCase() === 'aok'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.totalOutReach))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.kpiOnboarded || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.product.name.toLowerCase() === 'others'),
        expression: "product.name.toLowerCase() === 'others'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.remark || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Nature of deal")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.natureOfDeal || '-'))])])], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Billing Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Payment Mode")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.clientPaymentModesDisplay(_vm.client.paymentMode) || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Billing Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.billingAddress || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Billing Contact")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.billingPhoneNumber || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Billing Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.billingEmail || '-'))])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("When did this campaign concluded?")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-form', {
    ref: "quarterForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.defaultYears,
      "label": "Year",
      "outlined": "",
      "dense": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.year),
      callback: function($$v) {
        _vm.$set(_vm.data, "year", $$v)
      },
      expression: "data.year"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.quarters,
      "item-value": "name",
      "item-text": "title",
      "label": "Quarter",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.quarter),
      callback: function($$v) {
        _vm.$set(_vm.data, "quarter", $$v)
      },
      expression: "data.quarter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Review Deck URL")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "hide-details": "",
      "error-messages": _vm.reviewDeckURL
    },
    on: {
      "input": function($event) {
        return _vm.$v.reviewDeckURL.$touch()
      },
      "blur": function($event) {
        return _vm.$v.reviewDeckURL.$touch()
      }
    },
    model: {
      value: (_vm.reviewDeckURL),
      callback: function($$v) {
        _vm.reviewDeckURL = $$v
      },
      expression: "reviewDeckURL"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.reviewDeckURL.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.feedback.campaignID) ? _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "content-class": "client-feedback-view-dialog",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "elevate-on-scroll": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Kobe Feedback Form")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-feedback-container ims-modal-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "feedbackform",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.account_manager.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback.accountManager))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.client_name.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback.clientName))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.content_curator.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback.CO))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', [_vm._v("Campaign Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback.campaignName))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold mb-0"
  }, [_vm._v("Your feedback helps decide what improvements should be made and what new features to work on in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("We would like to take this opportunity to find out your experience working with Kobe.")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("This form will take you 5 minutes to complete.")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1 mb-0"
  }, [_vm._v("Thank you for your time.")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', _vm._l((_vm.feedbackFormSections.good_ratings.fields), function(prop) {
          return _c('tr', {
            key: prop.key,
            class: prop.class,
            attrs: {
              "height": "60"
            }
          }, [_c('td', {
            staticClass: "text-left pt-3"
          }, [_c('label', [_vm._v(_vm._s(prop.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedbackFormSections.good_ratings.values.find(function (v) { return v === _vm.feedback[prop.name]; })))])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 2175431109)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', _vm._l((_vm.feedbackFormSections.likely_recommend.fields), function(item, index) {
          return _c('tr', {
            key: index,
            staticClass: "background-soft-grey"
          }, [_c('td', {
            staticClass: "text-left pt-3"
          }, [_c('label', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[item.name]) + " / 10")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3154019715)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', _vm._l((_vm.feedbackFormSections.likely_consider_again.fields), function(item, index) {
          return _c('tr', {
            key: index,
            staticClass: "background-soft-grey"
          }, [_c('td', {
            staticClass: "text-left pt-3"
          }, [_c('label', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[item.name]) + " / 10")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 188119587)
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.buyagain_decision.title))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_vm._l((_vm.feedbackFormSections.buyagain_decision.fields.filter(function (v) { return _vm.feedback[_vm.feedbackFormSections.buyagain_decision.name].includes(v.value); })), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('p', [_vm._v(_vm._s(b.label))])])
  }), _vm._v(" "), _vm._l((_vm.filterOtherBuyAgain()), function(other, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('p', [_vm._v(_vm._s(other))])])
  })], 2)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.what_did_well.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[_vm.feedbackFormSections.what_did_well.name]))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.what_can_improve.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[_vm.feedbackFormSections.what_can_improve.name]))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.account_manager_status.title) + " " + _vm._s(_vm.feedback.accountManager) + " is")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.account_manager_status.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v(_vm._s(b.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[b.name]) + " / 4")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.inf_line_up.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v(_vm._s(b.label))]), _vm._v(" "), _vm._l((_vm.feedbackFormSections.inf_line_up.values), function(value, index) {
      return _c('div', {
        key: index,
        staticClass: "radio-section"
      }, [_c('v-radio-group', {
        attrs: {
          "hide-details": "",
          "required": ""
        },
        model: {
          value: (_vm.feedback[b.name]),
          callback: function($$v) {
            _vm.$set(_vm.feedback, b.name, $$v)
          },
          expression: "feedback[b.name]"
        }
      }, [_c('span', {
        staticClass: "pr-1"
      }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-radio', {
        attrs: {
          "value": value,
          "label": value,
          "disabled": ""
        }
      })], 1)], 1)
    })], 2)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.inf_content_created.fields), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v(_vm._s(b.label))]), _vm._v(" "), _vm._l((_vm.feedbackFormSections.inf_content_created.values), function(value, index) {
      return _c('div', {
        key: index,
        staticClass: "radio-section"
      }, [_c('v-radio-group', {
        attrs: {
          "hide-details": "",
          "required": ""
        },
        model: {
          value: (_vm.feedback[b.name]),
          callback: function($$v) {
            _vm.$set(_vm.feedback, b.name, $$v)
          },
          expression: "feedback[b.name]"
        }
      }, [_c('span', {
        staticClass: "pr-1"
      }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('v-radio', {
        attrs: {
          "value": value,
          "label": value,
          "disabled": ""
        }
      })], 1)], 1)
    })], 2)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.sea_countries.title))]), _vm._v(" "), _vm._l((_vm.feedback[_vm.feedbackFormSections.sea_countries.name]), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('p', [_vm._v(_vm._s(b))])])
  })], 2)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.feedbackFormSections.platforms.title))]), _vm._v(" "), _vm._l((_vm.feedback[_vm.feedbackFormSections.platforms.name]), function(b) {
    return _c('v-flex', {
      key: b.key,
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('p', [_vm._v(_vm._s(b))])])
  })], 2)], 1)], 1), _vm._v(" "), _c('v-row', _vm._l((_vm.feedbackFormSections.kobe_questions.fields), function(kobe, index) {
    return (_vm.feedback[kobe.name]) ? _c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('label', [_vm._v(_vm._s(kobe.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[kobe.name]))])]) : _vm._e()
  }), 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('p', {
    staticClass: "font-weight-bold mb-3"
  }, [_vm._v(_vm._s(_vm.feedbackFormSections.refer_info.title))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.refer_info.fields), function(contact, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', [_c('label', [_vm._v(_vm._s(contact.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[contact.name] || '-'))])])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.feedback.scheduleSharing === true || _vm.feedback.scheduleSharing === false) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [(_vm.feedback.scheduleSharing === true) ? _c('v-icon', {
    attrs: {
      "color": "green",
      "size": "20"
    }
  }, [_vm._v("mdi-check")]) : _vm._e(), _vm._v(" "), (_vm.feedback.scheduleSharing === false) ? _c('v-icon', {
    attrs: {
      "color": "danger",
      "size": "20"
    }
  }, [_vm._v("mdi-close-circle")]) : _vm._e(), _vm._v("\n                  I would like for Kobe to schedule an internal sharing for the rest of my business teams\n                ")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.feedbackFormSections.contact_info.fields), function(contact, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('div', [_c('label', [_vm._v(_vm._s(contact.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.feedback[contact.name] || '-'))])])])
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$vuetify.breakpoint.xsOnly) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "dark": "",
      "touchless": "",
      "fixed": "",
      "height": "100%",
      "temporary": "",
      "width": "300"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [(_vm.$vuetify.breakpoint.mdAndUp) ? _c('v-toolbar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-center"
  }, [_c('div', {
    class: _vm.mini ? 'drawer-logo-wrap drawer-logo-wrap-mini' : 'drawer-logo-wrap'
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "drawer-toggle-btn",
    attrs: {
      "icon": "",
      "aria-label": "Close navigation drawer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('toggleDrawer')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('nav-list', {
    attrs: {
      "singleMenus": _vm.singleMenuList,
      "groupMenus": _vm.groupMenuList
    }
  })], 1) : _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "dark": "",
      "touchless": "",
      "mini-variant": _vm.mini,
      "mini-variant-width": _vm.$vuetify.breakpoint.xsOnly ? '50' : '80',
      "clipped": _vm.$vuetify.breakpoint.xsOnly,
      "expand-on-hover": _vm.$vuetify.breakpoint.xsOnly,
      "permanent": "",
      "width": "300"
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      },
      "update:mini-variant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [(_vm.$vuetify.breakpoint.mdAndUp) ? _c('v-toolbar', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-center"
  }, [_c('div', {
    class: _vm.mini ? 'drawer-logo-wrap drawer-logo-wrap-mini' : 'drawer-logo-wrap'
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.mini) ? _c('v-btn', {
    staticClass: "drawer-toggle-btn",
    attrs: {
      "icon": "",
      "aria-label": "Collapse navigation drawer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('nav-list', {
    attrs: {
      "singleMenus": _vm.singleMenuList,
      "groupMenus": _vm.groupMenuList
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    ref: "chooseDateDialog",
    attrs: {
      "value": _vm.ChooseDateDialogValue,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('chooseDateClosed')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Propose Dates Available\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center pb-0",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "text-center title"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "size": "75"
    }
  }, [_vm._v("rate_review")]), _vm._v(" "), _c('p', [_vm._v("Rate & Review")])], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("Kindly Rate Influencer's Quality of Work")]), _vm._v(" "), _c('v-rating', {
    attrs: {
      "color": "secondary",
      "size": "45"
    },
    model: {
      value: (_vm.submissionReview.approveRatings),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveRatings", $$v)
      },
      expression: "submissionReview.approveRatings"
    }
  }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submissionReview.approveRatings > 0 && _vm.submissionReview.approveRatings <= 4),
      expression: "submissionReview.approveRatings > 0 && submissionReview.approveRatings <= 4"
    }]
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_c('v-textarea', {
    attrs: {
      "filled": "",
      "label": "How can we make this a 5 stars?"
    },
    model: {
      value: (_vm.submissionReview.approveSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "approveSuggestion", $$v)
      },
      expression: "submissionReview.approveSuggestion"
    }
  })], 1), _vm._v(" "), _c('v-divider')], 1)])], 1), _vm._v(" "), (_vm.post && _vm.post.propose_dates) ? _c('div', [_c('p', {
    staticClass: "subtitle-1 font-weight-bold mb-0"
  }, [_vm._v("Proposed Dates")]), _vm._v(" "), _c('p', {
    staticClass: "caption caption-text",
    staticStyle: {
      "font-size": "13px!important"
    }
  }, [_vm._v("Please choose one of the dates here")]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.submissionReview.wantedLiveDate),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "wantedLiveDate", $$v)
      },
      expression: "submissionReview.wantedLiveDate"
    }
  }, _vm._l((_vm.post.propose_dates), function(date, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": _vm.utils.func.formatCustomDate(date, 'DD-MM-YYYY'),
        "value": date
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-3",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": !_vm.submissionReview.wantedLiveDate
    },
    on: {
      "click": [_vm.submitApprove, function($event) {
        $event.stopPropagation();
        _vm.askDate = false
      }]
    }
  }, [_vm._v("Approve")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box-campaign-posts"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n            Posts for campaign " + _vm._s(_vm.campaign.name) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.buttonShow('create')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.description),
      expression: "newPost.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.newPost.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPost, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.location),
      expression: "newPost.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Location"
    },
    domProps: {
      "value": (_vm.newPost.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPost, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("Hashtags")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPost.hashtag),
      expression: "newPost.hashtag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hashtags"
    },
    domProps: {
      "value": (_vm.newPost.hashtag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPost, "hashtag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('input', {
    ref: "newPostImage",
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": "newPostImage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding-top": "22px"
    }
  }, [_c('b-button', {
    staticClass: "col-xs-12",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createPost()
      }
    }
  }, [_vm._v("\n                Create\n              ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items": _vm.items,
      "fields": _vm.fields
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "imageURL",
      fn: function(row) {
        return [(row.item.imageURL) ? [_c('img', {
          staticStyle: {
            "max-height": "80px",
            "max-width": "500px"
          },
          attrs: {
            "src": row.item.imageURL,
            "alt": "image"
          }
        })] : _vm._e()]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [(_vm.acceptButtonShow(row.item.status)) ? _c('button', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.approvePost(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (_vm.canEditPost(row.item)) ? _c('button', {
          staticClass: "btn btn-default btn-sm",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#modal-edit-post"
          },
          on: {
            "click": function($event) {
              return _vm.showModalEditPost(row.item)
            }
          }
        }, [_vm._v("\n                    Edit\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.rejectButtonShow(row.item.status)) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.rejectPost(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e(), _vm._v(" "), (_vm.showInputUpdateInstagram == row.item.id) ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.instagramURL),
            expression: "instagramURL"
          }],
          staticClass: "form-control input-instagram",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (_vm.instagramURL)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.instagramURL = $event.target.value
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.updateInstagramURLShow(row.item.status)) ? _c('button', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.showModalUpdateInstagramURL(row.item)
            }
          }
        }, [_vm._v("\n                    Update Instagram URL\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.showInputUpdateInstagram == row.item.id) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showInputUpdateInstagram = ''
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "sm",
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modal-edit-post"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPost.description),
      expression: "currentPost.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.currentPost.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPost, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPost.location),
      expression: "currentPost.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.currentPost.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPost, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Hashtags")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPost.hashtag),
      expression: "currentPost.hashtag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.currentPost.hashtag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPost, "hashtag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('input', {
    ref: "editPostImage",
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": "editPostImage"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "btnCloseEditPostModal",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editPost()
      }
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")])])
}]}

/***/ }),
/* 2265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Please let us know your social handles.\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "instagramHandle", $$v)
      },
      expression: "updateData.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("TikTok")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.tiktokHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "tiktokHandle", $$v)
      },
      expression: "updateData.tiktokHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#1877F2",
      "small": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v("\n          Facebook\n        ")], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "@handle or facebook.com/handle",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.facebookHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "facebookHandle", $$v)
      },
      expression: "updateData.facebookHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Youtube")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.youtubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "youtubeHandle", $$v)
      },
      expression: "updateData.youtubeHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v("\n          LinkedIn\n        ")], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "@handle or linkedin.com/in/handle",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.linkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "linkedinHandle", $$v)
      },
      expression: "updateData.linkedinHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-flex align-center"
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "14",
      "height": "14",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          X (Twitter)\n        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "@handle or x.com/handle",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "twitterHandle", $$v)
      },
      expression: "updateData.twitterHandle"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": !_vm.updateData.instagramHandle && !_vm.updateData.tiktokHandle && !_vm.updateData.youtubeHandle && !_vm.updateData.facebookHandle && !_vm.updateData.linkedinHandle && !_vm.updateData.twitterHandle
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "800px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Manage Team to Campaign")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [_c('AssignTeam', {
    attrs: {
      "dedicatedData": _vm.dedicatedData,
      "supportingData": _vm.supportingData,
      "assignUsers": _vm.assignUsers
    },
    on: {
      "updateSelectedDedicated": _vm.updateSelectedDedicated,
      "updateSelectedSupporting": _vm.updateSelectedSupporting
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.assignCS()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-combobox', {
    staticClass: "search-keyword",
    staticStyle: {
      "max-height": "40px",
      "margin-top": "12px"
    },
    attrs: {
      "width": "200",
      "height": "40px",
      "multiple": "",
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "label": "Enter the keyword"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeKeyword(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.item))])]
      }
    }]),
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "setting-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red lighten-2",
      "dark": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Location")]), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.locations,
      "label": "Select influencer location"
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "type": "text",
      "clearable": "",
      "label": "Negative Keyword"
    },
    model: {
      value: (_vm.negativeKeyword),
      callback: function($$v) {
        _vm.negativeKeyword = $$v
      },
      expression: "negativeKeyword"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold mt-3 pb-3"
  }, [_vm._v("Duration in Year")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "ticks": "always",
      "min": "1",
      "max": "10",
      "step": "1",
      "thumb-size": 24,
      "thumb-label": "always"
    },
    model: {
      value: (_vm.pastYear),
      callback: function($$v) {
        _vm.pastYear = $$v
      },
      expression: "pastYear"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("It will search posts from (" + _vm._s(_vm.pastDate) + ") ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.message.show) ? _c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "green darken-3",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('dashboard-activation-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('campaign-brief-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('pairing-lineup-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('drafts-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('reporting-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "modalId": 'view_campaign_modal',
      "value": _vm.viewCampaignModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewCampaignModalDialog),
      callback: function($$v) {
        _vm.viewCampaignModalDialog = $$v
      },
      expression: "viewCampaignModalDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "3",
      "md": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadAll()
      }
    }
  }, [_vm._v("\n          Reload All\n          "), _c('i', {
    staticClass: "fa fa-repeat"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openReportPasscodeDialog.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLists.length > 0),
      expression: "selectedLists.length > 0"
    }],
    attrs: {
      "small": "",
      "color": "warning",
      "disabled": !_vm.selectedLists || _vm.selectedLists.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openAddPairingCampaignModal()
      }
    }
  }, [_vm._v("Add to Pairing (" + _vm._s(_vm.selectedLists.length) + ")")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "9",
      "md": "9"
    }
  }, [_c('v-row', {
    staticStyle: {
      "width": "100%",
      "justify-content": "right"
    },
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pr-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.platformList,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.selectedPlatform),
      callback: function($$v) {
        _vm.selectedPlatform = $$v
      },
      expression: "selectedPlatform"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Search Handle",
      "hide-details": "auto",
      "id": "igHandle"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin": "30px 0px 0px 0px"
    },
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.influencerGeos),
      callback: function($$v) {
        _vm.influencerGeos = $$v
      },
      expression: "influencerGeos"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Gender",
      "items": _vm.searchConfig.genderOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.gender),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "gender", $$v)
      },
      expression: "searchFilter.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "IMS Status",
      "items": _vm.searchConfig.imsOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.isIMS),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "isIMS", $$v)
      },
      expression: "searchFilter.isIMS"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Campaigns",
      "items": _vm.filterCampaigns,
      "item-value": "id",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.searchFilter.campaign),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "campaign", $$v)
      },
      expression: "searchFilter.campaign"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Aud. Credibilty",
      "items": _vm.audCredibilities
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "x-small": "",
            "color": item,
            "text-color": "white"
          }
        })]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticStyle: {
            "width": "100%",
            "margin-top": "10px",
            "margin-bottom": "-26px"
          },
          attrs: {
            "x-small": "",
            "color": item,
            "text-color": "white"
          }
        })]
      }
    }]),
    model: {
      value: (_vm.searchFilter.credibility),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "credibility", $$v)
      },
      expression: "searchFilter.credibility"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.audienceInterestLists,
      "item-text": "name",
      "item-value": "name",
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Influencer Interests"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeInfInterest(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item.name))]), _vm._v(" \n            ")])]
      }
    }]),
    model: {
      value: (_vm.searchFilter.infInterest),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "infInterest", $$v)
      },
      expression: "searchFilter.infInterest"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ml-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "min-width": "175px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "min-height": "250px"
    },
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Aud. Country "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Select Countries")])]), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Aud. Country"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeAudGeos(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n                      ")])]
      }
    }]),
    model: {
      value: (_vm.audGeos),
      callback: function($$v) {
        _vm.audGeos = $$v
      },
      expression: "audGeos"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.audGeoPercent),
      callback: function($$v) {
        _vm.audGeoPercent = $$v
      },
      expression: "audGeoPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-5"
  }, [_c('v-list-item', {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.limitOptions
    },
    model: {
      value: (_vm.searchFilter.limit),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "limit", $$v)
      },
      expression: "searchFilter.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  From\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.from
    },
    model: {
      value: (_vm.searchFilter.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.followers, "from", $$v)
      },
      expression: "searchFilter.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  To\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.to
    },
    model: {
      value: (_vm.searchFilter.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.followers, "to", $$v)
      },
      expression: "searchFilter.followers.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "min-height": "250px"
    },
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Age Group "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Audience")])]), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgeOptions
    },
    model: {
      value: (_vm.searchFilter.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "ageGroup", $$v)
      },
      expression: "searchFilter.ageGroup"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.searchFilter.ageGroupPercent),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "ageGroupPercent", $$v)
      },
      expression: "searchFilter.ageGroupPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("2nd Deg. Audience")])]), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-2",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgeOptions
    },
    model: {
      value: (_vm.searchFilter.secAgeGroup),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "secAgeGroup", $$v)
      },
      expression: "searchFilter.secAgeGroup"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.searchFilter.secAgeGroupPercent),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "secAgeGroupPercent", $$v)
      },
      expression: "searchFilter.secAgeGroupPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-5"
  }, [_c('v-list-item', {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.limitOptions
    },
    model: {
      value: (_vm.searchFilter.limit),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "limit", $$v)
      },
      expression: "searchFilter.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Aud. Interests "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-list-item', [_c('v-list-item-title', [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Select")])])], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.audienceInterestLists,
      "item-text": "name",
      "item-value": "name",
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "Audience Interests"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeAudInterest(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item.name))]), _vm._v(" \n                      ")])]
      }
    }]),
    model: {
      value: (_vm.searchFilter.audienceInterest),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "audienceInterest", $$v)
      },
      expression: "searchFilter.audienceInterest"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.creatorAgePercentOptions
    },
    model: {
      value: (_vm.audInterestPercent),
      callback: function($$v) {
        _vm.audInterestPercent = $$v
      },
      expression: "audInterestPercent"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-5"
  }, [_c('v-list-item', {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c('p', {
    staticClass: "subtitle-2 mb-0"
  }, [_vm._v("Size")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.limitOptions
    },
    model: {
      value: (_vm.searchFilter.limit),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter, "limit", $$v)
      },
      expression: "searchFilter.limit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "175px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Engagements "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "150px"
    }
  }, [_c('v-list-item', [_c('v-list-item-title', [_vm._v("Engagement Rate")])], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                  To (%)\n                  "), _c('v-autocomplete', {
    staticClass: "mt-2",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.engRatePercentageOptions.to
    },
    model: {
      value: (_vm.searchFilter.engagementRate.to),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.engagementRate, "to", $$v)
      },
      expression: "searchFilter.engagementRate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n              Paid Post Performance "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  From (%)\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.paidPstPerformanceOptions.from
    },
    model: {
      value: (_vm.searchFilter.paidPstPerformance.from),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.paidPstPerformance, "from", $$v)
      },
      expression: "searchFilter.paidPstPerformance.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                  To (%)\n                  "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.paidPstPerformanceOptions.to
    },
    model: {
      value: (_vm.searchFilter.paidPstPerformance.to),
      callback: function($$v) {
        _vm.$set(_vm.searchFilter.paidPstPerformance, "to", $$v)
      },
      expression: "searchFilter.paidPstPerformance.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showFilters) ? _c('v-row', {
    staticClass: "ml-3 mt-5",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-wrap"
  }, [_c('p', {
    staticClass: "body-2 mr-2 pt-2"
  }, [_vm._v("Filters:")]), _vm._v(" "), _vm._l((_vm.getFilterLists), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', {
            staticClass: "mr-2",
            attrs: {
              "color": "default"
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "left": ""
            }
          }, on), [_vm._v(_vm._s(item.icon))]), _vm._v(" "), (item.value) ? _c('span', [_vm._v(_vm._s(item.value))]) : _vm._e(), _vm._v(" "), (item.htmlValue) ? _c('span', {
            domProps: {
              "innerHTML": _vm._s(item.htmlValue)
            }
          }) : _vm._e(), _vm._v(" "), _c('v-btn', {
            staticClass: "btn-close",
            attrs: {
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.removeFilterShow(item.type)
              }
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "left": ""
            }
          }, on), [_vm._v("mdi-close")])], 1)], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "pt-0 pb-0"
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right!important"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewCompany",
      "data-toggle": "modal",
      "data-target": _vm.viewCompanyModalIdDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('v-data-table', {
    staticClass: "table-small elevation-1",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.items,
      "loading": _vm.loading,
      "options": _vm.pagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.totalItems,
      "item-key": "id",
      "show-select": "",
      "single-select": false
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "toggle-select-all": _vm.selectAllLists
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-select",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex flex-row",
          staticStyle: {
            "margin-left": "18px"
          }
        }, [_c('v-checkbox', {
          staticStyle: {
            "margin-right": "-12px"
          },
          attrs: {
            "label": "",
            "value": item,
            "color": "grey darken-2"
          },
          model: {
            value: (_vm.selectedLists),
            callback: function($$v) {
              _vm.selectedLists = $$v
            },
            expression: "selectedLists"
          }
        }), _vm._v(" "), _c('v-btn', {
          staticClass: "btn-reload",
          staticStyle: {
            "margin-top": "22px"
          },
          attrs: {
            "text": "",
            "x-small": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReport(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                      mdi-reload\n                    ")])], 1)], 1)]
      }
    }, {
      key: "item.profilePicture",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.paserImageUrl(item.profilePicture),
            "alt": "avatar"
          }
        })])], 1)])]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(_vm.selectedPlatform === 'tiktok') ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://www.tiktok.com/@' + item.instagramHandle
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle))]) : (_vm.selectedPlatform === 'youtube') ? _c('a', {
          attrs: {
            "target": "_blank",
            "href": item.url
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle || item.fullName))]) : _c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + item.instagramHandle
          }
        }, [_vm._v("@" + _vm._s(item.instagramHandle))]), _vm._v(" "), (item.importedCreator) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "secondary",
                  "small": ""
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("mdi-newspaper-plus")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Imported Creator")])]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.campaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((item.campaignTypes), function(campaignType, index) {
          return _c('div', {
            key: index
          }, [(campaignType.count > 0) ? _c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.openCampaignListsModal(item, item.instagramHandle)
              }
            }
          }, [_c('subtitle-1', [_vm._v(_vm._s(campaignType.name))]), _vm._v("  "), _c('b', [_vm._v("(" + _vm._s(campaignType.count) + ")")])], 1) : _vm._e()], 1)
        }), 0)])]
      }
    }, {
      key: "item.totalFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.totalFollowers)) + "\n                  ")])])]
      }
    }, {
      key: "item.country",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.countries || item.countries.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.countries), function(country, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(country.name))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.countries),
            expression: "item.countries"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.countries && item.countries.length > 0),
                  expression: "item.countries && item.countries.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + _vm.parentIndex,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      More...\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Countries")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.countries), function(country, index) {
          return _c('div', {
            key: index,
            staticClass: "d-flex justify-space-between"
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), _c('span', {
            staticClass: "more-percent"
          }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")])], 1)
        })], 2)], 1)], 1)]
      }
    }, {
      key: "item.genderPercentage",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticStyle: {
            "width": "75px"
          }
        }, [(item.audienceGenders.length > 0) ? _c('PieChart', {
          attrs: {
            "name": ("genderPie" + (item.id)),
            "title": _vm.genderPie.title,
            "labels": _vm.genderPie.labels,
            "backgroundColors": _vm.genderPie.backgroundColors,
            "items": _vm.getGenderPieData(item.audienceGenders),
            "options": _vm.genderPie.options,
            "width": _vm.genderPie.width,
            "height": _vm.genderPie.height
          }
        }) : _vm._e()], 1)])])]
      }
    }, {
      key: "item.ageGroup",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "pa-2",
          staticStyle: {
            "max-width": "84px!important",
            "max-height": "84px!important"
          }
        }, [_c('bar-chart', {
          attrs: {
            "options": _vm.barChartOptions,
            "chart-data": item.ageGroupDisplay
          }
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.audienceAges),
            expression: "item.audienceAges"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.audienceAges && item.audienceAges.length > 0),
                  expression: "item.audienceAges && item.audienceAges.length > 0"
                }],
                staticStyle: {
                  "margin-top": "-25px"
                },
                attrs: {
                  "id": 'btnMore_' + _vm.parentIndex,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                            More...\n                          ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Age Groups")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.getSortedAges(item.audienceAges)), function(age, index) {
          return _c('div', {
            key: index,
            staticClass: "d-flex justify-space-between"
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(age.code))]), _vm._v(" "), _c('span', {
            staticClass: "more-percent"
          }, [_vm._v("(" + _vm._s((age.weight * 100).toFixed(2)) + "%)")])], 1)
        })], 2)], 1)], 1)], 1)])])]
      }
    }, {
      key: "item.creatorAgeGroup",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.ageGroup) + "\n                  ")])])]
      }
    }, {
      key: "item.engagements",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("abbr")(parseInt(item.engagements))) + "\n                  ")])])]
      }
    }, {
      key: "item.engagementRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.engagementRate) + "%\n                  ")])])]
      }
    }, {
      key: "item.paidPstPerformance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.paidPstPerformance)), (item.paidPstPerformance !== '-') ? _c('span', [_vm._v("%")]) : _vm._e()])])]
      }
    }, {
      key: "item.audienceCredibility",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(_vm.selectedPlatform === 'instagram') ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "width": "50px"
          },
          attrs: {
            "x-small": "",
            "color": item.audienceCredibilityColor,
            "text-color": "white"
          }
        })], 1) : _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(item.audienceCredibility) + "\n                  ")])])]
      }
    }, {
      key: "item.rateCard",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "max-height": "500px",
            "close-on-content-click": false,
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary",
                  "x-small": "",
                  "text": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.getRateCard(item)
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      View\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left",
            "width": "300px"
          },
          attrs: {
            "max-width": "350"
          }
        }, [_c('v-card-text', [_c('v-expansion-panels', {
          attrs: {
            "multiple": ""
          },
          model: {
            value: (_vm.openExpansion),
            callback: function($$v) {
              _vm.openExpansion = $$v
            },
            expression: "openExpansion"
          }
        }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', [_vm._v("IMS Imported Rates "), _c('br'), _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('rate-card-preview', {
          attrs: {
            "data": _vm.inputRates,
            "type": "IMS"
          }
        })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', [_vm._v("Rate Card Form Rates "), _c('br'), _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('rate-card-preview', {
          attrs: {
            "data": _vm.rateCardFormRates,
            "type": "rateCard"
          }
        })], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.infInterests",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.infInterests || item.infInterests.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.infInterests), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(interest.name))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.infInterests),
            expression: "item.infInterests"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.infInterests && item.infInterests.length > 0),
                  expression: "item.infInterests && item.infInterests.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      More...\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Influencer Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.infInterests), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest.name))])
        })], 2)], 1)], 1)]
      }
    }, {
      key: "item.audienceInterests",
      fn: function(ref) {
        var item = ref.item;

        return [(!item.audienceInterests || item.audienceInterests.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.audienceInterests), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(interest.name))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.audienceInterests),
            expression: "item.audienceInterests"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.audienceInterests && item.audienceInterests.length > 0),
                  expression: "item.audienceInterests && item.audienceInterests.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + _vm.parentIndex,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                      More...\n                    ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Audience Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audienceInterests), function(interest, index) {
          return _c('div', {
            key: index,
            staticClass: "d-flex justify-space-between"
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(interest.name))]), _vm._v(" "), _c('span', {
            staticStyle: {}
          }, [_vm._v("(" + _vm._s((interest.weight * 100).toFixed(2)) + "%)")])], 1)
        })], 2)], 1)], 1)]
      }
    }, {
      key: "item.avgViews",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgViews)) + "\n                  ")])])]
      }
    }, {
      key: "item.avgLikes",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgLikes)) + "\n                  ")])])]
      }
    }, {
      key: "item.avgComments",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgComments)) + "\n                  ")])])]
      }
    }, {
      key: "item.avgReelPlays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avgReelPlays)) + "\n                  ")])])]
      }
    }, {
      key: "item.medianEngagements",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "115px"
          }
        }, [_c('div', {
          staticClass: "clearfix"
        }, [_c('ul', {
          attrs: {
            "id": "progressbar"
          }
        }, _vm._l((item.medianEngagements), function(eng, index) {
          return _c('li', {
            key: index,
            class: {
              'active red-color': !eng.median && index <= item.influencerIndex && item.influencerIndex < item.medianIndex,
              'active green-color': !eng.median && index <= item.influencerIndex && item.influencerIndex >= item.medianIndex,
              'median': eng.median && item.influencerIndex < item.medianIndex,
              'median green-color': eng.median && item.influencerIndex >= item.medianIndex
            }
          }, [(eng.median) ? _c('span', [_vm._v("Median")]) : _vm._e()])
        }), 0)]), _vm._v(" "), _c('div', [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.openMedianEngModal(item)
            }
          }
        }, [_vm._v("\n                        Details\n                      ")])], 1)])])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(props.item.totalFollowers)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.audienceCredibility) + "%")])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("assessment")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])])], 1), _vm._v(" "), (!item.isIMS && _vm.isSuperAdminRole) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAud(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-trash-can-outline")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1) : _vm._e()], 1)])]
      }
    }], null, true),
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    on: {
      "showLoadingEvent": _vm.showLoadingEvent
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showLoading),
      callback: function($$v) {
        _vm.showLoading = $$v
      },
      expression: "showLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Exporting your data.\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.importLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.importLoading = $event
      }
    }
  }), _vm._v(" "), _c('campaign-lists-modal', {
    attrs: {
      "items": _vm.viewCampaigns,
      "handle": _vm.viewHandle,
      "value": _vm.viewCampaignListsDialog
    },
    model: {
      value: (_vm.viewCampaignListsDialog),
      callback: function($$v) {
        _vm.viewCampaignListsDialog = $$v
      },
      expression: "viewCampaignListsDialog"
    }
  }), _vm._v(" "), _c('median-engagements-modal', {
    attrs: {
      "items": _vm.viewMedianEngs,
      "handle": _vm.viewHandle,
      "engagementRate": _vm.viewEngRate,
      "followersRange": _vm.viewFollowersRange,
      "value": _vm.viewMedianEngDialog
    },
    model: {
      value: (_vm.viewMedianEngDialog),
      callback: function($$v) {
        _vm.viewMedianEngDialog = $$v
      },
      expression: "viewMedianEngDialog"
    }
  }), _vm._v(" "), _c('add-influencer-pairing-modal', {
    attrs: {
      "selectedInfluencers": _vm.selectedLists,
      "value": _vm.addInfluencerPairingDialog
    },
    model: {
      value: (_vm.addInfluencerPairingDialog),
      callback: function($$v) {
        _vm.addInfluencerPairingDialog = $$v
      },
      expression: "addInfluencerPairingDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "All Influencers",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('all-reports-passcode-modal', {
    attrs: {
      "value": _vm.allReportsPasscodeDialog,
      "reportType": _vm.downloadReportType
    },
    on: {
      "success": _vm.reportPasscodeSuccess
    },
    model: {
      value: (_vm.allReportsPasscodeDialog),
      callback: function($$v) {
        _vm.allReportsPasscodeDialog = $$v
      },
      expression: "allReportsPasscodeDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "1000px",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "absolute": "",
      "color": "primary",
      "width": "100%"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.termsAndConditions.title[_vm.selectedLang]))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.termsAndConditions.title[_vm.selectedLang]))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.termsAndConditions.html[_vm.selectedLang])
    }
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.agree
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]), _vm._v(_vm._s(_vm.termsAndConditions.confirmButtonText))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v(" mdi-cancel")]), _vm._v(_vm._s(_vm.termsAndConditions.cancelButtonText))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "end",
      "align": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "right"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.billingFilterItems,
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "dense": "",
      "label": "Billing Names"
    },
    on: {
      "change": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.billingSelectedFilter),
      callback: function($$v) {
        _vm.billingSelectedFilter = $$v
      },
      expression: "billingSelectedFilter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "right"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignFilterItems,
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "dense": "",
      "label": "Campaign Names"
    },
    on: {
      "change": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.campaignSelectedFilter),
      callback: function($$v) {
        _vm.campaignSelectedFilter = $$v
      },
      expression: "campaignSelectedFilter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1",
      "align": "left"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.campaignReportHeaders,
      "items": _vm.campaignReportData,
      "single-expand": "",
      "expanded": _vm.expanded,
      "item-key": "id",
      "show-expand": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.clientName",
      fn: function(ref) {
        var item = ref.item;

        return [(item.campaignGroup) ? _c('v-icon', [_vm._v("mdi-domain")]) : _vm._e(), _vm._v(" " + _vm._s(item.clientName) + "\n            ")]
      }
    }, {
      key: "item.IOAmount",
      fn: function(ref) {
        var item = ref.item;

        return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "primary",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
      }
    }, {
      key: "item.cogs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-icon', {
          staticClass: "currency",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n            ")]
      }
    }, {
      key: "item.revenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "green",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenue)))])], 1)]
      }
    }, {
      key: "item.avgInfluencerRatings",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-center"
        }, [_c('v-rating', {
          staticClass: "v-rating-button",
          attrs: {
            "readonly": "",
            "dense": "",
            "small": "",
            "length": "5"
          },
          model: {
            value: (item.avgInfluencerRatings),
            callback: function($$v) {
              _vm.$set(item, "avgInfluencerRatings", $$v)
            },
            expression: "item.avgInfluencerRatings"
          }
        })], 1)]
      }
    }, {
      key: "item.avgClientRatings",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-center"
        }, [_c('v-rating', {
          staticClass: "v-rating-button",
          attrs: {
            "readonly": "",
            "dense": "",
            "small": "",
            "length": "5"
          },
          model: {
            value: (item.avgClientRatings),
            callback: function($$v) {
              _vm.$set(item, "avgClientRatings", $$v)
            },
            expression: "item.avgClientRatings"
          }
        })], 1)]
      }
    }, {
      key: "item.amountPaid",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-icon', {
          staticClass: "currency",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amountPaid)) + "\n            ")]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.influencers) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "payout-table-small elevation-1",
          attrs: {
            "headers": _vm.detailsHeaders,
            "items": item.influencers,
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([{
            key: "item.handle",
            fn: function(ref) {
              var item = ref.item;

              return [_c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://instagram.com/' + item.handle
                }
              }, [_vm._v("@" + _vm._s(item.handle))])]
            }
          }, {
            key: "item.amount",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                  ")]
            }
          }, {
            key: "item.influencerRating",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "text-center"
              }, [_c('v-rating', {
                staticClass: "v-rating-button",
                attrs: {
                  "readonly": "",
                  "dense": "",
                  "small": "",
                  "length": "5"
                },
                model: {
                  value: (item.influencerRating),
                  callback: function($$v) {
                    _vm.$set(item, "influencerRating", $$v)
                  },
                  expression: "item.influencerRating"
                }
              })], 1)]
            }
          }], null, true)
        })], 1) : _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          key: _vm.dataTableKey,
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.campaignReportHeaders,
            "items": item.campaigns,
            "single-expand": "",
            "expanded": _vm.expanded2,
            "show-expand": ""
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded2 = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "item.IOAmount",
            fn: function(ref) {
              var item = ref.item;

              return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "primary",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
            }
          }, {
            key: "item.cogs",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n                  ")]
            }
          }, {
            key: "item.revenue",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "green",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenue)))])], 1)]
            }
          }, {
            key: "item.avgInfluencerRatings",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "text-center"
              }, [_c('v-rating', {
                staticClass: "v-rating-button",
                attrs: {
                  "readonly": "",
                  "dense": "",
                  "small": "",
                  "length": "5"
                },
                model: {
                  value: (item.avgInfluencerRatings),
                  callback: function($$v) {
                    _vm.$set(item, "avgInfluencerRatings", $$v)
                  },
                  expression: "item.avgInfluencerRatings"
                }
              })], 1)]
            }
          }, {
            key: "item.avgClientRatings",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "text-center"
              }, [_c('v-rating', {
                staticClass: "v-rating-button",
                attrs: {
                  "readonly": "",
                  "dense": "",
                  "small": "",
                  "length": "5"
                },
                model: {
                  value: (item.avgClientRatings),
                  callback: function($$v) {
                    _vm.$set(item, "avgClientRatings", $$v)
                  },
                  expression: "item.avgClientRatings"
                }
              })], 1)]
            }
          }, {
            key: "item.vertical",
            fn: function(ref) {
              var item = ref.item;

              return _vm._l((item.vertical), function(item, index) {
                return _c('v-chip', {
                  key: index,
                  staticClass: "ma-1",
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                      ")])
              })
            }
          }, {
            key: "item.amountPaid",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amountPaid)) + "\n                  ")]
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [_c('td', {
                staticStyle: {
                  "border": "none",
                  "padding": "20px"
                },
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-data-table', {
                staticClass: "payout-table-small elevation-1",
                attrs: {
                  "headers": _vm.detailsHeaders,
                  "items": item.influencers,
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u([{
                  key: "item.handle",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('a', {
                      attrs: {
                        "target": "_blank",
                        "href": 'https://instagram.com/' + item.handle
                      }
                    }, [_vm._v("@" + _vm._s(item.handle))])]
                  }
                }, {
                  key: "item.amount",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-icon', {
                      staticClass: "currency",
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                        ")]
                  }
                }, {
                  key: "item.influencerRating",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('div', {
                      staticClass: "text-center"
                    }, [_c('v-rating', {
                      staticClass: "v-rating-button",
                      attrs: {
                        "readonly": "",
                        "dense": "",
                        "small": "",
                        "length": "5"
                      },
                      model: {
                        value: (item.influencerRating),
                        callback: function($$v) {
                          _vm.$set(item, "influencerRating", $$v)
                        },
                        expression: "item.influencerRating"
                      }
                    })], 1)]
                  }
                }], null, true)
              })], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    ref: "dateDialog",
    attrs: {
      "value": _vm.proposeDialogValue,
      "max-width": "325px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('proposeClosed')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Choose 3 Dates\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [(_vm.post) ? _c('p', [_vm._v("\n        Scheduled: "), _c('strong', [_vm._v(_vm._s(_vm.post.postDate) + _vm._s(_vm.post.postDateEnd ? ("  to " + (_vm.post.postDateEnd)) : ''))])]) : _vm._e(), _vm._v(" "), (_vm.post && _vm.post.requestDate) ? _c('p', [_vm._v("\n        Requested Date: "), _c('strong', [_vm._v(_vm._s(_vm.post.requestDate))])]) : _vm._e(), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "multiple": "",
      "allowed-dates": _vm.allowedDates
    },
    model: {
      value: (_vm.submissionReview.propose_dates),
      callback: function($$v) {
        _vm.$set(_vm.submissionReview, "propose_dates", $$v)
      },
      expression: "submissionReview.propose_dates"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": [_vm.saveChangeDate, function($event) {
        $event.stopPropagation();
        _vm.askDate = false
      }]
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('v-col', [_c('v-card', [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Influencer Account",
      "placeholder": "username or url",
      "outlined": "",
      "required": ""
    },
    model: {
      value: (_vm.userAccount),
      callback: function($$v) {
        _vm.userAccount = $$v
      },
      expression: "userAccount"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "solo": "",
      "items": _vm.platformList,
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.selectedPlatform),
      callback: function($$v) {
        _vm.selectedPlatform = $$v
      },
      expression: "selectedPlatform"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download(PDF)")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("Overview Report")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filterUsers,
      "item-value": "id",
      "item-text": "name",
      "label": "Filter",
      "solo": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%",
      "color": "rgba(0,0,0,0.12)",
      "margin-top": "0px"
    }
  })], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.overviewHeaders,
      "items": _vm.overviewData,
      "single-expand": "",
      "expanded": _vm.expanded,
      "show-expand": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [(item.type === 'group') ? _c('v-icon', [_vm._v("mdi-domain")]) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n                ")]
      }
    }, {
      key: "item.totalIOAmount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "primary",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalIOAmount)))])], 1)]
      }
    }, {
      key: "item.totalRevenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "green",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalRevenue)))])], 1)]
      }
    }, {
      key: "item.totalCompletion",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          style: ({
            color: _vm.getColor(item.totalCompletion)
          })
        }, [_vm._v(_vm._s(item.totalCompletion) + " %")])]
      }
    }, {
      key: "item.totalPayout",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-icon', {
          staticClass: "currency",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalPayout)) + "\n                ")]
      }
    }, {
      key: "item.lastIODate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.lastIODate)) + " ")])]
      }
    }, {
      key: "item.CO",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.CO), function(obj, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-1",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                        " + _vm._s(obj.firstName) + "\n                    ")])
        })
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.campaigns) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.detailsHeaders,
            "items": item.campaigns,
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([{
            key: "item.IOAmount",
            fn: function(ref) {
              var item = ref.item;

              return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "primary",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
            }
          }, {
            key: "item.budget",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n                      ")]
            }
          }, {
            key: "item.payout",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.payout)) + "\n                      ")]
            }
          }, {
            key: "item.revenvue",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "green",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenvue)))])], 1)]
            }
          }, {
            key: "item.completion",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                style: ({
                  color: _vm.getColor(item.completion)
                })
              }, [_vm._v(_vm._s(item.completion))])]
            }
          }, {
            key: "item.dateAt",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.dateAt)) + " ")])]
            }
          }, {
            key: "item.AM",
            fn: function(ref) {
              var item = ref.item;

              return _vm._l((item.AM), function(obj, index) {
                return _c('v-chip', {
                  key: index,
                  staticClass: "ma-1",
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                            " + _vm._s(obj.firstName) + "\n                        ")])
              })
            }
          }], null, true)
        })], 1) : _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          key: _vm.dataTableKey,
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.overviewHeaders,
            "items": item.clients,
            "single-expand": "",
            "expanded": _vm.expanded2,
            "show-expand": ""
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded2 = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "item.totalIOAmount",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "primary",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalIOAmount)))])], 1)]
            }
          }, {
            key: "item.totalRevenue",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "green",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalRevenue)))])], 1)]
            }
          }, {
            key: "item.totalCompletion",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                style: ({
                  color: _vm.getColor(item.totalCompletion)
                })
              }, [_vm._v(_vm._s(item.totalCompletion) + " %")])]
            }
          }, {
            key: "item.totalPayout",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalPayout)) + "\n                        ")]
            }
          }, {
            key: "item.lastIODate",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.lastIODate)) + " ")])]
            }
          }, {
            key: "item.CO",
            fn: function(ref) {
              var item = ref.item;

              return _vm._l((item.CO), function(obj, index) {
                return _c('v-chip', {
                  key: index,
                  staticClass: "ma-1",
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                                " + _vm._s(obj.firstName) + "\n                            ")])
              })
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [_c('td', {
                staticStyle: {
                  "border": "none",
                  "padding": "20px"
                },
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-data-table', {
                staticClass: "elevation-1",
                attrs: {
                  "headers": _vm.detailsHeaders,
                  "items": item.campaigns,
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u([{
                  key: "item.IOAmount",
                  fn: function(ref) {
                    var item = ref.item;

                    return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
                      staticClass: "ma-1",
                      attrs: {
                        "color": "primary",
                        "small": "",
                        "text-color": "white"
                      }
                    }, [_c('v-icon', {
                      staticClass: "mr-0",
                      attrs: {
                        "small": "",
                        "left": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
                  }
                }, {
                  key: "item.budget",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-icon', {
                      staticClass: "currency",
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n                                  ")]
                  }
                }, {
                  key: "item.payout",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-icon', {
                      staticClass: "currency",
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.payout)) + "\n                                  ")]
                  }
                }, {
                  key: "item.revenvue",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-chip', {
                      staticClass: "ma-1",
                      attrs: {
                        "color": "green",
                        "small": "",
                        "text-color": "white"
                      }
                    }, [_c('v-icon', {
                      staticClass: "mr-0",
                      attrs: {
                        "small": "",
                        "left": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenvue)))])], 1)]
                  }
                }, {
                  key: "item.completion",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('div', {
                      style: ({
                        color: _vm.getColor(item.completion)
                      })
                    }, [_vm._v(_vm._s(item.completion))])]
                  }
                }, {
                  key: "item.dateAt",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('div', [_vm._v(_vm._s(_vm.formatDate(item.dateAt)) + " ")])]
                  }
                }, {
                  key: "item.AM",
                  fn: function(ref) {
                    var item = ref.item;

                    return _vm._l((item.AM), function(obj, index) {
                      return _c('v-chip', {
                        key: index,
                        staticClass: "ma-1",
                        attrs: {
                          "small": ""
                        }
                      }, [_vm._v("\n                                        " + _vm._s(obj.firstName) + "\n                                    ")])
                    })
                  }
                }], null, true)
              })], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "400"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Create Password")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage && _vm.errorMessage !== null),
      expression: "errorMessage && errorMessage !== null"
    }],
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]), _vm._v(" "), _c('form', [_c('v-container', {
    staticClass: "remove-padding",
    attrs: {
      "container--fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Generate a strong password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-space-between"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "500",
      "padding-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.generatedPass))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyPass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.generatePass()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-reload")])], 1)], 1)]), _vm._v(" "), _c('label', {
    staticClass: "mt-3"
  }, [_vm._v("Set Password")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    staticClass: "input-group--focused mt-0 pt-0",
    attrs: {
      "error-messages": _vm.passwordError,
      "type": "text",
      "autocomplete": "new-password",
      "name": "new-password",
      "color": "#1687c0",
      "label": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "blur": function($event) {
        return _vm.$v.user.newPassword.$touch()
      },
      "click:append": function($event) {
        _vm.show.password = !_vm.show.password
      }
    },
    model: {
      value: (_vm.user.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "newPassword", $$v)
      },
      expression: "user.newPassword"
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary",
      "disabled": _vm.$v.user.$invalid
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-pass"
    },
    domProps: {
      "value": _vm.generatedPass
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('add-review-meeting-date', {
    attrs: {
      "oldReviewDate": _vm.oldReviewDate,
      "oldActivatingDate": _vm.oldActivatingDate,
      "campaignID": _vm.campaignID,
      "options": {
        theme: 'default'
      }
    },
    on: {
      "updated": _vm.invokeReviewMeetingUpdated,
      "reloadTimeline": _vm.getCampaignTimelines
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pb-2 text-right"
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "xs": "6",
      "md": "6",
      "justify": "left",
      "align": "left",
      "pt-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadImage()
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("download")]), _vm._v("\n        Download Image\n      ")], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12",
      "xs": "6",
      "md": "6",
      "justify": "right",
      "align": "right",
      "pt-0": ""
    }
  }, [(_vm.currentMode === 'view') ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('edit')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("edit")]), _vm._v("\n        Edit Mode\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('view')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("close")]), _vm._v("\n        Cancel\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "success",
      "small": "",
      "disabled": _vm.disableSave
    },
    on: {
      "click": function($event) {
        return _vm.saveChanges()
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("check")]), _vm._v("\n        Save Changes\n      ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    class: ("text-center print-table-inner " + (_vm.currentMode === 'view' ? 'table-view-mode' : 'table-edit-mode'))
  }, [_c('div', {
    attrs: {
      "id": "img-node"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "campaign-timeline-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('draggable', {
          attrs: {
            "list": props.items,
            "tag": "tbody",
            "handle": ".move-cursor"
          },
          on: {
            "update": function($event) {
              return _vm.handleDataTableDragDrop(props.items)
            }
          }
        }, _vm._l((props.items), function(item, parentIndex) {
          return _c('tr', {
            key: parentIndex
          }, [_c('td', {
            staticClass: "text-start",
            style: (("width:" + (_vm.viewMode ? '20%' : '40%')))
          }, [_c('div', {
            staticClass: "d-flex flex-row justify-left pt-4"
          }, [(_vm.editMode) ? _c('v-icon', {
            staticClass: "move-cursor",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n                        mdi-arrow-all\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.viewMode) ? _c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          " + _vm._s(item.startDate) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row"
          }, [(_vm.editMode) ? _c('v-text-field', {
            staticClass: "edit-date-box",
            attrs: {
              "placeholder": "Start Date",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'startDate', 'validStartDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'startDate', 'validStartDate')
              }
            },
            model: {
              value: (item.startDate),
              callback: function($$v) {
                _vm.$set(item, "startDate", $$v)
              },
              expression: "item.startDate"
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [(_vm.editMode) ? _c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.startDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'startDate' ].concat( argsArray ))
              }
            }
          }) : _vm._e()], 1), _vm._v("\n                           "), (_vm.editMode && item.startDate) ? _c('span', {
            class: ("pt-2 " + (_vm.utils.func.getDaysDiff(item.startDate) < 0 ? 'text-red': ''))
          }, [_vm._v("(" + _vm._s(_vm.utils.func.getDaysDiff(item.startDate)) + ")")]) : _vm._e()], 1), _vm._v(" "), (_vm.editMode && !item.validStartDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid Start Date")]) : _vm._e()]), _vm._v(" "), ((item.startDate && item.endDate) || _vm.editMode) ? _c('div', {
            class: ("px-2 " + (_vm.editMode ? 'pt-2' : '') + " text-center")
          }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.viewMode) ? _c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          " + _vm._s(item.endDate) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row"
          }, [(_vm.editMode) ? _c('v-text-field', {
            staticClass: "edit-date-box",
            attrs: {
              "placeholder": "End Date",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'endDate', 'validEndDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'endDate', 'validEndDate')
              }
            },
            model: {
              value: (item.endDate),
              callback: function($$v) {
                _vm.$set(item, "endDate", $$v)
              },
              expression: "item.endDate"
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [(_vm.editMode) ? _c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.endDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'endDate' ].concat( argsArray ))
              }
            }
          }) : _vm._e()], 1), _vm._v("\n                           "), (_vm.editMode && item.endDate) ? _c('span', {
            class: ("pt-2 " + (_vm.utils.func.getDaysDiff(item.endDate) < 0 ? 'text-red': ''))
          }, [_vm._v("(" + _vm._s(_vm.utils.func.getDaysDiff(item.endDate)) + ")")]) : _vm._e()], 1), _vm._v(" "), (_vm.editMode && !item.validEndDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid End Date")]) : _vm._e()])], 1), _vm._v(" "), (_vm.editMode && !item.startDate && !item.endDate && item.actionType !== _vm.timelineTypes.EMPTY) ? _c('div', {
            staticClass: "text-danger text-left ma-0 pt-1"
          }, [_vm._v("Please enter start date or end date")]) : _vm._e(), _vm._v(" "), (_vm.showActivatingDueDateBox(item)) ? _c('div', {
            staticClass: "pb-3"
          }, [(_vm.editMode) ? _c('div', [_c('hr', {
            staticClass: "mb-2"
          }), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row pt-3 pb-3"
          }, [(_vm.editMode) ? _c('span', [_vm._v("Enter Date for IMS to remind you on brief due date:")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-text-field', {
            attrs: {
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'activatingDueDate', 'validActivatingDueDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'activatingDueDate', 'validActivatingDueDate')
              }
            },
            model: {
              value: (item.activatingDueDate),
              callback: function($$v) {
                _vm.$set(item, "activatingDueDate", $$v)
              },
              expression: "item.activatingDueDate"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [_c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.activatingDueDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'activatingDueDate' ].concat( argsArray ))
              }
            }
          })], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.editMode && !item.validActivatingDueDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid Activating Due Date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewMode && !_vm.hideForPrint) ? _c('div', {
            staticStyle: {
              "margin-top": "-15px"
            }
          }, [_c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          Brief Due Date: " + _vm._s(item.activatingDueDate) + "\n                        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPairingDueDateBox(item)) ? _c('div', {
            staticClass: "pb-3"
          }, [(_vm.editMode) ? _c('div', [_c('hr', {
            staticClass: "mb-2"
          }), _vm._v(" "), _c('div', {
            staticClass: "d-flex flex-row pt-3 pb-3"
          }, [(_vm.editMode) ? _c('span', [_vm._v("Enter Date to prompt CC on lineup due date:")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-text-field', {
            attrs: {
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            on: {
              "input": function($event) {
                return _vm.checkDate(item, 'pairingDueDate', 'validPairingDueDate')
              },
              "keyup": function($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                return _vm.checkDate(item, 'pairingDueDate', 'validPairingDueDate')
              }
            },
            model: {
              value: (item.pairingDueDate),
              callback: function($$v) {
                _vm.$set(item, "pairingDueDate", $$v)
              },
              expression: "item.pairingDueDate"
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "date-picker-inner"
          }, [_c('date-picker', {
            attrs: {
              "className": "input-field",
              "options": {
                theme: 'icon'
              },
              "status": item.pairingDueDateCal
            },
            on: {
              "changeDate": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.setDateFromPicker.apply(void 0, [ item, 'pairingDueDate' ].concat( argsArray ))
              }
            }
          })], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.editMode && !item.validPairingDueDate) ? _c('span', {
            staticClass: "text-danger ma-0 pt-1"
          }, [_vm._v("Invalid Pairing Due Date")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewMode && !_vm.hideForPrint) ? _c('div', {
            staticStyle: {
              "margin-top": "-15px"
            }
          }, [_c('p', {
            staticClass: "text-center mb-0"
          }, [_vm._v("\n                          Lineup Due Date: " + _vm._s(item.pairingDueDate) + "\n                        ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-start",
            style: (("width:" + (_vm.viewMode ? '45%' : '40%')))
          }, [(_vm.viewMode) ? _c('h4', {
            class: ((item.actionType && item.actionType.value ? 'font-weight-bold' : '') + " mb-1 mt-1"),
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v("\n                      " + _vm._s(_vm.displayActionType(item.actionType)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('v-combobox', {
            staticClass: "mt-1 mb-1",
            staticStyle: {
              "width": "200px"
            },
            attrs: {
              "label": "",
              "items": _vm.timelineTypeLists,
              "item-text": "title",
              "item-value": "value",
              "dense": "",
              "outlined": "",
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeActionType()
              }
            },
            model: {
              value: (item.actionType),
              callback: function($$v) {
                _vm.$set(item, "actionType", $$v)
              },
              expression: "item.actionType"
            }
          }) : _vm._e(), _vm._v(" "), (_vm.viewMode) ? _c('p', {
            staticClass: "mb-1",
            domProps: {
              "innerHTML": _vm._s(_vm.formatDesc(item.actionDesc))
            }
          }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('v-textarea', {
            staticClass: "mb-1",
            attrs: {
              "outlined": "",
              "dense": "",
              "rows": "2",
              "hide-details": ""
            },
            model: {
              value: (item.actionDesc),
              callback: function($$v) {
                _vm.$set(item, "actionDesc", $$v)
              },
              expression: "item.actionDesc"
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-start",
            style: (("width:" + (_vm.viewMode ? '25%' : '30%')))
          }, [(_vm.viewMode) ? _c('p', [_vm._v(_vm._s(item.actionBy))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('v-text-field', {
            staticClass: "edit-date-box",
            attrs: {
              "outlined": "",
              "dense": "",
              "hide-details": ""
            },
            model: {
              value: (item.actionBy),
              callback: function($$v) {
                _vm.$set(item, "actionBy", $$v)
              },
              expression: "item.actionBy"
            }
          }) : _vm._e()], 1), _vm._v(" "), (_vm.editMode) ? _c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "5%"
            }
          }, [_c('v-btn', {
            attrs: {
              "small": "",
              "icon": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                return _vm.deleteItem(item)
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e()])
        }), 0)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }])
  })], 1)]), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-row', {
    staticClass: "mt-1"
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "justify": "left",
      "align": "left",
      "pt-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.addAction
    }
  }, [_c('v-icon', _vm._g({}, _vm.on), [_vm._v("add")]), _vm._v(" Add Action\n        ")], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('linear-progress', {
    attrs: {
      "loading": _vm.isLoading,
      "text": "Generating..."
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1300px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    staticClass: "pairing-elimination-toolbar",
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "pairing-elimination-title"
  }, [_c('h2', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            Proposed Influencer List for \"\n            "), _c('strong', [_vm._v(_vm._s(_vm.campaign.name))]), _vm._v("\" campaign\n          ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ims-modal-body"
  }, [_c('div', {
    staticClass: "pairing-elimination-options"
  }, [_c('v-btn-toggle', {
    attrs: {
      "mandatory": "",
      "color": "secondary"
    },
    on: {
      "change": function($event) {
        return _vm.changeOption()
      }
    },
    model: {
      value: (_vm.optionVal),
      callback: function($$v) {
        _vm.optionVal = $$v
      },
      expression: "optionVal"
    }
  }, [_c('v-btn', {
    staticClass: "option-btn"
  }, [_vm._v("Option A")]), _vm._v(" "), _c('v-btn', {
    staticClass: "option-btn"
  }, [_vm._v("Option B")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.termsAndCondition)
    }
  })]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('pairing-influencers-table', {
    attrs: {
      "influencers": _vm.pairedInfluencers,
      "elimination": "",
      "campaignID": _vm.campaign.id,
      "campaignData": _vm.campaign
    },
    on: {
      "savedEliminationChanges": _vm.eliminationSubmitted,
      "savedClientNotes": _vm.getPairingList
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-invite"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.campaigns,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group",
            "aria-label": "Basic example"
          }
        }, [_c('button', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.approveRateCard(row.item.id, row.item.editRateCard)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.rejectRateCard(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "md"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "modalId": 'view_campaign_modal',
      "campaignData": _vm.viewCampaignData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.downloadCogsEstimateRpt
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-combobox', {
    staticClass: "pr-2",
    staticStyle: {
      "min-width": "200px",
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n              ")])]
      }
    }]),
    model: {
      value: (_vm.selectedFilter.country),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "country", $$v)
      },
      expression: "selectedFilter.country"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "200px"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "All CC",
      "items": _vm.CCUsers,
      "item-text": "name",
      "item-value": "id",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getCogsEstimation()
      }
    },
    model: {
      value: (_vm.selectedFilter.cc),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "cc", $$v)
      },
      expression: "selectedFilter.cc"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    ref: "startDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "200px",
            "max-width": "200px"
          },
          attrs: {
            "label": "Start Month",
            "placeholdre": "Start Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateCal),
      callback: function($$v) {
        _vm.startDateCal = $$v
      },
      expression: "startDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }, [_c('v-spacer')], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "date-divider"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('v-menu', {
    ref: "endDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-3",
          staticStyle: {
            "min-width": "200px",
            "max-width": "200px"
          },
          attrs: {
            "label": "End Month",
            "placeholder": "End Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateCal),
      callback: function($$v) {
        _vm.endDateCal = $$v
      },
      expression: "endDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }, [_c('v-spacer')], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.getCogsEstimation
    }
  }, [_vm._v("Apply")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row mt-3",
    staticStyle: {
      "justify-content": "space-between",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Estimated COGS for " + _vm._s(_vm.currentMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.currentMthCOGS)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Estimated COGS for " + _vm._s(_vm.nextMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.nextMthCOGS)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Estimated COGS " + _vm._s(_vm.showFilterDate))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsEstimate)))])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.openMoreDetailsDialog
    }
  }, [_vm._v("\n            More Details\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _vm._l((_vm.monthsData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "campaign-cogs-section",
      attrs: {
        "id": item.name
      }
    }, [_c('v-expansion-panels', {
      staticClass: "expansion-panels mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (item.panel),
        callback: function($$v) {
          _vm.$set(item, "panel", $$v)
        },
        expression: "item.panel"
      }
    }, [_c('v-expansion-panel', {
      staticClass: "expansion-panel-main",
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "expansion-panel-header"
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(_vm.formatTitle(item.month)))])]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "expansion-panel-content"
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-row', {
      staticClass: "action-section mb-3"
    }, [_c('v-col', {
      staticClass: "action-group-section pl-0",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "gap": "3px"
      }
    }, [_c('div', [(item.selectedCOGS && item.selectedCOGS.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openTotalSummaryDialog(item.selectedCOGS)
        }
      }
    }, [_vm._v("View Summary (" + _vm._s(item.selectedCOGS.length) + ")")]) : _vm._e()], 1)])]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-right float-right"
    }, [_c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      model: {
        value: (item.filter),
        callback: function($$v) {
          _vm.$set(item, "filter", $$v)
        },
        expression: "item.filter"
      }
    })], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      ref: "CreatorCogsTable",
      refInFor: true,
      staticClass: "creator-cogs-table elevation-1",
      attrs: {
        "headers": _vm.computedHeaders,
        "search": item.filter,
        "items": item.data,
        "items-per-page": 15,
        "show-select": "",
        "single-select": false
      },
      on: {
        "current-items": _vm.getFiltered
      },
      scopedSlots: _vm._u([{
        key: "item.estimatedLiveDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.estimatedLiveDate) ? _c('span', [_vm._v(_vm._s(item.estimatedLiveDate ? _vm.formatYM(item.estimatedLiveDate) : ''))]) : _vm._e()])]
        }
      }, {
        key: "item.liveDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.liveDate && item.liveDate !== 'Invalid date') ? _c('span', [_vm._v(_vm._s(item.liveDate ? _vm.formatDate(item.liveDate) : ''))]) : _vm._e()])]
        }
      }, {
        key: "item.submissionDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.submissionDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDMY(item.submissionDate) !== 'Invalid date' ? _vm.formatDMY(item.submissionDate) : ''))]) : _vm._e()])]
        }
      }, {
        key: "item.handle",
        fn: function(ref) {
          var item = ref.item;

          return [(item.handle) ? _c('div', {
            class: item.duplicate ? 'text-duplicate' : ''
          }, [_c('social-handle', {
            attrs: {
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isYoutube": item.platform === 'youtube',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.handle,
              "instagramHandle": item.handle,
              "youtubeHandle": item.handle,
              "otherHandle": item.handle
            }
          })], 1) : _vm._e()]
        }
      }, {
        key: "item.country",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.country) ? _c('span', [_vm._v(_vm._s(item.country))]) : _vm._e()])]
        }
      }, {
        key: "item.bankName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.bankName) ? _c('span', [_vm._v(_vm._s(item.bankName))]) : _vm._e()])]
        }
      }, {
        key: "item.swiftCode",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.swiftCode) ? _c('span', [_vm._v(_vm._s(item.swiftCode))]) : _vm._e()])]
        }
      }, {
        key: "item.bankAccount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.bankAccount) ? _c('span', [_vm._v(_vm._s(item.bankAccount))]) : _vm._e()])]
        }
      }, {
        key: "item.username",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.username) ? _c('span', [_vm._v(_vm._s(item.username))]) : _vm._e()])]
        }
      }, {
        key: "item.email",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.email) ? _c('span', [_vm._v(_vm._s(item.email))]) : _vm._e()])]
        }
      }, {
        key: "item.amount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-left' : 'text-left',
            staticStyle: {
              "min-width": "120px"
            }
          }, [(!item.pairing && (item.amount || item.amount === 0)) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e(), _vm._v(" "), (item.pairing && item.GSTpercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                            " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")((item.amount - item.GSTpercent))) + "\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")((item.amount - item.GSTpercent))))])])], 1) : _vm._e(), _vm._v(" "), (item.pairing && !item.GSTpercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                              " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimate SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e()])]
        }
      }, {
        key: "item.GSTAmount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "80px!important"
            }
          }, [(item.GSTAmount) ? _c('span', [_vm._v("$" + _vm._s(item.GSTAmount))]) : _vm._e()])]
        }
      }, {
        key: "item.GSTExcludedAmt",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.GSTExcludedAmt || item.GSTExcludedAmt === 0) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                              " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTExcludedAmt)) + "\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTExcludedAmt)))]), _c('br'), _vm._v(" "), (item.sgdGstIncluded) ? _c('span', [_vm._v("Estimate SGD: " + _vm._s(item.sgdGstIncluded))]) : _vm._e()])], 1) : _vm._e()])]
        }
      }, {
        key: "item.campaignName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "130px!important"
            }
          }, [(item.campaignName) ? _c('span', [_vm._v(_vm._s(item.campaignName))]) : _vm._e()])]
        }
      }, {
        key: "item.clientName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.clientName) ? _c('span', [_vm._v(_vm._s(item.clientName))]) : _vm._e()])]
        }
      }, {
        key: "item.IONumber",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.IONumber) ? _c('span', [_vm._v(_vm._s(item.IONumber))]) : _vm._e()])]
        }
      }, {
        key: "item.CC",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate' : 'text-start'
          }, [(item.CC) ? _c('span', [_vm._v(_vm._s(item.CC))]) : _vm._e()])]
        }
      }, {
        key: "item.duplicate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate' : 'text-start'
          }, [_c('div', {
            staticClass: "text-center"
          }, [_c('v-checkbox', {
            staticClass: "mt-0 pr-4",
            attrs: {
              "label": "",
              "color": "red",
              "value": false,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeDuplicate(item, item.duplicate)
              }
            },
            model: {
              value: (item.duplicate),
              callback: function($$v) {
                _vm.$set(item, "duplicate", $$v)
              },
              expression: "item.duplicate"
            }
          })], 1)])]
        }
      }, {
        key: "item.estimationType",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start"
          }, [_c('span', [_vm._v(_vm._s(item.estimationType))]), _vm._v(" "), (item.customType) ? _c('p', [_vm._v("(" + _vm._s(item.customType) + ")")]) : _vm._e()])]
        }
      }, {
        key: "item.remarks",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate' : 'text-start'
          }, [(item.remarks) ? _c('span', [_vm._v(_vm._s(item.remarks))]) : _vm._e()])]
        }
      }, {
        key: "item.invoices",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "120px"
            }
          }, [(item.invoices) ? _c('div', {
            staticClass: "w-100 pt-1"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "btn-payment-action",
                  attrs: {
                    "color": "warning",
                    "dark": "",
                    "small": "",
                    "text": ""
                  }
                }, on), [_vm._v("\n                              View\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.invoices), function(invoice, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "href": invoice.url,
                "target": "_blank"
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(invoice.name))])], 1)
          }), 1)], 1)], 1) : _vm._e()])]
        }
      }, {
        key: "item.action",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "120px"
            }
          }, [_c('div', {
            staticClass: "w-100 pt-1"
          }, [_c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "warning"
            },
            on: {
              "click": function($event) {
                return _vm.viewEditDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Edit Campaign"
            }
          }, [_vm._v("edit")])], 1)], 1)])]
        }
      }], null, true),
      model: {
        value: (item.selectedCOGS),
        callback: function($$v) {
          _vm.$set(item, "selectedCOGS", $$v)
        },
        expression: "item.selectedCOGS"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('create-cogs-estimate-modal', {
    attrs: {
      "editItem": _vm.editCogsEstimate,
      "value": _vm.createCogsEstimateDialog
    },
    on: {
      "created": _vm.getCogsEstimation
    },
    model: {
      value: (_vm.createCogsEstimateDialog),
      callback: function($$v) {
        _vm.createCogsEstimateDialog = $$v
      },
      expression: "createCogsEstimateDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "COGS Estimation",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.revsForMonthYear.length) ? _c('more-details-modal', {
    attrs: {
      "value": _vm.moreDetailsDialog,
      "monthYearValues": _vm.revsForMonthYear
    },
    model: {
      value: (_vm.moreDetailsDialog),
      callback: function($$v) {
        _vm.moreDetailsDialog = $$v
      },
      expression: "moreDetailsDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('total-summary-modal', {
    attrs: {
      "value": _vm.totalSummaryDialog,
      "selectedCOGS": _vm.selectedCOGS
    },
    model: {
      value: (_vm.totalSummaryDialog),
      callback: function($$v) {
        _vm.totalSummaryDialog = $$v
      },
      expression: "totalSummaryDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-icon', {
    staticClass: "cursor-pointer",
    attrs: {
      "title": "Update"
    }
  }, [_vm._v("edit")]), _vm._v(" \n        "), _c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("Edit Distribution")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "min-width": "95px"
    },
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "2"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label font-weight-bold mb-0"
  }, [_vm._v("Amount: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "disabled": _vm.resetEdit,
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.amount),
      callback: function($$v) {
        _vm.$set(_vm.editData, "amount", $$v)
      },
      expression: "editData.amount"
    }
  }), _vm._v(" "), (this.editData.editedCheck) ? _c('v-btn', {
    staticClass: "warning ml-2",
    on: {
      "click": _vm.resetEditedMonth
    }
  }, [_vm._v("Reset")]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "min-width": "95px"
    },
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "2"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label font-weight-bold mb-0"
  }, [_vm._v("Recorded:")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "8",
      "sm": "8"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "",
      "color": "secondary",
      "true-value": true,
      "false-value": false,
      "hide-details": ""
    },
    model: {
      value: (_vm.editData.recordCheck),
      callback: function($$v) {
        _vm.$set(_vm.editData, "recordCheck", $$v)
      },
      expression: "editData.recordCheck"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    staticStyle: {
      "max-width": "95px"
    },
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label font-weight-bold mb-0"
  }, [_vm._v("Remarks : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "placeholder": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.editData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.editData, "remarks", $$v)
      },
      expression: "editData.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Timestamp")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Recorded")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")])])]), _vm._v(" "), _c('tbody', [(!_vm.editItem.editHistory.length) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Empty List")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editItem.editHistory), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(item.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.recorded ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks || ''))])])
        })], 2)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": !_vm.editData.amount && !_vm.resetEdit,
      "text": ""
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Map the Influencer on behalf\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [(_vm.postData) ? _c('p', [_vm._v("\n        The post is submitted by \n        "), (_vm.postData.submitedBy && _vm.postData.submitedBy.tiktokHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.tiktokHandle))]) : (_vm.postData.submitedBy && _vm.postData.submitedBy.youtubeHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.youtubeHandle))]) : (_vm.postData.submitedBy && _vm.postData.submitedBy.linkedinHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.linkedinHandle))]) : (_vm.postData.submitedBy && _vm.postData.submitedBy.instagramHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.instagramHandle))]) : _c('strong', [_vm._v("-")]), _vm._v("\n        for the "), _c('strong', [_vm._v(_vm._s(_vm.postData.campaignName))]), _vm._v(" campaign.\n      ")]) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Instagram",
      "value": "instagram"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "TikTok",
      "value": "tiktok"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Youtube",
      "value": "youtube"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "LinkedIn",
      "value": "linkedin"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prefix": "@",
      "label": "Handle",
      "block": "",
      "disabled": _vm.isValidating,
      "outlined": ""
    },
    model: {
      value: (_vm.handle),
      callback: function($$v) {
        _vm.handle = $$v
      },
      expression: "handle"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveMappedInfluencer()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    staticStyle: {
      "min-height": "80px"
    },
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [(_vm.campaignList.length) ? _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "searchText"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item === Object(item)) ? _c('div', {
          staticClass: "campaign-payment-selection"
        }, [_c('span', {
          staticClass: "campaign-payment-selection__name"
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.ioNumber) ? _c('span', {
          staticClass: "campaign-payment-selection__io"
        }, [_vm._v(_vm._s(item.ioNumber))]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('CampaignListPaymentStatus', {
          attrs: {
            "item": item
          }
        })]
      }
    }], null, false, 1131324621),
    model: {
      value: (_vm.campaignID),
      callback: function($$v) {
        _vm.campaignID = $$v
      },
      expression: "campaignID"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "height": "56px"
    },
    attrs: {
      "disabled": !_vm.campaignID,
      "small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.getPairedInfluencers(_vm.campaignID, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-cached")]), _vm._v(" Refresh\n      ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [(_vm.campaignCOEB && _vm.campaignCOEB.campaignId) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#CFD8DC"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Campaign Name: " + _vm._s(_vm.campaignCOEB.campaignName || 'N/A') + "\n          "), (_vm.campaignCOEB.lockedCOGS) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Client Name: " + _vm._s(_vm.campaignCOEB.clientName || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pt-2"
  }, [_vm._v("\n          IO Number: " + _vm._s(_vm.campaignCOEB.ioNumbers || 'N/A') + "\n        ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-2 flex-row-reverse",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.briefConfirmationSearch),
      callback: function($$v) {
        _vm.briefConfirmationSearch = $$v
      },
      expression: "briefConfirmationSearch"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.pairedHeaders,
      "items": _vm.pairedInfluencers,
      "items-per-page": -1,
      "search": _vm.briefConfirmationSearch,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', [(props.items && props.items.length === 0) ? _c('tr', [_c('td', [_vm._v("No Data")])]) : _vm._e(), _vm._v(" "), _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.influencer_details.instagramHandle
          }, [_c('td', [_c('div', {
            staticClass: "payment-status-handle"
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "isLinkedIn": item.influencer_details.platform === 'linkedin',
              "isTwitter": item.influencer_details.platform === 'twitter',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isXiaohongshu": item.influencer_details.platform === 'xiaohongshu',
              "isOthers": item.influencer_details.platform === 'others',
              "tiktokHandle": item.influencer_details.instagramHandle,
              "instagramHandle": item.influencer_details.instagramHandle,
              "facebookHandle": _vm.getPlatformHandle(item.influencer_details, 'facebook'),
              "linkedinHandle": item.influencer_details.linkedinHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle,
              "twitterHandle": _vm.getPlatformHandle(item.influencer_details, 'twitter'),
              "youtubeHandle": item.influencer_details.instagramHandle,
              "youtubeURL": item.influencer_details.url,
              "xiaohongshuHandle": item.influencer_details.xhsID,
              "xiaohongshuFullName": item.influencer_details.fullName,
              "otherHandle": item.influencer_details.instagramHandle
            }
          }), _vm._v(" "), (item.influencer_details && item.influencer_details.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "ml-1",
                  attrs: {
                    "color": "green",
                    "small": ""
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "ml-1",
                  attrs: {
                    "color": "red",
                    "small": ""
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not registered in IMS")])])], 1), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "secondary",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.linkedin) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#0A66C2",
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.twitter) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "",
                "aria-hidden": "true"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDeliverableDetails(item.deliverablesDisplay)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDeliverableCounts(item.producedDeliverables)))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(!item.GSTIncluded) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt && !Number.isNaN(Number(item.sgdAmt)) ? item.sgdAmt : ""))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.GSTIncluded) ? _c('span', {
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": _vm.displayGSTText(item)
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt && !Number.isNaN(Number(item.sgdAmt)) ? item.sgdAmt : ""))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.GSTIncluded) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              "title": "GST Included"
            }
          }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.formatSubmissionDate(item.pairing_details.submission_date)))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "min-width": "12rem"
            }
          }, [_c('div', [(item.payout_details && item.payout_details.status !== _vm.payoutStatus.CONFIRMED && !_vm.isAM) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "primary",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updateSend(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("new_releases")]), _vm._v(" Confirm Payout\n                  ")], 1) : _vm._e(), _vm._v(" "), (item.payout_details && item.payout_details.status === _vm.payoutStatus.CONFIRMED) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "left": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v("Confirmed\n                  ")], 1) : _vm._e(), _vm._v(" "), (item.payout_details && item.payout_details.status === _vm.payoutStatus.CONFIRMED && !_vm.isAM) ? _c('v-btn', {
            attrs: {
              "text": "",
              "small": "",
              "color": "error",
              "disabled": _vm.disableLockedCOGS
            },
            on: {
              "click": function($event) {
                return _vm.cancelPayout(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": "",
              "data-toggle": "tooltip",
              "data-placement": "button",
              "title": "Click to cancel Payout"
            }
          }, [_vm._v("mdi-cancel")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('div', [(!item.inReport) ? _c('v-chip', {
            attrs: {
              "color": "error",
              "outlined": "",
              "small": "",
              "to": ('/campaign-report-internal?id=' + _vm.campaignID),
              "target": "_blank",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Click to add contents to Report"
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "left": ""
            }
          }, _vm.on), [_vm._v("warning")]), _vm._v(" Pending in Report\n                  ")], 1) : _vm._e(), _vm._v(" "), (item.inReport) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": "",
              "to": ('/campaign-report-internal?id=' + _vm.campaignID),
              "target": "_blank"
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "left": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v(" Present in Report\n                  ")], 1) : _vm._e()], 1)]), _vm._v(" "), _c('td', _vm._l((item.paymentStatusDisplay), function(p, index) {
            return _c('div', {
              key: index,
              staticClass: "payment-status-list"
            }, [((p !== null && p.statusDisplay)) ? _c('v-chip', {
              staticClass: "payment-status-chip",
              class: ("payment-status-chip--" + (p.statusDisplay.value)),
              style: ({
                borderColor: p.statusDisplay.color || 'var(--ims-color-secondary)'
              }),
              attrs: {
                "outlined": "",
                "small": "",
                "to": ('/finance/payment-consolidation'),
                "target": "_blank"
              }
            }, [(p.imported) ? _c('v-tooltip', {
              attrs: {
                "bottom": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;

                  return [_c('span', _vm._g({
                    staticClass: "payment-status-imported-badge",
                    attrs: {
                      "aria-label": "Imported payment"
                    }
                  }, on), [_c('v-icon', {
                    staticClass: "payment-status-icon",
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v("mdi-newspaper-plus")])], 1)]
                }
              }], null, true)
            }, [_vm._v(" "), _c('span', [_vm._v("Imported payment")])]) : _vm._e(), _vm._v(" "), _c('span', {
              staticClass: "payment-status-label",
              style: ({
                color: p.statusDisplay.color || 'var(--ims-color-secondary)'
              })
            }, [_vm._v("\n                      " + _vm._s(p.statusDisplay.text) + "\n                    ")]), _vm._v(" "), _c('span', {
              staticClass: "payment-status-divider",
              attrs: {
                "aria-hidden": "true"
              }
            }), _vm._v(" "), (p.payConsAmt) ? _c('v-tooltip', {
              attrs: {
                "bottom": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;

                  return [_c('span', _vm._g({
                    staticClass: "payment-status-amount"
                  }, on), [_vm._v("\n                          " + _vm._s(_vm.utilsFunc.currencySym(p.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(p.payConsAmt)) + "\n                        ")])]
                }
              }], null, true)
            }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(p.currency) + " " + _vm._s(_vm._f("thousandSeprator")(p.payConsAmt)))]), _c('br'), _vm._v(" "), (p.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(p.sgdAmt && !Number.isNaN(Number(p.sgdAmt)) ? p.sgdAmt : ""))]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1)
          }), 0)])
        })], 2)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.dialog,
      "influencer": _vm.influencer,
      "influencerProfile": _vm.influencerProfile,
      "selectedTab": _vm.selectedTab,
      "briefDetailContent": _vm.briefDetailsHTML,
      "close": _vm.closeModal,
      "newPairingFlow": true,
      "isDownload": _vm.invoiceDownload
    },
    on: {
      "loadInfluencer": _vm.loadInfluencerData,
      "reRenderDatTable": _vm.loadInfluencerData,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-card-text', {
    staticClass: "loading-dialog-text"
  }, [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-editor', {
    staticStyle: {
      "height": "600px"
    },
    attrs: {
      "useCustomImageHandler": "",
      "editorOptions": _vm.editorSettings
    },
    on: {
      "image-added": _vm.handleImageAdded
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('cogs-summary-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n        View Influencer\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "overflow": "hidden",
      "margin-top": "10px",
      "min-height": "35px"
    }
  }, [_c('div', [_c('v-row', {
    staticClass: "text-right"
  }, [_c('v-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [(_vm.isViewMode) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeModeCustom('edit')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("edit")]), _vm._v("\n                Edit\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeModeCustom('view')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("close")]), _vm._v("\n                Cancel Edit\n              ")], 1) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "700px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isViewMode),
      expression: "isViewMode"
    }]
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openExpansion),
      callback: function($$v) {
        _vm.openExpansion = $$v
      },
      expression: "openExpansion"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n                  Contact Information\n                ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Instagram Handle")]), _vm._v(" "), (_vm.influencer.instagram) ? _c('social-handle', {
    attrs: {
      "isInstagram": _vm.influencer.instagram ? true : false,
      "instagramHandle": _vm.influencer.instagram ? _vm.influencer.instagram.instagramHandle : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("TikTok Handle")]), _vm._v(" "), (_vm.influencer.tiktok) ? _c('social-handle', {
    attrs: {
      "isTikTok": _vm.influencer.tiktok ? true : false,
      "tiktokHandle": _vm.influencer.tiktok ? _vm.influencer.tiktok.tiktokHandle : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Youtube Handle")]), _vm._v(" "), (_vm.influencer.youtube) ? _c('social-handle', {
    attrs: {
      "isYoutube": _vm.influencer.youtube ? true : false,
      "youtubeHandle": _vm.influencer.youtube ? _vm.influencer.youtube.youtubeHandle : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Facebook Handle")]), _vm._v(" "), (_vm.influencer.facebook) ? _c('social-handle', {
    attrs: {
      "isFacebook": _vm.influencer.facebook ? true : false,
      "facebookHandle": _vm.influencer.facebook ? _vm.influencer.facebook.handle : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("XHS Handle")]), _vm._v(" "), (_vm.influencer.xiaohongshu) ? _c('social-handle', {
    attrs: {
      "isXiaohongshu": _vm.influencer.xiaohongshu ? true : false,
      "xiaohongshuHandle": _vm.influencer.xiaohongshu ? _vm.influencer.xiaohongshu.xhsHandle : '',
      "xiaohongshuFullName": _vm.influencer.xiaohongshu ? _vm.influencer.xiaohongshu.xhsFullname : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("LinkedIn Handle")]), _vm._v(" "), (_vm.influencer.linkedin && _vm.influencer.linkedin.linkedinHandle) ? _c('social-handle', {
    attrs: {
      "isLinkedIn": true,
      "linkedinHandle": _vm.influencer.linkedin ? _vm.influencer.linkedin.linkedinHandle : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("X (Twitter) Handle")]), _vm._v(" "), (_vm.influencer.twitter && _vm.influencer.twitter.twitterHandle) ? _c('social-handle', {
    attrs: {
      "isTwitter": true,
      "twitterHandle": _vm.influencer.twitter ? _vm.influencer.twitter.twitterHandle : ''
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Fullname")]), _vm._v(" "), (_vm.influencer.fullName) ? _c('div', [_vm._v(_vm._s(_vm.influencer.fullName))]) : _c('div', [(_vm.influencer.tiktok) ? _c('div', [_vm._v(_vm._s((_vm.influencer.tiktok.tiktokFullname ? _vm.influencer.tiktok.tiktokFullname : '-')))]) : (_vm.influencer.youtube) ? _c('div', [_vm._v(_vm._s((_vm.influencer.youtube.youtubeFullname ? _vm.influencer.youtube.youtubeFullname : '-')))]) : (_vm.influencer.facebook) ? _c('div', [_vm._v(_vm._s((_vm.influencer.facebook.name ? _vm.influencer.facebook.name : '-')))]) : (_vm.influencer.xiaohongshu) ? _c('div', [_vm._v(_vm._s((_vm.influencer.xiaohongshu.xhsFullname ? _vm.influencer.xiaohongshu.xhsFullname : '-')))]) : (_vm.influencer.linkedin) ? _c('div', [_vm._v(_vm._s((_vm.influencer.linkedin.linkedinFullname ? _vm.influencer.linkedin.linkedinFullname : '-')))]) : (_vm.influencer.twitter) ? _c('div', [_vm._v(_vm._s((_vm.influencer.twitter.twitterFullname ? _vm.influencer.twitter.twitterFullname : '-')))]) : _c('div', [_vm._v(_vm._s(_vm.influencer.instagram ? (_vm.influencer.instagram.instagramFullname ? _vm.influencer.instagram.instagramFullname : '-') : '-'))])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.email ? _vm.influencer.email : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.phone ? _vm.influencer.phone : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("What is your occupation?")]), _vm._v(" "), _c('div', [_vm._v("\n                        " + _vm._s(_vm.inputedRates.occupation || '-') + "\n                      ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n                  Billing Information\n                ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Bank name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.bankName ? _vm.influencer.bankName : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Swift code")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.swiftCode ? _vm.influencer.swiftCode : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Bank account")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.bankAccount ? _vm.influencer.bankAccount : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Fullname as per Bank Account")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.fullName ? _vm.influencer.fullName : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.country ? _vm.influencer.country : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Street address")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.mailingAddress ? _vm.influencer.mailingAddress : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Postal Code")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.postalCode ? _vm.influencer.postalCode : '-')))])])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n                  Your Rates "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "margin-left": "5px"
    }
  }, [_vm._v("(in SGD per item)")])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Influencer Handle")]), _vm._v(" "), (_vm.inputedRates.instagramHandle) ? _c('social-handle', {
    attrs: {
      "isInstagram": true,
      "instagramHandle": _vm.inputedRates.instagramHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inputedRates.instagramHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Tiktok Handle")]), _vm._v(" "), (_vm.inputedRates.tiktokHandle) ? _c('social-handle', {
    attrs: {
      "isTikTok": true,
      "tiktokHandle": _vm.inputedRates.tiktokHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.inputedRates.tiktokHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Story")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igStory || '-'))]), _vm._v(" "), (_vm.inputedRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.igStoryCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igPost || '-'))]), _vm._v(" "), (_vm.inputedRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.igPostCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igCarousel || '-'))]), _vm._v(" "), (_vm.inputedRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.igCarouselCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Reel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.igReel || '-'))]), _vm._v(" "), (_vm.inputedRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.igReelCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Loading Fee")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.loadingFee || '-'))]), _vm._v(" "), (_vm.inputedRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Event Appearance")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.inputedRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (Instagram)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.inputedRates.igRemarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "tiktok-stats",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Tiktok")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.inputedRates.tiktok || '-'))]), _vm._v(" "), (_vm.inputedRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.inputedRates.tiktokCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (TikTok)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.inputedRates.tiktokRemarks || '-'))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-divider', {
    staticClass: "ma-0"
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Handle of Other Platforms")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Platform")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inputedRates.platforms), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v("\n                                    " + _vm._s(item.platform) + "\n                                    "), (item.platform === 'others') ? _c('span', [_vm._v(_vm._s(item.otherPlatform))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.rate) ? _c('span', [_vm._v(_vm._s(item.rateCurrency || 'SGD'))]) : _vm._e()])])
        }), 0)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), (_vm.inputedRates.pricingDecks && _vm.inputedRates.pricingDecks.length > 0) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Media Kit")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.inputedRates.pricingDecks
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n                  Additional Information\n                ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.userGender_options[_vm.influencer.gender] ? _vm.userGender_options[_vm.influencer.gender] : '-')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Birthday")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.birthday ? _vm.influencer.birthday : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.isMainPlatform('linkedin') ? 'Followers (Connections)' : 'Followers'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getSocialMetric('totalFollowers')))])]), _vm._v(" "), (!_vm.isMainPlatform('linkedin')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Following")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getSocialMetric('totalFollowing')))])]) : _vm._e(), _vm._v(" "), (_vm.influencer.xiaohongshu && _vm.influencer.xiaohongshu.xiaohongshu) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Total Likes/Favourites")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.influencer.xiaohongshu ? _vm.influencer.xiaohongshu.xiaohongshu.totalLikesFavourites : '-')))])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('label', [_vm._v("Preferred type of campaigns/genre")]), _vm._v(" "), _c('div', _vm._l((_vm.formatInfKeywords(_vm.influencer.keywords)), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  }), 1)])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("About You")]), _vm._v(" "), _c('div', [_vm._v("\n                        " + _vm._s(_vm.inputedRates.aboutYou || '-') + "\n                      ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s((_vm.inputedRates.clientType ? _vm.inputedRates.clientType : '-')))]), _vm._v(" "), _c('div', [_vm._v("\n                        " + _vm._s((_vm.inputedRates.agencyName ? _vm.inputedRates.agencyName : '-')) + "\n                      ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("\n                  Travel Information\n                ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', _vm._l((_vm.influencer.tallySub), function(tallyForm, title) {
    return (!_vm.excludeTitles.includes(title) && tallyForm !== null) ? _c('v-col', {
      key: title,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('label', [_vm._v(_vm._s(title))]), _vm._v(" "), (Array.isArray(tallyForm)) ? _c('div', [_vm._v("\n                        " + _vm._s(tallyForm.join(', ') || '-') + "\n                      ")]) : _c('div', [_vm._v("\n                        " + _vm._s(tallyForm || '-') + "\n                      ")])]) : _vm._e()
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditMode),
      expression: "isEditMode"
    }]
  }, [_c('edit-influencer-modal', {
    attrs: {
      "influencerData": _vm.editInfluencerData,
      "processEdit": _vm.processEdit
    },
    on: {
      "showLoading": _vm.showLoading,
      "closeModal": _vm.close
    }
  })], 1)]), _vm._v(" "), (_vm.isViewMode) ? _c('v-card-actions', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn btn-default text--secondary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logoPrimary
    }
  })]), _vm._v(" "), _c('v-card-text', {
    staticClass: "center-block"
  }, [_c('p', {
    staticClass: "user-reset"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('b-card', {
    attrs: {
      "bg-variant": "light"
    }
  }, [_c('div', {
    class: {
      'has-error': (_vm.$v.user.password.$error && _vm.$v.user.password.$dirty)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "New Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }, function($event) {
        return _vm.$v.user.password.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.user.password.$error && _vm.$v.user.password.$dirty) ? _c('div', [(!_vm.$v.user.password.required) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please enter new password")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.password.validPassword) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Password must contain number, uppercase, lowercase, special symbols and more than 8 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'has-error': _vm.$v.user.repeatPassword.$error && _vm.$v.user.repeatPassword.$dirty
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.repeatPassword),
      expression: "user.repeatPassword"
    }],
    staticClass: "margin-top-5 form-control",
    attrs: {
      "type": "password",
      "placeholder": "Repeat Password"
    },
    domProps: {
      "value": (_vm.user.repeatPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "repeatPassword", $event.target.value)
      }, function($event) {
        return _vm.$v.user.repeatPassword.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.user.repeatPassword.sameAsPassword && _vm.$v.user.repeatPassword.$error) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Password is not matched")]) : _vm._e()]), _vm._v(" "), _c('b-button', {
    staticClass: "margin-top-5",
    attrs: {
      "block": "",
      "type": "submit",
      "variant": "primary"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedTab >= 0) ? _c('v-dialog', {
    attrs: {
      "fullscreen": !_vm.newPairingFlow || _vm.selectedTab === 1,
      "max-width": _vm.modalMaxWidth,
      "hide-overlay": !_vm.newPairingFlow,
      "persistent": "",
      "scrollable": "",
      "no-click-animation": !_vm.newPairingFlow
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticStyle: {
      "max-height": "64px"
    },
    attrs: {
      "dark": "",
      "flat": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeModel
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [(!_vm.newPairingFlow) ? _c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "50px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "sm": "4",
      "md": "4",
      "lg": "4",
      "align": "center"
    }
  }, [_c('div', [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "src": _vm.profilePicture,
      "width": "130px",
      "height": "130px"
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "d-none d-sm-flex",
    attrs: {
      "cols": "12",
      "xs": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "40px",
      "margin-bottom": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(("" + (_vm.influencer.userHandle))))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(((_vm.influencer.followers) + " followers")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.audience_credibility) + " AC")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.engagement_rate) + " ER")))]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.fullName))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [(_vm.influencer.status === this.pairingStatus.ACCEPTED.value) ? _c('div', [(_vm.influencer.agreement) ? _c('div', [(_vm.influencer.agreement.isAgree !== undefined) ? _c('div', [(_vm.influencer.agreement.isAgree) ? _c('v-chip', {
    attrs: {
      "color": "success",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                            Agreed\n                          ")]) : _c('v-chip', {
    attrs: {
      "color": "red",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                            Declined\n                          ")])], 1) : _c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.influencer.status_description) + "\n                        ")])], 1) : _c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.influencer.status_description) + "\n                      ")])], 1) : _c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.influencer.status_description) + "\n                      ")])], 1)])]), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex d-sm-none",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "40px",
      "margin-bottom": "50px",
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(("" + (_vm.influencer.userHandle))))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(((_vm.influencer.followers) + " followers")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.audience_credibility) + " AC")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.engagement_rate) + " ER")))]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.fullName))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.influencer.status_description) + "\n                      ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pendingStatus && !_vm.acceptedStatus && !_vm.notAcceptedStatus),
      expression: "!pendingStatus && !acceptedStatus && !notAcceptedStatus"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.approvedClick()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notAcceptedStatus),
      expression: "!notAcceptedStatus"
    }],
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.notAccepted()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notInterestedStatus),
      expression: "notInterestedStatus"
    }],
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "primary"
    }
  }, [_vm._v("\n                  Convince"), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-help")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingStatus),
      expression: "pendingStatus"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.approvedClick()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notAcceptedStatus),
      expression: "!notAcceptedStatus"
    }],
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.notAccepted()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.followUp()
      }
    }
  }, [_vm._v("\n                  Follow Up"), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-help")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.newPairingFlow) ? _c('hr', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "width": "90%"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabShow),
      expression: "tabShow"
    }],
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPairingFlow),
      expression: "!newPairingFlow"
    }]
  }, [_vm._v("\n                Detail\n              ")]), _vm._v(" "), (_vm.inquiryStatus) ? _c('v-tab', [_vm._v("\n                Q&A\n              ")]) : _vm._e(), _vm._v(" "), (_vm.notInterestedStatus) ? _c('v-tab', [_vm._v("\n                Reject reasons\n              ")]) : _vm._e(), _vm._v(" "), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.interestedStatus || _vm.pendingStatus || _vm.acceptedStatus) && !_vm.newPairingFlow),
      expression: "(interestedStatus || pendingStatus || acceptedStatus) && !newPairingFlow"
    }]
  }, [_vm._v("\n                Brief detail\n              ")]), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": _vm.newPairingFlow ? 12 : 6,
      "lg": _vm.newPairingFlow ? 12 : 6
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Campaign")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                          " + _vm._s(("" + (_vm.influencer.CampaignName))) + "\n                          "), _c('v-divider'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.influencer.deliverables),
      expression: "this.influencer.deliverables"
    }]
  }, [_c('h4', [_vm._v("Deliverables")]), _vm._v(" "), _c('lu', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfTikTokPost > 0),
      expression: "numberOfTikTokPost > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfTikTokPost))]), _vm._v(" x TikTok Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfXHSPost > 0),
      expression: "numberOfXHSPost > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfXHSPost))]), _vm._v(" x XHS Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfPost > 0),
      expression: "numberOfPost > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfPost))]), _vm._v(" x Instagram Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfCarousels > 0),
      expression: "numberOfCarousels > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfCarousels))]), _vm._v(" x Instagram Carousels Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfStories > 0),
      expression: "numberOfStories > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfStories))]), _vm._v(" x Instagram Stories")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfVideo > 0),
      expression: "numberOfVideo > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfVideo))]), _vm._v(" x Instagram Video")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfIGReels > 0),
      expression: "numberOfIGReels > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfIGReels))]), _vm._v(" x Instagram Reel")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfLinkedInPosts > 0),
      expression: "numberOfLinkedInPosts > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfLinkedInPosts))]), _vm._v(" x LinkedIn Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfXPosts > 0),
      expression: "numberOfXPosts > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfXPosts))]), _vm._v(" x X (Twitter) Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfYoutube > 0),
      expression: "numberOfYoutube > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfYoutube))]), _vm._v(" x Youtube")]), _vm._v(" "), (_vm.isLoadingWhitelist) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.influencer.deliverables.loading_whitelisting))]), _vm._v(" x Loading/Whitelisting")]) : _vm._e(), _vm._v(" "), (_vm.isExclusivity) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.influencer.deliverables.exclusivity))]), _vm._v(" x Exclusivity")]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfPA > 0),
      expression: "numberOfPA > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfPA))]), _vm._v(" x Physical Attendance")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfOA > 0),
      expression: "numberOfOA > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfOA))]), _vm._v(" x Online Attendance")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.influencer.deliverables) ? _c('div', _vm._l((_vm.influencer.deliverables.custom), function(custom, pIndex) {
    return _c('v-list', {
      key: pIndex,
      staticClass: "pt-0 pb-0"
    }, [_c('v-list-item', {
      staticClass: "multiple-fields-area pt-0 pb-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row pt-2"
    }, [_c('div', [_c('v-text-field', {
      staticClass: "mutliple-field px-1",
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "placeholder": "Custom Deliverables"
      },
      model: {
        value: (custom.label),
        callback: function($$v) {
          _vm.$set(custom, "label", $$v)
        },
        expression: "custom.label"
      }
    })], 1), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "type": "number",
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "min": "1"
      },
      model: {
        value: (custom.value),
        callback: function($$v) {
          _vm.$set(custom, "value", _vm._n($$v))
        },
        expression: "custom.value"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "pt-5",
      attrs: {
        "color": "danger",
        "text": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.influencer.deliverables.custom.splice(pIndex, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-delete-forever")])], 1)], 1)])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "float-left"
  }, [_c('v-list-item', {
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.addCustom()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Custom Deliverable\n                                ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("Additional Line Items")]), _vm._v(" "), (_vm.influencer.payout_details) ? _c('div', {
    staticClass: "clearfix"
  }, [(_vm.influencer.payout_details.boostingFees) ? _c('div', _vm._l((_vm.influencer.payout_details.boostingFees), function(boostingFee, bIndex) {
    return _c('v-list', {
      key: bIndex,
      staticClass: "pt-0 pb-0"
    }, [_c('v-list-item', {
      staticClass: "multiple-fields-area pt-0 pb-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row pt-2"
    }, [_c('div', [_c('v-text-field', {
      staticClass: "mutliple-field px-1",
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "placeholder": "E.g. Boosting Fee"
      },
      model: {
        value: (boostingFee.label),
        callback: function($$v) {
          _vm.$set(boostingFee, "label", $$v)
        },
        expression: "boostingFee.label"
      }
    })], 1), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "type": "number",
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "min": "0",
        "step": "0.01"
      },
      on: {
        "input": function($event) {
          return _vm.updateTotalPayoutWithBoostingFee(boostingFee.value)
        }
      },
      model: {
        value: (boostingFee.value),
        callback: function($$v) {
          _vm.$set(boostingFee, "value", _vm._n($$v))
        },
        expression: "boostingFee.value"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "pt-5",
      attrs: {
        "color": "danger",
        "text": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteBoostingFees(bIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-delete-forever")])], 1)], 1)])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "float-left"
  }, [_c('v-list-item', {
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.addBoostingFee()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Additional Line Item\n                                ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "pa-0"
  }, [_c('li', {
    staticClass: "mt-2",
    staticStyle: {
      "list-style": "none"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.deliverableNotes),
      callback: function($$v) {
        _vm.deliverableNotes = $$v
      },
      expression: "deliverableNotes"
    }
  })], 1)]), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('h4', [_vm._v("Payout Amount")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-combobox', {
    staticStyle: {
      "max-width": "100px",
      "font-size": "20px"
    },
    attrs: {
      "items": _vm.currencies,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.currency),
      callback: function($$v) {
        _vm.currency = $$v
      },
      expression: "currency"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "400",
      "color": "green",
      "padding-top": "7px",
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.totalPayout))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('container', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('h4', [_vm._v("Submission Date")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": _vm.submissionDateFormatted,
            "label": "",
            "prepend-icon": "mdi-calendar",
            "hint": "DD/MM/YYYY format",
            "readonly": ""
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 1854811427),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.submissionDate),
      callback: function($$v) {
        _vm.submissionDate = $$v
      },
      expression: "submissionDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Include GST 9%"
    },
    model: {
      value: (_vm.chkGST),
      callback: function($$v) {
        _vm.chkGST = $$v
      },
      expression: "chkGST"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0 pt-0"
  }, [_c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Special Payment Terms"
    },
    model: {
      value: (_vm.chkSpecialPaymentTerms),
      callback: function($$v) {
        _vm.chkSpecialPaymentTerms = $$v
      },
      expression: "chkSpecialPaymentTerms"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('h4', [_vm._v("Remarks")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.invoiceRemarks),
      callback: function($$v) {
        _vm.invoiceRemarks = $$v
      },
      expression: "invoiceRemarks"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaignBackground),
      expression: "campaignBackground"
    }],
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Campaign Background")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.campaignBackground))])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.inquiryStatus) ? _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('QandA', {
    attrs: {
      "Questions": _vm.loadAllQuestions,
      "campaignID": _vm.influencer.CampaignID,
      "influencerID": _vm.influencer.influencer_details.influencerID,
      "TriggerEmail": true,
      "pairedID": _vm.influencer.id
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.notInterestedStatus) ? _c('v-tab-item', [_c('v-card', {
    staticStyle: {
      "width": "600px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "50px",
      "margin-bottom": "20px"
    }
  }, [_c('v-card-title', [_vm._v("Reasons")]), _vm._v(" "), _c('v-card-text', [_c('div', [(_vm.rejectReasons) ? _c('ul', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "300"
    }
  }, [(_vm.rejectReasons.campaign_proposed) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_proposed))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.campaign_timeline) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_timeline))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.payout_issue) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.payout_issue))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.competitor) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.competitor))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.not_associate) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.not_associate))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.others) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.others))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.co_reject) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.co_reject))]) : _vm._e()]) : _vm._e()])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tab-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row"
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "width": "200"
    },
    on: {
      "click": _vm.restoreCampaignBrief
    }
  }, [_vm._v("Reset as Campaign Brief")])], 1)], 1), _vm._v(" "), _c('sun-editor', {
    staticStyle: {
      "height": "650px"
    },
    attrs: {
      "width": "100%",
      "content": _vm.briefDetailContentNew,
      "editorOpened": _vm.editorOpened,
      "source": "brief"
    },
    on: {
      "contentChanged": _vm.changeBriefContent,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  })], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    staticClass: "editor-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1 white--text",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download\n                      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "width": "200"
    },
    on: {
      "click": _vm.briefDetailSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.closeModel
    }
  }, [_vm._v("\n                      Close\n                      ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.acceptedStatus) ? _c('v-tab-item', [_c('v-container', {
    staticStyle: {
      "max-width": "850px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "50px",
      "margin-left": "auto,margin-right:auto"
    },
    domProps: {
      "innerHTML": _vm._s(this.briefDetail)
    }
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.selectedTab === 0) ? _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('div', [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.updateSubmission
    }
  }, [_vm._v("\n                    Save\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Close\n                  ")])], 1)])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n            Close\n          ")])]
      }
    }], null, false, 667378165),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarText) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('influencer-contract-modal', {
    attrs: {
      "dialogTitle": "Invoice",
      "dialog": _vm.showContractModal,
      "close": _vm.closeInfluencerContractModal,
      "contract": _vm.influencerContract,
      "invoiceContract": _vm.invoiceContract,
      "action": _vm.upatedApproved,
      "showTerms": false,
      "showSendButton": true,
      "showSubmitButton": false,
      "showDeclineButton": false,
      "showOptions": false,
      "showCancelButton": true,
      "emailTemplateHTML": _vm.emailTemplateHTML,
      "updateEmailTemplate": _vm.updateEmailTemplate,
      "content": this.briefDetailContent,
      "briefDetailHTML": this.briefDetail,
      "users": _vm.influencer.Users || [],
      "selectedUser": _vm.selectedUser,
      "influencerEmail": _vm.influencerEmail
    }
  }), _vm._v(" "), _c('follow-up', {
    attrs: {
      "dialog": _vm.showFollowUpModal,
      "dialogClose": _vm.followUpClose,
      "from": _vm.currentUser.email,
      "fromName": _vm.currentUserFullName,
      "to": _vm.currentInfluencerEmail,
      "toName": _vm.fullName
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n        Close\n      ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "content-class": "edit-post-modal",
      "max-width": "900px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.postData) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Edit Draft")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    attrs: {
      "id": "campaignForm"
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "name": "campaignName",
      "disabled": typeof _vm.postData.submittedCampaignName === 'string'
    },
    model: {
      value: (_vm.postData.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.postData, "campaignName", $$v)
      },
      expression: "postData.campaignName"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [(_vm.postData.author) ? _c('div', {
    staticClass: "mb-2"
  }, [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "35",
      "color": "grey lighten-4"
    }
  }, [_c('img', {
    staticClass: "elevation-6",
    attrs: {
      "src": _vm.paserImageUrl(_vm.postData.author.picture),
      "alt": "avatar"
    }
  })]), _vm._v(" "), (_vm.postData.author.tiktokHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.postData.author.tiktokHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.postData.author.tiktokHandle))]) : (_vm.postData.author.youtubeHandle) ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.postData.author.youtubeHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.postData.author.youtubeHandle))], 1) : (_vm.postData.author.xhsHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.xiaohongshu.com/user/profile/' + _vm.postData.author.xhsHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.postData.author.xhsHandle))]) : (_vm.postData.author.linkedinHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.postData.author.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.postData.author.linkedinHandle))], 1) : (_vm.postData.type === 'twitter' || _vm.postData.author.twitterHandle) ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + (_vm.postData.author.twitterHandle || _vm.postData.author.instagramHandle),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.postData.author.twitterHandle || _vm.postData.author.instagramHandle))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.postData.author.instagramHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.postData.author.instagramHandle))], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.type) ? _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("platformDisplayName")(_vm.postData.type)) + "\n                  ")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "md": (_vm.postAbuseHistory && _vm.clientReportAbuse.length > 0) ? 8 : 12,
      "xs": "12"
    }
  }, [_c('v-container', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "grid-list-sm": "",
      "container--fluid": ""
    }
  }, [(_vm.viewImages.length === 0) ? _c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "align-center": "",
      "justify-center": "",
      "ma-0": ""
    }
  }, [_c('p', [_vm._v("No Media to show")])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('draggable', {
    staticClass: "row align-center justify-center",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": _vm.dragEnd
    },
    model: {
      value: (_vm.viewImages),
      callback: function($$v) {
        _vm.viewImages = $$v
      },
      expression: "viewImages"
    }
  }, _vm._l((_vm.viewImages), function(img, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "mb-3",
      attrs: {
        "md4": "",
        "xs12": ""
      }
    }, [(_vm.isMissingMedia(img)) ? _c('div', [_c('v-alert', {
      attrs: {
        "type": "warning",
        "outlined": ""
      }
    }, [_vm._v("\n                            This media file is missing. Remove it and upload the original file again.\n                          ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "block": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                          ")], 1)], 1) : (img.publicID && img.isvideo) ? _c('div', [_c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-hover', [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img)
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-2"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                              ")], 1), _vm._v(" "), _c('btn-download', {
      attrs: {
        "url": img.url,
        "className": "mt-0"
      }
    })], 1)])], 1) : _c('v-card', {
      staticClass: "elevation-0",
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [(!img.isvideo) ? _c('div', [(!img.isvideo && !img.publicID) ? _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      attrs: {
        "src": img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      }
    }) : _vm._e(), _vm._v(" "), (img && !img.isvideo && img.publicID) ? _c('div', {
      staticClass: "cursor-pointer"
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {})
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-2"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('v-btn', {
      staticClass: "mr-2",
      attrs: {
        "small": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                                ")], 1), _vm._v(" "), _c('btn-download', {
      attrs: {
        "url": img.url,
        "className": "mt-0"
      }
    })], 1)])], 1) : _vm._e(), _vm._v(" "), (img.isvideo) ? _c('v-card', {
      staticClass: "elevation-8",
      attrs: {
        "text": ""
      }
    }, [_c('v-card-text', [_c('video', {
      attrs: {
        "id": "previewVideo",
        "width": "100%",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.url,
        "type": "video/mp4"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "px-2"
    }, [(img.type === 'video/quicktime') ? _c('btn-download', {
      attrs: {
        "url": img.url
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "text": "",
        "block": "",
        "dark": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImages(i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("delete")]), _vm._v("Remove\n                            ")], 1)], 1)], 1) : _vm._e()], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "blue-grey",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_vm._v("\n                  Add Media\n                  "), _c('v-icon', {
    attrs: {
      "float-right": "",
      "dark": ""
    }
  }, [_vm._v("cloud_upload")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": "image/*, video/*",
      "multiple": ""
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.isCaptionText) ? _c('div', [_c('v-textarea', {
    attrs: {
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "name": "captionText",
      "label": "Current Caption",
      "value": _vm.postData.defaultCaptionText,
      "counter": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "name": "captionText",
      "label": _vm.captionLabel,
      "rules": [_vm.rules.length(2200)],
      "counter": ""
    },
    model: {
      value: (_vm.postData.captionText),
      callback: function($$v) {
        _vm.$set(_vm.postData, "captionText", $$v)
      },
      expression: "postData.captionText"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isVideoLink) ? _c('div', [_c('v-text-field', {
    attrs: {
      "filled": "",
      "clearable": "",
      "name": "vdoLink",
      "type": "text",
      "label": "Link (If your file size is bigger than 100mb or the video fails to upload, please insert a video/drive link here)",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.postData.vdoLink),
      callback: function($$v) {
        _vm.$set(_vm.postData, "vdoLink", $$v)
      },
      expression: "postData.vdoLink"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isRemark) ? _c('div', [_c('div', {
    staticClass: "kobe-remark-editor-label"
  }, [_vm._v("Kobe Remark")]), _vm._v(" "), _c('sun-editor', {
    staticClass: "kobe-remark-editor",
    attrs: {
      "content": _vm.postData.remark || '',
      "width": "100%",
      "height": "180",
      "source": "post"
    },
    on: {
      "contentChanged": function($event) {
        _vm.postData.remark = $event
      },
      "loadingDialogOpen": function($event) {
        _vm.loading = true
      },
      "loadingDialogClose": function($event) {
        _vm.loading = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHashTag) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "name": "mandatoryHashtag",
      "label": "Mandatory Hashtag & Mentions",
      "counter": ""
    },
    model: {
      value: (_vm.postData.mandatoryHashtag),
      callback: function($$v) {
        _vm.$set(_vm.postData, "mandatoryHashtag", $$v)
      },
      expression: "postData.mandatoryHashtag"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCallToActionLinks) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "4",
      "name": "callToActionLinks",
      "label": "Call to Action Links",
      "counter": ""
    },
    model: {
      value: (_vm.postData.callToActionLinks),
      callback: function($$v) {
        _vm.$set(_vm.postData, "callToActionLinks", $$v)
      },
      expression: "postData.callToActionLinks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.postAbuseHistory && _vm.clientReportAbuse.length > 0) ? _c('v-col', {
    attrs: {
      "md": "4",
      "xs": "12"
    }
  }, [_c('v-expansion-panels', {
    staticClass: "report-abuse-section-edit"
  }, _vm._l((_vm.clientReportAbuse), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "subtitle-1",
      attrs: {
        "color": "red lighten-4"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "deep-orange"
      }
    }, [_vm._v("report_problem")]), _vm._v("\n                        Reported Abuse\n                      ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
      return _c('li', {
        key: r
      }, [_vm._v(_vm._s(r))])
    }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Abuse:")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(item.comment) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-right caption font-weight-italic"
    }, [_vm._v(_vm._s(_vm.formatDate(item.date)))])])], 1)], 1)], 1)
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.allowDelete) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.deletePost()
      }
    }
  }, [_vm._v("Delete Post")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": _vm.color
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "pa-3 mt-3",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn-toggle', {
    staticClass: "btn-filter-group pa-3",
    attrs: {
      "small": "",
      "dense": "",
      "mandatory": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.monthlyClick
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.quartelyClick
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.yearlyClick
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "col-md-3 col-sm-12 col-xs-12 pa-3",
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.firstFilters,
      "label": _vm.firstFilterLabel,
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.firstFilterId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "firstFilterId", $$v)
      },
      expression: "selectedFilter.firstFilterId"
    }
  }), _vm._v(" "), (_vm.summary && _vm.summary.length) ? _c('v-card', {
    staticClass: "summary-card",
    attrs: {
      "max-width": "330",
      "height": "180",
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "text-h6 text--primary"
  }, [_vm._v("\n                  " + _vm._s(_vm.summaryTitle) + "\n                ")]), _vm._v(" "), _vm._l((_vm.summary), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text--primary",
      staticStyle: {
        "font-size": "14px",
        "margin": "5px"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.data)))])])
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.id,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), (_vm.detail) ? _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "end",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.detailClick
    }
  }, [_vm._v("Details")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1300px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Push Campaign to Review")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Close push to review modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('invoices-brief-confirmation', {
    attrs: {
      "viewCampaignID": _vm.viewCampaignID,
      "isView": true
    },
    on: {
      "confirmBrief": _vm.confirmBrief,
      "closeBriefModal": _vm.closeModal
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.openUpdateCampaignQuarterModal
    }
  }, [_vm._v("\n          Push to Review\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('update-campaign-quarter-modal', {
    attrs: {
      "value": _vm.campaignQuarterDialog,
      "campaignID": _vm.viewCampaignID
    },
    on: {
      "updated": _vm.confirmBrief
    },
    model: {
      value: (_vm.campaignQuarterDialog),
      callback: function($$v) {
        _vm.campaignQuarterDialog = $$v
      },
      expression: "campaignQuarterDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rate-card-search-page"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('section', {
    staticClass: "rate-card-search-panel"
  }, [_c('div', {
    staticClass: "rate-card-search-primary"
  }, [_c('v-text-field', {
    staticClass: "rate-card-search-input",
    attrs: {
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Search rate cards",
      "placeholder": "Name, handle, email, country or category"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "rate-card-search-submit",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchFilter()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("Search\n          ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "rate-card-filters-toggle",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.filtersExpanded = !_vm.filtersExpanded
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-tune-variant")]), _vm._v("\n            Filters\n            "), (_vm.activeFilterCount) ? _c('span', {
    staticClass: "rate-card-filter-count"
  }, [_vm._v(_vm._s(_vm.activeFilterCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "right": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.filtersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "rate-card-reset-toggle",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.resetFilters();
        _vm.searchFilter()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-refresh")]), _vm._v("Reset\n          ")], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtersExpanded),
      expression: "filtersExpanded"
    }],
    staticClass: "rate-card-filters-accordion"
  }, [_c('div', {
    staticClass: "rate-card-advanced-filters__header"
  }, [_c('div', [_c('span', [_vm._v("Advanced filters")]), _vm._v(" "), _c('small', [_vm._v("Audience size, profile details, categories and pricing")])]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "#8b92a5"
    }
  }, [_vm._v("mdi-tune-variant")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "rate-card-filter-bar"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "min-width": "135px",
      "max-width": "135px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pr-4",
    attrs: {
      "label": "Star Only",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.filters.starOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "starOnly", $$v)
      },
      expression: "filters.starOnly"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  TikTok Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.tiktokFollowers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "from", $$v)
      },
      expression: "filters.tiktokFollowers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.tiktokFollowers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "to", $$v)
      },
      expression: "filters.tiktokFollowers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isTikTokEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isTikTokEmpty", $$v)
      },
      expression: "filters.isTikTokEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchTikTokFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "max-width": "165px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  IG Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "from", $$v)
      },
      expression: "filters.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "to", $$v)
      },
      expression: "filters.followers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isIgEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isIgEmpty", $$v)
      },
      expression: "filters.isIgEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchIGFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  Rate "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Content Type\n                      "), _c('v-select', {
    staticClass: "rate-card-content-type-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.contentTypes,
      "item-text": "title",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "rate-card-content-type-option",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "rate-card-content-type-option rate-card-content-type-option--selected",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.contentType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "contentType", $$v)
      },
      expression: "filters.contentType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-combobox', {
    staticClass: "rate-card-rate-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.filters.rateCurrency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCurrency", $$v)
      },
      expression: "filters.rateCurrency"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-text-field', {
    staticClass: "rate-card-rate-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "from", $$v)
      },
      expression: "filters.rate.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-text-field', {
    staticClass: "rate-card-rate-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "to", $$v)
      },
      expression: "filters.rate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "rate-card-rate-actions"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearRateFilters()
      }
    }
  }, [_vm._v("\n                    Clear all\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.countries,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "min-width": "150px",
      "max-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1"
    }
  }, [_c('v-menu', {
    ref: "DOBDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Date of Birth",
            "placeholder": "Date of Birth",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "clearable": "",
            "hide-details": ""
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.filters.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.filters, "dateOfBirth", $$v)
            },
            expression: "filters.dateOfBirth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dateOfBirthCal),
      callback: function($$v) {
        _vm.dateOfBirthCal = $$v
      },
      expression: "dateOfBirthCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filters.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateOfBirth", $$v)
      },
      expression: "filters.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelDOB()
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.categories,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Preferred Campaigns/Genre"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.rateCardLabels,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Main Category"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.mainCategory),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mainCategory", $$v)
      },
      expression: "filters.mainCategory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.rateCardLabels,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Sub Category"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.subCategory),
      callback: function($$v) {
        _vm.$set(_vm.filters, "subCategory", $$v)
      },
      expression: "filters.subCategory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 rate-card-filter-legacy-tool",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0 rate-card-filter-legacy-tool",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "margin-left": "-25px"
    },
    attrs: {
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Sort By\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.sortColumns
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  })], 1), _vm._v(" "), (_vm.isSortCurrency) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.sort.currency),
      callback: function($$v) {
        _vm.$set(_vm.sort, "currency", $$v)
      },
      expression: "sort.currency"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Type\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-20px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0 rate-card-filter-legacy-tool",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('section', {
    staticClass: "rate-card-results-panel"
  }, [_c('div', {
    staticClass: "rate-card-results-toolbar"
  }, [_c('span', {
    staticClass: "rate-card-results-count"
  }, [_c('strong', [_vm._v(_vm._s(_vm.filteredItems.length))]), _vm._v(" rate cards")]), _vm._v(" "), _c('div', {
    staticClass: "rate-card-results-toolbar__actions"
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "width": "250"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Sort by",
      "items": _vm.sortColumns
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  }), _vm._v(" "), (_vm.isSortCurrency) ? _c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Currency",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.sort.currency),
      callback: function($$v) {
        _vm.$set(_vm.sort, "currency", $$v)
      },
      expression: "sort.currency"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Direction",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right mt-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rate-card-column-settings",
          attrs: {
            "icon": "",
            "aria-label": "Column settings"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Column settings")])])], 1)]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 rate-card-table",
    attrs: {
      "id": "rate-card-data-table",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]
      }
    }, {
      key: "item.email",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.email) + "\n          ")])]
      }
    }, {
      key: "item.dateOfBirth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n            " + _vm._s(item.dateOfBirth ? _vm.utils.formatCustomDate(item.dateOfBirth, 'DD MMM, YYYY') : '') + "\n          ")])]
      }
    }, {
      key: "item.ethnicity",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.ethnicity && item.ethnicity !== 'Others' ? item.ethnicity : '') + "\n            " + _vm._s(item.otherEth ? item.otherEth : '') + "\n          ")])]
      }
    }, {
      key: "item.country",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.country) + "\n          ")])]
      }
    }, {
      key: "item.city",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.city) + "\n          ")])]
      }
    }, {
      key: "item.gender",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.gender) + "\n          ")])]
      }
    }, {
      key: "item.contactNo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.contactNo) + "\n          ")])]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.instagramHandle) ? _c('social-handle', {
          attrs: {
            "isInstagram": true,
            "instagramHandle": item.instagramHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.igFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.igFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.tiktokHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.tiktokHandle) ? _c('social-handle', {
          attrs: {
            "isTikTok": true,
            "tiktokHandle": item.tiktokHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.tiktokFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.tiktokFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.youtube",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'youtube')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'youtube'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'youtube')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.youtubeFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.youtubeFollowerCount)))])]
      }
    }, {
      key: "item.youtubeRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'youtube')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'youtube')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'youtube'))))]) : _vm._e()])]
      }
    }, {
      key: "item.facebook",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'facebook')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'facebook'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-facebook")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'facebook')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.linkedin",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'linkedin')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'linkedin'),
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#0A66C2"
          }
        }, [_vm._v("mdi-linkedin")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'linkedin')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.facebookFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.facebookFollowerCount)))])]
      }
    }, {
      key: "item.facebookRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'facebook')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'facebook')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'facebook'))))]) : _vm._e()])]
      }
    }, {
      key: "item.linkedinFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.linkedinFollowerCount)))])]
      }
    }, {
      key: "item.linkedinRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'linkedin')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'linkedin')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'linkedin'))))]) : _vm._e()])]
      }
    }, {
      key: "item.twitter",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'twitter')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'twitter'),
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "mr-1",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "15",
            "alt": "X (Twitter)"
          }
        }), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'twitter')))])]) : _vm._e()])]
      }
    }, {
      key: "item.twitterFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.twitterFollowerCount)))])]
      }
    }, {
      key: "item.twitterRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'twitter')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'twitter')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'twitter'))))]) : _vm._e()])]
      }
    }, {
      key: "item.twitch",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'twitch')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'twitch'),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getHandlePreview(item, 'twitch')))])]) : _vm._e()])]
      }
    }, {
      key: "item.twitchFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.twitchFollowerCount)))])]
      }
    }, {
      key: "item.twitchRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'twitch')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'twitch')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'twitch'))))]) : _vm._e()])]
      }
    }, {
      key: "item.igStory",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igStoryCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igStory)))]) : _vm._e()])]
      }
    }, {
      key: "item.igPost",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igPostCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igPost)))]) : _vm._e()])]
      }
    }, {
      key: "item.igCarousel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igCarouselCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igCarousel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igVideoCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igVideo)))]) : _vm._e()])]
      }
    }, {
      key: "item.igReel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igReelCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igReel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.igRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.igRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.tiktok",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.tiktokCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.tiktok)))]) : _vm._e()])]
      }
    }, {
      key: "item.tiktokRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.tiktokRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.tiktokRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.eventAppearance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.eventAppearanceCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.eventAppearance)))]) : _vm._e()])]
      }
    }, {
      key: "item.loadingFee",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.loadingFeeCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.loadingFee)))]) : _vm._e()])]
      }
    }, {
      key: "item.uploadMediaKit",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, _vm._l((item.pricingDecks), function(deck, idx) {
          return _c('v-btn', {
            key: idx,
            attrs: {
              "small": "",
              "text": "",
              "color": "secondary",
              "href": deck.url,
              "target": "_blank"
            }
          }, [_vm._v("\n              View Media\n            ")])
        }), 1)]
      }
    }, {
      key: "item.preferredCampaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.keywords || item.keywords.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.keywords), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.keywords),
            expression: "item.keywords"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.keywords && item.keywords.length > 1),
                  expression: "item.keywords && item.keywords.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Preferred Campaigns / Genre")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.keywords), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest))])
        })], 2)], 1)], 1)], 2)]
      }
    }, {
      key: "item.labelDisplays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.mainCategories || item.mainCategories.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _c('v-chip', {
          staticClass: "ma-2",
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(_vm._s(item.mainCategories))]), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.mainCategories),
            expression: "item.mainCategories"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.mainCategories && item.mainCategories.length > 0),
                  expression: "item.mainCategories && item.mainCategories.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('div', [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Main Category")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-chip', {
          staticClass: "ma-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.mainCategories))])], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Sub Category")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.subCategories), function(sub, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(sub))])
        })], 2)], 1)])], 1)], 1)]
      }
    }, {
      key: "item.labels",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mb-1 pa-0",
                attrs: {
                  "color": "secondary",
                  "small": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("edit")]), _vm._v("  Label\n                ")], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('div', [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Main Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.mainCategories),
            callback: function($$v) {
              _vm.$set(item, "mainCategories", $$v)
            },
            expression: "item.mainCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Sub Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "multiple": "",
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.subCategories),
            callback: function($$v) {
              _vm.$set(item, "subCategories", $$v)
            },
            expression: "item.subCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1)], 1)])], 1)], 1)]
      }
    }, {
      key: "item.aboutYou",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.aboutYou || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.aboutYou))
          }
        })])], 1)]
      }
    }, {
      key: "item.loadContent",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.loadContent) + "\n            " + _vm._s(item.loadContentText) + "\n          ")])]
      }
    }, {
      key: "item.giftBrand",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.giftBrand) + "\n          ")])]
      }
    }, {
      key: "item.engagement",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.engagement) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagement)))]) : _vm._e()])]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.views) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.views)))]) : _vm._e()])]
      }
    }, {
      key: "item.updatedAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm.utils.formatCustomDate(item.updatedAt, 'DD-MM-YYYY')) + "\n          ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [(item.star) ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Unstar",
            "icon": "",
            "small": "",
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.chgStarStatus(item, false)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', [_vm._v("mdi-star")])], 1) : _c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Star",
            "icon": "",
            "small": "",
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.chgStarStatus(item, true)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', [_vm._v("mdi-star-outline")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Details"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Rate Card",
            "color": "error",
            "text": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteRateCard(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)])], 1), _vm._v(" "), (_vm.viewData) ? _c('view-modal-dialog', {
    attrs: {
      "value": _vm.viewDialog,
      "data": _vm.viewData
    },
    model: {
      value: (_vm.viewDialog),
      callback: function($$v) {
        _vm.viewDialog = $$v
      },
      expression: "viewDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Ratecard Forms",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Update Email for @" + _vm._s(_vm.influencerHandle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "email",
      "type": "email",
      "error-messages": _vm.emailErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.email.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.updateEmail
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "absolute": "",
      "color": "primary",
      "width": "100%"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.termsAndConditions.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.termsAndConditions.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.termsAndConditions.html)
    }
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "align": "right",
      "rules": [function (v) { return !!v || ''; }],
      "label": "I have read and agree to the Terms and Conditions"
    },
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "text": "",
      "dismissible": "",
      "border": "left",
      "type": "error"
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("                              \n                 Please indicate that you have read and agree to the terms and conditions.\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.agree
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]), _vm._v(_vm._s(_vm.termsAndConditions.confirmButtonText))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v(" mdi-cancel")]), _vm._v(_vm._s(_vm.termsAndConditions.cancelButtonText))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Report Group")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-combobox', {
    attrs: {
      "items": _vm.reportGroups,
      "label": "Select Group",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name",
      "search-input": _vm.newReportGroup,
      "chips": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newReportGroup = $event
      },
      "update:search-input": function($event) {
        _vm.newReportGroup = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v("Press Enter to Create")]), _vm._v(" "), _c('v-chip', {
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.newReportGroup) + "\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', [_c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-list-item-content', _vm._l((_vm.selectedPosts), function(post, index) {
    return _c('v-list-item-subtitle', {
      key: index
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v(" " + _vm._s(post.instagram) + " - " + _vm._s(post.type))], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": !_vm.selectedGroup
    },
    on: {
      "click": _vm.saveReportGroup
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportInfluencers.apply(null, arguments)
      }
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadAll()
      }
    }
  }, [_vm._v("\n            Reload All\n            "), _c('i', {
    staticClass: "fa fa-repeat"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5 search-keyword-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search influencers by Tags extracted from NLU"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchByKeywords()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 v-dialog-wrapper"
  }, [_c('v-dialog', {
    attrs: {
      "width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          attrs: {
            "color": "red lighten-2",
            "dark": ""
          }
        }, on), [_vm._v("settings")])]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "type": "text",
      "clearable": "",
      "label": "Negative Keyword"
    },
    model: {
      value: (_vm.negativeKeyword),
      callback: function($$v) {
        _vm.negativeKeyword = $$v
      },
      expression: "negativeKeyword"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Negative keyword scope")]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.negativePeriod),
      callback: function($$v) {
        _vm.negativePeriod = $$v
      },
      expression: "negativePeriod"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Search period',
      "value": 'search_period'
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'Entire Account',
      "value": 'entire_account'
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "type": "number",
      "label": "Search Period(months)"
    },
    model: {
      value: (_vm.searchDuration),
      callback: function($$v) {
        _vm.searchDuration = $$v
      },
      expression: "searchDuration"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Enable")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Computer Vision"
    },
    model: {
      value: (_vm.computerVison),
      callback: function($$v) {
        _vm.computerVison = $$v
      },
      expression: "computerVison"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "NLU"
    },
    model: {
      value: (_vm.searchNlu),
      callback: function($$v) {
        _vm.searchNlu = $$v
      },
      expression: "searchNlu"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Opt-in Only")]), _vm._v(" "), _c('v-radio-group', {
    model: {
      value: (_vm.optInOnly),
      callback: function($$v) {
        _vm.optInOnly = $$v
      },
      expression: "optInOnly"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Yes',
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'No',
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.igHandle),
      expression: "igHandle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search Influencers by Instagram Handle(username)",
      "id": "igHandle"
    },
    domProps: {
      "value": (_vm.igHandle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.igHandle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.filters",
      modifiers: {
        "filters": true
      }
    }],
    staticClass: "btn btn-default btn-sm"
  }, [_vm._v("More Filters >>")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-3"
  }, [_c('label', [_vm._v("Influencer Location")]), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "outlined": "",
      "clearable": "",
      "small-chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "selected": data.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n                    ")])]
      }
    }]),
    model: {
      value: (_vm.influencerGeos),
      callback: function($$v) {
        _vm.influencerGeos = $$v
      },
      expression: "influencerGeos"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('b-btn', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.paginate()
      }
    }
  }, [_vm._v("Apply")]), _vm._v(" "), _c('b-btn', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.resetFilters()
      }
    }
  }, [_vm._v("Reset")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewReport",
      "data-toggle": "modal",
      "data-target": _vm.audienceDataReportDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "pagination": _vm.pagination,
      "expanded-item": _vm.expand,
      "loading": _vm.loading,
      "items-per-page-options": _vm.pagination.rowsPerPageItems,
      "server-items-length": _vm.pagination.totalItems,
      "item-key": "instagramHandle"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-avatar', {
          attrs: {
            "size": _vm.avatarSize,
            "color": "grey lighten-4"
          }
        }, [_c('img', {
          attrs: {
            "src": props.item.profilePicture,
            "alt": "avatar"
          }
        })])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', {
          attrs: {
            "target": "_blank",
            "href": 'https://instagram.com/' + props.item.instagramHandle
          }
        }, [_vm._v("@" + _vm._s(props.item.instagramHandle))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.instagramFullname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.totalFollowers))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.totalFollowing))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.joinedAt))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "mr-2",
                attrs: {
                  "medium": "",
                  "color": "success"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.showReport(props.item)
                  }
                }
              }, on), [_vm._v("assessment")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "mr-2",
                attrs: {
                  "medium": "",
                  "color": "success"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.viewInfluencerPosts(props.item)
                  }
                }
              }, on), [_vm._v("local_library")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Posts")])]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [(_vm.buttonShow('assignCompany')) ? _c('v-icon', _vm._g({
                attrs: {
                  "medium": "",
                  "color": "success"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.getCompanyDataToView(props.item)
                  }
                }
              }, on), [_vm._v("how_to_reg")]) : _vm._e()]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Assign Company")])])], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-card', {
          attrs: {
            "text": ""
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('v-card-text', [_c('strong', [_vm._v("Bank Account:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.item.bankAccount))])]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("Bank Name:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.item.bankName))])])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('v-card-text', [_c('strong', [_vm._v("Address:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.item.mailingAddress))])]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("Country:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.item.country))])])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('v-card-text', [_c('strong', [_vm._v("Date of Birth:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.item.birthday))])])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('v-card-text', [_c('strong', [_vm._v("Engagement Rate:")]), _vm._v(" "), _c('span', {
          staticClass: "engagement"
        }, [_vm._v(_vm._s(props.item.engagementRate) + "%")])])], 1)])])]
      }
    }])
  })], 1)])], 1)])])]), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "modalId": _vm.audienceDataReportId,
      "audienceData": _vm.audienceDataReport
    }
  }), _vm._v(" "), _c('influencer-post-modal', {
    attrs: {
      "modalId": _vm.influencerPostModalId,
      "title": _vm.postsTitle,
      "shortCodes": _vm.shortCodes
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Payment records")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "rounded": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.openAddDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Submit a new Payment"
    }
  }, [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.records,
      "data-app": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_vm._v(_vm._s(_vm.campaignName(item.campaignID)))]), _vm._v(" "), _c('td', [_vm._v("$ " + _vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTime")(item.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status == 1 ? 'Approved' : 'Submitted'))])])
        }), 0)]
      }
    }])
  })], 1)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('form', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Submit a new Payment")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.unpaidCampaigns,
      "item-text": "name",
      "item-value": "id",
      "label": "Campaigns",
      "prepend-icon": "view_list",
      "required": ""
    },
    model: {
      value: (_vm.addForm.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "campaignID", $$v)
      },
      expression: "addForm.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hint": "Insert the amount you need to submit (SGD)",
      "required": "",
      "prepend-icon": "attach_money"
    },
    model: {
      value: (_vm.addForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "amount", $$v)
      },
      expression: "addForm.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Attach Receipt/Proof",
      "prepend-icon": "attach_file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.receipt.click()
      }
    },
    model: {
      value: (this.imageName),
      callback: function($$v) {
        _vm.$set(this, "imageName", $$v)
      },
      expression: "this.imageName"
    }
  }), _vm._v(" "), _c('input', {
    ref: "receipt",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), (_vm.previewImage) ? _c('img', {
    attrs: {
      "src": _vm.previewImage,
      "width": "100%"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": "",
      "disabled": _vm.loadDialog,
      "loading": _vm.loadDialog
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Submit")])], 1)], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadDialog),
      callback: function($$v) {
        _vm.loadDialog = $$v
      },
      expression: "loadDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Submitting\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "content-class": ("rate-card-modal " + (_vm.currentMode === 'edit' ? 'rate-card-modal--edit' : '')),
      "width": _vm.currentMode === 'edit' ? '1500px' : '1000px'
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Rate Card Form\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "rate-card-modal__controls"
  }, [_c('div', [_c('v-row', {
    staticClass: "text-right"
  }, [_c('v-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [(_vm.currentMode === 'detail') ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('edit')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("edit")]), _vm._v("\n              Edit\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('detail')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("close")]), _vm._v("\n              Cancel Edit\n            ")], 1) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), (_vm.currentMode === 'detail') ? _c('v-card-text', {
    staticClass: "bg-white rate-card-modal__body"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.name ? _vm.data.name : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.email ? _vm.data.email : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.dateOfBirth ? _vm.utils.formatCustomDate(_vm.data.dateOfBirth, 'DD/MM/YYYY') : '-') + "\n          ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Ethnicity")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.ethnicity && _vm.data.ethnicity !== 'Others' ? _vm.data.ethnicity : '')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.otherEth ? _vm.data.otherEth : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.country ? _vm.data.country : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.city ? _vm.data.city : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.gender ? _vm.data.gender : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.contactNo ? _vm.data.contactNo : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("What is your occupation?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.occupation || '-') + "\n          ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Instagram Handle")]), _vm._v(" "), (_vm.data.instagramHandle) ? _c('social-handle', {
    attrs: {
      "isInstagram": true,
      "instagramHandle": _vm.data.instagramHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.data.instagramHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Tiktok Handle")]), _vm._v(" "), (_vm.data.tiktokHandle) ? _c('social-handle', {
    attrs: {
      "isTikTok": true,
      "tiktokHandle": _vm.data.tiktokHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.data.tiktokHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Your IG Followers Count")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.igFollowerCount ? _vm.data.igFollowerCount : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Your TikTok Followers Count")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.tiktokFollowerCount ? _vm.data.tiktokFollowerCount : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("LinkedIn Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'linkedin')) ? _c('social-handle', {
    attrs: {
      "isLinkedIn": true,
      "linkedinHandle": _vm.getStandaloneHandle(_vm.data, 'linkedin')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Followers (Connections)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.linkedinFollowerCount || '-'))])])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("X (Twitter) Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'twitter')) ? _c('social-handle', {
    attrs: {
      "isTwitter": true,
      "twitterHandle": _vm.getStandaloneHandle(_vm.data, 'twitter')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("X (Twitter) Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.twitterFollowerCount || '-'))])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("Facebook Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'facebook')) ? _c('social-handle', {
    attrs: {
      "isFacebook": true,
      "facebookHandle": _vm.getStandaloneHandle(_vm.data, 'facebook')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Facebook Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.facebookFollowerCount || '-'))])])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("YouTube Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'youtube')) ? _c('social-handle', {
    attrs: {
      "isYoutube": true,
      "youtubeHandle": _vm.getStandaloneHandle(_vm.data, 'youtube')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("YouTube Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.youtubeFollowerCount || '-'))])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("Twitch Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'twitch')) ? _c('a', {
    attrs: {
      "href": ("https://www.twitch.tv/" + (_vm.getStandaloneHandle(_vm.data, 'twitch'))),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "#9146FF"
    }
  }, [_vm._v("mdi-twitch")]), _vm._v(" @" + _vm._s(_vm.getStandaloneHandle(_vm.data, 'twitch')) + "\n            ")], 1) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Twitch Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.twitchFollowerCount || '-'))])])])], 1), _vm._v(" "), _c('v-row', [(_vm.data.engagement) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Engagement")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.engagement ? (_vm.data.engagement | _vm.thousandSeprator) : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.data.views) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.views ? (_vm.data.views | _vm.thousandSeprator) : '-')))])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Content Type")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Ordinary Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Preferential rate")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Story")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igStory || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igStoryCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igStory || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igStoryCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igPost || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igPostCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igPost || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igPostCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igCarousel || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igCarouselCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igCarousel || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igCarouselCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Reel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igReel || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igReelCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igReel || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igReelCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 188216484)
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (Instagram)")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.data.igRemarks))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "tiktok-stats",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Tiktok")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.tiktok || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.tiktokCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.tiktok || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.tiktokCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("LinkedIn Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'linkedin', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'linkedin', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'linkedin', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'linkedin', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'linkedin', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'linkedin', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("X (Twitter) Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitter', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitter', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitter', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitter', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitter', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitter', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Facebook Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'facebook', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'facebook', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'facebook', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'facebook', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'facebook', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'facebook', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("YouTube Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'youtube', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'youtube', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'youtube', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'youtube', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'youtube', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'youtube', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Twitch Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitch', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitch', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitch', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitch', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitch', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitch', 'preferential')))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 2518230305)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (TikTok)")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.data.tiktokRemarks))
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-divider', {
    staticClass: "ma-0"
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Handle of Other Platforms")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Platform")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getOtherPlatforms(_vm.data)), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [(_vm.getPlatformKey(item.platform) === 'linkedin') ? _c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]) : (_vm.getPlatformKey(item.platform) === 'twitter') ? _c('img', {
            staticClass: "mr-1",
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "14",
              "alt": "X (Twitter)"
            }
          }) : _vm._e(), _vm._v("\n                        " + _vm._s(_vm.getPlatformLabel(item.platform)) + "\n                        "), (item.platform === 'others') ? _c('span', [_vm._v(_vm._s(item.otherPlatform))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.rate) ? _c('span', [_vm._v(_vm._s(item.rateCurrency || 'SGD'))]) : _vm._e()])])
        }), 0)]
      },
      proxy: true
    }], null, false, 1752233488)
  })], 1), _vm._v(" "), (_vm.data.pricingDecks && _vm.data.pricingDecks.length > 0) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Media Kit")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.data.pricingDecks
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("Common Fees")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Fee Type")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Ordinary Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Preferential Rate")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Event Attendance")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loading Fee")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.loadingFee || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.loadingFee || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 3454867861)
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.loadContent || '-') + "\n          ")]), _vm._v(" "), (_vm.data.loadContentText) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.data.loadContentText) + "\n          ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Would you like to be part of our PR or gifting collaborations with brands?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.giftBrand || '-') + "\n          ")])])], 1), _vm._v(" "), (_vm.data.keywords) ? _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Preferred type of campaigns/genre (please tick relevant)")]), _vm._v(" "), _c('div', _vm._l((_vm.data.keywords), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.transPreferredEng(item) || '-') + "\n            ")])
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.data.aboutYou) ? _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("A short description of your profile that best represents you")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.aboutYou || '-') + "\n          ")])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('div', {
    staticClass: "edit-rate-card-form rate-card-modal__body"
  }, [_c('rate-card-form', {
    attrs: {
      "value": _vm.rateCardDialog,
      "mode": "edit",
      "editData": _vm.editData
    },
    on: {
      "updated": _vm.updatedRateCardForm
    },
    model: {
      value: (_vm.rateCardDialog),
      callback: function($$v) {
        _vm.rateCardDialog = $$v
      },
      expression: "rateCardDialog"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Add Partial Amount for @" + _vm._s(_vm.report.instagram))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hide-details": "",
      "prefix": "S$",
      "error-messages": _vm.amountErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.amount.$touch()
      }
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = _vm._n($$v)
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.amount.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('review-meeting-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', {
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "transition": "fade-transition"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "signInForm",
    staticClass: "sign-in-form",
    attrs: {
      "id": "sign-in-form-id",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "content",
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', {
    staticClass: "text-center mb-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "avatar-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoDataUrl,
      "alt": "Logo"
    }
  })])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin": "0px 20px 0px 0px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                      Kobe Global Technologies Pte Ltd."), _c('br'), _vm._v("\n                      GST Registration no. 201608755R"), _c('br'), _vm._v("\n                      51 Goldhill Plaza"), _c('br'), _vm._v("\n                      #14-01"), _c('br'), _vm._v("\n                      Singapore 308900"), _c('br'), _vm._v("\n                      finance@getkobe.com\n                    ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("\n                      Content Creator Details\n                    ")]), _vm._v(" "), (_vm.displayData.platform === 'tiktok') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      TikTok Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'instagram') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      Instagram Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'youtube') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      Youtube Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'twitter') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      X (Twitter) Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : (_vm.displayData.platform === 'others') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("platformDisplayName")(_vm.displayData.platformName)) + " Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')]) : _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                      Platform Handle: " + _vm._s(_vm.displayData.handle) + "  "), _c('br')])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("Company Rep Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v("Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('br'), _vm._v("\n                      (+65) 6255 5662 "), _c('br'), _vm._v("\n                      finance@getkobe.com\n                    ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("Campaign Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.displayData.campaignName))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v("\n                      Campaign Ref: " + _vm._s(_vm.displayData.campaignID) + "\n                    ")])])])], 1), _vm._v(" "), (_vm.pairingDetails.deliverables_details) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-top": "1px solid black"
    }
  }, [_c('thead', {
    staticClass: "brand-secondary-bg"
  }, [_c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("AMOUNT")])])]), _vm._v(" "), _c('tbody', [(_vm.pairingDetails.deliverables_details.no_of_stories) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Story")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_stories))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_stories')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_xhs_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("XHS Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_xhs_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_xhs_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_tiktok_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("TikTok Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_tiktok_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_tiktok_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_carousels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_carousels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_carousels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_video) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Video")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_video))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_video')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_igTv) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG TV")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_igTv))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_igTv')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_reels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Reels")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_reels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_reels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_li_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("LinkedIn Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_li_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_li_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_x_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("X (Twitter) Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_x_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_x_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.youtube) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Youtube")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.youtube))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('youtube')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.loading_whitelisting) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Loading/Whitelisting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.loading_whitelisting))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('loading_whitelisting')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.exclusivity) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Exclusivity ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.exclusivity))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('exclusivity')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.physical_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Physical Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.physical_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('physical_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.online_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Online Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.online_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('online_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.deliverables_details.no_of_fb_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Facebook ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.pairingDetails.deliverables_details.no_of_fb_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_fb_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pairingDetails.deliverables_details.custom), function(custom, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', [_vm._v(_vm._s(custom.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(custom.value))]), _vm._v(" "), (index === 0 && _vm.checkShowAmountRowSpan('custom')) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowspan": _vm.getRowSpanCount
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.pairingDetails.payout_details.boostingFees), function(boostingFee, index) {
    return (_vm.pairingDetails.payout_details) ? _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(boostingFee.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(boostingFee.value)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.pairingDetails.payout_details.GSTpercent) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("\n                            GST\n                          ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.pairingDetails.payout_details.GSTpercent)))])]) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.pairing_details.deliverable_notes) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.pairingDetails.pairing_details.deliverable_notes))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "brand-secondary-total-cell",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(" TOTAL: " + _vm._s(_vm.formatPayout(_vm.pairingDetails.payout_details.amount)) + " ")])])])], 2)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.remarks) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.pairingDetails.remarks)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.pairingDetails.pairing_details && _vm.pairingDetails.pairing_details.remarks) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "brand-secondary-bg"
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.pairingDetails.pairing_details.remarks))
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h2', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("I have read and accepted the terms of use ("), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.getkobe.com/influencer-terms-use-agreement/")]), _vm._v(").")]), _vm._v(" "), _c('li', [_vm._v("I have read and understood supporting campaign details that accompany this brief.")]), _vm._v(" "), _c('li', [_vm._v("I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.")]), _vm._v(" "), _c('li', [_vm._v("Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance,\n                        I may forfeit my rate or be deducted a penalty by the client.")]), _vm._v(" "), _c('li', [_vm._v("I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.")]), _vm._v(" "), _c('li', [_vm._v("I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.")]), _vm._v(" "), _c('li', [_vm._v("I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.")]), _vm._v(" "), _c('li', [_vm._v("If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.")]), _vm._v(" "), _c('li', [_vm._v("The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.")])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.pairingDetails.pairing_details) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('h4', [_vm._v("Please confirm your submission date!")]), _vm._v("\n                    " + _vm._s(_vm.formatSubmissionDate(_vm.pairingDetails.pairing_details.submission_date)) + "\n                    "), _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "color": "secondary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUpdateSubmissionDialog(_vm.pairingDetails)
      }
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
    attrs: {
      "color": "secondary",
      "small": ""
    }
  }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Date")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "max-width": "420px"
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 mb-2",
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.clearSignature
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #cfcece",
      "margin-bottom": "10px",
      "max-width": "100%",
      "overflow": "hidden"
    }
  }, [_c('canvas', {
    staticClass: "cls-signature-pad",
    attrs: {
      "id": "signin-signature-pad",
      "width": "400",
      "height": "200"
    }
  })])], 1), _vm._v(" "), (_vm.errors.signature) ? _c('p', {
    staticClass: "text-danger",
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("Signature field is required.")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_vm._v("Signature")]), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_vm._v("Date: " + _vm._s(_vm.todayDate()))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting,
      "x-large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n                    Submit\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('update-submission-date-modal', {
    attrs: {
      "value": _vm.updateSubmissionDateDialog,
      "pairing": _vm.viewPairingData
    },
    on: {
      "updated": _vm.refreshPairing,
      "closeModal": _vm.closeSubmissionDialog
    },
    model: {
      value: (_vm.updateSubmissionDateDialog),
      callback: function($$v) {
        _vm.updateSubmissionDateDialog = $$v
      },
      expression: "updateSubmissionDateDialog"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "font-size": "1.3rem!important"
    }
  }, [_vm._v("Recognised Revenue")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', [_c('v-autocomplete', {
    staticClass: "autocomplete-filter mb-5",
    attrs: {
      "items": _vm.AMCC,
      "item-value": "id",
      "item-text": "name",
      "label": "AM, CC",
      "clearable": "",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.changeFilter
    },
    model: {
      value: (_vm.selectedFilter.AMCC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AMCC", $$v)
      },
      expression: "selectedFilter.AMCC"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "recognized-revenue-table elevation-1",
    attrs: {
      "dense": "",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.monthYearValues,
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.month",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.month) ? _c('span', [_vm._v(_vm._s(item.month))]) : _vm._e()])]
      }
    }, {
      key: "item.amount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.amount) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e()])]
      }
    }, {
      key: "item.filteredAmt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start",
          staticStyle: {
            "min-width": "100px!important"
          }
        }, [(item.filteredAmt) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.filteredAmt)) + " (" + _vm._s(_vm.getRevPercent(item)) + "%)")]) : _vm._e()])]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("Total " + _vm._s(_vm.currentYear))])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalAmount)))])]), _vm._v(" "), (_vm.selectedFilter && _vm.selectedFilter.AMCC) ? _c('th', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('b', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalFilteredAmount)) + " (" + _vm._s(_vm.totalFilterPercent) + "%)")])]) : _vm._e()])])], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.message.show) ? _c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "green darken-3",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('dashboard-activation-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('campaign-brief-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('pairing-lineup-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('drafts-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('reporting-data-table', {
    attrs: {
      "AM": _vm.AM,
      "CC": _vm.CC
    },
    on: {
      "viewCampaign": _vm.getCampaignDataToView
    }
  })], 1)], 1), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "value": _vm.passwordModalDialog
    },
    on: {
      "changePassword": _vm.passwordChanged
    },
    model: {
      value: (_vm.passwordModalDialog),
      callback: function($$v) {
        _vm.passwordModalDialog = $$v
      },
      expression: "passwordModalDialog"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "modalId": 'view_campaign_modal',
      "value": _vm.viewCampaignModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewCampaignModalDialog),
      callback: function($$v) {
        _vm.viewCampaignModalDialog = $$v
      },
      expression: "viewCampaignModalDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.quoteData.id ? 'Edit' : 'Create') + " Quote")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "30px 50px 0",
      "max-height": "600px",
      "overflow-y": "auto"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Sales Person : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.saleUsers,
      "item-text": "firstName",
      "item-value": "id",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.salePersonErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.quoteData.salePerson.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "salePerson", $$v)
      },
      expression: "quoteData.salePerson"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Billing Name as per Xero : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.xeroContacts,
      "item-text": "Name",
      "attach": "",
      "dense": "",
      "outlined": "",
      "return-object": ""
    },
    model: {
      value: (_vm.quoteData.billingContact),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "billingContact", $$v)
      },
      expression: "quoteData.billingContact"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote No : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "prefix": "IO-",
      "dense": "",
      "outlined": "",
      "error-messages": _vm.quoteNoErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.quoteData.quoteNo.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.quoteNo),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "quoteNo", $$v)
      },
      expression: "quoteData.quoteNo"
    }
  }, _vm.on))], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote Acceptance Date (DD/MM/YYYY) : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "error-messages": _vm.acceptanceDateErrors
    },
    on: {
      "input": _vm.changeQuoteDate,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeQuoteDate.apply(null, arguments)
      },
      "blur": function($event) {
        return _vm.$v.quoteData.acceptanceDate.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.acceptanceDate),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "acceptanceDate", $$v)
      },
      expression: "quoteData.acceptanceDate"
    }
  }, _vm.on)), _vm._v(" "), (_vm.isInvalidQuoteDate) ? _c('p', {
    staticClass: "custom-danger ma-0 pt-1",
    staticStyle: {
      "margin-top": "-30px!important"
    }
  }, [_vm._v("Invalid Quote Date")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Currency : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.currencyLists,
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.quoteData.currency),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "currency", $$v)
      },
      expression: "quoteData.currency"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote Amt FC : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "blur": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.quoteAmtFC),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "quoteAmtFC", $$v)
      },
      expression: "quoteData.quoteAmtFC"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Est Exchange Rate : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "blur": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.estExchangeRate),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "estExchangeRate", $$v)
      },
      expression: "quoteData.estExchangeRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Confirm Exchange Rate : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "blur": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.confirmExchangeRate),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "confirmExchangeRate", $$v)
      },
      expression: "quoteData.confirmExchangeRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isOtherCurrency) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Display Rate : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-radio-group', {
    staticClass: "mt-0",
    attrs: {
      "row": ""
    },
    on: {
      "change": _vm.calcExgAmt
    },
    model: {
      value: (_vm.quoteData.priceRdo),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "priceRdo", $$v)
      },
      expression: "quoteData.priceRdo"
    }
  }, [_c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": "Est Rate",
      "color": "warning",
      "value": 1
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-radio', {
    staticClass: "pt-1",
    attrs: {
      "label": "Confirm Rate",
      "color": "warning",
      "value": 2
    }
  })], 1)]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.calculatedRate),
      callback: function($$v) {
        _vm.calculatedRate = $$v
      },
      expression: "calculatedRate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Quote Amt (excl. GST) : ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": "",
      "error-messages": _vm.quoteAmtErrors
    },
    on: {
      "blur": function($event) {
        return _vm.$v.quoteData.quoteAmt.$touch()
      }
    },
    model: {
      value: (_vm.quoteData.quoteAmt),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "quoteAmt", $$v)
      },
      expression: "quoteData.quoteAmt"
    }
  })], 1)], 1), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Invoice Created on Xero: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.changeInvoiceSent
    },
    model: {
      value: (_vm.quoteData.invoiceCreated),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "invoiceCreated", $$v)
      },
      expression: "quoteData.invoiceCreated"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Invoice Sent: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [(_vm.quoteData.activity && _vm.quoteData.activity.length) ? _c('div', _vm._l((_vm.quoteData.activity), function(activity, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-row mb-2"
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "placeholder": "",
        "prefix": "$",
        "outlined": "",
        "disabled": "",
        "dense": "",
        "hide-details": ""
      },
      model: {
        value: (activity.amount),
        callback: function($$v) {
          _vm.$set(activity, "amount", $$v)
        },
        expression: "activity.amount"
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('v-btn', {
    staticClass: "btn-invoice-sent-edit ml-0",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.openInvoiceSentEditDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n              ")], 1), _vm._v(" "), (_vm.quoteData.id) ? _c('v-btn', {
    staticClass: "btn-invoice-sent-edit",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openInvoiceSentActivityDialog(_vm.quoteData.activity)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "View Details",
      "small": ""
    }
  }, [_vm._v("remove_red_eye")]), _vm._v(" View\n              ")], 1) : _vm._e()], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "sm": "12"
    }
  }, [_c('p', {
    staticClass: "title-1 form-label"
  }, [_vm._v("Yet to Invoice: ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "7",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "",
      "prefix": "$",
      "disabled": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.quoteData.invoicePending),
      callback: function($$v) {
        _vm.$set(_vm.quoteData, "invoicePending", $$v)
      },
      expression: "quoteData.invoicePending"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.quoteData.id) ? _c('v-row', [_c('h4', {
    staticClass: "pl-2 mb-0",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Timelines")]), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.openTimelineUpdateDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n            ")], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Start Month")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("End Month")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(!_vm.quoteData.quoteData.length) ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Empty List")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.quoteData.quoteData), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.quoteAmt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMonth(item.startMonth)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMonth(item.endMonth)))]), _vm._v(" "), _c('td', [(item.status === _vm.quoteStatuses.ACCEPT) ? _c('span', [_vm._v("Approved")]) : (item.status === _vm.quoteStatuses.REJECT) ? _c('span', [_vm._v("Rejected")]) : _c('span', [_vm._v("Pending")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks || ''))]), _vm._v(" "), _c('td', [(item.status === _vm.quoteStatuses.ACCEPT) ? _c('div', {
            staticClass: "ma-1"
          }, [_c('div', [_c('v-btn', {
            staticClass: "ml-0",
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.openTimelineUpdateDialogForEdit(item, index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (item.status === _vm.quoteStatuses.ACCEPT) ? _c('div', {
            staticClass: "ma-1"
          }, [_c('div', [_c('v-btn', {
            staticClass: "ml-0",
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteTimeline(index)
              }
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("mdi-delete-outline")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (item.status === _vm.quoteStatuses.PENDING) ? _c('div', {
            staticClass: "mt-2"
          }, [_c('div', [_c('v-btn', {
            staticClass: "ml-0",
            staticStyle: {
              "width": "80px"
            },
            attrs: {
              "color": "green",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.processQuoteData(index, _vm.quoteStatuses.ACCEPT)
              }
            }
          }, [_vm._v("\n                            Approve\n                          ")])], 1), _vm._v(" "), _c('div', [_c('v-btn', {
            staticClass: "ml-0 mt-1",
            staticStyle: {
              "width": "80px"
            },
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.processQuoteData(index, _vm.quoteStatuses.REJECT)
              }
            }
          }, [_vm._v("\n                            Reject\n                          ")])], 1)]) : _vm._e()])])
        })], 2)]
      },
      proxy: true
    }], null, false, 3600264267)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.disableMasterLists || _vm.invalidInvoiceSent || _vm.isInvalidQuoteDate,
      "text": ""
    },
    on: {
      "click": _vm.saveQuote
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('invoice-sent-edit-modal', {
    attrs: {
      "value": _vm.invoiceSentEditDialog,
      "data": _vm.quoteData
    },
    on: {
      "created": _vm.updatedInvoiceSent
    },
    model: {
      value: (_vm.invoiceSentEditDialog),
      callback: function($$v) {
        _vm.invoiceSentEditDialog = $$v
      },
      expression: "invoiceSentEditDialog"
    }
  }), _vm._v(" "), _c('invoice-sent-activity-modal', {
    attrs: {
      "value": _vm.invoiceSentActivityDialog,
      "data": _vm.editActivityData
    },
    on: {
      "updateActivityData": _vm.updateActivityData
    },
    model: {
      value: (_vm.invoiceSentActivityDialog),
      callback: function($$v) {
        _vm.invoiceSentActivityDialog = $$v
      },
      expression: "invoiceSentActivityDialog"
    }
  }), _vm._v(" "), _c('timeline-amount-update-modal', {
    attrs: {
      "value": _vm.timelineUpdateDialog,
      "data": _vm.quoteData,
      "editTimelineData": _vm.editTimelineData,
      "editTimelineIdx": _vm.editTimelineIdx
    },
    on: {
      "created": _vm.updateTimelineAmount
    },
    model: {
      value: (_vm.timelineUpdateDialog),
      callback: function($$v) {
        _vm.timelineUpdateDialog = $$v
      },
      expression: "timelineUpdateDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "container--fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Instagram Post URL",
      "placeholder": "e.g. https://www.instagram.com/p/abcdefghijklm/",
      "outlined": "",
      "color": "yellow darken-3"
    },
    model: {
      value: (_vm.igUrl),
      callback: function($$v) {
        _vm.igUrl = $$v
      },
      expression: "igUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.analyse(_vm.igUrl)
      }
    }
  }, [_vm._v("Analyse\n            ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "hidden",
      "id": "viewModalIdDisplay",
      "data-toggle": "modal",
      "data-target": _vm.viewModalIdDisplay
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('h3', [_vm._v("History")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "headers": _vm.fields,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item.instagram",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', [_c('a', {
          attrs: {
            "href": item.instagram,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.instagram))])])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', [_c('v-btn', {
          attrs: {
            "small": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              return _vm.view(item)
            }
          }
        }, [_vm._v("\n                View\n              ")])], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('content-analysis-result-modal', {
    attrs: {
      "modalId": _vm.contentAnalysisResultModal,
      "postData": _vm.postAnalytics
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "secondary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("Reload")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "sort-by": _vm.sortBy,
      "item-key": "igHandle"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('a', {
            attrs: {
              "target": "_blank",
              "href": 'https://instagram.com/' + item.instagramHandle
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.fullName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.createdAt))]), _vm._v(" "), _c('td', {
            staticClass: "justify-center layout px-0"
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', {
                  attrs: {
                    "text": "",
                    "icon": "",
                    "color": "green"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.approveOrReject(1, item.id)
                    }
                  }
                }, [_c('v-icon', _vm._g({}, on), [_vm._v("done_outline")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Approve")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', {
                  attrs: {
                    "text": "",
                    "icon": "",
                    "color": "deep-orange"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.approveOrReject(2, item.id)
                    }
                  }
                }, [_c('v-icon', _vm._g({}, on), [_vm._v("not_interested")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Reject")])])], 1)])
        }), 0)]
      }
    }])
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "rotate": -90,
      "size": 100,
      "width": 20,
      "value": Math.round(_vm.usage * 100),
      "color": _vm.color
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            " + _vm._s(Math.round(_vm.usage * 100)) + " % Used\n          ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "subtitle-2"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + ":\n    "), _c('v-spacer'), _vm._v("\n    " + _vm._s(_vm.used) + " / " + _vm._s(_vm.available) + "\n  ")], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.influencer) ? _c('div', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.openExpansion),
      callback: function($$v) {
        _vm.openExpansion = $$v
      },
      expression: "openExpansion"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Contact Information *")]), _vm._v(" "), _c('v-expansion-panel-content', [(_vm.influencer.facebook) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Facebook Handle"
    },
    model: {
      value: (_vm.influencer.facebook.handle),
      callback: function($$v) {
        _vm.$set(_vm.influencer.facebook, "handle", $$v)
      },
      expression: "influencer.facebook.handle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.twitter) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "X (Twitter) Handle"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.influencer.twitter.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.influencer.twitter, "twitterHandle", $$v)
      },
      expression: "influencer.twitter.twitterHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasFirstName) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "First Name",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.influencer.firstName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "firstName", $$v)
      },
      expression: "influencer.firstName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasLastName) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Last Name"
    },
    model: {
      value: (_vm.influencer.lastName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "lastName", $$v)
      },
      expression: "influencer.lastName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Email Address",
      "required": "",
      "rules": _vm.MessageRules
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "input": _vm.removeSpaces,
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.influencer.email),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "email", $$v)
      },
      expression: "influencer.email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Contact Number"
    },
    model: {
      value: (_vm.influencer.phone),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "phone", $$v)
      },
      expression: "influencer.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Billing Information")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Country",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name"
    },
    on: {
      "change": _vm.changeCountry
    },
    model: {
      value: (_vm.influencer.country),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "country", $$v)
      },
      expression: "influencer.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.bankNames,
      "label": "Bank Name (select your bank)",
      "item-text": "bank",
      "item-value": "bank",
      "search-input": _vm.newBankName,
      "attach": "",
      "disabled": _vm.disableBankSelect
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newBankName = $event
      },
      "update:search-input": function($event) {
        _vm.newBankName = $event
      },
      "change": _vm.changeBankName
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
      },
      proxy: true
    }], null, false, 2535767177),
    model: {
      value: (_vm.influencer.bankName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "bankName", $$v)
      },
      expression: "influencer.bankName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('################'),
      expression: "'################'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "Bank Account Number (Please omit dash '-')"
    },
    model: {
      value: (_vm.influencer.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "bankAccount", $$v)
      },
      expression: "influencer.bankAccount"
    }
  }), _vm._v(" "), _c('span')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Swift Code"
    },
    model: {
      value: (_vm.swiftCode),
      callback: function($$v) {
        _vm.swiftCode = $$v
      },
      expression: "swiftCode"
    }
  }), _vm._v(" "), _c('span')], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Fullname as per Bank Account Name"
    },
    model: {
      value: (_vm.influencer.fullName),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "fullName", $$v)
      },
      expression: "influencer.fullName"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Street Address"
    },
    model: {
      value: (_vm.influencer.mailingAddress),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "mailingAddress", $$v)
      },
      expression: "influencer.mailingAddress"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Postal Code"
    },
    model: {
      value: (_vm.influencer.postalCode),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "postalCode", $$v)
      },
      expression: "influencer.postalCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_c('p', [_vm._v("Your rates\n            "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(in SGD per item)")])])]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG Static",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igStatic),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igStatic", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igStatic"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG Carousel",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igCarousel),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igCarousel", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igCarousel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG Story",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igStory),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igStory", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igStory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "IG TV",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.igTv),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "igTv", _vm._n($$v))
      },
      expression: "influencer.inputedRates.igTv"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Tiktok",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.tiktok),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "tiktok", _vm._n($$v))
      },
      expression: "influencer.inputedRates.tiktok"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Blog",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.inputedRates.blog),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "blog", _vm._n($$v))
      },
      expression: "influencer.inputedRates.blog"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_vm._v("\n            Pricing Decks:\n              "), _c('v-btn', {
    staticClass: "ma-5 white--text",
    attrs: {
      "color": "blue-grey"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_vm._v("\n              Upload\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("\n                mdi-cloud-upload\n              ")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "media",
      "id": "fileToUpload",
      "accept": "image/*, .pdf, .ppt, .txt, .doc, .docx"
    },
    on: {
      "change": _vm.prepareUpload
    }
  }), _vm._v(" "), _c('div', [(_vm.images.length > 0) ? _c('v-row', _vm._l((_vm.images), function(img, index) {
    return _c('v-col', {
      key: index,
      staticClass: "d-flex child-flex",
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "1"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "d-flex",
            attrs: {
              "flat": "",
              "tile": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.url,
              "lazy-src": img.url,
              "aspect-ratio": "1"
            }
          }), _vm._v(" "), _c('v-overlay', {
            attrs: {
              "absolute": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "dark": "",
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteImage(index)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "dark": "",
              "color": "red"
            }
          }, [_vm._v("cancel")])], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.decksFiles.length > 0) ? _c('v-row', _vm._l((_vm.decksFiles), function(item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "2",
        "lg": "1",
        "align": "center"
      }
    }, [(item.type.indexOf('pdf') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/pdf.png",
        "aspect-ratio": "1"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('ppt') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/ppt.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('doc') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/doc.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type.indexOf('text') !== -1) ? _c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('v-img', {
      attrs: {
        "width": "67",
        "height": "85",
        "src": "./static/img/text.png"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-textarea', {
    staticClass: "purple-input",
    attrs: {
      "filled": "",
      "auto-grow": "",
      "label": "Remark",
      "placeholder": "If you have any thoughts on your rates, please let us know here."
    },
    model: {
      value: (_vm.influencer.inputedRates.remark),
      callback: function($$v) {
        _vm.$set(_vm.influencer.inputedRates, "remark", $$v)
      },
      expression: "influencer.inputedRates.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Additional")]), _vm._v(" "), _c('v-expansion-panel-content', [(_vm.influencer.xiaohongshu && _vm.isMainPlatform('xiaohongshu')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Followers",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.xiaohongshu.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.xiaohongshu, "totalFollowers", $$v)
      },
      expression: "influencer.xiaohongshu.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.xiaohongshu && _vm.isMainPlatform('xiaohongshu')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Following",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.xiaohongshu.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.influencer.xiaohongshu, "totalFollowing", $$v)
      },
      expression: "influencer.xiaohongshu.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.xiaohongshu && _vm.isMainPlatform('xiaohongshu')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Likes/Favourites",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.xiaohongshu.totalLikesFavourites),
      callback: function($$v) {
        _vm.$set(_vm.influencer.xiaohongshu, "totalLikesFavourites", $$v)
      },
      expression: "influencer.xiaohongshu.totalLikesFavourites"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.facebook && _vm.isMainPlatform('facebook')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Followers",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.facebook.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.facebook, "totalFollowers", $$v)
      },
      expression: "influencer.facebook.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.facebook && _vm.isMainPlatform('facebook')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Following",
      "type": "number"
    },
    model: {
      value: (_vm.influencer.facebook.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.influencer.facebook, "totalFollowing", $$v)
      },
      expression: "influencer.facebook.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.linkedin && _vm.isMainPlatform('linkedin')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Followers (Connections)",
      "type": "number",
      "min": "0"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "#0A66C2",
            "small": ""
          }
        }, [_vm._v("mdi-linkedin")])]
      },
      proxy: true
    }], null, false, 2884666817),
    model: {
      value: (_vm.influencer.linkedin.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.linkedin, "totalFollowers", _vm._n($$v))
      },
      expression: "influencer.linkedin.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.twitter && _vm.isMainPlatform('twitter')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "X (Twitter) Followers",
      "type": "number",
      "min": "0"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.influencer.twitter.totalFollowers),
      callback: function($$v) {
        _vm.$set(_vm.influencer.twitter, "totalFollowers", _vm._n($$v))
      },
      expression: "influencer.twitter.totalFollowers"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.twitter && _vm.isMainPlatform('twitter')) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "X (Twitter) Following",
      "type": "number",
      "min": "0"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('img', {
          staticClass: "mr-2",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "20px",
            "alt": "",
            "aria-hidden": "true"
          }
        })]
      },
      proxy: true
    }], null, false, 2464317665),
    model: {
      value: (_vm.influencer.twitter.totalFollowing),
      callback: function($$v) {
        _vm.$set(_vm.influencer.twitter, "totalFollowing", _vm._n($$v))
      },
      expression: "influencer.twitter.totalFollowing"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": _vm.userGender_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.influencer.gender),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "gender", $$v)
      },
      expression: "influencer.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Your Birthday",
            "prepend-icon": "event",
            "readonly": ""
          },
          model: {
            value: (_vm.influencer.birthday),
            callback: function($$v) {
              _vm.$set(_vm.influencer, "birthday", $$v)
            },
            expression: "influencer.birthday"
          }
        }, on))]
      }
    }], null, false, 472973793),
    model: {
      value: (_vm.bdPicker),
      callback: function($$v) {
        _vm.bdPicker = $$v
      },
      expression: "bdPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.bdPicker = false
      }
    },
    model: {
      value: (_vm.influencer.birthday),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "birthday", $$v)
      },
      expression: "influencer.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Ethnicity",
      "items": _vm.ethnicity_options,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.influencer.ethnicity),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "ethnicity", $$v)
      },
      expression: "influencer.ethnicity"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "purple-input",
    attrs: {
      "label": "Occupation"
    },
    model: {
      value: (_vm.influencer.occupation),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "occupation", $$v)
      },
      expression: "influencer.occupation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('label', [_vm._v("Preferred type of campaigns/genre (please tick relevant)")]), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "secondary white--text",
      "max": "3",
      "column": ""
    },
    model: {
      value: (_vm.influencer.keywords),
      callback: function($$v) {
        _vm.$set(_vm.influencer, "keywords", $$v)
      },
      expression: "influencer.keywords"
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-5 pr-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "btn-save-change",
      "color": "green"
    },
    on: {
      "click": _vm.editInfluencer
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pd-bottom-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', [_c('div', {
    style: ({
      'color': _vm.theme
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v("                  \n                " + _vm._s(_vm.title) + "\n              ")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 0px 10px"
    }
  }, [_c('v-select', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filters,
      "label": "Filter",
      "dense": "",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "change": _vm.selectedChangeHandler
    },
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  })], 1)])], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mg-top-0"
  }, [_c('v-col', {
    staticClass: "pd-top-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-container', {
    staticClass: "pd-top-0"
  }, [_c('v-row', _vm._l((_vm.previews.avgBlocks), function(item, index) {
    return _c('v-col', {
      key: index
    }, [_c('div', {
      attrs: {
        "id": "avgbox"
      }
    }, [_c('div', {
      attrs: {
        "id": "avg"
      }
    }, [_vm._v(_vm._s(item.avg))]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "avgTitle"
      }
    }, [_vm._v(_vm._s(item.title))])])])
  }), 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', _vm._l((_vm.fields), function(field, index) {
          return _c('th', {
            key: index,
            staticClass: "text-center",
            staticStyle: {
              "border": "none !important"
            }
          }, [_vm._v("\n                                " + _vm._s(field.header) + "\n                            ")])
        }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.previews.items), function(item, index) {
          return _c('tr', {
            key: index
          }, _vm._l((_vm.fields), function(field, index) {
            return _c('td', {
              key: index,
              staticStyle: {
                "line-height": "35px",
                "padding": "0px 0px",
                "font-weight": "300"
              },
              attrs: {
                "align": "center"
              }
            }, [(index === 0) ? _c('div', {
              staticClass: "left-div-border",
              style: ({
                'border-left-color': _vm.theme
              })
            }) : _vm._e(), _vm._v(" "), (field.format[0] === 'multiple') ? _c('div', [_vm._v(_vm._s(item[field.name[0]]) + "/" + _vm._s(item[field.name[1]]) + "\n                                  "), _c('span', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(field.format[1]))])]) : _c('div', [(field.type === 'money') ? _c('div', [_vm._v("\n                                      " + _vm._s(item[field.name]) + "\n                                      "), _c('span', {
              staticStyle: {
                "font-size": "10px"
              }
            }, [_vm._v(_vm._s(field.format[1]))])]) : _c('div', [_vm._v(_vm._s(item[field.name]))])])])
          }), 0)
        }), 0)]
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mg-top-0"
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "space-around",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "text": "",
      "color": _vm.theme
    },
    on: {
      "click": _vm.seeMoreModalOpen
    }
  }, [_vm._v("See More...")])], 1)], 1)], 1), _vm._v(" "), _c('see-more', {
    key: _vm.seeMoreDialogKey,
    attrs: {
      "dialog": _vm.seeMoreDialog,
      "title": _vm.title,
      "closeDialog": _vm.seeMoreModalClose,
      "headers": _vm.fields,
      "DataItems": _vm.detail.items,
      "theme": _vm.theme,
      "filterItems": _vm.filters,
      "filterCampaigns": _vm.filterCampaigns,
      "avgArray": _vm.detail.avgBlocks,
      "type": _vm.type
    },
    on: {
      "searchFilter": _vm.seeMoreFilter
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "content-class": "view-post-modal",
      "max-width": "1200px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.postData !== null) ? _c('v-card', [_c('v-toolbar', {
    staticClass: "elevation-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "text-no-wrap font-weight-bold"
        }, on), [_vm._v(_vm._s(_vm.postData.campaignName) + " Campaign")])]
      }
    }], null, false, 4264487728)
  }, [_vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('span', [_vm._v("Submitted as "), _c('strong', [_vm._v(_vm._s(_vm.postData.submittedCampaignName || _vm.postData.campaignName + ' (Unverified)'))])]) : _vm._e()])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-post-modal__body",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.postHistoryData.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.viewPostDetails()
      }
    }
  }, [_vm._v("\n              Details\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [(_vm.postAbuseHistory && _vm.postHistoryData.length > 0) ? _c('v-col', {
    attrs: {
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-flex', [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n                  Draft History\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.postHistoryData), function(hpost, i) {
    return [_c('v-list-item', {
      key: hpost._id + i,
      on: {
        "click": function($event) {
          return _vm.switchPostView(hpost)
        }
      }
    }, [_c('v-list-item-content', [(hpost.editedBy) ? _c('v-list-item-title', [_vm._v("\n                            " + _vm._s(hpost.editedBy.name) + "\n                          ")]) : _vm._e(), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                            " + _vm._s(hpost.isMain == null ? ((_vm.formatDate(hpost.createdAt)) + " (Active)") : _vm.formatDate(hpost.createdAt)) + "\n                          ")]), _vm._v(" "), (hpost.abuse_resolved) ? _c('v-list-item-title', [_vm._v("\n                            (Pending Abuse Resolved)\n                          ")]) : _vm._e()], 1), _vm._v(" "), (hpost._id === _vm.postData._id) ? _c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), (hpost._id !== _vm.postData._id && hpost._id === _vm.post.mainPost._id) ? _c('v-list-item-action', [_c('v-tooltip', {
      attrs: {
        "float-right": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey"
            }
          }, on), [_vm._v("check_circle_outline")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Influencer & Client will see this version of draft.")])])], 1) : _vm._e()], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.setPrimaryPost(_vm.postData._id)
      }
    }
  }, [_vm._v("\n                        Change to this version\n                      ")])], 1), _vm._v(" "), (_vm.postData.status <= _vm.postStatusConfig.CLIENT_PENDING && _vm.postData.abuse_resolved && _vm.saleActions) ? _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticClass: "success",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.releaseAbuseResolvedPosts([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                        Release to Client\n                        "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("done_all")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": _vm.mainViewGrid,
      "xs": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [(_vm.influencerData && !_vm.mappedInfluencerData) ? _c('div', [_c('div', [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.influencers && _vm.postData.influencers.length > 1 && this.currentUserRole <= _vm.userRoles.AD_STRATEGIST) ? _c('div', [(_vm.postData.defaultInf) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [(_vm.postData.defaultInf.tiktok) ? _c('a', {
          attrs: {
            "href": 'https://www.tiktok.com/@' + _vm.postData.defaultInf.handle,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(_vm.postData.defaultInf.handle))]) : (_vm.postData.defaultInf.youtube) ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/' + _vm.postData.defaultInf.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.postData.defaultInf.handle))], 1) : _c('a', {
          attrs: {
            "href": 'https://instagram.com/' + _vm.postData.defaultInf.handle,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.postData.defaultInf.handle))], 1), _vm._v(" "), _c('v-icon', {
          staticClass: "ml-2",
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("mdi-chevron-down-circle")])], 1)]
      }
    }], null, false, 316165323)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postData.influencers), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePlatform(obj, i)
        }
      }
    }, [_c('v-list-item-title', [(obj.tiktok) ? _c('a', [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
  }), 1)], 1) : _vm._e()], 1) : _c('div', [(_vm.influencerData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'xiaohongshu') ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + _vm.influencerData.username)
      }
    }
  }, [_vm._v(_vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)])]), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.type) ? _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [(_vm.getPostTypeMeta(_vm.postData.type).imgIcon) ? _c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.getPostTypeMeta(_vm.postData.type).imgIcon,
      "width": "15px",
      "height": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('v-icon', {
    staticClass: "mr-1",
    style: (("color: " + (_vm.getPostTypeMeta(_vm.postData.type).iconColor || '#ffffff') + " !important;")),
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.getPostTypeMeta(_vm.postData.type).icon))]), _vm._v("\n                          " + _vm._s(_vm._f("platformDisplayName")(_vm.postData.type)) + "\n                        ")], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "0",
            "padding": "0",
            "margin-left": "-5px"
          },
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', _vm._g({
          staticClass: "ml-2",
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, on), [_vm._v("mdi-chevron-down-circle")])], 1)]
      }
    }], null, false, 970486711)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postTypes), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePostType(obj)
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(obj.imgIcon) ? _c('img', {
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": obj.imgIcon,
        "width": "20px",
        "height": "20px",
        "alt": "",
        "aria-hidden": "true"
      }
    }) : _c('v-icon', {
      style: (("color: " + (obj.iconColor || '#616161') + " !important;")),
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(obj.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                                " + _vm._s(_vm._f("platformDisplayName")(obj.type)) + "\n                              ")])], 1)
  }), 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.mappedInfluencerData && this.currentUserRole <= _vm.userRoles.AD_STRATEGIST) ? _c('div', [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [(_vm.mappedInfluencerData.tiktokHandle) ? _c('a', {
    attrs: {
      "href": 'https://tiktok.com/' + _vm.mappedInfluencerData.tiktokHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.tiktokHandle))]) : (_vm.mappedInfluencerData.youtubeHandle) ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.mappedInfluencerData.youtubeHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.youtubeHandle))], 1) : (_vm.mappedInfluencerData.linkedinHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.mappedInfluencerData.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.linkedinHandle))], 1) : (_vm.postData.type === 'twitter' || _vm.mappedInfluencerData.twitterHandle) ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + (_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.twitterHandle || _vm.mappedInfluencerData.instagramHandle))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.mappedInfluencerData.instagramHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.mappedInfluencerData.instagramHandle))], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData.type) ? _c('v-chip', {
    attrs: {
      "color": "primary"
    }
  }, [(_vm.getPostTypeMeta(_vm.postData.type).imgIcon) ? _c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.getPostTypeMeta(_vm.postData.type).imgIcon,
      "width": "15px",
      "height": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('v-icon', {
    staticClass: "mr-1",
    style: (("color: " + (_vm.getPostTypeMeta(_vm.postData.type).iconColor || '#ffffff') + " !important;")),
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.getPostTypeMeta(_vm.postData.type).icon))]), _vm._v("\n                        " + _vm._s(_vm._f("platformDisplayName")(_vm.postData.type)) + "\n                      ")], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "0",
            "padding": "0",
            "margin-left": "-5px"
          },
          attrs: {
            "dark": "",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', _vm._g({
          staticClass: "ml-2",
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, on), [_vm._v("mdi-chevron-down-circle")])], 1)]
      }
    }], null, false, 970486711)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postTypes), function(obj, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          return _vm.changePostType(obj)
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(obj.imgIcon) ? _c('img', {
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": obj.imgIcon,
        "width": "20px",
        "height": "20px",
        "alt": "",
        "aria-hidden": "true"
      }
    }) : _c('v-icon', {
      style: (("color: " + (obj.iconColor || '#616161') + " !important;")),
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(obj.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("\n                              " + _vm._s(_vm._f("platformDisplayName")(obj.type)) + "\n                            ")])], 1)
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.influencerData) ? _c('v-col', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("\n                      Submitted By:\n                      "), _vm._v(" "), (_vm.influencerData.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : (_vm.influencerData.platform === 'youtube') ? _c('a', {
    attrs: {
      "href": 'https://youtube.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.influencerData.platform === 'linkedin') ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1) : (_vm.postData.type === 'twitter' || _vm.influencerData.platform === 'twitter') ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + _vm.influencerData.username,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.influencerData.username))]) : _c('a', {
    attrs: {
      "href": 'https://instagram.com/' + _vm.influencerData.username,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.influencerData.username))], 1)])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCutOffView) ? _c('div', [_c('v-row', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "xs": "12"
    }
  }, [_c('v-switch', {
    staticClass: "float-right",
    attrs: {
      "label": "Preview Tiktok"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('tiktok')
      }
    },
    model: {
      value: (_vm.isTikTokCutOff),
      callback: function($$v) {
        _vm.isTikTokCutOff = $$v
      },
      expression: "isTikTokCutOff"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "float-right pr-4",
    attrs: {
      "label": "Preview IG Story"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IGStory')
      }
    },
    model: {
      value: (_vm.isIGStory),
      callback: function($$v) {
        _vm.isIGStory = $$v
      },
      expression: "isIGStory"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "float-right pr-5",
    attrs: {
      "label": "Preview IG Reel"
    },
    on: {
      "change": function($event) {
        return _vm.changeCutOff('IG')
      }
    },
    model: {
      value: (_vm.isIGCutOff),
      callback: function($$v) {
        _vm.isIGCutOff = $$v
      },
      expression: "isIGCutOff"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "container--fluid": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.images.length === 0,
      "color": "secondary",
      "icon": "secondary",
      "outlined": ""
    }
  }, [_vm._v("\n                    No Media found for this post.\n                  ")]), _vm._v(" "), (_vm.images !== undefined) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "justify-space-around": ""
    }
  }, _vm._l((_vm.images), function(img, imageIndex) {
    return _c('v-flex', {
      key: img && img.url ? img.url : ("missing-media-" + imageIndex),
      attrs: {
        "md4": "",
        "xs12": ""
      }
    }, [(_vm.isMissingMedia(img)) ? _c('v-card', {
      staticClass: "mb-3",
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "warning",
        "outlined": ""
      }
    }, [_vm._v("\n                          This media file is missing. Edit the draft and upload it again.\n                        ")])], 1) : (img.publicID && img.isvideo) ? _c('v-card', {
      staticClass: "mb-3",
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          videoDownload: true,
          overlay: true,
          overlayType: _vm.overlayType,
          postView: true
        })
      }
    })], 1) : (img.isvideo && img.url.includes('s3-ap-southeast-1')) ? _c('v-card', {
      staticClass: "mb-3",
      staticStyle: {
        "max-width": "258px"
      },
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          videoDownload: true,
          overlay: true,
          overlayType: _vm.overlayType,
          postView: true
        })
      }
    })], 1) : _c('v-card', {
      attrs: {
        "text": "",
        "tile": ""
      }
    }, [(!img.isvideo) ? _c('v-hover', [(img.publicID) ? _c('div', {
      staticClass: "cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.viewMedia(img)
        }
      }
    }, [_c('custom-media-v2', {
      attrs: {
        "media": _vm.campaignHelper.customPostMediaConfig(img, {
          trans: {
            width: 320,
            crop: 'scale'
          },
          overlay: true,
          overlayType: _vm.overlayType
        })
      }
    })], 1) : _c('v-img', {
      staticClass: "grey lighten-2 mx-auto",
      class: ("elevation-" + (_vm.hover ? 12 : 2)),
      attrs: {
        "src": img.thumbnail || img.url,
        "lazy-src": img.url,
        "aspect-ratio": "1"
      },
      on: {
        "click": function($event) {
          return _vm.viewMedia(img.url, img.video)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (img.isvideo) ? _c('div', {
      staticClass: "elevation-8"
    }, [_c('video', {
      attrs: {
        "id": "previewVideo",
        "width": "100%",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": img.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n                            Your browser does not support the video tag.\n                          ")])]) : _vm._e()], 1)], 1)
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.postData.captionText) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    staticClass: "post-caption-textarea",
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": _vm.captionLabel,
      "counter": ""
    },
    model: {
      value: (_vm.postData.captionText),
      callback: function($$v) {
        _vm.$set(_vm.postData, "captionText", $$v)
      },
      expression: "postData.captionText"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isVideoLink) ? _c('div', [(_vm.postData.vdoLink) ? _c('div', {
    staticClass: "caption-label"
  }, [_vm._v("\n                    Link\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.postData.vdoLink) ? _c('div', {
    staticClass: "caption-text"
  }, [_c('span', {
    staticClass: "caption-text__value"
  }, [_vm._v(_vm._s(_vm.postData.vdoLink))]), _vm._v(" "), (_vm.getVideoLink(_vm.postData.vdoLink)) ? _c('v-btn', {
    attrs: {
      "href": _vm.getVideoLink(_vm.postData.vdoLink),
      "target": "_blank",
      "rel": "noopener noreferrer",
      "icon": "",
      "x-small": "",
      "color": "secondary",
      "title": "Open video link"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isRemark) ? _c('div', {
    staticClass: "body-1"
  }, [_c('div', {
    staticClass: "kobe-remark-display"
  }, [_c('div', {
    staticClass: "kobe-remark-display__label"
  }, [_vm._v("Kobe Remark")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderHTML(_vm.postData.remark))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isHashTag) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Mandatory Hashtag & Mentions",
      "counter": ""
    },
    model: {
      value: (_vm.postData.mandatoryHashtag),
      callback: function($$v) {
        _vm.$set(_vm.postData, "mandatoryHashtag", $$v)
      },
      expression: "postData.mandatoryHashtag"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCallToActionLinks) ? _c('div', {
    staticClass: "body-1"
  }, [_c('v-textarea', {
    attrs: {
      "readonly": "",
      "filled": "",
      "auto-grow": "",
      "rows": "4",
      "label": "Call to Action Links",
      "counter": ""
    },
    model: {
      value: (_vm.postData.callToActionLinks),
      callback: function($$v) {
        _vm.$set(_vm.postData, "callToActionLinks", $$v)
      },
      expression: "postData.callToActionLinks"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [(_vm.postData.postDate) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Scheduled: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.postDate))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.postDateEnd ? ("  to " + (_vm.postData.postDateEnd)) : ''))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Status: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postStatusDisplay))])])], 1), _vm._v(" "), (_vm.postData.abuse_resolved || _vm.postData.release_abuse_resolved) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check")]), _vm._v(" "), _c('span', [_vm._v("Abuse Resolved")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.postData.postURL) ? _c('div', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-chip', {
    staticClass: "subtitle-1 ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('v-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('strong', [_c('a', {
    attrs: {
      "href": _vm.postData.postURL,
      "target": "_blink"
    }
  }, [_vm._v("View Live Post")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [(_vm.postData.requestDate) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading-1 ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Request Date: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.requestDate))])])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.requestDate && _vm.postData.propose_dates) ? _c('div', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-chip', {
    staticClass: "subheading-1 ma-1",
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("Propose Dates: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.postData.propose_dates.map(function (p) { return p; }).join(', ')))])])], 1) : _vm._e()]), _vm._v(" "), (_vm.proposeDateActions) ? _c('v-card-actions', {
    staticClass: "mt-2",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.overRideBySuperAdmin || (_vm.postData.status === _vm.postStatusConfig.APPROVE && _vm.postData.requestDate)) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openProposeDateDialog()
      }
    }
  }, [_vm._v("\n                    Propose new Dates\n                    "), _c('v-icon', {
    attrs: {
      "small": "",
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "success"
    },
    on: {
      "click": _vm.invokeConfirmDateChange
    }
  }, [_vm._v("\n                    Confirm Date\n                    "), _c('v-icon', {
    attrs: {
      "small": "",
      "float-right": ""
    }
  }, [_vm._v("check")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.influencerActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("\n                    Edit Draft\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.overRideBySuperAdmin ? _vm.overRideBySuperAdmin : _vm.csActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("\n                    Edit Draft\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.editLiveDate()
      }
    }
  }, [_vm._v("\n                    Edit Live Date\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.postData.status !== _vm.postStatusConfig.CLIENT_PENDING && _vm.postData.status !== _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.approve()
      }
    }
  }, [_vm._v("\n                    Submit Draft to AM\n                    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.status >= _vm.postStatusConfig.CLIENT_PENDING && !_vm.postData.metadataTagged) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.markMetadataTag([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                    Mark As Metadata Tagged\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.status >= _vm.postStatusConfig.CLIENT_PENDING && _vm.isIncludeInAbuseReport(_vm.postData._id, _vm.clientReportAbuseData) && !_vm.postData.abuse_resolved && !_vm.postData.release_abuse_resolved) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.abuseResolvePosts([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                    Mark As Abuse Resolved\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.status === _vm.postStatusConfig.AD_STRATEGIST_PENDING && _vm.postData.campaignID && _vm.campaign.campaignType !== _vm.campaignTypes.STORY_TELL) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.directRelease()
      }
    }
  }, [_vm._v("\n                    Direct Release to Client\n                    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.overRideBySuperAdmin ? _vm.overRideBySuperAdmin : _vm.saleActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.postData.abuse_resolved) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.releaseAbuseResolvedPosts([_vm.postData._id])
      }
    }
  }, [_vm._v("\n                    Release to Client\n                    "), _c('v-icon', {
    attrs: {
      "float-right": ""
    }
  }, [_vm._v("done_all")])], 1) : _vm._e(), _vm._v(" "), ((_vm.postData.status === _vm.postStatusConfig.AD_STRATEGIST_PENDING && _vm.postData.waiting_release)) ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.release()
      }
    }
  }, [_vm._v("\n                    Release to Client\n                    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.clientReportAbuse.length < 1 && _vm.clientActions) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.postData.propose_dates && _vm.postData.status === _vm.postStatusConfig.CLIENT_PENDING) ? _c('v-btn', {
    attrs: {
      "color": "indigo",
      "dark": "",
      "to": {
        name: 'posts-submission-review',
        query: {
          id: _vm.postData._id
        }
      }
    }
  }, [_vm._v("Start Submission Review")]) : _vm._e(), _vm._v(" "), (_vm.postData.propose_dates && _vm.postData.status !== _vm.postStatusConfig.APPROVE) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.openChooseDateDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("check")]), _vm._v(" Approve Date\n                  ")], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.cs_inf_chatbox) ? _c('v-flex', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "subtitle-1"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("message")]), _vm._v("\n                          " + _vm._s(_vm.conversationWithName) + " (" + _vm._s(_vm.messages.length) + ")\n                        ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-container', [_c('chat-box', {
    attrs: {
      "label": _vm.commentToLabel,
      "messages": _vm.messages
    },
    on: {
      "commented": _vm.sendMessage
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client_inf_chatbox) ? _c('v-flex', [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('div', {
    staticClass: "subtitle-2"
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("message")]), _vm._v("\n                          Internal Notes (for your internal communication only, neither Kobe nor the creators would have access to these notes)\n                        ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-container', [_c('chat-box', {
    attrs: {
      "label": "",
      "messages": _vm.clientMessages,
      "isClient": _vm.isClient,
      "type": "internal_notes"
    },
    on: {
      "commented": _vm.sendClientMessage
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.postReviewApproved) ? _c('v-flex', {
    attrs: {
      "centered": ""
    }
  }, [(_vm.postData.clientAcceptReview) ? _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v("Rating on influencer's quality of work")]), _vm._v(" "), _c('v-rating', {
    staticClass: "ma-5",
    attrs: {
      "color": "secondary",
      "size": "30",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.postData.clientAcceptReview.rate),
      callback: function($$v) {
        _vm.$set(_vm.postData.clientAcceptReview, "rate", $$v)
      },
      expression: "postData.clientAcceptReview.rate"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.postData.clientAcceptReview.rate) + "/5 stars Rated")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-1",
    attrs: {
      "max-width": "100"
    }
  }, [_c('p', [_vm._v("Comment for Influencer")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "text": "",
      "filled": "",
      "readonly": ""
    },
    model: {
      value: (_vm.postData.clientAcceptReview.comment),
      callback: function($$v) {
        _vm.$set(_vm.postData.clientAcceptReview, "comment", $$v)
      },
      expression: "postData.clientAcceptReview.comment"
    }
  })], 1)])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), ((_vm.overRideBySuperAdmin || _vm.postAbuseHistory) && _vm.clientReportAbuse.length > 0) ? _c('v-col', {
    attrs: {
      "md": "3",
      "xs": "12"
    }
  }, [_c('v-expansion-panels', {
    staticClass: "report-abuse-section"
  }, _vm._l((_vm.clientReportAbuse), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "subtitle-1",
      attrs: {
        "color": "red lighten-4"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "deep-orange"
      }
    }, [_vm._v("report_problem")]), _vm._v("\n                    Reported Abuse\n                  ")], 1)]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "report-abuse-expansion"
    }, [_c('v-card', [_c('v-card-text', {
      staticClass: "grey lighten-3 pl-1 pr-1"
    }, [_c('h4', [_vm._v("Reasons for Non-Approval")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.reasons), function(r) {
      return _c('li', {
        key: r
      }, [_vm._v(_vm._s(r))])
    }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Comments for Abuse:")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "max-height": "300px",
        "min-height": "200px",
        "overflow-y": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderHTML(item.comment))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-xs-right caption font-weight-italic"
    }, [_vm._v(_vm._s(_vm.formatDate(item.date)))]), _vm._v(" "), (item.files) ? _c('div', [_c('h4', [_vm._v("Uploaded Screenshots:")]), _vm._v(" "), _c('p', [_c('ol', _vm._l((item.files), function(f, index) {
      return _c('li', {
        key: index
      }, [(f.url) ? _c('a', {
        attrs: {
          "href": f.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.utilsFunc.getFileNameFromURL(f.url)))]) : _vm._e()])
    }), 0)])]) : _vm._e()])], 1)], 1)], 1)
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('post-media-viewer-modal', {
    attrs: {
      "viewerValue": _vm.mediaViewerDialog,
      "media": _vm.mediaItem,
      "videoPlayer": _vm.videoPlayer
    },
    on: {
      "closed": _vm.closeMediaViewerModal
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.postData !== null) ? _c('view-post-detail-modal', {
    attrs: {
      "campaignName": _vm.postData.campaignName,
      "submittedCampaignName": _vm.postData.submittedCampaignName,
      "postDetails": _vm.postDetails,
      "postReviewApproved": _vm.postReviewApproved,
      "influencerData": _vm.influencerData,
      "mappedInfluencerData": _vm.mappedInfluencerData,
      "postAbuseHistory": _vm.postAbuseHistory,
      "clientReportAbuse": _vm.clientReportAbuse,
      "detailValue": _vm.viewPostDetailDialog,
      "userObj": _vm.userObj
    },
    on: {
      "detailClosed": _vm.closeDetailModal
    }
  }) : _vm._e(), _vm._v(" "), _c('propose-date-modal', {
    attrs: {
      "post": _vm.postData,
      "proposeDialogValue": _vm.proposeDateDialog
    },
    on: {
      "proposeClosed": _vm.closeProposeDateModal
    }
  }), _vm._v(" "), _c('client-choose-date-modal', {
    attrs: {
      "post": _vm.postData,
      "ChooseDateDialogValue": _vm.chooseDateDialog
    },
    on: {
      "chooseDateClosed": _vm.closeChooseDateModal
    }
  }), _vm._v(" "), _c('v-dialog', {
    ref: "dateDialog",
    attrs: {
      "return-value": _vm.confirmDate,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.confirmDate = $event
      },
      "update:return-value": function($event) {
        _vm.confirmDate = $event
      }
    },
    model: {
      value: (_vm.changeConfirmDate),
      callback: function($$v) {
        _vm.changeConfirmDate = $$v
      },
      expression: "changeConfirmDate"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.post ? _vm.post.postDate : ''
    },
    model: {
      value: (_vm.confirmDate),
      callback: function($$v) {
        _vm.confirmDate = $$v
      },
      expression: "confirmDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.changeConfirmDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.saveConfirmDate
    }
  }, [_vm._v("OK")])], 1)], 1), _vm._v(" "), _c('propose-date-modal', {
    attrs: {
      "post": _vm.postData,
      "proposeDialogValue": _vm.proposeDateDialog
    },
    on: {
      "proposeClosed": _vm.closeProposeDateModal
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isView),
      expression: "!isView"
    }],
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n            " + _vm._s(item.name) + "  \n            "), (item.lockedCOGS) ? _c('v-chip', {
          attrs: {
            "color": "error",
            "small": ""
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_c('v-icon', _vm._g({
          attrs: {
            "small": "",
            "left": ""
          }
        }, _vm.on), [_vm._v("mdi-lock")]), _vm._v(" Locked COGS")], 1)]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.campaignID),
      callback: function($$v) {
        _vm.campaignID = $$v
      },
      expression: "campaignID"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 secondary",
    staticStyle: {
      "height": "56px"
    },
    attrs: {
      "disabled": !_vm.campaignCOEB.campaignId,
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.refreshPairingInfFromIMS(_vm.campaignCOEB)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-cached")]), _vm._v(" Refresh\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.campaignCOEB) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#CFD8DC"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Campaign Name: " + _vm._s(_vm.campaignCOEB.campaignName || 'N/A') + "\n          "), (_vm.campaignCOEB.lockedCOGS) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && _vm.disableLockedCOGS) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openLockedCOGSDialog(_vm.campaignCOEB)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Request Unlock\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.disableLockedCOGS && !_vm.isView) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaignCOEB, false)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open")]), _vm._v(" Unlock\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.showLockBtn) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.changeLock(_vm.campaignCOEB, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock")]), _vm._v(" Lock\n          ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Client Name: " + _vm._s(_vm.campaignCOEB.clientName || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pt-2"
  }, [_vm._v("\n          IO Number: " + _vm._s(_vm.campaignCOEB.ioNumbers || 'N/A') + "\n        ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), (_vm.measurement.totalPercentage && _vm.measurement.totalPercentage !== 'NaN' && _vm.measurement.totalPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), (_vm.measurement.outreachPercentage && _vm.measurement.outreachPercentage !== 'NaN' && _vm.measurement.outreachPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), (_vm.measurement.engagementPercentage && _vm.measurement.engagementPercentage !== 'NaN' && _vm.measurement.engagementPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [(_vm.budget) ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : 0")]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), (_vm.measurement.cogsPercentage && _vm.measurement.cogsPercentage !== 'NaN' && _vm.measurement.cogsPercentage !== 'Infinity') ? _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")]) : _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: -")])])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 flex-row-reverse",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [(_vm.selectedItems && _vm.selectedItems.length > 0) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleEstimatedLiveDateDialog()
      }
    }
  }, [_vm._v("Update Estimated Live Month (" + _vm._s(_vm.selectedItems.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.selectedItems && _vm.selectedItems.length > 0) ? _c('v-btn', {
    staticClass: "ml-2 secondary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleSubmissionDateDialog()
      }
    }
  }, [_vm._v("Update Submission Date (" + _vm._s(_vm.selectedItems.length) + ")")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.briefConfirmationSearch),
      callback: function($$v) {
        _vm.briefConfirmationSearch = $$v
      },
      expression: "briefConfirmationSearch"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.computedPairedHeaders,
      "items": _vm.pairedInfluencers,
      "items-per-page": 10,
      "search": _vm.briefConfirmationSearch,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllItems
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', [(props.items && props.items.length === 0) ? _c('tr', [_c('td', [_vm._v("No Data")])]) : _vm._e(), _vm._v(" "), _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticStyle: {
              "min-width": "100px",
              "padding": "0 14px!important"
            }
          }, [_c('v-checkbox', {
            staticClass: "multi-select-checkbox",
            staticStyle: {
              "padding-left": "18px"
            },
            attrs: {
              "label": "",
              "color": "grey darken-2"
            },
            on: {
              "change": _vm.actionSelectChange
            },
            model: {
              value: (item.isSelected),
              callback: function($$v) {
                _vm.$set(item, "isSelected", $$v)
              },
              expression: "item.isSelected"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "invoice-handle-column"
          }, [_c('div', {
            staticClass: "d-flex align-center"
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "isLinkedIn": item.influencer_details.platform === 'linkedin',
              "isTwitter": item.influencer_details.platform === 'twitter',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isXiaohongshu": item.influencer_details.platform === 'xiaohongshu',
              "isOthers": item.influencer_details.platform === 'others',
              "tiktokHandle": item.influencer_details.instagramHandle,
              "instagramHandle": item.influencer_details.instagramHandle,
              "facebookHandle": _vm.getFacebookHandle(item.influencer_details),
              "linkedinHandle": item.influencer_details.linkedinHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle,
              "twitterHandle": item.influencer_details.twitterHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle,
              "youtubeHandle": item.influencer_details.instagramHandle,
              "otherHandle": item.influencer_details.instagramHandle,
              "xiaohongshuHandle": item.influencer_details.xhsID,
              "xiaohongshuFullName": item.influencer_details.fullName,
              "youtubeURL": item.influencer_details.url
            }
          }), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "secondary",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.linkedin) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#0A66C2",
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.twitter) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "",
                "aria-hidden": "true"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (item.influencer_details.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.influencer_details.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
            staticClass: "invoice-platform-column"
          }, [_c('span', [_vm._v(_vm._s(_vm._f("platformDisplayName")(item.platformName)))])]), _vm._v(" "), _c('td', [(item.influencer_details.followers !== undefined && item.influencer_details.followers !== null) ? _c('span', [_vm._v(_vm._s(item.influencer_details.followers))]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', [(item.influencer_details.platform !== 'facebook' && item.engagement_rate !== '0.00' && item.engagement_rate) ? _c('span', [_vm._v(_vm._s(item.influencer_details.engagement_rate) + "%")]) : (item.engagement_rate === '0.00') ? _c('span', {
            staticClass: "caption"
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Hidden"
            }
          }, [_vm._v("mdi-eye-off")])], 1) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.influencer_details.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                " + _vm._s(item.influencer_details.audience_credibility) + "\n              ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDeliverableCounts(item.deliverablesDisplay)))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(item.payoutAmount))])])], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(item.GSTpercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                      " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")((item.payoutAmount - item.GSTpercent))) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")((item.payoutAmount - item.GSTpercent))))])])], 1) : _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(item.GSTIncluded) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTpercent)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTpercent)))])])], 1) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                " + _vm._s(_vm.formatSubmissionDate(item.pairing_details.submission_date)) + "\n                "), _c('v-btn', _vm._g(_vm._b({
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }],
            attrs: {
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openUpdateSubmissionDialog(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Date")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                " + _vm._s(_vm.formatLiveMonth(item.pairing_details.estimatedLiveDate)) + "\n                "), _c('v-btn', _vm._g(_vm._b({
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }],
            attrs: {
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openEstimatedLiveDateDialog(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Date")])], 1)], 1), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }]
          }, [_c('v-btn', {
            attrs: {
              "color": "primary",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.viewClick(item, 0)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "secondary",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Edit Invoice\n                ")], 1), _vm._v(" "), _c('v-btn', {
            staticClass: "mt-1",
            attrs: {
              "color": "primary",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.viewClick(item, 1)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "secondary",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Edit Brief\n                ")], 1)], 1), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }]
          }, [_c('div', [_c('div', [(item.contact_details && item.contact_details.email && _vm.isCampaignAM && _vm.isCampaignCC && !item.signinForm && item.pairing_details.estimatedLiveDate) ? _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.copySignInFormLink(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy link")])], 1) : _vm._e(), _vm._v(" "), (item.contact_details && !item.contact_details.email) ? _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openUpdateEmailDialog(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "color": "secondary",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), _c('span', [_vm._v("Update Email")])], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.isCampaignAM || !_vm.isCampaignCC) ? _c('v-btn', {
            staticClass: "assign-am-cc-btn mt-2 mb-2 black--text",
            attrs: {
              "small": "",
              "depressed": "",
              "color": "yellow"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-alert-circle")]), _vm._v("\n                        Assign "), (!_vm.isCampaignAM) ? _c('span', [_vm._v("AM")]) : _vm._e(), (!_vm.isCampaignCC && !_vm.isCampaignCC) ? _c('span', [_vm._v(",")]) : _vm._e(), (!_vm.isCampaignCC) ? _c('span', [_vm._v("CC")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.signingFormsForDownload(item).length) ? _c('div', {
            staticClass: "pt-1"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "mb-1",
                  attrs: {
                    "color": "success",
                    "small": "",
                    "text": ""
                  }
                }, 'v-btn', _vm.attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-download")]), _vm._v(" Download\n                          ")], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.signingFormsForDownload(item)), function(invoice, i) {
            return _c('v-list-item', {
              key: invoice.contractFile.url || i,
              attrs: {
                "href": invoice.contractFile.url,
                "target": "_blank"
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(_vm.utilsFunc.formatCustomDate(invoice.contractFile.timestamp || invoice.createdAt, 'DD/MM/YYYY hh:mm:ss A')))])], 1)
          }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.signinForm && !item.pairing_details.estimatedLiveDate) ? _c('span', [_vm._v("(Please update estimate live month)")]) : _vm._e()], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.copyContentScriptFormLink(item)
              }
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy link")])], 1)], 1)]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.isView),
              expression: "!isView"
            }]
          }, [_c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "success",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.viewClick(item, 2)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-send")]), _vm._v(" Preview and Send\n                ")], 1), _vm._v(" "), (item.payout_details && item.payout_details.status !== _vm.payoutStatus.CONFIRMED) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "success",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.confirmPayout(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-check")]), _vm._v(" Confirm Payout\n                ")], 1) : _vm._e(), _vm._v(" "), (item.payout_details && item.payout_details.status === _vm.payoutStatus.CONFIRMED) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "error",
              "small": "",
              "disabled": _vm.disableLockedCOGS
            },
            on: {
              "click": function($event) {
                return _vm.cancelPayout(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-cancel")]), _vm._v(" Cancel Payout\n                ")], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.sentStatus === _vm.pairingSendStatus.DRAFT) ? _c('v-chip', {
            attrs: {
              "color": "info",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("new_releases")]), _vm._v("  " + _vm._s(_vm.pairingSendStatusDisplay[item.sentStatus]) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.sentStatus === _vm.pairingSendStatus.SENT) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v("  " + _vm._s(_vm.pairingSendStatusDisplay[item.sentStatus]) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.sentStatus === _vm.pairingSendStatus.SIGNED) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v("  " + _vm._s(_vm.pairingSendStatusDisplay[item.sentStatus]) + "\n                ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "mt-1 mb-1"
          }, [((item.payout_details && item.payout_details.status !== _vm.payoutStatus.CONFIRMED) && (item.pairingStatus && item.pairingStatus === _vm.pairingStatus.ACCEPTED.value) && !_vm.isView) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "error",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.cancelAccept(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-close")]), _vm._v(" Remove\n                  ")], 1) : _vm._e()], 1)], 1)])
        })], 2)]
      }
    }]),
    model: {
      value: (_vm.selectedItems),
      callback: function($$v) {
        _vm.selectedItems = $$v
      },
      expression: "selectedItems"
    }
  })], 1)], 1), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.dialog,
      "influencer": _vm.influencer,
      "influencerProfile": _vm.influencerProfile,
      "selectedTab": _vm.selectedTab,
      "briefDetailContent": _vm.briefDetailsHTML,
      "close": _vm.closeModal,
      "newPairingFlow": true,
      "isDownload": _vm.invoiceDownload,
      "isFinalPayout": _vm.isFinalPayout
    },
    on: {
      "loadInfluencer": _vm.loadInfluencerData,
      "reRenderDatTable": _vm.loadInfluencerData,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.signinFormLink
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-concept-link"
    },
    domProps: {
      "value": _vm.conceptFormLink
    }
  }), _vm._v(" "), _c('view-signin-form-modal', {
    attrs: {
      "value": _vm.viewSigninFormModalDialog,
      "signinFormData": _vm.viewSigninFormData
    },
    model: {
      value: (_vm.viewSigninFormModalDialog),
      callback: function($$v) {
        _vm.viewSigninFormModalDialog = $$v
      },
      expression: "viewSigninFormModalDialog"
    }
  }), _vm._v(" "), _c('update-creator-email-modal', {
    attrs: {
      "value": _vm.updateCreatorEmailDialog,
      "pairing": _vm.viewPairingData
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateCreatorEmailDialog),
      callback: function($$v) {
        _vm.updateCreatorEmailDialog = $$v
      },
      expression: "updateCreatorEmailDialog"
    }
  }), _vm._v(" "), _c('update-submission-date-modal', {
    attrs: {
      "value": _vm.updateSubmissionDateDialog,
      "pairing": _vm.viewPairingData
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateSubmissionDateDialog),
      callback: function($$v) {
        _vm.updateSubmissionDateDialog = $$v
      },
      expression: "updateSubmissionDateDialog"
    }
  }), _vm._v(" "), _c('estimated-live-date-modal', {
    attrs: {
      "value": _vm.updateEstimatedLiveDateDialog,
      "pairing": _vm.viewPairingData,
      "multiplePairings": _vm.multiplePairings
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateEstimatedLiveDateDialog),
      callback: function($$v) {
        _vm.updateEstimatedLiveDateDialog = $$v
      },
      expression: "updateEstimatedLiveDateDialog"
    }
  }), _vm._v(" "), _c('submission-date-modal', {
    attrs: {
      "value": _vm.updateMultipleSubmissionDateDialog,
      "pairing": _vm.viewPairingData,
      "multiplePairings": _vm.multiplePairings
    },
    on: {
      "updated": _vm.loadInfluencerData
    },
    model: {
      value: (_vm.updateMultipleSubmissionDateDialog),
      callback: function($$v) {
        _vm.updateMultipleSubmissionDateDialog = $$v
      },
      expression: "updateMultipleSubmissionDateDialog"
    }
  }), _vm._v(" "), (_vm.viewContentScriptsData) ? _c('view-creator-concept-modal-dialog', {
    attrs: {
      "value": _vm.viewcontentScriptModalDialog,
      "data": _vm.viewContentScriptsData
    },
    model: {
      value: (_vm.viewcontentScriptModalDialog),
      callback: function($$v) {
        _vm.viewcontentScriptModalDialog = $$v
      },
      expression: "viewcontentScriptModalDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n    Copied to Clipboard!\n    "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.text) + "\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creator-search-page"
  }, [_c('section', {
    staticClass: "creator-search-panel"
  }, [_c('div', {
    staticClass: "creator-search-primary"
  }, [_c('v-text-field', {
    staticClass: "creator-search-input",
    attrs: {
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "hide-details": "",
      "label": "Search creators",
      "placeholder": "Name, handle, email, keyword or category",
      "dense": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "creator-search-submit",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.paginate()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("Search\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "creator-filters-toggle",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.filtersExpanded = !_vm.filtersExpanded
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-tune-variant")]), _vm._v("\n        Filters\n        "), (_vm.activeFilterCount) ? _c('span', {
    staticClass: "creator-filter-count"
  }, [_vm._v(_vm._s(_vm.activeFilterCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "right": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.filtersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "creator-actions-toggle",
          attrs: {
            "outlined": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-dots-horizontal")]), _vm._v("Actions\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "creator-actions-menu",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-refresh")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Reset filters")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.downloadSampleUpload
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-download")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Download template")])], 1), _vm._v(" "), (_vm.isAdminRole) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$refs.igBulkHandle.click()
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-home-import-outline")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Import creators")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminRole) ? _c('v-list-item', {
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-file-excel-outline")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Export results")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtersExpanded),
      expression: "filtersExpanded"
    }],
    staticClass: "creator-filters-accordion"
  }, [_c('div', {
    staticClass: "creator-quick-filters"
  }, [_c('span', {
    staticClass: "creator-quick-filters__label"
  }, [_vm._v("Quick filters")]), _vm._v(" "), _c('div', {
    staticClass: "creator-quick-filters__options"
  }, [_c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "IMS Onboarded",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.imsOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "imsOnly", $$v)
      },
      expression: "filters.imsOnly"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Rate Card Submitted",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.rateCardOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCardOnly", $$v)
      },
      expression: "filters.rateCardOnly"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Past Campaigns",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.pairedCreatorOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pairedCreatorOnly", $$v)
      },
      expression: "filters.pairedCreatorOnly"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "creator-filter-toggle"
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Travel Form",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.travelFormOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "travelFormOnly", $$v)
      },
      expression: "filters.travelFormOnly"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "creator-advanced-filters"
  }, [_c('div', {
    staticClass: "creator-advanced-filters__header"
  }, [_c('div', [_c('span', [_vm._v("Advanced filters")]), _vm._v(" "), _c('small', [_vm._v("Audience, campaign, travel and pricing details")])]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "#8b92a5"
    }
  }, [_vm._v("mdi-tune-variant")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "row align-left",
    staticStyle: {
      "text-align": "left",
      "justify-content": "left",
      "margin": "5px 10% 0px"
    }
  }, [_c('v-col', {
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n          ")])]
      }
    }]),
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.allTags,
      "item-text": "name",
      "item-value": "id",
      "hide-selected": "",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "chips": "",
      "label": "Tag",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n              $delete\n            ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.filters.tags),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tags", $$v)
      },
      expression: "filters.tags"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Gender",
      "items": _vm.genderOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.gender),
      callback: function($$v) {
        _vm.$set(_vm.filters, "gender", $$v)
      },
      expression: "filters.gender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Platform",
      "items": _vm.platformOptions,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-platform-option"
        }, [(item.icon) ? _c('v-icon', {
          staticClass: "creator-platform-option__icon",
          attrs: {
            "color": item.iconColor,
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          staticClass: "creator-platform-option__image",
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])], 1)]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-platform-option creator-platform-option--selected"
        }, [(item.icon) ? _c('v-icon', {
          staticClass: "creator-platform-option__icon",
          attrs: {
            "color": item.iconColor,
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          staticClass: "creator-platform-option__image",
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.platform),
      callback: function($$v) {
        _vm.$set(_vm.filters, "platform", $$v)
      },
      expression: "filters.platform"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Tier",
      "items": _vm.infTiers,
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.filters.tier),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tier", $$v)
      },
      expression: "filters.tier"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignVerticals,
      "item-value": "id",
      "item-text": "name",
      "label": "Campaign Verticals",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.vertical),
      callback: function($$v) {
        _vm.$set(_vm.filters, "vertical", $$v)
      },
      expression: "filters.vertical"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignTypeDisplayFilter,
      "item-value": "value",
      "item-text": "text",
      "label": "Type",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.campaignType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "campaignType", $$v)
      },
      expression: "filters.campaignType"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.ageGroupDisplayFilter,
      "item-value": "value",
      "item-text": "text",
      "label": "Age Group",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ageGroup", $$v)
      },
      expression: "filters.ageGroup"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "DOBDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Date of Birth",
            "placeholder": "Date of Birth",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "clearable": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.filters.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.filters, "dateOfBirth", $$v)
            },
            expression: "filters.dateOfBirth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dateOfBirthCal),
      callback: function($$v) {
        _vm.dateOfBirthCal = $$v
      },
      expression: "dateOfBirthCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filters.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateOfBirth", $$v)
      },
      expression: "filters.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelDOB()
      }
    }
  }, [_vm._v("\n              Cancel\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.okDOB()
      }
    }
  }, [_vm._v("\n              OK\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-text-field', _vm._g(_vm._b({
    attrs: {
      "type": "number",
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "clearable": "",
      "placeholder": "Age"
    },
    model: {
      value: (_vm.filters.age),
      callback: function($$v) {
        _vm.$set(_vm.filters, "age", $$v)
      },
      expression: "filters.age"
    }
  }, 'v-text-field', _vm.attrs, false), _vm.on))], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "220px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3"
    }
  }, [_c('v-text-field', _vm._g(_vm._b({
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "clearable": "",
      "placeholder": "Travel Destinations"
    },
    model: {
      value: (_vm.filters.travelCountry),
      callback: function($$v) {
        _vm.$set(_vm.filters, "travelCountry", $$v)
      },
      expression: "filters.travelCountry"
    }
  }, 'v-text-field', _vm.attrs, false), _vm.on))], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "DOBDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Travel Period",
            "placeholder": "Travel Period",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "clearable": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.filters.travelDate),
            callback: function($$v) {
              _vm.$set(_vm.filters, "travelDate", $$v)
            },
            expression: "filters.travelDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.travelDateCal),
      callback: function($$v) {
        _vm.travelDateCal = $$v
      },
      expression: "travelDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filters.travelDate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "travelDate", $$v)
      },
      expression: "filters.travelDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelTravelDate()
      }
    }
  }, [_vm._v("\n              Cancel\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.okTravelDate()
      }
    }
  }, [_vm._v("\n              OK\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "310px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "outlined": "",
      "clearable": "",
      "items": _vm.allCampaigns,
      "label": "Campaign",
      "item-value": "name",
      "hide-details": "",
      "item-text": "fullName"
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n            " + _vm._s(item.fullName) + "\n          ")])]
      }
    }]),
    model: {
      value: (_vm.filters.campaign),
      callback: function($$v) {
        _vm.$set(_vm.filters, "campaign", $$v)
      },
      expression: "filters.campaign"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "max-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false,
      "min-width": "300px",
      "max-width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "creator-rate-filter",
          attrs: {
            "value": _vm.rateFilterLabel,
            "label": "Rate",
            "append-icon": "mdi-menu-down",
            "outlined": "",
            "dense": "",
            "readonly": "",
            "clearable": "",
            "hide-details": "auto"
          },
          on: {
            "click:clear": function($event) {
              $event.stopPropagation();
              return _vm.clearRateFilter.apply(null, arguments)
            }
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.rateFilterMenu),
      callback: function($$v) {
        _vm.rateFilterMenu = $$v
      },
      expression: "rateFilterMenu"
    }
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                Content Type\n                "), _c('v-select', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.contentTypes,
      "item-text": "title",
      "item-value": "value"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-content-type-option",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "creator-content-type-option creator-content-type-option--selected",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.contentType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "contentType", $$v)
      },
      expression: "filters.contentType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                Currency\n                "), _c('v-combobox', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.filters.rateCurrency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCurrency", $$v)
      },
      expression: "filters.rateCurrency"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                From\n                "), _c('v-text-field', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "from", $$v)
      },
      expression: "filters.rate.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                To\n                "), _c('v-text-field', {
    staticClass: "creator-rate-popover-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "to", $$v)
      },
      expression: "filters.rate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "creator-rate-filter-actions"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearRateFilter()
      }
    }
  }, [_vm._v("\n              Clear all\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.applyRateFilter()
      }
    }
  }, [_vm._v("\n              Apply\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('section', {
    staticClass: "creator-results-panel"
  }, [_c('div', {
    staticClass: "creator-results-toolbar"
  }, [_c('div', [(_vm.selectedLists.length === 0) ? _c('span', {
    staticClass: "creator-results-count"
  }, [_c('strong', [_vm._v(_vm._s(_vm.totalItems || 0))]), _vm._v(" creators\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLists.length > 0 && _vm.isSuperAdmin),
      expression: "selectedLists.length > 0 && isSuperAdmin"
    }],
    attrs: {
      "small": "",
      "color": "red",
      "disabled": !_vm.selectedLists || _vm.selectedLists.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteMultipleInf()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-delete-forever")]), _vm._v(" Delete (" + _vm._s(_vm.selectedLists.length) + ")")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right creator-results-toolbar__actions"
  }, [_c('v-menu', {
    staticStyle: {
      "margin-left": "-25px"
    },
    attrs: {
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                  Sort By\n                  "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.sortColumns,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                  Type\n                  "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-20px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate()
      }
    }
  }, [_vm._v("\n                Apply\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg"
        })])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Column settings")])])], 1)]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "id": "search-creator-table",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "loading": _vm.loading,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "items-per-page": 20,
      "show-select": "",
      "item-key": "_id"
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "toggle-select-all": _vm.selectAllLists
    },
    scopedSlots: _vm._u([{
      key: ("item." + (_vm.customSlots.instagram)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['instagram']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": true,
            "isTikTok": false,
            "isYoutube": false,
            "instagramHandle": item['instagram'],
            "divClassName": "float-left"
          }
        }), _vm._v(" "), (item.igCheck) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green",
                  "small": ""
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (item.igCheck === false) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "red",
                  "small": ""
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("cancel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.tiktok)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['tiktok']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": false,
            "isTikTok": true,
            "isYoutube": false,
            "tiktokHandle": item['tiktok'],
            "divClassName": "float-left"
          }
        }), _vm._v(" "), (item.tiktokCheck) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (item.tiktokCheck === false) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "red"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("cancel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.youtube)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['youtube']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": false,
            "isTikTok": false,
            "isYoutube": true,
            "youtubeHandle": item['youtube'],
            "divClassName": "float-left"
          }
        }), _vm._v(" "), (item.youtubeCheck) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (item.youtubeCheck === false) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "red"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("cancel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e()], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.linkedin)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(_vm.getLinkedInHandle(item)) ? _c('div', [_c('social-handle', {
          attrs: {
            "isLinkedIn": true,
            "linkedinHandle": _vm.getLinkedInHandle(item),
            "divClassName": "float-left"
          }
        })], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.twitter)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(_vm.getTwitterHandle(item)) ? _c('div', [_c('social-handle', {
          attrs: {
            "isTwitter": true,
            "twitterHandle": _vm.getTwitterHandle(item),
            "divClassName": "float-left"
          }
        })], 1) : _vm._e()])])]
      }
    }, {
      key: "item.xiaohongshu",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [(item['xiaohongshu']) ? _c('div', [_c('social-handle', {
          attrs: {
            "isInstagram": false,
            "isTikTok": false,
            "isYoutube": false,
            "isXiaohongshu": true,
            "xiaohongshuHandle": item['xiaohongshu'],
            "xiaohongshuFullName": item['xhsFullName'],
            "divClassName": "float-left"
          }
        })], 1) : _vm._e()])])]
      }
    }, {
      key: ("item." + (_vm.customSlots.type)),
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(_vm.getTypeText(item.type)) + "\n          ")])])]
      }
    }, {
      key: "item.pastCampaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [(item.campaignsCount) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "color": "#CFD8DC",
            "text-color": "black",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openCampaignListsModal(item, false)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_vm._v("Campaigns  "), _c('strong', [_vm._v("(" + _vm._s(item.campaignsCount) + ")")])])]) : _vm._e(), _vm._v(" "), (!item.campaignsCount && item.pastCampaigns) ? _c('div', _vm._l((item.pastCampaigns), function(preferred, index) {
          return _c('div', {
            key: index
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(preferred))])], 1)
        }), 0) : _vm._e()], 1)])]
      }
    }, {
      key: "item.instagramFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['instagramFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['instagramFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.tiktokFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['tiktokFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['tiktokFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.youtubeFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['youtubeFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['youtubeFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.linkedinFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "170px"
          }
        }, [(_vm.getLinkedInFollowers(item) !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.getLinkedInFollowers(item))))]) : _c('span', [_vm._v("-")])])])]
      }
    }, {
      key: "item.twitterFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "170px"
          }
        }, [(_vm.getTwitterFollowers(item) !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.getTwitterFollowers(item))))]) : _c('span', [_vm._v("-")])])])]
      }
    }, {
      key: "item.xhsFollowers",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [(item['xhsFollowers']) ? _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item['xhsFollowers'])) + "\n          ")]) : _vm._e()])]
      }
    }, {
      key: "item.email",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right pa-2"
        }, [(item.emailEdit) ? _c('div', [_c('v-text-field', {
          staticStyle: {
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: (item.email),
            callback: function($$v) {
              _vm.$set(item, "email", $$v)
            },
            expression: "item.email"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateImportedCreator(item, 'email')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeImportedCreatorEdit('emailEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.emailEdit) ? _c('div', [(item.email) ? _c('v-chip', {
          staticStyle: {
            "min-width": "20px"
          },
          attrs: {
            "small": "",
            "color": "default"
          }
        }, [_vm._v("\n              " + _vm._s(item.email) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeImportedCreatorEdit('emailEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Email")])])], 1)], 1) : _vm._e()])]
      }
    }, {
      key: "item.dateOfBirth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n          " + _vm._s(item.dateOfBirth ? _vm.utils.formatCustomDate(item.dateOfBirth, 'DD MMM, YYYY') : '') + "\n        ")])]
      }
    }, {
      key: "item.ageGroup",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n          " + _vm._s(item.ageGroup || '') + "\n        ")])]
      }
    }, {
      key: "item.shortDescription",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_c('p', {
          staticClass: "remark-text",
          staticStyle: {
            "margin-bottom": "0"
          }
        }, [_vm._v(_vm._s(item.shortDescription || '-'))]), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.shortDescription),
            expression: "item.shortDescription"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.shortDescription && item.shortDescription.length > 1),
                  expression: "item.shortDescription && item.shortDescription.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Short Description")]), _vm._v(" "), _c('v-divider'), _vm._v("                                    \n                  " + _vm._s(item.shortDescription) + "\n                ")], 1)], 1)], 1)], 1)])]
      }
    }, {
      key: "item.ccRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [(item.ccRemarksCount) ? _c('div', [(item.ccRemarksCount) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "color": "#CFD8DC",
            "text-color": "black",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openCampaignListsModal(item, true)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_c('strong', [_vm._v("Remarks (" + _vm._s(item.ccRemarksCount) + ")")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.campaignsCount && item.pastCampaigns) ? _c('div') : _vm._e()])])]
      }
    }, {
      key: "item.statsAnalysis",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-center"
        }, [(item.pairingHistory && item.pairingHistory.length) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "color": "#CFD8DC",
            "text-color": "black",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewStatsAnalysis(item)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "11px"
          }
        }, [_c('strong', [_vm._v("View Stats")])])]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.travelForm",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.travelForm) ? _c('v-btn', {
          attrs: {
            "color": "info",
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.getTravelDataToView(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-wallet-travel")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Travel Form")])])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.rateCard",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [((item.rateCardID || item.creatorCommunityID) && item.rateCard) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "info",
            "outlined": ""
          },
          on: {
            "click": function($event) {
              return _vm.getRateCardDataToView(item.rateCard)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('img', _vm._g({
                attrs: {
                  "src": "/static/img/material_icons/mdi--money.svg",
                  "width": "25px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Rate Card")])])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.PairedCreators",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.pairedCreator) ? _c('v-btn', {
          attrs: {
            "text": "",
            "small": "",
            "color": "warning",
            "href": ("/paired/creators?handle=" + (item.pairedCreator.handle)),
            "target": '_blank'
          }
        }, [_vm._v("\n              View\n            ")]) : _vm._e()], 1)])]
      }
    }, {
      key: "item.tags",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', _vm._l((item.tags), function(item, index) {
          return _c('span', {
            key: index
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "warning",
              "text-color": "white",
              "small": ""
            }
          }, [_vm._v("\n              " + _vm._s(item) + "\n            ")])], 1)
        }), 0)]
      }
    }, {
      key: "item.genre",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticStyle: {
            "min-width": "150px"
          }
        }, [(!item.genre || item.genre.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.genre), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.genre),
            expression: "item.genre"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.genre && item.genre.length > 1),
                  expression: "item.genre && item.genre.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                More...\n              ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Genre")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.genre), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest))])
        })], 2)], 1)], 1)], 2)]
      }
    }, {
      key: "item.IMS",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [(item.influencerID) ? _c('v-btn', {
          attrs: {
            "color": "secondary",
            "outlined": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.getInfluencerDataToView(item.influencerID, item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("mdi-account-edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Influencer")])])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "item.Audience",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_c('v-btn', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "outlined": "",
            "disabled": !item.audienceID
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'instagram')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("assessment")]), _vm._v(" "), _c('i', _vm._g({
                staticClass: "fab fa-instagram"
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View IG Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "outlined": "",
            "disabled": !item.tiktokAudienceID
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'tiktok')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("assessment")]), _vm._v(" "), _c('img', _vm._g({
                attrs: {
                  "src": "/static/img/tiktok-32.png",
                  "width": "17px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View TikTok Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "outlined": "",
            "disabled": !item.youtubeAudienceID
          },
          on: {
            "click": function($event) {
              return _vm.showReport(item, 'youtube')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("assessment")]), _vm._v(" "), _c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-youtube")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Youtube Aud")])])], 1)], 1)])]
      }
    }, {
      key: "item.createdAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n          " + _vm._s(_vm.utils.formatCustomDate(item.createdAt, 'DD-MM-YYYY')) + "\n        ")])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticStyle: {
            "min-width": "280px"
          }
        }, [_c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "warning",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.showAddTagDialog(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-tag")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Add Tag")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "disabled": !item.instagram
          },
          on: {
            "click": function($event) {
              return _vm.fetchIQData(item, 'instagram')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("download")]), _vm._v(" "), _c('i', _vm._g({
                staticClass: "fab fa-instagram"
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Fetch IG Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "disabled": !item.tiktok
          },
          on: {
            "click": function($event) {
              return _vm.fetchIQData(item, 'tiktok')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("download")]), _vm._v(" "), _c('img', _vm._g({
                attrs: {
                  "src": "/static/img/tik-tok-white.png",
                  "width": "12px"
                }
              }, on))]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Fetch TikTok Aud")])])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "info",
            "small": "",
            "disabled": !item.youtube
          },
          on: {
            "click": function($event) {
              return _vm.fetchIQData(item, 'youtube')
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("download")]), _vm._v(" "), _c('v-icon', _vm._g({
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("mdi-youtube")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Fetch Youtube Aud")])])], 1), _vm._v(" "), (_vm.isSuperAdmin) ? _c('v-btn', {
          staticClass: "mb-1",
          attrs: {
            "color": "red",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteInf(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "white",
                  "small": ""
                }
              }, on), [_vm._v("mdi-delete-forever")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Delete")])])], 1) : _vm._e()], 1)])]
      }
    }], null, true),
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  }), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    on: {
      "showLoadingEvent": _vm.showLoadingEvent
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.importLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.importLoading = $event
      }
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Creators Search",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('campaign-lists-modal', {
    attrs: {
      "items": _vm.viewCampaigns,
      "handle": _vm.viewHandle,
      "isRemark": _vm.isCcRemarks,
      "emptyCampaigns": _vm.emptyCampaigns,
      "value": _vm.viewCampaignListsDialog
    },
    model: {
      value: (_vm.viewCampaignListsDialog),
      callback: function($$v) {
        _vm.viewCampaignListsDialog = $$v
      },
      expression: "viewCampaignListsDialog"
    }
  }), _vm._v(" "), _c('add-tag-modal', {
    attrs: {
      "item": _vm.editTagItem
    },
    on: {
      "saved": _vm.saveTagProcess
    },
    model: {
      value: (_vm.addTagDialog),
      callback: function($$v) {
        _vm.addTagDialog = $$v
      },
      expression: "addTagDialog"
    }
  }), _vm._v(" "), (_vm.rateCardViewData) ? _c('ratecard-view-modal-dialog', {
    attrs: {
      "value": _vm.rateCardViewDialog,
      "data": _vm.rateCardViewData
    },
    on: {
      "updated": _vm.paginate
    },
    model: {
      value: (_vm.rateCardViewDialog),
      callback: function($$v) {
        _vm.rateCardViewDialog = $$v
      },
      expression: "rateCardViewDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('view-influencer-modal', {
    attrs: {
      "influencerData": _vm.viewInfluencerData
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }), _vm._v(" "), _c('view-travel-modal', {
    attrs: {
      "travelData": _vm.viewTravelData
    },
    model: {
      value: (_vm.viewTravelDialog),
      callback: function($$v) {
        _vm.viewTravelDialog = $$v
      },
      expression: "viewTravelDialog"
    }
  }), _vm._v(" "), _c('view-stats-modal', {
    attrs: {
      "handle": _vm.viewHandle
    },
    model: {
      value: (_vm.viewStatsDialog),
      callback: function($$v) {
        _vm.viewStatsDialog = $$v
      },
      expression: "viewStatsDialog"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', [_c('v-container', {
    attrs: {
      "container--fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-center avatar-header"
  }, [_c('div', {
    staticClass: "private-register-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Kobe"
    }
  })])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Register using your information below :")]), _vm._v(" "), _c('v-form', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.nameErrors,
      "prepend-icon": "person",
      "name": "firstName",
      "label": "First Name",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.$v.registerUser.firstName.$touch()
      },
      "blur": function($event) {
        return _vm.$v.registerUser.firstName.$touch()
      }
    },
    model: {
      value: (_vm.registerUser.firstName),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "firstName", $$v)
      },
      expression: "registerUser.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "name": "lastName",
      "label": "Last Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.lastName),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "lastName", $$v)
      },
      expression: "registerUser.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.registerEmailErrors,
      "prepend-icon": "email",
      "name": "email",
      "disabled": "",
      "label": "Email",
      "type": "email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.registerUser.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.registerUser.email.$touch()
      }
    },
    model: {
      value: (_vm.registerUser.email),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "email", $$v)
      },
      expression: "registerUser.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "mdi-instagram",
      "name": "instagram",
      "disabled": _vm.disableIgHandle,
      "label": "Instagram Account Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.igHandle),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "igHandle", $$v)
      },
      expression: "registerUser.igHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "fab fa-tiktok",
      "name": "tiktok",
      "disabled": _vm.disableTikTokHandle,
      "label": "TikTok Account Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.tiktokHandle),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "tiktokHandle", $$v)
      },
      expression: "registerUser.tiktokHandle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "fab fa-youtube",
      "name": "youtube",
      "disabled": _vm.disableYoutubeHandle,
      "label": "Youtube Account Name",
      "type": "text"
    },
    model: {
      value: (_vm.registerUser.youtubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "youtubeHandle", $$v)
      },
      expression: "registerUser.youtubeHandle"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "prepend-icon": "my_location",
      "items": _vm.locations,
      "label": "Select your location"
    },
    model: {
      value: (_vm.registerUser.location),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "location", $$v)
      },
      expression: "registerUser.location"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.registerPasswordErrors,
      "id": "regPassword",
      "prepend-icon": "lock",
      "name": "regPassword",
      "label": "Password",
      "type": "password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.registerUser.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.registerUser.password.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.registerInfluencer()
      }
    },
    model: {
      value: (_vm.registerUser.password),
      callback: function($$v) {
        _vm.$set(_vm.registerUser, "password", $$v)
      },
      expression: "registerUser.password"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.$v.registerUser.$invalid,
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.registerInfluencer()
      }
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "text-xs-left"
  }, [_vm._v("\n                  By Signing up, you confirm that you have read the\n                  "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" , that you understand them and that you agree to be bound by them.\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "dark": "",
      "height": "auto",
      "color": "#1A1A1A"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "white--text": "",
      "text-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Singapore")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "tel:+6562555662"
    }
  }, [_vm._v("6255 5662")]), _vm._v(" /\n          "), _c('a', {
    attrs: {
      "href": "mailto:contact@getkobe.com"
    }
  }, [_vm._v("CONTACT@GETKOBE.COM")]), _vm._v(" "), _c('br'), _vm._v("75 Ayer Rajah Crescent #01-09/10 Singapore 139953\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('br'), _vm._v("Website\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n          "), _c('br'), _vm._v("All Rights Reserved © 2016-" + _vm._s(_vm.year) + " Kobe Global Technologies Pte Ltd\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Malaysia / Thailand / Indonesia")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "mailto:international@getkobe.com"
    }
  }, [_vm._v("INTERNATIONAL@GETKOBE.COM")])])])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "#A3FF12",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mb-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.init()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n            mdi-cached\n          ")]), _vm._v(" \n          Reload\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.revMeetingSections), function(revItem, revIdx) {
    return _c('div', {
      key: revIdx
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(revItem.title))]), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 mt-3"
    }), _vm._v(" "), _c('v-row', {
      staticClass: "mt-0 mb-1 pb-2 text-right"
    }, [_c('v-col', {
      staticClass: "text-left",
      attrs: {
        "cols": "12",
        "xs": "6",
        "md": "6",
        "justify": "left",
        "align": "left",
        "pt-0": ""
      }
    }), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "12",
        "xs": "6",
        "md": "6",
        "justify": "right",
        "align": "right",
        "pt-0": ""
      }
    }, [(revItem.currentMode === 'view') ? _c('v-btn', {
      attrs: {
        "color": "secondary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeModeCustom('edit', revItem)
        }
      }
    }, [_c('v-icon', _vm._g({
      attrs: {
        "small": ""
      }
    }, _vm.on), [_vm._v("edit")]), _vm._v("\n          Edit Mode\n        ")], 1) : _vm._e(), _vm._v(" "), (revItem.currentMode === 'edit') ? _c('v-btn', {
      attrs: {
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeModeCustom('view', revItem)
        }
      }
    }, [_vm._v("\n          Close Edit\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "30px!important"
      }
    }, [_c('v-data-table', {
      staticClass: "review-meeting-table elevation-1",
      attrs: {
        "dense": "",
        "headers": _vm.headers,
        "search": _vm.filter,
        "items": revItem.data,
        "items-per-page": 10
      },
      scopedSlots: _vm._u([{
        key: "item.name",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "300px"
            }
          }, [_c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])])])]
        }
      }, {
        key: "item.AM",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "200px"
            }
          }, [_c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.AM) + "\n              ")])])])]
        }
      }, {
        key: "item.CC",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "200px"
            }
          }, [_c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.CC) + "\n              ")])])])]
        }
      }, {
        key: "item.reviewMeetingDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "min-width": "200px"
            }
          }, [(revItem.currentMode === 'view') ? _c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.reviewMeetingDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (revItem.currentMode === 'edit') ? _c('div', [_c('add-review-meeting-date', {
            attrs: {
              "oldReviewDate": item.reviewMeetingDate,
              "campaignID": item.id,
              "options": {
                theme: 'tableview'
              }
            },
            on: {
              "updated": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.invokeReviewMeetingUpdated.apply(void 0, [ item ].concat( argsArray ))
              }
            }
          })], 1) : _vm._e()])]
        }
      }, {
        key: "item.sentimentDueDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.sentimentDueDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.sentimentDueDate, item.SentimentDateCol.status)) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.sentimentDueDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.sentimentDueDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.sentimentDateColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'SentimentDateCol')
              }
            },
            model: {
              value: (item.SentimentDateCol.status),
              callback: function($$v) {
                _vm.$set(item.SentimentDateCol, "status", $$v)
              },
              expression: "item.SentimentDateCol.status"
            }
          })], 1)]), _vm._v(" "), (item.SentimentDateCol.reviewDateURL) ? _c('v-btn', _vm._g(_vm._b({
            staticClass: "btn-view-review-deck",
            attrs: {
              "href": item.SentimentDateCol.reviewDateURL,
              "target": "_blank",
              "color": "secondary",
              "small": "",
              "text": ""
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "x-small": "",
              "left": ""
            }
          }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('span', [_vm._v("View Review Deck")])], 1) : _vm._e()], 1) : _vm._e()])]
        }
      }, {
        key: "item.ccDeckReadyDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.ccDeckReadyDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.ccDeckReadyDate, item.CCReadyDeckCol.status)) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.ccDeckReadyDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.ccDeckReadyDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.ccReadyDeckColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'CCReadyDeckCol')
              }
            },
            model: {
              value: (item.CCReadyDeckCol.status),
              callback: function($$v) {
                _vm.$set(item.CCReadyDeckCol, "status", $$v)
              },
              expression: "item.CCReadyDeckCol.status"
            }
          })], 1)])]) : _vm._e()])]
        }
      }, {
        key: "item.amDeckReadyDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.amDeckReadyDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.amDeckReadyDate, item.AMReadyDeckCol.status)) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.amDeckReadyDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.amDeckReadyDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.amReadyDeckColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'AMReadyDeckCol')
              }
            },
            model: {
              value: (item.AMReadyDeckCol.status),
              callback: function($$v) {
                _vm.$set(item.AMReadyDeckCol, "status", $$v)
              },
              expression: "item.AMReadyDeckCol.status"
            }
          })], 1)])]) : _vm._e()])]
        }
      }, {
        key: "item.overallAlignmentDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.overallAlignmentDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.overallAlignmentDate, item.overallAlignmentCol.status) && !item.overallAlignmentCol.status) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.overallAlignmentDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.overallAlignmentDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.overallAlignmentColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'overallAlignmentCol')
              }
            },
            model: {
              value: (item.overallAlignmentCol.status),
              callback: function($$v) {
                _vm.$set(item.overallAlignmentCol, "status", $$v)
              },
              expression: "item.overallAlignmentCol.status"
            }
          })], 1)])]) : _vm._e()])]
        }
      }, {
        key: "item.approvedByAdmin",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.approvedByAdminCol && !_vm.reviewMeetingFilters.showEmptyReviewDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "center"
            }
          }, [_c('div', [_c('v-checkbox', {
            staticClass: "mt-2",
            attrs: {
              "color": "green",
              "value": false,
              "disabled": !_vm.approvedByAdminAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'approvedByAdminCol')
              }
            },
            model: {
              value: (item.approvedByAdminCol.status),
              callback: function($$v) {
                _vm.$set(item.approvedByAdminCol, "status", $$v)
              },
              expression: "item.approvedByAdminCol.status"
            }
          })], 1), _vm._v(" "), (item.approvedByAdminCol.status) ? _c('div', {
            staticClass: "col-checkbox-label"
          }, [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    Review Completed\n                  ")])]) : _vm._e()])]) : _vm._e()])]
        }
      }, {
        key: "item.feedback",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "150px"
            }
          }, [_c('div', [(item.feedbackForm) ? _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "to": '/client/feedback-form?id=' + item.feedbackForm.id,
              "target": "_blank",
              "color": "success",
              "small": "",
              "text": ""
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('span', [_vm._v("View Form")])], 1) : _vm._e(), _vm._v(" "), (!item.feedbackForm && item.AM && item.CC) ? _c('v-tooltip', {
            attrs: {
              "right": "",
              "open-on-hover": false
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  attrs: {
                    "color": "secondary",
                    "small": "",
                    "text": ""
                  },
                  on: {
                    "click": function($event) {
                      return _vm.copyFeedbackLink(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "left": ""
                  }
                }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Link")])], 1)]
              }
            }], null, true),
            model: {
              value: (item.linkCopied),
              callback: function($$v) {
                _vm.$set(item, "linkCopied", $$v)
              },
              expression: "item.linkCopied"
            }
          }, [_vm._v(" "), _c('span', [_c('v-icon', {
            attrs: {
              "color": "white darken-2"
            }
          }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)]) : _vm._e()], 1)])]
        }
      }, {
        key: "no-data",
        fn: function() {
          return [_vm._v("No Data")]
        },
        proxy: true
      }], null, true)
    })], 1)], 1)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.feedbackLink
    }
  }), _vm._v(" "), _c('review-deck-url-modal', {
    attrs: {
      "value": _vm.reviewDeckURLDialog,
      "item": _vm.reviewDeckItem,
      "dateCol": _vm.reviewDateCol
    },
    on: {
      "saveClicked": _vm.saveReviewDeckURL,
      "closeClicked": _vm.closeReviewDeckModal
    },
    model: {
      value: (_vm.reviewDeckURLDialog),
      callback: function($$v) {
        _vm.reviewDeckURLDialog = $$v
      },
      expression: "reviewDeckURLDialog"
    }
  }), _vm._v(" "), _c('review-meeting-checklist-modal', {
    attrs: {
      "value": _vm.checkListsDialog,
      "item": _vm.checkItem,
      "dateCol": _vm.checkCol
    },
    on: {
      "saveClicked": _vm.saveReviewMeetingCheckList,
      "closeClicked": _vm.closeCheckListModal
    },
    model: {
      value: (_vm.checkListsDialog),
      callback: function($$v) {
        _vm.checkListsDialog = $$v
      },
      expression: "checkListsDialog"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.records,
      "data-app": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.client.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.campaign.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status == 1 ? 'Approved' : 'Submitted'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTime")(props.item.createdAt)))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Payment Detail",
            "color": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showModalEdit(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1)], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Payment Records found!")]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), (_vm.selectedRecord && _vm.selectedRecord.id) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.viewPaymentDetailDialog),
      callback: function($$v) {
        _vm.viewPaymentDetailDialog = $$v
      },
      expression: "viewPaymentDetailDialog"
    }
  }, [_c('v-card', [_c('form', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Payment Record Details")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Client")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.selectedRecord.client.name))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Campaign")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v(_vm._s(_vm.selectedRecord.campaign.name))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.paymentStatus,
      "item-text": "text",
      "item-value": "value",
      "label": "Status"
    },
    model: {
      value: (_vm.selectedRecord.status),
      callback: function($$v) {
        _vm.$set(_vm.selectedRecord, "status", $$v)
      },
      expression: "selectedRecord.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hint": "Insert the amount you need to submit (SGD)",
      "required": ""
    },
    model: {
      value: (_vm.selectedRecord.amount),
      callback: function($$v) {
        _vm.$set(_vm.selectedRecord, "amount", $$v)
      },
      expression: "selectedRecord.amount"
    }
  })], 1), _vm._v(" "), (_vm.selectedRecord.image) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Receipt/Proof")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedRecord.image.Location,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedRecord.image.Location,
      "height": "250",
      "width": "auto"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.deleteRecord
    }
  }, [_vm._v("\n              Delete this Record\n              "), _c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": function($event) {
        _vm.viewPaymentDetailDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": _vm.updateRecord
    }
  }, [_vm._v("Save")])], 1)], 1)])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Payment records")])])
}]}

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    ref: "editorElement"
  })])
},staticRenderFns: []}

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.pairingBriefModelSections[1].content), function(campaignField, index) {
    return _c('element', {
      key: index
    }, [(campaignField.type === 'text') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name] == '' ? '-' : _vm.campaign[campaignField.name]))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', {
      staticClass: "form-group col-xs-12 col-sm-12"
    }, [_c('label', [_vm._v(_vm._s(campaignField.label) + ":")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(campaignField.value, _vm.campaign[campaignField.name])))])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('element', [_c('div', {
      staticClass: "form-group col-xs-12"
    }, _vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
      return _c('div', {
        key: optionIndex,
        staticClass: "form-group col-xs-12"
      }, [_c('div', {
        staticClass: "form-group col-xs-12"
      }, [_c('h4', [_vm._v(_vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1))])]), _vm._v(" "), _vm._l((campaignField.template), function(optionField, index) {
        return _c('element', {
          key: index
        }, [(optionField.type == 'text') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(_vm._s(_vm.campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : _vm.campaign[campaignField.name][optionIndex][optionField.name]))])]) : _vm._e(), _vm._v(" "), (optionField.type == 'upload') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12"
        }, [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(image) {
          return [(image != '') ? _c('div', {
            key: image
          }, [_c('a', {
            key: image,
            staticClass: "campaign-image",
            attrs: {
              "href": _vm.constructImageURL(image),
              "target": "_blank"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "src": _vm.constructImageURL(image)
            }
          })])]) : _vm._e()]
        })], 2)]) : _vm._e(), _vm._v(" "), (optionField.type === 'select') ? _c('div', {
          staticClass: "form-group col-xs-12 col-sm-12"
        }, [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getDisplayValueFromSelect(optionField.value, _vm.campaign[campaignField.name][optionIndex][optionField.name])))])]) : _vm._e()])
      })], 2)
    }), 0)]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12"
  }, [_c('label', [_vm._v("Payout:")]), _vm._v(" $" + _vm._s(_vm.rateCardData) + "\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Pairing Brief\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', [_c('h3', [_vm._v("Pairing Brief Details")])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("\n          MUST READ "), _c('br'), _vm._v("\n          (Drop us an email at huanrong@getkobe.com if you need any help) "), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n          Reminder:"), _c('br'), _vm._v(" "), _c('ol', [_c('li', [_vm._v(" Both client and influencer will be mutually rated after each campaign and scores will be kept with Kobe to keep making the world a better place.")]), _vm._v(" "), _c('li', [_vm._v(" Do not make your post live until approval from client.")]), _vm._v(" "), _c('li', [_vm._v(" It is NON-MANDATORY for client to be giving a discount or any value added services.")]), _vm._v(" "), _c('li', [_vm._v(" For any discounts or value-added services that has been extended to you - it is entirely up to the sole discretion of the client - KOBE is not commissioned, neither do we enjoy similar perks.")]), _vm._v(" "), _c('li', [_vm._v(" KOBE gets you rewarded and recognized for sharing on social media, whilst at the same time provide word of mouth to businesses. Kobe isn’t a money making platform. ")]), _vm._v(" "), _c('li', [_vm._v(" For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation from campaign.")])])])])])
}]}

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value && _vm.showDialog),
      expression: "value && showDialog"
    }],
    staticClass: "theme--dark"
  }, [(_vm.showDialog) ? _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Estimated Live Month")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": _vm.submissionDateFormatted,
            "label": "",
            "prepend-icon": "mdi-calendar",
            "hint": "DD/MM/YYYY format",
            "readonly": ""
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 1854811427),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "change": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.submissionDate),
      callback: function($$v) {
        _vm.submissionDate = $$v
      },
      expression: "submissionDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.updateSubmission
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deliverable-lists"
  }, [_c('ul', {
    staticClass: "mb-0"
  }, [(_vm.deliverables.no_of_stories) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_stories) + " x Story(ies)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_posts) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_posts) + " x Post(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_tiktok_posts) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_tiktok_posts) + " x TikTok Post(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_carousels) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_carousels) + " x Carousel(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_video) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_video) + " x Video(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_reels) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_reels) + " x IG Reel(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_xhs_posts) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_xhs_posts) + " x XHS Post(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_fb_posts) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_fb_posts) + " x FB Post(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_li_posts) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_li_posts) + " x LinkedIn Post(s)")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_x_posts) ? _c('li', [_vm._v(_vm._s(_vm.deliverables.no_of_x_posts) + " x X (Twitter) Post(s)")]) : _vm._e()]), _vm._v(" "), (_vm.deliverables.custom && _vm.deliverables.custom.length > 0) ? _c('ul', _vm._l((_vm.deliverables.custom), function(custom, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n      " + _vm._s(custom.value) + " x " + _vm._s(custom.label) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "legacy-sunset-banner",
    attrs: {
      "aria-label": "Legacy interface retirement announcement"
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "legacy-sunset-banner__cta",
    attrs: {
      "href": _vm.v3Url
    }
  }, [_vm._v("\n    Try V3 "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("→")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legacy-sunset-banner__message"
  }, [_c('strong', [_vm._v("This legacy interface will retire in December 2026.")]), _vm._v(" "), _c('span', [_vm._v("Start using V3 today to get ready for the switch.")])])
}]}

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mb-3 mt-3",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-row', {
    staticClass: "filter-area"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.resetFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n            ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CC),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CC", $$v)
      },
      expression: "selectedFilter.CC"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.defaultYears,
      "label": "Active Year",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getCampaignCogs()
      }
    },
    model: {
      value: (_vm.selectedFilter.activeYear),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "activeYear", $$v)
      },
      expression: "selectedFilter.activeYear"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.totalSummary) ? _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q1")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[0].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[0].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[0].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[0].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[0].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q2")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[1].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[1].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[1].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[1].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[1].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q3")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[2].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[2].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[2].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[2].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[2].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "150px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Q4")]), _vm._v(" "), (_vm.summaryItems.length) ? _c('v-card-text', [_c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.summaryItems[3].data.length))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[3].totalValues.cappedCOGS)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[3].totalValues.cogsTotal)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.summaryItems[3].totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
    staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
  }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryItems[3].totalValues.cogsInfPercentage) + "%")])])]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mb-1"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('div', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('v-menu', {
    ref: "startDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Start Month",
            "placeholder": "Start Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.selectedFilter.startDate),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "startDate", $$v)
            },
            expression: "selectedFilter.startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateCal),
      callback: function($$v) {
        _vm.startDateCal = $$v
      },
      expression: "startDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.startDate),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "startDate", $$v)
      },
      expression: "selectedFilter.startDate"
    }
  }, [_c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "date-divider"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_c('v-menu', {
    ref: "endDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-3",
          attrs: {
            "label": "End Month",
            "placeholder": "End Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.selectedFilter.endDate),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "endDate", $$v)
            },
            expression: "selectedFilter.endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateCal),
      callback: function($$v) {
        _vm.endDateCal = $$v
      },
      expression: "endDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.endDate),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "endDate", $$v)
      },
      expression: "selectedFilter.endDate"
    }
  }, [_c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedFilter.text),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "text", $$v)
      },
      expression: "selectedFilter.text"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)])])], 1), _vm._v(" "), _vm._l((_vm.filteredItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "campaign-cogs-section",
      attrs: {
        "id": item.name
      }
    }, [_c('v-expansion-panels', {
      staticClass: "expansion-panels mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (item.panel),
        callback: function($$v) {
          _vm.$set(item, "panel", $$v)
        },
        expression: "item.panel"
      }
    }, [_c('v-expansion-panel', {
      staticClass: "expansion-panel-main",
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "expansion-panel-header"
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "expansion-panel-content"
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-row', {
      staticClass: "action-section mb-3"
    }, [_c('v-col', {
      staticClass: "action-group-section pl-0",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "gap": "3px"
      }
    }, [_c('div', [(item.selectedCOGS && item.selectedCOGS.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openQuarterUpdateModal(item.selectedCOGS)
        }
      }
    }, [_vm._v("Update Status (" + _vm._s(item.selectedCOGS.length) + ")")]) : _vm._e(), _vm._v(" "), (item.selectedCOGS && item.selectedCOGS.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openActiveYearDialog(item.data)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")]), _vm._v(" Update Active Year\n                      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "mb-2 primary",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exportReport(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-file-excel")]), _vm._v(" Export Excel")], 1)], 1)])]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-right float-right"
    }, [_c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      model: {
        value: (item.filter.search),
        callback: function($$v) {
          _vm.$set(item.filter, "search", $$v)
        },
        expression: "item.filter.search"
      }
    })], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      staticClass: "cogs-summary-table elevation-1",
      attrs: {
        "headers": _vm.computedHeaders,
        "search": item.filter.search,
        "items": item.data,
        "items-per-page": 15,
        "show-select": "",
        "single-select": false
      },
      on: {
        "current-items": _vm.getFiltered
      },
      scopedSlots: _vm._u([{
        key: "item.campaignName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                    " + _vm._s(item.campaignName) + "\n                    "), (item.lockedCOGS) ? _c('div', [_c('v-chip', {
            attrs: {
              "color": "warning",
              "x-small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-lock")]), _vm._v(" Locked COGS\n                      ")], 1)], 1) : _vm._e()])]
        }
      }, {
        key: "item.budget",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.budget)))])]
        }
      }, {
        key: "item.cappedCOGS",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cappedCOGS) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cappedCOGS)))]) : _vm._e(), _vm._v(" "), (item.markupDeal) ? _c('v-chip', {
            attrs: {
              "color": "warning",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                      Markup COGS\n                    ")]) : _vm._e()], 1)]
        }
      }, {
        key: "item.cogsTotal",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsTotal) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsTotal)))]) : _vm._e(), _vm._v(" "), (item.cogsTotal && item.cappedCOGS && item.cogsTotal > item.cappedCOGS) ? _c('v-chip', {
            attrs: {
              "color": "red",
              "x-small": "",
              "text-color": "white"
            }
          }, [_vm._v("\n                      Burst COGS\n                    ")]) : _vm._e()], 1)]
        }
      }, {
        key: "item.cogsInf",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsInf) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsInf)))]) : _vm._e()])]
        }
      }, {
        key: "item.cogsNoGST",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsNoGST) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsNoGST)))]) : _vm._e()])]
        }
      }, {
        key: "item.cogsOthers",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsOthers) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.cogsOthers)))]) : _vm._e()])]
        }
      }, {
        key: "item.cogsInfPercentage",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.cogsInfPercentage) ? _c('span', [_vm._v(_vm._s(item.cogsInfPercentage) + "%")]) : _vm._e()])]
        }
      }, {
        key: "item.cogsExcess",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            class: _vm.getCOGSExcessColor(item.cogsExcess)
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.getCOGSExcessSign(item.cogsExcess))))])])]
        }
      }, {
        key: "item.completedAmt",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            staticClass: "custom-link",
            attrs: {
              "href": '/finance/payment-consolidation/status?id=' + item.campaignID,
              "target": "_blank"
            }
          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.completedAmt)))])])]
        }
      }, {
        key: "item.pendingAmt",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [_c('a', {
            staticClass: "custom-link",
            attrs: {
              "href": '/finance/payment-consolidation/status?id=' + item.campaignID,
              "target": "_blank"
            }
          }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.pendingAmt)))])])]
        }
      }, {
        key: "item.AM",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.AM) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.getUsersDisplay(item.AM)) + "\n                    ")]) : _vm._e()])]
        }
      }, {
        key: "item.CC",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.CC) ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.getUsersDisplay(item.CC)) + "\n                    ")]) : _vm._e()])]
        }
      }, {
        key: "item.startDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.startDateEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'startDate', 'filteredItems')
              }
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.startDate)) + " "), _c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "warning",
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "120px"
            }
          }, [_c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "nudge-right": 40,
              "transition": "scale-transition",
              "offset-y": "",
              "min-width": "290px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-text-field', _vm._g({
                  staticClass: "input-field mt-3",
                  attrs: {
                    "append-icon": "event",
                    "readonly": "",
                    "dense": "",
                    "outlined": ""
                  },
                  model: {
                    value: (item.startDate),
                    callback: function($$v) {
                      _vm.$set(item, "startDate", $$v)
                    },
                    expression: "item.startDate"
                  }
                }, on))]
              }
            }], null, true),
            model: {
              value: (item.startCal),
              callback: function($$v) {
                _vm.$set(item, "startCal", $$v)
              },
              expression: "item.startCal"
            }
          }, [_vm._v(" "), _c('v-date-picker', {
            attrs: {
              "type": "month"
            },
            on: {
              "input": function($event) {
                item.startCal = false
              }
            },
            model: {
              value: (item.startDate),
              callback: function($$v) {
                _vm.$set(item, "startDate", $$v)
              },
              expression: "item.startDate"
            }
          })], 1)], 1)])]
        }
      }, {
        key: "item.endDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.endDateEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'endDate', 'filteredItems')
              }
            }
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.endDate)) + " "), _c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "warning",
              "x-small": ""
            }
          }, [_vm._v("edit")])], 1)]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "120px"
            }
          }, [_c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "nudge-right": 40,
              "transition": "scale-transition",
              "offset-y": "",
              "min-width": "290px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-text-field', _vm._g({
                  staticClass: "input-field mt-3",
                  attrs: {
                    "append-icon": "event",
                    "readonly": "",
                    "dense": "",
                    "outlined": ""
                  },
                  model: {
                    value: (item.endDate),
                    callback: function($$v) {
                      _vm.$set(item, "endDate", $$v)
                    },
                    expression: "item.endDate"
                  }
                }, on))]
              }
            }], null, true),
            model: {
              value: (item.endCal),
              callback: function($$v) {
                _vm.$set(item, "endCal", $$v)
              },
              expression: "item.endCal"
            }
          }, [_vm._v(" "), _c('v-date-picker', {
            attrs: {
              "type": "month"
            },
            on: {
              "input": function($event) {
                item.endCal = false
              }
            },
            model: {
              value: (item.endDate),
              callback: function($$v) {
                _vm.$set(item, "endDate", $$v)
              },
              expression: "item.endDate"
            }
          })], 1)], 1)])]
        }
      }, {
        key: "item.startMonth",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.startMonth)) + "\n                    ")])])]
        }
      }, {
        key: "item.endMonth",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', [_c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n                      " + _vm._s(_vm.formatMonth(item.endMonth)) + "\n                    ")])])]
        }
      }, {
        key: "item.action",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "170px"
            }
          }, [(item.lockedCOGS && _vm.isAdmin) ? _c('v-btn', {
            attrs: {
              "small": "",
              "color": "warning"
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(item, false)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("mdi-lock-open")]), _vm._v(" Unlock\n                    ")], 1) : _vm._e(), _vm._v(" "), (!item.lockedCOGS && _vm.isAdmin) ? _c('v-btn', {
            attrs: {
              "small": "",
              "color": "error"
            },
            on: {
              "click": function($event) {
                return _vm.changeLock(item, true)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("mdi-lock")]), _vm._v(" Lock\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "small": "",
              "color": "success"
            },
            on: {
              "click": function($event) {
                return _vm.showPairedAdminViewDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "View Influencers"
            }
          }, [_vm._v("people")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
            staticClass: "mb-2",
            attrs: {
              "color": "secondary",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.reloadManually(item.campaignID)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-repeat fa-xs"
          })]), _vm._v(" "), _c('v-btn', {
            staticClass: "mb-2",
            attrs: {
              "to": '/influencers/invoices-brief-confirmation?id=' + item.campaignID,
              "target": "_blank",
              "color": "warning",
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-file-outline")]), _vm._v(" Invoices & Brief\n                  ")], 1)], 1)]
        }
      }], null, true),
      model: {
        value: (item.selectedCOGS),
        callback: function($$v) {
          _vm.$set(item, "selectedCOGS", $$v)
        },
        expression: "item.selectedCOGS"
      }
    }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
      slot: "body.append"
    }, [_c('tr', [_c('th', {
      staticClass: "subtitle-2"
    }, [_vm._v("Total:")]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(cItem, index) {
      return _c('th', {
        key: index,
        staticClass: "text-center"
      }, [(item.totalValues && item.totalValues[cItem.value]) ? _c('v-chip', {
        staticClass: "summary-chip",
        attrs: {
          "small": "",
          "color": "primary",
          "text-color": "white"
        }
      }, [_c('v-icon', {
        staticClass: "mr-0",
        attrs: {
          "small": "",
          "left": ""
        }
      }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm._f("thousandSeprator")(item.totalValues[cItem.value])) + "\n                      ")], 1) : _vm._e()], 1)
    })], 2)])], 2)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('paired-inf-admin-view-dialog', {
    attrs: {
      "value": _vm.pairedInfAdminViewDialog,
      "campaign": _vm.pairedCampaign,
      "clients": _vm.allClients
    },
    model: {
      value: (_vm.pairedInfAdminViewDialog),
      callback: function($$v) {
        _vm.pairedInfAdminViewDialog = $$v
      },
      expression: "pairedInfAdminViewDialog"
    }
  }), _vm._v(" "), _c('update-quarter-modal', {
    attrs: {
      "value": _vm.quarterUpdateialog,
      "selectedCOGS": _vm.selectedCOGS
    },
    on: {
      "updated": _vm.getCampaignCogs
    },
    model: {
      value: (_vm.quarterUpdateialog),
      callback: function($$v) {
        _vm.quarterUpdateialog = $$v
      },
      expression: "quarterUpdateialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Campaign COGS",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.totalSummary) ? _c('projected-cogs-modal', {
    attrs: {
      "value": _vm.projectedCogsDialog,
      "monthYearValues": _vm.totalSummary.revsForMonthYear
    },
    model: {
      value: (_vm.projectedCogsDialog),
      callback: function($$v) {
        _vm.projectedCogsDialog = $$v
      },
      expression: "projectedCogsDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('active-year-modal', {
    attrs: {
      "value": _vm.activeYearDialog,
      "items": _vm.selectedCOGS,
      "campaigns": _vm.editCampaigns
    },
    on: {
      "updated": _vm.getCampaignCogs
    },
    model: {
      value: (_vm.activeYearDialog),
      callback: function($$v) {
        _vm.activeYearDialog = $$v
      },
      expression: "activeYearDialog"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.campaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "instagramHandle", $$v)
      },
      expression: "filter.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clients,
      "outlined": true,
      "label": "Client",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && _vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "text",
      "item-value": "value",
      "items": _vm.statuses,
      "outlined": true,
      "label": "Status",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.filter.filterStatus),
      callback: function($$v) {
        _vm.$set(_vm.filter, "filterStatus", $$v)
      },
      expression: "filter.filterStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-2 primary",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.statusReportHeaders,
      "items": _vm.reportData,
      "item-key": "id",
      "options": _vm.pagging,
      "server-items-length": _vm.pagging.totalItems
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [(item.author.tiktokHandle) ? _c('a', {
          attrs: {
            "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": "/static/img/tiktok-32.png",
            "width": "20px"
          }
        }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author.youtubeHandle) ? _c('a', {
          attrs: {
            "href": 'https://youtube.com/' + item.author.youtubeHandle,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : _c('a', {
          attrs: {
            "href": 'https://instagram.com/' + item.author.instagramHandle,
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#000000",
            "small": ""
          }
        }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1)]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return _vm._l((item.labels), function(label) {
          return _c('div', {
            key: label.text
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "small": "",
              "color": label.color,
              "outlined": label.outlined,
              "dark": label.dark
            }
          }, [_vm._v("\n                  " + _vm._s(label.text) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v(_vm._s(label.icon))])], 1)], 1)
        })
      }
    }, {
      key: "item.submittedDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                " + _vm._s(item.submittedDate) + " "), (item.hasReport || item.postURL) ? _c('v-icon', {
          attrs: {
            "color": "green",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "title": "Live Post"
          }
        }, [_vm._v("mdi-check")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.payoutDueDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                " + _vm._s(item.payoutDueDate) + " "), (item.payoutSubmitted) ? _c('v-icon', {
          attrs: {
            "color": "green",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            "title": "Payout Submitted"
          }
        }, [_vm._v("mdi-check")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "mb-2"
        }, [_c('v-btn', {
          staticClass: "mt-2 primary",
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewDetailPost(item)
            }
          }
        }, [_vm._v("\n                View Post "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-magnify")])], 1), _vm._v(" "), _c('v-btn', _vm._g({
          staticClass: "mt-2 primary",
          attrs: {
            "to": ("/campaignPayoutsInternal?influencerID=" + (item.influencerID) + "&campaignID=" + (item.campaignID)),
            "target": "_blank",
            "disabled": !item.payout,
            "small": ""
          }
        }, _vm.on), [_vm._v("\n                View Submitted Payouts "), _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-image-multiple")])], 1), _vm._v(" "), _c('v-menu', {
          attrs: {
            "bottom": "",
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mt-2 primary",
                attrs: {
                  "small": ""
                }
              }, on), [_vm._v("Action")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
          return _c('v-list-item', {
            key: i,
            on: {
              "click": function($event) {
                return _vm.actionPostBy(menuItem.action, item)
              }
            }
          }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1)
        }), 1)], 1)], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "postReviewApproved": _vm.showPostReviewApproved,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('edit-post-modal', {
    attrs: {
      "post": _vm.editPostData,
      "postAbuseHistory": true,
      "value": _vm.editPostDialog,
      "userObj": _vm.user
    },
    on: {
      "postUpdated": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.editPostDialog),
      callback: function($$v) {
        _vm.editPostDialog = $$v
      },
      expression: "editPostDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-modal', {
    attrs: {
      "post": _vm.assignCampaignPostData
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignDialog),
      callback: function($$v) {
        _vm.assignCampaignDialog = $$v
      },
      expression: "assignCampaignDialog"
    }
  }), _vm._v(" "), _c('map-influencer-modal', {
    attrs: {
      "post": _vm.mapInfluencerPostData
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.mapInfluencerDialog),
      callback: function($$v) {
        _vm.mapInfluencerDialog = $$v
      },
      expression: "mapInfluencerDialog"
    }
  }), _vm._v(" "), _c('submission-review-multiple-modal', {
    attrs: {
      "posts": _vm.selected,
      "internalApprove": true
    },
    on: {
      "successBulkApprove": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.submissionReviewMultipleDialog),
      callback: function($$v) {
        _vm.submissionReviewMultipleDialog = $$v
      },
      expression: "submissionReviewMultipleDialog"
    }
  }), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataForAddPost,
      "postID": _vm.postIdToUpdate,
      "post": _vm.addPost
    },
    on: {
      "done": _vm.postAdded
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('change-post-status-modal', {
    attrs: {
      "post": _vm.postDataForChangeStatus,
      "postIds": _vm.changePostIds
    },
    on: {
      "updated": function($event) {
        return _vm.getStatusReport()
      }
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-card-text', {
    staticClass: "loading-dialog-text"
  }, [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("\n          Companies that can access " + _vm._s(_vm.influencer.instagramHandle) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addCompanyID),
      expression: "addCompanyID"
    }],
    staticClass: "form-control select2",
    attrs: {
      "id": "select",
      "name": "state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addCompanyID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Assign a company to influencer")]), _vm._v(" "), _vm._l((_vm.company_options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                " + _vm._s(option.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('b-button', {
    staticClass: "col-xs-12",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.assignCompany()
      }
    }
  }, [_vm._v("\n              Assign\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "bordered": "",
      "hover": "",
      "responsive": "",
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items": _vm.items,
      "fields": _vm.fields
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-button', {
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.unassignCompany(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "sm",
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    ref: "closeButton",
    staticClass: "btn btn-default text--secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Update Quarter")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total Entries:")]), _c('span', [_vm._v(_vm._s(_vm.selectedCOGS.length))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total COGS Capped:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsCapped)))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total COGS Used:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsUsed)))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("Total COGS Excess:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsExcess)))])]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font text-left d-flex justify-space-between"
        }, [_c('span', [_vm._v("COGS %:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalValues.cogsPercent) + "%")])])])], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isTopUsers) ? _c('v-form', {
    ref: "quarterForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.quarters,
      "item-value": "name",
      "item-text": "title",
      "label": "Quarter",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.quarter),
      callback: function($$v) {
        _vm.$set(_vm.data, "quarter", $$v)
      },
      expression: "data.quarter"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isTopUsers) ? _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */
/***/ (function(module, exports) {

module.exports = {"totalActiveCampaigns":10,"totalInfluencersOnIMS":1074,"totalInfluencerPerMonth":30,"campaigns":{"ACTIVATION":{"name":"Activation","average":[{"avg":6,"title":"Average time to activate"},{"avg":4,"title":"Total Number of accounts"}],"items":[{"id":[1],"name":"Maybank","days":"4","createAt":"2020-05-10"},{"id":[1,2],"name":"NIKE","days":"5","createAt":"2021-05-10"},{"id":[1],"name":"HPB","days":"2","createAt":"2021-02-10"},{"id":[2],"name":"Maybank","days":"6","createAt":"2020-05-15"},{"id":[2],"name":"Maybank","days":"10","createAt":"2021-06-18"},{"id":[2],"name":"Maybank","days":"7","createAt":"2021-09-01"},{"id":[1],"name":"Maybank","days":"1","createAt":"2021-03-10"},{"id":[2,1],"name":"Maybank","days":"7","createAt":"2020-02-01"}]},"CREATING":{"name":"CC-CREATING","average":[{"avg":4,"title":"Average time to pair"},{"avg":3,"title":"Total Number of accounts"}],"items":[{"id":[1],"name":"Maybank","days":"4","createAt":"2020-02-10"},{"id":[1],"name":"Maybank","days":"5","createAt":"2020-08-10"},{"id":[1],"name":"Maybank","days":"2","createAt":"2020-01-12"},{"id":[1,2],"name":"Maybank","days":"4","createAt":"2021-05-10"},{"id":[2],"name":"Maybank","days":"5","createAt":"2021-01-10"},{"id":[2],"name":"NIKE","days":"2","createAt":"2021-03-13"},{"id":[1],"name":"HPS","days":"4","createAt":"2020-03-20"},{"id":[2],"name":"Tiger Broker","days":"5","createAt":"2021-04-30"},{"id":[1,2],"name":"Maybank","days":"2","createAt":"2020-04-18"}]},"PAIRING":{"name":"Pairing","average":[{"avg":6,"title":"Average time to pair"},{"avg":3,"title":"Total Number of accounts"}],"items":[{"id":[1],"name":"Maybank","days":"4","createAt":"2020-05-10"},{"id":[1],"name":"Maybank","days":"5","createAt":"2020-08-10"},{"id":[1],"name":"HPS","days":"2","createAt":"2020-03-10"},{"id":[1,2],"name":"Maybank","days":"4","createAt":"2020-04-10"},{"id":[1],"name":"NIKE","days":"5","createAt":"2021-05-10"},{"id":[2],"name":"Maybank","days":"2","createAt":"2021-08-10"},{"id":[1,2],"name":"COKE","days":"4","createAt":"2020-06-15"},{"id":[2,1],"name":"Tiger Brokers","days":"5","createAt":"2021-01-17"},{"id":[2],"name":"Maybank","days":"2","createAt":"2021-04-19"}]},"COMPLETE":{"name":"Complete","average":[{"avg":8,"title":"Average time to submit"}],"items":[{"id":[1],"name":"XM Trading","submit_payout":5,"yet_to_submit":15,"total_post":20,"createAt":"2020-05-10"},{"id":[1],"name":"Coke","submit_payout":1,"yet_to_submit":3,"total_post":4,"createAt":"2020-06-10"},{"id":[1],"name":"HPB","submit_payout":15,"yet_to_submit":5,"total_post":20,"createAt":"2020-01-10"},{"id":[2,1],"name":"Maybank","submit_payout":2,"yet_to_submit":8,"total_post":10,"createAt":"2020-10-10"},{"id":[1],"name":"NIKE","submit_payout":0,"yet_to_submit":15,"total_post":15,"createAt":"2021-05-10"},{"id":[2,1],"name":"Maybank","submit_payout":3,"yet_to_submit":3,"total_post":6,"createAt":"2021-02-10"},{"id":[1],"name":"Tiger Brokers","submit_payout":10,"yet_to_submit":0,"total_post":10,"createAt":"2021-07-19"},{"id":[1],"name":"Maybank","submit_payout":1,"yet_to_submit":2,"total_post":3,"createAt":"2021-04-10"},{"id":[2,1],"name":"Maybank","submit_payout":0,"yet_to_submit":0,"total_post":20,"createAt":"2021-05-20"}]},"DURATION":{"name":"Duration per stage","items":[{"name":"April","activation":50,"pairing":30,"COCreating":18,"completion":40,"overall":null},{"name":"Shania","activation":20,"pairing":21,"COCreating":5,"completion":20,"overall":null},{"name":"Jai Qi","activation":8,"pairing":5,"COCreating":4,"completion":8,"overall":null},{"name":"Jocelyn","activation":2,"pairing":1,"COCreating":1,"completion":2,"overall":null},{"name":"Young Qi","activation":10,"pairing":7,"COCreating":5,"completion":8,"overall":null},{"name":"Geena","activation":5,"pairing":2,"COCreating":1,"completion":3,"overall":null}]}},"revenue":{"overview":{"headers":[{"text":"Billing Name","align":"start","value":"billing_name"},{"text":"Number Of IO","align":"center","sortable":false,"value":"number_of_io"},{"text":"Total IO Amount","align":"center","sortable":false,"value":"total_io_amount"},{"text":"Total Revenue Recognize","align":"center","sortable":false,"value":"total_revenue_recognize"},{"text":"% Completion","align":"center","sortable":false,"value":"completion_percentage"},{"text":"Amount Paid","align":"center","sortable":false,"value":"amount_paid"},{"text":"Date Of Last IO","align":"center","sortable":false,"value":"date_of_last_io"},{"text":"AM","align":"center","sortable":false,"value":"am"},{"text":"CC","align":"center","sortable":false,"value":"co"}],"data":[{"billing_id":1,"billing_name":"Revamp Haircare Pte Ltd","number_of_io":2,"total_io_amount":120000,"total_revenue_recognize":70000,"amount_paid":80000,"date_of_last_io":"Dec-21","am":["Jessica"],"co":["April","Shania"]},{"billing_id":2,"billing_name":"Maybank Pte Ltd","number_of_io":2,"total_io_amount":40000,"total_revenue_recognize":-39998,"amount_paid":25000,"date_of_last_io":"Jul-20","am":["Jessica"],"co":["April"]},{"billing_id":3,"billing_name":"Etika Pte Ltd","number_of_io":3,"total_io_amount":30000,"total_revenue_recognize":-29997,"amount_paid":10500,"date_of_last_io":"Sep-20","am":["Jessica"],"co":["Shania"]},{"billing_id":4,"billing_name":"Herbal Pharm Pte Ltd","number_of_io":1,"total_io_amount":10000,"total_revenue_recognize":-9999,"amount_paid":6000,"date_of_last_io":"Dec-21","am":["Jessica"],"co":["April","Shania"]},{"billing_id":5,"billing_name":"Herbal Pharm Pte Ltd","number_of_io":1,"total_io_amount":10000,"total_revenue_recognize":10000,"amount_paid":4000,"date_of_last_io":"Dec-21","am":["Jiayi"],"co":["April","Shania"]},{"billing_id":6,"billing_name":"Herbal Pharm Pte Ltd","number_of_io":2,"total_io_amount":50000,"total_revenue_recognize":40000,"amount_paid":20000,"date_of_last_io":"Dec-21","am":["Jiayi"],"co":["Shania"]}]},"details":{"headers":[{"text":"IO Number","align":"start","value":"io_number","groupable":false},{"text":"IO Amount","align":"center","sortable":false,"value":"io_amount","groupable":false},{"text":"Amount Paid","align":"center","sortable":false,"value":"amount_paid","groupable":false},{"text":"Campaign Name","align":"center","sortable":false,"value":"campaign_name","groupable":false},{"text":"Product Name","align":"center","sortable":false,"value":"product_name","groupable":false},{"text":"Budget","align":"center","sortable":false,"value":"budget","groupable":false},{"text":"Revenue","align":"center","sortable":false,"value":"revenue","groupable":false},{"text":"% Completion","align":"center","sortable":false,"value":"completion_percentage","groupable":false},{"text":"Date","align":"center","sortable":false,"value":"product_date","groupable":false}],"data":[{"billing_id":1,"io_number":"201900123","io_amount":100000,"amount_paid":70000,"campaign_name":"Journey with Jamie","budget":20000,"revenue":20000,"product_name":"Uncut","product_date":"Jun-19"},{"billing_id":1,"io_number":"201900123","io_amount":100000,"amount_paid":70000,"campaign_name":"Journey with Jamie","budget":10000,"revenue":-10000,"product_name":"Storytell","product_date":"Jul-19"},{"billing_id":1,"io_number":"201900123","io_amount":100000,"amount_paid":70000,"campaign_name":"Journey with Jamie","budget":40000,"revenue":10000,"product_name":"Amplify","product_date":"Sep-20"},{"billing_id":1,"io_number":"201900123","io_amount":100000,"amount_paid":70000,"campaign_name":"Journey with Jamie","budget":20000,"revenue":10000,"product_name":"Others","product_date":"Dec-21"},{"billing_id":1,"io_number":"201980231","io_amount":100000,"amount_paid":70000,"campaign_name":"Ambassador ","budget":10000,"revenue":10000,"product_name":"Others","product_date":"Dec-21"},{"billing_id":2,"io_number":"202140231","io_amount":100000,"amount_paid":50000,"campaign_name":"Ambassador ","budget":10000,"revenue":5000,"product_name":"Amplify","product_date":"May-21"},{"billing_id":5,"io_number":"202770231","io_amount":500000,"amount_paid":50000,"campaign_name":"Ambassador ","budget":100000,"revenue":50000,"product_name":"Storytell","product_date":"Jul-21"},{"billing_id":6,"io_number":"202350231","io_amount":400000,"amount_paid":30000,"campaign_name":"Ambassador ","budget":10000,"revenue":10000,"product_name":"Amplify","product_date":"Aug-21"},{"billing_id":6,"io_number":"202350232","io_amount":300000,"amount_paid":80000,"campaign_name":"Ambassador ","budget":50000,"revenue":40000,"product_name":"Uncut","product_date":"Sep-21"}]},"campaign_report":{"headers":[{"text":"Billing Name","align":"start","value":"billing_name"},{"text":"Campaign Name","align":"center","sortable":false,"value":"campaign_name"},{"text":"IO Number","align":"center","sortable":false,"value":"io_number"},{"text":"Vertical","align":"center","sortable":false,"value":"vertical"},{"text":"Total IO Budget","align":"center","sortable":false,"value":"total_io_budget"},{"text":"COGS","align":"center","sortable":false,"value":"cogs"},{"text":"Revenue Recognize","align":"center","sortable":false,"value":"revenue_recognize"},{"text":"NPS","align":"center","sortable":true,"value":"nps"},{"text":"Average Influencer Ratings","align":"center","sortable":true,"value":"average_influencer_ratings"},{"text":"Average Client Ratings","align":"center","sortable":true,"value":"average_client_ratings"},{"text":"Amount Paid to Creators","align":"center","sortable":false,"value":"amount_paid_to_creators"}],"data":[{"billing_id":1,"billing_name":"Revamp Haircare Pte Ltd","campaign_name":"PHS Journey","io_number":2019001002,"vertical":["Beauty","lifestyle"],"total_io_budget":50000,"cogs":25603,"revenue_recognize":29000,"nps":7,"average_influencer_ratings":7,"average_client_ratings":8,"amount_paid_to_creators":200},{"billing_id":2,"billing_name":"Maybank Pte Ltd","campaign_name":"Journey with Jamie","io_number":2019001003,"vertical":["Music","lifestyle","Technologies"],"total_io_budget":100000,"cogs":25900,"revenue_recognize":50000,"nps":8,"average_influencer_ratings":9,"average_client_ratings":10,"amount_paid_to_creators":400},{"billing_id":3,"billing_name":"Maybank Pte Ltd","campaign_name":"Demo","io_number":2019001003,"vertical":["Movies","Cars","Technologies"],"total_io_budget":100000,"cogs":25500,"revenue_recognize":40000,"nps":9,"average_influencer_ratings":10,"average_client_ratings":8,"amount_paid_to_creators":400}]},"campaign_report_details":{"headers":[{"text":"Handle","align":"start","value":"handle","sortable":true},{"text":"Following","align":"start","value":"following","sortable":true},{"text":"Engagement Rate","align":"start","value":"eng_rate","sortable":false},{"text":"Status","align":"start","value":"status","sortable":false},{"text":"Amount","align":"start","value":"amount","sortable":true},{"text":"Live Date","align":"start","value":"live_date","sortable":false},{"text":"Payment Date","align":"start","value":"payment_date","sortable":false},{"text":"Payee Name","align":"start","value":"payee_name","sortable":false},{"text":"Bank A/C No.","align":"start","value":"bank_account","sortable":false},{"text":"Swift Code","align":"start","value":"swift_code","sortable":false},{"text":"BIB REF","align":"start","value":"bib_ref","sortable":false},{"text":"FT REF","align":"start","value":"ft_ref","sortable":false},{"text":"Deliverable","align":"start","value":"deliverable","sortable":false},{"text":"Rating from Influencer","align":"start","value":"rating_from_influencer","sortable":true},{"text":"Date paid to influencer","align":"start","value":"date_paid_to_influencer","sortable":false}],"data":[{"billing_id":1,"handle":"jaderasif","following":300000,"eng_rate":"0.89%","status":"Processing Payment","amount":5000,"live_date":"6/1/2021","payment_date":"7/1/2021","payee_name":"Jade Rasif","bank_account":2093727971,"swift_code":"DBSSSGSGXXX","bib_ref":"","ft_ref":"","deliverable":["3 x IGS"," 3 x IGP"],"rating_from_influencer":7,"date_paid_to_influencer":""},{"billing_id":1,"handle":"jamieyeo","following":200000,"eng_rate":"0.89%","status":"Paid","amount":200,"live_date":"6/1/2021","payment_date":"7/1/2021","payee_name":"Jamie Yeo","bank_account":2093727971,"swift_code":"OCBCSGSGXXX","bib_ref":"BK21010094409345","ft_ref":"FT21010094409524","deliverable":["4 x IGS","3 x IGP"],"rating_from_influencer":7,"date_paid_to_influencer":""},{"billing_id":1,"handle":"getkobe","following":100000,"eng_rate":"0.89%","status":"Payout submitted","amount":400,"live_date":"6/1/2021","payment_date":"7/1/2021","payee_name":"Kobe","bank_account":2093727971,"swift_code":"DBSSSGSGXXX","bib_ref":"BK21010094409345","ft_ref":"FT21010094409524","deliverable":["5 x IGS","3 x IGP"],"rating_from_influencer":9,"date_paid_to_influencer":""},{"billing_id":1,"handle":"imchaaa","following":50000,"eng_rate":"0.89%","status":"Payout not submitted","amount":5000,"live_date":"6/1/2021","payment_date":"7/1/2021","payee_name":"Cha Lin","bank_account":2093727971,"swift_code":"UOVBSGSGXXX","bib_ref":"","ft_ref":"","deliverable":["6 x IGS","3 x IGP"],"rating_from_influencer":10,"date_paid_to_influencer":""},{"billing_id":1,"handle":"evangeline_leong","following":20000,"eng_rate":"0.89%","status":"Error in Details","amount":6000,"live_date":"6/1/2021","payment_date":"7/1/2021","payee_name":"Evangeline","bank_account":2093727971,"swift_code":"DBSSSGSGXXX","bib_ref":"","ft_ref":"","deliverable":["7 x IGS","3 x IGP"],"rating_from_influencer":8,"date_paid_to_influencer":""},{"billing_id":2,"handle":"roshini_m","following":10000,"eng_rate":"0.89%","status":"Reminder Sent ","amount":9000,"live_date":"6/1/2021","payment_date":"7/1/2021","payee_name":"Roshini","bank_account":2093727971,"swift_code":"DBSSSGSGXXX","bib_ref":"","ft_ref":"","deliverable":["8 x IGS","3 x IGP"],"rating_from_influencer":8,"date_paid_to_influencer":""}]}}}

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

module.exports = {"Speed":{"WEEKLY":{"labels":["Week1","Week2","Week3","week4"],"datasets":[{"label":"April","data":[5,15,14,7],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[8,18,2,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"April","data":[5,15,14,7,20,22,25,8,12,10,21,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16,22,8,13,15,22,25,26,20],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21,21,21,21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"April","data":[5,15,14,7],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"April","data":[10,15,14,7,25,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,18,23,22,24],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]}},"Quality":{"WEEKLY":{"labels":["Week1","Week2","Week3","week4"],"datasets":[{"label":"April","data":[5,15,14,7],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Benchmark","data":[8,18,2,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]},"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"April","data":[5,15,14,7,20,22,25,8,12,10,21,20],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16,22,8,13,15,22,25,26,20],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21,21,21,21,21,21,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"April","data":[5,15,14,7],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"April","data":[10,15,14,7,25,20],"borderColor":"rgba(255, 99, 132, 0.8)","fill":false,"stack":"Stack 0"},{"label":"Shania","data":[12,9,18,23,22,24],"borderColor":"rgba(255, 159, 64, 0.8)","fill":false,"stack":"Stack 1"},{"label":"Benchmark","data":[21,21,21,21,21,21],"borderColor":"rgba(54, 162, 235, 0.8)","fill":false,"stack":"Stack 2"}]},"REPORTABUSE":{"All":{"labels":["Non-compliance to Brief","Language Consideration","Clarity of Image","Inaccuracy of Factual Information","Inaccurate hastags & mentions"],"datasets":[{"data":[1,2,3,4,5],"backgroundColor":["rgba(255, 156, 132, 0.8)","rgba(255, 33, 64, 0.8)","rgba(255, 219, 235, 0.8)","rgba(255, 119, 111, 0.8)","rgba(255, 189, 123, 0.8)"]}]}}},"Spend":{"COGS":100000,"WEEKLY":{"labels":["Week1","Week2","Week3","week4"],"datasets":[{"label":"April","data":["5%","15%","14%","7%"],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[8,18,2,21],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"MONTHLY":{"labels":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"datasets":[{"label":"April","data":[10,20,15,17,20,22,30,18,12,16,21,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16,22,8,13,15,22,25,26,20],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[30,30,30,30,30,30,30,30,30,30,30,30],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"QUARTELY":{"labels":["Q1","Q2","Q3","Q4"],"datasets":[{"label":"April","data":[5,15,14,7],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,10,16],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[30,30,30,30],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]},"YEARLY":{"labels":["2016","2017","2018","2019","2020","2021"],"datasets":[{"label":"April","data":[10,15,14,7,25,20],"backgroundColor":"rgba(255, 99, 132, 0.8)","stack":"Stack 0"},{"label":"Shania","data":[12,9,18,23,22,24],"backgroundColor":"rgba(255, 159, 64, 0.8)","stack":"Stack 1"},{"label":"Benchmark","data":[30,30,30,30,30,30],"backgroundColor":"rgba(54, 162, 235, 0.8)","stack":"Stack 2"}]}}}

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

module.exports = {"totalActiveCampaigns":10,"totalInfluencersOnIMS":1074,"totalInfluencerPerMonth":30,"campaigns":{"ACTIVATION":{"name":"Activation","average":[{"avg":6,"title":"Average time to activate"},{"avg":4,"title":"Total Number of accounts"}],"items":[{"id":[1],"name":"Maybank","days":"4","createAt":"2020-05-10"},{"id":[1,2],"name":"NIKE","days":"5","createAt":"2021-05-10"},{"id":[1],"name":"HPB","days":"2","createAt":"2021-02-10"},{"id":[2],"name":"Maybank","days":"6","createAt":"2020-05-15"},{"id":[2],"name":"Maybank","days":"10","createAt":"2021-06-18"},{"id":[2],"name":"Maybank","days":"7","createAt":"2021-09-01"},{"id":[1],"name":"Maybank","days":"1","createAt":"2021-03-10"},{"id":[2,1],"name":"Maybank","days":"7","createAt":"2020-02-01"}]},"CREATING":{"name":"CO-CREATING","average":[{"avg":4,"title":"Average time to pair"},{"avg":3,"title":"Total Number of accounts"}],"items":[{"id":[1],"name":"Maybank","days":"4","createAt":"2020-02-10"},{"id":[1],"name":"Maybank","days":"5","createAt":"2020-08-10"},{"id":[1],"name":"Maybank","days":"2","createAt":"2020-01-12"},{"id":[1,2],"name":"Maybank","days":"4","createAt":"2021-05-10"},{"id":[2],"name":"Maybank","days":"5","createAt":"2021-01-10"},{"id":[2],"name":"NIKE","days":"2","createAt":"2021-03-13"},{"id":[1],"name":"HPS","days":"4","createAt":"2020-03-20"},{"id":[2],"name":"Tiger Broker","days":"5","createAt":"2021-04-30"},{"id":[1,2],"name":"Maybank","days":"2","createAt":"2020-04-18"}]},"PAIRING":{"name":"Pairing","average":[{"avg":6,"title":"Average time to pair"},{"avg":3,"title":"Total Number of accounts"}],"items":[{"id":[1],"name":"Maybank","days":"4","createAt":"2020-05-10"},{"id":[1],"name":"Maybank","days":"5","createAt":"2020-08-10"},{"id":[1],"name":"HPS","days":"2","createAt":"2020-03-10"},{"id":[1,2],"name":"Maybank","days":"4","createAt":"2020-04-10"},{"id":[1],"name":"NIKE","days":"5","createAt":"2021-05-10"},{"id":[2],"name":"Maybank","days":"2","createAt":"2021-08-10"},{"id":[1,2],"name":"COKE","days":"4","createAt":"2020-06-15"},{"id":[2,1],"name":"Tiger Brokers","days":"5","createAt":"2021-01-17"},{"id":[2],"name":"Maybank","days":"2","createAt":"2021-04-19"}]},"COMPLETE":{"name":"Complete","average":[{"avg":8,"title":"Average time to submit"}],"items":[{"id":[1],"name":"XM Trading","submit_payout":5,"yet_to_submit":15,"total_post":20,"createAt":"2020-05-10"},{"id":[1],"name":"Coke","submit_payout":1,"yet_to_submit":3,"total_post":4,"createAt":"2020-06-10"},{"id":[1],"name":"HPB","submit_payout":15,"yet_to_submit":5,"total_post":20,"createAt":"2020-01-10"},{"id":[2,1],"name":"Maybank","submit_payout":2,"yet_to_submit":8,"total_post":10,"createAt":"2020-10-10"},{"id":[1],"name":"NIKE","submit_payout":0,"yet_to_submit":15,"total_post":15,"createAt":"2021-05-10"},{"id":[2,1],"name":"Maybank","submit_payout":3,"yet_to_submit":3,"total_post":6,"createAt":"2021-02-10"},{"id":[1],"name":"Tiger Brokers","submit_payout":10,"yet_to_submit":0,"total_post":10,"createAt":"2021-07-19"},{"id":[1],"name":"Maybank","submit_payout":1,"yet_to_submit":2,"total_post":3,"createAt":"2021-04-10"},{"id":[2,1],"name":"Maybank","submit_payout":0,"yet_to_submit":0,"total_post":20,"createAt":"2021-05-20"}]},"DURATION":{"name":"Duration per stage","items":[{"name":"April","activation":50,"pairing":30,"COCreating":18,"completion":40,"overall":null},{"name":"Shania","activation":20,"pairing":21,"COCreating":5,"completion":20,"overall":null},{"name":"Jai Qi","activation":8,"pairing":5,"COCreating":4,"completion":8,"overall":null},{"name":"Jocelyn","activation":2,"pairing":1,"COCreating":1,"completion":2,"overall":null},{"name":"Young Qi","activation":10,"pairing":7,"COCreating":5,"completion":8,"overall":null},{"name":"Geena","activation":5,"pairing":2,"COCreating":1,"completion":3,"overall":null}]},"INFLUENCER_RATING":{"name":"Influencer Rating","items":[{"name":"XM Trading","avg_campaign":5,"avg_advertiser":4,"avg_kobe":3,"overall":3},{"name":"PHS","avg_campaign":50,"avg_advertiser":30,"avg_kobe":18,"overall":2},{"name":"Test Campaign","avg_campaign":50,"avg_advertiser":30,"avg_kobe":18,"overall":3},{"name":"Test Campaign 2","avg_campaign":50,"avg_advertiser":30,"avg_kobe":18,"overall":4},{"name":"Other Campaigns","avg_campaign":50,"avg_advertiser":30,"avg_kobe":18,"overall":6},{"name":"New Campaign","avg_campaign":50,"avg_advertiser":30,"avg_kobe":18,"overall":5}]},"CLIENT_RATING":{"name":"Client Rating","items":[{"name":"XM Trading","vertical":5,"budget":5,"avg_selection":5,"avg_draft":5,"avg_timeline":5,"avg_contentquality":4,"overall_kobeexperience":3,"overall_score":3},{"name":"PHS","vertical":5,"budget":5,"avg_selection":5,"avg_draft":5,"avg_timeline":5,"avg_contentquality":4,"overall_kobeexperience":3,"overall_score":3},{"name":"Test Campaign","vertical":5,"budget":5,"avg_selection":5,"avg_draft":5,"avg_timeline":5,"avg_contentquality":4,"overall_kobeexperience":3,"overall_score":3},{"name":"Test Campaign 2","vertical":5,"budget":5,"avg_selection":5,"avg_draft":5,"avg_timeline":5,"avg_contentquality":4,"overall_kobeexperience":3,"overall_score":3},{"name":"Other Campaigns","vertical":5,"budget":5,"avg_selection":5,"avg_draft":5,"avg_timeline":5,"avg_contentquality":4,"overall_kobeexperience":3,"overall_score":3},{"name":"New Campaign","vertical":5,"budget":5,"avg_selection":5,"avg_draft":5,"avg_timeline":5,"avg_contentquality":4,"overall_kobeexperience":3,"overall_score":3}]}}}

/***/ }),
/* 2356 */
/***/ (function(module, exports) {

module.exports = {"status":true,"data":{"interests":[{"id":1,"name":"Television & Film","count":95540390,"deprecated":false},{"id":3,"name":"Music","count":96103559,"deprecated":false},{"id":7,"name":"Shopping & Retail","count":90933713,"deprecated":false},{"id":9,"name":"Coffee, Tea & Beverages","count":90635385,"deprecated":false},{"id":11,"name":"Camera & Photography","count":100392395,"deprecated":false},{"id":13,"name":"Clothes, Shoes, Handbags & Accessories","count":104396187,"deprecated":false},{"id":19,"name":"Beer, Wine & Spirits","count":79196244,"deprecated":false},{"id":21,"name":"Sports","count":95470931,"deprecated":false},{"id":25,"name":"Electronics & Computers","count":95329292,"deprecated":false},{"id":30,"name":"Gaming","count":84290871,"deprecated":false},{"id":33,"name":"Activewear","count":89017247,"deprecated":false},{"id":36,"name":"Art & Design","count":95121144,"deprecated":false},{"id":43,"name":"Travel, Tourism & Aviation","count":98450659,"deprecated":false},{"id":58,"name":"Business & Careers","count":79708501,"deprecated":false},{"id":80,"name":"Beauty & Cosmetics","count":96733840,"deprecated":false},{"id":100,"name":"Healthcare & Medicine","count":65405896,"deprecated":false},{"id":130,"name":"Jewellery & Watches","count":85460277,"deprecated":false},{"id":139,"name":"Restaurants, Food & Grocery","count":97980765,"deprecated":false},{"id":190,"name":"Toys, Children & Baby","count":97697148,"deprecated":false},{"id":196,"name":"Fitness & Yoga","count":92891179,"deprecated":false},{"id":291,"name":"Wedding","count":87373802,"deprecated":false},{"id":405,"name":"Tobacco & Smoking","count":22069571,"deprecated":false},{"id":673,"name":"Pets","count":91104799,"deprecated":false},{"id":798,"name":"Healthy Lifestyle","count":90631404,"deprecated":false},{"id":1500,"name":"Luxury Goods","count":88618218,"deprecated":false},{"id":1560,"name":"Home Decor, Furniture & Garden","count":79213655,"deprecated":false},{"id":1708,"name":"Friends, Family & Relationships","count":102277259,"deprecated":false},{"id":1826,"name":"Cars & Motorbikes","count":94592173,"deprecated":false}],"brands":[{"id":2,"name":"20th Century Fox","interest":[{"id":1}],"count":237088,"deprecated":false},{"id":4,"name":"2Pac","interest":[{"id":3}],"count":7868455,"deprecated":false},{"id":8,"name":"7-Eleven","interest":[{"id":7}],"count":1303785,"deprecated":false},{"id":10,"name":"7UP","interest":[{"id":9}],"count":530324,"deprecated":false},{"id":12,"name":"A Game of Tones","interest":[{"id":11}],"count":22800460,"deprecated":false},{"id":14,"name":"A.P.C.","interest":[{"id":13}],"count":1290202,"deprecated":false},{"id":15,"name":"ABC","interest":[{"id":1}],"count":5534416,"deprecated":false},{"id":17,"name":"Abercrombie & Fitch","interest":[{"id":7}],"count":7289411,"deprecated":false},{"id":18,"name":"Ableton","interest":[{"id":3}],"count":5272986,"deprecated":false},{"id":20,"name":"Absolut","interest":[{"id":19}],"count":4036977,"deprecated":false},{"id":22,"name":"Abus","interest":[{"id":21}],"count":231880,"deprecated":false},{"id":23,"name":"Acacia Swimwear","interest":[{"id":13}],"count":102050,"deprecated":false},{"id":24,"name":"Accessorize","interest":[{"id":13}],"count":4245578,"deprecated":false},{"id":26,"name":"Acer","interest":[{"id":25}],"count":1179112,"deprecated":false},{"id":27,"name":"Acne Studios","interest":[{"id":13}],"count":1072640,"deprecated":false},{"id":28,"name":"ACRONYM","interest":[{"id":13}],"count":150682,"deprecated":false},{"id":29,"name":"Acroyoga","interest":[{"id":21}],"count":3415425,"deprecated":false},{"id":31,"name":"Activision Blizzard","interest":[{"id":30}],"count":33620897,"deprecated":false},{"id":32,"name":"Acura","interest":[{"id":1826}],"count":5170840,"deprecated":false},{"id":34,"name":"Adidas","interest":[{"id":33}],"count":84708890,"deprecated":false},{"id":35,"name":"Adidog","interest":[{"id":33}],"count":462139,"deprecated":false},{"id":37,"name":"Adobe","interest":[{"id":36}],"count":38340858,"deprecated":false},{"id":38,"name":"Adonit","interest":[{"id":25}],"count":15690,"deprecated":false},{"id":39,"name":"Adrianna Papell","interest":[{"id":13}],"count":43781,"deprecated":false},{"id":40,"name":"Aecht Schlenkerla Rauchbier","interest":[{"id":19}],"count":51275,"deprecated":false},{"id":41,"name":"Aeon","interest":[{"id":7}],"count":743734,"deprecated":false},{"id":44,"name":"Aeroflot","interest":[{"id":43}],"count":996611,"deprecated":false},{"id":45,"name":"Aeromexico","interest":[{"id":43}],"count":464061,"deprecated":false},{"id":46,"name":"Aéropostale","interest":[{"id":7}],"count":3060423,"deprecated":false},{"id":48,"name":"Afew store","interest":[{"id":7}],"count":29759,"deprecated":false},{"id":49,"name":"Affliction","interest":[{"id":13}],"count":73569,"deprecated":false},{"id":50,"name":"Afterpay","interest":[{"id":7}],"count":1441608,"deprecated":false},{"id":51,"name":"Agent Provocateur","interest":[{"id":13}],"count":320991,"deprecated":false},{"id":52,"name":"Agfa","interest":[{"id":11}],"count":142986,"deprecated":false},{"id":53,"name":"Air Canada","interest":[{"id":43}],"count":616177,"deprecated":false},{"id":54,"name":"Air France","interest":[{"id":43}],"count":942408,"deprecated":false},{"id":55,"name":"Air New Zealand","interest":[{"id":43}],"count":306231,"deprecated":false},{"id":56,"name":"AirAsia","interest":[{"id":43}],"count":3275358,"deprecated":false},{"id":57,"name":"Airbnb","interest":[{"id":43}],"count":25367937,"deprecated":false},{"id":59,"name":"Airtel","interest":[{"id":58}],"count":2472525,"deprecated":false},{"id":60,"name":"Airwalk","interest":[{"id":13}],"count":795450,"deprecated":false},{"id":61,"name":"Akai","interest":[{"id":3}],"count":2011513,"deprecated":false},{"id":62,"name":"Akg","interest":[{"id":3}],"count":1449369,"deprecated":false},{"id":63,"name":"Akrapovič","interest":[{"id":1826}],"count":2741577,"deprecated":false},{"id":64,"name":"Akris","interest":[{"id":13}],"count":76140,"deprecated":false},{"id":65,"name":"Al Merrick","interest":[{"id":21}],"count":64058,"deprecated":false},{"id":66,"name":"Alannah Hill","interest":[{"id":13}],"count":5236,"deprecated":false},{"id":67,"name":"Alberta Ferretti","interest":[{"id":13}],"count":184863,"deprecated":false},{"id":68,"name":"Alcatel","interest":[{"id":58}],"count":1443076,"deprecated":false},{"id":69,"name":"Alden","interest":[{"id":13}],"count":1002811,"deprecated":false},{"id":70,"name":"ALDI","interest":[{"id":7}],"count":2596179,"deprecated":false},{"id":72,"name":"Alessi","interest":[{"id":1560}],"count":252996,"deprecated":false},{"id":73,"name":"Alex Perry","interest":[{"id":13}],"count":67631,"deprecated":false},{"id":75,"name":"Alexander McQueen","interest":[{"id":1500}],"count":4378197,"deprecated":false},{"id":76,"name":"Alexander Wang","interest":[{"id":1500}],"count":2672246,"deprecated":false},{"id":78,"name":"Alfa Bank","interest":[{"id":58}],"count":84335,"deprecated":false},{"id":79,"name":"Alfa Romeo","interest":[{"id":1826}],"count":6528386,"deprecated":false},{"id":81,"name":"Algenist","interest":[{"id":80}],"count":79186,"deprecated":false},{"id":82,"name":"Alibaba","interest":[{"id":7}],"count":6005952,"deprecated":false},{"id":83,"name":"Alice + Olivia","interest":[{"id":13}],"count":36085,"deprecated":false},{"id":84,"name":"Alien Workshop","interest":[{"id":33}],"count":78425,"deprecated":false},{"id":85,"name":"Alienbees","interest":[{"id":11}],"count":20889,"deprecated":false},{"id":87,"name":"AliExpress","interest":[{"id":7}],"count":8234614,"deprecated":false},{"id":88,"name":"Alitalia","interest":[{"id":43}],"count":939563,"deprecated":false},{"id":89,"name":"All Blacks","interest":[{"id":21}],"count":17,"deprecated":false},{"id":90,"name":"All Saints","interest":[{"id":13}],"count":926341,"deprecated":false},{"id":91,"name":"Allen & Heath","interest":[{"id":3}],"count":134381,"deprecated":false},{"id":92,"name":"Allen Edmonds","interest":[{"id":13}],"count":37040,"deprecated":false},{"id":93,"name":"Allergan, Plc","interest":[{"id":80}],"count":980951,"deprecated":false},{"id":94,"name":"Allis-Chalmers","interest":[{"id":1826}],"count":15930,"deprecated":false},{"id":95,"name":"Aloft","interest":[{"id":43}],"count":73935,"deprecated":false},{"id":96,"name":"Alpha Industries","interest":[{"id":13}],"count":647569,"deprecated":false},{"id":97,"name":"Alphalete","interest":[{"id":33}],"count":1729594,"deprecated":false},{"id":98,"name":"Alpina","interest":[{"id":1826}],"count":888425,"deprecated":false},{"id":99,"name":"Alpinestars","interest":[{"id":33}],"count":2900608,"deprecated":false},{"id":101,"name":"ALS Association","interest":[{"id":100}],"count":542607,"deprecated":false},{"id":102,"name":"AltaModa","interest":[{"id":7}],"count":532418,"deprecated":false},{"id":103,"name":"Alverde","interest":[{"id":80}],"count":177432,"deprecated":false},{"id":104,"name":"Alviero Martini","interest":[{"id":1500}],"count":170025,"deprecated":false},{"id":105,"name":"Amazon","interest":[{"id":25}],"count":71002252,"deprecated":false},{"id":106,"name":"Amazon Music","interest":[{"id":3}],"count":5222971,"deprecated":false},{"id":107,"name":"AMD","interest":[{"id":25}],"count":1127835,"deprecated":false},{"id":108,"name":"American Airlines","interest":[{"id":43}],"count":4056913,"deprecated":false},{"id":109,"name":"American Apparel","interest":[{"id":13}],"count":900537,"deprecated":false},{"id":110,"name":"American Bass","interest":[{"id":3}],"count":39937,"deprecated":false},{"id":111,"name":"American Crew","interest":[{"id":80}],"count":426644,"deprecated":false},{"id":112,"name":"American Eagle","interest":[{"id":7}],"count":4191812,"deprecated":false},{"id":113,"name":"Amiclubwear","interest":[{"id":7}],"count":56939,"deprecated":false},{"id":114,"name":"Ampeg","interest":[{"id":3}],"count":587314,"deprecated":false},{"id":115,"name":"Amplid","interest":[{"id":21}],"count":8624,"deprecated":false},{"id":116,"name":"Amstel","interest":[{"id":19}],"count":3975506,"deprecated":false},{"id":117,"name":"Amway","interest":[{"id":80}],"count":5952925,"deprecated":false},{"id":118,"name":"Anantara","interest":[{"id":43}],"count":3439435,"deprecated":false},{"id":119,"name":"Anastasia Beverly Hills","interest":[{"id":80}],"count":29055135,"deprecated":false},{"id":121,"name":"Andis","interest":[{"id":80}],"count":5154403,"deprecated":false},{"id":122,"name":"Andrew James","interest":[{"id":1560}],"count":2388,"deprecated":false},{"id":123,"name":"Angenieux","interest":[{"id":11}],"count":102705,"deprecated":false},{"id":124,"name":"Ann Chery","interest":[{"id":80}],"count":54683,"deprecated":false},{"id":125,"name":"Ann Demeulemeester","interest":[{"id":1500}],"count":161189,"deprecated":false},{"id":126,"name":"Ann Summers","interest":[{"id":13}],"count":236777,"deprecated":false},{"id":127,"name":"Ann Taylor Loft","interest":[{"id":13}],"count":27563,"deprecated":false},{"id":128,"name":"ANNA LOTAN","interest":[{"id":80}],"count":1098594,"deprecated":false},{"id":129,"name":"Anna Sui","interest":[{"id":13}],"count":333565,"deprecated":false},{"id":131,"name":"Anne Klein","interest":[{"id":130}],"count":205002,"deprecated":false},{"id":132,"name":"Anthropologie","interest":[{"id":7}],"count":5208231,"deprecated":false},{"id":133,"name":"Antik Batik","interest":[{"id":13}],"count":20344,"deprecated":false},{"id":134,"name":"Antony Morato","interest":[{"id":13}],"count":382523,"deprecated":false},{"id":135,"name":"Ap Racing","interest":[{"id":1826}],"count":136826,"deprecated":false},{"id":136,"name":"Apeks","interest":[{"id":43}],"count":44391,"deprecated":false},{"id":137,"name":"Apollinaris","interest":[{"id":9}],"count":3591,"deprecated":false},{"id":138,"name":"Apple","interest":[{"id":25}],"count":89095008,"deprecated":false},{"id":140,"name":"Applebee's","interest":[{"id":139}],"count":1597586,"deprecated":false},{"id":141,"name":"Aquascutum","interest":[{"id":13}],"count":119890,"deprecated":false},{"id":142,"name":"Aquazzura","interest":[{"id":13}],"count":251847,"deprecated":false},{"id":143,"name":"Arbonne","interest":[{"id":80}],"count":1917567,"deprecated":false},{"id":144,"name":"Arctic Cat","interest":[{"id":1826}],"count":359374,"deprecated":false},{"id":145,"name":"Ardbeg","interest":[{"id":19}],"count":214761,"deprecated":false},{"id":146,"name":"Arden B","interest":[{"id":13}],"count":2875,"deprecated":false},{"id":147,"name":"Arduino","interest":[{"id":25}],"count":1480891,"deprecated":false},{"id":150,"name":"Ariat","interest":[{"id":13}],"count":1095168,"deprecated":false},{"id":151,"name":"Arla Foods","interest":[{"id":139}],"count":92462,"deprecated":false},{"id":152,"name":"Armani","interest":[{"id":1500}],"count":21995310,"deprecated":false},{"id":154,"name":"Arnotts","interest":[{"id":139}],"count":108599,"deprecated":false},{"id":155,"name":"Arri","interest":[{"id":11}],"count":1238484,"deprecated":false},{"id":156,"name":"Asahi","interest":[{"id":19}],"count":49725,"deprecated":false},{"id":157,"name":"ASDA","interest":[{"id":7}],"count":967080,"deprecated":false},{"id":158,"name":"Ashley Furniture","interest":[{"id":1560}],"count":33103,"deprecated":false},{"id":161,"name":"Asolo","interest":[{"id":33}],"count":363443,"deprecated":false},{"id":162,"name":"ASOS","interest":[{"id":7}],"count":23259035,"deprecated":false},{"id":163,"name":"Aspirin","interest":[{"id":100}],"count":846907,"deprecated":false},{"id":164,"name":"Asrock","interest":[{"id":25}],"count":203128,"deprecated":false},{"id":165,"name":"Aston Martin","interest":[{"id":1826}],"count":7565615,"deprecated":false},{"id":166,"name":"ASUS","interest":[{"id":25}],"count":6433530,"deprecated":false},{"id":167,"name":"Athleisure","interest":[{"id":33}],"count":122,"deprecated":false},{"id":168,"name":"Athleta","interest":[{"id":33}],"count":1328528,"deprecated":false},{"id":170,"name":"Atlas Copco","interest":[{"id":1826}],"count":77327,"deprecated":false},{"id":171,"name":"Atmos","interest":[{"id":13}],"count":1974503,"deprecated":false},{"id":172,"name":"Attack on Titan","interest":[{"id":1}],"count":39605,"deprecated":false},{"id":173,"name":"Auchan","interest":[{"id":7}],"count":1642720,"deprecated":false},{"id":175,"name":"Audemars Piguet","interest":[{"id":130}],"count":1873653,"deprecated":false},{"id":176,"name":"Audi","interest":[{"id":1826}],"count":53931835,"deprecated":false},{"id":177,"name":"Audiopipe","interest":[{"id":3}],"count":98204,"deprecated":false},{"id":178,"name":"Audison","interest":[{"id":3}],"count":71607,"deprecated":false},{"id":180,"name":"Augustiner Helles","interest":[{"id":19}],"count":518878,"deprecated":false},{"id":181,"name":"Aussiebum","interest":[{"id":13}],"count":425272,"deprecated":false},{"id":182,"name":"Auto Union","interest":[{"id":1826}],"count":33199,"deprecated":false},{"id":183,"name":"AutoZone","interest":[{"id":7}],"count":486319,"deprecated":false},{"id":184,"name":"Avaya","interest":[{"id":58}],"count":238012,"deprecated":false},{"id":185,"name":"Aveeno","interest":[{"id":80}],"count":447793,"deprecated":false},{"id":186,"name":"Avon","interest":[{"id":80}],"count":14435374,"deprecated":false},{"id":187,"name":"AwesomenessTV","interest":[{"id":1}],"count":42607,"deprecated":false},{"id":188,"name":"Axial","interest":[{"id":1826}],"count":153537,"deprecated":false},{"id":189,"name":"Ayinger","interest":[{"id":19}],"count":56948,"deprecated":false},{"id":191,"name":"Babybump","interest":[{"id":190}],"count":8118852,"deprecated":false},{"id":192,"name":"BaByliss","interest":[{"id":80}],"count":9374264,"deprecated":false},{"id":193,"name":"BabySwag","interest":[{"id":7}],"count":416298,"deprecated":false},{"id":194,"name":"Babywearing International","interest":[{"id":190}],"count":8982,"deprecated":false},{"id":195,"name":"Bacardi","interest":[{"id":19}],"count":6339182,"deprecated":false},{"id":198,"name":"Backroads","interest":[{"id":43}],"count":7604,"deprecated":false},{"id":199,"name":"Baileys","interest":[{"id":19}],"count":6871336,"deprecated":false},{"id":200,"name":"Baldinini","interest":[{"id":13}],"count":339280,"deprecated":false},{"id":201,"name":"Balenciaga","interest":[{"id":1500}],"count":37336900,"deprecated":false},{"id":202,"name":"Ball mason jar","interest":[{"id":1560}],"count":765633,"deprecated":false},{"id":203,"name":"Ballantine's","interest":[{"id":19}],"count":1329637,"deprecated":false},{"id":204,"name":"BALMAIN","interest":[{"id":1500}],"count":11880322,"deprecated":false},{"id":205,"name":"Banco Bradesco","interest":[{"id":58}],"count":9802183,"deprecated":false},{"id":206,"name":"Bandai Namco","interest":[{"id":190}],"count":2065790,"deprecated":false},{"id":207,"name":"Bang & Olufsen","interest":[{"id":3}],"count":86581,"deprecated":false},{"id":208,"name":"Bank of America","interest":[{"id":58}],"count":233700,"deprecated":false},{"id":209,"name":"Bank of China","interest":[{"id":58}],"count":10920,"deprecated":false},{"id":211,"name":"Barber Shop Connect","interest":[{"id":80}],"count":14701249,"deprecated":false},{"id":212,"name":"Barbie","interest":[{"id":190}],"count":1673929,"deprecated":false},{"id":213,"name":"Bare Escentuals","interest":[{"id":80}],"count":1470932,"deprecated":false},{"id":214,"name":"BarkBox","interest":[{"id":7}],"count":1366036,"deprecated":false},{"id":216,"name":"Baselworld","interest":[{"id":130}],"count":226224,"deprecated":false},{"id":217,"name":"BASF SE","interest":[{"id":58}],"count":36,"deprecated":false},{"id":219,"name":"Bath & Body Works","interest":[{"id":7}],"count":2051035,"deprecated":false},{"id":221,"name":"BaubleBar","interest":[{"id":13}],"count":114579,"deprecated":false},{"id":222,"name":"Bayer","interest":[{"id":100}],"count":217412,"deprecated":false},{"id":224,"name":"BBC","interest":[{"id":1}],"count":20157655,"deprecated":false},{"id":225,"name":"BCBG Max Azria","interest":[{"id":13}],"count":284743,"deprecated":false},{"id":227,"name":"Beautyblender","interest":[{"id":80}],"count":2903233,"deprecated":false},{"id":228,"name":"Beautybox","interest":[{"id":7}],"count":4431,"deprecated":false},{"id":229,"name":"BeautyGram Inc","interest":[{"id":7}],"count":2151613,"deprecated":false},{"id":230,"name":"Beautylish","interest":[{"id":7}],"count":183250,"deprecated":false},{"id":231,"name":"Beck`s","interest":[{"id":19}],"count":1382695,"deprecated":false},{"id":232,"name":"Bed Bath & Beyond","interest":[{"id":7}],"count":117861,"deprecated":false},{"id":233,"name":"Beefeater","interest":[{"id":19}],"count":1910735,"deprecated":false},{"id":234,"name":"Beeline","interest":[{"id":25}],"count":262416,"deprecated":false},{"id":235,"name":"beIN SPORTS","interest":[{"id":21}],"count":765544,"deprecated":false},{"id":236,"name":"Bellagio","interest":[{"id":43}],"count":21884537,"deprecated":false},{"id":237,"name":"Bellator MMA","interest":[{"id":21}],"count":2180378,"deprecated":false},{"id":238,"name":"Belstaff","interest":[{"id":13}],"count":128603,"deprecated":false},{"id":239,"name":"Belvedere","interest":[{"id":19}],"count":589283,"deprecated":false},{"id":240,"name":"Bendicks","interest":[{"id":139}],"count":1527,"deprecated":false},{"id":241,"name":"Benefit Cosmetics","interest":[{"id":80}],"count":8872357,"deprecated":false},{"id":242,"name":"Benihana","interest":[{"id":139}],"count":3497857,"deprecated":false},{"id":243,"name":"Bentley","interest":[{"id":1826}],"count":29497526,"deprecated":false},{"id":244,"name":"Berrisom","interest":[{"id":80}],"count":172220,"deprecated":false},{"id":245,"name":"Bershka","interest":[{"id":13}],"count":22536965,"deprecated":false},{"id":246,"name":"Best Buy","interest":[{"id":7}],"count":589270,"deprecated":false},{"id":247,"name":"Bethesda Softworks","interest":[{"id":30}],"count":3820859,"deprecated":false},{"id":248,"name":"BH Cosmetics","interest":[{"id":80}],"count":5505412,"deprecated":false},{"id":249,"name":"Billabong","interest":[{"id":13}],"count":6807679,"deprecated":false},{"id":250,"name":"Bimmerpost","interest":[{"id":1826}],"count":622601,"deprecated":false},{"id":251,"name":"Bioderma","interest":[{"id":80}],"count":1405377,"deprecated":false},{"id":252,"name":"Biogen","interest":[{"id":80}],"count":226791,"deprecated":false},{"id":253,"name":"Biore","interest":[{"id":80}],"count":362544,"deprecated":false},{"id":254,"name":"BioShock","interest":[{"id":30}],"count":490470,"deprecated":false},{"id":255,"name":"Biotherm","interest":[{"id":80}],"count":979770,"deprecated":false},{"id":256,"name":"Birchbox","interest":[{"id":7}],"count":472608,"deprecated":false},{"id":257,"name":"Bitburger","interest":[{"id":19}],"count":151885,"deprecated":false},{"id":258,"name":"BlackLove","interest":[{"id":1}],"count":1312614,"deprecated":false},{"id":259,"name":"Blackstar","interest":[{"id":3}],"count":436598,"deprecated":false},{"id":260,"name":"Blancpain","interest":[{"id":130}],"count":223705,"deprecated":false},{"id":261,"name":"Blaupunkt","interest":[{"id":25}],"count":84011,"deprecated":false},{"id":262,"name":"BleachBright","interest":[{"id":80}],"count":6816,"deprecated":false},{"id":264,"name":"Blink182","interest":[{"id":3}],"count":1529,"deprecated":false},{"id":265,"name":"Blogilates","interest":[{"id":196}],"count":132488,"deprecated":false},{"id":266,"name":"Bloomingdale's","interest":[{"id":7}],"count":582093,"deprecated":false},{"id":267,"name":"Blumarine","interest":[{"id":1500}],"count":523089,"deprecated":false},{"id":268,"name":"BMW","interest":[{"id":1826}],"count":66950749,"deprecated":false},{"id":269,"name":"BNSF RAILWAY","interest":[{"id":43}],"count":35157,"deprecated":false},{"id":270,"name":"Bobbi Brown Cosmetics","interest":[{"id":80}],"count":3062554,"deprecated":false},{"id":272,"name":"Bodytech","interest":[{"id":196}],"count":3253409,"deprecated":false},{"id":273,"name":"Boeing","interest":[{"id":43}],"count":8656052,"deprecated":false},{"id":274,"name":"Bombay Sapphire","interest":[{"id":19}],"count":545985,"deprecated":false},{"id":275,"name":"bonappetitmag","interest":[{"id":139}],"count":602159,"deprecated":false},{"id":276,"name":"Bonneville","interest":[{"id":1826}],"count":1636518,"deprecated":false},{"id":277,"name":"Bonprix","interest":[{"id":7}],"count":136766,"deprecated":false},{"id":278,"name":"boohoo","interest":[{"id":13}],"count":11704965,"deprecated":false},{"id":279,"name":"Booking.com","interest":[{"id":43}],"count":819686,"deprecated":false},{"id":280,"name":"Bosch","interest":[{"id":25}],"count":2141649,"deprecated":false},{"id":281,"name":"Bose","interest":[{"id":25}],"count":2027628,"deprecated":false},{"id":282,"name":"Bottega Veneta","interest":[{"id":1500}],"count":1860425,"deprecated":false},{"id":283,"name":"Boucheron","interest":[{"id":130}],"count":399367,"deprecated":false},{"id":284,"name":"Bourjois","interest":[{"id":80}],"count":2430091,"deprecated":false},{"id":285,"name":"BOXYCHARM","interest":[{"id":7}],"count":1385622,"deprecated":false},{"id":286,"name":"BRABUS","interest":[{"id":1826}],"count":4285739,"deprecated":false},{"id":287,"name":"Brahma","interest":[{"id":19}],"count":1758787,"deprecated":false},{"id":288,"name":"Brandy Melville","interest":[{"id":13}],"count":3878360,"deprecated":false},{"id":289,"name":"Braun","interest":[{"id":25}],"count":1078374,"deprecated":false},{"id":290,"name":"Breitling","interest":[{"id":7}],"count":1117345,"deprecated":false},{"id":292,"name":"Bridebook","interest":[{"id":291}],"count":434796,"deprecated":false},{"id":293,"name":"British Airways","interest":[{"id":43}],"count":651086,"deprecated":false},{"id":294,"name":"Britney Spears","interest":[{"id":3}],"count":778,"deprecated":false},{"id":295,"name":"Broadcom","interest":[{"id":25}],"count":40977,"deprecated":false},{"id":296,"name":"Bron Elektronik","interest":[{"id":11}],"count":147336,"deprecated":false},{"id":297,"name":"Brunello","interest":[{"id":19}],"count":1133762,"deprecated":false},{"id":298,"name":"Bud Light","interest":[{"id":19}],"count":3712271,"deprecated":false},{"id":299,"name":"Budweiser","interest":[{"id":19}],"count":19840703,"deprecated":false},{"id":300,"name":"Buffalo Wild Wings","interest":[{"id":139}],"count":403428,"deprecated":false},{"id":301,"name":"BUGARI ARMANDO srl","interest":[{"id":3}],"count":49250,"deprecated":false},{"id":302,"name":"Bugatti","interest":[{"id":1826}],"count":15776973,"deprecated":false},{"id":303,"name":"Buick","interest":[{"id":1826}],"count":1074641,"deprecated":false},{"id":304,"name":"Bulgari","interest":[{"id":1500}],"count":12683474,"deprecated":false},{"id":305,"name":"Burberry","interest":[{"id":1500}],"count":37526762,"deprecated":false},{"id":306,"name":"Burger King","interest":[{"id":139}],"count":7074769,"deprecated":false},{"id":307,"name":"Busch","interest":[{"id":19}],"count":8497297,"deprecated":false},{"id":308,"name":"Cacau Show","interest":[{"id":139}],"count":3746807,"deprecated":false},{"id":309,"name":"Cacharel","interest":[{"id":80}],"count":1070613,"deprecated":false},{"id":310,"name":"Cadbury","interest":[{"id":139}],"count":5099145,"deprecated":false},{"id":311,"name":"Cadillac","interest":[{"id":1826}],"count":20091651,"deprecated":false},{"id":312,"name":"Cafecito","interest":[{"id":9}],"count":8937511,"deprecated":false},{"id":313,"name":"Calvin Klein","interest":[{"id":13}],"count":38273734,"deprecated":false},{"id":314,"name":"Calzedonia","interest":[{"id":13}],"count":2920484,"deprecated":false},{"id":315,"name":"Campbell's","interest":[{"id":139}],"count":146757,"deprecated":false},{"id":317,"name":"Cannondale","interest":[{"id":21}],"count":1644153,"deprecated":false},{"id":318,"name":"Canon","interest":[{"id":25}],"count":72889061,"deprecated":false},{"id":319,"name":"Capital One","interest":[{"id":58}],"count":115130,"deprecated":false},{"id":320,"name":"Captain Morgan","interest":[{"id":19}],"count":553683,"deprecated":false},{"id":321,"name":"Carhartt","interest":[{"id":13}],"count":7401268,"deprecated":false},{"id":322,"name":"CarLifestyle","interest":[{"id":1826}],"count":25,"deprecated":false},{"id":323,"name":"Carling","interest":[{"id":19}],"count":431793,"deprecated":false},{"id":324,"name":"Carlsberg","interest":[{"id":19}],"count":1795635,"deprecated":false},{"id":325,"name":"Carmen Steffens","interest":[{"id":13}],"count":848701,"deprecated":false},{"id":326,"name":"Carolina Herrera","interest":[{"id":7}],"count":3248580,"deprecated":false},{"id":327,"name":"Carrefour","interest":[{"id":7}],"count":16842951,"deprecated":false},{"id":328,"name":"Cartier","interest":[{"id":130}],"count":30251117,"deprecated":false},{"id":329,"name":"Cartoon Network","interest":[{"id":1}],"count":4511271,"deprecated":false},{"id":330,"name":"Casetify","interest":[{"id":7}],"count":698404,"deprecated":false},{"id":331,"name":"Cathay Pacific","interest":[{"id":43}],"count":308800,"deprecated":false},{"id":332,"name":"Catupiry","interest":[{"id":139}],"count":10156022,"deprecated":false},{"id":333,"name":"Caudalie","interest":[{"id":80}],"count":1220935,"deprecated":false},{"id":334,"name":"CBS","interest":[{"id":1}],"count":22995741,"deprecated":false},{"id":335,"name":"CBS Television Studios","interest":[{"id":1}],"count":17361930,"deprecated":false},{"id":336,"name":"Cellucor","interest":[{"id":80}],"count":1046339,"deprecated":false},{"id":337,"name":"Certifeye","interest":[{"id":80}],"count":75344,"deprecated":false},{"id":338,"name":"Chanel","interest":[{"id":1500}],"count":54613532,"deprecated":false},{"id":339,"name":"Chantelle","interest":[{"id":13}],"count":734706,"deprecated":false},{"id":340,"name":"Chase","interest":[{"id":58}],"count":43325,"deprecated":false},{"id":341,"name":"Cheesecake Factory","interest":[{"id":139}],"count":1505337,"deprecated":false},{"id":342,"name":"Chevrolet","interest":[{"id":1826}],"count":60590621,"deprecated":false},{"id":343,"name":"Chick-fil-A","interest":[{"id":139}],"count":4391663,"deprecated":false},{"id":344,"name":"Chicwish","interest":[{"id":7}],"count":127836,"deprecated":false},{"id":345,"name":"China Glaze","interest":[{"id":80}],"count":205371,"deprecated":false},{"id":346,"name":"Chipotle Mexican Grill","interest":[{"id":139}],"count":15742279,"deprecated":false},{"id":347,"name":"Chiquelle","interest":[{"id":7}],"count":241277,"deprecated":false},{"id":348,"name":"Chivas Regal","interest":[{"id":19}],"count":738841,"deprecated":false},{"id":349,"name":"Chloé","interest":[{"id":1500}],"count":426634,"deprecated":false},{"id":351,"name":"Chop-Chop","interest":[{"id":80}],"count":833515,"deprecated":false},{"id":352,"name":"Christian Dior","interest":[{"id":1500}],"count":51690149,"deprecated":false},{"id":353,"name":"Christian Louboutin","interest":[{"id":1500}],"count":14214245,"deprecated":false},{"id":354,"name":"Chrysler","interest":[{"id":1826}],"count":18399778,"deprecated":false},{"id":355,"name":"Cinnabon","interest":[{"id":139}],"count":1938212,"deprecated":false},{"id":356,"name":"Circle K","interest":[{"id":7}],"count":174913,"deprecated":false},{"id":357,"name":"Ciroc","interest":[{"id":19}],"count":185413,"deprecated":false},{"id":358,"name":"Cisco","interest":[{"id":25}],"count":672095,"deprecated":false},{"id":359,"name":"Citi","interest":[{"id":58}],"count":1253289,"deprecated":false},{"id":360,"name":"Citroën","interest":[{"id":1826}],"count":148137,"deprecated":false},{"id":361,"name":"Clairol","interest":[{"id":80}],"count":94049,"deprecated":false},{"id":362,"name":"Clarins","interest":[{"id":80}],"count":4182012,"deprecated":false},{"id":363,"name":"Clarisonic","interest":[{"id":80}],"count":131916,"deprecated":false},{"id":364,"name":"Clean & Clear","interest":[{"id":80}],"count":192326,"deprecated":false},{"id":365,"name":"Clever Fit","interest":[{"id":196}],"count":436763,"deprecated":false},{"id":366,"name":"Clinique","interest":[{"id":80}],"count":4697746,"deprecated":false},{"id":367,"name":"CNN","interest":[{"id":1}],"count":9431371,"deprecated":false},{"id":368,"name":"Coachella","interest":[{"id":11}],"count":22781043,"deprecated":false},{"id":369,"name":"Coast 2 Coast","interest":[{"id":43}],"count":580116,"deprecated":false},{"id":370,"name":"Coca-Cola","interest":[{"id":9}],"count":55484025,"deprecated":false},{"id":372,"name":"Coffeegram","interest":[{"id":9}],"count":11470421,"deprecated":false},{"id":373,"name":"Cognizant","interest":[{"id":58}],"count":471376,"deprecated":false},{"id":374,"name":"Cole Haan","interest":[{"id":13}],"count":267749,"deprecated":false},{"id":375,"name":"Coles","interest":[{"id":7}],"count":483011,"deprecated":false},{"id":376,"name":"Color Therapy","interest":[{"id":36}],"count":52478,"deprecated":false},{"id":377,"name":"Colorama","interest":[{"id":80}],"count":3078355,"deprecated":false},{"id":378,"name":"ColourPop","interest":[{"id":80}],"count":2107343,"deprecated":false},{"id":379,"name":"Columbia Pictures","interest":[{"id":1}],"count":4964265,"deprecated":false},{"id":380,"name":"Comedy Central","interest":[{"id":1}],"count":6224135,"deprecated":false},{"id":381,"name":"Commerzbank","interest":[{"id":58}],"count":361131,"deprecated":false},{"id":382,"name":"Continental AG","interest":[{"id":1826}],"count":146217,"deprecated":false},{"id":383,"name":"Converse","interest":[{"id":13}],"count":50244231,"deprecated":false},{"id":384,"name":"Coors","interest":[{"id":19}],"count":4316129,"deprecated":false},{"id":385,"name":"Corona Extra","interest":[{"id":19}],"count":1374009,"deprecated":false},{"id":386,"name":"Costa Coffee","interest":[{"id":9}],"count":1230953,"deprecated":false},{"id":387,"name":"Costco","interest":[{"id":7}],"count":10849626,"deprecated":false},{"id":388,"name":"CouchSurfing","interest":[{"id":43}],"count":711670,"deprecated":false},{"id":389,"name":"Courrèges","interest":[{"id":80}],"count":81298,"deprecated":false},{"id":390,"name":"Coveteur","interest":[{"id":7}],"count":37515,"deprecated":false},{"id":391,"name":"Crate and Barrel","interest":[{"id":7}],"count":291005,"deprecated":false},{"id":394,"name":"Crown","interest":[{"id":43}],"count":65459,"deprecated":false},{"id":395,"name":"Crown Royal","interest":[{"id":19}],"count":992821,"deprecated":false},{"id":396,"name":"Crowne Plaza","interest":[{"id":43}],"count":162374,"deprecated":false},{"id":397,"name":"CSX","interest":[{"id":58}],"count":46429,"deprecated":false},{"id":398,"name":"Daihatsu","interest":[{"id":1826}],"count":4470232,"deprecated":false},{"id":399,"name":"Dallmayr","interest":[{"id":9}],"count":41865,"deprecated":false},{"id":400,"name":"Dancing with the Stars","interest":[{"id":1}],"count":709685,"deprecated":false},{"id":401,"name":"Daniel Wellington","interest":[{"id":130}],"count":7660922,"deprecated":false},{"id":402,"name":"Danone","interest":[{"id":139}],"count":6217382,"deprecated":false},{"id":403,"name":"DAPPERMAN","interest":[{"id":13}],"count":676201,"deprecated":false},{"id":404,"name":"DASH","interest":[{"id":13}],"count":8143,"deprecated":false},{"id":406,"name":"Davidoff","interest":[{"id":405}],"count":1975396,"deprecated":false},{"id":407,"name":"dawanda","interest":[{"id":7}],"count":62817,"deprecated":false},{"id":408,"name":"Days Inn","interest":[{"id":43}],"count":14270,"deprecated":false},{"id":409,"name":"DC Entertainment","interest":[{"id":1}],"count":77383095,"deprecated":false},{"id":411,"name":"Debenhams","interest":[{"id":7}],"count":1081481,"deprecated":false},{"id":412,"name":"Deepwave","interest":[{"id":80}],"count":33580,"deprecated":false},{"id":413,"name":"Delicius","interest":[{"id":7}],"count":2282273,"deprecated":false},{"id":414,"name":"Dell","interest":[{"id":25}],"count":2069821,"deprecated":false},{"id":415,"name":"DeLorean Motor Company","interest":[{"id":1826}],"count":1780446,"deprecated":false},{"id":416,"name":"Delta","interest":[{"id":43}],"count":2003341,"deprecated":false},{"id":417,"name":"DeluxeFX","interest":[{"id":11}],"count":74640,"deprecated":false},{"id":418,"name":"Denny's","interest":[{"id":139}],"count":1319276,"deprecated":false},{"id":419,"name":"Dermalogica","interest":[{"id":80}],"count":941714,"deprecated":false},{"id":420,"name":"Deutsche Bank","interest":[{"id":58}],"count":36874,"deprecated":false},{"id":421,"name":"Deutsche Post","interest":[{"id":58}],"count":42165,"deprecated":false},{"id":422,"name":"DevaCurl","interest":[{"id":80}],"count":582606,"deprecated":false},{"id":423,"name":"DeviantArt","interest":[{"id":36}],"count":1411560,"deprecated":false},{"id":424,"name":"DHL","interest":[{"id":58}],"count":884335,"deprecated":false},{"id":425,"name":"Diane von Furstenberg","interest":[{"id":13}],"count":572410,"deprecated":false},{"id":426,"name":"Discovery Media","interest":[{"id":1}],"count":974839,"deprecated":false},{"id":428,"name":"Dodge","interest":[{"id":1826}],"count":22660166,"deprecated":false},{"id":429,"name":"DODOLASHES","interest":[{"id":80}],"count":500686,"deprecated":false},{"id":430,"name":"DOGO","interest":[{"id":13}],"count":12444,"deprecated":false},{"id":431,"name":"Dolce & Gabbana","interest":[{"id":1500}],"count":17083428,"deprecated":false},{"id":432,"name":"Dollar General","interest":[{"id":7}],"count":155312,"deprecated":false},{"id":433,"name":"Dollar Tree","interest":[{"id":7}],"count":1050234,"deprecated":false},{"id":434,"name":"Domino's Pizza","interest":[{"id":139}],"count":986530,"deprecated":false},{"id":435,"name":"Donna Karan","interest":[{"id":13}],"count":3217393,"deprecated":false},{"id":436,"name":"DoubleTree","interest":[{"id":43}],"count":178465,"deprecated":false},{"id":437,"name":"Dove","interest":[{"id":80}],"count":1764615,"deprecated":false},{"id":438,"name":"Dr Pepper","interest":[{"id":9}],"count":557996,"deprecated":false},{"id":439,"name":"Dr. Martens","interest":[{"id":13}],"count":15883340,"deprecated":false},{"id":440,"name":"Dr. Oetker","interest":[{"id":139}],"count":455479,"deprecated":false},{"id":442,"name":"DreamWorks","interest":[{"id":1}],"count":1400970,"deprecated":false},{"id":443,"name":"Dsquared","interest":[{"id":1500}],"count":6413315,"deprecated":false},{"id":444,"name":"Dunkin' Donuts","interest":[{"id":139}],"count":3535736,"deprecated":false},{"id":445,"name":"Dymatize","interest":[{"id":80}],"count":896666,"deprecated":false},{"id":446,"name":"Dyson","interest":[{"id":25}],"count":4932433,"deprecated":false},{"id":447,"name":"E! News","interest":[{"id":1}],"count":429575,"deprecated":false},{"id":448,"name":"Easyjet","interest":[{"id":43}],"count":1040831,"deprecated":false},{"id":449,"name":"Easysim4u","interest":[{"id":25}],"count":60741,"deprecated":false},{"id":450,"name":"eBay","interest":[{"id":7}],"count":3813769,"deprecated":false},{"id":451,"name":"Ecotools","interest":[{"id":80}],"count":330780,"deprecated":false},{"id":452,"name":"Edeka","interest":[{"id":7}],"count":496402,"deprecated":false},{"id":453,"name":"Edelsteine","interest":[{"id":130}],"count":115829,"deprecated":false},{"id":454,"name":"El Corte Ingles","interest":[{"id":7}],"count":965222,"deprecated":false},{"id":456,"name":"Electrolux","interest":[{"id":25}],"count":1420173,"deprecated":false},{"id":457,"name":"Electronic Arts (EA)","interest":[{"id":30}],"count":360329,"deprecated":false},{"id":458,"name":"ELIE SAAB","interest":[{"id":1500}],"count":882494,"deprecated":false},{"id":459,"name":"Elinchrom","interest":[{"id":11}],"count":338083,"deprecated":false},{"id":460,"name":"Elisabetta Franchi","interest":[{"id":13}],"count":802463,"deprecated":false},{"id":461,"name":"ELITE SPORTS NUTRIENTS","interest":[{"id":80}],"count":45449,"deprecated":false},{"id":462,"name":"Elle Magazine","interest":[{"id":13}],"count":3216091,"deprecated":false},{"id":463,"name":"Embassy Suites Hotels","interest":[{"id":43}],"count":75266,"deprecated":false},{"id":464,"name":"Embryolisse","interest":[{"id":80}],"count":675874,"deprecated":false},{"id":465,"name":"Emirates Airlines","interest":[{"id":43}],"count":2079195,"deprecated":false},{"id":467,"name":"ENERGY PRO","interest":[{"id":80}],"count":953939,"deprecated":false},{"id":468,"name":"Energy Slim","interest":[{"id":80}],"count":1093781,"deprecated":false},{"id":469,"name":"eos Products","interest":[{"id":80}],"count":82837,"deprecated":false},{"id":471,"name":"Erborian","interest":[{"id":80}],"count":426431,"deprecated":false},{"id":472,"name":"Erdinger","interest":[{"id":19}],"count":458909,"deprecated":false},{"id":473,"name":"Ericsson","interest":[{"id":25}],"count":582658,"deprecated":false},{"id":474,"name":"ESPN","interest":[{"id":21}],"count":11591533,"deprecated":false},{"id":475,"name":"essie","interest":[{"id":80}],"count":2750714,"deprecated":false},{"id":477,"name":"Etienne Aigner","interest":[{"id":13}],"count":1904740,"deprecated":false},{"id":478,"name":"Etihad Airways","interest":[{"id":43}],"count":446639,"deprecated":false},{"id":479,"name":"Etisalat","interest":[{"id":58}],"count":725377,"deprecated":false},{"id":480,"name":"Etsy","interest":[{"id":7}],"count":19775413,"deprecated":false},{"id":481,"name":"Eurosport","interest":[{"id":21}],"count":371384,"deprecated":false},{"id":482,"name":"Eurostar","interest":[{"id":43}],"count":597272,"deprecated":false},{"id":483,"name":"Everlast","interest":[{"id":33}],"count":2536445,"deprecated":false},{"id":484,"name":"Evian","interest":[{"id":9}],"count":1120275,"deprecated":false},{"id":486,"name":"Exploremore","interest":[{"id":43}],"count":6753,"deprecated":false},{"id":487,"name":"Faber-Castell","interest":[{"id":36}],"count":5562956,"deprecated":false},{"id":488,"name":"Faberlic","interest":[{"id":80}],"count":4083056,"deprecated":false},{"id":489,"name":"FabFitFun","interest":[{"id":7}],"count":728910,"deprecated":false},{"id":490,"name":"Fabletics","interest":[{"id":33}],"count":1567601,"deprecated":false},{"id":491,"name":"Falabella","interest":[{"id":7}],"count":1791808,"deprecated":false},{"id":492,"name":"Fanta","interest":[{"id":9}],"count":2819541,"deprecated":false},{"id":493,"name":"Farfetch","interest":[{"id":13}],"count":523588,"deprecated":false},{"id":494,"name":"Farm to Table","interest":[{"id":7}],"count":1307,"deprecated":false},{"id":495,"name":"Fashion TV","interest":[{"id":1}],"count":283244,"deprecated":false},{"id":496,"name":"FashionNova","interest":[{"id":7}],"count":33156949,"deprecated":false},{"id":497,"name":"Fat to Fit","interest":[{"id":196}],"count":1,"deprecated":false},{"id":498,"name":"FedEx","interest":[{"id":58}],"count":5359271,"deprecated":false},{"id":500,"name":"Fendi","interest":[{"id":1500}],"count":26455745,"deprecated":false},{"id":502,"name":"Ferragamo","interest":[{"id":1500}],"count":7883273,"deprecated":false},{"id":503,"name":"Ferrari","interest":[{"id":1826}],"count":45433521,"deprecated":false},{"id":504,"name":"Ferrero","interest":[{"id":139}],"count":19023635,"deprecated":false},{"id":505,"name":"Fiat","interest":[{"id":1826}],"count":18328642,"deprecated":false},{"id":507,"name":"FIFA","interest":[{"id":21}],"count":39594515,"deprecated":false},{"id":508,"name":"Fisher-Price","interest":[{"id":190}],"count":948290,"deprecated":false},{"id":509,"name":"Fit Berry","interest":[{"id":196}],"count":7881,"deprecated":false},{"id":512,"name":"FitFluential","interest":[{"id":196}],"count":886635,"deprecated":false},{"id":513,"name":"Fitfriends Sporting Club","interest":[{"id":196}],"count":518131,"deprecated":false},{"id":517,"name":"FitTea","interest":[{"id":80}],"count":153008,"deprecated":false},{"id":518,"name":"Flickr","interest":[{"id":11}],"count":975138,"deprecated":false},{"id":519,"name":"Flight Club","interest":[{"id":7}],"count":438712,"deprecated":false},{"id":520,"name":"Florena","interest":[{"id":80}],"count":29104,"deprecated":false},{"id":521,"name":"Fly Kicks","interest":[{"id":7}],"count":1295009,"deprecated":false},{"id":522,"name":"Flynn Skye","interest":[{"id":7}],"count":7288,"deprecated":false},{"id":523,"name":"Folgers","interest":[{"id":9}],"count":113118,"deprecated":false},{"id":524,"name":"Foodspring","interest":[{"id":196}],"count":575831,"deprecated":false},{"id":525,"name":"Foot Locker","interest":[{"id":7}],"count":3480040,"deprecated":false},{"id":526,"name":"Ford","interest":[{"id":1826}],"count":51618544,"deprecated":false},{"id":527,"name":"Forever 21","interest":[{"id":13}],"count":22904911,"deprecated":false},{"id":528,"name":"FOREX","interest":[{"id":58}],"count":18263584,"deprecated":false},{"id":529,"name":"Four Points","interest":[{"id":43}],"count":111202,"deprecated":false},{"id":530,"name":"Four Seasons","interest":[{"id":43}],"count":3829091,"deprecated":false},{"id":531,"name":"FOX","interest":[{"id":1}],"count":3046396,"deprecated":false},{"id":533,"name":"Free People","interest":[{"id":7}],"count":3207945,"deprecated":false},{"id":534,"name":"Freeletics","interest":[{"id":196}],"count":398638,"deprecated":false},{"id":536,"name":"Fruh Kolsch","interest":[{"id":19}],"count":15403,"deprecated":false},{"id":537,"name":"Fujifilm","interest":[{"id":11}],"count":20102687,"deprecated":false},{"id":538,"name":"Fujitsu","interest":[{"id":25}],"count":392927,"deprecated":false},{"id":541,"name":"GALERIA Kaufhof","interest":[{"id":7}],"count":23581,"deprecated":false},{"id":542,"name":"Galia Lahav","interest":[{"id":291}],"count":443272,"deprecated":false},{"id":544,"name":"Gamescom","interest":[{"id":30}],"count":522612,"deprecated":false},{"id":545,"name":"GameStop","interest":[{"id":7}],"count":1695570,"deprecated":false},{"id":546,"name":"GAP","interest":[{"id":13}],"count":13172706,"deprecated":false},{"id":547,"name":"Garnier","interest":[{"id":80}],"count":10577462,"deprecated":false},{"id":548,"name":"Garuda Indonesia","interest":[{"id":43}],"count":2764964,"deprecated":false},{"id":549,"name":"Gatorade","interest":[{"id":9}],"count":7465631,"deprecated":false},{"id":550,"name":"GE","interest":[{"id":25}],"count":166406,"deprecated":false},{"id":552,"name":"GENTLE MONSTER","interest":[{"id":13}],"count":672153,"deprecated":false},{"id":553,"name":"Geocaching","interest":[{"id":43}],"count":12812504,"deprecated":false},{"id":554,"name":"Gerard Cosmetics","interest":[{"id":80}],"count":589403,"deprecated":false},{"id":555,"name":"Get It Done","interest":[{"id":196}],"count":63,"deprecated":false},{"id":556,"name":"GetBetter","interest":[{"id":196}],"count":1930,"deprecated":false},{"id":558,"name":"Gillette","interest":[{"id":80}],"count":4103566,"deprecated":false},{"id":560,"name":"Girlactik","interest":[{"id":80}],"count":157547,"deprecated":false},{"id":561,"name":"Giuseppe Zanotti Design","interest":[{"id":1500}],"count":641046,"deprecated":false},{"id":562,"name":"GIVENCHY","interest":[{"id":13}],"count":31659344,"deprecated":false},{"id":563,"name":"Giving Tuesday","interest":[{"id":1708}],"count":170,"deprecated":false},{"id":564,"name":"GLAMGLOW","interest":[{"id":80}],"count":1536736,"deprecated":false},{"id":565,"name":"Glamour","interest":[{"id":13}],"count":66806,"deprecated":false},{"id":566,"name":"GLAMSQUAD","interest":[{"id":80}],"count":788785,"deprecated":false},{"id":567,"name":"Glashütte","interest":[{"id":130}],"count":68531,"deprecated":false},{"id":568,"name":"Glenfiddich","interest":[{"id":19}],"count":600990,"deprecated":false},{"id":569,"name":"Glitter Eyes","interest":[{"id":80}],"count":436008,"deprecated":false},{"id":571,"name":"Glossybox","interest":[{"id":7}],"count":414780,"deprecated":false},{"id":572,"name":"GMC","interest":[{"id":1826}],"count":6068785,"deprecated":false},{"id":573,"name":"GoExplore","interest":[{"id":43}],"count":3733,"deprecated":false},{"id":574,"name":"Golden Goose Deluxe Brand","interest":[{"id":13}],"count":376331,"deprecated":false},{"id":575,"name":"Goldman Sachs","interest":[{"id":58}],"count":77643,"deprecated":false},{"id":576,"name":"GOLDWELL","interest":[{"id":80}],"count":755597,"deprecated":false},{"id":577,"name":"Google","interest":[{"id":25}],"count":72383315,"deprecated":false},{"id":578,"name":"GoPro","interest":[{"id":11}],"count":59404508,"deprecated":false},{"id":579,"name":"Gorillaz","interest":[{"id":3}],"count":41454,"deprecated":false},{"id":580,"name":"Gose","interest":[{"id":19}],"count":192049,"deprecated":false},{"id":581,"name":"Grammy Award","interest":[{"id":3}],"count":1395710,"deprecated":false},{"id":582,"name":"Granini","interest":[{"id":9}],"count":52279,"deprecated":false},{"id":583,"name":"Grey Goose","interest":[{"id":19}],"count":2158229,"deprecated":false},{"id":586,"name":"Gucci","interest":[{"id":1500}],"count":67692368,"deprecated":false},{"id":587,"name":"Guerlain","interest":[{"id":80}],"count":4786160,"deprecated":false},{"id":588,"name":"Guess","interest":[{"id":13}],"count":39633438,"deprecated":false},{"id":589,"name":"Guinness","interest":[{"id":19}],"count":19758719,"deprecated":false},{"id":590,"name":"Gymaholic","interest":[{"id":196}],"count":179,"deprecated":false},{"id":591,"name":"Gymboree","interest":[{"id":7}],"count":9263,"deprecated":false},{"id":592,"name":"Gymqueen","interest":[{"id":196}],"count":63217,"deprecated":false},{"id":593,"name":"H&M","interest":[{"id":13}],"count":2965028,"deprecated":false},{"id":594,"name":"H&M Home","interest":[{"id":1560}],"count":927091,"deprecated":false},{"id":595,"name":"Hacker-Pschorr","interest":[{"id":19}],"count":22239,"deprecated":false},{"id":596,"name":"Hairfinity","interest":[{"id":80}],"count":138664,"deprecated":false},{"id":599,"name":"Hampton Inn","interest":[{"id":43}],"count":14546,"deprecated":false},{"id":600,"name":"Harajuku","interest":[{"id":7}],"count":65,"deprecated":false},{"id":601,"name":"Haribo","interest":[{"id":139}],"count":2286630,"deprecated":false},{"id":602,"name":"Harley-Davidson","interest":[{"id":1826}],"count":26104348,"deprecated":false},{"id":603,"name":"Hasbro","interest":[{"id":190}],"count":1448155,"deprecated":false},{"id":604,"name":"Hasselblad","interest":[{"id":11}],"count":1367674,"deprecated":false},{"id":605,"name":"Hasseröder","interest":[{"id":19}],"count":7250,"deprecated":false},{"id":606,"name":"Havana Club","interest":[{"id":19}],"count":602898,"deprecated":false},{"id":607,"name":"HBO","interest":[{"id":1}],"count":53748005,"deprecated":false},{"id":608,"name":"Head & Shoulders","interest":[{"id":80}],"count":140248,"deprecated":false},{"id":609,"name":"Heineken","interest":[{"id":19}],"count":29816080,"deprecated":false},{"id":610,"name":"Heinz","interest":[{"id":139}],"count":4077940,"deprecated":false},{"id":611,"name":"Helen Gold","interest":[{"id":80}],"count":3835,"deprecated":false},{"id":612,"name":"Henkel","interest":[{"id":58}],"count":127697,"deprecated":false},{"id":613,"name":"Hennessy","interest":[{"id":19}],"count":13431774,"deprecated":false},{"id":614,"name":"Herbalife","interest":[{"id":80}],"count":27088143,"deprecated":false},{"id":615,"name":"Hermès","interest":[{"id":1500}],"count":22027845,"deprecated":false},{"id":616,"name":"Hershey's","interest":[{"id":139}],"count":2047217,"deprecated":false},{"id":617,"name":"Hewlett Packard Enterprise","interest":[{"id":25}],"count":61288,"deprecated":false},{"id":618,"name":"Hikvision","interest":[{"id":25}],"count":819800,"deprecated":false},{"id":619,"name":"Hilton","interest":[{"id":43}],"count":6514945,"deprecated":false},{"id":620,"name":"Hino","interest":[{"id":1826}],"count":1062502,"deprecated":false},{"id":621,"name":"HiPP","interest":[{"id":190}],"count":124853,"deprecated":false},{"id":622,"name":"Hitachi","interest":[{"id":25}],"count":1542039,"deprecated":false},{"id":623,"name":"Hockeylife","interest":[{"id":7}],"count":6867,"deprecated":false},{"id":624,"name":"Holden","interest":[{"id":1826}],"count":3859088,"deprecated":false},{"id":625,"name":"Holiday Inn","interest":[{"id":43}],"count":468323,"deprecated":false},{"id":626,"name":"Hollister Co","interest":[{"id":13}],"count":20475158,"deprecated":false},{"id":627,"name":"Holsten","interest":[{"id":19}],"count":98933,"deprecated":false},{"id":628,"name":"HomeGoods","interest":[{"id":7}],"count":2798475,"deprecated":false},{"id":629,"name":"Honda","interest":[{"id":1826}],"count":72357211,"deprecated":false},{"id":630,"name":"Honeywell","interest":[{"id":43}],"count":364657,"deprecated":false},{"id":631,"name":"Hoonigan","interest":[{"id":1826}],"count":1718520,"deprecated":false},{"id":632,"name":"Hot Topic","interest":[{"id":7}],"count":2387238,"deprecated":false},{"id":633,"name":"Hot Wheels","interest":[{"id":190}],"count":6250036,"deprecated":false},{"id":634,"name":"Hotel ibis","interest":[{"id":43}],"count":56468,"deprecated":false},{"id":635,"name":"HOTELES VINCCI","interest":[{"id":43}],"count":26445,"deprecated":false},{"id":638,"name":"Houston Livestock Show and Rodeo","interest":[{"id":3}],"count":1143679,"deprecated":false},{"id":639,"name":"HSBC","interest":[{"id":58}],"count":285161,"deprecated":false},{"id":640,"name":"Huawei","interest":[{"id":25}],"count":32392617,"deprecated":false},{"id":641,"name":"Hublot","interest":[{"id":130}],"count":9797034,"deprecated":false},{"id":642,"name":"Huda Beauty","interest":[{"id":80}],"count":35355595,"deprecated":false},{"id":643,"name":"Huggies","interest":[{"id":190}],"count":2488578,"deprecated":false},{"id":644,"name":"Hugo Boss","interest":[{"id":13}],"count":6273503,"deprecated":false},{"id":645,"name":"Hunkemöller","interest":[{"id":13}],"count":237381,"deprecated":false},{"id":646,"name":"Hurley","interest":[{"id":33}],"count":6118882,"deprecated":false},{"id":648,"name":"HYATT","interest":[{"id":43}],"count":1331575,"deprecated":false},{"id":649,"name":"Hyundai","interest":[{"id":1826}],"count":24551099,"deprecated":false},{"id":650,"name":"I LOVE MAKEUP","interest":[{"id":7}],"count":480,"deprecated":false},{"id":651,"name":"Iberia","interest":[{"id":43}],"count":1452326,"deprecated":false},{"id":652,"name":"Iberostar Hotels & Resorts","interest":[{"id":43}],"count":7966952,"deprecated":false},{"id":653,"name":"IBM","interest":[{"id":25}],"count":639046,"deprecated":false},{"id":655,"name":"Icelandair","interest":[{"id":43}],"count":503204,"deprecated":false},{"id":656,"name":"iHeartRadio Music Awards","interest":[{"id":3}],"count":6925423,"deprecated":false},{"id":657,"name":"iHeartRaves","interest":[{"id":13}],"count":246383,"deprecated":false},{"id":658,"name":"IKEA","interest":[{"id":7}],"count":23035756,"deprecated":false},{"id":659,"name":"Illamasqua","interest":[{"id":80}],"count":924010,"deprecated":false},{"id":660,"name":"Illesteva","interest":[{"id":13}],"count":254047,"deprecated":false},{"id":661,"name":"In-N-Out","interest":[{"id":139}],"count":213606,"deprecated":false},{"id":663,"name":"Infiniti","interest":[{"id":1826}],"count":3279583,"deprecated":false},{"id":664,"name":"Influenster","interest":[{"id":7}],"count":3696128,"deprecated":false},{"id":665,"name":"Infosys","interest":[{"id":58}],"count":414514,"deprecated":false},{"id":666,"name":"Innisfree","interest":[{"id":80}],"count":4764829,"deprecated":false},{"id":667,"name":"Insta Color","interest":[{"id":11}],"count":120,"deprecated":false},{"id":668,"name":"Instadraw","interest":[{"id":36}],"count":2285,"deprecated":false},{"id":669,"name":"InstaFilm","interest":[{"id":1}],"count":16408,"deprecated":false},{"id":670,"name":"Instahome","interest":[{"id":1560}],"count":5,"deprecated":false},{"id":672,"name":"InstaMovies","interest":[{"id":1}],"count":1244,"deprecated":false},{"id":674,"name":"Instapet","interest":[{"id":673}],"count":624,"deprecated":false},{"id":675,"name":"Instapics","interest":[{"id":11}],"count":15603,"deprecated":false},{"id":677,"name":"instaRUN","interest":[{"id":196}],"count":284512,"deprecated":false},{"id":680,"name":"Instasnap","interest":[{"id":11}],"count":2280,"deprecated":false},{"id":681,"name":"InstaVape","interest":[{"id":7}],"count":97767,"deprecated":false},{"id":683,"name":"Integrative Nutrition","interest":[{"id":139}],"count":152404,"deprecated":false},{"id":684,"name":"Intel","interest":[{"id":25}],"count":9745920,"deprecated":false},{"id":685,"name":"InterContinental","interest":[{"id":43}],"count":1012963,"deprecated":false},{"id":686,"name":"Intimissimi","interest":[{"id":13}],"count":2579100,"deprecated":false},{"id":687,"name":"Invisalign","interest":[{"id":80}],"count":2792044,"deprecated":false},{"id":688,"name":"Invisibobble","interest":[{"id":13}],"count":166971,"deprecated":false},{"id":689,"name":"IRONMAN","interest":[{"id":139}],"count":213568,"deprecated":false},{"id":690,"name":"Ishine365","interest":[{"id":7}],"count":13609,"deprecated":false},{"id":691,"name":"Isuzu","interest":[{"id":1826}],"count":2830006,"deprecated":false},{"id":692,"name":"Itaipava","interest":[{"id":19}],"count":11704570,"deprecated":false},{"id":693,"name":"ITV","interest":[{"id":1}],"count":1218371,"deprecated":false},{"id":694,"name":"Iveco","interest":[{"id":1826}],"count":1498888,"deprecated":false},{"id":695,"name":"Ivyrevel","interest":[{"id":7}],"count":28993,"deprecated":false},{"id":696,"name":"J Brand","interest":[{"id":13}],"count":80089,"deprecated":false},{"id":697,"name":"J. C. Penney","interest":[{"id":7}],"count":570470,"deprecated":false},{"id":698,"name":"J.Crew","interest":[{"id":7}],"count":1735636,"deprecated":false},{"id":699,"name":"J.W. Anderson","interest":[{"id":1500}],"count":220891,"deprecated":false},{"id":700,"name":"Jack Daniels","interest":[{"id":19}],"count":15380665,"deprecated":false},{"id":701,"name":"Jack In The Box","interest":[{"id":139}],"count":145310,"deprecated":false},{"id":702,"name":"JACQUEMUS","interest":[{"id":1500}],"count":2208234,"deprecated":false},{"id":703,"name":"Jacques Lemans","interest":[{"id":130}],"count":21957,"deprecated":false},{"id":704,"name":"Jagermeister","interest":[{"id":19}],"count":2647977,"deprecated":false},{"id":705,"name":"Jaguar","interest":[{"id":1826}],"count":17203617,"deprecated":false},{"id":706,"name":"Jameson","interest":[{"id":19}],"count":2643182,"deprecated":false},{"id":707,"name":"Japonesque","interest":[{"id":80}],"count":58064,"deprecated":false},{"id":708,"name":"Jawbone","interest":[{"id":25}],"count":1991,"deprecated":false},{"id":709,"name":"Jeep","interest":[{"id":1826}],"count":11524261,"deprecated":false},{"id":710,"name":"Jetblue Airways","interest":[{"id":43}],"count":1374644,"deprecated":false},{"id":711,"name":"JetSetter","interest":[{"id":43}],"count":1948613,"deprecated":false},{"id":712,"name":"JetSmarter","interest":[{"id":43}],"count":19983,"deprecated":false},{"id":713,"name":"Jil Sander","interest":[{"id":13}],"count":387804,"deprecated":false},{"id":714,"name":"Jim Beam","interest":[{"id":19}],"count":897059,"deprecated":false},{"id":715,"name":"Jimmy Choo","interest":[{"id":1500}],"count":3844998,"deprecated":false},{"id":716,"name":"JL Audio","interest":[{"id":3}],"count":302970,"deprecated":false},{"id":717,"name":"JOHN JOHN","interest":[{"id":13}],"count":1936118,"deprecated":false},{"id":718,"name":"Johnnie Walker","interest":[{"id":19}],"count":1796270,"deprecated":false},{"id":719,"name":"Johnson & Johnson","interest":[{"id":80}],"count":556981,"deprecated":false},{"id":720,"name":"Jollibee","interest":[{"id":139}],"count":1480723,"deprecated":false},{"id":721,"name":"Joseph Altuzarra","interest":[{"id":1500}],"count":55805,"deprecated":false},{"id":722,"name":"Joyetech","interest":[{"id":405}],"count":390136,"deprecated":false},{"id":723,"name":"JP Morgan","interest":[{"id":58}],"count":292176,"deprecated":false},{"id":724,"name":"JULIEN MACDONALD","interest":[{"id":1500}],"count":23628,"deprecated":false},{"id":725,"name":"Jumeirah","interest":[{"id":43}],"count":2917016,"deprecated":false},{"id":726,"name":"Just Cavalli","interest":[{"id":13}],"count":564085,"deprecated":false},{"id":727,"name":"Justin Bieber","interest":[{"id":3}],"count":40930004,"deprecated":false},{"id":728,"name":"Juvederm","interest":[{"id":80}],"count":2507736,"deprecated":false},{"id":729,"name":"Juventus","interest":[{"id":21}],"count":55181,"deprecated":false},{"id":730,"name":"Kailijumei","interest":[{"id":80}],"count":143176,"deprecated":false},{"id":731,"name":"KangerTech","interest":[{"id":405}],"count":351270,"deprecated":false},{"id":732,"name":"Kärcher","interest":[{"id":25}],"count":773748,"deprecated":false},{"id":733,"name":"KARL LAGERFELD","interest":[{"id":13}],"count":4416956,"deprecated":false},{"id":735,"name":"Kellerbier","interest":[{"id":19}],"count":85194,"deprecated":false},{"id":736,"name":"Kellogg's","interest":[{"id":139}],"count":551447,"deprecated":false},{"id":737,"name":"Kenworth","interest":[{"id":1826}],"count":707818,"deprecated":false},{"id":738,"name":"KENZO","interest":[{"id":13}],"count":16736605,"deprecated":false},{"id":739,"name":"Kerastase","interest":[{"id":80}],"count":3776164,"deprecated":false},{"id":740,"name":"Keyshia Ka'oir","interest":[{"id":80}],"count":425512,"deprecated":false},{"id":741,"name":"KFC","interest":[{"id":139}],"count":16281372,"deprecated":false},{"id":742,"name":"Kia","interest":[{"id":1826}],"count":2686165,"deprecated":false},{"id":743,"name":"Kia Motors","interest":[{"id":1826}],"count":8097301,"deprecated":false},{"id":744,"name":"Kickstagram","interest":[{"id":58}],"count":5583949,"deprecated":false},{"id":745,"name":"Kickstarter","interest":[{"id":25}],"count":5693728,"deprecated":false},{"id":746,"name":"KidStyle","interest":[{"id":190}],"count":2213648,"deprecated":false},{"id":747,"name":"Kinder","interest":[{"id":139}],"count":607356,"deprecated":false},{"id":748,"name":"Kinky-Curly","interest":[{"id":80}],"count":1841894,"deprecated":false},{"id":750,"name":"Kiss Proof","interest":[{"id":80}],"count":84,"deprecated":false},{"id":751,"name":"KitKat","interest":[{"id":139}],"count":16349138,"deprecated":false},{"id":752,"name":"KLM","interest":[{"id":43}],"count":1185139,"deprecated":false},{"id":753,"name":"Knoppers","interest":[{"id":139}],"count":51463,"deprecated":false},{"id":754,"name":"Knorr","interest":[{"id":139}],"count":613678,"deprecated":false},{"id":755,"name":"Koenigsegg Automotive AB","interest":[{"id":1826}],"count":1873283,"deprecated":false},{"id":756,"name":"Kohl's","interest":[{"id":7}],"count":714886,"deprecated":false},{"id":757,"name":"Korean Air","interest":[{"id":43}],"count":202224,"deprecated":false},{"id":758,"name":"KOSÉ","interest":[{"id":80}],"count":302973,"deprecated":false},{"id":759,"name":"Kraft Foods","interest":[{"id":139}],"count":1509960,"deprecated":false},{"id":760,"name":"Kroger","interest":[{"id":7}],"count":3640015,"deprecated":false},{"id":761,"name":"Krombacher","interest":[{"id":19}],"count":131811,"deprecated":false},{"id":762,"name":"Kronenbourg","interest":[{"id":19}],"count":113277,"deprecated":false},{"id":763,"name":"Kylie Cosmetics","interest":[{"id":80}],"count":9095272,"deprecated":false},{"id":764,"name":"L'Occitane","interest":[{"id":80}],"count":1026780,"deprecated":false},{"id":765,"name":"L'Oréal Paris","interest":[{"id":80}],"count":31349173,"deprecated":false},{"id":767,"name":"La Roche-Posay","interest":[{"id":80}],"count":3222191,"deprecated":false},{"id":768,"name":"Lacoste","interest":[{"id":13}],"count":28606373,"deprecated":false},{"id":769,"name":"Lamborghini","interest":[{"id":1826}],"count":54843904,"deprecated":false},{"id":770,"name":"Lancôme","interest":[{"id":80}],"count":15728024,"deprecated":false},{"id":771,"name":"Land Rover","interest":[{"id":1826}],"count":21340380,"deprecated":false},{"id":772,"name":"Laneíge","interest":[{"id":80}],"count":4922520,"deprecated":false},{"id":773,"name":"LaserAway","interest":[{"id":80}],"count":25147,"deprecated":false},{"id":774,"name":"LATAM","interest":[{"id":43}],"count":6875229,"deprecated":false},{"id":775,"name":"Launchpad","interest":[{"id":25}],"count":459180,"deprecated":false},{"id":776,"name":"Lay's","interest":[{"id":139}],"count":1671803,"deprecated":false},{"id":777,"name":"LC Waikiki","interest":[{"id":7}],"count":2414274,"deprecated":false},{"id":778,"name":"Le Petit Marseillais","interest":[{"id":80}],"count":195514,"deprecated":false},{"id":779,"name":"League of Legends","interest":[{"id":30}],"count":7514653,"deprecated":false},{"id":781,"name":"Lego","interest":[{"id":190}],"count":24587052,"deprecated":false},{"id":782,"name":"LEGOLAND","interest":[{"id":190}],"count":7521276,"deprecated":false},{"id":783,"name":"Leica","interest":[{"id":11}],"count":7038421,"deprecated":false},{"id":784,"name":"Leicester City F.C","interest":[{"id":21}],"count":37266,"deprecated":false},{"id":785,"name":"Lenovo","interest":[{"id":25}],"count":10219641,"deprecated":false},{"id":786,"name":"Levi's","interest":[{"id":13}],"count":39295337,"deprecated":false},{"id":787,"name":"Lexus","interest":[{"id":1826}],"count":24044660,"deprecated":false},{"id":788,"name":"LG Group","interest":[{"id":25}],"count":7209911,"deprecated":false},{"id":789,"name":"Lidl","interest":[{"id":7}],"count":2015978,"deprecated":false},{"id":790,"name":"Liebherr","interest":[{"id":1826}],"count":381844,"deprecated":false},{"id":792,"name":"Lime Crime","interest":[{"id":80}],"count":3383659,"deprecated":false},{"id":793,"name":"Lindt","interest":[{"id":139}],"count":4038438,"deprecated":false},{"id":794,"name":"Lionsgate","interest":[{"id":1}],"count":666684,"deprecated":false},{"id":795,"name":"Lipton","interest":[{"id":9}],"count":1419870,"deprecated":false},{"id":796,"name":"Liqui Moly","interest":[{"id":1826}],"count":382542,"deprecated":false},{"id":797,"name":"Littlest Pet Shop","interest":[{"id":190}],"count":58445,"deprecated":false},{"id":799,"name":"Liveglam","interest":[{"id":7}],"count":732315,"deprecated":false},{"id":800,"name":"Loewe","interest":[{"id":1500}],"count":2945206,"deprecated":false},{"id":801,"name":"Logitech","interest":[{"id":25}],"count":1807432,"deprecated":false},{"id":802,"name":"Lojas Renner","interest":[{"id":7}],"count":3865878,"deprecated":false},{"id":804,"name":"Lollapalooza","interest":[{"id":3}],"count":11719838,"deprecated":false},{"id":805,"name":"Longchamp","interest":[{"id":1500}],"count":3569254,"deprecated":false},{"id":806,"name":"Longines","interest":[{"id":130}],"count":1074333,"deprecated":false},{"id":808,"name":"Los Angeles Lakers","interest":[{"id":21}],"count":27410519,"deprecated":false},{"id":809,"name":"Louis Vuitton","interest":[{"id":1500}],"count":50208527,"deprecated":false},{"id":811,"name":"Loving Tan","interest":[{"id":80}],"count":259290,"deprecated":false},{"id":812,"name":"Lowe's","interest":[{"id":7}],"count":1487629,"deprecated":false},{"id":813,"name":"Löwenbräu","interest":[{"id":19}],"count":121986,"deprecated":false},{"id":814,"name":"Lucasfilm","interest":[{"id":1}],"count":748646,"deprecated":false},{"id":815,"name":"Lucky Strike","interest":[{"id":405}],"count":380291,"deprecated":false},{"id":816,"name":"Lufthansa","interest":[{"id":43}],"count":2090779,"deprecated":false},{"id":820,"name":"M O C K B E R G","interest":[{"id":130}],"count":22557,"deprecated":false},{"id":823,"name":"MAC Cosmetics","interest":[{"id":80}],"count":58427940,"deprecated":false},{"id":824,"name":"Macallan","interest":[{"id":19}],"count":793207,"deprecated":false},{"id":826,"name":"Maclaren","interest":[{"id":190}],"count":18860,"deprecated":false},{"id":827,"name":"Macy's","interest":[{"id":7}],"count":3018032,"deprecated":false},{"id":828,"name":"Madewell","interest":[{"id":7}],"count":1190660,"deprecated":false},{"id":829,"name":"MadWhips","interest":[{"id":7}],"count":87279,"deprecated":false},{"id":830,"name":"Maersk","interest":[{"id":58}],"count":241479,"deprecated":false},{"id":832,"name":"Magnaflow","interest":[{"id":1826}],"count":571281,"deprecated":false},{"id":833,"name":"Maison Margiela","interest":[{"id":1500}],"count":1419912,"deprecated":false},{"id":835,"name":"Make-upstudio","interest":[{"id":80}],"count":636687,"deprecated":false},{"id":836,"name":"Malibu","interest":[{"id":19}],"count":34191,"deprecated":false},{"id":837,"name":"MamaBear","interest":[{"id":190}],"count":2827894,"deprecated":false},{"id":838,"name":"Mamonde","interest":[{"id":80}],"count":800357,"deprecated":false},{"id":839,"name":"MAN Truck & Bus","interest":[{"id":1826}],"count":290966,"deprecated":false},{"id":840,"name":"Manfrotto","interest":[{"id":11}],"count":1214910,"deprecated":false},{"id":841,"name":"Manolo Blahnik","interest":[{"id":1500}],"count":514455,"deprecated":false},{"id":842,"name":"Marc Jacobs","interest":[{"id":13}],"count":6900536,"deprecated":false},{"id":843,"name":"Marcelle","interest":[{"id":80}],"count":1057467,"deprecated":false},{"id":844,"name":"Marchesa","interest":[{"id":1500}],"count":413992,"deprecated":false},{"id":845,"name":"Margaritaville","interest":[{"id":19}],"count":5566093,"deprecated":false},{"id":846,"name":"Marks & Spencer","interest":[{"id":7}],"count":1274916,"deprecated":false},{"id":847,"name":"Marlboro","interest":[{"id":405}],"count":55597,"deprecated":false},{"id":848,"name":"Marriott","interest":[{"id":43}],"count":3265161,"deprecated":false},{"id":849,"name":"Mars","interest":[{"id":139}],"count":40370,"deprecated":false},{"id":850,"name":"Marshalls","interest":[{"id":7}],"count":1397844,"deprecated":false},{"id":851,"name":"Marvel Entertainment","interest":[{"id":1}],"count":70612716,"deprecated":false},{"id":852,"name":"Maserati","interest":[{"id":1826}],"count":18841287,"deprecated":false},{"id":853,"name":"Masked Rider","interest":[{"id":190}],"count":44431,"deprecated":false},{"id":854,"name":"Massey Ferguson","interest":[{"id":21}],"count":783696,"deprecated":false},{"id":855,"name":"Massimo Dutti","interest":[{"id":13}],"count":1298960,"deprecated":false},{"id":856,"name":"MasterCard Incorporated","interest":[{"id":58}],"count":8120544,"deprecated":false},{"id":857,"name":"MATTEL","interest":[{"id":190}],"count":1629744,"deprecated":false},{"id":858,"name":"Max Factor","interest":[{"id":80}],"count":1180891,"deprecated":false},{"id":859,"name":"Maybank","interest":[{"id":58}],"count":2927426,"deprecated":false},{"id":860,"name":"Maybelline","interest":[{"id":80}],"count":32134854,"deprecated":false},{"id":861,"name":"Mazda","interest":[{"id":1826}],"count":23168378,"deprecated":false},{"id":862,"name":"McCafé","interest":[{"id":9}],"count":866889,"deprecated":false},{"id":863,"name":"McDonald's","interest":[{"id":139}],"count":56065586,"deprecated":false},{"id":864,"name":"McDonald’s","interest":[{"id":139}],"count":376378,"deprecated":false},{"id":865,"name":"McLaren","interest":[{"id":1826}],"count":16289427,"deprecated":false},{"id":866,"name":"Media Markt","interest":[{"id":7}],"count":372877,"deprecated":false},{"id":867,"name":"MEGA Bloks","interest":[{"id":190}],"count":52148,"deprecated":false},{"id":868,"name":"Megadeth","interest":[{"id":3}],"count":10383,"deprecated":false},{"id":869,"name":"Megafon","interest":[{"id":58}],"count":102067,"deprecated":false},{"id":870,"name":"Melia","interest":[{"id":43}],"count":193845,"deprecated":false},{"id":871,"name":"Mercedes-Benz","interest":[{"id":1826}],"count":62463080,"deprecated":false},{"id":872,"name":"Mercure","interest":[{"id":43}],"count":218307,"deprecated":false},{"id":873,"name":"Mesoderm","interest":[{"id":80}],"count":3501759,"deprecated":false},{"id":874,"name":"metabo","interest":[{"id":196}],"count":120631,"deprecated":false},{"id":875,"name":"Metrobank","interest":[{"id":58}],"count":154475,"deprecated":false},{"id":876,"name":"Mevius","interest":[{"id":405}],"count":35144,"deprecated":false},{"id":877,"name":"Michael Kors","interest":[{"id":13}],"count":16730772,"deprecated":false},{"id":878,"name":"Michelin","interest":[{"id":1826}],"count":123309,"deprecated":false},{"id":879,"name":"Microsoft","interest":[{"id":25}],"count":22543696,"deprecated":false},{"id":880,"name":"Miele","interest":[{"id":1560}],"count":1356527,"deprecated":false},{"id":881,"name":"Milani Cosmetics","interest":[{"id":80}],"count":3251349,"deprecated":false},{"id":882,"name":"Miller Lite","interest":[{"id":19}],"count":757132,"deprecated":false},{"id":883,"name":"MINI","interest":[{"id":1826}],"count":4632381,"deprecated":false},{"id":884,"name":"Minnesota Timberwolves","interest":[{"id":21}],"count":1386,"deprecated":false},{"id":885,"name":"Minute Maid","interest":[{"id":9}],"count":110589,"deprecated":false},{"id":886,"name":"Mirinda","interest":[{"id":9}],"count":381687,"deprecated":false},{"id":888,"name":"MISSGUIDED","interest":[{"id":7}],"count":3877206,"deprecated":false},{"id":889,"name":"Mitsubishi Motors","interest":[{"id":1826}],"count":17672682,"deprecated":false},{"id":890,"name":"Miu Miu","interest":[{"id":1500}],"count":3401893,"deprecated":false},{"id":891,"name":"Mixcloud","interest":[{"id":3}],"count":2053298,"deprecated":false},{"id":893,"name":"ModCloth","interest":[{"id":13}],"count":107981,"deprecated":false},{"id":894,"name":"ModelFIT","interest":[{"id":196}],"count":275706,"deprecated":false},{"id":896,"name":"Monoprix","interest":[{"id":7}],"count":369256,"deprecated":false},{"id":897,"name":"Monster Beverage","interest":[{"id":9}],"count":7095933,"deprecated":false},{"id":898,"name":"Monster High","interest":[{"id":190}],"count":709239,"deprecated":false},{"id":899,"name":"Monster Products","interest":[{"id":25}],"count":13703,"deprecated":false},{"id":901,"name":"Montecristo","interest":[{"id":405}],"count":1446943,"deprecated":false},{"id":902,"name":"Morgan Stanley","interest":[{"id":58}],"count":30890,"deprecated":false},{"id":903,"name":"Moroccanoil","interest":[{"id":80}],"count":972559,"deprecated":false},{"id":904,"name":"Morrisons","interest":[{"id":7}],"count":899669,"deprecated":false},{"id":905,"name":"Moschino","interest":[{"id":13}],"count":15300060,"deprecated":false},{"id":906,"name":"Motel Rocks","interest":[{"id":7}],"count":376445,"deprecated":false},{"id":907,"name":"Mothercare","interest":[{"id":7}],"count":2933315,"deprecated":false},{"id":908,"name":"Motives Cosmetics","interest":[{"id":80}],"count":292810,"deprecated":false},{"id":909,"name":"Motorola","interest":[{"id":25}],"count":10721415,"deprecated":false},{"id":910,"name":"Mountain Dew","interest":[{"id":9}],"count":1339934,"deprecated":false},{"id":912,"name":"Movenpick","interest":[{"id":139}],"count":115732,"deprecated":false},{"id":913,"name":"Movistar","interest":[{"id":1}],"count":5374223,"deprecated":false},{"id":914,"name":"MR PORTER","interest":[{"id":7}],"count":278590,"deprecated":false},{"id":915,"name":"MTV","interest":[{"id":3}],"count":18655643,"deprecated":false},{"id":916,"name":"Musclecar","interest":[{"id":1826}],"count":1030,"deprecated":false},{"id":918,"name":"MusclePharm","interest":[{"id":196}],"count":660578,"deprecated":false},{"id":919,"name":"MuscleTech","interest":[{"id":196}],"count":1414019,"deprecated":false},{"id":922,"name":"MV Agusta","interest":[{"id":1826}],"count":694197,"deprecated":false},{"id":923,"name":"My Bottle","interest":[{"id":798}],"count":912,"deprecated":false},{"id":925,"name":"MyFitnessPal","interest":[{"id":196}],"count":1443313,"deprecated":false},{"id":926,"name":"Mykita","interest":[{"id":13}],"count":121217,"deprecated":false},{"id":927,"name":"Myprotein","interest":[{"id":80}],"count":3444160,"deprecated":false},{"id":929,"name":"Napapijri","interest":[{"id":33}],"count":1286825,"deprecated":false},{"id":930,"name":"NARS Cosmetics","interest":[{"id":80}],"count":6705570,"deprecated":false},{"id":931,"name":"Nasty Gal","interest":[{"id":7}],"count":1392482,"deprecated":false},{"id":932,"name":"National Geographic","interest":[{"id":1}],"count":43420703,"deprecated":false},{"id":933,"name":"Naturalmojo","interest":[{"id":80}],"count":82835,"deprecated":false},{"id":934,"name":"NBA","interest":[{"id":21}],"count":44238664,"deprecated":false},{"id":935,"name":"NBC","interest":[{"id":1}],"count":11595397,"deprecated":false},{"id":936,"name":"Neiman Marcus","interest":[{"id":7}],"count":491801,"deprecated":false},{"id":938,"name":"Neoplan","interest":[{"id":1826}],"count":98813,"deprecated":false},{"id":939,"name":"Nerf","interest":[{"id":190}],"count":884997,"deprecated":false},{"id":940,"name":"Nescafé","interest":[{"id":9}],"count":6131816,"deprecated":false},{"id":941,"name":"Nestlé","interest":[{"id":9}],"count":7126007,"deprecated":false},{"id":942,"name":"NET-A-PORTER","interest":[{"id":7}],"count":352700,"deprecated":false},{"id":943,"name":"Netflix","interest":[{"id":1}],"count":77031068,"deprecated":false},{"id":945,"name":"Neutrogena","interest":[{"id":80}],"count":4043377,"deprecated":false},{"id":946,"name":"New Line Cinema","interest":[{"id":1}],"count":1620548,"deprecated":false},{"id":948,"name":"Newdress","interest":[{"id":7}],"count":913160,"deprecated":false},{"id":949,"name":"Next Model Management","interest":[{"id":11}],"count":689919,"deprecated":false},{"id":950,"name":"NH","interest":[{"id":43}],"count":70336,"deprecated":false},{"id":951,"name":"NHL","interest":[{"id":21}],"count":5766014,"deprecated":false},{"id":952,"name":"Nice Kicks","interest":[{"id":33}],"count":5558351,"deprecated":false},{"id":953,"name":"Nickelodeon","interest":[{"id":1}],"count":10407933,"deprecated":false},{"id":955,"name":"niederegger","interest":[{"id":139}],"count":17968,"deprecated":false},{"id":956,"name":"Nike","interest":[{"id":33}],"count":84590965,"deprecated":false},{"id":957,"name":"Nikon","interest":[{"id":11}],"count":65709024,"deprecated":false},{"id":958,"name":"nimm2","interest":[{"id":139}],"count":13744,"deprecated":false},{"id":959,"name":"Nintendo","interest":[{"id":25}],"count":32028866,"deprecated":false},{"id":960,"name":"Nissan","interest":[{"id":1826}],"count":54325670,"deprecated":false},{"id":961,"name":"Nivea","interest":[{"id":80}],"count":10531485,"deprecated":false},{"id":962,"name":"Nokia","interest":[{"id":25}],"count":16574761,"deprecated":false},{"id":964,"name":"NORDSTROM","interest":[{"id":7}],"count":6579987,"deprecated":false},{"id":965,"name":"Northskull","interest":[{"id":130}],"count":36751,"deprecated":false},{"id":967,"name":"Novartis","interest":[{"id":100}],"count":183576,"deprecated":false},{"id":968,"name":"Novotel","interest":[{"id":43}],"count":574186,"deprecated":false},{"id":969,"name":"NUDESTIX","interest":[{"id":80}],"count":384142,"deprecated":false},{"id":970,"name":"Nutella","interest":[{"id":139}],"count":58545677,"deprecated":false},{"id":971,"name":"Nutribullet","interest":[{"id":798}],"count":490649,"deprecated":false},{"id":972,"name":"Nvidia","interest":[{"id":25}],"count":4159259,"deprecated":false},{"id":974,"name":"Oculus","interest":[{"id":25}],"count":5600146,"deprecated":false},{"id":975,"name":"Oettinger","interest":[{"id":19}],"count":123976,"deprecated":false},{"id":976,"name":"Olaplex","interest":[{"id":80}],"count":8149623,"deprecated":false},{"id":977,"name":"Olay","interest":[{"id":80}],"count":564307,"deprecated":false},{"id":978,"name":"OLD NAVY","interest":[{"id":13}],"count":3390374,"deprecated":false},{"id":979,"name":"Old Spice","interest":[{"id":80}],"count":161028,"deprecated":false},{"id":980,"name":"Olive Garden","interest":[{"id":139}],"count":701655,"deprecated":false},{"id":981,"name":"Olloclip","interest":[{"id":11}],"count":95958,"deprecated":false},{"id":982,"name":"Olympus","interest":[{"id":11}],"count":4261999,"deprecated":false},{"id":983,"name":"Omega","interest":[{"id":130}],"count":6650040,"deprecated":false},{"id":984,"name":"On the Beach","interest":[{"id":43}],"count":6510,"deprecated":false},{"id":985,"name":"OneTeaspoon","interest":[{"id":13}],"count":169596,"deprecated":false},{"id":986,"name":"Onitsuka Tiger","interest":[{"id":13}],"count":2469167,"deprecated":false},{"id":988,"name":"OOTD Magazine","interest":[{"id":13}],"count":4034282,"deprecated":false},{"id":989,"name":"Opel","interest":[{"id":1826}],"count":5087212,"deprecated":false},{"id":990,"name":"OPS Objects","interest":[{"id":130}],"count":32770,"deprecated":false},{"id":991,"name":"Oral-B","interest":[{"id":80}],"count":513631,"deprecated":false},{"id":993,"name":"OREO","interest":[{"id":139}],"count":24207049,"deprecated":false},{"id":994,"name":"Organic Beauty","interest":[{"id":80}],"count":3630,"deprecated":false},{"id":995,"name":"Oriflame","interest":[{"id":80}],"count":13498627,"deprecated":false},{"id":996,"name":"OSGEMEOS","interest":[{"id":11}],"count":586793,"deprecated":false},{"id":997,"name":"Outfitgrid","interest":[{"id":13}],"count":1201693,"deprecated":false},{"id":998,"name":"Outlet46","interest":[{"id":7}],"count":2196,"deprecated":false},{"id":999,"name":"Ovaltine","interest":[{"id":139}],"count":7898867,"deprecated":false},{"id":1001,"name":"Pacific Northwest Wonderland","interest":[{"id":43}],"count":2984097,"deprecated":false},{"id":1002,"name":"Paco Rabanne","interest":[{"id":80}],"count":7747031,"deprecated":false},{"id":1003,"name":"Pagani","interest":[{"id":1826}],"count":2772418,"deprecated":false},{"id":1004,"name":"Palm Beach","interest":[{"id":43}],"count":67236,"deprecated":false},{"id":1005,"name":"Palmolive","interest":[{"id":80}],"count":480191,"deprecated":false},{"id":1006,"name":"Pampers","interest":[{"id":190}],"count":6545829,"deprecated":false},{"id":1007,"name":"Panasonic","interest":[{"id":25}],"count":7346180,"deprecated":false},{"id":1008,"name":"Panavision","interest":[{"id":11}],"count":174467,"deprecated":false},{"id":1009,"name":"Pandora","interest":[{"id":130}],"count":48100453,"deprecated":false},{"id":1010,"name":"Panera Bread","interest":[{"id":139}],"count":341058,"deprecated":false},{"id":1011,"name":"Pantene","interest":[{"id":80}],"count":3804617,"deprecated":false},{"id":1012,"name":"Pantone Inc","interest":[{"id":36}],"count":16995149,"deprecated":false},{"id":1013,"name":"Papa John's","interest":[{"id":139}],"count":380069,"deprecated":false},{"id":1014,"name":"Paramount Pictures","interest":[{"id":1}],"count":13904141,"deprecated":false},{"id":1016,"name":"Paris City Vision","interest":[{"id":11}],"count":426902,"deprecated":false},{"id":1018,"name":"Paulaner","interest":[{"id":19}],"count":1537551,"deprecated":false},{"id":1019,"name":"Paypal","interest":[{"id":58}],"count":36318178,"deprecated":false},{"id":1020,"name":"PB 0110","interest":[{"id":13}],"count":2958,"deprecated":false},{"id":1021,"name":"Penshoppe","interest":[{"id":7}],"count":393152,"deprecated":false},{"id":1022,"name":"Pepsi","interest":[{"id":9}],"count":33706839,"deprecated":false},{"id":1023,"name":"Peroni","interest":[{"id":19}],"count":900871,"deprecated":false},{"id":1024,"name":"Peroni Honey","interest":[{"id":139}],"count":692,"deprecated":false},{"id":1025,"name":"Perrier","interest":[{"id":9}],"count":995793,"deprecated":false},{"id":1026,"name":"Perrier-Jouët","interest":[{"id":19}],"count":257070,"deprecated":false},{"id":1027,"name":"Persil","interest":[{"id":1560}],"count":227382,"deprecated":false},{"id":1028,"name":"PEScience","interest":[{"id":80}],"count":91910,"deprecated":false},{"id":1029,"name":"Petronas","interest":[{"id":43}],"count":10481681,"deprecated":false},{"id":1030,"name":"PetSmart","interest":[{"id":7}],"count":2809606,"deprecated":false},{"id":1031,"name":"Peugeot","interest":[{"id":1826}],"count":13502602,"deprecated":false},{"id":1032,"name":"Pfizer","interest":[{"id":100}],"count":14633206,"deprecated":false},{"id":1033,"name":"Phase One","interest":[{"id":11}],"count":294884,"deprecated":false},{"id":1034,"name":"Philips","interest":[{"id":25}],"count":12357217,"deprecated":false},{"id":1035,"name":"Pic Collage","interest":[{"id":11}],"count":8736483,"deprecated":false},{"id":1036,"name":"Pilsner Urquell","interest":[{"id":19}],"count":2072910,"deprecated":false},{"id":1037,"name":"Pininfarina","interest":[{"id":1826}],"count":568339,"deprecated":false},{"id":1038,"name":"Pinkberry","interest":[{"id":139}],"count":670161,"deprecated":false},{"id":1039,"name":"Pinup Girl Clothing","interest":[{"id":7}],"count":54462,"deprecated":false},{"id":1040,"name":"Pirelli","interest":[{"id":1826}],"count":2877291,"deprecated":false},{"id":1041,"name":"Pittsburgh Steelers","interest":[{"id":21}],"count":31425,"deprecated":false},{"id":1042,"name":"Pixar","interest":[{"id":1}],"count":19648658,"deprecated":false},{"id":1044,"name":"Pizza Hut","interest":[{"id":139}],"count":6233280,"deprecated":false},{"id":1045,"name":"Pizza Lover","interest":[{"id":139}],"count":13239747,"deprecated":false},{"id":1046,"name":"Play-Doh","interest":[{"id":190}],"count":945326,"deprecated":false},{"id":1047,"name":"PLAYMOBIL","interest":[{"id":190}],"count":1663202,"deprecated":false},{"id":1048,"name":"Playskool","interest":[{"id":190}],"count":55624,"deprecated":false},{"id":1050,"name":"Pokemon","interest":[{"id":30}],"count":52075055,"deprecated":false},{"id":1053,"name":"Polaroid","interest":[{"id":11}],"count":40648299,"deprecated":false},{"id":1054,"name":"PolarPro","interest":[{"id":43}],"count":352242,"deprecated":false},{"id":1055,"name":"Polo Ralph Lauren","interest":[{"id":13}],"count":22492592,"deprecated":false},{"id":1056,"name":"Polyvore","interest":[{"id":7}],"count":209273,"deprecated":false},{"id":1057,"name":"Popular Demand","interest":[{"id":13}],"count":67837,"deprecated":false},{"id":1058,"name":"Porsche","interest":[{"id":1826}],"count":52266300,"deprecated":false},{"id":1059,"name":"Porter Airlines","interest":[{"id":43}],"count":16423,"deprecated":false},{"id":1060,"name":"Postmates","interest":[{"id":58}],"count":986814,"deprecated":false},{"id":1061,"name":"Pottery Barn","interest":[{"id":7}],"count":1259180,"deprecated":false},{"id":1062,"name":"Power Rangers","interest":[{"id":1}],"count":3329844,"deprecated":false},{"id":1063,"name":"PowerFood","interest":[{"id":7}],"count":521192,"deprecated":false},{"id":1064,"name":"Prada","interest":[{"id":1500}],"count":56218950,"deprecated":false},{"id":1065,"name":"Preloved","interest":[{"id":7}],"count":6607624,"deprecated":false},{"id":1066,"name":"Premier Inn","interest":[{"id":43}],"count":31888,"deprecated":false},{"id":1067,"name":"Premier League","interest":[{"id":21}],"count":378,"deprecated":false},{"id":1068,"name":"Preplife","interest":[{"id":196}],"count":584740,"deprecated":false},{"id":1069,"name":"Pretty Little Liars","interest":[{"id":1}],"count":104,"deprecated":false},{"id":1071,"name":"Primark","interest":[{"id":13}],"count":10175431,"deprecated":false},{"id":1072,"name":"Pringles","interest":[{"id":139}],"count":4900603,"deprecated":false},{"id":1073,"name":"Prismacolor","interest":[{"id":7}],"count":3721346,"deprecated":false},{"id":1074,"name":"Pro Tools","interest":[{"id":3}],"count":4411922,"deprecated":false},{"id":1075,"name":"Pro:Direct Soccer","interest":[{"id":7}],"count":84146,"deprecated":false},{"id":1076,"name":"Product Photography","interest":[{"id":11}],"count":1843,"deprecated":false},{"id":1078,"name":"Pronovias","interest":[{"id":291}],"count":864058,"deprecated":false},{"id":1079,"name":"ProSupps","interest":[{"id":196}],"count":343817,"deprecated":false},{"id":1080,"name":"Publix","interest":[{"id":7}],"count":2808432,"deprecated":false},{"id":1081,"name":"Pull&Bear","interest":[{"id":13}],"count":7635115,"deprecated":false},{"id":1082,"name":"Puma","interest":[{"id":33}],"count":53813394,"deprecated":false},{"id":1083,"name":"Pure beauty","interest":[{"id":80}],"count":586,"deprecated":false},{"id":1084,"name":"Qantas","interest":[{"id":43}],"count":1021064,"deprecated":false},{"id":1085,"name":"Qatar Airways","interest":[{"id":43}],"count":3063629,"deprecated":false},{"id":1086,"name":"Quaker Foods and Snacks","interest":[{"id":139}],"count":1344474,"deprecated":false},{"id":1087,"name":"Qualcomm","interest":[{"id":25}],"count":3162893,"deprecated":false},{"id":1088,"name":"Quiksilver","interest":[{"id":7}],"count":4820348,"deprecated":false},{"id":1089,"name":"QVC","interest":[{"id":58}],"count":30895,"deprecated":false},{"id":1090,"name":"Rabobank","interest":[{"id":58}],"count":234884,"deprecated":false},{"id":1091,"name":"Radeberger","interest":[{"id":19}],"count":31836,"deprecated":false},{"id":1092,"name":"Radiohead","interest":[{"id":3}],"count":1635,"deprecated":false},{"id":1093,"name":"RadioShack","interest":[{"id":3}],"count":44584,"deprecated":false},{"id":1094,"name":"Raiffeisen Bank","interest":[{"id":58}],"count":36659,"deprecated":false},{"id":1095,"name":"Rakuten","interest":[{"id":21}],"count":581212,"deprecated":false},{"id":1096,"name":"RAM Trucks","interest":[{"id":1826}],"count":612402,"deprecated":false},{"id":1097,"name":"Ramada","interest":[{"id":43}],"count":301418,"deprecated":false},{"id":1098,"name":"Rammstein","interest":[{"id":3}],"count":318913,"deprecated":false},{"id":1100,"name":"Ray-Ban","interest":[{"id":13}],"count":41661558,"deprecated":false},{"id":1101,"name":"READY STOCK","interest":[{"id":7}],"count":1782,"deprecated":false},{"id":1103,"name":"Real Madrid","interest":[{"id":21}],"count":251287,"deprecated":false},{"id":1104,"name":"Real Techniques","interest":[{"id":80}],"count":1570866,"deprecated":false},{"id":1105,"name":"Red Bull","interest":[{"id":9}],"count":39983872,"deprecated":false},{"id":1106,"name":"Red Lobster","interest":[{"id":139}],"count":463325,"deprecated":false},{"id":1107,"name":"RedBubble","interest":[{"id":7}],"count":1292396,"deprecated":false},{"id":1108,"name":"Reebok","interest":[{"id":33}],"count":35016575,"deprecated":false},{"id":1109,"name":"Reese's","interest":[{"id":139}],"count":1605301,"deprecated":false},{"id":1110,"name":"Rémy Martin","interest":[{"id":19}],"count":710021,"deprecated":false},{"id":1112,"name":"Renault","interest":[{"id":1826}],"count":19988950,"deprecated":false},{"id":1113,"name":"Residence Inn","interest":[{"id":43}],"count":11424,"deprecated":false},{"id":1114,"name":"Revlon","interest":[{"id":80}],"count":9381435,"deprecated":false},{"id":1115,"name":"REVOLVE","interest":[{"id":7}],"count":5057553,"deprecated":false},{"id":1117,"name":"Rexona","interest":[{"id":80}],"count":1991789,"deprecated":false},{"id":1118,"name":"Riachuelo","interest":[{"id":7}],"count":8632282,"deprecated":false},{"id":1119,"name":"Ricard","interest":[{"id":19}],"count":1285779,"deprecated":false},{"id":1122,"name":"Rimmel","interest":[{"id":80}],"count":5277801,"deprecated":false},{"id":1123,"name":"Ritter Sport","interest":[{"id":139}],"count":287255,"deprecated":false},{"id":1124,"name":"River Island","interest":[{"id":13}],"count":2328599,"deprecated":false},{"id":1125,"name":"Roberto Cavalli","interest":[{"id":1500}],"count":834744,"deprecated":false},{"id":1126,"name":"ROCCAT","interest":[{"id":30}],"count":53750,"deprecated":false},{"id":1127,"name":"Rocksbox","interest":[{"id":130}],"count":24667,"deprecated":false},{"id":1128,"name":"Rolex","interest":[{"id":130}],"count":44553585,"deprecated":false},{"id":1129,"name":"Rollerblade","interest":[{"id":33}],"count":839251,"deprecated":false},{"id":1131,"name":"Rolls-Royce","interest":[{"id":1826}],"count":15096489,"deprecated":false},{"id":1132,"name":"Ross Dress For Less","interest":[{"id":7}],"count":281530,"deprecated":false},{"id":1133,"name":"Rossignol","interest":[{"id":21}],"count":544669,"deprecated":false},{"id":1134,"name":"Rossmann","interest":[{"id":7}],"count":1085436,"deprecated":false},{"id":1136,"name":"Rotiform","interest":[{"id":1826}],"count":905852,"deprecated":false},{"id":1137,"name":"Royal Mail","interest":[{"id":58}],"count":227898,"deprecated":false},{"id":1138,"name":"Ryanair","interest":[{"id":43}],"count":2945706,"deprecated":false},{"id":1141,"name":"Sainsbury's","interest":[{"id":7}],"count":1035008,"deprecated":false},{"id":1142,"name":"Salesforce","interest":[{"id":58}],"count":717090,"deprecated":false},{"id":1143,"name":"Sally Beauty Supply LLC","interest":[{"id":7}],"count":347352,"deprecated":false},{"id":1144,"name":"SalonCentric","interest":[{"id":80}],"count":516204,"deprecated":false},{"id":1145,"name":"Sam's Club","interest":[{"id":7}],"count":358361,"deprecated":false},{"id":1146,"name":"Samsonite","interest":[{"id":43}],"count":233346,"deprecated":false},{"id":1147,"name":"Samsung Group","interest":[{"id":25}],"count":74320785,"deprecated":false},{"id":1150,"name":"San Miguel Corporation","interest":[{"id":19}],"count":27584,"deprecated":false},{"id":1151,"name":"Sanderson","interest":[{"id":1560}],"count":1237446,"deprecated":false},{"id":1152,"name":"Sandisk","interest":[{"id":25}],"count":1350656,"deprecated":false},{"id":1153,"name":"Sanofi","interest":[{"id":100}],"count":184259,"deprecated":false},{"id":1154,"name":"Santa Lolla","interest":[{"id":13}],"count":690933,"deprecated":false},{"id":1157,"name":"Sberbank","interest":[{"id":58}],"count":573465,"deprecated":false},{"id":1158,"name":"Scania","interest":[{"id":1826}],"count":3267989,"deprecated":false},{"id":1160,"name":"Schneider Weisse","interest":[{"id":19}],"count":49947,"deprecated":false},{"id":1161,"name":"Schutz","interest":[{"id":13}],"count":3636021,"deprecated":false},{"id":1162,"name":"Schwartz's","interest":[{"id":139}],"count":1171092,"deprecated":false},{"id":1163,"name":"Schwarzkopf","interest":[{"id":80}],"count":4441732,"deprecated":false},{"id":1164,"name":"Scion","interest":[{"id":1826}],"count":9941846,"deprecated":false},{"id":1165,"name":"ScissorSalute","interest":[{"id":80}],"count":315586,"deprecated":false},{"id":1166,"name":"Scotiabank","interest":[{"id":58}],"count":1021632,"deprecated":false},{"id":1167,"name":"Scuf Gaming","interest":[{"id":25}],"count":205063,"deprecated":false},{"id":1169,"name":"Seagate","interest":[{"id":25}],"count":1677197,"deprecated":false},{"id":1170,"name":"Selfiegram","interest":[{"id":11}],"count":10581415,"deprecated":false},{"id":1171,"name":"Selfridges","interest":[{"id":7}],"count":3420372,"deprecated":false},{"id":1172,"name":"SeneGence","interest":[{"id":80}],"count":1275033,"deprecated":false},{"id":1173,"name":"Sennheiser","interest":[{"id":25}],"count":1609357,"deprecated":false},{"id":1174,"name":"Sephora","interest":[{"id":80}],"count":23274697,"deprecated":false},{"id":1175,"name":"SEVENFRIDAY","interest":[{"id":130}],"count":1127308,"deprecated":false},{"id":1176,"name":"Shake Shack","interest":[{"id":139}],"count":2268028,"deprecated":false},{"id":1178,"name":"Shea Moisture","interest":[{"id":80}],"count":1635844,"deprecated":false},{"id":1180,"name":"Sheraton","interest":[{"id":43}],"count":1436860,"deprecated":false},{"id":1181,"name":"Sherri Hill","interest":[{"id":13}],"count":588438,"deprecated":false},{"id":1182,"name":"Shiseido","interest":[{"id":80}],"count":4913885,"deprecated":false},{"id":1183,"name":"ShoeDazzle","interest":[{"id":13}],"count":249119,"deprecated":false},{"id":1184,"name":"Shoegame","interest":[{"id":7}],"count":2904,"deprecated":false},{"id":1185,"name":"Shoegasm","interest":[{"id":7}],"count":2307972,"deprecated":false},{"id":1186,"name":"Shopkins","interest":[{"id":7}],"count":529317,"deprecated":false},{"id":1187,"name":"ShopStyle","interest":[{"id":7}],"count":114945,"deprecated":false},{"id":1188,"name":"SHREDZ","interest":[{"id":80}],"count":2662073,"deprecated":false},{"id":1189,"name":"Siemens","interest":[{"id":25}],"count":1772889,"deprecated":false},{"id":1192,"name":"Singapore Airlines","interest":[{"id":43}],"count":733073,"deprecated":false},{"id":1193,"name":"SK-II","interest":[{"id":80}],"count":608118,"deprecated":false},{"id":1194,"name":"SkateSpot","interest":[{"id":21}],"count":1087916,"deprecated":false},{"id":1195,"name":"Skechers","interest":[{"id":13}],"count":5897142,"deprecated":false},{"id":1196,"name":"SkinCeuticals","interest":[{"id":80}],"count":624001,"deprecated":false},{"id":1197,"name":"Skindinavia","interest":[{"id":80}],"count":142997,"deprecated":false},{"id":1198,"name":"SkinFood","interest":[{"id":80}],"count":2179457,"deprecated":false},{"id":1199,"name":"Skoal","interest":[{"id":19}],"count":48817,"deprecated":false},{"id":1200,"name":"Skoda","interest":[{"id":1826}],"count":8559425,"deprecated":false},{"id":1201,"name":"Skullcandy","interest":[{"id":25}],"count":597389,"deprecated":false},{"id":1202,"name":"Sky Sports","interest":[{"id":21}],"count":627826,"deprecated":false},{"id":1203,"name":"SKYY","interest":[{"id":19}],"count":278648,"deprecated":false},{"id":1204,"name":"Smart","interest":[{"id":1826}],"count":2659197,"deprecated":false},{"id":1205,"name":"Smart Fit","interest":[{"id":196}],"count":83426,"deprecated":false},{"id":1207,"name":"Smirnoff","interest":[{"id":19}],"count":9175424,"deprecated":false},{"id":1208,"name":"Snapple","interest":[{"id":9}],"count":560024,"deprecated":false},{"id":1209,"name":"Snapseed","interest":[{"id":11}],"count":26002293,"deprecated":false},{"id":1210,"name":"Sneaker News","interest":[{"id":33}],"count":2235270,"deprecated":false},{"id":1211,"name":"Sneakerhead","interest":[{"id":7}],"count":21750788,"deprecated":false},{"id":1212,"name":"Snickers","interest":[{"id":139}],"count":9930490,"deprecated":false},{"id":1213,"name":"Snoopy And The Peanuts Gang","interest":[{"id":190}],"count":7188268,"deprecated":false},{"id":1215,"name":"soccerbible","interest":[{"id":21}],"count":562349,"deprecated":false},{"id":1216,"name":"Society6","interest":[{"id":7}],"count":715167,"deprecated":false},{"id":1217,"name":"Sole Collector","interest":[{"id":7}],"count":3399013,"deprecated":false},{"id":1218,"name":"Sony","interest":[{"id":25}],"count":50042826,"deprecated":false},{"id":1220,"name":"Sotheby's","interest":[{"id":36}],"count":714954,"deprecated":false},{"id":1221,"name":"SoulCycle","interest":[{"id":196}],"count":979442,"deprecated":false},{"id":1222,"name":"SoundCloud","interest":[{"id":3}],"count":45009234,"deprecated":false},{"id":1225,"name":"SpeedPaint","interest":[{"id":36}],"count":1299987,"deprecated":false},{"id":1226,"name":"SPIEGELAU","interest":[{"id":1560}],"count":51530,"deprecated":false},{"id":1227,"name":"Spinrilla","interest":[{"id":3}],"count":4231946,"deprecated":false},{"id":1228,"name":"Sportmax","interest":[{"id":13}],"count":134797,"deprecated":false},{"id":1230,"name":"SportsNation","interest":[{"id":21}],"count":142406,"deprecated":false},{"id":1231,"name":"Spotify Music","interest":[{"id":3}],"count":66452802,"deprecated":false},{"id":1232,"name":"Sprayground","interest":[{"id":7}],"count":437019,"deprecated":false},{"id":1233,"name":"Sprite","interest":[{"id":9}],"count":15698548,"deprecated":false},{"id":1234,"name":"Staedtler","interest":[{"id":36}],"count":1166572,"deprecated":false},{"id":1235,"name":"StairMaster","interest":[{"id":196}],"count":833161,"deprecated":false},{"id":1236,"name":"Standard Bank","interest":[{"id":58}],"count":150603,"deprecated":false},{"id":1237,"name":"Star Wars","interest":[{"id":1}],"count":54580116,"deprecated":false},{"id":1238,"name":"Starbucks","interest":[{"id":9}],"count":74708840,"deprecated":false},{"id":1239,"name":"Starbuzz","interest":[{"id":405}],"count":640873,"deprecated":false},{"id":1240,"name":"SteelSeries","interest":[{"id":25}],"count":420883,"deprecated":false},{"id":1241,"name":"Steiff","interest":[{"id":190}],"count":162470,"deprecated":false},{"id":1242,"name":"Stella Artois","interest":[{"id":19}],"count":3553201,"deprecated":false},{"id":1243,"name":"Stella McCartney","interest":[{"id":13}],"count":1422224,"deprecated":false},{"id":1244,"name":"Stemcell Technologies","interest":[{"id":7}],"count":3639303,"deprecated":false},{"id":1246,"name":"Steve Madden","interest":[{"id":13}],"count":3523498,"deprecated":false},{"id":1247,"name":"Stiegl","interest":[{"id":19}],"count":94928,"deprecated":false},{"id":1248,"name":"Stihl","interest":[{"id":1560}],"count":892158,"deprecated":false},{"id":1249,"name":"Stradivarius","interest":[{"id":13}],"count":8143200,"deprecated":false},{"id":1250,"name":"Stuart Weitzman","interest":[{"id":13}],"count":397184,"deprecated":false},{"id":1252,"name":"Stüssy","interest":[{"id":13}],"count":5814746,"deprecated":false},{"id":1253,"name":"Style Nanda","interest":[{"id":7}],"count":1901108,"deprecated":false},{"id":1254,"name":"StyleHaul","interest":[{"id":80}],"count":16535,"deprecated":false},{"id":1255,"name":"StyleSeat","interest":[{"id":80}],"count":691970,"deprecated":false},{"id":1256,"name":"STYLEWATCH Magazine","interest":[{"id":130}],"count":201235,"deprecated":false},{"id":1257,"name":"Suavecito","interest":[{"id":80}],"count":7070048,"deprecated":false},{"id":1258,"name":"Subaru","interest":[{"id":1826}],"count":30227488,"deprecated":false},{"id":1259,"name":"SugarBearHair","interest":[{"id":80}],"count":544212,"deprecated":false},{"id":1260,"name":"Sugarfina","interest":[{"id":139}],"count":60653,"deprecated":false},{"id":1261,"name":"Sugarpill Cosmetics","interest":[{"id":80}],"count":647503,"deprecated":false},{"id":1262,"name":"Suitsupply","interest":[{"id":13}],"count":508086,"deprecated":false},{"id":1263,"name":"Sulwhasoo","interest":[{"id":80}],"count":1148565,"deprecated":false},{"id":1264,"name":"Sunnies Studios","interest":[{"id":13}],"count":15613297,"deprecated":false},{"id":1265,"name":"Superdry","interest":[{"id":13}],"count":4850066,"deprecated":false},{"id":1266,"name":"SuperSport","interest":[{"id":1826}],"count":3039,"deprecated":false},{"id":1267,"name":"Sushi time","interest":[{"id":139}],"count":1069,"deprecated":false},{"id":1268,"name":"SUSHISAMBA","interest":[{"id":139}],"count":668895,"deprecated":false},{"id":1269,"name":"Suzuki","interest":[{"id":1826}],"count":40522471,"deprecated":false},{"id":1270,"name":"SWAROVSKI","interest":[{"id":130}],"count":30570718,"deprecated":false},{"id":1271,"name":"Sweaty Betty","interest":[{"id":33}],"count":330744,"deprecated":false},{"id":1272,"name":"Swedbank","interest":[{"id":58}],"count":129759,"deprecated":false},{"id":1273,"name":"Sweetgreen","interest":[{"id":139}],"count":193232,"deprecated":false},{"id":1274,"name":"Swift Kickz","interest":[{"id":7}],"count":107011,"deprecated":false},{"id":1275,"name":"SWIMBIKERUN","interest":[{"id":21}],"count":3028,"deprecated":false},{"id":1276,"name":"swimwear365","interest":[{"id":13}],"count":1180,"deprecated":false},{"id":1277,"name":"Syoss","interest":[{"id":80}],"count":370551,"deprecated":false},{"id":1278,"name":"T-Mobile","interest":[{"id":58}],"count":684843,"deprecated":false},{"id":1279,"name":"T.G.I. Friday's","interest":[{"id":139}],"count":2677855,"deprecated":false},{"id":1280,"name":"T.J. Maxx","interest":[{"id":7}],"count":1500015,"deprecated":false},{"id":1281,"name":"Taco Bell","interest":[{"id":139}],"count":4889054,"deprecated":false},{"id":1282,"name":"TAG Heuer","interest":[{"id":130}],"count":1681583,"deprecated":false},{"id":1283,"name":"Tanqueray","interest":[{"id":19}],"count":3327384,"deprecated":false},{"id":1284,"name":"Target","interest":[{"id":7}],"count":5283276,"deprecated":false},{"id":1286,"name":"Tarte Cosmetics","interest":[{"id":80}],"count":14618884,"deprecated":false},{"id":1287,"name":"Tate Modern","interest":[{"id":36}],"count":1541964,"deprecated":false},{"id":1288,"name":"Tattoodo","interest":[{"id":80}],"count":3030245,"deprecated":false},{"id":1289,"name":"Taylor Swift","interest":[{"id":3}],"count":18873,"deprecated":false},{"id":1290,"name":"Tchibo","interest":[{"id":9}],"count":492760,"deprecated":false},{"id":1291,"name":"TeamCozy","interest":[{"id":13}],"count":360207,"deprecated":false},{"id":1292,"name":"Technogym","interest":[{"id":196}],"count":611751,"deprecated":false},{"id":1294,"name":"Tele2","interest":[{"id":58}],"count":611947,"deprecated":false},{"id":1295,"name":"Telstra","interest":[{"id":58}],"count":320462,"deprecated":false},{"id":1296,"name":"Tencent","interest":[{"id":25}],"count":608569,"deprecated":false},{"id":1298,"name":"Tesco","interest":[{"id":7}],"count":6381488,"deprecated":false},{"id":1299,"name":"Tesla Motors","interest":[{"id":1826}],"count":31271488,"deprecated":false},{"id":1300,"name":"Texas Instruments","interest":[{"id":25}],"count":19366,"deprecated":false},{"id":1301,"name":"Texas Roadhouse","interest":[{"id":139}],"count":379420,"deprecated":false},{"id":1302,"name":"Thai Airways","interest":[{"id":43}],"count":274281,"deprecated":false},{"id":1303,"name":"The Body Shop","interest":[{"id":80}],"count":2257447,"deprecated":false},{"id":1304,"name":"The Glenlivet","interest":[{"id":19}],"count":119278,"deprecated":false},{"id":1305,"name":"The Home Depot","interest":[{"id":7}],"count":2027066,"deprecated":false},{"id":1306,"name":"The House of Marley","interest":[{"id":25}],"count":65809,"deprecated":false},{"id":1307,"name":"The North Face","interest":[{"id":33}],"count":11853878,"deprecated":false},{"id":1308,"name":"The Olympic Games","interest":[{"id":21}],"count":27835238,"deprecated":false},{"id":1312,"name":"THEFACESHOP","interest":[{"id":7}],"count":818908,"deprecated":false},{"id":1313,"name":"Thermomix","interest":[{"id":139}],"count":1273110,"deprecated":false},{"id":1315,"name":"ThyssenKrupp","interest":[{"id":58}],"count":109391,"deprecated":false},{"id":1316,"name":"Tiffany & Co","interest":[{"id":130}],"count":39564980,"deprecated":false},{"id":1317,"name":"Tim Hortons","interest":[{"id":9}],"count":1501168,"deprecated":false},{"id":1318,"name":"Timberland","interest":[{"id":13}],"count":14743189,"deprecated":false},{"id":1319,"name":"Titleist","interest":[{"id":21}],"count":693218,"deprecated":false},{"id":1320,"name":"Toffifee","interest":[{"id":139}],"count":230401,"deprecated":false},{"id":1321,"name":"TOM FORD","interest":[{"id":1500}],"count":11140670,"deprecated":false},{"id":1322,"name":"Tom Tailor","interest":[{"id":13}],"count":324357,"deprecated":false},{"id":1323,"name":"TOMICA","interest":[{"id":190}],"count":386112,"deprecated":false},{"id":1324,"name":"Tommy Hilfiger","interest":[{"id":13}],"count":44423510,"deprecated":false},{"id":1325,"name":"Tomorrowland","interest":[{"id":3}],"count":17026854,"deprecated":false},{"id":1326,"name":"TONY MOLY","interest":[{"id":80}],"count":2394143,"deprecated":false},{"id":1327,"name":"Too Faced Cosmetics","interest":[{"id":80}],"count":12873520,"deprecated":false},{"id":1328,"name":"Top Gear","interest":[{"id":1}],"count":1082284,"deprecated":false},{"id":1329,"name":"Topbeauty Magazine","interest":[{"id":13}],"count":170005,"deprecated":false},{"id":1330,"name":"Topshop","interest":[{"id":13}],"count":8015333,"deprecated":false},{"id":1331,"name":"Tory Burch","interest":[{"id":13}],"count":2107650,"deprecated":false},{"id":1332,"name":"Toshiba","interest":[{"id":25}],"count":2121087,"deprecated":false},{"id":1334,"name":"Toyota","interest":[{"id":1826}],"count":68824997,"deprecated":false},{"id":1335,"name":"Trainsmart","interest":[{"id":196}],"count":800068,"deprecated":false},{"id":1336,"name":"Trancefamily","interest":[{"id":3}],"count":2153480,"deprecated":false},{"id":1337,"name":"Transformers","interest":[{"id":1}],"count":11800703,"deprecated":false},{"id":1338,"name":"Travelgram","interest":[{"id":43}],"count":66704548,"deprecated":false},{"id":1339,"name":"Travelstoke","interest":[{"id":43}],"count":7419083,"deprecated":false},{"id":1340,"name":"TrendMood","interest":[{"id":80}],"count":386854,"deprecated":false},{"id":1341,"name":"TRESemmé","interest":[{"id":80}],"count":871192,"deprecated":false},{"id":1342,"name":"TRIANGL","interest":[{"id":13}],"count":265850,"deprecated":false},{"id":1344,"name":"TripAdvisor","interest":[{"id":43}],"count":8697407,"deprecated":false},{"id":1345,"name":"Trippics","interest":[{"id":43}],"count":187140,"deprecated":false},{"id":1346,"name":"Trussardi","interest":[{"id":13}],"count":2034600,"deprecated":false},{"id":1347,"name":"TUI Group","interest":[{"id":43}],"count":745666,"deprecated":false},{"id":1348,"name":"Tupperware Brands","interest":[{"id":7}],"count":8850532,"deprecated":false},{"id":1349,"name":"Turkish Airlines","interest":[{"id":43}],"count":1918026,"deprecated":false},{"id":1350,"name":"Twinings","interest":[{"id":139}],"count":347728,"deprecated":false},{"id":1351,"name":"Twistshake","interest":[{"id":190}],"count":710711,"deprecated":false},{"id":1353,"name":"Uber","interest":[{"id":43}],"count":12098787,"deprecated":false},{"id":1354,"name":"UberEATS","interest":[{"id":139}],"count":7952290,"deprecated":false},{"id":1355,"name":"Ubisoft","interest":[{"id":30}],"count":8221953,"deprecated":false},{"id":1356,"name":"UEFA","interest":[{"id":21}],"count":6170119,"deprecated":false},{"id":1357,"name":"ULTA Beauty","interest":[{"id":80}],"count":3081992,"deprecated":false},{"id":1358,"name":"Ultimate Ears","interest":[{"id":25}],"count":159258,"deprecated":false},{"id":1359,"name":"Under Armour","interest":[{"id":33}],"count":17828517,"deprecated":false},{"id":1361,"name":"UniCredit","interest":[{"id":58}],"count":424542,"deprecated":false},{"id":1362,"name":"Unilever","interest":[{"id":139}],"count":1756750,"deprecated":false},{"id":1363,"name":"Union Pacific","interest":[{"id":43}],"count":67770,"deprecated":false},{"id":1364,"name":"UNIQLO","interest":[{"id":13}],"count":11733854,"deprecated":false},{"id":1365,"name":"United","interest":[{"id":43}],"count":1337567,"deprecated":false},{"id":1369,"name":"Univision","interest":[{"id":1}],"count":1577909,"deprecated":false},{"id":1370,"name":"Unsplash","interest":[{"id":36}],"count":2148425,"deprecated":false},{"id":1371,"name":"Urban Decay Cosmetics","interest":[{"id":80}],"count":20062047,"deprecated":false},{"id":1372,"name":"Urban Outfitters","interest":[{"id":7}],"count":9616991,"deprecated":false},{"id":1373,"name":"Urbanwear","interest":[{"id":7}],"count":130529,"deprecated":false},{"id":1374,"name":"Vacheron Constantin","interest":[{"id":130}],"count":460173,"deprecated":false},{"id":1375,"name":"Valentino","interest":[{"id":1500}],"count":14286739,"deprecated":false},{"id":1376,"name":"Valrhona","interest":[{"id":139}],"count":711108,"deprecated":false},{"id":1377,"name":"Vans","interest":[{"id":13}],"count":60239396,"deprecated":false},{"id":1378,"name":"Vapelyfe","interest":[{"id":405}],"count":2098928,"deprecated":false},{"id":1379,"name":"VapeMail","interest":[{"id":405}],"count":302943,"deprecated":false},{"id":1380,"name":"VapeWorld","interest":[{"id":405}],"count":669887,"deprecated":false},{"id":1381,"name":"Vauxhall","interest":[{"id":1826}],"count":1819376,"deprecated":false},{"id":1382,"name":"Vegemite","interest":[{"id":139}],"count":762401,"deprecated":false},{"id":1383,"name":"Vera Wang","interest":[{"id":291}],"count":632940,"deprecated":false},{"id":1384,"name":"Verizon","interest":[{"id":58}],"count":5504313,"deprecated":false},{"id":1385,"name":"Versace","interest":[{"id":13}],"count":40571682,"deprecated":false},{"id":1386,"name":"Vichy","interest":[{"id":80}],"count":2832860,"deprecated":false},{"id":1387,"name":"Victoria's Secret","interest":[{"id":13}],"count":14987982,"deprecated":false},{"id":1388,"name":"Victorinox","interest":[{"id":130}],"count":799679,"deprecated":false},{"id":1389,"name":"VidaSana","interest":[{"id":798}],"count":9058632,"deprecated":false},{"id":1390,"name":"VIKTOR&ROLF","interest":[{"id":80}],"count":236760,"deprecated":false},{"id":1391,"name":"Virgin Atlantic","interest":[{"id":43}],"count":215453,"deprecated":false},{"id":1392,"name":"Virgin Australia","interest":[{"id":43}],"count":242402,"deprecated":false},{"id":1393,"name":"VisitBritain","interest":[{"id":43}],"count":562389,"deprecated":false},{"id":1394,"name":"VMWARE","interest":[{"id":58}],"count":160998,"deprecated":false},{"id":1395,"name":"Vodafone","interest":[{"id":58}],"count":4124868,"deprecated":false},{"id":1397,"name":"Volkswagen","interest":[{"id":1826}],"count":54998143,"deprecated":false},{"id":1398,"name":"Volvo","interest":[{"id":1826}],"count":21908239,"deprecated":false},{"id":1399,"name":"Vorsteiner","interest":[{"id":1826}],"count":273792,"deprecated":false},{"id":1400,"name":"VOSSEN WHEELS","interest":[{"id":1826}],"count":1303633,"deprecated":false},{"id":1401,"name":"Vpfashion","interest":[{"id":80}],"count":16246,"deprecated":false},{"id":1402,"name":"W Motors","interest":[{"id":1826}],"count":418027,"deprecated":false},{"id":1403,"name":"Waist Trainer","interest":[{"id":33}],"count":1429458,"deprecated":false},{"id":1404,"name":"Waitrose","interest":[{"id":7}],"count":763558,"deprecated":false},{"id":1405,"name":"Waldorf Astoria","interest":[{"id":43}],"count":260019,"deprecated":false},{"id":1406,"name":"Walgreens","interest":[{"id":7}],"count":3399302,"deprecated":false},{"id":1407,"name":"Walmart","interest":[{"id":7}],"count":28620492,"deprecated":false},{"id":1408,"name":"Walt Disney","interest":[{"id":190}],"count":83946739,"deprecated":false},{"id":1409,"name":"WantMyLook","interest":[{"id":7}],"count":25538,"deprecated":false},{"id":1410,"name":"Warner Bros","interest":[{"id":1}],"count":17645324,"deprecated":false},{"id":1411,"name":"Warner Bros.","interest":[{"id":1}],"count":1589808,"deprecated":false},{"id":1412,"name":"Warsteiner","interest":[{"id":19}],"count":233565,"deprecated":false},{"id":1413,"name":"Washington Huskies","interest":[{"id":21}],"count":1120,"deprecated":false},{"id":1415,"name":"Weedmaps","interest":[{"id":405}],"count":558063,"deprecated":false},{"id":1416,"name":"Weihenstephan Hefe Weissbier","interest":[{"id":19}],"count":185922,"deprecated":false},{"id":1417,"name":"Wella","interest":[{"id":80}],"count":7499796,"deprecated":false},{"id":1418,"name":"Wells Fargo","interest":[{"id":58}],"count":305130,"deprecated":false},{"id":1419,"name":"Wemoto","interest":[{"id":7}],"count":9745,"deprecated":false},{"id":1420,"name":"Werther’s Original","interest":[{"id":139}],"count":24899,"deprecated":false},{"id":1421,"name":"West Elm","interest":[{"id":7}],"count":679891,"deprecated":false},{"id":1422,"name":"Westin","interest":[{"id":43}],"count":296449,"deprecated":false},{"id":1423,"name":"White&Smile","interest":[{"id":80}],"count":10712,"deprecated":false},{"id":1424,"name":"Whitestrips","interest":[{"id":80}],"count":77739,"deprecated":false},{"id":1425,"name":"Who What Wear","interest":[{"id":13}],"count":957317,"deprecated":false},{"id":1426,"name":"Whole Foods","interest":[{"id":7}],"count":2459,"deprecated":false},{"id":1427,"name":"Wilton","interest":[{"id":139}],"count":2782521,"deprecated":false},{"id":1428,"name":"Winelover","interest":[{"id":19}],"count":2663,"deprecated":false},{"id":1429,"name":"Wingstop","interest":[{"id":139}],"count":1549840,"deprecated":false},{"id":1430,"name":"Woolworths","interest":[{"id":7}],"count":1672878,"deprecated":false},{"id":1431,"name":"WordPress","interest":[{"id":58}],"count":4543347,"deprecated":false},{"id":1432,"name":"WUNDERBROW","interest":[{"id":80}],"count":62612,"deprecated":false},{"id":1433,"name":"WWE","interest":[{"id":1}],"count":40626510,"deprecated":false},{"id":1434,"name":"Wyndham","interest":[{"id":43}],"count":178505,"deprecated":false},{"id":1435,"name":"Xbox","interest":[{"id":25}],"count":34242977,"deprecated":false},{"id":1436,"name":"Xerox","interest":[{"id":25}],"count":7620521,"deprecated":false},{"id":1437,"name":"Xiaomi","interest":[{"id":25}],"count":37565367,"deprecated":false},{"id":1438,"name":"Yakult","interest":[{"id":9}],"count":3914519,"deprecated":false},{"id":1441,"name":"Yo-Kai Watch","interest":[{"id":190}],"count":49291,"deprecated":false},{"id":1442,"name":"Yoplait","interest":[{"id":139}],"count":103148,"deprecated":false},{"id":1443,"name":"Younique","interest":[{"id":80}],"count":1631860,"deprecated":false},{"id":1444,"name":"Yves Saint Laurent","interest":[{"id":1500}],"count":31495542,"deprecated":false},{"id":1446,"name":"Zara","interest":[{"id":13}],"count":65063456,"deprecated":false},{"id":1448,"name":"ZTE","interest":[{"id":25}],"count":321214,"deprecated":false},{"id":1451,"name":"Grand Theft Auto","interest":[{"id":30}],"count":24470331,"deprecated":false},{"id":1452,"name":"Harry Potter","interest":[{"id":1}],"count":2796726,"deprecated":false},{"id":1453,"name":"David's Bridal","interest":[{"id":291}],"count":364315,"deprecated":false},{"id":1454,"name":"Zuhair Murad","interest":[{"id":291}],"count":537421,"deprecated":false},{"id":1455,"name":"Southwest Airlines","interest":[{"id":43}],"count":428671,"deprecated":false},{"id":1456,"name":"Expedia.com","interest":[{"id":43}],"count":329986,"deprecated":false},{"id":1457,"name":"The Ritz-Carlton","interest":[{"id":43}],"count":2265631,"deprecated":false},{"id":1458,"name":"Figurinha Boys","interest":[{"id":190}],"count":165613,"deprecated":false},{"id":1459,"name":"Figurinha Girls","interest":[{"id":190}],"count":165613,"deprecated":false},{"id":1460,"name":"Guess Kids","interest":[{"id":190}],"count":67444,"deprecated":false},{"id":1461,"name":"Il Gufo","interest":[{"id":190}],"count":17746,"deprecated":false},{"id":1462,"name":"Little Marc Jacobs","interest":[{"id":190}],"count":6788,"deprecated":false},{"id":1463,"name":"Next","interest":[{"id":190}],"count":811536,"deprecated":false},{"id":1464,"name":"Gundam","interest":[{"id":190}],"count":3992140,"deprecated":false},{"id":1465,"name":"Marvel","interest":[{"id":1}],"count":57531899,"deprecated":false},{"id":1466,"name":"Summit Entertainment","interest":[{"id":1}],"count":4779863,"deprecated":false},{"id":1467,"name":"Universal","interest":[{"id":1}],"count":39347700,"deprecated":false},{"id":1468,"name":"AMC","interest":[{"id":1}],"count":8957209,"deprecated":false},{"id":1469,"name":"Freeform","interest":[{"id":1}],"count":101848,"deprecated":false},{"id":1470,"name":"Showtime","interest":[{"id":1}],"count":15765490,"deprecated":false},{"id":1471,"name":"NFL","interest":[{"id":21}],"count":28358826,"deprecated":false},{"id":1472,"name":"Burton Snowboards","interest":[{"id":21}],"count":367994,"deprecated":false},{"id":1473,"name":"UFC","interest":[{"id":21}],"count":35692142,"deprecated":false},{"id":1474,"name":"Southampton FC","interest":[{"id":21}],"count":4071,"deprecated":false},{"id":1475,"name":"Babolat","interest":[{"id":21}],"count":469118,"deprecated":false},{"id":1476,"name":"North Sails","interest":[{"id":21}],"count":62679,"deprecated":false},{"id":1477,"name":"Courtside","interest":[{"id":21}],"count":1186,"deprecated":false},{"id":1478,"name":"Real,-","interest":[{"id":7}],"count":1279,"deprecated":false},{"id":1479,"name":"Whole Foods Market","interest":[{"id":7}],"count":222376,"deprecated":false},{"id":1480,"name":"Harrods","interest":[{"id":7}],"count":6618258,"deprecated":false},{"id":1481,"name":"TsUM","interest":[{"id":7}],"count":459621,"deprecated":false},{"id":1482,"name":"Kmart","interest":[{"id":7}],"count":2098719,"deprecated":false},{"id":1483,"name":"Siam Center","interest":[{"id":7}],"count":222618,"deprecated":false},{"id":1484,"name":"Hema","interest":[{"id":7}],"count":832842,"deprecated":false},{"id":1485,"name":"Emporium","interest":[{"id":7}],"count":7583688,"deprecated":false},{"id":1486,"name":"Galeries Lafayette","interest":[{"id":7}],"count":882440,"deprecated":false},{"id":1487,"name":"Isetan","interest":[{"id":7}],"count":607412,"deprecated":false},{"id":1488,"name":"Fnac","interest":[{"id":7}],"count":596203,"deprecated":false},{"id":1489,"name":"Myer","interest":[{"id":7}],"count":407612,"deprecated":false},{"id":1490,"name":"Siam Discovery","interest":[{"id":7}],"count":93434,"deprecated":false},{"id":1491,"name":"Value Village","interest":[{"id":7}],"count":203378,"deprecated":false},{"id":1492,"name":"Holt Renfrew","interest":[{"id":7}],"count":94875,"deprecated":false},{"id":1493,"name":"Centrepoint","interest":[{"id":7}],"count":1021079,"deprecated":false},{"id":1494,"name":"OVS","interest":[{"id":7}],"count":583048,"deprecated":false},{"id":1495,"name":"KaDeWe","interest":[{"id":7}],"count":255393,"deprecated":false},{"id":1496,"name":"Ocean Plaza","interest":[{"id":7}],"count":129178,"deprecated":false},{"id":1497,"name":"GittiGidiyor","interest":[{"id":7}],"count":443562,"deprecated":false},{"id":1498,"name":"Stockmann","interest":[{"id":7}],"count":473684,"deprecated":false},{"id":1499,"name":"Twix","interest":[{"id":139}],"count":945820,"deprecated":false},{"id":1501,"name":"Andres Sarda","interest":[{"id":1500}],"count":7366,"deprecated":false},{"id":1502,"name":"Arc'teryx Veilance","interest":[{"id":1500}],"count":7755,"deprecated":false},{"id":1503,"name":"Armani Junior","interest":[{"id":1500}],"count":13751,"deprecated":false},{"id":1504,"name":"Bibhu Mohapatra","interest":[{"id":1500}],"count":11196,"deprecated":false},{"id":1505,"name":"Charriol","interest":[{"id":1500}],"count":134184,"deprecated":false},{"id":1506,"name":"Christian Siriano","interest":[{"id":1500}],"count":37735,"deprecated":false},{"id":1507,"name":"Emilio Pucci","interest":[{"id":1500}],"count":191357,"deprecated":false},{"id":1508,"name":"Emporio Armani","interest":[{"id":1500}],"count":2740175,"deprecated":false},{"id":1509,"name":"Ermanno Scervino","interest":[{"id":1500}],"count":90031,"deprecated":false},{"id":1510,"name":"Ermenegildo Zegna","interest":[{"id":1500}],"count":584983,"deprecated":false},{"id":1511,"name":"Escada","interest":[{"id":1500}],"count":1864477,"deprecated":false},{"id":1512,"name":"Franck Sorbier","interest":[{"id":1500}],"count":2589,"deprecated":false},{"id":1513,"name":"Frédérique Constant","interest":[{"id":1500}],"count":64415,"deprecated":false},{"id":1514,"name":"Giada Curti","interest":[{"id":1500}],"count":5165,"deprecated":false},{"id":1515,"name":"Giambattista Valli","interest":[{"id":1500}],"count":352474,"deprecated":false},{"id":1516,"name":"Girard-Perregaux","interest":[{"id":1500}],"count":66887,"deprecated":false},{"id":1517,"name":"IWC","interest":[{"id":1500}],"count":474288,"deprecated":false},{"id":1518,"name":"Jean Paul Gaultier","interest":[{"id":1500}],"count":1415754,"deprecated":false},{"id":1519,"name":"La Perla","interest":[{"id":1500}],"count":851194,"deprecated":false},{"id":1520,"name":"Lanvin","interest":[{"id":1500}],"count":4691234,"deprecated":false},{"id":1521,"name":"Luisaviaroma","interest":[{"id":1500}],"count":120945,"deprecated":false},{"id":1522,"name":"Moncler","interest":[{"id":1500}],"count":6788329,"deprecated":false},{"id":1523,"name":"Montblanc","interest":[{"id":1500}],"count":9702518,"deprecated":false},{"id":1524,"name":"Mulberry","interest":[{"id":1500}],"count":9136678,"deprecated":false},{"id":1525,"name":"Officine Panerai","interest":[{"id":1500}],"count":1234422,"deprecated":false},{"id":1526,"name":"Patek Philippe","interest":[{"id":1500}],"count":4619519,"deprecated":false},{"id":1527,"name":"Paul Smith","interest":[{"id":1500}],"count":1304426,"deprecated":false},{"id":1528,"name":"Piaget","interest":[{"id":1500}],"count":1464749,"deprecated":false},{"id":1529,"name":"Prabal Gurung","interest":[{"id":1500}],"count":57307,"deprecated":false},{"id":1530,"name":"Roberto Cavalli Class","interest":[{"id":1500}],"count":17738,"deprecated":false},{"id":1531,"name":"Roberto Cavalli Junior","interest":[{"id":1500}],"count":1287,"deprecated":false},{"id":1532,"name":"Roberto Cavalli Newborn","interest":[{"id":1500}],"count":868763,"deprecated":false},{"id":1533,"name":"Roger Vivier","interest":[{"id":1500}],"count":226141,"deprecated":false},{"id":1534,"name":"Sister by Sibling","interest":[{"id":1500}],"count":1314,"deprecated":false},{"id":1535,"name":"Thom Browne","interest":[{"id":1500}],"count":476225,"deprecated":false},{"id":1536,"name":"TOD's","interest":[{"id":1500}],"count":602621,"deprecated":false},{"id":1537,"name":"Ulyana Sergeenko","interest":[{"id":1500}],"count":19263,"deprecated":false},{"id":1538,"name":"Victoria Beckham","interest":[{"id":1500}],"count":1032147,"deprecated":false},{"id":1539,"name":"Zac Posen","interest":[{"id":1500}],"count":89704,"deprecated":false},{"id":1540,"name":"Zimmermann","interest":[{"id":1500}],"count":1279817,"deprecated":false},{"id":1541,"name":"Fossil","interest":[{"id":130}],"count":892044,"deprecated":false},{"id":1542,"name":"Jaeger-LeCoultre","interest":[{"id":130}],"count":205664,"deprecated":false},{"id":1543,"name":"Nixon","interest":[{"id":130}],"count":4118241,"deprecated":false},{"id":1544,"name":"Shinola","interest":[{"id":130}],"count":145101,"deprecated":false},{"id":1545,"name":"Swatch","interest":[{"id":130}],"count":2650995,"deprecated":false},{"id":1546,"name":"Tissot","interest":[{"id":130}],"count":5607847,"deprecated":false},{"id":1547,"name":"Alex and Ani","interest":[{"id":130}],"count":263648,"deprecated":false},{"id":1548,"name":"Boccadamo","interest":[{"id":130}],"count":18311,"deprecated":false},{"id":1549,"name":"Chopard","interest":[{"id":130}],"count":2152077,"deprecated":false},{"id":1550,"name":"Damiani","interest":[{"id":130}],"count":327822,"deprecated":false},{"id":1551,"name":"David Yurman","interest":[{"id":130}],"count":211189,"deprecated":false},{"id":1552,"name":"Queriot","interest":[{"id":130}],"count":1330,"deprecated":false},{"id":1553,"name":"Stroili Oro","interest":[{"id":130}],"count":128145,"deprecated":false},{"id":1554,"name":"TOUS","interest":[{"id":130}],"count":1224734,"deprecated":false},{"id":1555,"name":"Trollbeads","interest":[{"id":130}],"count":70846,"deprecated":false},{"id":1556,"name":"Tuum","interest":[{"id":130}],"count":5011,"deprecated":false},{"id":1557,"name":"Van Cleef & Arpels","interest":[{"id":130}],"count":866871,"deprecated":false},{"id":1558,"name":"Sinn","interest":[{"id":130}],"count":173614,"deprecated":false},{"id":1559,"name":"Rado","interest":[{"id":130}],"count":1318372,"deprecated":false},{"id":1561,"name":"Laura Ashley","interest":[{"id":1560}],"count":273573,"deprecated":false},{"id":1562,"name":"Smeg","interest":[{"id":1560}],"count":523206,"deprecated":false},{"id":1563,"name":"Energy Diet Smart","interest":[{"id":798}],"count":1248982,"deprecated":false},{"id":1564,"name":"Kirkland Signature","interest":[{"id":798}],"count":12747,"deprecated":false},{"id":1565,"name":"PlayStation","interest":[{"id":30}],"count":62361442,"deprecated":false},{"id":1566,"name":"RAZER","interest":[{"id":30}],"count":2680229,"deprecated":false},{"id":1567,"name":"343 Industries","interest":[{"id":30}],"count":63243,"deprecated":false},{"id":1568,"name":"ArenaNet","interest":[{"id":30}],"count":6561,"deprecated":false},{"id":1569,"name":"Atlus","interest":[{"id":30}],"count":152755,"deprecated":false},{"id":1570,"name":"BioWare","interest":[{"id":30}],"count":172283,"deprecated":false},{"id":1571,"name":"Infinity Ward","interest":[{"id":30}],"count":139391,"deprecated":false},{"id":1572,"name":"Natsume","interest":[{"id":30}],"count":189359,"deprecated":false},{"id":1573,"name":"Rockstar Games","interest":[{"id":30}],"count":1868458,"deprecated":false},{"id":1574,"name":"Sledgehammer Games","interest":[{"id":30}],"count":29753,"deprecated":false},{"id":1575,"name":"Sonic","interest":[{"id":30}],"count":405378,"deprecated":false},{"id":1576,"name":"Telltale Games","interest":[{"id":30}],"count":74356,"deprecated":false},{"id":1577,"name":"Treyarch","interest":[{"id":30}],"count":374692,"deprecated":false},{"id":1578,"name":"Wargaming","interest":[{"id":30}],"count":240612,"deprecated":false},{"id":1579,"name":"Zynga","interest":[{"id":30}],"count":43747,"deprecated":false},{"id":1580,"name":"2K Games","interest":[{"id":30}],"count":70792,"deprecated":false},{"id":1581,"name":"Blizzard Entertainment","interest":[{"id":30}],"count":250568,"deprecated":false},{"id":1582,"name":"Bungie","interest":[{"id":30}],"count":438573,"deprecated":false},{"id":1583,"name":"Capcom","interest":[{"id":30}],"count":1797781,"deprecated":false},{"id":1584,"name":"CD Projekt RED","interest":[{"id":30}],"count":211517,"deprecated":false},{"id":1585,"name":"Crystal Dynamics","interest":[{"id":30}],"count":33600,"deprecated":false},{"id":1586,"name":"FromSoftware","interest":[{"id":30}],"count":188435,"deprecated":false},{"id":1587,"name":"Gameloft","interest":[{"id":30}],"count":117256,"deprecated":false},{"id":1588,"name":"Games Workshop","interest":[{"id":30}],"count":217291,"deprecated":false},{"id":1589,"name":"Konami","interest":[{"id":30}],"count":1086014,"deprecated":false},{"id":1590,"name":"LucasArts","interest":[{"id":30}],"count":63923,"deprecated":false},{"id":1591,"name":"Maxis","interest":[{"id":30}],"count":1271974,"deprecated":false},{"id":1592,"name":"Namco","interest":[{"id":30}],"count":370211,"deprecated":false},{"id":1593,"name":"NCsoft","interest":[{"id":30}],"count":8783,"deprecated":false},{"id":1594,"name":"Riot Games","interest":[{"id":30}],"count":837341,"deprecated":false},{"id":1595,"name":"Sega","interest":[{"id":30}],"count":2369823,"deprecated":false},{"id":1596,"name":"Square Enix","interest":[{"id":30}],"count":855920,"deprecated":false},{"id":1597,"name":"Toei Animation","interest":[{"id":30}],"count":259327,"deprecated":false},{"id":1598,"name":"Ark: Survival Evolved","interest":[{"id":30}],"count":219373,"deprecated":false},{"id":1599,"name":"Assassin's Creed","interest":[{"id":30}],"count":152640,"deprecated":false},{"id":1600,"name":"Battlefield","interest":[{"id":30}],"count":1202504,"deprecated":false},{"id":1601,"name":"Beyond: Two Souls","interest":[{"id":30}],"count":35746,"deprecated":false},{"id":1602,"name":"Black Desert Online","interest":[{"id":30}],"count":35161,"deprecated":false},{"id":1603,"name":"Bloodborne","interest":[{"id":30}],"count":608514,"deprecated":false},{"id":1604,"name":"Call of Duty","interest":[{"id":30}],"count":14498830,"deprecated":false},{"id":1605,"name":"Dead Rising","interest":[{"id":30}],"count":37964,"deprecated":false},{"id":1606,"name":"Diablo","interest":[{"id":30}],"count":2682101,"deprecated":false},{"id":1607,"name":"Dishonored","interest":[{"id":30}],"count":47340,"deprecated":false},{"id":1608,"name":"Dragon Ball Xenoverse","interest":[{"id":30}],"count":130859,"deprecated":false},{"id":1609,"name":"Driveclub","interest":[{"id":30}],"count":111723,"deprecated":false},{"id":1610,"name":"Elite: Dangerous","interest":[{"id":30}],"count":13798,"deprecated":false},{"id":1611,"name":"The Evil Within","interest":[{"id":30}],"count":111954,"deprecated":false},{"id":1612,"name":"Far Cry","interest":[{"id":30}],"count":966939,"deprecated":false},{"id":1613,"name":"Final Fantasy","interest":[{"id":30}],"count":2105886,"deprecated":false},{"id":1614,"name":"Goat Simulator","interest":[{"id":30}],"count":18899,"deprecated":false},{"id":1615,"name":"God of War","interest":[{"id":30}],"count":2801945,"deprecated":false},{"id":1616,"name":"Horizon Zero Dawn","interest":[{"id":30}],"count":480524,"deprecated":false},{"id":1617,"name":"Infamous","interest":[{"id":30}],"count":36336,"deprecated":false},{"id":1618,"name":"Injustice: Gods Among Us","interest":[{"id":30}],"count":296808,"deprecated":false},{"id":1619,"name":"Just Cause","interest":[{"id":30}],"count":52023,"deprecated":false},{"id":1620,"name":"Just Dance","interest":[{"id":30}],"count":53171,"deprecated":false},{"id":1621,"name":"The Last Guardian","interest":[{"id":30}],"count":58620,"deprecated":false},{"id":1622,"name":"The Last of Us","interest":[{"id":30}],"count":1305103,"deprecated":false},{"id":1623,"name":"The Legend of Korra","interest":[{"id":30}],"count":67272,"deprecated":false},{"id":1625,"name":"Life Is Strange","interest":[{"id":30}],"count":1068216,"deprecated":false},{"id":1626,"name":"Madden NFL","interest":[{"id":30}],"count":157761,"deprecated":false},{"id":1627,"name":"Mass Effect","interest":[{"id":30}],"count":270134,"deprecated":false},{"id":1628,"name":"Mortal Kombat","interest":[{"id":30}],"count":5361956,"deprecated":false},{"id":1629,"name":"Need for Speed","interest":[{"id":30}],"count":2889820,"deprecated":false},{"id":1630,"name":"No Man's Sky","interest":[{"id":30}],"count":73333,"deprecated":false},{"id":1631,"name":"The Order: 1886","interest":[{"id":30}],"count":26023,"deprecated":false},{"id":1632,"name":"Outlast","interest":[{"id":30}],"count":1102190,"deprecated":false},{"id":1633,"name":"Persona 5","interest":[{"id":30}],"count":568029,"deprecated":false},{"id":1634,"name":"PlayerUnknown's Battlegrounds","interest":[{"id":30}],"count":6037550,"deprecated":false},{"id":1635,"name":"Project CARS","interest":[{"id":30}],"count":221637,"deprecated":false},{"id":1636,"name":"Tomb Raider","interest":[{"id":30}],"count":1109058,"deprecated":false},{"id":1637,"name":"Shovel Knight","interest":[{"id":30}],"count":26058,"deprecated":false},{"id":1638,"name":"The Sims","interest":[{"id":30}],"count":1268973,"deprecated":false},{"id":1639,"name":"Stardew Valley","interest":[{"id":30}],"count":147473,"deprecated":false},{"id":1640,"name":"Star Wars: Battlefront","interest":[{"id":30}],"count":141911,"deprecated":false},{"id":1641,"name":"Street Fighter V","interest":[{"id":30}],"count":125260,"deprecated":false},{"id":1642,"name":"Tales of Zestiria","interest":[{"id":30}],"count":28577,"deprecated":false},{"id":1643,"name":"Tekken","interest":[{"id":30}],"count":1456239,"deprecated":false},{"id":1644,"name":"Titanfall","interest":[{"id":30}],"count":171458,"deprecated":false},{"id":1645,"name":"Uncharted","interest":[{"id":30}],"count":37877,"deprecated":false},{"id":1646,"name":"Until Dawn","interest":[{"id":30}],"count":135665,"deprecated":false},{"id":1647,"name":"Watch Dogs","interest":[{"id":30}],"count":227122,"deprecated":false},{"id":1648,"name":"The Witcher 3","interest":[{"id":30}],"count":67482,"deprecated":false},{"id":1649,"name":"The Wolf Among Us","interest":[{"id":30}],"count":14562,"deprecated":false},{"id":1650,"name":"ARMA","interest":[{"id":30}],"count":44164,"deprecated":false},{"id":1651,"name":"Assetto Corsa","interest":[{"id":30}],"count":163601,"deprecated":false},{"id":1652,"name":"Batman: Arkham","interest":[{"id":30}],"count":197137,"deprecated":false},{"id":1653,"name":"Borderlands","interest":[{"id":30}],"count":1012469,"deprecated":false},{"id":1654,"name":"Counter-Strike","interest":[{"id":30}],"count":6507064,"deprecated":false},{"id":1655,"name":"DayZ","interest":[{"id":30}],"count":217710,"deprecated":false},{"id":1656,"name":"Dead Island","interest":[{"id":30}],"count":30217,"deprecated":false},{"id":1657,"name":"Deus Ex","interest":[{"id":30}],"count":33009,"deprecated":false},{"id":1658,"name":"Dota 2","interest":[{"id":30}],"count":4322086,"deprecated":false},{"id":1659,"name":"Dragon Age","interest":[{"id":30}],"count":195556,"deprecated":false},{"id":1660,"name":"Euro Truck Simulator","interest":[{"id":30}],"count":137089,"deprecated":false},{"id":1661,"name":"Fallout","interest":[{"id":30}],"count":2568841,"deprecated":false},{"id":1662,"name":"Five Nights at Freddy's","interest":[{"id":30}],"count":584642,"deprecated":false},{"id":1663,"name":"FlatOut","interest":[{"id":30}],"count":514868,"deprecated":false},{"id":1664,"name":"Garry's Mod","interest":[{"id":30}],"count":24328,"deprecated":false},{"id":1665,"name":"Guild Wars","interest":[{"id":30}],"count":32636,"deprecated":false},{"id":1666,"name":"Half-Life","interest":[{"id":30}],"count":177420,"deprecated":false},{"id":1667,"name":"Halo","interest":[{"id":30}],"count":216344,"deprecated":false},{"id":1668,"name":"Homeworld","interest":[{"id":30}],"count":97986,"deprecated":false},{"id":1669,"name":"Hotline Miami","interest":[{"id":30}],"count":38642,"deprecated":false},{"id":1670,"name":"Max Payne","interest":[{"id":30}],"count":77022,"deprecated":false},{"id":1671,"name":"Metal Gear Solid","interest":[{"id":30}],"count":592083,"deprecated":false},{"id":1672,"name":"Metro 2033","interest":[{"id":30}],"count":62173,"deprecated":false},{"id":1673,"name":"Mirror's Edge","interest":[{"id":30}],"count":28125,"deprecated":false},{"id":1674,"name":"Nier: Automata","interest":[{"id":30}],"count":424639,"deprecated":false},{"id":1675,"name":"Payday","interest":[{"id":30}],"count":91038,"deprecated":false},{"id":1676,"name":"Valve","interest":[{"id":30}],"count":74592,"deprecated":false},{"id":1677,"name":"Rayman","interest":[{"id":30}],"count":235132,"deprecated":false},{"id":1678,"name":"Resident Evil","interest":[{"id":30}],"count":2832362,"deprecated":false},{"id":1679,"name":"Sengoku","interest":[{"id":30}],"count":130329,"deprecated":false},{"id":1680,"name":"SimCity","interest":[{"id":30}],"count":72947,"deprecated":false},{"id":1681,"name":"Sleeping Dogs","interest":[{"id":30}],"count":441203,"deprecated":false},{"id":1682,"name":"Smite","interest":[{"id":30}],"count":399546,"deprecated":false},{"id":1683,"name":"StarCraft","interest":[{"id":30}],"count":228387,"deprecated":false},{"id":1684,"name":"Team Fortress","interest":[{"id":30}],"count":102596,"deprecated":false},{"id":1685,"name":"Terraria","interest":[{"id":30}],"count":206860,"deprecated":false},{"id":1686,"name":"The Witcher","interest":[{"id":30}],"count":4247742,"deprecated":false},{"id":1687,"name":"World of Tanks","interest":[{"id":30}],"count":315383,"deprecated":false},{"id":1688,"name":"World of Warcraft","interest":[{"id":30}],"count":1522481,"deprecated":false},{"id":1689,"name":"Angry Birds","interest":[{"id":30}],"count":1246490,"deprecated":false},{"id":1690,"name":"Boom Beach","interest":[{"id":30}],"count":104870,"deprecated":false},{"id":1691,"name":"Candy Crush Saga","interest":[{"id":30}],"count":46514,"deprecated":false},{"id":1692,"name":"Clash of Clans","interest":[{"id":30}],"count":2882021,"deprecated":false},{"id":1693,"name":"Clash Royale","interest":[{"id":30}],"count":2498578,"deprecated":false},{"id":1694,"name":"CSR Racing","interest":[{"id":30}],"count":36602,"deprecated":false},{"id":1695,"name":"Fire Emblem Heroes","interest":[{"id":30}],"count":108364,"deprecated":false},{"id":1696,"name":"Hearthstone","interest":[{"id":30}],"count":463312,"deprecated":false},{"id":1697,"name":"Miitomo","interest":[{"id":30}],"count":89528,"deprecated":false},{"id":1698,"name":"Minecraft","interest":[{"id":30}],"count":98143,"deprecated":false},{"id":1699,"name":"One Piece Treasure Cruise","interest":[{"id":30}],"count":17186,"deprecated":false},{"id":1700,"name":"Plants vs. Zombies","interest":[{"id":30}],"count":139100,"deprecated":false},{"id":1701,"name":"Pokemon Go","interest":[{"id":30}],"count":16272694,"deprecated":false},{"id":1702,"name":"Pokemon Shuffle","interest":[{"id":30}],"count":5376,"deprecated":false},{"id":1703,"name":"Real Racing 3","interest":[{"id":30}],"count":81847,"deprecated":false},{"id":1704,"name":"Super Mario Run","interest":[{"id":30}],"count":32410,"deprecated":false},{"id":1705,"name":"The Simpsons: Tapped Out","interest":[{"id":30}],"count":12128,"deprecated":false},{"id":1706,"name":"Vainglory","interest":[{"id":30}],"count":337281,"deprecated":false},{"id":1707,"name":"Witcher","interest":[{"id":30}],"count":250884,"deprecated":false},{"id":1709,"name":"InstaMeet","interest":[{"id":1708}],"count":1278832,"deprecated":false},{"id":1710,"name":"Bodybuilding.com","interest":[{"id":196}],"count":1935187,"deprecated":false},{"id":1711,"name":"Beats Electronics","interest":[{"id":25}],"count":44733686,"deprecated":false},{"id":1712,"name":"Alienware","interest":[{"id":25}],"count":374478,"deprecated":false},{"id":1713,"name":"IndieGoGo","interest":[{"id":25}],"count":648752,"deprecated":false},{"id":1714,"name":"LIKEtoKNOW.it","interest":[{"id":25}],"count":1235544,"deprecated":false},{"id":1715,"name":"musical.ly","interest":[{"id":25}],"count":56697211,"deprecated":false},{"id":1716,"name":"MOOG","interest":[{"id":25}],"count":1164748,"deprecated":false},{"id":1717,"name":"HTC","interest":[{"id":25}],"count":1813313,"deprecated":false},{"id":1718,"name":"Aeropress","interest":[{"id":9}],"count":907709,"deprecated":false},{"id":1719,"name":"Zumo","interest":[{"id":9}],"count":239893,"deprecated":false},{"id":1720,"name":"Sabo Skirt","interest":[{"id":13}],"count":83756,"deprecated":false},{"id":1721,"name":"Supreme","interest":[{"id":13}],"count":45875677,"deprecated":false},{"id":1722,"name":"Ted Baker","interest":[{"id":13}],"count":1064979,"deprecated":false},{"id":1723,"name":"Tommy Bahama","interest":[{"id":13}],"count":70979,"deprecated":false},{"id":1724,"name":"True Religion","interest":[{"id":13}],"count":1387136,"deprecated":false},{"id":1725,"name":"UNIF","interest":[{"id":13}],"count":432256,"deprecated":false},{"id":1726,"name":"Van Heusen","interest":[{"id":13}],"count":286488,"deprecated":false},{"id":1727,"name":"Victoria's Secret Pink","interest":[{"id":13}],"count":100544,"deprecated":false},{"id":1728,"name":"Carrera","interest":[{"id":13}],"count":420346,"deprecated":false},{"id":1729,"name":"Maui Jim","interest":[{"id":13}],"count":210966,"deprecated":false},{"id":1730,"name":"Moscot","interest":[{"id":13}],"count":368516,"deprecated":false},{"id":1731,"name":"Oakley","interest":[{"id":13}],"count":22932147,"deprecated":false},{"id":1732,"name":"Warby Parker","interest":[{"id":13}],"count":338453,"deprecated":false},{"id":1733,"name":"Coach","interest":[{"id":13}],"count":8437558,"deprecated":false},{"id":1734,"name":"Dooney & Bourke","interest":[{"id":13}],"count":86205,"deprecated":false},{"id":1735,"name":"Furla","interest":[{"id":13}],"count":4236312,"deprecated":false},{"id":1736,"name":"Kate Spade","interest":[{"id":13}],"count":3743542,"deprecated":false},{"id":1737,"name":"Liu Jo","interest":[{"id":13}],"count":1251876,"deprecated":false},{"id":1738,"name":"Vera Bradley","interest":[{"id":13}],"count":131539,"deprecated":false},{"id":1739,"name":"Alcott","interest":[{"id":13}],"count":1213039,"deprecated":false},{"id":1740,"name":"Banana Republic","interest":[{"id":13}],"count":895252,"deprecated":false},{"id":1741,"name":"Betsey Johnson","interest":[{"id":13}],"count":185192,"deprecated":false},{"id":1742,"name":"Charlotte Russe","interest":[{"id":13}],"count":437654,"deprecated":false},{"id":1743,"name":"Claire's","interest":[{"id":13}],"count":554831,"deprecated":false},{"id":1744,"name":"Colcci","interest":[{"id":13}],"count":8232452,"deprecated":false},{"id":1745,"name":"Cuadra","interest":[{"id":13}],"count":98811,"deprecated":false},{"id":1746,"name":"Desigual","interest":[{"id":13}],"count":669626,"deprecated":false},{"id":1747,"name":"Eddie Bauer","interest":[{"id":13}],"count":147906,"deprecated":false},{"id":1748,"name":"Express","interest":[{"id":13}],"count":132410,"deprecated":false},{"id":1749,"name":"Faik Sonmez","interest":[{"id":13}],"count":5007,"deprecated":false},{"id":1750,"name":"FARM RIO","interest":[{"id":13}],"count":1199327,"deprecated":false},{"id":1751,"name":"Impericon","interest":[{"id":13}],"count":162528,"deprecated":false},{"id":1752,"name":"Ivanka Trump","interest":[{"id":13}],"count":1620485,"deprecated":false},{"id":1753,"name":"Jack Wills","interest":[{"id":13}],"count":356289,"deprecated":false},{"id":1754,"name":"Jay Jays","interest":[{"id":13}],"count":68092,"deprecated":false},{"id":1755,"name":"Jeffrey Campbell","interest":[{"id":13}],"count":152873,"deprecated":false},{"id":1756,"name":"Kiabi","interest":[{"id":13}],"count":1566373,"deprecated":false},{"id":1757,"name":"Lane Bryant","interest":[{"id":13}],"count":133864,"deprecated":false},{"id":1758,"name":"Lauren Conrad","interest":[{"id":13}],"count":92196,"deprecated":false},{"id":1759,"name":"Lee","interest":[{"id":13}],"count":204725,"deprecated":false},{"id":1760,"name":"Lilly Pulitzer","interest":[{"id":13}],"count":496245,"deprecated":false},{"id":1761,"name":"MANGO","interest":[{"id":13}],"count":606456,"deprecated":false},{"id":1762,"name":"Mavi Jeans","interest":[{"id":13}],"count":114440,"deprecated":false},{"id":1763,"name":"Melissa","interest":[{"id":13}],"count":121576,"deprecated":false},{"id":1764,"name":"Miss Me","interest":[{"id":13}],"count":33182,"deprecated":false},{"id":1765,"name":"Moda Praia","interest":[{"id":13}],"count":14870253,"deprecated":false},{"id":1766,"name":"Mr. GUGU & Miss GO","interest":[{"id":13}],"count":17752,"deprecated":false},{"id":1767,"name":"New Era","interest":[{"id":13}],"count":1079236,"deprecated":false},{"id":1768,"name":"New Look","interest":[{"id":13}],"count":494527,"deprecated":false},{"id":1769,"name":"Oysho","interest":[{"id":13}],"count":894448,"deprecated":false},{"id":1770,"name":"Quiz Clothing","interest":[{"id":13}],"count":188640,"deprecated":false},{"id":1771,"name":"Ruche","interest":[{"id":13}],"count":551,"deprecated":false},{"id":1772,"name":"Sullen Clothing","interest":[{"id":13}],"count":547480,"deprecated":false},{"id":1773,"name":"TOMS","interest":[{"id":13}],"count":1632573,"deprecated":false},{"id":1774,"name":"Wet Seal","interest":[{"id":13}],"count":36172,"deprecated":false},{"id":1775,"name":"Ben Sherman","interest":[{"id":13}],"count":124027,"deprecated":false},{"id":1776,"name":"John Varvatos","interest":[{"id":13}],"count":127120,"deprecated":false},{"id":1777,"name":"Perry Ellis","interest":[{"id":13}],"count":117464,"deprecated":false},{"id":1778,"name":"Turnbull & Asser","interest":[{"id":13}],"count":15336,"deprecated":false},{"id":1779,"name":"Vivienne Westwood","interest":[{"id":13}],"count":1475871,"deprecated":false},{"id":1780,"name":"Nelly.com","interest":[{"id":13}],"count":98490,"deprecated":false},{"id":1781,"name":"SheInside","interest":[{"id":13}],"count":37454231,"deprecated":false},{"id":1782,"name":"Clarks","interest":[{"id":13}],"count":3044771,"deprecated":false},{"id":1783,"name":"Del Toro Shoes","interest":[{"id":13}],"count":8129,"deprecated":false},{"id":1784,"name":"Geox","interest":[{"id":13}],"count":245872,"deprecated":false},{"id":1785,"name":"Hunter","interest":[{"id":13}],"count":497406,"deprecated":false},{"id":1786,"name":"Kurt Geiger","interest":[{"id":13}],"count":250134,"deprecated":false},{"id":1787,"name":"UGG","interest":[{"id":13}],"count":6766611,"deprecated":false},{"id":1788,"name":"7 for all mankind","interest":[{"id":13}],"count":80908,"deprecated":false},{"id":1789,"name":"Armani Collezioni","interest":[{"id":13}],"count":9631,"deprecated":false},{"id":1790,"name":"Armani Jeans","interest":[{"id":13}],"count":419238,"deprecated":false},{"id":1791,"name":"Barbour","interest":[{"id":13}],"count":1004645,"deprecated":false},{"id":1792,"name":"Bebe","interest":[{"id":13}],"count":76714,"deprecated":false},{"id":1793,"name":"Bec & Bridge","interest":[{"id":13}],"count":113957,"deprecated":false},{"id":1794,"name":"Brooks Brothers","interest":[{"id":13}],"count":226586,"deprecated":false},{"id":1795,"name":"By Malene Birger","interest":[{"id":13}],"count":43296,"deprecated":false},{"id":1796,"name":"Designers Remix","interest":[{"id":13}],"count":14135,"deprecated":false},{"id":1797,"name":"Diesel","interest":[{"id":13}],"count":116810,"deprecated":false},{"id":1798,"name":"Fred Perry","interest":[{"id":13}],"count":1472804,"deprecated":false},{"id":1799,"name":"Freda's","interest":[{"id":13}],"count":11388,"deprecated":false},{"id":1800,"name":"Isaac Mizrahi","interest":[{"id":13}],"count":24570,"deprecated":false},{"id":1801,"name":"Jean-Charles de Castelbajac","interest":[{"id":13}],"count":67888,"deprecated":false},{"id":1802,"name":"Jeremy Scott","interest":[{"id":13}],"count":552898,"deprecated":false},{"id":1803,"name":"Jovani","interest":[{"id":13}],"count":1151652,"deprecated":false},{"id":1804,"name":"La Petite Robe di Chiara Boni","interest":[{"id":13}],"count":24160,"deprecated":false},{"id":1805,"name":"Les Benjamins","interest":[{"id":13}],"count":50411,"deprecated":false},{"id":1806,"name":"Luiza Barcelos","interest":[{"id":13}],"count":378228,"deprecated":false},{"id":1807,"name":"Melissa Odabash","interest":[{"id":13}],"count":17136,"deprecated":false},{"id":1808,"name":"Paige","interest":[{"id":13}],"count":218395,"deprecated":false},{"id":1809,"name":"Patrizia Pepe","interest":[{"id":13}],"count":154734,"deprecated":false},{"id":1810,"name":"Sabyasachi Mukherjee","interest":[{"id":13}],"count":1007238,"deprecated":false},{"id":1811,"name":"Sandro","interest":[{"id":13}],"count":1155973,"deprecated":false},{"id":1812,"name":"Tumi","interest":[{"id":13}],"count":131204,"deprecated":false},{"id":1813,"name":"Vakko","interest":[{"id":13}],"count":579944,"deprecated":false},{"id":1814,"name":"Zadig & Voltaire","interest":[{"id":13}],"count":28662,"deprecated":false},{"id":1815,"name":"47 Street","interest":[{"id":13}],"count":649007,"deprecated":false},{"id":1816,"name":"Earth Music & Ecology","interest":[{"id":13}],"count":59265,"deprecated":false},{"id":1817,"name":"Gisele Bündchen","interest":[{"id":13}],"count":115,"deprecated":false},{"id":1818,"name":"On Aura Tout Vu","interest":[{"id":13}],"count":7222,"deprecated":false},{"id":1819,"name":"Stephen Jones","interest":[{"id":13}],"count":32376,"deprecated":false},{"id":1820,"name":"Vogue","interest":[{"id":13}],"count":48124858,"deprecated":false},{"id":1821,"name":"Ecco","interest":[{"id":13}],"count":586151,"deprecated":false},{"id":1822,"name":"Etro","interest":[{"id":13}],"count":791833,"deprecated":false},{"id":1823,"name":"Gant","interest":[{"id":13}],"count":1184906,"deprecated":false},{"id":1824,"name":"FORWARD","interest":[{"id":13}],"count":58490,"deprecated":false},{"id":1825,"name":"Mexx","interest":[{"id":13}],"count":62807,"deprecated":false},{"id":1827,"name":"Husqvarna Motorcycles","interest":[{"id":1826}],"count":3166662,"deprecated":false},{"id":1828,"name":"Yamaha","interest":[{"id":1826}],"count":55298156,"deprecated":false},{"id":1830,"name":"Hennessey","interest":[{"id":1826}],"count":2184541,"deprecated":false},{"id":1831,"name":"Nokian Tyres","interest":[{"id":1826}],"count":226010,"deprecated":false},{"id":1832,"name":"Ariel","interest":[{"id":1826}],"count":28103,"deprecated":false},{"id":1833,"name":"Bajaj","interest":[{"id":1826}],"count":4828371,"deprecated":false},{"id":1834,"name":"BMW Alpina","interest":[{"id":1826}],"count":318983,"deprecated":false},{"id":1836,"name":"Caterham","interest":[{"id":1826}],"count":173577,"deprecated":false},{"id":1837,"name":"Chery","interest":[{"id":1826}],"count":690484,"deprecated":false},{"id":1838,"name":"Citroen","interest":[{"id":1826}],"count":9022072,"deprecated":false},{"id":1839,"name":"Dacia","interest":[{"id":1826}],"count":3124013,"deprecated":false},{"id":1840,"name":"Daewoo","interest":[{"id":1826}],"count":4453706,"deprecated":false},{"id":1841,"name":"Datsun","interest":[{"id":1826}],"count":2453938,"deprecated":false},{"id":1842,"name":"De Tomaso","interest":[{"id":1826}],"count":121269,"deprecated":false},{"id":1844,"name":"DS","interest":[{"id":1826}],"count":350019,"deprecated":false},{"id":1845,"name":"FAW","interest":[{"id":1826}],"count":302878,"deprecated":false},{"id":1846,"name":"Freightliner","interest":[{"id":1826}],"count":328195,"deprecated":false},{"id":1847,"name":"Geely","interest":[{"id":1826}],"count":547563,"deprecated":false},{"id":1848,"name":"Genesis","interest":[{"id":1826}],"count":5243148,"deprecated":false},{"id":1849,"name":"Ginetta","interest":[{"id":1826}],"count":90980,"deprecated":false},{"id":1850,"name":"Great Wall","interest":[{"id":1826}],"count":7071859,"deprecated":false},{"id":1851,"name":"Hafei","interest":[{"id":1826}],"count":724495,"deprecated":false},{"id":1852,"name":"Haima","interest":[{"id":1826}],"count":6500383,"deprecated":false},{"id":1853,"name":"Haval","interest":[{"id":1826}],"count":966712,"deprecated":false},{"id":1854,"name":"Hummer","interest":[{"id":1826}],"count":2023900,"deprecated":false},{"id":1855,"name":"JAC","interest":[{"id":1826}],"count":1071732,"deprecated":false},{"id":1856,"name":"KIA","interest":[{"id":1826}],"count":5397829,"deprecated":false},{"id":1857,"name":"Koenigsegg","interest":[{"id":1826}],"count":571693,"deprecated":false},{"id":1858,"name":"KTM","interest":[{"id":1826}],"count":17914624,"deprecated":false},{"id":1859,"name":"Lancia","interest":[{"id":1826}],"count":953897,"deprecated":false},{"id":1860,"name":"LDV","interest":[{"id":1826}],"count":40184,"deprecated":false},{"id":1861,"name":"Lifan","interest":[{"id":1826}],"count":785745,"deprecated":false},{"id":1862,"name":"Lincoln","interest":[{"id":1826}],"count":2482112,"deprecated":false},{"id":1863,"name":"Lotus","interest":[{"id":1826}],"count":348944,"deprecated":false},{"id":1864,"name":"Mahindra","interest":[{"id":1826}],"count":3074814,"deprecated":false},{"id":1865,"name":"Maruti","interest":[{"id":1826}],"count":2318870,"deprecated":false},{"id":1866,"name":"Maybach","interest":[{"id":1826}],"count":4765422,"deprecated":false},{"id":1867,"name":"Mercury","interest":[{"id":1826}],"count":75540,"deprecated":false},{"id":1868,"name":"Mini","interest":[{"id":1826}],"count":2811198,"deprecated":false},{"id":1869,"name":"Mitsubishi","interest":[{"id":1826}],"count":34497063,"deprecated":false},{"id":1870,"name":"Oldsmobile","interest":[{"id":1826}],"count":594881,"deprecated":false},{"id":1872,"name":"Pontiac","interest":[{"id":1826}],"count":3617118,"deprecated":false},{"id":1873,"name":"Proton","interest":[{"id":1826}],"count":131120,"deprecated":false},{"id":1874,"name":"Rover","interest":[{"id":1826}],"count":6699209,"deprecated":false},{"id":1875,"name":"Saab","interest":[{"id":1826}],"count":101817,"deprecated":false},{"id":1876,"name":"Seat","interest":[{"id":1826}],"count":2325342,"deprecated":false},{"id":1877,"name":"Spyker","interest":[{"id":1826}],"count":121052,"deprecated":false},{"id":1878,"name":"SsangYong","interest":[{"id":1826}],"count":483537,"deprecated":false},{"id":1879,"name":"Tagaz","interest":[{"id":1826}],"count":1107330,"deprecated":false},{"id":1880,"name":"Tesla","interest":[{"id":1826}],"count":1739617,"deprecated":false},{"id":1881,"name":"Tofas","interest":[{"id":1826}],"count":1563698,"deprecated":false},{"id":1882,"name":"Zotye","interest":[{"id":1826}],"count":183491,"deprecated":false},{"id":1883,"name":"ВАЗ","interest":[{"id":1826}],"count":2019320,"deprecated":false},{"id":1885,"name":"Ё-авто","interest":[{"id":1826}],"count":0,"deprecated":false},{"id":1886,"name":"ЗАЗ","interest":[{"id":1826}],"count":70988,"deprecated":false},{"id":1887,"name":"ЗИЛ","interest":[{"id":1826}],"count":143887,"deprecated":false},{"id":1888,"name":"Иж","interest":[{"id":1826}],"count":129140,"deprecated":false},{"id":1889,"name":"КАМАЗ","interest":[{"id":1826}],"count":2562429,"deprecated":false},{"id":1890,"name":"УАЗ","interest":[{"id":1826}],"count":618857,"deprecated":false},{"id":1891,"name":"Lada","interest":[{"id":1826}],"count":3142530,"deprecated":false},{"id":1892,"name":"Cobb","interest":[{"id":1826}],"count":640575,"deprecated":false},{"id":1893,"name":"BBS","interest":[{"id":1826}],"count":4073409,"deprecated":false},{"id":1894,"name":"Corvette","interest":[{"id":1826}],"count":733317,"deprecated":false},{"id":1895,"name":"U. S. Bank","interest":[{"id":58}],"count":54188,"deprecated":false},{"id":1896,"name":"KRUG","interest":[{"id":19}],"count":415682,"deprecated":false},{"id":1897,"name":"Armani Prive","interest":[{"id":80}],"count":99622,"deprecated":false},{"id":1898,"name":"Blend-a-Med","interest":[{"id":80}],"count":9913,"deprecated":false},{"id":1899,"name":"House of Lashes","interest":[{"id":80}],"count":936205,"deprecated":false},{"id":1900,"name":"Stencil Stuff","interest":[{"id":80}],"count":444326,"deprecated":false},{"id":1901,"name":"Drybar","interest":[{"id":80}],"count":215135,"deprecated":false},{"id":1902,"name":"Oribe","interest":[{"id":80}],"count":870176,"deprecated":false},{"id":1903,"name":"Artistry","interest":[{"id":80}],"count":87159,"deprecated":false},{"id":1904,"name":"Ciaté","interest":[{"id":80}],"count":726228,"deprecated":false},{"id":1905,"name":"Elizabeth Arden","interest":[{"id":80}],"count":444580,"deprecated":false},{"id":1906,"name":"Jane Iredale","interest":[{"id":80}],"count":160950,"deprecated":false},{"id":1907,"name":"Julep","interest":[{"id":80}],"count":120547,"deprecated":false},{"id":1908,"name":"Lorac","interest":[{"id":80}],"count":700802,"deprecated":false},{"id":1909,"name":"Lush","interest":[{"id":80}],"count":10770798,"deprecated":false},{"id":1910,"name":"Make Up For Ever","interest":[{"id":80}],"count":18094779,"deprecated":false},{"id":1911,"name":"Mary Kay","interest":[{"id":80}],"count":15096412,"deprecated":false},{"id":1912,"name":"NYX Cosmetics","interest":[{"id":80}],"count":25360269,"deprecated":false},{"id":1913,"name":"Priceline Pharmacy","interest":[{"id":80}],"count":416646,"deprecated":false},{"id":1914,"name":"Rimmel London","interest":[{"id":80}],"count":1328008,"deprecated":false},{"id":1915,"name":"SigmaBeauty.com","interest":[{"id":80}],"count":1024084,"deprecated":false},{"id":1916,"name":"Smashbox","interest":[{"id":80}],"count":5732675,"deprecated":false},{"id":1917,"name":"Gelpolish","interest":[{"id":80}],"count":135,"deprecated":false},{"id":1918,"name":"Nails Inc.","interest":[{"id":80}],"count":250327,"deprecated":false},{"id":1919,"name":"Opi","interest":[{"id":80}],"count":4192159,"deprecated":false},{"id":1920,"name":"Zoya","interest":[{"id":80}],"count":707233,"deprecated":false},{"id":1921,"name":"Soap & Glory","interest":[{"id":80}],"count":504981,"deprecated":false},{"id":1922,"name":"Kiko","interest":[{"id":80}],"count":6767939,"deprecated":false},{"id":1923,"name":"Cien","interest":[{"id":80}],"count":242377,"deprecated":false},{"id":1924,"name":"ORLY","interest":[{"id":80}],"count":294222,"deprecated":false},{"id":1925,"name":"Pixi","interest":[{"id":80}],"count":655060,"deprecated":false},{"id":1926,"name":"OFRA","interest":[{"id":80}],"count":1889742,"deprecated":false},{"id":1927,"name":"Ouai","interest":[{"id":80}],"count":582950,"deprecated":false},{"id":1928,"name":"Veet","interest":[{"id":80}],"count":129198,"deprecated":false},{"id":1929,"name":"Adidas Y-3","interest":[{"id":33}],"count":173748,"deprecated":false},{"id":1930,"name":"And1","interest":[{"id":33}],"count":444441,"deprecated":false},{"id":1931,"name":"Arc'teryx","interest":[{"id":33}],"count":555547,"deprecated":false},{"id":1932,"name":"ASICS","interest":[{"id":33}],"count":15613574,"deprecated":false},{"id":1933,"name":"Capezio","interest":[{"id":33}],"count":454773,"deprecated":false},{"id":1934,"name":"Castelli Cycling","interest":[{"id":33}],"count":131161,"deprecated":false},{"id":1935,"name":"Dainese","interest":[{"id":33}],"count":1631321,"deprecated":false},{"id":1936,"name":"Diadora","interest":[{"id":33}],"count":2473329,"deprecated":false},{"id":1937,"name":"Henri Lloyd","interest":[{"id":33}],"count":18979,"deprecated":false},{"id":1938,"name":"Lululemon Athletica","interest":[{"id":33}],"count":7349851,"deprecated":false},{"id":1939,"name":"O'Neill","interest":[{"id":33}],"count":825626,"deprecated":false},{"id":1940,"name":"Rapha","interest":[{"id":33}],"count":3837894,"deprecated":false},{"id":1941,"name":"SOCCER.COM","interest":[{"id":33}],"count":269153,"deprecated":false},{"id":1942,"name":"Volcom","interest":[{"id":33}],"count":3329173,"deprecated":false},{"id":1943,"name":"Zumba Wear","interest":[{"id":33}],"count":493692,"deprecated":false},{"id":1944,"name":"Zumiez","interest":[{"id":33}],"count":784109,"deprecated":false},{"id":1945,"name":"ASICS Tiger","interest":[{"id":33}],"count":176683,"deprecated":false},{"id":1946,"name":"DC Shoes","interest":[{"id":33}],"count":1527093,"deprecated":false},{"id":1947,"name":"New Balance","interest":[{"id":33}],"count":18476494,"deprecated":false},{"id":10001,"name":"Armani Beauty","interest":[{"id":80}],"count":1145200,"deprecated":false},{"id":10002,"name":"Estee Lauder","interest":[{"id":80}],"count":6355591,"deprecated":false},{"id":10003,"name":"Lego Gaming","interest":[{"id":30}],"count":49978,"deprecated":false},{"id":10004,"name":"Tinder","interest":[{"id":1708}],"count":20462392,"deprecated":false},{"id":10007,"name":"OKCupid","interest":[{"id":1708}],"count":53264,"deprecated":false},{"id":10015,"name":"Grindr","interest":[{"id":1708}],"count":1633263,"deprecated":false},{"id":10066,"name":"Natura","interest":[{"id":80}],"count":228734,"deprecated":false},{"id":10068,"name":"Colgate","interest":[{"id":80}],"count":10767911,"deprecated":false},{"id":10071,"name":"Jafra","interest":[{"id":80}],"count":3668576,"deprecated":false},{"id":10075,"name":"Jequiti","interest":[{"id":80}],"count":2307222,"deprecated":false},{"id":10077,"name":"Boticario","interest":[{"id":80}],"count":6518546,"deprecated":false},{"id":10079,"name":"Eudora","interest":[{"id":80}],"count":9022148,"deprecated":false},{"id":10081,"name":"Casas Bahia","interest":[{"id":7}],"count":358601,"deprecated":false},{"id":10083,"name":"Ponto Frio","interest":[{"id":7}],"count":94071,"deprecated":false},{"id":10085,"name":"Americanas.com","interest":[{"id":7}],"count":576369,"deprecated":false},{"id":10087,"name":"Centauro","interest":[{"id":33}],"count":122191,"deprecated":false},{"id":10089,"name":"Insinuante","interest":[{"id":7}],"count":121679,"deprecated":false},{"id":10091,"name":"Ricardo Eletro","interest":[{"id":7}],"count":34058,"deprecated":false},{"id":10093,"name":"Divcom Pharma","interest":[{"id":80}],"count":60465,"deprecated":false},{"id":10096,"name":"BIC","interest":[{"id":80}],"count":2152,"deprecated":false},{"id":10098,"name":"Reckitt Benckiser","interest":[{"id":798}],"count":6768,"deprecated":false},{"id":10100,"name":"Ypê","interest":[{"id":7}],"count":430856,"deprecated":false},{"id":10102,"name":"Kimberly Clark","interest":[{"id":80}],"count":11241,"deprecated":false},{"id":10104,"name":"Baruel","interest":[{"id":80}],"count":69052,"deprecated":false},{"id":10106,"name":"P&G","interest":[{"id":80}],"count":28948,"deprecated":false},{"id":10108,"name":"Hypermarcas","interest":[{"id":100}],"count":10627,"deprecated":false},{"id":10110,"name":"Coty","interest":[{"id":80}],"count":143950,"deprecated":false},{"id":10112,"name":"Ultrafarma","interest":[{"id":80}],"count":30202,"deprecated":false},{"id":10114,"name":"AstraZeneca","interest":[{"id":100}],"count":7057765,"deprecated":false},{"id":10116,"name":"Sundown Vitaminas","interest":[{"id":80}],"count":2499,"deprecated":false},{"id":10118,"name":"EMS","interest":[{"id":100}],"count":27058,"deprecated":false},{"id":10120,"name":"Blowtex","interest":[{"id":100}],"count":14609,"deprecated":false},{"id":10122,"name":"Eurofarma","interest":[{"id":100}],"count":90360,"deprecated":false},{"id":10124,"name":"Genomma","interest":[{"id":100}],"count":2188,"deprecated":false},{"id":10126,"name":"Itaú","interest":[{"id":58}],"count":1867689,"deprecated":false},{"id":10128,"name":"Banco do Brasil","interest":[{"id":58}],"count":937765,"deprecated":false},{"id":10130,"name":"BMG","interest":[{"id":58}],"count":64261,"deprecated":false},{"id":10132,"name":"Santander","interest":[{"id":58}],"count":525696,"deprecated":false},{"id":10134,"name":"Banco Original","interest":[{"id":58}],"count":28956,"deprecated":false},{"id":10136,"name":"C&A","interest":[{"id":13}],"count":1197,"deprecated":false},{"id":10138,"name":"Grendene","interest":[{"id":13}],"count":539662,"deprecated":false},{"id":10140,"name":"Besni","interest":[{"id":13}],"count":20740,"deprecated":false},{"id":10144,"name":"Arezzo","interest":[{"id":13}],"count":7023906,"deprecated":false},{"id":10146,"name":"Alpargatas","interest":[{"id":13}],"count":2642454,"deprecated":false},{"id":10148,"name":"Amaro","interest":[{"id":13}],"count":8357,"deprecated":false},{"id":10150,"name":"Ana Capri","interest":[{"id":13}],"count":1377451,"deprecated":false},{"id":10152,"name":"Ramarim","interest":[{"id":13}],"count":580467,"deprecated":false},{"id":10154,"name":"Lepostiche","interest":[{"id":13}],"count":20262,"deprecated":false},{"id":10156,"name":"Birô","interest":[{"id":13}],"count":107713,"deprecated":false},{"id":10158,"name":"Tropical Fashion","interest":[{"id":13}],"count":35159,"deprecated":false},{"id":10160,"name":"Rosa Fina Moda","interest":[{"id":13}],"count":12191,"deprecated":false},{"id":10162,"name":"Sawary","interest":[{"id":13}],"count":407527,"deprecated":false},{"id":10164,"name":"Dumond","interest":[{"id":13}],"count":155103,"deprecated":false},{"id":10166,"name":"MOB","interest":[{"id":13}],"count":38914,"deprecated":false},{"id":10168,"name":"Mr. Cat","interest":[{"id":13}],"count":116311,"deprecated":false},{"id":10170,"name":"Pernambucanas","interest":[{"id":13}],"count":1413698,"deprecated":false},{"id":10172,"name":"Colombo","interest":[{"id":13}],"count":5226,"deprecated":false},{"id":10174,"name":"Lojas Pompeia","interest":[{"id":13}],"count":36646,"deprecated":false},{"id":10176,"name":"Hering","interest":[{"id":13}],"count":5576131,"deprecated":false},{"id":10178,"name":"Corello","interest":[{"id":13}],"count":39411,"deprecated":false},{"id":10180,"name":"ChilliBeans","interest":[{"id":13}],"count":5826520,"deprecated":false},{"id":10182,"name":"Marisa","interest":[{"id":13}],"count":589444,"deprecated":false},{"id":10184,"name":"Vivara","interest":[{"id":130}],"count":1665217,"deprecated":false},{"id":10186,"name":"Montecarlo","interest":[{"id":130}],"count":21244,"deprecated":false},{"id":10188,"name":"Morana","interest":[{"id":130}],"count":119995,"deprecated":false},{"id":10190,"name":"Orient","interest":[{"id":130}],"count":68556,"deprecated":false},{"id":10192,"name":"Dumont","interest":[{"id":130}],"count":3057,"deprecated":false},{"id":10194,"name":"Champion","interest":[{"id":130}],"count":23931,"deprecated":false},{"id":10196,"name":"H Stern","interest":[{"id":130}],"count":96495,"deprecated":false},{"id":10198,"name":"Rommanel","interest":[{"id":130}],"count":1273484,"deprecated":false},{"id":10200,"name":"Locaweb","interest":[{"id":25}],"count":22045,"deprecated":false},{"id":10202,"name":"General Electric","interest":[{"id":58}],"count":166406,"deprecated":false},{"id":10203,"name":"Tramontina","interest":[{"id":1560}],"count":3152560,"deprecated":false},{"id":10205,"name":"Azul","interest":[{"id":43}],"count":56136,"deprecated":false},{"id":10207,"name":"CVC","interest":[{"id":43}],"count":270359,"deprecated":false},{"id":10209,"name":"Submarino Viagens","interest":[{"id":43}],"count":34187,"deprecated":false},{"id":10211,"name":"Decolar.com","interest":[{"id":43}],"count":250553,"deprecated":false},{"id":10213,"name":"Viajanet","interest":[{"id":43}],"count":18925,"deprecated":false},{"id":10215,"name":"Hotel Urbano","interest":[{"id":43}],"count":50026,"deprecated":false},{"id":10217,"name":"Gol","interest":[{"id":43}],"count":702932,"deprecated":false},{"id":10219,"name":"Trivago","interest":[{"id":43}],"count":954839,"deprecated":false},{"id":10221,"name":"Claro","interest":[{"id":58}],"count":399091,"deprecated":false},{"id":10223,"name":"Nextel","interest":[{"id":58}],"count":328107,"deprecated":false},{"id":10225,"name":"Vivo","interest":[{"id":58}],"count":428490,"deprecated":false},{"id":10227,"name":"Uol","interest":[{"id":58}],"count":191874,"deprecated":false},{"id":10229,"name":"Tim","interest":[{"id":58}],"count":167661,"deprecated":false},{"id":10231,"name":"Rbtv","interest":[{"id":1}],"count":61014,"deprecated":false},{"id":10233,"name":"Visa","interest":[{"id":58}],"count":58268,"deprecated":false},{"id":10235,"name":"Easy Taxi","interest":[{"id":58}],"count":22387,"deprecated":false},{"id":10237,"name":"Ifood","interest":[{"id":139}],"count":3779992,"deprecated":false},{"id":10239,"name":"Multiplus","interest":[{"id":58}],"count":70824,"deprecated":false},{"id":10241,"name":"Bob's","interest":[{"id":139}],"count":926298,"deprecated":false},{"id":10243,"name":"Bauducco","interest":[{"id":139}],"count":1211297,"deprecated":false},{"id":10245,"name":"Kopenhagen","interest":[{"id":139}],"count":136216,"deprecated":false},{"id":10247,"name":"Arcor","interest":[{"id":139}],"count":647417,"deprecated":false},{"id":10249,"name":"Ajinomoto","interest":[{"id":139}],"count":529685,"deprecated":false},{"id":10251,"name":"Habib`s","interest":[{"id":139}],"count":796890,"deprecated":false},{"id":10253,"name":"Mead Johnson Nutrution","interest":[{"id":139}],"count":3998,"deprecated":false},{"id":10255,"name":"Tres Corações","interest":[{"id":139}],"count":357902,"deprecated":false},{"id":10257,"name":"Doce Sabor","interest":[{"id":139}],"count":205521,"deprecated":false},{"id":10259,"name":"Garoto","interest":[{"id":139}],"count":116491,"deprecated":false},{"id":10261,"name":"Frango Assado","interest":[{"id":139}],"count":767476,"deprecated":false},{"id":10263,"name":"Itambé","interest":[{"id":139}],"count":1920819,"deprecated":false},{"id":10265,"name":"Italac","interest":[{"id":139}],"count":232490,"deprecated":false},{"id":10267,"name":"Mondelez","interest":[{"id":139}],"count":57943,"deprecated":false},{"id":10269,"name":"Josapar","interest":[{"id":139}],"count":8539,"deprecated":false},{"id":10271,"name":"Açúcar União","interest":[{"id":139}],"count":40788,"deprecated":false},{"id":10273,"name":"Perfetti Van Melle","interest":[{"id":139}],"count":2492,"deprecated":false},{"id":10275,"name":"General Mills","interest":[{"id":139}],"count":84099,"deprecated":false},{"id":10277,"name":"Nissin","interest":[{"id":139}],"count":845,"deprecated":false},{"id":10279,"name":"Piraque","interest":[{"id":139}],"count":162087,"deprecated":false},{"id":10281,"name":"Obrigado Agua de coco","interest":[{"id":9}],"count":387,"deprecated":false},{"id":10283,"name":"Ducoco","interest":[{"id":9}],"count":41595,"deprecated":false},{"id":10285,"name":"Cachaça 51","interest":[{"id":19}],"count":8907,"deprecated":false},{"id":10287,"name":"Proibida","interest":[{"id":19}],"count":137006,"deprecated":false},{"id":10289,"name":"Pernod Ricard","interest":[{"id":19}],"count":156303,"deprecated":false},{"id":10291,"name":"Estrella Galícia","interest":[{"id":19}],"count":409448,"deprecated":false},{"id":10293,"name":"Grupo Petrópolis","interest":[{"id":19}],"count":74594,"deprecated":false},{"id":10295,"name":"Jurupinga","interest":[{"id":19}],"count":30116,"deprecated":false},{"id":10297,"name":"Schin","interest":[{"id":19}],"count":745871,"deprecated":false},{"id":10299,"name":"Ambev","interest":[{"id":19}],"count":5720718,"deprecated":false},{"id":10301,"name":"Diageo","interest":[{"id":19}],"count":523599,"deprecated":false},{"id":10303,"name":"Dia","interest":[{"id":139}],"count":51844,"deprecated":false},{"id":10305,"name":"Extra Hipermercado","interest":[{"id":139}],"count":5438,"deprecated":false},{"id":10307,"name":"Sonda Supermercado","interest":[{"id":139}],"count":7765,"deprecated":false},{"id":10309,"name":"Lojas Americanas","interest":[{"id":7}],"count":954354,"deprecated":false},{"id":10311,"name":"Drogasil","interest":[{"id":80}],"count":557545,"deprecated":false},{"id":10313,"name":"Magazine Luiza","interest":[{"id":1560}],"count":1316481,"deprecated":false},{"id":10315,"name":"Raia","interest":[{"id":80}],"count":52407,"deprecated":false},{"id":10317,"name":"Kalunga","interest":[{"id":7}],"count":149029,"deprecated":false},{"id":10319,"name":"Via Varejo","interest":[{"id":58}],"count":61590,"deprecated":false},{"id":10321,"name":"BR Malls","interest":[{"id":7}],"count":23647,"deprecated":false},{"id":10323,"name":"Iguatemi","interest":[{"id":7}],"count":286189,"deprecated":false},{"id":10325,"name":"Suvinil","interest":[{"id":1560}],"count":1596858,"deprecated":false},{"id":10327,"name":"Leroy Merlin","interest":[{"id":1560}],"count":938932,"deprecated":false},{"id":10329,"name":"C&C","interest":[{"id":1560}],"count":111423,"deprecated":false},{"id":10331,"name":"Telha Norte","interest":[{"id":1560}],"count":59757,"deprecated":false},{"id":10333,"name":"Raízen","interest":[{"id":58}],"count":122941,"deprecated":false},{"id":10335,"name":"Grupo Piaggio do Brasil","interest":[{"id":1826}],"count":357,"deprecated":false},{"id":10337,"name":"Troller","interest":[{"id":1826}],"count":794778,"deprecated":false},{"id":10339,"name":"Bridgestone","interest":[{"id":1826}],"count":73493,"deprecated":false},{"id":10341,"name":"Sulamérica","interest":[{"id":58}],"count":606270,"deprecated":false},{"id":10343,"name":"Liberty","interest":[{"id":58}],"count":74167,"deprecated":false},{"id":10345,"name":"Mapfre","interest":[{"id":58}],"count":703267,"deprecated":false},{"id":10347,"name":"Bradesco Seguros","interest":[{"id":58}],"count":190449,"deprecated":false},{"id":10349,"name":"Qualicorp","interest":[{"id":58}],"count":65859,"deprecated":false},{"id":10351,"name":"OLX","interest":[{"id":58}],"count":21131,"deprecated":false},{"id":10353,"name":"Dafiti","interest":[{"id":13}],"count":387812,"deprecated":false},{"id":10355,"name":"Netshoes","interest":[{"id":13}],"count":393981,"deprecated":false},{"id":10357,"name":"Cyrela","interest":[{"id":58}],"count":644309,"deprecated":false},{"id":10359,"name":"MRV","interest":[{"id":58}],"count":916590,"deprecated":false},{"id":10361,"name":"Amanco","interest":[{"id":58}],"count":116084,"deprecated":false},{"id":10363,"name":"Superga","interest":[{"id":13}],"count":1796541,"deprecated":false},{"id":10365,"name":"Maison Kitsuné","interest":[{"id":13}],"count":197898,"deprecated":false},{"id":10367,"name":"Armani Exchange","interest":[{"id":13}],"count":1486198,"deprecated":false},{"id":10369,"name":"Brioni","interest":[{"id":13}],"count":343100,"deprecated":false},{"id":10371,"name":"Corneliani","interest":[{"id":13}],"count":51301,"deprecated":false},{"id":10373,"name":"Max Mara","interest":[{"id":13}],"count":5340930,"deprecated":false},{"id":10375,"name":"Marni","interest":[{"id":13}],"count":1158953,"deprecated":false},{"id":10377,"name":"Palm Angels","interest":[{"id":13}],"count":993450,"deprecated":false},{"id":10379,"name":"Sunnei","interest":[{"id":13}],"count":30378,"deprecated":false},{"id":10381,"name":"Sergio Tacchini","interest":[{"id":13}],"count":282503,"deprecated":false},{"id":10383,"name":"Ellesse","interest":[{"id":33}],"count":2564889,"deprecated":false},{"id":10385,"name":"Stone Island","interest":[{"id":13}],"count":4419722,"deprecated":false},{"id":10387,"name":"Loro Piana","interest":[{"id":13}],"count":425965,"deprecated":false},{"id":10389,"name":"M Missoni","interest":[{"id":13}],"count":15830,"deprecated":false},{"id":10391,"name":"Martini","interest":[{"id":19}],"count":7649045,"deprecated":false},{"id":10393,"name":"Barilla","interest":[{"id":139}],"count":738818,"deprecated":false},{"id":10395,"name":"Chicco","interest":[{"id":190}],"count":804837,"deprecated":false},{"id":10397,"name":"United Colors of Benetton","interest":[{"id":13}],"count":2903270,"deprecated":false},{"id":10401,"name":"Gruppo Agenti Generali Italia","interest":[{"id":58}],"count":5450,"deprecated":false},{"id":10403,"name":"Indesit","interest":[{"id":1560}],"count":180234,"deprecated":false},{"id":10405,"name":"S.Pellegrino","interest":[{"id":9}],"count":199422,"deprecated":false},{"id":10407,"name":"Galbani","interest":[{"id":139}],"count":64981,"deprecated":false},{"id":10409,"name":"Lavazza","interest":[{"id":9}],"count":1820557,"deprecated":false},{"id":10412,"name":"Cinzano","interest":[{"id":19}],"count":326146,"deprecated":false},{"id":10414,"name":"Illy","interest":[{"id":9}],"count":754941,"deprecated":false},{"id":10416,"name":"Disaronno","interest":[{"id":19}],"count":355510,"deprecated":false},{"id":10418,"name":"Mandarina Duck","interest":[{"id":13}],"count":19397,"deprecated":false},{"id":10420,"name":"Campari","interest":[{"id":19}],"count":6731316,"deprecated":false},{"id":10422,"name":"Ducati","interest":[{"id":1826}],"count":13929970,"deprecated":false},{"id":10424,"name":"Gianfranco Ferre Home","interest":[{"id":1560}],"count":1217,"deprecated":false},{"id":10426,"name":"Cerruti1881","interest":[{"id":13}],"count":59903,"deprecated":false},{"id":10428,"name":"Divella","interest":[{"id":139}],"count":46306,"deprecated":false},{"id":10430,"name":"Acqua Panna","interest":[{"id":9}],"count":28166,"deprecated":false},{"id":10432,"name":"Colavita","interest":[{"id":139}],"count":14761,"deprecated":false},{"id":10434,"name":"Luxardo","interest":[{"id":19}],"count":344392,"deprecated":false},{"id":10436,"name":"Deborah Milano","interest":[{"id":80}],"count":140008,"deprecated":false},{"id":10438,"name":"American Express","interest":[{"id":58}],"count":334799,"deprecated":false},{"id":10440,"name":"THUN","interest":[{"id":190}],"count":854,"deprecated":false},{"id":10442,"name":"Bottega Verde","interest":[{"id":80}],"count":73664,"deprecated":false},{"id":10444,"name":"Glossip Milano Make Up","interest":[{"id":80}],"count":15568,"deprecated":false},{"id":10447,"name":"Bim","interest":[{"id":7}],"count":2191136,"deprecated":false},{"id":10450,"name":"A101","interest":[{"id":7}],"count":1006739,"deprecated":false},{"id":10452,"name":"Uyum","interest":[{"id":7}],"count":277,"deprecated":false},{"id":10454,"name":"Sok","interest":[{"id":7}],"count":797099,"deprecated":false},{"id":10456,"name":"Onur Air","interest":[{"id":43}],"count":57390,"deprecated":false},{"id":10458,"name":"Kinetix","interest":[{"id":13}],"count":226805,"deprecated":false},{"id":10460,"name":"Gezer","interest":[{"id":13}],"count":47,"deprecated":false},{"id":10462,"name":"Forelli","interest":[{"id":13}],"count":3288,"deprecated":false},{"id":10464,"name":"Scooter Ayakkabi","interest":[{"id":13}],"count":1010,"deprecated":false},{"id":10466,"name":"Polaris Ayakkabi","interest":[{"id":13}],"count":34432,"deprecated":false},{"id":10468,"name":"Lescon","interest":[{"id":33}],"count":87730,"deprecated":false},{"id":10470,"name":"Torku","interest":[{"id":139}],"count":185289,"deprecated":false},{"id":10472,"name":"Tariş Zeytinyağı","interest":[{"id":139}],"count":4466,"deprecated":false},{"id":10474,"name":"Solen","interest":[{"id":139}],"count":47551,"deprecated":false},{"id":10476,"name":"Ulker","interest":[{"id":139}],"count":137166,"deprecated":false},{"id":10478,"name":"Ulker Cafe Crown","interest":[{"id":139}],"count":10361,"deprecated":false},{"id":10480,"name":"Lezita","interest":[{"id":139}],"count":5325,"deprecated":false},{"id":10482,"name":"Eti","interest":[{"id":139}],"count":29294,"deprecated":false},{"id":10484,"name":"Pınar Sütüm","interest":[{"id":9}],"count":230,"deprecated":false},{"id":10486,"name":"Sütaş","interest":[{"id":139}],"count":313499,"deprecated":false},{"id":10488,"name":"Tadelle","interest":[{"id":139}],"count":33714,"deprecated":false},{"id":10490,"name":"Banvit","interest":[{"id":139}],"count":9530,"deprecated":false},{"id":10492,"name":"Hamidiye","interest":[{"id":9}],"count":4540,"deprecated":false},{"id":10494,"name":"Erikli","interest":[{"id":9}],"count":3966,"deprecated":false},{"id":10496,"name":"Nigde Gazozu","interest":[{"id":9}],"count":5048,"deprecated":false},{"id":10498,"name":"Beypazari","interest":[{"id":9}],"count":345,"deprecated":false},{"id":10500,"name":"Dimes.tr","interest":[{"id":9}],"count":20764,"deprecated":false},{"id":10502,"name":"Dogus Cay","interest":[{"id":9}],"count":24255,"deprecated":false},{"id":10504,"name":"Kigili","interest":[{"id":13}],"count":83968,"deprecated":false},{"id":10506,"name":"Hatemoglu","interest":[{"id":13}],"count":15176,"deprecated":false},{"id":10508,"name":"Damat","interest":[{"id":13}],"count":1974773,"deprecated":false},{"id":10510,"name":"Suvari","interest":[{"id":13}],"count":31847,"deprecated":false},{"id":10512,"name":"Naturalive","interest":[{"id":80}],"count":6842,"deprecated":false},{"id":10514,"name":"Duru","interest":[{"id":80}],"count":319307,"deprecated":false},{"id":10516,"name":"Turk Telekom","interest":[{"id":58}],"count":186861,"deprecated":false},{"id":10518,"name":"Vestel","interest":[{"id":25}],"count":519836,"deprecated":false},{"id":10520,"name":"Casper","interest":[{"id":1560}],"count":102089,"deprecated":false},{"id":10522,"name":"Bimeks","interest":[{"id":25}],"count":6379,"deprecated":false},{"id":10524,"name":"Vatan Bilgisayar","interest":[{"id":25}],"count":10099,"deprecated":false},{"id":10526,"name":"Kaan","interest":[{"id":25}],"count":233,"deprecated":false},{"id":10528,"name":"Arcelik","interest":[{"id":1560}],"count":449448,"deprecated":false},{"id":10530,"name":"Beko","interest":[{"id":1560}],"count":412006,"deprecated":false},{"id":10532,"name":"Arzum","interest":[{"id":1560}],"count":1192335,"deprecated":false},{"id":10534,"name":"Sinbo","interest":[{"id":1560}],"count":257659,"deprecated":false},{"id":10536,"name":"GoldMaster","interest":[{"id":1560}],"count":378,"deprecated":false},{"id":10538,"name":"Ford Otosan","interest":[{"id":1826}],"count":22870,"deprecated":false},{"id":10540,"name":"Grundig","interest":[{"id":1560}],"count":212318,"deprecated":false},{"id":10542,"name":"Regal Saat","interest":[{"id":1560}],"count":1177,"deprecated":false},{"id":10544,"name":"Arnica Ev Aletleri","interest":[{"id":1560}],"count":23475,"deprecated":false},{"id":10546,"name":"Homend","interest":[{"id":1560}],"count":19847,"deprecated":false},{"id":10548,"name":"Kumtel","interest":[{"id":1560}],"count":42069,"deprecated":false},{"id":10550,"name":"Bisse","interest":[{"id":13}],"count":28871,"deprecated":false},{"id":10552,"name":"Chakra","interest":[{"id":1560}],"count":599,"deprecated":false},{"id":10554,"name":"DeFacto","interest":[{"id":13}],"count":2661366,"deprecated":false},{"id":10556,"name":"Derimod","interest":[{"id":13}],"count":228097,"deprecated":false},{"id":10558,"name":"Desa","interest":[{"id":13}],"count":8400,"deprecated":false},{"id":10560,"name":"FLO","interest":[{"id":13}],"count":60407,"deprecated":false},{"id":10562,"name":"Greyder","interest":[{"id":13}],"count":79261,"deprecated":false},{"id":10564,"name":"Koton","interest":[{"id":13}],"count":1151330,"deprecated":false},{"id":10566,"name":"LTB Jeans","interest":[{"id":13}],"count":53953,"deprecated":false},{"id":10568,"name":"Lumberjack","interest":[{"id":13}],"count":2646,"deprecated":false},{"id":10570,"name":"Sarar","interest":[{"id":13}],"count":7206307,"deprecated":false},{"id":10572,"name":"Bellona","interest":[{"id":1560}],"count":272390,"deprecated":false},{"id":10574,"name":"Biev","interest":[{"id":1560}],"count":32703,"deprecated":false},{"id":10576,"name":"English Home Turkiye","interest":[{"id":1560}],"count":237697,"deprecated":false},{"id":10578,"name":"Enza Home","interest":[{"id":1560}],"count":47838,"deprecated":false},{"id":10580,"name":"Evidea","interest":[{"id":1560}],"count":73985,"deprecated":false},{"id":10582,"name":"Istikbal","interest":[{"id":1560}],"count":1214862,"deprecated":false},{"id":10584,"name":"Ozdilek","interest":[{"id":1560}],"count":1136124,"deprecated":false},{"id":10586,"name":"Merinos Mobilya","interest":[{"id":1560}],"count":729703,"deprecated":false},{"id":10588,"name":"Mondi","interest":[{"id":1560}],"count":67966,"deprecated":false},{"id":10590,"name":"Royal Hali","interest":[{"id":1560}],"count":3872,"deprecated":false},{"id":10592,"name":"Saray Hali","interest":[{"id":1560}],"count":34460,"deprecated":false},{"id":10594,"name":"Yatas Bedding","interest":[{"id":1560}],"count":17842,"deprecated":false},{"id":10597,"name":"Teknosa","interest":[{"id":25}],"count":171142,"deprecated":false},{"id":10599,"name":"Akbank","interest":[{"id":58}],"count":412811,"deprecated":false},{"id":10601,"name":"Anadolu Sigorta","interest":[{"id":58}],"count":31762,"deprecated":false},{"id":10603,"name":"Halkbank","interest":[{"id":58}],"count":159140,"deprecated":false},{"id":10605,"name":"Sekerbank","interest":[{"id":58}],"count":27496,"deprecated":false},{"id":10607,"name":"Isbankasi","interest":[{"id":58}],"count":113985,"deprecated":false},{"id":10609,"name":"Turkishbank","interest":[{"id":58}],"count":637,"deprecated":false},{"id":10611,"name":"VakifBank","interest":[{"id":58}],"count":98530,"deprecated":false},{"id":10613,"name":"Ziraat Bankasi","interest":[{"id":58}],"count":98062,"deprecated":false},{"id":10616,"name":"Yapı Kredi","interest":[{"id":58}],"count":272603,"deprecated":false},{"id":10618,"name":"Ziraat Katılım","interest":[{"id":58}],"count":4881,"deprecated":false},{"id":10620,"name":"AnadoluJet","interest":[{"id":43}],"count":146486,"deprecated":false},{"id":10622,"name":"AtlasJet","interest":[{"id":43}],"count":29483,"deprecated":false},{"id":10624,"name":"Borajet","interest":[{"id":43}],"count":11162,"deprecated":false},{"id":10626,"name":"Pegasus Airlines","interest":[{"id":43}],"count":183940,"deprecated":false},{"id":10628,"name":"SunExpress","interest":[{"id":43}],"count":176371,"deprecated":false},{"id":10630,"name":"Tailwind Airlines","interest":[{"id":43}],"count":4839,"deprecated":false},{"id":10632,"name":"Çaykur","interest":[{"id":9}],"count":330710,"deprecated":false},{"id":10634,"name":"Istanbul Halk Ekmek","interest":[{"id":139}],"count":10819,"deprecated":false},{"id":10636,"name":"Konya Seker","interest":[{"id":139}],"count":3354,"deprecated":false},{"id":10639,"name":"Tamek","interest":[{"id":139}],"count":33020,"deprecated":false},{"id":10641,"name":"Tukas","interest":[{"id":139}],"count":18448,"deprecated":false},{"id":10643,"name":"Arko Nem","interest":[{"id":80}],"count":48182,"deprecated":false},{"id":10645,"name":"Bioblas","interest":[{"id":80}],"count":162085,"deprecated":false},{"id":10647,"name":"Molfix","interest":[{"id":80}],"count":175679,"deprecated":false},{"id":10649,"name":"Molped","interest":[{"id":80}],"count":81857,"deprecated":false},{"id":10651,"name":"Jolly Tur","interest":[{"id":43}],"count":53554,"deprecated":false},{"id":10653,"name":"Komili","interest":[{"id":139}],"count":35699,"deprecated":false},{"id":10655,"name":"Komili Bebe","interest":[{"id":80}],"count":18679,"deprecated":false},{"id":10657,"name":"Beymen","interest":[{"id":13}],"count":645777,"deprecated":false},{"id":10659,"name":"Boyner","interest":[{"id":13}],"count":375442,"deprecated":false},{"id":10661,"name":"NetWork","interest":[{"id":13}],"count":18241,"deprecated":false},{"id":10663,"name":"Twist","interest":[{"id":13}],"count":17178,"deprecated":false},{"id":10665,"name":"Ipekyol","interest":[{"id":13}],"count":462536,"deprecated":false},{"id":10667,"name":"Vakkorama","interest":[{"id":13}],"count":33273,"deprecated":false},{"id":10669,"name":"Machka","interest":[{"id":13}],"count":25120,"deprecated":false},{"id":10671,"name":"Turkcell","interest":[{"id":58}],"count":1197192,"deprecated":false},{"id":10673,"name":"Kizilkayalar","interest":[{"id":139}],"count":15012,"deprecated":false},{"id":10675,"name":"Flormar","interest":[{"id":80}],"count":439547,"deprecated":false},{"id":10677,"name":"Pastel","interest":[{"id":80}],"count":209264,"deprecated":false},{"id":10679,"name":"Golden Rose","interest":[{"id":80}],"count":1837443,"deprecated":false},{"id":10681,"name":"Galatasaray","interest":[{"id":21}],"count":6584842,"deprecated":false},{"id":10683,"name":"Besiktas","interest":[{"id":21}],"count":5005083,"deprecated":false},{"id":10685,"name":"Fenerbahce","interest":[{"id":21}],"count":3600119,"deprecated":false},{"id":10687,"name":"Trabzonspor","interest":[{"id":21}],"count":2439453,"deprecated":false},{"id":10689,"name":"Kavaklidere","interest":[{"id":19}],"count":8375,"deprecated":false},{"id":10691,"name":"Ulker Cokokrem","interest":[{"id":139}],"count":17042,"deprecated":false},{"id":10693,"name":"Sirmagrup","interest":[{"id":9}],"count":8451,"deprecated":false},{"id":10695,"name":"Garanti Bankasi","interest":[{"id":58}],"count":19356,"deprecated":false},{"id":10697,"name":"QNB Finansbank","interest":[{"id":58}],"count":32694,"deprecated":false},{"id":10699,"name":"Odeabank","interest":[{"id":58}],"count":23412,"deprecated":false},{"id":10701,"name":"Eti Form","interest":[{"id":798}],"count":38369,"deprecated":false},{"id":10703,"name":"PowerTürk","interest":[{"id":3}],"count":69654,"deprecated":false},{"id":10706,"name":"Show TV","interest":[{"id":1}],"count":2253531,"deprecated":false},{"id":10708,"name":"Kanal D","interest":[{"id":1}],"count":1390838,"deprecated":false},{"id":10710,"name":"TV8","interest":[{"id":1}],"count":1668206,"deprecated":false},{"id":10712,"name":"Star TV","interest":[{"id":1}],"count":1385606,"deprecated":false},{"id":10714,"name":"TRT 1","interest":[{"id":1}],"count":793770,"deprecated":false},{"id":10716,"name":"CNN Turk","interest":[{"id":1}],"count":137219,"deprecated":false},{"id":10718,"name":"Haberturk TV","interest":[{"id":1}],"count":23675,"deprecated":false},{"id":10720,"name":"KKW Beauty","interest":[{"id":80}],"count":1492377,"deprecated":false},{"id":10722,"name":"Havaianas","interest":[{"id":13}],"count":7222772,"deprecated":false},{"id":10723,"name":"Cointreau","interest":[{"id":19}],"count":1132984,"deprecated":false},{"id":10725,"name":"Jinro","interest":[{"id":19}],"count":132833,"deprecated":false},{"id":10727,"name":"Emperador","interest":[{"id":19}],"count":410,"deprecated":false},{"id":10729,"name":"Chum-churum","interest":[{"id":19}],"count":9974,"deprecated":false},{"id":10731,"name":"Cachaca 51","interest":[{"id":19}],"count":146319,"deprecated":false},{"id":10732,"name":"Pitu","interest":[{"id":19}],"count":147,"deprecated":false},{"id":10734,"name":"Khortytsa","interest":[{"id":19}],"count":66,"deprecated":false},{"id":10740,"name":"Zubrowka","interest":[{"id":19}],"count":35054,"deprecated":false},{"id":10742,"name":"Belenkaya","interest":[{"id":19}],"count":4605,"deprecated":false},{"id":10744,"name":"Grant's","interest":[{"id":19}],"count":24824,"deprecated":false},{"id":10746,"name":"Green Mark","interest":[{"id":19}],"count":275,"deprecated":false},{"id":10748,"name":"Svedka","interest":[{"id":19}],"count":83917,"deprecated":false},{"id":10750,"name":"Sauza","interest":[{"id":19}],"count":106636,"deprecated":false},{"id":10752,"name":"Gordon's","interest":[{"id":19}],"count":167343,"deprecated":false},{"id":10754,"name":"Yeni Raki","interest":[{"id":19}],"count":156901,"deprecated":false},{"id":10756,"name":"Stolichnaya","interest":[{"id":19}],"count":283454,"deprecated":false},{"id":10758,"name":"Finlandia","interest":[{"id":19}],"count":33453,"deprecated":false},{"id":10760,"name":"William Lawson's","interest":[{"id":19}],"count":50492,"deprecated":false},{"id":10762,"name":"Russian Standard","interest":[{"id":19}],"count":37368,"deprecated":false},{"id":10764,"name":"Aperol","interest":[{"id":19}],"count":13741121,"deprecated":false},{"id":10766,"name":"Dewar's","interest":[{"id":19}],"count":69635,"deprecated":false},{"id":10769,"name":"Patron","interest":[{"id":19}],"count":89020,"deprecated":false},{"id":10771,"name":"Jose Cuervo","interest":[{"id":19}],"count":1060512,"deprecated":false},{"id":10773,"name":"Bud","interest":[{"id":19}],"count":8911,"deprecated":false},{"id":10775,"name":"Miller","interest":[{"id":19}],"count":24253,"deprecated":false},{"id":10777,"name":"Moët & Chandon","interest":[{"id":19}],"count":3145397,"deprecated":false},{"id":10779,"name":"G.H. Mumm","interest":[{"id":19}],"count":122692,"deprecated":false},{"id":10781,"name":"Dom Pérignon","interest":[{"id":19}],"count":2777047,"deprecated":false},{"id":10783,"name":"Martell","interest":[{"id":19}],"count":24420,"deprecated":false},{"id":10785,"name":"Kahlua","interest":[{"id":19}],"count":61968,"deprecated":false},{"id":10787,"name":"24Classics","interest":[{"id":3}],"count":493,"deprecated":false},{"id":10789,"name":"7Camicie","interest":[{"id":13}],"count":6344,"deprecated":false},{"id":10791,"name":"AAKASHA","interest":[{"id":13}],"count":6212,"deprecated":false},{"id":10793,"name":"ABN AMRO","interest":[{"id":58}],"count":50352,"deprecated":false},{"id":10795,"name":"About you","interest":[{"id":13}],"count":540481,"deprecated":false},{"id":10797,"name":"Accor Hotels","interest":[{"id":43}],"count":1037186,"deprecated":false},{"id":10799,"name":"Action","interest":[{"id":7}],"count":87099,"deprecated":false},{"id":10801,"name":"ADAX","interest":[{"id":13}],"count":12278,"deprecated":false},{"id":10803,"name":"Albert Heijn","interest":[{"id":7}],"count":221167,"deprecated":false},{"id":10805,"name":"Allaire Collection Privee","interest":[{"id":19}],"count":337,"deprecated":false},{"id":10807,"name":"Alpro","interest":[{"id":798}],"count":751464,"deprecated":false},{"id":10809,"name":"Amanda Wakeley","interest":[{"id":13}],"count":7093,"deprecated":false},{"id":10811,"name":"American Eagle Outfitters AEO","interest":[{"id":13}],"count":82177,"deprecated":false},{"id":10813,"name":"ANNA + NINA","interest":[{"id":130}],"count":34476,"deprecated":false},{"id":10815,"name":"Austrian Airlines","interest":[{"id":43}],"count":112528,"deprecated":false},{"id":10817,"name":"Aveda","interest":[{"id":80}],"count":1159391,"deprecated":false},{"id":10819,"name":"Avery Dennison","interest":[{"id":58}],"count":258626,"deprecated":false},{"id":10821,"name":"Bahrain Tourism","interest":[{"id":43}],"count":53010,"deprecated":false},{"id":10823,"name":"Bakker","interest":[{"id":1560}],"count":52066,"deprecated":false},{"id":10825,"name":"Barclays","interest":[{"id":58}],"count":4369,"deprecated":false},{"id":10827,"name":"Beauty Bay","interest":[{"id":80}],"count":1995451,"deprecated":false},{"id":10829,"name":"Beerwulf","interest":[{"id":19}],"count":3965,"deprecated":false},{"id":10831,"name":"Beiersdorf","interest":[{"id":80}],"count":35103,"deprecated":false},{"id":10833,"name":"Belloya","interest":[{"id":13}],"count":630,"deprecated":false},{"id":10835,"name":"Berlinlinien Bus","interest":[{"id":58}],"count":185,"deprecated":false},{"id":10837,"name":"Bestseller","interest":[{"id":13}],"count":21493,"deprecated":false},{"id":10843,"name":"Betoncentrale Festival","interest":[{"id":3}],"count":1628,"deprecated":false},{"id":10845,"name":"Binatone","interest":[{"id":1560}],"count":15614,"deprecated":false},{"id":10847,"name":"BioTABs","interest":[{"id":100}],"count":9626,"deprecated":false},{"id":10849,"name":"Bloemen Bureau","interest":[{"id":1560}],"count":939,"deprecated":false},{"id":10851,"name":"Bloomingdales","interest":[{"id":13}],"count":692698,"deprecated":false},{"id":10852,"name":"Bloomon","interest":[{"id":1560}],"count":139031,"deprecated":false},{"id":10854,"name":"Bol.com","interest":[{"id":1560}],"count":121189,"deprecated":false},{"id":10856,"name":"Bos Group International","interest":[{"id":13}],"count":202,"deprecated":false},{"id":10858,"name":"Buienalarm","interest":[{"id":25}],"count":434,"deprecated":false},{"id":10860,"name":"Bunq","interest":[{"id":58}],"count":4275,"deprecated":false},{"id":10862,"name":"Car2Go","interest":[{"id":1826}],"count":16249,"deprecated":false},{"id":10864,"name":"Catawiki","interest":[{"id":36}],"count":20490,"deprecated":false},{"id":10866,"name":"China Airlines","interest":[{"id":43}],"count":146006,"deprecated":false},{"id":10868,"name":"Chupa Chups","interest":[{"id":139}],"count":539214,"deprecated":false},{"id":10870,"name":"CHUS BURÉS","interest":[{"id":36}],"count":579,"deprecated":false},{"id":10872,"name":"Cluse","interest":[{"id":130}],"count":954226,"deprecated":false},{"id":10874,"name":"Containr Affairs","interest":[{"id":1560}],"count":187,"deprecated":false},{"id":10876,"name":"Coolcat","interest":[{"id":13}],"count":66614,"deprecated":false},{"id":10878,"name":"Cortina","interest":[{"id":1826}],"count":2410,"deprecated":false},{"id":10880,"name":"Corum","interest":[{"id":130}],"count":24592,"deprecated":false},{"id":10882,"name":"Coty Benelux","interest":[{"id":80}],"count":27567,"deprecated":false},{"id":10884,"name":"Coty USA","interest":[{"id":80}],"count":268,"deprecated":false},{"id":10885,"name":"Delhaize","interest":[{"id":139}],"count":111083,"deprecated":false},{"id":10887,"name":"Deliveroo","interest":[{"id":139}],"count":1658858,"deprecated":false},{"id":10889,"name":"Delta Lloyd","interest":[{"id":58}],"count":15450,"deprecated":false},{"id":10891,"name":"Denham","interest":[{"id":13}],"count":20910,"deprecated":false},{"id":10893,"name":"Digital Kitchen","interest":[{"id":36}],"count":1087,"deprecated":false},{"id":10895,"name":"D-link","interest":[{"id":25}],"count":178829,"deprecated":false},{"id":10897,"name":"DNSW","interest":[{"id":21}],"count":2929,"deprecated":false},{"id":10899,"name":"Douwe Egberts","interest":[{"id":9}],"count":32262,"deprecated":false},{"id":10901,"name":"DrinkUp","interest":[{"id":9}],"count":2453,"deprecated":false},{"id":10903,"name":"Duifhuizen","interest":[{"id":13}],"count":3449,"deprecated":false},{"id":10905,"name":"Eastpak","interest":[{"id":13}],"count":393851,"deprecated":false},{"id":10907,"name":"Edited","interest":[{"id":13}],"count":67158,"deprecated":false},{"id":10909,"name":"EeStairs","interest":[{"id":1560}],"count":3512,"deprecated":false},{"id":10911,"name":"Efteling","interest":[{"id":1708}],"count":798719,"deprecated":false},{"id":10913,"name":"Elissa & Stef","interest":[{"id":13}],"count":334,"deprecated":false},{"id":10915,"name":"Ellis gourmet Burger","interest":[{"id":139}],"count":8511,"deprecated":false},{"id":10917,"name":"EMU Australia","interest":[{"id":13}],"count":42823,"deprecated":false},{"id":10919,"name":"ESPRIT","interest":[{"id":13}],"count":1331158,"deprecated":false},{"id":10921,"name":"Estee Lauder Cosmetics N.V.","interest":[{"id":80}],"count":7057,"deprecated":false},{"id":10923,"name":"Euro Italia","interest":[{"id":80}],"count":15607,"deprecated":false},{"id":10925,"name":"European Bartender School","interest":[{"id":19}],"count":43042,"deprecated":false},{"id":10927,"name":"Eyelove","interest":[{"id":100}],"count":317,"deprecated":false},{"id":10929,"name":"FAEMD","interest":[{"id":130}],"count":1023,"deprecated":false},{"id":10931,"name":"Feel Unique","interest":[{"id":80}],"count":146852,"deprecated":false},{"id":10933,"name":"Feraggio","interest":[{"id":13}],"count":1709,"deprecated":false},{"id":10935,"name":"FIA World Endurance Championship","interest":[{"id":21}],"count":44121,"deprecated":false},{"id":10937,"name":"FitShe","interest":[{"id":196}],"count":5678,"deprecated":false},{"id":10939,"name":"Fiverr","interest":[{"id":25}],"count":580368,"deprecated":false},{"id":10941,"name":"Fjallraven","interest":[{"id":13}],"count":491774,"deprecated":false},{"id":10943,"name":"Flat Tummy Tea","interest":[{"id":798}],"count":132351,"deprecated":false},{"id":10945,"name":"Fleur de Sante","interest":[{"id":80}],"count":848,"deprecated":false},{"id":10947,"name":"Franklin & Marshall","interest":[{"id":13}],"count":44427,"deprecated":false},{"id":10949,"name":"Frico","interest":[{"id":139}],"count":1620,"deprecated":false},{"id":10951,"name":"Funda","interest":[{"id":1560}],"count":3553,"deprecated":false},{"id":10953,"name":"General Motors","interest":[{"id":1826}],"count":635892,"deprecated":false},{"id":10955,"name":"Genuine People","interest":[{"id":13}],"count":59066,"deprecated":false},{"id":10957,"name":"Grader","interest":[{"id":25}],"count":61,"deprecated":false},{"id":10959,"name":"Griffin Emblem","interest":[{"id":130}],"count":657,"deprecated":false},{"id":10961,"name":"Groupon","interest":[{"id":7}],"count":586656,"deprecated":false},{"id":10963,"name":"G-shock","interest":[{"id":130}],"count":8890666,"deprecated":false},{"id":10965,"name":"GSUS","interest":[{"id":13}],"count":11649,"deprecated":false},{"id":10967,"name":"Happy Planet","interest":[{"id":9}],"count":1890,"deprecated":false},{"id":10969,"name":"Hebe","interest":[{"id":13}],"count":5816,"deprecated":false},{"id":10971,"name":"Helpling","interest":[{"id":58}],"count":2585,"deprecated":false},{"id":10973,"name":"Hertog Jan","interest":[{"id":19}],"count":76308,"deprecated":false},{"id":10975,"name":"Het Concertgebouw","interest":[{"id":3}],"count":64816,"deprecated":false},{"id":10977,"name":"Hill's Pet Nutrition Company","interest":[{"id":798}],"count":46627,"deprecated":false},{"id":10979,"name":"Hilvertshof","interest":[{"id":7}],"count":4212,"deprecated":false},{"id":10981,"name":"Hooghoudt","interest":[{"id":19}],"count":8355,"deprecated":false},{"id":10983,"name":"Hudson's Bay","interest":[{"id":7}],"count":167158,"deprecated":false},{"id":10985,"name":"HUMANOID","interest":[{"id":13}],"count":437,"deprecated":false},{"id":10987,"name":"Hunkemoller","interest":[{"id":13}],"count":231115,"deprecated":false},{"id":10989,"name":"IMA","interest":[{"id":58}],"count":10349,"deprecated":false},{"id":10991,"name":"Indelust","interest":[{"id":1560}],"count":114,"deprecated":false},{"id":10993,"name":"Innocent","interest":[{"id":798}],"count":82634,"deprecated":false},{"id":10995,"name":"Isobar Communications Pty Ltd","interest":[{"id":25}],"count":102,"deprecated":false},{"id":10997,"name":"Juice Brothers","interest":[{"id":9}],"count":8620,"deprecated":false},{"id":10999,"name":"Junarose","interest":[{"id":13}],"count":5553,"deprecated":false},{"id":11001,"name":"Just Brands","interest":[{"id":13}],"count":2433,"deprecated":false},{"id":11003,"name":"King","interest":[{"id":30}],"count":23,"deprecated":false},{"id":11005,"name":"Kodak","interest":[{"id":11}],"count":19072104,"deprecated":false},{"id":11007,"name":"Kruidvat","interest":[{"id":80}],"count":186195,"deprecated":false},{"id":11009,"name":"Kvadrat","interest":[{"id":1560}],"count":56431,"deprecated":false},{"id":11011,"name":"Kwekkeboom","interest":[{"id":139}],"count":2468,"deprecated":false},{"id":11013,"name":"Laboratorium LA","interest":[{"id":13}],"count":619,"deprecated":false},{"id":11015,"name":"Lake Side","interest":[{"id":13}],"count":141,"deprecated":false},{"id":11017,"name":"Landmarkt","interest":[{"id":7}],"count":1335,"deprecated":false},{"id":11019,"name":"LINDA","interest":[{"id":1}],"count":362603,"deprecated":false},{"id":11021,"name":"Luco Charles","interest":[{"id":130}],"count":12,"deprecated":false},{"id":11023,"name":"Maasmechelen Village","interest":[{"id":7}],"count":40676,"deprecated":false},{"id":11025,"name":"Marc O'Polo","interest":[{"id":13}],"count":1272211,"deprecated":false},{"id":11027,"name":"Marktplaats","interest":[{"id":7}],"count":58136,"deprecated":false},{"id":11029,"name":"Marlies Dekkers","interest":[{"id":13}],"count":19710,"deprecated":false},{"id":11031,"name":"Max & Co.","interest":[{"id":13}],"count":41370,"deprecated":false},{"id":11033,"name":"Mekkdes","interest":[{"id":13}],"count":3116,"deprecated":false},{"id":11035,"name":"MOCO Museum","interest":[{"id":36}],"count":147804,"deprecated":false},{"id":11037,"name":"Monica Vinader","interest":[{"id":130}],"count":138150,"deprecated":false},{"id":11039,"name":"Nakd","interest":[{"id":13}],"count":3772438,"deprecated":false},{"id":11041,"name":"Bear","interest":[{"id":139}],"count":2486,"deprecated":false},{"id":11043,"name":"Nasty Lifestyle","interest":[{"id":33}],"count":4220,"deprecated":false},{"id":11045,"name":"Natural Cycles","interest":[{"id":100}],"count":11230,"deprecated":false},{"id":11047,"name":"Natural Mojo","interest":[{"id":798}],"count":113491,"deprecated":false},{"id":11048,"name":"Nomads Festival","interest":[{"id":3}],"count":4317,"deprecated":false},{"id":11050,"name":"Nordcurrent","interest":[{"id":30}],"count":643,"deprecated":false},{"id":11053,"name":"Nutricia","interest":[{"id":798}],"count":123413,"deprecated":false},{"id":11055,"name":"Ofyr","interest":[{"id":1560}],"count":30237,"deprecated":false},{"id":11057,"name":"Oilily","interest":[{"id":190}],"count":16427,"deprecated":false},{"id":11059,"name":"Olvi's","interest":[{"id":13}],"count":32250,"deprecated":false},{"id":11061,"name":"Omoda","interest":[{"id":13}],"count":56991,"deprecated":false},{"id":11063,"name":"OnePlus","interest":[{"id":25}],"count":515127,"deprecated":false},{"id":11066,"name":"Oppo","interest":[{"id":25}],"count":2464697,"deprecated":false},{"id":11068,"name":"Otterbox","interest":[{"id":25}],"count":144236,"deprecated":false},{"id":11070,"name":"Oxydo Eyewear","interest":[{"id":13}],"count":8121,"deprecated":false},{"id":11072,"name":"Parfois","interest":[{"id":13}],"count":1120696,"deprecated":false},{"id":11074,"name":"People's Avenue","interest":[{"id":13}],"count":227,"deprecated":false},{"id":11076,"name":"Phone House","interest":[{"id":25}],"count":23682,"deprecated":false},{"id":11078,"name":"Pickwick","interest":[{"id":9}],"count":13421,"deprecated":false},{"id":11080,"name":"Pioneer","interest":[{"id":25}],"count":6257883,"deprecated":false},{"id":11082,"name":"Ports 1961","interest":[{"id":13}],"count":19370,"deprecated":false},{"id":11084,"name":"Praxis","interest":[{"id":1560}],"count":27,"deprecated":false},{"id":11086,"name":"Pret a Voir","interest":[{"id":13}],"count":1122,"deprecated":false},{"id":11088,"name":"Puig","interest":[{"id":80}],"count":20,"deprecated":false},{"id":11090,"name":"Rebelle","interest":[{"id":13}],"count":874,"deprecated":false},{"id":11092,"name":"Rice Force","interest":[{"id":80}],"count":7590,"deprecated":false},{"id":11094,"name":"Rituals","interest":[{"id":80}],"count":727984,"deprecated":false},{"id":11096,"name":"Saks Fifth Avenue","interest":[{"id":13}],"count":265495,"deprecated":false},{"id":11098,"name":"Schaap & Citroen","interest":[{"id":130}],"count":6368,"deprecated":false},{"id":11101,"name":"Send Anywhere","interest":[{"id":25}],"count":1068,"deprecated":false},{"id":11103,"name":"Sensation","interest":[{"id":3}],"count":68778,"deprecated":false},{"id":11105,"name":"SKYN","interest":[{"id":100}],"count":4984,"deprecated":false},{"id":11107,"name":"Snapbook","interest":[{"id":25}],"count":14089,"deprecated":false},{"id":11109,"name":"Southern Comfort","interest":[{"id":19}],"count":9963,"deprecated":false},{"id":11111,"name":"Spa","interest":[{"id":9}],"count":539,"deprecated":false},{"id":11113,"name":"Stadshart Amstelveen","interest":[{"id":7}],"count":3431,"deprecated":false},{"id":11115,"name":"Stokke","interest":[{"id":190}],"count":436822,"deprecated":false},{"id":11117,"name":"Stylefruits","interest":[{"id":13}],"count":1113,"deprecated":false},{"id":11119,"name":"TAO Group","interest":[{"id":139}],"count":53577,"deprecated":false},{"id":11121,"name":"Tech21","interest":[{"id":25}],"count":12050,"deprecated":false},{"id":11123,"name":"Telecom Lifestyle Fashion","interest":[{"id":25}],"count":4136,"deprecated":false},{"id":11126,"name":"Teva","interest":[{"id":13}],"count":20588,"deprecated":false},{"id":11129,"name":"The Frozen Butcher","interest":[{"id":139}],"count":518,"deprecated":false},{"id":11131,"name":"Ticwatch","interest":[{"id":130}],"count":35262,"deprecated":false},{"id":11133,"name":"TIMEX","interest":[{"id":130}],"count":550534,"deprecated":false},{"id":11135,"name":"Tom Tom","interest":[{"id":21}],"count":299961,"deprecated":false},{"id":11137,"name":"TopVintage","interest":[{"id":13}],"count":27189,"deprecated":false},{"id":11139,"name":"TUI","interest":[{"id":43}],"count":789567,"deprecated":false},{"id":11140,"name":"Twinset","interest":[{"id":13}],"count":913381,"deprecated":false},{"id":11142,"name":"Ujet","interest":[{"id":1826}],"count":898,"deprecated":false},{"id":11145,"name":"Urban Ears","interest":[{"id":25}],"count":29693,"deprecated":false},{"id":11147,"name":"Valtifest","interest":[{"id":3}],"count":7096,"deprecated":false},{"id":11149,"name":"Van Dalen","interest":[{"id":13}],"count":1330,"deprecated":false},{"id":11151,"name":"Vigorsol","interest":[{"id":139}],"count":97,"deprecated":false},{"id":11153,"name":"Vionnet","interest":[{"id":13}],"count":31688,"deprecated":false},{"id":11155,"name":"Warehouse Fashions LTD","interest":[{"id":13}],"count":96223,"deprecated":false},{"id":11157,"name":"Warner Music","interest":[{"id":3}],"count":1024817,"deprecated":false},{"id":11159,"name":"Weight Watchers","interest":[{"id":798}],"count":183090,"deprecated":false},{"id":11161,"name":"Westwing","interest":[{"id":1560}],"count":680627,"deprecated":false},{"id":11163,"name":"WeTransfer","interest":[{"id":25}],"count":95977,"deprecated":false},{"id":11165,"name":"XD Design","interest":[{"id":13}],"count":12405,"deprecated":false},{"id":11167,"name":"Yogi Tea","interest":[{"id":9}],"count":470582,"deprecated":false},{"id":11169,"name":"Zadig Voltaire","interest":[{"id":13}],"count":273508,"deprecated":false},{"id":11171,"name":"Zalando","interest":[{"id":13}],"count":1404797,"deprecated":false},{"id":11173,"name":"Zapf Creations","interest":[{"id":190}],"count":215,"deprecated":false},{"id":11175,"name":"Zeeman","interest":[{"id":7}],"count":196973,"deprecated":false},{"id":11177,"name":"Purina","interest":[{"id":673}],"count":1077325,"deprecated":false},{"id":11187,"name":"Royal Canin","interest":[{"id":673}],"count":1154539,"deprecated":false},{"id":11194,"name":"Vitacraft","interest":[{"id":673}],"count":3043,"deprecated":false},{"id":11196,"name":"Bozita","interest":[{"id":673}],"count":9577,"deprecated":false},{"id":11198,"name":"Whiskas","interest":[{"id":673}],"count":895768,"deprecated":false},{"id":11203,"name":"Chomper","interest":[{"id":673}],"count":336720,"deprecated":false},{"id":11206,"name":"Cesar","interest":[{"id":673}],"count":1433,"deprecated":false},{"id":11209,"name":"Brit Care","interest":[{"id":673}],"count":21152,"deprecated":false},{"id":11212,"name":"Belcando","interest":[{"id":673}],"count":25354,"deprecated":false},{"id":11215,"name":"Animonda","interest":[{"id":673}],"count":23098,"deprecated":false},{"id":11217,"name":"ACANA Petfoods","interest":[{"id":673}],"count":296390,"deprecated":false},{"id":11220,"name":"Orijen","interest":[{"id":673}],"count":91292,"deprecated":false},{"id":11222,"name":"Petkind","interest":[{"id":673}],"count":1722,"deprecated":false},{"id":11225,"name":"Dreamies","interest":[{"id":673}],"count":86806,"deprecated":false},{"id":11227,"name":"Evangers","interest":[{"id":673}],"count":3824,"deprecated":false},{"id":11231,"name":"Hill's","interest":[{"id":673}],"count":38665,"deprecated":false},{"id":11234,"name":"Monge","interest":[{"id":673}],"count":131878,"deprecated":false},{"id":11236,"name":"Pedigree Petfoods","interest":[{"id":673}],"count":1284522,"deprecated":false},{"id":11247,"name":"Sheba","interest":[{"id":673}],"count":88011,"deprecated":false},{"id":11249,"name":"Todomoda","interest":[{"id":13}],"count":266178,"deprecated":false},{"id":11252,"name":"Isadora","interest":[{"id":13}],"count":38076,"deprecated":false},{"id":11254,"name":"Peter Pan Lencería","interest":[{"id":13}],"count":4677,"deprecated":false},{"id":11259,"name":"Blackmagic Design","interest":[{"id":11}],"count":1234419,"deprecated":false},{"id":11278,"name":"Kotex","interest":[{"id":100}],"count":171189,"deprecated":false},{"id":13891,"name":"Gymshark","interest":[{"id":196}],"count":24503072,"deprecated":false},{"id":13892,"name":"WNBA","interest":[{"id":21}],"count":1280762,"deprecated":false},{"id":13899,"name":"Haus","interest":[{"id":9}],"count":7253,"deprecated":false},{"id":13901,"name":"Cortefiel","interest":[{"id":13}],"count":59763,"deprecated":false},{"id":13903,"name":"Pedro del Hierro","interest":[{"id":13}],"count":35307,"deprecated":false},{"id":13905,"name":"Women'secret","interest":[{"id":13}],"count":131063,"deprecated":false},{"id":13907,"name":"Springfield","interest":[{"id":13}],"count":541124,"deprecated":false},{"id":13909,"name":"305 Fitness","interest":[{"id":196}],"count":38025,"deprecated":false},{"id":13911,"name":"Amazon Handmade","interest":[{"id":1560}],"count":65588,"deprecated":false},{"id":13913,"name":"Amika","interest":[{"id":80}],"count":587985,"deprecated":false},{"id":13919,"name":"Arches & Halos","interest":[{"id":80}],"count":4462,"deprecated":false},{"id":13921,"name":"Arctic Fox hair Color","interest":[{"id":80}],"count":1008159,"deprecated":false},{"id":13923,"name":"Asarai","interest":[{"id":80}],"count":1738,"deprecated":false},{"id":13931,"name":"Avene","interest":[{"id":80}],"count":574467,"deprecated":false},{"id":13934,"name":"Barry's Bootcamp","interest":[{"id":196}],"count":359782,"deprecated":false},{"id":13937,"name":"Barstool Sports","interest":[{"id":1}],"count":2684630,"deprecated":false},{"id":13939,"name":"Biossance","interest":[{"id":80}],"count":150672,"deprecated":false},{"id":13941,"name":"Blue Marble","interest":[{"id":13}],"count":10921,"deprecated":false},{"id":13943,"name":"Bodewell","interest":[{"id":80}],"count":384,"deprecated":false},{"id":13945,"name":"Brilliant Earth","interest":[{"id":130}],"count":88220,"deprecated":false},{"id":13947,"name":"Bumble","count":25526,"deprecated":false},{"id":13949,"name":"Butler Hospitality","interest":[{"id":139}],"count":141,"deprecated":false},{"id":13951,"name":"Cheap Tickets","interest":[{"id":43}],"count":27289,"deprecated":false},{"id":13953,"name":"Classpass","interest":[{"id":196}],"count":153462,"deprecated":false},{"id":13956,"name":"Club Pilates","interest":[{"id":196}],"count":27148,"deprecated":false},{"id":13959,"name":"CreatorIQ","interest":[{"id":58}],"count":314,"deprecated":false},{"id":13961,"name":"Credit Karma","count":2444,"deprecated":false},{"id":13963,"name":"Cub Coats","interest":[{"id":190}],"count":3002,"deprecated":false},{"id":13965,"name":"Cult Gaia","interest":[{"id":13}],"count":463635,"deprecated":false},{"id":13967,"name":"Depop","interest":[{"id":13}],"count":1711946,"deprecated":false},{"id":13975,"name":"Dermalogica UK","interest":[{"id":80}],"count":81258,"deprecated":false},{"id":13976,"name":"Rumble","interest":[{"id":196}],"count":38925,"deprecated":false},{"id":13978,"name":"DraftKings","count":2865,"deprecated":false},{"id":13980,"name":"Bev","interest":[{"id":19}],"count":9171,"deprecated":false},{"id":13982,"name":"Cann","interest":[{"id":19}],"count":13731,"deprecated":false},{"id":13984,"name":"LQD","interest":[{"id":19}],"count":393,"deprecated":false},{"id":13986,"name":"Dropbox","count":4271,"deprecated":false},{"id":13988,"name":"Drunk Elephant","interest":[{"id":80}],"count":758013,"deprecated":false},{"id":13991,"name":"EA SPORTS Madden NFL 21","count":4143,"deprecated":false},{"id":13992,"name":"Edie Parker","interest":[{"id":13}],"count":5776,"deprecated":false},{"id":13994,"name":"ee","interest":[{"id":25}],"count":55177,"deprecated":false},{"id":13996,"name":"Epson UK","interest":[{"id":25}],"count":4487,"deprecated":false},{"id":14009,"name":"EverlyWell","interest":[{"id":798}],"count":3690,"deprecated":false},{"id":14011,"name":"Expedia","interest":[{"id":43}],"count":422197,"deprecated":false},{"id":14014,"name":"FanDuel","interest":[{"id":21}],"count":72729,"deprecated":false},{"id":14016,"name":"Farmacy","interest":[{"id":80}],"count":308513,"deprecated":false},{"id":14018,"name":"First Aid Beauty","interest":[{"id":80}],"count":432626,"deprecated":false},{"id":14020,"name":"Flywheel","interest":[{"id":21}],"count":32377,"deprecated":false},{"id":14022,"name":"Fresh","interest":[{"id":80}],"count":725952,"deprecated":false},{"id":14024,"name":"Fun Boy","interest":[{"id":798}],"count":87453,"deprecated":false},{"id":14026,"name":"Function of Beauty","interest":[{"id":80}],"count":88381,"deprecated":false},{"id":14028,"name":"Gerber","interest":[{"id":190}],"count":3414341,"deprecated":false},{"id":14031,"name":"GIVZ","interest":[{"id":58}],"count":648,"deprecated":false},{"id":14033,"name":"Giant Bicycles","interest":[{"id":21}],"count":664372,"deprecated":false},{"id":14035,"name":"Glossier","interest":[{"id":80}],"count":3422863,"deprecated":false},{"id":14037,"name":"Glow Recipe","interest":[{"id":80}],"count":569872,"deprecated":false},{"id":14039,"name":"Habit Burger","interest":[{"id":139}],"count":4241,"deprecated":false},{"id":14041,"name":"HBO Max","interest":[{"id":1}],"count":1751887,"deprecated":false},{"id":14043,"name":"Herbivore","interest":[{"id":80}],"count":225155,"deprecated":false},{"id":14045,"name":"Hers","interest":[{"id":80}],"count":14139,"deprecated":false},{"id":14047,"name":"Hims","interest":[{"id":80}],"count":12981,"deprecated":false},{"id":14049,"name":"IMDb","interest":[{"id":1}],"count":989804,"deprecated":false},{"id":14051,"name":"Myro","interest":[{"id":80}],"count":12496,"deprecated":false},{"id":14053,"name":"iZettle","count":499,"deprecated":false},{"id":14055,"name":"James Allen","interest":[{"id":130}],"count":16263,"deprecated":false},{"id":14057,"name":"Joico","interest":[{"id":80}],"count":2275071,"deprecated":false},{"id":14063,"name":"J.R. Watkins","interest":[{"id":80}],"count":1942,"deprecated":false},{"id":14065,"name":"Juneshine","interest":[{"id":19}],"count":72713,"deprecated":false},{"id":14067,"name":"Kenra Professional","interest":[{"id":80}],"count":451333,"deprecated":false},{"id":14069,"name":"Crossfit","interest":[{"id":21}],"count":71905,"deprecated":false},{"id":14071,"name":"Kiehls","interest":[{"id":80}],"count":2080346,"deprecated":false},{"id":14074,"name":"Laneige","interest":[{"id":80}],"count":1960837,"deprecated":false},{"id":14079,"name":"Littlewoods","interest":[{"id":13}],"count":7274,"deprecated":false},{"id":14081,"name":"Live Nation","interest":[{"id":3}],"count":853504,"deprecated":false},{"id":14083,"name":"Kiva","interest":[{"id":139}],"count":36527,"deprecated":false},{"id":14085,"name":"Manscaped","interest":[{"id":80}],"count":92522,"deprecated":false},{"id":14087,"name":"Matrix","interest":[{"id":80}],"count":9463253,"deprecated":false},{"id":14093,"name":"Cleo","count":622,"deprecated":false},{"id":14095,"name":"MeUndies","interest":[{"id":13}],"count":30833,"deprecated":false},{"id":14097,"name":"Miku","interest":[{"id":25}],"count":4249,"deprecated":false},{"id":14099,"name":"Minted","interest":[{"id":36}],"count":504805,"deprecated":false},{"id":14102,"name":"Nuface","interest":[{"id":25}],"count":46818,"deprecated":false},{"id":14104,"name":"Necessarie","interest":[{"id":80}],"count":1958815,"deprecated":false},{"id":14106,"name":"Nespresso","interest":[{"id":139}],"count":4866281,"deprecated":false},{"id":14109,"name":"Neuehouse","interest":[{"id":36}],"count":31804,"deprecated":false},{"id":14111,"name":"Noom","interest":[{"id":100}],"count":48239,"deprecated":false},{"id":14114,"name":"Norwood House","interest":[{"id":36}],"count":5579,"deprecated":false},{"id":14116,"name":"Nurture Life","interest":[{"id":139}],"count":9976,"deprecated":false},{"id":14118,"name":"o2","interest":[{"id":25}],"count":20341,"deprecated":false},{"id":14127,"name":"Ole Henriksen","interest":[{"id":80}],"count":577782,"deprecated":false},{"id":14129,"name":"Oligo Professional","interest":[{"id":80}],"count":221293,"deprecated":false},{"id":14131,"name":"Peloton","interest":[{"id":21}],"count":1131256,"deprecated":false},{"id":14133,"name":"Orbitz","interest":[{"id":43}],"count":19708,"deprecated":false},{"id":14136,"name":"Overstock","interest":[{"id":1560}],"count":190506,"deprecated":false},{"id":14138,"name":"Overwatch League","count":3883,"deprecated":false},{"id":14140,"name":"Pulp Riot","interest":[{"id":80}],"count":1111113,"deprecated":false},{"id":14143,"name":"Redken","interest":[{"id":80}],"count":3907164,"deprecated":false},{"id":14149,"name":"Ritual","interest":[{"id":798}],"count":4447,"deprecated":false},{"id":14151,"name":"R0AM","interest":[{"id":13}],"count":2094,"deprecated":false},{"id":14153,"name":"Shaya Pets","interest":[{"id":673}],"count":380,"deprecated":false},{"id":14155,"name":"Dr Ourian","interest":[{"id":100}],"count":43316,"deprecated":false},{"id":14158,"name":"SLT","interest":[{"id":21}],"count":10333,"deprecated":false},{"id":14160,"name":"SmileDirectClub","interest":[{"id":100}],"count":126293,"deprecated":false},{"id":14162,"name":"Soho House","interest":[{"id":43}],"count":13977,"deprecated":false},{"id":14164,"name":"Solace","interest":[{"id":196}],"count":8901,"deprecated":false},{"id":14166,"name":"Square Baby","interest":[{"id":190}],"count":548,"deprecated":false},{"id":14168,"name":"SumUp","count":2769,"deprecated":false},{"id":14170,"name":"Supergoop!","interest":[{"id":80}],"count":308255,"deprecated":false},{"id":14172,"name":"T3 Micro","interest":[{"id":25}],"count":230881,"deprecated":false},{"id":14175,"name":"Tatcha","interest":[{"id":80}],"count":1285196,"deprecated":false},{"id":14177,"name":"Telefonica","interest":[{"id":25}],"count":131185,"deprecated":false},{"id":14179,"name":"Terez","interest":[{"id":13}],"count":48884,"deprecated":false},{"id":14181,"name":"The Citizenry","interest":[{"id":1560}],"count":18504,"deprecated":false},{"id":14183,"name":"Clear Cut","interest":[{"id":130}],"count":2917,"deprecated":false},{"id":14185,"name":"The Last Line","interest":[{"id":130}],"count":4611,"deprecated":false},{"id":14187,"name":"Theragun","interest":[{"id":25}],"count":113228,"deprecated":false},{"id":14189,"name":"Tiffany","interest":[{"id":130}],"count":8839770,"deprecated":false},{"id":14191,"name":"Tommy John","interest":[{"id":13}],"count":31109,"deprecated":false},{"id":14194,"name":"Travelocity","interest":[{"id":43}],"count":37148,"deprecated":false},{"id":14196,"name":"Trip","interest":[{"id":43}],"count":77304533,"deprecated":false},{"id":14197,"name":"Truss Professional","interest":[{"id":80}],"count":1175048,"deprecated":false},{"id":14199,"name":"Twitch","count":221638,"deprecated":false},{"id":14207,"name":"Vegamour","interest":[{"id":80}],"count":9910,"deprecated":false},{"id":14209,"name":"Very","interest":[{"id":13}],"count":180686,"deprecated":false},{"id":14211,"name":"VidCon","count":6172,"deprecated":false},{"id":14213,"name":"Vital Proteins","interest":[{"id":798}],"count":521964,"deprecated":false},{"id":14215,"name":"Winc","interest":[{"id":19}],"count":64539,"deprecated":false},{"id":14217,"name":"WW","interest":[{"id":798}],"count":1798863,"deprecated":false},{"id":14226,"name":"Youth To The People","interest":[{"id":80}],"count":225130,"deprecated":false},{"id":14228,"name":"YPO","interest":[{"id":58}],"count":5050,"deprecated":false},{"id":14230,"name":"ZitSticka","interest":[{"id":80}],"count":10846,"deprecated":false},{"id":14232,"name":"shein","interest":[{"id":13}],"count":34512457,"deprecated":false},{"id":14235,"name":"Fenty beauty","interest":[{"id":80}],"count":20823605,"deprecated":false},{"id":14237,"name":"Le coq sportif","interest":[{"id":13}],"count":636431,"deprecated":false},{"id":14239,"name":"Kappa","interest":[{"id":13}],"count":7857770,"deprecated":false},{"id":14241,"name":"Umbro","interest":[{"id":13}],"count":1486286,"deprecated":false},{"id":14243,"name":"Fila","interest":[{"id":13}],"count":21793396,"deprecated":false},{"id":14248,"name":"Hummel","interest":[{"id":13}],"count":981875,"deprecated":false},{"id":14251,"name":"Décathlon","interest":[{"id":13}],"count":3220858,"deprecated":false},{"id":14253,"name":"Luxottica","interest":[{"id":13}],"count":136162,"deprecated":false}]}}

/***/ }),
/* 2357 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[820]);


// WEBPACK FOOTER //
// static/js/app.26c22fd9f29c9e6f8672.js